// для IE
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
(function() {
  'use strict';

  angular
    .module('frontend', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ui.router',
      'ui.select',
      'toastr',
      'ui.grid',
      'ui.grid.selection',
      'ui.grid.pinning',
      'ui.grid.autoResize',
      'ngMask',
      'daterangepicker',
      'ui.grid.pagination',
      'ui.grid.resizeColumns',
      'ui.grid.moveColumns',
      'mj.scrollingTabs',
      'dibari.angular-ellipsis',
      'ui.bootstrap',
      'ngScrollbars',
      'scrollto',
      'chart.js',
      'angular-carousel',
      'monospaced.elastic',
      // Позволяет удобно настраивать маску для ввода
      'ui.mask',
      'ngProgress',
      'dndLists',
      'angularjs-dropdown-multiselect',
      'btorfs.multiselect',
      'ui.tab.scroll',
      'ngCroppie',
      'ngFileUpload',
      'angularFileUpload',
      'ui.carousel',
      'ngclipboard'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('totalsAmounts', {
      require: {
        // TODO: в целом мелкие бинжинги можно не биндить каждый раз, а тянуть родительский контроллер
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        externalData: '<', // дополнительный источник общих для докумнета данных
        item: '=', // атрибуты изменяют данные
        withTaxes: '<' // флаг указывающий на необходимость показывать налоги
      },
      templateUrl: 'app/documents/components/attribute/fields/totals/totals-amounts/totals-amounts.html',
      controllerAs: 'totalsAmountsCtrl',
      controller: function ($scope, documentService) {
        var totalsAmountsCtrl = this;
        var currencyCode = totalsAmountsCtrl.item.ref[0],
            rateCode = totalsAmountsCtrl.item.ref[1],
            amountCode = totalsAmountsCtrl.item.ref[2],
            taxGroupCode = totalsAmountsCtrl.item.ref[3],
            commissionPercentCode = totalsAmountsCtrl.item.ref[4];

        if (totalsAmountsCtrl.withTaxes === undefined) {
          totalsAmountsCtrl.withTaxes = true;
        }

        $scope.$watchGroup(["totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[0]]", "totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[1]]", "totalsAmountsCtrl.values[totalsAmountsCtrl.item.ref[2]]", "totalsAmountsCtrl.values[totalsAmountsCtrl.item.ref[3]]"], function (newVal, oldVal) {
          if (newVal && newVal[0] && newVal[1]) { // newVal[1] - может быть 0 и undefined
            totalsAmountsCtrl.documentsAmountsCalculate();
          }
        });

        if(commissionPercentCode){
          $scope.$watch("totalsAmountsCtrl.values[totalsAmountsCtrl.item.ref[4]]", function (newVal, oldVal) {
            if (newVal && totalsAmountsCtrl.externalData[currencyCode]
                && totalsAmountsCtrl.externalData[rateCode] && totalsAmountsCtrl.values[amountCode]) {
              totalsAmountsCtrl.documentsAmountsCalculate();
            }
          });
        }


        /**
         * Метод расчет сумм для документа, для линеек документа включая налоги
         */
        totalsAmountsCtrl.documentsAmountsCalculate = function () {
          if (totalsAmountsCtrl.externalData[rateCode]) {
            var lines = [{}],
                amount;
            if(totalsAmountsCtrl.values[taxGroupCode]){
              lines[0].tax_group_id = totalsAmountsCtrl.values[taxGroupCode].id;
            }
            if(totalsAmountsCtrl.values[amountCode]){
              amount = parseFloat(totalsAmountsCtrl.values[amountCode]);
              if (!isNaN(amount)) {
                lines[0].amount = amount;
                lines[0].price = amount;
              }
            }

            // структура для запроса на бек
            var rate = {
              lines: lines,
              denominator_log10: totalsAmountsCtrl.externalData["denominator_log10"] || 0,
              currency_rate: totalsAmountsCtrl.externalData["currency_rate"]
            };

            if (lines[0].amount) {
              documentService.documentsAmountsCalculate(rate).then(function (res) {
                totalsAmountsCtrl.values[totalsAmountsCtrl.item.code] = res.data.documentTotals;
              });
            } else {
              // при пустом количестве валидных строк экономим вызов бека
              totalsAmountsCtrl.values[totalsAmountsCtrl.item.code] = {
                documentTotals: {
                  home_amount: 0,
                  home_tax_amount: 0,
                  natural_amount: 0,
                  natural_tax_amount: 0
                },
                lineDetails: []
              };
            }
          }
        };

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('totalsAdvanceReport', {
      require: {
        // TODO: в целом мелкие бинжинги можно не биндить каждый раз, а тянуть родительский контроллер
        attributeCtrl: '^^documentAttribute',
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        externalData: '<', // дополнительный источник общих для докумнета данных
        item: '=' // атрибуты изменяют данные
      },
      templateUrl: 'app/documents/components/attribute/fields/totals/totals-advance-report/totals-advance-report.html',
      controllerAs: 'totalsFieldCtrl',
      controller: function ($scope, documentService, $filter, $timeout) {
        var totalsFieldCtrl = this;
        totalsFieldCtrl.tableAdvancesValues = totalsFieldCtrl.item.ref[0];
        totalsFieldCtrl.tableCostsValues = totalsFieldCtrl.item.ref[1];
        totalsFieldCtrl.advances = totalsFieldCtrl.item.ref[2];
        totalsFieldCtrl.costs = totalsFieldCtrl.item.ref[3];

        if(!totalsFieldCtrl.values.totals){
          totalsFieldCtrl.values.totals = {};
        }

        totalsFieldCtrl.getPriceStr = function (price, char_iso_code) {
          if (price) {
            return $filter('priceFormatter')(price / 100, char_iso_code);
          } else {
            return 0;
          }
        }

        totalsFieldCtrl.getDifference = function(){
          if(totalsFieldCtrl.values.totals[totalsFieldCtrl.advances] && totalsFieldCtrl.values.totals[totalsFieldCtrl.costs]){
            totalsFieldCtrl.difference = totalsFieldCtrl.values.totals[totalsFieldCtrl.advances] - totalsFieldCtrl.values.totals[totalsFieldCtrl.costs];
            totalsFieldCtrl.isPositive = totalsFieldCtrl.difference > 0;
            totalsFieldCtrl.difference = Math.abs(totalsFieldCtrl.difference);
          }else{
            totalsFieldCtrl.difference = undefined;
          }
        }

        // вотчер на изменение выбраных документов
        $scope.$watch(function(){
          return totalsFieldCtrl.values[totalsFieldCtrl.item.ref[0]];
        }, function (newVal, oldVal) {
          totalsFieldCtrl.values.totals[totalsFieldCtrl.advances] = 0;
          angular.forEach(totalsFieldCtrl.values[totalsFieldCtrl.item.ref[0]], function (line) {
            totalsFieldCtrl.values.totals[totalsFieldCtrl.advances] += line.home_amount;
          });
          totalsFieldCtrl.getDifference();
        }, true);

        // вотчер на изменение выбраных документов
        $scope.$watch(function(){
          return totalsFieldCtrl.values[totalsFieldCtrl.item.ref[1]];
        }, function (newVal, oldVal) {
          if(!totalsFieldCtrl.values.totals){
            totalsFieldCtrl.values.totals = {};
          }
          totalsFieldCtrl.values.totals[totalsFieldCtrl.costs] = 0;
          angular.forEach(totalsFieldCtrl.values[totalsFieldCtrl.item.ref[1]], function (line) {
            totalsFieldCtrl.values.totals[totalsFieldCtrl.costs] += line.home_amount;
          });
          totalsFieldCtrl.getDifference();
        }, true);

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('totalAmount', {
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        externalData: '<', // дополнительный источник общих для докумнета данных
        item: '=', // атрибуты изменяют данные
      },
      templateUrl: 'app/documents/components/attribute/fields/totals/total-amount/total-amount.html',
      controllerAs: 'totalsAmountCtrl',
      controller: function ($scope, documentService) {
        var totalsAmountCtrl = this;

        $scope.$watchGroup(['totalsAmountCtrl.values[totalsAmountCtrl.item.ref[0]]', 'totalsAmountCtrl.values[totalsAmountCtrl.item.ref[1]]'], function(newVal, oldVal) {
          angular.forEach(newVal, function(val, key){
            if(val && typeof val == "object"){
              newVal[key] = val.natural_amount;
            }
          });
          if (!newVal[0]) {
            totalsAmountCtrl.values[totalsAmountCtrl.item.code] = 0;
          } else if (newVal[0] && newVal[1] && typeof newVal[0] !== "object" && typeof newVal[1] !== "object") {
            totalsAmountCtrl.values[totalsAmountCtrl.item.code] = (newVal[1] * newVal[0]) / 100;
          }
        });

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('multipleTotal', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        externalData: '<', // дополнительный источник общих для докумнета данных
        item: '=', // атрибуты изменяют данные
      },
      templateUrl: 'app/documents/components/attribute/fields/totals/multiple-total/multiple-total.html',
      controllerAs: 'multipleTotalCtrl',
      controller: function ($scope, attributeUtilService, $timeout) {
        var multipleTotalCtrl = this;
        var watchGroup = [];
        _.forEach(multipleTotalCtrl.item.ref, function (ref) {
          watchGroup.push('multipleTotalCtrl.values.' + ref);
        });
        $scope.$watchGroup(watchGroup, function(newVal, oldVal) {
          var fieldVal = 0;
          if (multipleTotalCtrl.item.code == 'quantity_end_period') {
            fieldVal = parseFloat(newVal[0] || 0) + parseFloat(newVal[1] || 0) - parseFloat(newVal[2] || 0);
          } else {
            fieldVal = _.reduce(newVal, function(memo, num){ 
              return (memo || 0) + (num || 0); 
            }, 0);
          }
          if (multipleTotalCtrl.item.onlyPositive) {
            multipleTotalCtrl.invalid = fieldVal.toFixed(3) < 0;
          }
          multipleTotalCtrl.universalSetterGetter(parseFloat(fieldVal).toFixed(3));
        });

        multipleTotalCtrl.universalSetterGetter = function (value) {
          if (angular.isDefined(value) || arguments.length > 0) {
            return multipleTotalCtrl.item.code && attributeUtilService._setValueDeep(
              multipleTotalCtrl.values,
              multipleTotalCtrl.item.code.split('.'),
              value);
          } else {
            return multipleTotalCtrl.item.code && attributeUtilService._getValueDeep(
              multipleTotalCtrl.values,
              multipleTotalCtrl.item.code.split('.'));
          }
        };

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('totalsField', {
      require: {
        // TODO: в целом мелкие бинжинги можно не биндить каждый раз, а тянуть родительский контроллер
        attributeCtrl: '^^documentAttribute',
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        externalData: '<', // дополнительный источник общих для докумнета данных
        item: '=', // атрибуты изменяют данные
        withTaxes: '<' // флаг указывающий на необходимость показывать налоги
      },
      templateUrl: 'app/documents/components/attribute/fields/totals/common-totals/totals-field.html',
      controllerAs: 'totalsFieldCtrl',
      controller: function ($scope, documentService, $filter, $timeout) {
        var totalsFieldCtrl = this;
        var linesCode = totalsFieldCtrl.item.ref[0],
          naturalCurrencyCode = totalsFieldCtrl.item.ref[1],
          taxGroupCode = totalsFieldCtrl.item.ref[2],
          priceCode = totalsFieldCtrl.item.ref[3],
          quantityCode = totalsFieldCtrl.item.ref[4],
          naturalAmountCode = totalsFieldCtrl.item.ref[5],
          taxAmountCode = totalsFieldCtrl.item.ref[6];

        if (totalsFieldCtrl.withTaxes === undefined) {
          totalsFieldCtrl.withTaxes = true;
        }

        totalsFieldCtrl.getPriceStr = function (price, char_iso_code) {
          if (price) {
            return $filter('priceFormatter')(price / 100, char_iso_code);
          } else {
            return 0;
          }
        }

        /**
         * Функция исключает не значащие для пересчета поля.
         * Реализация для undercore.
         *
         * @private
         */
        totalsFieldCtrl._compareFieldsFunc = function (value, key, object) {
          if (key == priceCode ||
            key == taxGroupCode ||
            key == quantityCode) {
            // учитываем только влияющие на суммы поля
            return true;
          }
          return false;
        };

        /**
         * Проверка наличия криитчных для пресчета сумм изменений
         *
         * @param newVal новое значение линеек
         * @param oldVal старое значение линеек
         */
        totalsFieldCtrl.checkImportantChanges = function (newVal, oldVal) {
          if (newVal.length != oldVal.length) {
            // если различаются размеры массивов, то изменения считаются существенныи для пересчета
            return true;
          }
          // перебор всех строк
          for (var i = 0; i < newVal.length; i++) {
            var valNew = _.pick(newVal[i], totalsFieldCtrl._compareFieldsFunc);
            var valOld = _.pick(oldVal[i], totalsFieldCtrl._compareFieldsFunc);

            if (!angular.equals(valNew, valOld)) {
              return true;
            }
          }
          
          // если различий не встретилось
          return false;
        }

        // вотчер на изменение полей для перерасчета сумм
        $scope.$watch('totalsFieldCtrl.values[totalsFieldCtrl.item.ref[0]]', function (newVal, oldVal) {
          if (!totalsFieldCtrl.checkImportantChanges(newVal, oldVal)) {
            // если не зарегистрированы важные изменения, возврат
            return false;
          }

          // todo убрать лишний вызов calculate
          angular.forEach(newVal, function (line) {
            line[naturalAmountCode] = line[quantityCode] * line[priceCode];
          });
          if (totalsFieldCtrl.redact) {
            totalsFieldCtrl.documentsAmountsCalculate();
          }
        }, true);

        $scope.$watch("totalsFieldCtrl.externalData['currency_rate']", function (newVal, oldVal) {
          if (newVal != oldVal) {
            totalsFieldCtrl.documentsAmountsCalculate();
          }
        });

        /**
         * Метод расчет сумм для документа, для линеек документа включая налоги
         */
        totalsFieldCtrl.documentsAmountsCalculate = function () {
          if (totalsFieldCtrl.values[linesCode]) {
            var lines = totalsFieldCtrl.values[linesCode];
            var lineFiltered;
            if (totalsFieldCtrl.withTaxes) {
              lineFiltered = _.filter(lines, function (line, key) {
                return line[taxGroupCode] && line[taxGroupCode].id;
              });
            } else {
              lineFiltered = lines;
            }

            lineFiltered = _.map(lineFiltered, function (line) {
              return {
                $$owner: line,
                tax_group_id: (line[taxGroupCode]) ? line[taxGroupCode].id : '',
                price: line[priceCode] || 0,
                amount: Math.round(line[quantityCode] * line[priceCode]) || 0
              };
            });

            // структура для запроса на бек
            var rate = {
              lines: lineFiltered,
              denominator_log10: totalsFieldCtrl.externalData["denominator_log10"] || 0,
              currency_rate: totalsFieldCtrl.externalData["currency_rate"] || 1
            };
            // В рамках было к проверке добавлено  (...&& lineFiltered[0].tax_group_id) но с эти мотваливается подсчет цены в складских остатках
            if (lineFiltered && lineFiltered.length) {
              documentService.documentsAmountsCalculate(rate).then(function (res) {
                totalsFieldCtrl.values[totalsFieldCtrl.item.code] = res.data.documentTotals;
                _.forEach(rate.lines, function (line, key) {
                  if (res.data.lineDetails[key].natural_amount && line.$$owner[naturalAmountCode] != res.data.lineDetails[key].natural_amount) {
                    line.$$owner[naturalAmountCode] = res.data.lineDetails[key].natural_amount || 0;
                  }
                  if (res.data.lineDetails[key].natural_amount && line.$$owner[naturalAmountCode] != res.data.lineDetails[key].natural_amount) {
                    line.$$owner[naturalAmountCode] = res.data.lineDetails[key].natural_amount || 0;
                  }
                  if (res.data.lineDetails[key].natural_tax_amount && line.$$owner[taxAmountCode] != res.data.lineDetails[key].natural_tax_amount) {
                    line.$$owner[taxAmountCode] = res.data.lineDetails[key].natural_tax_amount || 0;
                  }
                });
              });
            } else {
              // при пустом количестве валидных строк экономим вызов бека
              totalsFieldCtrl.values[totalsFieldCtrl.item.code] = {
                documentTotals: {
                  home_amount: 0,
                  home_tax_amount: 0,
                  natural_amount: 0,
                  natural_tax_amount: 0
                },
                lineDetails: []
              };
            }
          }
        };

        $timeout(function () {
          totalsFieldCtrl.documentsAmountsCalculate();
        });
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('stockQuantityField', {
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        externalData: '<' // дополнительный источник общих для докумнета данных
      },
      templateUrl: 'app/documents/components/attribute/fields/stockQuantity/field/stock-quantity-field.html',
      controllerAs: 'stockQuantityField',
      controller: function ($scope, documentService, $uibModal, inventoryService, $timeout) {
        var stockQuantityField = this;
        var linesCode = stockQuantityField.item.ref[2],
            derivativeCode = stockQuantityField.item.ref[3],
            quantityCode = stockQuantityField.item.ref[4],
            lotSnCode = stockQuantityField.item.ref[5],
            uomCode = stockQuantityField.item.ref[6],
            dateCode = stockQuantityField.item.ref[1],
            divisionCode = stockQuantityField.item.ref[0];

        function getStockData(newValue, isSimple) {
          // копирование даты, чтобы изменения не влияли на дату документа
          var dateForStock = angular.copy(stockQuantityField.externalData[dateCode]);
          var params = {
            division: stockQuantityField.externalData.values[divisionCode].id,
            date: moment.utc(dateForStock.startOf('day')).add(2, 'day').startOf('day'),
            derivative: newValue[0][derivativeCode].id
          }
          if(!isSimple){
            if(newValue[0].stock_accounting_type == "BY_SERIAL_NUMBERS"){
              params.serial_number_id = newValue[1].id;
            }
            if(newValue[0].stock_accounting_type == "BY_LOTS_FIFO" || newValue[0].stock_accounting_type == "BY_LOTS_LIFO"){
              params.lot_number_id = newValue[1].id;
            }
          }
          // заполнение одной строки по выбранному диревативу и партии/серийнику
          inventoryService.getInventoryDivisionsStocks(params).then(function(res){
            if(res.data.length){
              var line = _.find(stockQuantityField.externalData.values[linesCode], function (line) {
                return line.derivative.id == res.data[0].id;
              });
              if(line){
                line[quantityCode] = res.data[0].quantity || 0;
                line[uomCode] = res.data[0].uom;
              }
            }
          });
        }

        $scope.$watchGroup(['stockQuantityField.values[stockQuantityField.item.ref[3]]', 'stockQuantityField.values[stockQuantityField.item.ref[5]]'], function (newValue, oldValue) {
          if(!stockQuantityField.externalData.$$derivativeLocker &&
            stockQuantityField.externalData[dateCode] &&
            stockQuantityField.externalData.values &&
            stockQuantityField.externalData.values[divisionCode]){

            if (newValue && newValue[0] && newValue[0].id) {
              if (oldValue && oldValue[0] && oldValue[0].id == newValue[0].id &&
                ((!newValue[1] && !oldValue[1]) || (newValue[1] && newValue[1].id == (oldValue[1] ? oldValue[1].id : undefined)))) {
                // объекты фактически равны
                return;
              }
              if (newValue[0].stock_accounting_type == "SIMPLE") {
                getStockData(newValue, true);
              }

              if( newValue[0].stock_accounting_type !== "SIMPLE" && newValue[1]){
                getStockData(newValue);
              }
            }

          }
        });
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('stockQuantityAll', {
      require: {
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        externalData: '<', // дополнительный источник общих для докумнета данных
        referenceData: '<?' // эталонные данные документа, для вычисления данных с сервера
      },
      controllerAs: 'stockQuantityAll',
      controller: function ($scope, $uibModal, inventoryService, $timeout, helpService) {
        var stockQuantityAll = this;
        stockQuantityAll.popupObj = undefined;
        var divisionCode = stockQuantityAll.item.ref[0],
            dateCode = stockQuantityAll.item.ref[1],
            linesCode = stockQuantityAll.item.ref[2],
            derivativeCode = stockQuantityAll.item.ref[3],
            baseQuantityCode = stockQuantityAll.item.ref[4],
            lotSnCode = stockQuantityAll.item.ref[5],
            uomCode = stockQuantityAll.item.ref[6];

        // событие при загрузке всего дерева странички
        $scope.$watch('$viewContentLoaded', function() { 
          $timeout(function() {
            stockQuantityAll.documentCtrl.startSaving = false; // todo что-то нужно придумать
          }, 1000);
        });

        // Загрузка данных складских остатков
        stockQuantityAll.loadInventory = function(close){
          var dateForStock = angular.copy(stockQuantityAll.externalData[dateCode]);
          stockQuantityAll.documentCtrl.startSaving = true;
          var params = {
            division: stockQuantityAll.externalData.values[divisionCode].id,
            date: moment.utc(dateForStock.startOf('day')).add(2, 'day').startOf('day')
          };
          inventoryService.getInventoryDivisionsStocks(params).then(function(res){
            stockQuantityAll.values[linesCode] = [];
            if(res.data.length){
              _.forEach(res.data, function(item, key){
                if(!stockQuantityAll.values[linesCode][key]){
                  stockQuantityAll.values[linesCode][key] = {};
                }
                stockQuantityAll.values[linesCode][key][derivativeCode] = item.derivative;
                stockQuantityAll.values[linesCode][key][derivativeCode].name = item.name;
                stockQuantityAll.values[linesCode][key][baseQuantityCode] = item.quantity || 0;
                stockQuantityAll.values[linesCode][key][uomCode] = item.uom;

                if(item.stock_accounting_type){
                  stockQuantityAll.values[linesCode][key][derivativeCode].stock_accounting_type = item.stock_accounting_type;
                }
                if(item.lot_number_id){
                  stockQuantityAll.values[linesCode][key][lotSnCode] = {
                    type: "LOT",
                    id: item.lot_number_id,
                    lot_number: item.lot_number,
                    manufacture_date: item.manufacture_date || null,
                    expiration_date: item.expiration_date || null
                  };
                }
                if(item.serial_number_id){
                  stockQuantityAll.values[linesCode][key][lotSnCode] = {
                    type: "SERIAL_NUMBER",
                    id: item.serial_number_id,
                    serial_number: item.serial_number
                  };
                }
              });
            }else{
              stockQuantityAll.values[linesCode] = [{}];
            }
            close();
            $timeout(function() {
              stockQuantityAll.documentCtrl.startSaving = false;
            });
          });
        }

        // попап на изменение даты
        $scope.$watch(function(){
          return stockQuantityAll.externalData[dateCode];
        }, function (newValue, oldValue) {
          if (!newValue || newValue.isEmpty || moment(newValue).isSame(oldValue)) return;
          if (!stockQuantityAll.popupObj && !stockQuantityAll.documentCtrl.startSaving && 
               stockQuantityAll.externalData.values[divisionCode]) { // проверка на необходимость заполнения данными
            stockQuantityAll.popupObj = $uibModal.open({
              templateUrl: 'app/settings/templates/modals/one-question.html',
              size: 'small-width',
              backdrop: 'static',
              keyboard: false,
              controller: function ($scope, $uibModalInstance) {
                $scope.text = "При изменении даты расчетное количество будет пересчитано. Продолжить?";
                $scope.close = function () {
                  $uibModalInstance.dismiss();
                  stockQuantityAll.popupObj = undefined;
                };
                $scope.action = function () {
                  $scope.load = true;
                  stockQuantityAll.loadInventory($scope.close);
                };
              }
            });
          }
        });

        // попап на изменение подразделения
        $scope.$watch(function(){
          return stockQuantityAll.values[divisionCode];
        }, function (newValue, oldValue) {
          if (!stockQuantityAll.popupObj && !stockQuantityAll.documentCtrl.startSaving && newValue && newValue.id // проверка на наличие всех необходимых данных
            && (!stockQuantityAll.referenceData.values || !stockQuantityAll.referenceData.values[divisionCode] || 
                newValue.id !== stockQuantityAll.referenceData.values[divisionCode].id)) { // проверка на необходимость заполнения данными
            if (!stockQuantityAll.externalData[dateCode] || stockQuantityAll.externalData[dateCode].isEmpty || 
                !newValue || (oldValue && newValue && oldValue.id == newValue.id)) return;
            stockQuantityAll.popupObj = $uibModal.open({
              templateUrl: 'app/settings/templates/modals/one-question.html',
              size: 'small-width',
              backdrop: 'static',
              keyboard: false,
              controller: function ($scope, $uibModalInstance) {
                $scope.text = "Загрузить данные складских остатков?";
                $scope.close = function () {
                  $uibModalInstance.dismiss();
                  stockQuantityAll.popupObj = undefined;
                };
                $scope.action = function () {
                  $scope.load = true;
                  stockQuantityAll.loadInventory($scope.close);
                };
              }
            });
          }
        });
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('priceWidgetColumn', {
      transclude: true,
      bindings: {
        priceListType: '<',
        column: '=',
        uomSymbol: '<',
        redactMode: '<',
        onColumnChange: '&'
      },
      templateUrl: 'app/settings/widgets/price-widget/components/price-widget-column/price-widget-column.html',
      controllerAs: 'priceWidgetColumn',
      controller: function (helpService) {
        var priceWidgetColumn = this;
        var today = helpService.now();
        priceWidgetColumn.column.prices
          .forEach(function (value, index, array) {
            value.$$deleted = false; // изачально нет удаленных, присваивание необходимо лля корректной работы стандартного фильтра
            value.$$hide = today.valueOf() < value.effective_date || (array.some(function (item, index2) {
              return item.effective_qty === value.effective_qty
                && (today.valueOf() >= item.effective_date) &&
                item.effective_date > value.effective_date && index2 !== index;
            }));
        });
        priceWidgetColumn.column.prices.sort(function (a, b) {
          return a.effective_qty - b.effective_qty
        });

        // полуение модели новой цены
        function _getNewPriceModel() {
          var price = {
            price_for_one_uom: 0,
            effective_qty: 1,
            $$uiid: helpService.stringGen(),
            $$modified: true,
            enable_to_modify: true,
            $$hide: false,
            $$deleted: false
          };
          if (priceWidgetColumn.priceListType !== 'PURCHASE') {
            price.effective_date = today.valueOf();
            price.free_of_control_price = false;
          }

          return price;
        }

        // получение контроллера поля
        function _getFieldCtrl(commonFieldName, index) {
          return priceWidgetColumn['form' + priceWidgetColumn.column.id]
            && priceWidgetColumn['form' + priceWidgetColumn.column.id][commonFieldName + index];
        }

        //проверка уникальности введенных значений цены или количества
        function _checkUnique(attributeToCheck) {
          priceWidgetColumn.column.prices.forEach(function (price, i, self) {
            var hasDuplicates = !price.$$hide && !price.$$deleted && self.some(function (price2, j) {
              return !price2.$$hide && !price2.$$deleted && price2[attributeToCheck] === price[attributeToCheck] && j !== i;
            });

            if (_getFieldCtrl(attributeToCheck, i)) {
              _getFieldCtrl(attributeToCheck, i).$setValidity('unique', !hasDuplicates);
            }
          });
        }

        function _setModified(price) {
          price.effective_date = today.valueOf();
          price.$$modified = true;
          price.enable_to_modify = true;
        }

        // хэндлер обработки флага с типом цены
        priceWidgetColumn.onTypeChange = function(price, index) {
          _setModified(price);
          priceWidgetColumn.onColumnChange({updatedColumn: priceWidgetColumn.column});
        };

        // хэндлер обработки количества
        priceWidgetColumn.onQtyChange = function(price, index) {
          _setModified(price);
          if (priceWidgetColumn.priceListType !== 'RETAIL') {
            _checkUnique('effective_qty')
          }
          priceWidgetColumn.onColumnChange({updatedColumn: priceWidgetColumn.column});
        };

        // хэгдлер обработки цены
        priceWidgetColumn.onPriceChange = function (price, index) {
          _setModified(price);
          priceWidgetColumn.onColumnChange({updatedColumn: priceWidgetColumn.column});
        };

        // добавление новой цены
        priceWidgetColumn.addNewPrice = function() {
          priceWidgetColumn.column.prices = priceWidgetColumn.column.prices || [];
          if (priceWidgetColumn.priceListType !== 'RETAIL' || !priceWidgetColumn.column.prices.length) {
            var price = _getNewPriceModel();
            priceWidgetColumn.column.prices.push(price);
            _checkUnique('effective_qty');
            priceWidgetColumn.onColumnChange({updatedColumn: priceWidgetColumn.column});
          }
        };

        priceWidgetColumn.removePrice = function(price, index){
          price.$$deleted = true;
          price.$$modified = true;
          priceWidgetColumn.onColumnChange({updatedColumn: priceWidgetColumn.column});
          priceWidgetColumn.column.prices.splice(index, 1);
        }
      }
    });
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('discountBelongs', discountBelongs);

  /**
   * Директива для отображения календаря действия акции
   */
  function discountBelongs() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/discounts/crudDiscount/discountDirectives/worksFor/discountBelongs.html',
      scope: {
        discount: '=',
        mode: '<',
        formCtrl: '=',
        parameterType: '<',
        catalogItemPopup: '=',
        catalogElementsError: '='
      },
      controller: discountCalendarController,
      controllerAs: 'vm'
    }

    function discountCalendarController($scope, companyService, $anchorScroll) {
      var vm = this;

      if ($scope.discount.regions.length) {
          $scope.discount.regions = _.map($scope.discount.regions, function(addr){
            return {
              address: addr,
              addressOptions: {}
            };
          });
        }

      vm.addRegion = function(){
        if(!$scope.discount.regions.length){
          $scope.discount.regions = [{
            address: {},
            addressOptions: {}
          }];
        }
      };

      vm.addItemData = function(arr){
        arr.push({});
      };

      vm.addAddressData = function(arr){
        arr.push({
          address: {},
          addressOptions: {}
        });
      };

      vm.removeItemData = function(arr, index){
        arr.splice(index, 1);
      };

      // сформировать необходимые данные для специфического множественного списка выбора для подразделений
      vm.divisionsData = [];
      companyService.divisions({limit: 200}).then(function(res){
        vm.divisionsData = res.data.items;
        if($scope.discount.divisions && $scope.discount.divisions.length){
          var tempDivisions = [];
          angular.forEach(vm.divisionsData, function(divAllinfo){
            angular.forEach($scope.discount.divisions, function(division){
              if(divAllinfo.id == division.id){
                tempDivisions.push(divAllinfo);
              }
            });
          });
          $scope.discount.divisions = tempDivisions;
        }
        $anchorScroll();
      });

    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('discountParameters', discountParameters);

  /**
   * Директива для отображения календаря действия акции
   */
  function discountParameters() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/discounts/crudDiscount/discountDirectives/parameters/discountParameters.html',
      scope: {
        discount: '=',
        parameter: '=',
        mode: '<',
        catalogItemPopup: '=',
        catalogElementsError: '=', // показ ошибка не выбранных товаров или услуг
        noParam: '=' // показ ошибки невыбранного параметра
      },
      controller: discountCalendarController,
      controllerAs: 'vm'
    }

    function discountCalendarController($scope, discountsService, categoryService, currenciesService, $uibModal) {
      var vm = this;
      var parentScope = $scope;
      vm.propertyTypes = [];
      vm.currency = {};

      // Сопоставляет тип скидки из API с типом в справочнике свойств
      function getCatalogPropertyType(type) {
        if (type === 'FIXED_AMOUNT') {
          return 'PROC_OF_CASH_RECEIPT_AMOUNT';
        }
        if (type === 'CASHIER_DECIDES_AMOUNT_FOR_SEL_ITEMS') {
          return 'CASHIER_DECIDES_ON_PROC';
        }
        return type;
      }

      // Восстанавливает фактический тип и единицу измерения после подстановки шаблона.
      function syncDiscountUnit(parameter, discountType) {
        if (discountType === 'FIXED_AMOUNT' || discountType === 'CASHIER_DECIDES_AMOUNT_FOR_SEL_ITEMS') {
          parameter.type = discountType;
          parameter.unit = 'summ';
        } else if (discountType === 'PROC_OF_CASH_RECEIPT_AMOUNT' || discountType === 'CASHIER_DECIDES_ON_PROC') {
          parameter.type = discountType;
          parameter.unit = 'percent';
        }
      }

      function isCashierDiscountType(type) {
        return type === 'CASHIER_DECIDES_ON_PROC' || type === 'CASHIER_DECIDES_AMOUNT_FOR_SEL_ITEMS';
      }

      function setParam(item) {
        if (item) {
          // Копия, чтобы смена type/unit не портила справочник типов в попапе
          parentScope.parameter = angular.copy(item);
          if(item.units){
            parentScope.parameter.units = $scope.discount.units;
          }
          if($scope.discount.discount_set_items){
            parentScope.parameter.discount_set_items = $scope.discount.discount_set_items;
          }
          syncDiscountUnit(parentScope.parameter, $scope.discount.type);
        }
      }

      discountsService.getDiscountProperties().then(function(res){
        vm.propertyTypes = angular.copy(res.data.items);
        vm.metaType = $scope.discount.type;
        var catalogType = getCatalogPropertyType($scope.discount.type);
        if(catalogType !== 'PROC_FOR_EACH_NTH_UNIT_IN_ONE_LINE') {
          setParam(_.find(vm.propertyTypes, function(item) {
            return item.type === catalogType
          }))
        } else if ($scope.discount.type === 'PROC_FOR_EACH_NTH_UNIT_IN_ONE_LINE') {
          if ($scope.discount.units.length === 1 && $scope.discount.units[0].unit_seq_num === 1) {
            setParam(_.find(vm.propertyTypes, function(item) {
              return item.type === $scope.discount.type && item.units[0].unit_seq_num === 1;
            }));
            vm.metaType = 'PROC_ON_ONE'
          } else {
            setParam(_.find(vm.propertyTypes, function(item) {
              return item.type === $scope.discount.type && item.units[0].unit_seq_num === ''
            }))
          }
        }
      });

      function getType(discount) {
        vm.metaType = discount.type;
        if (discount.type === 'PROC_FOR_EACH_NTH_UNIT_IN_ONE_LINE' && discount.unitSeqNum === 1) {
          vm.metaType = 'PROC_ON_ONE'
        }
      }


      currenciesService.getDomainCurrencies().then(function(res){
        vm.currency = _.find(res.data.items, function(cur){
          return cur.home_currency;
        });
      });

      vm.addDiscount = function(){
        parentScope.parameter.units.push({
          unit_seq_num: "", // Номер позиции в строке или чеке, Порядковый номер товара
          proc_value: "" // цена в процентах
        });

      };
      vm.removeDiscount = function(index){
        parentScope.parameter.units[index].unit_seq_num = null;
        vm.checkUniqueNumber(null, index);
        parentScope.parameter.units.splice(index, 1)
      };

      vm.removeDiscountSetItem = function(index) {
        parentScope.parameter.discount_set_items.splice(index, 1)
      }

      vm.changeUnit = function(){
        var isCashier = isCashierDiscountType(parentScope.parameter.type) || isCashierDiscountType(vm.metaType);
        if(parentScope.parameter.unit == 'summ'){
          parentScope.parameter.type = isCashier ? 'CASHIER_DECIDES_AMOUNT_FOR_SEL_ITEMS' : 'FIXED_AMOUNT';
          parentScope.parameter.units[0].proc_value = 0;
        }else if(parentScope.parameter.unit == 'percent'){
          if (isCashier) {
            parentScope.parameter.type = 'CASHIER_DECIDES_ON_PROC';
            parentScope.parameter.units[0].max_discount_amount = 0;
          } else {
            parentScope.parameter.type = 'PROC_OF_CASH_RECEIPT_AMOUNT';
            parentScope.parameter.units[0].fixed_amount = 0;
          }
        }
      };

      // Проверяет максимальную сумму скидки кассира.
      vm.validateMaxDiscountAmount = function() {
        var control = vm.discountParamentsForm && vm.discountParamentsForm.maxDiscountAmount;
        if (!control || !parentScope.parameter || !parentScope.parameter.units || !parentScope.parameter.units[0]) {
          return;
        }
        var value = parentScope.parameter.units[0].max_discount_amount;
        var hasValue = value !== undefined && value !== null && value !== '';
        control.$setValidity('required', hasValue);
        control.$setValidity('min', !hasValue || Number(value) > 0);
      };

      vm.checkUniqueNumber = function(number, index) {
        number = parseFloat(number); // получение числа из инпута
        var numbers = $scope.parameter.units.map(function (value) { return parseFloat(value.unit_seq_num)});

        function getAllIndexes(arr, target) { // получение всех индексов с определенным значением
          var result = [];
          arr = angular.copy(arr);
          do {
            var index = arr.indexOf(target);
            result.push(index);
            arr[index] = null;
          } while (arr.indexOf(target) >= 0);

          return result;
        }

        angular.forEach(_.uniq(numbers), function (value) { // обход уникальных значений
          var duplicatesArray = getAllIndexes(numbers, value); // получение индексов оригинального массива с значением из уникального

          if (duplicatesArray.length > 1) { // если совпадений более чем 1
            duplicatesArray.forEach(function (j) { // обход индексов оригинального массива и установка флага invalid
              if (vm.discountParamentsForm && vm.discountParamentsForm['unit_seq_num' + j]) {
                vm.discountParamentsForm['unit_seq_num' + j].$setValidity('unique', false);
              }
            })
          } else { // если в массиве один индек - значит значение уникальнно
            if (vm.discountParamentsForm && vm.discountParamentsForm['unit_seq_num' + duplicatesArray[0]]) {
              // обход индексов оригинального массива и установка флага valid
              vm.discountParamentsForm['unit_seq_num' + duplicatesArray[0]].$setValidity('unique', true);
            }
          }
        });

        if (isNaN(number)) { // если true - значение - пустая строка
          if (vm.discountParamentsForm && vm.discountParamentsForm['unit_seq_num' + index]) {
            // обход индексов оригинального массива и установка флага valid
            vm.discountParamentsForm['unit_seq_num' + index].$setValidity('unique', true);
          }
        }
      };

      vm.openPropertyPopup = function () {
        $uibModal.open({
          templateUrl: 'app/settings/discounts/crudDiscount/modals/propertyPopup.html',
          size: 'large-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.propertyTypes = angular.copy(vm.propertyTypes);

            $scope.search = function () {
              var tempTypes = [];
              if($scope.searchText){
                angular.forEach(vm.propertyTypes, function(item){
                  if(~item.description.indexOf($scope.searchText) ||
                    ~item.description.indexOf($scope.example) ||
                    ~item.description.indexOf($scope.name) ||
                    ~item.name.indexOf($scope.searchText) ||
                    ~item.name.indexOf($scope.example) ||
                    ~item.name.indexOf($scope.name)
                  ){
                    tempTypes.push(item);
                  }
                });
                $scope.propertyTypes = tempTypes;
              }else{
                $scope.propertyTypes = vm.propertyTypes;
              }
            };

            $scope.close = function () {
              $uibModalInstance.dismiss();
            };

            $scope.choose = function(prop, index) {
              parentScope.noParam = false;
              parentScope.parameter = angular.copy(prop);
              parentScope.parameter.unitSeqNum = (index == 1)? 1 : 0;
              if(parentScope.parameter.type == 'PROC_FOR_UNIT_FROM_SET'){
                parentScope.discount.all_catalog_elements = true;
                delete parentScope.discount.catalog_elements;
              }
              getType(prop);
              $uibModalInstance.dismiss();
            };

            // настройка скролла
            $scope.configScroll = {
              axis:'y',
              autoHideScrollbar: false,
              theme: 'dark',
              advanced:{
                updateOnContentResize: true
              },
              setHeight: 500,
              scrollInertia: 0,
              scrollButtons: {
                enable: false // enable scrolling buttons by default
              }
            }

          }
        });
      }

    }
  }
}) ();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('discountCalendar', discountCalendar);

  /**
   * Директива для отображения календаря действия акции
   */
  function discountCalendar(auth) {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/discounts/crudDiscount/discountDirectives/calendar/discountCalendar.html',
      scope: {
        discount: '=',
        mode: '<',
        formCtrl: '=',
        unique: '<'
      },
      controller: discountCalendarController,
      controllerAs: 'vm'
    };

    function discountCalendarController($scope, helpService) {
      var vm = this;
      var startTime = "00:00";
      var endTime = "23:59";
      var today = helpService.now();

      vm.timetable = [
        {
          id: 'ANY_DAY',
          name: 'Ежедневно'
        },
        {
          id: 'WORKING_DAY_OFF',
          name: 'По будням и выходным'
        },
        {
          id: 'DAY_OF_WEEK',
          name: 'Индивидуально по дням'
        }
      ];

      vm.calendarsMode = [
        {
          id: 'interval',
          name: 'промежуток'
        },
        {
          id: 'round the clock',
          name: 'круглосуточно'
        },
        {
          id: 'not',
          name: 'не действует'
        }
      ];

      vm.effective_date = $scope.discount.effective_date ? moment.utc($scope.discount.effective_date) : today.clone().startOf('day');
      vm.expire_date = $scope.discount.expire_date ? moment.utc($scope.discount.expire_date) : today.clone().startOf('day');
      vm.expire_date.isEmpty = !$scope.discount.expire_date;
      vm.dateOptsStart = {singleDatePicker: true, correctTimeZone: false, minDate: today };

      $scope.$watch('discount.effective_date', function () {
        $scope.formCtrl.name.$setValidity('unique', true);
        if ($scope.formCtrl.effective_date) {
          $scope.formCtrl.effective_date.$setValidity('unique', true);
        }
        $scope.unique();
      });

      function createTimeItem(type) {
        return {
          day_type: type,
          from_hour: startTime,
          upto_hour: endTime,
          $$mode: 'round the clock'
        };
      }

      vm.getDayStr = function (number) {
        return moment().weekday(number).format('dddd');
      };

      vm.calendarType = vm.calendarType || 'ANY_DAY';
      if ($scope.discount.times) {
        angular.forEach($scope.discount.times, function (item) {
          if (item.day_type === 'ANY_DAY') {
            vm.calendarType = 'ANY_DAY';
          } else if (item.day_type === 'WORKING_DAY' || item.day_type == 'DAY_OFF') {
            vm.calendarType = 'WORKING_DAY_OFF';
          } else if (item.day_type === 'DAY_OF_WEEK') {
            vm.calendarType = 'DAY_OF_WEEK';
          }
        });
        if ($scope.discount.times[0].day === 6) {
          $scope.discount.times.reverse();
        }
      }

      if (!$scope.discount.times) {
        $scope.discount.times = [];
        $scope.discount.times.push(createTimeItem("ANY_DAY"));
      }

      vm.changeMode = function (item) {
        if (item.mode === 'round the clock') {
          item.from_hour = startTime;
          item.upto_hour = endTime;
        } else if (item.mode === 'not') {
          item.from_hour = startTime;
          item.upto_hour = startTime;
        }
      };

      // изменение режима календаря
      vm.changeTimetable = function () {
        if (vm.calendarType === 'ANY_DAY') {
          $scope.discount.times = [];
          $scope.discount.times.push(createTimeItem("ANY_DAY"));
        } else if (vm.calendarType === 'DAY_OF_WEEK') {
          $scope.discount.times = [];
          for (var i = 0; i < 7; i++) {
            $scope.discount.times.push({
              day_type: "DAY_OF_WEEK",
              from_hour: startTime,
              upto_hour: endTime,
              $$mode: 'round the clock',
              day: i
            });
          }
        } else if (vm.calendarType === 'WORKING_DAY_OFF') {
          $scope.discount.times = [];
          $scope.discount.times.push(createTimeItem("WORKING_DAY"));
          $scope.discount.times.push(createTimeItem("DAY_OFF"));
        }
      };

      vm.onDatePickerClose = function (returnValue, name) {
        $scope.discount[name] = returnValue && !returnValue.isEmpty
          ? returnValue
          : null;

        if (name === 'effective_date') {
          vm.dateOptsEnd = {
            singleDatePicker: true, correctTimeZone: false,
            minDate: returnValue
          };

          if (returnValue && vm.expire_date && !vm.expire_date.isEmpty &&
            returnValue.isAfter(vm.expire_date)) {
            vm.expire_date = returnValue.clone().add(1, 'day');
            vm.expire_date.enableUpdate = true;
          }
        }
      };

      auth.ensureUserData().then(function (user) {
        $scope.tz = user.data.user.time_zone_ext.offset || moment().format('Z');
        vm.onDatePickerClose(vm.effective_date, 'effective_date');
        vm.onDatePickerClose(vm.expire_date, 'expire_date');
      });

      vm.dateOptsEnd = {
        singleDatePicker: true, correctTimeZone: false,
        minDate: vm.effective_date
      };
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('allFilter', allFilter);

  function allFilter($timeout, dateRangePickerService) {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/components/filters/modals/allFilters/all-filters.html',
      scope: {
        filterMeta: '=',
        applyFilter: '=',
        filterData: '=',
        cleanFilter: '='
      },
      link: function(scope, element, attr) {
        function onOpenEventHandler() {
          $timeout(function() {
            angular.forEach(element.find('.multiple-select'), function(elem) {
              scope.$broadcast(elem.getAttribute('focus-on'));
            });
          }, 500, false)
        }

        scope.$on('popupFilterOpen', onOpenEventHandler);

      },
      controller: function ($scope, auth) {
        $scope.filterData = $scope.filterData || {};
        $scope.tz = {};
        $scope.state = {};
        $scope.dateFilters = {};
        $scope.showDateFilters = false;


        $scope.configScroll = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          setHeight: 422,
          scrollInertia: 0,
          scrollButtons: {
            enable: false
          },
          mouseWheel: {
            preventDefault: false,
            disableOver: ['ul', 'li', 'span']
          }
        };

        $scope.$on('popupFilterOpen', function(e, data) {
          $scope.showDateFilters = false;
          for (var i in data) {
            if (data.hasOwnProperty(i) && data[i] && (data[i].startDate && data[i].endDate)) {
              if (!$scope.filterData[i]) $scope.filterData[i] = {};
              $scope.filterData[i].startDate = data[i].startDate && moment(data[i].startDate);
              $scope.filterData[i].endDate = data[i].endDate && moment(data[i].endDate);
            }
          }
          $scope.showDateFilters = true;
        });

        $scope.onDatePickerClose = function (returnValue, name) {
          if (returnValue && !returnValue.isAllTime) {
            $scope.dateFilters[name] = returnValue;
          } else if (returnValue && returnValue.isAllTime) {
            delete $scope.dateFilters[name];
          }
        };

        $scope.onSelect = function(item , id) {
          $scope.filterData[id] = item
        };

        $scope.prepareApply = function () {
          for (var i in $scope.filterData) {
            if ($scope.filterData.hasOwnProperty(i) && $scope.filterData[i] && $scope.filterData[i].isAllTime) {
              delete $scope.filterData[i];
            }
          }
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('yearSelect', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        redact: '<?', // режим редактирования
        meta: '<?', //вся мета для дизэйбла поля даты
        externalData: '<'
      },
      templateUrl: 'app/documents/components/attribute/fields/select/simple-select.html',
      controllerAs: 'vm',
      controller: function ($scope, $rootScope, OPTIONS_LENGTH) {
        var vm = this;
        var year = new Date().getFullYear();
        var refMeta = _.find(vm.meta.layout[0].items, function(item){
          return item.code == vm.item.ref[0];
        });

        // заполнение массива перечнем годов(лет)
        vm.data = [year];
        for (var i = 0; i < OPTIONS_LENGTH - 1; i++) {
          vm.data.push((vm.data[vm.data.length - 1]) - 1);
        }

        if (vm.item.ref[3] && vm.values[vm.item.ref[3]] &&
            vm.values[vm.item.ref[3]].period_type) {
          vm.values[vm.item.ref[1]] = true;
          vm.values[vm.item.code] = new Date(vm.values[vm.item.ref[3]].start_date).getFullYear();
        }

        $scope.$watch(function() { return vm.values[vm.item.ref[1]] }, function(newVal, oldVal) {
          vm.show = newVal;
          refMeta.disabled = newVal;
          if (!newVal && oldVal !== undefined) {
            vm.values[vm.item.code] = undefined;
            vm.values[vm.item.ref[3]] = null;
            if (oldVal) {
              vm.externalData[vm.item.ref[0]] = moment().utc();
            }
          }
        });

        vm.setTime = function (date) {
          var now = new Date();
          return date.set({hour: now.getUTCHours(), minute: now.getUTCMinutes(), second: now.getUTCSeconds(), millisecond: now.getUTCMilliseconds()});
        }

        vm.change = function(newVal) {
          if (newVal) {
            var start_date;
            if (vm.values[vm.item.ref[2]]) {
              if (vm.values[vm.item.ref[2]].value == 'MONTH') {
                start_date = moment().utc().month(vm.values[vm.item.ref[2]].id);
              } else {
                start_date = moment().utc().quarter(vm.values[vm.item.ref[2]].id);
              }
              start_date = start_date.year(newVal).startOf(vm.values[vm.item.ref[2]].value.toLowerCase());
              vm.externalData[vm.item.ref[0]] = vm.setTime(start_date.year(newVal).endOf(vm.values[vm.item.ref[2]].value.toLowerCase()));
            } else {
              start_date = moment().utc().year(newVal).startOf('year');
              vm.externalData[vm.item.ref[0]] = vm.setTime(moment().utc().year(newVal).endOf('year'));
            }
            vm.values[vm.item.ref[3]] = {
              start_date: moment.utc(start_date).valueOf(),
              period_type: "YEAR"
            }
            
          } else {
            vm.values[vm.item.ref[3]] = null;
          }
        };

      }
    });
})();
(function () {
  'use strict';

  angular
    .module('frontend')
    .component('uomField', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<' // метод получения списка
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope) {
        var vm = this;
        
        // вотчер на зависимое поле
        $scope.$watch('vm.values[vm.item.ref[0]]', function(newValue, oldValue) {
          if (newValue && (!oldValue || 
             (newValue.derivative && oldValue.derivative && newValue.derivative.name !== oldValue.derivative.name))) {
            vm.refresh(true, newValue);
          }
        });

        // todo посмотреть необходима ли выпадашка, есть подозрения, что это не выпадающий список нужен, апросто readonly блок
        vm.refresh = function(fromWatch, data){
          if(fromWatch === true && vm.values[vm.item.ref[0]] && vm.values[vm.item.ref[0]].id && vm.values[vm.item.ref[0]][vm.item.code]){
            if (data && data[vm.item.code]) {
              vm.values[vm.item.code] = {
                id: data[vm.item.code].id,
                name: data[vm.item.code].symbols || data[vm.item.code].name
              };
            } else { 
              vm.values[vm.item.code] = vm.values[vm.item.code] || vm.values[vm.item.ref[0]][vm.item.code];
            }
          }
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('taxGroupField', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<', // метод получения списка
        redact: '<?', // режим редактирования
        onCurrencyChange: '=?', // события на изменение валюты,
        externalData: '<?',
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope) {
        var vm = this;
        vm.documentDate = vm.externalData.date;
        vm.amount = vm.amount || 5;
        if(vm.item.ref){
          // вотчер на зависимое поле дериватива
          $scope.$watch('vm.values[vm.item.ref[0]]', function(newVal) {
            if(vm.values[vm.item.ref[0]] && !vm.values[vm.item.code]){
              vm.values[vm.item.code] = newVal.tax_group ? newVal.tax_group: newVal.committent_tax_group;
            }
          });

          // вотчер на зависимое поле компании
          $scope.$watch('vm.externalData[vm.item.ref[1]]', function(newVal, oldVal) {
            if (newVal && (!oldVal || newVal.id !== oldVal.id) ) {
              vm.values[vm.item.code] = undefined;
              vm.refresh('', undefined, newVal.id);
            }
          });
          if (vm.item.ref[2]) {
            // вотчер на зависимое поле отображать/неотображать
            $scope.$watch('vm.values[vm.item.ref[2]]', function(newVal) {
              vm.hideField = !newVal;
              if (!newVal) {
                vm.values[vm.item.code] = undefined;
              }
            });
          }
        }

        vm.refresh = function(search, select, companyId){
          var date = moment.isMoment(vm.documentDate) ? vm.documentDate.valueOf() : vm.documentDate;
          var companyId = companyId ? companyId : (vm.externalData.company? vm.externalData.company.id : undefined);
          vm.getData(search, date, companyId).then(function(res){
            vm.items = res.data;
            vm.dynamicTotal = res.data.total;
            vm.total = res.data.length;
            vm.searchEnabled = (vm.amount === 100)? vm.total > vm.amount && vm.total <= vm.amount : vm.total > vm.amount;

            // выбор значения по-умолчанию
            if(vm.total == 1 && vm.item.required){
              vm.values[vm.item.code] = vm.items[0];
            }
          });
        }

        vm.totalStr = function(){
          if(vm.dynamicTotal > vm.amount){
            return "Показано " + vm.amount + " из " + vm.dynamicTotal;
          }
          return '';
        };
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('skuModalInfo', {
      transclude: true,
      bindings: {
        modalInstance: "<",
        resolve: '<',
      },
      templateUrl: 'app/documents/components/attribute/fields/skuModalInfo/sku-modal-info-popup.html',
      controllerAs: 'skuModalInfoCtrl',
      controller: function ($scope, egaiszService) {
        var skuModalInfoCtrl = this;
        skuModalInfoCtrl.load = true;
        if (skuModalInfoCtrl.resolve.is_recs_sku) {
          egaiszService.getSkuInfo(skuModalInfoCtrl.resolve.alcohol_catalog_item_id).then(function(res){
            skuModalInfoCtrl.load = false;
            skuModalInfoCtrl.data = res.data;
            console.log(skuModalInfoCtrl.data)
          });
        } else {
          egaiszService.getLineInfo(skuModalInfoCtrl.resolve.document_id, skuModalInfoCtrl.resolve.line.id).then(function(res){
            skuModalInfoCtrl.load = false;
            skuModalInfoCtrl.data = res.data;
            console.log(skuModalInfoCtrl.data)
          });
        }
        
        skuModalInfoCtrl.close = function () {
          skuModalInfoCtrl.modalInstance.dismiss();
        };

        skuModalInfoCtrl.configScroll = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          scrollButtons: {
            enable: false
          },
          setHeight: 416,
          scrollInertia: 0,
          axis: 'y'
        };
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('simplifiedContent', {
      transclude: true,
      bindings: {
        values: '<',
        redact: '<',
        item: '<', // единая для документа карта значений
        purpose: '=' // атрибуты изменяют данные
      },
      templateUrl: 'app/documents/components/attribute/fields/simplified-content/simplified-content.html',
      controllerAs: 'simplifiedContentCtrl',
      controller: function ($scope, documentService, $uibModal) {
        var simplifiedContentCtrl = this;
        documentService.getSimplifiedContent().then(function(result){
          simplifiedContentCtrl.allContents = result.data.items;
        });

        simplifiedContentCtrl.setData = function(){
          var objContent = _.find(simplifiedContentCtrl.allContents, function(item){
            if (simplifiedContentCtrl.purpose == item.purpose) {
              return item;
            }
          });
          simplifiedContentCtrl.values[simplifiedContentCtrl.item.code] = objContent.content;
        }

        // вотчер на зависимое поле отображать/неотображать
        $scope.$watch('simplifiedContentCtrl.values[simplifiedContentCtrl.item.ref[0]]', function(newVal) {
          simplifiedContentCtrl.hideField = !newVal;
          if (!newVal) {
            simplifiedContentCtrl.values[simplifiedContentCtrl.item.code] = undefined;
          } else {
            if (!simplifiedContentCtrl.values[simplifiedContentCtrl.item.code]) {
              simplifiedContentCtrl.setData();
            }
          }
        });


      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('selectWithoutAutocomplete', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<', // метод получения списка
        redact: '<?', // режим редактирования
        purpose: '<',
        externalData: '=',
        param: '<?', // параметр для запроса
        outsideRefresh: '=?'
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $rootScope) {
        var vm = this;
        vm.amount = vm.amount || 5;
        vm.refresh = function(){
          vm.getData(vm.param).then(function(res){
            vm.items = res.data;
            vm.total = res.data.length;
            // выбор значения по-умолчанию
            if(vm.total == 1 && vm.item.required){
              vm.values[vm.item.code] = vm.items[0];
            }
          });
        };

        vm.outsideRefresh = function(){
          vm.refresh();
        }

        vm.getTitleMatch = function(str) {
          return $scope.$eval(str);
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('titleExt', function ($interpolate) {
      return {
        restrict: 'EA',
        scope: false,
        link: function ($scope, $elem, $attrs) {
          var sc = $scope;
          $scope.$watch(function () { return $elem[0].innerText; }, function(newVal, oldVal) {
            var res = sc.$eval($attrs.titleExt);
            var text = $interpolate(res)(sc);
            $elem.attr('title', text);
          });
          
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('selectField', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<', // метод получения списка
        redact: '<?', // режим редактирования
        purpose: '<', // назначение документа
        onCurrencyChange: '=?', // события на изменение валюты
        filters: '<?',
        alwaysSet: '<?',
        resetDirty: '<?', // для сброса флагов поля и формы
        createStr: '<?', // текст внутри ссылки создания новой сущности
        createLink: '<?', // ссылка, куда переходить по клику на ссылке создания новой сущности
        createData: '<?' // данные для перехода на страничку создания новой сущности
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $rootScope, $state, $window, $timeout) {
        var vm = this;
        vm.amount = vm.amount || 5;

        if (vm.item.foreignOrganizations && vm.values[vm.item.code]) {
          vm.invalid = vm.values[vm.item.code].counterparty_egais_type == "FO" || vm.values[vm.item.code].counterparty_egais_type == "TS";
        }

        vm.refresh = function (search, select) {
          $timeout(function () {
            if (select) {
              vm.selectObj = select;
            }
          });
          var fsrarId = (vm.values.fsrar) ? vm.values.fsrar.id : undefined;
          vm.getData(search, vm.amount, vm.filters, undefined, fsrarId).then(function (res) {
            // валюта не показывается, если она одна (вообще я бы просто дизейблил, это было бы универсальным поведением)
            if (vm.item.field_type == 'FLD_CURRENCY' && res.data.items.length == 1) {
              vm.item.$$hidden = true;
            }
            vm.dynamicTotal = res.data.total;
            vm.items = Array.isArray(res.data) ? res.data : res.data.items;
            vm.total = res.data.total;
            vm.searchEnabled = (vm.amount == 100) ? vm.total > vm.amount && vm.total <= vm.amount : vm.total > vm.amount;
            if (vm.item.create_new_item && vm.items[vm.items.length - 1] && !vm.items[vm.items.length - 1].helper) {
              vm.items.push({ helper: true });
            }
            // выбор значения по-умолчанию
            if (vm.items && ((vm.total == 1 && vm.item.required) || (vm.alwaysSet && !vm.values[vm.item.code]))) {
              vm.values[vm.item.code] = vm.items[0];
            }
          });
        };

        vm.totalStr = function () {
          if (vm.dynamicTotal > vm.amount) {
            return "Показано " + vm.amount + " из " + vm.dynamicTotal;
          }
          return '';
        };

        vm.getTitleMatch = function (str) {
          return $scope.$eval(str);
        };

        vm.change = function (selected, select) {
          if (vm.item.field_type == 'FLD_CURRENCY') {
            vm.onCurrencyChange(vm.values[vm.item.code], vm.item.ref[0]);
          }
          if (vm.item.foreignOrganizations) {
            vm.selectObj.ngModel.$setValidity('foreign-organizations', selected.counterparty_egais_type !== "FO" && selected.counterparty_egais_type !== "TS");
          }
        };

        var initWatchDestroyer = $scope.$watch(function () { return vm.values[vm.item.code] }, function (newVal) {
          if (!newVal) {
            // TODO:: видимо стоит убирать вотчер после первого обновления?
            vm.refresh();
            initWatchDestroyer();
          }
        });

        // реф 1 - связь с полем типа boolean(FLD_BOOLEAN или FLD_CHECKBOX)
        if (vm.item.ref && vm.item.ref[1]) {
          $scope.$watch(function () { return vm.values[vm.item.ref[1]] }, function (val) {
            $scope.hide = !val;
            if ($scope.hide) {
              vm.values[vm.item.code] = undefined;
            }
          })
        }

        vm.toCreateItem = function (event, select) {
          select.close();
          event.stopPropagation();
          var url = $state.href(vm.createLink, vm.createData);
          $window.open(url, '_blank');
        };

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('quarterOrMonth', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        redact: '<?', // режим редактирования
        meta: '<?', //вся мета для дизэйбла поля даты
        externalData: '<?'
      },
      templateUrl: 'app/documents/components/attribute/fields/select/simple-select.html',
      controllerAs: 'vm',
      controller: function ($scope, $rootScope, utilsService, OPTIONS_LENGTH) {
        var vm = this;
        var refMeta = _.find(vm.meta.layout[0].items[1], function(item){
          return item.code == vm.item.ref[0];
        });

        // получние данных по месяцу и по кварталам
        utilsService.quarterOrMonth().then(function(res){
          vm.data = res.data.items;

          if (vm.item.ref[3] && vm.values[vm.item.ref[3]] &&
              vm.values[vm.item.ref[3]].period_type &&
              vm.values[vm.item.ref[3]].period_type !== "YEAR") {
            var id;
            vm.show = true;
            vm.values[vm.item.ref[1]] = true;
            if (vm.values[vm.item.ref[3]].period_type == "QUARTER") {
              id = moment.utc(vm.values[vm.item.ref[3]].start_date).quarter()
            } else {
              id = (moment.utc(vm.values[vm.item.ref[3]].start_date).format('M')) - 1;
            }
            vm.values[vm.item.code] = _.find(vm.data, function(item){
              return item.value == vm.values[vm.item.ref[3]].period_type &&
                     item.id == id;
            });
          }

        });

        $scope.$watch(function() { return vm.values[vm.item.ref[1]] }, function(newVal, oldVal) {
          vm.show = newVal;
          if (!newVal && oldVal !== undefined) {
            vm.values[vm.item.code] = undefined;
            vm.values[vm.item.ref[3]] = null;
            if (oldVal) {
              vm.externalData[vm.item.ref[0]] = moment().utc();
            }
          }
        });

        vm.setTime = function (date) {
          var now = new Date();
          return date.set({hour: now.getUTCHours(), minute: now.getUTCMinutes(), second: now.getUTCSeconds(), millisecond: now.getUTCMilliseconds()});
        }

        vm.change = function(newVal) {
          if (newVal && vm.values[vm.item.ref[2]]) {
            var start_date;
            if (newVal.value == 'MONTH') {
              start_date = moment().utc().month(newVal.id);
            } else {
              start_date = moment().utc().quarter(newVal.id);
            }
            vm.values[vm.item.ref[3]] = {
              start_date: moment.utc(start_date.year(vm.values[vm.item.ref[2]]).startOf(newVal.value.toLowerCase())).valueOf(),
              period_type: newVal.value
            }
            vm.externalData[vm.item.ref[0]] = vm.setTime(moment.utc(start_date.year(vm.values[vm.item.ref[2]]).endOf(newVal.value.toLowerCase()))).valueOf();
          } else {
            vm.values[vm.item.code] = null;
            if (vm.values[vm.item.ref[2]]) {
              vm.externalData[vm.item.ref[0]] = vm.setTime(moment().utc().year(vm.values[vm.item.ref[2]]).endOf('year')).valueOf();
              vm.values[vm.item.ref[3]] = {
                start_date: moment().utc().year(vm.values[vm.item.ref[2]]).startOf('year').valueOf(),
                period_type: "YEAR"
              }
            } else {
              vm.values[vm.item.ref[1]] = false;
              vm.values[vm.item.ref[3]] = null;
            }
          }
        };

        vm.getViewStr = function () {
          if (vm.values[vm.item.code]) {
            return vm.values[vm.item.code].label;
          } else {
            return "-";
          }
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('quantityWriteOff', {
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        externalData: '='
      },
      templateUrl: 'app/documents/components/attribute/fields/quantity/quantity-field.html',
      controllerAs: 'quantityFieldCtrl',
      controller: function ($scope, $filter, $uibModal, egaiszService, attributeUtilService) {
        var quantityFieldCtrl = this;
        var ref_writeup = quantityFieldCtrl.item.ref[3];
        var ref_changealcohol = quantityFieldCtrl.item.ref[4];
        var ref_transferDirection = quantityFieldCtrl.item.ref[5];
        var documentCtrl = $scope.$parent.$parent.$parent.documentAttributeCtrl.documentCtrl;

        quantityFieldCtrl.needMarks = quantityFieldCtrl.item.needMarks;

        quantityFieldCtrl.universalSetterGetter = function (value) {
          if (angular.isDefined(value) || arguments.length > 0) {
            return attributeUtilService._setValueDeep(
              quantityFieldCtrl.values,
              quantityFieldCtrl.item.code.split('.'),
              value);
          } else {
            return quantityFieldCtrl.item.code &&  attributeUtilService._getValueDeep(
              quantityFieldCtrl.values,
              quantityFieldCtrl.item.code.split('.'));
          }
        };


        // вывод в подсказку марок, если они есть
        quantityFieldCtrl.getMarksTooltip = function(label){
          quantityFieldCtrl.amcsList = label || 'Марки для списания: ';
          if (quantityFieldCtrl.values && quantityFieldCtrl.values.amcs && quantityFieldCtrl.values.amcs.length) {
            _.forEach(quantityFieldCtrl.values.amcs, function (acm) {
              if(quantityFieldCtrl.amcsList !== label  &&
                 quantityFieldCtrl.amcsList !== 'Марки для списания: '){
                quantityFieldCtrl.amcsList += ', ';
              }
              quantityFieldCtrl.amcsList += $filter('egaisBarcode')(acm.amc);
            });
          }
        }
        quantityFieldCtrl.getMarksTooltip((quantityFieldCtrl.item.noSource)? 'Выбранные марки: ' : undefined);

        // количество undefined устанавливается равной 0 по бизнес-логике
        quantityFieldCtrl.universalSetterGetter(quantityFieldCtrl.universalSetterGetter() || 0);

        // хук на изменение выбранного товара
        $scope.$watch('quantityFieldCtrl.values[quantityFieldCtrl.item.ref[0]]', function (newValue, oldValue) {
          // при заполнении складской позиции количество всегда выставляется как 0
          if (newValue) {
            quantityFieldCtrl.stockAccountingType = newValue.stock_accounting_type;
            if(!oldValue || newValue.id !== oldValue.id){
              quantityFieldCtrl.universalSetterGetter(0);
              quantityFieldCtrl.values.amcs = [];
              quantityFieldCtrl.amcsList = '';
            }
            // убрать поиск
            // если крепкий алкоголь
            if (newValue.is_alcohol && newValue.require_amc) {
              quantityFieldCtrl.needMarks = true;
              if (quantityFieldCtrl.item.noSource) {
                quantityFieldCtrl.needMarks = ref_transferDirection && quantityFieldCtrl.externalData[ref_transferDirection] == "REGISTER1";
              }
            }else{
              quantityFieldCtrl.needMarks = false;
            }
          } else {
            quantityFieldCtrl.stockAccountingType = undefined;
          }
        });

        if (quantityFieldCtrl.item.noSource) {
          // проверка по регистру
          $scope.$watch(function () {
            return quantityFieldCtrl.externalData[ref_transferDirection];
          }, function (newVal, oldVal) {
            if (newVal !== oldVal) {
              quantityFieldCtrl.universalSetterGetter(0);
              if (quantityFieldCtrl.values[quantityFieldCtrl.item.ref[0]]) {
                quantityFieldCtrl.needMarks = quantityFieldCtrl.values[quantityFieldCtrl.item.ref[0]].is_alcohol && quantityFieldCtrl.values[quantityFieldCtrl.item.ref[0]].require_amc && newVal == "REGISTER1";
              }
            }
          });
        }

        // хук на изменение выбранной справки
        $scope.$watch('quantityFieldCtrl.values[quantityFieldCtrl.item.ref[2]]', function (newVal, oldVal) {
          if (newVal !== oldVal && (!newVal || (newVal && (!oldVal || newVal.id !== oldVal.id)))) {
            quantityFieldCtrl.universalSetterGetter(0);
            quantityFieldCtrl.values.amcs = [];
            quantityFieldCtrl.amcsList = '';
          }
        });

        function getData () {
          if (!quantityFieldCtrl.externalData[quantityFieldCtrl.item.ref[1]]) return;
          var params = {
            filter_is_burned: false,
            filter_stock_id: (quantityFieldCtrl.values[quantityFieldCtrl.item.ref[2]])? quantityFieldCtrl.values[quantityFieldCtrl.item.ref[2]].id : undefined,
            filter_fsrar_id : quantityFieldCtrl.externalData[quantityFieldCtrl.item.ref[1]].id,
            filter_derivative_id: quantityFieldCtrl.values[quantityFieldCtrl.item.ref[0]].derivative.id
          };

          // Загрузка марок, которые есть на балансе
          return egaiszService.getStockMarks(params).then(function (res) {
            var amcs = quantityFieldCtrl.values.amcs || quantityFieldCtrl.values.amc_list;
            // компоновка объекта для работы с принятыми и не принятыми марками.
            return {
              accepted_amcs: _.map(amcs, function(amc){
                if (!_.find(res.items, function(no_accept){
                    return no_accept.amc == amc.amc;
                  })) {
                  amc.$$canDelete = true;
                }
                return amc;
              }),
              // надо принятые марки удалить из массива непринятых марок
              no_accepted_amcs: _.reject(res.items, function(amc){
                return _.find(amcs, function(accept){
                  return accept.amc == amc.amc;
                });
              })
            };
          });
        }

        // сброс ошибок
        $scope.$watch('quantityFieldCtrl.values[quantityFieldCtrl.item.code]', function (newVal, oldVal) {
          var formCtrl = $scope.$parent.$parent.$parent.documentAttributeCtrl.documentCtrl.formCtrl;
          // RECS-11449 сброс ошибки поиска марки в системе
          if (formCtrl && quantityFieldCtrl.item.$errorObj) {
            var lineNumber = quantityFieldCtrl.item.$errorObj.field.split('.')[1];
            formCtrl.commonData['rowForm' + (lineNumber-1)][quantityFieldCtrl.item.code].$setValidity('notFoundMark', true);
          }
        });

        quantityFieldCtrl.showMarkViewModal = function(){
          if(quantityFieldCtrl.needMarks) {
            var modal = $uibModal.open({
              size: 'large-width',
              component: 'markViewModal',
              controllerAs: 'markViewModal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                item: quantityFieldCtrl.item,
                values: quantityFieldCtrl.values,
                externalData: quantityFieldCtrl.externalData,
                canAddNewMarks: true,
                multiSelect: true,
                data: function(){
                  return getData();
                },
                moveMarks: function () {
                  return function (codes, type) {
                    if (type == 'ACCEPTED') {
                      // если нет данных, то создать пустой массив
                      if (!quantityFieldCtrl.values.amcs) {
                        quantityFieldCtrl.values.amcs = [];
                      }
                      // снять выделение всем маркам
                      _.forEach(codes, function(mark){
                        mark.$$selected = undefined;
                        quantityFieldCtrl.values.amcs.push({
                          amc: mark.amc,
                          amc_name: mark.amc_name
                        });
                      });
                    } else {
                      quantityFieldCtrl.values.amcs = _.reject(quantityFieldCtrl.values.amcs, function(amc){
                        return _.find(codes, function(mark){
                          mark.$$selected = undefined;
                          return mark.amc == amc.amc;
                        });
                      });
                    }
                    return getData();
                  }
                },
                removeMark: function () {
                  // удаление марки старого образца, которой нет на балансе
                  return function (mark) {
                    quantityFieldCtrl.values.amcs = _.reject(quantityFieldCtrl.values.amcs, function(amc){
                      return mark.amc == amc.amc;
                    });
                    return getData();
                  }
                }
              }
            });
            modal.result.then(function(data){
              quantityFieldCtrl.universalSetterGetter((data.accepted_amcs && data.accepted_amcs.length) || 0);
              quantityFieldCtrl.values.amcs = _.map(data.accepted_amcs, function(mark){
                return {
                  amc: mark.amc,
                  amc_name: mark.amc_name
                };
              });
              quantityFieldCtrl.getMarksTooltip();
              // для установки dirty форме, когда изменили кол-во
              $scope.$parent.$parent.$parent.documentAttributeCtrl.documentCtrl.formCtrl.$setDirty();
            });
          }
        }

        quantityFieldCtrl.showMarksWithoutSourse = function () {
          var modal = $uibModal.open({
            size: 'small-width',
            component: 'marksWithoutSourse',
            controllerAs: 'marksWithoutSourse',
            backdrop: 'static',
            keyboard: false,
            resolve: {
              item: quantityFieldCtrl.item,
              values: quantityFieldCtrl.values,
              externalData: quantityFieldCtrl.externalData,
              data: function(){
                return quantityFieldCtrl.values.amcs || [];
              }
            }
          });
          modal.result.then(function(data){
            quantityFieldCtrl.universalSetterGetter(data.length);
            quantityFieldCtrl.values.amcs = data;
            quantityFieldCtrl.getMarksTooltip("Выбранные марки: ");
            // для установки dirty форме, когда изменили кол-во
            $scope.$parent.$parent.$parent.documentAttributeCtrl.documentCtrl.formCtrl.$setDirty();
          });
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('quantityField', {
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        externalData: '=',
        needMarks: '<?' // признак того что количество выставляется с помошью попапа марок
      },
      templateUrl: 'app/documents/components/attribute/fields/quantity/quantity-field.html',
      controllerAs: 'quantityFieldCtrl',
      controller: function ($scope, $filter,
                            $uibModal,
                            egaiszService,
                            attributeUtilService) {
        var quantityFieldCtrl = this;
        quantityFieldCtrl.item.max_after_comma = (_.isUndefined(quantityFieldCtrl.item.max_after_comma) || quantityFieldCtrl.item.max_after_comma === null)? 3 : quantityFieldCtrl.item.max_after_comma;
        quantityFieldCtrl.universalSetterGetter = function (value) {
          if (angular.isDefined(value) || arguments.length > 0) {
            return attributeUtilService._setValueDeep(
              quantityFieldCtrl.values,
              quantityFieldCtrl.item.code.split('.'),
              value);
          } else {
            if (quantityFieldCtrl.item.code) {
              var res = attributeUtilService._getValueDeep(
                          quantityFieldCtrl.values,
                          quantityFieldCtrl.item.code.split('.'));
              if (!quantityFieldCtrl.redact && !isNaN(parseFloat(res))) {
                res = parseFloat(res).toFixed(_.isUndefined(quantityFieldCtrl.item.max_after_comma) ? 3 : quantityFieldCtrl.item.max_after_comma);
              }
            }
            return res;
          }
        };

        quantityFieldCtrl.onblur = function () {
          if (parseFloat(quantityFieldCtrl.values[quantityFieldCtrl.item.code]) || quantityFieldCtrl.values[quantityFieldCtrl.item.code] === 0) {
            quantityFieldCtrl.values[quantityFieldCtrl.item.code] = parseFloat(quantityFieldCtrl.values[quantityFieldCtrl.item.code]).toFixed(quantityFieldCtrl.item.max_after_comma);
          }
        }

        // вывод в подсказку марок, если они есть
        quantityFieldCtrl.getMarksTooltip = function () {
          quantityFieldCtrl.amcsList = 'Марки для списания: ';
          if (quantityFieldCtrl.values && quantityFieldCtrl.values.amc_list && quantityFieldCtrl.values.amc_list.length) {
            _.forEach(quantityFieldCtrl.values.amc_list, function (acm) {
              if (quantityFieldCtrl.amcsList !== 'Марки для списания: ') {
                quantityFieldCtrl.amcsList += ', ';
              }
              quantityFieldCtrl.amcsList += $filter('egaisBarcode')(acm.amc);
            });
          }
        }
        quantityFieldCtrl.getMarksTooltip();

        // количество undefined устанавливается равной 0 по бизнес-логике
        quantityFieldCtrl.universalSetterGetter(quantityFieldCtrl.universalSetterGetter() || (quantityFieldCtrl.item.noZeroes? undefined : 0));
        // хук на изменение выбранного товара
        $scope.$watch('quantityFieldCtrl.values[quantityFieldCtrl.item.ref[0]]', function (newValue, oldValue) {
          if (quantityFieldCtrl.externalData.values.isImported) 
            return;
          // при заполнении складской позиции количество всегда выставляется как 1
          if (newValue) {
            quantityFieldCtrl.stockAccountingType = newValue.stock_accounting_type;
            if (!oldValue || newValue.id !== oldValue.id) {
              quantityFieldCtrl.universalSetterGetter(1);
              quantityFieldCtrl.amcsList = '';
            }
          } else {
            quantityFieldCtrl.stockAccountingType = undefined;
          }
        });

        // проверка максимума и его установка в поле, если его значение превышает
        quantityFieldCtrl.checkError = function () {
          var maxVal = 0;
          quantityFieldCtrl.hint = undefined;
          if (quantityFieldCtrl.item.ref[3] && quantityFieldCtrl.transferDirection) {
            maxVal = (quantityFieldCtrl.transferDirection == "REGISTER2") ? quantityFieldCtrl.values[quantityFieldCtrl.item.ref[1]] : quantityFieldCtrl.values[quantityFieldCtrl.item.ref[2]]
            // TODO RECS-12587
            if (quantityFieldCtrl.transferDirection == "REGISTER1" && quantityFieldCtrl.values[quantityFieldCtrl.item.ref[4]]) {
              // значение должно быть меньше или равно shopTransferQuantity
              // (значение выводим в ховере в формате: "Доступно к переводу: ..."
              maxVal = quantityFieldCtrl.values[quantityFieldCtrl.item.ref[4]][quantityFieldCtrl.item.ref[5]];
              if (_.isDefined(maxVal)) {
                quantityFieldCtrl.hint = "Доступно к переводу: " + maxVal;
              }
            }
          }
          if (!quantityFieldCtrl.item.ref[3]) {
            maxVal = quantityFieldCtrl.values[quantityFieldCtrl.item.ref[1]];
          }
          if (quantityFieldCtrl.item.ref.length > 1) {
            if (maxVal < quantityFieldCtrl.universalSetterGetter()) {
              quantityFieldCtrl.universalSetterGetter(maxVal);
            }
          }
        };

        if (quantityFieldCtrl.item.ref && !quantityFieldCtrl.item.ref[3]) {
          // вотчер за значением максимума
          $scope.$watch('quantityFieldCtrl.values[quantityFieldCtrl.item.ref[1]]', function (newValue, oldValue) {
            if (newValue && (!oldValue || newValue.id !== oldValue.id)) {
              quantityFieldCtrl.checkError();
            }
          });
        } else {
          // вотчер за значением самого поля
          $scope.$watch('quantityFieldCtrl.universalSetterGetter()', function (newValue, oldValue) {
            if (newValue && (!oldValue || newValue.id !== oldValue.id)) {
              quantityFieldCtrl.checkError();
            }
          });
        }


        quantityFieldCtrl.showMarkViewModal = function () {
          if (quantityFieldCtrl.needMarks) {
            var modal = $uibModal.open({
              size: 'large-width',
              component: 'markViewModal',
              controllerAs: 'markViewModal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                item: quantityFieldCtrl.item,
                values: quantityFieldCtrl.values,
                externalData: quantityFieldCtrl.externalData,
                multiSelect: true,
                data: function () {
                  return egaiszService.getMarkInfoByCatalogItem(
                    quantityFieldCtrl.externalData.id,
                    quantityFieldCtrl.values.id
                  ).then(function (data) {
                    return data;
                  });
                },
                moveMarks: function () {
                  return function (codes, type) {
                    var marks = [];
                    _.forEach(codes, function(mark){
                      marks.push(mark.amc);
                    })
                    return egaiszService.scanMark(quantityFieldCtrl.externalData.id, marks, type).then(function () {
                      // обновление списка марок
                      return egaiszService.getMarkInfoByCatalogItem(
                        quantityFieldCtrl.externalData.id,
                        quantityFieldCtrl.values.id
                      ).then(function (data) {
                        return data;
                      }, function (error) {
                        return error;
                      });
                    }, function (error) {
                      return error;
                    });
                  }
                }
              }
            });
            modal.result.then(function (res) {
              quantityFieldCtrl.universalSetterGetter(res.accepted_amcs ? res.accepted_amcs.length : 0);
            });
          }
        }

        // частный случай для переводов между регистрами
        // несколько максимумов, в зависимости от четвертого параметра
        if (quantityFieldCtrl.item.ref && quantityFieldCtrl.item.ref[3]) {
          // вотчер за значением направления перевода
          $scope.$watch(function () {
            return quantityFieldCtrl.externalData[quantityFieldCtrl.item.ref[3]];
          }, function (newValue) {
            if (newValue) {
              quantityFieldCtrl.transferDirection = newValue;
              quantityFieldCtrl.checkError();
            }
          });
        }


        // пивная декларация, врядли это еще в каком-то документе понадобится
        if (quantityFieldCtrl.item.code == 'number_corrective') {
          var isEdit = quantityFieldCtrl.item.editable;
          // пивная декларация, отслеживание Тип декларации для возможности редактирования Номера корректировки
          $scope.$watch('quantityFieldCtrl.values[quantityFieldCtrl.item.ref[5]]', function (newValue) {
            if (isEdit) {
              quantityFieldCtrl.item.editable = newValue == "CORRECTIVE";
              quantityFieldCtrl.item.required = newValue == "CORRECTIVE";
              quantityFieldCtrl.values[quantityFieldCtrl.item.code] = undefined;
            }
          });
        }

        // частный случай для переводов между регистрами ЕГАИС
        // количество зависит от alcohol_shop_transfer_quantity, который находится в поле справки 2 (alcohol_stock_item)
        if (quantityFieldCtrl.item.ref && quantityFieldCtrl.item.ref[4]) {
          $scope.$watch(function () {
            return quantityFieldCtrl.values[quantityFieldCtrl.item.ref[4]];
          }, function () {
            quantityFieldCtrl.checkError();
          });
        }

      }
    });
})();

(function () {
  'use strict';

  angular
  .module('frontend')
  .component('priceField', {
    transclude: true,
    bindings: {
      values: '=', // единая для документа карта значений
      item: '=', // атрибуты изменяют данные
      hideLabel: '<',
      index: '<',
      redact: '<',
      defaultCurrency: '<',
      externalData: "<"
      // redact: '<?', // режим редактирования
      // purpose: '<', // назначение документа
      // onCurrencyChange: '=?' // события на изменение валюты
    },
    templateUrl: 'app/documents/components/attribute/fields/price/field-price.html',
    controller: function ($scope, documentService) {
      var vm = this;
      var firstData = (vm.item.ref && vm.item.ref[4])? vm.externalData[vm.item.ref[4]] : undefined;
      var documentCtrl = $scope.$parent.$parent.$parent.documentAttributeCtrl.documentCtrl;
      vm.values[vm.item.code] = vm.values[vm.item.code] || 0; // цена undefined устанавливается равной 0 по бизнес-логике
      vm.simpleField = vm.item.simpleField || !vm.item.ref || vm.item.ref.length < 10;

      /*
        реф с индексом 0 - валюта
        реф с индексом 1 - связь с полем с типом BOOLEAN
        реф с индексом 2 - cвязь с полем при изменении которого его значение подставляется в текущий инпут
      */
      if (vm.item.ref && vm.item.ref[0]) {
        $scope.$watch(function() { return vm.values[vm.item.ref[0]] }, function(val) {
          vm.currencyIcon = val && val.symbol;
        })
      }

      if (vm.item.ref && vm.item.ref[1] && vm.item.ref[2]) {
        $scope.$watch(function() { return vm.values[vm.item.ref[1]] }, function(val) {
          if(val && !vm.values[vm.item.code]){
            vm.values[vm.item.code] = vm.values[vm.item.ref[2]];
          }
        })
      }

      if (vm.item.ref && vm.item.ref[2]) {
        $scope.$watch(function() { return vm.values[vm.item.ref[2]] }, function(val) {
          if(!vm.values[vm.item.code]){
            vm.values[vm.item.code] = val;
          }
        })
      }

      if (vm.item.ref && vm.item.ref[3]) {
        $scope.$watch(function() { return vm.values[vm.item.ref[3]] }, function(val) {
            vm.item.required = (val == 'SELLING');
        })
      }

      // проверка максимума, vm.item.ref[4] - это максимум
      if (vm.item.ref && vm.item.ref[4] && !vm.externalData.values.isImported) {
        $scope.$watchGroup([
          function() { return vm.values[vm.item.ref[4]] },
          function() { return vm.values[vm.item.code] }
          ], function(val) {
            // для установки dirty форме, когда изменили кол-во
            documentCtrl.formCtrl.$setDirty();
            if (val[0] && val[0] < val[1]) {
              documentCtrl.formCtrl[documentCtrl.formName][vm.item.code].$setValidity('error-max', false);
            } else {
              documentCtrl.formCtrl[documentCtrl.formName][vm.item.code].$setValidity('error-max', true);
            }
        })
      }

      // вотчер для контракта, идет вычисление вознаграждения по формуле
      // "Сумма в валюте документа" * Contract.commission / (100 - Contract.commission)
      if (vm.item.ref && vm.item.ref[4] && vm.item.ref[5]) {
        $scope.$watchGroup([
          function() { return vm.values[vm.item.ref[4]] },
          function() { return vm.values[vm.item.ref[5]] }
        ],
        function(newData) {
          if (newData[0] == firstData) return;
          // идет вычисление вознаграждения по формуле
          // "Сумма в валюте документа" * Contract.commission / (100 - Contract.commission)
          var contract = vm.values[vm.item.ref[5]];
          if (vm.values[vm.item.ref[4]] && contract && contract.commission) {
            vm.values[vm.item.code] = Math.round((vm.values[vm.item.ref[4]]) * contract.commission / (100 - contract.commission));
          }
          if (!vm.values[vm.item.ref[4]]) {
            vm.values[vm.item.code] = 0;
          }
        });
      }

      // выбор цены
      vm.choosePrice = function (priceObj) {
        vm.edited = false;
        vm.values[vm.item.code] = priceObj.price;
      };

      // устанока курсива или закрытие списка, в зависимости от того есть такое значение  ценах или нет
      vm.closeDropDown = function () {
        var match = false;
        vm.edited = vm.close = false;
        if (vm.pricesData) {
          _.forEach(vm.pricesData.lines[0].prices, function (priceObj) {
            if (vm.values[vm.item.code] == priceObj.price) {
              match = true;
            }
          });
          if (!match && vm.values[vm.item.code]) {
            vm.edited = vm.close = true;
            vm.editetHelper = true; // необходим для установки и сброса курсива у кастомной цены
          }
        }
      };

      $scope.$watch(function() { return vm.values[vm.item.code] }, function() {
        if (!vm.editetHelper){// необходим для установки и сброса курсива у кастомной цены
          vm.edited = false;
        } else {
          vm.editetHelper = false;
        }
      });

      var sourseData = {
        "RETAIL": {
          "short": "РОЗН. ",
          "full": "Розничный прайс-лист"
        },
        "WHOLESALE": {
          "short": "ОПТ. ",
          "full": "Оптовый прайс-лист"
        },
        "PURCHASE": {
          "short": "ЗАКУП. ",
          "full": "Закупочный прайс-лист"
        },
        "CONSIGNMENT_NOTE": {
          "full": "Последняя приемка"
        },
        "STOCK_ITEM_COST": {
          "full": "Себестоимость"
        }
      };

      vm.getAllPrices = function () {
        vm.close = false;
        // если нет товарной позиции, то выход
        if (!vm.item.ref[8] || !vm.values[vm.item.ref[8]]) return;
        var params = {
          document_purpose: documentCtrl.purpose,
          document_date: vm.externalData.date.valueOf(),
          division: vm.externalData.values[vm.item.ref[6]],
          counterparty: vm.externalData.values[vm.item.ref[7]],
          document_currency: (vm.externalData[vm.item.ref[0]])? {
            id: vm.externalData[vm.item.ref[0]].id,
            name: vm.externalData[vm.item.ref[0]].name
          } : undefined,
          lines: [{
            domain_catalog_item: vm.values[vm.item.ref[8]] ? {
              id: vm.values[vm.item.ref[8]].id,
              name: vm.values[vm.item.ref[8]].name
            } : undefined,
            tax_group: {
              // приоритет у собственного налога
              id: (vm.values[vm.item.ref[8]].tax_group || vm.values[vm.item.ref[8]].committent_tax_group).id,
              name: (vm.values[vm.item.ref[8]].tax_group || vm.values[vm.item.ref[8]].committent_tax_group).name
            },
            quantity: vm.values[vm.item.ref[9]],
            uom: vm.values[vm.item.ref[10]]
          }]
        };
        if (vm.item.ref[8] == "derivative" && vm.values[vm.item.ref[8]].derivative) {
          params.lines[0].derivative = vm.values[vm.item.ref[8]].derivative;
        }
        vm.getPrices(params);
      };

      vm.getPrices = function(params, setPrice){
        documentService.documentsPrices(params).then(function (res) {
          vm.pricesData = res.data;
          var prices = res.data.lines[0].prices;
          _.forEach(prices, function (priceObj, key) {
            priceObj.name = '';
            if ((prices[key + 1] && prices[key + 1].document_price_source == priceObj.document_price_source) ||
                (prices[key - 1] && prices[key - 1].document_price_source == priceObj.document_price_source)) {
              priceObj.name = sourseData[priceObj.document_price_source].short + priceObj.column_name;
            } else {
              priceObj.name = sourseData[priceObj.document_price_source].full;
            }
            if (priceObj.effective_order_sum) {
              priceObj.name += " (сумма от " + priceObj.effective_order_sum + vm.externalData[vm.item.ref[0]].symbol + ")";
            }
          });

          if (!vm.edited && setPrice && vm.pricesData.lines[0] && vm.pricesData.lines[0].prices[0]
            && vm.values[vm.item.code] == 0) { // установка только в том cлучае, если нет назначенной цены
            vm.values[vm.item.code] = vm.pricesData.lines[0].prices[0].price;
          }
        });
      };

      // вотчер за зависимыми полями для автоподстановки цен
      if (!vm.simpleField) {
        $scope.$watchGroup([
          function() { return vm.externalData[vm.item.ref[0]] }, // валюта
          function() { return vm.externalData.values[vm.item.ref[6]] }, // подразделение
          function() { return vm.externalData.values[vm.item.ref[7]] }, // контрагент
          function() { return vm.values[vm.item.ref[8]] }, // складская позиция
          function() { return vm.values[vm.item.ref[9]] }, // количество
          function() { return vm.values[vm.item.ref[10]] }, // единицы измерения
          function() { return vm.values[vm.item.ref[11]] } // налог
        ],
        function(newData, oldData) {
          // если нет товарной позиции, то выход
          if (!newData[3]) return;

          if ((!oldData[3] || newData[3].id !== oldData[3].id) && !vm.externalData.values.isImported) {
            vm.values[vm.item.code] = 0;
            vm.edited = false;
          }

          var params = {
            document_purpose: documentCtrl.purpose,
            document_date: vm.externalData.date.valueOf(),
            division: newData[1],
            counterparty: newData[2],
            document_currency: (newData[0])? {
              id: newData[0].id,
              name: newData[0].name
            } : undefined,
            lines: [{
              domain_catalog_item: {
                id: newData[3].id,
                name: newData[3].name
              },
              quantity: newData[4],
              uom: newData[5]
            }]
          }

          if (vm.item.ref[8] == "derivative" && newData[3].derivative) {
            params.lines[0].derivative = newData[3].derivative;
          }
          if (newData[6]) {
            params.lines[0].tax_group = newData[6];
          } else {
            params.lines[0].tax_group = newData[3][vm.item.ref[11]];
          }
          if (!params.lines[0].tax_group) {
            return;
          }

          if (documentCtrl.priceSource) {
            params.document_price_source = documentCtrl.priceSource.pricing_type;
          }
          vm.getPrices(params, !!params.document_price_source);
        });
      }


    }
  });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('numberField', {
      require: {
        // TODO: в целом мелкие бинжинги можно не биндить каждый раз, а тянуть родительский контроллер
        attributeCtrl: '^^documentAttribute',
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=' // атрибуты изменяют данные
      },
      templateUrl: 'app/documents/components/attribute/fields/number/number-field.html',
      controllerAs: 'numberFieldCtrl',
      controller: function ($scope, documentService, $uibModal) {
        var numberFieldCtrl = this;
        // кеш значений номеров документов (для предотвращения инкрементирования счетчика)
        numberFieldCtrl.cacheNumbers = {};

        // хук на изменение выбранной компании
        $scope.$watch('numberFieldCtrl.values[numberFieldCtrl.item.ref[0]]', function (newValue, oldValue) {
          // поиск значения только в случае отсутствия номера или сменыы компании (из undefined не отлавливается при наличии номера)
          if (newValue && newValue.id && (!oldValue || newValue.id !== oldValue.id)) {
            if (!numberFieldCtrl.values[numberFieldCtrl.item.code] ||
              (oldValue && oldValue.id && oldValue.id != newValue.id)) {
              if (numberFieldCtrl.cacheNumbers[newValue.id]) {
                // возврат из кеша
                numberFieldCtrl.values[numberFieldCtrl.item.code] = numberFieldCtrl.cacheNumbers[newValue.id];
              } else {
                documentService.getNextDocumentNumber(
                  numberFieldCtrl.documentCtrl.documentMeta.document_type.code,
                  newValue.id)
                  .then(function (data) {
                    // сохраение в кеше
                    numberFieldCtrl.cacheNumbers[newValue.id] = data.data;
                    numberFieldCtrl.values[numberFieldCtrl.item.code] = numberFieldCtrl.cacheNumbers[newValue.id];
                  });
              }
            } else if (numberFieldCtrl.values[numberFieldCtrl.item.code]) {
              // Если мы в этом блоке, то номер проставлен и есть выбранная организация, его нужно сохранить в кеш
              numberFieldCtrl.cacheNumbers[newValue.id] = numberFieldCtrl.values[numberFieldCtrl.item.code];
            }
          }
        });

        if (numberFieldCtrl.item.code == 'year_reporting' && !numberFieldCtrl.values[numberFieldCtrl.item.code]) {
          if (moment().utc().quarter() == 1) {
            numberFieldCtrl.values[numberFieldCtrl.item.code] = new Date().getFullYear() - 1;
          } else {
            numberFieldCtrl.values[numberFieldCtrl.item.code] = new Date().getFullYear();
          }
        }


      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('lotSn', {
      transclude: true,
      require: {
        documentCtrl: '^^document'
      },
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        allowAdd: '<', // флаг разрешения добавления
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<', // метод получения списка
        saveItem: '<?', // метод сохранения серийного номера или партии
        redact: '<?', // режим редактирования
        externalData: '<?', // потребовался дополнительный дата-сет для связанных компонент с внешними
      },
      templateUrl: 'app/documents/components/attribute/fields/lot-sn/lot-sn.html',
      controllerAs: 'lotSnCtrl',
      controller: function ($scope, $uibModal, modalMessageSrv) {
        var lotSnCtrl = this;
        var derevetiveCode = lotSnCtrl.item.ref[0],
          divisionCode = lotSnCtrl.item.ref[1];


        // вотчер на зависимое поле
        $scope.$watch('lotSnCtrl.values[lotSnCtrl.item.ref[0]]', function (newVal, oldVal) {
          if (oldVal && oldVal != newVal) {
            // сброс тольок в том случае, когда меняется значение в зависимом поле (если старого значения нет - случай инициализации)
            lotSnCtrl.values[lotSnCtrl.item.code] = undefined;
          }
          lotSnCtrl.stockAccountingType = undefined;
          if (newVal) {
            lotSnCtrl.stockAccountingType = newVal.stock_accounting_type; // в зависимости от типа складского учета, подгружать либо серии либо партии, название переменной скорее всего не совпадет
            // сброс значения серийного номера/партии при выборе простого дериватива
            if (lotSnCtrl.stockAccountingType == 'SIMPLE') {
              lotSnCtrl.values[lotSnCtrl.item.code] = undefined;
            }

            lotSnCtrl.refresh();
          }
        });

        lotSnCtrl.getStr = function (obj) {
          if (!obj) return "";
          if (lotSnCtrl.stockAccountingType === "BY_SERIAL_NUMBERS") {
            return obj.serial_number;
          } else if (lotSnCtrl.stockAccountingType === "BY_LOTS_LIFO"
            || lotSnCtrl.stockAccountingType === "BY_LOTS_FIFO"
            || lotSnCtrl.stockAccountingType === 'BY_LOTS_FEFO') {
            var str = obj.lot_number;
            if (obj.manufacture_date || obj.expiration_date) {
              str += " (";
              if (obj.manufacture_date) {
                str += moment(obj.manufacture_date).format('DD.MM.YYYY');
              }
              if (obj.manufacture_date && obj.expiration_date) {
                str += " - ";
              }
              if (obj.expiration_date) {
                str += moment(obj.expiration_date).format('DD.MM.YYYY');
              }
              str += ")";
            }
            return str;
          }
          return "";
        }

        lotSnCtrl.refresh = function (search, offset) {
          if (!lotSnCtrl.refreshParams) {
            lotSnCtrl.refreshParams = {
              limit: 5,
              offset: 0
            };
          }
          lotSnCtrl.refreshParams.search = search;
          lotSnCtrl.refreshParams.offset = offset;

          if (!lotSnCtrl.allowAdd && !search && lotSnCtrl.externalData.values && lotSnCtrl.externalData.values[divisionCode] && lotSnCtrl.externalData.values[divisionCode].id) {
            lotSnCtrl.refreshParams.division_id = lotSnCtrl.externalData.values[divisionCode].id;
          } else {
            lotSnCtrl.refreshParams.division_id = undefined;
          }

          // тут нужно будет подгружать либо серии либо партии
          if (lotSnCtrl.values[derevetiveCode] && // наличие дериватива или товара в ссылке
            lotSnCtrl.values[derevetiveCode] &&
            lotSnCtrl.stockAccountingType && // наличие заполненного типа
            lotSnCtrl.stockAccountingType != 'SIMPLE' &&
            lotSnCtrl.values[derevetiveCode].derivative) {
            lotSnCtrl.getData(lotSnCtrl.values[derevetiveCode].id, lotSnCtrl.values[derevetiveCode].derivative.id, lotSnCtrl.stockAccountingType, lotSnCtrl.refreshParams).then(function (res) {
              lotSnCtrl.items = res.data.items;
              lotSnCtrl.helpTotal = res.data.total;
              if (!lotSnCtrl.total) {
                lotSnCtrl.total = res.data.total;
                lotSnCtrl.searchEnabled = (lotSnCtrl.amount == 100) ? lotSnCtrl.total > lotSnCtrl.amount && lotSnCtrl.total <= lotSnCtrl.amount : lotSnCtrl.total > lotSnCtrl.amount;
              }
              // если одно значение, автоматически заполняем (если нет выбранного)
              if (res.data.items && res.data.items.length == 1 && !lotSnCtrl.values[lotSnCtrl.item.code] && lotSnCtrl.item.required) {
                lotSnCtrl.values[lotSnCtrl.item.code] = res.data.items[0];
              }
            }, function (error) {
              if (error.status !== 500) {
                modalMessageSrv.showModal({ message: 'При запросе данных произошла ошибка', submessage: error });
              }
            });
          }
        };

        lotSnCtrl.addLotSn = function () {
          var modalPromise = $uibModal.open({
            templateUrl: 'app/documents/components/attribute/fields/lot-sn/popup/add-lot-sn.html',
            resolve: {
              stockItem: function () {
                return lotSnCtrl.values[derevetiveCode];
              },
              stockId: function () {
                return lotSnCtrl.values[derevetiveCode] && lotSnCtrl.values[derevetiveCode].id;
              },
              derivativeId: function () {
                return lotSnCtrl.values[derevetiveCode] && lotSnCtrl.values[derevetiveCode].derivative && lotSnCtrl.values[derevetiveCode].derivative.id;
              },
              type: function () {
                return lotSnCtrl.stockAccountingType;
              },
              saveItemCallback: function () {
                return lotSnCtrl.saveItem;
              }
            },
            size: 'small-width',
            controller: function ($scope, $uibModalInstance, modalMessageSrv, type, saveItemCallback, stockItem, stockId, derivativeId) {
              $scope.type = type;
              // заголовок
              $scope.typeStr = type == 'BY_SERIAL_NUMBERS' ? 'серийного номера' : 'партии';

              // создаваемый объект
              $scope.createdValue = {};

              angular.element("[name=" + lotSnCtrl.item.code + "]").removeClass("open"); // закрыть все открытые выпадалки

              $scope.save = function () {
                if (saveItemCallback) {
                  if ($scope.type !== 'BY_SERIAL_NUMBERS') {
                    if (!$scope.createdValue.$$manufacture_date.isEmpty) {
                      $scope.createdValue.manufacture_date = moment.utc($scope.createdValue.$$manufacture_date).valueOf();
                    }
                    if (!$scope.createdValue.$$expiration_date.isEmpty) {
                      $scope.createdValue.expiration_date = moment.utc($scope.createdValue.$$expiration_date).valueOf();
                    }
                  }
                  saveItemCallback(stockItem, type, $scope.createdValue).then(function (success) {
                    // успех
                    $uibModalInstance.close(success);
                  }, function (error) {
                    if (error.status !== 500) {
                      modalMessageSrv.showModal({ message: 'При сохранении произошла ошибка', submessage: error });
                    }
                  });
                }
              };

              $scope.close = function () {
                $uibModalInstance.dismiss();
              };
            }
          });

          // обработка результата вызова модального окна
          modalPromise.result.then(function (res) {
            lotSnCtrl.values[lotSnCtrl.item.code] = res.data;
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('htmlField', function ($compile) {
      return {
        scope: {
          redact: '<', // флаг редактирования
          values: '=', // единая для документа карта значений
          item: '=' // атрибуты изменяют данные
        },
        templateUrl: 'app/documents/components/attribute/fields/html-field/html-field.html',
        controllerAs: 'htmlFieldCtrl',
        link: function ($scope, element, attr) {
          $scope.$watch(function () {
            return $scope.item.html;
          }, function (value) {
            element.html(value);
            $compile(element.contents())($scope);
          });
        },
        controller: function ($scope, $filter) {
          var htmlFieldCtrl = this;


        }
      }
    });
})();

(function () {
  'use strict';

  angular
  .module('frontend')
  .component('getSum', {
    transclude: true,
    bindings: {
      values: '=', // единая для документа карта значений
      item: '=', // атрибуты изменяют данные
      externalData: '='
    },
    templateUrl: 'app/documents/components/attribute/fields/getSum/get-sum.html',
    controller: function ($scope) {
      var getSumCtrl = this;
      getSumCtrl.values[getSumCtrl.item.code] = getSumCtrl.values[getSumCtrl.item.code] || 0; // цена undefined устанавливается равной 0 по бизнес-логике
      $scope.$watchGroup([
        function() {
          return getSumCtrl.values[getSumCtrl.item.ref[0]]
        },
        function() {
          return getSumCtrl.values[getSumCtrl.item.ref[1]]
        }    
      ], function(newVal) {
        if (getSumCtrl.externalData.values.isImported) 
            return;

        if(newVal[0] && newVal[1]){
          getSumCtrl.values[getSumCtrl.item.code] = parseFloat((newVal[0] * newVal[1]).toFixed(2));
        }
      });

    }
  });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('fnRegField', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        getData: '<', // метод получения списка
        redact: '<?', // режим редактирования
        externalData: '<?' // все данные документа
      },
      templateUrl: 'app/documents/components/attribute/fields/fn-reg-field/fn-reg-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $state, $rootScope, searchAlcoItemSrv, $timeout) {
        var vm = this;
        var ref_fsrar = vm.item.ref[2];
        var ref_stock_quantity = vm.item.ref[3];
        var ref_shop_quantity = vm.item.ref[4];
        var ref_quantity = vm.item.ref[5];
        var ref_register = vm.item.ref[6];
        var transfer_direction = vm.item.ref[7];

        vm.showField = vm.values[vm.item.ref[0]] && (!transfer_direction || vm.externalData[transfer_direction]);
        vm.amount = vm.amount || 5;
        vm.selectCode = (vm.item.code == "f1_reg_id")? "f1reg_id" : "f2reg_id";
        vm.params = {};

        vm.setData = function (res) {
          vm.selectObj && vm.selectObj.ngModel.$setValidity('accountingType', true);
          if (res) {
            if (vm.item.ref[1]) {
              vm.values[vm.item.ref[1]] = (res.f1reg_id)? res.f1reg_id : ((res.form_2)? res.form_2.f1reg_id : undefined);
            }
            if (ref_stock_quantity) {
              vm.values[ref_stock_quantity] = res.alcohol_stock_quantity || 0;
            }
            if (ref_shop_quantity) {
              vm.values[ref_shop_quantity] = res.alcohol_shop_quantity || 0;
            }
            if (ref_quantity) {
              vm.values[ref_quantity] = (res.item)? res.item.quantity : undefined;
            }
            // если нужно учитывать accounting_type при выборе справки 2
            if (vm.item.successAccountingTypes && vm.item.successAccountingTypes.length && 
                vm.selectObj && res.accounting_type) {
              vm.selectObj.ngModel.$setValidity('accountingType', !!(vm.item.successAccountingTypes.indexOf(res.accounting_type) + 1));
            }
          }
        }

        vm.refresh = function(select){
          if (!vm.redact) return; 
          $timeout(function(){
            if(select) vm.selectObj = select; // вытаскиваем объект выпадалки для установки ей ошибок валидации
          }, 0);

          vm.params.limit = vm.amount;
          vm.params.filter_fsrar_id = (vm.externalData[ref_fsrar])? vm.externalData[ref_fsrar].id : undefined;
          vm.params.search_string = (select && select.search)? select.search : undefined;
          vm.params.filter_derivative_id = (vm.values[vm.item.ref[0]])? ((vm.values[vm.item.ref[0]].derivative)? vm.values[vm.item.ref[0]].derivative.id : vm.values[vm.item.ref[0]].id) : undefined;
          
          if (vm.externalData.division && vm.externalData.division.id) {
            vm.params.filter_division_id = vm.externalData.division.id;
          }

          if (vm.externalData[transfer_direction] == "REGISTER1") {
            vm.params.filter_balance = false;
          } else if (vm.externalData[transfer_direction] == "REGISTER2") {
            vm.params.filter_balance = true;
          }

          vm.getData(vm.params).then(function(res){
            vm.items = res.data.items;
            vm.total = res.data.total;
            // выбор значения по-умолчанию
            if(vm.item.required && vm.total == 1 && vm.item.editable && vm.items.length && (!vm.values[vm.item.code] || vm.values[vm.item.code].id !== vm.items[0].id)) {
              vm.values[vm.item.code] = vm.items[0];
              vm.setData(vm.items[0]);
            }
          });
        };

        vm.totalStr = function(){
          if(vm.total > vm.amount){
            return "Показано " + vm.amount + " из " + vm.total;
          }
          return '';
        };

        $scope.$watch(function(){
          return vm.values[vm.item.ref[0]];
        }, function (newVal, oldVal) {
          if (newVal && (!oldVal || newVal.id !== oldVal.id)) {
            vm.showField = newVal && (!transfer_direction || vm.externalData[transfer_direction]);
            vm.values[vm.item.code] = undefined;
            vm.refresh(vm.selectObj);
            vm.setData({});
          }
        });

        if(vm.item.code !== 'f1_reg_id') {
          $scope.$watch(function(){
            return vm.values[vm.item.code];
          }, function (newVal) {
            if (!newVal) {
              vm.values[vm.item.ref[1]] = undefined;
            } else {
              $timeout(function(){
                // если нужно учитывать accounting_type при выборе справки 2
                if (vm.item.successAccountingTypes && vm.item.successAccountingTypes.length && 
                    vm.selectObj && newVal.accounting_type) {
                  vm.selectObj.ngModel.$setValidity('accountingType', !!(vm.item.successAccountingTypes.indexOf(newVal.accounting_type) + 1));
                }
              }, 0);
            }
          });
        }

        // Если дериватив и направление перевода не выбраны, то автокомплит с поиском не отображается - в ячейке пусто
        if(transfer_direction) {
          $scope.$watch(function(){
            return vm.externalData[transfer_direction];
          }, function (newVal, oldVal) {
            if (newVal && newVal !== oldVal) {
              vm.showField = vm.values[vm.item.ref[0]];
              vm.items = [];
              vm.values[vm.item.code] = undefined;
              vm.showField = vm.values[vm.item.ref[0]] && vm.externalData[transfer_direction];
              // TODO RECS-12587
              vm.params.accounting_type = ["PARTY_ACCOUNTING", "BEER_ACCOUNTING"];
            } else {
              vm.params.accounting_type = null;
            }
          });
        }

        vm.showSearchCatalogItemPopup = function(){
          vm.promice = searchAlcoItemSrv.showModal(vm.externalData[vm.item.ref[2]], 
                                                   vm.values[vm.item.ref[0]], 
                                                   vm.item.isDerivative, 
                                                   false, 
                                                   false, 
                                                   vm.externalData.division && vm.externalData.division.id,
                                                   vm.externalData.transfer_direction);
          vm.promice.result.then(function(res) {
            if(res){
              vm.values[vm.item.code] = res;
              vm.setData(res);
              vm.selectObj.ngModel.$setDirty();
            }
          })
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('f1RegField', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        getData: '<', // метод получения списка
        redact: '<?', // режим редактирования
        externalData: '<?' // все данные документа
      },
      templateUrl: 'app/documents/components/attribute/fields/fn-reg-field/f1-reg-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $uibModal, $filter) {
        var vm = this;
        var ref_sku = vm.item.ref[0];
        var ref_transfer = vm.item.ref[1];
        var formCtrl = $scope.$parent.$parent.$parent.documentAttributeCtrl.documentCtrl.formCtrl;

        function getViewValue () {
          if (vm.values[vm.item.code] && vm.values[vm.item.code].ttn_number && 
              vm.values[vm.item.code].ttn_date && 
              vm.values[vm.item.code].quantity && 
              vm.values[vm.item.code].bottling_date) {
            vm.viewValue = 'ТТН №' + vm.values[vm.item.code].ttn_number + ' от ' + moment(vm.values[vm.item.code].ttn_date).format('DD.MM.YYYY');
          } else {
            vm.viewValue = "";
          }
        }
        getViewValue();


        if (ref_transfer) {
          $scope.$watch(function(){
            return vm.externalData[ref_transfer];
          }, function(newVal, oldVal){
            vm.item.editable = newVal == "REGISTER1";
          });
        }
        
        vm.openF1Popup = function(){
          $uibModal.open({
            templateUrl: 'app/documents/components/attribute/fields/fn-reg-field/f1-popup.html',
            size: 'middle-width',
            controller: function ($scope, $uibModalInstance) {
              $scope.data = (!vm.values[vm.item.code])? {} : angular.copy(vm.values[vm.item.code]);
              $scope.isEdit = !!vm.values[vm.item.code];
              $scope.datePickerOpts = {singleDatePicker: true, correctTimeZone: false};
              $scope.close = function () {
                $uibModalInstance.dismiss();
              };

              $scope.create = function () {
                vm.values[vm.item.code] = $scope.data;
                getViewValue();
                formCtrl.$setDirty();
                $uibModalInstance.dismiss();
              };
            }
          });
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('documentCheckboxesList', {
      require: {
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        redact: '<?', // флаг возможности редактирования
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        externalData: '<', // дополнительный источник общих для докумнета данных
        referenceData: '<?' // эталонные данные документа, для вычисления данных с сервера
      },
      templateUrl: 'app/documents/components/attribute/fields/documentCheckboxesList/document-checkboxes-list.html',
      controllerAs: 'documentCheckboxesList',
      controller: function ($scope, $state, $uibModal, searchDocumentsSrv, $timeout) {
        var documentCheckboxesList = this;
        documentCheckboxesList.items = documentCheckboxesList.item.ref;
        documentCheckboxesList.canRedact = !documentCheckboxesList.item.disabled && (!documentCheckboxesList.externalData.id || documentCheckboxesList.externalData[documentCheckboxesList.items[0]]);

        function getState(){
          var disabled = true;
          _.forEach(documentCheckboxesList.checkboxList, function(item){
            if(!documentCheckboxesList.externalData[item.code]){
              disabled = false;
            }
          });
          return disabled;
        }

        $timeout(function(){
          documentCheckboxesList.properties = documentCheckboxesList.documentCtrl.document.layout.properties;
          documentCheckboxesList.checkboxList = documentCheckboxesList.properties[documentCheckboxesList.item.code];
          if ($state.current.name.endsWith('new') && !$state.params.source) {
            _.forEach(documentCheckboxesList.checkboxList, function(item){
              documentCheckboxesList.externalData[item.code] = item.default;
            });
          }else{
            documentCheckboxesList.item.editable = !getState();
          }
        },0);

        documentCheckboxesList.changeInfo = function(){
          var needPopup = true;
          if(documentCheckboxesList.externalData[documentCheckboxesList.item.ref[0]] != 'AUTO'){
            needPopup = getState();
          }
          if(needPopup){
            $uibModal.open({
              templateUrl: 'app/catalog/modals/info-popup.html',
              size: 'middle-width',
              controller: function ($scope, $uibModalInstance) {
                $scope.class = "info";
                $scope.title = "Предупреждение";
                $scope.descrTxt = documentCheckboxesList.properties[documentCheckboxesList.item.code + 'Message'];
                $scope.btnText = "Понятно";
                $scope.textFontSize = 16;
                $scope.close = function () {
                  if (documentCheckboxesList.externalData[documentCheckboxesList.item.ref[0]] != 'AUTO') {
                    documentCheckboxesList.item.editable = true;
                  }
                  $uibModalInstance.dismiss();
                };
              }
            });
          }else{
            documentCheckboxesList.item.editable = true;
          }
        };
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('divisionsField', {
      transclude: true,
      bindings: {
        redact: '<?', // режим редактирования
        values: '=', // единая для документа карта значений
        externalData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        item: '=', // атрибуты изменяют данные
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<' // метод получения списка
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $timeout) {
        var vm = this;

        /**
         * Вотчер на зависимое поле.
         *
         * Т.е. для поля с этим типом есть необходимость отслеживать изменения не только в текущем документа
         * но и во внешнем, используется конструкция из двух извлечений данных из текущего и внешнего
         * хранилища, с приоритетом текущего. в целом, исходим из предположения, что коды уникальны в рамках документа
         * (т.е. нет пересекающихся ключей в обоих хранилищах)
         */
        $scope.$watch('vm.values[vm.item.ref[0]] || vm.externalData[vm.item.ref[0]]', function(newCompany, oldCompany) {
          if(newCompany && oldCompany && newCompany.id !== oldCompany.id){
            vm.values[vm.item.code] = null;
          }
          vm.refresh();
        });

        vm.refresh = function(search_str, select){
          $timeout(function(){
            if(select) vm.selectObj = select; // вытаскиваем объект выпадалки для установки ей ошибок валидации
          }, 0);
          // обработка также учитывает. что ссылка может быть получена и из внешнего датасорса
          var company = vm.values[vm.item.ref[0]] || vm.externalData[vm.item.ref[0]];
          if(company && company.id){
            var fsrarId = (vm.externalData.fsrar)? vm.externalData.fsrar.id : undefined;
            vm.getData(company.id, fsrarId).then(function(res){
              vm.items = res.data;
              vm.dynamicTotal = res.data.length;
              vm.total = res.data.length;
              if(vm.total == 1 && vm.item.required){
                vm.values[vm.item.code] = vm.items[0];
              }
            });
          }
        };

        vm.totalStr = function(){
          return '';
        };

        /**
         * Вотчер для проверки уникальности подразделения отправителя и подразделения получателя
         */
        $scope.$watch(function () {
            return vm.values[vm.item.ref[1]];
          }, function(newDevision) {
          vm.isDivisonUniq = true;
          if(vm.selectObj && vm.values[vm.item.code] && newDevision){
            if(vm.values[vm.item.code].id == newDevision.id){
              vm.selectObj.ngModel.$setValidity('unique', false);
            }else{
              vm.selectObj.ngModel.$setValidity('unique', true);
            }
          }
        });

        vm.change = function(selected, select){
          if(vm.selectObj && selected && vm.values[vm.item.ref[1]]){
            if(selected.id == vm.values[vm.item.ref[1]].id){
              vm.selectObj.ngModel.$setValidity('unique', false);
            }else{
              vm.selectObj.ngModel.$setValidity('unique', true);
            }
          }
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('differenceField', {
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=' // атрибуты изменяют данные
      },
      templateUrl: 'app/documents/components/attribute/fields/differenceField/difference-field.html',
      controllerAs: 'differenceFieldCtrl',
      controller: function ($scope, documentService) {
        var differenceFieldCtrl = this;
        $scope.$watchGroup(['differenceFieldCtrl.values[differenceFieldCtrl.item.ref[0]]', 'differenceFieldCtrl.values[differenceFieldCtrl.item.ref[1]]'], function (newValue, oldValue) {
          differenceFieldCtrl.values[differenceFieldCtrl.item.code] = (newValue[0] || 0) - (newValue[1] || 0);
        });
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('dateField', {
      require: {
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        properties: '<?', // дополнительные свойства [из commonFieldData или метаданных c бэка]
        referenceData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        externalData: '<?'
      },
      templateUrl: 'app/documents/components/attribute/fields/date/date-field.html',
      controllerAs: 'dateFieldCtrl',
      controller: function ($scope, helpService, $timeout) {
        var dateFieldCtrl = this;
        var quarter = dateFieldCtrl.item.ref && dateFieldCtrl.item.ref[1];
        var year = dateFieldCtrl.item.ref && dateFieldCtrl.item.ref[2];

        dateFieldCtrl.id = moment().valueOf();

        // универсальные настройки датапикера (можно обернуть и перенети в настройки field)
        dateFieldCtrl.datePickerOptions = {
          singleDatePicker: true,
          correctTimeZone: dateFieldCtrl.item.code === 'date',
          timePicker: dateFieldCtrl.item.field_type.toUpperCase() === 'FLD_DATE_TIME',
        };


        if (year && quarter && dateFieldCtrl.externalData[year] && dateFieldCtrl.externalData[quarter]) {
          var quarterNum;
          switch (dateFieldCtrl.externalData[quarter]) {
            case "FIRST":
              quarterNum = 1;
              break;
            case "SECOND":
              quarterNum = 2;
              break;
            case "THIRD":
              quarterNum = 3;
              break;
            case "FOURTH":
              quarterNum = 4;
              break;
          }
          dateFieldCtrl.datePickerOptions.minDate = moment().utc().quarter(quarterNum).year(dateFieldCtrl.externalData[year]).startOf('quarter');
          dateFieldCtrl.datePickerOptions.maxDate = moment().utc().quarter(quarterNum).year(dateFieldCtrl.externalData[year]).endOf('quarter').subtract(1, "days");
        }
        
        // если поле должно показываться только в режиме просмотра
        if (dateFieldCtrl.item.onlyView && (!dateFieldCtrl.referenceData.status || dateFieldCtrl.referenceData.status == 'DRAFT')) {
          dateFieldCtrl.item.flex = 0;
        }
        
        if (dateFieldCtrl.properties) {
          angular.forEach(dateFieldCtrl.properties, function(value, key) {
            var date = dateFieldCtrl.item.code === 'date' ? helpService.now(true) : helpService.now();
            if (key === 'future_only') {
              dateFieldCtrl.datePickerOptions.minDate = date;
            } else if (key === 'disable_future') { // дизейбл дат в будущем
              dateFieldCtrl.datePickerOptions.maxDate = date;
            } else {
              dateFieldCtrl.datePickerOptions[key] = value;
            }
          });
        }

        // индивидуальные правила для даты документа
        if(dateFieldCtrl.item.code === 'date'){
          $timeout(function(){
            dateFieldCtrl.datePickerOptions.maxDate = moment();
            if(dateFieldCtrl.datePickerOptions.maxDate < moment(dateFieldCtrl.values[dateFieldCtrl.item.code])){
              dateFieldCtrl.values[dateFieldCtrl.item.code] = dateFieldCtrl.datePickerOptions.maxDate;
            }
            if(dateFieldCtrl.documentCtrl.docSettings){
              dateFieldCtrl.datePickerOptions.minDate = moment().subtract(dateFieldCtrl.documentCtrl.docSettings.domain_documents_settings.stop_editing,'d');
            }
          }, 0);
        }

		    // Динамический minDate
        if (dateFieldCtrl.item.ref && dateFieldCtrl.item.ref[0] && dateFieldCtrl.externalData) {
          $scope.$watch(function () {
            return dateFieldCtrl.externalData[dateFieldCtrl.item.ref[0]]
          }, function(newValue, oldValue) {
            if (newValue && (!oldValue || newValue !== oldValue)) {
              if (dateFieldCtrl.item.code == "payment_date"){
                dateFieldCtrl.datePickerOptions.minDate = moment(newValue).add(1, "d");
              } else {
                dateFieldCtrl.datePickerOptions.minDate = moment(newValue).add(1, "d").add(2, 'hours'); // пришлось добавить еще 2 часа,т.к. почемуто не хотел запрещаться день в date
              }
              if (dateFieldCtrl.item.$$dateState.resetData && dateFieldCtrl.datePickerOptions.minDate.valueOf() > dateFieldCtrl.values[dateFieldCtrl.item.code]) {
                dateFieldCtrl.item.$$dateState.resetData();
              }
            }
          }, true);
        }

        // Динамический maxDate
        if (dateFieldCtrl.item.ref && dateFieldCtrl.item.ref[3] && dateFieldCtrl.externalData) {
          $scope.$watch(function () {
            return dateFieldCtrl.externalData[dateFieldCtrl.item.ref[3]]
          }, function(newValue, oldValue) {
            if (newValue) {
              dateFieldCtrl.datePickerOptions.maxDate = moment(newValue);
              if (dateFieldCtrl.item.$$dateState && dateFieldCtrl.item.$$dateState.resetData &&
                  dateFieldCtrl.datePickerOptions.maxDate && dateFieldCtrl.values[dateFieldCtrl.item.code] && 
                  dateFieldCtrl.datePickerOptions.maxDate.valueOf() < dateFieldCtrl.values[dateFieldCtrl.item.code].valueOf()) {
                dateFieldCtrl.item.$$dateState.resetData();
              }
            }
          });
        }

      }
    });
})();

(function () {
  'use strict';

  angular
  .module('frontend')
  .component('customSelectField', {
    require: {
      documentCtrl: '^^document'
    },
    transclude: true,
    bindings: {
      redact: '<?', // режим редактирования
      values: '=', // единая для документа карта значений
      item: '=' // атрибуты изменяют данные
    },
    templateUrl: 'app/documents/components/attribute/fields/custom-select/custom-select.html',
    controllerAs: 'vm',
    controller: function ($scope, $uibModal, $timeout) {
      var vm = this;
      vm.needPopup = undefined;
      vm.items = vm.item.choices;
      vm.total = vm.item.choices.length;
      if(vm.total === 1){
        vm.values[vm.item.code] = vm.items[0];
      }

      vm.getViewValue = function(enumVal){
        return _.find(vm.items, function(item, key){
          return enumVal == key;
        });
      }

      // для vm.documentCtrl.document,т.к. этого объекта нет на этом этапе
      $timeout(function () {
        vm.needPopup = vm.documentCtrl.document.layout.properties &&
                       vm.documentCtrl.document.layout.properties.formsPopup &&
                       vm.documentCtrl.document.layout.properties.formsPopup[vm.item.code] &&
                       vm.documentCtrl.document.layout.properties.formsPopup[vm.item.code] == vm.values[vm.item.code];
      }, 0);

      vm.openFormsPopup = function () {
        $uibModal.open({
          templateUrl: 'app/documents/modals/forms-popup/forms-popup.html',
          size: 'large-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.catalogItem = vm.values[vm.item.ref[0]];
            $scope.data = vm.values[vm.item.ref[1]];
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };

            $scope.getItems = function (argument) {
              // body...
            }

            $scope.columns = [{
              name: "№",
              flex: 0.1,
              headerTemplateUrl: "headerCellTemplate.html",
              templateUrl: 'numberTemplate.html',
              templateScope: $scope,
              visible: true,
              column_visible: true
            },{
              name: "Справка 1",
              field: "f1_reg_id",
              flex: 0.6,
              headerTemplateUrl: "headerCellTemplate.html",
              templateUrl: "cellTemplate.html",
              templateScope: $scope,
              visible: true,
              column_visible: true
            },{
              name: "Справка 2",
              field: "f2_reg_id",
              flex: 0.6,
              headerTemplateUrl: "headerCellTemplate.html",
              templateUrl: "cellTemplate.html",
              templateScope: $scope,
              visible: true,
              column_visible: true
            },{
              name: "Кол-во",
              field: "quantity",
              flex: 0.5,
              headerTemplateUrl: "headerCellTemplate.html",
              templateUrl: "cellTemplate.html",
              templateScope: $scope,
              visible: true,
              column_visible: true
            }];
          }
        });
      }


    }
  });
})();

(function () {
  'use strict';

  angular
  .module('frontend')
  .component('counterpartyContact', {
    transclude: true,
    bindings: {
      redact: '<?', // режим редактирования
      values: '=', // единая для документа карта значений
      item: '=', // атрибуты изменяют данные
      selectMatchPatern: '<', // шаблон для строки результата выбора
      selectChoicesPatern: '<' // шаблон строки в выпадающем списке
    },
    templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
    controllerAs: 'vm',
    controller: function ($scope, contragentService) {
      var vm = this;
      $scope.$watch('vm.values[vm.item.ref[0]]', function(val, old) {
        // сброс текущего выбранного, при условии, что меняеются не undefined значения (когда old undefined, а в values[vm.item.code] - инициализация, чистаить не нужно)
        if (!val || old && (old.id != val.id)) {
          vm.values[vm.item.code] = undefined;
        };
        vm.refresh('', val, old)
      });

      vm.refresh = function(search, val, old) {
        if (vm.values[vm.item.ref[0]] && vm.values[vm.item.ref[0]].id) {
          contragentService.contacts(vm.values[vm.item.ref].id).then(function(res) {
            vm.items = res.data;
            vm.total = res.data.length;
            vm.dynamicTotal = res.data.total;
          })
        }
      }

      vm.totalStr = function(){
        return '';
      };
    }
  });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('contractsField', {
      transclude: true,
      bindings: {
        redact: '<?', // режим редактирования
        values: '=', // единая для документа карта значений
        externalData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        createStr: '<?', // текст внутри ссылки создания новой сущности
        createLink: '<?', // ссылка, куда переходить по клику на ссылке создания новой сущности
        createData: '<?', // данные для перехода на страничку создания новой сущности
        getData: '<' // метод получения списка
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $state, $stateParams, $window) {
        var vm = this;

        $scope.$watchGroup([function(){
          // следить за контрагентом
          return vm.values[vm.item.ref[0]] || vm.externalData[vm.item.ref[0]];
        }, 
        function(){
          // следить за компанией
          return vm.values[vm.item.ref[1]] || vm.externalData[vm.item.ref[1]];
        }], function (newValue, oldValue) {
          if (vm.item.create_new_item) {
              vm.redact = newValue[0] && newValue[1];
          }
          if ((!oldValue[0] || !oldValue[1]) && newValue[0] && newValue[1]) {
            vm.refresh();
          }
          if (newValue[0] && oldValue[0] && newValue[1] && (newValue[0].id != oldValue[0].id || (oldValue[1] && newValue[1].id != oldValue[1].id))){
            vm.refresh("", null, true);
          }
        });

        vm.refresh = function (search, select, reset) {
          if (((vm.values[vm.item.ref[0]] && vm.values[vm.item.ref[0]].id) ||
            (vm.externalData[vm.item.ref[0]] && vm.externalData[vm.item.ref[0]].id)) &&
            ((vm.values[vm.item.ref[1]] && vm.values[vm.item.ref[1]].id) ||
            (vm.externalData[vm.item.ref[1]] && vm.externalData[vm.item.ref[1]].id))) {

            // сброс текущего выбранного договора:
            if(reset){
              vm.values[vm.item.code] = undefined;
            }
            
            vm.getData(
              search,
              vm.amount,
              null,
              (vm.values[vm.item.ref[1]] || vm.externalData[vm.item.ref[1]])["id"], // компания
              (vm.values[vm.item.ref[0]] || vm.externalData[vm.item.ref[0]])["id"], // контрагент
              $stateParams.purpose)
              .then(function (res) {
                vm.items = res.data.items;
                vm.total = res.data.total;
                vm.searchEnabled = (vm.amount == 100)? vm.total > vm.amount && vm.total <= vm.amount : vm.total > vm.amount;
                if (vm.item.create_new_item && vm.items[vm.items.length - 1] && !vm.items[vm.items.length - 1].helper) {
                  vm.items.push({helper: true});
                }
                if (res.data.total == 1 && vm.item.required) {
                  vm.values[vm.item.code] = vm.items[0];
                }
              });
          }
        }

        vm.totalStr = function(){
          if(vm.total > vm.amount){
            return "Показано " + vm.amount + " из " + vm.total;
          }
          return '';
        };

        vm.toCreateItem = function(event, select){
          select.close();
          event.stopPropagation();
          var url = $state.href(vm.createLink, vm.createData);
          $window.open(url,'_blank');
        };

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('companyEgaisField', {
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        amount: '<', // количество элементов в списке
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<', // метод получения списка
        redact: '<?', // режим редактирования
        purpose: '<' // назначение документа
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $rootScope, $uibModal) {
        var vm = this;
        vm.amount = vm.amount || 5;
        vm.oldVal = vm.values[vm.item.code];

        vm.refresh = function(search){
          vm.getData({limit: vm.amount}, search).then(function(res){
            vm.items = res.data.items;
            vm.total = res.data.total;
            vm.searchEnabled = (vm.amount == 100)? vm.total > vm.amount && vm.total <= vm.amount : vm.total > vm.amount;

            // выбор значения по-умолчанию
            if(vm.total == 1 && vm.item.required){
              vm.values[vm.item.code] = vm.items[0];
            }
          });
        };

        vm.totalStr = function(){
          if(vm.total > vm.amount){
            return "Показано " + vm.amount + " из " + vm.total;
          }
          return '';
        };

        vm.getTitleMatch = function(str) {
          return $scope.$eval(str);
        }

        vm.change = function(){
          // реф 1 - связь с гридом
          if (vm.item.ref && vm.item.ref[0] && 
            !vm.changed && vm.values[vm.item.code] && 
            !vm.modal && 
            (vm.values[vm.item.ref[0]].length > 1 || vm.values[vm.item.ref[0]][0].derivative)) {
            vm.modal = $uibModal.open({
              templateUrl: 'app/settings/templates/modals/one-question.html',
              size: 'small-width',
              controller: function ($scope, $uibModalInstance) {
                $scope.title = "Предупреждение";
                $scope.text = vm.item.change_message || "При изменении ФСРАР ИД, все строки в документе будут удалены.<br>Изменить ФСРАР ИД?";
                $scope.close = function () {
                  vm.values[vm.item.code] = vm.oldVal;
                  vm.modal = undefined;
                  $uibModalInstance.dismiss();
                };
                $scope.action = function () {
                  vm.changed = true;
                  vm.modal = undefined;
                  vm.values[vm.item.ref[0]] = [{}];
                  vm.values[vm.item.ref[1]] = null;
                  vm.values[vm.item.ref[2]] = null;
                  vm.oldVal = vm.values[vm.item.code];
                  $uibModalInstance.dismiss();
                };
              }
            });
          }else{
            vm.values[vm.item.ref[1]] = null;
            vm.values[vm.item.ref[2]] = null;
          }
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('catalogField', {
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        getData: '<', // метод получения списка
        onlyStock: '<', // флаг запроса товаров
        externalData: '<'
      },
      templateUrl: 'app/documents/components/attribute/fields/catalogItem/catalog-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $state, OPTIONS_LENGTH, $stateParams, searchCatalogItemSrv, $timeout, $uibModal, utilsService) {
        var vm = this;
        var uomRef = vm.item.ref[1];
        var purpose = $stateParams.purpose; // возможно стоит передавать через все диррективы
        var onlyCommittent = null;
        var filter_is_alcohol = vm.item.filter_is_alcohol;
        vm.tipForSearch = "Расширенный поиск товара или услуги";
        var purposeWithTrueFlag = [
          'CNI_FROM_COMMITTEE',
          'CNO_TO_COMMITTEE',
          'PO_TO_COMMITTEE',
          'PR_TO_COMMITTEE',
          'REPORT_TO_COMMITTEE'
        ];
        var purposeWithFalseFlag = [
          'PO_TO_SUPPLIER',
          'PR_FROM_SUPPLIER',
          'INVI_PURCHASE',
          'INVO_RETURN',
          'CNO_TO_SUPPLIER',
          'CNI_FROM_SUPPLIER'
        ];

        if (~purposeWithTrueFlag.concat(purposeWithFalseFlag).indexOf(purpose)) {
          onlyCommittent = purposeWithTrueFlag.indexOf(purpose) >= 0
        }

        vm.refresh = function (select) {
          if (select.search.length > 150) {
            select.search = select.search.slice(0, -1);
            return;
          }
          $timeout(function () {
            vm.selectObj = select; // вытаскиваем объект выпадалки для установки ей dirty после изменения значения
            vm.getData(select.search, vm.onlyStock, OPTIONS_LENGTH, onlyCommittent, filter_is_alcohol).then(function (res) {
              vm.items = (select.search.length > 2) ? res.data.items : [];
              vm.searchTotal = res.data.total;
              vm.total = res.data.total;
              if (vm.total == 1 && vm.item.required && vm.items.length) {
                vm.values[vm.item.code] = vm.items[0];
                vm.onSelect();
              }
              if (select.search.length > 2 && res.data.items.length == 1 && vm.items.length) {
                vm.values[vm.item.code] = vm.items[0];
                vm.onSelect();
                select.close();
                // запрет на дальнейший ввод в поисковую строку после подстановки данных
                $timeout(function () {
                  vm.selectObj.$element.find('input').blur();
                }, 0);
              }
            });
          }, 0);
        };

        vm.setUom = function (uom) {
          if ($state.current.name.indexOf('writeUpStatement') + 1 && uom.classifier_code == 112) {
            //RECS-9866 При добавлении дериватива, у которого uom = 112 (литр), в акте списания необходимо подставлять lines.uom = 116 (декалитр).
            if (!vm.uom116) {
              utilsService.getUoms(116).then(function (res) {
                vm.uom116 = res.data[0];
                vm.values[uomRef] = res.data[0];
              });
            } else {
              vm.values[uomRef] = vm.uom116;
            }
          } else {
            vm.values[uomRef || 'uom'] = {
              id: uom.id,
              name: uom.symbols
            };
          }
        }

        vm.onSelect = function () {
          vm.selectObj.ngModel.$setValidity('wrong-match', true);
          if (uomRef && vm.values[vm.item.code]) {
            vm.setUom(vm.values[vm.item.code].uom);
          }
        }

        vm.totalStr = function () {
          if (vm.searchTotal > OPTIONS_LENGTH) {
            return "Показано " + OPTIONS_LENGTH + " из " + vm.searchTotal;
          }
          return '';
        };

        vm.showSearchCatalogItemPopup = function () {
          vm.promice = searchCatalogItemSrv.showModal(false, vm.item.field_type == 'FLD_SKU_SERVICE_DERIVATIVE' || vm.item.field_type == 'FLD_SKU_DERIVATIVE', vm.item.create_alco_item)
          vm.promice.result.then(function (res) {
            if (res) {
              vm.values[vm.item.code] = {
                id: res.id,
                name: res.name || res.code,
                tax_group: res.tax_group,
                committent_tax_group: res.committent_tax_group,
                derivative: res.derivative,
                stock_accounting_type: res.stock_accounting_type,
                is_alcohol: res.is_alcohol || undefined,
                require_amc: res.require_amc || undefined
              }
              var uom = res.uom || res.base_uom || undefined;
              if (uom) {
                vm.setUom(uom);
              }
              vm.selectObj.ngModel.$setDirty();
            }
          });
        }

        vm.showSkuInfoModal = function () {
          $uibModal.open({
            size: 'large-width',
            component: 'skuModalInfo',
            controllerAs: 'skuModalInfoCtrl',
            resolve: {
              line: function () {
                return vm.values;
              },
              document_id: function () {
                return vm.externalData.id;
              },
              is_recs_sku: function () {
                return vm.item.is_recs_sku;
              },
              alcohol_catalog_item_id: function () {
                return vm.values.alcohol_catalog_item.id;
              }
            }
          });
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('alcoholField', {
      transclude: true,
      bindings: {
        redact: '<', // флаг редактирования
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        matchPaternTooltip: '<', // шаблон строки в подсказке
        getData: '<', // метод получения списка
        onlyStock: '<', // флаг запроса товаров
        externalData: '<',
        properties: '<' // дополнительные опции из меты
      },
      templateUrl: 'app/documents/components/attribute/fields/catalogItem/catalog-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $state, OPTIONS_LENGTH, $stateParams, searchCatalogItemSrv, searchAlcoItemSrv, $timeout, egaiszService, utilsService) {
        var vm = this;
        var purpose = $stateParams.purpose; // возможно стоит передавать через все диррективы
        var ref_sku = vm.item.ref[0];
        var ref_uom = vm.item.ref[2];
        var ref_fsrar = vm.item.ref[1];
        var ref_form2 = vm.item.ref[3];
        var ref_stock_quantity = vm.item.ref[4];
        var ref_shop_quantity = vm.item.ref[5];
        var ref_quantity = vm.item.ref[6];
        var alcohol_item = vm.item.ref[7];
        var ref_derivative = vm.item.ref[8];
        var ref_register = vm.item.ref[9];
        vm.tipForSearch = "Расширенный поиск алкогольной продукции";
        
        vm.selectObj = {search: ''};

        function promiseSuccess (res, showAllData) {
          vm.items = (vm.selectObj.search.length > 2 || vm.item.hideSearchButton || showAllData)? res.data.items : [];
          if (vm.item.isAlcoExtendedSearch) {
            vm.items = _.map(vm.items, function (item) {
              item.id = (item.item)? item.item.id : item.id;
              item.name = (item.item)? item.item.full_name : item.full_name;
              return item;
            });
          }
          vm.searchTotal = res.data.total;
          vm.total = res.data.total;
          if(vm.total == 1 && vm.items.length && vm.item.required){
            vm.values[vm.item.code] = {
              id: vm.items[0].id || null,
              full_name: vm.items[0].full_name || null,
              alc_code: vm.items[0].alc_code || null,
              capacity: vm.items[0].capacity || null
            };
          }
          if(res.data.items && (vm.selectObj.search.length > 2 || vm.item.hideSearchButton) && res.data.items.length == 1){
            vm.values[vm.item.code] = {
              id: vm.items[0].id || null,
              full_name: vm.items[0].full_name || null,
              alc_code: vm.items[0].alc_code || null,
              capacity: vm.items[0].capacity || null
            };
            vm.setDataInLine(vm.items[0]);
            vm.selectObj.close();
            // запрет на дальнейший ввод в поисковую строку после подстановки данных
            $timeout(function(){
              vm.selectObj.$element.find('input').blur();
            },0);
          }
        }

        vm.refresh = function(select){
          if (select.search.length > 150) {
            select.search = select.search.slice(0, -1);
            return;
          }
          $timeout(function(){
            if(select){
              vm.selectObj = select;
            }
            if(vm.selectObj.search.length > 2 || ((vm.item.hideSearchButton || vm.item.searchDisabled) && vm.selectObj.activeSelect)){
              if (vm.item.isAlcoExtendedSearch) {
                if (vm.externalData[ref_fsrar]) {
                  var params = {
                    search_string: (select)? select.search : '',
                    filter_fsrar_id: vm.externalData[ref_fsrar].id,
                    filter_derivative_id: (ref_derivative && vm.values[ref_derivative])? ((vm.values[ref_derivative].derivative && vm.values[ref_derivative].derivative.id)? vm.values[ref_derivative].derivative.id : vm.values[ref_derivative].id) : null
                  };
                  egaiszService.catalogItemsAuto(params).then(function(res){
                    promiseSuccess(res, !!params.filter_derivative_id);
                  });
                }
              } else if (vm.item.alcoSearchFromCatalog) {
                var params = {
                  search_string: (select)? select.search : '',
                  filter_fsrar_id: vm.externalData[ref_fsrar].id,
                  catalog_item_id: vm.values[vm.item.ref[0]].id
                };
                egaiszService.getAlcoholCatalogItems(params).then(function(res){
                  promiseSuccess(res);
                });
              } else {
                vm.getData((select)? select.search : '', vm.onlyStock, OPTIONS_LENGTH).then(function(res){
                  promiseSuccess(res);
                });
              }
            }else{
              vm.items = [];
              vm.selectObj.activeSelect = true;
            }
          },0);
        }

        vm.onSelect = function(selected){
          vm.selectObj.ngModel.$setValidity('wrong-match', true);
          vm.setDataInLine(selected);
        }

        vm.totalStr = function(){
          if(vm.searchTotal > OPTIONS_LENGTH){
            return "Показано " + OPTIONS_LENGTH + " из " + vm.searchTotal;
          }
          return '';
        };

        // если есть зависимость от farar
        if (ref_fsrar) {
          $scope.$watch(function(){
            return vm.externalData[ref_fsrar];
          }, function(newVal, oldVal){
            vm.isDisabled = !newVal;
            if (ref_derivative && !vm.values[ref_derivative]) {
              vm.isDisabled = true;
            }

            if (newVal && (!oldVal || newVal.id !== oldVal.id)) {
              vm.values[vm.item.code] = undefined;
              vm.refresh();
            }
          });
        }

        vm.setDataInValues = function(ref, value, defaultVal) {
          if (ref) {
            vm.values[ref] = value || defaultVal;
          }
        };

        vm.setDataInLine = function (res) {
          if (vm.item.isAlcoExtendedSearch) {
            vm.values[vm.item.code] = {
              id: (res.item)? res.item.id : res.id,
              name: (res.item)? (res.item.full_name || res.item.alc_code) : (res.full_name || res.alc_code),
              is_alcohol: res.is_alcohol || undefined,
              require_amc: res.require_amc || undefined
            }
            if (ref_form2) {
            vm.setDataInValues(ref_form2, res.form_2.f2reg_id, undefined);
            }
            if (ref_uom) {
            vm.setDataInValues(ref_uom, res.item.uom, undefined);
            }
            if (ref_stock_quantity) {
            vm.setDataInValues(ref_stock_quantity, res.alcohol_stock_quantity, 0);
            }
            if (ref_shop_quantity) {
            vm.setDataInValues(ref_shop_quantity, res.alcohol_shop_quantity, 0);
            }
            if (ref_quantity) {
            vm.setDataInValues(ref_quantity, res.item.quantity, 0);
            }
          } else {
            vm.values[vm.item.code] = {
              id: res.id,
              name: res.name || res.code,
              derivative: res.derivative,
              stock_accounting_type: res.stock_accounting_type,
              is_alcohol: res.is_alcohol || undefined,
              require_amc: res.require_amc || undefined
            }

            if(res.uom){
              vm.selectObj.ngModel.$setValidity('wrong-match', true);
              
              if ($state.current.name.indexOf('cancellationAct') + 1 || // все это только для актов списания
                  $state.current.name.indexOf('transferBetweenRegister') + 1 ||  // и переводов междду регистрами
                  $state.current.name.indexOf('writeUpStatement') + 1) { // и оприходований
                vm.values[vm.item.code].uom = res.uom;
                //RECS-9866 Запретить добавлять/сохранять линейки с деривативами, у которых (имеется ввиду деривативов) единица измерения derivative.uom не равна 116 (декалитр), 112 (литр) или 796 (штука).
                if (res.uom.classifier_code !== 116 && res.uom.classifier_code !== 112 && res.uom.classifier_code !== 796) {
                  vm.selectObj.ngModel.$setValidity('wrong-match', false);
                  vm.selectObj.ngModel.errorStr = "Допустимые единицы измерения товара: штуки, литры, декалитры";
                } else if (res.uom.classifier_code == 112) {
                  //RECS-9866 При добавлении дериватива, у которого uom = 112 (литр), в акте списания необходимо подставлять lines.uom = 116 (декалитр).
                  utilsService.getUoms(116).then(function(res){
                    vm.values[vm.item.code].uom = res.data[0];
                    vm.setDataInValues(ref_uom, vm.values[vm.item.code].uom, undefined);
                  });
                }
              } else {
                vm.values[vm.item.code].uom = {
                  id: res.uom.id,
                  name: res.uom.symbols
                }
              }
              vm.setDataInValues(ref_uom, vm.values[vm.item.code].uom, undefined);
            }
            vm.setDataInValues(ref_form2, undefined, undefined);
          }
        }

        vm.showSearchCatalogItemPopup = function(){


          if(vm.item.isAlcoExtendedSearch){
            vm.promice = searchAlcoItemSrv.showModal(vm.externalData[ref_fsrar], undefined, false, false, false, false, false, true)
          }else{
            vm.promice = searchCatalogItemSrv.showModal(false, true,
                                                        vm.item.create_alco_item,
                                                        vm.externalData.id,
                                                        vm.values.id,
                                                        vm.values[alcohol_item] && vm.values[alcohol_item].id)
          }
          vm.promice.result.then(function(res) {
            if(res){
              vm.setDataInLine(res);
              vm.selectObj.ngModel.$setDirty();
            }
          })
        }

        // если есть зависимость от складской позиции
        if (ref_sku) {
          $scope.$watch(function(){
            return vm.values[ref_sku];
          }, function(newVal, oldVal){
            if (ref_fsrar && !vm.externalData[ref_fsrar]) {
              vm.isDisabled = true;
              return;
            }
            if (!oldVal || newVal.id != oldVal.id) {
              vm.values[vm.item.code] = undefined;
              vm.refresh();
            }
            vm.isDisabled = !newVal;
          });
        }

        // если есть зависимость от фсрар
        if (ref_fsrar) {
          $scope.$watch(function(){
            return vm.externalData[ref_fsrar];
          }, function(newVal, oldVal){
            if (ref_sku && !vm.values[ref_sku]) {
              vm.isDisabled = true;
              return;
            }
            vm.isDisabled = !newVal;
          });
        }

        // скрытие поля в зависимости от properties
        if (vm.properties && vm.properties.hide_field &&
            vm.properties.hide_field[vm.item.code]) {
          var hideProp = vm.properties.hide_field[vm.item.code];
          vm.hideField = vm.values[hideProp.ref_property] == hideProp.ref_value;
        }

        if (ref_derivative) {
          $scope.$watch(function(){
            return vm.values[ref_derivative];
          }, function (newVal, oldVal) {
            if (!oldVal || !newVal || newVal.id != oldVal.id) {
              vm.values[vm.item.code] = undefined;
              vm.refresh();
            }
            vm.isDisabled = !newVal;
            if (ref_fsrar && !vm.externalData[ref_fsrar]) {
              vm.isDisabled = true;
            }
          });
        }


      }
    });
})();

(function () {
  'use strict';

  angular
  .module('frontend')
  .component('baseDocument', {
    transclude: true,
    bindings: {
      externalData: '<',
      item: '<',
      values: '<'
    },
    controllerAs: 'baseDocumentCtrl',
    templateUrl: 'app/documents/components/attribute/fields/base-document/base-document.html',
    controller: function ($scope, $filter, $stateParams) {
      var baseDocumentCtrl = this;
      baseDocumentCtrl.register = $stateParams.register;
      
      if ($stateParams.source && $stateParams.sourceNumber  && $stateParams.sourceDate){
        baseDocumentCtrl.doc = baseDocumentCtrl.externalData[baseDocumentCtrl.item.code];
        baseDocumentCtrl.doc.base_document_type = 'DOCUMENT_EGAIS';
      } else {
        baseDocumentCtrl.doc = baseDocumentCtrl.externalData[baseDocumentCtrl.item.code] || baseDocumentCtrl.values[baseDocumentCtrl.item.code];
      }

      if (baseDocumentCtrl.doc) {
        baseDocumentCtrl.docData = baseDocumentCtrl.doc.document? baseDocumentCtrl.doc.document : baseDocumentCtrl.doc.document_egais;
        
        baseDocumentCtrl.viewStr = function () {
          if ($stateParams.source && $stateParams.sourceNumber  && $stateParams.sourceDate) {
            return '№' + baseDocumentCtrl.docData.doc_number + 
                    ' от ' + $filter('date')(baseDocumentCtrl.docData.doc_date, 'dd.MM.yyyy');
          } else {
            if (baseDocumentCtrl.doc.base_document_type == 'DOCUMENT_RECS') {
              return $filter('documentType')(baseDocumentCtrl.docData.document_type) + 
                    ' №' + baseDocumentCtrl.docData.number + 
                    ' от ' + $filter('date')(baseDocumentCtrl.docData.date, 'dd.MM.yyyy');
            } else {
              return $filter('egaisDocumentsType')(baseDocumentCtrl.docData.document_egais_type) + 
                    ' №' + baseDocumentCtrl.docData.doc_number + 
                    ' от ' + $filter('date')(baseDocumentCtrl.docData.doc_date, 'dd.MM.yyyy');
            }
          }
        }();
      }

    }
  });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('addDocuments', {
      require: {
        documentCtrl: '^^document'
      },
      transclude: true,
      bindings: {
        values: '=', // единая для документа карта значений
        item: '=', // атрибуты изменяют данные
        externalData: '<', // дополнительный источник общих для докумнета данных
        referenceData: '<?' // эталонные данные документа, для вычисления данных с сервера
      },
      templateUrl: 'app/documents/components/attribute/fields/add-documents/add-documents.html',
      controllerAs: 'addDocuments',
      controller: function ($scope, $uibModal, searchDocumentsSrv) {
        var addDocuments = this;
        var gridCode = (addDocuments.item.ref)? addDocuments.item.ref[1] : '';
        var homeAmountCode = (addDocuments.item.ref)? addDocuments.item.ref[2] : '';
        var companyCode = (addDocuments.item.ref && addDocuments.item.ref[3])? addDocuments.item.ref[3] : 'company';
        var employeeCode = (addDocuments.item.ref)? addDocuments.item.ref[4] : '';
        addDocuments.isDisableLink = true;
        addDocuments.disableMessage = '';
        addDocuments.gridFields = [];

        addDocuments.showPopup = function(){
          if(!addDocuments.gridFields.length){
            _.forEach(addDocuments.documentCtrl.document.layout.items, function(itemParent){
              _.forEach(itemParent.items, function(item){
                if(gridCode == item.code){
                  addDocuments.gridFields = item.fields;
                }
              });
            });
          }

          if(!addDocuments.isDisableLink){
            addDocuments.promice = searchDocumentsSrv.showModal(addDocuments.documentCtrl.document.layout.properties[addDocuments.item.ref[1]].purposes,
                                                                addDocuments.gridFields,
                                                                addDocuments.documentCtrl.document.layout.properties[addDocuments.item.ref[1] + '_title'],
                                                                addDocuments.values[addDocuments.item.ref[1]],
                                                                addDocuments.documentCtrl.externalData[companyCode].id,
                                                                addDocuments.documentCtrl.values[employeeCode] && addDocuments.documentCtrl.values[employeeCode].id);
            addDocuments.promice.result.then(function(res) {
              addDocuments.values[addDocuments.item.ref[1]] = res;
            });
          }
        }
        // реф 0 - связь с полем типа boolean(FLD_BOOLEAN или FLD_CHECKBOX)
        // реф 1 - связь с гридом документов
        // реф 2 - связь с переменной суммы, для отображения в рублях, а не в копейках
        // реф 3 - связь с компанией
        // реф 4 - связь с сотрудником
        if (addDocuments.item.ref && addDocuments.item.ref[0] && addDocuments.item.ref[1]) {
          $scope.$watch(function() { return addDocuments.values[addDocuments.item.ref[0]] }, function(val) {
              addDocuments.hide = !val;
              if(!val){
                addDocuments.values[addDocuments.item.ref[1]] = undefined;
              }
          })
        }

        // проверка запоненности комапнии и сотрудника в звисимости от их необходимости
        // и формирование необходимой подсказки
        if (addDocuments.item.ref && companyCode) {
          $scope.$watch(function() { return addDocuments.externalData[companyCode] }, function(val) {
            if (!val) {
              addDocuments.isDisableLink = true;
              addDocuments.disableMessage = (employeeCode && !addDocuments.values[employeeCode])? "Для добавления связанного документа выберите компанию и сотрудника" : "Для добавления связанного документа выберите компанию";
            }else if(val && employeeCode && !addDocuments.values[employeeCode]) {
              addDocuments.isDisableLink = true;
              addDocuments.disableMessage = "Для добавления связанного документа выберите сотрудника" ;
            }else{
              addDocuments.isDisableLink = false;
              addDocuments.disableMessage = "";
            }
          })
        }

        if (addDocuments.item.ref && employeeCode) {
          $scope.$watch(function() { return addDocuments.values[employeeCode] }, function(val) {
            if (!val) {
              addDocuments.isDisableLink = true;
              addDocuments.disableMessage = (companyCode && !addDocuments.externalData[companyCode])? "Для добавления связанного документа выберите компанию и сотрудника" : "Для добавления связанного документа выберите сотрудника";
            }else if(val && companyCode && !addDocuments.externalData[companyCode]) {
              addDocuments.isDisableLink = true;
              addDocuments.disableMessage = "Для добавления связанного документа выберите компанию" ;
            }else{
              addDocuments.isDisableLink = false;
              addDocuments.disableMessage = "";
            }
          })
        }


      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('accountsField', {
      transclude: true,
      bindings: {
        redact: '<?', // режим редактирования
        values: '=', // единая для документа карта значений
        externalData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        item: '=', // атрибуты изменяют данные
        selectMatchPatern: '<', // шаблон для строки результата выбора
        selectChoicesPatern: '<', // шаблон строки в выпадающем списке
        createStr: '<?', // текст внутри ссылки создания новой сущности
        createLink: '<?', // ссылка, куда переходить по клику на ссылке создания новой сущности
        createData: '<?' // данные для перехода на страничку создания новой сущности
      },
      templateUrl: 'app/documents/components/attribute/fields/select/select-field.html',
      controllerAs: 'vm',
      controller: function ($scope, $state, $window, contragentService, personsDataSrv, companyService, employeesService) {
        var vm = this;
        $scope.$watchGroup(["vm.externalData[vm.item.ref[0]]", "vm.externalData[vm.item.ref[1]]", "vm.values[vm.item.ref[0]]", "vm.values[vm.item.ref[1]]"], function(newVal, oldVal) {
          if(newVal[2] && oldVal[2] && newVal[2].id !== oldVal[2].id){
            vm.values[vm.item.code] = undefined;
          }
          vm.refresh();
        });

        function getSelectList(res, ref1){
          var newAccounts = [];
          angular.forEach(res.data, function(account){
            if(ref1 && account.currency.id === ref1.id){
              newAccounts.push(account);
            }
          });
          // странное условие
          vm.items = (newAccounts.length)? newAccounts : res.data;
          vm.total = vm.items.length;
          if(vm.total === 1 && vm.item.required){
            vm.values[vm.item.code] = vm.items[0];
          }
          if (vm.item.create_new_item && vm.items[vm.items.length - 1] && !vm.items[vm.items.length - 1].helper) {
            vm.items.push({helper: true});
          }
        }

        vm.refresh = function(){
          var ref0 = vm.values[vm.item.ref[0]] || vm.externalData[vm.item.ref[0]];
          var ref1 = vm.values[vm.item.ref[1]] || vm.externalData[vm.item.ref[1]] || vm.externalData.natural_currency;
          vm.item.create_new_item = ref0;
          if (ref0 && ref1) {
            if (vm.item.field_type == "FLD_COMPANY_BANK_ACCOUNT"){
              companyService.getAccounts(ref0.id).then(function(res){
                getSelectList(res, ref1);
              });
            } else if (vm.item.field_type == "FLD_COUNTERPARTY_BANK_ACCOUNT") {
              contragentService.getAccounts(ref0.id).then(function(res){
                getSelectList(res, ref1);
              });
            } else if (vm.item.field_type == "FLD_PERSON_BANK_ACCOUNT") {
              employeesService.user(ref0.id).then(function(res){
                if(res.data.person){
                  personsDataSrv.getPersonAccountList(res.data.person.id).then(function(resPerson){
                    getSelectList(resPerson, ref1);
                  });
                }
              });
            }
          }
        }

        vm.totalStr = function(){
          return '';
        };

        vm.toCreateItem = function(event, select){
          var data = {};
          select.close();
          event.stopPropagation();
          if (vm.item.field_type == 'FLD_COMPANY_BANK_ACCOUNT') {
            data.companyId = vm.createData;
          } else if (vm.item.field_type == 'FLD_COUNTERPARTY_BANK_ACCOUNT') {
            data.contragentId = vm.createData;
          } else {
            data.userId = vm.createData;
          }
          data.closeTab = true;
          var url = $state.href(vm.createLink, data);
          $window.open(url,'_blank');
        };

      }
    });
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('utmConnectionCard', utmCompanyCard);

  function utmCompanyCard() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/utmConnections/directives/utm-connection-card/utm-connection-card.html',
      bindings: {
        connection: '<'
      },
      controller: function ($scope) {
        $scope.connection = $scope.connection;
      }
    }
  }
}) ();

/**
 * Created by aivanov on 21.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('personsCompany', personsCompany);

  /**
   * Директива для отображения одного типа подразделений компании
   */
  function personsCompany() {
    return {
      require: '^form',
      restrict: 'E',
      templateUrl: 'app/settings/templates/companies/main-person/main-person.html',
      bindToController: true,
      scope: {
        /* Сущность компании в которую маппятся нужные для счетов свойства */
        company: '=',
        stateName: '@',
        mode: '<'
      },
      link: function(scope, element, attrs, form) {
        scope.parentForm = form;
      },
      controller: personsCompanyController,
      controllerAs: 'vm'
    }

    function personsCompanyController(personsDataSrv) {
      var vm = this;
    }
  }
}) ();

/**
 * Created by aivanov on 21.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('infoCompany', infoCompany);

  /**
   * Директива для отображения одного типа подразделений компании
   */
  function infoCompany() {
    return {
      require: '^form',
      restrict: 'E',
      templateUrl: 'app/settings/templates/companies/main-info/main-info.html',
      bindToController: true,
      scope: {
        /* Сущность компании в которую маппятся нужные для счетов свойства */
        company: '=',
        name: '=?',
        stateName: '@',
        showNames: '=',
        uniqueCallback: "=?", // callback для проверки уникальности по blur,
        addressControls: '<?'
      },
      link: function(scope, element, attrs, form) {
        scope.parentForm = form;
      },
      controller: infoCompanyController,
      controllerAs: 'vm'
    }

    function infoCompanyController($scope, personsDataSrv, utilsService,$log,focus,$timeout) {
      var vm = this;

      vm.reset = function (index) {
        vm.company.contact_info.details[index].value = undefined;
        $timeout(function () {
          focus.setFocusOnInput('[name="contactVal' + index + '"]')
        },1)
      };

      vm.uniqueCheck = function(str){
        if(str){
          var obj = {
            "constraint_name": vm.stateName.split('.')[0] == 'company'?'COMPANY':"COUNTERPARTY",
            "parameters": [
              {
                "name": "name",
                "value": str
              }
            ]
          }
          utilsService.uniqueCheck(obj).then(function(res){},
          function (error) {
            if(error.status == 409){
              angular.forEach(error.data.parameters, function(field){
                $scope.parentForm[field.name].$setValidity('unique', false);
              });
            } else {
              $log.debug(error)
            }
          });
        }
      }
    }
  }
}) ();

/**
 * Created by aivanov on 21.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('requisitesCompany', requisitesCompany);

  /**
   * Директива для отображения одного типа подразделений компании
   */
  function requisitesCompany() {
    return {
      require: '^form',
      restrict: 'E',
      templateUrl: 'app/settings/templates/companies/legal-requisites/legal-requisites.html',
      bindToController: true,
      scope: {
        /* Сущность компании в которую маппятся нужные для счетов свойства */
        company: '=',
        stateName: '@',
        mode: '<'
      },
      link: function(scope, element, attrs, form) {
        scope.parentForm = form;
      },
      controller: requisitesCompanyController,
      controllerAs: 'vm'
    };

    function requisitesCompanyController(utilsService, $timeout, modalAskSrv) {
      var vm = this;
      vm.triggerOkvedUpdate = function () {};

      // структура для управления директивой адреса
      vm.addressOptions = {};

      vm.datePickerOpts = {singleDatePicker: true, correctTimeZone: false, maxDate: moment()};
      var tempDate = vm.company.organization.legal_requisites.registration_date;
      if(vm.company.organization.legal_requisites.registration_date){
        vm.dateStr = moment(vm.company.organization.legal_requisites.registration_date).format('DD.MM.YYYY');
        vm.date = moment(vm.company.organization.legal_requisites.registration_date);
      }
      vm.hideBlock = true;
      for(var ind in vm.company.organization.legal_requisites){
        if(ind != 'legal_status' && vm.company.organization.legal_requisites[ind]){
          vm.hideBlock = false;
          break;
        }
      }
      if (vm.company.organization && vm.company.organization.legal_requisites) {
        vm.company.organization.legal_requisites.registration_date = vm.company.organization.legal_requisites.registration_date || null;
      }
      // для правильного формата даты регистрации
      $timeout(function(){
        vm.company.organization.legal_requisites.registration_date = tempDate;
      },0);
      vm.onDatePickerClose2 = function(returnValue, name) {
        vm.company.organization.legal_requisites.registration_date = returnValue && !returnValue.isEmpty ? returnValue.valueOf(): null;
      };

      function legalRequisitesIsFilled() {
        return !!vm.company.organization.legal_requisites.kpp || !!vm.company.organization.legal_requisites.full_name ||
         !!vm.company.organization.legal_requisites.legal_address || !!vm.company.organization.legal_requisites.short_name ||
          !!vm.company.organization.legal_requisites.ogrn || !!vm.company.organization.legal_requisites.okpo
      }

      function openConfirmDialog() {
        return modalAskSrv.showModal({
          title: 'По вашему ИНН мы можем заполнить остальные реквизиты компании. Возможно они не совпадут с тем, что вы уже ввели. Изменить информацию?'
        })
      }

      function getLegalRequisitesInfo() {
        utilsService.getCompanyInfo(vm.company.organization.legal_requisites.inn).then(function(res) {
          var item = res.data[0];
          vm.company.organization.legal_requisites.kpp = item.kpp;
          vm.company.organization.legal_requisites.full_name = item.full_name_with_opf;
          vm.company.organization.legal_requisites.legal_address = {
            address_as_string: item.address
          };
          vm.company.organization.legal_requisites.short_name = item.short_name_with_opf;
          vm.company.organization.legal_requisites.ogrn = item.ogrn;
          vm.company.organization.legal_requisites.okpo = item.okpo;
          vm.company.organization.legal_requisites.okved = item.okved;
          vm.date = parseInt(item.ogrn_date);

          $timeout(function () {

            if (vm.triggerOkvedUpdate) {
              vm.triggerOkvedUpdate()
            }
            // вызов экспортируемого метода директивы адреса для установления связи с объектом бекенда
            vm.addressOptions.checkAddr(vm.company.organization.legal_requisites.legal_address.address_as_string);
          }, 0);
        });
      }

      vm.onInnFill = function() {
        if (vm.company.organization.legal_requisites.inn) {
          if (legalRequisitesIsFilled()) {
              openConfirmDialog().then(function() {
                getLegalRequisitesInfo();
              });
            return;
          }
          getLegalRequisitesInfo()
        }
      }

    }
  }
}) ();

/**
 * Created by aivanov on 21.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('accountCompany', accountCompany);

  /**
   * Директива для отображения одного типа подразделений компании
   */
  function accountCompany() {
    return {
      require: '^form',
      restrict: 'E',
      templateUrl: 'app/settings/templates/companies/accounts/accounts.html',
      bindToController: true,
      scope: {
        /* Сущность компании в которую маппятся нужные для счетов свойства */
        company: '=',
        stateName: '@',
        mode: "<"
      },
      link: function(scope, element, attrs, form) {
        scope.parentForm = form;
      },
      controller: accountCompanyController,
      controllerAs: 'vm'
    }

    function accountCompanyController($scope,$timeout, personsDataSrv, $log, uiSelectStructure, currenciesService, utilsService) {
      var vm = this;

      if(!vm.company.organization.accounts){
        vm.company.organization.accounts = [];
      }

      /* Реакция на кнопку добавления нового счета */
      vm.addAccount = function() {
        vm.company.organization.accounts.push({
          name: (vm.company.organization.accounts.length)? 'Новый счет' : 'Банковский счет'
        });
        if(vm.company.organization.accounts.length == 2){
          vm.company.organization.accounts[0].main = true;
        }
        $timeout(function(){
          vm.reCalcScroll();
          vm.checkUnique();
          vm.selectTab(vm.company.organization.accounts.length - 1);
        },0);
      }

      vm.removeAccount = function(id, event){
        event.preventDefault();
        vm.selectTab(id - 1);
        for(var i in vm.company.organization.accounts){
          if(i == id){
            vm.company.organization.accounts.splice(i ,1);
            break;
          }
        }
        if(vm.company.organization.accounts.length == 1){
          vm.company.organization.accounts[0].main = false;
        }
        vm.reCalcScroll();
      };

      vm.changeMainAccount = function(id){
        for(var i in vm.company.organization.accounts){
          if(i == id){
            vm.company.organization.accounts[i].main = true;
          }else{
            vm.company.organization.accounts[i].main = false;
          }
        }
      };

      vm.getBankInfo = function ($event, model) {
        var account = vm.company.organization.accounts[ parseInt($event.target.name.match(/\d/)[0]) ];
        function setValue(bankName,corr_acc){ account.bank = bankName; account.corr_account = corr_acc;}
        if (model) {
          utilsService.getBankInfo(model)
          .then(function (res) {
            if (res.data.length > 0) {
              setValue(res.data[0].name.replace(/&quot;/g, '"'), res.data[0].correspondent_account);
            } else {
              setValue('', '');
            }
          })
          .catch(function (err) {
            setValue('','');
            $log.log(err);
          });
        }
      };

      vm.checkUnique = function () {
        var errorInd = [];
        _.forEach(vm.company.organization.accounts, function (acc1, key1) {
          vm.accoutnsForm['accName' + key1].$setValidity('unique', true);
          _.forEach(vm.company.organization.accounts, function (acc2, key2) {
            if(acc1.name && acc2.name && key1 < key2 && acc1.name == acc2.name){
              errorInd.push(key1);
              errorInd.push(key2);
            }
          });
        });
        
        _.forEach(errorInd, function (errIndex) {
          vm.accoutnsForm['accName' + errIndex].$setValidity('unique', false);
        });
      }

      vm.currencies = uiSelectStructure.getStructure(currenciesService.getDomainCurrenciesSearch);

      vm.scrlTabsApi = {};
      vm.reCalcScroll = function() {
        if(vm.scrlTabsApi.doRecalculate) {
          vm.scrlTabsApi.doRecalculate();
        }else{
          vm.scrlTabsApi = {};
        }
      };

      vm.scrollIntoView = function(arg) {
        if(vm.scrlTabsApi.scrollTabIntoView) {
          vm.scrlTabsApi.scrollTabIntoView();
        }
      };
      $timeout(function() {vm.reCalcScroll()}, 2000);


      vm.activeCount = vm.activeCount || 0;
      
      vm.selectTab = function(index) {
        vm.activeCount = index;
        vm.scrollIntoView();
      };


    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('priceTagView', priceTagView);

  function priceTagView() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/priceTagsSettings/directives/priceTagView/price-tag-view.html',
      scope: {
        config: '<',
        showSize: '<'
      }
    }
  }
}) ();

(function() {
  'use strict';

  angular
  .module('frontend')
  .directive('priceTagPrint', priceTagPrint);

  function priceTagPrint() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/priceTagsSettings/directives/priceTagPopup/price-tag-button.html',
      scope: {
        config: '<',
        forService: '<',
        catalogItems: '<',
        asButton: '<?',
        root: '<?'
      },
      controller: function($scope, $uibModal, currenciesService, downloadSrv){
        var parentScope = $scope;
        currenciesService.getDomainCurrencies().then(function(res) {
          angular.forEach(res.data.items, function(item) {
            if (item.home_currency) {
              $scope.homeCurrency = {
                id: item.currency.id,
                name: item.currency.name,
                char_iso_code: item.currency.char_iso_code,
                symbol: item.currency.symbol
              };
            }
          });
        });

        $scope.printData = {};
        $scope.showPopup = function(){
          $uibModal.open({
            templateUrl: 'app/settings/priceTagsSettings/directives/priceTagPopup/price-tag-popup.html',
            size: 'middle-width',
            windowClass: 'more-zindex',
            resolve: {
              items: function() {
                return parentScope.catalogItems
              },
              homeCurrency: function() {
                return parentScope.homeCurrency
              }
            },
            controller: function ($scope,
                                  API_URL,
                                  $uibModalInstance,
                                  $state,
                                  $timeout,
                                  print,
                                  items,
                                  companyService,
                                  uiSelectStructure,
                                  currenciesService,
                                  helpService,
                                  homeCurrency,
                                  authToken,
                                  statusSrv) {
              print.turnonInterceptorStatus();
              $scope.catalogItems = items;
              var ids = [];
              $scope.config = parentScope.config;
              $scope.datePickerOptions = {singleDatePicker: true, correctTimeZone: false, opens: 'right', minDate: helpService.now()};
              $scope.format = {type: 'PDF'};
              $scope.close = function () {
                $uibModalInstance.dismiss();
              };
              var currencies = [];
              function prepareArrayOfItems(array) { // Рекурсивная сортировка выделенных айтемов по типу
                angular.forEach(array, function(root) {
                  if (root.catalog_item && root.catalog_item.id) {
                    ids.push(root.catalog_item.id);
                  } else if (root.id) {
                    ids.push(root.id);
                  }
                  if (root.children && root.children.length > 0) {
                    angular.forEach(root.children, function(child) {
                      prepareArrayOfItems([child]);
                    })
                  }
                });
              }
              if (parentScope.root) {
                $scope.selectedItems = parentScope.root.getSelectionModel();
                prepareArrayOfItems($scope.selectedItems);
              }

              $scope.printData = {
                number_of_copies: 1,
                date: helpService.now()
              };

              $scope.currencies = uiSelectStructure.getStructure(currenciesService.getDomainCurrenciesSearch);
              var currencyRefreshOriginal = $scope.currencies.refresh;
              $scope.currencies.refresh = function() {
                currencyRefreshOriginal().then(function () {
                  $scope.currencies.field.items = $scope.currencies.field.items.filter(function (currency) {
                    return ~currencies.indexOf(currency.id);
                  })
                })
              };

              $scope.longRequest = {
                format: null,
                exec_id: null,
                crudState: helpService.getCrudStateStructure(),
                flags: {
                  processStart: false,
                  finish: false
                },
                stopAskingError: function(){
                  $scope.longRequest.flags.processStart = false;
                  $scope.longRequest.flags.finish = true;
                  $scope.longRequest.flags.error = true;
                  $scope.longRequest.crudState.stopLoadingFailure();
                  print.turnoffInterceptorStatus();
                },
                onError: function(err) {
                  if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
                    $scope.longRequest.revert();
                  } else {
                    $scope.longRequest.stopAskingError();
                  }
                },
                revert: function() {
                  $scope.longRequest.format = null;
                  $scope.longRequest.cancelled = false;
                  $scope.longRequest.exec_id = null;
                  $scope.longRequest.crudState.stopLoadingSuccess();
                  $scope.longRequest.flags.processStart = false;
                  $scope.longRequest.flags.finish = false;
                }
              };

              $scope.print = function () {
                $scope.printData.division = {
                  id: $scope.printData.division.id,
                  name: $scope.printData.division.name
                };
                $scope.longRequest.crudState.startLoading();
                print.printTags({
                  division_id: $scope.printData.division.id,
                  effective_date: $scope.printData.date.valueOf(),
                  currency_id: $scope.currencies.value ? $scope.currencies.value.id : homeCurrency.id,
                  number_of_copies: $scope.printData.number_of_copies || 1,
                  catalog_items: !!$scope.selectedItems ? ids : [$scope.catalogItems[0].id],
                  print_old_price: !!$scope.printData.print_old_price,
                  print_discount_price: !!$scope.printData.print_discount_price
                }).then(function(res) {
                  $scope.longRequest.exec_id = res.data.exec_id;
                  statusSrv.getPromise('/print_report/executions/' + $scope.longRequest.exec_id + '/status').then(function (res) {
                      $scope.longRequest.flags.finish = true;
                      print.turnoffInterceptorStatus();
                      $timeout(function() {
                        downloadSrv.getPromise('/print_report/executions/' + $scope.longRequest.exec_id + '/output').then(function(){
                          $scope.longRequest.crudState.stopLoadingSuccess();
                          $timeout(function() {
                            $uibModalInstance.dismiss();
                          }, 300, false)
                        });
                      });
                  },$scope.longRequest.onError);
                }).catch($scope.longRequest.onError);
              };


              companyService.divisions({limit: 200}, undefined, undefined, undefined, true).then(function(res){
                $scope.divisions = res.data.items;
                $scope.divisionsTotal = res.data.total;
                if ($scope.divisions.length === 1) {
                  $scope.printData.division = $scope.divisions[0];
                  $scope.divisionSelected($scope.printData.division)
                }
              });

              $scope.goToPriceTagsSettings = function() {
                $uibModalInstance.dismiss();
                $state.go('priceTagsSettings', {parent: 'retail'});
              }



              $scope.divisionSelected = function(division) {
                currencies = [];
                if (division && division.cash_registers && division.cash_registers.length > 0) {
                  angular.forEach(division.cash_registers, function(cash_register) {
                    if (cash_register.currency && currencies.indexOf(cash_register.currency.id) < 0) {
                      currencies.push(cash_register.currency.id)
                    }
                  });
                  $scope.showCurrencySelect = currencies.length > 1;
                  if (currencies.length === 1) { // выбирается одна валюта , если она одна
                    $scope.currencies.value = {id: currencies[0]};
                  }
                } else {
                  $scope.showCurrencySelect = false;
                  $scope.currencies.value = null;
                }

              }


            }
          })
        };

        /*
        name товара
        колчество позиций
         */
      }
    }
  }
}) ();

'use strict';
angular.module('frontend').component('orderPopup', {
  templateUrl: 'app/settings/paid-services/includes/order-popup/order-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function (encashmentsService) {
    var orderPopupCtr = this;
    orderPopupCtr.companies = orderPopupCtr.resolve.companies;
    orderPopupCtr.isOnline = orderPopupCtr.resolve.isOnline;
    orderPopupCtr.formError = false;
    orderPopupCtr.needReloadCompany = false;
    orderPopupCtr.userMailPhoneFlags = {};
    orderPopupCtr.orderObj = { email: orderPopupCtr.resolve.email };
    orderPopupCtr.isConfirmed = false;

    orderPopupCtr.close = function () {
      if (orderPopupCtr.userMailPhoneFlags.isPhone) {
        orderPopupCtr.orderObj.phone = orderPopupCtr.orderObj.email;
        orderPopupCtr.orderObj.email = undefined;
      }
      if (orderPopupCtr.isConfirmed) {
        orderPopupCtr.modalInstance.close({
          companies: orderPopupCtr.companies,
          orderObj: orderPopupCtr.orderObj
        });
      } else {
        orderPopupCtr.modalInstance.close({ companies: orderPopupCtr.companies });
      }
    };

    orderPopupCtr.goToCompany = function () {
      orderPopupCtr.needReloadCompany = true; 
      orderPopupCtr.companyError = false;
    }

    orderPopupCtr.onChangeEmail = function () {
      orderPopupCtr.formError = orderPopupCtr.orderForm.$invalid;
    }

    orderPopupCtr.confirm = function () {
      var legal;
      // если форма не валидна вывести сообщение
      if (orderPopupCtr.orderForm.$invalid) {
        orderPopupCtr.formError = true;
        return;
      }

      if (orderPopupCtr.companies && orderPopupCtr.companies.length) {

        // если есть необходимость перепроверки данных компании
        // такая необходимость есть поле перехода на страничку компании
        if (orderPopupCtr.needReloadCompany) {
          orderPopupCtr.load = true;
          encashmentsService.companies().then(function (data) {
            orderPopupCtr.companies = data;
            orderPopupCtr.orderObj.company = _.find(orderPopupCtr.companies, function(company){
              return orderPopupCtr.orderObj.company.id == company.id;
            });
            orderPopupCtr.needReloadCompany = false;
            orderPopupCtr.load = false;
            orderPopupCtr.confirm();
            return
          });
          return;
        }

        // проверка обязательных полей в компании
        legal = orderPopupCtr.orderObj.company.organization.legal_requisites;
        // если ИП
        if (legal && legal.legal_status == "SOLE_TRADER" && (!legal.ogrn || !legal.inn || !legal.full_name || 
            !legal.legal_address || !legal.short_name)) {
          orderPopupCtr.companyError = true;
          return;
        }
        // если юр лицо
        if (legal && legal.legal_status == "LEGAL_ENTITY" && (!legal.kpp || !legal.inn || !legal.full_name || 
            !legal.legal_address || !legal.short_name)) {
          orderPopupCtr.companyError = true;
          return;
        }
      }

      orderPopupCtr.isConfirmed = true;
      orderPopupCtr.close();
      
    };

  }
});

'use strict';
angular.module('frontend').component('extendSubscribePopup', {
  templateUrl: 'app/settings/paid-services/includes/extend-subscribe-popup/extend-subscribe-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($state, requestStatus, paidServicesService, print, helpService, statusSrv, downloadSrv, $timeout) {
    var extendSubscribeCtrl = this;
    extendSubscribeCtrl.id = extendSubscribeCtrl.resolve.serviceId;
    extendSubscribeCtrl.resolve_invoice_out_id = extendSubscribeCtrl.resolve.invoice_out_id;
    print.turnonInterceptorStatus();
    extendSubscribeCtrl.numberOfMonthsObj = [{
      name: "3 месяца",
      id: 3,
    },
    {
      name: "6 месяцев",
      id: 6,
    },
    {
      name: "12 месяцев",
      id: 12,
    }];

    extendSubscribeCtrl.number_of_months = 12;

    extendSubscribeCtrl.close = function (res) {
      extendSubscribeCtrl.modalInstance.close(res);
    };

    extendSubscribeCtrl.confirm = function () {
      extendSubscribeCtrl.load = extendSubscribeCtrl.resolve.invoice_out_id != null;
      paidServicesService.extendSubscription(extendSubscribeCtrl.id, extendSubscribeCtrl.number_of_months).then(function (res) {
        extendSubscribeCtrl.new_id = res.data.id;
        if (res.data.invoice_out && res.data.invoice_out.id) {
          extendSubscribeCtrl.invoice_out_id = res.data.invoice_out.id;
          if (extendSubscribeCtrl.resolve.invoice_out_id){
            extendSubscribeCtrl.print();
          } else {
            if (extendSubscribeCtrl.resolve.callback){
              extendSubscribeCtrl.resolve.callback();
            }

            extendSubscribeCtrl.close();
          }
        } else {
          if (extendSubscribeCtrl.resolve.callback) {
            extendSubscribeCtrl.resolve.callback();
          }
          extendSubscribeCtrl.close(res);
        }
      });
    };

    extendSubscribeCtrl.longRequest = {
      format: "PDF",
      exec_id: null,
      crudState: helpService.getCrudStateStructure(),
      flags: {
        processStart: false,
        finish: false
      },
      stopAskingError: function () {
        extendSubscribeCtrl.longRequest.flags.processStart = false;
        extendSubscribeCtrl.longRequest.flags.finish = true;
        extendSubscribeCtrl.longRequest.flags.error = true;
        extendSubscribeCtrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function (err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          extendSubscribeCtrl.longRequest.revert();
        } else {
          extendSubscribeCtrl.longRequest.stopAskingError();
        }
        if (err.data && err.data.fields[0] && err.data.fields[0].error) {
          extendSubscribeCtrl.errorMessage = err.data.fields[0].error;
        } else {
          extendSubscribeCtrl.errorMessage = "При подготовке отчета произошла ошибка";
        }
        requestStatus.error('Во время продления подписки произошла ошибка. Повторите попытку позже.');
        extendSubscribeCtrl.modalInstance.close();
      },
      revert: function () {
        extendSubscribeCtrl.longRequest.format = null;
        extendSubscribeCtrl.longRequest.cancelled = false;
        extendSubscribeCtrl.longRequest.exec_id = null;
        extendSubscribeCtrl.longRequest.crudState.stopLoadingSuccess();
        extendSubscribeCtrl.longRequest.flags.processStart = false;
        extendSubscribeCtrl.longRequest.flags.finish = false;
      }
    };

    extendSubscribeCtrl.print = function () {
      if (!extendSubscribeCtrl.longRequest.flags.processStart && extendSubscribeCtrl.invoice_out_id) {
        extendSubscribeCtrl.longRequest.flags.processStart = true;
        extendSubscribeCtrl.processStart = true;
        extendSubscribeCtrl.longRequest.crudState.startLoading();
        print.prepareDocumentPrintForm("DPF_INVOICE_PAYMENT_OUT",
          extendSubscribeCtrl.invoice_out_id,
          {},
          "PDF").then(function (res) {
          extendSubscribeCtrl.longRequest.exec_id = res.data.exec_id;
          statusSrv.getPromise('/print_report/executions/' + extendSubscribeCtrl.longRequest.exec_id + '/status').then(function (res) {
            extendSubscribeCtrl.longRequest.flags.finish = true;
            print.turnoffInterceptorStatus();
            $timeout(function () {
              downloadSrv.getPromise('/print_report/executions/' + extendSubscribeCtrl.longRequest.exec_id + '/output').then(function () {
                extendSubscribeCtrl.longRequest.crudState.stopLoadingSuccess();
                $timeout(function () {
                  extendSubscribeCtrl.modalInstance.dismiss();

                  if (extendSubscribeCtrl.resolve.callback)
                    extendSubscribeCtrl.resolve.callback();

                  if (extendSubscribeCtrl.resolve.goToService)
                    $state.go('paidService', {id: extendSubscribeCtrl.new_id || extendSubscribeCtrl.id, subscription: true});
                }, 300, false);
              });
            });
          }).catch(extendSubscribeCtrl.longRequest.onError);
        }).catch(extendSubscribeCtrl.longRequest.onError);
      }
    };

    if (extendSubscribeCtrl.resolve_invoice_out_id) {
      extendSubscribeCtrl.load = true;
      extendSubscribeCtrl.invoice_out_id = extendSubscribeCtrl.resolve_invoice_out_id;
      extendSubscribeCtrl.print();
    }
  }
});
/**
 * Created by aivanov on 04.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('userRole', userRole);

  function userRole(rolesService) {
    var rolesMap = {};
    rolesService.roles().then(function (res) {
      angular.forEach(res.data, function(role){
        rolesMap[role.id] = role.name;
      });
    });
    return {
      restrict: 'EA',
      transclude: true,
      templateUrl: 'app/settings/employees/directives/user-role/user-role.html',
      scope: {
        role: '='
      },
      controller: function($scope){
        $scope.rolesMap = rolesMap;
      }
    }
  }
}) ();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('employeeCard', employeeCard);

  function employeeCard() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/employees/directives/employee-card/employee-card.html',
      bindings: {
        employee: '=',
        total: '=',
        roles: '='
      },
      link: function($scope, el, arg){
        $scope.txt = '';
        $scope.isAllCompanies = false;
        // отображать роли, только с флагом is_public
        arg.roles = _.filter(arg.roles, function (role) {
          return role.is_public;
        });
        $scope.roles = arg.roles;
        var companyStr = '',
            employee = JSON.parse(arg.employee);

        if(employee.companies.length == arg.total){
          $scope.txt = "все компании";
          $scope.isAllCompanies = true;
        }else{
          companyStr = (employee.companies.length < 5)? 'компании' : 'компаний';
          $scope.txt = employee.companies.length + " " + companyStr;
        }

      }
    }
  }
}) ();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('divisionTab', divisionTab);

  /**
   * Директива для отображения одного типа подразделений компании
   */
  function divisionTab() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/employees/directives/division/divisions-tab.html',
      scope: {
        // Подразделения (передаётся указатель на все подразделения,
        // а не на отдельный список, пока нет причин разделять списки
        // и можно работать с единым массивом фильтруя в директиве)
        divisions: '=',
        // Содержит информацию о вкладке, для которой примерняется директива, в частности - тип подразделения
        tab: '<',
        access: '=',
        state: '<'
      },
      controller: divisionTabController
    }

    function divisionTabController($scope, $filter, $element) {
      var divisions = $filter('filter')($scope.divisions, {type: $scope.tab.type});
      $scope.$watch('access', function() {
        if ($scope.access) {
          // выбраны все подразделения, поставить дизейбл чекбоксов и разрешить доступ
          angular.forEach(divisions, function(division){
            division.has_access = true;
            division.$$disable_access_to_places = false;
          });
          $scope.checkAllDivision();
        }else{
          // выбраны не все подразделения, убрать дизейбл чекбоксов
          angular.forEach(divisions, function(division){
            division.$$disable_access_to_places = !division.has_access;
          });
        }
      }, true);

      $scope.changeAccessToKKM = function (division) {
        division.$$disable_access_to_places = !division.has_access;
        if (!division.has_access) {
          division.has_access_to_cash_register_places = false;
          $scope.all = false;
        }
        $scope.changeAccessToPlaces(division);
      }

      $scope.selectAll = function () {
        angular.forEach(divisions,function (division) {
          division.has_access = $scope.all;
          $scope.changeAccessToKKM(division)
        })
      }

      $scope.changeAccessToPlaces = function(division){
        angular.forEach(division.cash_register_access_rules, function(place){
          place.has_access = division.has_access_to_cash_register_places;
        });
      }

      $scope.checkAllDivision = function(){
        var isAll = true;
        angular.forEach($filter('filter')(divisions, {type: $scope.tab.type}), function(division){
          if(!division.has_access){
            isAll = false;
          }
        });
        $scope.all = isAll;
      }
      $scope.checkAllDivision();

    }
  }
}) ();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('division', division);

  /**
   * Директива для работы с подразделениями одной компании
   */
  function division() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/employees/directives/division/divisions-access.html',
      scope: {
        // Подразделения TODO: взможно, потребуется информация о всей компании
        divisions: '=',
        // Родительская компания для подразделений
        company: '=',
        // Вкладки с типами подразделений
        tabs: '=',
        // Вид странички
        state: '='
      },
      controller: divisionController
    }
    function divisionController($scope, $filter) {
      $scope.activeTab = 0;
      $scope.height = 0;

      if ($scope.state.indexOf('view') + 1) {
        $scope.divisions = _.filter($scope.divisions, function (division) {
          return division.has_access;
        });
        $scope.allAccess = true;
        _.forEach($scope.divisions, function (division) {
          if(!division.has_access || !division.has_access_to_cash_register_places) {
            $scope.allAccess = false;
          }
        });
      }

      angular.forEach($scope.tabs, function(tab, key){
        var divisionLength = $filter('filter')($scope.divisions, {type: tab.type}).length;
        if(divisionLength){
          if(!$scope.activeTab) $scope.activeTab = key + 1;
          if($scope.height < divisionLength) $scope.height = divisionLength;
        }
      });

    }
  }
}) ();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('divisionTabCompany', divisionTab);

  /**
   * Директива для отображения одного типа подразделений компании
   */
  function divisionTab() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/companies/directives/divisions-tab/divisions-tab.html',
      scope: {
        // Подразделения (передаётся указатель на все подразделения,
        // а не на отдельный список, пока нет причин разделять списки
        // и можно работать с единым массивом фильтруя в директиве)
        divisions: '=',
        // Содержит информацию о вкладке, для которой примерняется директива, в частности - тип подразделения
        tab: '=',
        // Содержит id компании для перехода в подразделение
        companyId: '='
      },
      controller: divisionTabController
    }

    function divisionTabController($scope, $filter, $state) {
      $scope.divisions = $filter('filter')($scope.divisions, {type: $scope.tab.type});
      // Обратный вызов для выбора строки (галочка)
      var callbackRowSelected = function(row) {
          row.entity.has_access = row.isSelected;
      }

      // Передаётся массив выбранных строк
      var callbackRowBatchSelected = function(rows) {
        // Вызываем для всех строк установку значения в сущность
        angular.forEach(rows, function (row) {
          callbackRowSelected(row);
        })
      }

      // Установка выбранных объектов при рендеринге таблицы
      var onRowsRendered = function(gridApi) {
        gridApi.grid.rows.forEach(function(row) {
          if (row.entity.has_access) {
            // Устанавливается через сущность
            gridApi.selection.selectRow(row.entity);
          }
        });
      };

      $scope.goToView = function(id){
        $state.go('division.view',{divisionId: id, companyId: $scope.companyId, parent: 'business' });
      };

      // Настройка табличного представления
      var pencil = '<a ng-if="$root.hasRole(\'division.write\')" ui-sref="division.edit({divisionId: row.entity.id, companyId: \''+$scope.companyId+'\', parent: \'business\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать" ng-click="grid.appScope.showForm(grid, row)"></span></a>';
      $scope.gridOptions = {
        onRegisterApi: function (gridApi) {
          $scope.gridApi = gridApi;
          // gridApi.selection.on.rowSelectionChanged($scope, callbackRowSelected);
          // gridApi.selection.on.rowSelectionChangedBatch($scope, callbackRowBatchSelected);
          // gridApi.core.on.rowsRendered($scope, onRowsRendered);
        },
        rowTemplate: '<div ng-click="grid.appScope.goToView(row.entity.id);">' +
                      ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
                     '</div>',
        columnDefs: [
          { name: 'name', displayName: 'Наименование', minWidth: 200},
          { name: 'address.address_as_string', displayName: 'Адрес', minWidth: 200},
          { name: 'cash_registers', cellTemplate: 'cashTemplate.html', displayName: 'ККМ', minWidth: 200},
          { name: 'option', cellTemplate: pencil, displayName: '', enableColumnMenu:false, enableSorting:false, enableFiltering: false,enableHiding:false, width: 40}
        ],
        data: $scope.divisions
      };
    }
  }
}) ();

/**
 * Created by aivanov on 12.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('companyCard', companyCard);

  function companyCard() {
    return {
      restrict: 'E',
      templateUrl: 'app/settings/companies/directives/company-card/company-card.html',
      bindings: {
        company: '<'
      },
      controller: function ($scope) {
        $scope.phones = [];
        $scope.mails = [];
        if ($scope.company && $scope.company.contact_info) {
          angular.forEach($scope.company.contact_info.details, function(detail) {
            if(detail.type == 'PHONE' && detail.value){
              $scope.phones.push(detail.value);
            }
            if(detail.type == 'EMAIL' && detail.value){
              $scope.mails.push(detail.value);
            }
          });
        }

      }
    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service("taxModalSrv", function ($uibModal) {
        this.showModal = function (isCompany, viewType, mode, tax_modes_modified, taxs) {
          return $uibModal.open({
            templateUrl: 'app/settings/companies/crudCompanies/modals/tax-modal.html',
            controller: 'taxModalCtrl',
            controllerAs: 'taxModalCtrl',
            bindToController: true,
            size: 'small-width',
            resolve: {
              isCompany: function(){
                return isCompany; // режим компании или подразделения
              },
              viewType: function(){
                return viewType; // режим просмотра, удаления или редактирования попапа
              },
              mode: function(){
                return mode; // режим просмотра, добавления или редактирования странички
              },
              tax_modes_modified: function(){
                return tax_modes_modified;
              },
              taxs: function(){
                return taxs; // допустимые режимы налогообложения
              }
            }
          });
        }
    })
    .controller("taxModalCtrl", function ($scope, isCompany, viewType, mode, tax_modes_modified, taxs, $filter, $uibModalInstance) {
      var taxModalCtrl = this;
      taxModalCtrl.viewType = viewType;
      taxModalCtrl.taxs = taxs;
      taxModalCtrl.mode = mode;
      taxModalCtrl.isCompany = isCompany;
      taxModalCtrl.checkDateError = false;
      taxModalCtrl.tax_modes_modified = _.map(tax_modes_modified, function(tax){
        if(tax.end_date){
          tax.$$end_date = tax.end_date;
        }
        return tax;
      });
      taxModalCtrl.newTax = {};
      taxModalCtrl.today = moment().utc().startOf('day').valueOf();
      taxModalCtrl.fieldName = (isCompany)? 'tax_mode' : 'special_tax_mode';

      taxModalCtrl.configScroll = {
        autoHideScrollbar: false,
        theme: 'dark-thick',
        advanced: {
          updateOnContentResize: true
        },
        setHeight: 300,
        scrollInertia: 0
      };

      taxModalCtrl.tax_modes_modified.sort(function (a, b) {
        return b.start_date - a.start_date;
      }) // сортировка массива по возрастанию дат

      if(taxModalCtrl.viewType == 'change'){
        taxModalCtrl.startDate = moment().utc().startOf('day');
        taxModalCtrl.newTax.start_date = moment().utc().startOf('day').valueOf();
        if(taxModalCtrl.taxs.length == 1){
          taxModalCtrl.newTax[taxModalCtrl.fieldName] = taxModalCtrl.taxs[0].type;
        }
      }

      taxModalCtrl.close = function () {
        $uibModalInstance.close({
          currentTax: taxModalCtrl.currentTax,
          tax_modes_modified: taxModalCtrl.tax_modes_modified
        });
      };

      taxModalCtrl.onDatePickerClose = function (returnValue, name) {
        taxModalCtrl.checkDateError = false;
        taxModalCtrl.textError = '';
        if (name === 'start_date_edit' && !returnValue.isEmpty) {
          taxModalCtrl.newTax.start_date = returnValue.valueOf();
        }else if(name === 'end_date_edit' && !returnValue.isEmpty){
          taxModalCtrl.newTax.$$end_date = returnValue.valueOf();
        }
      };

      taxModalCtrl.getEndDateStr = function(start_date) {
        if(start_date){
          return moment(start_date).utc().subtract(1, 'day').valueOf();
        }
        return '';
      }

      function setCurrentTax(start_date, end_date, tax_mode) { // создает currentTax
        taxModalCtrl.currentTax = {
          start_date: start_date,
          $$end_date: end_date || undefined
        };
        taxModalCtrl.currentTax[taxModalCtrl.fieldName] = tax_mode;
      }

      function calluclateCurrentTax() { // расчет текущей системы налогооблажения и добавление свойства end_date
        var taxArr = taxModalCtrl.tax_modes_modified;
        taxModalCtrl.currentTax = undefined; // сброс переменной

        if(isCompany){ // автоматическое добавления конечной даты для налогооблажений компании
          angular.forEach(taxArr, function (tax_mode, i, tax_modes) { // вычисление текущей системы налогооблажения и добавление свойства end_date
            tax_mode.$$end_date = undefined;
            if (tax_modes[i + 1]) {
              if (tax_mode.start_date < tax_modes[i + 1].start_date) {
                tax_mode.$$end_date = moment.utc(tax_modes[i + 1].start_date).subtract(1, 'day').valueOf();
              }
            }
          });
        }

        angular.forEach(taxArr, function (tax_mode, index) {
          if (taxModalCtrl.today >= tax_mode.start_date || !taxModalCtrl.currentTax) {
            if((taxModalCtrl.today == tax_mode.start_date || taxModalCtrl.today == tax_mode.end_date || (taxModalCtrl.today > tax_mode.start_date && taxModalCtrl.today < tax_mode.end_date)) || // проверка действующего налога
              !index && !tax_mode.end_date && tax_mode.start_date < taxModalCtrl.today){ // проверка действует ли перевый налог без конечной даты
              tax_mode.$$current = true;
              setCurrentTax(tax_mode.start_date, 
                            tax_mode.$$end_date, 
                            tax_mode[taxModalCtrl.fieldName]);
            }
          }
        });
        taxModalCtrl.currentTax = taxModalCtrl.currentTax || taxModalCtrl.tax_modes_modified[taxModalCtrl.tax_modes_modified.length - 1]; // если сегодняшняя дата не вписывается в диапазоны существующих систем, показывается наиболее близкая к сегоднящнему дню
      }
      calluclateCurrentTax();


      taxModalCtrl.removeTaxMode = function (tax) {
        angular.forEach(taxModalCtrl.tax_modes_modified, function (tax_mode, i) {
          if (tax_mode.start_date === tax.start_date && tax_mode[taxModalCtrl.fieldName] === tax[taxModalCtrl.fieldName]) {
            taxModalCtrl.tax_modes_modified.splice(i, 1);
          }
        });
        if(!taxModalCtrl.tax_modes_modified.length){
          $uibModalInstance.close({
            currentTax: undefined,
            tax_modes_modified: []
          });
        }else{
          calluclateCurrentTax();
        }
      };

      taxModalCtrl.addTaxMode = function () {
        if (taxModalCtrl.editTaxForm && taxModalCtrl.editTaxForm.$invalid) {
          return;
        }
        //подготовка дат
        var newTaxMode = {
          start_date: taxModalCtrl.newTax.start_date,
          $$end_date: taxModalCtrl.newTax.$$end_date || undefined
        }
        newTaxMode[taxModalCtrl.fieldName] = taxModalCtrl.newTax[taxModalCtrl.fieldName];
        taxModalCtrl.checkDateError = false;
        if(checkValid(newTaxMode)){
          taxModalCtrl.tax_modes_modified.push(newTaxMode);
          calluclateCurrentTax();
          taxModalCtrl.close();
        }else{
          taxModalCtrl.checkDateError = true;
        }
      };

       // проверка уникальности дат, главное чтобы ни одна дата не входила в, уже существующий, диапазон
      function checkValid(new_tax_mode){
        if(new_tax_mode.start_date > new_tax_mode.$$end_date){
          taxModalCtrl.textError = "Дата окончания действия спецрежима должна быть позднее даты начала";
          return false;
        }
        return !_.find(taxModalCtrl.tax_modes_modified, function (tax_mode, i) {
          if(isCompany){ // для компании уникальными должны быть только start_date
            if(new_tax_mode.start_date == tax_mode.start_date){
              return tax_mode;
            }
          }else{
            // проверка не входят ли новые даты в диапазон уже заданных дат или не совпадают ли
            if(tax_mode.$$end_date){// если это промежуток
              if((new_tax_mode.start_date >= tax_mode.start_date && new_tax_mode.start_date <= tax_mode.$$end_date) || 
              (new_tax_mode.$$end_date >= tax_mode.start_date && new_tax_mode.$$end_date <= tax_mode.$$end_date)){ // проверяем совпадения в диапазонах
                return tax_mode;
              }
            }else{// если это только дата начала
              if(new_tax_mode.start_date == tax_mode.start_date || new_tax_mode.$$end_date == tax_mode.start_date){
                return tax_mode;
              }
            }
            // проверка не входят ли даты из общего списка в диапазон новой
            if(new_tax_mode.$$end_date){ // если новая дата - не диапазон, то точно не входят, раз до сюда дошло
              if(tax_mode.$$end_date){// если это промежуток (это другие проверки)
                if((tax_mode.start_date >= new_tax_mode.start_date && tax_mode.start_date <= new_tax_mode.$$end_date) || 
                (tax_mode.$$end_date >= new_tax_mode.start_date && tax_mode.$$end_date <= new_tax_mode.$$end_date)){ // проверяем совпадения в диапазонах
                  return tax_mode;
                }
              }else{
                if((tax_mode.start_date >= new_tax_mode.start_date && tax_mode.start_date <= new_tax_mode.$$end_date) ||
                  tax_mode.start_date == new_tax_mode.start_date  || tax_mode.start_date == new_tax_mode.$$end_date){
                  return tax_mode;
                }
              }
            }
          }
        });
      }

      
    })
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('singleMark', {
      bindings: {
        mark: '<',
        waybillId: '<',
        isset: '<'
      },
      templateUrl: 'app/egaisz/scan-marks/components/single-mark/single-mark.html',
      controllerAs: 'singleMarkCtrl',
      controller: function (
        egaiszFamService // сервис для работы с типами марок
      ) {
        var singleMarkCtrl = this;
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('simpleTree', simpleTree);

  /** @ngInject */
  function simpleTree() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/egaisz/scan-marks/components/simple-tree/simple-tree.html',
      controller: simpleTreeCtrl,
      bindToController: true,
      controllerAs: 'simpleTreeCtrl',
      scope: {
        root: '<',
        rootVisible: '<?',
        removeRow: '<?', // callback удаления строчки
        rowClickCallback: '<?' // callback при клике на cтрочку
      },
      link: function (scope, element, attrs) {
      }
    };
    return directive;

    function simpleTreeCtrl($scope, $q, $log, $timeout) {
      var simpleTreeCtrl = this;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('simpleTreeRow', simpleTreeRow);

  /** @ngInject */
  function simpleTreeRow() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/egaisz/scan-marks/components/simple-tree/simple-tree-row.html',
      controller: simpleTreeRowCtrl,
      bindToController: true,
      controllerAs: 'simpleTreeRowCtrl',
      scope: {
        item: '<',
        hideSelf: '<',
        removeRow: '<',
        level: '<',
        rowClickCallback: '<?' // callback при клике на cтрочку
      },
      link: function (scope, element, attrs) {
      }
    };
    return directive;

    function simpleTreeRowCtrl($scope, $q, $log, $timeout) {
      var simpleTreeRowCtrl = this;
      // флаг раскрытия дочерних
      simpleTreeRowCtrl.expanded = false;
    }
  }
})();

/**
 * Директива выделяет текст, введенный в инпуте по событию
 */
(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('selectByEvent', selectByEvent);

  /** @ngInject */
  function selectByEvent() {
    var directive = {
      restrict: 'A',
      scope: false,
      link: function (scope, element, attr) {
        // значение атрибута интерпретируется как название события, пустое значение недопустимо
        // также проверяется что элемент есть input или textarea
        if (attr.selectByEvent && (element[0].tagName == 'INPUT' || element[0].tagName == 'TEXTAREA')) {
          scope.$on(attr.selectByEvent, function () {
            element[0].setSelectionRange(0, element[0].value.length)
          });
        }
      }
    };
    return directive;

  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('markInput', markInput);

  /** @ngInject */
  function markInput() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      replace: false,
      link: function (scope, element, attrs, ngModelCtrl) {

        /**
         * Направление вывода модели в вид
         */
        ngModelCtrl.$parsers.push(function (value) {
          if (!value) {
            return;
          }

          // установка смещения в случае если есть пробелы до начала позиции
          var shift = value.length == 4 ? 1 : 0;//value.substring(0, element[0].selectionStart).split(' ').length - 1;

          // сохранение позиции курсора
          var start = element[0].selectionStart + shift;
          var end = element[0].selectionEnd + shift;

          ngModelCtrl.$viewValue = value.toString()
            .replace(' ', '') // убираем пробелы
            .replace(/[^\d]/g, '') // убираем все символы кроме цифр
            .replace(/(\d{0,11}).*/g, "$1") // убираем все кроме первой группы (не более 11 символов)
            .replace(/^(\d{3})(?=\d+)/g, "$1 "); // оставляем пробел только один после 3-й цифры
          ngModelCtrl.$render();

          // восстановление позиции курсора
          element[0].setSelectionRange(start, end);

          return value.toString().replace(' ', '');
        });

        element.on('keypress', function (e) {
          // разные браузеы испоьлзуют разные поля (event - глобальное событие в прототипе window)
          var charCode = (event.which) ? event.which : event.keyCode;

          if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
            return false;
          }

          return true;
        });
      }
    };
    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('scanMarksInfoBlock', {
      bindings: {
        level: '<',
        message: '<'
      },
      templateUrl: 'app/egaisz/scan-marks/components/info-block/info-block.html',
      controllerAs: 'infoBlockCtrl',
      controller: function (
      ) {
        var infoBlockCtrl = this;
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('groupBox', {
      bindings: {
        mark: '<',
        waybillId: '<',
        promisses: '<',
        isset: '<', // флаг что марка уже просканирована
        onlyView: '<' // полько просмотр
      },
      templateUrl: 'app/egaisz/scan-marks/components/group-box/group-box.html',
      controllerAs: 'groupBoxCtrl',
      controller: function (
        $scope,
        $uibModal,
        egaiszService, // сервис для работы с ЕГАИС
        userSettingsService // сервис для работы со сторой
      ) {
        var groupBoxCtrl = this;
        groupBoxCtrl.scanAll = userSettingsService.loadProperty('invoiceWaybillCtrl', 'scanGroup', 'scanAll');

        groupBoxCtrl.init = function () {
          // подсчет количества марок - общее и отсканировнных
          groupBoxCtrl.totalMarks = (groupBoxCtrl.mark.amcs)? groupBoxCtrl.mark.amcs.length : 0; // начало высчитывания сколько всего марок
          groupBoxCtrl.totalAcceptedMarks = _.filter(groupBoxCtrl.mark.amcs, function(mark){ // вычисление количества принятых марок
            return mark.accepted;
          }).length;

          function getTotals(mark){
            _.forEach(groupBoxCtrl.mark.children_box_num, function(child){
              groupBoxCtrl.totalMarks += child.amcs.length; // учитывается и количество марк внутренних упаковок
              groupBoxCtrl.totalAcceptedMarks += _.filter(child.amcs, function(mark){ // вычисление количества принятых марок и во внутренних упаковках
                return mark.accepted;
              }).length;
              if(child.children_box_num){
                getTotals(child.children_box_num);
              }
            });
          }
          getTotals(groupBoxCtrl.mark);

          
          // если установлен флаг сканирования автоматически, то пинятые сразу устанавливаются
          if (groupBoxCtrl.scanAll) {
            groupBoxCtrl.totalAcceptedMarks = groupBoxCtrl.totalMarks;
          }
        }

        $scope.$watch('groupBoxCtrl.mark', function(newVal) {
          if (newVal) {
            groupBoxCtrl.init();
          }
        }, true);

        /**
         * Метод принимает все марки текущей групповой упаковки
         */
        groupBoxCtrl.approveAll = function () {
          $uibModal.open({
            templateUrl: 'app/egaisz/scan-marks/components/group-box/approve-modal.html',
            size: 'small-width',
            windowClass: 'more-zindex',
            controller: function ($scope, $uibModalInstance) {
              $scope.scanAll = false;
              $scope.close = function() {
                $uibModalInstance.dismiss();
              };
              $scope.accept = function() {
                groupBoxCtrl.totalAcceptedMarks = groupBoxCtrl.totalMarks;
                // запомним флаг принимать ли все упаковки без предупреждения
                userSettingsService.saveProperty('invoiceWaybillCtrl', 'scanGroup', 'scanAll', $scope.scanAll);
                // разрешение внешнего промисса
                groupBoxCtrl.promisses.deferred.resolve('GROUP');
                $uibModalInstance.dismiss();
              };
            }
          });
        };

        // настройка скролла
        groupBoxCtrl.configScroll = {
          axis:'y',
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced:{
            updateOnContentResize: true
          },
          setHeight: 240,
          scrollInertia: 0,
          scrollButtons: {
            enable: false // enable scrolling buttons by default
          }
        }



      }
    });
})();

(function () {
  'use strict';

	angular.module('frontend').service('gridSettingsService', gridSettingsService);

  function gridSettingsService(userSettingsService) {

    // Получение приоритета выводимых колонок
    this.getColumnPriority= function(docType, gridCode) {
      return userSettingsService.loadProperty(docType, gridCode, "columns");
    }

    // Установка приоритета выводимых колонок
    this.setColumnPriority = function(docType, gridCode, priority) {
      return userSettingsService.saveProperty(docType, gridCode, "columns", priority);
    };

    // Возвращает колонки с учетом настроек приоритета и видимости
    this.getColumnWithPriority = function(columnsExternal, docType, gridCode) {
      var columns = _.clone(columnsExternal); // копия нужна, т.к. алгоритм чистит элементы списка
      var result = [];
      var settingColumns = this.getColumnPriority(docType, gridCode);
      if(!settingColumns){
        return columns;
      }

      while(columns.length) {
        // блок необходим для вывода колонок, которых нет в списке колонок из настроек (или для служебных колонок без field)
        if (!columns[0].field || !~_.findIndex(settingColumns, function (settingsColumn) {
            return settingsColumn.code == columns[0].field.code;
          })) {
          result.push(columns[0]);
          columns.splice(0, 1);
          continue;
        }
        while (settingColumns.length) {
          var indexColumn =_.findIndex(columns, function (column) {
            return column.field && (column.field.code == settingColumns[0].code);
          });
          // очищаем колонку из настроек вне зависимосте от того, найдена ли реальная колонка
          var settingColumn = settingColumns.splice(0, 1);
          if (~indexColumn) {
            columns[indexColumn].column_visible = settingColumn[0].column_visible;
            result.push(columns[indexColumn]);
            columns.splice(indexColumn, 1);
            break;
          }
        }
      }
      return result;
    };
  }

})();


(function() {
  'use strict';

angular.module('frontend').controller('gridSettingsController', gridSettingsController);

  function gridSettingsController($scope,
                                  $state,
                                  gridSettingsService,
                                  columns,
                                  docType,
                                  metadata,
                                  $uibModalInstance) {
    var gridSettingsCtrl = this;
    // колонки текущего грида
    gridSettingsCtrl.columns = columns;

    // отсортированные
    gridSettingsCtrl.columnsSorted = gridSettingsService.getColumnWithPriority(
      columns,
      docType,
      metadata.code);

    // отфильтрованные колонки (доступные для изменений видимости и порядка)
    gridSettingsCtrl.columnsFiltered = _.filter(gridSettingsCtrl.columnsSorted, function (item, $index) {
      return item.name && $index && item.visible;
    });

    // упрощенная модель колонок
    gridSettingsCtrl.simpleColumns = _.map(gridSettingsCtrl.columnsFiltered, function (item, $index) {
      return {
        column_visible: item.column_visible,
        name: item.name
      };
    });

    gridSettingsCtrl.cancel = function() {
      $uibModalInstance.dismiss();
    };

    /* настройки по умолчанию */
    gridSettingsCtrl.default = function () {
      gridSettingsService.setColumnPriority(
        docType,
        metadata.code,
        gridSettingsCtrl.getStructuredObj(gridSettingsCtrl.columnsFiltered, metadata.fields)
      );
      $uibModalInstance.close();
    };

    /**
     * Получить структурированный массив колонок, для установки приоритета выводимых колонок
     *
     * @param donor полная информация по колонкам, из элементов которой, строится новый амссив колонок
     * @param map мапер, по информации из которого, строится новый массив колонок
     *
     * @return новый массив колонок
     */
    gridSettingsCtrl.getStructuredObj = function(donor, map) {
      var newColumns = []; // временное хранилище для измененного порядка колонок
      _.forEach(map, function(column){
        var newColumn = _.find(donor, function(oldColumn){
          return column.name == oldColumn.name;
        });
        // необходимая струтура данных колонок для сохранения в сторе
        if(newColumn){
          newColumns.push({
            column_visible: column.column_visible,
            visible: newColumn.visible,
            code: newColumn.field.code,
            name: newColumn.name
          });
        }
      });
      return newColumns;
    }

    // /* сохранение */
    gridSettingsCtrl.save = function() {
      gridSettingsService.setColumnPriority(
        docType,
        metadata.code,
        gridSettingsCtrl.getStructuredObj(gridSettingsCtrl.columnsFiltered, gridSettingsCtrl.simpleColumns)
      );
      $uibModalInstance.close();
    };

    // for drag&drop
    var helpIndex, listCount;

    gridSettingsCtrl.listMoved = function (index, item, parent) {
      if(listCount < parent.length){
        if(helpIndex > index){
          parent.splice(index, 1)
        } else {
          parent.splice(index + 1, 1)
        }
      }
    };

    gridSettingsCtrl.dropCallback = function (index, item, external, type, parent){
      helpIndex = index;
      listCount = parent.length;
      parent.splice(index, 0, item)
    };

    // настройки для скролла
    gridSettingsCtrl.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced:{
        updateOnContentResize: true
      },
      setHeight: 383,
      scrollInertia: 0
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('documentGridUnique', documentGridUnique);

  /**
   * Директива для отображения блоков разметки документа
   */
  function documentGridUnique() {
    return {
      restrict: 'E',
      require: {
        form: '^',
        gridCustom: '^^',
        documentGrid: '^^'
      },
      bindToController: true,
      controllerAs: 'documentGridUniqueCtrl',
      scope: {
        uniqueField: '<', // строковый код поля
        uniqueIndex: '<', // код составного индекса
        values: '<', // значения текущей строки
        refs: '<' // массив полей составного индекса
      },
      link: function ($scope, element, ctrl, ctrls) {
        $scope.documentGridUniqueCtrl.formCtrl = ctrls.form;
        $scope.documentGridUniqueCtrl.gridCustomCtrl = ctrls.gridCustom;
        $scope.documentGridUniqueCtrl.documentGridCtrl = ctrls.documentGrid;
      },
      controller: function ($scope) {
        var documentGridUniqueCtrl = this;

        // метод устанавливает статус уникальности
        documentGridUniqueCtrl.recalculate = function () {
          var count = 0;

          var isValueSet = false;
          angular.forEach(documentGridUniqueCtrl.refs, function (ref) {
            isValueSet = isValueSet || !!documentGridUniqueCtrl.values[ref];
          });

          // если значение не установлено, ошибки валидации уникальности быть не должно
          if (isValueSet) {
            angular.forEach(documentGridUniqueCtrl.gridCustomCtrl.data, function (row) {
              var eqFlag = true;
              angular.forEach(documentGridUniqueCtrl.refs, function (ref) {
                if (!documentGridUniqueCtrl.checkEquals(row[ref] || null, documentGridUniqueCtrl.values[ref] || null)) {
                  // если хотя бы одно значение составного индекса не совпадает, флаг сбрасывается
                  eqFlag = false;
                }
              });
              if (eqFlag) {
                // все значения совпали
                count++;
              }
            });
          }
          // строки не фильтруются и сравниваются в т.ч. сами с собой, поэтому > 1, а не > 0
          if (count > 1) {
            if ($scope.documentGridUniqueCtrl.formCtrl[documentGridUniqueCtrl.uniqueField]) {
              $scope.documentGridUniqueCtrl.formCtrl[documentGridUniqueCtrl.uniqueField]
                .$setValidity("unique", false);
            }
          } else {
            if ($scope.documentGridUniqueCtrl.formCtrl[documentGridUniqueCtrl.uniqueField]) {
              $scope.documentGridUniqueCtrl.formCtrl[documentGridUniqueCtrl.uniqueField]
                .$setValidity("unique", true);
            }
          }
        };

        /**
         * Проверка на эквивалентность объектов учитывает специфику работы с объектами документов,
         * а именно, наличие идентификаторов. Если объекты имеют заполненные поля id - эквивалентности id хватает, чтобы говорить об
         * эквивалентности сущностей. Если id не заполнены - проверяется обычный equals.
         *
         * @param obj1
         * @param obj2
         */
        documentGridUniqueCtrl.checkEquals = function (obj1, obj2) {
          if (obj1 && obj2) {
            if (obj1.derivative && obj1.derivative.id && obj2.derivative && obj2.derivative.id) {
              // приоритет у идентификаторов дериватив
              return obj1.derivative.id === obj2.derivative.id;
            }
            if (obj1.id && obj2.id) {
              return obj1.id === obj2.id;
            }
          }
          return angular.equals(obj1, obj2);
        };

        // ожидаем событие для пресчета
        $scope.$on('uniqueDocument' + documentGridUniqueCtrl.uniqueIndex, function (event, data) {
          documentGridUniqueCtrl.recalculate();
        });

        // ожидаем изменений в переданной модели
        $scope.$watch('documentGridUniqueCtrl.values[documentGridUniqueCtrl.uniqueField]', function (newItemValue) {
          if (newItemValue != undefined) {
            // отправка события проверки уникальности в гриде
            documentGridUniqueCtrl.documentGridCtrl.sendUniqueEvent(documentGridUniqueCtrl.uniqueIndex);
          }
        });
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('specialTaxSettings', {
      templateUrl: 'app/components/widgets/implementations/special-tax-settings/special-tax-settings.html',
      controller: specialTaxSettingsController,
      controllerAs: 'specialTaxSettingsCtrl',
      bindings: {
      }
    });

  function specialTaxSettingsController() {
    var specialTaxSettingsCtrl = this;
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('specialTax', {
      templateUrl: 'app/components/widgets/implementations/special-tax/special-tax.html',
      controller: specialTaxController,
      controllerAs: 'specialTaxCtrl',
      bindings: {
        options: '<',
        callbacks: '='
      }
    });

  function specialTaxController() {
    var specialTaxCtrl = this;

    specialTaxCtrl.callbacks = {
      dismiss: function(){
      },
      save: function(){
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('derivativesTab', derivativesTab);

  /**
   * Директива для отображения одного типа дериватив
   */
  function derivativesTab() {
    return {
      restrict: 'E',
      templateUrl: 'app/catalog/modals/search-catalog-item/derivative-tab/derivative-tab.html',
      scope: {
        list: '=',
        // Содержит информацию о вкладке, для которой примерняется директива
        tab: '=',
        choiseCallback: '<'
      },
      controller: derivativesTabController
    }

    function derivativesTabController($scope, $filter, $element) {
      $scope.tabDerivatives = $filter('filter')($scope.list, {domain_sku_name: $scope.tab.title});
      // настройка скролла
      $scope.configScroll = {
        axis:'y',
        autoHideScrollbar: false,
        theme: 'dark-thick',
        advanced:{
          updateOnContentResize: true
        },
        setHeight: 450,
        scrollInertia: 0,
        scrollButtons: {
          enable: false // enable scrolling buttons by default
        }
      }

    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('alcoholCalendar', alcoholCalendar);

  /**
   * Директива для отображения календаря действия акции
   */
  function alcoholCalendar() {
    return {
      restrict: 'E',
      templateUrl: 'app/catalog/alcoholSettings/directives/calendar/calendar.html',
      scope: {
        settings: '=',
        formCtrl: '='
      },
      controller: alcoholCalendarController,
      controllerAs: 'vm'
    };

    function alcoholCalendarController($scope, $timeout, helpService) {
      var vm = this;
      vm.alcoholSettings = $scope.settings;
      vm.errorInd = [];
      vm.oldName = '';
      vm.days = ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"];
      vm.timetable = [
        {
          id: 'ANY_DAY',
          name: 'Ежедневно'
        },
        {
          id: 'WORKING_DAY_OFF',
          name: 'По будням и выходным'
        },
        {
          id: 'DAY_OF_WEEK',
          name: 'Индивидуально по дням'
        }
      ];
      vm.calendarsMode = [
        {
          id: 'interval',
          name: 'промежуток'
        },
        {
          id: 'not',
          name: 'не продавать'
        }
      ];
      //Temp для введенных ранне значений расписания
      vm.timetableTmp = {};

      angular.forEach(vm.alcoholSettings.calendars, function(calendar){
        helpService.addId(calendar);
        angular.forEach(calendar.calendar_items, function(item){
           helpService.addId(item);
        })
      })

      vm.datePickerOpts = {singleDatePicker: true, correctTimeZone: false, minDate: helpService.now()};
      vm.disabledDays = {};
      angular.forEach(vm.alcoholSettings.calendars, function(calendar) {
        helpService.addId(calendar);
        getDisabledDays(calendar);
        angular.forEach(calendar.calendar_items, function(calendar_item) {
          helpService.addId(calendar_item);
        });
      });

      function getDisabledDays(calendar, dateModel) {
        var filteredDays = calendar.calendar_items.filter(function(t) {
          return t.type === 'EXCEPTIONAL_DATE' &&
                  !!t.exceptional_date &&
                  (dateModel && dateModel.$valid || true)
        });
        if (!vm.disabledDays[calendar.$$uiid]) {
          vm.disabledDays[calendar.$$uiid] = [];
        }
        vm.disabledDays[calendar.$$uiid] = _.map(filteredDays, function(item) {
          if (item && !~vm.disabledDays[calendar.$$uiid].indexOf(item)) {
            return moment.utc(item.exceptional_date)
          }
        });
      }

      vm.onDatePickerClose = function (returnValue, name, item, calendar) {
        if (name && returnValue && !returnValue.isEmpty) {
          item.exceptional_date = returnValue.valueOf();
        } else if (returnValue && returnValue.isEmpty) {
          item.exceptional_date = null;
        }
        getDisabledDays(calendar, $scope.formCtrl[name]);
      };
      vm.scrlTabsApi = {};
      vm.reCalcScroll = function() {
        if(vm.scrlTabsApi.doRecalculate) {
          vm.scrlTabsApi.doRecalculate();
        }else{
          vm.scrlTabsApi = {};
        }
      };

      vm.scrollIntoView = function(arg) {
        if(vm.scrlTabsApi.scrollTabIntoView) {
          vm.scrlTabsApi.scrollTabIntoView(arg);
        }
      };
      $timeout(function() {vm.reCalcScroll()}, 2000);

      vm.activeCalendar = vm.activeCalendar || 1;
      
      vm.selectTab = function(index) {
        vm.activeCalendar = index + 1;
        vm.scrollIntoView();
      };
      // добавить исключение
      vm.addException = function(calendar){
        calendar.$$hasException = true;
        calendar.calendar_items.push({
          type: "EXCEPTIONAL_DATE",
          from_time: '08:00',
          to_time: '23:00',
          exceptional_date: null,
          $$mode: 'interval',
          $$uiid: helpService.stringGen()
        });
      };

      // удалить исключение
      vm.removeException = function(calendar, index){
        calendar.calendar_items.splice(index, 1);
        calendar.$$hasException = false;
        angular.forEach(calendar.calendar_items, function(item){
          if(item.type == 'EXCEPTIONAL_DATE'){
            calendar.$$hasException = true;
          }
        });
      };
      // добавить календарь
      vm.addCalendar = function(){
        vm.alcoholSettings.calendars.push({
            name: (!vm.alcoholSettings.calendars.length)? "Основной календарь" : "Календарь " + (vm.alcoholSettings.calendars.length + 1),
            $$uiid: helpService.stringGen(),
            $$type: 'ANY_DAY',
            $$hasException: false,
            calendar_items: [
              {
                type: "ANY_DAY",
                from_time: '08:00',
                to_time: '23:00',
                $$mode: 'interval',
                $$uiid: helpService.stringGen()
              }
            ]
        });
        vm.checkCalendarName();
        $timeout(function(){
          vm.reCalcScroll();
          vm.selectTab(vm.alcoholSettings.calendars.length - 1);
        },0);
      };
      // удалить календарь
      vm.removeCalendar = function(index, event){
        if (index == vm.alcoholSettings.calendars.length - 1) {
          vm.selectTab(1);
          event.preventDefault();
          event.stopPropagation();
        }
        var calendarName = vm.alcoholSettings.calendars[index].name;
        vm.alcoholSettings.calendars.splice(index, 1);
        angular.forEach(vm.alcoholSettings.companies, function(company){
          angular.forEach(company.division_links, function(division){
            if(division.calendar_name == calendarName){
              division.calendar_name = null;
            }
          });
        });
        vm.checkCalendarName();
      };
      // проверка имени календаря на уникальность
      vm.checkCalendarName = function(){
        vm.errorInd = [];
        angular.forEach(vm.alcoholSettings.calendars, function(calendar1, key1){
          angular.forEach(vm.alcoholSettings.calendars, function(calendar2, key2){
            if(calendar1.name && calendar2.name && key1 < key2 && calendar1.name == calendar2.name){
              vm.calendarUniqError = true;
              vm.errorInd.push(key1);
              vm.errorInd.push(key2);
            }
          });
        });
        if(vm.errorInd.length){
          $scope.formCtrl.$error.errorUnique = true;
          $scope.formCtrl.$valid = false;
        }else{
          if($scope.formCtrl) delete $scope.formCtrl.$error.errorUnique;
          if(_.isEmpty($scope.formCtrl.$error)) $scope.formCtrl.$valid = true;
        }
      };
      // для проверки изменилось ли имя календаря
      vm.changeName = function(calendar){
        if(vm.oldName !== calendar.name){
          angular.forEach(vm.alcoholSettings.companies, function(company){
            angular.forEach(company.division_links, function(division){
              if (calendar.id && division.$$uiid && calendar.id === division.$$uiid) {
                division.calendar_name = calendar.name
              }
            });
          });
        }
      };
      // изменить режим времени
      vm.changeMode = function(item){
        item.from_time = '08:00';
        item.to_time = '23:00';
        if(item.$$mode == 'not'){
          item.from_time = "00:00";
          item.to_time = "00:00";
        }
      };
      // проверка установленного времени
      vm.checkTime = function(item){
        if(item.type !== "ANY_DAY" && item.from_time == item.to_time && item.to_time == "00:00"){
          item.$$mode = 'not';
        }
        if (item.from_time && item.to_time && /\:/.test(item.from_time) && /\:/.test(item.to_time)) {
          var from_time =  moment.utc().set({'hour': item.from_time.split(':')[0], 'minute': item.from_time.split(':')[1]});
          var to_time = moment.utc().set({'hour': item.to_time.split(':')[0], 'minute': item.to_time.split(':')[1]});
          $scope.formCtrl['to' + item.$$uiid].$setValidity('lesserThenFrom', to_time > from_time);
        }
      };

      // изменение режима календаря
      vm.changeTimetable = function(calendar){
        var exception = [];
        var firstEntry = 0;
        if(!vm.timetableTmp[calendar.$$uiid]){
          vm.timetableTmp[calendar.$$uiid] = []
        }
        angular.forEach(calendar.calendar_items, function(item){
          if(item.type == 'EXCEPTIONAL_DATE'){
            exception.push(item);
          }else{
            if(!vm.timetableTmp[calendar.$$uiid][item.type]){ vm.timetableTmp[calendar.$$uiid][item.type] = [];
            }else if(firstEntry == 0){
              vm.timetableTmp[calendar.$$uiid][item.type] = [];
            }
            firstEntry ++;

            if (item.from_time && item.to_time && /\:/.test(item.from_time) && /\:/.test(item.to_time)) {
              var from_time =  moment.utc().set({'hour': item.from_time.split(':')[0], 'minute': item.from_time.split(':')[1]});
              var to_time = moment.utc().set({'hour': item.to_time.split(':')[0], 'minute': item.to_time.split(':')[1]});
              if(to_time < from_time){
                item.to_time = null;
              }
            }
            vm.timetableTmp[calendar.$$uiid][item.type].push(item);
          }
        });

        if(vm.timetableTmp[calendar.$$uiid][calendar.$$type] && vm.timetableTmp[calendar.$$uiid][calendar.$$type].length){
          calendar.calendar_items = vm.timetableTmp[calendar.$$uiid][calendar.$$type].slice(0);

        }else if(calendar.$$type == 'ANY_DAY'){
          calendar.calendar_items = [
            {
              type: "ANY_DAY",
              from_time: '08:00',
              to_time: '23:00',
              $$mode: 'interval',
              $$uiid: helpService.stringGen()
            }
          ];
        }else if(calendar.$$type == 'DAY_OF_WEEK'){
          calendar.calendar_items = [];
          for(var i = 0; i < 7; i++){
            calendar.calendar_items.push({
              type: "DAY_OF_WEEK",
              from_time: '08:00',
              to_time: '23:00',
              day_of_week: i,
              $$mode: 'interval',
              $$uiid: helpService.stringGen()
            });
          }
        }else if(calendar.$$type == 'WORKING_DAY_OFF'){
          if(vm.timetableTmp[calendar.$$uiid]["WORKING_DAY"] && vm.timetableTmp[calendar.$$uiid]["DAY_OFF"]){
            calendar.calendar_items = [vm.timetableTmp[calendar.$$uiid]["WORKING_DAY"][0], vm.timetableTmp[calendar.$$uiid]["DAY_OFF"][0]];
          }else{
            calendar.calendar_items =  [
              {
                type: "WORKING_DAY",
                from_time: '08:00',
                to_time: '23:00',
                $$mode: 'interval',
                $$uiid: helpService.stringGen()
              },
              {
                type: "DAY_OFF",
                from_time: '08:00',
                to_time: '23:00',
                $$mode: 'interval',
                $$uiid: helpService.stringGen()
              }
            ];
          }
        }
        calendar.calendar_items = calendar.calendar_items.concat(exception);
      }

    }
  }
}) ();

(function() {
  'use strict';

  angular.module('frontend').controller('crudProjectController', crudProjectController);

  function crudProjectController($scope, $stateParams, $state, $window, $uibModal, auth, projectsService, project, errorMessageService, utilsService, $log, cardHistory, $q, askDeleteSrv) {
    var projectCrudCtrl = this;

    // для возврата на предыдущую страницу
    projectCrudCtrl.returnToPage = function(){
      var prev = cardHistory.popStep('projectId', $stateParams.projectId) || {name: 'projects', param: {parent: 'money'}};
      $state.go(prev.name !== '' ? prev.name : 'projects', prev.param || {parent: 'money'});
    };

    projectCrudCtrl.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    }
    projectCrudCtrl.initData = function() {
      // Инициализация проекта
      if (project) {
        projectCrudCtrl.project = $.extend(true, {}, project);
      } else {
        projectCrudCtrl.project = {active: true};
      }
    }
    projectCrudCtrl.initData()

    projectCrudCtrl.resetData = function() {
      projectCrudCtrl.initData();
      $scope.addproject.$setPristine();
      projectCrudCtrl.returnToPage()
    }

    projectCrudCtrl.closeTab = function () {
      if ($stateParams.closeTab) {
        $window.close();
      }
    }

    // Метод, вызываемый при сохранении или изменении сотрудника
    projectCrudCtrl.save = function () {
      var deferred = $q.defer();
      if ($scope.addproject.$valid) {// проверка валидности формы
        if (projectCrudCtrl.project.id) {
          // Блок обновления
          return projectsService.updateProject(projectCrudCtrl.project).then(
            function () {
              project = projectCrudCtrl.project;
              projectCrudCtrl.closeTab();
              projectCrudCtrl.resetData();
            },
            function (error) {
              if(error.status != 403) errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
              return deferred.reject();
            }
          )
        } else {
          // Блок создания
          if(!projectCrudCtrl.project.name) return deferred.reject();;
          return projectsService.createProject(projectCrudCtrl.project).then(
            function () {
              projectCrudCtrl.closeTab();
              projectCrudCtrl.resetData();
            },
            function (error) {
              if(error.status != 403) errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
              return deferred.reject();
            }
          )
        }
      } else {
        $scope.addproject.name.$setDirty();
        projectCrudCtrl.isSetDirty = true;
        return $q.when();
      }

    }

    projectCrudCtrl.uniqueCheck = function(str){
      if(str || projectCrudCtrl.project.name){
        var obj = {
          "constraint_name": "PROJECT",
          "parameters": [
            {
              "name": "name",
              "value": str || projectCrudCtrl.project.name
            }
          ]
        }
        obj.id = projectCrudCtrl.project.id || null;
        utilsService.uniqueCheck(obj).then(function(){},
        function (error) {
          if(error.status == 409){
            angular.forEach(error.data.parameters, function(field){
              $scope.addproject[field.name].$setValidity('unique', false);
            });
          } else {
            $log.debug(error);
          }
        });
      }
    }

    /*
     * Метод, вызываемый при открытии попапа удаления проекта
     * @param item объект проекта для удаления
     */
    projectCrudCtrl.delete = function () {
      return askDeleteSrv.showAskDelete(
        projectCrudCtrl.project.name,
        "проект",
        "Невозможно удалить проект <strong>"+ projectCrudCtrl.project.name +"</strong>.<br>Для удаления проекта необходимо удалить все связанные с ним подразделения, договоры и документы.",
        projectCrudCtrl.project.id,
        projectsService.deleteProject
      ).then(function (data) {
        projectCrudCtrl.resetData();
      });
    }

    projectCrudCtrl.crud = function (status) {
      switch(status) {
        case 'save':
          return projectCrudCtrl.save();
          break;
        case 'delete':
          return projectCrudCtrl.delete();
          break;
        case 'return':
          projectCrudCtrl.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('project.edit', {parent: 'money'});
          return $q.when();
        default :
          return $q.when();
          break;
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('verificationWidget', {
      transclude: true,
      bindings: {
        options: '<', // параметры виджета
        callbacks: '=', // для настроек (сохранение и отмена)
        settingsmode: '<' // режим отображения настроек
      },
      templateUrl: 'app/settings/widgets/verificationWidget/verification-widget.html',
      controllerAs: 'verificationWidgetCtrl',
      controller: function ($scope, accountingService, $q, contractService, helpService, requestStatus, userSettingsService) {
        var verificationWidgetCtrl = this;
        var tomorrow = moment.utc(new Date()).add(1,'days').startOf('day').valueOf();
        verificationWidgetCtrl.youOwe = 0;
        verificationWidgetCtrl.weOwe = 0;
        verificationWidgetCtrl.documentsData = [];
        verificationWidgetCtrl.load = false;
        verificationWidgetCtrl.showCount = verificationWidgetCtrl.limit = 5;
        verificationWidgetCtrl.residue = 0;
        verificationWidgetCtrl.accountingCodes = ["60.01", "62.01", "66", "58.3", "76.09", "57.3"];

        // состояние скрытой/раскрытой деализации
        verificationWidgetCtrl.showData = userSettingsService.loadProperty('widget', 'showData', 'verification') || false;

        function _isNullValues(obj) {
          return obj.beginning_balance_credit === null &&
                 obj.beginning_balance_debit === null &&
                 obj.total_credit === null &&
                 obj.total_debit === null;
        }

        function debitCreditSumm(res, obj, isDebit) {
          if (isDebit) {
            res += obj.beginning_balance_debit + obj.total_debit;
          } else {
            res += obj.beginning_balance_credit + obj.total_credit;
          }
          return res;
        }



        accountingService.getPeriodDimTotal('CONTRACT', 
                                             verificationWidgetCtrl.options.contractId, 
                                             verificationWidgetCtrl.accountingCodes, 
                                             tomorrow, 
                                             tomorrow).then(function (res) {
          var debit = 0, credit = 0;
          verificationWidgetCtrl.someError = false;
          verificationWidgetCtrl.noPermissions = false;
          // проверка на то достаточно ли прав просматривать данные
          if (!_.find(res.data.items, function(item){
            return !_isNullValues(item);
          })) {
            mutualSettlementCtrl.noPermissions = true;
          }

          _.forEach(res.data.items, function(item){
            debit = debitCreditSumm(debit, item, true);
            credit = debitCreditSumm(credit, item, false);
          });

          verificationWidgetCtrl.youOwe = (debit / 100).toFixed(2); // Нам должен контрагент по договору
          verificationWidgetCtrl.weOwe = (credit / 100).toFixed(2); // Мы должны контрагенту по договору

          verificationWidgetCtrl.owe = verificationWidgetCtrl.youOwe - verificationWidgetCtrl.weOwe;
          verificationWidgetCtrl.isWeOweMain = verificationWidgetCtrl.owe < 0;
          verificationWidgetCtrl.owe = Math.abs(verificationWidgetCtrl.owe).toFixed(2);
        }, function (error) {
          verificationWidgetCtrl.someError = true;
          requestStatus.error('Произошла ошибка. Мы уже в курсе, и работаем над ее устранением. Попробуйте повторить действие спустя некоторое время.');
        });

        verificationWidgetCtrl.getData = function (reload, withSave) {
          if (withSave) {
            verificationWidgetCtrl.showData = !verificationWidgetCtrl.showData;
            userSettingsService.saveProperty('widget', 'showData', 'verification', verificationWidgetCtrl.showData);
          }
          if (!verificationWidgetCtrl.documentsData.length || reload) {
            verificationWidgetCtrl.documentsData = [];
            verificationWidgetCtrl.load = true;
            var params = {
              dimension_type: 'CONTRACT',
              dimension_id: verificationWidgetCtrl.options.contractId,
              account_codes: verificationWidgetCtrl.accountingCodes,
              limit: verificationWidgetCtrl.limit,
              sort_by: 'document_date',
              sort_order: 'desc'
            }
            accountingService.getTransactions(params).then(function (res) {
              var sumYouOwe = 0; // temp переменная Сумма операций Нам должны
              var sumWeOwe = 0; // temp переменная Сумма операций Мы должны
              verificationWidgetCtrl.someError = false;
              verificationWidgetCtrl.documentsData = res.data.items;


              _.forEach(verificationWidgetCtrl.documentsData, function(docData, docDataKey){
                var debit = 0, credit = 0;
                if(docData.debit_credit == 'DEBIT'){
                  debit = docData.home_amount;
                }
                if(docData.debit_credit == 'CREDIT'){
                  credit = docData.home_amount;
                }

                var tempYouOwe = debit.toFixed(2);
                var tempWeOwe = credit.toFixed(2);
                docData.isYourOwe = tempYouOwe >= tempWeOwe;
                docData.owe = (Math.abs(tempYouOwe - tempWeOwe)/100).toFixed(2);

                _.forEach(verificationWidgetCtrl.documentsData, function(doc, docKey){
                  if (docKey < docDataKey) {
                    if(doc.account_code == "60.01" &&
                       doc.debit_credit == "CREDIT" &&
                       (doc.document.document_purpose == 'CP_TO_SUPPLIER' || doc.document.document_purpose == 'NCP_TO_SUPPLIER')){
                      doc.isSecondDoc = true;
                    }
                    if(doc.account_code == "76.09" &&
                       doc.debit_credit == "CREDIT" &&
                       (doc.document.document_purpose == 'CP_OTHER' || doc.document.document_purpose == 'NCP_OTHER')){
                      doc.withoutCNI = true;
                    }
                    if((doc.account_code == "66" && doc.debit_credit == "CREDIT" &&
                       (doc.document.document_purpose == 'CP_OF_LOAN' || doc.document.document_purpose == 'NCP_OF_LOAN')) || 
                      (doc.account_code == "58.3" && doc.debit_credit == "DEBIT" &&
                       (doc.document.document_purpose == 'CR_FROM_BORROWER' || doc.document.document_purpose == 'NCR_FROM_BORROWER'))){
                      doc.percent = true;
                    }
                  }
                });
              });

              _.forEach(res.data.page_totals, function(total){
                if(total.debit_credit == 'DEBIT'){
                  sumYouOwe += (total.home_amount / 100);
                }
                if(total.debit_credit == 'CREDIT'){
                  sumWeOwe += (total.home_amount / 100);
                }
              });
              verificationWidgetCtrl.residue = (verificationWidgetCtrl.youOwe - verificationWidgetCtrl.weOwe - sumYouOwe + sumWeOwe).toFixed(2);
              verificationWidgetCtrl.isWeOwe = verificationWidgetCtrl.residue < 0;
              verificationWidgetCtrl.residue = Math.abs(verificationWidgetCtrl.residue);
              verificationWidgetCtrl.load = false;
            }, function (error) {
              verificationWidgetCtrl.someError = true;
              requestStatus.error('Произошла ошибка. Мы уже в курсе, и работаем над ее устранением. Попробуйте повторить действие спустя некоторое время.');
            });

          }
        }

        if (verificationWidgetCtrl.showData) {
          verificationWidgetCtrl.getData();
        }

        verificationWidgetCtrl.callbacks = {
          dismiss: function(){
            verificationWidgetCtrl.showCount = verificationWidgetCtrl.limit;
          },
          save: function(){
            verificationWidgetCtrl.limit = verificationWidgetCtrl.showCount;
            verificationWidgetCtrl.getData(true);
          }
        };



      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('stockWidget', {
      transclude: true,
      bindings: {
        options: '<', // параметры виджета
        callbacks: '=', // для настроек (сохранение и отмена)
        settingsmode: '<' // режим отображения настроек
      },
      templateUrl: 'app/settings/widgets/stockWidget/stock-widget.html',
      controllerAs: 'stockWidgetCtrl',
      controller: function ($scope, helpService, catalogService, userSettingsService) {
        var stockWidgetCtrl = this;
        var today = new Date(new Date().toUTCString());
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        var tomorrow = today.setDate(today.getDate()  + 1);
        stockWidgetCtrl.crudState = helpService.getCrudStateStructure();
        stockWidgetCtrl.sortBy = userSettingsService.loadProperty('widget', 'sortBy', 'stockWidget') || 'company_id';
        stockWidgetCtrl.tempSortBy = stockWidgetCtrl.sortBy;
        // состояние скрытой/раскрытой детализации
        stockWidgetCtrl.showData = userSettingsService.loadProperty('widget', 'showData', 'stockWidget') || false;

        stockWidgetCtrl.init = function () {
          stockWidgetCtrl.crudState.startLoading();
          catalogService.getCatalogItemsStock(stockWidgetCtrl.options.id, tomorrow, stockWidgetCtrl.sortBy)
            .then(function (res) {
              stockWidgetCtrl.stock = res.data;
              stockWidgetCtrl.crudState.stopLoadingSuccess();
            },
            function (error) {
              stockWidgetCtrl.crudState.stopLoadingFailure(error);
            });
        }

        stockWidgetCtrl.$onInit = function() {
          stockWidgetCtrl.init();
        };
        
        stockWidgetCtrl.showHideData = function () {
          stockWidgetCtrl.showData = !stockWidgetCtrl.showData;
          userSettingsService.saveProperty('widget', 'showData', 'stockWidget', stockWidgetCtrl.showData);
        }

        stockWidgetCtrl.callbacks = {
          dismiss: function(){
            stockWidgetCtrl.tempSortBy = userSettingsService.loadProperty('widget', 'sortBy', 'stockWidget') || stockWidgetCtrl.sortBy;
            stockWidgetCtrl.sortBy = stockWidgetCtrl.tempSortBy;
            stockWidgetCtrl.settingsmode = false;
          },
          save: function(){
            userSettingsService.saveProperty('widget', 'sortBy', 'stockWidget', stockWidgetCtrl.tempSortBy);
            stockWidgetCtrl.sortBy = stockWidgetCtrl.tempSortBy;
            stockWidgetCtrl.init();
            stockWidgetCtrl.settingsmode = false;
          }
        };
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('specialTaxMode', {
      transclude: true,
      bindings: {
        options: '<', // параметры виджета
        callbacks: '=', // для настроек (сохранение и отмена)
        settingsmode: '<' // режим отображения настроек
      },
      templateUrl: 'app/settings/widgets/specialTaxMode/special-tax-mode.html',
      controllerAs: 'specialTaxModeCtrl',
      controller: function ($scope) {
        var specialTaxModeCtrl = this;
        var today = moment().utc().startOf('day').valueOf();
        specialTaxModeCtrl.divisions = [];
        specialTaxModeCtrl.hasCurrentLength = 0;
        specialTaxModeCtrl.companyId = specialTaxModeCtrl.options.companyId;

        if(specialTaxModeCtrl.options){
          specialTaxModeCtrl.allTaxMode = []; // для режима отображения всех спец режимов
          specialTaxModeCtrl.currentTaxMode = []; // для режима отображения только текущих спец режимов
          _.forEach(specialTaxModeCtrl.options.divisions, function(division, key){
            if(division.special_tax_modes && division.special_tax_modes.length){
              var special_tax_modes = []; // для режима отображения всех спец режимов
              var current_tax_modes = []; // для режима отображения только текущих спец режимов
              division.$$hasCurrent = false; //для скрытия подраздленеия в режиме просмотра только действующих спец режимов, в случае если нет действующих

              // сортировка массива по убыванию дат
              division.special_tax_modes.sort(function (a, b) {
                return b.start_date - a.start_date;
              })

              _.forEach(division.special_tax_modes, function(tax_mode, index){
                if(tax_mode.end_date){
                  if(today > tax_mode.start_date && today > tax_mode.end_date){
                    special_tax_modes.push(tax_mode);
                  }else if(today == tax_mode.end_date || today == tax_mode.start_date || (today > tax_mode.start_date && today < tax_mode.end_date)){
                    specialTaxModeCtrl.hasCurrentLength++;
                    tax_mode.$$current = true;
                    division.$$hasCurrent = true;
                    special_tax_modes.push(tax_mode);
                    current_tax_modes.push(tax_mode);
                  }
                }else{ // если нет конечной даты, то нет промежутка, значит сравнивается только начальная дата
                  if(tax_mode.start_date <= today){
                    if(tax_mode.start_date == today || (!index && tax_mode.start_date < today)){
                      specialTaxModeCtrl.hasCurrentLength++;
                      tax_mode.$$current = true;
                      division.$$hasCurrent = true;
                      current_tax_modes.push(tax_mode);
                    }
                    special_tax_modes.push(tax_mode);
                  }
                }
              });

              division.special_tax_modes = special_tax_modes;
              specialTaxModeCtrl.allTaxMode.push(angular.copy(division));

              division.special_tax_modes = current_tax_modes;
              specialTaxModeCtrl.currentTaxMode.push(angular.copy(division));
            }
          });
          specialTaxModeCtrl.divisions = specialTaxModeCtrl.allTaxMode;
        }

        specialTaxModeCtrl.getDateStr = function(tax, index, division){
          var startDate = (tax.end_date)? moment.utc(tax.start_date).format('DD.MM.YYYY') : 'с ' + moment.utc(tax.start_date).format('DD.MM.YYYY');
          if(tax.special_tax_mode == 'IMPUTED' && !tax.end_date && index){
            tax.end_date = moment(division.special_tax_modes[index - 1].start_date).utc().subtract(1, 'day').valueOf();
          }
          return startDate + ((tax.end_date)? " — " + moment.utc(tax.end_date).format('DD.MM.YYYY') : "");
        }

        specialTaxModeCtrl.callbacks = {
          dismiss: function(){
            specialTaxModeCtrl.setOnlyCurrent = specialTaxModeCtrl.onlyCurrent;
          },
          save: function(){
            specialTaxModeCtrl.onlyCurrent = specialTaxModeCtrl.setOnlyCurrent;
            specialTaxModeCtrl.divisions = (!specialTaxModeCtrl.setOnlyCurrent)? specialTaxModeCtrl.allTaxMode : specialTaxModeCtrl.currentTaxMode;
          }
        };
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .filter('priceListName', function () {
      return function (value) {
        return value === 'RETAIL'
          ? 'Розничный'
          : value === 'WHOLE_SALE'
            ? 'Оптовый'
            : value === 'PURCHASE'
              ? 'Закупочный'
              : value;
      }
    })
    .component('priceWidget', {
      transclude: true,
      bindings: {
        options: '<', // параметры виджета
        callbacks: '=', // для настроек (сохранение и отмена)
        settingsmode: '=', // режим отображения настроек
        redactMode: '='
      },
      templateUrl: 'app/settings/widgets/price-widget/price-widget.html',
      controllerAs: 'priceWidgetCtrl',
      controller: function ($scope,
                            helpService, 
                            catalogService, 
                            userSettingsService, 
                            $uibModal,
                            $timeout) {
        var priceWidgetCtrl = this;
        var pageName = 'catalog-item';
        var widgetComponentName = 'price-widget';
        priceWidgetCtrl.crudState = helpService.getCrudStateStructure();
        priceWidgetCtrl.pricesLists = [];

        priceWidgetCtrl.$onInit = function() {
          priceWidgetCtrl.crudState.startLoading();
          catalogService.getCatalogItemPrices(priceWidgetCtrl.options.id)
            .then(onSuccessLoading,
              function (error) {
                priceWidgetCtrl.crudState.stopLoadingFailure(error);
              });
        };

        function onSuccessLoading(res) {
          priceWidgetCtrl.pricesLists = res.data;
          // добавление префиксов полномочий для каждого из прайслистов
          _.forEach(priceWidgetCtrl.pricesLists.price_lists, function(list){
            if (list.type == "WHOLE_SALE") {
              list.$$action_prefix = 'wholesale_price_list';
            } else if (list.type == "PURCHASE") {
              list.$$action_prefix = 'purchase_price_list';
            } else {
              list.$$action_prefix = 'price_list';
            }
          });
          priceWidgetCtrl.dataToSave = angular.copy(priceWidgetCtrl.pricesLists);
          priceWidgetCtrl.widgetSettings = mapSettings(userSettingsService.loadComponent(pageName, widgetComponentName) || {}, priceWidgetCtrl.pricesLists);
          priceWidgetCtrl.crudState.stopLoadingSuccess();
        }

        function mapSettings(savedSettings, priceListData) {
          // ремап из-за того, что могут добавлятся колонки
          angular.forEach(priceListData.price_lists, function (priceList) {
            savedSettings[priceList.type] = savedSettings[priceList.type] || { columns: {}, visible: true };
            angular.forEach(priceList.columns, function (column, key) {
              savedSettings[priceList.type].columns[column.id] = savedSettings[priceList.type].columns[column.id] || {
                visible: true,
                name: column.name,
                // группировка по поставщику только закупочных колонок
                supplier: column.supplier
              };
              savedSettings[priceList.type].columns[column.id].enableToAddNewPrice = priceList.type !== 'RETAIL' || !column.prices.length;
              column.prices.sort(function (a, b) {
                return +b.effective_date - a.effective_date
              }).forEach(function (price) {
                price.$$uiid = helpService.stringGen();
              })
            })
          });
          return savedSettings;
        }


        priceWidgetCtrl.callbacks = {
          // отмена сохранения настроек
          dismiss: function(){
            priceWidgetCtrl.widgetSettings = mapSettings(userSettingsService.loadComponent(pageName, widgetComponentName) || {}, priceWidgetCtrl.pricesLists);
            priceWidgetCtrl.settingsmode = false;
          },
          // сохранение настроек
          save: function(){
            userSettingsService.saveComponent(pageName, widgetComponentName, priceWidgetCtrl.widgetSettings);
            priceWidgetCtrl.settingsmode = false;
          }
        };

        priceWidgetCtrl.priceListVisibilityChange = function (type) {
          angular.forEach(priceWidgetCtrl.widgetSettings[type].columns, function (column) {
            column.visible = priceWidgetCtrl.widgetSettings[type].visible;
          })
        };

        priceWidgetCtrl.columnVisibilityChanged = function (type) {
          priceWidgetCtrl.widgetSettings[type].visible = !!_.find(priceWidgetCtrl.widgetSettings[type].columns, function (value) {
            return value.visible;
          });
        };

        // сохранение отредактированных данных
        priceWidgetCtrl.save = function () {
          priceWidgetCtrl.crudState.startLoading();
          catalogService.updateCatalogItemPrices(priceWidgetCtrl.options.id, priceWidgetCtrl.dataToSave)
            .then(function (res) {
              onSuccessLoading(res);
              priceWidgetCtrl.redactMode = false;
            },
            function (error) {
              priceWidgetCtrl.crudState.stopLoadingFailure(error);
            });
        };

        // отмена редактирования
        priceWidgetCtrl.dismiss = function () {
          priceWidgetCtrl.$onInit();
          priceWidgetCtrl.redactMode = false;
        };


        priceWidgetCtrl.onColumnChange = function (updatedColumn, priceList, index) {
          var list = priceWidgetCtrl.dataToSave.price_lists.find(function (list) {
            return list.type === priceList.type;
          });
          if (list)  {
            var newPrices = [];
            updatedColumn.prices.forEach(function (price, key) {
              if (price.effective_qty > 0 && price.$$modified) {
                if (price.$$deleted) {
                  list.columns[index].prices.splice(key, 1);
                } else {
                  var existing = list.columns[index].prices.find(function (existingPrice, existingKey) {
                    return existingPrice.enable_to_modify && 
                    (
                      (existingPrice.id === price.id && existingPrice.id) ||
                      (existingPrice.$$uiid === price.$$uiid && existingPrice.$$uiid)
                    );
                  });
                  if (existing) {
                    existing.effective_qty = price.effective_qty;
                    existing.price_for_one_uom = price.price_for_one_uom;
                    if (list.type !== 'PURCHASE') {
                      existing.effective_date = price.effective_date;
                      existing.free_of_control_price = price.free_of_control_price;
                    }
                  } else {
                    price.id = null;
                    newPrices.push(price);
                  }
                }
              }
            });
            list.columns[index].prices = list.columns[index].prices.concat(newPrices);
          }
        };


      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('mutualSettlement', {
      transclude: true,
      bindings: {
        options: '<', // параметры виджета
        callbacks: '=', // для настроек (сохранение и отмена)
        settingsmode: '<' // режим отображения настроек
      },
      templateUrl: 'app/settings/widgets/mutualSettlement/mutual-settlement.html',
      controllerAs: 'mutualSettlementCtrl',
      controller: function ($scope, accountingService, $q, contractService, requestStatus, userSettingsService) {
        var mutualSettlementCtrl = this;
        var tomorrow = moment.utc(new Date()).add(1,'days').startOf('day').valueOf();
        mutualSettlementCtrl.counterpartyOwe = 0;
        mutualSettlementCtrl.weOwe = 0;
        mutualSettlementCtrl.contractsData = [];
        mutualSettlementCtrl.load = 0;
        mutualSettlementCtrl.accountingCodes = ["60.01", "62.01", "66", "58.3", "76.09", "57.3"];
        
        // состояние скрытой/раскрытой деализации
        mutualSettlementCtrl.showData = userSettingsService.loadProperty('widget', 'showData', 'mutualSettlement') || false;

        function _isNullValues(obj) {
          return obj.beginning_balance_credit === null &&
                 obj.beginning_balance_debit === null &&
                 obj.total_credit === null &&
                 obj.total_debit === null;
        }

        function debitCreditSumm(res, obj, isDebit) {
          if (isDebit) {
            res += obj.beginning_balance_debit + obj.total_debit;
          } else {
            res += obj.beginning_balance_credit + obj.total_credit;
          }
          return res;
        }

        accountingService.getPeriodDimTotal('COUNTERPARTY', mutualSettlementCtrl.options.counterpartyId, mutualSettlementCtrl.accountingCodes, tomorrow, tomorrow).then(function (res) {
          var debit = 0, credit = 0, tempCounterpartyOwe, tempWeOwe;
          mutualSettlementCtrl.someError = false;
          mutualSettlementCtrl.noPermissions = false;

          // проверка на то достаточно ли прав просматривать данные
          if (!_.find(res.data.items, function(item){
            return !_isNullValues(item);
          })) {
            mutualSettlementCtrl.noPermissions = true;
          }

          _.forEach(res.data.items, function(item){
            debit = debitCreditSumm(debit, item, true);
            credit = debitCreditSumm(credit, item, false);
          });

          tempCounterpartyOwe = debit;
          tempWeOwe = credit;
          mutualSettlementCtrl.owe = ((tempCounterpartyOwe - tempWeOwe) / 100).toFixed(2);
          mutualSettlementCtrl.isWeOwe = mutualSettlementCtrl.owe < 0;
          mutualSettlementCtrl.owe = Math.abs(mutualSettlementCtrl.owe);
        }, function (error) {
          mutualSettlementCtrl.someError = true;
          requestStatus.error('Произошла ошибка. Мы уже в курсе, и работаем над ее устранением. Попробуйте повторить действие спустя некоторое время.');
        });

        mutualSettlementCtrl.getData = function (withSave) {
          if (withSave) {
            mutualSettlementCtrl.showData = !mutualSettlementCtrl.showData;
            userSettingsService.saveProperty('widget', 'showData', 'mutualSettlement', mutualSettlementCtrl.showData);
          }
          if (!mutualSettlementCtrl.contractsData.length) {
            var filters = {
              counterparty_id: mutualSettlementCtrl.options.counterpartyId
            }
            mutualSettlementCtrl.load = 1;
            contractService.contracts({limit: 100, sortBy: 'company_name'}, '', filters).then(function (contractRes) {
              mutualSettlementCtrl.someError = false;
              if (contractRes.data.items.length) {
                mutualSettlementCtrl.load = contractRes.data.items.length;
                mutualSettlementCtrl.contractsData = [{
                  company_name: contractRes.data.items[0].organization_name,
                  contracts: []
                }];
                _.forEach(contractRes.data.items, function (contract) {
                  accountingService.getPeriodDimTotal('CONTRACT', contract.id, mutualSettlementCtrl.accountingCodes, tomorrow, tomorrow).then(function (res) {
                    var debit = 0, credit = 0;
                    mutualSettlementCtrl.someError = false;
                    
                    _.forEach(res.data.items, function(item){
                      debit = debitCreditSumm(debit, item, true);
                      credit = debitCreditSumm(credit, item, false);
                    });
                    
                    var tempCounterpartyOwe = debit;
                    var tempWeOwe = credit;
                    var company = _.find(mutualSettlementCtrl.contractsData, function(company){
                      return contract.organization_name == company.company_name;
                    });

                    contract.owe = ((tempCounterpartyOwe - tempWeOwe) / 100).toFixed(2);
                    contract.isWeOwe = contract.owe < 0;
                    contract.owe = Math.abs(contract.owe);

                    if (!company) {
                      mutualSettlementCtrl.contractsData.push({
                        company_name: contract.organization_name,
                        contracts: [contract]
                      });
                    }else{
                      company.contracts.push(contract);
                    }

                    mutualSettlementCtrl.load--;
                  }, function (error) {
                    mutualSettlementCtrl.someError = true;
                    requestStatus.error('Произошла ошибка. Мы уже в курсе, и работаем над ее устранением. Попробуйте повторить действие спустя некоторое время.');
                  });
                });
              } else {
                mutualSettlementCtrl.load = 0;
              }
            }, function (error) {
              mutualSettlementCtrl.someError = true;
              requestStatus.error('Произошла ошибка. Мы уже в курсе, и работаем над ее устранением. Попробуйте повторить действие спустя некоторое время.');
            });
          }
        }

        if (mutualSettlementCtrl.showData) {
          mutualSettlementCtrl.getData();
        }
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('egaisCounterparties', {
      transclude: true,
      bindings: {
        options: '<', // параметры виджета
        callbacks: '=', // для настроек (сохранение и отмена)
        settingsmode: '<', // режим отображения настроек
        redactMode: '='
      },
      templateUrl: 'app/settings/widgets/egaisCounterparties/egais-counterparties.html',
      controllerAs: 'egaisCounterpartiesCtrl',
      controller: function ($scope, $uibModal, egaiszService, helpService) {
        var egaisCounterpartiesCtrl = this;
        egaisCounterpartiesCtrl.noData = false;
        egaisCounterpartiesCtrl.crudState = helpService.getCrudStateStructure();

        egaisCounterpartiesCtrl.$onInit = function() {
          egaisCounterpartiesCtrl.crudState.startLoading();
          //запроc на связанных контрагентов
          egaiszService.getCounterpartyBind(egaisCounterpartiesCtrl.options.counterpartyId, false).then(function(res){
            egaisCounterpartiesCtrl.noData = !res.data.length;
            egaisCounterpartiesCtrl.counterparties = res.data;
            egaisCounterpartiesCtrl.crudState.stopLoadingSuccess();
          },
          function (error) {
            egaisCounterpartiesCtrl.crudState.stopLoadingFailure(error);
          });
        };



        // сохранение отредактированных данных
        egaisCounterpartiesCtrl.save = function () {
          egaisCounterpartiesCtrl.crudState.startLoading();
          var counterparties = _.map(egaisCounterpartiesCtrl.counterparties, function(item){
            return {
              id: item.id,
              name: item.short_name
            };
          });
          egaiszService.putCounterpartyBind(egaisCounterpartiesCtrl.options.counterpartyId, counterparties, true)
            .then(function (res) {
                return egaiszService.getCounterpartyBind(egaisCounterpartiesCtrl.options.counterpartyId, false)
                  .then(function(res){
                  egaisCounterpartiesCtrl.noData = !res.data.length;
                  egaisCounterpartiesCtrl.counterparties = res.data;
                  egaisCounterpartiesCtrl.crudState.stopLoadingSuccess();
                    egaisCounterpartiesCtrl.redactMode = false;
                }, function (error) {
                    egaisCounterpartiesCtrl.crudState.stopLoadingFailure(error);
                  });
            },
            function (error) {
              egaisCounterpartiesCtrl.crudState.stopLoadingFailure(error);
            });
        };

        // отмена редактирования
        egaisCounterpartiesCtrl.dismiss = function () {
          egaisCounterpartiesCtrl.$onInit();
          egaisCounterpartiesCtrl.redactMode = false;
        };

        egaisCounterpartiesCtrl.deletePopup = function(counterparty){
          $uibModal.open({
            templateUrl: 'app/settings/templates/modals/one-question.html',
            size: 'small-width',
            controller: function ($scope, $uibModalInstance) {
              var basicCanDeleteText = "Удаление невозможно, так как по данной услуге созданы документы";
              $scope.canDelete = true;
              $scope.title = "Редактирование";
              $scope.buttonAction = "Отвязать";
              $scope.buttonClose = "Отмена";

              $scope.text = 'Вы действительно хотите отвязать обособленное подразделение ЕГАИС от данного контрагента?';
              $scope.conflictDeleteText = basicCanDeleteText;
              $scope.lock = false;
              $scope.close = function() {
                $uibModalInstance.dismiss();
              };

              $scope.action = function() {
                egaisCounterpartiesCtrl.counterparties = _.filter(egaisCounterpartiesCtrl.counterparties, function(contr){
                  return contr.id !== counterparty.id;
                });
                $uibModalInstance.dismiss();
              };
            }
          });
        }

      }
    });
})();

(function () {
    'use strict';

    angular.module('frontend').controller('utmConnectionController', utmConnectionController);

    function utmConnectionController($scope, 
                                     $state, 
                                     $stateParams, 
                                     connection, 
                                     utmConnectionsService, 
                                     errorMessageService, 
                                     companyService,
                                     $uibModal,
                                     cardHistory,
                                     $q) {
      var utmConnectionCtrl = this;
      utmConnectionCtrl.state = $state;
      utmConnectionCtrl.newDivisionsList = [];
      utmConnectionCtrl.today = moment.utc().valueOf();
      
      utmConnectionCtrl.mode = {
        isEdit: utmConnectionCtrl.state.current.name.endsWith('edit'),
        isView: utmConnectionCtrl.state.current.name.endsWith('view')
      };

      // для возврата на предыдущую страницу
      utmConnectionCtrl.returnToPage = function () {
        var prev = cardHistory.popStep('id', $stateParams.id) || {name: 'utmConnections', param: {parent: 'alcohol'}};
        $state.go(prev.name !== '' ? prev.name : 'utmConnections', prev.param || {parent: 'alcohol'});
      };

      utmConnectionsService.getDivisionsList($stateParams.id).then(function(res){
        utmConnectionCtrl.divisions = res.data.items;
      });

      utmConnectionCtrl.addDivision = function(){
        utmConnectionCtrl.newDivisionsList.push({});
      }

      utmConnectionCtrl.initCompany = function(){
        utmConnectionCtrl.companies = [];
        _.forEach(utmConnectionCtrl.connection.divisions, function(division){
          if(!utmConnectionCtrl.companies.length) { 
            utmConnectionCtrl.companies.push({
              id: division.company.id,
              name: division.company.name
            });
          }else{
            var issetCompany = false;
            _.forEach(utmConnectionCtrl.companies, function(company){
                if(division.company.id == company.id){
                    issetCompany = true;
                }
            });
            if(!issetCompany){
                utmConnectionCtrl.companies.push({
                    name: division.company.name,
                    id: division.company.id
                });
            }
          }
        });
      }

      function getDateInfo (status) {
        if (status == 'EXPIRED') {
          return 'Cрок действия сертификата закончился';
        } else if (status == 'EXPIRING') {
          return 'Cрок действия сертификата скоро закончится';
        }
        return '';
      }
      

      /* Инициализация подключения */
      utmConnectionCtrl.initData = function () {
        utmConnectionCtrl.connection = $.extend(true, {}, connection);
        utmConnectionCtrl.gostInfo = getDateInfo(utmConnectionCtrl.connection.gost_status);
        utmConnectionCtrl.rsaInfo = getDateInfo(utmConnectionCtrl.connection.rsa_status);
        utmConnectionCtrl.initCompany();
      };
      utmConnectionCtrl.initData();

      utmConnectionCtrl.deleteIssetDivision = function(index){
        var modal = $uibModal.open({
          templateUrl: 'app/settings/templates/modals/one-question.html',
          size: 'small-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.text = "При удалении связи, алкогольная продукция продаваемая через данное подразделение не будет корректно списываться через ЕГАИС, что приведет к рассинхронизации данных. Также, невозможно будет принять продукцию, полученную через ЕГАИС, на баланс подразделения.<br>Удалить связь с подразделением?";
            $scope.title = "Предупреждение";
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };
            $scope.action = function () {
              utmConnectionCtrl.connection.divisions.splice(index, 1);
              utmConnectionCtrl.initCompany();
              $uibModalInstance.dismiss();
            };
          }
        });
      }

      utmConnectionCtrl.deleteDivision = function(index){
        utmConnectionCtrl.newDivisionsList.splice(index, 1);
        utmConnectionCtrl.checkData();
      }

      // В методе выполняются подготовительные операции перед сохранением
      utmConnectionCtrl.prepareSave = function () {
        utmConnectionCtrl.apiConnection = {
          id: utmConnectionCtrl.connection.id,
          fsrar_id: utmConnectionCtrl.connection.fsrar_id,
          divisions: []
        };
        _.forEach(utmConnectionCtrl.newDivisionsList, function(divisionData){
          utmConnectionCtrl.apiConnection.divisions.push(divisionData.data);
        });
        _.forEach(utmConnectionCtrl.connection.divisions, function(divisionData){
          utmConnectionCtrl.apiConnection.divisions.push(divisionData);
        });
      };

      // Метод, вызываемый при изменении
      utmConnectionCtrl.save = function () {
        // подготовка структур в соответствие АПИ
        utmConnectionCtrl.prepareSave();
        if (utmConnectionCtrl.connection.id) {
          // Блок обновления
          return utmConnectionsService.updateConnection(utmConnectionCtrl.connection.id, utmConnectionCtrl.apiConnection).then(
            function (newConnection) {
              utmConnectionCtrl.connection = newConnection.data;
              connection = newConnection.data;
              $state.go('utmConnection.view', {id: $stateParams.id, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
            }
          )
        }
      };

      // проверка списка новых подразделений на уникальность
      utmConnectionCtrl.checkData = function(){
        utmConnectionCtrl.errorInd = [];
        angular.forEach(utmConnectionCtrl.newDivisionsList, function(division1, key1){
          angular.forEach(utmConnectionCtrl.newDivisionsList, function(division2, key2){
            if(division1.data && division2.data && division1.data.division && division2.data.division && key1 < key2 && division1.data.division.id == division2.data.division.id){
              utmConnectionCtrl.errorInd.push(key1);
              utmConnectionCtrl.errorInd.push(key2);
            }
          });
        });
        if(utmConnectionCtrl.errorInd.length){
          $scope.utmForm.$error.errorUnique = true;
          $scope.utmForm.$valid = false;
        }else{
          if($scope.utmForm) delete $scope.utmForm.$error.errorUnique;
          if(_.isEmpty($scope.utmForm.$error)) $scope.utmForm.$valid = true;
        }
      };

      utmConnectionCtrl.setDirty = function() {
        utmConnectionCtrl.isSetDirty = true;
        angular.forEach($scope.utmForm.$error, function(controls, errorName) {
          angular.forEach(controls, function(control) {
            control.$setDirty();
          });
        });
        return $q.when();
      }


      utmConnectionCtrl.crud = function (status) {
        console.log(status)
        switch (status) {
          case 'save':
            if ($scope.utmForm.$valid) {
              return utmConnectionCtrl.save();
            }else{
              return utmConnectionCtrl.setDirty();
            }
            break;
          case 'return':
            utmConnectionCtrl.returnToPage();
            return $q.when();
            break;
          case 'edit':
            $state.go('utmConnection.edit', {
              id: utmConnectionCtrl.connection.id,
              parent: 'alcohol'
            });
            return $q.when();
            break;
          default :
            return $q.when();
            break;
        }
      };
    }
  }
)();

/**
 * Created by aivanov on 08.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .service("modalMessageSrv", function ($rootScope, $uibModal) {
        if ($rootScope.hasAppError) return;
        this.showModal = function (settings) {
          return $uibModal.open({
            windowClass: 'more-zindex',
            templateUrl: 'app/settings/services/message/modal-message.html',
            controller: 'ModalMessageController',
            size: 'middle-width',
            resolve: {
              message: settings
            }
          }).result;
        }
    })
    .controller("ModalMessageController", function ($scope, $uibModalInstance, message) {
      $scope.message = message;
      $scope.close = function () {
        $uibModalInstance.dismiss();
      };
    })
})();

/**
 * Created by aivanov on 08.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .service("askDeleteSrv", function ($uibModal) {
      this.showAskDelete = function (
        name, // им удаляемой сущности
        deleteEntityStr, // род. падеж имени удаляемой сущности
        conflictDeleteText, // текст сообщения о конфликте при удалении
        entityId, // идентификатор удаляемой сущности
        deleteMethod // метод внешнего сервиса, принимающий идентификатор сущности и возвращающий промис
      ) {
        var modal = $uibModal.open({
          templateUrl: 'app/settings/templates/modals/ask-delete.html',
          size: 'small-width',
          resolve: {
            name: function () {
              return name;
            },
            deleteEntityStr: function () {
              return deleteEntityStr;
            },
            conflictDeleteText: function () {
              return conflictDeleteText;
            },
            entityId: function () {
              return entityId;
            },
            deleteMethod: function () {
              return deleteMethod;
            }
          },
          controller: function ($scope,
                                $uibModalInstance,
                                name,
                                deleteEntityStr,
                                conflictDeleteText,
                                entityId,
                                deleteMethod
          ) {
            $scope.name = name;
            $scope.canDelete = true;
            $scope.deleteEntityStr = deleteEntityStr;
            $scope.conflictDeleteText = conflictDeleteText;

            // блокировка кнопок
            $scope.lock = false;

            $scope.close = function () {
              $uibModalInstance.dismiss();
            };

            $scope.delete = function () {
              $scope.lock = true;
              deleteMethod(entityId).then(function () {
                $scope.lock = false;
                $uibModalInstance.close();
              }, function (error) {
                $scope.lock = false;
                if (error.status == 409) {
                  $scope.canDelete = false;
                  return;
                }
                errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: error});
                $uibModalInstance.dismiss();
              });
            };
          }
        });
        return modal.result;
      }
    })
})();

(function () {
  'use strict';

  angular.module('frontend').service('returnsCrudSumDefsService', returnsCrudSumDefsService);

  /** @ngInject */
  function returnsCrudSumDefsService(crudsService) {
    this.get = function (entity, symbol) {
      entity.tax_amounts = entity.tax_amounts || [];
      entity.payment_type_amounts = entity.payment_type_amounts || [];

      var tax_totals = entity.tax_amounts.map(function (tax_total) {
        return new crudsService.SumChild([
          new crudsService.SumTableData(tax_total.tax.name),
          new crudsService.SumTableData(tax_total.home_amount, symbol)
        ]);
      });

      var payment_type_amounts = entity.payment_type_amounts.map(function (payment_type_amount) {
        return new crudsService.SumChild([
          new crudsService.SumTableData(payment_type_amount.type.name),
          new crudsService.SumTableData(payment_type_amount.home_amount, symbol)
        ]);
      });

      return [
        new crudsService.SumHeader([
            new crudsService.SumTableData('Сумма'),
            new crudsService.SumTableData(entity.home_amount, symbol)
          ], true, payment_type_amounts
        ),
        new crudsService.SumHeader([
          new crudsService.SumTableData('Сумма налогов'),
          new crudsService.SumTableData(entity.home_tax_amount, symbol)
        ], true, tax_totals)
      ];
    };
  }
})();

(function () {
  'use strict';
  angular.module('frontend').controller('ReturnCrudController', ReturnCrudController);

  function ReturnCrudController(uiGridConstants,
                                API_URL,
                                crudsService,
                                $stateParams,
                                returnsCrudSumDefsService,
                                returnCrudColumnDefsService,
                                cardHistory,
                                $state,
                                $filter) {
    var ctrl = this;
    var RETURNS_URL = API_URL + '/retail/documents/RETAIL_RETURN';
    ctrl.url = RETURNS_URL + '/' + $stateParams.id + '/lines';
    ctrl.page = 'return-crud';
    ctrl.header = 'Позиции';
    ctrl.sort = 'name';
    ctrl.limit = 5;
    ctrl.showSum = false;
    ctrl.showTaxTotals = false;
    ctrl.showCash = false;
    ctrl.showNonCash = false;
    ctrl.fields = [];
    ctrl.columnDefs = returnCrudColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    ctrl.usingService = returnCrudColumnDefsService;
    ctrl.gridConfig = {
      gridOptions: {
        enableRowSelection: true,
        multiSelect: true,
        enableRowSelectionAll: true
      }
    };
    ctrl.returnToPage = function() {
      var prev = cardHistory.popStep('id', $stateParams.id) || {name: 'returns', param: {parent: 'retail'}};
      $state.go(prev.name !== '' ? prev.name : 'returns', prev.param || {parent: 'retail'});
    };

    ctrl.initPage = function () {
      ctrl.loadingData = true;
      ctrl.success = false;
      ctrl.fail = false;
      ctrl.loadedData = false;
      crudsService.getView(RETURNS_URL + '/' + $stateParams.id)
        .then(function (result) {
          ctrl.return = result.data;
          ctrl.currency = ctrl.return.home_currency.symbol;

          var number = result.data.number
            ? result.data.number
            : '-';
          var date = result.data.date
            ? ctrl.getFormattedDate(result.data.date, true, 'DD.MM.YYYY HH:mm')
            : '-';
          var shift = result.data.shift
            ? '№' + result.data.shift.number + ' от ' + ctrl.getFormattedDate(result.data.shift.date)
            : '-';
          var sale = result.data.retail_sale
            ? '№' + result.data.retail_sale.number + ' от ' + ctrl.getFormattedDate(result.data.retail_sale.date)
            : '-';
          var user = result.data.user ? result.data.user.name : '-';
          var company = result.data.company ? result.data.company.name : '-';
          var division = result.data.division ? result.data.division.name : '-';
          var place = result.data.place ? result.data.place.name : '-';
          var tax = result.data.tax_mode ? $filter('tax')(result.data.tax_mode) : '-';
          var cash_register = result.data.cash_register
            ? result.data.cash_register.manufacturer + ' - '
            + result.data.cash_register.model + ' №'
            + result.data.cash_register.serial_num
            : '-';

          ctrl.fields.push(new crudsService.Field('Номер возврата', number, null,
            'Аппаратный номер возврата: ' + (result.data.ext_number || '-')));
          ctrl.fields.push(new crudsService.Field('Дата возврата', date, null,
            'Аппаратная дата возврата: ' + (ctrl.getFormattedDate(result.data.ext_date, true, 'DD.MM.YYYY HH:mm') || '-')));
          ctrl.fields.push(new crudsService.Field('Смена', shift, {
            stateName: 'cashregshift.view',
            stateParams: {
              id: result.data.shift && result.data.shift.id
            }
          }));
          ctrl.fields.push(new crudsService.Field('Чек продажи', sale, {
            stateName: 'cashregreceipt.view',
            stateParams: {
              id: result.data.retail_sale && result.data.retail_sale.id
            }
          }));
          ctrl.fields.push(new crudsService.Field('Кассир', user, {
            stateName: 'employee.view',
            stateParams: {
              userId: result.data.user && result.data.user.id
            }
          }));
          ctrl.fields.push(new crudsService.Field('Компания', company, {
            stateName: 'company.view',
            stateParams: {
              companyId: result.data.company && result.data.company.id
            }
          }));
          ctrl.fields.push(new crudsService.Field('Подразделение', division, {
            stateName: 'division.view',
            stateParams: {
              divisionId: result.data.division && result.data.division.id,
              companyId: result.data.company && result.data.company.id
            }
          }));
          ctrl.fields.push(new crudsService.Field('Кассовое место', place));
          ctrl.fields.push(new crudsService.Field('Кассовый аппарат', cash_register));
          ctrl.fields.push(new crudsService.Field('СНО', tax));

          return result.data;
        })
        .then(function (result) {
          ctrl.sumTable = returnsCrudSumDefsService.get(result, result.home_currency.symbol);
          ctrl.success = true;
          ctrl.loadedData = true;
        })
        .catch(function () {
          ctrl.fail = true;
        })
        .finally(function () {
          ctrl.loadingData = false;
        });
    };

    ctrl.getFormattedDate = function (date, returnTime, format) {
      return crudsService.getFormattedDate(date, returnTime, format);
    };

    ctrl.getCashValue = function (value, symbol) {
      return crudsService.getCashValue(value, symbol);
    };

    ctrl.initPage();
  }
})();


(function() {
  'use strict';

  angular.module('frontend').service('returnCrudColumnDefsService', returnCrudColumnDefsService);

  /** @ngInject */
  function returnCrudColumnDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\':' +
      ' col.sort.direction == asc, \'ui-grid-icon-down-dir\':' +
      ' col.sort.direction == desc, \'ui-grid-icon-blank\':' +
      ' !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var markTemplate = '<div class="ui-grid-cell-contents" uib-tooltip="{{grid.appScope.ctrl.getArrTipStr(COL_FIELD, \'amc\')}}" tooltip-placement="bottom">' +
    '  <span ng-bind="grid.appScope.ctrl.getArrTipStr(COL_FIELD, \'amc_name\')"></span>' +
    '</div>';

    var columnsDefinedWidth = [ 80, 100, 160, 160, 160, 160, 160, 200, 160, 160, 160, 100];


    this.loadSavedDefinedColumnWidth = function() {
      var income = userSettingsService.loadProperty('return-crud', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('return-crud', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function(columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('return-crud', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function(uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'
        },
        {
          __index               : 1,
          name                  : 'dataValue.code',
          displayName           : 'Код',
          width                 : columnsDefinedWidth[1],
          visible               : true,
          headerCellClass       : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-left',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD"/>',
          enableSorting   : true,
          sortName        : 'code',
          pinned: true
        },
        {
          __index               : 2,
          name                  : 'dataValue.name',
          displayName           : 'Название',
          visible               : true,
          headerCellClass       : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-left',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD"/>',
          width                 : columnsDefinedWidth[2],
          enableSorting         : true,
          sortName              : 'name',
          pinned: true,
          backButton            : true
        },
        {
          __index               : 3,
          name                  : 'dataValue.vendor_code',
          displayName           : 'Артикул производителя',
          visible               : true,
          headerCellClass       : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-left',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD"/>',
          width                 : columnsDefinedWidth[3]
        },
        {
          __index               : 4,
          name                  : 'dataValue.marks',
          displayName           : 'Марка',
          visible               : false,
          headerCellClass       : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-left',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : markTemplate,
          width                 : columnsDefinedWidth[4]
        },
        {
          __index               : 5,
          name                  : 'dataValue.quantity',
          displayName           : 'Количество',
          visible               : true,
          headerCellClass       : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-left',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<div class="ui-grid-cell-contents"><span>{{row.entity.dataValue.quantity}} {{row.entity.dataValue.uom.symbols}}</span></div>',
          width                 : columnsDefinedWidth[5]
        },
        {
          __index               : 6,
          name                  : 'dataValue.home_price',
          displayName           : 'Цена',
          width                 : columnsDefinedWidth[6],
          headerCellClass       : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-right',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.currency"/>',
          visible               : true
        },
        {
          __index               : 7,
          name                  : 'dataValue.home_amount',
          displayName           : 'Сумма',
          width                 : columnsDefinedWidth[7],
          headerCellClass       : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-right',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.currency"/>',
          visible               : true
        },
        {
          __index: 8,
          name: 'dataValue.settlements_type',
          displayName: 'Способ расчета',
          width: columnsDefinedWidth[8],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD | settlementsTypes"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: false
        },
        {
          __index: 9,
          name: 'dataValue.cash_register_item_type',
          displayName: 'Предмет расчета',
          width: columnsDefinedWidth[9],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD | cashRegisterItemTypes"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: false
        },
        {
          __index               : 10,
          name                  : 'dataValue.tax_group.name',
          displayName           : 'Налоговая группа',
          width                 : columnsDefinedWidth[10],
          headerCellClass       : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-left',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD"/>',
          visible               : false
        },
        {
          __index               : 11,
          name                  : 'dataValue.tax_amount',
          displayName           : 'Сумма налога',
          width                 : columnsDefinedWidth[11],
          headerCellClass       : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass             : 'ui-custom-cell-text-align-to-right',
          headerCellTemplate    : headerTemplate,
          cellTemplate          : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.currency"/>',
          visible               : false
        },
        {
          __index           : 12,
          name              : 'option',
          field             : 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button>',
          cellTemplate      : '',
          displayName       : '',
          headerCellClass   : 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu  : false,
          enableHiding      : false,
          enableFiltering   : false,
          width             : 50,
          minWidth          : 50,
          enableColumnResizing : false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function() {
  'use strict';

  angular.module('frontend').controller('paymentTypeCrudController', paymentTypeCrudController);

  function paymentTypeCrudController($scope, $state, $filter, $uibModal, utilsService, $stateParams, paymentTypesService, contractService, paymentType, errorMessageService, cardHistory, $log, $q, askDeleteSrv) {
    var paymentTypeCrudCtrl = this;

    //help
    paymentTypeCrudCtrl.createContractString = function (obj) {
      if (obj) {
        return '№' + obj.number + ' от ' + $filter('date')(obj.date, 'dd.MM.yyyy') + ' (' + obj.counterparty_name + ')'
      }
    }


    //Проверка на наличие способа оплаты типа Cash, если нет , то даем возможность создать
    paymentTypesService.paymentTypes(
      {
        current: 0,
        limit: 100,
        offset: 0,
        sortBy: 'name',
        total: undefined
      }
    ).then(function (res) {
      angular.forEach(res.data.items, function (item) {
        if (item.type === 'CASH') {
          paymentTypeCrudCtrl.disabledCashType = true;
        }
      })
    });

    // для возврата на предыдущую страницу
    paymentTypeCrudCtrl.returnToPage = function(){
      var prev = cardHistory.popStep('paymentTypeId', $stateParams.paymentTypeId) || {name: 'paymentTypes', param: {parent: 'money'}};
      $state.go(prev.name !== '' ? prev.name : 'paymentTypes', prev.param || {parent: 'money'});
    };

    paymentTypeCrudCtrl.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    }
    // Инициализация  статьи затрат
    if (paymentType) {
      paymentTypeCrudCtrl.paymentType = paymentType;
    } else {
      paymentTypeCrudCtrl.paymentType = {active: true, type : 'BANK_CARD', default:false};
    }

    //конфиг для поля договоров
    paymentTypeCrudCtrl.changeType = function(){
      var contractType;
      if ( paymentTypeCrudCtrl.paymentType.type == "OTHER" ) {
        contractType = ['WE_USE_ACQUIRING', 'WE_BUY'];
      } else {
        contractType = ['WE_USE_ACQUIRING'];
      }
      contractService.contractsForAutocomplete(undefined, 100, contractType).then(function (res) {
        paymentTypeCrudCtrl.contracts = res.data.items;
      });
    };
    paymentTypeCrudCtrl.changeType();

    function prepareSave() {
      if (paymentTypeCrudCtrl.paymentType.type === 'BANK_CARD' && !paymentTypeCrudCtrl.paymentType.active) {
        paymentTypeCrudCtrl.paymentType.default = paymentTypeCrudCtrl.paymentType.active;
      }
    }

    paymentTypeCrudCtrl.resetData = function(){
      $scope.addPaymentType.$setPristine();
      paymentTypeCrudCtrl.returnToPage()
    };

    // Метод, вызываемый при сохранении или изменении сотрудника
    paymentTypeCrudCtrl.save = function () {
      var deferred = $q.defer();
      if ($scope.addPaymentType.$valid) {// проверка валидности формы
        prepareSave();
        if (paymentTypeCrudCtrl.paymentType.id) {
          // Блок обновления
          return paymentTypesService.updatePaymentType(paymentTypeCrudCtrl.paymentType).then(
            function (res) {
              paymentType = res.data;
              paymentTypeCrudCtrl.resetData();
            },
            function (error) {
              if(error.status === 409 && error.data.code === "non_unique"){
                $scope.addpaymentType[error.data.parameters[0].name].$setValidity('unique', false);
              }else{
                errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        } else {
          // Блок создания
          if(!paymentTypeCrudCtrl.paymentType.name) return;
          return paymentTypesService.createPaymentType(paymentTypeCrudCtrl.paymentType).then(
            function (res) {
              paymentType = res.data;
              paymentTypeCrudCtrl.resetData();
            },
            function (error) {
              if(error.status === 409 && error.data.code === "non_unique"){
                $scope.addpaymentType[error.data.parameters[0].name].$setValidity('unique', false);
              }else{
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        }
      } else {
        angular.forEach( $scope.addPaymentType.$error ,function (control) {
          for (var i = 0; i < control.length; i++) {
            control[i].$setDirty()
          }
        });
        paymentTypeCrudCtrl.isSetDirty = true;
        return $q.when();
      }
    }


    /*
     * Метод, вызываемый при открытии попапа удаления способа оплаты
     */
    paymentTypeCrudCtrl.removePaymentType = function () {
      if (paymentTypeCrudCtrl.paymentType.type === 'CASH') {
        errorMessageService.showModal({message: 'Нельзя удалить способ оплаты с типом "Наличные"'});
        return $q.when();
      } else {
        return askDeleteSrv.showAskDelete(
          paymentTypeCrudCtrl.paymentType.name,
          "способ оплаты",
          "Невозможно удалить способ оплаты <strong>"+ paymentTypeCrudCtrl.paymentType.name +"</strong>. <br>Для удаления способа оплаты необходимо удалить все связанные с ним кассовые аппараты.",
          paymentTypeCrudCtrl.paymentType.id,
          paymentTypesService.deletePaymentType
        ).then(function (data) {
          paymentTypeCrudCtrl.resetData();
        });
      }

    }

    paymentTypeCrudCtrl.uniqueCheck = function(){
      if(paymentTypeCrudCtrl.paymentType.name){
        var obj = {
          "constraint_name": "PAYMENT_TYPE",
          "parameters": [
            {
              "name": "name",
              "value": paymentTypeCrudCtrl.paymentType.name
            }
          ]
        }
        obj.id = paymentTypeCrudCtrl.paymentType.id || null;
        utilsService.uniqueCheck(obj).then(function(){},
        function (error) {
          if(error.status === 409){
            angular.forEach(error.data.parameters, function(field){
              $scope.addPaymentType[field.name].$setValidity('unique', false);
            });
          } else {
            $log.debug(error)
          }
        });
      }
    }

    paymentTypeCrudCtrl.crud = function (status) {
      switch(status) {
        case 'save':
          return paymentTypeCrudCtrl.save();
          break;
        case 'delete':
          return paymentTypeCrudCtrl.removePaymentType();
          break;
        case 'return':
          paymentTypeCrudCtrl.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('paymentType.edit', {parent: 'money'});
          return $q.when();
        default :
          return $q.when();
          break;
      }
    }

  }// ctrl end

})();

(function () {
  'use strict';

  angular.module('frontend').controller('paidServiceCtrl', paidServiceCtrl);

  function paidServiceCtrl($state,
                           $stateParams,
                           serviceInfo,
                           companies,
                           divisions,
                           paidServicesService,
                           $uibModal,
                           requestStatus,
                           $rootScope,
                           errorMessageService,
                           $filter,
                           $timeout) {

    var paidServiceCtrl = this;
    paidServiceCtrl.serviceInfo = serviceInfo;
    paidServiceCtrl.serviceApplicationMap = [];
    paidServiceCtrl.companies = companies;
    paidServiceCtrl.divisions = divisions;
    paidServiceCtrl.hasCashregisters = false;
    paidServiceCtrl.isFree = false;
    paidServiceCtrl.companyWords = ["компаний", "компания", "компании"];
    paidServiceCtrl.divisionWords = ["подразделений", "подразделение", "подразделения"];
    paidServiceCtrl.cashregisterWords = ["касс", "касса", "кассы"];
    paidServiceCtrl.monthsWords = ["месяцев", "месяц", "месяца"];
    paidServiceCtrl.weekWords = ["недель", "неделя", "недели"];
    /**** структура внутри serviceApplicationMap  *****
    paidServiceCtrl.serviceApplicationMap = [{
      idCompany: 'id',
      name: 'name',
      checked: true,
      items: [{
        idDivision: 'id',
        name: 'name',
        checked: true,
        items: [{
          idCashregister: 'id',
          name: 'name',
          checked: true
        }]
      }]
    }]*/

    // А: объекты в карточке Выбрана и всех остальных - отличается, поэтому такие преобразования к одному типу
    // Т: не очень понял, зачем это странное копирование
    // А: оно нужно для приведение объектов из разных запросов к одному виду, на бэке почемуто сделали разные структуры объектов услуг
    // А: мне объект из запроса GET /paid_service/{paid_service_id} нужно привести к объекту, который ждет PUT/paid_service_subscription/{paid_service_subscription_id}
    // А: Объект, который приходит с бэка отличается, от объекта, который в итоге ждет бэк в другом запросе
    // TODO Переделать объект на бэке
    if ($stateParams.subscription) {
      paidServiceCtrl.serviceInfo = paidServiceCtrl.serviceInfo.price.service;
      paidServiceCtrl.serviceInfo.numberOfRemainingUpdates = serviceInfo.number_of_remaining_updates
      paidServiceCtrl.serviceInfo.status = serviceInfo.status;
      paidServiceCtrl.serviceInfo.key = serviceInfo.key;
      paidServiceCtrl.serviceInfo.payer = serviceInfo.payer;
      paidServiceCtrl.serviceInfo.email = serviceInfo.email;
      paidServiceCtrl.serviceInfo.prices = [serviceInfo.price];
      paidServiceCtrl.serviceInfo.effective_date = serviceInfo.effective_date;
      paidServiceCtrl.serviceInfo.expire_date = serviceInfo.expire_date;
      paidServiceCtrl.serviceInfo.invoice_out = serviceInfo.invoice_out;
      paidServiceCtrl.serviceInfo.code = serviceInfo.code;
      paidServiceCtrl.serviceInfo.price_subscription = serviceInfo.price_subscription;
      paidServiceCtrl.serviceInfo.consignment_note_out = serviceInfo.consignment_note_out;
      paidServiceCtrl.companyCheckedCount = serviceInfo.companies.length;
      paidServiceCtrl.divisionCheckedCount = serviceInfo.divisions.length;
      paidServiceCtrl.cashregCheckedCount = serviceInfo.cash_registers.length;
      paidServiceCtrl.choosenTarif = serviceInfo.price;
      paidServiceCtrl.isFree = !serviceInfo.price.price;
    }


    paidServiceCtrl.autocompleteServiceApplication = function () {
      /* Если одна компания, то автовыбор */
      _.forEach(paidServiceCtrl.serviceApplicationMap, function (company) {
        if (paidServiceCtrl.choosenTarif.number_of_companies == 1 && paidServiceCtrl.serviceApplicationMap.length == 1) {
          company.checked = true;
          paidServiceCtrl.companyCheckedCount = 1;
          paidServiceCtrl.checkItem(company, true);
        }

        if (paidServiceCtrl.serviceInfo.applicable_to_company) 
          return;

        // если нет привязки к компаниям, то отметить все, чтобы отобразались подразделения и кассы
        company.checked = true;
        
        if (paidServiceCtrl.serviceInfo.applicable_to_division) 
          return;
        // если нет привязки к подраздлелениям отметить все, чтобы отобразились кассы
        _.forEach(company.items, function (division) {
          division.checked = true;
        });
        
      });
    }

    paidServiceCtrl.disabledActivate = function () {
      var disabled = !paidServiceCtrl.choosenTarif || !paidServiceCtrl.companyCheckedCount;
      if (paidServiceCtrl.serviceInfo.code == "CRB" && paidServiceCtrl.cashregCheckedCount != paidServiceCtrl.choosenTarif.number_of_cashregisters) {
        disabled = true;
      }

      if (paidServiceCtrl.choosenTarif && !paidServiceCtrl.choosenTarif.price && 
          !paidServiceCtrl.choosenTarif.number_of_companies && 
          !paidServiceCtrl.choosenTarif.number_of_divisions && 
          !paidServiceCtrl.choosenTarif.number_of_cashregisters)  
        disabled = false;
      return disabled;
    }

    paidServiceCtrl.buildMap = function () {
      _.forEach(companies, function (company) {
        paidServiceCtrl.serviceApplicationMap.push({
          idCompany: company.id,
          name: company.name,
          checked: !!_.find(serviceInfo.companies, function(checkedCompay){ return checkedCompay.id == company.id}),
          items:[]
        });
      });

      _.forEach(divisions, function (division) {
        var divisionObj;
        var companyForDivision = _.find(paidServiceCtrl.serviceApplicationMap, function (company) {
          return company.idCompany == division.company_id;
        });
        divisionObj = {
          idDivision: division.id,
          name: division.name,
          checked: !!_.find(serviceInfo.divisions, function(checkedDivision){ return checkedDivision.id == division.id}),
          items: []
        };
        divisionObj.items = _.filter(division.cash_registers, function (cashRegister) {
          cashRegister.checked = !!_.find(serviceInfo.cash_registers, function(checkedCash){ return checkedCash.id == cashRegister.id});
          return cashRegister.manufacturer != "Без кассы" && cashRegister.model != "Без кассы"? cashRegister : false;
        });
        if (companyForDivision.checked && !paidServiceCtrl.serviceInfo.applicable_to_division) {
          divisionObj.checked = true;
        }
        if (divisionObj.items.length) paidServiceCtrl.hasCashregisters = true;
        companyForDivision.items.push(divisionObj);
      });
    };

    // для возврата на предыдущую страницу
    paidServiceCtrl.returnToPage = function(tabName){
      var prev = {name: 'paidServices', param: {tabName : tabName || paidServiceCtrl.serviceInfo.status || "EMPTY"}};
      $state.go(prev.name, prev.param);
    };

    paidServiceCtrl.goToCard = function (id, subscription) {
      var params = {id: id, subscription: subscription};
      $state.go('paidService', params, {inherit: false});
    }

    // для получения коррктного склонения слова в зависимоти от числа
    paidServiceCtrl.getCorrectWord = function(number, words){
      var lastDigit = number % 10;
      if (number < 20 && number > 10) {
        return words[0];
      } else if (lastDigit == 1) {
        return words[1];
      } else if (lastDigit < 5 && lastDigit > 1) {
        return words[2];
      } else {
        return words[0];
      }
    }

    paidServiceCtrl.periodStr = function (number_of_months) {
      if (number_of_months < 1) {
        return number_of_months/0.25 + ' ' + paidServiceCtrl.getCorrectWord(number_of_months/0.25, paidServiceCtrl.weekWords);
      } else {
        return number_of_months + ' ' + paidServiceCtrl.getCorrectWord(number_of_months, paidServiceCtrl.monthsWords)
      }
    }
    

    paidServiceCtrl.calculateCountsItems = function () {
      paidServiceCtrl.companyCheckedCount = 0;
      paidServiceCtrl.divisionCheckedCount = 0;
      paidServiceCtrl.cashregCheckedCount = 0;
      _.forEach(paidServiceCtrl.serviceApplicationMap, function (company) {
        if (company.checked) {
          paidServiceCtrl.companyCheckedCount += 1;
          _.forEach(company.items, function (division) {
            if (division.checked) {
              paidServiceCtrl.divisionCheckedCount += 1;
              _.forEach(division.items, function (cashRegister) {
                  if (cashRegister.checked) {
                    paidServiceCtrl.cashregCheckedCount += 1;
                  }
              });
            }
          });
        }
      });
    }

    paidServiceCtrl.checkItem = function (obj, isCompany, divisionslength) {
      // для сброса галок чилдиков, если сняли галку с родителя
      if (!obj.checked) {
        _.forEach(obj.items, function (subObj) {
          subObj.checked = false;
          if (subObj.items && subObj.items.length) {
            _.forEach(subObj.items, function (subsubObj) {
              subsubObj.checked = false;
            });
          }
        });
      }
      // если нет привязки к подразделениям, то выбирать их все автоматом, чтобы отобразились кассы
      if (isCompany && obj.checked && !paidServiceCtrl.serviceInfo.applicable_to_division) {
        _.forEach(obj.items, function (subObj) {
          subObj.checked = true;
        });
      }

      //// Автовыбор подразделения и кассы 
      // если чек компании, то отмечаем подразделение если оно одно
      if (isCompany && 
          paidServiceCtrl.serviceInfo.applicable_to_division && 
          paidServiceCtrl.choosenTarif.number_of_divisions == 1 && 
          obj.items.length == 1) {
        obj.items[0].checked = true;
        paidServiceCtrl.divisionCheckedCount = 1;
      }

      // если чек компании и если нет возможности выбрать подразделение
      if (isCompany && 
          !paidServiceCtrl.serviceInfo.applicable_to_division &&
          obj.items.length == 1 && 
          paidServiceCtrl.choosenTarif.number_of_cashregisters == 1 && 
          obj.items[0].items.length == 1) {
        obj.items[0].items[0].checked = true;
        paidServiceCtrl.cashregCheckedCount = 1;
      }

      // если подразделение, и одна касса, то чекнуть
      if (!isCompany && 
          paidServiceCtrl.choosenTarif.number_of_divisions == 1 && 
          divisionslength == 1 &&
          obj.items.length == 1 && 
          paidServiceCtrl.choosenTarif.number_of_cashregisters == 1) {
        obj.items[0].checked = true;
        paidServiceCtrl.cashregCheckedCount = 1;
      }
      
    };

    // полный сброс галочек, при переключении тарифа
    paidServiceCtrl.resetChecked = function () {
      _.forEach(paidServiceCtrl.serviceApplicationMap, function (company) {
        company.checked = false;
        _.forEach(company.items, function (division) {
          division.checked = false;
          _.forEach(division.items, function (cash) {
            cash.checked = false;
          });
        });
      });
      paidServiceCtrl.companyCheckedCount = 0;
      paidServiceCtrl.divisionCheckedCount = 0;
      paidServiceCtrl.cashregCheckedCount = 0;
    }

    // проверка есть ли отмеченные подразделения, у которых есть кассы
    paidServiceCtrl.hasCheckedItem = function (company) {
      var hasChecked = false;
      _.forEach(company.items, function (division) {
        if (division.checked && division.items.length) {
          hasChecked = true;
        }
      });
      return hasChecked;
    }

    //
    paidServiceCtrl.hasVisibleCashregisters = function () {
      var hasChecked = false;
      _.forEach(paidServiceCtrl.serviceApplicationMap, function (company) {
        if (company.checked && company.items.length) {
          _.forEach(company.items, function (division) {
            if (division.checked && division.items.length) {
              hasChecked = true;
            }
          });
        }
      });
      return hasChecked;
    }

    paidServiceCtrl.hasVisibleDivisions = function () {
      var hasChecked = false;
      _.forEach(paidServiceCtrl.serviceApplicationMap, function (company) {
        if (company.checked && company.items.length) {
          hasChecked = true;
        }
      });
      return hasChecked;
    }

    paidServiceCtrl.chooseTarif = function (priceObj) {
      paidServiceCtrl.choosenTarif = priceObj;
      paidServiceCtrl.resetChecked();
      paidServiceCtrl.autocompleteServiceApplication();
    }

    paidServiceCtrl.copied = function () {
      requestStatus.success("Скопировано");
    }

    function _prepareSave (requestObj) {
      _.forEach(paidServiceCtrl.serviceApplicationMap, function (company) {
        if (company.checked && paidServiceCtrl.serviceInfo.applicable_to_company) {
          requestObj.companies.push({
            id: company.idCompany,
            name: company.name
          });
        }
        _.forEach(company.items, function (division) {
          if (division.checked && paidServiceCtrl.serviceInfo.applicable_to_division) {
            requestObj.divisions.push({
              id: division.idDivision,
              name: division.name
            });
          }
          _.forEach(division.items, function (cashRegister) {
              if (cashRegister.checked && paidServiceCtrl.serviceInfo.applicable_to_cashregister) {
                requestObj.cash_registers.push({
                  id: cashRegister.id || null,
                  created_by: cashRegister.created_by || null,
                  updated_by: cashRegister.updated_by || null,
                  manufacturer: cashRegister.manufacturer || null,
                  model: cashRegister.model || null,
                  serial_num: cashRegister.serial_num || null,
                  division: cashRegister.division || null
                });
              }
          });
        });
      });
      return requestObj;
    }

    paidServiceCtrl.saveRequest = function (requestObj, tabName) {
      paidServicesService.savePaidService(requestObj).then(function (res) {
        requestStatus.success("Услуга сохранена успешно");
        paidServiceCtrl.serviceInfo.id = res.data.id;
        paidServiceCtrl.serviceInfo.status = res.data.status;

        if (tabName) {
          paidServiceCtrl.returnToPage(tabName);
          return;
        }
        
        paidServiceCtrl.goToCard(res.data.id, true);
      },
      function (error) {
        if (error.status == 403 && (error.data.code == "ACTIVATION_NOT_AVAILABLE" || error.data.code == "free_trial_period_has_expired")) {
          error.stopHandleError = false;
          errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
        } else {
          requestStatus.error('Во время сохранения услуги произошла ошибка. Повторите попытку позже.');
        }
      });
    }

    paidServiceCtrl.activate = function () {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Активация";
          $scope.text = "Активировать услугу <strong>" + paidServiceCtrl.serviceInfo.name + "</strong>?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            var requestObj = {
              status: "ACTIVE",
              email: $rootScope.user.email,
              price: paidServiceCtrl.choosenTarif,
              cash_registers: [],
              companies: [],
              divisions:[]
            }
            requestObj = _prepareSave(requestObj);
            if (requestObj.companies.length > 0) {
              requestObj.payer = {
                id: requestObj.companies[0].id,
                name: requestObj.companies[0].name
              };
            }
            $uibModalInstance.dismiss();
            paidServiceCtrl.saveRequest(requestObj);
          };
        }
      });
    };

    paidServiceCtrl.choose = function () {
      var requestObj = {
        status: "DRAFT",
        email: paidServiceCtrl.serviceInfo.email || $rootScope.user.email,
        price: paidServiceCtrl.choosenTarif,
        cash_registers: [],
        companies: [],
        divisions:[]
      }
      requestObj = _prepareSave(requestObj);
      paidServiceCtrl.saveRequest(requestObj, "EMPTY");
    } 

    paidServiceCtrl.save = function () {
      var cleanPrice = serviceInfo.price;
      cleanPrice.service = undefined;
      var requestObj = {
        status: serviceInfo.status,
        effective_date: serviceInfo.effective_date,
        expire_date: serviceInfo.expire_date,
        payment_document_date: serviceInfo.payment_document_date,
        payment_document_number: serviceInfo.payment_document_number,
        payer: serviceInfo.payer,
        email: paidServiceCtrl.serviceInfo.email,
        price: cleanPrice,
        cash_registers: [],
        companies: [],
        divisions:[]
      };
      requestObj = _prepareSave(requestObj);
      paidServicesService.updatePaidService(serviceInfo.id, requestObj).then(function (res) {
        requestStatus.success("Услуга сохранена успешно");
        paidServiceCtrl.returnToPage(paidServiceCtrl.serviceInfo.status);
      }, function (error) {
        if (error.status == 409) {
          requestStatus.error('Закончились попытки обновления списка объектов применения.');
        } else {
          requestStatus.error('Во время сохранения услуги произошла ошибка. Повторите попытку позже.');
        }
      });
    };

    paidServiceCtrl.getSubscriptionsStatus = function(subscriptions) {
      var status = "";
      var now = moment().valueOf();
      _.forEach(subscriptions, function (subscription) {
        if (subscription.name == paidServiceCtrl.serviceInfo.name && 
            subscription.status == 'INVOICE_SENT' &&
            !subscription.expire_date) {
          status = "yellow";
        } else if (subscription.name == paidServiceCtrl.serviceInfo.name && 
            subscription.status == 'ACTIVE' &&
            subscription.expire_date > now) {
          status = "green";
        }
      });
      return status;
    };

    paidServiceCtrl.getSubscriptionDate = function(subscription) {
      var resultStr = "";
      if (subscription.status == 'ACTIVE') {
        resultStr = 'Действует до';
      } else if (subscription.status == 'INVOICE_SENT') {
        resultStr = 'Выставлен счет';
      } else {
        resultStr = 'Истекла';
      }
      if (subscription.expire_date) {
        resultStr += ' ' + $filter('date')(subscription.expire_date, 'dd.MM.yyyy');
      }
      return resultStr;
    };

    // TODO Перенести логику метода removeOtherServices на бэк
    // Удаление одинаковых услуг, которые ожидают оплаты
    function removeOtherServices (id) {
      paidServicesService.getPaidSubscription({
        current: 0,
        limit: 100,
        offset: 0
      }, "", "INVOICE_SENT").then(function (res) {
        var sameServices = _.filter(res.data.items, function (service) {
          return service.invoice_out.id == id;
        });
        _.forEach(sameServices, function (service) {
            paidServicesService.deletePaidService(service.id).then(function () {}, function () {
              requestStatus.error('Во время удаления услуги произошла ошибка. Повторите попытку позже.');
            });
        });
      });
    }

    paidServiceCtrl.extendAndPrint = function (invoice_out_id) {
      var modal = $uibModal.open({
        size: 'small-width',
        component: 'extendSubscribePopup',
        controllerAs: 'extendSubscribeCtrl',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          serviceId: function() {
            return $stateParams.id;
          },
          invoice_out_id: function() {
            return invoice_out_id;
          },
          callback: function () {
            return paidServiceCtrl.returnToPage;
          }
        }
      });
    }

    paidServiceCtrl.delete = function () {
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'все подписки из этого счета';

          $scope.close = function () {
            $uibModalInstance.dismiss();
          };

          $scope.delete = function() {
            $scope.lock = true;
            
            paidServicesService.deletePaidService(serviceInfo.id).then(function (res) {
              requestStatus.success("Услуга успешно удалена");
              removeOtherServices(serviceInfo.invoice_out.id);
              $timeout(function(){
                paidServiceCtrl.returnToPage(paidServiceCtrl.serviceInfo.status);
              }, 1000);
            }, function () {
              requestStatus.error('Во время удаления услуги произошла ошибка. Повторите попытку позже.');
            });
          };
        }
      });
    }

    paidServiceCtrl.loadUTD = function () {
      if (!paidServiceCtrl.serviceInfo.consignment_note_out || !paidServiceCtrl.serviceInfo.consignment_note_out.id) 
        return;
      
      $uibModal.open({
        size: 'middle-width',
        component: 'documentPrint',
        controllerAs: '$ctrl',
        resolve: {
          printForm: {
            name: "Загрузка УПД",
            code: "DPF_CONSIGNMENT_NOTE_OUT_UTD_SHOT"
          },
          documentId: function () {
            return paidServiceCtrl.serviceInfo.consignment_note_out.id
          },
          printNow: true
        }
      });
    }

    paidServiceCtrl.buildMap();
    //предустановка тарифа
    if ($stateParams.tarif) {
      paidServiceCtrl.choosenTarif = _.find(paidServiceCtrl.serviceInfo.prices, function (priceObj) {
        return priceObj.id == $stateParams.tarif;
      });
    }

    if (paidServiceCtrl.choosenTarif)
        paidServiceCtrl.autocompleteServiceApplication();

  }
})();

(function() {
  'use strict';

  angular.module('frontend').controller('expenseItemCrudController', expenseItemCrudController);

  function expenseItemCrudController($scope, $stateParams, $state, $window, $uibModal, expenseItemsService, cardHistory, expenseItem, errorMessageService, utilsService, $log, $q, askDeleteSrv) {
    var expenseItemCrudCtrl = this;

    // для возврата на предыдущую страницу
    expenseItemCrudCtrl.returnToPage = function(){
      var prev = cardHistory.popStep('expenseItemId', $stateParams.expenseItemId) || {name: 'expenseItems', param: {parent: 'money'}};
      $state.go(prev.name !== '' ? prev.name : 'expenseItems', prev.param || {parent: 'money'});
    };

    expenseItemCrudCtrl.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    };
    // Инициализация  статьи затрат
    if (expenseItem) {
      expenseItemCrudCtrl.expenseItem = expenseItem;
    } else {
      expenseItemCrudCtrl.expenseItem = {active: true};
    }

    expenseItemCrudCtrl.resetData = function(){
      $scope.addexpenseItem.$setPristine();
      expenseItemCrudCtrl.returnToPage()
    };

    // Метод, вызываемый при сохранении или изменении сотрудника
    expenseItemCrudCtrl.save = function () {
      var deferred = $q.defer();
      if ($scope.addexpenseItem.$valid) {// проверка валидности формы
        if (expenseItemCrudCtrl.expenseItem.id) {
          // Блок обновления
          return expenseItemsService.updateExpenseItem(expenseItemCrudCtrl.expenseItem).then(
            function (res) {
              expenseItem = res.data;
              expenseItemCrudCtrl.resetData();
            },
            function (error) {
              if(error.status == 409 && error.data.code == "non_unique"){
                $scope.addexpenseItem[error.data.parameters[0].name].$setValidity('unique', false);
              }else{
                errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        } else {
          // Блок создания
          if(!expenseItemCrudCtrl.expenseItem.name) return;
          return expenseItemsService.createExpenseItem(expenseItemCrudCtrl.expenseItem).then(
            function () {
              expenseItemCrudCtrl.resetData();
            },
            function (error) {
              if(error.status == 409 && error.data.code == "non_unique"){
                $scope.addexpenseItem[error.data.parameters[0].name].$setValidity('unique', false);
              }else{
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        }
      } else {
        $scope.addexpenseItem.name.$setDirty();
        expenseItemCrudCtrl.isSetDirty = true;
        return $q.when();
      }
    };


    expenseItemCrudCtrl.uniqueCheck = function(str){
      if(str || expenseItemCrudCtrl.expenseItem.name){
        var obj = {
          "constraint_name": "EXPENSE_ITEM",
          "parameters": [
            {
              "name": "name",
              "value": str || expenseItemCrudCtrl.expenseItem.name
            }
          ]
        };
        utilsService.uniqueCheck(obj).then(function(){},
        function (error) {
          if(error.status === 409){
            angular.forEach(error.data.parameters, function(field){
              $scope.addexpenseItem[field.name].$setValidity('unique', false);
            });
          } else {
            $log.debug(error)
          }
        });
      }
    };

    /*
     * Метод, вызываемый при открытии попапа удаления проекта
     * @param item объект проекта для удаления
     */
    expenseItemCrudCtrl.delete = function () {
      return askDeleteSrv.showAskDelete(
        expenseItemCrudCtrl.expenseItem.name,
        "статью затрат",
        "Невозможно удалить статью затрат <strong>"+ expenseItemCrudCtrl.expenseItem.name +"</strong>.<br>Для удаления статьи затрат необходимо удалить все связанные с ней документы.",
        expenseItemCrudCtrl.expenseItem.id,
        expenseItemsService.deleteExpenseItem
      ).then(function (data) {
        expenseItemCrudCtrl.resetData();
      });
    };

    expenseItemCrudCtrl.uniqueCheck = function(){
      if(expenseItemCrudCtrl.expenseItem.name){
        var obj = {
          "constraint_name": "EXPENSE_ITEM",
          "parameters": [
            {
              "name": "name",
              "value": expenseItemCrudCtrl.expenseItem.name
            }
          ]
        };
        obj.id = expenseItemCrudCtrl.expenseItem.id || null;
        utilsService.uniqueCheck(obj).then(function(res){},
        function (error) {
          if(error.status == 409){
            $scope.addexpenseItem[error.data.parameters[0].name].$setValidity('unique', false);
          }
        });
      }
    };

    expenseItemCrudCtrl.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        expenseItemCrudCtrl.isSetDirty = true;
        return true;
      }
      return false;
    }

    expenseItemCrudCtrl.setDirty = function () {
      expenseItemCrudCtrl.isSetDirty = true;
      utilsService.setDirty($scope.addexpenseItem);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    expenseItemCrudCtrl.crud = function (status) {
      switch(status) {
        case 'save':
          if ($scope.addexpenseItem.$invalid) {
            return expenseItemCrudCtrl.setDirty();
          } else {
            return expenseItemCrudCtrl.save();
          }
          break;
        case 'delete':
          return expenseItemCrudCtrl.delete();
          break;
        case 'return':
          expenseItemCrudCtrl.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('expenseItem.edit', {parent: 'money'});
          return $q.when();
        default :
          return $q.when();
          break;
      }
    }

  }

})();


'use strict';
angular.module('frontend').component('printUsers', {
  templateUrl: 'app/settings/employees/print-component/print-users-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope, print, helpService, authToken, statusSrv, $timeout, API_URL, downloadSrv) {
    var ctrl = this;
    print.turnonInterceptorStatus();
    ctrl.format = { type: 'PDF' };

    ctrl.longRequest = {
      format: null,
      exec_id: null,
      crudState: helpService.getCrudStateStructure(),
      flags: {
        processStart: false,
        finish: false
      },
      stopAskingError: function(){
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function(err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
      },
      revert: function() {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };

    ctrl.close = function() {
      ctrl.modalInstance.dismiss();
    };

    ctrl.print = function() {
      if (!ctrl.longRequest.flags.processStart) {
        ctrl.longRequest.flags.processStart = true;
        ctrl.processStart = true;
        ctrl.longRequest.crudState.startLoading();
        print.printUsers(ctrl.format.type).then(function(res) {
          ctrl.longRequest.exec_id = res.data.exec_id;
          statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
            ctrl.longRequest.flags.finish = true;
            print.turnoffInterceptorStatus();
            $timeout(function() {
              downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
                ctrl.longRequest.crudState.stopLoadingSuccess();
                $timeout(function() {
                  ctrl.modalInstance.dismiss();
                }, 300, false)
              });
            });
          },ctrl.longRequest.onError);
        }).catch(ctrl.longRequest.onError);

      }
    };


  }
});


/**
 * Created by aivanov on 25.05.2017.
 */
(function () {
  'use strict';
  /*eslint angular/controller-as-vm: [2,"employeeCrudCtrl"]*/
  angular.module('frontend').controller('EmployeesCrudController', EmployeesCrudController);

  function EmployeesCrudController($scope,
                                   $log,
                                   $state,
                                   $stateParams,
                                   $filter,
                                   $uibModal,
                                   $window,
                                   $q,
                                   $rootScope,
                                   employeesService,
                                   user,
                                   roles,
                                   companies,
                                   timezones,
                                   me,
                                   errorMessageService,
                                   requestStatus,
                                   tree,
                                   utilsService,
                                   cardHistory,
                                   $anchorScroll,
                                   auth,
                                   askDeleteSrv,
                                   projectsService) {
    var employeesCrudCtrl = this;
    employeesCrudCtrl.showCashColumn = false;
    employeesCrudCtrl.state = $state;
    // флаги компонента с универсальным вводом телефона и почты
    employeesCrudCtrl.flags = {};

    // для возврата на предыдущую страницу
    employeesCrudCtrl.returnToPage = function (modifiedPhone) {
      var prev = cardHistory.popStep('userId', $stateParams.userId || null);
      prev.param.modifiedPhone = modifiedPhone;
      $state.go(prev && prev.name || 'employees', prev.param || {parent: 'business'});
    };

    /* Автодополнение проектов */
    employeesCrudCtrl.refreshProjects = function (search) {
      projectsService.projectsSearch(search, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH, {filter_active: true}).then(function (res) {
        employeesCrudCtrl.projects = res.data;
        if (!employeesCrudCtrl.projectsFullTotal) {
          employeesCrudCtrl.projectsFullTotal = res.data.total;
        }
      });
    }
    employeesCrudCtrl.totalSelectStr = function () {
      if (employeesCrudCtrl.projectsFullTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH) {
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + employeesCrudCtrl.projectsFullTotal;
      }
      return '';
    };

    employeesCrudCtrl.initData = function () {
      // Сотрудник
      if ($state.current.name === 'employee.new' || !user) {
        // Инициализация DTO пользователя при создании нового (TODO: дополнительно рповерить состояние)
        employeesCrudCtrl.user = {
          enabled: true,
          data_access_rules: tree,
          contact_info: {
            details: []
          }
        }
      } else {
        employeesCrudCtrl.user = angular.copy(user);
        employeesCrudCtrl.mailNotRequired = !user.email;
        
        if (employeesCrudCtrl.user.contact_info &&
          (!employeesCrudCtrl.user.contact_info.details || !employeesCrudCtrl.user.contact_info.details.length)) {
          employeesCrudCtrl.user.contact_info.details = []
        }
        if (!employeesCrudCtrl.user.email && employeesCrudCtrl.user.email_confirmed) {
          employeesCrudCtrl.user.email_confirmed = false;
        }
        if (!employeesCrudCtrl.user.phone && employeesCrudCtrl.user.phone_confirmed) {
          employeesCrudCtrl.user.phone_confirmed = false;
        }
      }
    };
    employeesCrudCtrl.initData();

    employeesCrudCtrl.isPublicRole = function(userRole) {
      return !!_.find(roles, function (role) {
        return userRole == role.id && role.is_public;
      });
    }

    employeesCrudCtrl.resetData = function (changedPhone) {
      employeesCrudCtrl.initData();
      employeesCrudCtrl.returnToPage(changedPhone)
    };

    employeesCrudCtrl.changeRole = function () {
      var currentRoles = [];
      angular.forEach(employeesCrudCtrl.rolesMap, function (value, key) {
        if (value.enabled)
          this.push(key);
      }, currentRoles);
      if (currentRoles.indexOf('seniorcashier') != -1
        || currentRoles.indexOf('cashier') != -1) {
        employeesCrudCtrl.showCashColumn = true;
      } else {
        employeesCrudCtrl.showCashColumn = false;
        // сброс доступов к кассовым местам, если сняли поль кассиров
        angular.forEach(employeesCrudCtrl.user.data_access_rules.company_access_rules, function (company) {
          angular.forEach(company.division_access_rules, function (division) {
            division.has_access_to_cash_register_places = false;
            angular.forEach(division.cash_register_access_rules, function (place) {
              place.has_access = division.has_access_to_cash_register_places;
            });
          });
        });
      }
      employeesCrudCtrl.hideCompanies = currentRoles.length == 1 && currentRoles[0] == 'admin';
      //устанавливает обязательность выбора одного из чекбоксов
      employeesCrudCtrl.requiredCheckbox = currentRoles.length == 0;
      //Красная рамка вокруг чекбоксов
      employeesCrudCtrl.redCheckbox = employeesCrudCtrl.requiredCheckbox
    };

    employeesCrudCtrl.allCompanyAccess = function () {
      if (employeesCrudCtrl.user.data_access_rules.has_access) {
        angular.forEach(employeesCrudCtrl.user.data_access_rules.company_access_rules, function (company) {
          company.enabled = true;
          employeesCrudCtrl.checkAllCompany(company, true);
        });
      }
    };

    employeesCrudCtrl.checkAllCompany = function (companyItem, allCompanyAccess) {
      angular.forEach(employeesCrudCtrl.user.data_access_rules.company_access_rules, function (company) {
        if (companyItem.company_id == company.company_id) {
          company.has_access = companyItem.enabled;
          angular.forEach(company.division_access_rules, function (division) {
            division.has_access = companyItem.enabled;
            if (!allCompanyAccess) {
              division.has_access_to_cash_register_places = false;
            }
            angular.forEach(division.cash_register_access_rules, function (cash) {
              cash.has_access = division.has_access_to_cash_register_places;
            });
          });
        }
      });
      if (!companyItem.enabled) {
        employeesCrudCtrl.user.data_access_rules.has_access = false;
      }
    };

    if ($state.current.name === 'employee.new' || !user) {
      employeesCrudCtrl.user.data_access_rules.has_access = true;
      employeesCrudCtrl.allCompanyAccess();
    }

    // Доступные для выбора роли
    employeesCrudCtrl.roles = roles;
    // Доступные для выбора компании (все возможные)
    employeesCrudCtrl.companies = companies;
    // Временные зоны
    employeesCrudCtrl.timezones = timezones;
    // Текущий пользователь
    employeesCrudCtrl.me = me.user;
    // Состояние
    employeesCrudCtrl.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    };

    // С сервера не получить пока
    employeesCrudCtrl.divisionsTabs = [
      {
        type: "OFFICE",
        title: "Офисы"
      },
      {
        type: "SHOP",
        title: "Магазины"
      },
      {
        type: "STOREHOUSE",
        title: "Склады"
      }
    ];


    // Подготовка структур для работы с ролями
    var prepareRoles = function () {
      // Инициалиция карты ролей
      employeesCrudCtrl.rolesMap = {};
      angular.forEach(employeesCrudCtrl.roles, function (role) {
        employeesCrudCtrl.rolesMap[role.id] = {
          enabled: false,
          name: role.name,
          description: role.description
        }
      });
      // Устанавливаем атктивные роли по DTO пользователя
      angular.forEach(employeesCrudCtrl.user.roles, function (role) {
        if (employeesCrudCtrl.rolesMap[role]) {
          employeesCrudCtrl.rolesMap[role].enabled = true;
        } else {
          $log.warn('Неизвестная роль: ' + role)
        }
      });
    };

    // Инициализация вспомогательных структур для раоты с сотрудником
    var prepareUser = function () {
      // Подготовка ролей
      prepareRoles();
      // Настраиваем персональные данные
      /*if (employeesCrudCtrl.user.person) {
        employeesCrudCtrl.person = {
          id: employeesCrudCtrl.user.person.id,
          name: employeesCrudCtrl.user.person.name,
          surname: employeesCrudCtrl.user.person.surname,
          patronymic: employeesCrudCtrl.user.person.patronymic
        }
      }*/

      // Подготовка временной зоны
      employeesCrudCtrl.timeZoneSelected = _.find(timezones, function (timezone) {
        return timezone.timezoneId == employeesCrudCtrl.user.time_zone
      });
      // Скрытые поля ввода
      employeesCrudCtrl.showLocation = employeesCrudCtrl.user.time_zone || employeesCrudCtrl.user.location;
      // Скрытые поля комментария
      employeesCrudCtrl.showComment = !!employeesCrudCtrl.user.comment;
      // Установка флага активным компаниям
      if (employeesCrudCtrl.user.data_access_rules && employeesCrudCtrl.user.data_access_rules.company_access_rules) {
        angular.forEach(employeesCrudCtrl.user.data_access_rules.company_access_rules, function (company) {
          if (company.has_access) {
            company.enabled = true;
          } else {
            angular.forEach(company.division_access_rules, function (division) {
              if (division.has_access) {
                company.enabled = true;
              }
            })
          }
        })
      }


      if (user && !user.login) {
        employeesCrudCtrl.disableLogin = true;
        employeesCrudCtrl.user.login = ((employeesCrudCtrl.user.phone && employeesCrudCtrl.user.phone_confirmed) ? $filter('phoneFormat')(employeesCrudCtrl.user.phone) : (employeesCrudCtrl.user.email && employeesCrudCtrl.user.email_confirmed) ? employeesCrudCtrl.user.email : '-');
      }
    };

    prepareUser();

    // Метод, вызываемый при удалении сотрудника
    employeesCrudCtrl.delete = function () {
      if (employeesCrudCtrl.user.id !== me.user.id) {
        return askDeleteSrv.showAskDelete(
          employeesCrudCtrl.user.name,
          "сотрудника",
          "Невозможно удалить сотрудника <strong>" + employeesCrudCtrl.user.name + "</strong>.<br>Для удаления сотрудника необходимо удалить все связанные с ним документы.",
          employeesCrudCtrl.user.id,
          employeesService.deleteUser
        ).then(function (data) {
          employeesCrudCtrl.resetData();
        });
      } else {
        requestStatus.error('Нельзя удалить пользователя, под которым вы сейчас работаете.');
        return $q.when();
      }
    };

    employeesCrudCtrl.closeTab = function () {
      if ($stateParams.closeTab) {
        $window.close();
      }
    }

    function prepareSave(user) {
      if (employeesCrudCtrl.user.data_access_rules &&
        employeesCrudCtrl.user.data_access_rules.company_access_rules) {
        angular.forEach(employeesCrudCtrl.user.data_access_rules.company_access_rules, function (value, key) {
          value.enabled = undefined;
        });
      }

      var data = {
        id: user.id,
        comment: user.comment,
        contact_info: user.contact_info,
        data_access_rules: angular.copy(user.data_access_rules),
        email: user.email,
        email_confirmed: (employeesCrudCtrl.email) ? true : user.email_confirmed,
        enabled: user.enabled,
        // переходный период, приходится для старых ползователей у которых есть логин так отображать страницу
        login: employeesCrudCtrl.disableLogin ? null : user.login,
        name: user.name,
        need_change_password: user.need_change_password,
        pending_email_changes: user.pending_email_changes,
        person: user.person,
        phone: user.phone,
        phone_confirmed: user.phone_confirmed,
        project: user.project,
        roles: [],
        time_zone: user.time_zone,
        location: user.location,
        user_photo: user.user_photo,
        from_profile: (user && user.id && user.id === $rootScope.user.id) ? true : undefined
      };

      angular.forEach(employeesCrudCtrl.rolesMap, function (value, key) {
        if (value.enabled) {
          data.roles.push(key);
        }
      });

      if (employeesCrudCtrl.timeZoneSelected) {
        data.time_zone = employeesCrudCtrl.timeZoneSelected.timezoneId;

      }

      if (data.data_access_rules) {
        angular.forEach(data.data_access_rules.company_access_rules, function (value, key) {
          value.enabled = undefined;
        });
      }
      if (!employeesCrudCtrl.user.enabled) {
        data.data_access_rules.has_access = false;
      }
      if (data.roles.length == 1 && data.roles[0] == 'admin') {
        data.data_access_rules = tree;
      }

      return data;
    }

    function applySavedData(data) {
      angular.forEach(data, function (value, key) {
        employeesCrudCtrl.user[key] = value;
      });
      employeesCrudCtrl.eform.$setPristine();
    }

    employeesCrudCtrl.emailErrStr = function () {
      return (employeesCrudCtrl.mode.isNew) ? 'Телефон или Email должны быть заполнены' : 'Телефон, Email или Логин должны быть заполнены';
    }

    // Метод, вызываемый при сохранении или изменении сотрудника
    employeesCrudCtrl.save = function () {
      var deferred = $q.defer();
      if (!employeesCrudCtrl.user.login && !employeesCrudCtrl.user.phone && !employeesCrudCtrl.user.email) {
        employeesCrudCtrl.eform.phone.$setValidity('required', false);
        employeesCrudCtrl.eform.email.$setValidity('required', false);
        employeesCrudCtrl.eform.phone.$setDirty();
        employeesCrudCtrl.eform.email.$setDirty();
        if (employeesCrudCtrl.eform.login && !employeesCrudCtrl.disableLogin) {
          employeesCrudCtrl.eform.login.$setValidity('required', false);
          employeesCrudCtrl.eform.login.$setDirty();
        }
        $window.scrollTo(0, 0);
        return $q.when();
      }


      if (employeesCrudCtrl.eform.$valid) {
        if (employeesCrudCtrl.user.id) {
          // Блок обновления
          return employeesService.updateUser(prepareSave(employeesCrudCtrl.user)).then(
            function (res) {
              // если сменился телефон или статус активности уходит СМС
              var changedPhone = (res.data.enabled && res.data.phone &&
                (user.phone != res.data.phone || user.enabled == false)) ? res.data.phone : undefined;
              user = res.data;
              applySavedData(res.data);
              if (employeesCrudCtrl.user.id === $rootScope.user.id) {
                auth.getPermissions(true).then(function () {
                  employeesCrudCtrl.closeTab();
                  employeesCrudCtrl.resetData(changedPhone);
                })
              } else {
                employeesCrudCtrl.closeTab();
                employeesCrudCtrl.resetData(changedPhone);
              }
            },
            function (error) {
              if (error.status == 409) {
                if (error.data.message == "No admins left") requestStatus.error('В группе должен быть хотя бы один пользователь с ролью Администратор');
                angular.forEach(error.data.parameters, function (field) {
                  employeesCrudCtrl._setUniqueValidity(field.name, false);
                  $anchorScroll(employeesCrudCtrl._getFieldNameByConstraintName(field.name));
                });
              } else if (error.status != 500 && error.status != 403 && error.status != 401) {
                errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        } else {
          // Блок создания
          return employeesService.createUser(prepareSave(employeesCrudCtrl.user)).then(
            function (res) {
              var addedPhone = (res.data.enabled && res.data.phone) ? res.data.phone : undefined;
              employeesCrudCtrl.eform.$setPristine();
              employeesCrudCtrl.closeTab();
              employeesCrudCtrl.returnToPage(addedPhone);
            },
            function (error) {
              if (error.status == 409) {
                angular.forEach(error.data.parameters, function (field) {
                  employeesCrudCtrl._setUniqueValidity(field.name, false);
                  $anchorScroll(employeesCrudCtrl._getFieldNameByConstraintName(field.name));
                });
              } else {
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        }
      } else {
        return employeesCrudCtrl.setDirty();
        return $q.when();
      }
    };

    /**
     * Вынесено в отдельный метод из-за логики установки
     * валидности поля универсального логина
     *
     * @param fieldName имя поля в терминах ограничения бекенда
     * @param value значение для установки (true | false)
     * @private
     */
    employeesCrudCtrl._setUniqueValidity = function (fieldName, value) {
      employeesCrudCtrl.eform[fieldName].$setValidity('unique', value);
    };

    employeesCrudCtrl.resetLogin = function (event) {
      if (employeesCrudCtrl.disableLogin && employeesCrudCtrl.user.login) {
        if ((event.target.name == "phone" && !employeesCrudCtrl.user.login.indexOf("+7 (")) || (event.target.name == "email" && !employeesCrudCtrl.user.email && /^[A-z0-9.@]+$/.test(employeesCrudCtrl.user.login))) {
          employeesCrudCtrl.user.login = null;
        }
      }
    };

    // сброс подтверждения и сброс ошибки
    employeesCrudCtrl.resetEmailError = function ($event) {
      employeesCrudCtrl.resetLogin($event);
      employeesCrudCtrl.user.email_confirmed = false;
      employeesCrudCtrl.eform.email.$setValidity('unique', true);
      employeesCrudCtrl.resetLoginError();
      if (!employeesCrudCtrl.user.email && employeesCrudCtrl.user.pending_email_changes.length) {
        employeesCrudCtrl.user.pending_email_changes = [];
      }
    }

    // сброс ошибок логина
    employeesCrudCtrl.resetLoginError = function () {
      employeesCrudCtrl.eform.phone.$setValidity('required', true);
      employeesCrudCtrl.eform.email.$setValidity('required', true);
      if (employeesCrudCtrl.eform.login) {
        employeesCrudCtrl.eform.login.$setValidity('required', true);
      }
    }

    employeesCrudCtrl.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        employeesCrudCtrl.isSetDirty = true;
        return true;
      }
      return false;
    }

    employeesCrudCtrl.setDirty = function () {
      employeesCrudCtrl.isSetDirty = true;
      utilsService.setDirty(employeesCrudCtrl.eform);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid').offset().top - 20);
      return $q.when();
    };

    employeesCrudCtrl.uniqueCheck = function (str, event) {
      var constraintName = 'USER_LOGIN';
      var name = 'login';
      if (event.target.name == "name") {
        constraintName = 'USER_NAME';
        name = 'name';
      } else if (event.target.name == "phone") {
        // случай универсального логина
        constraintName = 'USER_PHONE';
        name = 'phone';
      } else if (event.target.name == "email") {
        // случай универсального логина
        constraintName = 'USER_EMAIL';
        name = 'email';
      }
      if (str) {
        var obj = {
          "constraint_name": constraintName,
          "parameters": [
            {
              "name": name,
              "value": str
            }
          ]
        };
        if (employeesCrudCtrl.user.id) obj.id = employeesCrudCtrl.user.id;
        utilsService.uniqueCheck(obj).then(function (res) {
          },
          function (error) {
            if (error.status == 409) {
              employeesCrudCtrl._setUniqueValidity(name, false);
            }
          });
      }
    };

    employeesCrudCtrl.crud = function (status) {
      switch (status) {
        case 'save':
          if (employeesCrudCtrl.eform.$valid) {
            return employeesCrudCtrl.save();
          } else {
            return employeesCrudCtrl.setDirty();
          }
          break;
        case 'delete':
          return employeesCrudCtrl.delete();
          break;
        case 'return':
          employeesCrudCtrl.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('employee.edit', {parent: 'business'});
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    };

    // для отслеживания отключения доступов в диррективах и отключения доступа ко всем компаниям
    $scope.$watch('employeesCrudCtrl.user.data_access_rules.company_access_rules', function (newVal, oldVal) {
      angular.forEach(newVal, function (division) {
        if (!division.has_access) {
          employeesCrudCtrl.user.data_access_rules.has_access = false;
        }
      });
    }, true);

    employeesCrudCtrl.openImgView = function () {
      if (employeesCrudCtrl.user.user_photo) {
        $uibModal.open({
          templateUrl: 'app/settings/templates/modals/img-view.html',
          windowClass: 'img-view-popup',
          controller: function ($scope, $uibModalInstance) {
            $scope.img = employeesCrudCtrl.user.user_photo.url;
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };
          }

        });
      }
    };

    employeesCrudCtrl.showImgLoadPopup = function () {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/img-editor/img-editor.html',
        windowClass: 'img-editor-popup',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance, API_URL, authToken, Upload) {
          $scope.title = "Фотография пользователя";
          $scope.imgWidth = 301;
          $scope.imgHeight = 402;
          $scope.imgType = 'square';
          $scope.temp = {
            outputImage: undefined,
            inputImage: undefined
          };
          $scope.rotate = 0;

          $scope.rotateAction = function (deg) {
            $scope.rotate += deg;
          };

          $scope.changeFile = function (elem) {
            var input = elem;
            if (input.files && input.files[0]) {
              var reader = new FileReader();
              reader.onload = function (e) {
                $scope.$apply(function () {
                  $scope.temp.inputImage = e.target.result;
                });
              }
              reader.readAsDataURL(input.files[0]);
            }
          };

          $scope.removeImg = function () {
            $scope.temp.inputImage = null;
            $scope.temp.outputImage = null;
          };

          // функция преобразует dataUrl в file
          $scope._dataURLtoBlob = function (dataUrl, name) {
            var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], {type: mime});

            blob.name = name;
            blob.lastModifiedDate = new Date();
            return blob;
          };

          $scope.save = function () {
            if (!$scope.temp.outputImage) {
              employeesCrudCtrl.user.user_photo = undefined;
              $scope.close();
              return;
            }
            Upload.upload({
              url: API_URL + "/upload",
              headers: {'X-Session-Id': authToken.getToken()},
              data: {
                file: $scope._dataURLtoBlob($scope.temp.outputImage),
                type: "USER_PHOTO",
                name: "USER_PHOTO"
              }
            }).then(function (resp) {
              employeesCrudCtrl.user.user_photo = resp.data;
              $scope.close();
            });
          };

          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    employeesCrudCtrl.allCompanyAccess();

  }

})();

(function() {
  'use strict';

  /*eslint angular/controller-as-vm: [2,"divisionCrudCtrl"]*/
  angular.module('frontend').controller('crudDivisionController', crudDivisionController);

  function crudDivisionController($scope,$log, $filter, helpService, $state, $uibModal, errorMessageService, $stateParams, allPaymentTypes,
                                  companyService, paymentTypesService, division, utilsService, currenciesService, $q, taxModalSrv, $rootScope,
                                  uiSelectStructure, homeCurrency, cardHistory, $anchorScroll, defaultBankPaymentType, projectsService, $window) {
    var divisionCrudCtrl = this;
    divisionCrudCtrl.currencies = {};
    divisionCrudCtrl.companies = [];
    divisionCrudCtrl.today = moment().utc().startOf('day');
    divisionCrudCtrl.allPaymentTypes = allPaymentTypes;
    var cashPayment = {};
    divisionCrudCtrl.typeStr = {
      OFFICE: "Офис",
      SHOP: "Магазин",
      STOREHOUSE: "Склад"
    };

    divisionCrudCtrl.specialTaxes = [{
      type: "IMPUTED",
      name: "ЕНВД"
    },{
      type: "PATENT",
      name: "Патент"
    }];

    divisionCrudCtrl.showPopup = function(viewType){
      divisionCrudCtrl.promice = taxModalSrv.showModal(false, viewType, divisionCrudCtrl.mode,
                                                      divisionCrudCtrl.tax_modes_modified, divisionCrudCtrl.specialTaxes);
      divisionCrudCtrl.promice.result.then(function(res) {
        if(res){
          divisionCrudCtrl.currentTax = res.currentTax;
          divisionCrudCtrl.tax_modes_modified = res.tax_modes_modified;
          if(res.currentTax && res.currentTax.$$end_date){
            divisionCrudCtrl.currentTax.end_date = res.currentTax.$$end_date;
          }
          if(!res.tax_modes_modified.length){
            divisionCrudCtrl.specialTaxOn = false;
          }
        }
      });
    }

    // для возврата на предыдущую страницу
    divisionCrudCtrl.returnToPage = function(){
      var prev = cardHistory.popStep('divisionId', $stateParams.divisionId) || {name: 'divisions', param: {parent: 'business'}};
      $state.go(prev.name !== '' ? prev.name : 'divisions', prev.param || {parent: 'business'});
    };

    // подстановка компании
    divisionCrudCtrl.companies = uiSelectStructure.getStructure(companyService.companiesSearch, divisionCrudCtrl.company, true, true);

    companyService.companies({limit: 100}, null).then(function (res) {
      // для подставления компании при переходе из раздела компаний
      if (($state.params.companyId || division) && $state.current.name !== 'division.new' ) {
        divisionCrudCtrl.company = _.find(res.data.items, function(company) {
          return company.id === $state.params.companyId;
        });
        divisionCrudCtrl.updateSpecialTaxList(divisionCrudCtrl.company);
      }
    });

    divisionCrudCtrl.currencies = uiSelectStructure.getStructure(currenciesService.getDomainCurrenciesSearch);

    divisionCrudCtrl.onDatePickerClose = function(returnValue, name){
      $scope.addDivision.start_date.$setValidity('dateError', true);
      $scope.addDivision.end_date.$setValidity('dateError', true);
      if(divisionCrudCtrl.isSetDirty &&
        (name == 'start_date' && !returnValue.isEmpty && !divisionCrudCtrl.currentTax.end_date.isEmpty && returnValue.utc().valueOf() > divisionCrudCtrl.currentTax.end_date.utc().valueOf()) ||
        (name == 'end_date' && !returnValue.isEmpty && !divisionCrudCtrl.currentTax.start_date.isEmpty && divisionCrudCtrl.currentTax.start_date.utc().valueOf() > returnValue.utc().valueOf())){
          $scope.addDivision.start_date.$setValidity('dateError', false);
          $scope.addDivision.end_date.$setValidity('dateError', false);
      }
    }

    divisionCrudCtrl.paymentTypes = [];

    /* Автодополнение способов оплаты */
    divisionCrudCtrl.refreshPaymentTypes = function(search, index, checkDefault) {
      var filter = {};
      filter.filter_company_id = divisionCrudCtrl.company ? divisionCrudCtrl.company.id : null;
      filter.filter_type = 'BANK_CARD';
      if (typeof index !== 'undefined') {
        filter.filter_currency_id = divisionCrudCtrl.division.cash_registers[index].currency.id;
      }
      paymentTypesService.paymentTypesAuto(search, 5, filter)
      .then(function (data) {
        if (typeof index !== 'undefined') {
          divisionCrudCtrl.paymentTypes[index] = data.data;
          if (divisionCrudCtrl.paymentTypes[index].total === 1) {
            if(!divisionCrudCtrl.division.cash_registers[index].bank_payment_type){
              divisionCrudCtrl.division.cash_registers[index].bank_payment_type = divisionCrudCtrl.paymentTypes[index].items[0];
            }
          }

          if (checkDefault && divisionCrudCtrl.paymentTypes[index].total > 1) {
            divisionCrudCtrl.division.cash_registers[index].bank_payment_type = _.find(data.data.items, function(item){
              return item.id == defaultBankPaymentType.id;
            });
          }

        } else {
          if (data.data.total === 0) {
            angular.forEach(divisionCrudCtrl.division.cash_registers, function(item) {
              item.bank_payment_type = null;
            })
          }
        }
      })
    };

    /* Автодополнение проектов */
    divisionCrudCtrl.refreshProjects = function (search) {
      projectsService.projectsSearch(search, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH, {filter_active: true}).then(function(res){
        divisionCrudCtrl.projects = res.data;
        if(!divisionCrudCtrl.projectsFullTotal){
          divisionCrudCtrl.projectsFullTotal = res.data.total;
        }
      });
    }
    divisionCrudCtrl.totalSelectStr = function(){
      if(divisionCrudCtrl.projectsFullTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + divisionCrudCtrl.projectsFullTotal;
      }
      return '';
    };

    divisionCrudCtrl.getOtherPaymentTypes = function(search, index) {
      // запрос прочих OTHER способов оплаты
      var filter = {};
      filter.filter_type = 'OTHER';
      paymentTypesService.paymentTypesAuto('', 100, filter).then(function (data) {
        divisionCrudCtrl.otherPaymentType = data.data.items;
      });
    };


    divisionCrudCtrl.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    };

    // показывает блок с выбором специального налогообложения и устанавливает дату по умочанию
    divisionCrudCtrl.showSpecialTaxBlock = function(){
      divisionCrudCtrl.specialTaxOn = true;
      if(divisionCrudCtrl.mode.isNew){
        divisionCrudCtrl.currentTax = {start_date: moment().utc().startOf('day').valueOf()};
      }
      divisionCrudCtrl.updateSpecialTaxList(divisionCrudCtrl.company);
      if (divisionCrudCtrl.mode.isEdit && !divisionCrudCtrl.currentTax) {
        divisionCrudCtrl.showPopup('change');
      }
    }

    // обновить список специальных налогооблажений, в зависимости от типа выбранной компании
    divisionCrudCtrl.updateSpecialTaxList = function(company){
      if(company){
        if(company.legal_status == 'SOLE_TRADER' || (company.organization && company.organization.legal_requisites.legal_status == 'SOLE_TRADER')){
          divisionCrudCtrl.specialTaxes = [{
            type: "IMPUTED",
            name: "ЕНВД"
          },{
            type: "PATENT",
            name: "Патент"
          }];
          if(divisionCrudCtrl.mode.isNew){
            divisionCrudCtrl.currentTax.special_tax_mode = undefined;
          }
        }else{
          divisionCrudCtrl.specialTaxes = [{
            type: "IMPUTED",
            name: "ЕНВД"
          }];
          if(divisionCrudCtrl.currentTax && (divisionCrudCtrl.specialTaxOn || divisionCrudCtrl.division.special_tax_modes)){
            divisionCrudCtrl.currentTax.special_tax_mode = (divisionCrudCtrl.specialTaxOn)? "IMPUTED" : undefined;
          }

        }
      }
    }

    // Инициализация подразделения
    divisionCrudCtrl.companySelected = function() {
      divisionCrudCtrl.updateSpecialTaxList(divisionCrudCtrl.company);
      divisionCrudCtrl.getOtherPaymentTypes();
      if (divisionCrudCtrl.mode.isNew) {
        angular.forEach(divisionCrudCtrl.division.cash_registers, function(cash_register, i) {
          cash_register.bank_payment_type = null;
          divisionCrudCtrl.refreshPaymentTypes('', i, true);
          if ($scope.addDivision['bank_payment_type' + i]) {
            $scope.addDivision['bank_payment_type' + i].$setPristine();
            $scope.addDivision['bank_payment_type' + i].$setUntouched();
          }
        });
      }
    };

    divisionCrudCtrl.currencySelected = function(i) {
      divisionCrudCtrl.refreshPaymentTypes(null, i, true);
    };

    divisionCrudCtrl.onPaymentTypeChange = function(val, index) {
      if (val) {
        divisionCrudCtrl.refreshPaymentTypes(undefined, index, true);
      }
    };


    divisionCrudCtrl.initData = function() {
      if (division && $state.current.name !== 'division.new') {
        divisionCrudCtrl.division = division;
        angular.forEach(divisionCrudCtrl.division.cash_registers, function (cash_register, i) {
          cash_register.$$meta = {};
          _.forEach(divisionCrudCtrl.allPaymentTypes, function(item){
            var type;
            if (item.type == 'OTHER') {
              cash_register.$$meta['other' + item.id] = !!_.find(cash_register.other_payment_types, function(type){
                return type.id == item.id;
              });
            } else {
              type = (item.type == 'BANK_CARD')? 'bank' : item.type.toLowerCase();
              cash_register.$$meta[type] = !!cash_register[type + '_payment_type'];
              if (item.type == 'BANK_CARD') {
                divisionCrudCtrl.refreshPaymentTypes('', i);
              }
              if (item.type == 'CASH') {
                cashPayment = {
                  id: item.id,
                  name: item.name
                };
              }
            }
          });
        });
        divisionCrudCtrl.companySelected();
        divisionCrudCtrl.cashRegistersCopy = angular.copy(division.cash_registers);

        /* Инициализация текущей системы налогообложения */
        divisionCrudCtrl.tax_modes_modified = [];
        if(divisionCrudCtrl.division.special_tax_modes && divisionCrudCtrl.division.special_tax_modes.length){
          divisionCrudCtrl.specialTaxOn = true;
          divisionCrudCtrl.division.special_tax_modes.sort(function (a, b) {
            return a.start_date - b.start_date;
          }) // сортировка массива по возрастанию дат
          angular.forEach(divisionCrudCtrl.division.special_tax_modes, function (tax_mode) { //первичный расчет текущей системы + свойство end_date
            if (!divisionCrudCtrl.currentTax || divisionCrudCtrl.currentTax.start_date < tax_mode.start_date) {// определение текущей системы налогообложения
              if (divisionCrudCtrl.today.valueOf() >= tax_mode.start_date || !divisionCrudCtrl.currentTax) {
                divisionCrudCtrl.currentTax = tax_mode;
              }
            }
          });
          divisionCrudCtrl.tax_modes_modified = angular.copy(divisionCrudCtrl.division.special_tax_modes);
          divisionCrudCtrl.currentTax = divisionCrudCtrl.currentTax || divisionCrudCtrl.tax_modes_modified[divisionCrudCtrl.tax_modes_modified.length - 1]; // если сегодняшняя дата не вписывается в диапазоны существующих систем, показывается наиболее близкая к сегоднящнему дню
          divisionCrudCtrl.tax_modes_modified.reverse();
        }
      } else {
        var paramType = ($state.params.type)? $state.params.type : '';
        divisionCrudCtrl.division = {
          type: paramType || "OFFICE",
          cash_register_places: [{name: "Касса 1"}]
        };
        divisionCrudCtrl.division.cash_registers = [];
        divisionCrudCtrl.currentTax = {start_date: moment().utc().startOf('day')};

      }
      angular.forEach(divisionCrudCtrl.division.cash_register_places, function (place) {
        helpService.addId(place);
      });

      angular.forEach(divisionCrudCtrl.division.cash_registers, function (cash_register) {
        if (cash_register.place && cash_register.place.id) {
          angular.forEach(divisionCrudCtrl.division.cash_register_places, function (place) {
            if (cash_register.place.id === place.id) {
              cash_register.place.$$uiid = place.$$uiid
            }
          })
        }
      });

    };
    divisionCrudCtrl.initData();
    divisionCrudCtrl.getOtherPaymentTypes();

    divisionCrudCtrl.resetData = function(){
      if (divisionCrudCtrl.division.id) {
        divisionCrudCtrl.initData();
      }
      $scope.addDivision.$setPristine();
      divisionCrudCtrl.returnToPage()
    };

    $scope.gridOptions = {
      columnDefs: [
        { name: 'model', displayName: 'Кассовый аппарат', cellTemplate: '<cell-with-tooltip text="(row.entity.manufacturer + \' \' + row.entity.model)"></cell-with-tooltip>'},
        { name: 'serial_number', displayName: 'Заводской номер', cellTemplate: '<cell-with-tooltip text="row.entity.serial_number"></cell-with-tooltip>'},
        { name: 'place.name', displayName: 'Место', cellTemplate: '<cell-with-tooltip text="row.entity.place.name"></cell-with-tooltip>'},
        { name: 'enabled', displayName: 'Статус', cellTemplate: 'cashTemplate.html'},
        { name: 'subscriptions', displayName: 'Подписки', cellTemplate: 'subscriptionsTemplate.html', width: 130}
      ],
      data: divisionCrudCtrl.division.cash_registers
    };

    $scope.getPaymentTypeNames = function(entity) {
      var res = '';
      // формируем строку из указанных типов оплаты
      for (var prop in entity.$$meta) {
        if (entity.$$meta[prop]) {
          if (res) res += ", ";
          // у other источник другой, ищем по id
          if (prop.indexOf('other') + 1) {
            var id = prop.replace('other', '');
            res += _.find(entity.other_payment_types, function(item){
              return id == item.id;
            }).name;
          } else {
            res += entity[prop + '_payment_type'].name;
          }
        }
      }
      return res;
    };


    $scope.getSubscriptionsStatus = function(subscriptions) {
      var status = subscriptions.length? "red" : "";
      var week = moment().add(7, 'day').valueOf();
      _.forEach(subscriptions, function (subscription) {
        if (subscription.sync_enabled && subscription.status == 'ACTIVE' && subscription.expire_date < week) {
          status = "yellow";
        } else if (subscription.sync_enabled && subscription.status == 'ACTIVE' && subscription.expire_date > week) {
          status = "green";
        }
      });
      return status;
    };

    // В методе выполняются подготовительные операции перед сохранением
    divisionCrudCtrl.prepareSave = function () {
      $scope.addDivision.$setValidity('payment', true);
      angular.forEach(divisionCrudCtrl.division.cash_registers, function (cash_register) {
        cash_register.$$noPaymentType = true;
        // необходимо из временного массива расставить значения в объект
        for (var prop in cash_register.$$meta) {
          // в банковскую карту записыватся автоматом через выпадалку
          if (prop !== 'bank') {
            // если other то подставляем тип оплаты по id, иначе по типу
            var otherId = (prop.indexOf('other') + 1)? prop.replace('other', '') : '';
            
            if(cash_register.$$meta[prop]){
              cash_register.$$noPaymentType = false;
              var type = _.find(divisionCrudCtrl.allPaymentTypes, function(item){
                if (otherId) {
                  return otherId == item.id;
                } else {
                  return prop.toUpperCase() == item.type;
                }
              });
              // запись в формате baseRef
              var res = {id: type.id, name: type.name};

              //other все записываются в other_payment_types
              if (otherId) {

                if (!cash_register.other_payment_types) cash_register.other_payment_types = [];
                if (!_.find(cash_register.other_payment_types, function(item){ return item.id === res.id })) {
                  cash_register.other_payment_types.push(res);
                }
              } else {
                cash_register[prop + '_payment_type'] = res;
              }
            } else {
              cash_register[prop + '_payment_type'] = undefined;
              // удалить other, которые не отмечены
              if (otherId) {
                cash_register.other_payment_types = _.filter(cash_register.other_payment_types, function(item){
                  return otherId !== item.id;
                });
              }
            }
          } else {
            // обнуляем банк, если нет галки на нем
            if (!cash_register.$$meta[prop]) {
              cash_register.bank_payment_type = undefined;
            } else {
              cash_register.$$noPaymentType = false;
            }
          }
        }
        if (cash_register.$$noPaymentType) {
          $scope.addDivision.$setValidity('payment', false);
        }
      });

      if (!divisionCrudCtrl.division.total_area && divisionCrudCtrl.division.sales_area) {
        divisionCrudCtrl.division.sales_area = null;
      }

      if (divisionCrudCtrl.tax_modes_modified && divisionCrudCtrl.tax_modes_modified.length) {
          angular.forEach(divisionCrudCtrl.tax_modes_modified, function (tax_mode) {
            if(tax_mode.$$end_date){
              tax_mode.end_date = tax_mode.$$end_date;
            }
          });
          divisionCrudCtrl.division.special_tax_modes = divisionCrudCtrl.tax_modes_modified
      } else {
        divisionCrudCtrl.division.special_tax_modes = [];
        if (divisionCrudCtrl.currentTax && divisionCrudCtrl.currentTax.special_tax_mode) {
          divisionCrudCtrl.division.special_tax_modes.push({
            special_tax_mode: divisionCrudCtrl.currentTax.special_tax_mode,
            start_date: moment(divisionCrudCtrl.currentTax.start_date).valueOf(),
            end_date: (!divisionCrudCtrl.currentTax.end_date || divisionCrudCtrl.currentTax.end_date.isEmpty)? undefined : moment(divisionCrudCtrl.currentTax.end_date).valueOf()
          });
        }
      }
    };

    function onCashRegisterModified(id) {
      var cash_register = divisionCrudCtrl.cashRegistersCopy.find(function(value) { return value.id === id });
      errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {data: {message: 'Зарегистрированный кассовый аппарат ' + cash_register.manufacturer + ' ' + cash_register.model + ' с заводским номером ' + cash_register.serial_number + ' не может быть удален/изменен.'}}});
    }

    // структура для управления директивой адреса
    divisionCrudCtrl.addressOptions = {};
    divisionCrudCtrl.addressCheck = function(addrObj){
      return (addrObj && !addrObj.id) ? divisionCrudCtrl.addressOptions.checkAddr(addrObj.address_as_string).then(function (res) {
        return res;
      }) : $q.when({});
    }

    divisionCrudCtrl.isValidAddr = function(addr){
      if(!addr) return false;
      if(addr.data && addr.data.view_ref){
        return !(addr.data.view_ref.qc == 2 && !addr.data.view_ref.accepted);
      }else{
        return true;
      }
    }

    // Метод, вызываемый при сохранении или изменении
    divisionCrudCtrl.save = function () {
      return divisionCrudCtrl.addressCheck(divisionCrudCtrl.division.address).then(function (values) {
        if(divisionCrudCtrl.isValidAddr(values)){
          var deferred = $q.defer();
          // подготовка структур в соответствие АПИ
          divisionCrudCtrl.prepareSave();
          if ($scope.addDivision.$error.payment) {
            divisionCrudCtrl.setDirty();
            return;
          }
          if (divisionCrudCtrl.division.id) {
            // Блок обновления
            return companyService.updateDivision(divisionCrudCtrl.division, divisionCrudCtrl.company.id).then(function () {
                division = divisionCrudCtrl.division;
                divisionCrudCtrl.resetData();
              }, function (error) {
                if(error.status === 409){
                  if (error.data.code && error.data.code === 'integrity_violation') {
                    errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {data: {message: 'Удаление кассового аппарата невозможно, так как имеются связанные документы'}}});
                  } else if (error.data.code == "business_error" && error.data.message == "Division code contains in object_code") {
                    $scope.addDivision.code.$setValidity('used', false);
                    errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {data: {message: 'Операция отклонена. Невозможно удалить код партнера, по котору были начисления бонусов'}}});
                  } else if (error.data.code === 'cashregister_with_cert_can_not_be_modified') {
                    onCashRegisterModified(error.data.message);
                  } else if(error.data.parameters){
                    if (error.data.parameters[0].name != 'name') {
                      angular.forEach(divisionCrudCtrl.division.cash_registers,
                        function(cash, key) {
                          if (cash.serial_number == error.data.parameters[0].value) {
                            $scope.addDivision['serialNum' + key].$setValidity(
                              'unique', false);
                            $anchorScroll('serialNum' + key);
                          }
                        });
                    } else {
                      angular.forEach(error.data.parameters, function(field) {
                        $scope.addDivision[field.name].$setValidity('unique',
                          false);
                        $anchorScroll(field.name + "Anchor");
                      });
                    }
                  }else{
                    errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
                  }
                }else{
                  if (error.status === 400 && error.data.code === 'cashregister_with_cert_can_not_be_modified') {
                    onCashRegisterModified(error.data.message)
                  } else if (error.data.code == 'bad_arguments' && error.data.fields[0].error) {
                    errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {message: error.data.fields[0].error}});
                  } else {
                    errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
                  }
                }
                divisionCrudCtrl.dataAfterError();
                return deferred.reject();
              }
            )
          } else {
            // Блок создания
            return companyService.createDivision(divisionCrudCtrl.division, divisionCrudCtrl.company.id).then(
              function () {
                // Переход на предыдущую страницу
                divisionCrudCtrl.resetData();
              },
              function (error) {
                if(error.status === 409) {
                  if (error.data.code && error.data.code === 'integrity_violation') {
                    errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {data: {message: 'Нельзя удалить кассовый аппарат или кассовое место, если на них ссылаются кассовые смены и документы'}}});
                  } else if(error.data.parameters){
                    if (error.data.parameters[0].name !== 'name') {
                      angular.forEach(divisionCrudCtrl.division.cash_registers, function(cash, key){
                        if(cash.serial_number == error.data.parameters[0].value){
                          $scope.addDivision['serialNum' + key].$setValidity('unique', false);
                          $anchorScroll('serialNum' + key);
                        }
                      });
                    } else {
                      angular.forEach(error.data.parameters, function(field){
                        $scope.addDivision[field.name].$setValidity('unique', false);
                        $anchorScroll(field.name + "Anchor");
                      });
                    }
                  } else {
                    errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
                  }
                } else if (error.data.code == 'bad_arguments' && error.data.fields[0].error) {
                  errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {data: {message: error.data.fields[0].error}}});
                } else {
                  errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
                }
                return deferred.reject();
              }
            )
          }
        }
      });
    };

    divisionCrudCtrl.resetPaymentError = function(index){
      var noPaymentData = true;
      for (var prop in divisionCrudCtrl.division.cash_registers[index].$$meta) {
        if (divisionCrudCtrl.division.cash_registers[index].$$meta[prop]) {
          noPaymentData = false;
        }
      }
      angular.element('input[name="nal"]').prop("disabled", noPaymentData);
      if (noPaymentData) {
        divisionCrudCtrl.division.cash_registers[index].$$meta.cash = true;
      }
    };

    // Метод, вызываемый при удалении подразделения
    divisionCrudCtrl.delete = function () {
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        resolve: {
          division: function () {
            return divisionCrudCtrl.division;
          },
          companyId: function () {
            return divisionCrudCtrl.company.id;
          }
        },
        controller: function ($scope, $uibModalInstance, division, companyId) {
          $scope.name = divisionCrudCtrl.typeStr[division.type] + " " + division.name;
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'подразделение';
          $scope.conflictDeleteText = "Невозможно удалить подразделение <strong>"+ $scope.name +"</strong>.<br>Для удаления подразделения необходимо удалить все связанные с ним ККМ, скидки, колонки прайс-листов и документы.";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.delete = function() {
            $scope.lock = true;
            companyService.deleteDivision(companyId, division.id).then(function () {
              $uibModalInstance.dismiss();
              // Переход на предыдущую страницу
              divisionCrudCtrl.resetData();
              $scope.lock = false;
            }, function (error) {
              if(error.status == 409){
                $scope.canDelete = false;
                $scope.lock = false;
                if (error.data.code == "business_error" && error.data.message == "Division contains in object_code") {
                  $scope.conflictDeleteText = "Невозможно удалить подразделение <strong>"+ $scope.name +"</strong>.<br>Невозможно удалить подразделение, по котору были начисления бонусов.";
                }
                return;
              }
              $uibModalInstance.dismiss();
              errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: error});
              $scope.lock = false;
            });
          };
        }
      });
      return modal.result;
    };

    divisionCrudCtrl.uniqueCheckCode = function(code){
      if (code) {
        var obj = {
          "constraint_name": "PARTNER_CODE",
          "parameters": [
            {
              "name": "code",
              "value": code
            }
          ]
        }
        if (divisionCrudCtrl.division.id) obj.id = divisionCrudCtrl.division.id;
        utilsService.uniqueCheck(obj).then(function (res) {
          },
          function (error) {
            if (error.status === 409) {
              angular.forEach(error.data.parameters, function (field) {
                $scope.addDivision[field.name].$setValidity('unique', false);
              });
            } else {
              $log.debug(error);
            }
          });
      }
    }

    divisionCrudCtrl.uniqueCheck = function(str, constraint, fieldName, index){
      if(str){
        var obj = {
          "constraint_name": constraint,
          "parameters": [
            {
              "name": fieldName,
              "value": str
            }
          ]
        };
        if (divisionCrudCtrl.division.id) {
          if (constraint === 'CASH_REGISTER') {
            obj.id = divisionCrudCtrl.division.cash_registers[index].id;
          } else if (constraint === 'DIVISION'){
            obj.id = divisionCrudCtrl.division.id;
          }
        }
        utilsService.uniqueCheck(obj).then(function(){},
        function (error) {
          if(error.status == 409){
            if(error.data.parameters[0].name != 'name'){
              angular.forEach(divisionCrudCtrl.division.cash_registers, function(cash, key){
                if(cash.serial_number == error.data.parameters[0].value){
                  $scope.addDivision['serialNum' + key].$setValidity('unique', false);
                }
              });
            }else{
              angular.forEach(error.data.parameters, function(field){
                $scope.addDivision[field.name].$setValidity('unique', false);
              });
            }
          } else {
            $log.debug(error)
          }
        });
      }
    };


    // Метод, вызываемый при редактировании/добавлении кассовых мест
    divisionCrudCtrl.openCrudPlaces = function (index) {
      $uibModal.open({
        templateUrl: 'app/settings/divisions/crudDivision/cash-register-places.html',
        size: 'small-width',
        resolve: {
          division: function () {
            return divisionCrudCtrl.division;
          },
          currentPlace: function () {
            return divisionCrudCtrl.division.cash_registers[index].place || undefined
          }
        },
        controller: function ($scope, $uibModalInstance, division, focus, currentPlace) {
          $scope.places = $filter('orderBy')(division.cash_register_places, 'name');
          $scope.errorInd = [];
          $scope.scrollBarConfig = { // конфиг скролбара
            autoHideScrollbar: false,
            theme: 'dark',
            advanced:{
              updateOnContentResize: true
            },
            setHeight: 196,
            scrollInertia: 0
          };

          if (currentPlace) {
            var index = _.findIndex($scope.places, function (place) {
              return place.$$uiid === currentPlace.$$uiid
            });
            focus.setFocusOnInput('[name="place'+ index +'"]');
          }

          $scope.$on('modal.closing', function(event, result, closed) { // нужно что бы изменения в попапе всегда передовались в родительский контроллер при закрытии
            if (!closed) {
              event.preventDefault();
              $uibModalInstance.close($scope.places)
            }
          });

          $scope.delete = function (index) {// удаление кассового места
            $scope.places.splice(index,1);
            $scope.checkName();
          };

          $scope.close = function() { // закрытие попапа
            $uibModalInstance.close($scope.places)
          };

          $scope.add = function () { // добавление кассового места + установка фокуса в новый инпут
            $scope.places.push({
              $$uiid: helpService.stringGen()
            });
            focus.setFocusOnInput('[name="place'+ ($scope.places.length - 1) +'"]')
          };

          $scope.clearErrorInd = function(index){
            $scope.errorInd = [];
          };

          $scope.checkName = function(){
            $scope.errorInd = [];
            angular.forEach($scope.places, function(place1, key1){
              angular.forEach($scope.places, function(place2, key2){
                if(place1.name && place2.name && key1 < key2 && place1.name == place2.name){
                  $scope.errorInd.push(key1);
                  $scope.errorInd.push(key2);
                }
              });
            });
          }
        }
      }).result.then(function (arr) { // после закрытия модального окна массив с данными присваивается division.cash_register_places
        angular.forEach(arr, function(item){
          if(item.name){
            _.find(divisionCrudCtrl.division.cash_registers, function (cash_register) {
              if (cash_register.place && cash_register.place.name !== item.name && cash_register.place.$$uiid === item.$$uiid) {
                cash_register.place.name = item.name;
              }
            });
          }
        });
        divisionCrudCtrl.division.cash_register_places = [];
        angular.forEach(arr, function(item){
          if(item.name){
            var issetName = _.find(divisionCrudCtrl.division.cash_register_places, function (place) {
              return place.name === item.name;
            });
            if (!issetName) {
              divisionCrudCtrl.division.cash_register_places.push(item)
            }
          }
        });

        angular.forEach(divisionCrudCtrl.division.cash_registers, function (cash_register) {
          if (!divisionCrudCtrl.division.cash_register_places.length||divisionCrudCtrl.division.cash_register_places.length === 0) {
            //если массив пустой или не задан, то поле кассовое место у кассовых аппаратов очищается
            cash_register.place = null;
          } else {
            //если кассовое место было удалено , но оно есть у кассового аппарата , кассовое место у аппарата очищается
            var counter = 0;
            angular.forEach(divisionCrudCtrl.division.cash_register_places , function (place) {
              if (cash_register.place && cash_register.place.name && place.name !== cash_register.place.name) {
                counter ++;
              }
            });
            if (counter === divisionCrudCtrl.division.cash_register_places.length) {
              cash_register.place = null
            }

          }
        })

      });
    };

    divisionCrudCtrl.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        divisionCrudCtrl.isSetDirty = true;
        return true;
      }
      return false;
    }

    divisionCrudCtrl.setDirty = function () {
      divisionCrudCtrl.isSetDirty = true;
      utilsService.setDirty($scope.addDivision);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    /*
     * Метод, вызываемый при удалении кассы
     */
    divisionCrudCtrl.removeCash = function (item, index) {
      if(!item.manufacturer && !item.model && !item.serialNum){
        divisionCrudCtrl.division.cash_registers.splice(index ,1);
        return;
      }
      $uibModal.open({
        templateUrl: 'app/settings/divisions/crudDivision/remove-cash.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.cash = item;

          // close remove/main popup
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };

          $scope.removeCash = function(){
            divisionCrudCtrl.division.cash_registers.splice(index ,1);
            $scope.close();
          };

        }
      }).result.then(function () {

      });
    };

    divisionCrudCtrl.crud = function (status) {
      switch(status) {
        case 'save':
          if ($scope.addDivision.$valid) {
            return divisionCrudCtrl.save();
          } else {
            return divisionCrudCtrl.setDirty();
          }
        case 'delete':
          return divisionCrudCtrl.delete();
        case 'return':
          divisionCrudCtrl.returnToPage();
          return $q.when();
        case 'edit':
          $state.go('division.edit', {parent: "business"});
          return $q.when();
        default :
          return $q.when();
      }
    };

  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('crudDiscountController', crudDiscountController);

  function crudDiscountController($scope, $stateParams, $state, $filter, $uibModal, $timeout, $anchorScroll, discount, discountsService, errorMessageService, utilsService, cardHistory, categoryService, catalogService, $q, askDeleteSrv, $window) {
    var vm = this;
    vm.state = $state;

    vm.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    }

    // для возврата на предыдущую страницу
    vm.returnToPage = function () {
      var prev = cardHistory.popStep('discountId', $stateParams.discountId) || {name: 'discounts', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'discounts', prev.param || {parent: 'retail'});
    };

    /* Инициализация акции */
    vm.initData = function () {
      if (!discount && vm.mode.isNew) {
        vm.discount = {
          regions: [{}],
          all_regions: true,
          all_divisions: true,
          all_catalog_elements: true,
          all_price_list_columns: true,
          mode: "ACTION"
        };
      } else {
        vm.discount = $.extend(true, {}, discount);
      }
      angular.forEach(vm.discount.times, function (item) {
        item.from_hour = item.from_hour.substr(0, 5);
        item.upto_hour = item.upto_hour.substr(0, 5);
        if (item.from_hour == item.upto_hour && item.upto_hour == "00:00") {
          item.$$mode = "not";
        } else {
          item.$$mode = "interval";
        }
        if (item.from_hour == "00:00" && item.upto_hour == "23:59") {
          item.$$mode = "round the clock";
        }
      });

      if (vm.discount.effective_date) {
        vm.discount.$$effectiveDateStr = $filter('date')(new Date(vm.discount.effective_date), 'dd.MM.yyyy');
      }
      if (vm.discount.expire_date) {
        vm.discount.$$expireDateStr = $filter('date')(new Date(vm.discount.expire_date), 'dd.MM.yyyy');
      }
    }
    vm.initData();

    vm.resetData = function () {
      $scope.addDiscount.$setPristine();
      vm.returnToPage();
    };

    // Метод, вызываемый при удалении акции
    vm.delete = function () {
      return askDeleteSrv.showAskDelete(
        vm.discount.name,
        "скидочную акцию",
        "Невозможно удалить скидочную акцию <strong>"+ vm.discount.name +"</strong>.",
        vm.discount.id,
        discountsService.deleteDiscount
      ).then(function (data) {
        vm.resetData();
      });
    }

    // В методе выполняются подготовительные операции перед сохранением
    vm.prepareSave = function () {
      // подготовка праметров акции
      if (vm.parameter && vm.parameter.type) {
        vm.discount.type = vm.parameter.type;
        if (vm.parameter.units) vm.discount.units = vm.parameter.units;
        if (vm.parameter.discount_set_items) vm.discount.discount_set_items = vm.parameter.discount_set_items;
        var tempDivisions = [];
        angular.forEach(vm.discount.divisions, function (division) {
          tempDivisions.push({
            id: division.id,
            name: division.name
          });
        });
        angular.forEach(vm.discount.units, function (unit) {
          if (unit.proc_value === "") {
            unit.proc_value = 0;
          }
        });
        // Для суммовой скидки кассира бэк требует proc_value = 0 и числовой max_discount_amount
        if (vm.discount.type === 'CASHIER_DECIDES_AMOUNT_FOR_SEL_ITEMS') {
          angular.forEach(vm.discount.units, function (unit) {
            unit.proc_value = 0;
            if (unit.max_discount_amount !== undefined && unit.max_discount_amount !== null && unit.max_discount_amount !== '') {
              unit.max_discount_amount = Number(unit.max_discount_amount);
            }
          });
        }
        vm.discount.divisions = tempDivisions;
      }

      // добавление недостоющего типа категории
      angular.forEach(vm.discount.catalog_elements, function (item) {
        if (!item.type) item.type = "CATEGORY";
      });
      angular.forEach(vm.discount.discount_set_items, function (item) {
        if (!item.catalog_item.type) item.catalog_item.type = "CATEGORY";
      });

      // подготовка времени
      angular.forEach(vm.discount.times, function (item) {
        if (item.$$mode == "not") {
          item.from_hour = item.upto_hour = "00:00:00";
        } else if (item.$$mode == "round the clock") {
          item.from_hour = "00:00:00";
          item.upto_hour = "23:59:00";
        } else {
          item.from_hour += ":00";
          item.upto_hour += ":00";
        }
      });
      // подготовка данных из блока "Действует для"
      if (vm.discount.all_price_list_columns) {
        delete vm.discount.price_list_columns;
      }
      if (vm.discount.all_catalog_elements) {
        delete vm.discount.catalog_elements;
      }
      if (vm.discount.all_divisions) {
        delete vm.discount.divisions;
      }
      if (vm.discount.all_regions) {
        delete vm.discount.regions;
      }
      if(vm.discount.regions && vm.discount.regions.length){
        vm.discount.regions = _.map(vm.discount.regions, function(addr){
          return addr.address;
        });
      }

      if (vm.discount.effective_date) vm.discount.effective_date = vm.discount.effective_date.valueOf();
      if (vm.discount.expire_date) vm.discount.expire_date = vm.discount.expire_date.valueOf();
    };


    // отправка адреса на проверку
    vm.addressCheck = function(addrObj){
      return (addrObj.address && !addrObj.address.id) ? addrObj.addressOptions.checkAddr(addrObj.address.address_as_string).then(function (res) {
        return res;
      }) : $q.when({});
    };

    // проверка статусов адреса
    vm.isValidAddr = function(addr){
      if(!addr) return true;
      if(addr.data && addr.data.view_ref){
        return !(addr.data.view_ref.qc == 2 && !addr.data.view_ref.accepted);
      }else{
        return true;
      }
    };

    // проверка адресов, если они есть, перед сохранением
    vm.checkAddrArrPrepareSave = function(){
      // если есть адреса то их надо проверить перед сохранением
      if (!vm.discount.all_regions) {
        return $q.all(_.map(vm.discount.regions, function(addr){
          return vm.addressCheck(addr);
        })).then(function (values) {
          var isValidAddresses = !_.find(values, function(val){
            return !vm.isValidAddr(val);
          });
          // если все адреса валидны, то сохраняем
          return (isValidAddresses)? vm.save() : $q.reject();
        });
      } else {
        return vm.save();
      }
    };

    // Метод, вызываемый при сохранении или изменении акции
    vm.save = function () {
      var deferred = $q.defer();
      // подготовка структур в соответствие АПИ
      vm.prepareSave();
      if (vm.discount.id) {
        // Блок обновления
        return discountsService.updateDiscount(vm.discount).then(
          function () {
            discount = vm.discount;
            vm.resetData()
          },
          function (error) {
            if (error.status == 409) {
              angular.forEach(error.data.parameters, function (field) {
                $scope.addDiscount[field.name].$setValidity('unique', false);
                $anchorScroll(field.name + "Anchor");
              });
            } else {
              errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
            }
            return deferred.reject();
          }
        )
      } else {
        // Блок создания
        return discountsService.createDiscount(vm.discount).then(
          function () {
            vm.resetData();
          },
          function (error) {
            if (error.status == 409) {
              angular.forEach(error.data.parameters, function (field) {
                $scope.addDiscount[field.name].$setValidity('unique', false);
                $anchorScroll(field.name + "Anchor");
              });
            } else {
              errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
            }
            return deferred.reject();
          }
        )
      }
    }

    vm.uniqueCheck = function () {
      if (vm.discount.name && vm.discount.effective_date) {
        var timestampTemp = (!vm.discount.effective_date._d) ? vm.discount.effective_date : (vm.discount.effective_date.unix()) * 1000;
        var obj = {
          "constraint_name": "DISCOUNT_NAME",
          "parameters": [
            {
              "name": "name",
              "value": vm.discount.name
            },
            {
              "name": "effective_date",
              "value": timestampTemp
            }
          ]
        }
        if (vm.discount.id) obj.id = vm.discount.id;
        utilsService.uniqueCheck(obj).then(function (res) {
          },
          function (error) {
            if (error.status == 409) {
              angular.forEach(error.data.parameters, function (field) {
                $scope.addDiscount[field.name].$setValidity('unique', false);
              });
            }
          });
      }
    }

    vm.catalogItemPopup = function (field) {
      $uibModal.open({
        templateUrl: 'app/settings/discounts/crudDiscount/modals/catalogItemsPopup.html',
        size: 'large-width',
        controller: function ($scope, $uibModalInstance) {
          // Флаг - переключатель между деревом и результатами поиска
          $scope.showSearch = false;
          $scope.$watch('searchText', function (newVal, oldVal) {
            if (oldVal && !newVal) { // Если не пустое значение меняется на пустое (в широком смысле)
              $scope.showSearch = false; // Смена вида на каталог
            }
          });

          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          // настройка скролла
          $scope.configScroll = {
            axis: 'y',
            autoHideScrollbar: false,
            theme: 'dark',
            advanced: {
              updateOnContentResize: true
            },
            setHeight: 459,
            scrollInertia: 0,
            scrollButtons: {
              enable: false // enable scrolling buttons by default
            }
          }

          // Узлы дерева
          $scope.root = {
            name: 'Каталог',
            root: true,
            has_children: true,
            children: []
          };

          $scope.isBlockCheckbox = function(item){
            return true;
          }

          /* метод раскрывает узлы дерева по пути */
          $scope.expandTreePath = function (path) {
            $scope.root.expandFunc(path).then(function () {
              $scope.showSearch = false;
            }, function () {
              $scope.showSearch = false;
            });
          }

          /* Метод поиска в дереве каталога участника */
          $scope.search = function () {
            catalogService.searchCatalogElements($scope.searchText).then(
              function (data) {
                $scope.searchResult = data.data.items;
                $scope.currentSelectionTree = $scope.root.getSelectionModel();
                //$scope.searchResult[0].parents = $scope.searchResult[0].parentList;
                $scope.showSearch = true;
              },
              function (error) {
                $log.log('Ошибка при поиске: ' + error);
              }
            )
          }

          /* Callback для раскрытия дерева */
          $scope.expand = function (node, nextPage) {
            var categoryPromise;
            var itemPromise;
            // Загрузка дочерних категорий только при установленном флаге наличия
            if (!nextPage && node.has_children) {
              categoryPromise = categoryService.getDomainCategories(node.id, vm.filters).then(function (data) {
                if (data.data) {
                  return data.data;
                }
              });
            } else {
              categoryPromise = $q.when([]);
            }

            var page = nextPage ? {
              offset: _.filter(node.children, function(item) {return item.unstructure;}).length
              // лимит по-умолчанию определяется в сервисе
            } : undefined;

            // Загрузка дочерних элементов только при их наличии
            if (node.item_count) {
              itemPromise = categoryService.getDomainCategoryItems(node.id, vm.filters, page).then(function (data) {
                if (data.data) {
                  node.total = data.data.total;
                  return data.data.items;
                }
              })
            } else {
              itemPromise = $q.when([]);
            }
            // Композиция промисов, и конкатенация рузультатов (в итоге компонент дерева не в курсе нескольки запросов при callback и остается универсальным)
            return $q.all([categoryPromise, itemPromise]).then(function (values) {
              angular.forEach(values[1], function (item) {
                item.unstructure = true;
                item.has_children = false;
                item.item_count = 0;
              });
              return values[0].concat(values[1]);
            })
          };

          $scope.choose = function () {
            var selectionModel;
            // в зависимости от того, какой контрол отображается (дерево или результат поиска) исользуем различные модели выбора
            if ($scope.showSearch) {
              // случай активного поиска
              selectionModel = _.map(_.where($scope.searchResult, {_checked: true}), function (obj) {
                return obj;
              });
            } else {
              // случай активного дерева
              selectionModel = $scope.root.getSelectionModel();
            }
            // Формирование нужной структуры запроса по списку выбраннх узлов
            var resItems = _.map(selectionModel, function (node) {
              return {
                id: node.id,
                name: node.name,
                type: node.type,
                $$path: node._path
              }
            });
            if (resItems.length) {
              if (!vm.discount[field]) {
                vm.discount[field] = [];
              }
              if (field == 'discount_set_items') {
                vm.parameter.discount_set_items = [];
                angular.forEach(resItems, function (item) {
                  vm.parameter.discount_set_items.push({catalog_item: item});
                });
              } else {
                vm.discount[field] = resItems;
              }
            }
            $uibModalInstance.dismiss();
          }

          // Callback загрузки дерева
          $scope.onTreeLoaded = function () {
            $scope.root.expandFuncByModel({}).then(function () {
              var paths = [];
              if (field == 'discount_set_items') {
                angular.forEach(vm.parameter.discount_set_items, function (item) {
                  if (!item.catalog_item.$$path) {
                    setIdPath(item.catalog_item);
                  }
                  paths.push(item.catalog_item.$$path);
                });
              } else {
                angular.forEach(vm.discount[field], function (item) {
                  if (!item.$$path) {
                    setIdPath(item);
                  }
                  paths.push(item.$$path);
                });
              }
              $scope.root.checkByPaths(paths);
            });
          };

          function setIdPath(item) {
            item.$$path = [];
            angular.forEach(item.parentList, function (parent) {
              item.$$path.push(parent.id);
            });
            item.$$path.push(item.id);
          }

        }
      });
    }

    vm.checkCatalogItems = function () {
      vm.noParam = !vm.parameter;
      vm.discountCatalogElementsError = !vm.discount.all_catalog_elements && (!vm.discount.catalog_elements || !vm.discount.catalog_elements.length);
      if (!vm.parameter) {
        vm.paramCatalogElementsError = false;
      } else {
        vm.paramCatalogElementsError = vm.parameter.type == 'PROC_FOR_UNIT_FROM_SET' && (!vm.parameter.discount_set_items || !vm.parameter.discount_set_items.length);
      }
      return vm.discountCatalogElementsError || vm.paramCatalogElementsError || vm.noParam;
    }

    vm.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        vm.isSetDirty = true;
        return true;
      }
      return false;
    }

    vm.setDirty = function () {
      vm.isSetDirty = true;
      utilsService.setDirty($scope.addDiscount);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, div.has-error').offset().top - 20);
      return $q.when();
    };

    vm.crud = function (status) {
      switch (status) {
        case 'save':
          var isFormValid = vm.checkCatalogItems();
          if (!$scope.addDiscount.$valid || isFormValid) {
            return vm.setDirty();
          } else {
            return vm.checkAddrArrPrepareSave();
          }
          break;
        case 'delete':
          return vm.delete();
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('discount.edit', {discountId: vm.discount.id, parent: 'retail'});
          return $q.when();
        default :
          return $q.when();
          break;
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('crudContragentController', crudContragentController);

  function crudContragentController($scope,
                                    $stateParams,
                                    $state,
                                    $filter,
                                    $uibModal,
                                    $timeout,
                                    $window,
                                    $anchorScroll,
                                    contragent,
                                    contragentService,
                                    errorMessageService,
                                    utilsService,
                                    cardHistory,
                                    dateRangePickerService,
                                    $q,
                                    askDeleteSrv,
                                    $rootScope,
                                    userSettingsService,
                                    companyService) {
    var vm = this;
    vm.widget = [];
    vm.state = $state;
    vm.addressOptions = {};
    vm.counterpartyRoleMap = contragentService.getCounterpartiesRoles();

    function prepareRoles() { // мапинг ролей
      angular.forEach(vm.contragent.roles, function (code) {
        vm.counterpartyRoleMap[code].checked = true;
      });
    }

    vm.counterpartyName = function(isInfo, isView) {
      switch ($state.params.parent) {
        case 'purchase':
          return isInfo ? (vm.mode.isView || isView)? 'поставщике' : 'поставщика' : 'Поставщики';
        case 'sale':
          return isInfo ? (vm.mode.isView || isView)? 'покупателе' : 'покупателя' : 'Покупатели';
        default :
          return isInfo ? (vm.mode.isView || isView)? 'контрагенте' : 'контрагента' : 'Контрагенты';
      }
    };

    vm.datePickerOpts = {singleDatePicker: true, correctTimeZone: false, maxDate: moment().utc().startOf('day')};
    vm.onDatePickerClose = function (returnValue, name) {
      vm.contragent.organization.legal_requisites.registration_date = (returnValue && !returnValue.isEmpty)
        ? returnValue.valueOf()
        : null;
    };

    vm.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    };

    // для возврата на предыдущую страницу
    vm.returnToPage = function() {
      var prev = cardHistory.popStep('contragentId', $stateParams.contragentId) || {name: 'contragents', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'contragents', prev.param || {parent: $stateParams.parent});
    };

    vm.initWidgets = function () {
      vm.mutualSettlement = {
        name: 'Взаиморасчеты',
        component: 'mutual-settlement',
        settingsComponent: 'mutualSettlement',
        options: {
          counterpartyId: contragent.id || undefined,
          pageName: 'counterparty'
        },
        visible: $rootScope.hasRole('period_totals.read')
      };
      vm.egaisCounterparties = {
        name: 'Контрагенты ЕГАИС',
        component: 'egais-counterparties',
        settingsComponent: 'egaisCounterparties',
        options: {
          counterpartyId: contragent.id || undefined,
          pageName: 'counterparty'
        },
        allowRedactMode: $rootScope.hasRole('counterparty_egais.write'),
        visible: $rootScope.hasRole('counterparty_egais.read') ||  $rootScope.hasRole('counterparty_egais.write')
      };

      // инициализация виджетов
      // сделано хранение в сторе последовательности только названий виджетов, т.к. необходима актуальная дата и актуальные доступы
      vm.widgetSequence = userSettingsService.loadProperty("counterparty", "widget", "sequence") || [];
      if (!vm.widgetSequence.length) {
        vm.widget = [vm.mutualSettlement, vm.egaisCounterparties];
        _.forEach(vm.widget, function (widget) {
          vm.widgetSequence.push(widget.settingsComponent);
        });
        userSettingsService.saveProperty("counterparty", "widget", "sequence", vm.widgetSequence);
      } else {
        _.forEach(vm.widgetSequence, function (widgetName) {
          vm.widget.push(vm[widgetName]);
        });
      }
    };

    // Проверка наличия домена
    vm.checkDomain = function () {
      $scope.addContragent.domain.$setValidity('unique', true);
      utilsService.checkIssetDomain(vm.domain).then(function () {
        companyService.getCompaniesByDomain(vm.domain).then(function (res) {
          vm.companies = res.data.items;
        }, function (error) {
          errorMessageService.showModal({message: 'При загрузке компаний произошла ошибка', submessage: error});
        });
      }, function (error) {
        $scope.addContragent.domain.$setValidity('unique', false);
      });
    }

    // Загрузка данных компании
    vm.loadCompany = function () {
      vm.manually = false;
      vm.contragent = {
        counterparty_type: vm.company.organization.legal_requisites.legal_status,
        name: vm.company.name,
        real_address: vm.company.real_address,
        organization: {
          accounts: vm.company.organization.accounts,
          chief_name: vm.company.organization.chief_name,
          chief_position: vm.company.organization.chief_position,
          legal_requisites: {
            full_name: vm.company.organization.legal_requisites.full_name,
            inn: vm.company.organization.legal_requisites.inn,
            kpp: vm.company.organization.legal_requisites.kpp,
            legal_address: vm.company.organization.legal_requisites.legal_address,
            ogrn: vm.company.organization.legal_requisites.ogrn,
            okpo: vm.company.organization.legal_requisites.okpo,
            short_name: vm.company.organization.legal_requisites.short_name
          }
        },
        linked_company_organization : {
          id: vm.company.id
        },
        roles: $stateParams.parent === 'purchase'
                                ? ['SUPPLIER']
                                : $stateParams.parent === 'sale'
                                  ? ['CUSTOMER']
                                  : [],
        contact_info: vm.company.contact_info
      };
      vm.contragent.contact_info.id = undefined;
    }

    /* Инициализация контрагента */
    vm.initData = function () {
      if (!contragent && vm.mode.isNew) {
        /* Начальный тип контрагента */
        vm.type = 'LEGAL_ENTITY';

        // Инициализация DTO контрагента при создании нового
        vm.contragent = {
          counterparty_type: "LEGAL_ENTITY",
          organization: {},
          roles: $stateParams.parent === 'purchase'
                                  ? ['SUPPLIER']
                                  : $stateParams.parent === 'sale'
                                    ? ['CUSTOMER']
                                    : [],
          contacts: [
            {
              contact_info: {
                details: [
                  {caption: "Телефон", type: "PHONE"},
                  {caption: "E-mail", type: "EMAIL"}
                ]
              }
            }
          ]
        };
        vm.contragent.organization = {
          vat_payer: false,
          legal_requisites: {
            // Инциализация типа компании по-умолчанию (юридическое лицо)
            legal_status: "LEGAL_ENTITY"
          },
          accounts: []
        };
        if ($stateParams.purpose) {
          utilsService.purposeCounterpartyContractRelationship().then(function(res){
            _.find(res.data.items, function (item) {
              if (item.purpose == $stateParams.purpose) {
                vm.counterpartyRoleMap[item.counterparty_role].checked = true;
                return true;
              }
            });
          });
        }
      } else {
        vm.contragent = $.extend(true, {}, contragent);

        /* Инициализация типа контрагента */
        vm.type = vm.contragent.counterparty_type;

        vm.contragent.organization = vm.contragent.organization || {vat_payer: false};

        if (!vm.contragent.organization.legal_requisites) {
          vm.contragent.organization.legal_requisites = {
            // Инциализация типа компании по-умолчанию (юридическое лицо)
            legal_status: "LEGAL_ENTITY"
          }
        }

        // TODO: ???
        // vm.contragent.organization.accounts = vm.contragent.organization.accounts || [];

        if (vm.contragent.person) vm.person = vm.contragent.person;

        /* Инициализация даты */
        if (vm.contragent.organization.legal_requisites && vm.contragent.organization.legal_requisites.registration_date) {
          vm.contragent.organization.legal_requisites.registration_date = moment(vm.contragent.organization.legal_requisites.registration_date, "DD-MM-yyyy");
          vm.registrationDateStr = $filter('date')(new Date(vm.contragent.organization.legal_requisites.registration_date), "dd.MM.yyyy")
        }
        /* Инициализация текущей системы налогообложения */
        angular.forEach(vm.contragent.organization.tax_modes, function (tax_mode) {
          if (!vm.currentTax || vm.currentTax.start_date < tax_mode.start_date) {
            vm.currentTax = {
              start_date: tax_mode.start_date,
              tax_mode: tax_mode.tax_mode
            }
          }
          vm.currentTax = vm.currentTax || {};
        });

        /* флаг для скрытия блока с юр. реквизитами */
        vm.hideBlock = true;
        for (var ind in vm.contragent.organization.legal_requisites) {
          if (ind !== 'legal_status' && vm.contragent.organization.legal_requisites[ind]) {
            vm.hideBlock = false;
          }
        }

        vm.initWidgets();

      }
      if($state.params.inn){
        vm.contragent.organization.legal_requisites.inn = $state.params.inn;
      }
      if($state.params.kpp){
        vm.contragent.organization.legal_requisites.kpp = $state.params.kpp;
      }
      if($state.params.short_name){
        vm.contragent.organization.legal_requisites.short_name = $state.params.short_name;
      }
      if($state.params.full_name){
        vm.contragent.organization.legal_requisites.full_name = $state.params.full_name;
        if (!vm.contragent.name) {
          vm.contragent.name = $state.params.full_name;
        }
      }
      prepareRoles();
    };
    vm.initData();

  vm.resetData = function(){
    vm.addComment = false;
    $scope.addContragent.$setPristine();
    $scope.addContragent.$setUntouched();
    angular.element(".ng-invalid").val("").removeClass("ng-invalid");
    vm.initData();
    vm.returnToPage();
  };

    vm.resetTypes = function () {
      if (vm.contragent.counterparty_type !== 'PERSON') {
        vm.contragent.organization.legal_requisites.legal_status = vm.type;
      }
      if (vm.contragent.counterparty_type === 'PERSON') {
        $timeout(function () {
          var element = angular.element('input#name');
          element.trigger('blur');
          return element
        }, 5).then(function (element) {
          $scope.addContragent.name.$setUntouched();
        })

      }
    }

  // Метод, вызываемый при удалении контрагента
  vm.delete = function () {
    return askDeleteSrv.showAskDelete(
      vm.contragent.name,
      "контрагента",
      "Невозможно удалить контрагента <strong>"+ vm.contragent.name +"</strong>.<br>Для удаления контрагента необходимо удалить все связанные с ним договоры и документы.",
      vm.contragent.id,
      contragentService.deleteContragent
    ).then(function (data) {
      vm.resetData();
    });
  }

  // структура для управления директивой адреса
  vm.addressOptions = {};
  vm.addressCheck = function(addrObj){
    return (addrObj && !addrObj.id) ? vm.addressOptions.checkAddr(addrObj.address_as_string).then(function (res) {
      return res;
    }) : $q.when([]);
  }

  // В методе выполняются подготовительные операции перед сохранением
  vm.prepareSave = function () {
    // Тип контрагента
    if (vm.contragent.counterparty_type === 'PERSON') {
      vm.contragent.organization = undefined;
      vm.contragent.contacts = undefined;
    } else {
      // представители контрагента
      for (var ind in vm.contragent.contacts) {
        var contact = vm.contragent.contacts[ind];
        if (!contact.position && !contact.name && !contact.contact_info.details[0].value && !contact.contact_info.details[1].value) {
          vm.contragent.contacts.splice(ind, 1);
        } else {
          if (!contact.name) contact.name = null;
        }
      }
      //Поправка legal_status
      vm.contragent.organization.legal_requisites.legal_status = vm.contragent.counterparty_type;
    }
    // подготовка массива ролей контрагентов
    vm.contragent.roles = [];
    angular.forEach(vm.counterpartyRoleMap, function (value, key) {
      if (value.checked) vm.contragent.roles.push(key);
    });
  }

  vm.isValidAddr = function(addr){
    if(!addr) return true;
    if(addr.data && addr.data.view_ref){
      return !(addr.data.view_ref.qc == 2 && !addr.data.view_ref.accepted);
    }else{
      return true;
    }
  }

  vm.closeTab = function () {
    if ($stateParams.closeTab) {
      $window.close();
    }
  }

  // Метод, вызываемый при сохранении или изменении сотрудника
  vm.save = function () {
    return $q.all([vm.addressCheck(vm.contragent.real_address),
            vm.addressCheck(vm.contragent.organization &&
                            vm.contragent.organization.legal_requisites &&
                            vm.contragent.organization.legal_requisites.legal_address)]).then(function (values) {
      if(vm.isValidAddr(values[0]) && vm.isValidAddr(values[1])){
        var deferred = $q.defer();
        vm.prepareSave();
        if (vm.contragent.id) {
          // Блок обновления
          return contragentService.updateContragent(vm.contragent).then(
            function () {
              contragent = vm.contragent;
              vm.closeTab();
              vm.resetData();
            },
            function (error) {
              if(error.status == 409){
                angular.forEach(error.data.parameters, function(field){
                  $scope.addContragent[field.name].$setValidity('unique', false);
                  $anchorScroll(field.name + "Anchor");
                });
              }else{
                errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
                return deferred.reject();
              }
            }
          )
        } else {
          // Блок создания
          return contragentService.createContragent(vm.contragent).then(
            function () {
              vm.closeTab();
              vm.resetData();
            },
            function (error) {
              if(error.status == 409){
                angular.forEach(error.data.parameters, function(field){
                  $scope.addContragent[field.name].$setValidity('unique', false);
                  $anchorScroll(field.name + "Anchor");
                });
              }else{
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
                return deferred.reject();
              }
            }
          )
        }
      }else{
        return $q.when();
      }
    });
  }

    // добавление новых вкладок и все махинации с ними
    if (!vm.contragent.contacts) vm.contragent.contacts = [{}];

    vm.addRepresentatives = function () {
      vm.contragent.contacts.push({
        contact_info: {
          details: [
            {caption: "Телефон", type: "PHONE"},
            {caption: "E-mail", type: "EMAIL"}
          ]
        }
      });
      $timeout(function () {
        vm.reCalcScroll();
        vm.selectTab(vm.contragent.contacts.length + 1);
      }, 0)
    };

    vm.removeRepresentatives = function (id, event) {
      event.preventDefault();
      vm.selectTab(id + 1);
      vm.contragent.contacts.splice(id, 1);
      vm.reCalcScroll();
    };

    vm.scrollIntoView = function(arg) {
      if(vm.scrlTabsApi.scrollTabIntoView) {
        vm.scrlTabsApi.scrollTabIntoView();
      }
    };
    $timeout(function() {vm.reCalcScroll()}, 2000);
    vm.activeContact = vm.activeContact || 0;
    
    vm.selectTab = function(index) {
      vm.activeContact = index;
      vm.scrollIntoView();
    };

    vm.uniqueCheck = function (str) {
      if (str || vm.contragent.name) {
        var obj = {
          "constraint_name": "COUNTERPARTY",
          "parameters": [
            {
              "name": "name",
              "value": str || vm.contragent.name
            }
          ]
        }
        if (vm.contragent.id) obj.id = vm.contragent.id;
        utilsService.uniqueCheck(obj).then(function (res) {
          },
          function (error) {
            if (error.status == 409) {
              angular.forEach(error.data.parameters, function (field) {
                $scope.addContragent[field.name].$setValidity('unique', false);
              });
            }
          });
      }
    }

    vm.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        vm.isSetDirty = true;
        return true;
      }
      return false;
    }

    vm.setDirty = function () {
      vm.isSetDirty = true;
      utilsService.setDirty($scope.addContragent);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    vm.crud = function (status) {
      switch (status) {
        case 'save':
          if ($scope.addContragent.$valid) {
            return vm.save();
          } else {
            return vm.setDirty();
          }
          break;
        case 'delete':
          return vm.delete();
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('contragent.edit', {parent: $stateParams.parent});
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    }

    vm.scrlTabsApi = {};
    vm.reCalcScroll = function() {
      if(vm.scrlTabsApi.doRecalculate) {
        vm.scrlTabsApi.doRecalculate();
      }else{
        vm.scrlTabsApi = {};
      }
    };


    vm.onInnFill = function() {
      if (vm.contragent.organization.legal_requisites.inn) {
        utilsService.getCompanyInfo(vm.contragent.organization.legal_requisites.inn).then(function(res) {
          var item = res.data[0];
          if (item.kpp) {
            vm.contragent.organization.legal_requisites.kpp = item.kpp;
          }
          vm.contragent.organization.legal_requisites.full_name = item.full_name_with_opf;
          vm.contragent.organization.legal_requisites.legal_address = {
            address_as_string: item.address
          };
          vm.contragent.organization.legal_requisites.short_name = item.short_name_with_opf;
          vm.contragent.organization.legal_requisites.ogrn = item.ogrn;
          vm.contragent.organization.legal_requisites.okpo = item.okpo;
          vm.registration_date = parseInt(item.ogrn_date);

          $timeout(function () {
            // вызов экспортируемого метода директивы адреса для установления связи с объектом бекенда
            vm.addressOptions.checkAddr(vm.contragent.organization.legal_requisites.legal_address.address_as_string).then(function (res) {
              if (!vm.contragent.organization.legal_requisites.legal_address.id && res && res.data && res.data.view_ref) {
                vm.contragent.organization.legal_requisites.legal_address = res.data.view_ref;
              }
            });
          }, 0);
        })
      }
    }

    vm.scrollIntoView = function(arg) {
      if(vm.scrlTabsApi.scrollTabIntoView) {
        vm.scrlTabsApi.scrollTabIntoView(arg);
      }
    };
    $timeout(function() {vm.reCalcScroll()}, 2000);

  }
})();

/**
 * Created by aivanov on 25.05.2017.
 */
(function () {
  'use strict';

  /*eslint angular/controller-as-vm: [2,"contractCrudCtrl"]*/
  angular.module('frontend').controller('crudContractController', crudContractController);

  function crudContractController($scope, $state, $filter, $uibModal, $window,
                                  contractService, contract,
                                  errorMessageService,
                                  types,
                                  defaultCompany,
                                  defaultCurrency,
                                  $stateParams,
                                  currenciesService,
                                  contragentService,
                                  companyService,
                                  projectsService,
                                  parseNumberSrv,
                                  uiSelectStructure,
                                  $anchorScroll,
                                  utilsService,
                                  cardHistory,
                                  $rootScope,
                                  $q,
                                  askDeleteSrv,
                                  companies,
                                  counterparties) {
    var contractCrudCtrl = this;
    contractCrudCtrl.datePickerOpts = {singleDatePicker: true, correctTimeZone: false};

    contractCrudCtrl.onDatePickerClose = function (returnValue, name) {
      if (name && returnValue && !returnValue.isEmpty) {
        contractCrudCtrl.contract.date = returnValue.valueOf();
      } else if (returnValue.isEmpty) {
        contractCrudCtrl.contract.date = null;
      }
    };

    contractCrudCtrl.showComision = function () {
      return !contractCrudCtrl.contract_type ||
        (contractCrudCtrl.mode.isView && !contractCrudCtrl.contract.commission) ||
        (contractCrudCtrl.contract_type.code === 'WE_SELL' || contractCrudCtrl.contract_type.code === 'WE_BUY');
    };

    // для возврата на предыдущую страницу
    contractCrudCtrl.returnToPage = function(){
      var prev = cardHistory.popStep('contractId', $stateParams.contractId) || {name: 'contracts', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'contracts', prev.param || {parent: 'money'});
    };

    contractCrudCtrl.types = types;

    contractCrudCtrl.initData = function() {
      // Договор
      if (!contract) {
        // Инициализация DTO пользователя при создании нового (TODO: дополнительно рповерить состояние)
        contractCrudCtrl.contract = {active: true};
        if ($stateParams.purpose) {
          utilsService.purposeCounterpartyContractRelationship().then(function(res){
            _.find(res.data.items, function (item) {
              if (item.purpose == $stateParams.purpose) {
                contractCrudCtrl.contract_type = _.find(contractCrudCtrl.types, function(type){
                  return type.code == item.contract_type;
                });
                return true;
              }
            });
          });
        }
      } else {
        contractCrudCtrl.contract = $.extend(true, {}, contract);
        /* Установка даты */
        contractCrudCtrl.date = moment.utc(contract.date);
        /* Установка значения в чекбокс при редактировании */
        contractCrudCtrl.contract_type = _.find(contractCrudCtrl.types, function (item) {
          return item.code == contract.contract_type;
        });
        contractCrudCtrl.widget = [{
          name: 'Сверка',
          component: 'verification-widget',
          settingsComponent: 'verificationWidget',
          options: {
            contractId: contract.id || undefined
          },
          visible: true
        }];
      }
    };
    contractCrudCtrl.initData()
    contractCrudCtrl.resetData = function() {
      contractCrudCtrl.initData();
      contractCrudCtrl.eForm.$setPristine();
      contractCrudCtrl.returnToPage()
    };
    // Состояние


    contractCrudCtrl.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    };

    contractCrudCtrl.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        contractCrudCtrl.isSetDirty = true;
        return true;
      }
      return false;
    }

    contractCrudCtrl.setDirty = function () {
      contractCrudCtrl.isSetDirty = true;
      utilsService.setDirty(contractCrudCtrl.eForm);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    // Метод, вызываемый при удалении сотруника
    contractCrudCtrl.delete = function () {
      return askDeleteSrv.showAskDelete(
        contractCrudCtrl.contract.number,
        "договор",
        "Невозможно удалить договор <strong>"+ contractCrudCtrl.contract.number +"</strong>.<br>Для удаления договора необходимо удалить все связанные с ним документы.",
        contractCrudCtrl.contract.id,
        contractService.deleteContract
      ).then(function (data) {
        contractCrudCtrl.resetData();
      });
    };

    // необходимость закрытия окна после сохранения
    contractCrudCtrl.closeTab = function () {
      if ($stateParams.closeTab) {
        $window.close();
      }
    }

    // В методе выполняются подготовительные операции перед сохранением
    contractCrudCtrl.prepareSave = function () {
      contractCrudCtrl.contract.contract_type = contractCrudCtrl.contract_type.code;
    };
    // Метод, вызываемый при сохранении или изменении сотрудника
    contractCrudCtrl.save = function () {
      var deferred = $q.defer();
      // подготовка структур в соответствие АПИ
      contractCrudCtrl.prepareSave();
      if (contractCrudCtrl.contract.id) {
        // Блок обновления
        return contractService.updateContract(contractCrudCtrl.contract).then(
          function () {
            contract = contractCrudCtrl.contract;
            contractCrudCtrl.closeTab();
            contractCrudCtrl.resetData();
          },
          function (error) {
            if(error.status === 409 && error.data.code === "non_unique"){
              angular.forEach(error.data.parameters, function(field){
                contractCrudCtrl.eForm[field.name].$setValidity('unique', false);
                $anchorScroll("numberAnchor");
              });
            }else{
              errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
            }
            return deferred.reject();
          }
        );
      } else {
        // Блок создания
        return contractService.createContract(contractCrudCtrl.contract).then(
          function () {
            contractCrudCtrl.closeTab();
            contractCrudCtrl.resetData();
          },
          function (error) {
            if(error.status === 409 && error.data.code === "non_unique"){
              angular.forEach(error.data.parameters, function(field){
                contractCrudCtrl.eForm[field.name].$setValidity('unique', false);
                $anchorScroll("numberAnchor");
              });
            }else{
              errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
            }
            return deferred.reject();
          }
        );
      }
    };

    contractCrudCtrl.parseAmount = function (value) {
      return parseNumberSrv.parseValue(value);
    };

    contractCrudCtrl.resetUniqError = function(){
      contractCrudCtrl.eForm.number.$setValidity('unique', true);
      contractCrudCtrl.eForm.company_id.$setValidity('unique', true);
      contractCrudCtrl.eForm.counterparty_id.$setValidity('unique', true);
      contractCrudCtrl.uniqueCheck();
    };

    contractCrudCtrl.uniqueCheck = function(){
      if(contractCrudCtrl.contract.company && contractCrudCtrl.contract.counterparty && contractCrudCtrl.contract.number && contractCrudCtrl.contract.company.id && contractCrudCtrl.contract.counterparty.id){
        var obj = {
          'constraint_name': 'CONTRACT',
          'parameters': [{
              'name': 'company_id',
              'value': contractCrudCtrl.contract.company.id
            },{
              'name': 'number',
              'value': contractCrudCtrl.contract.number
            },{
              'name': 'counterparty_id',
              'value': contractCrudCtrl.contract.counterparty.id
            }
          ]
        };
        obj.id = contractCrudCtrl.contract.id || null;
        utilsService.uniqueCheck(obj).then(function(res){},
        function (error) {
          if(error.status === 409 && error.data.code === 'non_unique'){
            angular.forEach(error.data.parameters, function(field){
              contractCrudCtrl.eForm[field.name].$setValidity('unique', false);
            });
          }
        });
      }
    };

    contractCrudCtrl.crud = function (status) {
      switch(status) {
        case 'save':
          if (contractCrudCtrl.eForm.$valid) {
            return contractCrudCtrl.save();
          } else {
            return contractCrudCtrl.setDirty();
          }
          break;
        case 'delete':
          return contractCrudCtrl.delete();
          break;
        case 'return':
          contractCrudCtrl.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('contract.edit', {parent: 'money'});
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    };

    contractCrudCtrl.totalStr = function(){
      if(contractCrudCtrl.counterparties.field.total > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + contractCrudCtrl.counterparties.field.total;
      }
      return '';
    };

    contractCrudCtrl.onContractTypeSelect = function() {
      contractCrudCtrl.contract.counterparty = null;
      contractCrudCtrl.eForm.counterparty_id.$setPristine();
      contractCrudCtrl.eForm.counterparty_id.$setUntouched();
      contractCrudCtrl.counterparties.refresh();
    };

    //autocomplete settings
    contractCrudCtrl.counterparties = uiSelectStructure.getStructure(contragentService.counterpartiesSearch,contractCrudCtrl.contract.counterparty);
    contractCrudCtrl.counterparties.refresh = function(searchString) {
      contragentService.counterpartiesSearch(searchString, null, { filter_contract_type: contractCrudCtrl.contract_type && contractCrudCtrl.contract_type.code})
        .then(contractCrudCtrl.counterparties.onRefreshSuccess)
    };


    contractCrudCtrl.projects = uiSelectStructure.getStructure(projectsService.projectsSearch,contractCrudCtrl.contract.project);

    contractCrudCtrl.currencies = uiSelectStructure.getStructure(currenciesService.getDomainCurrenciesSearch,contractCrudCtrl.contract.currency);

    contractCrudCtrl.companies = uiSelectStructure.getStructure(companyService.companiesSearch,contractCrudCtrl.contract.company);

    //предустанавливает значения по умолчанию, при cоздании договора
    if(contractCrudCtrl.mode.isNew){
      contractCrudCtrl.contract.company = defaultCompany;
      contractCrudCtrl.contract.currency =  defaultCurrency;
    }

    if ($stateParams.companyId){
      contractCrudCtrl.contract.company = _.find(companies, function (company) {
        return company.id == $stateParams.companyId;
      })
    }

    if ($stateParams.counterpartyId){
      contractCrudCtrl.contract.counterparty = _.find(counterparties, function (counterparty) {
        return counterparty.id == $stateParams.counterpartyId;
      })
    }

    if ($stateParams.purpose){
      // todo
      // contractCrudCtrl.contract_type = '';
    }
      
  }
})();

angular.module('frontend').component('partnerInfoCard', {
  bindings: {
    info: '<'
  },
  templateUrl: 'app/settings/components/partnerInfoCard/partner_info_card.html',
  controllerAs: 'vm',
  controller: function (clipboardService, requestStatus) {
    var vm = this;

    vm.copyText = function (text, message) {
    	if (!text) return;
    	clipboardService.copyTextToClipboard(text);
  		requestStatus.success((message || 'Сохранено') + " в буфер обмена", false);
    }

  }
});

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('longText', longText);

  /** @ngInject */
  function longText($timeout) {
    var directive = {
          restrict: 'E',
          templateUrl: 'app/settings/components/longText/longText.html',
          scope: {
              text: '=',
              url: '='
          },
          controller: longTextController,
          controllerAs: 'vm',
          bindToController: true
        };
    return directive;

    /** @ngInject */
    function longTextController($scope, $element) {
      var vm = this;
      $scope.$watch('vm.text', function(val, newVal) {
        $timeout(function() {
          vm.isFits = $element.get()[0].offsetWidth > $element.parent().get()[0].offsetWidth;
        }, 0);
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('formErrors', function(){
      return {
        restrict: 'E',
        templateUrl: 'app/settings/components/formErrors/formErrors.html',
        scope: {
          formCtrl: '=',
          canShow: '<',
          // пользовательские проверки на вывод сообщений
          customCheck: '<'
        },
        controller: function($scope) {
          $scope.reqError = true;
          $scope.insideCanShow = false;
          $scope.$watch('formCtrl.$error', function(newVal) {
            if(newVal){
              var keyLen = Object.keys(newVal).length;
              if(!keyLen){
                $scope.insideCanShow = false;
              }else if(!newVal.required){
                $scope.reqError = false;
                $scope.insideCanShow = true;
              }else{
                $scope.reqError = true;
                $scope.insideCanShow = true;
              }
            }
          }, true);
          
        }
      }
    });

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('formButtons', {
      transclude: true,
      bindings: {
        viewType: '<',
        onButton: '&',
        hideDelete: '<',
        canDisabled: '<',
        noActionCheck: '<?', // флаг игнорирования проверок прав на дейтсвие
        formPristine: '<?', // показ/скрытие кнопок, если форма нетронута
        isSmsButton: '<?', // для показа кнопки "Отправить СМС" в сотрудниках
        userPhone: '<?'
      },
      templateUrl: 'app/settings/components/formButtons/formButtons.html',
      controller: function($scope, auth, requestStatus, $filter) {
        var ctrl = this;

        // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
        ctrl.crudState = {
          error: false,
          message: '',
          loading: false,
          // Утилитарный метод устанавливающий флаги состояния загрузки
          startLoading: function () {
            ctrl.crudState.error = false;
            ctrl.crudState.message = '';
            ctrl.crudState.loading = true;
          },
          stopLoadingSuccess: function () {
            ctrl.crudState.error = false;
            ctrl.crudState.message = '';
            ctrl.crudState.loading = false;
          },
          stopLoadingFailure: function (message) {
            ctrl.crudState.error = true;
            ctrl.crudState.message = message;
            ctrl.crudState.loading = false;
          }
        };

        /**
         * метод проксирует процесс сохранения
         */
        ctrl.actionDecorator = function (action) {
          ctrl.crudState.startLoading();
          ctrl.onButton(action).then(function () {
            ctrl.crudState.stopLoadingSuccess();
          }, function () {
            ctrl.crudState.stopLoadingFailure();
          });
        }

        ctrl.sendPassword = function (phone) {
          auth.generateTempPassword(phone).then(function (data) {
              requestStatus.success("СМС с временным паролем отправлено на телефон: " + $filter('phoneFormat')(phone));
            },
            function (error) {
              requestStatus.error('При отправке смс произошла ошибка. Мы уже в курсе, и работаем над ее устранением. Попробуйте повторить действие спустя некоторое время.');
            });
        }

      }//ctrl end
    });//component ends

})();

(function () {
  'use strict';

  angular.module('frontend').service('addressService', addressService);

  function addressService($http, API_URL) {

    /* отправить строку адреса, получить измененную строку, id, уровень доступа */
    this.address = function (addr, truncate, postal_index) {
      return $http.post(API_URL + '/address', addr, {
        params: {
          truncate_address: truncate,
          postal_index: postal_index,
          $$ignoreInterceptor: true
        }
      });
    };

    /* отправить строку адреса, получить измененную строку, id, уровень доступа */
    this.addressExt = function (addr, truncate, postal_index) {
      return $http.post(API_URL + '/address/ext', addr, {
        params: {
          truncate_address: truncate,
          postal_index: postal_index,
          $$ignoreInterceptor: true
        }
      });
    };

    this.addressExtPublic = function (addr, truncate, postal_index) {
      return $http.post(API_URL + '/locations/ext', addr, {
        params: {
          truncate_address: truncate,
          postal_index: postal_index,
          $$ignoreInterceptor: true
        }
      });
    };

    /* подсказки для полей в попапе */
    this.addressGranular = function (str) {
      return $http.get(API_URL + '/address/suggest/granular/?' + str);
    };

    /* подсказка для textarea */
    this.addressSuggest = function (str, truncate) {
      var truncateAddress = (truncate) ? 'PLACE' : 'ADDRESS';
      return $http.get(API_URL + '/address/suggest?suggest_type=' + truncateAddress + '&search_string=' + str);
    };

    /* подсказка для textarea */
    this.addressSuggestPublic = function (str) {
      return $http.get(API_URL + '/locations/suggest?search_string=' + str);
    };

    /* получить детальную информацию по id */
    this.addressObject = function (id) {
      return $http.get(API_URL + '/address/' + id);
    };

    /* Редактирование детальной инофрмации об адресном объекте */
    this.updateObject = function (id, addrObj) {
      return $http.put(API_URL + '/address/' + id, addrObj, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('address', address);

  /** @ngInject */
  function address() {
    var directive = {
          restrict: 'E',
          templateUrl: 'app/settings/components/address/address.html',
          scope: {
              // ng-model где хранится адресный объект
              addressData: '=',
              // имя родительской формы
              parentForm: '=',
              // name поля для установки ошибки
              name: '<',
              // обязательность поля
              ngRequired: '<?',
              // какое поле использовать (input, textarea)
              mode: '<?',
              // в адресе обрезка всего что ниже поселка
              truncate: '<',
              // часовой пояс
              timezone: '=?',
              //
              postalIndex: '<?',
              //
              usePublic: '=',
              // Название поля
              fieldLabel: '<',
              // стурктура для внешнего управления
              addressControls: '=?'
          },
          controller: addressController,
          controllerAs: 'vm',
          bindToController: true
        };

    return directive;

    /** @ngInject */
    function addressController(settings, $timeout, addressService, $uibModal, $scope, $q) {
      var QC_WRONG_ADDRESS = 2,     // параметр для переменной qc - мусорный адрес
          QC_NOT_EXACTLY = 3,       // параметр для переменной qc - не точный адрес
          QC_HOUSE_NO_HOUSE = 2,    // параметр для переменной qc_house - не указан дом
          QC_COMPLETE_OK = 0,       // параметр для переменной qc_complete - адрес прошел проверку
          QC_COMPLETE_NO_FLAT = 5;  // параметр для переменной qc_complete - не указана квартира
      var vm = this,
          targetInput = '';
      vm.confirmPopup = false;
      vm.addressPopup = false;
      vm.statusClass = '';
      vm.oldAddr = (vm.addressData)? vm.addressData.address_as_string : '';
      vm.addrID = (vm.addressData)? vm.addressData.id : '';
      /* установка флагов статуса и необходимых сообщений */
      vm.setStatus = function(status){
        vm.statusClass = status;
        if(status == 'error') vm.statusMessage = "Не распознан";
        if(!status || status == 'success') vm.statusMessage = "";
        if(status == 'rewrite') vm.statusMessage = "Проверьте корректность";
        if(status == 'success' && vm.addressData.accepted)  vm.statusMessage = "Подтвержден вручную";
        if(vm.parentForm[vm.name]){
          vm.parentForm[vm.name].$setValidity('address', status != 'error');
        }
      }

      if(vm.addressData) {
        if(vm.addressData.accepted){
          vm.setStatus('success');
        }else if(vm.addressData.qc_house !== QC_HOUSE_NO_HOUSE || (vm.addressData.qc_complete !== QC_COMPLETE_OK && vm.addressData.qc_complete !== QC_COMPLETE_NO_FLAT)){
          vm.setStatus('rewrite');
        }else if(!vm.addressData.qc){
          vm.setStatus('success');
        }
        if(vm.addressData.qc == QC_WRONG_ADDRESS && !vm.addressData.accepted){
          vm.setStatus('error');
        }
      }

      vm.getSuggest = function(str){
        if(!str) vm.areaTip = [];
        if(vm.oldAddr !== str){
          vm.setStatus();
          vm.addrID = '';
          vm.addressData = {address_as_string: str};
        }
        if (vm.usePublic) {
          addressService.addressSuggestPublic(str, vm.truncate, vm.postalIndex).then(function(res){
            vm.areaTip = res.data;
          });
        } else {
          addressService.addressSuggest(str, vm.truncate, vm.postalIndex).then(function(res){
            vm.areaTip = res.data;
          });
        }
      }

      vm.filterThrottled = _.debounce(vm.getSuggest, 500);

      vm.getTip = function(str){
        vm.filterThrottled(str);
      }

      vm.choiseTip = function(str){
        vm.addressData.address_as_string = str;
        vm.areaTip = [];
      }

      vm.keyEvent = function(event){
        var ul = event.target.parentElement.getElementsByClassName('dropdown-menu')[0];
        // 38 up, 40 down, 13 enter, 8 backspase
        if(event.keyCode == 8 && !event.target.value){ // сброс статусов и информации об адресе
          vm.setStatus();
          vm.addrID = '';
          vm.addressData = undefined;
        }
        if(event.keyCode == 13){
          if(event.target.tagName == "TEXTAREA"){
            var activeItem = ul.getElementsByClassName('active')[0];
            if(activeItem){
              vm.choiseTip(activeItem.innerText.trim())
            }
          }else{
            event.stopPropagation();
            event.preventDefault();
            vm.choiseTip(ul.getElementsByClassName('active')[0].innerText.trim(), event.target);
          }
        }
        if(event.keyCode == 40 || event.keyCode == 38){
          var cursorPos = event.target.selectionStart;
          var totalLen = event.target.value.length;
          var nodes = Array.prototype.slice.call( ul.children );
          var ind = nodes.indexOf(ul.getElementsByClassName('active')[0]);

          if(cursorPos == totalLen && ul.children.length){
            if(!ul.getElementsByClassName('active').length){
              ul.children[0].classList.add("active");
            }else{
              if(ul.children.length-1 != ind){
                ul.children[ind].classList.remove("active");
                ul.children[ind+1].classList.add("active");
              }
            }
          }else if(!cursorPos && ul.children.length){
            if(!ul.getElementsByClassName('active').length){
              ul.children[ul.children.length-1].classList.add("active");
            }else{
              if(ind){
                ul.children[ind].classList.remove("active");
                ul.children[ind-1].classList.add("active");
              }
            }
          }
        }
      }

      vm.address = function(addrStr, callback){
        if(vm.mode === 'input'){
          var addressPromise;
          if (vm.usePublic) {
            addressPromise = addressService.addressExtPublic({address_as_string: addrStr}, vm.truncate, vm.postalIndex);
          } else {
            addressPromise = addressService.addressExt({address_as_string: addrStr}, vm.truncate, vm.postalIndex);
          }
          return addressPromise.then( function(res) {
            callback(res.data.view_ref);
            if(res.data.time_zone) vm.timezone = res.data.time_zone;
            return res;
          });
        }else{
          return addressService.addressExt({address_as_string: addrStr}, vm.truncate, vm.postalIndex).then( function(res) {
            callback(res.data.view_ref);
            if(res.data.time_zone) vm.timezone = res.data.time_zone;
            return res;
          });
        }
      }

      // проверка  адресса в textarea
      vm.checkAddr = function(addrStr, accepted){
        if(!addrStr){
          vm.setStatus();
          vm.addrID = '';
          vm.addressData = undefined;
        }

        // в проверке дичь
        if (addrStr &&  // если есть строка для проверки
           (!vm.addressData || !vm.addressData.accepted) && // и если нет данных о адресе или если адрес не подтвержден вручную
           ((vm.oldAddr !== addrStr) || (!vm.addrID))) { // если строка адреса изменилась или если не определен id адреса
          vm.oldAddr = addrStr;

          return vm.address(addrStr, function(res){
            vm.addressData = angular.copy(res, vm.addressData);
            if(accepted) vm.addressData.accepted = true;
            if(res.qc == QC_WRONG_ADDRESS && !accepted){
              vm.addressData.address_as_string = addrStr;
              vm.setStatus('error');
            }else{
              if(!res.qc){
                if((res.qc_complete == QC_COMPLETE_OK || res.qc_complete == QC_COMPLETE_NO_FLAT) && res.qc_house == QC_HOUSE_NO_HOUSE){
                  vm.addressData.address_as_string = res.address_as_string;
                  vm.oldAddr = vm.addressData.address_as_string;
                  vm.areaTip = [];
                  vm.setStatus('success');
                }else{
                  vm.addressData.address_as_string = addrStr;
                  vm.oldAddr = vm.addressData.address_as_string;
                  vm.areaTip = [];
                  vm.setStatus('rewrite');
                }
              }else if(res.qc && !accepted){
                vm.setStatus('rewrite');
                vm.addressData.address_as_string = (res.qc == QC_NOT_EXACTLY)? res.address_as_string : addrStr;
                vm.oldAddr = (res.qc == QC_NOT_EXACTLY)? res.address_as_string : addrStr;
              }
            }
            vm.addrID = res.id;
          }).then( function(res) {
            return res;
          });
        }else{
          return $q.when();
        }
      }

      vm.adressDetail = function(){
        $uibModal.open({
          templateUrl: 'app/settings/components/address/modals/address-detail.html',
          size: 'middle-width',
          windowClass: 'more-zindex',
          resolve: {
            address: function() {
              if(vm.addrID){
                return addressService.addressObject(vm.addrID).then(function(res) {
                  return res;
                })
              }else{
                return undefined;
              }
            }
          },
          controller: function ($scope, $uibModalInstance, address) {
            $scope.addrID = vm.addrID;
            $scope.getTip = vm.getTip;
            $scope.keyEvent = vm.keyEvent;
            $scope.statusClass = vm.statusClass;
            $scope.granularListRegion = vm.granularListRegion;
            $scope.granularListArea = vm.granularListArea;
            $scope.granularListCity = vm.granularListCity;
            $scope.granularListStreet = vm.granularListStreet;
            $scope.addrData = {
              granular_address: {
                house_type: 'HOUSE',
                building_type: 'BUILDING',
                flat_type: 'FLAT'
              }
            };
            if(!vm.addressData){
              vm.addressData = {};
            }
            // данные для выпадающих списков
            $scope.houseTypes = [
              {id: 'HOUSE', name: 'Дом'},
              {id: 'HOLDING', name: 'Владение'},
              {id: 'HOUSEKEEPING', name: 'Домовладение'},
              {id: 'GROUND', name: 'Участок'}
            ];
            $scope.buildingTypes = [
              {id: 'BUILDING', name: 'Строение'},
              {id: 'FACILITY', name: 'Сооружение'},
              {id: 'LITER', name: 'Литера'}
            ];
            $scope.flatTypes = [
              {id: 'FLAT', name: 'Квартира'},
              {id: 'PREMISE', name: 'Помещение'},
              {id: 'OFFICE', name: 'Офис'},
              {id: 'ROOM', name: 'Комната'}
            ];

            function onResolve(res) {
              $scope.addrData = res.data;
              if(res.data.granular_address.postal_code && !res.data.granular_address.city && !res.data.granular_address.settlement){
                $scope.addrData.granular_address.postal_code = undefined;
              }
              if(!$scope.addrData.granular_address.house_type) $scope.addrData.granular_address.house_type = "HOUSE";
              if(!$scope.addrData.granular_address.building_type) $scope.addrData.granular_address.building_type = "BUILDING";
              if(!$scope.addrData.granular_address.flat_type) $scope.addrData.granular_address.flat_type = "FLAT";
              if($scope.addrData.granular_address.settlement) $scope.addrData.granular_address.city = $scope.addrData.granular_address.settlement;
            }
            if(address){
              onResolve(address);
            }

            $scope.findStr = function(id, arr){
              var res = '';
              angular.forEach(arr, function(item){
                if(item.id == id) res = item.name;
              });
              return res;
            };

            $scope.choiseTip = function(obj, input, name){

              if(input.value){
                input.value = obj.caption;
              }else{
                $scope.addrData.granular_address[name] = obj.caption;
              }
              angular.element(input).blur();
              $scope.granularListRegion = $scope.granularListArea = $scope.granularListCity = $scope.granularListStreet = [];
              delete obj.caption;
              delete obj.type;
              $scope.addrData.fias = obj;
            }
            // закрыть попап
            $scope.close = function() {
              $uibModalInstance.dismiss();
            };

            /**
              * to collect data from the fields pop-up
              * @param  event(blur in popup)
              */

            // сбор данных в строку для проверки адреса
            $scope.gatherAddrAsString = function(firstIndex){
              var gatherAddrStr = '';
              for(var prop in $scope.addrData.granular_address){
                if($scope.addrData.granular_address[prop] && prop != 'select'){
                  if(prop == 'house'){
                    gatherAddrStr += $scope.findStr($scope.addrData.granular_address.house_type, $scope.houseTypes) + ' ';
                  }else if(prop == 'building'){
                    gatherAddrStr += $scope.findStr($scope.addrData.granular_address.building_type, $scope.buildingTypes) + ' ';
                  }else if(prop == 'flat'){
                    gatherAddrStr += $scope.findStr($scope.addrData.granular_address.flat_type, $scope.flatTypes) + ' ';
                  }else if(prop == 'housing'){
                    gatherAddrStr += 'Корпус ';
                  }

                  if(prop != "house_type" && prop != "building_type" && prop != "flat_type" && !( prop == "postal_code" && firstIndex === true))
                    gatherAddrStr += $scope.addrData.granular_address[prop] + ", ";

                  if( firstIndex === true && prop == "postal_code"){
                    gatherAddrStr = $scope.addrData.granular_address[prop] + ", " + gatherAddrStr;
                  }

                }
              }
              gatherAddrStr = gatherAddrStr.substring(0, gatherAddrStr.length - 2);
              return gatherAddrStr;
            };

            $scope.gatherData = function(event, checkHouse, withSave){
              $scope.isSaved = true;
              if(checkHouse && !event.target.value) $scope.wrongHouse = false;
              $scope.addrData.address_as_string = $scope.gatherAddrAsString();
              if(withSave) $scope.saveAddr();
            };

            $scope.saveAddr = function(){
              if($scope.addrData.accepted === true) $scope.addrData.address_as_string = $scope.gatherAddrAsString(true);

              if (($scope.addrData.address_as_string && $scope.addrData.address_as_string === '') || !$scope.addrData.address_as_string) {
                return
              }
              var promiseAddr;
              if($scope.addrID){
                promiseAddr = addressService.updateObject($scope.addrID, $scope.addrData).then(function(res){
                  vm.addressData = {
                    id: res.data.id,
                    address_as_string: res.data.address_as_string,
                    qc: res.data.address_quality.qc,
                    qc_house: res.data.address_quality.qc_house,
                    accepted: res.data.accepted
                  };
                  if(!res.data.qc){
                    vm.areaTip = [];
                    $scope.addrData.address_as_string = res.data.address_as_string;
                  }
                });
              }else{
                promiseAddr = vm.checkAddr($scope.addrData.address_as_string, $scope.addrData.accepted);
              }
              // заполнение данных для корректного отображения статусов
              return promiseAddr.then(function(){
                vm.addressData.accepted = $scope.addrData.accepted;
                if($scope.addrID){
                  vm.addrID = $scope.addrID;
                }
                if($scope.addrData.accepted){
                  vm.statusClass = 'success';
                }
                if(vm.statusClass){
                  vm.setStatus(vm.statusClass);
                }
                $scope.close();
              });
            };

            $scope.getSuggest = function(str, type){
              if(!str) $scope.granularListRegion = $scope.granularListArea = $scope.granularListCity = $scope.granularListStreet = [];
              var requestStr = "from_bound=" + type + "&to_bound=" + type;
              if(type == 'CITY') requestStr = "from_bound=" + type + "&to_bound=SETTLEMENT";
              requestStr += "&search_string=" + str;
              if($scope.addrData.fias){
                if($scope.addrData.fias.region_fias_id && type != 'REGION'){
                  requestStr += "&parent_region_id=" + $scope.addrData.fias.region_fias_id;
                }
                if($scope.addrData.fias.area_fias_id && type != 'REGION' && type != 'AREA'){
                  requestStr += "&parent_area_id=" + $scope.addrData.fias.area_fias_id;
                }
                if($scope.addrData.fias.city_fias_id && type != 'REGION' && type != 'AREA' && type != 'CITY'){
                  requestStr += "&parent_city_id=" + $scope.addrData.fias.city_fias_id;
                }
                if($scope.addrData.fias.settlement_fias_id && type != 'REGION' && type != 'AREA' && type != 'CITY' && type != 'STREET'){
                  requestStr += "&parent_settlement_id=" + $scope.addrData.fias.settlement_fias_id;
                }
              }

              addressService.addressGranular(requestStr).then(function(res){
                if(type == 'REGION'){
                  $scope.granularListRegion = res.data;
                }else if(type == 'AREA'){
                  $scope.granularListArea = res.data;
                }else if(type == 'CITY'){
                  $scope.granularListCity = res.data;
                }else if(type == 'STREET'){
                  $scope.granularListStreet = res.data;
                }
              });

            }

            $scope.filterThrottled = _.debounce($scope.getSuggest, 500);

            $scope.getTip = function(str, type){
              $scope.filterThrottled(str, type);
            }
          }
        })
      }


      vm.openPopupAddress = function(){
        if(vm.statusClass == 'error'){
          $uibModal.open({
            templateUrl: 'app/settings/components/address/modals/confirm-popup.html',
            size: 'small-width',
            controller: function ($scope, $uibModalInstance) {
              $scope.addrID = vm.addrID || vm.addressData.id;
              $scope.addressStr = vm.addressData.address_as_string;
              $scope.setStatus = vm.setStatus;
              $scope.adressDetail = vm.adressDetail;

              // получение детальной информации по адресу
              if($scope.addrID){
                addressService.addressObject($scope.addrID).then(function(res) {
                  $scope.addrData = res.data;
                });
              }

              $scope.save = function() {
                $scope.addrData.accepted = true;
                $scope.addrData.address_as_string = $scope.addressStr;
                if($scope.addrID){
                  addressService.updateObject($scope.addrID, $scope.addrData).then(function(res){
                    vm.addressData = {
                      id: res.data.id,
                      address_as_string: res.data.address_as_string,
                      qc: res.data.address_quality.qc,
                      qc_house: res.data.address_quality.qc_house,
                      accepted: res.data.accepted
                    };
                    vm.setStatus('success');
                    $uibModalInstance.dismiss();
                  });
                }
              };

              $scope.close = function() {
                $uibModalInstance.dismiss();
              };
            }
          });
        }else{
          vm.adressDetail();
        }
      }

      if (vm.addressControls) {
        // установка ссылки на экспортируемый метод на объект внешнего управления
        vm.addressControls.checkAddr = vm.checkAddr;
      }
    }
  }
})();

(function () {
    'use strict';

    /*eslint angular/controller-as-vm: [2,"vm"]*/
    angular.module('frontend').controller('crudCompaniesController', crudCompaniesController);

    function crudCompaniesController($scope, $log, $q, $filter, $state, $uibModal, $window, $stateParams, company, companyService, $timeout,
                                     errorMessageService, taxs, utilsService, cardHistory, taxModalSrv, $anchorScroll) {
      var vm = this;
      vm.today = vm.date = moment().utc().startOf('day').valueOf();
      vm.state = $state;
      vm.oldTimeZone = '';
      /* Маппинг систем налогообложения */
      vm.taxs = taxs.items;
      // структура для управления директивой адреса
      vm.addressOptions = {};

      vm.showPopup = function(viewType){
        vm.promice = taxModalSrv.showModal(true, viewType, vm.mode, 
                                          vm.tax_modes_modified, vm.taxs);
        vm.promice.result.then(function(res) {
          if(res){
            vm.currentTax = res.currentTax;
            vm.tax_modes_modified = res.tax_modes_modified;
          }
        });
      }

      vm.onDatePickerClose = function (returnValue, name) {
        // ставим для всех, чтобы нельзя было выбрать сначала дату, а потом тип
        vm.taxs.forEach(function (tax) {
          tax.start_date = returnValue.valueOf();
        });
      };

      vm.mode = {
        isEdit: vm.state.current.name.endsWith('edit'),
        isNew: vm.state.current.name.endsWith('new'),
        isView: vm.state.current.name.endsWith('view')
      };
      
      // для возврата на предыдущую страницу
      vm.returnToPage = function () {
        var prev = cardHistory.popStep('companyId', $stateParams.companyId) || {name: 'companies', param: {}};
        $state.go(prev.name !== '' ? prev.name : 'companies', prev.param || {parent: 'retail'});
      };

      /* Инициализация компании */
      vm.initData = function () {
        if (vm.mode.isNew) {
          // Инициализация DTO компании при создании нового
          vm.company = {
            // Инциализация типа компании по-умолчанию (юридическое лицо)
            organization: {
              legal_requisites: {
                legal_status: (vm.state.params.type) ? vm.state.params.type : "LEGAL_ENTITY"
              },
              accounts: [],
              tax_modes: []
            }
          }

          // Инициализация систем налогообложения
          vm.currentTax = {};
          vm.currentTax.tax_mode = vm.taxs[0].type;
          vm.addTaxMode = true;
        } else {
          vm.company = $.extend(true, {}, company);
          vm.oldTimeZone = company.time_zone;
          vm.company.organization.accounts = vm.company.organization.accounts || [];
          vm.company.organization.tax_modes = vm.company.organization.tax_modes || [];
          /* Инициализация текущей системы налогообложения */
          vm.tax_modes_modified = [];
          vm.widget = [{
            name: 'Спецрежимы налогообложения',
            component: 'special-tax-mode',
            settingsComponent: 'specialTaxMode',
            options: {
              divisions: company.divisions,
              companyId: company.id || undefined
            },
            visible: true
          }];
          vm.company.organization.tax_modes.sort(function (a, b) {
            return a.start_date - b.start_date;
          }) // сортировка массива по возрастанию дат
          angular.forEach(vm.company.organization.tax_modes, function (tax_mode, i, tax_modes) { //первичный расчет текущей системы + свойство end_date
            if (tax_modes[i + 1] && tax_mode.start_date < tax_modes[i + 1].start_date) { // если систем больше 1 , создается своество end_date
              tax_mode.$$end_date = moment.utc(tax_modes[i + 1].start_date).subtract(1, 'day').valueOf();
            }
            if (!vm.currentTax || vm.currentTax.start_date < tax_mode.start_date) {// определение текущей системы налогообложения
              if ((vm.today > tax_mode.start_date && vm.today <= tax_mode.$$end_date)) {
                vm.currentTax = {
                  tax_mode: tax_mode.tax_mode,
                  start_date: tax_mode.start_date,
                  $$end_date: tax_mode.$$end_date || undefined
                };
              }
            }
          });
          vm.tax_modes_modified = angular.copy(vm.company.organization.tax_modes);
          vm.currentTax = vm.currentTax || vm.tax_modes_modified[vm.tax_modes_modified.length - 1]; // если сегодняшняя дата не вписывается в диапазоны существующих систем, показывается наиболее близкая к сегоднящнему дню
          vm.tax_modes_modified.reverse();
        }
      };
      vm.initData();

      vm.resetData = function () {
        if (vm.company.id) {
          vm.initData();
        }
        if ($scope.addOrg) {
          $scope.addOrg.$setPristine();
        }
        vm.returnToPage();
      };

      // С сервера не получить пока
      vm.divisionsTabs = [
        {
          type: "OFFICE",
          title: "Офисы",
          className: "office-tab"
        },
        {
          type: "SHOP",
          title: "Магазины",
          className: "shop-tab"
        },
        {
          type: "STOREHOUSE",
          title: "Склады",
          className: "warehouse-tab"
        }
      ];

      vm.addressCheck = function(addrObj){
        return (addrObj && !addrObj.id) ? vm.addressOptions.checkAddr(addrObj.address_as_string).then(function (res) {
          return res;
        }) : $q.when({});
      }

      vm.closeTab = function () {
        if ($stateParams.closeTab) {
          $window.close();
        }
      }

      // В методе выполняются подготовительные операции перед сохранением
      vm.prepareSave = function () {
        // Сначала очищаем все ранее добавленные данные без идентификатора
        if (!vm.company.organization.legal_requisites.registration_date) {
          vm.company.organization.legal_requisites.registration_date = null;
        } else {
          vm.company.organization.legal_requisites.registration_date = new Date(vm.company.organization.legal_requisites.registration_date).getTime();
        }

        if (!vm.mode.isNew) {
          vm.company.organization.tax_modes = vm.tax_modes_modified
        } else {
          if (vm.currentTax.tax_mode) {
            // так как дата начала у нас во всех налогах одинаковая, то берём первый
            if(vm.taxs[0].start_date){
              vm.currentTax.start_date = vm.taxs[0].start_date;
            }else{
              vm.currentTax.start_date = vm.today;
            }
            vm.company.organization.tax_modes.push(vm.currentTax)
          }
        }
        if(vm.company.time_zone && vm.company.time_zone.timezoneId){
          vm.newTimezoneObj = angular.copy(vm.company.time_zone);
          vm.company.time_zone = vm.company.time_zone.timezoneId;
        }
      };

      vm.isValidAddr = function(addr){
        if(!addr) return true;
        if(addr.data && addr.data.view_ref){
          return !(addr.data.view_ref.qc == 2 && !addr.data.view_ref.accepted);
        }else{
          return true;
        }
      }

      // Метод, вызываемый при сохранении или изменении сотрудника
      vm.save = function () {
        $q.all([vm.addressCheck(vm.company.real_address), 
                vm.addressCheck(vm.company.organization && 
                                vm.company.organization.legal_requisites && 
                                vm.company.organization.legal_requisites.legal_address)]).then(function (values) {
          if(vm.isValidAddr(values[0]) && vm.isValidAddr(values[1])){
		        var deferred = $q.defer();
		        // подготовка структур в соответствие АПИ
		        vm.prepareSave();
		        if (vm.company.id) {
		          // Блок обновления
		          return companyService.updatecompany(vm.company).then(
		            function () {
		              company = vm.company;
                  vm.closeTab();
		              vm.resetData();
                  return deferred.resolve();
		            },
		            function (error) {
		              if (error.data && error.data.code == 'unable_change_timezone') {
		                $uibModal.open({
		                  templateUrl: 'app/settings/templates/modals/one-question.html',
		                  size: 'small-width',
		                  controller: function ($scope, $uibModalInstance) {
		                    $scope.text = "Нельзя изменить часовой пояс компании, так как есть обработанные документы.<br>Сохранить обновленные данные без изменения часового пояса?";
		                    $scope.close = function () {
		                      vm.company.time_zone = vm.newTimezoneObj;
		                      $uibModalInstance.dismiss();
		                      return deferred.reject();
		                    };
		                    $scope.action = function () {
		                      vm.company.time_zone = vm.oldTimeZone;
		                      $uibModalInstance.close();
		                      return vm.save();
		                    };
		                  }
		                });
		              } else {
                    if (error.data.code == "business_error" && error.data.message == "Company code contains in object_code") {
                      errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {
                        data: {message: "Операция отклонена. Невозможно удалить код партнера, по котору были начисления бонусов"}
                      }});
                      $scope.addOrg.code.$setValidity('used', false);
                    } else {
		                  errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
                    }
		                vm.currentTax.start_date = moment.utc(vm.currentTax.start_date).format("DD.MM.YYYY");
                    
                    return deferred.reject();
		              }
		            }
		          )
		        } else {
		          // Блок создания
		          return companyService.createcompany(vm.company).then(
		            function () {
                  vm.closeTab();
		              vm.resetData();
		            },
		            function (error) {
		              errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
		              vm.currentTax.start_date = moment.utc(vm.currentTax.start_date).format("DD.MM.YYYY");
                  return deferred.reject();
		            }
		          )
            }
          }
        });
        return $q.when();
      };

      vm.uniqueCheckCode = function (str) {
        if (str || vm.company.code) {
          var obj = {
            "constraint_name": "PARTNER_CODE",
            "parameters": [
              {
                "name": "code",
                "value": str || vm.company.code
              }
            ]
          }
          if (vm.company.id) obj.id = vm.company.id;
          utilsService.uniqueCheck(obj).then(function (res) {
            },
            function (error) {
              if (error.status === 409) {
                angular.forEach(error.data.parameters, function (field) {
                  $scope.addOrg[field.name].$setValidity('unique', false);
                });
              } else {
                $log.debug(error);
              }
            });
        }
      };

      vm.uniqueCheck = function (str) {
        if (str || vm.company.name) {
          var obj = {
            "constraint_name": "COMPANY",
            "parameters": [
              {
                "name": "name",
                "value": str || vm.company.name
              }
            ]
          }
          if (vm.company.id) obj.id = vm.company.id;
          utilsService.uniqueCheck(obj).then(function (res) {
            },
            function (error) {
              if (error.status === 409) {
                angular.forEach(error.data.parameters, function (field) {
                  $scope.addOrg[field.name].$setValidity('unique', false);
                });
              } else {
                $log.debug(error);
              }
            });
        }
      };

      vm.isHasValidErrors = function(errors){
        var errayErrors = Object.keys(errors);
        if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
          vm.isSetDirty = true;
          return true;
        }
        return false;
      }

      vm.setDirty = function () {
        vm.isSetDirty = true;
        utilsService.setDirty($scope.addOrg);
        $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
        return $q.when();
      };

      vm.crud = function (status) {
        switch (status) {
          case 'save':
            if ($scope.addOrg.$valid) {
              return vm.save();
            } else {
              return vm.setDirty();
            }
            break;
          case 'delete':
            return vm.delete();
            break;
          case 'return':
            vm.returnToPage();
            return $q.when();
            break;
          case 'edit':
            $state.go('company.edit', {parent: 'business'});
            return $q.when();
            break;
          default :
            return $q.when();
            break;
        }
      };

      // Метод, вызываемый при удалении компании
      vm.delete = function () {
        companyService.deletecompany(vm.company.id).then(
          function () {
            vm.resetData();
          },
          function (error) {
            if (error.data.code == "business_error" && error.data.message == "Company contains in object_code") {
              errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {
                data: {message: "Операция отклонена. Невозможно удалить компанию, по которой были начисления бонусов"}
              }});
            } else {
              errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {
                data: {message: "Невозможно удалить компанию <strong>" + vm.company.name + "</strong>.<br>Для удаления компании необходимо удалить все связанные с ней подразделения, договоры и документы."}
              }});
            }
          });
        return $q.when();
      };

      vm.changeType = function () {
        if (!vm.company || !vm.company.organization || !vm.company.organization.legal_requisites) 
            return
          
        if (vm.company.organization.legal_requisites.inn) 
          vm.company.organization.legal_requisites.inn = vm.company.organization.legal_requisites.inn.substr(0, 10);
        
        if (vm.company.organization.legal_requisites.ogrn)
          vm.company.organization.legal_requisites.ogrn = vm.company.organization.legal_requisites.ogrn.substr(0, 13);
      }



    }
  }
)();

(function () {
  'use strict';

  angular.module('frontend').service('cashregisterShiftsCrudSumDefsService', cashregisterShiftsCrudSumDefsService);

  /** @ngInject */
  function cashregisterShiftsCrudSumDefsService(crudsService) {
    this.get = function (entity, symbol) {
      entity.tax_totals = entity.tax_totals || [];

      var tax_amount = 0;
      var tax_totals = entity.tax_totals.map(function (tax_total) {
        return new crudsService.SumChild([
          new crudsService.SumTableData(tax_total.tax.name),
          new crudsService.SumTableData(tax_total.home_amount, symbol),
          new crudsService.SumTableData()
        ]);
      });
      var average_receipt = entity.cash_amounts
        ? (entity.cash_amounts.home_sales_for_cash + entity.cash_amounts.home_sales_for_non_cash) /
        entity.number_of_sales
        : '-';

      if (!entity.number_of_sales) {
        average_receipt = '∞';
      }

      if (entity.cash_amounts &&
        (entity.cash_amounts.home_sales_for_cash + entity.cash_amounts.home_sales_for_non_cash === 0)) {
        average_receipt = 0;
      }

      entity.tax_totals.forEach(function (tax_total) {
        tax_amount += tax_total.home_amount;
      });

      return [
        new crudsService.SumHeader([
          new crudsService.SumTableData('Наличные'),
          new crudsService.SumTableData(),
          new crudsService.SumTableData()
        ], false, [
          new crudsService.SumChild([
            new crudsService.SumTableData('Наличных на начало'),
            new crudsService.SumTableData(),
            new crudsService.SumTableData(entity.z_home_start_cash, symbol)
          ]),
          new crudsService.SumChild([
            new crudsService.SumTableData('Продажа', undefined, {state: 'cashregreceipts'}),
            new crudsService.SumTableData(entity.cash_amounts.home_sales_for_cash, symbol),
            new crudsService.SumTableData(entity.z_cash_amounts.home_sales_for_cash, symbol)
          ]),
          new crudsService.SumChild([
            new crudsService.SumTableData('Возвраты', undefined, {state: 'returns'}),
            new crudsService.SumTableData(entity.cash_amounts.home_cash_refunds &&
              -entity.cash_amounts.home_cash_refunds, symbol),
            new crudsService.SumTableData(entity.z_cash_amounts.home_cash_refunds &&
              -entity.z_cash_amounts.home_cash_refunds, symbol)
          ]),
          new crudsService.SumChild([
            new crudsService.SumTableData('Внесения', undefined, {state: 'cashboxreplenishments'}),
            new crudsService.SumTableData(entity.cash_amounts.home_replenishments, symbol),
            new crudsService.SumTableData(entity.z_cash_amounts.home_replenishments, symbol)
          ]),
          new crudsService.SumChild([
            new crudsService.SumTableData('Выемки', undefined, {state: 'encashments'}),
            new crudsService.SumTableData(entity.cash_amounts.home_encashments &&
              -entity.cash_amounts.home_encashments, symbol),
            new crudsService.SumTableData(entity.z_cash_amounts.home_encashments &&
              -entity.z_cash_amounts.home_encashments, symbol
            )], {isUnderlined: true}),
          new crudsService.SumChild([
            new crudsService.SumTableData('Наличных на конец'),
            new crudsService.SumTableData(entity.cash_amounts.home_sales_for_cash -
              entity.cash_amounts.home_cash_refunds +
              entity.cash_amounts.home_replenishments -
              entity.cash_amounts.home_encashments, symbol),
            new crudsService.SumTableData(entity.z_home_end_cash, symbol)
          ])
        ]),
        new crudsService.SumHeader([
          new crudsService.SumTableData('Безналичные'),
          new crudsService.SumTableData(),
          new crudsService.SumTableData()
        ], false, [
          new crudsService.SumChild([
            new crudsService.SumTableData('Продажа'),
            new crudsService.SumTableData(entity.cash_amounts.home_sales_for_non_cash, symbol),
            new crudsService.SumTableData(entity.z_cash_amounts.home_sales_for_non_cash, symbol)]),
          new crudsService.SumChild([
            new crudsService.SumTableData('Возвраты'),
            new crudsService.SumTableData(entity.cash_amounts.home_non_cash_refunds &&
              -entity.cash_amounts.home_non_cash_refunds, symbol),
            new crudsService.SumTableData(entity.z_cash_amounts.home_non_cash_refunds &&
              -entity.z_cash_amounts.home_non_cash_refunds, symbol)])
        ]),
        new crudsService.SumHeader([
          new crudsService.SumTableData('Сумма налогов'),
          new crudsService.SumTableData(tax_amount, symbol),
          new crudsService.SumTableData()
        ], true, tax_totals),
        new crudsService.SumHeader([
          new crudsService.SumTableData('Итоговые показатели'),
          new crudsService.SumTableData(),
          new crudsService.SumTableData()
        ], false, [
          new crudsService.SumChild([
            new crudsService.SumTableData('Средний чек'),
            new crudsService.SumTableData(average_receipt, symbol),
            new crudsService.SumTableData()
          ]),
          new crudsService.SumChild([
            new crudsService.SumTableData('Количество продаж'),
            new crudsService.SumTableData(entity.number_of_sales),
            new crudsService.SumTableData()
          ]),
          new crudsService.SumChild([
            new crudsService.SumTableData('Количество возвратов'),
            new crudsService.SumTableData(entity.number_of_refunds),
            new crudsService.SumTableData('')
          ])
        ])];
    };
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('cashregisterShiftsCrudColumnDefsService',
    cashregisterShiftsCrudColumnDefsService);

  /** @ngInject */
  function cashregisterShiftsCrudColumnDefsService(userSettingsService) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ? \'ascending\' :' +
      ' ( col.sort.direction == desc ? \'descending\' : (!col.sort.direction ? \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\':' +
      ' col.sort.direction == asc, \'ui-grid-icon-down-dir\':' +
      ' col.sort.direction == desc, \'ui-grid-icon-blank\':' +
      ' !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 100, 160, 160, 160, 160, 200, 160, 160];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('cashregister-shifts-crud', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('cashregister-shifts-crud',
          'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('cashregister-shifts-crud', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {

      self.totals = this.cashregisterShiftsTotals;

      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'
        },
        {
          __index: 1,
          name: 'dataValue.code',
          displayName: 'Код',
          width: columnsDefinedWidth[1],
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableSorting: true,
          sortName: 'code',
          pinned: true
        },
        {
          __index: 2,
          name: 'dataValue.name',
          displayName: 'Наименование',
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[2],
          enableSorting: true,
          sortName: 'name',
          pinned: true,
          backButton: true
        },
        {
          __index: 3,
          name: 'dataValue.vendor_code',
          displayName: 'Артикул производителя',
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.natural_quantity',
          displayName: 'Количество',
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<div class="ui-grid-cell-contents"><span>{{row.entity.dataValue.natural_quantity}}' +
          ' {{row.entity.dataValue.natural_uom.symbols}}</span></div>',
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.home_amount',
          displayName: 'Сумма',
          width: columnsDefinedWidth[5],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.currency"/>',
          visible: true
        },
        {
          __index: 6,
          name: 'dataValue.average_price',
          displayName: 'Средняя цена',
          width: columnsDefinedWidth[6],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.currency"/>',
          visible: true
        },

        {
          __index: 7,
          name: 'dataValue.tax_group.name',
          displayName: 'Налоговая группа',
          width: columnsDefinedWidth[7],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: false
        },
        {
          __index: 8,
          name: 'dataValue.tax_amount',
          displayName: 'Сумма налога',
          width: columnsDefinedWidth[8],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.currency"/>',
          visible: false
        },
        {
          __index: 9,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 50,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function () {
  'use strict';
  angular.module('frontend').controller('CashregisterShiftCrudController', CashregisterShiftCrudController);

  function CashregisterShiftCrudController($stateParams,
                                           userSettingsService,
                                           crudsService,
                                           cashregisterShiftsCrudSumDefsService,
                                           cashregisterShiftsCrudColumnDefsService,
                                           API_URL,
                                           uiGridConstants,
                                           cardHistory,
                                           $state,
                                           $uibModal) {
    var ctrl = this;

    var CASHREGISTER_SHIFT_URL = API_URL + '/retail/cashregister_shifts';
    ctrl.url = CASHREGISTER_SHIFT_URL + '/' + $stateParams.id + '/lines?end_shift=' + $state.params.end_shift;
    ctrl.page = 'cashregister-shifts-crud';
    ctrl.header = 'Позиции';
    ctrl.sort = 'name';
    ctrl.limit = 5;
    ctrl.showSum = false;
    ctrl.showTaxTotals = false;
    ctrl.showCash = false;
    ctrl.showNonCash = false;
    ctrl.fields = [];
    ctrl.columnDefs = cashregisterShiftsCrudColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    ctrl.usingService = cashregisterShiftsCrudColumnDefsService;
    ctrl.gridConfig = {
      gridOptions: {
        enableRowSelection: true,
        multiSelect: true,
        enableRowSelectionAll: true
      }
    };
    
    ctrl.returnToPage = function() {
      var prev = cardHistory.popStep('id', $stateParams.id) || {name: 'cashregshifts', param: {}};
      prev.param = angular.extend(prev.param || {}, {page: $stateParams.backPage});
      $state.go(prev.name !== '' ? prev.name : 'cashregshifts', prev.param || {parent: 'retail'});
    };

    ctrl.initPage = function () {
      ctrl.loadingData = true;
      ctrl.success = false;
      ctrl.fail = false;
      ctrl.loadedData = false;

      crudsService.getView(CASHREGISTER_SHIFT_URL + '/' + $stateParams.id, {end_shift: $state.params.end_shift})
        .then(function (result) {
          ctrl.cashRegisterShift = result.data;
          ctrl.cashRegisterTaxTotals = result.data.tax_totals;
          ctrl.formattedTime = ctrl.cashRegisterShift.duration ?
            ctrl.getFormattedTime(ctrl.cashRegisterShift.duration) : '-';

          var shift = result.data.number;
          var duration = result.data.duration ? ctrl.getFormattedTime(result.data.duration) : '-';

          var openDate = result.data.start_date ? ctrl.getFormattedDate(result.data.start_date, true, 'DD.MM.YYYY HH:mm') : '-';
          var openUser = result.data.started_by ? result.data.started_by.name : '-';

          var closeDate = result.data.end_date ? ctrl.getFormattedDate(result.data.end_date, true, 'DD.MM.YYYY HH:mm') : '-';
          var closeUser = result.data.ended_by ? result.data.ended_by.name : '-';

          var company = result.data.company ? result.data.company.name : '-';
          var division = result.data.division ? result.data.division.name : '-';

          var place = result.data.place ? result.data.place.name : '-';
          var cash_register = result.data.cash_register_ext
            ? result.data.cash_register_ext.manufacturer + ' - '
            + result.data.cash_register_ext.model + ' №'
            + result.data.cash_register_ext.serial_num
            : '-';

          ctrl.fields.push(new crudsService.Field('Номер смены',
            shift, null, 'Аппапартный номер смены: ' + (result.data.extNumber || '-')));
          ctrl.fields.push(new crudsService.Field('Продолжительность', duration));

          ctrl.fields.push(new crudsService.Field('Дата открытия', openDate, null, 'Аппаратная дата открытия: ' +
            ctrl.getFormattedDate(result.data.extStartDate, false, 'DD.MM.YYYY HH:mm')));
          ctrl.fields.push(new crudsService.Field('Открыл сотрудник', openUser, {
            stateName: 'employee.view',
            stateParams: {
              userId: result.data.started_by && result.data.started_by.id
            }
          }));

          ctrl.fields.push(new crudsService.Field('Дата закрытия', closeDate, null, 'Аппаратная дата закрытия: ' +
            ctrl.getFormattedDate(result.data.extEndDate, false, 'DD.MM.YYYY HH:mm')));
          ctrl.fields.push(new crudsService.Field('Закрыл сотрудник', closeUser, {
            stateName: 'employee.view',
            stateParams: {
              userId: result.data.ended_by && result.data.ended_by.id
            }
          }));

          ctrl.fields.push(new crudsService.Field('Компания', company, {
            stateName: 'company.view',
            stateParams: {
              companyId: result.data.company && result.data.company.id
            }
          }));
          ctrl.fields.push(new crudsService.Field('Подразделение', division, {
            stateName: 'division.view',
            stateParams: {
              divisionId: result.data.division && result.data.division.id,
              companyId: result.data.company && result.data.company.id
            }
          }));

          ctrl.fields.push(new crudsService.Field('Кассовое место', place));
          ctrl.fields.push(new crudsService.Field('Кассовый аппарат', cash_register));

          userSettingsService.saveProperty('cashregister-receipts', 'grid', 'currentFilter', {shift_number: shift});
          userSettingsService.saveProperty('cashbox-replenishments', 'grid', 'currentFilter', {shift_number: shift});
          userSettingsService.saveProperty('cashbox-encashments', 'grid', 'currentFilter', {shift_number: shift});
          userSettingsService.saveProperty('returns', 'grid', 'currentFilter', {shift_number: shift});

          return result.data;
        })
        .then(function (result) {
          ctrl.currency = result.home_currency.symbol;
          ctrl.sumTable = {
            headerItems: ['', 'ПОДСЧИТАННЫЕ ДАННЫЕ', 'ДАННЫЕ С Z-ОТЧЕТА ККМ'],
            data: cashregisterShiftsCrudSumDefsService.get(result, result.home_currency.symbol)
          };
          ctrl.loadedData = true;
          ctrl.success = true;
        })
        .catch(function () {
          ctrl.fail = true;
        })
        .finally(function () {
          ctrl.loadingData = false;
        });
    };

    userSettingsService.saveProperty('cashregister-receipts', 'grid', 'showFilter', true);
    userSettingsService.saveProperty('cashbox-replenishments', 'grid', 'showFilter', true);
    userSettingsService.saveProperty('cashbox-encashments', 'grid', 'showFilter', true);
    userSettingsService.saveProperty('returns', 'grid', 'showFilter', true);

    ctrl.initPaging = function () {
      ctrl.paging = userSettingsService.loadProperty('cashregister-shift', 'grid', 'paging') || {
        current: 0,
        limit: 5,
        offset: 0,
        sortBy: 'name',
        total: undefined
      };
      ctrl.paging.offset = 0;
      ctrl.paging.current = 0;
    };

    ctrl.getFormattedDate = function (date, showTime, format) {
      return crudsService.getFormattedDate(date, showTime, format);
    };

    ctrl.getFormattedTime = function (time) {
      var hours = time.split(':')[0];
      var minutes = time.split(':')[1];
      if (time.charAt(0) === '0' && time.charAt(1) === '0') {
        return minutes + ' мин.';
      } else {
        return  hours + ' ч. ' + minutes + ' мин.'
      }
    };

    ctrl.showSales = function () {
      ctrl.currentTransType = 'SALES';
    };

    ctrl.showRefunds = function () {
      ctrl.currentTransType = 'REFUNDS';
    };

    ctrl.search = function () {
      ctrl.paging.current = 0;
      ctrl.paging.offset = 0;
    };

    ctrl.salesTotalRepo = function (format) {
      $uibModal.open({
        size: 'middle-width',
        component: 'printSalesReport',
        controllerAs: '$ctrl',
        resolve: {
          format: function() {
            return format;
          },
          company: function() {
            return ctrl.cashRegisterShift.company;
          },
          cashregister_id: function() {
            return ctrl.cashRegisterShift.id;
          },
          division: function() {
            return ctrl.cashRegisterShift.division;
          }
        }
      });
    }

    ctrl.initPage();
    ctrl.initPaging();
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('cashregisterReceiptsCrudSumDefsService', cashregisterReceiptsCrudSumDefsService);

  /** @ngInject */
  function cashregisterReceiptsCrudSumDefsService(crudsService) {
    this.get = function (entity, symbol) {
      entity.tax_amounts = entity.tax_amounts || [];
      entity.payment_type_amounts = entity.payment_type_amounts || [];

      var tax_totals = entity.tax_amounts.map(function (tax_total) {
        return new crudsService.SumChild([
          new crudsService.SumTableData(tax_total.tax.name),
          new crudsService.SumTableData(tax_total.home_amount, symbol)
        ]);
      });

      var payment_type_amounts = entity.payment_type_amounts.map(function (payment_type_amount) {
        return new crudsService.SumChild([
          new crudsService.SumTableData(payment_type_amount.type.name),
          new crudsService.SumTableData(payment_type_amount.home_amount, symbol)
        ]);
      });

      return [
        new crudsService.SumHeader([
            new crudsService.SumTableData('Сумма'),
            new crudsService.SumTableData(entity.home_amount, symbol)
          ], true, payment_type_amounts
        ),
        new crudsService.SumHeader([
          new crudsService.SumTableData('Сумма скидки'),
          new crudsService.SumTableData(entity.home_discount, symbol)
        ], true, []),
        new crudsService.SumHeader([
          new crudsService.SumTableData('Сумма налогов'),
          new crudsService.SumTableData(entity.home_tax_amount, symbol)
        ], true, tax_totals)
      ];
    };
  }
})();

(function () {
  'use strict';

  angular.module('frontend')
    .service('cashregisterReceiptsCrudColumnDefsService', cashregisterReceiptsCrudColumnDefsService);

  /** @ngInject */
  function cashregisterReceiptsCrudColumnDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\':' +
      ' col.sort.direction == asc, \'ui-grid-icon-down-dir\':' +
      ' col.sort.direction == desc, \'ui-grid-icon-blank\':' +
      ' !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 100, 160, 160, 160, 160, 200, 160, 160, 160, 160, 160, 160, 160];

    var markTemplate = '<div class="ui-grid-cell-contents" uib-tooltip="{{grid.appScope.ctrl.getArrTipStr(COL_FIELD, \'amc\')}}" tooltip-placement="bottom">' +
    '  <span ng-bind="grid.appScope.ctrl.getArrTipStr(COL_FIELD, \'amc_name\')"></span>' +
    '</div>';

    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('cashregister-receipts-crud', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('cashregister-receipts-crud',
          'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('cashregister-receipts-crud',
        'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {

      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'
        },
        {
          __index: 1,
          name: 'dataValue.code',
          displayName: 'Код',
          width: columnsDefinedWidth[1],
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableSorting: true,
          sortName: 'code',
          pinned: true
        },
        {
          __index: 2,
          name: 'dataValue.name',
          displayName: 'Наименование',
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[2],
          enableSorting: true,
          sortName: 'name',
          pinned: true,
          backButton: true
        },
        {
          __index: 3,
          name: 'dataValue.printed_line_description',
          displayName: 'Наименование как в чеке',
          visible: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[3],
          enableSorting: false,
          pinned: false
        },
        {
          __index: 4,
          name: 'dataValue.vendor_code',
          displayName: 'Артикул производителя',
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.marks',
          displayName: 'Марка',
          visible: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: markTemplate,
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.quantity',
          displayName: 'Количество',
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<div class="ui-grid-cell-contents"><span>{{row.entity.dataValue.quantity}}' +
          ' {{row.entity.dataValue.uom.symbols}}</span></div>',
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.home_price',
          displayName: 'Цена',
          width: columnsDefinedWidth[7],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellTemplate: headerTemplate,
          visible: true,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>'
        },
        {
          __index: 8,
          name: 'dataValue.home_amount',
          displayName: 'Сумма',
          width: columnsDefinedWidth[8],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: true
        },
        {
          __index: 9,
          name: 'dataValue.home_discount',
          displayName: 'Скидка',
          width: columnsDefinedWidth[9],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: true
        },
        {
          __index: 10,
          name: 'dataValue.settlements_type',
          displayName: 'Способ расчета',
          width: columnsDefinedWidth[10],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD | settlementsTypes"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: false
        },
        {
          __index: 11,
          name: 'dataValue.cash_register_item_type',
          displayName: 'Предмет расчета',
          width: columnsDefinedWidth[11],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD | cashRegisterItemTypes"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: false
        },
        {
          __index: 12,
          name: 'dataValue.tax_amount',
          displayName: 'Сумма налога',
          width: columnsDefinedWidth[12],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellTemplate: headerTemplate,
          visible: true,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>'
        },
        {
          __index: 13,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 50,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }
})();

(function () {
  'use strict';
  angular.module('frontend').controller('CashregisterReceiptCrudController', CashregisterReceiptCrudController);

  function CashregisterReceiptCrudController($state,
                                             $filter,
                                             API_URL,
                                             crudsService,
                                             $stateParams,
                                             cashregisterReceiptsCrudColumnDefsService,
                                             uiGridConstants,
                                             cardHistory,
                                             cashregisterReceiptsCrudSumDefsService) {
    var ctrl = this;
    var CASHREGISTER_RECEIPTS_URL = API_URL + '/retail/documents/RETAIL_SALE';
    ctrl.url = CASHREGISTER_RECEIPTS_URL + '/' + $stateParams.id + '/lines';
    ctrl.page = 'cashregister-receipts-crud';
    ctrl.header = 'Позиции';
    ctrl.sort = 'name';
    ctrl.limit = 5;
    ctrl.showSum = false;
    ctrl.showTaxTotals = false;
    ctrl.showCash = false;
    ctrl.showNonCash = false;
    ctrl.fields = [];
    ctrl.columnDefs = cashregisterReceiptsCrudColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    ctrl.usingService = cashregisterReceiptsCrudColumnDefsService;
    ctrl.gridConfig = {
      gridOptions: {
        enableRowSelection: true,
        multiSelect: true,
        enableRowSelectionAll: true
      }
    };

    ctrl.returnToPage = function() {
      var prev = cardHistory.popStep('id', $stateParams.id) || {name: 'cashregreceipts', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'cashregreceipts', prev.param || {parent: 'retail'});
    };

    ctrl.fields = [];

    ctrl.initPage = function () {
      ctrl.loadedData = false;
      ctrl.loadingData = true;
      ctrl.success = false;
      ctrl.fail = false;
      crudsService.getView(CASHREGISTER_RECEIPTS_URL + '/' + $stateParams.id)
        .then(function (result) {
          ctrl.cashRegisterReceipt = result.data;
          ctrl.currency = ctrl.cashRegisterReceipt.home_currency.symbol;

          var number = result.data.number
            ? result.data.number
            : '-';
          var date = result.data.date
            ? ctrl.getFormattedDate(result.data.date, true, 'DD.MM.YYYY HH:mm')
            : '-';
          var shift = result.data.shift
            ? '№' + result.data.shift.number + ' от ' + ctrl.getFormattedDate(result.data.shift.date)
            : '-';
          var user = result.data.user ? result.data.user.name : '-';
          var company = result.data.company ? result.data.company.name : '-';
          var division = result.data.division ? result.data.division.name : '-';
          var place = result.data.place ? result.data.place.name : '-';
          var tax = result.data.tax_mode ? $filter('tax')(result.data.tax_mode) : '-';
          var cash_register = result.data.cash_register
            ? result.data.cash_register.manufacturer + ' - '
            + result.data.cash_register.model + ' №'
            + result.data.cash_register.serial_num
            : '-';

          ctrl.fields.push(new crudsService.Field('Номер кассового чека', number, null,
            'Аппаратный номер кассового чека: ' + (result.data.ext_number || '-')));
          ctrl.fields.push(new crudsService.Field('Дата кассового чека', date, null,
            'Аппаратная дата кассового чека: ' + (ctrl.getFormattedDate(result.data.ext_date, true, 'DD.MM.YYYY HH:mm') || '-')));

          ctrl.fields.push(new crudsService.Field('Смена', shift, {
            stateName: 'cashregshift.view',
            stateParams: {id: result.data.shift && result.data.shift.id}
          }));
          ctrl.fields.push(new crudsService.Field('Кассир', user, {
            stateName: 'employee.view',
            stateParams: {userId: result.data.user && result.data.user.id}
          }));
          ctrl.fields.push(new crudsService.Field('Компания', company, {
            stateName: 'company.view',
            stateParams: {companyId: result.data.company && result.data.company.id}
          }));
          ctrl.fields.push(new crudsService.Field('Подразделение', division, {
            stateName: 'division.view',
            stateParams: {
              divisionId: result.data.division && result.data.division.id,
              companyId: result.data.company && result.data.company.id
            }
          }));
          ctrl.fields.push(new crudsService.Field('Кассовое место', place));
          ctrl.fields.push(new crudsService.Field('Кассовый аппарат', cash_register));
          ctrl.fields.push(new crudsService.Field('СНО', tax));

          return result.data;
        })
        .then(function (result) {
          ctrl.sumTable = cashregisterReceiptsCrudSumDefsService.get(result, result.home_currency.symbol);
          ctrl.loadedData = true;
          ctrl.success = true;
          ctrl.cashRegister = result.data;
        })
        .catch(function () {
          ctrl.fail = true;
        })
        .finally(function () {
          ctrl.loadingData = false;
        });
    };

    ctrl.goToState = function (name, key, value) {
      if (value) {
        var params = {};

        params[key] = value;
        $state.go(name, params);
      }
    };

    ctrl.getFormattedDate = function (date, returnTime, format) {
      return crudsService.getFormattedDate(date, returnTime, format);
    };

    ctrl.search = function () {
      ctrl.paging.current = 0;
      ctrl.paging.offset = 0;
    };

    ctrl.initPage();
  }
})();

(function () {
  'use strict';

  angular.module('frontend')
    .service('cashboxReplenishmentsCrudSumDefsService', cashboxReplenishmentsCrudSumDefsService);

  /** @ngInject */
  function cashboxReplenishmentsCrudSumDefsService(crudsService) {
    this.get = function (entity, symbol) {
      return [
        new crudsService.SumHeader([
          new crudsService.SumTableData('Сумма'),
          new crudsService.SumTableData(entity.home_amount, symbol)
        ], false, [])
      ];
    };
  }
})();

(function () {
  'use strict';
  angular.module('frontend').controller('CashboxReplenishmentsCrudController', CashboxReplenishmentsCrudController);

  function CashboxReplenishmentsCrudController($state,
                                               API_URL,
                                               crudsService,
                                               $stateParams,
                                               cardHistory,
                                               cashboxReplenishmentsCrudSumDefsService) {
    var ctrl = this;
    var CASHBOX_REPLENISHMENTS_URL = API_URL + '/retail/documents/CASHBOX_REPLENISHMENT';


    ctrl.returnToPage = function() {
      var prev = cardHistory.popStep('id', $stateParams.id) || {name: 'cashboxreplenishments', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'cashboxreplenishments', prev.param || {parent: 'retail'});
    };

    ctrl.showTaxTotals = false;
    ctrl.showSum = false;

    ctrl.fields = [];

    ctrl.initPage = function () {
      ctrl.loadedData = false;
      ctrl.loadingData = true;
      ctrl.success = false;
      ctrl.fail = false;
      crudsService.getView(CASHBOX_REPLENISHMENTS_URL + '/' + $stateParams.id)
        .then(function (result) {
          ctrl.replenishment = result.data;
          ctrl.cashRegisterTaxTotals = result.data.tax_totals;
          ctrl.loadedData = true;
          ctrl.success = true;
          ctrl.cashRegister = result.data.cash_register;

          var number = result.data.number ? result.data.number : '-';
          var date = ctrl.getFormattedDate(result.data.date, true, 'DD.MM.YYYY HH:mm');

          var shift = result.data.shift
            ? '№' + result.data.shift.number + ' от ' + ctrl.getFormattedDate(result.data.shift.date)
            : '-';
          var user = result.data.user ? result.data.user.name : '-';
          var company = result.data.company ? result.data.company.name : '-';
          var division = result.data.division ? result.data.division.name : '-';
          var place = result.data.place ? result.data.place.name : '-';
          var cash_register = result.data.cash_register
            ? result.data.cash_register.manufacturer + ' - '
            + result.data.cash_register.model + ' №'
            + result.data.cash_register.serial_num
            : '-';

          ctrl.fields.push(new crudsService.Field('Номер внесения', number, null,
            'Аппаратный номер внесения: ' + (result.data.ext_number || '-')));

          ctrl.fields.push(new crudsService.Field('Дата внесения', date, null,
            'Аппаратная дата внесения: ' + (ctrl.getFormattedDate(result.data.ext_date, true, 'DD.MM.YYYY HH:mm') || '-')));

          ctrl.fields.push(new crudsService.Field('Смена', shift, {
            stateName: 'cashregshift.view',
            stateParams: {id: result.data.shift && result.data.shift.id}
          }));

          ctrl.fields.push(new crudsService.Field('Кассир', user, {
            stateName: 'employee.view',
            stateParams: {userId: result.data.user && result.data.user.id}
          }));

          ctrl.fields.push(new crudsService.Field('Компания', company, {
            stateName: 'company.view',
            stateParams: {companyId: result.data.company && result.data.company.id}
          }));

          ctrl.fields.push(new crudsService.Field('Подразделение', division, {
            stateName: 'division.view',
            stateParams: {
              divisionId: result.data.division && result.data.division.id,
              companyId: result.data.company && result.data.company.id
            }
          }));

          ctrl.fields.push(new crudsService.Field('Кассовое место', place));
          ctrl.fields.push(new crudsService.Field('Кассовый аппарат', cash_register));
          ctrl.loadedData = true;
          ctrl.success = true;

          return result.data;
        })
        .then(function (result) {
          ctrl.sumTable = cashboxReplenishmentsCrudSumDefsService.get(result, result.home_currency.symbol);
        })
        .catch(function () {
          ctrl.fail = true;
        })
        .finally(function () {
          ctrl.loadingData = false;
        });
    };

    ctrl.goToState = function (name, key, value) {
      if (value) {
        var params = {};

        params[key] = value;
        $state.go(name, params);
      }
    };

    ctrl.getFormattedDate = function (date, returnTime, format) {
      return crudsService.getFormattedDate(date, returnTime, format);
    };

    ctrl.getCashValue = function (value, symbol) {
      return crudsService.getCashValue(value, symbol);
    };

    ctrl.search = function () {
      ctrl.paging.current = 0;
      ctrl.paging.offset = 0;
    };

    ctrl.initPage();
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('cashboxEncashmentsCrudSumDefsService', cashboxEncashmentsCrudSumDefsService);

  /** @ngInject */
  function cashboxEncashmentsCrudSumDefsService(crudsService) {
    this.get = function (entity, symbol) {
      return [
        new crudsService.SumHeader([
            new crudsService.SumTableData('Сумма'),
            new crudsService.SumTableData(entity.home_amount, symbol)
          ], false, [])
      ];
    };
  }
})();

(function () {
  'use strict';
  angular.module('frontend').controller('EncashmentCrudController', EncashmentCrudController);

  function EncashmentCrudController($state,
                                    $stateParams,
                                    cashboxEncashmentsCrudSumDefsService,
                                    crudsService,
                                    encashmentsService,
                                    API_URL,
                                    cardHistory) {
    var ctrl = this;
    var CASHBOX_REPLENISHMENTS_URL = API_URL + '/retail/documents/CASHBOX_ENCASHMENT';

    ctrl.fields = [];

    ctrl.returnToPage = function() {
      var prev = cardHistory.popStep('id', $stateParams.id) || {name: 'encashments', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'encashments', prev.param || {parent: 'retail'});
    };

    ctrl.initPage = function () {
      ctrl.loadingData = true;
      ctrl.success = false;
      ctrl.fail = false;
      ctrl.loadedData = false;
      crudsService.getView(CASHBOX_REPLENISHMENTS_URL + '/' + $stateParams.id)
        .then(function (result) {
          ctrl.encashment = result.data;
          ctrl.cashRegister = result.data.cash_register;
          ctrl.loadedData = true;
          ctrl.success = true;
          ctrl.loadingData = false;

          var number = result.data.number || '-';
          var date = ctrl.getFormattedDate(result.data.date, true, 'DD.MM.YYYY HH:mm');

          ctrl.fields.push(new crudsService.Field('Номер выемки', number, null,
            'Аппаратный номер выемки: ' + (result.data.ext_number || '-')));

          ctrl.fields.push(new crudsService.Field('Дата выемки', date, null,
            'Аппаратная дата выемки: ' + (ctrl.getFormattedDate(result.data.ext_date, true, 'DD.MM.YYYY HH:mm') || '-')));

          var shift = result.data.shift
            ? '№' + result.data.shift.number + ' от ' + ctrl.getFormattedDate(result.data.shift.date)
            : '-';
          var user = result.data.user ? result.data.user.name : '-';
          var company = result.data.company ? result.data.company.name : '-';
          var division = result.data.division ? result.data.division.name : '-';
          var place = result.data.place ? result.data.place.name : '-';
          var cash_register = result.data.cash_register
            ? result.data.cash_register.manufacturer + ' - '
            + result.data.cash_register.model + ' №'
            + result.data.cash_register.serial_num
            : '-';

          ctrl.fields.push(new Field('Смена', shift, {
            stateName: 'cashregshift.view',
            stateParams: {
              id: result.data.shift && result.data.shift.id
            }
          }));
          ctrl.fields.push(new Field('Кассир', user, {
            stateName: 'employee.view',
            stateParams: {
              userId: result.data.user && result.data.user.id
            }
          }));
          ctrl.fields.push(new Field('Компания', company, {
            stateName: 'company.view',
            stateParams: {
              companyId: result.data.company && result.data.company.id
            }
          }));
          ctrl.fields.push(new Field('Подразделение', division, {
            stateName: 'division.view',
            stateParams: {
              divisionId: result.data.division && result.data.division.id,
              companyId: result.data.company && result.data.company.id
            }
          }));
          ctrl.fields.push(new Field('Кассовое место', place));
          ctrl.fields.push(new Field('Кассовый аппарат', cash_register));

          return result.data;
        })
        .then(function (result) {
          ctrl.sumTable = cashboxEncashmentsCrudSumDefsService.get(result, result.home_currency.symbol);
        })
        .catch(function () {
          ctrl.fail = true;
        }).finally(function () {
        ctrl.loadingData = false;
      });
    };

    ctrl.getFormattedDate = function (date, showTime, format) {
      return crudsService.getFormattedDate(date, showTime, format);
    };


    ctrl.redirectToCompany = function () {
      $state.go('company.view', {
        companyId: ctrl.encashment.company.id,
        parent: 'business'
      });
    };

    ctrl.redirectToDivision = function () {
      $state.go('division.view', {
        companyId: ctrl.encashment.company.id,
        divisionId: ctrl.encashment.division.id,
        parent: 'business'
      });
    };

    ctrl.redirectToUser = function () {
      $state.go('employee.view', {
        userId: ctrl.encashment.user.id,
        parent: 'business'
      });
    };

    function Field(name, value, linkParams, info) {
      this.name = name;
      this.value = value.replace(/\s{2,}/g, ' ');
      this.linkParams = linkParams;
      this.info = info;
    }

    ctrl.initPage();
  }
})();



angular.module('frontend')
  .controller('beneficiaryCrudController', function ($scope,
                                                     $state,
                                                     beneficiary,
                                                     companies,
                                                     beneficiaryService,
                                                     $q,
                                                     $stateParams,
                                                     cardHistory,
                                                     askDeleteSrv,
                                                     errorMessageService,
                                                     utilsService,
                                                     $window) {
    var vm = this;
    vm.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    };

    vm.beneficiary = angular.copy(beneficiary) || {};
    vm.companies = companies;

    if (!vm.beneficiary.contact_info) {
      vm.beneficiary.contact_info = {
        details: [
          {caption: "Телефон", type: "PHONE"},
          {caption: "Дополнительный телефон", type: "PHONE"},
          {caption: "E-mail", type: "EMAIL"},
        ]
      }
    }

    vm.returnToPage = function () {
      var prev = cardHistory.popStep('id', $stateParams.id) || {name: 'beneficiaries'};
      $state.go(prev.name !== '' ? prev.name : 'beneficiaries', prev.param || {parent: 'business'});
    };

    vm.resetData = function () {
      vm.beneficiaryForm.$setPristine();
      vm.returnToPage();
    };

    vm.save = function() {
      if (vm.beneficiary.id) {
        return beneficiaryService.updateBeneficiary(vm.beneficiary.id, vm.beneficiary)
          .then(onRequestSuccess, onSaveError)
      } else {
        return beneficiaryService.createBeneficiary(vm.beneficiary)
          .then(onRequestSuccess, onSaveError)
      }
    };


    function onRequestSuccess(res) {
      vm.returnToPage();
    }

    function onSaveError(err) {
      if (err.status === 409) {
        if (err.data.code === 'duplicate_unique_entity_key') {
          vm.beneficiaryForm.person.$setValidity('unique', false);
          vm.setDirty();
        } else if (err.data.code === 'solo_trader_already_has_beneficiary') {
          errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {
            data: {
              message: "Копания с типом ИП может иметь не более одного бенефициара"
            }
          }});
        }
      }
    }

    function getFio() {
      if (!vm.beneficiary.person) {
        return '';
      }
      return vm.beneficiary.person.surname + ' ' + vm.beneficiary.person.name + ' ' + vm.beneficiary.person.patronymic
    }


    vm.delete = function() {
      return askDeleteSrv.showAskDelete(
        getFio(),
        "бенефициара",
        "",
        vm.beneficiary.id,
        beneficiaryService.deleteBeneficiary
      ).then(onRequestSuccess);
    };

    vm.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        vm.isSetDirty = true;
        return true;
      }
      return false;
    }

    vm.setDirty = function () {
      vm.isSetDirty = true;
      utilsService.setDirty(vm.beneficiaryForm);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    vm.crud = function (status) {
      switch (status) {
        case 'save':
          if (vm.beneficiaryForm.$valid) {
            return vm.save();
          } else {
            return vm.setDirty();
          }
        case 'delete':
          return vm.delete();
        case 'return':
          vm.returnToPage();
          return $q.when();
        case 'edit':
          $state.go('beneficiary.edit', {id: vm.beneficiary.id, parent: 'business'}, {reload: true});
          return $q.when();
        default :
          return $q.when();
      }
    };


  });

angular.module('frontend')
  .filter('bankProductRequestStatus', function () {
    return function (status) {
      if (status) {
        var upper = status.toUpperCase();
        return upper === 'APPROVED' ? 'Одобрена' :
          upper === 'DENIED' ? "Отказ" :
            upper === 'NEW' ? "Новая/Черновик" :
              upper === 'PENDING' ? 'На рассмотрении' :
                upper === "CANCELLED" ? "Отменена" :
                  upper === "EXPIRED" ? "Просрочена" :
                    status;
      }
      return status;
    }
  })
  .filter('bankProductRequestStatusHelpersMessage', function () {
    return function (status) {
      if (status) {
        var upper = status.toUpperCase();
        return upper === 'APPROVED' ? 'По вашей заявке было принято положительное решение. В ближайшее время с Вами свяжется представитель Банка и расскажет подробности.' :
          upper === 'DENIED' ? "К сожалению, по вашей заявке было принято отрицательно решение. Попробуйте подать заявку позже." :
            upper === 'NEW' ? "Пожалуйста, дозаполните вашу заявку для отправки ее в банк." :
              upper === 'PENDING' ? 'Ваша заявка отправлена в банк. Ожидайте ответ в течении 1 рабочего дня с момента подачи.' :
                upper === "CANCELLED" ? "Отменена" :
                  upper === "EXPIRED" ? "К сожалению, срок действия предложения закончился, получить кредит на данный момент невозможно." :
                    status;
      }
      return status;
    }
  })
  .controller('bankProductRequestsCtrl', function ($scope,
                                                   userSettingsService,
                                                   $state,
                                                   helpService,
                                                   bankProductRequestService,
                                                   uiGridConstants,
                                                   filterFactoryService,
                                                   companies,
                                                   bankProducts,
                                                   $filter) {
    var vm = this;
    vm.prepareSavedFiltersList = function () {
      vm.savedFilterListSearchText = ""
    };

    vm.cleanObj = function (obj) {
      var tempObj = angular.copy(obj);
      for (var prop in tempObj) {
        if (!tempObj[prop]) delete obj[prop];
      }
      return obj;
    };

    vm.configScrollFilter = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      setHeight: 186,
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      scrollInertia: 0
    };

    vm.subjectTypesPopup = vm.subjectTypes;

    vm.gridFilter = filterFactoryService.createFilter("bank-product-request", "grid");

    vm.updateColumnFilter = function (colDef, col) {
      if (vm.filter[colDef.filterName || colDef.name] && vm.filter[colDef.filterName || colDef.name].complex) {
        col.filters[0].dateRange = vm.filter[colDef.filterName || colDef.name].dateRange;
        col.filters[0].term = vm.filter[colDef.filterName || colDef.name].datePickStr
      } else {
        col.filters[0].term = vm.filter[colDef.filterName || colDef.name]
      }
    };

    vm.initFilter = function () {
      vm.filter = vm.gridFilter.loadFilter() || {};
      vm.gridApi && vm.gridApi.grid.columns.filter(function (column) {
        return column.enableFiltering;
      }).forEach(function (col) {
        vm.updateColumnFilter(col.colDef, col)
      });
      vm.gridFilter.storeFilter(vm.filter)
    };

    vm.prepareSavedFiltersList = function () {
      vm.savedFilterListSearchText = "";
    };

    vm.saveFilter = function (name) {
      vm.gridFilter.saveFilter(name, vm.filter);
      vm.filterSaved = true;
      vm.filterDeepCopy = angular.copy(vm.filter);
      vm.savedFilterName = name;
    };

    vm.chooseFilter = function (filterName) {
      vm.gridFilter.storeFilter(vm.gridFilter.loadSavedFilter(filterName));
      vm.initFilter();
      vm.filterDeepCopy = angular.copy(vm.filter);
      if (vm.filter) {
        vm.filterSaved = true;
        vm.savedFilterName = filterName
      }
      vm.showFilter = true;
    };

    vm.removeFilter = function (filterName, $event) {
      $event.stopPropagation();
      vm.gridFilter.removeFilter(filterName);
      if (filterName === vm.savedFilterName) {
        vm.filterSaved = false
      }
      if (vm.gridFilter.getSavedFiltersNames().length < 6) {
        vm.savedFilterListSearchText = ""
      }
    };

    vm.updateFilter = function (filter) {
      vm.filterSaved = vm.filterSaved && _.isEqual(vm.cleanObj(vm.filterDeepCopy), vm.cleanObj(filter));
      vm.gridFilter.storeFilter(filter);
      if (!vm.filterSaved) vm.savedFilterName = '';
      vm.gridFilter.storeFilter(filter);
      vm.initFilter();
      if (_.isEmpty(filter)) {
        vm.filterSaved = false;
        vm.savedFilterName = '';
      }
    };

    vm.applyFilter = function () {
      vm.updateFilter(vm.popupFilter);
      vm.getPage()
    };

    vm.cleanFilter = function () {
      vm.updateFilter(undefined);
      vm.getPage()
    };

    vm.initPaging = function () {
      vm.paging = userSettingsService.loadProperty("bank-product-request", "grid", "paging") || {
        current: 0,
        limit: 5,
        offset: 0,
        sortBy: 'updated_at',
        total: undefined
      };

      /**
       * Свойство добавлено из-за того, что количество сущностей в момент
       * сохранения может быть больше, чем при повторном обращении,
       * сохранять смещение - опасно. Кроме того, в разработке задача,
       * которая позволит после сохранения или редактирования сущности запрашивать
       * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
       * где сохранение смещение могло бы быть полезным.
       */
      vm.paging.offset = 0;
      vm.paging.current = 0;
    };

    vm.init = function () {
      vm.initFilter();
      vm.initPaging();
      vm.showFilter = userSettingsService.loadProperty("bank-product-request", "grid", "showFilter") || false;
    };

    vm.turnShowFilter = function () {
      vm.showFilter = !vm.showFilter;
      userSettingsService.saveProperty("bank-product-request", "grid", "showFilter", vm.showFilter);
      if (!vm.showFilter) {
        vm.cleanFilter();
      }
    };

    vm.init();

    vm.showFilterPopup = function () {
      vm.popupFilter = $.extend(true, {}, vm.filter);
    };

    vm.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      setHeight: 400,
      scrollInertia: 0
    };

    vm.goToView = function (id) {
      $state.go('bankProductRequest', { id: id, parent: 'money' });
    };

    $scope.columnVisibilityChanged = function () {
      var columnsProperty = vm.gridApi.grid.options.columnDefs;
      angular.forEach(columnsProperty, function (column) {
        if (column.filter) delete column.filter.selectOptions;
      });
      userSettingsService.saveProperty("bank-product-request", "grid", "columnsProperty", columnsProperty)
    };

    var statuses = ['APPROVED', 'DENIED', 'NEW', 'PENDING', 'CANCELLED', 'EXPIRED'];

    $scope.defaultColumns = [
      {
        name: 'selection',
        field: 'option',
        displayName: '',
        enableColumnMenu: false,
        enableHiding: false,
        enableFiltering: false,
        width: 64
      },
      {
        name: 'created_at',
        displayName: 'Дата создания',
        cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : \'UTC\'"/>',
        enableFiltering: false,
        enableSorting: false,
        visible: true
      },
      {
        name: 'bank_product.partner_bank.name',
        displayName: 'Банк',
        visible: true,
        enableSorting: false,
        enableFiltering: false
      },
      {
        name: 'bank_product.name', displayName: 'Продукт', visible: true, enableSorting: false, enableFiltering: true,
        filterName: 'bank_product_id', filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: bankProducts
        },
      },
      {
        name: 'company.name',
        displayName: 'Компания',
        visible: true,
        enableFiltering: true,
        enableSorting: false,
        filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
        filterName: 'company_id',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: companies
        },
      },
      {
        name: 'status',
        displayName: 'Статус',
        visible: true,
        enableSorting: false,
        enableFiltering: true,
        filterName: 'status',
        cellTemplate: '<cell-with-tooltip text="COL_FIELD | bankProductRequestStatus" tooltip-text="COL_FIELD | bankProductRequestStatusHelpersMessage"/>',
        filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: statuses.map(function (status) {
            return {
              label: $filter('bankProductRequestStatus')(status),
              value: status
            }
          })
        },
      },
      {
        name: 'updated_at',
        displayName: 'Дата обновления',
        visible: false,
        enableFiltering: false,
        cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : \'UTC\'"/>'
      },
      {
        name: 'marginRight',
        field: 'option',
        displayName: '',
        enableColumnMenu: false,
        enableHiding: false,
        enableFiltering: false,
        width: 63
      }
    ];

    var columnsProperty = userSettingsService.loadProperty("bank-product-request", "grid", "columnsProperty");

    vm.gridOptions = {
      enableSorting: false,
      useExternalSorting: true,
      useExternalFiltering: true,
      virtualizationThreshold: vm.paging.limit,
      enableGridMenu: true,
      enableFiltering: true,
      showColumnFooter: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      rowTemplate: '<div ng-click="grid.appScope.vm.goToView(row.entity.id);">' +
        ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
        '</div>',
      columnDefs: columnsProperty || angular.copy($scope.defaultColumns)
    };
    var columnsVisibility = userSettingsService.loadProperty("bank-product-request", "grid", "columnsVisibility") || {};
    vm.gridOptions.columnDefs.forEach(function (colDef) {
      if (columnsVisibility[colDef.name] === false) {
        colDef.visible = false
      } else if (columnsVisibility[colDef.name]) {
        colDef.visible = true
      }
    });

    vm.gridOptions.onRegisterApi = function (gridApi) {
      vm.gridApi = gridApi;
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns.length === 0) {
          vm.paging.sortBy = null;
          vm.paging.sortDirection = null;
        } else {
          vm.paging.sortBy = sortColumns[0].colDef.sortName;
          vm.paging.sortDirection = sortColumns[0].sort.direction;
        }
        vm.getPage();
      });
      gridApi.core.on.filterChanged($scope, function () {
        gridApi.grid.columns.filter(function (column) {
          return column.enableFiltering && column.visible !== false;
        }).forEach(function (column) {
          var filter = vm.filter[column.colDef.filterName || column.name];
          if (filter && filter.complex) {
            if (column.filters[0].term) filter.datePickStr = column.filters[0].term;
            filter.dateRange = column.filters[0].dateRange
          } else {
            vm.filter[column.colDef.filterName || column.name] = column.filters[0].term
          }
        });
        vm.paging.offset = 0;
        vm.updateFilter(vm.filter);
        vm.getPage();
      });
      gridApi.grid.registerColumnBuilder(vm.updateColumnFilter)
    }.bind(this);

    // Поиск
    vm.search = function () {
      // Сброс текущей страницы и поиск
      vm.paging.current = 0;
      vm.paging.offset = 0;
      vm.getPage();
    };

    vm.showSaveFilterPopup = helpService.getOpenFilterFunction(vm.gridFilter, vm.saveFilter);


    vm.crudState = helpService.getCrudStateStructure();


    // Функция обновления страницы, вызываетсяperson. при изменениях фильтров и пейджинге
    vm.getPage = function () {
      vm.noData = false;
      vm.loadData = false;
      vm.gridOptions.virtualizationThreshold = vm.paging.limit;
      vm.crudState.startLoading();
      userSettingsService.saveProperty("bank-product-request", "grid", "paging", vm.paging); // Настройки paging сохраняются при оюбом обновлении страницы (фильтры и остальное, в своих обработчиках)
      bankProductRequestService.getBankProductRequestList(vm.filter, vm.paging, vm.searchText).then(
        function (data) {
          if (!data.data.items.length && !vm.searchText && _.isEmpty(vm.filter)) {
            vm.noData = true;
          }
          vm.bankProductRequests = data.data.items;
          vm.paging.total = data.data.total;
          vm.paging.current = data.data.offset / vm.paging.limit;

          vm.loadData = true;
          // Ссылка в grid
          vm.gridOptions.data = data.data.items;

          vm.crudState.stopLoadingSuccess();
        },
        function (error) {
          vm.bankProductRequests = [];
          vm.crudState.stopLoadingFailure(error);
        }
      )
    };
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    vm.getPage();
  });



angular
  .module('frontend')
  .component('consentComponent', {
    replace: true,
    bindings: {
      consentData: '<',
      bankProductRequestId: '<',
      onUpdate: '&'
    },
    bindToController: true,
    templateUrl: 'app/settings/bank-product-request/components/consent.html',
    controllerAs: 'ctrl',
    controller: function ($scope,
                          helpService,
                          print,
                          statusSrv,
                          $timeout,
                          downloadSrv,
                          FileUploader,
                          authToken,
                          MAX_UPLOAD_FILE_SIZE,
                          bankProductRequestService,
                          API_URL) {
      var ctrl = this;
      // выбор режима работы в зависимости от того привязан ли скан к согласи/
      ctrl.consentMode = ctrl.consentData.link ? 'upload' : '';

      // конфиг аплоадера
      ctrl.uploader = new FileUploader({
        url: API_URL + '/bank_product_requests/' + ctrl.bankProductRequestId + '/consents/' + ctrl.consentData.id + '/upload',
        headers: {'X-Session-Id': authToken.getToken()},
        queueLimit: 1,
        onAfterAddingFile : function(){
          var file = ctrl.uploader.queue[0].file;

          ctrl.fileError = '';
          if(file.type !== 'application/pdf'){  // ошибка неверный формат файла
            ctrl.uploader.queue[0].isError = true;
            ctrl.fileError = 'format';
            return;
          }
          if(file.size > MAX_UPLOAD_FILE_SIZE){ // ошибка файл больше чем 5 МБ
            ctrl.uploader.queue[0].isError = true;
            ctrl.fileError = 'size';
            return;
          }
          ctrl.uploader.queue[0].url = API_URL + '/bank_product_requests/' + ctrl.bankProductRequestId + '/consents/' + ctrl.consentData.id + '/upload';
          ctrl.uploader.queue[0].upload();
        },
        onBeforeUploadItem: function(item) {
          item.formData.push({
            name: item.file.name
          })
        },
        onWhenAddingFileFailed: function(item, filter, options){
          ctrl.uploader.clearQueue();
          ctrl.uploader.addToQueue([item]);
        },
        onSuccessItem: function(item, response, status){
          ctrl.consentData = response;
          ctrl.onUpdate({consent: ctrl.consentData});
        }
      });

      // конфиг долгого опроса
      ctrl.longRequest = {
        format: null,
        exec_id: null,
        crudState: helpService.getCrudStateStructure(),
        flags: {
          processStart: false,
          finish: false
        },
        stopAskingError: function(){
          ctrl.longRequest.flags.processStart = false;
          ctrl.longRequest.flags.finish = true;
          ctrl.longRequest.flags.error = true;
          ctrl.longRequest.crudState.stopLoadingFailure();
          print.turnoffInterceptorStatus();
        },
        onError: function(err) {
          if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
            ctrl.longRequest.revert();
          } else {
            ctrl.longRequest.stopAskingError();
          }
        },
        revert: function() {
          ctrl.longRequest.format = null;
          ctrl.longRequest.cancelled = false;
          ctrl.longRequest.exec_id = null;
          ctrl.longRequest.crudState.stopLoadingSuccess();
          ctrl.longRequest.flags.processStart = false;
          ctrl.longRequest.flags.finish = false;
        }
      };

      // подготовка отчета ( печать согласия )
      ctrl.prepareReport = function() {
        ctrl.longRequest.crudState.startLoading();
        print.consentReport({
          id: ctrl.consentData.id,
          output_name: 'Согласие ' + ctrl.consentData.output_name,
          type: ctrl.consentData.type
        }).then(function (res) {
          ctrl.longRequest.exec_id = res.data.exec_id;
          statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
            ctrl.longRequest.flags.finish = true;
            print.turnoffInterceptorStatus();
            $timeout(function () {
              downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function () {
                ctrl.longRequest.crudState.stopLoadingSuccess();
                ctrl.consentMode = 'upload';
              });
            });
          }, ctrl.longRequest.onError);
        }).catch(ctrl.longRequest.onError);
      };

      // отвязка сущьности от согласия
      ctrl.unlink = function () {
        bankProductRequestService.unlink(ctrl.bankProductRequestId, ctrl.consentData.id)
          .then(function (res) {
            ctrl.consentData = res.data;
            ctrl.consentMode = '';
            ctrl.uploader.clearQueue();
            ctrl.onUpdate({consent: ctrl.consentData});
          })
      };

    }
  });

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('visibilitySettings', visibilitySettings);

  /**
   * Директива для отображения календаря действия акции
   */
  function visibilitySettings() {
    return {
      restrict: 'E',
      templateUrl: 'app/price-list/directives/visibility-settings/visibility-settings.html',
      scope: {
        column: '=',
        formCtrl: '='
      },
      controller: visibilitySettingsController,
      controllerAs: 'vm'
    }

    function visibilitySettingsController($scope, companyService, contragentService) {
      var vm = this;
      vm.divisionsData = [];
      /* Все подразделения */
      companyService.divisions({limit: 100}).then(function(res){
        vm.divisionsData = res.data.items;
        if($scope.column.divisions && $scope.column.divisions.length){
          var tempDivisions = [];
          angular.forEach(vm.divisionsData, function(divAllinfo){
            angular.forEach($scope.column.divisions, function(division){
              if(divAllinfo.id == division.id){
                tempDivisions.push(divAllinfo);
              }
            });
          });
          $scope.column.divisions = tempDivisions;
        }
      });
      /* Все контрагенты */
      contragentService.counterparties({limit: 100}).then(function(data){
        vm.contragentsAll = [];
        angular.forEach(data.data.items, function(contragent){
          vm.contragentsAll.push({
            id: contragent.id,
            name: contragent.name
          });
        });
      });
    }
  }
}) ();
(function() {
  'use strict';

  angular
    .module('frontend')
    .component('printPriceList', {
      templateUrl: 'app/price-list/directives/print-price-list/print-price-list-popup.html',
      bindings: {
        modalInstance: "<",
        resolve: "<"
      },
      controller: function(companyService,
                           API_URL,
                           print,
                           uiSelectStructure,
                           currenciesService,
                           $timeout,
                           helpService,
                           authToken,
                           statusSrv,
                           $rootScope,
                           downloadSrv) {
        print.turnonInterceptorStatus();
        var ctrl = this;
        ctrl.columns = ctrl.resolve.columns;
        ctrl.retailMode = ctrl.resolve.mode === 'RETAIL';
        ctrl.currencies = uiSelectStructure.getStructure(currenciesService.getDomainCurrenciesSearch);
        currenciesService.getDomainCurrencies().then(function(res) {
          angular.forEach(res.data.items, function(item) {
            if (item.home_currency) {
              ctrl.homeCurrency = {
                id: item.currency.id,
                name: item.currency.name,
                char_iso_code: item.currency.char_iso_code,
                symbol: item.currency.symbol
              };
            }
          });
        });
        // настройка скролла
        ctrl.configScroll = {
          axis:'y',
          autoHideScrollbar: false,
          theme: 'dark',
          advanced:{
            updateOnContentResize: true
          },
          setHeight: 300,
          scrollInertia: 0
        };

        ctrl.printData = {
          format: 'PDF',
          page_orientation: 'LANDSCAPE',
          other_inform: "NOMENCLATURE_CODE",
          price_print: 'ONE',
          effective_date: moment.utc().startOf('day')
        };

        ctrl.longRequest = {
          format: null,
          exec_id: null,
          crudState: helpService.getCrudStateStructure(),
          flags: {
            processStart: false,
            finish: false
          },
          stopAskingError: function(){
            ctrl.longRequest.flags.processStart = false;
            ctrl.longRequest.flags.finish = true;
            ctrl.longRequest.flags.error = true;
            ctrl.longRequest.crudState.stopLoadingFailure();
            print.turnoffInterceptorStatus();
          },
          onError: function(err) {
            if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
              ctrl.longRequest.revert();
            } else {
              ctrl.longRequest.stopAskingError();
            }
          },
          revert: function() {
            ctrl.longRequest.format = null;
            ctrl.longRequest.cancelled = false;
            ctrl.longRequest.exec_id = null;
            ctrl.longRequest.crudState.stopLoadingSuccess();
            ctrl.longRequest.flags.processStart = false;
            ctrl.longRequest.flags.finish = false;
          }
        };

        companyService.divisions({limit: 200}).then(function(res){
          ctrl.divisions = $rootScope.availableDivisions(res.data.items);
          ctrl.divisionsTotal = res.data.total;
          if (res.data.total === 1) {
            ctrl.printData.division = ctrl.divisions[0];
          }
        });

        ctrl.close = function () {
          ctrl.modalInstance.dismiss();
        };

        ctrl.print = function () {
          ctrl.longRequest.crudState.startLoading();
          print.printPriceList({
            division_id: ctrl.printData.division ? ctrl.printData.division.id : null,
            currency_id: ctrl.currencies.value ? ctrl.currencies.value.id : ctrl.homeCurrency.id,
            effective_date: ctrl.printData.effective_date.valueOf() ,
            page_orientation: ctrl.printData.page_orientation,
            show_code: ctrl.printData.is_other_inform ? ctrl.printData.other_inform : 'NONE',
            grouping: !!ctrl.printData.grouping,
            column_type: ctrl.resolve.mode
          }, ctrl.printData.format).then(function(res) {
            ctrl.longRequest.exec_id = res.data.exec_id;
            if (ctrl.printData.format) {
              ctrl.longRequest.format = ctrl.printData.format;
            }
            statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
              ctrl.longRequest.flags.finish = true;
              print.turnoffInterceptorStatus();
              $timeout(function() {
                downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
                  ctrl.longRequest.crudState.stopLoadingSuccess();
                  $timeout(function() {
                    ctrl.modalInstance.dismiss();
                  }, 300, false)
                });
              });
            },ctrl.longRequest.onError);
          }).catch(ctrl.longRequest.onError);

        };

        ctrl.next = function() {
          ctrl.showColumns = true;
        };

        ctrl.selectColumn = function(isSelect){
          var selectAll = true;
          angular.forEach(ctrl.columns, function(column){
            if(!column.selected){
              selectAll = false;
            }
          });
          ctrl.printData.$$selectAll = selectAll;
        };

        ctrl.changeAll = function(){
          angular.forEach(ctrl.columns, function(column){
            column.selected = ctrl.printData.$$selectAll;
          });
        };


        ctrl.divisionSelected = function(division) {
          var currencies = [];
          if (division && division.cash_registers && division.cash_registers.length) {
            angular.forEach(division.cash_registers, function(cash_register) {
              if (cash_register.currency && currencies.indexOf(cash_register.currency.id) < 0) {
                currencies.push(cash_register.currency.id)
              }
            });
            ctrl.showCurrencySelect = currencies.length > 1;
          } else {
            ctrl.showCurrencySelect = false;
          }
        };
      }
    });

}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('priceFormula', priceFormula);

  /**
   * Директива для отображения календаря действия акции
   */
  function priceFormula() {
    return {
      restrict: 'E',
      templateUrl: 'app/price-list/directives/price-formula/formula.html',
      scope: {
        column: '=',
        formCtrl: '='
      },
      controller: priceFormulaController,
      controllerAs: 'vm'
    }

    function priceFormulaController($scope, $timeout, currenciesService) {
      var vm = this;
      vm.roundingFactors = [];
      // хэлпер для психологического округления и выставления необходимых данных
      vm.factorsHelper = [{
        position: 100000,
        last_digit: "...",
        psych_digit: ''
      },
      {
        position: 10000,
        last_digit: "X",
        psych_digit: ''
      },
      {
        position: 1000,
        last_digit: "X",
        psych_digit: ''
      },
      {
        position: 100,
        last_digit: "X",
        psych_digit: ''
      },
      {
        position: 100,
        last_digit: ",",
        psych_digit: ''
      },
      {
        position: 10,
        last_digit: "X",
        psych_digit: ''
      },
      {
        position: 1,
        last_digit: "X",
        psych_digit: ''
      }];

      vm.init = function(){
        angular.forEach($scope.column.rounding_details, function(rounding, key){
          rounding.$$factorsHelper = angular.copy(vm.factorsHelper);
          if(key){
            // Значение "До" высчитывается автоматически
            $scope.column.rounding_details[key-1].$$to = rounding.starting_price_for_rounding - 1;
          }
          if(rounding.psychological_rounding){
            rounding.$$usePsychRounding = true;
            angular.forEach(rounding.$$factorsHelper, function(item){
              if (item.position > rounding.psychological_rounding.position) {
                item.psych_digit = 'X';
              } else if (item.position == rounding.psychological_rounding.position) {
                item.psych_digit = rounding.psychological_rounding.last_digit;

              } else {
                item.psych_digit = '0';
              }
            });
          }
        });
      }

      // выбор числа психологического округление
      vm.changeLastDigit = function(int, index, interval){
        angular.forEach(interval.$$factorsHelper, function(item, key){
          if(key < index){
            item.psych_digit = 'X';
          }
          if(key == index){
            item.psych_digit = int;
            interval.psychological_rounding.last_digit = int;
            interval.psychological_rounding.position = item.position;
          }
          if(key > index){
            item.psych_digit = '0';
          }
        });
        vm.updateRounding();
      }
      // проставить ДО и проверить валидность
      vm.changeTo = function(){
        var prev;
        angular.forEach($scope.column.rounding_details, function(interval, key){
          delete $scope.formCtrl.$error.intervalError;
          if(!key){
            prev = interval;
          }else{
            if(interval.starting_price_for_rounding <= prev.starting_price_for_rounding){
              interval.$$error = true;
              $scope.formCtrl.$error.intervalError = true;
            }else{
              interval.$$error = false;
              prev.$$to = interval.starting_price_for_rounding - 1;
            }
            prev = interval;
          }
        });
      }

      /* добавление нового интервала */
      vm.addNewInterval = function() {
        var lastItem = $scope.column.rounding_details[$scope.column.rounding_details.length-1];
        if (!$scope.column.rounding_details) {
          $scope.column.rounding_details = [];
        }

        // установить значение в "До"
        if(lastItem){
          //lastItem.rounding_factor = 10;
          lastItem.$$to = (Math.pow(10, $scope.column.rounding_details.length) * 100) - 1;
          if(lastItem.rounding_factor >=  Math.pow(10, $scope.column.rounding_details.length) * 100){
            lastItem.rounding_factor = 10;
          }
        }

        $scope.column.rounding_details.push({
          starting_price_for_rounding: Math.pow(10, $scope.column.rounding_details.length) * 100,
          rounding_method: (lastItem)? lastItem.rounding_method : 'UP',
          rounding_factor: (lastItem)? lastItem.rounding_factor : 10,
          $$usePsychRounding: (lastItem)? lastItem.$$usePsychRounding : false,
          psychological_rounding: (lastItem)? lastItem.psychological_rounding : null,
          $$factorsHelper: angular.copy(vm.factorsHelper)
        });
        if($scope.column.rounding_details.length > 1){
          $timeout(function(){
            vm.updateRounding();
            vm.reCalcScroll();
            vm.selectTab($scope.column.rounding_details.length - 1);
          },100);
        }

      }

      vm.removeInterval = function(index, event){
        event.preventDefault();
        $scope.column.rounding_details.splice(index, 1);
        $scope.column.rounding_details[$scope.column.rounding_details.length-1].$$to = 0;
        vm.changeTo();
        vm.reCalcScroll();
        //$scope.column.rounding_details[$scope.column.rounding_details.length-1].rounding_factor = 10;
      }

      // установка психологического округление по умолчанию
      vm.resetPsychRounding = function(interval){
        vm.updateRounding();
        if(interval.rounding_factor == 1){
          interval.$$usePsychRounding = false;
          vm.turnPsychRounding(interval);
        }
        if(interval.$$usePsychRounding){
          angular.forEach(interval.$$factorsHelper, function(item, key){
            var tempfactor = interval.rounding_factor/10;
            if(item.position > tempfactor){
              item.psych_digit = "X";
            }
            if(item.position == tempfactor){
              item.psych_digit = 9;
              interval.psychological_rounding.last_digit = 9;
              interval.psychological_rounding.position = item.position;
            }
            if(item.position < tempfactor){
              item.psych_digit = 0;
            }
          });
        }
      }

      // применить психологисеское округление
      vm.turnPsychRounding = function(interval){
        vm.updateRounding();
        if(interval.$$usePsychRounding){
          interval.psychological_rounding = {};
          interval.psychological_rounding.last_digit = 9;
          vm.resetPsychRounding(interval);
        }
      }
      // изменить опции в выпадающем списке "округляем до" при клике на бегунок
      vm.changeFactor = function(side, interval){
        var oldFactor = interval.rounding_factor;
        if(side == 'right'){
          interval.rounding_factor = interval.rounding_factor / 10;
          // установка психологического округления при смещении бегунка вправо
          if(interval.$$usePsychRounding && interval.rounding_factor <= interval.psychological_rounding.position){
            _.find(interval.$$factorsHelper, function(item){
              if(item.position == interval.rounding_factor)
                item.psych_digit = "X";
              return item.position == interval.rounding_factor;
            });
            interval.psychological_rounding.last_digit = 0;
            interval.psychological_rounding.position = interval.rounding_factor;
          }
        }else{
          interval.rounding_factor = interval.rounding_factor * 10;
        }
        if(interval.$$to != 0 && interval.rounding_factor > interval.$$to){
          interval.rounding_factor = oldFactor;
        }
        if(interval.rounding_factor < 1) interval.rounding_factor = 1;
        if(interval.rounding_factor > 100000) interval.rounding_factor = 100000;
        vm.updateRounding();
      }
      // подстановка значений в список "округляем до" при изменении валюты
      vm.getRoundingFactors = function(id){
        vm.roundingFactors = [];
        currenciesService.getCurrency(id).then(function(res){
          vm.roundingFactors.push({
            count: 1,
            name: res.data.fractional.for_five
          });
          vm.roundingFactors.push({
            count: 10,
            name: "десятков " + res.data.fractional.for_five
          });
          vm.roundingFactors.push({
            count: 100,
            name: res.data.integer.for_five
          });
          vm.roundingFactors.push({
            count: 1000,
            name: "десятков " + res.data.integer.for_five
          });
          vm.roundingFactors.push({
            count: 10000,
            name: "сотен " + res.data.integer.for_five
          });
          vm.roundingFactors.push({
            count: 100000,
            name: "тысячи " + res.data.integer.for_five
          });
        });
        angular.forEach($scope.column.rounding_details, function(rounding){
          var tempFactor = rounding.rounding_factor;
          rounding.rounding_factor = '';
          $timeout(function(){rounding.rounding_factor = tempFactor;}, 0);
        });
      }

      $scope.$watch('column.currency', function(newVal, oldVal) {
        if(newVal && newVal.id) vm.getRoundingFactors(newVal.id);
      });

      /* Расчеты для примера */
      vm.updateRounding = function(){
        $timeout(function(){
          var objForExample = $scope.column.rounding_details[vm.activeInterval];
          var min = (parseFloat(objForExample.starting_price_for_rounding) || 1) / 100;
          var max = parseFloat(objForExample.$$to / 100) || Math.pow(min + 3, 2);
          vm.example = (Math.random() * (max - min) + min).toFixed(4);
          vm.examplePsychRes = 0;
          var temp = (vm.example * 100) / objForExample.rounding_factor;
          if(objForExample.rounding_method == 'DOWN'){
            temp = Math.round(Math.floor(temp));
          }else if(objForExample.rounding_method == 'UP'){
            temp = Math.round(Math.ceil(temp));
          }else{
            temp = Math.round(temp);
          }
          vm.exampleRes = ((temp * objForExample.rounding_factor) / 100).toFixed(2);

          if(objForExample.$$usePsychRounding){
            // vm.exampleRes = Цена после использования правил в копейках
            // objForExample.rounding_factor = Точность округления
            // objForExample.psychological_rounding.last_digit = Цифра психологического округления
            // objForExample.psychological_rounding.position = Разряд
            vm.examplePsychRes = (((vm.exampleRes * 100) - (objForExample.rounding_factor - objForExample.psychological_rounding.last_digit * objForExample.psychological_rounding.position))/100).toFixed(2);
          }
        }, 0);
      }
      if($scope.column.rounding_details[vm.activeInterval]){
        vm.updateRounding();
      }

      vm.init();
      if(!$scope.column.rounding_details.length){
        vm.addNewInterval();
        vm.updateRounding();
      }

      $scope.$watch('vm.activeInterval', function(newVal, oldVal) {
        vm.updateRounding();
      });

      vm.scrlTabsApi = {};

      vm.reCalcScroll = function() {
        if(vm.scrlTabsApi.doRecalculate) {
          vm.scrlTabsApi.doRecalculate();
        }else{
          vm.scrlTabsApi = {};
        }
      };

      vm.scrollIntoView = function(arg) {
        if(vm.scrlTabsApi.scrollTabIntoView) {
          vm.scrlTabsApi.scrollTabIntoView(arg);
        }
      };

      vm.activeInterval = vm.activeInterval || 0;
      
      vm.selectTab = function(index) {
        vm.activeInterval = index;
        vm.scrollIntoView();
      };
      setTimeout(function() {vm.reCalcScroll()}, 2000);
    }
  }
}) ();

/**
 * Created by aivanov on 15.11.2017.
 */
(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('priceCellMultiple', priceCellMultiple);

  /**
   * Директива для отображения и редактирование данных о цене
   *
   * @return {{restrict: string, templateUrl: string, scope: {price: string, currency: string}, controller: priceCellController, controllerAs: string, bindToController: boolean}}
   */
  function priceCellMultiple($timeout) {
    var pMCell = {
      restrict: 'EA',
      templateUrl: 'app/price-list/directives/price-cell-multiple/price-cell-multiple.html',
      scope: {
        // массив с ценами
        prices: '=',
        // информация о колонке
        column: '<',
        // информация об упаковке
        uom: '<?',
        // Колбек для коммита значений
        commitValue: '<?',
        // для открытия попапа редактирования цен
        openPositionPrices: '<?',
        // для передачи узла дерева
        node: '<?',
        // для добавления товара в корзину
        addToCart: '<?'
      },
      controller: priceCellMultipleController,
      controllerAs: 'priceCellMultipleCtrl',
      bindToController: true
    };
    return pMCell;

    function priceCellMultipleController($scope, $state, $document, helpService, priceListSrv, $filter) {
      var priceCellMultipleCtrl = this;
      var today = helpService.userNow();
      // нужен для дизэйбла кнопки удаления, если дата цены в прошлом
      priceCellMultipleCtrl.today = today.valueOf();
      // текущая цена
      priceCellMultipleCtrl.current = 0;
      // режим ячеек (пока по кейсам режим един для всех и его можно определить в внешней директиве)
      priceCellMultipleCtrl.selected = false;

      // сортировка цен по дате и по количеству
      priceCellMultipleCtrl.sortPrices = function () {
        if (!priceCellMultipleCtrl.prices) return;
        priceCellMultipleCtrl.prices = priceCellMultipleCtrl.prices.sort(function (a, b) {
          var aDate = moment(a.effective_date).valueOf();
          var bDate = moment(b.effective_date).valueOf();

          if (aDate == bDate || (!aDate && !bDate)) {
            return a.effective_qty - b.effective_qty;
          } else {
            return (aDate < bDate) ? -1 : (aDate > bDate) ? 1 : 0;
          }
        });
        if (priceCellMultipleCtrl.column.column_type == "PURCHASE") {
          priceCellMultipleCtrl.current = 0;
        }
      };

      // открыть попап редактирования цен, с учетом показа необходимой колонки
      priceCellMultipleCtrl.openAllPrices = function () {
        priceCellMultipleCtrl.selected = false;
        var modal = priceCellMultipleCtrl.openPositionPrices(priceCellMultipleCtrl.node, priceCellMultipleCtrl.column.id, true);
        modal.result.then(function (result) {
          if (result.mode == 'minimizer') {
            priceCellMultipleCtrl.selected = true;
          }
        });
      };

      function _getValueOf(date) {
        return moment(date).valueOf();
      }

      // сначала сортировка
      priceCellMultipleCtrl.sortPrices();
      // потом пробежаться по ценам и в текущую выставить ближайшую дату к сегодняшней с наименьшим количеством effective_qty
      var closestDate;
      _.forEach(priceCellMultipleCtrl.prices, function (price, key) {
        var today = helpService.userNow();
        var effective_date = moment(price.effective_date).valueOf(); // всегда в UTC

        // установить флаг рассчета по формуле, чтобы отображать курсивом
        if(price && price.price_for_one_uom == undefined && price.calculated_automatically_price_for_one_uom != undefined){
          price.$$withFormula = true;
        }

        if (!closestDate) {
          closestDate = effective_date;
        }
        //в текущую выставить ближайшую дату к сегодняшней
        if ((effective_date == today) ||
            (today > effective_date && effective_date > closestDate) ||
            (today < effective_date && priceCellMultipleCtrl.current == undefined)) {
          // с наименьшим количеством effective_qty
          if (_getValueOf(priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current].effective_date) !== _getValueOf(price.effective_date)) {
            priceCellMultipleCtrl.current = key;
          }
        }
      });


      /**
       * Вспомогательный метод копирования массива цен
       *
       * @param source
       * @return {*}
       * @private
       */
      priceCellMultipleCtrl._copyPrice = function (source, dest) {
        angular.forEach(source, function (item, index) {
          if (!dest[index]) {
            dest[index] = {};
          }
          angular.copy(item, dest[index]);
        });
        return dest;
      };

      /**
       * Метод обновляет флаги состояния мультиячейки с ценами
       */
      priceCellMultipleCtrl.refreshFlags = function () {
        angular.forEach(priceCellMultipleCtrl.prices, function (price) {
          priceCellMultipleCtrl.hasDeleted |= price.$deleted;
          priceCellMultipleCtrl.hasNew |= price.$new;
          priceCellMultipleCtrl.hasModify |= price.$modify;

          // узнать сколько знаков у цены и у предыдущей цены, для того чтобы спрятать цену в подсказку, если слишком длинные числа
          if (price && price.$$previos) {
            var count = Math.ceil(Math.log10(price.$$previos.price_for_one_uom || price.$$previos.calculated_automatically_price_for_one_uom));
            var prevCount = Math.ceil(Math.log10(price.price_for_one_uom || price.calculated_automatically_price_for_one_uom));
            if (count && prevCount && (count + prevCount) > 10) {
              price.$$previos.$$withTip = true;
            }
          }
        });
      };

      /**
       * Начало обновления ячейки
       */
      priceCellMultipleCtrl.startSelectedCallback = function () {
        // кеширование текущих цен
        priceCellMultipleCtrl.oldPrices = [];
        priceCellMultipleCtrl._copyPrice(priceCellMultipleCtrl.prices, priceCellMultipleCtrl.oldPrices);
      };

      /**
       * Метод валидирует цену согласно существующим
       *
       * @param price
       */
      priceCellMultipleCtrl.validatePrice = function (price) {

        if (priceCellMultipleCtrl.column.column_type == "PURCHASE") {
          var allow = true;
          angular.forEach(priceCellMultipleCtrl.prices, function (temp, index) {
            if(priceCellMultipleCtrl.current != index && price.effective_qty == temp.effective_qty){
              allow = false;
            }
          });
          return allow;
        }

        // исходим из предположения, что для автоматически рассчитанных цен дата и штучность не меняется
        if (price && !price.id) { // новая цена
          var allow = true;
          angular.forEach(priceCellMultipleCtrl.prices, function (temp) {
            if (temp == price) {
              return; // отбрасываем сам объект стравнения
            }
            if (((temp.effective_qty == undefined && price.effective_qty == undefined)
                || (temp.effective_qty == price.effective_qty)) &&
              ((temp.effective_date == undefined && price.effective_date == undefined) ||
                (Math.floor(new Date(temp.effective_date).getTime() / (1000 * 60 * 60 * 24)) == Math.floor(new Date(price.effective_date).getTime() / (1000 * 60 * 60 * 24))))) {
              allow = false; // встретилась цена с таким же значением цены и даты
            }
          });
          return allow;
        }
        return true;
      };

      /**
       * Метод обновляет текущую позицию
       */
      priceCellMultipleCtrl.refreshCurrentPosition = function () {
        if (priceCellMultipleCtrl.prices && priceCellMultipleCtrl.prices.length) {
          priceCellMultipleCtrl.current = Math.min(priceCellMultipleCtrl.current, priceCellMultipleCtrl.prices.length - 1);
        } else {
          priceCellMultipleCtrl.prices = [];
          priceCellMultipleCtrl.current = 0;
        }
      };

      // Обновление флагов при инициализации
      priceCellMultipleCtrl.refreshFlags();

      // едсиная инициализация
      priceCellMultipleCtrl.refreshCurrentPosition();

      priceCellMultipleCtrl.commitValueMulti = function () {
        // сохраняем всем блоком цен
        priceCellMultipleCtrl.commitValue(priceCellMultipleCtrl.prices).then(function () {
          // обновление флагов
          $timeout(priceCellMultipleCtrl.refreshFlags);
          // обновление позиции
          $timeout(priceCellMultipleCtrl.refreshCurrentPosition);
          // обновление сортировки
          $timeout(priceCellMultipleCtrl.sortPrices);
        });
      };

      // добавление новой ячейи с ценой
      priceCellMultipleCtrl.addNewPrice = function (event) {
        event.stopPropagation();
        if (!priceCellMultipleCtrl.prices) {
          priceCellMultipleCtrl.prices = [];
        }
        // итерация поиска доступного дня
        var nextDate = today.valueOf();
        while (true) {
          if (!_.find(priceCellMultipleCtrl.prices, function (item) {
              return moment(item.effective_date).valueOf() == nextDate;
            })) break;
          else nextDate += 24 * 60 * 60 * 1000;
        }
        priceCellMultipleCtrl.prices.push({
          effective_date: nextDate,
          free_of_control_price: false,
          effective_qty: 1, // значение по-умолчанию
          price_for_one_uom: undefined
        });
        priceCellMultipleCtrl.current = priceCellMultipleCtrl.prices.length - 1;
        // рассылка события добавления новой цены
        $scope.$broadcast('newPriceEvent');
        priceCellMultipleCtrl.validatePrice(priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current]);
      };

      // Выход из режима редактирования (принудительный без сохранения)
      priceCellMultipleCtrl.cancelWithoutSave = function () {
        // восстановление копии цен
        priceCellMultipleCtrl._copyPrice(priceCellMultipleCtrl.oldPrices, priceCellMultipleCtrl.prices);

        priceCellMultipleCtrl.selected = false;
        priceCellMultipleCtrl.commitValue(false).then(function () { // false обрабытывается как отмена
          // обновление флагов
          $timeout(priceCellMultipleCtrl.refreshFlags);
          // обновление позиции
          $timeout(priceCellMultipleCtrl.refreshCurrentPosition);
        });
      };

      // удаление ячейки с ценой
      priceCellMultipleCtrl.removePrice = function (event) {
        event.stopPropagation();
        if (priceCellMultipleCtrl.column.column_type == "PURCHASE") {
          if (priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current].id) {
            priceListSrv.immediateRemovePrices([priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current].id]).then(function (res) {
              priceCellMultipleCtrl.prices.splice(priceCellMultipleCtrl.current, 1);
              priceCellMultipleCtrl.current = (priceCellMultipleCtrl.current) ? priceCellMultipleCtrl.current - 1 : 0;
              if (!priceCellMultipleCtrl.prices.length) {
                $state.reload();
              }
            });
          } else {
            priceCellMultipleCtrl.prices.splice(priceCellMultipleCtrl.current, 1);
            priceCellMultipleCtrl.current = (priceCellMultipleCtrl.current) ? priceCellMultipleCtrl.current - 1 : 0;
            if (!priceCellMultipleCtrl.prices.length) {
              priceCellMultipleCtrl.cancelWithoutSave();
            }
            priceCellMultipleCtrl.validatePrice(priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current]);
          }
        } else {
          if (priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current].price_for_one_uom === undefined && !priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current].calculated_automatically_price_for_one_uom) {
            priceCellMultipleCtrl.cancelWithoutSave();
            return;
          }
          if (priceCellMultipleCtrl.prices && priceCellMultipleCtrl.prices.length > 0) {
            if (priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current].$local) {
              priceCellMultipleCtrl.prices.splice(priceCellMultipleCtrl.current, 1);
            } else {
              priceCellMultipleCtrl.selected = false;
              // для удаления закоммиченных цен используется промежуточное состояние
              priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current].$deleted = true;
              // обновление флагов
              $timeout(priceCellMultipleCtrl.refreshFlags);
              priceCellMultipleCtrl.commitValueMulti();
              return;
            }
          }
          priceCellMultipleCtrl.current = Math.min(priceCellMultipleCtrl.current, priceCellMultipleCtrl.prices.length - 1);
        }
      }

    }
  }
})();

/**
 * Created by aivanov on 15.11.2017.
 */
(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('priceCell', priceCell);

  /**
   * Директива для отображения и редактирование данных о цене
   *
   * @return {{restrict: string, templateUrl: string, scope: {price: string, currency: string}, controller: priceCellController, controllerAs: string, bindToController: boolean}}
   */
  function priceCell($interval, $timeout) {
    var pCell = {
      restrict: 'EA',
      require: '?^priceCellMultiple',
      templateUrl: 'app/price-list/directives/price-cell/price-cell.html',
      scope: {
        // цена (объект с атрибутами времени, количества штук, типа и собственно цены)
        price: '=',
        // необязательный параметр упаковки
        uom: '<?',
        // блокировка режима редактирования
        lock: '<?',
        // тип колонки
        columnType: '<?',
        // Данные валюты
        currency: '<',
        // Колбек для коммита значений
        commitValue: '<?',
        // флаг состояния редактирование (необходимо управение извне)
        selected: '=?state',
        // метод внешней валидации при добавлении или редактировании
        validatePrice: '<?',
        // необязательный параметр колонки
        column: '<?',
        // обратный вызов при переходе в режим редактирования
        startSelectedCallback: '<?',
        // флаг указания добавлять листенер на закрытие по ESC (для дерева управляется мультиячейкой, для попапа тут)
        escListener: '<?',
        // выход без сохранения
        cancel: '<?',
        // всегда доступно редактирование
        alwaysEdit: '<?',
        // добавить новую цену
        addNew: "<?"
      },
      controller: priceCellController,
      link: function (scope, elem, attr, priceCellMultiple) {
        // Связывание контроллера родительской директивы
        scope.priceCellCtrl.priceCellMultiple = priceCellMultiple;
      },
      controllerAs: 'priceCellCtrl',
      bindToController: true
    };
    return pCell;

    function priceCellController($scope, $document, $timeout, helpService) {
      var priceCellCtrl = this;
      priceCellCtrl.effective_date_state = {};
      if(priceCellCtrl.price && priceCellCtrl.price.price_for_one_uom == undefined && priceCellCtrl.price.calculated_automatically_price_for_one_uom != undefined){
        priceCellCtrl.price.$$withFormula = true;
        priceCellCtrl.price.price_for_one_uom = priceCellCtrl.price.calculated_automatically_price_for_one_uom;
      }
      // статус вализации (используется для установки флага проверки возможности добавления)
      priceCellCtrl.valid = true;
      priceCellCtrl.message = '';
      if(priceCellCtrl.alwaysEdit && priceCellCtrl.price.price_for_one_uom == undefined && priceCellCtrl.price && priceCellCtrl.price.calculated_automatically_price_for_one_uom){ // подстановка в основную цену - цену, которая посчитана по формууле, релактироваться он оне может
        priceCellCtrl.price.price_for_one_uom = priceCellCtrl.price.calculated_automatically_price_for_one_uom;
      }

      priceCellCtrl.todayMoment = helpService.userNow();

      // установка видимой даты
      priceCellCtrl.effective_date = (priceCellCtrl.price)? priceCellCtrl.price.effective_date : priceCellCtrl.todayMoment;

      // текущее время (используется для сравнения)
      priceCellCtrl.nextDay = priceCellCtrl.todayMoment.clone().add(1, 'day').valueOf();
      // нужен для дизэйбла полей ячейки, если дата в прошлом
      priceCellCtrl.today = priceCellCtrl.todayMoment.valueOf();

      priceCellCtrl.onDatePickerClose = function (returnValue, name) {
        $interval.cancel(priceCellCtrl.dpInterval);
        if (name && returnValue && !returnValue.isEmpty && priceCellCtrl.price) {
          if (priceCellCtrl.price.effective_date !== returnValue.valueOf()) {
            // установка флагов модификации
            priceCellCtrl.setModify();
          }
          priceCellCtrl.price.effective_date = returnValue.valueOf();
          priceCellCtrl._validatePriceInit();
        }
      };

      priceCellCtrl.datePickerOpts = {
        singleDatePicker: true, correctTimeZone: false, minDate: priceCellCtrl.todayMoment
      };

      priceCellCtrl.onDatePickerClick = function ($event, value, old) {
        $event.stopPropagation();
        priceCellCtrl.dpInterval = $timeout(function () {
          var offset = angular.element($event.target).offset();
          var $picker = angular.element('.daterangepicker.dropdown-menu');
          $picker.offset(offset);
          $picker.width(285);
        });
        priceCellCtrl.opened = !priceCellCtrl.opened;
      };

      // слушатель событий клавиатуры для перехвата esc
      priceCellCtrl.keyListener = function (evt) {
        if (evt.isDefaultPrevented()) {
          // Такой код есть при закрытии модального окна, вставил его и тут.
          // Т.к. поведение выхода по esc работает на уровне дефолтного, еод яно не лишний.
          //return evt;
        }
        if (priceCellCtrl.selected) {
          switch (evt.which) {
            case 27: { // ESC
              evt.preventDefault();
              $timeout(priceCellCtrl.onClick());
              break;
            }
          }
        }
      };

      /* Обработка клика на ячейку */
      priceCellCtrl.onClick = function ($event) {
        // подстановка цены по формуле, если она есть
        if(priceCellCtrl.price && 
           (priceCellCtrl.price.price_for_one_uom === undefined || priceCellCtrl.price.price_for_one_uom === null) && 
           priceCellCtrl.price.calculated_automatically_price_for_one_uom != undefined){
          priceCellCtrl.price.$$withFormula = true;
          priceCellCtrl.price.price_for_one_uom = priceCellCtrl.price.calculated_automatically_price_for_one_uom;
        }

        if(priceCellCtrl.price && priceCellCtrl.price.$$changed){
          priceCellCtrl.price.$$withFormula = false;
        }

        // если цена удаленная, то создавать новую
        if(priceCellCtrl.price && priceCellCtrl.price.$deleted){
          priceCellCtrl.addNew($event);
        }

        $event && $event.stopPropagation();

        if (priceCellCtrl.price && 
            (priceCellCtrl.price.price_for_one_uom === undefined || priceCellCtrl.price.price_for_one_uom === null) && 
            priceCellCtrl.price.calculated_automatically_price_for_one_uom !== undefined) { // для того чтобы оставался курсив у цены, если значение не задано и не изменилось
          priceCellCtrl.price.price_for_one_uom = undefined;
        }

        if (priceCellCtrl.lock) {
          return; // блокировка
        }

        // Указываем явно, чтобы пикер не открывался при выделении ячейки
        priceCellCtrl.opened = false;

        if (priceCellCtrl.selected) { // попытка закрыть
          if (priceCellCtrl.price && priceCellCtrl.price.calculated_automatically_price_for_one_uom === undefined &&
            (priceCellCtrl.price.price_for_one_uom === undefined || priceCellCtrl.price.price_for_one_uom === null)) {
            if (priceCellCtrl.valid == false) {
              // если это уже не первое нажатие, то делается попытка закрыть ячейку чеерз родительскую директиву (она есть не всегда)
              if (priceCellCtrl.priceCellMultiple) {
                priceCellCtrl.priceCellMultiple.cancelWithoutSave();
                // снятие перехватчика обработки клавиатуры
                $document.off('keydown', priceCellCtrl.keyListener);
                return;
              }
            }
            priceCellCtrl.valid = false;
            priceCellCtrl.message = 'Необходимо заполнить значение цены';
            return;
          }

          if (priceCellCtrl._validatePriceInit() == false) {
            // отправка события отката фиксации изменений
            $scope.$emit('priceCommitChangedRollback', priceCellCtrl.price);
            return;
          }
        } else {
          // установка видимой даты
          priceCellCtrl.effective_date = (priceCellCtrl.price)? priceCellCtrl.price.effective_date : priceCellCtrl.todayMoment;
          priceCellCtrl.valid = true;
          priceCellCtrl.message = '';
        }

        if (priceCellCtrl.selected) {
          // снятие перехватчика обработки клавиатуры
          $document.off('keydown', priceCellCtrl.keyListener);
        } else {
          // добавление перехватчика
          $document.on('keydown', priceCellCtrl.keyListener);
        }

        // инверсия состояния редактирвоания
        priceCellCtrl.selected = !priceCellCtrl.selected;

        // при открытии если цена не установлена - создается временная цена (будет отброшена при сохраннеии,
        // если других измненений не будет). создается здесь, а не выше в целях оптимизации.
        if (priceCellCtrl.selected) {
          // уведомление о переходе в режим редактирования
          if (priceCellCtrl.startSelectedCallback) {
            priceCellCtrl.startSelectedCallback();
          }

          if (!priceCellCtrl.price) {
            priceCellCtrl.price = {
              effective_date: priceCellCtrl.today,
              free_of_control_price: false,
              effective_qty: 1 // значение по-умолчанию
            }
          }
        }

        /* Коммит изменения значений при закрытии режима редактирования (дифф не проверяется) */
        if (!priceCellCtrl.selected) {
          if (priceCellCtrl.commitValue) {
            priceCellCtrl.commitValue(priceCellCtrl.price);
          }
          // отправка события успешной фиксации измененных данных
          $scope.$emit('priceCommitChangedSuccess', priceCellCtrl.price);
        }
      };

      /**
       * Метод инициирующий запуск процесса валидации. Отправу событий и т.д.
       * @private
       */
      priceCellCtrl._validatePriceInit = function () {
        // отправка события начала фиксации изменений цены ячейки
        $scope.$emit('priceCommitChangedStarted', priceCellCtrl.price);
        return priceCellCtrl._validatePrice(); // тех. процесс валидации
      };

      /**
       *  Внутриенний метод, берет на себя логику валидации и установку флагов статуса валидации.
       */
      priceCellCtrl._validatePrice = function () {
        priceCellCtrl.valid = true;
        priceCellCtrl.message = '';
        // внешняя валидация (данных на уровне ячейки недостаточно для принятия решения о валидности)
        if (priceCellCtrl.validatePrice) {
          if (priceCellCtrl.validatePrice(priceCellCtrl.price,
              (priceCellCtrl.column ? priceCellCtrl.column.id : undefined)) === false) {
            // TODO: нужно предусмотреть различные типы ошибок
            priceCellCtrl.valid = false;
            priceCellCtrl.message = 'Цена с такими параметрами уже существует';
            return false;
          }
        }
        return true;
      };

      /**
       * Обработчик события надатия клавиш в ячейке цены
       */
      priceCellCtrl.keyEventHandler = function ($event) {
        $timeout(function () {
          // модель еще не обновилась
          priceCellCtrl._validatePrice();
        });
      };

      /**
       * Обработчик события надатия клавиш в ячейке цены
       */
      priceCellCtrl.onBlurHandler = function ($event) {
        priceCellCtrl._validatePriceInit();
      };

      /**
       * Обработчик события пересчета статуса валидации
       */
      $scope.$on('recalculatePriceValidationStatus', function ($event, data) {
        if (!data || priceCellCtrl.price != data) {
          // обновление пришло от другой цены
          priceCellCtrl._validatePrice();
        }
      });

      /* Установка флага модификации */
      priceCellCtrl.setModify = function () {
        priceCellCtrl.price.$$changed = true;
      };

      // При смене цены извне обновляет визуальное представление даты в дейтпикере
      $scope.$watch('priceCellCtrl.price', function(model) {
        if (model) {
          if (priceCellCtrl.effective_date_state.forceUpdate) {
            priceCellCtrl.effective_date_state.forceUpdate(model.effective_date);
          }
        }
        priceCellCtrl._validatePrice();
      })

    }
  }
})();

/**
 * Created by aivanov on 02.12.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('footerAbsolute', footerAbsolute);

  /**
   * Директива скроллинга использует родительский скоуп и проставляет в нем флаги состояния скролла
   * по которым внешний контроллер может управлять отображением контролов, к примеру,
   * скрывать фиксированное меню по достижение "дна" документа.
   *
   * @param $window испольузется angular-обертка
   * @return {{link: link}} низкоуровневая директива, испольузется только линк
   */
  function footerAbsolute($window) {
    var d = {
      link: function(scope, element, attrs) {
        // определение смещения для выставления флагов
        var topShift= +attrs.topShift || 10;
        var bottomShift = +attrs.bottomShift || 10;
        // пременные скоупа, в которые будут проставляться флаги
        var topFlag = attrs.topFlag || 'notInTop';
        var bottomFlag = attrs.bottomFlag || 'onBottom';
        angular.element($window).bind("scroll", function() {
          topShift= +attrs.topShift || 10;
          if (this.pageYOffset >= topShift) {
            scope[topFlag] = true;
          } else {
            scope[topFlag] = false;
          }
          if(this.pageYOffset + this.innerHeight >= $(document).height() - bottomShift) { // небольшие допуски
            scope[bottomFlag] = true;
          } else {
            scope[bottomFlag] = false;
          }
          scope.$apply();
        });
      }
    };

    return d;
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('partnerController', partnerController);

  function partnerController($scope, 
                             $state, 
                             partner, 
                             cardHistory,
                             $q) {
    var partnerController = this;
    partnerController.partner = partner;
    partnerController.cashRegisterlength = 0;

    // необходимо выяснить есть ли в компании кассы, для отображения сообщения если их нет
    _.forEach(partnerController.partner.companies, function(company){
      company.cashRegisterlength = 0;
      _.forEach(company.divisions, function(division){
        company.cashRegisterlength += division.cash_registers.length;
      });
    });

    // для возврата на предыдущую страницу
    partnerController.returnToPage = function(){
      var prev = cardHistory.popStep('id', partnerController.partner.client_id) || {name: 'partners', param: {parent: 'business'}};
      $state.go(prev.name !== '' ? prev.name : 'partners', prev.param || {parent: 'business'});
    };

    partnerController.crud = function (status) {
      if (status == 'return') {
        partnerController.returnToPage();
      }
      return $q.when();
    }

    partnerController.cashRegisterStr = function(cash_register){
      var res = cash_register.manufacturer || '';
      if(cash_register.model){
        res += (res)? ' ' + cash_register.model : cash_register.model;
      }
      if(cash_register.serial_number){
        res += (res)? ' №' + cash_register.serial_number : '№' + cash_register.serial_number;
      }
      return res;
    }

    partnerController.versionStr = function(cash_register){
      var res = cash_register.software_version || '';
      if(cash_register.os_version){
        res += ' ОС: ' + cash_register.os_version;
      }
      return res;
    }

    partnerController.getSubscriptionsStatus = function(subscriptions) {
      var status = subscriptions.length? "red" : "";
      var week = moment().add(7, 'day').valueOf();
      _.forEach(subscriptions, function (subscription) {
        if (subscription.sync_enabled && subscription.status == 'ACTIVE' && subscription.expire_date < week) {
          status = "yellow";
        } else if (subscription.sync_enabled && subscription.status == 'ACTIVE' && subscription.expire_date > week) {
          status = "green";
        }
      });
      return status;
    };

    
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('searchHeader', searchHeader);

  /** @ngInject */
  function searchHeader($timeout) {
    var directive = {
          restrict: 'E',
          templateUrl: 'app/mobile/components/search-header/search-header.html',
          scope: {
            catalogItemsLength: '<?', // количество дочерних элементов категории
            choosenItem: '<?', // выбранный в каталоге элемент (категория, товар или услуга)
            type: '<?', // тип выбранной сущности
            cannotRedact: '=', // включить попап невозможности редатирования товара (из-за множества дериватив)
            searchCallback: '<', // для поиска
            searchActive: '=', // флаг показа режима поиска
            searchLoading: '=' // флаг для лоадера
          },
          controller: searchHeaderController,
          controllerAs: 'searchHeaderCtrl',
          bindToController: true
        };
    return directive;

    /** @ngInject */
    function searchHeaderController($scope, $state, $stateParams, $window, cardHistory, focus) {
      var searchHeaderCtrl = this;
      searchHeaderCtrl.params = $stateParams;

      if ($stateParams.request) {
        searchHeaderCtrl.searchHeaderActive = true;
        searchHeaderCtrl.searchStr = $stateParams.request;
        $timeout(function () {
          focus.setFocusOnInput(false, angular.element("#msearch")[0]);
        }, 0);
      }

      searchHeaderCtrl.goBack = function (isClear) {
        if (!isClear && $state.current.name == 'catalogMobile' && !$stateParams.parent && $window.Android && $window.Android.sendEditCatalogResult) {
          $window.Android.sendEditCatalogResult(angular.toJson({"status":"CANCEL"}));
          return;
        }
        var prev = cardHistory.popStep();
        if(prev && prev.name){
          if (prev.name.indexOf("sku") + 1 || prev.name.indexOf("service") + 1 || (prev.name == $state.current.name && prev.param.parent == $stateParams.parent)) {
            searchHeaderCtrl.goBack();
            return;
          }
          $state.go(prev.name, prev.param);
        }else{
          $state.go('catalogMobile', { parent: undefined, parentname: undefined });
        }
      }

      searchHeaderCtrl.checkRedact = function (event) {
        if (searchHeaderCtrl.choosenItem.there_is_multivalued_attributes) {
          event.preventDefault();
          event.stopPropagation();
          searchHeaderCtrl.cannotRedact = true;
          $timeout(function () {
            searchHeaderCtrl.searchLoading = false;
          }, 0);
          
        }
      }

      searchHeaderCtrl.search = function () {
        if (!searchHeaderCtrl.searchStr) return;
        searchHeaderCtrl.params.request = searchHeaderCtrl.searchStr;
        $state.go('catalogMobile.searchCatalog', searchHeaderCtrl.params);
      }

      searchHeaderCtrl.keyUp = _.debounce(searchHeaderCtrl.search, 1000);

      searchHeaderCtrl.clear = function () {
        searchHeaderCtrl.searchActive = false;
        searchHeaderCtrl.searchHeaderActive = false;
        searchHeaderCtrl.searchStr = '';
        searchHeaderCtrl.goBack(true);
      }

      searchHeaderCtrl.goMrecover = function () {
        searchHeaderCtrl.params.isarchived = true;
        $state.go("catalogMobile.mrecover", searchHeaderCtrl.params);
      }

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('mobileSelect', mobileSelect);

  /** @ngInject */
  function mobileSelect($timeout) {
    var directive = {
          restrict: 'E',
          templateUrl: 'app/mobile/components/mobile-select/mobile-select.html',
          scope: {
            model: '=ngModel', // модель
            callback: '<', // calback на изменение в model
            config: '<'  // настройки
              // в конфиге:
              // disabled
              // getData - запрос данных
              // multiselect - можно ли выбрать несколько вариантов
              // chooseParent - возможно ли выбрать родительский элемент
              // title - Название в шапке
              // name - name для поля
              // label - лэйба в поле
              // required - обязательность поля
              // treeView - нужна ли древовидная структура (родитель/дети),
              // saveAs - параметр который нужно сохранить в модели
              // hasChildren - проверка наличия детей, и необходимости показывать стрелочку для перехода к ним
          },
          link:function (scope, element, attr) {},
          controller: mobileSelectController,
          controllerAs: 'mobileSelectCtrl',
          bindToController: true
        };
    return directive;

    /** @ngInject */
    function mobileSelectController($scope, $state, $stateParams, cardHistory, $window) {
      var mobileSelectCtrl = this;
      mobileSelectCtrl.params = $stateParams;
      mobileSelectCtrl.allData = []; // все данные, для выбора в списке выбора, содержит и все дочерние варианты выбора
      mobileSelectCtrl.chosenData = []; // выбранные данные, отображаются в отдельном блоке
      mobileSelectCtrl.deepData = []; // данные по вложенности и глубине погружения в дочесрние элементы
      mobileSelectCtrl.title = mobileSelectCtrl.config.title;

      if (mobileSelectCtrl.model) {
        if (Array.isArray(mobileSelectCtrl.model)) {
          mobileSelectCtrl.chosenData = mobileSelectCtrl.model;
        } else {
          mobileSelectCtrl.chosenData = [mobileSelectCtrl.model];
        }
      }

      $scope.$watch(function () {
        return mobileSelectCtrl.model;
      }, function (newVal, oldVal) {
        if ((!oldVal && newVal) || (oldVal && newVal && oldVal.id && newVal.id && oldVal.id !== newVal.id)){
          if (mobileSelectCtrl.config.saveAs) {
            mobileSelectCtrl.chosenData = [mobileSelectCtrl.findData(newVal)];
          } else if (!Array.isArray(newVal)) {
            mobileSelectCtrl.chosenData = [newVal];
          } else {
            mobileSelectCtrl.chosenData = newVal;
          }
          if (mobileSelectCtrl.callback) {
            mobileSelectCtrl.callback();
          }
        }
      });

      // для отображения имени в chosenData
      mobileSelectCtrl.findData = function (view) {
        if (typeof view == 'string' && mobileSelectCtrl.config.saveAs) {
          var data = _.find(mobileSelectCtrl.allData, function(parent){
            if (parent[mobileSelectCtrl.config.saveAs] == view) {
              return true;
            }
            if (parent.child_data && parent.child_data.length) {
              return _.find(parent.child_data, function(item){
                if (item[mobileSelectCtrl.config.saveAs] == view) {
                  return true;
                }
              });
            }
          });
          return data;
        }
        return '';
      }

      // установить отмеченные данные в списке
      function setActiveFlags() {
        var data = mobileSelectCtrl.model;
        mobileSelectCtrl.chosenData = [];
        if (!Array.isArray(mobileSelectCtrl.model)) {
          data = [mobileSelectCtrl.model];
        }
        _.forEach(data, function(chosen){
          if (!chosen) return;
          var findItem = mobileSelectCtrl.findElemById(mobileSelectCtrl.allData, chosen.id || chosen.value, true, false, true);
        });
        if (!mobileSelectCtrl.chosenData.length && !mobileSelectCtrl.model && mobileSelectCtrl.config.default){
          mobileSelectCtrl.chosenData = [mobileSelectCtrl.config.default];
        }
        if (mobileSelectCtrl.model && !mobileSelectCtrl.chosenData.length) {
          if (mobileSelectCtrl.model.id) {
            mobileSelectCtrl.chosenData.push(mobileSelectCtrl.model);
          } else {
            var itemInArr = mobileSelectCtrl.findData(mobileSelectCtrl.model);
            if (itemInArr) {
              mobileSelectCtrl.chosenData.push(itemInArr);
            }
          }
        }
      }

      // поиск элемента по id по всему дереву
      // return полный объект найденного элемента
      var temp;
      mobileSelectCtrl.findElemById = function (arr, id, setActive, resetActive, addToChosenData){
        temp = undefined;
        _.forEach(arr, function (element) {
          var elemId = element.id || element.value
          if (resetActive) {
            element.$$active = false;
            element.$$hasActiveChilds = false;
          }

          if (elemId == id) {
            temp = element;
            if (setActive) {
              element.$$active = true;
              element.$$hasActiveChilds = false;
              if (_.find(mobileSelectCtrl.tempData, function (obj) { return obj.id == id})) {
                _.forEach(mobileSelectCtrl.deepData, function (item) {
                  item.$$hasActiveChilds = true;
                });
              }
            }
          }

          if (addToChosenData && element.$$active) {
            mobileSelectCtrl.chosenData.push(element);
          }

          if (!temp && element.child_data) {
            return mobileSelectCtrl.findElemById(element.child_data, id, setActive, resetActive, addToChosenData);
          }
        });
        return temp;
      };



      // показать экран с родительскими пунктами
      mobileSelectCtrl.getData = function(event, index){
        // если не переделаи запрос, то запрашивать ничего не надо
        if (!mobileSelectCtrl.config.getData) return;

        event && event.preventDefault();
        event && event.stopPropagation();
        mobileSelectCtrl.errorMessage = '';


        // если данные ужe были подгружены, то не надо заново запрос отправлять запрос
        if (index === undefined && mobileSelectCtrl.allData.length) {
          $window.scrollTo(0, 0);
          mobileSelectCtrl.showData = !!event;
          mobileSelectCtrl.title = mobileSelectCtrl.config.title;
          mobileSelectCtrl.tempData = mobileSelectCtrl.allData;
          mobileSelectCtrl.deepData = [];
          return;
        }

        // если данные ужe были подгружены, то не надо заново запрос отправлять
        if (index !== undefined && mobileSelectCtrl.allData.length) {
          var element = mobileSelectCtrl.tempData[index];
          if (element && element.child_data) {
            mobileSelectCtrl.showData = true;
            mobileSelectCtrl.title = element.name;
            mobileSelectCtrl.tempData = element.child_data;
            mobileSelectCtrl.deepData.push(element);
            return;
          }
        }

        // получения данных для выбора
        mobileSelectCtrl.config.getData(mobileSelectCtrl.tempData && mobileSelectCtrl.tempData[index] && mobileSelectCtrl.tempData[index].id).then(function(res){
          var parent = (index !== undefined)? mobileSelectCtrl.tempData[index] : undefined;
          $window.scrollTo(0, 0);
          mobileSelectCtrl.showData = !!event;
          mobileSelectCtrl.title = mobileSelectCtrl.config.title;
          mobileSelectCtrl.tempData = (res.data)? (res.data.items || res.data) : res;
          if (!mobileSelectCtrl.isChoose && mobileSelectCtrl.config.parentHierarchy) {
            _.forEach(mobileSelectCtrl.config.parentHierarchy, function (item) {
              var findedData = _.find(mobileSelectCtrl.tempData, function (tempItem) {
                return tempItem.id == item.id;
              });
              if (findedData) findedData.$$hasActiveChilds = true;
            })
          }

          if (index === undefined) {
            mobileSelectCtrl.allData = mobileSelectCtrl.tempData;
          } else {
            var data = mobileSelectCtrl.findElemById(mobileSelectCtrl.allData, parent.id || parent.value);
            if (data) {
              data.child_data = mobileSelectCtrl.tempData;
              mobileSelectCtrl.deepData.push(data);
            } else {

            }
            mobileSelectCtrl.title = parent.name;
          }
          if (!mobileSelectCtrl.isChoose) setActiveFlags();
        }, function (error) {
          var params = $stateParams;
          params.message = (error.status == -1)? "Отсутствует подключение в интернету" : "Во время получения данных возникла ошибка";
          $state.go('mobileError', params);
        });
      };


      mobileSelectCtrl.checkChosenData = function () {
      // проверка выбрал ли что-то пользователь
      // поле обязательное
        mobileSelectCtrl.noData = !_.find(mobileSelectCtrl.allData, function(area){
          return area.$$active || area.$$hasActiveChilds;
        });
      }

      // выбор элемента
      mobileSelectCtrl.choose = function(index){
        var item = mobileSelectCtrl.tempData[index];
        var active = item.$$active;
        mobileSelectCtrl.isChoose = true;
        // убрать все статусы active, при случае если это не множетвенный выбор
        if (!mobileSelectCtrl.config.multiselect) {
          mobileSelectCtrl.findElemById(mobileSelectCtrl.allData, '', false, true);
        }
        if (!active) {// если не стоит $$active, то поставить, если стоит active, то флаг снимется на предыдущем пробеге
          if (mobileSelectCtrl.deepData.length) {
            _.forEach(mobileSelectCtrl.deepData, function (parent, key) {
              parent.$$hasActiveChilds = true;
              if (key == mobileSelectCtrl.deepData.length - 1) {
                _.forEach(parent.child_data, function (child) {
                  if (item.id == child.id) {
                    child.$$active = true;

                  }
                });
              }
            });
          } else {
            _.forEach(mobileSelectCtrl.tempData, function (elem) {
              if ((item.id && elem.id && item.id == elem.id) 
                || (typeof(item.id) === 'boolean' && typeof(elem.id) === 'boolean' && item.id == elem.id)
                || (item.value && elem.value && item.value == elem.value)) {
                elem.$$active = true;
              }
            });
          }
        }

        if (mobileSelectCtrl.config.required) {
          mobileSelectCtrl.checkChosenData();
        }
      };

      // сохранение сфер деятельности
      mobileSelectCtrl.save = function(index){
        mobileSelectCtrl.chosenData = [];
        mobileSelectCtrl.findElemById(mobileSelectCtrl.allData, '', false, false, true);
        if (mobileSelectCtrl.config.multiselect) {
          mobileSelectCtrl.model = mobileSelectCtrl.chosenData;
        } else {
          if (!mobileSelectCtrl.chosenData.length) {
            mobileSelectCtrl.chosenData[0] = mobileSelectCtrl.config.default;
            mobileSelectCtrl.model = mobileSelectCtrl.config.default;
          } else {
            if (mobileSelectCtrl.config.saveAs) {
              mobileSelectCtrl.model = mobileSelectCtrl.chosenData[0][mobileSelectCtrl.config.saveAs];
            } else {
              mobileSelectCtrl.model = mobileSelectCtrl.chosenData[0];
            }
          }
        }
        mobileSelectCtrl.showData = false;
        mobileSelectCtrl.title = mobileSelectCtrl.config.title;
      };

      // Закрытие списка
      mobileSelectCtrl.closeSelect = function(){
        mobileSelectCtrl.deepData.pop();

        if (mobileSelectCtrl.deepData.length) {
          mobileSelectCtrl.title = mobileSelectCtrl.deepData[mobileSelectCtrl.deepData.length - 1].name;
          mobileSelectCtrl.tempData = mobileSelectCtrl.deepData[mobileSelectCtrl.deepData.length - 1].child_data;
        } else {
          if (mobileSelectCtrl.title == mobileSelectCtrl.config.title) {
            mobileSelectCtrl.showData = false;
          } else {
            mobileSelectCtrl.tempData = mobileSelectCtrl.allData;
            mobileSelectCtrl.title = mobileSelectCtrl.config.title;
          }
        }
      };

      if (mobileSelectCtrl.config.saveAs || mobileSelectCtrl.config.default) {
        mobileSelectCtrl.getData();
      }

    }

  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('attrElementMobile', attrElementMobile);

  function attrElementMobile() {
    return {
      restrict: 'E',
      templateUrl: 'app/mobile/components/attr-element/attr-element-mobile.html',
      scope: {
        // Атрибут
        attribute: '=',
        // Значение
        data: '=',
        // форма
        parentForm: '<',
        // индекс атрибута
        attrIndex: '<'
      },
      controller: function ($scope, catalogService, focus, $filter, $q) {
        $scope.dateData = {};
        if ($scope.attribute.data_type === 'DICTIONARY') {
          $scope.selectConfig = {
            multiselect: false,
            chooseParent: true,
            title: $scope.attribute.name,
            name: "uom",
            label: $scope.attribute.name,
            required: true,
            treeView: false,
            getData: function () {
              return $q.when({ data: $scope.attribute.values });
            }
          };
        }
        if ($scope.attribute.data_type === 'BOOLEAN') {
          $scope.selectConfig = {
            multiselect: false,
            chooseParent: false,
            title: $scope.attribute.name,
            name: "boolean",
            label: $scope.attribute.name,
            required: true,
            treeView: false,
            saveAs: 'id',
            getData: function () {
              return $q.when({ data: [{value: "Да", id: "true"}, {value: "Нет", id: "false"}] }); //TODO пересмотреть boolean в строке
            }
          };

          if ($scope.data) {
            if ($scope.data.values[0] === 'true') {
              $scope.data.values[0] = {value: "Да", id: "true"};
            } else if ($scope.data.values[0] === 'false'){
              $scope.data.values[0] = {value: "Нет", id: "false"};
            }
          }
        }
        if (!$scope.data) {
          // Инициализация вложенной структуры значения атрибута
          $scope.data = {
            attribute: {},
            values: ['']
          };
        } else {
          if ($scope.attribute.data_type === 'DATE' || $scope.attribute.data_type === 'DATE_TIME') {
            var format = ($scope.attribute.data_type === 'DATE') ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm';
            var dateMoment = moment(parseInt($scope.data.value));
            $scope.dateData[$scope.attribute.data_type.toLowerCase() + $scope.attrIndex] = dateMoment.format(format);
            if (dateMoment.isValid()) {
              // запись в модель
              $scope.data.values[0] = {
                value: dateMoment,
                date: new Date(parseInt(dateMoment.valueOf())),
                stamp: dateMoment.valueOf()
              };
            }
          }
        }


        $scope.data.attribute = {
          id: $scope.attribute.id,
          name: $scope.attribute.name,
          data_type: $scope.attribute.data_type
        };

        function watch(value) {
          angular.forEach(value, function(val) {
            $scope.parentForm.$setValidity('requiredAttribute', angular.isDefined(val));
          });
        }

        if ($scope.attribute.required) {
          $scope.$watch(function () {
            return $scope.data.values
          }, watch);
        }

        /* Данные справочников */
        $scope.refreshDictionary = function (search) {
          $scope.dictValues = $scope.attribute.values;
          $scope.notFound = !$filter('filter')($scope.dictValues, search).length;
        };

        $scope.checkDate = function (dateStr, fieldName, index) {
          // если нет данных обнуляем модель
          if (!dateStr) {
            $scope.parentForm[fieldName].$setValidity('date', true);
            $scope.data.values[index] = undefined;
            return;
          }
          // устанавливаем формат данных
          var format = "MM/DD/YYYY";
          var day = dateStr.substring(0,2);
          var month = dateStr.substring(2,4);
          var year = dateStr.substring(4,8);
          var date = month + '/' + day + '/' + year;
          if (year < 1970 || year > 3000) {
            $scope.parentForm[fieldName].$setValidity('date', false);
            $scope.data.values[index] = undefined;
            return;
          }
          // добавляем время если это дата с временем
          if (fieldName.indexOf('date_time') + 1) {
            var hour = dateStr.substring(8, 10);
            var minute = dateStr.substring(10, 12);
            date = date + ' ' + hour + ':' + minute;
            format = "MM/DD/YYYY HH:mm";
          }
          // проверяем валидность даты
          if (moment(date, format).isValid()) {
            $scope.parentForm[fieldName].$setValidity('date', true);
            // обнуляем время, если это дата без времемни
            if (fieldName.indexOf('date_time') + 1) {
              var momentDate = moment(date, format);
            } else {
              var momentDate = moment(date, format).endOf('day');
            }
            // запись в модель
            $scope.data.values[index] = {
              value: momentDate,
              date: new Date(parseInt(momentDate.valueOf())),
              stamp: momentDate.valueOf()
            };
          } else {
            $scope.parentForm[fieldName].$setValidity('date', false);
            $scope.data.values[index] = undefined;
          }

        }


      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('skuMobileController', skuMobileController);

  function skuMobileController($scope, $state, $q,
                                    $stateParams,
                                    $timeout,
                                    sku,
                                    cardHistory,
                                    categoryService,
                                    utilsService,
                                    settings,
                                    taxGroups,
                                    catalogService,
                                    taxModes,
                                    skuByGtin,
                                    catalogItemService,
                                    parentHierarchy) {
    var skuMobileCtrl = this;
    var defaultUom = {
      id: "4a639aa0-478a-49e4-80f7-2b7f159ea6aa",
      name : "Штука",
      symbols: "шт"
    };
    var defaultTax = {
      id: '9cda6b93-40c1-4ca3-95d8-0b11d33b7e78',
      name: 'Без НДС'
    };
    skuMobileCtrl.taxGroups = taxGroups; // справочник режимов налогообложения чека
    skuMobileCtrl.params = $stateParams;
    skuMobileCtrl.theme = $stateParams.theme || 'standard';
    skuMobileCtrl.state = $state;
    skuMobileCtrl.settings = settings;
    skuMobileCtrl.catalogItemFromApi = angular.copy(sku);

    if (skuByGtin) {
      skuByGtin.id = undefined;
      skuByGtin.stock_accounting_type = 'SIMPLE';
      skuByGtin.tax_group_selector = 'OWN';
      skuByGtin.cash_register_item_type = 'GOODS';
      skuByGtin.tax_group = defaultTax;
      skuByGtin.sku_list[0].id = undefined;
      skuByGtin.sku_list[0].name = "Единичная упаковка";
      skuByGtin.sku_list[0].pack_type = {
        id: "263d9664-93ef-4173-8ea8-eaadd0884706",
        name: "Единичная упаковка",
        active: true,
        ext_id: "PACK_BASE_UNIT",
        modified_manually: true
      };
    }

    // инит данных категории
    skuMobileCtrl.sku = sku || skuByGtin || {
      name: '',
      tax_group: defaultTax,
      committent_tax_group: defaultTax,
      tax_group_selector: 'OWN',
      stock_accounting_type: 'SIMPLE',
      attribute_values: [],
      tax_mode_source: 'FROM_CASHREGISTER',
      tax_mode: null,
      cash_register_item_type: 'GOODS',
      sku_list: [{
        name: "Единичная упаковка",
        auto_assemble: true,
        gtin_list: [],
        pack_type: {
          id: "263d9664-93ef-4173-8ea8-eaadd0884706",
          name: "Единичная упаковка",
          active: true,
          ext_id: "PACK_BASE_UNIT",
          modified_manually: true
        },
        uom: defaultUom
      }]
    };

    if (!skuMobileCtrl.sku.category) {
      skuMobileCtrl.sku.category = {
        id : $stateParams.parent,
        name: $stateParams.parentname
      };
    }

    if (skuMobileCtrl.params.gtin) {
      skuMobileCtrl.sku.sku_list[0].gtin_list = [{type: "", gtin: skuMobileCtrl.params.gtin}];
    }


    if(!sku && settings.use_auto_codes){
      catalogService.getCode().then(function(res){
        skuMobileCtrl.sku.code = res.data.code;
      });
    }

    // подстановка налога из параметра
    if(!sku && $stateParams.tax_group_id){
      skuMobileCtrl.sku.tax_group = _.find(skuMobileCtrl.taxGroups, function (tax) {
        return tax.id == $stateParams.tax_group_id;
      });
    }


    skuMobileCtrl.parentConfig = {
      getData: categoryService.getDomainCategories,
      multiselect: false,
      chooseParent: true,
      title: "Товары и услуги",
      name: "parent",
      label: "Расположение товара",
      required: true,
      treeView: true,
      parentHierarchy: parentHierarchy,
      hasChildren: function (item) {
        return item.has_children;
      }
    };

    skuMobileCtrl.taxGroupConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Налог при реализации",
      name: "tax_group",
      label: "Налог при реализации",
      required: true,
      treeView: false,
      getData: function () {
        return $q.when({ data: skuMobileCtrl.taxGroups })
      }
    };

    skuMobileCtrl.uomConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Единица измерения",
      name: "uom",
      label: "Единица измерения",
      required: true,
      treeView: false,
      getData: catalogService.getUoms
    };


    skuMobileCtrl.goBack = function () {
      var prev = cardHistory.popStep();
      if(prev && prev.name){
        $state.go(prev.name, prev.param);
      }else{
        $state.go('catalogMobile', { parent: undefined, parentname: undefined });
      }
    }

    // изменение чекбокса "Товар весовой/мерный"
    skuMobileCtrl.changePackaged = function () {
        // если отпускается без упаковки и если есть флаг весового штрихкода
      if (skuMobileCtrl.sku.sku_list[0].packaged && skuMobileCtrl.settings.generate_weight_barcode) {
        if ((skuMobileCtrl.settings.weight_barcode_format == 'EAN13' &&
            ((skuMobileCtrl.settings.weight_barcode_source == "ITEM_CODE" && (!skuMobileCtrl.sku.code || !/^[\d]+$/.test(skuMobileCtrl.sku.code.toString()) ) ) ||
              (skuMobileCtrl.settings.weight_barcode_source == "VENDOR_CODE" && (!skuMobileCtrl.sku.vendor_code || !/^[\d]+$/.test(skuMobileCtrl.sku.vendor_code.toString()) ) ) )) ||
          (skuMobileCtrl.settings.weight_barcode_format == 'Code39' &&
            ((skuMobileCtrl.settings.weight_barcode_source == "ITEM_CODE" && (!skuMobileCtrl.sku.code || !/^[\d\sA-Z%.+*/$-]+$/.test(skuMobileCtrl.sku.code.toString()) ) ) ||
              (skuMobileCtrl.settings.weight_barcode_source == "VENDOR_CODE" && (!skuMobileCtrl.sku.vendor_code || !/^[\d\sA-Z%.+*/$-]+$/.test(skuMobileCtrl.sku.vendor_code.toString()) ) ) ))) {
          skuMobileCtrl.needWeightBarcode = false;
          return;
        }
        skuMobileCtrl.needWeightBarcode = true;
        skuMobileCtrl.generateWeightBarcode();
      } else {
        skuMobileCtrl.needWeightBarcode = false;
      }
    }

    /**
     * Проверка уникальности полей товара
     */
    skuMobileCtrl.uniqueCheck = function (str, name) {
      var constraintName = '';
      switch (name) {
        case 'name':
          constraintName = 'DOMAIN_CATALOG_STOCK_ITEM_NAME';
          break;
        case 'derivative_code_prefix':
          constraintName = 'DOMAIN_STOCK_ITEM_CODE_PREFIX';
          break;
        case 'vendor_code':
          constraintName = 'DOMAIN_STOCK_ITEM_VENDOR';
          break;
        default:
          constraintName = 'DOMAIN_CATALOG_ITEM_GTIN';
      }

      if (str) {
        var obj = {
          "constraint_name": constraintName,
          "parameters": [
            {
              "name": name,
              "value": str
            }
          ]
        }
        if (name == 'gtin') {
          if (skuMobileCtrl.sku.id) {
            obj.parameters.push({
              "name": "catalog_item_id",
              "value": skuMobileCtrl.sku.id
            });
          }
          if (str.id) obj.id = str.id;
        } else {
          if (skuMobileCtrl.sku.id) obj.id = skuMobileCtrl.sku.id;
        }
        utilsService.uniqueCheck(obj).then(function (res) {
          },
          function (error) {
            if (error.status == 409 && error.data.code == 'non_unique') {
              _.forEach(error.data.parameters, function (formError) {
                if (skuMobileCtrl.skuForm[formError.name]) {
                  skuMobileCtrl.skuForm[formError.name].$setValidity('unique', false);
                }
              });
            } else {
              $state.go('catalogMobile.msku.mobileError', {message: (error.status == -1)? "Отсутствует подключение в интернету" : "Во время проверки уникальности произошла ошибка"});
            }
          });
      }
    }

    // проверка на уникальность подставленного из параметров штрих-кода
    if (skuMobileCtrl.sku.sku_list.length &&
        skuMobileCtrl.sku.sku_list[0].gtin_list &&
        skuMobileCtrl.sku.sku_list[0].gtin_list.length &&
        skuMobileCtrl.sku.sku_list[0].gtin_list[0].gtin) {
      skuMobileCtrl.uniqueCheck(skuMobileCtrl.sku.sku_list[0].gtin_list[0].gtin, 'gtin');
    }

    // Если длина кода меньше weight_barcode_code, то слева от него дописываем нули. Если больше, то отрезаем лишние цифры слева
    skuMobileCtrl.genCodeForBarcode = function (strLength, source) {
      source = source || '';
      var sourceLen = source ? source.toString().length : 0;
      if (strLength > sourceLen) {
        var res = '';
        for (var i = 0; i < (strLength - sourceLen); i++) {
          res += '0';
        }
        return res + source;
      } else if (strLength < sourceLen) {
        // скрываем отображение весового шк
        return source.substring(sourceLen - strLength, sourceLen);
      } else {
        return source;
      }
    }

    // настройки для весового штрихкода
    skuMobileCtrl.generateWeightBarcode = function () {
      if (skuMobileCtrl.settings.generate_weight_barcode) {
        // Префикс весового ШК
        skuMobileCtrl.weightBarcode = skuMobileCtrl.settings.weight_barcode_prefix;
        // Код весового ШК
        if (skuMobileCtrl.settings.weight_barcode_source == 'ITEM_CODE') {
          if (!skuMobileCtrl.sku.code || skuMobileCtrl.sku.code.toString().length > skuMobileCtrl.settings.weight_barcode_code) {
            skuMobileCtrl.needWeightBarcode = false;
            return;
          }
          skuMobileCtrl.weightBarcode += skuMobileCtrl.genCodeForBarcode(skuMobileCtrl.settings.weight_barcode_code, skuMobileCtrl.sku.code);
        } else if (skuMobileCtrl.settings.weight_barcode_source == 'VENDOR_CODE') {
          if (!skuMobileCtrl.sku.vendor_code || skuMobileCtrl.sku.vendor_code.toString().length > skuMobileCtrl.settings.weight_barcode_code) {
            skuMobileCtrl.needWeightBarcode = false;
            return;
          }
          skuMobileCtrl.weightBarcode += skuMobileCtrl.genCodeForBarcode(skuMobileCtrl.settings.weight_barcode_code, skuMobileCtrl.sku.vendor_code);
        }
        // Вес весового ШК
        for (var i = 0; i < skuMobileCtrl.settings.weight_barcode_weight - 1; i++) {
          skuMobileCtrl.weightBarcode += '0';
        }
        skuMobileCtrl.weightBarcode += '1';
        // Контрольная сумма
        if (skuMobileCtrl.settings.weight_barcode_format == "EAN13") {
          var result = 0;
          var i;
          for (i = 0; i < 12; i += 2) {
            result += parseInt(skuMobileCtrl.weightBarcode[i]);
          }
          for (i = 1; i < 12; i += 2) {
            result += parseInt(skuMobileCtrl.weightBarcode[i]) * 3;
          }
          skuMobileCtrl.weightBarcode += (10 - (result % 10)) % 10;
        }
      }
    };

    function issetAttrVal (attr) {
      return _.find(skuMobileCtrl.sku.attribute_values, function (skuAttr) {
        return skuAttr.attribute.id == attr.id;
      });
    }

    skuMobileCtrl.calculNexStep = function () {
      categoryService.getCustomCategory($stateParams.parent).then(function (data) {
        if (data.data.cash_register_item_type) {
          skuMobileCtrl.sku.cash_register_item_type = data.data.cash_register_item_type;
        }
        skuMobileCtrl.isAttr = !!_.find(data.data.elements, function (element) {
          if (element.block && element.block.attributes.length) {
            return _.find(element.block.attributes, function (blockElement) {
             return blockElement.required || issetAttrVal(blockElement);
            });
          } else {
            return element.attribute.required || issetAttrVal(element.attribute);
          }
        });
      });
    }

    skuMobileCtrl.getSkuByGtin = function (gtin) {
      if (!gtin) return;

      catalogItemService.getElements(null, gtin).then(function (data) {
        if (!data.data.items[0]) return undefined;
        catalogItemService.getElementInfo(data.data.items[0].id, $stateParams.parent).then(function (res) {
          var oldCode = skuMobileCtrl.sku.code;
          var oldTaxGroup = skuMobileCtrl.sku.tax_group;
          skuMobileCtrl.sku = res.data;
          skuMobileCtrl.sku.category = {
            id : $stateParams.parent,
            name: $stateParams.parentname
          };
          skuMobileCtrl.sku.code = oldCode;
          skuMobileCtrl.sku.tax_group_selector = 'OWN';
          skuMobileCtrl.sku.stock_accounting_type = 'SIMPLE';
          skuMobileCtrl.sku.tax_mode_source = 'FROM_CASHREGISTER';
          skuMobileCtrl.sku.cash_register_item_type = 'GOODS';
          if (!skuMobileCtrl.sku.tax_group) {
            skuMobileCtrl.sku.tax_group = oldTaxGroup;
          }
          skuMobileCtrl.sku.id = undefined;
          skuMobileCtrl.sku.brand = undefined;
          skuMobileCtrl.sku.sub_brand = undefined;

          skuMobileCtrl.sku.sku_list[0].id = undefined;
          skuMobileCtrl.sku.sku_list[0].count = undefined;
          skuMobileCtrl.sku.sku_list[0].attributeValues = undefined;
          skuMobileCtrl.sku.sku_list[0].children = undefined;
          skuMobileCtrl.sku.sku_list[0].uom_original = undefined;
          skuMobileCtrl.sku.sku_list[0].packing_type = undefined;
          skuMobileCtrl.sku.sku_list[0].uom = defaultUom;

          if (!skuMobileCtrl.sku.sku_list[0].name) {
            skuMobileCtrl.sku.sku_list[0].name = "Единичная упаковка";
          }

          if (!skuMobileCtrl.sku.sku_list[0].pack_type) {
            skuMobileCtrl.sku.sku_list[0].pack_type = {
              id: "263d9664-93ef-4173-8ea8-eaadd0884706",
              name: "Единичная упаковка",
              active: true,
              ext_id: "PACK_BASE_UNIT",
              modified_manually: true
            };
          }

          if (!skuMobileCtrl.sku.sku_list[0].name) {
            skuMobileCtrl.sku.sku_list[0].name = "Единичная упаковка";
          }

          skuMobileCtrl.uniqueCheck(skuMobileCtrl.sku.name, 'name');
          skuMobileCtrl.uniqueCheck(skuMobileCtrl.sku.code, 'derivative_code_prefix');

        });
      }, function (error) {
        $state.go('catalogMobile.msku.mobileError', {message: (error.status == -1)? "Отсутствует подключение в интернету" : "Во время получения атрибутов произошла ошибка"});
      });
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('serviceMobileController', serviceMobileController);

  function serviceMobileController($scope, $state, $q,
                                    $stateParams,
                                    $timeout,
                                    service,
                                    cardHistory,
                                    categoryService,
                                    utilsService,
                                    settings,
                                    taxGroups,
                                    catalogService,
                                    taxModes,
                                    parentHierarchy) {
    var serviceMobileCtrl = this;
    serviceMobileCtrl.taxGroups = taxGroups; // справочник режимов налогообложения чека
    serviceMobileCtrl.params = $stateParams;
    serviceMobileCtrl.theme = $stateParams.theme || 'standard';
    serviceMobileCtrl.state = $state;
    serviceMobileCtrl.loading = false;
    serviceMobileCtrl.hasMarkedSKU = false;
    serviceMobileCtrl.isNew = !service;
    serviceMobileCtrl.catalogItemFromApi = angular.copy(service);

    // инит данных категории
    serviceMobileCtrl.service = service || {
      name: "",
      uom: {
        id: "4a639aa0-478a-49e4-80f7-2b7f159ea6aa",
        name : "Штука",
        symbols: "шт"
      },
      tax_group:{
        id: "9cda6b93-40c1-4ca3-95d8-0b11d33b7e78",
        name: "Без НДС"
      },
      category: {
        id : $stateParams.parent,
        name: $stateParams.parentname,
      },
      attribute_values: [],
      derivatives: [],
      tax_mode_source: "FROM_CASHREGISTER",
      cash_register_item_type: "SERVICE",
      tax_mode: null
    };

    if(!service && settings.use_auto_codes){
      catalogService.getCode().then(function(res){
        serviceMobileCtrl.service.code = res.data.code;
      });
    }

    if(!service && $stateParams.tax_group_id){
      serviceMobileCtrl.service.tax_group = _.find(serviceMobileCtrl.taxGroups, function (tax) {
        return tax.id == $stateParams.tax_group_id;
      });
    }

    //[ ALWAYS, CASHIER_DECISION, NEVER ]
    serviceMobileCtrl.parentConfig = {
      getData: categoryService.getDomainCategories,
      multiselect: false,
      chooseParent: true,
      title: "Товары и услуги",
      name: "parent",
      label: "Расположение услуги",
      required: true,
      treeView: true,
      parentHierarchy: parentHierarchy,
      hasChildren: function (item) {
        return item.has_children;
      }
    };

    serviceMobileCtrl.taxGroupConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Налог при реализации",
      name: "tax_group",
      label: "Налог при реализации",
      required: true,
      treeView: false,
      getData: function () {
        return $q.when({ data: serviceMobileCtrl.taxGroups })
      }
    };

    serviceMobileCtrl.uomConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Единица измерения",
      name: "uom",
      label: "Единица измерения",
      required: true,
      treeView: false,
      getData: catalogService.getUoms
    };


    serviceMobileCtrl.goBack = function () {
      var prev = cardHistory.popStep();
      if(prev && prev.name){
        $state.go(prev.name, prev.param);
      }else{
        $state.go('catalogMobile', { parent: undefined, parentname: undefined });
      }
    };

    /**
     * Проверка уникальности имени услуги, кода, и дериватива
     */
    serviceMobileCtrl.uniqueCheck = function (str, fieldName) {
      if(str){
        var constraintName = '';
        switch(fieldName){
          case 'name':
            constraintName = 'DOMAIN_SERVICE_NAME';
          break;
          case 'derivative_code_prefix':
            constraintName = 'DOMAIN_SERVICE_CODE_PREFIX';
          break;
          default:
            constraintName = 'DOMAIN_SERVICE_DERIVATIVE';
        }
        var obj = {
          "constraint_name": constraintName,
          "parameters": [
            {
              "name": fieldName,
              "value": str
            }
          ]
        };
        if(serviceMobileCtrl.service.id) obj.id = serviceMobileCtrl.service.id;
        utilsService.uniqueCheck(obj).then(function(res){},
        function (error) {
          if(error.status == 409 && error.data.code == 'non_unique'){
            _.forEach(error.data.parameters, function (formError) {
              if (serviceMobileCtrl.serviceForm[formError.name]) {
                serviceMobileCtrl.serviceForm[formError.name].$setValidity('unique', false);
              }
            });
          } else {
            $state.go('catalogMobile.mservice.mobileError', {message: (error.status == -1)? "Отсутствует подключение в интернету" : "Во время проверки уникальности произошла ошибка"});
          }
        });
      }
    };

    function issetAttrVal (attr) {
      return _.find(serviceMobileCtrl.service.attribute_values, function (seviceAttr) {
        return seviceAttr.attribute.id == attr.id;
      });
    }

    serviceMobileCtrl.calculNexStep = function () {
      categoryService.getCustomCategory($stateParams.parent).then(function (data) {
        serviceMobileCtrl.isAttr = !!_.find(data.data.elements, function (element) {
          if (element.block && element.block.attributes.length) {
            return _.find(element.block.attributes, function (blockElement) {
             return blockElement.required || issetAttrVal(blockElement);
            });
          } else {
            return element.attribute.required || issetAttrVal(element.attribute);
          }
        });
      }, function (error) {
        $state.go('catalogMobile.mservice.mobileError', {message: (error.status == -1)? "Отсутствует подключение в интернету" : "Во время получения атрибутов произошла ошибка"});
      });
    }


  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('searchCatalogController', searchCatalogController);

  function searchCatalogController($scope, $state, $stateParams, catalogService, $timeout) {
    var searchCatalogCtrl = this;
    var categories, catalogItems;
    searchCatalogCtrl.params = $stateParams;
    searchCatalogCtrl.theme = $stateParams.theme || 'standard';
    searchCatalogCtrl.state = $state;
    searchCatalogCtrl.searchLoading = true;
    searchCatalogCtrl.getAbbreviation = $scope.$parent.catalogMobileCtrl.getAbbreviation;
    
    searchCatalogCtrl.chooseSearchData = function (item) {
      searchCatalogCtrl.searchActive = false;
      var pathData = (item.type && item.type != "CATEGORY" && item.parentList.length)? item.parentList[item.parentList.length - 1] : item;
      $state.go("catalogMobile", {parent: pathData.id, parentname: pathData.name, choosen: item.id});
    }

    searchCatalogCtrl.searchCallback = function (search) {
      if (!search) return;
      searchCatalogCtrl.searchLoading = true;
      catalogService.searchCatalogElements(search, {offset: 0, limit: 100}).then(function (res) {
        var categories = _.filter(res.data.items, function (item) {
          return item.type == "CATEGORY";
        }).sort(function (a, b) {
          return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : 0;
        });
        var items = _.filter(res.data.items, function (item) {
          return item.type !== "CATEGORY";
        }).sort(function (a, b) {
          return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : 0;
        });
        searchCatalogCtrl.searchData = categories.concat(items);
        searchCatalogCtrl.searchLoading = false;
        searchCatalogCtrl.class = "animate";
        searchCatalogCtrl.searchActive = true;
      });
    }

    if (searchCatalogCtrl.params && searchCatalogCtrl.params.request) {
      searchCatalogCtrl.searchCallback(searchCatalogCtrl.params.request);
    } else {
      searchCatalogCtrl.searchLoading = false;
    }


  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('scangtinController', scangtinController);

  function scangtinController($state, $scope, $stateParams, cardHistory, focus, $timeout) {
    var scangtinCtrl = this;
    var previousPage = {};
    var previousParams = {};
    scangtinCtrl.params = $stateParams;
    scangtinCtrl.theme = $stateParams.theme || 'standard';
    scangtinCtrl.scanBuffer = '';
    
    scangtinCtrl.goBack = function () {
      var prev = cardHistory.popStep();
      if(prev){
        $state.go(prev.name || 'catalogMobile', prev.param);
      }else{
        $state.go(previousPage.name || 'catalogMobile', previousParams);
      }
    }

    scangtinCtrl.goToSku = function () {
      scangtinCtrl.params.gtin = scangtinCtrl.gtin;
      $state.go('catalogMobile.msku', scangtinCtrl.params);
    }

    /**
     * Метод принимает вводимую информацию от сканера.
     * моментом аппрува введенных данных является либо превышение
     * таймаута с последнего события, либо энтер.
     *
     * @param keyEvent событие клвавиатуры
     */
    scangtinCtrl.applyScannerKeys = function(keyEvent) {
      // оставнока таймера, т.к. ввод продолжен
      $timeout.cancel(scangtinCtrl.scanTimer);
      if (keyEvent.keyCode == 13) {
        scangtinCtrl.gtin = scangtinCtrl.scanBuffer;
        scangtinCtrl.scanBuffer = '';
        scangtinCtrl.goToSku();
      } else {
        var charFromEvent = undefined;
        if (keyEvent.originalEvent.code.startsWith('Digit')) {
          charFromEvent = keyEvent.key;
        }
        if (keyEvent.originalEvent.code.startsWith('Key')) {
          charFromEvent = keyEvent.shiftKey ? keyEvent.originalEvent.code.charAt(3) : keyEvent.originalEvent.code.charAt(3).toLowerCase();
        }
        if (!/[0-9]{1}/.test(charFromEvent)) {
          // допустимы только числа
          scangtinCtrl.scanBuffer = ''; // сброс аккумулятора из-за ошибки
          return;
        }
        if (charFromEvent !== undefined && charFromEvent !== null) {
          scangtinCtrl.scanBuffer += charFromEvent;
        }
      }
    };

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('mrecoverController', mrecoverController);

  function mrecoverController($scope, $state, $stateParams, cardHistory, catalogItemService) {
    var mrecoverCtrl = this;
    mrecoverCtrl.params = $stateParams;
    mrecoverCtrl.loading = false;
    mrecoverCtrl.isArchived = $stateParams.isarchived;
    mrecoverCtrl.theme = $stateParams.theme || 'standard';
    
    mrecoverCtrl.choosenItem = $scope.$parent.catalogMobileCtrl.choosenItem;

    mrecoverCtrl.goBack = function () {
      var prev = cardHistory.popStep();
      $stateParams.choosen = $stateParams.parent;
      if(prev){
        $state.go(prev.name || 'catalogMobile', prev.param);
      }else{
        $state.go('catalogMobile', $stateParams);
      }
    }

    mrecoverCtrl.action = function () {
      mrecoverCtrl.loading = true;
      var status = (mrecoverCtrl.isArchived)? "ARCHIVED" : "CONFIRMED";
      if (mrecoverCtrl.choosenItem.type == "SERVICE") {
        catalogItemService.changeServiceStatus(mrecoverCtrl.choosenItem.id, status).then(function(){
          $scope.$parent.catalogMobileCtrl.choosenItem.status = status;
          mrecoverCtrl.goBack();
          mrecoverCtrl.loading = false;
        }, function (error) {
          var params = $stateParams;
          params.message = "Во время смены статуса произошла ошибка";
          $state.go('mobileError', params);
        });
      } else {
        catalogItemService.changeSkuStatus(mrecoverCtrl.choosenItem.id, status).then(function(){
          $scope.$parent.catalogMobileCtrl.choosenItem.status = status;
          mrecoverCtrl.goBack();
          mrecoverCtrl.loading = false;
        }, function (error) {
          var params = $stateParams;
          params.message = "Во время смены статуса произошла ошибка";
          $state.go('mobileError', params);
        });
      }
    }


  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('catalogItemPriceMobileController', catalogItemPriceMobileController);

  function catalogItemPriceMobileController($scope, $state, $q,
                                    $stateParams,
                                    $timeout,
                                    columns,
                                    $rootScope,
                                    cardHistory,
                                    catalogService,
                                    catalogItemService,
                                    categoryService) {
    var catalogItemPriceMobileCtrl = this;
    catalogItemPriceMobileCtrl.loading = true;
    catalogItemPriceMobileCtrl.columnsLen = columns.length;
    if ($scope.$parent.$parent.serviceMobileCtrl) {
      catalogItemPriceMobileCtrl.catalogItem = $scope.$parent.$parent.serviceMobileCtrl.service;
    } else if ($scope.$parent.$parent.skuMobileCtrl) {
      catalogItemPriceMobileCtrl.catalogItem = $scope.$parent.$parent.skuMobileCtrl.sku;
    }

    var filtersForPrice = {
      filter_divisions_id: $stateParams.division_id,
      time_zone: $stateParams.timezone,
      filter_column_type: "RETAIL"
    };

    // метод сделан, чтобы время не обрезалось,т.к. тут важно знать время пользователя
    // если использовать moment() с valueOf() без распарсивания строки,
    // то время обрезается вне зависимоти от указанной таймзоны
    var getCorrectTimestamp = function(){
      var dateInTz = moment().utc().tz($stateParams.timezone || 'UTC'); // узнать правильную дату пользователя в зависимоти от таймзоны
      var dateWithoutTime = dateInTz.set({hour:0,minute:0,second:0,millisecond:0}); // сбросить время на 00:00:00
      var parseDate = dateWithoutTime.toString().split(' '); // распарсить строку, чтобы обрезать GMT
      parseDate.pop(); // обрезаем GMT
      var returnDate = moment(parseDate.join(" "));
      var tzOffset = moment.parseZone(new Date()).utcOffset()/60; // смещение таймзоны компьютера
      returnDate.add(tzOffset, 'hours');
      return returnDate.valueOf(); // формируем правильный timestamp
    }

    catalogItemPriceMobileCtrl.init = function () {
      categoryService.getItemsWithPrice($stateParams.parent, filtersForPrice).then(function (res) {
        var priceObj = _.find(res.data.items, function (catalogItem) {
          return catalogItemPriceMobileCtrl.catalogItem.id == catalogItem.id;
        });
        catalogItemPriceMobileCtrl.currency = $rootScope.homeCurrency.currency;
        if (!priceObj || !priceObj.price) {
          catalogItemPriceMobileCtrl.catalogItem.price_detail = {
            effective_qty: 1
          };
          catalogItemPriceMobileCtrl.catalogItem.price_detail.price_type = { id: false, name: "Указанная" };
          if ($stateParams.timezone) {
            catalogItemPriceMobileCtrl.catalogItem.price_detail.effective_date = getCorrectTimestamp();
          } else {
            catalogItemPriceMobileCtrl.catalogItem.price_detail.effective_date = moment.utc().set({hour:0,minute:0,second:0,millisecond:0}).valueOf();
          }
        } else {
          catalogItemPriceMobileCtrl.catalogItem.price_detail = {
            price_for_one_uom: priceObj.price.price_for_one_uom,
            effective_date: priceObj.price.effective_date,
            effective_qty: priceObj.price.effective_qty,
            column: priceObj.price.column,
            price_type: {
              id: priceObj.price.free_of_control_price,
              name: priceObj.price.free_of_control_price? "Свободная" : "Указанная"
            }
          }
        }

      // подсктановка колонки, если она одна
      if (catalogItemPriceMobileCtrl.columnsLen == 1) {
        catalogItemPriceMobileCtrl.catalogItem.price_detail.column = columns[0];
        catalogItemPriceMobileCtrl.getPrice();
      }

        catalogItemPriceMobileCtrl.loading = false;

        // подсктановка колонки, если она одна
        if (catalogItemPriceMobileCtrl.columnsLen == 1) {
          catalogItemPriceMobileCtrl.catalogItem.price_detail.column = columns[0];
          catalogItemPriceMobileCtrl.getPrice();
        }
      });
    }


    // чистка мусора в штрихкоде
    catalogItemPriceMobileCtrl.isSku = !!($state.current.name.indexOf("sku") + 1);
    if (catalogItemPriceMobileCtrl.isSku &&
        catalogItemPriceMobileCtrl.catalogItem.sku_list &&
        catalogItemPriceMobileCtrl.catalogItem.sku_list[0].gtin_list &&
        catalogItemPriceMobileCtrl.catalogItem.sku_list[0].gtin_list[0] &&
        !catalogItemPriceMobileCtrl.catalogItem.sku_list[0].gtin_list[0].gtin) {
      catalogItemPriceMobileCtrl.catalogItem.sku_list[0].gtin_list = undefined;
    }

    if (!catalogItemPriceMobileCtrl.catalogItem.name || !catalogItemPriceMobileCtrl.catalogItem.code) {
      $state.go(catalogItemPriceMobileCtrl.isSku? 'msku' : 'mservice', $stateParams);
    }

    catalogItemPriceMobileCtrl.goBack = function (isSave) {
      if (!isSave) {
        // сохранение данных по цене
        catalogItemPriceMobileCtrl.catalogItem.price_detail.free_of_control_price = catalogItemPriceMobileCtrl.catalogItem.price_detail.price_type.id;
        catalogItemPriceMobileCtrl.catalogItem.price_detail.price_type = undefined;

        if ($scope.$parent.$parent.serviceMobileCtrl) {
          $scope.$parent.$parent.serviceMobileCtrl.service = catalogItemPriceMobileCtrl.catalogItem;
        } else if ($scope.$parent.$parent.skuMobileCtrl) {
          $scope.$parent.$parent.skuMobileCtrl.sku = catalogItemPriceMobileCtrl.catalogItem;
        }
      }

      if (isSave) {
        var isAttr = ($scope.$parent.$parent.skuMobileCtrl)? $scope.$parent.$parent.skuMobileCtrl.isAttr : $scope.$parent.$parent.serviceMobileCtrl.isAttr;
        if (isAttr) {
          cardHistory.deleteLastStep();
        }
        if (catalogItemPriceMobileCtrl.isSku && !$stateParams.id) {
          cardHistory.deleteLastStep();
        }
        if (!$stateParams.id) {
          cardHistory.deleteLastStep();
        }
        cardHistory.deleteLastStep();
      }
      var prev = cardHistory.popStep();
      if(prev && prev.name){
        $state.go(prev.name, prev.param);
      }else{
        $state.go('catalogMobile', { parent: undefined, parentname: undefined });
      }
    }

    catalogItemPriceMobileCtrl.columnsConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Колонка цен",
      name: "column",
      label: "Колонка цен",
      required: true,
      treeView: false,
      getData: function () {
        return $q.when({ data: columns });
      }
    };

    catalogItemPriceMobileCtrl.priceTypeConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Тип цены",
      name: "price_type",
      label: "Тип цены",
      required: true,
      treeView: false,
      getData: function () {
        return $q.when({ data: [{
          id: false,
          name: "Указанная"
        }, {
          id: true,
          name: "Свободная"
        }] });
      }
    };



    // сохранение товаров и услуг
    catalogItemPriceMobileCtrl.save = function () {
      catalogItemPriceMobileCtrl.loading = true;
      catalogItemPriceMobileCtrl.catalogItem.brand = undefined;
      catalogItemPriceMobileCtrl.catalogItem.sub_brand = undefined;

      if (catalogItemPriceMobileCtrl.isSku) {
        catalogItemPriceMobileCtrl.catalogItem.sku_list[0].count = undefined;
        catalogItemPriceMobileCtrl.catalogItem.sku_list[0].attributeValues = undefined;
        catalogItemPriceMobileCtrl.catalogItem.sku_list[0].children = undefined;
        catalogItemPriceMobileCtrl.catalogItem.sku_list[0].uom_original = undefined;
        catalogItemPriceMobileCtrl.catalogItem.sku_list[0].packing_type = undefined;
      }

      catalogItemPriceMobileCtrl.catalogItem.price_detail.column = {
        id: catalogItemPriceMobileCtrl.catalogItem.price_detail.column.id,
        name: catalogItemPriceMobileCtrl.catalogItem.price_detail.column.name
      };
      catalogItemPriceMobileCtrl.catalogItem.price_detail.free_of_control_price = catalogItemPriceMobileCtrl.catalogItem.price_detail.price_type.id || false;
      catalogItemPriceMobileCtrl.catalogItem.price_detail.price_type = undefined;
      // если не указана цена
      if (!catalogItemPriceMobileCtrl.catalogItem.price_detail.price_for_one_uom) {
        catalogItemPriceMobileCtrl.catalogItem.price_detail.price_for_one_uom = 0;
      }
      // если есть таймзона, то применить её к полю "дата начала действия цены"
      if (catalogItemPriceMobileCtrl.priceForm.$dirty && $stateParams.timezone) {
        catalogItemPriceMobileCtrl.catalogItem.price_detail.effective_date = getCorrectTimestamp();
      }
      // если товар
      if (catalogItemPriceMobileCtrl.isSku) {
        if(catalogItemPriceMobileCtrl.catalogItem.id){
          catalogItemService.updateSkus(catalogItemPriceMobileCtrl.catalogItem).then(function(res){
            catalogItemPriceMobileCtrl.goBack(true);
            catalogItemPriceMobileCtrl.loading = false;
          }, function (error) {
            catalogItemPriceMobileCtrl.loading = false;
            if (error.data.code == "business_error" && error.data.message == "impossible_to_modify_there_are_documents") {
              $state.go('catalogMobile.msku.mobileError', {message: "Изменение невозможно, так как по данному товару были созданы документы", hide_try_later: true});
            } else {
              $state.go('catalogMobile.msku.mobileError', {message: "Во время обновления товара произошла ошибка"});
            }
          });
        }else{
          catalogItemPriceMobileCtrl.catalogItem.sku_list[0].derivatives = [{code: catalogItemPriceMobileCtrl.catalogItem.code}];
          catalogItemService.createSkus(catalogItemPriceMobileCtrl.catalogItem).then(function(res){
            catalogItemPriceMobileCtrl.goBack(true);
            catalogItemPriceMobileCtrl.loading = false;
          }, function (error) {
            catalogItemPriceMobileCtrl.loading = false;
            $state.go('catalogMobile.msku.mobileError', {message: "Во время создания товара произошла ошибка"});
          });
        }
      } else {
      // если услуга
        if(catalogItemPriceMobileCtrl.catalogItem.id){
          catalogItemService.updateService(catalogItemPriceMobileCtrl.catalogItem).then(function(res){
            catalogItemPriceMobileCtrl.goBack(true);
            catalogItemPriceMobileCtrl.loading = false;
          }, function (error) {
            catalogItemPriceMobileCtrl.loading = false;
            if (error.data.code == "business_error" && error.data.message == "impossible_to_modify_there_are_documents") {
              $state.go('catalogMobile.msku.mobileError', {message: "Изменение невозможно, так как по данной услуге были созданы документы", hide_try_later: true});
            } else {
              $state.go('catalogMobile.msku.mobileError', {message: "Во время обновления товара произошла ошибка"});
            }
          });
        }else{
          catalogItemPriceMobileCtrl.catalogItem.derivatives = [{code: catalogItemPriceMobileCtrl.catalogItem.code}];
          catalogItemService.createService(catalogItemPriceMobileCtrl.catalogItem).then(function(res){
            catalogItemPriceMobileCtrl.goBack(true);
            catalogItemPriceMobileCtrl.loading = false;
          }, function (error) {
            catalogItemPriceMobileCtrl.loading = false;
            $state.go('catalogMobile.mservice.mobileError', {message: "Во время создания услуги произошла ошибка"});
          });
        }
      }
    };


    /* работа с ценами */
    catalogItemPriceMobileCtrl.getPrice = function () {
      if (catalogItemPriceMobileCtrl.catalogItem.price_detail.column &&
          catalogItemPriceMobileCtrl.catalogItem.id) {

          var userNow = moment.utc().tz($stateParams.timezone || 'UTC');
          catalogService.getCatalogItemPrices(catalogItemPriceMobileCtrl.catalogItem.id).then(function (res) {
            var columnData = _.find(res.data.price_lists[0].columns, function (column) {
              return column.id == catalogItemPriceMobileCtrl.catalogItem.price_detail.column.id;
            });
            if (columnData && columnData.prices.length) {
              var userKey;
              _.forEach(columnData.prices, function (priceObj, key) {
                if (moment(priceObj.effective_date).isBefore(userNow) &&
                   (userKey === undefined ||
                    moment(columnData.prices[userKey].effective_date).isBefore(moment(priceObj.effective_date)))){
                  userKey = key;
                }
              });
              if (userKey !== undefined) {
                catalogItemPriceMobileCtrl.catalogItem.price_detail.price_for_one_uom = columnData.prices[userKey].price_for_one_uom;
              }
            }
          });
      }
    }

    catalogItemPriceMobileCtrl.init();

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('deleteCatalogItemController', deleteCatalogItemController);

  function deleteCatalogItemController($state, $stateParams, $scope, cardHistory, catalogItemService, categoryService) {
    var deleteCatalogItemCtrl = this;
    deleteCatalogItemCtrl.loading = false;
    deleteCatalogItemCtrl.params = $stateParams;
    deleteCatalogItemCtrl.theme = $stateParams.theme || 'standard';
    var previousPage = {};
    var previousParams = {};

    $scope.$on('$stateChangeSuccess', function (ev, to, toParams, prev, prevParams) {
      previousPage = prev;
      previousParams = prevParams;
    });

    deleteCatalogItemCtrl.goBack = function () {
      var prev = cardHistory.popStep();
      if(prev){
        $state.go(prev.name || 'catalogMobile', prev.param);
      }else{
        $state.go(previousPage.name || 'catalogMobile', previousParams);
      }
    }

    deleteCatalogItemCtrl.delete = function () {
      deleteCatalogItemCtrl.loading = true;
      if (!deleteCatalogItemCtrl.params.type || deleteCatalogItemCtrl.params.type == "CATEGORY") {
        categoryService.deleteCategory(deleteCatalogItemCtrl.params.parent).then(function(){
          cardHistory.deleteLastStep();
          deleteCatalogItemCtrl.goBack();
          deleteCatalogItemCtrl.loading = false;
        }, function (error) {
          var params = $stateParams;
          params.message = (error.status == -1)? "Отсутствует подключение в интернету" : "Во время удаления категории произошла ошибка";
          $state.go('mobileError', params);
        });
      } else if (deleteCatalogItemCtrl.params.type == "SKU") {
        catalogItemService.deleteSkus(deleteCatalogItemCtrl.params.parent).then(function(){
          deleteCatalogItemCtrl.goBack();
          deleteCatalogItemCtrl.loading = false;
        }, function (error) {
          var params = $stateParams;
          params.message = (error.status == -1)? "Отсутствует подключение в интернету" : "Во время удаления товара произошла ошибка";
          $state.go('mobileError', params);
        });
      } else {
        catalogItemService.deleteService(deleteCatalogItemCtrl.params.parent).then(function(){
          deleteCatalogItemCtrl.goBack();
          deleteCatalogItemCtrl.loading = false;
        }, function (error) {
          var params = $stateParams;
          params.message = (error.status == -1)? "Отсутствует подключение в интернету" : "Во время удаления услуги произошла ошибка";
          $state.go('mobileError', params);
        });
      }
    };



  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('createCatalogRouteController', createCatalogRouteController);

  function createCatalogRouteController($state, $scope, $stateParams, cardHistory) {
    var createCatalogRouteCtrl = this;
    var previousPage = {};
    var previousParams = {};
    createCatalogRouteCtrl.params = $stateParams
    createCatalogRouteCtrl.theme = $stateParams.theme || 'standard';

    $scope.$on('$stateChangeSuccess', function (ev, to, toParams, prev, prevParams) {
      previousPage = prev;
      previousParams = prevParams;
    });

    createCatalogRouteCtrl.goBack = function () {
      var prev = cardHistory.popStep();
      if(prev){
        $state.go(prev.name || 'catalogMobile', prev.param);
      }else{
        $state.go(previousPage.name || 'catalogMobile', previousParams);
      }
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('categoryMobileController', categoryMobileController);

  function categoryMobileController($scope, $state, $q, 
                                    $stateParams, 
                                    $timeout, 
                                    category, 
                                    cardHistory, 
                                    categoryService, 
                                    utilsService,
                                    parentHierarchy) {
    var categoryMobileCtrl = this;
    categoryMobileCtrl.params = $stateParams;
    categoryMobileCtrl.theme = $stateParams.theme || 'standard';
    categoryMobileCtrl.state = $state;
    categoryMobileCtrl.loading = false;
    categoryMobileCtrl.hasMarkedSKU = false;
    
    // инит данных категории
    if (category) {
      categoryMobileCtrl.category = category;
      if (category.scan_mark_type && category.product_group) {
        categoryMobileCtrl.hasMarkedSKU = true;
      }
      if (!categoryMobileCtrl.category.cash_register_item_type) {
        categoryMobileCtrl.category.cash_register_item_type = 'GOODS';
      }
    } else {
      categoryMobileCtrl.isNew = true;
      categoryMobileCtrl.category = {
        scan_mark_type: "CASHIER_DECISION",
        cash_register_item_type: "GOODS"
      };

      if (categoryMobileCtrl.params.parent && categoryMobileCtrl.params.parentname) {
        categoryMobileCtrl.category.parent = {
          id: categoryMobileCtrl.params.parent,
          name: categoryMobileCtrl.params.parentname
        }
      }
    }

    //[ ALWAYS, CASHIER_DECISION, NEVER ]
    categoryMobileCtrl.parentConfig = {
      disabled: !!category,
      getData: categoryService.getDomainCategories,
      multiselect: false,
      chooseParent: true,
      title: "Товары и услуги",
      name: "parent",
      label: "Расположение категории",
      required: false,
      treeView: true,
      parentHierarchy: parentHierarchy,
      default: {
        id: "",
        name : "Каталог товаров и услуг"
      },
      hasChildren: function (item) {
        return item.has_children;
      }
    };

    categoryMobileCtrl.cashRegisterConfig = {
      disabled: !!category,
      getData: categoryService.cashRegisterItemTypes,
      multiselect: false,
      chooseParent: false,
      title: "Предмет расчета по умолчанию",
      name: "cash_register_item_type",
      label: "Предмет расчета по умолчанию",
      required: true,
      treeView: false,
      saveAs: 'value',
      default: {
        value: "GOODS",
        label : "Товар"
      }
    };

    categoryMobileCtrl.productGroupConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Маркируемая продукция",
      name: "product_group",
      label: "Маркируемая продукция",
      required: true,
      treeView: false,
      getData: categoryService.getProductGroup
    };

    categoryMobileCtrl.scanMarkConfig = {
      multiselect: false,
      chooseParent: true,
      title: "Сканировать марку",
      name: "scan_mark_type",
      label: "Сканировать марку",
      required: true,
      treeView: false,
      saveAs: 'id',
      getData: function () {
        return $q.when({
          data: [{
            id: "ALWAYS",
            name: "Всегда"
          }, {
            id: "CASHIER_DECISION",
            name: "На усмотрение кассира"
          }, {
            id: "PERMISSIVE_MODE",
            name: "Разрешительный режим"
          }]
        })
      }
    };

    categoryMobileCtrl.hasMarkedChange = function () {
      if (categoryMobileCtrl.hasMarkedSKU && (!categoryMobileCtrl.category.scan_mark_type || categoryMobileCtrl.category.scan_mark_type == "NEVER")) {
        categoryMobileCtrl.category.scan_mark_type = "CASHIER_DECISION";
      }
    }

    categoryMobileCtrl.goBack = function (changeName) {
      var prev = cardHistory.popStep();
      if(prev && prev.name){
        if (changeName) {
          prev.param.parentname = categoryMobileCtrl.category.name;
        }
        $state.go(prev.name, prev.param);
      }else{
        $state.go('catalogMobile', { parent: undefined, parentname: undefined });
      }
    }

    /**
     * Проверка уникальности имени категории
     */
    categoryMobileCtrl.uniqueCheck = function(str){
      if(str){
        var obj = {
          "constraint_name": "DOMAIN_CATEGORY_NAME",
          "parameters": [
            {
              "name": "name",
              "value": str
            }
          ]
        }
        if(categoryMobileCtrl.category.id) obj.id = categoryMobileCtrl.category.id;
        utilsService.uniqueCheck(obj).then(function(res){},
        function (error) {
          if(error.status == 409 && error.data.code == 'non_unique'){
            angular.forEach(error.data.parameters, function(field){
              categoryMobileCtrl.categoryForm[field.name].$setValidity('unique', false);
            });
          }
        });
      }
    }

    categoryMobileCtrl.save = function(){
      categoryMobileCtrl.loading = true;
      var data = angular.copy(categoryMobileCtrl.category);

      if (!categoryMobileCtrl.hasMarkedSKU) {
        data.scan_mark_type = "NEVER";
        data.product_group = undefined;
      }

      if (!data.parent || !data.parent.id) {
        data.parent = null;
      }
      if (category) {
        // Блок обновления
        return categoryService.updateCategory(data).then(function(res){
          // Переход на предыдущую страницу
          categoryMobileCtrl.goBack(true);
          categoryMobileCtrl.loading = false;
        }, function (error) {
          if(error.status == 409 && (error.data.code == 'non_unique' || error.data.code == 'business_rule')){
            categoryMobileCtrl.categoryForm.name.$setValidity('unique', false);
          }else{
            $state.go('catalogMobile.category.mobileError', {message: "В процессе обновления категории произошла ошибка"});
          }
          categoryMobileCtrl.loading = false;
        })
      }else{
        // Блок создания
        return categoryService.saveCategory(data).then(function(res){
          // Переход на предыдущую страницу
          cardHistory.deleteLastStep();
          categoryMobileCtrl.goBack();
          categoryMobileCtrl.loading = false;
        },
        function (error) {
          if(error.status === 409 && (error.data.code === 'non_unique' || error.data.code === 'business_rule')){
            categoryMobileCtrl.categoryForm.name.$setValidity('unique', false);
          } else if (error.status === 409 && error.data.code === 'exceeded_maximum_number_of_categories') {
            $state.go('catalogMobile.category.mobileError', {message: "Невозможно создать новую категорию. Превышено максимальное количество категорий на одном уровне."});
          }else{
            $state.go('catalogMobile.category.mobileError', {message: "Во время сохранения категории произошла ошибка"});
          }
          categoryMobileCtrl.loading = false;
        })
      }
    };




  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('catalogItemAttrMobileController', catalogItemAttrMobileController);

  function catalogItemAttrMobileController($scope, $state, $q, 
                                    $stateParams, 
                                    $timeout, 
                                    categoryElements,
                                    cardHistory) {
    var catalogItemAttrMobileCtrl = this;
    catalogItemAttrMobileCtrl.loading = true;
    catalogItemAttrMobileCtrl.isSku = !!($state.current.name.indexOf("sku") + 1);
    if ($scope.$parent.$parent.serviceMobileCtrl) {
      catalogItemAttrMobileCtrl.parentCtrl = $scope.$parent.$parent.serviceMobileCtrl;
      catalogItemAttrMobileCtrl.catalogItem = $scope.$parent.$parent.serviceMobileCtrl.service;
    } else if ($scope.$parent.$parent.skuMobileCtrl) {
      catalogItemAttrMobileCtrl.parentCtrl = $scope.$parent.$parent.skuMobileCtrl;
      catalogItemAttrMobileCtrl.catalogItem = $scope.$parent.$parent.skuMobileCtrl.sku;
    }

    if (!catalogItemAttrMobileCtrl.catalogItem.name || !catalogItemAttrMobileCtrl.catalogItem.code) {
      $state.go("catalogMobile." + (catalogItemAttrMobileCtrl.isSku? 'msku' : 'mservice'), $stateParams);
    }

    // создание мапинга для сохранения атрибутов
    /* получение необходимой структуры значений */
    catalogItemAttrMobileCtrl.attribValues = {}; /* Кэш значений атрибутов */

    /* Установка значений атрибутов в модель */
    if (catalogItemAttrMobileCtrl.parentCtrl.catalogItemFromApi && catalogItemAttrMobileCtrl.parentCtrl.catalogItemFromApi.attribute_values.length) { // Только при редактировании (при создании нечего маппить)
      angular.forEach(catalogItemAttrMobileCtrl.parentCtrl.catalogItemFromApi.attribute_values, function (attributeValue) {
        if (attributeValue.value !== undefined) {
          delete attributeValue.values;
          if (!catalogItemAttrMobileCtrl.attribValues[attributeValue.attribute.name]) catalogItemAttrMobileCtrl.attribValues[attributeValue.attribute.name] = attributeValue;
          if (!catalogItemAttrMobileCtrl.attribValues[attributeValue.attribute.name].values)catalogItemAttrMobileCtrl.attribValues[attributeValue.attribute.name].values = [];
          if (attributeValue.dict_value){
            catalogItemAttrMobileCtrl.attribValues[attributeValue.attribute.name].values.push(attributeValue.dict_value);
          } else {
            catalogItemAttrMobileCtrl.attribValues[attributeValue.attribute.name].values.push(attributeValue.value);
          }
        }
      });
    }

    catalogItemAttrMobileCtrl.attributesFields = [];
    _.forEach(categoryElements, function (element) {
      if (element.block && element.block.attributes.length) {
        element.block.attributes = _.forEach(element.block.attributes, function (blockElement) {
         if (blockElement.required || (catalogItemAttrMobileCtrl.attribValues[blockElement.name] && catalogItemAttrMobileCtrl.attribValues[blockElement.name].values.length == 1)) {
            catalogItemAttrMobileCtrl.attributesFields.push(blockElement);
          }
        });
      } else {
        if (element.attribute.required || (catalogItemAttrMobileCtrl.attribValues[element.attribute.name] && catalogItemAttrMobileCtrl.attribValues[element.attribute.name].values.length == 1)) {
          catalogItemAttrMobileCtrl.attributesFields.push(element.attribute);
        }
      }
    });
    catalogItemAttrMobileCtrl.loading = false;

    if (!catalogItemAttrMobileCtrl.attributesFields.length) {
      $state.go("catalogMobile." + (catalogItemAttrMobileCtrl.isSku? 'msku.price' : 'mservice.price'), $stateParams);
    }

    catalogItemAttrMobileCtrl.goBack = function () {
      catalogItemAttrMobileCtrl.catalogItem.attribute_values = _.forEach(catalogItemAttrMobileCtrl.catalogItem.attribute_values, function (attr, key) {
        if (attr.values && attr.values.length) {
          if (attr.attribute.data_type == 'DATE' || attr.attribute.data_type == 'DATE_TIME') {
            attr.value = attr.values[0].stamp;
          } else if (attr.attribute.data_type == 'DICTIONARY') {
            attr.dict_value = attr.values[0];
            attr.value = attr.values[0].id;
          } else {
            if (attr.values[0].id && attr.values[0].value) {
              attr.value = attr.values[0].id;
            } else {
              attr.value = attr.values[0];
            }
          }
        }
      });

      var prev = cardHistory.popStep();
      if(prev && prev.name){
        $state.go(prev.name, prev.param);
      }else{
        $state.go('catalogMobile', { parent: undefined, parentname: undefined });
      }
    }



    catalogItemAttrMobileCtrl.save = function (isBack) {
      catalogItemAttrMobileCtrl.loading = true;
      catalogItemAttrMobileCtrl.catalogItem.attribute_values = _.map(catalogItemAttrMobileCtrl.attribValues, function (attr, key) {
        if (attr.values && attr.values.length) {
          if (attr.attribute.data_type == 'DATE' || attr.attribute.data_type == 'DATE_TIME') {
            attr.value = attr.values[0].stamp;
          } else if (attr.attribute.data_type == 'DICTIONARY') {
            attr.dict_value = attr.values[0];
            attr.value = attr.values[0].id;
          } else {
            if (attr.values[0].id && attr.values[0].value) {
              attr.value = attr.values[0].id;
            } else {
              attr.value = attr.values[0];
            }
          }
          attr.values = undefined;
        }
        return (attr.value === '' || attr.value === undefined)? false : attr;
      });
      catalogItemAttrMobileCtrl.catalogItem.attribute_values = _.filter(catalogItemAttrMobileCtrl.catalogItem.attribute_values, function (attr) {
        return attr;
      });
      $state.go("catalogMobile." + (catalogItemAttrMobileCtrl.isSku? 'msku.price' : 'mservice.price'), $stateParams);
    };

  }

})();

(function() {
  'use strict';

  /* Компонент для работы с произвольным докуентом в системе на основе метаинформации */
  angular
    .module('frontend')
    .directive('survey', survey);

  function survey() {
    return {
      restrict: 'E',
      scope: {
        values: '=', // единая для опроса карта значений
        survey: '<', // информация об опросе
        redact: '<?', // флаг редактирования
        callbackSend: '<?', // коллбек при выборе значения (для шагов с выбором)
        showHeader: '<?', // флаг отображения заголовка
        callbackClose: '<?' // обработка закрытия окна
      },
      bindToController: true,
      templateUrl: 'app/messages/components/survey/survey.html',
      controllerAs: 'surveyCtrl',
      link: function (scope, element, attrs, surveyCtrl) {
        // в линке, т.к. форма в контроллере еще не проинициализирована
        surveyCtrl.formValidation = surveyCtrl.surveyForm;
      },
      controller: function ($scope, $sce) {
        var surveyCtrl = this;
        // настройка отображения хедера по-умолчанию
        if (surveyCtrl.showHeader == undefined) {
          surveyCtrl.showHeader = false;
        }

        /**
         * Метод вызывается для установки значения в карту значений для типов шагов опроса,
         * для которых другие способы недоступны
         *
         * @param code код шага
         * @param value значение
         */
        surveyCtrl.setValue = function(code, value, event) {
          if (surveyCtrl.values) {
            surveyCtrl.values[code] = value;
          }
          surveyCtrl.callbackSend && surveyCtrl.callbackSend(code, value);
          surveyCtrl.callbackClose && surveyCtrl.callbackClose(true, event);
        };

        /**
         * Метод вызывается при изменении значений для вызова callback-ов
         * @param code
         */
        surveyCtrl.valueChange = function(code) {
          surveyCtrl.callbackSend && surveyCtrl.callbackSend(code, surveyCtrl.values[code]);
          surveyCtrl.callbackClose && surveyCtrl.callbackClose(true, event);
        };

        // хук на внешнее перестроение метаинформации документа
        $scope.$watch('surveyCtrl.survey', function (newVal) {
          if (surveyCtrl.survey) { // может быть не определен
            angular.forEach(surveyCtrl.survey.items, function (item) {
              item.messageSafe =
                $sce.trustAsHtml(item.message);
            });
          }
        });
      }
    }
  };
})();

'use strict';
angular.module('frontend').component('printStock', {
  templateUrl: 'app/inventory/stock/stock-print/stock-print.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'ctrl',
  controller: function ($scope, print, helpService, authToken, statusSrv, $timeout, API_URL, downloadSrv) {
    var ctrl = this;
    print.turnonInterceptorStatus();
    ctrl.format = { type: 'PDF' };

    ctrl.longRequest = {
      format: null,
      exec_id: null,
      crudState: helpService.getCrudStateStructure(),
      flags: {
        processStart: false,
        finish: false
      },
      stopAskingError: function(){
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function(err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
      },
      revert: function() {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };

    ctrl.close = function() {
      ctrl.longRequest.cancelled = true;
      if (ctrl.longRequest.flags.processStart && ctrl.longRequest.exec_id){
        print.cancelPrintPriceList(ctrl.longRequest.exec_id).then(function (res) {
          ctrl.modalInstance.dismiss();
        }, ctrl.longRequest.onError);
      } else if (!ctrl.longRequest.flags.processStart) {
        ctrl.modalInstance.dismiss();
      }
    };

    ctrl.print = function() {
      ctrl.longRequest.flags.processStart = true;
      ctrl.longRequest.crudState.startLoading();
      ctrl.resolve.params.filter_date = moment(ctrl.resolve.params.filter_date).valueOf();
      print.printStock(ctrl.format.type, ctrl.resolve.params).then(function(res) {
        ctrl.longRequest.exec_id = res.data.exec_id;
        if (ctrl.longRequest.cancelled) {
          ctrl.close();
          return;
        }
        statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
          ctrl.longRequest.flags.finish = true;
          print.turnoffInterceptorStatus();
          $timeout(function() {
            downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
              ctrl.longRequest.crudState.stopLoadingSuccess();
              $timeout(function() {
                ctrl.modalInstance.dismiss();
              }, 300, false)
            });
          });
        },ctrl.longRequest.onError);
      }).catch(ctrl.longRequest.onError);

    };


  }
});


'use strict';
angular.module('frontend').component('alcoStockInfo', {
  templateUrl: 'app/egaisz/stock-balance/alco-stock-info/alco-stock-info.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'alcoStockInfoCtrl',
  controller: function ($scope, egaiszService, $timeout, errorMessageService, stockBalanceEgaisListDefsService) {
    var alcoStockInfoCtrl = this;

    alcoStockInfoCtrl.load = false;
    alcoStockInfoCtrl.alco_items = alcoStockInfoCtrl.resolve.data.alco_items;
    alcoStockInfoCtrl.fn2Columns = stockBalanceEgaisListDefsService.getColumnsFn2();
    alcoStockInfoCtrl.alcoItemsColumns = stockBalanceEgaisListDefsService.getColumnsAlcoItems();
    alcoStockInfoCtrl.paging = {
      current: 0,
      limit: 7,
      offset: 0,
      limits: [7]
    };

    _.forEach(alcoStockInfoCtrl.alcoItemsColumns, function (column) {
      column.templateScope = $scope;
    });

    _.forEach(alcoStockInfoCtrl.fn2Columns, function (column) {
      column.templateScope = $scope;
    });

    alcoStockInfoCtrl.close = function () {
      alcoStockInfoCtrl.modalInstance.dismiss();
    };

    alcoStockInfoCtrl.getTotal = function (field) {
      return alcoStockInfoCtrl.resolve.data['total_' + field];
    };

    alcoStockInfoCtrl.rowSelectionHandler = function (alco_item) {
      if (!alcoStockInfoCtrl.resolve.data ||
        !alcoStockInfoCtrl.resolve.data.sku_derivative) {
        alcoStockInfoCtrl.fn2Mode = true;
        alcoStockInfoCtrl.alcoItem = alco_item;
        return;
      }
      if (!alcoStockInfoCtrl.resolve ||
        !alco_item.alcohol_catalog) {
        errorMessageService.showModal({message: 'Не хватает данных для выполнения запроса', submessage: ''});
        return;
      }
      egaiszService.getAlcoholStockItem(
        alcoStockInfoCtrl.resolve.fsrarId,
        alco_item.alcohol_catalog.id,
        alcoStockInfoCtrl.resolve.data.sku_derivative.derivative.id,
        alcoStockInfoCtrl.paging.offset,
        alcoStockInfoCtrl.paging.limit)
        .then(function (res) {
          alcoStockInfoCtrl.fn2Mode = true;
          alcoStockInfoCtrl.alcoItem = alco_item;
          alcoStockInfoCtrl.fn2Data = res.data.items;
          alcoStockInfoCtrl.paging.total = res.data.total
        }, function (error) {
          alcoStockInfoCtrl.modalInstance.dismiss();
          errorMessageService.showModal({message: 'При запросе данных произошла ошибка', submessage: error});
        });
    };

    alcoStockInfoCtrl.getFn1 = function () {
      alcoStockInfoCtrl.rowSelectionHandler(alcoStockInfoCtrl.resolve.data.alco_items[0]);
    }


  }
});


/**
 * Created by aivanov on 08.01.2019.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает форматированное представление штрихкода.
   */
  angular.module('frontend').filter('egaisFamName', function (egaiszFamService) {
    return function (barcode) {
      if (!barcode)
        return;
      var type = egaiszFamService.getFamInfoByBarcode(barcode);
      return type && type.value;
    };
  });

})();

/**
 * Created by aivanov on 08.01.2019.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает форматированное представление штрихкода.
   */
  angular.module('frontend').filter('egaisBarcode', function () {
    return egaisBarcode;
  });

  var egaisBarcode = function (barcode) {
    return barcode && barcode.length !== 68 ? barcode.substring(3, 6) + ' ' + barcode.substring(6, 14) : "марка старого образца";
  }

})();

'use strict';
angular.module('frontend').component('historyPopup', {
  templateUrl: 'app/egaisz/modals/history-popup/history-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope, $filter) {
    var historyPopupCtrl = this;
    
    historyPopupCtrl.data = historyPopupCtrl.resolve.data;
    
    historyPopupCtrl.close = function () {
      historyPopupCtrl.modalInstance.dismiss();
    };

    historyPopupCtrl.getStatus = function(status){
        return $filter(historyPopupCtrl.resolve.filterStatus)(status);
    }

    historyPopupCtrl.configScroll = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          scrollButtons: {
            enable: false
          },
          setHeight: 500,
          scrollInertia: 0,
          axis: 'y'
        };

  }
});

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('approveWaybill', {
      bindings: {
        modalInstance: '<',
        resolve: '<'
      },
      templateUrl: 'app/egaisz/invoice-waybill/approve-waybill/approve-waybill.html',
      controllerAs: 'approveWaybillCtrl',
      controller: function (
        egaiszService, // сервис для работы с АПИ ЕГАИС
        $timeout,
        $state,
        $stateParams,
        errorMessageService
      ) {
        var approveWaybillCtrl = this;

        // Объект акта для отправки на бекенд
        approveWaybillCtrl.act = {act_date: moment()};

        // универсальные настройки датапикера
        approveWaybillCtrl.datePickerOptions = {
          singleDatePicker: true,
          correctTimeZone: false,
          timePicker: false,
          minDate: moment(new Date()).add(-1, 'days'),
          maxDate: moment(new Date()).add(1,'days')
        };

        approveWaybillCtrl.step = (approveWaybillCtrl.resolve.isViewAct) ? 'ACT' : 'INFO'; // INFO, ACT

        // если просмотр акта, то подставить данные из ттн
        if (approveWaybillCtrl.resolve.isViewAct) {
          approveWaybillCtrl.act = {
            act_date: approveWaybillCtrl.resolve.waybill.way_bill_act.act_date,
            act_number: approveWaybillCtrl.resolve.waybill.way_bill_act.act_number,
            note:  approveWaybillCtrl.resolve.waybill.way_bill_act.note,
            accept:  approveWaybillCtrl.resolve.waybill.way_bill_act.accept
          };
        }

        /**
         * Непосредственно принятие с соттвествующим статусом ТТН
         */
        approveWaybillCtrl.approve = function() {
          approveWaybillCtrl.act.act_date = moment(approveWaybillCtrl.act.act_date).valueOf();
          approveWaybillCtrl.act.accept = approveWaybillCtrl.resolve.settings.decision;
          egaiszService.setDecide(approveWaybillCtrl.resolve.waybill.id, approveWaybillCtrl.act).then(function(res){
            approveWaybillCtrl.modalInstance.close('success');
            $state.transitionTo("invoiceWaybill.view", $stateParams, {
                reload: true,
                inherit: false,
                notify: true
            });
          },
          function (error) {
            approveWaybillCtrl.modalInstance.close('success');
            if (error.data.fields.length && error.data.fields[0].field == 'derivative'){
              if(error.data.fields[0].error.indexOf('Attribute for alcohol product flag can not be false') + 1) {
                errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Атрибут \"Алкогольная продукция\" выбранной позиции каталога не может иметь значение \"Нет\""}}});
              }else if(error.data.fields[0].error.indexOf('Attribute for alcohol label can not be') + 1) {
                errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Сканировать акцизную марку\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
              }else if(error.data.fields[0].error.indexOf('Attribute for alcohol type must be equals product code') + 1) {
                errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Код вида продукции ФСРАР\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
              }else if(error.data.fields[0].error.indexOf('Attribute for alcohol percentage must be equals alc volume') + 1) {
                errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Крепость\" выбранной позиции каталога не соответствует крепости алкогольной продукции"}}});
              }else if(error.data.fields[0].error.indexOf('Derivative is null') + 1) {
                errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Сохранены не все складские позиции"}}});
              } else {
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
              }
            } else if (error.status == 400 && error.data.code == "bad_arguments" && error.data.message) {
              errorMessageService.showModal({message: 'При принятии решения произошла ошибка', submessage: error});
            } else {
              errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
            }
          });
        };

        /**
         * Закрытие модального окна
         */
        approveWaybillCtrl.close = function () {
          approveWaybillCtrl.modalInstance.close('success');
        };
      }
    });
})();

'use strict';

/**
 * Вспомогательный сервис для работы с окном подтверждения ТТН
 */
angular.module('frontend').service('approveCommonService', function ($http, $q, API_URL) {

  /* Кешированный промис */
  var messagesPromise = undefined;

  /**
   * Получение натсроек сообщений для различного поведения окна подтверждения накладной
   *
   * @param type тип окна (APPROVE, APPROVE_WITH_DISAGREEMENT, DECLINE)
   *
   */
  this.getSettingsByType = function (type) {
    if (!messagesPromise) {
      messagesPromise = $http.get('assets/api/egais/approve-messages.json');
    }
    return messagesPromise.then(function (data) {
      return data.data[type];
    });
  };
});

(function () {
  'use strict';

  angular
  .module('frontend')
  .component('fsrarCompanyModal', {
    transclude: true,
    bindings: {
      modalInstance: "<"
    },
    templateUrl: 'app/egaisz/beginning-balance-egais-list/fsrar-company/fsrar-company-modal.html',
    controllerAs: 'fsrarCompanyModalCtr',
    controller: function ($scope, $state, egaiszService, utmConnectionsService, errorMessageService) {
      var fsrarCompanyModalCtr = this;
      fsrarCompanyModalCtr.load = true;

      fsrarCompanyModalCtr.refreshUtms = function(searchStr){
        utmConnectionsService.connections({limit: 5}, searchStr).then(function(res){
          fsrarCompanyModalCtr.load = false;
          fsrarCompanyModalCtr.companies = res.data.items;
          fsrarCompanyModalCtr.total = res.data.total;
        });
      }
      fsrarCompanyModalCtr.refreshUtms();
      
      fsrarCompanyModalCtr.close = function () {
        fsrarCompanyModalCtr.modalInstance.dismiss();
      };

      fsrarCompanyModalCtr.send = function(){
        if(fsrarCompanyModalCtr.company){
          var sendData = {
            id: fsrarCompanyModalCtr.company.id,
            fsrar_id: fsrarCompanyModalCtr.company.fsrar_id
          };
          fsrarCompanyModalCtr.load = true;
          egaiszService.sendBeginningBalanceEgais(sendData).then(function(res){
            fsrarCompanyModalCtr.modalInstance.dismiss();
            $state.reload();
          },
          function(error){
            if (error.status == 400 && error.data.code == "bad_arguments" && error.data.message) {
              fsrarCompanyModalCtr.modalInstance.dismiss();
              errorMessageService.showModal({message: 'При проведении произошла ошибка', submessage: error});
            } else {
              fsrarCompanyModalCtr.load = false;
              fsrarCompanyModalCtr.invalid = true;
            }
          });
        }
      };

    }
  });
})();

/**
 * Created by aivanov on 09.02.2019.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название статуса.
   */
  angular.module('frontend').filter('balanceStatus', function () {
    return balanceStatus;
  });

  var balanceStatus = function (barcode) {
    if (!barcode)
      return barcode;
    switch (barcode) {
      case 'SEND_TO_EGAIS':
        return 'Отправлен в ЕГАИС';
      case  'DATA_RECEIVED':
        return 'Данные получены';
      case  'MARK_REQUEST':
        return 'Отправлен запрос марок';
      case  'MARK_REQUEST_COMPLETED':
        return 'Марки получены';
      case  'MARK_REQUEST_ERROR':
        return 'Ошибка запроса марок';
      case  'REJECTED':
        return 'Отклонен';
      case  'NEED_TO_ACCOUNTED':
        return 'Требуется проведение';
      case  'IN_PROGRESS':
        return 'Ожидает проведения';
      case  'ACCOUNTED_TO':
        return 'Проведен';
      case  'ACCOUNTED_ERROR':
        return 'Ошибка проведения';
      default:
        return barcode;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service("searchDocumentsSrv", function ($uibModal) {
        this.showModal = function (docPurposes, fields, title, result, company_id, employee_id) {
          return $uibModal.open({
            templateUrl: 'app/documents/modals/search-documents/search-documents.html',
            controller: 'searchDocumentsCtrl',
            controllerAs: 'searchCtrl',
            bindToController: true,
            size: 'large-width',
            resolve: {
              docPurposes: function(){
                return docPurposes;
              },
              fields: function(){
                return fields;
              },
              title: function(){
                return title;
              },
              result: function(){
                return result;
              },
              company_id: function(){
                return company_id;
              },
              employee_id: function(){
                return employee_id;
              }
            }
          });
        }
    })
    .controller("searchDocumentsCtrl", function ($scope, 
                                                  catalogService, 
                                                  $uibModalInstance, 
                                                  companyService, 
                                                  categoryService,
                                                  catalogItemService,
                                                  OPTIONS_LENGTH,
                                                  docPurposes,
                                                  fields,
                                                  title,
                                                  $timeout,
                                                  documentService,
                                                  contragentService,
                                                  contractService,
                                                  projectsService,
                                                  $rootScope,
                                                  result,
                                                  company_id,
                                                  employee_id) {
      var searchCtrl = this;
      searchCtrl.result = result || [];
      searchCtrl.optionLength = OPTIONS_LENGTH;
      // убрать некоторые фильры в авансовом отчете в авансах
      searchCtrl.isAdvanceReport = searchCtrl.$stateParams.type == "ADVANCE_REPORT" && docPurposes.length > 1;
      searchCtrl.documentOptions = {};
      searchCtrl.divisionsAll = [];
      searchCtrl.columns = [];
      searchCtrl.urlParams = {
        filter_company_id: company_id,
        filter_employee_id: employee_id,
        filter_status: ["PROCESSED"],
        filter_document_purpose: docPurposes,
        limit: 9,
        offset: 0,
        sort_by: "date",
        sort_order: "asc"
      };

      searchCtrl.title = title || function(){
        if(docPurposes && docPurposes.indexOf("CNI_FROM_SUPPLIER") + 1 && docPurposes.indexOf("CNI_FROM_COMMITTEE") + 1){
          return "Выберите приемки товаров, на которые нужно отнести дополнительные затраты";
        }else if(docPurposes && docPurposes.indexOf("CP_FOR_ADVANCE_REPORT") + 1 && docPurposes.indexOf("NCP_FOR_ADVANCE_REPORT") + 1){
          return "Добавления связанного документа, подтверждающего выдачу и получение аванса";
        }else {
          return "Выберите приемки товаров, на которые нужно отнести дополнительные затраты";
        }
      }();

      // формирование колоночной модели грида документов
      angular.forEach(fields, function (item, key) {
        if(item.code){
          if(key == 1){
            item.flex = 1;
          }
          if(key == 3){
            item.flex = 2;
          }
          if(key == 5){
            item.flex = 1.3;
          }
          searchCtrl.columns.push({
            name: item.name,
            field: item.code,
            flex: item.flex || 2,
            headerTemplateUrl: 'documentSearchHeaderCellTemplate.html',
            templateUrl: 'documentSearchCellTemplate.html',
            templateScope: $scope,
            visible: item.visible,
            column_visible: item.column_visible
          });
        }
      });

      // настройка скролла
      searchCtrl.configScroll = {
        axis:'y',
        autoHideScrollbar: false,
        theme: 'dark-thick',
        advanced:{
          updateOnContentResize: true
        },
        setHeight: 480,
        scrollInertia: 0,
        scrollButtons: {
          enable: false // enable scrolling buttons by default
        }
      }
      searchCtrl.paging = {
        current: 0,
        limit: 9,
        offset: 0,
        total: 0
      };

      searchCtrl.close = function () {
        $uibModalInstance.close(searchCtrl.result);
      };

      searchCtrl.reset = function(){
        searchCtrl.urlParams = {
          filter_status: ["PROCESSED"],
          filter_document_purpose: docPurposes,
          limit: 9,
          offset: 0,
          sort_by: "date",
          sort_order: "asc"
        };
        searchCtrl.paging = {
          current: 0,
          limit: 9,
          offset: 0,
          total: 0
        };
        searchCtrl.date = {isAllTime: true};
        searchCtrl.searchRes = undefined;
        searchCtrl.notFound = undefined;
        searchCtrl.formInvalid = false;
        searchCtrl.isIssetData = false;
      }

      searchCtrl.checkIssetData = function(){
        searchCtrl.isIssetData = false;
        if(searchCtrl.urlParams.filter_number || 
           searchCtrl.urlParams.filter_division_id || searchCtrl.urlParams.filter_counterparty_id || 
           searchCtrl.urlParams.filter_contract_id || searchCtrl.urlParams.filter_project_id || 
           !searchCtrl.date.isAllTime || searchCtrl.urlParams.filter_home_amount_from || 
           searchCtrl.urlParams.filter_home_amount_to || searchCtrl.urlParams.filter_derivative_id){
           searchCtrl.isIssetData = true;
          return;
        }
      }

      searchCtrl.setCheckedItems = function(){
        $timeout(function(){
          var ids = [];
          _.forEach(searchCtrl.result, function(item){
            ids.push(item.id);
          })
          searchCtrl.documentOptions.setCheckedRows(ids, 'id');
        }, 0);
      };

      searchCtrl.getCheckedItems = function(){
        if(searchCtrl.documentOptions.getCheckedRows){
          _.forEach(searchCtrl.searchRes, function(item){
            var index;
            _.find(searchCtrl.result, function(resItem, key){
              if(resItem.id == item.id){
                index = key;
              }
            });
            if(Number.isInteger(index)){
              searchCtrl.result.splice(index, 1);
            }

          });
          searchCtrl.result = searchCtrl.result.concat(searchCtrl.documentOptions.getCheckedRows());
        }
      }

      searchCtrl.search = function(resetOffset){
        searchCtrl.showLoader = true;
        searchCtrl.getCheckedItems();
        
        if(resetOffset){
          searchCtrl.urlParams.offset = 0;
          searchCtrl.paging.offset = 0;
        }else{
          searchCtrl.urlParams.offset = searchCtrl.paging.offset;
        }
        
        if(searchCtrl.date.startDate && !searchCtrl.date.startDate.isEmpty && !searchCtrl.date.isAllTime){
          searchCtrl.urlParams.filter_date_from = moment.utc(searchCtrl.date.startDate).valueOf();
        }else{
          searchCtrl.urlParams.filter_date_from = undefined;
        }
        if(searchCtrl.date.endDate && !searchCtrl.date.endDate.isEmpty && !searchCtrl.date.isAllTime){
          searchCtrl.urlParams.filter_date_to = moment.utc(searchCtrl.date.endDate).valueOf();
        }else{
          searchCtrl.urlParams.filter_date_to = undefined;
        }

        if(searchCtrl.urlParams.filter_division_id && !searchCtrl.urlParams.filter_division_id.length){
          searchCtrl.urlParams.filter_division_id = undefined;
        }

        documentService.getDocuments(searchCtrl.urlParams).then(function(res) {
          searchCtrl.searchRes = res.data.items;
          searchCtrl.paging.total = res.data.total;
          searchCtrl.notFound = !res.data.total;
          searchCtrl.showLoader = false;
          searchCtrl.setCheckedItems();
        });
      }

      searchCtrl.addDocuments = function(){
        searchCtrl.getCheckedItems();
        searchCtrl.close();
      }



      /* работа с выпадалками */

      searchCtrl.divisions = [];
      companyService.companyDivisions(company_id).then(function(res){
        searchCtrl.divisions = res.data;
      });

      searchCtrl.refreshCounterparties = function(search){
        contragentService.counterpartiesSearch(search, searchCtrl.optionLength).then(function(res){
          searchCtrl.counterparties = res.data;
          if(!searchCtrl.counterpartiesFullTotal){
            searchCtrl.counterpartiesFullTotal = res.data.total;
          }
        })
      }

      searchCtrl.refreshContracts = function(search){
        contractService.contractsForAutocomplete(search, searchCtrl.optionLength, ['WE_BUY'], company_id).then(function(res){
          searchCtrl.contracts = res.data;
          if(!searchCtrl.contractsFullTotal){
            searchCtrl.contractsFullTotal = res.data.total;
          }
        })
      }

      searchCtrl.refreshProjects = function(search){
        projectsService.projectsSearch(search, searchCtrl.optionLength).then(function(res){
          searchCtrl.projects = res.data;
          if(!searchCtrl.projectsFullTotal){
            searchCtrl.projectsFullTotal = res.data.total;
          }
        })
      }

      searchCtrl.catalogItemRefresh = function(search){
        catalogService.getItemDerivativeAuto(search, true, OPTIONS_LENGTH).then(function(res){
          searchCtrl.catalogItems = res.data;
          if(!searchCtrl.catalogItemsFullTotal){
            searchCtrl.catalogItemsFullTotal = res.data.total;
          }
        })
      }

      searchCtrl.totalStr = function(length){
        return function(){
          if(length > OPTIONS_LENGTH){
            return "Показано " + OPTIONS_LENGTH + " из " + length;
          }
          return '';
        }
      };



      
    })
})();

(function() {
    'use strict';
  
    angular.module('frontend').service('importDocumentSrv', importDocumentsSrv);
  
    function importDocumentsSrv($http, API_URL) {
  
      /**
       * Запрос Ошибок в файле
       *
       * @param importId
       */
      this.getDocumentsResult = function (importId) {
        return $http.get(API_URL + "/import/documents/" + importId + "/result").then(function (res) {
          return res.data;
        });
      }
  
      /**
       * Запрос обработки файла
       * Главные настройки импорта
       * @param importSettings
       */
      this.documentsProcessing = function (format, importSettings) {
        return $http.post(API_URL + "/import/documents/" + format + "/parcing", importSettings);
      }
  
      /**
       * Отменяет импорт файла
       *
       * @param importId
       */
      this.cancelFileImport = function (importId) {
        return $http.put(API_URL + "/import/documents/" + importId + "/cancel");
      }
  
    }
  
  }) ();
  
'use strict';
angular.module('frontend').component('importFromFile', {
  templateUrl: 'app/documents/modals/import-from-file/import-from-file.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function (FileUploader, API_URL, authToken, MAX_UPLOAD_FILE_SIZE, importDocumentSrv, errorMessageService, statusSrv) {
    var importFromFileCtrl = this;
    importFromFileCtrl.activeStep = 0;
    importFromFileCtrl.countColumn = 3;
    importFromFileCtrl.formatFile = 'excel';
    importFromFileCtrl.processing = {
      start_line: 1,
      need_create_item: false,
      column_mapping: {}
    };

    importFromFileCtrl.headerData = [
      {id: "SKIP", label: "Пусто"},
      {id: "ITEM_CODE", label: "Код позиции"},
      {id: "VENDOR_CODE", label: "Артикул производителя"},
      {id: "GTIN", label: "Штрих-код"},
      {id: "ITEM_NAME", label: "Наименование позиции"},
      {id: "QUANTITY", label: "Количество"},
      {id: "UOM", label: "Единица измерения позиции"},
      {id: "PRICE", label: "Цена"},
      {id: "TAX_GROUP", label: "Налоговая группа"},
      {id: "CATEGORY", label: "Категория"}
    ];

    // настройка скролла
    importFromFileCtrl.configScroll = {
      autoHideScrollbar: false,
      autoExpandScrollbar: false,
      setHeight: 290,
      scrollInertia: 0,
      axis: 'y',
      advanced: {
          updateOnContentResize: true,
          autoExpandHorizontalScroll: false,
          autoScrollOnFocus: false
      },
      scrollButtons: {
          enable: false
      },
      theme: 'dark',
      mouseWheel:{
        preventDefault: false,
        disableOver: ["ul", "li", "span"]
      }
    };

    function setColumnsMapping() {
      importFromFileCtrl.processing.column_mapping = angular.copy(importFromFileCtrl.fileData.lines[0]);
      angular.forEach(importFromFileCtrl.processing.column_mapping, function(cell, key){
        var isset = false;
        angular.forEach(importFromFileCtrl.headerData, function(value){
          if (cell.replace(/[\s\n\r]+/g, '') === value.label.replace(/[\s\n\r]+/g, '')) {
            isset = value;
          }
        });
        if(!isset){
          importFromFileCtrl.processing.column_mapping[key] = '';
        }else{
          importFromFileCtrl.processing.column_mapping[key] = isset.id;
        }
      });
    }

    importFromFileCtrl.checkForm = function () {
      // проверка полей формы, выделение красным пустых полей
      angular.forEach(importFromFileCtrl.importForm.$error, function (controls) {
        angular.forEach(controls, function(control) {
          control.$setDirty();
        });
      });
    };

    importFromFileCtrl.changeNeedCreateItem = function (need_create_item) {
      importFromFileCtrl.processing.need_create_item = need_create_item
    };

    importFromFileCtrl.close = function () {
      importFromFileCtrl.modalInstance.dismiss();
    }

    importFromFileCtrl.afterProcessing = function (import_id) {
      // importFromFileCtrl.processing.import_id = data.data.import_id;
      // importFromFileCtrl.modalInstance.close(data.data);

      importFromFileCtrl.processing.import_id = import_id;

      angular.forEach(importFromFileCtrl.processing.column_mapping, function(item,  key){
        if (item == 'SKIP') {
          importFromFileCtrl.processing.column_mapping[key] = '';
        }
      });
      importFromFileCtrl.processing.actual_date = moment.utc(importFromFileCtrl.processing.actual_date);
      statusSrv.getPromise('/import/documents/' + importFromFileCtrl.processing.import_id + '/status').then(function () {
        importDocumentSrv.getDocumentsResult(importFromFileCtrl.processing.import_id).then(function(res){
            var errorStr = ['ошибка', 'ошибки', 'ошибок'],
                successStr = ['строка', 'строки', 'строк'],
                cases = [2, 0, 1, 1, 1, 2];
              
            importFromFileCtrl.fileErrors = res;
            if(res.error_list){ // вывод правильного окончания для ошибки
              importFromFileCtrl.errorCountStr = errorStr[ (res.error_list % 100 > 4 && res.error_list % 100 < 20)? 2 : cases[(res.error_list % 10 < 5)?res.error_list % 10 : 5] ]
            }else{
              importFromFileCtrl.errorCountStr = '';
            }
            if(res.success_count){ // вывод правильного окончания для ошибки
              importFromFileCtrl.successCountStr = successStr[ (res.success_count % 100 > 4 && res.success_count % 100 < 20)? 2 : cases[(res.success_count % 10 < 5)?res.success_count % 10 : 5] ]
            }else{
              importFromFileCtrl.successCountStr = '';
            }
          },
          function (error) {
            importFromFileCtrl.fileErrors = {};
            importFromFileCtrl.processing.actual_date = moment.utc(importFromFileCtrl.processing.actual_date);
            importFromFileCtrl.activeStep--;
            errorMessageService.showModal({message: 'При получении результатов произошла ошибка', submessage: error});
          });
        },
        function () {
          importFromFileCtrl.activeStep--;
          errorMessageService.showModal({message: 'При проверке данных произошла ошибка'});
        },
        function () {
          errorMessageService.showModal({message: 'При проверке данных произошла ошибка'});
        });
    }

    importFromFileCtrl.next = function () {
      if(importFromFileCtrl.uploader.queue[0] && importFromFileCtrl.uploader.queue[0].isSuccess){

        if (importFromFileCtrl.activeStep === 1) {
          importFromFileCtrl.checkForm();

          // проверка указания всех обязательных колонок
          importFromFileCtrl.reqColumn = {
            item_name: !!_.find(importFromFileCtrl.processing.column_mapping, function (cell) {
              return cell === "ITEM_NAME";
            }),
            quantity: !!_.find(importFromFileCtrl.processing.column_mapping, function (cell) {
              return cell === "QUANTITY";
            }),
            price: !!_.find(importFromFileCtrl.processing.column_mapping, function (cell) {
              return cell === "PRICE";
            })
          };
          importFromFileCtrl.headersCheck = importFromFileCtrl.reqColumn.item_name || importFromFileCtrl.reqColumn.quantity || importFromFileCtrl.reqColumn.price;

          if(importFromFileCtrl.headersCheck){
            importFromFileCtrl.activeStep++;
            importFromFileCtrl.next();
          }else{
            importFromFileCtrl.headersCheck = false;
          }
          return;
        } else if (importFromFileCtrl.activeStep === 2) {
          

          if (importFromFileCtrl.fileErrors && importFromFileCtrl.fileErrors.imported_document && importFromFileCtrl.fileErrors.imported_document.lines.length) {
            importFromFileCtrl.modalInstance.close(importFromFileCtrl.fileErrors.imported_document.lines);
            return;
          }

          importFromFileCtrl.fileErrors = undefined;


          angular.forEach(importFromFileCtrl.processing.column_mapping, function(item,  key){
            if(!item){
              importFromFileCtrl.processing.column_mapping[key] = 'SKIP';
            }
          });

          importDocumentSrv.documentsProcessing("excel", importFromFileCtrl.processing).then(function(data){
            importFromFileCtrl.afterProcessing(data.data.import_id)
          },
          function (error) {
            importFromFileCtrl.fileErrors = {};
            importFromFileCtrl.processing.actual_date = moment.utc(importFromFileCtrl.processing.actual_date);
            importFromFileCtrl.activeStep--;
            errorMessageService.showModal({message: 'При получении результатов произошла ошибка', submessage: error});
          });
          
          return;
        }

        if (importFromFileCtrl.activeStep < 1)
          importFromFileCtrl.activeStep++;
      }
    }

    // записть изменееного имени колонки в объект
    importFromFileCtrl.changeColumnName = function(row, index){
      importFromFileCtrl.headersCheck = undefined;
      importFromFileCtrl.processing.column_mapping[index] = row;
      // проверка уникальности имени колонки
      importFromFileCtrl.columnErrorInds = [];
      angular.forEach(importFromFileCtrl.processing.column_mapping, function(val1, key1){
        angular.forEach(importFromFileCtrl.processing.column_mapping, function(val2, key2){
          if (val1 && val2 && key1 < key2 && val1 === val2) {
            importFromFileCtrl.columnErrorInds.push(key1);
            importFromFileCtrl.columnErrorInds.push(key2);
          }
        });
      });
    };

    // изменение "Первой строки" загруженного документа
    importFromFileCtrl.changeRowNum = function(isIncre){
      if(isIncre){
        if(importFromFileCtrl.processing.start_line < importFromFileCtrl.fileData.lines.length - 1){
          importFromFileCtrl.processing.start_line++;
          var removedIncre = importFromFileCtrl.lineHelper.splice(importFromFileCtrl.processing.start_line-1,1);
          importFromFileCtrl.lineHelper.splice(importFromFileCtrl.processing.start_line, 0, removedIncre[0]);
        }
      }else{
        if(importFromFileCtrl.processing.start_line > 0){
          importFromFileCtrl.processing.start_line--;
          var removed = importFromFileCtrl.lineHelper.splice(importFromFileCtrl.processing.start_line,1);
          importFromFileCtrl.lineHelper.splice(importFromFileCtrl.processing.start_line+1, 0, removed[0]);
        }
      }
    };

    // переключение колонок
    importFromFileCtrl.switchColumn = function(next){
      if(next && (importFromFileCtrl.offsetColumn + importFromFileCtrl.countColumn) < importFromFileCtrl.processing.column_mapping.length){
        importFromFileCtrl.offsetColumn++;
      }else if(importFromFileCtrl.offsetColumn){
        importFromFileCtrl.offsetColumn--;
      }
    }
    
    // загрузка файла
    importFromFileCtrl.uploader = new FileUploader({
      headers: {'X-Session-Id': authToken.getToken()},
      queueLimit: 1,
      onAfterAddingFile : function(){
        var file = importFromFileCtrl.uploader.queue[0].file;
        var nameArr = file.name.split('.');
        var fileFormat = nameArr[nameArr.length - 1]

        importFromFileCtrl.fileError = '';
        if(fileFormat !== 'xls' && 
           fileFormat !== 'xlsx' && 
           fileFormat !== 'xml'){  // ошибка неверный формат файла
          importFromFileCtrl.uploader.queue[0].isError = true;
          importFromFileCtrl.fileError = 'format';
          return;
        }
        if(file.size > MAX_UPLOAD_FILE_SIZE){ // ошибка файл больше чем 5 МБ
          importFromFileCtrl.uploader.queue[0].isError = true;
          importFromFileCtrl.fileError = 'size';
          return;
        }

        // Для XML меняем URL
        if (fileFormat === 'xml') {
          importFromFileCtrl.formatFile = 'xml'
          importFromFileCtrl.uploader.url = API_URL + "/import/documents/xml/parcing";
        } else {
          importFromFileCtrl.formatFile = 'excel'
          importFromFileCtrl.uploader.url = API_URL + "/import/documents/excel/upload";
        }

        importFromFileCtrl.uploader._onBeforeUploadItem = function(item) {
          item.url = importFromFileCtrl.uploader.url;

          if (importFromFileCtrl.formatFile === 'xml') {
            item.formData = item.formData || [];
            item.formData.push({need_create_item: importFromFileCtrl.processing.need_create_item});
          }
        };
        importFromFileCtrl.uploader.queue[0].upload();
      },
      onWhenAddingFileFailed: function(item){
        importFromFileCtrl.uploader.clearQueue();
        importFromFileCtrl.uploader.addToQueue([item]);
      },
      onSuccessItem: function(item, response){
        importFromFileCtrl.offsetColumn = 0;
        importFromFileCtrl.processing.start_line = 1;
        importFromFileCtrl.fileData = response;
        importFromFileCtrl.processing.import_id = importFromFileCtrl.fileData.import_id;

        if (importFromFileCtrl.formatFile == 'xml') {
          importFromFileCtrl.activeStep = 2;
          importFromFileCtrl.afterProcessing(importFromFileCtrl.processing.import_id)
          return
        }

        setColumnsMapping();
        importFromFileCtrl.lineHelper = angular.copy(response.lines);
        importFromFileCtrl.lineHelper.splice(1, 0, [true]);
        // если в файле одна строка, то по умолчанияю "первая строка" начинается с нуля
        if(importFromFileCtrl.fileData.line_count == 1){
          importFromFileCtrl.processing.start_line = 0;
        }
        // обработка пустого файла
        if(!importFromFileCtrl.fileData.line_count){
          importFromFileCtrl.fileError = 'empty';
          importFromFileCtrl.uploader.queue[0].progress = false;
          importFromFileCtrl.uploader.queue[0].isSuccess = false;
          importFromFileCtrl.uploader.queue[0].isError = true;
        }
      }
    });


  }
});

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('docSettingsCompany', docSettingsCompany);

  /**
   * Директива для отображения настроек компании
   */
  function docSettingsCompany() {
    return {
      restrict: 'E',
      templateUrl: 'app/documents/document-settings/companyTab/company-tab.html',
      scope: {
        // Все настройки 
        settings: '=',
        // Содержит информацию о вкладке, для которой примерняется директива, в частности - компания
        tab: '<',
        // периоды для выпадающего списка
        periods: '<'
      },
      controller: docSettingsCompanyController
    }

    function docSettingsCompanyController($scope, $filter) {
      var tabSettings = $filter('filter')($scope.settings, {company: { id: $scope.tab.id }});
      $scope.tabSettings = _.sortBy(tabSettings, function(o) {
        o.reset_period = o.reset_period === null ? 'EMPTY' : o.reset_period;
        return $filter('getDocName')(o.document_type);
      });
    }
  }
}) ();

'use strict';
angular.module('frontend').component('autoPricePopup', {
  templateUrl: 'app/documents/document-settings/autoPricePopup/auto-price-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'autoPricePopup',
  controller: function ($scope, $timeout, $filter) {
    var autoPricePopup = this;
    autoPricePopup.settings = autoPricePopup.resolve.settings;
    autoPricePopup.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      setHeight: 400,
      scrollInertia: 0,
      axis: 'y'
    };

    // возможные типы цен
    autoPricePopup.priceTypes = [{
      value: "PURCHASE",
      label: "Закупочный прайс-лист"
    },
    {
      value: "WHOLESALE",
      label: "Оптовый прайс-лист"
    },
    {
      value: "RETAIL",
      label: "Розничный прайс-лист"
    },
    {
      value: "CONSIGNMENT_NOTE",
      label: "Последняя приемка"
    },
    {
      value: "STOCK_ITEM_COST",
      label: "Себестоимость"
    }];

    autoPricePopup.close = function(isSave) {
      autoPricePopup.modalInstance.close(isSave? autoPricePopup.settings: undefined);
    };

    autoPricePopup.init = function() {
      autoPricePopup.types = _.uniq(autoPricePopup.settings.document_number_sequences, function(item) { return item.document_type }).map(function(item) {
        return item.document_type
      });
      autoPricePopup.types = _.sortBy(autoPricePopup.types, function(o) {
        return $filter('getDocName')(o);
      });

      if (autoPricePopup.settings.document_price_source && !autoPricePopup.settings.document_price_source.length) {
        _.forEach(autoPricePopup.types, function(type) {
          autoPricePopup.settings.document_price_source.push({ 
            document_type: type, 
            pricing_type: null
          });
        });
      }
    };

    $timeout(function () {
      autoPricePopup.init();
    }, 0);

  }
});


'use strict';
angular.module('frontend').component('autoNumbersPopup', {
  templateUrl: 'app/documents/document-settings/autoNumbersPopup/auto-numbers-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'autoNumbersPopup',
  controller: function ($scope, $timeout) {
    var autoNumbersPopup = this;
    autoNumbersPopup.settings = autoNumbersPopup.resolve.settings;
    autoNumbersPopup.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      setHeight: 400,
      scrollInertia: 0,
      axis: 'y'
    };

    autoNumbersPopup.periods = ['EMPTY', 'DAY', 'MONTH', 'QUARTER', 'YEAR'];

    autoNumbersPopup.close = function(isSave) {
      autoNumbersPopup.modalInstance.close(isSave? autoNumbersPopup.settings: undefined);
    };

    autoNumbersPopup.init = function() {
      autoNumbersPopup.settings.document_number_sequences = _.sortBy(autoNumbersPopup.settings.document_number_sequences, function(o) {
        return o.company.name;
      });
      autoNumbersPopup.companies = _.uniq(autoNumbersPopup.settings.document_number_sequences, function(item) { return item.company.id }).map(function(item) {
        return item.company
      });
    };

    autoNumbersPopup.scrlTabsApi = {};
    autoNumbersPopup.reCalcScroll = function() {
      if(autoNumbersPopup.scrlTabsApi.doRecalculate) {
        autoNumbersPopup.scrlTabsApi.doRecalculate();
      }else{
        autoNumbersPopup.scrlTabsApi = {};
      }
    };

    autoNumbersPopup.scrollIntoView = function(arg) {
      if(autoNumbersPopup.scrlTabsApi.scrollTabIntoView) {
        autoNumbersPopup.scrlTabsApi.scrollTabIntoView(arg);
      }
    };

    autoNumbersPopup.activeTab = autoNumbersPopup.activeTab || 0;

    autoNumbersPopup.selectTab = function(index) {
      autoNumbersPopup.activeTab = index;
      autoNumbersPopup.scrollIntoView();
    };

    $timeout(function () {
      autoNumbersPopup.init();
    }, 0);

  }
});


(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('bindHtmlCompile', bindHtmlCompile);

  /** @ngInject */
  function bindHtmlCompile($compile, $templateCache) {
    var directive = {
      restrict: 'A',
      link: function (scope, element, attrs) {
        scope.$watch(function () {
          return scope.$eval(attrs.bindHtmlCompile);
        }, function (value) {
          element.html(value);
          $compile(element.contents())(scope);
        });
      }
    };
    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('documentGrid', documentGrid);

  /**
   * Директива для отображения блоков разметки документа
   */
  function documentGrid() {
    return {
      restrict: 'E',
      templateUrl: 'app/documents/components/document-grid/document-grid.html',
      scope: {
        redact: '=', // режим редактирования
        values: '=', // единая для документа карта значений
        item: '<', // метаинформация о блоке
        docType: '<', // для хранения настроек грида в сторе по типу документа
        externalData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        amountCalculate: '<?', //метод расчета сумм
        referenceData: '<?', // эталонные данные документа, для вычисления данных с сервера
        checkValid: '=?',
        needAddToCart: '<?' // необходимость добавлять товары в корзину // todo надо будет вынести этот флаг в мету (например)
      },
      link: function ($scope, element) {
      },
      bindToController: true,
      controllerAs: 'documentGridCtrl',
      controller: documentGridController
    };

    function documentGridController($scope,
                                    $parse,
                                    $filter,
                                    $uibModal,
                                    gridSettingsService,
                                    $state,
                                    $window,
                                    attributeUtilService,
                                    userSettingsService,
                                    $rootScope,
                                    cartService,
                                    requestStatus,
                                    errorMessageService) {
      var documentGridCtrl = this;
      documentGridCtrl.editable = false;
      documentGridCtrl.lineError = -1;
      documentGridCtrl.attributeUtilService = attributeUtilService;

      // настройки пейджинга
      documentGridCtrl.pagingOptions = {
        current: 0,
        limit: userSettingsService.loadProperty("documents", "grid", "pagingLimit") || 10,
        offset: 0,
        total: documentGridCtrl.values[documentGridCtrl.item.code] ? documentGridCtrl.values[documentGridCtrl.item.code].length : 0,
        enablePaging: documentGridCtrl.item.client_paging
      };


      // инициализация массива значений в глобальной медели данных документа
      if (!Array.isArray(documentGridCtrl.values[documentGridCtrl.item.code])) {
        documentGridCtrl.values[documentGridCtrl.item.code] = [];
      }

      /**
       * Метод вычисляет условие видимости из настроек метаданных,
       * если условие не задано, возвращает true
       *
       * @return {boolean|*}
       */
      documentGridCtrl.checkVisibleExpression = function () {
        return !documentGridCtrl.item.visible_expression ||
          $scope.$eval(documentGridCtrl.item.visible_expression, {values: documentGridCtrl.values});
      };

      /**
       * Универсальный обработчик события выбора строки
       */
      documentGridCtrl.rowSelectionHandler = function (row) {
        if (!documentGridCtrl.item.selection_event) {
          return;
        }
        // Поддреживается тип обработчика: открыть документ
        if (documentGridCtrl.item.selection_event.handler_type == 'openDocument') {
          $window.open($state.href('document.view', {
            type: row[documentGridCtrl.item.selection_event.ref[2]], // ссылка на тип
            purpose: row[documentGridCtrl.item.selection_event.ref[1]], // ссылка на назначение
            id: row[documentGridCtrl.item.selection_event.ref[0]], // ссылка на идентификатор
            parent: $state.params.parent
          }));
        }
      };

      // объект для взаиодействия с АПИ грида
      documentGridCtrl.gridOptions = {};

      // построение модели уникальных индексов (ключ: имя индекса, занчение: массив кодов полей составного индекса)
      documentGridCtrl.uniqueIndexes = {};

      angular.forEach(documentGridCtrl.item.fields, function (item, index) {

        if (item.code == 'document_purpose') {
          item.template = 'documentGridPurposeTemplate.html';
        }

        // формирование модели уникальных индексов
        if (item.unique) {
          if (!documentGridCtrl.uniqueIndexes.hasOwnProperty(item.unique)) {
            documentGridCtrl.uniqueIndexes[item.unique] = [];
          }
          documentGridCtrl.uniqueIndexes[item.unique].push(item.code);
        }
      });

      // перенос грида на страницу, где находится элемент под номером {{lineNumber}}
      documentGridCtrl.setPagingOptions = function (lineNumber) {
        var currentPage = Math.floor(lineNumber / documentGridCtrl.pagingOptions.limit);
        documentGridCtrl.pagingOptions.offset = currentPage * documentGridCtrl.pagingOptions.limit;
        documentGridCtrl.pagingOptions.inputPage = currentPage + 1;
        documentGridCtrl.pagingOptions.current = currentPage;
        documentGridCtrl.pagingOptions.last = Math.ceil(documentGridCtrl.pagingOptions.total / documentGridCtrl.pagingOptions.limit) - 1;
      };

      // вспомогательный метод для обновления тотала
      documentGridCtrl._updateTotal = function () {
        documentGridCtrl.pagingOptions.total = $filter('filter')(
          $filter('filter')(
            $filter('groupCustom')(
              documentGridCtrl.values[documentGridCtrl.item.code],
              documentGridCtrl.groupFunc),
            documentGridCtrl._discriminatorFn),
          documentGridCtrl.filterFunc).length;
      };

      // Если задано условие на функцию фильтрации
      if (documentGridCtrl.item.filter_expression) {
        documentGridCtrl.filterExp = $parse(documentGridCtrl.item.filter_expression);
      }
      documentGridCtrl.filterFunc = function (value, index) {
        if (documentGridCtrl.filterExp) {
          return !!documentGridCtrl.filterExp(value);
        }
        return true;
      };

      // Если задано условие на разрешение удаления
      if (documentGridCtrl.item.remove_expression) {
        documentGridCtrl.removeExp = $parse(documentGridCtrl.item.remove_expression);
      }
      documentGridCtrl.showRemoveIcon = function (value) {
        if (documentGridCtrl.removeExp) {
          return !!documentGridCtrl.removeExp(value);
        }
        return true;
      };

      /**
       * Метод позволяет группировать значения по полю
       * (допустимы Path, напиример: 'division.id'). Если поле
       * для группировки не задано, возвращается значение индекса (т.к. он уникален - отсутсвие группировки).
       *
       * @param value допускает массив, при этом происходит конкатенация значений из ключей в массиве
       * @param index
       * @return {*}
       */
      documentGridCtrl.groupFunc = function (value, index) {
        if (documentGridCtrl.item.group_field) {
          if (Array.isArray(documentGridCtrl.item.group_field)) {
            var accStr = _.reduce(documentGridCtrl.item.group_field, function (acc, groupField) {
              return acc + '&' + (documentGridCtrl.attributeUtilService._getValueDeep(
                value,
                groupField.split('.')) || ''); //
            }, '');
            if (accStr.match('^\&+$'))
              return index; // если все значения в группировки пусты, строки не схловпываются TODO: вероятно это стоит контролировать флагом
            return accStr;
          } else {
            return documentGridCtrl.attributeUtilService._getValueDeep(
              value,
              documentGridCtrl.item.group_field.split('.')) || index; // || index добавлен для того, чтобы undefined строки не схлапывались
          }
        }
        return index;
      };

      // Если поле для дискриминатора задано, необходимо отслеживать его изменение для перестоения пейджинга
      if (documentGridCtrl.item.discriminator_value) {
        $scope.$watch("documentGridCtrl.attributeUtilService._getValueDeep(documentGridCtrl.values, documentGridCtrl.item.discriminator_value.split('.')) || index;",
          function (newVal, oldVal) {
            if (newVal !== oldVal) {
              documentGridCtrl._updateTotal();
              documentGridCtrl.setPagingOptions(1); // для отображения первой странички
            }
          })
      }

      // TODO проверка валидности данных в гриде требует рефакторинг, убрать всплытие метода в document-crud
      documentGridCtrl.checkValid = function () {
        if (documentGridCtrl.item.client_paging) {
          documentGridCtrl.lineError = -1;
          var isValid = true;
          _.forEach(documentGridCtrl.values[documentGridCtrl.item.code], function (line, index) {
            if (line.uom) {
              if (!line.quantity) {
                line.quantity = 0;
              }
            } else {
              isValid = false;
              documentGridCtrl.lineError = index;
            }
            // проверка на наличие дериватива и партии с серийников
            if (line.derivative && line.derivative.stock_accounting_type && 
               (line.derivative.stock_accounting_type == "BY_LOTS_LIFO" || 
                line.derivative.stock_accounting_type == "BY_LOTS_FIFO" || 
                line.derivative.stock_accounting_type == "BY_LOTS_FEFO" || 
                line.derivative.stock_accounting_type == "BY_SERIAL_NUMBERS") && !line.lot_sn){
              isValid = false;
              documentGridCtrl.lineError = index;
            }
          });
          // Установка необходимой стриницы пэйджинга, если поменялась переменная
          if (documentGridCtrl.lineError !== undefined && documentGridCtrl.lineError !== -1) {
            documentGridCtrl.setPagingOptions(documentGridCtrl.lineError);
          }
          return isValid;
        }
        return true;
      };

      /**
       * Метод перестаивает колоночную модель при старте и после изменений настроек
       */
      documentGridCtrl.rebuildColumns = function () {
        // построение колоночной модели
        documentGridCtrl.columns = [];

        angular.forEach(documentGridCtrl.item.fields, function (item, index) {
          var isTextRight = item.field_type === "FLD_PRICE" || item.field_type === "FLD_AMOUNT" || item.field_type === "FLD_LINE_TAX_AMOUNT" || item.field_type === 'FLD_QUANTITY' || item.field_type === 'FLD_QUANTITY_WRITE_OFF';

          // формирование колоночной модели
          documentGridCtrl.columns.push({
            name: item.name,
            field: item,
            parent: item.parent,
            flex: item.flex || 2,
            headerTemplateUrl: 'documentGridHeaderCellTemplate.html',
            templateUrl: item.template || 'documentGridCellTemplate.html',
            headerCellClass: isTextRight ? 'pull-right' : '',
            templateScope: $scope,
            visible: item.visible,
            column_visible: item.column_visible
          });

          // узнать необходимо ли редактировать данные в гриде
          if (item.editable) {
            documentGridCtrl.editable = true;
          }
        });

        if (!documentGridCtrl.item.without_number) {
          documentGridCtrl.columns.unshift({
            name: "№",
            flex: 0.7,
            templateUrl: 'documentGridNumberTemplate.html',
            templateScope: $scope,
            visible: true,
            column_visible: true
          });
        }

        // колонка с управляющими элементами
        documentGridCtrl.columns.push({
          name: "",
          flex: 0,
          width: 170,
          templateUrl: 'documentGridControlTemplate.html',
          templateScope: $scope,
          visible: true,
          column_visible: true
        });

        documentGridCtrl.defaultColumns = documentGridCtrl.columns;
        documentGridCtrl.columns = gridSettingsService.getColumnWithPriority(
          documentGridCtrl.columns,
          documentGridCtrl.docType,
          documentGridCtrl.item.code
        );
      };
      documentGridCtrl.rebuildColumns();

      /**
       * Вспомогательный метод для расчета пейджинга грида по дискриминатору
       *
       * @param item
       * @return {boolean}
       */
      documentGridCtrl._discriminatorFn = function (item) {
        if (!documentGridCtrl.item.discriminator_field)
          return true;
        return angular.equals(attributeUtilService._getValueDeep(
          item,
          documentGridCtrl.item.discriminator_field.split('.')),
          documentGridCtrl.attributeUtilService._getValueDeep(
            documentGridCtrl.values,
            documentGridCtrl.item.discriminator_value.split('.')));
      };

      /**
       * Метод добавляет новую строку в массив данных грида
       *
       * @param autoGenerate флаг автоматического добавления (не пользователем)
       */
      documentGridCtrl.addRow = function (autoGenerate) {
        var line = documentGridCtrl.item.create_base ?
          angular.copy(documentGridCtrl.item.create_base) : {};
        line._manual = !autoGenerate;

        // добвление поля по discriminator_field
        if (documentGridCtrl.item.discriminator_field && 
            documentGridCtrl.item.discriminator_value && 
            documentGridCtrl.values[documentGridCtrl.item.discriminator_value.split('.')[0]]) {
          var discriminator_value = documentGridCtrl.values[documentGridCtrl.item.discriminator_value.split('.')[0]]
          line[documentGridCtrl.item.discriminator_field.split('.')[0]] = {
            id: discriminator_value.id,
            name: discriminator_value.name
          };
        }

        if (documentGridCtrl.item.edit_row_singly) {
          line.$$editMode = true;
        }

        if (documentGridCtrl.item.discriminator_field &&
          documentGridCtrl.values[documentGridCtrl.item.discriminator_value]) {
          // т.е. если заданы поля фильтрации (дискриминатор) и задано его внешнее значение
          line[documentGridCtrl.item.discriminator_field] = documentGridCtrl.values[documentGridCtrl.item.discriminator_value];
        }
        documentGridCtrl.values[documentGridCtrl.item.code].push(line);
        // установка на страничку, куда добавилось новое поле
        if (documentGridCtrl.pagingOptions.enablePaging) {
          documentGridCtrl._updateTotal();
          documentGridCtrl.setPagingOptions(documentGridCtrl.pagingOptions.total - 1);
        }
      };

      // по умолчанию при редактировании должна быть одна пустая строка (при условии что строк нет)
      if (documentGridCtrl.redact && !documentGridCtrl.values[documentGridCtrl.item.code].length && documentGridCtrl.editable) {
        documentGridCtrl.addRow(true);
      }

      /**
       * Коллбек вызывается при смене страницы
       */
      documentGridCtrl.onPageChanges = function (page) {
        // обновление индексов
        documentGridCtrl._refreshIndexes();
        userSettingsService.saveProperty("documents", "grid", "pagingLimit" + documentGridCtrl.item.code, documentGridCtrl.pagingOptions.limit);

        // убрать редактирование строк, если есть возможность их редактировать
        if (documentGridCtrl.item.edit_row_singly) {
          _.forEach(documentGridCtrl.values[documentGridCtrl.item.code], function (row, key) {
            row.$$editMode = false;
          });
        }
      };

      /**
       * Обновление индексов при изменении структуры страницы данных
       *
       * @private
       */
      documentGridCtrl._refreshIndexes = function () {
        // обновление индексов
        angular.forEach(documentGridCtrl.uniqueIndexes, function (key, value) {
          documentGridCtrl.sendUniqueEvent(value);
        });
      };

      /**
       * Метод рассылает событие для пересчета статуса уникальности (прием на стороне соответствующей директивы)
       *
       * @param unique имя индекса, по которому нужно провести проверку уникальности
       */
      documentGridCtrl.sendUniqueEvent = function (unique) {
        $scope.$broadcast('uniqueDocument' + unique);
      };

      documentGridCtrl.key = function (event) {
        if (event.keyCode == 45) {
          documentGridCtrl.addRow();
          event.stopPropagation();
        }
      };

      /**
       * Метод удаляет строку с переданным значением
       *
       * @param value значение, которое требуется удалить из массива
       */
      documentGridCtrl.removeValue = function (value) {
        var index = documentGridCtrl.values[documentGridCtrl.item.code].indexOf(value);
        if (index !== -1) {
          documentGridCtrl.values[documentGridCtrl.item.code].splice(index, 1);
        }
        // перестроение индекса уникальности
        documentGridCtrl._refreshIndexes();
        documentGridCtrl._updateTotal();
        if (documentGridCtrl.pagingOptions.enablePaging && 
          (documentGridCtrl.pagingOptions.total == documentGridCtrl.pagingOptions.offset)) {
          documentGridCtrl.setPagingOptions(documentGridCtrl.pagingOptions.total);
        }
      };

      /**
       * Включить режим редактирования для строки
       */
      documentGridCtrl.editRow = function (value, event) {
        _.find(documentGridCtrl.values[documentGridCtrl.item.code], function (row, key) {
          if (row.$$hashKey == value.$$hashKey) {
            row.$$editMode = true;
            return true;
          }
        });
      };

      /** Открытие окна настроек */
      documentGridCtrl.openSettings = function () {
        var modal = $uibModal.open({
          size: 'small-width',
          resolve: {
            columns: function () {
              return documentGridCtrl.defaultColumns;
            },
            docType: function () {
              return documentGridCtrl.docType;
            },
            metadata: function () {
              return documentGridCtrl.item;
            }
          },
          controller: 'gridSettingsController',
          controllerAs: 'gridSettingsCtrl',
          templateUrl: 'app/documents/components/document-grid/settings/gridSettings.html'
        });
        // при сохранении настроек грид перестраивается
        modal.result.then(function () {
          documentGridCtrl.rebuildColumns();
        })
      };

      // вычисление высоты начала фиксации заголовков грида
      documentGridCtrl.topShift = function () {
        if (angular.element('.fixed-helper').offset()) {
          return angular.element('.fixed-helper').offset().top;
        }
      };

      // добавление товара из документа в корзину
      documentGridCtrl.addToCart = function (value) {
        if (documentGridCtrl.needAddToCart) {
          var currency = documentGridCtrl.externalData.natural_currency || $rootScope.homeCurrency.currency;
          var item = {
            catalog_item: {
              id: (value.derivative) ? value.derivative.id : value.catalog_item.id,
              name: (value.derivative) ? value.derivative.name : value.catalog_item.name
            },
            quantity: value.quantity,
            uom: {id: value.uom.id, name: value.uom.name},
            natural_price: value.natural_price || value.price || 0,
            currency: {
              id: currency.id,
              name: currency.name,
              char_iso_code: currency.char_iso_code,
              numeric_iso_code: currency.numeric_iso_code,
              symbol: currency.symbol
            },
            tax_group: value.tax_group,
            tax_included: true
          };
          if (value.derivative && value.derivative.derivative) {
            item.derivative = {
              id: value.derivative.derivative.id,
              name: value.derivative.derivative.name
            };
          }
          cartService.addToCart({items: [item]}).then(function (res) {
            cartService.getCartCount().then(function (res) {
              $rootScope.cartCount = res.data.item_count;
              requestStatus.success("Добавление в корзину прошло успешно", 'move', "Перейти в корзину", "#/cart");
            });
          }, function (error) {
            if (error.status == 409 && error.data.code == 'unique_index_violation') {
              errorMessageService.showModal({message: 'Данный товар уже добавлен в корзину', submessage: {}});
            } else {
              requestStatus.error('Во время добавления в корзину произошла ошибка. Повторите попытку позже');
            }
          });
        }
      }
      // TODO
      // if (documentGridCtrl.item.ref && documentGridCtrl.item.ref.length) {
      //   $scope.$watch('documentGridCtrl.values[documentGridCtrl.item.ref[0]]', function(val) {
      //
      //   });
      // }

    }

  }
})();

(function() {
  'use strict';

  /* Компонент для работы с произвольным докуентом в системе на основе метаинформации */
  angular
    .module('frontend')
    .directive('document', document);

  function document() {
    return {
      restrict: 'E',
      scope: {
        redact: '<?', // режим редактиррования
        values: '=', // единая для документа карта значений
        externalData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        purpose: '<', // назначение документа
        document: '<', // информация о документе
        documentMeta: '<', // метаинформация документа
        showHeader: '<?', // флаг отображения заголовка
        formValidation: '=', // проброс статуса валидации формы (на текущий момент всего объекта)
        currencyHome: '<?', // валюта учета
        getCurrenciesRate: '=?', // метод получения курса валют
        amountCalculate: '<?', // метод расчета сумм
        referenceData: '<?', // эталонные данные документа, для вычисления данных с сервера
        formCtrl: '<?', //контроллер формы
        startSaving: '=', // локер для подгрузки данных в грид, означается что запрос отправлен, ответ tit не получен
        formName: '<', // уникальное имя формы, для обращения к полям через контроллер формы
        checkValid: '=?',
        docSettings: '=?', // настройки документов
        needAddToCart: '<?', // необходимость добавлять товары в корзину // todo надо будет вынести этот флаг в мету (например)
        commonMeta: '<' // необходима метf общей информации для манипулирования полями из common meta
      },
      bindToController: true,
      templateUrl: 'app/documents/components/document/document.html',
      controllerAs: 'documentCtrl',
      link: function (scope, element, attrs, documentCtrl) {
        // в линке, т.к. форма в контроллере еще не проинициализирована
        documentCtrl.formValidation = documentCtrl.documentForm;
      },
      controller: function ($scope) {
        var documentCtrl = this;
        // настройка отображения хедера по-умолчанию
        if (documentCtrl.showHeader == undefined) {
          documentCtrl.showHeader = false;
        }

        if (documentCtrl.docSettings) {
          // источник для подстановки цен
          documentCtrl.priceSource = _.find(documentCtrl.docSettings.document_price_source, function(doc){
            return doc.document_type == documentCtrl.document.metadata.document_type.code;
          });
        }

        // хук на внешнее перестроение метаинформации документа
        $scope.$watch('documentCtrl.document', function (newVal) {
          if (documentCtrl.document) { // может быть не определен
            // Формирование рутового блока на основе массива разметок
            if (Array.isArray(documentCtrl.document.layout)) {
              documentCtrl.root = {
                type: "container",
                direction: "COLUMN",
                items: documentCtrl.document.layout,
                docType: documentCtrl.document.metadata.document_type.code
              };
            } else {
              documentCtrl.root = angular.extend(documentCtrl.document.layout, {
                type: "container",
                direction: "COLUMN",
                docType: documentCtrl.document.metadata.document_type.code
              });
            }
          }
        });
      }
    }
  };
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('documentBlock', documentBlock);

  /**
   * Директива для отображения блоков разметки документа
   */
  function documentBlock() {
    return {
      restrict: 'E',
      require: '^^document',
      templateUrl: 'app/documents/components/block/document-block.html',
      bindToController: true,
      controllerAs: 'documentBlockCtrl',
      scope: {
        redact: '<?', // режим редактирования
        values: '=', // единая для документа карта значений
        externalData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        item: '<', // метаинформация о блоке
        currencyHome: '<?', // валюта учета
        getCurrenciesRate: '=?', // метод получения курса валют
        amountCalculate: '<?', //метод расчета сумм
        referenceData: '<?', // эталонные данные документа, для вычисления данных с сервера
        checkValid: '=?',
        needAddToCart: '<?' // необходимость добавлять товары в корзину // todo надо будет вынести этот флаг в мету (например)
      },
      link: function($scope, element, ctrl, documentCtrl){
        $scope.documentBlockCtrl.documentCtrl = documentCtrl;
      },
      controller: function ($scope, currenciesService, $parse) {
        var documentBlockCtrl = this;
        // получение поля курса валют, для скрытия/показ через флаг
        function getRate(){
          return _.find(documentBlockCtrl.item.items, function(item){
            return item.code == "currency_rate";
          });
        }

        // получение поля валюты, для указание её ширины
        function getCurrency(){
          return _.find(documentBlockCtrl.item.items, function(item){
            return item.code == "natural_currency";
          });
        }

        // для скрытия/показа курса валют, в зависимостит от того выбрана валюта учета или нет
        if(documentBlockCtrl.values && documentBlockCtrl.values.natural_currency && documentBlockCtrl.currencyHome){
          var currencyRate = getRate();
          var currency = getCurrency();
          if(currencyRate){
            currencyRate.$$hidden = !(documentBlockCtrl.item && documentBlockCtrl.values.natural_currency.id !== documentBlockCtrl.currencyHome.currency_id);
            // только в режиме просмотра применяется изменение размеров, т.к. добавляется новое полк "Дата учета"
            if (documentBlockCtrl.referenceData.status && documentBlockCtrl.referenceData.status !== "DRAFT") {
              if (currencyRate.$$hidden) {
                currencyRate.flex = 0;
                currency.flex = 1;
              } else {
                currencyRate.flex = 0.4;
                currency.flex = 0.6;
              }
            }
          }
        }

        // событие смены валюты
        documentBlockCtrl.onCurrencyChange = function(currentCurrency, ref){
          var currencyRate = getRate();
          if (currencyRate) {
            currencyRate.$$hidden = currencyRate && currentCurrency.id == documentBlockCtrl.currencyHome.currency_id;
            if(documentBlockCtrl.values.natural_currency){
              documentBlockCtrl.getCurrenciesRate(ref);
            }
          }
        };


        documentBlockCtrl.isVisibleBlock = function(){
          if(documentBlockCtrl.item){
            var visible = false;
            _.forEach(documentBlockCtrl.item.items, function (child) {
              if((!child.visible_purposes ||
                (child.visible_purposes.indexOf(documentBlockCtrl.documentCtrl.purpose) != -1)) &&
                (child.visible == undefined || child.visible)){
                visible = true;
              }
            });

            var properties = (documentBlockCtrl.documentCtrl.document.properties)? documentBlockCtrl.documentCtrl.document.properties.view_properties :
                             (documentBlockCtrl.documentCtrl.document.layout.properties && documentBlockCtrl.documentCtrl.document.layout.properties.view_properties);
            if (properties && !documentBlockCtrl.redact) {
              var blockProp = _.find(properties, function (prop) {
                return prop.type == "container" && documentBlockCtrl.item.class && 
                       documentBlockCtrl.item.class.indexOf(prop.code) + 1;
              });
              if (blockProp && blockProp.is_view_expression) {
                documentBlockCtrl.expression = $parse(blockProp.is_view_expression);
                return !!documentBlockCtrl.expression(documentBlockCtrl.externalData.values) && visible;
              }
            }
            return visible;
          }
          return true;
        }

        documentBlockCtrl.isVisibleField = function (child) {
          var properties = (documentBlockCtrl.documentCtrl.document.properties)? documentBlockCtrl.documentCtrl.document.properties.view_properties :
                             (documentBlockCtrl.documentCtrl.document.layout.properties && documentBlockCtrl.documentCtrl.document.layout.properties.view_properties);
          if (properties && !documentBlockCtrl.redact) {
            var blockProp = _.find(properties, function (prop) {
              return prop.type == "field" && 
                     child.code == prop.code;
            });
            if (blockProp && blockProp.is_view_expression) {
              documentBlockCtrl.expression = $parse(blockProp.is_view_expression);
              return !!documentBlockCtrl.expression(documentBlockCtrl.externalData.values);
            }
          }
          return true;
        }

      }
    }

  }
}) ();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('documentAttribute', documentAttribute)
    .filter('mathPow', function () { // TODO вынести в отдельный компонент
      return function (base, exponent) {
        return Math.pow(base, exponent);
      }
    });

  /**
   * Директива для отображения блоков разметки документа
   */
  function documentAttribute() {
    return {
      restrict: 'E',
      require: '^^document',
      templateUrl: 'app/documents/components/attribute/document-attribute.html',
      bindToController: true,
      controllerAs: 'documentAttributeCtrl',
      scope: {
        redact: '<?', // режим редактиррования
        hideLabel: '<?', // показывать ли подсказку в input
        values: '=', // единежим редактиррованияая для документа карта значений
        externalData: '<', // потребовался дополнительный дата-сет для связанных компонент с внешними
        item: '<', // метаинформация об атрибуте
        onCurrencyChange: '=?', // события на изменение валюты
        currencyHome: '<?', // валюта учета
        referenceData: '<?' // эталонные данные документа, для вычисления данных с сервера
      },
      link: function ($scope, element, ctrl, documentCtrl) {
        $scope.documentAttributeCtrl.documentCtrl = documentCtrl;
      },
      controller: function ($scope, currenciesService,
                            attributeUtilService,
                            companyService,
                            contractService,
                            paymentTypesService,
                            employeesService,
                            catalogService,
                            projectsService,
                            contragentService,
                            expenseItemsService,
                            cashRegistersPlacesSrv,
                            cacheRequest, // кеширующий универсальный сервис
                            inventoryService, // сервис для работы с АПИ склада (партиями и серийными номерами)
                            catalogItemService,
                            egaiszService,
                            utmConnectionsService,
                            $uibModal,
                            $q,
                            crudsService,
                            requestStatus) {
        var documentAttributeCtrl = this;
        
        documentAttributeCtrl.crudsService = crudsService;
        
        documentAttributeCtrl.universalSetterGetter = function (value) {
          if(documentAttributeCtrl.item.code) {
            if (angular.isDefined(value) || arguments.length > 0) {
              return attributeUtilService._setValueDeep(
                documentAttributeCtrl.values,
                documentAttributeCtrl.item.code.split('.'),
                value);
            } else {
              var res = attributeUtilService._getValueDeep(
                documentAttributeCtrl.values,
                documentAttributeCtrl.item.code.split('.'));
              if (documentAttributeCtrl.item.field_type == "FLD_QUANTITY" && !documentAttributeCtrl.redact) {
                res = parseFloat(res).toFixed(documentAttributeCtrl.item.max_after_comma === undefined ? 3 : documentAttributeCtrl.item.max_after_comma);
              }
              return res;
            }
          }
        };

        // обработка флага blockRedactIfSet (блокировка возможности редактировать, если значение установлено)
        if (documentAttributeCtrl.item.block_redact_if_set) {
          var blockDestructor = $scope.$watch('documentAttributeCtrl.values', function (newValue) {
            if (newValue) { // при инициализации общей карты
              if (documentAttributeCtrl.values[documentAttributeCtrl.item.code] != undefined) {
                documentAttributeCtrl.blockRedact = true;
              }
              blockDestructor(); // уничтожение вотчера
            }
          });
        }

        /**
         * Метод вычисляет условие видимости из настроек метаданных,
         * если условие не задано, возвращает true
         *
         * @return {boolean|*}
         */
        documentAttributeCtrl.checkVisibleExpression = function () {
          return !documentAttributeCtrl.item.visible_expression ||
            $scope.$eval(documentAttributeCtrl.item.visible_expression, { values: documentAttributeCtrl.values });
        };

        documentAttributeCtrl.currenciesService = currenciesService;
        documentAttributeCtrl.contractService = contractService;
        documentAttributeCtrl.paymentTypesService = paymentTypesService;
        documentAttributeCtrl.employeesService = employeesService;
        documentAttributeCtrl.catalogService = catalogService;
        documentAttributeCtrl.projectsService = projectsService;
        documentAttributeCtrl.cashRegistersPlacesSrv = cashRegistersPlacesSrv;
        documentAttributeCtrl.companyService = companyService;
        documentAttributeCtrl.contragentService = contragentService;
        documentAttributeCtrl.expenseItemsService = expenseItemsService;
        documentAttributeCtrl.inventoryService = inventoryService;
        documentAttributeCtrl.catalogItemService = catalogItemService;
        documentAttributeCtrl.cacheRequest = cacheRequest;
        documentAttributeCtrl.egaiszService = egaiszService;
        documentAttributeCtrl.utmConnectionsService = utmConnectionsService;

        documentAttributeCtrl.currencyMatchPatern = "{{$select.selected.name + ' (' +$select.selected.char_iso_code+')'}}";
        documentAttributeCtrl.currencyChoicesPatern = "{{( item.name + ' (' + item.char_iso_code + ')' )}}";

        documentAttributeCtrl.matchPatern = "{{$select.selected.name}}";
        documentAttributeCtrl.choicesPatern = "{{item.name}}";

        documentAttributeCtrl.uomMatchPatern = "{{$select.selected.symbols || $select.selected.name}}";
        documentAttributeCtrl.uomChoicesPatern = "{{item.symbols || item.name}}";

        documentAttributeCtrl.matchPaternDerivative = "{{$select.selected.name || $select.selected.full_name}} {{$select.selected.derivative.name}}";
        documentAttributeCtrl.choicesPaternDerivative = "{{item.name || item.full_name}} {{item.derivative.name}}";
        documentAttributeCtrl.matchPaternDerivativeTooltip = "{{$select.selected.alc_code}} {{$select.selected.name || $select.selected.full_name}} {{$select.selected.derivative.name}}";

        documentAttributeCtrl.cashRegisterMatchPatern = "{{$select.selected.manufacturer + '-' + $select.selected.model + ' №' + $select.selected.serial_number}}";
        documentAttributeCtrl.cashRegisterChoicesPatern = "{{item.manufacturer + '-' + item.model + ' №' + item.serial_number}}";

        documentAttributeCtrl.contractMatchPatern = "{{'№' + $select.selected.number + ' от ' + ($select.selected.date | date:'dd.MM.yyyy')}}";
        documentAttributeCtrl.contractChoicesPatern = "{{'№' + item.number + ' от ' + (item.date | date:'dd.MM.yyyy')}}";

        documentAttributeCtrl.companyEgaisMatchPatern = "{{$select.selected.fsrar_id + ' ' + $select.selected.company_name}}";
        documentAttributeCtrl.companyEgaisChoicesPatern = "{{item.fsrar_id + ' ' + item.company_name}}";

        documentAttributeCtrl.productClassifierPatern = "{{$select.selected.code}}";
        documentAttributeCtrl.productClassifierChoicesPatern = "{{item.code + ' ' + item.name}}";

        documentAttributeCtrl.alcoholCounterpartyPatern = "{{($select.selected.short_name || $select.selected.full_name || $select.selected.name || (($select.selected.client_reg_id && !$select.selected.inn)? $select.selected.client_reg_id + ' информация о контрагенте отсутствует в справочнике' : ''))}}";
        documentAttributeCtrl.alcoholCounterpartyChoicesPatern = "{{(item.inn || '-') + '/' + (item.kpp || '-') + ' ' + (item.short_name || item.full_name || item.name || ((item.client_reg_id && !item.inn)? item.client_reg_id + ' информация о контрагенте отсутствует в справочнике' : ''))}}";

        documentAttributeCtrl.cachedDerivativeForFld = documentAttributeCtrl.cacheRequest.cacheRequest('catalogService', 'getItemDerivativeForFldAuto');
        documentAttributeCtrl.getAlcoDerivatives = documentAttributeCtrl.cacheRequest.cacheRequest('egaiszService', 'getAlcoDerivatives');
        documentAttributeCtrl.getProductClassifier = documentAttributeCtrl.cacheRequest.cacheRequest('egaiszService', 'getProductClassifier');
        documentAttributeCtrl.counterpartiesSearch = documentAttributeCtrl.cacheRequest.cacheRequest('contragentService', 'counterpartiesSearch');
        documentAttributeCtrl.getAlcoholCounterparties = documentAttributeCtrl.cacheRequest.cacheRequest('egaiszService', 'getAlcoholCounterparties');

        documentAttributeCtrl.openCounterpartiesMap = function (item, values) {
          $uibModal.open({
            size: 'large-width',
            component: 'counterpartiesMap',
            controllerAs: 'counterpartiesMapCtrl',
            resolve: {
              params: function () {
                return {
                  item: item,
                  values: values
                };
              }
            }
          }).result.then(function (result) {
            documentAttributeCtrl.outsideRefresh();
          });
        }

        documentAttributeCtrl.filterData = function(){
          var data = (!documentAttributeCtrl.values[documentAttributeCtrl.item.source_data])? {data:{}} :
            $q.when({
              data: {
                items: documentAttributeCtrl.values[documentAttributeCtrl.item.source_data],
                total: documentAttributeCtrl.values[documentAttributeCtrl.item.source_data].length
              }
            });
          return $q.when(data);
        }

      }
    }

  }
})();

'use strict';

angular.module('frontend').service('attributeUtilService', function () {

  this._getValueDeep = function (obj, path) {
    if (!path) return obj;
    return path.reduce(function(obj, prop) {
      return obj && obj[prop];
    }, obj);
  };

  this._setValueDeep = function(obj, path, value) {
    if (path.length == 1) {
      return obj[path[0]] = value;
    }
    if (angular.isDefined(obj[path[0]]) == false) {
      obj[path[0]] = {};
    }
    return this._setValueDeep(obj[path[0]], path.slice(1), value);
  };
});

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('widgetWrapper', widgetWrapper);

  /** @ngInject */
  function widgetWrapper($compile, $templateCache) {
    var directive = {
      require: '^widgetContainer',
      restrict: 'E',
      templateUrl: 'app/components/widgets/widget-wrapper/widget-wrapper.html',
      controller: widgetWrapperController,
      controllerAs: 'widgetWrapperCtrl',
      bindToController: true,
      scope: {
        widget: '<'
      },
      link: function (scope, element, attrs, widgetContainerCtrl) {
        scope.widgetWrapperCtrl.widgetContainerCtrl = widgetContainerCtrl;
        var bodyEl = angular.element(element[0].getElementsByClassName('widget-body')[0]);
        var templateEl = angular.element('<' + scope.widgetWrapperCtrl.widget.component + '/>');
        templateEl.attr('options', 'widgetWrapperCtrl.widget.options');
        templateEl.attr('callbacks', 'widgetWrapperCtrl.callbacks');
        templateEl.attr('settingsmode', 'widgetWrapperCtrl.settingsmode');
        templateEl.attr('redact-mode', 'widgetWrapperCtrl.redactMode');
        // добавление виджета в тело враппера
        bodyEl.append(templateEl);
        // компиляция нового участка кода с внешним виджетом
        $compile(templateEl)(scope);
      }

    };
    return directive;

    function widgetWrapperController(userSettingsService) {
      var widgetWrapperCtrl = this;
      widgetWrapperCtrl.callbacks = {};
      // настройки скрыты
      widgetWrapperCtrl.settingsmode = false;
      // режим редактирвоания
      widgetWrapperCtrl.redactMode = false;
      // технический момент, чтобы не усложнять проверки
      widgetWrapperCtrl.widget.eventHandlers = widgetWrapperCtrl.widget.eventHandlers || {};
      // состояние свернутого/развернутого виджета
      widgetWrapperCtrl.rollUp = userSettingsService.loadProperty('widget', 'rollUp', widgetWrapperCtrl.widget.settingsComponent, widgetWrapperCtrl.rollUp) || false;

      /**
       * Метод меняет флаг скрыти/раскрытия виджета.
       * И записывает флаг в стору.
       */
      widgetWrapperCtrl.changeRollUp = function () {
        widgetWrapperCtrl.rollUp = !widgetWrapperCtrl.rollUp;
        userSettingsService.saveProperty('widget', 'rollUp', widgetWrapperCtrl.widget.settingsComponent, widgetWrapperCtrl.rollUp);
      }
           
      /**
       * Метод открывает в модальном окне компонент настроек, переданный в описании виджета.
       * Компоненту передается параметр widget с текущим описанием виджета. В дальнейшем resolve, видимо, будет расширяться.
       */
      widgetWrapperCtrl.openSettings = function () {
        if(widgetWrapperCtrl.callbacks.save) {
          widgetWrapperCtrl._changeMode();
        }
      };

      /**
       * Смена режима редактирования на активный
       */
      widgetWrapperCtrl.changeRedactMode = function () {
        if (widgetWrapperCtrl.widget.allowRedactMode) {
          // если режим редактирования доступен для виджета
          widgetWrapperCtrl.redactMode = true;
        }
      };

      /**
       * Сохранение
       */
      widgetWrapperCtrl.save = function () {
        if(widgetWrapperCtrl.callbacks.save) {
          // вызов колбека на стороне пользовательского компонента, встроенного во враппер
          var promiseCandidate = widgetWrapperCtrl.callbacks.save();
          if (promiseCandidate && typeof promiseCandidate.then == 'function') {
            promiseCandidate.then(function (data) {
              if (widgetWrapperCtrl.widget.eventHandlers.changeModeEventHandler) {
                // вызов колбека сохранения настроек
                widgetWrapperCtrl.widget.eventHandlers.saveEventHandler(data);
              }
              widgetWrapperCtrl._changeMode();
              return;
            }, function () {
              // TODO: ошибка сохранения, обработка предполагается на стороне кастомного компонента, хотя лучше вынести сюда
              return; // выход без смены состояния
            });
          }
        }
        if (widgetWrapperCtrl.widget.eventHandlers.changeModeEventHandler) {
          // вызов колбека сохранения настроек
          widgetWrapperCtrl.widget.eventHandlers.saveEventHandler({});
        }
        // для всех не основных сценариев просто меняется режим
        widgetWrapperCtrl._changeMode();
      };

      /**
       * Отмена
       */
      widgetWrapperCtrl.dismiss = function () {
        if(widgetWrapperCtrl.callbacks.dismiss) {
          var promiseCandidate = widgetWrapperCtrl.callbacks.dismiss();
          if (promiseCandidate && typeof promiseCandidate.then == 'function') {
            promiseCandidate.then(function (data) {
              widgetWrapperCtrl._changeMode();
              return; // выход без смены состояния
            }, function () {
              // ошибка отмены, вряд ли такое случится, но универсальная возможность при возврате промиса дожна быть обработана
              return;
            });
          }
        }
        widgetWrapperCtrl._changeMode();
      };

      /**
       * Смена состояния
       *
       * @private
       */
      widgetWrapperCtrl._changeMode = function () {
        widgetWrapperCtrl.settingsmode = !widgetWrapperCtrl.settingsmode;
        if (widgetWrapperCtrl.widget.eventHandlers.changeModeEventHandler) {
          // вызов колбека смены режима
          widgetWrapperCtrl.widget.eventHandlers.changeModeEventHandler({
            newMode: widgetWrapperCtrl.settingsmode
          });
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('widgetContainer', {
      templateUrl: 'app/components/widgets/widget-container/widget-container.html',
      controller: widgetContainerController,
      controllerAs: 'widgetContainerCtrl',
      bindings: {
        widgets: '<'
      }
    });

  function widgetContainerController(userSettingsService) {
    var widgetContainerCtrl = this;

    // сохранение последовательности виджета в сторе
    function saveWidgetSequence() {
      var widgetSequence = [];
      if (widgetContainerCtrl.widgets[0].options && widgetContainerCtrl.widgets[0].options.pageName) {
        _.forEach(widgetContainerCtrl.widgets, function (widget) {
          widgetSequence.push(widget.settingsComponent);
        });
        userSettingsService.saveProperty(widgetContainerCtrl.widgets[0].options.pageName, "widget", "sequence", widgetSequence);
      }
    }

    widgetContainerCtrl.pullUp = function (widget) {
      var index = widgetContainerCtrl.widgets.indexOf(widget);
      // только если эдемент найден и не первый в списке
      if (index > 0) {
        var temp = widgetContainerCtrl.widgets[index - 1];
        widgetContainerCtrl.widgets[index - 1] = widget;
        widgetContainerCtrl.widgets[index] = temp;
      }
      saveWidgetSequence();
    }

    widgetContainerCtrl.pushDown = function (widget) {
      var index = widgetContainerCtrl.widgets.indexOf(widget);
      // только если эдемент найден и не последний в списке
      if (~index && index != widgetContainerCtrl.widgets.length - 1) {
        var temp = widgetContainerCtrl.widgets[index + 1];
        widgetContainerCtrl.widgets[index + 1] = widget;
        widgetContainerCtrl.widgets[index] = temp;
      }
      saveWidgetSequence();
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('frontend')
  .component('entityHistory', {
    replace: true,
    bindings: {
      entityData: '<?'
    },
    templateUrl: 'app/components/ux-elements/entity-history/entity-history.html',
    controller: function($state) {
      var ctrl = this;
      ctrl.showHistory = (ctrl.entityData.created_at || ctrl.entityData.created_by) && ($state.current.name.endsWith('view') || $state.current.name.endsWith('edit'));
    } // controller end
  });

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('selectChoicesPaging', selectChoicesPaging);

  /** @ngInject */
  function selectChoicesPaging() {
    return {
      require: 'uiSelect',
      restrict: 'A',
      link: function($scope, element, attr, ctrl) {
        var leftArr = angular.element(document.createElement('span')),
            rightArr = angular.element(document.createElement('span')),
            paginBox = angular.element(document.createElement('span')),
            method = element.find('ui-select-choices').attr('refresh'),
            originalFunctionClose,
            originalFunctionActivate,
            originalFunctionClear,
            originalFunctionRefresh,
            init = true;

        element.addClass('select-with-paging');
        $scope.$select.offset = 0;

        function showHideArrow(){
          if(!$scope.$select.offset){
            leftArr.addClass('ng-hide');
          }else{
            leftArr.removeClass('ng-hide');
          }
          if(attr.itemsTotal >= $scope.$select.offset + 5){
            rightArr.removeClass('ng-hide');
          }else{
            rightArr.addClass('ng-hide');
          }
        }

        function initialization() {
          if (init) {
            init = false;
            var dropdown = element.find('.ui-select-choices li');
            leftArr.addClass('left-arr').addClass('ng-hide');
            rightArr.addClass('right-arr');
            paginBox.addClass('paging-box');
            //paginBox.text(parceInt(attr.itemsTotal/5));
            dropdown.append(leftArr);
            dropdown.append(rightArr);
            dropdown.append(paginBox);

            leftArr.click(function(){
              if($scope.$select.offset){
                $scope.$select.offset -= 5;
              }
              $scope.$select.refresh(method);
              showHideArrow();
            });
            rightArr.click(function(){
              if(attr.itemsTotal >= $scope.$select.offset + 5){
                $scope.$select.offset += 5;
              }
              $scope.$select.refresh(method);
              showHideArrow();
            });
          }
        }

        /**
         * Подмена метода ctrl.close с дальнейшим вызовом оригинального метода
         */
        originalFunctionClose = ctrl.close;
        ctrl.close = function (skipFocusser) {
          $scope.$select.offset = 0;
          showHideArrow();
          if (! this.ngModel.$error.notFound) {
            originalFunctionClose.call(this, skipFocusser);
          }
        };

        /**
         * Подмена метода ctrl.activate с дальнейшим вызовом оригинального метода
         */
        originalFunctionActivate = ctrl.activate;
        ctrl.activate = function () {
          originalFunctionActivate.call(this);
          element.tooltip('hide');
          initialization();
        };

        /**
         * Вотчер на изменение тотала, чтобы проставить правильно пэйджинг
         */
        $scope.$watch(function () {return attr.itemsTotal}, function(newVal) {
          showHideArrow();
        });

      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('modelSaveField', modelSaveField);

  function modelSaveField() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: function link($scope, $elm, $attr, ngModel) {
        $attr.modelSaveField = $attr.modelSaveField || 'value';

        function preventEvent(e) {
          e.stopPropagation();
        }
        $elm.on('scroll', preventEvent);
        $elm.on('mousewheel', preventEvent);

        ngModel.$parsers.push(function(val) {
          $elm.removeClass('has-selected-item').addClass(function() {
            return val.length ? 'has-selected-item' : ''
          });
          return val.map(function(item) {
            return item[$attr.modelSaveField]
          })
        })
      }
    };

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('universalLoginInput', universalLoginInput);

  /** @ngInject */
  function universalLoginInput() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        isPhone: '=?',
        isEmail: '=?',
        onlyPhoneEmail: '<?'
      },
      link: function (scope, element, attrs, ngModelCtrl) {

        // обработка натсройки валидирвоать только телефон или email
        if (attrs.onlyPhoneEmail) {
          ngModelCtrl.$validators.validPhoneOrEmail = function (modelValue, viewValue) {
            if (modelValue) {
              return !!(scope.isPhone || scope.isEmail);
            } else {
              return true;
            }
          };
        }

        /**
         * Билдер шаблона телефонного номера
         *
         * @param all
         * @param p1 первая группа паттерна
         * @param p2 вторая группа паттерна
         * @param p3 третья группа паттерна
         * @param p4 четверная группа паттерна
         * @return {string} собранный телефонный номер в формате (999) 999-99-99
         * @private
         */
        var _phoneBuilder = function (all, p1, p2, p3, p4) {
          return (p1 && p2 ? '(' + p1 + ') ' : (p1 || '')) + [p2, p3, p4].filter(function (elem) {
            return !!elem;
          }).join('-');
        };

        /**
         * Вспомогательная функция для обработки входной строки
         *
         * @param str входная строка (с телефонным номером от пользователя)
         * @private
         */
        var _transformPhone = function (str) {
          return str.replace(/[()\s-]/g, '') // убираем пробелы, символы, использующиеся для написания номера телефона
            .replace(/[^\d]/g, '') // убираем все символы кроме цифр
            // формируем номер телефона из номеров без кода страны
            .replace(/^.*?(\d\d\d)(\d{0,3})?(\d{0,2})?(\d{0,2})?\d*$/g, _phoneBuilder);
        };

        /**
         * Направление вывода модели в вид.
         * На момент создания требуется только первичное форматироваиние.
         */
        ngModelCtrl.$formatters.push(function (value) {
          if (!value) {
            // само значение не меняется и остается undefined
            return value;
          }
          // если значение полностью соответсвует телефону
          if (value.match(/^9\d{9}$/g)) {
            scope.isPhone = true;
            scope.isEmail = false;
            return _transformPhone(value.toString());
          }
          // если значение соответствует email (email не форматируется)
          if (value.match(/^\S+@\S+\.\S+$/g)) {
            scope.isPhone = false;
            scope.isEmail = true;
          }
          return value;
        });

        /**
         * Направление вывода вида в модель
         */
        ngModelCtrl.$parsers.push(function (value) {
          if (!value) {
            return value;
          }

          var valueClear = value.replace(/[()\s-]/g, '');
          var valueClearEmail = value.replace(/[\s]/g, '');

          // случай уже форматированного как нужно номера телефона
          if (value.match(/^\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/g)) {
            ngModelCtrl.$viewValue = _transformPhone(value.toString());
            scope.isPhone = true;
            scope.isEmail = false;
            return valueClear;
          }

          if (valueClear.match(/^89\d{9}$/g)) {
            valueClear = valueClear.replace(/^8(\d{10})/g, '$1');
            ngModelCtrl.$viewValue = _transformPhone(valueClear);
            scope.isPhone = true;
            scope.isEmail = false;
          } else if (valueClear.match(/^79\d{9}$/g)) {
            valueClear = valueClear.replace(/^7(\d{10})/g, '$1');
            ngModelCtrl.$viewValue = _transformPhone(valueClear);
            scope.isPhone = true;
            scope.isEmail = false;
          } else if (valueClear.match(/^\+79\d{9}$/g)) {
            valueClear = valueClear.replace(/^\+7(\d{10})/g, '$1');
            ngModelCtrl.$viewValue = _transformPhone(valueClear);
            scope.isPhone = true;
            scope.isEmail = false;
          } else if (valueClear.match(/^9\d{9}$/g)) {
            ngModelCtrl.$viewValue = _transformPhone(valueClear);
            scope.isPhone = true;
            scope.isEmail = false;
          } else if (valueClearEmail.match(/^\S+@\S+\.\S+$/g)) { // случай email (берется нативная строка)
            scope.isPhone = false;
            scope.isEmail = true;
            valueClear = valueClearEmail;
          } else {
            ngModelCtrl.$viewValue = value;
            scope.isPhone = false;
            scope.isEmail = false;
          }

          ngModelCtrl.$render();

          return valueClear;
        });
      }
    };
    return directive;
  }
})();

(function () {
  'use strict';

  /**
   * Директива принимает на вход целое число, но при отображении последние два символа показываются как дробная часть.
   * С точки зрения модели значение всегда целочисленное, все преобразования дробных частей скрыты в директиве.
   */
  angular
    .module('frontend')
    .directive('inputPrice', inputPriceDirective);

  /** @ngInject */
  function inputPriceDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      replace: false,
      scope: {},
      link: function ($scope, element, attr, ngModelController) {
        
        element.on('blur', function (e) {
          var processedViewValue = ngModelController.$viewValue;
          if (ngModelController.$viewValue.match(/[,.]\d$/g)) {
            //.replace(/(?<=[.,]\d$)/g, '0') - из-за риска отсутсвия поддержки Look-behind в старых браузерах, пока ноль добавляем руками
            processedViewValue += '0';
          }
          processedViewValue = processedViewValue ? processedViewValue
            .match(/\d+(,\d{2})?/g)[0] // убираем лишние символы (точность 2 знака)
            .replace(/\B(?=(\d{3})+(?:([,.]\d*)?)$)/g, ' ') // добавляем пробелы
            : "0,00";
          ngModelController.$setViewValue(processedViewValue);
        });

        element.on('focus', function (e) {
          var processedViewValue = ngModelController.$viewValue
            .replace(/\s/g, '') // убираем пробелы
            .replace(/^0,00/g, '') // убираем 0,00 из значния для удобного ввода
            .replace(/,00$/, ''); // убираем копейки, если их значимое значение отсутствует
          ngModelController.$setViewValue(processedViewValue);

          // установка начала ввода в целую часть
          if (processedViewValue.startsWith('0,')) {
            element[0].setSelectionRange(1, 1);
          }
        });

        element.on('keypress', function (e) {
          // разные браузеы испоьлзуют разные поля (event - глобальное событие в прототипе window)
          var charCode = (event.which) ? event.which : event.keyCode;

          // блокирование дублей
          if ((charCode == 44 || charCode == 46) && ~ngModelController.$viewValue.search(/\,/g)) {
            e.preventDefault();
            return false;
          }

          if (charCode != 44 && charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
            return false;
          }

          return true;
        });

        /**
         * Направление вывода модели в вид
         */
        ngModelController.$formatters.push(function (value) {
          if (!value) {
            // само значение не меняется и остается undefined
            return (attr.hideZero)? '' : '0,00';
          }
          return value.toString()
            .replace(/^(?=\d$)/g, '0')
            .replace(/^(?=\d{2}$)/g, '0')
            .replace(/\B(?=\d{2}$)/g, ',');
        });

        /**
         * Преобразование вида в модель
         */
        ngModelController.$parsers.push(function (value) {
          var parsedView = value.toString()
            .replace(/[^0-9,.\s]/g, '') // удаляем все символы кроме запятой и цифр
            .replace(/^0+(?=\d+)/g, '') // удаляем нули в начале строки
            .replace(/\./g, ',') // заменяем точку на запятую
            .replace(/[,](?=.*[,])/g, ''); // удаляем все запятые кроме последней

          // сохранение позиции курсора
          var start = element[0].selectionStart;
          var end = element[0].selectionEnd;

          // отобразим в инпуте преобразованную строку, для того, чтобы представление пользователя
          // о ввеенном значение соответствовало программе обработки
          ngModelController.$viewValue = parsedView;
          ngModelController.$render();

          // восстановление позиции курсора
          element[0].setSelectionRange(start, end);

          parsedView = parsedView.replace(/\s/g, ''); // убираем пробелы

          var parts = parsedView.split(','); // разбиваем строку на целую и дробную части (от которй берем тольок 2 символа)
          if (parts[1] && parts[1].length == 1) {
            //.replace(/(?<=[.,]\d$)/g, '0') - из-за риска отсутсвия поддержки Look-behind в старых браузерах, пока ноль добавляем руками
            parts[1] += '0'; // для корректного счета
          }
          return +parts[0] * 100 + (parts[1] ? +parts[1].substring(0, 2) : 0);
        });

      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('phoneInput', phoneInput);

  /** @ngInject */
  function phoneInput() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ngModelCtrl) {

        /**
         * Блок добавляет флаг в начало инпута, не самое эдегантное решение TODO: посмотреть как лушче
         */
        var flagEl = angular.element(document.createElement('DIV'));
        flagEl.addClass('input-flag');
        flagEl.html('<div class="flag-ru"></div><div class="phone-code"><span class="phone-code-text">+7</span></div>');
        element.addClass('phone-input');
        element.after(flagEl);


        /**
         * Билдер шаблона телефонного номера
         *
         * @param all
         * @param p1 первая группа паттерна
         * @param p2 вторая группа паттерна
         * @param p3 третья группа паттерна
         * @param p4 четверная группа паттерна
         * @return {string} собранный телефонный номер в формате (999) 999-99-99
         * @private
         */
        var _phoneBuilder = function (all, p1, p2, p3, p4) {
          return (p1 && p2 ? '(' + p1 + ') ' : (p1 || '')) + [p2, p3, p4].filter(function (elem) {
            return !!elem;
          }).join('-');
        };

        /**
         * Вспомогательная функция для обработки входной строки
         *
         * @param str входная строка (с телефонным номером от пользователя)
         * @private
         */
        var _transformPhone = function (str) {
          return str.replace(' ', '') // убираем пробелы
            .replace(/[^\d]/g, '') // убираем все символы кроме цифр
            .replace(/^.*?(\d\d\d)(\d{0,3})?(\d{0,2})?(\d{0,2})?\d*$/g, _phoneBuilder); // формируем номер телефона из номеров без кода страны
        };

        /**
         * Направление вывода вида в модель
         */
        ngModelCtrl.$parsers.push(function (value) {
          var valueClear = value.replace(/[()\s-]/g, '');
          if (!valueClear) {
            return null;
          }

          // сохранение позиции курсора с учетом трансформации подстроки до курсора
          var start, end = start = _transformPhone(valueClear.toString().substring(0, element[0].selectionStart)).length;

          ngModelCtrl.$viewValue = _transformPhone(value.toString());


          // восстановление позиции курсора
          element[0].setSelectionRange(start, end);
          ngModelCtrl.$render();
          ngModelCtrl.$commitViewValue();
          return valueClear;
        });

        /**
         * Направление вывода модели в вид
         */
        ngModelCtrl.$formatters.push(function (value) {
          if (!value) {
            // само значение не меняется и остается undefined
            return value;
          }
          return value.toString().replace(' ', '') // убираем пробелы
            .replace(/[^\d]/g, '') // убираем все символы кроме цифр
            .replace(/^.*?(\d\d\d)(\d{0,3})?(\d{0,2})?(\d{0,2})?\d*$/g, _phoneBuilder);
        });

        element.on('keypress', function (e) {
          // разные браузеы испоьлзуют разные поля (event - глобальное событие в прототипе window)
          var charCode = (event.which) ? event.which : event.keyCode;

          if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            e.preventDefault();
            return false;
          }

          return true;
        });
      }
    };
    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('okvedInput', {
      replace: true,
      bindings: {
        company: '=',
        triggerUpdate: '=',
        mode: '<'
      },
      templateUrl: 'app/components/inputs/okved-input/okved-input.html',
      controllerAs: 'vm',
      controller: function ($scope, companyService) {
        var vm = this;
        vm.suggestions = [];
        var okvedRegexp = new RegExp('^((\\d\\d\\.\\d\\d\\.\\d\\d)|(\\d\\d\\.\\d\\d\\.\\d)|(\\d\\d\\.\\d\\d)|(\\d\\d\\.\\d)|(\\d\\d))$');
        var ngModel = null;

        vm.$postLink = function() { // бинд ngModel изначально отсутствует в контроллере
          ngModel = $scope.okvedContainer.okved;
        };

        vm.updateOkved = function (data) { // обновление модели
          if (data.data) {
            vm.company.organization.legal_requisites.okved = data.data.code;
            vm.company.organization.legal_requisites.okved_name = data.data.name;
            vm.suggestions = [];
          }
        };

        vm.refresh = function (searchString, blurEvent) {
          ngModel.$setValidity('okvedCode', true); // Сброс невалидного состояния
          var isCode = okvedRegexp.test(searchString); // проверка что в строке
          if (isCode && blurEvent) searchString = searchString.trim(); // уничтожение пробелов
          if (!searchString) { // если значения, сборос okved_name и не посылаем запрос
            vm.company.organization.legal_requisites.okved_name = null;
            return;
          }
          // запрос Okved по searchString , при blur запрашиваем больше suggestions
          companyService.okvedCheck(searchString, blurEvent ? 100 : 5).then(function (res) {
            vm.suggestions = res.data;

            if (blurEvent) {
              if (!vm.suggestions.length || !isCode) { // если пришло 0 вариантов
                onNotFound()
              }
              // поиск подходящего значения по полному совпадению с code , подстановка при успехе
              var okvedData = _.find(vm.suggestions, function (value) {return value.data.code === searchString});
              if (okvedData) vm.updateOkved(okvedData);
            }
          }).catch(function () {
            if (blurEvent) onNotFound();
          });
        };


        if (vm.triggerUpdate) { // установка внешней функции
          vm.triggerUpdate = triggerUpdate;
        }

        function triggerUpdate() {
          if (vm.company.organization.legal_requisites.okved) {
            companyService.okvedCheck(vm.company.organization.legal_requisites.okved).then(function (res) {
              var item = res.data[0];
              if (item) {
                vm.updateOkved(item);
              }
            })
          }
        }



        function onNotFound() { // сброс okved_name и проверка что вписано в поле код или нет
          vm.company.organization.legal_requisites.okved_name = null;
          ngModel.$setValidity('okvedCode', okvedRegexp.test(vm.company.organization.legal_requisites.okved));
        }

      }
    });
  //component ends
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('okpoInput', {
      replace: true,
      bindings: {
        company: '=',
        mode: '<'
      },
      templateUrl: 'app/components/inputs/okpo-input/okpo-input.html',
      controllerAs: 'vm',
      controller: function ($scope, companyService) {
        var vm = this;

        vm.keyupInput = function () {
          var isValid = vm.checkOkpo(vm.company.organization.legal_requisites.okpo);
          vm.okpoForm.okpo.$setValidity('okpo', isValid);
        }

        vm.checkOkpo = function (value) {
          if(!value) return false
          var expectedValue = Number(value.slice(-1))
          var getWeight = function (index) {
            if(index < 10) return index + 1
            else return index % 10 + 1 
          }
          var testingValue = value.slice(0, -1)
          let summ = 0
          for(var i in testingValue.split('')){
            summ += Number(testingValue[i]) * getWeight(Number(i))
          }
          let del11 = summ % 11
          if(del11 === 10){
            summ = 0
            for(var i in testingValue.split('')){
              summ += Number(testingValue[i]) * ( getWeight(Number(i)) + 2)
            }
            del11 = (del11  === 10) ? 0 : del11
          }
          return (del11 === expectedValue)
        };
      }
    });

})();

(function() {
  'use strict';

  angular
  .module('frontend')
  .directive('multiselectWrapper', multiselectWrapper);

  /** @ngInject */
  function multiselectWrapper() {
    return {
      restrict: 'E',
      require: 'ngModel',
      scope: {
        model:'=ngModel',
        settings: "<", // должно содержать все настройки для мультиселекта
        change: "<" // переводы строк
      },
      templateUrl: 'app/components/inputs/multiselect-wrapper/multiselect-wrapper.html',
      controllerAs: 'multiselectCtrl',
      bindToController: true,
      controller: function($scope, $uibModal, categoryService, OPTIONS_LENGTH) {
        var multiselectCtrl = this;

        if (!multiselectCtrl.model) {
          multiselectCtrl.model = [];
        }

        multiselectCtrl.translationTexts = {
          checkAll: 'Выбрать все',
          uncheckAll: 'Очистить',
          buttonDefaultText: 'Выберите значение'
        };

        multiselectCtrl.multiselectEvents = {
          onItemSelect: function(item){
            multiselectCtrl.change(multiselectCtrl.model, multiselectCtrl.settings);
          },
          onItemDeselect: function(item){
            multiselectCtrl.change(multiselectCtrl.model, multiselectCtrl.settings);
          },
          onSelectAll: function(){
            multiselectCtrl.change(multiselectCtrl.model, multiselectCtrl.settings);
          },
          onDeselectAll: function(){
            multiselectCtrl.change([], multiselectCtrl.settings);
          }
        };


      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('customMultiChoose', {
      bindings: {
        getData: '<', // список для выбора
        selectedArr: '=', // массив выбранных значений
        viewPatern: '<', // шаблон для отображения в поле
        selectedPatern: '<', // шаблон для записи необходимого поля в model
        limit: '<?',
        sortBy: '<?'
      },
      templateUrl: 'app/components/inputs/custom-ui-multiselect/custom-ui-multiselect.html',
      controllerAs: 'customUiMultiselectCtrl',
      controller: function ($scope, attributeUtilService) {
        var customUiMultiselectCtrl = this;
        customUiMultiselectCtrl.limit = customUiMultiselectCtrl.limit || 5;
        customUiMultiselectCtrl.sortBy = customUiMultiselectCtrl.sortBy || 'name';
        
        customUiMultiselectCtrl.selectedItems = [];// для корректного отображения выбранных элементов
        customUiMultiselectCtrl.selectedArr = customUiMultiselectCtrl.selectedArr || [];// для модели id-шников

        customUiMultiselectCtrl.clickItem = function(event, index, currentItem){
          var selectedVal = attributeUtilService._getValueDeep(currentItem,
                                                               customUiMultiselectCtrl.selectedPatern.split('.'));
          event.preventDefault();
          event.stopPropagation();
          customUiMultiselectCtrl.selectedItems.push(currentItem);
          customUiMultiselectCtrl.selectedArr.push(selectedVal);
          customUiMultiselectCtrl.list.splice(index, 1);
          customUiMultiselectCtrl.searchItem();
        };

        customUiMultiselectCtrl.removeItem = function (event, index) {
          event.preventDefault();
          event.stopPropagation();
          customUiMultiselectCtrl.selectedItems.splice(index, 1);
          customUiMultiselectCtrl.selectedArr.splice(index, 1);
          customUiMultiselectCtrl.searchItem();
        };

        customUiMultiselectCtrl.resetAll = function (event) {
          event.preventDefault();
          event.stopPropagation();
          customUiMultiselectCtrl.selectedItems = [];
          customUiMultiselectCtrl.selectedArr = [];
          customUiMultiselectCtrl.searchItem();
        }

        customUiMultiselectCtrl.searchItem = function (){
          customUiMultiselectCtrl.getData(customUiMultiselectCtrl.search_string, customUiMultiselectCtrl.selectedArr.length + customUiMultiselectCtrl.limit).then(function(res){
            if (customUiMultiselectCtrl.selectedArr && customUiMultiselectCtrl.selectedArr.length) {
              // убираем из списка выбранные элементы
              var data = _.filter(res.data.items, function (item) {
                return !_.find(customUiMultiselectCtrl.selectedArr, function (selected) {
                  return selected == attributeUtilService._getValueDeep(item,
                                                                        customUiMultiselectCtrl.selectedPatern.split('.'));
                });
              });
              customUiMultiselectCtrl.list = _.sortBy(data, customUiMultiselectCtrl.sortBy);
              customUiMultiselectCtrl.total = res.data.total;
            } else {
              customUiMultiselectCtrl.list = _.sortBy(res.data.items, customUiMultiselectCtrl.sortBy);
              customUiMultiselectCtrl.total = res.data.total;
            }
          });
        };
        customUiMultiselectCtrl.searchItem();

      }
    });
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('customMultiselect', {
      bindings: {
        list: '=', // список для выбора
        selected: '=', // массив выбранных значений
        height: '<?', // высота поля
        viewPatern: '<', // шаблон для отображения в поле
        isOneSelected: '<?', // флаг для множественного или одинарного выбора
        deleteCallback: '<?', // callback на удаление элемента из списка
        scrollKey: '=?' // автоскроллк нужному элементу
      },
      templateUrl: 'app/components/inputs/custom-multiselect/custom-multiselect.html',
      controllerAs: 'customMultiselect',
      controller: function ($scope) {
        var customMultiselect = this;

        customMultiselect.configScroll = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          scrollButtons: {
            enable: false
          },
          setHeight: customMultiselect.height,
          scrollInertia: 0,
          axis: 'y'
        };
        
        customMultiselect.scrollTo = function(index){
          customMultiselect.callbacks.updateScrollbar("scrollTo", index * 22);
        }

        $scope.$watch(function(){
          return customMultiselect.scrollKey;
        }, function (newVal) {
          if (newVal !== undefined) {
            customMultiselect.scrollTo(newVal);
          }
        });

        customMultiselect.clickItem = function(currentItem){
          if(customMultiselect.isOneSelected){ // случай одиночного выбора
            if(!currentItem.$$selected){
              _.forEach(customMultiselect.list, function(item){
                  item.$$selected = false;
              });
            }
            currentItem.$$selected = !currentItem.$$selected;
            customMultiselect.selected = (currentItem.$$selected)? [currentItem] : [];
          }else{ // случай множественного выбора
            currentItem.$$selected = !currentItem.$$selected;
            customMultiselect.selected = _.filter(customMultiselect.list, function(item){
              if(item.$$selected){
                return item;
              }
            });
          }
        };

        customMultiselect.removeItem = function (item){
          customMultiselect.deleteCallback(item);
        };

      }
    });
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('combobox', combobox);


  function combobox() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/inputs/combobox/combobox.html',
      scope: {
        ngModel: '=',
        placeholder:'<?',
        refresh: '=',
        isRequired: '<?',
        title: '<?',
        idName: '<?',
        choose: '<',
        maxlength: '<?',
        isDisabled: '<?',
        arrItems: '=', // массив для выпадающего списка
        param: '<',// имя параметра в объекте, который надо выводить в выпадающем списке
        fieldLabel: '<',
        total: '<',
        isOpen: '=?', // флаг открыт ли автокомплит
        blurEvent: '<?'
      },
      link: function($scope, element,attr,ctrl) {
      },
      controller: comboboxController,
      controllerAs: 'vm'
    } // return end

    function comboboxController($scope, $element) {
      var vm = this;
      vm.name = $scope.ngModel;

      $scope.$watch('ngModel', function(newVal, oldVal) {
        vm.name = newVal;
      });
      
      vm.keyUp = _.debounce($scope.refresh, 500);
      vm.choose = function(item){
        $scope.ngModel = vm.name = item[$scope.param];
        $scope.choose(item);
      }

      vm.changeIsOpen = function(bool){
        if($scope.isOpen){
          $scope.isOpen.isOpen = bool;
        }
      }
    }


  } // function end
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('clearButton', clearButton);

  /** @ngInject */
  function clearButton($compile) {
    return {
      require: 'ngModel',
      scope: {
        callback:'&?'
      },
      restrict: 'A',
      link: function(scope, element, attrs, modelCtrl) {
        scope.modelCtrl = modelCtrl;

        // Отступ справа
        element.addClass('clear-input');

        // проверка через $viewValue работает, но я встрачал проверку через elem.val() - нужно понаблюдать
        var resetButtonTemplate = $compile('<b ' +
          'title="Очистить" ng-click="clear()" ' +
          'ng-show="modelCtrl.$viewValue" ' +
          'class="clear-button"' +
          '></b>')(scope);
        element.after(resetButtonTemplate);

        scope.clear = function() {
          modelCtrl.$setViewValue('');
          modelCtrl.$render();
          if (scope.callback) {
            scope.callback();
          }
          // Запрос фокуса (может быть не очень актуально)
          setTimeout(function() {
            element[0].focus();
          }, 0);
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('checkbox', checkbox);


  function checkbox() {
    return {
      restrict: 'E',
      replace: true,
      require: 'ngModel',
      templateUrl: 'app/components/inputs/checkbox/checkbox.html',
      scope: {
        mode: '<?',
        checkboxId: '@',
        model: '=ngModel',
        text:'<'
      },
      link: function($scope, element,attr,ctrl) {
      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
  .module('frontend')
  .directive('inputCategory', inputCategory);

  /** @ngInject */
  function inputCategory() {
    return {
      restrict: 'E',
      require: 'ngModel',
      scope: {
        model:'=ngModel',
        onClose: '<?',
        fieldName: '<',
        label: '<?',
        isSlimControl: '<?',
        position: '<?', // направление выпадающего списке (up/down)
        onlyAutocomplete: '<?', // скрыть возможность открытия попапаи использовать только автокомплит
        hasPlaceholder: '<?',
        required: '<?',
        hiddenItems: '<?',
        selectClass: '<?',
        disableClearance: '<?', // прячит крестик для очистки выбранной сущности
        triggers: '=?'// триггеры передаваемые в родительский компонент
      },
      templateUrl: 'app/components/inputs/category-input/category-input.html',
      controllerAs: 'inputCategoryCtrl',
      bindToController: true,
      controller: function($scope, $uibModal, categoryService, OPTIONS_LENGTH) {
        var inputCategoryCtrl = this;
        inputCategoryCtrl.selectMatchPattern = '{{$select.selected.name}}';
        inputCategoryCtrl.selectChoicesPattern = '{{item.name}}';
        inputCategoryCtrl.optionLength = OPTIONS_LENGTH;
        inputCategoryCtrl.items = [];

        inputCategoryCtrl.refresh = function(searchString) {
          categoryService.getCategoriesAuto(searchString).then(function(res) {
            inputCategoryCtrl.items = !!inputCategoryCtrl.hiddenItems
              ? res.data.items.filter(function (value) {
                  return !~inputCategoryCtrl.hiddenItems.indexOf(value.id);
                })
              : res.data.items;
            inputCategoryCtrl.itemsTotal = res.data.total;
          });
        };

        inputCategoryCtrl.totalStr = function(){
          if(inputCategoryCtrl.itemsTotal > inputCategoryCtrl.optionLength){
            return "Показано " + inputCategoryCtrl.optionLength + " из " + inputCategoryCtrl.itemsTotal;
          }
          return '';
        };

        inputCategoryCtrl.onChange = function(value) {
          if (inputCategoryCtrl.onClose) {
            inputCategoryCtrl.onClose(value, inputCategoryCtrl.fieldName);
          }
        };

        inputCategoryCtrl.openChooseCategoryDialog = function() {
          return $uibModal.open({
            templateUrl: 'app/price-list/modal/new-price-item.modal.html',
            size: 'large-width',
            resolve: {
              categoryInputMode: true,
              type: function(){
                return null;
              },
              hiddenItems: function () {
                return inputCategoryCtrl.hiddenItems
              }
            },
            controller: 'newPriceItemModalController',
            controllerAs: 'newPriceItemModalCtrl',
            bindToController: true
          }).result.then(function(value) { // при успешном закрытии модельного окна переоткрывается деерво
            inputCategoryCtrl.model = value;
            if (inputCategoryCtrl.onClose) {
              inputCategoryCtrl.onClose(value, inputCategoryCtrl.fieldName);
            }
            return value
          });
        };

        if (inputCategoryCtrl.hasOwnProperty('triggers')) {
          inputCategoryCtrl.triggers = {};
          inputCategoryCtrl.triggers.openChooseCategoryDialog = inputCategoryCtrl.openChooseCategoryDialog;
        }


      }
    }
  }
})();

(function() {
  'use strict';
  angular
    .module('frontend')
    .directive('activityAreas', activityAreas);

  /** @ngInject */
  function activityAreas() {
    return {
      restrict: 'EA',
      require: 'ngModel',
      replace: false,
      scope: {
        fieldName: '<?', // название поля
        isRequired:'<?',// обязательность
        hasError: '=' // флаг ошибки
      },
      templateUrl: 'app/components/inputs/activity-areas/activity-areas.html',
      controllerAs: 'activityAreasCtrl',
      bindToController: true,
      link: function ($scope, element, attr, ngModelController) {
        $scope.ngModelController = ngModelController;
      },
      controller: function($scope, $uibModal, utilsService, $q) {
        var activityAreasCtrl = this;
        activityAreasCtrl.areas = [];
        $scope.currentSelectionTree = [];

          activityAreasCtrl.removeItemData = function(index) {
          activityAreasCtrl.areas.splice(index, 1);
          $scope.ngModelController.$setViewValue(activityAreasCtrl.areas);
        };

        activityAreasCtrl.activityAreasPopup = function (field) {
          activityAreasCtrl.ngModelController = $scope.ngModelController;
          $uibModal.open({
            templateUrl: 'app/components/inputs/activity-areas/modal/activity-areas-popup.html',
            size: 'large-width',
            controller: function ($scope, $uibModalInstance) {
              // Флаг - переключатель между деревом и результатами поиска
              $scope.showSearch = false;
              $scope.$watch('searchText', function (newVal, oldVal) {
                if (oldVal && !newVal) { // Если не пустое значение меняется на пустое (в широком смысле)
                  $scope.showSearch = false; // Смена вида на каталог
                }
              });

              $scope.close = function () {
                $uibModalInstance.dismiss();
              };
              // настройка скролла
              $scope.configScroll = {
                axis: 'y',
                autoHideScrollbar: false,
                theme: 'dark',
                advanced: {
                  updateOnContentResize: true
                },
                setHeight: 459,
                scrollInertia: 200,
                scrollButtons: {
                  enable: false // enable scrolling buttons by default
                }
              }

              // Узлы дерева
              $scope.root = {
                name: 'Сферы',
                root: true,
                has_children: true,
                children: []
              };

              $scope.allowCheckbox = function(item){
                return !item.child_areas || !item.child_areas.length;
              }

              $scope.selectNode = function(selectedItem, node){
                if (node && node._path) {
                  $scope.root.expandFunc(node._path).then(function (lastNode) {
                    lastNode.checked = !lastNode.checked;
                  });
                }
              }

              /* метод раскрывает узлы дерева по пути */
              $scope.expandTreePath = function (path) {
                $scope.root.expandFunc(path).then(function () {
                  $scope.showSearch = false;
                }, function () {
                  $scope.showSearch = false;
                });
              }

              /* Метод поиска в дереве каталога участника */
              $scope.search = function () {
                utilsService.getActivityAreasAuto($scope.searchText).then(
                  function (data) {
                    $scope.searchResult = data.data.values;
                    $scope.currentSelectionTree = $scope.root.getSelectionModel();
                    $scope.showSearch = true;
                  },
                  function (error) {
                    $log.log('Ошибка при поиске: ' + error);
                  }
                )
              };

              /* Метод возвращает кол-во выбраных элементоа в поиске*/
              $scope.checkedLength = function(){
                return _.where($scope.searchResult, {_checked: true}).length;
              };

              /* Callback для раскрытия дерева */
              $scope.expand = function (node, nextPage) {
                var categoryPromise;
                var itemPromise;
                // Загрузка дочерних категорий только при установленном флаге наличия
                if (!nextPage && node.has_children) {
                  categoryPromise = utilsService.getАctivityАreas().then(function (data) {
                    if (data.data) {
                      return data.data;
                    }
                  });
                } else {
                  categoryPromise = $q.when([]);
                }

                var page = nextPage ? {
                  offset: node.children.length
                  // лимит по-умолчанию определяется в сервисе
                } : undefined;

                // Загрузка дочерних элементов только при их наличии
                if (node.child_areas) {
                  itemPromise = $q.when(node.child_areas);
                } else {
                  itemPromise = $q.when([]);
                }
                // Композиция промисов, и конкатенация результатов (в итоге компонент дерева не в курсе нескольки запросов при callback и остается универсальным)
                return $q.all([categoryPromise, itemPromise]).then(function (values) {
                  angular.forEach(values[1], function (item) {
                    item.unstructure = true;
                    item.has_children = false;
                    item.item_count = 0;
                  })
                  return values[0].concat(values[1]);
                })
              }

              $scope.choose = function () {
                var selectionModel;
                // в зависимости от того, какой контрол отображается (дерево или результат поиска) исользуем различные модели выбора
                if ($scope.showSearch) {
                  // случай активного поиска
                  selectionModel = _.map(_.where($scope.searchResult, {_checked: true}), function (obj) {
                    return obj;
                  });
                } else {
                  // случай активного дерева
                  selectionModel = $scope.root.getSelectionModel();
                }
                // Формирование нужной структуры запроса по списку выбраннх узлов
                activityAreasCtrl.areas = _.map(selectionModel, function (node) {
                  return {
                    name: node.name,
                    id: node.id,
                    $$path: node._path
                  }
                });
                activityAreasCtrl.hasError = !activityAreasCtrl.areas.length;
                activityAreasCtrl.ngModelController.$setViewValue(activityAreasCtrl.areas);
                $uibModalInstance.dismiss();
              }

              // Callback загрузки дерева
              $scope.onTreeLoaded = function () {
                $scope.root.expandFuncByModel({}).then(function () {
                  var paths = [];
                  angular.forEach(activityAreasCtrl.areas , function (item) {
                    if (item.$$path) {
                      paths.push(item.$$path);
                    }
                  });
                  $scope.root.checkByPaths(paths);
                });
              };

            }
          });
        }
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('frontend').directive('filterBlock', filterBlockDirective);

  function filterBlockDirective() {
    return {
      restrict: 'E',
      scope: {
        searchTrigger: '<',
        filters: '=',
        config: '<',
        searchText: '=',
        initialBaseMode: '<',
        noSearchOnLoad: '<?'
      },
      templateUrl: 'app/components/gird-wide-addons/filter-block/filter-block.html',
      controller: function ($scope, categoryService, $timeout, dateRangePickerApiService, helpService, catalogItemService) {
        $scope.filterData = {};
        $scope.dateStates = {};
        $scope.isValidForm = true;
        $scope.multiselectCode = '';
        var isIssetDefaultVal = false;
        var tomorrow = helpService.now().clone().add(1, 'day');
        var placeholderForDateRange = " ";
        var containsBaseModeField = !!$scope.config.filterFields.find(function(value) {return value.code === 'base_mode'});
        var balanceFieldValues = [
          {
            id: 'ANY',
            name: 'Любой'
          },
          {
            id: 'POSITIVE',
            name: 'Положительный'
          },
          {
            id: 'NEGATIVE',
            name: 'Отрицательный'
          },
          {
            id: 'ZERO',
            name: 'Нулевой'
          },
          {
            id: 'NON_ZERO',
            name: 'Ненулевой'
          }
        ];

        if (containsBaseModeField) {
          $scope.filterData.base_mode = $scope.initialBaseMode;
        }

        $scope.onSelect = function(selectedItem, code, field) {
          $scope.filters[code] = selectedItem ? selectedItem.id : null;
          if (field.onSelect) {
            field.onSelect();
          }

          if(code === 'company_id'){
            if (!$scope.filters[code]) {
              $scope.filters.division_id = null;
              $scope.filters.contract_id = null;
            }
            $scope.getDivisions();
            $scope.getContracts();
          }
          if(code === 'counterparty_id'){
            if (!$scope.filters[code]) {
              $scope.filters.contract_id = null;
            }
            $scope.getContracts();
          }
          if(code === 'item_id'){
            if (!$scope.filters[code]) {
              $scope.filters.stock_item_id = null;
            }
            $scope.getStockItems(selectedItem.id);
          }
          if(code === 'filter_domain_catalog_item_ids'){
            $scope.filters[code] = selectedItem.derivative.id;
          }
          if ($scope.filtersForm) {
            $scope.isValid();
          }
        };

        $scope.changeMultiselect = function(res, field){
          $timeout(function(){
            if (res && res.length) {
              $scope.filters[field.code] = _.map(res, function(item){
                return item.id;
              });
            } else {
              $scope.filters[field.code] = null;
            }
          }, 0)
        }

        $scope.onDatePickerClose = function(returnValue, name) {
          $scope.filters[name] = !returnValue.isEmpty && !returnValue.isAllTime ? returnValue : tomorrow.clone();
          $timeout(function(){
            $scope.isValid();
          },0);
        };

        $scope.onCategoryPopupClose = function(category, name) {
          $scope.filters[name] = category ? category.id : null;
        };

        $scope.onCheckBoxChange = function(value, name) {
          $scope.filterData[name] = value;
          $scope.filters[name] = value;
          if (name === 'base_mode') {
            $scope.$emit('base_mode_changed', value);
          }
        };

        $scope.onInputChange = function(value, name) {
          $scope.filters[name] = value;
        };

        $scope.isValid = function(){
          //если форма не валидна сама по себе то не делаем лишних проверок
          if(!$scope.filtersForm.$valid){
            $scope.isValidForm = false;
            $scope.filtersForm.$setDirty();
          }else if ($scope.config) {
            angular.forEach($scope.config.filterFields, function(filterItem){
              // если есть обязательные интервалы, то их проверять отдельно,т.к. в ng-model у них всегде объект
              if((filterItem.type === "dateRange") && filterItem.required && $scope.filtersForm[filterItem.code]){
                if($scope.filtersForm[filterItem.code].$modelValue === placeholderForDateRange){
                  $scope.isValidForm = false;
                  $scope.filtersForm[filterItem.code].$setValidity('required', false);
                  $scope.filtersForm[filterItem.code].$setDirty();
                }else{
                  $scope.filtersForm[filterItem.code].$setValidity('required', true);
                }
              }
            });

            if ($scope.config.preventRequest) {
              var requiredFilters = $scope.config.filterFields.filter(function(value) { return value.required });
              $scope.isValidForm = requiredFilters.some(function(value) { return $scope.filters[value.code]})
            } else {
              $scope.isValidForm = true;
            }
          } else {
            $scope.isValidForm = true;
          }
          return $scope.isValidForm;
        }

        $scope.staticfields = [
          {
            code: 'category_id',
            selectMatchPattern: '{{ $select.selected.name }}',
            selectChoicesPattern: '{{ item.name }}',
            type: 'categorySearch',
            name: 'Категория'
          },
          {
            code: 'company_id',
            selectMatchPattern: '{{ $select.selected.name }}',
            selectChoicesPattern: '{{ item.name }}',
            type: 'select',
            name: 'Компания',
            items: []
          },
          {
            code: 'division_id',
            disabled: false,
            selectMatchPattern: '{{ $select.selected.name }}',
            selectChoicesPattern: '{{ item.name }}',
            type: 'select',
            name: 'Подразделение',
            items: []
          }
        ];

        $scope.fields = (!$scope.config.withoutStaticFilters)? $scope.staticfields.concat($scope.config.filterFields) : $scope.config.filterFields;

        function disableField(field) {
          field.disabled = true;
          $scope.$applyAsync(function () {
            $scope.filtersForm[field.code].$setPristine();
            $scope.filtersForm[field.code].$setUntouched();
            $scope.filtersForm[field.code].$setValidity('notFound', true);
          })
        }

        function setFieldDisability(field) {
          if (field.items.length === 0) {
            disableField(field)
          } else if (field.items.length === 1 && (field.code === 'division_id' || field.code === 'company_id' || field.code === 'stock_item_id' )) {
            disableField(field);
            $scope.filterData[field.code] = field.items[0];
          } else {
            field.disabled = false;
          }
        }

        angular.forEach($scope.config.selectValues, function(value, key) {
          var field = $scope.fields.find(function(item) { return item.code === key });
          if (field)  {
            if(key !== 'division_id' && key !== 'contract_id' && key !== 'stock_item_id'){
              field.items = value;
            }
            setFieldDisability(field);
          }
        });

        $scope.getDivisions = function(id, divisionId){
          var field = $scope.fields.find(function(item) { return item.code === "division_id" });
          if ($scope.config.selectValues.division_id && field) {
            $scope.filterData.division_id = null;
            var companyID = id || ($scope.filterData.company_id ? ($scope.filterData.company_id.id || $scope.filterData.company_id) : null);
            $scope.config.selectValues['division_id'](companyID).then(function(data) {
              field.items = companyID ? data.data : data.data.items;
              setFieldDisability(field);
              if (divisionId) {
                $scope.filterData.division_id = field.items.find(function(value) { return value.id === divisionId });
              }
            });
          }
        };

        $scope.getContracts = function(contractId, companyId, counterpartyId){
          var field = $scope.fields.find(function(item) { return item.code === "contract_id" });
          if ($scope.config.selectValues.contract_id && field) {
            var company_id = companyId || (($scope.filterData.company_id)? ($scope.filterData.company_id.id? $scope.filterData.company_id.id : $scope.filterData.company_id) : null),
                counterparty_id = counterpartyId || (($scope.filterData.counterparty_id)? ($scope.filterData.counterparty_id.id? $scope.filterData.counterparty_id.id : $scope.filterData.counterparty_id) : null);
            $scope.filterData.contract_id = undefined;
            $scope.config.selectValues['contract_id'](company_id, counterparty_id).then(function(data) {
              field.items = data.data.items;
              setFieldDisability(field);
              if (contractId) {
                $scope.filterData.contract_id = field.items.find(function(value) { return value.id === contractId });
              }
            });
          }
        };

        $scope.getStockItems = function (id, stockItemId) {
          var field = $scope.fields.find(function(item) { return item.code === "stock_item_id" });
          if ($scope.config.selectValues.stock_item_id && field) {
            $scope.filterData.stock_item_id = null;
            var catalogItemID = id || ($scope.filterData.item_id ? $scope.filterData.item_id : null);
            
            if (catalogItemID) {
              $scope.config.selectValues['stock_item_id'](catalogItemID).then(function(data) {
                field.items = data.data.items;
                setFieldDisability(field);
                if (stockItemId) {
                  $scope.filterData.stock_item_id = field.items.find(function(value) { return value.id === stockItemId });
                }
              });
            }
          }
        };

        $scope.getCatalogItem = function (item_id, stock_id) {
          catalogItemService.getSkus(item_id).then(function (res) {
            $scope.filterData.item_id = {
              name: res.data.name,
              id: item_id
            };
            $scope.getStockItems(item_id, stock_id);
          }, function () {
            catalogItemService.getService(item_id).then(function (res) {
              $scope.filterData.item_id = {
                name: res.data.name,
                id: item_id
              };
              $scope.getStockItems(item_id, stock_id);
            });
          });
        }

        if ($scope.config.selectValues.company_id) {
          if ($scope.config.selectValues.company_id.length === 1) {
            $scope.getDivisions($scope.config.selectValues.company_id[0].id);
          } else {
            $scope.getDivisions($scope.filters.company_id);
          }
        }

        var balanceField = $scope.fields.find(function(item) { return item.code === 'balance' });
        if (balanceField) {
          balanceField.items = balanceFieldValues;
        }

        var dateField = $scope.fields.find(function(item) { return item.code === 'date' && item.type === 'date' });
        if (dateField) {
          $scope.filters.date = tomorrow.clone().valueOf();
        }

        // подстановка значений по умолчанию
        angular.forEach($scope.config.filterFields, function(filter){
          if (filter.default) {
            isIssetDefaultVal = true;
            if ((filter.default.startDate &&  filter.default.startDate._d.toString() !== 'Invalid Date') || 
                (filter.default.endDate &&  filter.default.endDate._d.toString() !== 'Invalid Date')) {
              filter.default.isAllTime = false;
              $scope.onDatePickerClose(filter.default, filter.code);
              $scope.filterData[filter.code] = filter.default;
            }
            if (!filter.default.startDate && !filter.default.endDate) {
              $scope.filters[filter.code] = (filter.default.id)? filter.default.id : filter.default;
              $scope.filterData[filter.code] = filter.default;
              if (filter.type == 'select') {
                $scope.onSelect(filter.default, filter.code, filter);
              }
              if (filter.type == 'checkbox') {
                $scope.onCheckBoxChange(filter.default == "true", filter.code);
              }
            }
          }
        });


        angular.forEach($scope.filters, function(value, key) {
          if (!$scope.filterData[key]) {
            var field = _.find($scope.fields, function(item) { return item.code === key});
            if (field) {
              var filterValue = value;
              if ( field.type == 'select') {
                filterValue = _.find(field.items, function (item) { return value.id === item.id || value === item.id });
                if (!filterValue && key === 'division_id') {
                  $scope.getDivisions($scope.filters.company_id, value.id || value);
                }
                if (!filterValue && key === 'contract_id') {
                  $scope.getContracts(value.id || value);
                }
              }
              if (key === 'date' && value !== tomorrow.valueOf() && field.type !== 'dateRange') {
                filterValue = moment.utc(value)
              }
              if (key === 'date' && field.type === 'dateRange' && value.startDate && value.endDate) {
                filterValue = {
                  startDate: moment.utc(value.startDate),
                  endDate: moment.utc(value.endDate)
                }
              }
              if (key === 'category_id') {
                categoryService.getCustomCategory(value).then(function(res) {
                  $scope.filterData[key] = res.data;
                })
              }
              if (key === 'item_id') {
                $scope.getCatalogItem($scope.filters.item_id, $scope.filters.stock_item_id || $scope.filters.stock_item_id);
              }
              $scope.filterData[key] = filterValue;
            }
          }

        });

        var contractField = $scope.config.filterFields.find(function(item) { return item.code === "contract_id" });
        $scope.getContracts((contractField && contractField.default && contractField.default.id) || null, $scope.filters.company_id, $scope.filters.counterparty_id);

        if (isIssetDefaultVal) {
          var validData = true;
          _.forEach($scope.config.filterFields, function(filter){
            if (filter.required && !$scope.filters[filter.code]) {
              validData = false;
            }
          });
          for (var prop in $scope.filterData) {
            if (!$scope.filterData[prop] && !$scope.filters[prop]) {
              $scope.filters[prop] = undefined;;
            }
          }
          if (validData && !$scope.noSearchOnLoad) $scope.searchTrigger($scope.filters, true);
        }
        
      }
    };
  }
})();
(function() {
  'use strict';

  angular.module('frontend').directive('gridMenu', gridMenu);

  function gridMenu($timeout) {

    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cellTemplates/grid-menu/grid-menu.html',
      controller: gridMenuController,
      link: function (scope, elem) {
        elem.bind('DOMMouseScroll mousewheel wheel', function (e) {
          e.preventDefault();
        });
      }
    };

    return directive;

    function gridMenuController($scope, $element) {
      var gridScope = $scope.$parent.grid;

      $scope.clickModal = function(event) {
        event.stopPropagation();
      };

      $scope.columnDefs = angular.copy(gridScope.options.columnDefs);
      $scope.visibleColumnsCount = 0;

      $scope.columnDefs.forEach(function (item) {
        if(item.settedVisibility !== undefined){
          item.visible = item.visible || item.settedVisibility;
        } else {
          item.settedVisibility = item.visible;
        }
        if(item.visible) {
          $scope.visibleColumnsCount ++;
        }
      });

      // for drag&drop
      var helpIndex, listCount;

      $scope.listMoved = function (index, item, parent) {
        if(listCount < parent.length){
          if(helpIndex > index){
            parent.splice(index, 1)
          } else {
            parent.splice(index + 1, 1)
          }
        }
      };

      $scope.dropCallback = function (index, item, external, type, parent){
        helpIndex = index;
        listCount = parent.length;
        parent.splice(index, 0, item);
      };

      // настройки для скролла
      $scope.configScroll = {
        autoHideScrollbar: false,
        theme: 'dark-thick',
        advanced:{
          updateOnContentResize: true
        },
        setHeight: 383,
        scrollInertia: 0
      };

      // события кнопок
      $scope.default = function(){
        gridScope.options.columnDefs = angular.copy(gridScope.appScope.defaultColumns);
        $scope.columnDefs = gridScope.options.columnDefs;
        gridScope.appScope.columnVisibilityChanged();
        $scope.hideMenu();
      };

      $scope.save = function(){
        $scope.columnDefs.forEach(function(col) {
          col.visible = col.settedVisibility;
        });

        for (var i = 0; i < $scope.columnDefs.length; i++) {
          gridScope.options.columnDefs[i].visible = $scope.columnDefs[i].settedVisibility;
        }


        // Копирование колонок нужно для работы с перемещения колонок
        gridScope.options.columnDefs = angular.copy($scope.columnDefs);

        gridScope.appScope.columnVisibilityChanged();
        $scope.hideMenu();
      }
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('cellWithTooltipMoney', cellWithTooltipMoney);

  function cellWithTooltipMoney($timeout, $filter) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cellTemplates/cell-with-tooltip-money/cell-with-tooltip-money.html',
      scope: {
        text: '<',
        currencySymbol: '<'
      },
      link: function ($scope, $element) {
        var placement = 'left bottom';
        
        $element.tooltip({
          trigger: 'manual',
          placement: function () {
            return placement
          },
          title: function () {
            return $filter('currency')($scope.text / 100, '', 2) + ' ' +  $scope.currencySymbol;
          },
          template: '<div class="tooltip currency-font no-arrow" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        });
        $element.on('mouseover', function () {
          var cell = $element.children()[0];
          var span = cell.children[0];
          var isFits = span.offsetWidth + 1 > (cell.clientWidth - 32); //сравнение ширины
          var right = Math.abs(angular.element(window).width() / 2 - cell.getBoundingClientRect().right);
          var left = Math.abs(angular.element(window).width() / 2 - cell.getBoundingClientRect().left);
          placement = right > left ? 'left' : 'right';
          if (isFits) {
            $element.tooltip('show');
          }
        });
        $element.on('mouseleave', function () {
          $element.tooltip('hide');
        });
      }
    };

    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('cellWithTooltip', cellWithTooltip);

  function cellWithTooltip($timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cellTemplates/cell-with-tooltip/cell-with-tooltip.html',
      scope: {
        text: '<',
        tooltipText: '<?',
        pullRight: '<?'
      },
      link: function ($scope, $element, attrs) {
        var placement = 'left';
        $element.addClass('tooltip-light');
        if($scope.text && $scope.text.toString().indexOf("___________") + 1){
          $scope.text = "—";
          return;
        }

        function recalculateCycle() {
          if (attrs.hasOwnProperty('cycle') && $scope.text && angular.isArray($scope.text)) {
            var text = '';
            $scope.text.forEach(function(item, i, items) {
              text += item[attrs.cycle] + (i + 1 < items.length ? ', ' : '')
            });
            $scope.text = text;
          }
        }

        if (attrs.hasOwnProperty('cycle') && $scope.text && angular.isArray($scope.text)) {
          recalculateCycle();
          $scope.$watch('text', recalculateCycle);
        }


        $element.tooltip({
          trigger: 'manual',
          placement: function () {
            return placement
          },
          title: function () {
            return ($scope.tooltipText || $scope.text || '').replace('&nbsp;', ' ');
          },
          template: '<div class="tooltip no-arrow" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        });
        $element.on('mouseover', function () {
          var cell = $element.children()[0];
          var span = cell.children[0];
          var isFits = span.offsetWidth + 1 > (cell.offsetWidth - 32); //сравнение ширины
          var right = Math.abs(angular.element(window).width() / 2 - cell.getBoundingClientRect().right);
          var left = Math.abs(angular.element(window).width() / 2 - cell.getBoundingClientRect().left);
          placement = right > left ? 'left' : 'right';
          if ($scope.tooltipText || isFits) {
            $element.tooltip('show');
          }
        });
        $element.on('mouseleave', function () {
          $element.tooltip('hide');
        });
      }
    };

    return directive;
  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('cellWithRequestedData', cellWithRequestedData)
  .filter('formattedAmount', function () {
    return function (num) {
      var formatter = new Intl.NumberFormat('ru', {useGrouping: true, minimumFractionDigits: 3});
      return angular.isDefined(num) ? formatter.format(num) : ''
    };
  });
  function cellWithRequestedData() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cellTemplates/cell-with-requested-data/cell-with-requested-data.html',
      scope: {
        config: '<'
      },
      link: function ($scope, $elm, $attr) {
        $scope.height = $elm.find('.ui-grid-cell-contents')[0].offsetHeight;
      },
      controller: function($scope, inventoryService) {
        calculateMode();
        function setMode() {
          console.log($scope.config)
          $scope.mode = $scope.config.row.stock_accounting_type;
          if (/(BY_LOTS)/.test($scope.mode)) {
            $scope.mode = 'BY_LOTS'
          }
          if ($scope.reserve) {
            $scope.mode = 'RESERVES'
          }
        }

        $scope.getText = function() {
          if ($scope.config.row && $scope.config.field) {
            return $scope.config.row[$scope.config.field.replace('dataValue.', '')]
          }
        };

        function calculateMode() {
          $scope.onlyReadMode = $scope.config.row && $scope.config.row.stock_accounting_type === 'SIMPLE' && !$scope.reserve;
        }


        $scope.onCellClick = function() {
          calculateMode();
          if ($scope.showPopup) {
            $scope.showPopup = !$scope.showPopup;
          } else {
            if (!$scope.onlyReadMode && $scope.config.row) {
              setMode();
              if($scope.getText()){
                requestData()
              }
            }
          }
        };

        $scope.getLotStr = function(obj){
          var str = "Партия №" + obj.lot_number;
          if(obj.manufacture_date || obj.expiration_date){
            str += " (";
            if(obj.manufacture_date){
              str += moment(obj.manufacture_date).format('DD.MM.YYYY');
            }
            if(obj.manufacture_date && obj.expiration_date){
              str += " - ";
            }
            if(obj.expiration_date){
              str += moment(obj.expiration_date).format('DD.MM.YYYY');
            }
            str += ")";
          }
          return str;
        }

        function onRequestSuccess(res) {
          $scope.uomSymbol = $scope.config.row.uom.symbols; // единицы измерения
          $scope.requestedData = res.data.items;
          $scope.paging.total = res.data.total;
          $scope.paging.offset = res.data.offset;
          $scope.showPopup = !$scope.showPopup;
        }

        function onRequestError(error) {
          $scope.showPopup = false;
        }


        $scope.paging = {
          limit: 5,
          offset: 0,
          total: 0
        };

        $scope.forward = function() {
          $scope.paging.offset += $scope.paging.limit;
          requestData()
        };

        $scope.backWard = function () {
          $scope.paging.offset -= $scope.paging.limit;
          requestData()
        };

        function requestData() {
          if ($scope.config.requestPath === 'stock') {
            return inventoryService[$scope.config.requestPath + $scope.mode]({
              stock_period_total_id: $scope.config.row.stock_period_total_id,
              transaction_type: $scope.config.reserve
            }, $scope.paging).then(onRequestSuccess, onRequestError)
          } else if ($scope.config.requestPath === 'stockTotal') {
            var filters = angular.copy($scope.config.currentFilters);
            var params = {
              filter_division_id: filters.division_id || ($scope.config.row.division ? $scope.config.row.division.id : undefined),
              filter_date_from: moment.isMoment(filters.date.startDate) ? filters.date.startDate.valueOf(): filters.date.startDate,
              filter_date_to: moment.isMoment(filters.date.endDate) ? filters.date.endDate.valueOf(): filters.date.endDate,
              stock_total_type: $scope.config.stockType
            };
            if ($scope.mode === 'BY_LOTS') {
              params.filter_derivative_id = $scope.config.row.derivative.id;
              params.base = filters.base_mode
            } else if ($scope.mode === 'BY_SERIAL_NUMBERS') {
              params.filter_derivative_id = $scope.config.row.derivative.id;
            }
            return inventoryService[$scope.config.requestPath + $scope.mode](params, $scope.paging).then(onRequestSuccess, onRequestError)
          }
        }
      }
    };

    return directive;
  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('cellSelectFilter', cellSelectFilter);

  function cellSelectFilter($document, $window) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cellTemplates/cell-select-filter/cell-select-filter.html',
      scope: {
        col: '<'
      },
      link: function link($scope, $elm, $attr) {
        angular.element(document.querySelector('.ui-grid-viewport')).on('scroll', function (event) {
          return docScroll(event)
        });

        var lastScrollLeft = angular.element(document.querySelector('.ui-grid-viewport')).scrollLeft();

        function docScroll(evt) {
          var documentScrollLeft = $(evt.target).scrollLeft();
          if (lastScrollLeft !== documentScrollLeft) {
            // angular.element(document.querySelector('.ui-select-container.open')).html('');
            lastScrollLeft = documentScrollLeft;
          }
        }
      }
    };

    return directive;
  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('cellMultipleSelectFilter', cellMultipleSelectFilter);

  function cellMultipleSelectFilter($document, $window, $timeout) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cellTemplates/cell-multiple-select-filter/cell-multiple-select-filter.html',
      scope: {
        col: '<',
        filter: '@'
      },
      link: function link($scope, $elm, $attr) {
        angular.element(document.querySelector('.ui-grid-viewport')).on('scroll', function (event) {
          return docScroll(event)
        });
        $scope.filter = $scope.filter || 'uppercase';

        var lastScrollLeft = angular.element(document.querySelector('.ui-grid-viewport')).scrollLeft();

        function docScroll(evt) {
          var documentScrollLeft = $(evt.target).scrollLeft();
          if (lastScrollLeft !== documentScrollLeft) {
            // angular.element(document.querySelector('.ui-select-container.open')).html('');
            lastScrollLeft = documentScrollLeft;
          }
        }

        $scope.onCloseButtonClick = function() {
          $scope.col.filters[0].term = [];
        };

        var onClick = function (event) {
          _.forEach($document.querySelectorAll('multiselect'), function (multiselect) {
            var selectWrap = multiselect.closest(".select-wrap");
            if (!selectWrap)
              return;
            $timeout(function() {
              if (multiselect.querySelector('ul').style.display == "block") {
                multiselect.closest(".select-wrap").classList.add("open");
              } else {
                multiselect.closest(".select-wrap").classList.remove("open")
              }
            }, 0);
            
          });
        }

        $document.on('click', 'body', onClick);

      }
    };

    return directive;
  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('cellForGtins', cellForGtins);

  function cellForGtins() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/cellTemplates/cell-for-gtins/cell-for-gtins.html',
      scope: {
        col: '<'
      },
      link: function ($scope, $elm, $attr) {
        $scope.text = generateString();

        function generateString() {
          var string = '';
          if($scope.col){
            $scope.col.forEach(function(value, i) {
              string += i + 1 !== $scope.col.length ?  value.gtin + ', ' : value.gtin;
            });
          }
          return string;
        }
      }
    };

    return directive;
  }
})();

(function() {
  'use strict';

  angular.module('frontend').directive('cellForFooter', cellForFooter);

  function cellForFooter($timeout) {
    var directive = {
      restrict    : 'E',
      templateUrl : 'app/components/cellTemplates/cell-for-footer/cell-for-footer.html',
      scope: {
        gridInstance  : '<',
        totalType     : '<',
        totalSubType  : '<'
      },
      controller: cellForFooterController
    };

    return directive;

    /** @ngInject */
    function cellForFooterController($scope) {
      $scope.totalValue = 0;

      if ($scope.totalType) {
        $scope.totalValue = ($scope.gridInstance.options.data && $scope.gridInstance.options.data[0]  &&
          $scope.gridInstance.options.data[0].dataTotals[$scope.totalType] )
          ? $scope.gridInstance.options.data[0].dataTotals[$scope.totalType][$scope.totalSubType]
          : 0;
      } else {
        $scope.totalValue = $scope.gridInstance.options.data && $scope.gridInstance.options.data[0]
          ? $scope.gridInstance.options.data[0].dataTotals[$scope.totalSubType]
          : 0;
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('cellDatePickerFilter', cellDatePickerFilter);

    function cellDatePickerFilter($timeout, dateRangePickerService) {
      return {
        restrict: 'E',
        templateUrl: 'app/components/cellTemplates/cell-date-picker-filter/cell-date-picker-filter.html',
        scope: {
          col: '<',
          correctTimezone: '<?',
          opts: '<',
          name: '@',
          parentScope: '=scope'
        },
        controller: function ($scope, auth) {
          $scope.callback = function (returnValue, name) {
            $scope.parentScope.ctrl.filter[name] = {
              startDate: returnValue.startDate && returnValue.startDate.valueOf(),
              endDate: returnValue.endDate && returnValue.endDate.valueOf(),
              dateRange: returnValue
            };
            if (returnValue && returnValue.isAllTime) {
              delete $scope.parentScope.ctrl.filter[name];
            }
            $scope.parentScope.ctrl.updateFilter($scope.parentScope.ctrl.filter);
          };

          auth.ensureUserData().then(function (user) {
            var offsetManual;
            if (user.data.user && user.data.user.time_zone_ext) {
              offsetManual = user.data.user.time_zone_ext.offset;
            } else {
              offsetManual = moment.parseZone(new Date()).format('Z');
            }
            var offset = dateRangePickerService.createMinuteOffsetValue(offsetManual);
            var model = ($scope.parentScope.ctrl.filter[$scope.name] && $scope.col.filter.term)
              ? {
                startDate: moment($scope.parentScope.ctrl.filter[$scope.name].startDate).subtract(offset, 'minutes'),
                endDate: moment($scope.parentScope.ctrl.filter[$scope.name].endDate).subtract(offset, 'minutes')
              }
              : {
                startDate: moment(),
                endDate: moment(),
                isAllTime: true
              };

            if (typeof model.startDate === 'number') {
              model.startDate = moment(model.startDate);
              model.endDate = moment(model.endDate);
            }

            if (typeof model.endDate === 'number') {
              model.startDate = moment(model.startDate);
              model.endDate = moment(model.endDate);
            }

            $scope.model = model;

            $scope.$watch('parentScope.ctrl.showFilter', function (val) {
              if (!val) {
                model = null;
              }

              $scope.model = model || {
                startDate: moment(),
                endDate: moment(),
                isAllTime: true
              };
            });

          $scope.$watch('parentScope.ctrl.filter', function (val) {
            /**$scope.model = null;
            auth.ensureUserData().then(function (user) {
              var offsetManual;
              if (user.data.user && user.data.user.time_zone_ext) {
                offsetManual = user.data.user.time_zone_ext.offset;
              } else {
                offsetManual = moment.parseZone(new Date()).format('Z');
              }
              var offset = dateRangePickerService.createMinuteOffsetValue(offsetManual);

              $scope.model = {
                startDate: val && val[$scope.name] && val[$scope.name].startDate && moment(val[$scope.name].startDate).subtract(offset, 'minutes'),
                endDate: val && val[$scope.name] && val[$scope.name].endDate && moment(val[$scope.name].endDate).subtract(offset, 'minutes')
              };
            });**/
          });
        });

          $scope.opts = {correctTimeZone: $scope.correctTimezone === false ? false: true, opens: 'right'};
        }
      };
    }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('cellTransfer', function ($timeout, $rootScope) {return {
      scope: {
        rowEntity: '<',
        onTransfer: '&'
      },
      templateUrl: 'app/components/cellTemplates/cell-cash-register-transfer/cell-cash-register-transfer.html',
      link: function (scope, element) {
        var grid = angular.element('.ui-grid');
            scope.showTransfer = [];
            scope.showInfo = [];

        angular.forEach(scope.rowEntity.cash_registers,function (item) {
          scope.showTransfer.push(false);
          scope.showInfo.push(false)
        });

        scope.close = function () {
          angular.forEach(scope.rowEntity.cash_registers,function (item,i) {
            scope.showTransfer[i] = false;
            scope.showInfo[i] = false;
          });
          scope.places = {value:null};
          scope.divisions.value = angular.copy(scope.rowEntity) || null;
          grid.removeClass('openedTransferModal');
          scope.$emit('closed');
        };

        scope.showTransferDialog = function (event, index) { // окткрытие попапа перемешения кассового аппарата
          if (angular.element(event.target).hasClass('cash-machine-ico') || angular.element(event.target).hasClass('btn') && !scope.showTransfer[index]) {
            event.stopPropagation();
            scope.showTransfer[index] = true;
            grid.addClass('openedTransferModal');
            scope.$emit('opened',{elem: index > 3 ? element[0].getElementsByClassName('cash-machine-ico')[index] : element[0].getElementsByClassName('more-element')[0],index:index});
            scope.places.value = angular.copy(scope.rowEntity.cash_registers[index].place)
          }
        };

        scope.showInfoDialog = function (event, index) { // окткрытие попапа перемешения кассового аппарата
          event.stopPropagation();
          scope.showInfo[index] = true;
          grid.addClass('openedTransferModal');
          scope.$emit('opened',{elem: index > 3 ? element[0].getElementsByClassName('cash-machine-ico')[index] : element[0].getElementsByClassName('more-element')[0],index:index});
        };

        scope.closeInfo = function (event,index) { // закрытие попапа перемешения
          event.stopPropagation();
          scope.showInfo[index] = false;
          grid.removeClass('openedTransferModal');
          scope.$emit('closed');
        };

        scope.closeMore = function(index) {
          angular.forEach(scope.showTransfer,function (item, i) {
            scope.showTransfer[i] = false;
            scope.showInfo[i] = false;
          });
          grid.removeClass('openedTransferModal');
          scope.$emit('closed');
        };

        scope.closeTransfer = function (event,index) { // закрытие попапа перемешения
          event.stopPropagation();
          scope.showTransfer[index] = false;
          scope.close();
        };

        scope.changeIndexMinus = function(index) {
          if (index !== 0) {
            index = index - 1
          }
          scope.showTransfer[index + 4] = false;
          return index
        }

        scope.changeIndexPlus = function(index) {
          if (index + 1 !== scope.rowEntity.cash_registers.length - 3 ) {
            index = index + 1
          }
          scope.showTransfer[index + 2] = false;
          return index
        }

        scope.$on('closePopup', function (event,data) {
          if (data.elem === element[0].getElementsByClassName('cash-machine-ico')[data.index] || data.elem === element[0].getElementsByClassName('more-element')[0]) {
            scope.showTransfer[data.index] = false;
            scope.showInfo[data.index] = false;
            scope.$digest();
            scope.close();
          }
        })

      },
      controller: function($scope, companyService, cashRegistersPlacesSrv, requestStatus, $state) {
        var ctrl = this;
        $scope.initialValues = {
          division: [],
          place: []
        };

        $scope.places = {value:null};
        $scope.divisions = {
          field: {},
          value: {},
          refresh: function (search) {
            var obj = this;
            companyService.divisions({},search || undefined)
              .then(function (res) {
                obj.field = res.data;
                if (obj.field.items.length === 1 && search === '' && model) {
                  $scope.divisions.value = obj.field.items[0];
                }
              })
          },
          getSearchEnabled: function (selectCtrl) {
            return this.field.total > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH || selectCtrl.search !== ''
          },
          getDisabled: function (selectCtrl) {
            return this.field.total === 0 || selectCtrl.search !== ''
          }
        };

        $scope.isChanged = function(cashMash, place) {
          return (cashMash.division.id !== $scope.divisions.value.id) || (!cashMash.place || !place || (place && cashMash.place && cashMash.place.id !== place.id));
        };

        $scope.resetPlaces = function() {
          $scope.places.value = null;
        };

        $scope.divisions.value = angular.copy($scope.rowEntity);

        $scope.transferCash = function (cashMash, division, place) { // перемешение кассового аппарата
          var newDivision = {
              id:division.id,
              name:division.name
            },
            newPlace = place ? {
              id:place.id,
              name:place.name
            } : null;
          cashRegistersPlacesSrv.replaceCashRegister(cashMash.id,{
            new_division: newDivision,
            new_place: newPlace
          }).then(function () {
            var message = 'ККМ ' + cashMash.manufacturer + '-' + cashMash.model + ' №' + cashMash.serial_number + ' перемещен в подразделение ' + division.name + ( place ? ' на кассовое место ' + place.name : '');

            var link = $state.href('division.view', {companyId: division.company_id, divisionId: division.id});
            $scope.onTransfer();
            $scope.close();
            requestStatus.success(message, undefined, 'Перейти в подразделение', link)
          }).catch(function (err) {
            console.error(err);
            if (err.status === 409) {
              requestStatus.error('Нельзя переместить ККМ ' + cashMash.manufacturer + '-' + cashMash.model + ' №' + cashMash.serial_number + ' в подразделение ' + division.name + '. Так как ИНН организации, на которую зарегистрирован ККМ, не совпадает с ИНН организации, которой принадлежит подразделение');
            } else {
              requestStatus.error('Во время перемещения ККМ произошла ошибка. Повторите попытку позже или обратитесь к администратору')
            }
          });
        };

      }
    }
    });//component ends

})();

/**
 * Created by aivanov on 08.01.2018.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название по статусу объекта каталога участника.
   */
  angular.module('frontend').filter('groupCustom', function () {
    return groupCustomFilter;
  });

  var groupCustomFilter = function (list, groupFunction) {
    var map = new Map();
    angular.forEach(list, function (item, index) {
      var groupField = groupFunction(item, index);
      if (map.has(groupField) == false) {
        map.set(groupField, item); // т.е. в группировке окажется первй элемент
        item.$$count = 0;
      }
      map.get(groupField).$$count = map.get(groupField).$$count + 1;
    });
    return Array.from(map.values());
  }

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('gridCustomTotalCell', gridCustomTotalCell);

  /** @ngInject */
  function gridCustomTotalCell($compile, $templateCache) {
    var directive = {
      require: '^gridCustom',
      restrict: 'EA',
      templateUrl: 'app/comparative/components/grid-custom/grid-custom-total-cell.html',
      controller: gridCustomTotalCtrl,
      bindToController: true,
      controllerAs: 'gridCustomTotalCtrl',
      scope: {
        templateUrl: '<?', // шаблон ячейки
        column: '=?', // информация о колонке (из модели колонок)
        templateHeaderScope: '=?',  // функциональный scope
        totalsData: '<?' // мап данных в тоталах
      },
      link: function (scope, element, attrs, gridCustom) {
        scope.gridCustomTotalCtrl.gridCustomCtrl = gridCustom;
        var totalCellScope = undefined;
        if (scope.gridCustomTotalCtrl.templateHeaderScope && scope.gridCustomTotalCtrl.templateHeaderScope.$new) {
          totalCellScope = scope.gridCustomTotalCtrl.templateHeaderScope.$new();
        } else {
          totalCellScope = scope.$new();
        }
        totalCellScope.column = scope.gridCustomTotalCtrl.column;
        totalCellScope.totalsData = scope.gridCustomTotalCtrl.totalsData;
        // Ищем переданный шаблон или ничего не пердаем
        var _template = $templateCache.get(scope.gridCustomTotalCtrl.templateUrl || '');
        // Компилируем шаблон
        var template = $compile(_template)(totalCellScope);
        // добавляем в ячейку
        var cellContainer = angular.element(element[0].querySelector('.total-cell-container'));
        cellContainer.append(template);

        // необходимо позаботиться об освобождении функционального скоупа
        scope.$on('$destroy', function() {
          totalCellScope.$destroy();
        });
      }
    };
    return directive;

    function gridCustomTotalCtrl($log) {
      var gridCustomTotalCtrl = this;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('gridCustomRowCell', gridCustomRowCell);

  /** @ngInject */
  function gridCustomRowCell($compile, $templateCache) {
    var directive = {
      require: '^gridCustomRow',
      restrict: 'E',
      templateUrl: 'app/comparative/components/grid-custom/grid-custom-row-cell.html',
      controller: gridCustomRowCellCtrl,
      bindToController: true,
      controllerAs: 'gridCustomRowCellCtrl',
      scope: {
        value: '=', // значение в сроке (предполагается, что в шаблоне есть обработка этого значения)
        templateUrl: '<?', // шаблон ячейки
        column: '=?', // информация о колонке (из модели колонок)
        cellUpdateCallback: '=?', // коллбек для изменений ячейки
        templateScope: '=?'  // функциональный scope
      },
      link: function (scope, element, attrs, gridCustomRow) {
        scope.gridCustomRowCellCtrl.gridCustomRowCtrl = gridCustomRow;
        var cellScope = undefined;
        if (scope.gridCustomRowCellCtrl.templateScope && scope.gridCustomRowCellCtrl.templateScope.$new) {
          cellScope = scope.gridCustomRowCellCtrl.templateScope.$new();
        } else {
          cellScope = scope.$new();
        }
        // сслыка на контроллер строки нужна и в функциональном скоупе
        cellScope.rowCtrl = scope.gridCustomRowCellCtrl.gridCustomRowCtrl;
        cellScope.column = scope.gridCustomRowCellCtrl.column;
        cellScope.value = scope.gridCustomRowCellCtrl.value;
        // Ищем переданный шаблон или используем по-умолчанию
        var _template = $templateCache.get(scope.gridCustomRowCellCtrl.templateUrl || 'defaultCustomGridCellTemplate.html');
        // Компилируем шаблон
        var template = $compile(_template)(cellScope);
        // добавляем в ячейку
        var cellContainer = angular.element(element[0].querySelector('.row-cell-container'));
        cellContainer.append(template);

        // обновляет сдержание ячейки если меняется шаблон
        scope.$watch(function() {
          return scope.gridCustomRowCellCtrl.column
        }, function(newVal, oldValue) {
          if (newVal.templateUrl === oldValue.templateUrl) {
            return;
          }
          // Ищем переданный шаблон или используем по-умолчанию
          var _templateWatcher = $templateCache.get(newVal.templateUrl || 'defaultCustomGridCellTemplate.html');
          // Компилируем шаблон
          var templateWatcher = $compile(_templateWatcher)(cellScope);
          cellContainer.empty();
          cellContainer.append(templateWatcher);
          cellScope.column = newVal;
        });

        // необходимо позаботиться об освобождении функционального скоупа
        scope.$on('$destroy', function() {
          cellScope.$destroy();
        });
      }
    };
    return directive;

    function gridCustomRowCellCtrl($log) {
      var gridCustomRowCellCtrl = this;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('gridCustomRow', gridCustomRow);

  /** @ngInject */
  function gridCustomRow($compile, $templateCache) {
    var directive = {
      require: '^gridCustom',
      restrict: 'EA',
      templateUrl: 'app/comparative/components/grid-custom/grid-custom-row.html',
      controller: gridCustomRowCtrl,
      bindToController: true,
      controllerAs: 'gridCustomRowCtrl',
      scope: {
        row: '=',  // Данные строки
        index: '<' // индекс строки
      },
      link: function (scope, element, attrs, gridCustomCtrl) {
        scope.gridCustomRowCtrl.gridCustomCtrl = gridCustomCtrl;
      }
    };
    return directive;

    function gridCustomRowCtrl($log, $q) {
      var gridCustomRowCtrl = this;

      /**
       * Колбек на клик на строку
       *
       * @param $event событие DOM
       */
      gridCustomRowCtrl.setSelected = function ($event) {
        gridCustomRowCtrl.gridCustomCtrl._selectRow(gridCustomRowCtrl.row);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('gridCustomHeaderCell', gridCustomHeaderCell);

  /** @ngInject */
  function gridCustomHeaderCell($compile, $templateCache) {
    var directive = {
      require: '^gridCustom',
      restrict: 'EA',
      templateUrl: 'app/comparative/components/grid-custom/grid-custom-header-cell.html',
      controller: gridCustomHeaderCtrl,
      bindToController: true,
      controllerAs: 'gridCustomHeaderCtrl',
      scope: {
        templateUrl: '<?', // шаблон ячейки
        column: '=?', // информация о колонке (из модели колонок)
        templateHeaderScope: '=?'  // функциональный scope
      },
      link: function (scope, element, attrs, gridCustom) {
        scope.gridCustomHeaderCtrl.gridCustomCtrl = gridCustom;
        var headerCellScope = undefined;
        if (scope.gridCustomHeaderCtrl.templateHeaderScope && scope.gridCustomHeaderCtrl.templateHeaderScope.$new) {
          headerCellScope = scope.gridCustomHeaderCtrl.templateHeaderScope.$new();
        } else {
          headerCellScope = scope.$new();
        }
        headerCellScope.column = scope.gridCustomHeaderCtrl.column;
        // Ищем переданный шаблон или используем по-умолчанию
        var _template = $templateCache.get(scope.gridCustomHeaderCtrl.templateUrl || 'defaultCustomGridHeaderCellTemplate.html');
        // Компилируем шаблон
        var template = $compile(_template)(headerCellScope);
        // добавляем в ячейку
        var cellContainer = angular.element(element[0].querySelector('.header-cell-container'));
        cellContainer.append(template);

        // необходимо позаботиться об освобождении функционального скоупа
        scope.$on('$destroy', function() {
          headerCellScope.$destroy();
        });
      }
    };
    return directive;

    function gridCustomHeaderCtrl($log) {
      var gridCustomHeaderCtrl = this;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('gridCustom', gridCustom);

  /** @ngInject */
  function gridCustom() {
    // размер страницы по-умолчанию
    var DEFAULT_PAGE_LIMIT = 10;

    var directive = {
      restrict: 'E',
      templateUrl: 'app/comparative/components/grid-custom/grid-custom.html',
      controller: gridCustomCtrl,
      bindToController: true,
      controllerAs: 'gridCustomCtrl',
      scope: {
        data: '=', // массив объектов-строк данных
        options: '=?', // настройки
        minHeight: '<?', // Минимальная высота дерева
        columns: '<?', // Настройки колонок
        columnsPage: '=?', // Настройка отображения списка колонок (limit и offset)
        twoLevelHeader: '<?', // Включение режима двухровнего заголовка
        loading: '=?', // флаг внешней загрузки
        parent: '<?', // родительская сущность
        isShowSettings: '<?', // флаг отображения кнопки меню колонок
        showCheckbox: '<?', // флаг отображения чекбоксов выбора строк
        hideHeader: '<?', // скрыть header
        groupExternalFunc: '=?', // колбек функции группировки
        externalFilterFunc: '=?', // колбек внешней функции сортировки
        pagingOptions: '<?', // параметры для пэйджинга
        pageCallback: '<?', // внешний колбек при изменении страницы
        selectedCallback: '<?', // колбек при выборе строки
        allowSelected: '<?', // флаг разрешает выбор строк
        discriminatorField: '<?', // код поля дискриминатора
        discriminatorValue: '<?', // значение поля дискриминатора (отображаемые строки должны соответствовать)
        isFullWidth: '<?', // флаг для добавления отступов слева/справа, если грид растягивается на всю ширину страницы
        headerFixedTopOffset: '<?', // число отсупа фиксации header
        scrollHeight: '<?', // добавление внутреннего скролла
        totalsData: '<?', // добавляет футер для грида, в биндинге содержится массив с именами колонок, по которым надо выводить итог
      },
      link: function (scope, element, attrs) {
      }
    };
    return directive;

    function gridCustomCtrl($scope, $filter, attributeUtilService) {
      var gridCustomCtrl = this;
      // объект с текущей сортировкой
      gridCustomCtrl.sorting = {};

      gridCustomCtrl.options = gridCustomCtrl.options || {};

      // системные колонки в начале грида
      gridCustomCtrl.columnsPre = [];

      // счетчик отмеченных элементов (для оптимизации)
      gridCustomCtrl._checkCount = 0;

      /**
       * Функция группировки. При определении внешней функции вызывает её,
       * в противном случае использует индекс, как фактическое отсутствие группировки.
       *
       * @param item элемнт списка
       * @param index индекс элемена
       * @return {*} строка с ключом группировки
       */
      gridCustomCtrl.groupFunction = function (item, index) {
        if (gridCustomCtrl.groupExternalFunc) {
          return gridCustomCtrl.groupExternalFunc(item, index);
        }
        return '' + index;
      };

      /*
        Сортировка
       */
      gridCustomCtrl.sortColumn = function (column) {
        if (!column) return;

        if (gridCustomCtrl.sorting.sortName == column.sortName) {
          if (!gridCustomCtrl.sorting.sortDirection) {
            gridCustomCtrl.sorting.sortDirection = 'asc';
          } else if (gridCustomCtrl.sorting.sortDirection == 'asc') {
            gridCustomCtrl.sorting.sortDirection = 'desc';
          } else if (gridCustomCtrl.sorting.sortDirection == 'desc') {
            gridCustomCtrl.sorting = {};
          }
          column.sortDirection = gridCustomCtrl.sorting.sortDirection;
        } else {
          // очистка флага сортировки у других колонок
          _.forEach(gridCustomCtrl.columns, function (column) {
            column.sortDirection = undefined;
          });

          gridCustomCtrl.sorting = {
            sortName: column.sortName,
            sortDirection: column.sortDirection || 'asc'
          };
          column.sortDirection = column.sortDirection || 'asc';
        }
        gridCustomCtrl.pageCallback(gridCustomCtrl.sorting);
      };

      /**
       * Метод фильтрет данные грида по дискриминатору
       *
       * @param item
       * @return {boolean}
       */
      gridCustomCtrl.discriminatorFn = function (item) {
        if (!gridCustomCtrl.discriminatorField)
          return true;
        return angular.equals(attributeUtilService._getValueDeep(
          item,
          gridCustomCtrl.discriminatorField.split('.')),
          gridCustomCtrl.discriminatorValue);
      };

      /**
       * Метод фильтрет данные грида по дискриминатору
       *
       * @param item
       * @return {boolean}
       */
      gridCustomCtrl._externalFilterFn = function (item) {
        if (gridCustomCtrl.externalFilterFunc)
          return gridCustomCtrl.externalFilterFunc(item);
        return true; // если внешнего фильтра нет, элементы не фильтруются
      };

      // применить сортировку по умолчанию
      gridCustomCtrl.sortColumn(_.find(gridCustomCtrl.columns, function (column) {
        return column.sortDirection;
      }));

      /**
       * Экспортируемый метод, возвращает выбранную строку
       *
       * @return {*}
       */
      gridCustomCtrl.options.getSelectedRow = function () {
        return gridCustomCtrl.selectedRow;
      };

      /**
       * Экспортируемый метод, возвращает отмеченные чекбоксом строки
       *
       * @return {*}
       */
      gridCustomCtrl.options.getCheckedRows = function () {
        if (!gridCustomCtrl.data) {
          return [];
        }
        return _.filter(gridCustomCtrl.data, function (item) {
          return item.$$checked;
        });
      };

      /**
       * Экспортируемый метод, возвращает флаг наличия хотя бы одной отмеченной строки
       *
       * @return {*}
       */
      gridCustomCtrl.options.hasCheckedRows = function () {
        return !!gridCustomCtrl._checkCount;
      };

      /**
       * Экспортируемый метод, устанавливает выделение у объектов
       *
       * @param ids - список ключей для установки выделения
       * @param idField - имя поля-ключа объектов (елси undefined - берется весь объект)
       *
       * @return {int} - количество отмеченных строк
       */
      gridCustomCtrl.options.setCheckedRows = function (ids, idField) {
        if (!ids || !gridCustomCtrl.data) {
          // случай, когда данных для выделения нет
          return;
        }
        if (!Array.isArray(ids)) {
          // случай, когда передан объект, а не массив
          ids = [ids];
        }
        var counter = 0; // счетчик выделенных строк
        _.forEach(gridCustomCtrl.data, function (item) {
          if (_.find(ids, function (id) {
              if (idField) {
                return item[idField] == id;
              }
              return item == id;
            })) {
            // если совпадение найдено - выделяем
            gridCustomCtrl._checkRow(item, undefined, true);
            counter++;
          }
        });
        return counter;
      };

      // пейджинг (копия из-за модификации total)
      gridCustomCtrl.paging = gridCustomCtrl.pagingOptions ? gridCustomCtrl.pagingOptions : {
        current: 0,
        limit: Math.abs(gridCustomCtrl.pagingLimit || DEFAULT_PAGE_LIMIT),
        offset: 0
      };

      // пересчитвает кол-во строк с учетом установенных фильтров
      gridCustomCtrl.recalculateTotalWithFilters = function () {
        gridCustomCtrl.paging.total = gridCustomCtrl.data ? $filter('filter')(
          $filter('filter')(
            $filter('groupCustom')(
              gridCustomCtrl.data,
              gridCustomCtrl.groupFunction),
            gridCustomCtrl.discriminatorFn),
          gridCustomCtrl._externalFilterFn).length : 0;
      };
      gridCustomCtrl.recalculateTotalWithFilters();

      /**
       * Вызывается при изменении страницы
       *
       * @param page
       */
      gridCustomCtrl.recreatePaging = function (page) {
        if (gridCustomCtrl.pageCallback) {
          // отправка в том же цикле приведет к тому, то валидация будет установлена для старой формы
          $scope.$$postDigest(function () {
            gridCustomCtrl.pageCallback(page);
          });
        }
      };

      /**
       * Метод пересчитывает опциональный верхний слой заголовков (пока поддерживается
       * только один такой слой, помимо непосредственно заголовков колонок)
       */
      gridCustomCtrl.rebuildTopLevelHeader = function () {
        if (!gridCustomCtrl.twoLevelHeader)
          return;
        gridCustomCtrl.topLevelHeaders = [];
        var pre;
        angular.forEach(gridCustomCtrl.allColumns, function (column) {
          if (column.visible && column.column_visible) {
            if (pre && pre.name && (column.parent == pre.name)) {
              pre.flex += column.flex || 1;
              if (pre.width && column.width)
                pre.width += column.width;
            } else {
              if (pre) {
                gridCustomCtrl.topLevelHeaders.push(pre);
              }
              pre = {
                name: column.parent || '',
                flex: column.flex || 1,
                width: column.width
              }
            }
          }
        });
        if (pre) {
          gridCustomCtrl.topLevelHeaders.push(pre);
        }
      };

      //  TODO вынести добавление родителя в общий контроллер итд
      $scope.$watch('gridCustomCtrl.data', function (newVal, oldVal) {
        if (gridCustomCtrl.data && gridCustomCtrl.data.length && gridCustomCtrl.parent) {
          gridCustomCtrl.parent.parent = true;
          gridCustomCtrl.data.unshift(gridCustomCtrl.parent);
        }
      });

      $scope.$watch('gridCustomCtrl.data.length', function (newVal, oldVal) {
        if (newVal != undefined) {
          // сброс настроек пейджинга
          gridCustomCtrl.recalculateTotalWithFilters();
        }
      });

      $scope.$watch('gridCustomCtrl.columns', function (newVal, oldVal) {
        if (newVal != undefined) {
          gridCustomCtrl.allColumns = gridCustomCtrl.columnsPre.concat(gridCustomCtrl.columns)
        } else {
          gridCustomCtrl.allColumns = gridCustomCtrl.columnsPre;
        }
        gridCustomCtrl.rebuildTopLevelHeader(); // перестроение группировки заголовков верхнего уровня
      });

      // добавление служебной колонки для чекбоксов
      if (gridCustomCtrl.showCheckbox) {
        gridCustomCtrl.columnsPre.unshift({
          name: "",
          width: (gridCustomCtrl.isFullWidth) ? 80 : 40,
          flex: 0,
          templateUrl: 'checkboxGridCellTemplate.html',
          visible: true,
          fixed: true, // перспективный флаг, осзначает фиксацию колонки при листании колонок
          column_visible: true
        });
      }

      if (angular.isUndefined(gridCustomCtrl.columnsPage)) {
        gridCustomCtrl.columnsPage = {offset: 0, limit: undefined}; // шаблон по-умолчанию
      }

      /**
       * Внутренний метод обрабатывающий выделение строки
       */
      gridCustomCtrl._checkRow = function (row, oldValue, value) {
        if (value != undefined) {
          row.$$checked = value;
        }
        gridCustomCtrl._checkCount += row.$$checked ? 1 : -1;
      };

      /**
       * Внутренний метод выбора строки
       */
      gridCustomCtrl._selectRow = function (row) {
        if (!gridCustomCtrl.allowSelected) {
          // выделение строк не разрешено
          return;
        }
        if (gridCustomCtrl.selectedRow === row) {
          // выделение снимается при повторном клике
          gridCustomCtrl.selectedRow.$$selected = false;
          gridCustomCtrl.selectedRow = undefined;
          if (gridCustomCtrl.selectedCallback) {
            gridCustomCtrl.selectedCallback(undefined); // отправка пустого селекта при отмене выделения
          }
          return;
        }
        if (gridCustomCtrl.selectedRow) {
          gridCustomCtrl.selectedRow.$$selected = false;
        }
        gridCustomCtrl.selectedRow = row;
        row.$$selected = true;
        // callback, если присутствует
        if (gridCustomCtrl.selectedCallback) {
          gridCustomCtrl.selectedCallback(row);
        }
      };

      if (gridCustomCtrl.scrollHeight) {
        gridCustomCtrl.configScroll = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          scrollButtons: {
            enable: false
          },
          setHeight: gridCustomCtrl.scrollHeight,
          scrollInertia: 0,
          axis: 'y'
        };
      }

    }
  }
})();

(function () {
  'use strict';

  angular.module('frontend').component('compare', {
    bindings: {
      header: '<',
      valueFrom: '<',
      valueTo: '<',
      coin: '<?',
      symbol: '<?'
    },
    controller: 'compareController',
    controllerAs: 'compareCtrl',
    templateUrl: 'app/comparative/components/compare/compare.html'
  });

})();

(function () {
  'use strict';

  angular.module('frontend').controller('compareController', compareController);

  function compareController($scope, $log) {
    var compareCtrl = this;

    // Использовани фильтра для значений с копейками
    if (compareCtrl.coin == undefined) {
      compareCtrl.coin = true;
    }

    /* Метод выполянет пеерсчет зависимых переменных при изменнии показателей */
    compareCtrl.recalculate = function () {
      // флаг тренда
      compareCtrl.trendUp = compareCtrl.valueTo >= compareCtrl.valueFrom;

      compareCtrl.widthTo = Math.floor((compareCtrl.valueTo/Math.max(compareCtrl.valueFrom, compareCtrl.valueTo))*100);
      compareCtrl.widthFrom = Math.floor((compareCtrl.valueFrom/Math.max(compareCtrl.valueFrom, compareCtrl.valueTo))*100);

      if (compareCtrl.valueFrom) { // при нуле не высчитывается
        compareCtrl.procent = Math.floor((compareCtrl.valueTo / compareCtrl.valueFrom) * 100) - 100;
      } else {
        compareCtrl.procent = undefined;
      }

    }

    // хук на изменение показателей
    $scope.$watch('compareCtrl.valueTo', function (newVal) {
      compareCtrl.recalculate();
    });

    // хук на изменение показателей
    $scope.$watch('compareCtrl.valueFrom', function (newVal) {
      compareCtrl.recalculate();
    });
  }

})();

(function () {
  'use strict';

  angular.module('frontend').component('calendarCustom', {
    bindings: {
      date: '<'
    },
    controller: function () {
      var monthNamesDecl = ["января","февраля","марта","апреля","мая","июня","июля","августа","сентября","октября","ноября","декабря"];
      var calendarCtrl = this;
      calendarCtrl.date = moment(calendarCtrl.date);
      calendarCtrl.day = calendarCtrl.date.format('DD');
      calendarCtrl.month = monthNamesDecl[calendarCtrl.date.format('M')-1];
    },
    controllerAs: 'calendarCtrl',
    templateUrl: 'app/comparative/components/calendar/calendar.html'
  });

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .service("searchCatalogItemSrv", function ($uibModal) {
      this.showModal = function (fromCatalog, isDerivative, createAlcoItem, docId, lineId, alcoholItemId) {
        return $uibModal.open({
          templateUrl: 'app/catalog/modals/search-catalog-item/search-catalog-item.html',
          controller: 'searchCatalogItemCtr',
          controllerAs: 'searchCtrl',
          bindToController: true,
          size: 'large-width',
          resolve: {
            fromCatalog: fromCatalog,
            isDerivative: isDerivative,
            createAlcoItem: function () { return createAlcoItem },
            docId: function () { return docId },
            lineId: function () { return lineId },
            alcoholItemId: function () { return alcoholItemId }
          }
        });
      }
    })
    .controller("searchCatalogItemCtr", function ($scope,
      $state,
      $window,
      $uibModalInstance,
      catalogService,
      companyService,
      categoryService,
      catalogItemService,
      OPTIONS_LENGTH,
      fromCatalog,
      isDerivative,
      createAlcoItem,
      $timeout,
      docId,
      lineId,
      egaiszService,
      alcoholItemId,
      utilsService) {
      var searchCtrl = this;
      searchCtrl.isDerivative = isDerivative;
      searchCtrl.createAlcoItem = createAlcoItem;
      searchCtrl.filterDateFromState = {};
      searchCtrl.filterDateToState = {};
      searchCtrl.urlParams = {
        limit: 6,
        search_string_type: 'NAME',
        include_service_item: true
      };
      searchCtrl.optionLength = OPTIONS_LENGTH;
      searchCtrl.reqParams = { filter_divisions_ids: [] };
      searchCtrl.divisions_ids = searchCtrl.divisionsAll = searchCtrl.filterAttrs = [];

      searchCtrl.options = {
        keyboardControls: true,
        displayProp: 'name',
        smartButtonMaxItems: 2,
        smartButtonTextConverter: function (itemText, originalItem) {
          return itemText;
        }
      }

      searchCtrl.translationTexts = {
        checkAll: 'Выбрать все',
        uncheckAll: 'Очистить',
        buttonDefaultText: 'Выберите подразделение'
      }

      searchCtrl.checkIssetData = function () {
        searchCtrl.isIssetData = false;
        if (searchCtrl.urlParams.search_string || searchCtrl.urlParams.filter_category_id || (searchCtrl.divisions_ids && searchCtrl.divisions_ids.length)) {
          searchCtrl.isIssetData = true;
          return;
        }
        _.forEach(searchCtrl.filterAttrs, function (attr, key) {
          if (searchCtrl.attrs && searchCtrl.attrs[key].$$hasVal) {
            searchCtrl.isIssetData = true;
          }
        });
      }

      searchCtrl.multiselectEvents = {
        onItemSelect: function (item) {
          searchCtrl.divisions_ids.push(item.id);
          searchCtrl.checkIssetData();
        },
        onItemDeselect: function (item) {
          var deleteIndex = _.indexOf(searchCtrl.divisions_ids, item.id);
          searchCtrl.divisions_ids.splice(deleteIndex, 1);
          searchCtrl.checkIssetData();
        },
        onSelectAll: function () {
          searchCtrl.divisions_ids = angular.copy(searchCtrl.divisionsAll);
          searchCtrl.checkIssetData();
        },
        onDeselectAll: function () {
          searchCtrl.divisions_ids = [];
          searchCtrl.checkIssetData();
        }
      };

      searchCtrl.options = {
        keyboardControls: true,
        displayProp: 'name',
        smartButtonMaxItems: 2,
        smartButtonTextConverter: function (itemText, originalItem) {
          return itemText;
        }
      }

      searchCtrl.translationTexts = {
        checkAll: 'Выбрать все',
        uncheckAll: 'Очистить',
        buttonDefaultText: 'Выберите подразделение'
      }

      searchCtrl.searchStringTypes = [{
        id: 'VENDOR_CODE',
        name: 'Артикул'
      },
      {
        id: 'DERIVATIVE_CODE_PREFIX',
        name: 'Код товара или услуги'
      },
      {
        id: 'NAME',
        name: 'Наименование'
      },
      {
        id: 'GTIN',
        name: 'Штрих-код'
      }];

      searchCtrl.implementationTypes = [{
        value: false,
        name: 'Собственный'
      },
      {
        value: true,
        name: 'Комитента'
      }];

      function setCommittent(isReset) {
        if (isReset) {
          searchCtrl.committent = undefined;
        }
        // RECS-11074 В документах CNI_FROM_COMMITTEE, CNO_TO_COMMITTEE в попапе расширенного поиска нужно предустанавливать и не давать менять фильтр  "committent = true".
        if (searchCtrl.$stateParams.purpose == 'CNI_FROM_COMMITTEE' ||
          searchCtrl.$stateParams.purpose == 'CNO_TO_COMMITTEE' ||
          searchCtrl.$stateParams.purpose == 'PO_TO_COMMITTEE' ||
          searchCtrl.$stateParams.purpose == 'REPORT_TO_COMMITTEE') {
          searchCtrl.disabledCommittent = true;
          searchCtrl.committent = true;
        } else if (searchCtrl.$stateParams.purpose == 'PO_TO_SUPPLIER' ||
          searchCtrl.$stateParams.purpose == 'INVI_PURCHASE' ||
          searchCtrl.$stateParams.purpose == 'INVO_RETURN' ||
          searchCtrl.$stateParams.purpose == 'CNO_TO_SUPPLIER' ||
          searchCtrl.$stateParams.purpose == 'CNI_FROM_SUPPLIER') {
          searchCtrl.disabledCommittent = true;
          searchCtrl.committent = false;
        }
      }
      setCommittent();



      // настройка скролла
      searchCtrl.configScroll = {
        axis: 'y',
        autoHideScrollbar: false,
        theme: 'dark-thick',
        advanced: {
          updateOnContentResize: true
        },
        setHeight: 480,
        scrollInertia: 0,
        scrollButtons: {
          enable: false // enable scrolling buttons by default
        }
      }

      searchCtrl.gridFooterPaging = [25, 50, 100];
      searchCtrl.paging = {
        current: 0,
        limit: 6,
        offset: 0,
        total: 0
      };

      searchCtrl.close = function () {
        $uibModalInstance.close(searchCtrl.result);
      };

      searchCtrl.reset = function () {
        searchCtrl.urlParams = {
          limit: 6,
          search_string_type: 'NAME',
          include_service_item: true
        };
        searchCtrl.paging = {
          current: 0,
          limit: 6,
          offset: 0,
          total: 0
        };
        searchCtrl.reqParams = {};
        searchCtrl.isShowDerivatives = false;
        searchCtrl.choseCatalogItem = undefined;
        searchCtrl.searchRes = undefined;
        searchCtrl.category = undefined;
        searchCtrl.notFound = undefined;
        searchCtrl.attrs = [];
        searchCtrl.formInvalid = false;
        setCommittent(true);
      }

      searchCtrl.return = function () {
        searchCtrl.notFound = false;
        searchCtrl.isShowDerivatives = false;
        searchCtrl.choseCatalogItem = undefined;
      }

      companyService.divisions({ limit: 100 }).then(function (data) {
        searchCtrl.divisionsAll = data.data.items;
      });

      searchCtrl.totalStr = function () {
        if (searchCtrl.categoriesAll.length > OPTIONS_LENGTH) {
          return "Показано " + OPTIONS_LENGTH + " из " + searchCtrl.helperTotal;
        }
        return '';
      };

      searchCtrl.getParentsStr = function (parentList) {
        var parentsStr = '';
        _.forEach(parentList, function (parent) {
          parentsStr += (parentsStr) ? " → " + parent.name : parent.name;
        });
        return parentsStr;
      };

      searchCtrl.getAttrs = function (category) {
        searchCtrl.urlParams.filter_category_id = (category) ? category.id : null;
        searchCtrl.checkIssetData();
        searchCtrl.attrs = [];
        if (category && category.id) {
          categoryService.getCustomCategory(category.id).then(function (res) {
            _.forEach(res.data.elements, function (attr) {
              if (attr.attribute) {
                searchCtrl.attrs.push(attr.attribute);
              } else {
                _.forEach(attr.block.attributes, function (blockAttr) {
                  searchCtrl.attrs.push(blockAttr);
                });
              }
            });
            searchCtrl.filterAttrs = [];
            _.forEach(searchCtrl.attrs, function (attr) {
              var neAttr = {
                attribute_id: attr.id,
                values: {
                  data_type: attr.data_type
                }
              };
              if (attr.data_type == "STRING" || attr.data_type == "BOOLEAN" || attr.data_type == "DICTIONARY") {
                neAttr.values.filter_string = [];
              }
              searchCtrl.filterAttrs.push(neAttr);
            });
          });
        }
      }

      searchCtrl.clearAttrData = function (attr, index) {
        var values = searchCtrl.filterAttrs[index].values;
        attr.$$hasVal = false;
        if (attr.data_type === "FLOAT") {
          values.filter_float_min = undefined;
          values.filter_float_max = undefined;
        } else if (attr.data_type === "INTEGER") {
          values.filter_int_min = undefined;
          values.filter_int_max = undefined;
        } else if (attr.data_type === "DATE" || attr.data_type === "DATE_TIME") {
          searchCtrl.filterDateFromState[index].resetData();
          searchCtrl.filterDateToState[index].resetData();
        } else {
          values.filter_string = [];
        }
      }

      searchCtrl.checkValid = function () {
        searchCtrl.formInvalid = false;
        _.forEach(searchCtrl.attrs, function (attr) {
          if (attr.$$invalid) {
            searchCtrl.formInvalid = true;
          }
        });

      }

      searchCtrl.changeAttrData = function (attr, index) {
        var values = searchCtrl.filterAttrs[index].values;
        if (attr.data_type === "FLOAT") {
          attr.$$hasVal = !!(values.filter_float_min || values.filter_float_max);
          attr.$$invalid = values.filter_float_min && values.filter_float_max && values.filter_float_min > values.filter_float_max;
        } else if (attr.data_type === "INTEGER") {
          attr.$$hasVal = !!(values.filter_int_min || values.filter_int_max);
          attr.$$invalid = values.filter_int_min && values.filter_int_max && values.filter_int_min > values.filter_int_max;
        } else if (attr.data_type === "DATE" || attr.data_type === "DATE_TIME") {
          attr.$$hasVal = (values.filter_date_from && !values.filter_date_from.isEmpty) || (values.filter_date_to && !values.filter_date_to.isEmpty);
          attr.$$invalid = values.filter_date_from && values.filter_date_to && !values.filter_date_from.isEmpty && !values.filter_date_to.isEmpty && values.filter_date_from.isAfter(values.filter_date_to);
        } else if (attr.data_type === "DICTIONARY") {
          attr.$$hasVal = false;
          _.forEach(values.filter_string, function (val) {
            if (val) {
              attr.$$hasVal = true;
            }
          });
        } else {
          attr.$$hasVal = !!values.filter_string[0];
        }
        searchCtrl.checkValid();
      }

      searchCtrl.prepareSearch = function () {
        searchCtrl.reqParams.filter_attributes_values = [];
        _.forEach(searchCtrl.filterAttrs, function (attr, key) {
          if (searchCtrl.attrs && searchCtrl.attrs[key] && searchCtrl.attrs[key].$$hasVal) {
            var helpAttr = angular.copy(attr);
            if (helpAttr.values.data_type === "DATE" || helpAttr.values.data_type === "DATE_TIME") {
              if (!helpAttr.values.filter_date_from.isEmpty) {
                helpAttr.values.filter_date_from = moment.utc(helpAttr.values.filter_date_from).valueOf();
              } else {
                helpAttr.values.filter_date_from = undefined;
              }
              if (!helpAttr.values.filter_date_to.isEmpty) {
                helpAttr.values.filter_date_to = moment.utc(helpAttr.values.filter_date_to).valueOf();
              } else {
                helpAttr.values.filter_date_to = undefined;
              }
            }
            if (helpAttr.values.filter_string && !helpAttr.values.filter_string.length) {
              helpAttr.values.filter_string = undefined;
            } else if (helpAttr.values.filter_string && helpAttr.values.filter_string.length) {
              helpAttr.values.filter_string = helpAttr.values.filter_string.filter(function (el) { return el });
            }
            searchCtrl.reqParams.filter_attributes_values.push(helpAttr);
          }
        });
        if (!searchCtrl.reqParams.filter_attributes_values.length) {
          searchCtrl.reqParams.filter_attributes_values = undefined;
        }
        if (searchCtrl.reqParams.filter_divisions_ids && !searchCtrl.reqParams.filter_divisions_ids.length) {
          searchCtrl.reqParams.filter_divisions_ids = undefined;
        }
      };

      // Получить необходимую структутру из той что получается в multiselect
      searchCtrl.getDivisionIds = function () {
        if (searchCtrl.divisions_ids.length) {
          searchCtrl.reqParams.filter_divisions_ids = _.map(searchCtrl.divisions_ids, function (idObj) {
            return idObj.id;
          });
        }
      }

      searchCtrl.search = function (resetOffset) {
        if (searchCtrl.formInvalid || !searchCtrl.catalogItemSearchForm.$valid || !searchCtrl.isIssetData) {
          searchCtrl.isSaved = true;
          utilsService.setTouched(searchCtrl.catalogItemSearchForm);
          return;
        }

        searchCtrl.showLoader = true;
        if (resetOffset) {
          searchCtrl.urlParams.offset = 0;
          searchCtrl.paging.offset = 0;
        } else {
          searchCtrl.urlParams.offset = searchCtrl.paging.offset;
        }
        searchCtrl.getDivisionIds();
        searchCtrl.prepareSearch();
        if (_.isEmpty(searchCtrl.reqParams)) {
          searchCtrl.reqParams = undefined;
        }
        if (!searchCtrl.urlParams.search_string) {
          searchCtrl.urlParams.search_string = undefined;
        }

        // RECS-12386 filter_committent в зависимости от purpose
        if (searchCtrl.$stateParams.purpose == "PO_TO_COMMITTEE" ||
          searchCtrl.$stateParams.purpose == "PR_TO_COMMITTEE" ||
          searchCtrl.$stateParams.purpose == "REPORT_TO_COMMITTEE" ||
          searchCtrl.$stateParams.purpose == "CNO_TO_COMMITTEE" ||
          searchCtrl.$stateParams.purpose == "CNI_FROM_COMMITTEE") {
          searchCtrl.urlParams.filter_committent = true;
        } else if (searchCtrl.$stateParams.purpose == "PO_TO_SUPPLIER" ||
          searchCtrl.$stateParams.purpose == "PR_FROM_SUPPLIER" ||
          searchCtrl.$stateParams.purpose == "INVI_PURCHASE" ||
          searchCtrl.$stateParams.purpose == "INVO_RETURN" ||
          searchCtrl.$stateParams.purpose == "CNO_TO_SUPPLIER" ||
          searchCtrl.$stateParams.purpose == "CNI_FROM_SUPPLIER") {
          searchCtrl.urlParams.filter_committent = false;
        }

        catalogService.searchCatalogItems(searchCtrl.reqParams, searchCtrl.urlParams).then(function (res) {
          searchCtrl.searchRes = res.data.items;
          searchCtrl.paging.total = res.data.total;
          searchCtrl.notFound = !res.data.total;
          searchCtrl.showLoader = false;
        });
      }

      searchCtrl.choiceCatalogItem = function (event, catalogItem) {
        searchCtrl.catalogItemId = catalogItem.id;
        if (fromCatalog) {
          searchCtrl.close();
        } else {
          event.preventDefault();
          event.stopPropagation();
          if (!isDerivative) {
            searchCtrl.result = catalogItem;
            searchCtrl.close();
            // выбор позиции или товара и подстановка в поле
          } else {
            searchCtrl.showDerivatives(catalogItem, event);
          }
        }
      }

      searchCtrl.choiceDerivative = function (event, derivative) {
        event.preventDefault();
        event.stopPropagation();
        if (searchCtrl.choseCatalogItem) {
          derivative.derivative = {
            id: derivative.id,
            name: derivative.name
          };
          derivative.id = searchCtrl.choseCatalogItem.id;
          derivative.name = searchCtrl.choseCatalogItem.name;
        }
        searchCtrl.result = derivative;
        searchCtrl.close();
      }

      searchCtrl.showDerivatives = function (catalogItem, event) {
        if (searchCtrl.formInvalid || !searchCtrl.catalogItemSearchForm.$valid || (!searchCtrl.isIssetData && !searchCtrl.derivatives.length)) {
          searchCtrl.isSaved = true;
          utilsService.setTouched(searchCtrl.catalogItemSearchForm);
          return;
        }

        searchCtrl.showLoader = true;
        event.preventDefault();
        event.stopPropagation();
        searchCtrl.choseCatalogItem = catalogItem;
        searchCtrl.prepareSearch();
        searchCtrl.getDivisionIds();
        if (_.isEmpty(searchCtrl.reqParams)) {
          searchCtrl.reqParams = undefined;
        }
        catalogService.searchDerivatives(catalogItem.id, searchCtrl.reqParams, { limit: 100, committent: searchCtrl.committent }).then(function (res) {
          searchCtrl.isShowDerivatives = true;
          searchCtrl.derivatives = res.data.items;
          searchCtrl.notFound = !res.data.total;
          searchCtrl.packingTabs = [];
          _.forEach(searchCtrl.derivatives, function (item) {
            var copy = _.find(searchCtrl.packingTabs, function (tab) {
              return tab.title == item.domain_sku_name;
            })
            if (!copy) {
              // опередение упаковок товара
              searchCtrl.packingTabs.push({
                title: item.domain_sku_name,
                className: item.ext_id
              })
            }
          });
          searchCtrl.showLoader = false;
          $timeout(function () {
            searchCtrl.activeTab = 0;
          }, 0);
        });
      };


      // Узлы дерева
      searchCtrl.root = {
        name: 'Корень',
        root: true,
        has_children: true,
        children: []
      };

      // Callback загрузки дерева
      searchCtrl.onTreeLoaded = function () {
        searchCtrl.root.expandFuncByModel({}); // открывает корень дерева
      };

      searchCtrl.goToCatalogItemNew = function (categoryId, data) {
        searchCtrl.close();
        var url = $state.href("catalogSkus.new", {
          categoryId: categoryId,
          alcoPackedType: data.alco_packed_type,
          capacity: data.capacity,
          ean13: data.ean13,
          name: data.full_name,
          closeTab: true,
          cashRegisterType: "EXCISE_GOODS"
        });
        $window.open(url, '_blank');
      }

      /**
       * При выборе узла в дереве идет запрос на доп.информацию и переход на создание товара с параметрами
       *
       * @param node выбранный узел
       */
      searchCtrl.selectNode = function (node) {
        searchCtrl.showTreeLoader = true;
        if (searchCtrl.createAlcoItem == "no_recs_sku") {
          egaiszService.getLineInfo(docId, lineId).then(function (res) {
            searchCtrl.goToCatalogItemNew(node.id, res.data);
          });

        } else if (searchCtrl.createAlcoItem == "recs_sku") {
          egaiszService.getSkuInfo(alcoholItemId).then(function (res) {
            searchCtrl.goToCatalogItemNew(node.id, res.data);
          });
        }
      }

      /* Callback для раскрытия дерева */
      searchCtrl.expand = function (node) {
        // Загрузка дочерних категорий только при установленном флаге наличия
        return categoryService.getDomainCategories(node.id).then(function (data) {
          searchCtrl.noCategories = !data.data.length;
          if (data.data) {
            return data.data;
          }
        });
      }

    })
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service("searchAlcoItemSrv", function ($uibModal) {
        this.showModal = function (fsrar, sku, isDerivative, viewMode, needDocLink, divisionId, register, withoutFn2) {
          return $uibModal.open({
            templateUrl: 'app/catalog/modals/search-alco-item/search-alco-item.html',
            controller: 'searchAlcoItemSrvCtr',
            controllerAs: 'searchCtrl',
            bindToController: true,
            size: 'large-width',
            resolve: {
              sku: sku,
              fsrar: fsrar,
              isDerivative: isDerivative,
              viewMode: viewMode,
              needDocLink: needDocLink,
              divisionId: function () { return divisionId; },
              register: function () { return register; },
              withoutFn2: withoutFn2
            }
          });
        }
    })
    .controller("searchAlcoItemSrvCtr", function ($scope,
                                                  $state,
                                                  $uibModalInstance,
                                                  catalogService,
                                                  companyService,
                                                  categoryService,
                                                  catalogItemService,
                                                  OPTIONS_LENGTH,
                                                  sku,
                                                  $timeout, 
                                                  egaiszService,
                                                  fsrar,
                                                  isDerivative,
                                                  viewMode, 
                                                  $filter,
                                                  $window,
                                                  needDocLink,
                                                  divisionId,
                                                  register,
                                                  withoutFn2) {
      var searchCtrl = this;
      searchCtrl.sku = sku || {}; // переданный алко товар
      searchCtrl.onlyForm2 = !!sku;
      searchCtrl.isShowForms2 = searchCtrl.onlyForm2;
      searchCtrl.viewMode = viewMode;
      searchCtrl.withoutFn2 = withoutFn2;
      searchCtrl.needDocLink = needDocLink;

      searchCtrl.urlParams = {
        limit: 6
      };

      searchCtrl.form2_params = {}
      if (isDerivative) {
        searchCtrl.form2_params.filter_derivative_id = searchCtrl.sku.id || undefined;
      } else {
        searchCtrl.form2_params.filter_catalog_id = searchCtrl.sku.id || undefined;
      }
      

      searchCtrl.choseCatalogItem = searchCtrl.sku || undefined;

      // на будущее
      // searchCtrl.barcodeTypes = [
      //   {
      //     name: 'ФСМ',
      //     code: 'FCM'
      //   },
      //   {
      //     name: 'АМ',
      //     code: 'AM'
      //   }
      // ];
      // 
      searchCtrl.optionLength = OPTIONS_LENGTH;

      searchCtrl.checkIssetData = function(){
        searchCtrl.isIssetData = false;
        if(searchCtrl.urlParams.catalog_search || searchCtrl.urlParams.alc_code_search){
          searchCtrl.isIssetData = true;
          return;
        }
      }

      searchCtrl.getTip = function(catalogItem){
        var tip = catalogItem.full_name;
        if (catalogItem.alc_code) {
          tip += "<br>Алкокод: " + catalogItem.alc_code;
        }
        if (catalogItem.capacity) {
          tip += "<br>Объем: " + catalogItem.capacity + "л";
        }
        if (catalogItem.alc_volume) {
          tip += "<br>Крепость: " + catalogItem.alc_volume;
        }
        if (catalogItem.producer) {
          tip += "<br>Производитель: " + catalogItem.producer.client_reg_id + " " + (catalogItem.producer.full_name || "");
        }
        return tip;
      }

      searchCtrl.gridFooterPaging = [5, 10, 25];
      searchCtrl.paging = {
        current: 0,
        limit: 5,
        offset: 0,
        total: 0
      };

      searchCtrl.form2paging = {
        current: 0,
        limit: 10,
        offset: 0,
        total: 0
      };

      searchCtrl.close = function () {
        $uibModalInstance.close(searchCtrl.result);
      };

      searchCtrl.reset = function(){
        searchCtrl.urlParams = {
          limit: 6,
          // barcodeType: "FCM" // на будущее
        };
        searchCtrl.form2_params = {};
        searchCtrl.paging = {
          current: 0,
          limit: 6,
          offset: 0,
          total: 0
        };
        searchCtrl.isShowForms2 = false;
        searchCtrl.choseCatalogItem = searchCtrl.sku || undefined;
        searchCtrl.searchRes = undefined;
        searchCtrl.notFound = undefined;
        searchCtrl.formInvalid = false;
      }

      searchCtrl.return = function(){
        searchCtrl.notFound = false;
        searchCtrl.isShowForms2 = false;
        searchCtrl.choseCatalogItem = searchCtrl.sku || undefined;
        searchCtrl.form2_params.filter_document_id = undefined;
      }


      // автокомплит для документов
      searchCtrl.refreshDocuments = function(search) {
        egaiszService.searchDocumentsAuto({
          search_string: search || undefined, 
          limit: searchCtrl.optionLength,
          fsrar_id: (fsrar)? fsrar.fsrar_id : undefined
        })
          .then(function (data) {
            searchCtrl.documents = data.data.items;
            searchCtrl.documentsTotal = data.data.total;
          });
      };

      searchCtrl.totalDocStr = function(){
        if(searchCtrl.documentsTotal > OPTIONS_LENGTH){
          return "Показано " + OPTIONS_LENGTH + " из " + searchCtrl.documentsTotal;
        }
        return '';
      };


      searchCtrl.search = function(resetOffset){
        searchCtrl.showLoader = true;
        if(resetOffset){
          searchCtrl.urlParams.offset = 0;
          searchCtrl.paging.offset = 0;
        }else{
          searchCtrl.urlParams.offset = searchCtrl.paging.offset;
        }

        egaiszService.searchAlcoCatalogItems(searchCtrl.urlParams).then(function(res){
          searchCtrl.searchRes = res.data.items;
          searchCtrl.paging.total = res.data.total;
          searchCtrl.notFound = !res.data.total;
          searchCtrl.showLoader = false;
        });
      }



      searchCtrl.choiceCatalogItem = function(event, catalogItem){
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (withoutFn2) {
          $uibModalInstance.close(catalogItem);
        } else {
          searchCtrl.catalogItemId = catalogItem.id;
          searchCtrl.sku = catalogItem;
          searchCtrl.showForm2SearchForm(catalogItem, event);
        }
      }

      searchCtrl.getForms2 = function(sortObj){
        searchCtrl.showLoader = true;
        searchCtrl.choseCatalogItem = searchCtrl.sku;
        searchCtrl.form2_params.limit = searchCtrl.form2paging.limit;
        searchCtrl.form2_params.offset = searchCtrl.form2paging.offset;
        searchCtrl.form2_params.filter_division_id = divisionId;
        searchCtrl.form2_params.filter_fsrar_id = (fsrar)? fsrar.id : undefined;

        if (sortObj) {
          // сортировка кастомная из грида
          searchCtrl.form2_params.sort_by = sortObj.sortName;
          searchCtrl.form2_params.sort_order = sortObj.sortDirection;
        }

        if (isDerivative) {
          searchCtrl.form2_params.filter_derivative_id = (searchCtrl.sku.derivative)? searchCtrl.sku.derivative.id : searchCtrl.sku.id || undefined;
        } else {
          searchCtrl.form2_params.filter_catalog_id = (searchCtrl.sku.derivative)? searchCtrl.sku.derivative.id : searchCtrl.sku.id || undefined;
        }

        if (register == "REGISTER1") {
          searchCtrl.form2_params.filter_balance = false;
        } else if (register == "REGISTER2") {
          searchCtrl.form2_params.filter_balance = true;
        }
        egaiszService.searchAlcoItems(searchCtrl.form2_params).then(function(res){
          searchCtrl.isShowForms2 = true;
          searchCtrl.forms2 = res.data.items;
          searchCtrl.notFound = !res.data.total;
          searchCtrl.form2paging.total = res.data.total;
          searchCtrl.showLoader = false;
        });
      }

      searchCtrl.showForm2SearchForm = function(catalogItem, event){
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        searchCtrl.getForms2();
      };

      if (sku) {
        searchCtrl.choiceCatalogItem(undefined, sku);
      }

      searchCtrl.selectDoc = function(item){
        if (!viewMode) {
          searchCtrl.result = item;
          searchCtrl.close();
        }
      }

      searchCtrl.getTooltipStr = function(value){
        var resStr = '';
        resStr = 'Регистр №1: ' +  (value.alcohol_stock_quantity || 0) + ', <br>';
        resStr += 'Регистр №2: ' +  (value.alcohol_shop_quantity || 0) + ', <br>';
        resStr += 'Можно вернуть на регистр №1: ' +  (value.alcohol_shop_transfer_quantity || 0);
        return resStr;
      };

      searchCtrl.goToDoc = function (doc) {
        if (needDocLink) {
          var url = $state.href($filter('docEgaisUrlStr')(doc.document_egais_type) + '.view', {id: doc.id});
          $window.open(url,'_blank');
        }
      }

      searchCtrl.columns = [{
        name: "№",
        flex: 0.1,
        headerTemplateUrl: "documentSearchHeaderCellTemplate.html",
        templateUrl: 'documentSearchNumberTemplate.html',
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Документ поставки",
        field: "document",
        flex: 1,
        headerTemplateUrl: "documentSearchHeaderCellTemplate.html",
        templateUrl: "documentAlcoSearchTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true,
        sortName: 'doc_date',
        sortDirection: 'desc'
      },{
        name: "Справка 2",
        field: "f2reg_id",
        flex: 0.55,
        headerTemplateUrl: "documentSearchHeaderCellTemplate.html",
        templateUrl: "documentAlcoSearchTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Регистр №1",
        field: "alcohol_stock_quantity",
        flex: 0.3,
        headerTemplateUrl: "documentSearchHeaderCellTemplate.html",
        templateUrl: "documentAlcoSearchTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      }];

    })
})();

/**
 * Created by aivanov on 12.10.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('productsTabs', productsTabs);

  function productsTabs() {
    return {
      restrict: 'E',
      templateUrl: 'app/catalog/directives/products-tab/products-tabs.html',
      bindToController: true,
      controllerAs: 'productsTabsCtrl',
      scope: {
        // упаковки
        packingTabs: '=',
        // признак товарной позиции
        isGoods: '<',
        // проверка совпадения кодов
        checkDuplicate: '=',
        // имя услуги/товара
        name: '<',
        // признак просмотра
        isView: '<'
      },
      controller: productsTabsController
    }

    function productsTabsController($scope, $filter, $state, $timeout) {

      var productsTabsCtrl = this;

      $scope.$on('updateUniqueUp', function (event) {
        $scope.$broadcast('updateUniqueDown');
      });
      productsTabsCtrl.scrlTabsApi = {};
      productsTabsCtrl.reCalcScroll = function() {
        if(productsTabsCtrl.scrlTabsApi.doRecalculate) {
          productsTabsCtrl.scrlTabsApi.doRecalculate();
        }else{
          productsTabsCtrl.scrlTabsApi = {};
        }
      };

      productsTabsCtrl.scrollIntoView = function(arg) {
        if(productsTabsCtrl.scrlTabsApi.scrollTabIntoView) {
          productsTabsCtrl.scrlTabsApi.scrollTabIntoView(arg);
        }
      };
      $timeout(function() {productsTabsCtrl.reCalcScroll()}, 2000);

      productsTabsCtrl.activeTab = productsTabsCtrl.activeTab || 0;
      
      productsTabsCtrl.selectTab = function(index) {
        productsTabsCtrl.activeTab = index;
        productsTabsCtrl.scrollIntoView();
      };
    }
  }
}) ();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('productsTab', productsTab);

  function productsTab() {
    return {
      restrict: 'E',
      require: '^productsTabs',
      templateUrl: 'app/catalog/directives/products-tab/products-tab.html',
      scope: {
        // объект с настройками для грида
        gridOptions: '=',
        // флаг валидности данных
        valid: '=',
        // флаг вида
        view: '<',
        // флаг товар или услуга
        isGoods: '<',
        // имя вкладки
        formName: '<?',
        // имя активной вкладки
        activeFormName: '='
      },
      link: function(scope, element, attrs, tabsCtrl) {
        scope.tabsCtrl = tabsCtrl;
      },
      controller: productsTabController
    }

    function productsTabController($scope, $state, $timeout, utilsService) {
      $scope.grid = {
        paginationPageSize: 5,
        columnDefs: [],
        data: []
      };

      angular.forEach($scope.gridOptions.attributes, function(val, key){
        if(!key){
          $scope.grid.columnDefs.push({
            name: val.name, 
            width: 350, 
            displayName: ($scope.isGoods)? 'Код складской позиции' : 'Код вида услуги', 
            cellTemplate: 'articleTemplate.html'
          });
        }else{
          if(val.name == "sku"){
            $scope.grid.columnDefs.push({
              name: val.name, 
              displayName: 'Товар', 
              cellTemplate: 'goodsTemplate.html'
            });
          }else if(val.name != "pack"){
            $scope.grid.columnDefs.push({name: val.name});
          }
        }
      });

      angular.forEach($scope.gridOptions.values, function(arr, index){
        var dataElem = {
          pos: index
        };
        angular.forEach(arr, function(val, key){
          if(val){
            if(val.value) val = val.value;
            if($scope.gridOptions.attributes[key].name != 'pack'){
              dataElem[$scope.gridOptions.attributes[key].name] = val;
            }
          }
        });
        $scope.grid.data.push(dataElem);
        $scope.hidePagination = $scope.grid.data.length < 5;
      });

      $scope.checkArticleName = function(value, pos){
        if(value && pos != undefined){
          $scope.gridOptions.values[pos][0] = value;
        }
        if ($scope[$scope.formName]) { // защита от первого вызова
          // Перебираем все поля на проверку, а не только то, на котором было вызвано событие
          angular.forEach($scope.gridOptions.values, function(
            rowArray, // строка номенклатуры
            index)  // индекс строки
          {
            if ($scope[$scope.formName]['code_' + index]) { // Самих элементов может не существовать
              if ($scope.tabsCtrl.checkDuplicate(rowArray[0])) {
                $scope[$scope.formName]['code_' + index].$setValidity('unique', false);
              } else {
                $scope[$scope.formName]['code_' + index].$setValidity('unique', true);
              }
            }
          });
        }
      }
      $scope.checkArticleName();

      $scope.$on('updateUniqueDown', function (event) {
        $scope.checkArticleName();
      })

      $scope.sendUniqueUpdateEvent = function (value, pos) {
        if(value && pos != undefined){
          $scope.gridOptions.values[pos][0] = value;
        }
        $scope.$emit('updateUniqueUp');
      }

      $scope.uniqueCallback = function (item) {
        var str = item.article;
        var num = item.pos;
        if(str){
          var obj = {
            "constraint_name": ($scope.isGoods)? 'DOMAIN_SKU_DERIVATIVE' : 'DOMAIN_SERVICE_DERIVATIVE',
            "parameters": [
              {
                "name": 'code',
                "value": str
              }
            ]
          };
          
          // для вычисления id при проверке уникальности кода дериватива
          if($scope.gridOptions.issetDerivatives && $scope.gridOptions.issetDerivatives.length){
            angular.forEach($scope.gridOptions.issetDerivatives, function(derivative){
              if(derivative.code == str){
                obj.id = derivative.id;
              }
            });
          }
          
          utilsService.uniqueCheck(obj).then(function(res){console.log(res)},
          function (error) {
            if(error.status == 409 && error.data.code == 'non_unique'){
              $scope[$scope.formName]["code_" + num].$setValidity('unique', false);
            }
          });
        }
      }

    }
  }
}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('gridSearchRow', gridSearchRow);

  /** @ngInject */
  function gridSearchRow() {
    var directive = {
      require: '^gridSearch',
      restrict: 'EA',
      templateUrl: 'app/catalog/directives/grid-search/grid-search-row.html',
      controller: gridSearchRowCtrl,
      bindToController: true,
      controllerAs: 'gridSearchRowCtrl',
      scope: {
        item: '=', // Объект поиска для отображения
        rowEvent: '<?', // callback клика на строку поиска
        withoutLinks: '<?'
      },
      link: function(scope, element, attrs, gridSearchCtrl) {
        scope.gridSearchRowCtrl.gridSearchCtrl = gridSearchCtrl;

        if (scope.gridSearchRowCtrl.item) {
          var temp = [];
          // Вычисление path для передеачи в качестве параметра
          angular.forEach(scope.gridSearchRowCtrl.item[scope.gridSearchRowCtrl.gridSearchCtrl.parentProperty], function (pathItem) {
            if (pathItem) {
              temp.push(pathItem.id);
              pathItem.path = temp.slice(); // Копируем путь в ноду (именно копия) каждую итерацию
            }
          });
          temp.push(scope.gridSearchRowCtrl.item.id); // Путь до самого элемента
          scope.gridSearchRowCtrl.item.path = temp;
        }
      }

    };
    return directive;

    function gridSearchRowCtrl($window, $state, priceListSrv, $stateParams) {
      var gridSearchRowCtrl = this;

      gridSearchRowCtrl.getUrl = function(node) {
        if (node.type) {
          return $state.href((node.type === 'SERVICE')? "catalogServices.view" : "catalogSkus.view", {elementId: node.id})
        }
      };

      gridSearchRowCtrl.expandTreePath = function (path) {
        gridSearchRowCtrl.gridSearchCtrl.expandCallback(path);
      };

      gridSearchRowCtrl.catalogItemEvent = function(){
        console.log(gridSearchRowCtrl.rowEvent);
        if(gridSearchRowCtrl.rowEvent){
          priceListSrv.getLineByItem($stateParams.parent || 'RETAIL', gridSearchRowCtrl.item.id).then(function(res){
            gridSearchRowCtrl.rowEvent(res);
          });
        }else{
          var url = $state.href((gridSearchRowCtrl.item.type === 'SERVICE')? "catalogServices.view" : "catalogSkus.view", {elementId: gridSearchRowCtrl.item.id});
          $window.open(url,'_blank');
        }
      }

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('gridSearch', gridSearch);

  /** @ngInject */
  function gridSearch() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/catalog/directives/grid-search/grid-search.html',
      controller: gridSearchCtrl,
      bindToController: true,
      controllerAs: 'gridSearchCtrl',
      scope: {
        expandCallback: '=?',
        parentProperty: '@?',
        externalSelectionModel: '<?', // внешняя модель выборки (накладывается компонентом на результат)
        showCheckbox: '<?', // флаг присутствия чекбоксов в строке
        total: '<?',
        results: '=', // Результаты поиска
        rowEvent: '<?', // callback клика на строку поиска
        withoutLinks: '<?'
      },
      link: function(scope, element, attrs) {

      }
    };
    return directive;

    function gridSearchCtrl($scope) {
      var gridSearchCtrl = this;
      // Значение по-умолчанию для имени свойства пути рдительских категорий
      if (angular.isUndefined(gridSearchCtrl.parentProperty))
        gridSearchCtrl.parentProperty = 'parentList';

      // Значение по-умолчанию для свойства присутствия чекбоксов в строках
      if (angular.isUndefined(gridSearchCtrl.showCheckbox))
        gridSearchCtrl.showCheckbox = false;

      if (gridSearchCtrl.showCheckbox) {
        // хук на изменение результатов поиска и модели выборки
        $scope.$watchGroup(['gridSearchCtrl.results', 'gridSearchCtrl.externalSelectionModel'], function (newValues, oldValues) {
          if (Array.isArray(gridSearchCtrl.results) && Array.isArray(gridSearchCtrl.externalSelectionModel)) {
            angular.forEach(gridSearchCtrl.results, function (item) {
              item._checked = !!_.find(gridSearchCtrl.externalSelectionModel, function (selectionItem) {
                // в модели выборки могут быть как объекты, таки и строки-идентификаторы
                if (typeof selectionItem === 'object') {
                  return selectionItem.id === item.id;
                }
                return selectionItem === item.id;
              })
            })
          }
        });
      }

    }
  }
})();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('attributes', attributes);

  function attributes() {
    return {
      restrict: 'E',
      templateUrl: 'app/catalog/directives/attributes/attributes.html',
      scope: {
        parentForm: '=?',
        data: '=',
        category: '=',
        kind: '<', // для отравки запросов относительно категории или упаковки
        valid: '=', // для проверки ошибок уникальности атрибутов
        issetReqAttr: '=' // флаг для уведомления о том что статус позиций изменится, при условии что добавляется обязательный атрибут
      },
      link: function($scope, el, arg){
        $scope.hideParents = function(event, isEnd){
          var elem = angular.element(event.target);
          if(event && elem.parents('.container-element').length){
            if(isEnd){
              elem.parents('.dropzone').removeClass("opacity-child");
              elem.parents('.attributeContainer').removeClass("no-opacity");
            }else{
              elem.parents('.dropzone').addClass("opacity-child");
              elem.parents('.attributeContainer').addClass("no-opacity");
            }
          }
        }
      },
      controller: function($scope, $uibModal, $timeout, catalogService, $state, utilsService, $q){
        var sc = $scope;
        var helpIndex, listCount;
        sc.customBlocks = []; // для подстановки в автокомплит блоков, которых нет в системе
        sc.reqAttrArr = [];
        sc.dataType = {
            STRING: "Строка",
            DICTIONARY: "Один из списка",
            FLOAT: "Дробное число",
            BOOLEAN: "Да/Нет",
            DATE: "Дата",
            DATE_TIME: "Дата и время",
            INTEGER: "Целое число"
        }

        // for drag&drop
        $scope.listMoved = function (index, item, parent) {
          if(listCount < parent.length){
            if(helpIndex > index){
              parent.splice(index, 1);
            } else {
              parent.splice(index + 1, 1);
            }
          }
        };
        $scope.dropCallback = function (index, item, external, type, parent){
          if(item.attribute){
            item.attribute.$$enabled = true;
          }else{
            if(item.block && item.block.hasOwnProperty('inherited')){
              item.block.$$enabled = true;
              angular.forEach(item.block.attributes, function(attr){
                attr.$$enabled = true;
              });
            }else{
              item.$$enabled = true;
            }
          }
          helpIndex = index;
          listCount = parent.length;
          parent.splice(index, 0, item);
          sc.parentForm.$setDirty();
        }

        // флаг для уведомления о том что статус позиций изменится, при условии что добавляется обязательный атрибут
        sc.checkReqAttr = function(attr){
          if(sc.reqAttrArr.length && sc.reqAttrArr.indexOf(attr.name) + 1){
            sc.reqAttrArr.splice(sc.reqAttrArr.indexOf(attr.name), 1);
          }
          sc.issetReqAttr = !!sc.reqAttrArr.length;
        }

        // удаление блока атрибута, если удаляемый атрибут последний
        function removeEmptyBlock(block){
          if(!block) return;
          var isRemoveBlock = false;
          angular.forEach(block.attributes, function(attr){
            if(attr.$$enabled) isRemoveBlock = true;
          });
          if(!isRemoveBlock) block.$$enabled = false;
          sc.parentForm.$setDirty();
        }

        // Метод, вызываемый при удалении атрибута
        $scope.deleteAttr = function (attr, categoryName, block, index) {
          if(attr.canDelete || (!sc.category.id && block)){
            // удаление без подтверждения
            attr.$$enabled = false;
            sc.checkReqAttr(attr);
            removeEmptyBlock(block);
            sc.valid();
            return;
          }
          var derivative_owners = {
            items: [],
            offset: 0,
            total: 0
          };

          // рекурсивное вычисление позиций. При удалении группы со всеми атрибутами , нудно получить у список позиций у всех атрибутов в группе
          function getPos(pos, items, i) {
            return $q(function(resolve, reject) {
              if (items[i] && items[i].id) {
                return catalogService.getPositions(items[i].id, sc.category.id).
                  then(function(res) {
                    angular.forEach(res.data.items, function(i) {
                      if (!_.find(pos.items, function(findedItem) {
                          return findedItem.id === i.id
                        })) {
                        pos.items.push(i)
                      }
                    });
                    pos.total += res.data.total;
                    i++;
                    resolve(getPos(pos, items, i));
                  }).catch(reject);
              } else {
                resolve(pos)
              }
            });
          }

          $uibModal.open({
            templateUrl: 'app/catalog/crudAttribute/ask-delete.html',
            size: 'small-width',
            resolve: {
              positions: function() {
                if (!attr.attributes && attr.id) {
                  return catalogService.getPositions(attr.id, sc.category.id).then(function(res) {
                    return res.data
                  })
                }
              }
            },
            controller: function ($scope, $uibModalInstance, positions) {
              $scope.deleteType = {value: 'block'};
              $scope.lock = false;
              $scope.name = attr.name;
              $scope.categoryName = categoryName;
              $scope.isBlock = !!attr.attributes;
              $scope.positions = positions || {};
              if (!$scope.isBlock) {
                $scope.canDelete = $scope.positions.total === 0;
              } else {
                $scope.canDelete = true;
              }
              $scope.close = function() {
                $uibModalInstance.dismiss();
              };
              function deleteAttrs() {
                angular.forEach(attr.attributes, function(value) {
                  if($scope.deleteType.value == 'block'){
                    delete value.block;
                    sc.data.splice(index++, 0, {attribute: value});
                  }else{
                    value.$$value = false;
                    sc.checkReqAttr(attr);
                  }
                });
                attr.$$enabled = false;
                sc.checkReqAttr(attr);
                $uibModalInstance.dismiss();
                removeEmptyBlock(block);
                sc.valid();
              }

              $scope.delete = function() {
                $scope.lock = true;
                if ($scope.isBlock) {
                  if ($scope.deleteType.value === 'all') {
                    getPos(derivative_owners, attr.attributes, 0).finally(function(res) {
                      $scope.positions = derivative_owners;
                      if (derivative_owners.total > 0) {
                        $scope.canDelete = false;
                        $scope.isBlock = false;
                        $scope.lock = false;
                        return;
                      }
                      deleteAttrs();
                    });
                  } else {
                    deleteAttrs();
                  }
                } else {
                  if ($scope.positions.total > 0) {
                    $scope.canDelete = false;
                    $scope.isBlock = false;
                    $scope.lock = false;
                    return;
                  }
                  deleteAttrs();
                }
                $scope.lock = false;
              };
            }
          });
        }

        // Создание/редактирование атрибута
        $scope.crudAttr = function (index, attr, editGroup, block, blockInd) {
          $uibModal.open({
            templateUrl: 'app/catalog/crudAttribute/crud-attribute.html',
            size: 'large-width',
            controller: function ($scope, $uibModalInstance, $timeout,focus) {
              var constraint = {}; // определение constraint для проверки уникальности
              $scope.isOpenNameObj = {isOpen: false};
              $scope.isOpenGroupObj = {isOpen: false};
              constraint.attr = 'DOMAIN_ATTRIBUTE_NAME';
              constraint.group = 'DOMAIN_GROUP_NAME';
              $scope.showAnotherAttrBox = false;
              $scope.showBox = function(){
                $scope.showAnotherAttrBox = !$scope.showAnotherAttrBox
              }
              $scope.editGroup = editGroup;
              $scope.dataType = sc.dataType;
              $scope.isCreate = !attr;
              $scope.disabledGroup = false;
              $scope.element = angular.copy(attr) || { $$enabled: true };
              if(sc.category && !sc.category.elements) sc.category.elements = [];
              if(block){
                $scope.element.block = {id: block.id, name: block.name};
              }
              if(editGroup){
                $scope.element.block = {name: attr.name};
              }
              // настройка скролла
              $scope.configScroll = {
                axis:'y',
                autoHideScrollbar: false,
                theme: 'dark-thick',
                advanced:{
                  updateOnContentResize: true
                },
                setHeight: 385,
                scrollInertia: 0
              }
              $scope.configScrollAtttr = $scope.configScroll;
              $scope.configScrollAtttr.setHeight = 294;

              $scope.close = function() {
                $uibModalInstance.dismiss();
              };

              // добавить пустой инпут к типу данных DICTIONARY(кнопка +)
              $scope.addDictionaryVal = function(){
                $scope.element.values.push({value: ""});
                $timeout(function(){
                  angular.element(".dict-wrapper .form-group:last-child input").focus();
                  angular.element('.grey-box').mCustomScrollbar("scrollTo",1000);
                },0);
              };

              $scope.selectDataType = function(item){
                // если тип данных DICTIONARY, то добавить пустые инпуты
                if(item == 'DICTIONARY'){
                  if(!$scope.element.values){
                    $scope.element.values = [];
                    for (var i = 0; i < 3; i++) {
                      $scope.element.values.push({value: ""});
                    }
                  }
                }
              }
              if(attr) $scope.selectDataType($scope.element.data_type);

              // проверка совпадений значений из справосника при выборе типа Dict
              $scope.checkDictVal = function(event, dictValue){
                $scope.errorInd = [];
                angular.forEach($scope.element.values, function (val1, key1) {
                  angular.forEach($scope.element.values, function (val2, key2) {
                    if(val1.value && val2.value && key1 < key2 && val1.value == val2.value){
                      $scope.errorInd.push(key1);
                      $scope.errorInd.push(key2);
                    }
                  });
                });
              }

              //Сохранение атрибута
              $scope.save = function() {
                if(attr) attr.uinqError = false;
                $scope.element.uinqError = false;
                //todo заново добавление значения которое есть в каталоге,но задизейблоно - редактировать,а не пересоздавать
                var isNewBlock = true;
                var newAttr = angular.copy($scope.element);
                delete newAttr.block;
                if(attr) attr.$$enabled = false;
                newAttr.$$enabled = true;
                var indexFix = (index === undefined)? sc.category.elements.length : index;
                //удаление пустых значений справочника
                if($scope.element.values){
                  var tempValues = [];
                  angular.forEach($scope.element.values, function(val, key){
                    if(val.value){
                      tempValues.push(val);
                    }
                  });
                  $scope.element.values = tempValues;
                  newAttr.values = tempValues;
                }
                // добавить атрибут в блок
                if($scope.element.block){
                  angular.forEach(sc.category.elements, function(value) {
                    if(value.block && value.block.name.toLowerCase() == $scope.element.block.name.toLowerCase()){
                      // найти название атрибута если есть то заменить, если нет то добавить в конец
                      var isEditAttr = false;
                      angular.forEach(value.block.attributes, function(blockAttr, key){
                        if(blockAttr.name == newAttr.name || (newAttr.id && blockAttr.id == newAttr.id)){
                          value.block.attributes.splice(key, 1, newAttr);
                          isEditAttr = true;
                          isNewBlock = false;
                          value.block.$$enabled = true;
                        }
                      });
                      if(!isEditAttr){
                        newAttr.$$enabled = true;
                        value.block.$$enabled = true;
                        if(index === undefined){
                          value.block.attributes.push(newAttr);
                        }else{
                          value.block.attributes.splice(index, 0, newAttr);
                        }
                        isNewBlock = false;
                      }

                      if($scope.autocompleteBlock && $scope.autocompleteBlock.attributes){
                        angular.forEach($scope.autocompleteBlock.attributes, function(attr, key){
                          if(attr.$$enabled){
                            if(value.block.attributes[key]){
                              value.block.attributes[key].$$enabled = attr.$$enabled;
                            }else{
                              value.block.attributes.push(attr);
                            }
                          }
                        });
                      }
                    }
                  });
                  // добавить новый блок атрибутов
                  if(isNewBlock){
                    newAttr.canDelete = true;
                    // добавление нового атрибута если не существует, если существует,то включение его
                    if($scope.autocompleteBlock && $scope.autocompleteBlock.attributes){
                      var issetNewAttr = false;
                      angular.forEach($scope.autocompleteBlock.attributes, function(attr, key){
                        if(attr.name == newAttr.name){
                          attr.$$enabled = true;
                          attr.values = newAttr.values;
                          attr.required = newAttr.required;
                          issetNewAttr = true;
                        }
                      });
                      if(!issetNewAttr){
                        $scope.autocompleteBlock.attributes.push(newAttr);
                      }
                    }else{
                      $scope.autocompleteBlock = {
                        attributes: [newAttr]
                      };
                    }
                    if(block && block.attributes.length == 1 && block.name != $scope.element.block.name){// todo добавить index блока при изменнии имени группы, если один атрибут в ней
                      indexFix = sc.category.elements.length;
                    }
                    if(!$scope.element.block.id) sc.customBlocks.push($scope.element.block.name);
                    sc.category.elements.splice(indexFix, 0, {
                      block: {
                        name: $scope.element.block.name,
                        attributes: $scope.autocompleteBlock.attributes,
                        $$enabled: true
                      }
                    });
                  }
                  if($scope.editGroup){
                    sc.category.elements.splice(indexFix, 1, {
                      block: newAttr
                    });
                    removeEmptyBlock(sc.category.elements[indexFix].block);
                  }

                }else{
                  // добавить атрибут в корневую позицию
                  newAttr.canDelete = true;
                  sc.category.elements.splice(indexFix, 0, {
                    attribute: newAttr
                  });
                }
                removeEmptyBlock(block);
                sc.valid();
                sc.parentForm.$setDirty();
                $scope.close();
                // если атрибут обязательный то ставим флаг для уведомления о том что статус позиций изменится
                if(newAttr.required){
                  sc.reqAttrArr.push(newAttr.name);
                  sc.issetReqAttr = true;
                  if(attr){
                    sc.reqAttrArr.splice(sc.reqAttrArr.indexOf(attr.name), 1);
                  }
                }
                // todo статус успеха
              };


              /*******  РАБОТА С АВТОКОМПЛИТОМ АТРИБУТОВ  *******/

              $scope.resetErrors = function(){
                $scope.attrNameError = $scope.blockNameError = '';
              }
              // проверка уникальности имени атрибута и группы атрибутов
              $scope.uniqueCheck = function(str, type){
                var constraintName;
                constraintName = constraint[type];
                if(type == 'attr'){
                  $scope.attrNameError = '';
                }else{
                  $scope.blockNameError = '';
                }
                // перед проверкой на сервере, проверить уникальность в рамках одной категории
                if(constraintName.indexOf("ATTRIBUTE") + 1){
                  $scope.checkAttrName(str);
                }else{
                  $scope.checkBlockName(str)
                }

                if(str){
                  var obj = {
                    "constraint_name": constraintName,
                    "parameters": [
                      {
                        "name": "name",
                        "value": str
                      }
                    ]
                  }

                  obj.id = (type == 'attr' ? $scope.element.id : ($scope.element.block)? $scope.element.block.id : null) || null;
                  utilsService.uniqueCheck(obj).then(function(res){
                    if(constraintName.indexOf("ATTRIBUTE") + 1){
                      $scope.attrNameError = '';
                    }else{
                      $scope.blockNameError = '';
                    }
                  },
                  function (error) {
                    if(error.status == 409 && error.data.code == 'non_unique'){
                      angular.forEach(error.data.parameters, function(field){
                        if(constraintName.indexOf("ATTRIBUTE") + 1){
                          $scope.attrNameError = "Атрибут уже существует";
                        }else{
                          $scope.blockNameError = "Группа уже существует";
                        }
                      });
                    }
                  });
                }
              }

              $scope.checkAttrInCombo = function (name) {
                $scope.uniqueCheck(name, "attr");
                $scope.checkAttrName();
              }

              // перевести попап в режим создания атрибута
              $scope.addAttribute = function(){
                var countIsset = 0;
                var tempAttr = {};
                $scope.disabledGroup = true;
                tempAttr.block = {
                  name: $scope.element.name,
                  id: $scope.element.id
                };
                tempAttr.$$enabled = true;
                $scope.autocompleteBlock.attributes = $scope.element.attributes;
                delete $scope.element;
                angular.forEach($scope.autocompleteBlock.attributes, function(attr){
                  if(attr.$$enabled){
                    attr.$$isset = true;
                    countIsset++;
                  }
                });
                if(countIsset == $scope.autocompleteBlock.attributes.length){
                  $scope.autocompleteBlock.$$isset = true;
                }
                $scope.editGroup = false;
                $scope.isCreate = true;
                $scope.element = tempAttr;
                sc.parentForm.$setDirty();
              }

              // проверка имени блока при редактировании блока атрибутов
              $scope.checkBlockName = function(name){
                if($scope.editGroup){
                  $scope.blockNameError = '';
                  if(name){
                    angular.forEach(sc.category.elements, function(elem){
                      if(elem.block && attr && elem.block.name.toLowerCase() == name.toLowerCase() && name.toLowerCase() != attr.name.toLowerCase()){
                        $scope.blockNameError = "Группа уже используется";
                      }
                    });
                  }
                }
              }

              /* Автодополнение блоков атрибутов */
              $scope.refreshAttrBlocks = function(search) {
                if(sc.customBlocks.length){
                  var match = _.filter(sc.customBlocks, function(val){
                    if(val && search){
                      return val.toLowerCase().indexOf(search.toLowerCase()) + 1;
                    }
                  });
                }
                if(search){
                  if($scope.editGroup){
                    $scope.element.name = search;
                  }else{
                    $scope.element.block = {
                      name: search
                    }
                  }
                  $scope.uniqueCheck(search, "group");
                }else{
                  $scope.element.block = undefined;
                }
                if (search && search.length >= 2) {
                  catalogService.getAttrBlocks(search, sc.kind).then(function(res){
                    $scope.attrBlocks = res.data.items;
                    angular.forEach(match, function(val){
                      $scope.attrBlocks.unshift({name: val});
                    });
                    if(!$scope.attrBlocks.length) $scope.autocompleteBlock = {};
                  });
                }
              }

              /* установить признак включенности в подгруженные атрибуты TODO */
              $scope.checkIssetAttr = function(newAttr, issetAttr){
                var issetBlock;
                if(issetAttr){
                  var attrLen = 0;
                  angular.forEach(issetAttr, function(attr){
                    if(attr.block && newAttr.name == attr.block.name && attr.block.$$enabled){
                      issetBlock = attr.block;
                    }
                  });
                  if(issetBlock){
                    angular.forEach(issetBlock.attributes, function(attr1, key){
                      angular.forEach(newAttr.attributes, function(attr2){
                        if(attr1.name == attr2.name && attr1.$$enabled){
                          attr2.$$isset = true;
                          attrLen++;
                        }
                      });
                    });

                    if(attrLen == newAttr.attributes.length){
                      $scope.autocompleteBlock.$$isset = true;
                    }
                  }
                  attrLen = 0;
                  angular.forEach(newAttr.attributes, function(attr){
                    if($scope.element.name == attr.name && !attr.$$isset){
                      attr.$$isset = true;
                      attrLen++;
                    }
                  });
                  if(attrLen == newAttr.attributes.length){
                    $scope.autocompleteBlock.$$isset = true;
                  }
                }
              }

              /* маршрутизатор подробной информации о блоке атрибутов */
              $scope.getBlockInfo = function(item){
                $scope.attrBlocks = [];
                $scope.autocompleteBlock = {};
                if(item){
                  angular.element("#blockAuto").find('input').val(item.name);
                  if(item.source == "DOMAIN_CATALOG" && !$scope.attrNameError){
                    catalogService.getBlockDomain(item.id, sc.kind).then(function(res){
                      $scope.autocompleteBlock = res.data;
                      $scope.checkIssetAttr($scope.autocompleteBlock, sc.category.elements);
                    });
                  }else if(item.source == "CATALOG" && !$scope.attrNameError){
                    catalogService.getBlockInfo(item.id).then(function(res){
                      $scope.autocompleteBlock = res.data;
                      $scope.checkIssetAttr($scope.autocompleteBlock, sc.category.elements);
                    });
                  }
                }else{
                  angular.element("#blockAuto").find('input').val('');
                }
              }
              if($scope.editGroup) $scope.getBlockInfo($scope.element);

              /* Автодополнение название атрибутов */
              $scope.refreshAttr = function(search){
                $scope.element.name = '';
                $scope.attrNameError = '';
                $scope.attributesList = [];
                if(search){
                  $scope.element.name = search;
                }
                if (search && search.length >= 2) {
                  catalogService.getAttr(search, sc.kind).then(function(res){
                    $scope.attributesList = res.data.items;
                    if(search) $scope.element.name = search;
                  });
                }
              }

              $scope.checkAttrName = function(){
                /* проверка уникальности имени атрибута в рамках категории */
                angular.forEach(sc.category.elements, function(elem){
                  if(elem.attribute){
                    if(elem.attribute.$$enabled && $scope.element.name &&
                      elem.attribute.name.toLowerCase() == $scope.element.name.toLowerCase()){
                      $scope.attrNameError = "Атрибут уже существует";
                      if(attr && elem.attribute.name.toLowerCase() == attr.name.toLowerCase()){
                        $scope.attrNameError = "";
                      }
                    }
                  }else{
                    if(elem.block.$$enabled){
                      angular.forEach(elem.block.attributes, function(val){
                        if(val.$$enabled && $scope.element.name &&
                          val.name.toLowerCase() == $scope.element.name.toLowerCase()){
                          $scope.attrNameError = "Атрибут уже используется";
                          if(attr && val.name.toLowerCase() == attr.name.toLowerCase()){
                            $scope.attrNameError = "";
                          }
                        }
                      });
                    }
                  }
                });
              }

              /* Получить детальную информацию по атрибуту */
              $scope.getAttrInform = function(item){
                $scope.attributesList = [];
                $scope.attrNameError = '';
                angular.element("#attrAuto").find('input').val((item)? item.name : '');
                $scope.element.name = (item)? item.name : '';
                $scope.element.id = (item)? item.id : '';
                if(item){
                  $scope.uniqueCheck(item.name, "attr");
                  var tempBlock = $scope.element.block;
                  if(item.source == "DOMAIN_CATALOG" && !$scope.attrNameError){
                    catalogService.getAttrDomain(item.id, sc.kind).then(function(res){
                      $scope.element = res.data;
                      $scope.element.name = (item)? item.name : res.data.name;
                      if($scope.element.data_type == 'DICTIONARY' && !$scope.element.values.length){
                        $scope.element.values = [{}, {}];
                      }
                      if($scope.element.block && !$scope.disabledGroup){
                        $scope.element.block.source = "DOMAIN_CATALOG";
                        $scope.getBlockInfo($scope.element.block)
                      }else{
                        $scope.element.block = tempBlock;
                      }
                      $scope.disabledDataType = true;
                      if($scope.element.block){
                        $scope.uniqueCheck($scope.element.block.name, "group");
                      }
                    });
                  }else if(item.source == "CATALOG" && !$scope.attrNameError){
                    catalogService.getAttrInfo(item.id).then(function(res){
                      $scope.element = res.data;
                      $scope.element.name = (item)? item.name : res.data.name;
                      if($scope.element.data_type == 'DICTIONARY' && !$scope.element.values.length){
                        $scope.element.values = [{}, {}];
                      }
                      if($scope.element.block && !$scope.disabledGroup){
                        $scope.element.block.source = "CATALOG";
                        $scope.getBlockInfo($scope.element.block)
                      }else{
                        $scope.element.block = tempBlock
                      }
                      $scope.disabledDataType = true;
                      if($scope.element.block){
                        $scope.uniqueCheck($scope.element.block.name, "group");
                      }
                    });
                  }
                }else{
                  $scope.element.name = '';
                  $scope.attrNameError = '';
                  $scope.attributesList = [];
                  $scope.disabledDataType = false;
                }
              }
              //установка фокуса в поле названия при открытии попапа
              $scope.setFocus = function (isInput,selector) {
                if ($state.current.name.endsWith('new')) {
                  if (isInput) {
                    focus.setFocusOnInput(selector);
                  } else {
                    focus.setFocusOnUiSelect(selector);
                  }
                }
              }

              $scope.setDirty = function() {
                $scope.isSetDirty = true;
                angular.forEach($scope.crudAttribute.$error, function(controls, errorName) {
                  angular.forEach(controls, function(control) {
                    control.$setDirty();
                  });
                });
              }

              $scope.setFocus(false,'#attrAuto');
              $scope.$watch('element.name', function(newVal, oldVal) {
                $scope.disabledDataType = false;
              });
            }

          });
        }
      }
    }
  }
}) ();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('attrElement', attrElement);

  function attrElement() {
    return {
      restrict: 'E',
      templateUrl: 'app/catalog/directives/attr-element/attr-element.html',
      scope: {
        // Атрибут
        attribute: '=',
        // Значение
        data: '=',
        // функция для перестройки дереватив
        callback: '=',
        // состоние
        stateName: '<',
        // Флаг разрешает несколько атрибутов
        multiple: '<?',
        // флаг для скрытия добавления новых значений атрибутов
        hideDeterminate: '<',
        // для блокировки кнопки на форме, если есть дубли
        unique: '=?',
        // форма
        parentForm: '<?'
      },
      controller: function ($scope, catalogService, focus, $filter) {
        // по-умолчанию разрешены множественные значения (из соображений обратной совместимости)
        $scope.datePickerOpts = {singleDatePicker: true, correctTimeZone: false};
        $scope.dateTimePickerOpts = {singleDatePicker: true, timePicker: true, correctTimeZone: false};

        $scope.onDatePickerClose = function (returnValue, name) {
          if (name) {
            // They said date cannot repeat more that 1 time
            $scope.data.values[0].value = returnValue && !returnValue.isEmpty ? returnValue.valueOf() : null;
          }
        };

        if ($scope.multiple === undefined) {
          $scope.multiple = true;
        }
        if (!$scope.data) {
          // Инициализация вложенной структуры значения атрибута
          $scope.data = {
            attribute: {},
            values: ['']
          };
          // todo после рефакторинга датапикера
          if ($scope.attribute.data_type === 'DATE' || $scope.attribute.data_type === 'DATE_TIME') {
            $scope.data.values = [{value: '', date: ''}];
          }
        } else {
          if ($scope.attribute.data_type === 'BOOLEAN') {
            $scope.data.values[0] = $scope.data.values[0] + "";
          }
          if ($scope.attribute.data_type === 'DATE' || $scope.attribute.data_type === 'DATE_TIME') {
            var format = ($scope.attribute.data_type === 'DATE') ? 'DD.MM.YYYY' : 'DD.MM.YYYY HH:mm';
            angular.forEach($scope.data.values, function (val, key) {
              if (val.value) {
                $scope.data.values[key] = val;
              } else {
                var dateValue = moment.utc(parseInt(val)).format(format);
                $scope.data.values[key] = {
                  value: (dateValue === 'Invalid date') ? '' : dateValue,
                  date: moment(parseInt(val)),
                  stamp: val
                };
              }
            });
          }
        }


        $scope.data.attribute = {
          id: $scope.attribute.id,
          name: $scope.attribute.name,
          data_type: $scope.attribute.data_type
        };

        function watch(value) {
          angular.forEach(value, function(val) {
            $scope.parentForm.$setValidity('requiredAttribute', angular.isDefined(val));
          });
        }

        if ($scope.attribute.required) {
          $scope.$watch(function () {
            return $scope.data.values
          }, watch);
        }

        $scope.onDatePickerChange = function(isEmpty) {
          if ($scope.attribute.required) {
            $scope.parentForm.$setValidity('requiredAttribute', !isEmpty);
          }
        };

        /* Данные справочников */
        $scope.refreshDictionary = function (search) {

          $scope.dictValues = $scope.attribute.values;
          $scope.notFound = !$filter('filter')($scope.dictValues, search).length;
        };

        $scope.addAttrValue = function (event, arr) {
          event.stopPropagation();
          arr.push('');
          setTimeout(function () {
            var parent = event.target.parentNode.parentNode;
            if ($scope.attribute.data_type === 'DICTIONARY') {
              focus.setFocusOnUiSelect(parent.querySelector('.input-wrapper-' + (arr.length - 1) + ' .ui-select-container'));
            } else {
              focus.setFocusOnInput(false, parent.querySelector('.input-wrapper-' + (arr.length - 1) + ' input'));
            }
          }, 1);
        };

        $scope.removeAttrValue = function (arr, index) {
          arr.splice(index, 1);
          $scope.callback();
        };

        $scope.checkVal = function () {
          $scope.errorInd = [];
          angular.forEach($scope.data.values, function (val1, key1) {
            angular.forEach($scope.data.values, function (val2, key2) {
              if (val1 && val2 && key1 < key2 && (val1.id && val2.id ? val1.id === val2.id :val1 === val2)) {
                $scope.errorInd.push(key1);
                $scope.errorInd.push(key2);
              }
            });
          });
          if ($scope.errorInd.length && $scope.unique.indexOf($scope.attribute.id) < 0) {
            $scope.unique.push($scope.attribute.id);
          }
          if (!$scope.errorInd.length && $scope.unique.indexOf($scope.attribute.id) > -1) {
            $scope.unique.splice($scope.unique.indexOf($scope.attribute.id), 1);
          }
          if ($scope.attribute.required) {
            watch($scope.data.values);
          }
          $scope.callback();
        };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('attrBlock', attrBlock);

  /**
   * Директива для отображения блоков атрибутов при поиске категории
   */
  function attrBlock() {
    return {
      restrict: 'E',
      templateUrl: 'app/catalog/directives/attr-block/attr-block.html',
      scope: {
        data: '=', // данные о атрибутах
        index: '<' // индекс для уникальности
      },
      link: function($scope, el){
        $scope.checkAll = function(){
          $scope.data.$$enabled = $scope.isCheckAll;
          angular.forEach($scope.data.attributes, function(attr) {
            attr.$$enabled = $scope.isCheckAll;
          });
        }

        $scope.removeCheckAll = function(enabled){
          var isExid = false;
          angular.forEach($scope.data.attributes, function(attr) {
            if(!isExid){
              $scope.data.$$enabled = !!attr.$$enabled;
              isExid = !!attr.$$enabled;
            }
          });
          $scope.isCheckAll = false;
        }
      }
    }
    
  }
}) ();

'use strict';
angular.module('frontend').component('cartPopup', {
  templateUrl: 'app/cart/modals/cartPopup/cart-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope, $rootScope, cartService, requestStatus) {
    var cartPopupCtrl = this;
    cartPopupCtrl.gridOptions = {};
    cartPopupCtrl.values = [];
    cartPopupCtrl.load = true;
    cartPopupCtrl.selectiveAdd = cartPopupCtrl.resolve.selectiveAdd;
    cartPopupCtrl.isDerivative = cartPopupCtrl.resolve.isDerivative;
    var purpose = cartPopupCtrl.resolve.purpose;
    var filterTaxGroupSelector = undefined;

    cartPopupCtrl.paging = {
      current: 0,
      limit: 10,
      offset: 0,
      limits: [10, 20, 50]
    };

    if (purpose == "CNI_FROM_SUPPLIER" || purpose == "CNO_TO_SUPPLIER" || purpose == "PO_TO_SUPPLIER" || purpose == "PR_FROM_SUPPLIER" || purpose == "INVI_PURCHASE" || purpose == "INVO_RETURN") {
      cartPopupCtrl.paging.filter_tax_group_selector = "OWN";
    }else if (purpose == "CNI_FROM_COMMITTEE" || purpose == "CNO_TO_COMMITTEE" || purpose == "PO_TO_COMMITTEE" || purpose == "PR_TO_COMMITTEE" || purpose == "REPORT_TO_COMMITTEE") {
      cartPopupCtrl.paging.filter_tax_group_selector = "COMMITTENT";
    }

    cartPopupCtrl.getCartItems = function(){
      cartService.getCartData(cartPopupCtrl.paging).then(function (res) {// todo добавить фильтр по деривативу и товару
        cartPopupCtrl.values = res.data.items;
        cartPopupCtrl.paging.total = res.data.total;
        cartPopupCtrl.load = false;
      }).catch(function (err) {
        requestStatus.error('Во время получения информации о корзине произошла ошибка. Повторите попытку позже');
      });
    }
    cartPopupCtrl.getCartItems();

    cartPopupCtrl.close = function () {
      cartPopupCtrl.modalInstance.dismiss();
    };

    cartPopupCtrl.save = function () {
      cartPopupCtrl.load = true;
      var checkedRows = cartPopupCtrl.gridOptions.getCheckedRows();
      if (checkedRows.length){
        cartPopupCtrl.modalInstance.close(checkedRows);
      }else {
        cartPopupCtrl.modalInstance.close(cartPopupCtrl.values);
      }
    };

    cartPopupCtrl.columns = [{
        name: "Наименование",
        field: "catalog_item",
        flex: 1,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartCatalogItemTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Количество",
        field: "quantity",
        flex: 0.4,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartQuantityTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Ед. изм.",
        field: "uom",
        flex: 0.3,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartNameTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Цена",
        field: "natural_price",
        flex: 0.4,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartPriceTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Налог",
        field: "tax_group",
        flex: 0.5,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartNameTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      }];

  }
});

'use strict';
angular.module('frontend').component('promoModal', {
  templateUrl: 'app/auth/register/modals/promo-popup.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function (utilsService, auth) {
    var promoModalCtr = this;
    promoModalCtr.codes = {
      promo_code: promoModalCtr.resolve.userData.promo_code || '',
      partner_code: promoModalCtr.resolve.userData.partner_code || ''
    }
    promoModalCtr.close = function () {
      promoModalCtr.modalInstance.dismiss();
    };

    promoModalCtr.savePromo = function () {
      promoModalCtr.modalInstance.close(promoModalCtr.codes);
    }

    promoModalCtr.checkCode = function (isPartnerCode) {
      if (isPartnerCode) {
        promoModalCtr.promoForm.partner_code.$setValidity('notFound', true);
        utilsService.delay(promoModalCtr.checkPartnerCode, 300);
      } else {
        promoModalCtr.promoForm.promo_code.$setValidity('notFound', true);
        utilsService.delay(promoModalCtr.checkPromoCode, 300);
      }
    }

    promoModalCtr.checkPartnerCode = function () {
      auth.checkPartnerCode(promoModalCtr.codes.partner_code).then(function (res) {
      }, function (error) {
        promoModalCtr.promoForm.partner_code.$setValidity('notFound', false);
      });
    }

    promoModalCtr.checkPromoCode = function () {
      auth.checkPromoCode(promoModalCtr.codes.promo_code).then(function (res) {
      }, function (error) {
        promoModalCtr.promoForm.promo_code.$setValidity('notFound', false);
      });
    }

    if (promoModalCtr.codes.promo_code) {
      promoModalCtr.checkPromoCode();
    }

    if (promoModalCtr.codes.partner_code) {
      promoModalCtr.checkPartnerCode();
    }

  }
});

(function() {
  'use strict';

  angular.module('frontend').service('utmConnectionsService', utmConnectionsService);

  /**
   * Сервис для работы с АПИ подключений к УТМ
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function utmConnectionsService($http, API_URL, $q) {

    this.connections = function (paging, searchText) {
      return $http.get(API_URL + '/alcohol/utms', {
        params: {
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          search_string: searchText,
          sort_order: paging.sortOrder
        }
      });
    };

    // получение информации о подключении
    this.connection = function (id) {
      return $http.get(API_URL + '/alcohol/utms/' + id);
    };

    // обновление изменений по подразделениям
    this.updateConnection = function (id, params) {
      return $http.put(API_URL + '/alcohol/utms/' + id + '/divisions', params);
    };

    // Возвращает список подразделений, доступных для добавления во ФС РАР
    this.getDivisionsList = function (id) {
      return $http.get(API_URL + '/alcohol/utms/' + id + '/divisions');
    };

    // автокомлит для fsrar
    this.utmsAuto = function (paging, searchText) {
      return $http.get(API_URL + '/alcohol/utms/auto', {
        params: {
          limit: paging.limit || 5,
          offset: paging.offset || undefined,
          sort_by: paging.sortBy || undefined,
          search_string: searchText || undefined,
          sort_order: paging.sortOrder || undefined
        }
      });
    };

  }

})();

(function() {
  'use strict';

  angular.module('frontend').controller('utmConnectionsController', utmConnectionsController);

  function utmConnectionsController($scope, $state, auth, utmConnectionsService) {
    var utmConnectionsCtrl = this;
    utmConnectionsCtrl.gridPaging = [15, 25, 50];

    // Структура для управления paging-ом
    utmConnectionsCtrl.paging = {
      current: 0,
      limit: 15,
      offset: 0,
      sortBy: undefined,
      total: undefined
    }

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    utmConnectionsCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        utmConnectionsCtrl.crudState.error = false;
        utmConnectionsCtrl.crudState.message = '';
        utmConnectionsCtrl.crudState.loading = true;
      },
      stopLoadingSuccess: function() {
        utmConnectionsCtrl.crudState.error = false;
        utmConnectionsCtrl.crudState.message = '';
        utmConnectionsCtrl.crudState.loading = false;
      },
      stopLoadingFailure: function(message) {
        utmConnectionsCtrl.crudState.error = true;
        utmConnectionsCtrl.crudState.message = message;
        utmConnectionsCtrl.crudState.loading = false;
      }
    }

    // Поиск
    utmConnectionsCtrl.search = function () {
      // Сброс текущей страницы и поиск
      utmConnectionsCtrl.paging.current = 0;
      utmConnectionsCtrl.paging.offset = 0;
      utmConnectionsCtrl.getPage();
    }

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    utmConnectionsCtrl.getPage = function () {
      utmConnectionsCtrl.noData = utmConnectionsCtrl.loadData = false;
      utmConnectionsCtrl.crudState.startLoading();
      utmConnectionsService.connections(utmConnectionsCtrl.paging, utmConnectionsCtrl.searchText).then(
        function (data) {
          if(!data.data.items.length && !utmConnectionsCtrl.searchText){
            utmConnectionsCtrl.noData = true;
          }
          utmConnectionsCtrl.connections = data.data.items;
          utmConnectionsCtrl.paging.total = data.data.total;
          utmConnectionsCtrl.crudState.stopLoadingSuccess();
          utmConnectionsCtrl.loadData = true;
        },
        function (error) {
          utmConnectionsCtrl.connections = [];
          utmConnectionsCtrl.crudState.stopLoadingFailure(error);
        }
      )
    }
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    utmConnectionsCtrl.getPage();
  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('supportService', supportService);

  function supportService($http, API_URL) {

    /* Отправка письма в поддержку */
    this.send = function (data) {
      return $http.post(API_URL + '/support_requests', data, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.getAttachmentTypes = function () {
      return $http.get('assets/api/attachmentTypes.json');
    };
  }

}) ();

'use strict';

angular.module('frontend')
.controller('supportController', function ($scope, 
                                           $stateParams,
                                           Upload,
                                           API_URL,
                                           $rootScope, 
                                           authToken,
                                           attachmentType,
                                           MAX_UPLOAD_FILE_SIZE,
                                           supportService,
                                           partnersService,
                                           $timeout,
                                           $state,
                                           requestStatus) {
  var supportCtrl = this;
  supportCtrl.params = $stateParams;
  supportCtrl.fileName = '';
  supportCtrl.data = {
  	name: $rootScope.user.name,
    subject: supportCtrl.params.subject,
    mail_body: supportCtrl.params.message,
  	reply_to: [$rootScope.user.email]
  };

	$scope.img = {};

  partnersService.getMyPartner().then(function (res) {
    supportCtrl.myPartner = res.data;
  }, function () {
      partnersService.getPartners().then(function (res) {
        supportCtrl.possiblePartners = res.data.items;
      }, function () {
          requestStatus.error('Во время получения информации о возможных партнерах произошла ошибка.');
      });
  });

  supportCtrl.partnershipReject = function () {
    partnersService.partnershipReject().then(function() {
      $state.go('support', {}, {reload: true});
    }, function () {
        requestStatus.error('Во время отказа от партнерства произошла ошибка.');
    });
  }

  supportCtrl.selectTab = function () {
    // исправляем лаг карусели из RECS-15282
    $timeout(function(){
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

	$scope.changeFile = function (elem) {
    var input = elem;
    if (input.files && input.files[0]) {
    	supportCtrl.fileName = input.files[0].name;
    	supportCtrl.type = attachmentType[input.files[0].type];
      supportCtrl.fileChosen = true;
      var reader = new FileReader();
      reader.onload = function (e) {
        $scope.$apply(function () {
          $scope.img = input.files[0];
          var maxSizeExceeded = input.files[0].size > MAX_UPLOAD_FILE_SIZE;
          // сброс или установка флага валидности
          supportCtrl.supportForm.$setValidity('maxUploadFileSize', !maxSizeExceeded);
          supportCtrl.supportForm.$setValidity('unsupportedType', !!supportCtrl.type);
          if (maxSizeExceeded) {
            supportCtrl.errorMessage = 'Размер файла превышает 5 МБ';
            return;
          }
          if (!supportCtrl.type ) {
            supportCtrl.errorMessage = 'Неподдерживаемый формат файла';
            return;
          }
          supportCtrl.errorMessage = null;
          Upload.upload({
			      url: API_URL + "/upload",
			      headers: {'X-Session-Id': authToken.getToken()},
			      data: {
			        file: $scope.img,
			        type: supportCtrl.type,
			        name: encodeURI(supportCtrl.fileName)
			      }
			    }).then(function (res) {
			      supportCtrl.data.attachments = res.data;
			    });
        });
      }
      reader.readAsDataURL(input.files[0]);
    }
  };


	supportCtrl.send = function () {
		supportCtrl.isSetDirty = true;
		supportCtrl.supportForm.$dirty = true;
      angular.forEach( supportCtrl.supportForm.$error ,function (control) {
        for (var i = 0; i < control.length; i++) {
          if (control[i]) control[i].$setDirty();
        }
      });
		if(supportCtrl.supportForm.$valid){
			supportService.send(supportCtrl.data).then(function(data){
				supportCtrl.successMessage = true;
				supportCtrl.errorMessage = undefined;
			},
			function(error){
				supportCtrl.successMessage = false;
				supportCtrl.errorMessage = error;
			});
		}
	};

  supportCtrl.openForm = function () {
    supportCtrl.showForm = true;
    if (supportCtrl.successMessage) {
      supportCtrl.successMessage = false;
      supportCtrl.data = {};
      supportCtrl.supportForm.$setUntouched();
      supportCtrl.supportForm.$setPristine();
      supportCtrl.isSetDirty = false;
    }
  }

});

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular.module('frontend').service('utilsService', UtilsService);

  function UtilsService($http, API_URL) {

    /* Загрузка списка доступных временных зон */
    this.timezones = function () {
      return $http.get(API_URL + '/utils/timezones');
    };

    /* Получение списка ограничений уникальности, зарегистрированных в системе */
    this.uniqueCheckGet = function () {
      return $http.get(API_URL + '/utils/unique_check');
    };

    /* Универсальная проверка уникальности сущности */
    this.uniqueCheck = function (obj) {
      return $http.post(API_URL + '/utils/unique_check', obj, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /**
     * Проверяет, что логин содержит запрещённый почтовый домен.
     *
     * Назначение: не даёт регистрироваться с gmail, hotmail, outlook, yahoo, icloud
     * Используется: форма регистрации, поле телефона/email
     * Параметры:
     * - login: введённый телефон или email
     * Возвращает: true, если в строке есть запрещённый домен
     */
    this.hasForbiddenEmailDomain = function (login) {
      if (!login || typeof login !== 'string' || login.indexOf('@') === -1) {
        return false;
      }
      var value = login.toLowerCase();
      var forbiddenDomains = [
        'gmail.com',
        'hotmail.com',
        'outlook.com',
        'yahoo.com',
        'icloud.com'
      ];
      for (var i = 0; i < forbiddenDomains.length; i++) {
        if (value.indexOf(forbiddenDomains[i]) !== -1) {
          return true;
        }
      }
      return false;
    };

    /* Получение списка ограничений уникальности, зарегистрированных в системе */
    this.getUniqueCheck = function () {
      return $http.get(API_URL + '/utils/unique_check');
    };

    /* Загрузка типов договоров */
    this.contractType = function () {
      return $http.get('assets/api/contract_type.json');
    };

    /* Загрузка статусов товаров и услуг */
    this.catalogStatuses = function () {
      return $http.get('assets/api/catalog_statuses.json');
    };

    this.getBankInfo = function (bik) {
      return $http.get(API_URL + '/utils/bank_info', {
        params: {
          search_string: bik,
          limit: 5
        }
      })
    };

    this.getCompanyInfo = function(search_string, limit) {
      return $http.get(API_URL + '/utils/company_info', {
        params: {
          search_string: search_string,
          limit: limit || 5
        }
      })
    };

    this.getCountryClassifierAuto = function (searchString, limit) {
      return $http.get(API_URL + '/countries/auto', {
        params: {
          search_string: searchString,
          limit: limit || 5,
          offset: 0
        }
      })
    }

    this.getUoms = function (classifier_code) {
      return $http.get(API_URL + '/uoms', {
        params: {
          filter_classifier_code: classifier_code
        }
      })
    }

    // получение сфер деятельности по id родятеля
    this.getАctivityАreasByParent = function (parent_area_id) {
      return $http.get(API_URL + '/activity_areas', {
        params: {
          parent_area_id: parent_area_id
        }
      })
    }

    // получение всех сфер деятельности
    this.getАctivityАreas = function () {
      return $http.get(API_URL + '/activity_areas/tree')
    }

    this.getActivityAreasAuto = function (search_string) {
      return $http.get(API_URL + '/activity_areas/auto', {
        params: {
          search_string: search_string,
          limit: 100
        }
      })
    }

    /* Загрузка месяцев и кварталов */
    this.quarterOrMonth = function () {
      return $http.get('assets/api/quarter_or_month.json');
    };

    /* Загрузка месяцев и кварталов */
    this.taxChargeTypes = function () {
      return $http.get('assets/api/tax_charge_types.json');
    };

    /* Загрузка связи между назначением документа, ролью контрагента и типом договора */
    this.purposeCounterpartyContractRelationship = function () {
      return $http.get('assets/api/purposeCounterpartyContractRelationship.json');
    };

    /* Загрузка месяцев и кварталов */
    this.checkIssetDomain = function (domain) {
      return $http.get(API_URL + '/noauth/domains/by_name/' + domain);
    };

    this.setDirty = function (formCtrl) {
      var me = this;
      angular.forEach(Object.entries(formCtrl.$error), function (control) {
        var controlArr = control[1];
        for (var i = 0; i < control[1].length; i++) {
          if (controlArr[i].constructor.name == "FormController") {
            me.setDirty(controlArr[i]);
          } else{
            controlArr[i].$setDirty();
          }
        }
      });
    };

    // рекурсивная установка Touched всем полям всех подформ
    // для отображения ошибок валидации
    this.setTouched = function (formCtrl) {
      var me = this;
      angular.forEach(formCtrl.$error, function (field) {
        angular.forEach(field, function(formObj){
          if (formObj.$setTouched){
            formObj.$setTouched();
            return;
          } else {
            me.setTouched(formObj);
            return;
          }
        });
      });
    };

    // для задержки вызова calback, например при вводе данных в поле
    var timeout;
    this.delay = function (callback, ms) {
      if(timeout) {
          clearTimeout(timeout);
      }
      timeout = setTimeout(function() {
          callback();
      }, ms);
    };


  }

}) ();

(function () {
  'use strict';

  angular
    .module('frontend')
    .service('userSettingsService', function ($window, $rootScope, auth, uiVersion) {
      /* Сохранение свойств целого компонента */
      this.saveComponent = function (page, component, value) {
        if ($rootScope.user) {
          var pageObj = angular.fromJson($window.localStorage.getItem($rootScope.user.id + page)) || {};
          pageObj[component] = value;
          pageObj.version = uiVersion.version;
          $window.localStorage.setItem($rootScope.user.id + page, angular.toJson(pageObj));
        }
      };

      /* Очистка свойств целого компонента */
      this.clearComponent = function (page, component) {
        if ($rootScope.user) {
          var pageObj = angular.fromJson($window.localStorage.getItem($rootScope.user.id + page)) || {};
          delete pageObj[component];

          $window.localStorage.setItem($rootScope.user.id + page, angular.toJson(pageObj));
        }
      };

      /* Сохранение конкретного свойства объекта */
      this.saveProperty = function (page, component, property, value) {
        if ($rootScope.user) {
          var pageObj = angular.fromJson($window.localStorage.getItem($rootScope.user.id + page)) || {};
          pageObj[component] = pageObj[component] || {};
          pageObj[component][property] = value;
          pageObj.version = uiVersion.version;

          $window.localStorage.setItem($rootScope.user.id + page, angular.toJson(pageObj));
        }
      };

      this.load = function (page) {
        if ($rootScope.user) {
          try {
            var obj = angular.fromJson($window.localStorage.getItem($rootScope.user.id + page));
            if (uiVersion.version !== 'dev' && uiVersion.reasonOfUpdate === 'regular' && obj.version !== uiVersion.version && uiVersion.reasonOfUpdate === 'regular') {
              throw 'version_conflict'
            } else {
              return obj;
            }
          } catch (err) {
            $window.localStorage.removeItem(page);
            return undefined;
          }
        }
      };

      /* Загрузка свойств компонента страницы */
      this.loadComponent = function (page, component) {
        if ($rootScope.user) {
          try {
            var objPage = angular.fromJson($window.localStorage.getItem($rootScope.user.id + page));
            var obj = objPage[component];
            if (uiVersion.version !== 'dev' && uiVersion.reasonOfUpdate === 'regular' && objPage.version !== uiVersion.version) {
              throw 'version_conflict'
            } else {
              return obj;
            }
          } catch (err) {
            $window.localStorage.removeItem($rootScope.user.id + page);
            return undefined;
          }
        }
      };

      /* Загрузка свойств компонента страницы */
      this.loadProperty = function (page, component, property) {
        if ($rootScope.user) {
          var temp;
          try {
            temp = angular.fromJson($window.localStorage.getItem($rootScope.user.id + page));
            if (uiVersion.version !== 'dev' &&
              uiVersion.reasonOfUpdate === 'regular' &&
              temp.version !== uiVersion.version) {
              throw 'version_conflict'
            }
          } catch (err) {
            $window.localStorage.removeItem($rootScope.user.id + page);
            return undefined;
          }
          if (temp && temp[component]) {
            return temp[component][property];
          }
        }
      };

      /* Генерация рандомного guid */
      this.guid = function () {
        function s4() {
          return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
        }

        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
          s4() + '-' + s4() + s4() + s4();
      };
    });
})();


(function() {
  'use strict';

  angular.module('frontend').service('taxModeService', taxModeService);

  /**
   * Сервис для работы с АПИ ржимов налогообложения чека
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function taxModeService($http, API_URL) {

    /* Загрузка списка ржимов налогообложения чека TODO: не реализована на бекенде */
    this.taxModes = function () {
      return $http.get('assets/api/taxMode.json');
    }
  }

}) ();

/**
 * Created by aivanov on 19.06.2017.
 */
(function() {
  'use strict';

  angular.module('frontend').service('taxService', taxService);

  /**
   * Сервис для работы с АПИ ржимов налогообложения
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function taxService($http, API_URL) {

    /* Загрузка списка ролей TODO: не реализована на бекенде */
    this.taxs = function () {
      return $http.get('assets/api/tax.json');
    }
  }

}) ();

(function() {
  'use strict';

  angular
  .module('frontend')
  .service('statusSrv', statusSrv);

  /** @ngInject */
  function statusSrv($http, API_URL, $timeout, $q) {
    this.getPromise = function(url) {
      return $q(function (resolve, reject) {
        if(!url){
          reject();
        }
        function startAsking() {
          $timeout(function() {
            $http.get(API_URL + url).then(function(res) {
              switch (res.data.status) {
                case 'FINISHED':
                  resolve(res.data);
                  break;
                case 'IN_PROGRESS':
                  $timeout(function() {
                    startAsking();
                  }, 750, false);
                  break;
                case 'ERROR':
                    reject(res.data);
                  break;
                case 'CANCELLED':
                    reject(res.data);
                  break;
                case 'EXPIRED':
                    reject(res.data);
                  break;
                default :
                    reject(res.data);
                  break;
              }
            })
          }, 750, false);
        }
        startAsking();
      });
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('settingsEntitiesService', settingsEntitiesService);

  /** @ngInject */
  function settingsEntitiesService($http) {
    var keyExceptions = [
      'shift_date',
      'return_date',
      'sale_date',
      'when_opened2' ,
      'end_date',
      'receipt_date',
      'filter_receipt_date',
      'filter_when_created',
      'date',
      'ext_date',
      'acc_date',
      'created_at',
      'updated_at',
      'analysis',
      'date',
      'when_created',
      'shipping_date',
      'doc_date',
      'when_updated',
      'last_action',
      'registration',
      'operation_type',
      'calc_cost'
    ];

    this.getEntities = function (url, paging, search, filter, transType) {
      var payload = {
        params: {
          search_string: search,
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          filter_trans_type: transType,
          sort_order: paging.sortDirection
        }
      };

      function appendParams(keyForCondition, keyForFilter, suffixMode, withoutFilterPrefix) {

        if (filter[keyForCondition] !== undefined && keyForFilter) {
          // проверка дополнительно на поле dateRange, т.к. оно означает что это промежуток дат, и если их нет то и писать в фильтры не надо
          if (filter[keyForCondition].startDate || filter[keyForCondition].endDate || filter[keyForCondition].dateRange) {
            if (filter[keyForCondition].startDate) {
              payload.params['filter_' + keyForFilter + (!suffixMode ? '_from': '_start_date')] = filter[keyForCondition].startDate.valueOf();
            }
            if (filter[keyForCondition].endDate) {
              payload.params['filter_' + keyForFilter + (!suffixMode ? '_to': '_end_date')] = filter[keyForCondition].endDate.valueOf();
            }
          } else {
            // тип операции, значение во вью: Приход/расход, а на деле надо много данных отсылать
            if (keyForCondition == 'operation_type') {
              if (filter[keyForCondition] == "IN") {
                payload.params['filter_' + keyForFilter] = ['BEGINNING_QTY', 'REPLENISHMENT', 'MOVEMENT_IN', 'WRITE_UP', 'ASSEMBLE_PLUS_WHOLE', 'DISASSEMBLE_PLUS_PARTS'];
              } else if (filter[keyForCondition] == "OUT") {
                payload.params['filter_' + keyForFilter] = ['SHIPMENT', 'MOVEMENT_OUT', 'WRITE_OFF', 'ASSEMBLE_MINUS_PARTS', 'DISASSEMBLE_MINUS_WHOLE'];
              }
            } else {
              keyForFilter = (withoutFilterPrefix)? keyForFilter : 'filter_' + keyForFilter;
              payload.params[keyForFilter] = filter[keyForCondition].valueOf();
            }
          }
        }
      }

      function appendParamsWithSuffix(keyForCondition, keyForFilter) {
        if (filter[keyForCondition] !== undefined) {
          payload.params['filter_' + keyForFilter + '_begin_date'] = filter[keyForCondition].startDate.valueOf();
          payload.params['filter_' + keyForFilter + '_end_date'] = filter[keyForCondition].endDate.valueOf();
        }
      }

      if (filter) {
        var arrays = {};
        Object.keys(filter).forEach(function (key) {
          if (key && filter[key] != undefined && filter[key] != null) {
            var filterKey = 'filter_' + key;

            if (!angular.isArray(filter[key])) {
              if (filter[key].complex) {
                if (filter[key].dateRange) {
                  filter[key].dateRange.startDate && (payload.params[filterKey + "_from"] = filter[key].dateRange.startDate.valueOf());
                  filter[key].dateRange.endDate && (payload.params[filterKey + "_to"] = filter[key].dateRange.endDate.valueOf());
                }
              } else {
                appendParamsWithSuffix('shift_date', 'start_shift');
                appendParamsWithSuffix('sale_date', 'sale');
                appendParams('receipt_date', 'start_date');
                appendParams('filter_when_created', 'when_created');
                appendParams('date', 'date');
                appendParams('when_opened2', 'start_date');
                appendParams('end_date', 'end_date');
                appendParams('return_date', 'start_date');
                appendParams('ext_date', 'ext_date');
                appendParams('acc_date', 'acc_date');
                appendParams('created_at', 'created_at');
                appendParams('updated_at', 'updated_at');
                appendParams('effective_date', 'effective_date');
                appendParams('expire_date', 'expire_date');
                appendParams('analysis', 'analysis', true);
                appendParams('date', 'date');
                appendParams('when_created', 'when_created');
                appendParams('when_updated', 'when_updated');
                appendParams('shipping_date', 'shipping_date');
                appendParams('doc_date', 'doc_date');
                appendParams('operation_type', 'transaction_type');
                appendParams('last_action', 'last_action');
                appendParams('registration', 'registration');
                appendParams('calc_cost', 'calc_cost', false, true);

                if (keyExceptions.indexOf(key) < 0) {
                  payload.params[filterKey] = filter[key];
                }
                
                if (filter[key].value) {
                  payload.params[filterKey] = filter[key].value;
                }

                if (filterKey === 'filter_status') {
                  if (filter[key] !== 'IN_PROGRESS') {
                    payload.params[filterKey] = filter[key];
                  } else if (~url.indexOf('api/documents/data') ||
                             ~url.indexOf('api/retail/documents')) {
                    payload.params[filterKey] = ['IN_PROCESS', 'IN_ROLLBACK'];
                  }
                }
              }
            } else {
              payload.params[filterKey] = _.flatten(filter[key]);
            }

          }
        });

      }

      return $http.get(url, payload).then(function (results) {
        return results.data;
      });
    };
  }
})();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular.module('frontend').service('rolesService', RolesService);

  function RolesService($http, API_URL) {

    /* Загрузка списка ролей */
    this.roles = function () {
      return $http.get(API_URL + '/users/roles');
    }
  }

}) ();

(function() {
  'use strict';

  angular.module('frontend').service('filterSettingsService', filterSettingsService);

  function filterSettingsService($http) {

    /* Настройки фильтра для контрагентов */
    this.filterCounterparty = function () {
      return $http.get('assets/api/filterSettings/filterCounterparty.json');
    };

    /* Настройки фильтра для договоров */
    this.filterContract = function () {
      return $http.get('assets/api/filterSettings/filterContract.json');
    };

    /* Настройки фильтра для сотрудников */
    this.filterEmploye = function () {
      return $http.get('assets/api/filterSettings/filterEmploye.json');
    };

    /* Настройки фильтра для подразделений */
    this.filterDivision = function () {
      return $http.get('assets/api/filterSettings/filterDivision.json');
    };

    /* Настройки фильтра для скидок */
    this.filterDicounts = function () {
      return $http.get('assets/api/filterSettings/filterDiscount.json');
    };

    /* Настройки фильтра для смен */
    this.filterCashregistesShifts = function () {
      return $http.get('assets/api/filterSettings/cashregistesShifts.json');
    };

    /* Настройки фильтра для кассовых чеков (продажи) */
    this.filterCashregistesReceipts = function () {
      return $http.get('assets/api/filterSettings/cashregistesReceipts.json');
    };

    /* Настройки фильтра для внесений */
    this.filterCashboxReplenishments = function () {
      return $http.get('assets/api/filterSettings/cashboxReplenishments.json');
    };

    /* Настройки фильтра для выемок */
    this.filterCashboxEncashments = function () {
      return $http.get('assets/api/filterSettings/cashboxEncashments.json');
    };

    /* Настройки фильтра для возвратов */
    this.filterReturns = function () {
      return $http.get('assets/api/filterSettings/filterReturns.json');
    };

    /* Настройки фильтра для всех документов */
    this.filterAllDocuments = function () {
      return $http.get('assets/api/filterSettings/AllDocuments.json');
    };

    /* Настройки фильтра для товарно-транспортных накладных */
    this.filterInvoiceWaybillList = function () {
      return $http.get('assets/api/filterSettings/InvoiceWaybillList.json');
    };

    /* Настройки фильтра для актов списания ЕГАИС */
    this.filterCancellationActsList = function () {
      return $http.get('assets/api/filterSettings/CancellationActsList.json');
    };

    /* Настройки фильтра для начальных остатков ЕГАИС */
    this.filterBeginningBalanceList = function () {
      return $http.get('assets/api/filterSettings/BeginningBalanceList.json');
    };

    /* Настройки фильтра для складских остатков ЕГАИС */
    this.filterStockBalanceList = function () {
      return $http.get('assets/api/filterSettings/StockBalanceList.json');
    };

    /* Настройки фильтра для переводов между регистрами ЕГАИС */
    this.filterTransferBetweenRegisterList = function () {
      return $http.get('assets/api/filterSettings/TransferBetweenRegisterList.json');
    };

    /* Настройки фильтра для возвратов ЕГАИС */
    this.filterWriteReturnList = function () {
      return $http.get('assets/api/filterSettings/WriteReturnListList.json');
    };

    /* Настройки фильтра для оприходования ЕГАИС */
    this.filterWriteUpStatementList = function () {
      return $http.get('assets/api/filterSettings/writeUpStatementList.json');
    };

    /* Настройки фильтра для пивной декларации */
    this.filterBeerDeclarationsList = function () {
      return $http.get('assets/api/filterSettings/beerDeclarations.json');
    };

    this.filterConsignmentNoteOutToSupplier = function() {
      return $http.get('assets/api/filterSettings/consignmentNoteOutToSupplier.json');
    };

    this.consignmentNoteInFromSupplier = function() {
      return $http.get('assets/api/filterSettings/consignmentNoteInFromSupplier.json');
    };

    /* Настройки фильтра для партнеров */
    this.filterPartners = function () {
      return $http.get('assets/api/filterSettings/Partners.json');
    };

    /* Настройки фильтра для бонусов партнеров */
    this.filterPartnerBonuses = function () {
      return $http.get('assets/api/filterSettings/PartnerBonuses.json');
    };

  }
}) ();

(function() {
  'use strict';

  angular
  .module('frontend')
  .service('downloadSrv', downloadSrv);

  /** @ngInject */
  function downloadSrv(API_URL, $q, authToken, requestStatus) {
    this.getPromise = function(url) {
      return $q(function (resolve, reject) {
        if(!url){
          reject();
        }
        try{
          var downloadLink = document.createElement('A');
          downloadLink.setAttribute('href', API_URL + url + '?session_id=' + authToken.getToken());
          downloadLink.setAttribute('download', 'true');
          downloadLink.setAttribute('target', '_blank');
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.remove();
          resolve();
        }catch(error){
          requestStatus.error('Во время формирования файла произошла ошибка. Повторите попытку позже');
          reject(error);
        }

      });
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('crudsService', crudsService);

  /** @ngInject */
  function crudsService($http,
                        $filter,
                        $rootScope) {
    this.getView = function (url, params) {
      return $http.get(url, {
        params: params
      });
    };

    this.getFormattedDate = function (date, returnTime, format) {
      if (!date || !$rootScope.user) {
        return '-';
      }

      if (returnTime) {
        return moment(date).tz($rootScope.user.time_zone).format(format || 'DD MMMM YYYY HH:mm');
      }

      return moment(date).tz($rootScope.user.time_zone).format(format || 'DD MMMM YYYY');
    };

    this.getCashValue = function (value, symbol, isCopecs) {
      symbol = symbol || '';

      if (isCopecs) {
        value = (value / 100).toFixed(2).toString().replace('.', ',');
      }

      if (value || value === 0) {
        return value + ' ' + symbol;
      }
      return '-';
    };

    this.Field = function (name, value, linkParams, info) {
      this.name = value && name.replace(/\s{2,}/g, ' ');
      this.value = value && value.replace(/\s{2,}/g, ' ');
      this.linkParams = linkParams;
      this.info = info && info.replace(/\s{2,}/g, ' ');
    };

    this.SumTableData = function (value, symbol, link) {
      this.value = isNaN(+value)
        ? value
        : $filter('currency')(value / 100, '', 2);
      this.symbol = symbol;
      this.value = value;
      this.link = link;
    };

    this.SumChild = function (values, options) {
      this.values = values;
      this.options = options;
    };

    this.SumHeader = function (values, isCollapsible, children, options) {
      this.values = values;
      this.isCollapsible = isCollapsible;
      this.isExpanded = !isCollapsible;
      this.children = children;
      this.options = options;
    };
  }
})();

/**
 * Created by aivanov on 27.05.2017.
 */
(function() {
  'use strict';

  angular.module('frontend').service('companiesService', companiesService);

  function companiesService($http) {

    /* Загрузка списка компаний */
    this.companies = function (userId) {
      return $http.get('assets/api/companies.json');
    }

    /* Загрузка списка подразделений по клмпании */
    this.divisions = function (companyId) {
      return $http.get('assets/api/divisions.json');
    }
  }

}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service("clipboardService", function clipboardService() {

      function fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
          var successful = document.execCommand('copy');
        } catch (err) {
          console.error('Could not copy text', err);
        }

        document.body.removeChild(textArea);
      }
      this.copyTextToClipboard = function(text) {
        if (!navigator.clipboard) {
          fallbackCopyTextToClipboard(text);
          return;
        }
        navigator.clipboard.writeText(text).then(function() {
        }, function(err) {
          console.error('Could not copy text: ', err);
        });
      }

    })
})();
/**
 * Created by aivanov on 02.10.2018.
 */
(function() {
  'use strict';

  angular.module('frontend').service('cacheRequest', cacheRequestService);

  function cacheRequestService($injector, $q) {

    /**
     * Структура для хранения кеша запросов.
     *
     * В качестве ключа используется конкатенация имени сервиса и метода,
     * в качестве значения, структура с timestamp и сохраненным промиссом конечного сервиса.
     *
     */
    var requestCacheMap = {};

    var TIMEOUT_CACHE = 10000; // 10 сек
    var me = this;

    this.cacheRequest = function (service, method) {
      /**
       * Возвращается функция с замыканием на имя сервиса и метод,
       * при вызове функции параметры передаются точно также, как и при вызове целевой функции.
       */
      return function () {
        var q;
        if (q = me._getFromCache(service, method, arguments)) {
          // если поиск в кеше успешен, возврашаем сохраненный промисс
          return q;
        }

        if ($injector.has(service)) {
          var reqService = $injector.get(service);
          // проверка, на то, что по переданному названию метода в сервисе определена функция
          if (reqService && angular.isFunction(reqService[method])) {
            q = reqService[method].apply(reqService, arguments);
            requestCacheMap[service + '_' + method] = {
              timestamp: Date.now(),
              params: arguments,
              promise: q
            };
            return q;
          }
        }
        return $q.defer().reject('Переданные параметы не позволяют вызвать сервис');
      }
    };

    this._getFromCache = function(service, method, params) {
      var c;
      if (c = requestCacheMap[service + '_' + method]) {
        if (Date.now() - c.timestamp < TIMEOUT_CACHE) {
          if (angular.equals(c.params, params)) {
            return c.promise; // только в этом случае возвращается сохраненный промис
          }
        } else {
          // стирание устаревшего кеша
          requestCacheMap[service + '_' + method] = undefined;
        }
      }
    }
  }

}) ();

(function() {
  'use strict';

  angular.module('frontend').service('accountingService', accountingService);

  function accountingService($http, API_URL, $rootScope) {

    /** Обороты по счету и направлению учета
      *
      * @param* dimension_type Тип направления учета (COUNTERPARTY, CONTRACT, CATALOG_ITEM, PROJECT, EXPENSE_ITEM, DIVISION, EMPLOYEE, VAT, BANK_ACCOUNT)
      * @param* dimension_id  id направления учета
      * @param* account_code  Код счета
      * @param period_start_date Дата начала периода
      * @param period_end_date Дата окончания периода
      * @param filter_company_id Фильтр по компании
      */
    this.getPeriodDimTotal = function (dimension_type, dimension_id, account_code, period_start_date, period_end_date, filter_company_id) {
      return $http.get(API_URL + '/accounting/period_dim_total', {
        params: {
          dimension_type : dimension_type,
          dimension_id : dimension_id,
          account_codes : account_code,
          period_start_date : period_start_date,
          period_end_date : period_end_date,
          filter_company_id : filter_company_id
        }
      });
    };

    /** Получение оборотов по счету
      *
      * @param* account_code Код счета
      * @param period_start_date Дата начала периода
      * @param period_end_date Дата окончания периода
      * @param filter_company_id Фильтр по компании
      */
    this.getPeriodTotal = function (account_code, period_start_date, period_end_date, filter_company_id) {
      return $http.get(API_URL + '/accounting/period_total', {
        params: {
          account_code : account_code,
          period_start_date : period_start_date,
          period_end_date : period_end_date,
          filter_company_id : filter_company_id
        }
      });
    };

    /** Получение списка финансовых транзакций
      * params:
      * @param filter_dimension_type фильтр по типу направлению учета
      * @param filter_dim_id id направления учета
      * @param accounting_codes* спиоск кодов счетов
      * @param limit: limit Количество элементов на странице
      * @param sort_by
      * @param sort_order
      */
    this.getTransactions = function (params) {
      return $http.get(API_URL + '/accounting/transactions', {
        params: {
          filter_dimension_type : params.dimension_type,
          filter_dim_id : params.dimension_id,
          accounting_codes : params.account_codes,
          limit: params.limit,
          sort_by: params.sort_by,
          sort_order: params.sort_order || 'desc'
        }
      });
    };

    function saveAccSettings (data) {
      $rootScope.accountingSettings = angular.copy(data);
    }

    /** Возвращает настройки проведения домена */
    this.getAccountingSettings = function () {
      return $http.get(API_URL + '/domain/accounting_settings');
    };

    /** Обновляет настройки проведения домена 
     * * settings:
      * @param calc_cost_enabled* Считать себестоимость товаров
      * @param inventory_accounting_enabled* Вести складской учёт
      * @param financial_accounting_enabled* Вести финансовый учёт
      */
    this.updateAccountingSettings = function (settings) {
      return $http.put(API_URL + '/domain/accounting_settings', settings).success(saveAccSettings);
    };

  }

}) ();
(function() {
  'use strict';

  angular.module('frontend').service('returnsService', ReturnsService);

  /** @ngInject */
  function ReturnsService(
  ) {
  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('returnsController', returnsController);

  /** @ngInject */
  function returnsController($state, API_URL,
                             userSettingsService,
                             uiGridConstants,
                             filterSettingsService,
                             returnsColumnDefsService,
                             divisions,
                             companies,
                             employees,
                             cashRegisters,
                             taxModes,
                             $filter,
                             $stateParams) {

    var self = this;
    self.url = API_URL + '/retail/documents/RETAIL_RETURN';
    self.page = 'returns';
    self.header = 'Возвраты';
    self.noDataStr = 'У вас пока нет ни одного документа \"Возврат\"';
    self.sort = 'date';
    self.limit = 25;
    self.columnDefs = userSettingsService.loadProperty(self.page, 'grid', 'columnsProperty') ||
      returnsColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    self.usingService = returnsColumnDefsService;
    self.filterMeta = {};
    self.params = $stateParams;

    self.rowRouteFunc = function (data) {
      $state.go('return.view', {parent: 'retail', id: data.id});
    };

    // Get data for selects
    if(companies){
      this.companiesSelect = [];
      self.companiesPopup = companies;
      companies.forEach(function (item) {
        self.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name == 'dataValue.company.name') {
          column.filter.selectOptions = self.companiesSelect;
        }
      });
    }

    if(divisions){
      this.divisionsSelect = [];
      self.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        self.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name == 'dataValue.division.name') {
          column.filter.selectOptions = self.divisionsSelect;
        }
      });
    }

    if(employees){
      this.employeeListSelect = [];
      self.employeeListPopup = employees;
      employees.forEach(function (item) {
        self.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name == 'dataValue.user.name') {
          column.filter.selectOptions = self.employeeListSelect;
        }
      });
    }

    if(cashRegisters){
      this.cashRegistersListSelect = [];
      self.cashRegistersListPopup = cashRegisters;
      cashRegisters.forEach(function (item) {
        self.cashRegistersListSelect.push({value: item.id, label: item.manufacturer + ((item.model && item.model !== item.manufacturer)?' ' + item.model: '') + ((item.serial_number)?' №' + item.serial_number : '')});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.cash_register') {
          column.filter.selectOptions = self.cashRegistersListSelect;
        }
      });
    }

    if (taxModes) {
      this.taxSelect = [];
      self.taxListPopup = taxModes;
      taxModes.forEach(function (item) {
        self.taxSelect.push({value: item, label: $filter('tax')(item)});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.tax_mode') {
          column.filter.selectOptions = self.taxSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterReturns().then(function(res){
      self.filterMeta = res.data.items;
      self.filterMeta[5].selectVal = self.companiesSelect;
      self.filterMeta[6].selectVal = self.divisionsSelect;
      //self.filterMeta[6].selectVal = self.cashRegisterPlacesSelect;
      self.filterMeta[8].selectVal = self.employeeListSelect;
      self.filterMeta[9].selectVal = self.taxSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('returnsColumnDefsService', returnsColumnDefsService);

  /** @ngInject */
  function returnsColumnDefsService(userSettingsService, $rootScope) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName" title="{{col.colDef.headerTooltip}}">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\':' +
      ' col.sort.direction == asc, \'ui-grid-icon-down-dir\':' +
      ' col.sort.direction == desc, \'ui-grid-icon-blank\':' +
      ' !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [64, 100, 160, 160, 160, 160, 200, 160, 100, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200];

    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('returns', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('returns', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('returns', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 64,
          visible: true,
          headerCellTemplate: '<div class="save-filter-star"' +
          ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
          '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
          '  ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
          '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
          '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          enableSorting: false,
          sortName: 'status',
          displayName: 'Статус',
          headerCellClass: 'text-center no-wrap-header',
          cellClass: 'text-center',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<span class="tooltip-light ui-grid-cell-contents" tooltip-placement="right" uib-tooltip="{{row.entity.dataValue.status == \'PROCESSED\'? \'Проведен\' : (row.entity.dataValue.status == \'DRAFT\')? \'Черновик\' : \'В обработке\'}}" ng-bind-html="grid.appScope.ctrl.getStatus(row.entity) | documentStatus"></span>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: $rootScope.documentStatuses
          },
          minWidth: 60,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true,
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>',
        },
        {
          __index: 2,
          name: 'dataValue.number',
          enableSorting: true,
          sortName: 'number',
          displayName: 'Номер возврата',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[2],
          visible: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.date',
          enableSorting: true,
          sortName: 'date',
          displayName: 'Дата возврата',
          headerCellTemplate: headerTemplate,
          backButton: true,
          filterName: 'return_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="return_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[3],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          pinned: true
        },
        {
          __index: 4,
          name: 'dataValue.shift_number',
          enableSorting: true,
          sortName: 'shift_number',
          displayName: 'Номер смены',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_number',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          visible: true,
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.shift_date',
          enableSorting: true,
          sortName: 'shift_date',
          displayName: 'Дата смены',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="shift_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[5],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 6,
          name: 'dataValue.sale_doc_number',
          enableSorting: true,
          sortName: 'sale_number',
          displayName: 'Номер чека продажи',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'sale_number',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          visible: false,
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.sale_doc_date',
          enableSorting: true,
          sortName: 'sale_date',
          displayName: 'Дата чека продажи',
          headerCellTemplate: headerTemplate,
          filterName: 'sale_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="sale_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[7],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 8,
          name: 'dataValue.company.name',
          sortName: 'company',
          displayName: 'Компания',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.companiesSelect
          },
          width: columnsDefinedWidth[8],
          visible: false
        },
        {
          __index: 9,
          name: 'dataValue.division.name',
          sortName: 'division',
          displayName: 'Подразделение',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.divisionsSelect
          },
          width: columnsDefinedWidth[9],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          visible: true
        },
        {
          __index: 10,
          name: 'dataValue.cash_register',
          enableSorting: false,
          enableFiltering: true,
          displayName: 'Касса',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD.manufacturer + ((COL_FIELD.model && COL_FIELD.manufacturer !== COL_FIELD.model)?\' \' + COL_FIELD.model : \'\') + ((COL_FIELD.serial_num)? \' №\' + COL_FIELD.serial_num : \'\')"/>',
          visible: false,
          width: columnsDefinedWidth[10],
          filterName: 'cash_register_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.cashRegistersListSelect
          }
        },
        {
          __index: 11,
          name: 'dataValue.place.name',
          sortName: 'place',
          displayName: 'Кассовое место',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'cash_register_place_name',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          width: columnsDefinedWidth[11],
          visible: true
        },
        {
          __index: 12,
          name: 'dataValue.home_cash_amount',
          sortName: 'home_cash_amount',
          displayName: 'Сумма наличными',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD" currency-symbol="grid.appScope.ctrl.currency"/>',
          headerCellTemplate: headerTemplate,
          width: columnsDefinedWidth[12],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.home_cash_amount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: true
        },
        {
          __index: 13,
          name: 'dataValue.home_non_cash_amount',
          sortName: 'home_non_cash_amount',
          displayName: 'Сумма безналичными',
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD" currency-symbol="grid.appScope.ctrl.currency"/>',
          headerCellTemplate: headerTemplate,
          visible: true,
          width: columnsDefinedWidth[13],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          footerCellTemplate: '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.home_non_cash_amount"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          cellClass: 'ui-custom-cell-text-align-to-right'
        },
        {
          __index: 14,
          name: 'dataValue.home_amount',
          sortName: 'home_amount',
          enableFiltering: false,
          displayName: 'Общая сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD" currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_amount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[14],
          visible: false
        },
        {
          __index: 15,
          name: 'dataValue.home_tax_amount',
          enableFiltering: false,
          displayName: 'Сумма налогов',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible: true,
          width: columnsDefinedWidth[15],
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_tax_amount || 0"\' +\n' +
          '          \' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right'
        },
        {
          __index: 16,
          name: 'dataValue.user.name',
          sortName: 'user',
          enableFiltering: true,
          displayName: 'Сотрудник',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: false,
          width: columnsDefinedWidth[16],
          filterName: 'user_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.employeeListSelect
          }
        },
        {
          __index: 17,
          name: 'dataValue.tax_mode',
          enableSorting: false,
          enableFiltering: true,
          displayName: 'СНО',
          headerTooltip: 'Система налогообложения',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<div class="ui-grid-cell-contents ellipsis"><span ng-bind="COL_FIELD | tax:true" uib-tooltip="{{COL_FIELD | tax}}" tooltip-placement="left"></span></div>',
          visible: false,
          width: columnsDefinedWidth[17],
          filterName: 'cashregister_tax_mode',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.cashRegistersListSelect
          }
        },
        {
          __index: 18,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.return_date">\n' +
          '              <p style="margin-bottom: 0">Дата возврата:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.return_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user_id">\n' +
          '              <p style="margin-bottom: 0">Сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();


(function() {
  'use strict';

  angular.module('frontend').service('projectsService', projectsService);

  /**
   * Сервис для работы с АПИ проектов
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   */
  function projectsService($http, API_URL) {

    /* Загрузка списка проектов */
    this.projects = function (paging, search) {
      return $http.get(API_URL + '/projects', {
        params: {
          search_string: search,
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection
        }
      });
    };

    /* Загрузка списка проектов для механизма автодополнения */
    this.projectsSearch = function (search, limit, filtersData) {
      var params = {};
      params.search_string = search;
      params.limit = limit || 5;
      if (filtersData) {
        Object.keys(filtersData).map(function(value) { return params[value] = filtersData[value];});
      }
      return $http.get(API_URL + '/projects/auto', {
        params: params
      });
    };

    /* Загрузка одного проекта */
    this.project = function (projectId) {
      return $http.get(API_URL + '/projects/' + projectId);
    };

    /* Удаление проекта */
    this.deleteProject = function (projectId) {
      return $http.delete(API_URL + '/projects/' + projectId);
    };

    /* Создание нового проекта */
    this.createProject = function (project) {
      return $http.post(API_URL + '/projects/', project);
    };

    /* Обновление информации о проектe */
    this.updateProject = function (project) {
      return $http.put(API_URL + '/projects/' + project.id, {
        name: project.name,
        active: project.active,
        comment: project.comment
      });
    }

  }

}) ();

(function () {
  'use strict';

  angular.module('frontend').controller('projectsController', projectsController);

  function projectsController($state, $scope, auth, projectsService, userSettingsService) {
    var projectsCtrl = this;

    if ($state.params.companyName) {
      projectsCtrl.searchText = $state.params.companyName;
    }

    $scope.goToView = function(id){
      $state.go('project.view',{projectId: id, parent: 'money'});
    };

    // Структура для управления paging-ом
    projectsCtrl.paging = userSettingsService.loadProperty("projects", "grid", "paging") || {
      current: 0,
      limit: 5,
      offset: 0,
      sortBy: 'Default',
      total: undefined
    };

    /**
     * Свойство добавлено из-за того, что количество сущностей в момент
     * сохранения может быть больше, чем при повторном обращении,
     * сохранять смещение - опасно. Кроме того, в разработке задача,
     * которая позволит после сохранения или редактирования сущности запрашивать
     * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
     * где сохранение смещение могло бы быть полезным.
     */
    projectsCtrl.paging.offset = 0;
    projectsCtrl.paging.current = 0;

    var pencil = '<a ng-if="$root.hasRole(\'project.write\')" ui-sref="project.edit({projectId: row.entity.id, parent: \'money\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>';

    $scope.columnVisibilityChanged = function(){
      var columnsProperty = projectsCtrl.gridApi.grid.options.columnDefs;
      angular.forEach(columnsProperty, function(column){
        if(column.filter) delete column.filter.selectOptions;
      });
      userSettingsService.saveProperty("projects", "grid", "columnsProperty", columnsProperty)
    };

    $scope.defaultColumns = [
      { name: 'marginLeft', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 64},
      { name: 'name', visible: true, displayName:'Наименование', cellTemplate:"textTemplate.html",enableSorting:true, enableFiltering: true, width: 300},
      { name: 'active', visible: true, displayName:'Статус', enableSorting:true, enableFiltering: true, cellTemplate: 'statusTemplate.html', width: 150, sort: {
          direction: 'desc',
          priority: 0
        }},
      { name: 'comment', visible: true, displayName:'Комментарий', cellTemplate:"textTemplate.html"},
      { name: 'created_at', displayName:'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
      { name: 'created_by.name', displayName:'Кто создал',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
      { name: 'updated_at', displayName:'Дата обновления',cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
      { name: 'updated_by.name', displayName:'Кто обновил',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
      { name: 'option', visible: true, cellTemplate: pencil, displayName:'', enableHiding:false, width: 95, enableFiltering: false},
      { name: 'marginRight', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 63}
    ];
    var columnsProperty = userSettingsService.loadProperty("projects", "grid", "columnsProperty");

    projectsCtrl.gridOptions = {
      enableGridMenu:true,
      enableColumnMenu:false,
      useExternalSorting: true,
      resizable: false,
      enableSorting:false,
      enableFiltering: false,
      showColumnFooter: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      rowTemplate: '<div ng-click="grid.appScope.goToView(row.entity.id);">' +
                    ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
                   '</div>',
      columnDefs: columnsProperty || angular.copy($scope.defaultColumns),
      onRegisterApi: function (gridApi) {
        projectsCtrl.gridApi = gridApi;
        projectsCtrl.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns.length == 0) {
            projectsCtrl.paging.sortBy = null;
            projectsCtrl.paging.sortDirection = null;
          } else {
            projectsCtrl.paging.sortBy = sortColumns[0].field;
            projectsCtrl.paging.sortDirection = sortColumns[0].sort.direction;
          }
          projectsCtrl.getPage();
        });
      },
      data: []
    };


    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    projectsCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        this.error = false;
        this.message = '';
        this.loading = true;
      },
      stopLoadingSuccess: function() {
        this.error = false;
        this.message = '';
        this.loading = false;
      },
      stopLoadingFailure: function(message) {
        this.error = true;
        this.message = message;
        this.loading = false;
      }
    }

    // Поиск
    projectsCtrl.search = function () {
      // Сброс текущей страницы и поиск
      projectsCtrl.paging.current = 0;
      projectsCtrl.paging.offset = 0;
      projectsCtrl.getPage();
    }

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    projectsCtrl.getPage = function () {
      projectsCtrl.noData = projectsCtrl.loadData = false;
      projectsCtrl.crudState.startLoading();
      userSettingsService.saveProperty("projects", "grid", "paging", projectsCtrl.paging);
      projectsService.projects(projectsCtrl.paging, projectsCtrl.searchText).then(
        function (data) {
          if(!data.data.items.length && !projectsCtrl.searchText){
            projectsCtrl.noData = true;
          }
          projectsCtrl.projects = data.data.items;
          // Ссылка в grid
          projectsCtrl.gridOptions.data = projectsCtrl.projects;
          projectsCtrl.paging.total = data.data.total;
          projectsCtrl.crudState.stopLoadingSuccess();
          projectsCtrl.loadData = true;
        },
        function (error) {
          projectsCtrl.projects = [];
          projectsCtrl.crudState.stopLoadingFailure(error);
        }
      )
    }
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    projectsCtrl.getPage();
  }

})();

(function () {
  'use strict';

	angular.module('frontend').service('priceTagsService', priceTagsService);

  function priceTagsService($http, API_URL) {
    /* Запрос настроек печати ценников */
    this.getPriceTagsSettings = function() {
      return $http.get(API_URL + "/price_tags/settings");
    }

    /* Устанока настроек печати ценников */
    this.updatePriceTagsSettings = function(settings) {
      return $http.put(API_URL + "/price_tags/settings", settings, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    }
  }

})();

(function() {
  'use strict';

angular.module('frontend').controller('priceTagsSettingsController', priceTagsSettingsController);

  function priceTagsSettingsController($scope, $state, priceTagsSettings, priceTagsService, errorMessageService, cardHistory, $q) {
    var vm = this;

    vm.formats = ['PDF', 'RTF'];
    vm.paperSizes = ['A4', 'A5', 'TAGS_PRINTER'];
    vm.priceTagSizeA4 = [
      {label: '5 х 4 см (28 шт. на листе)', value: 'SIZE_5X4'},
      {label: '10 х 4 см (14 шт. на листе)', value: 'SIZE_10X4'}
    ];
    vm.priceTagSizeA5 = [
      {label: '5 х 4 см (12 шт. на листе)', value: 'SIZE_5X4'},
      {label: '10 х 4 см (6 шт. на листе)', value: 'SIZE_10X4'}
    ];
    vm.priceTagSizeTAGS_PRINTER = [
      {label: '5 х 4 см (1 шт. на листе)', value: 'SIZE_5X4'},
      {label: '10 х 4 см (1 шт. на листе)', value: 'SIZE_10X4'}
    ];

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if(prev){
        $state.go(prev.name || 'catalog', prev.param|| {parent: $state.params.parent});
      }else{
        $state.go('catalog', {parent: $state.params.parent});
      }
    };

    if(priceTagsSettings){
      vm.priceTagsSettings = priceTagsSettings;
    }else{
      vm.priceTagsSettings = {};
      vm.priceTagsSettings.output_format = 'PDF';
      vm.priceTagsSettings.paper_size = "A5";
      vm.priceTagsSettings.price_tag_size = "5 х 4 см (12 шт. на листе)";
    }
    if (!vm.priceTagsSettings.output_format) {
      vm.priceTagsSettings.output_format = 'PDF';
    }

    if(vm.priceTagsSettings.bar_code == 'NONE'){
      vm.is_gtin = false;
      vm.is_img = false;
    }else if(vm.priceTagsSettings.bar_code == 'GTIN_IMG'){
      vm.is_gtin = true;
      vm.is_img = true;
    }else{
      vm.is_gtin = true;
      vm.is_img = false;
    }

    vm.save = function(){
      var deferred = $q.defer();
      if(!vm.is_gtin ){
        vm.priceTagsSettings.bar_code = 'NONE';
      }else if(vm.is_gtin && vm.is_img){
        vm.priceTagsSettings.bar_code = 'GTIN_IMG';
      }else{
        vm.priceTagsSettings.bar_code = 'GTIN';
      }
      return priceTagsService.updatePriceTagsSettings(vm.priceTagsSettings).then(function(res) {
        $scope.priceTagsSettings.$setPristine();
        vm.returnToPage();
      },
      function (error) {
        errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
        return deferred.reject();
      })
    };

    vm.crud = function (status) {
      switch(status) {
        case 'save':
          return vm.save();
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    }

  }
})();


(function() {
  'use strict';

  angular.module('frontend').service('paymentTypesService', paymentTypesSrv);

  function paymentTypesSrv($http, API_URL) {

    //Получить все способы оплаты
    this.paymentTypes = function (paging,searchText, filter) {
      paging = paging || {};
      filter = filter || {};
      return $http.get(API_URL + '/payment_types', {
        params: {
          search_string: searchText,
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection,
          filter_type: filter.filter_type,
          filter_by_default: filter.filter_by_default,
          filter_active: filter.filter_active,
          filter_currency: filter.filter_currency
        }
      });
    }

    this.paymentTypesAuto = function (searchText, limit, filter) {
      filter = filter || {};
      return $http.get(API_URL + '/payment_types/auto', {
        params: {
          search_string: searchText,
          limit: limit || 5,
          filter_type: filter.filter_type || 'CASH',
          filter_currency_id: filter.filter_currency_id || undefined,
          filter_company_id: filter.filter_company_id || undefined,
          filter_by_default: filter.filter_by_default || undefined
        }
      })
    }

    //информация по одному способу оплаты
    this.paymentType = function (paymentTypeId) {
      return $http.get(API_URL + '/payment_types/' + paymentTypeId);
    }

    //создание способа оплаты
    this.createPaymentType = function (paymentType) {
      return $http.post(API_URL + '/payment_types', paymentType);
    }
    //удаление способа оплаты
    this.deletePaymentType = function (paymentTypeid) {
      return $http.delete(API_URL + '/payment_types/' + paymentTypeid);
    }
    //обновление способа оплаты
    this.updatePaymentType = function (paymentType) {
      return $http.put(API_URL + '/payment_types/' + paymentType.id, paymentType);
    }


  }

}) ();

(function () {
  'use strict';

  angular.module('frontend').controller('paymentTypesController', paymentTypesController);

  function paymentTypesController($state, $scope, auth, paymentTypesService, userSettingsService) {
    var paymentTypesCtrl = this;

    $scope.goToView = function (id) {
      $state.go('paymentType.view', { paymentTypeId: id, parent: 'money' });
    };

    // Структура для управления paging-ом
    paymentTypesCtrl.paging = userSettingsService.loadProperty("paymentTypes", "grid", "paging") || {
      current: 0,
      limit: 5,
      offset: 0,
      sortBy: 'name',
      total: undefined
    };

    /**
     * Свойство добавлено из-за того, что количество сущностей в момент
     * сохранения может быть больше, чем при повторном обращении,
     * сохранять смещение - опасно. Кроме того, в разработке задача,
     * которая позволит после сохранения или редактирования сущности запрашивать
     * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
     * где сохранение смещение могло бы быть полезным.
     */
    paymentTypesCtrl.paging.offset = 0;
    paymentTypesCtrl.paging.current = 0;

    var pencil = '<a ng-if="$root.hasRole(\'payment_type.write\') && row.entity.type !== \'CASH\'" ui-sref="paymentType.edit({paymentTypeId: row.entity.id, parent: \'money\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>',
      currencyTemplate = "<cell-with-tooltip text=\"row.entity.type !== 'CASH' && row.entity.contract.currency.name ? row.entity.contract.currency.name + ' ('+ row.entity.contract.currency.char_iso_code +')':''\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip>",
      contractTemplate = '<cell-with-tooltip text="row.entity.type !== \'CASH\' && row.entity.contract.number ? \'№\' + row.entity.contract.number + \' от \' + (row.entity.contract.date | date: \'dd.MM.yyyy\') + \' (\' + row.entity.contract.counterparty_name + \')\': \'\'" cell-row="row" cell-col="col"></cell-with-tooltip>';

    $scope.columnVisibilityChanged = function () {
      var columnsProperty = paymentTypesCtrl.gridApi.grid.options.columnDefs;
      userSettingsService.saveProperty("paymentTypes", "grid", "columnsProperty", columnsProperty)
    }

    /* настройки грида по умолчанию ($scope - обязательно) */
    $scope.defaultColumns = [
      { name: 'marginLeft', field: 'option', displayName: '', enableColumnMenu: false, enableHiding: false, enableFiltering: false, width: 64 },
      { name: 'name', displayName: 'Наименование', visible: true, cellTemplate: "textTemplate.html", enableSorting: true, width: 300 },
      { name: 'type', displayName: 'Тип', visible: true, cellTemplate: "typeTemplate.html", enableSorting: false },
      { name: 'active', displayName: 'Статус', visible: true, enableSorting: false, cellTemplate: 'statusTemplate.html', width: 150 },
      { name: 'default', cellTemplate: "defaultTemplate.html", visible: true, enableSorting: false, displayName: 'По умолчанию' },
      { name: 'contract', displayName: 'Договор', visible: false, enableSorting: false, cellTemplate: contractTemplate },
      { name: 'contract.currency', cellTemplate: currencyTemplate, enableSorting: false, displayName: 'Валюта', visible: false },
      { name: 'created_at', displayName: 'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false },
      { name: 'created_by.name', displayName: 'Кто создал', cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible: false },
      { name: 'updated_at', displayName: 'Дата обновления', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false },
      { name: 'updated_by.name', displayName: 'Кто обновил', cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible: false },
      { name: 'option', cellTemplate: pencil, displayName: '', enableHiding: false, width: 95 },
      { name: 'marginRight', field: 'option', displayName: '', enableColumnMenu: false, enableHiding: false, enableFiltering: false, width: 63 }
    ];


    paymentTypesCtrl.gridOptions = {
      enableGridMenu: true,
      enableColumnMenu: false,
      useExternalSorting: true,
      enableSorting: false,
      enableFiltering: false,
      showColumnFooter: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      rowTemplate: '<div ng-click="grid.appScope.goToView(row.entity.id);">' +
        ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
        '</div>',
      columnDefs: userSettingsService.loadProperty("paymentTypes", "grid", "columnsProperty") || angular.copy($scope.defaultColumns),
      onRegisterApi: function (gridApi) {
        paymentTypesCtrl.gridApi = gridApi;
        paymentTypesCtrl.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns.length === 0) {
            paymentTypesCtrl.paging.sortBy = null;
            paymentTypesCtrl.paging.sortDirection = null;
          } else {
            paymentTypesCtrl.paging.sortBy = sortColumns[0].field;
            paymentTypesCtrl.paging.sortDirection = sortColumns[0].sort.direction;
          }
          paymentTypesCtrl.getPage();
        });
      },
      data: []
    };


    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    paymentTypesCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function () {
        this.error = false;
        this.message = '';
        this.loading = true;
      },
      stopLoadingSuccess: function () {
        this.error = false;
        this.message = '';
        this.loading = false;
      },
      stopLoadingFailure: function (message) {
        this.error = true;
        this.message = message;
        this.loading = false;
      }
    }

    // Поиск
    paymentTypesCtrl.search = function () {
      // Сброс текущей страницы и поиск
      paymentTypesCtrl.paging.current = 0;
      paymentTypesCtrl.paging.offset = 0;
      paymentTypesCtrl.getPage();
    }

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    paymentTypesCtrl.getPage = function () {
      paymentTypesCtrl.noData = paymentTypesCtrl.loadData = false;
      userSettingsService.saveProperty("paymentTypes", "grid", "paging", paymentTypesCtrl.paging)
      paymentTypesCtrl.crudState.startLoading();
      paymentTypesService.paymentTypes(paymentTypesCtrl.paging, paymentTypesCtrl.searchText).then(
        function (data) {
          if (!data.data.items.length && !paymentTypesCtrl.searchText) {
            paymentTypesCtrl.noData = true;
          }
          paymentTypesCtrl.paymentTypes = data.data.items;
          // Ссылка в grid
          paymentTypesCtrl.gridOptions.data = paymentTypesCtrl.paymentTypes;
          paymentTypesCtrl.paging.total = data.data.total;
          paymentTypesCtrl.crudState.stopLoadingSuccess();
          paymentTypesCtrl.loadData = true;
        },
        function (error) {
          paymentTypesCtrl.paymentTypes = [];
          paymentTypesCtrl.crudState.stopLoadingFailure(error);
        }
      )
    }
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    paymentTypesCtrl.getPage();
  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('paidServicesService', paidServicesService);

  /**
   * Сервис для работы с АПИ платных услуг
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function paidServicesService($http, API_URL, $rootScope) {
    /* Загрузка списка доступных услуг */
    this.getPaidServices = function (paging, search) {
      paging = paging || {};
      var data = {
        params: {
          search_string: search,
          limit: paging.limit || 100,
          offset: paging.offset || 0,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection
        }
      };
      return $http.get(API_URL + '/paid_service', data);
    }

    /* Загрузка списка действующих услуг */
    this.getPaidSubscription = function (paging, search, status) {
      paging = paging || {};
      var data = {
        params: {
          search_string: search,
          limit: paging.limit || 100,
          offset: paging.offset || 0,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection,
          status: status
        }
      };
      return $http.get(API_URL + '/paid_service_subscription', data);
    }

    this.getPaidService = function (id) {
      return $http.get(API_URL + '/paid_service/' + id);
    }

    this.getPaidServiceSubscription = function (id) {
      return $http.get(API_URL + '/paid_service_subscription/' + id);
    }

    this.savePaidService = function (data) {
      return $http.post(API_URL + '/paid_service_subscription', data);
    };

    this.updatePaidService = function (id, data) {
      return $http.put(API_URL + '/paid_service_subscription/' + id, data);
    };

    this.deletePaidService = function (id) {
      return $http.delete(API_URL + '/paid_service_subscription/' + id);
    }

    /* Продление подписки */
    this.extendSubscription = function (id, number_of_months) {
      return $http.post(API_URL + '/paid_service_subscription/' + id + "/extend?number_of_months=" + number_of_months, {});
    };

    this.orderInvoice = function (data) {
      return $http.post(API_URL + '/paid_service_subscription/order_invoice', data);
    };

    this.payOnline = function (data) {
      return $http.post(API_URL + '/paid_service_subscription/pay_online', data);
    };
    
  }

}) ();

(function() {
  'use strict';

  angular.module('frontend').controller('paidServicesCtrl', paidServicesCtrl);

  function paidServicesCtrl($scope, $state, $stateParams, paidServicesService, $timeout, $rootScope, $filter, $uibModal, companies, requestStatus, $window) {
    var paidServicesCtrl = this;
    paidServicesCtrl.activeStatus = "EMPTY";
    paidServicesCtrl.companies = companies;

    // Структура для управления paging-ом
    paidServicesCtrl.paging = {
      current: 0,
      limit: 25,
      offset: 0,
      sortBy: undefined,
      total: undefined
    }

    paidServicesCtrl.statusesMap = {
      INVOICE_SENT: "Счет выставлен",
      INVOICE_ORDERED: "Счет заказан",
      ACTIVE: "Активна",
      EXPIRED: "Подписка истекла",
      DRAFT: "Выбранные"
    };

    paidServicesCtrl.tabs = {
      "EMPTY" : {
        "title": "Доступные",
        "include": "app/settings/paid-services/includes/available.html",
        "requestFunction": paidServicesService.getPaidServices,
        "paging": angular.copy(paidServicesCtrl.paging),
        "searchText": "",
        "paidServices": [],
        "pagingCallback": function () {
          paidServicesCtrl.universalGetPaidServices("EMPTY");
        }
      },
      "ACTIVE" : {
        "title": "Действующие",
        "include": "app/settings/paid-services/includes/existing.html",
        "requestFunction": paidServicesService.getPaidSubscription,
        "paging": angular.copy(paidServicesCtrl.paging),
        "searchText": "",
        "paidServices": [],
        "pagingCallback": function () {
          paidServicesCtrl.universalGetPaidServices("ACTIVE");
        }
      },
      "INVOICE_SENT" : {
        "title": "Ожидают оплаты",
        "include": "app/settings/paid-services/includes/invoice-sent.html",
        "requestFunction": paidServicesService.getPaidSubscription,
        "paging": angular.copy(paidServicesCtrl.paging),
        "searchText": "",
        "paidServices": [],
        "pagingCallback": function () {
          paidServicesCtrl.universalGetPaidServices("INVOICE_SENT");
        }
      },
      "EXPIRED" : {
        "title": "Истекшие",
        "include": "app/settings/paid-services/includes/expired.html",
        "requestFunction": paidServicesService.getPaidSubscription,
        "paging": angular.copy(paidServicesCtrl.paging),
        "searchText": "",
        "paidServices": [],
        "pagingCallback": function () {
          paidServicesCtrl.universalGetPaidServices("EXPIRED");
        }
      },
      "DRAFT" : {
        "title": "Выбранные",
        "include": "app/settings/paid-services/includes/draft.html",
        "showLength": true,
        "requestFunction": paidServicesService.getPaidSubscription,
        "paging": angular.copy(paidServicesCtrl.paging),
        "searchText": "",
        "paidServices": [],
        "pagingCallback": function () {
          paidServicesCtrl.universalGetPaidServices("DRAFT");
        }
      }
    };

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    paidServicesCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        paidServicesCtrl.crudState.error = false;
        paidServicesCtrl.crudState.message = '';
        paidServicesCtrl.crudState.loading = true;
      },
      stopLoadingSuccess: function() {
        paidServicesCtrl.crudState.error = false;
        paidServicesCtrl.crudState.message = '';
        paidServicesCtrl.crudState.loading = false;
      },
      stopLoadingFailure: function(message) {
        paidServicesCtrl.crudState.error = true;
        paidServicesCtrl.crudState.message = message;
        paidServicesCtrl.crudState.loading = false;
      }
    }

    // Поиск
    paidServicesCtrl.search = function (status) {
      // Сброс текущей страницы и поиск
      paidServicesCtrl.tabs[status].paging.current = 0;
      paidServicesCtrl.tabs[status].paging.offset = 0;
      paidServicesCtrl.universalGetPaidServices(status);

    }

    paidServicesCtrl.goToCard = function (id, subscription, prices) {
      var params = {id: id, subscription: subscription};
      if (prices && prices.length == 1) {
        params.tarif = prices[0].id;
      }
      $state.go('paidService', params);
    }

    paidServicesCtrl.disabledlClick = function(event){
      event.stopPropagation();
      event.preventDefault();
    }

    paidServicesCtrl.companyWords = ["компаний", "компания", "компании"];
    paidServicesCtrl.divisionWords = ["подразделений", "подразделение", "подразделения"];
    paidServicesCtrl.cashregisterWords = ["касс", "касса", "кассы"];
    paidServicesCtrl.monthsWords = ["месяцев", "месяц", "месяца"];
    paidServicesCtrl.weekWords = ["недель", "неделю", "недели"];

    paidServicesCtrl.getCorrectWord = function(number, words){
      var lastDigit = number % 10;
      if (number < 20 && number > 10) {
        return words[0];
      } else if (lastDigit == 1) {
        return words[1];
      } else if (lastDigit < 5 && lastDigit > 1) {
        return words[2];
      } else {
        return words[0];
      }
    }

    paidServicesCtrl.getTarifDescription = function (serv, index) {
      var tarif = serv.prices[index];
      var returnStr = '';
      if (serv.applicable_to_company) {
        if (returnStr) returnStr += ', <hr/>';
        returnStr += tarif.number_of_companies + ' ' +
               paidServicesCtrl.getCorrectWord(tarif.number_of_companies, paidServicesCtrl.companyWords);
      }
      if (serv.applicable_to_division) {
        if (returnStr) returnStr += ', <hr/>';
        returnStr += tarif.number_of_divisions + ' ' +
               paidServicesCtrl.getCorrectWord(tarif.number_of_divisions, paidServicesCtrl.divisionWords);
      }
      if (serv.applicable_to_cashregister) {
        if (returnStr) returnStr += ', <hr/>';
        returnStr += tarif.number_of_cashregisters + ' ' +
               paidServicesCtrl.getCorrectWord(tarif.number_of_cashregisters, paidServicesCtrl.cashregisterWords);
      }
      if (tarif.number_of_months) {
        if (returnStr) returnStr += '<hr/>';

        if (tarif.number_of_months < 1) {
          returnStr += ' на ' + tarif.number_of_months/0.25 + ' ' + paidServicesCtrl.getCorrectWord(tarif.number_of_months/0.25, paidServicesCtrl.weekWords);
        } else {
          returnStr += ' на ' + tarif.number_of_months + ' ' + paidServicesCtrl.getCorrectWord(tarif.number_of_months, paidServicesCtrl.monthsWords);
        }
      }

      return returnStr;
    }

    // получить описание тарифа
    paidServicesCtrl.getDescriptionTarif = function (price, priceSubscription) {
      priceSubscription = priceSubscription ? priceSubscription / 100 : undefined;
      var description = (!price.price && !priceSubscription)? "БЕСПЛАТНО " : $filter('priceFormatter')((priceSubscription || price.price), price.currency.char_iso_code, 0);
      if (price.number_of_companies) {
        description += " " + price.number_of_companies + " " + paidServicesCtrl.getCorrectWord(price.number_of_companies, paidServicesCtrl.companyWords)
      }
      if (price.number_of_divisions) {
        if (price.number_of_companies) description += ",";
        description += " " + price.number_of_divisions + " " + paidServicesCtrl.getCorrectWord(price.number_of_divisions, paidServicesCtrl.divisionWords)
      }
      if (price.number_of_cashregisters) {
        if (price.number_of_companies || price.number_of_divisions) description += ",";
        description += " " + price.number_of_cashregisters + " " + paidServicesCtrl.getCorrectWord(price.number_of_cashregisters, paidServicesCtrl.cashregisterWords)
      }

      if (price.number_of_months < 1) {
        description += ' на ' + price.number_of_months/0.25 + ' ' + paidServicesCtrl.getCorrectWord(price.number_of_months/0.25, paidServicesCtrl.weekWords);
      } else {
        description += ' на ' + price.number_of_months + ' ' + paidServicesCtrl.getCorrectWord(price.number_of_months, paidServicesCtrl.monthsWords);
      }
      return description;
    }

    // Функция получения данных по разным типам услуг, вызывается при изменениях фильтров и пейджинге
    paidServicesCtrl.universalGetPaidServices = function (status, tabOn) {
      paidServicesCtrl.crudState.loading = true;
      paidServicesCtrl.crudState.startLoading();
      paidServicesCtrl.tabs[status].requestFunction(paidServicesCtrl.tabs[status].paging, paidServicesCtrl.tabs[status].searchText, status).then(
        function (data) {
          if(!data.data.items.length && !paidServicesCtrl.tabs[status].searchText){
            paidServicesCtrl.noData = true;
          }
          paidServicesCtrl.tabs[status].paidServices = data.data.items;
          paidServicesCtrl.tabs[status].paging.total = data.data.total;
          paidServicesCtrl.crudState.stopLoadingSuccess();
          paidServicesCtrl.crudState.loading = false;
          _.forEach(paidServicesCtrl.tabs[status].paidServices, function(serv){
            _.forEach(serv.prices, function(tarif, index){
              tarif.parentId = serv.id;
              tarif.description = paidServicesCtrl.getTarifDescription(serv, index);
            });
          });
          $timeout(function() {
            if (tabOn)
              paidServicesCtrl.activeStatus = status;
          }, 0);
        },
        function (error) {
          paidServicesCtrl.crudState.loading = false;
          paidServicesCtrl.tabs[status].paidServices = [];
          paidServicesCtrl.crudState.stopLoadingFailure(error);
        }
      );
    }

    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    paidServicesCtrl.universalGetPaidServices("EMPTY");
    paidServicesCtrl.universalGetPaidServices("ACTIVE");
    paidServicesCtrl.universalGetPaidServices("INVOICE_SENT");
    paidServicesCtrl.universalGetPaidServices("EXPIRED");
    paidServicesCtrl.universalGetPaidServices("DRAFT");

    $timeout(function(){
      paidServicesCtrl.showCarousel = true;
      if ($stateParams.tabName) {
        $timeout(function(){
          paidServicesCtrl.selectTab($stateParams.tabName);
        }, 200);
      }
    }, 500);

    paidServicesCtrl.selectTab = function (status) {
      paidServicesCtrl.activeStatus = status;
      if (!paidServicesCtrl.tabs[status] || !paidServicesCtrl.tabs[status].paidServices.length) {
        paidServicesCtrl.activeStatus = "EMPTY";
      }
      // исправляем лаг карусели из RECS-15282
      $timeout(function(){
        window.dispatchEvent(new Event('resize'));
      }, 0);
    }

    paidServicesCtrl.extend = function (paidServId, invoice_out_id, goToService) {
      $uibModal.open({
        size: 'small-width',
        component: 'extendSubscribePopup',
        controllerAs: 'extendSubscribeCtrl',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          goToService: goToService,
          serviceId: function() {
            return paidServId;
          },
          invoice_out_id: function() {
            return invoice_out_id;
          },
          callback: function () {
            if (!invoice_out_id){
              paidServicesCtrl.universalGetPaidServices("ACTIVE");
              paidServicesCtrl.universalGetPaidServices("EXPIRED");
              return
            }

            if (goToService)
              return;

            paidServicesCtrl.universalGetPaidServices("DRAFT");
            paidServicesCtrl.universalGetPaidServices("INVOICE_SENT", true);
          }
        }
      });
      modal.result.then(function(res) {
        if (!res)
          return;
        paidServicesCtrl.universalGetPaidServices("DRAFT");
      });
    }

    paidServicesCtrl.getPaidServicesIds = function (status) {
      return _.map(paidServicesCtrl.tabs[status].paidServices, function (paidService) {
        return paidService.id
      });
    }

    paidServicesCtrl.orderInvoice = function () {
      var modal = $uibModal.open({
        size: 'small-width',
        component: 'orderPopup',
        controllerAs: 'orderPopupCtr',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          companies: function() {
            return paidServicesCtrl.companies;
          },
          email: function() {
            return $rootScope.user.email;
          }
        }
      });
      modal.result.then(function(res){
        if (!res.orderObj)
          return;

        var requestObj = {
          email: res.orderObj.email,
          phone: res.orderObj.phone,
          payer: {
            id: res.orderObj.company.id,
            name: res.orderObj.company.name
          },
          items: paidServicesCtrl.getPaidServicesIds('DRAFT')
        };
        paidServicesService.orderInvoice(requestObj).then(function (res) {
          requestStatus.success("Счет успешно заказан");
          paidServicesCtrl.activeStatus = "INVOICE_SENT";
          paidServicesCtrl.extend(null, res.data.items[0].invoice_out.id);
        }, function () {
          requestStatus.error('Во время заказа счета произошла ошибка. Повторите попытку позже.');
        });
      });
    }

    paidServicesCtrl.payOnline = function () {
      var modal = $uibModal.open({
        size: 'small-width',
        component: 'orderPopup',
        controllerAs: 'orderPopupCtr',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          isOnline: true,
          companies: function() {
            return paidServicesCtrl.companies;
          },
          email: function() {
            return $rootScope.user.email;
          }
        }
      });
      modal.result.then(function(res){
        if (!res.orderObj)
          return;

        var requestObj = {
          email: res.orderObj.email,
          phone: res.orderObj.phone,
          payer: { 
            id: res.orderObj.company.id,
            name: res.orderObj.company.name
          },
          items: paidServicesCtrl.getPaidServicesIds('DRAFT')
        };
        paidServicesService.payOnline(requestObj).then(function (res) {
          if (!res.data.confirmation || !res.data.confirmation.confirmation_url)
              return;

          $window.open(res.data.confirmation.confirmation_url, '_blank');
        }, function () {
          requestStatus.error('Во время заказа счета произошла ошибка. Повторите попытку позже.');
        });
      });
    }

    paidServicesCtrl.remove = function (event, serviceId) {
      event.stopPropagation();
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'выбранную услугу';

          $scope.close = function () {
            $uibModalInstance.dismiss();
          };

          $scope.delete = function() {
            $scope.lock = true;

            paidServicesService.deletePaidService(serviceId).then(function (res) {
              requestStatus.success("Выбранная услуга успешно удалена");
              if (paidServicesCtrl.getPaidServicesIds('DRAFT').length == 0)
                paidServicesCtrl.activeStatus = "INVOICE_SENT";

              paidServicesCtrl.tabs["DRAFT"].pagingCallback();
              $uibModalInstance.dismiss();
            }, function () {
              requestStatus.error('Во время удаления  услуги произошла ошибка. Повторите попытку позже.');
              $uibModalInstance.dismiss();
            });
          };
        }
      });
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('markedProductSettings', markedProductSettings);

  function markedProductSettings($scope, settings,
                                 cardHistory,
                                 productGroups,
                                 categoryService,
                                 catalogService,
                                 helpService,
                                 $q,
                                 $state) {
    var vm = this;
    vm.hiddenItems = [];
    vm.settings = settings.map(function (setting) {
      var view = {};
      view.category = {
        id: setting.id,
        name: setting.name
      };
      view.product_group = setting.product_group;
      view.scan_mark_type = setting.scan_mark_type;
      vm.hiddenItems.push(setting.id);
      return view;
    });
    vm.productGroups = productGroups;
    vm.scanMarkTypes = categoryService.getScanMarkTypes();
    vm.triggersMap = {};
    vm.watchersMap = {};


    function _setFormDirty() {
      if ($scope.markedProductSettingsForm.$pristine) {
        $scope.markedProductSettingsForm.$setDirty();
      }
    }

    function _setOneTimeWatcher(setting, index) {
      _setFormDirty();
      var canceler = $scope.$watch(function () {
        return vm.triggersMap[setting.$$uiid];
      }, function (value) {
        if (value && value.openChooseCategoryDialog) {
          value.openChooseCategoryDialog()
            .then(function () {
              canceler();
            }, function () {
              vm.deleteCategorySettings(index);
              canceler();
            });
        }
      });
    }

    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if (prev) {
        $state.go(prev.name || 'catalog', prev.param || {parent: $state.params.parent});
      } else {
        $state.go('catalog', {parent: $state.params.parent});
      }
    };

    vm.refreshProductGroups = function(searchString) {
      categoryService.getProductGroup(searchString)
        .then(function (res) {
          vm.productGroups = res;
        });
    };

    vm.onCategoryPopupClose = function(category, index) {
      if (category) {
        vm.hiddenItems[index] = category.id;
      } else {
        vm.hiddenItems.splice(index, 1);
      }
      _setFormDirty();
    };

    vm.deleteCategorySettings = function(index) {
      vm.hiddenItems.splice(index, 1);
      vm.settings.splice(index, 1);
      _setFormDirty();
    };

    vm.addNewSettings = function () {
      var newSetting = {
        $$uiid: helpService.stringGen()
      };
      vm.settings.push(newSetting);
      _setOneTimeWatcher(newSetting, vm.settings.length - 1);
    };

    function _prepareToSave() {
      return vm.settings.map(function (categorySettings) {
        var model = {};
        model.id = categorySettings.category.id;
        model.name = categorySettings.category.name;
        model.product_group = categorySettings.product_group;
        model.scan_mark_type = categorySettings.scan_mark_type;
        return model;
      });
    }

    vm.save = function() {
      return catalogService.updateMarksSettings(_prepareToSave())
        .then(function () {
          vm.returnToPage();
        })
    };

    vm.crud = function (status) {
      switch(status) {
        case 'save':
          if ($scope.markedProductSettingsForm.$valid) {
            return vm.save()
          }
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
        default :
          return $q.when();
      }
    }
  }

})();

'use strict';

angular.module('frontend').controller('mainSettingsController', function ($scope) {
  var vm = this;
  vm.settingsOptions = [{
    label: "Настройки учета",
    link: "accountingSettings"
  },
  {
    label: "Настройки документов",
    link: "documentSettings"
  },
  {
    label: "Настройки каталога товаров",
    link: "attrSettings"
  },
  {
    label: "Настройки реализации алкогольной продукции",
    link: "alcoholSettings"
  },
  {
    label: "Настройки реализации маркированного товара",
    link: "markedProductSettings"
  },
  {
    label: "Настройка печати ценников",
    link: "priceTagsSettings"
  },
  {
    label: "Настройка печати этикеток",
    link: "inventoryTagSettings"
  }];

});
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа оприходования ЕГАИС.
   */
  angular.module('frontend').filter('writeUpStatementStatus', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'DRAFT':
            status = 'Черновик';
            break;
          case 'NEED_TO_ACCOUNTED':
            status = 'Ожидает проведения';
            break;
          case 'SEND_TO_EGAIS':
            status = 'Отправка в ЕГАИС';
            break;
          case 'ACCEPTED':
            status = 'Доставлен в ЕГАИС';
            break;
          case 'REJECTED':
            status = 'Отклонен';
            break;
          case 'CONFIRMED':
            status = 'Принят в ЕГАИС';
            break;
          case 'IN_PROGRESS':
            status = 'Проведение';
            break;
          case 'ACCOUNTED_TO':
            status = 'Проведен';
            break;
          case 'ACCOUNTED_ERROR':
            status = 'Ошибка проведения';
            break;
          case 'DATA_RECEIVED':
            status = 'Данные получены';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа возврата егаис.
   */
  angular.module('frontend').filter('writeReturnStatus', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'DRAFT':
            status = 'Черновик';
            break;
          case 'IN_PROGRESS':
            status = 'Проведение';
            break;
          case 'ACCOUNTED_ERROR':
            status = 'Ошибка проведения';
            break;
          case 'ACCOUNTED_TO':
            status = 'Проведен';
            break;
          case 'NEED_TO_ACCOUNTED':
            status = 'Ожидает проведения';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название статуса списания ЕГАИС.
   */
  angular.module('frontend').filter('writeOffType', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'MIX':
            status = 'Пересортица';
            break;
          case 'DEFICIT':
            status = 'Недостача';
            break;
          case 'PRICE_DOWN':
            status = 'Уценка';
            break;
          case 'SPOILAGE':
            status = 'Порча';
            break;
          case 'LOSSES':
            status = 'Потери';
            break;
          case 'CHECKS':
            status = 'Проверки';
            break;
          case 'ARREST':
            status = 'Арест';
            break;
          case 'OTHER':
            status = 'Иные цели';
            break;
          case 'SELLING':
            status = 'Реализация';
            break;
          case 'PRODUCTION_LOSSES':
            status = 'Производственные потери';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа товарно-транспортной накладной.
   */
  angular.module('frontend').filter('waybillStatus', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'NEED_TO_DECIDE':
            status = 'Новая';
            break;
          case 'DECIDED':
            status = 'Решение принято';
            break;
          case 'CANCELED':
            status = 'Отозвана отправителем';
            break;
          case 'SEND_DECISION':
            status = 'Отправка акта';
            break;
          case 'ACT_REJECTED':
            status = 'Ошибка отправки акта';
            break;
          case 'ACT_ACCEPTED':
            status = 'Акт доставлен';
            break;
          case 'TTN_CONFIRMED':
            status = 'Принята';
            break;
          case 'TTN_PART_CONFIRMED':
            status = 'Частично принята';
            break;
          case 'TTN_REJECTED':
            status = 'Отклонена';
            break;
          case 'IN_PROGRESS':
            status = 'Проведение';
            break;
          case 'ACCOUNTED_ERROR':
            status = 'Ошибка проведения';
            break;
          case 'ACCOUNTED_TO':
            status = 'Проведена';
            break;
          case 'NEED_TO_ACCOUNTED':
            status = 'Требуется проведение';
            break;
          case 'DRAFT':
            status = 'Черновик';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа складской операции
   */
  angular.module('frontend').filter('transactionType', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'BEGINNING_QTY':
            status = 'Начальные остатки';
            break;
          case 'REPLENISHMENT':
            status = 'Приемка товара от контрагента';
            break;
          case 'MOVEMENT_IN':
            status = 'Приемка товара при перемещении между складами';
            break;
          case 'WRITE_UP':
            status = 'Оприходование товара без контрагента, корректировка';
            break;
          case 'ASSEMBLE_PLUS_WHOLE':
            status = 'Комплектование оптовой/транспортной упаковки: оприходование созданной упаковки';
            break;
          case 'DISASSEMBLE_PLUS_PARTS':
            status = 'Разукомплектование оптовой/транспортной упаковки: оприходование содержимого упаковки';
            break;
          case 'SHIPMENT':
            status = 'Отгрузка товара контрагенту';
            break;
          case 'MOVEMENT_OUT':
            status = 'Отпуск товара при перемещении между складами';
            break;
          case 'WRITE_OFF':
            status = 'Списание товара без контрагента, корректировка';
            break;
          case 'ASSEMBLE_MINUS_PARTS':
            status = 'Комплектование оптовой/транспортной упаковки: списание содержимого упаковки';
            break;
          case 'DISASSEMBLE_MINUS_WHOLE':
            status = 'Разукомплектование оптовой/транспортной упаковки: списание разобранной упаковки';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа начисления
   */
  angular.module('frontend').filter('taxChargeType', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'PERSONAL_INCOME_TAX':
            status = 'НДФЛ';
            break;
          case 'EXCISE':
            status = 'Акциз';
            break;
          case 'INCOME_TAX':
            status = 'Налог на прибыль';
            break;
          case 'LAND_TAX':
            status = 'Земельный налог';
            break;
          case 'TRANSPORT_TAX':
            status = 'Транспортный налог';
            break;
          case 'PROPERTY_TAX':
            status = 'Налог на имущество';
            break;
          case 'ADVERTISING_TAX':
            status = 'Налог на рекламу';
            break;
          case 'IMPUTED_TAX':
            status = 'ЕНВД';
            break;
          case 'SIMPLIFIED_TAX':
            status = 'УСН';
            break;
          case 'TRADING_FEE':
            status = 'Торговый сбор';
            break;
          case 'PATENT':
            status = 'Патент';
            break;
          case 'OTHER':
            status = 'Прочие налоги и сборы';
            break;
          
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

/**
 * Created by aivanov on 26.05.2017.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название системы налогообложения.
   * TODO: мне не очень нравится на клиенте резолвить это
   */
  angular.module('frontend').filter('tax', function () {
    return taxFilter;
  });

  var taxFilter = function (taxRaw, isShort) {
    if (taxRaw) {
      var lower = taxRaw.toLowerCase();
      if (isShort) {
        return lower == 'general' ? 'ОСН' :
          lower == 'simplified6' ? "УСН доход" :
            lower == 'simplified15' ? "УСН доход-расход" :
              lower == 'agricultural' ? 'ЕСХН' :
                lower == 'none' ? 'По настройкам кассы' :
                  lower == 'imputed' ? 'ЕНВД' :
                    lower == 'patent' ? 'Патент' :
                      taxRaw; // Если нет совпадений, позвращаем исходное название
      } else {
        return lower == 'general' ? 'ОСН' :
          lower == 'simplified6' ? "УСН доход" :
            lower == 'simplified15' ? "УСН доход-расход" :
              lower == 'agricultural' ? 'ЕСХН' :
                lower == 'none' ? 'По настройкам кассы' :
                  lower == 'imputed' ? 'ЕНВД' :
                    lower == 'patent' ? 'Патент' :
                      taxRaw; // Если нет совпадений, позвращаем исходное название
      }
    }
    return taxRaw;
  }

})();

(function () {
  'use strict';

  /**
   * Фильтр для получения названия признака Способ расчёта
   */
  angular.module('frontend').filter('settlementsTypes', function () {
    return function (value) {
      switch (value) {
          case 'PREPAY_100_PERC':
            return 'Предоплата 100%';
          case 'PREPAY':
            return 'Предоплата';
          case 'ADVANCE':
            return 'Аванс';
          case 'FULL_SETTLEMENT':
            return 'Полный расчет';
          case 'PARTIAL_SETTLEMENT_AND_LOAN':
            return 'Частичный расчет и кредит';
          case 'LOAN':
            return 'Передача в кредит';
          case 'LOAN_PAYMENT':
            return 'Оплата кредита';
          default :
            return value;
        }
    };
  });

})();
(function () {
  'use strict';

  /**
   * Фильтр для замены точки на запятую для дробных чисел
   */
  angular.module('frontend').filter('rounding', function () {
    return roundingNumber;
  });

  var roundingNumber = function (num, count) {
    return parseFloat(num).toFixed(parseInt(count));
  }

})();
(function () {
  'use strict';

  /**
   * Фильтр для проставления разделителей тысяч и нулей в цене
   */
  angular.module('frontend').filter('priceFormatter', function ($rootScope) {
    return function (number, char_iso_code, numbers_after_comma) {
      return new Intl.NumberFormat('ru-RU', {minimumFractionDigits: numbers_after_comma === undefined? 2 : numbers_after_comma, style: 'currency', currency: char_iso_code || ($rootScope.homeCurrency && $rootScope.homeCurrency.currency.char_iso_code) || 'RUB'}).format(number);
    };
  });

})();
(function () {
  'use strict';

  /**
   * Фильтр возвращает телефон в формате +7 (123) 123-12-12
   */
  angular.module('frontend').filter('phoneFormat', function () {
    return function(phone) {
      if (phone && /^[\d]+$/.test(phone.toString())) {
        return "+7 (" + phone.substr(0, 3) + ") " + phone.substr(3, 3) + "-" + phone.substr(6, 2) + "-" + phone.substr(8, 2);
      }
      return phone;
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название периода.
   */
  angular.module('frontend').filter('periodReportings', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'FIRST':
            status = '1 квартал';
            break;
          case 'SECOND':
            status = '2 квартал';
            break;
          case 'THIRD':
            status = '3 квартал';
            break;
          case 'FOURTH':
            status = '4 квартал';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название способа оплаты.
   */
  angular.module('frontend').filter('paymentTypes', function () {
    return function(typeRaw, shortStatus) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'CASH':
            status = 'Наличные';
            break;
          case 'BANK_CARD':
            status = 'Банковская карта';
            break;
          case 'BANK_TRANSFER':
            status = 'Банковский перевод';
            break;
          case 'PREPAY':
            status = 'Предоплата';
            break;
          case 'POSTPAY':
            status = 'Постоплата';
            break;
          case 'CONSIDERATION':
            status = 'Встречное предоставление';
            break;
          case 'OTHER':
            status = 'Прочий';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр для получения названия типа партнера
   */
  angular.module('frontend').filter('partnerType', function () {
    return partnerTypeStr;
  });

  var partnerTypeStr = function (value) {
    switch (value) {
        case 'DOMAIN':
          return 'Группа';
        case 'COMPANY':
          return 'Компания';
        case 'DIVISION':
          return 'Подразделение';
        default :
          return value;
      }
  }

})();
(function () {
  'use strict';

  /**
   * Фильтр для замены точки на запятую для дробных чисел и отделения каждых 3х порядков
   */
  angular.module('frontend').filter('parseNumber', function () {
    return formatNumber;
  });

  var format = new Intl.NumberFormat('ru-Ru');

  var formatNumber = function (value) {
    if(isNaN(value)) return '';
    if (typeof value !== 'undefined') {
      if (value === null) value = '0,00';
      var string = (value + '').split(/[,.]/);
      if (typeof string[1] === 'undefined') {
        string[1] = '00'
      } else if (string[1].length === 1) {
        string[1] += '0'
      }
      if (string[0] === '') {
        value = undefined
      } else {
        value = format.format(parseInt(string[0].replace(/\s/g,'')))+','+string[1]
      }
      return value;
    }
  }

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает проскланенное слово "Новый", в зависимости от рода
   */
  angular.module('frontend').filter('newWord', function () {
    return newWord;
  });

  var newWord = function(gender){
    var newWord = '';
    switch (gender) {
      case 'MALE':
        newWord = 'Новый';
        break;
      case 'FEMALE':
        newWord = 'Новая';
        break;
      case 'PLURAL':
        newWord = 'Новые';
        break;
      case 'NEUTER':
        newWord = 'Новое';
        break;
      default: ''
    }
    return newWord;
  }

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает родительский пункт меню, где находится документ по типу документа
   */
  angular.module('frontend').filter('getMenuParent', function () {
    return function (type) {
      if (type) {
        switch (type) {
          case 'PURCHASE_ORDER':
            return 'purchase';
          case 'SALES_ORDER':
            return 'sale';
          case 'PAYMENT_REQUEST_OUT':
            return 'sale';
          case 'PAYMENT_REQUEST_IN':
            return 'purchase';
          case 'COMMISSIONERS_REPORT_IN':
            return 'sale';
          case 'COMMISSIONERS_REPORT_OUT':
            return 'purchase';
          case 'INVOICE_IN':
            return 'money';
          case 'INVOICE_OUT':
            return 'money';
          case 'BEGINNING_BALANCE_CONTRACT':
            return 'money';
          case 'BEGINNING_BALANCE_NON_CASH':
            return 'money';
          case 'BEGINNING_BALANCE_CASH':
            return 'money';
          case 'BEGINNING_BALANCE_SKU':
            return 'storehouse';
          case 'CONSIGNMENT_NOTE_OUT':
            return 'storehouse';
          case 'CONSIGNMENT_NOTE_IN':
            return 'storehouse';
          case 'INTERNAL_CONSIGNMENT_NOTE':
            return 'storehouse';
          case 'INVENTORY':
            return 'storehouse';
          case 'WRITE_OFF_STATEMENT':
            return 'storehouse';
          case 'WRITE_UP_STATEMENT':
            return 'storehouse';
          case 'CASH_PAYMENT':
            return 'money';
          case 'CASH_RECEIPT':
            return 'money';
          case 'ADVANCE_REPORT':
            return 'money';
          case 'NON_CASH_RECEIPT':
            return 'Входящий платеж';
          case 'NON_CASH_PAYMENT':
            return 'money';
          case 'CASHREGISTER_START_SHIFT':
            return 'retail';
          case 'CASHREGISTER_END_SHIFT':
            return 'retail';
          case 'CASHBOX_REPLENISHMENT':
            return 'retail';
          case 'RETAIL_SALE':
            return 'retail';
          case 'RETAIL_RETURN':
            return 'retail';
          case 'CASHBOX_ENCASHMENT':
            return 'retail';
          case 'MONEY_TRANSFER':
            return 'money';
          case 'TAX_CHARGE':
            return 'money';
          default:
            return attr.value;
        }
      } else {
        return 'money';
      }
    };
  });

})();

(function () {
  'use strict';

  /**
   * Фильтр для замены точки на запятую для дробных чисел
   */
  angular.module('frontend').filter('fractNum', function () {
    return formatFractionalNumber;
  });

  var formatFractionalNumber = function (num) {
    if(isNaN(num)) return '';
    return (num)? num.toString().replace(".",",") : '';
  }

})();
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа документа егаис
   */
  angular.module('frontend').filter('egaisDocumentsType', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'CONSIGNMENT_NOTE_IN_EGAIS':
            status = 'Приемка ТТН';
            break;
          case 'WRITE_OFF_STATEMENT_EGAIS_ONLY':
            status = 'Акт списания ЕГАИС';
            break;
          case 'WRITE_OFF_STATEMENT_EGAIS':
            status = 'Акт списания';
            break;
          case 'WRITE_RETURN_EGAIS':
            status = 'Акт возврата';
            break;
          case 'WRITE_UP_STATEMENT_EGAIS':
            status = 'Акт постановки на баланс';
            break;
          case 'INVENTORY_EGAIS':
            status = 'Инвентаризация';
            break;
          case 'TRANSFER_BETWEEN_REGISTER_EGAIS':
            status = 'Перевод между регистрами';
            break;
          case 'BEGINNING_BALANCE_EGAIS':
            status = 'Запрос остатков ЕГАИС';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа документа.
   */
  angular.module('frontend').filter('documentType', function ($rootScope) {

    return function(typeRaw) {
      if (typeRaw) {
        var type = $rootScope.findDocumentType(typeRaw);
        if (type) {
          return type.name
        }
      }
      return typeRaw
    }
  })
  .filter('documentPurpose', function ($rootScope) {

    return function(typeRaw) {
      if (typeRaw) {
        var type = $rootScope.findDocumentTypeByPurpose(typeRaw);
        if (type) {
          var purpose =_.find(type.purposes, function(purpose) {
            return purpose.code === typeRaw
          });
          if (purpose) {
            return purpose.purpose_name
          }
        }
      }
      return typeRaw
    }
  })
  .filter('documentStatus', function () {

    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'DRAFT':
            status = '<span class="no-done"></span>';
            break;
          case 'PROCESSED':
            status = '<span class="done"></span>';
            break;
          case 'DRAFT_DISABLED':
            status = '<span class="no-done-disabled"></span>';
            break;
          case 'PROCESSED_DISABLED':
            status = '<span class="done-disabled"></span>';
            break;
          case 'IN_PROCESS':
            status = '<span class="wait"></span>';
            break;
          default :
            status = '<span class="wait"></span>';
            break;
        }
        return status
      }
      return typeRaw
    }
  })
  .filter('dynamicFilter', function ($filter) {
    return function(value, filterName) {
      return $filter(filterName)(value);
    };
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр для получения названия документа на русском
   */
  angular.module('frontend').filter('getDocName', function () {
    return roundingNumber;
  });

  var roundingNumber = function (value) {
    switch (value) {
        case 'PURCHASE_ORDER':
          return 'Заказ на закупку';
        case 'SALES_ORDER':
          return 'Заказ на продажу';
        case 'PAYMENT_REQUEST_OUT':
          return 'Счет на оплату выданный';
        case 'PAYMENT_REQUEST_IN':
          return 'Счет на оплату полученный';
        case 'COMMISSIONERS_REPORT_IN':
          return 'Отчет комиссионера полученный';
        case 'COMMISSIONERS_REPORT_OUT':
          return 'Отчет комиссионера выданный';
        case 'INVOICE_IN':
          return 'Счет-фактура полученный';
        case 'INVOICE_OUT':
          return 'Счет-фактура выданный';
        case 'BEGINNING_BALANCE_CONTRACT':
          return 'Начальное состояние взаиморасчетов';
        case 'BEGINNING_BALANCE_NON_CASH':
          return 'Начальные остатки на счетах';
        case 'BEGINNING_BALANCE_CASH':
          return 'Начальные остатки в кассе';
        case 'BEGINNING_BALANCE_SKU':
          return 'Начальные складские остатки';
        case 'CONSIGNMENT_NOTE_OUT':
          return 'Товарная накладная на отпуск';
        case 'CONSIGNMENT_NOTE_IN':
          return 'Товарная накладная на прием';
        case 'INTERNAL_CONSIGNMENT_NOTE':
          return 'Накладная на внутреннее перемещение';
        case 'INVENTORY':
          return 'Опись инвентаризации';
        case 'WRITE_OFF_STATEMENT':
          return 'Акт о списании';
        case 'WRITE_UP_STATEMENT':
          return 'Акт об оприходовании';
        case 'CASH_PAYMENT':
          return 'Расходный ордер';
        case 'CASH_RECEIPT':
          return 'Приходный ордер';
        case 'ADVANCE_REPORT':
          return 'Авансовый отчет подотчетного лица';
        case 'NON_CASH_RECEIPT':
          return 'Входящий платеж';
        case 'NON_CASH_PAYMENT':
          return 'Исходящий платеж';
        case 'CASHREGISTER_START_SHIFT':
          return 'Открытие кассовой смены';
        case 'CASHREGISTER_END_SHIFT':
          return 'Закрытие кассовой смены';
        case 'CASHBOX_REPLENISHMENT':
          return 'Внесение денежных средств в ККМ';
        case 'RETAIL_SALE':
          return 'Розничная продажа через ККМ';
        case 'RETAIL_RETURN':
          return 'Возврат денежных средств из ККМ';
        case 'CASHBOX_ENCASHMENT':
          return 'Выемка денежных средств из ККМ';
        case 'MONEY_TRANSFER':
          return 'Перемещение денежных средств';
        case 'TAX_CHARGE':
          return 'Начисление налога или сбора';
        default :
          return value;
      }
  }

})();
(function () {
  'use strict';

  /**
   * Фильтр возвращает часть строки url
   */
  angular.module('frontend').filter('docEgaisUrlStr', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var name = '';
        switch (typeRaw) {
          case 'CONSIGNMENT_NOTE_IN_EGAIS':
            name = 'invoiceWaybill';
            break;
          case 'WRITE_OFF_STATEMENT_EGAIS_ONLY':
            name = 'cancellationAct';
            break;
          case 'WRITE_OFF_STATEMENT_EGAIS':
            name = 'cancellationAct';
            break;
          case 'WRITE_RETURN_EGAIS':
            name = 'writeReturn';
            break;
          case 'WRITE_UP_STATEMENT_EGAIS':
            name = 'cancellationAct';
            break;
          case 'INVENTORY_EGAIS':
            name = 'beginningBalanceEgais';
            break;
          case 'TRANSFER_BETWEEN_REGISTER_EGAIS':
            name = 'transferBetweenRegister';
            break;
          case 'BEGINNING_BALANCE_EGAIS':
            name = 'beginningBalanceEgais';
            break;
          default :
            name = typeRaw;
            break;
        }
        return name;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название документа ЕГАИС.
   */
  angular.module('frontend').filter('docEgaisType', function () {
    return function(typeRaw, shortStatus) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'CONSIGNMENT_NOTE_IN_EGAIS':
            status = (shortStatus == 'short')? 'ТТН' : 'Товарно-транспортная накладная';
            break;
          case 'WRITE_OFF_STATEMENT_EGAIS_ONLY':
            status = 'Акт автономного списания из ЕГАИС';
            break;
          case 'WRITE_OFF_STATEMENT_EGAIS':
            status = 'Акт списания с баланса';
            break;
          case 'WRITE_RETURN_EGAIS':
            status = 'Акт возврата алкогольной продукции';
            break;
          case 'WRITE_UP_STATEMENT_EGAIS':
            status = 'Акт постановки на баланс';
            break;
          case 'INVENTORY_EGAIS':
            status = 'Запрос остатков в ЕГАИС';
            break;
          case 'TRANSFER_BETWEEN_REGISTER_EGAIS':
            status = 'Перевод остатков между регистрами';
            break;
          case 'BEGINNING_BALANCE_EGAIS':
            status = 'Запрос остатков';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр для получения названия типа подразделения
   */
  angular.module('frontend').filter('divisionType', function () {
    return divisionTypeStr;
  });

  var divisionTypeStr = function (value, is_plural) {
    switch (value) {
        case 'OFFICE':
          return is_plural? 'Офисы' : 'Офис';
        case 'SHOP':
          return is_plural? 'Магазины' : 'Магазин';
        case 'STOREHOUSE':
          return is_plural? 'Склады' : 'Склад';
        default :
          return value;
      }
  }

})();
/**
 * Created by aivanov on 26.05.2017.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название по названию роли.
   * TODO: мне не очень нравится на клиенте резолвить это
   */
  angular.module('frontend').filter('contractType', function () {
    return typeContractFilter;
  });
  var typeContractFilter = function (typeRaw, taxService) {
    if (typeRaw) {
      var upper = typeRaw.toUpperCase();
      return upper == 'WE_SELL' ? 'Продажа' :
        upper == 'WE_BUY' ? "Покупка" :
          upper == 'WE_ARE_COMMITTENT' ? "Сдача на комиссию" :
            upper == 'WE_ARE_COMMISSION_AGENT' ? 'Прием на комиссию' :
             upper == "WE_GIVE_LOAN" ? "Выдача займа" :
              upper == "WE_TAKE_LOAN" ? "Получение займа" :
               upper == "WE_USE_ACQUIRING" ? "Эквайринг" :
              typeRaw; // Если нет совпадений, позвращаем исходное название
    }
    return typeRaw;
  }

})();

/**
 * Created by aivanov on 26.05.2017.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название по названию роли.
   * TODO: мне не очень нравится на клиенте резолвить это
   */
  angular.module('frontend').filter('company', function () {
    return companyFilter;
  });

  var companyFilter = function (num) {
    if (num == 1) return 'компания';
    if (num > 1 && num <= 4) return 'компании';
    if (num > 5) return 'компаний';
  }

})();

(function () {
  'use strict';

  /**
   * Фильтр для получения названия признака предмета расчета
   */
  angular.module('frontend').filter('cashRegisterItemTypes', function () {
    return function (value) {
      switch (value) {
          case 'WORK':
            return 'Работа';
          case 'TRADE_FEE':
            return 'Торговый сбор';
          case 'TOURIST_FEE':
            return 'Курортный сбор';
          case 'SERVICE':
            return 'Услуга';
          case 'PROPERTY':
            return 'Имущественное право';
          case 'PAYMENT':
            return 'Платеж';
          case 'OTHER':
            return 'Иной предмет расчета';
          case 'NON_SALES_INCOME':
            return 'Внереализационный доход';
          case 'LOTTERY_WINNING':
            return 'Выигрыш лотереи';
          case 'LOTTERY_TICKET':
            return 'Лотерейный билет';
          case 'INSURANCE_CONTRIBUTION':
            return 'Иные платежи и взносы';
          case 'GOODS':
            return 'Товар';
          case 'GAME_WINNING':
            return 'Выигрыш азартной игры';
          case 'GAME_BET':
            return 'Ставка азартной игры';
          case 'EXCISE_GOODS':
            return 'Подакцизный товар';
          case 'DEPOSIT':
            return 'Залог';
          case 'COPYRIGHT_PRODUCT':
            return 'Результат интеллектуальной деятельности (РИД)';
          case 'COMPOSITE':
            return 'Составной предмет расчета';
          case 'AGENTS_COMMISSION':
            return 'Агентское вознаграждение';
          case 'PAYOUT':
            return 'Выплата';
          case 'CONSUMPTION':
            return 'Расход';
          case 'CASINO_PAYMENT':
            return 'Платеж казино';
          case 'OPS_IP':
            return 'Взносы на ОПС ИП';
          case 'OPS':
            return 'Взносы на ОПС';
          case 'OMS_IP':
            return 'Взносы на ОМС';
          case 'OMS':
            return 'Взносы на ОМС';
          case 'OSS':
            return 'Взносы на OCC';
          case 'OTHER_CONTRIBUTION':
            return 'Иной взнос';
          default :
            return value;
        }
    };
  });

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название статуса списания ЕГАИС.
   */
  angular.module('frontend').filter('cancellationActStatus', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'DRAFT':
            status = 'Черновик';
            break;
          case 'NEED_TO_ACCOUNTED':
            status = 'Ожидает проведения';
            break;
          case 'SEND_TO_EGAIS':
            status = 'Отправка в ЕГАИС';
            break;
          case 'ACCEPTED':
            status = 'Доставлен в ЕГАИС';
            break;
          case 'REJECTED':
            status = 'Отклонен';
            break;
          case 'CONFIRMED':
            status = 'Принят в ЕГАИС';
            break;
          case 'IN_PROGRESS':
            status = 'Проведение';
            break;
          case 'ACCOUNTED_TO':
            status = 'Проведен';
            break;
          case 'ACCOUNTED_ERROR':
            status = 'Ошибка проведения';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа транзакции бонуссов партнера
   */
  angular.module('frontend').filter('bonusTypes', function () {
    return function(obj) {
      if (obj && obj.debit_account && obj.credit_account) {
        if (obj.debit_account == "RECS_DEBT" && obj.credit_account == "ACCRUED_BONUSES") {
          return 'Начисления бонусов'; // ACCRUED_BONUSES
        } else if (obj.debit_account == "RECS_DEBT" && obj.credit_account == "PAYABLE_BONUSES") {
          return 'Начисления выплачиваемых бонусов'; // PAYABLE_BONUSES
        } else if (obj.debit_account == "ACCRUED_BONUSES" && obj.credit_account == "PAYABLE_BONUSES") {
          return 'Перевод бонусов в выплачиваемые'; // TRANSFER_BONUSES
        }else if (obj.debit_account == "PAYABLE_BONUSES" && obj.credit_account == "RECS_DEBT") {
          return 'Выплаты'; // PAID_BONUSES
        } else {
          return "";
        }
      }
      return "";
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название типа запроса начальных остатков.
   */
  angular.module('frontend').filter('beginningBalancesEgaisStatus', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'DRAFT':
            status = 'Черновик';
            break;
          case 'SEND_TO_EGAIS':
            status = 'Отправлен в ЕГАИС';
            break;
          case 'DATA_RECEIVED':
            status = 'Данные получены';
            break;
          case 'MARK_REQUEST':
            status = 'Отправлен запрос марок';
            break;
          case 'MARK_REQUEST_COMPLETED':
            status = 'Марки получены';
            break;
          case 'MARK_REQUEST_ERROR':
            status = 'Ошибка запроса марок';
            break;
          case 'REJECTED':
            status = 'Отклонен';
            break;
          case 'NEED_TO_ACCOUNTED':
            status = 'Требуется проведение';
            break;
          case 'IN_PROGRESS':
            status = 'Ожидает проведения';
            break;
          case 'ACCOUNTED_TO':
            status = 'Проведен';
            break;
          case 'ACCOUNTED_ERROR':
            status = 'Ошибка проведения';
            break;
          case 'BALANCE_RECEIVED':
            status = 'Ответ получен';
            break;
          case 'FINISHED':
            status = 'Завершен';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название статуса пивной декларации.
   */
  angular.module('frontend').filter('beerDeclarationsStatus', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'DRAFT':
            status = 'Черновик';
            break;
          case 'CONFIRMED':
            status = 'Принята ФСРАР';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название решения ттн.
   */
  angular.module('frontend').filter('acceptStatuses', function () {
    return function(typeRaw) {
      if (typeRaw) {
        var status = '';
        switch (typeRaw) {
          case 'ACCEPTED':
            status = 'Принята';
            break;
          case 'REJECTED':
            status = 'Отклонена';
            break;
          case 'DIFFERENCES':
            status = 'Принята с разногласиями';
            break;
          default :
            status = typeRaw;
            break;
        }
        return status;
      }
      return typeRaw
    }
  })

})();

(function() {
  'use strict';

  angular.module('frontend').service('expenseItemsService', expenseItemsService);

  function expenseItemsService($http, API_URL) {

    /* Загрузка списка статей затрат */
    this.expenseItems = function (paging, search) {
      return $http.get(API_URL + '/expense_items', {
        params: {
          search_string: search,
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection
        }
      });
    };

    /* Загрузка списка статей затрат для механизма автодополнения */
    this.expenseItemsSearch = function (search, limit, filtersData) {
      var params = {};
      params.search_string = search;
      params.limit = limit || 5;
      if (filtersData) {
        Object.keys(filtersData).map(function(value) { return params[value] = filtersData[value];});
      }
      return $http.get(API_URL + '/expense_items/auto', {
        params: params
      });
    };

    /* Загрузка одной статьи затрат */
    this.expenseItem = function (expenseItemId) {
      return $http.get(API_URL + '/expense_items/' + expenseItemId);
    };

    /* Удаление статьи затрат */
    this.deleteExpenseItem = function (expenseItemId) {
      return $http.delete(API_URL + '/expense_items/' + expenseItemId);
    };

    /* Создание новой статьи затрат */
    this.createExpenseItem = function (expenseItem) {
      return $http.post(API_URL + '/expense_items/', expenseItem);
    };
    /* Обновление информации о статье затрат */
    this.updateExpenseItem = function (expenseItem) {
      return $http.put(API_URL + '/expense_items/' + expenseItem.id, {
        name: expenseItem.name,
        general_expenses: expenseItem.general_expenses,
        active: expenseItem.active,
        comment: expenseItem.comment
      });
    }

  }

}) ();

(function () {
  'use strict';

  angular.module('frontend').controller('expenseItemsController', expenseItemsController);

  function expenseItemsController($state, $scope, auth, expenseItemsService, userSettingsService) {
    var expenseItemsCtrl = this;

    if ($state.params.companyName) {
      expenseItemsCtrl.searchText = $state.params.companyName;
    }

    $scope.goToView = function(id){
      $state.go('expenseItem.view', {expenseItemId: id, parent: "money"});
    };

    // Структура для управления paging-ом
    expenseItemsCtrl.paging = {
      current: 0,
      limit: 5,
      offset: 0,
      sortBy: 'name',
      total: undefined
    };

    var pencil = '<a ng-if="$root.hasRole(\'expense_item.write\')" ui-sref="expenseItem.edit({expenseItemId: row.entity.id, parent: \'money\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>';

    $scope.columnVisibilityChanged = function(){
      var columnsProperty = expenseItemsCtrl.gridApi.grid.options.columnDefs;
      userSettingsService.saveProperty("expenseItems", "grid", "columnsProperty", columnsProperty)
    };

    /* настройки грида по умолчанию ($scope - обязательно) */
    $scope.defaultColumns = [
    { name: 'marginLeft', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 64},
      { name: 'name', displayName: 'Наименование', visible: true, cellTemplate: "textTemplate.html",enableSorting: true, enableFiltering: true, width: 300},
      { name: 'active', displayName: 'Статус', visible: true, enableSorting:true, enableFiltering: true, cellTemplate: 'statusTemplate.html', width: 150},
      { name: 'comment', displayName:'Комментарий', visible: true, cellTemplate:"textTemplate.html"},
      { name: 'created_at', displayName:'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
      { name: 'created_by.name', displayName:'Кто создал',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
      { name: 'updated_at', displayName:'Дата обновления',cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
      { name: 'updated_by.name', displayName:'Кто обновил',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
      { name: 'option', cellTemplate: pencil, displayName:'', visible: true, enableHiding: false, width: 95},
      { name: 'marginRight', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 63}
    ];


    expenseItemsCtrl.gridOptions = {
      enableGridMenu:true,
      enableColumnMenu:false,
      useExternalSorting: true,
      enableSorting:false,
      enableFiltering: false,
      showColumnFooter: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      rowTemplate: '<div ng-click="grid.appScope.goToView(row.entity.id);">' +
                    ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
                   '</div>',
      columnDefs: userSettingsService.loadProperty("expenseItems", "grid", "columnsProperty") || angular.copy($scope.defaultColumns),
      onRegisterApi: function (gridApi) {
        expenseItemsCtrl.gridApi = gridApi;
        expenseItemsCtrl.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns.length == 0) {
            expenseItemsCtrl.paging.sortBy = null;
            expenseItemsCtrl.paging.sortDirection = null;
          } else {
            expenseItemsCtrl.paging.sortBy = sortColumns[0].field;
            expenseItemsCtrl.paging.sortDirection = sortColumns[0].sort.direction;
          }
          expenseItemsCtrl.getPage();
        });
      },
      data: []
    };


    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    expenseItemsCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        this.error = false;
        this.message = '';
        this.loading = true;
      },
      stopLoadingSuccess: function() {
        this.error = false;
        this.message = '';
        this.loading = false;
      },
      stopLoadingFailure: function(message) {
        this.error = true;
        this.message = message;
        this.loading = false;
      }
    };

    // Поиск
    expenseItemsCtrl.search = function () {
      // Сброс текущей страницы и поиск
      expenseItemsCtrl.paging.current = 0;
      expenseItemsCtrl.paging.offset = 0;
      expenseItemsCtrl.getPage();
    };

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    expenseItemsCtrl.getPage = function () {
      expenseItemsCtrl.noData = expenseItemsCtrl.loadData = false;
      expenseItemsCtrl.crudState.startLoading();
      expenseItemsService.expenseItems(expenseItemsCtrl.paging, expenseItemsCtrl.searchText).then(
        function (data) {
          if(!data.data.items.length && !expenseItemsCtrl.searchText){
            expenseItemsCtrl.noData = true;
          }
          expenseItemsCtrl.expenseItems = data.data.items;
          // Ссылка в grid
          expenseItemsCtrl.gridOptions.data = expenseItemsCtrl.expenseItems;
          expenseItemsCtrl.paging.total = data.data.total;
          expenseItemsCtrl.crudState.stopLoadingSuccess();
          expenseItemsCtrl.loadData = true;
        },
        function (error) {
          expenseItemsCtrl.expenseItems = [];
          expenseItemsCtrl.crudState.stopLoadingFailure(error);
        }
      )
    };
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    expenseItemsCtrl.getPage();
  }

})();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular.module('frontend').service('employeesService', EmployeesService);

  /**
   * Сервис для работы с АПИ сотрудников
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function EmployeesService($http, API_URL, $rootScope) {

    /* Загрузка списка сотрудников TODO: рассмотреть переход на restangular */
    this.users = function (paging, search, filter) {
      var data = {
        params: {
          search_string: search,
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection
        }
      }
      if(filter){
        Object.keys(filter).forEach(function (key) {
          if (!!filter[key]) {
            data.params["filter_" + key] = filter[key];
          }
        });
      }
      return $http.get(API_URL + '/users', data);
    }

    /* Загрузка списка сотрудников  /users/auto */
    this.usersAuto = function (search, limit) {
      var data = {
        params: {
          search_string: search,
          limit: limit || 100
        }
      }

      return $http.get(API_URL + '/users/auto', data);
    }

    /* Загрузка расширенной информации о сотруднике */
    this.user = function (userId) {
      return $http.get(API_URL + '/users/' + userId, {
        params: {
          avoid_data_access_rules: true
        }
      });
      //return $http.get('assets/api/user.json');
    }

    /* Удаление сотрудника */
    this.deleteUser = function (userId) {
      return $http.delete(API_URL + '/users/' + userId);
    }

    /* Создание нового сотрудника */
    this.createUser = function (user) {
      if (user.roles && user.roles.length == 0) {
        user.roles = undefined;
      }
      return $http.post(API_URL + '/users/', user);
    }

    /* Обновление информации о сотруднике */
    this.updateUser = function (user) {
      var id = user.id;
      user.id = undefined;
      user.created_at = undefined;
      user.domain = undefined;
      return $http.put(API_URL + '/users/' + id, user);
    }

    /* Получить пустое дерево прав */
    this.getDataAccessRules = function() {
      return $http.get(API_URL + '/users/data_access_rules', {
        params: {
          avoid_data_access_rules: true
        }
      });
    }

    /* Получить список компаний для пользователя */
    this.getCompanies = function() {
      return $http.get(API_URL + '/companies');
    }

    /* Получить дерево прав доступа на данные */
    this.getAccessTree = function(id) {
      return $http.get(API_URL + '/users/' + id + '/data_access_rules');
    }

    /* Устанавливает флаг необходимости смены пароля для нескольких пользователей */
    this.resetPassword = function (ids) {
      return $http.post(API_URL + '/users/need_change_password', ids, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    }

    /* Заводит быстрого кассира в системе */
    this.fastCashier = function (cashier) {
      return $http.post(API_URL + '/users/fast_cashier', cashier, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    }
  }

}) ();

/**
 * Created by aivanov on 24.05.2017.
 */
(function () {
  'use strict';

  /*eslint angular/controller-as-vm: [2,"employeesCtrl"]*/
  angular.module('frontend').controller('EmployeesController', EmployeesController);

  function EmployeesController($state, $stateParams, auth, $scope, $timeout, $filter, $uibModal, companyService, employeesService, rolesService, filterFactoryService, uiGridConstants, userSettingsService, errorMessageService, requestStatus, filterSettingsService) {
    var employeesCtrl = this;
    employeesCtrl.display = 'card';
    employeesCtrl.rolesArr = employeesCtrl.rolesMap = employeesCtrl.timezonesMap = [];

    if ($state.params.modifiedPhone) {
      requestStatus.success('Пользователю задан новый пароль. СМС с паролем отправлена на телефон ' + $filter('phoneFormat')($state.params.modifiedPhone));
      $stateParams.modifiedPhone = undefined;
      $state.go('employees', $stateParams);
    }

    employeesCtrl.cleanObj = function(obj){
      var tempObj = angular.copy(obj);
      for(var prop in tempObj){
        if(!tempObj[prop]) delete obj[prop];
      }
      return obj;
    };

    // Обратный вызов для выбора строки (галочка)
    var callbackRowSelected = function(row) {
      row.entity.checked = row.isSelected;
    };

    // Передаётся массив выбранных строк
    var callbackRowBatchSelected = function(rows) {
      // Вызываем для всех строк установку значения в сущность
      angular.forEach(rows, function (row) {
        callbackRowSelected(row);
      })
    };

    // Установка выбранных объектов при рендеринге таблицы
    var onRowsRendered = function(gridApi) {
      gridApi.grid.rows.forEach(function(row) {
        if (row.entity.checked) {
          // Устанавливается через сущность
          gridApi.selection.selectRow(row.entity);
        }
      });
    };

    auth.getTimezones().then(function (res) {
      angular.forEach(res.data, function(timezone){
        employeesCtrl.timezonesMap[timezone.timezoneId] = timezone.displayName;
      });
    });

    rolesService.roles().then(function (res) {
      employeesCtrl.roles = res.data;
      angular.forEach(employeesCtrl.roles, function(role){
        employeesCtrl.rolesArr.push({value: role.id, label: role.name});
        employeesCtrl.rolesMap[role.id] = role.name;
      });
    });

    employeesCtrl.getRoleTooltip = function (userRoles) {
      var roles = '';
      _.forEach(userRoles, function(userRole, index){
        var isPublick = !!_.find(employeesCtrl.roles, function (role) { return role.id == userRole && role.is_public });
        if (isPublick) {
          roles += (index)? ', ' + employeesCtrl.rolesMap[userRole] : employeesCtrl.rolesMap[userRole];
        }
      });
      return roles;
    }

    employeesCtrl.getCompaniesTooltip = function (companies) {
      var companiesStr = '';
      _.forEach(companies, function(company, index){
        companiesStr += (index)? ', ' + company.short_name : company.short_name;
      });
      return companiesStr;
    }

    $scope.goToView = function(id){
      $state.go('employee.view',{userId: id, parent: 'business'});
    };

    employeesCtrl.gridFilter = filterFactoryService.createFilter("employees", "grid");

    employeesCtrl.updateColumnFilter = function (colDef, col) {
      if(col.filters[0]){
        if (employeesCtrl.filter[colDef.filterName || colDef.name] && employeesCtrl.filter[colDef.filterName || colDef.name].complex) {
          col.filters[0].dateRange = employeesCtrl.filter[colDef.filterName || colDef.name].dateRange;
          col.filters[0].term = employeesCtrl.filter[colDef.filterName || colDef.name].datePickStr
        } else {
          col.filters[0].term = employeesCtrl.filter[colDef.filterName || colDef.name]
        }
      }
    };

    employeesCtrl.initFilter = function () {
      employeesCtrl.filter = employeesCtrl.gridFilter.loadFilter() || {};
      employeesCtrl.gridApi && employeesCtrl.gridApi.grid.columns.filter(function (column) {
        return column.enableFiltering;
      }).forEach(function (col) {
        employeesCtrl.updateColumnFilter(col.colDef, col)
      });
      employeesCtrl.gridFilter.storeFilter(employeesCtrl.filter);
      employeesCtrl.filterDeepCopy = angular.copy(employeesCtrl.filter)
    };

    employeesCtrl.saveFilter = function (name) {
      employeesCtrl.gridFilter.saveFilter(name, employeesCtrl.filter);
      employeesCtrl.filterSaved = true;
      employeesCtrl.filterDeepCopy = angular.copy(employeesCtrl.filter);
      employeesCtrl.savedFilterName = name;
    };

    employeesCtrl.closeFilterSavingModal = function (saveFilterForm) {
      saveFilterForm.$setPristine();
      saveFilterForm.$setUntouched()
    };

    employeesCtrl.prepareSavedFiltersList = function() {
      employeesCtrl.savedFilterListSearchText = ""
    };

    employeesCtrl.chooseFilter = function (filterName) {
      employeesCtrl.gridFilter.storeFilter(employeesCtrl.gridFilter.loadSavedFilter(filterName));
      employeesCtrl.initFilter();
      if (employeesCtrl.filter) {
        employeesCtrl.filterSaved = true;
        employeesCtrl.savedFilterName = filterName
      }
      employeesCtrl.getPage();
    };

    employeesCtrl.removeFilter = function (filterName, $event) {
      $event.stopPropagation();
      employeesCtrl.gridFilter.removeFilter(filterName);
      if (filterName === employeesCtrl.savedFilterName) {
        employeesCtrl.filterSaved = false;
        employeesCtrl.savedFilterName = '';
      }
      if (employeesCtrl.gridFilter.getSavedFiltersNames().length < 6) {
        employeesCtrl.savedFilterListSearchText = ""
      }
    };

    employeesCtrl.updateFilter = function (filter) {
      employeesCtrl.filterSaved = _.isEqual(employeesCtrl.cleanObj(employeesCtrl.filterDeepCopy), employeesCtrl.cleanObj(filter)) && !!employeesCtrl.savedFilterName;
      if(!employeesCtrl.filterSaved) employeesCtrl.savedFilterName = '';
      employeesCtrl.gridFilter.storeFilter(filter);
      employeesCtrl.initFilter();
      if (_.isEmpty(filter)) {
        employeesCtrl.filterSaved = false;
        employeesCtrl.savedFilterName = '';
      }
      employeesCtrl.paging.offset = 0;
    };

    employeesCtrl.applyFilter = function () {
      employeesCtrl.updateFilter(employeesCtrl.popupFilter);
      employeesCtrl.getPage()
    };

    employeesCtrl.cleanFilter = function () {
      employeesCtrl.updateFilter(undefined);
      employeesCtrl.getPage()
    };

    employeesCtrl.initPaging = function () {
      employeesCtrl.paging = userSettingsService.loadProperty("employees", "grid", "paging") || {
        current: 0,
        limit: 5,
        offset: 0,
        sortBy: 'name',
        total: undefined
      };

      /**
       * Свойство добавлено из-за того, что количество сущностей в момент
       * сохранения может быть больше, чем при повторном обращении,
       * сохранять смещение - опасно. Кроме того, в разработке задача,
       * которая позволит после сохранения или редактирования сущности запрашивать
       * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
       * где сохранение смещение могло бы быть полезным.
       */
      employeesCtrl.paging.offset = 0;
      employeesCtrl.paging.current = 0;
    };

    employeesCtrl.init = function () {
      employeesCtrl.initFilter();
      employeesCtrl.initPaging();
      employeesCtrl.showFilter = userSettingsService.loadProperty("employees", "grid", "showFilter") || false;
    };

    employeesCtrl.turnShowFilter = function () {
      employeesCtrl.showFilter = !employeesCtrl.showFilter;
      userSettingsService.saveProperty("employees", "grid", "showFilter", employeesCtrl.showFilter);
      if(!employeesCtrl.showFilter){
        employeesCtrl.cleanFilter();
      }
    };

    employeesCtrl.init();

    employeesCtrl.showFilterPopup = function () {
      employeesCtrl.popupFilter = $.extend(true, {}, employeesCtrl.filter);
    };

    employeesCtrl.companiesArr = [];
    companyService.companies({limit:100}, null).then(function (res) {
      angular.forEach(res.data.items, function(company){
        employeesCtrl.companiesArr.push({value: company.id, label: company.name});
      });
    });

    employeesCtrl.status = [{value: 'true', label: 'Есть доступ'},
                            {value: 'false', label: 'Доступа нет'}];

    employeesCtrl.configScrollFilter = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      scrollInertia: 0
    };

    $scope.columnVisibilityChanged = function(){
      var columnsProperty = employeesCtrl.gridApi.grid.options.columnDefs;
      angular.forEach(columnsProperty, function(column){
        if(column.filter) delete column.filter.selectOptions;
      });
      userSettingsService.saveProperty("employees", "grid", "columnsProperty", columnsProperty)
    };

    /* настройки грида по умолчанию ($scope - обязательно) */
    $scope.defaultColumns = [
        { name: 'selection', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 124},
        { name: 'name', displayName:'Имя', visible: true, cellTemplate: 'textTemplate.html', enableFiltering: false, enableSorting:true, sort: {
          direction: 'asc',
          priority: 0
        }, width: "20%"},
        { name: 'login', displayName:'Логин', visible: false, enableFiltering: false, enableSorting:false, cellTemplate: 'loginTemplate.html', width: "150"},
        { name: 'enabled', displayName: 'Доступ', visible: true, width: "120", filterName: 'enabled', filterHeaderTemplate: 'recs/select-filter-template.html', cellTemplate: 'accessTemplate.html',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: employeesCtrl.status
          }
        },
        { name:'email', displayName: 'E-mail', cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', visible: true, enableFiltering: false, width: "*"},
        { name:'roles', displayName: 'Роли', width: "*", filterName: 'role', visible: true, filterHeaderTemplate: 'recs/select-filter-template.html', cellTemplate: 'recs/rolesTemplate.html',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: employeesCtrl.rolesArr
          }
        },
        { name:'phone', displayName: 'Телефон', visible: true, cellTemplate: 'phoneTemplate.html', enableFiltering: false, width: "*"},
        { name:'companies', displayName: 'Компании', cellTemplate: 'companyTemplate.html', filterName: 'company_id', visible: false, width: "*", filterHeaderTemplate: 'recs/select-filter-template.html',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: employeesCtrl.companiesArr
          }
        },
        { name:'location', displayName: 'Местоположение', filterName: 'location', cellTemplate: 'locationTemplate.html',visible: false, width: "*", filterHeaderTemplate: 'recs/inputFilterTemplate.html'},
        { name:'time_zone', displayName: 'Временная зона',cellTemplate: 'textTimezones.html', enableFiltering: false, visible: false, width: "*"},
        { name: 'created_at', displayName:'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"></cell-with-tooltip>', enableFiltering: false, enableSorting: false, visible: false},
        { name: 'created_by.name', displayName:'Кто создал',cellTemplate: '<cell-with-tooltip text="COL_FIELD"></cell-with-tooltip>', enableFiltering: false, enableSorting: false, visible:false },
        { name: 'updated_at', displayName:'Дата обновления',cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"></cell-with-tooltip>', enableFiltering: false, enableSorting: false, visible: false},
        { name: 'updated_by.name', displayName:'Кто обновил',cellTemplate: '<cell-with-tooltip text="COL_FIELD"></cell-with-tooltip>', enableFiltering: false, enableSorting: false, visible:false },
        { name:'redact', field: 'option', displayName: '', visible: true, width: "95", enableHiding:false, enableColumnMenu:false, enableFiltering: false, cellTemplate: '<a class="table-redact" ui-sref="employee.edit({userId: row.entity.id, parent: \'business\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>'},
        { name: 'marginRight', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 63}
      ];
    var columnsProperty = userSettingsService.loadProperty("employees", "grid", "columnsProperty") || angular.copy($scope.defaultColumns);
    angular.forEach(columnsProperty, function(column){
      if(column.name == 'enabled'){
        column.filter.selectOptions = employeesCtrl.status;
      }
      if(column.name == 'roles'){
        column.filter.selectOptions = employeesCtrl.rolesArr;
      }
      if(column.name == 'companies'){
        column.filter.selectOptions = employeesCtrl.companiesArr;
      }
    });

    // Настройка табличного представления
    employeesCtrl.gridOptions = {
      useExternalSorting: true,
      useExternalFiltering: true,
      enableSorting: false,
      minWidth: 50,
      maxWidth: 9000,
      enableColumnResizing: false,
      enableGridMenu:true,
      enableRowHeaderSelection: true,
      showColumnFooter: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      rowTemplate: '<div ng-click="grid.appScope.goToView(row.entity.id);">' +
      ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
      '</div>',
      // Фильтры на колонках грида
      enableFiltering: true,
      columnDefs: columnsProperty,
      data: []
    };

    employeesCtrl.gridOptions.columnDefs.filter(function (colDef) {
      return colDef.name == employeesCtrl.paging.sortBy
    }).forEach(function (colDef) {
      colDef.sort = {
        direction: employeesCtrl.paging.sortDirection,
        priority: 0
      }
    });
    var columnsVisibility = userSettingsService.loadProperty("employees", "grid", "columnsVisibility") || {};
    employeesCtrl.gridOptions.columnDefs.forEach(function (colDef) {
      if (columnsVisibility[colDef.name] === false) {
        colDef.visible = false
      } else if (columnsVisibility[colDef.name]) {
        colDef.visible = true
      }
    });

    employeesCtrl.gridOptions.onRegisterApi = function (gridApi) {
      employeesCtrl.gridApi = gridApi;
      gridApi.selection.on.rowSelectionChanged($scope, callbackRowSelected);
      gridApi.selection.on.rowSelectionChangedBatch($scope, callbackRowBatchSelected);
      gridApi.core.on.rowsRendered($scope, onRowsRendered);
      gridApi.selection.on.rowSelectionChanged($scope, function (row) {
        //$state.go("employee.edit", {userId: row.entity.id, parent: 'business'});
      });
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns.length == 0) {
          employeesCtrl.paging.sortBy = null;
          employeesCtrl.paging.sortDirection = null;
        } else {
          employeesCtrl.paging.sortBy = sortColumns[0].colDef.sortName || sortColumns[0].field;
          employeesCtrl.paging.sortDirection = sortColumns[0].sort.direction;
        }
        employeesCtrl.getPage();
      });
      gridApi.core.on.filterChanged($scope, function () {
        employeesCtrl.gridApi.grid.columns.filter(function (column) {
          return column.enableFiltering && column.visible !== false;
        }).forEach(function (column) {
          var filter = employeesCtrl.filter[column.colDef.filterName || column.name];
          if(column.filters[0]){
            employeesCtrl.filter[column.colDef.filterName || column.name] = column.filters[0].term;
          }
        });
        employeesCtrl.paging.offset = 0;
        employeesCtrl.updateFilter(employeesCtrl.filter);
        employeesCtrl.getPage();
      });
      employeesCtrl.gridApi.grid.registerColumnBuilder(employeesCtrl.updateColumnFilter)
    }.bind(this);


    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    employeesCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        employeesCtrl.crudState.error = false;
        employeesCtrl.crudState.message = '';
        employeesCtrl.crudState.loading = true;
      },
      stopLoadingSuccess: function() {
        employeesCtrl.crudState.error = false;
        employeesCtrl.crudState.message = '';
        employeesCtrl.crudState.loading = false;
      },
      stopLoadingFailure: function(message) {
        employeesCtrl.crudState.error = true;
        employeesCtrl.crudState.message = message;
        employeesCtrl.crudState.loading = false;
      }
    };

    // Поиск
    employeesCtrl.search = function () {
      // Сброс текущей страницы и поиск
      employeesCtrl.paging.current = 0;
      employeesCtrl.paging.offset = 0;
      employeesCtrl.getPage();
    };

    employeesCtrl.showSaveFilterPopup = function(){
      $uibModal.open({
        templateUrl: 'app/settings/components/filters/modals/saveFilter/save-filter.html',
        size: 'middle-width',
        controller: function($scope, $uibModalInstance){
          $scope.filterName = '';
          $scope.filterObj = employeesCtrl.gridFilter;

          $scope.save = function () {
            if ($scope.saveFilterForm.$valid) {
              employeesCtrl.saveFilter($scope.filterName);
            }
            $uibModalInstance.dismiss();
          };

          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      })
    };

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    employeesCtrl.getPage = function () {
      employeesCtrl.noData = employeesCtrl.loadData = false;
      employeesCtrl.crudState.startLoading();
      userSettingsService.saveProperty("employees", "grid", "paging", employeesCtrl.paging);
      employeesService.users(employeesCtrl.paging, employeesCtrl.searchText, employeesCtrl.filter).then(
        function (data) {
          if(!data.data.items.length && !employeesCtrl.searchText && _.isEmpty(employeesCtrl.filter)){
            employeesCtrl.noData = true;
          }
          employeesCtrl.employees = data.data.items;
          employeesCtrl.paging.total = data.data.total;
          //employeesCtrl.paging.current = data.data.offset / employeesCtrl.paging.limit; // TODO: эта строчка вообще смысла не имеет, зачем offset делится на limit?
          // Ссылка в grid
          employeesCtrl.gridOptions.data = employeesCtrl.employees;
          employeesCtrl.crudState.stopLoadingSuccess();
          employeesCtrl.loadData = true;
        },
        function (error) {
          employeesCtrl.employees = [];
          employeesCtrl.crudState.stopLoadingFailure(error);
        }
      );
      employeesService.getCompanies().then(function(data){
        employeesCtrl.totalCompany = data.data.total;
      });
    };
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    employeesCtrl.getPage();

    /* для сброса пароля */
    employeesCtrl.resetPassword = function () {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/reset-password.html',
        size: 'small-width',
        resolve: {
          data: function () {
            var data = {
              names: [],
              ids: []
            };

            if(employeesCtrl.display == 'card'){
              angular.forEach(employeesCtrl.employees, function(empl){
                if(empl.checked){
                  data.names.push(empl.name);
                  data.ids.push(empl.id);
                }
              });
            }else{
              angular.forEach(employeesCtrl.gridApi.grid.rows, function(row){
                if(row.isSelected){
                  data.names.push(row.entity.name);
                  data.ids.push(row.entity.id);
                }
              });
            }
            return data;
          }
        },
        controller: function ($scope, $uibModalInstance, data) {
          $scope.data = data;
          $scope.errorUserIds = [];
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
          $scope.resetPassword = function() {
            employeesService.resetPassword({ids: data.ids}).then(function (res) {
              employeesCtrl.getPage();
              angular.forEach(res.data, function(item, key){
                if(item.status != 'OK'){
                  $scope.errorUserIds.push(key);
                }
              });
              if(!$scope.errorUserIds.length){
                $scope.close();
              }
            }, function (error) {
              $scope.close();
              if(error.data.code == 'need_role'){
                requestStatus.error('Недостаточно прав'); // todo временное решение
              }else{
                errorMessageService.showModal({message: 'При сбросе паролей произошла ошибка', submessage: error});
              }
            });
          };
        }
      });
    };

    filterSettingsService.filterEmploye().then(function(res){
      employeesCtrl.filterMeta = res.data.items;
      employeesCtrl.filterMeta[1].selectVal = employeesCtrl.rolesArr;
      employeesCtrl.filterMeta[2].selectVal = employeesCtrl.companiesArr;
    });

    $scope.$watch('employeesCtrl.filter.location', function(newVal, oldVal) {
      if (oldVal && !newVal) { // Если не пустое значение меняется на пустое (в широком смысле)
        employeesCtrl.updateFilter(employeesCtrl.filter);
        employeesCtrl.getPage();
      }
    });

    employeesCtrl.openPrintUserDialog = function() {
      $uibModal.open({
        component: 'printUsers',
        size: 'small-width '
      })
    }


  }

})();

'use strict';

angular.module('frontend').controller('editProfileController', function ($scope,
                                                                         auth,
                                                                         authToken,
                                                                         cardHistory,
                                                                         settings,
                                                                         user,
                                                                         $filter,
                                                                         $log,
                                                                         $location,
                                                                         $state,
                                                                         $uibModal,
                                                                         $rootScope,
                                                                         errorMessageService,
                                                                         phoneConfirmationService,
                                                                         utilsService,
                                                                         requestStatus,
                                                                         PHONE_ATTEMPTS,
                                                                         partnersService
) {
  var vm = this;
  var guid = '';
  vm.userData = {};
  vm.isTimerEnd = true;
  vm.phoneAttempts = PHONE_ATTEMPTS;
  vm.login = (user.user.login ? user.user.login + '@' : '') + user.user.domain;

  vm.returnToPage = function () {
    var prev = cardHistory.popStep();
    if (prev) {
      if (prev.name === 'confirmemail' || prev.name === 'confirmnewemail' || prev.name === 'recoverpass' || prev.name === 'setpass') {
        prev.name = 'home';
        prev.param = {}
      }
    }
    $state.go(prev && prev.name || 'home',prev && prev.param || {});
  };

  vm.time_zone = {};
  vm.userData = angular.copy(user.user);


  // сохраняем пришедший номер телефона для понимания какой именно телефон подтвержден
  vm.userBasePhone = vm.userData.phone;

  // логика восстановления подтверждаемого номера телефона, если существует актуальный запрос на подтверждение номера
  if (vm.userData.pending_phone_changes) {
    vm.pendingPhone = vm.userData.pending_phone_changes.phone;
  }

  /**
   * Метод для проверки статуса текущего телефонного номера
   */
  vm.isPhoneConfirmed = function() {
    return vm.userData.phone_confirmed && vm.userData.phone == vm.userBasePhone;
  };


  guid = vm.userData.id;


  vm.resetPhone = function(){
    $scope.editProfileForm.phone.$setValidity('unique', true);
    $scope.editProfileForm.phone.$setValidity('phoneAttempts', true);
    vm.confirmCode = undefined;
    vm.phoneConfirmSended = false;
    vm.userData.pending_phone_changes = null;
    vm.phoneAttempts = PHONE_ATTEMPTS;
  };

  /**
   * Отправка запроса на создания кода подтверждения телефона
   */
  vm.sendPhoneConfirmRequest = function (resending) {
    vm.start = new Date();
    $rootScope.stateChangeStart = true;
    phoneConfirmationService.sendPhoneConfirmationCreate(vm.userData.phone).then(function (data) {
      vm.phoneConfirmSended = true;
      vm.pendingPhone = vm.userData.phone;
      $rootScope.stateChangeStart = false;
      if(!resending) {
        requestStatus.success("Сообщение отправлено на телефон: " + $filter('phoneFormat')(vm.pendingPhone));
      }else if (resending) {
        requestStatus.success("Сообщение отправлено повторно на телефон: " + $filter('phoneFormat')(vm.pendingPhone));
      }
    }, function (error) {
      if (error.status == 503 && error.data.code == "unknown" && vm.phoneConfirmSended) {
        requestStatus.error('Во время повторной отправки кода произошла ошибка. Повторите попытку позже.');
      } else {
        requestStatus.error('Во время отправки кода произошла ошибка. Повторите попытку позже.');
      }
      $rootScope.stateChangeStart = false;
    });
  };

  /**
   * Отправка запроса на подтверждения телефона по коду
   */
  vm.checkPhoneConfirmCode = function () {
    if (!vm.confirmCode) {
      return;
    }
    $rootScope.stateChangeStart = true;
    phoneConfirmationService.sendPhoneConfirmationCode(vm.confirmCode).then(function () {
      $scope.editProfileForm.phone && $scope.editProfileForm.phone.$setValidity('phone_must_be_confirmed', true);
      vm.userData.phone_confirmed = true;
      vm.phoneConfirmSended = false;
      vm.userBasePhone = vm.pendingPhone;
      vm.userData.phone = vm.pendingPhone;
      vm.userData.pending_phone_changes = null;
      vm.phoneConfirmSended = false;
      vm.phoneAttempts = PHONE_ATTEMPTS;
      $rootScope.stateChangeStart = false;
    }, function (error) {
      vm.confirmCode = undefined;
      $rootScope.stateChangeStart = false;
      if (error.status == 503) {
        vm.phoneAttempts--;
        $scope.editProfileForm.confirmCode.$setValidity('confirmError', false);
        if (!vm.phoneAttempts) {
          vm.resetPhone();
          $scope.editProfileForm.phone.$setValidity('phoneAttempts', false);
        }
      } else {
        requestStatus.error('Во время подтверждения телефона произошла ошибка. Повторите попытку позже');
      }
    });
  };

  /**
   * Снятие ошибки валидации наличия телефона или email
   */
  $scope.$watchGroup(['vm.userData.phone', 'vm.userData.email'], function (oldArr, newArr) {
    if ((vm.userData.phone || vm.userData.email) && $scope.editProfileForm) {
      $scope.editProfileForm.phone && $scope.editProfileForm.phone.$setValidity('phone_or_email', true);
      $scope.editProfileForm.email && $scope.editProfileForm.email.$setValidity('phone_or_email', true);
    }
    if (oldArr[0] != newArr[0]) {
      $scope.editProfileForm.phone && $scope.editProfileForm.phone.$setValidity('phone_must_be_confirmed', true);
    }
  });

  vm._checkValidity = function() {
    if (!vm.userData.phone && !vm.userData.email && $scope.editProfileForm) {
      $scope.editProfileForm.phone && $scope.editProfileForm.phone.$setValidity('phone_or_email', false);
      $scope.editProfileForm.email && $scope.editProfileForm.email.$setValidity('phone_or_email', false);
      return false;
    }
    if (vm.userData.phone && (!vm.userData.phone_confirmed || vm.userBasePhone != vm.userData.phone)) {
      $scope.editProfileForm.phone && $scope.editProfileForm.phone.$setValidity('phone_must_be_confirmed', false);
      return false;
    }
    return true;
  };

  vm.submit = function () {
    vm.isSaved = true;
    if ($scope.editProfileForm.$valid &&
      vm._checkValidity()
    ) {
      auth.ensureSession().then(function(res) {
        editProfile();
      });
    }
  };

  function editProfile() {
    var requestBody = angular.copy(vm.userData);
    requestBody.time_zone = requestBody.time_zone ? requestBody.time_zone.timezoneId : null;
    requestBody.domain = undefined;
    requestBody.from_profile = true;
    settings.updateProfileInfo(guid, requestBody)
    .then(function (res) {
      $scope.editProfileForm.$setPristine();
      vm.returnToPage();
      $rootScope.user.user_pic = vm.userData.user_pic;
    })
    .catch(function (error) {
      if (error.status == 409) {
        $scope.editProfileForm[error.data.parameters[0].name].$setValidity('unique', false);
      } else {
        errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
      }

    });
  }

  vm.changePass = function(){
    $uibModal.open({
      templateUrl: 'app/settings/editProfile/modalChangePass.html',
      size: 'small-width',
      controller: function ($scope, $uibModalInstance) {

        $scope.close = function () {
          $uibModalInstance.dismiss();
        };

        $scope.checkPassword = function(){
          $scope.passNoMatch = $scope.newPassword && $scope.repeatedPassword && $scope.newPassword !== $scope.repeatedPassword;
          $scope.wrongDataTxt = ($scope.passNoMatch)? "Пароли не совпадают" : "";
        };

        $scope.changePassword = function(){
          if ($scope.changePasswordForm.$valid) {
            var passObj = {
              old_password: $scope.password,
              new_password: $scope.newPassword
            };
            auth.changePassword(passObj).then(function (res) {
              $uibModalInstance.close();
              $scope.password = $scope.newPassword = $scope.repeatedPassword = $scope.wrongDataTxt = '';
            })
              .catch(function (err) {
                if(err.data.message == 'Passwords do not match'){
                  $scope.wrongDataTxt = "Текущий пароль указан неверно"
                }
              });
          } else {
            angular.forEach( $scope.changePasswordForm.$error ,function (control) {
              for (var i = 0; i < control.length; i++) {
                control[i].$setDirty()
              }
            })
          }
        }

      }
    });
  };

  vm.restEmailError = function (){
    $scope.editProfileForm.email.$setValidity('unique', true);
    if (!vm.userData.email && vm.userData.pending_email_changes.length) {
      vm.userData.pending_email_changes = [];
    }
  };

  vm.uniqueCheck = function (str, event) {
    var constraintName = 'USER_EMAIL';
    var name = 'email';

    if (event.target.name == "phone") {
      constraintName = 'USER_PHONE';
      name = 'phone';
    }

    if (str) {
      var obj = {
        "constraint_name": constraintName,
        "parameters": [
          {
            "name": name,
            "value": str
          }
        ]
      };
      if (user.user.id) obj.id = user.user.id;
      utilsService.uniqueCheck(obj).then(function (res) {},
        function (error) {
          if (error.status == 409 && error.data.parameters[0].name == name) {
            $scope.editProfileForm[name].$setValidity('unique', false);
          }
        });
    }
  };

  vm.openImgView = function(){
    if(vm.userData.user_pic){
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/img-view.html',
        windowClass: 'img-view-popup',
        controller: function ($scope, $uibModalInstance) {
          $scope.img = vm.userData.user_pic.url;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    }
  };

  vm.showImgLoadPopup = function(){
    $uibModal.open({
        templateUrl: 'app/settings/templates/modals/img-editor/img-editor.html',
        windowClass: 'img-editor-popup',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance, API_URL, authToken, Upload) {
          $scope.title = "Аватарка пользователя";
          $scope.imgWidth = 301;
          $scope.imgHeight = 301;
          $scope.imgType = 'circle';
          $scope.temp = {
            outputImage:  undefined,
            inputImage: undefined
          };
          $scope.rotate = 0;

          $scope.rotateAction = function(deg) {
            $scope.rotate += deg;
          };

          $scope.changeFile = function (elem) {
            var input = elem;
            if (input.files && input.files[0]) {
              var reader = new FileReader();
              reader.onload = function (e) {
                $scope.$apply(function () {
                  $scope.temp.inputImage = e.target.result;
                });
              };
              reader.readAsDataURL(input.files[0]);
            }
          };

          $scope.removeImg = function(){
            $scope.temp.inputImage = null;
            $scope.temp.outputImage = null;
          };

          // функция преобразует dataurl в file
          $scope._dataURLtoBlob = function(dataurl, name) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
              bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
              u8arr[n] = bstr.charCodeAt(n);
            }
            var blob = new Blob([u8arr], {type:mime});

            blob.name = name;
            blob.lastModifiedDate = new Date();
            return blob;
          };

          $scope.save = function(){
            Upload.upload({
              url: API_URL + "/upload",
              headers: {'X-Session-Id': authToken.getToken()},
              data: {
                file: $scope._dataURLtoBlob($scope.temp.outputImage),
                type: "USER_PIC",
                name: "USER_PIC"
              }
            }).then(function (resp) {
              vm.userData.user_pic = resp.data;
              $scope.close();
            });
          };

          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    }

    /**
     * регистрация нового партнера в домене
     */
    vm.registerNewPartnerPopup = function(){
      $uibModal.open({
        templateUrl: 'app/partnership/modals/register-partner.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.save = function () {
            partnersService.addPromo('PARTNER').then(function(res){
              $rootScope.partner = true;
              $uibModalInstance.close();
            }, function(error){
              errorMessageService.showModal({message: 'Произошла ошибка', submessage: error});
            });
          };
        }
      });
    };
});

(function() {
  'use strict';

  angular.module('frontend').controller('DivisionsController', DivisionsController);

  function DivisionsController($scope, $state, auth, companyService, $document, cashRegistersPlacesSrv, filterFactoryService, userSettingsService, uiGridConstants, $timeout, $uibModal, filterSettingsService, companies) {
    var divisionCtrl = this;
    var transferPopup = {};

    if ($state.params.companyName) {
      divisionCtrl.searchText = $state.params.companyName;
    }

    $scope.$on('opened', function (event, data) {
      $scope.goToViewMode = false;
      transferPopup = data;
      $document.on('click', 'body', closePopup);
    });

    $scope.$on('closed', function (event) {
      $scope.goToViewMode = true;
      $document.off('click', 'body', closePopup);
    });

    function closePopup(event) {
      $scope.$broadcast('closePopup', transferPopup);
    }

    $scope.goToView = function(id, companyId){
      $state.go('division.view', {companyId: companyId, divisionId: id, parent: 'business'});
    };


    divisionCtrl.cleanObj = function(obj){
      var tempObj = angular.copy(obj);
      for(var prop in tempObj){
        if(!tempObj[prop]) delete obj[prop];
      }
      return obj;
    };

    divisionCtrl.gridFilter = filterFactoryService.createFilter("divisions", "grid");

    divisionCtrl.updateColumnFilter = function (colDef, col) {
      if (divisionCtrl.filter[colDef.filterName || colDef.name] && divisionCtrl.filter[colDef.filterName || colDef.name].complex) {
        col.filters[0].dateRange = divisionCtrl.filter[colDef.filterName || colDef.name].dateRange;
        col.filters[0].term = divisionCtrl.filter[colDef.filterName || colDef.name].datePickStr
      } else {
        col.filters[0].term = divisionCtrl.filter[colDef.filterName || colDef.name]
      }
    };

    divisionCtrl.initFilter = function () {
      divisionCtrl.filter = divisionCtrl.gridFilter.loadFilter() || {};
      divisionCtrl.gridApi && divisionCtrl.gridApi.grid.columns.filter(function (column) {
        return column.enableFiltering;
      }).forEach(function (col) {
        divisionCtrl.updateColumnFilter(col.colDef, col)
      });
      divisionCtrl.gridFilter.storeFilter(divisionCtrl.filter);
      divisionCtrl.filterDeepCopy = angular.copy(divisionCtrl.filter)
    };

    divisionCtrl.saveFilter = function (name) {
      divisionCtrl.gridFilter.saveFilter(name, divisionCtrl.filter);
      divisionCtrl.filterSaved = true;
      divisionCtrl.filterDeepCopy = angular.copy(divisionCtrl.filter);
      divisionCtrl.tmpFilterName = name;
    };

    divisionCtrl.closeFilterSavingModal = function (saveFilterForm) {
      saveFilterForm.$setPristine();
      saveFilterForm.$setUntouched()
    };

    divisionCtrl.prepareSavedFiltersList = function() {
      divisionCtrl.savedFilterListSearchText = ""
    };

    divisionCtrl.chooseFilter = function (filterName) {
      divisionCtrl.gridFilter.storeFilter(divisionCtrl.gridFilter.loadSavedFilter(filterName));
      divisionCtrl.initFilter();
      if (divisionCtrl.filter) {
        divisionCtrl.filterSaved = true;
        divisionCtrl.tmpFilterName = filterName
      }
    };

    divisionCtrl.removeFilter = function (filterName, $event) {
      $event.stopPropagation();
      divisionCtrl.gridFilter.removeFilter(filterName);
      if (filterName === divisionCtrl.tmpFilterName) {
        divisionCtrl.filterSaved = false
      }
      if (divisionCtrl.gridFilter.getSavedFiltersNames().length < 6) {
        divisionCtrl.savedFilterListSearchText = ""
      }
    };

    divisionCtrl.updateFilter = function (filter) {
      divisionCtrl.filterSaved = _.isEqual(divisionCtrl.cleanObj(divisionCtrl.filterDeepCopy), divisionCtrl.cleanObj(filter)) && divisionCtrl.tmpFilterName;
      if(!divisionCtrl.filterSaved) divisionCtrl.tmpFilterName = '';
      divisionCtrl.gridFilter.storeFilter(filter);
      divisionCtrl.initFilter();
      if (_.isEmpty(filter)) {
        divisionCtrl.filterSaved = false;
        divisionCtrl.tmpFilterName = '';
      }
    };

    divisionCtrl.applyFilter = function () {
      divisionCtrl.updateFilter(divisionCtrl.popupFilter);
      divisionCtrl.getPage()
    };

    divisionCtrl.cleanFilter = function () {
      divisionCtrl.updateFilter(undefined);
      divisionCtrl.getPage()
    };

    divisionCtrl.initPaging = function () {
      divisionCtrl.paging = userSettingsService.loadProperty("divisions", "grid", "paging") || {
        current: 0,
        limit: 5,
        offset: 0,
        sortBy: 'division.name',
        total: undefined
      };

      /**
       * Свойство добавлено из-за того, что количество сущностей в момент
       * сохранения может быть больше, чем при повторном обращении,
       * сохранять смещение - опасно. Кроме того, в разработке задача,
       * которая позволит после сохранения или редактирования сущности запрашивать
       * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
       * где сохранение смещение могло бы быть полезным.
       */
      divisionCtrl.paging.offset = 0;
      divisionCtrl.paging.current = 0;
    };

    divisionCtrl.init = function () {
      divisionCtrl.initFilter();
      divisionCtrl.initPaging();
      divisionCtrl.showFilter = userSettingsService.loadProperty("divisions", "grid", "showFilter") || false;
    };

    divisionCtrl.turnShowFilter = function () {
      divisionCtrl.showFilter = !divisionCtrl.showFilter;
      userSettingsService.saveProperty("divisions", "grid", "showFilter", divisionCtrl.showFilter);
      if(!divisionCtrl.showFilter){
        divisionCtrl.cleanFilter();
      }
    };

    divisionCtrl.init();

    divisionCtrl.showFilterPopup = function () {
      divisionCtrl.popupFilter = $.extend(true, {}, divisionCtrl.filter);
    };

    // запросы и преобразования для получения информации для фильтров
    divisionCtrl.companiesArr = [];
    angular.forEach(companies.items, function(company){
      divisionCtrl.companiesArr.push({value: company.id, label: company.name});
    });
    divisionCtrl.type = [{value: 'OFFICE', label: 'Офис'},
                         {value: 'SHOP', label: 'Магазин'},
                         {value: 'STOREHOUSE', label: 'Склад'}];

    divisionCtrl.configScrollFilter = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      setHeight: 186,
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      scrollInertia: 0
    };

    var pencil = '<a ng-if="$root.hasRole(\'division.write\')" ui-sref="division.edit({divisionId: row.entity.id, companyId: row.entity.company_id, parent: \'business\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>';
    var kkmHeader = '<div class="ui-grid-cell-contents"><span class="ui-grid-header-cell-label">ККМ</span></div>';
    divisionCtrl.rowsForDelete = [];

    $scope.columnVisibilityChanged = function(){
      var columnsProperty = divisionCtrl.gridApi.grid.options.columnDefs;
      angular.forEach(columnsProperty, function(column){
        if(column.filter) delete column.filter.selectOptions;
      });
      userSettingsService.saveProperty("divisions", "grid", "columnsProperty", columnsProperty)
    };

    /* настройки грида по умолчанию ($scope - обязательно) */
    $scope.defaultColumns = [
        { name: 'selection', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 64},
        { name: 'company_name', displayName:'Компания', visible: true, cellTemplate:'textTemplate.html', filterName: 'company_id', sortName: 'company.name', enableSorting: true, filterHeaderTemplate: 'recs/select-filter-template.html',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: divisionCtrl.companiesArr
          }
        },
        { name: 'type', displayName:'Тип', visible: true, cellTemplate: 'typeTemplate.html', enableSorting:false, width: 150, filterName: 'type', filterHeaderTemplate: 'recs/select-filter-template.html',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: divisionCtrl.type
          }
        },
        { name: 'name', displayName:'Название', visible: true,  cellTemplate:'textTemplate.html', sortName: 'division.name', enableSorting:true, enableFiltering: true, filterName: 'search_string', sort: {
            direction: 'asc',
            priority: 0
          }
        },
        { name: 'address', displayName:'Адрес', visible: true, cellTemplate:'addressTemplate.html', enableFiltering: false},
        { name: 'kkm', displayName:'ККМ', visible: true, cellTemplate: 'cashTemplate.html', headerCellTemplate: kkmHeader, width: 150, enableFiltering: false},
        { name: 'created_at', displayName:'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
        { name: 'created_by.name', displayName:'Кто создал',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
        { name: 'updated_at', displayName:'Дата обновления',cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
        { name: 'updated_by.name', displayName:'Кто обновил',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
        { name: 'option', visible: true, cellTemplate: pencil, displayName:'', enableHiding:false, width: 95, enableFiltering: false},
        { name: 'marginRight', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 63}
      ];

    var columnsProperty = userSettingsService.loadProperty("divisions", "grid", "columnsProperty");
    angular.forEach(columnsProperty, function(column){
      if(column.name == 'company_name'){
        column.filter.selectOptions = divisionCtrl.companiesArr;
      }
      if(column.name == 'type'){
        column.filter.selectOptions = divisionCtrl.type;
      }
    });

    divisionCtrl.gridOptions = {
      enableGridMenu:true,
      useExternalSorting: true,
      enableColumnMenu:false,
      enableSorting:false,
      enableFiltering: true,
      useExternalFiltering: true,
      showColumnFooter: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      rowTemplate: '<div ng-click="(grid.appScope.goToViewMode)?grid.appScope.goToView(row.entity.id, row.entity.company_id):\'\'">' +
                    ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
                   '</div>',
      columnDefs: columnsProperty || angular.copy($scope.defaultColumns),
      data: []
    };
    divisionCtrl.gridOptions.columnDefs.filter(function (colDef) {
      return colDef.name == divisionCtrl.paging.sortBy
    }).forEach(function (colDef) {
      colDef.sort = {
        direction: divisionCtrl.paging.sortDirection,
        priority: 0
      }
    });
    var columnsVisibility = userSettingsService.loadProperty("divisions", "grid", "columnsVisibility") || {};
    divisionCtrl.gridOptions.columnDefs.forEach(function (colDef) {
      if (columnsVisibility[colDef.name] === false) {
        colDef.visible = false
      } else if (columnsVisibility[colDef.name]) {
        colDef.visible = true
      }
    });

    divisionCtrl.gridOptions.onRegisterApi = function (gridApi) {
      divisionCtrl.gridApi = gridApi;
      divisionCtrl.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns.length == 0) {
          divisionCtrl.paging.sortBy = null;
          divisionCtrl.paging.sortDirection = null;
        } else {
          divisionCtrl.paging.sortBy = sortColumns[0].colDef.sortName || sortColumns[0].field;
          divisionCtrl.paging.sortDirection = sortColumns[0].sort.direction;
        }
        divisionCtrl.getPage();
      });
      gridApi.core.on.filterChanged($scope, function () {
        gridApi.grid.columns.filter(function (column) {
          return column.enableFiltering && column.visible !== false;
        }).forEach(function (column) {
          var filter = divisionCtrl.filter[column.colDef.filterName || column.name];
          if (filter && filter.complex) {
            filter.datePickStr = column.filters[0].term;
            filter.dateRange = column.filters[0].dateRange
          } else {
            divisionCtrl.filter[column.colDef.filterName || column.name] = column.filters[0].term
          }
        });
        divisionCtrl.paging.offset = 0;
        divisionCtrl.updateFilter(divisionCtrl.filter);
        divisionCtrl.getPage();
      });
      gridApi.grid.registerColumnBuilder(divisionCtrl.updateColumnFilter)
    }.bind(this);

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    divisionCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        this.error = false;
        this.message = '';
        this.loading = true;
      },
      stopLoadingSuccess: function() {
        this.error = false;
        this.message = '';
        this.loading = false;
      },
      stopLoadingFailure: function(message) {
        this.error = true;
        this.message = message;
        this.loading = false;
      }
    };

    // Поиск
    divisionCtrl.search = function () {
      // Сброс текущей страницы и поиск
      divisionCtrl.paging.current = 0;
      divisionCtrl.paging.offset = 0;
      divisionCtrl.getPage();
    };

    divisionCtrl.showSaveFilterPopup = function(){
      $uibModal.open({
        templateUrl: 'app/settings/components/filters/modals/saveFilter/save-filter.html',
        size: 'middle-width',
        controller: function($scope, $uibModalInstance){
          $scope.filterName = '';
          $scope.filterObj = divisionCtrl.gridFilter;

          $scope.save = function () {
            if ($scope.saveFilterForm.$valid) {
              divisionCtrl.saveFilter($scope.filterName);
            }
            $uibModalInstance.dismiss();
          };

          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      })
    };

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    divisionCtrl.getPage = function () {
      divisionCtrl.noData = divisionCtrl.loadData = false;
      divisionCtrl.crudState.startLoading();
      userSettingsService.saveProperty("divisions", "grid", "paging", divisionCtrl.paging);
      companyService.divisions(divisionCtrl.paging, divisionCtrl.searchText, divisionCtrl.filter).then(
        function (data) {
          if(!data.data.items.length && !divisionCtrl.searchText && _.isEmpty(divisionCtrl.filter)){
            divisionCtrl.noData = true;
          }
          divisionCtrl.divisions = data.data.items;
          // Ссылка в grid
          $scope.goToViewMode = true;
          divisionCtrl.gridOptions.data = divisionCtrl.divisions;
          divisionCtrl.paging.total = data.data.total;
          divisionCtrl.paging.current = data.data.offset / divisionCtrl.paging.limit;
          divisionCtrl.crudState.stopLoadingSuccess();
          divisionCtrl.loadData = true;
        },
        function (error) {
          divisionCtrl.divisions = [];
          divisionCtrl.crudState.stopLoadingFailure(error);
        }
      )
    };
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    divisionCtrl.getPage();

    filterSettingsService.filterDivision().then(function(res){
      divisionCtrl.filterMeta = res.data.items;
      divisionCtrl.filterMeta[0].selectVal = divisionCtrl.companiesArr;
    });

  }
})();

'use strict';

angular.module('frontend').service('cashRegistersPlacesSrv', function settings($http, API_URL, $log) {

  this.getPlaces = function (id) {
    return $http.get(API_URL + '/cash_register_places/', {
      params: {
        division_id: id,
        sort_by: 'name'
      }
    })
  }

  this.getAllPlaces = function (limit) {
    return $http.get(API_URL + '/cash_register_places', {
      params: {
        limit: limit || 100,
        sort_by: 'name'
      }
    });
  }

  this.createPlace = function (model) {
    return $http.post(API_URL + '/cash_register_places/', model)
  }

  this.replaceCashRegister = function (id, model) {
    return $http.put(API_URL + '/cash_registers/' + id + '/place', model, {
      params: {
        avoid_data_access_rules: true
      }
    })
  }

  this.getAllCashRegister = function (limit) {
    return $http.get(API_URL + '/cash_registers', {
      params: {
        limit: limit || 100,
        sort_by: 'division'
      }
    });
  }

});

(function () {
  'use strict';


  angular.module('frontend').service('discountsService', discountsService);

  function discountsService($http, API_URL) {

    /* Загрузка парметров скидок */
    this.getDiscountProperties = function () {
      return $http.get('assets/api/discountProperties.json');
    }
    // Получение списка скидок
    this.getDiscounts = function (paging, search, filter) {
      var data = {
        params: {
          search_string: search,
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection
        }
      }
      if(filter){
        Object.keys(filter).forEach(function (key) {
          if (filter[key]) {
            if (filter[key].complex) {
              filter[key].value && (data.params["filter_" + key] = filter[key].value)
              if (filter[key].dateRange) {
                filter[key].dateRange.startDate && (data.params["filter_" + key + "_from"] = convertDateToTimestamp(filter[key].dateRange.startDate))
                filter[key].dateRange.endDate && (data.params["filter_" + key + "_to"] = convertDateToTimestamp(filter[key].dateRange.endDate))
              }
            } else {
              data.params["filter_" + key] = filter[key];
            }
          }
        });
      }
      return $http.get(API_URL + "/retail_discounts", data);
    }

    /* Загрузка расширенной информации скидок */
    this.discount = function (id) {
      return $http.get(API_URL + "/retail_discounts/" + id)
    }

    /* Удаление скидки по идентифиактору */
    this.deleteDiscount = function (id) {
      return $http.delete(API_URL + '/retail_discounts/' + id);
    }

    /* Создание новой скидки */
    this.createDiscount = function (discount) {
      return $http.post(API_URL + '/retail_discounts/', discount);
    }

    /* Обновление информации о скидке */
    this.updateDiscount = function (discount) {
      return $http.put(API_URL + '/retail_discounts/' + discount.id, discount);
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('DiscountsController', DiscountsController);

  function DiscountsController(API_URL, discountColDefSrv, userSettingsService, uiGridConstants, filterSettingsService, employees) {
    var ctrl = this;
    ctrl.url = API_URL + '/retail_discounts';
    ctrl.page = 'discounts';
    ctrl.header = 'Скидочные акции';
    ctrl.rowRoute = 'discount.view';
    ctrl.sort = 'name';
    ctrl.limit = 25;
    ctrl.columnDefs = userSettingsService.loadProperty(ctrl.page, 'grid', 'columnsProperty') ||
      discountColDefSrv.getColumnDefs.call(this, uiGridConstants);
    ctrl.usingService = discountColDefSrv;
    ctrl.filterMeta = {};
    ctrl.gridButtonConfig = [{
      class: 'add-entity',
      url: 'discount.new({parent: "retail"})',
      text: 'Скидочная акция',
      permission: 'retail_discount.write',
      plusButton: true
    }];
    filterSettingsService.filterDicounts().then(function(res) {
      ctrl.filterMeta = res.data.items;
    });

    if(employees){
      this.employeeListSelect = [];
      ctrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        ctrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(ctrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = ctrl.employeeListSelect;
        }
      });
    }

    angular.forEach(ctrl.columnDefs, function (column) {
      if (column.name === 'dataValue.mode') {
        column.filter.selectOptions = [
          {
            value: "ACTION",
            label: "Акция"
          },
          {
            value: "REGULAR",
            label: "Регулярная скидка"
          }
        ];
      }
    });
  }
})();

(function() {
  'use strict';

  angular.module('frontend').service('discountColDefSrv', discountColDefSrv);

  /** @ngInject */
  function discountColDefSrv(userSettingsService, $window) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ? \'ascending\' :' +
      ' ( col.sort.direction == desc ? \'descending\' :' +
      ' (!col.sort.direction ? \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\':' +
      ' col.sort.direction == asc, \'ui-grid-icon-down-dir\':' +
      ' col.sort.direction == desc, \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    function getWidthAbsolute(percentage) {
      var width = $window.innerWidth - 64 - 120;
      return Math.round(width * (percentage / 100));
    }

    var columnsDefinedWidth = [64, getWidthAbsolute(50), getWidthAbsolute(20), getWidthAbsolute(20), 160, 160, 160, 160, 160];



    this.loadSavedDefinedColumnWidth = function() {
      var income = userSettingsService.loadProperty('discounts', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('discounts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function(columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('discounts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    var subjectTypes = [
        {value: 'true', label: 'Да'},
        {value: 'false', label: 'Нет'}];

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          visible: true,
          headerCellTemplate: '<div class="save-filter-star"' +
          ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
          '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
          ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
          '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
          '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.name',
          enableSorting: true,
          sortName: 'name',
          displayName: 'Наименование',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          minWidth: 160,
          width: columnsDefinedWidth[1],
          visible: true,
          backButton: true
        },
        {
          __index: 2,
          name: 'dataValue.effective_date',
          enableSorting: true,
          sortName: 'effective_date',
          displayName: 'Дата начала',
          headerCellTemplate: headerTemplate,
          minWidth: 115,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\'"/>',
          visible: true,
          filterName: 'effective_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="effective_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellFilter: 'date:\'dd.MM.yyyy\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.expire_date',
          enableSorting: false,
          sortName: 'expire_date',
          displayName: 'Дата окончания',
          minWidth: 115,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\'"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'expire_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="expire_date" scope="grid.appScope"></cell-date-picker-filter>',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          visible: true,
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.mode',
          enableSorting: false,
          displayName: 'Формат',
          headerCellTemplate: headerTemplate,
          filterName: 'mode',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD === \'REGULAR\')? \'Регулярная скидка\' : ((COL_FIELD === \'ACTION\')? \'Акция\' : \'\') "/>',
          enableColumnMenu: false,
          visible: false,
          minWidth: 115,
          width: columnsDefinedWidth[4],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: subjectTypes
          }
        },
        { __index: 5,
          name: 'dataValue.active',
          enableSorting: false,
          enableFiltering: true,
          displayName:'Активность',
          visible: true,
          width: 100,
          filterName: 'active',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<div class="ui-grid-cell-contents">\n' +
            '    <div ng-if="row.entity.dataValue.active">\n' +
            '      <span class="active-status tooltip-light" tooltip-placement="bottom-left" uib-tooltip="Действующая"></span>\n' +
            '    </div>\n' +
            '  </div>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: subjectTypes
          }
        },
        { __index: 6,
          name: 'dataValue.created_by.name',
          enableSorting: false,
          displayName:'Кто создал',
          visible: false,
          width: columnsDefinedWidth[5],
          filterName: 'created_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 7,
          name: 'dataValue.created_at',
          displayName: 'Когда создал',
          enableSorting: true,
          sortName: 'created_at',
          headerCellTemplate: headerTemplate,
          filterName: 'created_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[6]
        },
        { __index: 8,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[7],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 9,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'updated_at',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[8]
        },
        {
          __index: 10,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.effective_date">\n' +
          '              <p style="margin-bottom: 0">Дата начала:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.effective_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.expire_date">\n' +
          '              <p style="margin-bottom: 0">Дата окончания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.expire_date}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '<a ng-if="row.entity.dataValue && $root.hasRole(\'retail_discount.write\')" ' +
          'ui-sref="discount.edit({id: row.entity.dataValue.id, parent: \'retail\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('currenciesService', currenciesService);

  /**
   * Сервис для работы с АПИ валют
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   */
  function currenciesService($http, API_URL, $rootScope, $q) {

    function getDomainCurrenciesSuccess(res) {
      $rootScope.domainCurrencies = res;
      $rootScope.homeCurrency = _.find(res.items, function(item) {
        return item.home_currency
      });
    }

    /* Получить список доступных валют */
    this.getCurrencies = function() {
      return $http.get(API_URL + '/currencies');
    };

    this.getDomainCurrenciesSearch = function(searchText) {
      return $http.get(API_URL + '/domain/auto', {
        params: {
          search_string: searchText
        }
      });
    };

    /* Получить список доступных валют для конкретного домена */
    this.getDomainCurrencies = function(force) {
      if (!!$rootScope.domainCurrencies && !!$rootScope.homeCurrency && !force) {
        return $q(function(resolve) {
          resolve({data: $rootScope.domainCurrencies})
        })
      } else {
        return $http.get(API_URL + '/domain/currencies').success(getDomainCurrenciesSuccess);
      }

    };

    /* Добавляет валюту в домен */
    this.setCurrencies = function(data) {
      return $http.post(API_URL + '/domain/currencies', data, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /* Пытается удалить валюту из домена */
    this.deleteCurrencies = function(id) {
      return $http.delete(API_URL + '/domain/currencies/' + id);
    };

    /* Обновляет валюту в домене */
    this.putCurrencies = function(id, data) {
      return $http.put(API_URL + '/domain/currencies/' + id, data, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /* Получение детальной информации по отдельной валюте по ID */
    this.getCurrency = function(id) {
      return $http.get(API_URL + '/currencies/' + id);
    }

    /* Возвращает курс валюты документа */
    this.getCurrenciesRate = function(document_purpose, document_date, document_currency_id) {
      return $http.get(API_URL + '/domain/currencies/rate', {
        params: {
          document_purpose: document_purpose,
          document_date: document_date,
          document_currency_id: document_currency_id
        }
      });
    }

  }

}) ();

(function() {
  'use strict';

  angular.module('frontend').controller('currenciesController', currenciesController);

  function currenciesController($scope, $location, $state, $uibModal, auth, helpService, currenciesService, $rootScope) {
    var vm = this;
    vm.currencies = [];
    vm.currentCurrencies = {};
    /*
     * Запрос на получание всех валют участника
     */
    vm.crudState = helpService.getCrudStateStructure();
    vm.getDomainCurrency = function(){
      vm.crudState.startLoading();
      currenciesService.getDomainCurrencies(true).then(function(res){
        vm.crudState.stopLoadingSuccess();
        var currencies = res.data.items;
        vm.currencies = [];
        vm.canChangeCurrency = res.data.can_change_home_currency;
        for(var i in res.data.items){
          if(currencies[i].home_currency){
            vm.currentCurrencies = currencies[i];
          }else{
            vm.currencies.push(currencies[i]);
          }
        }
      });
    }

    /*
     * Расчет процента наценки для валюты участника
     * @param cb курс Центрального Банка России
     * @param percentage процент от курса
     * @result number вычисленный процент или курс центрального банка
     */
    vm.calculateFormula = function(cb, percentage){
      var res = cb;
      if(parseFloat(percentage)){
        res = (parseFloat(cb)*(1+parseFloat(percentage)/100)).toFixed(4);
        if(!isNaN(res)) return res;
        else return cb;
      }else{
        return res;
      }
    }

    /*
     * Метод, вызываемый при открытии попапа добавления/редактирования валюты
     * @param popupMode режим попапа (добавлениe/редактированиe)
     * @param item объект валюты для редактирования
     */
    vm.crudCurrency = function (popupMode, item) {
      $uibModal.open({
        templateUrl: 'app/settings/currencies/crudCurrencies.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.showRemove = false;
          $scope.popupMode = popupMode;
          $scope.systemCurrencies = [];
          $scope.selectedCurr = null;
          $scope.selectName = '';
          $scope.selectCode = '';
          $scope.rate = {
            signSaleRate: '+',
            signPurchaseRate: '+'
          };
          $scope.canChangeCurrency = vm.canChangeCurrency;
          $scope.calculateFormula = vm.calculateFormula;

          if (item) {
            $scope.hideCheck = item.home_currency;
            $scope.rate.signSaleRate = (item.sell_rate < 0) ? '-' : '+';
            $scope.rate.signPurchaseRate = (item.buy_rate < 0) ? '-' : '+';
            $scope.saleRate = Math.abs(item.sell_rate);
            $scope.purchaseRate = Math.abs(item.buy_rate);
            $scope.homeCurrency = item.home_currency;
            $scope.removeCurrency = item.id;
            $scope.selectedCurr = item.currency;
            $scope.selectedCurr.last_central_bank_rate = item.last_central_bank_rate;
            if (item.last_central_bank_rate) {
              $scope.calculateSale = $scope.calculateFormula(
                item.last_central_bank_rate.rate, item.sell_rate);
              $scope.calculatePurchase = $scope.calculateFormula(
                item.last_central_bank_rate.rate, item.buy_rate);
            }
          } else {
            if (!vm.systemCurrencies) {
              currenciesService.getCurrencies().then(function(res){
                var names = [];
                for (var i = 0; i < vm.currencies.length; i++) {
                  names.push(vm.currencies[i].currency.name)
                }
                angular.forEach(res.data, function (currency , i , currencies) {
                  if (names.indexOf(currency.name) < 0 && vm.currentCurrencies.currency.name !== currency.name) {
                    $scope.systemCurrencies.push(currency)
                  }
                });
                vm.systemCurrencies = $scope.systemCurrencies;
              });
            } else {
              $scope.systemCurrencies = vm.systemCurrencies;
            }
          }

          $scope.totalStr = function(total){
            return function () {
              if(total > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
                return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + total;
              }
              return '';
            }

          };

          // create Currency
          $scope.create = function() {
            $scope.isSaved = true;
            $scope.currenciesForm.currencyName.$setTouched();
            if (!$scope.selectedCurr) return;
            currenciesService.setCurrencies(
              {
                "currency_id": $scope.selectedCurr.id,
                "sell_rate": ($scope.saleRate)? parseFloat($scope.sign($scope.saleRate, $scope.rate.signSaleRate, false)) : 0,
                "buy_rate": ($scope.purchaseRate)? parseFloat($scope.sign($scope.purchaseRate, $scope.rate.signPurchaseRate, false)) : 0,
                "home_currency": ($scope.homeCurrency)? $scope.homeCurrency : false
              }).then(function(res){
                $uibModalInstance.close({mode: 'add', data: res.data});
              });
          };

          // update Currency
          $scope.save = function() {
            currenciesService.putCurrencies($scope.removeCurrency,
              {
                "currency_id": $scope.selectedCurr.id,
                "sell_rate": ($scope.saleRate)? parseFloat($scope.sign($scope.saleRate, $scope.rate.signSaleRate, true)) : 0,
                "buy_rate": ($scope.purchaseRate)? parseFloat($scope.sign($scope.purchaseRate, $scope.rate.signPurchaseRate, true)) : 0,
                "home_currency": $scope.homeCurrency
              }).then(function(res){
                $uibModalInstance.close({mode: 'edit', data: res.data});
              });
          };

          // close remove/main popup
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };

          // toggle remove popup
          $scope.removeToggle = function() {
            $scope.showRemove = !$scope.showRemove;
          };

          $scope.deleteCurrencies = function(id){
            currenciesService.deleteCurrencies(id).then(function(){
              $uibModalInstance.close({mode: 'delete', data: $scope.selectedCurr});
            });
          }

          $scope.changeSelect = function(curr){
            $scope.homeCurrency = false;
            $scope.selectedCurr = curr;
            if($scope.selectedCurr.last_central_bank_rate){
              $scope.calculateSale = $scope.calculateFormula($scope.selectedCurr.last_central_bank_rate.rate, $scope.saleRate);
              $scope.calculatePurchase = $scope.calculateFormula($scope.selectedCurr.last_central_bank_rate.rate, $scope.purchaseRate);
            }
          }

          // Расчет процента наценки для валюты участника в попапе
          $scope.calc = function(cb, rate, sign){
            if(rate){
              rate = parseFloat($scope.sign(rate, sign, true));
              return $scope.calculateFormula(cb, rate);
            } else {
              return cb;
            }
          }

          $scope.calcSale = function(rate,saleRate,signSaleRate ){
            $scope.calculateSale = $scope.calc(rate,saleRate,signSaleRate);

          }

          $scope.calcPurchase = function(rate, purchaseRate, signPurchaseRate){
            $scope.calculatePurchase = $scope.calc(rate, purchaseRate, signPurchaseRate);
          }

          // замена знака разделителя у дробных чисел
          $scope.sign = function(num, sign, isNeedDott){
            if(isNeedDott){
              return sign + num.toString().replace(",",".");
            }else{
              return sign + num.toString().replace(".",",");
            }
          }

        }
      }).result.then(function (result) {
        $rootScope.domainCurrencies = vm.currencies;
        $rootScope.homeCurrency = _.find(vm.currencies.items, function(item) {
          return item.home_currency
        });
        $state.reload();
      });
    }

    if($state.params.state == 'new'){
       vm.crudCurrency('add');
       $location.search('state', null);
    }
  }
})();

(function () {
  'use strict';


  angular.module('frontend').service('contragentService', contragentService);

  function contragentService($http, API_URL) {

    var contrAgentsApiUrl = API_URL + '/counterparties';

    this.getBankInfo = function (bik) {
      return $http.get(API_URL + '/utils/bank_info', {
        params: {
          search_string: bik,
          limit: 5
        }
      });
    }

    function convertDateToTimestamp(dateStr) {
      var date = moment(dateStr);
      var offset = date.utcOffset();
      return date.utcOffset(0).add(offset, 'minutes').unix() * 1000
    }

    this.counterparties = function (paging, search, filter) {
      var data = {
        params: {
          search_string: search,
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection
        }
      }
      if(filter){
        Object.keys(filter).forEach(function (key) {
          if (!!filter[key]) {
            if (filter[key].complex) {
              filter[key].value && (data.params["filter_" + key] = filter[key].value)
              if (filter[key].dateRange) {
                filter[key].dateRange.startDate && (data.params["filter_" + key + "_from"] = convertDateToTimestamp(filter[key].dateRange.startDate))
                filter[key].dateRange.endDate && (data.params["filter_" + key + "_to"] = convertDateToTimestamp(filter[key].dateRange.endDate))
              }
            } else {
              data.params["filter_" + key] = filter[key];
            }
          }
        });
      }
      return $http.get(contrAgentsApiUrl, data)
    }

    /* Загрузка расширенной информации о контрагенте */
    this.contragent = function (contragentId) {
      return $http.get(contrAgentsApiUrl + '/' + contragentId);
    }

    /* Загрузка списка контрагентов по поисковой строке */
    this.counterpartiesSearch = function (search, limit, filters) {
      var params = {
        search_string: search,
        limit: limit || 5
      };
      params = Object.assign(params, filters);
      return $http.get(contrAgentsApiUrl + '/auto', {
        params: params
      })
    }

    /* Возвращает список счетов контрагента. Для физического лица это список счетов связанного физического лица */
    this.getAccounts = function (contragentId) {
      return $http.get(contrAgentsApiUrl + '/' + contragentId + '/accounts');
    }

    /* Удаление контрагента по идентифиактору */
    this.deleteContragent = function (contragentId) {
      return $http.delete(contrAgentsApiUrl + '/' + contragentId);
    }

    /* Создание нового контрагента */
    this.createContragent = function (contragent) {
      return $http.post(contrAgentsApiUrl + '/', contragent);
    }

    /* Обновление информации о контрагенте */
    this.updateContragent = function (contragent) {
      return $http.put(contrAgentsApiUrl + '/' + contragent.id, contragent);
    }


    this.contacts = function(id) {
      return $http.get(contrAgentsApiUrl + '/' + id + '/contacts');
    }
    
    this.getCounterpartiesRoles = function () {
      return {
        CUSTOMER:  { name: "Покупатель", checked: false },
        SUPPLIER:  { name: "Поставщик", checked: false },
        COMMITTEE:  { name: "Комитент", checked: false },
        COMMISSIONER:  { name: "Комиссионер", checked: false },
        BANK:  { name: "Банк", checked: false },
        LENDER:  { name: "Кредитор", checked: false },
        BORROWER:  { name: "Заемщик", checked: false }
      }

    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('ContragentsController', ContragentsController);

  function ContragentsController($scope, auth, $state, $timeout, $uibModal, contragentService, userSettingsService, uiGridConstants, filterFactoryService, filterSettingsService) {
    var vm = this;
    var pencil = '<a ng-if="$root.hasRole(\'counterparty.write\')" ui-sref="contragent.edit({contragentId: row.entity.id, parent: grid.appScope.vm.parentPage})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>';
    vm.parentPage = $state.params.parent;
    vm.cleanObj = function(obj){
      var tempObj = angular.copy(obj);
      for(var prop in tempObj){
        if(!tempObj[prop]) delete obj[prop];
      }
      return obj;
    }

    vm.configScrollFilter = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      setHeight: 186,
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      scrollInertia: 0
    };

    vm.subjectTypes = [
      {value: 'LEGAL_ENTITY', label: 'Юридическое лицо'},
      {value: 'SOLE_TRADER', label: 'Индивидуальный предпринематель'},
      {value: 'PERSON', label: 'Физическое лицо'}]

    vm.subjectTypesPopup = vm.subjectTypes;

    vm.gridFilter = filterFactoryService.createFilter("contragents", "grid")

    vm.updateColumnFilter = function (colDef, col) {
      if (vm.filter[colDef.filterName || colDef.name] && vm.filter[colDef.filterName || colDef.name].complex) {
        col.filters[0].dateRange = vm.filter[colDef.filterName || colDef.name].dateRange
        col.filters[0].term = vm.filter[colDef.filterName || colDef.name].datePickStr
      } else {
        col.filters[0].term = vm.filter[colDef.filterName || colDef.name]
      }
    }

    vm.initFilter = function () {
      vm.filter = vm.gridFilter.loadFilter() || {};
      vm.gridApi && vm.gridApi.grid.columns.filter(function (column) {
        return column.enableFiltering;
      }).forEach(function (col) {
        vm.updateColumnFilter(col.colDef, col)
      })
      vm.gridFilter.storeFilter(vm.filter)
    }

    vm.prepareSavedFiltersList = function() {
      vm.savedFilterListSearchText = ""
    }

    vm.saveFilter = function (name) {
      vm.gridFilter.saveFilter(name, vm.filter);
      vm.filterSaved = true;
      vm.filterDeepCopy = angular.copy(vm.filter);
      vm.savedFilterName = name;
    }

    vm.chooseFilter = function (filterName) {
      vm.gridFilter.storeFilter(vm.gridFilter.loadSavedFilter(filterName))
      vm.initFilter()
      vm.filterDeepCopy = angular.copy(vm.filter)
      if (vm.filter) {
        vm.filterSaved = true
        vm.savedFilterName = filterName
      }
      vm.showFilter = true;
    }

    vm.removeFilter = function (filterName, $event) {
      $event.stopPropagation()
      vm.gridFilter.removeFilter(filterName)
      if (filterName === vm.savedFilterName) {
        vm.filterSaved = false
      }
      if (vm.gridFilter.getSavedFiltersNames().length < 6) {
        vm.savedFilterListSearchText = ""
      }
    }

    vm.updateFilter = function (filter) {
      vm.filterSaved = vm.filterSaved &&  _.isEqual(vm.cleanObj(vm.filterDeepCopy), vm.cleanObj(filter));      vm.gridFilter.storeFilter(filter)
      if(!vm.filterSaved) vm.savedFilterName = '';
      vm.gridFilter.storeFilter(filter);
      vm.initFilter();
      if (_.isEmpty(filter)) {
        vm.filterSaved = false;
        vm.savedFilterName = '';
      }
    }

    vm.applyFilter = function () {
      vm.updateFilter(vm.popupFilter)
      vm.getPage()
    }

    vm.cleanFilter = function () {
      vm.updateFilter(undefined)
      vm.getPage()
    }

    vm.initPaging = function () {
      vm.paging = userSettingsService.loadProperty("contragents", "grid", "paging") || {
        current: 0,
        limit: 5,
        offset: 0,
        sortBy: 'name',
        total: undefined
      };

      /**
       * Свойство добавлено из-за того, что количество сущностей в момент
       * сохранения может быть больше, чем при повторном обращении,
       * сохранять смещение - опасно. Кроме того, в разработке задача,
       * которая позволит после сохранения или редактирования сущности запрашивать
       * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
       * где сохранение смещение могло бы быть полезным.
       */
      vm.paging.offset = 0;
      vm.paging.current = 0;
    }

    vm.init = function () {
      vm.initFilter();
      vm.initPaging();
      vm.showFilter = userSettingsService.loadProperty("contragents", "grid", "showFilter") || false;
    }

    vm.turnShowFilter = function () {
      vm.showFilter = !vm.showFilter;
      userSettingsService.saveProperty("contragents", "grid", "showFilter", vm.showFilter);
      if(!vm.showFilter){
        vm.cleanFilter();
      }
    }

    vm.init();

    vm.showFilterPopup = function () {
      vm.popupFilter = $.extend(true, {}, vm.filter);
    }

    vm.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      setHeight: 400,
      scrollInertia: 0
    }

    $scope.goToView = function (id) {
      $state.go('contragent.view', {contragentId: id, parent: $state.params.parent});
    };

    $scope.columnVisibilityChanged = function(){
      var columnsProperty = vm.gridApi.grid.options.columnDefs;
      angular.forEach(columnsProperty, function(column){
        if(column.filter) delete column.filter.selectOptions;
      });
      userSettingsService.saveProperty("contragents", "grid", "columnsProperty", columnsProperty)
    }

    /* настройки грида по умолчанию ($scope - обязательно) */
    $scope.defaultColumns = [
        { name: 'selection', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 64},
        { name: 'name',  enableSorting:true, sortName: 'name', displayName:'Наименование', visible: true, cellTemplate: 'textTemplate.html', sort: {direction: 'asc', priority: 0}, filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'phone', displayName:'Телефон', visible: true, enableFiltering: false, cellTemplate: 'textPhoneTemplate.html' },
        { name: 'email', displayName:'E-mail', visible: true, enableColumnMenu:false, enableFiltering: false, cellTemplate: 'textEmailTemplate.html'},
        { name: 'organization.chief_name', sortName: 'chief', filterName: 'chief_name', displayName:'Руководитель', visible: true,cellTemplate: 'textTemplate.html', enableSorting:true, filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'comment', displayName:'Комментарий', visible: true, cellTemplate: 'textTemplate.html', enableColumnMenu:false, enableFiltering: false },
        { name: 'counterparty_type', displayName: 'Тип контрагента', cellTemplate: 'typeTemplate.html', enableColumnMenu: false,visible: false, filterHeaderTemplate: 'recs/select-filter-template.html',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: vm.subjectTypes
          }
        },
        { name: 'organization.legal_requisites.full_name', enableSorting:true, sortName: 'full_name', displayName:'Полное наименование', filterName: 'full_name',cellTemplate: 'textTemplate.html', visible:false, filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'organization.legal_requisites.short_name', enableSorting:true, sortName: 'short_name', displayName:'Сокращенное наименование', filterName: 'short_name',cellTemplate: 'textTemplate.html', visible:false, filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'organization.legal_requisites.legal_address', displayName:'Юридический адрес/Адрес регистрации', filterName: 'legal_address', enableColumnMenu:false, visible:false, cellTemplate: 'addressTemplate.html', filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'real_address',  displayName:'Фактический адрес', filterName: 'real_address', enableColumnMenu:false,cellTemplate: 'addressTemplate.html', visible:false, filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'organization.legal_requisites.ogrn', enableSorting:true, sortName: 'ogrn',filterName: 'ogrn',  displayName:'ОГРН', enableColumnMenu:false,cellTemplate: 'textTemplate.html', visible:false, filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'organization.legal_requisites.inn', enableSorting:true, sortName: 'inn', filterName: 'inn', displayName:'ИНН', enableColumnMenu:false,cellTemplate: 'textTemplate.html', visible:false, filterHeaderTemplate: 'recs/inputFilterTemplate.html' },
        { name: 'organization.legal_requisites.kpp', displayName:'КПП', enableColumnMenu:false, enableFiltering: false,cellTemplate: 'textTemplate.html', visible:false },
        { name: 'organization.accounts[0].bank', displayName:'Банк', enableFiltering: false,cellTemplate: 'textTemplate.html', visible:false },
        { name: 'organization.accounts[0].account', displayName:'Расчетный счет', enableColumnMenu:false, enableFiltering: false,cellTemplate: 'textTemplate.html', visible:false },
        { name: 'created_at', displayName:'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
        { name: 'created_by.name', displayName:'Кто создал',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
        { name: 'updated_at', displayName:'Дата обновления',cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
        { name: 'updated_by.name', displayName:'Кто обновил',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
        { name: 'option', field: 'option', cellTemplate: pencil, displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 95},
        { name: 'marginRight', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 63}
      ]

    var columnsProperty = userSettingsService.loadProperty("contragents", "grid", "columnsProperty");
    angular.forEach(columnsProperty, function(column){
      if(column.name == 'counterparty_type'){
        column.filter.selectOptions = vm.subjectTypes;
      }
    });

    vm.gridOptions = {
      enableSorting:false,
      useExternalSorting: true,
      useExternalFiltering: true,
      virtualizationThreshold: vm.paging.limit,
      enableGridMenu:true,
      enableFiltering: true,
      showColumnFooter: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      rowTemplate: '<div ng-click="grid.appScope.goToView(row.entity.id);">' +
      ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
      '</div>',
      columnDefs: columnsProperty || angular.copy($scope.defaultColumns)
    };
    vm.gridOptions.columnDefs.filter(function (colDef) {
      return colDef.name == vm.paging.sortBy
    }).forEach(function (colDef) {
      colDef.sort = {
        direction: vm.paging.sortDirection,
        priority: 0
      }
    })
    var columnsVisibility = userSettingsService.loadProperty("contragents", "grid", "columnsVisibility") || {}
    vm.gridOptions.columnDefs.forEach(function (colDef) {
      if (columnsVisibility[colDef.name] === false) {
        colDef.visible = false
      } else if (columnsVisibility[colDef.name]) {
        colDef.visible = true
      }
    })

    vm.gridOptions.onRegisterApi = function (gridApi) {
      vm.gridApi = gridApi
      gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns.length === 0) {
          vm.paging.sortBy = null;
          vm.paging.sortDirection = null;
        } else {
          vm.paging.sortBy = sortColumns[0].colDef.sortName;
          vm.paging.sortDirection = sortColumns[0].sort.direction;
        }
        vm.getPage();
      });
      gridApi.core.on.filterChanged($scope, function () {
        gridApi.grid.columns.filter(function (column) {
          return column.enableFiltering && column.visible !== false;
        }).forEach(function (column) {
          var filter = vm.filter[column.colDef.filterName || column.name]
          if (filter && filter.complex) {
            if(column.filters[0].term) filter.datePickStr = column.filters[0].term
            filter.dateRange = column.filters[0].dateRange
          } else {
            vm.filter[column.colDef.filterName || column.name] = column.filters[0].term
          }
        });
        vm.paging.offset = 0;
        vm.updateFilter(vm.filter)
        vm.getPage();
      });
      gridApi.grid.registerColumnBuilder(vm.updateColumnFilter)
    }.bind(this);

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    vm.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function () {
        this.error = false;
        this.message = '';
        this.loading = true;
      },
      stopLoadingSuccess: function () {
        this.error = false;
        this.message = '';
        this.loading = false;
      },
      stopLoadingFailure: function (message) {
        this.error = true;
        this.message = message;
        this.loading = false;
      }
    }

    // Поиск
    vm.search = function () {
      // Сброс текущей страницы и поиск
      vm.paging.current = 0;
      vm.paging.offset = 0;
      vm.getPage();
    }

    vm.showSaveFilterPopup = function(){
      $uibModal.open({
        templateUrl: 'app/settings/components/filters/modals/saveFilter/save-filter.html',
        size: 'middle-width',
        controller: function($scope, $uibModalInstance){
          $scope.filterName = '';
          $scope.filterObj = vm.gridFilter;

          $scope.save = function () {
            if ($scope.saveFilterForm.$valid) {
              vm.saveFilter($scope.filterName);
            }
            $uibModalInstance.dismiss();
          }

          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      })
    }

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    vm.getPage = function () {
      vm.noData = vm.loadData = false;
      vm.gridOptions.virtualizationThreshold = vm.paging.limit;
      vm.crudState.startLoading();
      userSettingsService.saveProperty("contragents", "grid", "paging", vm.paging); // Настройки paging сохраняются при оюбом обновлении страницы (фильтры и остальное, в своих обработчиках)
      vm.filter.roles = $state.params.parent === 'purchase'
                                        ? ['SUPPLIER']
                                        : $state.params.parent === 'sale'
                                          ? ['CUSTOMER']
                                          : null;
      contragentService.counterparties(vm.paging, vm.searchText, vm.filter).then(
        function (data) {
          if(!data.data.items.length && !vm.searchText && _.isEmpty(vm.filter)){
            vm.noData = true;
          }
          vm.counterparties = data.data.items;
          vm.paging.total = data.data.total;
          vm.paging.current = data.data.offset / vm.paging.limit;
          /* выявление основного счета и перенос его на первое место */
          var mainAcc, indexMain;
          angular.forEach(vm.counterparties, function(counterparty) {
            if (counterparty.organization && counterparty.organization.accounts.length > 1) {
              mainAcc = _.find(counterparty.organization.accounts, function (item, i) {
                if (item.main == true) indexMain = i;
                return item.main == true;
              });
              counterparty.organization.accounts.splice(indexMain, 1);
              counterparty.organization.accounts.unshift(mainAcc);
            }

            // Установка почты и телефона для отображения
            counterparty.$$phone = _.find(counterparty.contact_info.details, function(cInfo) {
              return cInfo.type == 'PHONE';
            })
            counterparty.$$email = _.find(counterparty.contact_info.details, function(cInfo) {
              return cInfo.type == 'EMAIL';
            })
          });
          vm.loadData = true;
          // Ссылка в grid
          vm.gridOptions.data = vm.counterparties;

          vm.crudState.stopLoadingSuccess();
        },
        function (error) {
          vm.counterparties = [];
          vm.crudState.stopLoadingFailure(error);
        }
      )
    }
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    vm.getPage();

    filterSettingsService.filterCounterparty().then(function(res){
      vm.filterMeta = res.data.items;
    });

  }
})();

/**
 * Created by aivanov on 27.06.2017.
 */
(function() {
  'use strict';

  angular.module('frontend').service('contractService', contractService);

  /**
   * Сервис для работы с АПИ сотрудников
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function contractService($http, API_URL) {

    /* Загрузка списка договоров */
    this.contracts = function (paging, search, filter) {
      paging = paging || {};
      var data = {
        params: {
          search_string: search,
          limit: paging.limit || 100,
          offset: paging.offset || 0,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection
        }
      };
      if(filter){
        Object.keys(filter).forEach(function (key) {
          if (!!filter[key]) {
            data.params["filter_" + key] = filter[key];
          }
        });
      }
      return $http.get(API_URL + '/contracts', data);
    }

    this.contractsForAutocomplete = function (search, limit, type, companyId, counterpartyId, purpose) {
      return $http.get(API_URL + '/contracts/auto', {
        params: {
          search_string: search,
          limit: limit || 5,
          filter_contract_type: type,
          filter_active: true,
          filter_company_id: companyId,
          filter_counterparty_id: counterpartyId,
          filter_purpose_code: purpose
        }
      });
    }

    /* Загрузка расширенной информации о контракте */
    this.contract = function (contractId) {
      return $http.get(API_URL + '/contracts/' + contractId);
      //return $http.get('assets/api/user.json');
    }

    /* Удаление контракта */
    this.deleteContract = function (contractId) {
      return $http.delete(API_URL + '/contracts/' + contractId);
    }

    /* Создание нового контракта */
    this.createContract = function (contract) {
      if (contract.roles && contract.roles.length == 0) {
        contract.roles = undefined;
      }
      return $http.post(API_URL + '/contracts/', contract);
    }

    /* Обновление информации о контракте */
    this.updateContract = function (contract) {
      var id = contract.id;
      return $http.put(API_URL + '/contracts/' + id, contract);
    }
  }

}) ();

/**
 * Created by aivanov on 24.05.2017.
 */
(function () {
  'use strict';

  /*eslint angular/controller-as-vm: [2,"contractsCtrl"]*/
  angular.module('frontend').controller('contractsController', contractsController);

  function contractsController($state,
                               $scope,
                               $timeout,
                               $uibModal,
                               contractService,
                               auth,
                               types,
                               contragentService,
                               companyService,
                               uiGridConstants,
                               userSettingsService,
                               filterFactoryService,
                               filterSettingsService,
                               TIMEOUT_THROTTLE
  ) {
    var contractsCtrl = this;

    contractsCtrl.cleanObj = function(obj){
      var tempObj = angular.copy(obj);
      for(var prop in tempObj){
        if(!tempObj[prop]) delete obj[prop];
      }
      return obj;
    };

    $scope.goToView = function(id){
      $state.go('contract.view',{contractId: id, parent: 'money'});
    };

    contractsCtrl.gridFilter = filterFactoryService.createFilter("contracts", "grid")

    contractsCtrl.updateColumnFilter = function (colDef, col) {
      col.filters[0].term = contractsCtrl.filter[colDef.filterName || colDef.name]
    };

    contractsCtrl.initFilter = function () {
      contractsCtrl.filter = contractsCtrl.gridFilter.loadFilter() || {};
      contractsCtrl.gridApi && contractsCtrl.gridApi.grid.columns.filter(function (column) {
        return column.enableFiltering;
      }).forEach(function (col) {
        contractsCtrl.updateColumnFilter(col.colDef, col)
      });
      contractsCtrl.gridFilter.storeFilter(contractsCtrl.filter);
      contractsCtrl.filterDeepCopy = angular.copy(contractsCtrl.filter)
    };

    contractsCtrl.saveFilter = function (name) {
        contractsCtrl.gridFilter.saveFilter(name, contractsCtrl.filter);
        contractsCtrl.filterSaved = true;
        contractsCtrl.filterDeepCopy = angular.copy(contractsCtrl.filter);
        contractsCtrl.savedFilterName = name;
    };

    contractsCtrl.closeFilterSavingModal = function (saveFilterForm) {
      saveFilterForm.$setPristine();
      saveFilterForm.$setUntouched()
    };

    contractsCtrl.prepareSavedFiltersList = function() {
      contractsCtrl.savedFilterListSearchText = ""
    };

    contractsCtrl.chooseFilter = function (filterName) {
      contractsCtrl.gridFilter.storeFilter(contractsCtrl.gridFilter.loadSavedFilter(filterName));
      contractsCtrl.initFilter();
      if (contractsCtrl.filter) {
        contractsCtrl.filterSaved = true;
        contractsCtrl.savedFilterName = filterName
      }
      contractsCtrl.showFilter = true;
    };

    contractsCtrl.removeFilter = function (filterName, $event) {
      $event.stopPropagation();
      contractsCtrl.gridFilter.removeFilter(filterName);
      if (filterName === contractsCtrl.savedFilterName) {
        contractsCtrl.filterSaved = false
      }
      if (contractsCtrl.gridFilter.getSavedFiltersNames().length < 6) {
        contractsCtrl.savedFilterListSearchText = ""
      }
    };

    contractsCtrl.updateFilter = function (filter) {
      contractsCtrl.filterSaved = _.isEqual(contractsCtrl.cleanObj(contractsCtrl.filterDeepCopy), contractsCtrl.cleanObj(filter)) && contractsCtrl.savedFilterName;
      if(!contractsCtrl.filterSaved) contractsCtrl.savedFilterName = '';
      contractsCtrl.gridFilter.storeFilter(filter);
      contractsCtrl.initFilter();
      if (_.isEmpty(filter)) {
        contractsCtrl.filterSaved = false;
        contractsCtrl.savedFilterName = '';
      }
    };

    contractsCtrl.applyFilter = function () {
      contractsCtrl.updateFilter(contractsCtrl.popupFilter);
      contractsCtrl.getPage();
    };

    contractsCtrl.cleanFilter = function () {
      contractsCtrl.updateFilter(undefined);
      contractsCtrl.getPage()
    };

    contractsCtrl.initPaging = function () {
      contractsCtrl.paging = userSettingsService.loadProperty("contracts", "grid", "paging") || {
        current: 0,
        limit: 5,
        offset: 0,
        sortBy: 'number',
        total: undefined
      };

      /**
       * Свойство добавлено из-за того, что количество сущностей в момент
       * сохранения может быть больше, чем при повторном обращении,
       * сохранять смещение - опасно. Кроме того, в разработке задача,
       * которая позволит после сохранения или редактирования сущности запрашивать
       * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
       * где сохранение смещение могло бы быть полезным.
       */
      contractsCtrl.paging.offset = 0;
      contractsCtrl.paging.current = 0;
    };

    contractsCtrl.init = function () {
      contractsCtrl.initFilter();
      contractsCtrl.initPaging();
      contractsCtrl.showFilter = userSettingsService.loadProperty("contracts", "grid", "showFilter") || false
    };

    contractsCtrl.turnShowFilter = function () {
      contractsCtrl.showFilter = !contractsCtrl.showFilter;
      userSettingsService.saveProperty("contracts", "grid", "showFilter", contractsCtrl.showFilter);
      if(!contractsCtrl.showFilter){
        contractsCtrl.cleanFilter();
      }
    };

    contractsCtrl.init();

    contractsCtrl.showFilterPopup = function () {
      contractsCtrl.popupFilter = $.extend(true, {}, contractsCtrl.filter)
    };

    // запросы и преобразования для получения информации для фильтров
    contractsCtrl.typesArr = [];
    contractsCtrl.types = types;
    angular.forEach(contractsCtrl.types, function(type){
      contractsCtrl.typesArr.push({value: type.code, label: type.name});
    });
    contractsCtrl.companiesArr = [];
    companyService.companies({limit:100}).then(function (res) {
      angular.forEach(res.data.items, function(company){
        contractsCtrl.companiesArr.push({value: company.id, label: company.name});
      });
    });
    contractsCtrl.counterpartiesArr = [];
    contragentService.counterparties({limit:100}).then(function (res) {
      angular.forEach(res.data.items, function(counterparty){
        contractsCtrl.counterpartiesArr.push({value: counterparty.id, label: counterparty.name});
      });
    });
    contractsCtrl.status = [{value: 'true', label: 'Действующий'},
                            {value: 'false', label: 'Не действующий'}];

    contractsCtrl.configScrollFilter = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      setHeight: 186,
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      scrollInertia: 0
    };

    $scope.columnVisibilityChanged = function(){
      var columnsProperty = contractsCtrl.gridApi.grid.options.columnDefs;
      angular.forEach(columnsProperty, function(column){
        if(column.filter) delete column.filter.selectOptions;
      });
      userSettingsService.saveProperty("contracts", "grid", "columnsProperty", columnsProperty)
    };

    /* настройки грида по умолчанию ($scope - обязательно) */
    $scope.defaultColumns = [
      { name: 'selection', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 64},
      { name: 'number', displayName:'Номер', visible: true, enableFiltering: false, sort: {
        direction: 'asc',
        priority: 0
      }, width: "20%", enableSorting: true, cellTemplate:"textTemplate.html"},
      { name: 'organization_name', displayName:'Компания', visible: true, width: "*", filterName: 'company_id', cellTemplate:"textTemplate.html", filterHeaderTemplate: 'recs/select-filter-template.html',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: contractsCtrl.companiesArr
        }
      },
      { name: 'counterparty_name', displayName:'Контрагент', visible: true, width: "*", filterName: 'counterparty_id', cellTemplate:"textTemplate.html", filterHeaderTemplate: 'recs/select-filter-template.html',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: contractsCtrl.counterpartiesArr
        }
      },
      { name: 'contract_type', displayName: 'Тип', visible: true, filterName: 'type', cellTemplate: '<cell-with-tooltip text="row.entity.contract_type | contractType" cell-row="row" cell-col="col"></cell-with-tooltip>', filterHeaderTemplate: 'recs/select-filter-template.html',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: contractsCtrl.typesArr
        }
      },
      /* Преобразование временной зоны не требуется для даты */
      { name: 'date', displayName:'Дата', visible: true, enableSorting: true, enableFiltering: false, type: 'date', cellFilter: 'date:\'dd.MM.yyyy\'',cellTemplate:'textDateTemplate.html'},
      { name: 'active', displayName: 'Статус', visible: true, filterName: 'active', cellTemplate: 'statusTemplate.html', width: 100, filterHeaderTemplate: 'recs/select-filter-template.html',
        filter: {
          type: uiGridConstants.filter.SELECT,
          selectOptions: contractsCtrl.status
        }
      },
      { name: 'project.name', displayName:'Проект', enableFiltering: false, visible: false, cellTemplate:"textTemplate.html"},
      { name: 'amount', displayName:'Сумма', enableFiltering: false, visible: false, enableSorting: true, type : 'number', cellTemplate:"amountTemplate.html"},
      { name: 'currency', displayName:'Валюта', enableFiltering: false, visible: false, cellTemplate:"currencyTemplate.html"},
      { name: 'comment', displayName:'Комментарий', enableFiltering: false, visible: false, cellTemplate:"textTemplate.html"},
      { name: 'created_at', displayName:'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
      { name: 'created_by.name', displayName:'Кто создал',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
      { name: 'updated_at', displayName:'Дата обновления',cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
      { name: 'updated_by.name', displayName:'Кто обновил',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
      { name: 'redact', displayName: '', enableFiltering: false, visible: true, width: "95",enableHiding:false,
      cellTemplate: '<a ng-if="$root.hasRole(\'contract.write\')" ui-sref="contract.edit({contractId: row.entity.id, parent: \'money\'})"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>'},
      { name: 'marginRight', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 63}
    ];
    var columnsProperty = userSettingsService.loadProperty("contracts", "grid", "columnsProperty") || angular.copy($scope.defaultColumns);
    angular.forEach(columnsProperty, function(column){
      if(column.name == 'organization_name'){
        column.filter.selectOptions = contractsCtrl.companiesArr;
      }
      if(column.name == 'counterparty_name'){
        column.filter.selectOptions = contractsCtrl.counterpartiesArr;
      }
      if(column.name == 'contract_type'){
        column.filter.selectOptions = contractsCtrl.typesArr;
      }
      if(column.name == 'active'){
        column.filter.selectOptions = contractsCtrl.status;
      }
    });

    // Настройка табличного представления
    contractsCtrl.gridOptions = {
      enableSorting: false,
      useExternalSorting: true,
      useExternalFiltering: true,
      minWidth: 50,
      maxWidth: 9000,
      enableGridMenu: true,
      gridMenuTemplate: '<grid-menu></grid-menu>',
      enableRowHeaderSelection: true,
      showColumnFooter: true,
      rowTemplate: '<div ng-click="grid.appScope.goToView(row.entity.id);">' +
                    ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
                   '</div>',
      // Фильтры на колонках грида
      enableFiltering: true,
      columnDefs: columnsProperty,
      data: []
    };
    contractsCtrl.gridOptions.columnDefs.filter(function (colDef) {
      return colDef.name == contractsCtrl.paging.sortBy
    }).forEach(function (colDef) {
      colDef.sort = {
        direction: contractsCtrl.paging.sortDirection,
        priority: 0
      }
    });

    contractsCtrl.gridOptions.onRegisterApi = function (gridApi) {
      contractsCtrl.gridApi = gridApi;
      contractsCtrl.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (sortColumns.length == 0) {
          contractsCtrl.paging.sortBy = null;
          contractsCtrl.paging.sortDirection = null;
        } else {
          contractsCtrl.paging.sortBy = sortColumns[0].field;
          contractsCtrl.paging.sortDirection = sortColumns[0].sort.direction;
        }
        contractsCtrl.getPage();
      });
      gridApi.core.on.filterChanged($scope, function () {
        gridApi.grid.columns.filter(function (column) {
          return column.enableFiltering && column.visible !== false;
        }).forEach(function (column) {
          contractsCtrl.filter[column.colDef.filterName || column.name] = column.filters[0].term;
        });
        contractsCtrl.paging.offset = 0;
        contractsCtrl.updateFilter(contractsCtrl.filter)
        contractsCtrl.getPageThrottle();
      });
      gridApi.grid.registerColumnBuilder(contractsCtrl.updateColumnFilter)
    }.bind(this);

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    contractsCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        contractsCtrl.crudState.error = false;
        contractsCtrl.crudState.message = '';
        contractsCtrl.crudState.loading = true;
      },
      stopLoadingSuccess: function() {
        contractsCtrl.crudState.error = false;
        contractsCtrl.crudState.message = '';
        contractsCtrl.crudState.loading = false;
      },
      stopLoadingFailure: function(message) {
        contractsCtrl.crudState.error = true;
        contractsCtrl.crudState.message = message;
        contractsCtrl.crudState.loading = false;
      }
    }

    // Поиск
    contractsCtrl.search = function () {
      // Сброс текущей страницы и поиск
      contractsCtrl.paging.current = 0;
      contractsCtrl.paging.offset = 0;
      contractsCtrl.getPage();
    }

    contractsCtrl.showSaveFilterPopup = function(){
      $uibModal.open({
        templateUrl: 'app/settings/components/filters/modals/saveFilter/save-filter.html',
        size: 'middle-width',
        controller: function($scope, $uibModalInstance){
          $scope.filterName = '';
          $scope.filterObj = contractsCtrl.gridFilter;

          $scope.save = function () {
            if ($scope.saveFilterForm.$valid) {
              contractsCtrl.saveFilter($scope.filterName);
            }
            $uibModalInstance.dismiss();
          }

          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      })
    };

    /**
     * Метод делает отложенный вызов с приоритетом последнего для устранения дублей при реакции на события.
     */
    contractsCtrl.getPageThrottle = function () {
      if (contractsCtrl.pageTimer) {
        $timeout.cancel( contractsCtrl.pageTimer );
      }
      contractsCtrl.pageTimer = $timeout(function () {

        return contractsCtrl.getPage.apply(contractsCtrl, arguments);
      }, TIMEOUT_THROTTLE);
    };

    $scope.$on("$destroy", function (event) {
      if (angular.isDefined($scope.pageTimer)) {
        $timeout.cancel($scope.pageTimer);
      }
    });

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    contractsCtrl.getPage = function () {
      contractsCtrl.noData = contractsCtrl.loadData = false;
      contractsCtrl.crudState.startLoading();
      userSettingsService.saveProperty("contracts", "grid", "paging", contractsCtrl.paging); // Настройки paging сохраняются при оюбом обновлении страницы (фильтры и остальное, в своих обработчиках)

      contractService.contracts(contractsCtrl.paging, contractsCtrl.searchText, contractsCtrl.filter).then(
        function (data) {
          if(!data.data.items.length && !contractsCtrl.searchText && _.isEmpty(contractsCtrl.filter)){
            contractsCtrl.noData = true;
          }
          contractsCtrl.contracts = data.data.items;
          contractsCtrl.paging.total = data.data.total;
          contractsCtrl.paging.current = data.data.offset / contractsCtrl.paging.limit;
          // Ссылка в grid
          contractsCtrl.gridOptions.data = contractsCtrl.contracts;
          contractsCtrl.crudState.stopLoadingSuccess();
          contractsCtrl.loadData = true;
        },
        function (error) {
          contractsCtrl.contracts = [];
          contractsCtrl.paging.total = 0;
          contractsCtrl.crudState.stopLoadingFailure(error);
        }
      )
    }
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    contractsCtrl.getPage();


    /* Автодополнение компаний */
    contractsCtrl.refreshCompanies = function(search) {
      companyService.companiesSearch(search)
        .then(function (data) {
          contractsCtrl.companies = data.data.items;
        });
    }
    contractsCtrl.refreshCompanies();

    /* Автодополнение контрагентов */
    contractsCtrl.refreshContragents = function(search) {
      contragentService.counterpartiesSearch(search)
        .then(function (data) {
          contractsCtrl.contragents = data.data.items;
        });
    }
    contractsCtrl.refreshContragents();

    filterSettingsService.filterContract().then(function(res){
      contractsCtrl.filterMeta = res.data.items;
      contractsCtrl.filterMeta[0].selectVal = contractsCtrl.typesArr;
      contractsCtrl.filterMeta[1].selectVal = contractsCtrl.status;
      contractsCtrl.filterMeta[2].selectVal = contractsCtrl.companiesArr;
      contractsCtrl.filterMeta[3].selectVal = contractsCtrl.counterpartiesArr;
    });

  }

})();

/**
 * Created by aivanov on 24.05.2017.
 */
(function() {
  'use strict';

  angular.module('frontend').service('companyService', companyService);

  /**
   * Сервис для работы с АПИ компаний
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function companyService($http, API_URL, $rootScope) {

    /* Загрузка списка подразделений (домен определяется по сессии) */
    this.divisions = function (paging, searchText, filter, filter_only_with_codes, notAllPermissions) {
      paging = paging || {};
      var data = {
        params: {
          limit: paging.limit || 5,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection,
          search_string: searchText,
          avoid_data_access_rules: !notAllPermissions,
          filter_only_with_codes: filter_only_with_codes
        }
      }
      if(filter){
        Object.keys(filter).forEach(function (key) {
          if (!!filter[key]) {
            if(key !== "search_string"){
              data.params["filter_" + key] = filter[key];
            } else {
              data.params[key] = filter[key];
            }
          }
        });
      }
      return $http.get(API_URL + '/companies/domain/divisions', data);
    }

    /* Загрузка списка компаний */
    this.companies = function (paging, searchText) {
      return $http.get(API_URL + '/companies', {
        params: {
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          search_string: searchText,
          avoid_data_access_rules: !!($rootScope.permission.roles.indexOf('admin') + 1)
        }
      });
    };

    // TODO: соглашусь, что такие метод лучше пределывать на объекты с картой свойств,
    // чтобы при появлении новго параметра не пришлось вносить исправления по всему коду
    this.companiesSearch = function (searchText,
                                     limit,
                                     expand,
                                     avoidDataAccessRules, // игнорируется, т.к. всегда true, но нужен для работы uiSelectStructure
                                     fsrarId,
                                     filter_only_with_codes) {
      return $http.get(API_URL + '/companies/auto', {
        params: {
          limit: limit || 100,
          search_string: searchText,
          avoid_data_access_rules: !!($rootScope.permission.roles.indexOf('admin') + 1),
          expand: expand,
          fsrar: fsrarId,
          filter_only_with_codes: filter_only_with_codes
        }
      });
    };

    /* Загрузка расширенной информации о компании */
    this.company = function (companyId) {
      return $http.get(API_URL + '/companies/' + companyId);
    }

    /* Создание новой компании */
    this.createcompany = function (company) {
      return $http.post(API_URL + '/companies/', company, {
        params: {
          avoid_data_access_rules: true
        }
      });
    }

    /* Обновление информации о компании */
    this.updatecompany = function (company) {
      return $http.put(API_URL + '/companies/' + company.id, company, {
        params: {
          avoid_data_access_rules: true
        }
      });
    }

    /* Удаление компании */
    this.deletecompany = function (companyId) {
      return $http.delete(API_URL + '/companies/' + companyId, {
        params: {
          avoid_data_access_rules: true
        }
      });
    }

    /* Загрузка информации о подразделении */
    this.division = function (companyId, divisionId) {
      return $http.get(API_URL + '/companies/' + companyId  + '/divisions/' + divisionId, {
        params: {
          avoid_data_access_rules: true
        }
      });
    }

    /* Загрузка информации о подразделениях одной компании */
    this.companyDivisions = function (companyId) {
      return $http.get(API_URL + '/companies/' + companyId  + '/divisions', {
        params: {
          avoid_data_access_rules: true
        }
      });
    }

    /* Загрузка информации о подразделениях одной компании (без лишних полей, к сожалению, фильтрация полей пока тольок на UI) */
    this.companyDivisionsLight = function (companyId, fsrarId) {
      return $http.get(API_URL + '/companies/' + companyId  + '/divisions', {
        params: {
          fsrar: fsrarId
        }
      }).then(function (data) {
        var res = [];
        angular.forEach(data.data, function (item) {
          res.push({
            id: item.id,
            name: item.name
          });
        });
        data.data = res;
        return data;
      });
    };

    /* Создание подразделения (TODO: есть некоторая избыточность в идентификаторе компании) */
    this.createDivision = function (division, companyId) {
      return $http.post(API_URL + '/companies/' + companyId + '/divisions/', division, {
        params: {
          avoid_data_access_rules: true
        }
      });
    };

    /* Обновление информации о подразделении */
    this.updateDivision = function (division, companyId) {
      var divisionId = division.id;
      return $http.put(API_URL + '/companies/' + companyId + '/divisions/' + divisionId, division, {
        params: {
          avoid_data_access_rules: true
        }
      });
    };

    /* Удаление подразделения */
    this.deleteDivision = function (companyId, divisionId) {
      return $http.delete(API_URL + '/companies/' + companyId  + '/divisions/' + divisionId, {
        params: {
          avoid_data_access_rules: true
        }
      });
    };

    /* Возвращает список счетов компании */
    this.getAccounts = function (companyId) {
      return $http.get(API_URL + '/companies/' + companyId  + '/accounts');
    }

    this.okvedCheck = function (searchString, limit) {
      return $http.get(API_URL + '/utils/okved_check', {
        params: {
          search_string: searchString,
          limit: limit
        }
      })
    }


    this.sendInvitation = function (invitation) {
      return $http.post(API_URL + '/invitations', invitation);
    }

    this.getLegalRequisitesFieldMap = function () {
      return $http.get('assets/api/legalRequisitesFieldMap.json');
    }

    /* Загрузка расширенной информации о компании */
    this.getCompaniesByDomain = function (domain) {
      return $http.get(API_URL + '/companies/domain/' + domain, {
        params: {
          limit: 100
        }
      });
    }

    /* Запрос подразделений */
    this.getDivisionsExtended = function (params) {
      return $http.get(API_URL + '/companies/domain/divisions/extended', {
        params: {
          limit: 100
        }
      });
    }

  }

})();

(function() {
  'use strict';

  /*eslint angular/controller-as-vm: [2,"companyCtrl"]*/
  angular.module('frontend').controller('companiesController', companiesController);

  function companiesController($scope, $state, auth, companyService) {
    var companyCtrl = this;

    // Структура для управления paging-ом
    companyCtrl.paging = {
      current: 0,
      limit: 5,
      offset: 0,
      sortBy: undefined,
      total: undefined
    }

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    companyCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function() {
        companyCtrl.crudState.error = false;
        companyCtrl.crudState.message = '';
        companyCtrl.crudState.loading = true;
      },
      stopLoadingSuccess: function() {
        companyCtrl.crudState.error = false;
        companyCtrl.crudState.message = '';
        companyCtrl.crudState.loading = false;
      },
      stopLoadingFailure: function(message) {
        companyCtrl.crudState.error = true;
        companyCtrl.crudState.message = message;
        companyCtrl.crudState.loading = false;
      }
    }

    // Поиск
    companyCtrl.search = function () {
      // Сброс текущей страницы и поиск
      companyCtrl.paging.current = 0;
      companyCtrl.paging.offset = 0;
      companyCtrl.getPage();
    }

    // Функция обновления страницы, вызывается при изменениях фильтров и пейджинге
    companyCtrl.getPage = function () {
      companyCtrl.noData = companyCtrl.loadData = false;
      companyCtrl.crudState.startLoading();
      companyService.companies(companyCtrl.paging, companyCtrl.searchText).then(
        function (data) {
          if(!data.data.items.length && !companyCtrl.searchText){
            companyCtrl.noData = true;
          }
          companyCtrl.companies = data.data.items;
          companyCtrl.paging.total = data.data.total;
          companyCtrl.crudState.stopLoadingSuccess();
          companyCtrl.loadData = true;
        },
        function (error) {
          companyCtrl.companies = [];
          companyCtrl.crudState.stopLoadingFailure(error);
        }
      )
    }
    // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
    companyCtrl.getPage();
  }

})();

(function () {
  'use strict';

  angular.module('frontend').service('cashregisterShiftsService', CashregisterShiftsService);

  /** @ngInject */
  function CashregisterShiftsService(companyService,
                                     employeesService,
                                     cashRegistersPlacesSrv,
                                     $http,
                                     API_URL) {
    /* Получить смены */
    this.cashregisterShifts = function (data) {
      var data = data || {};
      return $http.get(API_URL + '/retail/cashregister_shifts', {
        params: {
          filter_start_date_from: data.filter_start_date_from,
          filter_start_date_to: data.filter_start_date_to,
          limit: data.limit,
          offset: data.offset,
          sort_by: data.sortBy,
          sort_order: data.sortDirection
        }
      });
    };


    this.companies = function (paging, searchText) {
      return companyService.companies({
        current: 0,
        limit: 100,
        offset: 0,
        sortBy: 'name',
        total: undefined
      }, searchText).then(function (results) {
        return results.data.items || [];
      });
    };

    this.divisions = function () {
      return companyService.divisions({
        current: 0,
        limit: 100,
        offset: 0,
        sortBy: 'company.name',
        total: undefined
      }, '', undefined).then(function (results) {
        return results.data.items || [];
      });
    };

    // необходимо будет позже, для автокомплита по кассовым местам
    // this.cashRegisterPlaces = function () {
    //   return cashRegistersPlacesSrv.getAllPlaces(100).then(function (results) {
    //     return results.data.items || [];
    //   });
    // };

    this.employees = function () {
      return employeesService.usersAuto().then(function (results) {
        return results.data.items || [];
      });
    };

    this.cashRegisters = function () {
      return cashRegistersPlacesSrv.getAllCashRegister().then(function (results) {
        return results.data.items || [];
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('CashregisterShiftsController', CashregisterShiftsController);

  /** @ngInject */
  function CashregisterShiftsController($state, $scope,
                                        $stateParams,
                                        userSettingsService,
                                        uiGridConstants,
                                        filterSettingsService,
                                        cashregisterShiftsColumnDefsService,
                                        API_URL,
                                        divisions,
                                        companies,
                                        employees) {
    var self = this;
    self.url = API_URL + '/retail/cashregister_shifts';
    self.page = 'cashregister-shifts';
    self.header = 'Смены';
    self.noDataStr = 'У вас пока нет ни одного документа \"Смена\"';
    self.sort = 'start_date';
    self.startPage = $stateParams.page - 1, // возврат на конкретную страницу (отображаемая в строке браузера - пользовательская, внутренняя - с 0)
    self.limit = 25;
    self.columnDefs = userSettingsService.loadProperty($scope.page, 'grid', 'columnsProperty') ||
      cashregisterShiftsColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    self.usingService = cashregisterShiftsColumnDefsService;
    self.filterMeta = {};
    self.params = $stateParams;

    self.rowRouteFunc = function (data, paging) {
      $state.go('cashregshift.view', {parent: 'retail', id: data.id, backPage: paging.current + 1});
    };

    // Get data for selects
    if(companies){
      this.companiesSelect = [];
      self.companiesPopup = companies;
      companies.forEach(function (item) {
        self.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = self.companiesSelect;
        }
      });
    }

    if(divisions){
      this.divisionsSelect = [];
      self.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        self.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = self.divisionsSelect;
        }
      });
    }

    if(employees){
      this.employeeListSelect = [];
      self.employeeListPopup = employees;
      employees.forEach(function (item) {
        self.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.started_by.name' || column.name === 'dataValue.ended_by.name') {
          column.filter.selectOptions = self.employeeListSelect;
        }
      });
    }
    // -- End Get data for selects

    filterSettingsService.filterCashregistesShifts().then(function (res) {
      self.filterMeta = res.data.items;
      self.filterMeta[0].selectVal = self.companiesSelect;
      self.filterMeta[1].selectVal = self.divisionsSelect;
      self.filterMeta[2].selectVal = self.cashRegisterPlacesSelect;
      self.filterMeta[4].selectVal = self.employeeListSelect;
      self.filterMeta[6].selectVal = self.employeeListSelect;
    });
  }
})();

(function() {
  'use strict';

  angular.module('frontend').service('cashregisterShiftsColumnDefsService', cashregisterShiftsColumnDefsService);

  /** @ngInject */
  function cashregisterShiftsColumnDefsService(userSettingsService) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ? \'ascending\' :' +
      ' ( col.sort.direction == desc ? \'descending\' :' +
      ' (!col.sort.direction ? \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\':' +
      ' col.sort.direction == asc, \'ui-grid-icon-down-dir\':' +
      ' col.sort.direction == desc, \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [ 64, 100, 160, 160, 160, 160, 200, 160, 100, 200, 200, 200, 200, 200, 200, 200,
      200, 200, 100, 100, 100, 100, 200, 200, 200, 200, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function() {
      var income = userSettingsService.loadProperty('cashregister-shifts', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('cashregister-shifts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function(columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('cashregister-shifts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function(uiGridConstants) {

      self.totals = this.ctrl;

      return [
        {
          __index           : 0,
          name              : 'selection',
          field             : 'option',
          displayName       : '',
          enableColumnMenu  : false,
          enableHiding      : false,
          enableFiltering   : false,
          visible           : true,
          width             : 64,
          headerCellTemplate: '<div class="save-filter-star" ' +
          'ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
          '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
          '  ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
          '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
          '    </div>'
        },
        {
          __index         : 1,
          name            : 'dataValue.number',
          enableSorting   : true,
          sortName        : 'number',
          displayName     : 'Номер',
          headerCellClass : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass       : 'ui-custom-cell-text-align-to-left',
          headerCellTemplate    : headerTemplate,
          cellTemplate    : '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering     : false,
          minWidth            : 60,
          width               : columnsDefinedWidth[1],
          footerCellTemplate  : '<div class="ui-grid-bottom-panel">Итого</div>',
          visible       : true,
          pinned: true
        },
        {
          __index               : 2,
          name                  : 'dataValue.start_date',
          enableSorting         : true,
          sortName              : 'start_date',
          displayName           : 'Дата открытия',
          headerCellTemplate    : headerTemplate,
          backButton            : true,
          filterName            : 'when_opened2',
          minWidth              : 60,
          filterHeaderTemplate  : '<cell-date-picker-filter col="col" name="when_opened2" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible               : true,
          cellFilter            : 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[2],
          headerCellClass     : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-left',
          pinned: true
        },
        {
          __index               : 3,
          name                  : 'dataValue.company.name',
          sortName              : 'company_id',
          displayName           : 'Компания',
          minWidth              : 60,
          cellClass             : 'ui-custom-cell-text-align-to-left',
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate    : headerTemplate,
          filterName            : 'company_id',
          filterHeaderTemplate  : '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type          : uiGridConstants.filter.SELECT,
            selectOptions : this.companiesSelect
          },
          visible : false,
          width   : columnsDefinedWidth[3]
        },
        {
          __index       : 4,
          name          : 'dataValue.division.name',
          sortName      : 'division',
          displayName   : 'Подразделение',
          visible       : true,
          minWidth      : 60,
          headerCellClass       : 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate    : headerTemplate,
          cellClass             : 'ui-custom-cell-text-align-to-left',
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD"/>',
          filterName            : 'division_id',
          filterHeaderTemplate  : '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type          : uiGridConstants.filter.SELECT,
            selectOptions : this.divisionsSelect
          },
          width : columnsDefinedWidth[4]
        },
        {
          __index       : 5,
          name          : 'dataValue.place.name',
          sortName      : 'cashier_place',
          displayName   : 'Кассовое место',
          minWidth      : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate  : headerTemplate,
          cellClass           : 'ui-custom-cell-text-align-to-left',
          cellTemplate        : '<cell-with-tooltip text="COL_FIELD"/>',
          filterName            : 'cash_register_place_name',
          filterHeaderTemplate  : '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
            '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          width : columnsDefinedWidth[5],
          visible       : true
        },
        {
          __index       : 6,
          name          : 'dataValue.started_by.name',
          sortName      : 'started_by_id',
          displayName   : 'Открыл сотрудник',
          cellTemplate  : '<cell-with-tooltip text="COL_FIELD"/>',
          filterName    : 'started_by_id',
          minWidth      : 60,
          filterHeaderTemplate  : '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.employeeListSelect
          },
          width: columnsDefinedWidth[6],
          headerCellClass     : 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate  : headerTemplate,
          cellClass           : 'ui-custom-cell-text-align-to-left',
          visible       : true
        },
        {
          __index               : 7,
          name                  : 'dataValue.end_date',
          enableSorting         : true,
          sortName              : 'end_date',
          displayName           : 'Дата закрытия',
          filterName            : 'end_date',
          minWidth              : 60,
          headerCellTemplate    : headerTemplate,
          filterHeaderTemplate  : '<cell-date-picker-filter col="col" name="end_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate          : '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible               : true,
          cellFilter            : 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[7],
          headerCellClass     : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-left'
        },
        {
          __index           : 8,
          name          : 'dataValue.ended_by.name',
          sortName      : 'ended_by_id',
          displayName   : 'Закрыл сотрудник',
          cellTemplate  : '<cell-with-tooltip text="COL_FIELD"/>',
          filterName    : 'ended_by_id',
          minWidth      : 60,
          filterHeaderTemplate  : '<cell-select-filter col="col"></cell-select-filter>',
          headerCellTemplate    : headerTemplate,
          filter: {
            type          : uiGridConstants.filter.SELECT,
            selectOptions : this.employeeListSelect
          },
          width: columnsDefinedWidth[8],
          headerCellClass     : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-left',
          visible       : false
        },
        {
          __index         : 9,
          name            : 'dataValue.duration',
          sortName        : 'continued',
          displayName     : 'Продолжительность',
          enableFiltering : false,
          minWidth        : 60,
          cellTemplate    : '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\'"/>',
          headerCellTemplate: headerTemplate,
          visible         : false,
          width           : columnsDefinedWidth[9],
          headerCellClass : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass       : 'ui-custom-cell-text-align-to-left'
        },
        {
          __index         : 10,
          name            : 'dataValue.extNumber',
          displayName     : 'Аппаратный номер смены',
          enableFiltering : false,
          minWidth        : 60,
          cellTemplate  : '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          visible         : false,
          width           : columnsDefinedWidth[10],
          headerCellClass : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass       : 'ui-custom-cell-text-align-to-left'
        },
        {
          __index         : 11,
          name            : 'dataValue.extStartDate',
          displayName     : 'Аппаратная дата открытия',
          enableFiltering : false,
          minWidth        : 60,
          cellTemplate    : '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\'"/>',
          headerCellTemplate: headerTemplate,
          visible         : false,
          width           : columnsDefinedWidth[11],
          headerCellClass : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass       : 'ui-custom-cell-text-align-to-left'
        },
        {
          __index         : 12,
          name            : 'dataValue.extEndDate',
          displayName     : 'Аппаратная дата закрытия',
          enableFiltering : false,
          minWidth        : 60,
          cellTemplate    : '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\'"/>',
          headerCellTemplate: headerTemplate,
          visible         : false,
          width           : columnsDefinedWidth[12],
          headerCellClass : 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass       : 'ui-custom-cell-text-align-to-left'
        },
        {
          __index           : 13,
          name              : 'dataValue.z_home_start_cash',
          sortName          : 'zHomeStartCash',
          enableFiltering   : false,
          minWidth          : 60,
          displayName       : 'ККМ Z: Наличных на&nbsp;начало',
          enableColumnMenu  : false,
          headerCellTemplate: headerTemplate,
          headerCellClass   : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass         : 'ui-custom-cell-text-align-to-right',
          cellTemplate      : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible           : false,
          width: columnsDefinedWidth[13]
        },
        {
          __index           : 14,
          name              : 'dataValue.z_cash_amounts.home_sales_for_cash',
          sortName          : 'zHomeSalesForCash',
          enableFiltering   : false,
          displayName       : 'ККМ Z: Продажи&nbsp;наличные',
          headerCellTemplate: headerTemplate,
          enableColumnMenu  : false,
          headerCellClass   : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass         : 'ui-custom-cell-text-align-to-right',
          cellTemplate      : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible           : false,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.z_amounts.home_sales_for_cash || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          minWidth: 60,
          width: columnsDefinedWidth[14]
        },
        {
          __index           : 15,
          name              : 'dataValue.z_cash_amounts.home_sales_for_non_cash',
          sortName          : 'zHomeSalesForNonCash',
          enableFiltering   : false,
          displayName       : 'ККМ Z: Продажи&nbsp;безналичные',
          headerCellTemplate: headerTemplate,
          enableColumnMenu  : false,
          headerCellClass   : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass         : 'ui-custom-cell-text-align-to-right',
          cellTemplate      : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible           : false,
          minWidth          : 60,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.z_amounts.home_sales_for_non_cash || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[15]
        },
        {
          __index           : 16,
          name              : 'dataValue.z_cash_amounts.home_cash_refunds',
          sortName          : 'zHomeCashRefunds',
          enableFiltering   : false,
          displayName       : 'ККМ Z: Возвраты&nbsp;наличные',
          headerCellTemplate: headerTemplate,
          enableColumnMenu  : false,
          minWidth          : 60,
          headerCellClass   : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass         : 'ui-custom-cell-text-align-to-right',
          cellTemplate      : '<cell-with-tooltip-money text="-COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible           : false,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="-grid.appScope.ctrl.totals.z_amounts.home_cash_refunds || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[16]
        },
        {
          __index           : 17,
          name              : 'dataValue.z_cash_amounts.home_non_cash_refunds',
          sortName          : 'zHomeCashRefunds',
          enableFiltering   : false,
          displayName       : 'ККМ Z: Возвраты&nbsp;безналичные',
          headerCellTemplate: headerTemplate,
          enableColumnMenu  : false,
          minWidth          : 60,
          headerCellClass   : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass         : 'ui-custom-cell-text-align-to-right',
          cellTemplate      : '<cell-with-tooltip-money text="-COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible           : false,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="-grid.appScope.ctrl.totals.z_amounts.home_non_cash_refunds || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[17]
        },
        {
          __index             : 18,
          name                : 'dataValue.z_cash_amounts.home_replenishments',
          sortName            : 'zHomeNonCashRefunds',
          enableFiltering     : false,
          displayName         : 'ККМ Z: Внесения',
          enableColumnMenu    : false,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate  : headerTemplate,
          minWidth            : 60,
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible             : false,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.z_amounts.home_replenishments || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[18]
        },
        {
          __index           : 19,
          name              : 'dataValue.z_cash_amounts.home_encashments',
          sortName          : 'zHomeEncashments',
          enableFiltering   : false,
          displayName       : 'ККМ Z: Выемки',
          enableColumnMenu  : false,
          minWidth          : 60,
          headerCellClass   : 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass         : 'ui-custom-cell-text-align-to-right',
          cellTemplate      : '<cell-with-tooltip-money text="-COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible           : false,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="-grid.appScope.ctrl.totals.z_amounts.home_encashments || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width             : columnsDefinedWidth[19]
        },
        {
          __index             : 20,
          name                : 'dataValue.z_home_end_cash',
          sortName            : 'zHomeEndCash',
          enableFiltering     : false,
          displayName         : 'ККМ Z: Наличных на&nbsp;конец',
          headerCellTemplate  : headerTemplate,
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible             : false,
          width               : columnsDefinedWidth[20]
        },
        {
          __index             : 21,
          name                : 'dataValue.cash_amounts.home_sales_for_cash',
          sortName            : 'homeSalesForCash',
          enableFiltering     : false,
          displayName         : 'Факт: Продажи&nbsp;наличные',
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate  : headerTemplate,
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          cellFilter          : 'my-filter',
          visible             : true,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.amounts.home_sales_for_cash || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[21]
        },
        {
          __index             : 22,
          name                : 'dataValue.cash_amounts.home_sales_for_non_cash',
          sortName            : 'homeSalesForNonCash',
          enableFiltering     : false,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-right',
          displayName         : 'Факт: Продажи&nbsp;безналичные',
          headerCellTemplate  : headerTemplate,
          enableColumnMenu    : false,
          minWidth            : 60,
          cellTemplate        : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible             : true,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.amounts.home_sales_for_non_cash || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[22]
        },
        {
          __index             : 23,
          name                : 'dataValue.cash_amounts.home_cash_refunds',
          sortName            : 'homeCashRefunds',
          enableFiltering     : false,
          displayName         : 'Факт: Возвраты&nbsp;наличные',
          headerCellTemplate  : headerTemplate,
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip-money text="COL_FIELD && -COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible             : true,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="-grid.appScope.ctrl.totals.amounts.home_cash_refunds || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[23]
        },
        {
          __index           : 24,
          name              : 'dataValue.cash_amounts.home_non_cash_refunds',
          sortName          : 'homeNonCashRefunds',
          enableFiltering   : false,
          displayName       : 'Факт: Возвраты&nbsp;безналичные',
          headerCellTemplate: headerTemplate,
          enableColumnMenu  : false,
          minWidth          : 60,
          headerCellClass   : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass         : 'ui-custom-cell-text-align-to-right',
          cellTemplate      : '<cell-with-tooltip-money text="COL_FIELD && -COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible           : true,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="-grid.appScope.ctrl.totals.amounts.home_non_cash_refunds || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width             : columnsDefinedWidth[24]
        },
        {
          __index             : 25,
          name                : 'dataValue.cash_amounts.home_replenishments',
          sortName            : 'homeReplenishments',
          enableFiltering     : false,
          displayName         : 'Факт: Внесения',
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate  : headerTemplate,
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible             : false,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="grid.appScope.ctrl.totals.amounts.home_replenishments || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[25]
        },
        {
          __index             : 26,
          name                : 'dataValue.cash_amounts.home_encashments',
          sortName            : 'homeEncashments',
          enableFiltering     : false,
          displayName         : 'Факт: Выемки',
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate  : headerTemplate,
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip-money text="COL_FIELD && -COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible             : false,
          footerCellTemplate : '<cell-with-tooltip-money' +
          ' text="-grid.appScope.ctrl.totals.amounts.home_encashments || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[26]
        },
        {
          __index             : 27,
          name                : 'dataValue.number_of_sales',
          sortName            : 'numberOfSales',
          enableFiltering     : false,
          displayName         : 'Факт: Количество&nbsp;продаж',
          headerCellTemplate  : headerTemplate,
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip text="COL_FIELD"/>',
          visible             : false,
          footerCellTemplate  : '<div>{{grid.appScope.ctrl.totals.number_of_sales || 0 }}</div>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[27]
        },

        {
          __index             : 28,
          name                : 'dataValue.number_of_refunds',
          sortName            : 'numberOfRefunds',
          enableFiltering     : false,
          displayName         : 'Факт: Количество&nbsp;возвратов',
          headerCellTemplate  : headerTemplate,
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass           : 'ui-custom-cell-text-align-to-right',
          cellTemplate        : '<cell-with-tooltip text="COL_FIELD"/>',
          visible             : false,
          footerCellTemplate  : '<div>{{grid.appScope.ctrl.totals.number_of_refunds || 0 }}</div>',
          footerCellClass     : 'ui-custom-cell-text-align-to-right',
          width               : columnsDefinedWidth[28]
        },

        {
          __index             : 29,
          name                : 'dataValue.home_currency',
          sortName            : 'home_currency',
          enableFiltering     : false,
          displayName         : 'Валюта',
          enableColumnMenu    : false,
          minWidth            : 60,
          headerCellClass     : 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate  : headerTemplate,
          cellClass           : 'ui-custom-cell-text-align-to-left',
          cellTemplate        : '<cell-with-tooltip text="COL_FIELD.name"/>',
          visible             : false,
          width               : columnsDefinedWidth[29]
        },

        {
          __index           : 30,
          name              : 'option',
          field             : 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата открытия:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.started_by_id">\n' +
          '              <p style="margin-bottom: 0">Открыл сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.started_by.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.end_date">\n' +
          '              <p style="margin-bottom: 0">Дата закрытия:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.end_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.ended_by_id">\n' +
          '              <p style="margin-bottom: 0">Закрыл сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.ended_by.name")}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate      : '',
          displayName       : '',
          headerCellClass   : 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu  : false,
          enableHiding      : false,
          enableFiltering   : false,
          width             : 80,
          minWidth          : 50,
          enableColumnResizing : false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function () {
  'use strict';

  angular.module('frontend').service('cashregisterReceiptsService', CashregisterReceiptsService);

  /** @ngInject */
  function CashregisterReceiptsService(companyService,
                                       employeesService,
                                       cashRegistersPlacesSrv) {
    this.companies = function (paging, searchText) {
      return companyService.companies({
        current: 0,
        limit: 100,
        offset: 0,
        sortBy: 'name',
        total: undefined
      }, searchText).then(function (results) {
        return results.data.items || [];
      });
    };

    this.divisions = function () {
      return companyService.divisions({
        current: 0,
        limit: 100,
        offset: 0,
        sortBy: 'company.name',
        total: undefined
      }, '', undefined).then(function (results) {
        return results.data.items || [];
      });
    };

    // необходимо будет позже, для автокомплита по кассовым местам
    // this.cashRegisterPlaces = function () {
    //   return cashRegistersPlacesSrv.getAllPlaces(100).then(function (results) {
    //     return results.data.items || [];
    //   });
    // };

    this.employees = function () {
      return employeesService.usersAuto().then(function (results) {
        return results.data.items || [];
      });
    };

    this.cashRegisters = function () {
      return cashRegistersPlacesSrv.getAllCashRegister().then(function (results) {
        return results.data.items || [];
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('CashregisterReceiptsController', CashregisterReceiptsController);

  /** @ngInject */
  function CashregisterReceiptsController($state, userSettingsService,
                                          uiGridConstants,
                                          filterSettingsService,
                                          cashregisterReceiptsColumnDefsService,
                                          API_URL,
                                          companies,
                                          divisions,
                                          employees,
                                          cashRegisters,
                                          taxModes,
                                          $filter,
                                          $stateParams) {

    var self = this;
    self.url = API_URL + '/retail/documents/RETAIL_SALE';
    self.page = 'cashregister-receipts';
    self.header = 'Кассовые чеки';
    self.noDataStr = 'У вас пока нет ни одного документа \"Кассовый чек\"';
    self.sort = 'date';
    self.limit = 25;
    self.columnDefs = userSettingsService.loadProperty(self.page, 'grid', 'columnsProperty') ||
      cashregisterReceiptsColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    self.usingService = cashregisterReceiptsColumnDefsService;
    self.filterMeta = {};
    self.params = $stateParams;

    self.rowRouteFunc = function (data) {
      $state.go('cashregreceipt.view', {parent: 'retail', id: data.id});
    };

    // Get data for selects
    if(companies){
      this.companiesSelect = [];
      self.companiesPopup = companies;
      companies.forEach(function (item) {
        self.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = self.companiesSelect;
        }
      });
    }

    if(divisions){
      this.divisionsSelect = [];
      self.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        self.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = self.divisionsSelect;
        }
      });
    }

    if(employees){
      this.employeeListSelect = [];
      self.employeeListPopup = employees;
      employees.forEach(function (item) {
        self.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.user.name') {
          column.filter.selectOptions = self.employeeListSelect;
        }
      });
    }

    if (taxModes) {
      this.taxSelect = [];
      self.taxListPopup = taxModes;
      taxModes.forEach(function (item) {
        self.taxSelect.push({value: item, label: $filter('tax')(item)});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.tax_mode') {
          column.filter.selectOptions = self.taxSelect;
        }
      });
    }

    if(cashRegisters){
      this.cashRegistersListSelect = [];
      self.cashRegistersListPopup = cashRegisters;
      cashRegisters.forEach(function (item) {
        //<Производитель>-<Модель> №<Серийный номер>
        self.cashRegistersListSelect.push({value: item.id, label: item.manufacturer + ((item.model && item.model !== item.manufacturer)?' ' + item.model: '') + ((item.serial_number)?' №' + item.serial_number : '')});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.cash_register') {
          column.filter.selectOptions = self.cashRegistersListSelect;
        }
      });
    }
    // -- End Get data for selects

    filterSettingsService.filterCashregistesReceipts().then(function(res){
      self.filterMeta = res.data.items;
      self.filterMeta[4].selectVal = self.companiesSelect;
      self.filterMeta[5].selectVal = self.divisionsSelect;
      self.filterMeta[6].selectVal = self.cashRegisterPlacesSelect;
      self.filterMeta[7].selectVal = self.cashRegisterPlacesSelect;
      self.filterMeta[8].selectVal = self.employeeListSelect;
      self.filterMeta[9].selectVal = self.taxSelect;
    });
  }
})();


(function () {
  'use strict';

  angular.module('frontend').service('cashregisterReceiptsColumnDefsService', cashregisterReceiptsColumnDefsService);

  /** @ngInject */
  function cashregisterReceiptsColumnDefsService(userSettingsService, $rootScope) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' :' +
      ' ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="{{TOOLTIP}}">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName" title="{{col.colDef.headerTooltip}}">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [64, 100, 100, 160, 160, 160, 160, 200, 160, 100, 200, 200, 200, 200, 200, 200, 200, 200];

    self.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('cashregister-receipts', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('cashregister-receipts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    self.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('cashregister-receipts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    self.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          visible: true,
          headerCellTemplate: '<div class="save-filter-star"' +
          ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
          '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
          ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
          '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
          '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          enableSorting: false,
          sortName: 'status',
          displayName: 'Статус',
          headerCellClass: 'text-center no-wrap-header',
          cellClass: 'text-center',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<span class="tooltip-light ui-grid-cell-contents" tooltip-placement="right" uib-tooltip="{{row.entity.dataValue.status == \'PROCESSED\'? \'Проведен\' : (row.entity.dataValue.status == \'DRAFT\')? \'Черновик\' : \'В обработке\'}}" ng-bind-html="grid.appScope.ctrl.getStatus(row.entity) | documentStatus"></span>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: $rootScope.documentStatuses
          },
          minWidth: 60,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true,
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>',
        },
        {
          __index: 2,
          name: 'dataValue.number',
          enableSorting: true,
          sortName: 'number',
          displayName: 'Номер чека',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[2],
          visible: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.date',
          enableSorting: true,
          sortName: 'date',
          displayName: 'Дата чека',
          headerCellTemplate: headerTemplate,
          backButton: true,
          filterName: 'receipt_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="receipt_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate:  '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[3],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          pinned: true
        },
        {
          __index: 4,
          name: 'dataValue.shift_number',
          enableSorting: true,
          sortName: 'shift_number',
          displayName: 'Номер смены',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_number',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          visible: true,
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.shift_date',
          enableSorting: true,
          sortName: 'shift_date',
          displayName: 'Дата смены',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="shift_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate:  '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[5],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 6,
          name: 'dataValue.company.name',
          sortName: 'company',
          displayName: 'Компания',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.companiesSelect
          },
          width: columnsDefinedWidth[6],
          visible: false
        },
        {
          __index: 7,
          name: 'dataValue.division.name',
          sortName: 'division',
          displayName: 'Подразделение',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.divisionsSelect
          },
          width: columnsDefinedWidth[7],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          visible: true
        },
        {
          __index: 8,
          name: 'dataValue.user.name',
          sortName: 'user.name',
          enableFiltering: true,
          displayName: 'Сотрудник',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: false,
          width: columnsDefinedWidth[8],
          filterName: 'user_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.employeeListSelect
          }
        },
        {
          __index: 9,
          name: 'dataValue.cash_register',
          enableSorting: false,
          enableFiltering: true,
          displayName: 'Касса',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD.manufacturer + ((COL_FIELD.model && COL_FIELD.manufacturer !== COL_FIELD.model)?\' \' + COL_FIELD.model : \'\') + ((COL_FIELD.serial_num)? \' №\' + COL_FIELD.serial_num : \'\')"/>',
          visible: false,
          width: columnsDefinedWidth[9],
          filterName: 'cash_register_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.cashRegistersListSelect
          }
        },
        {
          __index: 10,
          name: 'dataValue.place.name',
          sortName: 'place',
          displayName: 'Кассовое место',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'cash_register_place_name',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          width: columnsDefinedWidth[10],
          visible: true
        },
        {
          __index: 11,
          name: 'dataValue.home_cash_amount',
          sortName: 'home_cash_amount',
          displayName: 'Сумма наличными',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          headerCellTemplate: headerTemplate,
          width: columnsDefinedWidth[11],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_cash_amount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: true
        },
        {
          __index: 12,
          name: 'dataValue.home_non_cash_amount',
          sortName: 'home_non_cash_amount',
          displayName: 'Сумма безналичными',
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          headerCellTemplate: headerTemplate,
          visible: true,
          width: columnsDefinedWidth[12],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_non_cash_amount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          cellClass: 'ui-custom-cell-text-align-to-right'
        },
        {
          __index: 13,
          name: 'dataValue.home_amount',
          sortName: 'home_amount',
          enableFiltering: false,
          displayName: 'Общая сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_amount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[13]
        },
        {
          __index: 14,
          name: 'dataValue.home_discount',
          sortName: 'home_discount',
          enableFiltering: false,
          displayName: 'Сумма скидки',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_discount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[14]
        },
        {
          __index: 15,
          name: 'dataValue.home_tax_amount',
          enableFiltering: false,
          displayName: 'Сумма налогов',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible: false,
          width: columnsDefinedWidth[15],
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_tax_amount || 0"\' +\n' +
          '          \' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right'
        },
        {
          __index: 16,
          name: 'dataValue.tax_mode',
          enableSorting: false,
          enableFiltering: true,
          displayName: 'СНО',
          headerTooltip: 'Система налогообложения',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<div class="ui-grid-cell-contents ellipsis"><span ng-bind="COL_FIELD | tax:true" uib-tooltip="{{COL_FIELD | tax}}" tooltip-placement="left"></span></div>',
          visible: false,
          width: columnsDefinedWidth[16],
          filterName: 'cashregister_tax_mode',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.cashRegistersListSelect
          }
        },
        {
          __index: 17,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.filter.receipt_date">\n' +
          '              <p style="margin-bottom: 0">Дата чека:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.receipt_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user_id">\n' +
          '              <p style="margin-bottom: 0">Сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user")}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80
        }
      ];
    };

    self.loadSavedDefinedColumnWidth();
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('cashboxReplenishmentsService', CashboxReplenishmentsService);

  /** @ngInject */
  function CashboxReplenishmentsService(companyService,
                                        employeesService) {


    this.companies = function (paging, searchText) {
      return companyService.companies({
        current: 0,
        limit: 100,
        offset: 0,
        sortBy: 'name',
        total: undefined
      }, searchText).then(function (results) {
        return results.data.items || [];
      });
    };

    this.divisions = function () {
      return companyService.divisions({
        current: 0,
        limit: 100,
        offset: 0,
        sortBy: 'company.name',
        total: undefined
      }, '', undefined).then(function (results) {
        return results.data.items || [];
      });
    };

    // необходимо будет позже, для автокомплита по кассовым местам
    // this.cashRegisterPlaces = function () {
    //   return cashRegistersPlacesSrv.getAllPlaces(100).then(function (results) {
    //     return results.data.items || [];
    //   });
    // };

    this.employees = function () {
      return employeesService.usersAuto().then(function (results) {
        return results.data.items || [];
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('CashboxReplenishmentsController', CashboxReplenishmentsController);

  /** @ngInject */
  function CashboxReplenishmentsController($state, userSettingsService,
                                           uiGridConstants,
                                           cashboxReplenishmentsColumnDefsService,
                                           filterSettingsService,
                                           API_URL,
                                           companies,
                                           divisions,
                                           employees,
                                           $stateParams) {

    var ctrl = this;
    ctrl.url = API_URL + '/retail/documents/CASHBOX_REPLENISHMENT';
    ctrl.page = 'cashbox-replenishments';
    ctrl.header = 'Внесения';
    ctrl.noDataStr = 'У вас пока нет ни одного документа \"Внесение\"';
    ctrl.sort = 'date';
    ctrl.limit = 25;
    ctrl.columnDefs = userSettingsService.loadProperty(ctrl.page, 'grid', 'columnsProperty') ||
      cashboxReplenishmentsColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    ctrl.usingService = cashboxReplenishmentsColumnDefsService;
    ctrl.filterMeta = {};
    ctrl.params = $stateParams;

    ctrl.rowRouteFunc = function (data) {
      $state.go('cashboxreplenishment.view', {parent: 'retail', id: data.id});
    };

    // Get data for selects
    if(companies){
      this.companiesSelect = [];
      ctrl.companiesPopup = companies;
      companies.forEach(function (item) {
        ctrl.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(ctrl.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = ctrl.companiesSelect;
        }
      });
    }

    if(divisions){
      this.divisionsSelect = [];
      ctrl.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        ctrl.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(ctrl.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = ctrl.divisionsSelect;
        }
      });
    }

    if(employees){
      this.employeeListSelect = [];
      ctrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        ctrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(ctrl.columnDefs, function (column) {
        if (column.name === 'dataValue.user.name' || column.name == 'dataValue.user.name') {
          column.filter.selectOptions = ctrl.employeeListSelect;
        }
      });
    }
    // -- End Get data for selects

    filterSettingsService.filterCashboxReplenishments().then(function(res){
      ctrl.filterMeta = res.data.items;
      ctrl.filterMeta[4].selectVal = ctrl.companiesSelect;
      ctrl.filterMeta[5].selectVal = ctrl.divisionsSelect;
      //ctrl.filterMeta[5].selectVal = ctrl.cashRegisterPlacesSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('cashboxReplenishmentsColumnDefsService', cashboxReplenishmentsColumnDefsService);

  /** @ngInject */
  function cashboxReplenishmentsColumnDefsService(userSettingsService, $rootScope) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\':' +
      ' col.sort.direction == asc, \'ui-grid-icon-down-dir\':' +
      ' col.sort.direction == desc, \'ui-grid-icon-blank\':' +
      ' !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [64, 100, 100, 160, 160, 160, 160, 200, 160, 100, 200, 200];


    self.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('cashbox-replenishments', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('cashbox-replenishments', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    self.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('cashbox-replenishments', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    self.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          visible: true,
          headerCellTemplate: '<div class="save-filter-star"' +
          ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
          '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
          ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
          '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
          '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          enableSorting: false,
          sortName: 'status',
          displayName: 'Статус',
          headerCellClass: 'text-center no-wrap-header',
          cellClass: 'text-center',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<span class="tooltip-light ui-grid-cell-contents" tooltip-placement="right" uib-tooltip="{{row.entity.dataValue.status == \'PROCESSED\'? \'Проведен\' : (row.entity.dataValue.status == \'DRAFT\')? \'Черновик\' : \'В обработке\'}}" ng-bind-html="grid.appScope.ctrl.getStatus(row.entity) | documentStatus"></span>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: $rootScope.documentStatuses
          },
          minWidth: 60,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true,
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>',
        },
        {
          __index: 2,
          name: 'dataValue.number',
          enableSorting: true,
          sortName: 'number',
          displayName: 'Номер внесения',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: true,
          filterName: 'number',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          width: columnsDefinedWidth[2],
          visible: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.date',
          enableSorting: true,
          sortName: 'date',
          displayName: 'Дата внесения',
          headerCellTemplate: headerTemplate,
          backButton: true,
          filterName: 'receipt_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="receipt_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[3],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          pinned: true
        },
        {
          __index: 4,
          name: 'dataValue.shift_number',
          enableSorting: true,
          sortName: 'shift_number',
          displayName: 'Номер смены',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_number',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          visible: true,
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.shift_date',
          enableSorting: true,
          sortName: 'shift_date',
          displayName: 'Дата смены',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="shift_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate:  '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[5],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 6,
          name: 'dataValue.division.name',
          sortName: 'division',
          displayName: 'Подразделение',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.divisionsSelect
          },
          width: columnsDefinedWidth[6],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          visible: true
        },
        {
          __index: 7,
          name: 'dataValue.place.name',
          sortName: 'place',
          displayName: 'Кассовое место',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'cash_register_place_name',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          width: columnsDefinedWidth[7],
          visible: true
        },
        {
          __index: 8,
          name: 'dataValue.home_amount',
          sortName: 'home_amount',
          displayName: 'Сумма',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          headerCellTemplate: headerTemplate,
          width: columnsDefinedWidth[8],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_amount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          visible: true
        },
        {
          __index: 9,
          name: 'dataValue.company.name',
          sortName: 'company',
          displayName: 'Компания',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.companiesSelect
          },
          width: columnsDefinedWidth[9],
          visible: false
        },
        {
          __index: 10,
          name: 'dataValue.user.name',
          sortName: 'user.name',
          enableFiltering: true,
          displayName: 'Кассир',
          headerCellTemplate: headerTemplate,
          enableColumnMenu: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: false,
          width: columnsDefinedWidth[10],
          filterName: 'user_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.employeeListSelect
          }
        },
        {
          __index: 11,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.filter.receipt_date">\n' +
          '              <p style="margin-bottom: 0">Дата чека:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.receipt_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user_id">\n' +
          '              <p style="margin-bottom: 0">Сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80
        }
      ];
    };

    self.loadSavedDefinedColumnWidth();
  }
})();

(function() {
  'use strict';

  angular.module('frontend').service('encashmentsService', EncashmentsService);

  /** @ngInject */
  function EncashmentsService(
    companyService,
    employeesService
  ) {

    this.companies = function(paging, searchText) {
      return companyService.companies({
        current:  0,
        limit:    100,
        offset:   0,
        sortBy:   'name',
        total:    undefined
      }, searchText).then(function(results) {
        return results.data.items || [];
      });
    };

    this.divisions = function() {
      return companyService.divisions({
        current:  0,
        limit:    100,
        offset:   0,
        sortBy:   'company.name',
        total:    undefined
      }, '', undefined).then(function(results) {
        return results.data.items || [];
      });
    };

    // необходимо будет позже, для автокомплита по кассовым местам
    // this.cashRegisterPlaces = function () {
    //   return cashRegistersPlacesSrv.getAllPlaces(100).then(function (results) {
    //     return results.data.items || [];
    //   });
    // };

    this.employees = function() {
      return employeesService.usersAuto().then(function(results) {
        return results.data.items || [];
      });
    };
  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('EncashmentsController', EncashmentsController);

  /** @ngInject */
  function EncashmentsController($state, userSettingsService,
                                 uiGridConstants,
                                 encashmentsColumnDefsService,
                                 filterSettingsService,
                                 API_URL,
                                 companies,
                                 divisions,
                                 employees,
                                 $stateParams) {

    var self = this;
    self.url = API_URL + '/retail/documents/CASHBOX_ENCASHMENT';
    self.page = 'cashbox-encashments';
    self.header = 'Выемки';
    self.noDataStr = 'У вас пока нет ни одного документа \"Выемка\"';
    self.sort = 'date';
    self.limit = 25;
    self.columnDefs = userSettingsService.loadProperty(self.page, 'grid', 'columnsProperty') ||
      encashmentsColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    self.usingService = encashmentsColumnDefsService;
    self.filterMeta = {};
    self.params = $stateParams;

    self.rowRouteFunc = function (data) {
      $state.go('encashment.view', {parent: 'retail', id: data.id});
    };

    // Get data for selects
    if(companies){
      this.companiesSelect = [];
      self.companiesPopup = companies;
      companies.forEach(function (item) {
        self.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = self.companiesSelect;
        }
      });
    }

    if(divisions){
      this.divisionsSelect = [];
      self.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        self.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = self.divisionsSelect;
        }
      });
    }

    if(employees){
      this.employeeListSelect = [];
      self.employeeListPopup = employees;
      employees.forEach(function (item) {
        self.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(self.columnDefs, function (column) {
        if (column.name === 'dataValue.user.name') {
          column.filter.selectOptions = self.employeeListSelect;
        }
      });
    }
    // -- End Get data for selects
    filterSettingsService.filterCashboxEncashments().then(function(res){
      self.filterMeta = res.data.items;
      self.filterMeta[4].selectVal = self.companiesSelect;
      self.filterMeta[5].selectVal = self.divisionsSelect;
      self.filterMeta[6].selectVal = self.cashRegisterPlacesSelect;
      self.filterMeta[7].selectVal = self.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('encashmentsColumnDefsService', EncashmentsColumnDefsService);

  /** @ngInject */
  function EncashmentsColumnDefsService(userSettingsService, $rootScope) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [64, 100, 100, 160, 160, 160, 160, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('cashbox-encashments', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('cashbox-encashments', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('cashbox-encashments', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          visible: true,
          headerCellTemplate: '<div class="save-filter-star"' +
          ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
          '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
          ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
          '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
          ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
          '    </div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          enableSorting: false,
          sortName: 'status',
          displayName: 'Статус',
          headerCellClass: 'text-center no-wrap-header',
          cellClass: 'text-center',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<span class="tooltip-light ui-grid-cell-contents" tooltip-placement="right" uib-tooltip="{{row.entity.dataValue.status == \'PROCESSED\'? \'Проведен\' : (row.entity.dataValue.status == \'DRAFT\')? \'Черновик\' : \'В обработке\'}}" ng-bind-html="grid.appScope.ctrl.getStatus(row.entity) | documentStatus"></span>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: $rootScope.documentStatuses
          },
          minWidth: 60,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true,
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>',
        },
        {
          __index: 2,
          name: 'dataValue.number',
          enableSorting: true,
          sortName: 'number',
          displayName: 'Номер выемки',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: true,
          filterName: 'number',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          minWidth: 60,
          width: columnsDefinedWidth[2],
          visible: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.date',
          enableSorting: true,
          sortName: 'date',
          displayName: 'Дата выемки',
          headerCellTemplate: headerTemplate,
          backButton: true,
          filterName: 'when_opened2',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="when_opened2" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[3],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          pinned: true
        },
        {
          __index: 4,
          name: 'dataValue.shift_number',
          enableSorting: true,
          sortName: 'shift_number',
          displayName: 'Номер смены',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_number',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          visible: true,
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.shift_date',
          enableSorting: true,
          sortName: 'shift_date',
          displayName: 'Дата смены',
          headerCellTemplate: headerTemplate,
          filterName: 'shift_date',
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="shift_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[5],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 6,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.companiesSelect
          },
          visible: false,
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.divisionsSelect
          },
          width: columnsDefinedWidth[7]
        },
        {
          __index: 8,
          name: 'dataValue.place.name',
          displayName: 'Кассовое место',
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'cash_register_place_name',
          filterHeaderTemplate: '<div class="select-wrap for-filter ui-grid-filter-container">\n' +
          '<input clear-button type="text"' +
          ' class="ui-grid-filter-input"' +
          ' ng-model="col.filters[0].term"' +
          ' placeholder="Поиск" >\n' +
          '</div>',
          width: columnsDefinedWidth[8],
          visible: true
        },
        {
          __index: 9,
          name: 'dataValue.home_amount',
          enableFiltering: false,
          displayName: 'Cумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="row.entity.dataValue.home_currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_amount || 0"' +
          ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[9]
        },
        {
          __index: 10,
          name: 'dataValue.user.name',
          displayName: 'Кассир',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'user_id',
          minWidth: 60,
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.employeeListSelect
          },
          width: columnsDefinedWidth[10],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          visible: false
        },
        {
          __index: 11,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('businessController', businessController);

  /** @ngInject */
  function businessController($scope,
                              $filter,
                              $rootScope,
                              companyService,
                              employeesService,
                              phoneConfirmationService,
                              utilsService,
                              errorMessageService,
                              requestStatus,
                              PHONE_ATTEMPTS,
                              $q) {
    var vm = this;
    vm.isTimerEnd = true;
    vm.phoneAttempts = PHONE_ATTEMPTS;
    vm.cashier = {
      enabled: true,
      roles: ["cashier"],
      data_access_rules: {has_access: false}
    };
    vm.companies = [];

    vm.getUserTotal = function () {
      if (!$rootScope.hasRole('user.read')) {
        return
      }
      employeesService.users({}).then(function (res) {
        vm.employeesTotal = res.data.total + '';
        if (vm.employeesTotal.substr(-1) < 2 || vm.employeesTotal.substr(-1) > 4) {
          vm.declension = true;
        }
      });
    };
    vm.getUserTotal();

    vm.resetPhone = function(){
      vm.addCashier.phone.$setValidity('unique', true);
      vm.addCashier.phone.$setValidity('phoneAttempts', true);
      vm.confirmCode = undefined;
      vm.phoneConfirmSended = false;
      vm.cashier.pending_phone_changes = null;
      vm.phoneAttempts = PHONE_ATTEMPTS;
    }

    /**
     * Метод для проверки статуса текущего телефонного номера
     */
    vm.isPhoneConfirmed = function () {
      return vm.cashier.phone_confirmed && vm.cashier.phone == vm.userBasePhone;
    };

    /**
     * Отправка запроса на создания кода подтверждения телефона
     */
    vm.sendPhoneConfirmRequest = function (resending) {
      vm.startTimer = new Date();
      $rootScope.stateChangeStart = true;
      phoneConfirmationService.sendPhoneConfirmationAnonymousCreate(vm.cashier.phone).then(function (data) {
        vm.phoneConfirmSended = true;
        // сохранение объекта подтверждения
        vm.cashier.phone_confirmation = data.data;
        vm.pendingPhone = vm.cashier.phone;
        $rootScope.stateChangeStart = false;
        if(!resending) {
          requestStatus.success("Сообщение отправлено на телефон: " + $filter('phoneFormat')(vm.pendingPhone));
        }else if (resending) {
          requestStatus.success("Сообщение отправлено повторно на телефон: " + $filter('phoneFormat')(vm.pendingPhone));
        }
      }, function (error) {
        if (error.status == 503 && error.data.code == "unknown" && vm.phoneConfirmSended) {
          requestStatus.error('Во время повторной отправки кода произошла ошибка. Повторите попытку позже.');
        } else {
          requestStatus.error('Во время отправки кода произошла ошибка. Повторите попытку позже.');
        }
        $rootScope.stateChangeStart = false;
      });
    };

    /**
     * Отправка запроса на подтверждения телефона по коду
     */
    vm.checkPhoneConfirmCode = function () {
      $rootScope.stateChangeStart = true;
      // код должен быть введен и сохранен объект подтверждения
      if (!vm.confirmCode || !vm.cashier.phone_confirmation) {
        return;
      }
      phoneConfirmationService.sendPhoneConfirmationAnonymousCode(
        vm.cashier.phone_confirmation.id,
        vm.confirmCode)
        .then(function () {
          vm.phoneConfirmError = false;
          vm.cashier.phone_confirmed = true;
          vm.phoneConfirmSended = false;
          vm.userBasePhone = vm.pendingPhone;
          vm.cashier.phone = vm.pendingPhone;
          vm.cashier.pending_phone_changes = null;
          vm.addCashier.phone.$setValidity('confirmError', true);
          vm.addCashier.confirmCode.$setValidity('confirmError', true);
          $rootScope.stateChangeStart = false;
          vm.phoneConfirmSended = false;
          vm.phoneAttempts = PHONE_ATTEMPTS;
        }, function (error) {
          vm.confirmCode = '';
          if (error.status == 503) {
            vm.phoneAttempts--;
            vm.addCashier.confirmCode.$setValidity('confirmError', false);
            if (!vm.phoneAttempts) {
              vm.resetPhone();
              vm.addCashier.phone.$setValidity('phoneAttempts', false);
            }
          } else {
            requestStatus.error('Во время подтверждения телефона произошла ошибка. Повторите попытку позже');
          }
          $rootScope.stateChangeStart = false;
        });
    };

    

    // Структура для управления paging-ом
    vm.paging = {
      current: 0,
      limit: 25,
      offset: 0,
      sortBy: undefined,
      total: undefined
    }
    vm.gridPaging = [15, 25, 50];

    vm.getCompanies = function () {
      companyService.companies(vm.paging, null).then(function (res) {
        vm.companies = res.data.items;
        vm.paging.total = res.data.total;
        angular.forEach(vm.companies, function (company) {
          companyService.companyDivisions(company.id).then(function (res) {
            company.divisions = [];
            if (res.data.length) {
              company.divisions.push($filter('filter')(res.data, {type: "OFFICE"}));
              company.divisions.push($filter('filter')(res.data, {type: "SHOP"}));
              company.divisions.push($filter('filter')(res.data, {type: "STOREHOUSE"}));
              company.divisionTypeCount = 0;
              angular.forEach(company.divisions, function (division) {
                if (division.length) {
                  company.divisionTypeCount++;
                }
              });
              company.divisionTypeCount = 12 / company.divisionTypeCount;
            }
          });
        });
      });
    }
    vm.getCompanies();

    /* Автодополнение компаний */
    vm.refreshCompanies = function (search) {
      companyService.companiesSearch(search, null).then(function (res) {
        if (!vm.companiesListTotal) vm.companiesListTotal = res.data.total;
        vm.companiesList = res.data.items;
        vm.searchTotal = res.data.total;
      });
    };
    vm.refreshCompanies();
    vm.totalStr = function () {
      if (vm.searchTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH) {
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + vm.searchTotal;
      }
      return '';
    };

    vm.addDivision = function (item) {
      vm.cashierDivision = '';
      vm.refreshDivisions(item.id);
    };

    /* Автодополнение подразделений */
    vm.refreshDivisions = function (id) {
      if (!id) return;
      companyService.companyDivisions(id).then(function (res) {
        if (!vm.divisionsListTotal) vm.divisionsListTotal = res.data.total;
        vm.divisionsList = res.data;
      });
    };

    vm.checkPassword = function () {
      vm.passNoMatch = vm.cashier.password && vm.repeatedPassword && vm.cashier.password !== vm.repeatedPassword;
    };

    vm.setDirty = function () {
      vm.isSetDirty = true;
      angular.forEach(vm.addCashier.$error, function (control) {
        for (var i = 0; i < control.length; i++) {
          control[i].$setDirty()
        }
      });
      if (vm.cashier.phone && (!vm.cashier.phone_confirmation || !vm.cashier.phone_confirmed)) {
        vm.addCashier.phone.$setValidity('confirmError', false);
        vm.phoneConfirmError = true;
      }
    };

    vm.resetForm = function () {
      vm.cashier.surname = null;
      vm.cashier.name = null;
      vm.cashier.patronymic = null;
      vm.cashier.inn = null;
      vm.cashierCompany = null;
      vm.cashierDivision = null;
      vm.cashier.login = null;
      vm.cashier.password = null;
      vm.repeatedPassword = null;
      vm.phoneConfirmError = false;
      vm.cashier.phone_confirmed = false;
      vm.phoneConfirmSended = false;
      vm.userBasePhone = null;
      vm.cashier.phone = null;
      vm.cashier.pending_phone_changes = null;
      vm.confirmCode = null;
      vm.addCashier.phone.$setValidity('confirmError', true);
      if (vm.addCashier.confirmCode) {
        vm.addCashier.confirmCode.$setValidity('confirmError', true);
      }
      vm.addCashier.$setPristine();
      vm.addCashier.$setUntouched();
    };

    vm.addEmployee = function () {
      // проверка на наличие подтверждения номера телефона
      if (vm.cashier.phone && (!vm.cashier.phone_confirmation || !vm.cashier.phone_confirmed)) {
        vm.setDirty();
        return;
      }
      var cashier = {
        division_id: vm.cashierDivision,
        login: vm.cashier.login,
        surname: vm.cashier.surname,
        name: vm.cashier.name,
        patronymic: vm.cashier.patronymic || null,
        inn: vm.cashier.inn || null,
        phone: vm.cashier.phone || null,
        phone_confirmation: vm.cashier.phone_confirmation || null,
        password: vm.cashier.password
      };
      employeesService.fastCashier(cashier).then(
        function (res) {
          if (res.status === 200) {
            // статус успеха
            requestStatus.success("Кассир " + vm.cashier.name + " добавлен", false, "Сотрудники", "#/employees");
            vm.getUserTotal();
            vm.resetForm();
          }
        },
        function (error) {
          if (error.status === 409) {
            angular.forEach(error.data.parameters, function (field) {
              vm.addCashier[field.name].$setValidity('unique', false);
            });
            requestStatus.error('Сотрудник с такими данными уже существует');
          } else {
            requestStatus.error('Во время создания быстрого кассира произошла ошибка. Повторите попытку позже или обратитесь к администратору');
          }
        });
    };

    function getUniqueCheckObj(constraintName, params) {
      return {
        constraint_name: constraintName,
        parameters: params
      };
    }

    function onUniqueCheckError(error) {
      if (error.status === 409) {
        setFieldValidity(error.data.parameters, false)
      }
    }

    function setFieldValidity(params, validity) {
      angular.forEach(params, function (field) {
        if (vm.addCashier[field.name]) {
          vm.addCashier[field.name].$setValidity('unique', validity);
        }
      });
    }

    /**
     * Метод выполняет проверку уникальности полей быстрого кассира
     *
     * @param str строка для проверки
     * @param event событие, по которому можно определеить поле на котором оно сработало
     */
    vm.uniqueCheck = function (fieldValue, event, directName) {
      if (fieldValue) {
        switch (event ? event.target.name : directName) {
          case 'login':
            var loginCheck = {};
            loginCheck = getUniqueCheckObj('USER_LOGIN', [
              {name: 'login', value: fieldValue}
            ]);
            utilsService.uniqueCheck(loginCheck).then(function () {
              setFieldValidity(loginCheck.parameters, true)
            }).catch(onUniqueCheckError);
            break;
          case 'phone':
            var phoneCheck = getUniqueCheckObj('USER_PHONE', [
              {name: 'phone', value: fieldValue}
            ]);
            vm.pendingPhoneCheck = true;
            utilsService.uniqueCheck(phoneCheck).then(function () {
              vm.lastApprovePhone = fieldValue;
              setFieldValidity(phoneCheck.parameters, true)
            }).catch(onUniqueCheckError).finally(function () {
              vm.pendingPhoneCheck = false;
            });
            break;
          default:
            var userNameChecks = getUniqueCheckObj('USER_NAME', [
              {name: 'name', value: vm.cashier.surname + ' ' + vm.cashier.name + ' ' + vm.cashier.patronymic}
            ]);
            var personChecks = getUniqueCheckObj('PERSON', [
              {name: 'name', value: vm.cashier.name},
              {name: 'surname', value: vm.cashier.surname},
              {name: 'patronymic', value: vm.cashier.patronymic || null},
              {name: 'birth_address', value: null},
              {name: 'birth_date', value: null}
            ]);
            $q.all([utilsService.uniqueCheck(userNameChecks), utilsService.uniqueCheck(personChecks)])
              .then(function () {
                setFieldValidity(personChecks.parameters, true)
              })
              .catch(onUniqueCheckError)
        }
      }
    }
  }

})();




angular.module('frontend')
       .service('beneficiaryService', function (API_URL, $http) {
         var baseBeneficiaryUrl = API_URL + '/beneficiaries';

         this.beneficiaries = function (filter, paging, searchString) {
           var params = {};
           Object.keys(filter).forEach(function (key) {
             params['filter_' + key] = filter[key];
           });
           params.search_string = searchString;
           params.limit = paging.limit || 5;
           params.offset = paging.offset || 0;
           params.sort_by = paging.sortBy || 'name';
           params.sort_order = paging.sortDirection || 'asc';
           return $http.get(baseBeneficiaryUrl, {
             params: params
           });
         };

         this.getBeneficiary = function (entityId) {
           return $http.get(baseBeneficiaryUrl + '/' + entityId);
         };

         this.createBeneficiary = function (model) {
           return $http.post(baseBeneficiaryUrl, model);
         };

         this.updateBeneficiary = function (entityId, model) {
           return $http.put(baseBeneficiaryUrl + '/' + entityId, model);
         };

         this.deleteBeneficiary = function (entityId) {
           return $http.delete(baseBeneficiaryUrl + '/' + entityId);
         }

       });



angular.module('frontend')
       .controller('beneficiariesController', function ($scope,
                                                        beneficiaryService,
                                                        $state,
                                                        helpService,
                                                        filterFactoryService,
                                                        userSettingsService,
                                                        uiGridConstants,
                                                        companies) {
         var vm = this;

         var pencil = '<a ng-if="$root.hasRole(\'beneficiary.write\')" ui-sref="beneficiary.edit({ id: row.entity.id, parent: \'business\' })"><span class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать"></span></a>';
         vm.cleanObj = function(obj){
           var tempObj = angular.copy(obj);
           for(var prop in tempObj){
             if(!tempObj[prop]) delete obj[prop];
           }
           return obj;
         };

         vm.configScrollFilter = {
           autoHideScrollbar: false,
           theme: 'dark-thick',
           setHeight: 186,
           advanced: {
             updateOnContentResize: true
           },
           scrollButtons: {
             enable: false
           },
           scrollInertia: 0
         };

         vm.subjectTypesPopup = vm.subjectTypes;

         vm.gridFilter = filterFactoryService.createFilter("beneficiary", "grid");

         vm.updateColumnFilter = function (colDef, col) {
           if (vm.filter[colDef.filterName || colDef.name] && vm.filter[colDef.filterName || colDef.name].complex) {
             col.filters[0].dateRange = vm.filter[colDef.filterName || colDef.name].dateRange;
             col.filters[0].term = vm.filter[colDef.filterName || colDef.name].datePickStr
           } else {
             col.filters[0].term = vm.filter[colDef.filterName || colDef.name]
           }
         };

         vm.initFilter = function () {
           vm.filter = vm.gridFilter.loadFilter() || {};
           vm.gridApi && vm.gridApi.grid.columns.filter(function (column) {
             return column.enableFiltering;
           }).forEach(function (col) {
             vm.updateColumnFilter(col.colDef, col)
           });
           vm.gridFilter.storeFilter(vm.filter)
         };

         vm.prepareSavedFiltersList = function() {
           vm.savedFilterListSearchText = ""
         };

         vm.saveFilter = function (name) {
           vm.gridFilter.saveFilter(name, vm.filter);
           vm.filterSaved = true;
           vm.filterDeepCopy = angular.copy(vm.filter);
           vm.savedFilterName = name;
         };

         vm.chooseFilter = function (filterName) {
           vm.gridFilter.storeFilter(vm.gridFilter.loadSavedFilter(filterName));
           vm.initFilter();
           vm.filterDeepCopy = angular.copy(vm.filter);
           if (vm.filter) {
             vm.filterSaved = true;
             vm.savedFilterName = filterName
           }
           vm.showFilter = true;
         };

         vm.removeFilter = function (filterName, $event) {
           $event.stopPropagation();
           vm.gridFilter.removeFilter(filterName);
           if (filterName === vm.savedFilterName) {
             vm.filterSaved = false
           }
           if (vm.gridFilter.getSavedFiltersNames().length < 6) {
             vm.savedFilterListSearchText = ""
           }
         };

         vm.updateFilter = function (filter) {
           vm.filterSaved = vm.filterSaved &&  _.isEqual(vm.cleanObj(vm.filterDeepCopy), vm.cleanObj(filter));      vm.gridFilter.storeFilter(filter);
           if(!vm.filterSaved) vm.savedFilterName = '';
           vm.gridFilter.storeFilter(filter);
           vm.initFilter();
           if (_.isEmpty(filter)) {
             vm.filterSaved = false;
             vm.savedFilterName = '';
           }
         };

         vm.applyFilter = function () {
           vm.updateFilter(vm.popupFilter);
           vm.getPage()
         };

         vm.cleanFilter = function () {
           vm.updateFilter(undefined);
           vm.getPage()
         };

         vm.initPaging = function () {
           vm.paging = userSettingsService.loadProperty("beneficiary", "grid", "paging") || {
             current: 0,
             limit: 5,
             offset: 0,
             sortBy: 'surname',
             total: undefined
           };

           /**
            * Свойство добавлено из-за того, что количество сущностей в момент
            * сохранения может быть больше, чем при повторном обращении,
            * сохранять смещение - опасно. Кроме того, в разработке задача,
            * которая позволит после сохранения или редактирования сущности запрашивать
            * нужную страницу для позиционирования - это перекроет оставшиеся кейсы,
            * где сохранение смещение могло бы быть полезным.
            */
           vm.paging.offset = 0;
           vm.paging.current = 0;
         };

         vm.init = function () {
           vm.initFilter();
           vm.initPaging();
           vm.showFilter = userSettingsService.loadProperty("beneficiary", "grid", "showFilter") || false;
         };

         vm.turnShowFilter = function () {
           vm.showFilter = !vm.showFilter;
           userSettingsService.saveProperty("beneficiary", "grid", "showFilter", vm.showFilter);
           if(!vm.showFilter){
             vm.cleanFilter();
           }
         };

         vm.init();

         vm.showFilterPopup = function () {
           vm.popupFilter = $.extend(true, {}, vm.filter);
         };

         vm.configScroll = {
           autoHideScrollbar: false,
           theme: 'dark-thick',
           advanced: {
             updateOnContentResize: true
           },
           setHeight: 400,
           scrollInertia: 0
         };

         vm.goToView = function (id) {
           $state.go('beneficiary.view', { id: id, parent: 'business' });
         };

         $scope.columnVisibilityChanged = function(){
           var columnsProperty = vm.gridApi.grid.options.columnDefs;
           angular.forEach(columnsProperty, function(column){
             if(column.filter) delete column.filter.selectOptions;
           });
           userSettingsService.saveProperty("beneficiary", "grid", "columnsProperty", columnsProperty)
         };

         $scope.defaultColumns = [
           { name: 'selection', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 64},
           { name: 'person.surname', displayName:'Фамилия', visible: true,  enableSorting: true, enableFiltering: false, sort: {
               direction: 'asc',
               priority: 0
             }
           },
           { name: 'person.name', displayName:'Имя', visible: true, enableSorting: true, enableFiltering: false},
           { name: 'person.patronymic', displayName:'Отчество', visible: true, enableSorting: true, enableFiltering: false },
           { name: 'company.name', displayName: 'Компания', visible: true,  enableFiltering: true, enableSorting: false, filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
             filterName: 'company_id',
             filter: {
               type: uiGridConstants.filter.SELECT,
               selectOptions: companies
             },},
           { name: 'created_at', displayName:'Дата создания', cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
           { name: 'created_by.name', displayName:'Кто создал',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
           { name: 'updated_at', displayName:'Дата обновления',cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>', enableFiltering: false, enableSorting: false, visible: false},
           { name: 'updated_by.name', displayName:'Кто обновил',cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableFiltering: false, enableSorting: false, visible:false },
           { name: 'option', field: 'option', cellTemplate: pencil, displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 95},
           { name: 'marginRight', field: 'option', displayName:'', enableColumnMenu:false, enableHiding:false, enableFiltering: false, width: 63}
         ];

         var columnsProperty = userSettingsService.loadProperty("beneficiary", "grid", "columnsProperty");

         vm.gridOptions = {
           enableSorting:false,
           useExternalSorting: true,
           useExternalFiltering: true,
           virtualizationThreshold: vm.paging.limit,
           enableGridMenu:true,
           enableFiltering: true,
           showColumnFooter: true,
           gridMenuTemplate: '<grid-menu></grid-menu>',
           rowTemplate: '<div ng-click="grid.appScope.vm.goToView(row.entity.id);">' +
             ' <div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell"  ui-grid-cell></div>' +
             '</div>',
           columnDefs: columnsProperty || angular.copy($scope.defaultColumns)
         };
         vm.gridOptions.columnDefs.filter(function (colDef) {
           return colDef.name === vm.paging.sortBy
         }).forEach(function (colDef) {
           colDef.sort = {
             direction: vm.paging.sortDirection,
             priority: 0
           }
         });
         var columnsVisibility = userSettingsService.loadProperty("beneficiary", "grid", "columnsVisibility") || {};
         vm.gridOptions.columnDefs.forEach(function (colDef) {
           if (columnsVisibility[colDef.name] === false) {
             colDef.visible = false
           } else if (columnsVisibility[colDef.name]) {
             colDef.visible = true
           }
         });

         vm.gridOptions.onRegisterApi = function (gridApi) {
           vm.gridApi = gridApi;
           gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
             if (sortColumns.length === 0) {
               vm.paging.sortBy = null;
               vm.paging.sortDirection = null;
             } else {
               vm.paging.sortBy = sortColumns[0].colDef.sortName;
               vm.paging.sortDirection = sortColumns[0].sort.direction;
             }
             vm.getPage();
           });
           gridApi.core.on.filterChanged($scope, function () {
             gridApi.grid.columns.filter(function (column) {
               return column.enableFiltering && column.visible !== false;
             }).forEach(function (column) {
               var filter = vm.filter[column.colDef.filterName || column.name];
               if (filter && filter.complex) {
                 if(column.filters[0].term) filter.datePickStr = column.filters[0].term;
                 filter.dateRange = column.filters[0].dateRange
               } else {
                 vm.filter[column.colDef.filterName || column.name] = column.filters[0].term
               }
             });
             vm.paging.offset = 0;
             vm.updateFilter(vm.filter);
             vm.getPage();
           });
           gridApi.grid.registerColumnBuilder(vm.updateColumnFilter)
         }.bind(this);

         vm.crudState = helpService.getCrudStateStructure();

         // Поиск
         vm.search = function () {
           // Сброс текущей страницы и поиск
           vm.paging.current = 0;
           vm.paging.offset = 0;
           vm.getPage();
         };

         vm.showSaveFilterPopup = helpService.getOpenFilterFunction(vm.gridFilter, vm.saveFilter);

         // Функция обновления страницы, вызываетсяperson. при изменениях фильтров и пейджинге
         vm.getPage = function () {
           vm.noData = false;
           vm.loadData = false;
           vm.gridOptions.virtualizationThreshold = vm.paging.limit;
           vm.crudState.startLoading();
           userSettingsService.saveProperty("beneficiary", "grid", "paging", vm.paging); // Настройки paging сохраняются при оюбом обновлении страницы (фильтры и остальное, в своих обработчиках)
           beneficiaryService.beneficiaries(vm.filter, vm.paging, vm.searchText).then(
             function (data) {
               if(!data.data.items.length && !vm.searchText && _.isEmpty(vm.filter)){
                 vm.noData = true;
               }
               vm.beneficiaries = data.data.items;
               vm.paging.total = data.data.total;
               vm.paging.current = data.data.offset / vm.paging.limit;

               vm.loadData = true;
               // Ссылка в grid
               vm.gridOptions.data = data.data.items;
               console.log(vm.gridOptions.data);

               vm.crudState.stopLoadingSuccess();
             },
             function (error) {
               vm.beneficiaries = [];
               vm.crudState.stopLoadingFailure(error);
             }
           )
         };
         // Запрос начального участка списка (потенциально длинный вызов, лучше в контроллере, чем при роутинге)
         vm.getPage();
       });

'use strict';

angular.module('frontend').service('bankProductRequestService', function ($http, API_URL, $rootScope, $q) {
  var baseUrl = API_URL + '/bank_product_requests';
  var bankProductsPromise = null;

  this.getBankProductRequestList = function (filter, paging, searchString) {
    filter = filter || {};
    paging = paging || {};
    var params = {};
    Object.keys(filter).forEach(function (key) {
      params['filter_' + key] = filter[key];
    });
    params.search_string = searchString;
    params.limit = paging.limit || 5;
    params.offset = paging.offset || 0;
    params.sort_by = paging.sortBy || 'updated_at';
    params.sort_order = paging.sortDirection || 'desc';
    return $http.get(baseUrl, {
      params: params
    });
  };

  this.createBankProductRequest = function (data) {
    return $http.post(baseUrl, data);
  };

  this.getBankProductRequest = function (entityId) {
    return $http.get(baseUrl + '/' + entityId);
  };

  this.updateBankProductRequest = function (entityId) {
    return $http.put(baseUrl + '/' + entityId, {});
  };

  this.getDiagnosticsForBankProductRequest = function (entityId) {
    return $http.get(baseUrl + '/' + entityId + '/diagnosis_results');
  };

  this.changeBankProductRequestStatus = function (entityId, status) {
    return $http.put(baseUrl + '/' + entityId + '/status/' + status, {});
  };

  this.getBankProducts = function (force) {
    if (bankProductsPromise && !force) {
      return bankProductsPromise;
    }
    bankProductsPromise = _loadActiveBankProducts();
    return bankProductsPromise;
  };

  this.unlink = function (bankProductRequestId, consentId) {
    return $http.delete(baseUrl + '/' + bankProductRequestId + '/consents/' + consentId + '/links');
  };

  function _loadActiveBankProducts() {
    // Вank products cannot be displayed in domain demo   
    if ($rootScope.user && $rootScope.user.domain === 'demo') {
      return $q.when({
        data: []
      })
    }
    
    return $http.get(API_URL + '/bank_products')
  }

});



angular.module('frontend')
  .controller('bankProductRequestCtrl', function ($scope,
                                                  $state,
                                                  companies,
                                                  bankProducts,
                                                  cardHistory,
                                                  bankProductRequestService,
                                                  errorMessageService,
                                                  bankProductRequest,
                                                  bankProductRequests,
                                                  $window,
                                                  print,
                                                  statusSrv,
                                                  downloadSrv,
                                                  helpService,
                                                  $timeout,
                                                  companyService,
                                                  $rootScope,
                                                  $q) {
    var vm = this;
    vm.companies = companies;
    vm.bankProducts = bankProducts;
    vm.bankProductRequests = bankProductRequests;
    vm.activeStep = 0;
    vm.errors = [];
    vm.company = {};
    vm.personFakeTriggers = {};
    // Расшифровка разделов ошибок с бэка
    vm.examinationType = {
      LEGAL_REQUISITES_EXAMINATION: 'Реквизиты компании',
      COMPANY_LIFETIME_EXAMINATION: 'Возраст компании',
      HAVING_RETAIL_SALE_EXAMINATION: 'Наличие розничных продаж в Торговля.Онлайн',
      RETAIL_REVENUE_EXAMINATION: 'Розничный оборот компании',
      CHIEF_PERSONAL_DATA_EXAMINATION: 'Заполнены данные о руководителе компании',
      BENEFICIARY_EXAMINATION: 'Заполнены сведения о бенефициарах компании'
    };

    vm.legalEntityConsents = ['PSB_CONSENT_LEGAL_ENTITY'];

    // мапинг параметров в зависимости от сущьности в которой нужно произвести изменения
    var stateParamMap = {
      EMPLOYEE: 'userId',
      BENEFICIARY: 'id',
      COMPANY: 'companyId'
    };

    // маппинг наименований стейтов
    var stateNameMap = {
      EMPLOYEE_LIST: 'employees',
      COMPANY_LIST: 'companies',
      BENEFICIARY_LIST: 'beneficiaries',
      COMPANY: 'company.edit',
      EMPLOYEE: 'employee.edit',
      BENEFICIARY: 'beneficiary.edit',
      PERSON: null,
    };

    vm.bankProductRequest = {
      status: 'NEW',
      bank_product: bankProducts[0]
    };

    vm.choosenBankProduct = bankProducts[0];

    function checkConsents(reset) {
      vm.requestForm.$setValidity('consents', reset || vm.bankProductRequest.consents.every(function (val) {
        return !!val.link
      }));
    }

    vm.returnToPage = function(){
      var prev = cardHistory.popStep('bankProductRequest') || {name: 'business'};
      $state.go(prev.name !== '' ? prev.name : 'business', prev.param);
    };

    // при смене продукта сбрасывается информация о компании и проверки
    vm.onBankProductChange = function() {
      vm.bankProductRequest.bank_product = vm.choosenBankProduct;
      vm.bankProductRequest.company = null;
      vm.examinations = [];
    };

    vm.onCompanySelect = function (company) {
      if (vm.bankProductRequest.company && vm.bankProductRequest.bank_product)  {
        // если выбрана компания и банковский продукт, происходит поиск среди уже имеющихся заявок
        var existing = vm.bankProductRequests.find(function (value) {
          return value.company.id === company.id &&
                  vm.bankProductRequest.bank_product.id === value.bank_product.id
        });
        // если есть совпадение , то оно присваивается в текущую заявку на кредит и триггерит запрос проверок
        if (existing) {
          vm.bankProductRequest = angular.copy(existing);
          vm.refreshDiagnostics();
        } else {
          // если совпадений нет, то обнуляются согласия, и происходит создание заявки
          vm.bankProductRequest.consents = [];
          bankProductRequestService.createBankProductRequest(vm.bankProductRequest)
            .then(function (res) {
              vm.bankProductRequest = res.data;
              vm.refreshDiagnostics();
            }, function (err) {
              if (err.status === 409) {
                // при конфликте все заявки запрашиваются заного и функция выбор компании тригерится повторно,
                // при этом форма заходит в тупик , если заявка в статусе не NEW
                if (err.data.code === 'bank_product_request_is_already_exist') {
                  bankProductRequestService.getBankProductRequestList(null, {limit: 100})
                    .then(function (res) {
                      vm.bankProductRequests = res.data.items;
                      vm.onCompanySelect(company);
                      onNotNewRequest();
                    })
                }
              } else {
                errorMessageService.showModal({ message:'При создании заявки произошла ошибка', submessage: err});
              }
            });
        }
      }
    };

    // когда выбрана заявка в статусе не NEW , ее нельзя редактировать далее, поэтому сброс проверок и установка формы
    // в невалидное состояние
    function onNotNewRequest() {
      if (vm.bankProductRequest.status !== 'NEW') {
        vm.examinations = [];
        vm.requestForm.$setValidity('examinations', false);
      }
    }

    // обноление проверок
    vm.refreshDiagnostics = function () {
      onNotNewRequest();
      if (vm.bankProductRequest.id && vm.bankProductRequest.status === 'NEW') {
        return bankProductRequestService.getDiagnosticsForBankProductRequest(vm.bankProductRequest.id)
          .then(function (res) {
            vm.examinations = res.data;
            vm.requestForm.$setValidity('examinations', vm.examinations.every(function (item) {
              return item.status === 'SUCCESS';
            }));
          })
      }
      return $q.when()
    };

    vm.nextStep = function () {
      vm.activeStep += 1;
      // на втором шаге обновление проверок
      if (vm.activeStep === 1) {
        vm.refreshDiagnostics();
      }
      // на третьем шаге запрос на обновление заявки из первоисточника и формирование соглаий
      if (vm.activeStep === 2) {
        vm.refreshBankProductRequest();
      }
      // получение полного вью компании
      if (vm.activeStep === 3) {
        companyService.company(vm.bankProductRequest.company.id)
          .then(function (res) { vm.company = res.data; prepareListOfIncludes() });
      }
      if (vm.activeStep === 4) {
        // на 5 шаге обновление статуса заявки
        bankProductRequestService.changeBankProductRequestStatus(vm.bankProductRequest.id, 'PENDING')
          .then(function () {
            vm.nextStep();
          })
      }
      if (vm.activeStep === 6) {
        // на 7 шаге преход на список всех заявок
        $state.go('bankProductRequests', {parent: 'money'});
      }
    };


    vm.back = function () {
      vm.activeStep -= 1;
      // при возврате на 1 шаг , сброс валиднации
      if (vm.activeStep === 0) {
        vm.requestForm.$setValidity('examinations', true);
      }
      // сброс валидации согласий при переходе с 3 шага
      if (vm.activeStep === 1) {
        checkConsents(true);
      }
      // при переходе на 3 шаг обновление заявки и получение актуального списка согласий
      if (vm.activeStep === 2) {
        vm.refreshBankProductRequest();
      }
    };

    // получение ссылки на сущьность для редактирования
    function getEntityHref(entityName, entityId) {
      // person открываем через скрытое поле ПДФЛ
      if (entityName === 'PERSON') {
        void vm.personFakeTriggers.openPersonFn(entityId);
      }
      var entityPath = stateNameMap[entityName];
      var params = {};
      if (entityPath && entityId) {
        params[stateParamMap[entityName]] = entityId;
      }
      return $state.href(entityPath, params);
    }

    // открытие сущьности в новой вкладке
    vm.fixError = function (entityName, entityId) {
      var href = getEntityHref(entityName, entityId);
      if (href) {
        $window.open(href, '_blank');
      }
    };

    // обглвдение заявки
    vm.refreshBankProductRequest = function() {
      vm.refreshDiagnostics().then(function () {
        if (vm.requestForm.$invalid) {
          vm.back();
        } else {
          bankProductRequestService.updateBankProductRequest(vm.bankProductRequest.id).then(function (res) {
            vm.bankProductRequest = res.data;
            checkConsents();
          });
        }
      })
    };


    // если передается bankProductRequest и он в статусе new переход сразу на 2 шаг и тригер запроса проверок
    if (bankProductRequest && bankProductRequest.status === 'NEW') {
      vm.bankProductRequest = bankProductRequest;
      vm.activeStep = 1;
      vm.refreshDiagnostics();
    }


    // треггер при обновлении согласия изнутри
    vm.onConsentUpdate = function (consent) {
      var existingIndex = _.findIndex(vm.bankProductRequest.consents, function (val) { return val.id === consent.id});
      if (~existingIndex) {
        vm.bankProductRequest.consents[existingIndex] = consent;
      }
      checkConsents();
    };

    vm.regexp = new RegExp(/\[\[(.*?)]]/, 'g');
    vm.listOfIncludes = [];
    function prepareListOfIncludes() {
      if (vm.regexp.test(vm.bankProductRequest.bank_product.partner_bank.ready_request_test)) {
        var source = vm.bankProductRequest.bank_product.partner_bank.ready_request_test.match(vm.regexp);
        if (source !== null) {
          source = source[0].replace('[[','').replace(']]','');
          vm.listOfIncludes = [];
          source.split(',').forEach(function (item) {
            vm.listOfIncludes.push(item);
          });

        }
      }
    }


  });

'use strict';

angular.module('frontend').controller('accountingSettingsController', function ($state, accountingSettings, accountingService, requestStatus, cardHistory, errorMessageService) {
  var vm = this;

  vm.request = angular.copy(accountingSettings);

  vm.settingsOptions = [{
    model: "inventory_accounting_enabled",
    checkboxLabel: "Вести складской учёт",
    description: "Складской учет позволяет вести учет товаров на складе и контролировать их движение. Будет добавлена возможность создавать следующие документы: начальные остатки, акт о списании, акт об оприходовании, внутреннее перемещение между складами одной компании, отгрузка контрагенту, приёмка от контрагента. Позволит вести учёт по серийным номерам и партиям. <br/><br/> При включенном складском учете проведение документов станет не моментальным (требуется дополнительное время на формирование складских проводок и записей себестоимости), а также у товаров, по которым были созданы документы, нельзя будет изменить единицу измерения."
  },{
    model: "financial_accounting_enabled",
    checkboxLabel: "Вести финансовый учёт",
    description: "Функция финансового учета помогает управлять финансовыми операциями, позволяя владельцам магазинов и их сотрудникам легко следить за денежными потоками и принимать соответствующие решения в режиме реального времени. <br/><br/> Будет добавлена возможность создавать следующие документы: начальные взаиморасчёты по договорам, начальные остатки денежных средств, безналичные платежи, кассовые ордера, авансовые отчёты, акты сверки взаиморасчётов, расчеты с подотчётными лицами.",
    ref: "inventory_accounting_enabled"
  },{
    model: "calc_cost_enabled",
    checkboxLabel: "Считать себестоимость товаров",
    description: "",
    ref: "inventory_accounting_enabled"
  }];

  vm.changeOption = function (option) {
    if (option.model == "inventory_accounting_enabled" && !vm.request.inventory_accounting_enabled) {
      vm.request.financial_accounting_enabled = false;
      vm.request.calc_cost_enabled = false;
    }
  }

  // для возврата на предыдущую страницу
  vm.returnToPage = function(){
    var prev = cardHistory.popStep();
    if(prev && prev.name){
      $state.go(prev.name, prev.param);
      return;
    }
    $state.go('mainSettings');
  };

  vm.save = function () {
    accountingService.updateAccountingSettings(vm.request).then(function (res) {
        requestStatus.success("Настройки учета сохранены");
      }, function (error) {
        console.log(error);
        if (!error.data.message) {
          requestStatus.error('Во время сохранения настроек учета произошла ошибка.');
          return;
        }
        
        errorMessageService.showModal({message: 'При сохранении настроек учета произошла ошибка', submessage: {
          data: {message: error.data.message}
        }});
      });
  }

});
(function() {
  'use strict';

  angular.module('frontend').controller('salesTotalsPrint', function(
                           $scope,
                           companyService,
                           API_URL,
                           print,
                           uiSelectStructure,
                           currenciesService,
                           $timeout,
                           helpService,
                           authToken,
                           statusSrv,
                           $rootScope,
                           downloadSrv,
                           $uibModal,
                           filterFactoryService,
                           $state,
                           requestStatus,
                           allDimensions,
                           cardHistory,
                           salesTotalsPrintData) {
        var salesTotalsPrintCtrl = this;
        salesTotalsPrintCtrl.today = moment();
        salesTotalsPrintCtrl.activeTab = 1;
        salesTotalsPrintCtrl.filterObj = filterFactoryService.createFilter("sales-totals-print", "print");
        // для возврата на предыдущую страницу
        salesTotalsPrintCtrl.returnToPage = function(){
          var prev = cardHistory.popStep();
          if(prev){
            $state.go(prev.name || 'business', prev.param);
          }else{
            $state.go('business');
          }
        };

        salesTotalsPrintCtrl.allDimensions = allDimensions;

        salesTotalsPrintCtrl.myTotals = salesTotalsPrintData;

        salesTotalsPrintCtrl.data = {
          dimensions: "DIVISION"
        };

        /* Автодополнение компаний */
        salesTotalsPrintCtrl.refreshCompanies = function(search) {
          companyService.companiesSearch(search)
            .then(function (res) {
              salesTotalsPrintCtrl.companies = res.data.items;
            });
        };
        salesTotalsPrintCtrl.refreshCompanies();

        /**/
        salesTotalsPrintCtrl.refreshDivisions = function() {
          if (salesTotalsPrintCtrl.data.filter_company_id) {
            // если компания выбрана - обновляем список
            companyService.companyDivisions(salesTotalsPrintCtrl.data.filter_company_id)
              .then(function (data) {
                salesTotalsPrintCtrl.divisions = data.data;
                if (data.data.length == 1) {
                  salesTotalsPrintCtrl.data.filter_division_id = data.data[0].id;
                }
              });
          } else {
            // если компания не выбрана - сброс значений подразделений
            salesTotalsPrintCtrl.division = undefined;
            salesTotalsPrintCtrl.divisions = [];
            salesTotalsPrintCtrl.data.filter_division_id = undefined;
          }
        }

        salesTotalsPrintCtrl.setInterval = function (intervalStr) {
          switch (intervalStr) {
            case "yestarday":
              salesTotalsPrintCtrl.data.start_date = moment().utc().subtract(1, 'days').set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().subtract(1, 'days').set({hour:0,minute:0,second:0,millisecond:0});
              break;
            case "last month":
              salesTotalsPrintCtrl.data.start_date = moment().utc().subtract(1, 'months').startOf('month').set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().subtract(1, 'months').endOf('month').set({hour:0,minute:0,second:0,millisecond:0});
              break;
            case "last quarter":
              salesTotalsPrintCtrl.data.start_date = moment().utc().subtract(1, 'quarter').startOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().subtract(1, 'quarter').endOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
              break;
            case "last year":
              salesTotalsPrintCtrl.data.start_date = moment().utc().subtract(1, 'year').startOf('year').set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().subtract(1, 'year').endOf('year').set({hour:0,minute:0,second:0,millisecond:0});
              break;
            case "today":
              salesTotalsPrintCtrl.data.start_date = moment().utc().set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().set({hour:0,minute:0,second:0,millisecond:0});
              break;
            case "this month":
              salesTotalsPrintCtrl.data.start_date = moment().utc().startOf('month').set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().endOf('month').set({hour:0,minute:0,second:0,millisecond:0});
              break;
            case "this quarter":
              salesTotalsPrintCtrl.data.start_date = moment().utc().startOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().endOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
              break;
            case "this year":
              salesTotalsPrintCtrl.data.start_date = moment().utc().startOf('year').set({hour:0,minute:0,second:0,millisecond:0});
              salesTotalsPrintCtrl.data.end_date = moment().utc().endOf('year').set({hour:0,minute:0,second:0,millisecond:0});
              break;
          }
        }

        salesTotalsPrintCtrl.close = function () {
          salesTotalsPrintCtrl.modalInstance.dismiss();
        };

        salesTotalsPrintCtrl.setDirty = function() {
          salesTotalsPrintCtrl.isSetDirty = true;
          angular.forEach( $scope.printForm.$error, function (control) {
            for (var i = 0; i < control.length; i++) {
              control[i].$setDirty();
            }
          });
        };

        salesTotalsPrintCtrl.print = function () {
          salesTotalsPrintCtrl.showLoader = true;
          var printData = salesTotalsPrintCtrl.data;
          if (salesTotalsPrintCtrl.activeTab == 1) {
            printData.metrics = [ "SALES_AMOUNT", "COST", "PROFIT", "MARGIN_PROFIT"];
            printData.metric_grouping_period = null;
          } else {
            printData.metric_grouping_period = salesTotalsPrintCtrl.myTotals.metric_grouping_period;
            printData.metrics = _.map(salesTotalsPrintCtrl.myTotals.dndColumns[1].items, function (item) {
              return item.value;
            });

            printData.dimensions = _.map(salesTotalsPrintCtrl.myTotals.dndLines[1].items, function (item) {
              return item.value;
            });
          }

          printData.start_date = moment(printData.start_date).startOf('day').valueOf();
          printData.end_date = moment(printData.end_date).endOf('day').valueOf();

          print.printRetailSalesAnalyticalTotals(printData).then(function(res) {
            var exec_id = res.data.exec_id;
            statusSrv.getPromise('/print_report/executions/' + exec_id + '/status').then(function (res) {
              print.turnoffInterceptorStatus();
              $timeout(function() {
                downloadSrv.getPromise('/print_report/executions/' + exec_id + '/output').then(function(){
                  requestStatus.success("Отчет сформирован");
                  salesTotalsPrintCtrl.showLoader = false;
                });
              });
            }).catch(function () {
              requestStatus.error("Во время формирования отчета произошла ошибка. Попробуйте повторить действие позже.");
              salesTotalsPrintCtrl.showLoader = false;
            });
          }).catch(function () {
            requestStatus.error("Во время формирования отчета произошла ошибка. Попробуйте повторить действие позже.");
            salesTotalsPrintCtrl.showLoader = false;
          });
        };




        /**
         * dnd-dragging determines what data gets serialized and send to the receiver
         * of the drop. While we usually just send a single object, we send the array
         * of all selected items here.
         */
        salesTotalsPrintCtrl.getSelectedItemsIncluding = function(list, item) {
          item.selected = true;
          return list.items.filter(function(item) { return item.selected; });
        };

        /**
         * We set the list into dragging state, meaning the items that are being
         * dragged are hidden. We also use the HTML5 API directly to set a custom
         * image, since otherwise only the one item that the user actually dragged
         * would be shown as drag image.
         */
        salesTotalsPrintCtrl.onDragstart = function(list, event) {
          list.dragging = true;
          if (event.dataTransfer.setDragImage) {
            var img = new Image();
            img.src = 'framework/vendor/ic_content_copy_black_24dp_2x.png';
            event.dataTransfer.setDragImage(img, 0, 0);
          }
        };

        /**
         * In the dnd-drop callback, we now have to handle the data array that we
         * sent above. We handle the insertion into the list ourselves. By returning
         * true, the dnd-list directive won't do the insertion itself.
         */
        salesTotalsPrintCtrl.onDrop = function(list, items, index) {
          salesTotalsPrintCtrl.filterApplied = false;
          angular.forEach(items, function(item) { item.selected = false; });
          list.items = list.items.slice(0, index)
                      .concat(items)
                      .concat(list.items.slice(index));
          return true;
        }

        /**
         * Last but not least, we have to remove the previously dragged items in the
         * dnd-moved callback.
         */
        salesTotalsPrintCtrl.onMoved = function(list) {
          salesTotalsPrintCtrl.filterApplied = false;
          list.items = list.items.filter(function(item) { return !item.selected; });
        };

        // FILTERS
        //
        salesTotalsPrintCtrl.saveFilter = function (name) {
          console.log(salesTotalsPrintCtrl.myTotals)
          salesTotalsPrintCtrl.filterObj.saveFilter(name, salesTotalsPrintCtrl.myTotals);
          salesTotalsPrintCtrl.filterSaved = true;
          salesTotalsPrintCtrl.filterApplied = true;
          // salesTotalsPrintCtrl.filterDeepCopy = angular.copy(salesTotalsPrintCtrl.data);
          // salesTotalsPrintCtrl.savedFilterName = name;
        };

        salesTotalsPrintCtrl.chooseFilter = function (filterName) {
          var filter = salesTotalsPrintCtrl.filterObj.loadSavedFilter(filterName.filterName || filterName);
          salesTotalsPrintCtrl.filterObj.storeFilter(filter);
          salesTotalsPrintCtrl.myTotals = filter;
          salesTotalsPrintCtrl.filterDeepCopy = $.extend(true, {}, salesTotalsPrintCtrl.myTotals);
          salesTotalsPrintCtrl.filterApplied = true;
          if (salesTotalsPrintCtrl.myTotals) {
            salesTotalsPrintCtrl.filterSaved = true;
            salesTotalsPrintCtrl.savedFilterName = filterName;
          }
        };

        salesTotalsPrintCtrl.removeFilter = function (filterName, $event) {
          $event.stopPropagation();
          salesTotalsPrintCtrl.filterObj.removeFilter(filterName);

          if (filterName === salesTotalsPrintCtrl.savedFilterName) {
            salesTotalsPrintCtrl.filterSaved = false;
          }

          if (salesTotalsPrintCtrl.filterObj.getSavedFiltersNames().length < 6) {
            salesTotalsPrintCtrl.savedFilterListSearchText = '';
          }
        };

        salesTotalsPrintCtrl.saveFilterPopup = function () {
          $uibModal.open({
            templateUrl: 'app/settings/components/filters/modals/saveFilter/save-filter.html',
            size: 'middle-width',
            controller: function($scope, $uibModalInstance){
              $scope.filterName = '';
              $scope.filterObj = salesTotalsPrintCtrl.filterObj;
              $scope.title = 'Сохранение настроек отчета';
              $scope.description = 'Вы можете сохранить часто используемые настройки отчетов для быстрого запуска. Найти сохраненные настройки можно, нажав на <span class="caret"></span> рядом с кнопкой сохранения настроек';

              $scope.save = function () {
                if ($scope.saveFilterForm.$valid) {
                  salesTotalsPrintCtrl.saveFilter($scope.filterName);
                }
                $uibModalInstance.dismiss();
              };

              $scope.close = function() {
                $uibModalInstance.dismiss();
              };
            }
          })
        }


        salesTotalsPrintCtrl.prepareSavedFiltersList = function () {
          salesTotalsPrintCtrl.savedFilterListSearchText = '';
        }

        salesTotalsPrintCtrl.configScrollFilter = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          scrollButtons: {
            enable: false
          },
          setHeight: 130,
          scrollInertia: 0,
          axis: 'y'
        };


        salesTotalsPrintCtrl.filterApplied = false;
    });

}) ();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('reportProfitAndLoss', {
      templateUrl: 'app/print/report-profit-and-loss/report-profit-and-loss.html',
      bindings: {
        modalInstance: "<",
        resolve: "<"
      },
      controller: function($scope, $rootScope, print, statusSrv, downloadSrv, companyService, projectsService, helpService, $timeout, utilsService) {
        print.turnonInterceptorStatus();
        var reportProfitAndLossCtrl = this;
        reportProfitAndLossCtrl.format = "PDF";
        reportProfitAndLossCtrl.data = {};

        if (reportProfitAndLossCtrl.resolve.mode == 'cashFlow') {
          reportProfitAndLossCtrl.data.grouping_period = "DAY";
        }

        reportProfitAndLossCtrl.periods = [{
          value: "DAY",
          label: "День"
        },{
          value: "QUARTER",
          label: "Квартал"
        },{
          value: "MONTH",
          label: "Месяц"
        },{
          value: "YEAR",
          label: "Год"
        }];

        reportProfitAndLossCtrl.longRequest = {
          format: null,
          exec_id: null,
          crudState: helpService.getCrudStateStructure(),
          flags: {
            processStart: false,
            finish: false
          },
          stopAskingError: function(){
            reportProfitAndLossCtrl.longRequest.flags.processStart = false;
            reportProfitAndLossCtrl.longRequest.flags.finish = true;
            reportProfitAndLossCtrl.longRequest.flags.error = true;
            reportProfitAndLossCtrl.longRequest.crudState.stopLoadingFailure();
            print.turnoffInterceptorStatus();
          },
          onError: function(err) {
            if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
              reportProfitAndLossCtrl.longRequest.revert();
            } else {
              reportProfitAndLossCtrl.longRequest.stopAskingError();
            }
          },
          revert: function() {
            reportProfitAndLossCtrl.longRequest.format = null;
            reportProfitAndLossCtrl.longRequest.cancelled = false;
            reportProfitAndLossCtrl.longRequest.exec_id = null;
            reportProfitAndLossCtrl.longRequest.crudState.stopLoadingSuccess();
            reportProfitAndLossCtrl.longRequest.flags.processStart = false;
            reportProfitAndLossCtrl.longRequest.flags.finish = false;
          }
        };

        /* Автодополнение компаний */
        reportProfitAndLossCtrl.refreshCompanies = function(search) {
          companyService.companiesSearch(search)
            .then(function (res) {
              reportProfitAndLossCtrl.companies = res.data.items;
            });
        };
        reportProfitAndLossCtrl.refreshCompanies();

        /* Автодополнение проектов */
        reportProfitAndLossCtrl.refreshProjects = function (search) {
          projectsService.projectsSearch(search, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH, {filter_active: true}).then(function (res) {
            reportProfitAndLossCtrl.projects = res.data;
            if (!reportProfitAndLossCtrl.projectsFullTotal) {
              reportProfitAndLossCtrl.projectsFullTotal = res.data.total;
            }
          });
        };
        reportProfitAndLossCtrl.totalSelectStr = function () {
          if (reportProfitAndLossCtrl.projectsFullTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH) {
            return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + reportProfitAndLossCtrl.projectsFullTotal;
          }
          return '';
        };

        reportProfitAndLossCtrl.close = function () {
          reportProfitAndLossCtrl.modalInstance.dismiss();
        };

        reportProfitAndLossCtrl.status = function () {
          statusSrv.getPromise('/print_report/executions/' + reportProfitAndLossCtrl.longRequest.exec_id + '/status').then(function (res) {
            reportProfitAndLossCtrl.longRequest.flags.finish = true;
            print.turnoffInterceptorStatus();
            $timeout(function() {
              downloadSrv.getPromise('/print_report/executions/' + reportProfitAndLossCtrl.longRequest.exec_id + '/output').then(function(){
                reportProfitAndLossCtrl.longRequest.crudState.stopLoadingSuccess();
                $timeout(function() {
                  reportProfitAndLossCtrl.close();
                }, 300, false)
              });
            });
          },reportProfitAndLossCtrl.longRequest.onError);
        }

        reportProfitAndLossCtrl.print = function () {
          if ($scope.reportForm.$invalid) {
            reportProfitAndLossCtrl.isSaved = true;
            utilsService.setTouched($scope.reportForm);
            return;
          }
          var printData = reportProfitAndLossCtrl.data;
          printData.start_date = moment(printData.start_date).startOf('day').valueOf();
          printData.end_date = moment(printData.end_date).endOf('day').valueOf();

          reportProfitAndLossCtrl.longRequest.crudState.startLoading();

          if (!reportProfitAndLossCtrl.resolve.mode) {
            print.printProfitAndLoss(printData, reportProfitAndLossCtrl.format).then(function(res) {
              reportProfitAndLossCtrl.longRequest.exec_id = res.data.exec_id;
              reportProfitAndLossCtrl.status();
            }).catch(reportProfitAndLossCtrl.longRequest.onError);
          } else if (reportProfitAndLossCtrl.resolve.mode == 'cashFlow') {
            print.printCashFlow(printData, reportProfitAndLossCtrl.format).then(function(res) {
              reportProfitAndLossCtrl.longRequest.exec_id = res.data.exec_id;
              reportProfitAndLossCtrl.status();
            }).catch(reportProfitAndLossCtrl.longRequest.onError);
          } else {
            print.printPeriodTotals(printData, reportProfitAndLossCtrl.format).then(function(res) {
              reportProfitAndLossCtrl.longRequest.exec_id = res.data.exec_id;
              reportProfitAndLossCtrl.status();
            }).catch(reportProfitAndLossCtrl.longRequest.onError);
          }

        };

      }
    });

}) ();

'use strict';
angular.module('frontend').component('printSalesReport', {
  templateUrl: 'app/print/print-sales-report/print-sales-report-modal.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope,
                        print,
                        $timeout,
                        API_URL,
                        helpService,
                        uiSelectStructure,
                        companyService,
                        currenciesService,
                        categoryService,
                        statusSrv,
                        authToken,
                        $rootScope,
                        downloadSrv, 
                        utilsService,
                        cashregisterShiftsService,
                        requestStatus) {
    print.turnonInterceptorStatus();
    var ctrl = this;
    ctrl.exec_id = null;
    ctrl.isNotEmptyDates = false;
    ctrl.printData = {format: 'PDF'};
    ctrl.cashregisterShifts = [];

    ctrl.categories = {};
    ctrl.dateInterval = {};
    ctrl.categories = uiSelectStructure.getStructure(categoryService.getCategoriesAuto, ctrl.categories.value);

    companyService.divisions({limit: 200}).then(function(res){
      ctrl.divisions = $rootScope.availableDivisions(res.data.items);
      ctrl.divisionsTotal = res.data.total;
      if (res.data.total === 1) {
        ctrl.printData.division = ctrl.divisions[0];
      }
    });

    ctrl.totalStr = function(){
      if(ctrl.categories.field.total > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + ctrl.categories.field.total;
      }
      return '';
    }

    ctrl.longRequest = {
      format: null,
      exec_id: null,
      crudState: helpService.getCrudStateStructure(),
      flags: {
        processStart: false,
        finish: false
      },
      stopAskingError: function(){
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function(err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
      },
      revert: function() {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };

    ctrl.prepareReport = function() {
      if ($scope.printForm && $scope.printForm.$invalid) {
        ctrl.isSaved = true;
        utilsService.setTouched($scope.printForm);
        return;
      }
      ctrl.longRequest.crudState.startLoading();
      print.printSalesTotal({
        company_id: ctrl.printData.company ? ctrl.printData.company.id : null,
        cashregister_shift_id: ctrl.printData.cashregister_id || null,
        division_id: ctrl.printData.division ? ctrl.printData.division.id : null,
        category_id: ctrl.categories.value ? ctrl.categories.value.id : null,
        start_date: ctrl.dateInterval.startDate ? ctrl.dateInterval.startDate.valueOf() : undefined,
        end_date: ctrl.dateInterval.startDate ? ctrl.dateInterval.endDate.valueOf() : undefined
      }, ctrl.printData.format).then(function(res) {
        ctrl.longRequest.exec_id = res.data.exec_id;
        statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
          ctrl.longRequest.flags.finish = true;
          print.turnoffInterceptorStatus();
          $timeout(function() {
            downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
              ctrl.longRequest.crudState.stopLoadingSuccess();
            }).catch(ctrl.longRequest.onError);
          });
        },ctrl.longRequest.onError);
      }).catch(ctrl.longRequest.onError);

    };

    ctrl.close = function() {
      if (ctrl.longRequest.exec_id && ! ctrl.longRequest.flags.finish) {
        print.cancelPrintPriceList(ctrl.longRequest.exec_id).then(function(res) {
          ctrl.modalInstance.dismiss();
        }).catch(ctrl.longRequest.onError);
      } else {
        ctrl.modalInstance.dismiss();
      }
    };


    if (Object.keys(ctrl.resolve).length != 0) {
      ctrl.printData = ctrl.resolve;
      ctrl.prepareReport();
    }

    $scope.$watchGroup([function(){
          return ctrl.dateInterval.startDate;
        }, 
        function(){
          return ctrl.dateInterval.endDate;
        }], function(newVal) {
      if ($scope.printForm.$valid && newVal[0] && newVal[1]) {
        var data = {
          filter_start_date_from: newVal[0].valueOf(),
          filter_start_date_to: newVal[1].valueOf()
        }
        cashregisterShiftsService.cashregisterShifts(data).then(
          function (res) {
            ctrl.cashregisterShifts = res.data.items;
          },
          function (error) {
            requestStatus.error('Во время получения смен произошла ошибка. Повторите попытку позже.');
        });
      } else {
        ctrl.cashregisterShifts = [];
      }
    });

  }
});


(function () {
  'use strict';

	angular.module('frontend').service('priceSettingsService', priceSettingsService);

  function priceSettingsService(userSettingsService, API_URL) {

    var DEFAULT_COLUMN_LIMIT = 3;

    // Получение количества выводимых колонок
    this.getColumnCount = function(priceListType) {
      return userSettingsService.loadProperty("price-list-settings-" + priceListType.toLowerCase(), "columns", "limit") || DEFAULT_COLUMN_LIMIT;
    }

    // Установка количества выводимых колонок
    this.setColumnCount = function(priceListType, count) {
      return userSettingsService.saveProperty("price-list-settings-" + priceListType.toLowerCase(), "columns", "limit", count);
    }

    // Получение приоритета выводимых колонок
    this.getColumnPriority = function(priceListType) {
      return userSettingsService.loadProperty("price-list-settings-" + priceListType.toLowerCase(), "columns", "priority");
    }

    // Установка приоритета выводимых колонок
    this.setColumnPriority = function(priceListType, priority) {
      return userSettingsService.saveProperty("price-list-settings-" + priceListType.toLowerCase(), "columns", "priority", priority);
    }

    // Возвращает колонки с учетом настроек приоритета и видимости
    this.getColumnWithPriority = function(priceListType, columns) {
      var result = [];
      var settings = this.getColumnPriority(priceListType);
      if(!settings){
        return columns;
      }
      _.forEach(settings, function (settingsCol) {
        var column = _.findWhere(columns, {id: settingsCol.id});
        if (column && settingsCol.visible) {
          result.push(column);
        };
      });
      return result;
    };
  }

})();


(function() {
  'use strict';

angular.module('frontend').controller('priceSettingsController', priceSettingsController);

  function priceSettingsController($scope,
                                   priceSettingsService,
                                   priceColumnSrv,
                                   $window, 
                                   $stateParams) {
    var priceSettingsCtrl = this;
    var defaultColumn = [];

    // тип порайс-листа
    priceSettingsCtrl.type = $stateParams.parent;

    // Загрузка списка колонок
    priceColumnSrv.priceColumns(priceSettingsCtrl.type).then(function (data) {
      defaultColumn = data;
      var settings = priceSettingsService.getColumnPriority(priceSettingsCtrl.type);
      var result = [];
      // если в сторе нет настроек, то установить всем колонкам видимость
      if(!settings){
        _.forEach(data, function (column) {
            column.visible = true;
        });
        priceSettingsCtrl.columns = data;
        return;
      }

      _.forEach(settings, function (settingsCol) {
          var column = _.findWhere(data, {id: settingsCol.id});
          if (column) {
            column.visible = settingsCol.visible;
            result.push(column);
          };
      });
      priceSettingsCtrl.columns = result;
    });

    // количество отображаемых колонок
    priceSettingsCtrl.columnsNumber = priceSettingsService.getColumnCount(priceSettingsCtrl.type);

    priceSettingsCtrl.cancel = function() {
      priceSettingsCtrl.modalInstance.dismiss();
    };

    /* настройки по умолчанию */
    priceSettingsCtrl.default = function() {
      var settings = [];
      _.forEach(defaultColumn, function (column) {
        settings.push({
          id: column.id,
          visible: true
        });
      });
      priceSettingsService.setColumnCount(priceSettingsCtrl.type, ($window.innerWidth < 1300)? 2 : 3);  // вычисление ширины экрана для того чтобы в ячейку помещались длинные суммы RECS-3844
      priceSettingsService.setColumnPriority(priceSettingsCtrl.type, settings);
      priceSettingsCtrl.modalInstance.close();
    }

    /* сохранение */
    priceSettingsCtrl.save = function() {
      var settings = _.map(priceSettingsCtrl.columns, function (column) {
        return {
          id: column.id,
          visible: column.visible
        };
      });
      priceSettingsService.setColumnCount(priceSettingsCtrl.type, priceSettingsCtrl.columnsNumber);
      priceSettingsService.setColumnPriority(priceSettingsCtrl.type, settings);
      priceSettingsCtrl.modalInstance.close();
    }

    // for drag&drop
    var helpIndex, listCount;

    priceSettingsCtrl.listMoved = function (index, item, parent) {
      if(listCount < parent.length){
        if(helpIndex > index){
          parent.splice(index, 1)
        } else {
          parent.splice(index + 1, 1)
        }
      }
    };

    priceSettingsCtrl.dropCallback = function (index, item, external, type, parent){
      helpIndex = index;
      listCount = parent.length;
      parent.splice(index, 0, item)
    };

    // настройки для скролла
    priceSettingsCtrl.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced:{
        updateOnContentResize: true
      },
      setHeight: 383,
      scrollInertia: 0
    };

  }
})();

(function () {
  'use strict';

  angular.module('frontend').component('priceSettings', {
    bindings: {
      modalInstance: '<'
    },
    controller: 'priceSettingsController',
    controllerAs: 'priceSettingsCtrl',
    templateUrl: 'app/price-list/settings/priceSettings.html'
  });

})();

'use strict';

angular.module('frontend').component('priceListExport', {
  templateUrl: 'app/price-list/price-list-export/price-list-export-modal.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope, print, helpService, authToken, statusSrv, $timeout, API_URL, downloadSrv, errorMessageService) {
    var ctrl = this;
    ctrl.columns = ctrl.resolve.columns;
    ctrl.categoriesIds = ctrl.resolve.categoriesIds;
    ctrl.column = ctrl.columns[0] ? ctrl.columns[0] : null;
    ctrl.date = helpService.now();
    ctrl.longRequest = {
      exec_id: null, //ID задачи построения отчета
      crudState: helpService.getCrudStateStructure(), // состояния странички
      flags: {
        processStart: false, // флаг начала опроса статуса выполнения задачи
        finish: false // флаг конца опроса выполнения задачи
      },
      stopAskingError: function(){ // прекращение опроса статуса из-за ошибки
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function(err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
      },
      revert: function() {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };

    ctrl.dateOptions = {singleDatePicker: true, correctTimeZone: false, opens: 'right', minDate: helpService.now()};

    ctrl.prepareExport = function() {
      ctrl.longRequest.crudState.startLoading();
      print.exportPriceList({
        column_id: ctrl.column.id,
        effective_date: ctrl.date.valueOf(),
        category_ids: ctrl.categoriesIds
      }).then(function(res) {
        ctrl.longRequest.exec_id = res.data.exec_id;
        statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
          ctrl.longRequest.flags.finish = true;
          print.turnoffInterceptorStatus();
          if (res.status == 'FINISHED') {
            $timeout(function() {
              downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
                ctrl.longRequest.exec_id = null;
                ctrl.longRequest.crudState.stopLoadingSuccess();
              });
            });
          }
        },ctrl.longRequest.onError);
      }).catch(ctrl.longRequest.onError);
    };

    ctrl.configScroll = {
      axis:'y',
      autoHideScrollbar: false,
      theme: 'dark',
      advanced:{
        updateOnContentResize: true
      },
      setHeight: 200,
      scrollInertia: 0,
      scrollButtons: {
        enable: false
      }
    };

    ctrl.onDateToPickerIntervalClose = function(value, name) {
      ctrl.dateInterval[name] = value;
    };


    ctrl.close = function() {
      ctrl.modalInstance.close(ctrl.longRequest.exec_id);
    };

  }
});

(function () {
  'use strict';

  angular.module('frontend').controller('priceModalController', priceModalController);

  function priceModalController($uibModalInstance,
                                $scope,
                                $timeout,
                                priceLocalSrv, // сервис для хранения временных изменений (по результатам раоты модального окна изменения временные)
                                node, // узел позиции
                                column_id, // id колонки для её показа
                                prices, // текущий набор цен
                                columns, // пользовательские колонки
                                lock, // блокировка редактирования
                                price_list_type, // тип прайс-листа (розничный или оптовый)
                                catalog_item,
                                from_cell, // флаг того что попап открыи из ячейки
                                priceListSrv, // сервис праййслстов
                                updateTree, // обновления структуры дерева
                                helpService) {
    var priceModalCtrl = this,
      columnsLen = columns.data.length;
    var today = helpService.now();
    priceModalCtrl.noPrice = angular.isString(prices) && prices === 'no_prices';
    priceModalCtrl.catalogItem = node && node.catalog_item || catalog_item;
    priceModalCtrl.lock = lock;
    priceModalCtrl.node = node;
    priceModalCtrl.from_cell = from_cell;
    priceModalCtrl.priceListType = price_list_type;
    priceModalCtrl.allow = true;
    priceModalCtrl.deletedIds = [];

    // сортировка дате и количеству
    priceModalCtrl.prices = _.map(prices, function (columnPrice, key) {
      columnPrice = columnPrice.sort(function (a, b) {
        var aDate = moment(a.effective_date).valueOf();
        var bDate = moment(b.effective_date).valueOf()

        if (aDate == bDate) {
          return a.effective_qty - b.effective_qty;
        } else {
          return (aDate < bDate) ? -1 : (aDate > bDate) ? 1 : 0;
        }
      });
    });
    
    if (!priceModalCtrl.noPrice) {
      angular.forEach(prices, function (priceArray, key) {
        priceModalCtrl.prices[key] = _.map(priceArray, function (price) {
          return angular.copy(price);
        });
      });
    }
    priceModalCtrl.columns = columns.data;

    /* метод добавления цены в для колонки */
    priceModalCtrl.addPrice = function (columnId) {
      priceModalCtrl.prices = priceModalCtrl.prices || {};
      priceModalCtrl.prices[columnId] = priceModalCtrl.prices[columnId] || [];
      var newPrice = {
        effective_date: today.valueOf(),
        free_of_control_price: false,
        effective_qty: 1,
        column_ref: {
          id: columnId
        },
        $local: true
      };
      priceModalCtrl.prices[columnId].push(newPrice);
      // посе добавления новой цены необходимо пересчитать статус валидации
      $timeout(function () {
        $scope.$broadcast('recalculatePriceValidationStatus', {
          column_ref: {
            id: columnId
          }
        });
      });
    };

    /* настройка отображения окна колонок */
    priceModalCtrl.columnsPaging = {
      limit: 3, // эмпирически
      offset: 0
    };

    angular.forEach(priceModalCtrl.columns, function (column, key) {
      // переключение на колонку, если попап был вызван из ячейки цены
      if (column_id && column.id == column_id && priceModalCtrl.columns.length > 3) {
        priceModalCtrl.columnsPaging.offset = (key > columnsLen - 3) ? columnsLen - 3 : key;
      }
    });

    /* настройка для скролла */
    priceModalCtrl.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      setHeight: (priceModalCtrl.lock) ? 408 : 345,
      scrollInertia: 0,
      axis: 'y'
    };

    // удаление ячейки с ценой
    priceModalCtrl.removePrice = function (prices, index) {
      if (prices[index].$local) {
        prices.splice(index, 1);
      } else {
        // для удаления закоммиченных цен использект промежуточное состояние
        prices[index].$deleted = true;
        priceModalCtrl.deletedIds.push(prices[index].id);
      }
    };

    /**
     * Обработчик события изменения данный ценовой ячейки
     */
    $scope.$on('priceCommitChangedStarted', function ($event, data) {
      // обработчик события модального окна принимает решение о необходимости отправки события дочерним ячейкам для пересчета статуса валидности
      $scope.$broadcast('recalculatePriceValidationStatus', data);
    });

    /**
     * Метод валидирует цену согласно существующим
     *
     * @param price
     */
    priceModalCtrl.validatePrice = function (price, columnId) {
      if (priceModalCtrl.priceListType == "PURCHASE") {
        priceModalCtrl.allow = true;
        angular.forEach(priceModalCtrl.prices[columnId], function (temp) {
          if (price.$$hashKey !== temp.$$hashKey && price.effective_qty == temp.effective_qty) {
            priceModalCtrl.allow = false;
          }
        });
        return priceModalCtrl.allow;
      }

      // исходим из предположения, что для автоматически рассчитанных цен дата и штучность не меняется
      priceModalCtrl.allow = true;
      angular.forEach(priceModalCtrl.prices[columnId], function (temp) {
        if (temp == price) {
          return; // отбрасываем сам объект сравнения
        }
        if (((temp.effective_qty == undefined && price.effective_qty == undefined)
            || (temp.effective_qty == price.effective_qty)) &&
          ((temp.effective_date == undefined && price.effective_date == undefined) ||
            (Math.floor(new Date(temp.effective_date).getTime() / (1000 * 60 * 60 * 24)) == Math.floor(new Date(price.effective_date).getTime() / (1000 * 60 * 60 * 24))))) {
          priceModalCtrl.allow = false; // встретилась цена с таким же значением цены и даты
        }
      });
      return priceModalCtrl.allow;
    };

    /* отмена */
    priceModalCtrl.cancel = function (mode) {
      $uibModalInstance.close({mode: mode})
    };

    /* выход с фиксацией во временном хранилище наработок */
    priceModalCtrl.saveAndClose = function () {
      if (!priceModalCtrl.allow || priceModalCtrl.formCtrl.$invalid) {
        priceModalCtrl.isSaved = true;
        return;
      }
      if (priceModalCtrl.priceListType == 'PURCHASE') {
        // сначала отправить запрос на удаление цен
        priceListSrv.immediateRemovePrices(priceModalCtrl.deletedIds).then(function () {
          //потом сфромировать правильный объект с измененными ценами во всех колонках
          var line = {
            catalog_item: priceModalCtrl.node.catalog_item,
            prices: []
          };
          for (var columnId in priceModalCtrl.prices) {
          //angular.forEach(priceModalCtrl.prices, function (prices, columnId) {
            var column = _.find(priceModalCtrl.columns, function (column) {
              return columnId == column.id;
            });
            angular.forEach(priceModalCtrl.prices[columnId], function (price) {
              if (!price.$deleted) {
                line.prices.push({
                  id: price.id,
                  effective_qty: price.effective_qty,
                  price_for_one_uom: price.price_for_one_uom,
                  column_ref: {
                    id: column.id,
                    name: column.name
                  }
                });
              }
            });
          };
          priceListSrv.immediateSavePrices(line, priceModalCtrl.node.catalog_item.id).then(function () {
            if (updateTree) updateTree();
            priceModalCtrl.cancel();
          });

        });


      } else {
        priceLocalSrv.savePrices(priceModalCtrl.node.catalog_item.id, priceModalCtrl.prices, priceModalCtrl.priceListType).then(function (prices) {
          $uibModalInstance.close();
        });
      }
    };

    /* удаление выбранного товара или услуги из прайслиста */
    priceModalCtrl.removeCatalogItem = function (id) {
      priceListSrv.removeItems(priceModalCtrl.priceListType, {
        items: [id]
      }).then(function () {
        if (updateTree) updateTree();
        priceModalCtrl.cancel();
      });
    };

    /**
     * Подсказка для показа количества подразделений, привязанных к колонке
     *
     * @param column
     */
    priceModalCtrl.tipForDivisions = function (column) {
      var str = '';
      if (column.divisions.length) {
        str = 'Действует только для подразделений \n';
        angular.forEach(column.divisions, function (division, key) {
          if (key < 4) {
            str += ("<div>" + division.name + "</div>");
          } else if (key == 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    };

    /**
     * Подсказка для показа количества контрагентов, привязанных к колонке
     *
     * @param column
     */
    priceModalCtrl.tipForCounterparties = function (column) {
      var str = '';
      if (column.counterparties.length) {
        str = 'Действует только для контрагентов \n';
        angular.forEach(column.counterparties, function (counterparty, key) {
          if (key < 4) {
            str += ("<div>" + counterparty.name + "</div>");
          } else if (key == 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    }
  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('newPriceItemModalController', newPriceItemModalController);

  function newPriceItemModalController($uibModalInstance,
                                       $scope,
                                       $q,
                                       $log,
                                       $timeout,
                                       hiddenItems,
                                       type, // тип прайс-листа
                                       errorMessageService, // уведомление пользователя
                                       priceListSrv, // сервис для работы с прайс-листом
                                       categoryInputMode,
                                       categoryService // сервис для загрузки категорий участника в дерево
  ) {
    var newPriceItemModalCtrl = this;
    newPriceItemModalCtrl.lock = false;

    // анализ строки поиска
    $scope.$watch(function () {
      return newPriceItemModalCtrl.searchText
    }, function (newVal, oldVal) {
      // если предыдущее знаение определено, а текущее пусто
      if (oldVal != '' && newVal == '') {
        newPriceItemModalCtrl.showSearch = false;
      }
    });

    /* настройка для скролла */
    newPriceItemModalCtrl.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      setHeight: 416,
      scrollInertia: 0,
      axis: 'y'
    };

    newPriceItemModalCtrl.categoryInputMode = categoryInputMode;

    // Узлы дерева
    newPriceItemModalCtrl.root = {
      name: 'Каталог товар и услуг',
      root: true,
      has_children: true,
      children: [],
      hiddenItems: newPriceItemModalCtrl.hiddenItems
    };

    // Callback загрузки дерева
    newPriceItemModalCtrl.onTreeLoaded = function () {
      newPriceItemModalCtrl.root.expandFuncByModel({});
    };

    // структура пейджинга для поиска
    newPriceItemModalCtrl.searchPaging = {
      current: 0,
      limit: 10,
      offset: 0,
      total: undefined
    };


    function searchCallbackSuccess(data) {
      newPriceItemModalCtrl.searchResult = data.data.items;
      newPriceItemModalCtrl.showSearch = true;
      newPriceItemModalCtrl.searchPaging.total = data.data.total;
    }

    function searchCallbackFail(error) {
      $log.log('Ошибка при поиске: ' + error);
    }

    /* Метод поиска в каталоге участника */
    newPriceItemModalCtrl.search = function (withClear) {
      if (withClear) {
        newPriceItemModalCtrl.searchPaging.current = 0;
        newPriceItemModalCtrl.searchPaging.offset = 0;
      }
      if (!categoryInputMode) {
        priceListSrv.searchNotInPriceElements(type, newPriceItemModalCtrl.searchPaging, newPriceItemModalCtrl.searchText).then(
          searchCallbackSuccess, searchCallbackFail
        )
      } else {
        categoryService.getCategoriesAuto(newPriceItemModalCtrl.searchText, newPriceItemModalCtrl.searchPaging).then(
          searchCallbackSuccess, searchCallbackFail
        )
      }
    };

    /* раскрытие узлов дерева в упрощенном режиме */
    newPriceItemModalCtrl.expandSimple = function (node) {
      return (node.has_children) ? categoryService.getDomainCategories(node.id).then(function(data) {
        if (data.data) {
          if (hiddenItems) {
            return data.data.filter(function (value) {
                return !~hiddenItems.indexOf(value.id)
            });
          }
          return data.data;
        }
      }) : $q.when([]);
    };

    /* Callback для раскрытия дерева */
    newPriceItemModalCtrl.expand = function (node, nextPage) {
      // Загрузка дочерних категорий только при установленном флаге наличия
      var categoryPromise = (!nextPage && node.has_children) ? priceListSrv.getNotInPriceCategory(type, node.id).then(function (data) {
        if (data.data) {
          if (hiddenItems) {
            return data.data.filter(function (value) {
              return !~hiddenItems.indexOf(value.id)
            });
          }
          return data.data;
        }
      }) : $q.when([]);

      var page = nextPage ? {
        offset: _.filter(node.children, function(item) {return item.unstructure}).length
        // лимит по-умолчанию определяется в сервисе
      } : undefined;

      // Загрузка дочерних элементов только при их наличии
      var itemPromise = (node.item_count) ? priceListSrv.getNotInPriceCategoryItems(type, node.id, undefined, page).then(function (data) {
        if (data.data) {
          node.total = data.data.total;
          if (hiddenItems) {
            return data.data.items.filter(function (value) {
              return !~hiddenItems.indexOf(value.id)
            });
          }
          return data.data.items;
        }
      }) : $q.when([]);
      // Композиция промисов, и конкатенация рузультатов (в итоге компонент дерева не в курсе нескольки запросов при callback и остается универсальным)
      return $q.all([categoryPromise, itemPromise]).then(function (values) {
        angular.forEach(values[1], function (item) {
          item.unstructure = true;
          item.has_children = false;
          item.item_count = 0;
        })
        return values[0].concat(values[1]);
      })
    };

    newPriceItemModalCtrl.selectNode = function (node) {
      newPriceItemModalCtrl.selectedNode = newPriceItemModalCtrl.root.getSelectedNode();
    };

    /* метод раскрывает узлы деева по пути */
    newPriceItemModalCtrl.expandTreePath = function (path) {
      newPriceItemModalCtrl.root.expandFunc(path).then(function () {
        newPriceItemModalCtrl.showSearch = false;
      }, function () {
        newPriceItemModalCtrl.showSearch = false;
      });
    }

    /* отмена */
    newPriceItemModalCtrl.cancel = function () {
      $uibModalInstance.dismiss();
    };

    newPriceItemModalCtrl.selectAndClose = function () {
      $uibModalInstance.close(newPriceItemModalCtrl.root.getSelectedNode());
    };

    newPriceItemModalCtrl.getSelectedItems = function(){
      // в зависимости от того, какой контрол отображается (дерево или результат поиска) исользуем различные модели выбора
      if (newPriceItemModalCtrl.showSearch) {
        // случай активного поиска
        return _.map(_.where(newPriceItemModalCtrl.searchResult, {_checked: true}), function (obj) {
          return obj; // тут был маппинг только идентификаторов, из-за различий в АПИ приходится выносить логику в вызывающий контроллер
        });
      } else {
        // случай активного дерева
        return newPriceItemModalCtrl.root.getSelectionModel();
      }
    }

    /* выход с фиксацией во временном хранилище наработок */
    newPriceItemModalCtrl.saveAndClose = function () {
      console.log(newPriceItemModalCtrl.root.getSelectedNode())
      var selectionModel = newPriceItemModalCtrl.getSelectedItems();

      // Формирование нужной структуры запроса по списку выбраннх узлов
      var selectionModelIds = _.map(selectionModel, function (node) {
        return node.id;
      });

      if (selectionModelIds && selectionModelIds.length) {
        newPriceItemModalCtrl.lock = true;
        priceListSrv.addItems(type,
          {
            items: selectionModelIds
          }
        ).then(function (success) {
          newPriceItemModalCtrl.lock = false;
          $uibModalInstance.close(success);
        }, function (error) {
          errorMessageService.showModal({message: 'При добавлении произошла ошибка', submessage: error});
        })
      } else {
        newPriceItemModalCtrl.isSaved = true;
        return;
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('deletePriceItemModalController', deletePriceItemModalController);

  function deletePriceItemModalController($uibModalInstance, type, deleteItems // удаление элементов каталога из прайс-листа
  ) {
    var deletePriceItemModalCtrl = this;
    deletePriceItemModalCtrl.priceListType = type;
    deletePriceItemModalCtrl.close = function() {
      $uibModalInstance.dismiss();
    };
    deletePriceItemModalCtrl.delete = function() {
      deleteItems();
      $uibModalInstance.dismiss();
    };
  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('importPriceListSrv', importPriceListSrv);

  function importPriceListSrv($http, API_URL) {

    /**
     * Запрос Ошибок в файле
     *
     * @param importId
     */
    this.getPriceListResult = function (importId) {
      return $http.get(API_URL + "/import/price_list/" + importId + "/result").then(function (res) {
        return res.data;
      });
    }

    /**
     * Запрос обработки файла
     * Главные настройки импорта
     * @param importSettings
     */
    this.priceListProcessing = function (importSettings) {
      return $http.post(API_URL + "/import/price_list/processing", importSettings);
    }

    /**
     * Отменяет импорт файла прайсов
     *
     * @param importId
     */
    this.cancelFileImport = function (importId) {
      return $http.put(API_URL + "/import/price_list/" + importId + "/cancel");
    }

  }

}) ();

(function() {
  'use strict';

  angular.module('frontend').controller('importPriceListController', importPriceListController);

  function importPriceListController($scope,
                                 $state,
                                 auth,
                                 type,
                                 $rootScope,
                                 cardHistory,
                                 FileUploader,
                                 $uibModal,
                                 API_URL,
                                 importPriceListSrv,
                                 authToken,
                                 errorMessageService,
                                 statusSrv,
                                 MAX_UPLOAD_FILE_SIZE,
                                 $window,
                                 priceColumns,
                                 helpService
  ) {
    var vm = this;
    // тип прайс-листа
    vm.type = type;
    vm.activeStep = 0; // активный шаг импорта
    vm.columnNumber = 0; // номер выбранной колонки
    vm.fileErrors = undefined; // ошибки в обработанном файле
    vm.priceColumns = priceColumns; // колонки розничного прайслиста
    vm.type = $state.params.parent;
    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep('importPriceList') || {name: 'priceList', param: {parent: 'RETAIL'}};
      $state.go(prev.name !== '' ? prev.name : 'priceList', prev.param || {parent: 'RETAIL'});
    }
    // возможные названия колонок
    vm.headerData = [
      {id: "ALCOHOL_PRODUCT", label: "Алкогольная продукция"},
      {id: "VENDOR_CODE", label: "Артикул производителя"},
      {id: "UOM", label: "Единица измерения позиции"},
      {id: "ALT_UOM", label: "Единица измерения количества/меры нетто"},
      {id: "CATEGORY", label: "Категория"},
      {id: "ITEM_CODE", label: "Код позиции"},
      {id: "ALT_UOM_RATE", label: "Количество/мера нетто"},
      {id: "ITEM_NAME", label: "Наименование позиции"},
      {id: "PACKAGED", label: "Товар весовой/мерный"},
      {id: "TAX_GROUP", label: "Налоговая группа"},
      {id: "ITEM_DESCRIPTION", label: "Описание позиции"},
      {id: "ALCOHOL_LABEL", label: "Сканировать акцизную марку"},
      {id: "SKU_OR_SERVICE", label: "Товар или услуга"},
      {id: "PRICE", label: "Цена"},
      {id: "FREE_OF_CONTROL_PRICE", label: "Тип цены"},
      {id: "GTIN", label: "Штрих-код"},
      {id: "CASH_REGISTER_ITEM_TYPE", label: "Предмет расчета"},
    ];

    vm.headerData.sort(function ( a, b ) {
      if ( a.label < b.label ){
        return -1;
      }
      if ( a.label > b.label ){
        return 1;
      }
      return 0;
    });

    if (vm.type == 'WHOLE_SALE') {
      vm.headerData.push({id: "COUNT_FOR_PRICE", label: "Цена за количество"});
    }

    // настройка для датапикера
    vm.datePickerOpts = {singleDatePicker: true, correctTimeZone: false, minDate: helpService.now()};
    vm.fileData = {};

    vm.processing = {
      start_line: 1,
      actual_date: helpService.now(),
      create_position: true,
      update_position: true,
      mode: "CHECKING",
      column: {},
      column_mapping: {}
    };

    // подстановка первой колонки по умолчанию
    if(vm.priceColumns.length){
      vm.processing.column = {
        id: vm.priceColumns[0].id,
        name: vm.priceColumns[0].name
      };
    }

    function setColumnsMapping() {
      vm.processing.column_mapping = angular.copy(vm.fileData.lines[0]);
      angular.forEach(vm.processing.column_mapping, function(cell, key){
        var isset = false;
        angular.forEach(vm.headerData, function(value){
          if (cell.replace(/[\s\n\r]+/g, '') === value.label.replace(/[\s\n\r]+/g, '')) {
            isset = value;
          }
        });
        if(!isset){
          vm.processing.column_mapping[key] = '';
        }else{
          vm.processing.column_mapping[key] = isset.id;
        }
      });
    }

    // записть изменееного имени колонки в объект
    vm.changeColumnName = function(row, index){
      vm.headersCheck = undefined;
      vm.processing.column_mapping[index] = row;
      // проверка уникальности имени колонки
      vm.columnErrorInds = [];
      angular.forEach(vm.processing.column_mapping, function(val1, key1){
        angular.forEach(vm.processing.column_mapping, function(val2, key2){
          if (val1 && val2 && key1 < key2 && val1 === val2) {
            vm.columnErrorInds.push(key1);
            vm.columnErrorInds.push(key2);
          }
        });
      });
    };
    // изменение "Первой строки" загруженного документа
    vm.changeRowNum = function(isIncre){
      if(isIncre){
        if(vm.processing.start_line < vm.fileData.lines.length - 1){
          vm.processing.start_line++;
          var removed = vm.lineHelper.splice(vm.processing.start_line-1,1);
          vm.lineHelper.splice(vm.processing.start_line, 0, removed[0]);
        }
      }else{
        if(vm.processing.start_line > 0){
          vm.processing.start_line--;
          var removed = vm.lineHelper.splice(vm.processing.start_line,1);
          vm.lineHelper.splice(vm.processing.start_line+1, 0, removed[0]);
        }
      }
    };

    // загрузка файла
    vm.uploader = new FileUploader({
      url: API_URL + "/import/price_list/upload?type=" + vm.type,
      headers: {'X-Session-Id': authToken.getToken()},
      queueLimit: 1,
      onAfterAddingFile : function(){
        var file = vm.uploader.queue[0].file;
        var nameArr = file.name.split('.');

        vm.fileError = '';
        if(nameArr[nameArr.length - 1] !== 'xls' && nameArr[nameArr.length - 1] !== 'xlsx'){  // ошибка неверный формат файла
          vm.uploader.queue[0].isError = true;
          vm.fileError = 'format';
          return;
        }
        if(file.size > MAX_UPLOAD_FILE_SIZE){ // ошибка файл больше чем 5 МБ
          vm.uploader.queue[0].isError = true;
          vm.fileError = 'size';
          return;
        }
        vm.uploader.queue[0].upload();
      },
      onWhenAddingFileFailed: function(item, filter, options){
        vm.uploader.clearQueue();
        vm.uploader.addToQueue([item]);
      },
      onSuccessItem: function(item, response, status){
        vm.setColumnCount($window.innerWidth);
        vm.offsetColumn = 0;
        vm.processing.start_line = 1;
        vm.fileData = response;
        vm.processing.import_id = vm.fileData.import_id;
        setColumnsMapping();
        vm.lineHelper = angular.copy(response.lines);
        vm.lineHelper.splice(1, 0, [true]);
        // если в файле одна строка, то по умолчанияю "первая строка" начинается с нуля
        if(vm.fileData.line_count == 1){
          vm.processing.start_line = 0;
        }
        // обработка пустого файла
        if(!vm.fileData.line_count){
          vm.fileError = 'empty';
          vm.uploader.queue[0].progress = false;
          vm.uploader.queue[0].isSuccess = false;
          vm.uploader.queue[0].isError = true;
        }
      }
    });

    vm.setColumnCount = function(windowWidth){
      if(windowWidth < 1100){
        vm.countColumn = 3;
      }else if(windowWidth < 1400){
        vm.countColumn = 4;
      }else if(windowWidth < 1900){
        vm.countColumn = 5;
      }else{
        vm.countColumn = 6;
      }
    }
    // отслеживание ширины экрана для удобного отображения количества колонок bp файле
    angular.element(window).on('resize', function () {
      vm.setColumnCount($window.innerWidth);
    });

    // переключение колонок
    vm.switchColumn = function(next){
      if(next && (vm.offsetColumn + vm.countColumn) < vm.processing.column_mapping.length){
        vm.offsetColumn++;
      }else if(vm.offsetColumn){
        vm.offsetColumn--;
      }
    }

    // выбор колонки, куда загружать данные
    vm.choseColumn = function(index){
      if(index !== -1){
        vm.processing.column = {
          id: vm.priceColumns[index].id,
          name: vm.priceColumns[index].name
        };
      }else{
        vm.processing.column = {name: vm.newColumnName};
      }
    };

    vm.checkUniqueColumnName = function (name) {
      vm.issetColumnName = _.find(vm.priceColumns, function (column) {
        return column.name.toLowerCase() === name.toLowerCase();
      });
    };

    vm.checkForm = function () {
      // проверка полей формы, выделение красным пустых полей
      angular.forEach($scope.importForm.$error, function (controls) {
        angular.forEach(controls, function(control) {
          control.$setDirty();
        });
      });
    };

    // возврат на шаг назад
    vm.back = function(){
      vm.activeStep = vm.activeStep - 1;
      vm.headersCheck = true;
      vm.processing.mode = 'CHECKING';
    }

    // навигация по шагам импорта файла
    vm.next = function (){
      if(vm.uploader.queue[0] && vm.uploader.queue[0].isSuccess){
        if (vm.activeStep === 1) {
          vm.checkForm();

          // проверка указания всех обязательных колонок
          vm.reqColumn = {
            category: !!_.find(vm.processing.column_mapping, function (cell) {
              return cell === "CATEGORY";
            }),
            code: !!_.find(vm.processing.column_mapping, function (cell) {
              return cell === "ITEM_CODE";
            }),
            name: !!_.find(vm.processing.column_mapping, function (cell) {
              return cell === "ITEM_NAME";
            }),
            price: !!_.find(vm.processing.column_mapping, function (cell) {
              return cell === "PRICE";
            })
          };
          vm.headersCheck = vm.reqColumn.category && vm.reqColumn.code &&  vm.reqColumn.name && vm.reqColumn.price;
          if(vm.headersCheck){
            vm.activeStep++;
          }else{
            vm.headersCheck = false;
          }
          return;
        }
        if (vm.activeStep === 2) {
          if(vm.columnNumber == vm.priceColumns.length && vm.newColumnName){
            vm.processing.column = {name: vm.newColumnName};
          }else{
            vm.choseColumn(vm.columnNumber);
          }

          if(!vm.processing.column.name || vm.processing.actual_date.isEmpty){
            vm.checkForm();
            return;
          }else{
            vm.activeStep++;
            vm.fileErrors = undefined;
            angular.forEach(vm.processing.column_mapping, function(item,  key){
              if(!item){
                vm.processing.column_mapping[key] = 'SKIP';
              }
            });
            vm.processing.actual_date = vm.processing.actual_date.toDate().getTime();
            importPriceListSrv.priceListProcessing(vm.processing).then(function(data){
              vm.processing.import_id = data.data.import_id;

              angular.forEach(vm.processing.column_mapping, function(item,  key){
                if (item == 'SKIP') {
                  vm.processing.column_mapping[key] = '';
                }
              });
              vm.processing.actual_date = moment.utc(vm.processing.actual_date);
              statusSrv.getPromise('/import/price_list/' + vm.processing.import_id + '/status').then(function (res) {
                  importPriceListSrv.getPriceListResult(vm.processing.import_id).then(function(res){
                    var errorStr = ['ошибка', 'ошибки', 'ошибок'],
                        successStr = ['строка', 'строки', 'строк'],
                        cases = [2, 0, 1, 1, 1, 2];
                    vm.fileErrors = res;
                    if(res.file_errors){ // вывод правильного окончания для ошибки
                      vm.errorCountStr = errorStr[ (res.file_errors % 100 > 4 && res.file_errors % 100 < 20)? 2 : cases[(res.file_errors % 10 < 5)?res.file_errors % 10 : 5] ]
                    }else{
                      vm.errorCountStr = '';
                    }
                    if(res.success_count){ // вывод правильного окончания для ошибки
                      vm.successCountStr = successStr[ (res.success_count % 100 > 4 && res.success_count % 100 < 20)? 2 : cases[(res.success_count % 10 < 5)?res.success_count % 10 : 5] ]
                    }else{
                      vm.successCountStr = '';
                    }
                  },
                  function (error) {
                    vm.fileErrors = {};
                    vm.processing.actual_date = moment.utc(vm.processing.actual_date);
                    vm.activeStep--;
                    errorMessageService.showModal({message: 'При получении результатов произошла ошибка', submessage: error});
                  });
                },
                function (res) {
                  vm.activeStep--;
                  errorMessageService.showModal({message: 'При проверке данных произошла ошибка'});
                },
                function (error) {
                  errorMessageService.showModal({message: 'При проверке данных произошла ошибка'});
                });
            },
            function (error) {
              vm.fileErrors = {};
              vm.processing.actual_date = moment.utc(vm.processing.actual_date);
              vm.activeStep--;
              errorMessageService.showModal({message: 'При запросе импорта произошла ошибка', submessage: error});
            });
            return;
          }
        }
        vm.activeStep++;
      }
    };

    // конечный импорт
    vm.importStart = function(){
      $uibModal.open({
        templateUrl: 'app/price-list/import/modal/import-modal.html',
        size: 'middle-width',
        controller: function($scope, $uibModalInstance, statusSrv){
          $scope.fileErrors = vm.fileErrors;
          $scope.loadImport = false;
          $scope.type = vm.type;

          // установка статусов для ошибки
          $scope.errorStatuses = function(){
            $scope.loadError = true;
            $scope.loadImport = false;
            $scope.loadSuccess = false;
          }

          // начать импорт
          $scope.import = function () {
            $scope.showInfo = false;
            $scope.loadImport = true;
            vm.processing.mode = 'UPDATING';
            angular.forEach(vm.processing.column_mapping, function(item,  key){
              if(!item){
                vm.processing.column_mapping[key] = 'SKIP';
              }
            });
            if(vm.processing.actual_date){
              vm.processing.actual_date = vm.processing.actual_date.toDate().getTime();
            }

            importPriceListSrv.priceListProcessing(vm.processing).then(function (res) {
              vm.processing.import_id = res.data.import_id;
              vm.processing.actual_date = moment.utc(vm.processing.actual_date);
              angular.forEach(vm.processing.column_mapping, function(item,  key){
                if (item === 'SKIP') {
                  vm.processing.column_mapping[key] = '';
                }
              });
              // опрос статуса операции
              statusSrv.getPromise('/import/price_list/' + res.data.import_id + '/status').then(function (res) {
                $scope.loadImport = false;
                $scope.loadSuccess = true;
              },
              function (res) {
                $scope.errorMessage = "Ошибка";
                $scope.errorStatuses();
              },
              function (error) {
                if(error.status == 500 ||  error.status == 403 || error.status == 401){
                  $uibModalInstance.dismiss();
                }else{
                  $scope.errorMessage = error.data.message;
                  $scope.errorStatuses();
                }
              });
            },
            function (error) {
              if(error.status == 500 ||  error.status == 403 || error.status == 401){
                $uibModalInstance.dismiss();
              }else{
                $scope.errorMessage = error.data.message;
                $scope.errorStatuses();
              }
              vm.processing.actual_date = moment.utc(vm.processing.actual_date);
              angular.forEach(vm.processing.column_mapping, function(item,  key){
                if (item == 'SKIP') {
                  vm.processing.column_mapping[key] = '';
                }
              });
            });
          };
          // флаг для вывода предупреждения перед импортом
          if(!vm.fileErrors.file_errors){
            $scope.showInfo = false;
            $scope.import();
          }else{
            $scope.showInfo = true;
          }

          $scope.cancel = function() {
            $uibModalInstance.dismiss();
            importPriceListSrv.cancelFileImport(vm.processing.import_id).then(function (res) {
              $scope.errorStatuses();
            },
            function (error) {
              errorMessageService.showModal({message: 'При отмене импорта произошла ошибка', submessage: error});
            });
          };

          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      })
    };

    /**
     * Подсказка для показа количества подразделений, привязанных к колонке
     *
     * @param column
     */
    vm.tipForDivisions = function (column) {
      var str = '';
      if (column.divisions.length) {
        str = 'Действует только для подразделений \n';
        angular.forEach(column.divisions, function (division, key) {
          if (key < 4) {
            str += ("<div>" + division.name + "</div>");
          } else if (key === 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    };

    /**
     * Подсказка для показа количества контрагентов, привязанных к колонке
     *
     * @param column
     */
    vm.tipForCounterparties = function (column) {
      var str = '';
      if (column.counterparties.length) {
        str = 'Действует только для контрагентов \n';
        angular.forEach(column.counterparties, function (counterparty, key) {
          if (key < 4) {
            str += ("<div>" + counterparty.name + "</div>");
          } else if (key === 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    };

    // for drag&drop
    var helpIndex, listCount;

    vm.listMoved = function (index, item, parent) {
      if(listCount < parent.length){
        if(helpIndex > index){
          parent.splice(index, 1);
        } else {
          parent.splice(index + 1, 1);
        }
      }
    };

    vm.onDragstart = function(list, event) {
       list.dragging = true;
       if (event.dataTransfer.setDragImage) {
         var img = new Image();
         img.src = '';
         event.dataTransfer.setDragImage(img, 0, 0);
       }
    };

    vm.dropCallback = function (index, item, external, type, parent){
      if(vm.processing.start_line < index){
        vm.processing.start_line = index - 1;
        if(index > vm.fileData.lines.length){
          vm.processing.start_line = vm.fileData.lines.length - 1;
          helpIndex = vm.fileData.lines.length - 1;
          listCount = parent.length;
          parent.splice(vm.fileData.lines.length, 0, item);
          return;
        }
      }else{
        vm.processing.start_line = index;
      }
      helpIndex = index;
      listCount = parent.length;
      parent.splice(index, 0, item)
    };

    // настройка скролла
    vm.configScroll = {
      autoHideScrollbar: false,
      autoExpandScrollbar: false,
      setHeight: 500,
      scrollInertia: 0,
      axis: 'y',
      advanced: {
          updateOnContentResize: true,
          autoExpandHorizontalScroll: false,
          autoScrollOnFocus: false
      },
      scrollButtons: {
          enable: false
      },
      theme: 'dark',
      mouseWheel:{
        preventDefault: false,
        disableOver: ["ul", "li", "span"]
      }
    };

  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('priceColumnOldSrv', priceColumnSrv);

  /**
   * Сервис для работы с АПИ колонок прайс-листов (временное решение, через эмулятор)
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   */
  function priceColumnSrv($http,
                          API_URL,
                          $q,
                          userSettingsService // Для эмуляции сохранения, пока нет бекенда
  ) {

    /* Загрузка списка колонок */
    this.priceColumns = function () {
      return $q.when(userSettingsService.loadProperty("price-list", "column", "list") || []);
    }

    /* Загрузка колонки по идентификатору */
    this.priceColumn = function (columnId) {
      var list = userSettingsService.loadProperty("price-list", "column", "list") || [];
      var column = _.findWhere(list, {id: columnId});
      if (column)
        return $q.when(column);
      else
        return $q.reject({error: 'not found'});
    }

    /* Удаление колонки */
    this.deletePriceColumn = function (columnId) {
      var list = userSettingsService.loadProperty("price-list", "column", "list");
      list = list || [];
      if (list && list.length) {
        var removeList = _.findWhere(list, {
          id: columnId
        }); // поиск первого объекта по свойству
        if (removeList) {
          list = _.without(list, removeList);
          userSettingsService.saveProperty("price-list", "column", "list", list);
          return $q.when(true);
        }
      }
      return $q.reject(false); // не был найден объект по идентификатору
    }

    /* Добавление новой колонки */
    this.createPriceColumn = function (newColumn) {
      // загрузка списка
      var list = userSettingsService.loadProperty("price-list", "column", "list");
      newColumn.id = userSettingsService.guid(); // генерация id
      list = list || [];
      list.push(newColumn);
      // сохранение измененного списка
      userSettingsService.saveProperty("price-list", "column", "list", list);
      return $q.when(newColumn);
    }

    /* Обновление информации о проектe */
    this.updatePriceColumn = function (updatedColumn) {
      var list = userSettingsService.loadProperty("price-list", "column", "list");
      list = list || [];
      var obj = _.findWhere(list, {id: updatedColumn.id});
      _.extendOwn(obj, updatedColumn); // копирование собственных свойст
      userSettingsService.saveProperty("price-list", "column", "list", list);
      return $q.when(obj);
    }

  }

}) ();

(function() {
  'use strict';

  angular.module('frontend').service('priceColumnSrv', priceColumnSrv);

  /**
   * Сервис для работы с АПИ колонок прайс-листов (временное решение, через эмулятор)
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   */
  function priceColumnSrv($http,
                          API_URL
  ) {

    // получение строки, необходимой для подстановки в url запроса.
    // причина в другой реализации закупочного прайс-листа
    // можно было бы использовать $stateParams и параметрыв url, но это не сурьезно
    function _getRequestStr (type) {
      return (type == 'PURCHASE')? '/purchase_price_lists' : '/price_lists';
    }

    /* Загрузка списка колонок */
    this.priceColumns = function (type, filter_divisions_id) {
      return $http.get(API_URL + _getRequestStr(type) + '/columns', {
        params: {
          filter_column_type: (type == 'PURCHASE')? undefined : type,
          filter_divisions_id: filter_divisions_id || undefined
        }
      }).then(function (data) {
        return data.data;
      });
    };

    this.purchasePriceColumnsAuto = function (search, limit) {
      return $http.get(API_URL + '/purchase_price_lists/columns/auto', {
        params: {
          search_string: search,
          limit: limit || 5
        }
      }).then(function (data) {
        return data.data;
      });
    };

    this.priceColumnsAuto = function (search, filter_column_type, limit) {
      return $http.get(API_URL + '/price_lists/columns/auto', {
        params: {
          filter_column_type: filter_column_type || undefined,
          search_string: search,
          limit: limit || 5
        }
      }).then(function (data) {
        return data.data;
      });
    };

    /* Загрузка колонки по идентификатору */
    this.priceColumn = function (type, columnId) {
      return $http.get(API_URL + _getRequestStr(type) + '/columns/' + columnId).then(function (data) {
        return data.data;
      });
    };

    /* Удаление колонки */
    this.deletePriceColumn = function (type, columnId) {
      return $http.delete(API_URL + _getRequestStr(type) + '/columns/' + columnId);
    };

    /* Добавление новой колонки */
    this.createPriceColumn = function (type, newColumn) {
      return $http.post(API_URL + _getRequestStr(type) + '/columns', newColumn).then(function (data) {
        return data.data;
      });
    };

    /* Обновление информации о колонке */
    this.updatePriceColumn = function (type, updatedColumn) {
      return $http.put(API_URL + _getRequestStr(type) + '/columns/' + updatedColumn.id, updatedColumn).then(function (data) {
        return data.data;
      });
    }

  }

}) ();

(function () {
  'use strict';

  angular.module('frontend').controller('priceColumnController', priceColumnController);

  function priceColumnController($scope,
                                 $state,
                                 type, // тип колонки, розничная или оптовая
                                 taxGroups,
                                 $rootScope,
                                 cardHistory,
                                 priceColumn, // сущность при редактировании
                                 priceColumnSrv, // сервис для работы с колонками прайс-листов
                                 currenciesService, // сервис для работы с валютами
                                 contragentService, // сервис для работы с контрагентами
                                 catalogService, // сервис для работы с каталогом
                                 errorMessageService, // уведомление пользователя
                                 utilsService, // для загрузки валют
                                 $stateParams,
                                 $uibModal,
                                 $anchorScroll,
                                 $q,
                                 $window) {
    var priceColumnCrudCtrl = this;
    priceColumnCrudCtrl.useRounding = false; // по умолчанию не использовать округление
    priceColumnCrudCtrl.type = type;

    // тип прайслиста, по которому отображаются колонки для формирования на их основе текущей
    priceColumnCrudCtrl.currentType = (priceColumn && priceColumn.source_column) ?
      priceColumn.source_column.column_type :
      (priceColumn && priceColumn.purchase_source_column ? 'PURCHASE'
        : type);

    priceColumnCrudCtrl.priceListTypes = [
      {
        code: 'PURCHASE',
        name: 'Закупочный прайс-лист'
      },
      {
        code: 'WHOLE_SALE',
        name: 'Оптовый прайс-лист'
      }
    ];

    if (priceColumnCrudCtrl.type == 'RETAIL') {
      priceColumnCrudCtrl.priceListTypes.push({
        code: 'RETAIL',
        name: 'Розничный прайс-лист'
      })
    }

    // сброс выбранных значений при переключении типа ПЛ
    priceColumnCrudCtrl.onSelectType = function () {
      priceColumnCrudCtrl.priceColumn.source_column = undefined;
      priceColumnCrudCtrl.priceColumn.purchase_source_column = undefined;
      priceColumnCrudCtrl.refreshColumns();
    };

    priceColumnCrudCtrl.refreshColumns = function (searchText) {
      var filter_column_type = (priceColumnCrudCtrl.currentType == 'PURCHASE') ? undefined : priceColumnCrudCtrl.currentType;
      priceColumnSrv.priceColumnsAuto(searchText, filter_column_type).then(function (data) {
        // имеющиеся колонки (необходимы для связывания), фильтр убирает из списка текущую
        priceColumnCrudCtrl.columns = priceColumn ? _.filter(data.items, function (listColumn) {
          return listColumn.id != priceColumn.id;
        }) : data.items;
        priceColumnCrudCtrl.columnsTotalSearch = data.total;
        if (!priceColumnCrudCtrl.columnsTotal) {
          priceColumnCrudCtrl.columnsTotal = data.total;
        }
      });
    };

    priceColumnCrudCtrl.refreshPurchaseColumns = function (searchText) {
      priceColumnSrv.purchasePriceColumnsAuto(searchText).then(function (data) {
        priceColumnCrudCtrl.purchaseColumns = data.items;
        priceColumnCrudCtrl.purchaseColumnsTotal = data.total;
      });
    };

    priceColumnCrudCtrl.totalStr = function () {
      if (priceColumnCrudCtrl.columnsTotalSearch > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH) {
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + priceColumnCrudCtrl.columnsTotalSearch;
      }
      return '';
    };

    priceColumnCrudCtrl.totalPurchaseStr = function () {
      if (priceColumnCrudCtrl.purchaseColumnsTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH) {
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + priceColumnCrudCtrl.purchaseColumnsTotal;
      }
      return '';
    };

    priceColumnCrudCtrl.mode = {
      isEdit: $state.current.name.endsWith('edit'),
      isNew: $state.current.name.endsWith('new'),
      isView: $state.current.name.endsWith('view')
    };

    // для возврата на предыдущую страницу
    priceColumnCrudCtrl.returnToPage = function () {
      var prev = cardHistory.popStep('priceColumnId', $stateParams.priceColumnId) || {name: 'priceList', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'priceList', {parent: priceColumnCrudCtrl.type});
    };

    priceColumnCrudCtrl.state = $state;
    // Инициализация колонки
    if (priceColumn) {
      priceColumnCrudCtrl.priceColumn = priceColumn;
      priceColumnCrudCtrl.priceCreation = !!priceColumn.source_column || !!priceColumn.multiplier_for_source; // определяется по наличию колонки с формулой
      if (priceColumnCrudCtrl.priceColumn.rounding_details) {
        if (priceColumnCrudCtrl.priceColumn.rounding_details.length) {
          priceColumnCrudCtrl.useRounding = true;
        }
        // установка
        if (priceColumnCrudCtrl.priceColumn.multiplier_for_source || priceColumnCrudCtrl.priceColumn.multiplier_for_source === 0) {
          var temp = (priceColumnCrudCtrl.priceColumn.multiplier_for_source < 1) ? 1 - priceColumnCrudCtrl.priceColumn.multiplier_for_source : priceColumnCrudCtrl.priceColumn.multiplier_for_source - 1;
          priceColumnCrudCtrl.priceColumn.$$operation = (priceColumnCrudCtrl.priceColumn.multiplier_for_source < 1) ? '-' : '+';
          priceColumnCrudCtrl.priceColumn.$$percent = Math.abs((temp * 100).toFixed(2));
        }
        priceColumnCrudCtrl.useRounding = !!priceColumnCrudCtrl.priceColumn.rounding_details.length;
      }
    } else {
      priceColumnCrudCtrl.priceColumn = {
        column_type: type || 'RETAIL', // либо значение из роутинга, либо розничная
        taxes_included: true,
        $$operation: '+'
      };
      priceColumnCrudCtrl.priceCreation = false; // по-умолчанию вручную
    }
    if (!priceColumnCrudCtrl.priceColumn.divisions_assignment_type) {
      priceColumnCrudCtrl.priceColumn.divisions_assignment_type = 'NONE';
    }
    if (!priceColumnCrudCtrl.priceColumn.counterparties_assignment_type) {
      priceColumnCrudCtrl.priceColumn.counterparties_assignment_type = 'NONE';
    }
    priceColumnCrudCtrl.priceColumn.rounding_details = priceColumnCrudCtrl.priceColumn.rounding_details || [];

    /* Подсветка ошибок полей */
    priceColumnCrudCtrl.setDirty = function () {
      angular.forEach(priceColumnCrudCtrl.addPriceColumn.$error, function (controls, errorName) {
        angular.forEach(controls, function (control) {
          control.$setDirty();
        });
      });
    };

    /* Автодополнение валют */
    priceColumnCrudCtrl.refreshCurrencies = function (search) {
      currenciesService.getDomainCurrenciesSearch(search)
        .then(function (data) {
          priceColumnCrudCtrl.currencies = data.data.items;
          // для вычисления валюты учета и подстановки её в поле
          if (priceColumnCrudCtrl.mode.isNew && !priceColumnCrudCtrl.priceColumn.currency) {
            currenciesService.getDomainCurrencies().then(function (res) {
              var homeCurrencyId = 0;
              angular.forEach(res.data.items, function (item) {
                if (item.home_currency) {
                  homeCurrencyId = item.currency_id;
                }
              });
              angular.forEach(priceColumnCrudCtrl.currencies, function (item) {
                if (item.id == homeCurrencyId) {
                  priceColumnCrudCtrl.priceColumn.currency = item;
                }
              });
            });
          }
        });
    };
    priceColumnCrudCtrl.refreshCurrencies();

    if (priceColumnCrudCtrl.type == 'PURCHASE') {
      /* Автодополнение контрагентов */
      priceColumnCrudCtrl.refreshCounterparties = function (search) {
        contragentService.counterpartiesSearch(search, 100, {filter_roles: ['SUPPLIER']}).then(function (res) {
          priceColumnCrudCtrl.counterparties = res.data;
          if (!priceColumnCrudCtrl.counterpartiesTotal) {
            priceColumnCrudCtrl.counterpartiesTotal = res.data.total;
          }
        });
      };
      /* Список налогов */
      priceColumnCrudCtrl.taxGroups = taxGroups;
      if (priceColumnCrudCtrl.mode.isNew) {
        priceColumnCrudCtrl.priceColumn.supplier_tax_group = priceColumnCrudCtrl.taxGroups[0];
      }
    }

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    priceColumnCrudCtrl.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function () {
        this.error = false;
        this.message = '';
        this.loading = true;
      },
      stopLoadingSuccess: function () {
        this.error = false;
        this.message = '';
        this.loading = false;
      },
      stopLoadingFailure: function (message) {
        this.error = true;
        this.message = message;
        this.loading = false;
      }
    };

    priceColumnCrudCtrl.resetData = function () {
      priceColumnCrudCtrl.addPriceColumn.$setPristine();
      priceColumnCrudCtrl.returnToPage();
    };

    // метод для создания необходимой структуры, для закупочного прайс-листа
    // структура намного проще чем в других прайслистах, и чтобы не вырезать кучу полей составлен новый новый объект
    function rewritePurchaseObject() {
      priceColumnCrudCtrl.priceColumn = {
        currency: priceColumnCrudCtrl.priceColumn.currency,
        effective_order_sum: priceColumnCrudCtrl.priceColumn.effective_order_sum || undefined,
        id: priceColumnCrudCtrl.priceColumn.id || undefined,
        name: priceColumnCrudCtrl.priceColumn.name,
        supplier: priceColumnCrudCtrl.priceColumn.supplier || undefined,
        supplier_tax_group: priceColumnCrudCtrl.priceColumn.supplier_tax_group || undefined,
        taxes_included: priceColumnCrudCtrl.priceColumn.taxes_included
      };
      if (priceColumnCrudCtrl.priceColumn.supplier_tax_group) {
        priceColumnCrudCtrl.priceColumn.supplier_tax_group = {
          id: priceColumnCrudCtrl.priceColumn.supplier_tax_group.id,
          name: priceColumnCrudCtrl.priceColumn.supplier_tax_group.name
        };
      }
    }

    // Метод, вызываемый при сохранении или изменении колонки
    priceColumnCrudCtrl.save = function () {
      var deferred = $q.defer();
      // добавление источника колонки column_type, в объекту колонки
      if (priceColumnCrudCtrl.priceColumn.source_column) {
        priceColumnCrudCtrl.priceColumn.source_column.column_type = priceColumnCrudCtrl.currentType;
      }

      if (priceColumnCrudCtrl.addPriceColumn.$valid) {// проверка валидности формы

        if (!priceColumnCrudCtrl.priceCreation) {
          priceColumnCrudCtrl.priceColumn.source_column = null;
          priceColumnCrudCtrl.priceColumn.purchase_source_column = null;
          priceColumnCrudCtrl.priceColumn.multiplier_for_source = null;
        }

        if ((priceColumnCrudCtrl.priceColumn.source_column ||
            priceColumnCrudCtrl.priceColumn.purchase_source_column)
          && priceColumnCrudCtrl.priceCreation) {
          if (priceColumnCrudCtrl.priceColumn.$$operation && priceColumnCrudCtrl.priceColumn.$$percent) {
            var temp = Number.parseFloat(priceColumnCrudCtrl.priceColumn.$$operation + priceColumnCrudCtrl.priceColumn.$$percent);
            priceColumnCrudCtrl.priceColumn.multiplier_for_source = 1 + Number.parseFloat(temp / 100);
          } else {
            priceColumnCrudCtrl.priceColumn.multiplier_for_source = null;
          }
        }

        if (priceColumnCrudCtrl.priceColumn.counterparties_assignment_type != 'SET') {
          priceColumnCrudCtrl.priceColumn.counterparties = null;
        }
        if (priceColumnCrudCtrl.priceColumn.divisions_assignment_type != 'SET') {
          priceColumnCrudCtrl.priceColumn.divisions = null;
        }

        if (!priceColumnCrudCtrl.useRounding) {
          delete priceColumnCrudCtrl.priceColumn.rounding_details;
        } else {
          angular.forEach(priceColumnCrudCtrl.priceColumn.rounding_details, function (rounding) {
            if (!rounding.$$usePsychRounding) {
              delete rounding.psychological_rounding;
            }
          });
        }

        var tempDivisions = [];
        angular.forEach(priceColumnCrudCtrl.priceColumn.divisions, function (division) {
          tempDivisions.push({
            id: division.id,
            name: division.name
          });
        });
        priceColumnCrudCtrl.priceColumn.divisions = tempDivisions;

        // Удалить лишние поля
        if (priceColumnCrudCtrl.priceColumn.supplier) {
          priceColumnCrudCtrl.priceColumn.supplier.email = undefined;
          priceColumnCrudCtrl.priceColumn.supplier.inn = undefined;
          priceColumnCrudCtrl.priceColumn.supplier.kpp = undefined;
        }

        if (priceColumnCrudCtrl.priceColumn.id) {
          // Блок обновления
          if (priceColumnCrudCtrl.type == 'PURCHASE') {
            // формирование необходимой структуры объекта для закупочного прайс-л
            rewritePurchaseObject();
          }
          return priceColumnSrv.updatePriceColumn(priceColumnCrudCtrl.type, priceColumnCrudCtrl.priceColumn).then(
            function () {
              priceColumnCrudCtrl.resetData();
            },
            function (error) {
              if (error.status == 409) {
                angular.forEach(error.data.parameters, function (field) {
                  priceColumnCrudCtrl.addPriceColumn[field.name].$setValidity('unique', false);
                  $anchorScroll("numberAnchor");
                });
              } else {
                errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        } else {
          // Блок создания
          if (!priceColumnCrudCtrl.priceColumn.name) return;

          if (priceColumnCrudCtrl.type == 'PURCHASE') {
            // формирование необходимой структуры объекта для закупочного прайс-листа
            rewritePurchaseObject();
          }
          return priceColumnSrv.createPriceColumn(priceColumnCrudCtrl.type, priceColumnCrudCtrl.priceColumn).then(
            function () {
              priceColumnCrudCtrl.resetData();
            },
            function (error) {
              if (error.status == 409) {
                angular.forEach(error.data.parameters, function (field) {
                  priceColumnCrudCtrl.addPriceColumn[field.name].$setValidity('unique', false);
                  $anchorScroll("numberAnchor");
                });
              } else {
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
              }
              return deferred.reject();
            }
          )
        }
        // очистить интервалы и подразделение и контрагенты
      } else {
        priceColumnCrudCtrl.addPriceColumn.name.$setDirty();
        return deferred.promise;
      }
    };

    priceColumnCrudCtrl.uniqueCheck = function () {
      if (priceColumnCrudCtrl.priceColumn.name) {
        var obj = {
          "constraint_name": (priceColumnCrudCtrl.type == "PURCHASE")? "PURCHASE_PRICE_LIST_COLUMN" : "PRICE_LIST_COLUMN",
          "parameters": [
            {
              "name": "name",
              "value": priceColumnCrudCtrl.priceColumn.name
            }
          ]
        };
        if (priceColumnCrudCtrl.priceColumn.id) obj.id = priceColumnCrudCtrl.priceColumn.id;
        utilsService.uniqueCheck(obj).then(function (res) {
          },
          function (error) {
            if (error.status == 409) {
              angular.forEach(error.data.parameters, function (field) {
                priceColumnCrudCtrl.addPriceColumn[field.name].$setValidity('unique', false);
              });
            }
          });
      }
    };

    // Метод удаления колонки
    priceColumnCrudCtrl.delete = function () {
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.name = priceColumnCrudCtrl.priceColumn.name;
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'колонку';
          $scope.conflictDeleteText = "Мы не можем удалить колонку  «" + $scope.name + "», так как она используется для расчета цен в другой колонке. Измените расчет цен в зависимой колонке и повторите попытку.";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.delete = function () {
            $scope.lock = true;
            priceColumnSrv.deletePriceColumn(priceColumnCrudCtrl.type, priceColumnCrudCtrl.priceColumn.id).then(function (res) {
              $uibModalInstance.dismiss();
              // Переход на предыдущую страницу
              priceColumnCrudCtrl.resetData();
              $scope.lock = false;
            }, function (error) {
              $scope.lock = false;
              if (error.status == 409) {
                $scope.lock = false;
                $scope.canDelete = false;
                if (error.data.code == "last_column") {
                  $scope.conflictDeleteText = "Нельзя удалить единственную колонку с ценами в " + (priceColumnCrudCtrl.type == 'RETAIL' ? 'розничном' : ((priceColumnCrudCtrl.type == 'PURCHASE') ? 'закупочном' : 'оптовом')) + " прайс-листе";
                }
              } else {
                errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: error});
              }
            })
          };
        }
      });
      return modal.result;
    };

    priceColumnCrudCtrl.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        priceColumnCrudCtrl.isSetDirty = true;
        return true;
      }
      return false;
    }

    priceColumnCrudCtrl.setDirty = function () {
      priceColumnCrudCtrl.isSetDirty = true;
      utilsService.setDirty(priceColumnCrudCtrl.addPriceColumn);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    priceColumnCrudCtrl.crud = function (status) {
      switch (status) {
        case 'save':
          if (priceColumnCrudCtrl.addPriceColumn.$valid) {
            return priceColumnCrudCtrl.save();
          } else {
            return priceColumnCrudCtrl.setDirty();
          }
          break;
        case 'delete':
          return priceColumnCrudCtrl.delete();
          break;
        case 'return':
          priceColumnCrudCtrl.returnToPage();
          return $q.when();
          break;
        case 'edit':
          $state.go('price-list', {parent: $state.params.parent});
          return $q.when();
        default :
          return $q.when();
          break;
      }
    }
  }

})();

/**
 * Created by aivanov on 26.11.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .service("modalAskSrv", function ($uibModal) {
        this.showModal = function (text) {
          return $uibModal.open({
            templateUrl: 'app/price-list/ask/modal-ask.html',
            controller: 'ModalAskController',
            size: 'small-width',
            windowClass: 'more-zindex',
            resolve: {
              message: text
            }
          }).result;
        }
    })
    .controller("ModalAskController", function ($scope, $uibModalInstance, message) {
      $scope.message = message.title;

      $scope.ok = function () {
        $uibModalInstance.close();
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss();
      };
    })
})();

(function () {
  'use strict';

  angular.module('frontend').controller('partnerSettingsCtrl', partnerSettingsController);

  function partnerSettingsController($state, 
                                     objectCodes,
                                     $uibModal, 
                                     partnersService, 
                                     $rootScope,
                                     errorMessageService,
                                     clipboardService,
                                     requestStatus,
                                     companyService,
                                     cardHistory,
                                     utilsService, 
                                     auth,
                                     $location) {
    var partnerSettingsCtrl = this;
    partnerSettingsCtrl.settings =  {};
    partnerSettingsCtrl.objectCodes = objectCodes;
    partnerSettingsCtrl.addressOptions = {};
    partnerSettingsCtrl.regions = [];
    partnerSettingsCtrl.helper_public_contact = [
      {caption: "Телефон", type: "PHONE", value: null},
      {caption: "E-mail", type: "EMAIL", value: null}
    ];

    partnerSettingsCtrl.returnToPage = function(){
      var prev = cardHistory.popStep();
      if (prev) {
        $state.go(prev.name || 'indicators', prev.param);
      } else {
        $state.go("indicators");
      }
    };

    partnerSettingsCtrl.addAddressData = function(arr){
      arr.push({
        address: {},
        addressOptions: {}
      });
    };

    partnerSettingsCtrl.removeItemData = function(arr, index){
      arr.splice(index, 1);
    };

    partnerSettingsCtrl.changeCode = function () {
      if (!partnerSettingsCtrl.object_code.id) return;
      partnerSettingsCtrl.settingsLoaded = false;
      partnerSettingsCtrl.regions = [];
      partnersService.getPartnershipSettings(partnerSettingsCtrl.object_code.id).then(function (res) {
        partnerSettingsCtrl.settings = res.data;
        partnerSettingsCtrl.settingsLoaded = true;
        partnerSettingsCtrl.settings.only_for_own_clients = !!partnerSettingsCtrl.settings.only_for_own_clients;
        if (!partnerSettingsCtrl.settings.public_contact || !partnerSettingsCtrl.settings.public_contact.details) {
          partnerSettingsCtrl.settings.public_contact = {
            details: [{caption: "Факс", type: "FAX", value: null}]
          };
        } else {
          partnerSettingsCtrl.helper_public_contact[0].value = partnerSettingsCtrl.settings.public_contact.details[0].value;
          partnerSettingsCtrl.helper_public_contact[1].value = partnerSettingsCtrl.settings.public_contact.details[1].value;
          partnerSettingsCtrl.settings.public_contact.details.splice(0, 2);
        }
        if (!partnerSettingsCtrl.settings.regions || !partnerSettingsCtrl.settings.regions.length) {
          partnerSettingsCtrl.addAddressData(partnerSettingsCtrl.regions);
        } else {
          partnerSettingsCtrl.regions = _.map(partnerSettingsCtrl.settings.regions, function(addr){
            return {
              address: addr,
              addressOptions: {}
            };
          });
        }
      });
    }

    // подстановка кода, если он один + вылов логики поля
    if (objectCodes.length == 1) {
      partnerSettingsCtrl.object_code = objectCodes[0];
      partnerSettingsCtrl.changeCode();
    }

    /* Подгрузка банковских счетов */
    partnerSettingsCtrl.loadDataByCompany = function () {
      if (!partnerSettingsCtrl.settings.bonus_recipient) return;

      /* загрузка банковких счетов */
      partnerSettingsCtrl.settings.bonus_bank_account = undefined;
      partnerSettingsCtrl.settings.actual_address = undefined;
      companyService.getAccounts(partnerSettingsCtrl.settings.bonus_recipient.id).then(function (res) {
        partnerSettingsCtrl.bankAccounts = res.data.map(function (val) {
          return {
            id: val.id,
            name: val.name
          }
        });
        if(partnerSettingsCtrl.bankAccounts.length === 1){
          partnerSettingsCtrl.settings.bonus_bank_account = partnerSettingsCtrl.bankAccounts[0];
        }
      });

      /* загрузка подразделений */
      companyService.companyDivisions(partnerSettingsCtrl.settings.bonus_recipient.id)
          .then(function (res) {
            partnerSettingsCtrl.addreses = _.map(res.data, function (division) {
              return division.address;
            });
          });
    }

    /* Автодополнение компаний */
    partnerSettingsCtrl.refreshCompanies = function (search) {
      companyService.companiesSearch(search)
        .then(function (data) {
          partnerSettingsCtrl.companies = data.data.items;
        });
    };
    partnerSettingsCtrl.refreshCompanies();

    
    partnerSettingsCtrl.save = function () {
      if (!partnerSettingsCtrl.object_code.id) return;

      if (!partnerSettingsCtrl.settingsForm.$valid) {
        partnerSettingsCtrl.isSaved = true;
        utilsService.setTouched(partnerSettingsCtrl.settingsForm);
        return;
      }

      partnerSettingsCtrl.settings.regions = _.map(partnerSettingsCtrl.regions, function(addr){
        return addr.address;
      });

      partnerSettingsCtrl.settings.public_contact.details.unshift(partnerSettingsCtrl.helper_public_contact[1]);
      partnerSettingsCtrl.settings.public_contact.details.unshift(partnerSettingsCtrl.helper_public_contact[0]);

      partnersService.updatePartnershipSettings(partnerSettingsCtrl.object_code.id, partnerSettingsCtrl.settings).then(function (res) {
        partnerSettingsCtrl.returnToPage();
      }, function(error){
        errorMessageService.showModal({message: 'При сохранении данных произошла ошибка', submessage: error});
      });

    }

    /**
     * Отмена партнерства
     */
    partnerSettingsCtrl.deletePartnerPopup = function(){
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Отмена участия в партнерской программе";
          $scope.text = "Вы действительно хотите отменить участие в партнерской программе?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            partnersService.deletePromo('PARTNER').then(function(res){
              $rootScope.partner = false;
              $uibModalInstance.close();
              $state.go("indicators");
            }, function(error){
              $uibModalInstance.dismiss();
              errorMessageService.showModal({message: 'Произошла ошибка', submessage: error});
            });
          };
        }
      });
    };

    partnerSettingsCtrl.clientLinkPopup = function(){
      $uibModal.open({
        templateUrl: 'app/partnership/modals/client-link-popup.html',
        size: 'medium-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.load = false;
          $scope.reqData = {
            clientType: 'DOMAIN',
            clientPartnerId: {name: $rootScope.user.domain, id: $rootScope.user.domain}
          };

          $scope.close = function () {
            $uibModalInstance.dismiss();
          };

          $scope.copy = function(partner_code){
            if (partner_code) {
              var messageBody = window.origin + '' + window.location.pathname + '#/register?partner_code=' + partner_code;
              if ($scope.reqData.promo_code) {
                messageBody += '&promo_code=' + $scope.reqData.promo_code;
              }
              clipboardService.copyTextToClipboard(messageBody);
              $scope.load = false;
              requestStatus.success("Ссылка для регистрации клиента сохранена в буфер обмена", false);
              $uibModalInstance.dismiss();
            }else {
              $scope.load = false;
              requestStatus.error("При получении кода партнера произошла ошибка");
            }
          }

          $scope.action = function () {
            $scope.load = true;
            if ($scope.reqData.clientType == 'COMPANY') {
              companyService.company($scope.reqData.clientPartnerId.id).then(function(res){
                $scope.copy(res.data.code);
              }, function(err){
                requestStatus.error("При получении кода партнера произошла ошибка");
              });
            } else if ($scope.reqData.clientType == 'DIVISION') {
              $scope.copy($scope.reqData.clientPartnerId.code);
            } else {
              $scope.copy($scope.reqData.clientPartnerId.name);
            }

          };

          $scope.checkCode = function (isPartnerCode) {
            $scope.clientLink.promo_code.$setValidity('notFound', true);
            utilsService.delay($scope.checkPromoCode, 300);
          }

          $scope.checkPromoCode = function () {
            auth.checkPromoCode($scope.reqData.promo_code).then(function (res) {
            }, function (error) {
              $scope.clientLink.promo_code.$setValidity('notFound', false);
            });
          }
        }
      });
    };

    
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('partners', partners);

  function partners($state, userSettingsService,
                    $rootScope,
                    uiGridConstants,
                    partnersDefsService,
                    filterSettingsService,
                    API_URL,
                    $uibModal,
                    requestStatus,
                    partnersService,
                    errorMessageService,
                    companyService,
                    $location,
                    clipboardService,
                    utilsService) {
    var partners = this;
    var domain = $location.$$absUrl.replace($location.$$path, '');
    partners.url = API_URL + '/partnership/clients';
    partners.page = "partners";
    partners.header = 'Привлеченные клиенты';
    partners.sort = 'name';
    partners.limit = 25;
    partners.columnDefs = userSettingsService.loadProperty(partners.page, 'grid', 'columnsProperty') ||
      partnersDefsService.getColumnDefs.call(this, uiGridConstants);
    partners.usingService = partnersDefsService;
    partners.filterMeta = {};
    partners.gridConfig = {
      searchTip: 'Поиск складских транзакций по коду, артикулу или штрих-коду товара'
    };

    partners.gridButtonConfig = [{
      url: 'partners',
      text: 'Клиент',
      tooltip: 'Добавить привлеченного клиента',
      permission: 'company.read',
      plusButton: true,
      action: function(){
        $uibModal.open({
          templateUrl: 'app/partnership/modals/add-partner.html',
          size: 'middle-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.reqData = {
              clientType: "DOMAIN",
              clientPartnerId: {name: $rootScope.user.domain, id: $rootScope.user.domain}
            };
            $scope.client = {};

            $scope.errorHandler = function (error) {
              $scope.groupNameError = ($rootScope.user.domain == $scope.client.client)? 'Нельзя добавить собственную группу в качестве привлеченного клиента' : 'Клиент привлечен другим партнером';
              if (error.status == 404) {
                requestStatus.error("Клиент " + $scope.client.client + " не найден в Торговля.онлайн");
              } else if (error.status == 409) {

                if (error.data.code == "inn_not_filled" || error.data.code == "inn_not_found") {
                  $scope.addClientForm.inn.$setValidity('unique', false);
                  $scope.innError = error.data.message;
                  return;
                }

                $scope.addClientForm.domain.$setValidity('unique', false);
                if (error.data.code == "unique_index_violation") {
                  $scope.groupNameError = 'Клиент уже существует';
                } else if (error.data.code == "unable_to_add_client") {
                  $scope.groupNameError = 'Клиент отказался от партнерских услуг';
                }
              } else if (error.status !== 500) {
                requestStatus.error("При добавлении клиента " + $scope.client.client + " произошла ошибка");
              }
            }

            $scope.successHandler = function () {
              $uibModalInstance.dismiss();
              requestStatus.success("Клиент " + $scope.client.client + " добавлен в список привлеченных клиентов", false);
            }

            $scope.close = function () {
              $uibModalInstance.dismiss();
            };

            $scope.save = function () {
              $scope.isSaved = true;
              utilsService.setTouched($scope.addClientForm);
              if ($scope.addClientForm.$invalid) return;
              if ($scope.reqData.clientType == "COMPANY") {
                partnersService.addCompanyСlient($scope.reqData.clientPartnerId, $scope.client).then(function(){
                  $scope.successHandler();
                }, function(error){
                  $scope.errorHandler(error);
                });
              } else if ($scope.reqData.clientType == "DIVISION") {
                partnersService.addDivisonСlient($scope.reqData.clientPartnerId, $scope.client).then(function(){
                  $scope.successHandler();
                }, function(error){
                  $scope.errorHandler(error);
                });
              } else {
                partnersService.addDomainСlient($scope.client).then(function(){
                  $scope.successHandler();
                }, function(error){
                  $scope.errorHandler(error);
                });
              }
            };

            $scope.checkGroup = function () {
              $scope.addClientForm.domain.$setValidity('unique', $scope.client.client !== $rootScope.user.domain);
            }
          }
        });
      }
    }];

    angular.forEach(partners.columnDefs, function (column) {
      if (column.name === 'dataValue.partner') {
        column.filter.selectOptions = [{
          "value": "DOMAIN",
          "label": "Домен"
        },
        {
          "value": "COMPANY",
          "label": "Компания"
        },
        {
          "value": "DIVISION",
          "label": "Подразделение"
        }];
      }
    });

    /**
     * Переход на страничку просмотра клиента
     */
    partners.rowRouteFunc = function (rowData) {
      if (rowData.companies.length) {
        $state.go('partner.view', {
          id: rowData.client_id,
          parent: 'business'
        });
      } else {
        $uibModal.open({
          templateUrl: 'app/catalog/modals/info-popup.html',
          size: 'small-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.class = "info";
            $scope.reqAttrButton = false;
            $scope.title = "Предупреждение";
            $scope.descrTxt = 'У привлеченного клиента не настроена<br>структура бизнеса';
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };

          }
        });
      }
    };

    filterSettingsService.filterPartners().then(function (res) {
      partners.filterMeta = res.data.items;
    });

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('partnersDefsService', partnersDefsService);

  /** @ngInject */
  function partnersDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [60, 160, 160, 560, 160, 160, 160, 160, 160];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('partners', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('partners', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('partners', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enableSorting: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '',
          visible: true,
          headerCellTemplate: ''
        },
        {
          __index: 1,
          name: 'dataValue.name',
          displayName: 'Имя группы',
          enableSorting: true,
          sortName: 'name',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          width: columnsDefinedWidth[1],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 2,
          name: 'dataValue.domain_registered',
          displayName: 'Дата регистрации',
          enableSorting: true,
          sortName: 'domain_registered',
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset) || (row.entity.dataValue.name? \'-\' : \'\')"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' :\'UTC\'',
          filterName: 'registration',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="registration" scope="grid.appScope"></cell-date-picker-filter>',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[2],
          footerCellTemplate: ''
        },
        {
          __index: 3,
          name: 'dataValue.companies',
          displayName: 'Компании',
          enableFiltering: false,
          enableSorting: false,
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: 'companies.html',
          headerCellTemplate: headerTemplate,
          visible: true,
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.rejected_by_client',
          displayName: 'Статус',
          visible: true,
          minWidth: 60,
          enableSorting: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: 'statusCell.html',
          enableFiltering: false,
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.last_document_date',
          displayName: 'Дата последней активности',
          enableSorting: true,
          sortName: 'last_activity',
          headerCellTemplate: headerTemplate,
          filterName: 'last_action',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="last_action" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset) || (row.entity.dataValue.name? \'-\' : \'\')"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.partner',
          displayName: 'Партнер',
          visible: true,
          minWidth: 60,
          enableSorting: true,
          sortName: 'partner',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: 'partnerCell.html',
          enableFiltering: true,
          filterName: 'partner',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enableSorting: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('partnerBonusesController', partnerBonusesController);

  function partnerBonusesController(userSettingsService,
                                    uiGridConstants,
                                    partnerBonusesDefsService,
                                    filterSettingsService,
                                    API_URL,
                                    $rootScope,
                                    $filter,
                                    $state,
                                    $stateParams,
                                    clients,
                                    currenciesService,
                                    objectCodes) {
    var partnerBonusesCtrl = this;
    partnerBonusesCtrl.url = API_URL + '/partnership/bonuses/transactions';
    partnerBonusesCtrl.page = "partner-bonus-transactions";
    partnerBonusesCtrl.header = 'Детализация бонусов партнера';
    partnerBonusesCtrl.sort = null;
    partnerBonusesCtrl.limit = 25;
    partnerBonusesCtrl.columnDefs = userSettingsService.loadProperty(partnerBonusesCtrl.page, 'grid', 'columnsProperty') ||
      partnerBonusesDefsService.getColumnDefs.call(this, uiGridConstants);
    partnerBonusesCtrl.usingService = partnerBonusesDefsService;
    partnerBonusesCtrl.filterMeta = {};
    partnerBonusesCtrl.gridButtonConfig = [];

    partnerBonusesCtrl.gridConfig = {
      hideSearch: true,
      withoutStaticFilters: true, // отменяет обязательность статических фильтров (компания, каегория, подразделние)
      selectValues: {
        transactions_type: [{
            id: "ACCRUED_BONUSES",
            name: "Начисления бонусов"
          }, {
            id: "PAYABLE_BONUSES",
            name: "Начисление выплачиваемых бонусов"
          }, {
            id: "TRANSFER_BONUSES",
            name: "Перевод бонусов в выплачиваемые"
          }, {
            id: "PAID_BONUSES",
            name: "Выплаты"
          }],
        client_id: _.map(clients, function(client){
          client.id = client.client_domain_id;
          return client;
        }),
        partner: objectCodes
      },
      gridOptions: {
        enableRowSelection: false,
        multiSelect: false,
        enableRowSelectionAll: false,
        showColumnFooter: false
      },
      filterFields: [
        {
          code: 'transactions_type',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Тип',
          required: false,
          placeholder: 'Любой',
          class: 'col-xs-4',
          default: $stateParams.type? {
            id: $stateParams.type,
            name: $stateParams.type == "ACCRUED_BONUSES"? "Начисления бонусов" : ($stateParams.type == 'PAYABLE_BONUSES'? "Начисление выплачиваемых бонусов" : ($stateParams.type === 'TRANSFER_BONUSES'? "Перевод бонусов в выплачиваемые" : "Выплаты"))
          } : null
        },
        {
          code: 'partner',
          selectMatchPattern: '{{ $select.selected.company_id.name || $select.selected.division_id.name || $select.selected.value }}',
          selectChoicesPattern: '{{ item.company_id.name || item.division_id.name || item.value }}',
          type: 'select',
          name: 'Партнер',
          required: false,
          placeholder: 'Любой',
          class: 'col-xs-4'
        },
        {
          code: 'client_id',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Клиент',
          required: false,
          placeholder: 'Любой',
          class: 'col-xs-4'
        }
      ]
    }


    /**
     * Возможно что-то понадобится по клику на строку бонуса
     */
    partnerBonusesCtrl.rowRouteFunc = function (rowData) {

    };

    if (clients) {
      partnerBonusesCtrl.clientsSelect = [];
      partnerBonusesCtrl.clientsPopup = clients;
      _.forEach(clients, function (item) {
        partnerBonusesCtrl.clientsSelect.push({value: item.client_id, label: item.name});
      });
      _.forEach(partnerBonusesCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.domain') {
          column.filter.selectOptions = partnerBonusesCtrl.clientsSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterPartnerBonuses().then(function (res) {
      partnerBonusesCtrl.filterMeta = res.data.items;
      partnerBonusesCtrl.filterMeta[0].selectVal = partnerBonusesCtrl.clientsSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('partnerBonusesDefsService', partnerBonusesDefsService);

  /** @ngInject */
  function partnerBonusesDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 200, 200, 200, 200, 300, 200, 200, 200, 300];

    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('partner-bonus-transactions', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('partner-bonus-transactions', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('partner-bonus-transactions', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '',
          visible: true,
          headerCellTemplate: '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'date',
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          pinned: true,
          enableFiltering: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[1]
        },
        {
          __index: 2,
          name: 'dataValue',
          displayName: 'Тип транзакции',
          enableSorting: false,
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | bonusTypes"/>',
          visible: true,
          pinned: true,
          enableFiltering: false,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[2]
        },
        {
          __index: 3,
          name: 'dataValue.amount',
          enableFiltering: false,
          displayName: 'Сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          backButton: true,
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.client',
          displayName: 'Клиент',
          headerCellTemplate: headerTemplate,
          filterName: 'client',
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD.name"/>',
          visible: true,
          width: columnsDefinedWidth[4],
          filterHeaderTemplate: '<cell-select-filter filter="documentType" col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          pinned: false
        },
        { __index: 5,
          name: 'dataValue.partner',
          enableSorting: false,
          enableFiltering: false,
          displayName: 'Партнер',
          visible: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[5]
        },
        { __index: 6,
          name: 'dataValue.bonus_subject',
          enableSorting: false,
          enableFiltering: false,
          displayName: 'Предмет',
          visible: true,
          cellTemplate: 'bonusSubjectCell.html',
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.payment_document_date',
          displayName: 'Дата п/п',
          enableSorting: true,
          enableFiltering: false,
          sortName: 'payment_document_date',
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[7]
        },
        { __index: 8,
          name: 'dataValue.payment_document_number',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'Номер п/п',
          visible: true,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[8]
        },
        {
          __index: 9,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('closePeriodController', closePeriodController);

  function closePeriodController($state, userSettingsService,
                    $rootScope,
                    uiGridConstants,
                    closePeriodDefsService,
                    filterSettingsService,
                    API_URL,
                    $uibModal,
                    requestStatus,
                    partnersService,
                    errorMessageService,
                    companyService,
                    $location,
                    clipboardService,
                    utilsService) {
    var closePeriodCtrl = this;
    var domain = $location.$$absUrl.replace($location.$$path, '');
    closePeriodCtrl.url = API_URL + '/partnership/closing_period';
    closePeriodCtrl.page = "close-period";
    closePeriodCtrl.header = 'Закрытые периоды';
    closePeriodCtrl.sort = 'when_created';
    closePeriodCtrl.limit = 25;
    closePeriodCtrl.columnDefs = userSettingsService.loadProperty(closePeriodCtrl.page, 'grid', 'columnsProperty') ||
      closePeriodDefsService.getColumnDefs.call(this, uiGridConstants);
    closePeriodCtrl.usingService = closePeriodDefsService;
    closePeriodCtrl.filterMeta = {};
    closePeriodCtrl.gridConfig = {
      searchTip: 'Поиск'
    };

    closePeriodCtrl.callbacks = {
        printAct: function (id) {
            console.log(id);
            $uibModal.open({
                size: 'middle-width',
                component: 'closePeriodPrint',
                controllerAs: '$ctrl',
                resolve: {
                    printForm: {
                        name: "Период",
                        id: id
                    }
                }
            });
        }
    }


  }
})();

'use strict';
angular.module('frontend').component('closePeriodPrint', {
  templateUrl: 'app/documents/document-print/document-print.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope, print, helpService, authToken, statusSrv, $timeout, API_URL, downloadSrv) {
    var ctrl = this;
    ctrl.printForm = ctrl.resolve.printForm;
    print.turnonInterceptorStatus();
    ctrl.params = {};
    ctrl.format = 'PDF';
    ctrl.formats = ['PDF', 'XLS'];

    ctrl.longRequest = {
      format: null,
      exec_id: null,
      crudState: helpService.getCrudStateStructure(),
      flags: {
        processStart: false,
        finish: false
      },
      stopAskingError: function(){
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function(err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
        if (err.data && err.data.fields[0] && err.data.fields[0].error) {
          ctrl.errorMessage = err.data.fields[0].error;
        } else {
          ctrl.errorMessage = "При подготовке отчета произошла ошибка";
        }
      },
      revert: function() {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };

    ctrl.close = function() {
      ctrl.modalInstance.dismiss();
    };

    ctrl.print = function() {
      if (!ctrl.longRequest.flags.processStart) {
        ctrl.longRequest.flags.processStart = true;
        ctrl.processStart = true;
        ctrl.longRequest.crudState.startLoading();

        print.printClosePeriod(ctrl.printForm.id, ctrl.format).then(function(res) {
          ctrl.longRequest.exec_id = res.data.exec_id;
          statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
            ctrl.longRequest.flags.finish = true;
            print.turnoffInterceptorStatus();
            $timeout(function() {
              downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
                ctrl.longRequest.crudState.stopLoadingSuccess();
                $timeout(function() {
                  ctrl.modalInstance.dismiss();
                }, 300, false)
              });
            });
          },ctrl.longRequest.onError);
        }).catch(ctrl.longRequest.onError);

      }
    };


  }
});

(function () {
  'use strict';

  angular.module('frontend').service('closePeriodDefsService', closePeriodDefsService);

  /** @ngInject */
  function closePeriodDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [60, 200, 200, 200, 200, 200, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('partners', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('partners', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('partners', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enableSorting: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '',
          visible: true,
          headerCellTemplate: ''
        },
        {
          __index: 1,
          name: 'dataValue.period.period_name',
          displayName: 'Период',
          enableSorting: false,
          sortName: '',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          width: columnsDefinedWidth[1],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 2,
          name: 'dataValue.partner.value',
          displayName: 'Код партнера',
          enableSorting: false,
          sortName: '',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: false,
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.starting_amount',
          displayName: 'На начало',
          enableSorting: false,
          sortName: '',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          width: columnsDefinedWidth[3],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right'
        },
        {
          __index: 4,
          name: 'dataValue.payble_bonus_amount',
          displayName: 'Начислено',
          enableSorting: false,
          sortName: '',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          width: columnsDefinedWidth[4],
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right'
        },
        {
          __index: 5,
          name: 'dataValue.paid_bonus_amount',
          displayName: 'Выплачено',
          enableSorting: false,
          sortName: '',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          width: columnsDefinedWidth[5],
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right'
        },
        {
          __index: 6,
          name: 'dataValue.ending_amount',
          displayName: 'На конец',
          enableSorting: false,
          sortName: 'name',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          width: columnsDefinedWidth[6],
          visible: true,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right'
        },
        // {
        //   __index: 7,
        //   name: 'dataValue.sdf',
        //   displayName: 'отчет в excel',
        //   enableFiltering: false,
        //   enableSorting: false,
        //   minWidth: 60,
        //   visible: true,
        //   cellClass: 'ui-custom-cell-text-align-to-left',
        //   cellTemplate: 'excelReport.html',
        //   headerCellTemplate: headerTemplate,
        //   width: columnsDefinedWidth[7]
        // },
        {
          __index: 7,
          name: 'dataValue.closing_document_id',
          displayName: 'Закрывающий документ',
          enableFiltering: false,
          enableSorting: false,
          minWidth: 60,
          visible: true,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: 'closeDocument.html',
          headerCellTemplate: headerTemplate,
          width: columnsDefinedWidth[7]
        },
        {
          __index: 8,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          enableSorting: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

'use strict';
angular.module('frontend').component('mobileRegister', {
  templateUrl: 'app/mobile/register/mobile-register.html',
  controller: function ($scope,
                        $state,
                        $window,
                        $rootScope,
                        $timeout,
                        auth,
                        focus,
                        $filter,
                        utilsService,
                        PHONE_ATTEMPTS,
                        addressService,
                        phoneConfirmationService) {
    var mRegisterCtrl = this;
    mRegisterCtrl.state = $state;
    mRegisterCtrl.phoneAttempts = PHONE_ATTEMPTS; // количество попыток ввода неверного кода подтверждения телефона администратора
    mRegisterCtrl.phoneAttemptsCashier = PHONE_ATTEMPTS; // количество попыток ввода неверного кода подтверждения телефона кассира
    mRegisterCtrl.activeAddrIndex == undefined; // индекс выбранного из подсказки адреса
    mRegisterCtrl.address = {}; // объект для хранения промежуточных полей адреса
    mRegisterCtrl.addresses = []; // адреса, для подсказки
    mRegisterCtrl.userMailPhoneFlags = {}; // структура флагов логина пользователя
    mRegisterCtrl.regData = {
      company: {
        activity_areas: [],
        short_name: undefined
      },
      owner: {
      },
      cashier: {},
    };

    mRegisterCtrl.ocupacion = '';
    mRegisterCtrl.stepTitle = '';
    mRegisterCtrl.stepNumber = 1;
    mRegisterCtrl.stepNumberTitle = mRegisterCtrl.stepNumber;
    mRegisterCtrl.activeSelect = false;
    mRegisterCtrl.needCashier = false;
    mRegisterCtrl.cash_payment_type = true;

    $scope.$on("$destroy", function (event) {
      $window.backStep = undefined;
    });

    mRegisterCtrl.keypress = function(event){
      if (event.keyCode == 13) {
        event.preventDefault();
        $timeout(function() {
          angular.element(".btn-primary").triggerHandler('click');
        }, 0);
      }
    };

    auth.getMobileRegisterSteps().then(function (res) {
      mRegisterCtrl.steps = res.data.items;
    });

    // предыдущий шаг регистрации
    mRegisterCtrl.prev = function(){
      mRegisterCtrl.errorMessage = undefined;
      // если список открыт, то просто закрыть его
      if (mRegisterCtrl.activeSelect) {
        if (mRegisterCtrl.showChildAreas) {
          mRegisterCtrl.showChildAreas = false;
          mRegisterCtrl.stepTitle = "Сфера деятельности";
          return;
        }
        mRegisterCtrl.closeSelect();
        return;
      }

      mRegisterCtrl.stepNumber--;
      if ((mRegisterCtrl.stepNumber == 4 && (mRegisterCtrl.userMailPhoneFlags.isEmail || mRegisterCtrl.regData.owner.phone_confirmed)) ||
          ((mRegisterCtrl.stepNumber == 8 && mRegisterCtrl.regData.cashier.phone_confirmed) ) ||
          (mRegisterCtrl.stepNumber == 10) ||
          (mRegisterCtrl.stepNumber == 12 && !mRegisterCtrl.bank_payment_type)) {
        mRegisterCtrl.stepNumber--;
      }
      if (mRegisterCtrl.stepNumber == 8 && !mRegisterCtrl.needCashier) {
        mRegisterCtrl.stepNumber--;
        mRegisterCtrl.stepNumber--;
      }
      return !!mRegisterCtrl.stepNumber;
    };

    mRegisterCtrl.backStep = function () {
      return $window.backStep();
    };

    $window.backStep = function () {
      return !mRegisterCtrl.prev();
    };

    // далее по шагам регистрации
    mRegisterCtrl.next = function() {
      mRegisterCtrl.errorMessage = undefined;
      mRegisterCtrl.stepNumber++;
      if ((mRegisterCtrl.stepNumber == 4 && mRegisterCtrl.regData.owner.phone_confirmed) ||
        (mRegisterCtrl.stepNumber == 8 && mRegisterCtrl.regData.cashier.phone_confirmed)) {
        mRegisterCtrl.stepNumber++;
      }
      $timeout(function () {
        focus.setFocusOnInput(false, angular.element("#focusInput")[0]);
      }, 0);
    };

    mRegisterCtrl.error = function () {
      if ($window.Android && $window.Android.sendRegistrationResult) {
        $window.Android.sendRegistrationResult(angular.toJson({"status":"ERROR"}));
      }
    };

    mRegisterCtrl.cancelRegister = function () {
      if ($window.Android && $window.Android.sendRegistrationResult) {
        $window.Android.sendRegistrationResult(angular.toJson({"status":"CANCEL"}));
      }
    };

    mRegisterCtrl.setDirty = function (form) {
      if (form && form.$invalid) {
        form.$setDirty();
        angular.forEach( form.$error ,function (control) {
          for (var i = 0; i < control.length; i++) {
            control[i].$setDirty();
          }
        });
      }
    };

    // проверка валидности формы и установка ошибок, после нажатия кнопки "далее".
    mRegisterCtrl.validateLoginDomain = function(form) {
      if (form && form.ownerLogin) {
        form.ownerLogin.$setValidity('forbiddenEmailDomain', !utilsService.hasForbiddenEmailDomain(mRegisterCtrl.regData.owner.login));
      }
    };

    mRegisterCtrl.checkForm = function(form){
      if (mRegisterCtrl.errorMessage) {
        return;
      }

      mRegisterCtrl.validateLoginDomain(form);
      if (utilsService.hasForbiddenEmailDomain(mRegisterCtrl.regData.owner.login)) {
        if (form && form.ownerLogin) {
          form.ownerLogin.$setDirty();
        }
        return;
      }

      if (form && form.$invalid) {
        mRegisterCtrl.setDirty(form);
        return;
      }

      if (mRegisterCtrl.stepNumber == 3 && mRegisterCtrl.userMailPhoneFlags.isPhone && !mRegisterCtrl.phoneConfirmSended && !mRegisterCtrl.regData.owner.phone_confirmed) {
        mRegisterCtrl.sendPhoneConfirmRequest(form);
        return;
      } else if (mRegisterCtrl.stepNumber == 3 && mRegisterCtrl.userMailPhoneFlags.isEmail) {
        mRegisterCtrl.next();
      }

       if (mRegisterCtrl.stepNumber == 7 && !mRegisterCtrl.cashierPhoneConfirmSended && !mRegisterCtrl.regData.cashier.phone_confirmed) {
        mRegisterCtrl.sendPhoneConfirmRequest(form, true);
        return;
      }

      if (mRegisterCtrl.stepNumber == 6 && !mRegisterCtrl.needCashier) {
        mRegisterCtrl.stepNumber = 8;
      }
      mRegisterCtrl.next();
    };

    // подгрузка компании по инн
    mRegisterCtrl.updateInn = function(inn){
      if (inn) {
        utilsService.getCompanyInfo(inn).then(function(res) {
          if (res.data && res.data[0]) {
            var companyName = res.data[0].short_name_with_opf || res.data[0].name || res.data[0].full_name_with_opf || undefined;
            mRegisterCtrl.regData.company.short_name = companyName;
          } else {
           mRegisterCtrl.regData.company.short_name = null;
          }
        }, function () {
          mRegisterCtrl.error();
        });
      } else {
       mRegisterCtrl.regData.company.short_name = null;
      }
    };

    // получение спивка сфер деятельности
    utilsService.getАctivityАreas().then(function(res){
      mRegisterCtrl.allActivityAreas = res.data;
    }, function () {
      mRegisterCtrl.closeSelect();
      $state.go('registerMobile.mobileError', {message: "Во время получения сфер деятельности возникла ошибка"});
    });

    // показать экран с родительскими сферами деятельности
    mRegisterCtrl.getActivityAreas = function(event){
      event.preventDefault();
      event.stopPropagation();
      mRegisterCtrl.errorMessage = '';
      mRegisterCtrl.activeSelect = true;
      mRegisterCtrl.showActivityAreas = true;
      mRegisterCtrl.stepTitle = "Сфера деятельности";
      mRegisterCtrl.noActiveArea = !mRegisterCtrl.ocupacion;
    };

    // показать экран с чилдиками сфер деятельности
    mRegisterCtrl.getOcupacion = function(parentIndex){
      event.preventDefault();
      event.stopPropagation();
      mRegisterCtrl.activeParent = parentIndex;
      mRegisterCtrl.showChildAreas = true;
      mRegisterCtrl.activeSelect = true;
      mRegisterCtrl.stepTitle = mRegisterCtrl.allActivityAreas[parentIndex].name;
    };

    mRegisterCtrl.checkActivityAreas = function () {
      // проверка выбрал ли что-то пользователь
      // поле обязательное
      mRegisterCtrl.noActiveArea = !_.find(mRegisterCtrl.allActivityAreas, function(area){
        return area.$$active;
      });
    }

    // выбор сфер деятельности
    mRegisterCtrl.chooseActivityAreas = function(parentIndex, index){
      mRegisterCtrl.allActivityAreas[parentIndex].child_areas[index].$$active = !mRegisterCtrl.allActivityAreas[parentIndex].child_areas[index].$$active;
      mRegisterCtrl.allActivityAreas[parentIndex].$$active = !!_.find(mRegisterCtrl.allActivityAreas[parentIndex].child_areas, function(childArea){
        return childArea.$$active;
      });
      mRegisterCtrl.checkActivityAreas();
    };

    // сохранение сфер деятельности
    mRegisterCtrl.saveActivityAreas = function(){
      if (mRegisterCtrl.noActiveArea) return;
      // подготовка структуры для апи и для отображения на форме
      mRegisterCtrl.regData.company.activity_areas = [];
      mRegisterCtrl.ocupacion = '';
      _.forEach(mRegisterCtrl.allActivityAreas, function(area){
        if (area.$$active) {
          _.forEach(area.child_areas, function(child_area){
            if (child_area.$$active) {
              if (mRegisterCtrl.ocupacion) {
                mRegisterCtrl.ocupacion += ", ";
              }
              mRegisterCtrl.ocupacion += child_area.name;
              mRegisterCtrl.regData.company.activity_areas.push({id: child_area.id, name: child_area.name});
            }
          });
        }
      });
      mRegisterCtrl.closeSelect();
    };

    // Закрытие списка
    mRegisterCtrl.closeSelect = function(){
      mRegisterCtrl.activeSelect = false;
      mRegisterCtrl.showActivityAreas = false;
      mRegisterCtrl.showChildAreas = false;
      mRegisterCtrl.activeParent = undefined;
      mRegisterCtrl.stepTitle = undefined;
      mRegisterCtrl.noActiveArea = true;
    };


    /************** 2 шаг **************/
    mRegisterCtrl.checkDomain = function(form){
      if(mRegisterCtrl.regData.domain && /^[a-zA-Z0-9-]*$/.test(mRegisterCtrl.regData.domain)){
        mRegisterCtrl.domainStatus = "load";
        auth.checkDomain(mRegisterCtrl.regData.domain).then(function() {
          mRegisterCtrl.domainStatus = "error";
          mRegisterCtrl.domainTip = "Эта группа занята";
          if (form) {
            form.$invalid = true;
          }
        }).catch(function () {
          mRegisterCtrl.domainStatus = "success";
          mRegisterCtrl.domainTip = "Можете использовать эту группу";
          if (form) {
            form.$invalid = false;
          }
        });
      }else{
        mRegisterCtrl.domainStatus = '';
        mRegisterCtrl.domainTip = '';
      }
    };

    /************** 4 шаг **************/
    /**
     * Отправка запроса на создания кода подтверждения телефона
     */
    mRegisterCtrl.sendPhoneConfirmRequest = function (form, isCashier, noStep) {
      if (isCashier) {
        mRegisterCtrl.cashierTimerStart = new Date();
      } else {
        mRegisterCtrl.userTimerStart = new Date();
      }

      $rootScope.stateChangeStart = true;
      var phone = (isCashier)? mRegisterCtrl.regData.cashier.phone : mRegisterCtrl.regData.owner.login;
      if (!phone) return;
      phoneConfirmationService.sendPhoneConfirmationAnonymousCreate(phone).then(function (data) {
        if (isCashier) {
          mRegisterCtrl.cashierPhoneConfirmSended = true;
          mRegisterCtrl.regData.cashier.phone_confirmation = data.data;
          mRegisterCtrl.cashierPendingPhone = mRegisterCtrl.regData.cashier.phone;
        } else {
          mRegisterCtrl.phoneConfirmSended = true;
          mRegisterCtrl.regData.owner.phone_confirmation = data.data;
          mRegisterCtrl.pendingPhone = mRegisterCtrl.regData.owner.login;
        }
        $rootScope.stateChangeStart = false;
        if (!noStep) {
          mRegisterCtrl.next();
        }
      }).catch(function () {
        $rootScope.stateChangeStart = false;
        $state.go('registerMobile.mobileError', {message: "Во время подтверждения телефона произошла ошибка.<br><br>Повторите попытку позже."});
      });
    };

    /**************** 14 step **************/
    /* Проверка кода партнера и промо-кода */
    var timeout;
    mRegisterCtrl.checkCode = function (isPartnerCode, form) {
      if(timeout) {
          clearTimeout(timeout);
      }
      timeout = setTimeout(function() {
          if (isPartnerCode) {
            form.partner_code.$setValidity('notFound', true);
            mRegisterCtrl.checkPartnerCode(form);
          } else {
            form.promo_code.$setValidity('notFound', true);
            mRegisterCtrl.checkPromoCode(form);
          }
      }, 300);
    }

    mRegisterCtrl.checkPartnerCode = function (form) {
      auth.checkPartnerCode(mRegisterCtrl.regData.partner_code).then(function (res) {
      }, function (error) {
        form.partner_code.$setValidity('notFound', false);
      });
    }

    mRegisterCtrl.checkPromoCode = function (form) {
      auth.checkPromoCode(mRegisterCtrl.regData.promo_code).then(function (res) {
      }, function (error) {
        form.promo_code.$setValidity('notFound', false);
      });
    }
    /* end 14 step*/

    /**
     * Отправка запроса на подтверждения телефона по коду
     */
    mRegisterCtrl.checkPhoneConfirmCode = function (form, isCashier) {
      $rootScope.stateChangeStart = true;
      // код должен быть введен и сохранен объект подтверждения
      if (!isCashier && (!mRegisterCtrl.regData.owner.$$confirmCode || !mRegisterCtrl.regData.owner.phone_confirmation)) {
        return;
      }
      if (isCashier && (!mRegisterCtrl.regData.cashier.$$confirmCode || !mRegisterCtrl.regData.cashier.phone_confirmation)) {
        return;
      }
      phoneConfirmationService.sendPhoneConfirmationAnonymousCode(
        (isCashier)? mRegisterCtrl.regData.cashier.phone_confirmation.id : mRegisterCtrl.regData.owner.phone_confirmation.id,
        (isCashier)? mRegisterCtrl.regData.cashier.$$confirmCode : mRegisterCtrl.regData.owner.$$confirmCode)
        .then(function () {
          if (isCashier) {
            mRegisterCtrl.confirmedCasierPhone = mRegisterCtrl.regData.cashier.phone;
            mRegisterCtrl.regData.cashier.phone_confirmed = true;
            mRegisterCtrl.cashierPhoneConfirmSended = false;
            mRegisterCtrl.cashierBasePhone = $scope.cashierPendingPhone;
            mRegisterCtrl.cashier_pending_phone_changes = null;
            mRegisterCtrl.phoneAttemptsCashier = PHONE_ATTEMPTS;
            form.cashierConfirmCode.$setValidity('confirmError', true);
          } else {
            mRegisterCtrl.confirmedPhone = mRegisterCtrl.regData.owner.login;
            mRegisterCtrl.regData.owner.phone_confirmed = true;
            mRegisterCtrl.phoneConfirmSended = false;
            mRegisterCtrl.userBasePhone = $scope.pendingPhone;
            mRegisterCtrl.pending_phone_changes = null;
            mRegisterCtrl.phoneAttempts = PHONE_ATTEMPTS;
            form.confirmCode.$setValidity('confirmError', true);
          }
          mRegisterCtrl.next();
          $rootScope.stateChangeStart = false;
        }, function (error) {
          // очистка неверного кода
          if (isCashier) {
            mRegisterCtrl.regData.cashier.$$confirmCode = '';
          } else {
            mRegisterCtrl.regData.owner.$$confirmCode = '';
          }
          if (error.status == 503) {
            // сброс ошибки кода подтверждения
            if (isCashier) {
              mRegisterCtrl.phoneAttemptsCashier--;
              form.cashierConfirmCode.$setValidity('confirmError', false);
              if (!mRegisterCtrl.phoneAttemptsCashier) {
                mRegisterCtrl.resetUniversalLogin(form, true);
                mRegisterCtrl.regData.cashier.phone = '';
                mRegisterCtrl.prev();
              }
            } else {
              mRegisterCtrl.phoneAttempts--;
              form.confirmCode.$setValidity('confirmError', false);
              if (!mRegisterCtrl.phoneAttempts) {
                mRegisterCtrl.resetUniversalLogin(form);
                mRegisterCtrl.regData.owner.login = '';
                mRegisterCtrl.prev();
              }
            }
          } else {
            $state.go('registerMobile.mobileError', {message: "Во время подтверждения телефона произошла ошибка. Повторите попытку позже."});
          }
          $rootScope.stateChangeStart = false;
        });
    };

    mRegisterCtrl.resetUniversalLogin = function (form, isCashier) {
      if ((isCashier && mRegisterCtrl.confirmedCasierPhone == mRegisterCtrl.regData.cashier.phone) || 
         (!isCashier && mRegisterCtrl.confirmedPhone == mRegisterCtrl.regData.owner.login)) {
        return;
      }

      if (isCashier) {
        mRegisterCtrl.regData.cashier.phone_confirmed = undefined;
        mRegisterCtrl.regData.cashier.$$confirmCode = undefined;
        mRegisterCtrl.cashierPhoneConfirmSended = undefined;
        mRegisterCtrl.regData.cashier.pending_phone_changes = null;
        mRegisterCtrl.phoneAttemptsCashier = PHONE_ATTEMPTS;
      } else {
        mRegisterCtrl.regData.owner.phone_confirmed = undefined;
        mRegisterCtrl.phoneConfirmSended = undefined;
        mRegisterCtrl.regData.owner.pending_phone_changes = null;
        mRegisterCtrl.phoneAttempts = PHONE_ATTEMPTS;
        mRegisterCtrl.regData.owner.$$confirmCode = undefined;
      }

      /*mRegisterCtrl.confirmedCasierPhone = mRegisterCtrl.regData.cashier.phone;
mRegisterCtrl.confirmedPhone = mRegisterCtrl.regData.owner.login;*/

    }

    /* Проверки уникальности, timeout нужен чтобы поля кассира успели появиться и подсветиться красным в случае ошибки */
    mRegisterCtrl.checkPhonesUnique = function(form){
      $timeout(function () {
        if (mRegisterCtrl.userMailPhoneFlags.isPhone && mRegisterCtrl.regData.cashier.phone && mRegisterCtrl.regData.owner.login == mRegisterCtrl.regData.cashier.phone) {
          form.cashierLogin.$setValidity('phoneUnique', false);
          form.cashierLogin.$setDirty();
        }
      }, 0);
    };

    mRegisterCtrl.checkInnUnique = function(form){
      $timeout(function () {
        if (mRegisterCtrl.regData.owner.inn && mRegisterCtrl.regData.owner.inn == mRegisterCtrl.regData.cashier.inn) {
          form.cashierInn.$setValidity('dataUnique', false);
          form.cashierInn.$setDirty();
        } else {
          form.cashierInn.$setValidity('dataUnique', true);
        }
      }, 0);
    };

    mRegisterCtrl.checkNameUnique = function(form){
      $timeout(function () {
        if (mRegisterCtrl.regData.owner.name && mRegisterCtrl.regData.owner.surname &&
          mRegisterCtrl.regData.owner.name == mRegisterCtrl.regData.cashier.name &&
          mRegisterCtrl.regData.owner.surname == mRegisterCtrl.regData.cashier.surname &&
          mRegisterCtrl.regData.cashier.patronymic == mRegisterCtrl.regData.owner.patronymic) {
            form.cashierLastname.$setValidity('dataUnique', false);
            form.cashierName.$setValidity('dataUnique', false);
            form.cashierLastname.$setDirty();
            form.cashierName.$setDirty();
            if (mRegisterCtrl.regData.cashier.patronymic) {
              form.cashierPatronymic.$setValidity('dataUnique', false);
              form.cashierPatronymic.$setDirty();
            }
        } else {
          form.cashierLastname.$setValidity('dataUnique', true);
          form.cashierName.$setValidity('dataUnique', true);
          form.cashierPatronymic.$setValidity('dataUnique', true);
        }
      }, 0);
    };

    mRegisterCtrl.save = function () {
      mRegisterCtrl.loading = true;
      mRegisterCtrl.errorMessage = "";
      auth.logout().then(function () {
        auth.ensureSession(true).then(function () {
          var registerData = {
            domain: mRegisterCtrl.regData.domain,
            company: mRegisterCtrl.regData.company,
            acquiring_bank: mRegisterCtrl.regData.acquiring_bank || null,
            promo_code: mRegisterCtrl.regData.promo_code || null,
            partner_code: mRegisterCtrl.regData.partner_code || null,
            owner: {
              password: mRegisterCtrl.regData.owner.password,
              email: (mRegisterCtrl.userMailPhoneFlags.isEmail)? mRegisterCtrl.regData.owner.login : null,
              name: mRegisterCtrl.regData.owner.name,
              surname: mRegisterCtrl.regData.owner.surname,
              patronymic: mRegisterCtrl.regData.owner.patronymic,
              phone: (mRegisterCtrl.userMailPhoneFlags.isPhone)? mRegisterCtrl.regData.owner.login : null,
              phone_confirmation: mRegisterCtrl.regData.owner.phone_confirmation || null,
              phone_confirmed: mRegisterCtrl.regData.owner.phone_confirmed || null,
              location: mRegisterCtrl.regData.owner.location || null,
              time_zone: (mRegisterCtrl.regData.owner.time_zone)? mRegisterCtrl.regData.owner.time_zone.timezoneId : null,
              inn: mRegisterCtrl.regData.owner.inn || null,
            }
          };
          if (mRegisterCtrl.needCashier) {
            registerData.cashier = {
              password: mRegisterCtrl.regData.cashier.password,
              name: mRegisterCtrl.regData.cashier.name,
              surname: mRegisterCtrl.regData.cashier.surname,
              patronymic: mRegisterCtrl.regData.cashier.patronymic,
              phone: mRegisterCtrl.regData.cashier.phone || null,
              phone_confirmation: mRegisterCtrl.regData.cashier.phone_confirmation || null,
              phone_confirmed: mRegisterCtrl.regData.cashier.phone_confirmed || null,
              inn: mRegisterCtrl.regData.cashier.inn || null
            };
          }
          registerData.company.type = (registerData.company.inn.toString().length == 10)? "LEGAL_ENTITY" : "SOLE_TRADER";
          auth.register(registerData)
            .then(function (res) {
              mRegisterCtrl.loading = false;
              mRegisterCtrl.errorMessage = "";
              mRegisterCtrl.isSuccessRegister = true;
              mRegisterCtrl.isWrongRegisterData = false;
              if ($window.Android && $window.Android.sendRegistrationResult) {
                if (mRegisterCtrl.userMailPhoneFlags.isPhone) {
                  $window.Android.sendRegistrationResult(angular.toJson({"status": "APPROVE", "group": registerData.domain, "login": mRegisterCtrl.regData.owner.login}));
                } else {
                  $window.Android.sendRegistrationResult(angular.toJson({"status": "NEED_CONFIRM", "group": registerData.domain, "login": mRegisterCtrl.regData.owner.login}));
                  mRegisterCtrl.next();
                }
              }
            })
            .catch(function (err) {
              mRegisterCtrl.loading = false;
              mRegisterCtrl.isSuccessRegister = false;
              mRegisterCtrl.isWrongRegisterData = true;
              if (err.status === 409) {
                mRegisterCtrl.errorMessage = "Группа, которую вы ввели уже занята";
                mRegisterCtrl.domainStatus = "error";
                mRegisterCtrl.domainTip = "Эта группа занята";
                mRegisterCtrl.stepNumber = 2;
              } else {
                mRegisterCtrl.next();
              }
              mRegisterCtrl.error();
            });
        }, function (error) {
          mRegisterCtrl.stepNumber = 15;
          mRegisterCtrl.error();
        });
      }, function (error) {
        mRegisterCtrl.stepNumber = 15;
        mRegisterCtrl.error();
      });
    };

    mRegisterCtrl.gatherAddrAsString = function () {
      var adderess = '';
      for(var prop in mRegisterCtrl.address){
        if(mRegisterCtrl.address[prop] && prop != 'select'){
          if(prop == 'house'){
            adderess += 'дом ';
          }else if(prop == 'building'){
            adderess += 'строение ';
          }else if(prop == 'flat'){
            adderess += 'офис ';
          }else if(prop == 'housing'){
            adderess += 'корпус ';
          }else if(prop == 'street'){
            adderess += 'улица ';
          }else if(prop == 'region'){
            adderess += 'регион ';
          }else if(prop == 'area'){
            adderess += 'район ';
          }else if(prop == 'city'){
            adderess += 'город ';
          }
          adderess += mRegisterCtrl.address[prop] + ", ";
        }
      }
      adderess = adderess.substring(0, adderess.length - 2);
      if (adderess !==  mRegisterCtrl.gatherAddrStr) {
        mRegisterCtrl.gatherAddrStr = adderess;
        mRegisterCtrl.regData.company.shop_address = undefined;
        mRegisterCtrl.activeAddrIndex = undefined;
        mRegisterCtrl.addresses = [];
      }
      return mRegisterCtrl.gatherAddrStr;
    }

    // сбор данных адреса в строку для проверки адреса
    mRegisterCtrl.parseAddr = function(skipCheck){
      if (skipCheck) {
        mRegisterCtrl.next();
        mRegisterCtrl.next();
        return;
      }

      mRegisterCtrl.gatherAddrAsString();
      if (mRegisterCtrl.gatherAddrStr) {
        addressService.addressSuggest(mRegisterCtrl.gatherAddrStr).then(function(res){
          mRegisterCtrl.addresses = res.data;
          mRegisterCtrl.next();
          if (mRegisterCtrl.addresses.length == 1) {
            mRegisterCtrl.activeAddrIndex = 0;
          }
        }, function () {
          $state.go('registerMobile.mobileError', {message: "Во время проверки адреса возникла ошибка. Повторите попытку позже."});
        });
      } else {
        mRegisterCtrl.next();
        mRegisterCtrl.next();
      }
    };

    mRegisterCtrl.saveAddr = function(){
      if (!mRegisterCtrl.gatherAddrStr && !mRegisterCtrl.addresses.length && mRegisterCtrl.activeAddrIndex === undefined) {
        return;
      }
      addressService.addressExt({address_as_string: mRegisterCtrl.addresses[mRegisterCtrl.activeAddrIndex] || mRegisterCtrl.gatherAddrStr}).then(function(res){
        mRegisterCtrl.regData.company.shop_address = res.data.view_ref;
      }, function () {
        $state.go('registerMobile.mobileError', {message: "Во время проверки адреса возникла ошибка. Повторите попытку позже."});
      });
      mRegisterCtrl.next();
    };

    $timeout(function () {
      focus.setFocusOnInput(false, angular.element("#focusInput")[0]);
    }, 1500);

  }
});


(function () {
  'use strict';

  angular.module('frontend').controller('mErrorCtrl', mErrorCtrl);

  function mErrorCtrl($state, $scope, $stateParams, $rootScope, cardHistory, $window) {
    var mErrorCtrl = this;
    mErrorCtrl.previousPage = {};
    var previousParams = {};
    mErrorCtrl.params = $stateParams;
    mErrorCtrl.theme = $stateParams.theme || 'standard';
    mErrorCtrl.stateName = $state.current.name;

    $scope.$on('$stateChangeSuccess', function (ev, to, toParams, prev, prevParams) {
      mErrorCtrl.previousPage = prev;
      previousParams = prevParams;
    });

    mErrorCtrl.goBack = function () {
      if (mErrorCtrl.params.exit === 'true') {
        mErrorCtrl.cancel('ERROR');
        return;
      }
      var prev = cardHistory.popStep();
      var homePage = ($rootScope.toLogin)? 'registerMobile' : 'catalogMobile';
      if(prev){
        $state.go(prev.name || homePage, prev.param);
      }else{
        $state.go(mErrorCtrl.previousPage.name || homePage, previousParams);
      }
    }

    mErrorCtrl.cancel = function (status) {
      if ($window.Android && $window.Android.sendEditCatalogResult) {
        $window.Android.sendEditCatalogResult(angular.toJson({"status": status || "CANCEL"}));
      }
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('catalogMobileController', catalogMobileController);

  function catalogMobileController($scope, $state, $stateParams, $timeout, $window, auth, categoryService) {
    var catalogMobileCtrl = this;
    var categories, catalogItems;
    var statuses = ($stateParams.show_archived_item === 'false') ? ['CONFIRMED', 'DRAFT'] : undefined;
    catalogMobileCtrl.params = $stateParams;
    catalogMobileCtrl.theme = $stateParams.theme || 'standard';
    catalogMobileCtrl.stateParamsChoosen = $stateParams.choosen;
    catalogMobileCtrl.state = $state;
    catalogMobileCtrl.loading = false;
    catalogMobileCtrl.catalogItems = undefined;
    catalogMobileCtrl.totalItems = 0;
    catalogMobileCtrl.offset = 0;

    auth.initPermissions().then(function (res) {
      if (res.data.actions.indexOf('catalog_category.write') == -1 ||
        res.data.actions.indexOf('catalog_item.write') == -1 ||
        res.data.actions.indexOf('catalog_item.archive') == -1 ||
        res.data.actions.indexOf('catalog_item.unarchive') == -1 ||
        res.data.actions.indexOf('price_list.write') == -1) {
        var params = $stateParams;
        params.message = "У вас недостаточно прав на редактирование каталога товаров и услуг";
        params.hide_try_later = true;
        params.exit = !$stateParams.parent && !$stateParams.parentname;
        $state.go('mobileError', params);
      }
    }, function (error) {
      var params = $stateParams;
      params.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных пользователя произошла ошибка";
      params.exit = !params.parent && !params.parentname;
      $state.go('mobileError', params);
    });

    catalogMobileCtrl.initData = function () {
      catalogMobileCtrl.class = "animate";
      catalogMobileCtrl.loading = false;
      if ($stateParams.choosen) {
        catalogMobileCtrl.choosenItem = _.find(catalogMobileCtrl.catalogItems, function (item) {
          return item.id == $stateParams.choosen;
        });
      }
    }

    catalogMobileCtrl.onLoadingCatalogItems = function (isMore) {
      catalogMobileCtrl.blockLoad = true;
      if (isMore) catalogMobileCtrl.offset += 100;
      categoryService.getItemsWithPrice(
        $stateParams.parent,
        { filter_column_type: 'RETAIL', filter_status: statuses, filter_divisions_id: $stateParams.division_id },
        { offset: catalogMobileCtrl.offset }
      )
        .then(function (items) {
          catalogItems = items.data.items;
          catalogMobileCtrl.catalogItems = catalogMobileCtrl.catalogItems.concat(catalogItems);
          catalogMobileCtrl.totalItems = items.data.total;
          catalogMobileCtrl.initData();
          catalogMobileCtrl.blockLoad = false;
        }, function () {
          catalogMobileCtrl.loading = false;
          catalogMobileCtrl.blockLoad = false;
          var params = $stateParams;
          params.exit = !$stateParams.parent && !$stateParams.parentname;
          params.message = "Во время получения товаров и услуг произошла ошибка";
          $state.go('mobileError', params);
        });
    }

    $scope.$on('$viewContentLoaded', function (event, name) {
      // проверки, чтоб данные подгружались только на каталоге
      if ($state.current.name == 'catalogMobile' && name !== '@') {
        categories = undefined;
        catalogItems = undefined;
        catalogMobileCtrl.loading = true;
        // пришлось ини запихивать во viewContentLoaded, т.к. надо после возврата назад обновлять данные,
        // reload не подходит,т.к. сотрется история переходов
        categoryService.getDomainCategories($stateParams.parent, statuses).then(function (res) {
          categories = res.data || [];
          catalogMobileCtrl.catalogItems = categories;
          if ($stateParams.parent) {
            catalogMobileCtrl.onLoadingCatalogItems();
          } else {
            catalogMobileCtrl.initData();
          }
        }, function (error) {
          catalogMobileCtrl.loading = false;
          var params = $stateParams;
          params.exit = !$stateParams.parent && !$stateParams.parentname;
          params.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения категорий произошла ошибка";
          $state.go('mobileError', params);
        });
      }
    });

    $scope.$on('$stateChangeStart', function () {
      catalogMobileCtrl.class = undefined;
    });

    catalogMobileCtrl.cancelCatalog = function () {
      if ($window.Android && $window.Android.sendEditCatalogResult) {
        $window.Android.sendEditCatalogResult(angular.toJson({ "status": "CANCEL" }));
      }
    };

    catalogMobileCtrl.chooseItem = function (event, index) {
      if (index === undefined) {
        catalogMobileCtrl.choosenItem = undefined;
        return;
      }

      if (catalogMobileCtrl.choosenItem && catalogMobileCtrl.choosenItem.id == catalogMobileCtrl.catalogItems[index].id) {
        catalogMobileCtrl.choosenItem = undefined;
      } else {
        catalogMobileCtrl.choosenItem = catalogMobileCtrl.catalogItems[index];
      }
      if (catalogMobileCtrl.catalogItems[index].type) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    catalogMobileCtrl.getAbbreviation = function (name) {
      if (!name) return "";
      var result = "";
      var words = name.split(" ");
      if (words.length == 1) {
        var word = words[0];
        switch (word.length) {
          case 0:
            return "";
          case 1:
            return (word + word).toUpperCase();
          case 2:
            return word.toUpperCase();
          default:
            return (word.charAt(0) + word.charAt(2)).toUpperCase();
        }
      }
      for (var i = 0; i < 2; ++i) {
        var word = words[i];
        if (word.length > 0) {
          result += word.charAt(0);
        }
      }
      return result.toUpperCase();
    }

    catalogMobileCtrl.goMrecover = function () {
      $state.go("catalogMobile.mrecover");
    }


  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('transactionsController', transactionsController);

  function transactionsController($scope,
                 $state,
                 $window,
                 $stateParams,
                 API_URL,
                 OPTIONS_LENGTH,
                 transactionsColumnDefService,
                 userSettingsService,
                 uiGridConstants,
                 companyService,
                 companies,
                 counterparties,
                 contractService,
                 catalogService,
                 dafaultCompany,
                 dafaultDivision,
                 dafaultCatalogItem,
                 defaultStockItemId,
                 dafaultCounterparty,
                 dafaultContract) {
    var transactionsCtrl = this;
    transactionsCtrl.url = API_URL + '/inventory/transactions';
    transactionsCtrl.page = 'transactions';
    transactionsCtrl.header = 'Складские операции';
    transactionsCtrl.sort = "document_date";
    transactionsCtrl.searchPlaceholder = "По названию, коду, артикулу";
    transactionsCtrl.limit = 25;
    transactionsCtrl.params = $stateParams;
    transactionsCtrl.columnDefs =
      userSettingsService.loadProperty(transactionsCtrl.page, 'grid', 'columnsProperty') ||
      transactionsColumnDefService.getColumnDefs.call(this, uiGridConstants);
    transactionsCtrl.usingService = transactionsColumnDefService;
    transactionsCtrl.filterMeta = {};

    transactionsCtrl.rowRouteFunc = function (rowData) {
      var url;
      if (rowData.document.document_type == "CASHREGISTER_END_SHIFT") {
        url = $state.href('cashregshift.view', {
          id: rowData.document.id, 
          end_shift: true
        });
      } else if (rowData.document.document_type == "CASHREGISTER_START_SHIFT"){
        url = $state.href('cashregshift.view', {
          id: rowData.document.id
        });
      } else if (rowData.document.document_type == "CASHBOX_REPLENISHMENT"){
        url = $state.href('cashboxreplenishment.view', {
          id: rowData.document.id
        });
      } else if (rowData.document.document_type == "RETAIL_SALE"){
        url = $state.href('cashregreceipt.view', {
          id: rowData.document.id
        });
      } else if (rowData.document.document_type == "RETAIL_RETURN"){
        url = $state.href('return.view', {
          id: rowData.document.id
        });
      } else if (rowData.document.document_type == "CASHBOX_ENCASHMENT"){
        url = $state.href('encashment.view', {
          id: rowData.document.id
        });
      } else {
        url = $state.href('document.view', {
          type: rowData.document.document_type,
          purpose: rowData.document.document_purpose,
          id: rowData.document.id,
          parent: 'money',
          allDocument: true
        });
      }
      $window.open(url,'_blank');
    };

    transactionsCtrl.gridConfig = {
      gridOptions: {
        enableRowSelection: true,
        multiSelect: true,
        enableRowSelectionAll: true
      },
      preventRequest: true,
      withoutStaticFilters: true,
      searchPlaceholder: "По коду, артикулу, штрих-коду",
      selectValues: {
        company_id: companies,
        counterparty_id: counterparties,
        stock_item_id: function(catalogItemId){return catalogService.searchDerivatives(catalogItemId);},
        division_id: function(company_id){
          if (company_id) {
            return companyService.companyDivisionsLight(company_id);
          } else {
            return companyService.divisions({
              limit: 100
            })
          }
        },
        contract_id: function(companyId, counterpartyId){
          return contractService.contracts({limit: 100}, '', {counterparty_id: counterpartyId, company_id: companyId});
        }
      },
      baseColumns: [
        'quantity',
        'uom.symbols'
      ],
      filterFields: [
        {
          code: 'company_id',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Компания',
          default: dafaultCompany,
          items: []
        },
        {
          code: 'division_id',
          disabled: false,
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Подразделение',
          default: dafaultDivision,
          items: []
        },
        {
          code: 'counterparty_id',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Контрагент',
          default: dafaultCounterparty,
          items: []
        },
        {
          code: 'contract_id',
          selectMatchPattern: '{{\'№\' + $select.selected.number + \' от \' + ($select.selected.date | date:\'dd.MM.yyyy\')}}',
          selectChoicesPattern: '{{\'№\' + item.number + \' от \' + (item.date | date:\'dd.MM.yyyy\')}}',
          type: 'select',
          name: 'Договор',
          default: dafaultContract,
          items: []
        },
        {
          code: 'date',
          type: 'dateRange',
          name: 'Период',
          required: true,
          default: {
            endDate: moment(parseInt(transactionsCtrl.params.end_date)),
            startDate: moment(parseInt(transactionsCtrl.params.start_date))
          }
        },
        {
          code: 'item_id',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Товар',
          required: true,
          items: [],
          default: dafaultCatalogItem,
          refresh: function (search_string) {
            catalogService.catalogItemsAuto(search_string, false, false, OPTIONS_LENGTH).then(function (res) {
              transactionsCtrl.gridConfig.filterFields[5].items = res.data.items;
            });
          }
        },
        {
          code: 'stock_item_id',
          selectMatchPattern: '{{ $select.selected.code + " " + ($select.selected.name || "") }}',
          selectChoicesPattern: '{{ item.code + " " + (item.name || "") }}',
          type: 'select',
          name: 'Складская позиция',
          default: defaultStockItemId,
          items: []
        },
        {
          code: 'operation_type',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Вид операции',
          default: transactionsCtrl.params.stock_type ? {
              id: transactionsCtrl.params.stock_type,
              name: transactionsCtrl.params.stock_type == "OUT"? "Расход" : "Приход"
            } : null,
          items: [{
            id: "IN",
            name: 'Приход'
          },
          {
            id: "OUT",
            name: 'Расход'
          }]
        },
        {
          code: 'lot_number',
          type: 'string',
          name: 'Партия',
          class: 'col-xs-3'
        },
        {
          code: 'serial_number',
          type: 'string',
          name: 'Серийный номер',
          class: 'col-xs-3'
        },
        {
          code: 'base_mode',
          type: 'checkbox',
          default: transactionsCtrl.params.base_mode,
          name: 'Все количества сконвертированы в единичные упаковки'
        }
      ]
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('transactionsColumnDefService', transactionsColumnDefService);

  /** @ngInject */
  function transactionsColumnDefService(userSettingsService) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' :' +
      ' ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 100, 160, 160, 160, 160, 200, 160, 200, 200, 200, 200, 200, 200];

    self.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('transaction', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('transaction', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    self.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('transaction', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    self.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.document.document_purpose',
          enableSorting: false,
          displayName: 'Название документа',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | documentPurpose"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true
        },
        {
          __index: 2,
          name: 'dataValue.document.number',
          enableSorting: true,
          sortName: 'document_number',
          displayName: 'Номер',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[2],
          visible: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.document.date',
          displayName: 'Дата и время',
          enableSorting: true,
          sortName: 'document_date',
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          pinned: true,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.derivative.stock_item.name',
          enableSorting: true,
          sortName: 'stock_item_name',
          backButton: true,
          displayName: 'Складская позиция',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[4],
          visible: true,
          pinned: false,
          footerCellTemplate: ''
        },
        {
          __index: 5,
          name: 'dataValue.quantity',
          displayName: 'Количество',
          visible: true,
          enableSorting: true,
          sortName: 'quantity',
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: 'quantityTemplate.html',
          enableFiltering: false,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.uom.symbols',
          displayName: 'Ед. изм.',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.type',
          enableSorting: false,
          displayName: 'Тип складской операции',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | transactionType"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[7],
          visible: false,
          pinned: false,
          footerCellTemplate: ''
        },
        {
          __index: 8,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.filter.receipt_date">\n' +
          '              <p style="margin-bottom: 0">Дата чека:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.receipt_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user_id">\n' +
          '              <p style="margin-bottom: 0">Сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user")}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80
        }
      ];
    };

    self.loadSavedDefinedColumnWidth();
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('stockTotalController', stockTotalController);

  function stockTotalController($scope, $state,
                 $window,
                 API_URL,
                 stockTotalColumnDefService,
                 userSettingsService,
                 uiGridConstants,
                 companyService,
                 companies,
                 counterparties,
                 contractService) {
    var vm = this;
    vm.url = API_URL + '/inventory/stock_total';
    vm.page = 'stock-total';
    vm.header = 'Складские обороты';
    vm.sort = null;
    vm.limit = 25;
    vm.searchPlaceholder = "По названию, коду, артикулу";
    vm.columnDefs =
      userSettingsService.loadProperty(vm.page, 'grid', 'columnsProperty') ||
      stockTotalColumnDefService.getColumnDefs.call(this, uiGridConstants);
    vm.usingService = stockTotalColumnDefService;

    vm.gridConfig = {
      gridOptions: {
        enableRowSelection: true,
        multiSelect: true,
        enableRowSelectionAll: true
      },
      goToTransactions: function (row, filters, stockType) {
        var params = {
          parent: 'storehouse',
          company_id: row.company.id,
          division_id: row.division.id,
          item_id: row.id,
          stock_item_id: row.derivative.id,
          stock_type: stockType,
          start_date: filters.date.startDate,
          end_date: filters.date.endDate,
          base_mode: filters.base_mode || userSettingsService.loadProperty(vm.page, 'grid', 'base_mode'),
          counterparty_id: filters.counterparty_id,
          contract_id: filters.contract_id,
        };
        var url = $state.href("transactions", params);
        $window.open(url,'_blank');
      },
      preventRequest: true,
      selectValues: {
        company_id: companies,
        counterparty_id: counterparties,
        division_id: function(company_id){
          if (company_id) {
            return companyService.companyDivisionsLight(company_id);
          } else {
            return companyService.divisions({
              limit: 100
            })
          }
        },
        contract_id: function(companyId, counterpartyId){
          return contractService.contracts({limit: 100}, '', {counterparty_id: counterpartyId, company_id: companyId});
        }
      },
      baseColumns: [
        'beginning_qty',
        'quantity',
        'total_qty_in',
        'total_qty_out',
        'uom.symbols'
      ],
      filterFields: [
        {
          code: 'counterparty_id',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          name: 'Контрагент',
          items: []
        },
        {
          code: 'contract_id',
          selectMatchPattern: '{{\'№\' + $select.selected.number + \' от \' + ($select.selected.date | date:\'dd.MM.yyyy\')}}',
          selectChoicesPattern: '{{\'№\' + item.number + \' от \' + (item.date | date:\'dd.MM.yyyy\')}}',
          type: 'select',
          name: 'Договор',
          items: []
        },
        {
          code: 'date',
          type: 'dateRange',
          name: 'Период',
          required: true
        },
        {
          code: 'base_mode',
          type: 'checkbox',
          name: 'Все количества сконвертированы в единичные упаковки'
        }
      ]
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('stockTotalColumnDefService', stockColumnDefService);

  /** @ngInject */
  function stockColumnDefService(userSettingsService) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' :' +
      ' ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 100, 160, 160, 160, 160, 200, 160, 100, 200, 200, 200, 200, 200];

    self.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('stock-total', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('stock-total', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    self.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('stock-total', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    self.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.name',
          enableSorting: true,
          sortName: 'name',
          displayName: 'Складская позиция',
          headerCellTemplate: headerTemplate,
          cellTemplate: 'catalogItemTemplate.html',
          enableFiltering: false,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true
        },
        {
          __index: 2,
          name: 'dataValue.code',
          enableSorting: true,
          sortName: 'code',
          displayName: 'Код',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[2],
          visible: true,
          backButton: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.beginning_qty',
          displayName: 'Количество на начало периода',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.total_qty_in',
          displayName: 'Приход',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-requested-data '+
          'config="{currentFilters: grid.appScope.ctrl.filter, ' + 
                   'stockType: \'IN\', requestPath: \'stockTotal\', ' + 
                   'field: col.field, row: row.entity.dataValue, ' + 
                   'clickCallback: grid.appScope.config.goToTransactions}"></cell-with-requested-data>',
          enableFiltering: false,
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.total_qty_out',
          displayName: 'Расход',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-requested-data config="{currentFilters: grid.appScope.ctrl.filter, stockType: \'OUT\', requestPath: \'stockTotal\', field: col.field, row: row.entity.dataValue, clickCallback: grid.appScope.config.goToTransactions}"></cell-with-requested-data>',
          enableFiltering: false,
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.quantity',
          displayName: 'Количество на конец периода',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-requested-data config="{currentFilters: grid.appScope.ctrl.filter, stockType: \'END\', requestPath: \'stockTotal\', field: col.field, row: row.entity.dataValue}"></cell-with-requested-data>',
          enableFiltering: false,
          width: columnsDefinedWidth[7]
        },
        {
          __index: 8,
          name: 'dataValue.uom.symbols',
          displayName: 'Ед. изм.',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[8]
        },
        {
          __index: 9,
          name: 'dataValue.vendor_code',
          displayName: 'Артикул',
          visible: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[9]
        },
        {
          __index: 10,
          name: 'dataValue.gtins',
          displayName: 'Штрих-код',
          visible: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip cycle="gtin" text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[10]
        },
        {
          __index: 11,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[11]
        },
        {
          __index: 12,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.filter.receipt_date">\n' +
          '              <p style="margin-bottom: 0">Дата чека:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.receipt_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user_id">\n' +
          '              <p style="margin-bottom: 0">Сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user")}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80
        }
      ];
    };

    self.loadSavedDefinedColumnWidth();
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('stockAnalysisController', stock);

  function stock($scope,
                 API_URL,
                 stockAnalysisColumnDefService,
                 userSettingsService,
                 uiGridConstants,
                 companies,
                 companyService,
                 helpService,
                 $rootScope) {
    var vm = this;
    vm.url = API_URL + '/reports/stock_analysis';
    vm.page = 'stock-analysis';
    vm.header = 'Товарные запасы';
    var today = moment.utc();
    vm.sort = null;
    vm.limit = 25;
    vm.searchPlaceholder = "По названию, коду, артикулу";
    vm.columnDefs =
      userSettingsService.loadProperty(vm.page, 'grid', 'columnsProperty') ||
      stockAnalysisColumnDefService.getColumnDefs.call(this, uiGridConstants);
    vm.usingService = stockAnalysisColumnDefService;
    vm.filterMeta = {};
    vm.gridConfig = {
      gridOptions: {
        enableRowSelection: true,
        multiSelect: true,
        enableRowSelectionAll: true
      },
      selectValues: {
        company_id: companies,
        division_id: function(company_id){
          if (company_id) {
            return companyService.companyDivisionsLight(company_id);
          } else {
            return companyService.divisions({
              limit: 100
            })
          }
        }
      },
      baseColumns: [
        'beginning_qty',
        'expected_shipment',
        'expected_replenishment',
        'available',
        'uom'
      ],
      filterFields: [
        {
          code: 'analysis',
          type: 'dateRange',
          name: 'Анализ продаж за',
          required: true,
          default: {
            startDate: today.clone().subtract(7, 'day'),
            endDate: today,
            isAllTime: false
          }
        },
        {
          code: 'purchase_for',
          type: 'integer',
          name: 'Прогноз закупки на период в днях',
          inputSize: '6',
          required: true,
          default: 7
        }
      ]
    }

    if ($rootScope.accountingSettings && $rootScope.accountingSettings.calc_cost_enabled == false) {
      vm.columnDefs = _.filter(vm.columnDefs, function (column, index) {
        return column.name != "dataValue.sales_cost";
      });
      
      vm.columnDefs = _.forEach(vm.columnDefs, function (column, index) {
        column.__index = index;
      });
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('stockAnalysisColumnDefService', stockColumnDefService);

  /** @ngInject */
  function stockColumnDefService(userSettingsService) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' :' +
      ' ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 100, 160, 160, 160, 200, 160, 100, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200, 200];

    self.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('stock_analysis', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('stock_analysis', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    self.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('stock_analysis', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    self.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.name',
          enableSorting: true,
          sortName: 'name',
          displayName: 'Товар',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true,
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>'
        },
        {
          __index: 2,
          name: 'dataValue.code',
          enableSorting: false,
          sortName: 'code',
          displayName: 'Код',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[2],
          visible: true,
          backButton: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.vendor_code',
          displayName: 'Артикул',
          enableSorting: false,
          sortName: 'vendor_code',
          visible: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.gtins',
          displayName: 'Штрих-код',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-for-gtins col="COL_FIELD"></cell-for-gtins>',
          enableFiltering: false,
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.stock_qty',
          displayName: 'Остаток',
          visible: true,
          enableSorting: true,
          sortName: 'stock_qty',
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | formattedAmount" pull-right="true"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip text="grid.appScope.ctrl.totals.total_stock_qty || 0"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.uom.name',
          displayName: 'Единица измерения',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.reserved_qty',
          displayName: 'Резерв',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | formattedAmount" pull-right="true"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip text="grid.appScope.ctrl.totals.total_reserved_qty || 0"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[7]
        },
        {
          __index: 8,
          name: 'dataValue.expected_qty',
          displayName: 'Ожидается',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | formattedAmount" pull-right="true"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip text="grid.appScope.ctrl.totals.total_expected_qty || 0"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[8]
        },
        {
          __index: 9,
          name: 'dataValue.available_qty',
          displayName: 'Доступно',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | formattedAmount" pull-right="true"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip text="grid.appScope.ctrl.totals.total_available_qty || 0"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[9]
        },
        {
          __index: 10,
          name: 'dataValue.sales_qty',
          displayName: 'Продано',
          visible: true,
          sortName: 'sales_qty',
          enableSorting: true,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | formattedAmount" pull-right="true"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip text="grid.appScope.ctrl.totals.total_sales_qty || 0"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[10]
        },
        {
          __index: 11,
          name: 'dataValue.sales_amount',
          enableFiltering: false,
          enableSorting: true,
          sortName: 'sales_amount',
          displayName: 'Сумма продажи',
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_sales_amount || 0"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[11]
        },
        {
          __index: 12,
          name: 'dataValue.sales_cost',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'Себестоимость проданного',
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_sales_cost || 0"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[12]
        },
        {
          __index: 13,
          name: 'dataValue.profit_amount',
          displayName: 'Прибыль',
          cellClass: 'ui-custom-cell-text-align-to-right',
          visible: true,
          enableSorting: true,
          sortName: 'profit_amount',
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_profit_amount || 0"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[13]
        },
        {
          __index: 14,
          name: 'dataValue.margin_prc',
          displayName: 'Маржа',
          cellClass: 'ui-custom-cell-text-align-to-right',
          visible: true,
          enableSorting: true,
          sortName: 'margin_prc',
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD? COL_FIELD + \' %\' : \'\'"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[14]
        },
        {
          __index: 15,
          name: 'dataValue.recommended_purchase_qty',
          displayName: 'Рекомендовано к закупке',
          cellClass: 'ui-custom-cell-text-align-to-right',
          visible: true,
          enableSorting: true,
          sortName: 'recommended_purchase_qty',
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | formattedAmount" pull-right="true"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip text="grid.appScope.ctrl.totals.total_recommended_purchase_qty || 0"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[15]
        },
        {
          __index: 16,
          name: 'dataValue.purchase_amount',
          displayName: 'Стоимость закупки',
          cellClass: 'ui-custom-cell-text-align-to-right',
          visible: false,
          enableSorting: true,
          sortName: 'purchase_amount',
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          enableFiltering: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_purchase_amount || 0"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[16]
        },
        {
          __index: 17,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
            'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
            'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
            '      <button class="btn btn-default dropdown-toggle"\n' +
            '              data-toggle="modal" data-target="#filter-popup"\n' +
            '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
            '\n' +
            '      <div class="dropdown-menu pull-right">\n' +
            '\n' +
            '        <div>\n' +
            '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
            '        </div>\n' +
            '\n' +
            '        <div class="content-wrapper">\n' +
            '          <div class="content">\n' +
            '            <div ng-if="grid.appScope.filter.receipt_date">\n' +
            '              <p style="margin-bottom: 0">Дата чека:</p>\n' +
            '              <p>{{grid.appScope.ctrl.filter.receipt_date}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.filter.shift_number">\n' +
            '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
            '              <p>{{grid.appScope.filter.shift_number}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.filter.shift_date">\n' +
            '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
            '              <p>{{grid.appScope.filter.shift_date}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
            '              <p style="margin-bottom: 0">Компания:</p>\n' +
            '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
            '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
            '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
            '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
            '              <p>{{grid.appScope.filter.cash_register_place_name}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.user_id">\n' +
            '              <p style="margin-bottom: 0">Сотрудник:</p>\n' +
            '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user")}}</p>\n' +
            '            </div>\n' +
            '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
            '          </div>\n' +
            '        </div>\n' +
            '      </div>\n' +
            '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80
        }
      ];
    };

    self.loadSavedDefinedColumnWidth();
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('stockController', stock);

  function stock($scope,
                 API_URL,
                 stockColumnDefService,
                 userSettingsService,
                 uiGridConstants,
                 companies,
                 companyService,
                 helpService,
                 $rootScope) {
    var vm = this;
    vm.url = API_URL + '/inventory/stock';
    vm.page = 'stock';
    vm.header = 'Складские остатки';
    vm.searchPlaceholder = "По названию, коду, артикулу";
    vm.sort = null;
    vm.limit = 25;
    var tomorrow = helpService.now().clone().add(1, 'day');
    vm.columnDefs =
      userSettingsService.loadProperty(vm.page, 'grid', 'columnsProperty') ||
      stockColumnDefService.getColumnDefs.call(this, uiGridConstants);
    var date = helpService.now().clone().add(1, 'day');
    date.isEmpty = true;
    vm.usingService = stockColumnDefService;
    vm.filterMeta = {};
    vm.gridConfig = {
      gridOptions: {
        enableRowSelection: true,
        multiSelect: true,
        enableRowSelectionAll: true
      },
      selectValues: {
        company_id: companies,
        division_id: function(company_id){
          if (company_id) {
            return companyService.companyDivisionsLight(company_id);
          } else {
            return companyService.divisions({
              limit: 100
            })
          }
        }
      },
      baseColumns: [
        'qty',
        'expected_shipment',
        'expected_replenishment',
        'available',
        'uom.symbols',
        'cost'
      ],
      filterFields: [
        {
          code: 'date',
          type: 'date',
          name: 'На начало дня',
          default: tomorrow,
          required: true,
          opts: {singleDatePicker: true, correctTimeZone: false, maxDate: tomorrow}
        },
        {
          code: 'balance',
          selectMatchPattern: '{{ $select.selected.name }}',
          selectChoicesPattern: '{{ item.name }}',
          type: 'select',
          default: {
            id: 'POSITIVE',
            name: 'Положительный'
          },
          name: 'Остаток',
          placeholder: 'Любой',
          required: true,
          items: []
        },
        {
          code: 'base_mode',
          type: 'checkbox',
          name: 'Все количества сконвертированы в единичные упаковки'
        }
      ]
    }

    if ($rootScope.accountingSettings && $rootScope.accountingSettings.calc_cost_enabled) {
      vm.gridConfig.filterFields[vm.gridConfig.filterFields.length-1].class = 'col-xs-2';
      vm.gridConfig.filterFields.push({
        class: 'col-xs-2',
        code: 'calc_cost',
        type: 'checkbox',
        name: 'Считать себестоимость',
        default: false
      });
    }

    if ($rootScope.accountingSettings && $rootScope.accountingSettings.calc_cost_enabled == false) {
      vm.columnDefs = _.filter(vm.columnDefs, function (column, index) {
        return column.name != "dataValue.cost" && column.name != "dataValue.cost_amount";
      });
      
      vm.columnDefs = _.forEach(vm.columnDefs, function (column, index) {
        column.__index = index;
      });
    }
    

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('stockColumnDefService', stockColumnDefService);

  /** @ngInject */
  function stockColumnDefService(userSettingsService) {
    var self = this;

    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' :' +
      ' ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 100, 160, 160, 160, 100, 160, 100, 200, 200, 200, 200, 200, 200, 200];

    self.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('stock_columns', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('stock_columns', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    self.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('stock_columns', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    self.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.name',
          enableSorting: true,
          sortName: 'name',
          displayName: 'Складская позиция',
          headerCellTemplate: headerTemplate,
          cellTemplate: 'catalogItemTemplate.html',
          enableFiltering: false,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true,
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>'
        },
        {
          __index: 2,
          name: 'dataValue.code',
          enableSorting: true,
          sortName: 'code',
          displayName: 'Код',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[2],
          visible: true,
          backButton: true,
          pinned: true
        },
        {
          __index: 3,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.qty',
          displayName: 'Остаток',
          visible: true,
          enableSorting: false,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-requested-data config="{requestPath: \'stock\', field: col.field, row: row.entity.dataValue, index: rowRenderIndex}"></cell-with-requested-data>',
          enableFiltering: false,
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.uom.symbols',
          displayName: 'Ед. изм.',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.cost',
          displayName: 'Себестоимость',
          cellClass: 'ui-custom-cell-text-align-to-right',
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.sales_price',
          displayName: 'Цена продажи',
          cellClass: 'ui-custom-cell-text-align-to-right',
          visible: true,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[7]
        },
        {
          __index: 8,
          name: 'dataValue.vendor_code',
          displayName: 'Артикул',
          enableSorting: true,
          sortName: 'vendor_code',
          visible: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[8]
        },
        {
          __index: 9,
          name: 'dataValue.gtins',
          displayName: 'Штрих-код',
          visible: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-for-gtins col="COL_FIELD"></cell-for-gtins>',
          enableFiltering: false,
          width: columnsDefinedWidth[9]
        },
        {
          __index: 10,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          visible: false,
          enableSorting: false,
          minWidth: 60,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          enableFiltering: false,
          width: columnsDefinedWidth[10]
        },
        {
          __index: 11,
          name: 'dataValue.cost_amount',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'Сумма себестоимости',
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_cost_amount || 0"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[11]
        },
        {
          __index: 12,
          name: 'dataValue.sales_amount',
          enableFiltering: false,
          enableSorting: false,
          displayName: 'Сумма продажи',
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_sales_amount || 0"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[12]
        },
        {
          __index: 13,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.filter.receipt_date">\n' +
          '              <p style="margin-bottom: 0">Дата чека:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.receipt_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user_id">\n' +
          '              <p style="margin-bottom: 0">Сотрудник:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user")}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80
        }
      ];
    };

    self.loadSavedDefinedColumnWidth();
  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('inventoryTagSettingsController', inventoryTagSettingsController);

  function inventoryTagSettingsController($scope,
                                          inventoryTagSettings,
                                          inventoryTagSettingsOptions,
                                          cardHistory,
                                          $state,
                                          errorMessageService,
                                          inventoryService,
                                          $q) {
    var vm = this;
    vm.inventoryTagSettings = inventoryTagSettings;
    vm.checkboxes = inventoryTagSettingsOptions;
    vm.formats = ['PDF', 'RTF'];
    vm.inventoryTagSettingsSize = [
      {label: '5 х 4 см', value: 'SIZE_5X4'},
      {label: '10 х 4 см', value: 'SIZE_10X4'}
    ];

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if(prev){
        $state.go(prev.name || 'catalog', prev.param || {parent: $state.params.parent});
      }else{
        $state.go('catalog', {parent: $state.params.parent});
      }
    };

    vm.save = function(){
      var deferred = $q.defer();
      return inventoryService.updateInventoryTagSettings(vm.inventoryTagSettings).then(function(res) {
          $scope.inventoryTagsSettings.$setPristine();
          vm.returnToPage();
        },
        function (error) {
          errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
          return deferred.reject();
        })
    };

    vm.crud = function (status) {
      switch(status) {
        case 'save':
          return vm.save();
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    }

  }
})();

'use strict';
angular.module('frontend').component('printInventoryTags', {
  templateUrl: 'app/inventory/inventory-print/inventory-print.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'ctrl',
  controller: function ($timeout,
                        print,
                        API_URL,
                        helpService,
                        statusSrv,
                        authToken,
                        downloadSrv,
                        inventoryService,
                        $scope,
                        $state) {
    print.turnonInterceptorStatus();
    var ctrl = this;
    ctrl.exec_id = null;
    ctrl.selectAll = false;
    ctrl.amount = 1;
    ctrl.longRequest = {
      format: null,
      exec_id: null,
      crudState: helpService.getCrudStateStructure(),
      flags: {
        processStart: false,
        finish: false
      },
      stopAskingError: function(){
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function(err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
      },
      revert: function() {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };
    ctrl.gridState = helpService.getCrudStateStructure();
    ctrl.gtins = [];
    ctrl.derivatives = [];
    ctrl.total_qty = 0;

    if (ctrl.resolve.catalogItem) {
      var copy = angular.copy(ctrl.resolve.catalogItem.sku_list);
      angular.forEach(copy, function(sku) {
        angular.forEach(sku.gtin_list, function(gtin) {
          if (!ctrl.gtins.find(function(value) {return value.id === gtin.id})) {
            ctrl.gtins.push(gtin);
          }
        })
      });
      if (ctrl.gtins.length === 1) {
        ctrl.gtin = ctrl.gtins[0];
      }
    }

    ctrl.gridOptions =  {
      enableFiltering: false,
      enableSelection: true,
      enableRowHeaderSelection: false,
      showColumnFooter: true,
      columnDefs: [
        { name: 'marginLeft',
          field: 'option',
          displayName:'',
          enableColumnMenu:false,
          enableHiding: false,
          enableSorting: false,
          enableFiltering: false,
          width: 20
        },
        { name: 'code', displayName: 'Код', cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableSorting: false,
          footerCellTemplate: '<div style="padding-left: 16px" class="ui-grid-bottom-panel">Итого:</div>',
          width: 100
        },
        { name: 'name', displayName: 'Наименование', cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableSorting: true},
        { name: 'vendor_code', displayName: 'Артикул', cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableSorting: false, width: 130},
        { name: 'gtin.gtin', displayName: 'Штрих-код', cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>', enableSorting: false, width: 205},
        {
          name: 'qty', displayName: 'Этикеток', cellTemplate:  '<cell-with-tooltip text="COL_FIELD"/>', enableSorting: true,
          width: 120,
          footerCellTemplate: '<cell-with-tooltip text="grid.appScope.ctrl.total_qty"/>',
          footerCellClass: 'ui-grid-footer-custom-padding'
        }
      ],
      data: []
    };

    ctrl.onSelectAllHandler = function (isAllRowSelected) {
      if (!isAllRowSelected) {
        ctrl.gridApi.selection.clearSelectedRows()
      } else {
        ctrl.gridApi.selection.selectAllRows();
      }
      ctrl.printForm.$setValidity('selectedItems', isAllRowSelected);
    };

    ctrl.gridOptions.onRegisterApi = function(gridApi) {
      ctrl.gridApi = gridApi;
      ctrl.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
        if (!sortColumns.length) {
          ctrl.paging.sortBy = null;
          ctrl.paging.sortDirection = null;
        } else {
          ctrl.paging.sortBy = sortColumns[0].field;
          ctrl.paging.sortDirection = sortColumns[0].sort.direction;
        }
        ctrl.getPage();
      });
      ctrl.gridApi.selection.on.rowSelectionChanged($scope, function () {
        ctrl.printForm.$setValidity('selectedItems', ctrl.gridApi.selection.getSelectedRows().length > 0);
      });
    };

    ctrl.refreshDerivative = function(searchString, resetDerivative) {
      if (!(ctrl.gtin && ctrl.gtin.id)) return;
      if (resetDerivative) ctrl.derivative = null;
      var params = angular.copy(ctrl.resolve.params);
      params.push(searchString);
      params.push(ctrl.gtin.id);
      inventoryService.getInventoryTagsData(ctrl.resolve.type, params).then(function(res) {
        ctrl.derivatives = res.data.items || res.data;
        if (ctrl.derivatives.length === 1) {
          ctrl.derivative = ctrl.derivatives[0]
        }
      }, function(err) {
        console.error(err)
      })
    };

    ctrl.getPage = function() {
      var params = angular.copy(ctrl.resolve.params);
      params.push(ctrl.paging);
      ctrl.gridState.startLoading();
      params.filter_date = moment(params.filter_date).valueOf();
      inventoryService.getInventoryTagsData(ctrl.resolve.type, params).then(function(value) {
        ctrl.gridOptions.data = value.data.items;
        ctrl.noData = value.data.items.length === 0;
        ctrl.paging.total = value.data.total;
        ctrl.total_qty = value.data.total_qty;
        ctrl.gridState.stopLoadingSuccess();
        ctrl.printForm.$setValidity('selectedItems', ctrl.resolve.type === 'byItem');
      }, function(error) {
        ctrl.gridState.stopLoadingFailure('error');
        ctrl.noData = true;
        ctrl.printForm.$setValidity('selectedItems', ctrl.resolve.type === 'byItem');
      })
    };

    ctrl.goToInventoryTagsSettings = function() {
      ctrl.modalInstance.dismiss();
      $state.go('inventoryTagSettings', {parent: 'retail'});
    };

    ctrl.paging = {
      current: 0,
      limit: 5,
      offset: 0,
      sortBy: undefined,
      total: undefined
    };

    ctrl.onAmountChange = function(amount) {
      if (ctrl.derivative) ctrl.derivative.qty = parseInt(amount)
    };

    ctrl.prepareReport = function() {
      ctrl.longRequest.crudState.startLoading();
      var items = [ctrl.derivative];
      if (ctrl.resolve.type !== 'byItem') items = ctrl.gridApi.selection.getSelectedRows();
      print.printInventoryTags(items).then(function(res) {
        ctrl.longRequest.exec_id = res.data.exec_id;
        statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function (res) {
          ctrl.longRequest.flags.finish = true;
          print.turnoffInterceptorStatus();
          $timeout(function() {
            downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
              ctrl.longRequest.crudState.stopLoadingSuccess();
              $timeout(function() {
                ctrl.close()
              }, 300, false);
            });
          });
        },ctrl.longRequest.onError);
      }).catch(ctrl.longRequest.onError);

    };


    ctrl.close = function() {
      ctrl.modalInstance.dismiss();
    };


    ctrl.getPage();
  }
});


(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('writeUpStatementListCtrl', writeUpStatementListCtrl);

  function writeUpStatementListCtrl(userSettingsService,
                                  uiGridConstants,
                                  writeUpStatementListDefsService,
                                  filterSettingsService,
                                  API_URL,
                                  $rootScope,
                                  $filter,
                                  $state,
                                  writeUpStatementStatuses,
                                  divisions,
                                  companies,
                                  employees,
                                  currenciesService) {
    var writeUpStatementListCtrl = this;
    writeUpStatementListCtrl.url = API_URL + '/alcohol/documents/write_up_statements_egais';
    writeUpStatementListCtrl.page = "write-up-statement-list";
    writeUpStatementListCtrl.header = 'Оприходования';
    writeUpStatementListCtrl.sort = 'doc_date';
    writeUpStatementListCtrl.limit = 25;
    //writeUpStatementListCtrl.docSettings = docSettings;
    writeUpStatementListCtrl.columnDefs = userSettingsService.loadProperty(writeUpStatementListCtrl.page, 'grid', 'columnsProperty') ||
      writeUpStatementListDefsService.getColumnDefs.call(this, uiGridConstants);
    writeUpStatementListCtrl.usingService = writeUpStatementListDefsService;
    writeUpStatementListCtrl.filterMeta = {};
    writeUpStatementListCtrl.gridButtonConfig = [];


    /**
     * Переход на страничку просмотра/редактирования оприходования
     * если у оприходования статус NEED_TO_DECIDE (Новое), то редактирование,
     * в остальных случаях просмотр
     */
    writeUpStatementListCtrl.rowRouteFunc = function (rowData) {
      if ($rootScope.hasRole('write_up_statement_egais.write') && rowData.status == 'DRAFT') {
        $state.go('writeUpStatement.edit', {
          id: rowData.id,
          register: rowData.register,
          parent: 'alcohol'
        });
      } else {
        $state.go('writeUpStatement.view', {
          id: rowData.id,
          register: rowData.register,
          parent: 'alcohol'
        });
      }
    };

    currenciesService.getDomainCurrencies().then(function (res) {
      writeUpStatementListCtrl.gridConfig = {
        universalAlcoDocuments: true,
        purposesFilterOn: false,
        currencies: res.data.items,
        documentType: writeUpStatementListCtrl.page
      };

      if ($rootScope.hasRole('write_up_statement_egais.write')) {
        writeUpStatementListCtrl.gridConfig.purposes = [{
          url: "writeUpStatement.new({register: \"REGISTER1\"})",
          label: "акт постановки на баланс Регистр №1",
          permission: 'write_up_statement_egais.write'
        },{
          url: "writeUpStatement.new({register: \"REGISTER2\"})",
          label: "акт постановки на баланс Регистр №2",
          permission: 'write_up_statement_egais.write'
        }];
      }
    });

    writeUpStatementListCtrl.writeUpTypes = [
      {
        value: "MIX",
        label: "Пересортица"
      },
      {
        value: "OVERAGE",
        label: "Излишки"
      }
    ];

    writeUpStatementListCtrl.registers = [
      {
        value: "REGISTER1",
        label: "Регистр №1"
      },
      {
        value: "REGISTER2",
        label: "Регистр №2"
      }
    ];
    angular.forEach(writeUpStatementListCtrl.columnDefs, function (column) {
      if (column.name === 'dataValue.write_up_type') {
        column.filter.selectOptions = writeUpStatementListCtrl.writeUpTypes;
      }
      if (column.name === 'dataValue.register') {
        column.filter.selectOptions = writeUpStatementListCtrl.registers;
      }
    });

    // Get data for selects
    if (writeUpStatementStatuses) {
      angular.forEach(writeUpStatementListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.status') {
          column.filter.selectOptions = writeUpStatementStatuses;
        }
      });
    }

    if (divisions) {
      this.divisionsSelect = [];
      writeUpStatementListCtrl.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        writeUpStatementListCtrl.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(writeUpStatementListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = writeUpStatementListCtrl.divisionsSelect;
        }
      });
    }

    if (companies) {
      writeUpStatementListCtrl.companiesSelect = [];
      writeUpStatementListCtrl.companiesPopup = companies;
      companies.forEach(function (item) {
        writeUpStatementListCtrl.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(writeUpStatementListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = writeUpStatementListCtrl.companiesSelect;
        }
      });
    }

    if (employees) {
      writeUpStatementListCtrl.employeeListSelect = [];
      writeUpStatementListCtrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        writeUpStatementListCtrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(writeUpStatementListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = writeUpStatementListCtrl.employeeListSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterWriteUpStatementList().then(function (res) {
      writeUpStatementListCtrl.filterMeta = res.data.items;
      writeUpStatementListCtrl.filterMeta[0].selectVal = writeUpStatementStatuses;
      writeUpStatementListCtrl.filterMeta[3].selectVal = writeUpStatementListCtrl.writeUpTypes;
      writeUpStatementListCtrl.filterMeta[4].selectVal = writeUpStatementListCtrl.registers;
      writeUpStatementListCtrl.filterMeta[5].selectVal = writeUpStatementListCtrl.divisionsSelect;
      writeUpStatementListCtrl.filterMeta[7].selectVal = writeUpStatementListCtrl.companiesSelect;
      writeUpStatementListCtrl.filterMeta[8].selectVal = writeUpStatementListCtrl.employeeListSelect;
      writeUpStatementListCtrl.filterMeta[10].selectVal = writeUpStatementListCtrl.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('writeUpStatementListDefsService', writeUpStatementListDefsService);

  /** @ngInject */
  function writeUpStatementListDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 160, 160, 160, 100, 160, 200, 200, 200, 200, 200, 200, 160, 200, 200, 200, 200, 200];

    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('write-up-statement-list', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('write-up-statement-list', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('write-up-statement-list', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '',
          visible: true,
          headerCellTemplate: '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          displayName: 'Статус',
          visible: true,
          pinned: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | writeUpStatementStatus"/>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[1]
        },
        {
          __index: 2,
          name: 'dataValue.doc_number',
          enableSorting: true,
          sortName: 'doc_number',
          displayName: 'Номер',
          enableFiltering: true,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          backButton: true,
          filterName: 'number',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.doc_date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'doc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'date',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.write_up_type',
          displayName: 'Причина постановки',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD == \'MIX\')? \'Пересортица \' : (COL_FIELD == \'OVERAGE\')? \'Излишки \' : \'\'"/>',
          filterName: 'write_up_type',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.register',
          displayName: 'Регистр',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD == \'REGISTER1\')? \'Регистр №1 \' : (COL_FIELD == \'REGISTER2\')? \'Регистр №2\' : \'\'"/>',
          filterName: 'register',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.write_off_statement_egais',
          displayName: 'Акт списания',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD)? \'№\' + COL_FIELD.doc_number  + \' от \' + (COL_FIELD.doc_date | date: \'dd.MM.yyyy\') : \'\'"/>',
          width: columnsDefinedWidth[7]
        },
        { __index: 8,
          name: 'dataValue.home_amount',
          enableFiltering: false,
          displayName: 'Сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_home_amount || 0"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[8]
        },
        { __index: 9,
          name: 'dataValue.reg_id',
          enableSorting: true,
          sortName: 'reg_id',
          displayName: 'Номер ЕГАИС',
          visible: true,
          filterName: 'reg_id',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[9]
        },
        {
          __index: 10,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: false,
          width: columnsDefinedWidth[10]
        },
        { __index: 11,
          name: 'dataValue.comment',
          enableSorting: false,
          displayName: 'Комментарий',
          visible: false,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[11]
        },
        { __index: 12,
          name: 'dataValue.created_by.name',
          enableSorting: false,
          displayName:'Кто создал',
          visible: false,
          width: columnsDefinedWidth[12],
          filterName: 'created_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 13,
          name: 'dataValue.created_at',
          displayName: 'Когда создал',
          enableSorting: true,
          sortName: 'created_at',
          headerCellTemplate: headerTemplate,
          filterName: 'created_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[13]
        },
        { __index: 14,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[14],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 15,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'updated_at',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[15]
        },
        {
          __index: 16,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

'use strict';

angular.module('frontend').service('writeUpStatementService', function ($http, $q, API_URL) {

  /**
   * Получение акта постановки ЕГАИС
   *
   * @param id акта
   * @return {HttpPromise}
   */
  this.getWriteUpStatement = function (id) {
    return $http.get(API_URL + '/alcohol/documents/write_up_statements_egais/' + id);
  };

  /**
   * Сохранение нового акта
   *
   * @param data данные по новому акту
   * @return {HttpPromise}
   */
  this.createWriteUpStatement = function (data) {
    return $http.post(API_URL + '/alcohol/documents/write_up_statements_egais', data).then(function (data) {
      return data.data;
    });
  };


  /**
   * Обновление акта
   * @param id акта
   * @param data данные по новому акту
   * @return {HttpPromise}
   */
  this.updateWriteUpStatement = function (id, data) {
    return $http.put(API_URL + '/alcohol/documents/write_up_statements_egais/' + id, data).then(function (data) {
      return data.data;
    });
  };

  /**
   * Удаление акта
   *
   * @param ids актов
   * @return {HttpPromise}
   */
  this.removeWriteUpStatement = function (id) {
    return $http.delete(API_URL + '/alcohol/documents/write_up_statements_egais/' + id).then(function (data) {
      return data.data;
    });
  };

  /**
   * Изменение статуса акта постановки
   *
   * @param data данные по новому акту
   * @return {HttpPromise}
   */
  this.updateWriteUpStatementStatus = function (id, status) {
    var params = { status: status };
    return $http.put(API_URL + '/alcohol/documents/write_up_statements_egais/' + id + '/status', params).then(function (data) {
      return data.data;
    });
  };


  // /**
  //  * Получение марок акта списания ЕГАИС
  //  *
  //  * @param docId документа
  //  * @param lineId линейки
  //  * @return {HttpPromise}
  //  */
  // this.getWriteOffMarks = function (docId, lineId) {
  //   return $http.get(API_URL + '/alcohol/documents/write_up_statements_egais/' + docId + '/lines/' + lineId + '/marks').then(function (data) {
  //     return data.data;
  //   });
  // };

  // /**
  //  * Управление марками документа
  //  *
  //  * @param docId документа
  //  * @param lineId линейки
  //  * @return {HttpPromise}
  //  */
  // this.scanMarks = function (docId, lineId, params) {
  //   return $http.put(API_URL + '/alcohol/documents/write_up_statements_egais/' + docId + '/lines/' + lineId + '/marks', params).then(function (data) {
  //     return data.data;
  //   });
  // };



});

(function () {
  'use strict';

  angular.module('frontend').controller('writeUpStatementCtrl', writeUpStatementCtrl);

  /** @ngInject */
  function writeUpStatementCtrl($scope,
                               $state,
                               $stateParams,
                               $uibModal,
                               meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                               writeUpStatement,
                               egaiszService,
                               writeUpStatementService,
                               errorMessageService,
                               crudsService,
                               $window,
                               modalAskSrv) {
    var writeUpStatementCtrl = this;

    // состояние редактирования
    writeUpStatementCtrl.redact = !writeUpStatement || writeUpStatement.status == 'DRAFT' || $state.current.name.endsWith('new');

    // метаданные ТТН
    writeUpStatementCtrl.meta = meta;

    // данные по акту
    writeUpStatementCtrl.values = writeUpStatement || {doc_date: moment(), write_up_type : "OVERAGE", lines: []};
    writeUpStatementCtrl.values.register = $stateParams.register;

    // переход к списку
    writeUpStatementCtrl.toGridPage = function() {
      $state.go('writeUpStatementsList', {parent: 'alcohol'});
    };

    writeUpStatementCtrl.crudsService = crudsService;

    // // преобразование справки2
    // _.forEach(writeUpStatementCtrl.values.lines, function(line){
    //   if(line.alcohol_stock_item){
    //     line.alcohol_stock_item.f2reg_id = line.alcohol_stock_item.name;
    //   }
    // })

    // необходим вотчер для того чтобы разрешать сохранять документ, если удалили линейку.
    // diry у формы при этом автоматом не выставляется
    // прямо в компоненте поля не получилось этого сделать,т.к. нет прямого доступа к контроллеру формы
    $scope.$watch(function() { return writeUpStatementCtrl.values.lines.length }, function(newVal, oldVal) {
      if (newVal != oldVal) {
        writeUpStatementCtrl.writeUpStatementForm.$dirty = true;
      }
    });

    writeUpStatementCtrl.showStatusComment = function (comment) {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/info.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.titleFontSize = 28;
          $scope.title = 'Дополнительная информация';
          $scope.text = comment;
          $scope.infoIcon = true;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    // удаление акта
    writeUpStatementCtrl.delete = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'акт списания';
          $scope.conflictDeleteText = "Невозможно удалить акт списания.<br>Для удаления необходимо удалить все связанные документы.";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.delete = function() {
            $scope.lock = true;
            writeUpStatementService.removeWriteUpStatement(writeUpStatementCtrl.values.id).then(function(res){
              $uibModalInstance.dismiss();
              writeUpStatementCtrl.writeUpStatementForm.$setPristine();
              writeUpStatementCtrl.writeUpStatementForm.$setUntouched();
              writeUpStatementCtrl.toGridPage();
              $scope.lock = false;
            }, function (error) {
              if(error.status == 409){
                $scope.canDelete = false;
                $scope.lock = false;
                return;
              }
              $uibModalInstance.dismiss();
              errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: error});
              $scope.lock = false;
            });
          };
        }
      });
      return modal.result;
    }

    if ($stateParams.source && $stateParams.sourceDate && $stateParams.sourceNumber) {
      writeUpStatementCtrl.values.write_up_type = "MIX";
      writeUpStatementCtrl.values.base_document = {
        base_document_type: "DOCUMENT_EGAIS",
        document_egais: {
          id: $stateParams.source,
          doc_date: $stateParams.sourceDate,
          doc_number: $stateParams.sourceNumber,
          document_egais_type: "WRITE_OFF_STATEMENT_EGAIS"
        }
      }
    } else if ($stateParams.source && (!$stateParams.sourceDate || !$stateParams.sourceNumber)) {
      writeUpStatementCtrl.values.id = undefined;
      writeUpStatementCtrl.values.status = undefined;
      writeUpStatementCtrl.values.doc_number = undefined;
      writeUpStatementCtrl.values.status_history = undefined;
      _.forEach(writeUpStatementCtrl.values.lines, function(line){
        line.quantity = undefined;
      });
    }
    

    function copyDocument() {
      $window.open($state.href('writeUpStatement.new', { source: writeUpStatementCtrl.values.id, id: undefined, register: writeUpStatementCtrl.values.register, parent: 'alcohol' }), '_blank');
    }

    // копировать акт
    writeUpStatementCtrl.copyHandler = function(status){
      if (writeUpStatementCtrl.writeUpStatementForm.$pristine) {
        copyDocument();
      } else {
        modalAskSrv.showModal({
          title: 'Есть несохраненные изменения. Новый документ будет создан только по сохраненным данным.'
        }).then(copyDocument);
      }
    }

    // установка акту статуса
    writeUpStatementCtrl.setActStatus = function(status){
      if (status == 'NEED_TO_ACCOUNTED') {
        $uibModal.open({
          templateUrl: 'app/settings/templates/modals/one-question.html',
          size: 'small-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.title = "Провести";
            $scope.text = "Вы действительно хотите выполнить проведение документа?";
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };
            $scope.action = function () {
              $uibModalInstance.close();
              writeUpStatementCtrl.save(status);
            };
          }
        });
      } else {
        writeUpStatementService.updateWriteUpStatementStatus(writeUpStatementCtrl.values.id, status).then(function(res){
          $state.go("writeUpStatement.edit", {id: writeUpStatementCtrl.values.id, source: undefined, register: writeUpStatementCtrl.values.register, parent: 'alcohol'}, {reload: true});
        },
        function (error) {
          showError(error);
        });
      }
    }

    function showError (error) {
      if (error.data.fields && error.data.fields[0] && error.data.fields[0].field == 'derivative' && error.data.fields[0].error.indexOf("Строка ") != -1) {
        var errorStr = error.data.fields[0].error.split(". ");
        var number = errorStr[0].replace( /^\D+/g, '');
        writeUpStatementCtrl.writeUpStatementForm.commonData['rowForm' + number].derivative.errorStr = errorStr[1];
        writeUpStatementCtrl.writeUpStatementForm.commonData['rowForm' + number].derivative.$setValidity('wrong-match', false);
      } else if (error.data.fields && error.data.fields.length && error.data.fields[0].field == 'derivative'){
        if(error.data.fields[0].error.indexOf('Attribute for alcohol product flag can not be false') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Атрибут \"Алкогольная продукция\" выбранной позиции каталога не может иметь значение \"Нет\""}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol label can not be') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Сканировать акцизную марку\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol type must be equals product code') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Код вида продукции ФСРАР\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol percentage must be equals alc volume') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Крепость\" выбранной позиции каталога не соответствует крепости алкогольной продукции"}}});
        } else {
          errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
        }
      } else if(error.data.fields && error.data.fields.length && (error.data.fields[0].field.indexOf('amc_list') + 1) && (error.data.fields[0].field.indexOf('lines') + 1)){
        errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: error.data.fields[0].error}}});
      } else if (error.data.fields && error.data.fields.length && error.data.fields[0].error) {
        errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {data: { message: error.data.fields[0].error}}});
      } else if (error.data.message.indexOf("Not allowed to modify anyhow document in status") + 1) {
        errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {data: { message: "Нельзя изменить статус"}}});
      } else {
        errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
      }
    }

    function checkLineErrors(error) {
      // RECS-11449 проверка ошибки поиска марки в системе
      if (error.data.fields && error.data.fields[0].field.indexOf('lines.') + 1) {
        var lineNumber = error.data.fields[0].field.split('.')[1];
        if (writeUpStatementCtrl.writeUpStatementForm.commonData['rowForm' + (lineNumber - 1)]) {
          writeUpStatementCtrl.writeUpStatementForm.commonData['rowForm' + (lineNumber - 1)].quantity.$setValidity('notFoundMark', false)
          var quantityMeta = _.find(writeUpStatementCtrl.meta.layout.items[1].fields, function(item){
            return item.code == "quantity";
          });
          quantityMeta.$errorObj = error.data.fields[0];
          return;
        }
      }
      showError(error);
    }


    /**
     * Сохранение информации по акту списания
     */
    writeUpStatementCtrl.save = function(status){
      var values = angular.copy(writeUpStatementCtrl.values); // чтобы сохранить значения во вьюхе и отправить корректные данные
      values.home_amount = values.totals.home_amount;
      values.totals = undefined;
      _.forEach(values.lines, function(line){
        if (line.alcohol_catalog_item) {
          line.alcohol_catalog_item.full_name = line.alcohol_catalog_item.name;
          line.alcohol_catalog_item.name = undefined;
        }
        if (line.inform_f1_reg) {
          line.inform_f1_reg.egais_fix_number = line.inform_f1_reg.egais_fix_number || null;
          line.inform_f1_reg.bottling_date = (line.inform_f1_reg.bottling_date && !line.inform_f1_reg.bottling_date.isEmpty)? line.inform_f1_reg.bottling_date.valueOf() : null;
          line.inform_f1_reg.ttn_date = (line.inform_f1_reg.ttn_date && !line.inform_f1_reg.ttn_date.isEmpty)? line.inform_f1_reg.ttn_date.valueOf() : null;
          line.inform_f1_reg.egais_fix_date = (line.inform_f1_reg.egais_fix_date && !line.inform_f1_reg.egais_fix_date.isEmpty)? line.inform_f1_reg.egais_fix_date.valueOf() : null;
        }
        line._manual = undefined;
      });

      values.doc_date = moment(values.doc_date).valueOf();
      if (!writeUpStatementCtrl.values.id) {
        writeUpStatementService.createWriteUpStatement(values).then(function(data){
          writeUpStatementCtrl.writeUpStatementForm.$setPristine();
          $stateParams.source = undefined;
          if(status){
            writeUpStatementService.updateWriteUpStatementStatus(writeUpStatementCtrl.values.id, status).then(function(res){
              $state.go("writeUpStatement.view", {id: data.id, source: undefined, register: writeUpStatementCtrl.values.register, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              showError(error);
            });
          }else{
            $state.go("writeUpStatement.edit", {id: data.id, source: undefined, register: writeUpStatementCtrl.values.register, parent: 'alcohol'}, {reload: true});
          }
        },
        function (error) {
          checkLineErrors(error);
        });
      } else {
        writeUpStatementService.updateWriteUpStatement(values.id, values).then(function(data){
          writeUpStatementCtrl.writeUpStatementForm.$setPristine();
          if(status){
            writeUpStatementService.updateWriteUpStatementStatus(writeUpStatementCtrl.values.id, status).then(function(res){
              $state.go("writeUpStatement.view", {id: data.id, source: undefined, register: writeUpStatementCtrl.values.register, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              showError(error);
            });
          }
        },
        function (error) {
          checkLineErrors(error);
        });
      }

    }


    writeUpStatementCtrl.resetData = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.text = "Вы действительно хотите отменить выполненные изменения?";
          $scope.title = "Предупреждение";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            writeUpStatementService.getWriteUpStatement($stateParams.id || $stateParams.source).then(function(res){
              writeUpStatementCtrl.values = res.data;
              writeUpStatementCtrl.writeUpStatementForm.$pristine = true;
              writeUpStatementCtrl.writeUpStatementForm.$dirty = false;
              $uibModalInstance.dismiss();
            });
          };
        }
      });
    }

    // попап истории
    writeUpStatementCtrl.openHistoryPopup = function(){
      $uibModal.open({
        size: 'large-width',
        component: 'historyPopup',
        controllerAs: 'historyPopupCtrl',
        resolve: {
          data: function() {
            return writeUpStatementCtrl.values.status_history;
          },
          filterStatus: function(){
            return 'writeUpStatementStatus';
          }
        }
      });
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('writeReturnListCtrl', writeReturnListCtrl);

  function writeReturnListCtrl(userSettingsService,
                                  uiGridConstants,
                                  writeReturnListDefsService,
                                  filterSettingsService,
                                  API_URL,
                                  $rootScope,
                                  $filter,
                                  $state,
                                  writeReturnStatuses,
                                  divisions,
                                  companies,
                                  employees,
                                  currenciesService) {
    var writeReturnListCtrl = this;
    writeReturnListCtrl.url = API_URL + '/alcohol/documents/write_return_egais';
    writeReturnListCtrl.page = "write-return-list";
    writeReturnListCtrl.header = 'Розничные возвраты';
    writeReturnListCtrl.sort = 'doc_date';
    writeReturnListCtrl.sortOrder = "desc";
    writeReturnListCtrl.limit = 25;
    //writeReturnListCtrl.docSettings = docSettings;
    writeReturnListCtrl.columnDefs = userSettingsService.loadProperty(writeReturnListCtrl.page, 'grid', 'columnsProperty') ||
      writeReturnListDefsService.getColumnDefs.call(this, uiGridConstants);
    writeReturnListCtrl.usingService = writeReturnListDefsService;
    writeReturnListCtrl.filterMeta = {};
    writeReturnListCtrl.gridButtonConfig = [];


    /**
     * Переход на страничку просмотра возврата
     */
    writeReturnListCtrl.rowRouteFunc = function (rowData) {
      $state.go('writeReturn.view', {
        id: rowData.id,
        parent: 'alcohol'
      });
    };

    currenciesService.getDomainCurrencies().then(function (res) {
      writeReturnListCtrl.gridConfig = {
        universalAlcoDocuments: true,
        purposesFilterOn: false,
        currencies: res.data.items,
        documentType: 'invoice-waybill-list'
      };
    });

    // Get data for selects
    // статусы возвратов егаис
    if (writeReturnStatuses) {
      angular.forEach(writeReturnListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.status') {
          column.filter.selectOptions = writeReturnStatuses;
        }
      });
    }

    if (divisions) {
      this.divisionsSelect = [];
      writeReturnListCtrl.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        writeReturnListCtrl.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(writeReturnListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = writeReturnListCtrl.divisionsSelect;
        }
      });
    }

    if (companies) {
      writeReturnListCtrl.companiesSelect = [];
      writeReturnListCtrl.companiesPopup = companies;
      companies.forEach(function (item) {
        writeReturnListCtrl.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(writeReturnListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = writeReturnListCtrl.companiesSelect;
        }
      });
    }

    if (employees) {
      writeReturnListCtrl.employeeListSelect = [];
      writeReturnListCtrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        writeReturnListCtrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(writeReturnListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = writeReturnListCtrl.employeeListSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterWriteReturnList().then(function (res) {
      writeReturnListCtrl.filterMeta = res.data.items;
      writeReturnListCtrl.filterMeta[0].selectVal = writeReturnStatuses;
      writeReturnListCtrl.filterMeta[3].selectVal = writeReturnListCtrl.divisionsSelect;
      writeReturnListCtrl.filterMeta[4].selectVal = writeReturnListCtrl.companiesSelect;
      writeReturnListCtrl.filterMeta[5].selectVal = writeReturnListCtrl.employeeListSelect;
      writeReturnListCtrl.filterMeta[7].selectVal = writeReturnListCtrl.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('writeReturnListDefsService', writeReturnListDefsService);

  /** @ngInject */
  function writeReturnListDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 160, 160, 160, 100, 160, 200, 200, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('write-return-lis', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('write-return-lis', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('write-return-lis', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          displayName: 'Статус',
          visible: true,
          pinned: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | writeReturnStatus"/>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[1]
        },
        {
          __index: 2,
          name: 'dataValue.doc_number',
          enableSorting: true,
          sortName: 'doc_number',
          displayName: 'Номер',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          filterName: 'number',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.doc_date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'doc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'date',
          minWidth: 60,
          backButton: true,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[4]
        },
        { __index: 5,
          name: 'dataValue.home_amount',
          enableFiltering: false,
          displayName: 'Сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_home_amount || 0"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: false,
          width: columnsDefinedWidth[6]
        },
        { __index: 7,
          name: 'dataValue.comment',
          enableSorting: false,
          displayName: 'Комментарий',
          visible: false,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[7]
        },
        { __index: 8,
          name: 'dataValue.created_by.name',
          enableSorting: false,
          displayName:'Кто создал',
          visible: false,
          width: columnsDefinedWidth[8],
          filterName: 'created_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 9,
          name: 'dataValue.created_at',
          displayName: 'Когда создал',
          enableSorting: true,
          headerCellTemplate: headerTemplate,
          filterName: 'created_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[9]
        },
        { __index: 10,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[10],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 11,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'updated_at',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[11]
        },
        {
          __index: 12,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

'use strict';

angular.module('frontend').service('writeReturnService', function ($http, $q, API_URL) {

  /**
   * Получение акта ЕГАИС
   *
   * @param id акта
   * @return {HttpPromise}
   */
  this.getWriteReturn = function (id) {
    return $http.get(API_URL + '/alcohol/documents/write_return_egais/' + id);
  };

  /**
   * Изменение статуса акта с баланса
   *
   * @param data данные по новому акту
   * @return {HttpPromise}
   */
  this.updateWriteReturnStatus = function (id, status) {
    var params = { status: status };
    return $http.put(API_URL + '/alcohol/documents/write_return_egais/' + id + '/status', params).then(function (data) {
      return data.data;
    });
  };



});

(function () {
  'use strict';

  angular.module('frontend').controller('writeReturnCtrl', writeReturnCtrl);

  /** @ngInject */
  function writeReturnCtrl($scope,
                               $state,
                               $uibModal,
                               meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                               writeReturnAct,
                               egaiszService,
                               writeReturnService,
                               errorMessageService,
                               $window,
                               modalAskSrv,
                               crudsService) {
    var writeReturnCtrl = this;

    // состояние редактирования
    writeReturnCtrl.redact = false;

    // метаданные
    writeReturnCtrl.meta = meta;

    // данные по акту
    writeReturnCtrl.values = writeReturnAct || {};

    writeReturnCtrl.crudsService = crudsService;

    // переход к списку
    writeReturnCtrl.toGridPage = function() {
      $state.go('writeReturnList', {parent: 'alcohol'});
    };

    writeReturnCtrl.showStatusComment = function (comment) {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/info.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.titleFontSize = 28;
          $scope.title = 'Дополнительная информация';
          $scope.text = comment;
          $scope.infoIcon = true;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    // установка акту статуса
    writeReturnCtrl.setActStatus = function(status){
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Провести";
          $scope.text = "Вы действительно хотите выполнить проведение документа?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            $uibModalInstance.close();
            writeReturnService.updateWriteReturnStatus(writeReturnCtrl.values.id, status).then(function(res){
              $state.go("writeReturn.view", {id: writeReturnCtrl.values.id, parent: 'alcohol'}, {reload: true});
            });
          };
        }
      });
    }

    // попап истории
    writeReturnCtrl.openHistoryPopup = function(){
      $uibModal.open({
        size: 'large-width',
        component: 'historyPopup',
        controllerAs: 'historyPopupCtrl',
        resolve: {
          data: function() {
            return writeReturnCtrl.values.status_history;
          },
          filterStatus: function(){
            return 'writeReturnStatus';
          }
        }
      });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('transferBetweenRegisterListCtrl', transferBetweenRegisterListCtrl);

  function transferBetweenRegisterListCtrl(userSettingsService,
                                  uiGridConstants,
                                  transferBetweenRegisterListDefsService,
                                  filterSettingsService,
                                  API_URL,
                                  $rootScope,
                                  $filter,
                                  $state,
                                  cancellationActsStatuses,
                                  divisions,
                                  companies,
                                  employees,
                                  currenciesService,
                                  transferBetweenRegisterService,
                                  $window) {
    var transferBetweenRegisterListCtrl = this;
    transferBetweenRegisterListCtrl.url = API_URL + '/alcohol/documents/transfer_between_register_egais';
    transferBetweenRegisterListCtrl.page = "transfer-between-register-list";
    transferBetweenRegisterListCtrl.header = 'Переводы между регистрами';
    transferBetweenRegisterListCtrl.sort = 'updated_at';
    transferBetweenRegisterListCtrl.limit = 25;
    transferBetweenRegisterListCtrl.columnDefs = userSettingsService.loadProperty(transferBetweenRegisterListCtrl.page, 'grid', 'columnsProperty') ||
      transferBetweenRegisterListDefsService.getColumnDefs.call(this, uiGridConstants);
    transferBetweenRegisterListCtrl.usingService = transferBetweenRegisterListDefsService;
    transferBetweenRegisterListCtrl.filterMeta = {};
    transferBetweenRegisterListCtrl.gridButtonConfig = [{
      url: 'transferBetweenRegister.new',
      text: 'акт перевода',
      plusButton: true,
      permission: 'transfer_between_register_egais.write'
    }];


    /**
     * Переход на страничку просмотра/редактирования акта списания
     */
    transferBetweenRegisterListCtrl.rowRouteFunc = function (rowData) {
      if (rowData.document_status == 'DRAFT') {
        $state.go('transferBetweenRegister.edit', {
          id: rowData.id, parent: 'alcohol'
        });
      } else {
        $state.go('transferBetweenRegister.view', {
          id: rowData.id, parent: 'alcohol'
        });
      }
    };

    function copyDoc(id) {
      $window.open($state.href('transferBetweenRegister.new', { source: id, id: undefined, parent: 'alcohol' }), '_blank');
    }

    currenciesService.getDomainCurrencies().then(function (res) {
      transferBetweenRegisterListCtrl.gridConfig = {
        universalAlcoDocuments: true,
        universalDocuments: true,
        purposesFilterOn: false,
        currencies: res.data.items,
        documentType: 'transfer_between_register_egais',
        deleteRequest: transferBetweenRegisterService.deleteTransferBetweenRegister,
        copyDocCallback: copyDoc
      };
    });

    // Get data for selects
    transferBetweenRegisterListCtrl.transfer_directions = [{
        value: "REGISTER1", 
        label: "Регистр №1"
      },
      {
        value: "REGISTER2", 
        label: "Регистр №2"
      }];
    angular.forEach(transferBetweenRegisterListCtrl.columnDefs, function (column) {
      if (column.name === 'dataValue.transfer_direction') {
        column.filter.selectOptions = transferBetweenRegisterListCtrl.transfer_directions;
      }
    });

    // статусы актов списания ЕГАИС
    if (cancellationActsStatuses) {
      angular.forEach(transferBetweenRegisterListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.document_status') {
          column.filter.selectOptions = cancellationActsStatuses;
        }
      });
    }

    if (divisions) {
      this.divisionsSelect = [];
      transferBetweenRegisterListCtrl.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        transferBetweenRegisterListCtrl.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(transferBetweenRegisterListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = transferBetweenRegisterListCtrl.divisionsSelect;
        }
      });
    }

    if (companies) {
      transferBetweenRegisterListCtrl.companiesSelect = [];
      transferBetweenRegisterListCtrl.companiesPopup = companies;
      companies.forEach(function (item) {
        transferBetweenRegisterListCtrl.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(transferBetweenRegisterListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = transferBetweenRegisterListCtrl.companiesSelect;
        }
      });
    }

    if (employees) {
      transferBetweenRegisterListCtrl.employeeListSelect = [];
      transferBetweenRegisterListCtrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        transferBetweenRegisterListCtrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(transferBetweenRegisterListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = transferBetweenRegisterListCtrl.employeeListSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterTransferBetweenRegisterList().then(function (res) {
      transferBetweenRegisterListCtrl.filterMeta = res.data.items;
      transferBetweenRegisterListCtrl.filterMeta[0].selectVal = cancellationActsStatuses;
      transferBetweenRegisterListCtrl.filterMeta[3].selectVal = transferBetweenRegisterListCtrl.transfer_directions;
      transferBetweenRegisterListCtrl.filterMeta[4].selectVal = transferBetweenRegisterListCtrl.divisionsSelect;
      transferBetweenRegisterListCtrl.filterMeta[6].selectVal = transferBetweenRegisterListCtrl.companiesSelect;
      transferBetweenRegisterListCtrl.filterMeta[7].selectVal = transferBetweenRegisterListCtrl.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('transferBetweenRegisterListDefsService', transferBetweenRegisterListDefsService);

  /** @ngInject */
  function transferBetweenRegisterListDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 160, 160, 160, 100, 160, 200, 200, 200, 200, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('transfer_between_register', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('transfer_between_register', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('transfer_between_register', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.document_status',
          enableSorting: false,
          displayName: 'Статус',
          headerCellClass: 'no-wrap-header',
          cellClass: 'text-center',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | cancellationActStatus"/>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          minWidth: 60,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true
        },
        {
          __index: 2,
          name: 'dataValue.doc_number',
          enableSorting: false,
          sortName: 'doc_number',
          displayName: 'Номер',
          enableFiltering: true,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          filterName: 'number',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.doc_date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'doc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'date',
          minWidth: 60,
          backButton: true,
          enableFiltering: true,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[3]
        },
        { __index: 4,
          name: 'dataValue.reg_id',
          enableSorting: true,
          sortName: 'reg_id',
          displayName: 'Номер ЕГАИС',
          visible: true,
          filterName: 'reg_id',
          enableFiltering: true,
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.transfer_direction',
          displayName: 'Направление перевода',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD == \'REGISTER2\')? \'Регистр №2\' : ((COL_FIELD == \'REGISTER1\')? \'Регистр №1\' : \'\' )"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'transfer_direction',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          enableFiltering: true,
          visible: true,
          width: columnsDefinedWidth[5]
        },
        { __index: 6,
          name: 'dataValue.fsrar',
          enableSorting: false,
          displayName: 'Компания в ЕГАИС',
          visible: true,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD.fsrar_id + \' \' + COL_FIELD.company_name"/>',
          width: columnsDefinedWidth[6]
        },
        { __index: 7,
          name: 'dataValue.comment',
          enableSorting: false,
          displayName: 'Комментарий',
          visible: false,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[7]
        },
        { __index: 8,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[8],
          enableFiltering: true,
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 9,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'updated_at',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          enableFiltering: true,
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[9]
        },
        { __index: 10,
          name: 'dataValue.created_by.name',
          enableSorting: false,
          displayName:'Кто создал',
          enableFiltering: true,
          visible: false,
          width: columnsDefinedWidth[10],
          filterName: 'created_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 11,
          name: 'dataValue.created_at',
          displayName: 'Когда создал',
          enableSorting: false,
          headerCellTemplate: headerTemplate,
          enableFiltering: true,
          filterName: 'created_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[11]
        },
        {
          __index: 12,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

'use strict';

angular.module('frontend').service('transferBetweenRegisterService', function ($http, $q, API_URL) {


  /**
   * Метод получения информации о запросе акта переводов между регистрами
   *
   * @param id запроса
   * @return {HttpPromise}
   */
  this.getTransferBetweenRegister = function (id) {
    return $http.get(API_URL + '/alcohol/documents/transfer_between_register_egais/' + id);
  };

  /**
   * Метод создания акта переводов между регистрами
   *
   * @param data данные по запросу
   * @return {HttpPromise}
   */
  this.createTransferBetweenRegister = function (data) {
    return $http.post(API_URL + '/alcohol/documents/transfer_between_register_egais', data);
  };

  /**
   * Метод обновления информации о запросе акта переводов между регистрами
   *
   * @param id запроса
   * @param data данные по запросу
   * @return {HttpPromise}
   */
  this.updateTransferBetweenRegister = function (id, data) {
    return $http.put(API_URL + '/alcohol/documents/transfer_between_register_egais/' + id, data);
  };

  /**
   * Метод удаления акта переводов между регистрами
   *
   * @param ids запросов
   * @return {HttpPromise}
   */
  this.deleteTransferBetweenRegister = function (ids) {
    return $http.delete(API_URL + '/alcohol/documents/transfer_between_register_egais', {params: {id: ids}});
  };

  /**
   * Метод изменения статуса акта переводов между регистрами
   *
   * @param id запроса
   * @param status новый статус запроса
   * @return {HttpPromise}
   */
  this.updateTransferBetweenRegisterStatus = function (id, status) {
    return $http.put(API_URL + '/alcohol/documents/transfer_between_register_egais/' + id + '/status/' + status);
  };





});

(function () {
  'use strict';

  angular.module('frontend').controller('transferBetweenRegisterCtrl', transferBetweenRegisterCtrl);

  /** @ngInject */
  function transferBetweenRegisterCtrl($state,
                              $stateParams,
                              meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                              transferBetweenRegister,
                              egaiszService,
                              transferBetweenRegisterService,
                              errorMessageService,
                              crudsService,
                              $uibModal,
                              $window) {
    var transferBetweenRegisterCtrl = this;

    // состояние редактирования
    transferBetweenRegisterCtrl.redact = !transferBetweenRegister || transferBetweenRegister.document_status == 'DRAFT' || $stateParams.source;

    // метаданные ТТН
    transferBetweenRegisterCtrl.meta = meta;

    transferBetweenRegisterCtrl.crudsService = crudsService;

    // данные по акту
    transferBetweenRegisterCtrl.values = transferBetweenRegister || {};
    if ($stateParams.source) {
      transferBetweenRegisterCtrl.values.id = undefined;
      transferBetweenRegisterCtrl.values.document_status = undefined;
      transferBetweenRegisterCtrl.values.doc_number = undefined;
      transferBetweenRegisterCtrl.values.status_history = undefined;
      _.forEach(transferBetweenRegisterCtrl.values.lines, function(line){
        line.quantity = undefined;
      });
    }
    if ($state.current.name.endsWith('new')) {
      transferBetweenRegisterCtrl.values.doc_date = moment();
    }
    // преобразование справки2
    _.forEach(transferBetweenRegisterCtrl.values.lines, function(line){
      line.alcohol_stock_item.f2reg_id = line.alcohol_stock_item.name;
    });

    // переход к списку
    transferBetweenRegisterCtrl.toGridPage = function() {
      $state.go('transferBetweenRegisterList', {parent: 'alcohol'});
    };

    transferBetweenRegisterCtrl.showStatusComment = function (comment) {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/info.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.titleFontSize = 28;
          $scope.title = 'Дополнительная информация';
          $scope.text = comment;
          $scope.infoIcon = true;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    // удаление акта
    transferBetweenRegisterCtrl.delete = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'текущий документ';
          $scope.conflictDeleteText = "Невозможно удалить текущий документ.<br>Для удаления необходимо удалить все связанные документы.";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.delete = function() {
            $scope.lock = true;
            transferBetweenRegisterService.deleteTransferBetweenRegister([transferBetweenRegisterCtrl.values.id]).then(function(res){
              $uibModalInstance.dismiss();
              transferBetweenRegisterCtrl.transferBetweenRegisterForm.$setPristine();
              transferBetweenRegisterCtrl.transferBetweenRegisterForm.$setUntouched();
              transferBetweenRegisterCtrl.toGridPage();
              $scope.lock = false;
            }, function (error) {
              if(error.status == 409){
                $scope.canDelete = false;
                $scope.lock = false;
                return;
              }
              $uibModalInstance.dismiss();
              errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: error});
              $scope.lock = false;
            });
          };
        }
      });
      return modal.result;
    };

    function copyDocument() {
      $window.open($state.href('transferBetweenRegister.new', { source: transferBetweenRegisterCtrl.values.id, id: undefined, parent: 'alcohol' }), '_blank');
    }

    // копировать акт
    transferBetweenRegisterCtrl.copyHandler = function(status){
      if (transferBetweenRegisterCtrl.transferBetweenRegisterForm.$pristine) {
        copyDocument();
      } else {
        modalAskSrv.showModal({
          title: 'Есть несохраненные изменения. Новый документ будет создан только по сохраненным данным.'
        }).then(copyDocument);
      }
    };

    // установка акту статуса
    transferBetweenRegisterCtrl.setActStatus = function(status, withoutSave){
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Провести";
          $scope.text = "Вы действительно хотите выполнить проведение документа?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            $uibModalInstance.close();
            if (withoutSave) {
              transferBetweenRegisterService.updateTransferBetweenRegisterStatus(transferBetweenRegisterCtrl.values.id, status).then(function(res){
                $state.go("transferBetweenRegister.edit", {id: transferBetweenRegisterCtrl.values.id, source: undefined, parent: 'alcohol'}, {reload: true});
              }, function (error) {
                showError(error);
              });
            } else {
              transferBetweenRegisterCtrl.save(status);
            }
          };
        }
      });
    };

    function showError (error) {
      if (error.data.fields && error.data.fields[0] && error.data.fields[0].field == 'derivative'){
        if(error.data.fields[0].error.indexOf('Attribute for alcohol product flag can not be false') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Атрибут \"Алкогольная продукция\" выбранной позиции каталога не может иметь значение \"Нет\""}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol label can not be') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Сканировать акцизную марку\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol type must be equals product code') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Код вида продукции ФСРАР\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol percentage must be equals alc volume') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Крепость\" выбранной позиции каталога не соответствует крепости алкогольной продукции"}}});
        } else {
          errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
        }
      }else{
        errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
      }
    }


    /**
     * Сохранение информации по переводу
     */
    transferBetweenRegisterCtrl.save = function(status){
      var values = angular.copy(transferBetweenRegisterCtrl.values); // чтобы сохранить значения во вьюхе и отправить корректные данные
      _.forEach(values.lines, function(line){
        if(line.alcohol_stock_item){
          line.alcohol_stock_item = {
            id: line.alcohol_stock_item.id,
            name: line.alcohol_stock_item.f2reg_id
          }
        }
        line._manual = undefined;
      });

      values.doc_date = moment(values.doc_date).valueOf();
      if(!transferBetweenRegisterCtrl.values.id){
        transferBetweenRegisterService.createTransferBetweenRegister(values).then(function(data){
          transferBetweenRegisterCtrl.transferBetweenRegisterForm.$setPristine();
          if(status){
            transferBetweenRegisterService.updateTransferBetweenRegisterStatus(data.data.id, status).then(function(res){
              $state.go("transferBetweenRegister.edit", {id: data.data.id, source: undefined, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              showError(error);
            });
          }else{
            $state.go("transferBetweenRegister.edit", {id: data.data.id, source: undefined, parent: 'alcohol'}, {reload: true});
          }
        },
        function (error) {
          showError(error);
        });
      }else{
        transferBetweenRegisterService.updateTransferBetweenRegister(values.id, values).then(function(data){
          transferBetweenRegisterCtrl.transferBetweenRegisterForm.$setPristine();
          if(status){
            transferBetweenRegisterService.updateTransferBetweenRegisterStatus(data.data.id, status).then(function(res){
              $state.go("transferBetweenRegister.edit", {id: data.data.id, source: undefined, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              showError(error);
            });
          }else{
            $state.go("transferBetweenRegister.edit", {id: data.data.id, source: undefined, parent: 'alcohol'}, {reload: true});
          }
        },
        function (error) {
          showError(error);
        });
      }
    };

    transferBetweenRegisterCtrl.resetData = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.text = "Вы действительно хотите отменить выполненные изменения?";
          $scope.title = "Предупреждение";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            transferBetweenRegisterService.getTransferBetweenRegister($stateParams.id || $stateParams.source).then(function(res){
              $state.go("transferBetweenRegister.edit", {id: $stateParams.id || $stateParams.source, source: undefined, parent: 'alcohol'}, {reload: true});
              $uibModalInstance.dismiss();
            });
          };
        }
      });
    };


    // попап истории
    transferBetweenRegisterCtrl.openHistoryPopup = function(){
      $uibModal.open({
        size: 'large-width',
        component: 'historyPopup',
        controllerAs: 'historyPopupCtrl',
        resolve: {
          data: function() {
            return transferBetweenRegisterCtrl.values.status_history;
          },
          filterStatus: function(){
            return 'cancellationActStatus';
          }
        }
      });
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('balanceEgaisCtrl', balanceEgaisCtrl);

  function balanceEgaisCtrl($rootScope,
                            stockBalanceEgaisListDefsService,
                            fsrarCompanies,
                            $filter,
                            $uibModal,
                            productClassifier,
                            egaiszService,
                            errorMessageService,
                            catalogService) {
    var balanceEgaisCtrl = this;
    balanceEgaisCtrl.filterData = {
      filter_fsrar_id: (fsrarCompanies && fsrarCompanies[0])? fsrarCompanies[0].id : undefined,
    };
    balanceEgaisCtrl.paging = {
      current: 0,
      limit: 25,
      offset: 0,
      limits: [25, 50, 100]
    };
    balanceEgaisCtrl.columns = stockBalanceEgaisListDefsService.getColumns();
    balanceEgaisCtrl.config = stockBalanceEgaisListDefsService.getFilterConfig();
    balanceEgaisCtrl.config.filterFields[1].items = fsrarCompanies;
    balanceEgaisCtrl.config.filterFields[2].items = productClassifier;

    balanceEgaisCtrl.config.filterFields[0].refresh = function (search_string, limit) {
      return catalogService.catalogItemsAuto(search_string, false, true, limit, true);
    };
    
    balanceEgaisCtrl.getStatus = function () {
      egaiszService.getBalanceStatus(balanceEgaisCtrl.filterData.filter_fsrar_id).then(function (data) {
        balanceEgaisCtrl.statusData = data.data;
        balanceEgaisCtrl.generateHint();
      }, function (error) {
        errorMessageService.showModal({message: 'При запросе данных произошла ошибка', submessage: error});
      });
    }
    if (balanceEgaisCtrl.filterData.filter_fsrar_id) {
      balanceEgaisCtrl.getStatus();
    }
    // обновление данных при смене компании в фильтре
    balanceEgaisCtrl.config.filterFields[1].onSelect = balanceEgaisCtrl.getStatus;

    /**
     * Метод получения данных грида
     */
    balanceEgaisCtrl.getData = function (filters) {
      balanceEgaisCtrl.dataIsLoaded = false;
      if (!balanceEgaisCtrl.filterData.filter_fsrar_id) {
        balanceEgaisCtrl.dataIsLoaded = true;
        return;
      }
      balanceEgaisCtrl.filterData.offset = balanceEgaisCtrl.paging.offset;
      balanceEgaisCtrl.filterData.limit = balanceEgaisCtrl.paging.limit;
      for (var prop in filters) {
        if (balanceEgaisCtrl.filterData[prop]) {
          balanceEgaisCtrl.filterData[prop] = balanceEgaisCtrl.filterData[prop];
        }
      }
      egaiszService.getAlcoholStock(balanceEgaisCtrl.filterData).then(function (res) {
        balanceEgaisCtrl.data = res.data.items;
        // формирование подсказки для складской позиции (TODO: думаю логичнее такие вещи делать прямо в сервисе)
        _.map(balanceEgaisCtrl.data, function (line) {
          line.$$alcoNames = _.reduce(line.alco_items, function (acc, item) {
            return item.alcohol_catalog ? acc + (acc ? ', ' : '') + item.alcohol_catalog.full_name: acc;
          }, '')
        });
        balanceEgaisCtrl.paging.total = res.data.total;
        balanceEgaisCtrl.dataIsLoaded = true;
      });
    };
    balanceEgaisCtrl.getData();

    /**
     * Получение данных грида со сбросом смещения пейджинга
     */
    balanceEgaisCtrl.getDataWithResetOffset = function (filters) {
      balanceEgaisCtrl.paging.offset = 0;
      balanceEgaisCtrl.paging.current = 0;
      balanceEgaisCtrl.paging.inputPage = 1;
      return balanceEgaisCtrl.getData(filters);
    };


    balanceEgaisCtrl.updateStock = function () {
      if (!$rootScope.hasRole('alcohol_stock.write') || balanceEgaisCtrl.statusData.when_new_request) return
      egaiszService.getBalance(balanceEgaisCtrl.filterData.filter_fsrar_id).then(function (data) {
        balanceEgaisCtrl.statusData = data.data;
        balanceEgaisCtrl.generateHint();
        balanceEgaisCtrl.getData();
      }, function (error) {
        errorMessageService.showModal({message: 'При запросе данных произошла ошибка', submessage: error});
      });
    }

    balanceEgaisCtrl.generateHint = function () {
      balanceEgaisCtrl.hint = '';
      if (!balanceEgaisCtrl.statusData) return;
      balanceEgaisCtrl.hint = "Статус последнего запроса: ";
      switch (balanceEgaisCtrl.statusData.request_status) {
        case 'SEND_TO_EGAIS':
          balanceEgaisCtrl.hint += "Отправлен в ЕГАИС. ";
          break;
        case 'BALANCE_RECEIVED':
          balanceEgaisCtrl.hint += "Данные получены.";
          break;
        case 'REJECTED':
          balanceEgaisCtrl.hint += "Ошибка.";
          break;
        case 'IN_PROGRESS':
          balanceEgaisCtrl.hint = "Обработка.";
          break;
        default :
          balanceEgaisCtrl.hint = "Не найдены выполненные запросы остатков.";
          break;
      }
      if (balanceEgaisCtrl.statusData.description) {
        balanceEgaisCtrl.hint += balanceEgaisCtrl.statusData.description + ". ";
      }
      if (balanceEgaisCtrl.statusData.when_new_request) {
        balanceEgaisCtrl.hint += "Следующий запрос можно выполнить после: " + $filter('date')(balanceEgaisCtrl.statusData.when_new_request, 'HH:mm dd.MM.yyyy');
      }
    }

    balanceEgaisCtrl.rowSelectionHandler = function (data) {
      if (data && data.alco_items.length) {
        $uibModal.open({
          size: 'large-width',
          component: 'alcoStockInfo',
          controllerAs: 'alcoStockInfo',
          resolve: {
            data: function(){
              return data;
            },
            fsrarId: function () {
              return balanceEgaisCtrl.filterData.filter_fsrar_id
            }
          }
        });
      }
    }



  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('stockBalanceEgaisListDefsService', stockBalanceEgaisListDefsService);

  /** @ngInject */
  function stockBalanceEgaisListDefsService() {

    this.getColumns = function () {
      return [
        {
          name: "Складская позиция",
          field: "sku_derivative",
          flex: 7,
          templateUrl: "catalogItemTemplate.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Емкость",
          field: "alco_items",
          flex: 1,
          templateUrl: "capacityTemplate.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Крепость",
          field: "alco_items",
          flex: 1,
          templateUrl: "alcVolumeTemplate.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Вид продукции",
          field: "alco_items",
          flex: 1,
          templateUrl: "alcoCodeTemplate.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Склад ТО",
          field: "recs_quantity",
          templateUrl: "defaultTemplate.html",
          flex: 1,
          visible: true,
          column_visible: true
        },
        {
          name: "Р1",
          parent: "Копия базы ЕГАИС",
          field: "total_alcohol_stock_r1_quantity",
          templateUrl: "defaultTemplate.html",
          flex: 1,
          visible: true,
          column_visible: true
        },
        {
          name: "Р2",
          parent: "Копия базы ЕГАИС",
          field: "total_alcohol_stock_r2_quantity",
          templateUrl: "defaultTemplate.html",
          flex: 1,
          visible: true,
          column_visible: true
        },
        {
          name: "Р1",
          parent: "ЕГАИС",
          field: "total_egais_stock_r1_quantity",
          templateUrl: "defaultTemplate.html",
          flex: 1,
          visible: true,
          column_visible: true
        },
        {
          name: "Р2",
          parent: "ЕГАИС",
          field: "total_egais_stock_r2_quantity",
          templateUrl: "defaultTemplate.html",
          flex: 1,
          visible: true,
          column_visible: true
        },
        {
          name: "Ед.изм.",
          field: "alco_items",
          flex: 1,
          templateUrl: "uomTemplate.html",
          visible: true,
          column_visible: true
        }
      ];
    };

    this.getFilterConfig = function () {
      return {
        enableSorting:false,
        preventRequest: false,
        withoutStaticFilters: true, // отменяет обязательность статических фильтров (компания, каегория, подразделние)
        hideSearch: true,
        selectValues: {},
        filterFields: [
          {
            code: 'filter_domain_catalog_item_ids',
            selectMatchPattern: '{{ item.name}}',
            selectChoicesPattern: '{{ item.name }}',
            type: 'custom_multiselect',
            name: 'Складская позиция',
            items: [],
            limit: 20,
            selectedPattern: "derivative.id",
            sortBy: "name"
          },
          {
            code: 'filter_fsrar_id',
            selectMatchPattern: '{{ $select.selected.fsrar_id + " " + $select.selected.company_name}}',
            selectChoicesPattern: '{{ item.fsrar_id + " " + item.company_name }}',
            type: 'select',
            required: true,
            name: 'Компания в ЕГАИС',
            items: []
          },
          {
            code: 'filter_product_classifier_ids',
            type: 'multiselect',
            name: 'Код вида продукции',
            options: {
              keyboardControls: true,
              displayProp: 'name',
              smartButtonMaxItems: 2,
              enableSearch: true,
              template: '<div class="ellipsis" title="{{option.name}}">{{option.code + " " + option.name}}</div>',
              smartButtonTextConverter: function(itemText, originalItem) {
                return itemText;
              }
            },
            translationTexts: {
              checkAll: 'Выбрать все',
              uncheckAll: 'Очистить',
              buttonDefaultText: '',
              searchPlaceholder: 'Поиск'
            },
            items: []
          },
          {
            code: 'filter_balance',
            type: 'checkbox',
            name: 'Показать только расхождения'
          }
        ]
      };
    };

    this.getColumnsAlcoItems = function () {
      return [
        {
          name: "№",
          field: "",
          flex: 0.5,
          templateUrl: "numTemplateAlcoStockInfo.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Связанная алкогольная продукция",
          field: "alcohol_catalog",
          flex: 4,
          templateUrl: "catalogItemTemplateAlcoStock.html",
          totalTemplateUrl: "totalTitleTemplate.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Регистр №1",
          parent: "Копия базы ЕГАИС",
          field: "alcohol_stock_r1_quantity",
          templateUrl: "defaultTemplate.html",
          totalTemplateUrl: "totalTemplate.html",
          flex: 1.1,
          visible: true,
          column_visible: true
        },
        {
          name: "Регистр №2",
          parent: "Копия базы ЕГАИС",
          field: "alcohol_stock_r2_quantity",
          templateUrl: "defaultTemplate.html",
          totalTemplateUrl: "totalTemplate.html",
          flex: 1.1,
          visible: true,
          column_visible: true
        },
        {
          name: "Регистр №1",
          parent: "ЕГАИС",
          field: "egais_stock_r1_quantity",
          templateUrl: "defaultTemplate.html",
          totalTemplateUrl: "totalTemplate.html",
          flex: 1.1,
          visible: true,
          column_visible: true
        },
        {
          name: "Регистр №2",
          parent: "ЕГАИС",
          field: "egais_stock_r2_quantity",
          templateUrl: "defaultTemplate.html",
          totalTemplateUrl: "totalTemplate.html",
          flex: 1.1,
          visible: true,
          column_visible: true
        }
      ];
    };

    this.getColumnsFn2 = function () {
      return [
        {
          name: "№",
          field: "",
          flex: 0.5,
          templateUrl: "numTemplateFn2.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Документ поставки",
          field: "document",
          flex: 4,
          templateUrl: "documentTemplate.html",
          visible: true,
          column_visible: true
        },
        {
          name: "Справка 2",
          field: "f2reg_id",
          templateUrl: "fn2Template.html",
          flex: 1.5,
          visible: true,
          column_visible: true
        },
        {
          name: "Копия базы ЕГАИС",
          field: "alcohol_stock_r1_quantity",
          templateUrl: "defaultTemplate.html",
          flex: 2,
          visible: true,
          column_visible: true
        },
        {
          name: "ЕГАИС",
          field: "egais_stock_r1_quantity",
          templateUrl: "defaultTemplate.html",
          flex: 1.5,
          visible: true,
          column_visible: true
        }
      ];
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('scanMarks', {
      bindings: {
        modalInstance: '<',
        resolve: '<'
      },
      templateUrl: 'app/egaisz/scan-marks/scan-marks.html',
      controllerAs: 'scanMarkCtrl',
      controller: function ($scope,
                            egaiszService, // сервис для работы с АПИ ЕГАИС
                            $timeout,
                            $q,
                            userSettingsService) {
        var scanMarkCtrl = this;
        scanMarkCtrl.load = false;
        // структура для обмена промисами с дочерними компонентами
        scanMarkCtrl.promisses = {};

        // буфер автоматического сканирования (аккумулятор вводимых символов)
        scanMarkCtrl.scanBuffer = '';

        // по-умолчанию автоматический ввод сканером
        scanMarkCtrl.manual = false;

        // состояние ожидания ввода марки
        scanMarkCtrl.state = 'WAITING';

        scanMarkCtrl.barcodeTypes = scanMarkCtrl.resolve.marksTypes;
        scanMarkCtrl.barcodeType = scanMarkCtrl.barcodeTypes[0];

        // приведение к стандартизованной структуре
        function getMarksStructure(scan_mark_history) {
          return _.map(scan_mark_history.reverse(), function (item) {
            if (item.box_num && typeof item.box_num === 'object') {
              return item.box_num;
            }
            if (item.amc && typeof item.amc === 'object') {
              return item.amc;
            }
            return item;
          });
        }

        scanMarkCtrl.root = {
          children_box_num: getMarksStructure(scanMarkCtrl.resolve.marks.scan_mark_history)
        };
        scanMarkCtrl.marksQuantity = scanMarkCtrl.resolve.marks.quantity;
        scanMarkCtrl.acceptedMarksQuantity = scanMarkCtrl.resolve.marks.accepted_quantity;

        /**
         * Обработка данных марки (полученном при чтении)
         */
        function _processMark(data, calculatedBarcode) {
          scanMarkCtrl.promisses.promisePostScan = null;
          scanMarkCtrl.onlyView = false;
          if (data.amc) {
            // случай сканирования одиночной марки
            scanMarkCtrl.state = 'SINGLE_MARK';
            scanMarkCtrl.currentMarkData = data.amc;

            // немедленно резолвится промис для отдельной марки
            scanMarkCtrl.promisses.promisePostScan = $q.when();
          } else {
            scanMarkCtrl.promisses.deferred = $q.defer();

            if (!userSettingsService.loadProperty('invoiceWaybillCtrl', 'scanGroup', 'scanAll')) {
              scanMarkCtrl.promisses.promisePostScan = scanMarkCtrl.promisses.deferred.promise;
            } else {
              // немедленно резолвится промис для груповойй упаковки если поставлен флаг "сканировать сразу"
              scanMarkCtrl.promisses.promisePostScan = $q.when();
            }

            // случай сканирования групповой упаковки
            scanMarkCtrl.state = 'GROUP_MARK';
            scanMarkCtrl.currentMarkData = data.box_num;

          }
          // В зависимости от ситуации резолвится по созданному на одном из предыдущих шагов промиссу
          return scanMarkCtrl.promisses.promisePostScan.then(function () {
            egaiszService.scanMark(
              scanMarkCtrl.resolve.waybill.id,
              calculatedBarcode, // отсканированный штрихкод
              'ACCEPTED'
            ).then(function (data) {
              if (angular.isArray(data) && data.length) {
                data = data[0];
              }
              scanMarkCtrl.currentMarkData = (data.amc) ? data.amc : data.box_num;
              egaiszService.getScannedMarks(scanMarkCtrl.resolve.waybill.id).then(function (data) {
                scanMarkCtrl.root = {
                  children_box_num: getMarksStructure(data.scan_mark_history)
                };
                scanMarkCtrl.marksQuantity = data.quantity;
                scanMarkCtrl.acceptedMarksQuantity = data.accepted_quantity;
              });
            }, function (data) {
              scanMarkCtrl.message = undefined;
              if (data.status == 400) {
                scanMarkCtrl.message = (data.data && data.data.message) ? data.data.message : 'Ошибка при сканировании марки';
                scanMarkCtrl.state = (scanMarkCtrl.message.indexOf("Марка с кодом") + 1) ? 'ERROR_BUSINESS_MARK' : 'ERROR_BUSINESS_BOX';
                return;
              }
              scanMarkCtrl.state = 'ERROR_NO_NFO';
            });
          });
        }

        /**
         * Метод принимает вводимую информацию от сканера.
         * моментом аппрува введенных данных является либо превышение
         * таймаута с последнего события, либо энтер.
         *
         * @param keyEvent событие клвавиатуры
         */
        scanMarkCtrl.applyScannerKeys = function(keyEvent) {
          
          if (scanMarkCtrl.saving) {
            // в процессе сохраниения новый ввод блокируется
            return;
          }
          // оставнока таймера, т.к. ввод продолжен
          $timeout.cancel(scanMarkCtrl.scanTimer);
          if (keyEvent.keyCode == 13) {
            scanMarkCtrl.submitBarcode(scanMarkCtrl.scanBuffer).finally(function (res) {
              scanMarkCtrl.scanBuffer = '';
            });
            scanMarkCtrl.scanBuffer = '';
          } else {

            var charFromEvent = undefined;
            if (keyEvent.originalEvent.code.startsWith('Digit')) {
              var charFromEvent = keyEvent.key;
            }
            if (keyEvent.originalEvent.code.startsWith('Key')) {
              charFromEvent = keyEvent.shiftKey ? keyEvent.originalEvent.code.charAt(3) : keyEvent.originalEvent.code.charAt(3).toLowerCase();
            }

            if (!/[a-zA-Z0-9]{1}/.test(charFromEvent)) {
              // допустимы только числа и буквенные символы
              scanMarkCtrl.scanBuffer = ''; // сброс аккумулятора из-за ошибки
              return;
            }

            if (charFromEvent !== undefined) {
              scanMarkCtrl.scanBuffer += ("" + charFromEvent);
            }

            // новый таймер
            scanMarkCtrl.scanTimer = $timeout(function () {
              scanMarkCtrl.submitBarcode(scanMarkCtrl.scanBuffer).finally(function () {
                scanMarkCtrl.scanBuffer = '';
              });
            }, 200); // пока больше чем нужно, чтобы можно было тестить нормально
          }
        };

        /**
         * Отправка полученного кода на бекенд
         */
        scanMarkCtrl.submitBarcode = function (code, type) {
          var result = $q.defer();
          // в обертке с таймаутом из-за необходимости дождаться проброса нового занчения в модель при сканировании
          $timeout(function () {
            var calculatedBarcode = ("" + code) || '';
            if (!code) {
              if (type == 'MARK') {
                // логика вычисления полной строки марки
                calculatedBarcode = scanMarkCtrl.barcodeSingleMark;
              }
              if (type == 'BOX') {
                calculatedBarcode = scanMarkCtrl.barcodeBox;
              }
              // выделение текста в инпуте
              $scope.$broadcast('selectInput');
            }

            if (!calculatedBarcode || calculatedBarcode.length < 8) {
              // если полученное значение не значащее
              result.reject('Empty or small calculated code: ' + calculatedBarcode)
              return result.promise;
            }
            scanMarkCtrl.saving = true;
            egaiszService.getMarkInfo(
              scanMarkCtrl.resolve.waybill.id,
              calculatedBarcode
            ).then(function (data) {
              scanMarkCtrl.saving = false; // обработка марки может быть отдельным процессом требующим участия пользователя
              _processMark(data, calculatedBarcode).finally(function () {
                calculatedBarcode = undefined;
                result.resolve('Apply mark was introduced'); // речь не о гарантиях принятия
                return result.promise;
              });
            }, function (data) {
              scanMarkCtrl.saving = false;
              scanMarkCtrl.message = undefined;
              calculatedBarcode = undefined;
              if (data.status == 404) {
                scanMarkCtrl.state = 'ERROR_NO_NFO';
                result.reject('Error 404');
                return result.promise;
              }
              scanMarkCtrl.state = 'ERROR_NO_NFO';
              result.reject('Error');
              return result.promise;
            });
          });
          // возврат промиса
          return result.promise;
        };

        /**
         * Установка выбранных данных марки во view
         */
        scanMarkCtrl.showMarkInfo = function(markInfo) {
          scanMarkCtrl.currentMarkData = markInfo;
          scanMarkCtrl.onlyView = true;
          if (markInfo.amc) {
            // случай одиночной марки
            scanMarkCtrl.state = 'SINGLE_MARK';
          } else {
            // случай коробки
            scanMarkCtrl.state = 'GROUP_MARK';
          }
        };

        /**
         * Закрытие модального окна
         */
        scanMarkCtrl.close = function () {
          scanMarkCtrl.modalInstance.close();
        };

        /**
         * Отменить принятие марки
         */
        scanMarkCtrl.removeRow = function (mark) {
          var code;
          if (mark.amc) {
            code = (mark.amc.amc) ? mark.amc.amc : mark.amc;
          } else {
            code = (mark.box_num.box_num) ? mark.box_num.box_num : mark.box_num;
          }
          egaiszService.scanMark(scanMarkCtrl.resolve.waybill.id, code, 'REJECTED', 'REJECTED').then(function (res) {
            egaiszService.getScannedMarks(scanMarkCtrl.resolve.waybill.id).then(function (data) {
              scanMarkCtrl.root = {
                children_box_num: getMarksStructure(data.scan_mark_history)
              };
              scanMarkCtrl.marksQuantity = data.quantity;
              scanMarkCtrl.acceptedMarksQuantity = data.accepted_quantity;
              // сброс данных по выбранной марке
              scanMarkCtrl.state = 'WAITING';
              scanMarkCtrl.currentMarkData = undefined;
            });
          });
        }

        // настройка скролла
        scanMarkCtrl.configScroll = {
          axis: 'yх',
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          setHeight: 442,
          scrollInertia: 0,
          scrollButtons: {
            enable: false // enable scrolling buttons by default
          }
        }

      }
    });
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('invoiceWaybillListCtrl', invoiceWaybillListCtrl);

  function invoiceWaybillListCtrl(userSettingsService,
                                  uiGridConstants,
                                  invoiceWaybillListDefsService,
                                  filterSettingsService,
                                  API_URL,
                                  $rootScope,
                                  $filter,
                                  $state,
                                  invoiceWaybillStatuses,
                                  divisions,
                                  companies,
                                  counterparties,
                                  employees,
                                  currenciesService) {
    var invoiceWaybillListCtrl = this;
    invoiceWaybillListCtrl.url = API_URL + '/alcohol/documents/consignment_notes_in_egais';
    invoiceWaybillListCtrl.page = "invoice-waybill-list";
    invoiceWaybillListCtrl.header = 'Приемки ТТН';
    invoiceWaybillListCtrl.sort = 'doc_date';
    invoiceWaybillListCtrl.limit = 25;
    //invoiceWaybillListCtrl.docSettings = docSettings;
    invoiceWaybillListCtrl.columnDefs = userSettingsService.loadProperty(invoiceWaybillListCtrl.page, 'grid', 'columnsProperty') ||
      invoiceWaybillListDefsService.getColumnDefs.call(this, uiGridConstants);
    invoiceWaybillListCtrl.usingService = invoiceWaybillListDefsService;
    invoiceWaybillListCtrl.filterMeta = {};
    invoiceWaybillListCtrl.gridButtonConfig = [];


    /**
     * Переход на тсраничку просмотра/редактирования ттн
     * если у ттн статус NEED_TO_DECIDE (Новая), то редактирование,
     * в остальных случаях просмотр
     */
    invoiceWaybillListCtrl.rowRouteFunc = function (rowData) {
      if (rowData.document_status == 'NEED_TO_DECIDE') {
        $state.go('invoiceWaybill.edit', {
          id: rowData.id, 
          parent: 'alcohol'
        });
      } else {
        $state.go('invoiceWaybill.view', {
          id: rowData.id, 
          parent: 'alcohol'
        });
      }
    };

    currenciesService.getDomainCurrencies().then(function (res) {
      invoiceWaybillListCtrl.gridConfig = {
        universalAlcoDocuments: true,
        purposesFilterOn: false,
        currencies: res.data.items,
        documentType: 'invoice-waybill-list'
      };
    });


    invoiceWaybillListCtrl.isAccept = [
      {
        value: "ACCEPTED",
        label: "Принята"
      },
      {
        value: "REJECTED",
        label: "Отклонена"
      },
      {
        value: "DIFFERENCES",
        label: "Принята с разногласиями"
      }
    ];

    // Get data for selects
    // статусы товарно-транспортных накладных
    if (invoiceWaybillStatuses) {
      angular.forEach(invoiceWaybillListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.document_status') {
          column.filter.selectOptions = invoiceWaybillStatuses;
        }
        if (column.name === 'dataValue.way_bill_act.accept') {
          column.filter.selectOptions = invoiceWaybillListCtrl.isAccept;
        }
      });
    }

    if (divisions) {
      this.divisionsSelect = [];
      invoiceWaybillListCtrl.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        invoiceWaybillListCtrl.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(invoiceWaybillListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = invoiceWaybillListCtrl.divisionsSelect;
        }
      });
    }

    if (companies) {
      invoiceWaybillListCtrl.companiesSelect = [];
      invoiceWaybillListCtrl.companiesPopup = companies;
      companies.forEach(function (item) {
        invoiceWaybillListCtrl.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(invoiceWaybillListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = invoiceWaybillListCtrl.companiesSelect;
        }
      });
    }

    if (employees) {
      invoiceWaybillListCtrl.employeeListSelect = [];
      invoiceWaybillListCtrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        invoiceWaybillListCtrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(invoiceWaybillListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = invoiceWaybillListCtrl.employeeListSelect;
        }
      });
    }

    if (counterparties) {
      invoiceWaybillListCtrl.counterpartiesListSelect = [];
      invoiceWaybillListCtrl.counterpartiesListPopup = counterparties;
      counterparties.forEach(function (item) {
        invoiceWaybillListCtrl.counterpartiesListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(invoiceWaybillListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.counterparty.name') {
          column.filter.selectOptions = invoiceWaybillListCtrl.counterpartiesListSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterInvoiceWaybillList().then(function (res) {
      invoiceWaybillListCtrl.filterMeta = res.data.items;
      invoiceWaybillListCtrl.filterMeta[1].selectVal = invoiceWaybillStatuses;
      invoiceWaybillListCtrl.filterMeta[4].selectVal = invoiceWaybillListCtrl.divisionsSelect;
      invoiceWaybillListCtrl.filterMeta[5].selectVal = invoiceWaybillListCtrl.counterpartiesListSelect;
      invoiceWaybillListCtrl.filterMeta[8].selectVal = invoiceWaybillListCtrl.companiesSelect;
      invoiceWaybillListCtrl.filterMeta[10].selectVal = invoiceWaybillListCtrl.isAccept;
      invoiceWaybillListCtrl.filterMeta[11].selectVal = invoiceWaybillListCtrl.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('invoiceWaybillListDefsService', invoiceWaybillListDefsService);

  /** @ngInject */
  function invoiceWaybillListDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 160, 160, 160, 100, 160, 200, 200, 200, 200, 200, 200, 160, 200, 200, 200, 200, 160, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('invoice-waybill-list', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('invoice-waybill-list', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('invoice-waybill-list', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.created_at',
          displayName: 'Дата поступления документа',
          enableSorting: true,
          sortName: 'created_at',
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          pinned: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' :\'UTC\'',
          filterName: 'created_at',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[1],
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>'
        },
        {
          __index: 2,
          name: 'dataValue.document_status',
          displayName: 'Статус',
          visible: true,
          pinned: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | waybillStatus"/>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[2]
        },
        {
          __index: 3,
          name: 'dataValue.doc_number',
          enableSorting: true,
          sortName: 'doc_number',
          displayName: 'Номер',
          enableFiltering: true,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          backButton: true,
          filterName: 'number',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[3],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 4,
          name: 'dataValue.doc_date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'doc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'date',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[5]
        },
        { __index: 6,
          name: 'dataValue.counterparty.name',
          enableSorting: false,
          displayName:'Контрагент',
          visible: true,
          width: columnsDefinedWidth[6],
          filterName: 'counterparty_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        { __index: 7,
          name: 'dataValue.home_amount',
          enableFiltering: false,
          displayName: 'Сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_home_amount || 0"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[7]
        },
        { __index: 8,
          name: 'dataValue.reg_id',
          enableSorting: true,
          sortName: 'reg_id',
          displayName: 'Номер ЕГАИС',
          visible: true,
          filterName: 'reg_id',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[8]
        },
        { __index: 9,
          name: 'dataValue.client_identity',
          displayName: 'ИД в системе контрагента',
          visible: false,
          filterName: 'client_identity',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[9]
        },
        {
          __index: 10,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: false,
          width: columnsDefinedWidth[10]
        },
        { __index: 11,
          name: 'dataValue.contract.name',
          enableSorting: false,
          displayName: 'Договор',
          visible: false,
          enableFiltering: false,
          width: columnsDefinedWidth[11]
        },
        {
          __index: 12,
          name: 'dataValue.shipping_date',
          displayName: 'Дата поставки',
          enableSorting: true,
          sortName: 'shipping_date',
          headerCellTemplate: headerTemplate,
          filterName: 'shipping_date',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="shipping_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[12]
        },
        {
          __index: 13,
          name: 'dataValue.way_bill_act.act_number',
          enableSorting: false,
          displayName: 'Номер акта',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[13],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          visible: false
        },
        {
          __index: 14,
          name: 'dataValue.way_bill_act.act_date',
          displayName: 'Дата акта',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          visible: false,
          width: columnsDefinedWidth[14]
        },
        { __index: 15,
          name: 'dataValue.way_bill_act.accept',
          displayName: 'Решение',
          enableFiltering: true,
          filterName: 'accept',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | acceptStatuses"/>',
          width: columnsDefinedWidth[15]
        },
        { __index: 16,
          name: 'dataValue.comment',
          enableSorting: false,
          displayName: 'Комментарий',
          visible: false,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[16]
        },
        { __index: 17,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[17],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 18,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'updated_at',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[18]
        },
        {
          __index: 19,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('invoiceWaybillCtrl', invoiceWaybillCtrl);

  /** @ngInject */
  function invoiceWaybillCtrl($state,
                              meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                              waybill, // данные товарно-транспортной накладной
                              edit, // флаг редактирования
                              $uibModal,
                              egaiszService,
                              $timeout,
                              crudsService, // утилитарные вспомогательные методы
                              errorMessageService,
                              $rootScope) {
    var invoiceWaybillCtrl = this;

    invoiceWaybillCtrl.purpose = "INVOICE_WAYBILL";

    // состояние редактирования
    invoiceWaybillCtrl.redact = edit;

    // метаданные ТТН
    invoiceWaybillCtrl.meta = meta;

    // данные по ТТН пока без маппинга (возможно, и не понадобится)
    invoiceWaybillCtrl.values = waybill;

    invoiceWaybillCtrl.crudsService = crudsService;

    invoiceWaybillCtrl.toGridPage = function() {
      $state.go('invoiceWaybills', {parent: 'alcohol'});
    };

    invoiceWaybillCtrl.showStatusComment = function (comment) {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/info.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.titleFontSize = 28;
          $scope.title = 'Дополнительная информация';
          $scope.text = comment;
          $scope.infoIcon = true;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    function checkCanAccept(){
      invoiceWaybillCtrl.canAccept = false;
      invoiceWaybillCtrl.canAcceptWithDispute = false;
      // проверка наличия всех обязательных параметров
      if(waybill.company && waybill.division && waybill.counterparty && waybill.contract){
        // для блокировки возможности принятия решения, если ттн сохранена с ошибками.
        invoiceWaybillCtrl.canAcceptWithDispute = invoiceWaybillCtrl.canAccept = true;
        invoiceWaybillCtrl.canAccept = !_.find(waybill.lines, function (line){
          return !line.domain_sku_derivative;
        });
        invoiceWaybillCtrl.canAcceptWithDispute = !_.find(waybill.lines, function (line){
          return !line.domain_sku_derivative && line.real_quantity == 0;
        });
      }
    }
    checkCanAccept();

    invoiceWaybillCtrl.openApproveModal = function (type, isViewAct) {
      var result = $uibModal.open({
        component: 'approveWaybill',
        size: 'small-width',
        controllerAs: 'approveWaybillCtrl',
        resolve: {
          settings: function (approveCommonService) {
            return approveCommonService.getSettingsByType(type);
          },
          waybill: function () {
            return waybill;
          },
          isViewAct: function () {
            return isViewAct;
          }
        }
      });
    }

    /**
     * Открытие окна сканирования марок
     */
    invoiceWaybillCtrl.openScanMarks = function () {
      var modal = $uibModal.open({
        component: 'scanMarks',
        size: 'large-width',
        controllerAs: 'scanMarkCtrl',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          marksTypes: function (egaiszService) {
            return egaiszService.getMarkTypes().then(function(data) {
              return data.data;
            });
          },
          marks: function (egaiszService) {
            return egaiszService.getScannedMarks(waybill.id).then(function(data) {
              return data;
            });
          },
          waybill: function () {
            return waybill;
          }
        }
      });
      modal.result.then(function(){
        egaiszService.getWaybill(invoiceWaybillCtrl.values.id).then(function (res) {
          invoiceWaybillCtrl.values = res;
        });
      });
    }

    invoiceWaybillCtrl.setActStatus = function (status) {
      egaiszService.setWaybillStatus(invoiceWaybillCtrl.values.id, status).then(function (data) {
        invoiceWaybillCtrl.values.document_status = status;
        if (status == 'NEED_TO_DECIDE') {
          $state.go("invoiceWaybill.edit", {id: invoiceWaybillCtrl.values.id, parent: 'alcohol'}, {reload: true});
        }
      });
    }

    /**
     * Сохранение информации по ТТН
     */
    invoiceWaybillCtrl.save = function(){
      var values = angular.copy(invoiceWaybillCtrl.values); // чтобы сохранить значения во вьюхе и отправить корректные данные
      values.home_amount = values.home_amount.home_amount;
      _.forEach(values.lines, function(line){
        if(line.domain_sku_derivative){
          line.domain_sku_derivative.commitent_tax_group = line.domain_sku_derivative.committent_tax_group;
          line.domain_sku_derivative.committent_tax_group = undefined;
          line.domain_sku_derivative.uom = undefined;
        }
      });
      egaiszService.updateWaybill(values.id, values).then(function(data){
        invoiceWaybillCtrl.invoiceWaybillForm.$setPristine();
        // для блокировки возможности принятия решения, если ттн сохранена с ошибками.
        checkCanAccept();
      },
      function (error) {
        if (error.data.fields[0].field == 'derivative' && error.data.fields[0].error.indexOf("Строка ") != -1) {
          var errorStr = error.data.fields[0].error.split(". ");
          var number = errorStr[0].replace( /^\D+/g, '');
          invoiceWaybillCtrl.invoiceWaybillForm.commonData['rowForm' + (number - 1)].domain_sku_derivative.errorStr = errorStr[1];
          invoiceWaybillCtrl.invoiceWaybillForm.commonData['rowForm' + (number - 1)].domain_sku_derivative.$setValidity('wrong-match', false);
        }else if(error.data.fields[0].error.indexOf('Not equals fsrar inn') + 1) {
            errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "ИНН и КПП выбранной компании и подразделения не соответствуют ИНН и КПП компании, зарегистрированной в ЕГАИС"}}});
        } else {
          if(error.data.fields && error.data.fields[0].error.indexOf('Not equals fsrar inn') + 1) {
            errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "ИНН и КПП выбранной компании и подразделения не соответствуют ИНН и КПП компании, зарегистрированной в ЕГАИС"}}});
          }else if (error.data.fields && error.data.fields[0]) {
            errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: error.data.fields[0].error}}});
          } else {
            errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: error});
          }
        }
      });

    }

    // попап истории
    invoiceWaybillCtrl.openHistoryPopup = function(){
      $uibModal.open({
        size: 'large-width',
        component: 'historyPopup',
        controllerAs: 'historyPopupCtrl',
        resolve: {
          data: function() {
            return invoiceWaybillCtrl.values.status_history;
          },
          filterStatus: function(){
            return 'waybillStatus';
          }
        }
      });
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('cancellationActsListCtrl', cancellationActsListCtrl);

  function cancellationActsListCtrl(userSettingsService,
                                  uiGridConstants,
                                  cancellationActsListDefsService,
                                  filterSettingsService,
                                  API_URL,
                                  $rootScope,
                                  $filter,
                                  $state,
                                  cancellationActsStatuses,
                                  divisions,
                                  companies,
                                  employees,
                                  currenciesService,
                                  writeOffTypes,
                                  writeOffStatementService,
                                  $window) {
    var cancellationActsListCtrl = this;
    cancellationActsListCtrl.url = API_URL + '/alcohol/documents/write_off_statements_egais';
    cancellationActsListCtrl.page = "write_off_statement_egais";
    cancellationActsListCtrl.header = 'Списания';
    cancellationActsListCtrl.sort = 'doc_date';
    cancellationActsListCtrl.sortOrder = "desc";
    cancellationActsListCtrl.limit = 25;
    cancellationActsListCtrl.columnDefs = userSettingsService.loadProperty(cancellationActsListCtrl.page, 'grid', 'columnsProperty') ||
      cancellationActsListDefsService.getColumnDefs.call(this, uiGridConstants);
    cancellationActsListCtrl.usingService = cancellationActsListDefsService;
    cancellationActsListCtrl.filterMeta = {};
    cancellationActsListCtrl.gridButtonConfig = [];


    /**
     * Переход на страничку просмотра/редактирования акта списания
     */
    cancellationActsListCtrl.rowRouteFunc = function (rowData) {
      if (rowData.status == 'DRAFT' && rowData.register) {
        $state.go('cancellationAct.edit', {
          id: rowData.id,
          register: rowData.register, 
          parent: 'alcohol'
        });
      } else {
        $state.go('cancellationAct.view', {
          id: rowData.id,
          register: rowData.register, 
          parent: 'alcohol'
        });
      }
    };

    function copyDoc(id, data) {
      $window.open($state.href('cancellationAct.new', { source: id, register: data.register, parent: 'alcohol' }), '_blank');
    }

    currenciesService.getDomainCurrencies().then(function (res) {
      cancellationActsListCtrl.gridConfig = {
        universalAlcoDocuments: true,
        universalDocuments: true,
        purposesFilterOn: false,
        currencies: res.data.items,
        documentType: cancellationActsListCtrl.page,
        deleteRequest: writeOffStatementService.removeWriteOffStatement,
        copyDocCallback: copyDoc
      };

      if ($rootScope.hasRole('write_off_statement_egais.write')) {
        cancellationActsListCtrl.gridConfig.purposes = [{
          url: "cancellationAct.new({register: \"REGISTER1\"})",
          label: "АКТ СПИСАНИЯ Регистр №1",
          permission: 'write_off_statement_egais.write'
        },{
          url: "cancellationAct.new({register: \"REGISTER2\"})",
          label: "АКТ СПИСАНИЯ Регистр №2",
          permission: 'write_off_statement_egais.write'
        }];
      }
    });

    // Get data for selects
    // // Get data for selects
    cancellationActsListCtrl.registers = [{
      value: "REGISTER1", 
      label: "Регистр №1"
    },
    {
      value: "REGISTER2", 
      label: "Регистр №2"
    }];

    angular.forEach(cancellationActsListCtrl.columnDefs, function (column) {
      if (column.name === 'dataValue.register') {
        column.filter.selectOptions = cancellationActsListCtrl.registers;
      }
    });

    // статусы актов списания ЕГАИС
    if (cancellationActsStatuses) {
      angular.forEach(cancellationActsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.status') {
          column.filter.selectOptions = cancellationActsStatuses;
        }
      });
    }

    // причины списания
    if (writeOffTypes) {
      angular.forEach(cancellationActsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.write_off_type') {
          column.filter.selectOptions = writeOffTypes;
        }
      });
    }

    if (divisions) {
      this.divisionsSelect = [];
      cancellationActsListCtrl.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        cancellationActsListCtrl.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(cancellationActsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name') {
          column.filter.selectOptions = cancellationActsListCtrl.divisionsSelect;
        }
      });
    }

    if (companies) {
      cancellationActsListCtrl.companiesSelect = [];
      cancellationActsListCtrl.companiesPopup = companies;
      companies.forEach(function (item) {
        cancellationActsListCtrl.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(cancellationActsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = cancellationActsListCtrl.companiesSelect;
        }
      });
    }

    if (employees) {
      cancellationActsListCtrl.employeeListSelect = [];
      cancellationActsListCtrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        cancellationActsListCtrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(cancellationActsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = cancellationActsListCtrl.employeeListSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterCancellationActsList().then(function (res) {
      cancellationActsListCtrl.filterMeta = res.data.items;
      cancellationActsListCtrl.filterMeta[0].selectVal = cancellationActsStatuses;
      cancellationActsListCtrl.filterMeta[3].selectVal = cancellationActsListCtrl.divisionsSelect;
      cancellationActsListCtrl.filterMeta[4].selectVal = writeOffTypes;
      cancellationActsListCtrl.filterMeta[5].selectVal = cancellationActsListCtrl.registers;
      cancellationActsListCtrl.filterMeta[7].selectVal = cancellationActsListCtrl.companiesSelect;
      cancellationActsListCtrl.filterMeta[8].selectVal = cancellationActsListCtrl.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('cancellationActsListDefsService', cancellationActsListDefsService);

  /** @ngInject */
  function cancellationActsListDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 160, 160, 160, 200, 200, 200, 200, 200, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('cancellation_acts', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('cancellation_acts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('cancellation_acts', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          enableSorting: false,
          displayName: 'Статус',
          headerCellClass: 'no-wrap-header',
          cellClass: 'text-center',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | cancellationActStatus"/>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          minWidth: 60,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true
        },
        {
          __index: 2,
          name: 'dataValue.doc_number',
          enableSorting: true,
          sortName: 'doc_number',
          displayName: 'Номер',
          enableFiltering: true,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          filterName: 'number',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.doc_date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'doc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'date',
          minWidth: 60,
          backButton: true,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.write_off_type',
          displayName: 'Причина списания',
          visible: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | writeOffType"/>',
          filterName: 'write_off_type',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.register',
          displayName: 'Регистр списания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD == \'REGISTER2\')? \'Регистр №2\' : ((COL_FIELD == \'REGISTER1\')? \'Регистр №1\' : \'\' )"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'register',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          enableFiltering: true,
          visible: true,
          width: columnsDefinedWidth[6]
        },
        { __index: 7,
          name: 'dataValue.home_amount',
          enableFiltering: false,
          displayName: 'Сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.total_home_amount || 0"' +
          ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[7]
        },
        { __index: 8,
          name: 'dataValue.reg_id',
          enableSorting: true,
          sortName: 'reg_id',
          displayName: 'Номер ЕГАИС',
          visible: true,
          filterName: 'reg_id',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[8]
        },
        {
          __index: 9,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: false,
          width: columnsDefinedWidth[9]
        },
        { __index: 10,
          name: 'dataValue.comment',
          enableSorting: false,
          displayName: 'Комментарий',
          visible: false,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[10]
        },
        { __index: 11,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[11],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 12,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'when_updated',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[12]
        },
        {
          __index: 13,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

'use strict';

angular.module('frontend').service('writeOffStatementService', function ($http, $q, API_URL) {

  /**
   * Получение акта списания ЕГАИС
   *
   * @param id акта
   * @return {HttpPromise}
   */
  this.getWriteOffStatement = function (id) {
    return $http.get(API_URL + '/alcohol/documents/write_off_statements_egais/' + id);
  };

  /**
   * Сохранение нового акта
   *
   * @param data данные по новому акту
   * @return {HttpPromise}
   */
  this.createWriteOffStatement = function (data) {
    return $http.post(API_URL + '/alcohol/documents/write_off_statements_egais', data).then(function (data) {
      return data.data;
    });
  };


  /**
   * Обновление акта
   * @param id акта
   * @param data данные по новому акту
   * @return {HttpPromise}
   */
  this.updateWriteOffStatement = function (id, data) {
    return $http.put(API_URL + '/alcohol/documents/write_off_statements_egais/' + id, data).then(function (data) {
      return data.data;
    });
  };

  /**
   * Удаление акта
   *
   * @param ids актов
   * @return {HttpPromise}
   */
  this.removeWriteOffStatement = function (ids) {
    return $http.delete(API_URL + '/alcohol/documents/write_off_statements_egais', {params: {id: ids}}).then(function (data) {
      return data.data;
    });
  };

  /**
   * Изменение статуса акта списания с баланса
   *
   * @param data данные по новому акту
   * @return {HttpPromise}
   */
  this.updateWriteOffStatementStatus = function (id, status) {
    var params = { status: status };
    return $http.put(API_URL + '/alcohol/documents/write_off_statements_egais/' + id + '/status', params).then(function (data) {
      return data.data;
    });
  };


  /**
   * Получение марок акта списания ЕГАИС
   *
   * @param docId документа
   * @param lineId линейки
   * @return {HttpPromise}
   */
  this.getWriteOffMarks = function (docId, lineId) {
    return $http.get(API_URL + '/alcohol/documents/write_off_statements_egais/' + docId + '/lines/' + lineId + '/marks').then(function (data) {
      return data.data;
    });
  };

  /**
   * Управление марками документа
   *
   * @param docId документа
   * @param lineId линейки
   * @return {HttpPromise}
   */
  this.scanMarks = function (docId, lineId, params) {
    return $http.put(API_URL + '/alcohol/documents/write_off_statements_egais/' + docId + '/lines/' + lineId + '/marks', params, {
      params: {
        $$ignoreInterceptor: true
      }
    }).then(function (data) {
      return data.data;
    });
  };



});

(function () {
  'use strict';

  angular.module('frontend').controller('cancellationActCtrl', cancellationActCtrl);

  /** @ngInject */
  function cancellationActCtrl($scope,
                               $state,
                               $stateParams,
                               $uibModal,
                               meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                               cancellationAct,
                               egaiszService,
                               writeOffStatementService,
                               errorMessageService,
                               crudsService,
                               $window,
                               modalAskSrv) {
    var cancellationActCtrl = this;

    // состояние редактирования
    cancellationActCtrl.redact = !cancellationAct || (cancellationAct.status == 'DRAFT' && $stateParams.register) || $state.current.name.endsWith('new');

    // метаданные ТТН
    cancellationActCtrl.meta = meta;

    // данные по акту
    cancellationActCtrl.values = cancellationAct || {lines: [], register: $stateParams.register};

    // переход к списку
    cancellationActCtrl.toGridPage = function() {
      $state.go('cancellationActsList', {parent: 'alcohol'});
    };

    cancellationActCtrl.crudsService = crudsService;

    // преобразование справки2
    _.forEach(cancellationActCtrl.values.lines, function(line){
      if(line.alcohol_stock_item){
        line.alcohol_stock_item.f2reg_id = line.alcohol_stock_item.name;
      }
    })

    // необходим вотчер для того чтобы разрешать сохранять документ, если удалили линейку.
    // diry у формы при этом автоматом не выставляется
    // прямо в компоненте поля не получилось этого сделать,т.к. нет прямого доступа к контроллеру формы
    $scope.$watch(function() { return cancellationActCtrl.values.lines.length }, function(newVal, oldVal) {
      if (newVal != oldVal) {
        cancellationActCtrl.cancellationActForm.$dirty = true;
      }
    });

    // RECS-13637 необходим вотчер для того чтобы не разрешать сохранять документ, если есть линейки 
    // с одинаковыми складкими позициями, и если хоть у одной из этих позиций есть незаполненная справка 2
    $scope.$watch(function() { return cancellationActCtrl.values.lines }, function(newVal) {
      if (!cancellationActCtrl.cancellationActForm.commonData) return;

      var checkIndexes = [];
      _.forEach(newVal, function (line, key) {
        if (checkIndexes.indexOf(key) + 1) return;
        // сброс ошибок 
        if (cancellationActCtrl.cancellationActForm.commonData['rowForm' + (line.identity - 1)] &&
            cancellationActCtrl.cancellationActForm.commonData['rowForm' + (line.identity - 1)].alcohol_stock_item) {
          cancellationActCtrl.cancellationActForm.commonData['rowForm' + (line.identity - 1)].alcohol_stock_item.$setValidity("required", true);
        }

        var matchDerivativesLine = _.filter(newVal, function (searchLine, key) {
          if (!searchLine.identity) searchLine.identity = key + 1;
          return line.derivative && searchLine.derivative && line.derivative.id == searchLine.derivative.id;
        });
        if (matchDerivativesLine.length > 1) {
          var noFn = _.filter(matchDerivativesLine, function (checkFn) {
            return !checkFn.alcohol_stock_item
          });
          _.forEach(noFn, function (noFnItem) {
            if (cancellationActCtrl.cancellationActForm.commonData['rowForm' + (noFnItem.identity - 1)]) {
              cancellationActCtrl.cancellationActForm.commonData['rowForm' + (noFnItem.identity - 1)].alcohol_stock_item.$setValidity("required", false);
            }
          })
        }
        // сохранение индексов
        _.forEach(matchDerivativesLine, function (item) {
          checkIndexes.push(item.identity - 1);
        })
      });
    }, true);

    cancellationActCtrl.showStatusComment = function (comment) {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/info.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.titleFontSize = 28;
          $scope.title = 'Дополнительная информация';
          $scope.text = comment;
          $scope.infoIcon = true;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    // удаление акта
    cancellationActCtrl.delete = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'акт списания';
          $scope.conflictDeleteText = "Невозможно удалить акт списания.<br>Для удаления необходимо удалить все связанные документы.";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.delete = function() {
            $scope.lock = true;
            writeOffStatementService.removeWriteOffStatement(cancellationActCtrl.values.id).then(function(res){
              $uibModalInstance.dismiss();
              cancellationActCtrl.cancellationActForm.$setPristine();
              cancellationActCtrl.cancellationActForm.$setUntouched();
              cancellationActCtrl.toGridPage();
              $scope.lock = false;
            }, function (error) {
              if(error.status == 409){
                $scope.canDelete = false;
                $scope.lock = false;
                return;
              }
              $uibModalInstance.dismiss();
              errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: error});
              $scope.lock = false;
            });
          };
        }
      });
      return modal.result;
    }

    if ($stateParams.source) {
      cancellationActCtrl.values.id = undefined;
      cancellationActCtrl.values.status = undefined;
      cancellationActCtrl.values.doc_number = undefined;
      cancellationActCtrl.values.status_history = undefined;
      _.forEach(cancellationActCtrl.values.lines, function(line){
        line.quantity = undefined;
      });
    }
    if ($state.current.name.endsWith('new')) {
      cancellationActCtrl.values.doc_date = moment();
    }

    function copyDocument() {
      $window.open($state.href('cancellationAct.new', { source: cancellationActCtrl.values.id, id: undefined, parent: 'alcohol' }), '_blank');
    }

    // копировать акт
    cancellationActCtrl.copyHandler = function(status){
      if (cancellationActCtrl.cancellationActForm.$pristine) {
        copyDocument();
      } else {
        modalAskSrv.showModal({
          title: 'Есть несохраненные изменения. Новый документ будет создан только по сохраненным данным.'
        }).then(copyDocument);
      }
    }

    // установка акту статуса
    cancellationActCtrl.setActStatus = function(status){
      if (status == 'NEED_TO_ACCOUNTED') {
        $uibModal.open({
          templateUrl: 'app/settings/templates/modals/one-question.html',
          size: 'small-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.title = "Провести";
            $scope.text = "Вы действительно хотите выполнить проведение документа?";
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };
            $scope.action = function () {
              $uibModalInstance.close();
              cancellationActCtrl.save(status);
            };
          }
        });
      } else {
        writeOffStatementService.updateWriteOffStatementStatus(cancellationActCtrl.values.id, status).then(function(res){
          $state.go("cancellationAct.edit", {id: cancellationActCtrl.values.id, source: undefined, parent: 'alcohol'}, {reload: true});
        });
      }
    }

    function showError (error) {
      if (error.data.fields.length && error.data.fields[0].field == 'derivative'){
        if(error.data.fields[0].error.indexOf('Attribute for alcohol product flag can not be false') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Атрибут \"Алкогольная продукция\" выбранной позиции каталога не может иметь значение \"Нет\""}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol label can not be') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Сканировать акцизную марку\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol type must be equals product code') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Код вида продукции ФСРАР\" выбранной позиции каталога не соответствует виду алкогольной продукции"}}});
        }else if(error.data.fields[0].error.indexOf('Attribute for alcohol percentage must be equals alc volume') + 1) {
          errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: "Значение атрибута \"Крепость\" выбранной позиции каталога не соответствует крепости алкогольной продукции"}}});
        } else {
          errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
        }
      } else if(error.data.fields.length && (error.data.fields[0].field.indexOf('amc_list') + 1) && (error.data.fields[0].field.indexOf('lines') + 1)){
        errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: error.data.fields[0].error}}});
      } else if(error.status == 400 && error.data.code == "bad_arguments" && error.data.fields && error.data.fields[0] && error.data.fields[0].error) {
        errorMessageService.showModal({message: 'При проведении произошла ошибка', submessage: {data: { message: error.data.fields[0].error}}});
      } else {
        errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
      }
    }


    /**
     * Сохранение информации по акту списания
     */
    cancellationActCtrl.save = function(status){
      var formValid = true;
      var values = angular.copy(cancellationActCtrl.values); // чтобы сохранить значения во вьюхе и отправить корректные данные
      if (values.write_off_type == "MIX" && values.lines.length > 1) {
        $uibModal.open({
          templateUrl: 'app/settings/templates/modals/info.html',
          size: 'small-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.title = 'Невозможно сохранить';
            $scope.text = "Акт списания по причине \"Пересортица\" может содержать только одну позицию.";
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };
          }
        });
        return;
      }

      _.forEach(values.lines, function(line){
        if (line.derivative) {
          line.derivative.commitent_tax_group = line.derivative.committent_tax_group;
          line.derivative.committent_tax_group = undefined;
        }
        if (line.alcohol_stock_item) {
          line.alcohol_stock_item = {
            id: line.alcohol_stock_item.id,
            name: line.alcohol_stock_item.f2reg_id
          }
        }
        if (line.alcohol_catalog_item) {
          line.alcohol_catalog_item = {
            id: line.alcohol_catalog_item.id,
            full_name: line.alcohol_catalog_item.name
          }
        }
        if (!parseFloat(line.quantity)) {
           // если количество не указано, или указнов 0, то форма считается не валидной
           // сделано для отлавливания ошибки, когда нажимают на кнопку сохранить без отрабатывания события blur на поле.
          formValid = false;
        }
        if (line.amcs && line.amcs.length) {
          line.amc_list = line.amcs;
        }
        line.amcs = undefined;
        line._manual = undefined;
      });

      // описание выше
      if (!formValid) {
        return;
      }

      // описание выше
      if (!formValid) {
        return;
      }

      values.totals = {
        home_amount: values.totals.home_amount
      };

      values.doc_date = moment(values.doc_date).valueOf();
      if(!cancellationActCtrl.values.id){
        writeOffStatementService.createWriteOffStatement(values).then(function(data){
          cancellationActCtrl.cancellationActForm.$setPristine();
          $stateParams.source = undefined;
          if(status){
            writeOffStatementService.updateWriteOffStatementStatus(cancellationActCtrl.values.id, status).then(function(res){
              $state.go("cancellationAct.edit", {id: data.id, source: undefined, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              showError(error);
            });
          }else{
            $state.go("cancellationAct.edit", {id: data.id, source: undefined, parent: 'alcohol'}, {reload: true});
          }
        },
        function (error) {
          showError(error);
        });
      }else{
        writeOffStatementService.updateWriteOffStatement(values.id, values).then(function(data){
          cancellationActCtrl.cancellationActForm.$setPristine();
          if(status){
            writeOffStatementService.updateWriteOffStatementStatus(cancellationActCtrl.values.id, status).then(function(res){
              cancellationActCtrl.values.status = status;
              $state.go("cancellationAct.edit", {id: data.id, source: undefined, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              showError(error);
            });
          }
        },
        function (error) {
          // RECS-11449 проверка ошибки поиска марки в системе
          if (cancellationActCtrl.redact && error.data.fields && error.data.fields[0].field.indexOf('lines.') + 1) {
            var lineNumber = error.data.fields[0].field.split('.')[1];
            if (cancellationActCtrl.cancellationActForm.commonData['rowForm' + (lineNumber - 1)]) {
              cancellationActCtrl.cancellationActForm.commonData['rowForm' + (lineNumber - 1)].quantity.$setValidity('notFoundMark', false)
              var quantityMeta = _.find(cancellationActCtrl.meta.layout.items[1].fields, function(item){
                return item.code == "quantity";
              });
              quantityMeta.$errorObj = error.data.fields[0];
            } else {
              showError(error);
            }
            return;
          }
          showError(error);
        });
      }

    }


    cancellationActCtrl.resetData = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.text = "Вы действительно хотите отменить выполненные изменения?";
          $scope.title = "Предупреждение";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            writeOffStatementService.getWriteOffStatement($stateParams.id || $stateParams.source).then(function(res){
              cancellationActCtrl.values = res.data;
              cancellationActCtrl.cancellationActForm.$pristine = true;
              cancellationActCtrl.cancellationActForm.$dirty = false;
              $uibModalInstance.dismiss();
            });
          };
        }
      });
    }

    // попап истории
    cancellationActCtrl.openHistoryPopup = function(){
      $uibModal.open({
        size: 'large-width',
        component: 'historyPopup',
        controllerAs: 'historyPopupCtrl',
        resolve: {
          data: function() {
            return cancellationActCtrl.values.status_history;
          },
          filterStatus: function(){
            return 'cancellationActStatus';
          }
        }
      });
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('beginningBalanceEgaisListCtrl', beginningBalanceEgaisListCtrl);

  function beginningBalanceEgaisListCtrl(userSettingsService,
                                  uiGridConstants,
                                  beginningBalanceEgaisListDefsService,
                                  filterSettingsService,
                                  API_URL,
                                  $rootScope,
                                  $filter,
                                  $state,
                                  beginningBalanceStatuses,
                                  employees,
                                  currenciesService,
                                  $uibModal,
                                  fsrarCompanies) {
    var beginningBalanceEgaisListCtrl = this;
    beginningBalanceEgaisListCtrl.url = API_URL + '/alcohol/documents/beginning_balances_egais';
    beginningBalanceEgaisListCtrl.page = "beginning-balance-egais-list";
    beginningBalanceEgaisListCtrl.header = 'Остатки ЕГАИС';
    beginningBalanceEgaisListCtrl.sort = 'doc_date';
    beginningBalanceEgaisListCtrl.limit = 25;

    beginningBalanceEgaisListCtrl.columnDefs = userSettingsService.loadProperty(beginningBalanceEgaisListCtrl.page, 'grid', 'columnsProperty') ||
      beginningBalanceEgaisListDefsService.getColumnDefs.call(this, uiGridConstants);
    beginningBalanceEgaisListCtrl.usingService = beginningBalanceEgaisListDefsService;
    beginningBalanceEgaisListCtrl.filterMeta = {};
    beginningBalanceEgaisListCtrl.gridButtonConfig = [{
      url: 'beginningBalanceEgaisList',
      text: 'запрос остатков',
      permission: 'beginning_balance_egais.write',
      plusButton: true,
      action: function(){
        $uibModal.open({
          size: 'middle-width',
          component: 'fsrarCompanyModal',
          controllerAs: 'fsrarCompanyModalCtr'
        });
      }
    }];


    /**
     * Переход на страничку просмотра/редактирования актов списания
     */
    beginningBalanceEgaisListCtrl.rowRouteFunc = function (rowData) {
      if (rowData.document_status == 'DATA_RECEIVED') {
        $state.go('beginningBalanceEgais.edit', {
          id: rowData.id
        });
      } else {
        $state.go('beginningBalanceEgais.view', {
          id: rowData.id
        });
      }
    };

    currenciesService.getDomainCurrencies().then(function (res) {
      beginningBalanceEgaisListCtrl.gridConfig = {
        universalAlcoDocuments: true,
        purposesFilterOn: false,
        currencies: res.data.items,
        documentType: 'beginning-balance-egais-list'
      };
    });

    // Get data for selects
    // статусы начальных остатков ЕГАИС
    if (beginningBalanceStatuses) {
      angular.forEach(beginningBalanceEgaisListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.document_status') {
          column.filter.selectOptions = beginningBalanceStatuses;
        }
      });
    }

    if (fsrarCompanies) {
      beginningBalanceEgaisListCtrl.fsrarListSelect = [];
      beginningBalanceEgaisListCtrl.fsrarListPopup = fsrarCompanies;
      fsrarCompanies.forEach(function (item) {
        beginningBalanceEgaisListCtrl.fsrarListSelect.push({value: item.fsrar_id, label: item.company_name});
      });
      angular.forEach(beginningBalanceEgaisListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.fsrar') {
          column.filter.selectOptions = beginningBalanceEgaisListCtrl.fsrarListSelect;
        }
      });
    }

    if (employees) {
      beginningBalanceEgaisListCtrl.employeeListSelect = [];
      beginningBalanceEgaisListCtrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        beginningBalanceEgaisListCtrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(beginningBalanceEgaisListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = beginningBalanceEgaisListCtrl.employeeListSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterBeginningBalanceList().then(function (res) {
      beginningBalanceEgaisListCtrl.filterMeta = res.data.items;
      beginningBalanceEgaisListCtrl.filterMeta[0].selectVal = beginningBalanceStatuses;
      beginningBalanceEgaisListCtrl.filterMeta[4].selectVal = beginningBalanceEgaisListCtrl.fsrarListSelect;
      beginningBalanceEgaisListCtrl.filterMeta[7].selectVal = beginningBalanceEgaisListCtrl.employeeListSelect;
      beginningBalanceEgaisListCtrl.filterMeta[9].selectVal = beginningBalanceEgaisListCtrl.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('beginningBalanceEgaisListDefsService', beginningBalanceEgaisListDefsService);

  /** @ngInject */
  function beginningBalanceEgaisListDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 160, 160, 160, 100, 160, 200, 200, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('beginning-balance-egais-list', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('beginning-balance-egais-list', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('ibeginning-balance-egais-list', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.document_status',
          displayName: 'Статус',
          enableSorting: false,
          visible: true,
          pinned: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | beginningBalancesEgaisStatus"/>',
          enableFiltering: true,
          filterName: 'document_status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[1]
        },
        {
          __index: 2,
          name: 'dataValue.doc_number',
          enableSorting: true,
          sortName: 'doc_number',
          displayName: 'Номер',
          enableFiltering: true,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          filterName: 'doc_number',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.doc_date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'doc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'doc_date',
          minWidth: 60,
          backButton: true,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="doc_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          pinned: true,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[3]
        },
        { __index: 4,
          name: 'dataValue.fsrar',
          enableSorting: false,
          displayName: 'Компания в ЕГАИС',
          visible: true,
          filterName: 'fsrar_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD.fsrar_id + \' \' + COL_FIELD.company_name"/>',
          width: columnsDefinedWidth[4]
        },
        { __index: 5,
          name: 'dataValue.fsrar.inn',
          displayName: 'ИНН',
          enableSorting: false,
          visible: false,
          filterName: 'inn',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[5]
        },
        { __index: 6,
          name: 'dataValue.fsrar.kpp',
          displayName: 'КПП',
          visible: false,
          enableSorting: false,
          filterName: 'kpp',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[6]
        },
        { __index: 7,
          name: 'dataValue.created_by.name',
          enableSorting: false,
          displayName:'Кто создал',
          visible: false,
          width: columnsDefinedWidth[7],
          filterName: 'created_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 8,
          name: 'dataValue.created_at',
          displayName: 'Когда создал',
          enableSorting: true,
          sortName: 'created_at',
          headerCellTemplate: headerTemplate,
          filterName: 'created_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[8]
        },
        { __index: 9,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[9],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 10,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'when_updated',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[10]
        },
        {
          __index: 11,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('beginningBalanceEgaisCtrl', beginningBalanceEgaisCtrl);

  /** @ngInject */
  function beginningBalanceEgaisCtrl($state,
                                     meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                                     beginningBalanceEgais, // данные по запросу начальных остатков
                                     $uibModal,
                                     egaiszService,
                                     $timeout,
                                     crudsService, // утилитарные вспомогательные методы
                                     errorMessageService,
                                     $rootScope) {
    var beginningBalanceEgaisCtrl = this;

    // состояние редактирования
    beginningBalanceEgaisCtrl.redact = $state.current.name.endsWith('edit') || beginningBalanceEgais.document_status == 'DATA_RECEIVED';

    beginningBalanceEgaisCtrl.beginningBalanceEgais = beginningBalanceEgais || {};

    // метаданные начальныйх остатков
    beginningBalanceEgaisCtrl.meta = meta;

    // данные по начальным остаткам пока без маппинга (возможно, и не понадобится)
    beginningBalanceEgaisCtrl.values = beginningBalanceEgaisCtrl.beginningBalanceEgais;

    beginningBalanceEgaisCtrl.crudsService = crudsService;

    beginningBalanceEgaisCtrl.toGridPage = function () {
      $state.go('beginningBalanceEgaisList', {parent: 'alcohol'});
    };

    beginningBalanceEgaisCtrl.resetData = function (){
      $state.go('beginningBalanceEgais.edit', {id: beginningBalanceEgais.id, parent: 'alcohol'}, {reload: true});
    };

    beginningBalanceEgaisCtrl.showStatusComment = function (comment) {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/info.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.titleFontSize = 28;
          $scope.title = 'Дополнительная информация';
          $scope.text = comment;
          $scope.infoIcon = true;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    /**
     * Сохранение информации по начальным остаткам
     */
    beginningBalanceEgaisCtrl.save = function (status) {
      var values = angular.copy(beginningBalanceEgaisCtrl.values); // чтобы сохранить значения во вьюхе и отправить корректные данные
      _.forEach(values.lines, function(line){
        line._manual = undefined;
      });
      egaiszService.updateBeginningBalanceEgais(values.id, values).then(function(data){
        beginningBalanceEgaisCtrl.beginningBalanceForm.$setPristine();
        if(status){
          egaiszService.updateBeginningBalanceEgaisStatus(beginningBalanceEgaisCtrl.values.id, status).then(function(res){
            beginningBalanceEgaisCtrl.values.document_status = status;
          },
          function (error) {
            if (error.status == 400 && error.data.code == 'bad_arguments' &&
               (error.data.message == 'Exist another beginning balance in status: NEED_TO_ACCOUNTED, IN_PROGRESS, ACCOUNTED_ERROR, ACCOUNTED_TO' ||
                error.data.message.indexOf('Not set derivative for line:') + 1)) {
                if (error.data.message == 'Exist another beginning balance in status: NEED_TO_ACCOUNTED, IN_PROGRESS, ACCOUNTED_ERROR, ACCOUNTED_TO') {
                  errorMessageService.showModal({message: "При смене статуса произошла ошибка", submessage: {data: { message: "В системе зарегистрирован запрос остатков, переданный на проведение. Повторное проведение запроса остатков не допускается"}}});
                } else {
                  errorMessageService.showModal({message: "При смене статуса произошла ошибка", submessage: {data: { message: "Не все складские позиции заполнены"}}});
                }
            } else if (error.status == 400 && error.data.code == "bad_arguments" && error.data.message) {
              errorMessageService.showModal({message: 'При проведении произошла ошибка', submessage: error});
            } else {
              errorMessageService.showModal({message: 'При смене статуса произошла ошибка', submessage: error});
            }
          });
        }
      },
      function (error) {
        if (error.data.fields[0].field == 'derivative' && error.data.fields[0].error.indexOf("Строка ") != -1) {
          var errorStr = error.data.fields[0].error.split(". ");
          var number = errorStr[0].replace( /^\D+/g, '');
          if (beginningBalanceEgaisCtrl.beginningBalanceForm.commonData['rowForm' + (number - 1)]) {
            beginningBalanceEgaisCtrl.beginningBalanceForm.commonData['rowForm' + (number - 1)].domain_sku_derivative.errorStr = errorStr[1];
            beginningBalanceEgaisCtrl.beginningBalanceForm.commonData['rowForm' + (number - 1)].domain_sku_derivative.$setValidity('wrong-match', false);
          } else {
            errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: error.data.fields[0].error}}});
          }
        } else {
          if (error.data.fields && error.data.fields[0]) {
            errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: {data: { message: error.data.fields[0].error}}});
          } else {
            errorMessageService.showModal({message: "При сохранении произошла ошибка", submessage: error});
          }
        }
      });
    }


    // попап истории
    beginningBalanceEgaisCtrl.openHistoryPopup = function(){
      $uibModal.open({
        size: 'large-width',
        component: 'historyPopup',
        controllerAs: 'historyPopupCtrl',
        resolve: {
          data: function() {
            return beginningBalanceEgaisCtrl.values.status_history;
          },
          filterStatus: function(){
            return 'beginningBalancesEgaisStatus';
          }
        }
      });
    };

    // установка акту статуса
    beginningBalanceEgaisCtrl.setStatus = function(status){
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Провести";
          $scope.text = "Вы действительно хотите выполнить проведение документа?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            $uibModalInstance.close();
            beginningBalanceEgaisCtrl.save(status);
          };
        }
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('beerDeclarationsListCtrl', beerDeclarationsListCtrl);

  function beerDeclarationsListCtrl(userSettingsService,
                                  uiGridConstants,
                                  beerDeclarationsListDefsService,
                                  filterSettingsService,
                                  API_URL,
                                  $rootScope,
                                  $filter,
                                  $state,
                                  beerDeclarationsStatuses,
                                  divisions,
                                  companies,
                                  counterparties,
                                  employees,
                                  currenciesService,
                                  beerDeclarationService) {
    var beerDeclarationsListCtrl = this;
    beerDeclarationsListCtrl.url = API_URL + "/alcohol/documents/beer_declaration";
    beerDeclarationsListCtrl.page = "beer_declaration";
    beerDeclarationsListCtrl.header = "Пивные декларации";
    beerDeclarationsListCtrl.sort = "doc_date";
    beerDeclarationsListCtrl.limit = 25;

    beerDeclarationsListCtrl.columnDefs = userSettingsService.loadProperty(beerDeclarationsListCtrl.page, 'grid', 'columnsProperty') ||
      beerDeclarationsListDefsService.getColumnDefs.call(this, uiGridConstants);
    beerDeclarationsListCtrl.usingService = beerDeclarationsListDefsService;
    beerDeclarationsListCtrl.filterMeta = {};
    beerDeclarationsListCtrl.gridButtonConfig = [{
      url: 'beerDeclaration.new',
      text: 'декларация',
      plusButton: true,
      permission: 'beer_declaration.write'
    }];


    /**
     * Переход на страничку просмотра/редактирования пивной декларации
     */
    beerDeclarationsListCtrl.rowRouteFunc = function (rowData) {
      if (rowData) {
        if (rowData.document_status == 'DRAFT' && $rootScope.hasRole('beer_declaration.write')) {
          $state.go('beerDeclaration.edit', {
            id: rowData.id, 
            parent: 'alcohol'
          });
        } else {
          $state.go('beerDeclaration.view', {
            id: rowData.id, 
            parent: 'alcohol'
          });
        }
      }
    };

    currenciesService.getDomainCurrencies().then(function (res) {
      beerDeclarationsListCtrl.gridConfig = {
        universalAlcoDocuments: false,
        universalDocuments: true,
        purposesFilterOn: false,
        currencies: res.data.items,
        hideCopyButton: true,
        deleteRequest: beerDeclarationService.removeBeerDeclaration,
        documentType: beerDeclarationsListCtrl.page
      };
    });


    beerDeclarationsListCtrl.periodReportings = [
      {
        value: "FIRST",
        label: "1 квартал"
      },
      {
        value: "SECOND",
        label: "2 квартал"
      },
      {
        value: "THIRD",
        label: "3 квартал"
      },
      {
        value: "FOURTH",
        label: "4 квартал"
      }
    ];

    beerDeclarationsListCtrl.beerDeclarationTypes = [
      {
        value: "PRIMARY",
        label: "Первичная"
      },
      {
        value: "CORRECTIVE",
        label: "Корректирующая"
      }
    ];

    // Get data for selects
    // статусы товарно-транспортных накладных
    if (beerDeclarationsStatuses) {
      angular.forEach(beerDeclarationsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.status') {
          column.filter.selectOptions = beerDeclarationsStatuses;
        }
        if (column.name === 'dataValue.period_reporting') {
          column.filter.selectOptions = beerDeclarationsListCtrl.periodReportings;
        }
        if (column.name === 'dataValue.beer_declaration_type') {
          column.filter.selectOptions = beerDeclarationsListCtrl.beerDeclarationTypes;
        }
      });
    }


    if (companies) {
      beerDeclarationsListCtrl.companiesSelect = [];
      beerDeclarationsListCtrl.companiesPopup = companies;
      companies.forEach(function (item) {
        beerDeclarationsListCtrl.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(beerDeclarationsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = beerDeclarationsListCtrl.companiesSelect;
        }
      });
    }

    if (employees) {
      beerDeclarationsListCtrl.employeeListSelect = [];
      beerDeclarationsListCtrl.employeeListPopup = employees;
      employees.forEach(function (item) {
        beerDeclarationsListCtrl.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(beerDeclarationsListCtrl.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = beerDeclarationsListCtrl.employeeListSelect;
        }
      });
    }

    // -- End Get data for selects
    filterSettingsService.filterBeerDeclarationsList().then(function (res) {
      beerDeclarationsListCtrl.filterMeta = res.data.items;
      beerDeclarationsListCtrl.filterMeta[1].selectVal = beerDeclarationsStatuses;
      beerDeclarationsListCtrl.filterMeta[4].selectVal = beerDeclarationsListCtrl.companiesSelect;
      beerDeclarationsListCtrl.filterMeta[5].selectVal = beerDeclarationsListCtrl.periodReportings;
      beerDeclarationsListCtrl.filterMeta[7].selectVal = beerDeclarationsListCtrl.beerDeclarationTypes;
      beerDeclarationsListCtrl.filterMeta[8].selectVal = beerDeclarationsListCtrl.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('beerDeclarationsListDefsService', beerDeclarationsListDefsService);

  /** @ngInject */
  function beerDeclarationsListDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 160, 100, 160, 130, 160, 200, 200, 200, 200, 200, 200, 160, 200, 200, 200, 200, 160, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('beer_declaration', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('beer_declaration', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('beer_declaration', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>'+
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.created_at',
          displayName: 'Дата создания',
          enableSorting: true,
          sortName: 'created_at',
          headerCellTemplate: headerTemplate,
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          pinned: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' :\'UTC\'',
          filterName: 'created_at',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[1]
        },
        {
          __index: 2,
          name: 'dataValue.status',
          displayName: 'Статус',
          visible: true,
          pinned: true,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<div class="ui-grid-cell-contents"><span class="done" uib-tooltip="Принята ФСРАР" tooltip-placement="bottom-left" ng-if="COL_FIELD == \'CONFIRMED\'" style="margin: 0 auto; display: block;"></span> <span class="no-done" uib-tooltip="Черновик" tooltip-placement="bottom-left" ng-if="COL_FIELD == \'DRAFT\'" style="margin: 0 auto; display: block;"></span></div>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[2]
        },
        {
          __index: 3,
          name: 'dataValue.doc_number',
          displayName: 'Номер',
          enableFiltering: true,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          backButton: true,
          filterName: 'number',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[3],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 4,
          name: 'dataValue.doc_date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'doc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'date',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          pinned: false,
          cellFilter: 'date:\'dd.MM.yyyy\' :\'UTC',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[4]
        },
        {
          __index: 5,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: true,
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.period_reporting',
          displayName: 'Период',
          visible: true,
          pinned: false,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | periodReportings"/>',
          enableFiltering: true,
          filterName: 'period_reporting',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[6]
        },
        { __index: 7,
          name: 'dataValue.year_reporting',
          displayName: 'Год',
          visible: true,
          enableFiltering: false,
          enableSorting: false,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'year_reporting',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          width: columnsDefinedWidth[7]
        },
        {
          __index: 8,
          name: 'dataValue.beer_declaration_type',
          displayName: 'Тип',
          visible: true,
          pinned: false,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD == \'PRIMARY\')? \'Первичная\' : ((COL_FIELD == \'CORRECTIVE\')? \'Корректирующая\' : \'\');"/>',
          enableFiltering: true,
          filterName: 'beer_declaration_type',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          width: columnsDefinedWidth[8]
        },
        { __index: 9,
          name: 'dataValue.number_corrective',
          enableSorting: false,
          displayName: '№ корректировки',
          visible: true,
          enableFiltering: false,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[9]
        },
        { __index: 10,
          name: 'dataValue.comment',
          enableSorting: false,
          displayName: 'Комментарий',
          visible: false,
          enableFiltering: false,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          width: columnsDefinedWidth[10]
        },
        { __index: 11,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName:'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[11],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 12,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'updated_at',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[18]
        },
        {
          __index: 13,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
          'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
          'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
          '      <button class="btn btn-default dropdown-toggle"\n' +
          '              data-toggle="modal" data-target="#filter-popup"\n' +
          '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
          '\n' +
          '      <div class="dropdown-menu pull-right">\n' +
          '\n' +
          '        <div>\n' +
          '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
          '        </div>\n' +
          '\n' +
          '        <div class="content-wrapper">\n' +
          '          <div class="content">\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
          '              <p style="margin-bottom: 0">Компания:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
          '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
          '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
          '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
          '              <p style="margin-bottom: 0">Кассир:</p>\n' +
          '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
          '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
          '            </div>\n' +
          '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
          '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
          '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
          '            </div>\n' +
          '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
          '          </div>\n' +
          '        </div>\n' +
          '      </div>\n' +
          '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

'use strict';

angular.module('frontend').service('beerDeclarationService', function ($http, $q, API_URL) {

  // подготовка массива для корректного отображения в custom-grid - выпрямление массива
  function prepareData (res) {
    var product_movements = [];
    _.forEach(res.data.product_movements, function (item, keyProduct) {
      product_movements.push(item);
      if (item.incoming_products.length) {
        _.forEach(item.incoming_products, function (product, keyIncoming) {
          var newItem = angular.copy(item);
          // нельзя использовать объект, надо использовать отдельные переменные, чтобы не было в мете доступа к коду по цепочке,
          // т.к. дата и select такое не могут поддреживать на данном этапе
          newItem.date_ttn = product.date_ttn;
          newItem.number_td = product.number_td;
          newItem.number_ttn = product.number_ttn;
          newItem.quantity = product.quantity;
          newItem.shipper = product.shipper;
          newItem.$$incoming_product = true;
          product_movements.push(newItem);
        });
      }
    });
    _.forEach(product_movements, function (item) {
      item.incoming_products = undefined;
    });
    // сортировка по коду, происзводителю и дате ттн
    res.data.product_movements = product_movements.sort(function (a, b) {
      var aCode = a.alcohol_product_classifier.code;
      var bCode = b.alcohol_product_classifier.code;
      var aProducer = a.producer.id;
      var bProducer = b.producer.id;
      var aDate = a.date_ttn;
      var bDate = b.date_ttn;

      if (aProducer == bProducer && aCode == bCode) {
        return (aDate < bDate) ? -1 : (aDate > bDate) ? 1 : 0;
      } else if (aCode == bCode){
        return (aProducer < bProducer) ? -1 : (aProducer > bProducer) ? 1 : 0;
      } else {
        return (aCode < bCode) ? -1 : (aCode > bCode) ? 1 : 0;
      }
    });
    return res;
  }

  // подготовка данных для апи
  function gatherDataForApi (data) {
    var product_movements = [];
    _.forEach(data.product_movements, function (item) {
      var newItem;
      var hasItem = _.find(product_movements, function (item2) {
        return item.alcohol_product_classifier.id == item2.alcohol_product_classifier.id &&
               item.producer.id == item2.producer.id &&
               item.division.id == item2.division.id;
      });
      if (hasItem) {
        newItem = hasItem;
        if (!newItem.incoming_products) {
          newItem.incoming_products = [];
        }
      } else {
        newItem = item;
        newItem.incoming_products = [];
      }
      newItem.producer = {
        id: item.producer.id,
        name: item.producer.name
      }
      newItem.alcohol_product_classifier.low_alcohol = undefined;
      if (item.date_ttn && (item.number_td || item.number_ttn) && item.shipper) {
        newItem.incoming_products.push({
          date_ttn: item.date_ttn,
          number_td: item.number_td,
          number_ttn: item.number_ttn,
          quantity: item.quantity,
          shipper: {
            id: item.shipper.id,
            name: item.shipper.name || item.shipper.short_name
          }
        });
      }
      newItem.date_ttn = undefined;
      newItem.number_td = undefined;
      newItem.number_ttn = undefined;
      newItem.quantity = undefined;
      newItem.shipper = undefined;
      if (newItem.incoming_products && !newItem.incoming_products.length) {
        newItem.incoming_products = null;
      }
      if (!hasItem) {
        product_movements.push(newItem);
      }
    });
    data.product_movements = product_movements;
    return data;
  }

  /**
   * Метод получения пивных деклараций
   */
  this.getBeerDeclarations = function (params) {
    return $http.get(API_URL + '/alcohol/documents/beer_declaration', {
      params: params
    });
  };

  /**
   * Метод получения статусов пивных деклараций
   */
  this.getBeerDeclarationsStatuses = function () {
    return $http.get('assets/api/egais/beer-declarations_egais_statuses.json');
  };

  /**
   * Получение пивной декларации
   *
   * @param id декларации
   * @return {HttpPromise}
   */
  this.getBeerDeclaration = function (id) {
    return $http.get(API_URL + '/alcohol/documents/beer_declaration/' + id).then(function (res) {
      return prepareData(res);
    });
  };

  /**
   * Сохранение пивной декларации
   *
   * @param data данные по пивной декларации
   * @return {HttpPromise}
   */
  this.createBeerDeclaration = function (data) {
    return $http.post(API_URL + '/alcohol/documents/beer_declaration', data).then(function (data) {
      return data.data;
    });
  };


  /**
   * Обновление пивной декларации
   * @param id пивной декларации
   * @param data данные по новой пивной декларации
   * @return {HttpPromise}
   */
  this.updateBeerDeclaration = function (id, data) {
    data = gatherDataForApi(data);
    return $http.put(API_URL + '/alcohol/documents/beer_declaration/' + id, data).then(function (data) {
      return data.data;
    });
  };

  /**
   * Удаление пивной декларации
   *
   * @param ids актов
   * @return {HttpPromise}
   */
  this.removeBeerDeclaration = function (ids) {
    return $http.delete(API_URL + '/alcohol/documents/beer_declaration', {
      params: {
        id: ids
      }
    }).then(function (data) {
      return data.data;
    });
  };

  /**
   * Изменение статуса пивной декларации
   *
   * @param data данные по новой пивной декларации
   * @return {HttpPromise}
   */
  this.updateBeerDeclarationStatus = function (id, status) {
    var params = { status: status };
    return $http.put(API_URL + '/alcohol/documents/beer_declaration/' + id + '/status', params).then(function (data) {
      return data.data;
    });
  };


  /**
   *
   * Запрос автоматически сформированной пивной декларации
   * @param old_declaration_id ИД предыдущей декларации, используется для заполнения остатков на начало периода
   * @param data данные по новой пивной декларации
   * @return {HttpPromise}
   */
  this.beerDeclarationInit = function (beer_declaration_id, old_declaration_id) {
    return $http.get(API_URL + '/alcohol/documents/beer_declaration/' + beer_declaration_id + '/init',
        {
          params: {
            old_declaration_id: old_declaration_id
          }
        }).then(function (data) {
      return prepareData(data);
    });
  };

  /**
   * Запрос создания xml пивной декларации
   *
   * @param id ID документа
   * @return {HttpPromise}
   */
  this.createXml = function (id) {
    return $http.get(API_URL + '/alcohol/documents/beer_declaration/' + id + '/xml/create');
  };

  /**
   * Запрос остановки xml пивной декларации
   *
   * @param id ID документа
   * @return {HttpPromise}
   */
  this.cancelXml = function (id) {
    return $http.get(API_URL + '/alcohol/documents/beer_declaration/xml/' + id + '/cancel');
  };

  /**
   * Запрос статуса xml пивной декларации
   *
   * @param id ID документа
   * @return {HttpPromise}
   */
  this.statusXml = function (id) {
    return $http.get(API_URL + '/alcohol/documents/beer_declaration/xml/' + id + '/status');
  };

  /**
   * Запрос загрузки xml пивной декларации
   *
   * @param id ID документа
   * @return {HttpPromise}
   */
  this.downloadXml = function (id) {
    return $http.get(API_URL + '/alcohol/documents/beer_declaration/xml/' + id + '/download');
  };


});

 (function () {
  'use strict';

  angular.module('frontend').controller('beerDeclarationCtrl', beerDeclarationCtrl);

  /** @ngInject */
  function beerDeclarationCtrl($scope,
                               $state,
                               $stateParams,
                               $uibModal,
                               meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                               beerDeclaration,
                               egaiszService,
                               beerDeclarationService,
                               errorMessageService,
                               crudsService,
                               $window,
                               modalAskSrv,
                               print,
                               statusSrv,
                               downloadSrv,
                               requestStatus,
                               $timeout) {
    var beerDeclarationCtrl = this;

    // флаг нового документа
    beerDeclarationCtrl.newDoc = !beerDeclaration || $state.current.name.endsWith('new');

    // состояние редактирования 
    beerDeclarationCtrl.redact = !beerDeclaration || beerDeclaration.status == 'DRAFT' || $state.current.name.endsWith('edit');
    // метаданные
    beerDeclarationCtrl.meta = meta;

    // данные по акту
    beerDeclarationCtrl.values = beerDeclaration || {};

    // переход к списку
    beerDeclarationCtrl.toGridPage = function() {
      $state.go('beerDeclarations', {parent: 'alcohol'});
    };

    beerDeclarationCtrl.crudsService = crudsService;

    if (!beerDeclarationCtrl.newDoc) {
      // необходим вотчер для того чтобы разрешать сохранять документ, если удалили линейку.
      // dirty у формы при этом автоматом не выставляется
      // прямо в компоненте поля не получилось этого сделать,т.к. нет прямого доступа к контроллеру формы
      $scope.$watch(function() { return beerDeclarationCtrl.values.product_movements.length }, function(newVal, oldVal) {
        beerDeclarationCtrl.form.$dirty = newVal !== oldVal;
        _.forEach(beerDeclarationCtrl.values.product_movements, function(movement){
          if (!movement.division) {
            var division = beerDeclarationCtrl.values.filter_division || beerDeclarationCtrl.values.divisions[0]
            movement.division = {
              id: division.id,
              name: division.name
            };
          }
        });
      });
    }

    // удаление
    beerDeclarationCtrl.delete = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'пивную декларацию';
          $scope.conflictDeleteText = "Невозможно удалить деларацию.<br>Для удаления необходимо удалить все связанные документы.";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.delete = function() {
            $scope.lock = true;
            beerDeclarationService.removeBeerDeclaration([beerDeclarationCtrl.values.id]).then(function(res){
              $uibModalInstance.dismiss();
              beerDeclarationCtrl.form.$setPristine();
              beerDeclarationCtrl.form.$setUntouched();
              beerDeclarationCtrl.toGridPage();
              $scope.lock = false;
            }, function (error) {
              if(error.status == 409){
                $scope.canDelete = false;
                $scope.lock = false;
                return;
              }
              $uibModalInstance.dismiss();
              errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: error});
              $scope.lock = false;
            });
          };
        }
      });
      return modal.result;
    }
    
    if ($state.current.name.endsWith('new')) {
      beerDeclarationCtrl.values.doc_date = moment();
    }

    function showError (error) {
      errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
    }

    beerDeclarationCtrl.process = function () {
      beerDeclarationService.updateBeerDeclarationStatus(beerDeclarationCtrl.values.id, "CONFIRMED").then(function(){
        $state.go("beerDeclaration.view", {id: beerDeclaration.id, parent: 'alcohol'}, {reload: true});
      },
      function (error) {
        showError(error);
      });
    }

    beerDeclarationCtrl.rollback = function(){
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Предупреждение";
          $scope.text = "При переведении статуса в \"Черновик\" декларация не будет доступна для автоматического заполнения начальных остатков в других декларациях.<br><br>Вы действительно хотите изменить статус?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            beerDeclarationService.updateBeerDeclarationStatus(beerDeclarationCtrl.values.id, "DRAFT").then(function(){
              $state.go("beerDeclaration.edit", {id: beerDeclaration.id, parent: 'alcohol'}, {reload: true});
            },
            function (error) {
              showError(error);
            });
          };
        }
      });
    }

    /**
     * Сохранение информации по акту списания
     */
    beerDeclarationCtrl.save = function(isProcess){
      var formValid = true;
      var values = angular.copy(beerDeclarationCtrl.values); // чтобы сохранить значения во вьюхе и отправить корректные данные

      values.doc_date = moment(values.doc_date).valueOf();
      // чистим фильтры подразделений
      values.filter_division = undefined;
      
      _.forEach(values.product_movements, function(movement){
        movement._manual = undefined;
        movement.date_ttn = moment(movement.date_ttn).valueOf();
      });

      if(!beerDeclarationCtrl.values.id){
        beerDeclarationService.createBeerDeclaration(values).then(function(res){
          beerDeclarationCtrl.form.$setPristine();
          $stateParams.source = undefined;
          if (isProcess) {
            beerDeclarationCtrl.process();
          } else {
            $state.go("beerDeclaration.edit", {id: res.id, parent: 'alcohol'}, {reload: true});
          }
        },
        function (error) {
          showError(error);
        });
      }else{
        beerDeclarationService.updateBeerDeclaration(values.id, values).then(function(res){
          beerDeclarationCtrl.form.$setPristine();
          if (isProcess) {
            beerDeclarationCtrl.process();
          }
        },
        function (error) {
          showError(error);
        });
      }

    }


    beerDeclarationCtrl.resetData = function(){
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.text = "Вы действительно хотите отменить выполненные изменения?";
          $scope.title = "Предупреждение";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            beerDeclarationService.getBeerDeclaration(beerDeclarationCtrl.values.id).then(function(res){
              beerDeclarationCtrl.values = res.data;
              beerDeclarationCtrl.form.$pristine = true;
              beerDeclarationCtrl.form.$dirty = false;
              if (!res.data.product_movements || !res.data.product_movements.length) {
                res.data.product_movements = [{"_manual": true}];
              } 
              $uibModalInstance.dismiss();
            });
          };
        }
      });
    }

    // попап истории
    beerDeclarationCtrl.openHistoryPopup = function(){
      $uibModal.open({
        size: 'large-width',
        component: 'historyPopup',
        controllerAs: 'historyPopupCtrl',
        resolve: {
          data: function() {
            return beerDeclarationCtrl.values.status_history;
          },
          filterStatus: function(){
            return 'beerDeclarationStatus';
          }
        }
      });
    };

    function downloadXml(uibModalInstance) {
      downloadSrv.getPromise('/alcohol/documents/beer_declaration/xml/' + beerDeclarationCtrl.exec_id + '/download').then(function(){
        requestStatus.success("Отчет сформирован");
        beerDeclarationCtrl.exec_id = false;
        uibModalInstance.dismiss();
      });
    }

    beerDeclarationCtrl.exportPopup = function () {
      var modal = $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Экспорт декларации";
          $scope.text = "Вы действительно хотите выгрузить декларацию?";
          $scope.close = function () {
            if (beerDeclarationCtrl.exec_id) {
              beerDeclarationService.cancelXml(beerDeclarationCtrl.exec_id).then(function(res) {
                beerDeclarationCtrl.exec_id = false;
                $uibModalInstance.dismiss();
              });
            } else {
              $uibModalInstance.dismiss();
            }
          };
          $scope.action = function () {
            $scope.load = true;
            beerDeclarationService.createXml(beerDeclarationCtrl.values.id).then(function(res) {
              beerDeclarationCtrl.exec_id = res.data.task_id;
              statusSrv.getPromise('/alcohol/documents/beer_declaration/xml/' + beerDeclarationCtrl.exec_id + '/status').then(function (res) {
                print.turnoffInterceptorStatus();
                $uibModalInstance.dismiss();
                
                if (res.business_exceptions.length) {
                  $uibModal.open({
                    templateUrl: 'app/settings/templates/modals/info.html',
                    size: 'small-width',
                    controller: function ($scope, $uibModalInstance) {
                      $scope.title = "Предупреждение";
                      $scope.text = "";
                      _.forEach(res.business_exceptions, function (str, key) {
                        if (key) {
                          $scope.text += ".<br>";
                        }
                        $scope.text += str;
                      });
                      $scope.close = function () {
                        $uibModalInstance.dismiss();
                      };
                    }
                  });
                } else {
                  downloadXml($uibModalInstance);
                }
              }).catch(function (err) {
                if (err.error_description) {
                  errorMessageService.showModal({message: 'При экспорте произошла ошибка', submessage: { data: { message: err.error_description}}});
                } else {
                  requestStatus.error("Во время формирования отчета произошла ошибка. По пробуйте повторить действие позже.");
                }
                beerDeclarationCtrl.exec_id = false;
                $uibModalInstance.dismiss();
              });
            }).catch(function (err) {
              if (err.error_description) {
                errorMessageService.showModal({message: 'При экспорте произошла ошибка', submessage: { data: { message: err.error_description}}});
              } else if (err.data.message == 'Company with out inn') {
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: { data: { message: "У выбранной компании не указан инн"}}});
              } else {
                requestStatus.error("Во время формирования отчета произошла ошибка. По пробуйте повторить действие позже.");
              }
              beerDeclarationCtrl.exec_id = false;
              $uibModalInstance.dismiss();
            });
          };
        }
      });

      modal.result.then(function(res){
        if (beerDeclarationCtrl.exec_id) {
          beerDeclarationService.cancelXml(beerDeclarationCtrl.exec_id).then(function(res) {
            beerDeclarationCtrl.exec_id = false;
          });
        }
      });
    }

    beerDeclarationCtrl.autoFill = function () {
      var modal = $uibModal.open({
        templateUrl: 'app/egaisz/beer-declaration/modals/declaration-auto-fill.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance, beerDeclarationService) {
          $scope.setBB = false;
          $scope.load = false;
          $scope.correctData = false;
          $scope.data = {
            declaration: undefined
          };
          $scope.dirty = beerDeclarationCtrl.form.$dirty;

          $scope.refreshDeclarations = function (search) {
            var filters = {
                filter_company_id: (beerDeclarationCtrl.values.company)? beerDeclarationCtrl.values.company.id : null,
                filter_status: "CONFIRMED"
              };
            beerDeclarationService.getBeerDeclarations(filters)
              .then(function (data) {
                $scope.declartions = data.data.items;
              });
          }

          $scope.close = function () {
            $uibModalInstance.close();
          };

          $scope.fill = function () {
            $scope.load = true;
            var id = beerDeclarationCtrl.values.id;
            var doc_number = beerDeclarationCtrl.values.doc_number;
            beerDeclarationService.beerDeclarationInit(beerDeclarationCtrl.values.id, $scope.data.declaration && $scope.data.declaration.id).then(function(res){
              beerDeclarationCtrl.values = res.data;
              beerDeclarationCtrl.values.id = id;
              beerDeclarationCtrl.values.doc_number = doc_number;
              if (!beerDeclarationCtrl.values.product_movements || !beerDeclarationCtrl.values.product_movements.length) {
                beerDeclarationCtrl.values.product_movements = [{}];
              } else {
                beerDeclarationCtrl.values.filter_division = {
                  id: beerDeclarationCtrl.values.divisions[0].id,
                  name: beerDeclarationCtrl.values.divisions[0].name
                };
              }
              $scope.load = false;
              $scope.correctData = true;
              beerDeclarationCtrl.form.$setDirty();
            }, function () {
              $uibModalInstance.close();
              requestStatus.error("Во время автозаполнения произошла ошибка. По пробуйте повторить действие позже.");
            });
          }
        }
      });
    }


  }
})();

'use strict';
angular.module('frontend').component('documentToPriceList', {
  templateUrl: 'app/documents/document-to-price-list/document-to-price-list.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope,
                        $q,
                        priceListSrv,
                        utilsService,
                        priceColumnSrv,
                        modalMessageSrv,
                        errorMessageService) {
    var $ctrl = this;

    $ctrl.purchaseColumns = $ctrl.resolve.purchaseColumns;
    $ctrl.priceListType = 'PURCHASE'; // на момент создания добавляются только в закупочный из приемок

    // необходимо, если потребуется создание новой колонки
    $ctrl.createdColumn = {};

    // данные формируемого запроса
    $ctrl.requestData = {
      prices: $ctrl.resolve.prices,
      column: $ctrl.purchaseColumns && $ctrl.purchaseColumns.length && $ctrl.purchaseColumns[0],
      add_item: true,
      update_price: false,
      $$keep_qty: false
    };

    // конфиг для скролла названий колонок
    $ctrl.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      setHeight: 385,
      scrollInertia: 0,
      axis: 'y'
    };

    /**
     * Метод сбрасывает ошибки валидации (на момент создания только уникальности)
     */
    $ctrl.clearValidationError = function (fieldName) {
      $ctrl.priceBoxForm[fieldName].$setValidity('unique', true);
    };

    /**
     * Метод выполняет проверку введеного имени колонки
     */
    $ctrl.checkNewColumnName = function () {
        if ($ctrl.createdColumn.name) {
          var obj = {
            "constraint_name": "PURCHASE_PRICE_LIST_COLUMN",
            "parameters": [
              {
                "name": "name",
                "value": $ctrl.createdColumn.name
              }
            ]
          };
          utilsService.uniqueCheck(obj).catch(
            function (error) {
              if (error.status == 409) {
                $ctrl.priceBoxForm.columnNewInput.$setValidity('unique', false);
              }
            });
        }
    };

    /**
     * Обновление цен согласно выбранным настройкам
     */
    $ctrl.updatePrices = function () {
      $ctrl.loading = true;
      var columnCreatePromise = $q.when();
      if (!$ctrl.requestData.column.id) {
        columnCreatePromise = priceColumnSrv
          .createPriceColumn($ctrl.priceListType, {
            taxes_included: true,
            name: $ctrl.requestData.column.name,
            currency: $ctrl.resolve.homeCurrency
          });
      }
      columnCreatePromise.then(
        function (column) {
          if (column) {
            $ctrl.requestData.column.id = column.id;
          }
          if (!$ctrl.requestData.$$keep_qty) {
            $ctrl.requestData.prices = _.map($ctrl.requestData.prices, function (price) {
              return angular.merge({}, price, {quantity: 1});
            })
          }
          priceListSrv.boxPriceListUpdate($ctrl.requestData).then(function () {
            $ctrl.loading = false;
            $ctrl.modalInstance.close();
          }, function (error) {
            $ctrl.loading = false;
            $ctrl.modalInstance.close();
            errorMessageService.showModal({
              message: "При получении цен произошла ошибка",
              submessage: error
            });
          });
        }
      ), function () {
        $ctrl.loading = false;
        $ctrl.modalInstance.close();
        errorMessageService.showModal({
          message: "При создании колонки произошла ошибка",
          submessage: {
            data: {
              message: "Не удалось создать колонку"
            }
          }
        });
      };
    };

    /**
     * Подсказка для показа количества подразделений, привязанных к колонке
     *
     * @param column
     */
    $ctrl.tipForDivisions = function (column) {
      var str = '';
      if (column.divisions.length) {
        str = 'Действует только для подразделений \n';
        angular.forEach(column.divisions, function (division, key) {
          if (key < 4) {
            str += ("<div>" + division.name + "</div>");
          } else if (key === 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    };

    /**
     * Подсказка для показа количества контрагентов, привязанных к колонке
     *
     * @param column
     */
    $ctrl.tipForCounterparties = function (column) {
      var str = '';
      if (column.counterparties.length) {
        str = 'Действует только для контрагентов \n';
        angular.forEach(column.counterparties, function (counterparty, key) {
          if (key < 4) {
            str += ("<div>" + counterparty.name + "</div>");
          } else if (key === 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    };

    /**
     * Закрытие модального окна без результата
     */
    $ctrl.close = function() {
      $ctrl.modalInstance.dismiss();
    };
  }
});

(function () {
  'use strict';

  angular.module('frontend').controller('documentSettingsController', documentSettingsController).filter('resetPeriodFilter', function() {
    return function(value) {
      switch (value) {
        case 'DAY':
          return 'Каждый день';
        case 'MONTH':
          return 'Каждый месяц';
        case 'QUARTER':
          return 'Каждый квартал';
        case 'YEAR':
          return 'Каждый год';
        default :
          return 'Никогда';
      }
    }
  });

  /** @ngInject */
  function documentSettingsController(cardHistory,
                                      $scope,
                                      $state,
                                      documentService,
                                      documentSettings,
                                      $q,
                                      errorMessageService,
                                      $timeout,
                                      $uibModal) {

    var vm = this;
    vm.settings = angular.copy(documentSettings);
    vm.currentIndex = 0;
    vm.loading = true;

    vm.init = function () {
      vm.settings.document_number_sequences = _.sortBy(vm.settings.document_number_sequences, function(o) {
        return o.company.name;
      });

      vm.is_auto_price = !!vm.settings.document_price_source.length;

      if (vm.settings.document_number_sequences[vm.currentIndex]) {
        vm.company = vm.settings.document_number_sequences[vm.currentIndex].company;
        vm.document_type = vm.settings.document_number_sequences[vm.currentIndex].document_type;
      }


      if (!vm.settings.document_price_source.length) {
        // формирование начальной структуры, для сохранения типов цен
        _.forEach(vm.types, function(docType){
          vm.settings.document_price_source.push({
            document_type: docType
          });
        });
      }

      vm.autoStartProcessing = vm.settings.domain_documents_settings.start_processing >= 0;

      vm.loading = false;
    }


    function getItemIndex(companyID, type) {
      return _.findIndex(angular.copy(vm.settings.document_number_sequences), function(item, i) {
        return companyID === item.company.id && type === item.document_type
      });
    }


    vm.onFilterChange = function(company, type) {
      vm.currentIndex = getItemIndex(company.id, type);
    };

    vm.onAutoStartProcessingChange = function() {
      vm.settings.domain_documents_settings.start_processing = vm.settings.domain_documents_settings.start_processing < 0 ? 0 : vm.settings.domain_documents_settings.start_processing;
    };

    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if (prev) {
        $state.go(prev.name || 'allDocuments', prev.param);
      } else {
        $state.go('allDocuments');
      }
    };

    vm.setDirty = function() {
      vm.isSetDirty = true;
      angular.forEach( vm.documentSettingsForm.$error, function (control) {
        for (var i = 0; i < control.length; i++) {
          control[i].$setDirty();
        }
      });
      return $q.when();
    };

    vm.crud = function (status) {
      switch(status) {
        case 'save':
          if (vm.documentSettingsForm.$valid) {
            return vm.updateSettings()
          }else{
            return vm.setDirty();
          }
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    };

    function prepareSave() {
      vm.settings.domain_documents_settings.start_processing = vm.autoStartProcessing ? vm.settings.domain_documents_settings.start_processing : -1;
      if (!vm.settings.document_number_sequences.length) {
        vm.settings.document_number_sequences = undefined;
        return;
      }
      angular.forEach(vm.settings.document_number_sequences, function(item) {
        item.reset_period = item.reset_period === 'EMPTY' ? null : item.reset_period;
      });
      if (!vm.is_auto_price) {
        vm.settings.document_price_source = [];
      }

    }

    vm.updateSettings = function() {
      var deferred = $q.defer();
      prepareSave();
      return documentService.updateDocumentSettings(vm.settings).then(function() {
        vm.documentSettingsForm.$setPristine();
        vm.returnToPage();
      },
      function (error) {
        errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
        return deferred.reject();
      });
    };


    vm.autoNumbersPopup = function () {
      var modal = $uibModal.open({
        size: 'large-width',
        component: 'autoNumbersPopup',
        controllerAs: 'autoNumbersPopup',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: angular.copy(vm.settings)
        }
      });
      modal.result.then(function(data){
        if (data) vm.settings = data;
      });
    }

    vm.autoPricePopup = function () {
      var modal = $uibModal.open({
        size: 'large-width',
        component: 'autoPricePopup',
        controllerAs: 'autoPricePopup',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          settings: angular.copy(vm.settings)
        }
      });
      modal.result.then(function(data){
        if (data) vm.settings = data;
      });
    }

    $timeout(function () {
      vm.init();
    }, 0)
  }
})();

'use strict';
angular.module('frontend').component('documentPrint', {
  templateUrl: 'app/documents/document-print/document-print.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function ($scope, print, helpService, authToken, statusSrv, $timeout, API_URL, downloadSrv) {
    var ctrl = this;
    ctrl.printForm = ctrl.resolve.printForm;
    print.turnonInterceptorStatus();
    ctrl.params = {};
    angular.forEach(ctrl.printForm.parameters, function(parameter) {
      if (parameter.type === 'BOOLEAN') {
        ctrl.params[parameter.code] = false;
      }
    });
    ctrl.format = 'PDF';

    if (!ctrl.resolve.documentProperties || 
        typeof ctrl.resolve.documentProperties.xls !== "boolean" || 
        ctrl.resolve.documentProperties.xls !== false) {
      ctrl.formats = ['PDF', 'XLS'];
    }

    ctrl.longRequest = {
      format: null,
      exec_id: null,
      crudState: helpService.getCrudStateStructure(),
      flags: {
        processStart: false,
        finish: false
      },
      stopAskingError: function(){
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function(err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
        if (err.data && err.data.fields[0] && err.data.fields[0].error) {
          ctrl.errorMessage = err.data.fields[0].error;
        } else {
          ctrl.errorMessage = "При подготовке отчета произошла ошибка";
        }
      },
      revert: function() {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };

    ctrl.close = function() {
      ctrl.modalInstance.dismiss();
    };

    ctrl.print = function() {
      if (!ctrl.longRequest.flags.processStart) {
        ctrl.longRequest.flags.processStart = true;
        ctrl.processStart = true;
        ctrl.longRequest.crudState.startLoading();
        print.prepareDocumentPrintForm(ctrl.printForm.code, ctrl.resolve.documentId, ctrl.params, ctrl.format).then(function(res) {
          ctrl.longRequest.exec_id = res.data.exec_id;
          statusSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/status').then(function () {
            ctrl.longRequest.flags.finish = true;
            print.turnoffInterceptorStatus();
            $timeout(function() {
              downloadSrv.getPromise('/print_report/executions/' + ctrl.longRequest.exec_id + '/output').then(function(){
                ctrl.longRequest.crudState.stopLoadingSuccess();
                $timeout(function() {
                  ctrl.modalInstance.dismiss();
                }, 300, false)
              });
            });
          },ctrl.longRequest.onError);
        }).catch(ctrl.longRequest.onError);

      }
    };

    if (ctrl.resolve.printNow) {
      ctrl.print();
    }

  }
});

(function () {
  'use strict';

  angular.module('frontend').controller('documents', documents);

  /** @ngInject */
  function documents(documentsGridSettings,
    $state,
    API_URL,
    $stateParams,
    documentMetaData,
    userSettingsService,
    employees,
    allDocumentsColumnDefsService,
    uiGridConstants,
    companies,
    divisions,
    projects,
    contracts,
    $filter,
    counterparties,
    filterSettings,
    domainCurrencies,
    $rootScope,
    docSettings,
    taxChargeTypes) {
    var vm = this;
    vm.docSettings = docSettings;
    vm.url = API_URL + '/documents/data?filter_document_type=' + $stateParams.type;
    vm.documentsGridSettings = documentsGridSettings;
    vm.page = 'documents-' + $stateParams.type;
    vm.rowRoute = 'document.view';
    // функция-коллбек при перходе на view документа
    vm.rowRouteFunc = function (rowData) {
      if (rowData) {
        $state.go('document.view', {
          type: rowData.document_type,
          purpose: rowData.document_purpose,
          id: rowData.id,
          parent: $stateParams.parent
        });
      }
    };

    vm.header = vm.documentsGridSettings.header;
    vm.noDataStr = vm.documentsGridSettings.no_data_str;
    vm.sort = 'date';
    vm.limit = 25;
    vm.status_select_list = $rootScope.documentStatuses;
    vm.columnDefs = userSettingsService.loadProperty(vm.page, 'grid', 'columnsProperty') || getColumnsDef();
    vm.usingService = allDocumentsColumnDefsService;
    vm.filterMeta = {};

    vm.document_purpose_select_list = $rootScope.hasRole($stateParams.type.toLowerCase() + '.write') ?
      _.sortBy($rootScope.findDocumentType($stateParams.type).purposes, 'purpose_name') : [];
    vm.gridConfig = {
      universalDocuments: true,
      purposesFilterOn: true,
      printDocumentActions: documentMetaData.metadata.print_forms,
      documentType: $stateParams.type,
      purposes: vm.document_purpose_select_list || undefined,
      currencies: domainCurrencies,
      defaultColumns: getColumnsDef()
    };
    vm.documentsGridSettings.filters = getFilterSettings();

    function getColumnsDef() {
      var allColumns = allDocumentsColumnDefsService.getColumnDefs.call(vm, uiGridConstants);
      var neededColumns = [];
      function fundColumn(name) {
        return _.find(allColumns, function (item) {
          return item.name === name;
        })
      }
      angular.forEach(vm.documentsGridSettings.columns, function (item) {
        var column = fundColumn(item);
        if (vm.documentsGridSettings.customHeaders) {
          angular.forEach(vm.documentsGridSettings.customHeaders, function (obj) {
            if (obj.column === item) {
              column.displayName = obj.customHeader
            }
          })
        }
        neededColumns.push(column)
      });
      // настройка индексов и индивидуальная настрока полей колонок
      neededColumns.forEach(function (column, i) {
        column.__index = i;
        // RECS-14119 для инвенторизации установка видимости колонкам компании и подразделения + удаление Итого
        if ($stateParams.type == "INVENTORY") {
          if (column.name == "dataValue.company.name" || column.name == "dataValue.division.name") {
            column.visible = true;
          }
          if (column.__index === 1) {
            column.footerCellTemplate = undefined;
          }
        }
      });
      return neededColumns
    }

    function getFilterSettings() { // получаем конкретные фильтры из всех
      var filters = [];
      var filteredColumns = vm.columnDefs.filter(function (item) {
        return item.name.includes('dataValue.')
      }).map(function (item) {
        var filterName = item.name.replace('dataValue.', '').replace('.name', '');
        if (filterName === 'counterparty'
          || filterName === 'project'
          || filterName === 'division'
          || filterName === 'target_division'
          || filterName === 'company'
          || filterName === 'contract'
          || filterName === 'created_by'
          || filterName === 'updated_by'
          || filterName === 'natural_currency') {
          return filterName + '_id'
        }
        return filterName;
      });
      angular.forEach(filterSettings, function (filter) {
        if (~filteredColumns.indexOf(filter.id)) {
          filters.push(filter)
        }
      });
      return filters
    }

    // Get data for selects
    if (companies) {
      this.company_select_list = [];
      companies.forEach(function (item) {
        vm.company_select_list.push({ value: item.id, label: item.name });
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = vm.company_select_list;
        }
      });
    }

    if (divisions) {
      this.division_select_list = [];
      divisions.forEach(function (item) {
        vm.division_select_list.push({ value: item.id, label: item.name });
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name' || column.name === 'dataValue.target_division.name') {
          column.filter.selectOptions = vm.division_select_list;
        }
      });
    }

    if (projects) {
      this.project_select_list = [];
      projects.items.forEach(function (item) {
        vm.project_select_list.push({ value: item.id, label: item.name });
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.project.name') {
          column.filter.selectOptions = vm.project_select_list;
        }
      });
    }

    if (contracts) {
      this.contract_select_list = [];
      contracts.forEach(function (item) {
        vm.contract_select_list.push({ value: item.id, label: '№ ' + item.number + ' от ' + $filter('date')(item.date, 'dd.MM.yyyy') });
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.contract') {
          column.filter.selectOptions = vm.contract_select_list;
        }
      });
    }

    if (counterparties) {
      this.counterparty_select_list = [];
      counterparties.items.forEach(function (item) {
        vm.counterparty_select_list.push({ value: item.id, label: item.name });
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.counterparty.name') {
          column.filter.selectOptions = vm.counterparty_select_list;
        }
      });
    }

    if (employees) {
      this.employee_select_list = [];
      employees.forEach(function (item) {
        vm.employee_select_list.push({ value: item.id, label: item.name });
      });
      vm.created_by_select_list = vm.updated_by_select_list = vm.employee_select_list;
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = vm.employee_select_list;
        }
      });
    }


    if (domainCurrencies) {
      this.natural_currency_select_list = [];
      domainCurrencies.forEach(function (item) {
        vm.natural_currency_select_list.push({ value: item.currency_id, label: item.currency.name });
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.natural_currency.name') {
          column.filter.selectOptions = vm.natural_currency_select_list;
        }
      });
    }

    if (taxChargeTypes) {
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.tax_charge_type') {
          column.filter.selectOptions = taxChargeTypes;
        }
      });
    }

    angular.forEach(vm.columnDefs, function (column) {
      if (column.name === 'dataValue.status') {
        column.filter.selectOptions = vm.status_select_list;
      } else if (column.name === 'dataValue.document_purpose') {
        angular.forEach(vm.document_purpose_select_list, function (type) {
          type.label = type.purpose_name;
          type.value = type.code;
          delete type.purpose_name;
          delete type.code;
        });
        column.filter.selectOptions = vm.document_purpose_select_list;
      }
    });

    // -- End Get data for selects
    angular.forEach(vm.documentsGridSettings.filters, function (filter) {
      if (filter.selectVal) {
        filter.selectVal = vm[filter.id.replace('_id', '') + '_select_list'];
        if (filter.id === 'created_by_id' || filter.id === 'updated_by_id') {
          filter.selectVal = vm.employee_select_list;
        } else if (filter.id === 'target_division_id') {
          filter.selectVal = vm.division_select_list;
        }
      }
    });
    vm.filterMeta = vm.documentsGridSettings.filters;

  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('documentCrudController', documentCrudController);

  /** @ngInject */
  function documentCrudController($state,
                                  $stateParams,
                                  cardHistory,
                                  $filter,
                                  $scope,
                                  $rootScope,
                                  init, // инициализирующие данные
                                  crudsService, // утилитарные вспомогательные методы
                                  type, // тип
                                  purpose, // цель (подтип)
                                  data, // данные документа (при просмотре/редактировании)
                                  errorMessageService,
                                  modalAskSrv,
                                  requestStatus,
                                  documentService, // Сервис для работы с документами
                                  meta, // метаинформация для типа документа (генератора формы), резолвится в роутинге
                                  commonFieldsMeta, // метаинформация для общий полей
                                  settings, // настройки документов
                                  currenciesService,
                                  currencyHome, // валюта учета
                                  priceColumnSrv,
                                  $uibModal,
                                  utilsService,
                                  $window,
                                  $timeout,
                                  catalogService,
                                  $log) {
    var documentCrudCtrl = this;
    documentCrudCtrl.state = $state;
    documentCrudCtrl.rate = undefined;
    documentCrudCtrl.startSaving = true;
    documentCrudCtrl.crudsService = crudsService;
    documentCrudCtrl.settings = settings;
    documentCrudCtrl.currencyHome = currencyHome;
    // режим редактирования (для создания нового документа возможен только режим редактирования)
    documentCrudCtrl.redact = data && data.id ? !data.readonly : true;
    // метаданные документа
    documentCrudCtrl.metainfo = meta;
    documentCrudCtrl.metadata = meta.metadata;
    documentCrudCtrl.commonFieldsMeta = commonFieldsMeta;
    // проборос доп свойств из метадаты в commonFieldMeta
    documentCrudCtrl.commonFieldsMeta.properties = meta.layout.properties;

    documentCrudCtrl.priceSource = [{
      value: "RETAIL",
      label: "Розничного прайс-листа"
    }, {
      value: "WHOLESALE",
      label: "Оптового прайс-листа"
    }, {
      value: "PURCHASE",
      label: "Закупочного прайс-листа"
    }, {
      value: "CONSIGNMENT_NOTE",
      label: "Последней приемки"
    }, {
      value: "STOCK_ITEM_COST",
      label: "Себестоимости "
    }];

    // блок расширяет свойства полей и других компонентов свободно расширяющимися свойствами метаданных (properties)
    var extendProperties = function (item) {
      if (item.code && meta.layout.properties && meta.layout.properties[item.code]) {
        angular.extend(item, meta.layout.properties[item.code]);
      }
      if (item.items) {
        angular.forEach(item.items, extendProperties);
      }
    };
    extendProperties(meta.layout);

    documentCrudCtrl.type = type;
    documentCrudCtrl.roleType = type.toLowerCase();
    documentCrudCtrl.purpose = purpose;
    documentCrudCtrl.filteredDocumentReports = [];
    documentCrudCtrl.docPurpose = _.find(documentCrudCtrl.metadata.purposes, function (purpose) {
      return purpose.code === documentCrudCtrl.purpose;
    });
    // биндинг для валидации формы
    documentCrudCtrl.formValidation; // кастомная часть
    documentCrudCtrl.formCommonValidation; // общая часть


    // Логика конкатенации свойств по-умолчанию из метаинформации и init-данных (не очень понмиаю зачем их разделили на бекенде)
    init = init || {};
    init.values = init.values || (meta.layout.properties && meta.layout.properties.defaults) || {date: moment().utc()};

    // данные модели документа
    documentCrudCtrl.documentData = data && data.values ? data.values : init.values; // специфичные для типа данные
    documentCrudCtrl.documentCommonData = data || init || {date: moment().utc()}; // общие данные (сохраняются иначе)
    documentCrudCtrl.referenceData = angular.copy(documentCrudCtrl.documentCommonData);
    // выставление текущей даты по умолчанию
    if (!documentCrudCtrl.documentCommonData.date) {
      documentCrudCtrl.documentCommonData.date = moment().utc();
    }
    if (documentCrudCtrl.metadata.reports) {
      angular.forEach(documentCrudCtrl.metadata.reports, function (report) {
        if (report.purposes.includes(documentCrudCtrl.purpose)) {
          documentCrudCtrl.filteredDocumentReports.push(report);
        }
      });
    }

    /**
     * RECS-9748 Выставление обязетельному полю 0, которое не отображается на страничке из-за visible_purposes
     */
    if ((documentCrudCtrl.type == 'CASH_PAYMENT' && documentCrudCtrl.purpose !== 'CP_OF_LOAN') ||
      (documentCrudCtrl.type == 'CASH_RECEIPT' && documentCrudCtrl.purpose !== 'CR_FROM_BORROWER') ||
      (documentCrudCtrl.type == 'NON_CASH_PAYMENT' && documentCrudCtrl.purpose !== 'NCP_OF_LOAN') ||
      (documentCrudCtrl.type == 'NON_CASH_RECEIPT' && documentCrudCtrl.purpose !== 'NCR_FROM_BORROWER')) {
      documentCrudCtrl.documentData.natural_interest_amount = 0;
    }

    /**
     * Получение возможности редактировать документ от настроек
     */
    if (documentCrudCtrl.documentCommonData.id) {
      documentCrudCtrl.isExpirationDate = false;
      var expirationDate = moment.utc().subtract(documentCrudCtrl.settings.domain_documents_settings.stop_editing, 'day');
      if (moment(documentCrudCtrl.documentCommonData.date) < expirationDate) {
        documentCrudCtrl.isExpirationDate = true;
      }
    }

    // формирование модели уникальных индексов
    documentCrudCtrl.uniqueIndexes = [];
    _.forEach(documentCrudCtrl.commonFieldsMeta.layout[0].items, function (item) {
      if (item.unique) {
        if (!documentCrudCtrl.uniqueIndexes.hasOwnProperty(item.unique)) {
          documentCrudCtrl.uniqueIndexes[item.unique] = [];
        }
        documentCrudCtrl.uniqueIndexes[item.unique].push(item.code);
      }
    });

    /**
     * Метод получения курса валют
     */
    var oldDate = moment(documentCrudCtrl.documentCommonData.date).millisecond(0);
    var oldCurrency = null;
    documentCrudCtrl.getCurrenciesRate = function () {
      if (documentCrudCtrl.documentCommonData.natural_currency && documentCrudCtrl.documentCommonData.date) {
        var datesAreEqual = oldDate.valueOf() === documentCrudCtrl.documentCommonData.date.valueOf();
        var currenciesAreEqual = oldCurrency && oldCurrency.id === documentCrudCtrl.documentCommonData.natural_currency.id;
        if (datesAreEqual && currenciesAreEqual) {
          return
        }
        currenciesService.getCurrenciesRate(documentCrudCtrl.purpose, documentCrudCtrl.documentCommonData.date.valueOf(), documentCrudCtrl.documentCommonData.natural_currency.id).then(function (res) {
            oldCurrency = documentCrudCtrl.documentCommonData.natural_currency;
            oldDate = documentCrudCtrl.documentCommonData.date;
            documentCrudCtrl.documentCommonData.currency_rate = res.data.currency_rate;
            documentCrudCtrl.documentCommonData.denominator_log10 = res.data.denominator_log10;
            documentCrudCtrl.rate = res.data;
          },
          function () {
            documentCrudCtrl.documentCommonData.currency_rate = undefined;
            documentCrudCtrl.documentCommonData.denominator_log10 = 0;
          });
      }
    }

    // TODO: это еще актуально? почему нельзя в поле вынести эту логику?
    // подстановка валюты учета по умолчанию и курса валют
    if (!documentCrudCtrl.documentCommonData.natural_currency) {
      documentCrudCtrl.documentCommonData.natural_currency = {};
      documentCrudCtrl.documentCommonData.natural_currency.id = documentCrudCtrl.currencyHome.currency.id;
      documentCrudCtrl.documentCommonData.natural_currency.name = documentCrudCtrl.currencyHome.currency.name;
      documentCrudCtrl.documentCommonData.natural_currency.char_iso_code = documentCrudCtrl.currencyHome.currency.char_iso_code;
      documentCrudCtrl.documentCommonData.natural_currency.numeric_iso_code = documentCrudCtrl.currencyHome.currency.numeric_iso_code;
      documentCrudCtrl.documentCommonData.natural_currency.symbol = documentCrudCtrl.currencyHome.currency.symbol;
      documentCrudCtrl.getCurrenciesRate();
    }

    if ((!!$stateParams.source || !!$stateParams.donor || documentCrudCtrl.redact) && !documentCrudCtrl.documentCommonData.currency_rate) { // при копировании документа запрашивает курс валюты
      documentCrudCtrl.getCurrenciesRate();
    }

    // TODO: это еще актуально? почему нельзя в поле вынести эту логику?
    $scope.$watch("documentCrudCtrl.documentCommonData[documentCrudCtrl.commonFieldsMeta.layout[0].items[4].ref[0]]", function (newVal, oldVal) {
      if (newVal instanceof moment && newVal != oldVal) {
        documentCrudCtrl.getCurrenciesRate();
      }
    });

    /**
     * Метод возврата на предыдущее состояние
     */
    var exceptionsTypes = ['BEGINNING_BALANCE_CONTRACT', 'BEGINNING_BALANCE_CASH', 'BEGINNING_BALANCE_NON_CASH'];
    documentCrudCtrl.returnToPage = function () {
      var prev = cardHistory.popStep('id', $state.params.id);
      if (prev) {
        if (prev.name) {
          $state.go(prev.name, prev.param || {parent: $state.params.parent});
        } else {
          documentCrudCtrl.toGridPage();
        }
      } else {
        // переход по-умолчанию
        documentCrudCtrl.toGridPage();
      }
    };

    documentCrudCtrl.toGridPage = function () {
      if (~exceptionsTypes.indexOf(documentCrudCtrl.metadata.document_type.code)) {
        $state.go('allDocuments');
      } else {
        var prev = cardHistory.popStep();
        if (prev) {
          // перезод только если предудущее состояние - список всех документов (т.к. метод - возврат именно к списочному представлению)
          if (prev.name === 'allDocuments') {
            $state.go('allDocuments');
            return;
          }
        }
        $state.go('documents', {type: documentCrudCtrl.metadata.document_type.code, parent: $stateParams.parent});
      }
    };

    // необходимы вотчеры для того чтобы сбросить ошибки при выборе другой спкладской позиции.
    // прямо в компоненте поля не получилось этого сделать,т.к. нет прямого доступа к контроллеру формы
    function watchResetError(derivative) {
      var clearWatch = $scope.$watch(function () {
        return derivative.$modelValue
      }, function (newVal, oldVal) {
        if (newVal && oldVal && (newVal.id !== oldVal.id || (newVal.derivative && oldVal.derivative && newVal.derivative.id !== oldVal.derivative.id))) {
          derivative.$setValidity("wrongCommitent", true);
          derivative.$setValidity("wrongSupplier", true);
          clearWatch();
        }
      })
    }

    // необходим вотчер для того чтобы разрешать сохранять документ, если удалили линейку.
    // diry у формы при этом автоматом не выставляется
    // прямо в компоненте поля не получилось этого сделать,т.к. нет прямого доступа к контроллеру формы

    $scope.$watch(function () {
      return documentCrudCtrl.documentData.lines && documentCrudCtrl.documentData.lines.length
    }, function (newVal, oldVal) {
      if (newVal != oldVal) {
        documentCrudCtrl.documentAllForm.$dirty = true;
      }
    });
    $scope.$watch(function () {
      return documentCrudCtrl.documentData.expense_documents && documentCrudCtrl.documentData.expense_documents.length
    }, function (newVal, oldVal) {
      if (newVal != oldVal) {
        documentCrudCtrl.documentAllForm.$dirty = true;
      }
    });
    $scope.$watch(function () {
      return documentCrudCtrl.documentData.advance_documents && documentCrudCtrl.documentData.advance_documents.length
    }, function (newVal, oldVal) {
      if (newVal != oldVal) {
        documentCrudCtrl.documentAllForm.$dirty = true;
      }
    });


    /**
     * Метод сохранения универсального документа
     */
    documentCrudCtrl.save = function (skipReturning, noUpdate) {
      // при сохранении все поля подсветить, если они того требуют
      $timeout(function(){
        utilsService.setTouched(documentCrudCtrl.documentAllForm);
      }, 0);
      // проверка валидности строк в гриде, учитывая те, которые на других страничках пэйджинга
      if (documentCrudCtrl.documentAllForm.$invalid || (documentCrudCtrl.checkValid && !documentCrudCtrl.checkValid())) {
        documentCrudCtrl.documentAllForm.meta.$setDirty();
        documentCrudCtrl.isSaved = true;
        return;
      }
      
      documentCrudCtrl.isSaved = false;
      documentCrudCtrl.startSaving = true;
      documentCrudCtrl.documentCommonData.acc_date = undefined;
      documentCrudCtrl.documentCommonData.date = documentCrudCtrl.documentCommonData.date.clone().second(0).millisecond(0).valueOf();

      _.forEach(documentCrudCtrl.documentData, function (item, key) {
        if (moment.isMoment(item) && !item.isEmpty) {
          documentCrudCtrl.documentData[key] = item.clone().second(0).second(0).millisecond(0).valueOf();
        } else if (moment.isMoment(item) && item.isEmpty) {
          documentCrudCtrl.documentData[key] = null
        }
      });

      function isInvalid(array, invalidParameter) {
        return !!array.find(function (value) {
          return value.name === invalidParameter
        });
      }

      //Создание или обновление (сервис сам выбирает необходимый метод)
      return documentService.saveOrUpdateDocument(
        documentCrudCtrl.metadata.document_type.code, // тип
        documentCrudCtrl.purpose, // цель, подтип
        documentCrudCtrl.documentCommonData, // общие данные, структура идентична для свех документов
        documentCrudCtrl.documentData, // специфичные для текущего типа данные
        $state.params.donor // идентификатор документа-донора
      ).then(function (res) {
        documentCrudCtrl.documentAllForm.$setPristine();
        if (!skipReturning) {
          documentCrudCtrl.returnToPage();
        } else if (!noUpdate) {
          $state.go('document.view', {
            type: documentCrudCtrl.metadata.document_type.code,
            purpose: documentCrudCtrl.purpose,
            id: documentCrudCtrl.documentCommonData.id,
            parent: $state.params.parent || 'money'
          }, {reload: true});
        }
        return res;
      }).catch(function (err) {

        if (err.status === 409) {
          if (err.data.code === 'non_unique') {
            if (isInvalid(err.data.parameters, 'date') && isInvalid(err.data.parameters, 'number') &&
              isInvalid(err.data.parameters, 'company') && isInvalid(err.data.parameters, 'type')) {
              errorMessageService.showModal({
                message: 'При сохранении произошла ошибка', submessage: {
                  data: {
                    message: $filter('documentType')(documentCrudCtrl.metadata.document_type.code) + ' №' + documentCrudCtrl.documentCommonData.number + ' от ' + moment.utc(documentCrudCtrl.documentCommonData.date).format('DD MMMM YYYY') + ' для компании ' + documentCrudCtrl.documentCommonData.company.name + ' уже существует.'
                  }
                }
              });
            }
            // проверка уникальности строк
            if (err.data.constraint_name === "DOCUMENT_LINE") {
              var lotSnError = err.data.parameters[0];
              var derivativeError = err.data.parameters[3];
              var catalogItemError = err.data.parameters[2];
              var form = documentCrudCtrl.documentAllForm['documentCtrl.documentForm'];
              _.forEach(form, function (val, name) {
                if (name.indexOf('rowForm') + 1) {
                  if (val[derivativeError.name] && val[derivativeError.name].$modelValue && val[derivativeError.name].$modelValue.derivative &&
                    val[derivativeError.name].$modelValue.derivative.id === derivativeError.value) {
                    val[derivativeError.name].$setValidity("unique", false);
                  }
                  if (val[catalogItemError.name] && val[catalogItemError.name].$modelValue &&
                    val[catalogItemError.name].$modelValue.id === catalogItemError.value) {
                    val[catalogItemError.name].$setValidity("unique", false);
                  }
                  if (val[lotSnError.name] && val[lotSnError.name].$modelValue &&
                    val[lotSnError.name].$modelValue.id === lotSnError.value) {
                    val[lotSnError.name].$setValidity("unique", false);
                  }
                }
              });
            }
          }
        } else {
          if (err.status == 400 && err.data.fields && err.data.fields[0].error) {
            if (err.data.fields[0].error.indexOf("Direct cost document not PROCESSED, id:") + 1) {
              $uibModal.open({
                templateUrl: 'app/settings/templates/modals/info.html',
                size: 'small-width',
                controller: function ($scope, $uibModalInstance) {
                  $scope.title = 'Изменение невозможно';
                  $scope.text = "Добавлен непроведенный документ";
                  $scope.close = function () {
                    $uibModalInstance.dismiss();
                  };
                }
              });
            } else {
              // строка для необходимых ошибок
              var errorStr = (err.data.fields[0].error == 'No committent derivative') ? 'wrongCommitent' : 'wrongSupplier';
              // установка вотчера на сброс ошибок
              if (documentCrudCtrl.documentAllForm.meta['rowForm' + err.data.fields[0].field.split('.')[1]]) {
                watchResetError(documentCrudCtrl.documentAllForm.meta['rowForm' + err.data.fields[0].field.split('.')[1]].derivative);


                // установленный вотчер срабатывает позже, поэтому тут $timeout, чтобы установилась ошибка во время
                $timeout(function () {
                  documentCrudCtrl.documentAllForm.meta['rowForm' + err.data.fields[0].field.split('.')[1]].derivative.$setValidity(errorStr, false);
                }, 0)
              } else if (err.data.fields[0].field == "date" && err.data.fields[0].error.indexOf("Editing days:")) {
                $uibModal.open({
                  templateUrl: 'app/settings/templates/modals/info.html',
                  size: 'small-width',
                  controller: function ($scope, $uibModalInstance) {
                    $scope.title = "Произошла ошибка";
                    $scope.text = "Нельзя сохранить документ, так как указанная дата документа не попадает в разрешенный период создания и редактирования документов.<br><br>Измените период в настройках документов и повторите попытку.";
                    $scope.close = function () {
                      $uibModalInstance.dismiss();
                    };
                  }
                });
              } else {
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: err});
              }
            }

          }
          if (err.status !== 500 && err.status !== 400) {
            errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: err});
          }
        }
        documentCrudCtrl.startSaving = false;
      });
    };

    /**
     * Удаление документа
     */
    documentCrudCtrl.delete = function () {
      documentCrudCtrl.startSaving = true;
      modalAskSrv.showModal({
        title: 'Вы действительно хотите удалить документ?'
      }).then(function () {
        documentService.deleteDocument(documentCrudCtrl.documentCommonData.id).then(function () {
          documentCrudCtrl.documentAllForm.$dirty = false;
          // в случае успеха - переход на список
          $state.go('documents', {type: documentCrudCtrl.metadata.document_type.code, parent: $state.params.parent});
        }).catch(function (err) {
          documentCrudCtrl.startSaving = false;
          errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: err});
        });
      });
    };

    /**
     * Провести документ
     */
    documentCrudCtrl.process = function () {
      documentCrudCtrl.save(true, true).then(function (data) {
        if (data) {
          documentCrudCtrl.documentData = data.data.values; // специфичные для типа данные
          documentCrudCtrl.documentCommonData = data.data; // общие данные (сохраняются иначе)
          documentCrudCtrl.referenceData = angular.copy(documentCrudCtrl.documentCommonData);
          documentService.processDocument([documentCrudCtrl.documentCommonData.id]).then(function () {
              documentCrudCtrl.documentAllForm.$pristine = true;
              documentCrudCtrl.documentAllForm.$dirty = false;
              $state.go('document.view', {
                type: documentCrudCtrl.metadata.document_type.code,
                purpose: documentCrudCtrl.purpose,
                id: documentCrudCtrl.documentCommonData.id,
                parent: $stateParams.parent || 'money'
              }, {reload: true});
            },
            function (err) {
              errorMessageService.showModal({message: 'Документ провести не удалось', submessage: err});
            });
        }
      });
    };

    /**
     * Отменить проведение документа
     */
    documentCrudCtrl.rollback = function () {
      return modalAskSrv.showModal({
        title: 'После отмены проведеления документ не будет отражаться в финансовых проводках и он станет доступным для редактирования или удаления. <br><br>Вы действительно хотите отменить проведение документа?'
      }).then(function () {
        return documentService.rollbackDocument([documentCrudCtrl.documentCommonData.id]).then(function () {
          documentCrudCtrl.documentCommonData.status = 'IN_PROCESS';
        });
      }).catch(function (err) {
        if ((err.status === 409 && err.data.code === 'there_are_additional_costs') || (err.status === 400 && err.data.code === 'advance_report_is_related')) {
          $uibModal.open({
            templateUrl: 'app/settings/templates/modals/info.html',
            size: 'small-width',
            controller: function ($scope, $uibModalInstance) {
              $scope.title = 'Отмена проведения невозможна';
              $scope.text = "Отмена проведения документа невозможна, так как на него заведены дополнительные затраты";
              if (err.status === 400) {
                $scope.text = "Отмена проведения документа невозможна, так как с ним связаны другие документы";
              }
              $scope.close = function () {
                $uibModalInstance.dismiss();
              };
            }
          });
        } else {
          errorMessageService.showModal({message: 'При отмене проведения произошла ошибка', submessage: err});
        }
      });
    };

    function copyDocument() {
      $window.open($state.href('document.new', {
        source: documentCrudCtrl.documentCommonData.id,
        type: documentCrudCtrl.type,
        purpose: documentCrudCtrl.purpose,
        parent: $state.params.parent
      }), '_blank');
    }

    documentCrudCtrl.copyHandler = function () {
      if (documentCrudCtrl.documentAllForm.$pristine) {
        copyDocument()
      } else {
        modalAskSrv.showModal({
          title: 'Есть несохраненные изменения. Новый документ будет создан только по сохраненным данным.'
        }).then(copyDocument);
      }
    };

    /**
     * Получить просклоненное слово "Новый", в зависимости от параметра
     */
    documentCrudCtrl.getNewWord = function (gender) {
      var newWord = '';
      switch (gender) {
        case 'MALE':
          newWord = 'Новый';
          break;
        case 'FEMALE':
          newWord = 'Новая';
          break;
        case 'PLURAL':
          newWord = 'Новые';
          break;
        case 'NEUTER':
          newWord = 'Новое';
          break;
        default:
          ''
      }
      return newWord;
    };

    /**
     * Открывает модельное окно добавления товаров в прайс-лист
     */
    documentCrudCtrl.openToPriceListModal = function () {
      var priceLoadResultModal = $uibModal.open({
        size: 'middle-width',
        component: 'documentToPriceList',
        controllerAs: '$ctrl',
        resolve: {
          purchaseColumns: function () {
            return priceColumnSrv.priceColumns('PURCHASE');
          },
          homeCurrency: function () {
            return currenciesService.getDomainCurrencies().then(function (res) {
              var homeCurrencyId = 0;
              angular.forEach(res.data.items, function (item) {
                if (item.home_currency) {
                  homeCurrencyId = item.currency_id;
                }
              });
              return {
                id: homeCurrencyId
              }
            });
          },
          prices: function () {
            // фильтрация непустых значений
            return _.map(_.filter(documentCrudCtrl.documentData['lines'], function (line) {
              return line && line.derivative && (line.natural_price != undefined || line.price != undefined) && line.quantity != undefined;
            }), function (line) {
              return {
                item: {
                  "id": line.derivative.id,
                  "name": line.derivative.name
                },
                price: line.natural_price || line.price,
                quantity: line.quantity
              }
            });
          }
        }
      });
      priceLoadResultModal.result.then(function () {
        requestStatus.success("Товары и цены добавлены в закупочный прайс-лист", false, "Перейти в прайс-лист", "#/price-list?parent=PURCHASE");
      }, function (error) {
        if (error) {
          requestStatus.error("Во время добавления товаров и цен в закупочный прайс-лист произошла ошибка. Повторите попытку позже");
        }
      })
    };

    /**
     * Открывает модальное окно печати
     *
     * @param chosenPrintForm
     */
    function printDocument(chosenPrintForm) {
      $uibModal.open({
        size: 'middle-width',
        component: 'documentPrint',
        controllerAs: '$ctrl',
        resolve: {
          printForm: chosenPrintForm,
          documentId: function () {
            return data.id
          },
          documentProperties: function () {
            return documentCrudCtrl.commonFieldsMeta.properties
          }
        }
      });
    }


    // Метод вызова попапа печати
    documentCrudCtrl.printDocument = function (chosenPrintForm) {
      if (documentCrudCtrl.documentAllForm.$pristine) {
        printDocument(chosenPrintForm)
      } else {
        modalAskSrv.showModal({
          title: 'Есть несохраненные изменения. Выходная форма сформируется только по сохраненным данным.'
        }).then(function () {
          printDocument(chosenPrintForm)
        });
      }
    };

    function printReport(chosenReportName) {
      if (documentCrudCtrl['open' + chosenReportName + 'PrintModal']) {
        documentCrudCtrl['open' + chosenReportName + 'PrintModal']();
      } else {
        // TODO задел на будущее
        $log.error('There is no handler for', chosenReportName, 'report')
      }
    }

    // метод вызова отчета
    documentCrudCtrl.openReport = function (chosenReportName) {
      if (documentCrudCtrl.documentAllForm.$pristine) {
        printReport(chosenReportName)
      } else {
        modalAskSrv.showModal({
          title: 'Есть несохраненные изменения. Отчет сформируется только по сохраненным данным.'
        }).then(function () {
          printReport(chosenReportName)
        });
      }
    };

    // Метод вызова попапа печати этикеток
    documentCrudCtrl.openINVENTORY_TAGSPrintModal = function () {
      $uibModal.open({
        size: 'large-width',
        component: 'printInventoryTags',
        controllerAs: '$ctrl',
        resolve: {
          type: function () {
            return 'byDocument'
          },
          params: function () {
            return [data.id]
          }
        }
      });
    };

    documentCrudCtrl.uniqueCheck = function () {
      if (documentCrudCtrl.documentAllForm && documentCrudCtrl.documentAllForm.commonData) {
        _.forEach(documentCrudCtrl.uniqueIndexes.checkDocUnique, function (index) {
          if (documentCrudCtrl.documentAllForm.commonData[index]) {
            documentCrudCtrl.documentAllForm.commonData[index].$setValidity('unique', true);
          }
        });
      }

      if (documentCrudCtrl.documentCommonData.date &&
        documentCrudCtrl.documentCommonData.number &&
        documentCrudCtrl.documentCommonData.company &&
        documentCrudCtrl.documentCommonData.company.id &&
        documentCrudCtrl.metadata.document_type.code) {
        var obj = {
          'constraint_name': 'DOCUMENT',
          'parameters': [{
            'name': 'date',
            'value': (typeof documentCrudCtrl.documentCommonData.date == 'number') ? documentCrudCtrl.documentCommonData.date : documentCrudCtrl.documentCommonData.date.clone().second(0).millisecond(0).valueOf()
          }, {
            'name': 'number',
            'value': documentCrudCtrl.documentCommonData.number
          }, {
            'name': 'company',
            'value': documentCrudCtrl.documentCommonData.company.id
          }, {
            'name': 'type',
            'value': documentCrudCtrl.metadata.document_type.code
          }
          ]
        };
        obj.id = documentCrudCtrl.documentCommonData.id || null;
        utilsService.uniqueCheck(obj).then(function () {
          },
          function (error) {
            if (error.status === 409 && error.data.code === 'non_unique') {
              angular.forEach(error.data.parameters, function (field) {
                if (field.name !== "type") {
                  if (field.name == "date") {
                    for(var property in documentCrudCtrl.documentAllForm.commonData) {
                      if (property.indexOf('date') + 1) documentCrudCtrl.documentAllForm.commonData[property].$setValidity('unique', false);
                    }
                  } else {
                    documentCrudCtrl.documentAllForm.commonData[field.name].$setValidity('unique', false);
                  }
                }
              });
            }
          });
      }
    };

    // вотчет на проверку заполнения полей, котрые относятся к проверке уникальности.
    $scope.$watchCollection(
      function () {
        return _.map(documentCrudCtrl.uniqueIndexes.checkDocUnique, function (index) {
          return documentCrudCtrl.documentCommonData[index];
        });
      },
      function (newVal) {
        if (newVal[0] && newVal[1] && newVal[2]) {
          documentCrudCtrl.uniqueCheck();
        }
      }
    );

    documentCrudCtrl.resetData = function () {
      var prev = cardHistory.popStep();
      if (documentCrudCtrl.documentAllForm.$dirty) {
        $uibModal.open({
          templateUrl: 'app/settings/templates/modals/one-question.html',
          size: 'small-width',
          controller: function ($scope, $uibModalInstance) {
            $scope.text = "Вы действительно хотите отменить выполненные изменения?";
            $scope.title = "Предупреждение";
            $scope.close = function () {
              $uibModalInstance.dismiss();
            };
            $scope.action = function () {
              documentCrudCtrl.documentAllForm.$setPristine()
              $uibModalInstance.dismiss();
              prev = cardHistory.popStep();
              if(prev && prev.name){
                $state.go(prev.name, prev.param);
              } else {
                documentCrudCtrl.toGridPage();
              }
            };
          }
        });
      } else {
        prev = cardHistory.popStep();
        if(prev && prev.name){
          $state.go(prev.name, prev.param);
        } else {
          documentCrudCtrl.toGridPage();
        }
      }
    };

    // необходимо знать каким типом товара оперирует документ - деривативом или нет,
    // чтобы предложенные варианты из орзины соответствовали
    _.forEach(documentCrudCtrl.metainfo.layout.items, function (block) {
      if (block.type == 'table') {
        _.forEach(block.fields, function (field) {
          if (field.field_type == 'FLD_SKU_SERVICE_DERIVATIVE' || field.field_type == 'FLD_SKU_DERIVATIVE') {
            documentCrudCtrl.isDerivative = true;
          } else if (field.field_type == 'FLD_CATALOG_ITEM' || field.field_type == 'FLD_STOCK_ITEM') {
            documentCrudCtrl.isDerivative = false;
          }
        });
      }
    });

    documentCrudCtrl.addItemToLines = function (newItem) {
      documentCrudCtrl.documentData.lines.push(newItem);
      // очистка пустых строк при добавлении элементов из корзины
      if (documentCrudCtrl.documentData.lines.length > 1) {
        documentCrudCtrl.documentData.lines = _.filter(documentCrudCtrl.documentData.lines, function (line) {
          return !(line._manual === false);
        });
      }
      documentCrudCtrl.documentAllForm.$setDirty();
    }

    documentCrudCtrl.cartPopup = function () {
      var modal = $uibModal.open({
        size: 'large-width',
        component: 'cartPopup',
        controllerAs: 'cartPopupCtrl',
        resolve: {
          selectiveAdd: function () {
            return !!documentCrudCtrl.documentCommonData.status
          },
          isDerivative: function () {
            return documentCrudCtrl.isDerivative;
          },
          purpose: function () {
            return documentCrudCtrl.purpose;
          }
        }
      });
      modal.result.then(function (res) {
        var catalogItemName = documentCrudCtrl.isDerivative ? 'derivative' : 'catalog_item';
        _.forEach(res, function (catalogItem) {
          // проверка на существующий товаров документе? возможно понадобится, но это не точно
          var newItem = {
            natural_price: catalogItem.home_price,
            price: catalogItem.home_price,
            quantity: (catalogItem.quantity < 0) ? 0 : catalogItem.quantity,
            tax_group: catalogItem.tax_group,
            uom: catalogItem.uom
          };
          newItem[catalogItemName] = {
            derivative: catalogItem.derivative,
            id: catalogItem.catalog_item.id,
            name: catalogItem.catalog_item.name,
            tax_group: catalogItem.tax_group,
            uom: { id: catalogItem.uom.id, name: catalogItem.uom.name }
          };
          if (documentCrudCtrl.documentCommonData.natural_currency.id !== $rootScope.homeCurrency.currency.id) {
            newItem.natural_price = Math.round(newItem.natural_price / documentCrudCtrl.documentCommonData.currency_rate);
            newItem.price = Math.round(newItem.price / documentCrudCtrl.documentCommonData.currency_rate);
          }

          // RECS-14422 отдельно запрос дериватива,если его нет
          if (!catalogItem.derivative) {
            catalogService.searchDerivatives(catalogItem.catalog_item.id).then(function (res) {
              if (res.data.items[0]) {
                newItem[catalogItemName].derivative = {
                  id: res.data.items[0].id,
                  code: res.data.items[0].code
                };
                newItem[catalogItemName].stock_accounting_type = res.data.items[0].stock_accounting_type;
              }
              documentCrudCtrl.addItemToLines(newItem);
            });
          } else {
            documentCrudCtrl.addItemToLines(newItem);
          }
        });

      });
    }

    documentCrudCtrl.importFromFile = function () {
      var modal = $uibModal.open({
        size: 'large-width',
        component: 'importFromFile',
        controllerAs: 'importFromFileCtrl',
        resolve: {
        }
      });
      modal.result.then(function (res) {
        documentCrudCtrl.documentData.lines = res.map(function (line) {
          if (line.catalog_item) {
            line.derivative = line.catalog_item;
            line.price = line.natural_price || line.price;
            line.catalog_item = undefined;
          }
          return line;
        });
        documentCrudCtrl.documentData.isImported = true;
        documentCrudCtrl.documentAllForm.$setDirty();
      });
    }

    // автоподстановка цен, при смене источника
    documentCrudCtrl.autoPrice = function (source) {
      if (!documentCrudCtrl.documentData.lines.length) return;
      // подготовка параметров для запроса цен
      var params = {
        document_price_source: source,
        document_purpose: documentCrudCtrl.purpose,
        document_date: documentCrudCtrl.documentCommonData.date.valueOf(),
        division: documentCrudCtrl.documentData.division,
        counterparty: documentCrudCtrl.documentData.counterparty,
        document_currency: {
          id: documentCrudCtrl.documentCommonData.natural_currency.id,
          name: documentCrudCtrl.documentCommonData.natural_currency.name
        },
        lines: []
      };
      _.forEach(documentCrudCtrl.documentData.lines, function (line) {
        if (line.derivative || line.catalog_item) {
          var catalogItem = (line.derivative) ? line.derivative : line.catalog_item;
          var lineData = {
            domain_catalog_item: {
              id: catalogItem.id,
              name: catalogItem.name
            },
            quantity: line.quantity,
            uom: line.uom
          };
          if (line.derivative && line.derivative.derivative) {
            lineData.derivative = line.derivative.derivative;
          }
          if (line.catalog_item && line.catalog_item.derivative) {
            lineData.derivative = line.catalog_item.derivative;
          }
          // установка налога
          if (line.tax_group) {
            lineData.tax_group = line.tax_group;
          } else {
            lineData.tax_group = (line.derivative) ? line.derivative.tax_group : line.catalog_item.tax_group;
          }
          params.lines.push(lineData);
        }
      });
      // запрос на цены
      documentService.documentsPrices(params).then(function (res) {
        // выставляем цены
        _.forEach(res.data.lines, function (resLine) {
          var lineForPrice = _.find(documentCrudCtrl.documentData.lines, function (line) {
            if (!line.derivative && !line.catalog_item) return false;
            var match = false;
            if ((line.derivative && resLine.domain_catalog_item.id == line.derivative.id) ||
              (line.catalog_item && resLine.domain_catalog_item.id == line.catalog_item.id)) {
              match = true;
            } else {
              return false;
            }
            if (!line.derivative || !line.derivative.derivative) {
              return match;
            }
            return resLine.derivative.id == line.derivative.derivative.id;
          });
          lineForPrice.price = (resLine.prices.length) ? resLine.prices[0].price : 0;
          lineForPrice.natural_price = lineForPrice.price || lineForPrice.natural_price;
        });
      });
    }


  }
})();

(function() {
  'use strict';

  angular
      .module('frontend')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .factory('uiSelectStructure', function($rootScope) {
      return {
        getStructure: function (method, model, avoidDataAccessRules, expandCompanyRef) {
          var obj = {
            field:{},
            refresh: function (search) {
              return method(search || undefined, null, avoidDataAccessRules, expandCompanyRef)
                .then(function (res) { obj.onRefreshSuccess(res, search)})
            },
            getSearchEnabled: function (selectCtrl) {
              return this.field.total > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH || selectCtrl.search !== ''
            },
            getDisabled: function (selectCtrl) {
              return this.field.total === 0;
            },
            onRefreshSuccess: function(res, search) {
              obj.field = res.data;
              if(obj.field.items.length === 1 && !search && model){
                model = obj.field.items[0];
              }
            }
          };

          return obj
        }
      } // return end
    })
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('tooltipTextDepend',function () {
      return {
      restrict: 'E',
      replace:true,
      scope: {
        text: '<',
        placement: '@',
        classes: '@?'
      },
      templateUrl: 'app/components/tooltip-text-depend/tooltip-text-depend.html',
      controller: function($scope,$element,$timeout) {
        $timeout(function () {
          var parent = angular.element($element.parent()[0]),
            siblingsWidth = 0;

          function checkWidth() {
            siblingsWidth = 0;
            for (var i = 0; i < parent.children().length; i++) {
              siblingsWidth += angular.element(parent.children()[i])[0].offsetWidth
            }
            $scope.isFits = parent[0].offsetWidth < siblingsWidth; //сравнение ширины
          }

          $scope.$watch('text', function() { // вотч на текст ячейки
            checkWidth()
          });
        })
      }//link end
    }
    } );//directive ends

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('timezone', timezone);

  /** @ngInject */
  function timezone() {
    var directive = {
          restrict: 'E',
          templateUrl: 'app/components/timezone/timezone.html',
          scope: {
              timezoneData: '=',
              fieldLabel: '<?',
              allowClear: '<?',
              autoTimezone: '<?',
              ngRequired: '<?',
              ngDisabled: '<?'
          },
          controller: timezoneController,
          controllerAs: 'vm',
          bindToController: true
        };
    return directive;

    function timezoneController($scope, auth) {
      var vm = this;

      function init(timezoneId) {
        auth.getTimezones()
          .then(function (res) {
            vm.timezones = res.data;
            if (timezoneId) {
              angular.forEach(vm.timezones, function (zone) {
                if (zone.timezoneId === timezoneId) {
                  vm.timezoneData = zone;
                }
              });
            }else{
              var currentTimezone = new Date().getTimezoneOffset();
              currentTimezone = (currentTimezone/60) * -1;
              var gmt = '';
              if (currentTimezone !== 0) {
                gmt += currentTimezone > 0 ? '+' : ' ';
                gmt += currentTimezone > 10 ? currentTimezone : '0' + currentTimezone;
                gmt += ':00';
              }
              vm.timezoneData = _.find(vm.timezones, function(obj) {
                return obj.offset === gmt
              });
            }

          });
      }
      if(vm.autoTimezone){
        auth.ensureSession().then(function() {
          auth.ensureUserData().then(function (res) {
            var timezone;
            if (res.data.user && res.data.user.time_zone) {
              timezone = angular.isString(res.data.user.time_zone) ? res.data.user.time_zone : res.data.user.time_zone.timezoneId;
            }
            init(timezone);
          })
        });
      }else{
        init(vm.timezoneData);
      }

    }
  }
})();

(function() {
  'use strict';

  angular
  .module('frontend')
  .directive('timezoneNoAuth', timezone);

  /** @ngInject */
  function timezone() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/timezone/timezone.html',
      scope: {
        timezoneData: '=',
        fieldLabel: '<?',
        ngRequired: '<?'
      },
      controller: timezoneController,
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

    function timezoneController($scope, auth) {
      var vm = this;

      function init() {
        auth.getTimezones()
        .then(function (res) {
          vm.timezones = res.data;
          var currentTimezone = new Date().getTimezoneOffset();
          currentTimezone = (currentTimezone/60) * -1;
          var gmt = '';
          if (currentTimezone !== 0) {
            gmt += currentTimezone > 0 ? '+' : ' ';
            gmt += currentTimezone > 10 ? currentTimezone : '0' + currentTimezone;
            gmt += ':00';
          }
          vm.timezoneData = _.find(vm.timezones, function(obj) {
            return obj.offset === gmt;
          });
        });
      }

      auth.ensureSession().then(function() {
        init()
      });

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('timer', timer);

  function timer($interval) {
    var directive = {
          restrict: 'EA',
          templateUrl: 'app/components/timer/timer.html',
          scope: {
              start: '=', // начало отсчета
              duration: '<', // продолжительность в секундах
              isEnd: '=' // флаг окончаия таймера
          },
          controller: timerController,
          controllerAs: 'timerCtrl',
          bindToController: true
        };
    return directive;

    function timerController($scope) {
      var timerCtrl = this;
      timerCtrl.minutes = 0;
      timerCtrl.seconds = 0;

      // добавление нулей к однозначным чсилам
      timerCtrl.addZero = function (val) {
        return (val < 10)? '0' + val : val;
      }

      // если старт изменился, то поехали считать
      $scope.$watch('timerCtrl.start', function(newVal, oldVal) {
          timerCtrl.isEnd = false;
          timerCtrl.minutes = (timerCtrl.duration / 60).toFixed(0);
          timerCtrl.seconds = timerCtrl.duration % 60;

          timerCtrl.timer = $interval(function () {
            timerCtrl.seconds--;
            if (!timerCtrl.seconds) {
              if (!timerCtrl.minutes && !timerCtrl.seconds) {
                $interval.cancel(timerCtrl.timer);
                timerCtrl.timer = undefined;
                timerCtrl.isEnd = true;
                return;
              }
              timerCtrl.minutes--;
              timerCtrl.seconds = 59;
            }
          }, 1000);
      });

      // очиста интервала если контроллер прервался
      timerCtrl.$onDestroy = function() {
        if (timerCtrl.timer) {
          $interval.cancel(timerCtrl.timer);
          timerCtrl.timer = undefined;
        }
      };

    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('statusButton', statusButton);

  function statusButton() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/status-button/status-button.html',
      scope: {
        mode: '<',
        startProcessing: '<',
        cancelProcessing: '<'
      },
      link: function ($scope) {
        function setButtonName(mode) {
          var name = '';
          switch (mode) {
            case 'PROCESSED':
              name = 'Отменить проведение';
              $scope.action = $scope.cancelProcessing;
              break;
            case 'DRAFT':
              name = 'Провести';
              $scope.action = $scope.startProcessing;
              break;
            default :
              name = 'Статус';
              $scope.action = function() {};
              break;
          }
          $scope.buttonName = name;
        }

        $scope.$watch('mode', function(val) {
          setButtonName(val);
        });

      }
    };

    return directive;
  }
})();

(function() {
  'use strict';

  /**
   * Директива заставляет скролироваться на элемент при добавлении в DOM (в link)
   */
  angular
    .module('frontend')
    .directive('scrollOnCreate', scrollOnCreate);

  /** @ngInject */
  function scrollOnCreate() {
    return {
      restrict: 'A',
      link: function($scope, element) {
        $('html,body').animate({scrollTop: element[0].getBoundingClientRect().top}, "slow");
      } //link end
    } // return end
  } // function end
})();

angular.module('frontend')
       .component('reportPeriod', {
         bindings: {
           startDate: '=',
           endDate: '='
         },
         templateUrl: 'app/components/reportPeriod/report-period.html',
         controllerAs: 'reportPeriodCtrl',
         controller: function ($scope, $timeout, focus, $state) {
           var reportPeriodCtrl = this;
            reportPeriodCtrl.today = moment();
            reportPeriodCtrl.setReportInterval = function (intervalStr) {
              switch (intervalStr) {
                case "yestarday":
                  reportPeriodCtrl.startDate = moment().utc().subtract(1, 'days').set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().subtract(1, 'days').set({hour:0,minute:0,second:0,millisecond:0});
                  break;
                case "last month":
                  reportPeriodCtrl.startDate = moment().utc().subtract(1, 'months').startOf('month').set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().subtract(1, 'months').endOf('month').set({hour:0,minute:0,second:0,millisecond:0});
                  break;
                case "last quarter":
                  reportPeriodCtrl.startDate = moment().utc().subtract(1, 'quarter').startOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().subtract(1, 'quarter').endOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
                  break;
                case "last year":
                  reportPeriodCtrl.startDate = moment().utc().subtract(1, 'year').startOf('year').set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().subtract(1, 'year').endOf('year').set({hour:0,minute:0,second:0,millisecond:0});
                  break;
                case "today":
                  reportPeriodCtrl.startDate = moment().utc().set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().set({hour:0,minute:0,second:0,millisecond:0});
                  break;
                case "this month":
                  reportPeriodCtrl.startDate = moment().utc().startOf('month').set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().endOf('month').set({hour:0,minute:0,second:0,millisecond:0});
                  break;
                case "this quarter":
                  reportPeriodCtrl.startDate = moment().utc().startOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().endOf('quarter').set({hour:0,minute:0,second:0,millisecond:0});
                  break;
                case "this year":
                  reportPeriodCtrl.startDate = moment().utc().startOf('year').set({hour:0,minute:0,second:0,millisecond:0});
                  reportPeriodCtrl.endDate = moment().utc().endOf('year').set({hour:0,minute:0,second:0,millisecond:0});
                  break;
              }
            }
           
         }
       });

'use strict';

angular.module('frontend').service( 'personsDataSrv', function ($http, API_URL, $log) {

  function createPersonSuccess(res) {
    $log.log(res);
  }

  function getPersonsListSuccess(res) {
    $log.log(res);
  }

  function deletePersonSuccess(res) {
    $log.log(res);
  }

  function getPersonDataSuccess(res) {
    $log.log(res);
  }

  function updatePersonDataSuccess(res) {
    $log.log(res);
  }

  function getPersonAccountListSuccess(res) {
    $log.log(res);
  }

  function addPersonAccountSuccess(res) {
    $log.log(res);
  }

  function deletePersonAccountSuccess(res) {
    $log.log(res);
  }

  function updatePersonAccountSuccess(res) {
    $log.log(res);
  }

  function searchSuccess(res) {
    $log.log(res);
  }

  function getReferencesSuccess(res) {
    $log.log(res);
  }

  this.getBankInfo = function (bik) {
    return $http.get(API_URL + '/utils/bank_info', {
      params: {
        search_string: bik,
        limit: 5
      }
    }).success(getBankInfoSuccess);
  };

  this.createPerson = function (model) {
    return $http.post(API_URL + '/persons', model).success(createPersonSuccess);
  };

  this.getPersonsList = function (offset,limit,searchText) {
    limit = limit || 10;
    searchText = searchText||'';
      return $http.get(API_URL + '/persons',{
        params:{
          offset: offset,
          limit: limit,
          search_string: searchText
        }
      }).success(getPersonsListSuccess);
  };

  this.deletePerson = function (personID) {
    return $http.delete(API_URL + '/persons/' + personID, {} ).success(deletePersonSuccess);
  };

  this.getPersonData = function (personID) {
    return $http.get(API_URL + '/persons/' + personID, {}).success(getPersonDataSuccess);
  };

  this.updatePersonData = function (personID, newData) {
    return $http.put(API_URL + '/persons/' + personID, newData).success(updatePersonDataSuccess);
  };

  this.getPersonAccountList = function (personID) {
    return $http.get(API_URL + '/persons/' + personID + '/accounts',{}).success(getPersonAccountListSuccess);
  };

  this.addPersonAccount = function (personID, newAccountData) {
    return $http.post(API_URL + '/persons/' + personID + '/accounts',newAccountData).success(addPersonAccountSuccess);
  };

  this.deletePersonAccount = function (personID, accountID) {
    return $http.delete(API_URL + '/persons/' + personID + '/accounts/' + accountID,{}).success(deletePersonAccountSuccess);
  };

  this.updatePersonAccount = function (personID, accountID, newAccountData) {
    return $http.put(API_URL + '/persons/' + personID + '/accounts/' + accountID, newAccountData).success(updatePersonAccountSuccess);
  };

  this.search = function (searchText) {
    return $http.get(API_URL + '/persons?search_string='+ searchText).success(searchSuccess);
  };

  this.getReferences = function (personID) {
    return $http.get(API_URL + '/persons/'+ personID +'/references').success(getReferencesSuccess);
  };
});

(function() {
  'use strict';

  angular
    .module('frontend')
    .factory('personPicker', personPicker);

  function personPicker() {
    return {
      personsList:{},
      makePersonList: function (obj) {
        this.personsList = {
              offset: obj.offset,
              total: obj.total,
              items: obj.items
            }
      },
      loading: true,
      setLoading: function (is) {
        if (is) {
          this.loading = true
        } else {
          this.loading = false
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .service('modalOpenSrv', function ($uibModal) {
      this.showModal = function (successFunction, dismissFunction, personDataID, mode) {
        $uibModal.open({
          templateUrl: 'app/components/personsData/personsData.html',
          controller: 'ModalDialogController',
          controllerAs: 'vm',
          bindToController: true,
          size: 'large-width',
          resolve: {
            mode: function () { return mode },
            personDataID: function () { return personDataID }
          }
        })
          .result.then(successFunction, dismissFunction);
      };
    })
    .controller('ModalDialogController', function ($scope, $uibModalInstance, personsDataSrv, $log, $filter, $document,
                                                   auth, $timeout, $state, uiGridConstants, personPicker,
                                                   errorMessageService, utilsService, currenciesService, mode, personDataID,
                                                   uiSelectStructure) {
      var vm = this;
      var pencil = '<span ng-if="$root.hasRole(\'person.write\')" class="glyphicon glyphicon-pencil tooltip-light" tooltip-placement="bottom-right" uib-tooltip="Редактировать" ng-click="grid.appScope.showForm(grid, row)"></span>';
      var myData = [];
      var createdPerson;
      vm.datePickerOpts = {singleDatePicker: true, correctTimeZone: false, maxDate: moment().utc().startOf('day')};
      vm.edit = false;
      vm.today = moment().utc().startOf('day');
      vm.searchInProgress = false;
      vm.showFIOHelp = {};
      vm.showFIOHelp.surname = false;
      vm.showFIOHelp.name = false;
      vm.showFIOHelp.patronymic = false;
      $scope.selected = false;
      vm.person = {
        passport_type: 'I',
        real_address_eq_legal: true,
        accounts: []
      };
      vm.acrivePage = [];
      vm.limit = 6;
      vm.inited = false;
      vm.totalPersons = null;
      vm.pageList = [];
      vm.shortRefArray = [];
      vm.longRefArray = [];
      vm.currP = 1;
      vm.lastP = null;
      vm.searchText = '';
      vm.birth_date = null;
      vm.formMode = mode;
      vm.birthDateState = {};
      vm.passportDateState = {};

      vm.onDatePickerClose = function (returnValue, name) {
        if (returnValue && !returnValue.isEmpty) {
          vm.person[name] = returnValue.valueOf();
        } else {
          vm.person[name] = null;
        }
        if (name === 'birth_date') {
          vm.uniqueCheck();
        }
      };

      $scope.gridOptions = {
        enableRowSelection: true,
        enableRowHeaderSelection: false,
        multiSelect: false,
        data: myData,
        enablePaginationControls: false,
        paginationPageSize: vm.limit,
        onRegisterApi: function (gridApi) {
          $scope.gridApi = gridApi;

          vm.loadList = function () {
            personPicker.setLoading(true);
            vm.getPersonsListData();
            vm.getCurrentPage();
            vm.success = false;
            vm.loadingData = true;
            vm.fail = false;
            personsDataSrv.getPersonsList(vm.offset, vm.limit, vm.searchText)
              .then(function (res) {
                personPicker.personsList = res.data;
                vm.loadingData = false;
                vm.success = true;
                vm.fail = false;
                personPicker.setLoading(false);
                personPicker.makePersonList(res.data);
                vm.getPersonsListData();
                vm.getCurrentPage();
              })
              .catch(function (err) {
                $log.log('failed');
                vm.success = false;
                vm.fail = true;
                vm.loadingData = false;
                // errorMessageService.showModal({message: 'при загрузке данных произошла ошибка', submessage: err}, true);
                // отслеживание ошибок не нужно , оно будет мешать работе ModalLoad
                vm.getPersonsListData();
                vm.getCurrentPage();
              })
            };
            //not for search paging
            vm.nextPage = function () {
              vm.offset = vm.currP*vm.limit;
              if (personPicker.personsList.total>vm.offset) {
                vm.inputPage = vm.currP + 1;
                vm.loadList();
              }
            };
            vm.goToPage = function (number) {
              if(number && number <= vm.totalPersons){
                vm.inputPage = number;
                vm.offset = number == 1?0:(number-1)*vm.limit;
                vm.loadList();
              }
              if(number > vm.totalPersons){
                vm.goToLastPage();
              }
              if(number === 0){
                vm.goToFirstPage();
              }
            };
            vm.previousPage = function () {
              vm.offset = vm.currP*vm.limit-vm.limit*2;
              if (vm.offset>= 0) {
                vm.inputPage = vm.currP - 1;
                vm.loadList();
              }
            };
            vm.goToLastPage = function () {
              vm.offset = vm.totalPersons*vm.limit-vm.limit;
              vm.inputPage = vm.totalPersons;
              vm.loadList();
            };
            vm.goToFirstPage = function () {
              vm.offset = 0;
              vm.inputPage = 1;
              vm.loadList();
            };
            angular.element(document).ready(function () {
              vm.goToFirstPage();
            });
            gridApi.selection.on.rowSelectionChanged($scope, function () {
              $scope.selected = $scope.gridApi.selection.getSelectedRows().length != 0
            });
          },
          columnDefs: [{ name: 'surname', displayName:'Фамилия', enableSorting: false, width: 202},
                       {field:'name', displayName:'Имя', enableSorting: false, width: 202},
                       {field:'patronymic', displayName:'Отчество', enableSorting: false, width: 202},
                       {field:'birthdate', displayName:'Дата рождения', enableSorting: false, width: 202},
                       {field:'option', cellTemplate: pencil, displayName:'', enableSorting: false, width: 35}]
        };

      vm.countryClassifiers = uiSelectStructure.getStructure(utilsService.getCountryClassifierAuto, vm.person.citizenship);

      vm.passportTypes = {
        I: 'Паспорт гражданина РФ',
        II: 'Свидетельство о рождении',
        III: 'Военный билет',
        IV: 'Временное удостоверение, выданное взамен военного билета',
        V: 'Удостоверение личности военнослужащего РФ',
        VI: 'Паспорт иностранного гражданина',
        VII: 'Свидетельство о рассмотрении ходатайства о признании лица беженцем на территории РФ по существу',
        VIII: 'Вид на жительтво в РФ',
        IX: 'Удостоверение беженца',
        X: 'Разрешение на временное проживание в РФ',
        XI: 'Свидетельство о предоставлении временного убежища в РФ',
        XII: 'Свидетельство о рождение выдданное уполномоченным органов иностранного государства'
      };

      vm.maritalStatuses = {
        MARRIED: 'Женат/Замужем',
        UNMARRIED: 'Холост/Не замужем'
      };

      //help functions

      //pagination
      vm.getCurrentPage = function () {
        vm.currP = (vm.offset / vm.limit) + 1 || 1;
        vm.lastP = vm.totalPersons;
        vm.pageList.length = 0;
        if (vm.currP === 1) {
          vm.pageList = ['1', '2', '3'];
          vm.activePage = [true, false, false];
        } else if (vm.currP >= 2 && vm.currP !== vm.lastP) {
          vm.pageList = [(vm.currP - 1).toString(), (vm.currP).toString(), (vm.currP + 1).toString()];
          vm.activePage = [false, true, false];
        } else if (vm.currP === 2 && vm.currP === vm.lastP) {
          vm.pageList = [(vm.currP - 1).toString(), (vm.currP).toString()];
          vm.activePage = [false, true];
        } else {
          vm.pageList = [(vm.lastP - 2).toString(), (vm.lastP - 1).toString(), (vm.lastP).toString()];
          vm.activePage = [false, false, true];
        }
      };

          vm.getPersonsListData = function (row) {
            vm.showHelp = personPicker.personsList.total === 0;
            if (!personPicker.loading) {
              vm.loadingList = false;
              myData = [];
              for (var i = 0; i < personPicker.personsList.items.length; i++) {
                    var birth_date = personPicker.personsList.items[i].birth_date;
                    myData.push({});
                    myData[i].surname = personPicker.personsList.items[i].surname;
                    myData[i].name = personPicker.personsList.items[i].name;
                    myData[i].patronymic = personPicker.personsList.items[i].patronymic;
                    myData[i].birthdate = $filter('date')(personPicker.personsList.items[i].birth_date, 'dd.MM.yyyy', 'UTC');
                    myData[i].id = personPicker.personsList.items[i].id;
              }
              $scope.gridOptions.data = myData;
              vm.showHelp = personPicker.personsList.total === 0;
              setTotalPerson();
              vm.getCurrentPage();
            } else {
              myData = [];
              vm.showHelp = personPicker.personsList.total === 0;
              vm.loadingList = true;
              vm.getCurrentPage();
            }
          };

          vm.refreshData = function () {
            myData = [];
            if (vm.searchText.length != 1) {
                vm.offset = 0;
                vm.noData = vm.loadData = false;
                personsDataSrv.getPersonsList(vm.offset,vm.limit,vm.searchText)
                .then(function (result) {
                    personPicker.personsList = result.data;
                    if(!result.data.items.length && !vm.searchText){
                      vm.noData = true;
                    }
                    myData = [];
                    for (var i = 0; i < result.data.items.length; i++) {
                          myData.push({});
                          myData[i].surname = result.data.items[i].surname;
                          myData[i].name = result.data.items[i].name;
                          myData[i].patronymic = result.data.items[i].patronymic;
                          myData[i].birthdate = $filter('date')(result.data.items[i].birth_date, 'dd.MM.yyyy', 'UTC');
                          myData[i].id = result.data.items[i].id;
                    }

                    vm.currP = 1;
                    $scope.gridOptions.data = myData;
                    vm.getCurrentPage();
                    setTotalPerson();
                    vm.loadData = true;
                })
            } else {
              vm.getPersonsListData();
            }
          };

      function setTotalPerson() {
        var pagesNumber = personPicker.personsList.total / vm.limit;
        if (Math.floor(pagesNumber) < 1) {
          vm.totalPersons = 1;
        } else if (pagesNumber > 1 && pagesNumber <= 2) {
          vm.totalPersons = 2;
        } else if (pagesNumber > 2 && personPicker.personsList.total % vm.limit !== 0) {
          vm.totalPersons = Math.floor(pagesNumber) + 1;
        } else if (pagesNumber > 2 && personPicker.personsList.total % vm.limit === 0) {
          vm.totalPersons = Math.floor(pagesNumber);
        }
      }

      vm.changeLimit = function () {
        vm.goToFirstPage();
      };

      //pagination end

      //tabs
      vm.checkAccountUnique = function () {
        var errorInd = [];
        _.forEach(vm.person.accounts, function (acc1, key1) {
          $scope.personalDataForm['vm.bankAcc' + key1]['name' + key1].$setValidity('unique', true);
          _.forEach(vm.person.accounts, function (acc2, key2) {
            if(acc1.name && acc2.name && key1 < key2 && acc1.name == acc2.name){
              console.log(acc1.name);
              errorInd.push(key1);
              errorInd.push(key2);
            }
          });
        });
        
        _.forEach(errorInd, function (errIndex) {
          $scope.personalDataForm['name' + errIndex].$setValidity('unique', false);
        });
      }


      vm.addAccountTab = function () {
        if (vm.person.accounts.length === 0) {
          vm.person.accounts.push({
            'name': 'Банковский счет',
            'main': true
          });
        } else {
          vm.person.accounts.push({
            'name': 'Новый счет',
            'main': false
          });
        }

        $timeout(function() {
          vm.reCalcScroll();
          vm.selectTab(vm.person.accounts.length + 2);
          vm.checkAccountUnique();
        }, 300);
      };

      vm.removeAccountTab = function (id, event) {
        event.preventDefault();
        if (!vm.edit) {
          vm.selectTab(id + 1);
          vm.person.accounts.splice(id, 1);
          vm.reCalcScroll();
        }

        if (vm.edit) {
          if (typeof vm.person.accounts[id].id === 'undefined') {
            vm.selectTab(id + 1);
            vm.person.accounts.splice(id, 1);
            vm.reCalcScroll();
          } else {
            personsDataSrv.deletePersonAccount(vm.person.id, vm.person.accounts[id-1].id)
              .then(function () {
                vm.selectTab(id + 1);
                vm.person.accounts.splice(id, 1);
                vm.reCalcScroll();
              }).catch(function (err) {
              errorMessageService.showModal({message: 'При удалении аккаунта произошла ошибка', submessage: err});
            });
          }
        }
        vm.checkAccountUnique();
      };

      vm.changeMainAccount = function (id, val) {
        for (var i in vm.person.accounts) {
          vm.person.accounts[i].main = (i === id && val);
        }
      };

      vm.scrlTabsApi = {};
      vm.reCalcScroll = function() {
        if(vm.scrlTabsApi.doRecalculate) {
          vm.scrlTabsApi.doRecalculate();
        }else{
          vm.scrlTabsApi = {};
        }
      };

      vm.scrollIntoView = function(index) {
        if(vm.scrlTabsApi.scrollTabIntoView) {
          vm.scrlTabsApi.scrollTabIntoView(index);
        }
      };
      $timeout(function() {vm.reCalcScroll()}, 2000);

      vm.activeContact = vm.activeContact || 0;
      
      vm.selectTab = function(index) {
        vm.activeContact = index;
        vm.scrollIntoView(index);
      };
      // tabs end

      function isAuthenticated(callback) {
        auth.ensureSession().then(function (res) {
          callback();
        });
      }

      vm.resetValues = function () {
        vm.person = {};
        vm.edit = false;
        vm.isWrongFormData = false;
        vm.person.accounts = [];
        vm.birthDateState.resetData();
        vm.passportDateState.resetData();
        angular.element('.persons-form .ng-empty[required]').removeAttr('style');
        if ($scope.personalDataForm) {
          $scope.personalDataForm.$setPristine();
          $scope.personalDataForm.$setUntouched();
          angular.forEach($scope.personalDataForm, function (value, key) {
            if (angular.isObject(value) && value.hasOwnProperty('$modelValue')) {
              $scope.personalDataForm[key].$setValidity('unique', true);
            }
          });
        }
        vm.selectTab(0);
        setTotalPerson();
        vm.getCurrentPage();
        $timeout(function () {
          $scope.gridApi.selection.selectRow(vm.choosenRow);
          vm.showForm = false;
        }, 1);
      };

      vm.closePopup = function () {
        vm.resetValues();
        $scope.gridApi.pagination.seek(1);
        vm.getCurrentPage();
        $scope.cancel();
      };

      function changeGrid(action, data) {
        var index;
        switch (action) {
          case 'update':
            index = $scope.gridOptions.data.indexOf(vm.choosenRow);
            myData[index] = {
              'name': data.data.name,
              'surname': data.data.surname,
              'patronymic': data.data.patronymic,
              'birthdate': $filter('date')(data.data.birth_date, 'dd.MM.yyyy', 'UTC'),
              'id': data.data.id
            };
            vm.choosenRow = myData[index];
            break;
          case 'create':
            var obj = {
              'name': data.data.name,
              'surname': data.data.surname,
              'patronymic': data.data.patronymic,
              'birthdate': $filter('date')(data.data.birth_date, 'dd.MM.yyyy', 'UTC'),
              'id': data.data.id
            };

            //для выбора физ лиц (создать и выбрать)

            if (vm.select) {
              createdPerson = obj;
              $scope.choose();
              vm.select = false;
            }

            personPicker.personsList.total += 1;
            vm.showHelp = personPicker.personsList.total === 0;
            if ($scope.gridOptions.data.length > vm.limit) {
              vm.nextPage();
            } else {
              vm.loadList();
            }
            break;
          case 'delete':
            index = $scope.gridOptions.data.indexOf(vm.choosenRow);
            $scope.gridOptions.data.splice(index, 1);
            personPicker.personsList.total -= 1;
            if ($scope.gridOptions.data.length < vm.limit) {
              vm.loadList();
            } else {
              vm.offset -= vm.limit;
              vm.loadList();
            }
            vm.showHelp = personPicker.personsList.total === 0;
            break;
          default:
            break;
        }
        vm.resetValues();
      }

      vm.openForm = function () {
        vm.birth_date = null;
        vm.person.birth_date = null;
        vm.showForm = true;
      };

      vm.goTo = function (target) {
        angular.element('a[href="' + target + '"]').trigger('click');
      };

      vm.setValid = function () {
        angular.element('.persons-form .ng-empty[required]').removeAttr('style');
      };
      //help functions End

      // help eventListeners
      angular.element('#persons-data-popup').on('shown.bs.modal', function () {
        $scope.selected = false;
        vm.resetValues();
        isAuthenticated(vm.getPersonsListData);
      });

      vm.getBankInfo = function ($event, model) {
        var account = vm.person.accounts[parseInt($event.target.name.match(/\d/)[0])];

        function setValue(bankName, corr_acc) {
          account.bank = bankName;
          account.corr_account = corr_acc;
        }
        if (model) {
          utilsService.getBankInfo(model)
          .then(function (res) {
            if (res.data.length > 0) {
              setValue(res.data[0].name.replace(/&quot;/g, '"'), res.data[0].correspondent_account);
            } else {
              setValue('', '');
            }
          })
          .catch(function (err) {
            setValue('', '');
            $log.log(err);
          });
        }
      };

      //help eventListeners end

      $scope.choose = function (doNotChangeFio) {
        function getPerson(fullString) {
          var obj = typeof createdPerson !== 'undefined'
            ? createdPerson
            : $scope.gridApi.selection.getSelectedRows()[0];

          function checkType(target) {
            if (!angular.isString(target)) {
              target = '';
              return target;
            } else {
              target = target.charAt(0).toUpperCase() + target.substr(1).toLowerCase();
              return target;
            }
          }

          function concatName(target) {
            target = checkType(target);
            if (target.length === 0) {
              return '';
            } else {
              target = target[0] + '.';
              return target;
            }
          }

          var personName;
          if (!fullString) {
            personName = checkType(obj.surname) + ' ' + concatName(checkType(obj.name)) + ' ' +
              concatName(checkType(obj.patronymic));
            return personName;
          } else {
            personName = checkType(obj.surname) + ' ' + checkType(obj.name) + ' ' + checkType(obj.patronymic);
            return personName;
          }
        }

        var chosenPerson = typeof createdPerson !== 'undefined'
          ? createdPerson
          : $scope.gridApi.selection.getSelectedRows()[0];
        var obj = {
          name: chosenPerson.name,
          surname: chosenPerson.surname,
          patronymic: chosenPerson.patronymic,
          person: getPerson(false),
          id: chosenPerson.id,
          fullName: getPerson(true),
          choosed: true
        };
        if (doNotChangeFio) {
          obj.doNotChangeFio = true
        }
        vm.resetValues();
        $uibModalInstance.close(obj);
      };

      vm.validatePersonsForm = function (formData, functions) {
        vm.isSaved = true;
        utilsService.setTouched($scope.personalDataForm);

        //проверка валидности формы и переход на первую вкладку с неправилоно заполнеными данными
        functions = functions || null;
        if (formData.$valid) {
          if (typeof functions === 'function') {
            functions();
          }
          $scope.gridApi.core.refresh();
        } else {
          if (!formData.name.$valid || !formData.surname.$valid) {
            vm.selectTab(0);
            formData.name.$setDirty();
            formData.surname.$setDirty();
          } else if (!formData.inn.$valid || !formData.snils.$valid) {
            vm.selectTab(1);
          } else {
            var name = typeof formData.$error.required === 'undefined' ? formData.$error.pattern[0].$name : formData.$error.required[0].$name;
            angular.forEach(formData.$error, function (controls) {
              angular.forEach(controls, function (control) {
                control.$setDirty();
              });
            });
            name = String(name);
            var index = parseInt(name[name.length - 1]);
            vm.selectTab(index + 2);
          }
        }
      };

      $scope.showForm = function (grid, row) {
        personsDataSrv.getPersonData(row.entity.id)
          .then(function (res) {
            var acc = [];

            // Делает основой счет первым
            for (var i = 0; i < res.data.accounts.length; i++) {
              if (res.data.accounts[i].main) {
                var obj = res.data.accounts[i];
                res.data.accounts.splice(i, 1);
                res.data.accounts.unshift(obj);
              }
            }

            vm.person = res.data;
            if (res.data.birth_date) {
              vm.birth_date = moment.utc(res.data.birth_date);
            }
            if (res.data.passport_date) {
              vm.passport_date = moment.utc(res.data.passport_date);
            }

            if (vm.formMode === 'view' && vm.person.real_address_eq_legal) {
              vm.person.real_address = vm.person.legal_address;
            }
            vm.showForm = true;
            vm.edit = true;
            vm.choosenRow = row.entity;
            $scope.personalDataForm.$setPristine();
            $scope.personalDataForm.$setUntouched();
          }).catch(function (err) {
          errorMessageService.showModal({
            message: 'При загрузке данных физического лица произошла ошибка',
            submessage: err
          });
        });
      };

      // проверка уникальности
      vm.uniqueCheck = function () {
        vm.isRepeatData = false;
        vm.person.birth_date = vm.birth_date && vm.birth_date.valueOf();
        if (vm.person.surname && vm.person.name) {
          var obj = {
            constraint_name: 'PERSON',
            parameters: [
              {name: 'name', value: vm.person.name},
              {name: 'surname', value: vm.person.surname},
              {name: 'patronymic', value: vm.person.patronymic || null},
              {name: 'birth_address', value: vm.person.birth_place || null}
            ]
          };
          if (vm.person.birth_date) {
            obj.parameters.push({name: 'birth_date', value: vm.person.birth_date});
          } else {
            obj.parameters.push({name: 'birth_date', value: null});
          }
          if (vm.person.id) {
            obj.id = vm.person.id;
          }
          utilsService.uniqueCheck(obj).then(function () {
              angular.forEach(obj.parameters, function (field) {
                if(field.name == 'name') field.name = 'first_name';
                if ($scope.personalDataForm[field.name]) {
                  $scope.personalDataForm[field.name].$setValidity('unique', true);
                }
              });
            },
            function (error) {
              if (error.status === 409) {
                angular.forEach(error.data.parameters, function (field) {
                  if(field.name == 'name') field.name = 'first_name';
                  $scope.personalDataForm[field.name].$setValidity('unique', false);
                });
                vm.isRepeatData = true;
              } else {
                $log.debug(error);
              }
            });
        }
      };

      vm.save = function () {
        vm.person.birth_date = vm.birth_date && vm.birth_date.valueOf();
        Object.keys(vm.person).forEach(function(value) {
          vm.person[value] = vm.person[value] || null
        });
        if (vm.person.id) {
          //Блок редактирования
          personsDataSrv.updatePersonData(vm.person.id, vm.person).then(function (res) {
            if (vm.formMode || vm.editMode) {
              createdPerson = {
                'name': res.data.name,
                'surname': res.data.surname,
                'patronymic': res.data.patronymic,
                'birthdate': $filter('date')(res.data.birth_date, 'dd.MM.yyyy', 'UTC'),
                'id': res.data.id
              };
              $scope.choose(true);
            } else {
              changeGrid('update', res);
            }
          }).catch(function (err) {
            if (err.status === 409) {
              angular.forEach(err.data.parameters, function (field) {
                vm.isRepeatData = true;
                vm.birth_date = moment.utc(vm.person.birth_date);
              });
            } else {
              errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: err});
            }
          });
        } else {
          //Блок создания
          personsDataSrv.createPerson(vm.person)
            .then(function (res) {
              changeGrid('create', res);
            }).catch(function (err) {
            if (err.status === 409) {
              angular.forEach(err.data.parameters, function () {
                vm.isRepeatData = true;
                vm.birth_date = moment.utc(vm.person.birth_date);
              });
            } else {
              errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: err});
            }
          });
        }
      };

      vm.deletePerson = function () {
        personsDataSrv.deletePerson(vm.person.id).then(function () {
          changeGrid('delete');
        }).catch(function (err) {
          errorMessageService.showModal({message: 'При удалении произошла ошибка', submessage: err});
        });
      };

      //CRUD end

      // скролл при удалении физ.лица
      vm.configScroll = {
        autoHideScrollbar: false,
        theme: 'dark-thick',
        advanced: {
          updateOnContentResize: true
        },
        setHeight: 100,
        scrollInertia: 0
      };

      //попап удалениея физ лица
      vm.avaliableToDelete = function () {
        vm.shortRefArray = [];
        vm.longRefArray = [];

        function translateNames(data) {
          switch (data.type) {
            case 'company_chief':
              data.type = 'Руководитель компании ' + data.name;
              data.url = '#/company/' + data.id + '/edit/';
              break;
            case 'company_accountant':
              data.type = 'Бухгалтер компании ' + data.name;
              data.url = '#/company/' + data.id + '/edit/';
              break;
            case 'counterparty':
              data.type = 'Контрагент ' + data.name;
              data.url = '#/contragent/' + data.id + '/edit/';
              break;
            case 'counterparty_chief':
              data.type = 'Руководитель контрагента ' + data.name;
              data.url = '#/contragent/' + data.id + '/edit/';
              break;
            case 'counterparty_contact':
              data.type = data.position + ' контрагента ' + data.name;
              data.url = '#/contragent/' + data.id + '/edit/';
              break;
            case 'counterparty_accountant':
              data.type = 'Бухгалтер контрагента ' + data.name;
              data.url = '#/contragent/' + data.id + '/edit/';
              break;
            case 'system_user':
              data.type = 'Сотрудник ' + data.name;
              data.url = '#/employee/' + data.id + '/edit/';
              break;
            default:
              break;
          }
          return data
        }

        function createShortRefArr(res) {
          for (var i = 0; i < 2; i++) {
            vm.shortRefArray[i] = translateNames(res.data.references[i]);
          }
        }

        personsDataSrv.getReferences(vm.person.id)
          .then(function (res) {
            var length = res.data.references.length;
            if (length > 0) {
              if (length === 1) {
                vm.shortRefArray[0] = translateNames(res.data.references[0]);
              } else if (length === 2) {
                createShortRefArr(res);
              } else if (length > 2) {
                createShortRefArr(res);
                for (var j = 2; j < res.data.references.length; j++) {
                  vm.longRefArray[j - 2] = translateNames(res.data.references[j]);
                }
              }
              vm.cantBeDeleted = false;
            } else {
              vm.cantBeDeleted = true;
            }
            vm.showRemovePerson = true;
          });
      };

      vm.showAll = function () {
        vm.toAllWindow = true;
        $timeout(function () {
          vm.showHiddenData = true;
        }, 750);
      };

      vm.candelDeletetion = function () {
        vm.showRemovePerson = false;
        vm.toAllWindow = false;
        vm.showHiddenData = false;
      };

      vm.editOn = function () {
        vm.loadingData = true;
        vm.formMode = '';
        $timeout(function () {
          vm.loadingData = false;
          vm.editMode = true;
        }, 300);
      }

      vm.currencies = uiSelectStructure.getStructure(currenciesService.getDomainCurrenciesSearch);

      $scope.ok = function () {
        $uibModalInstance.close();
      };

      $scope.cancel = function () {
        $uibModalInstance.dismiss();
      };

      if (vm.formMode && !!personDataID) {
        $scope.showForm(null, { entity: {id: personDataID}})
      }

    });
})();

(function () {
  'use strict';
  angular
    .module('frontend')
    .directive('personDataInput', inputPersonData);

  function inputPersonData($state) {
    var count = 0;
    var directive = {
      require: '^form',
      restrict: 'A',
      scope: {
        formModel: '=',
        fio: '=?',
        nameAndId: '@?', // устанавливает name и id у инпута по умолчанию personInput
        isRequired:'@?', // Только 'true' будет считаться как положительно значение
        uniqueCallback: "=?", // callback для проверки уникальности по blur,
        onlyPopupEdit: '@?',
        triggers: "=?", // проброс внутренних функций компонента в компонент родителя (сейчас это тригер открытия попапа)
        fieldLabel: '<' // Название поля
      },
      templateUrl: 'app/components/personsData/inputPersonData.html',
      controller: inputPersonDataCtrl,
      controllerAs: 'vm',
      bindToController: false,
      link: inputPersonDataLink
    };

    function inputPersonDataLink(scope, element, attributes, form) {
      count++;
      scope.view = $state.current.name.endsWith('view');
      scope.parentForm = form;
      scope.model = attributes.model;
      scope.nameAndId = scope.nameAndId || 'personInput' + count;
      scope.required = scope.isRequired === 'true';
      scope.onlyPopupEdit = scope.onlyPopupEdit === 'true';
      // для проверки уникальности поля при выборе person
      scope.$watch('formModel', function (oldVal, newVal) {
        if(oldVal) angular.element(element).find('.pdfl-input').blur();
      });
    }

    function inputPersonDataCtrl($scope, modalOpenSrv, personPicker, $rootScope) {
      $scope.person = {};
      if (!$scope.fio) $scope.fio = '';
      if (!$scope.formModel) $scope.formModel = null;

      if ($scope.onlyPopupEdit && $scope.formModel) {
        $scope.fio = getPerson(true)
      }

      $scope.toForm = function () {
        if (!$scope.formModel) $scope.formModel = {};
        $scope.model = $scope.formModel
      };
      $scope.reset = function () {
        $scope.person.choosed = false;
        $scope.person.fullName = '';
        $scope.formModel = null;
        if ($scope.onlyPopupEdit) {
          $scope.fio = null;
          $scope.parentForm[$scope.nameAndId].$setValidity('unique', true)
        }
      };
      $scope.loading = true;
      $scope.getPersonsListData = function () {
        personPicker.setLoading(true);
      };
      $scope.showModal = function () {
        modalOpenSrv.showModal(successFun, dismissFun)
      };
      function successFun(formModelItem) {
        if (!$scope.formModel) $scope.formModel = {};
        $scope.formModel.id = formModelItem.id;
        $scope.formModel.name = formModelItem.name;
        $scope.formModel.surname = formModelItem.surname;
        $scope.formModel.patronymic = formModelItem.patronymic;
        $scope.person.choosed = formModelItem.choosed;
        $scope.person.fullName = formModelItem.fullName;
        $scope.fio = $scope.onlyPopupEdit ? formModelItem.person : ($scope.fio || formModelItem.person);
        $scope.parentForm.$setDirty();
      }

      function dismissFun() {
      }

      function getPerson(short) {
        function checkType(target, short) {
          if (!angular.isString(target)) {
            target = '';
            return target
          } else {
            target = target.charAt(0).toUpperCase() + (short ? '.': target.substr(1).toLowerCase());
            return target
          }
        }
        var obj = $scope.formModel;
        var personName;
        personName = checkType(obj.surname)  + ' ' + checkType(obj.name, short) + ' ' + checkType(obj.patronymic, short);
        return personName
      }

      $scope.$watch('formModel', function (oldVal, newVal) {
        if ($scope.formModel && $scope.formModel.id) {
          $scope.person.fullName = getPerson();
          $scope.person.choosed = true;
        } else {
          $scope.person.choosed = false
        }
      })

      $scope.$watch('fio', function (oldVal, newVal) {
        if (newVal == '') {
          $scope.fio = null
        }
      });


      $scope.openPersonDataInViewMode = function() {
        modalOpenSrv.showModal(successFun, dismissFun, $scope.formModel.id, $rootScope.hasRole('person.write') && !$scope.view ? 'edit' : 'view');
      };

      if ($scope.triggers) {
        $scope.triggers.openPersonFn = function (id) {
          if (id) {
            modalOpenSrv.showModal(successFun, dismissFun, id, $rootScope.hasRole('person.write') && !$scope.view ? 'edit' : 'view')
          }
        };
      }

    }

    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('partnerChoice', {
      bindings: {
        reqData: '=', // данные формы
      },
      templateUrl: 'app/components/partner-choice/partner-choice.html',
      controllerAs: 'partnerChoice',
      controller: function ($scope, $rootScope, companyService) {
        var partnerChoice = this;
        partnerChoice.partners = [partnerChoice.reqData.clientPartnerId];
        partnerChoice.companies = [];
        partnerChoice.divisions = [];

        partnerChoice.clientTypes = [{
          value: "DOMAIN",
          name: "Группа"
        },{
          value: "COMPANY",
          name: "Компания"
        },{
          value: "DIVISION",
          name: "Подразделение"
        }];

        partnerChoice.changePartnerType = function(type) {
          console.log('changePartnerType', type)
          switch (type) {
            case 'DOMAIN':
              partnerChoice.partners = [{name: $rootScope.user.domain, id: $rootScope.user.domain}];
              partnerChoice.reqData.clientPartnerId = partnerChoice.partners[0];
              break;
            case 'COMPANY':
              partnerChoice.reqData.clientPartnerId = undefined;
              partnerChoice.partners = partnerChoice.companies;
              break;
            case 'DIVISION':
              partnerChoice.reqData.clientPartnerId = undefined;
              partnerChoice.partners = partnerChoice.divisions;
              break;
            default :
              break;
          }
          partnerChoice.refreshPartnerName();
        };

       partnerChoice.refreshPartnerName = function (search) {
          console.log('refreshPartnerName', search)
          if (partnerChoice.reqData.clientType == "COMPANY") {
            /* Автодополнение компаний */
            companyService.companiesSearch(search, null, null, null, null, true)
              .then(function (data) {
                if (!partnerChoice.companies.length && !search){
                  partnerChoice.companies = data.data.items; // эталонный список компаний
                }
                partnerChoice.partners = data.data.items;
                if (partnerChoice.partners.length == 1) {
                  partnerChoice.reqData.clientPartnerId = $scope.partners[0];
                }
              });
          } else if (partnerChoice.reqData.clientType == "DIVISION") {
            /* Автодополнение подразделения */
            companyService.divisions({limit: 100}, search, null, true)
              .then(function (data) {
                if (!partnerChoice.divisions.length && !search){
                  partnerChoice.divisions = data.data.items; // эталонный список компаний
                }
                partnerChoice.partners = data.data.items;
                if (partnerChoice.partners.length == 1) {
                  partnerChoice.reqData.clientPartnerId = partnerChoice.partners[0];
                }
              });
          } else {
            partnerChoice.partners = [];
          }
        }
        

      }
    });
})();

/**
 * Created by aivanov on 01.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('pagingCustomizable', pagingCustomizable);

  function pagingCustomizable() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/paging-customizable/paging-customizable.html',
      scope: {
        // Состояние paging
        pageInfo: '=',
        // Обратный вызов при изменении paging
        callback: '=',
        // Размер блока соседних страниц (в одну сторону не считая текущую)
        size: '=?',
        paging: '<'
      },
      controller: function ($scope) {
        $scope.pageInfo.inputPage = ($scope.pageInfo.current || 0) + 1;
        // Определение размера блока по-умолчанию
        $scope.size = angular.isDefined($scope.size) ? $scope.size : 1; // Значение по-умолчанию: 1

        $scope.recalculateOffset = function() {
          // Смещение является вычисляемым полем
          $scope.pageInfo.offset =
            // Превентивная защита от отрицательных значений
            Math.max($scope.pageInfo.current * $scope.pageInfo.limit, 0);
        };

        // При внешнем изменении структуры (например, проставится total во внешнем контроллере) - произойдет пересчет страниц
        $scope.$watch('pageInfo.total', function (newValue, oldValue) {
          if (newValue != oldValue) {
            $scope.toFirst(true);
          }
        });

        $scope.$watch('pageInfo.limit', function (newValue, oldValue) {
          // Персчет смещения с приоритетом первого элемента текущего
          if (newValue) {
            // Превентивная защита от отрицательных значений
            $scope.pageInfo.current = Math.max(Math.floor(($scope.pageInfo.current * oldValue + 1) / newValue), 0);
            $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
            $scope.recalculateOffset();
          }
          if (newValue != undefined && newValue != oldValue) {
            $scope.callback();
          }
          $scope.updatePages();
        });

        $scope.updatePages = function () {
          $scope.pages = [];
          // Последняя страница
          $scope.pageInfo.last =
            // Превентивная защита от отрицательных значений
            Math.max(Math.floor(($scope.pageInfo.total - 1)/ $scope.pageInfo.limit), 0);
          if ($scope.pageInfo.current > $scope.pageInfo.last) {
            $scope.pageInfo.current = $scope.pageInfo.last;
          }
          $scope.pages.push({number: 0});
          if ($scope.pageInfo.last < 1)
            return;
          // проверка установки левого многоточия
          if ($scope.pageInfo.current - $scope.size > 1) {
            $scope.pages.push({number: Math.floor(($scope.pageInfo.current - $scope.size) / 2), ellipsis: true})
          }
          for (var i = $scope.pageInfo.current - $scope.size; i <= $scope.pageInfo.current + $scope.size; i++) {
            if (i > 0 && i < $scope.pageInfo.last) {
              $scope.pages.push({number: i})
            }
          }
          // проверка установки правого многоточия
          if ($scope.pageInfo.current + $scope.size < $scope.pageInfo.last - 1) { // проверка установки левого многоточия
            $scope.pages.push({number: Math.floor(($scope.pageInfo.current + $scope.size + $scope.pageInfo.last) / 2), ellipsis: true})
          }
          $scope.pages.push({number: $scope.pageInfo.last});
        }

        // Перход на первую страницу
        $scope.toFirst = function(ignoreCallBack) {
          $scope.pageInfo.current = 0;
          $scope.pageInfo.inputPage = 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          if (!ignoreCallBack) {
            $scope.callback();
          }
        }

        // Перход на последнюю страницу
        $scope.toLast = function() {
          $scope.pageInfo.current = $scope.pageInfo.last;
          $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        }

        // Перход на предыдущую страницу
        $scope.toPrevious = function() {
          $scope.pageInfo.current = $scope.pageInfo.current > 0 ? $scope.pageInfo.current - 1 : 0;
          $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        }

        // Перход на следующую страницу
        $scope.toNext = function() {
          $scope.pageInfo.current = $scope.pageInfo.current < $scope.pageInfo.last - 1 ? $scope.pageInfo.current + 1 : $scope.pageInfo.last;
          $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        }

        // Перход на указанную страницу
        $scope.toPage = function(index) {
          index--;
          if(index >= $scope.pageInfo.last){
            $scope.pageInfo.inputPage = $scope.pageInfo.last + 1;
          }
          $scope.pageInfo.current = index < 0 ? 0 : (index > $scope.pageInfo.last ? $scope.pageInfo.last : index);
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        }

        // Первичная инициализация
        $scope.updatePages();
      }
    }
  }
}) ();

/**
 * Created by aivanov on 01.06.2017.
 */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('paging', paging);

  function paging() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/paging/paging.html',
      scope: {
        // Состояние paging
        pageInfo: '=',
        // Обратный вызов при изменении paging
        callback: '=',
        // Размер блока соседних страниц (в одну сторону не считая текущую)
        size: '=?'
      },
      controller: function ($scope) {
        $scope.pageInfo.inputPage = 1;
        $scope.pageInfo.limits = $scope.pageInfo.limits || [5, 10, 25];
        // Определение размера блока по-умолчанию
        $scope.size = angular.isDefined($scope.size) ? $scope.size : 1; // Значение по-умолчанию: 1

        $scope.recalculateOffset = function() {
          // Смещение является вычисляемым полем
          $scope.pageInfo.offset =
            // Превентивная защита от отрицательных значений
            Math.max($scope.pageInfo.current * $scope.pageInfo.limit, 0);
        };

        // При внешнем изменении структуры (например, проставится total во внешнем контроллере) - произойдет пересчет страниц
        $scope.$watch('pageInfo.total', function () {
          $scope.updatePages();
        });

        $scope.$watch('pageInfo.limit', function (newValue, oldValue) {
          // Персчет смещения с приоритетом первого элемента текущего
          if (newValue) {
            // Превентивная защита от отрицательных значений
            $scope.pageInfo.current = Math.max(Math.floor(($scope.pageInfo.current * oldValue + 1) / newValue), 0);
            $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
            $scope.recalculateOffset();
          }
          if (newValue != undefined && newValue != oldValue) {
            $scope.callback();
          }
          $scope.updatePages();
        });

        $scope.updatePages = function () {
          $scope.pages = [];
          // Последняя страница
          $scope.pageInfo.last =
            // Превентивная защита от отрицательных значений
            Math.max(Math.floor(($scope.pageInfo.total - 1)/ $scope.pageInfo.limit), 0);
          if ($scope.pageInfo.current > $scope.pageInfo.last) {
            $scope.pageInfo.current = $scope.pageInfo.last;
          }
          $scope.pages.push({number: 0});
          if ($scope.pageInfo.last < 1)
            return;
          // проверка установки левого многоточия
          if ($scope.pageInfo.current - $scope.size > 1) {
            $scope.pages.push({number: Math.floor(($scope.pageInfo.current - $scope.size) / 2), ellipsis: true})
          }
          for (var i = $scope.pageInfo.current - $scope.size; i <= $scope.pageInfo.current + $scope.size; i++) {
            if (i > 0 && i < $scope.pageInfo.last) {
              $scope.pages.push({number: i})
            }
          }
          // проверка установки правого многоточия
          if ($scope.pageInfo.current + $scope.size < $scope.pageInfo.last - 1) { // проверка установки левого многоточия
            $scope.pages.push({number: Math.floor(($scope.pageInfo.current + $scope.size + $scope.pageInfo.last) / 2), ellipsis: true})
          }
          $scope.pages.push({number: $scope.pageInfo.last});
        };

        // Перход на первую страницу
        $scope.toFirst = function() {
          $scope.pageInfo.current = 0;
          $scope.pageInfo.inputPage = 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        };

        // Перход на последнюю страницу
        $scope.toLast = function() {
          $scope.pageInfo.current = $scope.pageInfo.last;
          $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        };

        // Перход на предыдущую страницу
        $scope.toPrevious = function() {
          $scope.pageInfo.current = $scope.pageInfo.current > 0 ? $scope.pageInfo.current - 1 : 0;
          $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        };

        // Перход на следующую страницу
        $scope.toNext = function() {
          $scope.pageInfo.current = $scope.pageInfo.current < $scope.pageInfo.last - 1 ? $scope.pageInfo.current + 1 : $scope.pageInfo.last;
          $scope.pageInfo.inputPage = $scope.pageInfo.current + 1;
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        };

        // Перход на указанную страницу
        $scope.toPage = function(index) {
          index--;
          if(index >= $scope.pageInfo.last){
            $scope.pageInfo.inputPage = $scope.pageInfo.last + 1;
          }
          $scope.pageInfo.current = index < 0 ? 0 : (index > $scope.pageInfo.last ? $scope.pageInfo.last : index);
          $scope.recalculateOffset();
          $scope.updatePages();
          $scope.callback();
        };

        // Первичная инициализация
        $scope.updatePages();
      }
    }
  }
}) ();

(function () {
  'use strict';
  angular
    .module('frontend')
    .directive('modalLoad', modalLoad)
    .controller('modalLoadCtrl', modalLoadCtrl);

  function modalLoad() {
    var directive = {
      restrict: 'E',
      scope: {
        // тип boolean, индицирует о наличии загрузки как процесса ( например получение данных с бэка)
        status: '=',
        // тип boolean,  свидетельствует о положительном результате загрузки
        success: '=',
        // тип boolean, показывает или скрывает главное окно ( необходимо указать в ng-show="" в главном окне)
        showMainModal:'=',
        // тип boolean, свидетельствует о неудачном результате загрузки
        fail: '=',
        // тип function, функция инициации загрузки данных, нужна в случае , если пользователь нажмет "повторите попытку"
        callback: '=',
        // тип function, функция закрытия главного попапа через $uibModal
        closeFun: '='
      },
      templateUrl: 'app/components/modalLoad/modalLoad.html',
      controller: 'modalLoadCtrl',
      bindToController: false
    };
    return directive;
  }

  function modalLoadCtrl($scope, ngProgressFactory) {
    $scope.showLoadMessage = false;
    $scope.showFailMessage = false;
    $scope.showMainModal = false;
    //первичная настройка прогресс-бара
    $scope.progressbar = ngProgressFactory.createInstance();
    $scope.progressbar.setHeight('4px');
    //Изменение в попапе загрузки
    $scope.makechanges = function () {
        //Загружаеться , результата нет
        if ($scope.status) {
          setProgressBarColor('#f8e4ab');
          $scope.progressbar.set(10);
          $scope.progressbar.start();
          $scope.showMainModal = false;
          $scope.showLoadMessage = true;
          $scope.showFailMessage = false;
        //Загрузилось успешно
      } else if (!$scope.status && $scope.success) {
          $scope.progressbar.set(100);
          $scope.progressbar.complete();
          $scope.showMainModal = true;
        //Загрузилось не успешно
      } else if (!$scope.status && $scope.fail) {
          setProgressBarColor('#cd343e');
          $scope.progressbar.set(100);
          $scope.progressbar.complete();
          $scope.showMainModal = false;
          $scope.showLoadMessage = false;
          $scope.showFailMessage = true;
      }
    }

    //Установка цвета прогрес-бара
    function setProgressBarColor(color) {
      $scope.progressbar.setColor(color);
    }

    //Реагирование на изменение статуса
    $scope.$watch('status', function (oldVal, newVal) {
        $scope.progressbar.setParent(angular.element('.modal-load-wrapper')[0]);
        $scope.makechanges()
    })

    //реагирование на окончание загрузки
    $scope.$watch('success', function (oldVal, newVal) {
        $scope.makechanges();
    })
  }

})();

'use strict';
angular.module('frontend').component('marksWithoutSourse', {
  templateUrl: 'app/components/marksWithoutSourse/marks-without-sourse.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'marksWithoutSourse',
  controller: function ($scope, egaiszService, $filter, $timeout, errorMessageService, $q, userSettingsService) {
    var marksWithoutSourse = this;
    marksWithoutSourse.load = false;
    marksWithoutSourse.data = marksWithoutSourse.resolve.data || [];
    marksWithoutSourse.isViewMode = false;
    marksWithoutSourse.viewPattern = '{{item.amc | egaisBarcode}}';
    marksWithoutSourse.skuInfo = marksWithoutSourse.resolve.values;

    marksWithoutSourse.configScroll = {
      autoHideScrollbar: false,
      theme: 'dark-thick',
      advanced: {
        updateOnContentResize: true
      },
      scrollButtons: {
        enable: false
      },
      setHeight: 200,
      scrollInertia: 0,
      axis: 'y'
    };

    marksWithoutSourse.removeAmc = function(index){
      marksWithoutSourse.data.splice(index, 1);
    }
    
    // буфер автоматического сканирования (аккумулятор вводимых символов)
    marksWithoutSourse.scanBuffer = '';

    marksWithoutSourse.close = function(cancel) {
      marksWithoutSourse.modalInstance.close(marksWithoutSourse.data);
    };


    /**
     * Поиск марок из тех что пришли с бэка
     */
    marksWithoutSourse.submitBarcode = function (cleanData, barcode) {
      var result = $q.defer();
      marksWithoutSourse.barcode = barcode || marksWithoutSourse.barcode;
      marksWithoutSourse.scanBuffer = '';

      marksWithoutSourse.matchError = !!_.find(marksWithoutSourse.data, function(mark, key){
        if(mark.amc == marksWithoutSourse.barcode || mark.amc_name == marksWithoutSourse.barcode){
          return mark;
        }
      });

      if (!marksWithoutSourse.matchError &&
          /^[a-zA-Z0-9]+$/i.test(marksWithoutSourse.barcode) &&  
          (marksWithoutSourse.barcode.length == 150 ||
           marksWithoutSourse.barcode.length == 68)) {
        marksWithoutSourse.data.push({
          amc: marksWithoutSourse.barcode,
          amc_name: $filter('egaisBarcode')(marksWithoutSourse.barcode)
        });
        marksWithoutSourse.barcode = '';
      } else {
        marksWithoutSourse.wrongMark = true;
      }

      if (cleanData) {
        marksWithoutSourse.barcode = '';
      }
      // возврат промиса
      return result.promise;
    };

    /**
     * Метод принимает вводимую информацию от сканера.
     * моментом аппрува введенных данных является либо превышение
     * таймаута с последнего события, либо энтер.
     *
     * @param keyEvent событие клвавиатуры
     */
    marksWithoutSourse.applyScannerKeys = function(keyEvent) {

      // оставнока таймера, т.к. ввод продолжен
      $timeout.cancel(marksWithoutSourse.scanTimer);
      if (keyEvent.keyCode == 13) {
        marksWithoutSourse.submitBarcode(false, marksWithoutSourse.scanBuffer).finally(function () {
          marksWithoutSourse.scanBuffer = '';
        });
      } else {
        var charFromEvent = undefined;
        if (keyEvent.originalEvent.code.startsWith('Digit')) {
          var charFromEvent = keyEvent.key;
        }
        if (keyEvent.originalEvent.code.startsWith('Key')) {
          charFromEvent = keyEvent.shiftKey ? keyEvent.originalEvent.code.charAt(3) : keyEvent.originalEvent.code.charAt(3).toLowerCase();
        }

        if (!/[a-zA-Z0-9]{1}/.test(charFromEvent)) {
          // допустимы только числа и буквенные символы
          marksWithoutSourse.scanBuffer = ''; // сброс аккумулятора из-за ошибки
          return;
        }

        marksWithoutSourse.scanBuffer += charFromEvent;

        if (marksWithoutSourse.scanBuffer) {
          // новый таймер
          marksWithoutSourse.scanTimer = $timeout(function () {
            marksWithoutSourse.submitBarcode(false, marksWithoutSourse.scanBuffer).finally(function () {
              marksWithoutSourse.scanBuffer = '';
            });
          }, 200); // пока больше чем нужно, чтобы можно было тестить нормально
        }
      }
    };

  }
});


'use strict';
angular.module('frontend').component('markViewModal', {
  templateUrl: 'app/components/markViewModal/mark-view-modal.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'markViewModal',
  controller: function ($scope, $state, egaiszService, $timeout, errorMessageService, $q, userSettingsService) {
    var markViewModal = this;
    markViewModal.load = false;
    markViewModal.acceptedAmcsSelected = [];
    markViewModal.noAcceptedAmcsSelected = [];
    markViewModal.data = markViewModal.resolve.data;
    markViewModal.isViewMode = !markViewModal.resolve.item.editable;
    markViewModal.canAddNewMarks = markViewModal.resolve.canAddNewMarks;
    markViewModal.viewPattern = '{{item.amc | egaisBarcode}}';
    markViewModal.skuInfo = markViewModal.resolve.values;
    // проверяется возможность добавлять марки к существующем ( в саписаниях можно, в ттн нельзя)
    markViewModal.canAddMark = !!($state.current.name.indexOf('cancellationAct') + 1);
    markViewModal.isCancelAct = markViewModal.canAddMark;

    // флаг для вопроса "надо ли спрашивать про сохранение старой марки"
    markViewModal.noQuestion = userSettingsService.loadProperty('alcoDocuments', 'marks', 'needSaveOldMarks') || false;


    // буфер автоматического сканирования (аккумулятор вводимых символов)
    markViewModal.scanBuffer = '';

    markViewModal.close = function() {
      markViewModal.modalInstance.close(markViewModal.data);
    };

    function addMarks (marksArr, mark) {
      if (!markViewModal.resolve.multiSelect) {
        marksArr = [mark];
      } else {
        if(!_.find(marksArr, function(amc){
          return amc.amc == mark.amc;
        })) {
          marksArr.push(mark);
        }
      }
    }

    /**
     * Поиск марок из тех что пришли с бэка
     */
    markViewModal.submitBarcode = function (cleanData, barcode, searchAllStr) {
      var result = $q.defer();
      markViewModal.barcode = barcode || markViewModal.barcodeSearch;
      markViewModal.scanBuffer = '';
      markViewModal.noAcceptedKey = undefined;
      markViewModal.acceptedKey = undefined;
      markViewModal.notFoundOldMark = markViewModal.canAddMark; // флаг чтобы понять найдена ли старая марка на балансе илив принятых марках
      // в обертке с таймаутом из-за необходимости дождаться проброса нового занчения в модель при сканировании
      $timeout(function () {
        if (!markViewModal.resolve.multiSelect) {
          _.forEach(markViewModal.data.no_accepted_amcs, function(mark){
            mark.$$selected = false;
            markViewModal.noAcceptedAmcsSelected = [];
          });
          _.forEach(markViewModal.data.accepted_amcs, function(mark){
            mark.$$selected = false;
            markViewModal.acceptedAmcsSelected = [];
          });
        }

        _.find(markViewModal.data.no_accepted_amcs, function(mark, key){
          if((!searchAllStr && mark.amc.indexOf(markViewModal.barcode) + 1) ||
             (searchAllStr && mark.amc == markViewModal.barcode)) {
            mark.$$selected = true;
            markViewModal.noAcceptedKey = key;
            markViewModal.notFoundOldMark = false;
            addMarks(markViewModal.noAcceptedAmcsSelected, mark);
            return mark;
          }
        });
        _.find(markViewModal.data.accepted_amcs, function(mark, key){
          if((!searchAllStr && mark.amc.indexOf(markViewModal.barcode) + 1) ||
             (searchAllStr && mark.amc == markViewModal.barcode)) {
            mark.$$selected = true;
            markViewModal.barcode = '';
            markViewModal.acceptedKey = key;
            markViewModal.notFoundOldMark = false;
            addMarks(markViewModal.acceptedAmcsSelected, mark);
            return mark;
          }
        });

        if ((!markViewModal.canAddMark && markViewModal.barcode) ||
           // если марка старая и её нигде не нашли, и cтоит флаг больше не спрашивать, то добавлять автоматически в марки для списания
           (markViewModal.barcode && markViewModal.barcode.length == 68 && markViewModal.noQuestion && markViewModal.notFoundOldMark)) {
          markViewModal.moving('ACCEPTED', false, markViewModal.barcode);
        }

        if (cleanData) {
          markViewModal.barcode = '';
        }
      });
      // возврат промиса
      return result.promise;
    };

    // перемещение марок из принятых в непринятые и наоборот
    markViewModal.moving = function(type, isAll, newCode){
      var codes;
      if (!newCode) { // если не новая марка перемщается
        if(type == 'ACCEPTED'){ // переместить в принятые
          codes = (isAll)? markViewModal.data.no_accepted_amcs : markViewModal.noAcceptedAmcsSelected;
        }else{ // переместить в непринятые (в марки на балансе)
          codes = (isAll)? markViewModal.data.accepted_amcs : markViewModal.acceptedAmcsSelected;
        }

        if(!codes || !codes.length){
          return;
        }else{
          codes[0].$$canDelete = undefined;
        }
      } else { // если новая марка перемещается, старого образца
        if(type == 'ACCEPTED'){
          codes = [{ amc: newCode, amc_name: "", $$canDelete: true }];
        } else {
          // не перемещать не принятую марку старого образца в список с балансовыми марками.
          return;
        }
      }

      markViewModal.load = true;
      markViewModal.resolve.moveMarks(codes, type).then(function (data) {
        markViewModal.barcode = '';
        markViewModal.load = false;
        if (data.status == 404 || data.status == 400) {
          markViewModal.markNotFound = true;
        } else {
          _.forEach(data.accepted_amcs, function(mark){
            mark.$$selected = undefined;
          });
          _.forEach(data.no_accepted_amcs, function(mark){
            mark.$$selected = undefined;
          });
          markViewModal.data = data;
          markViewModal.acceptedAmcsSelected = [];
          markViewModal.noAcceptedAmcsSelected = [];
        }
      });
    };

    /**
     * Метод принимает вводимую информацию от сканера.
     * моментом аппрува введенных данных является либо превышение
     * таймаута с последнего события, либо энтер.
     *
     * @param keyEvent событие клвавиатуры
     */
    markViewModal.applyScannerKeys = function(keyEvent) {
      // оставнока таймера, т.к. ввод продолжен
      $timeout.cancel(markViewModal.scanTimer);
      if (keyEvent.keyCode == 13) {
        markViewModal.submitBarcode(false, markViewModal.scanBuffer, true).finally(function () {
          markViewModal.scanBuffer = '';
        });
      } else {
        var charFromEvent = undefined;
        if (keyEvent.originalEvent.code.startsWith('Digit')) {
          var charFromEvent = keyEvent.key;
        }
        if (keyEvent.originalEvent.code.startsWith('Key')) {
          charFromEvent = keyEvent.shiftKey ? keyEvent.originalEvent.code.charAt(3) : keyEvent.originalEvent.code.charAt(3).toLowerCase();
        }

        if (!/[a-zA-Z0-9]{1}/.test(charFromEvent)) {
          // допустимы только числа и буквенные символы
          markViewModal.scanBuffer = ''; // сброс аккумулятора из-за ошибки
          return;
        }

        if (charFromEvent !== undefined) markViewModal.scanBuffer += charFromEvent;

        if (markViewModal.scanBuffer)
        // новый таймер
        markViewModal.scanTimer = $timeout(function () {
          markViewModal.submitBarcode(false, markViewModal.scanBuffer, true).finally(function () {
            markViewModal.scanBuffer = '';
          });
        }, 200); // пока больше чем нужно, чтобы можно было тестить нормально
      }
    };

    markViewModal.removeMark = function (item) {
      markViewModal.resolve.removeMark(item).then(function(data){
        markViewModal.data = data;
      });
    }

    markViewModal.saveNoQuestionFlag = function(){
      markViewModal.noQuestion = markViewModal.noQuestionForSave;
      userSettingsService.saveProperty('alcoDocuments', 'marks', 'needSaveOldMarks', markViewModal.noQuestionForSave);
    };

  }
});


(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

// 'use strict';
// angular.module('frontend').component('viewLoader', {
//   template: '<div class="view-spinner-wrapper" ng-show="$ctrl.show">' +
//               '<div class="view-loader ui-spinner"></div>' +
//             '</div>',
//   controller: function ($rootScope) {
//     var ctrl = this;
//     ctrl.show = true;
//   }
// });


'use strict';
angular.module('frontend').component('inviewLoader', {
  bindings: {
    show: '<'
  },
  template: '<div class="{{$ctrl.class}}" ng-show="$ctrl.show">' +
              '<div class="inview-loader ui-spinner"></div>' +
            '</div>',
  controller: function ($state) {
    var ctrl = this;
    ctrl.class = $state.current.name + '-loader';
  }
});

'use strict';
angular.module('frontend').component('gridLoader', {
  replace: true,
  bindings: {
    show: '<'
  },
  template: '<div class="grid-spinner-wrapper" ng-show="$ctrl.show">' +
    '<div class="grid-loader ui-spinner"></div>' +
  '</div>',
  controller: function () {
    var ctrl = this;
    ctrl.show = true;

  }
});

'use strict';
angular.module('frontend').component('lastSyncDocDate', {
  templateUrl: 'app/components/last-sync-doc-date/last-sync-doc-date.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'lastSyncDocDateCtrl',
  controller: function ($scope, auth, $rootScope) {
    var lastSyncDocDateCtrl = this;
    lastSyncDocDateCtrl.needShow = false;
    lastSyncDocDateCtrl.danger = false;

    auth.syncDate().then(function (res) {
      lastSyncDocDateCtrl.date = Number(res.data.LAST_ACCOUNTING_DOCUMENT_HOLDING);
      var now = moment().tz($rootScope.user.time_zone).valueOf();
      var plus10min = moment(lastSyncDocDateCtrl.date).add(10, 'minutes').valueOf();
      var plus1hour = moment(lastSyncDocDateCtrl.date).add(1, 'hours').valueOf();

      if (plus10min > now) {
        lastSyncDocDateCtrl.needShow = false;
      } else if (plus10min < now && plus1hour > now) {
        lastSyncDocDateCtrl.needShow = true;
      } else if (plus1hour < now) {
        lastSyncDocDateCtrl.needShow = true;
        lastSyncDocDateCtrl.danger = true;
      }

    });

  }
});


(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('kladrLocation', kladrLocation);

  /** @ngInject */
  function kladrLocation() {
    var vm, input, location = {},
        directive = {
          restrict: 'E',
          templateUrl: 'app/components/kladr/kladr.html',
          scope: {
              locationData: '='
          },
          controller: locationController,
          controllerAs: 'vm',
          bindToController: true,
          link: kladrLink
        };

    return directive;

    /**
     * use of the library kladr
     * @param  $scope
     * @param  element
     */
    function kladrLink($scope, element) {
      location = {};
      input = element.find('input');
      input.kladr({
        type: 'city',
        typeCode : 'all',
        withParents : true,
        labelFormat: function (obj) {
          return locationFormat(true, obj, input);
        },
        valueFormat:function (obj) {
          return locationFormat(false, obj, input);
        },
        change: function (obj) {
          location.prev = locationFormat(false, obj, input);
          location.json = angular.toJson(obj);
        },
        select: function (obj) {
          var i, result = '',
              parents = obj.parents;
          for(i in parents){
            result += parents[i].type + " " + parents[i].name + ((i == parents.length-1)? '' : ", ");
          }
          setDescription(result);
        }
      });

      // value without kladr
      element.find('input')[0].oninput = function () {
        var val = element.find('input')[0].value;
        location.prev = val;
        location.json = val;
        vm.locationData = location;
        vm.location = location;
        if(!val) setDescription('');
      }

      // remove type name when backspase for correct search
      element.find('input')[0].onkeydown = function (event) {
        if(event.keyCode == 8){
          var typeAndName = this.value.split(/\u00A0/);
          if(typeAndName.length > 1){
            typeAndName.splice(0, 1);
            this.value = typeAndName.join(' ');
          }
        }
      }


    }

    /**
     * set description under field(region, area)
     * @param  text
     */
    function setDescription(text){
      vm.description = text;
    }

    /**
     * locationFormat string format in the location field
     * @param  boolean isUseTag
     * @param  obj
     * @return string
     */
    function locationFormat (isUseTag, obj) {
      if(obj){
        var resLabel = '', parents,
            cityStr = obj.typeShort + "&nbsp;" + obj.name;

        resLabel = (isUseTag)? "<div>" + cityStr + "</div>" : "";

        if(obj.hasOwnProperty("parents") && obj.parents.length){
          parents = obj.parents;
          resLabel = (isUseTag)? resLabel + "<i>" : "";
          for(var i in parents){
            resLabel += parents[i].type + " " + parents[i].name + ((i == parents.length-1)? '' : ", ");
          }
          if(isUseTag) resLabel += "</i>";
        }
        if(!isUseTag) resLabel = cityStr;

        return resLabel;
      }
    }

    /** @ngInject */
    function locationController(auth) {
      vm = this;
      if(vm.locationData && vm.locationData.prev){
        vm.location = vm.locationData;
        return;
      }
      if (!auth.isAuthenticated()) {
        auth.ensureSession().then(function() {
          vm.locationData = location;
        });
      } else {
        if(vm.locationData && !vm.locationData.prev){
          try{
            var parents, resLabel='';
            location.prev = locationFormat(false, angular.fromJson(vm.locationData)).replace("&nbsp;"," ");
            parents = angular.fromJson(vm.locationData).parents;
            for(var i in parents){
              resLabel += parents[i].type + " " + parents[i].name + ((i == parents.length-1)? '' : ", ");
            }
            setDescription(resLabel);
          } catch (e){
            location.prev = vm.locationData;
          }
          location.json = vm.locationData;
          vm.locationData = location;
          vm.location = location;
        }
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('trimValue', trimValue);

  /** @ngInject */
  function trimValue() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {

        element.on("input", function(){
          this.value = this.value.trim();
        });

      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('snilsCheck', snilsCheck);

  /** @ngInject */
  function snilsCheck() {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope:{
        model:'=ngModel'//ng-model родительского контроллера
      },
      link: function($scope, element, attrs,ctrl) {
        ctrl.$validators.validSnils = function (modelValue, viewValue) {
          var sum = 0,
              value = (modelValue)?new String(modelValue.replace(/[- _]/g,'')):'',
              compareWith = value[9]+''+value[10];
          if (value.length == 11) {
            if (value.search(/(.)\1{2}/) >= 0) {
              return false
            } else {
              for (var i = 0; i < 9; i++) {
                sum += value[i]*(9-i);
              }
              if (sum < 100 && sum == compareWith) {
                return true
              } else if ((sum == 100 || sum == 101) && compareWith == '00') {
                return true
              } else if ( sum > 101 && sum%101 == compareWith) {
                return true
              } else {
                return false
              }
            }
          } else {
            return true
          }
        }
      } //linl end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
  .module('frontend')
  .directive('selectionOnFocus', selectionOnFocus);

  /** @ngInject */
  function selectionOnFocus() {
    return {
      restrict: 'A',
      priority: 5,
      require: 'ngModel',
      // selectionOnFocus
      link: function($scope, element, attr, ctrl) {

        if (attr.hasOwnProperty('selectionOnFocus')) {
          var selectionOnFocus = eval(attr.selectionOnFocus);
          element.on('focus', function() {
            var value = element.val();
            $scope.$evalAsync(function() {
              if (~selectionOnFocus.indexOf(value)) {
                element[0].setSelectionRange(0, element.val().length);
              } else {
                element[0].setSelectionRange(element.val().length, element.val().length);
              }
            })
          });
        }

      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('phoneNumber', phoneNumber);

  /** @ngInject */
  function phoneNumber() {
    return {
      restrict: 'A',
      scope:{
        //стили для helpMessage по умолчанию position:absolute;color:red;
        messageStyle:'&?',
        //текст по умолчанию 'Недопустимые символы'
        messageText:'&?'
      },
      link: function($scope, element, attrs) {
        var test;
        $scope.messageStyle = $scope.messageStyle || 'position:absolute;color:red;';
        $scope.messageText = $scope.messageText || 'Недопустимые символы';
        //Собщение будет отображаться при вводи не валидных символов
        var message = '<span style="'+$scope.messageStyle+'display:none">'+$scope.messageText+'</span>';
        element.after(message);
        //
        element.keydown(function (e) {
          //проверка валидные символы игнорирую метаклавиши
          test = /[\d()+# -*]/.test(e.key) || //на только цифрый и ()+# -*
           (e.metaKey || e.shiftKey || e.altKey || e.ctrlKey || e.key == 'Backspace'|| (e.keyCode >=37 && e.keyCode <=40)); // метаклавиши
          // срытие и отображение подсказки
          test?element.next().hide():element.next().show();
          //добавление и обновление атрибута , необходим для отслеживания состояния( к этому атрибуту привязаны стили)
          //стандартные методы ангуляра не подходят , потому что плохо работают при return false в событии keypress
          element[0].setAttribute('valid-value',test)
        })
        element.on('keypress', function(e){
          //запрещает вводить не валидные символы
          return /[\d()+# -*]/.test(e.key)
        });

      } //link end
    } // return end
  } // function end
})();

'use strict';

angular.module('frontend').service('parseNumberSrv', function parseNumber() {
  this.parseValue = function (value, maxAfterComma) {

    var format = new Intl.NumberFormat('ru-Ru');

    if (typeof value != 'undefined') {
      var string = (value + '').split(/[,.]/);
      if (typeof string[1] == 'undefined') {
        string[1] = '00';
        if(maxAfterComma){
          string[1] = "0".repeat(maxAfterComma);
        }else{
          string[1] = undefined;
        }
      } else if (string[1].length == 1) {
        string[1] += '0';
      }
      if (string[0] == '') {
        value = undefined;
      } else {
        if (string[1] === undefined) {
          value = format.format(parseInt(string[0].replace(/\s/g,'')));
        } else {
          value = format.format(parseInt(string[0].replace(/\s/g,'')))+','+string[1];
        }
      }
      return value;
    }
  }
});

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('onlyNumbers', onluNumbers);

  /** @ngInject */
  function onluNumbers() {
    return {
      restrict: 'A',
      link: function($scope, element) {
        element.on('keypress', function(e){
          return /\d/.test(parseInt(e.key))
        })
      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('integerInput', integerInput);

  /** @ngInject */
  function integerInput() {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {model:'=ngModel', maxVal: '<', minVal: '<', 'hideFormat': '<'},
      link: function($scope, element, attr, ctrl) {
        var input = angular.element(element);
        var mask = 999999999999999; //целочисленная часть не больше 15
        
        //help functions
        function resetValidity() {
          input.attr('data-valid','');
          ctrl.$setValidity('wrong-simbol',true);
        }

        function onBlur(value) {
          resetValidity();
          element.keyup();
          if (ctrl.$viewValue != 0){
            ctrl.$viewValue = parseValue(parseInt(value));
          }
          ctrl.$render();
          $scope.model = parseInt(value);
        }

        function onFocus() {
          ctrl.$viewValue = parseInt($scope.model);
          ctrl.$render();
        }

        function parseValue(value) {
          ctrl.$viewValue = parseInt($scope.model);
          if (value && !$scope.hideFormat) {
            var format = new Intl.NumberFormat('ru-Ru');
            return format.format(value)
          }
          return value;
        }

        function createNumber(e,string,amount) {
          var number;
          e.preventDefault();
          if (parseInt(string) + amount <= mask) {
            number = parseInt(string) + amount + ''
          }
          if (number == 'NaN' || string == '') {
            number = '0'
          }
          resetValidity()
          return number;
        }

        //
        element.on('keydown', function(e){
          switch (e.key) {
            case 'ArrowUp':
            // +1
                this.value = createNumber(e,this.value,1) || this.value;
              break;
            case 'ArrowDown':
            // -1
              if (this.value != 0 ) {
                this.value = createNumber(e,this.value,-1) || this.value
              }
              break;
            default:
            break
          }
        });


        //отлов невалидных символов, оформление валидности по постановки
        element.on('keypress', function(e) {
          if(e.key.length < 2){
            var number = /\d/.test(parseInt(e.key));
            ctrl.$setValidity('wrong-simbol', number);
            input.attr('data-valid', number ? '' : 'wrong-simbol');

            return number;
          }
        });

        element.on('keyup', function(e) {
          function setValid(cond1, cond2) {
            if (cond1 && !cond2) {
              element.attr('data-valid', cond1 ? 'maxVal' : '');
            } else if (!cond1 && cond2) {
              element.attr('data-valid', cond2 ? 'minVal' : '');
            }
            ctrl.$setValidity('max', !cond1);
            ctrl.$setValidity('min', !cond2);
          }
          if (e.key === 'Backspace') {
            setValid(parseInt(this.value) > ($scope.maxVal || mask), parseInt(this.value) < ($scope.minVal || 0));
          } else  {
            setValid((parseInt(this.value) > ($scope.maxVal || mask)), (parseInt(this.value) < ($scope.minVal || 0)));
          }
        });

        element.on('focus', onFocus);

        element.on('blur', function () {
          onBlur(this.value === '' ? $scope.model : this.value)
        });

        ctrl.$parsers.push(function(viewValue) {
            return parseInt(viewValue)
         });

        ctrl.$formatters.push(function(modelValue) {
          if (modelValue) {
            return parseValue(modelValue) + ''
          }
          return modelValue
         });

      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('floatInput', ['parseNumberSrv', '$timeout',floatInput]);

  /** @ngInject */
  function floatInput(parseNumberSrv, $timeout) {
    return {
      restrict: 'A',
      require: 'ngModel',
      replace:false,
      scope: {
        maxIntLength:'<?',// максимальная целочисленная часть колличество символов
        floatFixed:'<?', //округление до запятой по умолчанию 4
        floatStep:'<?', // шаг по умолчанию 1
        maxAfterComma:'<?',//,// максимально символов после запятой,
        maxVal: '<?',
        minVal: '<?',
        noEmpty: '<?'
      },//Стоит заметить , что если необходимо изменить цвет текста в инпуте так же нужно изменить цвет input::placeholder и изменить цвет в элементе с классом currency-input-addon
      link: function($scope, element,attr,ctrl) {
        var input = angular.element(element);
        var mask = 999999999999999; //целочисленная часть не больше 15
        $scope.maxAfterComma = ($scope.maxAfterComma == undefined)? 4 : $scope.maxAfterComma;

        function replaceComma(value) { // заменяет запятую
          if (/,/.test(value)) value = value.replace(/,/,'.');
          if (/\s/.test(value)) value = value.replace(/\s/,'');
          return value
        }

        function replaceFullstop(value) { // заменяет точку
          if (/\./.test(value)) {
            value = value.replace(/\./,',');
          }
          return value
        }

        function resetValidity() { // обнуляет валидность
          input.attr('data-valid','');
          ctrl.$setValidity('wrong-simbol', true);
        }

        function onFocus() { // превращает строку в число после toLocaleString
          if (parseFloat(ctrl.$modelValue) === 0 || (ctrl.$viewValue && ctrl.$viewValue.match('^0,[0]+$'))) {
            ctrl.$viewValue = '';
            //ctrl.$modelValue = '';
          } else if (angular.isNumber(ctrl.$modelValue) ||  $scope.noEmpty) {
            if (ctrl.$modelValue !== '') {
              ctrl.$viewValue = replaceFullstop(parseFloat(replaceComma(ctrl.$modelValue+''))+'');
            } else {
              ctrl.$modelValue = '';
            }
          }
          ctrl.$render();
        }

        function parseValue(value) { // возварщает строку после преобразованией toLocaleString
          return parseNumberSrv.parseValue(value, $scope.maxAfterComma)
        }

        function onBlur(value) { // превращает то что видно в инпуте через toLocaleString
          if ($scope.noEmpty || parseFloat(value.replace(/,/g, '.')) != 0) {
            ctrl.$setViewValue(parseValue(value));
            ctrl.$render();
            resetValidity();
          } else {
            ctrl.$viewValue = ''
            ctrl.$modelValue = '';
            ctrl.$render();
            if (input.attr('required') == 'required') {
              ctrl.$setValidity('wrong-simbol', false);
            }
          }
        }

        function calculateStep(string) { // расчет шага на увеличение/уменьшение в зависимости от положения запятой
          if (/\./.test(string)) {
            var length = replaceComma(string).split('.')[1].length;
            var  step='0.';
            for (var i = 0; i < length - 1 ; i++) {
              step += '0'
            }
            step += '1';
            if (!attr.floatStep) {
              $scope.floatStep = parseFloat(step);
            }
            if (attr.floatFixed === undefined) {
              $scope.floatFixed = step.length - 2;
            }
          }
        }

        function createNumber(string,amount) { // добавляет/отнимает указанное колличество с учетом шага
          var number;
          if (/\./.test(string)) {
            calculateStep(string);
            number = (parseFloat(replaceComma(string)) + amount * $scope.floatStep).toFixed($scope.floatFixed > $scope.maxAfterComma ? $scope.maxAfterComma : $scope.floatFixed ) + ''
          } else {
            number = parseFloat(string) + amount + ''
          }
          return number
        }

        function makeChanges(e,string,amount) { // увеличение/уменьшение
          e.preventDefault();
          var number = string;
          if (parseFloat(string) + amount <= 999999999999999) { // не дает перейти на опасные числа
            number = createNumber(string,amount)
          }
          if (number == 'NaN' || string == '' || parseFloat(number) <= 0) {
            number = 0;
          }
          resetValidity();
          return number
        }
        //

        function onKeyDown(e) {
          e.key = e.key || '';
          switch (e.key) {
            case 'ArrowUp':
              // +1
              this.value = replaceFullstop(makeChanges(e,replaceComma(this.value),1));
              break;
            case 'ArrowDown':
              // -1
              if (this.value != 0 ) {
                this.value = replaceFullstop(makeChanges(e,replaceComma(this.value),-1))
              }
              break;
            default:
              calculateStep(this.value);
              break
          }

          function setValid(cond1, cond2) {
            if (cond1 && !cond2) {
              element.attr('data-valid', cond1 ? 'maxVal' : '');
            } else if (!cond1 && cond2) {
              element.attr('data-valid', cond2 ? 'minVal' : '');
            } else if (!cond1 && !cond2) {
              element.attr('data-valid', '');
            }
            ctrl.$setValidity('max', ! cond1);
            ctrl.$setValidity('min', ! cond2);
          }

          var val = parseFloat(replaceComma(this.value.slice(0, this.selectionStart) + e.key + this.value.slice(this.selectionEnd)));
          var val2 = parseFloat(replaceComma(this.value.slice(0,this.value.length - 1)));
          var val3 = parseFloat(replaceComma(this.value));
          var hasMaxValue = $scope.hasOwnProperty('maxVal');

          if (e.key === 'Backspace') {
            setValid((val2 > ($scope.maxVal || (hasMaxValue ? 0: mask))), (val2 < ($scope.minVal || 0)));
          } else if (!e.key.includes('Arrow')) {
            setValid((val > ($scope.maxVal || (hasMaxValue ? 0: mask))), (val < ($scope.minVal || 0)));
          } else {
            setValid((val3 > ($scope.maxVal ||( hasMaxValue ? 0: mask))), (val3 < ($scope.minVal || 0)));
          }
        }

        element.on('keydown', onKeyDown); // увеличение/уменьшение

        element.on('keyup', function() {
          element.keydown()
        }); // триггер валидации

        element.on('paste', function(event) {
          $timeout(function(){ // без таймаута имеем не обновленное value
            if (event.target.value && parseFloat(event.target.value) > 0) {
              ctrl.$viewValue = parseFloat(event.target.value).toFixed($scope.maxAfterComma);
              ctrl.$modelValue = parseFloat(event.target.value).toFixed($scope.maxAfterComma);
              ctrl.$render();
            } else {
              ctrl.$viewValue = ''
              ctrl.$modelValue = '';
              ctrl.$render();
            }
          }, 0);
        });

        //отлов невалидных символов, оформление валидности по постановки
        element.on('keypress', function(e){
          if(e.key.length < 2){
            var commaOrFullstop = e.key === '.' || e.key === ',', // вводится точка или запятая
              hasComma = /,/.test(this.value), // есть уже одна запятая
              number = /\d/.test(parseFloat(e.key)),// вводится число
              maxIntLength =  this.value.length >= ($scope.maxIntLength || mask.toString().length + 2),//целочисленная часть не больше 15
              somethingSelected = window.getSelection().toString() != '', // если что-то выбрано ( необходимо что бы восстановить нормально поведение, из-за ограничение на целочисленную часть в 15 сиволов);
              commaInRightPlace = true;
            if (this.value.length > $scope.maxAfterComma) {
              commaInRightPlace = this.selectionEnd >= Math.abs(this.value.length - $scope.maxAfterComma) && this.selectionEnd <= ($scope.maxIntLength||this.value.length)
            }
            if (hasComma) {
              var fullFloatValue = replaceFullstop(this.value).split(',')[1].length == $scope.maxAfterComma, // есть 4 символа после запятой
                cursorAtIntPart = replaceFullstop(this.value).split(',')[0].length >= this.selectionEnd,// курсор в целочисленной части числа
                selectionPartInFloat = this.selectionEnd - this.selectionStart <= $scope.maxAfterComma + 1 && this.value.length - this.selectionEnd <= $scope.maxAfterComma + 1; //выделенная часть в дробной части + запятая , нужно для замены значения при выделении
              maxIntLength = replaceFullstop(this.value).split(',')[0].length >= ($scope.maxIntLength || mask.toString().length + 2);
            }
            ctrl.$setValidity('wrong-simbol',number || commaOrFullstop);
            input.attr('data-valid', number || commaOrFullstop || e.key === 'Enter' || e.key === 'Backspace' ?'':'wrong-simbol');
            if (number) { // если вводится число
              if (hasComma) { // если есть запятая
                if (selectionPartInFloat && !cursorAtIntPart) { // Заменяет значение при выделении дробной части
                  e.preventDefault();
                  var newValue = this.value.slice(0,this.selectionStart) + e.key;
                  if (/,/.test(newValue)) {
                    if (replaceFullstop(newValue).split(',')[1].length <= $scope.maxAfterComma) {
                      this.value = newValue
                    }
                  } else {
                    this.value = newValue
                  }
                } else {
                  return !fullFloatValue || (!maxIntLength && cursorAtIntPart) || somethingSelected  // ввод разрешается , если курсор в целочисленной части, или в дробной части , но до 4 знаков после запятой
                }
              } else { // если запятой нет
                return number &&  (!maxIntLength || somethingSelected) // можно ввести цифры
              }
            } else if (commaOrFullstop && commaInRightPlace) { // если вводится точка или запятая
              if (e.key === '.' && !hasComma) {
                e.preventDefault();
                var cursor = this.selectionStart;
                this.value = this.value.slice(0,this.selectionStart)+','+this.value.slice(this.selectionStart,this.value.length);
                this.selectionEnd = cursor + 1;
              }
              return !hasComma  // можно поставить запятую, если ее нет + что бы целочисленная часть не была больше установленной
            } else {
              return e.key === 'Backspace' // запрещает вводить все кроме точек/ запятой и цифр
            }
          }
        });

        element.on('blur', function () {
          if ($scope.noEmpty && !parseFloat(this.value.replace(/,/g, '.'))) {
            onBlur('0');
          } else {
            onBlur(this.value);
          }
        });

        element.on('focus',onFocus);


        ctrl.$parsers.push(function(viewValue) {
          return parseFloat(replaceComma(viewValue.replace(/\s/g,''))) // в контроллер всегда идет число
        });

        ctrl.$formatters.push(function(modelValue) {
          if (modelValue) {
            var source = angular.isNumber(modelValue) ? modelValue.toFixed($scope.maxAfterComma).toString() : modelValue;
            return parseValue(replaceFullstop(source)).toString(); // в форму идет красивое число через toLocaleString
          }
        });

        if ($scope.noEmpty) {
          ctrl.$formatters.push(function(value) {
            return (!parseFloat(value)) ? '0' : value;
          });
          //onBlur('0');
        }

        if ($scope.hasOwnProperty('minVal') || $scope.hasOwnProperty('maxVal')) { // вотчер на изменения
          $scope.$watchGroup(['minVal', 'maxVal'], function() {
            element.keydown()
          })
        }

      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('currencyInput', floatInput);

  /** @ngInject */
  function floatInput() {
    return {
      restrict: 'A',
      priority: 10,
      // currencyIcon:'@?',//  иконка валюты установить как атрибут
      // emptyValues: '@?'
      //showZeros
      //Стоит заметить , что если необходимо изменить цвет текста в инпуте так же нужно изменить цвет input::placeholder и изменить цвет в элементе с классом currency-input-addon
      link: function($scope, element, attr) {
        var fake;
        var maxAfterComma = parseInt(attr.maxAfterComma);
        attr.currencyIcon = attr.currencyIcon || '';
        attr.nonCurrencyUom = attr.nonCurrencyUom === 'true';
        attr.emptyValues = attr.emptyValues === 'true';
        var elem = angular.element(document.createElement('SPAN'));
        elem.addClass('form-control form-control--fake');
        elem.html('<span class="int"></span><span class="float"></span><span class="icon currency-font"></span>');
        element.after(elem);
        fake = angular.element(elem);
        var placement = 'left';



        if (attr.tooltip === 'on') {
          fake.tooltip({
            trigger: 'manual',
            placement: function () {
              return placement
            },
            title: function () {
              return fake[0].innerText;
            },
            template: '<div class="tooltip no-arrow" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
          });
          fake.on('mouseover', function () {
            var isFits = fake[0].scrollWidth > fake[0].offsetWidth;
            var right = Math.abs(angular.element(window).width() / 2 - fake[0].getBoundingClientRect().right);
            var left = Math.abs(angular.element(window).width() / 2 - fake[0].getBoundingClientRect().left);
            placement = right > left ? 'left' : 'right';
            if (isFits) {
              fake.tooltip('show');
            }
          });
          fake.on('mouseleave', function () {
            fake.tooltip('hide');
          });
        }

        function buildFakeContent() {
          var int = fake.find('.int'),
            float = fake.find('.float'),
            icon = fake.find('.icon'),
            value = element.val(),
            intVal, floatVal, iconVal;
          if ((!value || value.length === 0) && !attr.showZeroes) {
            intVal = null;
            floatVal =  null;
            iconVal = null;
          } else if (attr.showZeroes && !value) {
            intVal = '0';
            floatVal =  ',00';
            iconVal = ' ' + attr.currencyIcon;
          } else {
            var val = value.split(/[,.]/)[0].replace(/\s/gi, '');
            intVal = new Intl.NumberFormat('ru-RU').format(parseInt(val));
            floatVal =  value.split(/[,.]/)[1] ? ',' + value.split(/[,.]/)[1] : ',00' ;
            iconVal = ' ' + attr.currencyIcon;

            if (attr.nonCurrencyUom && floatVal.length > maxAfterComma + 1) {
              floatVal = floatVal.slice(0, maxAfterComma + 1 - floatVal.length );
            }
          }
          int.text(intVal);
          float.text(floatVal);
          icon.text(iconVal);
        }

        fake.on('click', function () {
          if (attr.disabled) {
            return;
          }
          element.focus();
          fake.addClass('active');
        });

        element.on('blur', function () {
          fake.removeClass('active');
          buildFakeContent();
        });

        $scope.$watch(function () {
          return element.attr('currency-icon')
        } , function () {
          buildFakeContent();
        });

        $scope.$watch(function() {
          return element.val();
        }, function() {
          buildFakeContent();
        });

        buildFakeContent();

      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('innCheck', innCheck);

  /** @ngInject */
  function innCheck() {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope:{
        model:'=',//ng-model родительского контроллера
        innType:'@'//физ-лицо = fiz, Юр-лицо = ur
      },
      link: function($scope, element, attrs, ctrl) {

        ctrl.$validators.validInn = function(modelValue, viewValue) {
          var value = new String(modelValue);
          var sum = 0,
              validInn;
          if (( attrs.innType === 'ur' && value.length === 10) || value.length === 10) {
            validInn = value[9]+'';
            sum = (((2*value[0] +
                     4*value[1] +
                     10*value[2] +
                     3*value[3] +
                     5*value[4] +
                     9*value[5] +
                     4*value[6] +
                     6*value[7] +
                     8*value[8])%11)%10);
            return sum == validInn;
          } else if (( attrs.innType === 'fiz' && value.length === 12) || value.length === 12){
            validInn = value[value.length-2]+''+value[value.length-1];
            sum = [(((7*value[0] +
                     2*value[1] +
                     4*value[2] +
                     10*value[3] +
                     3*value[4] +
                     5*value[5] +
                     9*value[6] +
                     4*value[7] +
                     6*value[8] +
                     8*value[9])%11)%10),
                  (((3*value[0] +
                    7*value[1] +
                    2*value[2] +
                    4*value[3] +
                    10*value[4] +
                    3*value[5] +
                    5*value[6] +
                    9*value[7] +
                    4*value[8] +
                    6*value[9] +
                    8*value[10])%11)%10)];
            sum = sum[0]+''+sum[1];
            return sum == validInn;
          } else {
            return true
          }
        }

      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('ignoreDirty', ignoreDirty);

  /** @ngInject */
  function ignoreDirty() {
    var directive = {
      restrict: 'A',
      require: 'ngModel',
      link: function(scope, elm, attrs, ctrl) {
        if (attrs.ignoreDirty) {
          ctrl.$setPristine = function() {};
          ctrl.$pristine = false;
        }
      }
    };
    return directive;
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('hardPruning', hardPruning);

  /** @ngInject */
  function hardPruning() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {

        var input = angular.element(element),
            elem = element[0];

        function prunOnInput(obj,e,cond) {
          var cursorPosition = getCaretPosition(),
              val = obj.value,
              str = pruning(val);
          if (attrs.formName) {
            scope[attrs.formName][attrs.name].$setViewValue(str);
            scope[attrs.formName][attrs.name].$render();
          } else {
            obj.value = str;
          }
          if(val.length != str.length) setCaretPosition(cursorPosition-1);

          if (cond) {
            input.removeAttr('data-valid');
          }

        }

        element.on("input", function(e){
          prunOnInput(this,e, e.originalEvent.inputType == 'insertFromPaste');
        });

        element.on("blur", function(e){
          prunOnInput(this,e,true)// нужно при смены инпута для модели например  в контрагентах при смене типа
          if (!e.isTrigger) {
            element.trigger('change');// для изменения модели
            if(input.hasClass("ng-valid-mask")){
              input.removeAttr('data-valid');
              if(input.val() && input.hasClass('ng-empty')){
                input.val("");
              }
            }

            if(input.attr('data-valid') == 'wrong-simbol'){
              input.attr('data-valid', '');
            }
            if(input.val() !== '' && !checkRegExp(attrs.pattern, this.value)){
              input.attr('data-valid', 'wrong-format');
            } else {
              input.attr('data-valid', '');
            }
            if (attrs.required && !this.value) {
              input.attr('data-valid', 'required');
            }
            //Для показа и скрытия доп элементов у инпута , актуально для инпута ПДФЛ
            hideAndShow(input.attr('data-valid') == 'wrong-simbol' || input.attr('data-valid') == 'required')

            this.value = this.value.trim();
          } else {
            hideAndShow(false);
          }
        });

        //help function для PDFL
        function hideAndShow(condition) {
          if (input.hasClass('pdfl-input')) {
            input.attr('message-shown', input.attr('data-valid') == 'wrong-simbol' || input.attr('data-valid') == 'required');
              if (condition) {
                input.parent().next().hide();
              } else {
                input.parent().next().show();
              }
          }
        }

        /*
         * Проверка по regExp
         * @param  value исходное значение
         */
        function checkRegExp(reg, val){
          var regExp = new RegExp(reg, 'g');
          return val.match(regExp);
        }

        /*
         * Обрезка некорректных символов
         * @param  value исходное значение
         */
        function pruning(value){
          var pattern = (attrs.check)? attrs.check : attrs.pattern;
          var arr = checkRegExp(pattern, value);

          if (value !== '') {
            if(attrs.check){
              if(arr && value == arr.join('')){
                input.attr('data-valid', 'wrong-format');
              }else {
                input.attr('data-valid', 'wrong-simbol');
              }
              if(arr && attrs.check && attrs.pattern){
                var arr1 = checkRegExp(attrs.pattern, value);
                if(arr1 || !arr){
                  input.attr('data-valid', '');
                }
              }
            }else{
              if(arr && value != arr.join('')){
                input.attr('data-valid', 'wrong-simbol');
              }else{
                input.removeAttr('data-valid');
              }
            }
          }
          if (attrs.required && !value) {
            input.attr('data-valid', 'required');
          }
          //Для показа и скрытия доп элементов у инпута , актуально для инпута ПДФЛ
          hideAndShow(input.attr('data-valid') == 'wrong-simbol' || input.attr('data-valid') == 'required')

          return (arr)? arr.join('') : "";
        }

        /*
         * Узнать позицию курсора в input
         * @param  value исходное значение
         */
        function getCaretPosition(){
          var cursorPos = null;
          if (document.selection){ // for IE
            var range = document.selection.createRange();
            range.moveStart('textedit', -1);
            cursorPos = range.text.length;
          }else{
            cursorPos = elem.selectionStart;
          }
          return elem.selectionStart;
        }

        function setCaretPosition(caretPos) {
          if(elem != null) {
            if(elem.createTextRange) { // for IE
              var range = elem.createTextRange();
              range.move('character', caretPos);
              range.select();
            } else {
              if(elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
              }
              else
                elem.focus();
            }
          }
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('code', code);

  /** @ngInject */

  // Директива штрих-кода требует :
  // 1 - классы input-group code-wraper в диве обертке
  // 2 - класс code-input в самом инпуты
  // pattern и data-check для hard-pruning можно поменять
  function code($state, catalogService, $timeout, $uibModal, utilsService) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        gtinType: "=?",
        generateBarcode: "<?"
      },
      link: function($scope, element, attr, ctrl) {
        element.after('<span class="generate-barcode"data-toggle="tooltip" data-placement="top" title="Создать собственный штрих-код"></span>'); // волшебная палочка с генерацией штрихкода
        element.next().after('<span class="code-sprite"></span>'); // элемент, который будет картинкой
        element.next().next().after('<div class="code-tooltip" style="display:none"></div>') ;//подсказка о том какой тип штрих-кода мы определили

        var magic = element.next(),
            span = magic.next(),
            tooltip = span.next(),
            tooltipCanBeShown = false;

        span.next().after('<div class="valid-message wrong-check-sum-mess">Некорректный штрих-код</div>');
        magic.tooltip();
        //help functions
        function choosePicture(value) {// главная функция директивы - выбирает картику , меняет текст в подсказке. Cрабатывает на блюр
          var length = new String(value).length;
          span.removeClass().addClass('code-sprite');
          tooltipCanBeShown = true;
          function setTooptip(className, type) {
            if (check['check' + className](value)) {
              span.addClass('code' + className);
              tooltip.html('<span class="code-tooltip-mess">Мы определили, что вы используете штрих-код ' + type + '</span>');
              $scope.gtinType = type;
            } else {
              // если при попытке определить штрих код не пройдена проверка на контрольную сумму, штрих код
              // считается кастомным (иного значения по-умолчанию не предусмотрено)
              $scope.gtinType = "CUSTOM";
              tooltip.html('');
            }
          }
          switch (length) {
            case 8:
              setTooptip('Ean8','EAN8');
              break;
            case 12:
              setTooptip('Upc','UPC');
              break;
            case 13:
              setTooptip('Ean13','EAN13');
              break;
            case 14:
              setTooptip('Itf14','ITF14');
              break;
            case 15:
              setTooptip('Ean13','EAN13_2');
              break;
            case 18:
              setTooptip('Ean13','EAN13_5');
              break;
            default:
              span.addClass('codeDefault');
              $scope.gtinType = "CUSTOM";
              tooltipCanBeShown = false;
              break;
          }
        }


        var check = {
          checkEan8: function(data){
            var result = 0;

            var i;
            for(i = 0; i < 7; i += 2){
              result += parseInt(data[i]) * 3;
            }

            for(i = 1; i < 7; i += 2){
              result += parseInt(data[i]);
            }
            return parseInt(data[7]) === (10 - (result % 10)) % 10;
          },
          checkEan13: function(data){
            var result = 0;

            var i;
            for(i = 0; i < 12; i += 2){
              result += parseInt(data[i]);
            }
            for(i = 1; i < 12; i += 2){
              result += parseInt(data[i]) * 3;
            }
            return parseInt(data[12]) === (10 - (result % 10)) % 10;
          },
          checkUpc: function(data){
            var result = 0;

            var i;
            for(i = 1; i < 11; i += 2){
              result += parseInt(data[i]);
            }
            for(i = 0; i < 11; i += 2){
              result += parseInt(data[i]) * 3;
            }
            return parseInt(data[11]) === (10 - (result % 10)) % 10;
          },
          checkItf14: function(data){
            var result = 0;

            for(var i = 0; i < 13; i++){
              result += parseInt(data[i]) * (3 - (i % 2) * 2);
            }
            return parseInt(data[13]) === Math.ceil(result / 10) * 10 - result;
          }
        };

        element.on('blur',function () {
          choosePicture(ctrl.$modelValue);
          if (!$scope.generateBarcode || ctrl.$modelValue || ($scope.generateBarcode && ctrl.$modelValue)) {
            magic.hide();
          } else {
            magic.show();
          }
        });

        span.on('mouseover',function () { // эмулирует ховер , ( ховер не используется , потому что есть зависимость от переменной tooltipCanBeShown, нет смысла показывает подсказку , если введенное значение не валидно )
          if (tooltipCanBeShown && tooltip[0].innerText) {
            tooltip.show()
          }
        });

        span.on('mouseout',function () { // эмулирует ховер
          tooltip.hide()
        });

        ctrl.$formatters.push(function (modelValue) { // вызывает главную функцию при установки значения из модели
          choosePicture(ctrl.$modelValue);
          return modelValue;
        });

        // спрятать кнопки генерации штрихкода у полей где уже указан штрих-код
        $timeout(function() {
          if (!$scope.generateBarcode || ($scope.generateBarcode && ctrl.$modelValue)) {
            magic.hide();
          }
        }, 0);

        $scope.$watch('generateBarcode', function(newVal, oldVal) {
          if (newVal) {
            magic.show();
          } else {
            magic.hide();
          }
        });

        // сгенерировать штрих-код
        magic.on('click',function () {
          if ($scope.generateBarcode) {
            catalogService.getBarcode().then(function(res){
              if (!res.data) {
                $uibModal.open({
                  templateUrl: 'app/catalog/modals/info-popup.html',
                  size: 'middle-width',
                  controller: function ($scope, $uibModalInstance) {
                    $scope.class = "info";
                    $scope.reqAttrButton = false;
                    $scope.mainTxt = "Невозможно сгенерировать штрих-код.";
                    $scope.descrTxt = 'Перейдите в <a target="_blank" href="#/catalog/attrSettings/?parent=' + $state.params.parent + '">Настройки каталога товаров и услуг</a> и увеличьте длину собственных штрих-кодов.';
                    $scope.close = function () {
                      $uibModalInstance.dismiss();
                    };
                    $scope.save = function () {
                      $uibModalInstance.dismiss();
                    };
                  }
                });
                return;
              } else {
                choosePicture(res.data.code);
              }
              ctrl.$setViewValue(res.data.code);
              ctrl.$render();
              $timeout(function() {
                $scope.$apply();
                magic.hide();
              }, 0);
            });
          }
        });

      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';
  // для добавления необходимого количества нулей для значений
  angular
    .module('frontend')
    .directive('addZeroes', addZeroes);

  /** @ngInject */
  function addZeroes() {
    return {
      restrict: 'A',
      require: 'ngModel',
      replace: false,
      scope: {
        maxlength:'<?'// максимальная целочисленная часть колличество символов
      },
      link: function($scope, element, attr, ctrl) {
        var input = angular.element(element);

        element.on('blur', function () {
          if(parseInt(ctrl.$viewValue) !== 0 && ctrl.$viewValue.length && ctrl.$viewValue.length < $scope.maxlength){
            var res = '';
            for (var i = 0; i < ($scope.maxlength - ctrl.$viewValue.length); i++) {
              res += '0'
            }
            res += ctrl.$viewValue;
            ctrl.$setViewValue(res);
            ctrl.$render();
          }
        });


      } //link end
    } // return end
  } // function end
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('imgLoadEvent', imgLoadEvent);

  function imgLoadEvent() {
    return {
      restrict: 'A',
      link: function(scope, element, attributes) {
        element.removeClass("img-loaded");
        var image = new Image();
        image.onload = function () {
          // the image must have been cached by the browser, so it should load quickly
          scope.$apply(function () {
            element.css({ backgroundImage: 'url("' + attributes.imgLoadEvent + '")' });
            element.addClass("img-loaded");
          });
        };
        image.src = attributes.imgLoadEvent;

      }
    } // return end
  } // function end
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('headerTemplateWithTooltip', headerTemplateWithTooltip);

  function headerTemplateWithTooltip() {
    var directive = {
      restrict: 'A',
      scope: true,
      link: function ($scope, $element) {
        var placement = 'left';
        $scope.gridCustomUsed = $scope.$parent.gridCustomHeaderCtrl && $scope.$parent.gridCustomHeaderCtrl.column;
        $element.tooltip({
          trigger: 'manual',
          placement: function () {
            return placement
          },
          title: function () {
            if ($scope.col) {
              return ($scope.col.displayName || '').replace('&nbsp;', ' ');
            } else if ($scope.gridCustomUsed) {
              return ($scope.$parent.gridCustomHeaderCtrl.column.name || '').replace('&nbsp;', ' ');
            } else {
              return ''
            }
          },
          template: '<div class="tooltip no-arrow" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        });
        $element.on('mouseover', function () {
          var cell = $element.children()[0];
          var span = cell.children[0];
          var isFits = $scope.gridCustomUsed ?  span.scrollWidth > span.offsetWidth  :span.offsetWidth + 1 > (cell.offsetWidth - 32); //сравнение ширины
          var right = Math.abs(angular.element(window).width() / 2 - cell.getBoundingClientRect().right);
          var left = Math.abs(angular.element(window).width() / 2 - cell.getBoundingClientRect().left);
          placement = right > left ? 'left' : 'right';
          if (isFits) {
            $element.tooltip('show');
          }
        });
        $element.on('mouseleave', function () {
          $element.tooltip('hide');
        });
      }
    };
    return directive;
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('gridWide', gridWide);

  function gridWide() {
    return {
      restrict: 'E',
      templateUrl: 'app/components/grid-wide/grid-wide.directive.html',
      controllerAs: 'ctrl',
      scope: {
        //урл по которому будет происходить обращение к бэку для заполнения справочника
        url: '=',
        // страница по котороый можно будет сохранятся настройки
        page: '=',
        //заголовок
        header: '=',
        // индивидуальная строка, о том что нет данных
        noDataStr: '<?',
        // массив с параметрами кнопок
        /*
        {
          class: string
          url: string
          action: function
          permission: string
          text: string
        }
         */
        gridButtonConfig: '<?',
        //
        defaultPosition: '<?',
        // количество запиненных колонок (без учета служебной колонки с чек-боксами)
        baseColumnsCount: '<?',
        filtersRequired: '=',
        // строка имени состояния
        rowRoute: '=?',
        // функция роутинга (коллбек, определяющий переход на состояние)
        rowRouteFunc: '<?',
        // рабочее название флага для режима работы грида в складских остатков
        onlyReadMode: '<',

        isSku: '=',
        sort: '=',
        sortOrder: '=',
        limit: '=',
        startPage: '<?', // указание на переход на конкретную страницу
        currency: '=',
        columnDefs: '=',
        usingService: '=',
        filterMeta: '<',
        config: '<?',
        searchPlaceholder: '<?',
        stopEditing: '<?', // Период в днях, в течение которого от даты документа возможно его редактирование
        needAddToCart: '<?', // открывается функционал добавления товара или услуги в корзину
        noSearchOnLoad:  '<?', // отменяет автопоиск при загрузке странички, чтобы поиск осуществлялся только по клику на кнопку "Поиск"
        callbacksForLine:  '<?', // объект из колбэков, которые необходимы для шаблонов с строках row (type="text/ng-template")
        lastSync: '<?' // Необходимость отображать актуальность данных
      },
      controller: function ($scope,
                            $state,
                            $window,
                            returnCrudColumnDefsService,
                            settingsEntitiesService,
                            filterFactoryService,
                            userSettingsService,
                            returnsColumnDefsService,
                            uiGridConstants,
                            $document,
                            cashregisterShiftsService,
                            $uibModal,
                            modalAskSrv,
                            $q,
                            documentService,
                            $location,
                            $rootScope,
                            $timeout,
                            TIMEOUT_THROTTLE,
                            cartService,
                            errorMessageService,
                            requestStatus) {
        var ctrl = this;

        $scope.config = $scope.config || {};
        ctrl.stateName = $state.current.name;
        ctrl.parent = $state.params.parent;
        ctrl.currency = $scope.currency;
        ctrl.filterMeta = $scope.filterMeta;
        ctrl.dataIsLoaded = $scope.config && !$scope.config.preventRequest;
        ctrl.savedFilterListSearchText = 1;
        ctrl.needAddToCart = $scope.needAddToCart;
        ctrl.searchPlaceholder = $scope.searchPlaceholder;
        ctrl.noSearchOnLoad = $scope.noSearchOnLoad;
        ctrl.lastSync = $scope.lastSync;
        ctrl.isCrud = $scope.page.indexOf('crud') > -1;
        ctrl.gridFooterPaging = [25, 50, 100];
        $scope.config.searchPlaceholder = $scope.searchPlaceholder;

        // todo надо будет пересмотреть
        $scope.searchHelper = {search: ctrl.searchText};
        $scope.$watch('searchHelper', function (newVal, oldVal) {
          ctrl.searchText = newVal.search;
        }, true);

        if (ctrl.isCrud) {
          ctrl.gridFooterPaging = [5, 10, 25]
        }
        ctrl.copyfilter = {};
        var hasBaseMode = $scope.config && $scope.config.filterFields && $scope.config.filterFields.find(function (value) {
          return value.code === 'base_mode'
        })
        ctrl.currentBaseMode = userSettingsService.loadProperty($scope.page, 'grid', 'base_mode');

        // одна запиненная колонка по-умолчанию
        ctrl.baseColumnsCount = $scope.baseColumnsCount || 2;

        this.gridOptions = {
          enableSorting: false,
          enableColumnResizing: true,
          enableColumnMoving: true,
          useExternalSorting: true,
          useExternalFiltering: true,
          enableGridMenu: true,
          enableFiltering: true,
          enableRowSelection: true,
          enableRowHeaderSelection: false,
          multiSelect: false,
          excessRows: 100,
          excessColumns: 0,
          showColumnFooter: true,
          enablePinning: true,
          gridMenuTemplate: '<grid-menu></grid-menu>',
          rowHeight: 40
        };
        if ($scope.config.universalDocuments) {
          this.gridOptions.enableRowSelection = true;
          this.gridOptions.multiSelect = true;
          this.gridOptions.enableRowSelectionAll = true;
        }

        if ($scope.config.gridOptions) {
          Object.keys($scope.config.gridOptions).forEach(function (value) {
            ctrl.gridOptions[value] = $scope.config.gridOptions[value];
          })
        }

        this.gridFilter = filterFactoryService.createFilter($scope.page, 'grid');
        this.conditions = '';
        if ($scope.page === 'cashregister-shifts-crud') {
          this.currentTransType = 'SALES';
        }

        // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
        this.crudState = {
          error: false,
          message: '',
          loading: false,
          // Утилитарный метод устанавливающий флаги состояния загрузки
          startLoading: function () {
            ctrl.error = false;
            ctrl.message = '';
            ctrl.loading = true;
          },
          stopLoadingSuccess: function () {
            ctrl.error = false;
            ctrl.message = '';
            ctrl.loading = false;
          },
          stopLoadingFailure: function (message) {
            ctrl.error = true;
            ctrl.message = message;
            ctrl.loading = false;
          }
        };

        this.showRefunds = function () {
          this.currentTransType = 'REFUNDS';
          this.getPage();
        };
        this.showSales = function () {
          this.currentTransType = 'SALES';
          this.getPage();
        };

        // для дополнительных статусов документа, в зависимости от настройни всех документов
        this.getStatus = function (row) {
          if (row && row.dataValue && (row.dataValue.status || row.dataValue.document_status) && angular.isDefined(row.dataValue.changeable_status)) { // для грида документов
            if ((row.dataValue.status === 'DRAFT' || row.dataValue.document_status === 'DRAFT') && !row.dataValue.changeable_status) {
              return 'DRAFT_DISABLED';
            } else if ((row.dataValue.status === 'PROCESSED' || row.dataValue.document_status === 'PROCESSED') && !row.dataValue.changeable_status) {
              return 'PROCESSED_DISABLED';
            }
            return row.dataValue.status || row.dataValue.document_status;
          } else if (row && row.dataValue && (row.dataValue.status || row.dataValue.document_status) && row.dataValue.date) { // для грида кассовых документов
            var expirationDate = moment.utc().subtract($scope.stopEditing, 'day');
            if (moment.utc(row.dataValue.date) < expirationDate) {
              if (row.dataValue.status === 'DRAFT' || row.dataValue.document_status === 'DRAFT') {
                return 'DRAFT_DISABLED';
              } else if (row.dataValue.status === 'PROCESSED' || row.dataValue.document_status === 'PROCESSED') {
                return 'PROCESSED_DISABLED';
              }
            }
            return row.dataValue.status || row.dataValue.document_status;
          }
          return '';
        };

        // Get data for selects

        this.companiesSelect = [];
        cashregisterShiftsService.companies(ctrl.paging, '').then(function (result) {
          ctrl.companiesPopup = result;
          result.forEach(function (item) {
            ctrl.companiesSelect.push({value: item.id, label: item.name});
          });
        });

        this.divisionsSelect = [];
        cashregisterShiftsService.divisions().then(function (results) {
          ctrl.divisionsPopup = results;
          results.forEach(function (item) {
            ctrl.divisionsSelect.push({value: item.id, label: item.name});
          });
          if (ctrl.divisionsPopup) {
            angular.forEach(ctrl.divisionsPopup, function (division) {
              ctrl.getCashierPlaces(division.id);
            });
          }
        });

        this.getFilterLabel = function (columnName) {
          var column = _.find(ctrl.gridOptions.columnDefs, {
            name: columnName
          });
          if (column && column.filter) {
            var res = _.find(column.filter.selectOptions, {
              value: ctrl.filter[column.filterName]
            });
            return res && res.label;
          }
        };

        this.cashRegisterPlacesSelect = [];
        this.getCashierPlaces = function (id) {
          // необходимо будет позже, для автокомплита по кассовым местам
          // cashregisterShiftsService.cashRegisterPlaces(id).then(function (results) {
          //   self.cashRegisterPlacesPopup = results;
          //   angular.forEach(results, function(cash, key){
          //     var isset = false;
          //     angular.forEach(self.cashRegisterPlacesSelect, function(issetCash){
          //       if(issetCash.value == cash.name){
          //         isset = true;
          //       }
          //     });
          //     if(!isset){
          //       self.cashRegisterPlacesSelect.push({value: cash.name, label: cash.name});
          //     }
          //   });
          // });
        };

        this.employeeListSelect = [];
        cashregisterShiftsService.employees().then(function (results) {
          ctrl.employeeListPopup = results;
          results.forEach(function (item) {
            ctrl.employeeListSelect.push({value: item.id, label: item.name});
          });
        });

        // -- End Get data for selects

        function prepareFilters() {
          if ($scope.onlyReadMode) {
            $scope.config.filterFields
              .map(function (value) {
                if ((value.required || value.default) && !ctrl.filter[value.code]) {
                  return value
                }
              })
              .forEach(function (value) {
                if (value) {
                  if (value.type !== 'dateRange') {
                    ctrl.filter[value.code] = moment.isMoment(value.default) ? value.default.valueOf() : value.default;
                  } else if (value.type === 'dateRange') {
                    ctrl.filter[value.code] = value.default
                  }
                }
              });
            changeSourceOfColumns(!!ctrl.filter.base_mode);
            delete ctrl.filter.base_mode;
          }
        }


        function changeSourceOfColumns(basemode, triggeredByEvent) {
          userSettingsService.saveProperty($scope.page, 'grid', 'base_mode', basemode);
          if ($scope.config.baseColumns) {
            var columns = angular.copy(ctrl.gridOptions.columnDefs);
            columns.forEach(function (column) {
              var fieldName = column.name.replace('dataValue.', '').replace('base_', '');
              var isDynamicColumn = !!~$scope.config.baseColumns.indexOf(fieldName);
              if (isDynamicColumn) {
                column.name = basemode ? 'dataValue.base_' + fieldName : 'dataValue.' + fieldName;
              }
            });
            ctrl.gridOptions.columnDefs = columns;
            if (triggeredByEvent) {
              ctrl.gridApi.core.refresh();
            }

            var filterCopy = angular.copy(ctrl.filter);
            angular.forEach(filterCopy, function (value, key) {
              if (value && moment.isMoment(value)) {
                filterCopy[key] = value.valueOf();
              } else if (value && value.startDate && value.endDate) {
                filterCopy[key] = {
                  startDate: value.startDate.valueOf(),
                  endDate: value.endDate.valueOf()
                }
              }
            });
            ctrl.updateFilter(filterCopy);
          }
        }

        $scope.$on('base_mode_changed', function (e, base_mode) {
          ctrl.currentBaseMode = base_mode;
          changeSourceOfColumns(base_mode, true);
        });

        /**
         * Метод делает отложенный вызов с приоритетом последнего для устранения дублей при реакции на события.
         */
        ctrl.getPageThrottle = function () {
          if (ctrl.pageTimer) {
            $timeout.cancel(ctrl.pageTimer);
          }
          ctrl.pageTimer = $timeout(function () {

            return ctrl.getPage.apply(ctrl, arguments);
          }, TIMEOUT_THROTTLE);
        };

        $scope.$on("$destroy", function (event) {
          if (angular.isDefined($scope.pageTimer)) {
            $timeout.cancel($scope.pageTimer);
          }
        });

        // Get contents for the page
        this.getPage = function (noPrepareFilters) {
          ctrl.noData = ctrl.dataIsLoaded = false;
          ctrl.crudState.startLoading();
          ctrl.usingService.loadSavedDefinedColumnWidth();
          if (!noPrepareFilters) prepareFilters();
          userSettingsService.saveProperty($scope.page, 'grid', 'paging', ctrl.paging);
          if ($scope.onlyReadMode) {
            userSettingsService.saveProperty($scope.page, 'grid', 'search_string', ctrl.searchText);
          }
          for (var prop in ctrl.filter) {
            if (ctrl.filter[prop] && ctrl.filter[prop].id) {
              ctrl.filter[prop] = ctrl.filter[prop].id;
            }
          }
          settingsEntitiesService.getEntities($scope.url, ctrl.paging, ctrl.searchText, ctrl.filter,
            ctrl.currentTransType).then(function (data) {
              ctrl.copyfilter = angular.copy(ctrl.filter);
              if (!data.items.length && !ctrl.searchText && _.isEmpty(ctrl.filter)) {
                ctrl.noData = true;
              }
              ctrl.dataIsLoaded = true;
              ctrl.blockFilterUpdate = false;

              ctrl.totals = data.totals;

              if (data.items && data.items.length && data.items[0].home_currency) {
                ctrl.currency = data.items[0].home_currency.symbol;
              }
              ctrl.gridOptions.data = data.items.map(function (item) {
                return Object.assign({}, {dataValue: item}, {dataTotals: data.totals});
              });
              while (ctrl.gridOptions.data.length < ctrl.paging.limit) {
                ctrl.gridOptions.data.push({});
              }

              ctrl.paging.total = data.total;

              ctrl.crudState.stopLoadingSuccess();
              ctrl.notFoundByFilters = false;
              var filtersIsUsed = false;
              for (var prop in ctrl.filter) {
                if (ctrl.filter.hasOwnProperty(prop) && ctrl.filter[prop] !== null) {
                  filtersIsUsed = true;
                  break;
                }
              }
              ctrl.isGridEmpty = data.items.length === 0;

              if (ctrl.isGridEmpty && filtersIsUsed) {
                ctrl.notFoundByFilters = true;
                ctrl.gridOptions.showColumnFooter = false;
              } else {
                ctrl.gridOptions.showColumnFooter = true;
              }
              if (hasBaseMode) {
                changeSourceOfColumns(ctrl.currentBaseMode, false);
              }
              ctrl.gridApi.core.refresh();
              ctrl.rowSelected = false;

              $timeout(function () {
                ctrl.isLargeHeight = window.innerHeight > document.documentElement.offsetHeight;
              }, 0);
            },
            function (error) {
              ctrl.cashregisterShifts = [];
              ctrl.crudState.stopLoadingFailure(error);
              ctrl.gridOptions.showColumnFooter = false;
            }
          );
        };

        this.setGridHeight = function () {
          var windowHeight = angular.element(window).height();
          var tableFooterLow = angular.element('.full-with-table-wrapper .table-footer').height();
          var tableFooterHigh = angular.element('.ui-grid-footer-panel').height();
          var tableHeader = angular.element('.ui-grid-header').height();
          var funcBlock = angular.element('.functional_block').height();

          // 42 - высота рядка в гриде
          var height = windowHeight - tableFooterLow - tableFooterHigh - tableHeader - funcBlock - 42;

          if ($scope.page === 'cashregister-shifts-crud') {
            // особый случай из-за кнопок продажи/возвраты
            angular.element('.ui-grid-render-container').height(800);
            angular.element('.settings-grid .ui-grid-viewport[class]').height(height - 42);
          } else if (ctrl.isCrud) {
            angular.element('.ui-grid-render-container').height(800);
            angular.element('.settings-grid .ui-grid-viewport[class]').height(height + 42);
          } else {
            angular.element('.ui-grid-render-container').height(1000);
            angular.element('.settings-grid .ui-grid-viewport[class]').height(height);
          }
        };

        angular.element(window).on('resize', function () {
          ctrl.setGridHeight();
        });

        // PAGING init
        this.initPaging = function () {
          ctrl.paging = userSettingsService.loadProperty($scope.page, 'grid', 'paging') || {
            current: +($scope.startPage || 0),
            limit: $scope.limit,
            offset: 0,
            sortBy: $scope.sort,
            total: undefined,
            amountType: 'ONE_HUNDRED',
            sortDirection: $scope.sortOrder || 'asc'
          };
          this.paging.offset = $scope.startPage ? $scope.limit * +$scope.startPage : 0;
          this.paging.current = +($scope.startPage || 0);
        };

        this.closeFilterSavingModal = function (saveFilterForm) {
          saveFilterForm.$setPristine();
          saveFilterForm.$setUntouched();
        };

        this.init = function () {
          this.initFilter();
          this.initPaging();
          this.showFilter = userSettingsService.loadProperty($scope.page, 'grid', 'showFilter') || false;
          if ($scope.onlyReadMode) {
            ctrl.searchText = userSettingsService.loadProperty($scope.page, 'grid', 'search_string') || null;
          }
        };

        var columnsProperty = userSettingsService.loadProperty($scope.page, 'grid', 'columnsProperty');

        ctrl.usingService = $scope.usingService;
        ctrl.gridOptions.columnDefs = columnsProperty || $scope.columnDefs;


        function deleteColumn(name, columnDefs) {
          var columnIndex = _.findIndex(columnDefs, function (item) {
            return item.name === name
          });
          if (columnIndex >= 0) {
            columnDefs.splice(columnIndex, 1);
          }
        }

        function renameHomeAmount(columnDefs, newName) {
          angular.forEach(columnDefs, function (item) {
            if (item.name === 'dataValue.home_amount') {
              item.displayName = newName;
            }
          });
        }

        function updateColumnsDefs(columnDefs) {
          //TODO REFACTORING
          if ($scope.config.universalDocuments) {
            renameHomeAmount(columnDefs, 'Сумма');
            if ($scope.config.currencies.length > 1) {
              renameHomeAmount(columnDefs, 'Сумма в валюте учета');
            } else {
              deleteColumn('dataValue.natural_currency.name', columnDefs);
              deleteColumn('dataValue.natural_amount', columnDefs);
            }
            // логика удаляет колонки, если в них для данного типа докумнетов будет одно и то же значение заведомо. исключение - тип "все документы"
            if ($scope.config.documentType && $scope.config.documentType != 'all_documents') {
              $scope.config.purpose = $scope.config.purpose
                || ($rootScope.findDocumentType($scope.config.documentType) ? $rootScope.findDocumentType($scope.config.documentType).purposes : null)
                || [];
              if ($scope.config.purpose.length < 2) { // если назначений меньше двух, то колонку удаляем
                deleteColumn('dataValue.document_purpose', columnDefs);
              }

              if ($scope.config.purposesFilterOn) {
                deleteColumn('dataValue.document_type', columnDefs);
              }
            }

            angular.forEach(columnDefs, function (item, i) {
              item.__index = i;
              item.backButton = i === ctrl.baseColumnsCount || i === columnDefs.length - 1;
              item.pinned = i <= (ctrl.baseColumnsCount || 1);
            });
            return angular.copy(columnDefs)
          }
        }

        updateColumnsDefs(ctrl.gridOptions.columnDefs);

        var lastColumnIndex = ctrl.gridOptions.columnDefs.length - 1;

        $scope.defaultColumns = $scope.config && $scope.config.defaultColumns ? updateColumnsDefs($scope.config.defaultColumns) : $scope.usingService.getColumnDefs.call(this, uiGridConstants);

        this.configScrollFilter = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          scrollInertia: 0
        };

        this.configScroll = {
          autoHideScrollbar: false,
          theme: 'dark-thick',
          advanced: {
            updateOnContentResize: true
          },
          setHeight: 400,
          scrollInertia: 0
        };

        this.chooseFilter = function (filterName) {
          ctrl.gridFilter.storeFilter(ctrl.gridFilter.loadSavedFilter(filterName));
          ctrl.initFilter();
          ctrl.filterDeepCopy = $.extend(true, {}, ctrl.filter);
          if (ctrl.filter) {
            ctrl.filterSaved = true;
            ctrl.savedFilterName = filterName;
          }
        };

        this.initFilter = function () {
          ctrl.filter = ctrl.gridFilter.loadFilter() || {};

          ctrl.gridApi && ctrl.gridApi.grid.columns.filter(function (column) {
            return column.enableFiltering;
          }).forEach(function (col) {
            ctrl.updateColumnFilter(col.colDef, col);
          });

          ctrl.gridFilter.storeFilter(ctrl.filter);
        };

        this.saveFilter = function (name) {
          ctrl.gridFilter.saveFilter(name, ctrl.filter);
          ctrl.filterSaved = true;
          ctrl.filterDeepCopy = angular.copy(ctrl.filter);
          ctrl.savedFilterName = name;
        };

        this.updateColumnFilter = function (colDef, col) {
          if (ctrl.filter[colDef.filterName || colDef.name] && ctrl.filter[colDef.filterName || colDef.name].complex) {
            col.filters[0].dateRange = ctrl.filter[colDef.filterName || colDef.name].dateRange;
            col.filters[0].term = ctrl.filter[colDef.filterName || colDef.name].datePickStr;
          } else {
            col.filters[0].term = ctrl.filter[colDef.filterName || colDef.name];
          }
        };

        this.removeFilter = function (filterName, $event) {
          $event.stopPropagation();
          ctrl.gridFilter.removeFilter(filterName);

          if (filterName === ctrl.savedFilterName) {
            ctrl.filterSaved = false;
          }

          if (ctrl.gridFilter.getSavedFiltersNames().length < 6) {
            ctrl.savedFilterListSearchText = '';
          }
        };

        this.showFilterPopup = function () {
          ctrl.popupFilter = $.extend(true, {}, ctrl.filter);
          $scope.$broadcast('popupFilterOpen', ctrl.popupFilter);
        };

        this.init();

        this.search = function (filters, noPrepareFilters) {
          if (isAllowToGetPage()) {
            ctrl.invalidFilterForm = false;
            ctrl.paging.current = 0;
            ctrl.paging.offset = 0;
            if (filters) {
              ctrl.filter = filters;
            }
            ctrl.getPage(noPrepareFilters);
          } else {
            ctrl.invalidFilterForm = true;
          }
        };

        this.prepareSavedFiltersList = function () {
          ctrl.savedFilterListSearchText = '';
        };

        this.turnShowFilter = function () {
          ctrl.showFilter = !ctrl.showFilter;
          userSettingsService.saveProperty($scope.page, 'grid', 'showFilter', this.showFilter);
          if (!ctrl.showFilter) {
            ctrl.cleanFilter();
          }
        };

        this.cleanFilter = function () {
          ctrl.updateFilter(undefined);
          ctrl.getPage();
        };

        this.cleanObj = function (obj) {
          var tempObj = angular.copy(obj);
          for (var prop in tempObj) {
            if (!tempObj[prop]) {
              delete obj[prop];
            }
          }
          return obj;
        };

        this.updateFilter = function (filter) {
          ctrl.popupFilter = $.extend(true, {}, ctrl.filter);
          ctrl.filterSaved = _.isEqual(ctrl.cleanObj(ctrl.filterDeepCopy), ctrl.cleanObj(filter));
          ctrl.gridFilter.storeFilter(filter);

          if (!ctrl.filterSaved) {
            ctrl.savedFilterName = '';
          }

          ctrl.initFilter();
          ctrl.blockFilterUpdate = true;

          if (_.isEmpty(filter)) {
            ctrl.filterSaved = false;
            ctrl.savedFilterName = '';
          }
        };

        this.applyFilter = function (dateFilter) {
          angular.forEach(dateFilter, function (value, key) {
            ctrl.filter[key] = value;
            if (value && value.startDate) {
              ctrl.filter[key] = {};
              ctrl.filter[key].startDate = (value.startDate && !value.isAllTime)
                ? value.startDate.valueOf()
                : null;
              ctrl.filter[key].endDate = (value.endDate && !value.isAllTime)
                ? value.endDate.valueOf()
                : null;
              if (value.isAllTime) {
                delete ctrl.filter[key];
              }
            }
          });
          ctrl.updateFilter(ctrl.filter);
          ctrl.getPage();
        };

        this.showSettings = function () {
          ctrl.gridApi.grid.gridMenuScope.toggleMenu();
        };

        var defaultPosition = $scope.defaultPosition || 2,
          position = defaultPosition,
          shownIndexes;

        this.moveNext = function () {
          position++;
          this.moveToPosition(true);
        };
        this.moveBack = function () {
          if (position < defaultPosition + 1) {
            position = defaultPosition;
            return;
          }
          position--;
          this.moveToPosition(false);
        };
        /**
         * Вызывается, например, при изменении видимости колонок
         */
        this.moveStart = function () {
          position = defaultPosition;
          shownIndexes = _.reduce(this.gridOptions.columnDefs, function (memo, item) {
            memo[item.__index] = item.visible || item.settedVisibility;
            return memo;
          }, {});
          this.moveToPosition(true);
        };

        function calcWidth(gridWidth, width, increment) {
          if (~(increment + '').indexOf('%')) {
            increment = parseFloat(increment) * gridWidth / 100;
          }
          return width + parseFloat(increment);
        }

        function getNextVisible(arr, index) {
          index++;
          for (; index < arr.length; index++) {
            if (arr[index].__index !== lastColumnIndex && (arr[index].visible || arr[index].settedVisibility)) {
              return arr[index];
            }
          }
        }

        function checkNextVisible(arr, index) {
          ctrl.hasNextVisible = !!getNextVisible(arr, index);
        }

        function getPrevVisible(arr, index) {
          index--;
          for (; index > -1; index--) {
            if (index < defaultPosition) {
              return;
            }
            if (arr[index].visible || arr[index].settedVisibility) {
              return arr[index];
            }
          }
        }

        function checkPrevVisible(arr, index) {
          ctrl.hasPrevVisible = !!getPrevVisible(arr, index);
        }

        /**
         * Переход на новую позицию (после изменения position)
         *
         * @param forward true, если вперед
         */
        this.moveToPosition = function (forward) {
          var colDefs = ctrl.gridApi.grid.options.columnDefs,
            // ширина грида в пикселях (на экране)
            gridWidth = ctrl.gridApi.grid.gridWidth - ctrl.gridApi.grid.scrollbarWidth,
            width = 50,
            // ? встретилась ли последняя колонка
            lastWasMet = false,
            lastShownIndex,
            lastShownItem,
            lastRenderedColumn;

          /// минимальная ширина запиненных колонок (впоследствии ограничит расширение колонки)
          var baseColumnsMinWidth = 50;
          // цикл определения параметров запиненных колонок (пропуск служебной с чек-боксами)
          for (var i = 1; i <= ctrl.baseColumnsCount; i++) {
            baseColumnsMinWidth += colDefs[i].minWidth || 100; // по-умолчанию ограничиваем 100 минимальную ширину
          }

          var wasAddedVariableColumn = false;

          colDefs.forEach(function (item, index) {

            item.allowCustomWidthOverride = true; // из исходников

            // colWidth - ширина которую займут колонки с новым item
            // width - накопленных фактический итог (сумма ширины отображаемых колонок)
            var colWidth = calcWidth(gridWidth, width,
              // для исключения некорректного расчета при наличии минимальной ширины
              item.width === '*' ? Math.max(item.settedWidth, item.minWidth || 0) : Math.max(item.width, item.minWidth || 0));
            var config = {
              //firstParameter: index >= 2,
              //secondParameter: index === 2
            };
            if ($scope.defaultPosition) {
              //config.firstParameter = index >= 2;
              //config.secondParameter = false
            }

            if (!shownIndexes[item.__index]) {
              if (forward && index === position) {
                // при движении вперед (?) если следующий элемент скрыт то текущая позиция итерируется дополнительно (а что, если она опять скрыта?)
                position++;
              }
              if (!forward && index <= position) {
                // при движении назад происходит пропуск колонок, которые в данный момент не выбраны пользователем
                position = _.findLastIndex(Object.keys(shownIndexes), function (value, i) {
                  return shownIndexes[value] && parseInt(value) <= position
                });
              }
              item.settedVisibility = item.visible;
              item.visible = false;
              return;
            }

            if (index < position && index >= ctrl.baseColumnsCount + 1) {
              item.settedVisibility = item.settedVisibility || item.visible;
              item.visible = false;
            } else if ((colWidth <= gridWidth || !wasAddedVariableColumn)
              && !lastWasMet) {
              // colWidth - это columnsWidth по сути, ширина с текушим item
              // в этой ветке собственно происходит добавление этого item-а
              width = colWidth;
              if (item.settedWidth) {
                item.width = item.settedWidth;
              }
              // возможна ситуация увеличени ширины второй колонки больше чем на ширину грида, для защиты добавляю условие
              if (!wasAddedVariableColumn) {
                // разрешенная ширина высчитывается как разница между шириной грида, места для динамических колонок и минимальной ширины, указанной для запиненных
                var allowMaxWidth = (gridWidth - 464 - baseColumnsMinWidth + (item.minWidth || 100));
                if (item.width > allowMaxWidth) {
                  width -= item.width - allowMaxWidth; // уменьшение расчитанной текущей ширины на дельту, на которую сокращается колонка
                  item.width = allowMaxWidth; // эмпирическая константа, это все равно переписывать
                }
              }

              if (index > ctrl.baseColumnsCount) {
                // флаг добавления хотя бы одной вариативной колонки
                wasAddedVariableColumn = true;
              }

              item.visible = true;
            } else {
              // нахождение в этой ветке означает, что добавление нового item в список отображаемых приведет к переполнению ширины
              lastWasMet = true;
              item.settedVisibility = item.settedVisibility || item.visible;
              item.visible = false;
            }

            if (item.width === '*') {
              item.width = item.settedWidth;
            } else if (item.width < item.minWidth) {
              item.width = item.minWidth;
            }
          });

          // последняя видимия колонка (помимо колонки с настройками)
          lastShownIndex = _.findLastIndex(colDefs, function (item) {
            return item.__index !== lastColumnIndex // настройки являются последней колонкой (не учитываются)
              && (item.visible);
          });

          lastShownItem = colDefs[lastShownIndex];
          lastShownItem.settedWidth = lastShownItem.width;
          // последнему элементу устанавливается принудительно резиновая ширина, видимо, в расчете на заполнение ею места
          // в которое не уложилась следующая колонка
          lastShownItem.width = '*';
          lastShownItem.allowCustomWidthOverride = true; // из исходников (активирует применение назначенной ширины)

          checkNextVisible(colDefs, lastShownIndex);
          checkPrevVisible(colDefs, position);

          _.find(colDefs, {__index: lastColumnIndex}).visible = true;

          ctrl.gridApi.grid.options.columnDefs = angular.copy(colDefs);
          //ctrl.gridApi.grid.buildColumns();
        };

        (function () {
          var running = false;
          var func = function () {
            if (running) {
              return;
            }
            running = true;
            requestAnimationFrame(function () {
              ctrl.moveToPosition(true);
              running = false;
            });
          };
          $window.addEventListener('resize', func);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', func);
          });
        })();

        this.gridOptions.columnDefs.filter(function (colDef) {
          return colDef.sortName === ctrl.paging.sortBy;
        }).forEach(function (colDef) {
          colDef.sort = {
            direction: ctrl.paging.sortDirection,
            priority: 0
          };
        });

        var columnsVisibility = userSettingsService.loadProperty($scope.page, 'grid', 'columnsVisibility') || {};

        $scope.columnVisibilityChanged = function () {
          columnsProperty = ctrl.gridApi.grid.options.columnDefs;
          lastColumnIndex = ctrl.gridApi.grid.options.columnDefs.length - 1;
          angular.forEach(columnsProperty, function (column) {
            if (column.width === '*') {
              column.width = column.settedWidth;
            }
            column.settedVisibility = column.visible;
          });
          ctrl.moveStart();
          userSettingsService.saveProperty($scope.page, 'grid', 'columnsProperty', columnsProperty);
        };

        this.gridOptions.columnDefs.forEach(function (colDef) {
          if (columnsVisibility[colDef.name] === false) {
            colDef.visible = false;
          } else if (columnsVisibility[colDef.name]) {
            colDef.visible = true;
          }
        });

        var cashRegistersDocs = [
          'CASHREGISTER_START_SHIFT',
          'CASHREGISTER_END_SHIFT',
          'CASHBOX_REPLENISHMENT',
          'RETAIL_SALE',
          'RETAIL_RETURN',
          'CASHBOX_ENCASHMENT'
        ];

        function getSelectedRows() {
          var rows = ctrl.gridApi.selection.getSelectedRows();
          return rows.filter(function (item) {
            return item.dataValue
          });
        }

        ctrl.changeButtonShowState = function () { // TODO REFACTORING
          var rows = getSelectedRows();
          var rowSelected = rows.length > 0;
          if (rowSelected) {
            var hasInProgressDocuments = isRowsHasStatus('IN_PROGRESS');
            var hasDraftDocuments = isRowsHasStatus('DRAFT');
            var hasProcessedDocuments = isRowsHasStatus('PROCESSED');
            var onlyDraft = hasDraftDocuments && !hasProcessedDocuments;
            var onlyProcessed = !hasDraftDocuments && hasProcessedDocuments;
            var onlyInProgress = hasInProgressDocuments && !hasDraftDocuments && !hasProcessedDocuments;
            var onlyCashDocument = rows.every(function (value) {
              return ~cashRegistersDocs.indexOf(value.dataValue.document_type)
            });
            var onlyWithReadOnlyFlag = rows.every(function (value) {
              return !!value.dataValue.readonly
            });
            var hasChangeableStatus = rows.some(function (value) {
              return !!value.dataValue.changeable_status
            });
            var draftHasChangeableStatus = some(rows.filter(function (value) {
              return value.dataValue.status === 'DRAFT' || value.dataValue.document_status === 'DRAFT'
            }), 'changeable_status');
            var processedHasChangeableStatus = some(rows.filter(function (value) {
              return value.dataValue.status === 'PROCESSED' || value.dataValue.document_status === 'PROCESSED'
            }), 'changeable_status');

            if (hasDraftDocuments && hasProcessedDocuments) {
              if (draftHasChangeableStatus && processedHasChangeableStatus) {
                ctrl.statusButtonMode = 'ALL';
              } else if (draftHasChangeableStatus && !processedHasChangeableStatus) {
                ctrl.statusButtonMode = 'DRAFT'
              } else if (!draftHasChangeableStatus && processedHasChangeableStatus) {
                ctrl.statusButtonMode = 'PROCESSED'
              }
            } else if (onlyDraft && draftHasChangeableStatus) {
              ctrl.statusButtonMode = 'DRAFT'
            } else if (onlyProcessed && processedHasChangeableStatus) {
              ctrl.statusButtonMode = 'PROCESSED'
            }

            ctrl.rowSelected = rowSelected && !onlyCashDocument;
            ctrl.showStatusButton = !onlyInProgress && hasChangeableStatus;
            ctrl.showDeleteButton = hasDraftDocuments && !onlyWithReadOnlyFlag;
            ctrl.showCopyButton = rows.length === 1;
          } else {
            ctrl.rowSelected = rowSelected;
          }

        };

        function some(array, prop) {
          return !!array.length && array.some(function (value) {
            return value.dataValue[prop]
          });
        }

        ctrl.copyDocument = function () {
          var row = ctrl.gridApi.selection.getSelectedRows()[0];
          if (row) {
            var data = row.dataValue;
            if ($scope.config.copyDocCallback) {
              $scope.config.copyDocCallback(data.id, data);
            } else {
              $window.open($state.href('document.new', {
                type: data.document_type,
                purpose: data.document_purpose,
                source: data.id,
                parent: $state.params.parent
              }), '_blank');
            }
          }
        };

        ctrl.printDocument = function (chosenPrintForm) {
          var documentsId = _.map(getSelectedRows(), function (value) {
            return value.dataValue.id
          })[0];
          $uibModal.open({
            size: 'middle-width',
            component: 'documentPrint',
            controllerAs: '$ctrl',
            resolve: {
              printForm: chosenPrintForm,
              documentId: function () {
                return documentsId
              }
            }
          });
        };


        ctrl.startProcessing = function () {
          var ids = _.filter(getSelectedRows(), function (row) {
            return (row.dataValue.status === 'DRAFT' || row.dataValue.document_status === 'DRAFT') && row.dataValue.changeable_status && !~cashRegistersDocs.indexOf(row.dataValue.document_type)
          }).map(function (item) {
            return item.dataValue.id
          });
          if (ids.length > 0) {
            documentService.processDocument(ids).then(function (res) {
              console.log('documents has status PROCESSED', res.data);
              ctrl.getPage();
            })
          }
        };

        ctrl.cancelProcessing = function () {
          modalAskSrv.showModal({
            title: 'После отмены проведения документы не будут отражаться в финансовых проводках и станут доступными для редактирования и удаления <br><br><br>' +
            'Вы действительно хотите отменить проведение документов в статусе "Проведен" ?'
          }).then(function () {
            var ids = _.filter(getSelectedRows(),
              function (row) {
                return (row.dataValue.status === 'PROCESSED' || row.dataValue.document_status === 'PROCESSED') && row.dataValue.changeable_status && !~cashRegistersDocs.indexOf(row.dataValue.document_type)
              }).map(function (item) {
              return item.dataValue.id
            });
            if (ids.length > 0) {
              documentService.rollbackDocument(ids).then(function (res) {
                console.log('documents has status DRAFT', res.data);
                ctrl.getPage();
              }).catch(function (err) {
                if (err.status === 409 && err.data.code === 'there_are_additional_costs') {
                  $uibModal.open({
                    templateUrl: 'app/settings/templates/modals/info.html',
                    size: 'small-width',
                    controller: function ($scope, $uibModalInstance) {
                      $scope.title = 'Отмена проведения невозможна';
                      $scope.text = "Отмена проведения документа невозможна, так как на него заведены дополнительные затраты";
                      $scope.close = function () {
                        $uibModalInstance.dismiss();
                      };
                    }
                  });
                }
              })
            }
          })
        };

        function isRowsHasStatus(status) {
          var rows = getSelectedRows();
          if (status === 'IN_PROGRESS') {
            return rows.some(function (row) {
              return (row.dataValue.status === 'IN_PROCESS' || row.dataValue.document_status === 'IN_PROCESS') || (row.dataValue.status === 'IN_ROLLBACK' || row.dataValue.document_status === 'IN_ROLLBACK')
            });
          } else {
            return rows.some(function (row) {
              return row.dataValue.status === status || row.dataValue.document_status === status
            });
          }

        }

        ctrl.openConfirmDeleteDialog = function () {
          var hasProcessed = isRowsHasStatus('PROCESSED');
          var hasInProgress = isRowsHasStatus('IN_PROGRESS');
          var isPrevStringNeeded = hasProcessed || hasInProgress;
          var prevString = 'Документы в статус';
          if (hasProcessed && hasInProgress) {
            prevString += 'ах "В обработке" и "Проведен"';
          } else {
            prevString += hasProcessed && !hasInProgress ? 'e "Проведен"' : 'e "В обработке"';
          }
          prevString += ' удалить нельзя.<br><br>';
          var titleString = isPrevStringNeeded ? prevString : '';
          titleString += 'Вы действительно хотите удалить выбранные документы в статусе "Черновик"?';
          modalAskSrv.showModal({
            title: titleString
          }).then(function () {
            if ($scope.config.deleteRequest) {
              var rows = getSelectedRows();
              $scope.config.deleteRequest(rows.map(function (item) {
                return item.dataValue.id
              })).then(function (res) {
                ctrl.getPage();
              })
            } else {
              ctrl.deleteSelectedDocuments();
            }
          })
        };

        ctrl.deleteSelectedDocuments = function () {
          var rows = getSelectedRows();
          documentService.deleteDocument(rows.map(function (item) {
            return item.dataValue.id
          })).then(function (res) {
            ctrl.getPage();
          })
        };

        ctrl.onSelectAllHandler = function (isAllRowSelected) {
          if (!isAllRowSelected) {
            ctrl.gridApi.selection.clearSelectedRows()
          } else {
            ctrl.gridApi.selection.selectAllRows();
          }
          ctrl.changeButtonShowState()
        };

        this.gridOptions.onRegisterApi = function (gridApi) {
          ctrl.gridApi = gridApi;
          ctrl.moveStart();
          ctrl.gridApi.selection.on.rowSelectionChanged($scope, function (row, event) {
            if (!!event.target.closest(".checkbox")) {
              ctrl.changeButtonShowState()
            } else {
              // при наличии функции-коллбека, она имеет приоритет
              if ($scope.rowRouteFunc) {
                $scope.rowRouteFunc(row.entity.dataValue, ctrl.paging);
              } else if ($scope.rowRoute && !$scope.isSku) {
                $state.go($scope.rowRoute, {id: row.entity.dataValue.id, backPage: ctrl.paging.current + 1, parent: $state.params.parent});
              } else if ($scope.isSku && row.entity.dataValue.catalog_item) {
                if (row.entity.dataValue.code.length < 31 && row.entity.dataValue.code.replace(/_/gi, '')) {
                  if (row.entity.dataValue.catalog_item.type === 'SERVICE') {
                    $state.go('catalogServices.view', {
                      elementId: row.entity.dataValue.catalog_item.id,
                      backPage: ctrl.paging.current + 1,
                      parent: $state.params.parent
                    });
                  } else {
                    $state.go('catalogSkus.view', {
                      elementId: row.entity.dataValue.catalog_item.id,
                      backPage: ctrl.paging.current + 1,
                      parent: $state.params.parent
                    });
                  }
                }
              }
            }
          });

          gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
            if (!sortColumns.length) {
              ctrl.paging.sortBy = null;
              ctrl.paging.sortDirection = null;
            } else {
              ctrl.paging.sortBy = sortColumns[0].colDef.sortName;
              ctrl.paging.sortDirection = sortColumns[0].sort.direction;
            }
            if (isAllowToGetPage()) {
              ctrl.getPage();
            } else {
              ctrl.dataIsLoaded = true;
            }
          });

          angular.element(document.querySelector('.grid-wrapper')).addClass('hide-body-scrollbar');
          gridApi.grid.scrollContainers = function (sourceContainerId, scrollEvent) {
            if (scrollEvent.y) {
              var bodyRect = document.body.getBoundingClientRect(),
                elemRect = document.querySelector('.functional_block').getBoundingClientRect(),
                offset = elemRect.top - bodyRect.top;
              var isBottom = $(window).scrollTop() + $(window).height() + 1 >= $(document).height();

              angular.element('.full-with-table-wrapper .table-footer').position('fixed');
              if (($window.scrollY < offset) && ((!isBottom && !ctrl.isCrud) || ctrl.isCrud)) {
                angular.element(document.querySelector('body')).removeClass('hide-body-scrollbar');
                angular.element(document.querySelector('.grid-wrapper')).addClass('hide-body-scrollbar');

                // вычисляем, куда скроллить $window, так как скролл евент перехватывается гридом
                $window.scrollTo(0, $window.scrollY + scrollEvent.y.pixels);
              } else {
                angular.element(document.querySelector('.grid-wrapper')).removeClass('hide-body-scrollbar');
                angular.element(document.querySelector('body')).addClass('hide-body-scrollbar');

                //default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left
                var verts = ['body', 'left', 'right'];

                this.flagScrollingVertically(scrollEvent);

                if (sourceContainerId === 'body') {
                  verts = ['left', 'right'];
                } else if (sourceContainerId === 'left') {
                  verts = ['body', 'right'];
                } else if (sourceContainerId === 'right') {
                  verts = ['body', 'left'];
                }

                for (var i = 0; i < verts.length; i++) {
                  var id = verts[i];
                  if (this.verticalScrollSyncCallBackFns[id]) {
                    this.verticalScrollSyncCallBackFns[id](scrollEvent);
                  }
                }
              }
            }

            if (scrollEvent.x) {
              //default for no container Id (ex. mousewheel means that all containers must set scrollTop/Left)
              var horizs = ['body', 'bodyheader', 'bodyfooter'];

              this.flagScrollingHorizontally(scrollEvent);
              if (sourceContainerId === 'body') {
                horizs = ['bodyheader', 'bodyfooter'];
              }

              for (var j = 0; j < horizs.length; j++) {
                var idh = horizs[j];
                if (this.horizontalScrollSyncCallBackFns[idh]) {
                  this.horizontalScrollSyncCallBackFns[idh](scrollEvent);
                }
              }
              ctrl.scrollEvent = scrollEvent;
            }
          };
          gridApi.core.on.filterChanged($scope, function () {
            gridApi.grid.columns.filter(function (column) {
              return column.enableFiltering && column.visible !== false;
            }).forEach(function (column) {
              var filter = ctrl.filter[column.colDef.filterName || column.name];

              if (column.colDef.filterName === 'filterDivisionId' && column.filters[0].term) {
                cashregisterShiftsService.cashRegisterPlaces(column.filters[0].term)
                  .then(function (results) {
                    ctrl.cashRegisterPlacesPopup = results;
                    ctrl.cashRegisterPlacesSelect = [];

                    results.forEach(function (item) {
                      ctrl.cashRegisterPlacesSelect.push({value: item.name, label: item.name});
                    });

                    ctrl.gridOptions.columnDefs[4].filter.selectOptions = ctrl.cashRegisterPlacesSelect;
                  });
              }

              if (filter && filter.complex) {
                if (column.filters[0].term) {
                  filter.datePickStr = column.filters[0].term;
                }

                filter.dateRange = column.filters[0].dateRange;
              } else {
                ctrl.filter[column.colDef.filterName || column.name] = column.filters[0].term;
              }
            });

            ctrl.paging.offset = 0;
            ctrl.filterSaved = _.isEqual(ctrl.cleanObj(ctrl.filterDeepCopy), ctrl.cleanObj(ctrl.filter));
            if (!ctrl.blockFilterUpdate) {
              ctrl.updateFilter(ctrl.filter);
            }
            ctrl.getPageThrottle();
          });

          gridApi.core.on.rowsRendered($scope, function () {
            ctrl.setGridHeight();
          });

          gridApi.colResizable.on.columnSizeChanged($scope, function (colDef, deltaChange) {
            var width = colDef.width;

            var mediator = _.find(ctrl.gridOptions.columnDefs, {
              name: colDef.name
            });

            if (width !== '*') {
              ctrl.gridOptions.columnDefs[mediator.__index].width = (parseFloat(width) + parseFloat(deltaChange));
            }

            ctrl.usingService.changeColumnDefinedWidth(
              colDef.__index,
              mediator.width !== '*' ? mediator.width : mediator.settedWidth
            );

            if (!columnsProperty) {
              columnsProperty = angular.copy(ctrl.gridOptions.columnDefs);
            }
            var col = _.find(columnsProperty, {
              name: colDef.name
            });
            col.width = mediator.width;


            var columnsPropertyToSave = angular.copy(columnsProperty);
            _.each(columnsPropertyToSave, function (item) {
              if (item.width === '*') {
                item.width = item.settedWidth;
              }
            });


            userSettingsService.saveProperty($scope.page, 'grid', 'columnsProperty', columnsPropertyToSave);
            ctrl.moveToPosition(true);
          });

          gridApi.grid.registerColumnBuilder(this.updateColumnFilter);
        }.bind(this);

        this.showSaveFilterPopup = function () {
          $uibModal.open({
            templateUrl: 'app/settings/components/filters/modals/saveFilter/save-filter.html',
            size: 'middle-width',
            controller: function ($scope, $uibModalInstance) {
              $scope.filterName = '';
              $scope.filterObj = ctrl.gridFilter;

              $scope.save = function () {
                if ($scope.saveFilterForm.$valid) {
                  ctrl.saveFilter($scope.filterName);
                }
                $uibModalInstance.dismiss();
              };

              $scope.close = function () {
                $uibModalInstance.dismiss();
              };
            }
          });
        };

        var scrollFunc = function () {
          if ($('.functional_block').position() && $('.functional_block').position().top - $(window).scrollTop() > 0) {
            angular.element(document.querySelector('body')).removeClass('hide-body-scrollbar');
            angular.element(document.querySelector('.grid-wrapper')).addClass('hide-body-scrollbar');
          } else {
            $window.scrollTo(0, $('.functional_block').offset() && $('.functional_block').offset().top + 1);
          }

          var elementOffset = angular.element(".settings-grid .ui-grid-viewport[class]").offset();

          var elementTop = elementOffset ? elementOffset.top : null;
          var screenBottom = angular.element(window).scrollTop() + window.innerHeight;

          if (elementTop && (elementTop < screenBottom)) {
            angular.element('.full-with-table-wrapper .table-footer').css('position', 'fixed');
          } else {
            angular.element('.full-with-table-wrapper .table-footer').css('position', 'relative');
          }
        };
        angular.element($document).bind('scroll', scrollFunc);

        var scrollFunc2 = function () {
          angular.element(document.querySelector('body')).removeClass('hide-body-scrollbar');
          angular.element(document.querySelector('.grid-wrapper')).addClass('hide-body-scrollbar');
        };
        angular.element().bind('scroll', scrollFunc2);

        if (isAllowToGetPage()) {
          ctrl.invalidFilterForm = false;
          if ($scope.config.filterFields && $scope.config.filterFields.length) {
            var requiredFilter = $scope.config.filterFields.find(function (value) {
              return value.required
            });
            if (!$scope.onlyReadMode || !requiredFilter) this.getPage();
          } else {
            if (!$scope.onlyReadMode) this.getPage();
          }
        } else {
          ctrl.invalidFilterForm = true;
        }

        function isAllowToGetPage() { // TODO зарефакторить
          if ($scope.config) {
            if ($scope.config.preventRequest) {
              var requiredFilters = $scope.config.filterFields.filter(function (value) {
                return value.required
              });
              if (!requiredFilters.some(function (value) {
                  return ctrl.filter[value.code]
                })) {
                ctrl.invalidFilterForm = true;
                return false;
              }
              return true;
            } else {
              return true;
            }
          } else {
            return true;
          }
        }

        $scope.$watch('filterMeta', function (newVal) {
          ctrl.filterMeta = newVal;
        });

        $scope.$on('$destroy', function () {
          angular.element($document).off('scroll', scrollFunc);
          angular.element($document).off('scroll', scrollFunc2);
        });

        ctrl.openInventoryTagPrintModal = function () {
          $uibModal.open({
            size: 'large-width',
            component: 'printInventoryTags',
            controllerAs: 'ctrl',
            resolve: {
              type: function () {
                return 'byStock'
              },
              params: function () {
                return [$scope.searchText, ctrl.copyfilter];
              }
            }
          });
        };

        ctrl.openStockPrintModal = function () {
          $uibModal.open({
            size: 'middle-width',
            component: 'printStock',
            controllerAs: 'ctrl',
            resolve: {
              params: function () {
                var params = !_.isEmpty(ctrl.copyfilter)? angular.copy(ctrl.copyfilter) : ctrl.gridFilter.loadFilter();
                angular.forEach(params, function (val, key) {
                  if (key !== 'base_mode') {
                    params['filter_' + key] = val;
                  }
                  delete params[key];
                });
                params.base_uom = ctrl.currentBaseMode;
                params.search_string = ctrl.searchText;
                params.filter_calc_cost = undefined;
                return params;
              }
            }
          });
        }

        // формирование подсказки для массива
        ctrl.getArrTipStr = function (arr, field) {
          if (!arr || !arr.length) return '';
          var res = ""
          _.forEach(arr, function (item) {
            if (res) res += ", ";
            res += item[field];
          });
          return res;
        }

        // добавление товаров и услуг в корзину
        ctrl.addToCart = function () {
          if (ctrl.needAddToCart) {
            var rows = getSelectedRows();
            var items = [];

            _.forEach(rows, function (row) {
              var source = row.dataValue;
              items.push({
                catalog_item: {
                  id: source.catalog_item_id || source.id,
                  name: source.name
                },
                derivative: source.derivative || null,
                quantity: source.recommended_purchase_qty || source.qty || source.quantity || 0,
                uom: {id: source.uom.id, name: source.uom.name},
                natural_price: source.cost ||((source.purchase_amount && source.recommended_purchase_qty) ?
                  source.purchase_amount / source.recommended_purchase_qty :
                  (source.purchase_amount || 0)),
                currency: {
                  id: $rootScope.homeCurrency.currency.id,
                  name: $rootScope.homeCurrency.currency.name,
                  char_iso_code: $rootScope.homeCurrency.currency.char_iso_code,
                  numeric_iso_code: $rootScope.homeCurrency.currency.numeric_iso_code,
                  symbol: $rootScope.homeCurrency.currency.symbol
                },
                tax_included: false
              });
            });
            cartService.addToCart({items: items}).then(function (res) {
              cartService.getCartCount().then(function (res) {
                $rootScope.cartCount = res.data.item_count;
                requestStatus.success("Добавление в корзину прошло успешно", 'move', "Перейти в корзину", "#/cart");
              });
            }, function (error) {
              if (error.status == 409 && error.data.code == 'unique_index_violation') {
                errorMessageService.showModal({message: 'Данный товар уже добавлен в корзину', submessage: {}});
              } else {
                requestStatus.error('Во время добавления в корзину произошла ошибка. Повторите попытку позже');
              }
            });
          }
        }

      }
      
    };

  }
})();

/**
 * Директива запрашивае фокус на элемент на котором установлена при линковке
 */
(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('focusRequest', focusRequest);

  /** @ngInject */
  function focusRequest($timeout) {
    var directive = {
      restrict: 'A',
      scope: false,
      link: function (scope, element, attr) {
        // если значение атрибута директивы не указано или равно true (полезно при автоматической генерации директивы)
        if (!attr.focusRequest || attr.focusRequest == 'true') {
          $timeout(function () {
            element[0].focus();
          });
        }

        // сохранять фокус
        if (attr.keepFocus) {
          angular.element(element[0]).bind('focusout', function (e) {
            e.preventDefault();
            element[0].focus();
          });
        }
      }
    };
    return directive;

  }
})();

/**
 * Директива запрашивае фокус на элемент на котором установлена при линковке
 */
(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('focusOnEvent', focusOnEvent);

  /** @ngInject */
  function focusOnEvent($timeout) {
    var directive = {
      restrict: 'A',
      scope: false,
      link: function (scope, element, attr) {
        if (attr.focusOnEvent) {
          // вешается обработчик на событие, указанное в атрибуте
          scope.$on(attr.focusOnEvent, function (event, data) {
            $timeout(function () {
              element[0].focus();
            });
          });
        }
      }
    };
    return directive;

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('filterButton', {
      bindings : {
        gridFilter                : '<',
        configScrollFilter        : '<',
        chooseFilter              : '&',
        prepareSavedFiltersList   : '&',
        turnShowFilter            : '&',
        removeFilter              : '&',
        savedFilterListSearchText : '=',
        showFilter                : '<'
      },
      templateUrl: 'app/components/filter-button/filter-button.html'
    });

})();

(function () {
  'use strict';

  angular.module('frontend')
    .filter('toDotFilter', function () {
      return toDotFilter;
    });

  var toDotFilter = function (text) {
    var ret = (text) ? text.toString().replace('.', ',') : null;
    if (ret) {
      var decArr = ret.split(",");
      if (decArr.length > 1) {
        var dec = decArr[1].length;
        if (dec === 1) {
          ret += '0';
        }
      }
    }
    return ret;
  }
})();

(function () {
  'use strict';

  /**
   * Фильтр, по которому в ответ выдается сумма выведенная с разделителем пробела на каждые три разряда, а также вывод
   * копеек, впереди которых отображается запятая как разделитель
   */
  angular.module('frontend')
    .filter('moneyFilter', function () {
      return moneyFilter;
    });

  var moneyFilter = function (text) {
    var normalize = parseInt(text) / 100;
    var parts     = normalize.toString().split('.');
    parts[0]      = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return  parts.join('.').replace(/\./g, ',');
  }

})();

(function () {
  'use strict';
  angular.module('frontend').service('filterFactoryService', filterFactoryService);

  function filterFactoryService(userSettingsService) {
    this.createFilter = function (page, component, currentFilterFieldName, savedFiltersFieldName) {
      currentFilterFieldName = currentFilterFieldName || "currentFilter";
      savedFiltersFieldName = savedFiltersFieldName || "savedFilters";
      return {
        storeFilter: function (filter) {
          userSettingsService.saveProperty(page, component, currentFilterFieldName, filter)
        },

        loadFilter: function () {
          return userSettingsService.loadProperty(page, component, currentFilterFieldName)
        },

        storeSavedFilters: function (filters) {
          userSettingsService.saveProperty(page, component, savedFiltersFieldName, filters)
        },

        loadSavedFilters: function () {
          return userSettingsService.loadProperty(page, component, savedFiltersFieldName) || {}
        },

        filterNameExists: function (filterName) {
          var savedFilters = this.loadSavedFilters()
          return !!savedFilters[filterName]
        },

        getSavedFiltersNames: function () {
          var savedFilters = this.loadSavedFilters();
          return savedFilters && Object.keys(savedFilters) || []
        },

        saveFilter: function (filterName, filter) {
          var savedFilters = this.loadSavedFilters();
          savedFilters[filterName] = filter
          this.storeSavedFilters(savedFilters)
        },

        removeFilter: function (filterName) {
          var savedFilters = this.loadSavedFilters()
          delete savedFilters[filterName]
          this.storeSavedFilters(savedFilters)
        },

        loadSavedFilter: function (filterName) {
          return this.loadSavedFilters() [filterName]
        }
      }
    }
  }
})();

(function () {
  'use strict';
  angular.module('frontend').directive('checkFilterNameExisting', checkFilterNameExisting);

  function checkFilterNameExisting() {
    return {
      restrict: 'A',
      scope: {
        targetFilter: '='
      },
      require: 'ngModel',
      link: function (scope, element, attr, ctrl) {
        function filterNameExistingFilter(modelValue, viewValue) {
          return !scope.targetFilter.filterNameExists(viewValue)
        }

        ctrl.$validators.filterExists = filterNameExistingFilter;
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('entityViewLowerTable', {
      templateUrl: 'app/components/entity-view-lower-table/entity-view-lower-table.html',
      controller: entityViewCardController,
      bindings: {
        headerItems: '<',
        data: '<'
      }
    });

  function entityViewCardController($scope, $state) {
    var $ctrl = this;

    $ctrl.data.forEach(function(sectionItem) {
      sectionItem.values.forEach(function (value) {
        if (value.value === null) {
          value.value = '-';
        }
      });
      sectionItem.children.forEach(function (childItem) {
        childItem.values.forEach(function (value) {
          if (value.value === null) {
            value.value = '-';
          }
        });
      });
    });

    $ctrl.goToState = function(stateName, stateParams) {
      if ('stateName') {
        $state.go(stateName, stateParams);
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('entityViewCard', {
      templateUrl: 'app/components/entity-view-card/entity-view-card.html',
      controller: entityViewCardController,
      bindings: {
        fields: '<'
      }
    });

  function entityViewCardController($state) {
    var $ctrl = this;

    $ctrl.goToState = function(field) {
      var isTransitional = field.linkParams && field.value !== '-';

      if (isTransitional) {
        var stateName = field.linkParams.stateName;

        if (field.linkParams.stateParams) {
          $state.go(stateName, field.linkParams.stateParams);
        }
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('emptyToNull', function () {
        return {
            restrict: 'A',
            priority:100,
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {
                ctrl.$parsers.push(function(viewValue) {
                    if(viewValue === "") {
                        return null;
                    }
                    return viewValue;
                });
            }
        };
    });
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('email', email);

  /** @ngInject */
  function email($timeout) {
    var directive = {
          restrict: 'E',
          templateUrl: 'app/components/email/email.html',
          scope: {
              mail: '=',
              confirmed: '=',
              modifyConfirmed: '<',
              isRequired: '=',
              mailName:'@?',
              isView: '<?',
              blurEvent: '<?',
              keyEvent: '<?',
              labelName: '<?'
          },
          link:function (scope,element,attr) {
            scope.mailName = attr.mailName || 'email';
          },
          controller: emailController,
          controllerAs: 'vm',
          bindToController: true
        };
    return directive;

    /** @ngInject */
    function emailController($scope, $element) {
      var vm = this;
      vm.oldMail = vm.mail;
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').directive('documentPrintButton', documentPrintButton);

  function documentPrintButton() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/document-print-button/document-print-button.html',
      scope: {
        actions: '<',
        perform: '&',
        reports: '<?',
        performReports: '&?'
      }
    };

    return directive;
  }
})();


(function () {

  angular.module('daterangepicker', [])
    .directive('dateRangePicker', dateRangePickerDirective);

  /** @ngInject */
  function dateRangePickerDirective(dateRangePickerConfig, dateRangePickerApiService, dateRangePickerService, $interval, $timeout) {
    return {
      require: 'ngModel',
      restrict: 'A',
      scope: {
        min: '=',
        max: '=',
        model: '=ngModel',
        opts: '=',
        state: '=',
        disabledDays: '=?',
        clearable: '=',
        onClose: '&',
        name: '@',
        ngRequired: '<',
        fieldLabel: '<',
        change: '<?'
      },
      transclude: true,
      template: '<span class="glyphicon glyphicon-calendar tooltip-light" tooltip-placement="top-right" uib-tooltip="{{(opts.singleDatePicker)? (opts.timePicker)? \'Выбрать дату и время\' : \'Выбрать дату\' : \'Выбор диапазона дат\'}}"></span>\n' +
      '          <date-range-picker-input ng-model="model" opts="opts"\n' +
      '                                   state="state" on-close="closeCallback" name="name"' +
      '                                   field-label="fieldLabel" ng-required="ngRequired"' +
      '                                   model-ctrl="modelCtrl" disabled-days="disabledDays"></date-range-picker-input>',
      link: function ($scope, element, attrs, modelCtrl) {
        var pickerContainerDom, filterMonth, filterQuarter, filterYear, backdrop,
          monthNames = moment.localeData()._months.standalone,
          quarterNames = ['I Квартал', 'II Квартал', 'III Квартал', 'IV Квартал'],
          _picker = null;

        var el = angular.element(element);
        var opts = dateRangePickerApiService.mergeOptions(dateRangePickerConfig, $scope.opts || {}); //merged options
        var $date = $scope.opts.correctTimeZone ? moment : moment.utc;
        var currentDate = $date().startOf('day');

        $scope.modelCtrl = modelCtrl;

        $scope.closeCallback = function (returnValue, name) {
          if ($scope.model && $scope.model.isAllTime) {
            returnValue.isAllTime = true;
          }
          $scope.onClose({returnValue: returnValue, name: name});
        };

        // Таймпикер только одиночный может быть
        if (opts.timePicker) {
          opts.singleDatePicker = true;
        }

        if (!$scope.model && !opts.singleDatePicker) {
          $scope.model = {
            startDate: $date(),
            endDate: $date(),
            isAllTime: true
          };
        } else if (!$scope.model) {
          $scope.model = $date();
          $scope.model.isEmpty = true;
        }

        if (!opts.singleDatePicker) {
          var getLocalizedMonth = function (date) {
            return date.format('MMMM');
          };
          var getLocalizedQuarter = function (date) {
            return quarterNames[date.quarter() - 1];
          };

          filterMonth = getLocalizedMonth(currentDate);
          filterQuarter = getLocalizedQuarter(currentDate);
          filterYear = currentDate.year();

          var setFiltersValues = function (date) {
            if (!date) {
              return;
            }
            filterMonth = getLocalizedMonth(date);
            filterQuarter = getLocalizedQuarter(date);
            filterYear = date.year();
            pickerContainerDom.find('.month-buttons .filter-button').text(filterMonth);
            pickerContainerDom.find('.quarter-buttons .filter-button').text(filterQuarter);
            pickerContainerDom.find('.years-buttons .filter-button').text(filterYear);
          };
        }

        var _setDatePoint = function (setter) {
          return function (newValue) {
            if (_picker && newValue) {
              var val = $date(newValue);
              if (!val.isValid()) {
                _resetCalendar();
              } else {
                setter(val);
              }
              _picker.updateView();
            }
          };
        };

        var _setStartDate = _setDatePoint(function (m) {
          if (_picker.endDate && m.isAfter(_picker.endDate)) {
            _picker.setEndDate(m.clone().startOf('day'));
          }
          _picker.setStartDate(m.clone().startOf('day'));
        });
        var _setEndDate = _setDatePoint(function (m) {
          if (_picker.startDate && m.isBefore(_picker.startDate)) {
            _picker.setStartDate(m.clone().startOf('day'));
          }
          _picker.setEndDate(m.clone().startOf('day').local());
        });
        var _hideAll = function () {
          _picker.startDate = _picker.oldStartDate; // prevent dates changed callback fired
          _picker.endDate = _picker.oldEndDate;
          _picker.hide();
          _picker.isShowing = false;
        };
        var _validate = function (validator) {
          return function (boundary, actual) {
            if (boundary && actual) {
              return validator($date(boundary, opts.locale.format), $date(actual, opts.locale.format));
            } else {
              return true;
            }
          };
        };
        var _validateMin = _validate(function (min, start) {
          return min.isBefore(start) || min.isSame(start, 'day');
        });
        var _validateMax = _validate(function (max, end) {
          return max.isAfter(end) || max.isSame(end, 'day');
        });

        /* set correct data in input */
        var datesChangedCallback = function (start, end) {
          $scope.model = opts.singleDatePicker ? start : {
            startDate: start && dateRangePickerApiService.parse(start, opts),
            endDate: end && dateRangePickerApiService.parse(end, opts)
          };
          setModel($scope.model);
          if (!opts.singleDatePicker) {
            if (!$scope.state.startDateCheck) {
              $scope.model.startDate = null;
            }
            if (!$scope.state.endDateCheck) {
              $scope.model.endDate = null;
            }
            $scope.state.allTime = dateRangePickerApiService.isAllTime($scope.model);
            $scope.model.isAllTime = $scope.state.allTime;
          }
        };

        var _setRange = function (range) {
          if (range.startDate && $scope.state.startDateCheck && !dateRangePickerApiService.checkBoundaries(range.startDate, opts)
            || range.endDate && $scope.state.endDateCheck && !dateRangePickerApiService.checkBoundaries(range.endDate, opts)
            || range.startDate && range.endDate && range.startDate.isAfter(range.endDate)) {
            return _resetCalendar();
          }
          if ($scope.state.startDateCheck && range.startDate) {
            _setStartDate(range.startDate);
          } else if (range.endDate) {
            _setStartDate(range.endDate.clone().subtract(1, 'months'));
          }
          if ($scope.state.endDateCheck && range.endDate) {
            _setEndDate(range.endDate);
          }
          return range;
        };

        var setModel = function (data) {
          $scope.showDatePicker = true;

          if (opts.singleDatePicker) {
            if (data) {
              if (dateRangePickerApiService.checkBoundaries(data, opts)) {
                _setStartDate(data);
                return data;
              }
              return _resetCalendar();
            }
          } else {
            data = data && _setRange(data);
            data && setFiltersValues(data.startDate || data.endDate);
            return data;
          }
        };

        var _init = function () {
          //init start/end date
          if (!opts.singleDatePicker) {
            $scope.model = $scope.model || {};
            $scope.state = $scope.state || {startDateCheck: true, endDateCheck: true};
            $scope.state.allTime = dateRangePickerApiService.isAllTime($scope.model);
          } else {
            $scope.state = $scope.state || {};
          }

          function calendarCanceled() {
            setModel($scope.model);
            $scope.state = angular.merge({}, $scope.state, $scope.oldState);
          }

          var resetCalendar = function (model) {
            _picker.startDate = undefined;
            _picker.endDate = undefined;
            _picker.oldStartDate = undefined;
            _picker.oldEndDate = undefined;
            if (!opts.singleDatePicker) {
              _setStartDate(model && model.startDate || $date());
              _setEndDate(model && model.endDate || $date());
              _picker.startDate =  model && model.startDate || _picker.minDate.clone();
              _picker.endDate = model && model.endDate || _picker.maxDate.clone();
            } else {
              _setStartDate(model || $date());
              _setEndDate(model || $date());
            }
            _picker.oldStartDate = _picker.startDate;
            _picker.oldEndDate = _picker.endDate;
          };

          var eventHandlers = {
            'show.daterangepicker': function () {
              $scope.startDateChoosen = false;
              $scope.oldState = angular.merge({}, $scope.state);
              $scope.state.pickerOpened = true;
              if (!opts.hideBackdrop) {
                backdrop.show();
              }
              if (!$scope.opts.singleDatePicker) {
                if (!$scope.model.startDate && !$scope.model.endDate) {
                  $scope.model = {
                    startDate: dateRangePickerService.getUtcDateTime($date(), opts),
                    endDate: dateRangePickerService.getUtcDateTime($date(), opts)
                  };
                } else {
                  $scope.model = dateRangePickerService.getUtcDateTime($scope.model, opts);
                }
              }
              resetCalendar($scope.model);
              if ($scope.opts.fullRangeRequired) {
                pickerContainerDom.find('.calendar-check').hide()
              }
            },
            'hide.daterangepicker': function () {
              if ($scope.model && (currentDate.valueOf() === $scope.model.valueOf())) {
                $scope.model = $date();
              }
              if ($scope.model) {
                $scope.model.isAllTime = $scope.state.allTime;
              }

              setModel($scope.model);

              if ($scope.model && ($scope.model.startDate && $scope.model.endDate)) {
                var datesIsEqual = $scope.model.startDate.clone().startOf('day').valueOf() === $scope.model.endDate.clone().startOf('day').valueOf();
                if (datesIsEqual && !$scope.model.isAllTime) {
                  $scope.model = {
                    startDate: dateRangePickerService.getUtcDateTime($scope.model.startDate, opts),
                    endDate: dateRangePickerService.getUtcDateTime($scope.model.endDate, opts)
                  };
                  //$scope.model.startDate = dateRangePickerService.getUtcDateTime($scope.model.startDate, opts);
                  if ($scope.model.endDate) {
                    $scope.model.endDate.startOf('day').add(1, 'day').subtract(1, 'seconds');
                  }
                } else {
                  $scope.model = dateRangePickerService.getUtcDateTime($scope.model, opts);
                  //$scope.model.startDate = dateRangePickerService.getUtcDateTime($scope.model.startDate, opts);
                }
                $scope.model.isAllTime = $scope.model.startDate.valueOf() === $scope.model.endDate.valueOf()
              } else if ($scope.model && ($scope.model.startDate || $scope.model.endDate)) {
                $scope.model = {
                  startDate: $scope.state.startDateCheck && $scope.model.startDate ? dateRangePickerService.getUtcDateTime($scope.model.startDate, opts) : null,
                  endDate: $scope.state.endDateCheck && $scope.model.endDate ? dateRangePickerService.getUtcDateTime($scope.model.endDate, opts) : null
                };
                if ($scope.model.endDate) {
                  $scope.model.endDate.tz('UTC').startOf('day').add(1, 'day').subtract(1, 'seconds');
                }
              } else if ($scope.model) {
                $scope.model = dateRangePickerService.getUtcDateTime($scope.model, opts);
              }
              $scope.closeCallback($scope.model, $scope.name);
              $scope.state.pickerOpened = false;
              if (!opts.hideBackdrop) {
                backdrop.hide();
              }
            },
            'cancel.daterangepicker': calendarCanceled,
            'outsideClick.daterangepicker': calendarCanceled
          };
          el.daterangepicker(angular.extend({}, opts, {
            eventHandlers: eventHandlers,
            isInvalidDate: function (day) {
              if ($scope.disabledDays) {
                var dates = _.map($scope.disabledDays, function(item) {
                  return moment.isMoment(item) ? $date(item.valueOf()).startOf('day').valueOf() : item;
                });
                return ~dates.indexOf(dateRangePickerService.getUtcDateTime(day, opts).valueOf())
              }
            }
          }), datesChangedCallback);

          $scope.initWasLaunched = true;
          _picker = el.data('daterangepicker');
          $scope.pickerComponent = _picker;
          pickerContainerDom = _picker.container;

          // outsideclick crutch
          _picker.__outsideClick = _picker.outsideClick;
          _picker.outsideClick = function (e) {
            if (e.target.className === 'picker-backdrop') {
              this.startDate = this.oldStartDate;
              this.endDate = this.oldEndDate;
            }
            _picker.__outsideClick(e);
          };
          // outsideclick crutch end

          // add filter html in datepicker
          if (!opts.singleDatePicker) {
            var filterTemplate = '<section class="wrapper-filters">' +
              '<h5 class="filters-title">Быстрые фильтры</h5>' +
              '<div class="buttons-wrap month-buttons">' +
              '<div class="left-arrow"> < </div>' +
              '<button class="filter-button">' + filterMonth + '</button>' +
              '<div class="right-arrow"> > </div>' +
              '</div>' +
              '<div class="buttons-wrap quarter-buttons">' +
              '<div class="left-arrow"> < </div>' +
              '<button class="filter-button">' + filterQuarter + '</button>' +
              '<div class="right-arrow"> > </div>' +
              '</div>' +
              '<div class="buttons-wrap years-buttons">' +
              '<div class="left-arrow"> < </div>' +
              '<button class="filter-button">' + filterYear + '</button>' +
              '<div class="right-arrow"> > </div>' +
              '</div>' +
              '</section>';
            pickerContainerDom.append(filterTemplate);
            pickerContainerDom.find('.calendar').append('<input type="checkbox" class="calendar-check" checked/><label class="calendar-check-label"></label>');
          }
          // add backdrop
          backdrop = angular.element('<div class="picker-backdrop"></div>');
          pickerContainerDom.after(backdrop);
          // add timeblock html in datepicker
          if (opts.timePicker) {
            pickerContainerDom.addClass('show-time');
            pickerContainerDom.find('.calendar-time').prepend('<h5 class="time-title">Время</h5>');

            // hours two-digit crutch
            // TODO this ugly crutch should be removed after root picker issue resolved
            // TODO https://github.com/dangrossman/bootstrap-daterangepicker/issues/1639
            if (!_picker.__renderTimePicker) {
              _picker.__renderTimePicker = _picker.renderTimePicker;
              _picker.renderTimePicker = function (side) {
                _picker.__renderTimePicker(side);
                pickerContainerDom.find('.hourselect option').each(function () {
                  var value = parseInt(angular.element(this).text(), 10);
                  angular.element(this).text(value < 10 ? '0' + value : value)
                });
              };
            }
          }
          if ($scope.disabledDays) {
            // console.log($scope.disabledDays);
            // $timeout(function() { // триггер для обновления календаря , недоступные даты добавляются после инициализации календаря
            //   element.find('input#' + $scope.name).blur()
            // })
          }

          return Object.keys(eventHandlers).map(function (eventType) {
            return el.on(eventType, function (e) {
              var eventName = e.type + '.' + e.namespace;
              return $scope.$evalAsync(eventHandlers[eventName]);
            });
          });
        };
        _init();

        // Если опции изменятся извне
        $scope.$watch('opts', function (newOpts) {
          opts = dateRangePickerApiService.mergeOptions(opts, newOpts);
          _picker.minDate = opts.minDate;
          _picker.maxDate = opts.maxDate;
        }, true);

        if (opts.pickerOpened) {
          _picker.toggle();
        }

        // Если модель измениться извне
        // Необходимо только в скидочных акциях (по состоянию на первый релиз 19.02.2018)
        $scope.$watch('model', function (newModel) {
          if (newModel && newModel.enableUpdate) {
            $scope.closeCallback(dateRangePickerService.getUtcDateTime(newModel, opts), $scope.name);
          }
        }, true);

        var _initBoundaryField = function (field, validator, modelField, optName) {
          if ($scope[field]) {
            modelCtrl.$validators[field] = function (value) {
              return value && validator(opts[optName], value[modelField]);
            };
            return $scope.$watch(field, function (date) {
              opts[optName] = date ? moment(date, opts.locale.format) : false;
              return _init();
            });
          }
        };
        _initBoundaryField('min', _validateMin, 'startDate', 'minDate');
        _initBoundaryField('max', _validateMax, 'endDate', 'maxDate');

        if (attrs.clearable) {
          $scope.$watch('clearable', function (newClearable) {
            if (newClearable) {
              opts = dateRangePickerApiService.mergeOptions(opts, {
                locale: {
                  cancelLabel: opts.clearLabel
                }
              });
            }
            _init();
            if (newClearable) {
              return el.on('cancel.daterangepicker', function () {
                datesChangedCallback();
              });
            }
          });
        }

        /*
         * reset all values in datepicker
         * @param  el  calendar icon
         */
        var _resetCalendar = function () {
          console.log('moko');
          var startInput = pickerContainerDom.find('input[name="daterangepicker_start"]'),
            endInput = pickerContainerDom.find('input[name="daterangepicker_end"]'),
            startCheck = pickerContainerDom.find('.calendar.left .calendar-check'),
            endCheck = pickerContainerDom.find('.calendar.right .calendar-check');
          startCheck.prop('checked', true).parents('.calendar').removeClass('disabled-calendar'); // TODO state?
          endCheck.prop('checked', true).parents('.calendar').removeClass('disabled-calendar');
          startInput.val(currentDate.format(opts.locale.format));
          startInput.change();
          endInput.val(currentDate.add(1, 'months').format(opts.locale.format));
          endInput.change();
          datesChangedCallback();
        };

        if (!opts.singleDatePicker) {
          // checkboxes for disabled date
          pickerContainerDom.on('change', '.calendar-check', function (e) {
            $scope.$apply(function () {
              return $scope.state = angular.merge({}, $scope.state, {
                startDateCheck: pickerContainerDom.find('.calendar.left .calendar-check').is(':checked'),
                endDateCheck: pickerContainerDom.find('.calendar.right .calendar-check').is(':checked')
              });
            });
            e.stopPropagation()
          });

          $scope.$watch('state', function (data) {
            var calendarLeft = pickerContainerDom.find('.calendar.left');
            var calendarRight = pickerContainerDom.find('.calendar.right');
            calendarLeft.find('.calendar-check').prop('checked', data.startDateCheck);
            calendarRight.find('.calendar-check').prop('checked', data.endDateCheck);

            if (!data.startDateCheck && !data.endDateCheck) {
              _hideAll();
              $scope.state = {
                startDateCheck: true,
                endDateCheck: true,
                allTime: true
              };
              $scope.model = {};
              return;
            }

            if (data.startDateCheck) {
              calendarLeft.removeClass('disabled-calendar');
            } else {
              calendarLeft.addClass('disabled-calendar');
            }
            if (data.endDateCheck) {
              calendarRight.removeClass('disabled-calendar');
              pickerContainerDom.removeClass('disabled-calendar-right');
            } else {
              calendarRight.addClass('disabled-calendar');
              pickerContainerDom.addClass('disabled-calendar-right');
            }

            if ($scope.startDateChoosen) {
              if (!data.startDateCheck) {
                _hideAll();
                $scope.startDateChoosen = false;
                return true;
              } else if (!data.endDateCheck) {
                _hideAll();
                $scope.startDateChoosen = false;
                return true;
              }
            }
          });

          // filter by month and quarter
          pickerContainerDom.on('click', '.buttons-wrap:not(.years-buttons)', function (event) {
            var container = angular.element(event.currentTarget),
              target = angular.element(event.target),
              button = container.find('.filter-button'),
              buttonTextArr = (container.hasClass('month-buttons')) ? monthNames : quarterNames,
              arrIndex = buttonTextArr.indexOf(button.text());

            function setText(index) {
              index = (index + buttonTextArr.length) % buttonTextArr.length;
              button.text(buttonTextArr[index]);
            }

            if (target.hasClass('left-arrow')) {
              setText(--arrIndex);
            } else if (target.hasClass('right-arrow')) {
              setText(++arrIndex);
            }

            if (target.hasClass('filter-button') && container.hasClass('month-buttons')) {
              var monthDate = $date([filterYear, arrIndex]);
              datesChangedCallback(
                monthDate,
                monthDate.clone().endOf('month')
              );
              _hideAll();
            }

            if (target.hasClass('filter-button') && container.hasClass('quarter-buttons')) {
              var quarterDate = $date([filterYear]).quarter(arrIndex + 1);
              datesChangedCallback(
                quarterDate,
                quarterDate.clone().endOf('quarter')
              );
              _hideAll();
            }
          });

          // filter by years
          pickerContainerDom.on('click', '.years-buttons', function (event) {
            var container = angular.element(event.currentTarget),
              target = angular.element(event.target),
              button = container.find('.filter-button');

            if (target.hasClass('left-arrow') || target.hasClass('right-arrow')) {
              var currentYear = parseInt(button.text());
              if (currentYear > 1939 && currentYear < 2036) {
                target.hasClass('left-arrow') ? currentYear-- : currentYear++;
                button.text(currentYear);
              }
            }

            if (target.hasClass('filter-button')) {
              filterYear = parseInt(button.text());
              var yearDate = moment([filterYear]);
              datesChangedCallback(
                yearDate,
                yearDate.clone().endOf('year')
              );
              _hideAll();
            }
          });

          // adjusting behavior of datepicker when calendars is off
          pickerContainerDom.on('mouseup', 'td.available', function () {
            var startInput = pickerContainerDom.find('input[name="daterangepicker_start"]'),
              endInput = pickerContainerDom.find('input[name="daterangepicker_end"]'),
              startCheck = pickerContainerDom.find('.calendar.left .calendar-check').is(':checked'),
              endCheck = pickerContainerDom.find('.calendar.right .calendar-check').is(':checked');

            if (!startCheck) {
              datesChangedCallback(null, endInput.val());
              _hideAll();
            } else if (!endCheck) {
              datesChangedCallback(startInput.val());
              _hideAll();
            } else {
              if (!$scope.startDateChoosen) {
                $scope.startDateChoosen = true;
                $scope.$apply();
              }
            }
          });
        }

        if ($scope.ngRequired) {
          // Стандартный не сработает, так как у нас всегда будет дата
          modelCtrl.$validators.required = function () {
            return $scope.model && !$scope.model.isEmpty && !$scope.model.isAllTime;
          };
        }


        modelCtrl.$formatters.push(function(modelValue) {
          if ($scope.opts.singleDatePicker) {
            if (moment.isMoment(modelValue)) {
              return modelValue
            } else {
              $scope.$evalAsync(function() {
                $scope.model = $date(modelValue)
              })
            }
          } else {
            return modelValue
          }
        });

        return $scope.$on('$destroy', function () {
          return _picker != null ? _picker.remove() : void 0;
        });
      },

      controller: function ($scope) {
        var publicApi = this;
        publicApi.change = $scope.change;
        publicApi.show = function () {
          $scope.pickerComponent.show();
        };

        publicApi.hide = function () {
          $scope.pickerComponent.hide();
        };
      }
    };
  }
}).call(this);

(function () {
  angular.module('daterangepicker')
    .directive('dateRangePickerInput', dateRangePickerInputDirective);

  /** @ngInject */
  function dateRangePickerInputDirective(dateRangePickerApiService, dateRangePickerConfig, dateRangePickerService, $timeout) {
    return {
      restrict: 'E',
      transclude: true,
      require: '^^dateRangePicker',
      scope: {
        model: '=ngModel',
        opts: '=',
        state: '=',
        onClose: '=',
        name: '=',
        modelCtrl: '=',
        ngRequired: '<',
        fieldLabel: '<',
        disabledDays: '<?'
      },
      templateUrl: 'app/components/datepicker/date-range-picker-input.html',
      link: function ($scope, element, attrs, dateRangePickerController) {
        var opts = dateRangePickerApiService.mergeOptions(dateRangePickerConfig, $scope.opts || {});
        var $date = opts.correctTimeZone ? moment : moment.utc;
        var firstSetData = true;
        if (opts.timePicker) {
          opts.singleDatePicker = true;
        }

        dateRangePickerService.opts = opts;

        var configureMask = function (state) {
          if (opts.singleDatePicker) {
            $scope.mask = opts.timePicker ? '99.99.9999 99:99' : '99.99.9999';
          } else {
            if (dateRangePickerApiService.isAllTime($scope.model, state)) {
              $scope.mask = 'AA AAA AAAAA';
            } else {
              var res = '';
              if (state && state.startDateCheck) {
                if (state.pickerOpened && !($scope.model && $scope.model.startDate)) {
                  res += 'A __.__.____';
                } else {
                  if ($scope.model && !$scope.model.startDate) {
                    res += '';
                  } else {
                    res += 'с 99.99.9999';
                  }
                }
              }
              if (state && state.endDateCheck) {
                if (state.pickerOpened && !($scope.model && $scope.model.endDate)) {
                  res += ' AA __.__.____';
                } else {
                  if ($scope.model && !$scope.model.endDate) {
                    res += '';
                  } else {
                    res += ' по 99.99.9999';
                  }
                }
              }
              $scope.mask = res;
            }
          }
        };

        if ($scope.state) {
          $scope.state.forceUpdate = function(model) {
            onModelChange(model)
          };
          $scope.state.resetData = function () {
            $scope.$applyAsync(function () { // код применяется в следующем digest
              $scope.model = null; // сначала полный сброс
              // восстановление исходных значений в следующем digest
              // ($applyAsync и $evalAsync не всегда работают, особенно если имеем дело с элементами , сгенерированными ng-repeat)
              $timeout(function() {
                var model;
                if (opts.singleDatePicker) {
                  model = $date();
                  model.isEmpty = true;
                } else {
                  model = {
                    startDate: $date(),
                    endDate: $date(),
                    isAllTime: true
                  }
                }
                $scope.model = model
              }, 0)
            });
            // $scope.onClose($scope.model, $scope.name);
          }
        }

        $scope.$on('userTimezoneChanged', function() {
          onModelChange($scope.model)
        });

        $scope.$watch('opts', function (newOpts) {
          opts = dateRangePickerApiService.mergeOptions(opts, newOpts);
          configureMask($scope.state);
          return opts;
        }, true);

        $scope.$watch('state', function (state) {
          configureMask(state);
        });

        function onModelChange(model) {
          // если первоначальная установка даты, то не надо стаивть dirty и touched
          if (!firstSetData && model) {
            $scope.modelCtrl.$setDirty();
            $scope.modelCtrl.$setTouched();
          } else {
            firstSetData = false;
          }

          if (element.find('input').val() === '__.__.____' && model === true) {
            element.find('input').focus();
          }
          configureMask($scope.state);

          if (model && model.isAllTime && !opts.singleDatePicker) {
            // если за всё время
            $scope.mask = 'AA AAA AAAAA';
            $scope.state.allTime = true;
            $scope.viewValue = $scope.opts.allTimePlaceholder || dateRangePickerApiService.getAllTimePlaceholder();
          } else if (opts.singleDatePicker && $scope.model && ($scope.model.isInvalid || $scope.model.isEmpty)) {
            // если невалидный или пустой
            $scope.model.isInvalid = false;
            $scope.model.isEmpty = true;
          } else {
            // если есть значение
            $scope.modelCtrl.$setValidity($scope.invalidMessageStore, true);
            $scope.viewValue = dateRangePickerService.format(model, $scope, opts);
          }
          if (dateRangePickerController.change) {
            dateRangePickerController.change(model && !!model.isEmpty);
          }
        }

        $scope.$watch('model', onModelChange);

        if ($scope.model && dateRangePickerApiService.isAllTime($scope.model, $scope.state) && !opts.singleDatePicker) {
          element.find('input').blur();
        }

        element.find('input')
          .on('focus', function () {
            if (!opts.singleDatePicker) {
              // Если за всё время, то показываем пикер независимо от того, куда мы кликнули
              if (dateRangePickerApiService.isAllTime($scope.model, $scope.state)) {
                element.find('input').blur();
                dateRangePickerController.show();
                return;
              }
              dateRangePickerController.hide();
            }

            if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
              $scope.$apply();
            }
          })
          .on('click', function (e) {
            e.stopPropagation();
          })
          .on('keydown', function (e) {
            e.stopPropagation();
          })
          .on('blur', function () {
            var model;
            var date = opts.correctTimeZone ? moment : moment.utc;
          // Ставим компонент тронутый даже если ничего не изменили
            $scope.modelCtrl.$setDirty();

            // Мы верим юзеру, поэтому сообщение об ошибке выставляем в ''
            $scope.invalidMsg = '';

            if (!opts.singleDatePicker) {
              // Если диапазон, сразу пытаемся парсить и присваеваем модель
              model = dateRangePickerService.parseRange($scope.viewValue, $scope, $scope.oldViewValue, opts);
            } else if (!opts.timePicker) {
              // Если одинарный, пытаемся парсить другим парсером и присваеваем во временную переменную
              model = dateRangePickerService.parseSingle($scope.viewValue, $scope, $scope.oldViewValue, opts);
            } else {
              // Если одинарный да ещё и со временем, пытаемся парсить другим парсером и присваеваем во временную переменную
              model = dateRangePickerService.parseSingleTime($scope.viewValue, $scope, $scope.oldViewValue, opts);
            }

            if (opts.singleDatePicker && opts.correctTimeZone && !model._isUTC) {
              model.subtract(dateRangePickerService.timezoneDifference(), 'minutes');
            } else {
              if (model.startDate) {
                model.startDate.subtract(dateRangePickerService.timezoneDifference(), 'minutes');
              }
              if (model.endDate) {
                model.endDate.subtract(dateRangePickerService.timezoneDifference(), 'minutes');
              }
            }

            // Заточено под конкретный случай, если введём неправильную дату (33 блаблабря 3333 года)
            // пустое значение должно валидироваться, как правильное
            // model === false если у нас нет значение в инпуте
            if ($scope.invalidMsg && $scope.viewValue && model !== false) {
              $scope.invalidMessageStore = $scope.invalidMsg;
              $scope.modelCtrl.$setValidity($scope.invalidMsg, false);
            } else {
              $scope.modelCtrl.$setValidity($scope.invalidMessageStore, true);
            }

            if ($scope.disabledDays) {
              var dates = _.map($scope.disabledDays, function(item) {
                return moment.isMoment(item) ? date(item).startOf('day').valueOf() : item;
              });
              $scope.modelCtrl.$setValidity('dateIsDisabled', !~dates.indexOf(date(model).startOf('day').valueOf()));
            }

            if (!opts.singleDatePicker) {
              $scope.model = model;
            }

            // Если был не диапазон, то есть временной пременной что-то присвоили
            if (model && opts.singleDatePicker) {
              $scope.model = model;
            } else if (opts.singleDatePicker || opts.timePicker) {
              // встречал, что стоит опция таймпикер, но не стоит синглпикер.
              // если парсер ничего не вернул, то пикер заполняется текущей датой и ставим, чтобы её не отображать
              $scope.model = date();
              $scope.model.isEmpty = true;
              $scope.model.isInvalid = true;
            }

            // Если диапазон всё время, ставим пометку
            if (dateRangePickerApiService.isAllTime($scope.model)) {
              $scope.state.allTime = true;
              $scope.model.isAllTime = true;
            }

            // запускаем дайджест, так как он в событиях джКвери не стартует
            if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
              $scope.$apply();
            }

            // если дата пропарсена, то запускаем коллбэк для родительского контроллера
            if ($scope.model.startDate || $scope.model.endDate) {
              $scope.model = {
                startDate: $scope.model.startDate && dateRangePickerService.getUtcDateTime($scope.model.startDate, opts),
                endDate: $scope.model.endDate && dateRangePickerService.getUtcDateTime($scope.model.endDate, opts)
              };
            } else {
              $scope.model = dateRangePickerService.getUtcDateTime($scope.model, opts);
            }
            $scope.onClose($scope.model, $scope.name);
          });
      }
    };
  }
}).call(this);

(function () {
  angular.module('daterangepicker')
  .constant('dateRangePickerConfig', {
    clearLabel: 'Clear',
    linkedCalendars: true, // fix calendars
    minDate: moment([1940, 0, 1]),
    maxDate: moment([2035, 11, 31]),
    locale: {
      separator: ' - ',
      format: 'DD.MM.YYYY',
      formatWithTime: 'DD.MM.YYYY HH:mm',
      applyLabel: "Применить",
      daysOfWeek: moment.localeData()._weekdaysShort.map(function (weekday) {return weekday.toUpperCase();}),
      monthNames: moment.localeData()._months.standalone,
      firstDay: 1,
      getFormat: function (timepicker) {
        return timepicker ? this.formatWithTime : this.format;
      }
    },
    showDropdowns: true,
    autoUpdateInput: true,
    autoApply: true,
    timePicker24Hour: true,
    opens: 'left'
})
  .constant('dateRangePickerAllTimePlaceholder', 'За все время')
  .service('dateRangePickerApiService', function service(dateRangePickerConfig, dateRangePickerAllTimePlaceholder, $injector) {
    this._allTimePlaceholder = dateRangePickerAllTimePlaceholder;

    this.setAllTimePlaceholder = function(placeholder) {
      this._allTimePlaceholder = placeholder;
    };

    this.getAllTimePlaceholder = function() {
      return this._allTimePlaceholder;
    };

    this.mergeOptions = function () {
      var extendData = angular.extend.apply(angular, [{}].concat(Array.prototype.slice.call(arguments)));
      var data = angular.merge.apply(angular, [{}].concat(Array.prototype.slice.call(arguments)));
      data.locale.format = dateRangePickerConfig.locale.getFormat(data.timePicker);
      // merge operation break momentjs object
      data.minDate = extendData.minDate;
      // merge operation break momentjs object
      data.maxDate = extendData.maxDate;
      // disable if not single date picker
      data.showDropdowns = data.showDropdowns && data.singleDatePicker;
      return data;
    };

    this.isAllTime = function (model, state) {
      if (state) {
        return !!state.allTime;
      }

      return !model || model === this._allTimePlaceholder ||
        !moment.isMoment(model) && !angular.isString(model) && !model.startDate && !model.endDate;
    };

    this.checkBoundaries = function(date, opts) {
      var parsedDate = this.parse(date, opts);
      return parsedDate.isSameOrAfter(opts.minDate) && parsedDate.isSameOrBefore(opts.maxDate);
    };

    this.format = function (date, opts) {
      if (!date) {
        return "";
      }
      if (!moment.isMoment(date)) {
        return moment(date).format(opts.locale.format); // TODO нужно ли?
      } else {
        if (opts.correctTimeZone) {
          var userTimezone = $injector.get('dateRangePickerService').getUserTimezoneId();
          return date.utc().tz(userTimezone).format(opts.locale.format);
        } else {
          return date.utc().format(opts.locale.format);
        }
      }
    };

    this.parse = function (value, opts) {
      var difference = $injector.get('dateRangePickerService').timezoneDifference();
      if (opts.correctTimeZone) {
        return moment.isMoment(value) ? value : moment(value, opts.locale.format);
      } else {
        return moment.isMoment(value) ? value : moment.utc(value, opts.locale.format).add(difference, 'minutes');
      }
    };

    this.valid = function (value, opts) {
      var val = this.parse(value, opts);
      return val.isValid() && this.checkBoundaries(val, opts);
    };
  });
}).call(this);

(function () {
  angular.module('daterangepicker')
    .service('dateRangePickerService', function service(dateRangePickerApiService, auth, $rootScope) {
      var settedTzOffset = new Date().getTimezoneOffset();
      var userTimezoneId;
      var userTimezoneOffsetPromise;
      var self = this;
      // этот функционал связан с проверкой закэшированного промиса sessions/me , а не с запросом напрямую. логика тут завязана на кеширование промиса при обращении к ensureUserData
      $rootScope.$watch(function() {
        var promise = null;
        if ($rootScope.user && $rootScope.permissions) {
          promise = auth.ensureUserData()
        }
        return promise
      }, function(val) {
        if (val) {
          self.getUserTimezone();
        }
      });

      this.timezoneDifference = function() {
        return moment().tz(userTimezoneId).utcOffset() - moment().utcOffset();
      };

      this.format = function (objValue, $scope, opts) {
        if ($scope.model && $scope.invalidMsg) {
          delete $scope.invalidMsg;
        }
        if (!opts || !objValue) {
          return dateRangePickerApiService.getAllTimePlaceholder();
        }

        if (!opts.singleDatePicker && ((!('endDate' in objValue) && ('startDate' in objValue)) ||
            (!('startDate' in objValue) && ('endDate' in objValue)))) {
          $scope.state.allTime = false;
        }
        var format = function (date) {
          return dateRangePickerApiService.format(date, opts);
        };

        if (opts.singleDatePicker) {
          return format(objValue);
        } else if (objValue) {
          if (dateRangePickerApiService.isAllTime(objValue, $scope.state)) {
            objValue.startDate = moment();
            objValue.endDate = moment();
            return opts.allTimePlaceholder || dateRangePickerApiService.getAllTimePlaceholder();
          } else {
            var startDateStr = format(objValue.startDate);
            var endDateStr = format(objValue.endDate);
            var res = '';
            if ($scope.state.startDateCheck) {
              if (startDateStr && startDateStr.length > 0) {
                res = 'с ' + startDateStr;
              } else if ($scope.state.pickerOpened) {
                res = 'с __.__.____';
              }
            }
            if ($scope.state.endDateCheck) {
              if (endDateStr && endDateStr.length > 0) {
                res += ' по ' + endDateStr;
              } else if ($scope.state.pickerOpened) {
                res += ' по __.__.____';
              }
            }

            $scope.state.filtersUsed = false;
            return res.trim();
          }
        }
      };

      this.getUserTimezoneId = function() {
        return userTimezoneId;
      };

      this.parseRange = function (viewValue, $scope, reservation, opts) {
        var placeholder = opts.allTimePlaceholder || dateRangePickerApiService.getAllTimePlaceholder();
        if (viewValue === placeholder) {
          return parse(viewValue, $scope, opts);
        }
        var parseStr = viewValue.match(/\d{1,2}/g);
        var isParseStrLastLengthValid = parseStr && parseStr[parseStr.length - 1].length === 2;
        var from = '';
        var to = '';

        if ((!parseStr || !viewValue) || (parseStr.length === 4 && $scope.state.startDateCheck && $scope.state.endDateCheck)) {
          return {
            startDate: moment(),
            endDate: moment(),
            isAllTime: true
          };
        }

        if (parseStr && viewValue &&  reservation && ((parseStr.length !== 4 && parseStr.length !== 8) || !isParseStrLastLengthValid)) {
          parseStr = reservation.match(/\d{1,2}/g);
        }

        if (!parseStr) {
          return parse(parseStr, $scope, opts);
        }


        if ($scope.state.startDateCheck && parseStr.length >= 4) {
          from = 'с ' + parseStr[0] + '.' + parseStr[1] + '.' + parseStr[2] + parseStr[3];
        }

        if ($scope.state.endDateCheck && parseStr.length === 8) {
          to = 'по ' + parseStr[4] + '.' + parseStr[5] + '.' + parseStr[6] + parseStr[7];
        }

        if (!$scope.state.startDateCheck && $scope.state.endDateCheck && parseStr.length === 4) {
          to = 'по ' + parseStr[0] + '.' + parseStr[1] + '.' + parseStr[2] + parseStr[3];
        }
        var totalStr = from + ' ' + to;

        return parse(totalStr, $scope, opts);
      };

      this.parseSingle = function (viewValue, $scope, reservation, opts) {
        if (!viewValue) {
          var m = moment();
          m.isEmpty = true;
          return m;
        }
        var parseStr = viewValue.match(/\d{1,2}/g);
        var isParseStrLastLengthValid = parseStr && parseStr[parseStr.length - 1].length === 2;

        if (!parseStr && !viewValue) {
          return false;
        }

        if (parseStr && viewValue &&  reservation && (parseStr.length !== 4 || !isParseStrLastLengthValid)) {
          parseStr = reservation.match(/\d{1,2}/g);
        }

        if (!parseStr) {
          return parse(parseStr, $scope, opts);
        }


        var totalStr = parseStr[0] + '.' + parseStr[1] + '.' + parseStr[2] + parseStr[3];

        return parse(totalStr, $scope, opts);
      };

      this.parseSingleTime = function (viewValue, $scope, reservation, opts) {
        if (!viewValue) {
          var m = moment();
          m.isEmpty = true;
          return m;
        }
        var parseStr = viewValue.match(/\d{1,2}/g);
        var isParseStrLastLengthValid = parseStr && parseStr[parseStr.length - 1].length === 2;

        if (!parseStr && !viewValue) {
          return moment();
        }

        if (parseStr && reservation && viewValue && (parseStr.length !== 6 || !isParseStrLastLengthValid)) {
          parseStr = reservation.match(/\d{1,2}/g);
        }

        if (!parseStr) {
          return parse(parseStr, $scope, opts);
        }

        var totalStr = parseStr[0] + '.' + parseStr[1] + '.' + parseStr[2] + parseStr[3] + ' ' + parseStr[4] + ':' + parseStr[5];

        return parse(totalStr, $scope, opts);
      };

      this.getUserTimezoneOffset = function() {
        return moment().tz(userTimezoneId).utcOffset();
      };

      this.validateManualInput = function(viewValue, $scope, opts) {
        if (opts.singleDatePicker) {
          return true;
        }
        if (dateRangePickerApiService.isAllTime(viewValue)) {
          return true;
        }
        var parts = viewValue.split(' ')
          .filter(function (x) {
            return !!x;
          });

        if (parts.length === 4) {
          return dateRangePickerApiService.valid(parts[1], opts)
            && dateRangePickerApiService.valid(parts[3], opts)
            && parts[0] === 'с' && parts[2] === 'по';
        }
        if (parts[1] === '___') {
          return true;
        }
        return parts.length === 2 && dateRangePickerApiService.valid(parts[1], opts)
          && (parts[0] === 'с' || parts[0] === 'по');
      };

      this.getUtcDateTime = function (momentObj, opts) {
        if (!momentObj) {
          return;
        } else if (momentObj.startDate || momentObj.endDate) {
          return {
            startDate: momentObj.startDate && self.getUtcDateTime(momentObj.startDate, opts).startOf('day'),
            endDate: momentObj.endDate && self.getUtcDateTime(momentObj.endDate, opts).startOf('day').add(1, 'day').subtract(1, 'seconds')
          };
        }

        var localMoment = moment(momentObj);
        var realTzOffset = this.createMinuteOffsetValue(localMoment.format('Z'));
        localMoment.isEmpty = momentObj.isEmpty;

        opts = opts || {correctTimeZone: true};
        if (!opts.timePicker) {
          localMoment.set({hour: 0, minute: 0, second: 0, millisecond: 0});
        } else {
          localMoment.millisecond(0);
        }

        if (opts.correctTimeZone) {
          var userOffset = moment().tz(userTimezoneId).utcOffset();
          localMoment.subtract(realTzOffset, 'minutes').subtract(userOffset, 'minutes').tz(userTimezoneId);
        } else {
          localMoment.subtract(realTzOffset, 'minutes').tz('UTC');
        }
        return localMoment;
      };

      function parse(viewValue, $scope, opts) {
        var val = viewValue;
        if (val && val.length > 0) {
          if (opts.singleDatePicker) {
            var value = dateRangePickerApiService.parse(val, opts);
            if (dateRangePickerApiService.valid(value, opts)) {
              return value;
            }
            console.log('wat?');
            $scope.invalidMsg = 'wrong-date';
            return $scope.model;
          } else {
            if (dateRangePickerApiService.isAllTime(val)) {
              return {
                startDate: moment(),
                endDate: moment()
              };
            }
            var parts = val.split(' ')
              .filter(function (x) {
                return !!x;
              });
            if (parts.length === 4) {
              if (parts[0] === 'с' && parts[2] === 'по') {
                var startDate = dateRangePickerApiService.parse(parts[1], opts);
                var endDate = dateRangePickerApiService.parse(parts[3], opts);
                if (dateRangePickerApiService.valid(startDate, opts)
                  && dateRangePickerApiService.valid(endDate, opts)
                  && startDate.isSameOrBefore(endDate)) {
                  return {
                    startDate: startDate,
                    endDate: endDate
                  };
                }

                if (startDate.isAfter(endDate)) {
                  $scope.invalidMsg = 'End-earlier-than-start';
                }

                if (!dateRangePickerApiService.valid(startDate, opts) ||
                  !dateRangePickerApiService.valid(endDate, opts)) {
                  $scope.invalidMsg = 'Invalid-start-or-end';
                }
              }

              return $scope.model;
            }
            var date = dateRangePickerApiService.parse(parts[1], opts);
            if (dateRangePickerApiService.valid(date, opts)) {
              var res = {};
              if (parts[0] === 'с') {
                res.startDate = date;
                return res;
              } else if (parts[0] === 'по') {
                res.endDate = date;
                return res;
              }
            }
            return $scope.model;
          }
        }
        if (opts.singleDatePicker) {
          return null;
        }
        return {
          startDate: moment(),
          endDate: moment()
        };
      }

      this.createMinuteOffsetValue = function(stringOffset) {
        var values = stringOffset.substr(1, 5).split(':');
        var multiplier = 1;
        var value;

        // offset to change timezone should have opposite sign
        if (stringOffset[0] === '+') {
          multiplier = -1;
        }

        value = (+values[0] * 60) + (+values[1]);

        return multiplier * value;
      };

      this.getUserTimezone = function() {
        if (userTimezoneOffsetPromise === auth.ensureUserData()) {
          return userTimezoneOffsetPromise
        }
        (function (context) {
          userTimezoneOffsetPromise = auth.ensureUserData().then(function (user) {
            var offsetManual;
            if (user.data.user && user.data.user.time_zone_ext) {
              offsetManual = user.data.user.time_zone_ext.offset;
            } else {
              offsetManual = moment.parseZone(new Date()).format('Z');
            }
            userTimezoneId = user.data.user.time_zone;
            settedTzOffset = context.createMinuteOffsetValue(offsetManual);
            $rootScope.$broadcast('userTimezoneChanged');
          });
        })(self);

        return userTimezoneOffsetPromise;
      };

      this.getUserTimezone();

    });
}).call(this);

'use strict';
angular.module('frontend').component('counterpartiesMap', {
  templateUrl: 'app/components/counterpartiesMap/counterparties-map.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controllerAs: 'counterpartiesMapCtrl',
  controller: function ($scope, contragentService, egaiszService, OPTIONS_LENGTH, requestStatus, utilsService) {
    var counterpartiesMapCtrl = this;
    counterpartiesMapCtrl.errorInd = [];
    counterpartiesMapCtrl.optionLength = OPTIONS_LENGTH;
    counterpartiesMapCtrl.counterparty = counterpartiesMapCtrl.resolve.params.values[counterpartiesMapCtrl.resolve.params.item.ref[0]];


    counterpartiesMapCtrl.refreshCounterparties = function(search){
      contragentService.counterpartiesSearch(search, OPTIONS_LENGTH).then(function(res){
        counterpartiesMapCtrl.counterpartiesAuto = res.data;
        if(!counterpartiesMapCtrl.counterpartiesFullTotal){
          counterpartiesMapCtrl.counterpartiesFullTotal = res.data.total;
        }
      })
    }
    counterpartiesMapCtrl.totalStr = function(){
      if(counterpartiesMapCtrl.counterpartiesFullTotal > OPTIONS_LENGTH){
        return "Показано " + OPTIONS_LENGTH + " из " + counterpartiesMapCtrl.counterpartiesFullTotal;
      }
      return '';
    };

    // построение колоночной модели
    counterpartiesMapCtrl.columns = [{
      name: "№",
      flex: 0.7,
      templateUrl: 'counterpartiesMapNumberTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    },{
      name: 'Наименование',
      field: 'name',
      flex: 6,
      headerTemplateUrl: 'counterpartiesMapHeaderCellTemplate.html',
      templateUrl: 'counterpartiesMapNameCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    },{
      name: 'ИНН',
      field: 'inn',
      flex: 2.3,
      headerTemplateUrl: 'counterpartiesMapHeaderCellTemplate.html',
      templateUrl: 'counterpartiesMapCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    },{
      name: 'КПП',
      field: 'kpp',
      flex: 1.8,
      headerTemplateUrl: 'counterpartiesMapHeaderCellTemplate.html',
      templateUrl: 'counterpartiesMapCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    },{
      name: "",
      flex: 0.7,
      templateUrl: 'documentGridControlTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true,
      width: 50
    }];

    counterpartiesMapCtrl.addRow = function(){
      counterpartiesMapCtrl.counterparties.push({});
    }

    counterpartiesMapCtrl.removeValue = function(index){
      counterpartiesMapCtrl.counterparties.splice(index, 1);
      counterpartiesMapCtrl.checkValid();
    }

    counterpartiesMapCtrl.close = function() {
      counterpartiesMapCtrl.modalInstance.close();
    };

    counterpartiesMapCtrl.updateCounterpartiesList = function(){
      egaiszService.getCounterpartyBind(counterpartiesMapCtrl.counterparty.id).then(function(res){
        if(res.data){
          counterpartiesMapCtrl.counterparties = _.map(res.data, function(data){
            return {counterparty: data}; // необходимо для красивого добавления пустого выпадающего списка в грид при добавлении (клик плюсик)
          });
          if (!res.data.length) {
            counterpartiesMapCtrl.addRow();
          }
        }else{
          counterpartiesMapCtrl.counterparties = [];
          counterpartiesMapCtrl.addRow();
        }
      });
    }
    counterpartiesMapCtrl.updateCounterpartiesList();

    counterpartiesMapCtrl.save = function(){
      if (counterpartiesMapCtrl.errorInd.length || !$scope.counterpartiesMap.$valid) {
        counterpartiesMapCtrl.isSaved = true;
        utilsService.setTouched($scope.counterpartiesMap);
        return;
      }

      var counterparties = _.map(angular.copy(counterpartiesMapCtrl.counterparties), function(counterparty){
        return {
          id: counterparty.counterparty.id,
          name: counterparty.counterparty.name
        }
      });
      egaiszService.putCounterpartyBind(counterpartiesMapCtrl.counterparty.id, counterparties).then(function(res){
        counterpartiesMapCtrl.modalInstance.close();
      }, function (error) {
        if (error) {
          requestStatus.error("Во время сохранения произошла ошибка. Повторите попытку позже");
        }
      });
    }

    counterpartiesMapCtrl.checkValid = function(){
      counterpartiesMapCtrl.errorInd = [];
      angular.forEach(counterpartiesMapCtrl.counterparties, function(item1, key1){
        angular.forEach(counterpartiesMapCtrl.counterparties, function(item2, key2){
          if(item1.counterparty && item2.counterparty && item1.counterparty.id && item2.counterparty.id && key1 < key2 && item1.counterparty.id == item2.counterparty.id){
            counterpartiesMapCtrl.errorInd.push(key1);
            counterpartiesMapCtrl.errorInd.push(key2);
          }
        });
      });
    }


  }
});




angular.module('frontend')
       .component('contactInfo', {
         bindings: {
           contactInfo: '=',
           minDetailsRequired: '<?',
           nameId: '<?' // необходим, когда на страничка два разных блока с контактами
         },
         templateUrl: 'app/components/contact-info/contact-info.html',
         controllerAs: 'vm',
         controller: function ($scope, $timeout, focus, $state) {
           var vm = this;

           vm.patterns = {
             "PHONE": '^[\\d()+# -]{1,20}$',
             "EMAIL": '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3})|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
             "FAX": '^[\\d()*+ -]{1,20}$',
             "SKYPE": '^[A-Za-z0-9_.-]+$',
             "WEBSITE": '^(http\\:\\/\\/|https\\:\\/\\/)?([a-zа-яё0-9][a-zа-яё0-9\\-]*\\.)+[a-zа-яё0-9][a-zа-яё0-9\\-]*$'
           };

           vm.minDetailsRequired = vm.minDetailsRequired || 0;

           if(!vm.contactInfo){
             vm.contactInfo = {};
           }

           if(!vm.nameId){
             vm.nameId = '';
           }

           if(!vm.contactInfo.details) {
             vm.contactInfo.details = [
               {caption: "Телефон", type: "PHONE"},
               {caption: "E-mail", type: "EMAIL"},
               {caption: "Факс", type: "FAX"}
             ];
           }

           vm.stateName = $state.current.name;

           vm.removeCompanyContact = function (index) {
             vm.contactInfo.details.splice(index, 1)
           };

           vm.addCompanyContact = function(type, caption){
             vm.contactInfo.details.push({caption: caption, type: type});
             $timeout(function () {
               focus.setFocusOnInput('[name="contactVal' + vm.nameId + (vm.contactInfo.details.length - 1) + '"]')
             },1)
           };
         }
       });

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('catalogTreeNodeCell', catalogTreeNodeCell);

  /** @ngInject */
  function catalogTreeNodeCell($compile, $templateCache) {
    var directive = {
      require: '^catalogTreeNode',
      restrict: 'E',
      templateUrl: 'app/components/catalog-tree/catalog-tree-node-cell.html',
      controller: catalogTreeNodeCtrl,
      bindToController: true,
      controllerAs: 'catalogTreeNodeCellCtrl',
      scope: {
        value: '=', // значение в сроке (предполагается, что в шаблоне есть обработка этого значения)
        templateUrl: '<?', // шаблон ячейки
        column: '=?', // информация о колонке (из модели колонок)
        cellUpdateCallback: '=?', // коллбек для изменений ячейки
        templateScope: '=?'  // функциональный scope
      },
      link: function (scope, element, attrs, catalogTreeNode) {
        scope.catalogTreeNodeCellCtrl.catalogTreeNodeCtrl = catalogTreeNode;
        var cellScope = undefined;
        if (scope.catalogTreeNodeCellCtrl.templateScope && scope.catalogTreeNodeCellCtrl.templateScope.$new) {
          cellScope = scope.catalogTreeNodeCellCtrl.templateScope.$new();
        } else {
          cellScope = scope.$new();
        }
        cellScope.value = scope.catalogTreeNodeCellCtrl.value;
        // Ищем переданный шаблон или используем по-умолчанию
        var _template = $templateCache.get(scope.catalogTreeNodeCellCtrl.templateUrl || 'defaultCellTemplate.html');
        // Компилируем шаблон
        var template = $compile(_template)(cellScope);
        // добавляем в ячейку
        var cellContainer = angular.element(element[0].querySelector('.tree-cell-container'));
        cellContainer.append(template);

        // необходимо позаботиться об освобождении функционального скоупа
        scope.$on('$destroy', function() {
          cellScope.$destroy();
        });
      }
    };
    return directive;

    function catalogTreeNodeCtrl($scope, $log, $rootScope, cartService, requestStatus) {
      var catalogTreeNodeCellCtrl = this;

      /* метод вызыватся при изменении значения в ячейке ($watch вероятнее менее производителен) */
      catalogTreeNodeCellCtrl.updateCell = function(price) {
        /* расширение информации для обратного вызова */
        return catalogTreeNodeCellCtrl.cellUpdateCallback(
          catalogTreeNodeCellCtrl.value,
          catalogTreeNodeCellCtrl.column,
          price
        );
      }

      catalogTreeNodeCellCtrl.addToCart = function(price, column) {
        var data = $scope.catalogTreeNodeCellCtrl.value;
        var item = {
          catalog_item: {
            id: data.catalog_item.id,
            name: data.catalog_item.name
          },
          quantity: price.effective_qty,
          natural_price: price.price_for_one_uom || 0,
          currency: column.currency,
          uom: {
            id: data.catalog_item.uom.id,
            name: data.catalog_item.uom.name
          },
          tax_included: column.taxes_included
        };
        cartService.addToCart({items: [item]}).then(function(res){
          cartService.getCartCount().then(function(res){
            $rootScope.cartCount = res.data.item_count;
            requestStatus.success("Добавление в корзину прошло успешно", 'move', "Перейти в корзину", "#/cart" );
          });
        }, function(error){
          if (error.status == 409 && error.data.code == 'unique_index_violation') {
            errorMessageService.showModal({message: 'Данный товар уже добавлен в корзину', submessage: {}});
          } else {
            requestStatus.error('Во время добавления в корзину произошла ошибка. Повторите попытку позже');
          }
        });
      }

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('catalogTreeNode', catalogTreeNode);

  /** @ngInject */
  function catalogTreeNode($compile, $templateCache) {
    var directive = {
      require: '^catalogTree',
      restrict: 'E',
      templateUrl: 'app/components/catalog-tree/catalog-tree-node.html',
      controller: catalogTreeNodeCtrl,
      bindToController: true,
      controllerAs: 'catalogTreeNodeCtrl',
      scope: {
        level: '<', // Уровень узла
        node: '='  // Данные узла
      },
      link: function (scope, element, attrs, treeCtrl) {
        scope.catalogTreeNodeCtrl.treeCtrl = treeCtrl;

        // Шаблон отображения иерархческой колонки
        var cellScope = scope.$new();
        // Ищем переданный шаблон или используем по-умолчанию
        var _template = $templateCache.get(scope.catalogTreeNodeCtrl.treeCtrl.hierarchicalTemplateUrl || 'defaultHierarchicalTemplate.html');
        // Компилируем шаблон
        var template = $compile(_template)(cellScope);
        // добавляем в ячейку
        var cellContainer = angular.element(element[0].querySelector('.tree-row-cell-hierarchical'));
        cellContainer.append(template);

        // Элемент смещения (для полного выделения строки)
        var el = angular.element('<div/>');
        el.css('float', 'left');
        el.css('height', '100%');
        el.css('width',
          (scope.catalogTreeNodeCtrl.treeCtrl.showArrow ? 25 : 20) // Отступ зависит от режима отображения стрелок раскрытия
          * (scope.catalogTreeNodeCtrl.level - (scope.catalogTreeNodeCtrl.treeCtrl.rootVisible ? 0 : 1))  // зависимость от отображения рута (сдвиг рута лучше не добавлять)
          + 'px');
        var textEl = angular.element(element[0].querySelector('.tree-row-cell-hierarchical'));
        textEl.before(el);

        // Настройка драг-and-дропа
        var rowEl = angular.element(element[0].querySelector('.catalog-tree-text'))
        rowEl.bind('dragenter', function (e) {
          this.classList.add('drag-over');
          if (!scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.unstructure]) {
            e.originalEvent.dataTransfer.dropEffect = 'move';
          } else {
            e.originalEvent.dataTransfer.dropEffect = 'none';
          }
        });
        rowEl.bind('dragleave', function () {
          this.classList.remove('drag-over');
        });
        rowEl.bind('dragover', function (e) {
          if (e.preventDefault) {
            e.preventDefault();
          }
          if (!scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.unstructure]) {
            e.originalEvent.dataTransfer.dropEffect = 'move';
          } else {
            e.originalEvent.dataTransfer.dropEffect = 'none';
          }
        });
        rowEl.bind('drop', function (e) {
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          this.classList.remove('drag-over');
          // Замена структуры узлов дерева
          if (scope.catalogTreeNodeCtrl.treeCtrl._draggedNode &&
            scope.catalogTreeNodeCtrl.treeCtrl._draggedNode != scope.catalogTreeNodeCtrl.node) { // Самого в себя нельзя добавлять
            scope.catalogTreeNodeCtrl.treeCtrl._addNodeToNode(
              scope.catalogTreeNodeCtrl.treeCtrl._draggedNode,
              scope.catalogTreeNodeCtrl.node);
          }
          return false;
        });
        rowEl.bind('dragend', function (e) {
          scope.catalogTreeNodeCtrl.treeCtrl._draggedNode = undefined;
          scope.catalogTreeNodeCtrl.treeCtrl._clearAllDragState(); // Очистка классов
        })
        if (scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.allowDrag]) { // Только узлам с установленным флагом dnd
          rowEl.attr("draggable", "true"); // установка флага разрешения претаскивания
          rowEl.bind('dragstart', function (e) {
            e.originalEvent.dataTransfer.effectAllowed = 'node';
            e.originalEvent.dataTransfer.setData('tree-node', scope.catalogTreeNodeCtrl.node.name);
            scope.catalogTreeNodeCtrl.treeCtrl._draggedNode = scope.catalogTreeNodeCtrl.node;
          });
        }

        // Флаг определяет отображается ли узел
        scope.catalogTreeNodeCtrl.showNodeInfo = !scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.rootFlag]
          || scope.catalogTreeNodeCtrl.treeCtrl.rootVisible;

        // Если корень не показыывается, его нужно принудительно раскрыть (или если установлен соответствующий флаг)
        if (scope.catalogTreeNodeCtrl.treeCtrl.rootVisible == false
          && scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.rootFlag] ||
          scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.rootFlag] &&
          scope.catalogTreeNodeCtrl.treeCtrl.rootAlwaysExpand
        ) {
          scope.catalogTreeNodeCtrl.node.expand = true;
        }

        // Блок определения актуальный контролов
        if (scope.catalogTreeNodeCtrl.treeCtrl.controlsProperty && scope.catalogTreeNodeCtrl.treeCtrl.controlsArray) {
          if (scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.controlsProperty]) {
            // Если совйство установленно, определеяем массив по значению этого свойства
            scope.catalogTreeNodeCtrl.nodeControls = scope.catalogTreeNodeCtrl.treeCtrl.controlsArray[scope.catalogTreeNodeCtrl.node[scope.catalogTreeNodeCtrl.treeCtrl.controlsProperty]];
          } else {
            // Для значения свойства == undefined, берется массив конторолов из 'default'
            scope.catalogTreeNodeCtrl.nodeControls = scope.catalogTreeNodeCtrl.treeCtrl.controlsArray['default'];
          }
        } else {
          // Если дифференцирующее свойство не установлено, контролы всех узлов одинаковые
          if (scope.catalogTreeNodeCtrl.treeCtrl.controlsArray != undefined) {
            // Либо сразу массив контролов, либо через default
            scope.catalogTreeNodeCtrl.nodeControls =
              angular.isArray(scope.catalogTreeNodeCtrl.treeCtrl.controlsArray)
                ? scope.catalogTreeNodeCtrl.treeCtrl.controlsArray
                : scope.catalogTreeNodeCtrl.treeCtrl.controlsArray['default'];
          }
        }
      }
    };
    return directive;

    function catalogTreeNodeCtrl($log, $q) {
      var catalogTreeNodeCtrl = this;

      /**
       * Экспортируемый метод, возвращает копию обекта родительского узла
       */
      catalogTreeNodeCtrl.node.getParent = function () {
        return catalogTreeNodeCtrl.node._parent ? {
          id: catalogTreeNodeCtrl.node._parent.id,
          name: catalogTreeNodeCtrl.node._parent.name,
          type: catalogTreeNodeCtrl.node._parent.type
        } : undefined;
      }

      /**
       * метод выделяет текущую ноду и пробрасывает событие в рутовый контроллер
       */
      catalogTreeNodeCtrl.setSelected = function ($event) {
        catalogTreeNodeCtrl.treeCtrl._selectNode(catalogTreeNodeCtrl.node);
        if ($event)
          $event.stopPropagation();
      };

      /**
       * Служебный функция, обновление параметров узла при изменений данных.
       *
       * @private
       */
      catalogTreeNodeCtrl._dataChangeProcess = function (issetNode) {
        if (issetNode) catalogTreeNodeCtrl.treeCtrl._setCheckedChildren(catalogTreeNodeCtrl.node);
        // пересчет позиций дочерних узлов
        catalogTreeNodeCtrl.treeCtrl._recalculatePosition(catalogTreeNodeCtrl.node, false);  // нет смысла идти в глубину
        catalogTreeNodeCtrl.treeCtrl._refreshPosition(catalogTreeNodeCtrl.node); // обновление вверх
      };

      /**
       * Служебный метод, выполняет раскрытие узла, если это необходимо.
       * Возвращает промис.
       *
       * @private
       */
      catalogTreeNodeCtrl._expandNodeWithLoading = function (node, force, $event) {
        if (node.expand && (!node.loaded || force)) {
          return catalogTreeNodeCtrl.treeCtrl._expandNode(node, $event);
        }
        return $q.when();
      };

      /**
       * Метод вызывается для подгрузки дополнительной страницы узла
       */
      catalogTreeNodeCtrl.onClickAddon = function ($event) {
        if (catalogTreeNodeCtrl.node.expand) {
          return catalogTreeNodeCtrl.treeCtrl._expandNode(catalogTreeNodeCtrl.node, $event, true).then(function () {
            catalogTreeNodeCtrl._dataChangeProcess();
          });
        }
        return $q.when();
      };

      /**
       * Раскрывает узел с возможностью принудительного обновления содержимого
       *
       * @param force признак принудительного обновления
       */
      catalogTreeNodeCtrl.onClick = function (force, $event) {
        if ($event && catalogTreeNodeCtrl.treeCtrl.blockExpand) // $event присутствует только у пользовательских событий, вызывающих метод
          return; // возврат из-за режима блокировки
        if ($event && catalogTreeNodeCtrl.treeCtrl.blockNodesExpand) {
          var needBlockEvent = false;
          angular.forEach(catalogTreeNodeCtrl.treeCtrl.blockNodesExpand, function (blockNode) {
            if ((typeof blockNode === 'object' ? blockNode.id : blockNode) == catalogTreeNodeCtrl.node.id) {
              needBlockEvent = true;
            }
          });
          if (needBlockEvent)
            return; // узел в списке заблокированных к изменению свертки
        }
        catalogTreeNodeCtrl.node.expand = force || !catalogTreeNodeCtrl.node.expand;
        catalogTreeNodeCtrl._expandNodeWithLoading(catalogTreeNodeCtrl.node, force, $event).then(function () {
          catalogTreeNodeCtrl._dataChangeProcess(catalogTreeNodeCtrl.node);
        });

        // Генерация событий скрытия/открытия узла
        catalogTreeNodeCtrl.treeCtrl._collapseChangeNodeEvent(
          catalogTreeNodeCtrl.node,
          catalogTreeNodeCtrl.node.expand,
          $event);

      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .directive('catalogTree', catalogTree);

  /** @ngInject */
  function catalogTree() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/catalog-tree/catalog-tree.html',
      controller: catalogTreeCtrl,
      bindToController: true,
      controllerAs: 'catalogTreeCtrl',
      scope: {
        minHeight: '<?', // Минимальная высота дерева
        rootFlag: '@?', // Свойство - признак рутового узла
        rootVisible: '<?', // Признак отображения рутового узла
        rootAlwaysExpand: '<?', // Признак того, что корень всегда раскрыт
        blockChoiceHoisting: '<?', // Флаг блокирует всплытие выбора элементов вверх (при выборе всех дочерних, родительская категория не выбирается)
        showArrow: '<?', // Флаг отображения раскрытых узлов
        blockExpand: '<?', // Флаг блокировки пользовательских событий управления раскрытием дерева
        blockNodesExpand: '<?', // Узлы, для которых блоируются пользовательские события свертывания/развертывания (примерняется бля блокировки скрытия пути с новой категорией, например)
        hasChildren: '@?', // Свойство, по которому можно проверить наличие потомков (TODO: возможно, флаг инверсии нужно добавить, если в АПИ будет leaf)
        itemCount: '@?', // Свойство по которому определяется количество дочерних узлов
        totalProperty: '@?', // Свойство по которому определяется общее количество элементов
        unstructure: '@?', // Свойство по которому определяется является ли узел структурным (рисуется иконка каталога или нет)
        expandNode: '=',  // Метод раскрытия узла
        checkedCallback: '=?', // callback для вызова внешней функции при изменении значение чекбокса у элемента
        selectedCallback: '=?', // callback для вызова внешней функции при изменении выбора элемента
        dragChangeCallback: '=?', // callback для вызова внешней функции при изменении выбора элемента
        controlsArray: '=?', // контролы дерева с иконками и callback-ом
        controlsProperty: '@?', // имя свойства по которому различаются свойства
        showCheckbox: '<?', // Признак, включающий механизм выбора элементов
        loadCallback: '=?', // Вызывается после инициализации дерева
        allowDrag: '@?', // Свойство по которому показывается контрол перетаскивания
        onExpandNode: '=?', // Callback на раскрытие узла
        onCollapseNode: '=?', // Callback на раскрытие узла
        root: '=', // Корень дерева
        hierarchicalFlex: '<?', // Флекс-ширина для иерархической колонки
        hierarchicalTemplateUrl: '<?', // шаблон ячейки для иерархической колонки
        columns: '<?', // Настройки колонок,
        columnsPage: '=?', // Настройка отображения списка колонок (limit и offset),
        allowCheckbox: '<?', // Внешняя функция, используется для проверки необходимости блокировки возможности выбора категории
        cellUpdateCallback: '=?', // коллбек для уведомлений об изменении ячейки (TODO: достаточно узкоспециализорованная вещь, нужно подумать как лучше)
        hierarchicalCallback: '=?', // также как и выше, не универсальный колбек, TODO: возможно стоит задействовать механизм эвентов, подумаю
        checkboxOnlyForLeaf: '<?' // показывать чекбоксы только для элементов у которых нет дочерних
      },
      link: function (scope, element, attrs) {
        /**
         * Метод очищает класс разрешений на перетаскивание у всех строк
         *
         * @private
         */
        scope.catalogTreeCtrl._clearAllDragState = function () {
          angular.forEach(angular.element(element[0].querySelectorAll('.catalog-tree-text')), function (value, key) {
            value.classList.remove('drag-over');
          });
        }

        if (scope.catalogTreeCtrl.loadCallback) { // Вызов колбека по завершению инициализации
          scope.catalogTreeCtrl.loadCallback();
        }
      }
    };
    return directive;

    function catalogTreeCtrl($scope, $q, $log, $timeout) {
      var catalogTreeCtrl = this;

      // Значение по-умолчанию для свойства наличия потомков
      if (angular.isUndefined(catalogTreeCtrl.hasChildren))
        catalogTreeCtrl.hasChildren = 'has_children';
      // Значение по-умолчанию для свойства наличия потомков
      if (angular.isUndefined(catalogTreeCtrl.itemCount))
        catalogTreeCtrl.itemCount = 'item_count';
      // Значение по-умолчанию для свойства total
      if (angular.isUndefined(catalogTreeCtrl.totalProperty))
        catalogTreeCtrl.totalProperty = 'total';
      // Значение по-умолчанию для свойства не структурированного элемента
      if (angular.isUndefined(catalogTreeCtrl.unstructure))
        catalogTreeCtrl.unstructure = 'unstructure';
      // Значение по-умолчанию для свойства отображения корневого элемента
      if (angular.isUndefined(catalogTreeCtrl.rootVisible))
        catalogTreeCtrl.rootVisible = true;
      // Значение по-умолчанию для свойства корневого узла
      if (angular.isUndefined(catalogTreeCtrl.rootFlag))
        catalogTreeCtrl.rootFlag = 'root';
      // Значение по-умолчанию для свойства перетаскивания (drag-and-drop)
      if (angular.isUndefined(catalogTreeCtrl.allowDrag))
        catalogTreeCtrl.allowDrag = 'allowDrag';
      // Значение по-умолчанию для флага отображения дочерних узлов
      if (angular.isUndefined(catalogTreeCtrl.showArrow))
        catalogTreeCtrl.showArrow = true;
      // Значение по-умолчанию для флага блокировки пользовательских событий раскрытия узлов
      if (angular.isUndefined(catalogTreeCtrl.blockExpand))
        catalogTreeCtrl.blockExpand = false; // по-умолчанию не блокируется
      // Значение по-умолчанию для флага всплытия распространения выбора (на снятие не влияет, оно распространяется)
      if (angular.isUndefined(catalogTreeCtrl.blockChoiceHoisting))
        catalogTreeCtrl.blockChoiceHoisting = false; // по-умолчанию всплытие не блокируется
      if (angular.isUndefined(catalogTreeCtrl.hierarchicalFlex))
        catalogTreeCtrl.hierarchicalFlex = 4; // ширина иерархической колонки по-умолчанию
      if (angular.isUndefined(catalogTreeCtrl.hierarchicalTemplateUrl))
        catalogTreeCtrl.hierarchicalTemplateUrl = 'defaultHierarchicalTemplate.html'; // шаблон по-умолчанию
      if (angular.isUndefined(catalogTreeCtrl.columnsPage))
        catalogTreeCtrl.columnsPage = {offset: 0, limit: undefined}; // шаблон по-умолчанию

      catalogTreeCtrl._expandModel = {}; // модель раскрытия

      // инициализация path корневого узла
      catalogTreeCtrl.root._path = [];


      /**
       * Построение модели выбора дерева
       */
      catalogTreeCtrl._getSelectionModel = function (res, node) {
        var currentNode = node || catalogTreeCtrl.root;
        if (currentNode.checked) {
          // раньше возвращались только идентификаторы, но из-за различий в АПИ
          // в общем случае приходится возвращать все узлы (это нарушает инкапсюляцию, ка минимум)
          res.push(currentNode);
        } else {
          angular.forEach(currentNode.children, function (childNode) {
            catalogTreeCtrl._getSelectionModel(res, childNode);
          });
        }
      }

      /**
       * Экспортируемый метод, возвращает текущую модель выбранных узлов дерева
       */
      catalogTreeCtrl.root.getSelectionModel = function () {
        var res = [];
        catalogTreeCtrl._getSelectionModel(res);
        return res;
      };

      /**
       * Экспортируемый метод, очищает информацию для перезагрузки дерева
       */
      catalogTreeCtrl.root.resetRoot = function () {
        catalogTreeCtrl.root.children = [];
        catalogTreeCtrl.root.loaded = false;
        catalogTreeCtrl.hasSelectedFlag = undefined;
      }

      /**
       * Экспортируемый метод, очищает выбранные элементы
       */
      catalogTreeCtrl.root.resetSelect = function () {
        catalogTreeCtrl.selectedNode.selected = false;
        catalogTreeCtrl.selectedNode = undefined;
        if (catalogTreeCtrl.selectedCallback) {
          catalogTreeCtrl.selectedCallback(undefined); // отправка пустого селекта при очищении выделения
        }
      }

      /**
       * Экспортируемый метод, возвращает true, если выбран хотя бы один узел
       */
      catalogTreeCtrl.root.hasSelected = function () {
        if (catalogTreeCtrl.hasSelectedFlag == undefined ||
          catalogTreeCtrl.invalidateCheckedState) {
          catalogTreeCtrl.hasSelectedFlag = catalogTreeCtrl._refreshHasSelectedFlag();
        }
        return catalogTreeCtrl.hasSelectedFlag;
      };

      /**
       * Метод обновляет флаг (пеерсчитыаением) наличия хотя бы одного выбранного узла
       *
       * @private
       */
      catalogTreeCtrl._refreshHasSelectedFlag = function (node) {
        var currentNode = node || catalogTreeCtrl.root;
        if (currentNode.checked) {
          return true;
        } else {
          if (currentNode.children &&
            currentNode.expand && // выделение скрытых узлов не учитывается
            currentNode.children.length) {
            // внешние бибилотеки (undercore) в директивах не используются
            for (var i = 0; i < currentNode.children.length; i++) {
              if (catalogTreeCtrl._refreshHasSelectedFlag(currentNode.children[i])) {
                catalogTreeCtrl.invalidateCheckedState = false;
                return true;
              }
            }
          }
          catalogTreeCtrl.invalidateCheckedState = false;
          return false; // если среди дочерних не найден
        }
      };

      /**
       * Метод призван оптимизировать полный обход при формировании модели раскрытых узлов
       *
       * @private
       */
      catalogTreeCtrl._addNodeToExpandModel = function (node) {
        var path = catalogTreeCtrl._getPathForNode(node); // восстанавливаем путь
        // временная пременная, отвечающая за текущий уровень в структуре модели раскрытия дерева
        var tempLevelObject = catalogTreeCtrl._expandModel;
        angular.forEach(path, function (pathItem) {
          if (!tempLevelObject[pathItem]) {
            tempLevelObject[pathItem] = {}; // Создаем новый пустой объект в структуру
          }
          tempLevelObject = tempLevelObject[pathItem];
        })
      }

      /**
       * Метод призван оптимизировать полный обход при формировании модели раскрытых узлов
       *
       * @private
       */
      catalogTreeCtrl._removeNodeFromExpandModel = function (node) {
        var path = catalogTreeCtrl._getPathForNode(node); // восстанавливаем путь
        var lastItem = path.pop();
        // временная пременная, отвечающая за текущий уровень в структуре модели раскрытия дерева
        var tempLevelObject = catalogTreeCtrl._expandModel;
        angular.forEach(path, function (pathItem) {
          tempLevelObject = tempLevelObject[pathItem];
        })
        delete tempLevelObject[lastItem]; // убираем из модели свернутый узел
      }

      /**
       * метод добавляет узел в новый родительский узел
       *
       * @param node узел для добавления
       * @param newParentNode новый родительский узел
       */
      catalogTreeCtrl._addNodeToNode = function (node, newParentNode) {
        if (node == newParentNode) {
          return; // проверка от добавления саого в себя
        }
        var loadingPromisse = newParentNode.loaded ? $q.when() : catalogTreeCtrl._expandNode(newParentNode);
        // Добавляем чайлд, только после дозагрузки узла
        loadingPromisse.then(function () {
          $timeout(function () { // необходим для безопасного запуска digest
            if (node._parent) { // Убираем информацию из старого узла
              var delIndex = node._parent.children.indexOf(node);
              if (delIndex != -1) {
                node._parent.children.splice(delIndex, 1);
              }
              if (node._parent.children.length == 0) {
                node._parent[catalogTreeCtrl.hasChildren] = false;
              }
            }
            // Обновление сновой структуры
            node._parent = newParentNode;
            newParentNode.children = newParentNode.children || [];
            newParentNode.children.push(node);
            node._parent[catalogTreeCtrl.hasChildren] = true;
            node._parent.expand = true;

            if (catalogTreeCtrl.dragChangeCallback) {
              catalogTreeCtrl.dragChangeCallback(node, newParentNode); // вызов callback
            }
          })
        });
      }

      /**
       * Метод вызывается, когда у узла меняется количество дочерних
       *
       * @param node узел, у которого изменилось количество дочерних
       * @private
       */
      catalogTreeCtrl._refreshPosition = function (node) {
        if (node[catalogTreeCtrl.rootFlag] || !node._parent) {
          // На корневом узле алгоритм останавливает распространение вверх
          return;
        }
        // обновление позиций текущих узлов (в глубину проход будет ниже, только в тех слуаях, когда необходимо)
        catalogTreeCtrl._recalculatePosition(node._parent, false);

        if (node._parent.children && node._parent.children.length > 0) { // всегда true
          var needUpdate = false;
          angular.forEach(node._parent.children, function (child) {
            if (needUpdate) { // Обновлять есть смысл только sibling узлы ниже
              catalogTreeCtrl._recalculatePosition(child, true);
            } else {
              if (child == node) {
                needUpdate = true; // после установки флага следующие узлы будут пересчитывать позиции дочерних
              }
            }
          });
          catalogTreeCtrl._refreshPosition(node._parent); // Проброс выше
        }
      }

      /**
       * Метод пересчитывает позицию дочерних узлов
       *
       * @param node узел, чья позиция была обновлена и тербуется обновить дочерние узлы
       * @param depth признак обновления по глубине
       * @private
       */
      catalogTreeCtrl._recalculatePosition = function (node, depth) {
        if (node[catalogTreeCtrl.rootFlag] || !node._parent) { // TODO: возможно, не лучшее место
          node._rowsPosition = 0;
        }
        node._rowsVolume = 1; // инициализация количества строк (как минимум сам узел - 1 строка)
        if (node.expand && node.children && node.children.length) {
          angular.forEach(node.children, function (child) {
            child._rowsPosition = node._rowsPosition + node._rowsVolume; // инициализация позиции дочернего узла
            if (depth) { // если требуется обновление по глубине
              catalogTreeCtrl._recalculatePosition(child, depth);
            }
            if (child._rowsVolume == undefined) {
              // инициализация начального объема не раскрытых узлов здесь (не хочется тянуть эту логику в инициализацию узла)
              child._rowsVolume = 1;
            }
            node._rowsVolume += child._rowsVolume;
          })
        }
        return node._rowsVolume; // для удобства возвращаем размер строк переданного узла
      }

      /**
       * метод вызывается при изменении состояния выбора узла (чекбокса)
       */
      catalogTreeCtrl._checkChanged = function (node) {
        catalogTreeCtrl._setCheckedChildren(node); // Устанавливает состояние в дочерние элементы (без раскрытия)
        node.checkedBrunchCount = node.checked ? 1 : 0; // Количество веток с выбранными элементами (если узе выбран, значит все его дочерние также выбраны)
        if (node._parent
          && (!catalogTreeCtrl.blockChoiceHoisting // Если 'всплытие' не заблокировано
            || !node.checked // снятие всплывает вне зависимости от блокировки (blockChoiceHoisting блокирует распространение выбора)
          )
        ) {
          // Распространяем изменение выше
          catalogTreeCtrl._refreshParentChecked(node._parent);
        }
        // обновление флага наличия выбранных узлов
        catalogTreeCtrl.hasSelectedFlag = catalogTreeCtrl._refreshHasSelectedFlag();
        // callback, если присутствует
        if (catalogTreeCtrl.checkedCallback) {
          catalogTreeCtrl.checkedCallback({
            id: node.id,
            name: node.name,
            checked: node.checked
          });
        }
      };

      /**
       * Метод устанавливает состояние checked у всех дочерних элементов
       *
       * @return true, если были изменения состояния
       */
      catalogTreeCtrl._setCheckedChildren = function (node) {
        var wasChange = false;
        angular.forEach(node.children, function (child) {
          if (child.checked != node.checked) {
            catalogTreeCtrl.invalidateCheckedState = true;
            wasChange = true;
          }
          child.checked = node.checked;
          child.checkedBrunchCount = node.checked ? 1 : 0;
          catalogTreeCtrl._setCheckedChildren(child);
        });
        return wasChange;
      };

      /**
       * Экспортируемый метод очистки высех выбранных строк
       */
      catalogTreeCtrl.root.clearChecked = function () {
        catalogTreeCtrl.root.checked = false;
        catalogTreeCtrl._setCheckedChildren(catalogTreeCtrl.root);
      }

      /**
       * Экспортируемый метод очистки высех выбранных строк
       */
      catalogTreeCtrl.root.checkAll = function () {
        catalogTreeCtrl.root.checked = true;
        catalogTreeCtrl._setCheckedChildren(catalogTreeCtrl.root);
      }

      /**
       * Метод обновляет состояние узла, при необходимости, по сигналу с дочерних
       */
      catalogTreeCtrl._refreshParentChecked = function (node) {
        if (node.children && node.children.length > 0) {
          var oldState = node.checked;
          var sum = 0;
          var sumCheckedBrunch = 0;
          // Подсчет количества выбранных узлов дочерних
          angular.forEach(node.children, function (item) {
            sum += item.checked ? 1 : 0;
            sumCheckedBrunch += item.checkedBrunchCount ? item.checkedBrunchCount : 0;
          });
          if (sum == node.children.length) {
            node.checked = true;
            node.checkedBrunchCount = 1; // у выбранного узла выбраны все дочерние
          } else {
            node.checked = false;
            node.checkedBrunchCount = sumCheckedBrunch; // все выбранные ветки дочерних узлов
          }
          if (node._parent && node.checked != oldState) {
            catalogTreeCtrl._refreshParentChecked(node._parent); // При изменении рукурсивно распространяем событие
          }
        }
      }

      /**
       * Внутренний метод выбора узла
       *
       * @param auto означает вызов из автоматический цикла, не вызывается коллбек на выделение
       */
      catalogTreeCtrl._selectNode = function (node, lockCallback) {
        if (catalogTreeCtrl.selectedNode === node) {
          // выделение снимается при повторном клике
          catalogTreeCtrl.selectedNode.selected = false;
          catalogTreeCtrl.selectedNode = undefined;
          if (catalogTreeCtrl.selectedCallback) {
            catalogTreeCtrl.selectedCallback(undefined, node); // отправка пустого селекта при отмене выделения
          }
          return;
        }
        if (catalogTreeCtrl.selectedNode) {
          catalogTreeCtrl.selectedNode.selected = false;
        }
        catalogTreeCtrl.selectedNode = node;
        node.selected = true;
        // callback, если присутствует
        if (catalogTreeCtrl.selectedCallback && !lockCallback) {
          catalogTreeCtrl.selectedCallback({
            id: catalogTreeCtrl.selectedNode.id,
            name: catalogTreeCtrl.selectedNode.name,
            _path: catalogTreeCtrl.selectedNode._path,
            type: catalogTreeCtrl.selectedNode.type // TODO: вынести исходные данные узла в отдельный объект
          }, node);
        }
      };

      /**
       * Внутренний метод, вызываемый при свертывании узла
       *
       * @param node сворачиваемый узел
       * @param $event событие, приведшее к сворачиванию узла
       * @private
       */
      catalogTreeCtrl._collapseChangeNodeEvent = function (node, expand, $event) {
        if (expand) {
          // Добавление в модель открытых узлов
          catalogTreeCtrl._addNodeToExpandModel(node);
          if (catalogTreeCtrl.onExpandNode) { // Вызов колбека
            catalogTreeCtrl.onExpandNode(node);
          }
        } else {
          // Удаление из модели открытых узлов
          catalogTreeCtrl._removeNodeFromExpandModel(node);
          if (catalogTreeCtrl.onCollapseNode) { // Вызов колбека
            catalogTreeCtrl.onCollapseNode(node);
          }
        }
      }

      /**
       * Метод раскрытия узла (внутренний)
       */
      catalogTreeCtrl._expandNode = function (node, $event, nextPage) {
        if ($event)
          $event.stopPropagation();
        // Добавление узла в модель раскрытия (возможно дублирование обновления модели,
        // в зависимости от инициатора раскрытия,
        // но наложение не критично даже с точки зрения производительноси)
        catalogTreeCtrl._addNodeToExpandModel(node);
        if (!node.activeLoading && catalogTreeCtrl.expandNode) { // защита от многократного открытия
          node.activeLoading = catalogTreeCtrl.expandNode(node, nextPage)
            .then(function (data) { // success
              if (data && data.length) {
                if (nextPage && Array.isArray(node.children)) {
                  // случай запроса новой страницы
                  Array.prototype.push.apply(node.children, data);
                } else {
                  // случай обычного раскрытия или форсированного обновления
                  node.children = data;
                }
              }
              // Проставляем родителя, для возможности подниматься вверх по дереву
              angular.forEach(node.children, function (child) {
                child._parent = node;
                // поддержка формирования пути для каждого узла
                if (node._path) {
                  child._path = node._path.slice();
                  child._path.push(child.id);
                }
              });
              node.loaded = true;
              if (!node.children || node.children.length == 0) {
                node[catalogTreeCtrl.hasChildren] = false;
              }
              node.activeLoading = undefined;

              return node;
            }, function () { // reject
              node.activeLoading = undefined;
              $log.error('Категории группы не были загружены')
            });
        }
        return node.activeLoading || $q.when(node); // Возвращает промис загрузки
      }

      /**
       * Вспомогательный метод, всегда возвращает промис.
       * Промис раскрывает узел, если это необходимо.
       *
       * @param node
       * @private
       */
      catalogTreeCtrl._expandNodeIfNeed = function (node) {
        if (node.loaded) {
          return $q.when(node);
        } else {
          return catalogTreeCtrl._expandNode(node);
        }
      }

      /**
       *  Вспомогательная функция поиска дочернего узла по идентификатору.
       *  С раскрытием пути.
       *
       *  @param currentNode: текущий узел
       *  @param pathItem: идентификатор искомого узла
       *
       *  @return promise расрешенный искомым узлом, или отказанный, если узел не найден
       */
      catalogTreeCtrl._findChildNode = function (currentNode, pathItem) {
        var deferred = $q.defer();
        var wasResolved = false;
        angular.forEach(currentNode.children, function (child) {
          if (child.id == pathItem
            || (child.catalog_item && child.catalog_item.id == pathItem)) { // страшный костыль в директиве, особенность наличия линеек в прайс-листе
            child.expand = true; // Флаг раскрытия узла

            wasResolved = true; // deferred angular нажежно не проверить на isResolved
            deferred.resolve(child);
          }
        });
        if (!wasResolved) {
          deferred.reject(pathItem + ' was not found');
        }
        return deferred.promise; // Возвращаем промис
      };

      /**
       * Метод устанавливает выбор на последний узел пути
       *
       * @param paths массив массивов путей
       */
      catalogTreeCtrl.root.selectByPaths = function (path, lockCallback) {
        return catalogTreeCtrl.root.expandFunc(path)
          .then(function (lastNode) { // Ожидается последний узел пути
            // вызов служебного обработчика
            catalogTreeCtrl._selectNode(lastNode, lockCallback);
            return lastNode;
          });
      };

      /**
       * Метод устанавливает выбор (галочку) на все узлы в массиве преданных path
       *
       * @param paths массив массивов путей
       */
      catalogTreeCtrl.root.checkByPaths = function (paths) {
        angular.forEach(paths, function (path) {
          catalogTreeCtrl.root.expandFunc(path)
            .then(function (lastNode) { // Ожидается последний узел пути
              lastNode.checked = true;
              catalogTreeCtrl._checkChanged(lastNode);
            });
        });
      };

      /**
       * Экспортируемый метод позволяет принудительно обновлять узел извне
       *
       * @param node узел для обновления
       */
      catalogTreeCtrl.root.reloadNode = function (node) {
        catalogTreeCtrl._expandNode(node);
      };

      /**
       * Экспортируемый метод, возвращает текущую модель выбранных элементов
       */
      catalogTreeCtrl.root.getExpandModel = function () {
        return catalogTreeCtrl._expandModel;
      };

      /**
       * Экспортируемый метод скрытия/открытия всех узлов
       *
       * @param node узел дерева
       * @param collapse признак скрытия
       */
      catalogTreeCtrl.root.collapseAll = function (node, collapse) {
        var workNode = node || catalogTreeCtrl.root;
        angular.forEach(workNode.children, function (child) {
          child.expand = collapse;
          catalogTreeCtrl.root.collapseAll(child, collapse);
        })
      };

      /**
       * Экспортируемая функция, возвращает выбранный узел (копию, с идентификатором и именем)
       *
       * @return выбранный в дереве узел
       */
      catalogTreeCtrl.root.getSelectedNode = function () {
        if (catalogTreeCtrl.selectedNode) {
          return {
            id: catalogTreeCtrl.selectedNode.id,
            name: catalogTreeCtrl.selectedNode.name,
            type: catalogTreeCtrl.selectedNode.type,
            $$parents: catalogTreeCtrl.selectedNode.parents
          };
        }
      };

      /**
       * Метод возвращает путь до корня
       *
       * @param node узел, для которго требуется восстановить путь до корня (path)
       * @private
       */
      catalogTreeCtrl._getPathForNode = function (node) {
        var tempNode = node;
        var path = [];
        // Поднимаемся до корня
        while (tempNode._parent) {
          path.unshift(tempNode.id);
          tempNode = tempNode._parent;
        }
        return path;
      };

      /**
       * Экспортируемая функция, возвращает путь до текущего выбранного узла
       *
       * @return путь до узла (массив идентификаторов)
       */
      catalogTreeCtrl.root.getSelectedNodePath = function () {
        if (catalogTreeCtrl.selectedNode) {
          return catalogTreeCtrl._getPathForNode(catalogTreeCtrl.selectedNode);
        }
      };

      /**
       *  Экспортируемая через корень дерева функция раскрытия узла по пути.
       *
       *  @param path: массив идентификаторов узлов
       *
       *  @return промис, разрешенный последним элементом в path или отказанный,
       *  если не удалось раскрыть весь путь
       */
      catalogTreeCtrl.root.expandFunc = function (path) {
        var promise = $q.when(catalogTreeCtrl.root); // Начало обхода с корневого узла
        angular.forEach(path, function (pathItem, idx, array) {
          promise = promise.then(function (currentNode) {
            // Требуется дозагрузка узла, прежде чем можно будет искать среди его потомков
            return catalogTreeCtrl._expandNodeIfNeed(currentNode).then(function (currentNode) {
              return catalogTreeCtrl._findChildNode(currentNode, pathItem);
            })
          });
        });
        return promise.then(function (lastNode) {
          return catalogTreeCtrl._expandNode(lastNode);
        });
      };

      /**
       * Метод раскрывает все узлы по переданной модели рскрытия
       *
       * @param expandModel модель раскрытия (дерево идентификаторов раскрытых узлов)
       * @param node текущий узел, от которого считается модель (используется в рекурсии)
       * @return промис рузультата
       */
      catalogTreeCtrl.root.expandFuncByModel = function (expandModel, node) {
        var currentNode = node || catalogTreeCtrl.root; // либо переданный, либо root

        // Требуется дозагрузка узла, прежде чем можно будет искать среди его потомков
        return catalogTreeCtrl._expandNodeIfNeed(currentNode).then(function (currentNode) {
          // при раскрытии модели актуально (со стороны пользователя проставляется при первичной обработке события)
          currentNode.expand = true;

          // пересчет позиций дочерних узлов
          catalogTreeCtrl._recalculatePosition(currentNode, false);  // нет смысла идти в глубину
          catalogTreeCtrl._refreshPosition(currentNode); // обновление вверх

          var promisses = [];
          angular.forEach(expandModel, function (subExpandModel, key) {
            var promise = catalogTreeCtrl._findChildNode(currentNode, key).then(function (subNode) {
              return catalogTreeCtrl.root.expandFuncByModel(subExpandModel, subNode);
            });
            promisses.push(promise);
          });
          return $q.all(promisses); // возвращает композицию промисов
        })
      };

      /**
       * Экспортируемая через корень дерева функция добавления нового элемента по пути.
       * Указание типа и атрибутов остаётся за вызывающим кодом.
       *
       * @param item: узел для вставки в дерево по пути
       * @param path: путь (массив идентификаторов) до родительского структурного элемента
       * @param selectParent: флаг показывает на каком узде останавливать выбор - true, на родительском
       */
      catalogTreeCtrl.root.addItem = function (item, path, selectParent) {
        // Раскрытие пути
        return catalogTreeCtrl.root.expandFunc(path)
          .then(function (lastNode) { // Ожидается последний узел пути
            lastNode.children = lastNode.children || [];
            lastNode.children.push(item);
            item._parent = lastNode; // связываем родителя
            lastNode[catalogTreeCtrl.hasChildren] = true; // Обновления свойства наличия дочерних узлов
            if (!selectParent) {
              catalogTreeCtrl._selectNode(item); // Выделение добавленного узла
            }
            return item;
          })
      }

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('bindHtmlCompile', ['$compile', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.bindHtmlCompile);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    }]);
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('barcode', barcode);

  function barcode() {
    return {
      restrict: 'E',
      template: '<div ng-copy="onCopy($event)"><svg class="barcode"></svg><svg ng-show="format === \'ean13_5\' || format === \'ean13_2\'" class="barcode-addon"></svg></div>',
      scope: {
        value: '<',
        backgroundColor: '@?'
      },
      link: function($scope, element, attr, ctrl) {
        $scope.format = '';

        function setformat(data) {
          switch(data.length) {
            case 8:
              $scope.format = 'ean8';
              break;
            case 12:
              $scope.format = 'upc';
              break;
            case 13:
              $scope.format = 'ean13';
              break;
            case 14:
              $scope.format = 'itf14';
              break;
            case 18:
              $scope.format = 'ean13_5';
              break;
            case 15:
              $scope.format = 'ean13_2';
              break;
            default:
              $scope.format = 'code128';
              break;
          }
        }

        function changeFormatitf14() {
          var text =  element.find('text');
          if (text) {
            text[0].innerHTML = text[0].innerHTML.slice(0,1) + '&nbsp' +
            text[0].innerHTML.slice(1,3) + '&nbsp' +
            text[0].innerHTML.slice(3,8) + '&nbsp' +
            text[0].innerHTML.slice(8,13) + '&nbsp' +
            text[0].innerHTML.slice(text[0].innerHTML.length-1,text[0].innerHTML.length)
          }
        }

        function changeBackground() {
          var background = element.find('rect[style]');
          background.each(function(elementFinder) {
            background[elementFinder].style.fill = $scope.backgroundColor
          });
        }

        $scope.$watch('value',function (val) {
          if (val) {
            setformat(val);
            try {
              var addonFormat = {
                textPosition: 'top',
                marginBottom: 20
              };
              if ($scope.format === 'ean13_5') {
                addonFormat.format = 'ean5';
                JsBarcode(element.find('.barcode')[0], val.substr(0, 13), {format: 'ean13'});
                JsBarcode(element.find('.barcode-addon')[0], val.substr(13, 18), addonFormat);
              } else if ($scope.format === 'ean13_2') {
                addonFormat.format = 'ean2';
                JsBarcode(element.find('.barcode')[0], val.substr(0, 13), {format: 'ean13'});
                JsBarcode(element.find('.barcode-addon')[0], val.substr(13, 15), addonFormat);
              } else {
                JsBarcode(element.find('.barcode')[0], val, {format: $scope.format});
                if ($scope.format === 'itf14') {
                  changeFormatitf14()
                }
              }
            } catch (e) {
              JsBarcode(element.find('.barcode')[0], val, {format: 'code39'});
            }
            changeBackground();
          }
        });

        $scope.onCopy = function (e) {
          e.originalEvent.clipboardData.setData('text/plain', $scope.value.toString());
          e.preventDefault();
        }

      }
    } // return end
  } // function end
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .component('invitation', {
      replace: true,
      templateUrl: 'app/components/Invitation/invitation-modal.html',
      controllerAs: 'invitationCtrl',
      bindings: {
        modalInstance: '<'
      },
      controller: function (uiSelectStructure, companyService, modalMessageSrv) {
        var invitationCtrl = this;
        invitationCtrl.invitation = {};
        invitationCtrl.errors = [];
        companyService.getLegalRequisitesFieldMap().then(function (res) {
          invitationCtrl.errorsMap = res.data
        });

        invitationCtrl.companies = uiSelectStructure.getStructure(companyService.companiesSearch, invitationCtrl.invitation.company);

        invitationCtrl.bankAccounts = {
          items: [],
          refresh: function (search, companyID) {
            if (!invitationCtrl.invitation.company) return;
            return companyService.getAccounts(companyID || invitationCtrl.invitation.company.id)
              .then(function (res) {
                invitationCtrl.bankAccounts.items = res.data.map(function (val) {
                  return {
                    id: val.id,
                    name: val.name
                  }
                });
                if(invitationCtrl.bankAccounts.items.length === 1 && search === '' && !invitationCtrl.invitation.bank_account){
                  invitationCtrl.invitation.bank_account = invitationCtrl.bankAccounts.items[0];
                }
              })
          }
        };

        invitationCtrl.onCompanySelect = function (company) {
          invitationCtrl.invitation.bank_account = null;
          invitationCtrl.invitationForm.bank_account.$setPristine();
          invitationCtrl.invitationForm.bank_account.$setUntouched();
          invitationCtrl.bankAccounts.refresh(null, company && company.id)
        };

        invitationCtrl.sendInvitation = function () {
          companyService.sendInvitation(invitationCtrl.invitation).then(function (res) {
            invitationCtrl.success = true;
          }).catch(function (err) {
            if (err.status === 400 && err.data.code === 'bad_arguments') {
                if (err.data.fields.length) {
                  invitationCtrl.errors = [];
                  angular.forEach(err.data.fields, function (item) {
                    invitationCtrl.errors.push(invitationCtrl.errorsMap[item.field])
                  })
                }
            } else {
              modalMessageSrv.showModal({message: 'При сохранении произошла ошибка', submessage: err});
            }
          })
        }

      }
    });
})();

/**
 * Created by aivanov on 08.01.2018.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название по статусу объекта каталога участника.
   */
  angular.module('frontend').filter('currencySpaces', function () {
    return currencySpacesFilter;
  });

  var currencySpacesFilter = function (currency) {
    if (currency)
      return currency.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
    return currency;
  }

})();

/**
 * Created by aivanov on 08.01.2018.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название по статусу объекта каталога участника.
   */
  angular.module('frontend').filter('currencySpacesShift', function () {
    return currencySpacesShiftFilter;
  });

  var currencySpacesShiftFilter = function (currency) {
    if (currency != undefined) {
      var coinStr = (currency % 100).toString();
      if (coinStr.length < 2) {
        // простое решение для обеспечения 2-х нулей в конце
        coinStr += '0';
      }
      return Math.floor(currency / 100).toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ') + ',' + coinStr;
    }
    return currency;
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service('requestStatus', requestStatus);

  /** @ngInject */
  function requestStatus(toastr, toastrConfig) {

    toastrConfig.maxOpened = 3;
    toastrConfig.newestOnTop = true;
    toastrConfig.positionClass = 'toast-top-full-width';
    toastrConfig.preventDuplicates = false;
    toastrConfig.preventOpenDuplicates = false;
    toastrConfig.allowHtml = true;
    toastrConfig.closeButton = false;
    toastrConfig.closeHtml = '<button></button>';
    toastrConfig.extendedTimeOut = 0;
    toastrConfig.messageClass = 'toast-message';
    toastrConfig.progressBar = false;
    toastrConfig.tapToDismiss = true;
    toastrConfig.timeOut = 0;
    toastrConfig.titleClass = 'toast-title';

    this.success = function(message, iconClass, buttonText, href){
      toastrConfig.iconClasses.success = (iconClass)? iconClass + '-success toast-success' : 'toast-success';
      toastrConfig.positionClass = 'toast-top-full-width';
      toastrConfig.closeButton = false;
      toastrConfig.timeOut = 5000;
      toastrConfig.messageClass = "";
      toastrConfig.templates.toast = "directives/toast/toast.html";
      toastrConfig.tapToDismiss = true;
      toastrConfig.preventDuplicates = false;
      toastrConfig.extendedTimeOut = 1500;
      if(!buttonText || !href){
        toastr.success('', message);
      }else{
        toastr.success('<a href="' + href + '" class="toast-success-button">' + buttonText + '</a>', message);
      }
    };

    this.dismissAll = function() {
      toastr.clear();
      toastr.previousToastMessage = '';
      toastr.openToasts = {};
    };

    this.error = function(message, iconClass){
      toastrConfig.iconClasses.error = (iconClass)? iconClass + '-error toast-error' : 'toast-error';
      toastrConfig.positionClass = 'toast-top-full-width';
      toastrConfig.closeButton = true;
      toastrConfig.timeOut = 0;
      toastrConfig.messageClass = "";
      toastrConfig.templates.toast = "directives/toast/toast.html";
      toastrConfig.tapToDismiss = false;
      toastrConfig.preventDuplicates = true;
      toastrConfig.extendedTimeOut = 0;
      toastrConfig.preventDuplicates = false;
      toastrConfig.preventOpenDuplicates = false;
      toastr.error(' ', message);
    };

    this.info = function(message, iconClass, buttonText, href){
      toastrConfig.positionClass = 'toast-bottom-right';
      toastrConfig.iconClasses.success = 'toast-info';
      toastrConfig.closeButton = true;
      toastrConfig.timeOut = 0;
      toastrConfig.tapToDismiss = false;
      toastrConfig.messageClass = "";
      toastrConfig.templates.toast = "directives/toast/toast.html";
      toastrConfig.extendedTimeOut = 0;
      toastrConfig.preventDuplicates = true;
      toastrConfig.preventOpenDuplicates = true;
      if(!buttonText || !href){
        toastr.info('', message);
      }else{
        toastr.info('<a href="' + href + '" class="toast-success-button">' + buttonText + '</a>', message);
      }
    };

    this.message = function(message, callback){
      toastrConfig.positionClass = 'toast-bottom-right';
      toastrConfig.iconClasses.success = 'toast-info';
      toastrConfig.closeButton = true;
      toastrConfig.timeOut = 0;
      toastrConfig.tapToDismiss = false;
      toastrConfig.extendedTimeOut = 0;
      toastrConfig.preventOpenDuplicates = true;
      toastrConfig.messageClass = message;
      toastrConfig.extraData = {callback: callback};
      toastrConfig.templates.toast = 'app/common/request-status/toastr-message.html';
      toastr.info('', message, message);
    };

  }
})();

/* eslint-disable angular/on-watch */
(function() {
  'use strict';

  angular
    .module('frontend')
    .service('preventLeaving', preventLeaving);

  /** @ngInject */
  function preventLeaving($rootScope, $uibModal, $state, $window, $timeout) {
    var alreadyPrevented = false;

    function openPreventModal(forward) { // модалка подтверждения уходим со страницы или нет
      return $uibModal.open({
        templateUrl: 'app/common/prevent-leaving/prevent-leaving-modal.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $rootScope.completeProgressBar();
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.leave = function () {
            $uibModalInstance.close();
          }
        }
      }).result.then(function () {
        $state.go(forward.toState.name, forward.toParams);
        alreadyInitiated = false;
      }, function () {
        alreadyPrevented = false;
      })
    }

    function getVariable(scope, variableName) { // получение переменно по имени в параметре стейта
      var parts, vars = [scope];
      if (/\./.test(variableName)) {
        parts = variableName.split('.');
        for (var i = 0; i < parts.length; i++) {
          vars.push(vars[i][parts[i]])
        }
        return vars[vars.length - 1];
      } else {
        return scope[variableName];
      }
    }

    function prevent(scope, event, toState, toParams) { // функция предотвращения перехода
      if (toState.name !== 'login') {
        event.preventDefault();
        var forward = {
          toState:  toState,
          toParams: toParams
        };
        scope.$emit('stateChangePrevented'); // нужно для восстановлении истории связвнно с card-history
        setWindowEvent();
        alreadyPrevented = true;
        openPreventModal(forward);
      }
    }

    function setWindowEvent() {// установка onbeforeunload эвента
      if (preventByBrowser) {
        $window.onbeforeunload = function () {
          return 'Покинуть эту страницу? Возможно, внесенные изменения не сохранятся.';
        };
      }
    }

    function unsetWindowEvent() {// удаление onbeforeunload эвента
      if (preventByBrowser) {
        $window.onbeforeunload = undefined
      }
    }
    function getFormName(scope, formName) {
      if (/\./.test(formName)) {
        var parts = formName.split('.'), ctrl;
        ctrl = scope[parts[0]];
        if (ctrl) {
          return ctrl[parts[1]]
        }
      } else {
        return scope[formName];
      }
    }

    var scope, preventByBrowser, ignorePreventing, alreadyInitiated;

    this.startTracking = function() {
      $rootScope.$on('$viewContentLoaded', function ($viewContentLoadedEvent) { // триггерится при загрузки странице
        if ($viewContentLoadedEvent && $viewContentLoadedEvent.currentScope && $viewContentLoadedEvent.currentScope.$state.current && !alreadyInitiated) {
          alreadyPrevented = false;
          if ($viewContentLoadedEvent.currentScope.$state.current.formName) { // если в стейте есть параметр formname
            alreadyInitiated = true;
            scope = $viewContentLoadedEvent.targetScope;
            preventByBrowser = $viewContentLoadedEvent.currentScope.$state.current.preventByBrowser;
            var formName = $viewContentLoadedEvent.currentScope.$state.current.formName, form = null;

            scope.$on('$stateChangeStart', function($stateChangeStartEvent, toState, toParams) { // начинает проверять выполняется ли условия для предотвращения перехода
              form = getFormName(scope, formName);
              if (form && form.$dirty && !alreadyPrevented) {
                prevent(scope, $stateChangeStartEvent, toState, toParams)
              } else {
                alreadyInitiated = false;
              }
            });
            scope.$on('$destroy', function() { // подчищаем следы
              unsetWindowEvent();
              alreadyInitiated = false;
            });
          }

          if ($viewContentLoadedEvent.currentScope.$state.current.conditionVariableName) { // если в стейте есть параметр имени переменной отвечающей за триггер
            alreadyInitiated = true;
            var variableName = $viewContentLoadedEvent.currentScope.$state.current.conditionVariableName, destroyWatcher;
            scope = $viewContentLoadedEvent.targetScope;
            preventByBrowser = $viewContentLoadedEvent.currentScope.$state.current.preventByBrowser;
            if ($viewContentLoadedEvent.currentScope.$state.current.exceptionsState) {
              var exception = $viewContentLoadedEvent.currentScope.$state.current.exceptionsState || [];
            }
            $timeout(function() { // идет посде digest loop
              destroyWatcher = scope.$watch(function() { // установка вотчера для слежкой за изменениями триггера
                return getVariable(scope, variableName);
              }, function(val) {
                if (!!val && !angular.isFunction($window.onbeforeunload)) {
                  setWindowEvent()
                } else {
                  unsetWindowEvent()
                }
              });

              function unwatchChanges() { // отмена слежки
                unsetWindowEvent();
                if (angular.isFunction(destroyWatcher)) {
                  destroyWatcher();
                }
              }
              scope.$on('$stateChangeStart', function($stateChangeStartEvent, toState, toParams)  { // начинает проверять выполняется ли условия для предотвращения перехода
                if (!~exception.indexOf(toState.name)) {
                  if (!!getVariable(scope, variableName) && !alreadyPrevented) {
                    prevent(scope, $stateChangeStartEvent, toState, toParams)
                  }
                }
                unwatchChanges();
                alreadyInitiated = false;
              });
              scope.$on('$destroy', function(){ // подчищаем следы
                unwatchChanges();
                alreadyInitiated = false;
              });
            }, 0, false);
          }

        }
      });
    };

  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('addToPriceListController', addToPriceListController);

  function addToPriceListController($uibModalInstance,
                                    $scope,
                                    type,
                                    $state,
                                    selectionModel,
                                    priceListSrv, 
                                    requestStatus, 
                                    $location, 
                                    helpService
  ) {
    var addToPriceListCtrl = this;
    var selectedItems = selectionModel;
    var items = [];

    addToPriceListCtrl.type = type;
    addToPriceListCtrl.crudState = helpService.getCrudStateStructure();

    function prepareArrayOfItems(array) { // Рекурсивная сортировка выделенных айтемов по типу
      angular.forEach(array, function(root) {
        items.push(root.id);
        if (root.children && root.children.length > 0) {
          angular.forEach(root.children, function(child) {
            prepareArrayOfItems([child]);
          })
        }
      });
    }
    prepareArrayOfItems(selectedItems);

    addToPriceListCtrl.close = function () {
      $uibModalInstance.dismiss();
    };

    addToPriceListCtrl.addToPriceList = function() {
      if (!addToPriceListCtrl.crudState.loading) {
        addToPriceListCtrl.crudState.startLoading();

        priceListSrv.addItems(type, {items: items}).then(function() {
          addToPriceListCtrl.crudState.stopLoadingSuccess();
          var link = $state.href('priceList', {parent: type});
          requestStatus.success(
            'Выбранные позиции добавлены в прайс-лист', '',
            'Перейти в прайс-лист', link);
          $uibModalInstance.dismiss();
        }).catch(function() {
          addToPriceListCtrl.crudState.stopLoadingFailure();
        })
      }
    }
  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('importCatalogSrv', importCatalogSrv);

  function importCatalogSrv($http, API_URL) {

  	/**
     * Запрос Ошибок в файле
     *
     * @param importId
     */
    this.getResult = function (importId) {
      return $http.get(API_URL + "/import/domain_catalog/" + importId + "/result").then(function (res) {
        return res.data;
      });
    }

    /**
     * Запрос проверки возможности импорта
     * Главные настройки импорта
     *
     * @param importId
     */
    this.processingChecking = function (importId) {
      return $http.post(API_URL + "/import/domain_catalog/" + importId + "/process_checking", null, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    }

    /**
     * Запрос на импорт
     * Главные настройки импорта
     *
     * @param importId
     * @param category_id
     */
    this.processingUpdating = function (importId, category_id) {
      return $http.get(API_URL + "/import/domain_catalog/" + importId + "/process_updating", {
        params: {
          category_id: category_id,
          $$ignoreInterceptor: true
        }
      });
    }

    /**
     * Отменяет импорт файла
     *
     * @param importId
     */
    this.cancelImport = function (importId) {
      return $http.put(API_URL + '/import/domain_catalog/' + importId + '/cancel', undefined, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    }

  }

}) ();

(function() {
  'use strict';

  angular.module('frontend').controller('importCatalogController', importCatalogController);

  function importCatalogController($state,
                                 authToken,
                                 cardHistory,
                                 FileUploader,
                                 $uibModal,
                                 API_URL,
                                 importCatalogSrv,
                                 categoryService,
                                 statusSrv,
                                 modalMessageSrv
  ) {
    var vm = this;
    vm.activeStep = 0;
    vm.fileErrors = undefined;
    vm.category_id = undefined;
    vm.contains_without_categories = false;

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if(prev){
        $state.go(prev.name || 'catalog', prev.param || {parent: $state.params.parent});
      }else{
        $state.go('catalog', {parent: $state.params.parent});
      }
    };

    // загрузка файла
    vm.uploader = new FileUploader({
      url: API_URL + "/import/domain_catalog/upload",
      headers: {'X-Session-Id': authToken.getToken()},
      queueLimit: 1,
      onAfterAddingFile : function(){
        var file = vm.uploader.queue[0].file;
        var nameArr = file.name.split('.');

        vm.fileError = '';
        if(nameArr[nameArr.length - 1] !== 'xml'){  // ошибка неверный формат файла
          vm.uploader.queue[0].isError = true;
          vm.fileError = 'format';
          return;
        }
        if(file.size > 5242880){ // ошибка файл больше чем 5 МБ
          vm.uploader.queue[0].isError = true;
          vm.fileError = 'size';
          return;
        }
        vm.uploader.queue[0].upload();
      },
      onWhenAddingFileFailed: function(item){
        vm.uploader.clearQueue();
        vm.uploader.addToQueue([item]);
      },
      onSuccessItem: function(item, response){
        vm.import_id = response.import_id;
      }
    });

    // навигация по шагам импорта файла "Назад"
    vm.prev = function () {
      vm.activeStep = vm.activeStep - 1;
      if(vm.activeStep == 1){
        vm.root.resetSelect();
      }
    }

    // навигация по шагам импорта файла "Далее"
    vm.next = function (){
      if(vm.uploader.queue[0].isSuccess){

        vm.activeStep++;
        if(vm.activeStep == 1){
          vm.fileErrors = undefined;
          importCatalogSrv.processingChecking(vm.import_id).then(function(){
            statusSrv.getPromise('/import/domain_catalog/' + vm.import_id + '/status').then(function () {
                importCatalogSrv.getResult(vm.import_id).then(function(res){
                  vm.contains_without_categories = res.contains_without_categories;
                  var errorStr = ['ошибка', 'ошибки', 'ошибок'],
                      successStr = ['строка', 'строки', 'строк'],
                      cases = [2, 0, 1, 1, 1, 2];
                  vm.fileErrors = res;
                  if(res.errors.length){ // вывод правильного окончания для ошибки
                    vm.errorCountStr = errorStr[ (res.errors.length % 100 > 4 && res.errors.length % 100 < 20)? 2 : cases[(res.errors.length % 10 < 5)?res.errors.length % 10 : 5] ]
                  }else{
                    vm.errorCountStr = '';
                  }
                  if(res.success_count){ // вывод правильного окончания для ошибки
                    vm.successCountStr = successStr[ (res.success_count % 100 > 4 && res.success_count % 100 < 20)? 2 : cases[(res.success_count % 10 < 5)?res.success_count % 10 : 5] ]
                  }else{
                    vm.successCountStr = '';
                  }
                },
                function (error) {
                  vm.fileErrors = {};
                  vm.activeStep--;
                  modalMessageSrv.showModal({message: 'При получении результатов произошла ошибка', submessage: error});
                });
              },
              function () {
                vm.activeStep--;
                modalMessageSrv.showModal({message: 'При проверке данных произошла ошибка'});
              },
              function () {
                modalMessageSrv.showModal({message: 'При проверке данных произошла ошибка'});
              });
          },
          function (error) {
            vm.fileErrors = {};
            vm.activeStep--;
            modalMessageSrv.showModal({message: 'При запросе импорта произошла ошибка', submessage: error});
          });
        }
      }
    };

    // конечный импорт
    vm.importStart = function(){
      $uibModal.open({
        templateUrl: 'app/catalog/import/modal/import-modal.html',
        size: 'middle-width',
        controller: function($scope, $uibModalInstance, statusSrv){
          $scope.fileErrors = vm.fileErrors;
          $scope.loadImport = false;

          // установка статусов для ошибки
          $scope.errorStatuses = function(){
            $scope.loadError = true;
            $scope.loadImport = false;
            $scope.loadSuccess = false;
          }

          // начать импорт
          $scope.import = function () {
            $scope.showInfo = false;
            $scope.loadImport = true;

            importCatalogSrv.processingUpdating(vm.import_id, vm.category_id).then(function (res) {
              vm.import_id = res.data.import_id;
              // опрос статуса операции
              statusSrv.getPromise('/import/domain_catalog/' + vm.import_id + '/status').then(function () {
                $scope.loadImport = false;
                $scope.loadSuccess = true;
              },
              function () {
                $scope.errorMessage = "Ошибка";
                $scope.errorStatuses();
              },
              function (error) {
                if(error.status == 500 ||  error.status == 403 || error.status == 401){
                  $uibModalInstance.dismiss();
                }else{
                  $scope.errorMessage = error.data.message;
                  $scope.errorStatuses();
                }
              });
            },
            function (error) {
              if(error.status == 500 ||  error.status == 403 || error.status == 401){
                $uibModalInstance.dismiss();
              }else{
                $scope.errorMessage = error.data.message;
                $scope.errorStatuses();
              }
            });
          };
          // флаг для вывода предупреждения перед импортом
          if(!vm.fileErrors.errors.length){
            $scope.showInfo = false;
            $scope.import();
          }else{
            $scope.showInfo = true;
          }

          $scope.cancel = function() {
            $uibModalInstance.dismiss();
            importCatalogSrv.cancelImport(vm.import_id).then(function () {
              $scope.errorStatuses();
            },
            function (error) {
              modalMessageSrv.showModal({message: 'При отмене импорта произошла ошибка', submessage: error});
            });
          };

          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      })
    };
    

    // настройка скролла
    vm.configScroll = {
      autoHideScrollbar: false,
      setHeight: 270,
      scrollInertia: 0,
      axis: 'yx',
      advanced: {
          updateOnContentResize: true
      },
      scrollButtons: {
          enable: false
      },
      theme: 'dark'
    };

    // Узлы дерева
    vm.root = {
      name: 'Все категории',
      root: true,
      has_children: true,
      children: []
    };

    // Callback загрузки дерева
    vm.onTreeLoaded = function () {
      vm.root.expandFuncByModel({}); // открывает корень дерева
    };

    /**
     * Пример callback для вызова при выборе узла в дереве
     *
     * @param node выбранный узел
     */
    vm.selectNode = function (node) {
      vm.category_id = (angular.isUndefined(node))? undefined : (node.id)? node.id : null;
    }

    /* Callback для раскрытия дерева */
    vm.expand = function (node) {
      // Загрузка дочерних категорий только при установленном флаге наличия
      return categoryService.getDomainCategories(node.id).then(function (data) {
        if (data.data) {
          return data.data;
        }
      });
    }

  }

})();

/**
 * Created by aivanov on 02.11.2017.
 */
(function () {
  'use strict';

  /**
   * Фильтр возвращает кириллическое название по статусу объекта каталога участника.
   */
  angular.module('frontend').filter('skuStatus', function () {
    return skuStatusFilter;
  });

  var skuStatusFilter = function (status) {
    if (status) {
      var upper = status.toUpperCase();
      return upper == 'DRAFT' ? 'Черновик' :
        upper == 'CHECKING' ? 'На проверке' :
          upper == 'NOT_CONFIRMED' ? 'Не подтвержден' :
            upper == 'CONFIRMED' ? 'Подтвержден' :
              upper == 'ARCHIVED' ? 'В архиве' :
                status; // Если нет совпадений, позвращаем исходное название
    } else {
      return '';
    }
  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('exportCatalogSrv', exportCatalogSrv);

  function exportCatalogSrv($http, API_URL) {

  	/**
     * Запрос Ошибок в файле
     *
     * @param exportId
     */
    this.getResult = function (exportId) {
      return $http.get(API_URL + "/export/domain_catalog/" + exportId + "/result").then(function (res) {
        return res.data;
      });
    }

    /**
     * Запрос проверки возможности экспорта
     * Главные настройки экспорта
     *
     * @param exportSettings
     */
    this.processing = function (exportSettings) {
      return $http.post(API_URL + "/export/domain_catalog/processing", exportSettings);
    }

    /**
     * Отменяет экспорт файла
     *
     * @param exportId
     */
    this.cancel = function (exportId) {
      return $http.put(API_URL + '/export/domain_catalog/' + exportId + '/cancel');
    }

  }

}) ();

'use strict';

angular.module('frontend').component('catalogExport', {
  templateUrl: 'app/catalog/export/catalog-export-modal.html',
  bindings: {
    modalInstance: "<",
    resolve: "<"
  },
  controller: function (exportCatalogSrv, helpService, authToken, statusSrv, $timeout, API_URL, downloadSrv, $q) {
    var ctrl = this;
    ctrl.processing = {mode: 'FULL'};
    ctrl.longRequest = {
      exec_id: null, //ID задачи построения отчета
      crudState: helpService.getCrudStateStructure(), // состояния странички
      flags: {
        processStart: false, // флаг начала опроса статуса выполнения задачи
        finish: false // флаг конца опроса выполнения задачи
      },
      stopAskingError: function () { // прекращение опроса статуса из-за ошибки
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = true;
        ctrl.longRequest.flags.error = true;
        ctrl.longRequest.crudState.stopLoadingFailure();
        print.turnoffInterceptorStatus();
      },
      onError: function (err) {
        if (err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated')) {
          ctrl.longRequest.revert();
        } else {
          ctrl.longRequest.stopAskingError();
        }
      },
      revert: function () {
        ctrl.longRequest.format = null;
        ctrl.longRequest.cancelled = false;
        ctrl.longRequest.exec_id = null;
        ctrl.longRequest.crudState.stopLoadingSuccess();
        ctrl.longRequest.flags.processStart = false;
        ctrl.longRequest.flags.finish = false;
      }
    };

    // формирование короткой структуры выбранных элементов каталога
    if (ctrl.resolve.catalogItems && ctrl.resolve.catalogItems.length) {
      ctrl.processing.catalog_elements = [];
      angular.forEach(ctrl.resolve.catalogItems, function (item) {
        ctrl.processing.catalog_elements.push({id: item.id, name: item.name, type: (item.type)? item.type : undefined});
      });
    }

    // установка статусов для ошибки
    ctrl.errorStatuses = function () {
      ctrl.loadError = true;
      ctrl.loadExport = false;
      ctrl.loadSuccess = false;
    }

    ctrl.prepareExport = function () {
      ctrl.showStatuses = true;
      ctrl.loadExport = true;

      exportCatalogSrv.processing(ctrl.processing).then(function (res) {
        ctrl.export_id = res.data.export_id;
        statusSrv.getPromise('/export/domain_catalog/' + res.data.export_id + '/status').then(function () {
            $timeout(function () {
              downloadSrv.getPromise('/export/domain_catalog/' + res.data.export_id + '/download').then(function () {
                ctrl.loadExport = false;
                ctrl.loadSuccess = true;
                ctrl.export_id = '';
              });
            });
          },
          function (res) {
            ctrl.export_id = '';
            ctrl.errorMessage = "Непредвиденная ошибка";
            ctrl.errorStatuses();
          });
      }).catch(function (error) {
        ctrl.export_id = '';
        if (error.status == 500 || error.status == 403 || error.status == 401) {
          ctrl.close();
        } else {
          ctrl.errorMessage = (error.data)? error.data.message : "Непредвиденная ошибка";
          ctrl.errorStatuses();
        }
      })
    };

    ctrl.close = function () {
      //$q.defer().resolve() // нужен аборт запроса
      if (ctrl.export_id) {
        exportCatalogSrv.cancel(ctrl.export_id);
      }
      ctrl.modalInstance.dismiss();
    };

  }
});

'use strict';
angular.module('frontend').component('deleteSkus', {
  templateUrl: 'app/catalog/deleteModal/delete-button.html',
  bindings: {
    root: '<',
    callback: '<'
  },
  controller: function ($scope, $uibModal) {
    var ctrl = this;
    ctrl.smthRemoved = false;
    ctrl.openDeleteDialog = function() {
      return $uibModal.open({
        templateUrl: 'app/catalog/deleteModal/delete-modal.html',
        size: 'middle-width',
        backdrop: 'static',
        keyboard: false,
        resolve: {
         root: ctrl.root
        },
        controller: function ($scope, $uibModalInstance, ngProgressFactory, $timeout, root, $q, categoryService, catalogItemService) {
          var element;
          var items = [];
          var intervalCounterId;

          $scope.flags = {
            finished: false,
            inProgress: false
          };
          $scope.selectedItems = root.getSelectionModel();
          function prepareArrayOfItems(array) { // Рекурсивная сортировка выделенных айтемов по типу
            angular.forEach(array, function(root) {
                items.push({
                id: root.id,
                name: root.name,
                parent_id: root._parent.id,
                has_children: root.has_children,
                children: root.children,
                status: root.status,
                type: root.type
              });
              if (root.children && root.children.length > 0) {
                angular.forEach(root.children, function(child) {
                  prepareArrayOfItems([child])
                })
              }
            });
          }
          /*
            Подготовка порядка удаления айтемов , сначала идут с самым глубоким уровнем вложенности, потом их родитель,
            затем стоящие с ним на одном уровне, затем их родитель, и тд до рута, затем преключение на другую ветку
           */
          function prepareForDeleting() {
            var maxDeepSkus = [];
            var maxDeepServices = [];
            var maxDeepCategories = [];
            var allMaxDeep = [];
            var finalOrder = [];
            function prepareObject(item) {
              return {
                id: item.id,
                name: item.name,
                type: item.type || 'CATEGORY',
                parent_id: item.parent_id
              }
            }
            angular.forEach(items, function(item) { // складываем в массив айтемы, которые находятся на максимально возможном уровне вложенности
              if ((item.type !== 'CATEGORY' && item.status === 'ARCHIVED') || item.type === 'CATEGORY' || !item.type) {
                switch (item.type) {
                  case 'SKU':
                    maxDeepSkus.push(prepareObject(item));
                    break;
                  case 'SERVICE':
                    maxDeepServices.push(prepareObject(item));
                    break;
                  default :
                    if (!item.children) {
                      maxDeepCategories.push(prepareObject(item));
                    }
                    break;
                }
              }
            });
            allMaxDeep = (maxDeepSkus.concat(maxDeepServices)).concat(maxDeepCategories); // формируем общий массив айтемов с максимальным уровнем вложенности

            var allMaxDeepParents =  _.filter(items, function(item) { // получаем родителей элементов которые находятся в allMaxDeep
              return !!_.find(allMaxDeep, function(insideItem) {
                return item.id === insideItem.parent_id || !insideItem.parent_id || insideItem.type
              })
            });

            allMaxDeepParents = _.filter(allMaxDeepParents, function(item) {
              return !_.find(allMaxDeepParents, function(insideItem) {
                return item.id === insideItem.parent_id
              })
            });

            angular.forEach(allMaxDeepParents, function(item) { // формирование массива в правильном порядке для удаления
              var children = _.filter(allMaxDeep, function(orderItem) {
                return item.id === orderItem.parent_id
              });
              finalOrder = finalOrder.concat(children);
              goUp(item);
            });

            var uniqueItemsInRightOrder = [];
            angular.forEach(finalOrder, function(item) { // формирование массива с уникальными значениями
              if (!_.find(uniqueItemsInRightOrder, function(findItem) {
                  return findItem.id === item.id
                })) {
                uniqueItemsInRightOrder.push(item)
              }
            });


            function goUp(parent) { // рекурсивное вычисление родителей
              function goDeep(array) { // проверяем вложенность и идем к потомкам рекурсиввно
                angular.forEach(array, function(item) { // пробегаем по элементам одного уровня
                  if (!item.children) { // если нет потомков
                    if (!_.find(finalOrder, function(findItem) { // если нет в массиве с правильныи порядком , добавляем
                        return findItem.id === item.id
                      })) {
                      finalOrder.push({
                        id: item.id,
                        name: item.name,
                        type: item.type,
                        status: item.status
                      })
                    }
                  } else { // если потомки есть
                    angular.forEach(item.children, function(child) { // опускаемся на уровень ниже к потомкам и добавляем, если они не добавленны ранее
                      if ((!_.find(finalOrder, function(findItem) {
                          return findItem.id === child.id
                        }))) {
                        finalOrder.push({
                          id: child.id,
                          name: child.name,
                          type: child.type,
                          status: child.status
                        })
                      }
                      goDeep(item.children)
                    });
                    if ((!_.find(finalOrder, function(findItem) { // добавляем родителя
                        return findItem.id === item.id
                      }))) {
                      finalOrder.push({
                        id: item.id,
                        name: item.name,
                        type: item.type,
                        status: item.status
                      })
                    }
                  }
                });
              }
              if (parent) {
                if (!parent.parent_id) { // флаг корневой категории
                  finalOrder.push(parent)
                } else {
                  var itemParent = _.find(items, function(item) { // получаем родителя переданного эелемента
                    return parent.parent_id === item.id
                  });

                  var siblings = _.filter(items, function(item) { // родственники
                    return parent.parent_id === item.parent_id
                  });

                  var orderedParent = _.find(siblings, function(item) { // находим среди всех родственников на одном уровне переданного родителя
                    return parent.id === item.id
                  });

                  finalOrder.push(orderedParent); // добавляем в массив с правильным порядком

                  siblings.splice(siblings.indexOf(orderedParent), 1); // удаляем переданный элемент
                  // рекурсии
                  goDeep(siblings);
                  goUp(itemParent);
                }
              }
            }
            return uniqueItemsInRightOrder.filter(function(value) {
              return !value.type || (value.type !== 'CATEGORY' && value.status === 'ARCHIVED');
            });
          }
          prepareArrayOfItems($scope.selectedItems);
          $scope.order = prepareForDeleting();
          var oneStep = Math.round(95 / ($scope.order.length));
          $scope.progressbarValue = 0;

          $scope.progressbar = ngProgressFactory.createInstance();
          $timeout(function() {
            $scope.progressbar.setHeight('16px');
            $scope.progressbar.setParent(angular.element('#progress-bar')[0]);
            element = $scope.progressbar.getDomElement();
          });

          function setProgress(progress, force) {
            $scope.progressbar.set(progress);
            if (progress >= 100 && !force) {
              $scope.progressbar.set(99);
              progress = 99;
            }
          }

          function move(start, limit) {
            var remaining, count = start;
            intervalCounterId = setInterval(function () {
              if (isNaN(count)) {
                clearInterval(intervalCounterId);
              } else {
                remaining = limit - count;
                count = count + (0.15 * Math.pow(1 - Math.sqrt(remaining), 2));
                $scope.progressbar.set(count)
              }
            }, 200);
          }


          $scope.startProcess = function(i) {
            $scope.currentIndex = i;
            if ($scope.currentIndex + 1 > $scope.order.length) {
              setProgress(100, true);
              $scope.flags.finished = true;
              return false;
            }
            $scope.nowDeleting = {
              name: $scope.order[i].name,
              type: $scope.order[i].type,
              index: i
            };
            return $q(function(resolve, reject) {
              $scope.flags.inProgress = true;
              move($scope.progressbarValue, $scope.progressbarValue + oneStep);
              if ($scope.order[i].type === 'SKU') {
                catalogItemService.deleteSkus($scope.order[i].id, true).then(resolve).catch(reject)
              } else if ($scope.order[i].type === 'SERVICE') {
                catalogItemService.deleteService($scope.order[i].id, true).then(resolve).catch(reject)
              } else {
                categoryService.deleteCategory($scope.order[i].id, true).then(resolve).catch(reject)
              }
              ctrl.smthRemoved = true;
            }).then(function(res) {
              setProgress($scope.progressbarValue + oneStep);
              $scope.progressbarValue += oneStep;
              $scope.startProcess(i + 1);
            }).catch(function(err) {
              clearInterval(intervalCounterId);
              setProgress($scope.progressbarValue + oneStep);
              $scope.progressbarValue += oneStep;
              if (err.status === 409) {
                error(i + 1, err.data.code);
              }
            })
          };


          function error(index, code) {
            $scope.flags.inProgress = false;
            $scope.flags.error = true;
            $scope.flags.stopped = true;
            $scope.currentIndex = index;
            if (code) {
              $scope.flags.errorCode = code
            }
          }

          $scope.continue = function() {
            if (!$scope.flags.inProgress) {
              $scope.flags.inProgress = true;
              $scope.flags.error = false;
              $scope.flags.stopped = false;
              $scope.startProcess($scope.currentIndex);
            }
            ctrl.callback();
          }

          $scope.close = function(needTreLoad) {
            $scope.order = [];
            if(needTreLoad || ctrl.smthRemoved){
              ctrl.callback();
            }
            $uibModalInstance.dismiss();
          };

        }
      }).result.finally(function () {
        if(ctrl.smthRemoved)ctrl.callback()
      });
    }

  }
});


(function() {
  'use strict';

angular.module('frontend').controller('crudCategoryController', crudCategoryController);

  function crudCategoryController($scope,
                                  $state,
                                  $log,
                                  $uibModal,
                                  $timeout,
                                  $q,
                                  $document,
                                  $stateParams,
                                  $rootScope,
                                  cardHistory,
                                  category,
                                  categoryService,
                                  errorMessageService,
                                  attrSettingsService,
                                  utilsService,
                                  $anchorScroll,
                                  askDeleteSrv, // сервис для вызова окна подтверждения удаления
                                  helpService,
                                  cashRegisterItemTypes,
                                  projectsService) {
    var vm = this;
    vm.state = $state;
    vm.showAllInform = (vm.state.current.name != 'category.new');
    vm.parentAttr = vm.parentAttrNames = [];
    vm.parentId = $state.params.parentId;
    vm.issetReqAttr = false;
    vm.hasMarkedSKU = false;
    vm.cashRegisterItemTypes = cashRegisterItemTypes;

    vm.scanMarkTypes = categoryService.getScanMarkTypes();

    $log.log(category);

    /* Настройки дерева расположения */
    // Узлы дерева
    vm.root = {
      name: 'Товары и услуги',
      root: true,
      has_children: true,
      children: []
    }

    /**
     * Метод обновляет список роителских категорий
     */
    vm.refreshParentList = function (parentId) {
      if (!parentId) return;
      return categoryService.categoryHierarchy(parentId).then(function (data) {
        if (data.data && data.data.levels) {
          vm.pathCatagory = _.map(data.data.levels, function (item) {
            return item.id;
          });
        }
      });
    };

    /* Автодополнение проектов */
    vm.refreshProjects = function (search) {
      projectsService.projectsSearch(search, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH, {filter_active: true}).then(function(res){
        vm.projects = res.data;
        if(!vm.projectsFullTotal){
          vm.projectsFullTotal = res.data.total;
        }
      });
    }
    vm.totalSelectStr = function(){
      if(vm.projectsFullTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + vm.projectsFullTotal;
      }
      return '';
    };

    if(category) vm.parentId = (vm.parentId)? vm.parentId : (category && category.parent)? category.parent.id : '';
    if (vm.parentId) {
      vm.refreshParentList(vm.parentId);
      /* получение всех родителей */
      categoryService.categoryHierarchy(vm.parentId).then(function (data) {
        if (data.data && data.data.levels) {
          // Создание структуры для простого отображения в дереве, без подзагрузки
          var curNode = vm.root;
          angular.forEach(data.data.levels, function (level) {
            level.expand = true;
            level.loaded = true;
            curNode.children = [level];
            curNode = level;
          });
        }
      });
    }

    function setCategory(){
      if(category){
        vm.category = category;
        if(!vm.category.elements) vm.category.elements = [];
        /* добавление атрибутов из родительской категории */
        var allAttr = vm.parentAttr.concat(vm.category.elements);
        vm.category.elements = allAttr;

        angular.forEach(vm.category.elements, function(value) {
          if(value.attribute){
            value.attribute.$$enabled = true;
          }else{
            value.block.$$enabled = true;
            angular.forEach(value.block.attributes, function(attr) {
              attr.$$enabled = true;
            });
          }
        });
      }else{
        if(vm.category){
          if(!vm.category.elements) vm.category.elements = [];
          /* добавление атрибутов из родительской категории */
          var allAttr = vm.parentAttr.concat(vm.category.elements);
          vm.category.elements = allAttr;
        }
      }
      if(vm.category){
        // Инициализация параметра "Использовать предмет расчета по умолчанию"
        if (vm.update_items_register_type === undefined) {
          vm.update_items_register_type = false;
        }
        angular.forEach(vm.category.elements, function(val) {
          if (val.attribute && val.attribute.required) {
            helpService.addId(val.attribute)
          }
          if (!val.attribute && val.block && val.block.attributes) {
            angular.forEach(val.block.attributes, function(attr) {
              if (attr && attr.required) {
                helpService.addId(attr)
              }
            })
          }
        });
      }
      _initMarkSKUSettings();
    }

    function _initMarkSKUSettings() {
      if (vm.category && vm.category.product_group) {
        vm.hasMarkedSKU = !!vm.category.product_group;
        if (!vm.category.product_group || !vm.category.scan_mark_type) {
          vm.category.scan_mark_type = "ALWAYS"
        }
        vm.category.product_group = vm.category.product_group || vm.productGroups[0];
      }
    }

    function getParentInfo(parentId){
      if (!parentId) return;
      /* получение списка родительских атрибутов */
      categoryService.getCustomCategory(parentId).then(function (res) {
        /* добавление всем атрибутам родителя недостающих параметров inherited итд */
        if(vm.state.current.name === 'category.new'){
          angular.forEach(res.data.elements, function(attr){
            if(attr.attribute){
              attr.attribute = rewriteAttr(attr.attribute, res.data.name, res.data.id);
            }else{
              attr.block.$$enabled = true;
              attr.block.inherited = true;
              angular.forEach(attr.block.attributes, function(blockAttr){
                blockAttr = rewriteAttr(blockAttr, res.data.name, res.data.id);
              });
            }
          });
          vm.parentAttr = res.data.elements || [];
          /* для удаления атрибутов из единого каталога */
          vm.parentAttrNames = [];
          if(vm.parentAttr.length){
            angular.forEach(vm.parentAttr, function(attr){
              if(attr.attribute){
                vm.parentAttrNames.push(attr.attribute.name);
              }else{
                angular.forEach(attr.block.attributes, function(blockAttr){
                  vm.parentAttrNames.push(blockAttr.name);
                });
              }
            });
          }
        }
        setCategory();
      });
    }

    /* получение флагов настроек */
    attrSettingsService.getSettings().then(function(res){
      vm.settings = res.data;
      delete vm.settings.elements;
      if(category) vm.parentId = (vm.parentId)? vm.parentId : (category && category.parent)? category.parent.id : '';
      if(vm.settings.inherit_category_attributes && vm.parentId){
        getParentInfo(vm.parentId)
      }else{
        setCategory()
      }
    });

    function rewriteAttr(attr, parentName, parentId){
      attr.$$enabled = true;
      if(!attr.inherited){
        attr.inherited = true;
        attr.inheritedFrom = {
          "id": parentId,
          "name": parentName
        };
      }
      return attr;
    }

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep('categoryId', $stateParams.categoryId) || {name: 'catalog', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'catalog', prev.param || {parent: $state.params.parent});
    }

    vm.resetData = function() {
      $scope.addCategory.$setPristine();
      vm.returnToPage();
    }

    // callback при изменении родиетльского узла ккатегории
    vm.dragChange = function (node, // перемещаемый узел
                              parent // куда переместился
    ) {
      $log.log('Смена узла на: ' + parent.name);

      // обновление path до текущего положения элемента
      vm.refreshParentList(parent.id);

      var attrWithoutParents = [];
      angular.forEach(vm.category.elements, function(attr){
        if(attr.attribute){
          if(!attr.attribute.inherited) attrWithoutParents.push(attr);
        }else{
          if(!attr.block.inherited) attrWithoutParents.push(attr);
        }
      });
      vm.category.elements = attrWithoutParents;
      getParentInfo(parent.id);
    }

    /**
     * Фиксация выбора узла в дереве
     *
     * @param node выбранный узел
     */
    vm.selectNode = function(node) {
      //vm.category.parent = node;
    }

    /* Callback для раскрытия дерева (TODO: вынести в сервис) */
    vm.expand = function(node) {
      // Загрузка дочерних категорий только при установленном флаге наличия
      return (node.has_children) ? categoryService.getDomainCategories(node.id).then(function(data) {
        if (data.data) {
          return data.data;
        }
      }) : $q.when([]);
    }

    /* Автодополнение категорий */
    vm.refreshCategories = function(search) {
      vm.autoCategories = [];
      vm.category = {
        name: search,
        elements: []
      }
      // Вынеcено из свойств компонента в виду необходимости вызова refresh на каждое обновление поля
      if (search && search.length >= 2) {
        categoryService.getCategories(search).then(function (res) {
          vm.autoCategories = res.data.items;
          vm.autoCategoriesTotal = res.data.total;
        });
      }
      _initMarkSKUSettings();
    }

    vm.choseCategory = function(category){
      vm.autoCategories = [];
      if(category){
        //if(searchCategory) angular.element(searchCategory).find('input').val(category.name);
        if(vm.settings.use_category_attributes){
          vm.disableButton = true;
          categoryService.getCategory(category.id).then(function(res){
            /* убрать показ атрибутов которые есть в родительской категории */
            if(vm.parentAttrNames.length){
              angular.forEach(res.data.elements, function(attr){
                if(attr.attribute){
                  if(vm.parentAttrNames.indexOf(attr.attribute.name) > -1){
                      blockAttr.$$isset = true;
                    }
                }else{
                  var countAttr = 0;
                  angular.forEach(attr.block.attributes, function(blockAttr){
                    if(vm.parentAttrNames.indexOf(blockAttr.name) > -1){
                      blockAttr.$$isset = true;
                      countAttr++;
                    }
                  });
                  if(countAttr == attr.block.attributes.length){
                    attr.block.$$isset = true;
                  }
                }
              });
            }
            vm.category = res.data;
            vm.category.parent = undefined; // очистка родителя единого каталога
            vm.disableButton = false;
            delete vm.category.id;
          });
        }else{
          vm.category = category;
        }
      }
      _initMarkSKUSettings();
    }

    /**
     * Проверка уникальности имени категории
     */
    vm.uniqueCheck = function(str){
      if(str){
        var obj = {
          "constraint_name": "DOMAIN_CATEGORY_NAME",
          "parameters": [
            {
              "name": "name",
              "value": str
            }
          ]
        }
        if(vm.category.id) obj.id = vm.category.id;
        utilsService.uniqueCheck(obj).then(function(res){},
        function (error) {
          if(error.status == 409 && error.data.code == 'non_unique'){
            angular.forEach(error.data.parameters, function(field){
              $scope.addCategory[field.name].$setValidity('unique', false);
            });
          }
        });
      }
    }

    /**
     * Переход на Далее при создании категории
     */
    vm.showDetails = function(){
      vm.showAllInform = true;
      // почистить обект категории от лишних блоков атрибутов
      if(vm.category){
        var selestedAttr = [];
        angular.forEach(vm.category.elements, function(attr) {
          if(attr.block){
            if(attr.block.$$enabled) selestedAttr.push(attr);
          }else{
            selestedAttr.push(attr);
          }
        });
        /* добавление атрибутов из родительской категории */
        vm.parentAttr = (vm.parentAttr)? vm.parentAttr : [];
        /* объединение блоков атрибутов с родительскими */
        if(vm.parentAttr.length){
          angular.forEach(selestedAttr, function(childAttr) {
            if(childAttr.block){
              angular.forEach(vm.parentAttr, function(parentAttr) {
                if(parentAttr.block){
                  if(childAttr.block.name == parentAttr.block.name){
                    childAttr.block.$$enabled = false;
                    parentAttr.block.attributes = parentAttr.block.attributes.concat(childAttr.block.attributes);
                  }
                }
              });
            }
          });
        }
        var allAttr = vm.parentAttr.concat(selestedAttr);
        vm.category.elements = allAttr;
        vm.uniqueCheck(vm.category.name);
      }else{
        vm.category = {};
        vm.category.elements = vm.parentAttr;
      }
      _initMarkSKUSettings();
      // Добавлени нового узла в дерево
      vm.tempNode = {
        name: vm.category ? vm.category.name : undefined,
        allowDrag: true,
        has_children: false
      };
      vm.root.addItem(vm.tempNode, vm.pathCatagory, true); // Выбор родителя, а не добавяемого элемента
      $anchorScroll();
    };

    // Связка изменения имени категории и временного узла
    $scope.$watch('vm.category.name', function (newVal) {
        if (vm.tempNode) {
          vm.tempNode.name = newVal;
        }
    });

    vm.checkAttrError = function(){
      vm.wrongData = false;
      angular.forEach(vm.category.elements, function(value) {
        if(value.attribute){
          if(value.attribute.$$enabled && value.attribute.uinqError) vm.wrongData = true;
        }else{
          if(value.block.$$enabled && value.block.uinqError) vm.wrongData = true;
          angular.forEach(value.block.attributes, function(attr) {
            if(attr.$$enabled && attr.uinqError) vm.wrongData = true;
          });
        }
      });
      if(vm.wrongData){
        $scope.addCategory.$error.errorUnique = true;
      }else{
        delete $scope.addCategory.$error.errorUnique;
      }
    };

    // Метод, вызываемый при удалении категории
    vm.delete = function () {
      return askDeleteSrv.showAskDelete(
        vm.category.name,
        "категорию",
        "Мы не можем удалить <a>категорию «" + vm.category.name + "»</a>, так как в ней содержатся товары или услуги.<br><br>Удалите или переместите товары из группы и повторите операцию ",
        vm.category.id,
        categoryService.deleteCategory
      ).then(function (data) {
        vm.resetData();
      });
    };

    // В методе выполняются подготовительные операции перед сохранением
    vm.prepareSave = function () {
      /* удаление вспомагательной информации из объекта категории */
      var attrObj = [];
      angular.forEach(vm.category.elements, function(value) {
        if(value.attribute){
          if(value.attribute.$$enabled){
            delete value.attribute.canDelete;
            delete value.attribute.uinqError;
            delete value.attribute.errorText;
            attrObj.push(value);
          }
        }else{
          var tempBlock = {};
          delete value.block.uinqError;
          delete value.block.errorText;
          if(value.block.$$enabled){
            if(!category) delete value.block.id;
            delete value.block.canDelete;
            tempBlock = angular.copy(value);
            tempBlock.block.attributes = [];

            angular.forEach(value.block.attributes, function(attr) {
              if(attr.$$enabled){
                delete attr.canDelete;
                delete attr.uinqError;
                delete attr.errorText;
                tempBlock.block.attributes.push(attr);
              }
            });
            attrObj.push(tempBlock);
          }
        }
      });

      // Установка родителя из перетаскиваемого темпового узла
      if(vm.tempNode) vm.category.parent = vm.tempNode.getParent();
      vm.category.elements = attrObj;
      if(!category){
        //delete vm.category.parent;
        delete vm.category.id;
      }
      if (!vm.hasMarkedSKU) {
        vm.category.product_group = null;
        vm.category.scan_mark_type = 'NEVER'
      }
    }

    vm.reqAttrInfo = function(){
      var total = 0;
      categoryService.getDomainCategoryEstimateRequired(category.id).then(function(res){
        total = res.data.stock_item_count + res.data.service_count;
        if ( total !== 0 ) {
          vm.info(total);
        } else {
          vm.issetReqAttr = false;
          vm.save(true);
        }
      });
    }

    // установка флагов ошибок атрибутам, блокам и атрибутам внутри блоков
    vm.setAttrError = function(error){
      vm.isSetDirty = true;
      if(error.data.constraint_name == "DOMAIN_CATEGORY_NAME"){
        $scope.addCategory.name.$setValidity('unique', false);
        $anchorScroll("nameAnchor");
      }else{
        angular.forEach(vm.category.elements, function(value) {
          if(error.data.code == 'business_rule'){
            if(value.attribute){
              if(error.data.rule == 'DOMAIN_ATTRIBUTE_NAME' && error.data.object_name == value.attribute.name){
                value.attribute.uinqError = true;
                value.attribute.errorText = 'Атрибут используется в упаковке';
              }
            }else{
              if(error.data.rule == 'DOMAIN_GROUP_NAME' && value.block.name == error.data.object_name){
                value.block.uinqError = true;
                value.block.errorText = 'Группа используется в упаковке';
              }
              angular.forEach(value.block.attributes, function(attr) {
                if(error.data.rule == 'DOMAIN_ATTRIBUTE_NAME' && error.data.object_name == attr.name){
                  attr.uinqError = true;
                  attr.errorText = 'Атрибут используется в упаковке';
                }
              });
            }
          }
          if(error.data.code == 'non_unique'){
            if(value.attribute){
              if(error.data.constraint_name == 'DOMAIN_ATTRIBUTE_NAME' && error.data.parameters[0].value == value.attribute.name){
                value.attribute.uinqError = true;
                value.attribute.errorText = 'Атрибут уже используется';
              }
            }else{
              if(error.data.constraint_name == 'DOMAIN_GROUP_NAME' && value.block.name == error.data.parameters[0].value){
                value.block.uinqError = true;
                value.block.errorText = 'Группа уже используется';
              }
              angular.forEach(value.block.attributes, function(attr) {
                if(error.data.constraint_name == 'DOMAIN_ATTRIBUTE_NAME' && error.data.parameters[0].value == attr.name){
                  attr.uinqError = true;
                  attr.errorText = 'Атрибут уже используется';
                }
              });
            }
          }
        });
        $timeout(function() {
          $anchorScroll("errorAnchor");
          vm.checkAttrError();
        }, 0);
      }
    }

    vm.save = function(ignoreStopSaving){
      var deferred = $q.defer();
      // подготовка структур в соответствие АПИ
      vm.prepareSave();
      var stopSaving = !!_.find(vm.category.elements, function(val) {
        return (val.attribute && !val.attribute.$$uiid && val.attribute.required)
          || (!val.attribute && val.block && val.block.attributes && !!_.find(val.block.attributes, function(attr) {
            return attr && !attr.$$uiid && attr.required
          }));
      });

      if (stopSaving && !ignoreStopSaving && category) {
        vm.reqAttrInfo();
        return deferred.promise;
      }

      if (category) {
        // Блок обновления
        return categoryService.updateCategory(vm.category, vm.update_items_register_type).then(function(res){
          // Переход на предыдущую страницу
          vm.resetData();
        }, function (error) {
          if(error.status == 409 && (error.data.code == 'non_unique' || error.data.code == 'business_rule')){
            vm.setAttrError(error);
          }else{
            errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
          }
          return deferred.reject();
        })
      }else{
        // Блок создания
        return categoryService.saveCategory(vm.category).then(function(res){
          // Переход на предыдущую страницу
          vm.resetData();
        },
        function (error) {
          if (error.status === 400 && (error.data.code === 'bad_arguments')){
            if (Array.isArray(error.data.fields) && error.data.fields.length > 0 && error.data.fields[0].field === "cashRegisterItemType"){
              errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {
                data: {
                    message: 'Не выбран предмет расчета по умолчанию.'
                  }
                }
              })
            }
          } else if(error.status === 409 && (error.data.code === 'non_unique' || error.data.code === 'business_rule')){
            vm.setAttrError(error);
          } else if (error.status === 409 && error.data.code === 'exceeded_maximum_number_of_categories') {
            errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {
              data: {
                  message: 'Невозможно создать новую категорию. Превышено максимальное количество категорий на одном уровне.'
                }
              }
            });
          } else{
            errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
          }
          return deferred.reject();
        })
      }
    };


    vm.info = function (total) {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/info-popup.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.class = "info";
          $scope.reqAttrButton = true;
          $scope.mainTxt = "Вы создали новый обязательный атрибут.";
          $scope.descrTxt = 'После сохранения изменений в категории ' + total + '&nbsp;товаров и услуг получат статус "Черновик". В статусе "Черновик" товар или услуга недоступны для продажи и по ним нельзя сформировать ни один документ.<br>Продолжить сохранение?';
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.save = function () {
            vm.issetReqAttr = false;
            $uibModalInstance.close();
            vm.save(true);
          };
        }
      })
    }

    vm.refresh = function(searchString) {
      categoryService.getProductGroup(searchString)
        .then(function (res) {
          vm.productGroups = res;
        });
    }

    vm.setDirty = function() {
      vm.isSetDirty = true;
      angular.forEach($scope.addCategory.$error, function(controls, errorName) {
        if(controls[0]) $anchorScroll(controls[0].$name + "Anchor");
        angular.forEach(controls, function(control) {
          control.$setDirty();
        });
      });
      return $q.when();
    }

    vm.mode = {
      isEdit: vm.state.current.name.endsWith('edit'),
      isNew: vm.state.current.name.endsWith('new')
    }

    vm.crud = function (status) {
      switch(status) {
        case 'save':
          if (!$scope.addCategory.$valid || vm.wrongData) {
            return vm.setDirty();
          } else {
            return vm.save();
          }
        case 'delete':
          return vm.delete();
        case 'return':
          vm.returnToPage();
          return $q.when();
        default :
          return $q.when();
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('categoryService', categoryService);

  function categoryService($http, API_URL) {

    this.categories = function (classifier_id, paging, filter) {
      paging = paging || {};
      return $http.get(API_URL + "/catalog/categories", {
        params: {
          limit: paging.limit,
          offset: paging.offset,
          sort_by: paging.sortBy,
          sort_order: paging.sortDirection,
          filter_name: filter.filter_name || undefined,
          filter_start_date: filter.filter_start_date ? filter.filter_start_date.getTime(): undefined,
          filter_end_date: filter.filter_end_date ? filter.filter_end_date.getTime(): undefined,
          filter_active: filter.filter_active ? filter.filter_active.value : undefined,
          filter_root: !filter.filter_root|| undefined,
          filter_ext_id: filter.filter_ext_id || undefined,
          filter_parent_id: filter.filter_parent_id
        }
      });
    }

    /* Запрос метаданынх категориии */
    this.categoryMetadata = function(category_id) {
      return $http.get(API_URL + "/catalog/meta/category", {
        params: {
          category_id : category_id
        }
      });
    }

    /* Получение детальной информации о категории классификатора участника */
    this.getCustomCategory = function(category_id) {
      return $http.get(API_URL + "/catalog/domain/categories/" + category_id);
    }

    /* Запрос категорий домена для дерева (один уровень) */
    this.getDomainCategories = function(parent_id, filters) {
      return $http.get(API_URL + "/catalog/domain/categories", {
        params: {
          parent_id: parent_id,
          filter_status: filters
        }
      });
    }

    /* Иерархия категорий */
    this.categoryHierarchy = function(category_id) {
      return $http.get(API_URL + "/catalog/domain/categories/" + category_id + "/hierarchy");
    }

    /* Запрос товаров и услуг категории */
    this.getDomainCategoryItems = function(parent_id, filters, page) {
      var param = {
        params: {
          filter_status: filters,
          offset: page && page.offset ? page.offset : 0,
          limit: page && page.limit ? page.limit : 100
        }
      };
      return $http.get(API_URL + "/catalog/domain/categories/" + parent_id + "/items", param);
    }

    /* Запрос товаров и услуг категории с ценами */
    this.getItemsWithPrice = function(category_id, filters, page) {
      var param = {
        params: {
          filter_divisions_id: filters && filters.filter_divisions_id? filters.filter_divisions_id : undefined,
          filter_time_zone: filters && filters.time_zone? filters.time_zone : "UTC",
          filter_column_type:  filters && filters.filter_column_type? filters.filter_column_type : undefined,
          offset: page && page.offset ? page.offset : 0,
          limit: page && page.limit ? page.limit : 100,
          filter_status: filters && filters.filter_status? filters.filter_status : undefined
        }
      };
      return $http.get(API_URL + "/catalog/domain/categories/" + category_id + "/items_with_price", param);
    }

    /* Запрос категорий единого каталога */
    this.getCategories = function(search_str) {
      return $http.get(API_URL + "/catalog/categories/auto", {
        params: {
          search_string: search_str
        }
      });
    }

    /* Автокомплит списка категорий домена */
    this.getCategoriesAuto = function(search_str, limit) {
      return $http.get(API_URL + "/catalog/domain/categories/auto", {
        params: {
          search_string: search_str || undefined,
          limit: limit
        }
      });
    }

    /* Запрос категории единого каталога со всем содержимым (атрибуты, блоки) */
    this.getCategory = function(category_id) {
      return $http.get(API_URL + "/catalog/categories/" + category_id);
    }

    /* Создание новой категории */
    this.saveCategory = function(category) {
      return $http.post(API_URL + "/catalog/domain/categories", category);
    }
    /* Обновление категории */
    this.updateCategory = function(category, update_items_register_type) {
      var params = {};
      if (update_items_register_type) {
        params.update_items_register_type = update_items_register_type;
      }
      return $http.put(API_URL + "/catalog/domain/categories/" + category.id, category, {params: params});
    }
    /* Удаление категории */
    this.deleteCategory = function(category_id, check_cashregister_sync) {
      var params = {};
      if (check_cashregister_sync) {
        params.check_cashregister_sync = check_cashregister_sync;
      }
      return $http.delete(API_URL + "/catalog/domain/categories/" + category_id, {params: params});
    }

    /**
     * Метод получения предметов рассчета по умолчанию
     */
    this.cashRegisterItemTypes = function () {
      return $http.get('assets/api/cashRegisterItemTypes.json');
    };

    this.getDomainCategoryEstimateRequired = function(category_id) {
      return $http.get(API_URL + '/catalog/domain/categories/' + category_id + '/estimate_required')
    }

    this.getProductGroup = function (searchString) {
      return $http.get(API_URL + '/catalog/product_groups/auto', {
        params: {
          search_string: searchString,
          limit: 100
        }
      }).then(function (res) {
        return res.data.items;
      });
    }

    this.getScanMarkTypes = function () {
      return {
        ALWAYS: "Всегда",
        CASHIER_DECISION: "На усмотрение кассира",
        PERMISSIVE_MODE: "Разрешительный режим"
      }
    }

  }

})();

(function () {
  'use strict';

	angular.module('frontend').service('nomenclatureService', nomenclatureService);

  /**
   * Сервис соержит вспомогательные функции для работы с номенклатурой (деривативами)
   */
  function nomenclatureService() {

    var me = this;
    //arrays - массив массивов с комбинациями
    this.combinations = function(arrays, i) {
      if (!arrays[i]) {
        return [];
      }
      if (i === arrays.length - 1) {
        return _.map(arrays[i], function (v) {
          return [v]; // Константные значения оборачиваются в массив
        });
      }
      var tmp = me.combinations(arrays, i + 1);
      var result = [];
      angular.forEach(arrays[i], function(v, keyV){
        angular.forEach(tmp, function(t){
          if(Array.isArray(t)){
            if(keyV){
              var arr = angular.copy(t);
              arr[0] = v;
              result.push(arr);
            }else{
              t.unshift(v);
              result.push(t);
            }
          }else{
            result.push([v,t]);
          }
        });
      });
      return result;
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('catalogSkusSearchController', catalogSkusSearchController);

  function catalogSkusSearchController($state, $scope, cardHistory, $rootScope, catalogItemService) {
    var vm = this;

    // Поиск по-умолчанию по имени
    vm.searchActive = 'GTIN'

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if (prev) {
        $state.go(prev.name || 'catalog', prev.param || {parent: $state.params.parent});
      } else {
        $state.go('catalog', {parent: $state.params.parent});
      }
    }

    /* Поиск товара или услуги в едином каталоге */
    vm.search = function(){
      var searchStr;
      var filterGtin;
      if (vm.searchActive === 'NAME') {
        searchStr = vm.searchItemName;
      } else {
        filterGtin = vm.searchGtinName;
      }
      if(searchStr || filterGtin){
        vm.showLoader = true;
        vm.showSeach = false;
        catalogItemService.getElements(searchStr, filterGtin).then(function(res){
          vm.showLoader = false;
          vm.showSeach = true;
          vm.searchTotal = res.data.total;
          vm.searchElements = res.data.items;
          if(!vm.searchElements.length) vm.searchActive = 'NAME';
        });
      }else{
        vm.showSeach = false;
        vm.searchTotal = 0;
        vm.searchElements = [];
      }
    }

    $scope.$watchGroup(['vm.searchItemName', 'vm.searchGtinName'], function(newVal, oldVal) {
      if (oldVal[0] && !newVal[0] || oldVal[1] && !newVal[1]) { // Если не пустое значение меняется на пустое (в широком смысле)
        vm.search();
      }
    });

  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('catalogSkusController', catalogSkusController);

  function catalogSkusController($scope,
    $state,
    $stateParams,
    $filter,
    $uibModal,
    $window,
    errorMessageService,
    nomenclatureService,
    catalogService,
    categoryService,
    cardHistory,
    catalogItemService,
    settings,
    element,
    packTypes,
    searchItem, // Элемент, найденный при поиске
    taxGroups,
    taxModes,
    $timeout,
    focus,
    uoms,
    priceSettingsService,
    priceLocalSrv,
    priceListSrv,
    priceColumnSrv,
    $anchorScroll,
    utilsService,
    radioTaxModeSource,
    cashRegisterItemTypes,
    $rootScope,
    userSettingsService,
    requestStatus,
    cashRegisterTypesByProductGroup,
    projectsService) {
    var vm = this;
    vm.packTypes = angular.copy(packTypes); // типы упаковок
    vm.taxGroups = taxGroups; // справочник видов налогообложения
    // справочник режимов налогообложения чека
    vm.taxMode = taxModes.items; // справочник режимов налогообложения чека
    vm.settings = settings; // Настройки, информация о флагах, информация об элементах упаковки
    vm.state = $state;
    vm.stateName = $state.current.name;
    vm.treeCollapsed = true; // Дерево свернуто по-умолчанию
    vm.isWrongValid = true; // флаг - все ли обязательные поля заполнены
    vm.packRequred = true; // флаг заполнености обязательных поле й упаковках
    vm.allNomenclatureCounter = 0; // Инициализация общего счетчика дериватив
    vm.hasError = [];
    vm.widget = [];
    vm.taxModeList = taxModes; // справочник режимов налогообложения чека

    // нужна сохраненная информация по штуке и по литру
    if (!vm.thing) {
      vm.thing = _.find(uoms, function (uom) {
        return uom.name == 'Штука';
      })
    }
    if (!vm.liter) {
      vm.liter = _.find(uoms, function (uom) {
        return uom.name == 'Литр';
      })
    }

    /* callback для открытия попапа цен позиции */
    vm.showPricePopup = function () {
      var modal = $uibModal.open({
        templateUrl: 'app/price-list/modal/price.modal.html',
        size: 'large-width',
        resolve: {
          catalog_item: function () {
            return vm.catalogSkus;
          },
          node: function () {
            return priceListSrv.getLineByItem('RETAIL', vm.catalogSkus.id).then(function (data) {
              return data;
            });
          },
          prices: function () {
            return priceListSrv.getLineByItem('RETAIL', vm.catalogSkus.id).then(function (data) {
              if (!data) return 'no_prices';
              angular.forEach(data.prices, function (price) {
                price.calculated_automatically_price_for_one_uom = price.calculated_automatically_price_for_one_uom ? (+price.calculated_automatically_price_for_one_uom).toFixed(2) : price.calculated_automatically_price_for_one_uom;
                price.price_for_one_uom = price.price_for_one_uom ? (+price.price_for_one_uom).toFixed(2) : price.price_for_one_uom;
                price.effective_date = price.effective_date ? new Date(price.effective_date) : price.effective_date;
              });
              return priceLocalSrv.priceByItem(data, 'RETAIL'); // true - загрузка тольок локальных цен
            });
          },
          columns: function () {
            return priceColumnSrv.priceColumns('RETAIL') // TODO: поправить
              .then(function (data) {
                _.forEach(data, function (column) {
                  column.flex = 1;
                });
                return { data: priceSettingsService.getColumnWithPriority('RETAIL', data) };
              });
          },
          lock: true,
          column_id: false,
          price_list_type: function () {
            return 'RETAIL';
          },
          from_cell: false,
          updateTree: null
        },
        controller: 'priceModalController',
        controllerAs: 'priceModalCtrl',
        bindToController: true
      });

      // обновление данных из стораджа в любом случае
      modal.result.finally(function () {
        // Обновление флага
        priceListCtrl.notEmptyChanges = priceLocalSrv.hasLocalChanges('RETAIL');
        // обновление информации цены ячейки
        priceLocalSrv.priceByItem(node, 'RETAIL').then(function (price) {
          // связывание цены с товаром или услугой
          node.price = price;
        });
      });
    };

    vm.accountingTypes = [
      {
        name: 'Обычный',
        val: 'SIMPLE'
      },
      {
        name: 'По партиям (LIFO)',
        val: 'BY_LOTS_LIFO'
      },
      {
        name: 'По партиям (FIFO)',
        val: 'BY_LOTS_FIFO'
      },
      {
        name: 'По партиям (FEFO)',
        val: 'BY_LOTS_FEFO'
      },
      {
        name: 'По серийным номерам',
        val: 'BY_SERIAL_NUMBERS'
      }
    ];

    // Узлы дерева
    vm.root = {
      name: 'Товары и услуги',
      root: true,
      has_children: true,
      children: []
    };

    vm.radioTaxGroupSelectors = [
      {
        value: 'OWN',
        label: 'Собственный'
      },
      {
        value: 'COMMITTENT',
        label: 'Комитента'
      },
      {
        value: 'OWN_AND_COMMITTENT',
        label: 'Собственный и комитента'
      }
    ];


    /**
     * Открывает налог перемещения товара
     */
    vm.showMoveDialog = function () {
      catalogItemService.openMoveCategoryDialog()
        .result.then(function (selectedNode) {
          if (!selectedNode || !selectedNode.id)
            return;
          var obj = {
            new_parent: selectedNode.id,
            childrens: [element.id]
          };
          catalogService.moveCatalogItems(obj).then(function (res) {
            $state.go('catalogSkus.edit', {
              elementId: element.id,
              categoryId: selectedNode.id,
              parent: $state.params.parent
            });
            $timeout(function () { // для показа статуса после reload
              requestStatus.success("Выбранные позиции перемещены в категорию " + selectedNode.name, 'move');
            }, 1000);
          },
            function () {
              requestStatus.error('Во время перемещения произошла ошибка. Повторите попытку позже');
            });
        });
    };

    vm.radioTaxModeSource = radioTaxModeSource;
    vm.cashRegisterItemTypes = cashRegisterItemTypes;

    vm.taxModeSourceChanged = function (value) {
      if (value === 'FROM_CATALOG_ITEM' && (!vm.catalogSkus.tax_mode || vm.catalogSkus.tax_mode === 'NONE')) {
        vm.catalogSkus.tax_mode = vm.taxModeList[0];
      }
    };

    vm.openInventoryTagPrintModal = function () {
      $uibModal.open({
        size: 'small-width',
        component: 'printInventoryTags',
        controllerAs: '$ctrl',
        resolve: {
          type: function () {
            return 'byItem'
          },
          catalogItem: function () {
            return vm.catalogSkus
          },
          params: function () {
            return [vm.catalogSkus.id]
          }
        }
      });
    };

    // Создание упрощенной иерархии дерева
    if ($state.params.categoryId) {
      categoryService.categoryHierarchy($state.params.categoryId).then(function (data) {
        if (data.data && data.data.levels) {
          vm.currentCategory = data.data.levels[data.data.levels.length - 1]; // текущую категорию сохраним отдельно
          vm.currentCategory.has_children = false;
          // Создание структуры для простого отображения в дереве, без подзагрузки
          var curNode = vm.root;
          angular.forEach(data.data.levels, function (level) {
            level.expand = true;
            level.loaded = true;
            curNode.children = [level];
            curNode = level;
          });
        }
      });
    }

    // для возврата на предыдущую страницу
    vm.returnToPage = function () {
      var prev = cardHistory.popStep('elementId', $stateParams.elementId) || { name: 'catalog', param: {} };
      $state.go(prev.name !== '' ? prev.name : 'catalog', prev.param || { parent: $state.params.parent });
    };

    if (!vm.packTypes || !vm.packTypes.length) {
      errorMessageService.showModal({
        message: 'Справочник типов упаковок не был загружен или пуст ',
        submessage: 'Обратитесь в поддержку'
      });
    } else {
      // Поиск базовой упаковки
      vm.basePack = _.find(vm.packTypes, function (type) {
        return type.ext_id === 'PACK_BASE_UNIT';
      });
      // Поиск базовой оптовой (групповой) упаковки
      vm.baseGroupPack = _.find(vm.packTypes, function (type) {
        return type.ext_id === 'PACK_GROUP_UNIT';
      });
      if (!vm.basePack) {
        vm.basePack = vm.packTypes[0]; // Если единичной упаковки нет, используем первую
      }
      // удалена из списка типов упаковки единичная, т.к. она может быть всего одна
      vm.packTypes.splice(_.findIndex(vm.packTypes, vm.basePack), 1);
    }

    // проверка валидности формы и блокировка кнопки
    vm.checkValidForm = function () {
      vm.isWrongValid = !vm.catalogSkus.name;
      vm.skuErrorIndex = undefined;
      if ((vm.addCatalogSkus.name && vm.addCatalogSkus.name.$invalid) ||
        (vm.addCatalogSkus.derivative_code_prefix && vm.addCatalogSkus.derivative_code_prefix.$invalid)) {
        vm.isWrongValid = true;
      } else {
        vm.packRequred = true;
        angular.forEach(vm.catalogSkus.sku_list, function (sku, key) {
          if (!vm.addCatalogSkus['sku' + key]) return;
          if (vm.addCatalogSkus['sku' + key]['uom'].$invalid || vm.addCatalogSkus['sku' + key]['name'].$invalid) {
            vm.isWrongValid = true;
          }
          if (sku.pack_type.ext_id && sku.pack_type.ext_id !== 'PACK_BASE_UNIT' &&
            (!sku.constituent_multiplier || !sku.$$constituent || !sku.$$constituent.name)) {
            vm.isWrongValid = true;
          }
          if (!sku.name || (sku.pack_type.ext_id !== 'PACK_BASE_UNIT' && !sku.constituent_multiplier)) {
            vm.packRequred = false;
          }
          vm.isWrongValid = vm.isWrongValid || !!_.find(sku.$$gtin_list, function (gtin, key2) {
            return vm.addCatalogSkus['sku' + key]['gtin_' + key2].$invalid &&
              vm.addCatalogSkus['sku' + key]['gtin_' + key2].$viewValue;
          });
          if (sku.$$gtinErrors && sku.$$gtinErrors.length) {
            vm.isWrongValid = true;
          }
          angular.forEach(sku.$$gtin_list, function (val, key) {
            if (val.$$error) vm.isWrongValid = true;
          });
          if (vm.isWrongValid) vm.skuErrorIndex = key;
        });
      }
    };

    // проверка уникальности штрихкодов в рамках одной упаковки
    vm.checkGtin = function (sku) {
      if (sku.$$gtin_list && sku.$$gtin_list.length > 1) {
        sku.$$gtinErrors = [];
        angular.forEach(sku.$$gtin_list, function (val1, key1) {
          angular.forEach(sku.$$gtin_list, function (val2, key2) {
            if (val1.gtin && val2.gtin && key1 < key2 && val1.gtin === val2.gtin) {
              if (sku.$$gtinErrors.indexOf(key1) === -1) sku.$$gtinErrors.push(key1);
              if (sku.$$gtinErrors.indexOf(key2) === -1) sku.$$gtinErrors.push(key2);
            }
          });
        });
      }
    };

    // событие при загрузке всего дерева странички
    $scope.$on('$viewContentLoaded', function (event) {
      $timeout(function () {
        $anchorScroll();
        /* для странички просмотра убрать пустые блоки атрибутов упаковки */
        angular.forEach(vm.catalogSkus.sku_list, function (sku) {
          // объект с id блока и флагом isEmpty
          sku.$$blockFlags = {};
          if (vm.stateName.endsWith('view')) {
            angular.forEach(vm.settings.elements, function (elem) {
              if (elem.block) {
                sku.$$blockFlags[elem.block.id] = true;
                angular.forEach(elem.block.attributes, function (attr) {
                  if (sku.$$attribValues && sku.$$attribValues[attr.name]) {
                    if (typeof sku.$$attribValues[attr.name].values[0] !== 'object' &&
                      sku.$$attribValues[attr.name].values[0] !== '') {
                      sku.$$blockFlags[elem.block.id] = false;
                    }
                    if (sku.$$attribValues[attr.name].values[0].value &&
                      sku.$$attribValues[attr.name].values[0].value !== '') {
                      sku.$$blockFlags[elem.block.id] = false;
                    }
                  }
                });
              }
            });
          }
        });
        if (!vm.stateName.endsWith('view')) {
          vm.checkValidForm();
        }
        if (element || $stateParams.searchElementId) vm.buildDerivatives();
      }, 500);
    });

    /* Загрузка метаинформации упаковки */
    vm.loadMetaByPack = function (pack_id, pack) {
      var packName = _.find(vm.packTypes, function (item) {
        return item.name === pack.name;
      });
      if (packName) {
        pack.name = pack.pack_type.name; // если пользователь не менял название упаковки, то в имя установить тип выбранной упаковки
        vm.checkPackingName();
        if (vm.buildDerivatives) {
          vm.buildDerivatives();
        }
      }
      catalogService.packingTypeMetadata(pack_id).then(function (data) {
        pack.$$constituent = {};
        pack.$$packMeta = data.data;
        if (pack.pack_type.parent) {
          var packList = $filter('filter')(vm.catalogSkus.sku_list, { pack_type: { id: pack.pack_type.parent.id } });
          vm.searchPackLength = packList.length;
          if (vm.searchPackLength === 1) {
            pack.$$constituent = packList[0];
          }
        }
      });
    };

    /* Метод добавляет gtin в упаковку */
    vm.addGtin = function (pack, noFocus) {
      pack.$$gtin_list.push({});
      if (vm.catalogSkus.sku_list.length && !noFocus) {
        focus.setFocusOnInput('[name="gtin_' + (pack.$$gtin_list.length - 1) + '"]');
      }
    };

    vm.checkPackingName = function () {
      vm.packNameError = [];
      angular.forEach(vm.catalogSkus.sku_list, function (val1, key1) {
        angular.forEach(vm.catalogSkus.sku_list, function (val2, key2) {
          if (key1 < key2 && val1.name === val2.name) {
            if (vm.packNameError.indexOf(key1) === -1) vm.packNameError.push(key1);
            if (vm.packNameError.indexOf(key2) === -1) vm.packNameError.push(key2);
          }
        });
      });
    };

    /* Метод добавляет новую упаковку в список */
    vm.addPack = function (pack_type) {
      var pack = {
        name: (pack_type) ? pack_type.name : vm.basePack.name,
        auto_assemble: true, // автоматически комплектовать
        pack_type: pack_type || vm.basePack, // базовая оптовая единичная по-умолчанию
        $$gtin_list: [], // рабочий массив (не соответствует отправляемому из-за возможного наличия пустых элементов)
        $$attribValues: {}, // рабочий контейнер свойств, на сервер отправляется фильтрованный, атм где есть введенные значения
        uom: { // по умолчанию в упаковке единицы измерения должна быть Штука
          id: vm.thing.id,
          name: vm.thing.name,
          symbols: vm.thing.symbols
        }
      };
      vm.addGtin(pack); // Добавление нового штрих кода (один на форме отображается, хоть и не является обязательным)
      if (!pack_type && $state.params.searchGtinName) {
        pack.$$gtin_list[0] = {
          gtin: $state.params.searchGtinName,
          type: "CUSTOM"
        };
      }
      vm.loadMetaByPack(pack.pack_type.id, pack);
      vm.catalogSkus.sku_list.push(pack);
      $timeout(function () {
        vm.checkValidForm();
        vm.checkPackingName();
        vm.reCalcScroll();
        vm.selectTab(vm.catalogSkus.sku_list.length - 1);
      }, 1500);
      return pack;
    };

    vm.activePack = vm.activePack || 1;
    vm.scrollIntoView = function (arg) {
      if (vm.scrlTabsApi.scrollTabIntoView) {
        vm.scrlTabsApi.scrollTabIntoView();
      }
    };
    vm.selectTab = function (index) {
      vm.activePack = index + 1;
      vm.scrollIntoView();
    };

    vm.initWidgets = function () {
      // виджет цен
      vm.priceWidget = {
        name: 'Цены на ' + moment().utc().tz($rootScope.user.time_zone).format('DD MMMM'),
        component: 'price-widget',
        settingsComponent: 'priceWidget',
        allowRedactMode: $rootScope.hasRole([
          'price_list.write',
          'wholesale_price_list.write',
          'purchase_price_list.write'
        ]),
        options: {
          id: vm.catalogSkus.id,
          pageName: 'catalogSkus'
        },
        visible: vm.stateName.endsWith('view') &&
          vm.catalogSkus.status == 'CONFIRMED' &&
          ($rootScope.hasRole('price_list.read') ||
            $rootScope.hasRole('price_list.write') ||
            $rootScope.hasRole('wholesale_price_list.read') ||
            $rootScope.hasRole('wholesale_price_list.write') ||
            $rootScope.hasRole('purchase_price_list.read') ||
            $rootScope.hasRole('purchase_price_list.write'))
      };
      //виджет остатков
      vm.stockWidget = {
        name: 'ОСТАТКИ на ' + moment().utc().tz($rootScope.user.time_zone).format('DD MMMM'),
        component: 'stock-widget',
        settingsComponent: 'stockWidget',
        allowRedactMode: false,
        options: {
          id: vm.catalogSkus.id,
          pageName: 'catalogSkus'
        },
        visible: vm.stateName.endsWith('view') && $rootScope.hasRole('stock_period_totals.read')
      };

      // инициализация виджетов
      // сделано хранение в сторе последовательности только названий виджетов, т.к. необходима актуальная дата и актуальные доступы
      vm.widgetSequence = userSettingsService.loadProperty("catalogSkus", "widget", "sequence") || [];
      if (!vm.widgetSequence.length) {
        vm.widget = [vm.priceWidget, vm.stockWidget];
        _.forEach(vm.widget, function (widget) {
          vm.widgetSequence.push(widget.settingsComponent);
        });
        userSettingsService.saveProperty("catalogSkus", "widget", "sequence", vm.widgetSequence);
      } else {
        _.forEach(vm.widgetSequence, function (widgetName) {
          vm.widget.push(vm[widgetName]);
        });
      }
    };

    vm.defaultCashRegItemType = function () {
      if (vm.category.cash_register_item_type) return vm.category.cash_register_item_type;

      var productGroup = cashRegisterTypesByProductGroup[vm.category.product_group];
      return productGroup || "GOODS"
    }

    // Инициализация значений основной сущности товарной позиции
    vm.init = function (element, noFocus) {
      vm.hasResult = true;
      vm.nomenclature = [];
      vm.categoryId = $state.params.categoryId || element.category.id;
      vm.attribValues = {};
      /* Кэш значений атрибутов */

      if (element) {
        vm.catalogSkus = element;
        if (!vm.catalogSkus.cash_register_item_type) {
          vm.catalogSkus.cash_register_item_type = vm.defaultCashRegItemType();
        }
        if (!vm.catalogSkus.committent_tax_group) {
          vm.catalogSkus.committent_tax_group = {
            id: '9cda6b93-40c1-4ca3-95d8-0b11d33b7e78',
            name: 'Без НДС'
          };
        }
        angular.forEach(vm.catalogSkus.sku_list, function (pack) {
          if (pack.constituent) { // установка связанной родиетельской упаковки
            pack.$$constituent = _.find(vm.catalogSkus.sku_list, function (item) {
              return item.id === pack.constituent.id;
            })
          }
          // Маппинг типов упаковки
          pack.pack_type = _.find(vm.packTypes, function (dictionaryPack) {
            return dictionaryPack.id === pack.pack_type.id;
          }) || pack.pack_type;
          pack.$$gtin_list = pack.gtin_list.slice(); // копирование списка gtin
          if (!pack.$$gtin_list.length) vm.addGtin(pack, noFocus);
        });

        vm.initWidgets();

      } else {
        vm.catalogSkus = {
          name: $state.params.searchName || $stateParams.name || '',
          tax_group: {
            id: '9cda6b93-40c1-4ca3-95d8-0b11d33b7e78',
            name: 'Без НДС'
          },
          committent_tax_group: {
            id: '9cda6b93-40c1-4ca3-95d8-0b11d33b7e78',
            name: 'Без НДС'
          },
          category: {
            id: $state.params.categoryId
          },
          tax_group_selector: 'OWN',
          stock_accounting_type: 'SIMPLE',
          attribute_values: [],
          sku_list: [],
          tax_mode_source: 'FROM_CASHREGISTER',
          tax_mode: null,
          cash_register_item_type: $stateParams.cashRegisterType || vm.defaultCashRegItemType()
        };

        if (settings.use_auto_codes) {
          catalogService.getCode().then(function (res) {
            vm.catalogSkus.code = res.data.code;
            $timeout(vm.checkValidForm, 0);
          });
        }

        if (searchItem && !element) { // Если создается на основе найденного товара
          vm.catalogSkus.name = searchItem.name;
          vm.catalogSkus.full_desc = searchItem.full_desc;
          vm.catalogSkus.attribute_values = searchItem.attribute_values;

          if (searchItem.brand) {
            vm.catalogSkus.name += (' ' + searchItem.brand);
          }
          if (searchItem.sub_brand) {
            vm.catalogSkus.name += (' ' + searchItem.sub_brand);
          }

          /* Вспомогательая функция маппинга упаковки есдиного каталога на упаковку каталога участника (в создаваемой товарной позиции) */
          var loadPack = function (sku, parent) {
            var pack = vm.addPack(_.find(vm.packTypes, function (pack) {
              return sku.packing_type.id === pack.id;
            }));
            pack.$$gtin_list = sku.gtin_list.slice();
            if (sku.packing_type.ext_id === 'PACK_BASE_UNIT') {
              pack.alt_count = sku.count;
              pack.alt_uom = {
                id: (sku.uom) ? sku.uom.id : vm.thing.id,
                name: (sku.uom) ? sku.uom.name : vm.thing.name,
                symbols: (sku.uom) ? sku.uom.symbols : vm.thing.symbols
              };
            } else {
              pack.constituent_multiplier = sku.count;
              pack.uom = {
                id: (sku.uom) ? sku.uom.id : vm.thing.id,
                name: (sku.uom) ? sku.uom.name : vm.thing.name,
                symbols: (sku.uom) ? sku.uom.symbols : vm.thing.symbols
              };
            }

            // подстановка атрибутов упаковки из единого каталога
            pack.pack_attribute_values = sku.attributeValues;
            pack.$$constituent = parent; // Маппинг родтельской упаковки
            if (sku.children && sku.children.length) {
              angular.forEach(sku.children, function (childSku) {
                loadPack(childSku, pack); // Рекурсиваня загрузка
              })
            }
          };
          // Загрузка иерархии упаковок
          angular.forEach(searchItem.sku_list, function (sku) {
            loadPack(sku, undefined);
          })
        }
      }

      vm.showInventoryTagButton = vm.catalogSkus.sku_list.some(function (value) {
        if (value.gtin_list) {
          return value.gtin_list.length > 0;
        }
        return false;
      });

      vm.getTaxMode = function (mode) {
        var TaxMode = {};
        vm.taxMode.forEach(function (item) {
          if (item.mode == mode) {
            TaxMode = item;
          }
        });
        return TaxMode;
      };

      if (!vm.catalogSkus.sku_list.length) { // Если упаковок нет (при редактировании они есть)
        vm.addPack(); // Добавление новой упаковки (по-умолчанию будет добавлена базовая)
        if ($stateParams.alcoPackedType || $stateParams.capacity || $stateParams.ean13) {
          if ($stateParams.alcoPackedType) {
            vm.catalogSkus.sku_list[0].uom = {
              id: ($stateParams.alcoPackedType == 'PACKED') ? vm.thing.id : vm.liter.id,
              name: ($stateParams.alcoPackedType == 'PACKED') ? vm.thing.name : vm.liter.name,
              symbols: ($stateParams.alcoPackedType == 'PACKED') ? vm.thing.symbols : vm.liter.symbols
            };
          }
          if ($stateParams.capacity) {
            vm.catalogSkus.sku_list[0].alt_count = $stateParams.capacity;
            vm.catalogSkus.sku_list[0].alt_uom = {
              id: vm.liter.id,
              name: vm.liter.name,
              symbols: vm.liter.symbols
            };
          }
          if ($stateParams.ean13) {
            vm.catalogSkus.sku_list[0].$$gtin_list[0] = {
              gtin: $stateParams.ean13,
              type: 'CUSTOM'
            };
          }
        }
      }

      /* Установка значений атрибутов в модель */
      if (vm.catalogSkus) { // Только при редактировании (при создании нечего маппить)
        angular.forEach(vm.catalogSkus.attribute_values, function (attributeValue) {
          delete attributeValue.values;
          if (!vm.attribValues[attributeValue.attribute.name]) vm.attribValues[attributeValue.attribute.name] = attributeValue;
          if (!vm.attribValues[attributeValue.attribute.name].values) vm.attribValues[attributeValue.attribute.name].values = [];
          if (attributeValue.dict_value) {
            vm.attribValues[attributeValue.attribute.name].values.push(attributeValue.dict_value);
          } else {
            vm.attribValues[attributeValue.attribute.name].values.push(attributeValue.value);
          }
        });

        if (!vm.catalogSkus.$$wasInit) {
          // Установка значений в упаковку
          angular.forEach(vm.catalogSkus.sku_list, function (pack) {
            angular.forEach(pack.pack_attribute_values, function (attributeValue) {
              pack.$$attribValues = pack.$$attribValues || {};
              if (!pack.$$attribValues[attributeValue.attribute.name]) pack.$$attribValues[attributeValue.attribute.name] = { attribute: attributeValue.attribute };
              if (!pack.$$attribValues[attributeValue.attribute.name].values) pack.$$attribValues[attributeValue.attribute.name].values = [];
              if (attributeValue.dict_value) {
                pack.$$attribValues[attributeValue.attribute.name].values[0] = attributeValue.dict_value;
              } else {
                pack.$$attribValues[attributeValue.attribute.name].values[0] = attributeValue.value;
              }
            });
            vm.catalogSkus.$$wasInit = true;
            // флаг отсутствия атрибутов вообще
            if (!pack.$$attribValues || _.isEmpty(pack.$$attribValues)) pack.$$noAttr = true;
          });
        }
      }
    };

    // для получения структуры атрибутов из категории
    function getCustomCategory() {
      categoryService.getCustomCategory($state.params.categoryId).then(function (res) {
        vm.category = res.data;

        vm.init(angular.copy(element), true);
        /* для странички просмотра убрать пустые блоки */
        if (vm.stateName.endsWith('view')) {
          angular.forEach(vm.category.elements, function (elem) {
            if (elem.block) {
              elem.block.$$empty = true;
              angular.forEach(elem.block.attributes, function (attr) {
                if (vm.attribValues[attr.name] && vm.attribValues[attr.name].values[0] != '') {
                  elem.block.$$empty = false;
                }
              });
            }
          });
        }
        if (vm.catalogSkus) {
          vm.uniqueCheck(vm.catalogSkus.name, 'name');
          vm.uniqueCheck(vm.catalogSkus.code, 'derivative_code_prefix');
        }
      });
    }

    getCustomCategory();

    /* Автодополнение единиц измерения */
    vm.refreshUoms = function (search) {
      catalogService.getUoms(search).then(function (res) {
        vm.uoms = _.map(res.data, function (uom) {
          return {
            id: uom.id,
            name: uom.name,
            symbols: uom.symbols
          }
        });
      });
    };

    vm.totalUomStr = function () {
      if (vm.uoms.length > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH) {
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + vm.uoms.length;
      }
      return '';
    };

    /* Автодополнение проектов */
    vm.refreshProjects = function (search) {
      projectsService.projectsSearch(search, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH, { filter_active: true }).then(function (res) {
        vm.projects = res.data;
        if (!vm.projectsFullTotal) {
          vm.projectsFullTotal = res.data.total;
        }
      });
    };
    vm.totalSelectStr = function () {
      if (vm.projectsFullTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH) {
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + vm.projectsFullTotal;
      }
      return '';
    };

    /* Удаление SKU из списка */
    vm.deleteSku = function (sku, $event, index) {
      $event.stopPropagation();
      if (index == vm.catalogSkus.sku_list.length - 1) {
        vm.selectTab(1);
        $event.stopPropagation();
      }
      angular.forEach(vm.catalogSkus.sku_list, function (item) {
        if ((item.constituent && item.constituent.name == sku.name) || (item.$$constituent && item.$$constituent.name == sku.name)) {
          item.constituent = item.$$constituent = undefined;
        }
      });
      var i = vm.catalogSkus.sku_list.indexOf(sku);
      if (i > -1) {
        vm.catalogSkus.sku_list.splice(i, 1);
      }
      vm.buildDerivatives();
    };

    /* Метод инициирует код (атрикул) дериватива упаковки */
    function createArticle(sku, skuIndex) {
      if (sku.$$nomenclature) {
        angular.forEach(sku.$$nomenclature, function (values, key) {
          var article = '';
          if (vm.catalogSkus.code) article += (vm.catalogSkus.code + '-');
          article += (skuIndex * sku.$$nomenclature.length + 1) + key; // добавление сквозного порядкового номера между упаковками для деривативы
          angular.forEach(values, function (word) {
            if (word) {
              if (word.value) word = word.value;
              word = (word + "").split(new RegExp(/-| /, 'g')).join("").substring(0, 4);
              if (word) {
                if (article) article += "-";
                article += word;
              }
            }
          });
          values.unshift(article); // Вставка первого элемента (соответствует артикулу)
        });
      }
    }


    vm.deleteOldAttrValue = function (index) {
      vm.catalogSkus.old_attribute_values.splice(index, 1);
    };

    /* Метод инициирует название дериватива упаковки */
    function createDerivativeName(sku) {
      if (sku.$$nomenclature) {
        var names = [];
        angular.forEach(sku.$$nomenclature, function (values, determinatorNum) {
          var name = '';
          angular.forEach(values, function (word, attributeNum) {
            var beginForNameBuild = (vm.catalogSkus.tax_group_selector == "OWN_AND_COMMITTENT") ? (attributeNum > 1) : (attributeNum);
            if (word && word != "com" && beginForNameBuild) {
              if (word.value) word = word.value;
              // добавить разделитель
              if (name) name += ", ";
              // добавить название атрибута + значение атрибута
              if (sku.$$listAttr[attributeNum].name !== 'pack') {
                name += (sku.$$listAttr[attributeNum].name + " " + word);
              }
            }
          });

          // добавить упаковку
          if (sku.pack_type.ext_id != "PACK_BASE_UNIT") {
            if (name) name += ", ";
            name += sku.name;
          }

          // добавить товар комитента
          if (vm.catalogSkus.tax_group_selector == "OWN_AND_COMMITTENT" && values.indexOf("com") + 1) {
            if (name) name += ", ";
            name += 'товар комитента';
          }

          names.push(name);
        });
        sku.$$names = names;
      }
    }

    // для выявления id деривативы
    function findMatch(issetAttrValue, tempDer) {
      var id = '';
      angular.forEach(tempDer, function (der) {
        angular.forEach(der.attribute_values, function (attrValue) {
          if (issetAttrValue.value == attrValue.value && issetAttrValue.attribute.id == attrValue.attribute.id) {
            id = attrValue.id;
          }
        });
      });
      return id;
    }

    // занесение информации о деривативах в объект товара
    function getDerivativeObj(sku, key) {
      var tempSkuDer = angular.copy(sku.derivatives);
      sku.derivatives = [];
      angular.forEach(sku.$$nomenclature, function (attr, key1) {
        var derivative = { attribute_values: [], name: sku.$$names[key1] || null };
        if (tempSkuDer && tempSkuDer[key1]) {
          derivative.id = tempSkuDer[key1].id;
        }
        angular.forEach(attr, function (val, key2) {
          if ((vm.catalogSkus.tax_group_selector === "OWN_AND_COMMITTENT") && sku.$$listAttr[key2].name == 'sku') {
            derivative.committent = !!val;
          }
          if (!key2) {
            derivative.code = val; // код дериватива в нулевом элементе массива
          } else {
            derivative.attribute_values.push({
              attribute: sku.$$listAttr[key2],
              value: val
            });
          }
        });
        sku.derivatives.push(derivative);
      });
      angular.forEach(sku.derivatives, function (der, key1) {
        angular.forEach(der.attribute_values, function (attrValue, key2) {
          var id = findMatch(attrValue, tempSkuDer);
          if (id) {
            attrValue.id = id;
          }
        });
      });
      if (!sku.derivatives) sku.derivatives = [];
      // обязан быть хотя бы один дериватив
      if (sku.derivatives.length == 0) {
        var derivative = {
          code: vm.catalogSkus.code || '_'
        };
        if (tempSkuDer && tempSkuDer[0] && tempSkuDer[0].id) {
          derivative.id = tempSkuDer[0].id
        }
        sku.derivatives.push(derivative);
        if (key) {
          sku.derivatives[0].code += ('-' + key);
        }
      } else if (sku.derivatives.length === 1 && vm.catalogSkus.code === sku.derivatives[0].code) { // после ошибки кода, надо его менять при повторном сохранении
        sku.derivatives[0].code = vm.catalogSkus.code;
        if (key) {
          sku.derivatives[0].code += ('-' + key);
        }
      }
    }

    /* метод строит дериватывы для упаковки */
    vm.buildDerivativesForSku = function (sku, // Упаковка
      listAttr, // Массив атрибутов категории со множественными значениями
      allValuesArr, // Массив значений атрибутов категории
      skuIndex // для сквозного счета количества дериватив и выставления индексов
    ) {
      sku.$$listAttr = listAttr.slice(); // Внутренние массивы создатс на основе внещних, общих для всех упаковок атрибутов категории
      sku.$$allValuesArr = allValuesArr.slice();
      angular.forEach(sku.$$attribValues, function (attr) {
        if (attr.values.length > 1) {
          if (attr.values[0].date) {
            var dateStrArr = [];
            angular.forEach(attr.values, function (val) {
              if (val.value) {
                dateStrArr.push(val.value);
              }
            });
            attr.values = dateStrArr;
          }
          sku.$$listAttr.push(attr.attribute);
          sku.$$allValuesArr.push(attr.values);
        }
      });
      sku.$$nomenclature = nomenclatureService.combinations(sku.$$allValuesArr, 0);
      createArticle(sku, skuIndex); // Добавление артикула по-умолчанию
      createDerivativeName(sku); // Добавление имени дериватива

    };

    /* построить деривативы для всех упаковок товарной позиции */
    vm.buildDerivatives = function () {
      vm.allNomenclatureCounter = 0;
      // Построение списков атрибутов и значений для атриьутов категоии (общие для всех упаковок)
      var temp = angular.copy(vm.attribValues);
      var listAttr = [{ name: 'article' }];
      var allValuesArr = [];
      angular.forEach(temp, function (attr) {
        for (var i = attr.values.length - 1; i >= 0; i--) {
          if (!attr.values[i]) {
            attr.values.splice(i, 1); // TODO: вероятно тут ошибка, и пустое значение, следующее за другим таким пустым, не будет отброшенно
          }
        }
        if (attr.values.length > 1) {
          // преобразование дат
          if (attr.values[0].date) {
            var dateStrArr = [];
            angular.forEach(attr.values, function (val) {
              if (val.value) {
                dateStrArr.push(val.value);
              }
            });
            attr.values = dateStrArr;
          }
          listAttr.push(attr.attribute);
          allValuesArr.push(attr.values);
        }
      });
      vm.hideDeterminate = allValuesArr.length > 2;
      angular.forEach(vm.catalogSkus.sku_list, function (sku, key) {
        // Учитывать собственные и комиссионные товары раздельно
        if (vm.catalogSkus.tax_group_selector == "OWN_AND_COMMITTENT" && !key) {
          listAttr.splice(1, 0, { name: 'sku' });
          allValuesArr.unshift(["", "com"]);
        }
        // для добавления деривативы с упаковками
        if (vm.catalogSkus.sku_list.length > 1) {
          if (!key) {
            listAttr.splice(1, 0, { name: 'pack' });
            allValuesArr.unshift([sku.name]);
          } else {
            allValuesArr[0] = [sku.name];
          }
        }
        vm.buildDerivativesForSku(sku, listAttr, allValuesArr, key);
        vm.allNomenclatureCounter += sku.$$nomenclature.length;
      });

      vm.catalogSkus.tax_group = vm.catalogSkus.tax_group || vm.taxGroups[0];
      vm.catalogSkus.committent_tax_group = vm.catalogSkus.committent_tax_group || vm.taxGroups[0];
    };

    // для подстановки необходимого id в атрибут
    function findMatchAttr(attrValue, tempAttrs) {
      var id = '';
      angular.forEach(tempAttrs, function (attr) {
        if (attrValue.value == attr.value && attrValue.attribute.id == attr.attribute.id) {
          id = attr.id;
        }
      });
      return id;
    }

    /* Метод формирует отправляемую на сервер структуру данны атрибутов */
    function getAttrValues() {
      var tempAttrs = angular.copy(vm.catalogSkus.attribute_values);
      // занести информмацию о значения атрибутов в объект позиции
      vm.catalogSkus.attribute_values = [];
      angular.forEach(vm.attribValues, function (attr) {
        angular.forEach(attr.values, function (val, key) {
          var newAttr = {}, id, issetItem;
          if (val) {
            if (val.date) {
              val = val.value ? val.date.valueOf() : null;
            } else if (val.value && val.id) {
              val = val.id;
            }
            if (val && typeof val !== 'object') {
              newAttr.value = val;
              newAttr.attribute = attr.attribute;
              id = findMatchAttr(newAttr, tempAttrs);
              if (id) {
                newAttr.id = id;
              }
              if (attr.attribute.data_type !== 'BOOLEAN') {
                vm.catalogSkus.attribute_values.push(newAttr);
              }
            }
          }

          if (attr.attribute.data_type === 'BOOLEAN') {
            issetItem = _.find(vm.catalogSkus.attribute_values, function (item) {
              return item.attribute.id == attr.attribute.id;
            });
            if (!issetItem && val !== '' && val !== null) {
              newAttr.value = (val === 'true') ? true : false;
              newAttr.attribute = attr.attribute;
              id = findMatchAttr(newAttr, tempAttrs);
              if (id) {
                newAttr.id = id;
              }
              vm.catalogSkus.attribute_values.push(newAttr);
            }
          }
        });
      });
      // занести информмацию о значения атрибутов в упаковки
      angular.forEach(vm.catalogSkus.sku_list, function (sku) {
        sku.pack_attribute_values = []; // Сброс атрибутов упаковки
        angular.forEach(sku.$$attribValues, function (attr) {
          if (attr.attribute.data_type == "BOOLEAN" && attr.values[0] === false) {
            sku.pack_attribute_values.push({
              attribute: attr.attribute,
              value: "false"
            });
          } else {
            angular.forEach(attr.values, function (val) {
              if (val) {
                if (val.date) {
                  val = val.value ? val.date.valueOf() : null;
                } else if (val.value && val.id) {
                  val = val.id;
                }
                if (val && typeof val !== 'object') {
                  sku.pack_attribute_values.push({
                    attribute: attr.attribute,
                    value: val
                  });
                }
              }
            });
          }
        });
      })
    }

    /* Метод обновляет тип у gtin-ов */
    vm.updateType = function () {
      angular.forEach(vm.catalogSkus.sku_list, function (pack) {
        // Очистка не заполенных gtin
        pack.gtin_list = _.filter(pack.$$gtin_list, function (gtin) {
          return !!gtin.gtin;
        });
      })
    };

    /* Информация о статусе черновик */
    vm.draftPopupInfo = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/draft-popup.html',
        size: '',
        controller: function ($scope, $uibModalInstance) {
          $scope.isCreate = false;
          $scope.isGoods = true;
          $scope.class = "info";
          $scope.isEdit = vm.stateName.endsWith('edit');
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.goToEdit = function () {
            $uibModalInstance.dismiss();
            $state.go('catalogSkus.edit', { elementId: vm.catalogSkus.id, parent: $state.params.parent });
          }
        }
      });
    };

    /* показать информация о том что товар будет сохранен как черновик */
    vm.showDraftMess = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/draft-popup.html',
        size: '',
        controller: function ($scope, $uibModalInstance) {
          $scope.isCreate = true;
          $scope.class = "info";
          $scope.isGoods = true;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.save = function () {
            $uibModalInstance.dismiss();
            vm.shownDraftMess = true;
            vm.save();
          };
        }
      });
    };

    function setGtinError(errorGtin, checkFormat) {
      angular.forEach(vm.catalogSkus.sku_list, function (sku, key) {
        angular.forEach(sku.$$gtin_list, function (gtin) {
          if (gtin.gtin && gtin.gtin == errorGtin) {
            vm.selectTab(key);
            if (checkFormat) {
              gtin.$$formatError = true;
            } else {
              gtin.$$error = true;
            }
            $anchorScroll("packingAnchor");
          }
        });
      });
    }


    // отправка пользователя перессматривать штрих-код,
    // пример wrongData 'skuList[0].gtinDetailList[0]'
    vm.goToWrongGtin = function (wrongData) {
      var errorIndexes = wrongData.split(/skuList\[|].gtinDetailList\[|]/);
      setGtinError(vm.catalogSkus.sku_list[errorIndexes[1]].$$gtin_list[errorIndexes[2]].gtin, true);
    };

    // проверка на ошибки обязательных атрибутов.
    // если какой-то из атрибутов не заполнен, то это не должно блокировать сохранение формы полностью
    // должен вызываться попап подтверждения сохранения Черновика
    vm.hasRequiredAttributeError = function () {
      // у полей атрибутов нет атрибутов name, поэтому их выслеживаем по отсутствию имени
      return _.find(vm.addCatalogSkus.$error.required, function (error) {
        if (!Array.isArray(error.$error.required) && !error.$name) {
          return true;
        } else if (Array.isArray(error.$error.required)) {
          return _.find(error.$error.required, function (errorPackAttr) {
            return !errorPackAttr.$name;
          });
        }
        return false;
      });
    };

    /* Сохранение или обновление товарной позиции */
    vm.save = function () {
      // для показа попапа черновика еще необходима проверка на наличие ошибки "requiredAttribute"
      // она выставляется если не заполнен обязательный датапикер, у него пустота определяется поле isEmpty
      var errors = Object.keys(vm.addCatalogSkus.$error);
      if ((vm.hasRequiredAttributeError() || errors.includes('requiredAttribute')) && !vm.shownDraftMess && vm.catalogSkus.status != 'ARCHIVED') {
        vm.showDraftMess();
        return;
      }
      var tempCatalogSkus = angular.copy(vm.catalogSkus);
      vm.findProduct = true;
      vm.updateType(); // обновление типов gtin-ов (штрих кодов)
      if (vm.catalogSkus.tax_group) {
        vm.catalogSkus.tax_group = {
          id: vm.catalogSkus.tax_group.id,
          name: vm.catalogSkus.tax_group.name
        };
        // Сброс, если тип реализации не предполагает такого налога
        if (vm.catalogSkus.tax_group_selector == 'COMMITTENT') {
          vm.catalogSkus.tax_group = undefined;
        }
      }
      if (vm.catalogSkus.committent_tax_group) {
        vm.catalogSkus.committent_tax_group = {
          id: vm.catalogSkus.committent_tax_group.id,
          name: vm.catalogSkus.committent_tax_group.name
        };
        // Сброс, если тип реализации не предполагает такого налога
        if (vm.catalogSkus.tax_group_selector == 'OWN') {
          vm.catalogSkus.committent_tax_group = undefined;
        }
      }

      vm.catalogSkus.tax_mode = vm.catalogSkus.tax_mode && vm.catalogSkus.tax_mode !== 'NONE' ? vm.catalogSkus.tax_mode : null;

      angular.forEach(vm.catalogSkus.sku_list, function (sku, key) {
        // Обрезка связанных упаковок для бека (полную сущность бек не воспримет)
        if (sku.$$constituent && !_.isEmpty(sku.$$constituent)) {
          sku.constituent = {
            id: sku.$$constituent.id,
            name: sku.$$constituent.name
          }
        }
        getDerivativeObj(sku, key); // построение деривативов для упаковки
        angular.forEach(sku.derivatives, function (derivative) {
          if (vm.catalogSkus.tax_group_selector === 'COMMITTENT') {
            derivative.committent = true;
          } else if (vm.catalogSkus.tax_group_selector === 'OWN') {
            derivative.committent = false;
          }
        });

      });
      // Формирование модели атрибутов для отправки на бек (вспомогательные структуры содержат лишние пустые значения, к примеру)
      getAttrValues();

      // запись id списков выбора в дериватив
      angular.forEach(vm.catalogSkus.sku_list, function (sku) {
        if (sku.alt_count) sku.alt_count = (sku.alt_count + "").replace(/,/g, '.');
        angular.forEach(sku.derivatives, function (der) {
          var tempDer = [];
          angular.forEach(der.attribute_values, function (attr) {
            if (attr.value.id) attr.value = attr.value.id;
            if (attr.attribute.name !== 'sku' && attr.attribute.name !== 'pack') {
              tempDer.push(attr);
            }
          });
          if (tempDer.length) {
            der.attribute_values = tempDer;
          } else {
            delete der.attribute_values;
          }
        });

        angular.forEach(sku.pack_attribute_values, function (attr) {
          if (attr.value.id) attr.value = attr.value.id;
        });

      });
      // Сохранение или обновление товарной позиции
      if (vm.catalogSkus.id) {
        catalogItemService.updateSkus(vm.catalogSkus).then(function (res) {
          vm.addCatalogSkus.$setPristine();
          if ($stateParams.closeTab) {
            $window.close();
          }
          vm.returnToPage();
        }, function (error) {
          if (error.status == 409 && error.data && error.data.code == 'non_unique') {
            if (error.data.constraint_name == 'DOMAIN_CATALOG_ITEM_GTIN') {
              setGtinError(error.data.parameters[0].value);
            } else if (error.data.constraint_name == "DOMAIN_SKU_DERIVATIVE") {
              errorMessageService.showModal({
                message: 'Код складской позиции уже существует "' + error.data.parameters[0].value + '"',
                submessage: error.data.parameters[0].value
              });
            } else {
              vm.addCatalogSkus[error.data.parameters[0].name].$setValidity('unique', false);
              $anchorScroll(error.data.parameters[0].name + "Anchor");
            }
          } else if (error.status == 409 && error.data && error.data.code == 'in_use') {
            vm.addCatalogSkus['derivative_code_prefix'].$setValidity('unique', false);
            $anchorScroll("derivative_code_prefixAnchor");
          } else if (error.status == 409 && error.data && error.data.code == 'business_rule' && error.data.rule == 'DOMAIN_CATALOG_ITEM_GTIN') {
            setGtinError(error.data.object_name);
          } else if (error.status == 400 && error.data && error.data.message === 'impossible_to_modify_there_are_documents') {
            $uibModal.open({
              templateUrl: 'app/settings/templates/modals/info.html',
              size: 'small-width',
              controller: function ($scope, $uibModalInstance) {
                $scope.title = 'Невозможно сохранить';
                $scope.text = "Изменение невозможно, так как по данному товару были созданы документы";
                $scope.close = function () {
                  $uibModalInstance.dismiss();
                };
              }
            });
          } else if (error.status === 400) {
            if (_.find(error.data.fields, { error: 'serial_number_only_one_sku' })) {
              errorMessageService.showModal({
                message: 'При обновлении произошла ошибка',
                submessage: { data: { message: 'Товар со складским учетом по серийным номерам может иметь только одну упаковку' } }
              });
            } else if (_.find(error.data.fields, { field: 'stock_accounting_type' }) || error.data.message === 'impossible_to_modify_there_are_documents') {
              errorMessageService.showModal({
                message: 'При обновлении произошла ошибка',
                submessage: { data: { message: 'Изменение невозможно, так как по данному товару созданы документы' } }
              });
            } else if (error.data.fields[0].error.indexOf('Invalid GTIN value') + 1) {
              vm.goToWrongGtin(error.data.fields[0].field);
            } else {
              errorMessageService.showModal({ message: 'При обновлении произошла ошибка', submessage: error });
            }
          } else {
            errorMessageService.showModal({ message: 'При обновлении произошла ошибка', submessage: error });
          }
          vm.init(vm.catalogSkus, true);
        });
      } else {
        catalogItemService.createSkus(vm.catalogSkus).then(function (res) {
          vm.addCatalogSkus.$setPristine();
          if ($stateParams.closeTab) {
            $window.close();
          }
          vm.returnToPage();
        }, function (error) {
          vm.selectTab(1);
          if (error.status === 409) {
            if (error.data.code === 'non_unique') {
              if (error.data.constraint_name === 'DOMAIN_CATALOG_ITEM_GTIN') {
                setGtinError(error.data.parameters[0].value);
              } else if (error.data.constraint_name === "DOMAIN_SKU_DERIVATIVE") {
                errorMessageService.showModal({
                  message: 'Код складской позиции уже существует "' + error.data.parameters[0].value + '"',
                  submessage: error.data.parameters[0].value
                });
              } else {
                vm.addCatalogSkus[error.data.parameters[0].name].$setValidity('unique', false);
                $anchorScroll(error.data.parameters[0].name + "Anchor");
              }
            } else if (error.data.code === 'in_use') {
              vm.addCatalogSkus['derivative_code_prefix'].$setValidity('unique', false);
              $anchorScroll("derivative_code_prefixAnchor");
            } else if (error.data.code === 'business_rule' && error.data.rule === 'DOMAIN_CATALOG_ITEM_GTIN') {
              setGtinError(error.data.object_name);
            } else if (error.data.code === 'exceeded_maximum_number_of_catalog_items') {
              errorMessageService.showModal({
                message: 'При сохранении произошла ошибка', submessage: {
                  data: {
                    message: error.data.message
                  }
                }
              });
            }
          } else if (error.status === 400) {
            if (_.find(error.data.fields, { error: 'serial_number_only_one_sku' })) {
              errorMessageService.showModal({
                message: 'При сохранении произошла ошибка',
                submessage: { data: { message: 'Товар со складским учетом по серийным номерам может иметь только одну упаковку' } }
              });
            } else if (error.data.fields[0].error.indexOf('Invalid GTIN value') + 1) {
              vm.goToWrongGtin(error.data.fields[0].field);
            } else {
              errorMessageService.showModal({ message: 'При сохранении произошла ошибка', submessage: error });
            }
          } else {
            errorMessageService.showModal({ message: 'При сохранении произошла ошибка', submessage: error });
          }
          vm.init(vm.catalogSkus, true);
        });
      }
    };

    // Метод, вызываемый при удалении товарной позиции
    vm.delete = function () {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'delete',
        resolve: {
          name: function () {
            return vm.catalogSkus.name;
          },
          checkCashregisterSync: function () {
            return catalogItemService.checkCashregisterSync(vm.catalogSkus.id).then(function (value) {
              return value.data
            })
          }
        },
        controller: function ($scope, $uibModalInstance, name, checkCashregisterSync) {
          var basicCanDeleteText = "Удаление невозможно, так как по данному товару созданы документы";
          $scope.name = name;
          $scope.lock = false;
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'товар';
          $scope.conflictDeleteText = basicCanDeleteText;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          if (checkCashregisterSync && checkCashregisterSync.length) {
            $scope.conflictDeleteText = "Сведения об удаляемой позиции ещё не обновились на следующих кассах:<br><br>";
            angular.forEach(checkCashregisterSync, function (item) {
              angular.forEach(item.cash_registers, function (cash_register) {
                $scope.conflictDeleteText += cash_register.model + " " + cash_register.serial_number + " в подразделении " + item.division.name + '<br>';
              });
            });
            $scope.canDelete = false;
            $scope.forceDelete = false;
          }

          $scope.delete = function () {
            $scope.lock = true;
            catalogItemService.deleteSkus(vm.catalogSkus.id).then(function () {
              $scope.lock = false;
              vm.addCatalogSkus.$setPristine();
              vm.returnToPage();
              $scope.close();
            }, function (error) {
              $scope.lock = false;
              if (error.status === 409) {
                if (error.data.code === 'integrity_violation') {
                  $scope.canDelete = false;
                  $scope.conflictDeleteText = basicCanDeleteText;
                  $scope.forceDelete = false;
                }
              } else {
                errorMessageService.showModal({ message: 'При удалении произошла ошибка', submessage: error });
              }
            });
          };
        }
      });
    };

    vm.printPopup = function () {
      vm.findProduct = true;
      $uibModal.open({
        templateUrl: 'app/catalog/modals/print-popup.html',
        size: '',
        controller: function ($scope, $uibModalInstance) {
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };

        }
      });
    };

    vm.statusPopup = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/status-popup.html',
        size: '',
        controller: function ($scope, $uibModalInstance) {
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    vm.recoveryPopup = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/recovery-popup.html',
        size: 'recovery-popup',
        controller: function ($scope, $uibModalInstance) {
          $scope.catalogItemName = "товара";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    // Попап перечня товаров
    vm.showGoodsLists = function () {
      var save = false;
      $uibModal.open({
        templateUrl: 'app/catalog/modals/goods-list.html',
        size: 'large-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.name = vm.catalogSkus.name;
          $scope.isGoods = true;
          $scope.tempNom = angular.copy(vm.catalogSkus.sku_list);
          $scope.valid = { isvalid: true };
          $scope.isView = vm.stateName.endsWith('view');
          // Создание вкладок по упаковкам
          $scope.packingTabs = _.map(vm.catalogSkus.sku_list, function (sku) {
            return {
              className: sku.pack_type.ext_id,
              title: sku.name || sku.pack_type.name,
              grid: {
                attributes: sku.$$listAttr,
                values: sku.$$nomenclature,
                issetDerivatives: sku.derivatives // для вычисления id при проверке уникальности кода дериватива
              }
            }
          });

          $scope.checkDuplicate = function (code) {
            if (code) {
              var res = 0;
              //$scope.valid.isvalid = true;
              angular.forEach(vm.catalogSkus.sku_list, function (sku) {
                res += _.size(_.filter(sku.$$nomenclature, function (row) {
                  return row[0] == code;
                }));
              });
              if (res > 1) $scope.valid.isvalid = false;
              return res > 1;
            }
            return false;
          };

          $scope.close = function () {
            $uibModalInstance.dismiss();
            vm.buildDerivatives();
          };

          $scope.save = function () {
            if ($scope.nomenclatureForm.$invalid) {
              $scope.isSaved = true;
              return;
            }
            angular.forEach($scope.packingTabs, function (value) {
              getDerivativeObj(value);
            });
            $uibModalInstance.dismiss();
            save = true;
          };
        }
      }).result.finally(function () {
        if (!save) vm.buildDerivatives();
      });
    };

    // Помещение/восстановление позиции в статус архив
    vm.archivePopup = function (isRecover) {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/archive-popup.html',
        size: '',
        controller: function ($scope, $uibModalInstance) {
          $scope.class = "info";
          $scope.isGoods = true;
          $scope.isRecover = isRecover;
          $scope.name = vm.catalogSkus.name;
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.inArchive = function () {
            catalogItemService.changeSkuStatus(vm.catalogSkus.id, "ARCHIVED").then(function (res) {
              vm.catalogSkus.status = res.data.status;
              $uibModalInstance.dismiss();
            });
          };
          $scope.recover = function () {
            catalogItemService.changeSkuStatus(vm.catalogSkus.id, 'CONFIRMED').then(function (res) {
              vm.catalogSkus.status = res.data.status;
              $uibModalInstance.dismiss();
            });
          };
        }
      });
    };

    /**
     * Проверка уникальности полей товара
     */
    vm.uniqueCheck = function (str, name) {
      var constraintName = '';
      switch (name) {
        case 'name':
          constraintName = 'DOMAIN_CATALOG_STOCK_ITEM_NAME';
          break;
        case 'derivative_code_prefix':
          constraintName = 'DOMAIN_STOCK_ITEM_CODE_PREFIX';
          break;
        case 'vendor_code':
          constraintName = 'DOMAIN_STOCK_ITEM_VENDOR';
          break;
        default:
          constraintName = 'DOMAIN_CATALOG_ITEM_GTIN';
      }

      if (str) {
        var obj = {
          "constraint_name": constraintName,
          "parameters": [
            {
              "name": name,
              "value": (name == 'gtin') ? str.gtin : str
            }
          ]
        }
        if (name == 'gtin') {
          if (vm.catalogSkus.id) {
            obj.parameters.push({
              "name": "catalog_item_id",
              "value": vm.catalogSkus.id
            });
          }
          if (str.id) obj.id = str.id;
        } else {
          if (vm.catalogSkus.id) obj.id = vm.catalogSkus.id;
        }
        utilsService.uniqueCheck(obj).then(function (res) {
        },
          function (error) {
            if (error.status == 409 && error.data.code == 'non_unique') {
              if (error.data.constraint_name == 'DOMAIN_CATALOG_ITEM_GTIN') {
                setGtinError(error.data.parameters[0].value);
              } else {
                vm.addCatalogSkus[error.data.parameters[0].name].$setValidity('unique', false);
              }
              vm.checkValidForm();
            }
          });
      }
    }

    vm.setDirty = function () {
      vm.isSetDirty = true;
      if (vm.hasError.length) {
        $anchorScroll(vm.hasError[0] + "Anchor");
      } else if (vm.skuErrorIndex !== undefined) {
        vm.selectTab(vm.skuErrorIndex);
        $anchorScroll("packingAnchor");
      }
      angular.forEach(vm.addCatalogSkus.$error, function (controls, errorName) {
        var anchor = _.find(controls, function (control) {
          return control && control.$name
        });
        $anchorScroll(anchor && anchor.$name + "Anchor");
        angular.forEach(controls, function (control) {
          if (control) {
            control.$setDirty();
            if (errorName === 'required') {
              $anchorScroll(control.$name + "Anchor");
              if (vm.skuErrorIndex !== undefined) {
                vm.selectTab(vm.skuErrorIndex);
                angular.forEach(control.$error.required, function (formControl) {
                  formControl.$setDirty();
                });
              }
            }
          }
        });
      });
    }

    /* карусель для табов */
    vm.scrlTabsApi = {};

    // Если длина кода меньше weight_barcode_code, то слева от него дописываем нули. Если больше, то отрезаем лишние цифры слева
    vm.genCodeForBarcode = function (strLength, source) {
      source = source || '';
      var sourceLen = source ? source.toString().length : 0;
      if (strLength > sourceLen) {
        var res = '';
        for (var i = 0; i < (strLength - sourceLen); i++) {
          res += '0';
        }
        return res + source;
      } else if (strLength < sourceLen) {
        // скрываем отображение весового шк
        return source.substring(sourceLen - strLength, sourceLen);
      } else {
        return source;
      }
    }

    vm.generateWeightBarcode = function (sku) {
      if (vm.settings.generate_weight_barcode) {
        // Префикс весового ШК
        vm.weightBarcode = vm.settings.weight_barcode_prefix;
        // Код весового ШК
        if (vm.settings.weight_barcode_source == 'ITEM_CODE') {
          if (!vm.catalogSkus.code || vm.catalogSkus.code.toString().length > vm.settings.weight_barcode_code) {
            sku.$$weight_barcode = false;
            return;
          }
          vm.weightBarcode += vm.genCodeForBarcode(vm.settings.weight_barcode_code, vm.catalogSkus.code);
        } else if (vm.settings.weight_barcode_source == 'VENDOR_CODE') {
          if (!vm.catalogSkus.vendor_code || vm.catalogSkus.vendor_code.toString().length > vm.settings.weight_barcode_code) {
            sku.$$weight_barcode = false;
            return;
          }
          vm.weightBarcode += vm.genCodeForBarcode(vm.settings.weight_barcode_code, vm.catalogSkus.vendor_code);
        }
        // Вес весового ШК
        for (var i = 0; i < vm.settings.weight_barcode_weight - 1; i++) {
          vm.weightBarcode += '0';
        }
        vm.weightBarcode += '1';
        // Контрольная сумма
        if (vm.settings.weight_barcode_format == "EAN13") {
          var result = 0;
          var i;
          for (i = 0; i < 12; i += 2) {
            result += parseInt(vm.weightBarcode[i]);
          }
          for (i = 1; i < 12; i += 2) {
            result += parseInt(vm.weightBarcode[i]) * 3;
          }
          vm.weightBarcode += (10 - (result % 10)) % 10;
        }
      }
    };

    vm.changePackaged = function (sku) {
      // если отпускается без упаковки и если есть флаг весового штрихкода
      if (sku.packaged && vm.settings.generate_weight_barcode) {
        if ((vm.settings.weight_barcode_format == 'EAN13' &&
          ((vm.settings.weight_barcode_source == "ITEM_CODE" && (!vm.catalogSkus.code || !/^[\d]+$/.test(vm.catalogSkus.code.toString()))) ||
            (vm.settings.weight_barcode_source == "VENDOR_CODE" && (!vm.catalogSkus.vendor_code || !/^[\d]+$/.test(vm.catalogSkus.vendor_code.toString()))))) ||
          (vm.settings.weight_barcode_format == 'Code39' &&
            ((vm.settings.weight_barcode_source == "ITEM_CODE" && (!vm.catalogSkus.code || !/^[\d\sA-Z%.+*/$-]+$/.test(vm.catalogSkus.code.toString()))) ||
              (vm.settings.weight_barcode_source == "VENDOR_CODE" && (!vm.catalogSkus.vendor_code || !/^[\d\sA-Z%.+*/$-]+$/.test(vm.catalogSkus.vendor_code.toString())))))) {
          sku.$$weight_barcode = false;
          return;
        }
        sku.$$weight_barcode = true;
        vm.generateWeightBarcode(sku);
      } else {
        sku.$$weight_barcode = false;
      }
    };

    // показ весового штрихкода, если это необходимо
    vm.checkWeightBarcode = function () {
      if (!vm.catalogSkus) return
      _.forEach(vm.catalogSkus.sku_list, function (sku) {
        vm.changePackaged(sku);
      });
    }
    vm.checkWeightBarcode();

    vm.reCalcScroll = function () {
      if (vm.scrlTabsApi.doRecalculate) {
        vm.scrlTabsApi.doRecalculate();
      } else {
        vm.scrlTabsApi = {};
      }
    };
    $timeout(vm.reCalcScroll, 2000);

  }
})();

(function () {
  'use strict';

  angular.module('frontend').controller('catalogServicesSearchController', catalogServicesSearchController);

  function catalogServicesSearchController($state, $scope, cardHistory, $rootScope, catalogItemService) {
    var vm = this;

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if (prev) {
        $state.go(prev.name || 'catalog', prev.param || {parent: $state.params.parent});
      } else {
        $state.go('catalog', {parent: $state.params.parent});
      }
    }

    /* Поиск товара или услуги в едином каталоге */
    vm.search = function(){
      if(vm.searchItemName){
        vm.showLoader = true;
        vm.showSeach = false;
        catalogItemService.getElements(vm.searchItemName).then(function(res){
          vm.showSeach = true;
          vm.searchTotal = res.data.total;
          vm.searchElements = res.data.items;
          vm.showLoader = false;
        });
      }else{
        vm.showSeach = false;
        vm.searchTotal = 0;
        vm.searchElements = [];
      }
    }

    $scope.$watch('vm.searchItemName', function(newVal, oldVal) {
      if (oldVal && !newVal) { // Если не пустое значение меняется на пустое (в широком смысле)
        vm.search();
      }
    });

  }
})();

(function() {
  'use strict';

angular.module('frontend').controller('catalogServicesController', catalogServicesController);

  function catalogServicesController($scope,
                                     $state,
                                     $timeout,
                                     requestStatus,
                                     $uibModal,
                                     cardHistory,
                                     catalogService,
                                     categoryService,
                                     catalogItemService,
                                     element,
                                     errorMessageService,
                                     taxGroups,
                                     taxModes,
                                     searchItem,
                                     $anchorScroll,
                                     utilsService,
                                     settings,
                                     $stateParams,
                                     $window,
                                     $rootScope,
                                     expenseItems,
                                     helpService,
                                     radioTaxModeSource,
                                     cashRegisterItemTypes,
                                     userSettingsService,
                                     priceListSrv,
                                     priceLocalSrv,
                                     priceColumnSrv,
                                     priceSettingsService,
                                     cashRegisterTypesByProductGroup,
                                     projectsService) {
    var vm = this;
    vm.taxMode = taxModes; // справочник режимов налогообложения чека
    vm.expenseItems = expenseItems;
    vm.nomenclature = [];
    vm.stateName = $state.current.name;
    vm.isGoods = vm.stateName.indexOf('goods') + 1;
    vm.treeCollapsed = true; // Дерево свернуто по-умолчанию
    vm.formError = {}; // для детекта ошибок формы
    vm.widget = [];
    vm.hasError = [];
    vm.taxModeList = []; // автокомплит списка налогообложения чека
    vm.currentTaxMode = {};
    // Узлы дерева
    vm.root = {
      name: 'Товары и услуги',
      root: true,
      has_children: true,
      children: []
    };

    // Создание упрощенной иерархии дерева
    vm.categoryId = (element)? element.category.id : $state.params.categoryId;
    if (vm.categoryId) {
      categoryService.categoryHierarchy(vm.categoryId).then(function (data) {
        if (data.data && data.data.levels) {
          vm.currentCategory = data.data.levels[data.data.levels.length - 1]; // текущую категорию сохраним отдельно
          vm.currentCategory.has_children = false;
          // Создание структуры для простого отображения в дереве, без подзагрузки
          var curNode = vm.root;
          angular.forEach(data.data.levels, function (level) {
            level.expand = true;
            level.loaded = true;
            curNode.children = [level];
            curNode = level;
          })
        }
      })
    }

    vm.deleteOldAttrValue = function(index) {
      vm.catalogItem.old_attribute_values.splice(index, 1);
    };

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep('elementId', $stateParams.elementId) || {name: 'catalog', param: {}};
      $state.go(prev.name !== '' ? prev.name : 'catalog', prev.param || {parent: $state.params.parent});
    };

    $scope.$watch('$state.current.name', function(model) {
      vm.stateName = model;
    }, true);

    /**
     * Открывает диалог перемещения услуги
     */
    vm.showMoveDialog = function () {
      catalogItemService.openMoveCategoryDialog()
        .result.then(function (selectedNode) {
        if (!selectedNode || !selectedNode.id)
          return;
        var obj = {
          new_parent: selectedNode.id,
          childrens: [element.id]
        };
        catalogService.moveCatalogItems(obj).then(function (res) {
            $state.go('catalogServices.edit', {
              elementId: element.id,
              categoryId: selectedNode.id,
              parent: $state.params.parent
            });
            $timeout(function () { // для показа статуса после reload
              requestStatus.success("Выбранные позиции перемещены в категорию " + selectedNode.name, 'move');
            }, 1000);
          },
          function () {
            requestStatus.error('Во время перемещения произошла ошибка. Повторите попытку позже');
          });
      });
    };

    vm.initWidgets = function () {
      // виджет цен
      vm.priceWidget = {
        name: 'Цены на ' + moment().utc().tz($rootScope.user.time_zone).format('DD MMMM'),
        component: 'price-widget',
        settingsComponent: 'priceWidget',
        allowRedactMode: $rootScope.hasRole([
          'price_list.write',
          'wholesale_price_list.write',
          'purchase_price_list.write'
        ]),
        options: {
          id: element.id,
          pageName: "catalogService"
        },
        visible: vm.stateName.endsWith('view') &&
                 ($rootScope.hasRole('price_list.read') ||
                  $rootScope.hasRole('price_list.write') ||
                  $rootScope.hasRole('wholesale_price_list.read') ||
                  $rootScope.hasRole('wholesale_price_list.write') ||
                  $rootScope.hasRole('purchase_price_list.read') ||
                  $rootScope.hasRole('purchase_price_list.write'))
      };

      // инициализация виджетов
      // сделано хранение в сторе последовательности только названий виджетов, т.к. необходима актуальная дата и актуальные доступы
      vm.widgetSequence = userSettingsService.loadProperty("catalogService", "widget", "sequence") || [];
      if (!vm.widgetSequence.length) {
        vm.widget = [vm.priceWidget];
        _.forEach(vm.widget, function (widget) {
          vm.widgetSequence.push(widget.settingsComponent);
        });
        userSettingsService.saveProperty("catalogService", "widget", "sequence", vm.widgetSequence);
      } else {
        _.forEach(vm.widgetSequence, function (widgetName) {
          vm.widget.push(vm[widgetName]);
        });
      }
    }

    if (element) {
      vm.initWidgets();
    }

    vm.catalogItem = element || {
      name: $state.params.searchName || '',
      uom: {
        id: '4a639aa0-478a-49e4-80f7-2b7f159ea6aa',
        name : "Штука",
        symbols: "шт"
      },
      tax_group:{
        id: '9cda6b93-40c1-4ca3-95d8-0b11d33b7e78',
        name: 'Без НДС'
      },
      category: {
        id : $state.params.categoryId
      },
      attribute_values: [],
      derivatives: [],
      tax_mode_source: 'FROM_CASHREGISTER',
      tax_mode: null
    };

    vm.defaultCashRegItemType = function () {
      if (vm.category.cash_register_item_type) return vm.category.cash_register_item_type;

      var productGroup = cashRegisterTypesByProductGroup[vm.category.product_group];
      return productGroup || "SERVICE"
    }

    if(!element && settings.use_auto_codes){
      catalogService.getCode().then(function(res){
        vm.catalogItem.code = res.data.code;
      });
    }

    vm.getTaxMode = function(mode){
      var TaxMode= {};
      vm.taxMode.forEach(function(item){
        if(item.mode == mode){
          TaxMode = item;
        }
      });
      return TaxMode;
    }

    // автокомплит списка налогообложения чека
    vm.taxMode.forEach(function(item){
      if(item.mode != 'NONE'){
        vm.taxModeList.push(item);
      }
    });



    /* получение необходимой структуры значений */
    function getValuesObj(){
      /* Кэш значений атрибутов */
      vm.attribValues = {};

      /* Установка значений атрибутов в модель */
      if (vm.catalogItem) { // Только при редактировании (при создании нечего маппить)
        angular.forEach(vm.catalogItem.attribute_values, function (attributeValue) {
          if(attributeValue.value){
            delete attributeValue.values;
            if(!vm.attribValues[attributeValue.attribute.name]) vm.attribValues[attributeValue.attribute.name] = attributeValue;
            if(!vm.attribValues[attributeValue.attribute.name].values)vm.attribValues[attributeValue.attribute.name].values = [];
            if(attributeValue.dict_value){
              vm.attribValues[attributeValue.attribute.name].values.push(attributeValue.dict_value);
            }else{
              vm.attribValues[attributeValue.attribute.name].values.push(attributeValue.value);
            }
          }
        });
      }
    }

    vm.getTaxGroups = function(search){
      catalogService.getTax(search, helpService.now().valueOf()).then(function(res){
        vm.taxGroups = res.data;
      });
    };

    /* Автодополнение единиц измерения */
    vm.refreshUoms = function(search) {
      vm.formError.uom = false;
      catalogService.getUoms(search).then(function(res){
        vm.uoms = res.data;
        vm.formError.uom = !res.data.length;
      });
    };
    vm.totalStr = function(){
      if(vm.uoms.length > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + vm.uoms.length;
      }
      return '';
    };

    /* Автодополнение проектов */
    vm.refreshProjects = function (search) {
      projectsService.projectsSearch(search, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH, {filter_active: true}).then(function(res){
        vm.projects = res.data;
        if(!vm.projectsFullTotal){
          vm.projectsFullTotal = res.data.total;
        }
      });
    };
    vm.totalSelectStr = function(){
      if(vm.projectsFullTotal > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
        return "Показано " + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + " из " + vm.projectsFullTotal;
      }
      return '';
    };

    // для подстановки необходимого id в дериватив
    function findMatch(issetAttrValue, tempDer){
      var id = '';
      angular.forEach(tempDer, function(der){
        angular.forEach(der.attribute_values, function(attrValue){
          if(issetAttrValue.value == attrValue.value && issetAttrValue.attribute.id == attrValue.attribute.id){
            id = attrValue.id;
          }
        });
      });
      return id;
    }

    // занесение информации о деривативах в объект услуги
    function getDerivativeObj(){
      var tempDer = angular.copy(vm.catalogItem.derivatives);
      vm.catalogItem.derivatives = [];
      angular.forEach(vm.nomenclature, function(attr, key1){
        var derivative = {attribute_values:[], name: vm.derivativeNames[key1]};
        if(tempDer && tempDer[key1]){
          derivative.id = tempDer[key1].id;
        }
        angular.forEach(attr, function(val, key2){
          if(!key2){
            derivative.code = val;
          }else{
            derivative.attribute_values.push({
              attribute: vm.listAttr[key2],
              value: val
            });
          }
        });
        vm.catalogItem.derivatives.push(derivative);
      });
      angular.forEach(vm.catalogItem.derivatives, function(der, key1){
        angular.forEach(der.attribute_values, function(attrValue, key2){
          var id = findMatch(attrValue, tempDer);
          if(id){
            attrValue.id = id;
          }
        });
      });
      if (!vm.catalogItem.derivatives) vm.catalogItem.derivatives = [];
      // обязан быть хотя бы один дериватив
      if (vm.catalogItem.derivatives.length === 0) {
        var derivative = {
          code: vm.catalogItem.code || '_'
        };
        if (tempDer && tempDer[0] && tempDer[0].id) {
          derivative.id = tempDer[0].id
        }
        vm.catalogItem.derivatives.push(derivative);
      } else if (vm.catalogItem.derivatives.length === 1 && vm.catalogItem.code !== vm.catalogItem.derivatives[0].code){ // после ошибки кода, надо его менять при повторном сохранении
        vm.catalogItem.derivatives[0].code = vm.catalogItem.code;
      }
    }

    //arrays - массив массивов с комбинациями
    function combinations(arrays, i) {
      if (!arrays[i]) {
        return [];
      }
      if (i == arrays.length - 1) {
        return arrays[i];
      }
      var tmp = combinations(arrays, i + 1);
      var result = [];
      angular.forEach(arrays[i], function(v, keyV){
        angular.forEach(tmp, function(t){
          if(Array.isArray(t)){
            if(keyV){
              var arr = angular.copy(t);
              arr[0] = v;
              result.push(arr);
            }else{
              t.unshift(v);
              result.push(t);
            }
          }else{
            result.push([v,t]);
          }
        });
      });
      return result;
    }

    function createArticle(){
      if(vm.nomenclature){
        angular.forEach(vm.nomenclature, function(values, key){
          var article = '';
          if(vm.catalogItem.code) article += (vm.catalogItem.code + '-');
          article += (key + 1);
          angular.forEach(values, function(word){
            if(word.value) word = word.value;
            word = (word + "").split(new RegExp(/-| /, 'g')).join("").substring(0, 4);
            if(article) article += "-";
            article += word;
          });
          values.unshift(article);
        });
        var matchCount = 0;
        angular.forEach(vm.nomenclature, function(val1, key1){
          angular.forEach(vm.nomenclature, function(val2, key2){
            if(key2 > key1){
              if(val1[0] == val2[0]){
                matchCount++;
              }
            }
          });
        });
      }
    }

    function createDerivativeName() {
      if (vm.nomenclature) {
        vm.derivativeNames = [];
        angular.forEach(vm.nomenclature, function (values, determinatorNum) {
          var name = '';
          angular.forEach(values, function (word, attributeNum) {
            if (word && attributeNum) {
              if (word.value) word = word.value;
              // добавить разделитель
              if (name) name += ", ";
              // добавить название атрибута + значение атрибута
              name += (vm.listAttr[attributeNum].name + " " + word);
            }
          });
          if(name){
            vm.derivativeNames.push(name);
          }
        });
      }
    }

    // построить деривативы/номенклатуры
    vm.buildDerivatives = function(){
      var temp = angular.copy(vm.attribValues);
      vm.allValuesArr = [];
      vm.listAttr = [{name: 'article'}];
      angular.forEach(temp, function(attr){
        for (var i = attr.values.length - 1; i >= 0; i--) {
          if (!attr.values[i]) {
            attr.values.splice(i, 1); // TODO: вероятно тут ошибка, и пустое значение, следующее за другим таким пустым, не будет отброшенно
          }
        }
        if(attr.values.length > 1){
          // преобразование даты
          if(attr.values[0].date){
            var dateStrArr = [];
            angular.forEach(attr.values, function(val){
              if(val.value){
                dateStrArr.push(val.value);
              }
            });
            attr.values = dateStrArr;
          }
          vm.listAttr.push(attr.attribute || attr.values);
          vm.allValuesArr.push(attr.values);
        }
      });
      if(vm.allValuesArr.length > 2){
        vm.hideDeterminate = true;
      }
      vm.nomenclature = combinations(vm.allValuesArr, 0);
      if(!Array.isArray(vm.nomenclature[0])){
        var copyNom = angular.copy(vm.nomenclature);
        vm.nomenclature = [];
        angular.forEach(copyNom, function(attr){
          vm.nomenclature.push([attr]);
        });
      }
      createArticle();
      createDerivativeName();
      getDerivativeObj();
    };
    // для получения структуры атрибутов из категории
    function getCustomCategory(){
      categoryService.getCustomCategory(vm.catalogItem.category.id).then(function(res){
        vm.category = res.data;

        if(!vm.catalogItem.cash_register_item_type){
          vm.catalogItem.cash_register_item_type = vm.defaultCashRegItemType();
        }

        getValuesObj();
        if(element) vm.buildDerivatives();
        /* для странички просмотра убрать пустые блоки */
        if(vm.stateName.endsWith('view')){
          angular.forEach(vm.category.elements, function (elem) {
            if(elem.block){
              elem.block.$$empty = true;
              angular.forEach(elem.block.attributes, function (attr) {
                if(vm.attribValues[attr.name] && vm.attribValues[attr.name].values[0] != ''){
                  elem.block.$$empty = false;
                }
              });
            }
          });
        }

        // подстановка данных из единого каталога
        if(searchItem){
          vm.catalogItem.name = searchItem.name || null;
          vm.catalogItem.full_desc = searchItem.full_desc || null;
          vm.catalogItem.attribute_values = searchItem.attribute_values;
          if(searchItem.brand){
            vm.catalogItem.name += (' ' + searchItem.brand);
          }
          if(searchItem.sub_brand){
            vm.catalogItem.name += (' ' + searchItem.sub_brand);
          }
          getValuesObj();
        }
      });
    }
    getCustomCategory();

    // для подстановки необходимого id в атрибут
    function findMatchAttr(attrValue, tempAttrs){
      var id = '';
      angular.forEach(tempAttrs, function(attr){
        if(attrValue.value == attr.value && attrValue.attribute.id == attr.attribute.id){
          id = attr.id;
        }
      });
      return id;
    }

    function getAttrValues(){
      var tempAttrs = angular.copy(vm.catalogItem.attribute_values);
      // занести информмацию о значения атрибутов в объект позиции
      vm.catalogItem.attribute_values = [];
      angular.forEach(vm.attribValues, function(attr){
        angular.forEach(attr.values, function(val, key){
          var newAttr = {}, id, issetItem;
          if(val){
            if(val.date){
              val = (val.value)? val.date.valueOf() : '';
            }
            if(val.value){
              val = val.id;
            }
            if(val){
              newAttr.value = val;
              newAttr.attribute = attr.attribute;
              id = findMatchAttr(newAttr, tempAttrs);
              if(id){
                newAttr.id = id;
              }
              if (attr.attribute.data_type !== 'BOOLEAN') {
                vm.catalogItem.attribute_values.push(newAttr);
              }
            }
          }
          if (attr.attribute.data_type === 'BOOLEAN') {
            issetItem = _.find(vm.catalogItem.attribute_values, function (item) {
              return item.attribute.id == attr.attribute.id;
            });
            if(!issetItem && val !== '' && val !== null){
              newAttr.value = (val === 'true')? true : false;
              newAttr.attribute = attr.attribute;
              id = findMatchAttr(newAttr, tempAttrs);
              if (id) {
                newAttr.id = id;
              }
              vm.catalogItem.attribute_values.push(newAttr);
            }
          }

        });
      });
    }
    // Попап перечня товаров
    vm.showGoodsLists = function () {
      var save = false;
      $uibModal.open({
        templateUrl: 'app/catalog/modals/goods-list.html',
        size: 'large-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.name = vm.catalogItem.name;
          $scope.tempNom = angular.copy(vm.nomenclature);
          $scope.valid = {isvalid: true};
          $scope.isView = vm.stateName.endsWith('view');
          $scope.packingTabs = [{
            className: '',
            title: '',
            grid: {
              attributes: vm.listAttr,
              values: vm.nomenclature
            }
          }];

          $scope.checkDuplicate = function(code){
            if(code){
              //$scope.valid.isvalid = true;
              var res = _.size(_.filter(vm.nomenclature, function(row) {
                return row[0] == code;
              })) > 1;
              if(res) $scope.valid.isvalid = false;
              return res;
            }
            return false;
          };

          $scope.close = function() {
            $uibModalInstance.dismiss();
            vm.nomenclature = $scope.tempNom;
          };

          $scope.save = function() {
            if ($scope.nomenclatureForm.$invalid) {
              $scope.isSaved = true;
              return;
            }
            getDerivativeObj();
            $uibModalInstance.dismiss();
            save = true;
          };

        }
      }).result.finally(function(){
        if(!save) vm.buildDerivatives();
      });
    };

    // Состояние процесса сохранения/обновления (ошибки, сообщения и т.д.)
    vm.crudState = {
      error: false,
      message: '',
      loading: false,
      // Утилитарный метод устанавливающий флаги состояния загрузки
      startLoading: function () {
        vm.crudState.error = false;
        vm.crudState.message = '';
        vm.crudState.loading = true;
      },
      stopLoadingSuccess: function () {
        vm.crudState.error = false;
        vm.crudState.message = '';
        vm.crudState.loading = false;
      },
      stopLoadingFailure: function (message) {
        vm.crudState.error = true;
        vm.crudState.message = message;
        vm.crudState.loading = false;
      }
    };
    /* обновление информации по услуге */
    vm.updateService = function(){
      catalogItemService.updateService(vm.catalogItem).then(function(res){
        vm.catalogItem = res.data;
        vm.crudState.stopLoadingSuccess();
        if ($stateParams.closeTab) {
          $window.close();
        }
        vm.resetData();
      }, function (error) {
        if(error.status === 409 && error.data.code === 'non_unique'){
          $scope.addCatalogItem[error.data.parameters[0].name].$setValidity('unique', false);
          $anchorScroll(error.data.parameters[0].name + "Anchor");
        } else if (error.status === 409 && error.data.code === 'in_use' || error.data.constraint_name === "DOMAIN_SERVICE_DERIVATIVE") {
          $scope.addCatalogItem['derivative_code_prefix'].$setValidity('unique', false);
          $anchorScroll("derivative_code_prefixAnchor");
        } else if (error.status === 409 && (error.data.code === 'integrity_violation')) {
          $uibModal.open({
            templateUrl: 'app/settings/templates/modals/info.html',
            size: 'small-width',
            controller: function ($scope, $uibModalInstance) {
              $scope.title = 'Невозможно сохранить';
              $scope.text = "Изменение невозможно, так как по данной услуге были созданы документы";
              $scope.close = function () {
                $uibModalInstance.dismiss();
              };
            }
          });
        } else if (error.status === 400 && error.data.message === 'impossible_to_modify_there_are_documents') {
          errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: { data: { message: 'Изменение невозможно, так как по данной услуге созданы документы'}}});
        } else {
          vm.crudState.stopLoadingFailure(error);
          errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
        }
      });
    };
    /* Информация о статусе черновик */
    vm.draftPopupInfo = function(){
      $uibModal.open({
        templateUrl: 'app/catalog/modals/draft-popup.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.isCreate = false;
          $scope.class = "info";
          $scope.idItem = vm.catalogItem.id;
          $scope.isEdit = vm.stateName.endsWith('edit');
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
          $scope.goToEdit = function(){
            $uibModalInstance.dismiss();
            $state.go('catalogServices.edit', {elementId: vm.catalogItem.id, parent: $state.params.parent});
          }
        }
      });
    };

    /* показать информация о том что товар будет сохранен как черновик */
    vm.showDraftMess = function(){
      $uibModal.open({
        templateUrl: 'app/catalog/modals/draft-popup.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.isCreate = true;
          $scope.class = "info";
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
          $scope.save = function() {
            $uibModalInstance.dismiss();
            vm.shownDraftMess = true;
            vm.save();
          };
        }
      });
    };

    radioTaxModeSource[2].label = 'По настройкам услуги';
    vm.radioTaxModeSource = radioTaxModeSource;
    vm.cashRegisterItemTypes = cashRegisterItemTypes;


    vm.taxModeSourceChanged = function(value) {
      if (value === 'FROM_CATALOG_ITEM' && (!vm.catalogItem.tax_mode || vm.catalogItem.tax_mode === 'NONE')) {
        vm.catalogItem.tax_mode = vm.taxModeList[0];
      }
    };

    // В методе выполняются подготовительные операции перед сохранением
    vm.prepareSave = function () {
      if(!vm.catalogItem.derivatives.length) vm.catalogItem.derivatives.push({code: vm.catalogItem.code});
      if(vm.catalogItem.uom){
        vm.catalogItem.uom = {
          id: vm.catalogItem.uom.id,
          name: vm.catalogItem.uom.name,
          symbols: vm.catalogItem.uom.symbols
        }
      }
      if(vm.catalogItem.tax_group){
        vm.catalogItem.tax_group = {
          id: vm.catalogItem.tax_group.id,
          name: vm.catalogItem.tax_group.name
        }
      }

      // присвоение значения типу налоогблажения чека
      vm.catalogItem.tax_mode = vm.catalogItem.tax_mode && vm.catalogItem.tax_mode !== 'NONE' ? vm.catalogItem.tax_mode : null;
      getAttrValues();
      // запись id списков выбора в дериватив
      angular.forEach(vm.catalogItem.derivatives, function(der){
        angular.forEach(der.attribute_values, function(attr){
          if(attr.value.id) attr.value = attr.value.id;
        });
      });
    };
    vm.resetData = function() {
      $scope.addCatalogItem.$setPristine();
      vm.returnToPage();
    };

    // проверка на ошибки обязательных атрибутов.
    // если какой-то из атрибутов не заполнен, то это не должно блокировать сохранение формы полностью
    // должен вызываться попап подтверждения сохранения Черновика
    vm.hasRequiredAttributeError = function() {
      // у полей атрибутов нет атрибутов name, поэтому их выслеживаем по отсутствию имени
      return _.find($scope.addCatalogItem.$error.required, function(error){
        if(!Array.isArray(error.$error.required) && !error.$name){
          return true;
        } else if (Array.isArray(error.$error.required)) {
          return _.find(error.$error.required, function(errorPackAttr){
            return !errorPackAttr.$name;
          });
        }
        return false;
      });
    };

    // сохранение услуги
    vm.save = function () {
      // для показа попапа черновика еще необходима проверка на наличие ошибки "requiredAttribute"
      // она выставляется если не заполнен обязательный датапикер, у него пустота определяется поле isEmpty
      var errors = Object.keys($scope.addCatalogItem.$error);
      if((vm.hasRequiredAttributeError() || errors.includes('requiredAttribute')) && !vm.shownDraftMess && vm.catalogItem.status !== 'ARCHIVED'){
        vm.showDraftMess();
        return;
      }
      if(vm.catalogItem.name && vm.catalogItem.code){
        vm.prepareSave();
        vm.crudState.startLoading();
        if(vm.catalogItem.id){
          vm.updateService();
        }else{
          catalogItemService.createService(vm.catalogItem).then(function(res){
            vm.catalogItem = res.data;
            vm.crudState.stopLoadingSuccess();
            if ($stateParams.closeTab) {
              $window.close();
            }
            vm.resetData();
          }, function (error) {
            if(error.status === 409) {
              if (error.data.code === 'non_unique') {
                $scope.addCatalogItem[error.data.parameters[0].name].$setValidity('unique', false);
                $anchorScroll(error.data.parameters[0].name + "Anchor");
              } else if (error.data.code === 'in_use' || error.data.constraint_name === "DOMAIN_SERVICE_DERIVATIVE") {
                $scope.addCatalogItem['derivative_code_prefix'].$setValidity('unique', false);
                $anchorScroll("derivative_code_prefixAnchor");
              } else if (error.data.code === 'exceeded_maximum_number_of_catalog_items') {
                errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: {
                    data: {
                      message: 'Невозможно создать новую позицию каталога. Достигнуто их  максимальное количество'
                    }
                  }
                });
              }
            } else {
              vm.crudState.stopLoadingFailure(error);
              errorMessageService.showModal({message: 'При Создании произошла ошибка', submessage: error});
            }
          });
        }
      }
    };

    // Метод, вызываемый при удалении услуги
    vm.delete = function () {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/ask-delete.html',
        size: 'small-width',
        resolve: {
          name: function () {
            return vm.catalogItem.name;
          },
          checkCashregisterSync: function() {
            return catalogItemService.checkCashregisterSync(vm.catalogItem.id).then(function(value) {
              return value.data
            })
          }
        },
        controller: function ($scope, $uibModalInstance, name, checkCashregisterSync) {
          var basicCanDeleteText = "Удаление невозможно, так как по данной услуге созданы документы";
          $scope.name = name;
          $scope.canDelete = true;
          $scope.deleteEntityStr = 'услугу';
          $scope.conflictDeleteText = basicCanDeleteText;
          $scope.lock = false;
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };

          if (checkCashregisterSync && checkCashregisterSync.length) {
            $scope.conflictDeleteText = "Сведения об удаляемой позиции ещё не обновились на следующих кассах:<br><br>";
            angular.forEach(checkCashregisterSync, function(item) {
              angular.forEach(item.cash_registers, function(cash_register) {
                $scope.conflictDeleteText += cash_register.model + " " +  cash_register.serial_number + " в подразделении " + item.division.name + '<br>';
              })
            });
            $scope.canDelete = false;
            $scope.forceDelete = false;
          }


          $scope.delete = function() {
            $scope.lock = true;
            vm.crudState.startLoading();
            catalogItemService.deleteService(vm.catalogItem.id).then(function () {
              $scope.lock = false;
              vm.crudState.stopLoadingSuccess();
              vm.resetData();
              $uibModalInstance.dismiss();
            }, function (error) {
              if (error.status === 409) {
                $scope.lock = false;
                if (error.data.code === 'integrity_violation') {
                  $scope.canDelete = false;
                  $scope.conflictDeleteText = basicCanDeleteText;
                  $scope.forceDelete = false;
                }
              } else {
                errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
              }
              vm.crudState.stopLoadingFailure(error);
            });
          };
        }
      });
    };

    vm.statusPopup = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/status-popup.html',
        size: '',
        controller: function ($scope, $uibModalInstance) {
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    vm.recoveryPopup = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/recovery-popup.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
        }
      });
    };

    // Помещение/восстановление позиции в статус архив
    vm.archivePopup = function (isRecover) {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/archive-popup.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.class = "info";
          $scope.isRecover = isRecover;
          $scope.name = vm.catalogItem.name;
          $scope.close = function() {
            $uibModalInstance.dismiss();
          };
          $scope.inArchive = function(){
            catalogItemService.changeServiceStatus(vm.catalogItem.id, "ARCHIVED").then(function(res){
              vm.catalogItem.status = res.data.status;
              $uibModalInstance.dismiss();
            });
          };
          $scope.recover = function(){
            catalogItemService.changeServiceStatus(vm.catalogItem.id,"CONFIRMED").then(function(res){
              vm.catalogItem.status = res.data.status;
              $uibModalInstance.dismiss();
            });
          };
        }
      });
    };

    vm.uniqueCallback = function (str, fieldName) {
      if(str){
        var constraintName = '';
        switch(fieldName){
          case 'name':
            constraintName = 'DOMAIN_SERVICE_NAME';
          break;
          case 'derivative_code_prefix':
            constraintName = 'DOMAIN_SERVICE_CODE_PREFIX';
          break;
          default:
            constraintName = 'DOMAIN_SERVICE_DERIVATIVE';
        }
        var obj = {
          "constraint_name": constraintName,
          "parameters": [
            {
              "name": fieldName,
              "value": str
            }
          ]
        };
        if(vm.catalogItem.id) obj.id = vm.catalogItem.id;
        utilsService.uniqueCheck(obj).then(function(res){},
        function (error) {
          if(error.status == 409 && error.data.code == 'non_unique'){
            $scope.addCatalogItem[error.data.parameters[0].name].$setValidity('unique', false);
          }
        });
      }
    };

    // событие при загрузке всего дерева странички, для проверки уникальности названия
    // $scope.$on('$viewContentLoaded', function(event) {
    //   $timeout(function() {
    //     angular.element('#name').blur();
    //   }, 200);
    // });

    vm.setDirty = function() {
      vm.isSetDirty = true;
      if(vm.hasError.length){
        $anchorScroll(vm.hasError[0] + "Anchor");
      }
      angular.forEach($scope.addCatalogItem.$error, function(controls, errorName) {
        var anchor = _.find(controls, function(control) {return control && control.$name});
        $anchorScroll(anchor && anchor.$name + "Anchor");
        angular.forEach(controls, function(control) {
          control && control.$setDirty();
        });
      });
    }

    /* callback для открытия попапа цен позиции */
    vm.showPricePopup = function () {
      var modal = $uibModal.open({
        templateUrl: 'app/price-list/modal/price.modal.html',
        size: 'large-width',
        resolve: {
          catalog_item: function() {
            return vm.catalogItem;
          },
          node: function () {
            return priceListSrv.getLineByItem('RETAIL', vm.catalogItem.id).then(function(data) {
              return data;
            });
          },
          prices: function () {
            return priceListSrv.getLineByItem('RETAIL', vm.catalogItem.id).then(function(data) {
              if (!data) return 'no_prices';
              angular.forEach(data.prices, function (price) {
                price.calculated_automatically_price_for_one_uom = price.calculated_automatically_price_for_one_uom ? (+price.calculated_automatically_price_for_one_uom).toFixed(2) : price.calculated_automatically_price_for_one_uom;
                price.price_for_one_uom = price.price_for_one_uom ? (+price.price_for_one_uom).toFixed(2) : price.price_for_one_uom;
                price.effective_date = price.effective_date ? new Date(price.effective_date) : price.effective_date;
              });
              return priceLocalSrv.priceByItem(data, 'RETAIL'); // true - загрузка тольок локальных цен
            });
          },
          columns: function () {
            return priceColumnSrv.priceColumns('RETAIL') // TODO: поправить
              .then(function (data) {
                _.forEach(data, function (column) {
                  column.flex = 1;
                });
                return {data: priceSettingsService.getColumnWithPriority('RETAIL', data)};
              });
          },
          lock: true,
          column_id: false,
          price_list_type: function () {
            return 'RETAIL';
          },
          from_cell: false,
          updateTree: null
        },
        controller: 'priceModalController',
        controllerAs: 'priceModalCtrl',
        bindToController: true
      });

      // обновление данных из стораджа в любом случае
      modal.result.finally(function () {
        // Обновление флага
        priceListCtrl.notEmptyChanges = priceLocalSrv.hasLocalChanges('RETAIL');
        // обновление информации цены ячейки
        priceLocalSrv.priceByItem(node, 'RETAIL').then(function (price) {
          // связывание цены с товаром или услугой
          node.price = price;
        });
      });
    };

  }
})();

(function () {
  'use strict';

	angular.module('frontend').service('catalogItemService', catalogItemService);

  function catalogItemService($http, API_URL, $uibModal) {

    // Возвращает услугу из каталога домена
    this.getService = function(id) {
      return $http.get(API_URL + "/catalog/domain/services/" + id);
    };

    // Cоздаёт услугу в каталоге домена
    this.createService = function(service) {
      return $http.post(API_URL + "/catalog/domain/services", service);
    };

    // Обновляет услугу в каталоге домена
    this.updateService = function(service) {
      return $http.put(API_URL + "/catalog/domain/services/" + service.id, service);
    };

    // Удаляет услугу из каталога домена
    this.deleteService = function(id, check_cashregister_sync) {
      var params = {};
      if (check_cashregister_sync) {
        params.check_cashregister_sync = check_cashregister_sync;
      }
      return $http.delete(API_URL + "/catalog/domain/services/" + id, {params: params});
    };

    // Проверка наличия не синхронизированных касс , возвращает массив с не синхронизированными кассами
    this.checkCashregisterSync = function(id) {
      return $http.get(API_URL + '/catalog/domain/items/' + id + '/non_synchronized_cashregisters')
    };

    // Возвращает товар из каталога домена
    this.getSkus = function(id) {
      return $http.get(API_URL + "/catalog/domain/skus/" + id);
    };

    // Cоздаёт товар в каталоге домена
    this.createSkus = function(service) {
      return $http.post(API_URL + "/catalog/domain/skus", service);
    };

    // Обновляет товар в каталоге домена
    this.updateSkus = function(service) {
      return $http.put(API_URL + "/catalog/domain/skus/" + service.id, service);
    };

    // Удаляет товар из каталога домена
    this.deleteSkus = function(id, check_cashregister_sync) {
      var params = {};
      if (check_cashregister_sync) {
        params.check_cashregister_sync = check_cashregister_sync;
      }
      return $http.delete(API_URL + "/catalog/domain/skus/" + id, {params: params});
    };

    // поиск позииций по единому каталогу
    this.getElements = function(search_str, filter_gtin) {
      return $http.get(API_URL + "/catalog/items", {
        params: {
          search_string: search_str,
          filter_gtin: filter_gtin,
          limit: 10
        }
      });
    };

    // Получение подробной информации о позиции из единого каталога
    this.getElementInfo = function(id, categoryId) {
      return $http.get(API_URL + "/catalog/items/" + id, {
        params: {
          category_id: categoryId,
          filter_pack_attributes: true
        }
      });
    };

    // Получение списка типов упаковок
    this.getSkusTypes = function() {
      return $http.get(API_URL + "/catalog/packing_types");
    };

    // Обновляет статус услуги в каталоге домена
    this.changeServiceStatus = function(id, status) {
      return $http.put(API_URL + "/catalog/domain/services/" + id + "/status", '"'+status+'"');
    };

    // Обновляет статус товара в каталоге домена
    this.changeSkuStatus = function(id, status) {
      return $http.put(API_URL + "/catalog/domain/skus/" + id + "/status", '"'+status+'"');
    };

    this.openMoveCategoryDialog = function () {
      return $uibModal.open({
        templateUrl: 'app/catalog/modals/move-catalog-items.html',
        size: 'large-width',
        controller: function ($scope, $uibModalInstance, categoryService, $q) {
          $scope.hasSelected = false;

          // настройка скролла
          $scope.configScroll = {
            axis:'y',
            autoHideScrollbar: false,
            theme: 'dark-thick',
            advanced:{
              updateOnContentResize: true
            },
            setHeight: 432,
            scrollInertia: 0,
            scrollButtons: {
              enable: false // enable scrolling buttons by default
            }
          };
          // Узлы дерева
          $scope.root = {
            name: 'Товары и услуги',
            root: true,
            has_children: true,
            children: []
          };

          $scope.onTreeLoaded = function () {
            $scope.root.expandFuncByModel({}); // открывает корень дерева
          };

          $scope.isSelectedItem = function (item) {
            return _.find($scope.selectedItems, function(selected_catalog_item){
              return selected_catalog_item.id == item.id;
            });
          };

          /* Callback для раскрытия дерева */
          $scope.expand = function (node) {
            return (node.has_children) ? categoryService.getDomainCategories(node.id).then(function(data) {
              if (data.data) {
                return _.filter(data.data, function(catalog_item, index){
                  return !$scope.isSelectedItem(catalog_item);
                });
              }
            }) : $q.when([]);
          };

          $scope.selectNode = function (node) {
            if (node) {
              if(!node.id && $scope.disabledRootSelect){
                $scope.hasSelected = false;
              }else{
                $scope.hasSelected = true;
                $scope.selectedNode = node;
              }
            } else {
              $scope.hasSelected = false;
              $scope.selectedNode = undefined;
            }
          };

          $scope.move = function(){
            if (!$scope.selectedNode) {
              $scope.isSaved = true;
              return;
            }
            $scope.load = true;
            $uibModalInstance.close($scope.selectedNode);
          };

          $scope.close = function () {
            $uibModalInstance.dismiss();
          };

        }
      });
    };

  }

})();

(function () {
  'use strict';

	angular.module('frontend').service('attrSettingsService', attrSettingsService);

  function attrSettingsService($http, API_URL) {
    
    // Получение настроек пользовательского каталога товаров
    this.getSettings = function() {
      return $http.get(API_URL + "/catalog/domain/settings");
    }

    // Обвноелние настроек пользовательского каталога товаров
    this.updateSettings = function(settings) {
      return $http.put(API_URL + "/catalog/domain/settings", settings);
    }
  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('attrSettingsController', attrSettingsController);

  function attrSettingsController($scope,
                                  $state,
                                  $rootScope,
                                  $uibModal,
                                  alcoholSettings,
                                  attrSettingsService,
                                  $anchorScroll,
                                  $timeout,
                                  errorMessageService,
                                  cardHistory,
                                  helpService,
                                  $stateParams,
                                  $q,
                                  utilsService,
                                  $window) {
    var vm = this;
    vm.state = $state;
    vm.issetReqAttr = false;
    vm.hasAlcoholProducts = alcoholSettings.alcohol_products;

    vm.formates = ['EAN8', 'EAN13', 'Code39'];
    vm.formatesShort = ['EAN13', 'Code39'];
    vm.sources = [{id: 'ITEM_CODE', name: 'Код товара'}, {id: 'VENDOR_CODE', name: 'Артикул производителя'}];

    vm.changeUniqueVendorCode = function() {
      if (vm.settings.unique_vendor_code) {
        vm.sources = [{id: 'ITEM_CODE', name: 'Код товара'}, {id: 'VENDOR_CODE', name: 'Артикул производителя'}];
      } else {
        vm.sources = [{id: 'ITEM_CODE', name: 'Код товара'}];
        vm.settings.weight_barcode_source = 'ITEM_CODE';
      }
    }

    vm.changeFormat = function (formatField, lengthField) {
      if (vm.settings[formatField] == 'EAN8' || vm.settings[formatField] == 'Code39') {
        vm.settings[lengthField] = 7;
      } else if (vm.settings[formatField] == 'EAN13') {
        vm.settings[lengthField] = 12;
      }
    }

    vm.changeCode = function () {if (vm.settings.weight_barcode_length && vm.settings.weight_barcode_prefix) {
        vm.settings.weight_barcode_code = Math.ceil((vm.settings.weight_barcode_length - (vm.settings.weight_barcode_prefix.toString().length)) / 2);
        if (!vm.settings.weight_barcode_code || vm.settings.weight_barcode_code < 0) {
          vm.settings.weight_barcode_code = undefined;
        }
      } else {
        vm.settings.weight_barcode_code = undefined;
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
      vm.changeWeight();
    }

    vm.changeWeight = function () {
      if (vm.settings.weight_barcode_length && vm.settings.weight_barcode_prefix && vm.settings.weight_barcode_code) {
        vm.settings.weight_barcode_weight = vm.settings.weight_barcode_length - (vm.settings.weight_barcode_prefix.toString().length) - vm.settings.weight_barcode_code;
        if (!vm.settings.weight_barcode_weight || vm.settings.weight_barcode_weight < 0) {
          vm.settings.weight_barcode_weight = undefined;
        }
      } else {
        vm.settings.weight_barcode_weight = undefined;
      }
    }

    attrSettingsService.getSettings().then(function (res) {
      vm.settings = res.data;
      vm.settings.inherit_category_attributes = vm.settings.use_category_attributes;

      if (!vm.settings.barcode_format) {
        vm.settings.barcode_format = 'EAN13';
        vm.changeFormat('barcode_format', 'barcode_length')
      }
      if (!vm.settings.weight_barcode_format) {
        vm.settings.weight_barcode_format = 'EAN13';
        vm.changeFormat('weight_barcode_format', 'weight_barcode_length')
      }
      
      if(!vm.settings.weight_barcode_source){
        vm.settings.weight_barcode_source = 'ITEM_CODE';
      }
      if (vm.settings.use_auto_codes === null) {
        vm.settings.use_auto_codes = true;
        vm.settings.code_len = 5;
      }
      if(!vm.settings.barcode_length){
        vm.settings.barcode_length = 7;
      }
      if(!vm.settings.barcode_first_digits){
        vm.settings.barcode_first_digits = 22;
      }
      if(!vm.settings.weight_barcode_prefix){
        vm.settings.weight_barcode_prefix = 21;
        vm.changeCode();
      }
      if (vm.settings.elements) {
        angular.forEach(vm.settings.elements, function (value) {
          if (value.attribute) {
            value.attribute.$$enabled = true;
          } else {
            value.block.$$enabled = true;
            angular.forEach(value.block.attributes, function (attr) {
              attr.$$enabled = true;
            });
          }
        });
      }
      angular.forEach(vm.settings.elements, function (val) {
        if (val.attribute && val.attribute.required) {
          helpService.addId(val.attribute)
        }
        if (!val.attribute && val.block && val.block.attributes) {
          angular.forEach(val.block.attributes, function (attr) {
            if (attr.attribute && attr.attribute.required) {
              helpService.addId(attr.attribute)
            }
          })
        }
      });
      vm.changeExample();
    });

    vm.checkAttrError = function () {
      vm.wrongData = false;
      angular.forEach(vm.settings.elements, function (value) {
        if (value.attribute) {
          if (value.attribute.$$enabled && value.attribute.uinqError) vm.wrongData = true;
        } else {
          if (value.block.$$enabled && value.block.uinqError) vm.wrongData = true;
          angular.forEach(value.block.attributes, function (attr) {
            if (attr.$$enabled && attr.uinqError) vm.wrongData = true;
          });
        }
      });
      if (vm.wrongData) {
        $scope.attrSettings.$error.errorUnique = true;
      } else {
        delete $scope.attrSettings.$error.errorUnique;
      }
    };

    // для возврата на предыдущую страницу
    vm.returnToPage = function () {
      var prev = cardHistory.popStep();
      if (prev) {
        $state.go(prev.name || 'catalog', prev.param || {parent: $state.params.parent});
      } else {
        $state.go('catalog', {parent: $state.params.parent});
      }
    };

    // В методе выполняются подготовительные операции перед сохранением
    vm.prepareSave = function () {
      /* удаление вспомагательной информации из объекта категории */
      var attrObj = [];
      angular.forEach(vm.settings.elements, function (value) {
        if (value.attribute) {
          if (value.attribute.$$enabled) {
            delete value.attribute.canDelete;
            delete value.attribute.uinqError;
            delete value.attribute.errorText;
            attrObj.push(value);
          }
        } else {
          var tempBlock = {};
          delete value.block.uinqError;
          delete value.block.errorText
          if (value.block.$$enabled) {
            delete value.block.id;
            delete value.block.canDelete;
            tempBlock = angular.copy(value);
            tempBlock.block.attributes = [];

            angular.forEach(value.block.attributes, function (attr) {
              if (attr.$$enabled) {
                delete attr.canDelete;
                delete attr.uinqError;
                delete attr.errorText;
                tempBlock.block.attributes.push(attr);
              }
            });
            attrObj.push(tempBlock);
          }
        }
      });

      vm.settings.elements = attrObj;

    }

    vm.save = function (ignoreStopSaving) {
      var deferred = $q.defer();
      // подготовка структур в соответствие АПИ
      vm.prepareSave();
      var stopSaving = !!_.find(vm.settings.elements, function (val) {
        return (val.attribute && !val.attribute.$$uiid && val.attribute.required)
          || (!val.attribute && val.block && val.block.attributes && !!_.find(val.block.attributes, function (attr) {
            return attr && !attr.$$uiid && attr.required;
          }));
      });

      if (stopSaving && !ignoreStopSaving) {
        vm.info();
        return deferred.reject();
      }
      // Блок обновления
      return attrSettingsService.updateSettings(vm.settings).then(function (res) {
        $scope.attrSettings.$setPristine();
        // Переход на предыдущую страницу
        vm.returnToPage();
      }, function (error) {
        if (error.status == 409 && (error.data.code == 'non_unique' || error.data.code == 'business_rule')) {
          switch (error.data.message) {
            case "impossible_to_modify_there_are_documents":
              errorMessageService.showModal({
                message: "При обновлении произошла ошибка",
                submessage: {
                  data: {
                    message: "Изменение невозможно, так как имеются атрибуты, участвующие в формировании складских позиций"
                  }
                }
              });
              break;
            case "not_unique_vendor_code":
              errorMessageService.showModal({
                message: "Невозможно установить флаг уникальности артикулов",
                submessage: {
                  data: {
                    message: "В каталоге уже существуют не уникальные артикулы, например: " + error.data.object_name
                  }
                }
              });
              break;
            default:
              vm.isSetDirty = true;
              angular.forEach(vm.settings.elements, function (value) {
                if (error.data.code == 'business_rule') {
                  if (value.attribute) {
                    if (error.data.rule == 'DOMAIN_ATTRIBUTE_NAME' && error.data.object_name == value.attribute.name) {
                      value.attribute.uinqError = true;
                      value.attribute.errorText = 'Атрибут используется в категории';
                    }
                  } else {
                    if (error.data.rule == 'DOMAIN_GROUP_NAME' && value.block.name == error.data.object_name) {
                      value.block.uinqError = true;
                      value.block.errorText = 'Группа используется в категории';
                    }
                    angular.forEach(value.block.attributes, function (attr) {
                      if (error.data.rule == 'DOMAIN_ATTRIBUTE_NAME ' && error.data.object_name == attr.name) {
                        attr.uinqError = true;
                        attr.errorText = 'Атрибут используется в категории';
                      }
                    });
                  }
                }
                if (error.data.code == 'non_unique') {
                  if (value.attribute) {
                    if (error.data.constraint_name == 'DOMAIN_ATTRIBUTE_NAME' && error.data.parameters[0].value == value.attribute.name) {
                      value.attribute.uinqError = true;
                      value.attribute.errorText = 'Атрибут уже используется';
                    }
                  } else {
                    if (error.data.constraint_name == 'DOMAIN_GROUP_NAME' && value.block.name == error.data.parameters[0].value) {
                      value.block.uinqError = true;
                      value.block.errorText = 'Группа уже используется';
                    }
                    angular.forEach(value.block.attributes, function (attr) {
                      if (error.data.constraint_name == 'DOMAIN_ATTRIBUTE_NAME' && error.data.parameters[0].value == attr.name) {
                        attr.uinqError = true;
                        attr.errorText = 'Атрибут уже используется';
                      }
                    });
                  }
                }
              });
              $timeout(function () {
                $anchorScroll("errorAnchor");
                vm.checkAttrError();
              }, 0);
              return deferred.reject();
          }

          if (error.data.message == "impossible_to_modify_there_are_documents") {

          } else {

          }
        } else {
          errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error});
          return deferred.reject();
        }
      })
    };

    vm.info = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/info-popup.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.class = "info";
          $scope.reqAttrButton = true;
          $scope.mainTxt = "Вы создали новый обязательный атрибут.";
          $scope.descrTxt = 'После сохранения изменений все товары получат статус "Черновик". В статусе "Черновик" товары недоступны для продажи и по ним нельзя сформировать ни один документ.<br>Продолжить сохранение?';
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.save = function () {
            vm.issetReqAttr = false;
            vm.save(true);
            $uibModalInstance.dismiss();
          };
        }
      });
    }

    vm.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        vm.isSetDirty = true;
        return true;
      }
      return false;
    }

    vm.setDirty = function () {
      vm.isSetDirty = true;
      utilsService.setDirty($scope.attrSettings);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    vm.crud = function (status) {
      switch (status) {
        case 'save':
          if ($scope.attrSettings.$valid && !vm.wrongData) {
            return vm.save()
          } else {
            return vm.setDirty();
          }
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    }

    vm.changeExample = function () {
      vm.exMin = "1";
      while (vm.exMin.length < vm.settings.code_len) {
        vm.exMin = "0" + vm.exMin;
      }
      vm.exMax = "9";
      while (vm.exMax.length < vm.settings.code_len) {
        vm.exMax = "9" + vm.exMax;
      }
    }

  }
})();

(function() {
  'use strict';

angular.module('frontend').controller('alcoholSettingsController', alcoholSettingsController);

  function alcoholSettingsController($scope, $filter, helpService, $state, $anchorScroll, alcoholSettings, cardHistory, catalogService, companyService, errorMessageService, $rootScope, $q, utilsService, $window) {
    var vm = this;
    vm.attributes = {};
    vm.errorAttrInd = [];

    // для возврата на предыдущую страницу
    vm.returnToPage = function(){
      var prev = cardHistory.popStep();
      if(prev && prev.name){
        $state.go(prev.name, prev.param);
      }
    };

    vm.alcoholSettings = alcoholSettings || {calendars: [], beer_accounting_type: "REGISTER1"};

    function initAlcSettings(){
      angular.forEach(vm.alcoholSettings.calendars, function(calendar){
        helpService.addId(calendar);
        angular.forEach(calendar.calendar_items, function(item){
          if(item.type == 'ANY_DAY'){
            calendar.$$type = 'ANY_DAY';
          }else if(item.type == 'WORKING_DAY' || item.type == 'DAY_OFF'){
            calendar.$$type = 'WORKING_DAY_OFF';
          }else if(item.type == 'DAY_OF_WEEK'){
            calendar.$$type = 'DAY_OF_WEEK';
          }
        });
      });

      angular.forEach(vm.alcoholSettings.companies, function(company) {
        angular.forEach(company.division_links, function(division_link) {
          angular.forEach( vm.alcoholSettings.calendars, function(calendar) {
            if (calendar.name === division_link.calendar_name) {
              division_link.$$uiid = calendar.id
            }
          });
        });
      });

      if(!vm.alcoholSettings.calendars.length){
        vm.alcoholSettings.calendars.push({
            name: "Основной календарь",
            $$type: 'ANY_DAY',
            $$hasException: false,
            calendar_items: [
              {
                type: "ANY_DAY",
                from_time: "08:00",
                to_time: "23:00",
                $$mode: 'interval'
              }
            ]
        });
      }

      // подготовка объекта vm.alcoholSettings перед выводом
      angular.forEach(vm.alcoholSettings.calendars, function(calendar){
        calendar.$$hasException = false;
        angular.forEach(calendar.calendar_items, function(item){
          if(item.from_time) item.from_time = item.from_time.substr(0, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH);
          if(item.to_time) item.to_time = item.to_time.substr(0, $rootScope.controlSettings.OPTION_DEFAULT_LENGTH);
          item.$$mode = (item.from_time == item.to_time && item.to_time == "00:00")? 'not' : 'interval';
          if(item.exceptional_date){
            item.exceptional_date_model = moment(item.exceptional_date);
          }
          if(item.type == 'EXCEPTIONAL_DATE'){
            calendar.$$hasException = true;
          }
        });
      });
    }

    // автокомплит для атрибутов
    vm.refreshAttr = function(search, dataType, index){
      catalogService.getAttr(search, 'CATEGORY', dataType, true).then(function(res){
        vm.attributes['attr' + index] = res.data.items;
      });
    };
    // проверка уникальности атрибутов
    vm.checkAttribute = function(){
      var attributes = [];
      vm.errorAttrInd = [];
      attributes.push(vm.alcoholSettings.attribute_for_alcohol_product_flag);
      attributes.push(vm.alcoholSettings.attribute_for_alcohol_type);
      attributes.push(vm.alcoholSettings.attribute_for_alcohol_percentage);
      attributes.push(vm.alcoholSettings.attribute_for_alcohol_label);
      angular.forEach(attributes, function(attr1, key1){
        angular.forEach(attributes, function(attr2, key2){
          if(attr1.name && attr2.name && key1 < key2 && attr1.name == attr2.name){
            vm.calendarUniqError = true;
            vm.errorAttrInd.push(key1);
            vm.errorAttrInd.push(key2);
          }
        });
      });
      if(vm.errorAttrInd.length){
        $scope.alcoholSettings.$error.errorAttrUnique = true;
      }else{
        delete $scope.alcoholSettings.$error.errorAttrUnique;
        if(_.isEmpty($scope.alcoholSettings.$error)) $scope.alcoholSettings.$valid = true;
      }
    };

    vm.save = function(){
      var deferred = $q.defer();
      var saveSettings = angular.copy(vm.alcoholSettings);
      angular.forEach(saveSettings.calendars, function(calendar){
        angular.forEach(calendar.calendar_items, function(item){
          item.from_time = item.from_time + ':00';
          item.to_time = item.to_time + ':00';
          if(item.type == "EXCEPTIONAL_DATE" && item.exceptional_date_model) {
            item.exceptional_date = (item.exceptional_date_model.unix())*1000;
            delete item.exceptional_date_model;
          }
        });
      });
      delete saveSettings.attribute_for_alcohol_product_flag.source;
      delete saveSettings.attribute_for_alcohol_type.source;
      delete saveSettings.attribute_for_alcohol_percentage.source;
      delete saveSettings.attribute_for_alcohol_label.source;

      return catalogService.updateAlcoholSettings(saveSettings).then(function(res) {
        $rootScope.alcohol_products = res.data.alcohol_products;
        $scope.alcoholSettings.$setPristine();
        vm.returnToPage();
      },
      function (error) {
        errorMessageService.showModal({message: 'При сохранении произошла ошибка', submessage: error});
        return deferred.reject();
      });
    };

    /* Данные для поиска календарей */
    vm.refreshCalendars = function(search, division) {
      if(!division.$$search) division.$$search = vm.alcoholSettings.calendars;
      if(vm.alcoholSettings.calendars.length > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
        division.$$search = $filter('filter')(vm.alcoholSettings.calendars, {name: search});
        if(division.$$search[0] && division.$$search.length > $rootScope.controlSettings.OPTION_DEFAULT_LENGTH){
          if(!division.$$search[0].class){
            division.$$search.unshift({ name: 'Показано ' + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + ' из ' + division.$$search.length, class: "select-info"});
          }else{
            division.$$search[0].name = 'Показано ' + $rootScope.controlSettings.OPTION_DEFAULT_LENGTH + ' из ' + division.$$search.length;
          }
        }
      }
    };

    vm.isHasValidErrors = function(errors){
      var errayErrors = Object.keys(errors);
      if (errayErrors.length && (errayErrors.length > 1 || errayErrors[0] != 'required')) {
        vm.isSetDirty = true;
        return true;
      }
      return false;
    }

    vm.setDirty = function () {
      vm.isSetDirty = true;
      utilsService.setDirty($scope.alcoholSettings);
      $window.scrollTo(0, angular.element('input.ng-invalid, div.ng-invalid, textarea.ng-invalid').offset().top - 20);
      return $q.when();
    };

    initAlcSettings();
    vm.crud = function (status) {
      switch(status) {
        case 'save':
          if ($scope.alcoholSettings.$valid && _.isEmpty($scope.alcoholSettings.$error) && !vm.errorAttrInd.length) {
            return vm.save()
          } else {
            return vm.setDirty();
          }
          break;
        case 'return':
          vm.returnToPage();
          return $q.when();
          break;
        default :
          return $q.when();
          break;
      }
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('frontend')
    .component('appHeader', {
      transclude: true,
      bindings: {
        hideAuthHeader: '<'
      },
      templateUrl: 'app/base/header/header.html',
      controller: function ($scope,
                            $state,
                            $log,
                            auth,
                            $rootScope,
                            $uibModal,
                            bankProductRequestService,
                            surveyService,
                            $interval,
                            $timeout,
                            POLLING_SURVEY_MESSAGE_RATE,
                            requestStatus,
                            partnersService,
                            cartService) {
        var vm = this;
        var watcher;
        vm.logout = function () {
          auth.showLogoutConfirm();
        };

        vm.state = $state;

        /**
         * Метод обновляет информацию о назначенных пользователю сообщениях
         */
        vm._refreshMessagesInfo = function () {
          if (!$rootScope.user) // только авторизованные пользователи могут запрашивать наличие сообщений
            return;
          return surveyService.getNewUserSurvey().then(function (data) {
            vm.messagesCount = data.data.length;
            _.forEach(data.data, function (message) {
              var showMessage = true;

              // если уже было показано, но скорее всего это не понадобится,т.к. в следующем запросе эти сообщения приходить не должны
              if (message.pop_up_date || (message.survey_responses && message.survey_responses.length))
                return;

              // проерка на разрешенное время демонстрации всплывающего окна
              if (message.pop_up_time_from || message.pop_up_time_to) {
                var now = moment().tz($rootScope.user.time_zone).valueOf();
                var pop_up_time_from = moment(message.pop_up_time_from, "HH:mm:ss").valueOf()
                var pop_up_time_to = moment(message.pop_up_time_to, "HH:mm:ss").valueOf()
                if ((message.pop_up_time_from && pop_up_time_from > now) ||
                  (message.pop_up_time_to && now > pop_up_time_to)) {
                  showMessage = false;
                }
              }

              if (showMessage) {
                // установка времени демонстрации всплывающего окна
                surveyService.setUserSurveyPopup(message.id);
                if (message.survey.auto_send) {
                  // запрос тела опроса
                  surveyService.getSurvey(message.survey.id).then(function (res) {
                    var messageData = angular.fromJson(res.data.body);
                    if (messageData.items.length == 1) {
                      requestStatus.message(angular.fromJson(res.data.body), function (step, value) {
                        // отправка быстрого ответа
                        surveyService.saveSurveyResponse({
                          id: message.id,
                          survey_responses:[{
                            step: step,
                            response: value
                          }]
                        }).then(function (res) {
                          $scope.$emit("messageUpdated"); // уведомление об изменении статуса сообщения
                        })
                      });
                    } else {
                      requestStatus.info("Получено новое уведомление", 'info', "Посмотреть", "#/messages?message_id=" + message.id);
                    }
                  });
                } else {
                  requestStatus.info("Получено новое уведомление", 'info', "Посмотреть", "#/messages?message_id=" + message.id);
                }
              }
            });
          }, function () {
            // не критично, не уведомляем
          });
        };

        vm._refreshBonuses = function(){
          if (!$rootScope.user || !$rootScope.hasRole('bonuses.read')) // только авторизованные пользователи могут запрашивать наличие сообщений
            return;
          partnersService.getBonuses().then(function(res){
            $rootScope.bonusesData = {
              accrued_bonuses_amount: res.data.accrued_bonuses_amount,
              payable_bonuses_amount: res.data.payable_bonuses_amount,
              paid_bonuses_amount: res.data.paid_bonuses_amount
            };
          }, function () {
            // не критично, не уведомляем
            //requestStatus.error('Во время получения информации о бонусах произошла ошибка.');
          });
        };

        vm._refreshCart = function(){
          if (!$rootScope.user) // только авторизованные пользователи могут запрашивать данные по корзине
            return;
          cartService.getCartCount().then(function (data) {
            $rootScope.cartCount = data.data.item_count;
          });
        };

        $timeout(function () {
          vm._refreshCart();
          vm._refreshBonuses();
          vm._refreshMessagesInfo(); // загрузка при старте
        }, 2000); // ожидание установки пользователя

        $scope.$on('updateMessages', function() {
          vm._refreshMessagesInfo();
        });

        // настройка шедуллера для обновления информации о сообщениях для пользователя
        vm.messagesCountTimer = $interval(function () {
          // интервальная загрузка
          vm._refreshMessagesInfo();
          vm._refreshCart();
        }, POLLING_SURVEY_MESSAGE_RATE * 1000);

        if (!$rootScope.user) {
          _activateWatcher();
        } else {
          _loadBankProducts();
        }

        /**
         * Подписка на событие успешного входа
         */
        $scope.$on('login-success', function () {
          _loadBankProducts();
          // обновление списка сообщений сразу после входа без ожидания таймера
          vm._refreshMessagesInfo();
        });

        function _activateWatcher() {
          watcher = $scope.$watch(function () {
            return $rootScope.user;
          }, function (val) {
            if (val) {
              _loadBankProducts();
              watcher();
            }
          })
        }

        function _loadBankProducts() {
          bankProductRequestService.getBankProducts(true)
            .then(function (res) {
              vm.activeBankProductRequestCounter = res.data.length;
            });
        }

        function getInitials(name) {
          var nameArr = name.split(' ');
          vm.initials = nameArr[0].charAt(0);
          if (nameArr[1]) {
            vm.initials += nameArr[1].charAt(0);
          }
        }

        vm.getName = function () {
          if ($rootScope.user) {
            getInitials($rootScope.user.name);
            return $rootScope.user.name;
          }
          return ''
        };

        vm.getPic = function () {
          if ($rootScope.user && $rootScope.user.user_pic) {
            return $rootScope.user.user_pic.url;
          }
          return ''
        };

        // печать отчета о продажах
        vm.openPrintSalesTotalDialog = function () {
          $uibModal.open({
            size: 'middle-width',
            component: 'printSalesReport',
            controllerAs: '$ctrl'
          });
        };

        // печать прайслиста
        vm.openPriceListPrintModal = function () {
          $uibModal.open({
            component: 'printPriceList',
            size: 'middle-width',
            controllerAs: '$ctrl',
            resolve: {
              mode: function () {
                return 'RETAIL'
              }
            }
          });
        };

        vm.openPrintUsersDialog = function () {
          $uibModal.open({
            component: 'printUsers',
            size: 'small-width',
            controllerAs: '$ctrl'
          });
        };

        vm.openInvitationModal = function () {
          $uibModal.open({
            component: 'invitation',
            size: 'middle-width',
            controllerAs: 'vm'
          })
        };

        // отчет о прибылях и убытках
        vm.openReportProfitAndLoss = function () {
          $uibModal.open({
            component: 'reportProfitAndLoss',
            size: 'middle-width',
            controllerAs: 'reportProfitAndLossCtrl'
          });
        };

        // отчет о движении денежных средств
        vm.openReportCashFlow = function () {
          $uibModal.open({
            component: 'reportProfitAndLoss',
            size: 'middle-width',
            controllerAs: 'reportProfitAndLossCtrl',
            resolve: {
              mode: function () {
                return 'cashFlow'
              },
              title: function () {
                return 'Печать отчета о движении денежных средств '
              }
            }
          });
        };

        $scope.$on("$destroy", function (event) {
          // остановка таймера
          if (angular.isDefined(vm.messagesCountTimer)) {
            $interval.cancel(vm.messagesCountTimer);
          }
        });
      }
    });
  //component ends
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service('deadendMessage', function () {
      var deadend_message = {
        confirmemail: {
          expired: '<span class="help-message">Регистрация группы и учетной записи администратора<br> группы не произведена. Пройдите повторно <br><a ui-sref="register">процедуру регистрации</a>.</span>',
          not_found: '<span class="help-message">Скопируйте ссылку из письма в адресную строку<br> браузера или обратитесь в службу поддержки.</span>',
          used: '<span class="help-message">Регистрация группы и учетной записи администратора<br> группы произведена ранее.</span>'
        },
        setpassword: {
          expired: '<span class="help-message">Регистрация пользователя не произведена.<br> Свяжитесь с администратором.</span>',
          not_found: '<span class="help-message">Невозможно подтвердить регистрацию пользователя.<br> Скопируйте ссылку из письма в адресную строку<br> браузера или свяжитесь с администратором.</span>',
          used: '<span class="help-message">Регистрация пользователя произведена ранее</span>'
        },
        recover: {
          expired: '<span class="help-message">Пароль не восстановлен. Пройдите процедуру<br> восстановления пароля повторно.</span>',
          not_found: '<span class="help-message">Невозможно восстановить пароль. Скопируйте ссылку<br> из письма в адресную строку браузера или<br> свяжитесь с администратором.</span>',
          used: '<span class="help-message">Процедура восстановления пароля<br> произведена ранее.</span>'
        },
        confirmnewemail: {
          expired: '<span class="help-message">Новый адрес электронной почты не подтвержден.<br> Пройдите процедуру смены адреса<br> электронной почты повторно.</span>',
          not_found: '<span class="help-message">Невозможно подтвердить новый адрес электронной почты.<br> Скопируйте ссылку из письма в адресную строку<br> браузера или свяжитесь с администратором.</span>',
          used: '<span class="help-message">Новый адрес электронной почты<br> подтвержден ранее</span>'

        },
        other: {
          not_found: '<span class="help-message help-message-not_found">Страница, которую вы пытаетесь открыть, не существует. Проверьте корректность ссылки или воспользуйтесь навигационным меню</span>',
          server_error: '<span class="help-message">На нашем сервере что-то пошло не так. Попробуйте <a ng-click="$emit(\'goBack\')">обновить страницу</a>.' +
          'Если не помогает, то это ошибка, о которой мы уже знаем и прилагаем все усилия для ее устранения. ' +
          'Извините, что доставили вам неудобства. Попробуйте повторить ваши действия позже. ' +
          '<a ui-sref="home">Главная страница</a></span>',
          need_role: '<span class="help-message help-message-need_role">У вас нет доступа на эту страницу. Обратитесь к администратору.</span>',
          deploy: '<span class="help-message">На нашем сервере ведутся технические работы.<br> Попробуйте повторить ваши<br> действия через 5 минут.</span>'
        }
      };

      this.getMessage = function (from, reason) {
        if (deadend_message[from] && deadend_message[from][reason]) {
          return deadend_message[from][reason];
        } else {
          return deadend_message['other']['not_found'];
        }
      }

      this.getTitle = function (from, reason) {
        if (deadend_message[from] && deadend_message[from][reason]) {
          switch (reason) {
            case 'not_found':
                return 'Некорректная ссылка';
            case 'expired':
                return 'Ссылка просрочена';
            case 'used':
                return 'Ссылка используется повторно';
            default :
              break;
          }
        }
      }

    })

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .component('deadend', {
      templateUrl: 'app/base/deadend/deadend.html',
      controller: function ($scope, $state, $window, $rootScope, cardHistory, deadendMessage, $stateParams, $timeout) {
        var timer;
        var previousHref = ''; // для хранения href предыдущей странички
        $rootScope.progressbar.complete();
        // очиста интервала если компонент прервался 
        $scope.$on("$destroy", function() {
          if (timer) {
            clearTimeout(timer);
            timer = undefined;
          }
        });

        function goBack() {
          var prev = cardHistory.popStep();
          if (previousHref) {
            $window.location = previousHref;
          } else if (prev) {
            $state.go(prev.name || 'home', prev.param);
          }
        }
        
        $scope.$on('goBack' , function () {
          goBack();
        });

        // Для записи href предыдущей странички
        $rootScope.$on('$locationChangeStart', function (event, current, previous) {
          if (previous.indexOf("/error/other") == -1){
            previousHref = previous;
          }
          event.preventDefault();
          clearTimeout(timer);
          if (event && event.stopPropagation) {
            event.stopPropagation();
          }
          goBack();
        });

        // для отправки назад, если F5
        angular.element($window).on('beforeunload', function (event, current, previous) {
            event.preventDefault();
            clearTimeout(timer);
            goBack();
        });

        // проверка связи каждые 30 сек
        timer = $timeout(function() {
          goBack();
        }, 30000);

        var stateName = $state.current.name;
        switch (stateName) {
          case '404':
            $scope.status = stateName;
            $scope.title = 'Страница не найдена';
            break;
          case '500':
            $scope.status = stateName;
            $scope.title = 'внутренняя ошибка сервера';
            break;
          case '401':
            $scope.status = stateName;
            $scope.title = 'недостаточно прав';
            break;
          default:
            $scope.status = '<img src="data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22369%22%20height%3D%22160%22%20viewBox%3D%220%200%20369%20160%22%3E%0A%20%20%20%20%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22369%22%20height%3D%22160%22%20fill%3D%22%23FAFAFA%22%20rx%3D%2280%22%2F%3E%0A%20%20%20%20%20%20%20%20%3Ctext%20fill%3D%22%23681A1B%22%20font-family%3D%22PTSans-Bold%2C%20PT%20Sans%22%20font-size%3D%2272%22%20font-weight%3D%22bold%22%20letter-spacing%3D%221.44%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Ctspan%20x%3D%2276.464%22%20y%3D%2299%22%3Ehttp%3A%2F%2F%3C%2Ftspan%3E%0A%20%20%20%20%20%20%20%20%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3Cpath%20stroke%3D%22%23CD343E%22%20stroke-linecap%3D%22round%22%20stroke-width%3D%227%22%20d%3D%22M64%2081h240%22%2F%3E%0A%20%20%20%20%3C%2Fg%3E%0A%3C%2Fsvg%3E" class="status">';
            $scope.title = deadendMessage.getTitle($stateParams.from, $stateParams.reason);
            break;
        }

      }
    })
    .directive('deadendText', [ 'deadendMessage', '$stateParams', '$state' , function (deadendMessage, $stateParams, $state) {
      return {
        restrict: "E",
        template: function() {
          return deadendMessage.getMessage($stateParams.from || $state.current.from, $stateParams.reason || $state.current.reason);
        }
      }
    }]);
})();

'use strict';
angular.module('frontend').component('registration', {
  templateUrl: 'app/auth/register/register.html',
  bindings : {
    isPartner : '<'
  },
  controller: function ($scope, auth, $state, $filter, $timeout, $location, $q, $uibModal, $window, $rootScope, utilsService, phoneConfirmationService, errorMessageService, requestStatus, PHONE_ATTEMPTS) {
    var registerCtrl = this;
    $scope.phoneAttempts = PHONE_ATTEMPTS;
    $scope.phoneAttemptsCashier = PHONE_ATTEMPTS;
    $scope.userData = {
      company: {
        type: "LEGAL_ENTITY",
        activity_areas: []
      },
      cashier: {},
      owner: {$$confirmCode: ''},
      promo_code: ($state.params && $state.params.promo_code? $state.params.promo_code: undefined),
      partner_code: ($state.params && $state.params.partner_code? $state.params.partner_code: undefined)
    };

    $scope.errorMessage = '';
    $scope.domainStatus = '';
    $scope.domainTip = '';
    $scope.passNoMatch = false;
    $scope.isSuccessRegister = false;
    $scope.login = $location.search().login;
    $scope.domain = $location.search().domain;
    $scope.isShortRegister = true;
    $scope.addressControls = {}; // структура для управления директивой адреса
    $scope.addressOptions = {};
    $scope.cashierEndTimer = true;
    $scope.userEndTimer = true;
    // флаги компонента с универсальным вводом телефона и почты
    $scope.userMailPhoneFlags = {};

    registerCtrl.returnToPage = function() {
      $state.go('login');
    };

    $scope.openPromo = function() {
      var modal = $uibModal.open({
        size: 'small-width',
        component: 'promoModal',
        controllerAs: 'promoModalCtr',
        resolve: {
          userData: function() {
            return $scope.userData;
          }
        }
      });
      modal.result.then(function(res){
        $scope.userData.promo_code = res.promo_code;
        $scope.userData.partner_code = res.partner_code;
      });
    };

    $scope.checkDomain = function(domain){
      if(domain && /^[a-zA-Z0-9-]*$/.test(domain)){
        $scope.domainStatus = "load";
        auth.checkDomain(domain).then(function() {
          $scope.domainStatus = "error";
          $scope.domainTip = "Эта группа занята";
        }).catch(function () {
          $scope.domainStatus = "success";
          $scope.domainTip = "Можете использовать эту группу";
        });
      }else{
        $scope.domainStatus = '';
        $scope.domainTip = '';
      }
    };

    $scope.checkPassword = function(){
      $scope.passNoMatch = $scope.userData.owner.password &&
        $scope.userData.$$repeatedPassword &&
        $scope.userData.owner.password !== $scope.userData.$$repeatedPassword;
    };

    $scope.checkCashierPassword = function(){
      $scope.cashPassNoMatch = $scope.userData.cashier.password &&
        $scope.userData.$$repeatedCashPassword &&
        $scope.userData.cashier.password !== $scope.userData.$$repeatedCashPassword;
    };

    /**
     * Проставляет валидность поля логина по запрещённым почтовым доменам.
     *
     * Назначение: подсветить email и не дать отправить форму, если в адресе есть gmail.com и т.п.
     */
    $scope.validateLoginDomain = function() {
      if (registerCtrl.long && registerCtrl.long.login) {
        registerCtrl.long.login.$setValidity('forbiddenEmailDomain', !utilsService.hasForbiddenEmailDomain($scope.universalLogin));
      }
    };

    $scope.submit = function () {
      var form = registerCtrl.short || registerCtrl.long;
      $scope.validateLoginDomain();
      if (utilsService.hasForbiddenEmailDomain($scope.universalLogin)) {
        if (registerCtrl.long.login) {
          registerCtrl.long.login.$setDirty();
        }
        $window.scrollTo(0, 0);
        return;
      }
      if ( form.$valid ) {
        form.$setPristine();
        register();
      } else {
        angular.forEach( form.$error ,function (control) {
          for (var i = 0; i < control.length; i++) {
            control[i].$setDirty()
          }
        })
      }
    };

    $scope.addressCheck = function(addrObj){
      return (addrObj && !addrObj.id) ? $scope.addressControls.checkAddr(addrObj.address_as_string).then(function (res) {
        return res;
      }) : $q.when({});
    };

    $scope.isValidAddr = function(addr){
      if(!addr) return true;
      if(addr.data && addr.data.view_ref){
        return !(addr.data.view_ref.qc == 2 && !addr.data.view_ref.accepted);
      }else{
        return true;
      }
    };

    function register() {
      // провека наличия и подтверждения телефона пользователя
      if ($scope.userMailPhoneFlags.isPhone && !$scope.userData.owner.phone_confirmed) {
        registerCtrl.long.login.$setValidity('confirmError', false);
        if (registerCtrl.long.confirmCode) {
          registerCtrl.long.confirmCode.$setValidity('confirmError', false);
        }
        $window.scrollTo(0, 0);
        return;
      }

      // провека наличия и подтверждения телефона кассира
      if ($scope.userData.needCashier && !$scope.userData.cashier.phone_confirmed) {
        registerCtrl.long.cashierLogin.$setValidity('confirmError', false);
        if (registerCtrl.long.cashierConfirmCode) {
          registerCtrl.long.cashierConfirmCode.$setValidity('confirmError', false);
        }
        $window.scrollTo(0, 2000);
        return;
      }

      $scope.addressCheck($scope.userData.owner.location).then(function(res){
        if($scope.isValidAddr(res)) {
          if ($scope.userData.owner.password === $scope.userData.$$repeatedPassword &&
              $scope.userData.company.activity_areas.length && (!$scope.userData.needCashier ||
              $scope.userData.cashier.password === $scope.userData.$$repeatedCashPassword)) {
            auth.logout().then(function () {
              auth.ensureSession(true).then(function () {
                var registerData = {
                  domain: $scope.userData.domain,
                  company: $scope.userData.company,
                  acquiring_bank: ($scope.userData.acquirerAgreement)? $scope.userData.acquiring_bank : null,
                  promo_code: $scope.userData.promo_code || null,
                  partner_code: $scope.userData.partner_code || null,
                  owner: {
                    password: $scope.userData.owner.password,
                    email: ($scope.userMailPhoneFlags.isEmail && !$scope.userMailPhoneFlags.isPhone)? $scope.universalLogin : null,
                    name: $scope.userData.owner.name,
                    surname: $scope.userData.owner.surname,
                    patronymic: $scope.userData.owner.patronymic,
                    phone: (!$scope.userMailPhoneFlags.isEmail && $scope.userMailPhoneFlags.isPhone)? $scope.universalLogin : null,
                    phone_confirmation: $scope.userData.owner.phone_confirmation || null,
                    phone_confirmed: $scope.userData.owner.phone_confirmed || null,
                    location: $scope.userData.owner.location || null,
                    time_zone: ($scope.userData.owner.time_zone)? $scope.userData.owner.time_zone.timezoneId : null,
                    inn: $scope.userData.owner.inn || null,
                  }
                };
                if ($scope.userData.needCashier) {
                  registerData.cashier = {
                    password: $scope.userData.cashier.password,
                    name: $scope.userData.cashier.name,
                    surname: $scope.userData.cashier.surname,
                    patronymic: $scope.userData.cashier.patronymic,
                    phone: $scope.userData.cashier.phone || null,
                    phone_confirmation: $scope.userData.cashier.phone_confirmation || null,
                    phone_confirmed: $scope.userData.cashier.phone_confirmed || null,
                    inn: $scope.userData.cashier.inn || null
                  };
                }
                auth.register(registerData)
                  .then(function (res) {
                    $scope.isSuccessRegister = true;
                    $scope.isWrongRegisterData = false;
                  })
                  .catch(function (err) {
                    $scope.isSuccessRegister = false;
                    $scope.isWrongRegisterData = true;
                    if (err.status === 409) {
                      $scope.errorMessage = "Группа, которую вы ввели уже занята";
                      $scope.domainStatus = "error";
                      $scope.domainTip = "Эта группа занята";
                    } else {
                      $scope.errorMessage = "В процессе регистрации произошла ошибка. Повторите попытку позже или обратитесь в службу поддержки.";
                    }
                  });
              });
            });
          } else {
            if (!$scope.userData.company.activity_areas.length) {
              $scope.noAreas = true;
              $window.scrollTo(0, 0);
            } else {
              $scope.isSuccessRegister = false;
              $scope.isWrongRegisterData = true;
              $scope.errorMessage= "Введенные пароли не совпадают";
            }
          }
        }
      });
    }

    function getUniqueCheckObj(constraintName, params) {
      return {
        constraint_name: constraintName,
        parameters: params
      };
    }

    function onUniqueCheckError(error) {
      if (error.status === 409) {
        setFieldValidity(error.data.parameters, false)
      }
    }

    function setFieldValidity(params, validity) {
      angular.forEach(params, function (field) {
        if ($scope.addCashier[field.name]) {
          $scope.addCashier[field.name].$setValidity('unique', validity);
        }
      });
    }

    if ($state.current.name === 'home') {
      $scope.$on('startNewRegistration',function () {
        var form = registerCtrl.short || registerCtrl.long;

        if ($scope.userData && $scope.isSuccessRegister) {
          form.$setUntouched();
          form.$setPristine();
          $scope.userData = undefined;
          $scope.accept = false;
          $scope.isSuccessRegister = false;
        }

      })
    }

    /**
     * Метод для проверки статуса текущего телефонного номера
     */
    $scope.isPhoneConfirmed = function(isCashier){
      if (isCashier) {
        return $scope.userData.cashier.phone_confirmed && $scope.userData.cashier.phone == $scope.cashierBasePhone;
      } else {
        return $scope.userData.owner.phone_confirmed && $scope.universalLogin == $scope.userBasePhone;
      }
    }

    /**
     * Отправка запроса на создания кода подтверждения телефона
     */
    $scope.sendPhoneConfirmRequest = function (isCashier, resending) {
      if (isCashier) {
        $scope.cashierTimerStart = new Date();
      } else {
        $scope.userTimerStart = new Date();
      }

      $rootScope.stateChangeStart = true;
      phoneConfirmationService.sendPhoneConfirmationAnonymousCreate((isCashier)? $scope.userData.cashier.phone : $scope.universalLogin).then(function (data) {
        if (isCashier) {
          $scope.cashierPhoneConfirmSended = true;
          $scope.userData.cashier.phone_confirmation = data.data;
          $scope.cashierPendingPhone = $scope.userData.cashier.phone;
        } else {
          $scope.phoneConfirmSended = true;
          $scope.userData.owner.phone_confirmation = data.data;
          $scope.pendingPhone = $scope.universalLogin;
        }
        $rootScope.stateChangeStart = false;
        if(!resending) {
          requestStatus.success("Сообщение отправлено на телефон: " + $filter('phoneFormat')($scope.pendingPhone));
        }else if (resending) {
          requestStatus.success("Сообщение отправлено повторно на телефон: " + $filter('phoneFormat')($scope.pendingPhone));
        }
      }, function (error) {
        if (error.status == 503 && error.data.code == "unknown" && vm.phoneConfirmSended) {
          requestStatus.error('Во время повторной отправки кода произошла ошибка. Повторите попытку позже.');
        } else {
          requestStatus.error('Во время отправки кода произошла ошибка. Повторите попытку позже.');
        }
        $rootScope.stateChangeStart = false;
      });
    };

    /**
     * Отправка запроса на подтверждения телефона по коду
     */
    $scope.checkPhoneConfirmCode = function (isCashier) {
      $rootScope.stateChangeStart = true;
      // код должен быть введен и сохранен объект подтверждения
      if (!isCashier && (!$scope.userData.$$confirmCode || !$scope.userData.owner.phone_confirmation)) {
        return;
      }
      if (isCashier && (!$scope.userData.cashier.$$confirmCode || !$scope.userData.cashier.phone_confirmation)) {
        return;
      }
      phoneConfirmationService.sendPhoneConfirmationAnonymousCode(
        (isCashier)? $scope.userData.cashier.phone_confirmation.id : $scope.userData.owner.phone_confirmation.id,
        (isCashier)? $scope.userData.cashier.$$confirmCode : $scope.userData.$$confirmCode)
        .then(function () {
          if (isCashier) {
            $scope.userData.cashier.phone_confirmed = true;
            $scope.cashierPhoneConfirmSended = false;
            $scope.cashierBasePhone = $scope.cashierPendingPhone;
            $scope.userData.cashier.phone = $scope.cashierPendingPhone;
            $scope.cashier_pending_phone_changes = null;
            $scope.phoneAttemptsCashier = PHONE_ATTEMPTS;
            registerCtrl.long.cashierLogin.$setValidity('confirmError', true);
            registerCtrl.long.cashierConfirmCode.$setValidity('confirmError', true);
          } else {
            $scope.userData.owner.phone_confirmed = true;
            $scope.phoneConfirmSended = false;
            $scope.userBasePhone = $scope.pendingPhone;
            $scope.universalLogin = $scope.pendingPhone;
            $scope.pending_phone_changes = null;
            $scope.phoneAttempts = PHONE_ATTEMPTS;
            registerCtrl.long.login.$setValidity('confirmError', true);
            registerCtrl.long.confirmCode.$setValidity('confirmError', true);
          }
          $rootScope.stateChangeStart = false;
        }, function (error) {
          // очистка неверного кода
          if (isCashier) {
            $scope.userData.cashier.$$confirmCode = '';
          } else {
            $scope.userData.$$confirmCode = '';
          }
          if (error.status == 503) {
            // сброс ошибки кода пдтверждения
            if (isCashier) {
              $scope.phoneAttemptsCashier--;
              registerCtrl.long.cashierConfirmCode.$setValidity('confirmError', false);
              if (!$scope.phoneAttemptsCashier) {
                $scope.resetUniversalLogin(true);
                registerCtrl.long.cashierLogin.$setValidity('phoneAttempts', false);
              }
            } else {
              $scope.phoneAttempts--;
              registerCtrl.long.confirmCode.$setValidity('confirmError', false);
              if (!$scope.phoneAttempts) {
                $scope.resetUniversalLogin();
                registerCtrl.long.login.$setValidity('phoneAttempts', false);
              }
            }
          } else {
            requestStatus.error('Во время подтверждения телефона произошла ошибка. Повторите попытку позже');
          }
          $rootScope.stateChangeStart = false;
        });
    };

    $scope.onInnFill = function(inn) {
      if (inn) {
        // обновление информации о типе компании (валидация поля допускает только 10 и 12 знаков по которым различаем тип компании)
        $scope.userData.company.type = (inn.length == 12) ? "SOLE_TRADER" : "LEGAL_ENTITY";
        utilsService.getCompanyInfo(inn).then(function(res) {
          $scope.userData.company.short_name = res.data[0].short_name_with_opf || res.data[0].name || res.data[0].full_name_with_opf || undefined;
        });
      } else {
       $scope.userData.company.short_name = null;
      }
    };

    $scope.checkPhonesUnique = function(){
      $timeout(function () {
        if (($scope.userMailPhoneFlags.isPhone && $scope.userData.needCashier && $scope.userData.cashier.phone && $scope.universalLogin == $scope.userData.cashier.phone) ||
             $scope.userData.needCashier && $scope.userData.cashier.phone && $scope.userData.owner.phone == $scope.userData.cashier.phone) {
          registerCtrl.long.login.$setValidity('phoneUnique', false);
          if (registerCtrl.long.cashierLogin) {
            registerCtrl.long.cashierLogin.$setValidity('phoneUnique', false);
            if ($scope.userData.cashier.phone) {
              registerCtrl.long.cashierLogin.$setDirty();
            }
          }
          if (registerCtrl.long.userPhone) {
            registerCtrl.long.userPhone.$setValidity('phoneUnique', false);
          }
        } else {
          registerCtrl.long.login.$setValidity('phoneUnique', true);
          if (registerCtrl.long.cashierLogin) {
            registerCtrl.long.cashierLogin.$setValidity('phoneUnique', true);
          }
          if (registerCtrl.long.userPhone) {
            registerCtrl.long.userPhone.$setValidity('phoneUnique', true);
          }
        }
      }, 0);
    };

    $scope.checkInnUnique = function(){
      $timeout(function () {
        if ($scope.userData.needCashier && $scope.userData.owner.inn && $scope.userData.owner.inn == $scope.userData.cashier.inn) {
          registerCtrl.long.ownerInn.$setValidity('dataUnique', false);
          if (registerCtrl.long.cashierInn) {
            registerCtrl.long.cashierInn.$setValidity('dataUnique', false);
            if ($scope.userData.cashier.inn) {
              registerCtrl.long.cashierInn.$setDirty();
            }
          }
        } else {
          registerCtrl.long.ownerInn.$setValidity('dataUnique', true);
          if (registerCtrl.long.cashierInn) {
            registerCtrl.long.cashierInn.$setValidity('dataUnique', true);
          }
        }
      }, 0);
    };

    $scope.checkNameUnique = function(){
      $timeout(function () {
        if ($scope.userData.needCashier && $scope.userData.owner.name && $scope.userData.owner.surname &&
          $scope.userData.owner.name == $scope.userData.cashier.name &&
          $scope.userData.owner.surname == $scope.userData.cashier.surname &&
          $scope.userData.cashier.patronymic == $scope.userData.owner.patronymic) {
          registerCtrl.long.lastName.$setValidity('dataUnique', false);
          registerCtrl.long.firstName.$setValidity('dataUnique', false);
          if ($scope.userData.owner.patronymic) {
            registerCtrl.long.patronymic.$setValidity('dataUnique', false);
          }
          if (registerCtrl.long.cashierInn) {
            registerCtrl.long.cashierLastname.$setValidity('dataUnique', false);
            registerCtrl.long.cashierName.$setValidity('dataUnique', false);
            if ($scope.userData.cashier.surname && $scope.userData.cashier.name) {
              registerCtrl.long.cashierLastname.$setDirty();
              registerCtrl.long.cashierName.$setDirty();
            }
            if ($scope.userData.cashier.patronymic) {
              registerCtrl.long.cashierPatronymic.$setValidity('dataUnique', false);
              registerCtrl.long.cashierPatronymic.$setDirty();
            }
          }
        } else {
          registerCtrl.long.lastName.$setValidity('dataUnique', true);
          registerCtrl.long.firstName.$setValidity('dataUnique', true);
          registerCtrl.long.patronymic.$setValidity('dataUnique', true);
          if (registerCtrl.long.cashierInn) {
            registerCtrl.long.cashierLastname.$setValidity('dataUnique', true);
            registerCtrl.long.cashierName.$setValidity('dataUnique', true);
            registerCtrl.long.cashierPatronymic.$setValidity('dataUnique', true);
          }
        }
      }, 0);
    };

    $scope.resetUniversalLogin = function (isCashier) {
      $scope.checkPhonesUnique();
      $scope.checkEmailUnique();
      if (isCashier) {
        registerCtrl.long.cashierLogin.$setValidity('confirmError', true);
        registerCtrl.long.cashierLogin.$setValidity('unique', true);
        registerCtrl.long.cashierLogin.$setValidity('phoneAttempts', true);
        $scope.userData.cashier.phone_confirmed = false;
        $scope.userData.cashier.$$confirmCode = undefined;
        $scope.cashierPhoneConfirmSended = false;
        $scope.userData.cashier.pending_phone_changes = null;
        $scope.phoneAttemptsCashier = PHONE_ATTEMPTS;
      } else {
        registerCtrl.long.login.$setValidity('confirmError', true);
        registerCtrl.long.login.$setValidity('unique', true);
        registerCtrl.long.login.$setValidity('phoneAttempts', true);
        $scope.userData.owner.phone_confirmed = false;
        $scope.userData.$$confirmCode = undefined;
        $scope.phoneConfirmSended = false;
        $scope.userData.pending_phone_changes = null;
        $scope.phoneAttempts = PHONE_ATTEMPTS;
      }

    }

  }
});


'use strict';

angular.module('frontend').controller('SetPassController', function ($scope, auth, $log, $location, $state, authToken, $stateParams, $rootScope) {
  var vm = this;
  var guid = $state.params.guid;
  vm.success = true;
  vm.goLogin = false;
  vm.isNewPass = $state.current.name === 'setpass';
  vm.guidInvalid = false;
  vm.invalidPassword = false;
  vm.errors = {};
  vm.login = $location.$$search.login;
  vm.domain = $location.$$search.domain;
  vm.passwordChangeRequested = $state.current.name == "passwordChangeRequested";

  vm.checkPassword = function(){
    vm.errors = {};
    vm.passNoMatch = vm.password && vm.repeatedPassword && vm.password !== vm.repeatedPassword;
  }

  function checkoStatusCode(err) {
    var statusCode = err.status;
    switch (statusCode) {
      case 400:
          $log.log('Пароль пользователя не удовлетворяет параметрам для пароля');
          vm.errors.invalidPassword = true;
          vm.success = false;
          vm.errors.invalidPassword = false;
          if(err.data.message == 'Passwords should be different'){
            vm.errors.invalidPassword = true;
          }
        break;
      case 401:
          $log.log('Пользователю запрещён вход');
          vm.errors.bannedUser = true;
          vm.success = false;
          vm.goLogin = false;
          vm.errors.invalidPassword = false;
        break;
      case 404:
          $log.log('Токен регистрации не найден');
          vm.errors.guidInvalid = true;
          vm.success = false;
          vm.goLogin = false;
          vm.errors.invalidPassword = false;
        break;
      case 409:
          $log.log('Токен регистрации уже был использован или протух');
          vm.errors.guidInvalid = true;
          vm.success = false;
          vm.goLogin = false;
          vm.errors.invalidPassword = false;
        break;
      case 204:
          vm.success = true;
          vm.goLogin = true;
          vm.errors.guidInvalid = false;
          vm.errors.invalidPassword = false;
        break;
      default:
          vm.errors.otherErrors = true;
        break;
    }
  }

  function setpass() {
    if (vm.password === vm.repeatedPassword) {
      if (vm.isNewPass || vm.passwordChangeRequested) {
        var req = {
          new_password: vm.password,
          token: guid
        };
        if(vm.passwordChangeRequested){
          req.login = $stateParams.login;
          req.domain = $stateParams.domain;
          req.old_password = $stateParams.oldPassword;
        }
        auth.setPass(req)
        .then(function (res) {
          authToken.logIn();
          auth.ensurePermissions(true, true).then(function() {
            checkoStatusCode(res);
            $log.log('Новый пароль успешно установлен');
            if (vm.isNewPass) {
              $state.go('editProfile');
            } else {
              $state.go($state.go($rootScope.hasRole('report.sale_totals') ? 'indicators' : 'business'));
            }
          });
        })
        .catch(function (err) {
          $log.log(err);
          checkoStatusCode(err);
        });
      } else {
        auth.recoverPassword(guid,vm.password)
        .then(function (res) {
          authToken.logIn();
          auth.ensurePermissions(true, true).then(function() {
            checkoStatusCode(res);
            $log.log('Новый пароль успешно установлен');
            $state.go($rootScope.hasRole('report.sale_totals') ? 'indicators' : 'business');
          });
        })
        .catch(function (err) {
          $log.log(err);
          checkoStatusCode(err);
        });
      }
    } else {
      $log.log('Пароли не совпадают');
      vm.errors.repeatedPassword = true;
      vm.goLogin = false;
    }
  }

  vm.submit = function() {
      setpass();
  }



});

'use strict';

angular.module('frontend').controller('ResetPassController', function ($scope, auth, $log, $location, previous) {

  $scope.userResetData = {};
  $scope.success= false;
  $scope.bannedLogin = false;
  $scope.badLogin = false;
  $scope.issetDomain = $location.search().domain;
  $scope.userResetData.data = $location.search().login;
  $scope.param = angular.element.param($location.search());
  $scope.userResetData.animateId = false;

  $scope.flags = {};

  $scope.generateTempPassword = function () {
    $scope.flags.generatePwdStarted = true;
    $scope.flags.pwdGenerated = false;
    auth.generateTempPassword($scope.userResetData.data, $scope.userResetData.domain).then(function (data) {
      $scope.flags.generatePwdStarted = false;
      $scope.flags.pwdGenerated = true;
      $scope.flags.pwdGeneratedTimestamp = Date.now();
      checkoStatusCode(data);
    }, function (error) {
      $scope.flags.generatePwdStarted = false;
      checkoStatusCode(error);
    })
  };

  $scope.generatePhoneStr = function () {
    var phone = $scope.userResetData.data;
    return "+7 (" + phone.substr(0, 3) + ") " + phone.substr(3, 3) + "-" + phone.substr(6, 2) + "-" + phone.substr(8, 2);
  };

  if(previous.name == "login"){
    $scope.userResetData.animateId = true;
  }

  $scope.resetErrors = function(){
    $scope.errStatus = '';
    $scope.success = false;
    $scope.resetPassForm.domain.$setValidity('error', true);
    $scope.resetPassForm.data.$setValidity('error', true);
  };

  function checkoStatusCode(err) {
    var statusCode = err.status;
    $scope.resetErrors();
    switch (statusCode) {
      case 403:
        $log.log('Используется для неподтвержденных email или телефона');
        $scope.resetPassForm.data.$setValidity('error', false);
        $scope.errStatus = err.data.code == 'email_not_confirmed' ? 'emailNotConfirm' :
          (err.data.code == 'phone_not_confirmed' ? 'phoneNotConfirm' : 'error');
        break;
      case 404:
          $log.log('Пользователь в группе или группа не найдены');
          $scope.errStatus = 'badLogin';
          $scope.resetPassForm.domain.$setValidity('error', false);
          $scope.resetPassForm.data.$setValidity('error', false);
        break;
      case 401:
          $log.log('Пользователь заблокирован');
          $scope.errStatus = 'bannedLogin';
          $scope.resetPassForm.data.$setValidity('error', false);
        break;
      case 400:
          $log.log('Неправильно сформированный запрос');
          $scope.errStatus = '';
        break;
      case 409:
          if(err.data.code == 'email_not_confirmed'){
            $log.log('Пользователь без подтвержденного email');
            $scope.errStatus = 'needConfirmedEmail';
            $scope.resetPassForm.data.$setValidity('error', false);
          }
          if(err.data.code == 'fast_cashier'){
            $log.log('Это быстрый кассир');
            $scope.errStatus = 'fastCashier';
            $scope.resetPassForm.data.$setValidity('error', false);
          }
        break;
      case 204:
          $scope.success = true;
          $scope.errStatus = '';
        break;
      case 200:
          $scope.success = true;
          $scope.errStatus = '';
        break;
      default:
    }
  }

  function resetpass() {
    if ($scope.resetPassForm.$valid) {
      var resetPassData = { domain: $scope.userResetData.domain },
        reg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'g'),
        arr = $scope.userResetData.data.match(reg);

      if(arr){
        resetPassData.email = $scope.userResetData.data;
      }else{
        resetPassData.login = $scope.userResetData.data;
      }
      if (!resetPassData.domain) {
        resetPassData.domain = '';
      }
      auth.resetPass(resetPassData)
        .then(function (res) {
          if(res.data.email) $scope.email = res.data.email;
          checkoStatusCode(res)
        })
        .catch(function (err) {
          $log.log(err);
          checkoStatusCode(err);
        });
    } else {
      angular.forEach( $scope.resetPassForm.$error ,function (control) {
        for (var i = 0; i < control.length; i++) {
          control[i].$setDirty()
        }
      })
    }
  }

  $scope.resetSubmit = function() {
    auth.ensureSession().then(function() {
      if ($scope.flags.isPhone && !$scope.flags.generatePwdStarted && !$scope.flags.pwdGenerated) {
        $scope.generateTempPassword();
      } else {
        resetpass();
      }
    });
  }

});

angular
  .module("frontend")
  .controller('LoginController', LoginController);

/** @ngInject */
function LoginController($scope, $state, auth, $location, previous, $stateParams, $rootScope, focus, uiVersion, ngProgressFactory) {
  var vm = this;
  var isLostSession = false;
  $scope.emailNotConfirmed = false;
  $scope.uiVersion = uiVersion;
  $scope.browser = navigator.userAgent || navigator.vendor || window.opera;
  $scope.isMobile = auth.checkMobileBrowser($scope.browser);
  $scope.issetDomain = $location.search().domain;
  $scope.userLoginData = {};
  $scope.userLoginData.login = $location.search().login;
  $scope.userLoginData.animateId = false;
  $scope.param = angular.element.param($location.search());
  $scope.userLoginData.error = {};

  if(previous.name == "resetpass"){
    $scope.userLoginData.animateId = true;
  }

  $scope.resetErrors = function (event) {
    if (event.key !== 'Enter') {
      vm.loginForm.$setValidity('loginPasswordIncorrect',true);
      $scope.userLoginData.error.wrongData = false;
    }
  }

  $scope.loginSubmit = function () {
    if(!$scope.userLoginData.isWrongLoginData){
      login();
    }
  };

  $scope.onEnter = function(event) {
    var target = event.currentTarget;
    switch (target.name) {
      case 'domain':
        focus.setFocusOnInput('[name="login"]');
        break;
      case 'login':
        focus.setFocusOnInput('[name="password"][type="password"]');
        break;
      default :

        break;
    }
  };


   function setDirty() {
     angular.forEach( vm.loginForm.$error ,function (control) {
       for (var i = 0; i < control.length; i++) {
         control[i].$setDirty()
       }
     })
   }

  function login() {
    if (vm.loginForm.$valid) {
      auth.login({
        login: $scope.userLoginData.login,
        domain: $scope.userLoginData.domain,
        password: $scope.userLoginData.password
      })
      .then(
        function (res) {
          isLostSession = false;
          $scope.userLoginData.error = {};
          auth.ensurePermissions(true, true).then(function() {
            $rootScope.toLogin = false;
            if ($stateParams.moveBack && previous.name && previous.name !== 'login') {
              $state.go(previous.name, previous.params);
            } else if ($stateParams.forward && $stateParams.forward.stateName) {
              $state.go($stateParams.forward.stateName, $stateParams.forward.stateParams);
            } else {
              $state.go($rootScope.hasRole('report.sale_totals') ? 'indicators' : 'business');
            }
            // отправка глобального события успешного логина нового пользователя
            $rootScope.$broadcast('login-success');
          }, function (error) {
            $scope.userLoginData.error.serverError = true;
          });
        }
      )
      .catch(
        function (err) {
          if (err.status === -1) {
            //TODO : обработать ошибку согласно требованиям бизнес логики
            console.error('Request has not been sent');
          } else if(err.data.code === "pass_change_requested") {
            $state.go('passwordChangeRequested', {login: $scope.userLoginData.login, domain: $scope.userLoginData.domain, oldPassword: $scope.userLoginData.password});
          } else if (err.data.code === "email_not_confirmed") {
            $scope.emailNotConfirmed = true;
          } else if (err.data.code === "non_unique_login") {
            $scope.userLoginData.error.nonUniqueLogin = true;
          } else {
            switch (err.status) {
              case 403:
                if(err.data.code === "session_not_set" && !isLostSession) {
                  isLostSession = true;
                  auth.ensureSession().then(function(res) {
                    login();
                  }, function (error) {
                    $scope.userLoginData.error.serverError = true;
                  });
                } else {
                  if(isLostSession){
                    $scope.userLoginData.error.serverError = true;
                  }else{
                    $scope.userLoginData.error.wrongData = true;
                  }
                }
                break;
              case 401:
                $scope.userLoginData.error.disabledUser = true;
                break;
              default:
                $scope.userLoginData.error.serverError = true;
                 break
            }
          }
        }
      );
    } else {
      setDirty()
    }

  }

}

'use strict';

angular.module('frontend').service('settings', function settings($http, API_URL, $log) {

  function updateProfileInfoSuccess(res) {
    $log.debug(res);
  }

  function dadataSuccess(){
  }

  this.updateProfileInfo = function (guid, profileModel) {
    return $http.put(API_URL + '/users/' + guid, profileModel).success(updateProfileInfoSuccess);
  }

});
(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($scope,auth, $state,personPicker,personsDataSrv) {
    var vm = this;
  }

})();

(function () {
  'use strict';

  angular.module('frontend').service('priceLocalSrv', priceLocalSrv);

  /**
   * Сервис инкапсюлирует в себе логику двуступенчатого сохранения цен.
   * Локальные изменения хранятся локально, и при коммите сохраняются на бекенде через соответствующий сервис.
   * Для коммита внешним потребителям потребуется вызвать метод commit без параметров. Отмета внешне также тривиальна.
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   */
  function priceLocalSrv($http,
                         API_URL,
                         $q,
                         priceColumnSrv,
                         helpService,
                         priceEmulatorSrv, // Сервис долговременного хранения цен
                         userSettingsService // Для эмуляции сохранения, пока нет бекенда
  ) {

    /**
     * Возвращает флаг наличия незакоммиченных локальных изменений
     *
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.hasLocalChanges = function (mode) {
      var hasPrice = false;
      var allPrices = userSettingsService.loadComponent("price-list-local-" + mode.toLowerCase(), "price");
      if (allPrices) {
        hasPrice = _.find(allPrices, function (item) {
          return _.find(item, function (prices) {
            return prices && prices.length;
          })
        })
      }
      return hasPrice;
    };

    /**
     * Очищает локальные цены
     *
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.clearLocalChanges = function (mode) {
      return $q.when(userSettingsService.clearComponent("price-list-local-" + mode.toLowerCase(), "price"));
    }

    /**
     * Коммит цен на бекенд (или эмулятор)
     *
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.commitPrices = function (mode) {
      var me = this;
      // Загрузка всех локально измененных цен
      var allPrices = userSettingsService.loadComponent("price-list-local-" + mode.toLowerCase(), "price");

      // перебор всех товаров и услуг
      angular.forEach(allPrices, function (pricesByColumn, itemId) {
        // перебор всех колонок
        angular.forEach(pricesByColumn, function (prices, columnId) {
          // перебор всех цен
          angular.forEach(prices, function (price) {
            if (price.$deleted) {
              priceEmulatorSrv.removePrice(
                itemId,
                columnId,
                price);
            } else {
              delete price.$new;
              delete price.$modify;
              delete price.$local;
              delete price.$base;
              priceEmulatorSrv.addNewPrice( // TODO: реальный метод бекенда будет принимать пачку изменений
                itemId,
                columnId,
                price,
                mode
              );
            }
          });
        });
      });

      return $q.when(true).then(function () {
        // очистка локальных изменений, после успешного сохранения
        return me.clearLocalChanges();
      });
    };

    /**
     *  Загрузка списка колонок из локального кеша.
     *  Метод внутренний, сам по себе пользователю он не интересен, но используется в
     *  пользовательском методе при мердже цен внешнего и локального хранилищ.
     *
     * @param itemId идентификатор товара или услуги
     * @param mode режим прайс-листа оптовый/розничный
     */
    this._priceByItem = function (itemId, mode) {
      var today = helpService.userNow();
      return $q.when(userSettingsService.loadProperty("price-list-local-" + mode.toLowerCase(), "price", itemId) || undefined)
        .then(function (prices) {
          // необходимо, для установки сегодняшней даты для цен из сторы, которые в прошлом
          angular.forEach(prices, function(prisecColumn){
            if(prisecColumn.length){
              angular.forEach(prisecColumn, function(price){
                if(!price.$deleted && moment(price.effective_date).valueOf() < today.valueOf()){
                  price.effective_date = today.valueOf();
                }
              });
            }
          });
          return prices;
        });
    };

    /**
     * Запрос массива ключей всех товаров и услуг, имеющих изменения
     *
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.allPricesItems = function (mode) {
      return $q.when(userSettingsService.loadComponent("price-list-local-" + mode.toLowerCase(), "price") || undefined)
        .then(function (items) {
          var itemsKeys = [];
          angular.forEach(items, function(prices, key) {
            var hasPrice = false;
            angular.forEach(prices, function (columnPrice) {
              if (columnPrice.length) {
                hasPrice = true;
              }
            });
            if (hasPrice) {
              itemsKeys.push(key);
            }
          });
          return itemsKeys;
        });
    };

    /**
     * Запрос массива ключей всех колонок, имеющих изменения
     *
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.allPricesColumns = function (mode) {
      return $q.when(userSettingsService.loadComponent("price-list-local-" + mode.toLowerCase(), "price") || undefined)
        .then(function (items) {
          var columnsMap = {}; // аккумулятор, индекс - идентификатор колонки
          _.forEach(items, function (prices, key) {
            _.forEach(prices, function (pricesArray, columnId) {
              if (pricesArray && pricesArray.length) {
                columnsMap[columnId] = true;
              }
            })
          });
          return columnsMap;
        });
    };

    /**
     * Запрос массива ключей всех колонок, имеющих изменения в конкретном узле
     *
     * @param itemId идентификатор товара или услуги
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.allPricesColumnsByItem = function (itemId, mode) {
      return $q.when(userSettingsService.loadProperty("price-list-local-" + mode.toLowerCase(), "price", itemId) || undefined)
        .then(function (prices) {
          var columnsMap = {}; // аккумулятор, индекс - идентификатор колонки
          _.forEach(prices, function (pricesArray, columnId) {
            if (pricesArray && pricesArray.length) {
              columnsMap[columnId] = true;
            }
          });
          return columnsMap;
        });
    };

    /**
     * Подготовка структуры цен по плоскому массиву с бекенда
     *
     * @private
     */
    this._prepareListOfPrices = function (prices) {
      // с бекенда приходят цены в обратном порядке
      prices.reverse();
      var priceByColumn = {};
      angular.forEach(prices, function (price) {

        if (!priceByColumn[price.column_ref.id]) {
          priceByColumn[price.column_ref.id] = [];
        }
        priceByColumn[price.column_ref.id].push(price);
      });
      return priceByColumn;
    };

    /**
     * Вспомогательный метод для поучения промиса загрузки с двух источников
     *
     * @param itemId идентификатор товара или услуги
     * @param mode режим прайс-листа оптовый/розничный
     * @private
     */
    this._getByItemPromise = function (item, onlySaved, mode) {
      var promiseFar = $q.when(this._prepareListOfPrices(item.prices));//priceEmulatorSrv.priceByItem(item);
      if (!onlySaved) { // флаг загрузки только сохраненных цен
        var promiseLocal = this._priceByItem(item.catalog_item.id, mode);
      } else {
        var promiseLocal = $q.when(undefined); // вместо локальный возвращается пустой массив
      }
      // объединение промисов загрузки с бекенда и локального хранилища
      return $q.all([promiseFar, promiseLocal]);
    };

    /**
     * Метод сравнения цен, учитывает количество,
     * установленное в поле effective_qty и
     * значение даты цены
     *
     * @param a первая цена
     * @param b вторая цена
     * @return {*} положительное число, если первая цена позже второй, отрицательное,
     * если первая цена раньше второй и ноль, если цены эквивалентны
     *
     * @private
     */
    this._priceCompare = function (a, b) {
      if (+a.effective_qty == +b.effective_qty) {
        var tA = a.effective_date ? new Date(a.effective_date).getTime() : 0;
        var tB = b.effective_date ? new Date(b.effective_date).getTime() : 0;
        return tA - tB;
      }
      return +b.effective_qty < +a.effective_qty;
    };

    /**
     * Единый метод для загрузки цен с уддаленного (бекенд)
     * и локального источников.
     *
     * @param itemId идентификатор товара или услуги
     * @param mode режим прайс-листа оптовый/розничный
     * @return {*} промис с объединенными ценами
     */
    this.priceByItem = function (item, mode, onlySaved) {
      var me = this;
      return this._getByItemPromise(item, onlySaved, mode).then(function (results) {
        // будем мерджить данные с бекенда в локальные данные
        if (results[1]) { // перебираем данные локального хранилища
          angular.forEach(results[1], function (prices, columnId) {
            if (prices && prices.length) { // при наличии цен в логальном хранилище
              item.$$hasChanges = true; // установка флага наличия изменений у item
            }
            if (results[0] && results[0][columnId]) {
              _.forEach(prices, function (price) {
                // ищем цены, которые локальное хранилище может перекрывать
                price.$base = _.findWhere(results[0][columnId], {id: price.id}); // устанавливаем цену с бекенда в базовое поле
              });
              // фильтруем цены бекенда (TODO: нужно оптимизировать)
              _.forEach(_.filter(results[0][columnId], function (p) {
                return !_.findWhere(prices, {id: p.id});
              }), function (notOverridedPrice) {
                prices.push(notOverridedPrice); // если цена бекенда не преопределена, добавляем её к выдаче
              });

              prices.sort(me._priceCompare);

              // установка ссылки на цену, которую сменит текущая
              for (var i = 1; i < prices.length; i++) {
                if (prices[i].effective_qty == prices[i - 1].effective_qty) {
                  prices[i].$$previos = prices[i - 1];
                }
              }
            }
          });
        }
        // заполнение колонок, которых не было в локальном хранилище (сортирует бекенд)
        if (results[0]) {
          if (!results[1]) {
            results[1] = {};
          }
          angular.forEach(results[0], function (prices, columnId) {
            // беке перестал присылать отсортированные цены
            prices.sort(me._priceCompare);

            // установка ссылки на цену, которую сменит текущая
            for (var i = 1; i < prices.length; i++) {
              if (prices[i].effective_qty == prices[i - 1].effective_qty) {
                prices[i].$$previos = prices[i - 1];
              }
            }

            if (!results[1][columnId]) {
              results[1][columnId] = prices;
            }
          });
        }
        return results[1];
      });
    };

    /**
     * Сохранение цен товара или услуги
     *
     * @param itemId идентификатор товара или услуги
     * @param prices массив цен
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.savePrices = function (itemId, prices, mode) {
      var me = this;
      // из-за необходимости отслеживать флаги модификации и добавления, сохранение происходит через единый метод
      for (var key in prices) {
        me.addAllPrices(
          itemId,
          key, // ключ - идентификатор колонки
          prices[key], // массив цен
          mode // режим прaйс-листа (оптовый или розничный)
        );
      }
      return $q.when(prices);
    };

    /**
     * Сохранение массива цен колонки
     *
     * @param itemId идентификатор товара или услуги
     * @param columnId id колонки, куда записывать цены
     * @param prices массив цен
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.addAllPrices = function (itemId, columnId, prices, mode) {
      var me = this;
      // очистка локальных цен текущей колонки
      var itemPrices = userSettingsService.loadProperty("price-list-local-" + mode.toLowerCase(), "price", itemId) || {};
      itemPrices[columnId] = [];
      userSettingsService.saveProperty("price-list-local-" + mode.toLowerCase(), "price", itemId, itemPrices);
      // из-за необходимости отслеживать флаги модификации и добавления, сохранение происходит через единый метод
      angular.forEach(prices, function (value) {
        me.addNewPrice(
          itemId,
          columnId, // ключ - идентификатор колонки
          value,
          mode
        );
      });
      return $q.when(prices);
    };

    /**
     * Сохранение цены по идентификатору товара и колонки
     *
     * @param itemId идентификатор товара или услуги
     * @param columnId id колонки, куда записывать цены
     * @param prices массив цен
     * @param mode режим прайс-листа оптовый/розничный
     */
    this.addNewPrice = function (itemId, columnId, price, mode) {
      var itemPrices = userSettingsService.loadProperty("price-list-local-" + mode.toLowerCase(), "price", itemId) || {};
      var columnPrices = itemPrices[columnId] || [];

      if (price.id) { // проверка наличия изменений
        if (price.$local) { // ситуация модификации локальной цены (id локально генерируется для возможности идентификации цен, редактирования еще не сохраненной цены, к примеру)
          var oldPrice = _.findWhere(columnPrices, {id: price.id});
          if (oldPrice && !angular.equals(price, oldPrice)) {
            angular.copy(price, oldPrice); // копирование свойств (deep)
            // Флаг модификации уже должен был быть установлен
          } else {
            // Например, если чистился список пред сохранением с удалением
            columnPrices.push(price);
          }
        } else { // ситуация модификации цены от бекенда
          if (price.$$changed) {
            price.$new = true; // установка флага новой цены
          }
          if (price.$$changed || price.$deleted) { // перегрузка происходит только если были изменения или речь идет об удалении
            var newOverridePrice = {}; // создается новая цена, которая будет перекрывать цену бекенда
            angular.copy(price, newOverridePrice); // копирование свойств
            // установка флага модификации (на $$new можно не обращать внимание из-за более высокого приоритета)
            newOverridePrice.$modify = true; // флаг модификации
            newOverridePrice.$local = true; // переопределяющая цена является локальной
            columnPrices.push(newOverridePrice); // добавляем в блок локального хранилища
          }
        }
      } else {
        price.id = userSettingsService.guid(); // генерация id (локального)
        price.$new = true; // установка флага новой цены
        price.$local = true; // установка флага локальной цены
        columnPrices.push(price);
      }

      itemPrices[columnId] = columnPrices;
      userSettingsService.saveProperty("price-list-local-" + mode.toLowerCase(), "price", itemId, itemPrices);
      return $q.when(price);
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').service('priceListSrv', priceListSrv);

  /**
   * Сервис для работы с АПИ прайс-листов
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   */
  function priceListSrv($http,
                        API_URL,
                        $q,
                        priceLocalSrv, // сервис локального хранилища изменений прайс-листа
                        userSettingsService // Для эмуляции сохранения, пока нет бекенда
  ) {

    var me = this;

    // получение строки, необходимой для подстановки в url запроса.
    // причина в другой реализации закупочного прайс-листа
    // можно было бы использовать $stateParams и параметрыв url, но это не сурьезно
    function _getRequestStr (type) {
      return (type == 'PURCHASE')? '/purchase_price_lists' : '/price_lists';
    }

    /* Добавление идентификаторов элементов в прайс-лист */
    this.addItems = function (type, itemIds) {
      return $http.put(API_URL + _getRequestStr(type) + '/items', itemIds, {
        params: {
          $$ignoreInterceptor: true
        }
      }).then(function (data) {
        return data.data;
      });
    };

    /* метод вовращает линейку по идентификатору позиции */
    this.getLineByItem = function (type, itemId) {
      return $http.get(API_URL + _getRequestStr(type) + "/lines/by_item/" + itemId, {
        params: {
          filter_column_type: type
        }
      }).then(function (data) {
        if (data && data.data) { //TODO: логика преобразований из целоисленного представления должна быть сконцентрирована в директиве инпута
          angular.forEach(data.data.prices, function (price) {
            price.effective_date = price.effective_date ? new Date(price.effective_date) : price.effective_date;
          });
          return data.data;
        }
      });
    };

    /* Удаление объектов из прайс-листа по идентификатору */
    this.removeItems = function (type, itemIds) {
      return $http.delete(API_URL + _getRequestStr(type) + '/items',
        {
          data: itemIds,
          headers: {'Content-Type': 'application/json'}
        });
    }

    /* Запрос категорий прайс-листа (один уровень) */
    this.getCategories = function (type, parent_id) {
      return $http.get(API_URL + _getRequestStr(type) + "/categories", {
        params: {
          parent_id: parent_id,
          filter_column_type: type
        }
      });
    };

    /**
     * Получение всего дерева родительских категорий для товаров и услуг
     *
     * @param items
     */
    this.getCategoriesTreeByItems = function (items) {
      return $http.post(API_URL + "/catalog/domain/search/categories/by_items", {
        items: items
      }, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /**
     * Пакетное добавление товаров и цен в закупочный прайс-лист
     *
     * @param priceBox
     */
    this.boxPriceListUpdate = function (priceBox) {
      return $http.put(API_URL + "/purchase_price_lists/prices", priceBox, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /* Поиск элементов прайс-листа (категорий, товаров, услуг) */
    this.searchElements = function (type, paging, search, filter_date) {
      return $http.get(API_URL + _getRequestStr(type) + "/items", {
        params: {
          limit: paging.limit,
          offset: paging.offset,
          filter_name: search,
          filter_column_type: type,
          filter_effective_date_from: (filter_date && filter_date.startDate)? moment(filter_date.startDate).set({hour:0,minute:0,second:0,millisecond:0}).valueOf() : undefined,
          filter_effective_date_to: (filter_date && filter_date.endDate)? moment(filter_date.endDate).set({hour:23,minute:59,second:59,millisecond:999}).valueOf() : undefined
        }
      });
    };

    /* Поиск элементов (категорий, товаров, услуг), которых нет в прайс-листе */
    this.searchNotInPriceElements = function (type, paging, search) {
      return $http.get(API_URL + _getRequestStr(type) + "/catalog/elements", {
        params: {
          limit: paging.limit,
          offset: paging.offset,
          filter_name: search
        }
      });
    };

    /* Запрос категорий, которых нет в прайс-листе */
    this.getNotInPriceCategory = function (type, parent_id, page) {
      return $http.get(API_URL + _getRequestStr(type) + "/catalog/categories", {
        params: {
          parent_id: parent_id,
          offset: page && page.offset ? page.offset : 0,
          limit: page && page.limit ? page.limit : 100
        }
      });
    };

    /* Запрос товаров и услуг категории котрых нет в прайс-листе */
    this.getNotInPriceCategoryItems = function (type, parent_id, filters, page) {
      var param = {
        params: {
          filter_status: filters,
          offset: page && page.offset ? page.offset : 0,
          limit: page && page.limit ? page.limit : 100
        }
      };
      return $http.get(API_URL + _getRequestStr(type) + "/catalog/categories/" + parent_id + "/items", param);
    };

    /* Запрос товаров и услуг категории прайс-листа */
    this.getCategoryItems = function (type, parent_id, filters, page) {
      var param = {
        params: {
          filter_status: filters,
          offset: page && page.offset ? page.offset : 0,
          limit: page && page.limit ? page.limit : 100,
          filter_column_type: type
        }
      };
      return $http.get(API_URL + _getRequestStr(type) + "/categories/" + parent_id + "/items", param).then(function (data) {
        if (data && data.data && data.data.items) { //TODO: логика преобразований из целоисленного представления должна быть сконцентрирована в директиве инпута
          angular.forEach(data.data.items, function (item) {
            angular.forEach(item.prices, function (price) {
              price.effective_date = price.effective_date ? new Date(price.effective_date) : price.effective_date;
            });
          });
          return data;
        }
      });
    };

    /**
     * Метод сохранения цен
     *
     * @param line объект с ценами
     * @return {*}
     */
    this.immediateSavePrices = function(line, itemId){
      return $http.put(API_URL + "/purchase_price_lists/lines/by_item/" + itemId + "/price", line);
    };

    /**
     * Метод немедленно сохраняет линейку на бекенде
     *
     * @param itemId идентификатор товара
     * @param columnId идентификатор колонки
     * @param prices массив цен колонки
     * @return {*}
     */
    this.immediateCommitPrices = function(itemId, columnId, prices) {
      // заготовка структуры для обновления
      // подготовка линейки
      var columnMap = {};
      columnMap[columnId] = prices;
      return me._commitLine('PURCHASE', columnMap, itemId).then(function (line) {
        line.visible_in_price_list = undefined;

        // обратное преобразование даты и цен из строк в копейки
        angular.forEach(line.prices, function (price) {
          price.calculated_automatically_price_for_one_uom = (typeof price.calculated_automatically_price_for_one_uom == "string")? price.price_for_one_uom : price.calculated_automatically_price_for_one_uom;
          price.price_for_one_uom = (typeof price.price_for_one_uom == "string")? price.price_for_one_uom : price.price_for_one_uom;
        });

        // добавляем единственную линейку патча
        // выполнение обновления
        return me.immediateSavePrices(line, itemId);
      });
    };


    /**
     * Метод удаления цен из закупочного прайслиста
     *
     * @param ids идентификаторы цен для удаления
     * @return {*}
     */
    this.immediateRemovePrices = function(ids) {
      return $http.delete(API_URL + "/purchase_price_lists/price", {
        data: {
          "items": ids
        },
        headers: {'Content-Type': 'application/json'}
      });
    };

    /**
     * Метод обновляет линейку на бекенде
     *
     * @param itemId идентификатор товара
     * @param pricesByColumn карта: колонка -> массив цен
     */
    this._commitLine = function (type, pricesByColumn, itemId) {
      return me.getLineByItem(type, itemId).then(function (line) {
        if (!line) { // Если линейка не создана еще
          line = {
            catalog_item: {
              id: itemId
            },
            prices: []
          };
        }
        // перебор всех колонок
        angular.forEach(pricesByColumn, function (prices, columnId) {
          // перебор всех цен
          angular.forEach(prices, function (price) {

            var overridedBasePrice = _.findWhere(line.prices, {id: price.id});

            if (price.$deleted) {
              // удаляем из списка
              if (overridedBasePrice) {
                line.prices.splice(line.prices.indexOf(overridedBasePrice), 1);
              }
            } else {

              // добавляем цену в список для позиции
              var price_ = angular.copy(price);
              delete price_.$new;
              delete price_.$modify;
              delete price_.$local;
              delete price_.$base;
              if (!price_.effective_date && type !== 'PURCHASE') {
                price_.effective_date = moment().utc().startOf('day').toDate().getTime();
              }

              if (overridedBasePrice) {
                // случай переопределения
                // копируем измененную цену в старую цену в списке
                angular.copy(price_, overridedBasePrice);
                // добавлять не нужно
              } else {
                // случай новой цены
                price_.free_of_control_price = !!price_.free_of_control_price; // обязательное поле
                price_.column_ref = {
                  id: columnId
                };
                if(type == 'PURCHASE'){
                  price_.effective_date = undefined;
                  price_.free_of_control_price = undefined;
                  //price_.line_ref = {
                  //  id: line.id
                  //}
                }
                // добавляем цену в список для позиции
                line.prices.push(price_);
              }
            }

          });
        });
        // резолвим созданной линией
        return line;
      });
    };

    /* Метод патчит прайс-лист локальными изменениями */
    this.commitPrices = function (mode) {
      // Загрузка всех локально измененных цен
      var allPrices = userSettingsService.loadComponent("price-list-local-" + mode.toLowerCase(), "price");
      // подготовка структуры патча
      var patch = {
        price_list_lines: []
      };
      // массив промисов для сборзиков линеек
      var linePromisses = [];

      // перебор всех товаров и услуг
      angular.forEach(allPrices, function (pricesByColumn, itemId) {
        // проверка на наличие хотя бы одной цены (ситуация с пустым массиво изменений, в целом, валина)
        var hasPrice = false;
        angular.forEach(pricesByColumn, function (value, key) {
          if (value && value.length) {
            hasPrice = true;
          }
        });
        // запрашивать линейку имеет смысл только для товаров с измененными ценами
        if (hasPrice) {

          var localPromise = me._commitLine(mode, pricesByColumn, itemId).then(function (line) {
            // добавляем в массив линий, линию для обработанного товара
            patch.price_list_lines.push(line);
          });

          linePromisses.push(localPromise); // добавляем описанный промис в массив
        }
      });
      return $q.all(linePromisses).then(function () {
        // обратное преобразование даты и цен из строк в копейки
        angular.forEach(patch.price_list_lines, function (item) {
          item.prices = _.filter(item.prices, function (price) {
            return price.price_for_one_uom !== null;
          })
          angular.forEach(item.prices, function (price) {
            price.calculated_automatically_price_for_one_uom = (typeof price.calculated_automatically_price_for_one_uom == "string")? price.price_for_one_uom : price.calculated_automatically_price_for_one_uom;
            price.price_for_one_uom = (typeof price.price_for_one_uom == "string")? price.price_for_one_uom : price.price_for_one_uom;
            price.effective_date = moment(price.effective_date).utc().valueOf();
          });
        });
        return $http.put(API_URL + "/price_lists", patch, {params: {filter_column_type: mode}}).then(function (result) {
          // очистка локальных изменений, после успешного сохранения
          return priceLocalSrv.clearLocalChanges(mode);
        });
      });
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').service('priceEmulatorSrv', priceEmulatorSrv);

  /**
   * Сервис для эмуляции работы бекенда в части сохранения цен товарных позиций
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   */
  function priceEmulatorSrv($http,
                            API_URL,
                            $q,
                            priceColumnSrv,
                            userSettingsService // Для эмуляции сохранения, пока нет бекенда
  ) {

    /* Загрузка списка колонок */
    this.priceByItem = function (itemId) {
      return priceColumnSrv.priceColumns().then(function (columns) {
        return $q.when(userSettingsService.loadProperty("price-list-emu", "price", itemId) || undefined)
          .then(function (prices) {
            // Перебираем все колонки, чтобы для автоматических сгенерировать цены
            angular.forEach(columns, function (column) {
              if (column && column.priceCreation) { // нужна эмуляция расчета значения
                if (!prices) {
                  // если объект не инициализирован - цен вовьбще нет, базы расчета соответсттвенно тоже
                  return prices;
                }
                var columnPrices = prices[column.id];
                if (!columnPrices) {
                  columnPrices = [];
                  prices[column.id] = columnPrices; // создаем новый массив для колонки
                }
                var columnDependedPrices = prices[column.dependentColumn.id];

                angular.forEach(columnDependedPrices, function (priceDep) {
                  var correspondingPrice = _.findWhere(columnPrices, {
                    dependentPriceId: priceDep.id
                  }); // ищем соответствующую цене в зависимой колонке цену

                  if (!correspondingPrice) {
                    // если цены соответствующей цене зависимой колонке не найдено - то добавляем
                    correspondingPrice = {
                      id: priceDep.id,//userSettingsService.guid(),
                      effective_qty: priceDep.effective_qty,
                      effective_date: priceDep.effective_date,
                      dependentPriceId: priceDep.id
                    };
                    columnPrices.push(correspondingPrice);
                  }
                  // пересчитываем автоматические значения
                  var mul = 1 + 0.01 * ((column.$$operation == '+') ? +column.$$percent : -column.$$percent);
                  if (priceDep && (priceDep.price_for_one_uom || priceDep.calculated_automatically_price_for_one_uom)) { // если цена в зависимой колонке установлена
                    correspondingPrice.calculated_automatically_price_for_one_uom = ((+priceDep.price_for_one_uom
                      || + priceDep.calculated_automatically_price_for_one_uom) * mul).toFixed(2); // общий приоритет цен (приоритетнее введеная руками)
                  }
                });
              }
            });

            return prices;
          });
      })
    }

    /* Сохранение всего массива цен */
    this.savePrices = function (itemId, prices) {
      userSettingsService.saveProperty("price-list-emu", "price", itemId, prices);
      return $q.when(prices);
    }

    /* Удаление цены по идентификатору товара и колонки */
    this.removePrice = function (itemId, columnId, price) {
      var itemPrices = userSettingsService.loadProperty("price-list-emu", "price", itemId) || {};
      var columnPrices = itemPrices[columnId] || [];

      var persistedPrice = _.findWhere(columnPrices, {id: price.id});
      if (persistedPrice) {
        columnPrices = _.without(columnPrices, persistedPrice);
        itemPrices[columnId] = columnPrices;
        userSettingsService.saveProperty("price-list-emu", "price", itemId, itemPrices);
        return $q.when(price);
      } else {
        $q.when(false);
      }
    }

    /* Сохранение цены по идентификатору товара и колонки */
    this.addNewPrice = function (itemId, columnId, price) {
      var itemPrices = userSettingsService.loadProperty("price-list-emu", "price", itemId) || {};
      var columnPrices = itemPrices[columnId] || [];

      if (price.id) {
        var oldPrice = _.findWhere(columnPrices, {id: price.id});
        if (oldPrice) {
          angular.copy(price, oldPrice); // копирование свойств (deep)
        } else {
          columnPrices.push(price);
        }
      } else { // Для этого эмулятора ветка не актуальна
        price.id = userSettingsService.guid(); // генерация id
        columnPrices.push(price);
      }

      itemPrices[columnId] = columnPrices;
      userSettingsService.saveProperty("price-list-emu", "price", itemId, itemPrices);
      return $q.when(price);
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('priceListController', priceListController);

  function priceListController($scope,
                               $uibModal,
                               userSettingsService,
                               columnLimit, // лимит количества колонок
                               auth,
                               type, // тип: розница или оптовый
                               twoStepSaving, // флаг одно или двуступенчатого сохранения
                               columns, // колонки, резолвятся при роутинге
                               priceColumnSrv,
                               modalAskSrv, // сервис для диалоговых окон
                               priceListSrv, // сервис для работы с прайс-листом
                               priceLocalSrv, // сервис для работы с временным локальным кешем для прайс-листов
                               requestStatus, // для вывода статусов об успехе или ошибке
                               changedCategories, // категории, в которых присутствуют изменения
                               changedColumns, // колонки, в которых присутствуют изменения
                               $log,
                               $timeout,
                               $anchorScroll, // сервис скролирования
                               $window,
                               $state,
                               $rootScope,
                               errorMessageService,
                               $q,
                               print) {
    var priceListCtrl = this;

    // тип прайс-листа (от этого значения, в частности, зависит тип создаваемой колонки)
    priceListCtrl.type = type;
    priceListCtrl.changedCategories = changedCategories || {};

    // Флаг наличия изменений
    priceListCtrl.notEmptyChanges = $rootScope.hasRole('price_list.write') ? priceLocalSrv.hasLocalChanges(priceListCtrl.type) : null;

    // Узлы дерева
    priceListCtrl.root = {
      name: 'Каталог товар и услуг',
      root: true,
      has_children: true,
      children: []
    };

    // Управление отображением колонок (аналог пейджинга)
    priceListCtrl.columnsPaging = {
      offset: 0,
      limit: ($window.innerWidth < 1300)? 2 : columnLimit || 3 // вычисление ширины экрана для того чтобы в ячейку помещались длинные суммы RECS-3844
    };

    priceListCtrl.treeColumns = columns || [];
    // установка флага наличия изменений
    angular.forEach(priceListCtrl.treeColumns, function (column) {
      column.$$hasChanges = changedColumns[column.id];
    });

    if (priceListCtrl.type == 'PURCHASE') {
      $scope.$watch('priceListCtrl.searchText', function (newVal, oldVal) {
        if (oldVal && !newVal) { // Если не пустое значение меняется на пустое (в широком смысле)
          priceListCtrl.showSearch = false; // Смена вида на каталог
        }
      });
    } else {
      $scope.$watchGroup(['priceListCtrl.searchText', 'priceListCtrl.dateFromInterval'], function(newVal) {
        if (!newVal[0] && (!newVal[1] || newVal[1].isAllTime)) {
          priceListCtrl.showSearch = false; // Смена вида на каталог
        }
      });
    }

    /* метод вызывается как callback при изменении данных ячейки */
    priceListCtrl.updateCell = function (node, column, prices) {
      var promise = $q.when();
      // очистка невалидных цен
      prices = _.filter(prices, function (price) {
               // в закупочном ПЛ нет дат
        return (price.effective_date || priceListCtrl.type == 'PURCHASE') && price.effective_qty && price.price_for_one_uom !== undefined;
      });
      if (!twoStepSaving) {
        // случай моментального сохранения
        promise = priceListSrv.immediateCommitPrices(
          node.catalog_item.id,
          column.id,
          prices).then(function () {}, function (error) {
            errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: error})
          });
      } else {
        // случай двуступенчатого сохранения
        if (prices != false) { // prices == false, ситуация отмены, чтобы не пробрасывать отдельный метод
          promise = priceLocalSrv.addAllPrices(
            node.catalog_item.id,
            column.id,
            prices,
            priceListCtrl.type
          );
        }
        // Обновление флага
        priceListCtrl.notEmptyChanges = priceLocalSrv.hasLocalChanges(priceListCtrl.type);
      }

      // обновление информации цены ячейки
      return promise.then(function() {
        return priceLocalSrv.priceByItem(
          node,
          priceListCtrl.type,
          !twoStepSaving // предается флаг загрузки только от бекенда, что актуально для одноступенчатого сохранения
        ).then(function (price) {
          // связывание цены с товаром или услугой
          node.price = price;

          // обновления актуальны только при двуступенчатом сохранении
          if (twoStepSaving) {
            // обновление флагов изменений в колонках
            priceLocalSrv.allPricesColumnsByItem(node.catalog_item.id, priceListCtrl.type)
              .then(function (columnsMap) {
                angular.forEach(priceListCtrl.treeColumns, function (column) {
                  column.$$hasChanges = columnsMap[column.id];
                });
              });

            // обновление флагов измнений в строках
            if (node.$$hasChanges) { // флаг устанавливается в сервисе при загрузке
              priceListCtrl.setChangeForParents(node);
            }
          }else{
            if (prices != false){
              $timeout(priceListCtrl.updateTree, 0);
            }
          }
        });
      });
    };

    /**
     * Установка флага наличия изменений всем родительским объектам
     * @param node
     */
    priceListCtrl.setChangeForParents = function(node) {
      node.$$hasChanges = true;
      if (node._parent) {
        priceListCtrl.setChangeForParents(node._parent);
      }
    }

    /* Открытие окна настроек */
    priceListCtrl.openSettings = function() {
      var modal = $uibModal.open({
        size: 'small-width',
        resolve: {},
        component: 'priceSettings'
      }).result.then(function () {
        // т.к. происходит изменение настроек колонок, страница перегружается полностью
        $state.reload();
      });
    };

    // Обновление структуры дерева
    priceListCtrl.updateTree = function(){
      priceListCtrl.root.resetRoot();
      priceListCtrl.root.expandFuncByModel(priceListCtrl.treeExpandModel);
    }

    /* callback для открытия модального окна добавлениея позиций */
    priceListCtrl.openNewPriceItems = function (node) {
      var modal = $uibModal.open({
        templateUrl: 'app/price-list/modal/new-price-item.modal.html',
        size: 'large-width',
        resolve: {
          categoryInputMode: false,
          type: function(){
            return priceListCtrl.type;
          },
          hiddenItems: function () {
            return null
          }
        },
        controller: 'newPriceItemModalController',
        controllerAs: 'newPriceItemModalCtrl',
        bindToController: true
      }).result.then(function () { // при успешном закрытии модельного окна переоткрывается деерво
        // Обновление структуры дерева
        priceListCtrl.updateTree();
      });
    };

    // callback для выделения строки
    priceListCtrl.selectNode = function (node) {
      if (node && node.type == "CATEGORY") {
        var path = _.map(priceListCtrl.searchRoot.getSelectedNode().$$parents, function (item) {
          return item.id
        });
        path.push(node.id);
        priceListCtrl.expandTreePath(path);
      }
    }
    // callback для выбора чекбокса строки в поиске
    priceListCtrl.checkedNodeSearch = function (node) {
      if (node.checked) {
        priceListCtrl.checkAllSearch = !_.find(priceListCtrl.searchRoot.children, function (child) {
          return !child.checked;
        });
      } else {
        priceListCtrl.checkAllSearch = false;
      }
    }
    // callback для выбора чекбокса строки в основном дереве
    priceListCtrl.checkedNode = function (node) {
      if (node.checked) {
        priceListCtrl.checkAll = !_.find(priceListCtrl.root.children, function (child) {
          return !child.checked;
        });
      } else {
        priceListCtrl.checkAll = false;
      }
    }

    /* callback для открытия попапа цен позиции */
    priceListCtrl.openPositionPrices = function (node, columnId, fromCell) {
      var modal = $uibModal.open({
        templateUrl: 'app/price-list/modal/price.modal.html',
        size: 'large-width',
        keyboard : false,
        resolve: {
          node: node,
          column_id:  function () {
            return columnId;
          },
          prices: function () {
            return priceLocalSrv.priceByItem(node, priceListCtrl.type);
          },
          columns: {data: priceListCtrl.treeColumns}, // нет смысла презатягивать через сервис
          lock: priceListCtrl.type == 'PURCHASE' && node.catalog_item.status == 'ARCHIVED',
          price_list_type: function () {
            return priceListCtrl.type;
          },
          catalog_item: null,
          from_cell: fromCell,
          updateTree: function () {
            return priceListCtrl.updateTree;
          }
        },
        controller: 'priceModalController',
        controllerAs: 'priceModalCtrl',
        bindToController: true
      });

      // обновление данных из стораджа в любом случае
      modal.result.finally(function () {
        // Обновление флага
        priceListCtrl.notEmptyChanges = priceLocalSrv.hasLocalChanges(priceListCtrl.type);
        // обновление информации цены ячейки
        priceLocalSrv.priceByItem(node, priceListCtrl.type).then(function (price) {
          // связывание цены с товаром или услугой
          node.price = price;
        });
      });
      return modal;
    };

    // Подготовка моедли колонок
    _.forEach(priceListCtrl.treeColumns, function (column) {
      if(!column.column_type){
        column.column_type = 'PURCHASE';
      }
      column.flex = 1;
      column.comnsLength = priceListCtrl.treeColumns.length;
      column.templateUrl = 'priceItemTemplate.html';
    });

    // Загрузка модели раскрытых узлов
    priceListCtrl.treeExpandModel = userSettingsService.loadProperty("price", "tree", "expandModel");

    /* Callback загрузки дерева */
    priceListCtrl.onTreeLoaded = function () {
      priceListCtrl.root.expandFuncByModel(priceListCtrl.treeExpandModel);
    };

    /**
     * Callback на раскрытие узла дерева
     *
     * @param node
     */
    priceListCtrl.onExpandNode = function (node) {
      userSettingsService.saveProperty("price", "tree", "expandModel", priceListCtrl.root.getExpandModel());
      // Обновление локальной копии модели раскрытых узлов (важно что без вызова хранилища - из-за последующего перевода на асинжронное АПИ)
      priceListCtrl.treeExpandModel = priceListCtrl.root.getExpandModel();
    }

    /**
     * Колбек на свертывание узла дерева
     *
     * @param node
     */
    priceListCtrl.onCollapseNode = function (node) {
      userSettingsService.saveProperty("price", "tree", "expandModel", priceListCtrl.root.getExpandModel());
      // Обновление локальной копии модели раскрытых узлов (важно что без вызова хранилища - из-за последующего перевода на асинжронное АПИ)
      priceListCtrl.treeExpandModel = priceListCtrl.root.getExpandModel();
    }

    /* Callback для раскрытия дерева */
    priceListCtrl.expand = function (node, nextPage) {
      // Загрузка дочерних категорий только при установленном флаге наличия (флаг наличия у root не играет значения)
      var categoryPromise = (!nextPage && (node.root || node.has_children)) ? priceListSrv.getCategories(priceListCtrl.type, node.id).then(function (data) {
        if (data.data) {
          // проверка для каждой раскрываемой категрии наличие её в списке с присутствующими изменениями
          angular.forEach(data.data, function (category) {
            if (priceListCtrl.changedCategories[category.id]) {
              category.$$hasChanges = true;
            }
          })
          return data.data;
        }
      }) : $q.when([]);

      var page = nextPage ? {
        // offset действует на загрузку товаров и услуг (не структурных элементов), но не категорий
        offset: _.filter(node.children, function(item) {return item.unstructure}).length
        // лимит по-умолчанию определяется в сервисе
      } : undefined;

      // Загрузка дочерних элементов только при их наличии
      var itemPromise = (node.own_item_count) ? priceListSrv.getCategoryItems(priceListCtrl.type, node.id, undefined, page).then(function (data) {
        if (data.data) {
          node.total = data.data.total;
          return data.data.items;
        }
      }) : $q.when([]);
      // Композиция промисов, и конкатенация рузультатов (в итоге компонент дерева не в курсе нескольки запросов при callback и остается универсальным)
      var itemsPromise = $q.all([categoryPromise, itemPromise]).then(function (values) {
        angular.forEach(values[1], function (item) {
          item.unstructure = true;
          item.has_children = false;
          item.item_count = 0;
        })
        return values[0].concat(values[1]);
      });

      // загрузка цен (будет переделано при смене АПИ)
      var pricePromises = []; // накопитель для промисов загрузки цен
      var pricePromise = itemsPromise.then(function (items) {
        angular.forEach(items, function (item) {
          if (item.catalog_item) {
            pricePromises.push(priceLocalSrv.priceByItem(item, priceListCtrl.type).then(function (price) {
              // связывание цены с товаром или услугой
              item.price = price;
            }));
          }
        });
        return $q.all(pricePromises).then(function () {
          return items; // возвращем товары и услуги
        });
      });

      return pricePromise;
    }

    /* метод раскрывает узлы деева по пути */
    priceListCtrl.expandTreePath = function (path) {
      priceListCtrl.root.collapseAll(); // сворачивание всех лишних узлов
      priceListCtrl.showSearch = false;
      priceListCtrl.searchRoot.resetRoot();
      priceListCtrl.clearSearch();
      priceListCtrl.root.expandFunc(path).then(function (lastNode) {
        // отложенный из-за рисков переключения элементов дерева с поиска на дерево
        $timeout(function () {
          var yOffsetOld = $anchorScroll.yOffset;
          $anchorScroll.yOffset = 300;
          $anchorScroll(lastNode.id); // скролл до строки с id = node.id
          $anchorScroll.yOffset = yOffsetOld;
        });
      }, function (failure) {
      });
    };

    /**
     * Удаление выбранных строк
     */
    priceListCtrl.removeSelected = function () {
      var selectionModel = (priceListCtrl.showSearch)? priceListCtrl.searchRoot.getSelectionModel() : priceListCtrl.root.getSelectionModel();
      // если выбран корневой элемент
      if (selectionModel[0].root) {
        var selectionModelIds = _.map(selectionModel[0].children, function (node) {
          return node.catalog_item ? node.catalog_item.id : node.id;
        });
      } else {
        // формирования списка идентификаторов
        var selectionModelIds = _.map(selectionModel, function (node) {
          // Для удаления значимым является идентификатор товара или каталога
          return node.catalog_item ? node.catalog_item.id : node.id;
        });
      }
      priceListSrv.removeItems(priceListCtrl.type, {
        items: selectionModelIds
      }).then(function () {
        if (priceListCtrl.showSearch){
          priceListCtrl.search();
        }
        // Обновление структуры дерева
        priceListCtrl.root.resetRoot();
        priceListCtrl.root.expandFuncByModel(priceListCtrl.treeExpandModel);
      });
    };

    // Метод, вызываемый при удалении элементов каталога из прайс-листа
    priceListCtrl.deletePriceItemModal = function () {
      $uibModal.open({
        templateUrl: 'app/price-list/modal/delete-price-item.modal.html',
        size: 'delete',
        resolve: {
          deleteItems: function () {
            return priceListCtrl.removeSelected;
          },
          type: function(){
            return priceListCtrl.type;
          }
        },
        controller: 'deletePriceItemModalController',
        controllerAs: 'deletePriceItemModalCtrl',
        bindToController: true
      });
    };

    /**
     * Откат локальных изменений
     */
    priceListCtrl.rollback = function () {
      // вызов диалогового окна подтверждения
      return modalAskSrv.showModal({
        title: 'Вы действительно хотите отменить введеные изменения?'
      }).then(function () {
        return priceLocalSrv.clearLocalChanges(priceListCtrl.type).then(function () {
          // Флаг наличия изменений
          priceListCtrl.notEmptyChanges = priceLocalSrv.hasLocalChanges(priceListCtrl.type);
          // Сброс флагов изменений в колонках
          angular.forEach(priceListCtrl.treeColumns, function (column) {
            column.$$hasChanges = false;
          });
          // Сброс закешированных запрошенных измененных
          priceListCtrl.changedCategories = {};

          priceListCtrl.root.resetRoot();
          priceListCtrl.root.expandFuncByModel(priceListCtrl.treeExpandModel);

          if (priceListCtrl.showSearch) {
            priceListCtrl.search();
          }
        });
      });
    };

    /**
     * Коммит локальных изменений
     */
    priceListCtrl.commit = function () {
      // вызов диалогового окна подтверждения
      return modalAskSrv.showModal({
        title: 'Вы действительно хотите опубликовать изменения<br>в ценах?'
      }).then(function () {
        priceListSrv.commitPrices(priceListCtrl.type).then(function () {
          // Флаг наличия изменений
          priceListCtrl.notEmptyChanges = priceLocalSrv.hasLocalChanges(priceListCtrl.type);

          // Сброс флагов изменений в колонках
          angular.forEach(priceListCtrl.treeColumns, function (column) {
            column.$$hasChanges = false;
          });
          // Сброс закешированных запрошенных измененных колонок
          priceListCtrl.changedCategories = {};

          if (priceListCtrl.showSearch) {
            priceListCtrl.search();
          }
          priceListCtrl.root.resetRoot();
          priceListCtrl.root.expandFuncByModel(priceListCtrl.treeExpandModel);
          requestStatus.success("Прайс-лист обновлен! Теперь товары и услуги доступны в продаже по новым ценам");
        }, function(error) {
          if (error.status === 409) {
            if (error.data.constraint_name === 'PRICE') {
              errorMessageService.showModal({message: 'При обновлении произошла ошибка', submessage: {data: { message: 'Нельзя опубликовать для одного товара несколько цен на одну дату'}}})
            }
          }
        });
      });
    };

    /**
     * Подсказка для показа количества подразделений, привязанных к колонке
     *
     * @param column
     */
    priceListCtrl.tipForDivisions = function (column) {
      var str = '';
      if (column.divisions.length) {
        str = 'Действует только для подразделений \n';
        angular.forEach(column.divisions, function (division, key) {
          if (key < 4) {
            str += ("<div>" + division.name + "</div>");
          } else if (key == 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    }
    /**
     * Подсказка для показа количества контрагентов, привязанных к колонке
     *
     * @param column
     */
    priceListCtrl.tipForCounterparties = function (column) {
      var str = '';
      if (column.counterparties.length) {
        str = 'Действует только для контрагентов \n';
        angular.forEach(column.counterparties, function (counterparty, key) {
          if (key < 4) {
            str += ("<div>" + counterparty.name + "</div>");
          } else if (key == 4) {
            str += "и прочих";
          }
        });
      }
      return str;
    }

    // вызов диалога печати прайс листа
    priceListCtrl.openPriceListPrintModal = function() {
      $uibModal.open({
        component: 'printPriceList',
        size: 'middle-width',
        resolve: {
          mode: function() {
            return priceListCtrl.type || 'RETAIL'
          },
          columns: function() {
            return priceListCtrl.treeColumns
          }
        }
      });
    };

    priceListCtrl.openPriceListExportModal = function() {
      var modal = $uibModal.open({
        component: 'priceListExport',
        size: 'middle-width',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          columns: function() {
            return priceColumnSrv.priceColumns(priceListCtrl.type).then(function(res) {
              return res;
            })
          },
          categoriesIds: function() {
            return _.map(priceListCtrl.root.getSelectionModel(), function (item) {
              return item.own_item_count || item.item_count ? item.id : undefined
            }).filter(Boolean)
          }
        }
      });
      modal.result.then(function(exec_id){
        if (exec_id) {
          print.cancelPrintPriceList(exec_id).then(function(res){
          }, function(error){
            errorMessageService.showModal({message: 'При отмене экспорта произошла ошибка', submessage: error});
          });
        }
      });
    }

    // Узлы дерева
    priceListCtrl.searchRoot = {
      name: 'Каталог товар и услуг',
      root: true,
      has_children: true,
      children: []
    };

    // структура пейджинга для поиска
    priceListCtrl.searchPaging = {
      loading: false,
      current: 0,
      limit: 10,
      offset: 0,
      total: undefined
    }

    /* Метод поиска в прайс-листе */
    priceListCtrl.search = function () {
      priceListCtrl.showSearch = true;
      priceListCtrl.checkAllSearch = false;
      priceListCtrl.searchRoot.resetRoot();
      priceListCtrl.searchRoot.expandFuncByModel();
      priceListCtrl.searchRoot.clearChecked();
    };

    /* отмены поиска */
    priceListCtrl.clearSearch = function () {
      priceListCtrl.showSearch = false;
      priceListCtrl.searchText = undefined;
      priceListCtrl.checkAllSearch = false;
      priceListCtrl.searchRoot.clearChecked();
      priceListCtrl.dateFromInterval = {
        startDate: new Date(),
        endDate: new Date(),
        isAllTime: true
      };
    };

    priceListCtrl.setIntervalPl = function (interval) {
      if (interval.startDate && interval.endDate && !interval.isAllTime &&
          !interval.startDate._a && !interval.endDate._a) {
        priceListCtrl.dateFromInterval = {
          startDate: new Date(),
          endDate: new Date(),
          isAllTime: true
        };
      }
    }

    /* Callback для раскрытия дерева */
    priceListCtrl.searchExpand = function (node) {
      var dateObj = (priceListCtrl.dateFromInterval && priceListCtrl.dateFromInterval.isAllTime)? undefined : priceListCtrl.dateFromInterval
      priceListCtrl.searchPaging.loading = true;
      var itemPromise = priceListSrv.searchElements(priceListCtrl.type, priceListCtrl.searchPaging, priceListCtrl.searchText, dateObj).then(function (data) {
        if (data.data) {
          node.total = data.data.total;
          priceListCtrl.searchPaging.total = data.data.total;
          return data.data.items;
        }
      });

      // загрузка цен (будет переделано при смене АПИ)
      var pricePromises = []; // накопитель для промисов загрузки цен
      var pricePromise = itemPromise.then(function (items) {
        angular.forEach(items, function (item) {
          if (item.type && item.type != "CATEGORY") {
            item.unstructure = true;
            item.has_children = false;
            item.item_count = 0;
            item.catalog_item = {
              id: item.id,
              name: item.name,
              type: item.type
            };
            if (!item.prices) {
              item.prices = [];
            }
          }
          if (item.catalog_item) {
            pricePromises.push(priceLocalSrv.priceByItem(item, priceListCtrl.type).then(function (price) {
              if (dateObj) {
                // проверка на наличие цен у найденного товара
                item.$$delete = true;
                _.forEach(priceListCtrl.treeColumns, function (column) {
                  _.find(price, function (priceObj, key) {
                    if (key == column.id) {
                      item.$$delete = false;
                      return;
                    }
                  })
                });
              }
              // связывание цены с товаром или услугой
              item.price = price;
            }));
          }
        });
        return $q.all(pricePromises).then(function () {
          if (dateObj) {
            items = _.filter(items, function (item) {
              return !item.$$delete;
            });
          }
          if (!items.length) {
            priceListCtrl.searchPaging.total = 0;
          }
          priceListCtrl.searchPaging.loading = false;
          return items;
        });

      });

      return pricePromise;
    }


  }

})();

(function() {
  'use strict';

  angular.module('frontend').service('partnersService', partnersService);

  /**
   * Сервис для работы с АПИ партнеров
   *
   * @param $http
   * @param API_URL базовый УРЛ бекенда
   * @constructor
   */
  function partnersService($http, API_URL) {

    /* Получение списка клиентов */
    this.getСlients = function (data) {
      return $http.get(API_URL + '/partnership/clients');
    }

    /* Добавляет уже зарегистрированный домен в качестве клиента к домену */
    this.addDomainСlient = function (data) {
      return $http.post(API_URL + '/partnership/clients/domain', data);
    }

    /* Получение данных по клиенту */
    this.getClientData = function (clientId) {
      return $http.get(API_URL + '/partnership/clients/' + clientId);
    }

    /* Добавляет уже зарегистрированный домен в качестве клиента к компании */
    this.addCompanyСlient = function (companyId, data) {
      return $http.post(API_URL + '/partnership/clients/company/' + companyId, data);
    }

    /* Добавляет уже зарегистрированный домен в качестве клиента к подразделению */
    this.addDivisonСlient = function (divisionId, data) {
      return $http.post(API_URL + '/partnership/clients/division/' + divisionId, data);
    }

    /* Добавляет промокод для домена */
    this.addPromo = function (code) {
      return $http.post(API_URL + '/sessions/me/partner_codes/' + code);
    }

    /* Удаляет промокод для домена */
    this.deletePromo = function (code) {
      return $http.delete(API_URL + '/sessions/me/partner_codes/' + code);
    }

    /* Получение данных по бонусам */
    this.getBonuses = function () {
      return $http.get(API_URL + '/partnership/bonuses/totals');
    }

    /* Получение кодов партнера */
    this.getObjectCodes = function () {
      return $http.get(API_URL + '/partnership/object_code');
    }

    /* Получение данных по настройкам партнера */
    this.getPartnershipSettings = function (object_code_id) {
      return $http.get(API_URL + '/partnership/settings/object_code/' + object_code_id);
    }

    this.updatePartnershipSettings = function (object_code_id, data) {
      return $http.put(API_URL + '/partnership/settings/object_code/' + object_code_id, data);
    };


    /* Получение данных о партнере */
    this.getMyPartner = function () {
      return $http.get(API_URL + '/partnership/partners/my_partner');
    };

    /* Получение данных о всех возможных парнерах */
    this.getPartners = function () {
      return $http.get(API_URL + '/partnership/partners');
    };

    /* Отменить партнерство */
    this.partnershipReject = function (code) {
      return $http.post(API_URL + '/partnership/reject', {"reject_reason": ""});
    }


  }

})();

'use strict';

angular.module('frontend').service('surveyService', function ($http, $q, API_URL) {

  /**
   * Получение списка активных опросов пользователя
   *
   * @return {HttpPromise}
   */
  this.getUserSurvey = function () {
    return $http.get(API_URL + '/survey');
    //return $http.get('assets/api/survey/surveyList.json');
  };

  /**
   * Получение списка новых активных опросов пользователя (непрочитанных)
   *
   * @return {HttpPromise}
   */
  this.getNewUserSurvey = function () {
    return $http.get(API_URL + '/survey/new');
    //return $http.get('assets/api/survey/surveyList.json');
  };

  /**
   * Установка времени прочтения
   *
   * @return {HttpPromise}
   */
  this.setUserSurveyViewed = function (survey_user_id) {
    return $http.get(API_URL + '/survey/' + survey_user_id + '/viewed');
  };

  /**
   * Установка времени появления всплывающего окна
   *
   * @return {HttpPromise}
   */
  this.setUserSurveyPopup = function (survey_user_id) {
    return $http.get(API_URL + '/survey/' + survey_user_id + '/popup');
  };

  /**
   * Получение тела опроса
   *
   * @return {HttpPromise}
   */
  this.getSurvey = function (survey_id) {
    return $http.get(API_URL + '/survey/' + survey_id);
  };

  /**
   * Получение количества новых сообщений
   *
   * @return {HttpPromise}
   */
  this.getCountNewSurvey = function () {
    return $http.get(API_URL + '/survey/new');
  };

  /**
   *  Сохраняет заполненные занные опроса
   */
  this.saveSurveyResponse = function (survey) {
    return $http.post(API_URL + '/survey', survey);
  }
});

(function () {
  'use strict';

  angular.module('frontend').controller('messagesController', messagesController);

  function messagesController($scope,
                              $stateParams,
                              $uibModal,
                              surveys,
                              surveyService,
                              errorMessageService,
                              $log,
                              $timeout) {
    var messagesCtrl = this;
    messagesCtrl.loadMessage = false;
    messagesCtrl.surveys = surveys;
    messagesCtrl.now = moment().valueOf();
    var timer;
    var currentSurveyTemplate = null;
    // Генерация документов
    messagesCtrl.buildSurvey = function (item, index) {
      messagesCtrl.currentSurveyTemplate = undefined;
      $timeout.cancel(timer);
      currentSurveyTemplate = item;
      messagesCtrl.loadMessage = true;
      messagesCtrl.currentSurveyMessage = item;
      messagesCtrl.messageData = messagesCtrl._buildValues(
        messagesCtrl.currentSurveyMessage.survey_responses);
      messagesCtrl.messageObj = {};

      surveyService.getSurvey(item.survey.id).then(function (data) {
        messagesCtrl.messageObj = angular.fromJson(data.data.body);
        messagesCtrl.loadMessage = false;
        messagesCtrl.currentSurveyTemplate = data.data;
        if (!item.seen_date) {
          // Сообщение считается просомтренным, когда оно было открытым не менее двух секунд
          timer = $timeout(function(){
            // При прочтении сообщения должно посылается уведомление на бекенд
            surveyService.setUserSurveyViewed(item.id).then(function(res){
              messagesCtrl.surveys[index] = res.data;
              messagesCtrl.currentSurveyTemplate = data.data;
              $scope.$emit("messageUpdated"); // уведомление об изменении статуса сообщения
            });
          }, 2000);
        }

      }, function () {
        messagesCtrl.loadMessage = false;
      })
    };

    /**
     * Метод собирает из массива ответов карту (map)
     *
     * @param values
     * @private
     */
    messagesCtrl._buildValues = function (values) {
      var temp = {};
      _.forEach(values, function (item) {
        temp[item.step] = item.response;
      });
      return temp;
    };

    messagesCtrl.valueSelected = function (code, value) {
      if (messagesCtrl._checkNeedAutoSend()) {
        messagesCtrl.sendSurvey();
      }
    };

    /**
     * Метод вычисляет необходимость автоматической отправки ответа при выборе значения
     *
     * @return {*|boolean}
     * @private
     */
    messagesCtrl._checkNeedAutoSend = function () {
      return messagesCtrl.currentSurveyTemplate &&
        messagesCtrl.currentSurveyTemplate.auto_send &&
        messagesCtrl.messageObj.items &&
        messagesCtrl.messageObj.items.length === 1;
    };

    /**
     * Метод содежит логику определения того, считать ли сообщение новым
     *
     * @param item
     * @return {boolean}
     */
    messagesCtrl.isNew = function(item) {
      return item && !item.seen_date && (item.survey_responses && item.survey_responses.length == 0);
    };

    messagesCtrl.sendSurvey = function () {
      if (!messagesCtrl.currentSurveyMessage)
        return;
      messagesCtrl.currentSurveyMessage.survey_responses = _.map(messagesCtrl.messageData, function (value, key) {
        return {step: key, response: value};
      });
      messagesCtrl.saving = true;
      surveyService.saveSurveyResponse(messagesCtrl.currentSurveyMessage).then(function (data) {
        messagesCtrl.currentSurveyMessage = data.data;
        messagesCtrl.messageData = messagesCtrl._buildValues(
          messagesCtrl.currentSurveyMessage.survey_responses);
        messagesCtrl.saving = false;
      }, function (err) {
        messagesCtrl.saving = false;
        errorMessageService.showModal({message: 'При сохранении ответа произошла ошибка', submessage: err});
      })
    };

    if ($stateParams.message_id) {
      var key;
      var item = _.find(messagesCtrl.surveys, function(survey, i){
        key = i;
        return survey.id == $stateParams.message_id;
      });
      if (item) {
        messagesCtrl.buildSurvey(item, key);
      }
    }

  }

})();

(function () {
  'use strict';

  angular.module('frontend').service('inventoryService', inventoryService);

  function inventoryService(API_URL, $http, $q) {

    var srv = this;

    /* метод в зависимости от типа выбирает нужный запрос */
    this.getByStockType = function (id, derivativeId, type, params) {
      if (type == 'BY_SERIAL_NUMBERS') {
        return srv.serialNumbers(derivativeId, params);
      }
      if (type.startsWith('BY_LOTS')) {
        return srv.lots(id, params);
      }
    };

    /* Получение списка партий по складской позиции */
    this.lots = function (stockItemId, params) {
      return $http.get(API_URL + '/inventory/stock_item/' + stockItemId + '/lots', {
        params: {
          search_string: params.search || undefined,
          offset: params.offset,
          limit: params.limit,
          filter_division_id: params.division_id || undefined,
          sort_by: (!params.search && !params.division_id)? "when_created" : undefined,
          sort_order: (!params.search && !params.division_id)? "desc" : undefined
        }
      });
    };

    /* Получение списка серийных номеров по складской позиции */
    this.serialNumbers = function (stockItemDerivativeId, params) {
      return $http.get(API_URL + '/inventory/stock_item/' + stockItemDerivativeId + '/serial_number', {
        params: {
          search_string: params.search || undefined,
          offset: params.offset,
          limit: params.limit,
          filter_division_id: params.division_id || undefined
        }
      });
    };

    /* Метод в зависимости от типа выбирает нужный запрос сохранения */
    this.saveByType = function (stockItem, type, data) {
      if (type == 'BY_SERIAL_NUMBERS') {
        return srv.createSerialNumber(stockItem.derivative.id, data);
      }
      if (type.startsWith('BY_LOTS')) {
        return srv.createLot(stockItem.id, data);
      }
    };

    /* Сохранение нового серийного номера */
    this.createSerialNumber = function (derivativeId, serialNumber) {
      var data = angular.copy(serialNumber);
      return $http.post(API_URL + '/inventory/stock_item/' + derivativeId + '/serial_number', data, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /* Сохранение новой партии */
    this.createLot = function (stockItemId, lot) {
      var data = angular.copy(lot);
      return $http.post(API_URL + '/inventory/stock_item/' + stockItemId + '/lots', data, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };


    this.stockBY_LOTS = function (params, paging) {
      return $http.get(API_URL + '/inventory/stock/' + params.stock_period_total_id + '/by_lots', {
        params: {
          limit: paging.limit || 5,
          offset: paging.offset || 0
        }
      });
    };

    this.stockBY_SERIAL_NUMBERS = function (params, paging) {
      return $http.get(API_URL + '/inventory/stock/' + params.stock_period_total_id + '/by_serial_number', {
        params: {
          limit: paging.limit || 5,
          offset: paging.offset || 0
        }
      });
    };

    this.stockTotalBY_LOTS = function (params, paging) {
      return $http.get(API_URL + '/inventory/stock_total/' + params.stock_total_type + '/by_lots', {
        params: {
          limit: paging.limit || 5,
          offset: paging.offset || 0,
          filter_division_id: params.filter_division_id || null,
          filter_date_from: params.filter_date_from,
          filter_date_to: params.filter_date_to,
          filter_derivative_id: params.filter_derivative_id,
          base: params.base
        }
      });
    };

    this.stockTotalBY_SERIAL_NUMBERS = function (params, paging) {
      return $http.get(API_URL + '/inventory/stock_total/' + params.stock_total_type + '/by_serial_number', {
        params: {
          limit: paging.limit || 5,
          offset: paging.offset || 0,
          filter_division_id: params.filter_division_id || null,
          filter_date_from: params.filter_date_from,
          filter_date_to: params.filter_date_to,
          filter_derivative_id: params.filter_derivative_id
        }
      });
    };


    this.stockRESERVES = function (params, paging) {
      return $http.get(API_URL + '/inventory/stock/' + params.stock_period_total_id + '/expected/' + params.transaction_type, {
        params: {
          limit: paging.limit || 5,
          offset: paging.offset || 0
        }
      });
    };

    // Получение складских остатков
    this.getInventoryStock = function (params) {
      return $http.get(API_URL + '/inventory/stock', {
        params: {
          filter_date: params.date,
          filter_derivative_id: params.derivative,
          filter_division_id : params.division
        }
      });
    };

    // Получение складских остатков по подразделению и по складским позициям
    this.getInventoryDivisionsStocks = function (params) {
      if(moment.isMoment(params.date)){
        params.date = moment.utc(params.date).valueOf()
      }
      return $http.get(API_URL + '/inventory/divisions/' + params.division + '/stocks', {
        params: {
          filter_date: params.date,
          filter_derivative_id: params.derivative,
          filter_serial_number_id: params.serial_number_id,
          filter_lot_number_id: params.lot_number_id
        }
      });
    };

    this.getInventoryTagSettings = function() {
      return $http.get(API_URL + '/inventory_tags/settings');
    };

    this.updateInventoryTagSettings = function(model) {
      return $http.put(API_URL + '/inventory_tags/settings', model, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    var paramsToRemove = ['last', 'inputPage', 'current', 'total'];


    this.getInventoryTagsDataByStock = function(searchString, filters, paging) {
      var params = {};
      angular.forEach(filters, function(value, key) {
        if (moment.isMoment(value)) {
          params['filter_' + key] = value.valueOf();
        } else {
          params['filter_' + key] = value;
        }
      });
      params.limit = paging.limit;
      params.offset = paging.offset;
      params.sort_by = paging.sortBy;
      params.sort_order = paging.sortDirection;
      params.search_string = searchString;
      return $http.get(API_URL + '/catalog/domain/items/inventory_tags/by_stock', {
        params: params
      })
    };

    this.getInventoryTagsDataByItem = function(itemId, searchString, gtinId) {
      return $http.get(API_URL + '/catalog/domain/items/inventory_tags/by_item', {
        params: {
          item_id: itemId,
          gtin_id: gtinId,
          search_string: searchString
        }
      })
    };

    this.getInventoryTagsDataByDocument = function(documentId, paging) {
      var params = {};
      params.document_id = documentId;
      params.limit = paging.limit;
      params.offset = paging.offset;
      params.sort_by = paging.sortBy;
      params.sort_order = paging.sortDirection;
      return $http.get(API_URL + '/catalog/domain/items/inventory_tags/by_document', {
        params: params
      })
    };

    this.getInventoryTagsData = function(type, args) {
      var promise = null;
      var source = type.substr(0, 1).toUpperCase() + type.substr(1, type.length);
      if (type === 'byStock') {
        promise = srv['getInventoryTagsData' + source];
      } else if (type === 'byItem') {
        promise = srv['getInventoryTagsData' + source];
      } else if (type === 'byDocument') {
        promise = srv['getInventoryTagsData' + source];
      }
      return promise.apply(null, args);
    }

  }

})();

(function() {
  angular.module('frontend').controller('guideDatesCtrl', guideDatesCtrl);


  function guideDatesCtrl($filter, auth, settings, $scope) {
    var vm = this;

    auth.ensureUserData().then(function(res) {
      vm.user = res.data.user;
    });
    vm.UTCDatePicker = moment.utc().startOf('day');

    vm.resetDatePickersData = function() {
      Object.keys(vm).forEach(function (prop) {
        if (prop.startsWith('state')) {
          vm[prop].resetData();
        }
      });
      $scope.$applyAsync(function () {

      })
    };

    vm.saveTimezone = function() {
      var requestBody = angular.copy(vm.user);
      requestBody.time_zone = vm.timezoneData.timezoneId;
      delete requestBody.domain;
      settings.updateProfileInfo(vm.user.id, requestBody)
        .then(function (res) {
          console.log('Updated successfully: new timezone is ', res.data.time_zone);
          auth.ensureUserData(true)
        })
    };

    vm.applyTimestamp = function() {
      var start = moment(parseInt(vm.timestampStart));
      var end = moment(parseInt(vm.timestampEnd));
      vm.UTCDatePicker = start;
      vm.UTCDateTimePicker = start;
      vm.datePicker = start;
      vm.dateTimePicker = start;

      if (vm.timestampStart && vm.timestampEnd) {
        vm.dateRangePickerUTC = {
          startDate: start,
          endDate: end
        };

        vm.dateRangePicker = {
          startDate: start,
          endDate: end
        };
      }
    };

    vm.datePickerWithDisabledDaysOpts = {
      singleDatePicker: true,
      correctTimeZone: false
    };

    vm.disabledDays = [moment().add(1, 'day'), moment().add(3, 'day'), moment().add(4, 'day')];


    vm.UTCDatePickerOpts = {
      singleDatePicker: true,
      correctTimeZone: false
    };

    vm.UTCDateTimePickerOpts = {
      timePicker: true,
      singleDatePicker: true,
      correctTimeZone: false
    };

    vm.datePickerOpts = {
      singleDatePicker: true,
      correctTimeZone: true
    };

    vm.dateTimePickerOpts =  {
      timePicker: true,
      singleDatePicker: true,
      correctTimeZone: true
    };

    vm.dateRangePickerUTCOpts = {
      correctTimeZone: false
    };

    vm.dateRangePickerOpts = {
      correctTimeZone: true
    };

    vm.dateRangePickerUTC = {};
    vm.dateRangePickerUTC.startDate = moment().startOf('day');
    vm.dateRangePickerUTC.endDate = moment().startOf('day').add(1,'day');


    vm.onDatePickerClose = function (returnValue, name) {
      console.log(returnValue, name);
    };


  }
})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .controller('guideController', guideController);

  /** @ngInject */
  function guideController($scope,
                           categoryService,
                           contragentService,
                           companyService,
                           $log,
                           errorMessageService,
                           surveyService,
                           auth,
                           dateRangePickerService) {
    var guide = this;

    // получение списка активных опросов
    surveyService.getUserSurvey().then(function (data) {
      guide.userSurveys = data.data;
    });

    guide.setSurvey = function(item) {
      guide.survey = item.body;
    };

    $scope.typeOf = function (value) {
      return typeof value;
    };

    guide.survey = '{\n' +
      '\t"id": "CREDIT_OFFER"\n' +
      '\t"title": "Предложение по кредиту",\n' +
      '\t"items": [\n' +
      '\t\t{\n' +
      '\t\t\t"code": "step1",\n' +
      '\t\t\t"name": "Шаг 1",\n' +
      '\t\t\t"message": "Добрый день! Вам обобрено преддожение по кредитной карте лимитом до 300 000р. \n' +
      '\t\t\t\t\t\tЕсли Вас заинтересовало предложение, заполните форму ниже или свяжительс с представителем банка. "\n' +
      '\t\t\t"placeholder": "Введите ответ",\n' +
      '\t\t\t"type": "TEXT"\n' +
      '\t\t},\n' +
      '\t]\n' +
      '}';

    guide.widgets = [
      {
        name: 'Спецрежим налогообложения',
        component: 'special-tax',
        allowRedactMode: true, // флаг разрешения режима редактирования (для обратной совместимости инверсный)
        settingsComponent: 'specialTaxSettings',
        eventHandlers: {
          saveEventHandler: function ($event) {
            alert('Сохранение было выбрано')
          },
          changeModeEventHandler: function () {
            alert('Произошло изменение режима отображения виджета')
          }
        },
        visible: true
      },
      {
        name: 'Спецрежим налогообложения2',
        component: 'special-tax',
        settingsComponent: 'specialTaxSettings',
        visible: true
      },
      {
        name: 'Спецрежим налогообложения3',
        component: 'special-tax',
        settingsComponent: 'specialTaxSettings',
        visible: true
      }
    ];

    guide.selectAutoOpt = {
      field: {},
      allowClear: true,
      required: true,
      refresh: function (search) {
        contragentService.counterpartiesSearch(search)
          .then(function (res) {
            guide.selectAutoOpt.field = res.data
          })
          .catch(function (error) {
            errorMessageService.showModal({
              message: 'При получение данных о контрагентах произошла ошибка',
              submessage: error
            }, true);
          })
      }
    };

    $scope.update = function () {
      $scope.barcode1 = generateNumber(8);
      $scope.barcode1form = 'ean8';
      $scope.barcode2 = generateNumber(13);
      $scope.barcode2form = 'ean13';
      $scope.barcode3 = generateNumber(12);
      $scope.barcode3form = 'upc';
      $scope.barcode4 = generateNumber(14);
      $scope.barcode4form = 'itf14';
    };
    $scope.update();

    function generateNumber(length) {
      var number = 0;
      for (var i = 0; i < length; i++) {
        number += Math.floor(Math.random() * 10) + ''
      }
      return parseInt(number)
    }


    // Элементы форм
    guide.inputs = {disabledInput: 'Не изменяемое значение'};
    guide.select = {};
    guide.contragentsAll = [];
    guide.inputs.isWrongFormData = false;

    guide.setDirty = function (form) {
      form.isWrongFormData = true;
      angular.forEach(form.$error, function (controls, errorName) {
        angular.forEach(controls, function (control) {
          control.$setDirty();
        });
      });
    }
    guide.inputs.integer = 23323;
    guide.inputs.integerReq = 1231232323;
    guide.inputs.float = 4444.222;
    guide.inputs.floatReq = 2131232.323;
    guide.inputs.money = 932.32;
    guide.inputs.code = '12312323';

    guide.makeRequiest = function () {
      guide.requiest = {
        float: guide.inputs.float,
        floatReq: guide.inputs.floatReq,
        int: guide.inputs.integer,
        intReq: guide.inputs.integerReq,
        sum: guide.inputs.money,
        code: guide.inputs.code
      }
    }

    /* Автодополнение контрагентов */
    guide.refreshContragents = function (search) {
      contragentService.counterpartiesSearch(search)
        .then(function (data) {
          guide.contragents = data.data.items;
          guide.contragents.push({});
          if (!search) guide.contragentsTotal = data.data.total;
        });
    }
    guide.refreshContragents();
    guide.select.multiple1 = [];


    // свормировать необходимые для данные для специфического множественного списка выбора для подразделений
    guide.divisionsData = [];
    companyService.companies({}).then(function (companyRes) {
      angular.forEach(companyRes.data.items, function (company) {
        companyService.companyDivisions(company.id).then(function (divisionRes) {
          angular.forEach(divisionRes.data, function (division) {
            division.$$companyName = company.name;
            guide.divisionsData.push(division);
          });
        });
      });
    });

    /* Все контрагенты */
    contragentService.counterparties({}).then(function (data) {
      guide.contragentsAll = data.data.items;
    });
    guide.select.multiple = [];
    guide.multipleSettings = {
      smartButtonMaxItems: 15,
      scrollable: true,
      keyboardControls: true,
      displayProp: 'name',
      showCheckAll: false,
      showUncheckAll: false
    };
    guide.customTexts = {
      buttonDefaultText: 'Выберите значение!',
    };

    // Узлы дерева
    guide.root = {
      name: 'Каталог товар и услуг',
      root: true,
      children: []
    }

    guide.treeColumns = [
      {
        name: 'Статус',
        flex: 1,
        templateUrl: 'statusTemplate.html'
      },
      {
        name: 'Тест',
        flex: 2,
        templateUrl: 'testTemplate.html'
      }
    ]

    guide.expand = function (node) {
      return categoryService.categories('f60188a7-96c4-45b2-8b19-9e667a176238', {}, {
        filter_parent_id: node.id
      }).then(function (data) {
        if (data && data.data) {
          return data.data.items;
        }
      })
    }

    /**
     * Пример добавления нового каталога в дерево
     */
    guide.addCatalog = function () {
      var path = guide.root.getSelectedNodePath();
      // Если даже path пустой - добавление произойдет в корень дерева
      guide.root.addItem({
        id: '00000000-0000-0000-0000-000000000000',
        name: guide.newCategoryName
      }, path).then(function () {
        $log.log('Новый узел успешно добавлен');
      }, function () {
        $log.log('Категория не была добавлена из-за ошибки');
      });
    };

    /**
     * Пример callback для вызова при выборе узла в дереве
     *
     * @param node выбранный узел
     */
    guide.selectCallback = function (node) {
      $log.log('Выбран: ', node);
    };

    /**
     * date-range-picker section
     */
    guide.datePickObj = {startDate: moment([2000, 3, 3]), endDate: moment([2014, 4, 5])};
    guide.datePickObj1 = {startDate: moment([2000, 3, 3]), endDate: moment([2014, 4, 5])};
    guide.datePickObj2 = {endDate: moment([2014, 4, 5])};
    guide.datePickObjTZ = {startDate: moment([2000, 3, 3]), endDate: moment([2014, 4, 5])};
    guide.datePickObj1TZ = {startDate: moment([2000, 3, 3]), endDate: moment([2014, 4, 5])};
    guide.datePickObj2TZ = {endDate: moment([2014, 4, 5])};

    guide.datePickState2 = {endDateCheck: true, startDateCheck: false};

    guide.dateTimePickModel = moment();
    guide.dateTimePickModelTZ = moment();

    guide.dateTimePickOpts = {timePicker: true, singleDatePicker: true, correctTimeZone: false};
    guide.dateTimePickOptsTZ = {timePicker: true, singleDatePicker: true, correctTimeZone: true};

    guide.singlePickOpts = {singleDatePicker: true, correctTimeZone: false};
    guide.singlePickOptsTZ = {singleDatePicker: true, correctTimeZone: true};

    guide.rangePickOpts = {singleDatePicker: false, correctTimeZone: false};
    guide.rangePickOptsTZ = {singleDatePicker: false, correctTimeZone: true};

    guide.opts = {
      range_1_utc: guide.rangePickOpts,
      range_2_utc: guide.rangePickOpts,
      range_3_utc: guide.rangePickOpts,
      range_1_tz: guide.rangePickOptsTZ,
      range_2_tz: guide.rangePickOptsTZ,
      range_3_tz: guide.rangePickOptsTZ,
      timezoneSingle: guide.singlePickOptsTZ,
      utcSingle: guide.singlePickOpts,
      date_time_utc: guide.dateTimePickOpts,
      date_time_tz: guide.dateTimePickOptsTZ
    };

    console.log(guide.outputs);

    auth.ensureUserData().then(function (user) {
      guide.time_zone = user.data.user.time_zone || new Date().getTimezoneOffset();

      guide.outputs = {
        range_1_utc: dateRangePickerService.getUtcDateTime(guide.datePickObj, guide.rangePickOpts),
        range_2_utc: dateRangePickerService.getUtcDateTime(guide.datePickObj2, guide.rangePickOpts),
        range_3_utc: dateRangePickerService.getUtcDateTime(guide.datePickObj1, guide.rangePickOpts),
        range_1_tz: dateRangePickerService.getUtcDateTime(guide.datePickObjTZ, guide.rangePickOptsTZ),
        range_2_tz: dateRangePickerService.getUtcDateTime(guide.datePickObj2TZ, guide.rangePickOptsTZ),
        // range_3_tz: dateRangePickerService.getUtcDateTime(guide.datePickObj1TZ, guide.rangePickOptsTZ),
        timezoneSingle: dateRangePickerService.getUtcDateTime(guide.datePickObj3TZ, guide.singlePickOptsTZ),
        utcSingle: dateRangePickerService.getUtcDateTime(guide.datePickObj3, guide.singlePickOpts),
        // date_time_utc: dateRangePickerService.getUtcDateTime(guide.dateTimePickModel, guide.dateTimePickOpts),
        date_time_tz: dateRangePickerService.getUtcDateTime(guide.dateTimePickModelTZ, guide.dateTimePickOptsTZ)
      };
    });

    guide.onDatePickerClose = function (returnValue, name) {
      console.log('ununu', returnValue, name);
      guide.outputs[name] = returnValue;
    };

    guide.getUtcDateTime = dateRangePickerService.getUtcDateTime;

    guide.redact = true;

    // Генерация документов
    guide.buildSurvey = function () {
      guide.messageData = {}; // карта значений
      guide.messageObj = angular.fromJson(guide.survey);
    };

    // Генерация документов
    guide.buildDocument = function () {
      guide.values = {
        test: 'Первичное значение'
      }; // карта значений
      guide.documentObj = angular.fromJson(guide.documentMeta);
    }
  }
})();

'use strict';

angular.module('frontend').service('egaiszService', function ($http, $q, API_URL) {

  /**
   * Получение метаданных ЕГАИС-докумнета по коду типа
   *
   * @param type код типа (ALCO_TTN_IN etc.)
   * @return {HttpPromise}
   */
  this.getMetaData = function (type) {
    return $http.get('assets/api/documents/alco/' + type + '.json');
  };

  /**
   * Получение списка ТТН
   *
   * @param paging настройки пейджинга списка ТТН
   * @param filters фильтры
   * @return {HttpPromise}
   */
  this.getWaybills = function (paging, filters) {
    paging = paging || {};
    var data = {
      // названия фильтров, возможно придется настраивать
      params: angular.extend(filters || {}, {
        limit: paging.limit || 100,
        offset: paging.offset || 0,
        sort_by: paging.sortBy,
        sort_order: paging.sortDirection
      })
    };
    return $http.get(API_URL + '/alcohol/documents/consignment_notes_in_egais', data);
  };

  /**
   * Получение расширенной информации о ТТН по идентификатору
   *
   * @param id идентификатор ТТН (товарно-транспортной накладной)
   * @return {HttpPromise}
   */
  this.getWaybill = function (id) {
    return $http.get(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + id).then(function (data) {
      return data.data;
    });
  };

  /**
   * Обновление сведений в ТТН (деривативы и фактически полученное количество товара)
   *
   * @param id идентификатор ТТН (товарно-транспортной накладной)
   * @return {HttpPromise}
   */
  this.updateWaybill = function (id, data) {
    return $http.put(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + id, data).then(function (data) {
      return data.data;
    });
  };

  /**
   * Проведение ТТН
   *
   * @param id идентификатор ТТН (товарно-транспортной накладной)
   * @return {HttpPromise}
   */
  this.setWaybillStatus = function (id, status) {
    return $http.put(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + id + '/status?status=' + status).then(function (data) {
      return data.data;
    });
  };

  /**
   * Метод получения информации о запросе начальных остатков
   *
   * @param id запроса
   * @return {HttpPromise}
   */
  this.getBeginningBalanceEgais = function (id) {
    return $http.get(API_URL + '/alcohol/documents/beginning_balances_egais/' + id);
  };

  /**
   * Метод обновления информации о запросе начальных остатков
   *
   * @param id запроса
   * @param data данные по запросу
   * @return {HttpPromise}
   */
  this.updateBeginningBalanceEgais = function (id, data) {
    return $http.put(API_URL + '/alcohol/documents/beginning_balances_egais/' + id, data);
  };

  /**
   * Метод получения информации о запросе начальных остатков
   *
   * @param id запроса
   * @param status новый статус запроса
   * @return {HttpPromise}
   */
  this.updateBeginningBalanceEgaisStatus = function (id, status) {
    var params = { status: status };
    return $http.put(API_URL + '/alcohol/documents/beginning_balances_egais/' + id + '/status', params);
  };

  /**
   * Запрос информации по позиции каталога
   *
   * @param id Идентификатор позиции каталога
   */
  this.getSkuInfo = function (id) {
    return $http.get(API_URL + '/alcohol/catalog/items/' + id);
  };

  /**
   * Запрос данных алкогольного каталога для автопоиска
   *
   * @param params Идентификатор позиции каталога
   */
  this.getAlcoholCatalogItems = function (params) {
    return $http.get(API_URL + '/alcohol/catalog/items/auto', {
      params: params
    });
  };

  /**
   * Метод вызывается при сканировании марки
   *
   * @param id идентификатор ТТН
   * @param barcode штрихкод
   * @param type тип ШК
   * @param operation тип операции (ACCEPTED, REJECTED)
   */
  this.scanMark = function (waybillId, barcode, operation) {
    return $http.put(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + waybillId + '/marks/state?request_type=' + (operation || 'ACCEPTED'), {
      code: barcode
    }, {
      params: {
        $$ignoreInterceptor: true,
      }
    }).then(function (data) {
        return data.data;
      });
  };

  /**
   * Метод получения информации марке
   *
   * @param id идентификатор накладной
   * @param code идентификатор (номер) марки
   */
  this.getMarkInfo = function (waybillId, code) {
    return $http.get(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + waybillId + '/marks', {
      params: {
        code: code
      }
    }).then(function (data) {
      return data.data;
    });
  };

  /**
   * Метод получения информации о марках по товару или услуге
   *
   * @param id идентификатор документа
   * @param line_id идентификатор линейки
   */
  this.getMarkInfoByCatalogItem = function (id, line_id) {
    return $http.get(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + id + '/lines/' + line_id + '/marks').then(function (data) {
      return data.data;
    });
  };

  /**
   * Метод получения отсканированныъ марок (история)
   *
   * @param id идентификатор накладной
   */
  this.getScannedMarks = function (waybillId) {
    return $http.get(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + waybillId + '/marks/accepted_history')
      .then(function (data) {
        return data.data;
      });
  };

  /**
   * Поиск принятых акцизных марок
   *
   * @param id идентификатор накладной
   */
  this.getStockMarks = function (params) {
    return $http.get(API_URL + '/alcohol/stock/marks', {
        params: params
      })
      .then(function (data) {
        return data.data;
      });
  };

  /**
   * Метод получения статусов товарно-транспортных накладных
   */
  this.getInvoiceWaybillStatuses = function () {
    return $http.get('assets/api/egais/invoice_waybill_statuses.json');
  };

  /**
   * Метод получения статусов списаний ЕГАИС
   */
  this.getCancellationActsStatuses = function () {
    return $http.get('assets/api/egais/cancellation_acts_statuses.json');
  };

  /**
   * Метод получения статусов запросов остатков ЕГАИС
   */
  this.getBeginningBalanceEgaisStatuses = function () {
    return $http.get('assets/api/egais/beginning_balance_egais_statuses.json');
  };

  /**
   * Метод получения статусов возвратов ЕГАИС
   */
  this.getWriteReturnStatuses = function () {
    return $http.get('assets/api/egais/write_return_egais_statuses.json');
  };

  /**
   * Метод получения статусов оприходований ЕГАИС
   */
  this.getWriteUpStatementStatuses = function () {
    return $http.get('assets/api/egais/write_up_statement_statuses.json');
  };

  /**
   * Метод получения причин списания ЕГАИС
   */
  this.getWriteOffTypes = function () {
    return $http.get('assets/api/egais/write_off_types.json');
  };

  /**
   * Получение списка связанных контрагентов (в каталоге участника и полученного из ЕГАИС)
   *
   * @param counterparty_id идентификатор контрагента
   * @paran egais boolean флаг, к чему относится контрагент
   */
  this.getCounterpartyBind = function (counterparty_id, egais) {
    return $http.get(API_URL + '/alcohol/counterparties/' + counterparty_id, {params: {egais: ((egais !== undefined)? egais : true)}});
  };

  /**
   * Автокомплит списка контрагентов (полученного из ЕГАИС)
   *
   * @paran paging объект с параметрами
   */
  this.getAlcoholCounterparties = function (search, limit, filter) {
    return $http.get(API_URL + '/alcohol/counterparties/auto', {
      params: {
        search_string: search,
        offset: (filter)? filter.offset : null,
        limit: limit,
        filter_egais_type: (filter)? filter.filter_egais_type : null
      }
    });
  };

  /**
   * Связывание контрагентов (в каталоге участника и полученного из ЕГАИС)
   *
   * @param counterparty_id идентификатор контрагента
   * @param {array} [counterparties] [список связанных контрагентов]
   * @param {bool} [recs] [флаг обозначаюший расположение искомого контрагента]
   */
  this.putCounterpartyBind = function (counterparty_id, counterparties, recs) {
    return $http.put(API_URL + '/alcohol/counterparties/' + counterparty_id, counterparties, {
      params: {
        recs: recs,
        $$ignoreInterceptor: true
      }
    });
  };

  /**
   * Запрос ранжированной истории связывания позиций алкогольного склада и деривативов
   *
   * @param id ттн
   * @param search_string
   * @param line_id id линейки в гриде
   */
  this.getAlcoDerivatives = function (id, search_string, line_id) {
    return $http.get(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + id + '/lines/' + line_id + '/alcohol_derivative_binding_history', {params: {search_string: search_string}});
  };

  /**
   * Запрос для формы детальной информации по позиции товарно-транспортной накладной ЕГАИС
   *
   * @param id ттн
   * @param line_id id линейки в гриде
   */
  this.getLineInfo = function (id, line_id) {
    return $http.get(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + id + '/lines/' + line_id + '/detail_info');
  };

  /**
   * Принятие решения по ТТН
   *
   * @param id ттн
   * @param [decide] решение
   */
  this.setDecide = function (id, decide) {
    return $http.post(API_URL + '/alcohol/documents/consignment_notes_in_egais/' + id + '/act', decide, {
      params: {
        $$ignoreInterceptor: true
      }
    });
  };

  /**
   * Запрос кодов марок
   *
   */
  this.getMarkTypes = function () {
    return $http.get(API_URL + '/alcohol/alcohol_mark_types');
  };

  /**
   * Запрос компаний со сведениями по fsrar
   *
   */
  this.getUtmsAuto = function () {
    return $http.get(API_URL + '/alcohol/utms');
  };

  // коды продукции
  this.getProductClassifier = function (search, limit, filters) {
    return $http.get(API_URL + '/alcohol/productClassifier/auto', {
        params: {
          limit: limit || 100,
          search_string: search,
          filter_low_alcohol: (filters)? filters.filter_low_alcohol : null
        }
      });
  };

  /**
   * Отправить запрос на начальный остатки в ЕГАИС
   *
   * @param {obj} [company] объект компании по fsrar
   */
  this.sendBeginningBalanceEgais = function (company) {
    return $http.post(API_URL + '/alcohol/documents/beginning_balances_egais', company);
  };

  /* Поиск справки 2 из остатков алкогольной продукции */
  this.searchForm2 = function (params) {
    return $http.get(API_URL + '/alcohol/stock/items/auto', {params: params});
  }

  /* Получение списка алкогольных позиций для автокомплита */
  this.catalogItemsAuto = function (params) {
    return $http.get(API_URL + '/alcohol/catalog/items/auto', {params: params});
  }

  /* Поиск документов ЕГАИС */
  this.searchDocumentsAuto = function (params) {
    return $http.get(API_URL + '/alcohol/documents/auto', {params: params});
  }

  /** Расширенный поиск алкогольных товаров **/

  /* Расширенный поиск позиции каталога алкогольной продукции */
  this.searchAlcoCatalogItems = function (params) {
    return $http.get(API_URL + '/alcohol/catalog/items/expanded_search', {params: params});
  }

  /* Расширенный поиск остатков алкогольной продукции */
  this.searchAlcoItems = function (params) {
    return $http.get(API_URL + '/alcohol/stock/items/expanded_search', {params: params});
  }

  /* Складские остатки алкоголя. Статус последнего запроса остатков в ЕГАИС 1 и 2 регистр */
  this.getBalanceStatus = function (fsrarId) {
    return $http.get(API_URL + '/alcohol/stock/balance_egais_request/' + fsrarId + '/status');
  }

  /* Складские остатки алкоголя. Запрос остатков в ЕГАИС 1 и 2 регистр */
  this.getBalance = function (fsrarId) {
    return $http.post(API_URL + '/alcohol/stock/balance_egais_request/' + fsrarId);
  }

  /* Складские остатки алкоголя. Получение складских остатков алкогольной продукции */
  this.getAlcoholStock = function (params) {
    return $http.get(API_URL + '/alcohol/stock', {params: params});
  };

  /* Складские остатки алкоголя. Запрос детализации складских остатков в разрезе заданной складской позиции и алкогольной продукции
      filter_fsrar_id *string - Fsrarid компании в ЕГАИС
      filter_catalog_id *string - Id алкогольного каталога
      filter_sku_id string - Id дериватива*/
  this.getAlcoholStockItem = function (filter_fsrar_id, filter_catalog_id, filter_sku_id, offset, limit) {
    return $http.get(API_URL + '/alcohol/stock/item', {params: {
      filter_fsrar_id: filter_fsrar_id,
      filter_catalog_id: filter_catalog_id,
      filter_sku_id: filter_sku_id,
      offset: offset,
      limit: limit
    }});
  };

  /* Запрос правок 1 */
  this.searchF1Reg = function (params) {
    return $http.get(API_URL + '/alcohol/inform_f1_reg', {params: params});
  }

});

'use strict';

/**
 * Сервис для синхронной работы с кодами ФАМ
 */
angular.module('frontend').service('egaiszFamService', function ($http, $q, API_URL) {

  var me = this;

  /**
   * Возвращает информацию о типе марки по коду
   *
   * @param code 3-х значный код марки
   * @return {*}
   */
  this.getFamInfoByCode = function (code) {
    return famCodes[code.toString().replace(/^0+(?=\d+)/g, '')];
  };

  /**
   * Возвращает информацию о типе марки по полному штрихкоду
   *
   * @param barcode полный штрихкод марки
   * @return {*}
   */
  this.getFamInfoByBarcode = function (barcode) {
    return me.getFamInfoByCode(barcode.substring(0, 3));
  };

  var famCodes = {
    "1": {
      "code": "ФСМ",
      "number": 1,
      "value": "Алкогольная продукция свыше 9 до 25%"
    },
    "2": {
      "number": 2,
      "code": "ФСМ",
      "value": "Алкогольная продукция свыше 25%. До 0.1 л"
    },
    "3": {
      "number": 3,
      "code": "ФСМ",
      "value": "Алкогольная продукция свыше 25%. До 0.25 л"
    },
    "4": {
      "number": 4,
      "code": "ФСМ",
      "value": "Алкогольная продукция свыше 25%. До 0.5 л"
    },
    "5": {
      "number": 5,
      "code": "ФСМ",
      "value": "Алкогольная продукция свыше 25%. До 0.75 л"
    },
    "6": {
      "number": 6,
      "code": "ФСМ",
      "value": "Алкогольная продукция свыше 25%. До 1 л"
    },
    "7": {
      "number": 7,
      "code": "ФСМ",
      "value": "Алкогольная продукция свыше 25%. Свыше 1 л"
    },
    "8": {
      "number": 8,
      "code": "ФСМ",
      "value": "Вина"
    },
    "9": {
      "number": 9,
      "code": "ФСМ",
      "value": "Вина шампанские и игристые"
    },
    "10": {
      "number": 10,
      "code": "ФСМ",
      "value": "Вина натуральные"
    },
    "20": {
      "number": 20,
      "code": "АМ",
      "value": "Алкогольная продукция свыше 9 до 25%"
    },
    "21": {
      "number": 21,
      "code": "АМ",
      "value": "Алкогольная продукция свыше 25%. До 0.1 л"
    },
    "22": {
      "number": 22,
      "code": "АМ",
      "value": "Алкогольная продукция свыше 25%. До 0.25 л"
    },
    "23": {
      "number": 23,
      "code": "АМ",
      "value": "Алкогольная продукция свыше 25%. До 0.5 л"
    },
    "24": {
      "number": 24,
      "code": "АМ",
      "value": "Алкогольная продукция свыше 25%. До 0.75 л"
    },
    "25": {
      "number": 25,
      "code": "АМ",
      "value": "Алкогольная продукция свыше 25%. До 1 л"
    },
    "26": {
      "number": 26,
      "code": "АМ",
      "value": "Алкогольная продукция свыше 25%. Свыше 1 л"
    },
    "27": {
      "number": 27,
      "code": "АМ",
      "value": "Вина"
    },
    "28": {
      "number": 28,
      "code": "АМ",
      "value": "Вина шампанские и игристые"
    },
    "29": {
      "number": 29,
      "code": "АМ",
      "value": "Вина натуральные"
    },
    "31": {
      "number": 31,
      "code": "АМ",
      "value": "Алкогольная продукция до 9 % включительно"
    },
    "101": {
      "number": 101,
      "code": "ФСМ",
      "value": "Спиртные напитки до 9 %"
    },
    "102": {
      "number": 102,
      "code": "ФСМ",
      "value": "Спиртные напитки свыше 9 до 25 %"
    },
    "103": {
      "number": 103,
      "code": "ФСМ",
      "value": "Крепкие спиртные напитки до 0,5 л"
    },
    "104": {
      "number": 104,
      "code": "ФСМ",
      "value": "Крепкие спиртные напитки до 0,75 л"
    },
    "105": {
      "number": 105,
      "code": "ФСМ",
      "value": "Крепкие спиртные напитки до 1 л"
    },
    "106": {
      "number": 106,
      "code": "ФСМ",
      "value": "Крепкие спиртные напитки свыше 1 л"
    },
    "107": {
      "number": 107,
      "code": "ФСМ",
      "value": "Водка до 0,5 л"
    },
    "108": {
      "number": 108,
      "code": "ФСМ",
      "value": "Водка до 0,75 л"
    },
    "109": {
      "number": 109,
      "code": "ФСМ",
      "value": "Водка до 1 л"
    },
    "110": {
      "number": 110,
      "code": "ФСМ",
      "value": "Водка свыше 1 л."
    },
    "111": {
      "number": 111,
      "code": "ФСМ",
      "value": "Вина игристые(шампанские) до 0,375 л."
    },
    "112": {
      "number": 112,
      "code": "ФСМ",
      "value": "Вина игристые(шампанские) до 0,75 л."
    },
    "113": {
      "number": 113,
      "code": "ФСМ",
      "value": "Вина игристые(шампанские) до 1,5 л."
    },
    "114": {
      "number": 114,
      "code": "ФСМ",
      "value": "Вина игристые(шампанские) свыше 1,5 л."
    },
    "115": {
      "number": 115,
      "code": "ФСМ",
      "value": "Вина виноградные до 0,375 л."
    },
    "116": {
      "number": 116,
      "code": "ФСМ",
      "value": "Вина виноградные до 0,75 л."
    },
    "117": {
      "number": 117,
      "code": "ФСМ",
      "value": "Вина виноградные до 1,5 л."
    },
    "118": {
      "number": 118,
      "code": "ФСМ",
      "value": "Вина виноградные свыше 1,5 л."
    },
    "119": {
      "number": 119,
      "code": "ФСМ",
      "value": "Вина ликерные до 0,375 л."
    },
    "120": {
      "number": 120,
      "code": "ФСМ",
      "value": "Вина ликерные до 0,75 л."
    },
    "121": {
      "number": 121,
      "code": "ФСМ",
      "value": "Вина ликерные до 1,5 л."
    },
    "122": {
      "number": 122,
      "code": "ФСМ",
      "value": "Вина ликерные свыше 1,5 л."
    },
    "123": {
      "number": 123,
      "code": "ФСМ",
      "value": "Вина фруктовые до 0,375 л."
    },
    "124": {
      "number": 124,
      "code": "ФСМ",
      "value": "Вина фруктовые до 0,75 л."
    },
    "125": {
      "number": 125,
      "code": "ФСМ",
      "value": "Вина фруктовые до 1,5 л."
    },
    "126": {
      "number": 126,
      "code": "ФСМ",
      "value": "Вина фруктовые свыше 1,5 л."
    },
    "127": {
      "number": 127,
      "code": "ФСМ",
      "value": "Винные напитки до 0,375 л."
    },
    "128": {
      "number": 128,
      "code": "ФСМ",
      "value": "Винные напитки до 0,75 л."
    },
    "129": {
      "number": 129,
      "code": "ФСМ",
      "value": "Винные напитки до 1,5 л."
    },
    "130": {
      "number": 130,
      "code": "ФСМ",
      "value": "Винные напитки свыше 1,5 л."
    },
    "131": {
      "number": 131,
      "code": "ФСМ",
      "value": "Крепкие спиртные напитки до 0,1 л"
    },
    "132": {
      "number": 132,
      "code": "ФСМ",
      "value": "Крепкие спиртные напитки 0,25 л"
    },
    "133": {
      "number": 133,
      "code": "ФСМ",
      "value": "Водка до 0,1 л"
    },
    "134": {
      "number": 134,
      "code": "ФСМ",
      "value": "Водка 0,25 л"
    },
    "135": {
      "number": 135,
      "code": "ФСМ",
      "value": "Водка 0,375 л"
    },
    "136": {
      "number": 136,
      "code": "ФСМ",
      "value": "Водка 0,5 л"
    },
    "137": {
      "number": 137,
      "code": "ФСМ",
      "value": "Винные напитки (без этилового спирта) до 0,375 л."
    },
    "138": {
      "number": 138,
      "code": "ФСМ",
      "value": "Винные напитки (без этилового спирта) до 0,75 л."
    },
    "139": {
      "number": 139,
      "code": "ФСМ",
      "value": "Винные напитки (без этилового спирта) до 1,5 л."
    },
    "140": {
      "number": 140,
      "code": "ФСМ",
      "value": "Винные напитки (без этилового спирта) свыше 1,5 л."
    },
    "141": {
      "number": 141,
      "code": "ФСМ",
      "value": "Винные напитки (с этиловым спиртом) до 0,375 л."
    },
    "142": {
      "number": 142,
      "code": "ФСМ",
      "value": "Винные напитки (с этиловым спиртом) до 0,75 л."
    },
    "143": {
      "number": 143,
      "code": "ФСМ",
      "value": "Винные напитки (с этиловым спиртом) до 1,5 л."
    },
    "144": {
      "number": 144,
      "code": "ФСМ",
      "value": "Винные напитки (с этиловым спиртом) свыше 1,5 л."
    },
    "145": {
      "number": 145,
      "code": "ФСМ",
      "value": "Коньяк. До 0,1 л"
    },
    "146": {
      "number": 146,
      "code": "ФСМ",
      "value": "Коньяк. 0,25 л"
    },
    "147": {
      "number": 147,
      "code": "ФСМ",
      "value": "Коньяк. До 0,5 л"
    },
    "148": {
      "number": 148,
      "code": "ФСМ",
      "value": "Коньяк. До 0,75 л"
    },
    "149": {
      "number": 149,
      "code": "ФСМ",
      "value": "Коньяк. До 1 л."
    },
    "150": {
      "number": 150,
      "code": "ФСМ",
      "value": "Коньяк. Свыше 1 л"
    },
    "151": {
      "number": 151,
      "code": "ФСМ",
      "value": "Коньяк (особый). До 0,1 л"
    },
    "152": {
      "number": 152,
      "code": "ФСМ",
      "value": "Коньяк (особый). 0,25 л"
    },
    "153": {
      "number": 153,
      "code": "ФСМ",
      "value": "Коньяк (особый). До 0,5 л"
    },
    "154": {
      "number": 154,
      "code": "ФСМ",
      "value": "Коньяк (особый). До 0,75 л"
    },
    "155": {
      "number": 155,
      "code": "ФСМ",
      "value": "Коньяк (особый). До 1 л"
    },
    "156": {
      "number": 156,
      "code": "ФСМ",
      "value": "Коньяк (особый). Свыше 1 л"
    },
    "157": {
      "number": 157,
      "code": "ФСМ",
      "value": "Вина виноградные (особые). До 1 л."
    },
    "158": {
      "number": 158,
      "code": "ФСМ",
      "value": "Вина виноградные (особые). Свыше 1 л."
    },
    "159": {
      "number": 159,
      "code": "ФСМ",
      "value": "Вина ликерные (особые). До 1 л."
    },
    "160": {
      "number": 160,
      "code": "ФСМ",
      "value": "Вина ликерные (особые). Свыше 1 л."
    },
    "161": {
      "number": 161,
      "code": "ФСМ",
      "value": "Вина игристые (особые). До 0,375 л."
    },
    "162": {
      "number": 162,
      "code": "ФСМ",
      "value": "Вина игристые (особые). До 1 л."
    },
    "163": {
      "number": 163,
      "code": "ФСМ",
      "value": "Вина игристые (особые). Свыше 1 л."
    },
    "164": {
      "number": 164,
      "code": "ФСМ",
      "value": "Спиртные напитки (особые). До 0,1 л."
    },
    "165": {
      "number": 165,
      "code": "ФСМ",
      "value": "Спиртные напитки (особые). 0,25 л."
    },
    "166": {
      "number": 166,
      "code": "ФСМ",
      "value": "Спиртные напитки (особые). До 0,5 л."
    },
    "167": {
      "number": 167,
      "code": "ФСМ",
      "value": "Спиртные напитки (особые). До 0,75 л."
    },
    "168": {
      "number": 168,
      "code": "ФСМ",
      "value": "Спиртные напитки (особые). До 1 л."
    },
    "169": {
      "number": 169,
      "code": "ФСМ",
      "value": "Спиртные напитки (особые). Свыше 1 л."
    },
    "202": {
      "number": 202,
      "code": "АМ",
      "value": "Спиртные напитки свыше 9 до 25 %"
    },
    "203": {
      "number": 203,
      "code": "АМ",
      "value": "Крепкие спиртные напитки до 0,5 л."
    },
    "204": {
      "number": 204,
      "code": "АМ",
      "value": "Крепкие спиртные напитки до 0,75 л."
    },
    "205": {
      "number": 205,
      "code": "АМ",
      "value": "Крепкие спиртные напитки до 1 л."
    },
    "206": {
      "number": 206,
      "code": "АМ",
      "value": "Крепкие спиртные напитки свыше 1 л."
    },
    "207": {
      "number": 207,
      "code": "АМ",
      "value": "Водка до 0,5 л."
    },
    "208": {
      "number": 208,
      "code": "АМ",
      "value": "Водка до 0,75 л."
    },
    "209": {
      "number": 209,
      "code": "АМ",
      "value": "Водка до 1 л."
    },
    "210": {
      "number": 210,
      "code": "АМ",
      "value": "Водка свыше 1 л."
    },
    "211": {
      "number": 211,
      "code": "АМ",
      "value": "Вина игристые (шампанские) до 0,375 л."
    },
    "212": {
      "number": 212,
      "code": "АМ",
      "value": "Вина игристые (шампанские) до 0,75 л."
    },
    "213": {
      "number": 213,
      "code": "АМ",
      "value": "Вина игристые (шампанские) до 1,5 л."
    },
    "214": {
      "number": 214,
      "code": "АМ",
      "value": "Вина игристые (шампанские) свыше 1,5 л."
    },
    "215": {
      "number": 215,
      "code": "АМ",
      "value": "Вина виноградные до 0,375 л."
    },
    "216": {
      "number": 216,
      "code": "АМ",
      "value": "Вина виноградные до 0,75 л."
    },
    "217": {
      "number": 217,
      "code": "АМ",
      "value": "Вина виноградные до 1,5 л."
    },
    "218": {
      "number": 218,
      "code": "АМ",
      "value": "Вина виноградные свыше 1,5 л."
    },
    "219": {
      "number": 219,
      "code": "АМ",
      "value": "Вина ликерные до 0,375 л."
    },
    "220": {
      "number": 220,
      "code": "АМ",
      "value": "Вина ликерные до 0,75 л."
    },
    "221": {
      "number": 221,
      "code": "АМ",
      "value": "Вина ликерные до 1,5 л."
    },
    "222": {
      "number": 222,
      "code": "АМ",
      "value": "Вина ликерные свыше 1,5 л."
    },
    "223": {
      "number": 223,
      "code": "АМ",
      "value": "Вина фруктовые до 0,375 л."
    },
    "224": {
      "number": 224,
      "code": "АМ",
      "value": "Вина фруктовые до 0,75 л."
    },
    "225": {
      "number": 225,
      "code": "АМ",
      "value": "Вина фруктовые до 1,5 л."
    },
    "226": {
      "number": 226,
      "code": "АМ",
      "value": "Вина фруктовые свыше 1,5 л."
    },
    "227": {
      "number": 227,
      "code": "АМ",
      "value": "Винные напитки до 0,375 л."
    },
    "228": {
      "number": 228,
      "code": "АМ",
      "value": "Винные напитки до 0,75 л."
    },
    "229": {
      "number": 229,
      "code": "АМ",
      "value": "Винные напитки до 1,5 л."
    },
    "230": {
      "number": 230,
      "code": "АМ",
      "value": "Винные напитки свыше 1,5 л."
    },
    "231": {
      "number": 231,
      "code": "АМ",
      "value": "Спиртные напитки до 9 %"
    },
    "232": {
      "number": 232,
      "code": "АМ",
      "value": "Крепкие спиртные напитки до 0,1 л."
    },
    "233": {
      "number": 233,
      "code": "АМ",
      "value": "Крепкие спиртные напитки до 0,25 л."
    },
    "234": {
      "number": 234,
      "code": "АМ",
      "value": "Водка до 0,1 л."
    },
    "235": {
      "number": 235,
      "code": "АМ",
      "value": "Водка до 0,25 л."
    }
  };

});

(function() {
  'use strict';

  angular
    .module('frontend')
    .factory('focus', function($timeout) {
      return {
        setFocusOnInput: function (selector, element) {// для установки фокуса в инпут передаем в аргументе селеrтор инпута? вторым парпаметром элемент,т.к. селектора иногда не хватает
          $timeout(function() {
            if (typeof selector == 'string') {
              var input = angular.element(selector);
              if (input) {
                input.focus();
              }
            }else if (element) {
              element.focus();
            }
          });
        },//method end
        setFocusOnUiSelect: function (element) {
          $timeout(function() {
            if (angular.isElement(element)) {
              var input = element.getElementsByTagName('input')[0],
                  span = element.querySelector('.ui-select-toggle');
              span.click();
              input.focus();
            }
          })
        }//method end
      } // return end
    })
})();

(function () {
  'use strict';

  angular.module('frontend').service('comparativeService', comparativeService);

  function comparativeService($http, API_URL) {

    /* Запрос статистики за период */
    this.retailSalesTotal = function (startDate, endDate, companyId, divisionId) {
      return $http.get(API_URL + "/reports/retail_sales_total", {
        params: {
          start_date: startDate,
          end_date: endDate,
          company_id: companyId,
          division_id: divisionId
        }
      });
    };

    /* Запрос статистики за период */
    this.retailSalesTotalCategory = function (currentStartDate,
                                              currentEndDate,
                                              previousStartDate,
                                              previousEndDate,
                                              categoryId,
                                              companyId,
                                              divisionId) {
      return $http.get(API_URL + "/reports/retail_sales_total/lfl", {
        params: {
          current_start_date: currentStartDate,
          current_end_date: currentEndDate,
          previous_start_date: previousStartDate,
          previous_end_date: previousEndDate,
          category_id: categoryId,
          company_id: companyId,
          division_id: divisionId
        }
      });
    };

  }

})();

(function () {
  'use strict';

  angular.module('frontend').controller('comparativeController', comparativeController);

  function comparativeController($scope,
                                 $uibModal,
                                 comparativeService,
                                 companyService,
                                 currencyHome, // домашняя валюта из роутинга
                                 $q,
                                 $state,
                                 $filter,
                                 priceListSrv, // сервис для работы с прайс-листом
                                 $rootScope,
                                 hasNeededRole,
                                 $log) {
    var comparativeCtrl = this;
    comparativeCtrl.today = moment.utc().startOf('day');
    // тип информации в гриде, по умолчанию "стало"
    comparativeCtrl.customGridType = 'after';

    comparativeCtrl.comparativeService = comparativeService;
    // валюта домена
    comparativeCtrl.currencyHome = currencyHome;

    // инициализация диапазона
    comparativeCtrl.dateRange = 'day';

    // стек категорий
    comparativeCtrl.categoryStack = new Array();
    comparativeCtrl.currentCategory = undefined;

    // время на момент перехода на страницу
    comparativeCtrl.calendarDateM = moment.utc().startOf('day');
    comparativeCtrl.calendarDate = moment.utc().startOf('day').toDate();

    comparativeCtrl.dateTo = comparativeCtrl.today.clone().subtract(0, "days");
    comparativeCtrl.dateFrom = comparativeCtrl.today.clone().subtract(7, "days");

    // инициализация интревалов
    comparativeCtrl.dateToInterval = {};
    comparativeCtrl.dateToInterval.startDate = moment.utc().startOf('day').subtract(4, 'day');
    comparativeCtrl.dateToInterval.endDate = moment.utc().startOf('day').subtract(3, 'day');
    comparativeCtrl.dateFromInterval = {};
    comparativeCtrl.dateFromInterval.startDate = moment.utc().startOf('day').subtract(2, 'day');
    comparativeCtrl.dateFromInterval.endDate = moment.utc().startOf('day').subtract(1, 'day');

    /* Автодополнение компаний */
    comparativeCtrl.refreshCompanies = function (search) {
      companyService.companiesSearch(search)
        .then(function (data) {
          comparativeCtrl.companies = data.data.items;
        });
    };
    comparativeCtrl.refreshCompanies();

    /**/
    comparativeCtrl.refreshDivisions = function () {
      if (comparativeCtrl.company) {
        // если компания выбрана - обновляем список
        companyService.companyDivisions(comparativeCtrl.company.id)
          .then(function (data) {
            comparativeCtrl.divisions = data.data;
          });
      } else {
        // если компания не выбрана - сброс значений подразделений
        comparativeCtrl.division = undefined;
        comparativeCtrl.divisions = [];
      }
    }

    comparativeCtrl.updateIndicatorsCurrent = function () {
      comparativeCtrl._loadIndicatorDelta(
        comparativeCtrl.calendarDateM, comparativeCtrl.dateRange
      ).then(function (data) {
        comparativeCtrl.indicatorsCurrent = data;
      }, function (error) {
        $log.log('При обновлении показателя произошла ошибка');
      });
    }

    comparativeCtrl.columnCategory = [{
      name: 'Категория',
      flex: 10,
      templateUrl: 'comparativeCategoryCellTemplate.html',
      templateHeaderScope: $scope,
      templateScope: $scope,
      visible: true,
      column_visible: true
    }];

    // описание колонок показателей
    comparativeCtrl.columnsAfter = [{
      name: 'Текущий',
      flex: 5,
      headerTemplateUrl: 'gridHeaderLightTemplate.html',
      templateUrl: 'comparativeIndicatorSalesToCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    }, {
      name: 'Текущий',
      flex: 5,
      headerTemplateUrl: 'gridHeaderLightTemplate.html',
      templateUrl: 'comparativeIndicatorAverageToCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    }, {
      name: 'Текущий',
      flex: 5,
      headerTemplateUrl: 'gridHeaderLightTemplate.html',
      templateUrl: 'comparativeIndicatorClientsToCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    }];
    // описание колонок показателей
    comparativeCtrl.columnsBefore = [{
      name: 'Предыдущий',
      flex: 5,
      headerTemplateUrl: 'gridHeaderLightTemplate.html',
      templateUrl: 'comparativeIndicatorSalesFromCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    }, {
      name: 'Предыдущий',
      flex: 5,
      headerTemplateUrl: 'gridHeaderLightTemplate.html',
      templateUrl: 'comparativeIndicatorAverageFromCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    }, {
      name: 'Предыдущий',
      flex: 5,
      headerTemplateUrl: 'gridHeaderLightTemplate.html',
      templateUrl: 'comparativeIndicatorClientsFromCellTemplate.html',
      templateScope: $scope,
      visible: true,
      column_visible: true
    }];


    comparativeCtrl.changeGridType = function () {
      var columns = (comparativeCtrl.customGridType == 'before') ? comparativeCtrl.columnsBefore : comparativeCtrl.columnsAfter;
      comparativeCtrl.columns = comparativeCtrl.columnCategory.concat(columns);
    }
    comparativeCtrl.changeGridType();

    /**
     * @param date локальная дата
     * @return {*}
     * @private
     */
    comparativeCtrl._parceDateWithBaseFormat = function (date) {
      if (!date) return date;
      return moment.utc(date);
    };

    comparativeCtrl.onDateFromPickerIntervalClose = function (returnValue) {
      comparativeCtrl.dateFromInterval = returnValue;
    };

    comparativeCtrl.onDateToPickerIntervalClose = function (returnValue) {
      comparativeCtrl.dateToInterval = returnValue;
    };

    comparativeCtrl.getDateRangeObj = function (date) {
      return moment.utc(date.clone()).add(1, comparativeCtrl.dateRange).subtract(1, 'day');
    }

    /**
     * Загрука показателей по дате и смещению
     *
     * @param дата moment
     * @param delta
     * @private
     */
    comparativeCtrl._loadIndicatorDelta = function (date, delta) {
      return comparativeCtrl.comparativeService.retailSalesTotal(
        date.valueOf(),
        date.clone().add(1, delta).subtract(1, 'day').valueOf(),
        comparativeCtrl.company ? comparativeCtrl.company.id : undefined,
        comparativeCtrl.division ? comparativeCtrl.division.id : undefined
      ).then(function (data) {
        return data.data;
      });
    }

    /**
     * Загрука показателей по дате начала и конца интервала
     *
     * @param dateFrom дата moment
     * @param dateTo дата moment
     * @private
     */
    comparativeCtrl._loadIndicatorDates = function (dateFrom, dateTo) {
      return comparativeCtrl.comparativeService.retailSalesTotal(
        dateFrom.valueOf(),
        dateTo.valueOf(),
        comparativeCtrl.company ? comparativeCtrl.company.id : undefined,
        comparativeCtrl.division ? comparativeCtrl.division.id : undefined
      ).then(function (data) {
        return data.data;
      });
    };

    /**
     * Обновление показателей, согласно выбранных дат
     */
    comparativeCtrl.loadIndicators = function () {
      // Обновление базового показателя
      if (comparativeCtrl.showInterval == false) {
        var toPromise = comparativeCtrl._loadIndicatorDelta(
          comparativeCtrl.dateFrom, comparativeCtrl.dateRange
        ).then(function (data) {
          comparativeCtrl.indicatorsFrom = data;
        }, function (error) {
          $log.log('При обновлении показателя произошла ошибка');
        });
        // Обновление показателй "На"
        var fromPromise = comparativeCtrl._loadIndicatorDelta(
          comparativeCtrl.dateTo, comparativeCtrl.dateRange
        ).then(function (data) {
          comparativeCtrl.indicatorsTo = data;
        }, function (error) {
          $log.log('При обновлении показателя произошла ошибка');
        });
      } else {
        // hotfix - пока в компоненте датапикера "За все время" - означает сегодняшнюю дату
        var dateFrom = comparativeCtrl.dateFromInterval,
          dateTo = comparativeCtrl.dateToInterval;
        if (dateFrom.isAllTime) {
          dateFrom = { startDate: moment.utc(1514757600000), endDate: comparativeCtrl.today };
        }
        if (!dateFrom.startDate) {
          dateFrom.startDate = moment.utc(1514757600000);
        }
        if (!dateFrom.endDate) {
          dateFrom.endDate = comparativeCtrl.today;
        }
        if (dateTo.isAllTime) {
          dateTo = { startDate: moment.utc(1514757600000), endDate: comparativeCtrl.today };
        }
        if (!dateTo.startDate) {
          dateTo.startDate = moment.utc(1514757600000);
        }
        if (!dateTo.endDate) {
          dateTo.endDate = comparativeCtrl.today;
        }
        // end hotfix

        var toPromise = comparativeCtrl._loadIndicatorDates(
          dateTo.startDate, dateTo.endDate
        ).then(function (data) {
          comparativeCtrl.indicatorsFrom = data;
        }, function (error) {
          $log.log('При обновлении показателя произошла ошибка');
        });
        // Обновление показателй "На"
        var fromPromise = comparativeCtrl._loadIndicatorDates(
          dateFrom.startDate, dateFrom.endDate
        ).then(function (data) {
          comparativeCtrl.indicatorsTo = data;
        }, function (error) {
          $log.log('При обновлении показателя произошла ошибка');
        });
      }

      return $q.all([toPromise, fromPromise]);
    };

    comparativeCtrl.showInterval = false; // по-умолчанию интервальные пикеры выключены

    /* обновление виджетов */
    comparativeCtrl._refreshData = function () {

      // проверка на переключение на интервал
      if (comparativeCtrl.dateRange == -1) { // зарезервированное значение для интервала
        if (!comparativeCtrl.showInterval) {
          comparativeCtrl.showInterval = true;
        }
      } else {
        comparativeCtrl.showInterval = false;
      }

      var promiseMain = comparativeCtrl.loadIndicators();
      // Загрузка обновленных данных по вершине стека
      var promiseCatalog = comparativeCtrl._expand();

      comparativeCtrl.loadingAll = true;
      $q.all([promiseMain, promiseCatalog]).then(function (success) {
        comparativeCtrl.loadingAll = false;
      }, function (failure) {
        comparativeCtrl.loadingAll = false;
      });
    }

    // хук на изменение даты
    $scope.$watch('comparativeCtrl.dateTo', function (newVal) {
      comparativeCtrl._refreshData();
    });

    // хук на изменение даты
    $scope.$watch('comparativeCtrl.dateFrom', function (newVal) {
      comparativeCtrl._refreshData();
    });

    /* Раскрытие текущей категории */
    comparativeCtrl._expand = function () {
      comparativeCtrl.loading = true;
      var expandedCategory = comparativeCtrl.categoryStack && comparativeCtrl.categoryStack.length ?
        comparativeCtrl.categoryStack[comparativeCtrl.categoryStack.length - 1] :
        undefined;
      // Загрузка дочерних категорий только при установленном флаге наличия
      if (comparativeCtrl.showInterval) {
        var categoryPromise = comparativeService.retailSalesTotalCategory(
          comparativeCtrl.dateFromInterval.startDate.clone().valueOf(),
          comparativeCtrl.dateFromInterval.endDate.clone().valueOf(),
          comparativeCtrl.dateToInterval.startDate.clone().valueOf(),
          comparativeCtrl.dateToInterval.endDate.clone().valueOf(),
          expandedCategory ? expandedCategory.item.id : undefined,
          comparativeCtrl.company ? comparativeCtrl.company.id : undefined,
          comparativeCtrl.division ? comparativeCtrl.division.id : undefined
        ).then(function (data) {
          comparativeCtrl.loading = false;
          if (data.data) {
            return data.data;
          }
        }, function (failure) {
          comparativeCtrl.loading = false;
        });
      } else {
        var categoryPromise = comparativeService.retailSalesTotalCategory(
          comparativeCtrl.dateTo.clone().valueOf(),
          comparativeCtrl.dateTo.clone().add(1, comparativeCtrl.dateRange).subtract(1, 'day').valueOf(),
          comparativeCtrl.dateFrom.clone().valueOf(),
          comparativeCtrl.dateFrom.clone().add(1, comparativeCtrl.dateRange).subtract(1, 'day').valueOf(),
          expandedCategory ? expandedCategory.item.id : undefined,
          comparativeCtrl.company ? comparativeCtrl.company.id : undefined,
          comparativeCtrl.division ? comparativeCtrl.division.id : undefined
        ).then(function (data) {
          comparativeCtrl.loading = false;
          if (data.data) {
            return data.data;
          }
        }, function (failure) {
          comparativeCtrl.loading = false;
        });
      }

      return categoryPromise.then(function (values) {
        // присваивание и возврат
        return comparativeCtrl.currentCategoryChildren = values;
      });
    }

    /* Вызыыается при выборе категории в интрефейсе */
    comparativeCtrl.expandCategory = function (expandedCategory, up) {
      // занесение в стек, если это не всплытие
      if (!up) {
        if (expandedCategory) {
          comparativeCtrl.categoryStack.push(expandedCategory);
        }
      }
      return comparativeCtrl._expand();
    };

    /**
     * Метод осуществляет переход выше по стеку (на категорию)
     */
    comparativeCtrl.up = function (category) {
      while (true) {
        comparativeCtrl.currentCategory = comparativeCtrl.categoryStack.pop();
        if (!comparativeCtrl.currentCategory || category == comparativeCtrl.currentCategory)
          break;
      }
      // открытие новой категории
      comparativeCtrl._expand();
    }

    // Загрузка первичных данных
    comparativeCtrl.updateIndicatorsCurrent();
    //comparativeCtrl._refreshData();
  }

})();

(function() {
  'use strict';

  angular
  .module('frontend')
  .service('print', print);

  /** @ngInject */
  function print($http, API_URL, helpService, $timeout, authToken, $rootScope) {
    var self = this;

    this.turnonInterceptorStatus = function() {
      $rootScope.preventInterceptorStatuses = true;
    };

    this.turnoffInterceptorStatus = function() {
      $rootScope.preventInterceptorStatuses = false;
    }

    this.printUsers = function(format) {
      return $http.post(API_URL + '/print_report/repo/USERS?format=' + format, {}, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.prepareDocumentPrintForm = function(formCode, documentId, params, format) {
      return $http.post(API_URL + '/print_report/dpf/' + formCode + '/' + documentId + '?format=' + format, params, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.getOutput = function(exec_id) {
      return $http.get(API_URL + '/print_report/executions/' + exec_id + '/output');
    };

    this.printInventoryTags = function(items) {
      return $http.post(API_URL + '/print_report/repo/INVENTORY_TAGS', {items: items}, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.printSalesTotal = function(model, format) {
      return $http.post(API_URL + '/print_report/repo/SALES_TOTALS?format=' + format, model, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.printTags = function(model) {
      return $http.post(API_URL + '/print_report/repo/PRICE_TAGS', model, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.printPriceList = function(model, format) {
      return $http.post(API_URL + '/print_report/repo/PRICE_LIST?format=' + format, model, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };


    this.exportPriceList = function(model) {
      return $http.post(API_URL + '/print_report/repo/EXPORT_PRICE_LIST', model, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };
    
    this.cancelPrintPriceList = function(id) {
      return $http.put(API_URL + '/print_report/executions/' + id + '/cancel', {}, {
        params: {
          $$ignoreInterceptor: true
        }
      });

    };
    
    this.printStock = function(format, model) {
      return $http.post(API_URL + '/print_report/repo/STOCK_TOTAL?format=' + format, model, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    }


    this.consentReport = function(consent) {
      return $http.post(API_URL + '/print_report/repo/CONSENT', consent);
    }

    this.printRetailSalesAnalyticalTotals = function(data) {
      return $http.post(API_URL + '/print_report/repo/RETAIL_SALES_ANALYTICAL_TOTALS', data);
    }

    this.printProfitAndLoss = function(data, format) {
      return $http.post(API_URL + '/print_report/repo/PROFIT_AND_LOSS?format=' + format, data);
    }

    this.printPeriodTotals = function(data, format) {
      return $http.post(API_URL + '/print_report/repo/PERIOD_TOTALS?format=' + format, data);
    }

    this.printCashFlow = function(data, format) {
      return $http.post(API_URL + '/print_report/repo/CASH_FLOW?format=' + format, data);
    }

    this.printClosePeriod = function(id, format) {
      return $http.post(API_URL + '/print_report/dpf/DPF_CONSIGNMENT_NOTE_IN_UTD_SHOT/' + id + '?format=' + format, {});
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service('helpService',helpService);

  /** @ngInject */
  function helpService($uibModal, $rootScope) {
    var self = this;
    this.stringGen = function () {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

      for (var i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    };

    this.addId = function (obj) {
      if (obj) {
        obj.$$uiid = self.stringGen();
      }
    };

    this.toSnakeCase = function(val) {
      if (!val) {
        return
      }
      var upperChars = val.match(/([A-Z])/g);
      if (!upperChars) {
        return val;
      }

      var str = val.toString();
      for (var i = 0, n = upperChars.length; i < n; i++) {
        str = str.replace(new RegExp(upperChars[i]), '_' + upperChars[i].toLowerCase());
      }

      if (str.slice(0, 1) === '_') {
        str = str.slice(1);
      }

      return str;
    };


    this.getCrudStateStructure = function() {
      return {
        error: false,
        message: '',
        loading: false,
        startLoading: function() {
          this.error = false;
          this.message = '';
          this.loading = true;
        },
        stopLoadingSuccess: function() {
          this.error = false;
          this.message = '';
          this.loading = false;
        },
        stopLoadingFailure: function(message) {
          this.error = true;
          this.message = message;
          this.loading = false;
        }
      }
    };

    this.userNow = function(noNeedUTC) {

      var localDate = moment().tz($rootScope.user.time_zone);
      var date = [
        localDate.year(),
        localDate.month(),
        localDate.date()
      ];

      return noNeedUTC ? moment(date).startOf('day') : moment.utc(date).startOf('day');
    };

    this.now = function(noNeedUTC) {
      var localDate = new Date();
      var date = [
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate()
      ];

      return noNeedUTC ? moment(date).startOf('day') : moment.utc(date).startOf('day');
    };

    this.getOpenFilterFunction = function (filters, saveFilterCb) {
      return function () {
        return $uibModal.open({
          templateUrl: 'app/settings/components/filters/modals/saveFilter/save-filter.html',
          size: 'middle-width',
          controller: function($scope, $uibModalInstance){
            $scope.filterName = '';
            $scope.filterObj = filters;

            $scope.save = function () {
              if ($scope.saveFilterForm.$valid) {
                saveFilterCb($scope.filterName);
              }
              $uibModalInstance.dismiss();
            };

            $scope.close = function() {
              $uibModalInstance.dismiss();
            };
          }
        })
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .service('cardHistory', cardHistory);

  /** @ngInject */
  function cardHistory($rootScope,$uibModalStack) {

    var history = [],
      preventOnPop = false,
      poppedStep;

    function pushStep (step) {
      if (!preventOnPop) {
        history.push(step);
      }
      preventOnPop = false;
    }

    function clearSteps () {
      history.length = 0;
      preventOnPop = false;
    }

    this.popStep =  function (attr, val) {
      preventOnPop = true;
      if (attr) {
        var index = _.findLastIndex(history, function (item) {
          return item.param[attr] !== val
        });
        history.length = index + 1;
      }
      poppedStep = history.pop();
      return poppedStep;
    };

    this.deleteLastStep = function () {
      preventOnPop = false;
      history.pop();
    };

    function restoreHistory() {
      if (poppedStep) {
        history.push(poppedStep);
      }
    }

    this.startTracking = function() {
      $rootScope.$on('$stateChangeStart', function (event, next, nextParam, prev, prevParam) {
        if (next.isThirdLevel) {
          pushStep({
            name: prev.name,
            param: prevParam
          });
        } else {
          clearSteps();
        }
      });
      $rootScope.$on('stateChangePrevented', function() {
        restoreHistory();
      })
    };

  }
})();

(function () {
  'use strict';

	angular.module('frontend').service('catalogService', catalogService);

  function catalogService($http, API_URL) {

    var catalogSrv = this;

    /* Запрос метаданынх упаковки */
    this.packingTypeMetadata = function(packing_type_id) {
      return $http.get(API_URL + "/catalog/meta/packing_type", {
        params: {
          packing_type_id: packing_type_id
        }
      });
    };

    /* Поиск элементов каталога участника (категорий, товаров, услуг) */
    this.searchCatalogElements = function(search, paging) {
      return $http.get(API_URL + "/catalog/domain/elements", {
        params: {
          search_string: search,
          offset: paging && paging.offset ? paging.offset : 0,
          limit: paging && paging.limit ? paging.limit : 10
        }
      });
    };

    /* Автокомлит по атрибутам */
    this.getAttr = function(search_str, kind, dataType, isDomainSource) {
      return $http.get(API_URL + "/catalog/domain/attributes/" + kind.toUpperCase() + "/auto", {
        params: {
          search_string: search_str,
          filter_data_type: dataType,
          filter_domain_catalog_source: isDomainSource
        }
      });
    };

    /* Список детальной информации по атрибуту из домена */
    this.getAttrDomain = function(id, kind) {
      return $http.get(API_URL + "/catalog/domain/attributes/" + kind.toUpperCase() + "/" + id);
    };

    /* Список детальной информации по атрибуту из единого каталога */
    this.getAttrInfo = function(id) {
      return $http.get(API_URL + "/catalog/attributes/" + id);
    };

    /* Поиск блоков атрибутов в каталоге участника по наименованию (ауто-комплит). */
    this.getAttrBlocks = function(search_str, kind) {
      return $http.get(API_URL + "/catalog/domain/attribute_blocks/" + kind.toUpperCase() + "/auto", {
        params: {
          search_string: search_str
        }
      });
    };

    /* Список детальной информации по блоку из домена */
    this.getBlockDomain = function(block_id, kind) {
      return $http.get(API_URL + "/catalog/domain/attribute_blocks/" + kind.toUpperCase() + "/" + block_id + "/aggregate");
    };

    /* Список детальной информации по блоку из единого каталога */
    this.getBlockInfo = function(block_id) {
      return $http.get(API_URL + "/catalog/attribute_blocks/" + block_id + "/aggregate");
    };

    // сортировка с приоритетом по длине строки
    this._orderByLength = function (v1, v2) {
      if (!v1.name || !v2.name) {
        return (v1.index < v2.index) ? -1 : 1;
      }
      return (v1.name.length < v2.name.length) ? -1 : 1;
    };

    /* Возвращает список единиц измерения (без пагинации) */
    this.getUoms = function(search_str) {
      return $http.get(API_URL + "/uoms/auto", {
        params: {
          search: search_str
        }
      }).then(function (data) {
        data.data = data.data.sort(catalogSrv._orderByLength);
        return data;
      });
    };

    /* Автокомлит по системам налогообложения */
    this.getTax = function(search_str, filter_doc_date, filter_company_id) {
      return $http.get(API_URL + "/tax_groups", {
        params: {
          filter_doc_date: filter_doc_date,
          filter_company_id: filter_company_id
        }
      });
    };

    /* Автокомлит по системам налогообложения */
    this.getTaxAuto = function(search_str) {
      return $http.get(API_URL + "/tax_groups/auto");
    };

    /* Запрос настроек */
    this.getSettings = function() {
      return $http.get(API_URL + "/catalog/domain/settings");
    };

    /* Получение настроек продажи алкогольной продукции*/
    this.getAlcoholSettings = function() {
      return $http.get(API_URL + "/catalog/domain/settings/alcohol");
    };

    /* Получение настроек продажи алкогольной продукции*/
    this.updateAlcoholSettings = function(alcohol_settings) {
      return $http.put(API_URL + "/catalog/domain/settings/alcohol", alcohol_settings);
    };

    /* Получить автокод */
    this.getCode = function() {
      return $http.post(API_URL + "/catalog/domain/items/code", {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.getPositions = function(attribute_id, category_id) {
      return $http.get(API_URL + '/catalog/domain/attributes/CATEGORY/' + attribute_id + '/derivative_owners', {
        params: {
          filter_category_id: category_id
        }
      });
    };

    /* Сервис по перемещению категорий, товаров и услуг */
    this.moveCatalogItems = function(obj) {
      return $http.put(API_URL + "/catalog/domain/elements/move", obj, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /* Автокомплит для товаров и услуг */
    this.catalogItemsAuto = function(search_string, only_stocks, derivative, limit, filter_is_alcohol) {
      return $http.get(API_URL + "/catalog/domain/items/auto", {
        params: {
          search_string: search_string,
          only_stocks: only_stocks,
          derivative: derivative,
          limit: limit || 100,
          filter_is_alcohol: filter_is_alcohol
        }
      });
    };

    /* Получение списка товаров услуг деривативов */
    this.getItemAuto = function(
      search, // строка поиска
      onlyStocks, // только товары
      derivative, // уточнение складской позиции
      length, // длина списка
      onlyCommittent,
      filterIsAlcohol // фильтр олько по алкогольным позициям
    ) {
      return $http.get(API_URL + "/catalog/domain/items/auto", {
        params: {
          search_string: search,
          only_stocks: onlyStocks,
          derivative: derivative,
          limit: length,
          filter_committent: onlyCommittent,
          filter_is_alcohol: filterIsAlcohol
        }
      });
    };

    /* Вспомогательный метод для поиска складских позиций */
    this.getItemSkuAuto = function(search, onlyStocks, length, onlyCommittent, filterIsAlcohol) {
      return catalogSrv.getItemAuto(search, onlyStocks, false, length, onlyCommittent, filterIsAlcohol);
    };

    /* Вспомогательный метод для поиска деривативов складских позиций */
    this.getItemDerivativeAuto = function(search, onlyStocks, length, onlyCommittent, filterIsAlcohol) {
      return catalogSrv.getItemAuto(search, onlyStocks, true, length, onlyCommittent, filterIsAlcohol);
    };

    // вспомогатеьный медов возвращающий подготовленный список дериватив
    this.getItemDerivativeForFldAuto = function (search, onlyStocks, length, onlyCommittent, filterIsAlcohol) {
      return catalogSrv.getItemDerivativeAuto(search, onlyStocks, length, onlyCommittent, filterIsAlcohol);
    };

    /* Расширеный поиск позиций каталога */
    this.searchCatalogItems = function (params, urlParams) {
      urlParams.$$ignoreInterceptor = true;
      return $http.post(API_URL + '/catalog/domain/items/expanded_search', params || {}, {params: urlParams});
    };

    /* Расширеный поиск деривативов */
    this.searchDerivatives = function (catalog_item_id, params, urlParams) {
      if (!urlParams) urlParams = {};
      urlParams.$$ignoreInterceptor = true;
      return $http.post(API_URL + '/catalog/domain/items/expanded_search/' + catalog_item_id + '/derivatives', params || {}, {params: urlParams});
    };


    this.getMarksSettings = function () {
      return $http.get(API_URL + '/catalog/domain/settings/marks');
    };

    this.updateMarksSettings = function (settings) {
      return $http.put(API_URL + '/catalog/domain/settings/marks', settings, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    this.getCatalogItemsStock = function (catalogItemId, date, sortBy) {
      return $http.get(API_URL + '/catalog/domain/items/' + catalogItemId + '/stock', {
        params: {
          filter_date: date,
          sort_by: sortBy
        }
      });
    };

    this.getCatalogItemPrices = function (catalogItemId) {
      return $http.get(API_URL + '/catalog/domain/items/' + catalogItemId + '/prices');
    };

    this.updateCatalogItemPrices = function (catalogItemId, prices) {
      return $http.patch(API_URL + '/catalog/domain/items/' + catalogItemId + '/prices', prices, {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

    /* Генерация штрихкода */
    this.getBarcode = function () {
      return $http.post(API_URL + '/catalog/domain/items/barcode', {
        params: {
          $$ignoreInterceptor: true
        }
      });
    };

  }

})();

angular.module('frontend').filter('attributeValue', function () {
  return function (attr) {
    switch (attr.attribute.data_type) {
      case 'BOOLEAN':
        return attr.value == "true" ? 'Да': ((attr.value == "false")?'Нет' : null);
      case 'DICTIONARY':
        return attr.dict_value.value;
      case 'DATE':
        return moment.utc(parseInt(attr.value)).format('DD.MM.YYYY');
      case 'DATE_TIME':
        return moment.utc(parseInt(attr.value)).format('DD.MM.YYYY HH:mm');
      case 'FLOAT':
        return new Intl.NumberFormat('ru-RU').format(parseFloat(attr.value));
      case 'INTEGER':
        return new Intl.NumberFormat('ru-RU').format(parseInt(attr.value));
      default:
        return attr.value;
    }
  };
});

(function () {
  'use strict';

  angular.module('frontend').controller('catalogController', catalogController);

  function catalogController($scope,
                             $uibModal,
                             requestStatus,
                             userSettingsService,
                             $rootScope,
                             catalogService,
                             categoryService,
                             statuses,
                             hasCategory,
                             $state,
                             $log,
                             $q,
                             attrSettingsService,
                             catalogItemService,
                             $timeout,
                             searchCatalogItemSrv,
                             errorMessageService) {
    var vm = this;
    // Вычисление наличия категорий делается при роутинге, чтобы исключить промаргивание интерфейса
    vm.hasCategory = hasCategory;
    // Флаг - переключатель между деревом и результатами поиска
    vm.showSearch = false;
    // Флаг показа лоадера каталога, показывается один раз, при загрузке страницы
    vm.showLoader = true;

    vm.searchResult = [];

    vm.showSearchCatalogItemPopup = searchCatalogItemSrv.showModal;
    // Вспомогательный метод, проверяет раскрыт ли хоть один узел
    vm.isExpand = function () {
      return _.find(vm.root.children, function (node) {
        return node.expand;
      })
    };

    // Схлапывает раcкрытые узлы первого уровня
    vm.collapseAll = function () {
      vm.root.collapseAll();
    };

    $scope.$watch('vm.searchText', function (newVal, oldVal) {
      if (oldVal && !newVal) { // Если не пустое значение меняется на пустое (в широком смысле)
        vm.showSearch = false; // Смена вида на каталог
      }
    });

    // Узлы дерева
    vm.root = {
      name: 'Каталог товаров и услуг',
      root: true,
      has_children: true,
      children: []
    };

    vm.searchPaging = {
      current: 0,
      limit: 10,
      offset: 0,
      total: undefined
    };

    // статусы товаров и услуг
    vm.filterStatus = userSettingsService.loadProperty("catalog", "grid", "filter") || statuses;
    vm.chooseFilter = function (event) {
      if (event) event.stopPropagation();
      vm.getFilters();
      vm.root.resetRoot();
      vm.root.expandFuncByModel(vm.treeExpandModel);
      userSettingsService.saveProperty("catalog", "grid", "filter", vm.filterStatus);
      categoryService.getDomainCategories()
        .then(function (data) {
          if (data && data.data) {
            vm.hasCategory = data.data.length > 0;
          }
        });
    };

    vm.getFilters = function () {
      vm.filters = [];
      angular.forEach(vm.filterStatus, function (status) {
        if (status.status) {
          vm.filters.push(status.id);
        }
      });
    };
    vm.getFilters();

    vm.treeColumns = [
      {
        name: 'Статус',
        flex: 1,
        templateUrl: 'statusItemTemplate.html'
      }
    ];

    // Загрузка модели раскрытых узлов
    vm.treeExpandModel = userSettingsService.loadProperty("catalog", "tree", "expandModel");
    vm.lastSelectedPath = userSettingsService.loadProperty("catalog", "tree", "lastSelectedPath");
    // Callback загрузки дерева
    vm.onTreeLoaded = function () {
      vm.root.expandFuncByModel(vm.treeExpandModel).then(function () {
        // раскрытие до выбранного в последний раз пользователем узла
        if (vm.lastSelectedPath && vm.lastSelectedPath.length) {
          vm.root.selectByPaths(vm.lastSelectedPath, true)
            .then(function (lastNode) {
              vm.showCreateButtons = !lastNode.type;
              vm.selectedNode = lastNode;
            });
        }
      })
    };

    /**
     * Колбек на раскрытие узла дерева
     *
     * @param node
     */
    vm.onExpandNode = function (node) {
      userSettingsService.saveProperty("catalog", "tree", "expandModel", vm.root.getExpandModel());
    };

    /**
     * Колбек на свертывание узла дерева
     *
     * @param node
     */
    vm.onCollapseNode = function (node) {
      userSettingsService.saveProperty("catalog", "tree", "expandModel", vm.root.getExpandModel());
    };


    /**
     * Редактирование категории
     *
     * @param node узел категории в дереве
     */
    vm.redactCategory = function (node) {
      $log.log('Редактирование категории: ' + node.id);
      $state.go('category.edit', {categoryId: node.id, parent: $state.params.parent});
    };

    /**
     * Редактирование товара
     *
     * @param node узел товара в дереве
     */
    vm.redactSku = function (node) {
      $log.log('Редактирование товара: ' + node.id);
      $state.go('catalogSkus.edit', {
        elementId: node.id,
        categoryId: node.getParent() ? node.getParent().id : undefined,
        parent: $state.params.parent
      });
    };

    /**
     * Редактирование услуги
     *
     * @param node узел услуги в дереве
     */
    vm.redactService = function (node) {
      $log.log('Редактирование сервиса: ' + node.id);
      $state.go('catalogServices.edit', {elementId: node.id, parent: $state.params.parent});
    };

    // Контролы дерева
    vm.treeControls = {
      'default': [{
        text: '',
        img: 'img-edit',
        imgSelected: 'img-edit-selected',
        callback: vm.redactCategory
      }],
      'SERVICE': [
        {
          text: '',
          img: 'img-edit',
          imgSelected: 'img-edit-selected',
          callback: vm.redactService
        }
      ],
      'SKU': [
        {
          text: '',
          img: 'img-edit',
          imgSelected: 'img-edit-selected',
          callback: vm.redactSku
        }
      ]
    };

    /* Callback для раскрытия дерева */
    vm.expand = function (node, nextPage) {
      // Загрузка дочерних категорий только при установленном флаге наличия и первичной загрузке (при загрузке следующей страницы категории не грузятся)
      var categoryPromise = (node.has_children && !nextPage) ? categoryService.getDomainCategories(node.id, vm.filters).then(function (data) {
        if (data.data) {
          vm.showLoader = false;
          return data.data;
        }
      }) : $q.when([]);

      var page = nextPage ? {
        // offset действует на загрузку товаров и услуг, но не категорий
        offset: _.filter(node.children, function(item) {return item.unstructure}).length
        // лимит по-умолчанию определяется в сервисе
      } : undefined;

      // Загрузка дочерних элементов только при их наличии
      var itemPromise = (node.item_count) ? categoryService.getDomainCategoryItems(node.id, vm.filters, page).then(function (data) {
        if (data.data) {
          vm.showLoader = false;
          node.total = data.data.total;
          return data.data.items;
        }
      }) : $q.when([]);
      // Композиция промисов, и конкатенация рузультатов (в итоге компонент дерева не в курсе нескольки запросов при callback и остается универсальным)
      return $q.all([categoryPromise, itemPromise]).then(function (values) {
        angular.forEach(values[1], function (item) {
          item.unstructure = true;
          item.has_children = false;
          item.item_count = 0;
        });
        vm.showLoader = false;
        return values[0].concat(values[1]);
      });
    };

    /* Метод поиска в дереве каталога участника */
    vm.search = function () {
      if (vm.searchText) {
        vm.showLoader = true;
        catalogService.searchCatalogElements(vm.searchText, vm.searchPaging).then(
          function (data) {
            vm.searchResult = data.data.items;
            vm.showSearch = true;
            vm.showLoader = false;
            vm.searchPaging.total = data.data.total;
            vm.searchResultTotal = data.data.total;
          },
          function (error) {
            $log.log('Ошибка при поиске: ' + error);
          }
        )
      }
    };

    /* метод раскрывает узлы деева по пути */
    vm.expandTreePath = function (path) {
      vm.root.expandFunc(path).then(function (res) {
        /*
          такое условие необходимо для корректной работы следующей функции 208 vm.selectNode
          у категории нет типа , по этому форма поиска будет сбрасываться , а у товаров и услуг есть тип, форма поиска будет оставаться,
          а элементы дерева открываться в новой вкладке
         */
        vm.showSearch = !!res.type;
      }, function () {
        vm.showSearch = false;
      });
    };

    /**
     * Метод сохраняет в пользовательском хранилище последний выбранный узел
     *
     * @param node
     * @private
     */
    vm._saveLastSelectedNode = function (node) {
      if (node && node._path && node._path.length) {
        userSettingsService.saveProperty("catalog", "tree", "lastSelectedPath", node._path);
      }
    };

    /**
     * Пример callback для вызова при выборе узла в дереве
     *
     * @param node выбранный узел
     */
    vm.selectNode = function (node) {
      if (node) {
        vm.showCreateButtons = !node.type;
        vm.selectedNode = node;
        if (!vm.showSearch) {
          // сохранение последнего выбранного узла
          vm._saveLastSelectedNode(node);
          if (node.type === "SERVICE") $state.go('catalogServices.view', {
            elementId: node.id,
            parent: $state.params.parent
          });
          if (node.type === "SKU") $state.go('catalogSkus.view', {elementId: node.id, parent: $state.params.parent});
        }
      } else {
        vm.showCreateButtons = false;
        vm.selectedNode = {};
      }
    };

    /* открыть дерево до необходимой категории, если её id есть в параметрах */
    vm.openTreeWithParams = function () {
      if ($state.params.categoryId) {
        categoryService.categoryHierarchy($state.params.categoryId).then(function (data) {
          if (data.data && data.data.levels) {
            vm.pathCatagory = _.map(data.data.levels, function (item) {
              return item.id;
            });
            vm.expandTreePath(vm.pathCatagory);
          }
        })
      }
    };

    attrSettingsService.getSettings().then(function (res) {
      vm.useCategoryAttributes = res.data.use_category_attributes;
    });

    vm.moveCatalogItems = function () {

      catalogItemService.openMoveCategoryDialog()
        .result.then(function (selectedNode) {
        var ids = _.map(vm.root.getSelectionModel(), function (item) {
          return item.id;
        });
        var obj = {
          new_parent: (selectedNode)? selectedNode.id : null,
          childrens: ids
        };
        catalogService.moveCatalogItems(obj).then(function (res) {
            vm.root.resetRoot();
            vm.root.expandFuncByModel(vm.treeExpandModel);
            $timeout(function () { // для показа статуса после reload
              if (obj.new_parent) {
                requestStatus.success("Выбранные позиции перемещены в категорию " + selectedNode.name,
                  'move', "Перейти в категорию", "#/catalog/" + selectedNode.id);
              } else {
                requestStatus.success("Выбранные позиции перемещены в корневую категорию", 'move');
              }
            }, 1000);
          },
          function (error) {
            if (error.data.code == "bad_arguments" && error.data.fields[0].error == "Children can not contains parent" && error.data.fields[0].field == "new_parent") {
              errorMessageService.showModal({message: 'При перемещении произошла ошибка', submessage: {
                data: {message: "Операция не выполнена. Родительская группа не может быть перемещена в дочернюю."}
              }});
            } else {
              requestStatus.error('Во время перемещения произошла ошибка. Повторите попытку позже');
            }
          });
      });
    };

    vm.exportPopup = function () {
      $uibModal.open({
        component: 'catalogExport',
        size: 'middle-width',
        resolve: {
          catalogItems: function () {
            return vm.root.getSelectionModel();
          }
        }
      });
    }

    vm.status = function () {
      $uibModal.open({
        templateUrl: 'app/catalog/modals/info-popup.html',
        size: 'middle-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.class = "success-draft";
          $scope.title = "Статус операции";
          $scope.mainTxt = "Товары перемещены успешно, но из-за различия в обязательных атрибутах в каталогах перемещаемые позиции получили статус «Черновик»";
          $scope.descrTxt = "Необходимо дополнительно заполнить все обязательные атрибуты в каждой перемещенной позиции";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };

        }
      });
    };

    vm.addToPrice = function (priceListType) {
      var modal = $uibModal.open({
        templateUrl: 'app/catalog/modals/add-to-price.html',
        size: 'small-width',
        resolve: {
          type: function () {
            return priceListType;
          },
          selectionModel: function () {
            return vm.root.getSelectionModel();
          }
        },
        controller: 'addToPriceListController',
        controllerAs: 'addToPriceListCtrl',
        bindToController: true
      });
    }

  }

})();

'use strict';

angular.module('frontend').service('cartService', function ($http, API_URL) {

  /**
   * Метод получения количества товаров в корзине
   *
   * @return {HttpPromise}
   */
  this.getCartCount = function () {
    return $http.get(API_URL + '/user_carts/status');
  };

  /**
   * Метод получения информации о данных в корзине
   *
   * @param filter_check_derivative фильтрация по деривативам
   * @return {HttpPromise}
   */
  this.getCartData = function (data) {
    return $http.get(API_URL + '/user_carts', {
      data: {},
      params: {
        offset: data.offset,
        limit: data.limit,
        sort_by: data.sort_by,
        sort_order: data.sort_order,
        filter_check_derivative: data.filter_check_derivative,
        filter_tax_group_selector: data.filter_tax_group_selector
      }, 
      headers: {'Content-Type': 'application/json'}
    });
  };

  /**
   * Обновляет элемент корзины пользователя
   * 
   * @param data данные по запросу
   * @return {HttpPromise}
   */
  this.updateCartData = function (user_cart_items_id , data) {
    return $http.put(API_URL + '/user_carts/items/' + user_cart_items_id, data, {
      params: {
        $$ignoreInterceptor: true
      }
    });
  };

  /**
   * Удаляет элемент
   * @param data данные по запросу
   * @return {HttpPromise}
   */
  this.deleteCartline = function (data) {
    return $http.delete(API_URL + '/user_carts/items', {
      data: data,
      params: {}, 
      headers: {'Content-Type': 'application/json'}
    });
  };

  /**
   * Удаляет всю козину
   * @return {HttpPromise}
   */
  this.deleteAllCartData = function () {
    return $http.delete(API_URL + '/user_carts');
  };

  /**
   * Добавляет элемент в корзину пользователя
   * 
   * @param item данные по запросу
   * @return {HttpPromise}
   */
  this.addToCart = function (item) {
    return $http.post(API_URL + '/user_carts/items', item, {
      params: {
        $$ignoreInterceptor: true
      }
    });
  };

});

(function () {
  'use strict';

  angular.module('frontend').controller('cartController', cartController);

  /** @ngInject */
  function cartController($scope, $state,
                          $rootScope,
                          $stateParams,
                          cartData,
                          cartService,
                          errorMessageService,
                          crudsService,
                          $uibModal,
                          requestStatus,
                          cardHistory) {
    var cartCtrl = this;
    cartCtrl.gridOptions = {};
    // состояние редактирования
    cartCtrl.redact = true;

    cartCtrl.crudsService = crudsService;
    // данные по корзине
    cartCtrl.values = cartData.items || [];
    cartCtrl.totalsData = cartData.totals || {};
    cartCtrl.paging = {
      current: 0,
      limit: 10,
      offset: 0,
      total: cartData.total
    };

    cartCtrl.returnToPage = function(){
      var prev = cardHistory.popStep();
      if (prev) {
        $state.go(prev.name || 'business', prev.param);
      } else {
        $state.go('business');
      }
    };

    cartCtrl.getCartItems = function () {
      cartService.getCartData(cartCtrl.paging).then(function (data) {
        $rootScope.cartCount = data.data.total;
        cartCtrl.values = data.data.items;
        cartCtrl.paging.total = data.data.total;
        cartCtrl.totalsData = data.data.totals;
      }, function () {
        cartCtrl.values = [];
        $rootScope.cartCount = 0;
        requestStatus.error('Во время получения информации о корзине произошла ошибка. Повторите попытку позже');
      });
    }

    cartCtrl.removeLine = function (value) {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Удаление из корзины";
          $scope.text = "Вы действительно хотите удалить <strong>" + value.catalog_item.name + "</strong> из корзины?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            cartService.deleteCartline({items: [value.id]}).then(function () {
              cartCtrl.getCartItems();
              $uibModalInstance.dismiss();
            }, function (error) {
              requestStatus.error('Во время удаления произошла ошибка, повторите действие позже.');
            });
          };
        }
      });
    };

    cartCtrl.openDeleteDialog = function () {
      $uibModal.open({
        templateUrl: 'app/settings/templates/modals/one-question.html',
        size: 'small-width',
        controller: function ($scope, $uibModalInstance) {
          $scope.title = "Очистить корзину";
          $scope.text = "Вы действительно хотите удалить все товары и услуги из корзины?";
          $scope.close = function () {
            $uibModalInstance.dismiss();
          };
          $scope.action = function () {
            cartService.deleteAllCartData().then(function () {
              cartCtrl.getCartItems();
              $uibModalInstance.dismiss();
            }, function (error) {
              requestStatus.error('Во время удаления произошла ошибка, повторите действие позже.');
            });
          };
        }
      });
    };

    cartCtrl.updateLine = function (value) {
      value.natural_price = value.natural_price || 0;
      cartService.updateCartData(value.id, value).then(function () {
        cartCtrl.getCartItems();
      }, function (error) {
        requestStatus.error('Во время обновления данных произошла ошибка, повторите действие позже.');
      });
    };

    cartCtrl.columns = [{
        name: "Наименование",
        field: "catalog_item",
        flex: 1.1,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartCatalogItemTemplate.html",
        totalTemplateUrl: "cartPriceTotalStrTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Количество",
        field: "quantity",
        flex: 0.3,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartQuantityTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Ед. изм.",
        field: "uom",
        flex: 0.3,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartNameTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Цена",
        field: "natural_price",
        flex: 0.4,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartPriceTemplate.html",
        totalTemplateUrl: "cartPriceTotalTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "Налог",
        field: "tax_group",
        flex: 0.3,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "cartNameTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      },{
        name: "",
        field: "",
        flex: 0.1,
        headerTemplateUrl: "cartHeaderCellTemplate.html",
        templateUrl: "removeLineTemplate.html",
        templateScope: $scope,
        visible: true,
        column_visible: true
      }];


  }
})();

'use strict';

angular.module('frontend').service('doOrToDeadEnd', function ($state, auth, $q, $rootScope) {
  var self = this;
  $rootScope.progressbar.complete();

  this.goToDeadEnd = function(from, reason) {
    $state.go('deadend', {from: from , reason: reason})
  };

  function checkToken(token) {
    return $q(function (resolve, reject) {

      function check() {
        auth.checkToken(token)
          .then(function (res) {
            resolve(res.data.token_state.toLowerCase());
          })
          .catch(reject)
      }

      auth.ensureSession().then(function () {
        check();
      });
    })
  }

  this.doOrToDeadEnd = function ( token , state ) {
    return $q(function (resolve, reject) {
      checkToken(token)
        .then(function (reason) {
          if (reason !== 'ok') {
            self.goToDeadEnd(state, reason)
          } else {
            resolve()
          }
        })
        .catch(function (err) {
          if (err.status >= 500) {
            self.goToDeadEnd('other', 'server_error')
          } else if (err.status === 404){
            self.goToDeadEnd(state, 'not_found')
          }
          reject(err)
        })
    })
  }

});

'use strict';

angular.module('frontend').service('errorMessageService', function (modalMessageSrv, $rootScope) {

  this.showModal = function(settings) {
    if ($rootScope.hasAppError || (settings.submessage && settings.submessage.stopHandleError)) {
      return;
    }
    return modalMessageSrv.showModal(settings);
  }

});

(function () {
  'use strict';


  angular.module('frontend').service('phoneConfirmationService', phoneConfirmationService);

  function phoneConfirmationService($http, API_URL) {

    /* Запрос на создание кода подтверждения */
    this.sendPhoneConfirmationCreate = function (phone) {
      return $http.get(API_URL + '/registrations/phone/confirm', {
        params: {
          phone: phone
        }
      });
    };

    /* Запрос на создание анонимного кода подтверждения */
    this.sendPhoneConfirmationAnonymousCreate = function (phone) {
      return $http.get(API_URL + '/confirmation/phone', {
        params: {
          phone: phone
        }
      });
    };

    /* Запрос подтверждения номера телефона по коду */
    this.sendPhoneConfirmationCode = function (code) {
      return $http.get(API_URL + '/registrations/phone/confirm/check', {
        params: {
          code: code
        }
      });
    }

    /* Запрос подтверждения номера телефона по коду */
    this.sendPhoneConfirmationAnonymousCode = function (id, code) {
      return $http.get(API_URL + '/confirmation/phone/' + id + '/check', {
        params: {
          code: code
        }
      });
    }
  }
})();

'use strict';

angular.module('frontend').factory('authToken', function($window) {
  var storage = $window.localStorage; //TODO: перевести на $localstorage
  return {
    setToken: function(token) {
      storage.setItem('userToken', token);
    },
    getToken: function() {
      return storage.getItem('userToken');
    },
    isAuthenticated: function() {
      return !!this.getToken();
    },
    isLoggedIn: function() {
      return storage.getItem('loginFlag');
    },
    logIn: function() {
      storage.setItem('loginFlag', true);
    },
    logOut: function() {
      storage.removeItem('loginFlag');
      this.removeToken();
    },
    removeToken: function() {
      storage.removeItem('userToken');
    },
    setPermissions: function(permissions, userId) {
      var permission = {
        userId: userId,
        permissions: permissions
      };
      storage.setItem('userPermissions', angular.toJson(permission))
    },
    getPermissions: function(userID) {
      if (!!storage.getItem('userPermissions') && userID !== angular.fromJson(storage.getItem('userPermissions')).userId) {
        return;
      }
      return angular.fromJson(storage.getItem('userPermissions')).permissions;
    },
    isPermissionsSet: function(userID) {
      return !!storage.getItem('userPermissions') && userID === angular.fromJson(storage.getItem('userPermissions')).userId
    },
    removePermissions: function() {
      storage.removeItem('userPermissions');
    }
  }
});

var rejectMethods = ['POST', 'PUT', 'DELETE', 'PATCH'];
angular.module('frontend').factory('authInterceptor', function($q, authToken, $injector, API_URL) {

  var canceller = $q.defer();
  var exceptionUrl = [API_URL + '/login',
    API_URL + '/users/me/password',
    API_URL + '/users/fast_cashier',
    API_URL + '/utils/unique_check',
    API_URL + '/utils/timezones',
    API_URL + '/users/need_change_password'];

  function checkUrl(rejection) {
    return exceptionUrl.indexOf(rejection.config.url) < 0;
  }
  var loginModalOpened = false;
  function openLogin(rejection) {
    if (~rejectMethods.indexOf(rejection.config.method) || (rejection.config.method === 'GET' && ~rejection.config.url.indexOf(API_URL + '/address/suggest/granular'))) {
      if (!loginModalOpened) {
        loginModalOpened = true;
        $injector.get('auth').showAuthModal().result.finally(function() {
          loginModalOpened = false
        });
      }
    } else if (rejection.config.method === 'GET') {
      if (!loginModalOpened) {
        $injector.get('$uibModalStack').dismissAll('stateChange');
        $injector.get('$state').go('login', {moveBack: true})
      }
    }
  }

  function checkForbiddenMessage(err) {
    if (err.status === 403) {

      if ( err.data && (err.data.code === 'session_not_set' || err.data.code === 'not_authenticated') ) {
        if (authToken.isAuthenticated()) {
          authToken.logOut();
        }
        openLogin(err)
      }

    } else {
      openLogin(err);
    }
  }

  return {
    request: function(config) {
      var token = authToken.getToken();
      if (token && config.url.indexOf(API_URL) !== -1) {
        config.headers['X-Session-Id'] = token;
      }
      config.timeout = canceller.promise;
      if (loginModalOpened && // если окно логина открыто
        (!config.url.includes('sessions') && // если не запросы связанные с сессией
          !config.url.includes('login')) && // если не логин
          !config.url.includes('documents/types') && // Получение типов документов
        !config.url.startsWith('app') // если не лезилоадинг
      ) {
        canceller.resolve() // превент запроса
      } else {
        canceller = $q.defer(); // обновление переменной
        config.timeout = canceller.promise; // обновление переменной
      }
      return config;
    },
    responseError: function(rejection) {
      var defer = $q.defer();
      var userCameFromOuterSpace = $injector.get('$state').current.url === '^';
      var errorOnResolve = $injector.get('$rootScope').stateChangeStart;

      // обработка 403 ошибки
      if (checkUrl(rejection) && (rejection.status === 403 || rejection.status === 401)) {
        rejection.stopHandleError = true;
        if (!$injector.get('$state').current.isMobile) {
          checkForbiddenMessage(rejection);
        }
      }
      if (rejection.status <= 0) {
        if (!loginModalOpened && !rejection.config.url.match(/sessions/) >= 0 && !$injector.get('$rootScope').preventInterceptorStatuses && !$injector.get('$rootScope').hasAppError) {
          $injector.get('$rootScope').reloadAfterConnectionUp = rejection.config.method == 'GET';
          $injector.get('$rootScope').hasAppError = true;
          $injector.get('$rootScope').checkConnection();
        }
      } else {
        if (errorOnResolve || userCameFromOuterSpace) {
          $injector.get('$rootScope').currentError = rejection;
        } else {
          switch (rejection.status) {
            case 500:
              if (!$injector.get('$rootScope').preventInterceptorStatuses && !$injector.get('$rootScope').mobilePage) {
                rejection.stopHandleError = true;
                $injector.get('requestStatus').error('Произошла ошибка. Мы уже в курсе, и работаем над ее устранением. Попробуйте повторить действие спустя некоторое время.');
              }
              break;
            case 403:
              if (rejection.data && rejection.data.code === 'need_role' && !$injector.get('$rootScope').mobilePage) {
                rejection.stopHandleError = true;
                $injector.get('requestStatus').error('Недостаточно прав');
              }
              break;
            case 402:
              rejection.stopHandleError = true;
              $injector.get('$uibModal').open({
                templateUrl: 'app/settings/templates/modals/info.html',
                size: 'small-width',
                controller: function ($scope, $uibModalInstance) {
                  $scope.title = 'Нет активной подписки';
                  $scope.text = 'Операция отклонена. Для того, чтобы воспользоваться данным функционалом, необходимо оплатить соответствующую услугу.';
                  if ($injector.get('$rootScope').hasRole('paid_service.read')) {
                    $scope.text += ' <a href="/#/paid-services" target="_blank">Список доступных услуг Торговля.Онлайн.</a>';
                  }
                  $scope.close = function () {
                    $uibModalInstance.dismiss();
                  };
                }
              });
              break;
            case 503://обработка деплоя бэка на проде
              $injector.get('$state').go('deadend', {from: 'other', reason: 'deploy'});
              break;
            default :
              break;
          }
        }
      }

      defer.reject(rejection);


      return defer.promise;
    }
  };
}).factory('spinnerInterceptor', function($q, authToken, $injector, $timeout, ngProgressFactory) {
  var requestMap = new Map(); // Маp для хранения промисов возвращаемых $timeout

  return {
    request: function(config) {
      /*
        Каждый модифицирующий запрос с таймаутом в 200ms включает спинер,
        Промис таймаута кладется в мап
       */
      if (~rejectMethods.indexOf(config.method) && !$injector.get('$rootScope').mobilePage && (!config.params || (config.params && !config.params.$$ignoreInterceptor ))) {
        if (!$injector.get('$rootScope').progressbar.count) {
          $injector.get('$rootScope').showSpinner = true;
          $injector.get('$rootScope').progressbar.start();
          $injector.get('$rootScope').progressbar.set(50);
          $injector.get('$rootScope').progressbar.getDomElement().css('width', '100%');
        } else {
          $injector.get('$rootScope').progressbar.set($injector.get('$rootScope').progressbar.count += 30);
        }
        
      }
      if (config.params) { // удаление параметра для внутреннего пользования
        delete config.params.$$ignoreInterceptor;
      }
      return config;
    },
    response: function (response) {
      /*
       Если запрос есть в мапе то резлвим его промис (отменяем таймаут) и удаляем его
       */
      if (~rejectMethods.indexOf(response.config.method)) {
        var key = response.config;
        if (requestMap.has(key)) {
          var requestPromise = requestMap.get(key);
          $timeout.cancel(requestPromise);
          requestMap.delete(key)
        }
        if (requestMap.size === 0) { // скрываем спиннер если в мапе нет промисов
          $injector.get('$rootScope').completeProgressBar();
        }
      }
      return response
    },
    responseError: function(rejection) {
      var defer = $q.defer();
      /*
         при ошибке очиишаем мап с промисами и отменяем их таймаут, скрываем спиннер,
         что бы он не мешал обработке ошибок через попапы и тд.
       */
      if (~rejectMethods.indexOf(rejection.config.method)) {
        requestMap.forEach(function(item) {
          $timeout.cancel(item);
        });
        requestMap.clear();
        $injector.get('$rootScope').completeProgressBar();
      }

      defer.reject(rejection);
      return defer.promise;
    }
  };
});

'use strict';

angular.module('frontend').service('auth', function auth($http,
                                                         $window,
                                                         $log,
                                                         API_URL,
                                                         $q,
                                                         authToken,
                                                         $uibModal,
                                                         $rootScope,
                                                         $state,
                                                         currenciesService,
                                                         requestStatus,
                                                         accountingService) {
  var userDataPromise = null,
    sessionPromise = null,
    permissionPromise = null,
    self = this;
  var typesPromise = null;

  function logoutResponseCheck() {
    authToken.logOut();
    authToken.removePermissions();
  }

  function authResponseValidSession(res) {
    if (res.id) {
      authToken.setToken(res.id);
      if (res.user) {
        $rootScope.user = res.user;
        $rootScope.partner = res.domain.partner;
        userDataPromise = sessionPromise;
        self.ensureTypes();
        self.ensurePermissions();
        self.getAccSettings();
      }
    } else {
      $log.warn('При инициализации сессии не был получен идентификатор (токен)');
      return false;
    }
  }

  function loadTypes() {
    return $http.get(API_URL + '/documents/types').success(function (res) {
      $rootScope.documentTypes = _.sortBy(res, 'name');
      currenciesService.getDomainCurrencies(true);
    });
  }

  this.ensureTypes = function (force) {
    if (typesPromise && !force) {
      return typesPromise;
    }
    typesPromise = $q(function (resolve, reject) {
      loadTypes().then(resolve).catch(reject);
    });
    return typesPromise;
  };

  function authResponseValidUser() {
    authToken.logIn();
    return self.ensureUserData(true);
  }

  this.getMobileRegisterSteps = function () {
    return $http.get('assets/api/mobileRegisterSteps.json');
  };

  function getPermissionsSuccess(res) {
    res.divisionAccessMap = []; // упращенная схема доступов к подразделениям
    res.hasNoDivisionsAccess = true; // флаг для проверки доступа ни к одному подразделению
    if (res.data_access_rules.has_access) {
      res.hasNoDivisionsAccess = false;
    }
    angular.forEach(res.data_access_rules.company_access_rules, function (company) {
      if (company.has_access) {
        res.hasNoDivisionsAccess = false;
      }
      angular.forEach(company.division_access_rules, function (division) {
        if (division.has_access) {
          res.hasNoDivisionsAccess = false;
        }
        res.divisionAccessMap[division.division_id] = division.has_access;
      });
    });
    $rootScope.permission = res;
    authToken.setPermissions(res, self.getUserId());
    self.ensureUserData(authToken.isPermissionsSet());
  }

  this.initPermissions = function () {
    return $http.get(API_URL + '/sessions/v2/me/permissions').success(getPermissionsSuccess);
  };

  this.ensurePermissions = function (force, update) {
    if (permissionPromise && !force) {
      return permissionPromise;
    }
    permissionPromise = $q(function (resolve, reject) {
      self.getPermissions(update).then(resolve).catch(reject);
    });
    return permissionPromise;
  };

  this.getPermissions = function (update) {
    return $q(function (resolveMain, rejectMain) {
      if (!update && authToken.isPermissionsSet(self.getUserId())) {

        console.log('permissions has taken from LS');
        $rootScope.permission = authToken.getPermissions(self.getUserId());
        resolveMain(authToken.getPermissions(self.getUserId()))

      } else {

        console.log('permissions updating');
        resolveMain(self.initPermissions())
      }
    })
  };

  this.saveAccSettings = function (data) {
    $rootScope.accountingSettings = angular.copy(data);
  }

  /** Возвращает настройки проведения домена */
  this.getAccSettings = function () {
    return accountingService.getAccountingSettings().success(self.saveAccSettings);
  };

  function getUserDataSuccess(res) {
    if (res.domain && typeof res.domain.partner == 'boolean') {
      $rootScope.partner = res.domain.partner;
    }
    if (res && res.user) {
      $rootScope.user = res.user;
      $rootScope.partner = res.domain.partner;
      self.ensureTypes(true);
      self.ensurePermissions();
      self.getAccSettings();
    }
  }

  this.getUserData = function () {
    return $http.get(API_URL + '/sessions/me', {}).success(getUserDataSuccess);
  };

  this.initSession = function () {
    return $http.post(API_URL + '/sessions', {}).success(authResponseValidSession);
  };

  this.health = function () {
    return $http.get(API_URL + '/health', {});
  };

  this.syncDate = function () {
    return $http.get(API_URL + '/health/sync_date', {});
  };

  this.ensureSession = function (force) {
    if (sessionPromise && !force) {
      return sessionPromise;
    }
    sessionPromise = $q(function (resolve, reject) {
      self.initSession()
        .then(resolve).catch(reject);
    });
    return sessionPromise;
  };

  this.ensureUserData = function (force) {
    if (userDataPromise && !force) {
      return userDataPromise;
    }
    userDataPromise = $q(function (resolve, reject) {
      self.getUserData()
        .then(resolve).catch(reject);
    });

    return userDataPromise;
  };

  this.isAuthenticated = function () {
    return authToken.isAuthenticated();
  };

  this.isLoggedIn = function () {
    return authToken.isLoggedIn();
  };

  this.getUserId = function () {
    return $rootScope.user ? $rootScope.user.id : ''
  };

  this.login = function (loginModel) {
    return $q(function (resolve, reject) {
      self.ensureSession(true).then(function () {
        resolve($http.post(API_URL + '/login', loginModel).success(authResponseValidUser));
      }).catch(reject)
    });

  };

  this.register = function (registerModel) {
    return $http.post(API_URL + '/registrations/domains', registerModel);
  };

  this.resetPass = function (resetPassModel) {
    return $http.post(API_URL + '/registrations/recovery', resetPassModel);
  };

  this.recoverPassword = function (guid, newPassword) {
    return $http.post(API_URL + '/registrations/recovery/' + guid + '/confirm', {password: newPassword})
  };

  this.generateTempPassword = function (phone, domain) {
    return $http.post(API_URL + '/registrations/temp_password?phone=' + phone + (domain ? '&domain=' + domain : ''), {})
  };

  this.setPass = function (setPassModel) {
    return $http.put(API_URL + '/users/me/password', setPassModel);
  };

  this.logout = function () {
    userDataPromise = null;
    sessionPromise = null;
    $rootScope.permission = null;
    $rootScope.user = null;
    $rootScope.partner = null;
    permissionPromise = null;
    return $http.post(API_URL + '/logout', {});
  };

  this.getTimezones = function () {
    return $http.get(API_URL + '/utils/timezones', {});
  };

  this.checkDomain = function (domain) {
    return $http.get(API_URL + '/noauth/domains/by_name/' + domain, {});
  };

  this.changePassword = function (data) {
    return $http.put(API_URL + '/users/me/password', data);
  };

  this.confirmEmailReq = function (guid) {
    return $http.post(API_URL + '/registrations/' + guid + '/confirmation', {});
  };

  this.confirmNewEmailReq = function (guid) {
    return $http.post(API_URL + '/users/me/email_change/' + guid, {});
  };

  this.checkToken = function (token) {
    return $http.get(API_URL + '/tokens/' + token)
  };

  this.checkPartnerCode = function (code) {
    return $http.get(API_URL + '/noauth/partnership/partner_codes/' + code)
  };

  this.checkPromoCode = function (code) {
    return $http.get(API_URL + '/noauth/promo_codes/' + code)
  };

  this.checkMobileBrowser = function (a) {
    if (a.match(/Android/i))
      return true;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
      return true;
    return false;
  };

  this.showLogoutConfirm = function () {
    return $uibModal.open({
      templateUrl: 'app/auth/logoutPopup.html',
      size: 'small-width',
      controller: function ($scope, $uibModalInstance, $state) {
        $scope.close = function () {
          $uibModalInstance.dismiss();
        };
        $scope.logout = function () {
          self.logout().then(function () {
            $rootScope.$broadcast('logout');
            $state.go('login').then(function () {
              $uibModalInstance.close();
            });
          });
        }
      }
    })
  };

  this.showAuthModal = function () {
    $rootScope.blurMainContent = true;
    return $uibModal.open({
      templateUrl: 'app/auth/authPopup.html',
      backdrop: 'static',
      keyboard: false,
      size: 'login',
      appendTo: angular.element('body'),
      controller: function ($scope, $uibModalInstance, $rootScope, auth, $log, $location) {
        $scope.openPopup = 'login';
        $scope.animatePopup = function () {
          if ($scope.openPopup === 'login') {
            $scope.openPopup = 'resetpass';
          } else if ($scope.openPopup === 'resetpass') {
            $scope.openPopup = 'login';
          } else {
            $scope.openPopup = '';
          }
        };

        $scope.close = function () {
          $uibModalInstance.dismiss();
        };

        $rootScope.$on('$locationChangeStart', function (event, current, previous) {
          $uibModalInstance.dismiss();
        });

        /*** Login Controller ***/
        $scope.issetDomain = $location.search().domain;
        $scope.userLoginData = {};
        $scope.userLoginData.login = $location.search().login;
        $scope.userLoginData.animateId = false;
        $scope.param = angular.element.param($location.search());

        $scope.loginSubmit = function () {
          if (!$scope.userLoginData.isWrongLoginData) {
            auth.ensureSession().then(function (res) {
              login();
            });
          }
        };

        function login() {
          auth.login({
            login: $scope.userLoginData.login,
            domain: $scope.userLoginData.domain,
            password: $scope.userLoginData.password
          }).then(
            function (res) {
              $scope.userLoginData.isWrongLoginData = false;
              $rootScope.blurMainContent = false;
              auth.ensurePermissions(true, true).then(function () {
                $uibModalInstance.close(true);
              });
              //$state.go('home');
            }
          ).catch(
            function (err) {
              $scope.userLoginData.isWrongLoginData = true;
            }
          );
        }

        /*** Reset password Controller ***/
        $scope.userResetData = {};
        $scope.success = false;
        $scope.bannedLogin = false;
        $scope.badLogin = false;
        $scope.userResetData.animateId = false;

        function checkoStatusCode(err) {
          var statusCode = err.status;
          switch (statusCode) {
            case 404:
              $log.log('Пользователь в группе или группа не найдены');
              $scope.badLogin = true;
              break;
            case 401:
              $log.log('Пользователь заблокирован');
              $scope.bannedLogin = true;
              break;
            case 400:
              $log.log('Неправильно сформированный запрос');
              break;
            case 204:
              $scope.success = true;
              $scope.bannedLogin = false;
              $scope.badLogin = false;
              break;
            case 200:
              $scope.success = true;
              $scope.bannedLogin = false;
              $scope.badLogin = false;
              break;
            default:
          }
        }

        function resetpass() {
          var resetPassData = {domain: $scope.userResetData.domain},
            reg = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3})|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'g'),
            arr = $scope.userResetData.data.match(reg);
          if (arr) {
            resetPassData.email = $scope.userResetData.data;
          } else {
            resetPassData.login = $scope.userResetData.data;
          }
          auth.resetPass(resetPassData).then(function (res) {
            angular.element(".modal-login").addClass("reset-confirm-popup");
            if (res.data.email) $scope.email = res.data.email;
            checkoStatusCode(res);

          }).catch(function (err) {
            $log.log(err);
            checkoStatusCode(err);
          });
        }

        $scope.resetSubmit = function () {
          auth.ensureSession().then(function (res) {
            resetpass();
          });
        }
      }
    });
  };

  this.confirmEmail = function (state, guid) {
    self.ensureSession().then(function (res) {
      if (res.data.domain && typeof res.data.domain.partner == 'boolean') {
        $rootScope.partner = res.data.domain.partner;
      }
      if (res.data.user) {
        $rootScope.user = res.data.user;
        $rootScope.partner = res.domain.partner;
      }
      confirm();
    });

    function confirm() {
      if (state === 'confirmemail') {
        confirmEmailAuth(guid)
      } else {
        confirmNewEmailAuth(guid)
      }
    }

    function confirmNewEmailAuth(code) {
      self.confirmNewEmailReq(code)
        .then(function (res) {
          authToken.logIn();
          self.ensurePermissions(true, true).then(function () {
            self.ensureUserData(true).then(function () {
              $state.go($rootScope.hasRole('report.sale_totals') ?
                'indicators' :
                'business')
            });
          })
        }, function (err) {
          if (err.status == 409 && err.data.code == 'non_unique' && err.data.parameters[0].name == 'email') {
            requestStatus.error('Почтовый адрес ' + err.data.parameters[0].value + ' не может быть подтвержден, так как он уже используется другим пользователем группы.');
          }
        })
    }

    function confirmEmailAuth(code) {
      var logoutPromise = authToken.isLoggedIn() ?
        self.logout().then(function () {
          return self.initSession();
        }) : $q.when();

      return logoutPromise.then(function () {
        self.confirmEmailReq(code)
          .then(function () {
            authToken.logIn();
            self.ensurePermissions(true, true).then(function () {
              self.ensureUserData(true).then(function () {
                // условие на иобильный бразер (завершение регистрации на специльной странице)
                if (self.checkMobileBrowser(navigator.userAgent || navigator.vendor || window.opera)) {
                  $window.location.href = 'https://trade365.online/mobilereg/confirmation?domain=' +
                    $rootScope.user.domain
                    + '&login=' + $rootScope.user.email;
                } else {
                  $state.go($rootScope.hasRole('report.sale_totals') ?
                    'indicators' :
                    'business')
                }
              });
            })
          })
      });
    }

  }
});

'use strict';

angular.module('frontend').service('documentService', function auth($http, API_URL) {
  var getDocumentsGridSettingsPromise = null;

  /**
   * Сохранение или обновление документа
   *
   * @param type тип документа
   * @param purpose цель (подтип)
   * @param commonData общие данные документа (единая для всех документов структура)
   * @param data вариантивные данные в зависимости от типа
   * @param donorId идентификатор окумента-донора, если есть
   *
   * @return {*} промис
   */
  this.saveOrUpdateDocument = function (type, purpose, commonData, data, donorId) {
    // расширение типом
    var allData = angular.copy(commonData);
    allData.values = data;
    var allData = angular.extend(allData, {
        document_purpose: purpose,
        document_type: type
      }
    );
    // вызов АПИ
    return $http(
      {
        method: allData.id ? 'PUT' : 'POST',
        url: API_URL + '/documents/data' + (allData.id ? '/' + allData.id : ''),
        data: allData
      }
    );
  };

  /**
   * Запрос списка документов
   */
  this.getDocuments = function (params) {
    return $http.get(API_URL + '/documents/data', {
      params: params
    });
  }
  
  /**
   * Запрос данных документа по идентификатору
   */
  this.getDocumentData = function (id) {
    return $http.get(API_URL + '/documents/data/' + id);
  }

  /**
   * Удаление документа по идентификатору
   */

  this.deleteDocument = function (id) {
    return $http.delete(API_URL + '/documents/data/', {params: {id: id}});
  };

  this.processDocument = function (items) {
    return $http.post(API_URL + '/documents/status/process', {items: items});
  };

  this.rollbackDocument = function (items) {
    return $http.post(API_URL + '/documents/status/rollback', {items: items});
  };

  this.getMetaData = function (type) {
    // return $http.get('assets/api/documents/' + type + '.json');
    return $http.get(API_URL + '/documents/meta/' + type);
  };

  this.getCommonFields = function (type) {
    return $http.get('assets/api/documents/common-fields.json');
  };

  this.getDocumentSettings = function () {
    return $http.get(API_URL + '/documents/settings')
  };

  this.updateDocumentSettings = function (settings) {
    return $http.put(API_URL + '/documents/settings', settings)
  };

  this.getDocumentsGridSettings = function (force) {
    if (getDocumentsGridSettingsPromise && !force) {
      return getDocumentsGridSettingsPromise
    }
    getDocumentsGridSettingsPromise = $http.get('assets/api/documents/documentsGridSettings.json');
    return getDocumentsGridSettingsPromise
  }

  /**
   * Запрос инициализирующих данных для документа и его назначения
   *
   * @param type тип документа (код)
   * @param purpose назначение документа (код)
   * @param donorId идентификатор документа для которого создается связанный
   * @param sourceId идентификатор документа, для которого создается копия
   */
  this.getInitData = function(type, purpose, donorId, sourceId) {
    return $http.get(API_URL + '/documents/data/init/' + type + '/' + purpose, {
      params: {
        donor_id: donorId,
        source_doc_id: sourceId
      }
    });
  }

  /**
   * Расчет сумм для документа, для линеек документа включая налоги
   *
   * @param содержит курс валют и информацию из грида
   */
  this.documentsAmountsCalculate = function (params) {
    return $http.post(API_URL + '/documents/amounts/calculate', params, {
      params: {
        $$ignoreInterceptor: true
      }
    });
  };

  /**
   * Запрос следующего номера документа
   *
   * @param type тип документа
   * @param companyId идентификатор компании
   * */
  this.getNextDocumentNumber = function(type, companyId) {
    return $http.put(API_URL + '/documents/number', {
      company: {
        id: companyId
      },
      document_type: type
    }, {
      params: {
        $$ignoreInterceptor: true
      }
    });
  }

  /**
   * Получение цен для автоподстановки
   *
   * @params содержит данные для получения цен
   */
  this.documentsPrices = function (params) {
    return $http.post(API_URL + '/documents/data/prices', params, {
      params: {
        $$ignoreInterceptor: true
      }
    });
  };

  /**
   * Правило заполнения "Содержание операции" (simplifiedContent)
   *
   */
  this.getSimplifiedContent = function () {
    return $http.get('assets/api/SimplifiedContent.json');
  }
});

(function () {
  'use strict';

  angular.module('frontend').controller('allDocuments', allDocuments);

  /** @ngInject */
  function allDocuments(         userSettingsService,
                                 uiGridConstants,
                                 allDocumentsColumnDefsService,
                                 filterSettingsService,
                                 API_URL,
                                 companies,
                                 divisions,
                                 employees,
                                 $rootScope,
                                 projects,
                                 counterparties,
                                 domainCurrencies,
                                 docSettings,
                                 contracts,
                                 $filter,
                                 $state) {

    var vm = this;
    vm.url = API_URL + '/documents/data';
    vm.page = 'all-documents';
    vm.header = 'Все документы';
    vm.noDataStr = 'У вас пока нет ни одного документа';
    vm.sort = 'date';
    vm.limit = 25;
    vm.docSettings = docSettings;
    vm.columnDefs = userSettingsService.loadProperty(vm.page, 'grid', 'columnsProperty') ||
      allDocumentsColumnDefsService.getColumnDefs.call(this, uiGridConstants);
    vm.usingService = allDocumentsColumnDefsService;
    vm.filterMeta = {};
    vm.rowRouteFunc = function (rowData) {
      var state = getState(rowData.document_type);
      if (state) {
        var idSource = state.stateName === 'cashregshift.view' ? 'shift_id': 'id';
        $state.go(state.stateName, {id: rowData[idSource]});
      } else {
        $state.go('document.view', {
          type: rowData.document_type,
          purpose: rowData.document_purpose,
          id: rowData.id,
          allDocument: true
        });
      }
    };

    // TODO: в АПИ json
    var cashRegisterDocumentsTypes = [
      {
        stateName: 'cashregshift.view',
        type: ['CASHREGISTER_START_SHIFT', 'CASHREGISTER_END_SHIFT']
      },
      {
        stateName: 'cashboxreplenishment.view',
        type: 'CASHBOX_REPLENISHMENT'
      },
      {
        stateName: 'cashregreceipt.view',
        type: 'RETAIL_SALE'
      },
      {
        stateName: 'return.view',
        type: 'RETAIL_RETURN'
      },
      {
        stateName: 'encashment.view',
        type: 'CASHBOX_ENCASHMENT'
      }
    ];

    function getState(documentType) {
      return _.find(cashRegisterDocumentsTypes, function (item) {
        if (angular.isArray(item.type)) {
          return ~item.type.indexOf(documentType)
        } else {
          return item.type === documentType
        }
      })
    }

    var cloneType = angular.copy($rootScope.documentTypes);
    var clonePurpose = angular.copy($rootScope.getAllPurposes());
    vm.gridConfig = {
      universalDocuments: true,
      purposesFilterOn: false,
      currencies: domainCurrencies,
      documentType: 'all_documents',
      purposes: [
        // TODO: рефаторинг, строить на основе данных бекенда
        {
          type: 'BEGINNING_BALANCE_CONTRACT',
          value: 'BB_CONTRACT',
          label: 'Начальное состояние взаиморасчетов'
        },
        {
          type: 'BEGINNING_BALANCE_NON_CASH',
          value: 'BB_NON_CASH',
          label: 'Начальные остатки безналичных денежных средств'
        },
        {
          type: 'BEGINNING_BALANCE_CASH',
          value: 'BB_CASH',
          label: 'Начальные остатки наличных денежных средств'
        }
      ]
    };

    // Get data for selects
    if(companies){
      this.companiesSelect = [];
      vm.companiesPopup = companies;
      companies.forEach(function (item) {
        vm.companiesSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.company.name') {
          column.filter.selectOptions = vm.companiesSelect;
        }
      });
    }

    if(divisions){
      this.divisionsSelect = [];
      vm.divisionsPopup = divisions;
      divisions.forEach(function (item) {
        vm.divisionsSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.division.name' || column.name === 'dataValue.target_division.name' ) {
          column.filter.selectOptions = vm.divisionsSelect;
        }
      });
    }

    if(contracts){
      this.contractsListSelect = [];
      vm.contractsPopup = contracts;
      contracts.forEach(function (item) {
        vm.contractsListSelect.push({value: item.id, label: '№ ' + item.number + ' от ' + $filter('date')(item.date, 'dd.MM.yyyy') });
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.contract') {
          column.filter.selectOptions = vm.contractsListSelect;
        }
      });
    }

    if(employees){
      this.employeeListSelect = [];
      vm.employeeListPopup = employees;
      employees.forEach(function (item) {
        vm.employeeListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.created_by.name' || column.name === 'dataValue.updated_by.name') {
          column.filter.selectOptions = vm.employeeListSelect;
        }
      });
    }

    if (projects) {
      this.projectsListSelect = [];
      vm.projectsListPopup = projects.items;
      projects.items.forEach(function (item) {
        vm.projectsListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.project.name') {
          column.filter.selectOptions = vm.projectsListSelect;
        }
      });
    }

    if (counterparties) {
      this.counterpartiesListSelect = [];
      vm.counterpartiesListPopup = counterparties.items;
      counterparties.items.forEach(function (item) {
        vm.counterpartiesListSelect.push({value: item.id, label: item.name});
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.counterparty.name') {
          column.filter.selectOptions = vm.counterpartiesListSelect;
        }
      });
    }

    if (domainCurrencies) {
      this.natural_currencyListSelect = [];
      domainCurrencies.forEach(function (item) {
        vm.natural_currencyListSelect.push({value: item.currency.id, label: item.currency.name});
      });
      angular.forEach(vm.columnDefs, function (column) {
        if (column.name === 'dataValue.natural_currency.name') {
          column.filter.selectOptions = vm.natural_currencyListSelect;
        }
      });
    }


    angular.forEach(vm.columnDefs, function (column) {
      if (column.name === 'dataValue.status') {
        column.filter.selectOptions = $rootScope.documentStatuses;
      } else if (column.name === 'dataValue.document_type') {
        angular.forEach(cloneType, function(type) {
          type.label = type.name;
          type.value = type.code;
          delete type.name;
          delete type.code;
        });
        column.filter.selectOptions = cloneType
      } else if (column.name === 'dataValue.document_purpose') {
        angular.forEach(clonePurpose, function(type) {
          type.label = type.purpose_name;
          type.value = type.code;
          delete type.purpose_name;
          delete type.code;
        });
        column.filter.selectOptions = clonePurpose;
      }
    });



    // -- End Get data for selects
    filterSettingsService.filterAllDocuments().then(function(res){
      vm.filterMeta = res.data.items;
      vm.filterMeta[2].selectVal = clonePurpose;
      vm.filterMeta[3].selectVal = $rootScope.documentStatuses;
      vm.filterMeta[4].selectVal = cloneType;
      vm.filterMeta[5].selectVal = vm.counterpartiesListSelect;
      vm.filterMeta[6].selectVal = vm.projectsListSelect;
      vm.filterMeta[7].selectVal = vm.companiesSelect;
      vm.filterMeta[8].selectVal = vm.divisionsSelect;
      vm.filterMeta[9].selectVal = vm.divisionsSelect;
      vm.filterMeta[11].selectVal = vm.contractsListSelect;
      vm.filterMeta[13].selectVal = vm.natural_currencyListSelect;
      vm.filterMeta[14].selectVal = vm.employeeListSelect;
      vm.filterMeta[16].selectVal = vm.employeeListSelect;
    });
  }
})();

(function () {
  'use strict';

  angular.module('frontend').service('allDocumentsColumnDefsService', allDocumentsColumnDefsService);

  /** @ngInject */
  function allDocumentsColumnDefsService(userSettingsService) {
    var headerTemplate = '<div header-template-with-tooltip="" \n' +
      '  role="columnheader"\n' +
      '  ng-class="{ \'sortable\': sortable }"\n' +
      '  ui-grid-one-bind-aria-labelledby-grid="col.uid + \'-header-text \' + col.uid + \'-sortdir-text\'"\n' +
      '  aria-sort="{{col.sort.direction == asc ?' +
      ' \'ascending\' : ( col.sort.direction == desc ?' +
      ' \'descending\' : (!col.sort.direction ?' +
      ' \'none\' : \'other\'))}}">\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ng-keydown="handleKeyDown($event)"\n' +
      '    class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"\n' +
      '    col-index="renderIndex"\n' +
      '    title="TOOLTIP">\n' +
      '    <span\n' +
      '      class="ui-grid-header-cell-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-header-text\'"' +
      '      ng-bind-html="col.displayName">\n' +
      '      {{ CUSTOM_FILTERS }}\n' +
      '    </span>\n' +
      '\n' +
      '    <span\n' +
      '      class="sort-label"\n' +
      '      ui-grid-one-bind-id-grid="col.uid + \'-sortdir-text\'"\n' +
      '      ui-grid-visible="col.sort.direction"\n' +
      '      aria-label="{{getSortDirectionAriaLabel()}}">\n' +
      '      <i\n' +
      '       ng-class="{ \'ui-grid-icon-up-dir\': col.sort.direction == asc,' +
      ' \'ui-grid-icon-down-dir\': col.sort.direction == desc,' +
      ' \'ui-grid-icon-blank\': !col.sort.direction }"\n' +
      '       aria-hidden="true">\n' +
      '     </i>\n' +
      '    </span>\n' +
      '  </div>\n' +
      '\n' +
      '  <div\n' +
      '    role="button"\n' +
      '    tabindex="0"\n' +
      '    ui-grid-one-bind-id-grid="col.uid + \'-menu-button\'"\n' +
      '    class="ui-grid-column-menu-button"\n' +
      '    ng-if="grid.options.enableColumnMenus && !col.isRowHeader  && col.colDef.enableColumnMenu !== false"\n' +
      '    ng-click="toggleMenu($event)"\n' +
      '    ng-keydown="headerCellArrowKeyDown($event)"\n' +
      '    ng-class="{\'ui-grid-column-menu-button-last-col\': isLastCol}"\n' +
      '    ui-grid-one-bind-aria-label="i18n.headerCell.aria.columnMenuButtonLabel"\n' +
      '    aria-haspopup="true">\n' +
      '    <i\n' +
      '      class="ui-grid-icon-angle-down"\n' +
      '      aria-hidden="true">\n' +
      '      &nbsp;\n' +
      '    </i>\n' +
      '  </div>\n' +
      '  <button ng-if="col.colDef.backButton && grid.appScope.ctrl.hasPrevVisible"' +
      ' class="move-position-button prev tooltip-light" tooltip-placement="right" uib-tooltip="Показать еще колонки"' +
      ' ng-click="grid.appScope.ctrl.moveBack()"><</button>\n' +
      '\n' +
      '  <div ui-grid-filter></div>\n' +
      '</div>';

    var columnsDefinedWidth = [80, 100, 160, 160, 100, 160, 200, 200, 200, 200, 200, 200, 160, 200, 200, 200, 200, 160, 200, 200, 200, 200, 200, 200, 200, 200];


    this.loadSavedDefinedColumnWidth = function () {
      var income = userSettingsService.loadProperty('all-documents', 'grid', 'columnsDefinedWidth');

      if (!income) {
        userSettingsService.saveProperty('all-documents', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
      } else {
        columnsDefinedWidth = income;
      }
    };

    this.changeColumnDefinedWidth = function (columnName, newWidth) {
      columnsDefinedWidth[columnName] = newWidth;
      userSettingsService.saveProperty('all-documents', 'grid', 'columnsDefinedWidth', columnsDefinedWidth);
    };

    this.getColumnDefs = function (uiGridConstants) {
      return [
        {
          __index: 0,
          name: 'selection',
          field: 'option',
          displayName: '',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: columnsDefinedWidth[0],
          cellTemplate: '<div class="checkbox pull-left" ng-if="row.entity.dataValue"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="row.isSelected" ng-change="$event.stopPropagation()"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>',
          visible: true,
          headerCellTemplate: '<div class="checkbox pull-left"><label><input class="ui-gird-selection-checkbox" type="checkbox" ng-model="grid.selection.selectAll" ng-change="grid.appScope.ctrl.onSelectAllHandler(grid.selection.selectAll)"><span class="cr"><i class="cr-icon glyphicon glyphicon-ok"></i></span></label></div>' +
            '<div class="save-filter-star"' +
            ' ng-class="grid.appScope.ctrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'">\n' +
            '      <span ng-if="!grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light"' +
            ' ng-click="grid.appScope.ctrl.showSaveFilterPopup()" tooltip-placement="bottom-left" uib-tooltip="Сохранить фильтр"></span>\n' +
            '      <span ng-if="grid.appScope.ctrl.filterSaved"' +
            ' class="glyphicon glyphicon-star dropdown-toggle tooltip-light" tooltip-placement="bottom-left" uib-tooltip="{{\'Фильтр «\' + grid.appScope.ctrl.savedFilterName + \'»\'}}"></span>\n' +
            '</div>'
        },
        {
          __index: 1,
          name: 'dataValue.status',
          enableSorting: false,
          sortName: 'status',
          displayName: 'Статус',
          headerCellClass: 'text-center no-wrap-header',
          cellClass: 'text-center',
          headerCellTemplate: headerTemplate,
          cellTemplate: '<span class="tooltip-light ui-grid-cell-contents" tooltip-placement="right" uib-tooltip="{{row.entity.dataValue.status == \'PROCESSED\'? \'Проведен\' : (row.entity.dataValue.status == \'DRAFT\')? \'Черновик\' : \'В обработке\'}}" ng-bind-html="grid.appScope.ctrl.getStatus(row.entity) | documentStatus"></span>',
          enableFiltering: true,
          filterName: 'status',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          minWidth: 60,
          width: columnsDefinedWidth[1],
          visible: true,
          pinned: true,
          footerCellTemplate: '<div class="ui-grid-bottom-panel">Итого</div>',
        },
        {
          __index: 2,
          name: 'dataValue.number',
          enableSorting: true,
          sortName: 'number',
          displayName: 'Номер',
          enableFiltering: false,
          headerCellTemplate: headerTemplate,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: true,
          pinned: true,
          width: columnsDefinedWidth[2],
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left'
        },
        {
          __index: 3,
          name: 'dataValue.date',
          displayName: 'Дата',
          enableSorting: true,
          sortName: 'date',
          headerCellTemplate: headerTemplate,
          filterName: 'date',
          minWidth: 60,
          backButton: true,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: true,
          pinned: true,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' :\'UTC\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[3]
        },
        {
          __index: 4,
          name: 'dataValue.document_type',
          displayName: 'Тип',
          headerCellTemplate: headerTemplate,
          backButton: true,
          filterName: 'document_type',
          minWidth: 60,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | documentType"/>',
          visible: true,
          width: columnsDefinedWidth[4],
          filterHeaderTemplate: '<cell-multiple-select-filter filter="documentType" col="col"></cell-multiple-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          pinned: true
        },
        {
          __index: 5,
          name: 'dataValue.document_purpose',
          displayName: 'Название',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | documentPurpose"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'document_purpose',
          filterHeaderTemplate: '<cell-multiple-select-filter filter="documentPurpose" col="col"></cell-multiple-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: true,
          width: columnsDefinedWidth[5]
        },
        {
          __index: 6,
          name: 'dataValue.tax_charge_type',
          displayName: 'Тип начисления',
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | taxChargeType"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'tax_charge_type',
          filterHeaderTemplate: '<cell-multiple-select-filter filter="tax_charge_type" col="col"></cell-multiple-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          visible: false,
          width: columnsDefinedWidth[6]
        },
        {
          __index: 7,
          name: 'dataValue.ext_number',
          displayName: 'Входящий номер',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'ext_number',
          visible: false,
          width: columnsDefinedWidth[7]
        },
        {
          __index: 8,
          name: 'dataValue.ext_date',
          displayName: 'Входящая дата',
          enableSorting: true,
          sortName: 'ext_date',
          headerCellTemplate: headerTemplate,
          filterName: 'ext_date',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="ext_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : \'UTC\'"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : \'UTC\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[8]
        },
        {
          __index: 9,
          name: 'dataValue.acc_date',
          displayName: 'Дата учета',
          enableSorting: true,
          sortName: 'acc_date',
          headerCellTemplate: headerTemplate,
          filterName: 'acc_date',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col"  correct-timezone="false" name="acc_date" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy\' : \'UTC\'"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy\' : \'UTC\'',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[9]
        },
        {
          __index: 10,
          name: 'dataValue.company.name',
          displayName: 'Компания',
          minWidth: 60,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          headerCellTemplate: headerTemplate,
          filterName: 'company_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.companiesSelect
          },
          visible: false,
          width: columnsDefinedWidth[10]
        },
        {
          __index: 11,
          name: 'dataValue.division.name',
          displayName: 'Подразделение',
          visible: false,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.divisionsSelect
          },
          width: columnsDefinedWidth[11]
        },
        {
          __index: 12,
          name: 'dataValue.target_division.name',
          displayName: 'Подразделение получатель',
          visible: false,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filterName: 'target_division_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: this.divisionsSelect
          },
          width: columnsDefinedWidth[12]
        },
        {
          __index: 13,
          name: 'dataValue.counterparty.name',
          enableSorting: false,
          displayName: 'Контрагент',
          visible: true,
          width: columnsDefinedWidth[13],
          filterName: 'counterparty_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 14,
          name: "dataValue.contract",
          enableSorting: false,
          displayName: 'Договор',
          visible: false,
          width: columnsDefinedWidth[14],
          enableFiltering: true,
          filterName: 'contract_id',
          cellTemplate: '<cell-with-tooltip text="(COL_FIELD)? \'№\' + COL_FIELD.number + \' от \' + (COL_FIELD.date | date: \'dd.MM.yyyy\' : \'UTC\') : \'\'" cell-row="row" cell-col="col"></cell-with-tooltip>',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT,
          }
        },
        {
          __index: 15,
          name: 'dataValue.project.name',
          enableSorting: false,
          displayName: 'Проект',
          visible: false,
          width: columnsDefinedWidth[15],
          filterName: 'project_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 16,
          name: 'dataValue.expense_item.name',
          enableSorting: false,
          enableFiltering: false,
          displayName: 'Статья затрат',
          visible: false,
          width: columnsDefinedWidth[16],
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>'
        },
        {
          __index: 17,
          name: 'dataValue.home_amount',
          enableFiltering: false,
          displayName: 'Сумма',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          visible: true,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.totals.home_amount || 0"' +
            ' currency-symbol="$root.homeCurrency.currency.symbol"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[17]
        },
        {
          __index: 18,
          name: 'dataValue.created_by.name',
          enableSorting: false,
          displayName: 'Кто создал',
          visible: false,
          width: columnsDefinedWidth[18],
          filterName: 'created_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 19,
          name: 'dataValue.created_at',
          displayName: 'Когда создал',
          enableSorting: true,
          sortName: 'created_at',
          headerCellTemplate: headerTemplate,
          filterName: 'created_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="created_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[19]
        },
        {
          __index: 20,
          name: 'dataValue.updated_by.name',
          enableSorting: false,
          displayName: 'Кто обновил',
          visible: false,
          width: columnsDefinedWidth[20],
          filterName: 'updated_by_id',
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          filter: {
            type: uiGridConstants.filter.SELECT
          }
        },
        {
          __index: 21,
          name: 'dataValue.updated_at',
          displayName: 'Когда обновил',
          enableSorting: true,
          sortName: 'updated_at',
          headerCellTemplate: headerTemplate,
          filterName: 'updated_at',
          minWidth: 60,
          filterHeaderTemplate: '<cell-date-picker-filter col="col" name="updated_at" scope="grid.appScope"></cell-date-picker-filter>',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD| date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset"/>',
          visible: false,
          cellFilter: 'date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset',
          filter: {
            condition: uiGridConstants.filter.NOT_EQUAL
          },
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-left',
          width: columnsDefinedWidth[21]
        },
        {
          __index: 22,
          name: 'dataValue.natural_currency.name',
          enableSorting: false,
          filterName: 'natural_currency_id',
          enableFiltering: true,
          displayName: 'Валюта',
          enableColumnMenu: false,
          minWidth: 60,
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          headerCellTemplate: headerTemplate,
          filterHeaderTemplate: '<cell-select-filter col="col"></cell-select-filter>',
          filter: {
            type: uiGridConstants.filter.SELECT
          },
          cellClass: 'ui-custom-cell-text-align-to-left',
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>',
          visible: false,
          width: columnsDefinedWidth[22]
        },
        {
          __index: 23,
          name: 'dataValue.natural_amount',
          enableFiltering: false,
          displayName: 'Сумма в валюте документа',
          enableColumnMenu: false,
          headerCellTemplate: headerTemplate,
          headerCellClass: 'ui-custom-cell-text-align-to-right no-wrap-header',
          cellClass: 'ui-custom-cell-text-align-to-right',
          cellTemplate: '<cell-with-tooltip-money text="COL_FIELD"' +
            ' currency-symbol="row.entity.dataValue.natural_currency.symbol"/>',
          visible: false,
          footerCellTemplate: '<cell-with-tooltip-money text="grid.appScope.ctrl.natural_amount || 0"' +
            ' currency-symbol="grid.appScope.ctrl.currency"/>',
          footerCellClass: 'ui-custom-cell-text-align-to-right',
          width: columnsDefinedWidth[23]
        },
        {
          __index: 24,
          name: 'dataValue.tax_amount',
          enableSorting: false,
          enableFiltering: false,
          displayName: 'Налог',
          visible: false,
          width: 100,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>'
        },
        {
          __index: 25,
          name: 'dataValue.comment',
          enableSorting: false,
          displayName: 'Комментарий',
          visible: false,
          enableFiltering: false,
          width: 160,
          cellTemplate: '<cell-with-tooltip text="COL_FIELD"/>'
        },
        {
          __index: 26,
          name: 'option',
          field: 'option',
          headerCellTemplate: '<button class="move-position-button next tooltip-light" tooltip-placement="left" uib-tooltip="Показать еще колонки" ng-click="grid.appScope.ctrl.moveNext()" ' +
            'ng-if="grid.appScope.ctrl.hasNextVisible">></button><button class="menu-settings-button" ' +
            'ng-click="grid.appScope.ctrl.showSettings()"></button><div class="dropdown all-filters-wrapper">\n' +
            '      <button class="btn btn-default dropdown-toggle"\n' +
            '              data-toggle="modal" data-target="#filter-popup"\n' +
            '              ng-click="grid.appScope.ctrl.showFilterPopup()">Все</button>\n' +
            '\n' +
            '      <div class="dropdown-menu pull-right">\n' +
            '\n' +
            '        <div>\n' +
            '          <p class="dropdown-menu-header">Установленные фильтры</p>\n' +
            '        </div>\n' +
            '\n' +
            '        <div class="content-wrapper">\n' +
            '          <div class="content">\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.company_id">\n' +
            '              <p style="margin-bottom: 0">Компания:</p>\n' +
            '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.company.name")}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.division_id">\n' +
            '              <p style="margin-bottom: 0">Подразделение:</p>\n' +
            '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.division.name")}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.cash_register_place_name">\n' +
            '              <p style="margin-bottom: 0">Кассовое место:</p>\n' +
            '              <p>{{grid.appScope.ctrl.filter.cash_register_place_name}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.when_opened2">\n' +
            '              <p style="margin-bottom: 0">Дата выемки:</p>\n' +
            '              <p>{{grid.appScope.ctrl.filter.when_opened2}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.user">\n' +
            '              <p style="margin-bottom: 0">Кассир:</p>\n' +
            '              <p>{{grid.appScope.ctrl.getFilterLabel("dataValue.user.name")}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.shift_date">\n' +
            '              <p style="margin-bottom: 0">Дата смены:</p>\n' +
            '              <p>{{grid.appScope.ctrl.filter.shift_date}}</p>\n' +
            '            </div>\n' +
            '            <div ng-if="grid.appScope.ctrl.filter.shift_number">\n' +
            '              <p style="margin-bottom: 0">Номер смены:</p>\n' +
            '              <p>{{grid.appScope.ctrl.filter.shift_number}}</p>\n' +
            '            </div>\n' +
            '            <div class="dropdown-menu-header empty-filter-info">Фильтры не установлены</div>\n' +
            '          </div>\n' +
            '        </div>\n' +
            '      </div>\n' +
            '    </div>',
          cellTemplate: '',
          displayName: '',
          headerCellClass: 'ui-custom-cell-text-align-to-left no-wrap-header',
          enableColumnMenu: false,
          enableHiding: false,
          enableFiltering: false,
          width: 80,
          minWidth: 50,
          enableColumnResizing: false
        }
      ];
    };

    this.loadSavedDefinedColumnWidth();
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log,
                    $locale,
                    $rootScope,
                    $state,
                    $stateParams,
                    cardHistory,
                    auth,
                    preventLeaving,
                    $urlRouter,
                    uiVersion,
                    userSettingsService) {
    $rootScope.mobileText = navigator.userAgent || navigator.vendor || window.opera;
    $rootScope.mobileFlag = auth.checkMobileBrowser(navigator.userAgent || navigator.vendor || window.opera);
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
    moment.locale('ru');
    $log.debug('runBlock end');
    $locale.NUMBER_FORMATS.GROUP_SEP = " ";
    $locale.NUMBER_FORMATS.DECIMAL_SEP = ".";
    preventLeaving.startTracking();
    cardHistory.startTracking();
    console.log('current version of UI:', uiVersion.version);
    console.log('version update reason:', uiVersion.reasonOfUpdate);

    // удаление данных из LS
    if (uiVersion.reasonOfUpdate !== 'hotfix') {

    }

    $rootScope.$on('$locationChangeSuccess', function(e, newUrl, oldUrl ) {
      if (!!auth.isAuthenticated() && !!auth.isLoggedIn() && !!$rootScope.permission) return;

      e.preventDefault();

      auth.ensureSession().then(function(res) {
        if (res.data.domain && typeof res.data.domain.partner == 'boolean') {
         $rootScope.partner = res.data.domain.partner;
        }
        if (res.data.user) { // Пользователь связан с сессией , можно пускать в приложение
          auth.ensurePermissions().then(function() { // запрос прав
            $urlRouter.sync();
          })
        } else {
          if (!$rootScope.toLoginDone) {
            $rootScope.toLogin = true;
            $rootScope.toLoginDone = false;
          }
          $urlRouter.sync();
        }

      });

    });

    $urlRouter.listen();

  }

})();

(function () {
  'use strict';

  angular
    .module('frontend')
    .config(routerConfig)
    .constant('headerExceptions', ['login', //массив с исключениями (где хедер не нужен)
      'setpass',
      'resetpass',
      'recoverpass',
      'home',
      'register',
      'confirmregister',
      'confirmemail',
      'confirmnewemail',
      'passwordChangeRequested',
      'deadend']);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    function getAction($stateParam) {
      return $stateParam.type.toLowerCase() + '.read'
    }


    $stateProvider
      .state('home', {
        url: '/',
        onEnter: function ($rootScope, $state) {
          $state.go($rootScope.hasRole('report.sale_totals') ? 'indicators' : 'business', {});
        }
      })
      .state('deadend', {
        url: '/error/:from/:reason',
        template: '<deadend></deadend>',
        isThirdLevel: true,
        params: {
          from: null,
          reason: null
        }
      })
      .state('404', {
        url: '/404',
        template: '<deadend></deadend>',
        from: 'other',
        reason: 'not_found',
        isThirdLevel: true
      })
      .state('500', {
        url: '/500',
        template: '<deadend></deadend>',
        from: 'other',
        reason: 'server_error',
        isThirdLevel: true
      })
      .state('401', {
        url: '/401',
        template: '<deadend></deadend>',
        from: 'other',
        reason: 'need_role',
        isThirdLevel: true
      })
      // странички для работы с мобильного устройства
      .state('registerMobile', {
        url: '/mregister',
        template: '<mobile-register></mobile-register>',
        isMobile: true
      })
      .state('registerMobile.mobileError', {
        url: '/merror?message',
        templateUrl: 'app/mobile/error/error.html',
        controller: 'mErrorCtrl',
        controllerAs: 'mErrorCtrl',
        isMobile: true,
        isThirdLevel: true
      })
      .state('mobileError', {
        url: '/merror?message&hide_try_later&exit&error&parent&parentname&theme&division_id&timezone&choosen&session_id&tax_group_id&show_archived_item',
        templateUrl: 'app/mobile/error/error.html',
        controller: 'mErrorCtrl',
        controllerAs: 'mErrorCtrl',
        isMobile: true,
        isThirdLevel: true
      })
      .state('catalogMobile', {
        url: '/mcatalog?parent&parentname&theme&division_id&timezone&choosen&session_id&tax_group_id&show_archived_item',
        templateUrl: 'app/mobile/catalog/catalog.html',
        controller: 'catalogMobileController',
        controllerAs: 'catalogMobileCtrl',
        isMobile: true,
        isThirdLevel: true
      })
      .state('catalogMobile.searchCatalog', {
        url: '/search-catalog?request',
        controller: 'searchCatalogController',
        controllerAs: 'searchCatalogCtrl',
        templateUrl: 'app/mobile/catalog/search-catalog/search-catalog.html',
        isMobile: true,
        isThirdLevel: true,
      })
      .state('catalogMobile.createCatalogRoute', {
        url: '/create-catalog-route',
        controller: 'createCatalogRouteController',
        controllerAs: 'createCatalogRouteCtrl',
        templateUrl: 'app/mobile/catalog/create-catalog-route/create-catalog-route.html',
        isMobile: true,
        isThirdLevel: true,
      })
      .state('catalogMobile.deleteCatalogItem', {
        url: '/delete-catalog-item?type',
        controller: 'deleteCatalogItemController',
        controllerAs: 'deleteCatalogItemCtrl',
        templateUrl: 'app/mobile/catalog/delete/delete.html',
        isMobile: true,
        isThirdLevel: true,
      })
      .state('catalogMobile.mrecover', {
        url: '/mrecover?isarchived',
        controller: 'mrecoverController',
        controllerAs: 'mrecoverCtrl',
        templateUrl: 'app/mobile/catalog/recover/recover.html',
        isMobile: true,
        isThirdLevel: true,
      })
      .state('catalogMobile.scangtin', {
        url: '/scangtin/?id',
        templateUrl: 'app/mobile/catalog/scangtin/scangtin.html',
        neededRole: 'catalog_item.write',
        controller: 'scangtinController',
        controllerAs: 'scangtinCtrl',
        isThirdLevel: true,
        isMobile: true
      })
      .state('catalogMobile.category', {
        url: '/category/?id',
        neededRole: 'catalog_category.write',
        templateUrl: 'app/mobile/catalog/category/category.html',
        controller: 'categoryMobileController',
        controllerAs: 'categoryMobileCtrl',
        isThirdLevel: true,
        isMobile: true,
        resolve: {
          category: function ($state, categoryService, $stateParams) {
            if (!$stateParams.id) {
              return undefined;
            }
            return categoryService.getCustomCategory($stateParams.id)
              .then(function (data) {
                return data.data;
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по категории произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          parentHierarchy: function ($state, $stateParams, categoryService) {
            if (!$stateParams.parent) return;
            return categoryService.categoryHierarchy($stateParams.parent)
              .then(function (data) {
                return data.data.levels;
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по истории произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          }
        }
      })
      .state('catalogMobile.category.mobileError', {
        url: '/merror?message',
        templateUrl: 'app/mobile/error/error.html',
        controller: 'mErrorCtrl',
        controllerAs: 'mErrorCtrl',
        isMobile: true,
        isThirdLevel: true
      })
      .state('catalogMobile.msku', {
        url: '/msku/?id&gtin',
        neededRole: 'catalog_item.write',
        templateUrl: 'app/mobile/catalog/sku/sku.html',
        controller: 'skuMobileController',
        controllerAs: 'skuMobileCtrl',
        isThirdLevel: true,
        isMobile: true,
        resolve: {
          sku: function ($state, catalogItemService, $stateParams) {
            if (!$stateParams.id) {
              return undefined;
            }
            return catalogItemService.getSkus($stateParams.id)
              .then(function (data) {
                return data.data;
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по товару произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          parentHierarchy: function ($state, $stateParams, categoryService) {
            if (!$stateParams.parent) return;
            return categoryService.categoryHierarchy($stateParams.parent)
              .then(function (data) {
                return data.data.levels;
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по истории произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          skuByGtin: function ($state, catalogItemService, $stateParams) {
            if (!$stateParams.gtin) {
              return undefined;
            }
            return catalogItemService.getElements(null, $stateParams.gtin)
              .then(function (data) {
                if (!data.data.items[0]) return undefined;
                return catalogItemService.getElementInfo(data.data.items[0].id, $stateParams.parent).then(function (res) {
                  return res.data;
                });
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по товару произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          taxGroups: function ($state, catalogService, helpService, $stateParams) {
            return catalogService.getTax(null, helpService.now().valueOf())
              .then(function (res) {
                return res.data;
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по налогам произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          taxModes: function ($state, taxModeService, $stateParams) {
            return taxModeService.taxModes()
              .then(function (data) {
                return data.data.items.map(function (value) {
                  return value.mode
                });
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по налогам произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          settings: function ($state, catalogService, $stateParams) {
            return catalogService.getSettings().then(function (data) {
              return data.data;
            }, function (error) {
              $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по настройкам произошла ошибка";
              $state.go('mobileError', $stateParams);
            });
          }
        }
      })
      .state('catalogMobile.msku.attr', {
        url: '/attr/',
        neededRole: 'catalog_item.write',
        templateUrl: 'app/mobile/catalog/attributes/attr.html',
        controller: 'catalogItemAttrMobileController',
        controllerAs: 'catalogItemAttrMobileCtrl',
        isThirdLevel: true,
        isMobile: true,
        resolve: {
          categoryElements: function ($state, categoryService, $stateParams) {
            if (!$stateParams.parent) {
              return undefined;
            }
            return categoryService.getCustomCategory($stateParams.parent)
              .then(function (data) {
                return data.data.elements;
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по атрибутам произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          }
        }
      })
      .state('catalogMobile.msku.price', {
        url: '/price/',
        neededRole: 'catalog_item.write',
        templateUrl: 'app/mobile/catalog/price/price.html',
        controller: 'catalogItemPriceMobileController',
        controllerAs: 'catalogItemPriceMobileCtrl',
        isThirdLevel: true,
        isMobile: true,
        resolve: {
          columns: function ($state, priceColumnSrv, $stateParams) {
            return priceColumnSrv.priceColumns("RETAIL", $stateParams.division_id)
              .then(function (data) {
                if ($stateParams.division_id) {
                  data = _.filter(data, function (column) {
                    return column.divisions_assignment_type !== "NONE";
                  });
                }
                return data;
              }, function (error) {
                $stateParams.message = (error.status == -1) ? "Отсутствует подключение в интернету" : "Во время получения данных по колонкам прайс-листа произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          }
        }
      })
      .state('catalogMobile.msku.mobileError', {
        url: '/merror?message&hide_try_later',
        templateUrl: 'app/mobile/error/error.html',
        controller: 'mErrorCtrl',
        controllerAs: 'mErrorCtrl',
        isMobile: true,
        isThirdLevel: true
      })
      .state('catalogMobile.mservice', {
        url: '/mservice/?id',
        neededRole: 'catalog_item.write',
        templateUrl: 'app/mobile/catalog/service/service.html',
        controller: 'serviceMobileController',
        controllerAs: 'serviceMobileCtrl',
        isThirdLevel: true,
        isMobile: true,
        resolve: {
          service: function ($state, catalogItemService, $stateParams) {
            if (!$stateParams.id) {
              return undefined;
            }
            return catalogItemService.getService($stateParams.id)
              .then(function (data) {
                return data.data;
              }, function () {
                $stateParams.message = "Во время получения данных по услуге произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          parentHierarchy: function ($state, $stateParams, categoryService) {
            if (!$stateParams.parent) return;
            return categoryService.categoryHierarchy($stateParams.parent)
              .then(function (data) {
                return data.data.levels;
              }, function () {
                $stateParams.message = "Во время получения данных по истории произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          taxGroups: function ($state, catalogService, helpService, $stateParams) {
            return catalogService.getTax(null, helpService.now().valueOf())
              .then(function (res) {
                return res.data;
              }, function () {
                $stateParams.message = "Во время получения данных по налогу произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          taxModes: function ($state, taxModeService, $stateParams) {
            return taxModeService.taxModes()
              .then(function (data) {
                return data.data.items.map(function (value) {
                  return value.mode
                });
              }, function () {
                $stateParams.message = "Во время получения данных по налогу произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          },
          settings: function ($state, catalogService, $stateParams) {
            return catalogService.getSettings().then(function (data) {
              return data.data;
            }, function () {
              $stateParams.message = "Во время получения данных по настройкам произошла ошибка";
              $state.go('mobileError', $stateParams);
            });
          }
        }
      })
      .state('catalogMobile.mservice.attr', {
        url: '/attr/',
        neededRole: 'catalog_item.write',
        templateUrl: 'app/mobile/catalog/attributes/attr.html',
        controller: 'catalogItemAttrMobileController',
        controllerAs: 'catalogItemAttrMobileCtrl',
        isThirdLevel: true,
        isMobile: true,
        resolve: {
          categoryElements: function ($state, categoryService, $stateParams) {
            if (!$stateParams.parent) {
              return undefined;
            }
            return categoryService.getCustomCategory($stateParams.parent)
              .then(function (data) {
                return data.data.elements;
              }, function () {
                $stateParams.message = "Во время получения данных по атрибутам произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          }
        }
      })
      .state('catalogMobile.mservice.price', {
        url: '/price/',
        neededRole: 'catalog_item.write',
        templateUrl: 'app/mobile/catalog/price/price.html',
        controller: 'catalogItemPriceMobileController',
        controllerAs: 'catalogItemPriceMobileCtrl',
        isThirdLevel: true,
        isMobile: true,
        resolve: {
          columns: function ($state, priceColumnSrv, $stateParams) {
            return priceColumnSrv.priceColumns("RETAIL", $stateParams.division_id)
              .then(function (data) {
                if ($stateParams.division_id) {
                  data = _.filter(data, function (column) {
                    return column.divisions_assignment_type !== "NONE";
                  });
                }
                return data;
              }, function () {
                $stateParams.message = "Во время получения данных по колонкам прайс-листам произошла ошибка";
                $state.go('mobileError', $stateParams);
              });
          }
        }
      })
      .state('catalogMobile.mservice.mobileError', {
        url: '/merror?message&hide_try_later',
        templateUrl: 'app/mobile/error/error.html',
        controller: 'mErrorCtrl',
        controllerAs: 'mErrorCtrl',
        isMobile: true,
        isThirdLevel: true
      })
      //Способы оплаты
      .state('paymentTypes', {
        url: '/paymentTypes?parent',
        templateUrl: 'app/settings/paymentTypes/paymentTypes.html',
        controller: 'paymentTypesController',
        neededRole: 'payment_type.read',
        controllerAs: 'paymentTypesCtrl'
      })
      .state('paymentType', {
        abstract: true,
        url: '/paymentType/:paymentTypeId?parent',
        templateUrl: 'app/settings/paymentTypes/paymentType.html',
        resolve: {
          paymentType: function (paymentTypesService, $stateParams) {
            if (!$stateParams.paymentTypeId) {
              // Актуально при создании новой статьи затрат
              return undefined;
            }
            return paymentTypesService.paymentType($stateParams.paymentTypeId)
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('paymentType.new', {
        templateUrl: 'app/settings/paymentTypes/crud/paymentTypeCrud.html',
        controller: 'paymentTypeCrudController',
        controllerAs: 'paymentTypeCrudCtrl',
        url: '/new/',
        isThirdLevel: true,
        neededRole: 'payment_type.write',
        formName: 'addPaymentType'
      })
      .state('paymentType.edit', {
        templateUrl: 'app/settings/paymentTypes/crud/paymentTypeCrud.html',
        controller: 'paymentTypeCrudController',
        controllerAs: 'paymentTypeCrudCtrl',
        url: '/edit/',
        isThirdLevel: true,
        neededRole: 'payment_type.write',
        formName: 'addPaymentType'
      })
      .state('paymentType.view', {
        templateUrl: 'app/settings/paymentTypes/crud/paymentTypeCrud.html',
        controller: 'paymentTypeCrudController',
        controllerAs: 'paymentTypeCrudCtrl',
        url: '/view/',
        neededRole: 'payment_type.read',
        isThirdLevel: true
      })
      //Статьи затрат
      .state('expenseItems', {
        url: '/expenseItems?parent',
        templateUrl: 'app/settings/expenseItems/expenseItems.html',
        controller: 'expenseItemsController',
        neededRole: 'expense_item.read',
        controllerAs: 'expenseItemsCtrl'
      })
      .state('expenseItem', {
        abstract: true,
        url: '/expenseItems/:expenseItemId?parent',
        templateUrl: 'app/settings/expenseItems/expenseItem.html',
        resolve: {
          expenseItem: function (expenseItemsService, $stateParams) {
            if (!$stateParams.expenseItemId) {
              // Актуально при создании новой статьи затрат
              return undefined;
            }
            return expenseItemsService.expenseItem($stateParams.expenseItemId)
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('expenseItem.new', {
        templateUrl: 'app/settings/expenseItems/crud/expenseItem-crud.html',
        controller: 'expenseItemCrudController',
        controllerAs: 'expenseItemCrudCtrl',
        neededRole: 'expense_item.write',
        url: '/new/',
        isThirdLevel: true,
        formName: 'addexpenseItem'
      })
      .state('expenseItem.edit', {
        templateUrl: 'app/settings/expenseItems/crud/expenseItem-crud.html',
        controller: 'expenseItemCrudController',
        controllerAs: 'expenseItemCrudCtrl',
        neededRole: 'expense_item.write',
        url: '/edit/',
        isThirdLevel: true,
        formName: 'addexpenseItem'
      })
      .state('expenseItem.view', {
        templateUrl: 'app/settings/expenseItems/crud/expenseItem-crud.html',
        controller: 'expenseItemCrudController',
        controllerAs: 'expenseItemCrudCtrl',
        neededRole: 'expense_item.read',
        url: '/view/',
        isThirdLevel: true
      })
      .state('encashments', {
        url: '/cashbox-encashments?parent',
        neededRole: 'cash_register_docs.read',
        templateUrl: 'app/settings/cashbox-encashments/cashbox-encashments.html',
        controller: 'EncashmentsController',
        controllerAs: 'ctrl',
        resolve: {
          divisions: function (encashmentsService) {
            return encashmentsService.divisions()
              .then(function (data) {
                return data;
              });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies()
              .then(function (data) {
                return data;
              });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees()
              .then(function (data) {
                return data;
              });
          }
        }
      })
      .state('encashment', {
        abstract: true,
        neededRole: 'cash_register_docs.read',
        templateUrl: 'app/settings/cashbox-encashments/cashbox-encashment.html',
        url: '/cashbox-encashments/:id?parent'
      })
      .state('encashment.view', {
        controller: 'EncashmentCrudController',
        templateUrl: 'app/settings/cashbox-encashments/crud/cashbox-encashment-crud.html',
        controllerAs: 'ctrl',
        neededRole: 'cash_register_docs.read',
        url: '/view/',
        isThirdLevel: true
      })
      .state('cashregshifts', {
        url: '/cashregister-shifts?page&parent',
        neededRole: 'cash_register_docs.read',
        templateUrl: 'app/settings/cashregistes-shifts/cashregister-shifts.html',
        controller: 'CashregisterShiftsController',
        controllerAs: 'ctrl',
        resolve: {
          divisions: function (cashregisterShiftsService) {
            return cashregisterShiftsService.divisions()
              .then(function (data) {
                return data;
              });
          },
          companies: function (cashregisterShiftsService) {
            return cashregisterShiftsService.companies()
              .then(function (data) {
                return data;
              });
          },
          employees: function (cashregisterShiftsService) {
            return cashregisterShiftsService.employees()
              .then(function (data) {
                return data;
              });
          }
        }
      })
      .state('cashregshift', {
        abstract: true,
        templateUrl: 'app/settings/cashregistes-shifts/cashregister-shift.html',
        neededRole: 'cash_register_docs.read',
        url: '/cashregister-shifts/:id?backPage&end_shift&parent'
      })
      .state('cashregshift.view', {
        controller: 'CashregisterShiftCrudController',
        templateUrl: 'app/settings/cashregistes-shifts/crud/cashregister-shift-crud.html',
        controllerAs: 'ctrl',
        neededRole: 'cash_register_docs.read',
        url: '/view/',
        isThirdLevel: true
      })
      .state('cashregreceipt', {
        abstract: true,
        neededRole: 'cash_register_docs.read',
        templateUrl: 'app/settings/cashregister-receipts/cashregister-receipt.html',
        url: '/cashregister-receipts/:id?parent'
      })
      .state('cashregreceipt.view', {
        controller: 'CashregisterReceiptCrudController',
        neededRole: 'cash_register_docs.read',
        templateUrl: 'app/settings/cashregister-receipts/crud/cashregister-receipt-crud.html',
        controllerAs: 'ctrl',
        url: '/view/',
        isThirdLevel: true
      })
      .state('cashregreceipts', {
        url: '/cashregister-receipts?parent',
        neededRole: 'cash_register_docs.read',
        templateUrl: 'app/settings/cashregister-receipts/cashregister-receipts.html',
        controller: 'CashregisterReceiptsController',
        controllerAs: 'ctrl',
        resolve: {
          divisions: function (cashregisterReceiptsService) {
            return cashregisterReceiptsService.divisions()
              .then(function (data) {
                return data;
              });
          },
          companies: function (cashregisterReceiptsService) {
            return cashregisterReceiptsService.companies()
              .then(function (data) {
                return data;
              });
          },
          employees: function (cashregisterReceiptsService) {
            return cashregisterReceiptsService.employees()
              .then(function (data) {
                return data;
              });
          },
          cashRegisters: function (cashregisterReceiptsService) {
            return cashregisterReceiptsService.cashRegisters()
              .then(function (data) {
                return data;
              });
          },
          taxModes: function (taxModeService) {
            return taxModeService.taxModes()
              .then(function (data) {
                return data.data.items.map(function (value) {
                  return value.mode
                });
              });
          }
        }
      })
      .state('returns', {
        url: '/returns?parent',
        templateUrl: 'app/settings/returns/returns.html',
        controller: 'returnsController',
        neededRole: 'cash_register_docs.read',
        controllerAs: 'ctrl',
        resolve: {
          divisions: function (cashregisterShiftsService) {
            return cashregisterShiftsService.divisions()
              .then(function (data) {
                return data;
              });
          },
          companies: function (cashregisterShiftsService) {
            return cashregisterShiftsService.companies()
              .then(function (data) {
                return data;
              });
          },
          employees: function (cashregisterShiftsService) {
            return cashregisterShiftsService.employees()
              .then(function (data) {
                return data;
              });
          },
          cashRegisters: function (cashregisterShiftsService) {
            return cashregisterShiftsService.cashRegisters()
              .then(function (data) {
                return data;
              });
          },
          taxModes: function (taxModeService) {
            return taxModeService.taxModes()
              .then(function (data) {
                return data.data.items.map(function (value) {
                  return value.mode
                });
              });
          }
        }
      })
      .state('return', {
        abstract: true,
        templateUrl: 'app/settings/returns/return.html',
        url: '/returns/:id?parent'
      })
      .state('return.view', {
        controller: 'ReturnCrudController',
        templateUrl: 'app/settings/returns/crud/return-crud.html',
        controllerAs: 'ctrl',
        url: '/view/',
        neededRole: 'cash_register_docs.read',
        isThirdLevel: true
      })
      .state('cashboxreplenishments', {
        url: '/cashbox-replenishments?parent',
        neededRole: 'cash_register_docs.read',
        templateUrl: 'app/settings/cashbox-replenishments/cashbox-replenishments.html',
        controller: 'CashboxReplenishmentsController',
        controllerAs: 'ctrl',
        resolve: {
          divisions: function (cashboxReplenishmentsService) {
            return cashboxReplenishmentsService.divisions()
              .then(function (data) {
                return data;
              });
          },
          companies: function (cashboxReplenishmentsService) {
            return cashboxReplenishmentsService.companies()
              .then(function (data) {
                return data;
              });
          },
          employees: function (cashboxReplenishmentsService) {
            return cashboxReplenishmentsService.employees()
              .then(function (data) {
                return data;
              });
          }
        }
      })
      .state('cashboxreplenishment', {
        abstract: true,
        templateUrl: 'app/settings/cashbox-replenishments/cashbox-replenishment.html',
        url: '/cashbox-replenishments/:id?parent'
      })
      .state('cashboxreplenishment.view', {
        controller: 'CashboxReplenishmentsCrudController',
        templateUrl: 'app/settings/cashbox-replenishments/crud/cashbox-replenishments-crud.html',
        controllerAs: 'ctrl',
        neededRole: 'cash_register_docs.read',
        url: '/view/',
        isThirdLevel: true
      })
      //гайд
      .state('guide', {
        url: '/guide',
        templateUrl: 'app/guide/guide.html',
        controller: 'guideController',
        controllerAs: 'guide'
      })
      .state('register', {
        url: '/register?promo_code&partner_code',
        template: '<registration></registration>'
      })
      .state('register.shortregister', {
        url: '/shortregister'
      })
      .state('registerPartner?promo_code', {
        url: '/register_partner',
        template: '<registration is-partner="true"></registration>'
      })
      .state('confirmregister', {
        url: '/confirmregister/:id/:email',
        templateUrl: 'app/auth/confirmRegister/confirmRegister.html',
        controller: 'ConfirmRegisterController',
        controllerAs: 'vm'
      })
      .state('confirmemail', {
        url: '/confirmemail/{guid}',
        templateUrl: 'app/auth/confirmEmail/confirmEmail.html',
        onEnter: function (auth, $stateParams, doOrToDeadEnd) {
          doOrToDeadEnd.doOrToDeadEnd($stateParams.guid, 'confirmemail').then(function () {
            auth.confirmEmail('confirmemail', $stateParams.guid);
          });
        }
      })
      .state('confirmnewemail', {
        url: '/confirmnewemail/{guid}',
        templateUrl: 'app/auth/confirmEmail/confirmEmail.html',
        onEnter: function (auth, $stateParams, doOrToDeadEnd) {
          doOrToDeadEnd.doOrToDeadEnd($stateParams.guid, 'confirmnewemail').then(function () {
            auth.confirmEmail('confirmnewemail', $stateParams.guid);
          });
        }
      })
      .state('login', {
        url: '/login',
        templateUrl: 'app/auth/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm',
        params: {
          moveBack: { value: false },
          forward: { stateName: null, stateParams: null }
        },
        resolve: {
          previous: function ($state) {
            return {
              name: $state.current.name,
              params: $state.params
            };
          }
        }
      })
      .state('resetpass', {
        url: '/resetpass',
        templateUrl: 'app/auth/passRecovery/resetpass.html',
        controller: 'ResetPassController',
        resolve: {
          previous: function ($state) {
            return $state.current;
          }
        }
      })
      .state('passwordChangeRequested', {
        url: '/passwordChangeRequested?login&domain',
        templateUrl: 'app/auth/passRecovery/setpass.html',
        controller: 'SetPassController',
        controllerAs: 'vm',
        resolve: {
          previous: function ($state) {
            return $state.current;
          }
        },
        params: {
          oldPassword: { value: null }
        }
      })
      .state('setpass', {
        url: '/setpassword/{guid}',
        templateUrl: 'app/auth/passRecovery/setpass.html',
        controller: 'SetPassController',
        controllerAs: 'vm',
        onEnter: function (doOrToDeadEnd, $stateParams) {
          doOrToDeadEnd.doOrToDeadEnd($stateParams.guid, 'setpassword');
        }
      })
      .state('recoverpass', {
        url: '/recover/{guid}',
        templateUrl: 'app/auth/passRecovery/setpass.html',
        controller: 'SetPassController',
        controllerAs: 'vm',
        onEnter: function (doOrToDeadEnd, $stateParams) {
          doOrToDeadEnd.doOrToDeadEnd($stateParams.guid, 'recover');
        }
      })
      .state('indicators', {
        url: '/dashboard',
        templateUrl: 'app/comparative/comparative-template.html',
        controller: 'comparativeController',
        controllerAs: 'comparativeCtrl',
        neededRole: 'report.sale_totals',
        resolve: {
          currencyHome: function (currenciesService) {
            return currenciesService.getDomainCurrencies().then(function (data) {
              var home = _.findWhere(data.data.items, { home_currency: true });
              return home || data.data.items[0]; // возвращаем либо домашнюю валюту, либо первую
            });
          },
          hasNeededRole: function ($rootScope) {
            return $rootScope.hasRole('report.sale_totals')
          }
        }
      })
      .state('business', {
        url: '/business',
        templateUrl: 'app/settings/business/business.html',
        controller: 'businessController',
        neededRole: 'company.read',
        controllerAs: 'vm',
        formName: 'vm.addCashier'
      })
      .state('settings', {
        url: '/settings?parent',
        templateUrl: 'app/settings/settings.html',
        controller: 'SettingsController',
        controllerAs: 'vm'
      })
      .state('editProfile', {
        url: '/editprofile',
        templateUrl: 'app/settings/editProfile/editProfile.html',
        controller: 'editProfileController',
        controllerAs: 'vm',
        isThirdLevel: true,
        formName: 'editProfileForm',
        resolve: {
          user: function (auth) {
            return auth.ensureUserData(true).then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('support', {
        url: '/support?subject&message',
        templateUrl: 'app/settings/support/support.html',
        controller: 'supportController',
        controllerAs: 'supportCtrl',
        resolve: {
          attachmentType: function (supportService) {
            return supportService.getAttachmentTypes().then(function (res) {
              return res.data;
            })
          }
        }
      })
      .state('mainSettings', {
        url: '/main-settings',
        templateUrl: 'app/settings/main-settings/main-settings.html',
        controller: 'mainSettingsController',
        controllerAs: 'vm'
      })
      .state('accountingSettings', {
        url: '/accounting-settings',
        templateUrl: 'app/settings/accounting-settings/accounting-settings.html',
        controller: 'accountingSettingsController',
        controllerAs: 'vm',
        isThirdLevel: true,
        resolve: {
          accountingSettings: function (accountingService) {
            return accountingService.getAccountingSettings().then(function (res) {
              return res.data;
            })
          }
        }
      })
      .state('contragents', {
        url: '/contragents?parent',
        templateUrl: 'app/settings/contragents/contragents.html',
        controller: 'ContragentsController',
        neededRole: 'counterparty.read',
        controllerAs: 'vm'
      })
      .state('contragent', {
        abstract: true,
        url: '/contragent/:contragentId?parent&inn&kpp&short_name&full_name&purpose&closeTab',
        templateUrl: 'app/settings/contragents/contragent.html',
        resolve: {
          contragent: function (contragentService, $stateParams) {
            if (!$stateParams.contragentId) {
              // Актуально при создании нового контрагента
              return undefined;
            }
            return contragentService.contragent($stateParams.contragentId)
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('contragent.edit', {
        url: '/edit/',
        templateUrl: 'app/settings/contragents/crudContragent/crudContragent.html',
        controller: 'crudContragentController',
        controllerAs: 'vm',
        isThirdLevel: true,
        neededRole: 'counterparty.write',
        formName: 'addContragent'
      })
      .state('contragent.new', {
        url: '/new/',
        templateUrl: 'app/settings/contragents/crudContragent/crudContragent.html',
        controller: 'crudContragentController',
        controllerAs: 'vm',
        isThirdLevel: true,
        neededRole: 'counterparty.write',
        formName: 'addContragent'
      })
      .state('contragent.view', {
        url: '/view/',
        templateUrl: 'app/settings/contragents/crudContragent/crudContragent.html',
        controller: 'crudContragentController',
        controllerAs: 'vm',
        neededRole: 'counterparty.read',
        isThirdLevel: true
      })
      .state('employees', {
        url: '/employees?parent&modifiedPhone',
        templateUrl: 'app/settings/employees/employees.html',
        controller: 'EmployeesController',
        neededRole: 'user.read',
        controllerAs: 'employeesCtrl'
      })
      .state('employee', {
        abstract: true,
        templateUrl: 'app/settings/employees/employee.html',
        url: '/employee/:userId?parent',
        // Переход после resolve сотрудника, списков ролей и компаний (можно часть в контроллер вынести)
        resolve: {
          tree: function (employeesService) {
            return employeesService.getDataAccessRules()
              .then(function (data) {
                return data.data;
              })
          },
          user: function (employeesService, $stateParams) {
            if (!$stateParams.userId) {
              // Актально при создании новго сотрудника
              return;
            }
            return employeesService.user($stateParams.userId)
              .then(function (data) {
                return data.data;
              })
          },
          roles: function (rolesService) {
            return rolesService.roles()
              .then(function (data) {
                return data.data;
              })
          },
          companies: function (companyService) {
            return companyService.companies({}, null)
              .then(function (data) {
                return data.data.items;
              })
          },
          timezones: function (utilsService) {
            return utilsService.timezones()
              .then(function (data) {
                return data.data;
              })
          },
          me: function (auth) {
            return auth.ensureUserData().then(function (data) {
              return data.data;
            })
          }
        }
      })
      .state('employee.edit', {
        controller: 'EmployeesCrudController',
        templateUrl: 'app/settings/employees/crud/employees-crud.html',
        controllerAs: 'employeesCrudCtrl',
        neededRole: 'user.write',
        url: '/edit/?closeTab',
        isThirdLevel: true,
        formName: 'employeesCrudCtrl.eform'
      })
      .state('employee.new', {
        controller: 'EmployeesCrudController',
        templateUrl: 'app/settings/employees/crud/employees-crud.html',
        controllerAs: 'employeesCrudCtrl',
        neededRole: 'user.write',
        url: '/new/?closeTab',
        isThirdLevel: true,
        formName: 'employeesCrudCtrl.eform'
      })
      .state('employee.view', {
        controller: 'EmployeesCrudController',
        templateUrl: 'app/settings/employees/crud/employees-crud.html',
        controllerAs: 'employeesCrudCtrl',
        neededRole: 'user.read',
        url: '/view/',
        isThirdLevel: true
      })
      /* Компании */
      .state('companies', {
        url: '/companies?parent',
        templateUrl: 'app/settings/companies/companies.html',
        controller: 'companiesController',
        controllerAs: 'companyCtrl'
      })
      .state('company', {
        abstract: true,
        url: '/company/:companyId?parent',
        templateUrl: 'app/settings/companies/company.html',
        neededRole: 'company.read',
        resolve: {
          company: function (companyService, $stateParams) {
            if (!$stateParams.companyId) {
              // Актально при создании новой компании
              return undefined;
            }
            return companyService.company($stateParams.companyId)
              .then(function (data) {
                return data.data;
              });
          },
          taxs: function (taxService) {
            return taxService.taxs()
              .then(function (data) {
                return data.data;
              });
          },
          me: function (auth) {
            return auth.ensureUserData().then(function (data) {
              return data.data;
            });
          }
        }
      })
      .state('company.new', {
        url: '/new/:type?closeTab',
        controller: 'crudCompaniesController',
        templateUrl: 'app/settings/companies/crudCompanies/companies-crud.html',
        controllerAs: 'vm',
        isThirdLevel: true,
        neededRole: 'company.write',
        formName: 'addOrg'
      })
      .state('company.edit', {
        url: '/edit/?closeTab',
        controller: 'crudCompaniesController',
        templateUrl: 'app/settings/companies/crudCompanies/companies-crud.html',
        controllerAs: 'vm',
        isThirdLevel: true,
        neededRole: 'company.write',
        formName: 'addOrg'
      })
      .state('company.view', {
        url: '/view/',
        controller: 'crudCompaniesController',
        templateUrl: 'app/settings/companies/crudCompanies/companies-crud.html',
        controllerAs: 'vm',
        neededRole: 'company.read',
        isThirdLevel: true
      })
      /* Подразделения */
      .state('divisions', {
        url: '/divisions/:companyName?parent',
        templateUrl: 'app/settings/divisions/divisions.html',
        controller: 'DivisionsController',
        neededRole: 'division.read',
        controllerAs: 'divisionCtrl',
        resolve: {
          companies: function (companyService) {
            return companyService.companies({ limit: 100 }, null).then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('division', {
        url: '/division/:companyId/:divisionId?parent',
        templateUrl: 'app/settings/divisions/division.html',
        abstract: true,
        resolve: {
          division: function (companyService, $stateParams) {
            if (!$stateParams.companyId || !$stateParams.divisionId) {
              // Актуально при создании нового подразделения
              return undefined;
            }
            return companyService.division($stateParams.companyId, $stateParams.divisionId)
              .then(function (data) {
                return data.data;
              });
          },
          me: function (auth) {
            return auth.ensureUserData().then(function (data) {
              return data.data;
            });
          },
          homeCurrency: function (currenciesService) {
            var homeCurrency;
            return currenciesService.getDomainCurrencies().then(function (res) {
              angular.forEach(res.data.items, function (item) {
                if (item.home_currency) {
                  homeCurrency = {
                    id: item.currency.id,
                    name: item.currency.name,
                    char_iso_code: item.currency.char_iso_code,
                    symbol: item.currency.symbol
                  };
                }
              });
              return homeCurrency;
            });
          },
          allPaymentTypes: function (paymentTypesService) {
            return paymentTypesService.paymentTypes({}, '', { filter_active: true }).then(function (data) {
              return data.data.items;
            })
          },
          defaultBankPaymentType: function (paymentTypesService, contractService, $rootScope) {
            if ($rootScope.hasRole('contract.read')) {
              return paymentTypesService.paymentTypesAuto('', 100, {
                filter_active: true,
                filter_by_default: true,
                filter_type: 'BANK_CARD'
              }).then(function (res) {
                return res.data.items[0];
              })
            }
          }
        }
      })
      .state('division.new', {
        url: '/new/:type/:companyId',
        templateUrl: 'app/settings/divisions/crudDivision/crudDivision.html',
        controller: 'crudDivisionController',
        controllerAs: 'divisionCrudCtrl',
        isThirdLevel: true,
        neededRole: 'division.write',
        formName: 'addDivision'
      })
      .state('division.edit', {
        url: '/edit/',
        templateUrl: 'app/settings/divisions/crudDivision/crudDivision.html',
        controller: 'crudDivisionController',
        controllerAs: 'divisionCrudCtrl',
        isThirdLevel: true,
        neededRole: 'division.write',
        formName: 'addDivision'
      })
      .state('division.view', {
        url: '/view/',
        templateUrl: 'app/settings/divisions/crudDivision/crudDivision.html',
        controller: 'crudDivisionController',
        controllerAs: 'divisionCrudCtrl',
        neededRole: 'division.read',
        isThirdLevel: true
      })
      /* Договоры */
      .state('contracts', {
        url: '/contracts?parent',
        templateUrl: 'app/settings/contracts/contracts.html',
        controller: 'contractsController',
        controllerAs: 'contractsCtrl',
        neededRole: 'contract.read',
        resolve: {
          me: function (auth) {
            return auth.ensureUserData().then(function (me) {
              return me.data.user;
            });
          },
          types: function (utilsService) {
            return utilsService.contractType()
              .then(function (data) {
                return data.data.items;
              });
          }
        }
      })
      .state('contract', {
        url: '/contract/:contractId?parent&companyId&counterpartyId&purpose&closeTab',
        templateUrl: 'app/settings/contracts/contract.html',
        abstract: true,
        resolve: {
          contract: function (contractService, $stateParams) {
            if (!$stateParams.contractId) {
              // Актально при создании нового договора
              return undefined;
            }
            return contractService.contract($stateParams.contractId)
              .then(function (data) {
                return data.data;
              });
          },
          types: function (utilsService) {
            return utilsService.contractType()
              .then(function (data) {
                return data.data.items;
              });
          },
          defaultCompany: function (companyService) {
            return companyService.companiesSearch()
              .then(function (res) {
                if (res.data.items.length === 1) {
                  return res.data.items[0];
                }
                return null;
              });
          },
          defaultCurrency: function (currenciesService) {
            return currenciesService.getDomainCurrenciesSearch()
              .then(function (res) {
                if (res.data.items.length === 1) {
                  return res.data.items[0];
                }
                return null;
              });
          },
          companies: function (companyService) {
            return companyService.companiesSearch().then(function (data) {
              return data.data.items;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data.items;
            })
          }
        }
      })
      .state('contract.new', {
        url: '/new/',
        templateUrl: 'app/settings/contracts/crud/contract-crud.html',
        controller: 'crudContractController',
        controllerAs: 'contractCrudCtrl',
        isThirdLevel: true,
        neededRole: 'contract.write',
        formName: 'contractCrudCtrl.eForm'
      })
      .state('contract.edit', {
        url: '/edit/',
        templateUrl: 'app/settings/contracts/crud/contract-crud.html',
        controller: 'crudContractController',
        controllerAs: 'contractCrudCtrl',
        isThirdLevel: true,
        neededRole: 'contract.write',
        formName: 'contractCrudCtrl.eForm'
      })
      .state('contract.view', {
        url: '/view/',
        templateUrl: 'app/settings/contracts/crud/contract-crud.html',
        controller: 'crudContractController',
        controllerAs: 'contractCrudCtrl',
        neededRole: 'contract.read',
        isThirdLevel: true
      })
      /* Проекты */
      .state('projects', {
        url: '/projects?parent',
        templateUrl: 'app/settings/projects/projects.html',
        controller: 'projectsController',
        controllerAs: 'projectsCtrl',
        neededRole: 'project.read'
      })
      .state('project', {
        abstract: true,
        url: '/project/:projectId?parent',
        templateUrl: 'app/settings/projects/project.html',
        resolve: {
          project: function (projectsService, $stateParams) {
            if (!$stateParams.projectId) {
              // Актуально при создании нового проекта
              return undefined;
            }
            return projectsService.project($stateParams.projectId)
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('project.new', {
        url: '/new/?closeTab',
        templateUrl: 'app/settings/projects/crud/project-crud.html',
        controller: 'crudProjectController',
        controllerAs: 'projectCrudCtrl',
        isThirdLevel: true,
        formName: 'addproject',
        neededRole: 'project.write'
      })
      .state('project.edit', {
        url: '/edit/',
        templateUrl: 'app/settings/projects/crud/project-crud.html',
        controller: 'crudProjectController',
        controllerAs: 'projectCrudCtrl',
        isThirdLevel: true,
        formName: 'addproject',
        neededRole: 'project.write'
      })
      .state('project.view', {
        url: '/view/',
        templateUrl: 'app/settings/projects/crud/project-crud.html',
        controller: 'crudProjectController',
        controllerAs: 'projectCrudCtrl',
        isThirdLevel: true,
        neededRole: 'project.read'
      })
      /* Валюты */
      .state('currencies', {
        url: '/currencies?state&parent',
        templateUrl: 'app/settings/currencies/currencies.html',
        controller: 'currenciesController',
        controllerAs: 'vm'
      })
      .state('catalog', {
        url: '/catalog/:categoryId?parent',
        templateUrl: 'app/catalog/catalog.html',
        controller: 'catalogController',
        controllerAs: 'vm',
        resolve: {
          // Передает наличие категорий у участника
          hasCategory: function (categoryService) {
            return categoryService.getCategoriesAuto(undefined, 1)
              .then(function (data) {
                if (data && data.data) {
                  return data.data.total > 0;
                } else {
                  return false;
                }
              });
          },
          statuses: function (utilsService) {
            return utilsService.catalogStatuses().then(function (res) {
              return res.data.items;
            });
          }
        }
      })
      .state('category', {
        url: '/catalog/category/:categoryId?parent',
        templateUrl: 'app/catalog/crudCategory/crudCategory.html',
        controller: 'crudCategoryController',
        controllerAs: 'vm',
        resolve: {
          category: function (categoryService, $stateParams) {
            if (!$stateParams.categoryId) {
              return undefined;
            }
            return categoryService.getCustomCategory($stateParams.categoryId)
              .then(function (data) {
                return data.data;
              });
          },
          cashRegisterItemTypes: function ($http) {
            return $http.get('assets/api/cashRegisterItemTypes.json').then(function (res) {
              return res.data;
            })
          }
        }
      })
      .state('category.new', {
        url: '/new/?parentId',
        formName: 'addCategory',
        neededRole: 'catalog_category.write',
        isThirdLevel: true
      })
      .state('category.edit', {
        url: '/edit/',
        formName: 'addCategory',
        neededRole: 'catalog_category.write',
        isThirdLevel: true
      })
      .state('attrSettings', {
        url: '/catalog/attrSettings/?parent',
        templateUrl: 'app/catalog/attrSettings/attrSettings.html',
        controller: 'attrSettingsController',
        controllerAs: 'vm',
        formName: 'attrSettings',
        neededRole: 'catalog_settings.write',
        resolve: {
          alcoholSettings: function (catalogService) {
            return catalogService.getAlcoholSettings()
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('alcoholSettings', {
        url: '/alcoholSettings?parent',
        templateUrl: 'app/catalog/alcoholSettings/alcohol-settings.html',
        controller: 'alcoholSettingsController',
        controllerAs: 'vm',
        formName: 'alcoholSettings',
        neededRole: 'alcohol_settings.write',
        isThirdLevel: true,
        resolve: {
          alcoholSettings: function (catalogService) {
            return catalogService.getAlcoholSettings()
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('priceTagsSettings', {
        url: '/priceTagsSettings?parent',
        templateUrl: 'app/settings/priceTagsSettings/price-tags-settings.html',
        controller: 'priceTagsSettingsController',
        controllerAs: 'vm',
        formName: 'priceTagsSettings',
        neededRole: 'price_tag_settings.write',
        isThirdLevel: true,
        resolve: {
          priceTagsSettings: function (priceTagsService) {
            return priceTagsService.getPriceTagsSettings()
              .then(function (data) {
                return data.data;
              })
          }
        }
      })
      .state('catalogSkus', {
        abstract: true,
        url: '/catalog/catalogSkus/:categoryId/:elementId?&closeTab&parent',
        templateUrl: 'app/catalog/catalogItem/catalogSkus.html',
        resolve: {
          settings: function (catalogService) {
            return catalogService.getSettings()
              .then(function (data) {
                return data.data;
              });
          },
          element: function (catalogItemService, $stateParams) {
            if (!$stateParams.elementId) {
              return undefined;
            }
            return catalogItemService.getSkus($stateParams.elementId)
              .then(function (data) {
                return data.data;
              });
          },
          packTypes: function (catalogItemService) {
            return catalogItemService.getSkusTypes()
              .then(function (data) {
                return data.data.items;
              });
          },
          taxGroups: function (catalogService, helpService) {
            return catalogService.getTax(null, helpService.now().valueOf())
              .then(function (res) {
                return res.data;
              });
          },
          taxModes: function (taxModeService) {
            return taxModeService.taxModes()
              .then(function (data) {
                return data.data.items.map(function (value) {
                  return value.mode
                });
              });
          },
          searchItem: function () {
            return undefined;
          },
          radioTaxModeSource: function ($http) {
            return $http.get('assets/api/radioTaxModeSource.json').then(function (res) {
              return res.data;
            })
          },
          cashRegisterItemTypes: function ($http) {
            return $http.get('assets/api/cashRegisterItemTypes.json').then(function (res) {
              return res.data;
            })
          },
          cashRegisterTypesByProductGroup: function ($http) {
            return $http.get('assets/api/cashRegisterTypeByProductGroup.json').then(function (res) {
              return res.data;
            })
          },
          uoms: function (catalogService) {
            return catalogService.getUoms().then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('catalogSkus.search', {
        templateUrl: 'app/catalog/catalogItem/sections/skus/catalogSkusSearch.html',
        url: '/sku.search/',
        controller: 'catalogSkusSearchController',
        controllerAs: 'vm'
      })
      .state('catalogSkus.new', {
        templateUrl: 'app/catalog/catalogItem/sections/skus/catalogSkusMain.html',
        url: '/sku.new?searchElementId&searchName&searchGtinName&alcoPackedType&capacity&ean13&name&cashRegisterType',
        controller: 'catalogSkusController',
        controllerAs: 'vm',
        neededRole: 'catalog_item.write',
        isThirdLevel: true,
        formName: 'vm.addCatalogSkus',
        resolve: {
          searchItem: function (catalogItemService, $stateParams) {
            if (!$stateParams.searchElementId) {
              return undefined;
            }
            return catalogItemService.getElementInfo($stateParams.searchElementId, $stateParams.categoryId)
              .then(function (res) {
                return res.data;
              });
          }
        }
      })
      .state('catalogSkus.edit', {
        controller: 'catalogSkusController',
        controllerAs: 'vm',
        neededRole: 'catalog_item.write',
        formName: 'vm.addCatalogSkus',
        isThirdLevel: true,
        templateUrl: 'app/catalog/catalogItem/sections/skus/catalogSkusMain.html',
        url: '/sku.edit/'
      })
      .state('catalogSkus.view', {
        controller: 'catalogSkusController',
        controllerAs: 'vm',
        neededRole: 'catalog_item.read',
        isThirdLevel: true,
        templateUrl: 'app/catalog/catalogItem/sections/skus/catalogSkusMain.html',
        url: '/sku.view/'
      })
      // Услуги
      .state('catalogServices', {
        abstract: true,
        url: '/catalog/catalogServices/:categoryId/:elementId?closeTab&parent',
        templateUrl: 'app/catalog/catalogItem/catalogServices.html',
        resolve: {
          element: function (catalogItemService, $stateParams) {
            if (!$stateParams.elementId) {
              return undefined;
            }
            return catalogItemService.getService($stateParams.elementId)
              .then(function (data) {
                return data.data;
              });
          },
          taxGroups: function (catalogService, helpService) {
            return catalogService.getTax(null, helpService.now().valueOf())
              .then(function (res) {
                return res.data;
              });
          },
          taxModes: function (taxModeService) {
            return taxModeService.taxModes()
              .then(function (data) {
                return data.data.items.map(function (value) {
                  return value.mode
                });
              });
          },
          searchItem: function () {
            return undefined;
          },
          settings: function (catalogService) {
            return catalogService.getSettings()
              .then(function (data) {
                return data.data;
              });
          },
          expenseItems: function (expenseItemsService) {
            return expenseItemsService.expenseItemsSearch(null, 100, { filter_active: true })
              .then(function (data) {
                return data.data.items;
              });
          },
          radioTaxModeSource: function ($http) {
            return $http.get('assets/api/radioTaxModeSource.json').then(function (res) {
              return res.data;
            })
          },
          cashRegisterItemTypes: function ($http) {
            return $http.get('assets/api/cashRegisterItemTypes.json').then(function (res) {
              return res.data;
            })
          },
          cashRegisterTypesByProductGroup: function ($http) {
            return $http.get('assets/api/cashRegisterTypeByProductGroup.json').then(function (res) {
              return res.data;
            })
          }
        }
      })
      .state('catalogServices.search', {
        templateUrl: 'app/catalog/catalogItem/sections/services/catalogServicesSearch.html',
        url: '/services.search/',
        controller: 'catalogServicesSearchController',
        controllerAs: 'vm'
      })
      .state('catalogServices.new', {
        templateUrl: 'app/catalog/catalogItem/sections/services/catalogServicesMain.html',
        url: '/services.new/:searchElementId/:searchName',
        controller: 'catalogServicesController',
        controllerAs: 'vm',
        isThirdLevel: true,
        neededRole: 'catalog_item.write',
        formName: 'addCatalogItem',
        resolve: {
          searchItem: function (catalogItemService, $stateParams) {
            if (!$stateParams.searchElementId) {
              return undefined;
            }
            return catalogItemService.getElementInfo($stateParams.searchElementId, $stateParams.categoryId)
              .then(function (res) {
                return res.data;
              });
          }
        }
      })
      .state('catalogServices.edit', {
        templateUrl: 'app/catalog/catalogItem/sections/services/catalogServicesMain.html',
        url: '/services.edit/',
        controller: 'catalogServicesController',
        controllerAs: 'vm',
        isThirdLevel: true,
        neededRole: 'catalog_item.write',
        formName: 'addCatalogItem'
      })
      .state('catalogServices.view', {
        templateUrl: 'app/catalog/catalogItem/sections/services/catalogServicesMain.html',
        url: '/services.view/',
        isThirdLevel: true,
        neededRole: 'catalog_item.read',
        controller: 'catalogServicesController',
        controllerAs: 'vm'
      })
      .state('discounts', {
        url: '/discounts?parent',
        templateUrl: 'app/settings/discounts/discount-wide.html',
        controller: 'DiscountsController',
        neededRole: 'retail_discount.read',
        controllerAs: 'ctrl',
        resolve: {
          // Передает наличие акций
          noDiscounts: function (discountsService) {
            return discountsService.getDiscounts({ limit: 200 }).then(function (data) {
              if (data && data.data) {
                return data.data.total == 0;
              } else {
                return true;
              }
            });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees()
              .then(function (data) {
                return data;
              });
          }
        }
      })
      .state('discount', {
        abstract: true,
        url: '/discount/:id?parent',
        templateUrl: 'app/settings/discounts/discount.html',
        resolve: {
          discount: function (discountsService, $stateParams) {
            if (!$stateParams.id) {
              return undefined;
            }
            return discountsService.discount($stateParams.id)
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('discount.edit', {
        url: '/edit/',
        templateUrl: 'app/settings/discounts/crudDiscount/crudDiscount.html',
        controller: 'crudDiscountController',
        controllerAs: 'vm',
        neededRole: 'retail_discount.write',
        isThirdLevel: true,
        formName: 'addDiscount'
      })
      .state('discount.new', {
        url: '/new/',
        templateUrl: 'app/settings/discounts/crudDiscount/crudDiscount.html',
        controller: 'crudDiscountController',
        controllerAs: 'vm',
        neededRole: 'retail_discount.write',
        isThirdLevel: true,
        formName: 'addDiscount'
      })
      .state('discount.view', {
        url: '/view/',
        templateUrl: 'app/settings/discounts/crudDiscount/crudDiscount.html',
        controller: 'crudDiscountController',
        controllerAs: 'vm',
        neededRole: 'retail_discount.read',
        isThirdLevel: true
      })
      .state('priceList', {
        url: '/price-list?parent',
        templateUrl: 'app/price-list/price-list.html',
        controller: 'priceListController',
        controllerAs: 'priceListCtrl',
        conditionVariableName: 'priceListCtrl.notEmptyChanges',
        exceptionsState: ['priceColumn.new', 'priceColumn.edit'],
        preventByBrowser: true,
        resolve: {
          // Передает наличие категорий у участника
          hasCategory: function (categoryService) {
            return categoryService.getDomainCategories()
              .then(function (data) {
                if (data && data.data) {
                  return data.data.length > 0;
                } else {
                  return false;
                }
              });
          },
          // категории в котоых есть изменения в локальном хранилище
          changedCategories: function (priceLocalSrv, priceListSrv, $stateParams) {
            return priceLocalSrv.allPricesItems($stateParams.parent).then(function (items) {
              if (items && items.length) {
                return priceListSrv.getCategoriesTreeByItems(items).then(function (ids) {
                  var categoriesMap = {};
                  if (ids && ids.data && ids.data.items) {
                    angular.forEach(ids.data.items, function (item) {
                      categoriesMap[item] = true; // для каждого идентификатора устанавливается флаг в ассоциативный массив
                    });
                  }
                  ;
                  return categoriesMap;
                });
              }
              return undefined;
            });
          },
          // тип: розница или оптовый
          type: function ($stateParams) {
            return $stateParams.parent;
          },
          // флаг промежуточного сохранения изменений
          twoStepSaving: function ($stateParams) {
            return $stateParams.parent !== 'PURCHASE';
          },
          // колонки в которых есть изменения в локальном хранилище
          changedColumns: function (priceLocalSrv, $stateParams) {
            return priceLocalSrv.allPricesColumns($stateParams.parent);
          },
          columns: function (priceColumnSrv, $stateParams, priceSettingsService) {
            // Для фильтрации испольузется свойство parent, без дополнительной трансформации
            return priceColumnSrv.priceColumns($stateParams.parent)
              .then(function (data) {
                return priceSettingsService.getColumnWithPriority($stateParams.parent, data);
              });
          },
          columnLimit: function (priceSettingsService, $stateParams) {
            return priceSettingsService.getColumnCount($stateParams.parent);
          }
        }
      })
      .state('priceColumn', {
        abstract: true,
        url: '/priceColumn/:priceColumnId?type&parent',
        templateUrl: 'app/price-list/column/price-column-crud-base.html',
        resolve: {
          // тип: розничная или оптовая
          type: function ($stateParams) {
            return $stateParams.type;
          },
          priceColumn: function (priceColumnSrv, $stateParams) {
            if (!$stateParams.priceColumnId) {
              return undefined;
            }
            return priceColumnSrv.priceColumn($stateParams.type, $stateParams.priceColumnId)
              .then(function (data) {
                return data;
              });
          },
          taxGroups: function (catalogService) {
            return catalogService.getTax('', moment().valueOf()).then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('priceColumn.new', {
        templateUrl: 'app/price-list/column/price-column-crud.html',
        url: '/priceColumn.new',
        isThirdLevel: true,
        controller: 'priceColumnController',
        controllerAs: 'priceColumnCrudCtrl',
        formName: 'priceColumnCrudCtrl.addPriceColumn'
      })
      .state('priceColumn.edit', {
        templateUrl: 'app/price-list/column/price-column-crud.html',
        url: '/priceColumn.edit/',
        isThirdLevel: true,
        controller: 'priceColumnController',
        controllerAs: 'priceColumnCrudCtrl',
        formName: 'priceColumnCrudCtrl.addPriceColumn'
      })
      .state('comparative', {
        url: '/comparative',
        templateUrl: 'app/comparative/comparative-template.html',
        controller: 'comparativeController',
        controllerAs: 'comparativeCtrl'
      })
      .state('importPriceList', {
        url: '/importPriceList?parent',
        templateUrl: 'app/price-list/import/import-price-list.html',
        controller: 'importPriceListController',
        controllerAs: 'vm',
        resolve: {
          priceColumns: function (priceColumnSrv, $stateParams) {
            return priceColumnSrv.priceColumns($stateParams.parent)
              .then(function (data) {
                return data;
              });
          },
          type: function ($stateParams) {
            return $stateParams.parent;
          }
        }
      })
      .state('importCatalog', {
        url: '/importCatalog?parent',
        templateUrl: 'app/catalog/import/import-catalog.html',
        controller: 'importCatalogController',
        controllerAs: 'vm'
      })
      .state('contacts', {
        url: '/contacts',
        templateUrl: 'app/settings/contacts/contacts.html'
      })
      .state('allDocuments', {
        url: '/all-documents?parent',
        templateUrl: 'app/all-documents/all-documents.html',
        controller: 'allDocuments',
        neededRole: 'all_documents.read',
        controllerAs: 'vm',
        resolve: {
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data
            })
          },
          projects: function (projectsService) {
            return projectsService.projects({ limit: 100, offset: 0 }).then(function (data) {
              return data.data
            })
          },
          docSettings: function (documentService) {
            return documentService.getDocumentSettings().then(function (data) {
              return data.data;
            });
          },
          domainCurrencies: function (currenciesService) {
            return currenciesService.getDomainCurrencies().then(function (data) {
              return data.data.items;
            });
          },
          types: function (auth, $rootScope) {
            return auth.ensureTypes().then(function (res) {
              var sortData = _.sortBy(res.data, 'name');
              $rootScope.documentTypes = sortData;
              return sortData
            })
          },
          contracts: function (contractService) {
            return contractService.contracts().then(function (data) {
              return data.data.items;
            })
          }
        }
      })
      .state('document', {
        abstract: true,
        url: '/document/:type/:purpose?donor&source&parent&allDocument',
        templateUrl: 'app/documents/document-crud/document-abstract-crud.html',
        neededRole: 'documentType', // проверка необходимой роли подставляется перед переходом
        resolve: {
          // тип документа
          type: function ($stateParams) {
            return $stateParams.type;
          },
          // purpose (подтип)
          purpose: function ($stateParams) {
            return $stateParams.purpose;
          },
          // метаинфомрация по типу документа
          meta: function ($stateParams, documentService) {
            if (!$stateParams.type) {
              return undefined;
            }
            return documentService.getMetaData($stateParams.type)
              .then(function (data) {
                return data.data;
              });
          },
          commonFieldsMeta: function (documentService) {
            return documentService.getCommonFields().then(function (res) {
              return res.data;
            });
          },
          data: function () {
            return undefined;
          },
          settings: function (documentService) {
            return documentService.getDocumentSettings().then(function (data) {
              return data.data;
            });
          },
          currencyHome: function (currenciesService) {
            return currenciesService.getDomainCurrencies().then(function (data) {
              var home = _.findWhere(data.data.items, { home_currency: true });
              return home || data.data.items[0]; // возвращаем либо домашнюю валюту, либо первую
            });
          }
        }
      })
      .state('document.new', {
        url: '/new',
        templateUrl: 'app/documents/document-crud/document-crud.html',
        controller: 'documentCrudController',
        controllerAs: 'documentCrudCtrl',
        formName: 'documentCrudCtrl.documentAllForm',
        isThirdLevel: true,
        neededRole: 'documentType', // провкрка необходимой роли подставляется перед переходом
        resolve: {
          init: function ($stateParams, documentService) {
            if ($stateParams.donor || $stateParams.source) {
              return documentService.getInitData(
                $stateParams.type,
                $stateParams.purpose,
                $stateParams.donor,
                $stateParams.source
              ).then(function (data) {
                return data.data;
              }, function (error) {
                return undefined; // ошибка тут позволяет работать дальше
              });
            } else {
              return undefined;
            }
          }
        }
      })
      .state('document.view', {
        url: '/view?id&allDocument',
        templateUrl: 'app/documents/document-crud/document-crud.html',
        controller: 'documentCrudController',
        controllerAs: 'documentCrudCtrl',
        formName: 'documentCrudCtrl.documentAllForm',
        isThirdLevel: true,
        neededRole: 'documentType', // проверка необходимой роли подставляется перед переходом
        resolve: {
          init: function () {
            return undefined;
          },
          data: function ($stateParams, documentService, $rootScope) {
            if (!$stateParams.id) {
              return undefined;
            }
            return documentService.getDocumentData($stateParams.id)
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('documentSettings', {
        url: '/document-settings?parent',
        templateUrl: 'app/documents/document-settings/document-settings.html',
        controller: 'documentSettingsController',
        controllerAs: 'vm',
        isThirdLevel: true,
        formName: 'documentSettingsForm',
        neededRole: 'document_settings.write',
        resolve: {
          documentSettings: function (documentService) {
            return documentService.getDocumentSettings().then(function (res) {
              return res.data
            })
          }
        }
      })
      .state('documents', {
        url: '/documents/:type?parent',
        templateUrl: 'app/documents/document-grid/document-grid.html',
        controller: 'documents',
        controllerAs: 'vm',
        neededRole: 'documentType',
        resolve: {
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data
            })
          },
          projects: function (projectsService) {
            return projectsService.projects({ limit: 100, offset: 0 }).then(function (data) {
              return data.data
            })
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          },
          contracts: function (contractService) {
            return contractService.contracts().then(function (data) {
              return data.data.items;
            })
          },
          documentMetaData: function (documentService, $stateParams) {
            return documentService.getMetaData($stateParams.type).then(function (res) {
              return res.data
            });
          },
          documentsGridSettings: function (documentService, $stateParams) {
            return documentService.getDocumentsGridSettings().then(function (res) {
              return res.data[$stateParams.type]
            });
          },
          filterSettings: function (filterSettingsService) {
            return filterSettingsService.filterAllDocuments().then(function (res) {
              return res.data.items;
            });
          },
          domainCurrencies: function (currenciesService) {
            return currenciesService.getDomainCurrencies().then(function (data) {
              return data.data.items;
            });
          },
          types: function (auth, $rootScope) {
            return auth.ensureTypes().then(function (res) {
              var sortData = _.sortBy(res.data, 'name');
              $rootScope.documentTypes = sortData;
              return sortData
            })
          },
          docSettings: function (documentService) {
            return documentService.getDocumentSettings().then(function (data) {
              return data.data;
            });
          },
          taxChargeTypes: function (utilsService) {
            return utilsService.taxChargeTypes().then(function (res) {
              return res.data.items;
            });
          }
        }
      })
      .state('stock', {
        url: '/stock?parent',
        templateUrl: 'app/inventory/stock/stock.html',
        controller: 'stockController',
        controllerAs: 'vm',
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          }
        }
      })
      .state('stockAnalysis', {
        url: '/stock-analysis?parent',
        templateUrl: 'app/inventory/stock/stock.html',
        controller: 'stockAnalysisController',
        controllerAs: 'vm',
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data.items
            })
          }
        }
      })
      .state('stockTotal', {
        url: '/stock-total?parent',
        templateUrl: 'app/inventory/stock/stock.html',
        controller: 'stockTotalController',
        controllerAs: 'vm',
        // neededRole: ['stock_period_totals.read', 'report.sale_totals'],
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data.items
            })
          }
        }
      })
      .state('transactions', {
        url: '/transactions?parent&company_id&division_id&item_id&stock_item_id&stock_type&start_date&end_date&counterparty_id&contract_id&base_mode',
        templateUrl: 'app/inventory/transaction/transactions.html',
        controller: 'transactionsController',
        controllerAs: 'transactionsCtrl',
        neededRole: ['stock_period_totals.read'],
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data.items
            })
          },
          dafaultCompany: function ($stateParams, companyService) {
            if (!$stateParams.company_id) return null;
            return companyService.company($stateParams.company_id).then(function (res) {
              return {
                name: res.data.name,
                id: $stateParams.company_id
              };
            });
          },
          dafaultDivision: function ($stateParams, companyService) {
            if (!$stateParams.company_id || !$stateParams.division_id) return null;
            return companyService.division($stateParams.company_id, $stateParams.division_id).then(function (res) {
              return {
                name: res.data.name,
                id: $stateParams.division_id
              };
            });
          },
          dafaultCounterparty: function ($stateParams, contragentService) {
            if (!$stateParams.counterparty_id) return null;
            return contragentService.contragent($stateParams.counterparty_id).then(function (res) {
              return {
                name: res.data.name,
                id: $stateParams.counterparty_id
              };
            });
          },
          dafaultContract: function ($stateParams, contractService, $filter) {
            if (!$stateParams.contract_id) return null;
            return contractService.contract($stateParams.contract_id).then(function (res) {
              return res.data;
            });
          },
          dafaultCatalogItem: function ($stateParams, catalogItemService) {
            if (!$stateParams.item_id) return null;
            return catalogItemService.getSkus($stateParams.item_id).then(function (res) {
              return {
                name: res.data.name,
                id: $stateParams.item_id
              };
            }, function () {
              catalogItemService.getService($stateParams.item_id).then(function (res) {
                return {
                  name: res.data.name,
                  id: $stateParams.item_id
                };
              });
            });
          },
          defaultStockItemId: function ($stateParams, catalogService) {
            if (!$stateParams.item_id || !$stateParams.stock_item_id) return null;
            return catalogService.searchDerivatives($stateParams.item_id).then(function (res) {
              var derivative = _.find(res.data.items, function (der) {
                return der.id == $stateParams.stock_item_id;
              });
              return {
                name: (!derivative.name) ? derivative.code : derivative.code + ' ' + derivative.name,
                id: $stateParams.stock_item_id
              };
            });
          }
        }
      })
      .state('inventoryTagSettings', {
        url: '/inventory-tag-settings?parent',
        templateUrl: 'app/inventory/inventory-tag-settings/inventory-tag-settings.html',
        controller: 'inventoryTagSettingsController',
        controllerAs: 'vm',
        isThirdLevel: true,
        resolve: {
          inventoryTagSettings: function (inventoryService) {
            return inventoryService.getInventoryTagSettings()
              .then(function (data) {
                return data.data;
              })
          },
          inventoryTagSettingsOptions: function ($http) {
            return $http.get('assets/api/inventoryTagSettingsOptions.json').then(function (res) {
              return res.data
            })
          }
        }
      })
      .state('invoiceWaybills', {
        url: '/invoice-waybill-list?parent',
        templateUrl: 'app/egaisz/invoice-waybill-list/invoice-waybill-list.html',
        controller: 'invoiceWaybillListCtrl',
        controllerAs: 'invoiceWaybillListCtrl',
        resolve: {
          invoiceWaybillStatuses: function (egaiszService) {
            return egaiszService.getInvoiceWaybillStatuses().then(function (data) {
              return data.data.items;
            });
          },
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data.items;
            })
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          }
        }
      })
      .state('invoiceWaybill', {
        abstract: true,
        url: '/invoice-waybill/:id?parent',
        templateUrl: 'app/egaisz/egaisz-abstract.html',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService) {
            return egaiszService.getMetaData('ALCO_TTN_IN')
              .then(function (data) {
                return data.data;
              });
          },
          waybill: function (egaiszService, $stateParams) {
            return egaiszService.getWaybill($stateParams.id);
          }
        }
      })
      .state('invoiceWaybill.edit', {
        url: '/edit',
        controllerAs: 'invoiceWaybillCtrl',
        templateUrl: 'app/egaisz/invoice-waybill/invoice-waybill.html',
        controller: 'invoiceWaybillCtrl',
        formName: 'invoiceWaybillCtrl.invoiceWaybillForm',
        resolve: {
          edit: function () {
            return true;
          }
        }
      })
      .state('invoiceWaybill.view', {
        url: '/view',
        controllerAs: 'invoiceWaybillCtrl',
        templateUrl: 'app/egaisz/invoice-waybill/invoice-waybill.html',
        controller: 'invoiceWaybillCtrl',
        resolve: {
          edit: function () {
            return false;
          }
        }
      })
      .state('beerDeclarations', {
        url: '/beer-declarations-list?parent',
        templateUrl: 'app/egaisz/beer-declarations-list/beer-declarations-list.html',
        controller: 'beerDeclarationsListCtrl',
        controllerAs: 'beerDeclarationsListCtrl',
        resolve: {
          beerDeclarationsStatuses: function (beerDeclarationService) {
            return beerDeclarationService.getBeerDeclarationsStatuses().then(function (data) {
              return data.data.items;
            });
          },
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          counterparties: function (contragentService) {
            return contragentService.counterparties({ limit: 100, offset: 0 }).then(function (data) {
              return data.data.items;
            })
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          }
        }
      }).state('beerDeclaration', {
        url: '/beer-declaration/:id?parent',
        templateUrl: 'app/egaisz/egaisz-abstract.html',
        neededRole: 'beer_declaration.read',
        formName: 'beerDeclarationCtrl.form',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService) {
            return egaiszService.getMetaData('BEER_DECLARATION')
              .then(function (data) {
                return data.data;
              });
          },
          beerDeclaration: function (beerDeclarationService, $stateParams) {
            if ($stateParams.id || $stateParams.source) {
              return beerDeclarationService.getBeerDeclaration($stateParams.id).then(function (res) {
                return res.data;
              });
            }
          }
        }
      })
      .state('beerDeclaration.new', {
        url: '/new',
        controllerAs: 'beerDeclarationCtrl',
        templateUrl: 'app/egaisz/beer-declaration/beer-declaration.html',
        controller: 'beerDeclarationCtrl',
        formName: 'beerDeclarationCtrl.form',
        neededRole: 'beer_declaration.write',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService) {
            return egaiszService.getMetaData('NEW_BEER_DECLARATION')
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('beerDeclaration.edit', {
        url: '/edit',
        controllerAs: 'beerDeclarationCtrl',
        templateUrl: 'app/egaisz/beer-declaration/beer-declaration.html',
        controller: 'beerDeclarationCtrl',
        formName: 'beerDeclarationCtrl.form',
        neededRole: 'beer_declaration.write'
      })
      .state('beerDeclaration.view', {
        url: '/view',
        controllerAs: 'beerDeclarationCtrl',
        templateUrl: 'app/egaisz/beer-declaration/beer-declaration.html',
        formName: 'beerDeclarationCtrl.form',
        controller: 'beerDeclarationCtrl'
      })
      .state('cancellationActsList', {
        url: '/cancellation-acts-list?parent',
        templateUrl: 'app/egaisz/cancellation-acts-list/cancellation-acts-list.html',
        controller: 'cancellationActsListCtrl',
        controllerAs: 'cancellationActsListCtrl',
        neededRole: 'write_off_statement_egais.read',
        resolve: {
          cancellationActsStatuses: function (egaiszService) {
            return egaiszService.getCancellationActsStatuses().then(function (data) {
              return data.data.items;
            });
          },
          writeOffTypes: function (egaiszService) {
            return egaiszService.getWriteOffTypes().then(function (data) {
              return data.data.items;
            });
          },
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          }
        }
      })
      .state('cancellationAct', {
        abstract: true,
        url: '/cancellation-act/:id?source&register&parent',
        templateUrl: 'app/egaisz/egaisz-abstract.html',
        neededRole: 'write_off_statement_egais.read',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService, $stateParams) {
            return egaiszService.getMetaData(($stateParams.register) ? 'CANCELLATION_ACT_' + $stateParams.register : 'CANCELLATION_ACT')
              .then(function (data) {
                return data.data;
              });
          },
          cancellationAct: function (writeOffStatementService, $stateParams) {
            if ($stateParams.id || $stateParams.source) {
              return writeOffStatementService.getWriteOffStatement($stateParams.id || $stateParams.source).then(function (res) {
                return res.data;
              });
            }
          }
        }
      })
      .state('cancellationAct.new', {
        url: '/new',
        controllerAs: 'cancellationActCtrl',
        templateUrl: 'app/egaisz/cancellation-act/cancellation-act.html',
        controller: 'cancellationActCtrl',
        formName: 'cancellationActCtrl.cancellationActForm'
      })
      .state('cancellationAct.edit', {
        url: '/edit',
        controllerAs: 'cancellationActCtrl',
        templateUrl: 'app/egaisz/cancellation-act/cancellation-act.html',
        controller: 'cancellationActCtrl',
        formName: 'cancellationActCtrl.cancellationActForm'
      })
      .state('cancellationAct.view', {
        url: '/view',
        controllerAs: 'cancellationActCtrl',
        templateUrl: 'app/egaisz/cancellation-act/cancellation-act.html',
        controller: 'cancellationActCtrl'
      })
      .state('stockBalanceEgaisList', {
        url: '/stock-balance-egais-list?parent',
        templateUrl: 'app/egaisz/stock-balance/stock-balance-egais-list.html',
        controller: 'balanceEgaisCtrl',
        controllerAs: 'balanceEgaisCtrl',
        resolve: {
          fsrarCompanies: function (egaiszService) {
            return egaiszService.getUtmsAuto().then(function (data) {
              return data.data.items;
            });
          },
          productClassifier: function (egaiszService) {
            return egaiszService.getProductClassifier().then(function (data) {
              return data.data;
            });
          }
        }
      })
      .state('beginningBalanceEgaisList', {
        url: '/beginning-balance-egais-list?parent',
        templateUrl: 'app/egaisz/beginning-balance-egais-list/beginning-balance-egais-list.html',
        controller: 'beginningBalanceEgaisListCtrl',
        controllerAs: 'beginningBalanceEgaisListCtrl',
        resolve: {
          beginningBalanceStatuses: function (egaiszService) {
            return egaiszService.getBeginningBalanceEgaisStatuses().then(function (data) {
              return data.data.items;
            });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          },
          fsrarCompanies: function (egaiszService) {
            return egaiszService.getUtmsAuto().then(function (data) {
              return data.data.items;
            });
          }
        }
      })
      .state('beginningBalanceEgais', {
        abstract: true,
        url: '/beginning-balance-egais/:id?parent',
        templateUrl: 'app/egaisz/egaisz-abstract.html',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService) {
            return egaiszService.getMetaData('BEGINNING_BALANCE_EGAIS')
              .then(function (data) {
                return data.data;
              });
          },
          beginningBalanceEgais: function (egaiszService, $stateParams) {
            if ($stateParams.id) {
              return egaiszService.getBeginningBalanceEgais($stateParams.id).then(function (data) {
                return data.data;
              });
            }
          }
        }
      })
      .state('beginningBalanceEgais.edit', {
        url: '/edit',
        controllerAs: 'beginningBalanceEgaisCtrl',
        templateUrl: 'app/egaisz/beginning-balance-egais/beginning-balance-egais.html',
        controller: 'beginningBalanceEgaisCtrl',
        neededRole: 'beginning_balance_egais.write',
        formName: 'beginningBalanceEgaisCtrl.beginningBalanceForm'
      })
      .state('beginningBalanceEgais.view', {
        url: '/view',
        controllerAs: 'beginningBalanceEgaisCtrl',
        templateUrl: 'app/egaisz/beginning-balance-egais/beginning-balance-egais.html',
        controller: 'beginningBalanceEgaisCtrl',
        neededRole: 'beginning_balance_egais.read'
      })
      .state('writeReturnList', {
        url: '/write-return-list?parent',
        templateUrl: 'app/egaisz/write-return-list/write-return-list.html',
        controller: 'writeReturnListCtrl',
        controllerAs: 'writeReturnListCtrl',
        resolve: {
          writeReturnStatuses: function (egaiszService) {
            return egaiszService.getWriteReturnStatuses().then(function (data) {
              return data.data.items;
            });
          },
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          }
        }
      })
      .state('writeReturn', {
        abstract: true,
        url: '/write-return/:id?parent',
        templateUrl: 'app/egaisz/egaisz-abstract.html',
        formName: 'writeReturnCtrl.writeReturnForm',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService) {
            return egaiszService.getMetaData('WRITE_RETURN')
              .then(function (data) {
                return data.data;
              });
          },
          writeReturnAct: function (writeReturnService, $stateParams) {
            return writeReturnService.getWriteReturn($stateParams.id).then(function (data) {
              return data.data;
            });
          }
        }
      })
      .state('writeReturn.view', {
        url: '/view',
        controllerAs: 'writeReturnCtrl',
        templateUrl: 'app/egaisz/write-return/write-return.html',
        controller: 'writeReturnCtrl',
        resolve: {
          edit: function () {
            return false;
          }
        }
      })
      /* Подключения к УТМ */
      .state('utmConnections', {
        url: '/utm-connections?parent',
        templateUrl: 'app/settings/utmConnections/utmConnections.html',
        controller: 'utmConnectionsController',
        controllerAs: 'utmConnectionsCtrl'
      })
      .state('transferBetweenRegisterList', {
        url: '/transfer-between-register-list?parent',
        templateUrl: 'app/egaisz/transfer-between-register-list/transfer-between-register-list.html',
        controller: 'transferBetweenRegisterListCtrl',
        controllerAs: 'transferBetweenRegisterListCtrl',
        neededRole: 'transfer_between_register_egais.read',
        resolve: {
          cancellationActsStatuses: function (egaiszService) {
            return egaiszService.getCancellationActsStatuses().then(function (data) {
              return data.data.items;
            });
          },
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          }
        }
      })
      .state('transferBetweenRegister', {
        abstract: true,
        url: '/transfer-between-register/:id?source&parent',
        templateUrl: 'app/egaisz/egaisz-abstract.html',
        neededRole: 'transfer_between_register_egais.read',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService) {
            return egaiszService.getMetaData('TRANSFER_BETWEEN_REGISTER')
              .then(function (data) {
                return data.data;
              });
          },
          transferBetweenRegister: function (transferBetweenRegisterService, $stateParams) {
            if ($stateParams.id || $stateParams.source) {
              return transferBetweenRegisterService.getTransferBetweenRegister($stateParams.id || $stateParams.source).then(function (data) {
                return data.data;
              });
            }
          }
        }
      })
      .state('transferBetweenRegister.new', {
        url: '/new',
        controllerAs: 'transferBetweenRegisterCtrl',
        templateUrl: 'app/egaisz/transfer-between-register/transfer-between-register.html',
        controller: 'transferBetweenRegisterCtrl',
        neededRole: 'transfer_between_register_egais.write',
        formName: 'transferBetweenRegisterCtrl.transferBetweenRegisterForm'
      })
      .state('transferBetweenRegister.edit', {
        url: '/edit',
        controllerAs: 'transferBetweenRegisterCtrl',
        templateUrl: 'app/egaisz/transfer-between-register/transfer-between-register.html',
        controller: 'transferBetweenRegisterCtrl',
        neededRole: 'transfer_between_register_egais.write',
        formName: 'transferBetweenRegisterCtrl.transferBetweenRegisterForm'
      })
      .state('transferBetweenRegister.view', {
        url: '/view',
        controllerAs: 'transferBetweenRegisterCtrl',
        templateUrl: 'app/egaisz/transfer-between-register/transfer-between-register.html',
        controller: 'transferBetweenRegisterCtrl'
      })
      .state('writeUpStatementsList', {
        url: '/write-up-statements-list?parent',
        templateUrl: 'app/egaisz/write-up-statement-list/write-up-statement-list.html',
        controller: 'writeUpStatementListCtrl',
        controllerAs: 'writeUpStatementListCtrl',
        neededRole: 'write_up_statement_egais.read',
        resolve: {
          writeUpStatementStatuses: function (egaiszService) {
            return egaiszService.getWriteUpStatementStatuses().then(function (data) {
              return data.data.items;
            });
          },
          divisions: function (encashmentsService) {
            return encashmentsService.divisions().then(function (data) {
              return data;
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          employees: function (encashmentsService) {
            return encashmentsService.employees().then(function (data) {
              return data;
            });
          }
        }
      })
      .state('writeUpStatement', {
        abstract: true,
        url: '/write-up-statement/:id?source&sourceNumber&sourceDate&register&parent',
        templateUrl: 'app/egaisz/egaisz-abstract.html',
        neededRole: 'write_up_statement_egais.read',
        resolve: {
          // метаинфомрация по типу документа
          meta: function (egaiszService, $stateParams) {
            var register = $stateParams.register || 'REGISTER1';
            return egaiszService.getMetaData('WRITE_UP_STATEMENT_' + register)
              .then(function (data) {
                return data.data;
              });
          },
          writeUpStatement: function (writeUpStatementService, $stateParams) {
            if ($stateParams.id || ($stateParams.source && !$stateParams.sourceNumber)) {
              return writeUpStatementService.getWriteUpStatement($stateParams.id || $stateParams.source).then(function (data) {
                return data.data;
              });
            }
          }
        }
      })
      .state('writeUpStatement.new', {
        url: '/new',
        controllerAs: 'writeUpStatementCtrl',
        templateUrl: 'app/egaisz/write-up-statement/write-up-statement.html',
        controller: 'writeUpStatementCtrl',
        neededRole: 'write_up_statement_egais.write',
        formName: 'writeUpStatementCtrl.writeUpStatementForm'
      })
      .state('writeUpStatement.edit', {
        url: '/edit',
        controllerAs: 'writeUpStatementCtrl',
        templateUrl: 'app/egaisz/write-up-statement/write-up-statement.html',
        controller: 'writeUpStatementCtrl',
        neededRole: 'write_up_statement_egais.write',
        formName: 'writeUpStatementCtrl.writeUpStatementForm'
      })
      .state('writeUpStatement.view', {
        url: '/view',
        controllerAs: 'writeUpStatementCtrl',
        templateUrl: 'app/egaisz/write-up-statement/write-up-statement.html',
        controller: 'writeUpStatementCtrl'
      })
      .state('utmConnection', {
        abstract: true,
        url: '/utm-connection/:id?parent',
        templateUrl: 'app/settings/utmConnections/utmConnection.html',
        neededRole: 'egais_connection.read',
        resolve: {
          connection: function (utmConnectionsService, $stateParams) {
            return utmConnectionsService.connection($stateParams.id)
              .then(function (data) {
                return data.data;
              });
          }
        }
      })
      .state('utmConnection.edit', {
        url: '/edit/',
        controller: 'utmConnectionController',
        templateUrl: 'app/settings/utmConnections/crudUtmConnection/utmConnection.html',
        controllerAs: 'utmConnectionCtrl',
        neededRole: 'egais_connection.write',
        isThirdLevel: true
      })
      .state('utmConnection.view', {
        url: '/view/',
        controller: 'utmConnectionController',
        templateUrl: 'app/settings/utmConnections/crudUtmConnection/utmConnection.html',
        controllerAs: 'utmConnectionCtrl',
        neededRole: 'egais_connection.read',
        isThirdLevel: true
      })
      .state('beneficiaries', {
        url: '/beneficiaries?parent',
        templateUrl: 'app/settings/beneficiary/beneficiaries.html',
        controller: 'beneficiariesController',
        controllerAs: 'vm',
        neededRole: 'beneficiary.read',
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data.map(function (value) {
                return {
                  label: value.name,
                  value: value.id
                }
              });
            });
          }
        }
      })
      .state('beneficiary', {
        abstract: true,
        url: '/beneficiary/:id?parent',
        controller: 'beneficiaryCrudController',
        controllerAs: 'vm',
        templateUrl: 'app/settings/beneficiary/crud/beneficiary.html',
        neededRole: 'beneficiary.read',
        resolve: {
          beneficiary: function (beneficiaryService, $stateParams) {
            if (!$stateParams.id) {
              return null;
            }
            return beneficiaryService.getBeneficiary($stateParams.id).then(function (res) {
              return res.data
            });
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies()
              .then(function (data) {
                return data.map(function (value) {
                  return {
                    id: value.id,
                    name: value.name
                  }
                });
              });
          }
        }
      })
      .state('beneficiary.new', {
        url: '/new',
        templateUrl: 'app/settings/beneficiary/crud/beneficiary-crud.html',
        neededRole: 'beneficiary.write',
        isThirdLevel: true
      })
      .state('beneficiary.edit', {
        url: '/edit',
        templateUrl: 'app/settings/beneficiary/crud/beneficiary-crud.html',
        neededRole: 'beneficiary.write',
        isThirdLevel: true
      })
      .state('beneficiary.view', {
        url: '/view',
        templateUrl: 'app/settings/beneficiary/crud/beneficiary-crud.html',
        neededRole: 'beneficiary.read',
        isThirdLevel: true
      })
      .state('bankProductRequests', {
        url: '/bank-product-requests?parent',
        controller: 'bankProductRequestsCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/settings/bank-product-request/list/bank-product-requests.html',
        neededRole: 'bank_product_request.write',
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies()
              .then(function (data) {
                return data.map(function (company) {
                  return {
                    value: company.id,
                    label: company.name
                  }
                });
              });
          },
          bankProducts: function (bankProductRequestService) {
            return bankProductRequestService.getBankProducts()
              .then(function (res) {
                return res.data.map(function (bankProduct) {
                  return {
                    value: bankProduct.id,
                    label: bankProduct.name
                  }
                })
              })
          }
        }
      })
      .state('bankProductRequest', {
        url: '/bank-product-request?id?parent',
        controller: 'bankProductRequestCtrl',
        controllerAs: 'vm',
        templateUrl: 'app/settings/bank-product-request/bank-product-request-base.html',
        neededRole: 'bank_product_request.write',
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies()
              .then(function (data) {
                return data.map(function (value) {
                  return {
                    id: value.id,
                    name: value.name
                  }
                });
              });
          },
          bankProductRequest: function (bankProductRequestService, $stateParams) {
            if (!$stateParams.id) {
              return null;
            }
            return bankProductRequestService.getBankProductRequest($stateParams.id)
              .then(function (res) {
                return res.data;
              })
          },
          bankProductRequests: function (bankProductRequestService) {
            return bankProductRequestService.getBankProductRequestList(null, { limit: 100 })
              .then(function (res) {
                return res.data.items;
              })
          },
          bankProducts: function (bankProductRequestService) {
            return bankProductRequestService.getBankProducts()
              .then(function (res) {
                return res.data.sort(function (a, b) {
                  if (a.name.toLowerCase() < b.name.toLowerCase()) {
                    return -1;
                  }
                  if (a.name.toLowerCase() > b.name.toLowerCase()) {
                    return 1;
                  }
                  return 0;
                });
              })
          }
        },
      })
      .state('markedProductSettings', {
        url: '/marked-product-settings?parent',
        templateUrl: 'app/settings/marked-product-settings/marked-product-settings.html',
        controller: 'markedProductSettings',
        controllerAs: 'vm',
        resolve: {
          settings: function (catalogService) {
            return catalogService.getMarksSettings()
              .then(function (res) {
                return res.data
              })
          },
          productGroups: function (categoryService) {
            return categoryService.getProductGroup()
              .then(function (res) {
                return res;
              })
          }
        }
      })
      .state('partners', {
        url: '/partners?parent',
        templateUrl: 'app/partnership/partners/partners.html',
        controller: 'partners',
        controllerAs: 'partners'
      })
      .state('partner', {
        abstract: true,
        url: '/partner/:id?parent',
        controller: 'partnerController',
        controllerAs: 'partnerController',
        templateUrl: 'app/partnership/partners/crud/partner.html',
        resolve: {
          partner: function (partnersService, $stateParams) {
            if (!$stateParams.id) {
              return null;
            }
            return partnersService.getClientData($stateParams.id).then(function (res) {
              return res.data
            });
          }
        }
      })
      .state('partner.view', {
        url: '/view',
        templateUrl: 'app/partnership/partners/crud/partner.html',
        isThirdLevel: true
      })
      .state('messages', {
        url: '/messages?message_id&parent',
        templateUrl: 'app/messages/messages-template.html',
        controller: 'messagesController',
        controllerAs: 'messagesCtrl',
        resolve: {
          surveys: function (surveyService) {
            return surveyService.getUserSurvey().then(function (data) {
              return data.data;
            })
          }
        }
      })
      .state('cart', {
        url: '/cart',
        templateUrl: 'app/cart/cart.html',
        controller: 'cartController',
        controllerAs: 'cartCtrl',
        resolve: {
          cartData: function (cartService) {
            return cartService.getCartData({ limit: 10 }).then(function (data) {
              return data.data;
            });
          }
        }
      })
      .state('partnerBonuses', {
        url: '/partner-bonus-transactions?type&parent',
        templateUrl: 'app/partnership/partner-bonuses/partner-bonuses.html',
        controller: 'partnerBonusesController',
        controllerAs: 'partnerBonusesCtrl',
        resolve: {
          clients: function (partnersService) {
            return partnersService.getСlients().then(function (res) {
              return res.data.items;
            });
          },
          objectCodes: function (partnersService) {
            return partnersService.getObjectCodes().then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('closePeriod', {
        url: '/close-period?parent',
        templateUrl: 'app/partnership/close-period/close-period.html',
        controller: 'closePeriodController',
        controllerAs: 'closePeriodCtrl',
        resolve: {
          clients: function (partnersService) {
            return partnersService.getСlients().then(function (res) {
              return res.data.items;
            });
          },
          objectCodes: function (partnersService) {
            return partnersService.getObjectCodes().then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('partnerSettings', {
        url: '/partner-settings?parent',
        templateUrl: 'app/partnership/partnership-settings/partner-settings.html',
        controller: 'partnerSettingsCtrl',
        controllerAs: 'partnerSettingsCtrl',
        resolve: {
          objectCodes: function (partnersService) {
            return partnersService.getObjectCodes().then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('salesTotalsPrint', {
        url: '/sales-totals-print?parent',
        templateUrl: 'app/print/sales-totals-print/sales-totals-print.html',
        controller: 'salesTotalsPrint',
        controllerAs: 'salesTotalsPrintCtrl',
        resolve: {
          allDimensions: function ($http) {
            return $http.get('assets/api/allDimensions.json').then(function (res) {
              return res.data.items;
            });
          },
          salesTotalsPrintData: function ($http) {
            return $http.get('assets/api/salesTotalsPrintData.json').then(function (res) {
              return res.data;
            });
          }
        }
      })
      .state('paidServices', {
        url: '/paid-services?tabName',
        templateUrl: 'app/settings/paid-services/paid-services.html',
        controller: 'paidServicesCtrl',
        controllerAs: 'paidServicesCtrl',
        neededRole: 'paid_service.read',
        resolve: {
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          }
        }
      })
      .state('paidService', {
        url: '/paid-service/:id?tarif&subscription',
        controller: 'paidServiceCtrl',
        controllerAs: 'paidServiceCtrl',
        templateUrl: 'app/settings/paid-services/crud/paid-service.html',
        neededRole: 'paid_service.read',
        resolve: {
          serviceInfo: function (paidServicesService, $stateParams) {
            if (!$stateParams.id) {
              return null;
            }
            if ($stateParams.subscription) {
              return paidServicesService.getPaidServiceSubscription($stateParams.id).then(function (res) {
                return res.data
              });
            } else {
              return paidServicesService.getPaidService($stateParams.id).then(function (res) {
                return res.data
              });
            }
          },
          companies: function (encashmentsService) {
            return encashmentsService.companies().then(function (data) {
              return data;
            });
          },
          divisions: function (companyService) {
            return companyService.getDivisionsExtended().then(function (data) {
              return data.data.items;
            });
          }
        }
      });


    $urlRouterProvider.when('', '/');
    $urlRouterProvider.otherwise('404');
  }
})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('frontend')
    .constant('malarkey', malarkey)
    .constant('moment', moment)
    .constant('POLLING_SURVEY_MESSAGE_RATE', 120) // промежуток поллинга запросов для получения информации об активныых сообщениях
    .constant('TIMEOUT_THROTTLE', 300) // время ожидания для схлапывания запросов
    .constant('OPTIONS_LENGTH', 5) // максимальное количество пунктов в выпадающем списке при поиске
    .constant('PHONE_ATTEMPTS', 3) // количество попыток для подтверждения телефона
    .constant('MAX_UPLOAD_FILE_SIZE', 5242880) // максимальный размер загружаемого файла (5Mb)
    .constant('NOT_FOUND_STRING', 'Значений не найдено') // Строка ошибки для выпадалки, если значения не найдены
    .constant('uiVersion', {
      version: '1.20.2'.startsWith('@@') ? 'dev': '1.20.2',
      reasonOfUpdate: 'regular'.startsWith('@@') ? 'dev': 'regular'
    })
    .constant('API_URL','api'.startsWith('@@') ? 'http://localhost:8080/recs/api' : 'api') // TODO:
  // пока не придумал как настроить фильтрацию при serve

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .config(config)
    .config(['uiMask.ConfigProvider', function(uiMaskConfigProvider) {
      uiMaskConfigProvider.maskDefinitions({'A': /[a-zA-Zа-яёА-ЯЁ]/, '*': /[a-zA-Z0-9а-яёА-ЯЁ]/});
    }]);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider, $uibModalProvider, $urlRouterProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
    $httpProvider.interceptors.push('authInterceptor');
    $httpProvider.interceptors.push('spinnerInterceptor');
    $uibModalProvider.options.appendTo = angular.element('.modal-level');
    $urlRouterProvider.deferIntercept();

  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('appController', appController);

  /** @ngInject */
  function appController($scope,
                         auth,
                         $state,
                         modalMessageSrv,
                         $rootScope,
                         $window,
                         headerExceptions,
                         requestStatus,
                         helpService,
                         ngProgressFactory,
                         $templateCache,
                         $timeout,
                         $interval,
                         OPTIONS_LENGTH,
                         $uibModalStack,
                         NOT_FOUND_STRING,
                         catalogService,
                         cartService,
                         partnersService,
                         authToken) {
    var main = this;
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isChrome = !!$window.chrome && !$window.opr;
    var stop; // для интервала проверки связи с бэком
    $rootScope.progressbar = ngProgressFactory.createInstance();
    $rootScope.progressbar.setHeight('4px');
    $rootScope.progressbar.setColor('#f8e4ab');
    $rootScope.progressbar.start();
    $rootScope.progressbar.set(50);

    // флаг, определяющий ie, edge и стандартный браузер андроида
    $rootScope.isWrongBrowsers = !!(navigator.userAgent.indexOf("MSIE ") + 1) || !!(navigator.userAgent.indexOf('Trident/') + 1) || !!(navigator.userAgent.indexOf('System/Android') + 1);
    $scope.showHeader = false;
    $scope.url = $state.current.url;
    $rootScope.showSpinner = true;
    $rootScope.hasAppError = false;
    $rootScope.controlSettings = {};
    $rootScope.controlSettings.OPTION_DEFAULT_LENGTH = OPTIONS_LENGTH;
    $rootScope.controlSettings.NOT_FOUND_STRING = NOT_FOUND_STRING;

    $rootScope.completeProgressBar = function () {
      $rootScope.showSpinner = false;
      if ($rootScope.progressbar.count) {
        $rootScope.progressbar.set(80);
      }
      $timeout(function () {
        if ($rootScope.progressbar.count) {
          $rootScope.progressbar.set(100);
          $rootScope.progressbar.complete();
        }
      }, 500); // для лучшей визуализации загрузки странички
    }

    // проверка статуса попапа (открыт или нет)
    $rootScope.checkOpenModal = function(){
      return !!$uibModalStack.getTop();
    }

    /* Обработчик ошибок при резолве роутинга */
    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      if ($rootScope.mobilePage) return;
      modalMessageSrv.showModal({
        message: 'При переходе на страницу произошла ошибка',
        submessage: error.statusText
      }).finally(function () {
          if (fromState && !fromState.abstract) {
            // возврат на предыдущее состояние
            $state.go(fromState, fromParams);
          } else {
            // при открытии в новой вкладке нет предыдущего состояния
            $state.go("indicators");
          }
      });
    });

    $rootScope.$on('$stateChangePrevented', function() {
      $rootScope.completeProgressBar($rootScope.progressbar);
    });

    $rootScope.$on('$stateChangeSuccess', function() {
      $scope.url = $state.current.url;
      $window.scrollTo(0, 0);
      $rootScope.mobilePage = $state.current.isMobile;
      $rootScope.desktopPage = !$state.current.isMobile;
      $scope.showHeader = headerExceptions.indexOf($state.current.name) < 0 && ($rootScope.user || $rootScope.permission);
      requestStatus.dismissAll();
      $rootScope.stateChangeStart = false;
      getAlcoholSettings();
      // Закрытие всех попапов при успешном переходе
      $uibModalStack.dismissAll('stateChange');
    });

    function prevent(event) {
      if (!event.defaultPrevented) {
        event.preventDefault();
        $rootScope.completeProgressBar($rootScope.progressbar);
      }
    }
    function fromletter(toState) {
      return toState.name === 'confirmemail' || toState.name === 'confirmnewemail' || toState.name === 'recoverpass' || toState.name === 'setpass'
    }

    function cases(event, toState, fromState, toParams) {
      if (!$rootScope.permission && (fromState.url === '^' && toState.name !== 'login' && !toState.isMobile) && !fromletter(toState)) {
        if (!event.defaultPrevented) {
          event.preventDefault();
          $rootScope.completeProgressBar($rootScope.progressbar);
        }
        $state.go('login', {forward: {stateName: toState.name || 'home', stateParams: toParams || {}} });
      }

    }

    // обновление сообщений
    $scope.$on('messageUpdated', function() {
      $scope.$broadcast('updateMessages');
    });

    $rootScope.$on('$viewContentLoaded', function() {
      $rootScope.completeProgressBar($rootScope.progressbar);
    });

    function isGoingHome(toState) {
      return (toState.name === 'home' || toState.name === 'business' || toState.name === 'indicators')
    }

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      $rootScope.blockAnimation = !((toState.name == 'login' && fromState.name == 'resetpass') || 
                                    (toState.name == 'resetpass' && fromState.name == 'login'));

      // логин для мобильных страничек
      if (toState.isMobile && toState.name !== 'registerMobile' && toParams.session_id && 
          fromParams.session_id !== toParams.session_id) {
        $rootScope.showLoader = true;
        $rootScope.toLogin = false;
        authToken.setToken(toParams.session_id);
        auth.ensureTypes();
        auth.ensurePermissions();
      } else {
        $rootScope.stateChangeStart = true;
        $rootScope.toState = toState;
        if (!fromletter(toState) && !toState.isMobile && toState.name !== 'deadend' && toState.name !== 'resetpass' && toState.name !== 'passwordChangeRequested' && toState.name !== 'register' && toState.name !== 'registerPartner' && toState.name !== 'registerMobile' && toState.name !== 'contacts') {
          if (toState.name !== 'login' && toState.name !== 'registerPartner?promo_code') {
            if ($rootScope.toLogin) { // редирект на логин если у пользователь не связан с сессией
              prevent(event);
              $rootScope.toLogin = false;
              $rootScope.toLoginDone = true;
              if (!isGoingHome(toState)) {
                $state.go('login', {
                  forward: {
                    stateName: toState.name || 'home',
                    stateParams: toParams || {}
                  }
                });
              } else {
                $state.go('login',
                  {forward: {stateName: 'home', stateParams: {}}});
              }
            }

            //TODO вернуть когда проставят экшены
            if (toState.neededRole === 'documentType') {
              toState.neededRole = toParams.type.toLowerCase() + '.read'
            }

            if (toState.neededRole && !$rootScope.hasRole(toState.neededRole)) {//редирект на тупиковую страницу, если пользователь запрашивает ее на прямую
              prevent(event);
              if (!$rootScope.user || !$rootScope.permission) {
                $state.go('login', {
                  forward: {
                    stateName: toState.name || 'home',
                    stateParams: toParams || {}
                  }
                });
              } else {
                $state.go('401');
              }
            }

          } else {
            if (($rootScope.user || $rootScope.permission) && !!auth.isAuthenticated() ) { // пользователь хочет на страницу логина , но он уже вошел
              prevent(event);
              if($state.current.name == "setpass"){  // для перевода на страничку профиля, если пользователь первый раз зашел
                $state.go('editProfile');
              }else if($rootScope.permission.roles.length == 1 && $rootScope.permission.roles[0] == 'cashier'){
                $state.go('cashregshifts');
              }else{
                $state.go($rootScope.hasRole('report.sale_totals') ?
                  'indicators' :
                  'business');
              }
            }
          }
        }

        if (toState.name === 'login' && fromState === 'login') {
          prevent(event);
        }
        
        // cases(event, toState, fromState, toParams);
      }
    });

    $rootScope.$on('$stateChangeError', function() {
      if ($rootScope.mobilePage) return;
      
      if ($rootScope.currentError && $rootScope.currentError.status === 500) {
        $state.go('500');
      } else if ($rootScope.currentError && $rootScope.currentError.status === 404) {
        $state.go('404');
      } else if ($rootScope.currentError && $rootScope.currentError.status === 403) {
        $state.go('401');
      }
      
      $rootScope.currentError = null;
      $rootScope.stateChangeStart = false;
      $rootScope.completeProgressBar($rootScope.progressbar);
    });

    $rootScope.hasRole = function(neededRole) {
      if ($rootScope.permission) {
        if (angular.isArray(neededRole)) {
          return neededRole.every(function(elem) {
            return $rootScope.permission.actions.indexOf(elem) > -1
          })
        } else {
          return ~$rootScope.permission.actions.indexOf(neededRole)
        }
      } else {
        return false
      }
    };

    $rootScope.hasAnyRole = function(neededRole) {
      if ($rootScope.permission) {
        if (angular.isArray(neededRole)) {
          return neededRole.some(function(elem) {
            return $rootScope.permission.actions.indexOf(elem) > -1
          })
        } else {
          return ~$rootScope.permission.actions.indexOf(neededRole)
        }
      } else {
        return false
      }
    };

    $rootScope.getRole = function(neededRole) {
      if ($rootScope.permission) {
        if (angular.isArray(neededRole)) {
          return neededRole.some(function(elem) {
            return $rootScope.permission.roles.indexOf(elem) > -1
          })
        } else {
          return ~$rootScope.permission.roles.indexOf(neededRole)
        }
      } else {
        return;
      }
    };

    $rootScope.hasAnyRoleEditButton = function() {
      var neededRole;
      if ($rootScope.permission) {
        if (/[A-Z]/.test($state.current.name)) {
          neededRole = helpService.toSnakeCase($state.current.name.split('.')[0])+ '.write';
        } else {
          neededRole = $state.current.name.split('.')[0] + '.write';
        }
        if (neededRole === 'contragent.write') {
          neededRole = 'counterparty.write'
        } else if (neededRole === 'employee.write') {
          neededRole = 'user.write'
        } else if (neededRole === 'category.write') {
          neededRole = 'catalog_category.write'
        } else if (neededRole === 'price_tags_settings.write') {
          neededRole = 'price_tag_settings.write'
        } else if (neededRole === 'attr_settings.write') {
          neededRole = 'catalog_settings.write'
        } else if (neededRole === 'discount.write') {
          neededRole = 'retail_discount.write'
        } else if (neededRole === 'price_column.write') {
          neededRole = 'price_list.write'
        } else if (neededRole === 'utm_connection.write') {
          neededRole = 'egais_connection.write'
        }
        return $rootScope.permission.actions.indexOf(neededRole) > -1
      } else {
        return false
      }
    };


    $rootScope.findDocumentType = function(type) {
      if (type) {
        var type = _.find(angular.copy($rootScope.documentTypes), function(item) {
          return item.code === type
        });
        if (type) {
          return type
        }
      }
    };

    $rootScope.findDocumentTypeByPurpose = function(typeRaw) {
      if (typeRaw) {
        var type = _.find(angular.copy($rootScope.documentTypes), function(item) {
          return _.find(item.purposes, function(purpose) {
            return purpose.code === typeRaw;
          });
        });
        if (type) {
          return type;
        }
      }
    };

    /**
     * Метод возвращает карту для определения типа по назначению документа
     *
     * @return {{}}
     */
    $rootScope.getAllPurposesWithType = function() {
      var purposesWithType = {};
      angular.forEach($rootScope.documentTypes, function(item) {
        if (item.purposes) {
          angular.forEach(item.purposes, function(purpose) {
            purposesWithType[purpose] = item;
          })
        }
      });
      return purposesWithType;
    };

    // TODO: это нужно рефакторить
    $rootScope.getAllPurposes = function() {
      var purposes = [];
      angular.forEach(angular.copy($rootScope.documentTypes), function(item) {
        if (item.purposes) {
          angular.forEach(item.purposes, function(purpose) {
            purposes.push(purpose);
          })
        }
      });
      return _.sortBy(purposes, 'purpose_name');
    };

    $rootScope.getFilteredPurposes = function(filter) {
      var purposes = angular.copy($rootScope.getAllPurposes());
      return purposes.filter(function(item) {
        if (angular.isArray(filter)) {
          return ~filter.indexOf(item.code)
        } else {
          return (item.code) === filter
        }
      })
    };

    $rootScope.documentStatuses = [
      {
        value: 'IN_PROGRESS', // перед отправкой заменяется на ['IN_PROCESS', 'IN_ROLLBACK'] или на ['IN_PROCESS'] в зависимости от запроса
        label: 'В обработке'
      },
      {
        value: 'PROCESSED',
        label: 'Проведенный'
      },
      {
        value: 'DRAFT',
        label: 'Черновик'
      }
    ];

    // получение подразделений к которым есть доступ
    $rootScope.availableDivisions = function(divisions){
      var availableDivisions = [];
      if($rootScope.permission.data_access_rules.has_access){
        availableDivisions = divisions;
      }else{
        angular.forEach(divisions, function (division) {
          if($rootScope.permission.divisionAccessMap[division.id]){
            availableDivisions.push(division);
          }
        });
      }
      return availableDivisions;
    };

    function getAlcoholSettings(required) {
      if((required || $rootScope.alcohol_products === undefined) && $rootScope.user){
        // получение необходимости показывать пункты меню, связанные с флагом в настройках алкогольной продукции
        catalogService.getAlcoholSettings().then(function (data) {
          $rootScope.alcohol_products = data.data.alcohol_products;
        });
      }
    }

    // Отправка глобального события успешного логина нового пользователя
    // событие успешного логина, в данном случае, необходимо для установки флага возможности продавать алкогольную продукцию
    $rootScope.$on('login-success', function() {
      getAlcoholSettings(true);
      requestStatus.dismissAll();
      cartService.getCartCount().then(function (data) {
        $rootScope.cartCount = data.data.item_count;
      });
      if ($rootScope.hasRole('bonuses.read')) {
        partnersService.getBonuses().then(function (res) {
          $rootScope.bonusesData = {
            accrued_bonuses_amount: res.data.accrued_bonuses_amount,
            payable_bonuses_amount: res.data.payable_bonuses_amount,
            paid_bonuses_amount: res.data.paid_bonuses_amount
          };
        }, function () {
          requestStatus.error('Во время получения информации о бонусах произошла ошибка.');
        });
      }
    });

    // Отправка глобального события завершения сессии пользователя.
    // событие разлогина, в данном случае, сбрасывается переменнаяс флагом настроек алкогольной продукции
    $rootScope.$on('logout', function() {
      $rootScope.alcohol_products = undefined;
      requestStatus.dismissAll();
    });

    // устранение бага с лишним фокусом на caret в ui-select
    $templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" tabindex=\"-1\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");



    // Логика для показа ошибки прерывания связи от бэка
    $rootScope.checkConnection = function(state){
      if ($rootScope.hasAppError && !stop) {
        // проверка связи каждые 30 сек
        stop = $interval(function() {
          auth.health().then(function(res){
            $rootScope.hasAppError = false;
            $interval.cancel(stop);
            stop = undefined;

            // необходима перезагрузка
            if ($rootScope.reloadAfterConnectionUp) {
              $state.reload();
            }
          }, function(e){
            console.log("no connect")
          });
        }, 30000);
      }
    };

    // очиста интервала если контроллер прервался
    main.$onDestroy = function() {
      if (stop) {
        $interval.cancel(stop);
        stop = undefined;
      }
    };


  }
})();

angular.module("frontend").run(["$templateCache", function($templateCache) {$templateCache.put("app/all-documents/all-document.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Деньги</a></li><li><a ui-sref=allDocuments>Все документы</a></li></ul><div ui-view></div>");
$templateCache.put("app/all-documents/all-documents.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Деньги</a></li></ul><grid-wide url=vm.url page=vm.page header=vm.header no-data-str=vm.noDataStr filters-required=true row-route-func=vm.rowRouteFunc sort=vm.sort limit=vm.limit base-columns-count=3 default-position=4 column-defs=vm.columnDefs using-service=vm.usingService filter-meta=vm.filterMeta config=vm.gridConfig currency=vm.currency stop-editing=vm.docSettings.domain_documents_settings.stop_editing></grid-wide></div>");
$templateCache.put("app/auth/auth.html","<div class=container><div class=row><div class=span12><div id=loginModal><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=modal aria-hidden=true>×</button><h3>Have an Account?</h3></div><div class=modal-body><div class=well><ul class=\"nav nav-tabs\"><li class=active><a href=#login data-toggle=tab>Login</a></li><li><a href=#create data-toggle=tab>Create Account</a></li></ul><div id=myTabContent class=tab-content><div class=\"tab-pane active in\" id=login><form class=form-horizontal action=\"\" method=POST><fieldset><div id=legend><legend>Login</legend></div><div class=control-group><!-- Username --><label class=control-label for=username>Username</label><div class=controls><input type=text id=username name=username placeholder=\"\" class=input-xlarge></div></div><div class=control-group><!-- Password--><label class=control-label for=password>Password</label><div class=controls><input type=password id=password name=password placeholder=\"\" class=input-xlarge></div></div><div class=control-group><!-- Button --><div class=controls><button class=\"btn btn-success\">Login</button></div></div></fieldset></form></div><div class=\"tab-pane fade\" id=create><form id=tab><label>Username</label><input type=text class=input-xlarge><label>First Name</label><input type=text class=input-xlarge><label>Last Name</label><input type=text class=input-xlarge><label>Email</label><input type=text class=input-xlarge><label>Address</label><textarea value=Smith rows=3 class=input-xlarge>\n                        </textarea><div><button class=\"btn btn-primary\">Create Account</button></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/auth/authPopup.html","<!--div class=\"close-popup\" ng-click=\"close()\"></div--><div class=\"popup-form login\" ng-include=\"\'app/auth/login/login.html\'\" ng-class=\"(openPopup == \'login\')? \'show-popup\' : \'\'\"></div>");
$templateCache.put("app/auth/logoutPopup.html","<div id=logout-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Подтверждение</h3></div><div class=container>Вы действительно хотите выйти из системы?</div><div class=modal-footer><button class=btn ng-click=close()>Нет</button> <button class=\"btn btn-primary\" ng-click=logout()>Да</button></div></div>");
$templateCache.put("app/cart/cart.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Корзина</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset clearfix\"><div class=clearfix><h1>Корзина</h1></div><div ng-include=\"\'app/cart/includes/buttons.html\'\"></div></div><form name=cartCtrl.cartForm class=cart-grid ng-class=\"{\'no-data\': !cartCtrl.values.length}\"><grid-custom columns=cartCtrl.columns data=cartCtrl.values page-callback=cartCtrl.getCartItems is-show-settings=false show-checkbox=false options=cartCtrl.gridOptions min-height=100 is-full-width=true allow-selected=true totals-data=cartCtrl.totalsData></grid-custom><div class=table-footer><paging page-info=cartCtrl.paging callback=cartCtrl.getCartItems></paging></div><div class=no-data-text ng-if=!cartCtrl.values.length>Нет данных</div></form><script type=text/ng-template id=cartHeaderCellTemplate.html><div class=\"default-header-cell\" ng-class=\"{\'word-break text-right\': gridCustomHeaderCtrl.column.field == \'price\'}\">\n    <span class=\"default-header-text\">\n      <span ng-bind=\"::gridCustomHeaderCtrl.column.name\"></span>\n    </span>\n  </div></script><script type=text/ng-template id=cartCatalogItemTemplate.html><div class=\"cell-data single-line\">\n    <div class=\"view-entity-control text-left catalog-item-cell\" style=\"height: 42px;\">\n      <span class=\"catalog-item-name\"\n            tooltip-placement=\"bottom-left\" uib-tooltip=\"{{::value[column.field].name}}\"\n            ng-bind=\"::value[column.field].name\"></span>\n      <span class=\"catalog-item-derivative\"\n            ng-if=\"value.derivative\"\n            tooltip-placement=\"bottom-left\" uib-tooltip=\"{{::value.derivative.name}}\"\n            ng-bind=\"::value.derivative.code + \' \' + (value.derivative.name || \'\')\"></span>\n    </div>\n  </div></script><script type=text/ng-template id=cartQuantityTemplate.html><div class=\"cell-data single-line\">\n    <input class=\"form-control slim-control\"\n         float-input\n         float-fixed=\"2\"\n         max-int-length=\"9\"\n         empty-values=\"::true\"\n         float-step=\"0.01\"\n         max-after-comma=\"3\"\n         selection-on-focus=\"[\'1\', 1]\"\n         name=\"qty{{cartCtrl.values.indexOf(value) + 1}}\"\n         ng-required=\"true\"\n         no-empty=\"true\"\n         ng-model=\"value[column.field]\"\n         style=\"margin-top: 3px;\"\n         ng-blur=\"cartCtrl.updateLine(value)\">\n  </div></script><script type=text/ng-template id=cartNameTemplate.html><div class=\"cell-data single-line\" tooltip-placement=\"bottom-right\" uib-tooltip=\"{{value[column.field].name}}\">\n    <span ng-bind=\"value[column.field].name\"></span>\n  </div></script><script type=text/ng-template id=cartPriceTemplate.html><div class=\"cell-data single-line\">\n    <input class=\"form-control currency-input slim-control\"\n           input-price\n           currency-input=\"true\"\n           currency-icon=\"{{value.currency.symbol || $root.homeCurrency.currency.symbol || $root.homeCurrency.currency.char_iso_code}}\"\n           ng-model=\"value[column.field]\"\n           name=\"price{{cartCtrl.values.indexOf(value) + 1}}\"\n           style=\"margin-top: 3px;\"\n           ng-blur=\"cartCtrl.updateLine(value)\">\n  </div></script><script type=text/ng-template id=cartTaxIncludedTemplate.html><div class=\"cell-data single-line\">\n    <span ng-bind=\"(value[column.field])? \'Да\' : \'Нет\'\"></span>\n  </div></script><script type=text/ng-template id=cartPriceTotalStrTemplate.html><span class=\"pull-left\">Итого</span></script><script type=text/ng-template id=cartPriceTotalTemplate.html><span ng-bind=\"(cartCtrl.totalsData.total_home_amount / 100) | priceFormatter \"></span></script><script type=text/ng-template id=removeLineTemplate.html><span class=\"glyphicon glyphicon-trash\" ng-click=\"cartCtrl.removeLine(value);\" tooltip-placement=\"bottom-right\" uib-tooltip=\"Удалить\"></span></script>");
$templateCache.put("app/catalog/catalog.html","<div ng-include=\"\'app/catalog/tree-cell-templates.html\'\"></div><div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-when=retail><a>Розница</a></li><li ng-switch-when=storehouse><a>Склад</a></li><li ng-switch-default><a>Розница</a></li></ul><h1>Товары и услуги</h1><div class=\"grid-buttons pull-left\"><a ng-if=\"$root.hasRole(\'catalog_category.write\')\" ui-sref=\"category.new({parentId: vm.selectedNode.id, parent: $state.params.parent})\" class=btn ng-class=\"(!vm.hasCategory)? \'btn-primary\' : \'\'\"><span class=\"btn-ico btn-plus\" ng-class=\"(!vm.hasCategory)? \'\' : \'btn-plus-dark\'\"></span> категория</a> <span ng-if=\"$root.hasRole(\'catalog_item.write\') && !vm.showSearch && vm.showCreateButtons\"><a ui-sref=\"catalogSkus.search({categoryId: vm.selectedNode.id, parent: $state.params.parent})\" class=btn><span class=\"btn-ico btn-plus btn-plus-dark\"></span> товар</a> <a ui-sref=\"catalogServices.search({categoryId: vm.selectedNode.id, parent: $state.params.parent})\" class=btn><span class=\"btn-ico btn-plus btn-plus-dark\"></span> услуга</a></span></div><div class=pull-right ng-if=\"$root.hasRole(\'catalog_settings.write\')\"><a ui-sref=\"attrSettings({parent: $state.params.parent})\" class=\"btn gear-button only-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Настроить каталог товаров и услуг\" style=\"padding-top: 7px;\"><span class=\"btn-ico btn-gear\" style=\"width: 24px; height: 26px;\"></span></a></div></div><div class=clear></div><div data-footer-absolute top-shift=348 top-flag=headerButtonNotInTop class=header-absolute ng-class=\"{hide: !headerButtonNotInTop}\" ng-show=!vm.showSearch><div ng-include=\"\'app/catalog/includes/search-catalog.html\'\"></div><div ng-include=\"\'app/catalog/includes/tree-head.html\'\"></div></div><div ng-include=\"\'app/catalog/includes/search-catalog.html\'\"></div><div class=catalog-content ng-if=!vm.hasCategory><a href=\"\" class=pull-right ng-if=vm.hasCategory>Выбрать несколько</a><div class=clear></div><div class=\"no-content text-center\" ng-if=!vm.hasCategory><p>У вас пока не&nbsp;добавлено ни&nbsp;одной категории чтобы иметь<br>возможность добавлять товар. Создайте первую и начните<br>формировать свою базу товаров и услуг</p><div class=arrow></div></div></div><div ng-show=vm.hasCategory ng-init=vm.openTreeWithParams() style=\"overflow: hidden; position: relative;\" class=catalog-tree-wrap><div ng-hide=vm.showSearch><div ng-include=\"\'app/catalog/includes/tree-head.html\'\"></div><div class=full-width><!--grid-loader class=\"catalog-spinner\" show=\"vm.showLoader\"></grid-loader--><catalog-tree min-height=400 root-visible=false block-choice-hoisting=true load-callback=vm.onTreeLoaded on-collapse-node=vm.onCollapseNode on-expand-node=vm.onExpandNode expand-node=vm.expand controls-property=type controls-array=vm.treeControls root=vm.root columns=vm.treeColumns show-checkbox=true selected-callback=vm.selectNode></catalog-tree></div></div><div ng-if=vm.showSearch><grid-loader class=catalog-spinner ng-show=vm.showLoader></grid-loader><grid-search ng-show=vm.searchResult.length results=vm.searchResult total=vm.searchResultTotal expand-callback=vm.expandTreePath></grid-search><div class=\"filter-not-found major-font\" ng-if=!vm.searchResult.length style=\"position: relative; margin: 0;\"><div class=big-danger-info-ico></div><div class=big-danger-info><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div></div><div class=table-footer ng-if=vm.searchResult.length><div class=pagination-wrapper><paging page-info=vm.searchPaging callback=vm.search></div></div></div></div>");
$templateCache.put("app/catalog/tree-cell-templates.html","<script type=text/ng-template id=statusItemTemplate.html><div style=\"border-left: 1px solid rgba(151, 151, 151, 0.17); padding-left: 10px\">\n    <small ng-hide=\"::value.status == \'CONFIRMED\'\" class=\"text-muted\" ng-bind=\"::value.status | skuStatus\"></small>\n  </div></script>");
$templateCache.put("app/comparative/comparative-template.html","<script type=text/ng-template id=comparativeCategoryCellTemplate.html><div class=\"single-line row-name\"\n       data-ng-click=\"(value.parent && comparativeCtrl.up(value)) || !comparativeCtrl.loading  && value.type == \'CATEGORY\' && comparativeCtrl.expandCategory(value); value.$$startLoad = true;\">\n    <span>\n      <span ng-show=\"::value.type == \'CATEGORY\'\"\n            class=\"catalog-folder\"></span>\n      <span ng-class=\"{\'text-muted\': comparativeCtrl.loading}\" class=\"default-cell-text\" ng-show=\"!value.parent\">\n        <cell-with-tooltip text=\"::value.item.name\"/>\n      </span>\n      <span ng-show=\"value.parent\" class=\"label-up\">[ .. ] На уровень выше</span>\n      <span ng-show=\"value.item_count\">({{value.item_count}})</span>\n    </span>\n    <i class=\"ui-spinner\" ng-show=\"value.$$startLoad && comparativeCtrl.loading\"></i>\n  </div></script><script type=text/ng-template id=comparativeCategoryBackCellTemplate.html><div class=\"single-line row-name\"\n       data-ng-click=\"!comparativeCtrl.loading && value.type == \'CATEGORY\'; value.$$startLoad = true;\">\n    <span>\n      <span ng-show=\"::value.type == \'CATEGORY\'\"\n            class=\"catalog-folder\"></span>\n      <span ng-class=\"{\'text-muted\': comparativeCtrl.loading}\" class=\"default-cell-text\">\n        <cell-with-tooltip text=\"::value.item.name\"/>\n      </span>\n      <span ng-show=\"value.item_count\">({{value.item_count}})</span>\n    </span>\n    <i class=\"ui-spinner\" ng-show=\"value.$$startLoad && comparativeCtrl.loading\"></i>\n  </div></script><script type=text/ng-template id=comparativeIndicatorSalesToCellTemplate.html><div class=\"cell-data text-right single-line\">\n    <span\n      class=\"pull-left tooltip-light\"\n      tooltip-placement=\"bottom-left\"\n      uib-tooltip=\"{{(value.previous.sales_totals)? \'Было: \' + value.previous.sales_totals + \'₽\' : \'\'}}\"\n      ng-class=\"{\'text-success\': value.current.sales_totals > value.previous.sales_totals,\n      \'text-default\': value.current.sales_totals == value.previous.sales_totals,\n      \'text-danger\': value.current.sales_totals < value.previous.sales_totals}\"\n      ng-bind=\"value.previous.sales_totals ?\n    (((value.current.sales_totals - value.previous.sales_totals) / value.previous.sales_totals) * 100 | number: 0) + \'%\' : \'-\'\"></span>\n    <span title=\"{{value.current.sales_totals}}\" ng-bind=\"value.current.sales_totals | currencySpacesShift\"></span>\n    <span ng-bind=\"comparativeCtrl.currencyHome.currency.symbol\"></span>\n  </div></script><script type=text/ng-template id=comparativeIndicatorSalesFromCellTemplate.html><div class=\"cell-data text-right single-line\">\n    <span title=\"{{value.previous.sales_totals}}\" ng-bind=\"value.previous.sales_totals | currencySpacesShift\"></span>\n    <span ng-bind=\"comparativeCtrl.currencyHome.currency.symbol\"></span>\n  </div></script><script type=text/ng-template id=comparativeIndicatorAverageToCellTemplate.html><div class=\"cell-data text-right single-line\">\n    <span\n      class=\"pull-left tooltip-light\"\n      tooltip-placement=\"bottom-left\"\n      uib-tooltip=\"{{(value.previous.average_receipt_amount)? \'Было: \' + value.previous.average_receipt_amount + \'₽\' : \'\'}}\"\n      ng-class=\"{\'text-success\': value.current.average_receipt_amount > value.previous.average_receipt_amount,\n      \'text-default\': value.current.average_receipt_amount == value.previous.average_receipt_amount,\n      \'text-danger\': value.current.average_receipt_amount < value.previous.average_receipt_amount}\"\n      ng-bind=\"value.previous.average_receipt_amount ?\n    (((value.current.average_receipt_amount - value.previous.average_receipt_amount) / value.previous.average_receipt_amount) * 100 | number: 0) + \'%\' : \'-\'\"></span>\n    <span title=\"{{value.current.average_receipt_amount}}\"\n          ng-bind=\"value.current.average_receipt_amount | currencySpacesShift\"></span>\n    <span ng-bind=\"comparativeCtrl.currencyHome.currency.symbol\"></span>\n  </div></script><script type=text/ng-template id=comparativeIndicatorAverageFromCellTemplate.html><div class=\"cell-data text-right single-line\">\n    <span title=\"{{value.previous.average_receipt_amount}}\"\n          ng-bind=\"value.previous.average_receipt_amount | currencySpacesShift\"></span>\n    <span ng-bind=\"comparativeCtrl.currencyHome.currency.symbol\"></span>\n  </div></script><script type=text/ng-template id=comparativeIndicatorClientsToCellTemplate.html><div class=\"cell-data text-right single-line\">\n    <span\n      class=\"pull-left tip-light tooltip-light\"\n      tooltip-placement=\"bottom-left\"\n      uib-tooltip=\"{{(value.previous.number_of_sales)? \'Было: \' + value.previous.number_of_sales + \'₽\' : \'\'}}\"\n      ng-class=\"{\'text-success\': value.current.number_of_sales > value.previous.number_of_sales,\n      \'text-default\': value.current.number_of_sales == value.previous.number_of_sales,\n      \'text-danger\': value.current.number_of_sales < value.previous.number_of_sales}\"\n      ng-bind=\"value.previous.number_of_sales ?\n    (((value.current.number_of_sales - value.previous.number_of_sales) / value.previous.number_of_sales) * 100 | number: 0) + \'%\' : \'-\'\"></span>\n    <span title=\"{{value.current.number_of_sales}}\" ng-bind=\"value.current.number_of_sales\"></span>\n  </div></script><script type=text/ng-template id=comparativeIndicatorClientsFromCellTemplate.html><div class=\"cell-data text-right single-line\">\n    <span title=\"{{value.previous.number_of_sales}}\" ng-bind=\"value.previous.number_of_sales\"></span>\n  </div></script><script type=text/ng-template id=gridHeaderLightTemplate.html><div class=\"light-header-cell\">\n    <small class=\"light-header-text\">{{gridCustomHeaderCtrl.column.name}}</small>\n  </div></script><div class=comparative><div class=\"main-left-offset main-right-offset\"><section class=light-section><div class=\"light-section-row clearfix\"><div class=col-xs-4 style=\"padding: 0;\"><h5 class=section-header>Компания</h5><ui-select ng-model=comparativeCtrl.company style=\"max-width: 58%\" class=\"slim-control transparent-select\" on-select=\"comparativeCtrl.refreshDivisions(); comparativeCtrl._refreshData(); comparativeCtrl.updateIndicatorsCurrent();\" on-remove=\"comparativeCtrl.refreshDivisions(); comparativeCtrl._refreshData(); comparativeCtrl.updateIndicatorsCurrent();\" name=companyId><ui-select-match allow-clear=true placeholder=ВСЕ><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=comparativeCtrl.refreshCompany($select.search) repeat=\"item in ( comparativeCtrl.companies | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div><div class=col-xs-4><h5 class=section-header>Подразделения</h5><ui-select ng-model=comparativeCtrl.division style=\"max-width: 50%\" on-select=\"comparativeCtrl._refreshData(); comparativeCtrl.updateIndicatorsCurrent();\" on-remove=\"comparativeCtrl._refreshData(); comparativeCtrl.updateIndicatorsCurrent();\" ng-disabled=!comparativeCtrl.company class=\"slim-control transparent-select\" name=company_id tooltip-placement=top-left uib-tooltip=\"{{(!comparativeCtrl.company)? \'Выберите компанию\' : \'\'}}\"><ui-select-match allow-clear=true placeholder=ВСЕ><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item in ( comparativeCtrl.divisions | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div><div class=col-xs-4 style=\"height: 36px; padding-top: 9px;\"><last-sync-doc-date></last-sync-doc-date></div></div></section><section class=\"solid-section indicators clearfix\"><div class=col-xs-4 style=\"padding-left: 0;\"><div class=small><span class=sales-icon></span>Товарооборот</div><h2>{{comparativeCtrl.indicatorsCurrent.sales_totals | currencySpacesShift }} {{comparativeCtrl.currencyHome.currency.symbol}}</h2></div><div class=col-xs-4><div class=small><span class=average-icon></span>Средний чек</div><h2>{{comparativeCtrl.indicatorsCurrent.average_receipt_amount | currencySpacesShift}} {{comparativeCtrl.currencyHome.currency.symbol}}</h2></div><div class=col-xs-2><div class=small><span class=clients-icon></span>Клиенты</div><h2>{{comparativeCtrl.indicatorsCurrent.number_of_sales | currencySpaces}}</h2></div><calendar-custom date=comparativeCtrl.calendarDate class=pull-right></calendar-custom></section><section class=\"solid-section clearfix\"><h5 class=section-header>Сравнение показателей</h5><i class=ui-spinner ng-show=comparativeCtrl.loading></i><div class=clear></div><div class=col-xs-4 style=\"padding-left: 0; padding-right: 32px;\"><div class=form-group><ui-select ng-model=comparativeCtrl.dateRange search-enabled=false on-select=comparativeCtrl._refreshData();><ui-select-match allow-clear=false><span ng-bind=$select.selected.text></span></ui-select-match><ui-select-choices repeat=\"range.value as range in [\n                {value: \'day\', text: \'День\'},\n                {value: \'week\', text: \'Неделя\'},\n                {value: \'month\', text: \'Месяц\'},\n                {value: -1, text: \'Интервал\'}]\"><span ng-bind-html=range.text></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Период</label></div><div class=form-group ng-show=comparativeCtrl.showInterval><div date-range-picker ng-model=comparativeCtrl.dateFromInterval ng-disabled=comparativeCtrl.loading state=comparative_date_from opts=\"{singleDatePicker: false, correctTimeZone: false, opens: \'right\', maxDate: comparativeCtrl.today}\" class=\"datepicker-wrap range-picker\" name=dateFrom on-close=\"comparativeCtrl.onDateFromPickerIntervalClose(returnValue); comparativeCtrl._refreshData(returnValue, name);\" field-label=\"\'Текущий\'\"></div></div><div class=form-group ng-show=comparativeCtrl.showInterval><div date-range-picker ng-disabled=comparativeCtrl.loading state=comparative_date_to ng-model=comparativeCtrl.dateToInterval opts=\"{singleDatePicker: false, correctTimeZone: false, opens: \'right\', maxDate: comparativeCtrl.dateFromInterval.endDate}\" class=\"datepicker-wrap range-picker\" name=dateTo on-close=\"comparativeCtrl.onDateToPickerIntervalClose(returnValue); comparativeCtrl._refreshData(returnValue, name)\" field-label=\"\'Предыдущий\'\"></div></div><div class=form-group ng-show=!comparativeCtrl.showInterval><div date-range-picker ng-disabled=comparativeCtrl.loading state=comparative_date_to ng-model=comparativeCtrl.dateTo opts=\"{singleDatePicker: true, correctTimeZone: false, maxDate: comparativeCtrl.today}\" class=datepicker-wrap name=dateTo on-close=\"\" field-label=\"\'Текущий\'\"></div><span ng-if=\"comparativeCtrl.dateRange == \'month\' && comparativeCtrl.dateTo.format(\'D\') == 1\" class=\"text-muted text-lowercase range-tip\" ng-bind=\"comparativeCtrl.dateTo.format(\'MMMM YYYY\')\"></span> <span class=\"text-muted text-lowercase range-tip\" ng-if=\"comparativeCtrl.dateRange == \'month\' && comparativeCtrl.dateTo.format(\'D\') != 1\" ng-bind=\"comparativeCtrl.dateTo.format(\'DD.MM.YYYY\') + \' - \' + comparativeCtrl.getDateRangeObj(comparativeCtrl.dateTo).format(\'DD.MM.YYYY\')\"></span> <span class=\"text-muted text-lowercase range-tip\" ng-if=\"comparativeCtrl.dateRange == \'week\'\" ng-bind=\"comparativeCtrl.dateTo.format(\'ddd DD.MM.YYYY\') + \' - \' + comparativeCtrl.getDateRangeObj(comparativeCtrl.dateTo).format(\'ddd DD.MM.YYYY\')\"></span></div><div class=form-group ng-show=!comparativeCtrl.showInterval><div date-range-picker ng-model=comparativeCtrl.dateFrom ng-disabled=comparativeCtrl.loading state=comparative_date_from opts=\"{singleDatePicker: true, correctTimeZone: false, maxDate: comparativeCtrl.dateTo}\" class=datepicker-wrap name=dateFrom on-close=\"\" field-label=\"\'Предыдущий\'\"></div><span ng-if=\"comparativeCtrl.dateRange == \'month\' && comparativeCtrl.dateFrom.format(\'D\') == 1\" class=\"text-muted text-lowercase range-tip\" ng-bind=\"comparativeCtrl.dateFrom.format(\'MMMM YYYY\')\"></span> <span class=\"text-muted text-lowercase range-tip\" ng-if=\"comparativeCtrl.dateRange == \'month\' && comparativeCtrl.dateFrom.format(\'D\') != 1\" ng-bind=\"comparativeCtrl.dateFrom.format(\'DD.MM.YYYY\') + \' - \' + comparativeCtrl.getDateRangeObj(comparativeCtrl.dateFrom).format(\'DD.MM.YYYY\')\"></span> <span class=\"text-muted text-lowercase range-tip\" ng-if=\"comparativeCtrl.dateRange == \'week\'\" ng-bind=\"comparativeCtrl.dateFrom.format(\'ddd DD.MM.YYYY\') + \' - \' + comparativeCtrl.getDateRangeObj(comparativeCtrl.dateFrom).format(\'ddd DD.MM.YYYY\')\"></span></div></div><!-- сами показатели --><div class=col-xs-8 style=\"border-left: 1px solid rgba(51, 51, 51, 0.1); padding: 10px 15px;\"><div class=\"col-xs-7 col-xs-offset-5 indicators-head\"><div class=\"col-xs-6 text-right\">Было</div><div class=col-xs-6>Стало</div></div><compare header=\"\'Товарооборот\'\" symbol=comparativeCtrl.currencyHome.currency.symbol value-to=comparativeCtrl.indicatorsTo.sales_totals value-from=comparativeCtrl.indicatorsFrom.sales_totals></compare><compare header=\"\'Средний чек\'\" symbol=comparativeCtrl.currencyHome.currency.symbol value-to=comparativeCtrl.indicatorsTo.average_receipt_amount value-from=comparativeCtrl.indicatorsFrom.average_receipt_amount></compare><compare header=\"\'Клиенты\'\" coin=false value-to=comparativeCtrl.indicatorsTo.number_of_sales value-from=comparativeCtrl.indicatorsFrom.number_of_sales></compare></div></section></div><section class=\"clearfix main-left-offset main-right-offset\" style=\"margin: 30px 0px 0px\"><h5 class=\"section-header pull-left\">Показатели по каталогу товара и услуг</h5><div class=\"grid-custom-type-wrap pull-right\"><input type=radio name=gridType value=before ng-model=comparativeCtrl.customGridType id=before ng-change=comparativeCtrl.changeGridType()><label for=before ng-class=\"{active: comparativeCtrl.customGridType == \'before\'}\">было</label><input type=radio name=gridType value=after ng-model=comparativeCtrl.customGridType id=after ng-change=comparativeCtrl.changeGridType()><label for=after ng-class=\"{active: comparativeCtrl.customGridType == \'after\'}\">cтало</label></div></section><div class=\"custom-grid-wrapper main-right-offset main-left-offset\"><div><div class=grid-custom-before-header><div style=\"width: 1%; flex: 10 10 0%;\"></div><div style=\"width: 1%; flex: 5 5 0%;\" class=text-center><div class=small>Товарооборот</div></div><div style=\"width: 1%; flex: 5 5 0%;\" class=text-center><div class=small>Средний чек</div></div><div style=\"width: 1%; flex: 5 5 0%; border-right: 1px solid #f1f1f1;\" class=text-center><div class=small>Клиенты</div></div></div><grid-custom columns=comparativeCtrl.columns loading=comparativeCtrl.loading data=comparativeCtrl.currentCategoryChildren parent=\"comparativeCtrl.categoryStack[comparativeCtrl.categoryStack.length - 1]\" hide-header=true></grid-custom></div></div></div>");
$templateCache.put("app/egaisz/egaisz-abstract.html","<div ui-view></div>");
$templateCache.put("app/guide/guide.html","<div class=\"settings guide\"><div ng-include=\"\'app/guide/sections/tree/templates.html\'\"></div><div class=container><section><h4>Элементы форм</h4><ul class=\"nav nav-tabs\"><li><a href=.tab0 data-toggle=tab>Поля ввода</a></li><li><a href=.tab1 data-toggle=tab>Выпадающие списки</a></li><li><a href=.tab2 data-toggle=tab>Дерево</a></li><li><a href=.tab3 data-toggle=tab>Прайс лист</a></li><li><a href=.tab4 data-toggle=tab>Адрес</a></li><li><a href=.tab5 data-toggle=tab>Штрих-коды</a></li><li><a href=.tab6 data-toggle=tab>Даты</a></li><li><a href=.tab7 data-toggle=tab>Документы</a></li><li><a href=.tab8 data-toggle=tab>Виджеты</a></li><li class=active><a href=.tab9 data-toggle=tab>Опросы</a></li></ul><div class=tab-content><div class=\"tab-pane tab0\" ng-include=\"\'app/guide/sections/form-elements/inputs.html\'\"></div><div class=\"tab-pane tab1\" ng-include=\"\'app/guide/sections/form-elements/selection-lists.html\'\"></div><div class=\"tab-pane tab2\" ng-include=\"\'app/guide/sections/tree/catalog-tree.html\'\"></div><div class=\"tab-pane tab3\" ng-include=\"\'app/guide/sections/tree/price-tree.html\'\"></div><div class=\"tab-pane tab4\" ng-include=\"\'app/guide/sections/address/address.html\'\"></div><div class=\"tab-pane tab5\" ng-include=\"\'app/guide/sections/barcodes/barcodes.html\'\"></div><!--div ng-controller=\"guideDatesCtrl as vm\">\n          <div class=\"tab-pane tab6\" ng-include=\"\'app/guide/sections/form-elements/datepicker.html\'\"></div>\n        </div--><div class=\"tab-pane tab7\" ng-include=\"\'app/guide/sections/documents/document-builder.html\'\"></div><div class=\"tab-pane tab8\" ng-include=\"\'app/guide/sections/widgets/widgets-simple.html\'\"></div><div class=\"tab-pane tab9 active\" ng-include=\"\'app/guide/sections/messages/messages.html\'\"></div></div></section></div></div>");
$templateCache.put("app/messages/messages-template.html","<div class=\"messages-page crud-entity\"><h1 class=\"main-left-offset main-right-offset\">Сообщения</h1><div class=\"main-left-offset main-right-offset\"><div ng-if=!messagesCtrl.surveys.length>В настоящий момент у вас нет уведомлений</div><div class=row ng-if=messagesCtrl.surveys.length><div class=\"col-xs-4 survey-items-wrapper\"><div ng-repeat=\"item in messagesCtrl.surveys\" class=survey-item ng-click=\"messagesCtrl.buildSurvey(item, $index)\" ng-class=\"{\'new\': messagesCtrl.isNew(item)}\" uib-tooltip=\"{{(messagesCtrl.isNew(item))? \'Новое уведомление\' : \'\'}}\"><span class=\"glyphicon glyphicon-ok pull-right text-muted\" title=\"Вы ответили: {{item.survey_responses[0].created_at | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset}}\" ng-show=item.survey_responses.length></span><div class=survey-name ng-bind=item.survey.name></div><div class=survey-data><small class=survey-date ng-class=\"{\'text-muted\': messagesCtrl.now > item.expired_date}\" ng-bind=\"item.created_at | date:\'dd.MM.yyyy HH:mm\'\" uib-tooltip=\"{{(messagesCtrl.now > item.expired_date)? \'Срок уведомления истек\' : \'\'}}\"></small></div></div></div><section class=\"col-xs-8 survey-wrapper\"><survey survey=messagesCtrl.messageObj redact=!messagesCtrl.currentSurveyMessage.survey_responses.length callback-send=messagesCtrl.valueSelected show-header=true values=messagesCtrl.messageData ng-if=!messagesCtrl.loadMessage></survey><div class=need-choose-message ng-if=\"!messagesCtrl.messageObj && !messagesCtrl.loadMessage\">Выберите уведомление</div><div class=ui-spinner ng-if=\"messagesCtrl.loadMessage && !messagesCtrl.messageObj.title\"></div><div class=clearfix style=\"margin-right: 35px;\" ng-if=messagesCtrl.currentSurveyTemplate><button ng-show=\"!messagesCtrl._checkNeedAutoSend() &&\n            !messagesCtrl.currentSurveyMessage.survey_responses.length\" ng-disabled=\"messagesCtrl.currentSurveyMessage.survey_responses.length || messagesCtrl.saving\" ng-click=messagesCtrl.sendSurvey() class=\"btn btn-primary pull-right\">Отправить</button></div><div ng-if=messagesCtrl.currentSurveyMessage.survey_responses.length style=\"margin-right: 35px; margin-top: 30px;\" class=text-right><small>Вы ответили:</small> <small ng-bind=\"messagesCtrl.currentSurveyMessage.survey_responses[0].created_at | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset\"></small></div></section></div></div></div>");
$templateCache.put("app/mobile/loader.html","<div class=loader-wrapper><div class=spinner-wrapper><div class=ui-spinner></div><div class=message>Ожидайте</div></div></div>");
$templateCache.put("app/price-list/price-list.html","<div class=price-list><div ng-include=\"\'app/price-list/tree-cell-templates.html\'\"></div><!-- content of settings --><div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li ng-if=\"priceListCtrl.type == \'RETAIL\'\"><a>Розница</a></li><li ng-if=\"priceListCtrl.type == \'WHOLE_SALE\'\"><a>Продажи</a></li><li ng-if=\"priceListCtrl.type == \'PURCHASE\'\"><a>Закупки</a></li></ul><h1 ng-bind=\"(priceListCtrl.type == \'RETAIL\')? \'Розничный прайс-лист\' : (priceListCtrl.type == \'WHOLE_SALE\')? \'Оптовый прайс-лист\' : \'Закупочный прайс-лист\'\"></h1><div class=\"grid-buttons clearfix\"><div ng-include=\"\'app/price-list/includes/button-block.html\'\"></div></div></div><div ng-include=\"\'app/price-list/includes/search-block.html\'\"></div><div style=\"position: relative;\"><div ng-show=!priceListCtrl.showSearch class=price-tree-header ng-class=\"{\'no-data\': priceListCtrl.root.loaded && !priceListCtrl.root.children.length && !priceListCtrl.showSearch}\"><div ng-include=\"\'app/price-list/includes/price-tree-header.html\'\"></div></div><div data-footer-absolute top-shift=320 top-flag=headerButtonNotInTop class=header-absolute ng-class=\"{hide: !headerButtonNotInTop}\" ng-show=!priceListCtrl.showSearch><div class=\"clearfix main-left-offset main-right-offset\" style=\"padding-top: 8px; padding-bottom: 8px;\"><div ng-include=\"\'app/price-list/includes/button-block.html\'\"></div></div><div class=clearfix><div ng-include=\"\'app/price-list/includes/search-block.html\'\"></div></div><div ng-show=!priceListCtrl.showSearch class=price-tree-header style=\"position: relative;\"><div ng-include=\"\'app/price-list/includes/price-tree-header.html\'\"></div></div></div><div class=catalog-content ng-if=\"priceListCtrl.root.loaded && !priceListCtrl.root.children.length && !priceListCtrl.showSearch\"><div class=no-content><p style=\"margin-left: 240px;\">Добавьте товары или услуги для<br>возможности формирования<br>прайс-листа</p><div class=arrow></div></div></div><div class=price-list-tree ng-show=\"priceListCtrl.root.loaded && priceListCtrl.root.children.length && !priceListCtrl.showSearch\" ng-init=priceListCtrl.openTreeWithParams()><catalog-tree min-height=450 root-visible=false hierarchical-flex=2 hierarchical-template-url=\"\'priceHierarchicalTemplate.html\'\" block-choice-hoisting=true load-callback=::priceListCtrl.onTreeLoaded on-collapse-node=::priceListCtrl.onCollapseNode on-expand-node=::priceListCtrl.onExpandNode expand-node=::priceListCtrl.expand controls-property=type controls-array=priceListCtrl.treeControls root=priceListCtrl.root columns=priceListCtrl.treeColumns columns-page=priceListCtrl.columnsPaging show-checkbox=true cell-update-callback=::priceListCtrl.updateCell hierarchical-callback=priceListCtrl.openPositionPrices selected-callback=priceListCtrl.selectNode checked-callback=priceListCtrl.checkedNode></catalog-tree></div></div><div style=\"margin: 45px 0 30px; position: absolute; width: 100%;display: none;\" class=\"main-left-offset main-right-offset footer-absolute\" ng-show=!priceListCtrl.showSearch ng-if=priceListCtrl.notEmptyChanges><div class=pull-right><button class=\"btn btn-default btn-padding-lg\" ng-click=priceListCtrl.rollback()>Отменить</button> <button class=\"btn btn-primary btn-padding-lg\" ng-click=priceListCtrl.commit()><span>Сохранить</span></button></div><div class=\"footer-description pull-left\">Изменения в ценах показаны знаком<span class=dot></span>После завершения правок не забудьте сохранить прайс-лист</div></div><div class=\"price-list-tree search-tree\" ng-show=priceListCtrl.showSearch style=\"position: relative; padding-bottom: 27px;\"><div class=price-tree-header ng-if=\"priceListCtrl.searchPaging.total && !priceListCtrl.searchPaging.loading\"><div ng-include=\"\'app/price-list/includes/price-tree-header.html\'\"></div></div><catalog-tree min-height=450 ng-show=\"priceListCtrl.searchPaging.total && !priceListCtrl.searchPaging.loading\" root-visible=false hierarchical-flex=2 block-expand=true hierarchical-template-url=\"\'priceHierarchicalTemplate.html\'\" block-choice-hoisting=true expand-node=::priceListCtrl.searchExpand controls-property=type controls-array=priceListCtrl.treeControls root=priceListCtrl.searchRoot columns=priceListCtrl.treeColumns columns-page=priceListCtrl.columnsPaging show-checkbox=true cell-update-callback=::priceListCtrl.updateCell hierarchical-callback=priceListCtrl.openPositionPrices selected-callback=priceListCtrl.selectNode checked-callback=priceListCtrl.checkedNodeSearch></catalog-tree><div class=\"filter-not-found major-font\" ng-if=\"!priceListCtrl.searchPaging.total && !priceListCtrl.searchPaging.loading\"><div class=big-danger-info-ico></div><div class=big-danger-info><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div></div><div class=table-footer ng-if=\"priceListCtrl.searchPaging.total && !priceListCtrl.searchPaging.loading\" style=\"z-index: 900;\" ng-style=\"{bottom: (priceListCtrl.notEmptyChanges? \'45px\' : \'0\')}\"><div class=pagination-wrapper><paging page-info=priceListCtrl.searchPaging callback=priceListCtrl.search></div></div><div ng-if=priceListCtrl.searchPaging.loading><div class=ui-spinner style=\"margin: 150px auto;\"></div></div></div><div data-footer-absolute bottom-shift=20 bottom-flag=footerOnBottomFlag class=footer-absolute ng-if=priceListCtrl.notEmptyChanges><div class=\"main-left-offset main-right-offset\"><div class=pull-right ng-if=priceListCtrl.notEmptyChanges><button class=\"btn btn-default btn-padding-lg\" ng-click=priceListCtrl.rollback()>Отменить</button> <button class=\"btn btn-primary btn-padding-lg\" ng-click=priceListCtrl.commit()><span>Опубликовать</span></button></div><div class=footer-description>Изменения в ценах показаны знаком<span class=dot></span>После завершения правок не забудьте сохранить прайс-лист</div></div></div></div>");
$templateCache.put("app/price-list/tree-cell-templates.html","<script type=text/ng-template id=priceItemTemplate.html><div class=\"price-cell width-cell-{{catalogTreeNodeCellCtrl.column.comnsLength}}\"\n       ng-class=\"{\'not-sell-wrapper\': (catalogTreeNodeCellCtrl.value.catalog_item.type &&\n      (catalogTreeNodeCellCtrl.value.catalog_item.type != \'CATEGORY\' &&\n       ((catalogTreeNodeCellCtrl.value.catalog_item.status == \'DRAFT\') || (catalogTreeNodeCellCtrl.value.catalog_item.status == \'ARCHIVED\' && catalogTreeNodeCellCtrl.column.column_type !== \'PURCHASE\'))))}\"\n       style=\"border-left: 1px solid rgba(151, 151, 151, 0.17);\">\n    <div style=\"padding: 0 10px; height: 100%; text-align: right\"\n         ng-show=\"::!catalogTreeNodeCellCtrl.value.catalog_item.type || catalogTreeNodeCellCtrl.value.catalog_item.type == \'CATEGORY\'\">\n      <small class=\"text-muted\"></small>\n    </div>\n    <div class=\"not_sale\"\n         ng-show=\":: catalogTreeNodeCellCtrl.column.column_type !== \'PURCHASE\' && catalogTreeNodeCellCtrl.value.catalog_item.type &&\n      (catalogTreeNodeCellCtrl.value.catalog_item.type != \'CATEGORY\' &&\n        (catalogTreeNodeCellCtrl.value.catalog_item.status == \'DRAFT\' ||\n          catalogTreeNodeCellCtrl.value.catalog_item.status == \'ARCHIVED\'))\">\n      <small class=\"text-muted\">Временно нет в продаже</small>\n    </div>\n\n    <div class=\"not_sale\"\n         ng-show=\"::catalogTreeNodeCellCtrl.column.column_type == \'PURCHASE\' && catalogTreeNodeCellCtrl.value.catalog_item.type &&\n      (catalogTreeNodeCellCtrl.value.catalog_item.type != \'CATEGORY\' &&\n        (catalogTreeNodeCellCtrl.value.catalog_item.status == \'DRAFT\'))\">\n      <small class=\"text-muted\">Временно недоступно для закупки</small>\n    </div>\n\n    <div ng-if=\"::catalogTreeNodeCellCtrl.value.catalog_item.type &&\n      ((catalogTreeNodeCellCtrl.value.catalog_item.type != \'CATEGORY\'\n      && catalogTreeNodeCellCtrl.value.catalog_item.status != \'DRAFT\'\n      && catalogTreeNodeCellCtrl.value.catalog_item.status != \'ARCHIVED\') || (catalogTreeNodeCellCtrl.value.catalog_item.status == \'ARCHIVED\' && catalogTreeNodeCellCtrl.column.column_type == \'PURCHASE\'))\">\n      <price-cell-multiple\n        commit-value=\"::catalogTreeNodeCellCtrl.updateCell\"\n        column=\"catalogTreeNodeCellCtrl.column\"\n        uom=\"::catalogTreeNodeCellCtrl.value.catalog_item.uom\"\n        prices=\"catalogTreeNodeCellCtrl.value.price[catalogTreeNodeCellCtrl.column.id]\"\n        open-position-prices=\"::catalogTreeNodeCellCtrl.catalogTreeNodeCtrl.treeCtrl.hierarchicalCallback\"\n        node=\"catalogTreeNodeCellCtrl.catalogTreeNodeCtrl.node\"\n        add-to-cart=\"catalogTreeNodeCellCtrl.addToCart\">\n      </price-cell-multiple>\n    </div>\n  </div></script><script type=text/ng-template id=priceHierarchicalTemplate.html><div ng-switch=\"::catalogTreeNodeCtrl.node.catalog_item.type\">\n    <span class=\"has-changes tooltip-light\" tooltip-placement=\"bottom-left\" uib-tooltip=\"Несохраненные изменения\" ng-if=\"catalogTreeNodeCtrl.node.$$hasChanges\"></span>\n    <div ng-switch-when=\"CATEGORY\">\n      <div ng-include src=\"\'defaultHierarchicalTemplate.html\'\"></div>\n    </div>\n    <div ng-switch-when=\"SKU\">\n      <span class=\"glyphicon glyphicon-info-sign inform-ico tooltip-light\"\n          ng-if=\"::catalogTreeNodeCtrl.node.catalog_item.status == \'DRAFT\'\"\n          tooltip-placement=\"right\"\n          uib-tooltip=\'Данный товар находится в статусе \"Черновик\". Заполните все обязательные поля в карточке товара, тогда товар станет доступен.\'>\n      </span>\n      <span class=\"glyphicon glyphicon-info-sign inform-ico tooltip-light\"\n          ng-if=\"::catalogTreeNodeCtrl.node.catalog_item.status == \'ARCHIVED\'\"\n          tooltip-placement=\"right\"\n          uib-tooltip=\'Данный товар находится в статусе \"В архиве\". Товар будет доступен лишь после восстановления товара в каталоге \"Товары и услуги\"\'>\n      </span>\n      <div class=\"text-hint single-line\">\n        <small class=\"text-muted\">{{::catalogTreeNodeCtrl.node.catalog_item.vendor_code || \'\'}}</small>\n        <small>\n          <b class=\"text-muted\" ng-bind=\"::catalogTreeNodeCtrl.node.catalog_item.derivative_code_prefix\"\n             style=\"margin-right: 8px; display: block; min-height: 16px;\"></b>\n        </small>\n        <a href=\"\" class=\"item-node-title\" title=\"{{::catalogTreeNodeCtrl.node.catalog_item.name}}\"\n           ng-click=\"::catalogTreeNodeCtrl.treeCtrl.hierarchicalCallback(catalogTreeNodeCtrl.node)\">\n          <span>{{::catalogTreeNodeCtrl.node.catalog_item.name}}</span>\n        </a>\n      </div>\n    </div>\n    <div ng-switch-when=\"SERVICE\">\n      <span class=\"glyphicon glyphicon-info-sign inform-ico tooltip-light\"\n          ng-if=\"::catalogTreeNodeCtrl.node.catalog_item.status == \'DRAFT\'\"\n          tooltip-placement=\"right\"\n          uib-tooltip=\'Данная услуга находится в статусе \"Черновик\". Заполните все обязательные поля в карточке услуги, тогда услуга станет доступна.\'>\n      </span>\n      <span class=\"glyphicon glyphicon-info-sign inform-ico tooltip-light\"\n          ng-if=\"::catalogTreeNodeCtrl.node.catalog_item.status == \'ARCHIVED\'\"\n          tooltip-placement=\"right\"\n          uib-tooltip=\'Данная услуга находится в статусе \"В архиве\". Услуга будет доступна лишь после восстановления услуги в каталоге \"Товары и услуги\"\'>\n      </span>\n      <div class=\"text-hint single-line\">\n        <small class=\"text-muted\" ng-bind=\"::catalogTreeNodeCtrl.node.catalog_item.vendor_code || \'\'\"></small>\n        <small>\n          <b class=\"text-muted\" ng-bind=\"::catalogTreeNodeCtrl.node.catalog_item.derivative_code_prefix\"\n             style=\"margin-right: 8px\"></b>\n        </small>\n        <br>\n        <a href=\"\" class=\"item-node-title\" title=\"{{::catalogTreeNodeCtrl.node.catalog_item.name}}\"\n           ng-click=\"catalogTreeNodeCtrl.treeCtrl.hierarchicalCallback(catalogTreeNodeCtrl.node)\">\n          <span>{{::catalogTreeNodeCtrl.node.catalog_item.name}}</span></a>\n      </div>\n\n    </div>\n    <div ng-switch-default>\n      <div ng-include src=\"\'defaultHierarchicalTemplate.html\'\"></div>\n    </div>\n  </div></script>");
$templateCache.put("app/settings/settings.html","<div class=settings><!-- content of settings --><div class=container><div class=row><div class=col-md-4><div class=\"panel panel-default\"><div class=panel-heading><a href=javascript:void class=panel-title>Структура бизнеса</a> <span class=caret></span></div><ul class=panel-body><li><a href=#/companies>Компании</a></li><li><a ui-sref=\"divisions({companyName: \'\', parent: \'business\'})\">Подразделения</a></li><li><a href=javascript:void(0)>Кассовые аппараты</a></li><li><a ui-sref=\"employees({parent: \'business\'})\">Сотрудники</a></li></ul></div><div class=\"panel panel-default\"><div class=panel-heading><a href=\"\" class=panel-title>Справочники</a> <span class=caret></span></div><ul class=panel-body><li><a ui-sref=\"currencies({parent: \'money\'})\">Валюты</a></li><li><a ui-sref=\"contragents({parent: \'money\'})\">Контрагенты</a></li><li><a ui-sref=\"contracts({parent: \'money\'})\">Договоры</a></li><li><a ui-sref=\"projects({parent: \'money\'})\">Проекты</a></li><li><a href=javascript:void>Классификатор товаров и услуг</a></li></ul></div><div class=\"panel panel-default\"><div class=panel-heading><a href=javascript:void class=panel-title>Настройки</a></div></div></div><div class=col-md-8><h2>Быстрый поиск товара на складе:</h2><div class=btn-group><button type=button class=\"btn btn-default dropdown-toggle\" data-toggle=dropdown>Default <span class=caret></span></button><ul class=dropdown-menu role=menu><li><a href=#>Действие</a></li><li><a href=#>Другое действие</a></li><li><a href=#>Что-то иное</a></li><li class=divider></li><li><a href=#>Отдельная ссылка</a></li></ul></div><form class=\"navbar-form search-form\" role=search><div class=form-group><input type=text class=form-control placeholder=Search></div><button type=submit class=\"btn btn-default\">Отправить</button></form><br><br><form name=mainForm> {{vm.fio1}} <br><br> {{vm.person1}} <br><br><input ng-model=vm.fio2><br><br> {{vm.person2}} <br><br><div person-data-input form-model=vm.person1 name-and-id=person22222 is-required=true fio=vm.fio1></div><div person-data-input form-model=vm.person2 fio=vm.fio2></div> {{vm.inn}} {{vm.validInn}} <input inn-check ng-model=vm.inn name=settingsInn ui-options={allowInvalidValue:true} inn-type=fiz ui-mask=\"999 999 999 999\" class=form-control> <span class=invalid-field ng-hide=mainForm.settingsInn.$pristine||!mainForm.settingsInn.$error.checkSum>Такой номер не существует</span> <span class=invalid-field ng-hide=mainForm.settingsInn.$pristine||!mainForm.settingsInn.$error.mask>ИНН должен содержать 12 цифр</span><br> {{vm.snils}} {{vm.validSnils}} <input snils-check ng-model=vm.snils name=snils class=form-control ui-mask=\"999-999-999 99\" model-view-value=true ui-options={allowInvalidValue:true}> <span class=invalid-field ng-hide=mainForm.snils.$pristine||!mainForm.snils.$error.mask>СНИЛС должен содержать 11 цифр</span> <span class=invalid-field ng-hide=mainForm.snils.$pristine||!mainForm.snils.$error.validSnils>Такой номер не существует</span> {{vm.tel}} <br><input phone-number ng-model=vm.tel name=tel class=form-control><br></form><div id=modal-container></div></div></div></div><div class=\"settings-footer row\"><div class=container><h3 class=report-title>Отчеты</h3><a href=javascript:void(0) class=add-report><span class=\"glyphicon glyphicon-file\"></span> <span class=report-text>Отчет по складским оборотам</span> </a><a href=javascript:void(0) class=add-report><span class=\"glyphicon glyphicon-plus\"></span> <span class=report-text>Создать собствееный отчет</span></a></div></div><!-- end content of settings --></div><!-- <persons-data></persons-data> -->");
$templateCache.put("app/auth/confirmEmail/confirmEmail.html","<div class=confirmemail-loader><div class=ui-spinner></div>Подождите</div>");
$templateCache.put("app/auth/login/login.html","<div class=\"login-bg-helper img-loaded\" img-load-event=assets/images/login-bg.png></div><div class=\"container auth-bg login-container\" ng-animate=\"\'animate\'\"><h5 class=section-header ng-bind=\"(emailNotConfirmed)? \'Вход не выполнен\' : \'ВХОД В ТОРГОВЛЮ.ОНЛАЙН\'\"></h5><form ng-submit=loginSubmit() novalidate class=\"auth-box small-auth-box\" ng-keyup=resetErrors($event) ng-class=\"(userLoginData.animateId)? \'resetpassOnLogin\' : \'\'\" role=form name=vm.loginForm><input name=pass type=password class=login-hack><!-- Для того чтобы не заполнялись поля autofill --><div class=isset-domain-name ng-if=issetDomain>{{issetDomain}}</div><div ng-hide=emailNotConfirmed><div class=\"form-group domain-form-group\" ng-class=\"{\'invalidData\': userLoginData.error.wrongData}\" ng-show=!issetDomain><input hard-pruning maxlength=30 name=domain ng-model=userLoginData.domain required ng-keypress=\"$event.key === \'Enter\' && onEnter($event)\" type=text class=form-control data-check=[a-zA-Z0-9-]* ng-keyup=\"userLoginData.isWrongLoginData = false; userLoginData.error.nonUniqueLogin = false;\"><label class=\"form-control-label small-offset\">Группа</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=form-group ng-class=\"{\'invalidData\': userLoginData.error.wrongData}\"><!--input hard-pruning\n               maxlength=\"30\"\n               name=\"login\"\n               ng-model=\"userLoginData.login\"\n               required\n               ng-keypress=\"$event.key === \'Enter\' && onEnter($event)\"\n               type=\"text\"\n               class=\"form-control\"\n               data-check=\"[a-zA-Z0-9._]*\"\n               ng-keyup=\"userLoginData.isWrongLoginData = false\"--><div class=phone-input-wrapper><input ng-class=\"{\n          \'phone-input\': flags.isPhone,\n          \'email-input\': flags.isEmail\n          }\" style=\"padding-top: 15px\" hard-pruning data-check=[a-zA-Z0-9._@\\-+\\(\\)\\s]* class=form-control maxlength=50 name=login required universal-login-input is-phone=flags.isPhone is-email=flags.isEmail ng-keypress=\"$event.key === \'Enter\' && onEnter($event)\" ng-keyup=\"userLoginData.isWrongLoginData = false; userLoginData.error.nonUniqueLogin = false;\" ng-model=userLoginData.login><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=input-flag ng-if=flags.isPhone><div class=flag-ru></div><div class=phone-code><span class=phone-code-text>+7</span></div></div><div class=\"input-flag email-img\" ng-if=flags.isEmail><div class=email></div><div class=phone-code></div></div><label class=\"form-control-label small-offset\">Логин, телефон или email</label></div><!--label class=\"form-control-label small-offset\">Логин</label--></div><div class=\"form-group hidden-password-form-group\" ng-class=\"{\'invalidData\': userLoginData.error.wrongData}\"><div class=hidden-password-wrapper><input maxlength=50 name=password ng-show=showpassword required type=text ng-model=userLoginData.password class=form-control ng-keyup=\"userLoginData.isWrongLoginData = false\"> <input maxlength=50 name=password ng-hide=showpassword required type=password ng-model=userLoginData.password class=form-control ng-keyup=\"userLoginData.isWrongLoginData = false; userLoginData.error.nonUniqueLogin = false;\"><label class=\"form-control-label small-offset\">Пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(showpassword)? \'open\' : \'\'\" ng-click=\"showpassword = !showpassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(showpassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=form-group ng-messages=userLoginData.error role=alert style=\"position: relative; overflow: hidden;\"><p class=wrong-info ng-message=wrongData>Неправильные группа, логин или пароль</p><p class=wrong-info ng-message=disabledUser>Пользователю не разрешен вход в систему</p><p class=wrong-info ng-message=serverError>В процессе авторизации произошли технические неполадки. Повторите вход в систему позже или обратитесь к администратору.</p><p class=wrong-info ng-message=nonUniqueLogin>Невозможно авторизоваться по неуникальному email. Используйте для авторизации логин.</p></div><button type=submit class=\"btn btn-primary\">Войти</button></div><div ng-show=emailNotConfirmed><span ng-if=flags.isEmail>Необходимо подтвердить адрес электронной почты.<br>Для этого перейдите по ссылке из письма, отправленного на ваш электронный адрес.<br><br>Если вы не знаете адрес электронной почты, указанный при регистрации, обратитесь к администратору. </span><span ng-if=flags.isPhone>Телефон не подтвержден.<br>Используйте электронную почту для входа или обратитесь к системному администратору.</span><div class=btn ng-click=\"emailNotConfirmed = false;\" style=\"margin-top: 16px;\">Вернуться</div></div></form><div class=text-center><a href=\"#/resetpass?{{param}}\" class=link-forget ng-click=\"vm.animateId = \'resetpassOnLogin\'\">не помню пароль</a></div></div><p class=version-label><span ng-bind=uiVersion.version></span>&nbsp;</p>");
$templateCache.put("app/auth/passRecovery/resetpass.html","<div class=\"login-bg-helper img-loaded\" img-load-event=assets/images/login-bg.png></div><div class=\"container auth-bg resetpass-container\" ng-animate=\"\'animate\'\"><div ng-show=!success||!resetPassForm.$submitted><div class=isset-domain-name ng-if=issetDomain>{{issetDomain}}</div><h5 class=section-header>ВОССТАНОВЛЕНИЕ ПАРОЛЯ</h5><form novalidate name=resetPassForm ng-submit=resetSubmit() class=\"auth-box small-auth-box\" ng-class=\"(userResetData.animateId)? \'loginOnResetpass\' : \'\'\" role=form><div class=form-group><div class=phone-input-wrapper><input ng-class=\"{\'phone-input\': flags.isPhone,\'email-input\': flags.isEmail}\" style=\"padding-top: 15px\" class=form-control maxlength=50 name=data required universal-login-input is-phone=flags.isPhone is-email=flags.isEmail ng-model=userResetData.data ng-blur=\"(!userResetData.data)? flags = {} : \'\'\" ng-keyup=resetErrors()><div class=input-flag ng-if=flags.isPhone><div class=flag-ru></div><div class=phone-code><span class=phone-code-text>+7</span></div></div><div class=\"input-flag email-img\" ng-if=flags.isEmail><div class=email></div><div class=phone-code></div></div><div class=\"valid-message required-mess small-offset\">Поле является обязательным</div><label class=\"form-control-label small-offset\">Логин, телефон или email</label></div><span class=req style=\"right: -12px;\"></span></div><div class=\"form-group domain-form-group\" ng-if=!issetDomain><input hard-pruning name=domain ng-model=userResetData.domain type=text class=form-control ng-required=\"!flags.isPhone && !flags.isEmail && userResetData.data\" data-check=[a-zA-Z0-9-]* ng-keyup=resetErrors()><label class=\"form-control-label small-offset\">Группа</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req style=\"right: -12px; width: 8px; height: 8px; top: 5px;\" ng-if=\"!flags.isPhone && !flags.isEmail && userResetData.data\"></span></div><div class=form-group><p class=wrong-info ng-show=\"errStatus == \'needConfirmedEmail\'\">Для восстановления по логину необходим подтвержденный email</p><p class=wrong-info ng-show=\"errStatus == \'phoneNotConfirm\'\">Телефон не подтвержден</p><p class=wrong-info ng-show=\"errStatus == \'emailNotConfirm\'\">Email не подтвержден</p><p class=wrong-info ng-show=\"errStatus == \'badLogin\'\">Учетная запись не найдена в системе</p><p class=wrong-info ng-show=\"errStatus == \'bannedLogin\'\">Пользователь заблокирован</p><p class=wrong-info ng-show=\"errStatus == \'fastCashier\'\">Ваша учетная запись имеет ограниченные права доступа. Для восстановления пароля, пожалуйста, обратитесь к администратору вашей группы</p></div><button type=submit class=\"btn btn-primary\">Далее</button></form><div class=text-center><a href=\"#/login?{{param}}\" class=link-forget ng-click=\"vm.animateId = \'loginOnResetpass\'\">я вспомнил пароль!</a></div></div><h5 class=section-header ng-show=\"success && resetPassForm.$submitted\">ВОССТАНОВЛЕНИЕ ПАРОЛЯ</h5><div class=\"auth-box reset-pass-submitted small-auth-box\" ng-show=\"success && resetPassForm.$submitted\" style=\"overflow: hidden;\"><div ng-if=!flags.isPhone><div class=reset-pass-message>Для восстановления пароля<br>перейдите по ссылке из письма, отправленного вам на e-mail</div><a href=\"mailto:{{email}}\">{{email}}</a></div><div ng-if=\"flags.isPhone && flags.pwdGenerated\" class=text-muted>На номер телефона <span ng-bind=generatePhoneStr();></span> было отправлено сообщение с временным паролем для входа в систему.<br><br>Пароль является одноразовым, поэтому просим вас после авторизации в своем профиле задать новый пароль</div></div><div class=text-center ng-show=\"success && resetPassForm.$submitted\"><a href=\"#/login?{{param}}\" class=link-forget ng-click=\"vm.animateId = \'loginOnResetpass\'\">войти в Систему</a></div></div>");
$templateCache.put("app/auth/passRecovery/setpass.html","<div class=\"login-bg-helper img-loaded\" img-load-event=assets/images/login-bg.png></div><div class=\"container auth-bg\"><div class=isset-domain-name ng-if=vm.domain>{{vm.domain}}</div><h5 class=section-header>СОЗДАНИЕ ПАРОЛЯ</h5><form ng-submit=vm.submit() class=\"auth-box small-auth-box\" novalidate role=form name=setPassForm ng-show=(vm.success&&!setPassForm.$submitted)||!vm.goLogin ng-class=\"{\'repeated-passwords\':vm.errors.repeatedPassword}\"><div class=form-group ng-if=!vm.isNewPass><span ng-bind=\"(vm.passwordChangeRequested)? \'смена пароля\' : \'новый пароль для:\'\"></span></div><div class=form-group ng-if=vm.isNewPass><div class=description>Администратор включил вас в число пользователей системы и назначил вам логин:</div></div><div class=form-group ng-if=vm.passwordChangeRequested><div class=description>Задайте новый пароль по требованию Администратора:</div></div><div class=form-group><div class=user-login ng-if=vm.login>{{vm.login}}</div></div><div class=form-group ng-if=vm.isNewPass><div class=description>Придумайте пароль</div></div><div class=\"form-group hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=50 name=password ng-show=vm.showpassword required type=text ng-class=\"{passNoMatch: vm.passNoMatch}\" ng-model=vm.password class=form-control> <input maxlength=50 name=password ng-hide=vm.showpassword required type=password ng-model=vm.password class=form-control ng-class=\"{passNoMatch: vm.passNoMatch}\" ng-focus=\"vm.errors.repeatedPassword = false\" ng-keyup=vm.checkPassword()><label class=\"form-control-label small-offset\">{{(vm.passwordChangeRequested)? \'Новый пароль \' : \'Пароль \'}}</label><label class=\"showpassword tooltip-light\" ng-class=\"(vm.showpassword)? \'open\' : \'\'\" ng-mouseup=\"vm.showpassword = false\" ng-mousedown=\"vm.showpassword = true\" tooltip-placement=bottom-left uib-tooltip=\"{{(showpassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=50 name=repeatedPassword ng-show=vm.repeatedShowPassword required ng-class=\"{passNoMatch: passNoMatch}\" ng-model=vm.repeatedPassword type=text class=form-control> <input maxlength=50 name=repeatedPassword ng-hide=vm.repeatedShowPassword required type=password ng-model=vm.repeatedPassword class=form-control ng-class=\"{passNoMatch: vm.passNoMatch}\" ng-focus=\"vm.errors.repeatedPassword = false\" ng-keyup=vm.checkPassword()><label class=\"form-control-label small-offset\">{{(vm.passwordChangeRequested)? \'Повторите новый пароль \' : \'Повторите пароль \'}}</label><label class=showpassword ng-class=\"(vm.repeatedShowPassword)? \'open\' : \'\'\" ng-mouseup=\"vm.repeatedShowPassword = false\" ng-mousedown=\"vm.repeatedShowPassword = true\"></label></div><div class=\"valid-message wrong-format\">Пароли не совпадают</div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div ng-messages=vm.errors class=form-group><p class=wrong-info ng-message=guidInvalid>Ссылка на смену пароля устарела или некорректна. Запросите смену пароля повторно.</p><p class=wrong-info ng-message=repeatedPassword>Пароли не совпадают</p><p class=wrong-info ng-message=otherErrors>Произошла техническая неполадка. Повторите попытку позже или обратитесь к администратору</p><p class=wrong-info ng-message=bannedUser>Пользователю запрещён вход</p><p class=wrong-info ng-message=invalidPassword>Старый и новый пароль должны отличаться</p></div><button type=submit class=\"btn btn-primary\" ng-disabled=vm.passNoMatch>Сохранить</button></form></div>");
$templateCache.put("app/auth/register/register.html","<div class=crud-entity ng-init=\"isShortRegister = $state.current.name == \'register.shortregister\'\"><h1 class=\"main-left-offset main-right-offset\" style=\"margin-top: 49px;\" ng-show=\"$state.current.name != \'register.shortregister\'\" ng-bind=\"($ctrl.isPartner)? \'Регистрация партнера\' : \'Регистрация\'\"></h1><!-- Short registration --><div class=short-register ng-if=isShortRegister><div class=isset-domain-name ng-if=\"isShortRegister && domain\">{{domain}}</div><form ng-submit=submit() class=auth-box role=form name=$ctrl.short><h5 class=section-header>ЗАВЕРШЕНИЕ РЕГИСТРАЦИИ</h5><div class=form-group><div class=text-muted>Администратор включил вас в число пользователей системы и назначил вам логин:</div></div><div class=form-group><div class=user-login ng-show=login>{{login}}</div></div><div class=form-group><div class=text-muted>Придумайте пароль и заполните все поля для возможности входа</div></div><div class=\"form-group hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=50 name=password ng-show=showpassword required type=text ng-model=userData.password class=form-control ng-keyup=checkPassword() ng-class=\"{passNoMatch: passNoMatch}\"> <input maxlength=50 name=password ng-hide=showpassword required type=password ng-model=userData.password class=form-control ng-keyup=checkPassword() ng-class=\"{passNoMatch: passNoMatch}\"><label class=\"form-control-label small-offset\">Пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(showpassword)? \'open\' : \'\'\" ng-click=\"showpassword = !showpassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(showpassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label></div></div><div class=\"form-group hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=50 name=$$repeatedPassword ng-show=repeatedShowPassword required ng-model=userData.$$repeatedPassword type=text class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()> <input maxlength=50 name=$$repeatedPassword ng-hide=repeatedShowPassword required type=password ng-model=userData.$$repeatedPassword class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()><label class=\"form-control-label small-offset\">Повторите пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(repeatedShowPassword)? \'open\' : \'\'\" ng-click=\"showpassword = !showpassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(repeatedShowPassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label><div class=\"valid-message wrong-format passNoMatch-mess\">Пароли не совпадают</div></div></div><address address-data=userData.location name=\"\'location\'\" parent-form=$ctrl.short mode=\"\'input\'\" truncate=true timezone=userData.time_zone use-public=true field-label=\"\'Местоположение\'\"></address><div class=form-group><timezone-no-auth timezone-data=userData.time_zone field-label=\"\'Часовой пояс\'\"></timezone-no-auth></div><button type=submit class=\"btn btn-primary\" ng-disabled=\"passNoMatch || $ctrl.short.$invalid\">Сохранить</button></form></div><!-- Long registration --><form novalidate class=\"main-left-offset main-right-offset\" role=form name=$ctrl.long ng-show=\"!isShortRegister && !isSuccessRegister\"><div class=\"clearfix full-width\"><section class=\"section col-xs-9\"><h5 class=section-header>Группа</h5><div class=row><div class=\"form-group col-xs-6\"><div class=field-wrapper><input hard-pruning name=domain ng-model=userData.domain required type=text class=form-control data-check=[a-zA-Z0-9-]* maxlength=30 ng-blur=checkDomain(userData.domain) ng-keyup=checkDomain(userData.domain) ng-paste=checkDomain(userData.domain)><label class=form-control-label>Имя группы</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div class=\"form-group col-xs-6\"><span class=\"status text-danger\" ng-class=domainStatus title=\"{{domainTip}}\">{{domainTip}}</span></div></div><div class=\"form-group description\" ng-if=!$ctrl.isPartner>В качестве имени группы можно указать название вашей компании или группы компаний, название вашей сети магазинов, торговую марку, домен вашего сайта и т.п. Название группы должно быть понятно и известно всем вашим пользователям, они будут указывать его при входе в систему.</div><div class=\"form-group description\" ng-if=$ctrl.isPartner>В качестве имени группы можно указать название вашей компании, торговую марку, домен вашего сайта и т.п. Название группы должно быть понятно и известно всем вашим пользователям.<br><br>Имя группы нужно будет использовать в качестве <strong>кода партнера</strong> при регистрации привлеченных вами клиентов.</div><div class=\"form-group row\"><activity-areas class=col-xs-12 name=activityAreas ng-model=userData.company.activity_areas is-required=true field-name=\"\'Сфера деятельности\'\" has-error=noAreas style=\"padding-right: 0;\"></activity-areas></div></section></div><div class=\"clearfix full-width\"><section class=\"section col-xs-9\"><h5 class=section-header>ДАННЫЕ ДЛЯ ВХОДА</h5><div class=row><div class=\"form-group col-xs-6 phone-input-wrapper\"><input ng-class=\"{\n            \'phone-input\': userMailPhoneFlags.isPhone,\n            \'email-input\': userMailPhoneFlags.isEmail\n            }\" style=\"padding-top: 15px\" hard-pruning data-check=[a-zA-Z0-9._@\\-+\\(\\)\\s]* class=form-control maxlength=50 name=login required universal-login-input is-phone=userMailPhoneFlags.isPhone is-email=userMailPhoneFlags.isEmail only-phone-email=true ng-keypress=\"$event.key === \'Enter\' && onEnter($event)\" ng-keyup=\"$ctrl.long.login.$setValidity(\'confirmError\', true); checkPhonesUnique(); validateLoginDomain();\" ng-model=universalLogin ng-blur=\"validateLoginDomain(); (!universalLogin)? userMailPhoneFlags = {} : \'\'\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message confirm-error-mess\">Необходимо подтвердить номер</div><div class=\"valid-message phone-or-email-mess\">Некорректный телефон или email</div><div class=\"forbidden-email-domain-error text-origin\" ng-if=$ctrl.long.login.$error.forbiddenEmailDomain>Регистрация с почтовых ящиков данного домена запрещена</div><div class=\"valid-message phone-unique-mess\">Телефон администратора группы совпадает с телефоном кассира</div><div class=\"valid-message email-unique-mess\">Email администратора группы совпадает с email кассира</div><div class=\"valid-message phone-attempts-mess\">Телефон не подтвержден</div><span class=\"field-status tip-top\" ng-bind=\"(!$ctrl.long.login.$dirty)? (isPhoneConfirmed())? \'Телефон подтвержден\' : \'Телефон не подтвержден\' : \'\'\"></span><div class=input-flag ng-if=userMailPhoneFlags.isPhone><div class=flag-ru></div><div class=phone-code><span class=phone-code-text>+7</span></div></div><div class=\"input-flag email-img\" ng-if=userMailPhoneFlags.isEmail><div class=email></div><div class=phone-code></div></div><label class=form-control-label>Телефон или email</label><span class=req></span><div class=status-control ng-if=userMailPhoneFlags.isPhone><span class=\"glyphicon glyphicon-ok confirm-field-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Телефон подтвержден\" ng-if=isPhoneConfirmed()></span> <span class=no-confirm-field-ico tooltip-placement=bottom-left uib-tooltip=\"Телефон не подтвержден\" ng-if=!isPhoneConfirmed()></span></div></div><div class=\"form-group col-xs-6\" style=\"height: 48px; padding: 0;\" ng-if=!$ctrl.long.login.$error.phoneAttempts><div class=\"form-group col-xs-6\" style=\"height: 48px;\" ng-if=\"userMailPhoneFlags.isPhone && universalLogin && (!isPhoneConfirmed() || pending_phone_changes)\"><div ng-if=\"!phoneConfirmSended && !pending_phone_changes\"><a href=\"\" ng-click=sendPhoneConfirmRequest() style=\"padding-top: 13px; display: inline-block;\">Подтвердить номер</a></div><div ng-if=\"phoneConfirmSended || pending_phone_changes\"><input class=form-control id=confirm required maxlength=4 name=confirmCode ng-model=userData.$$confirmCode ng-keypress=\"$event.keyCode == 13 && checkPhoneConfirmCode() && $event.stopPropagation()\" ng-keyup=\"$ctrl.long.confirmCode.$setValidity(\'confirmError\', true);\"><label for=confirm class=form-control-label>Код из СМС</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message confirm-error-mess\" style=\"min-width: 175px;\">Введен неверный код. Осталось попыток: {{phoneAttempts}}</div><span class=req></span></div></div><div class=\"col-xs-3 no-padding-right no-padding-left\" ng-if=userMailPhoneFlags.isPhone style=\"margin-left: -15px;\"><label ng-if=\"phoneConfirmSended || pending_phone_changes\" style=\"padding-top: 12px;\"><a class=break-word href=\"\" ng-click=\"checkPhoneConfirmCode() && $event.stopPropagation()\">Подтвердить</a></label></div><div class=\"col-xs-3 no-padding-right resend-with-timer\" ng-if=\"phoneConfirmSended || pending_phone_changes\" ng-class=\"{\'disabled-link\': !userEndTimer}\" style=\"display: inline-block;\"><label><a class=break-word href=\"\" ng-click=\"sendPhoneConfirmRequest(false, true)\">Отправить повторно</a></label><div class=timer-wrapper><timer start=userTimerStart duration=61 is-end=userEndTimer></timer></div></div></div></div><div class=row><div class=\"form-group hidden-password-form-group col-xs-6\"><div class=hidden-password-wrapper><input maxlength=50 name=password ng-show=showpassword required type=text ng-model=userData.owner.password class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()> <input maxlength=50 name=password ng-hide=showpassword required type=password ng-model=userData.owner.password class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()><label class=\"form-control-label small-offset\">Пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(showpassword)? \'open\' : \'\'\" ng-click=\"showpassword = !showpassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(showpassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label></div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group hidden-password-form-group col-xs-6\"><div class=hidden-password-wrapper><input maxlength=50 name=$$repeatedPassword ng-show=repeatedShowPassword required ng-model=userData.$$repeatedPassword type=text class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()> <input maxlength=50 name=$$repeatedPassword ng-hide=repeatedShowPassword required type=password ng-model=userData.$$repeatedPassword class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()><label class=\"form-control-label small-offset\">Повторите пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(repeatedShowPassword)? \'open\' : \'\'\" ng-click=\"repeatedShowPassword = !repeatedShowPassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(repeatedShowPassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label><div class=\"valid-message wrong-format passNoMatch-mess\">Пароли не совпадают</div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><span class=req></span></div></div></section></div><div class=\"clearfix full-width\"><section class=\"section col-xs-9\"><h5 class=section-header>ПЕРСОНАЛЬНЫЕ ДАННЫЕ</h5><div class=row><div class=\"form-group col-xs-6\"><input hard-pruning maxlength=150 name=lastName ng-model=userData.owner.surname required type=text class=form-control data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]{1,64}\" ng-blur=checkNameUnique();><label class=form-control-label>Фамилия</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message data-unique-mess text-origin\">ФИО администратора группы совпадает с ФИО кассира</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input hard-pruning maxlength=150 name=firstName ng-model=userData.owner.name required type=text class=form-control data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]{1,64}\" ng-blur=checkNameUnique();><label class=form-control-label>Имя</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message data-unique-mess text-origin\">ФИО администратора группы совпадает с ФИО кассира</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input hard-pruning maxlength=150 name=patronymic ng-model=userData.owner.patronymic type=text class=form-control data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]{1,64}\" ng-blur=checkNameUnique();><label class=form-control-label>Отчество</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message data-unique-mess text-origin\">ФИО администратора группы совпадает с ФИО кассира</div></div><div class=\"form-group col-xs-6\"><input empty-to-null hard-pruning data-check=([0-9_]) pattern=^(\\d{12})$ type=text inn-check maxlength=12 class=form-control inn-type=fiz name=ownerInn id=ownerInn ng-model=userData.owner.inn ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-blur=checkInnUnique()><label for=ownerInn class=form-control-label>ИНН</label><span class=\"valid-message invalid-inn-mess text-origin\">ИНН должен содержать 12 цифр</span><div class=\"valid-message data-unique-mess text-origin\">ИНН администратора группы совпадает с ИНН кассира</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=$ctrl.long.ownerInn.$error.validInn>Такой номер не существует</span></div><div class=\"form-group col-xs-6\"><address address-data=userData.owner.location name=\"\'location\'\" parent-form=$ctrl.long mode=\"\'input\'\" truncate=true postal-index=false timezone=userData.owner.time_zone use-public=true address-controls=addressControls field-label=\"\'Город или населенный пункт\'\"></address></div><div class=\"form-group col-xs-6\"><timezone-no-auth class=register timezone-data=userData.owner.time_zone field-label=\"\'Часовой пояс\'\"></timezone-no-auth></div></div></section></div><div class=more-data-wrapper ng-class=\"{\'slide-up\': registerCtrl.moreFields}\" ng-include=\"\'app/auth/register/includes/mode-data.html\'\"></div><div class=\"clearfix full-width\"><section class=\"section col-xs-9\"><h5 class=section-header style=\"display: inline-block\">СОГЛАШЕНИЕ И СОГЛАСИЕ</h5><span class=req></span><div class=check-wrapper style=\"height: 40px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=accept id=accept required> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=accept ng-if=!$ctrl.isPartner class=checkbox-label>Принимаю условия <a target=_blank href=http://файлы.торговля.онлайн/offer.pdf>договора-оферты</a> и <a target=_blank href=http://файлы.торговля.онлайн/license-agreement.pdf>лицензионного соглашения</a></label><label for=accept ng-if=$ctrl.isPartner class=checkbox-label>Принимаю условия <a target=_blank href=http://файлы.торговля.онлайн/partner_offer.pdf>партнерского договора-оферты</a></label></div><div class=check-wrapper style=\"height: 40px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=accept2 id=accept2 required> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=accept2 class=checkbox-label>Даю <a target=_blank href=http://файлы.торговля.онлайн/pd_consent.pdf>согласие</a> на обработку персональных данных (<a target=_blank href=http://файлы.торговля.онлайн/pd_policy.pdf>политика</a> обработки персональных данных)</label></div></section></div><div class=full-width ng-if=!$ctrl.isPartner><span class=link-style ng-click=openPromo(); ng-bind=\"(userData.promo_code || userData.partner_code)? \'Изменить код партнера или промо-код\' : \'Ввести код партнера или промо-код\'\"></span></div><div class=form-group><p id=wrongRegister class=wrong-data ng-show=isWrongRegisterData>{{errorMessage}}</p></div><span class=req-inform ng-show=\"$ctrl.long.$submitted && (!accept || !accept2 || domainStatus == \'error\' || passNoMatch || noAreas || $ctrl.long.$invalid)\">Поля, помеченные *, обязательные для заполнения</span><div class=\"clearfix full-width\"><div class=\"edit-view-buttons bottom-buttons section col-xs-9\"><button type=submit class=\"btn btn-primary right-button\" ng-disabled=\"$ctrl.long.login.$error.forbiddenEmailDomain || ($ctrl.long.$submitted && (!accept || !accept2 || domainStatus == \'error\' || passNoMatch || noAreas || $ctrl.long.$invalid))\" ng-click=\"noAreas = !userData.company.activity_areas.length; submit();\">Зарегистрироваться</button> <a ng-click=$ctrl.returnToPage() class=\"btn right-button\">Отменить</a></div></div></form><div class=\"main-left-offset main-right-offset\" ng-show=isSuccessRegister><section class=\"section col-xs-9\"><div ng-if=userMailPhoneFlags.isEmail><div style=\"margin-bottom: 15px;\">Для завершения регистрации в системе перейдите по ссылке из письма, отправленного вам на адрес:</div><a href=\"mailto:{{(userMailPhoneFlags.isEmail)? universalLogin : userData.owner.email}}\" class=user-mail>{{(userMailPhoneFlags.isEmail)? universalLogin : userData.owner.email}}</a></div><div ng-if=\"userMailPhoneFlags.isPhone && isPhoneConfirmed()\">Поздравляем! Регистрация прошла успешно. Для начала работы в системе необходимо <a ui-sref=login>авторизоваться</a>.</div></section></div></div>");
$templateCache.put("app/base/deadend/deadend.html","<div class=deadend-wrapper><div class=status-wrapper><span class=status-code ng-bind-html=status></span></div><div class=title-wrapper><span class=title>{{title | lowercase}}</span></div><div class=message><deadend-text></deadend-text></div></div>");
$templateCache.put("app/base/header/header.html","<!-- header of settings --><header class=\"header major-font main-left-offset main-right-offset\" role=navigation><a class=\"logo landing-path\" href=\"\"></a> <a class=\"logo indicators-path\" ui-sref=\"{{$root.hasRole(\'report.sale_totals\') ? \'indicators\' : \'business\'}}\"></a><!-- <div class=\"contacts-wrapper\">\n    <span class=\"contact-label\">телефон поддержки:</span>\n    <span class=\"contact-phone\">8 (800) 866-89-09</span>\n  </div> --><div class=\"user-box pull-right btn-group\" style=\"display: none; position: inherit;\"><div class=user-info><span class=text-right><a ui-sref=editProfile class=user-name ng-bind=$ctrl.getName()></a><br><!-- ng-bind=\"$ctrl.getName() + \',\'\" --><!-- <span ng-if=\"$root.hasRole(\'invite.friend\')\" class=\"hover-underline pull-right invite-friends-link\" ng-click=\"$ctrl.openInvitationModal()\">пригласите друзей!</span> --> </span><span class=admin-role>администратор</span></div><div class=user-buttons><div class=user-img style=\"background-image: url({{$ctrl.getPic()}})\" ng-bind=\"(!$ctrl.getPic())? $ctrl.initials : \'\'\"></div></div><span class=\"dropdown dropdown-toggle\" data-toggle=dropdown><span class=text-muted>Меню</span><span class=caret></span></span><ul class=\"main-dropdown dropdown-menu\" ng-style=\"(!$root.hasRole(\'user_cart.read\'))?{\'right\': \'70px\'} : \'\'\" ng-class=\"{\'item-length-5\': $root.hasRole(\'paid_service.read\')}\"><li><a ui-sref=editProfile>Профиль</a></li><li ng-if=\"$root.hasRole(\'paid_service.read\')\"><a ui-sref=paidServices>Услуги</a></li><li><a ui-sref=support ng-if=\"$root.user.login !== \'demo\' && $root.user.domain !== \'demo\'\">Поддержка</a> <a ng-disabled=\"$root.user.login == \'demo\' && $root.user.domain == \'demo\'\" uib-tooltip=\"Для обращения авторизируйтесь под своей учетной записью\" ng-if=\"$root.user.login == \'demo\' && $root.user.domain == \'demo\'\">Поддержка</a></li><li><a ui-sref=mainSettings>Настройки<span class=gear></span></a></li><li class=devider></li><li><a ng-click=$ctrl.logout() class=clearfix><span class=pull-left>Выйти</span> <span class=\"out-ico pull-right\"></span></a></li></ul><a ui-sref=messages class=bell><span class=\"badge badge-light count\" ng-bind=$ctrl.messagesCount ng-if=$ctrl.messagesCount></span> </a><a ui-sref=cart ui-sref-opts=\"{reload: true}\" class=cart-icon ng-if=\"$root.hasRole(\'user_cart.read\')\"><span class=\"badge badge-light count\" ng-bind=$root.cartCount ng-if=$root.cartCount></span></a></div><div class=\"navbar navbar-default no-auth-nav pull-right\" role=navigation ng-hide=\"$ctrl.state.current.name === \'registerPartner\'\"><div class=navbar-collapse ng-if=\"!($ctrl.state.current.name === \'deadend\' &&  $ctrl.state.params.reason === \'deploy\')\"><ul class=\"nav navbar-nav\"><li ui-sref-active-eq=active><a href=http://xn--b1abzjbkm4i.xn--80asehdb/ >О системе</a></li><li ui-sref-active-eq=active><a ui-sref=register>Регистрация</a></li><li ui-sref-active-eq=active><a ui-sref=login>Вход</a></li></ul></div></div></header><!-- end header of settings --><div class=main-menu ng-include=\"\'app/base/header/navbar/navbar.html\'\" style=\"display: none;\"></div>");
$templateCache.put("app/cart/includes/buttons.html","<div class=control-button-line-container><span class=\"btn btn-ico-wrap\" ng-click=cartCtrl.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</span> <button class=\"btn only-ico\" ng-click=cartCtrl.openDeleteDialog()><span class=\"glyphicon glyphicon-trash btn-ico\"></span> Очистить</button></div>");
$templateCache.put("app/catalog/alcoholSettings/alcohol-settings.html","<div class=\"crud-entity alcohol-settings main-left-offset main-right-offset\"><!-- content of settings --><ul class=breadcrumbs><li><a>РОЗНИЦА</a> <span class=divider></span></li><li><a ui-sref=\"alcoholSettings({parent: \'alcohol\'})\">Настройки реализации алкогольной продукции</a></li></ul><h1>Настройки реализации алкогольной продукции</h1><form role=form name=alcoholSettings><div class=\"clearfix full-width\"><section class=col-xs-9><div class=\"checkbox pull-left\" style=\"margin-top: 8px;margin-bottom: 0;\"><label style=\"padding: 0\"><input type=checkbox ng-model=vm.alcoholSettings.alcohol_products id=enabled-check> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=enabled-check style=\"margin-top: 8px;display: inline-block;font-weight: 100\">Продавать алкоголь в магазинах</label></section></div><div ng-if=vm.alcoholSettings.alcohol_products ng-include=\"\'app/catalog/alcoholSettings/sections/attributes.html\'\" class=\"clearfix full-width\"></div><div ng-if=vm.alcoholSettings.alcohol_products ng-include=\"\'app/catalog/alcoholSettings/sections/alcohol_accounting.html\'\" class=\"clearfix full-width\"></div><alcohol-calendar settings=vm.alcoholSettings form-ctrl=alcoholSettings class=\"clearfix full-width\" style=\"display: flex; align-items: flex-end;\" ng-if=vm.alcoholSettings.alcohol_products></alcohol-calendar><div ng-if=vm.alcoholSettings.alcohol_products ng-include=\"\'app/catalog/alcoholSettings/sections/divisions.html\'\" class=clearfix></div><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=alcoholSettings can-show=vm.isSetDirty></form-errors><form-buttons view-type=\"{isEdit: true}\" on-button=vm.crud(status) hide-delete=true can-disabled=\"(vm.isSetDirty && (!alcoholSettings.$valid || vm.errorAttrInd.length)) || vm.isHasValidErrors(alcoholSettings.$error)\"></form-buttons></div></form></div>");
$templateCache.put("app/catalog/attrSettings/attrSettings.html","<div class=\"settings catalog crud-entity attributes-settings\"><!-- content of settings --><div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-when=retail><a>Розница</a></li><li ng-switch-when=storehouse><a>Склад</a></li><li ng-switch-default><a>Розница</a></li><li><a ui-sref=\"catalog({parent: $state.params.parent})\">Товары и услуги</a></li></ul><h1>Настройки</h1><form ng-submit=vm.submit() role=form name=attrSettings><div class=\"full-width clearfix\"><section class=\"form-group col-xs-8 title-out-group\"><h5 class=section-header>Автоматическое формирование кодов</h5><div class=clearfix><div class=\"checkbox-group col-xs-8\" style=\"display: inline-block;padding: 0;margin-top: 8px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.use_auto_codes ng-change=\"vm.settings.use_auto_codes == true && vm.settings.code_len == null ? vm.settings.code_len = 5 : \'\' \" id=use_auto_codes ng-change=\"vm.settings.code_len = null\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=use_auto_codes>Автоматическое формирование кода позиции</label></div><div class=\"pull-right col-xs-4\" ng-if=vm.settings.use_auto_codes><label for=code_len class=\"col-xs-7 text-right\" style=\"margin-top: 8px;padding: 0;\">длина кода</label><div class=\"form-group col-xs-5\" style=\"margin-bottom: 0; min-width: 100px; margin-right: -40px;\"><input type=text required hard-pruning name=format data-check=^(1[0-2]|[0-9]){1}$ ng-pattern=/^(1[0-2]|[2-9]){1}$/ class=\"form-control text-center slim-control\" ng-model=vm.settings.code_len id=code_len ng-change=vm.changeExample() maxlength=2> <span class=req ng-show=vm.settings.use_auto_codes></span></div></div></div></section><div class=\"col-xs-4 section-helper\" style=\"margin-top: 68px;\" ng-if=\"vm.settings.use_auto_codes && vm.settings.code_len && vm.settings.code_len > 1 && vm.settings.code_len < 13\">Возможные значения<br><span ng-bind=vm.exMin></span> - <span ng-bind=vm.exMax></span></div></div><div class=\"full-width clearfix\"><section class=\"form-group title-out-group col-xs-8\"><h5 class=section-header>Автоматическое создание штрих-кодов</h5><div class=clearfix><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.generate_barcode id=generate_barcode> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=generate_barcode>Автоматическое создание собственных штрих-кодов для товаров</label></div><div class=row ng-if=vm.settings.generate_barcode style=\"margin-top: 15px;\"><div class=\"form-group col-xs-3\"><ui-select ng-model=vm.settings.barcode_format search-enabled=false on-select=\"vm.changeFormat(\'barcode_format\', \'barcode_length\')\" ng-required=true><ui-select-match><span ng-bind=$select.selected></span></ui-select-match><ui-select-choices repeat=\"format in vm.formates track by $index\"><span ng-bind-html=format></span></ui-select-choices></ui-select><label class=form-control-label>Формат штрих-кода</label><span class=req></span></div><div class=\"form-group col-xs-3\"><input name=barcode_length ng-required=true type=text class=form-control maxlength=2 ng-model=vm.settings.barcode_length float-input max-val=20 min-val=4 float-fixed=0 float-step=1 max-after-comma=0 ng-disabled=\"vm.settings.barcode_format !== \'Code39\'\"><label class=form-control-label>Длина штрих-кода</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message max-mess\">Длина штрих-кода не должна быть больше 20</div><div class=\"valid-message min-mess\">Длина штрих-кода не должна быть меньше 4</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input name=barcode_first_digits id=barcode_first_digits type=text class=form-control maxlength=\"{{vm.settings.barcode_length - 3}}\" ng-model=vm.settings.barcode_first_digits hard-pruning data-check=[0-9]><div class=\"valid-message invalid-maxlength\">Для данной длины штрих-кода количество первых цифр не может превышать {{vm.settings.barcode_length - 3}}</div><label class=form-control-label>Префикс штрих-кода</label></div></div><div class=clearfix><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.generate_weight_barcode id=generate_weight_barcode> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=generate_weight_barcode>Использование весовых штрих-кодов</label></div><div class=row ng-if=vm.settings.generate_weight_barcode style=\"margin-top: 15px;\"><div class=\"form-group col-xs-3\"><ui-select ng-model=vm.settings.weight_barcode_format search-enabled=false on-select=\"vm.changeFormat(\'weight_barcode_format\', \'weight_barcode_length\'); vm.changeCode();\" ng-required=true><ui-select-match><span ng-bind=$select.selected></span></ui-select-match><ui-select-choices repeat=\"format in vm.formatesShort track by $index\"><span ng-bind-html=format></span></ui-select-choices></ui-select><label class=form-control-label>Формат штрих-кода</label><span class=req></span></div><div class=\"form-group col-xs-3\"><input name=weight_barcode_length required type=text class=form-control maxlength=2 ng-model=vm.settings.weight_barcode_length float-input max-val=20 min-val=4 float-fixed=0 float-step=1 max-after-comma=0 ng-change=\"vm.settings.weight_barcode_prefix = (vm.settings.weight_barcode_length == 4)? 2 : vm.settings.weight_barcode_prefix; vm.changeCode();\" ng-disabled=\"vm.settings.weight_barcode_format !== \'Code39\'\"><label class=form-control-label>Длина штрих-кода</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message max-mess\">Длина штрих-кода не должна быть больше 20</div><div class=\"valid-message min-mess\">Длина штрих-кода не должна быть меньше 4</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input name=weight_barcode_prefix id=weight_barcode_prefix type=text class=form-control maxlength=20 ng-model=vm.settings.weight_barcode_prefix hard-pruning data-check=[0-9] ng-change=vm.changeCode(); ng-required=true><div class=\"valid-message invalid-maxlength\">Для данной длины штрих-кода количество первых цифр не может превышать {{vm.settings.barcode_length - 3}}</div><label class=form-control-label>Префикс штрих-кода</label><span class=req></span></div><div class=\"form-group col-xs-6\"><ui-select ng-model=vm.settings.weight_barcode_source search-enabled=false ng-required=true><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"source.id as source in vm.sources track by $index\"><span ng-bind-html=source.name></span></ui-select-choices></ui-select><label class=form-control-label>Источник кода</label><span class=req></span></div><div class=\"form-group col-xs-3\"><input name=weight_barcode_code id=weight_barcode_code type=text class=form-control maxlength=20 ng-model=vm.settings.weight_barcode_code hard-pruning data-check=[0-9] ng-change=vm.changeWeight(); ng-required=true title=\"Значение должно быть больше 0\"><label class=form-control-label>Длина кода</label><span class=req></span><div class=\"valid-message required-mess\">Значение должно быть больше 0</div></div><div class=\"form-group col-xs-3\"><input name=weight_barcode_weight id=weight_barcode_weight type=text class=form-control ng-model=vm.settings.weight_barcode_weight ng-disabled=true ng-required=true title=\"Значение должно быть больше 0\"><label class=form-control-label>Длина веса</label><span class=req></span><div class=\"valid-message required-mess\">Значение должно быть больше 0</div></div></div></section><div class=\"col-xs-3 section-helper\" style=\"margin-top: 5px;\">Данная настройка позволяет создавать собственные штрих-коды на карточке товара для продажи штучного и весового товара. При выборе формата \"Code39\" пользователь может определить длину штрих-кода от 4 до 20 цифр.</div></div><div class=\"full-width clearfix\"><section class=\"form-group title-out-group col-xs-8\"><h5 class=section-header>Товар по свободной цене</h5><div class=clearfix><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.use_freeprice_item id=use_freeprice_item> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=use_freeprice_item>Использовать товар по свободной цене в кассовом приложении</label></div></section><div class=\"col-xs-3 section-helper\" style=\"margin-top: 5px;\">Чтоб изменение настройки использования товара по свободной цене вступило в силу, необходимо перезапустить кассовое приложение</div></div><div class=\"full-width clearfix\"><section class=\"form-group title-out-group col-xs-8\" style=\"min-height: 140px\"><h5 class=section-header>Уникальность артикулов</h5><div class=clearfix><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.unique_vendor_code id=unique_vendor_code ng-change=vm.changeUniqueVendorCode();> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=unique_vendor_code>Проверять уникальность артикулов производителей</label></div></section><div class=\"col-xs-4 section-helper\" style=\"margin-top: 5px;\">Если включить проверку уникальности артикулов производителей, то нельзя будет в карточке товара задать артикул производителя, который уже используется для другого товара. Если же выключить проверку уникальности, можно один и тот же артикул производителя назначать разным товарам.</div></div><div class=\"full-width clearfix\"><section class=\"form-group title-out-group col-xs-8\"><h5 class=section-header>Атрибуты категории</h5><div class=clearfix><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.use_category_attributes ng-disabled=vm.hasAlcoholProducts id=use_category_attributes ng-change=\"vm.settings.inherit_category_attributes = vm.settings.use_category_attributes\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=use_category_attributes>Использовать атрибуты категорий</label></div></section><div class=\"col-xs-4 section-helper\" ng-if=vm.hasAlcoholProducts>Чтобы отключить использование атрибутов при создании категории необходимо отключить продажу алкогольной продукции в <a ui-sref=\"alcoholSettings({parent: \'alcohol\'})\">Настройках реализации алкогольной продукции</a></div><div class=\"col-xs-4 section-helper\" ng-if=!vm.hasAlcoholProducts>Если включить использование атрибутов категорий, можно будет в карточке любой категории определить произвольнй набор атрибутов. Атрибуты категории становятся атрибутами товаров, входящих в категорию, и доступны для редактирования на карточке товара.</div></div><div class=\"full-width clearfix\" style=\"margin-bottom: 24px;\"><section class=\"form-group col-xs-8\" style=\"padding-right: 16px;\"><h5 class=section-header>Атрибуты упаковки</h5><div class=clearfix style=\"margin-bottom: 20px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.use_pack_attributes id=use_pack_attributes> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=use_pack_attributes>Использовать атрибуты для упаковок</label></div><div ng-show=vm.settings.use_pack_attributes class=col-xs-12><attributes parent-form=attrSettings data=vm.settings.elements category=vm.settings kind=\"\'pack\'\" valid=vm.checkAttrError isset-req-attr=vm.issetReqAttr></attributes></div></section><div class=\"col-xs-4 section-helper\" style=\"margin-top: 20px;\" ng-show=vm.settings.use_pack_attributes><ul class=descr-ico><li class=one></li><li class=many></li><li class=transport></li></ul>Здесь вы можете настроить атрибуты, значения для которых можно будет задавать в карточке товара для каждой упаковки товара.</div></div><div class=\"section bottom-buttons col-xs-9\"><form-errors form-ctrl=attrSettings can-show=vm.isSetDirty></form-errors><form-buttons view-type=\"{isEdit: true}\" on-button=vm.crud(status) hide-delete=true can-disabled=\"(vm.isSetDirty && (!attrSettings.$valid || vm.wrongData)) || vm.isHasValidErrors(attrSettings.$error)\"></form-buttons></div></form></div></div>");
$templateCache.put("app/catalog/catalogItem/catalogServices.html","<div class=\"catalog crud-entity catalogItem main-left-offset main-right-offset\"><!-- content of settings --><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-when=retail><a>Розница</a></li><li ng-switch-when=storehouse><a>Склад</a></li><li ng-switch-default><a>Розница</a></li><li><a ui-sref=\"catalog({parent: $state.params.parent})\">Товары и услуги</a></li></ul><div ui-view></div></div>");
$templateCache.put("app/catalog/catalogItem/catalogSkus.html","<div class=\"catalog crud-entity catalogItem main-left-offset main-right-offset\"><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-when=retail><a>Розница</a></li><li ng-switch-when=storehouse><a>Склад</a></li><li ng-switch-default><a>Розница</a></li><li><a ui-sref=\"catalog({parent: $state.params.parent})\">Товары и услуги</a></li></ul><div ui-view></div></div>");
$templateCache.put("app/catalog/crudAttribute/ask-delete.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title>Подтверждение удаления</h3></div><div class=container ng-if=canDelete><div class=modal-main-text style=\"min-height: 130px;\"><span class=decription ng-if=\"categoryName && isBlock\">Вы действительно хотите удалить группу атрибутов <strong>«{{name}}»</strong> из категории <strong>«{{categoryName}}»</strong> и всех товаров и услуг в этой категории?</span> <span class=decription ng-if=\"!categoryName && isBlock\">Вы действительно хотите удалить группу атрибутов из упаковок всех товаров?</span> <span class=decription ng-if=\"categoryName && !isBlock\">Вы действительно хотите удалить атрибут <strong>«{{name}}»</strong> из категории <strong>«{{categoryName}}»</strong> и всех товаров и услуг в этой категории?</span> <span class=decription ng-if=\"!categoryName && !isBlock\">Вы действительно хотите удалить атрибут из упаковок всех товаров?</span><div class=\"delete-method row\" ng-if=isBlock style=\"margin-top: 24px;\"><div class=\"form-group col-xs-12\"><div class=\"radio pull-left\" style=\"margin: 0 15px 0 0;\"><label><input type=radio name=delete ng-model=deleteType.value ng-value=\"\'block\'\" id=delete-from-category> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=delete-from-category>Удалить группу без атрибутов</label></div><div class=\"form-group col-xs-12\"><div class=\"radio pull-left\" style=\"margin: 0 15px 0 0;\"><label><input type=radio name=delete ng-model=deleteType.value ng-value=\"\'all\'\" id=delete-from-all> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=delete-from-all>Удалить группу со всеми атрибутами</label></div></div></div></div><div class=modal-footer ng-if=canDelete><button class=btn type=button ng-click=close()>Нет</button> <button class=\"btn btn-primary\" type=button ng-click=delete()>Да</button></div><div class=container ng-if=!canDelete><div class=modal-main-text style=\"min-height: 130px;\"><span class=decription ng-if=\"deleteType.value == \'block\'\">Удаление атрибута \"{{name}}\" невозможно, так как он участвует в формировании складских позиций.</span> <span class=decription ng-if=\"deleteType.value !== \'block\'\">Удаление группы вместе с атрибутами невозможно, так как они участвуют в формировании складских позиций.</span></div></div><div class=modal-footer ng-if=!canDelete><button class=btn type=button ng-click=close()>Закрыть</button></div><div class=lock-bg ng-show=lock><div class=ui-spinner></div></div>");
$templateCache.put("app/catalog/crudAttribute/crud-attribute.html","<form name=crudAttribute class=\"container modal-attribute crud-entity\" style=\"padding: 0\"><div class=modal-body><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title ng-bind=\"(isCreate)? \'Добавление атрибута\' : \'Редактирование атрибута\'\" ng-if=!editGroup></h3><h3 class=modal-title ng-if=editGroup>Редактирование группы</h3><span class=\"modal-description text-muted\" ng-if=!editGroup>Если вы не нашли необходимые атрибуты, вы можете создать свои и при необходимости объединить<br>их в группы</span><div class=row style=\"margin-top: 24px;\"><div class=col-xs-6><div class=\"form-group hide-caret\" ng-if=!editGroup ng-class=\"{\'has-error-unique\': attrNameError, \'open\': isOpenNameObj.isOpen && attributesList.length}\" ng-style=\"(isCreate)? {\'padding-right\': \'0px\', \'margin-bottom\': \'0px\'} : \'\'\"><combobox ng-model=element.name refresh=refreshAttr is-required=true id-name=attrAuto is-disabled=false maxlength=128 choose=getAttrInform param=\"\'name\'\" arr-items=attributesList ng-if=isCreate field-label=\"\'Название\'\" is-open=isOpenNameObj blur-event=checkAttrInCombo></combobox><input empty-to-null type=text class=form-control name=name ng-if=!isCreate id=attr-name ng-model=element.name maxlength=128 required ng-blur=\"uniqueCheck(element.name, \'attr\')\" ng-keydown=resetErrors()><label for=attr-name class=\"form-control-label small-offset\" ng-if=!isCreate>Название</label><div class=\"valid-message required-mess small-offset\">Поле является обязательным</div><div class=\"valid-message isset-name small-offset\" ng-bind=attrNameError></div></div><div class=\"form-group checkbox-group\" ng-if=!editGroup style=\"margin: 0;padding: 16px 0 24px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=element.required> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox>Обязательно для ввода</label></div><div class=form-group ng-if=editGroup ng-class=\"{\'has-error-unique\': blockNameError}\"><input empty-to-null type=text class=form-control name=attrName ng-blur=\"uniqueCheck(element.name, \'group\')\" id=attr-name ng-model=element.name maxlength=128 required ng-keydown=resetErrors()><label for=attr-name class=\"form-control-label small-offset\">Название группы</label><div class=\"valid-message isset-name\" ng-bind=blockNameError></div><span class=req></span></div><div class=\"form-group hide-caret\" ng-if=!editGroup style=\"padding-right: 0\" ng-class=\"{\'has-error\': blockNameError, \'open\': isOpenGroupObj.isOpen && attrBlocks.length}\"><combobox ng-model=element.block.name refresh=refreshAttrBlocks is-required=false id-name=blockAuto is-disabled=disabledGroup maxlength=128 choose=getBlockInfo param=\"\'name\'\" isset-mess=blockNameError arr-items=attrBlocks field-label=\"\'Группа\'\" is-open=isOpenGroupObj></combobox><div class=\"valid-message isset-name\" ng-bind=blockNameError></div></div><div class=form-group ng-if=!editGroup><ui-select ng-model=element.data_type search-enabled=false ng-required=true on-select=selectDataType(element.data_type) ng-disabled=\"!isCreate || disabledDataType\" class=show-all-options><ui-select-match><span ng-bind=$select.selected.value></span></ui-select-match><ui-select-choices repeat=\"value.key as (key, value) in dataType\"><span ng-bind=value.value></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Значение</label><span class=req ng-if=isCreate></span></div><div class=\"form-group data-type-tip\" ng-if=!editGroup><span ng-if=\"element.data_type == \'DICTIONARY\'\">Будет предложено несколько вариантов значений с возможностью выбрать один вариант</span> <span ng-if=\"element.data_type == \'BOOLEAN\'\">Будет предложено выбрать одно из значений «Да» или «Нет»</span></div></div><div class=\"col-xs-6 grey-box\" ng-scrollbars ng-scrollbars-config=configScroll><div class=\"modal-form clearfix\" ng-show=!editGroup ng-class=\"{ heightInherit: (editGroup || autocompleteBlock.attributes.length) && !autocompleteBlock.$$isset, \'small-height\': editGroup}\"><div ng-if=\"element.data_type == \'DICTIONARY\'\" ng-init=\"setFocus(true,\'#dictValue0\')\"><span class=\"type-title major-font\">ВАРИАНТЫ ВЫБОРА:</span><div class=dict-wrapper><div class=\"form-group dictionary-val\" ng-repeat=\"val in element.values track by $index\"><span class=dictionary-val-index>{{$index + 1}}</span><input type=text maxlength=255 class=\"form-control slim-control\" ng-model=val.value ng-keyup=\"checkDictVal($event, val.value);\" title=\"{{val.value}}\" id=\"{{\'dictValue\'+$index}}\" ng-required=\"$index < 2\" ng-class=\"{\'has-error\': errorInd.length && errorInd.indexOf($index)+1}\"> <span class=req ng-if=\"$index < 2\"></span><div class=\"valid-message required-mess\" style=\"left: 20px;\">Поле является обязательным</div><span class=\"valid-message isset-name\" style=\"left: 20px;\">Значение уже существует</span></div></div><div class=form-group style=\"margin-left: 17px;\"><div class=add-item-wrap ng-click=addDictionaryVal();><span class=add-item-icon></span> <span class=add-item-title>Элемент</span></div></div></div><div ng-if=\"element.data_type == \'BOOLEAN\'\"><span class=\"type-title major-font\">ВАРИАНТЫ ВЫБОРА:</span><div class=boolean-value><span>1</span> ДА</div><div class=boolean-value><span>2</span> НЕТ</div></div></div><div class=\"modal-form clearfix\" ng-show=editGroup><div class=\"sub-attr-title major-font\">АТРИБУТЫ ГРУППЫ</div><div class=\"form-group clearfix choose-attributes moreHeight\"><div class=container-attr><ul class=list-attributes><li class=attr ng-repeat=\"item in element.attributes\"><input type=checkbox ng-model=item.$$enabled id=\"dict{{$index}}\"><label for=\"dict{{$index}}\">{{item.name}}<span class=req ng-if=item.required></span></label></li></ul></div></div></div></div></div><div ng-show=\"autocompleteBlock.attributes.length && !autocompleteBlock.$$isset && showAnotherAttrBox\" class=sub-attr-wrapper><div class=sub-attr-wrapper-animation ng-class=\"{\'show\': showAnotherAttrBox}\"><div class=sub-attr-title>Вы можете добавить и другие атрибуты из группы «{{element.block.name}}»:</div><div class=\"form-group clearfix choose-attributes\" style=\"min-height: 110px;\" ng-scrollbars ng-scrollbars-config=configScrollAtttr><div class=container-attr><ul class=list-attributes><li class=attr ng-repeat=\"item in autocompleteBlock.attributes\" ng-hide=item.$$isset>{{item.$$isset}} <input type=checkbox ng-model=item.$$enabled id=\"attr{{$index}}\"><label for=\"attr{{$index}}\">{{item.name}}<span class=req ng-if=item.required></span></label></li></ul></div></div></div></div></div><div class=modal-footer style=\"min-height: 105px;\"><div class=\"req-inform pull-left text-left\" ng-if=\"isSetDirty && (!crudAttribute.$valid || blockNameError || attrNameError || errorInd.length)\">* Обязательные для заполнения поля</div><button class=\"btn pull-left\" type=button ng-click=addAttribute() style=\"width: auto;\" ng-show=editGroup><span class=\"btn-ico btn-plus btn-plus-dark\"></span>атрибут</button> <span class=\"link-style pull-left\" ng-if=\"!editGroup && autocompleteBlock.attributes.length && !autocompleteBlock.$$isset\" ng-click=showBox(); style=\"max-width: 68%;\">{{(showAnotherAttrBox)? \'Скрыть\' : \'Добавить\'}} другие атрибуты из группы «{{element.block.name}}»</span> <button class=btn type=button ng-click=close() ng-if=!showAnotherAttrBox>Отменить</button> <a class=\"btn btn-primary\" ng-click=\"(!crudAttribute.$valid || blockNameError || attrNameError || errorInd.length)? setDirty() : save(element.block)\" ng-bind=\"(isCreate)? \'Добавить\' : \'Сохранить\'\" ng-disabled=\"isSetDirty && (!crudAttribute.$valid || blockNameError || attrNameError || errorInd.length)\" ng-if=!showAnotherAttrBox></a></div></form>");
$templateCache.put("app/catalog/crudCategory/crudCategory.html","<div class=\"catalog crud-entity category-crud main-left-offset main-right-offset\" ng-class=\"(vm.state.current.name === \'category.view\')? \'view-entity\': \'\'\"><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-when=retail><a>Розница</a></li><li ng-switch-when=storehouse><a>Склад</a></li><li ng-switch-default><a>Розница</a></li><li><a ui-sref=\"catalog({parent: $state.params.parent})\">Товары и услуги</a></li></ul><div ng-if=\"vm.state.current.name === \'category.new\'\"><h1>Добавление категории</h1></div><div ng-if=\"vm.state.current.name === \'category.edit\'\"><h1>Редактирование категории</h1></div><ng-form role=form name=addCategory><div class=\"col-xs-9 section top-buttons\" ng-if=!vm.mode.isNew><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"vm.isSetDirty && (!addCategory.$valid || vm.wrongData)\"></form-buttons></div><div class=clear></div><div ng-include=\"\'app/catalog/crudCategory/sections/searchItem.html\'\" ng-hide=vm.showAllInform></div><div ng-show=vm.showAllInform class=row><div class=\"clearfix full-width\"><section id=nameAnchor class=col-xs-9 ng-class=\"{\'has-error-unique\': addCategory.name.$invalid && addCategory.name.$error.unique}\"><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group col-xs-12\"><input empty-to-null required type=text class=form-control ng-model=vm.category.name maxlength=150 title=vm.category.name name=name ng-blur=vm.uniqueCheck(vm.category.name) ng-keyup=\"addCategory.name.$setValidity(\'unique\', true)\" id=name><label for=name class=form-control-label>Название категории</label><div class=req></div><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=addCategory.name.$error><div ng-message=unique class=\"valid-message isset-name\">Категория уже существует</div></div></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0;\"><ui-select ng-model=vm.category.project ng-hide=\"vm.state.current.name === \'category.view\'\" search-enabled=\"vm.projectsFullTotal > 5\" ng-class=\"{\'autocomplete-select\': vm.projectsFullTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.refreshProjects($select.search) repeat=\"item in ( vm.projects.items | filter: $select.search) track by $index\" group-by=vm.totalSelectStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Проект</label><div ng-if=\"vm.state.current.name === \'category.view\'\" class=view-entity-control>{{vm.category.project.name || \'-\'}}</div></div></div></section></div><div class=\"clearfix full-width\"><section class=\"form-group col-xs-9\" style=\"margin-right: 0\"><h5 class=section-header style=\"margin-bottom: 10px;\">Расположение категории</h5><div class=category-location ng-class=\"{\'no-selection\': vm.state.current.name !== \'category.new\'}\"><catalog-tree class=background-simple root-visible=true expand-node=\"(vm.state.current.name === \'category.new\')? vm.expand : \'\'\" drag-change-callback=vm.dragChange item-count=none show-arrow=\"vm.state.current.name === \'category.new\'\" root-always-expand=true block-expand=false block-nodes-expand=vm.pathCatagory root=vm.root selected-callback=vm.selectNode></catalog-tree></div></section><div class=\"col-xs-3 section-helper\">Вы можете распределить категории как папки на компьютере, создавая нужную вам структуру вложенности. Для этого нажмите на создаваемую группу и, не отпуская левую кнопку мыши, расположите ее в правильном месте</div><div class=\"col-xs-3 section-helper\" style=\"margin-top: 15px;\" ng-show=!vm.settings.use_category_attributes><a ui-sref=\"attrSettings({parent: $state.params.parent})\" class=link-gear>Перейти в раздел настроек использования атрибутов</a></div></div><div class=\"clearfix full-width\"><div class=clear></div><section class=col-xs-9><h5 class=section-header>Настройка реализации маркированного товара</h5><div class=form-group style=\"margin: 10px 10px;\" ng-style=\"{\'margin-bottom\': vm.hasMarkedSKU ? \'10px\' : \'-10px\'}\"><div class=check-wrapper><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.hasMarkedSKU id=has_marked_sku ng-change=\"vm.category.scan_mark_type = (vm.hasMarkedSKU)? \'CASHIER_DECISION\' : \'\'\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=has_marked_sku class=checkbox-label>Категория содержит товар, подлежащий обязательной маркировке</label></div></div><div ng-if=vm.hasMarkedSKU style=\"margin-left: -5px\"><div class=\"form-group col-xs-6 no-bottom-offset\"><ui-select ng-model=vm.category.product_group required class=tooltip-light tooltip=\"{{$select.selected.name}}\"><ui-select-match allow-clear=false><span bind-html-compile=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=\"vm.refresh($select.search, $select)\" repeat=\"item in (vm.productGroups | filter: $select.search) track by $index\"><span bind-html-compile=item.name title-ext=item.name></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req></span><label class=form-control-label>Товарная группа</label><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group col-xs-6\" ng-if=vm.category.product_group><ui-select ng-model=vm.category.scan_mark_type required search-enabled=false><ui-select-match allow-clear=false><span ng-bind-html=$select.selected.value></span></ui-select-match><ui-select-choices repeat=\"type.key as (key, type) in vm.scanMarkTypes\"><span ng-bind-html=type.value></span></ui-select-choices></ui-select><label class=form-control-label>Сканировать марку на кассе</label><span class=req></span></div></div></section></div><div class=\"clearfix full-width\"><div class=clear></div><section class=col-xs-9><h5 class=section-header>Предмет расчета по умолчанию</h5><div class=\"form-group col-xs-6\" style=\"margin: 0\"><ui-select ng-model=vm.category.cash_register_item_type search-enabled=false><ui-select-match><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"item.value as item in (vm.cashRegisterItemTypes) track by $index\"><span ng-bind=\"item.label | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Признак предмета расчета</label></div><div class=\"form-group col-xs-6\" style=\"margin: 10px 0; display: flex; align-items: flex-start;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.update_items_register_type> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=checkbox-label>Применить выбранный предмет расчета ко всем товарам категории</span></div></section></div><section class=\"col-xs-9 form-group\" ng-show=vm.settings.use_category_attributes style=\"padding-right: 15px;\"><h5 class=section-header>Атрибуты категории</h5><div class=\"section col-xs-12\"><attributes parent-form=addCategory data=vm.category.elements category=vm.category kind=\"\'category\'\" valid=vm.checkAttrError isset-req-attr=vm.issetReqAttr></attributes></div></section><div class=\"col-xs-3 section-helper\" ng-show=vm.settings.use_category_attributes>Вы можете настроить атрибуты, которые нужно будет заполнять при добавлении товара в категорию <a ui-sref=\"attrSettings({parent: $state.params.parent})\" class=link-gear>Перейти в раздел настроек использования атрибутов</a></div></div><div class=clear></div><div class=\"section bottom-buttons col-xs-9\" ng-show=vm.showAllInform><form-errors form-ctrl=addCategory can-show=vm.isSetDirty></form-errors><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"vm.isSetDirty && (!addCategory.$valid || vm.wrongData)\" class=edit-view-buttons></form-buttons></div></ng-form></div>");
$templateCache.put("app/catalog/deleteModal/delete-button.html","<button class=\"btn slim-button only-ico\" ng-click=$ctrl.openDeleteDialog()><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button>");
$templateCache.put("app/catalog/deleteModal/delete-modal.html","<div class=modal-header><button type=button ng-disabled=\"order.length === 1\" class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Удаление товаров и услуг</h3></div><div ng-show=!showProgress><div class=\"container column-row\">Вы действительно хотите удалить выбранные элементы<br>справочника \"Товары и услуги\"?</div><div class=modal-footer><button class=btn type=button ng-click=close()>Нет</button> <button class=\"btn btn-primary\" type=button ng-click=\"startProcess(0); showProgress = true;\">Да</button></div></div><div ng-show=showProgress><div class=\"container column-row\"><div class=\"full-width progress-bar-wrapper clearfix\" ng-class=\"{\'error\': flags.error, \'success\' : flags.finished}\" ng-show=\"selectedItems.length > 1\"><div id=progress-bar></div><span class=\"percentage pull-left\">0%</span> <span class=\"percentage pull-right\">100%</span></div><div class=\"col-xs-12 progress-status-wrapper\"><span ng-show=!flags.finished class=deleting>Производим удаление:</span><div class=item-wrapper><div ng-if=!flags.finished><span ng-class=\"{\'visible\' : !nowDeleting.type || nowDeleting.type === \'CATEGORY\'}\" class=catalog-folder></span> <span class=item-name ng-class=\"{\'error\': flags.error}\">{{nowDeleting.name}}</span></div><span class=\"pull-right ui-spinner\" ng-show=\"flags.inProgress && !flags.finished\"></span> <span class=success-message ng-show=flags.finished>Удаление успешно завершено<span class=\"success-ico pull-right\"></span></span></div></div><br><div class=\"col-xs-12 progress-error-message\" ng-class=\"{\'visible\' : flags.error}\"><div ng-if=\"flags.errorCode !== \'old_last_sync_date\'\"><p class=message ng-if=\"!nowDeleting.type || nowDeleting === \'CATEGORY\'\">К сожалению, мы не смогли удалить категорию «{{nowDeleting.name}}», так как в ней находятся товары или услуги, связанные с документами. Пропустить данную категорию и продолжить удаление?</p><p class=message ng-if=\"nowDeleting.type === \'SKU\'\">Мы не может удалить товар «{{nowDeleting.name}}», так как он связан с документами. Пропустить данный товар и продолжить удаление?</p><p class=message ng-if=\"nowDeleting.type === \'SERVICE\'\">Мы не может удалить услугу «{{nowDeleting.name}}», так как она связана с документами. Пропустить данную услугу и продолжить удаление?</p></div><div ng-if=\"flags.errorCode === \'old_last_sync_date\'\"><p class=message ng-if=\"!nowDeleting.type || nowDeleting === \'CATEGORY\'\">К сожалению, мы не смогли удалить категорию «{{nowDeleting.name}}», так как есть кассы, которые ещё не обновили данные об этом товаре или услуге. Пропустить данную категорию и продолжить удаление?</p><p class=message ng-if=\"nowDeleting.type === \'SKU\'\">Мы не можем удалить товар «{{nowDeleting.name}}», так как есть кассы, которые ещё не обновили данные об этом товаре. Пропустить данный товар и продолжить удаление?</p><p class=message ng-if=\"nowDeleting.type === \'SERVICE\'\">Мы не можем удалить услугу «{{nowDeleting.name}}», так как есть кассы, которые ещё не обновили данные об этой услуге. Пропустить данную услугу и продолжить удаление?</p></div></div></div><div class=modal-footer><button class=\"btn pull-left\" ng-disabled=\"order.length === 1\" ng-if=!flags.finished type=button ng-click=close()>Отмена</button> <button class=\"btn btn-primary\" ng-if=\"flags.stopped || flags.finished\" type=button ng-click=\"flags.error ? continue() : close(true)\">{{flags.error ? \'Продолжить\' : \'Закрыть\'}}</button></div></div>");
$templateCache.put("app/catalog/export/catalog-export-modal.html","<form name=$ctrl.exportForm><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title>Экспорт товаров и услуг</h3></div><div class=container style=\"padding-right: 0\"><div class=\"col-xs-12 row gray-content\" style=\"margin: 0;width: 670px;\" ng-if=!$ctrl.showStatuses><strong class=form-group style=\"display: block;\">Укажите параметры экспорта:</strong><div class=form-group><div class=\"radio pull-left\"><label><input type=radio name=accounting ng-model=$ctrl.processing.mode value=FULL id=full> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=full>Категории, товары и услуги</label></div><div class=form-group><div class=\"radio pull-left\"><label><input type=radio name=accounting ng-model=$ctrl.processing.mode value=CATEGORIES id=categories> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=categories>Категории</label></div><div class=form-group><div class=\"radio pull-left\"><label><input type=radio name=accounting ng-model=$ctrl.processing.mode value=ITEMS id=items> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=items>Товары и услуги</label></div></div><div class=statuses-wrapper ng-if=$ctrl.showStatuses><div class=\"load-data-spinner text-center\" ng-if=$ctrl.loadExport><inview-loader show=$ctrl.loadExport style=\"margin-bottom: 12px;display: block;\"></inview-loader>Подождите, проводится экспорт данных</div><div class=\"success-check text-center\" ng-if=\"!$ctrl.loadExport && $ctrl.loadSuccess && !$ctrl.loadError\"><div class=\"center-ico ok-check-ico\" style=\"margin-top: 0;\"></div>Экспорт успешно завершен!</div><div class=\"error-check text-center\" ng-if=\"!$ctrl.loadExport && !$ctrl.loadSuccess && $ctrl.loadError\"><div class=\"center-ico error-check-ico\"></div> {{$ctrl.errorMessage}} </div></div></div><div class=modal-footer><button class=\"btn pull-left\" type=button ng-click=$ctrl.close() ng-hide=\"!$ctrl.loadExport && $ctrl.loadSuccess && !$ctrl.loadError\">Отменить</button> <button ng-if=!$ctrl.showStatuses class=\"btn btn-primary\" ng-disabled=!$ctrl.exportForm.$valid ng-click=$ctrl.prepareExport() type=button>Начать</button> <button class=\"btn btn-primary pull-left\" type=button ng-click=$ctrl.close() ng-if=\"!$ctrl.loadExport && $ctrl.loadSuccess && !$ctrl.loadError\">Закрыть</button></div></form>");
$templateCache.put("app/catalog/import/import-catalog.html","<div class=\"crud-entity alcohol-settings main-left-offset main-right-offset\"><!-- content of settings --><ul class=breadcrumbs><li><a>РОЗНИЦА</a> <span class=divider></span></li><li><a ui-sref=\"catalog({parent: \'retail\'})\">Товары и услуги</a></li></ul><h1>Импорт каталога товаров и услуг</h1><form role=form name=importForm class=import-wrap><div class=\"clearfix full-width\" ng-include=\"\'app/catalog/import/sections/1-load-file.html\'\"></div><div class=\"clearfix full-width\" ng-show=vm.activeStep ng-include=\"\'app/catalog/import/sections/2-check-file.html\'\"></div><div class=\"clearfix full-width\" ng-show=\"vm.activeStep > 1\" ng-include=\"\'app/catalog/import/sections/3-category-choice.html\'\"></div></form><div class=\"section bottom-buttons col-xs-12\" style=\"max-width: inherit;\"><form-errors form-ctrl=contractCrudCtrl.eForm can-show=contractCrudCtrl.isSetDirty></form-errors><button class=\"btn btn-ico-wrap\" ng-click=vm.prev(); ng-show=vm.activeStep><span class=\"btn-ico btn-arrow\"></span>Назад</button> <span class=\"btn pull-right\" ng-class=\"{\'btn-primary\': vm.uploader.queue[0].isSuccess}\" ng-disabled=\"!vm.uploader.queue[0].isSuccess || (vm.activeStep == 1 && !vm.fileErrors)\" ng-click=vm.next(); ng-show=\"vm.activeStep < 2\">Далее</span> <button class=\"btn btn-primary pull-right\" ng-click=vm.importStart(); ng-show=\"vm.activeStep > 1\" ng-disabled=\"vm.category_id === undefined\">Начать импорт</button></div></div>");
$templateCache.put("app/catalog/includes/search-catalog.html","<div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"vm.showFilter ? \'show-filter\' : \'\'\"><form class=\"search-entity col-xs-7\" role=search><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button calback=vm.search() class=\"form-control label-clear-button\" ng-model=vm.searchText placeholder=\"Поиск по наименованию категории, товарной позиции и по штрих-коду\" maxlength=30> <button class=\"btn slim-button search-btn\" ng-click=vm.search()>Поиск</button></div><!--<span ng-click=\"vm.showSearchCatalogItemPopup(true);\" style=\"font-size: 12px; line-height: 1; display: inline-block; width: 100px; margin: 6px;\">Расширенный поиск</span>--></form><div class=\"pull-right grid-buttons-wrapper\" ng-show=!vm.showSearch><button type=button class=\"btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Переместить ng-click=vm.moveCatalogItems(); ng-show=vm.root.hasSelected()><span class=\"btn-move btn-ico\"></span></button><div class=\"dropdown simple-dropdown\" style=\"display: inline-block;\"><button type=button class=\"btn slim-button dropdown-toggle\" id=addTo data-toggle=dropdown ng-if=\"$root.hasRole(\'price_list.write\') && vm.root.hasSelected()\">Добавить в <span class=caret style=\"display: inline-block;\"></span></button><ul class=dropdown-menu aria-labelledby=addTo role=menu style=\"width: auto;\" ng-if=\"$root.hasRole(\'price_list.write\') && vm.root.hasSelected()\"><li><a ng-click=\"vm.addToPrice(\'RETAIL\')\">Розничный прайс-лист</a></li><li><a ng-if=\"$root.hasRole(\'purchase_price_list.read\')\" ng-click=\"vm.addToPrice(\'PURCHASE\')\">Закупочный прайс-лист</a></li></ul></div><a ui-sref=\"importCatalog({parent: $state.params.parent})\" class=\"btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Импортировать из файла\" ng-if=\"$root.hasRole(\'catalog.import\')\"><span class=\"btn-import btn-ico\"></span> </a><button ng-if=\"$root.hasRole(\'catalog.export\')\" type=button class=\"btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Экспортировать в файл\" ng-click=vm.exportPopup();><span class=\"btn-export btn-ico\"></span></button><delete-skus ng-if=false callback=vm.chooseFilter root=vm.root ng-show=vm.root.hasSelected()></delete-skus></div></div>");
$templateCache.put("app/catalog/includes/tree-head.html","<div class=\"catalog-tree-header clearfix\"><div class=\"col-xs-9 main-left-offset main-right-offset\"><strong>Наименование</strong> <a href=\"\" ng-show=vm.isExpand() ng-click=\"vm.collapseAll(undefined, false)\">(свернуть)</a></div><div class=col-xs-3><div class=\"filter-settings-block with-checkbox\" style=\"padding-left: 30px\" ng-class=\"{\'open\': vm.openFilter}\"><button type=button class=\"btn dropdown-toggle filter-dropdown\" ng-click=\"vm.openFilter = !vm.openFilter\"><span>Статус</span> <span class=caret></span></button><ul class=\"dropdown-menu pull-right\" ng-show=vm.openFilter><li ng-repeat=\"status in vm.filterStatus\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=status.status id=\"{{status.id}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=status-name for=\"{{status.id}}\" ng-bind=status.name></label></li><li><button class=\"btn btn-primary slim-button\" ng-click=\"vm.chooseFilter($event); vm.openFilter = false\">Применить</button></li><li class=helper-bg ng-click=\"vm.openFilter = false\"></li></ul></div></div></div>");
$templateCache.put("app/catalog/modals/add-to-price.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=addToPriceListCtrl.close()>×</button><h3 class=modal-title>Добавление товаров и услуг в прайс-лист</h3></div><div class=\"container products-tabs\"><h4 ng-if=\"!addToPriceListCtrl.crudState.loading && !addToPriceListCtrl.crudState.success && !addToPriceListCtrl.crudState.error\">Добавить выбранные элементы в {{(addToPriceListCtrl.type == \'PURCHASE\')? \'Закупочный\' : \'Розничный\'}} прайс-лист?</h4><h4 ng-if=\"!addToPriceListCtrl.crudState.loading && addToPriceListCtrl.crudState.error\">Во время переноса позиций в {{(addToPriceListCtrl.type == \'PURCHASE\')? \'Закупочный\' : \'Розничный\'}} прайс-лист произошла ошибка</h4></div><inview-loader show=addToPriceListCtrl.crudState.loading></inview-loader><div class=modal-footer><button class=btn type=button ng-click=addToPriceListCtrl.close()>Отменить</button> <button class=\"btn btn-primary\" ng-if=!addToPriceListCtrl.crudState.hide type=button ng-click=\"addToPriceListCtrl.crudState.hide = true; addToPriceListCtrl.addToPriceList()\" style=\"width: auto;\">Добавить</button></div>");
$templateCache.put("app/catalog/modals/archive-popup.html","<div class=catalog-inform ng-class=class><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button></div><div ng-if=isRecover><div class=\"container modal-main-text\"><h3 class=info-main><span ng-bind=\"(isGoods)? \'Товар\' : \'Услуга\'\"></span> находится в статусе «в архиве»</h3><p class=info-descr ng-if=!isGoods>После восстановления услуги вы сможете<br>выставлять её на продажу и формировать по<br>ней документы</p><p class=info-descr ng-if=isGoods>После восстановления товара вы сможете<br>выставлять его на продажу и формировать по<br>нему документы</p></div></div><div class=modal-footer ng-if=isRecover><button class=btn type=button ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=recover() style=\"width: auto;\">Восстановить</button></div><div ng-if=!isRecover><div class=\"container modal-main-text\"><h3 class=info-main>Вы действительно хотите отправить<br><strong ng-bind=name></strong> в архив?</h3><p class=info-descr>После отправки в архив вы не сможете<br>выставлять <span ng-bind=\"(isGoods)? \'товар на продажу и формировать по нему документы\' : \'услугу  на продажу и формировать по ней документы\'\"></span></p></div></div><div class=modal-footer ng-if=!isRecover><button class=btn type=button ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=inArchive()>Подтвердить</button></div></div>");
$templateCache.put("app/catalog/modals/draft-popup.html","<div class=catalog-inform ng-class=class><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button></div><div ng-if=isCreate><div class=\"container modal-main-text\"><h3 class=info-main>Вы заполнили не все обязательные атрибуты</h3><p class=info-descr>Заполните все обязательные атрибуты или сохраните <span ng-bind=\"(isGoods)? \'товар\' : \'услугу\'\"></span> в статусе «черновик» для последующего редактирования.</p><p class=info-descr>В статусе «черновик» <span ng-bind=\"(isGoods)? \'товар недоступен для продажи и по нему\' : \'услуга недоступна для продажи и по ней\'\"></span><br>нельзя сформировать ни один документ</p></div></div><div class=modal-footer ng-if=isCreate><button class=\"btn btn-default\" type=button ng-click=close()>Продолжить</button> <button class=\"btn btn-default btn-primary\" type=button ng-click=save() style=\"width: auto;\">Сохранить как черновик</button></div><div ng-if=!isCreate><div class=\"container modal-main-text\"><h3 class=info-main><span ng-bind=\"(isGoods)? \'Товар\' : \'Услуга\'\"></span> находится в статусе «черновик»</h3><p class=info-descr>Заполните все обязательные поля, и тогда <span ng-bind=\"(isGoods)? \'товар станет доступен\' : \'услуга станет доступна\'\"></span> для продажи и формирования документов</p></div></div><div class=modal-footer ng-if=!isCreate><button class=btn type=button ng-click=close() ng-bind=\"(isEdit)? \'Зактрыть\' : \'Отменить\'\"></button> <button class=\"btn btn-primary\" type=button ng-click=goToEdit() ng-hide=isEdit>Редактировать</button></div></div>");
$templateCache.put("app/catalog/modals/export-catalog.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title>Экспорт товаров и услуг</h3></div><div class=container><div class=gray-content style=\"min-height: 265px;\"><div class=radio-box><div class=radio-box-title style=\"font-weight: 500;margin-bottom: 21px;\">Укажите параметры экспорта:</div><div class=clearfix style=\"margin-bottom: 8px;\"><div class=\"radio pull-left\"><label><input type=radio name=exportType ng-model=vm.exportType value=all id=all> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=all>Категории, товары и услуги</label></div><div class=clearfix style=\"margin-bottom: 8px;\"><div class=\"radio pull-left\"><label><input type=radio name=exportType ng-model=vm.exportType value=cat id=cat> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=cat>Категории</label></div><div class=clearfix><div class=\"radio pull-left\"><label><input type=radio name=exportType ng-model=vm.exportType value=noCat id=noCat> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=noCat>Товары и услуги</label></div></div><label class=\"load-data-spinner pull-left\" ng-if=loadImport><span></span>Подождите, проводится экспорт данных</label><div class=success-check ng-if=\"!loadImport && !showInfo\">Экспорт успешно завершен! <span class=\"status-check pull-right\"></span></div></div></div><div class=modal-footer><button class=btn type=button ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=export();>Начать</button></div>");
$templateCache.put("app/catalog/modals/goods-list.html","<div class=\"modal-body products-tabs\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><ng-form name=nomenclatureForm><products-tabs packing-tabs=packingTabs is-goods=isGoods name=name is-view=isView check-duplicate=checkDuplicate></products-tabs></ng-form></div><div class=modal-footer><div class=\"req-inform pull-left text-left\" ng-show=\"nomenclatureForm.$invalid && nomenclatureForm.$error.unique.length && isSaved\" style=\"margin-top: -6px; width: 53%;\">* Код вида <span ng-bind=\"(isGoods)? \'складской позиции\' : \'услуги\'\"></span> не должен повторяться</div><div class=\"req-inform pull-left text-left\" ng-show=\"nomenclatureForm.$invalid && nomenclatureForm.$error.required.length && isSaved\" style=\"width: 53%;\">* Заполните все поля</div><div ng-if=!isCreate><button class=btn type=button ng-click=close() ng-bind=\"(isView)? \'Закрыть\': \'Отменить\'\"></button> <button class=\"btn btn-primary\" type=button ng-click=save() ng-hide=isView ng-disabled=\"nomenclatureForm.$invalid && isSaved\">Сохранить</button></div></div>");
$templateCache.put("app/catalog/modals/info-popup.html","<div class=catalog-inform ng-class=class><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title ng-bind=title></h3></div><div class=container><div class=modal-main-text><h3 class=info-main ng-bind-html=mainTxt></h3><div class=info-descr ng-bind-html=descrTxt style=\"font-size: {{textFontSize || 20}}px\"></div></div></div><div class=modal-footer ng-if=!reqAttrButton><button class=btn ng-class=\"(class == \'info\')? \'btn-primary\' : \'\'\" type=button ng-click=close() ng-bind=\"(class == \'info\')? (btnText || \'Закрыть\') : \'Редактировать\'\"></button> <a ui-sref=\"catalog({parent: $state.params.parent})\" class=\"btn btn-primary\" type=button ng-click=close() ng-hide=\"class == \'info\'\">На проверку</a></div><div class=modal-footer ng-if=reqAttrButton><button class=btn type=button ng-click=close()>Продолжить редактирование</button> <button class=\"btn btn-primary\" type=button ng-click=save()>Сохранить</button></div></div>");
$templateCache.put("app/catalog/modals/move-catalog-items.html","<div class=modal-body><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title>Перемещение товаров и услуг</h3><div ng-if=load style=\"padding: 230px; position: absolute; width: 94%; background: #fff; z-index: 2;\"><div class=ui-spinner style=\"margin: 0 auto;\"></div></div><div class=\"description main-control-block\" style=\"background: none\">Выберите новую категорию для перемещаемых товаров и услуг <span ng-show=useCategoryAttributes style=\"margin-top: 20px; display: block;\"><span class=text-danger>ВНИМАНИЕ!</span> Часть товаров и услуг может перейти в статус «Черновик» при несовпадении обязательных атрибутов.</span></div><div class=modal-tree><div ng-scrollbars ng-scrollbars-config=configScroll><catalog-tree min-height=375 root-visible=true expand-node=expand item-count=none show-arrow=true selected-callback=selectNode root=root root-always-expand=true load-callback=onTreeLoaded></catalog-tree></div></div></div><div class=modal-footer><div class=\"req-inform pull-left text-left\" ng-if=\"isSaved && !selectedNode\" style=\"margin-top: 10px;\">Для переноса позиций каталога необходимо выбрать категорию</div><button class=btn type=button ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=move() ng-disabled=\"load || (isSaved && !selectedNode)\">Переместить</button></div>");
$templateCache.put("app/catalog/modals/print-popup.html","<div class=\"modal-body print-popup\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3>Печать штрих-кода</h3><div class=description>Вы можете напечатать штрих-коды в одном из доступных вариантов</div><div class=modal-main-text><div class=\"barcode-type row\"><input type=radio class=input-barcode-type name=barcode value=type1 id=type1 checked><label class=col-md-4 for=type1><h4>КОД</h4><div class=print-item><div class=article></div><div class=code></div><div class=name></div><div class=check></div>\'\'</div></label><input type=radio class=input-barcode-type name=barcode value=type2 id=type2><label class=col-md-4 for=type2><h4>КОД + АРТИКУЛ</h4><div class=print-item><div class=article>kef_10</div><div class=code></div><div class=name></div><div class=check></div></div></label><input type=radio class=input-barcode-type name=barcode value=type3 id=type3><label class=col-md-4 for=type3><h4>КОД + АРТИКУЛ + НАИМЕНОВАНИЕ</h4><div class=print-item><div class=article>kef_10</div><div class=code></div><div class=name>Кефир «Останкинский» литр 20, киллограмм 10</div><div class=check></div></div></label></div><div class=form-group><label for=name>Печатаем для</label><select class=form-control ng-model=vm.catalogItem.print><option value=\"\">Кефир «Останкинский» литр 20, киллограмм 10</option><option value=\"\">Кефир «Столичный» литр 10, киллограмм 5</option></select></div><div class=form-group><label for=name style=\"display: block;\">Количество</label><input empty-to-null type=text class=form-control id=count ng-model=vm.catalogItem.count style=\"width: 80px;\"> шт.</div></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=close()>Печать</button></div>");
$templateCache.put("app/catalog/modals/recovery-popup.html","<div class=recovery-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title>Восстановление {{catalogItemName}}</h3></div><div class=container><div class=modal-main-text>Среди ваших товаров какое-то время назад уже был Кефир «Столичный». Вы хотите восстановить описание и атрибуты этого товара?</div></div><div class=modal-footer><button class=btn type=button ng-click=close()>Нет, создать новый</button> <a ui-sref=\"catalog({parent: $state.params.parent})\" class=\"btn btn-primary\" type=button ng-click=close()>Восстановить</a></div></div>");
$templateCache.put("app/catalog/modals/status-popup.html","<div class=\"modal-body status-popup\"><div class=popup-head><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3>Статус товара: <span class=req>не подтвержден</span></h3><div class=description>Мы не смогли найти букав много неосилил основании выбранных атрибутов сформирован следующий перечень товаров с разными характеристиками вручную.</div><div class=description><strong>ВНИМАНИЕ!</strong> без подтверждения товарной позиции, опять букав много неосилил основании выбранных атрибутов сформирован следующий перечень товаров с разными характеристиками вести торговлю.</div></div><div class=modal-main-text><h5>Предложенные альтернативы</h5><ul class=search-result><li class=result-item><img src=/assets/images/test-img.png alt=\"\" class=element-img><div class=element-title>Кефир «Брест-Литовский»</div><span class=\"glyphicon glyphicon-info-sign element-description-ico\"></span><div class=\"tip-top element-description\">Классический кефир «Брест-Литовск» производится из натурального коровьего молока с использованием закваски, приготовленной на живых кефирных грибках. Неповторимый вкус не оставит равнодушным даже самого тонкого ценителя классического кефира.</div><a class=\"btn btn-primary\">Выбрать</a></li><li class=result-item><img src=/assets/images/test-img.png alt=\"\" class=element-img><div class=element-title>Кефир «Брест-Литовский»</div><div class=element-description-wrapper><span class=\"glyphicon glyphicon-info-sign element-description-ico\"></span><div class=\"tip-top element-description\">Классический кефир «Брест-Литовск» производится из натурального коровьего молока с использованием закваски, приготовленной на живых кефирных грибках. Неповторимый вкус не оставит равнодушным даже самого тонкого ценителя классического кефира.</div></div><a class=\"btn btn-primary\">Выбрать</a></li><li class=result-item><img src=/assets/images/test-img.png alt=\"\" class=element-img><div class=element-title>Кефир «Брест-Литовский»</div><span class=\"glyphicon glyphicon-info-sign element-description-ico\"></span><div class=\"tip-top element-description\">Классический кефир «Брест-Литовск» производится из натурального коровьего молока с использованием закваски, приготовленной на живых кефирных грибках. Неповторимый вкус не оставит равнодушным даже самого тонкого ценителя классического кефира.</div><a class=\"btn btn-primary\">Выбрать</a></li><li class=result-item><img src=/assets/images/test-img.png alt=\"\" class=element-img><div class=element-title>Кефир «Брест-Литовский»</div><span class=\"glyphicon glyphicon-info-sign element-description-ico\"></span><div class=\"tip-top element-description\">Классический кефир «Брест-Литовск» производится из натурального коровьего молока с использованием закваски, приготовленной на живых кефирных грибках. Неповторимый вкус не оставит равнодушным даже самого тонкого ценителя классического кефира.</div><a class=\"btn btn-primary\">Выбрать</a></li></ul></div></div>");
$templateCache.put("app/common/prevent-leaving/prevent-leaving-modal.html","<div id=logout-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>&times;</button><h3 class=modal-title>Покинуть эту страницу?</h3></div><div class=container>Возможно, внесенные изменения не сохранятся.</div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=close()>Нет</button> <button class=btn ng-click=leave()>Да</button></div></div>");
$templateCache.put("app/common/request-status/toastr-message.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=tapToast()><div ng-switch on=allowHtml><survey class=survey survey=messageClass redact=true show-header=true values=messageData callback-send=extraData.callback callback-close=close></survey></div><progress-bar ng-if=progressBar></progress-bar></div>");
$templateCache.put("app/components/Invitation/invitation-modal.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=invitationCtrl.modalInstance.dismiss()>×</button><h3 class=modal-title>Выслать приглашение</h3></div><div class=\"container row invitation-modal\" ng-form=invitationCtrl.invitationForm><div ng-if=\"!invitationCtrl.errors.length && !invitationCtrl.success\"><div class=col-xs-12><div class=row><div class=\"form-group col-xs-6\"><ui-select ng-model=invitationCtrl.invitation.company required on-select=invitationCtrl.onCompanySelect($select.selected) name=company><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=invitationCtrl.companies.refresh($select.search) repeat=\"item in ( invitationCtrl.companies.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div><label class=form-control-label>От компании</label><i class=req></i></div><div class=\"form-group col-xs-6\"><ui-select ng-model=invitationCtrl.invitation.bank_account required ng-disabled=!invitationCtrl.invitation.company name=bank_account><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=invitationCtrl.bankAccounts.refresh($select.search) repeat=\"item in (invitationCtrl.bankAccounts.items | filter: $select.search) track by $index\"><span bind-html-compile=item.name title-ext=item.name></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div><label class=form-control-label>Счет для бонуса</label><i class=req></i></div></div></div><div class=col-xs-12><div class=row><div class=\"form-group col-xs-6\"><input empty-to-null hard-pruning data-check=([0-9_]) pattern=^(\\d{10}|\\d{12})$ type=text inn-check required maxlength=12 class=form-control name=invited_inn id=invited_inn ng-model=invitationCtrl.invitation.invited_inn ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=invited_inn class=form-control-label>ИНН приглашаемой компании</label><i class=req></i> <span class=\"valid-message wrong-format-mess text-lowercase\">ИНН должен содержать 10, 12 цифр</span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=invitationCtrl.invitationForm.invited_inn.$error.validInn>Такой номер не существует</span></div><div class=\"form-group col-xs-6\"><input empty-to-null required type=text class=form-control id=invited_name ng-model=invitationCtrl.invitation.invited_name> <i class=req></i><label for=invited_name class=form-control-label>Название приглашаемой компании</label></div></div></div><div class=col-xs-12><div class=form-group><div class=check-wrapper><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=invitationCtrl.accept id=accept required> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=accept class=checkbox-label>Принимаю условия <a target=_blank href=http://файлы.торговля.онлайн/partner_offer.pdf>партнерского соглашения</a>.</label></div></div></div></div><div ng-if=\"invitationCtrl.errors.length && !invitationCtrl.success\"><div class=col-xs-12><p>У вашей компании отсутствуют следующие юридические реквизиты:</p><div ng-repeat=\"error in invitationCtrl.errors\"> {{error}} </div><br><p>Чтобы выслать приглашение, пожалуйста, перейдите на <a target=_blank ui-sref=\"company.edit({companyId: invitationCtrl.invitation.company.id, parent: \'business\'})\">карточку</a> компании и заполните их.</p></div></div><div ng-if=invitationCtrl.success><div class=col-xs-12><p>Приглашение успешно отправлено</p></div></div></div><div class=modal-footer><button class=btn ng-click=invitationCtrl.modalInstance.dismiss()>{{!invitationCtrl.success ? \'Отменить\' : \'Закрыть\'}}</button> <button ng-if=!invitationCtrl.success class=\"btn btn-primary\" ng-disabled=\"invitationCtrl.invitationForm.$invalid || !invitationCtrl.accept\" ng-click=invitationCtrl.sendInvitation()>{{invitationCtrl.errors.length ? \'Попробовать еще раз\': \'Отправить приглашение\'}}</button></div>");
$templateCache.put("app/components/catalog-tree/catalog-tree-node-cell.html","<div class=tree-cell-container></div>");
$templateCache.put("app/components/catalog-tree/catalog-tree-node.html","<div class=catalog-tree-node id=\"{{catalogTreeNodeCtrl.node.id}}\" ng-style=\"{background: catalogTreeNodeCtrl.node._rowsPosition % 2 ? \'#fff\' : \'#f7f7f8\'}\" ng-click=catalogTreeNodeCtrl.setSelected($event) ng-class=\"catalogTreeNodeCtrl.node && catalogTreeNodeCtrl.node.type.toLowerCase()\"><div class=\"catalog-tree-text clearfix\" ng-class=\"{\'selected\': catalogTreeNodeCtrl.node.selected, \'offset\': catalogTreeNodeCtrl.treeCtrl.checkboxOnlyForLeaf && (catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] == undefined\n          || catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] == true\n          || catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount]) &&\n          !(catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag] && catalogTreeNodeCtrl.treeCtrl.rootAlwaysExpand)}\" ng-hide=!catalogTreeNodeCtrl.showNodeInfo><div class=\"checkbox pull-left\" ng-if=\"::catalogTreeNodeCtrl.treeCtrl.showCheckbox && catalogTreeNodeCtrl.node.id\n         && (!catalogTreeNodeCtrl.treeCtrl.allowCheckbox || catalogTreeNodeCtrl.treeCtrl.allowCheckbox(catalogTreeNodeCtrl.node))\"><label style=\"padding: 0; outline: none;\" ng-click=$event.stopPropagation()><input type=checkbox ng-change=catalogTreeNodeCtrl.treeCtrl._checkChanged(catalogTreeNodeCtrl.node) ng-click=$event.stopPropagation() ng-model=catalogTreeNodeCtrl.node.checked> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><div class=\"checkbox pull-left\" ng-hide=\"catalogTreeNodeCtrl.treeCtrl.checkboxOnlyForLeaf && (catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] == undefined\n          || catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] == true\n          || catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount]) &&\n          !(catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag] && catalogTreeNodeCtrl.treeCtrl.rootAlwaysExpand)\" ng-if=\"::(catalogTreeNodeCtrl.treeCtrl.showCheckbox\n         && catalogTreeNodeCtrl.treeCtrl.allowCheckbox && !catalogTreeNodeCtrl.treeCtrl.allowCheckbox(catalogTreeNodeCtrl.node))\"><label style=\"padding: 0; outline: none;\" ng-click=$event.stopPropagation()><span class=\"cr disabled-check\"></span></label></div><div class=tree-row-container><!-- Отступ встраивается здесь --><div class=tree-row-cell ng-style=\"::{\'flex\': catalogTreeNodeCtrl.treeCtrl.hierarchicalFlex + \' \' + catalogTreeNodeCtrl.treeCtrl.hierarchicalFlex}\"><div class=tree-row-cell-hierarchical></div></div><div class=tree-row-cell ng-style=\"::{\'flex\': column.flex + \' \' + column.flex}\" ng-repeat=\"column in catalogTreeNodeCtrl.treeCtrl.columns\n           | limitTo:catalogTreeNodeCtrl.treeCtrl.columnsPage.limit:catalogTreeNodeCtrl.treeCtrl.columnsPage.offset\"><catalog-tree-node-cell value=catalogTreeNodeCtrl.node column=column cell-update-callback=::catalogTreeNodeCtrl.treeCtrl.cellUpdateCallback template-url=column.templateUrl></catalog-tree-node-cell></div><div class=\"tree-row-cell tree-row-controls-cell\" style=\"min-width: 30px\"><span ng-repeat=\"control in ::catalogTreeNodeCtrl.nodeControls\"><small ng-bind=control.text ng-click=\"$event.stopPropagation(); control.callback(catalogTreeNodeCtrl.node)\"></small> <i class=\"control-item tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Редактировать ng-if=\"::!!catalogTreeNodeCtrl.node.type ? $root.hasRole(\'catalog_item.write\') : $root.hasRole(\'catalog_category.write\')\" ng-click=$event.stopPropagation();control.callback(catalogTreeNodeCtrl.node) ng-class=\"((catalogTreeNodeCtrl.node.selected) ? control.imgSelected : control.img)\"></i> </span><span ng-if=::catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.allowDrag] class=\"control-item drag-item\"></span></div></div></div><div ng-if=catalogTreeNodeCtrl.node.expand><catalog-tree-node node=item level=\"catalogTreeNodeCtrl.level + 1\" ng-repeat=\"item in catalogTreeNodeCtrl.node.children\"></catalog-tree-node></div><div class=addition-item-container ng-show=\"catalogTreeNodeCtrl.node.expand && catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.totalProperty] > catalogTreeNodeCtrl.node.children.length\"><div class=addition-item-button ng-click=catalogTreeNodeCtrl.onClickAddon($event)>Еще <span class=\"ui-spinner addition-item-spinner\" ng-if=catalogTreeNodeCtrl.node.activeLoading></span></div></div></div>");
$templateCache.put("app/components/catalog-tree/catalog-tree.html","<script type=text/ng-template id=defaultCellTemplate.html><div style=\"background-color: black\">\n  </div></script><script type=text/ng-template id=defaultHierarchicalTemplate.html><div class=\"hierarchical-column\" ng-class=\"{\'root-row\': catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag], \'no-children\': !catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren]}\">\n    <i class=\"ui-spinner\" ng-if=\"catalogTreeNodeCtrl.node.activeLoading\"></i>\n    <span ng-show=\"::catalogTreeNodeCtrl.treeCtrl.showArrow &&\n          (catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] == undefined\n          || catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] == true\n          || catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount]) &&\n          !(catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag] && catalogTreeNodeCtrl.treeCtrl.rootAlwaysExpand)\">\n          <span data-ng-click=\"catalogTreeNodeCtrl.onClick(false, $event)\"\n                ng-show=\"!catalogTreeNodeCtrl.node.expand\" class=\"node-arrow glyphicon glyphicon-triangle-right\"></span>\n          <span data-ng-click=\"catalogTreeNodeCtrl.onClick(false, $event)\"\n                ng-show=\"catalogTreeNodeCtrl.node.expand\" class=\"node-arrow glyphicon glyphicon-triangle-bottom\"></span>\n    </span>\n    <span data-ng-click=\"catalogTreeNodeCtrl.onClick(false, $event)\"\n          ng-show=\"catalogTreeNodeCtrl.treeCtrl.showArrow &&\n          (catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] != undefined\n          && catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.hasChildren] == false\n          && !catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount]\n          || catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag] && catalogTreeNodeCtrl.treeCtrl.rootAlwaysExpand)\"\n          class=\"empty-expand\"></span>\n    <span ng-if=\"::catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag]\"\n          data-ng-click=\"catalogTreeNodeCtrl.onClick(false, $event)\" class=\"base-image root-folder\"ng-class=\"{\'root-folder-open\': catalogTreeNodeCtrl.node.expand}\"></span>\n    <span\n      ng-if=\"::!catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag] && !catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.unstructure]\"\n      data-ng-click=\"catalogTreeNodeCtrl.onClick(false, $event)\"\n      class=\"for-folder\"\n      ng-class=\"{\'catalog-folder\': !catalogTreeNodeCtrl.node.expand, \'catalog-open-folder\': catalogTreeNodeCtrl.node.expand}\"></span>\n    <!--span ng-if=\"!catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.rootFlag] && catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.unstructure]\" class=\"empty-folder\"></span-->\n    <span class=\"tree-node-name\"\n          title=\"{{::catalogTreeNodeCtrl.node.name}} {{::catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount] ? (\'(\' + catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount] + \')\') : \'\'}}\"\n          ng-class=\"::{\'item-leaf\': catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.unstructure]}\"><span\n      ng-show=\"::catalogTreeNodeCtrl.node.name\" ng-bind=\"::catalogTreeNodeCtrl.node.name\"></span><i\n      ng-show=\"::!catalogTreeNodeCtrl.node.name\" class=\"text-muted\">Без названия</i><span\n      style=\"margin-left: 8px\" ng-show=\"::catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount]\">\n      (<span ng-bind=\"::catalogTreeNodeCtrl.node[catalogTreeNodeCtrl.treeCtrl.itemCount]\"></span>)\n    </span></span>\n  </div></script><div class=catalog-tree-container ng-style=\"::{\'min-height\': catalogTreeCtrl.minHeight}\"><catalog-tree-node level=0 node=catalogTreeCtrl.root></catalog-tree-node></div>");
$templateCache.put("app/components/contact-info/contact-info.html","<div class=\"form-group dynamic-field col-xs-6 icon-form-group\" ng-repeat=\"contact in vm.contactInfo.details\"><div ng-switch=contact.type><div ng-switch-when=PHONE><input hard-pruning empty-to-null ng-model=contact.value type=tel id=\"contactVal{{vm.nameId}}{{$index}}\" name=\"contactVal{{vm.nameId}}{{$index}}\" data-check=\"[0-9*+() -]\" class=form-control maxlength=20 ng-hide=\"vm.stateName.endsWith(\'view\') && !contact.value\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=\"contactVal{{vm.nameId}}{{$index}}\" class=form-control-label>{{contact.caption}}</label><div ng-if=\"vm.stateName.endsWith(\'view\') && !contact.value\" class=view-entity-control>-</div></div><div ng-switch-when=EMAIL><email mail=contact.value mail-name=\"contactVal{{vm.nameId}}{{$index}}\" confirmed=employeesCrudCtrl.user.email_confirmed is-required=false is-view=\"vm.stateName.endsWith(\'view\')\"></email></div><div ng-switch-when=FAX><input hard-pruning empty-to-null ng-model=contact.value type=tel name=\"contactVal{{vm.nameId}}{{$index}}\" data-check=\"[0-9*+() -]\" class=form-control ng-pattern=vm.patterns[contact.type] maxlength=20 ng-hide=\"vm.stateName.endsWith(\'view\') && !contact.value\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=\"contactVal{{vm.nameId}}{{$index}}\" class=form-control-label>{{contact.caption}}</label><div ng-if=\"vm.stateName.endsWith(\'view\') && !contact.value\" class=view-entity-control>-</div></div><div ng-switch-when=SKYPE><input hard-pruning empty-to-null ng-model=contact.value type=tel name=\"contactVal{{vm.nameId}}{{$index}}\" data-check=[A-Za-z0-9_.-] class=form-control ng-pattern=vm.patterns[contact.type] ng-hide=\"vm.stateName.endsWith(\'view\') && !contact.value\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=\"contactVal{{vm.nameId}}{{$index}}\" class=form-control-label>{{contact.caption}}</label><div ng-if=\"vm.stateName.endsWith(\'view\') && !contact.value\" class=view-entity-control>-</div></div><div ng-switch-when=WEBSITE><input hard-pruning empty-to-null ng-model=contact.value type=tel name=\"contactVal{{vm.nameId}}{{$index}}\" data-check=[a-zа-яё0-9_.:/-] class=form-control ng-pattern=vm.patterns[contact.type] ng-hide=\"vm.stateName.endsWith(\'view\') && !contact.value\"><div class=\"valid-message wrong-format-mess\">Некорректный формат</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=\"contactVal{{vm.nameId}}{{$index}}\" class=form-control-label>{{contact.caption}}</label><div ng-if=\"vm.stateName.endsWith(\'view\') && !contact.value\" class=view-entity-control>-</div></div></div><span class=\"glyphicon glyphicon-trash field-icon remove-field tooltip-light\" ng-click=vm.removeCompanyContact($index) ng-if=\"!vm.stateName.endsWith(\'view\')\" tooltip-placement=bottom-left uib-tooltip=Удалить ng-hide=\"contact == (vm.contactInfo.details | filter:{caption: contact.caption})[0] && (contact.type == \'PHONE\' || contact.type == \'EMAIL\') && $index < vm.minDetailsRequired\"></span></div><div class=\"add-item-wrap col-xs-12 dropdown-toggle\" ng-if=\"!vm.stateName.endsWith(\'view\')\" data-toggle=dropdown><span class=add-item-icon></span> <span class=add-item-title>Контактные данные</span></div><ul class=\"dropdown-menu add-field-dropdown\"><li class=phone ng-click=\"vm.addCompanyContact(\'PHONE\', \'Телефон\')\">Телефон</li><li class=email ng-click=\"vm.addCompanyContact(\'EMAIL\', \'E-mail\')\">E-mail</li><li class=fax ng-click=\"vm.addCompanyContact(\'FAX\', \'Факс\')\">Факс</li><li class=skype ng-click=\"vm.addCompanyContact(\'SKYPE\', \'Skype\')\">Skype</li><li class=web ng-click=\"vm.addCompanyContact(\'WEBSITE\', \'Сайт\')\">Сайт</li></ul>");
$templateCache.put("app/components/counterpartiesMap/counterparties-map.html","<form name=counterpartiesMap class=\"counterparties-map crud-entity\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=counterpartiesMapCtrl.close()></button><h3 class=modal-title>Контрагент ЕГАИС</h3></div><div class=\"container crud-entity view-entity\"><div class=row><div class=\"form-group col-xs-7\"><label class=form-control-label>Полное наименование</label><div ng-bind=\"counterpartiesMapCtrl.counterparty.full_name || \'-\'\" class=view-entity-control tooltip-placement=bottom-left uib-tooltip=\"{{counterpartiesMapCtrl.counterparty.full_name || \'\'}}\" style=\"height: auto; white-space: inherit;\"></div></div><div class=\"form-group col-xs-5\"><label class=form-control-label>ФСРАР ИД</label><div ng-bind=\"counterpartiesMapCtrl.counterparty.client_reg_id || \'-\'\" class=view-entity-control title=\"{{counterpartiesMapCtrl.counterparty.client_reg_id}}\"></div></div></div><div class=row><div class=\"form-group col-xs-7\"><label class=form-control-label>Сокращенное наименование</label><div ng-bind=\"counterpartiesMapCtrl.counterparty.short_name || \'-\'\" class=view-entity-control tooltip-placement=bottom-left uib-tooltip=\"{{counterpartiesMapCtrl.counterparty.short_name || \'\'}}\"></div></div><div class=\"form-group col-xs-2\"><label class=form-control-label>ИНН</label><div ng-bind=\"counterpartiesMapCtrl.counterparty.inn || \'-\'\" class=view-entity-control title=\"{{counterpartiesMapCtrl.counterparty.inn}}\"></div></div><div class=\"form-group col-xs-3\"><label class=form-control-label>КПП</label><div ng-bind=\"counterpartiesMapCtrl.counterparty.kpp || \'-\'\" class=view-entity-control title=\"{{counterpartiesMapCtrl.counterparty.kpp}}\"></div></div></div></div><div class=modal-header style=\"padding-top: 0;\"><h3 class=modal-title>Связанные контрагенты Торговля.Онлайн</h3><a ui-sref=\"contragent.new({inn: counterpartiesMapCtrl.counterparty.inn, kpp: counterpartiesMapCtrl.counterparty.kpp, short_name: counterpartiesMapCtrl.counterparty.short_name, full_name: counterpartiesMapCtrl.counterparty.full_name, parent: $state.params.parent})\" target=_blank style=\"font-size: 14px; padding-top: 10px; display: inline-block;\">Создать нового контрагента</a></div><div class=\"container grid-wrapper\" style=\"position: relative;\"><div class=grid-buttons><span ng-click=counterpartiesMapCtrl.updateCounterpartiesList() class=refresh></span> <span ng-click=counterpartiesMapCtrl.addRow() class=\"text-success glyphicon glyphicon-plus\" ng-if=\"counterpartiesMapCtrl.counterparties.length < 5\"></span></div><grid-custom class=row-bg columns=counterpartiesMapCtrl.columns data=counterpartiesMapCtrl.counterparties is-show-settings=false show-checkbox=false options=counterpartiesMapCtrl.gridOptions min-height=100 is-full-width=false></grid-custom></div><div class=modal-footer><div class=\"req-inform pull-left text-left\" ng-show=\"(counterpartiesMapCtrl.errorInd.length || !counterpartiesMap.$valid) && counterpartiesMapCtrl.isSaved\" style=\"width: 60%;\">* Заполните все поля</div><button class=\"btn btn-primary pull-right\" ng-click=counterpartiesMapCtrl.save() ng-disabled=\"(counterpartiesMapCtrl.errorInd.length || !counterpartiesMap.$valid) && counterpartiesMapCtrl.isSaved\">Сохранить</button> <button class=\"btn pull-right\" ng-click=counterpartiesMapCtrl.close()>Отменить</button></div></form><script type=text/ng-template id=counterpartiesMapCellTemplate.html><div class=\"cell-data single-line\" ng-bind=\"value.counterparty[column.field]\">\n  </div></script><script type=text/ng-template id=counterpartiesMapHeaderCellTemplate.html><div class=\"default-header-cell\">\n    <span class=\"default-header-text {{::gridCustomHeaderCtrl.column.headerCellClass}}\">\n      <span ng-bind=\"::gridCustomHeaderCtrl.column.name\"></span>\n    </span>\n  </div></script><script type=text/ng-template id=counterpartiesMapNumberTemplate.html><div class=\"cell-data\"> {{counterpartiesMapCtrl.counterparties.indexOf(value) + 1}} </div></script><script type=text/ng-template id=documentGridControlTemplate.html><div class=\"cell-data\">\n    <i ng-click=\"counterpartiesMapCtrl.removeValue(counterpartiesMapCtrl.counterparties.indexOf(value))\" tabindex=\"-1\" class=\"glyphicon glyphicon-trash text-danger tooltip-light\" tooltip-placement=\"bottom-right\" uib-tooltip=\"Удалить\" style=\"margin-left: 35px; margin-top: 8px;\"></i>\n  </div></script><script type=text/ng-template id=counterpartiesMapNameCellTemplate.html><div class=\"form-group\" style=\"margin-top: 3px;\">\n    <ui-select class=\"slim-control always-edit\" ng-model=\"value.counterparty\" search-enabled=\"counterpartiesMapCtrl.counterpartiesFullTotal > counterpartiesMapCtrl.optionLength\" ng-class=\"{\'autocomplete-select\': counterpartiesMapCtrl.counterpartiesAuto.total > counterpartiesMapCtrl.optionLength, \'has-error-unique\': counterpartiesMapCtrl.errorInd.length && counterpartiesMapCtrl.errorInd.indexOf(counterpartiesMapCtrl.counterparties.indexOf(value)) + 1}\" on-select=\"counterpartiesMapCtrl.checkValid();\" ng-required=\"true\">\n      <ui-select-match placeholder=\"Выберите контрагента\">\n        <span ng-bind-html=\"$select.selected.name\" title=\"{{$select.selected.name}}\"></span>\n      </ui-select-match>\n      <ui-select-choices\n        position=\"up\"\n        refresh-delay=\"500\"\n        refresh=\"counterpartiesMapCtrl.refreshCounterparties($select.search)\"\n        group-by=\"counterpartiesMapCtrl.totalStr\"\n        repeat=\"item in counterpartiesMapCtrl.counterpartiesAuto.items track by $index\">\n        <span ng-bind=\"item.name\" title=\"{{item.name}}\"></span>\n      </ui-select-choices>\n      <ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice>\n    </ui-select>\n    <div class=\"valid-message required-mess small-offset\">Поле является обязательным</div>\n    <div class=\"valid-message small-offset\">Значение уже существует</div>\n  </div></script>");
$templateCache.put("app/components/datepicker/date-range-picker-input.html","<input state=state name=\"{{name}}\" id=\"{{name}}\" ui-mask=\"{{mask}}\" ui-options=\"{modelViewValue: true, clearOnBlur: true, addDefaultPlaceholder: false, allowInvalidValue: true}\" class=\"form-control datepicker-input\" type=text ng-model=viewValue ng-model-options=\"{ allowInvalid: true, debounce: 200 }\" options=opts ng-class=\"{\'slim-control\': !fieldLabel}\" ng-required=ngRequired><label for=\"{{name}}\" class=form-control-label ng-bind=fieldLabel></label><span class=req ng-if=ngRequired></span><div class=\"valid-message date-is-disabled\">Дата уже существует</div><div class=\"valid-message wrong-format-mess\">Некорректный формат</div><div class=\"valid-message required-mess\">Поле является обязательным</div>");
$templateCache.put("app/components/document-print-button/document-print-button.html","<div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0; margin: 0;\"><button class=\"btn only-ico\" data-toggle=dropdown><span class=\"glyphicon btn-print btn-ico\" style=\"margin-top: -3px;\"></span><span class=caret style=\"display: inline-block;margin-left: 12px;\"></span></button><ul class=\"dropdown-menu pull-left\" role=menu style=\"width: auto; left: inherit; right: 0;\"><li style=\"cursor: pointer\" ng-repeat=\"action in actions\" ng-if=\"!action.action || $root.hasRole(action.action)\"><a ng-click=\"perform({mode: action})\">{{action.name}}</a></li><li style=\"cursor: pointer\" ng-class=\"{\'top-line\': actions.length && reports.length && $index === 0}\" ng-repeat=\"report in reports\" ng-if=\"!report.action || $root.hasRole(report.action)\"><a ng-click=\"performReports({mode: report.code})\">{{report.name}}</a></li></ul></div>");
$templateCache.put("app/components/email/email.html","<div class=email-wrap ng-class=\"(vm.confirmed && vm.mail == vm.oldMail)? \'confirm-field-on\' : \'\'\"><input empty-to-null type=text hard-pruning id=\"{{mailName}}\" name=\"{{mailName}}\" maxlength=50 ng-required=vm.isRequired class=form-control ng-model=vm.mail ng-pattern=\'/^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3})|(([a-zA-Z0-9-–]+\\.)+[a-zA-Z0-9-–]{2,}))$/\' data-check=[A-Za-z\\d()@\\-._–] ng-hide=\"(vm.isView && !vm.mail) || vm.isView\" ng-disabled=\"!vm.modifyConfirmed && vm.confirmed\" ng-blur=\"vm.blurEvent(vm.mail, $event)\" ng-keyup=vm.keyEvent($event);><label for=\"{{mailName}}\" class=form-control-label ng-bind=\"vm.labelName || \'E-mail\'\"></label><span ng-if=vm.isView class=view-entity-control ng-bind=\"vm.mail || \'-\'\" style=\"display: inline-block;\"></span> <span class=\"glyphicon glyphicon-ok confirm-field-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Email подтвержден\"></span> <span class=no-confirm-field-ico tooltip-placement=bottom-left uib-tooltip=\"Email не подтвержден\" ng-if=\"vm.mail && vm.confirmed === false\"></span><div class=\"valid-message isset-name\">Значение уже существует</div><span class=tip-top ng-show=\"!vm.modifyConfirmed && !vm.isView\">Нельзя изменить подтвержденный e-mail</span><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-format-mess\">Некорректный формат</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message email-or-phone\">Телефон или E-mail должны быть заполнены</div><span class=req ng-if=vm.isRequired></span></div>");
$templateCache.put("app/components/entity-view-card/entity-view-card.html","<div class=\"entity-view-card clearfix full-width\"><h5 class=section-header>Основная информация</h5><section class=\"col-xs-9 entity-view-card__fields\"><div class=\"form-group col-xs-6 entity-view-card__fields_field\" ng-repeat=\"field in $ctrl.fields\"><label class=form-control-label> {{field.name}} </label><span uib-tooltip=\"{{field.info}}\" ng-if=field.info tooltip-placement=bottom-left tooltip-trigger=\"\'mouseenter\'\" tooltip-enable=!inputModel class=\"info-icon tooltip-light\"></span><div ng-class=\"{\'is-not-link\': !field.linkParams || field.value === \'-\', \'is-link\': field.linkParams && field.value !== \'-\', \'text-lowercase\': field.name == \'Смена\' || field.name == \'Чек продажи\'}\" ng-click=$ctrl.goToState(field) class=view-entity-control> {{field.value}} </div></div></section></div>");
$templateCache.put("app/components/entity-view-lower-table/entity-view-lower-table.html","<div class=\"entity-view-lower-table clearfix full-width\"><section class=col-xs-9><div class=table><div class=entity-view-lower-table-header ng-if=$ctrl.headerItems><div ng-class=\"{\'empty\': $first}\" ng-repeat=\"headerItem in $ctrl.headerItems track by $index\"> {{headerItem}} </div></div><div class=sectors><div class=sector ng-repeat=\"section in $ctrl.data track by $index\"><table class=\"sector-content sector-header\"><tr><td ng-repeat=\"sectionHeader in section.values track by $index\"><div class=sector-header><h5 class=sector-header-cell ng-class=\"{\'is-value\': !$first}\" ng-click=\"section.isExpanded = !section.isExpanded\"><span ng-if=!sectionHeader.symbol>{{sectionHeader.value}}</span><cell-with-tooltip-money ng-if=sectionHeader.symbol text=sectionHeader.value currency-symbol=sectionHeader.symbol></cell-with-tooltip-money><span class=glyphicon ng-if=\"section.isCollapsible && $first && section.children.length\" ng-class=\"{\'glyphicon-triangle-right\' : !section.isExpanded,\n                                     \'glyphicon-triangle-bottom\' : section.isExpanded}\"></span></h5></div></td></tr></table><table class=\"sector-content sector-data\" ng-if=section.isExpanded><tr ng-repeat=\"sectionChild in section.children track by $index\"><td ng-class=\"{\'black-bottom-border\': sectionChild.options.isUnderlined && !$first}\" ng-repeat=\"value in sectionChild.values track by $index\"><span ng-if=\"!value.symbol && !value.link\">{{value.value}}</span><span ng-if=\"!value.symbol && value.link\" class=is-link ng-click=\"$ctrl.goToState(value.link.state, value.link.params)\">{{value.value}}</span><cell-with-tooltip-money ng-if=value.symbol text=value.value currency-symbol=value.symbol></cell-with-tooltip-money></td></tr></table></div></div></div></section></div>");
$templateCache.put("app/components/filter-button/filter-button.html","<div class=\"filter-settings-block text-right pull-right\"><button type=button class=\"btn toggle-filter\" ng-click=$ctrl.turnShowFilter(); uib-tooltip=\"{{$ctrl.showFilter? \'Выключить фильтр\' : \'Включить фильтр\'}}\">Фильтр</button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=$ctrl.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=$ctrl.gridFilter.getSavedFiltersNames().length><span class=ico></span>Сохраненные фильтры</div><div class=\"form-group input-group search search-entity\" ng-show=\"$ctrl.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"($ctrl.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control ng-model=$ctrl.savedFilterListSearchText placeholder=Найти></div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=$ctrl.configScrollFilter><div class=content><div ng-repeat=\"filterName in $ctrl.gridFilter.getSavedFiltersNames() | filter:$ctrl.savedFilterListSearchText\" ng-click=\"$ctrl.chooseFilter({filterName: filterName})\"><span ng-bind-html=\"filterName | highlight: $ctrl.savedFilterListSearchText\"></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"$ctrl.removeFilter({filterName: filterName, $event: $event})\"></span></div></div></div><div class=no-saved-filters ng-show=!$ctrl.gridFilter.getSavedFiltersNames().length>Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров<div class=no-saved-filters-ico></div></div><p class=\"info no-find-filters\" ng-show=\"$ctrl.gridFilter.getSavedFiltersNames().length && !($ctrl.gridFilter.getSavedFiltersNames() | filter:$ctrl.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p></div></div>");
$templateCache.put("app/components/grid-wide/grid-wide.directive.html","<div class=grid-wide><div class=\"main-left-offset main-right-offset\"><h1 style=\"margin-right: 15px;\">{{header}} <button class=\"btn only-ico tooltip-light pull-right cart-button minor-font\" tooltip-placement=bottom-right uib-tooltip=\"Добавить в корзину\" ng-show=\"ctrl.needAddToCart && ctrl.gridApi.grid.selection.selectedCount > 0\" ng-click=ctrl.addToCart();><span class=\"btn-cart btn-ico\" style=\"top: -3px; margin-right: 5px;\"></span> В корзину</button> <span ng-if=\"ctrl.stateName === \'stock\'\"><button style=\"width: 48px;\" ng-if=\"$root.hasRole(\'report.stock_period_totals\')\" class=\"pull-right btn button-print btn-ico-wrap tooltip-light minor-font\" tooltip-placement=bottom-right uib-tooltip=\"Печатать складские остатки\" ng-click=ctrl.openStockPrintModal()><span class=\"btn-ico btn-print\"></span></button> <button ng-if=\"$root.hasRole(\'report.inventory_tags\')\" class=\"pull-right btn button-print tooltip-light minor-font\" tooltip-placement=bottom-left uib-tooltip=\"Печатать этикетки\" ng-click=ctrl.openInventoryTagPrintModal()><span class=\"btn-ico btn-print\"></span><span>Этикетки</span></button> </span><span ng-if=\"ctrl.stateName === \'invoice-waybill-list\'\"><button style=\"width: 48px;\" ng-if=\"$root.hasRole(\'report.consignment_note_in_egais\')\" class=\"pull-right btn button-print btn-ico-wrap tooltip-light minor-font\" tooltip-placement=bottom-left uib-tooltip=\"Распечатать документы\" ng-click=ctrl.openStockPrintModal()><span class=\"btn-ico btn-print\"></span></button></span><div class=pull-right ng-if=ctrl.lastSync style=\"padding-top: 12px\"><last-sync-doc-date></last-sync-doc-date></div></h1><div ng-if=\"config.purposes || gridButtonConfig\" class=grid-buttons><div ng-if=\"config.purposes && config.purposes.length >= 2\" class=\"doc-settings-block text-right\" style=\"position: relative;display: inline-block; margin-right: 10px\"><button type=button class=btn data-toggle=dropdown><span class=\"btn-ico btn-plus btn-plus-dark\"></span> Документ <span class=caret></span></button><ul class=\"dropdown-menu pull-left\" role=menu style=\"width: auto\"><li ng-repeat=\"purpose in config.purposes\"><!--TODO убрать purpose.type после реализации виджетов--> <a ng-if=\"!purpose.url && config.documentType == \'all_documents\'\" ui-sref=\"document.new({type: purpose.type || config.documentType, purpose: purpose.value, parent: ctrl.parent, allDocument: true})\">{{ purpose.label }}</a><a ng-if=\"!purpose.url && config.documentType !== \'all_documents\'\" ui-sref=\"document.new({type: purpose.type || config.documentType, purpose: purpose.value, parent: ctrl.parent})\">{{ purpose.label }}</a><a ng-if=purpose.url ui-sref=\"{{purpose.url}}\">{{ purpose.label }}</a></li></ul></div><div ng-if=\"config.purposes && config.purposes.length < 2\" class=\"doc-settings-block text-right\" style=\"position: relative;display: inline-block; margin-right: 10px\"><a ng-repeat=\"purpose in config.purposes\" ui-sref=\"document.new({type: config.documentType, purpose: purpose.value || purpose.code, parent: ctrl.parent})\" class=btn><span class=\"btn-ico btn-plus btn-plus-dark\"></span> {{ purpose.label || purpose.purpose_name }}</a></div><a ng-repeat=\"button in gridButtonConfig\" ui-sref=\"{{button.url}}\" class=\"btn {{button.class}}\" ng-if=$root.hasRole(button.permission) ng-click=button.action() uib-tooltip=\"{{button.tooltip}}\"><span class=\"btn-ico btn-plus btn-plus-dark\" ng-if=button.plusButton></span> <span ng-bind=button.text></span> </a><span ng-if=\"::config.universalDocuments && !config.universalAlcoDocuments && $root.hasRole(\'document_settings.write\')\"><a ui-sref=\"documentSettings({parent: ctrl.parent})\" class=btn><span class=\"btn-ico btn-gear\"></span> Настройки</a> </span><span ng-if=\"::config.universalAlcoDocuments && $root.hasRole(\'alcohol_settings.write\')\"><a ui-sref=\"alcoholSettings({parent: \'alcohol\'})\" class=btn><span class=\"btn-ico btn-gear\"></span> Настройки</a></span></div></div><div ng-if=!onlyReadMode class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"ctrl.showFilter ? \'show-filter\' : \'\';\"><form class=\"search-entity col-xs-5\" role=search ng-submit=ctrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=getPage() ng-model=ctrl.searchText class=\"form-control label-clear-button\" placeholder=\"{{ctrl.searchPlaceholder || \'Поиск\'}}\"> <button class=\"btn slim-button search-btn\" uib-tooltip=\"{{::config.searchTip}}\">Поиск</button></div></form><div><filter-button ng-if=filtersRequired config-scroll-filter=ctrl.configScrollFilter choose-filter=ctrl.chooseFilter(filterName) remove-filter=\"ctrl.removeFilter(filterName, $event)\" turn-show-filter=ctrl.turnShowFilter() show-filter=ctrl.showFilter prepare-saved-filters-list=ctrl.prepareSavedFiltersList() grid-filter=ctrl.gridFilter saved-filter-list-search-text=ctrl.savedFilterListSearchText></filter-button><div class=pull-right ng-if=ctrl.rowSelected><status-button style=\"margin-right: 10px\" class=pull-left cancel-processing=ctrl.cancelProcessing start-processing=ctrl.startProcessing mode=ctrl.statusButtonMode ng-show=ctrl.showStatusButton ng-if=\"::config.universalDocuments && $root.hasRole(config.documentType.toLowerCase() + \'.write\')\"></status-button><button ng-if=\"::config.universalDocuments && $root.hasRole(config.documentType.toLowerCase() + \'.write\')\" ng-show=ctrl.showDeleteButton ng-click=ctrl.openConfirmDeleteDialog() class=\"pull-left btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Удалить style=\"margin-right: 10px\"><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button><div class=pull-left style=\"margin-right: 10px\" ng-if=::config.universalDocuments ng-show=\"ctrl.showCopyButton && !config.hideCopyButton\"><button style=\"margin-right: 10px\" ng-if=\"::$root.hasRole(config.documentType.toLowerCase() + \'.write\')\" ng-click=ctrl.copyDocument() class=\"btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Копировать><span class=\"btn-copy btn-ico\"></span></button><document-print-button perform=ctrl.printDocument(mode) ng-if=\"::$root.hasRole(\'report.\' + config.documentType.toLowerCase()) && config.printDocumentActions.length > 0\" actions=::config.printDocumentActions></document-print-button></div></div></div></div><div ng-if=onlyReadMode class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><filter-block config=config search-text=searchHelper filters=ctrl.filter initial-base-mode=ctrl.currentBaseMode search-trigger=ctrl.search no-search-on-load=ctrl.noSearchOnLoad></filter-block></div><section class=\"transtype-buttons main-left-offset main-right-offset\" ng-if=\"page === \'cashregister-shifts-crud\'\"><a class=\"toggle-button btn\" ng-class=\"{\'btn-primary\': ctrl.currentTransType == \'SALES\'}\" ng-click=ctrl.showSales()>Продажи</a> <a class=\"toggle-button btn\" ng-class=\"{\'btn-primary\': ctrl.currentTransType != \'SALES\'}\" ng-click=ctrl.showRefunds()>Возвраты</a></section><div class=clear></div></div><div class=\"filter-not-found major-font\" ng-if=\"!ctrl.paging.total && ctrl.dataIsLoaded\" ng-class=\"ctrl.showFilter ? \'show-filter-info\' : \'\';\"><div class=big-danger-info-ico ng-if=!ctrl.noData></div><div class=big-danger-info ng-if=!ctrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=ctrl.noData ng-bind=\"noDataStr || \'Нет данных\'\"></div></div><grid-loader class=big-gird show=!ctrl.dataIsLoaded ng-class=\"ctrl.showFilter ? \'show-filter\' : \'\';\"></grid-loader><div class=filter-not-found ng-if=\"filtersRequired && !ctrl.gridOptions.data.length && !ctrl.loading && (ctrl.invalidFilterForm || ctrl.noSearchOnLoad)\" ng-class=\"ctrl.showFilter ? \'filters-showed\' : \'\';\" style=\"z-index: 3;\">Для получения данных заполните, пожалуйста,<br>обязательные поля в фильтрах</div><div class=full-with-table-wrapper ng-class=\"ctrl.showFilter ? \'show-filter\' : \'\';\"><div class=\"grid-wrapper {{\'paging-limit-\' + ctrl.paging.limit}}\" ng-class=\"{\'max-height\': ctrl.isLargeHeight}\"><div class=\"settings-grid grid\" ng-class=\"{\'settings-crud-grid\' : filtersRequired === false}\" ui-grid=ctrl.gridOptions ui-grid-selection ui-grid-edit ui-grid-resize-columns ui-grid-cellnav></div></div><div class=table-footer><paging-customizable page-info=ctrl.paging callback=ctrl.getPage paging=ctrl.gridFooterPaging></paging-customizable></div></div><all-filter filter-meta=ctrl.filterMeta apply-filter=ctrl.applyFilter filter-data=ctrl.popupFilter clean-filter=ctrl.cleanFilter></all-filter>");
$templateCache.put("app/components/kladr/kladr.html","<input type=text ng-model=vm.location.prev class=\"kladr-input input-xlarge\"> <span class=kladr-description ng-bind=vm.description></span>");
$templateCache.put("app/components/last-sync-doc-date/last-sync-doc-date.html","<div class=\"last-sync-doc-date pull-right\" ng-if=lastSyncDocDateCtrl.needShow><span class=danger ng-if=lastSyncDocDateCtrl.danger></span> Данные актуальны на <span ng-bind=\"lastSyncDocDateCtrl.date | date:\'dd.MM.yyyy HH:mm\'\"></span></div>");
$templateCache.put("app/components/markViewModal/mark-view-modal.html","<div class=mark-view-modal focus-request=true tabindex=0 ng-keypress=markViewModal.applyScannerKeys($event) ng-class=\"{\'blur-content\': (markViewModal.barcode.length == 68 && !markViewModal.noQuestion && markViewModal.notFoundOldMark)|| markViewModal.markNotFound}\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=markViewModal.close()></button><h3 class=modal-title>Просмотр марок товара</h3></div><div class=container><section class=form-group ng-if=!markViewModal.isViewMode style=\"padding: 12px 18px;\"><uib-tabset active=1><uib-tab index=1><uib-tab-heading class=tab-heading><span class=\"tab-title section-header text-uppercase\">Сканер</span></uib-tab-heading><div class=\"row scan-tab text-center\" style=\"padding-top: 10px;\"><label class=text-muted><i>Используйте сканирующее устройство</i></label><div class=clearfix ng-if=\"markViewModal.canAddNewMarks && markViewModal.barcode.length\"><span class=text-danger ng-if=\"markViewModal.barcode.length == 150 && !markViewModal.noAcceptedAmcsSelected.length && !markViewModal.acceptedAmcsSelected.length\">Марка не найдена</span> <span class=\"pull-left text-danger text-center col-xs-12\" ng-if=\"markViewModal.barcode.length !== 68 && markViewModal.barcode.length !== 150\">Неверный формат марки</span></div></div></uib-tab><uib-tab index=2><uib-tab-heading class=tab-heading><span class=\"tab-title section-header text-uppercase\">РУЧНОЙ ВВОД МАРКИ</span></uib-tab-heading><div class=\"row scan-tab\" style=\"padding-top: 10px;\"><div class=col-xs-12 ng-form=markViewModal.searchSingleForm><div class=code-wraper><input mark-input maxlength=12 focus-request=true select-by-event=selectInput ng-keypress=\"$event.keyCode == 13 && markViewModal.submitBarcode(true); $event.stopPropagation();\" clear-button type=text style=\"padding-right: 80px;\" class=\"form-control slim-control\" ng-model=markViewModal.barcodeSearch> <span class=code-sprite></span></div></div></div></uib-tab></uib-tabset></section><section class=form-group ng-if=!markViewModal.isViewMode><div class=clearfix><h6 class=\"section-header pull-left\" ng-bind=markViewModal.skuInfo.alcohol_catalog_item.name style=\"max-width: calc(100% - 100px);\"></h6><div class=\"pull-right guantity\" ng-bind=\"(markViewModal.data.accepted_amcs.length || 0) + \' \' + (markViewModal.skuInfo.uom.symbols || markViewModal.skuInfo.uom.name)\"></div></div><div ng-if=markViewModal.load style=\"position: absolute; background: #f7f7f8; width: 98%; z-index: 99; height: 82%;\"><div class=ui-spinner style=\"margin: 90px auto;\"></div></div><div class=\"row clearfix\"><div class=col-xs-5><div class=marks-title>{{(markViewModal.canAddNewMarks)? \'Марки на балансе: \' : \'Непринятые марки: \'}}{{markViewModal.data.no_accepted_amcs.length || 0}}</div><custom-multiselect list=markViewModal.data.no_accepted_amcs height=150 view-patern=markViewModal.viewPattern data-selected=markViewModal.noAcceptedAmcsSelected is-one-selected=!markViewModal.resolve.multiSelect scroll-key=markViewModal.noAcceptedKey></custom-multiselect></div><div class=\"col-xs-1 moving-wrapper\" ng-style=\"(markViewModal.resolve.multiSelect)? {\'margin-top\': \'24px\'} : {\'margin-top\': \'70px\'}\"><button class=\"moving right-arrow\" ng-click=\"markViewModal.moving(\'ACCEPTED\', false);\" tooltip-placement=top-left uib-tooltip=\"{{(markViewModal.isCancelAct)? \'Списать выбранные марки\' : \'Принять выбранные марки\'}}\"></button> <button class=\"moving right-arrow right-arrow-double\" ng-if=markViewModal.resolve.multiSelect ng-click=\"markViewModal.moving(\'ACCEPTED\', true);\" tooltip-placement=top-left uib-tooltip=\"{{(markViewModal.isCancelAct)? \'Списать все марки\' : \'Принять все марки\'}}\"></button> <button class=\"moving left-arrow\" ng-click=\"markViewModal.moving(\'REJECTED\', false);\" tooltip-placement=top-left uib-tooltip=\"{{(markViewModal.resolve.multiSelect)? \'Вернуть выбранные марки\' : \'Отклонить выбранные марки\'}}\"></button> <button class=\"moving left-arrow-double\" ng-if=markViewModal.resolve.multiSelect ng-click=\"markViewModal.moving(\'REJECTED\', true);\" tooltip-placement=top-left uib-tooltip=\"Вернуть все марки\"></button></div><div class=col-xs-5><div class=marks-title>{{(markViewModal.canAddNewMarks)? \'Марки для списания: \' : \'Принятые марки: \'}}{{markViewModal.data.accepted_amcs.length || 0}}</div><custom-multiselect list=markViewModal.data.accepted_amcs height=150 view-patern=markViewModal.viewPattern data-selected=markViewModal.acceptedAmcsSelected is-one-selected=!markViewModal.resolve.multiSelect delete-callback=markViewModal.removeMark scroll-key=markViewModal.acceptedKey></custom-multiselect></div></div></section><div class=form-group ng-if=\"markViewModal.isViewMode && markViewModal.data.accepted_amcs.length\"><div class=clearfix style=\"margin-top: 10px;\"><h6 class=\"section-header pull-left\" ng-bind=markViewModal.skuInfo.alcohol_catalog_item.name style=\"max-width: calc(100% - 100px);\"></h6><h6 class=\"section-header pull-right guantity text-lowercase\" ng-bind=\"markViewModal.skuInfo.quantity + \' \' + markViewModal.skuInfo.uom.symbols\"></h6></div><div ng-if=markViewModal.load style=\"position: absolute; background: #f7f7f8; width: 98%; z-index: 99; height: 82%;\"><div class=ui-spinner style=\"margin: 90px auto;\"></div></div><div class=\"custom-list-wrapper clearfix\"><div class=\"custom-list-header clearfix\"><div class=\"col-xs-4 row\"><div class=col-xs-2>№</div><div class=col-xs-10>Тип, серия, номер</div></div><div class=\"col-xs-4 row\" ng-if=\"markViewModal.data.accepted_amcs.length > 1\"><div class=col-xs-2>№</div><div class=col-xs-10>Тип, серия, номер</div></div><div class=\"col-xs-4 row\" ng-if=\"markViewModal.data.accepted_amcs.length > 2\"><div class=col-xs-2>№</div><div class=col-xs-10>Тип, серия, номер</div></div></div><div class=\"custom-list-body clearfix\"><div class=\"col-xs-4 row\" ng-repeat=\"mark in markViewModal.data.accepted_amcs\"><div class=col-xs-2 ng-bind=\"$index + 1\"></div><div class=col-xs-10 ng-bind=\"mark.amc | egaisBarcode\"></div></div></div></div></div></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=markViewModal.close()>Закрыть</button></div></div><div class=remove-box ng-if=\"(markViewModal.barcode.length == 68 && !markViewModal.noQuestion && markViewModal.notFoundOldMark) || markViewModal.markNotFound\"><div><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=alert aria-hidden=true ng-click=\"markViewModal.barcode = \'\'; markViewModal.markNotFound = false;\">×</button><h3 class=remove-box-title>Предупреждение</h3></div><div ng-if=\"markViewModal.barcode.length == 68 && !markViewModal.noQuestion && markViewModal.notFoundOldMark && !markViewModal.markNotFound\">Марка старого образца не найдена.<br>Вы действительно хотите добавить ее для списания?<div class=clearfix style=\"margin-top: 30px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=markViewModal.noQuestionForSave id=noQuestion> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=noQuestion>Больше не спрашивать (добавлять марки сразу после сканирования)</label></div><p class=\"footer-buttons clearfix\"><button type=button ng-click=\"markViewModal.saveNoQuestionFlag(); markViewModal.moving(\'ACCEPTED\', false, markViewModal.barcode)\" class=\"btn btn-primary\">Добавить</button> <button type=button ng-click=\"markViewModal.barcode = \'\';\" class=btn>Отмена</button></p></div><div ng-if=markViewModal.markNotFound>Марка отсутствует в ТТН</div></div>");
$templateCache.put("app/components/marksWithoutSourse/marks-without-sourse.html","<div class=marks-without-sourse-wrap focus-request=true tabindex=0 ng-keypress=marksWithoutSourse.applyScannerKeys($event)><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=marksWithoutSourse.close()></button><h3 class=modal-title>Добавление марок</h3></div><div class=container><section class=form-group ng-if=!marksWithoutSourse.isViewMode><div>Отсканируйте номер федеральной специальной марки<br>или акцизной марки</div><div class=\"row scan-tab\" style=\"padding-top: 10px;\"><div class=col-xs-12 ng-form=marksWithoutSourse.searchSingleForm><div class=code-wraper><input maxlength=150 focus-request=true select-by-event=selectInput ng-keypress=\"marksWithoutSourse.wrongMark = false; $event.keyCode == 13 && marksWithoutSourse.submitBarcode(true); $event.stopPropagation();\" clear-button type=text style=\"padding-right: 80px; opacity: 0; height: 0;\" class=\"form-control slim-control\" ng-model=marksWithoutSourse.barcode></div></div><div class=\"col-xs-12 text-danger\" ng-if=marksWithoutSourse.matchError>Марка уже добавлена</div><div class=\"col-xs-12 text-danger\" ng-if=\"!marksWithoutSourse.matchError && marksWithoutSourse.wrongMark\">Неверный формат марки</div></div><div class=amcs-list ng-if=marksWithoutSourse.data.length><label>Выбранные марки</label><div ng-scrollbars ng-scrollbars-config=marksWithoutSourse.configScroll><span class=amcs ng-repeat=\"mark in marksWithoutSourse.data\"><span ng-bind=\"mark.amc | egaisBarcode\"></span> <span class=cross ng-click=marksWithoutSourse.removeAmc($index)></span></span></div></div><div class=pull-right>Добавлено марок: {{marksWithoutSourse.data.length}}</div></section></div><div class=modal-footer><button class=\"btn btn-primary\" ng-click=marksWithoutSourse.close() ng-disabled=!marksWithoutSourse.data.length>Закрыть</button></div></div>");
$templateCache.put("app/components/modalLoad/modalLoad.html","<div class=modal-load-wrapper><div id=modalLoad role=dialog ng-show=!showMainModal><div class=main-block><span class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=closeFun()>&times;</span><div class=alert-container><div ng-show=showFailMessage><div class=alert-sign><div class=alert-close>&times;</div></div><div class=alert-message><span>Ошибка при загрузке данных,</span> <a href=\"\" ng-click=callback();>повторите попытку</a></div></div></div><div ng-show=showLoadMessage><div class=success-message><span>Подождите,</span><br><span>данные загружаются</span></div></div></div></div></div>");
$templateCache.put("app/components/paging/paging.html","<div class=\"pagination-wrapper major-font\"><ul ng-if=\"pageInfo.total > pageInfo.limit\"><li class=\"page-item first-link\"><a class=\"page-link to-first tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == 0)? \'\': \'На первую страницу\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == 0}\" ng-click=toFirst() href=\"\" aria-label=Previous></a></li><li class=\"page-item previous-link\"><a class=\"page-link to-previous tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == 0)? \'\': \'На предыдущую\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == 0}\" ng-click=toPrevious() href=\"\" aria-label=Previous ng-disabed=\"pageInfo.current == 0\"></a></li><li class=page-item><input type=text class=current-page ng-model=pageInfo.inputPage ng-keyup=toPage(pageInfo.inputPage) ignore-dirty=true> <span class=total-page ng-bind=\"\' /&nbsp;&nbsp;\' + (pageInfo.last + 1)\"></span></li><li class=\"page-item next-link\"><a class=\"page-link to-next tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == pageInfo.last)? \'\': \'На следующую\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == pageInfo.last}\" ng-click=toNext() href=\"\" aria-label=Next></a></li><li class=\"page-item last-link\"><a class=\"page-link to-last tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == pageInfo.last)? \'\': \'На последнюю страницу\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == pageInfo.last}\" ng-click=toLast() href=\"\" aria-label=Next></a></li></ul><span class=\"per-page-label minor-font\">отображать по</span><ui-select ng-model=pageInfo.limit search-enabled=false ignore-dirty=true><ui-select-match allow-clear=false><span ng-bind=$select.selected></span></ui-select-match><ui-select-choices position=up repeat=\"limit in pageInfo.limits track by $index\"><span ng-bind=limit></span></ui-select-choices></ui-select><div class=\"quantity-wrapper minor-font\" ng-if=pageInfo.total>Найдено записей - {{pageInfo.total}} </div></div>");
$templateCache.put("app/components/paging-customizable/paging-customizable.html","<div class=\"pagination-wrapper major-font\"><ul ng-if=\"pageInfo.total > pageInfo.limit\"><li class=\"page-item first-link\"><a class=\"page-link to-first tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == 0)? \'\': \'На первую страницу\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == 0}\" ng-click=toFirst() href=\"\" aria-label=Previous></a></li><li class=\"page-item previous-link\"><a class=\"page-link to-previous tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == 0)? \'\': \'На предыдущую\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == 0}\" ng-click=toPrevious() href=\"\" aria-label=Previous ng-disabed=\"pageInfo.current == 0\"></a></li><li class=page-item><input type=text class=current-page ng-model=pageInfo.inputPage ng-keyup=toPage(pageInfo.inputPage) ignore-dirty=true> <span class=total-page ng-bind=\"\' /&nbsp;&nbsp;\' + (pageInfo.last + 1)\"></span></li><li class=\"page-item next-link\"><a class=\"page-link to-next tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == pageInfo.last)? \'\': \'На следующую\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == pageInfo.last}\" ng-click=toNext() href=\"\" aria-label=Next></a></li><li class=\"page-item last-link\"><a class=\"page-link to-last tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(pageInfo.current == pageInfo.last)? \'\': \'На последнюю страницу\'}}\" ng-class=\"{\'disabled-link\' : pageInfo.current == pageInfo.last}\" ng-click=toLast() href=\"\" aria-label=Next></a></li></ul><span class=\"per-page-label minor-font\">отображать по</span><ui-select ng-model=pageInfo.limit search-enabled=false ignore-dirty=true><ui-select-match allow-clear=false><span ng-bind=$select.selected></span></ui-select-match><ui-select-choices position=up repeat=\"limit in paging track by $index\"><span ng-bind=limit></span></ui-select-choices></ui-select><div class=\"quantity-wrapper minor-font\" ng-if=pageInfo.total>Найдено записей - {{pageInfo.total}} </div></div>");
$templateCache.put("app/components/partner-choice/partner-choice.html","<div class=\"form-group col-xs-8\"><ui-select ng-model=partnerChoice.reqData.clientType required on-select=partnerChoice.changePartnerType(partnerChoice.reqData.clientType);><ui-select-match allow-clear=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.value as item in partnerChoice.clientTypes track by $index\"><span ng-bind=item.name></span></ui-select-choices></ui-select><span class=req></span><label class=form-control-label>Партнер</label><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group col-xs-8\"><ui-select ng-model=partnerChoice.reqData.clientPartnerId required ng-disabled=\"partnerChoice.reqData.clientType == \'DOMAIN\'\"><ui-select-match allow-clear=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=partnerChoice.refreshPartnerName($select.search) repeat=\"item.id as item in partnerChoice.partners track by $index\"><span ng-bind=item.name></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req></span><label class=form-control-label>Наименование партнера</label><div class=\"valid-message required-mess\">Поле является обязательным</div></div>");
$templateCache.put("app/components/personsData/inputPersonData.html","<div class=add-person-data><div class=input-person-wrapper ng-class=\"(person.choosed)? \'has-person\' : \'\' \"><input maxlength=150 empty-to-null ng-required=required name=\"{{nameAndId}}\" type=text data-check=\"[a-zA-Zа-яА-ЯёЁ .-]\" class=\"form-control pdfl-input\" ng-model=fio id=\"{{nameAndId}}\" ng-disabled=onlyPopupEdit hard-pruning ng-keyup=\"parentForm[nameAndId].$setValidity(\'unique\', true)\" ng-blur=\"!view?uniqueCallback(fio, $event):\'\'\"><label for=\"{{nameAndId}}\" class=form-control-label ng-bind=fieldLabel></label><span ng-if=required class=req></span><div class=view-entity-control ng-bind=\"(fio)? fio : \'-\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span ng-if=\"$root.hasRole([\'person.read\', \'person.write\']) && person.choosed\" class=\"input-group-addon user-icon-container reset tooltip-light\" type=button ng-click=reset() tooltip-placement=bottom-left uib-tooltip=\"Отвязать данные из справочника персональных данных физических лиц\"><span class=\"glyphicon glyphicon-user\"></span></span> <span ng-if=\"$root.hasRole([\'person.read\', \'person.write\']) && !person.choosed\" class=\"input-group-addon user-icon-container tooltip-light\" type=button ng-click=showModal();getPersonsListData() tooltip-placement=bottom-left uib-tooltip=\"Привязать данные из справочника персональных данных физических лиц\"><span class=\"glyphicon glyphicon-user\"></span></span></div><span class=\"view-person-name view-entity-control ng-hide\" ng-bind=fio></span><div class=choosed-person-wrapper ng-if=person.choosed ng-mousedown=\"$event.which == 1 && $root.hasRole(\'person.read\') && openPersonDataInViewMode()\"><span class=\"fill-name-tip valid-message-hide tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"{{person.fullName}}\"><span class=\"glyphicon glyphicon-user\"></span> <span class=choosed-name ng-bind=person.fullName></span></span></div></div>");
$templateCache.put("app/components/personsData/personsData.html","<!-- Modal --><!-- <script type=\"text/ng-template\" id=\"personsData.html\"> --><div class=person-data-wrapper ng-class=\"{\'view-entity\': vm.formMode === \'view\'}\"><div id=personsData.html><div id=persons-data-popup ng-show=vm.showModal><!-- <div class=\"modal-dialog\"> --><!-- Modal content--><div class=modal-content><div class=persons-list ng-show=!vm.showForm><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=modal ng-click=vm.closePopup()>&times;</button><h3 class=modal-title>Персональные данные физических лиц</h3></div><div class=container><div class=\"row main-control-block\" style=\"background: none; padding: 4px 0px;\"><div class=\"col-xs-7 modal-description\">Внесите в&nbsp;список персональные данные физических лиц, с&nbsp;которыми планируется вести договорные отношения</div><form class=\"search-entity col-xs-5\" role=search ng-submit=vm.refreshData() ng-if=!vm.showHelp style=\"padding-right: 15px;\"><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=vm.refreshData() class=\"form-control label-clear-button\" ng-model=vm.searchText placeholder=Поиск ng-change=vm.refreshData() ng-model-options=\"{debounce: 1000}\"> <button class=\"btn slim-button search-btn\" ng-click=vm.refreshData()>Поиск</button></div></form></div></div><div class=modal-body ng-hide=vm.showHelp style=\"height: 450px; overflow: hidden;\"><div ui-grid=gridOptions class=grid ui-grid-selection ui-grid-pagination></div><div class=table-footer ng-if=!vm.showHelp><div class=\"pagination-wrapper major-font\" ng-if=\"vm.totalPersons > 1\"><ul><!--  ng-if=\"pageInfo.total > pageInfo.limit\" --><li class=\"page-item first-link\"><a class=\"page-link to-first tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(vm.currP == 1)? \'\': \'На первую страницу\'}}\" ng-class=\"{\'disabled-link\' : vm.currP == 1}\" ng-click=vm.goToFirstPage() href=\"\" aria-label=Previous></a></li><li class=\"page-item previous-link\"><a class=\"page-link to-previous tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(vm.currP == 1)? \'\': \'На предыдущую\'}}\" ng-class=\"{\'disabled-link\' : vm.currP == 1}\" ng-click=vm.previousPage() href=\"\" aria-label=Previous></a></li><li class=page-item><input type=text class=current-page ng-model=vm.inputPage ng-keyup=vm.goToPage(vm.inputPage)> <span class=total-page ng-bind=\"\' /&nbsp;&nbsp;\' + vm.totalPersons\"></span></li><li class=\"page-item next-link\"><a class=\"page-link to-next tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(vm.currP == vm.totalPersons)? \'\': \'На следующую\'}}\" ng-class=\"{\'disabled-link\' : vm.currP == vm.totalPersons}\" ng-click=vm.nextPage() href=\"\" aria-label=Next></a></li><li class=\"page-item last-link\"><a class=\"page-link to-last tooltip-light\" tooltip-placement=top-left uib-tooltip=\"{{(vm.currP == vm.totalPersons)? \'\': \'На последнюю страницу\'}}\" ng-class=\"{\'disabled-link\' : vm.currP == vm.totalPersons}\" ng-click=vm.goToLastPage() href=\"\" aria-label=Next></a></li></ul></div></div></div><div class=empty-modal ng-if=vm.showHelp><p>У вас пока не&nbsp;добавлено ни&nbsp;одной записи в&nbsp;справочник персональных данных физических лиц. Вы можете сделать это, нажав кнопку \"Добавить\"</p><div class=arrow></div></div><div class=modal-footer><button ng-if=\"$root.hasRole(\'person.write\')\" class=\"btn btn-left\" ng-class=\"{\'disabled\':vm.loadingList, \'btn-primary\': vm.showHelp}\" ng-disabled=vm.loadingList ng-click=vm.openForm() role=button><span class=\"btn-ico btn-plus\" ng-class=\"{\'btn-plus-dark\': !vm.showHelp}\"></span> Персональные данные</button><!-- Изменить лимит (10 по умолчанию)\n            <select ng-model=\"vm.limit\" ng-change=\"vm.changeLimit()\">\n              <option value=\"2\">2</option>\n              <option value=\"5\">5</option>\n              <option value=\"10\">10</option>\n            </select> --> <button class=btn ng-class=\"{\'disabled\':!selected,\'btn-primary\':selected}\" ng-disabled=!selected role=button ng-click=choose() data-dismiss=modal ng-hide=vm.showHelp>Выбрать</button></div></div><!-- edit person --><div class=\"persons-form-wrapper crud-entity\" ng-class=\"{\'view-entity\': vm.formMode === \'view\'}\" ng-show=vm.showForm><div ng-class=\"{\'blur-bg\': vm.showRemovePerson}\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=modal ng-click=vm.closePopup()>&times;</button><h4 class=modal-title ng-if=!vm.edit>Добавление персональных данных</h4><h4 class=modal-title ng-if=vm.edit ng-bind=\"(vm.formMode === \'view\')? \'Просмотр персональных данных\' : \'Редактирование персональных данных\'\"></h4></div><form class=\"persons-form container tab-form-group\" role=form name=personalDataForm><span class=\"add-new-post tooltip-light\" tooltip-placement=top-right uib-tooltip=\"Добавить банковский счет\" ng-click=vm.addAccountTab()></span><scrollable-tabset api=vm.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset active=vm.activeContact><uib-tab index=0 select=vm.selectTab(0)><uib-tab-heading class=tab-heading><span class=pull-left>Основное</span></uib-tab-heading><div class=clearfix><div class=row><div class=col-xs-6><div class=form-group><input type=text class=form-control hard-pruning empty-or-null name=surname required ng-if=\"!(vm.formMode === \'view\')\" id=surname ng-model=vm.person.surname data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-blur=vm.uniqueCheck() maxlength=50><label for=surname class=\"form-control-label small-offset\">Фамилия</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=req></span><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.surname || \'-\'}}</div></div><div class=form-group><input type=text ng-if=\"!(vm.formMode === \'view\')\" class=form-control ng-class=\"{\'ng-dirty\': vm.isSaved}\" name=first_name empty-or-null hard-pruning required id=first_name ng-model=vm.person.name data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-blur=vm.uniqueCheck() maxlength=50><label for=first_name class=\"form-control-label small-offset\">Имя</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=req></span><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.name || \'-\'}}</div></div><div class=form-group><input type=text hard-pruning empty-or-null ng-if=\"!(vm.formMode === \'view\')\" class=form-control name=patronymic id=patronymic ng-model=vm.person.patronymic data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-blur=vm.uniqueCheck() maxlength=50><label for=patronymic class=\"form-control-label small-offset\">Отчество</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.patronymic || \'-\'}}</div></div><div class=form-group ng-style=\"(vm.formMode === \'view\')?{\'margin-left\': \'15px\'} : \'\'\"><div date-range-picker ng-model=vm.birth_date opts=vm.datePickerOpts state=vm.birthDateState class=datepicker-wrap name=birth_date on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата рождения\'\"></div><div class=\"valid-message wrong-format-mess\" style=display:block ng-show=\"personalDataForm.birth_date.$error.mask && date_blur\">Некорректный формат</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=\"form-group birthlocation-wrapper\" ng-style=\"(vm.formMode === \'view\')?{\'margin-left\': \'15px\'} : \'\'\"><input type=text empty-or-null class=form-control id=birthlocation ng-model=vm.person.birth_place ng-blur=vm.uniqueCheck() name=birth_address maxlength=255><label for=birthlocation class=\"form-control-label small-offset\">Место рождения</label></div></div><div class=col-xs-6><div class=form-group><ui-select ng-model=vm.person.citizenship ng-if=\"!(vm.formMode === \'view\')\" search-enabled=vm.countryClassifiers.getSearchEnabled($select) ng-disabled=vm.countryClassifiers.getDisabled($select) name=countryClassifiers><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.countryClassifiers.refresh($select.search) repeat=\"item in vm.countryClassifiers.field.items track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Гражданство</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{(vm.person.citizenship && vm.person.citizenship.name) || \'-\'}}</div></div><div class=form-group><input inn-check ng-model=vm.person.inn hard-pruning data-check=([0-9_]) name=inn id=inn inn-type=fiz ng-if=\"!(vm.formMode === \'view\')\" ui-mask=999999999999 class=form-control ng-blur=\"inn_blur = true\" ng-focus=\"inn_blur = false\" ui-options=\"{ clearOnBlur: false, addDefaultPlaceholder: false }\"><label for=inn class=\"form-control-label small-offset\">ИНН</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=personalDataForm.inn.$error.validInn>Такой номер не существует</span> <span class=\"valid-message text-lowercase\" style=display:block ng-if=personalDataForm.inn.$error.mask>ИНН должен содержать 12 цифр</span><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.inn || \'-\'}}</div></div><div class=form-group><input id=snils snils-check ng-model=vm.person.snils hard-pruning data-check=\"[0-9\\- _]\" name=snils ng-if=\"!(vm.formMode === \'view\')\" class=form-control ui-mask=\"999-999-999 99\" ng-blur=\"snils_blur=true\" ng-focus=\"snils_blur=false\" ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" model-view-value=true><label for=snils class=\"form-control-label small-offset\">СНИЛС</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=personalDataForm.snils.$error.mask&&snils_blur>СНИЛС должен содержать 11 цифр</span> <span class=valid-message style=display:block ng-if=personalDataForm.snils.$error.validSnils&&!personalDataForm.snils.$error.mask>Такой номер не существует</span><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.snils || \'-\'}}</div></div><div class=form-group><ui-select ng-model=vm.person.marital_status search-enabled=false ng-if=\"!(vm.formMode === \'view\')\"><ui-select-match allow-clear=true><span ng-bind-html=$select.selected.value></span></ui-select-match><ui-select-choices repeat=\"type.key as (key, type) in vm.maritalStatuses | filter: { \'value\': $select.search }\"><span ng-bind-html=\"type.value | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Семейное положение</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.marital_status ? vm.maritalStatuses[vm.person.marital_status] : \'-\'}}</div></div></div><div class=req-mess ng-if=\"(!vm.person.name || !vm.person.surname) && vm.isSaved\">* Обязательные для заполнения поля</div><div class=req-mess ng-if=vm.isRepeatData>Персональные данные уже существуют в системе</div></div></div></uib-tab><uib-tab index=1 select=vm.selectTab(1)><uib-tab-heading class=tab-heading><span class=pull-left>Документ</span></uib-tab-heading><div class=clearfix><div class=row><div class=col-xs-6><div class=form-group><ui-select ng-model=vm.person.passport_type search-enabled=true ng-if=\"!(vm.formMode === \'view\')\"><ui-select-match allow-clear=true tooltip-placement=right uib-tooltip=\"{{$select.selected.value}}\"><span ng-bind-html=$select.selected.value></span></ui-select-match><ui-select-choices repeat=\"type.key as (key, type) in vm.passportTypes | filter: { \'value\': $select.search }\"><span ng-bind-html=\"type.value | highlight: $select.search\" tooltip-placement=\"{{$index < 3? \'bottom-left\' : \'top-left\'}}\" uib-tooltip=\"{{type.value}}\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Удостоверяющий документ</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.passport_type ? vm.passportTypes[vm.person.passport_type] :\'-\'}}</div></div><div class=form-group><input id=passport_series type=text class=form-control maxlength=32 ng-if=\"!(vm.formMode === \'view\')\" name=passport_series ng-model=vm.person.passport_series><label for=passport_series class=\"form-control-label small-offset\">Серия</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.passport_series || \'-\'}}</div></div><div class=form-group><input id=passport_number type=text class=form-control maxlength=31 ng-if=\"!(vm.formMode === \'view\')\" name=passport_number ng-model=vm.person.passport_number><label for=passport_number class=\"form-control-label small-offset\">Номер</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.passport_number || \'-\'}}</div></div><div class=form-group ng-style=\"(vm.formMode === \'view\')?{\'margin-left\': \'15px\'} : \'\'\"><div date-range-picker ng-model=vm.passport_date opts=vm.datePickerOpts state=vm.passportDateState class=datepicker-wrap name=passport_date on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата выдачи\'\"></div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div></div><div class=col-xs-6><div class=form-group><textarea id=passport_name_issued_by type=text class=form-control maxlength=1024 ng-if=\"!(vm.formMode === \'view\')\" name=passport_name_issued_by ng-model=vm.person.passport_name_issued_by></textarea><label for=passport_name_issued_by class=\"form-control-label small-offset\">Кем выдан (название)</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.passport_name_issued_by || \'-\'}}</div></div><div class=form-group><input id=passport_code_issued_by type=text class=form-control maxlength=32 ng-if=\"!(vm.formMode === \'view\')\" name=passport_code_issued_by ng-model=vm.person.passport_code_issued_by><label for=passport_number class=\"form-control-label small-offset\">Кем выдан (код)</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.passport_code_issued_by || \'-\'}}</div></div><div class=form-group><input type=text ng-if=\"!(vm.formMode === \'view\')\" id=passport_other class=\"form-control bank-name\" name=passport_other maxlength=255 ng-model=vm.person.passport_other><label for=passport_other class=\"form-control-label small-offset\">Прочие сведения</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.passport_other || \'-\'}}</div><div class=\"valid-message required-mess\">Поле является обязательным</div></div></div></div></div></uib-tab><uib-tab index=2 select=vm.selectTab(2)><uib-tab-heading class=tab-heading><span class=pull-left>Адреса</span></uib-tab-heading><div class=clearfix><div class=row><div class=col-xs-6><div class=form-group><address address-data=vm.person.legal_address name=\"\'legal_address\'\" ng-if=\"!(vm.formMode === \'view\')\" parent-form=personalDataForm field-label=\"\'Адрес регистрации\'\"></address><label ng-if=\"(vm.formMode === \'view\')\" class=\"form-control-label small-offset\">Адрес регистрации</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.legal_address && vm.person.legal_address.address_as_string || \'-\'}}</div></div><div class=form-group ng-if=\"vm.formMode !== \'view\'\"><div class=\"checkbox pull-left\" style=\"margin-top: 0\"><label style=\"outline: none;\" ng-click=$event.stopPropagation()><input type=checkbox ng-disabled=\"(vm.formMode === \'view\')\" id=same-addr ng-model=vm.person.real_address_eq_legal> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=same-addr>Адрес проживания совпадает с&nbsp;адресом регистрации</label></div><div class=form-group ng-show=\"vm.formMode === \'view\' || !vm.person.real_address_eq_legal\"><address address-data=vm.person.real_address name=\"\'real_address\'\" ng-if=\"!(vm.formMode === \'view\')\" parent-form=personalDataForm field-label=\"\'Адрес проживания\'\"></address><label ng-if=\"(vm.formMode === \'view\')\" class=\"form-control-label small-offset\">Адрес проживания</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{vm.person.real_address && vm.person.real_address.address_as_string || \'-\'}}</div></div></div></div></div></uib-tab><uib-tab ng-repeat=\"account in vm.person.accounts\" index=\"$index + 3\" select=\"vm.selectTab($index + 3)\"><uib-tab-heading class=tab-heading><span class=\"glyphicon glyphicon-star tooltip-light\" tooltip-placement=left uib-tooltip=\"Основной банковский счет\" ng-if=\"vm.person.accounts.length >= 2\" ng-show=account.main></span> <span>{{account.name || \'Банковский счет\'}}</span><span class=\"close-tab danger-close tooltip-light\" tooltip-placement=right uib-tooltip=Удалить ng-click=\"account.$$askRemove = true;\" ng-hide=\"account.main && vm.person.accounts.length >= 2\"></span><div class=\"remove-tab major-font\" ng-class=\"{\'ask-remove\': account.$$askRemove}\"><span class=\"glyphicon glyphicon-trash\"></span><label class=tab-remove-label>Удалить?</label><span class=pull-right><span class=tab-remove-yes ng-click=\"vm.removeAccountTab($index, $event)\">Да</span>/ <span class=tab-remove-no ng-click=\"account.$$askRemove = false;\">Нет</span></span></div></uib-tab-heading><div ng-form=\"{{\'vm.bankAcc\' + $index}}\"><div class=row><div class=col-xs-6><div class=form-group><input id=\"account-name{{$index}}\" required maxlength=20 ng-focus=\"vm.AccNameHelp = true\" ng-blur=\"vm.AccNameHelp = false; vm.checkAccountUnique()\" type=text ng-if=\"!(vm.formMode === \'view\')\" class=form-control value=account.name ng-model=account.name name=\"name{{$index}}\" ng-model-options=\"{debounce: 500}\" ng-keypress=\"personalDataForm[\'name\' + $index].$setValidity(\'unique\', true);\"><label for=\"account-name{{$index}}\" class=\"form-control-label small-offset\">Название счета</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{account.name || \'-\'}}</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Счет с таким именем уже существует</div><span class=req></span></div><div class=form-group><input id=\"bik{{$index}}\" type=text hard-pruning data-check=([0-9_]) class=form-control required ng-if=\"!(vm.formMode === \'view\')\" name=\"bik{{$index}}\" ng-model=account.bik ng-focus=\"bik_focus=true\" ng-blur=\"bik_focus=false;!(personalDataForm[\'bik\' + $index].$error.mask)? vm.getBankInfo($event, account.bik) : \'\'\" ng-enter=\"!(personalDataForm[\'bik\' + $index].$error.mask)? vm.getBankInfo($event) : \'\'\" ui-mask=999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=\"bik{{$index}}\" class=\"form-control-label small-offset\">БИК</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{account.bik || \'-\'}}</div><div class=\"valid-message required-mess\" ng-hide=bik_focus>Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-show=\"personalDataForm[\'bik\' + $index].$error.mask && !bik_focus\">БИК должен содержать 9 цифр</span> <span class=req></span></div><div class=form-group><input id=\"account{{$index}}\" type=text class=form-control hard-pruning ng-if=\"!(vm.formMode === \'view\')\" data-check=([0-9_]) required name=\"account{{$index}}\" ng-model=account.account ui-mask=99999999999999999999 ng-focus=\"account_focus = true\" ng-blur=\"account_focus = false\" ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=\"account{{$index}}\" class=\"form-control-label small-offset\">Банковский счет</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{account.account || \'-\'}}</div><div class=\"valid-message required-mess\" ng-hide=account_focus>Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-show=\"personalDataForm[\'account\' + $index].$error.mask && !account_focus\">Поле должно содержать 20 цифр</span> <span class=req></span></div><div class=form-group><ui-select ng-model=account.currency ng-if=\"!(vm.formMode === \'view\')\" search-enabled=\"(vm.currencies.field.total > 100 && vm.currencies.field.length <= 100)\" required><ui-select-match><span ng-bind-html=\"$select.selected.name + \' (\' +$select.selected.char_iso_code+\')\'\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.currencies.refresh($select.search) repeat=\"item in (vm.currencies.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"(item.name + \' (\' +item.char_iso_code+\')\') | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Валюта</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\" ng-bind-html=\"account.currency && (account.currency.name + \' (\' + account.currency.char_iso_code + \')\')\"></div><span class=req></span></div></div><div class=col-xs-5><div class=form-group><textarea type=text ng-if=\"!(vm.formMode === \'view\')\" id=\"bank-name{{$index}}\" class=\"form-control bank-name\" name=\"bankName{{$index}}\" maxlength=255 required ng-model=account.bank ng-disabled=\"!personalDataForm.bik{{$index}}.$dirty || !account.bik\"></textarea><label for=\"bank-name{{$index}}\" class=\"form-control-label small-offset\">Наименование банка</label><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{account.bank}}</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=form-group><input id=\"corr-account{{$index}}\" type=text ng-if=\"!(vm.formMode === \'view\')\" class=\"form-control corr-account\" hard-pruning data-check=([0-9_]) required name=\"corAcc{{$index}}\" ng-model=account.corr_account ng-disabled=\"!personalDataForm.bik{{$index}}.$dirty || !account.bik\" ui-mask=99999999999999999999 ng-focus=\"corr_acc_focus = true\" ng-blur=\"corr_acc_focus = false\" ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=\"corr-account{{$index}}\" class=\"form-control-label small-offset\">Корр. счет</label><div class=\"valid-message required-mess\" ng-hide=corr_acc_focus>Поле является обязательным</div><div class=view-entity-control ng-if=\"(vm.formMode === \'view\')\">{{account.corr_account}}</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-show=\"personalDataForm[\'corAcc\' + $index].$error.mask && !corr_acc_focus && !personalDataForm[\'bik\' + $index].$error.wrongBik\">Поле должно содержать 20 цифр</span> <span class=req></span></div><div class=\"form-group checkbox-group\" ng-if=\"!(vm.formMode === \'view\')\" ng-show=\"vm.person.accounts.length > 1\"><div class=\"checkbox pull-left\"><label><input ng-disabled=account.main type=checkbox ng-model=account.main ng-click=\"vm.changeMainAccount($index, account.main)\" id=\"mainAcc{{$index}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"mainAcc{{$index}}\">Сделать этот счет основным (<span class=\"glyphicon glyphicon-star\" style=\"margin: 0;\"></span>)</label></div></div></div><div class=req-mess ng-if=\"vm[\'bankAcc\' + $index].$invalid && vm.isSaved\">* Обязательные для заполнения поля</div></div></uib-tab></uib-tabset></scrollable-tabset></form><div class=modal-footer ng-if=vm.edit><button class=btn role=button ng-if=\"$root.hasRole(\'person.write\') && !vm.formMode && !vm.editMode\" ng-click=\"vm.showRemovePerson = true;vm.avaliableToDelete()\"><span class=\"btn-ico glyphicon glyphicon-trash\"></span>Удалить</button> <button class=btn role=button ng-if=\"!vm.formMode && !vm.editMode\" ng-click=vm.resetValues()>Отменить</button> <button class=\"btn btn-primary\" role=button ng-if=\"$root.hasRole(\'person.write\') && vm.formMode == \'view\'\" ng-click=vm.editOn();>Редактировать</button> <button type=submit class=\"btn btn-primary\" role=button ng-disabled=vm.isRepeatData ng-if=\"$root.hasRole(\'person.write\') && vm.formMode !== \'view\'\" ng-click=\"vm.validatePersonsForm(personalDataForm, vm.save)\">Обновить</button></div><div class=modal-footer ng-if=!vm.edit><button class=btn role=button ng-click=vm.resetValues()>Отменить</button> <button type=submit class=btn role=button ng-disabled=\"vm.isRepeatData || (vm.isSaved && personalDataForm.$invalid)\" ng-click=\"vm.validatePersonsForm(personalDataForm, vm.save)\">Создать</button> <button type=submit class=\"btn btn-primary\" role=button ng-disabled=\"vm.isRepeatData || (vm.isSaved && personalDataForm.$invalid)\" ng-click=\"vm.select = true; vm.validatePersonsForm(personalDataForm, vm.save)\">Создать и выбрать</button></div></div><div class=remove-box ng-show=vm.showRemovePerson ng-class={toAllWindow:vm.toAllWindow}><div><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=alert aria-hidden=true ng-click=vm.candelDeletetion()>×</button><h3 class=remove-box-title>Удаление</h3><p ng-if=!vm.cantBeDeleted>Персональные данные используются в:</p></div><div class=no-data ng-if=vm.cantBeDeleted>Вы действительно хотите удалить персональные данные физического лица?</div><div style=\"margin-bottom: auto\" class=yes-data ng-if=!vm.cantBeDeleted ng-scrollbars ng-scrollbars-config=vm.configScroll><ul class=references-list ng-class={showHiddenData:vm.showHiddenData}><li ng-repeat=\"shortRef in vm.shortRefArray\"><a href=\"{{shortRef.url}}\" ng-click=cancel()><span class=\"glyphicon glyphicon-file\"></span> {{shortRef.type}} </a></li><li class=all-references-button ng-if=\"vm.longRefArray.length > 0\" ng-hide=vm.toAllWindow ng-click=vm.showAll()><span>Все</span></li><li ng-repeat=\"longRef in vm.longRefArray\"><a href=\"{{longRef.url}}\" ng-click=cancel()><span class=\"glyphicon glyphicon-file\"></span> {{longRef.type}} </a></li></ul></div><span ng-if=!vm.cantBeDeleted>После удаления юридически значимые документы, связанные с этим физическим лицом, будут обезличены. Вы подтверждаете удаление?</span><p class=\"footer-buttons clearfix\"><button type=button ng-class=\"{\'change-margin\':!vm.cantBeDeleted}\" ng-click=\"vm.showRemovePerson = false;vm.deletePerson()\" class=\"btn btn-primary\">Да</button> <button type=button ng-click=vm.candelDeletetion() class=btn>Нет</button></p></div></div><!-- </div> --></div></div><!-- </script> --></div><modal-load close-fun=cancel show-main-modal=vm.showModal status=vm.loadingData success=vm.success fail=vm.fail callback=vm.loadList class=person-modal-load></modal-load></div>");
$templateCache.put("app/components/reportPeriod/report-period.html","<div class=\"form-group clearfix\" style=\"padding: 0;\"><div class=col-xs-6><h5 style=\"font-weight: bold;\">ПЕРИОД ОТЧЕТА</h5><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'yestarday\');\">Вчера</span><br><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'last month\');\">Прошлый месяц</span><br><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'last quarter\');\">Прошлый квартал</span><br><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'last year\');\">Прошлый год</span></div><div class=col-xs-6 style=\"padding-top: 29px;\"><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'today\');\">Сегодня</span><br><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'this month\');\">Текущий месяц</span><br><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'this quarter\');\">Текущий квартал</span><br><span class=link-style ng-click=\"reportPeriodCtrl.setReportInterval(\'this year\');\">Текущий год</span></div></div><div class=\"form-group col-xs-6\"><div date-range-picker state=start_date ng-model=reportPeriodCtrl.startDate opts=\"{singleDatePicker: true, correctTimeZone: false, maxDate: reportPeriodCtrl.today, drops: \'up\'}\" ng-required=true class=datepicker-wrap name=dateTo field-label=\"\'Начало периода\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group col-xs-6\"><div date-range-picker state=end_date ng-model=reportPeriodCtrl.endDate opts=\"{singleDatePicker: true, correctTimeZone: false, maxDate: reportPeriodCtrl.today, drops: \'up\'}\" ng-required=true class=datepicker-wrap name=dateTo field-label=\"\'Конец периода\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div>");
$templateCache.put("app/components/status-button/status-button.html","<div class=\"doc-settings-block text-right\" style=\"position: relative;\"><button type=button class=\"btn slim-button\" ng-click=action() ng-class=\"{\'dropdown-toggle\': mode === \'ALL\'}\" data-toggle=\"{{(mode === \'ALL\')? \'dropdown\' : \'\'}}\" ng-if=mode><span ng-if=\"mode !== \'ALL\'\" ng-class=\"{\'done\': mode === \'DRAFT\', \'no-done\': mode === \'PROCESSED\'}\"></span> {{buttonName}} <span class=caret ng-if=\"mode === \'ALL\'\"></span></button><ul class=\"dropdown-menu pull-right\" role=menu ng-if=\"mode === \'ALL\'\"><li ng-click=startProcessing()><a><span class=done></span>Провести</a></li><li ng-click=cancelProcessing()><a><span class=no-done></span>Отменить проведение</a></li></ul></div>");
$templateCache.put("app/components/timer/timer.html","<span class=timer ng-bind=\"timerCtrl.addZero(timerCtrl.minutes) + \':\' + timerCtrl.addZero(timerCtrl.seconds)\"></span>");
$templateCache.put("app/components/timezone/timezone.html","<div class=time_zone><ui-select ng-model=vm.timezoneData search-enabled=false ng-disabled=\"!vm.timezones.length || vm.ngDisabled\" ng-required=vm.ngRequired><ui-select-match allow-clear=vm.allowClear><span ng-bind-html=\"\'(UTC\' + $select.selected.offset + \') \' + $select.selected.displayName\"></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"timezone in vm.timezones track by $index\"><span ng-bind-html=\"(\'(UTC\' + timezone.offset + \') \' + timezone.displayName) | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>{{vm.fieldLabel}}</label><span class=req ng-if=vm.ngRequired></span></div>");
$templateCache.put("app/components/tooltip-text-depend/tooltip-text-depend.html","<span uib-tooltip=\"{{ (isFits)? text :\'\' }}\" tooltip-placement=\"{{placement}}\" class=tooltip-light><span class=\"{{classes}}\">{{ text }}</span></span>");
$templateCache.put("app/documents/document-crud/document-abstract-crud.html","<div ui-view></div>");
$templateCache.put("app/documents/document-crud/document-crud.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>{{$stateParams.parent === \'storehouse\' ? \'Склад\' : ($stateParams.parent === \'money\' || !$stateParams.parent)? \'Деньги\' : ($stateParams.parent === \'sale\')? \'Продажи\' : \'Закупки\'}}</a></li><li ng-if=!$stateParams.allDocument><a ui-sref=\"documents({type:documentCrudCtrl.type, parent: $stateParams.parent})\" ng-bind=documentCrudCtrl.metainfo.layout.properties.plural_name></a></li><li ng-if=\"$stateParams.allDocument || (!$stateParams.parent && !documentCrudCtrl.metainfo.layout.properties)\"><a ui-sref=allDocuments>Все документы</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix\" ng-class=\"(!documentCrudCtrl.redact)? \'view-entity\': \'\'\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 250px);\"><span class=\"light-custom-tip-wrap doc-status-icon\" ng-class=\"{\n        \'on\': documentCrudCtrl.documentCommonData.status == \'PROCESSED\',\n        \'on-disabled\': documentCrudCtrl.documentCommonData.status == \'PROCESSED\' && documentCrudCtrl.isExpirationDate,\n        \'off\': documentCrudCtrl.documentCommonData.status == \'DRAFT\',\n        \'wait\': documentCrudCtrl.documentCommonData.status == \'IN_PROCESS\' || documentCrudCtrl.documentCommonData.status == \'IN_ROLLBACK\',\n        \'off-disabled\': documentCrudCtrl.isExpirationDate && documentCrudCtrl.documentCommonData.status == \'DRAFT\'}\" ng-show=documentCrudCtrl.documentCommonData.id><div class=light-custom-tip style=\"margin-top: 30px; margin-left: 20px;\">Статус: <span ng-if=\"documentCrudCtrl.documentCommonData.status == \'PROCESSED\'\">Проведен</span> <span ng-if=\"documentCrudCtrl.documentCommonData.status == \'DRAFT\'\">Черновик</span> <span ng-if=\"documentCrudCtrl.documentCommonData.status == \'IN_PROCESS\' || documentCrudCtrl.documentCommonData.status == \'IN_ROLLBACK\'\">В обработке</span></div></span><span ng-if=!documentCrudCtrl.documentCommonData.id ng-bind=\"documentCrudCtrl.docPurpose.new_word_gender | newWord\"></span> <span ng-bind=documentCrudCtrl.docPurpose.purpose_name ng-class=\"{\'first-letter-lowercase\': !documentCrudCtrl.documentCommonData.id}\"></span> <span ng-if=documentCrudCtrl.documentCommonData.id>№<span ng-bind=documentCrudCtrl.documentCommonData.number></span><!-- todo hover --> &nbsp;от&nbsp;<span ng-bind=\"documentCrudCtrl.crudsService.getFormattedDate(documentCrudCtrl.documentCommonData.date, false).toLowerCase()\"></span></span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=documentCrudCtrl.documentCommonData.id><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\"><span class=\"persons-ico pull-left\" style=\"margin-top: 0;\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение: {{documentCrudCtrl.documentCommonData.updated_at | date:\'dd.MM.yyyy\'}}</span><div class=\"light-custom-tip persons-info\"><div class=clearfix><span class=pull-left ng-bind=\"\'Создан: \' + (documentCrudCtrl.documentCommonData.created_at | date:\'dd.MM.yyyy HH:mm\')\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span class=person-name ng-bind=\"documentCrudCtrl.documentCommonData.created_by.name || \'-\'\"></span></span></div><div class=clearfix ng-if=\"documentCrudCtrl.documentCommonData.updated_at && documentCrudCtrl.documentCommonData.updated_at !== documentCrudCtrl.documentCommonData.created_at\"><span class=pull-left ng-bind=\"\'Изменен: \' + (documentCrudCtrl.documentCommonData.updated_at | date:\'dd.MM.yyyy HH:mm\')\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span class=person-name ng-bind=\"documentCrudCtrl.documentCommonData.updated_by.name || \'-\'\"></span></span></div></div></span></span></div><div ng-include=\"\'app/documents/document-crud/includes/buttons.html\'\"></div><div ng-form=documentCrudCtrl.documentAllForm class=document-form><document redact=documentCrudCtrl.redact document-meta=documentCrudCtrl.metadata document=documentCrudCtrl.commonFieldsMeta purpose=documentCrudCtrl.purpose form-validation=documentCrudCtrl.formCommonValidation values=documentCrudCtrl.documentCommonData currency-home=documentCrudCtrl.currencyHome get-currencies-rate=documentCrudCtrl.getCurrenciesRate amount-calculate=documentCrudCtrl.documentsAmountsCalculate reference-data=documentCrudCtrl.referenceData start-saving=documentCrudCtrl.startSaving form-name=\"\'commonData\'\" check-valid=documentCrudCtrl.checkValid doc-settings=documentCrudCtrl.settings form-ctrl=documentCrudCtrl.documentAllForm need-add-to-cart=true></document><document redact=documentCrudCtrl.redact document-meta=documentCrudCtrl.metadata document=documentCrudCtrl.metainfo common-meta=documentCrudCtrl.commonFieldsMeta purpose=documentCrudCtrl.purpose external-data=documentCrudCtrl.documentCommonData form-validation=documentCrudCtrl.formValidation values=documentCrudCtrl.documentData form-name=\"\'meta\'\" currency-home=documentCrudCtrl.currencyHome get-currencies-rate=documentCrudCtrl.getCurrenciesRate amount-calculate=documentCrudCtrl.documentsAmountsCalculate reference-data=documentCrudCtrl.referenceData start-saving=documentCrudCtrl.startSaving check-valid=documentCrudCtrl.checkValid doc-settings=documentCrudCtrl.settings form-ctrl=documentCrudCtrl.documentAllForm need-add-to-cart=true></document></div></div>");
$templateCache.put("app/documents/document-grid/document-grid.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>{{$stateParams.parent === \'storehouse\' ? \'Склад\' : ($stateParams.parent === \'money\')? \'Деньги\' : ($stateParams.parent === \'sale\')? \'Продажи\' : \'Закупки\'}}</a></li></ul><grid-wide url=vm.url page=vm.page header=vm.header no-data-str=vm.noDataStr filters-required=true row-route=vm.rowRoute row-route-func=vm.rowRouteFunc sort=vm.sort limit=vm.limit base-columns-count=3 default-position=4 column-defs=vm.columnDefs using-service=vm.usingService filter-meta=vm.filterMeta config=::vm.gridConfig currency=vm.currency stop-editing=vm.docSettings.domain_documents_settings.stop_editing></grid-wide></div>");
$templateCache.put("app/documents/document-print/document-print.html","<div class=modal-header><button type=button class=close ng-click=$ctrl.close()>×</button><h3 class=modal-title>{{$ctrl.printForm.name}}</h3></div><div class=\"container row\"><div ng-show=!$ctrl.longRequest.crudState.loading><div class=col-xs-12 ng-if=\"!$ctrl.longRequest.flags.finish && !$ctrl.formats\">Распечатать \"<strong ng-bind=$ctrl.printForm.name></strong>\"?</div><div ng-if=\"!$ctrl.longRequest.flags.finish && $ctrl.formats\"><label class=col-xs-12 style=\"padding-left: 15px;padding-bottom: 20px;\">Формат файла</label><div class=\"col-xs-3 form-group\" ng-repeat=\"format in $ctrl.formats\"><div class=\"radio pull-left\"><label><input type=radio checked name=formatType ng-value=format id=\"{{format}}\" ng-model=$ctrl.format> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=\"{{format.toLowerCase()}} label-icon\"></span><label class=\"label-radio label-with-icon\" for=\"{{format}}\">{{format}}</label></div><div class=col-xs-12></div><div class=\"col-xs-6 form-group\" ng-repeat=\"parameter in $ctrl.printForm.parameters\"><div ng-if=\"parameter.type === \'BOOLEAN\'\" class=\"form-group form-group-checkbox\"><div class=\"checkbox pull-left\"><label><input type=checkbox checked name=\"{{parameter.code}}\" ng-value=parameter.code id=\"{{parameter.code}}\" ng-model=$ctrl.params[parameter.code]> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=\"{{parameter.code}}\">{{parameter.name}}</label></div></div></div></div><inview-loader class=popup show=$ctrl.longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center;\" ng-if=\"l$ctrl.ongRequest.crudState.loading && !$ctrl.longRequest.flags.finish\">Подготовка отчета</h4><h4 style=\"text-align: center;\" ng-if=\"!$ctrl.longRequest.crudState.loading && $ctrl.longRequest.flags.finish && !$ctrl.longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center;\" ng-if=$ctrl.longRequest.flags.error ng-bind=$ctrl.errorMessage></h4></div><div class=modal-footer><button class=btn type=button ng-click=$ctrl.close()>{{$ctrl.hide ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-show=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.processStart && !$ctrl.longRequest.flags.finish\" class=\"btn btn-primary\" type=button ng-click=\"$ctrl.hide = true;$ctrl.print()\">Печать</button></div>");
$templateCache.put("app/documents/document-settings/document-settings.html","<div class=\"settings catalog crud-entity\"><!-- content of settings --><div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-when=retail><a>Розница</a></li><li ng-switch-when=storehouse><a>Склад</a></li><li ng-switch-default><a>Деньги</a></li></ul><h1>Настройки документов</h1><div class=ui-spinner ng-if=vm.loading style=\"margin: 60px 42%; position: absolute;\"></div><form ng-submit=vm.submit() role=form name=vm.documentSettingsForm class=doc-settings ng-if=!vm.loading><div class=\"full-width clearfix\"><section class=\"form-group title-out-group col-xs-9\"><!--<h5 class=\"section-header\">Настройки документов для каждого типа</h5>--><div class=clearfix style=\"width: 105%;\"><span>Разрешать редактировать документы в течение</span><div style=\"width: 58px; display: inline-block; margin: 0 8px;position: relative;\"><input type=text id=stop_editing class=\"form-control text-right slim-control\" max-val=::365 min-val=::1 ng-model=vm.settings.domain_documents_settings.stop_editing integer-input required><div class=\"valid-message max-mess\" style=\"min-width: max-content;\">Не более 365</div></div><span>дней</span></div></section></div><div class=\"full-width clearfix\"><section class=\"form-group title-out-group col-xs-9\"><div class=checkbox-group><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.autoStartProcessing ng-change=vm.onAutoStartProcessingChange() id=auto-start-processing> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=auto-start-processing>Автоматически запускать проведение документов</label></div><div ng-if=vm.autoStartProcessing><div class=\"form-group last-group\" style=\"margin-top: 30px;\"><span>Через</span><div style=\"width: 70px; display: inline-block; margin: 0 8px;position: relative;\"><input type=text id=start_processing class=\"form-control text-right slim-control\" max-val=::1440 min-val=::0 ng-model=vm.settings.domain_documents_settings.start_processing integer-input required><div class=\"valid-message max-mess\" style=\"min-width: max-content;\">Не более 1440</div></div><span>минут после сохранения</span></div></div></section></div><div class=\"full-width clearfix\"><section class=\"form-group col-xs-9 title-out-group\"><!--<h5 class=\"section-header\">Автоматическое формирование кодов</h5>--><div class=clearfix><div class=\"checkbox-group col-xs-8\" style=\"display: inline-block;padding: 0;margin-top: 8px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.settings.domain_documents_settings.auto_numbers id=auto_numbers> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=auto_numbers>Автоматически создавать номер документа</label></div><button class=link-style ng-disabled=!vm.settings.domain_documents_settings.auto_numbers style=\"float: right; margin-top: 5px;\" ng-click=vm.autoNumbersPopup()>Параметры</button></div></section></div><div class=\"full-width clearfix\"><section class=\"form-group col-xs-9 title-out-group\"><div class=clearfix><div class=\"checkbox-group col-xs-8\" style=\"display: inline-block; padding: 0; margin-top: 8px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.is_auto_price id=is_auto_price ng-change=vm.setDirty()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=is_auto_price>Автоматически заполнять цены в линейках документов</label></div><button class=link-style ng-disabled=!vm.is_auto_price style=\"float: right; margin-top: 5px;\" ng-click=vm.autoPricePopup()>Параметры</button></div></section></div><div class=\"full-width clearfix\"><section class=\"form-group col-xs-9 hide-fields\" ng-init=\"(vm.settings.domain_documents_settings.invoice_header)? vm.is_invoice_header = true : \'\'\" ng-class=\"{\'same-padding\': !vm.is_invoice_header}\"><div class=add-item-wrap ng-click=\"vm.is_invoice_header = !vm.is_invoice_header\"><span class=add-item-icon></span> <span class=add-item-title>Дополнительная информация в шапке документа \"Счет на оплату\"</span></div><div class=added-item-wrap><div class=\"danger-close tooltip-light\" ng-click=\"vm.is_invoice_header = !vm.is_invoice_header; vm.settings.domain_documents_settings.invoice_header = undefined;\" tooltip-placement=bottom-left uib-tooltip=Удалить></div><h5 class=section-header>Дополнительная информация в шапке документа \"Счет на оплату\"</h5><div class=\"form-group row col-xs-12\" style=\"padding-right: 0; margin-bottom: 0;\"><textarea empty-to-null class=form-control rows=3 id=invoice_header ng-model=vm.settings.domain_documents_settings.invoice_header></textarea><label for=invoice_header class=form-control-label>Текст</label></div></div></section></div><div class=\"section bottom-buttons col-xs-9\"><form-errors form-ctrl=vm.documentSettingsForm can-show=vm.isSetDirty></form-errors><form-buttons view-type=\"{isEdit: true}\" on-button=vm.crud(status) hide-delete=true can-disabled=\"vm.isSetDirty && !vm.documentSettingsForm.$valid\"></form-buttons></div></form></div></div>");
$templateCache.put("app/documents/document-to-price-list/document-to-price-list.html","<div class=modal-header><button type=button class=close ng-click=$ctrl.close()>×</button><h3 class=modal-title>Добавление товаров и цен в закупочный прайс-лист</h3></div><div class=\"container gray-content\" ng-form=$ctrl.priceBoxForm style=\"position: relative;\n    border-radius: 6px;\n    box-shadow: 0 2px 8px 0 rgba(184, 178, 178, 0.5);\n    padding: 20px;\n    margin: 0px 20px;\n    max-width: 94.5%;\"><div style=\"margin: 150px auto; width: 340px;\" ng-if=$ctrl.loading><div class=ui-spinner style=\"margin: 0 auto 15px;\"></div><span>Подождите, проводится добавление данных</span></div><div class=clearfix ng-if=!$ctrl.loading ng-scrollbars ng-scrollbars-config=$ctrl.configScroll><div class=form-group><label>В какую колонку прайс-листа мы загружаем данные?</label><div class=row ng-repeat=\"column in $ctrl.purchaseColumns\"><div class=col-xs-12 style=\"min-height: 36px;\"><div class=\"radio pull-left\"><label><input type=radio name=\"column{{$index}}\" ng-model=$ctrl.requestData.column ng-value=column id=\"column{{$index}}\" ng-change=\"$ctrl.createdColumn.name = undefined; $ctrl.clearValidationError(\'columnNewInput\')\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"column{{$index}}\" ng-bind=column.name></label></div></div><div class=row><div class=col-xs-8><div class=\"radio pull-left\"><label><input type=radio name=columnNew ng-model=$ctrl.requestData.column ng-value=$ctrl.createdColumn id=columnNew> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=columnNew style=\"font-style: italic;\">Создать новую колонку</label></div></div><div class=row style=\"top: -7px; position: relative;\"><div class=col-xs-8 style=\"margin-left: 40px;\"><input class=\"form-control slim-control\" name=columnNewInput ng-model=$ctrl.createdColumn.name ng-blur=$ctrl.checkNewColumnName() maxlength=50 ng-keyup=\"$ctrl.clearValidationError(\'columnNewInput\')\" ng-required=\"$ctrl.requestData.column == $ctrl.createdColumn\"><div class=\"valid-message isset-name\" style=\"top: 33px;\">Название колонки уже существует</div><div class=\"valid-message required-mess\" style=\"top: 33px;\">Поле является обязательным</div><span style=\"font-size: 14px; color: rgba(51, 51, 51, 0.6);\">Не более 50 символов</span></div></div></div><div class=form-group><label>Добавлять товар, если его нет в закупочном прайс-листе?</label><div class=row><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=addItem ng-model=$ctrl.requestData.add_item ng-value=true id=addItemYes> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=addItemYes>Да</label></div><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=addItem ng-model=$ctrl.requestData.add_item ng-value=false id=addItemNo> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=addItemNo>Нет</label></div></div></div><div class=form-group><label>Обновлять цены товарам, которые уже есть в закупочном прайс-листе?</label><div class=row><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=updatePrice ng-model=$ctrl.requestData.update_price ng-value=true id=updatePriceYes> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=updatePriceYes>Да</label></div><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=updatePrice ng-model=$ctrl.requestData.update_price ng-value=false id=updatePriceNo> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=updatePriceNo>Нет</label></div></div></div><div class=form-group style=\"margin-bottom: 0;\"><label>Сохранять количество товара, как условие действия цены?</label><div class=row><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=keepQty ng-model=$ctrl.requestData.$$keep_qty ng-value=true id=keepQtyYes> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=keepQtyYes>Да</label></div><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=keepQty ng-model=$ctrl.requestData.$$keep_qty ng-value=false id=keepQtyNo> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=keepQtyNo>Нет</label></div></div></div></div></div><div class=modal-footer><button class=btn type=button ng-click=$ctrl.close()>Отменить</button> <button class=\"btn btn-primary\" ng-disabled=\"$ctrl.loading || $ctrl.priceBoxForm.$invalid\" ng-click=$ctrl.updatePrices()>Добавить</button></div>");
$templateCache.put("app/egaisz/beer-declaration/beer-declaration.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li><li><a ui-sref=\"beerDeclarations({parent: \'alcohol\'})\">Пивные декларации</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix beer-declaration-wrapper\" ng-class=\"{\'view-entity\': !beerDeclarationCtrl.redact, \'new-beer-declaration\': beerDeclarationCtrl.newDoc}\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 175px);\"><span class=\"light-custom-tip-wrap doc-status-icon\" ng-class=\"{\'off\': beerDeclarationCtrl.values.status == \'DRAFT\', \'on\': beerDeclarationCtrl.values.status == \'CONFIRMED\'}\" ng-if=!beerDeclarationCtrl.newDoc></span> <span ng-if=beerDeclarationCtrl.newDoc>Добавление пивной декларации</span> <span ng-if=beerDeclarationCtrl.values.id>Пивная декларация №{{beerDeclarationCtrl.values.doc_number}} за {{beerDeclarationCtrl.values.period_reporting | periodReportings}} {{beerDeclarationCtrl.values.year_reporting}} года</span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=beerDeclarationCtrl.values.status_history.length><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\" ng-click=beerDeclarationCtrl.openHistoryPopup();><span class=\"persons-ico pull-left\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение:<br>{{beerDeclarationCtrl.values.status_history[0].created_at | date:\'dd.MM.yyyy HH:mm\'}}</span><div class=\"light-custom-tip persons-info\"><div ng-repeat=\"statusData in beerDeclarationCtrl.values.status_history\"><span class=pull-left ng-bind=\"statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span ng-bind=\"statusData.status | beerDeclarationsStatus\"></span><br><span class=person-name ng-bind=statusData.created_by.name></span></span></div></div></span></span></div><div style=\"position: relative; top: -20px;\"><span ng-bind=\"beerDeclarationCtrl.values.status | beerDeclarationsStatus\"></span></div><div ng-include=\"\'app/egaisz/beer-declaration/includes/buttons.html\'\"></div><div ng-form=beerDeclarationCtrl.form><document redact=beerDeclarationCtrl.redact document-meta=beerDeclarationCtrl.meta.metadata document=beerDeclarationCtrl.meta purpose=beerDeclarationCtrl.purpose form-validation=beerDeclarationCtrl.formCommonValidation values=beerDeclarationCtrl.values external-data=beerDeclarationCtrl.values currency-home=beerDeclarationCtrl.currencyHome get-currencies-rate=beerDeclarationCtrl.getCurrenciesRate amount-calculate=beerDeclarationCtrl.documentsAmountsCalculate reference-data=beerDeclarationCtrl.values start-saving=beerDeclarationCtrl.startSaving form-name=\"\'commonData\'\" form-ctrl=beerDeclarationCtrl.form check-valid=beerDeclarationCtrl.checkValid></document></div></div>");
$templateCache.put("app/egaisz/beer-declarations-list/beer-declarations-list.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><grid-wide url=beerDeclarationsListCtrl.url page=beerDeclarationsListCtrl.page header=beerDeclarationsListCtrl.header filters-required=true row-route-func=beerDeclarationsListCtrl.rowRouteFunc sort=beerDeclarationsListCtrl.sort limit=beerDeclarationsListCtrl.limit base-columns-count=3 default-position=4 search-placeholder=\"\'Поиск по номеру декларации и наименованию компании\'\" column-defs=beerDeclarationsListCtrl.columnDefs using-service=beerDeclarationsListCtrl.usingService filter-meta=beerDeclarationsListCtrl.filterMeta config=beerDeclarationsListCtrl.gridConfig grid-button-config=beerDeclarationsListCtrl.gridButtonConfig currency=beerDeclarationsListCtrl.currency></grid-wide></div>");
$templateCache.put("app/egaisz/beginning-balance-egais/beginning-balance-egais.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li><li><a ui-sref=\"beginningBalanceEgaisList({parent: \'alcohol\'})\">Остатки ЕГАИС</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix\" ng-class=\"{\'view-entity\': !beginningBalanceEgaisCtrl.redact}\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 175px);\"><span ng-bind=beginningBalanceEgaisCtrl.meta.metadata.document_type.name ng-class=\"{\'first-letter-lowercase\': !beginningBalanceEgaisCtrl.values.id}\"></span> <span ng-if=beginningBalanceEgaisCtrl.values.id>№<span ng-bind=beginningBalanceEgaisCtrl.values.doc_number></span><!-- todo hover --> &nbsp;от&nbsp;<span ng-bind=\"beginningBalanceEgaisCtrl.crudsService.getFormattedDate(beginningBalanceEgaisCtrl.values.doc_date, false).toLowerCase()\"></span></span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=beginningBalanceEgaisCtrl.values.status_history.length><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\" ng-click=beginningBalanceEgaisCtrl.openHistoryPopup();><span class=\"persons-ico pull-left\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение:<br>{{beginningBalanceEgaisCtrl.values.status_history[0].created_at | date:\'dd.MM.yyyy HH:mm\'}}</span><div class=\"light-custom-tip persons-info\"><div ng-repeat=\"statusData in beginningBalanceEgaisCtrl.values.status_history\"><span class=pull-left ng-bind=\"statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span ng-bind=\"statusData.document_status | beginningBalancesEgaisStatus\"></span><br><span class=person-name ng-bind=statusData.created_by.name></span></span></div></div></span></span></div><div style=\"position: relative; top: -20px;\"><span ng-bind=\"beginningBalanceEgaisCtrl.values.document_status | beginningBalancesEgaisStatus\"></span> <span class=\"info-icon tooltip-light\" ng-click=beginningBalanceEgaisCtrl.showStatusComment(beginningBalanceEgaisCtrl.values.status_comment); uib-tooltip=\"Показать дополнительную информацию\" ng-if=\"beginningBalanceEgaisCtrl.values.status_comment && (beginningBalanceEgaisCtrl.values.document_status == \'MARK_REQUEST_ERROR\' || beginningBalanceEgaisCtrl.values.document_status == \'REJECTED\' || beginningBalanceEgaisCtrl.values.document_status == \'ACCOUNTED_ERROR\')\" style=\"position: relative; top: 2px; left: 5px;\"></span></div><div ng-include=\"\'app/egaisz/beginning-balance-egais/includes/buttons.html\'\"></div><div ng-form=beginningBalanceEgaisCtrl.beginningBalanceForm class=hide-grid-buttons><document redact=beginningBalanceEgaisCtrl.redact document-meta=beginningBalanceEgaisCtrl.meta.metadata document=beginningBalanceEgaisCtrl.meta purpose=beginningBalanceEgaisCtrl.purpose form-validation=beginningBalanceEgaisCtrl.formCommonValidation values=beginningBalanceEgaisCtrl.values external-data=beginningBalanceEgaisCtrl.values currency-home=beginningBalanceEgaisCtrl.currencyHome get-currencies-rate=beginningBalanceEgaisCtrl.getCurrenciesRate amount-calculate=beginningBalanceEgaisCtrl.documentsAmountsCalculate reference-data=beginningBalanceEgaisCtrl.values start-saving=beginningBalanceEgaisCtrl.startSaving form-name=\"\'commonData\'\" check-valid=beginningBalanceEgaisCtrl.checkValid></document></div></div>");
$templateCache.put("app/egaisz/beginning-balance-egais-list/beginning-balance-egais-list.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><grid-wide url=beginningBalanceEgaisListCtrl.url page=beginningBalanceEgaisListCtrl.page header=beginningBalanceEgaisListCtrl.header filters-required=true row-route-func=beginningBalanceEgaisListCtrl.rowRouteFunc sort=beginningBalanceEgaisListCtrl.sort limit=beginningBalanceEgaisListCtrl.limit base-columns-count=3 default-position=4 column-defs=beginningBalanceEgaisListCtrl.columnDefs using-service=beginningBalanceEgaisListCtrl.usingService filter-meta=beginningBalanceEgaisListCtrl.filterMeta config=beginningBalanceEgaisListCtrl.gridConfig grid-button-config=beginningBalanceEgaisListCtrl.gridButtonConfig currency=beginningBalanceEgaisListCtrl.currency></grid-wide></div>");
$templateCache.put("app/egaisz/cancellation-act/cancellation-act.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li><li><a ui-sref=\"cancellationActsList({parent: \'alcohol\'})\">Списания</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix cancellation-act\" ng-class=\"(!cancellationActCtrl.redact)? \'view-entity\': \'\'\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 175px);\"><span ng-if=!cancellationActCtrl.values.id ng-bind=\"cancellationActCtrl.meta.metadata.purposes[0].new_word_gender | newWord\"></span> <span ng-bind=cancellationActCtrl.meta.metadata.document_type.name ng-class=\"{\'first-letter-lowercase\': !cancellationActCtrl.values.id}\"></span> <span ng-if=cancellationActCtrl.values.id>№<span ng-bind=cancellationActCtrl.values.doc_number></span><!-- todo hover --> &nbsp;от&nbsp;<span ng-bind=\"cancellationActCtrl.crudsService.getFormattedDate(cancellationActCtrl.values.doc_date, false)\"></span></span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=cancellationActCtrl.values.status_history.length><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\" ng-click=cancellationActCtrl.openHistoryPopup();><span class=\"persons-ico pull-left\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение:<br>{{cancellationActCtrl.values.status_history[0].created_at | date:\'dd.MM.yyyy HH:mm\'}}</span><div class=\"light-custom-tip persons-info\"><div ng-repeat=\"statusData in cancellationActCtrl.values.status_history\"><span class=pull-left ng-bind=\"statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span ng-bind=\"statusData.status | cancellationActStatus\"></span><br><span class=person-name ng-bind=statusData.created_by.name></span></span></div></div></span></span></div><div style=\"position: relative; top: -20px;\"><span ng-bind=\"cancellationActCtrl.values.status | cancellationActStatus\"></span> <span class=\"info-icon tooltip-light\" ng-click=cancellationActCtrl.showStatusComment(cancellationActCtrl.values.status_comment); uib-tooltip=\"Показать дополнительную информацию\" ng-if=\"cancellationActCtrl.values.status_comment && (cancellationActCtrl.values.status == \'REJECTED\' || cancellationActCtrl.values.status == \'ACCOUNTED_ERROR\')\" style=\"position: relative; top: 2px; left: 5px;\"></span></div><div ng-include=\"\'app/egaisz/cancellation-act/includes/buttons.html\'\"></div><div ng-form=cancellationActCtrl.cancellationActForm><document redact=cancellationActCtrl.redact document-meta=cancellationActCtrl.meta.metadata document=cancellationActCtrl.meta purpose=cancellationActCtrl.purpose form-validation=cancellationActCtrl.formCommonValidation values=cancellationActCtrl.values external-data=cancellationActCtrl.values currency-home=cancellationActCtrl.currencyHome get-currencies-rate=cancellationActCtrl.getCurrenciesRate amount-calculate=cancellationActCtrl.documentsAmountsCalculate reference-data=cancellationActCtrl.values start-saving=cancellationActCtrl.startSaving form-name=\"\'commonData\'\" form-ctrl=cancellationActCtrl.cancellationActForm check-valid=cancellationActCtrl.checkValid></document></div></div>");
$templateCache.put("app/egaisz/cancellation-acts-list/cancellation-acts-list.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><grid-wide url=cancellationActsListCtrl.url page=cancellationActsListCtrl.page header=cancellationActsListCtrl.header filters-required=true row-route-func=cancellationActsListCtrl.rowRouteFunc sort=cancellationActsListCtrl.sort sort-order=cancellationActsListCtrl.sortOrder limit=cancellationActsListCtrl.limit base-columns-count=3 default-position=4 column-defs=cancellationActsListCtrl.columnDefs using-service=cancellationActsListCtrl.usingService filter-meta=cancellationActsListCtrl.filterMeta config=cancellationActsListCtrl.gridConfig grid-button-config=cancellationActsListCtrl.gridButtonConfig currency=cancellationActsListCtrl.currency></grid-wide></div>");
$templateCache.put("app/egaisz/invoice-waybill/invoice-waybill.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li><li><a ui-sref=\"invoiceWaybills({parent: \'alcohol\'})\">Приемки ТТН</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix\" ng-class=\"(!invoiceWaybillCtrl.redact)? \'view-entity\': \'\'\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 175px);\"><span ng-bind=invoiceWaybillCtrl.meta.metadata.document_type.name ng-class=\"{\'first-letter-lowercase\': !invoiceWaybillCtrl.values.id}\"></span> <span ng-if=invoiceWaybillCtrl.values.id>№<span ng-bind=invoiceWaybillCtrl.values.doc_number></span><!-- todo hover --> &nbsp;от&nbsp;<span ng-bind=\"invoiceWaybillCtrl.crudsService.getFormattedDate(invoiceWaybillCtrl.values.doc_date, false).toLowerCase()\"></span></span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=invoiceWaybillCtrl.values.status_history.length><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\" ng-click=invoiceWaybillCtrl.openHistoryPopup();><span class=\"persons-ico pull-left\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение:<br>{{invoiceWaybillCtrl.values.status_history[0].created_at | date:\'dd.MM.yyyy HH:mm\'}}</span><div class=\"light-custom-tip persons-info\"><div ng-repeat=\"statusData in invoiceWaybillCtrl.values.status_history\"><span class=pull-left ng-bind=\"statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span ng-bind=\"statusData.document_status | waybillStatus\"></span><br><span class=person-name ng-bind=statusData.created_by.name></span></span></div></div></span></span></div><div style=\"position: relative; top: -20px;\"><span ng-bind=\"invoiceWaybillCtrl.values.document_status | waybillStatus\"></span> <span class=\"info-icon tooltip-light\" ng-click=invoiceWaybillCtrl.showStatusComment(invoiceWaybillCtrl.values.status_comment); uib-tooltip=\"Показать дополнительную информацию\" ng-if=\"invoiceWaybillCtrl.values.status_comment && (invoiceWaybillCtrl.values.document_status == \'ACT_REJECTED\' || invoiceWaybillCtrl.values.document_status == \'ACCOUNTED_ERROR\')\" style=\"position: relative; top: 2px; left: 5px;\"></span></div><div ng-include=\"\'app/egaisz/invoice-waybill/includes/buttons.html\'\"></div><div ng-form=invoiceWaybillCtrl.invoiceWaybillForm class=hide-grid-buttons><document redact=invoiceWaybillCtrl.redact document-meta=invoiceWaybillCtrl.meta.metadata document=invoiceWaybillCtrl.meta purpose=invoiceWaybillCtrl.purpose form-validation=invoiceWaybillCtrl.formCommonValidation values=invoiceWaybillCtrl.values external-data=invoiceWaybillCtrl.values currency-home=invoiceWaybillCtrl.currencyHome get-currencies-rate=invoiceWaybillCtrl.getCurrenciesRate amount-calculate=invoiceWaybillCtrl.documentsAmountsCalculate reference-data=invoiceWaybillCtrl.values start-saving=invoiceWaybillCtrl.startSaving form-name=\"\'commonData\'\" check-valid=invoiceWaybillCtrl.checkValid></document></div></div>");
$templateCache.put("app/egaisz/invoice-waybill-list/invoice-waybill-list.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><grid-wide url=invoiceWaybillListCtrl.url page=invoiceWaybillListCtrl.page header=invoiceWaybillListCtrl.header filters-required=true row-route-func=invoiceWaybillListCtrl.rowRouteFunc sort=invoiceWaybillListCtrl.sort limit=invoiceWaybillListCtrl.limit base-columns-count=3 default-position=4 column-defs=invoiceWaybillListCtrl.columnDefs using-service=invoiceWaybillListCtrl.usingService filter-meta=invoiceWaybillListCtrl.filterMeta config=invoiceWaybillListCtrl.gridConfig grid-button-config=invoiceWaybillListCtrl.gridButtonConfig currency=invoiceWaybillListCtrl.currency></grid-wide></div>");
$templateCache.put("app/egaisz/scan-marks/scan-marks.html","<div ng-class=\"{\'blur-content\': scanMarkCtrl.saving}\" focus-request=true tabindex=0 ng-keypress=scanMarkCtrl.applyScannerKeys($event)><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=scanMarkCtrl.close()></button><h3 class=modal-title>Приемка марок по ТТН</h3></div><div class=\"modal-body scan-marks\" style=\"padding-top: 0;\"><div class=\"row full-height\"><div class=\"col-xs-8 full-height\"><section class=\"form-group block-section scan-marks-barcode-block\"><uib-tabset active=1><uib-tab index=1><uib-tab-heading class=tab-heading><span class=\"tab-title section-header text-uppercase\">Сканер</span></uib-tab-heading><div class=\"row scan-tab text-center\"><label class=text-muted><i>Используйте сканирующее устройство</i></label></div></uib-tab><uib-tab index=2><uib-tab-heading class=tab-heading><span class=\"tab-title section-header text-uppercase\">РУЧНОЙ ВВОД МАРКИ</span></uib-tab-heading><div class=\"row scan-tab\"><!--div class=\"col-xs-6\">\n                  <ui-select ng-model=\"scanMarkCtrl.barcodeType\"\n                             class=\"slim-control fsm-types\">\n                    <ui-select-match>\n                      <span title=\"{{$select.selected.name}}\" ng-bind=\"$select.selected.name\"></span>\n                    </ui-select-match>\n                    <ui-select-choices\n                      repeat=\"item as item in scanMarkCtrl.barcodeTypes\">\n                      <span title=\"{{item.name}}\" ng-bind=\"item.name\"></span>\n                    </ui-select-choices>\n                  </ui-select>\n                </div--><div class=col-xs-12 ng-form=scanMarkCtrl.searchSingleForm><!-- focus-request=\"true\"\n           keep-focus=\"true\" --><div class=code-wraper><input focus-request=true maxlength=12 mark-input ng-pattern=/^[\\d\\s\\w]{12}$/ select-by-event=selectInput ng-keypress=\"$event.keyCode == 13 && scanMarkCtrl.searchSingleForm.$valid && scanMarkCtrl.submitBarcode(undefined, \'MARK\'); $event.stopPropagation();\" clear-button type=text style=\"padding-right: 80px;\" class=\"form-control code-input slim-control\" ng-model=scanMarkCtrl.barcodeSingleMark name=searchSingleMark> <span class=code-sprite></span></div></div></div></uib-tab><uib-tab index=3><uib-tab-heading class=tab-heading><span class=\"tab-title section-header text-uppercase\">РУЧНОЙ ВВОД ШК УПАКОВКИ</span></uib-tab-heading><div class=\"row scan-tab\"><div class=col-xs-12><div class=code-wraper><input focus-request=true select-by-event=selectInput ng-keypress=\"$event.keyCode == 13 && scanMarkCtrl.submitBarcode(undefined, \'BOX\'); $event.stopPropagation();\" clear-button type=text hard-pruning data-check=[\\d\\s\\w] style=\"padding-right: 80px;\" class=\"form-control code-input slim-control\" ng-model=scanMarkCtrl.barcodeBox name=searchGroupMark> <span class=code-sprite></span></div></div></div></uib-tab></uib-tabset></section><div class=\"scan-marks-info-block-container full-height\"><div class=scan-marks-info-block-wrapper><section class=\"form-group block-section full-height\"><div ng-switch=scanMarkCtrl.state><div ng-switch-when=WAITING><scan-marks-info-block level=\"\'arrow-no-data\'\" message=\"\'Сканируйте федеральную специальную марку/акцизную марку, либо штрих-код групповой упаковки\'\"></scan-marks-info-block></div><div ng-switch-when=ERROR_NO_NFO><scan-marks-info-block level=\"\'big-danger-info\'\" message=\"\'Сведения по данной марке или упаковке в ТТН отсутствуют\'\"></scan-marks-info-block></div><div ng-switch-when=GROUP_MARK|ERROR_BUSINESS_BOX ng-switch-when-separator=|><group-box waybill-id=scanMarkCtrl.resolve.waybill.id promisses=scanMarkCtrl.promisses mark=scanMarkCtrl.currentMarkData isset=\"scanMarkCtrl.state == \'ERROR_BUSINESS_BOX\'\" only-view=scanMarkCtrl.onlyView></group-box></div><div ng-switch-when=SINGLE_MARK|ERROR_BUSINESS_MARK ng-switch-when-separator=|><single-mark waybill-id=scanMarkCtrl.resolve.waybill.id mark=scanMarkCtrl.currentMarkData isset=\"scanMarkCtrl.state == \'ERROR_BUSINESS_MARK\'\"></single-mark></div></div></section></div></div></div><div class=\"col-xs-4 full-height\"><section class=\"form-group block-section full-height simple-tree-wrapper\"><div class=\"sub-section-header simple-tree-header\"><h6 class=\"section-header text-uppercase\">принятые марки</h6></div><div class=\"scan-mark-tree-container simple-tree-body\"><div class=scan-marks-tree-wrapper ng-scrollbars ng-scrollbars-config=scanMarkCtrl.configScroll><simple-tree root=scanMarkCtrl.root root-visible=false remove-row=scanMarkCtrl.removeRow row-click-callback=scanMarkCtrl.showMarkInfo></simple-tree></div></div><div class=\"sub-section-footer sub-selection-tree-footer simple-tree-footer\"><div class=col-xs-6 style=\"padding-left: 0;\">Принято: {{scanMarkCtrl.acceptedMarksQuantity}}</div><div class=col-xs-6 style=\"padding-left: 0;\">Всего: {{scanMarkCtrl.marksQuantity}}</div></div></section></div></div></div><div class=modal-footer><button class=btn ng-click=scanMarkCtrl.close()>Закрыть</button></div></div><div ng-if=scanMarkCtrl.saving><div class=ui-spinner style=\"position: absolute;\n    margin: -2.5em -2.5em;\n    top: 50%;\n    left: 50%;\"></div></div>");
$templateCache.put("app/egaisz/stock-balance/stock-balance-egais-list.html","<div class=\"settings-entities all-documents egais-stock\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><div class=grid-wide style=\"padding-bottom: 45px;\"><div class=\"main-left-offset main-right-offset\"><h1 style=\"margin-right: 15px;\">Складские остатки алкоголя</h1><div class=grid-buttons><div class=doc-settings-block><button class=btn ng-click=balanceEgaisCtrl.updateStock() uib-tooltip=\"{{balanceEgaisCtrl.hint}}\" tooltip-placement=right ng-style=\"(!$root.hasRole(\'alcohol_stock.write\') || balanceEgaisCtrl.statusData.when_new_request)? {\'opacity\':\'0.5\', \'cursor\': \'not-allowed\'} : \'\' \">Обновить остатки ЕГАИС</button><div class=text-muted ng-if=balanceEgaisCtrl.statusData.when_last_request style=\"display: inline-block; vertical-align: middle;\">Последнее обновление {{balanceEgaisCtrl.statusData.when_last_request | date:\'HH:mm dd.MM.yyyy\'}}</div></div></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><filter-block config=balanceEgaisCtrl.config search-text=searchHelper filters=balanceEgaisCtrl.filterData initial-base-mode=balanceEgaisCtrl.currentBaseMode search-trigger=balanceEgaisCtrl.getDataWithResetOffset></filter-block></div><div class=\"filter-not-found major-font\" ng-if=\"!balanceEgaisCtrl.data && balanceEgaisCtrl.dataIsLoaded\" style=\"margin-top: 80px;\"><div class=big-danger-info-ico></div><div class=big-danger-info><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div></div><grid-custom columns=balanceEgaisCtrl.columns data=balanceEgaisCtrl.data page-callback=balanceEgaisCtrl.getData is-show-settings=false show-checkbox=false options=balanceEgaisCtrl.gridOptions min-height=100 is-full-width=true allow-selected=true totals-data=balanceEgaisCtrl.totalsData selected-callback=balanceEgaisCtrl.rowSelectionHandler two-level-header=true></grid-custom><div class=table-footer><paging page-info=balanceEgaisCtrl.paging callback=balanceEgaisCtrl.getData></paging></div></div></div><script type=text/ng-template id=defaultTemplate.html><div class=\"cell-data single-line\" uib-tooltip=\"{{value[column.field]}}\">\n      <span ng-bind=\"value[column.field]\"></span>\n    </div></script><script type=text/ng-template id=catalogItemTemplate.html><div class=\"cell-data single-line\">\n    <div class=\"view-entity-control text-left catalog-item-cell\" style=\"height: 42px;\">\n      <span class=\"catalog-item-name\"\n            tooltip-placement=\"bottom-left\" uib-tooltip=\"{{value[column.field].name}}\"\n            ng-bind=\"value[column.field].name || \'-\'\"></span>\n      <span class=\"catalog-item-derivative\"\n            ng-if=\"value[column.field].derivative\"\n            tooltip-placement=\"bottom-left\" uib-tooltip=\"{{value.$$alcoNames}}\"\n            ng-bind=\"value.$$alcoNames\"></span>\n      <span class=\"catalog-item-derivative\"\n            ng-if=\"!value[column.field]\"\n            tooltip-placement=\"bottom-left\" uib-tooltip=\"{{value.$$alcoNames}}\"\n            ng-bind=\"value.alco_items[0].alcohol_catalog.full_name\"></span>\n    </div>\n  </div></script><script type=text/ng-template id=capacityTemplate.html><div class=\"cell-data single-line\" uib-tooltip=\"{{value[column.field][0].alcohol_catalog.capacity}}\">\n      <span ng-bind=\"value[column.field][0].alcohol_catalog.capacity\"></span>\n    </div></script><script type=text/ng-template id=alcVolumeTemplate.html><div class=\"cell-data single-line\" uib-tooltip=\"{{value[column.field][0].alcohol_catalog.alc_volume}}\">\n      <span ng-bind=\"value[column.field][0].alcohol_catalog.alc_volume\"></span>\n    </div></script><script type=text/ng-template id=alcoCodeTemplate.html><div class=\"cell-data single-line\" uib-tooltip=\"{{value[column.field][0].alcohol_catalog.alcohol_product_classifier.code}}\">\n      <span ng-bind=\"value[column.field][0].alcohol_catalog.alcohol_product_classifier.code\"></span>\n    </div></script><script type=text/ng-template id=uomTemplate.html><div class=\"cell-data single-line\" uib-tooltip=\"{{value[column.field][0].alcohol_catalog.uom.symbols}}\">\n      <span ng-bind=\"value[column.field][0].alcohol_catalog.uom.symbols\"></span>\n    </div></script>");
$templateCache.put("app/egaisz/transfer-between-register/transfer-between-register.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li><li><a ui-sref=\"transferBetweenRegisterList({parent: \'alcohol\'})\">Переводы между регистрами</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix transfer-between-register\" ng-class=\"(!transferBetweenRegisterCtrl.redact)? \'view-entity\': \'\'\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 175px);\"><span ng-if=!transferBetweenRegisterCtrl.values.id ng-bind=\"transferBetweenRegisterCtrl.meta.metadata.purposes[0].new_word_gender | newWord\"></span> <span ng-bind=transferBetweenRegisterCtrl.meta.metadata.document_type.name ng-class=\"{\'first-letter-lowercase\': !transferBetweenRegisterCtrl.values.id}\"></span> <span ng-if=transferBetweenRegisterCtrl.values.id>№<span ng-bind=transferBetweenRegisterCtrl.values.doc_number></span><!-- todo hover --> &nbsp;от&nbsp;<span ng-bind=\"transferBetweenRegisterCtrl.crudsService.getFormattedDate(transferBetweenRegisterCtrl.values.doc_date, false)\"></span></span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=transferBetweenRegisterCtrl.values.status_history.length><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\" ng-click=transferBetweenRegisterCtrl.openHistoryPopup();><span class=\"persons-ico pull-left\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение:<br>{{transferBetweenRegisterCtrl.values.status_history[0].created_at | date:\'dd.MM.yyyy HH:mm\'}}</span><div class=\"light-custom-tip persons-info\"><div ng-repeat=\"statusData in transferBetweenRegisterCtrl.values.status_history\"><span class=pull-left ng-bind=\"statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span ng-bind=\"statusData.status | cancellationActStatus\"></span><br><span class=person-name ng-bind=statusData.created_by.name></span></span></div></div></span></span></div><div style=\"position: relative; top: -20px;\"><span ng-bind=\"transferBetweenRegisterCtrl.values.document_status | cancellationActStatus\"></span> <span class=\"info-icon tooltip-light\" ng-click=transferBetweenRegisterCtrl.showStatusComment(transferBetweenRegisterCtrl.values.status_comment); uib-tooltip=\"Показать дополнительную информацию\" ng-if=\"transferBetweenRegisterCtrl.values.status_comment && (transferBetweenRegisterCtrl.values.document_status == \'REJECTED\' || transferBetweenRegisterCtrl.values.document_status == \'ACCOUNTED_ERROR\')\" style=\"position: relative; top: 2px; left: 5px;\"></span></div><div ng-include=\"\'app/egaisz/transfer-between-register/includes/buttons.html\'\"></div><div ng-form=transferBetweenRegisterCtrl.transferBetweenRegisterForm><document redact=transferBetweenRegisterCtrl.redact document-meta=transferBetweenRegisterCtrl.meta.metadata document=transferBetweenRegisterCtrl.meta purpose=transferBetweenRegisterCtrl.purpose form-validation=transferBetweenRegisterCtrl.formCommonValidation values=transferBetweenRegisterCtrl.values external-data=transferBetweenRegisterCtrl.values currency-home=transferBetweenRegisterCtrl.currencyHome get-currencies-rate=transferBetweenRegisterCtrl.getCurrenciesRate amount-calculate=transferBetweenRegisterCtrl.documentsAmountsCalculate reference-data=transferBetweenRegisterCtrl.values start-saving=transferBetweenRegisterCtrl.startSaving form-name=\"\'commonData\'\" form-ctrl=transferBetweenRegisterCtrl.transferBetweenRegisterForm check-valid=transferBetweenRegisterCtrl.checkValid></document></div></div>");
$templateCache.put("app/egaisz/transfer-between-register-list/transfer-between-register-list.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><grid-wide url=transferBetweenRegisterListCtrl.url page=transferBetweenRegisterListCtrl.page header=transferBetweenRegisterListCtrl.header filters-required=true row-route-func=transferBetweenRegisterListCtrl.rowRouteFunc sort=transferBetweenRegisterListCtrl.sort limit=transferBetweenRegisterListCtrl.limit base-columns-count=3 default-position=4 column-defs=transferBetweenRegisterListCtrl.columnDefs using-service=transferBetweenRegisterListCtrl.usingService filter-meta=transferBetweenRegisterListCtrl.filterMeta config=transferBetweenRegisterListCtrl.gridConfig grid-button-config=transferBetweenRegisterListCtrl.gridButtonConfig currency=transferBetweenRegisterListCtrl.currency></grid-wide></div>");
$templateCache.put("app/egaisz/write-return/write-return.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li><li><a ui-sref=\"writeReturnList({parent: \'alcohol\'})\">Розничные возвраты</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix view-entity\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 175px);\"><span ng-if=!writeReturnCtrl.values.id ng-bind=\"writeReturnCtrl.meta.metadata.purposes[0].new_word_gender | newWord\"></span> <span ng-bind=writeReturnCtrl.meta.metadata.document_type.name ng-class=\"{\'first-letter-lowercase\': !writeReturnCtrl.values.id}\"></span> <span ng-if=writeReturnCtrl.values.id>№<span ng-bind=writeReturnCtrl.values.doc_number></span><!-- todo hover --> &nbsp;от&nbsp;<span ng-bind=\"writeReturnCtrl.crudsService.getFormattedDate(writeReturnCtrl.values.doc_date, false)\"></span></span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=writeReturnCtrl.values.status_history.length><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\" ng-click=writeReturnCtrl.openHistoryPopup();><span class=\"persons-ico pull-left\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение:<br>{{writeReturnCtrl.values.status_history[0].created_at | date:\'dd.MM.yyyy HH:mm\'}}</span><div class=\"light-custom-tip persons-info\"><div ng-repeat=\"statusData in writeReturnCtrl.values.status_history\"><span class=pull-left ng-bind=\"statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span ng-bind=\"statusData.status | writeReturnStatus\"></span><br><span class=person-name ng-bind=statusData.created_by.name></span></span></div></div></span></span></div><div style=\"position: relative; top: -20px;\"><span ng-bind=\"writeReturnCtrl.values.status | writeReturnStatus\"></span> <span class=\"info-icon tooltip-light\" ng-click=writeReturnCtrl.showStatusComment(writeReturnCtrl.values.status_comment); uib-tooltip=\"Показать дополнительную информацию\" ng-if=\"writeReturnCtrl.values.status_comment && writeReturnCtrl.values.status == \'ACCOUNTED_ERROR\'\" style=\"position: relative; top: 2px; left: 5px;\"></span></div><div ng-include=\"\'app/egaisz/write-return/includes/buttons.html\'\"></div><div ng-form=writeReturnCtrl.writeReturnForm><document redact=writeReturnCtrl.redact document-meta=writeReturnCtrl.meta.metadata document=writeReturnCtrl.meta purpose=writeReturnCtrl.purpose form-validation=writeReturnCtrl.formCommonValidation values=writeReturnCtrl.values external-data=writeReturnCtrl.values currency-home=writeReturnCtrl.currencyHome get-currencies-rate=writeReturnCtrl.getCurrenciesRate amount-calculate=writeReturnCtrl.documentsAmountsCalculate reference-data=writeReturnCtrl.values start-saving=writeReturnCtrl.startSaving form-name=\"\'commonData\'\" check-valid=writeReturnCtrl.checkValid></document></div></div>");
$templateCache.put("app/egaisz/write-return-list/write-return-list.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><grid-wide url=writeReturnListCtrl.url page=writeReturnListCtrl.page header=writeReturnListCtrl.header filters-required=true row-route-func=writeReturnListCtrl.rowRouteFunc sort=writeReturnListCtrl.sort sort-order=writeReturnListCtrl.sortOrder limit=writeReturnListCtrl.limit base-columns-count=3 default-position=4 column-defs=writeReturnListCtrl.columnDefs using-service=writeReturnListCtrl.usingService filter-meta=writeReturnListCtrl.filterMeta config=writeReturnListCtrl.gridConfig grid-button-config=writeReturnListCtrl.gridButtonConfig currency=writeReturnListCtrl.currency></grid-wide></div>");
$templateCache.put("app/egaisz/write-up-statement/write-up-statement.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li><li><a ui-sref=\"writeUpStatementsList({parent: \'alcohol\'})\">Оприходования</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset doc-crud clearfix write-up-statement\" ng-class=\"(!writeUpStatementCtrl.redact)? \'view-entity\': \'\'\"><div class=clearfix><h1 class=pull-left style=\"max-width: calc(100% - 175px);\"><span ng-if=!writeUpStatementCtrl.values.id ng-bind=\"writeUpStatementCtrl.meta.metadata.purposes[0].new_word_gender | newWord\"></span> <span ng-bind=writeUpStatementCtrl.meta.metadata.document_type.name ng-class=\"{\'first-letter-lowercase\': !writeUpStatementCtrl.values.id}\"></span> <span ng-if=writeUpStatementCtrl.values.id>№<span ng-bind=writeUpStatementCtrl.values.doc_number></span><!-- todo hover --> &nbsp;от&nbsp;<span ng-bind=\"writeUpStatementCtrl.crudsService.getFormattedDate(writeUpStatementCtrl.values.doc_date, false)\"></span></span></h1><span class=pull-right style=\"font-size: 14px; margin-top: 14px;\" ng-if=writeUpStatementCtrl.values.status_history.length><span class=\"light-custom-tip-wrap persons-icon-wrap status-history\" ng-click=writeUpStatementCtrl.openHistoryPopup();><span class=\"persons-ico pull-left\"></span> <span class=pull-right style=\"line-height: 1.2;\">Последнее изменение:<br>{{writeUpStatementCtrl.values.status_history[0].created_at | date:\'dd.MM.yyyy HH:mm\'}}</span><div class=\"light-custom-tip persons-info\"><div ng-repeat=\"statusData in writeUpStatementCtrl.values.status_history\"><span class=pull-left ng-bind=\"statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></span> <span class=pull-left style=\"border-left: 1px solid rgba(51, 51, 51, 0.1);\"><span ng-bind=\"statusData.status | writeUpStatementStatus\"></span><br><span class=person-name ng-bind=statusData.created_by.name></span></span></div></div></span></span></div><div style=\"position: relative; top: -20px;\"><span ng-bind=\"writeUpStatementCtrl.values.status | writeUpStatementStatus\"></span> <span class=\"info-icon tooltip-light\" ng-click=writeUpStatementCtrl.showStatusComment(writeUpStatementCtrl.values.status_comment); uib-tooltip=\"Показать дополнительную информацию\" ng-if=\"writeUpStatementCtrl.values.status_comment && (writeUpStatementCtrl.values.status == \'REJECTED\' || writeUpStatementCtrl.values.status == \'ACCOUNTED_ERROR\')\" style=\"position: relative; top: 2px; left: 5px;\"></span></div><div ng-include=\"\'app/egaisz/write-up-statement/includes/buttons.html\'\"></div><div ng-form=writeUpStatementCtrl.writeUpStatementForm><document redact=writeUpStatementCtrl.redact document-meta=writeUpStatementCtrl.meta.metadata document=writeUpStatementCtrl.meta purpose=writeUpStatementCtrl.purpose form-validation=writeUpStatementCtrl.formCommonValidation values=writeUpStatementCtrl.values external-data=writeUpStatementCtrl.values currency-home=writeUpStatementCtrl.currencyHome get-currencies-rate=writeUpStatementCtrl.getCurrenciesRate amount-calculate=writeUpStatementCtrl.documentsAmountsCalculate reference-data=writeUpStatementCtrl.values start-saving=writeUpStatementCtrl.startSaving form-name=\"\'commonData\'\" form-ctrl=writeUpStatementCtrl.writeUpStatementForm check-valid=writeUpStatementCtrl.checkValid></document></div></div>");
$templateCache.put("app/egaisz/write-up-statement-list/write-up-statement-list.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Алкоголь</a></li></ul><grid-wide url=writeUpStatementListCtrl.url page=writeUpStatementListCtrl.page header=writeUpStatementListCtrl.header filters-required=true row-route-func=writeUpStatementListCtrl.rowRouteFunc sort=writeUpStatementListCtrl.sort limit=writeUpStatementListCtrl.limit base-columns-count=3 default-position=4 column-defs=writeUpStatementListCtrl.columnDefs using-service=writeUpStatementListCtrl.usingService filter-meta=writeUpStatementListCtrl.filterMeta config=writeUpStatementListCtrl.gridConfig grid-button-config=writeUpStatementListCtrl.gridButtonConfig currency=writeUpStatementListCtrl.currency></grid-wide></div>");
$templateCache.put("app/inventory/inventory-print/inventory-print.html","<form name=ctrl.printForm><div class=modal-header><button type=button class=close ng-click=ctrl.close()>×</button><h3 class=modal-title>Выберите этикетки для печати</h3><a ng-if=\"!ctrl.longRequest.flags.finish && !ctrl.longRequest.crudState.loading\" ng-show=!ctrl.noData style=\"cursor: pointer; padding-top: 10px; display: inline-block;\" ng-click=\"ctrl.selectAll = !ctrl.selectAll; ctrl.onSelectAllHandler(ctrl.selectAll)\">{{ !ctrl.selectAll ? \'Выделить все на странице\': \' Очистить\' }}</a></div><div class=container><div ng-if=!ctrl.longRequest.crudState.loading class=crud-entity><div ng-if=!ctrl.longRequest.flags.finish><div ng-switch=ctrl.resolve.type><div ng-switch-when=byItem style=\"margin-left: -15px;\"><div class=col-xs-12><div class=form-group><ui-select ng-model=ctrl.gtin required search-enabled=false on-select=\"ctrl.refreshDerivative(null, true);\"><ui-select-match><span ng-bind=$select.selected.gtin></span></ui-select-match><ui-select-choices repeat=\"gtin in ctrl.gtins track by $index\"><span ng-bind-html=\"gtin.gtin | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req></span><label class=\"form-control-label small-offset\">Штрих-код</label></div></div><div class=col-xs-12><div class=form-group><ui-select ng-model=ctrl.derivative required search-enabled=true ng-disabled=!ctrl.gtin><ui-select-match><span ng-bind-html=\"$select.selected.code + \' \' + $select.selected.name\"></span></ui-select-match><ui-select-choices refresh=ctrl.refreshDerivative($select.search) repeat=\"derivative in ctrl.derivatives track by $index\"><span ng-bind-html=\"derivative.code + \' \' + derivative.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req></span><label class=\"form-control-label small-offset\">Печатать для</label></div></div><div class=col-xs-7><div class=form-group><input hard-pruning data-check=[0-9] required style=\"border-radius: 5px;\" type=text class=\"form-control code-input\" maxlength=20 ng-change=ctrl.onAmountChange(ctrl.amount) ng-model=ctrl.amount id=amount name=amount> <span class=req></span><label for=amount class=\"form-control-label small-offset\">Количество этикеток</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div></div></div><div ng-switch-when=byStock|byDocument ng-switch-when-separator=|><div style=\"position: relative;\"><div class=\"filter-not-found in-modal major-font\" ng-if=!ctrl.gridOptions.data.length><div ng-if=ctrl.noData>Этикетки можно напечатать только для положительных остатков</div></div><div class=grid-wrapper><div ui-grid=ctrl.gridOptions class=\"grid grid-head-bg in-modal up-footer\" ui-grid-auto-resize ui-grid-selection></div></div><div class=table-footer><div class=pagination-wrapper><paging page-info=ctrl.paging callback=ctrl.getPage></paging></div></div></div></div></div><div class=clear></div><a style=\"cursor: pointer; display: block; margin: 15px auto; width: 190px;\" class=link-gear ng-click=ctrl.goToInventoryTagsSettings()>Настройки печати</a></div></div><inview-loader class=popup show=ctrl.longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center;\" ng-if=ctrl.longRequest.crudState.loading>Подготовка отчета</h4><h4 style=\"text-align: center;\" ng-if=\"!ctrl.longRequest.crudState.loading && ctrl.longRequest.flags.finish && !ctrl.longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center;\" ng-if=ctrl.longRequest.flags.error>При подготовке отчета произошла ошибка</h4></div><div class=modal-footer><button class=btn type=button ng-click=ctrl.close()>{{ ctrl.longRequest.flags.finish ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-if=\"!ctrl.longRequest.crudState.loading && !ctrl.longRequest.flags.processStart && !ctrl.longRequest.flags.finish\" class=\"btn btn-primary\" type=button ng-disabled=!ctrl.printForm.$valid ng-click=ctrl.prepareReport()>Печать</button></div></form>");
$templateCache.put("app/inventory/inventory-tag-settings/inventory-tag-settings.html","<div class=\"main-left-offset main-right-offset crud-entity price-tags-settings\"><!-- content of settings --><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-when=retail><a>Розница</a></li><li ng-switch-when=storehouse><a>Склад</a></li><li ng-switch-default><a>Розница</a></li><li><a ui-sref=\"catalog({parent: $state.params.parent})\">Товары и услуги</a></li></ul><h1>Настройка печати этикеток</h1><form role=form name=inventoryTagsSettings class=row><div class=\"clearfix full-width\"><section class=col-xs-9><div class=\"form-group clearfix\"><label class=\"col-xs-12 row bottom-space\">Формат файла</label><div class=\"col-xs-3 row\" ng-repeat=\"format in vm.formats\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=vm.inventoryTagSettings.output_format id=\"{{format}}\" name=format ng-value=format> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{format}}\"><span class=\"{{format.toLowerCase()}}-ico\"></span>{{format}}</label></div></div><div class=row><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.inventoryTagSettings.inventory_tag_size ng-required=true search-enabled=false><ui-select-match><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"tagSize.value as tagSize in vm.inventoryTagSettingsSize track by $index\"><span ng-bind-html=tagSize.label></span></ui-select-choices></ui-select><label class=form-control-label>Размер одной этикетки</label></div><div class=\"form-group col-xs-7 text-muted price-tag-description\">Выберите один из предустановленных размеров для этикеток. Такого размера должны быть разделители на бумаге</div></div><div class=\"row bool-settings\"><label class=col-xs-12>Что включаем в этикету:</label><div class=\"form-group col-xs-12\" ng-repeat=\"checkbox in vm.checkboxes\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=vm.inventoryTagSettings[checkbox.code] id=\"{{checkbox.code}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{checkbox.code}}\">{{checkbox.label}}</label></div></div></section></div><div class=\"col-xs-9 section bottom-buttons\"><form-buttons view-type=\"{isEdit: true}\" on-button=vm.crud(status) hide-delete=true can-disabled=false></form-buttons></div></form></div>");
$templateCache.put("app/inventory/stock/stock.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Склад</a></li></ul><grid-wide url=vm.url page=vm.page header=vm.header filters-required=true row-route=vm.rowRoute row-route-func=vm.rowRouteFunc sort=vm.sort limit=vm.limit default-position=3 base-columns-count=2 column-defs=vm.columnDefs using-service=vm.usingService config=::vm.gridConfig only-read-mode=true currency=vm.currency need-add-to-cart=true search-placeholder=vm.searchPlaceholder no-search-on-load=true></grid-wide><script type=text/ng-template id=catalogItemTemplate.html><div class=\"ui-grid-cell-contents catalog-item-cell\" style=\"padding-top: 7px;\">\n      <span class=\"catalog-item-name\"\n            title=\"{{row.entity.dataValue.name}}\"\n            ng-bind=\"row.entity.dataValue.name\"></span>\n      <span class=\"catalog-item-derivative\"\n              title=\"{{row.entity.dataValue.derivative.name}}\"\n              ng-bind=\"row.entity.dataValue.derivative.name\" ng-if=\"row.entity.dataValue.derivative.name\"></span>\n    </div></script></div>");
$templateCache.put("app/inventory/transaction/transactions.html","<div class=\"settings-entities all-documents\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Склад</a></li></ul><grid-wide url=transactionsCtrl.url page=transactionsCtrl.page header=transactionsCtrl.header filters-required=true row-route=transactionsCtrl.rowRoute row-route-func=transactionsCtrl.rowRouteFunc sort=transactionsCtrl.sort limit=transactionsCtrl.limit default-position=3 base-columns-count=2 column-defs=transactionsCtrl.columnDefs using-service=transactionsCtrl.usingService config=::transactionsCtrl.gridConfig only-read-mode=true currency=transactionsCtrl.currency search-placeholder=transactionsCtrl.searchPlaceholder no-search-on-load=true></grid-wide><script type=text/ng-template id=catalogItemTemplate.html><div class=\"ui-grid-cell-contents catalog-item-cell\" style=\"padding-top: 7px;\">\n      <span class=\"catalog-item-name\"\n            title=\"{{row.entity.dataValue.name}}\"\n            ng-bind=\"row.entity.dataValue.name\"></span>\n      <span class=\"catalog-item-derivative\"\n              title=\"{{row.entity.dataValue.derivative.name}}\"\n              ng-bind=\"row.entity.dataValue.derivative.name\" ng-if=\"row.entity.dataValue.derivative.name\"></span>\n    </div></script><script type=text/ng-template id=quantityTemplate.html><div class=\"ui-grid-cell-contents catalog-item-cell\" style=\"padding-top: 7px;\">\n      <span ng-if=\"row.entity.dataValue.type == \'BEGINNING_QTY\' || row.entity.dataValue.type == \'REPLENISHMENT\' || row.entity.dataValue.type == \'MOVEMENT_IN\' || row.entity.dataValue.type == \'WRITE_UP\' || row.entity.dataValue.type == \'ASSEMBLE_PLUS_WHOLE\' || row.entity.dataValue.type == \'DISASSEMBLE_PLUS_PARTS\'\" ng-bind=\"(grid.appScope.ctrl.currentBaseMode)? row.entity.dataValue.base_quantity : row.entity.dataValue.quantity\"></span>\n      <span ng-if=\"row.entity.dataValue.type == \'SHIPMENT\' || row.entity.dataValue.type == \'MOVEMENT_OUT\' || row.entity.dataValue.type == \'WRITE_OFF\' || row.entity.dataValue.type == \'ASSEMBLE_MINUS_PARTS\' || row.entity.dataValue.type == \'DISASSEMBLE_MINUS_WHOLE\'\" ng-bind=\"(grid.appScope.ctrl.currentBaseMode)? -row.entity.dataValue.base_quantity : -row.entity.dataValue.quantity\"></span>\n    </div></script></div>");
$templateCache.put("app/mobile/catalog/catalog.html","<div class=\"mobile-catalog-wrapper {{catalogMobileCtrl.theme.toLowerCase()}}\" ng-class=\"{\'blur-bg\': catalogMobileCtrl.cannotRedact && catalogMobileCtrl.state.current.name.indexOf(\'mobileError\') == -1}\"><search-header ng-if=\"catalogMobileCtrl.state.current.name == \'catalogMobile\'\" catalog-items-length=catalogMobileCtrl.catalogItems.length choosen-item=catalogMobileCtrl.choosenItem type=\"catalogMobileCtrl.choosenItem.type || \'CATEGORY\'\" cannot-redact=catalogMobileCtrl.cannotRedact search-active=catalogMobileCtrl.searchActive search-loading=catalogMobileCtrl.loading></search-header><div class=main-container><div ng-if=\"catalogMobileCtrl.state.current.name == \'catalogMobile\' && catalogMobileCtrl.loading\" ng-include=\"\'app/mobile/loader.html\'\"></div><div class=catalog ng-class=catalogMobileCtrl.class ng-if=\"catalogMobileCtrl.state.current.name == \'catalogMobile\' && !catalogMobileCtrl.loading\"><div class=\"catalog-item-wrapper parent\" style=\"transition-delay: 50ms;\" ng-class=\"{\'choosen\': !catalogMobileCtrl.choosenItem || !catalogMobileCtrl.params.parent}\" ng-click=catalogMobileCtrl.chooseItem($event)><span class=catalog-item><span class=catalog-open-folder></span> <span class=\"default-cell-text major-font category\" ng-bind=\"::catalogMobileCtrl.params.parentname || \'Товары и услуги\'\"></span></span></div><a class=\"catalog-item-wrapper row-name {{item.type? item.type.toLowerCase() : \'category\'}}\" ng-class=\"{\'choosen\': catalogMobileCtrl.choosenItem.id == item.id, \'archived\': item.status == \'ARCHIVED\'}\" ng-click=\"catalogMobileCtrl.chooseItem($event, $index)\" ng-repeat=\"item in catalogMobileCtrl.catalogItems\" ui-sref=\"catalogMobile({parent: \'{{item.id}}\', parentname: \'{{item.name}}\'})\" ng-style=\"{\'transition-delay\': (($index + 2) * 50) + \'ms\', \'order\': catalogMobileCtrl.stateParamsChoosen == item.id ? 0 : 1}\"><span class=catalog-item><span ng-show=\"::!item.type || item.type == \'CATEGORY\'\" class=\"catalog-folder major-font\" ng-bind=::catalogMobileCtrl.getAbbreviation(item.name)></span> <span class=\"default-cell-text {{item.type.toLowerCase()}}\" ng-class=\"{\'category\': !item.type, \'major-font\': !item.type}\" ng-bind=::item.name></span> <span ng-show=\"::item.price && item.status !== \'ARCHIVED\'\" class=price ng-bind=\"::((item.price.price_for_one_uom / 100) + \' ₽\')\"></span> <span ng-show=\"::item.status == \'ARCHIVED\'\" class=\"major-font archived-status\">В архиве</span></span></a></div><button class=\"btn btn-primary\" ng-click=catalogMobileCtrl.onLoadingCatalogItems(true) ng-if=\"catalogMobileCtrl.state.current.name == \'catalogMobile\' && !catalogMobileCtrl.loading && (catalogMobileCtrl.offset + 100) < catalogMobileCtrl.totalItems\" ng-disabled=catalogMobileCtrl.blockLoad>Еще</button><div class=ui-view-wrapper><div ui-view></div></div></div><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=catalogMobileCtrl.cancelCatalog() ng-if=!catalogMobileCtrl.params.parent>Завершить</button> <button class=\"btn btn-primary\" ng-click=catalogMobileCtrl.goMrecover() ng-if=\"catalogMobileCtrl.choosenItem.status == \'ARCHIVED\'\">Восстановить</button></div></div><div class=mobile-popup-bg ng-click=\"catalogMobileCtrl.cannotRedact = false;\" ng-if=catalogMobileCtrl.cannotRedact><div class=\"mobile-popup-wrapper {{catalogMobileCtrl.theme.toLowerCase()}}\"><div class=mobile-popup-container><div class=mobile-popup-title>Предупреждение</div>Редактирование товара доступно только в товароучетной системе ТОРГОВЛЯ.онлайн</div><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=\"catalogMobileCtrl.cannotRedact = false;\">Закрыть</button></div></div></div>");
$templateCache.put("app/mobile/error/error.html","<div ng-class=mErrorCtrl.theme.toLowerCase()><header class=header><div class=container><div class=arrow ng-click=mErrorCtrl.goBack()></div><div class=title>Кажется, что-то пошло не так</div></div></header><div class=\"container-wrapper error-wrapper\"><div class=sad></div><p class=major-font ng-bind-html=mErrorCtrl.params.message></p><p class=major-font ng-hide=\"mErrorCtrl.stateName.indexOf(\'registerMobile\') + 1 || mErrorCtrl.params.hide_try_later\">Пожалуйста, повторите попытку позже</p></div><div class=buttons-wrapper ng-hide=\"mErrorCtrl.stateName.indexOf(\'registerMobile\') + 1\"><button class=\"btn btn-primary\" ng-click=mErrorCtrl.cancel()>Завершить</button></div></div>");
$templateCache.put("app/mobile/register/mobile-register.html","<div class=\"mobile-wrapper mobile-register-wrapper\" ng-keypress=$ctrl.keyEvent($event); ng-keyup=$ctrl.keyEvent($event); ng-keydown=$ctrl.keyEvent($event); ng-hide=\"$ctrl.state.current.name.indexOf(\'mobileError\') + 1\"><ng-include src=$ctrl.steps[$ctrl.stepNumber].template></ng-include></div><div class=ui-view-wrapper><div ui-view></div></div>");
$templateCache.put("app/partnership/close-period/close-period.html","<div class=\"settings-entities no-view-roe-selection close-period\" ng-if=$root.partner style=\"position: relative;\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Партнерство</a></li></ul><div style=\"position: absolute; top: 23px; right: 80px;\"><div class=bonus-wrapper style=\"margin-left: 5px;\"><button id=bonusDrop ng-if=\"$root.hasRole(\'bonuses.read\')\" type=button class=\"btn dropdown-toggle bonus-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false>Бонусы: <span class=minor-font ng-bind=\"($root.bonusesData.accrued_bonuses_amount? $root.bonusesData.accrued_bonuses_amount/100 : 0) | priceFormatter\"></span> <span class=caret></span></button><div class=\"bonus-dropdown dropdown-menu\" aria-labelledby=bonusDrop><div><div class=\"dropdown-item text-right\"><strong>Начислено:</strong> <span ng-bind=\"($root.bonusesData.accrued_bonuses_amount? $root.bonusesData.accrued_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=\"dropdown-item text-right\"><strong>Доступно для оплаты:</strong> <span ng-bind=\"($root.bonusesData.payable_bonuses_amount? $root.bonusesData.payable_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=\"dropdown-item text-right\"><strong>Выплачено:</strong> <span ng-bind=\"($root.bonusesData.paid_bonuses_amount? $root.bonusesData.paid_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=bonus-link><a ui-sref=\"partnerBonuses({parent: \'business\'})\" target=_blank>Детализация бонусов</a></div></div></div></div></div><grid-wide url=closePeriodCtrl.url page=closePeriodCtrl.page header=closePeriodCtrl.header filters-required=true row-route-func=closePeriodCtrl.rowRouteFunc sort=closePeriodCtrl.sort limit=closePeriodCtrl.limit base-columns-count=3 default-position=4 column-defs=closePeriodCtrl.columnDefs using-service=closePeriodCtrl.usingService filter-meta=closePeriodCtrl.filterMeta config=closePeriodCtrl.gridConfig grid-button-config=closePeriodCtrl.gridButtonConfig callbacks-for-line=closePeriodCtrl.callbacks></grid-wide></div><script type=text/ng-template id=excelReport.html><div class=\"ui-grid-cell-contents\">\n    <span class=\"link-style\" ng-click=\"\">Загрузить отчет</span>\n  </div></script><script type=text/ng-template id=closeDocument.html><div class=\"ui-grid-cell-contents\">\n    <span class=\"link-style\" ng-if=\"row.entity.dataValue.closing_document_id\" ng-click=\"grid.appScope.callbacksForLine.printAct(row.entity.dataValue.closing_document_id)\">Распечатать акт </span>\n  </div></script>");
$templateCache.put("app/partnership/modals/add-partner.html","<div class=\"register-partner crud-entity\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Добавить привлеченного клиента</h3></div><div class=container><form class=clearfix name=addClientForm><section class=\"form-group full-width\"><h5 class=section-header>Информация о партнере</h5><partner-choice req-data=reqData></partner-choice></section><section class=\"form-group full-width\"><h5 class=section-header>Информация о привлеченном клиенте</h5><div class=\"form-group col-xs-8 domain-form-group\"><input hard-pruning maxlength=30 name=domain ng-model=client.client required type=text class=form-control data-check=[a-zA-Z0-9-]* ng-keyup=checkGroup();> <span class=req></span><label class=form-control-label>Имя группы</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\" ng-bind=groupNameError></div></div><div class=\"form-group col-xs-8\"><input empty-to-null hard-pruning data-check=([0-9_]) pattern=^(\\d{10}|\\d{12})$ type=text inn-check required maxlength=12 class=form-control name=inn id=inn ng-model=client.inn ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-keyup=\"addClientForm.inn.$setValidity(\'unique\', true);\"><label for=inn class=form-control-label>ИНН</label><i class=req></i> <span class=\"valid-message wrong-format-mess text-lowercase\">ИНН должен содержать 10, 12 цифр</span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message wrong-inn\" ng-style=\"(addClientForm.inn.$error.validInn)? {\'display\':\'block\'} : \'\'\">Такой номер не существует</span><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\" ng-bind=innError></div></div><div class=\"form-group col-xs-8\"><input type=text hard-pruning data-check=([.\\S])+ add-zeroes class=form-control name=serialNum id=serialNum ng-model=client.cash_register_serial_number maxlength=20 required><label for=serialNum class=form-control-label>Заводской номер кассового аппарата</label><div class=\"valid-message wrong-simbol-mess\">Недопустимые символы</div><div class=\"valid-message required-mess\" ng-if=serialNum_blur>Поле является обязательным</div><span class=\"valid-message wrong-format-mess\">Требуется 20 символов</span><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></section></form></div><div class=modal-footer><div class=\"req-inform pull-left\" ng-if=\"addClientForm.$invalid && isSaved && !addClientForm.$error.unique\">* Обязательные для заполнения поля</div><button class=btn ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" ng-click=save() ng-disabled=\"addClientForm.$invalid && isSaved\">Добавить</button></div></div>");
$templateCache.put("app/partnership/modals/client-link-popup.html","<div class=\"client-link-popup crud-entity\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Ссылка для регистрации клиента</h3></div><div class=container><form class=clearfix name=clientLink><section class=\"form-group full-width\"><h5 class=section-header>Информация о партнере</h5><div class=row><partner-choice req-data=reqData></partner-choice><div class=\"form-group col-xs-8\"><input type=text name=promo_code class=form-control maxlength=64 ng-model=reqData.promo_code ng-keyup=checkCode()><label for=contract-number class=form-control-label>Введите промо-код</label><div class=\"valid-message not-found-mess\">Неизвестный код</div></div></div></section><div class=spinner-wrapper ng-if=load><div class=ui-spinner></div></div></form></div><div class=modal-footer><button class=btn ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" ng-click=action() ng-disabled=\"clientLink.client_type.$invalid || clientLink.client_partner_id.$invalid\">Получить</button></div></div>");
$templateCache.put("app/partnership/modals/register-partner.html","<div class=register-partner><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Регистрация партнера</h3></div><div class=container style=\"background: #f8f7f7; padding: 25px 40px;\"><div class=checkbox-wrapper style=\"margin-top: 25px;\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=accept id=accept required> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=accept>Принимаю условия <a target=_blank href=http://файлы.торговля.онлайн/partner_offer.pdf>партнерского договора-оферты</a> и даю согласие на обработку моих персональных данных (<a target=_blank href=http://файлы.торговля.онлайн/pd_policy.pdf>политика</a>).</label></div></div><div class=modal-footer><button class=btn ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" ng-click=save() ng-disabled=!accept>Подтвердить</button></div></div>");
$templateCache.put("app/partnership/partner-bonuses/partner-bonuses.html","<div class=\"settings-entities all-documents\" style=\"position: relative\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Партнерство</a></li></ul><div style=\"position: absolute; top: 23px; right: 80px;\"><div class=bonus-wrapper style=\"margin-left: 5px;\"><button id=bonusDrop ng-if=\"$root.hasRole(\'bonuses.read\')\" type=button class=\"btn dropdown-toggle bonus-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false>Бонусы: <span class=minor-font ng-bind=\"($root.bonusesData.accrued_bonuses_amount? $root.bonusesData.accrued_bonuses_amount/100 : 0) | priceFormatter\"></span> <span class=caret></span></button><div class=\"bonus-dropdown dropdown-menu\" aria-labelledby=bonusDrop><div><div class=\"dropdown-item text-right\"><strong>Начислено:</strong> <span ng-bind=\"($root.bonusesData.accrued_bonuses_amount? $root.bonusesData.accrued_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=\"dropdown-item text-right\"><strong>Доступно для оплаты:</strong> <span ng-bind=\"($root.bonusesData.payable_bonuses_amount? $root.bonusesData.payable_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=\"dropdown-item text-right\"><strong>Выплачено:</strong> <span ng-bind=\"($root.bonusesData.paid_bonuses_amount? $root.bonusesData.paid_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=bonus-link><a ui-sref=\"partnerBonuses({parent: \'business\'})\" target=_blank>Детализация бонусов</a></div></div></div></div></div><grid-wide url=partnerBonusesCtrl.url page=partnerBonusesCtrl.page header=partnerBonusesCtrl.header filters-required=true row-route-func=partnerBonusesCtrl.rowRouteFunc sort=partnerBonusesCtrl.sort limit=partnerBonusesCtrl.limit base-columns-count=3 default-position=4 column-defs=partnerBonusesCtrl.columnDefs using-service=partnerBonusesCtrl.usingService filter-meta=partnerBonusesCtrl.filterMeta config=partnerBonusesCtrl.gridConfig grid-button-config=partnerBonusesCtrl.gridButtonConfig currency=partnerBonusesCtrl.currency only-read-mode=true></grid-wide></div><script type=text/ng-template id=bonusSubjectCell.html><cell-with-tooltip ng-if=\"row.entity.dataValue.cash_register\"  text=\"(row.entity.dataValue.cash_register.manufacturer == \'Без кассы\')? row.entity.dataValue.cash_register.manufacturer : row.entity.dataValue.cash_register.manufacturer + \' \' + row.entity.dataValue.cash_register.model + \' \' + row.entity.dataValue.cash_register.serial_number + \' \' + row.entity.dataValue.cash_register.division.address.address_as_string + \' \' + (row.entity.dataValue.cash_register.created_at | date: \'dd.MM.yyyy\')\"></cell-with-tooltip>\n  \n  <cell-with-tooltip ng-if=\"row.entity.dataValue.bank_product_request\"  text=\"row.entity.dataValue.bank_product_request.bank_product.name + \' \' + (row.entity.dataValue.bank_product_request.updated_at | date: \'dd.MM.yyyy\')\"></cell-with-tooltip></script>");
$templateCache.put("app/partnership/partners/partners.html","<div class=\"settings-entities no-view-roe-selection\" ng-if=$root.partner style=\"position: relative;\"><ul class=\"breadcrumbs main-left-offset\"><li><a>Партнерство</a></li></ul><div style=\"position: absolute; top: 83px; right: 80px;\"><div class=bonus-wrapper style=\"margin-left: 5px;\"><button id=bonusDrop ng-if=\"$root.hasRole(\'bonuses.read\')\" type=button class=\"btn dropdown-toggle bonus-toggle\" data-toggle=dropdown aria-haspopup=true aria-expanded=false>Бонусы: <span class=minor-font ng-bind=\"($root.bonusesData.accrued_bonuses_amount? $root.bonusesData.accrued_bonuses_amount/100 : 0) | priceFormatter\"></span> <span class=caret></span></button><div class=\"bonus-dropdown dropdown-menu\" aria-labelledby=bonusDrop><div><div class=\"dropdown-item text-right\"><strong>Начислено:</strong> <span ng-bind=\"($root.bonusesData.accrued_bonuses_amount? $root.bonusesData.accrued_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=\"dropdown-item text-right\"><strong>Доступно для оплаты:</strong> <span ng-bind=\"($root.bonusesData.payable_bonuses_amount? $root.bonusesData.payable_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=\"dropdown-item text-right\"><strong>Выплачено:</strong> <span ng-bind=\"($root.bonusesData.paid_bonuses_amount? $root.bonusesData.paid_bonuses_amount/100 : 0) | priceFormatter\"></span></div><div class=bonus-link><a ui-sref=\"partnerBonuses({parent: \'business\'})\" target=_blank>Детализация бонусов</a></div></div></div></div></div><grid-wide url=partners.url page=partners.page header=partners.header filters-required=true row-route-func=partners.rowRouteFunc sort=partners.sort limit=partners.limit base-columns-count=3 default-position=4 column-defs=partners.columnDefs using-service=partners.usingService filter-meta=partners.filterMeta config=partners.gridConfig grid-button-config=partners.gridButtonConfig></grid-wide></div><script type=text/ng-template id=companies.html><div class=\"ui-grid-cell-contents\" ng-class=\"{\'wide-tip\': row.entity.dataValue.companies.length > 3}\">\n    <div class=\"ellipsis\" uib-tooltip=\"{{grid.appScope.ctrl.getArrTipStr(row.entity.dataValue.companies, \'short_name\')}}\" tooltip-placement=\"bottom\" ng-if=\"row.entity.dataValue.companies.length\">\n      <span ng-repeat=\"company in row.entity.dataValue.companies\" \n          ng-bind=\"($index)? \', \' + company.short_name : company.short_name\"></span>\n    </div>\n    <div ng-if=\"row.entity.dataValue.name && !row.entity.dataValue.companies.length\">-</div>\n  </div></script><script type=text/ng-template id=partnerCell.html><div class=\"ui-grid-cell-contents\">\n    <div class=\"ellipsis\" uib-tooltip=\"{{(row.entity.dataValue.partner)? (row.entity.dataValue.partner.type | partnerType) + \' \' + row.entity.dataValue.partner.name : \'\'}}\" tooltip-placement=\"bottom\">\n      <span ng-bind=\"(row.entity.dataValue.partner)? (row.entity.dataValue.partner.type | partnerType) + \' \' + row.entity.dataValue.partner.name : (row.entity.dataValue.name? \'-\' : \'\')\"></span>\n    </div>\n  </div></script><script type=text/ng-template id=statusCell.html><div class=\"ui-grid-cell-contents\">\n    <div class=\"ellipsis\" uib-tooltip=\"{{(row.entity.dataValue.rejected_by_client)? \'Клиент отказался от партнерских услуг\' : (row.entity.dataValue.name? \'Активен\' : \'\')}}\" tooltip-placement=\"bottom\">\n      <span ng-bind=\"(row.entity.dataValue.rejected_by_client)? \'Клиент отказался от партнерских услуг\' : (row.entity.dataValue.name? \'Активен\' : \'\')\"></span>\n    </div>\n  </div></script>");
$templateCache.put("app/partnership/partnership-settings/partner-settings.html","<div class=\"partner-settings crud-entity main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a ui-sref=partnership>Партнерство</a></li></ul><div ng-form=partnerSettingsCtrl.settingsForm ng-if=$root.partner class=\"clearfix full-width\" style=\"max-width: 1333px\"><h1>Настройки партнера</h1><div class=\"col-xs-9 section top-buttons\" style=\"padding: 0;\"><button class=\"btn pull-left\" ng-click=partnerSettingsCtrl.clientLinkPopup(); style=\"margin-right: 12px;\">ссылка для клиента</button> <button class=\"btn pull-left\" ng-click=partnerSettingsCtrl.deletePartnerPopup(); style=\"margin-left: 1px;\"><span class=\"btn-ico btn-no-done\"></span>Отменить партнерство</button> <button class=\"btn btn-primary pull-right\" ng-click=partnerSettingsCtrl.save() ng-disabled=\"!partnerSettingsCtrl.settingsForm.$valid && partnerSettingsCtrl.isSaved\">Сохранить</button> <button class=\"btn pull-right\" ng-click=partnerSettingsCtrl.returnToPage()>Отменить</button></div><div class=clear></div><section class=col-xs-9><h5 class=section-header>Код партнера</h5><div class=row><div class=\"form-group col-xs-6 fixed-width-group\"><ui-select ng-model=partnerSettingsCtrl.object_code search-enabled=false on-select=partnerSettingsCtrl.changeCode() ng-required=true><ui-select-match><span ng-bind-html=\"$select.selected.company_id.name || $select.selected.division_id.name || $select.selected.value\"></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"code in partnerSettingsCtrl.objectCodes track by $index\"><span ng-bind-html=\"code.company_id.name || code.division_id.name || code.value\"></span></ui-select-choices></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div><label class=form-control-label>Выберите код</label><span class=req></span></div></div></section><div ng-if=partnerSettingsCtrl.settingsLoaded><div ng-include=\"\'app/partnership/partnership-settings/sections/main-info.html\'\"></div><div ng-include=\"\'app/partnership/partnership-settings/sections/client-contacts.html\'\"></div><div ng-include=\"\'app/partnership/partnership-settings/sections/edi.html\'\"></div><div ng-include=\"\'app/partnership/partnership-settings/sections/edi-contacts.html\'\"></div><div ng-include=\"\'app/partnership/partnership-settings/sections/address.html\'\"></div></div><div class=\"col-xs-9 section top-buttons\" style=\"padding: 0;\"><button class=\"btn btn-primary pull-right\" ng-click=partnerSettingsCtrl.save() ng-disabled=\"!partnerSettingsCtrl.settingsForm.$valid && partnerSettingsCtrl.isSaved\">Сохранить</button> <button class=\"btn pull-right\" ng-click=partnerSettingsCtrl.returnToPage()>Отменить</button></div></div></div>");
$templateCache.put("app/price-list/ask/modal-ask.html","<div class=modal-content><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=cancel()>×</button><h3 class=modal-title>Подтверждение</h3></div><div class=container><div class=modal-main-text ng-bind-html=message></div></div><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=cancel()>Отмена</button> <button class=\"btn btn-primary\" type=button ng-click=ok()>Да</button></div></div>");
$templateCache.put("app/price-list/column/price-column-crud-base.html","<ui-view></ui-view>");
$templateCache.put("app/price-list/column/price-column-crud.html","<ul class=\"breadcrumbs main-left-offset\" ng-if=\"priceColumnCrudCtrl.type == \'WHOLE_SALE\'\"><li><a>Продажи</a></li><li><a ui-sref=\"priceList({parent: \'WHOLE_SALE\'})\">Оптовый прайс-лист</a></li></ul><ul class=\"breadcrumbs main-left-offset\" ng-if=\"priceColumnCrudCtrl.type == \'RETAIL\'\"><li><a>Розница</a></li><li><a ui-sref=\"priceList({parent: \'RETAIL\'})\">Розничный прайс-лист</a></li></ul><ul class=\"breadcrumbs main-left-offset\" ng-if=\"priceColumnCrudCtrl.type == \'PURCHASE\'\"><li><a>Закупки</a></li><li><a ng-if=\"$root.hasRole(\'purchase_price_list.read\')\" ui-sref=\"priceList({parent: \'PURCHASE\'})\">Закупочный прайс-лист</a></li></ul><div class=\"crud-entity main-left-offset main-right-offset\" id=price-column><div ng-if=\"priceColumnCrudCtrl.state.current.name == \'priceColumn.new\'\"><h1>Добавление колонки с ценами</h1></div><div ng-if=\"priceColumnCrudCtrl.state.current.name == \'priceColumn.edit\'\"><h1>Редактирование колонки с ценами</h1><div class=edit-view-buttons></div></div><div class=\"col-xs-9 section top-buttons\" ng-if=!priceColumnCrudCtrl.mode.isNew><form-buttons view-type=priceColumnCrudCtrl.mode on-button=priceColumnCrudCtrl.crud(status) can-disabled=\"(priceColumnCrudCtrl.isSetDirty && !priceColumnCrudCtrl.addPriceColumn.$valid) || priceColumnCrudCtrl.isHasValidErrors(priceColumnCrudCtrl.addPriceColumn.$error)\"></form-buttons></div><div class=clear></div><form role=form novalidate name=priceColumnCrudCtrl.addPriceColumn class=\"price-column crud-entity\"><div ng-if=\"priceColumnCrudCtrl.type == \'PURCHASE\'\"><div ng-include=\"\'app/price-list/column/sections/main-purchase-info.html\'\" class=\"clearfix full-width\"></div></div><div ng-if=\"priceColumnCrudCtrl.type !== \'PURCHASE\'\"><div ng-include=\"\'app/price-list/column/sections/main-info.html\'\" class=\"clearfix full-width\"></div><div ng-include=\"\'app/price-list/column/sections/price.html\'\" class=\"clearfix full-width\"></div><price-formula ng-if=\"priceColumnCrudCtrl.useRounding && priceColumnCrudCtrl.priceCreation\" column=priceColumnCrudCtrl.priceColumn form-ctrl=priceColumnCrudCtrl.addPriceColumn class=\"clearfix full-width\"></price-formula><visibility-settings column=priceColumnCrudCtrl.priceColumn fotm-ctrl=priceColumnCrudCtrl.addPriceColumn></visibility-settings></div><div class=clear></div><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=priceColumnCrudCtrl.addPriceColumn can-show=priceColumnCrudCtrl.isSetDirty></form-errors><form-buttons view-type=priceColumnCrudCtrl.mode on-button=priceColumnCrudCtrl.crud(status) can-disabled=\"(priceColumnCrudCtrl.isSetDirty && !priceColumnCrudCtrl.addPriceColumn.$valid) || priceColumnCrudCtrl.isHasValidErrors(priceColumnCrudCtrl.addPriceColumn.$error)\"></form-buttons></div></form></div>");
$templateCache.put("app/price-list/import/import-price-list.html","<div class=\"crud-entity alcohol-settings main-left-offset main-right-offset import-price-list-wrap\"><!-- content of settings --><ul class=breadcrumbs><li><a>РОЗНИЦА</a> <span class=divider></span></li><li ng-if=\"vm.type == \'RETAIL\'\"><a ui-sref=\"priceList({parent: \'RETAIL\'})\">Розничный прайс-лист</a></li><li ng-if=\"vm.type == \'WHOLE_SALE\'\"><a ui-sref=\"priceList({parent: \'WHOLE_SALE\'})\">Оптовый прайс-лист</a></li></ul><h1>Импорт прайс-листа</h1><form role=form name=importForm class=import-wrap><div class=\"clearfix full-width\" ng-include=\"\'app/price-list/import/sections/1-load-file.html\'\"></div><div class=\"clearfix full-width\" ng-show=vm.activeStep ng-include=\"\'app/price-list/import/sections/2-data-processing.html\'\"></div><div class=\"clearfix full-width\" ng-show=\"vm.activeStep > 1\" ng-include=\"\'app/price-list/import/sections/3-other-data.html\'\"></div><div class=\"clearfix full-width\" ng-show=\"vm.activeStep > 2\" ng-include=\"\'app/price-list/import/sections/4-check-file.html\'\"></div></form><div class=\"section bottom-buttons col-xs-12\"><button class=\"btn btn-ico-wrap\" ng-click=vm.back(); ng-show=vm.activeStep><span class=\"btn-ico btn-arrow\"></span>Назад</button> <button class=\"btn pull-right\" ng-class=\"{\'btn-primary\': vm.uploader.queue[0].isSuccess}\" ng-disabled=\"!vm.uploader.queue[0].isSuccess || vm.headersCheck === false || vm.columnErrorInds.length || (importForm.$invalid &&  vm.activeStep < 3) || vm.issetColumnName\" ng-click=\"(!vm.uploader.queue[0].isSuccess || vm.headersCheck === false || vm.columnErrorInds.length || (importForm.$invalid &&  vm.activeStep < 3))? \'\' : vm.next();\" ng-show=\"vm.activeStep < 3\">Далее</button> <button class=\"btn btn-primary pull-right\" ng-click=vm.importStart(); ng-show=\"vm.activeStep > 2\" ng-disabled=\"!vm.fileErrors || (vm.fileErrors.success_count === 0 && vm.activeStep > 2)\">Начать импорт</button> <button class=\"btn pull-right\" ng-click=vm.returnToPage() ng-show=\"vm.activeStep > 2\">Отменить</button></div></div>");
$templateCache.put("app/price-list/includes/button-block.html","<div><div class=pull-left ng-if=\"$root.hasRole(\'price_list.write\')\"><a href=\"\" ng-click=priceListCtrl.openNewPriceItems() class=btn ng-class=\"{\'btn-primary\': priceListCtrl.root.loaded && !priceListCtrl.root.children.length && !priceListCtrl.showSearch}\"><span class=\"btn-ico btn-plus\" ng-class=\"{\'btn-plus-dark\': !(priceListCtrl.root.loaded && !priceListCtrl.root.children.length && !priceListCtrl.showSearch)}\"></span>товары или услуги </a><a ui-sref=\"priceColumn.new({type: priceListCtrl.type, parent: priceListCtrl.type})\" class=\"btn ng-hide\" ng-hide=\"!priceListCtrl.root.loaded || !priceListCtrl.root.children.length || priceListCtrl.showSearch\" style=\"margin-left: 5px;\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>колонка цен</a></div><div class=pull-right ng-if=\"priceListCtrl.type !== \'PURCHASE\'\"><a ui-sref=\"importPriceList({parent: priceListCtrl.type})\" class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Импортировать из файла\" ng-if=\"($root.hasRole(\'price_list.import\') || $root.hasRole(\'wholesale_price_list.import\')) && priceListCtrl.type !== \'PURCHASE\'\" style=\"margin-right: 3px; padding: 9px 14px;\"><span class=\"btn-import btn-ico\"></span> </a><button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Экспортировать в файл\" ng-if=\"($root.hasRole(\'price_list.export\') || $root.hasRole(\'wholesale_price_list.export\')) && priceListCtrl.type !== \'PURCHASE\'\" ng-click=priceListCtrl.openPriceListExportModal() style=\"margin-right: 3px; padding: 9px 14px;\"><span class=\"btn-export btn-ico\"></span></button> <button class=\"btn button-print tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Печатать {{(priceListCtrl.type == \'RETAIL\')? \'розничный\' : \'оптовый\'}} прайс-лист\" ng-if=\"$root.hasRole(\'report.price_list\') || $root.hasRole(\'report.wholesale_price_list\')\" ng-click=priceListCtrl.openPriceListPrintModal() style=\"padding-top: 7px;\"><span class=printer></span></button></div></div>");
$templateCache.put("app/price-list/includes/price-tree-header.html","<div class=\"column-header-container main-right-offset\" style=\"position: inherit;\"><div class=\"column-header single-line head-checkbox\" style=\"width: 80px;\"><div class=\"checkbox pull-left\" style=\"margin-left: 30px;\"><label style=\"padding: 0; outline: none;\" ng-click=$event.stopPropagation()><input type=checkbox ng-if=priceListCtrl.showSearch ng-change=\"(priceListCtrl.checkAllSearch)? priceListCtrl.searchRoot.checkAll() : priceListCtrl.searchRoot.clearChecked()\" ng-model=priceListCtrl.checkAllSearch> <input type=checkbox ng-if=!priceListCtrl.showSearch ng-change=\"(priceListCtrl.checkAll)? priceListCtrl.root.checkAll() : priceListCtrl.root.clearChecked()\" ng-model=priceListCtrl.checkAll> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></div><div class=\"column-header single-line\" style=\"flex: 2 0; margin-right: 40px;\"><b style=\"margin-left: 13px;\">Позиции</b></div><div class=column-name-wrapper ng-style=\"{flex: (priceListCtrl.columnsPaging.limit > priceListCtrl.treeColumns.length ? priceListCtrl.treeColumns.length : priceListCtrl.columnsPaging.limit)\n         + \' \' + (priceListCtrl.columnsPaging.limit > priceListCtrl.treeColumns.length ? priceListCtrl.treeColumns.length : priceListCtrl.columnsPaging.limit) + \' \' + \'0\'}\"><div class=column-header-container><span class=\"badge badge-arrow left tooltip-light\" tooltip-placement=right uib-tooltip=\"Показать еще колонки\" ng-click=\"priceListCtrl.columnsPaging.offset = (priceListCtrl.columnsPaging.offset > 0) ? priceListCtrl.columnsPaging.offset - 1: 0\" ng-show=\"priceListCtrl.columnsPaging.offset > 0\"></span><div class=column-header style=\"min-width: 0\" ng-repeat=\"column in priceListCtrl.treeColumns\n              | limitTo:priceListCtrl.columnsPaging.limit:priceListCtrl.columnsPaging.offset\" ng-style=\"{\'flex\': column.flex + \' \' + 0}\"><span class=\"has-changes tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Несохраненные изменения\" ng-if=column.$$hasChanges></span><div class=single-line style=\"min-width: 0\"><a class=\"pull-right edit-container\" ng-if=\"$root.hasRole(\'price_list.write\') || $root.hasRole(\'wholesale_price_list.write\')\" ui-sref=\"priceColumn.edit({priceColumnId: column.id, type: priceListCtrl.type, parent: priceListCtrl.type})\"><i style=\"margin-right: 20px; position: relative;\" class=\"control-item img-edit tooltip-light\" tooltip-placement=left uib-tooltip=Редактировать></i> </a><b class=tree-column-name title=\"{{column.name}}\" ng-bind=column.name></b><br><small class=\"badge badge-primary\" ng-show=column.effective_order_sum tooltip-placement=bottom-left uib-tooltip=\"Действует только для заказов от {{column.effective_order_sum}} {{column.currency.symbol}}\">от {{column.effective_order_sum}} <span ng-bind=column.currency.symbol class=currency-font></span> </small><span class=\"glyphicon glyphicon-info-sign divisions-icon tooltip-light\" ng-if=column.divisions.length tooltip-placement=right uib-tooltip-html=\"\'{{priceListCtrl.tipForDivisions(column)}}\'\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon tooltip-light\" ng-if=column.counterparties.length tooltip-placement=right uib-tooltip-html=\"\'{{priceListCtrl.tipForCounterparties(column)}}\'\"></span> <span class=\"glyphicon glyphicon-info-sign divisions-icon no-access\" ng-if=\"column.divisions_assignment_type == \'NONE\'\" tooltip-placement=right uib-tooltip=\"Ни для кого\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon tooltip-light\" ng-if=\"priceListCtrl.type == \'PURCHASE\' && column.supplier.name\" tooltip-placement=right uib-tooltip-html=\"\'{{\'Действует для поставщика \' + column.supplier.name}}\'\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon no-access\" ng-if=\"column.counterparties_assignment_type == \'NONE\' && priceListCtrl.type !== \'RETAIL\'\" tooltip-placement=right uib-tooltip=\"Ни для кого\"></span></div></div><span class=\"badge badge-arrow right tooltip-light\" tooltip-placement=left uib-tooltip=\"Показать еще колонки\" ng-click=\"priceListCtrl.columnsPaging.offset = (priceListCtrl.columnsPaging.offset + priceListCtrl.columnsPaging.limit < priceListCtrl.treeColumns.length) ? priceListCtrl.columnsPaging.offset + 1 : priceListCtrl.columnsPaging.offset\" ng-show=\"priceListCtrl.columnsPaging.offset + priceListCtrl.columnsPaging.limit < priceListCtrl.treeColumns.length\"></span></div></div><a ng-if=\"$root.hasRole(\'catalog_settings.write\')\" ng-click=priceListCtrl.openSettings() class=\"btn gear-button only-ico btn-price-settings tooltip-light\" tooltip-placement=bottom uib-tooltip=\"Настроить отображение колонок\" style=\"padding-top: 7px;\"><span class=\"btn-ico btn-gear\" style=\"width: 24px; height: 26px;\"></span></a></div>");
$templateCache.put("app/price-list/includes/search-block.html","<div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><div class=pull-right style=\"margin-top: 16px;\"><price-tag-print catalog-items=[] root=priceListCtrl.root ng-if=\"$root.hasRole(\'report.price_tags\') && !priceListCtrl.showSearch && priceListCtrl.root.hasSelected() && priceListCtrl.root.children.length && priceListCtrl.type == \'RETAIL\'\" for-service=false as-button=\"\'slim\'\"></price-tag-print><price-tag-print catalog-items=[] root=priceListCtrl.searchRoot ng-if=\"$root.hasRole(\'report.price_tags\') && priceListCtrl.showSearch && priceListCtrl.searchRoot.hasSelected() && priceListCtrl.searchRoot.children.length && priceListCtrl.type == \'RETAIL\'\" for-service=false as-button=\"\'slim\'\"></price-tag-print><a href=\"\" ng-if=\"((!priceListCtrl.showSearch && priceListCtrl.root.hasSelected()) || (priceListCtrl.showSearch && priceListCtrl.searchRoot.hasSelected())) && priceListCtrl.root.children.length\" ng-click=priceListCtrl.deletePriceItemModal() class=\"btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Удалить ng-if=\"$root.hasRole(\'price_list.write\') || $root.hasRole(\'wholesale_price_list.write\')\" style=\"margin-left: 5px;\"><span class=\"glyphicon glyphicon-trash btn-ico\" style=\"margin-top: 2px;\"></span></a></div><form class=\"search-entity col-xs-9 filters-static-form\" role=search style=\"max-width: 820px;\"><div class=\"form-group col-xs-5\"><label class=label>Поиск</label><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button ng-model=priceListCtrl.searchText class=\"form-control label-clear-button inline-clear-button\" placeholder=\"Поиск по наименованию категории, товара или услуги\" style=\"padding-left: 30px;\"></div><div class=\"form-group col-xs-2\" ng-if=\"priceListCtrl.type !== \'PURCHASE\'\"><label class=label>Начало действия цены</label><div date-range-picker ng-model=priceListCtrl.dateFromInterval state=priceListCtrl.stateForFilter opts=\"{singleDatePicker: false, \n                  correctTimeZone: true, \n                  opens: \'right\'}\" class=\"datepicker-wrap range-picker\" name=interval on-close=priceListCtrl.setIntervalPl(returnValue);></div></div><button class=\"btn slim-button\" ng-click=priceListCtrl.search(true) style=\"margin-right: 10px; min-width: 112px; line-height: 2.2;\">Поиск</button> <button class=\"btn slim-button\" ng-click=priceListCtrl.clearSearch() ng-class=\"{\'rellative-hide\': priceListCtrl.dateFromInterval.isAllTime && !priceListCtrl.searchText}\" ng-if=\"priceListCtrl.type !== \'PURCHASE\'\" style=\"min-width: 112px;\">Очистить</button></form></div>");
$templateCache.put("app/price-list/modal/delete-price-item.modal.html","<div class=modal-body><h3 class=modal-title>Удаление</h3><div class=modal-main-text>Вы действительно хотите удалить<br>выбранные позиции <span ng-if=\"deletePriceItemModalCtrl.priceListType == \'RETAIL\'\">Розничного прайс-листа?</span> <span ng-if=\"deletePriceItemModalCtrl.priceListType == \'WHOLE_SALE\'\">Прайс-листа на продажу?</span> <span ng-if=\"deletePriceItemModalCtrl.priceListType == \'PURCHASE\'\">Закупочного прайс-листа?</span></div></div><div class=modal-footer><button class=btn type=button ng-click=deletePriceItemModalCtrl.close()>Отмена</button> <button class=\"btn btn-primary\" type=button ng-click=deletePriceItemModalCtrl.delete()>Удалить</button></div>");
$templateCache.put("app/price-list/modal/new-price-item.modal.html","<div class=\"modal-body catalog\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=newPriceItemModalCtrl.cancel()>×</button><h3 class=\"modal-price-title modal-title\" ng-bind=\"::!newPriceItemModalCtrl.categoryInputMode ? \'Товары и услуги\' : \'Выбор категории\'\"></h3><div class=\"row main-control-block\" style=\"background: none; margin: 0 0 0 -15px;\"><div class=col-xs-6 ng-if=::!newPriceItemModalCtrl.categoryInputMode><span class=text-muted>Выберите те товары и услуги, которые вы хотите выставить на продажу</span></div><form ng-if=::!newPriceItemModalCtrl.categoryInputMode class=search-entity ng-class=\"::!newPriceItemModalCtrl.categoryInputMode ? col-xs-6 : col-xs-12\" role=search ng-submit=newPriceItemModalCtrl.search(true)><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button class=\"form-control label-clear-button\" ng-model=newPriceItemModalCtrl.searchText placeholder=\"Поиск по категории и товару\" maxlength=30 ng-keypress=\"$event.which === 13 && newPriceItemModalCtrl.search(true)\"> <button class=\"btn slim-button search-btn\" ng-click=newPriceItemModalCtrl.search(true)>Поиск</button></div></form><!-- <div class=\"form-group input-group\">\n        <span class=\"input-group-addon\" ng-click=\"newPriceItemModalCtrl.search(true)\"><span\n          class=\"glyphicon glyphicon-search\"></span></span>\n        <input type=\"text\"\n               clear-button\n               ng-keypress=\"$event.which === 13 && newPriceItemModalCtrl.search(true)\"\n               class=\"form-control inline-clear-button\"\n               ng-model=\"newPriceItemModalCtrl.searchText\"\n               placeholder=\"Поиск по категории и товару\"\n               maxlength=\"30\">\n      </div> --></div><div class=modal-tree ng-class=\"{\'without-selected\': !newPriceItemModalCtrl.categoryInputMode}\"><div ng-scrollbars ng-scrollbars-config=newPriceItemModalCtrl.configScroll><catalog-tree ng-if=::!newPriceItemModalCtrl.categoryInputMode ng-show=!newPriceItemModalCtrl.showSearch min-height=400 root-visible=true load-callback=::newPriceItemModalCtrl.onTreeLoaded block-choice-hoisting=true on-collapse-node=newPriceItemModalCtrl.onCollapseNode on-expand-node=newPriceItemModalCtrl.onExpandNode expand-node=newPriceItemModalCtrl.expand root=newPriceItemModalCtrl.root show-checkbox=true></catalog-tree><catalog-tree ng-if=::newPriceItemModalCtrl.categoryInputMode ng-show=!newPriceItemModalCtrl.showSearch min-height=400 root-visible=true expand-node=newPriceItemModalCtrl.expandSimple item-count=none show-arrow=true selected-callback=newPriceItemModalCtrl.selectNode root=newPriceItemModalCtrl.root root-always-expand=true load-callback=::newPriceItemModalCtrl.onTreeLoaded></catalog-tree><div ng-show=\"newPriceItemModalCtrl.showSearch && newPriceItemModalCtrl.searchResult.length\"><grid-search results=newPriceItemModalCtrl.searchResult show-checkbox=::!newPriceItemModalCtrl.categoryInputMode parent-property=parents expand-callback=newPriceItemModalCtrl.expandTreePath></grid-search><div class=table-footer style=\"margin-bottom: 0\"><div class=pagination-wrapper><paging page-info=newPriceItemModalCtrl.searchPaging callback=newPriceItemModalCtrl.search></div></div></div><div class=\"no-content text-center\" style=\"height: 360px\" ng-if=\"newPriceItemModalCtrl.showSearch && !newPriceItemModalCtrl.searchResult.length\"><p style=\"padding-bottom: 0\">К сожалению, поиск не дал результатов.<br>Попробуйте уточнить запрос<br>и повторить попытку</p><div class=arrow></div></div></div></div></div><div class=modal-footer><div class=\"req-inform pull-left text-left\" ng-if=\"newPriceItemModalCtrl.isSaved && !newPriceItemModalCtrl.getSelectedItems().length\" style=\"margin-top: -6px;\">Необходимо выбрать те товары и услуги,<br>которые вы хотите выставить на продажу</div><div ng-if=::!newPriceItemModalCtrl.categoryInputMode><button class=\"btn btn-default\" type=button ng-click=newPriceItemModalCtrl.cancel()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=newPriceItemModalCtrl.saveAndClose() style=\"width: auto;\" ng-disabled=\"newPriceItemModalCtrl.isSaved && !newPriceItemModalCtrl.getSelectedItems().length\">Добавить</button></div><div ng-if=::newPriceItemModalCtrl.categoryInputMode><button class=\"btn btn-primary\" type=button ng-click=newPriceItemModalCtrl.selectAndClose() style=\"width: auto;\" ng-disabled=\"newPriceItemModalCtrl.isSaved && !newPriceItemModalCtrl.getSelectedItems().length\">Выбрать</button></div></div><div class=lock-bg ng-show=newPriceItemModalCtrl.lock><div class=ui-spinner></div></div>");
$templateCache.put("app/price-list/modal/price.modal.html","<div class=\"modal-body modal-price\" ng-class=\"{\'blur-bg\': priceModalCtrl.removeActive}\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Закрыть ng-click=\"priceModalCtrl.cancel(\'dismiss\');\">×</button> <button class=\"btn only-ico minimizer tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Свернуть ng-if=priceModalCtrl.from_cell ng-click=\"priceModalCtrl.cancel(\'minimizer\')\"><span class=\"btn-minimizer btn-ico\"></span></button><h3 class=\"modal-price-title modal-title\">Цена на «<span ng-bind=\"priceModalCtrl.node.catalog_item.name || priceModalCtrl.catalogItem.name\"></span>»</h3><a ng-if=\"$state.current.name === \'priceList\' && priceModalCtrl.node.catalog_item.type == \'SKU\'\" target=_blank ui-sref=\"catalogSkus.view({elementId: priceModalCtrl.node.catalog_item.id, parent: $state.params.parent})\" class=primary-text>Посмотреть карточку товара</a> <a ng-if=\"$state.current.name === \'priceList\' && priceModalCtrl.node.catalog_item.type == \'SERVICE\'\" target=_blank ui-sref=\"catalogServices.view({elementId: priceModalCtrl.node.catalog_item.id, parent: $state.params.parent})\" class=primary-text>Посмотреть карточку услуги</a><div class=emply-price-block ng-if=\"priceModalCtrl.priceListType !== \'PURCHASE\' && (priceModalCtrl.node.catalog_item.status == \'DRAFT\' ||\n        priceModalCtrl.node.catalog_item.status == \'ARCHIVED\')\">Временно нет в продаже</div><div class=emply-price-block ng-if=\"priceModalCtrl.noPrice && priceModalCtrl.node.catalog_item.status != \'DRAFT\' &&\n        (priceModalCtrl.priceListType == \'PURCHASE\' || priceModalCtrl.node.catalog_item.status != \'ARCHIVED\')\"> {{ priceModalCtrl.node.catalog_item.type === \'SERVICE\' ? \'Услуга\': \'Товар\' }} не в прайс-листе <a ui-sref=\"priceList({parent: \'RETAIL\'})\"></a></div><div ng-form=priceModalCtrl.formCtrl class=modal-price-container ng-if=\"!priceModalCtrl.noPrice && priceModalCtrl.node.catalog_item.status != \'DRAFT\' &&\n        (priceModalCtrl.priceListType == \'PURCHASE\' || priceModalCtrl.node.catalog_item.status != \'ARCHIVED\')\"><div class=\"column-header-container modal-price-header\"><span class=\"badge badge-arrow left tooltip-light\" tooltip-placement=right uib-tooltip=\"Показать еще колонки\" ng-click=\"priceModalCtrl.columnsPaging.offset = priceModalCtrl.columnsPaging.offset - 1\" ng-show=\"priceModalCtrl.columnsPaging.offset > 0\"></span><div class=\"column-header single-line\" ng-repeat=\"column in priceModalCtrl.columns\n              | limitTo:priceModalCtrl.columnsPaging.limit:priceModalCtrl.columnsPaging.offset\" ng-style=\"{\'flex\': column.flex + \' \' + column.flex}\"><b title=\"{{column.name}}\" ng-bind=column.name></b><br><small class=\"badge badge-primary\" ng-show=column.effective_order_sum>от {{column.effective_order_sum}} <span ng-bind=column.currency.symbol class=currency-font></span></small> <span class=\"glyphicon glyphicon-info-sign divisions-icon tooltip-light\" ng-if=column.divisions.length tooltip-placement=right uib-tooltip-html=\"\'{{priceModalCtrl.tipForDivisions(column)}}\'\"></span> <span class=\"glyphicon glyphicon-info-sign divisions-icon no-access\" ng-if=\"column.divisions_assignment_type == \'NONE\'\" tooltip-placement=right uib-tooltip=\"Ни для кого\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon tooltip-light\" ng-if=column.counterparties.length tooltip-placement=right uib-tooltip-html=\"\'{{priceModalCtrl.tipForCounterparties(column)}}\'\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon no-access\" ng-if=\"column.counterparties_assignment_type == \'NONE\' && priceModalCtrl.priceListType !== \'RETAIL\'\" tooltip-placement=right uib-tooltip=\"Ни для кого\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon tooltip-light\" ng-if=\"priceModalCtrl.priceListType == \'PURCHASE\' && column.supplier.name\" tooltip-placement=right uib-tooltip-html=\"\'{{\'Действует для поставщика \' + column.supplier.name}}\'\"></span></div><span class=\"badge badge-arrow right tooltip-light\" tooltip-placement=left uib-tooltip=\"Показать еще колонки\" ng-click=\"priceModalCtrl.columnsPaging.offset = priceModalCtrl.columnsPaging.offset + 1\" ng-show=\"priceModalCtrl.columnsPaging.offset + priceModalCtrl.columnsPaging.limit < priceModalCtrl.columns.length\"></span></div><div ng-scrollbars ng-scrollbars-config=priceModalCtrl.configScroll ng-class=\"{\'always-edit\': !priceModalCtrl.lock}\"><div class=\"column-header-container modal-price-body\"><div class=column-header ng-repeat=\"column in priceModalCtrl.columns\n                | limitTo:priceModalCtrl.columnsPaging.limit:priceModalCtrl.columnsPaging.offset\" ng-style=\"{\'flex\': column.flex + \' \' + column.flex}\"><div class=column-header-inner><div ng-repeat=\"price in priceModalCtrl.prices[column.id]\"><div class=modal-price-cell><div style=\"position: relative\"><price-cell currency=column.currency uom=::priceModalCtrl.catalogItem.uom lock=priceModalCtrl.lock column-type=::column.column_type column=column state=!priceModalCtrl.lock validate-price=priceModalCtrl.validatePrice price=price always-edit=!priceModalCtrl.lock></price-cell><button class=\"btn slim-button only-ico delete-badge tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Удалить ng-click=\"priceModalCtrl.removePrice(priceModalCtrl.prices[column.id], $index)\" ng-disabled=\"priceModalCtrl.prices[priceModalCtrl.current || 0] && priceModalCtrl.prices[priceModalCtrl.current || 0].price_for_one_uom == undefined && priceModalCtrl.prices[priceModalCtrl.current || 0].calculated_automatically_price_for_one_uom !== undefined\"><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button></div></div></div><button ng-hide=priceModalCtrl.lock ng-if=\"$root.hasRole(\'price_list.write\') || $root.hasRole(\'wholesale_price_list.write\')\" class=\"add-item-icon tooltip-light\" tooltip-placement=right uib-tooltip=\"Добавить цену\" ng-click=priceModalCtrl.addPrice(column.id)></button></div></div></div></div></div></div><div class=\"req-inform pull-left text-left\" ng-if=\"(!priceModalCtrl.allow || priceModalCtrl.formCtrl.$invalid) && priceModalCtrl.isSaved\" style=\"padding-left: 40px;\">* Заполните все поля</div><div class=modal-footer ng-class=\"{\'blur-bg\': priceModalCtrl.removeActive}\"><div class=pull-left ng-if=\"($root.hasRole(\'price_list.write\') || $root.hasRole(\'wholesale_price_list.write\')) && !priceModalCtrl.noPrice\"><button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Удалить type=button ng-click=\"priceModalCtrl.removeActive = true;\" style=\"margin-right: 10px;\"><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button><price-tag-print ng-if=\"priceModalCtrl.priceListType !== \'PURCHASE\'\" catalog-items=[priceModalCtrl.node.catalog_item] ng-if=\"$root.hasRole(\'report.price_tags\')\" for-service=\"priceModalCtrl.node.catalog_item.type == \'SERVICE\'\" as-button=true></price-tag-print></div><button class=btn type=button ng-click=priceModalCtrl.cancel()>Отмена</button> <button class=\"btn btn-primary\" ng-if=\"($root.hasRole(\'price_list.write\') && !priceModalCtrl.lock) || ($root.hasRole(\'wholesale_price_list.write\') && !priceModalCtrl.lock)\" type=button ng-click=priceModalCtrl.saveAndClose() ng-disabled=\"(!priceModalCtrl.allow || priceModalCtrl.formCtrl.$invalid) && priceModalCtrl.isSaved\">Сохранить</button></div><div class=remove-box ng-show=priceModalCtrl.removeActive><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=alert aria-hidden=true ng-click=\"priceModalCtrl.removeActive = false\">×</button><h3 class=remove-box-title>Удаление</h3><div class=remove-sub-acc>Вы действительно хотите удалить <span ng-bind=\"(priceModalCtrl.node.catalog_item.type == \'SKU\')? \'товар\' : \'услугу\'\"></span> {{priceModalCtrl.node.catalog_item.name}} из Прайс-листа?<br><br><br><p class=footer-buttons><button type=button ng-click=\"priceModalCtrl.removeActive = false;priceModalCtrl.removeCatalogItem(priceModalCtrl.node.catalog_item.id)\" class=\"btn btn-primary\">Да</button> <button type=button ng-click=\"priceModalCtrl.removeActive = false\" class=btn>Нет</button></p></div></div>");
$templateCache.put("app/price-list/price-list-export/price-list-export-modal.html","<form name=$ctrl.exportForm><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title>Экспорт прайс-листа в файл</h3></div><div class=container style=\"padding-right: 0\"><div class=\"col-xs-12 row\" ng-if=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.finish\"><div class=colNameWrapper ng-scrollbars ng-scrollbars-config=$ctrl.configScroll><div ng-repeat=\"col in $ctrl.columns\"><div class=\"radio pull-left\"><label><input type=radio name=colName ng-model=$ctrl.column ng-value=col ng-required=true id=\"colName{{$index}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"colName{{$index}}\" style=\"margin-bottom: 8px;\">{{col.name}}</label></div></div><br><div class=form-group><div class=col-xs-6 style=\"padding-left: 0;\"><div date-range-picker state=comparative_date_to ng-model=$ctrl.date opts=$ctrl.dateOptions class=datepicker-wrap name=startDate ng-required=true field-label=\"\'Дата действия цен\'\"></div></div></div></div><div class=\"statuses-wrapper text-center\" ng-hide=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.finish\"><div class=load-data-spinner ng-if=$ctrl.longRequest.crudState.loading><inview-loader show=$ctrl.longRequest.crudState.loading></inview-loader>Подготовка экспорта</div><div class=success-check ng-if=\"!$ctrl.longRequest.crudState.loading && $ctrl.longRequest.flags.finish && !$ctrl.longRequest.flags.error\"><div class=\"center-ico ok-check-ico\"></div>Файл сформирован</div><div class=error-check ng-if=$ctrl.longRequest.flags.error><div class=\"center-ico error-check-ico\"></div>При подготовке файла экспорта возникла ошибка</div></div></div><div class=modal-footer><button class=\"btn pull-left\" type=button ng-click=$ctrl.close()>{{!$ctrl.longRequest.exec_id ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-if=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.finish\" class=\"btn btn-primary\" ng-disabled=!$ctrl.exportForm.$valid ng-click=$ctrl.prepareExport() type=button>Выгрузить</button></div></form>");
$templateCache.put("app/price-list/settings/priceSettings.html","<div class=ui-grid-menu-wrapper><div class=\"price-settings ui-grid-menu simpleDemo\"><!-- content of settings --><div class=\"price-settings-container ui-grid-menu-inner\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=priceSettingsCtrl.cancel()>&times;</button><h3 class=modal-title>Отображение колонок</h3></div><div class=container><form class=clearfix><div class=row><section class=\"form-group col-xs-12\"><div class=\"form-group row\"><label class=col-xs-8>Количество отображаемых колонок</label><div class=col-xs-4><input class=\"form-control slim-control\" min=1 max=3 ng-model=priceSettingsCtrl.columnsNumber type=number></div></div><div class=modal-description>Вы можете настроить отображение любых колонок из списка и, перетаскивая их, задать порядок следования</div><div ng-scrollbars ng-scrollbars-config=priceSettingsCtrl.configScroll class=columns-wrapper><ul class=ui-grid-menu-items dnd-list=priceSettingsCtrl.columns dnd-drop=\"priceSettingsCtrl.dropCallback(index, item, external, type, priceSettingsCtrl.columns)\"><li ng-repeat=\"item in priceSettingsCtrl.columns track by $index\" class=\"ui-grid-menu-item ui-item-{{item.name}}\" dnd-draggable=item dnd-dragend=\"priceSettingsCtrl.listMoved($index, item, priceSettingsCtrl.columns)\" dnd-effect-allowed=move dnd-selected=\"models.selected = item\" ng-class=\"{\'selected\': priceSettingsCtrl.columns.selected === item}\"><dnd-nodrag class=display-flex ng-if=!item.pinned><div class=checkbox><label><input type=checkbox ng-model=item.visible> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><div class=menu-item-name><span ng-bind-html=item.name></span><div dnd-handle=\"\" class=handle></div></div></dnd-nodrag></li></ul></div></section></div></form></div><div class=modal-footer><div class=pull-right><button class=\"btn btn-padding-lg\" ng-click=priceSettingsCtrl.default()>по умолчанию</button> <button class=\"btn btn-primary btn-padding-lg\" ng-click=priceSettingsCtrl.save()><span>Применить</span></button></div></div></div></div></div>");
$templateCache.put("app/print/print-sales-report/print-sales-report-modal.html","<form name=printForm><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title>Печать отчета о розничных продажах</h3></div><div class=container><div ng-if=!$ctrl.longRequest.crudState.loading class=crud-entity style=\"width: 107%;\"><div ng-if=!$ctrl.longRequest.flags.finish><div class=\"col-xs-6 row form-group\" style=\"padding: 0\"><label class=col-xs-12 style=\"padding-left: 15px;padding-bottom: 20px;\">Формат файла</label><div class=col-xs-6 style=\"height: 33px;\"><div class=\"radio pull-left\"><label><input type=radio checked name=formatType value=PDF id=pdf ng-model=$ctrl.printData.format> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=\"pdf label-icon\"></span><label class=\"label-radio label-with-icon\" for=pdf>PDF</label></div><div class=col-xs-6 style=\"height: 33px;\"><div class=\"radio pull-left\"><label><input type=radio name=formatType value=XLS id=xls ng-model=$ctrl.printData.format> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=\"xls label-icon\"></span><label class=\"label-radio label-with-icon\" for=xls>XLS</label></div></div><div class=\"col-xs-12 row\"><div class=form-group><ui-select ng-model=$ctrl.printData.division search-enabled=false on-select=$ctrl.divisionSelected($select.selected) ng-disabled=!$ctrl.divisions.length><ui-select-match allow-clear=true><span ng-bind=\"$select.selected.name + \' - \' + $select.selected.company_name\"></span></ui-select-match><ui-select-choices repeat=\"item as item in $ctrl.divisions track by $index\"><span ng-bind-html=\"item.name + \' - \' + item.company_name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Подразделение</label></div></div><div class=\"col-xs-12 row clearfix\"><div class=form-group><ui-select ng-model=$ctrl.categories.value search-enable=$ctrl.categories.getSearchEnabled($select) ng-disabled=$ctrl.categories.getDisabled($select) ng-class=\"{\'autocomplete-select\': $ctrl.categories.field.total > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=$ctrl.categories.refresh($select.search) repeat=\"category in ($ctrl.categories.field.items | filter: $select.search) track by $index\" group-by=$ctrl.totalStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"category.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Категория товара</label></div></div><div class=\"col-xs-12 row form-group\" style=\"padding: 0 15px 0px 0; margin-bottom: 0;\"><report-period start-date=$ctrl.dateInterval.startDate end-date=$ctrl.dateInterval.endDate></report-period></div><div class=\"col-xs-6 row form-group\" style=\"padding-right: 43px;\" ng-if=printForm.$valid><ui-select ng-model=$ctrl.printData.cashregister_shift_id><ui-select-match><span ng-bind=\"\'№ \' + $select.selected.number + \' \' + ($select.selected.start_date | date:\'dd.MM.yyyy\')\"></span></ui-select-match><ui-select-choices repeat=\"item.id as item in $ctrl.cashregisterShifts track by $index\"><span ng-bind-html=\"\'№ \' + item.number + \' \' + (item.start_date | date:\'dd.MM.yyyy\')\" uib-tooltip=\"{{\'№ \' + item.number + \' \' + (item.start_date | date:\'dd.MM.yyyy\')}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Смена</label></div></div></div><inview-loader class=popup show=$ctrl.longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center; padding: 30px 0 20px;\" ng-if=$ctrl.longRequest.crudState.loading>Подготовка отчета</h4><h4 style=\"text-align: center; padding: 60px 0 20px;\" ng-if=\"!$ctrl.longRequest.crudState.loading && $ctrl.longRequest.flags.finish && !$ctrl.longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center; padding: 60px 0 20px;\" ng-if=$ctrl.longRequest.flags.error>При подготовке отчета произошла ошибка</h4></div><div class=modal-footer style=\"padding-top: 10px;\"><div class=\"req-inform pull-left text-left\" ng-show=\"printForm.$invalid && $ctrl.isSaved\" style=\"width: 60%;\">Поля, помеченные *, обязательные для заполнения</div><button class=btn type=button ng-click=$ctrl.close()>{{$ctrl.longRequest.flags.finish ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-if=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.processStart && !$ctrl.longRequest.flags.finish\" class=\"btn btn-primary\" type=button ng-disabled=\"printForm.$invalid && $ctrl.isSaved\" ng-click=$ctrl.prepareReport()>Печать</button></div></form>");
$templateCache.put("app/print/report-profit-and-loss/report-profit-and-loss.html","<form name=reportForm><div class=print-price-list-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>&times;</button><h3 class=modal-title ng-bind=\"$ctrl.resolve.title || \'Печать отчета о прибылях и убытках\'\"></h3></div><div class=\"container clearfix crud-entity\" ng-show=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.finish\"><div class=\"row clearfix\"><div class=col-xs-6 style=\"height: 75px;\"><label class=\"col-xs-12 row bottom-space\">Формат файла</label><div class=\"col-xs-6 row\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.format id=pdfFormat name=format value=PDF> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=pdfFormat><span class=pdf-ico></span>PDF</label></div><div class=col-xs-6><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.format id=xlsFormat name=format value=XLS> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=xlsFormat><span class=xls-ico></span>XLS</label></div></div><div class=\"form-group col-xs-6\" style=\"height: 75px\"></div><div class=\"form-group col-xs-6\"><ui-select ng-model=$ctrl.data.filter_company_id name=companyId><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=$ctrl.refreshCompanies($select.search) repeat=\"item.id as item in $ctrl.companies track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Компания</label></div><div class=\"form-group col-xs-6\"><ui-select ng-model=$ctrl.data.filter_project_id ng-hide=\"$ctrl.stateName.endsWith(\'view\')\" search-enabled=\"$ctrl.projectsFullTotal > 5\" ng-class=\"{\'autocomplete-select\': $ctrl.projectsFullTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=$ctrl.refreshProjects($select.search) repeat=\"item.id as item in ( $ctrl.projects.items | filter: $select.search) track by $index\" group-by=$ctrl.totalSelectStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Проект</label></div></div><div class=\"row clearfix\"><report-period start-date=$ctrl.data.start_date end-date=$ctrl.data.end_date></report-period></div><div class=\"row clearfix\" ng-if=\"$ctrl.resolve.mode == \'cashFlow\'\"><h5 class=col-xs-12 style=\"font-weight: bold;\">ГРУППИРОВАТЬ ПО</h5><div class=radio-box><div class=\"clearfix col-xs-6\" ng-repeat=\"radio in $ctrl.periods\"><div class=\"radio pull-left\"><label><input type=radio name=grouping_period ng-model=$ctrl.data.grouping_period ng-value=radio.value id=\"{{radio.value}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{radio.value}}\">{{radio.label}}</label></div></div></div></div><inview-loader show=$ctrl.longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center;\" ng-if=\"$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.finish\">Подготовка отчета</h4><h4 style=\"text-align: center;\" ng-if=\"!$ctrl.longRequest.crudState.loading && $ctrl.longRequest.flags.finish && !$ctrl.longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center;\" ng-if=$ctrl.longRequest.flags.error>При подготовке отчета произошла ошибка</h4><div class=modal-footer><div class=\"req-inform pull-left text-left\" ng-show=\"reportForm.$invalid && $ctrl.isSaved\" style=\"width: 60%;\">Поля, помеченные *, обязательные для заполнения</div><button class=\"btn btn-default\" type=button ng-click=$ctrl.close()>{{longRequest.flags.finish ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-if=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.processStart && !$ctrl.longRequest.flags.finish\" class=\"btn btn-primary\" ng-click=$ctrl.print() ng-disabled=\"(!reportForm.$valid || $ctrl.longRequest.crudState.loading) && $ctrl.isSaved\">Печать</button></div></div></form>");
$templateCache.put("app/print/sales-totals-print/sales-totals-print.html","<div class=\"main-left-offset main-right-offset\"><ui-view></ui-view><ul class=breadcrumbs><li><a>Розница</a></li></ul><h1>Сводный отчет о розничных продажах</h1></div><div class=\"crud-entity clearfix main-left-offset main-right-offset sales-totals-print\"><div class=loader-wrapper ng-if=salesTotalsPrintCtrl.showLoader><div class=ui-spinner></div></div><form name=printForm class=\"crud-main-column col-xs-9 sales-totals-print\"><div ng-include=\"\'app/print/sales-totals-print/includes/common-info.html\'\"></div><div ng-include=\"\'app/print/sales-totals-print/includes/tabs.html\'\"></div><div class=req-inform ng-show=\"salesTotalsPrintCtrl.isSetDirty && (printForm.$invalid || ((salesTotalsPrintCtrl.activeTab == 2) && (!salesTotalsPrintCtrl.myTotals.dndColumns[1].items.length || !salesTotalsPrintCtrl.myTotals.dndLines[1].items.length)))\" style=\"padding-bottom: 30px;\">Поля, помеченные *, обязательные для заполнения</div></form><div class=\"section bottom-buttons col-xs-9\" style=\"padding: 0;\"><a class=\"btn btn-ico-wrap\" ng-click=salesTotalsPrintCtrl.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</a> <button class=\"btn btn-primary pull-right\" type=button ng-disabled=\"salesTotalsPrintCtrl.isSetDirty && (printForm.$invalid || ((salesTotalsPrintCtrl.activeTab == 2) && (!salesTotalsPrintCtrl.myTotals.dndColumns[1].items.length || !salesTotalsPrintCtrl.myTotals.dndLines[1].items.length)))\" ng-click=\"(printForm.$invalid || (salesTotalsPrintCtrl.activeTab == 2 && (!salesTotalsPrintCtrl.myTotals.dndColumns[1].items.length || !salesTotalsPrintCtrl.myTotals.dndLines[1].items.length )))? salesTotalsPrintCtrl.setDirty() : salesTotalsPrintCtrl.print()\" uib-tooltip=\"Запустить формирование отчета\">Печать</button></div></div>");
$templateCache.put("app/settings/accounting-settings/accounting-settings.html","<div class=crud-entity><div class=\"main-left-offset main-right-offset\"><h1>Настройки учета</h1><form role=form name=accountingSettingsForm autocomplete=off><div class=\"clearfix full-width flex-column\"><section class=\"row col-xs-9\"><div class=\"row col-xs-12\" ng-repeat=\"option in vm.settingsOptions\" ng-if=\"!option.ref || (option.ref && vm.request[option.ref] == true)\"><div class=section-devider ng-if=$index></div><div class=col-xs-5><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=vm.request[option.model] id=\"{{option.model}}\" name=\"{{option.model}}\" ng-change=vm.changeOption(option)> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=pull-left for=\"{{option.model}}\" ng-bind=option.checkboxLabel></label></div><div class=\"col-xs-7 light-text\" ng-bind-html=option.description></div></div></section><br><div class=\"col-xs-9 section top-buttons no-padding\"><button class=\"btn btn-primary pull-right\" ng-click=vm.save()>Сохранить</button> <button class=\"btn pull-right\" ng-click=vm.returnToPage()>Отменить</button></div></div></form></div></div>");
$templateCache.put("app/settings/bank-product-request/bank-product-request-base.html","<div class=\"crud-entity alcohol-settings main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a>Деньги</a> <span class=divider></span></li></ul><h1>Оформление онлайн заявки на получение банковского продукта</h1><form role=form name=vm.requestForm class=import-wrap><div class=\"clearfix full-width\" ng-include=\"\'app/settings/bank-product-request/steps/first-step.html\'\"></div><div class=\"clearfix full-width\" ng-if=vm.activeStep ng-include=\"\'app/settings/bank-product-request/steps/second-step.html\'\"></div><div class=\"clearfix full-width\" ng-if=\"vm.activeStep > 1\" ng-include=\"\'app/settings/bank-product-request/steps/third-step.html\'\"></div><div class=\"clearfix full-width\" ng-if=\"vm.activeStep > 2\" ng-include=\"\'app/settings/bank-product-request/steps/forth-step.html\'\"></div><div class=\"clearfix full-width\" ng-if=\"vm.activeStep > 3\" ng-include=\"\'app/settings/bank-product-request/steps/fifth-step.html\'\"></div><div style=\"display: none;\" only-popup-edit=true triggers=vm.personFakeTriggers person-data-input form-model=vm.fakePerson name-and-id=name field-label=\"\'\'\"></div></form><div class=\"section bottom-buttons col-xs-12\"><button class=\"btn btn-ico-wrap\" ng-click=vm.back(); ng-show=\"vm.activeStep && vm.activeStep !== 5\"><span class=\"btn-ico btn-arrow\"></span>Назад</button> <a class=\"btn btn-default\" ui-sref=\"bankProductRequests({parent: \'money\'})\" ng-if=\"vm.activeStep == 0\">Перейти ко всем заявкам</a> <button class=\"btn pull-right\" ng-class=\"{\'btn-primary\': vm.activeStep == 3}\" ng-disabled=\"!vm.requestForm.$valid || (!vm.bankProducts.length && !vm.activeStep)\" ng-click=\"!vm.requestForm.$valid ? null : vm.nextStep() \">{{vm.activeStep == 3 ? \"Подтверждаю, отправить\" : vm.activeStep == 5 ? \"К списку заявок\": \"Далее\"}}</button></div></div>");
$templateCache.put("app/settings/beneficiary/beneficiaries.html","<div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a ui-sref=business>Структура бизнеса</a></li></ul><div><h1>Бенефициары</h1></div><div class=grid-buttons ng-if=\"$root.hasRole(\'beneficiary.write\')\"><a ui-sref=\"beneficiary.new({parent: \'business\'})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': vm.loadData && vm.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Бенефициар</a></div></div><div class=\"beneficiary main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"><form class=\"search-entity col-xs-6\" role=search ng-submit=vm.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=vm.getPage() class=\"form-control label-clear-button\" ng-model=vm.searchText placeholder=\"Поиск по фамилии, имени, отчеству\"> <button class=\"btn slim-button search-btn\" ng-click=vm.search()>Поиск</button></div></form><div class=btn-group style=\"display: none;\"><button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><span class=\"glyphicon glyphicon-share\"></span> Выгрузить <span class=caret></span></button><ul class=dropdown-menu role=menu><li><a href=#>Действие</a></li><li><a href=#>Другое действие</a></li><li><a href=#>Что-то иное</a></li><li class=divider></li><li><a href=#>Отдельная ссылка</a></li></ul></div><div class=\"filter-settings-block text-right pull-right\"><button type=button class=\"btn toggle-filter\" ng-click=vm.turnShowFilter();>Фильтр</button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=vm.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=vm.gridFilter.getSavedFiltersNames().length><span class=ico></span>Сохраненные фильтры</div><div class=\"form-group input-group search search-entity\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"(vm.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control ng-model=vm.savedFilterListSearchText placeholder=Найти></div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=vm.configScrollFilter><div class=content><div ng-repeat=\"filterName in vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText\" ng-click=vm.chooseFilter(filterName)><span ng-bind-html=\"filterName | highlight: vm.savedFilterListSearchText\"></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"vm.removeFilter(filterName, $event)\"></span></div></div></div><div class=no-saved-filters ng-show=!vm.gridFilter.getSavedFiltersNames().length>Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров<div class=no-saved-filters-ico></div></div><p class=\"info no-find-filters\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length && !(vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p></div></div></div><div class=save-filter-star ng-class=\"vm.filterSaved ? \'gold-star dropdown\' : \'white-star\'\"><span ng-if=!vm.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" ng-click=vm.showSaveFilterPopup(); tooltip-placement=bottom-left uib-tooltip=\"Сохранить фильтр\"></span> <span ng-if=vm.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"{{\'Фильтр «\' + vm.savedFilterName + \'»\'}}\"></span></div><div class=\"filter-not-found beneficiary major-font\" ng-if=\"!vm.beneficiaries.length && vm.loadData\"><div class=big-danger-info-ico ng-if=!vm.noData></div><div class=big-danger-info ng-if=!vm.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=vm.noData>Нет данных</div></div><grid-loader show=vm.crudState.loading ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"></grid-loader><div class=grid ui-grid=vm.gridOptions ui-grid-edit ui-grid-cellnav></div><div class=table-footer><paging page-info=vm.paging callback=vm.getPage></paging></div><all-filter filter-meta=vm.filterMeta apply-filter=vm.applyFilter filter-data=vm.popupFilter clean-filter=vm.cleanFilter></all-filter>");
$templateCache.put("app/settings/business/business.html","<div class=\"settings business crud-entity\"><!-- content of settings --><div class=\"main-left-offset main-right-offset\"><div class=row><div class=\"bar col-md-4 major-font\" ng-include=\"\'app/settings/business/sections/bar.html\'\"></div><div class=col-md-8><div class=\"full-width clearfix\"><div class=\"company-info full-width\" ng-if=vm.companies.length ng-include=\"\'app/settings/business/sections/companyInfo.html\'\"></div></div><div class=\"full-width clearfix\" ng-if=\"$root.hasRole(\'user.read\')\"><h5 class=section-header>Сотрудники</h5><section class=\"employee-info full-width\" ng-if=vm.employeesTotal ng-include=\"\'app/settings/business/sections/employeesInfo.html\'\"></section></div><div class=\"full-width clearfix\" ng-if=\"$root.hasRole(\'user.create_fast_cashier\')\"><h5 class=section-header>БЫСТРОЕ ДОБАВЛЕНИЕ КАССИРА</h5><section class=\"add-cashier full-width\" ng-include=\"\'app/settings/business/sections/addCashier.html\'\"></section></div></div></div></div></div>");
$templateCache.put("app/settings/cashbox-encashments/cashbox-encashment.html","<ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"$root.$state.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!$root.$state.params.parent><a>Деньги</a></li><li ng-if=!$root.$state.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li><li ng-if=$root.$state.params.parent><a ui-sref=\"encashments({parent: $root.$state.params.parent || \'retail\'})\">Выемки</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/cashbox-encashments/cashbox-encashments.html","<div class=settings-entities><ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"ctrl.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!ctrl.params.parent><a>Деньги</a></li><li ng-if=!ctrl.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li></ul><grid-wide url=ctrl.url page=ctrl.page header=ctrl.header no-data-str=ctrl.noDataStr filters-required=true row-route-func=ctrl.rowRouteFunc sort=ctrl.sort limit=ctrl.limit column-defs=ctrl.columnDefs using-service=ctrl.usingService filter-meta=ctrl.filterMeta currency=ctrl.currency last-sync=true></grid-wide></div>");
$templateCache.put("app/settings/cashbox-replenishments/cashbox-replenishment.html","<ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"$root.$state.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!$root.$state.params.parent><a>Деньги</a></li><li ng-if=!$root.$state.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li><li ng-if=$root.$state.params.parent><a ui-sref=\"cashboxreplenishments({parent: $root.$state.params.parent || \'retail\'})\">Внесения</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/cashbox-replenishments/cashbox-replenishments.html","<div class=settings-entities><ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"ctrl.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!ctrl.params.parent><a>Деньги</a></li><li ng-if=!ctrl.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li></ul><grid-wide url=ctrl.url page=ctrl.page header=ctrl.header no-data-str=ctrl.noDataStr filters-required=true row-route-func=ctrl.rowRouteFunc base-columns-count=3 default-position=4 sort=ctrl.sort limit=ctrl.limit column-defs=ctrl.columnDefs using-service=ctrl.usingService filter-meta=ctrl.filterMeta currency=ctrl.currency last-sync=true></grid-wide></div>");
$templateCache.put("app/settings/cashregister-receipts/cashregister-receipt.html","<ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"$root.$state.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!$root.$state.params.parent><a>Деньги</a></li><li ng-if=!$root.$state.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li><li ng-if=$root.$state.params.parent><a ui-sref=\"cashregreceipts({parent: $root.$state.params.parent || \'retail\'})\">Кассовые чеки</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/cashregister-receipts/cashregister-receipts.html","<div class=settings-entities><ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"ctrl.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!ctrl.params.parent><a>Деньги</a></li><li ng-if=!ctrl.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li></ul><grid-wide url=ctrl.url page=ctrl.page header=ctrl.header no-data-str=ctrl.noDataStr filters-required=true row-route-func=ctrl.rowRouteFunc base-columns-count=3 default-position=4 sort=ctrl.sort limit=ctrl.limit currency=ctrl.currency column-defs=ctrl.columnDefs using-service=ctrl.usingService filter-meta=ctrl.filterMeta last-sync=true></grid-wide></div>");
$templateCache.put("app/settings/cashregistes-shifts/cashregister-shift.html","<ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"$root.$state.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!$root.$state.params.parent><a>Деньги</a></li><li ng-if=!$root.$state.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li><li ng-if=!$root.$state.params.parent><a ui-sref=\"cashregshifts({parent: $root.$state.params.parent || \'retail\'})\">Смены</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/cashregistes-shifts/cashregister-shifts.html","<div class=settings-entities><ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"ctrl.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!ctrl.params.parent><a>Деньги</a></li><li ng-if=!ctrl.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li></ul><grid-wide url=ctrl.url page=ctrl.page header=ctrl.header no-data-str=ctrl.noDataStr filters-required=true row-route-func=ctrl.rowRouteFunc sort=ctrl.sort limit=ctrl.limit start-page=ctrl.startPage column-defs=ctrl.columnDefs using-service=ctrl.usingService filter-meta=ctrl.filterMeta currency=ctrl.currency last-sync=true></grid-wide></div>");
$templateCache.put("app/settings/companies/companies.html","<div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a ui-sref=business>Структура бизнеса</a></li></ul><h1>Компании</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'company.write\')\"><a ui-sref=\"company.new({parent: \'business\'})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': companyCtrl.loadData && companyCtrl.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Компания</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><form class=\"search-entity col-xs-6\" role=search ng-submit=companyCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=companyCtrl.getPage() ng-model=companyCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по наименованию, ИНН, ОГРН, телефону, e-mail, типу компании, фактическому адресу и комментарию\"> <button class=\"btn slim-button search-btn\" ng-click=companyCtrl.search()>Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!companyCtrl.companies.length && companyCtrl.loadData\"><div class=big-danger-info-ico ng-if=!companyCtrl.noData></div><div class=big-danger-info ng-if=!companyCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=companyCtrl.noData>Нет данных</div></div><grid-loader show=companyCtrl.crudState.loading></grid-loader><div class=\"card-wrapper main-left-offset main-right-offset\"><div class=row><div class=col-xs-6 ng-repeat=\"company in companyCtrl.companies\"><company-card company=company></company-card></div></div></div><div class=table-footer><paging page-info=companyCtrl.paging callback=companyCtrl.getPage></div>");
$templateCache.put("app/settings/companies/company.html","<ul class=\"breadcrumbs main-left-offset\"><li><a ui-sref=business>Структура бизнеса</a></li><li><a ui-sref=\"companies({parent: \'business\'})\">Компании</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/contacts/contacts.html","<div class=contacts-wrapper><div class=contacts-box><div class=img-wrapper></div><div class=contacts-phone><span>Техническая поддержка</span> 8 (800) 511-47-14</div><div class=contacts-phone><span>Расчетный отдел</span> 8 (495) 137-57-47</div><a href=mailto:support@торговля.онлайн class=link>support@торговля.онлайн</a><br><a href=http://торговля.онлайн class=link target=_blank>http://торговля.онлайн</a><div class=contacts-description>Перед обращением в службу поддержки убедитесь, пожалуйста, что у вас под рукой есть следующая информация:<ul><li>• название вашей группы в торговля.онлайн,</li><li>• производитель и модель кассового аппарата,</li><li>• заводской номер кассового аппарата,</li><li>• версия ПО на рабочем месте кассира,</li><li>• название и версия браузера.</li></ul></div><div class=assessment>Понравилось наше приложение? - Оцените его на <a href=\"https://play.google.com/store/apps/details?id=ru.septagon.android.cashregister\">Google Play</a>!</div></div></div>");
$templateCache.put("app/settings/contracts/contract.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Деньги</a></li><li><a ui-sref=\"contracts({parent: \'money\'})\">Договоры</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/contracts/contracts.html","<div class=\"main-left-offset main-right-offset\"><ui-view></ui-view><ul class=breadcrumbs><li><a>Деньги</a></li></ul><h1>Договоры</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'contract.write\')\"><a ui-sref=\"contract.new({parent: \'money\'})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': contractsCtrl.loadData && contractsCtrl.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Договор</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"contractsCtrl.showFilter ? \'show-filter\' : \'\'\"><form class=\"search-entity col-xs-6\" role=search ng-submit=contractsCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=contractsCtrl.getPage() ng-model=contractsCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по номеру, имени компании, имени контрагента, типу договора, дате, статусу, проекту, сумме, валюте и комментарию\"> <button class=\"btn slim-button search-btn\" ng-click=contractsCtrl.search()>Поиск</button></div></form><div class=\"filter-settings-block text-right pull-right\"><button type=button class=\"btn toggle-filter\" ng-click=contractsCtrl.turnShowFilter();>Фильтр</button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=contractsCtrl.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=contractsCtrl.gridFilter.getSavedFiltersNames().length><span class=ico></span>Сохраненные фильтры</div><div class=\"form-group input-group search search-entity\" ng-show=\"contractsCtrl.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"(contractsCtrl.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control ng-model=contractsCtrl.savedFilterListSearchText placeholder=Найти></div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=contractsCtrl.configScrollFilter><div class=content><div ng-repeat=\"filterName in contractsCtrl.gridFilter.getSavedFiltersNames() | filter:contractsCtrl.savedFilterListSearchText\" ng-click=contractsCtrl.chooseFilter(filterName)><span ng-bind-html=\"filterName | highlight: contractsCtrl.savedFilterListSearchText\"></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"contractsCtrl.removeFilter(filterName, $event)\"></span></div></div></div><div class=no-saved-filters ng-show=!contractsCtrl.gridFilter.getSavedFiltersNames().length>Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров<div class=no-saved-filters-ico></div></div><p class=\"info no-find-filters\" ng-show=\"contractsCtrl.gridFilter.getSavedFiltersNames().length && !(contractsCtrl.gridFilter.getSavedFiltersNames() | filter:contractsCtrl.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p></div></div></div><div class=save-filter-star ng-class=\"contractsCtrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'\"><span ng-if=!contractsCtrl.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" ng-click=contractsCtrl.showSaveFilterPopup(); tooltip-placement=bottom-left uib-tooltip=\"Сохранить фильтр\"></span> <span ng-if=contractsCtrl.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"{{\'Фильтр «\' + contractsCtrl.savedFilterName + \'»\'}}\"></span></div><div class=\"dropdown all-filters-wrapper\"><button class=\"btn btn-default dropdown-toggle\" data-toggle=modal data-target=#filter-popup ng-click=contractsCtrl.showFilterPopup()>Все</button><div class=\"dropdown-menu pull-right\" ng-style=\"(!(contractsCtrl.filter.name || contractsCtrl.filter.fullName || contractsCtrl.filter.shortName)) && {display:none}\"><div><p class=dropdown-menu-header>Установленные фильтры</p></div><div class=content-wrapper><div class=content><div ng-if=contractsCtrl.filter.organization_id><p style=\"margin-bottom: 0\">Компания:</p><p ng-repeat=\"item in contractsCtrl.companiesArr\" ng-bind=item.label ng-if=\"item.value == contractsCtrl.filter.organization_id\"></p></div><div ng-if=contractsCtrl.filter.counterparty_id><p style=\"margin-bottom: 0\">Контрагент:</p><p ng-repeat=\"item in contractsCtrl.counterpartiesArr\" ng-bind=item.label ng-if=\"item.value == contractsCtrl.filter.counterparty_id\"></p></div><div ng-if=contractsCtrl.filter.type><p style=\"margin-bottom: 0\">Тип:</p><p ng-if=\"contractsCtrl.filter.type == \'WE_SELL\'\">Продажа</p><p ng-if=\"contractsCtrl.filter.type == \'WE_BUY\'\">Покупка</p><p ng-if=\"contractsCtrl.filter.type == \'WE_ARE_COMMITTENT\'\">Сдача на комиссию</p><p ng-if=\"contractsCtrl.filter.type == \'WE_ARE_COMMISSION_AGENT\'\">Прием на комиссию</p><p ng-if=\"contractsCtrl.filter.type == \'WE_GIVE_LOAN\'\">Выдача займа</p><p ng-if=\"contractsCtrl.filter.type == \'WE_TAKE_LOAN\'\">Получение займа</p><p ng-if=\"contractsCtrl.filter.type == \'WE_USE_ACQUIRING\'\">Эквайринг</p></div><div ng-if=contractsCtrl.filter.active><p style=\"margin-bottom: 0\">Статус:</p><p ng-if=contractsCtrl.filter.active>Действующий</p><p ng-if=!contractsCtrl.filter.active>Не действующий</p></div><div class=\"dropdown-menu-header empty-filter-info\">Фильтры не установлены</div></div></div></div></div><div class=\"filter-not-found major-font\" ng-if=\"!contractsCtrl.contracts.length && contractsCtrl.loadData\"><div class=big-danger-info-ico ng-if=!contractsCtrl.noData></div><div class=big-danger-info ng-if=!contractsCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=contractsCtrl.noData>Нет данных</div></div><grid-loader show=contractsCtrl.crudState.loading ng-class=\"contractsCtrl.showFilter ? \'show-filter\' : \'\';\"></grid-loader><!-- Представление в виде таблицы --><div class=grid ui-grid=contractsCtrl.gridOptions ui-grid-edit ui-grid-cellnav></div><div class=table-footer><paging page-info=contractsCtrl.paging callback=contractsCtrl.getPage></div><!-- Вспомогательные скрипты шаблонов --><script type=text/ng-template id=statusTemplate.html><div class=\"ui-grid-cell-contents\">\n  <div ng-if=\"COL_FIELD\">\n    <span class=\"active-status tooltip-light\" tooltip-placement=\"bottom-left\" uib-tooltip=\"Действуюший\"></span>\n  </div>\n</div></script><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=textDateTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)|date : \'dd.MM.yyyy\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=currencyTemplate.html><cell-with-tooltip text=\"(row.entity.currency)? row.entity.currency.name + \' (\' + row.entity.currency.char_iso_code+\')\':\'\'\" cell-row=\"row\" cell-col=\"col\" ng-class=\"(row.entity.currency.symbol)? \'currency-font\' : \'\'\" ></cell-with-tooltip></script><script type=text/ng-template id=amountTemplate.html><div class=\"text-right\" ng-if=\"grid.getCellValue(row, col)\">\n    <cell-with-tooltip text=\"(grid.getCellValue(row, col)| currency: \'\' : 0 ) + \' \' + row.entity.currency.symbol\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip>\n</div></script><script type=text/ng-template id=recs/select-filter-template.html><div class=\"select-wrap for-filter ui-grid-filter-container\">\n  <ui-select ng-model=\"col.filters[0].term\" search-enabled=\"false\">\n    <ui-select-match allow-clear=\"true\" placeholder=\"Выберите\" title=\"{{$select.selected.label}}\">\n      <span ng-bind=\"$select.selected.label\"></span>\n    </ui-select-match>\n    <ui-select-choices\n      repeat=\"type.value as type in col.filters[0].selectOptions\">\n      <div ng-bind=\"type.label\" title=\"{{type.label}}\"></div>\n    </ui-select-choices>\n    <ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice>\n  </ui-select>\n</div></script><all-filter filter-meta=contractsCtrl.filterMeta apply-filter=contractsCtrl.applyFilter filter-data=contractsCtrl.popupFilter clean-filter=contractsCtrl.cleanFilter></all-filter>");
$templateCache.put("app/settings/contragents/contragent.html","<ul class=\"breadcrumbs main-left-offset\" ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-default><a>Деньги</a></li><li><a ui-sref=\"contragents({parent: $state.params.parent})\">{{$state.params.parent === \'purchase\' ? \'Поставщики\' : $state.params.parent === \'sale\' ? \'Покупатели\' : \' Контрагенты\' }}</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/contragents/contragents.html","<div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs ng-switch=$state.params.parent><li ng-switch-when=purchase><a>Закупки</a></li><li ng-switch-when=sale><a>Продажи</a></li><li ng-switch-default><a>Деньги</a></li></ul><div ng-switch=$state.params.parent><h1 ng-switch-when=purchase>Поставщики</h1><h1 ng-switch-when=sale>Покупатели</h1><h1 ng-switch-default>Контрагенты</h1></div><div class=grid-buttons ng-if=\"$root.hasRole(\'counterparty.write\')\"><a ui-sref=\"contragent.new({parent: vm.parentPage})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': vm.loadData && vm.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span> <span ng-switch=$state.params.parent><span ng-switch-when=purchase>Поставщик</span> <span ng-switch-when=sale>Покупатель</span> <span ng-switch-default>Контрагент</span></span></a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"><form class=\"search-entity col-xs-6\" role=search ng-submit=vm.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=vm.getPage() class=\"form-control label-clear-button\" ng-model=vm.searchText placeholder=\"Поиск по наименованию, телефону, e-mail, руководителю, комментарию, типу контрагента, полному наименованию, сокращенному наименованию, руководителю, ОГРН, ИНН, дате создания и дате обновления\"> <button class=\"btn slim-button search-btn\" ng-click=vm.search()>Поиск</button></div></form><div class=btn-group style=\"display: none;\"><button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><span class=\"glyphicon glyphicon-share\"></span> Выгрузить <span class=caret></span></button><ul class=dropdown-menu role=menu><li><a href=#>Действие</a></li><li><a href=#>Другое действие</a></li><li><a href=#>Что-то иное</a></li><li class=divider></li><li><a href=#>Отдельная ссылка</a></li></ul></div><div class=\"filter-settings-block text-right pull-right\"><button type=button class=\"btn toggle-filter\" ng-click=vm.turnShowFilter();>Фильтр</button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=vm.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=vm.gridFilter.getSavedFiltersNames().length><span class=ico></span>Сохраненные фильтры</div><div class=\"form-group input-group search search-entity\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"(vm.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control ng-model=vm.savedFilterListSearchText placeholder=Найти></div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=vm.configScrollFilter><div class=content><div ng-repeat=\"filterName in vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText\" ng-click=vm.chooseFilter(filterName)><span ng-bind-html=\"filterName | highlight: vm.savedFilterListSearchText\"></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"vm.removeFilter(filterName, $event)\"></span></div></div></div><div class=no-saved-filters ng-show=!vm.gridFilter.getSavedFiltersNames().length>Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров<div class=no-saved-filters-ico></div></div><p class=\"info no-find-filters\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length && !(vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p></div></div></div><div class=save-filter-star ng-class=\"vm.filterSaved ? \'gold-star dropdown\' : \'white-star\'\"><span ng-if=!vm.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" ng-click=vm.showSaveFilterPopup(); tooltip-placement=bottom-left uib-tooltip=\"Сохранить фильтр\"></span> <span ng-if=vm.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"{{\'Фильтр «\' + vm.savedFilterName + \'»\'}}\"></span></div><div class=\"dropdown all-filters-wrapper\"><button class=\"btn btn-default dropdown-toggle\" data-toggle=modal data-target=#filter-popup ng-click=vm.showFilterPopup()>Все</button><div class=\"dropdown-menu pull-right\"><div><p class=dropdown-menu-header>Установленные фильтры</p></div><div class=content-wrapper><div class=content><div ng-if=vm.filter.name><p style=\"margin-bottom: 0\">Наименование:</p><p>{{vm.filter.name}}</p></div><div ng-if=vm.filter.chief_name><p style=\"margin-bottom: 0\">Руководитель:</p><p>{{vm.filter.chief_name}}</p></div><div ng-if=vm.filter.counterparty_type><p style=\"margin-bottom: 0\">Тип контрагента:</p><p ng-if=\"vm.filter.counterparty_type == \'LEGAL_ENTITY\'\">Юридическое лицо</p><p ng-if=\"vm.filter.counterparty_type == \'SOLE_TRADER\'\">Индивидуальный предприниматель</p><p ng-if=\"vm.filter.counterparty_type == \'PERSON\'\">Физическое лицо</p></div><div ng-if=vm.filter.full_name><p style=\"margin-bottom: 0\">Полное наименование:</p><p>{{vm.filter.full_name}}</p></div><div ng-if=vm.filter.short_name><p style=\"margin-bottom: 0\">Сокращенное наименование:</p><p>{{vm.filter.short_name}}</p></div><div ng-if=vm.filter.legal_address><p style=\"margin-bottom: 0\">Юридический адрес/Адрес регистрации:</p><p>{{vm.filter.legal_address}}</p></div><div ng-if=vm.filter.real_address><p style=\"margin-bottom: 0\">Фактический адрес:</p><p>{{vm.filter.real_address}}</p></div><div ng-if=vm.filter.ogrn><p style=\"margin-bottom: 0\">ОГРН:</p><p>{{vm.filter.ogrn}}</p></div><div ng-if=vm.filter.inn><p style=\"margin-bottom: 0\">ИНН:</p><p>{{vm.filter.inn}}</p></div><div ng-if=vm.filter.when_created.datePickStr><p style=\"margin-bottom: 0\">Дата создания:</p><p>{{vm.filter.when_created.datePickStr}}</p></div><div class=\"dropdown-menu-header empty-filter-info\">Фильтры не установлены</div></div></div></div></div><div class=\"filter-not-found major-font\" ng-if=\"!vm.counterparties.length && vm.loadData\"><div class=big-danger-info-ico ng-if=!vm.noData></div><div class=big-danger-info ng-if=!vm.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=vm.noData>Нет данных</div></div><grid-loader show=vm.crudState.loading ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"></grid-loader><div class=grid ui-grid=vm.gridOptions ui-grid-edit ui-grid-cellnav></div><script type=text/ng-template id=typeTemplate.html><div ng-if=\"row.entity.counterparty_type == \'LEGAL_ENTITY\'\">\n    <cell-with-tooltip text=\"\'Юридическое лицо\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip>\n  </div>\n  <div ng-if=\"row.entity.counterparty_type == \'SOLE_TRADER\'\">\n    <cell-with-tooltip text=\"\'Индивидуальный предприниматель\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip>\n  </div>\n  <div ng-if=\"row.entity.counterparty_type == \'PERSON\'\">\n    <cell-with-tooltip text=\"\'Физическое лицо\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip>\n  </div></script><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=addressTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col).address_as_string\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><!-- uncommon templates --><script type=text/ng-template id=textDateTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)| date: \'dd.MM.yyyy HH:mm\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=textEmailTemplate.html><cell-with-tooltip text=\"row.entity.$$email.value\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=textPhoneTemplate.html><cell-with-tooltip class=\"phone-cell-tooltip\" text=\"row.entity.$$phone.value\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=recs/datepicker-filter-template.html><div class=\"datepicker-wrap for-filter ui-grid-filter-container\">\n    <div ng-repeat=\"colFilter in col.filters\">\n      <div date-range-picker\n           ng-model=\"colFilter\"\n           state=\"guide.datePickState1\"\n           view-value=\"guide.dateRangePickerViewValue1\"\n           class=\"datepicker-wrap\">\n        <span class=\"glyphicon glyphicon-calendar tooltip-light\" tooltip-placement=\"bottom-left\" uib-tooltip=\"Выбрать дату\"></span>\n      </div>\n    </div>\n  </div></script><script type=text/ng-template id=recs/inputFilterTemplate.html><div class=\"select-wrap for-filter ui-grid-filter-container\">\n    <input clear-button type=\"text\" class=\"ui-grid-filter-input\" ng-model=\"col.filters[0].term\" placeholder=\"Поиск\" >\n  </div></script><script type=text/ng-template id=recs/select-filter-template.html><div class=\"select-wrap for-filter ui-grid-filter-container\">\n    <ui-select ng-model=\"col.filters[0].term\" search-enabled=\"false\">\n      <ui-select-match allow-clear=\"true\" placeholder=\"Выберите\" title=\"{{$select.selected.label}}\">\n        <span ng-bind=\"$select.selected.label\"></span>\n      </ui-select-match>\n      <ui-select-choices\n        repeat=\"type.value as type in col.filters[0].selectOptions\">\n        <div ng-bind=\"type.label\" title=\"{{type.label}}\"></div>\n      </ui-select-choices>\n      <ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice>\n    </ui-select>\n  </div></script><!-- uncommon templates end --><div class=table-footer><paging page-info=vm.paging callback=vm.getPage></div><all-filter filter-meta=vm.filterMeta apply-filter=vm.applyFilter filter-data=vm.popupFilter clean-filter=vm.cleanFilter></all-filter>");
$templateCache.put("app/settings/currencies/crudCurrencies.html","<div class=modal-crud-currencies id=crud-currencies ng-form=currenciesForm role=dialog><div class=modal-header ng-class=\"{\'blur-bg\': showRemove}\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>&times;</button><h3 class=modal-title ng-if=\"popupMode == \'add\'\">Добавление валюты</h3><h3 class=modal-title ng-if=\"popupMode == \'edit\'\">Редактирование валюты</h3><p class=modal-description ng-if=\"popupMode == \'add\'\">Вы можете использовать несколько валют для<br>взаиморасчета в&nbsp;ситеме</p></div><div class=container ng-class=\"{\'blur-bg\': showRemove}\"><div class=form-group><ui-select ng-if=\"popupMode == \'add\'\" on-select=changeSelect($select.selected) ng-model=selectedCurr search-enabled=\"systemCurrencies.length > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-disabled=!systemCurrencies.length ng-class=\"{\'autocomplete-select\': (systemCurrencies | filter: $select.search ).length > $root.controlSettings.OPTION_DEFAULT_LENGTH}\" ng-required=true name=currencyName><ui-select-match><span ng-bind=$select.selected.name></span> <span>{{($select.selected.last_central_bank_rate.denominator > 1)? $select.selected.last_central_bank_rate.denominator + \' \' : \'\'}} {{$select.selected.char_iso_code }}</span></ui-select-match><ui-select-choices repeat=\"systemCurrency in (systemCurrencies | filter: $select.search ) | limitTo : $root.controlSettings.OPTION_DEFAULT_LENGTH track by $index\" group-by=\"totalStr((systemCurrencies | filter: $select.search ).length)\"><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"systemCurrency.name | highlight: $select.search\"></span> <span class=pull-right ng-bind-html=\"(((systemCurrency.last_central_bank_rate.denominator > 1)? systemCurrency.last_central_bank_rate.denominator : \'\') + \' \' + systemCurrency.char_iso_code)| highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label ng-if=\"popupMode == \'add\'\" class=\"form-control-label small-offset\">Новая валюта</label><div class=\"valid-message required-mess\" style=\"width: auto;\">Поле является обязательным</div><span class=req style=\"right: -12px;\"></span><div class=form-control ng-if=\"popupMode == \'edit\'\" disabled><div class=list-row><span ng-bind=selectedCurr.name></span> (<span>{{(selectedCurr.last_central_bank_rate.denominator > 1)? selectedCurr.last_central_bank_rate.denominator + \' \' : \'\'}}{{selectedCurr.char_iso_code}}</span>)</div></div></div><div class=course-table ng-class=\"(selectedCurr.char_iso_code == \'RUB\')? \'\' : \'curency-not-rub\'\"><div class=course-table-row ng-show=\"selectedCurr.char_iso_code !== \'RUB\'\"><div class=course-table-cel><div class=table-cel-label>КУРС ЦБ</div><div class=digit><span ng-if=!selectedCurr.last_central_bank_rate.rate style=\"visibility: hidden\">₽</span> <span style=\"color: #ccc;\">{{selectedCurr.last_central_bank_rate.rate | rounding : 2 | fractNum}} <span class=curr-ico ng-if=selectedCurr.last_central_bank_rate.rate>₽</span></span><div class=tip-bottom ng-if=selectedCurr.last_central_bank_rate.rate>Курс ЦБ на {{selectedCurr.last_central_bank_rate.on_date | date : \"dd.MM.yyyy\"}}: {{selectedCurr.last_central_bank_rate.rate | fractNum}} <span class=curr-ico>₽</span></div></div></div><div class=course-table-cel><div class=table-cel-label>Я ПРОДАЮ</div><div class=digit> {{calculateSale | rounding : 2 | fractNum}} <span class=curr-ico ng-if=selectedCurr.last_central_bank_rate.rate>₽</span><div class=tip-bottom> {{calculateSale | rounding : 4 | fractNum}} <span class=curr-ico ng-if=selectedCurr.last_central_bank_rate.rate>₽</span></div></div></div><div class=course-table-cel><div class=table-cel-label>Я ПОКУПАЮ</div><div class=digit> {{calculatePurchase | rounding : 2 | fractNum}} <span class=curr-ico ng-if=selectedCurr.last_central_bank_rate.rate>₽</span><div class=tip-bottom> {{calculatePurchase | rounding : 4 | fractNum}} <span class=curr-ico ng-if=selectedCurr.last_central_bank_rate.rate>₽</span></div></div></div></div><div class=label-markup ng-show=\"selectedCurr.char_iso_code !== \'RUB\'\">Наценка</div><div class=course-table-row2 ng-show=\"selectedCurr.char_iso_code !== \'RUB\'\"><div class=course-table-cel><ui-select ng-model=rate.signSaleRate on-select=\"calcSale(selectedCurr.last_central_bank_rate.rate, saleRate, rate.signSaleRate)\"><ui-select-match><span ng-bind=$select.selected></span></ui-select-match><ui-select-choices repeat=\"rate in [\'+\', \'-\'] track by $index\"><span ng-bind=rate></span></ui-select-choices></ui-select><div class=\"form-group percentage\"><input type=text float-input class=\"form-control currency-input\" float-fixed=2 float-step=0.01 max-after-comma=2 max-int-length=3 max-val=100 currency-input ng-model=saleRate no-empty=::true ng-blur=\"calculateSale = calc(selectedCurr.last_central_bank_rate.rate, saleRate, rate.signSaleRate)\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div><span class=currency-font style=\"margin-top: 5px; display: inline-block\">%</span></div><div class=course-table-cel><ui-select ng-model=rate.signPurchaseRate on-select=\"calcPurchase(selectedCurr.last_central_bank_rate.rate, purchaseRate, rate.signPurchaseRate)\"><ui-select-match><span ng-bind=$select.selected></span></ui-select-match><ui-select-choices repeat=\"rate in [\'+\', \'-\'] track by $index\"><span ng-bind=rate></span></ui-select-choices></ui-select><div class=\"form-group percentage\"><input type=text float-input class=\"form-control currency-input\" float-fixed=2 float-step=0.01 max-after-comma=2 max-int-length=3 max-val=100 currency-input no-empty=::true ng-model=purchaseRate no-empty=::true ng-blur=\"calculatePurchase = calc(selectedCurr.last_central_bank_rate.rate, purchaseRate, rate.signPurchaseRate)\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div><span class=currency-font style=\"margin-top: 5px; display: inline-block\">%</span></div></div></div><div class=check-wrapper ng-hide=\"popupMode == \'edit\' && hideCheck\" ng-class=\"(!canChangeCurrency)? \'disabled-check\' : \'\'\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=homeCurrency id=accounting-currency ng-disabled=!canChangeCurrency> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=accounting-currency class=checkbox-label>Сделать валютой учета</label><div class=tip-top ng-hide=canChangeCurrency>Смена валюты учета невозможна, так как есть проведенные документы</div></div></div><div class=modal-footer><span class=req-inform ng-show=\"isSaved && currenciesForm.currencyName.$invalid\" style=\"float: left;\">Поля, помеченные *, обязательные для заполнения </span><button type=button class=\"btn pull-left btn-ico-wrap\" ng-if=\"popupMode == \'edit\' && !hideCheck\" ng-click=removeToggle()><span class=\"btn-ico glyphicon glyphicon-trash\"></span>Удалить</button> <button class=btn role=button ng-click=close()>Отменить</button> <button type=submit class=\"btn btn-primary\" role=button ng-click=create() ng-if=\"popupMode == \'add\'\" ng-disabled=\"isSaved && currenciesForm.currencyName.$invalid\">Создать</button> <button type=submit class=\"btn btn-primary\" role=button ng-click=save() ng-if=\"popupMode == \'edit\'\">Сохранить</button></div><!-- popup for remove account --><div class=remove-box ng-show=showRemove><div><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=alert aria-hidden=true ng-click=removeToggle()>×</button><div class=remove-box-title>Удаление</div></div><p>Вы действительно хотите удалить валюту?</p><div class=footer-buttons><button type=button ng-click=\"removeToggle(); deleteCurrencies(removeCurrency)\" class=\"btn btn-primary\">Да</button> <button type=button ng-click=removeToggle(); class=btn>Нет</button></div></div><!-- popup --></div>");
$templateCache.put("app/settings/currencies/currencies.html","<div class=\"main-left-offset main-right-offset currency-page\" ng-init=vm.getDomainCurrency()><ui-view></ui-view><ul class=breadcrumbs><li><a ui-sref=money>Деньги</a></li></ul><h1>Валюты</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'currency.write\')\"><div ui-sref=\"currencies({parent: \'money\'})\" class=\"btn add-entity\" ng-click=\"vm.crudCurrency(\'add\');\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Валюта</div></div><div class=gray-label ng-if=false>Вы можете легко и просто<br>полюбить нашу систему</div><div class=currency ng-show=vm.crudState.loading><div class=ui-spinner style=\"position: relative; top: 35px;\"></div></div><div ng-if=vm.currentCurrencies.currency><div class=section-header><div class=star-icon></div>Валюта учета</div><div class=currency><div class=currency-descr><span class=currency-ico>{{vm.currentCurrencies.currency.symbol}}</span><span class=currency-name-wrapper><div class=currency-name>{{vm.currentCurrencies.currency.name}}</div><div class=currency-short-name> {{(vm.currentCurrencies.last_central_bank_rate.denominator > 1)? vm.currentCurrencies.last_central_bank_rate.denominator + \' \' + vm.currentCurrencies.currency.char_iso_code : vm.currentCurrencies.currency.char_iso_code}} </div></span></div><div class=cb-value ng-if=\"vm.currentCurrencies.currency.char_iso_code != \'RUB\'\"> {{vm.currentCurrencies.last_central_bank_rate.rate | rounding : 2 | fractNum }} <div class=tip-bottom>Курс ЦБ на {{vm.currentCurrencies.last_central_bank_rate.on_date | date : \"dd.MM.yyyy\"}}: {{vm.currentCurrencies.last_central_bank_rate.rate | fractNum }} P</div></div><div class=selling ng-if=\"vm.currentCurrencies.currency.char_iso_code != \'RUB\'\"> {{vm.calculateFormula(vm.currentCurrencies.last_central_bank_rate.rate, vm.currentCurrencies.sell_rate) | rounding : 2 | fractNum }} <div class=tip-bottom>{{vm.calculateFormula(vm.currentCurrencies.last_central_bank_rate.rate, vm.currentCurrencies.sell_rate) | fractNum }} P</div><div class=percentage> {{(vm.currentCurrencies.sell_rate < 0)? vm.currentCurrencies.sell_rate : \'+\' + vm.currentCurrencies.sell_rate | fractNum}}%</div></div><div class=buy ng-if=\"vm.currentCurrencies.currency.char_iso_code != \'RUB\'\"> {{vm.calculateFormula(vm.currentCurrencies.last_central_bank_rate.rate, vm.currentCurrencies.buy_rate) | rounding : 2 | fractNum}} <div class=tip-bottom>{{vm.calculateFormula(vm.currentCurrencies.last_central_bank_rate.rate, vm.currentCurrencies.buy_rate) | fractNum}} P</div><div class=percentage ng-class=\"{minus: vm.currentCurrencies.buy_rate < 0}\"> {{(vm.currentCurrencies.buy_rate < 0)? vm.currentCurrencies.buy_rate : \'+\' + vm.currentCurrencies.buy_rate | fractNum}}%</div></div><a ng-if=\"$root.hasRole(\'currency.write\')\" ui-sref=\"currencies({parent: \'money\'})\" class=\"edit-pencil tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Редактировать ng-click=\"vm.crudCurrency(\'edit\', vm.currentCurrencies);\"></a></div></div><ul class=table-currencies ng-if=vm.currencies.length><li class=head-table-currencies><div class=cb-value>ЦБ</div><div class=selling>Я ПРОДАЮ</div><div class=buy>Я ПОКУПАЮ</div></li><li class=currency ng-repeat=\"item in vm.currencies\"><div class=currency-descr><span class=currency-ico>{{item.currency.symbol}}</span><span class=currency-name-wrapper><div class=currency-name>{{item.currency.name}}</div><div class=currency-short-name> {{(item.last_central_bank_rate.denominator > 1)? item.last_central_bank_rate.denominator + \' \' + item.currency.char_iso_code : item.currency.char_iso_code}} </div></span></div><div class=cb-value ng-if=\"item.currency.char_iso_code != \'RUB\'\"> {{item.last_central_bank_rate.rate | rounding : 2 | fractNum }} <div class=tip-bottom>Курс ЦБ на {{item.last_central_bank_rate.on_date | date : \"dd.MM.yyyy\"}}: {{item.last_central_bank_rate.rate | fractNum }} <span class=curr-ico>₽</span></div></div><div class=selling ng-if=\"item.currency.char_iso_code != \'RUB\'\"> {{vm.calculateFormula(item.last_central_bank_rate.rate, item.sell_rate) | rounding : 2 | fractNum }} <div class=tip-bottom>{{vm.calculateFormula(item.last_central_bank_rate.rate, item.sell_rate) | fractNum }} <span class=curr-ico>₽</span></div><div class=percentage> {{(item.sell_rate < 0)? item.sell_rate : \'+\' + item.sell_rate | fractNum}}%</div></div><div class=buy ng-if=\"item.currency.char_iso_code != \'RUB\'\"> {{vm.calculateFormula(item.last_central_bank_rate.rate, item.buy_rate) | rounding : 2 | fractNum}} <div class=tip-bottom>{{vm.calculateFormula(item.last_central_bank_rate.rate, item.buy_rate) | fractNum}} <span class=curr-ico>₽</span></div><div class=percentage> {{(item.buy_rate < 0)? item.buy_rate : \'+\' + item.buy_rate | fractNum}}%</div></div><a ng-if=\"$root.hasRole(\'currency.write\')\" ui-sref=\"currencies({parent: \'money\'})\" class=\"edit-pencil tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Редактировать ng-click=\"vm.crudCurrency(\'edit\', item);\"></a></li></ul></div>");
$templateCache.put("app/settings/discounts/discount-wide.html","<div class=settings-entities><ul class=\"breadcrumbs main-left-offset\"><li><a>Розница</a></li></ul><grid-wide url=ctrl.url page=ctrl.page header=ctrl.header filters-required=true row-route=ctrl.rowRoute sort=ctrl.sort limit=ctrl.limit is-sku=false column-defs=ctrl.columnDefs using-service=ctrl.usingService filter-meta=ctrl.filterMeta grid-button-config=ctrl.gridButtonConfig currency=ctrl.currency></grid-wide></div><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=boolTemplate.html><div class=\"ui-grid-cell-contents\" ng-bind=\"(grid.getCellValue(row, col))? \'Да\' : \'Нет\'\"></div></script><script type=text/ng-template id=textDateTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)| date: \'dd.MM.yyyy\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=recs/datepicker-filter-template.html><div class=\"datepicker-wrap for-filter ui-grid-filter-container\">\n    <div ng-repeat=\"colFilter in col.filters\">\n      <div date-range-picker\n           ng-model=\"colFilter\"\n           state=\"guide.datePickState1\"\n           view-value=\"guide.dateRangePickerViewValue1\"\n           class=\"datepicker-wrap\">\n      </div>\n    </div>\n  </div></script><script type=text/ng-template id=recs/select-filter-template.html><div class=\"select-wrap for-filter ui-grid-filter-container\">\n    <ui-select ng-model=\"col.filters[0].term\" search-enabled=\"false\">\n      <ui-select-match allow-clear=\"true\" placeholder=\"Выберите\" title=\"{{$select.selected.label}}\">\n        <span ng-bind=\"$select.selected.label\"></span>\n      </ui-select-match>\n      <ui-select-choices\n        repeat=\"type.value as type in col.filters[0].selectOptions\">\n        <div ng-bind=\"type.label\" title=\"{{type.label}}\"></div>\n      </ui-select-choices>\n      <ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice>\n    </ui-select>\n  </div></script>");
$templateCache.put("app/settings/discounts/discount.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>РОЗНИЦА</a></li><li><a ui-sref=\"discounts({parent: \'retail\'})\">Скидочные акции</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/discounts/discounts.html","<div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a>РОЗНИЦА</a></li></ul><h1>Скидочные акции</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'retail_discount.write\')\"><a ui-sref=\"discount.new({parent: \'retail\'})\" class=btn ng-class=\"{\'btn-primary\': vm.loadData && vm.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Скидочная акция</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"><form class=\"search-entity col-xs-6\" role=search ng-submit=vm.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=vm.getPage() class=\"form-control label-clear-button\" ng-model=vm.searchText placeholder=\"Поиск по наименованию\"> <button class=\"btn slim-button search-btn\" ng-click=vm.search()>Поиск</button></div></form><!--<div class=\"filter-settings-block text-right pull-right\">--><!--<button type=\"button\" class=\"btn toggle-filter\" ng-click=\"vm.turnShowFilter();\">Фильтр</button>--><!--<button type=\"button\" class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=\"bottom-left\" uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=\"dropdown\" tabindex=\"-1\" ng-click=\"vm.prepareSavedFiltersList()\">--><!--<span class=\"caret\"></span>--><!--<span class=\"sr-only\"></span>--><!--</button>--><!--<div class=\"dropdown-menu pull-right\" role=\"menu\">--><!--<div class=\"filters-list-title major-font\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length\"><span class=\"ico\"></span>Сохраненные фильтры</div>--><!--<div class=\"form-group input-group search search-entity\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"(vm.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\">--><!--<span class=\"input-group-addon\"><span class=\"glyphicon glyphicon-search\"></span></span>--><!--<input type=\"text\" class=\"form-control\" ng-model=\"vm.savedFilterListSearchText\" placeholder=\"Найти\">--><!--</div>--><!--<div class=\"content-wrapper\" ng-scrollbars ng-scrollbars-config=\"vm.configScrollFilter\">--><!--<div class=\"content\">--><!--<div ng-repeat=\"filterName in vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText\" ng-click=\"vm.chooseFilter(filterName)\">--><!--<span ng-bind-html=\"filterName | highlight: vm.savedFilterListSearchText\"></span>--><!--<span class=\"glyphicon glyphicon-trash\" ng-click=\"vm.removeFilter(filterName, $event)\"></span>--><!--</div>--><!--</div>--><!--</div>--><!--<div class=\"no-saved-filters\" ng-show=\"!vm.gridFilter.getSavedFiltersNames().length\">Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров <div class=\"no-saved-filters-ico\"></div></div>--><!--<p class=\"info no-find-filters\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length && !(vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p>--><!--</div>--><!--</div>--></div><div class=save-filter-star ng-class=\"vm.filterSaved ? \'gold-star dropdown\' : \'white-star\'\"><span ng-if=!vm.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" ng-click=vm.showSaveFilterPopup(); tooltip-placement=bottom-left uib-tooltip=\"Сохранить фильтр\"></span> <span ng-if=vm.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"{{\'Фильтр «\' + vm.savedFilterName + \'»\'}}\"></span></div><div class=\"dropdown all-filters-wrapper\"><button class=\"btn btn-default dropdown-toggle\" data-toggle=modal data-target=#filter-popup ng-click=vm.showFilterPopup()>Все</button><div class=\"dropdown-menu pull-right\"><div><p class=dropdown-menu-header>Установленные фильтры</p></div><div class=content-wrapper><div class=content><div ng-if=vm.filter.effectiveDate.datePickStr><p style=\"margin-bottom: 0\">Дата начала:</p><p>{{vm.filter.effectiveDate.datePickStr}}</p></div><div ng-if=vm.filter.expireDate.datePickStr><p style=\"margin-bottom: 0\">Дата окончания:</p><p>{{vm.filter.expireDate.datePickStr}}</p></div><div class=\"dropdown-menu-header empty-filter-info\">Фильтры не установлены</div></div></div></div></div><div class=\"filter-not-found major-font\" ng-if=\"!vm.discounts.length && vm.loadData\"><div class=big-danger-info-ico ng-if=!vm.noData></div><div class=big-danger-info ng-if=!vm.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=vm.noData>Нет данных</div></div><grid-loader show=vm.crudState.loading ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"></grid-loader><div class=grid ui-grid=vm.gridOptions ui-grid-edit ui-grid-resize-columns ui-grid-cellnav ng-if=!vm.noDiscounts></div><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=boolTemplate.html><div class=\"ui-grid-cell-contents\" ng-bind=\"(grid.getCellValue(row, col))? \'Да\' : \'Нет\'\"></div></script><script type=text/ng-template id=textDateTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col) | date: \'dd.MM.yyyy\' : \'UTC\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=recs/datepicker-filter-template.html><div class=\"datepicker-wrap for-filter ui-grid-filter-container\">\n    <div ng-repeat=\"colFilter in col.filters\">\n      <div date-range-picker\n           ng-model=\"colFilter\"\n           state=\"guide.datePickState1\"\n           view-value=\"guide.dateRangePickerViewValue1\"\n           class=\"datepicker-wrap\">\n      </div>\n    </div>\n  </div></script><script type=text/ng-template id=recs/select-filter-template.html><div class=\"select-wrap for-filter ui-grid-filter-container hi\">\n    <ui-select ng-model=\"col.filters[0].term\" search-enabled=\"false\" append-to-body=\"true\" class=\"filter-select\">\n      <ui-select-match allow-clear=\"true\" placeholder=\"Выберите\" title=\"{{$select.selected.label}}\">\n        <span ng-bind=\"$select.selected.label\"></span>\n      </ui-select-match>\n      <ui-select-choices\n        repeat=\"type.value as type in col.filters[0].selectOptions\">\n        <div ng-bind=\"type.label\" title=\"{{type.label}}\"></div>\n      </ui-select-choices>\n    </ui-select>\n  </div></script><!-- uncommon templates end --><div class=table-footer><paging page-info=vm.paging callback=vm.getPage></div><all-filter filter-meta=vm.filterMeta apply-filter=vm.applyFilter filter-data=vm.popupFilter clean-filter=vm.cleanFilter></all-filter>");
$templateCache.put("app/settings/divisions/division.html","<ul class=\"breadcrumbs main-left-offset\"><li><a ui-sref=business>Структура бизнеса</a></li><li><a ui-sref=\"divisions({parent: \'business\'})\">Подразделения</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/divisions/divisions.html","<div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a ui-sref=business>Структура бизнеса</a></li></ul><h1>Подразделения</h1><div class=grid-buttons><a ui-sref=\"division.new({parent: \'business\'})\" class=\"btn add-entity\" ng-if=\"$root.hasRole(\'division.write\')\" ng-class=\"{\'btn-primary\': divisionCtrl.loadData && divisionCtrl.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Подразделение</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"divisionCtrl.showFilter ? \'show-filter\' : \'\';\"><form class=\"search-entity col-xs-6\" role=search ng-submit=divisionCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=divisionCtrl.getPage() ng-model=divisionCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по имени компании, типу подразделения, наименованию, адресу и ККМ\"> <button class=\"btn slim-button search-btn\" ng-click=divisionCtrl.search()>Поиск</button></div></form><div class=\"filter-settings-block text-right pull-right\"><button type=button class=\"btn toggle-filter\" ng-click=divisionCtrl.turnShowFilter();>Фильтр</button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=divisionCtrl.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=divisionCtrl.gridFilter.getSavedFiltersNames().length><span class=ico></span>Сохраненные фильтры</div><div class=\"form-group input-group search search-entity\" ng-show=\"divisionCtrl.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"(divisionCtrl.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control ng-model=divisionCtrl.savedFilterListSearchText placeholder=Найти></div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=divisionCtrl.configScrollFilter><div class=content><div ng-repeat=\"filterName in divisionCtrl.gridFilter.getSavedFiltersNames() | filter:divisionCtrl.savedFilterListSearchText\" ng-click=divisionCtrl.chooseFilter(filterName)><span ng-bind-html=\"filterName | highlight: divisionCtrl.savedFilterListSearchText\"></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"divisionCtrl.removeFilter(filterName, $event)\"></span></div></div></div><div class=no-saved-filters ng-show=!divisionCtrl.gridFilter.getSavedFiltersNames().length>Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров<div class=no-saved-filters-ico></div></div><p class=\"info no-find-filters\" ng-show=\"divisionCtrl.gridFilter.getSavedFiltersNames().length && !(divisionCtrl.gridFilter.getSavedFiltersNames() | filter:divisionCtrl.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p></div></div></div><div class=\"save-filter-star tooltip-light\" ng-class=\"divisionCtrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'\" tooltip-placement=bottom-left uib-tooltip=\"{{(divisionCtrl.filterSaved)? \'Фильтр «\' + divisionCtrl.tmpFilterName + \'»\' : \'Сохранить фильтр\'}}\"><span ng-if=!divisionCtrl.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle\" ng-click=divisionCtrl.showSaveFilterPopup();></span> <span ng-if=divisionCtrl.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle\"></span></div><div class=\"dropdown all-filters-wrapper\"><button class=\"btn btn-default dropdown-toggle\" data-toggle=modal data-target=#filter-popup ng-click=divisionCtrl.showFilterPopup()>Все</button><div class=\"dropdown-menu pull-right\" ng-style=\"(!(divisionCtrl.filter.name || divisionCtrl.filter.fullName || divisionCtrl.filter.shortName)) && {display:none}\"><div><p class=dropdown-menu-header>Установленные фильтры</p></div><div class=content-wrapper><div class=content><div ng-if=divisionCtrl.filter.company_id><p style=\"margin-bottom: 0\">Компания:</p><p ng-repeat=\"item in divisionCtrl.companiesArr\" ng-bind=item.label ng-if=\"item.value == divisionCtrl.filter.company_id\"></p></div><div ng-if=divisionCtrl.filter.type><p style=\"margin-bottom: 0\">Тип:</p><p ng-if=\"divisionCtrl.filter.type == \'OFFICE\'\">Офис</p><p ng-if=\"divisionCtrl.filter.type == \'SHOP\'\">Магазин</p><p ng-if=\"divisionCtrl.filter.type == \'STOREHOUSE\'\">Склад</p></div><div class=\"dropdown-menu-header empty-filter-info\">Фильтры не установлены</div></div></div></div></div><div class=clear></div><div class=\"filter-not-found major-font\" ng-if=\"!divisionCtrl.divisions.length && divisionCtrl.loadData\"><div class=big-danger-info-ico ng-if=!divisionCtrl.noData></div><div class=big-danger-info ng-if=!divisionCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=divisionCtrl.noData>Нет данных</div></div><grid-loader show=!divisionCtrl.loadData ng-class=\"divisionCtrl.showFilter ? \'show-filter\' : \'\';\"></grid-loader><div class=grid ui-grid=divisionCtrl.gridOptions ui-grid-edit></div><script type=text/ng-template id=typeTemplate.html><div class=\"ui-grid-cell-contents\" style=\"padding-top: 14px;\">\n    <div ng-if=\"row.entity.type == \'OFFICE\'\">\n      <span class=\"office-ico\"></span> Офис\n    </div>\n    <div ng-if=\"row.entity.type == \'SHOP\'\">\n      <span class=\"shop-ico\"></span> Магазин\n    </div>\n    <div ng-if=\"row.entity.type == \'STOREHOUSE\'\">\n      <span class=\"warehouse-ico\"></span> Склад\n    </div>\n  </div></script><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=addressTemplate.html><cell-with-tooltip text=\"row.entity.address.address_as_string\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=cashTemplate.html><cell-transfer row-entity=\"row.entity\" on-transfer=\"grid.appScope.divisionCtrl.getPage()\"></cell-transfer></script><script type=text/ng-template id=recs/select-filter-template.html><div class=\"select-wrap for-filter ui-grid-filter-container\">\n    <ui-select ng-model=\"col.filters[0].term\" search-enabled=\"false\">\n      <ui-select-match allow-clear=\"true\" placeholder=\"Выберите\" title=\"{{$select.selected.label}}\">\n        <span ng-bind=\"$select.selected.label\"></span>\n      </ui-select-match>\n      <ui-select-choices\n        repeat=\"type.value as type in col.filters[0].selectOptions\">\n        <div ng-bind=\"type.label\" title=\"{{type.label}}\"></div>\n      </ui-select-choices>\n      <ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice>\n    </ui-select>\n  </div></script><div class=table-footer><paging page-info=divisionCtrl.paging callback=divisionCtrl.getPage></div><all-filter filter-meta=divisionCtrl.filterMeta apply-filter=divisionCtrl.applyFilter filter-data=divisionCtrl.popupFilter clean-filter=divisionCtrl.cleanFilter></all-filter>");
$templateCache.put("app/settings/editProfile/editProfile.html","<div class=\"crud-entity edit-profile-wrap\"><!-- content of settings --><div class=\"main-left-offset main-right-offset\"><h1>Профиль пользователя</h1><div class=\"for-small-width add-user-img\" ng-include=\"\'app/settings/editProfile/user-img.html\'\"></div><form class=editProfile-form role=form name=editProfileForm autocomplete=off><div class=\"clearfix full-width\"><section class=col-xs-9><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group col-xs-6\"><input name=login ng-model=vm.login empty-to-null=true type=text class=form-control disabled><label class=form-control-label><span ng-if=vm.userData.login>Логин</span> <span ng-if=!vm.userData.login>Группа</span></label></div><div class=\"form-group col-xs-6\"><input hard-pruning maxlength=150 name=name ng-model=vm.userData.name required type=text id=fio class=form-control data-check=\"[A-Za-zА-Яа-яёЁ\'` -]{1,64}\" ng-keyup=\"editProfileForm.name.$setValidity(\'unique\', true);\"><label for=fio class=form-control-label>ФИО</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message isset-name\">имя пользователя должно быть уникальным</div><span class=req></span></div></div><div class=row><div class=\"form-group col-xs-6\"><address address-data=vm.userData.location name=\"\'location\'\" parent-form=editProfileForm mode=\"\'input\'\" truncate=true postal-index=false timezone=vm.userData.time_zone field-label=\"\'Местоположение\'\"></address></div><div class=\"form-group col-xs-6\"><timezone class=profile timezone-data=vm.userData.time_zone field-label=\"\'Часовой пояс\'\" auto-timezone=true ng-required=true></timezone><span class=req></span></div></div><div class=row><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-email-or-phone\' : editProfileForm.phone.$error.phone_or_email,\n                   \'has-error-phone-must-be-confirmed\' : editProfileForm.phone.$error.phone_must_be_confirmed}\"><div class=phone-input-wrapper><input id=tel name=phone class=form-control empty-to-null=true maxlength=15 ng-pattern=\"/^\\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/\" phone-input ng-model=vm.userData.phone ng-change=vm.resetPhone(); ng-keyup=\"vm.uniqueCheck(vm.userData.phone, $event)\"><label for=tel class=\"form-control-label phone-control-label\">Телефон</label><span class=\"field-status tip-top\" ng-bind=\"(!editProfileForm.phone.$dirty)? (vm.isPhoneConfirmed())? \'Телефон подтвержден\' : \'Телефон не подтвержден\' : \'\'\"></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message invalid-unique-mess small-offset\">Сотрудник с таким телефоном уже существует</div><div class=\"valid-message phone-attempts-mess small-offset\">Телефон не подтвержден</div><div class=\"valid-message email-or-phone\">Телефон или E-mail должны быть заполнены</div><div class=\"valid-message phone-must-be-confirmed\">Телефон должен быть подтвержден перед сохранением</div></div><div class=status-control><span class=\"glyphicon glyphicon-ok confirm-field-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Телефон подтвержден\" ng-if=vm.isPhoneConfirmed()></span> <span class=no-confirm-field-ico tooltip-placement=bottom-left uib-tooltip=\"Телефон не подтвержден\" ng-if=!vm.isPhoneConfirmed()></span></div></div><div class=\"form-group col-xs-2\" style=\"padding-right: 0\" ng-class=\"{\'has-error-email-or-phone\' : editProfileForm.email.$error.phone_or_email}\" ng-if=\"vm.userData.phone && !editProfileForm.phone.$error.unique && (!vm.isPhoneConfirmed() || vm.userData.pending_phone_changes)\"><div ng-if=\"!vm.phoneConfirmSended && !vm.userData.pending_phone_changes\"><a href=\"\" ng-click=vm.sendPhoneConfirmRequest()>Подтвердить номер</a></div><div ng-if=\"vm.phoneConfirmSended || vm.userData.pending_phone_changes\"><input class=form-control id=confirm ng-model=vm.confirmCode name=confirmCode maxlength=4 ng-keypress=\"$event.keyCode == 13 && vm.checkPhoneConfirmCode() && $event.stopPropagation()\"><div class=\"valid-message confirm-error-mess\" style=\"min-width: 175px;\">Введен неверный код. Осталось попыток: {{vm.phoneAttempts}} </div><label for=confirm class=form-control-label>Код из СМС</label></div></div><div class=\"form-group col-xs-2\" ng-if=\"vm.userData.phone && !editProfileForm.phone.$error.unique && (vm.phoneConfirmSended || vm.userData.pending_phone_changes)\"><label style=\"padding-top: 12px\"><a href=\"\" ng-click=\"vm.checkPhoneConfirmCode() && $event.stopPropagation()\">Подтвердить</a></label></div><div class=\"form-group col-xs-2 resend-with-timer\" ng-if=\"vm.userData.phone && !editProfileForm.phone.$error.unique && (vm.phoneConfirmSended || vm.userData.pending_phone_changes)\" ng-class=\"{\'disabled-link\': !vm.isTimerEnd}\"><label><a href=\"\" ng-click=vm.sendPhoneConfirmRequest(true)>Отправить повторно</a></label><div class=timer-wrapper><timer start=vm.start duration=61 is-end=vm.isTimerEnd></timer></div></div></div><div class=row><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-email-or-phone\' : editProfileForm.email.$error.phone_or_email}\" ng-class=\"(!editProfileForm.email.$dirty)? (vm.userData.email_confirmed)? \'confirmed-field\' : \'no-confirmed-field\' : \'\'\"><email mail=vm.userData.email confirmed=\"vm.userData.email && vm.userData.email_confirmed;\" modify-confirmed=true is-view=false mail-name=email blur-event=vm.uniqueCheck key-event=vm.restEmailError></email><span class=\"field-status tip-top\" ng-bind=\"(!editProfileForm.email.$dirty)? (vm.userData.email_confirmed)? \'E-mail подтвержден\' : \'E-mail не подтвержден\' : \'\'\"></span></div></div><div class=row ng-if=\"vm.userData.pending_email_changes.length && vm.userData.email != vm.userData.pending_email_changes[vm.userData.pending_email_changes.length-1].email\"><div class=\"col-xs-6 text-muted\" style=\"word-break: break-word; padding-right: 35px; margin: -19px 0 10px; font-size: 14px;\">Отправлен запрос подтверждения <strong class=last_new_mail>{{vm.userData.pending_email_changes[vm.userData.pending_email_changes.length-1].email}}</strong></div></div></section><div class=\"col-xs-3 section-helper\" ng-include=\"\'app/settings/editProfile/user-img.html\'\"></div></div><div class=\"clearfix full-width\"><section class=col-xs-9><h5 class=section-header>Партнерство</h5><div ng-if=!$root.partner class=col-xs-9 style=\"padding: 0;\">В настоящий момент вы не являетесь партнером Торговля.онлайн<br><br><button class=\"btn btn-primary\" ng-click=vm.registerNewPartnerPopup();>Стать партнером</button></div><div ng-if=$root.partner>Вы являетесь партнером Торговля.Онлайн</div></section><span class=req-inform ng-show=\"vm.isSaved && !editProfileForm.$valid\">Поля, помеченные *, обязательные для заполнения</span></div><div class=\"section bottom-buttons col-xs-9\"><div class=\"clearfix edit-view-buttons row\"><a class=btn ng-click=vm.changePass()><span class=icon-key></span>Изменить пароль</a> <a href=\"\" ng-click=vm.submit() class=\"btn btn-primary right-button\" ng-disabled=\"vm.isSaved && !editProfileForm.$valid\">Сохранить</a> <a ng-click=vm.returnToPage() class=\"btn right-button\">Отменить</a></div></div></form></div><!-- end content of settings --></div>");
$templateCache.put("app/settings/editProfile/modalChangePass.html","<div id=change-password role=dialog class=modal-change-pass><form novalidate name=changePasswordForm ng-submit=changePassword()><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>&times;</button><h3 class=modal-title>Изменение пароля</h3></div><div class=\"container hidden-password-form-group\"><div class=\"form-group hidden-password-wrapper\"><input maxlength=50 name=password ng-show=showpassword required type=text ng-model=password class=form-control> <input maxlength=50 name=password ng-hide=showpassword required type=password ng-model=password class=form-control><label class=\"showpassword tooltip-light\" ng-class=\"(showpassword)? \'open\' : \'\'\" ng-click=\"showpassword = !showpassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(showpassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label><label class=form-control-label>Текущий или временный пароль</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group hidden-password-wrapper\"><input maxlength=50 name=newPassword ng-show=showNewPassword required type=text ng-model=newPassword class=form-control ng-keyup=checkPassword() ng-class=\"{passNoMatch: passNoMatch}\"> <input maxlength=50 name=newPassword ng-hide=showNewPassword required type=password ng-model=newPassword class=form-control ng-keyup=checkPassword() ng-class=\"{passNoMatch: passNoMatch}\"><label class=form-control-label>Новый пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(showNewPassword)? \'open\' : \'\'\" ng-click=\"showNewPassword = !showNewPassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(showNewPassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group hidden-password-wrapper\"><input maxlength=50 name=repeatedPassword ng-show=repeatedShowPassword required ng-model=repeatedPassword type=text class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()> <input maxlength=50 name=repeatedPassword ng-hide=repeatedShowPassword required type=password ng-model=repeatedPassword class=form-control ng-class=\"{passNoMatch: passNoMatch}\" ng-keyup=checkPassword()><label class=form-control-label>Повторите пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(repeatedShowPassword)? \'open\' : \'\'\" ng-click=\"repeatedShowPassword = !repeatedShowPassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(repeatedShowPassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=wrong-data>{{wrongDataTxt}}</div></div><div class=modal-footer><button class=\"btn btn-primary\" type=submit ng-disabled=passNoMatch>Сохранить</button></div></form></div>");
$templateCache.put("app/settings/editProfile/user-img.html","<div class=person-logo style=\"background-image: url({{vm.userData.user_pic.url}});margin-left: 20px;\" ng-class=\"{\'bg-isset\': vm.userData.user_pic.url}\" ng-click=vm.openImgView();><span class=photo style=\"margin-top: 30px;\"></span></div><div class=\"link-style-wrapper add-img-link\" ng-class=\"{\'has-delete-button\': vm.userData.user_pic.url}\"><div class=link-style style=\"margin-bottom: 8px;\" ng-click=vm.showImgLoadPopup() ng-if=\"$root.hasRole(\'upload.user_pic\')\">Загрузить аватарку</div><div class=\"link-style text-danger\" ng-click=\"vm.userData.user_pic = undefined;\" ng-if=\"$root.hasRole(\'upload.user_pic\') && vm.userData.user_pic.url\">Удалить аватарку</div></div>");
$templateCache.put("app/settings/employees/employee.html","<ul class=\"breadcrumbs main-left-offset\"><li><a ui-sref=business>Структура бизнеса</a></li><li><a ui-sref=\"employees({parent: \'business\'})\">Сотрудники</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/employees/employees.html","<!-- id=\"employees\" --><div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a ui-sref=business>Структура бизнеса</a></li></ul><h1>Сотрудники</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'user.write\')\"><a ui-sref=\"employee.new({parent: \'business\'})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': employeesCtrl.loadData && employeesCtrl.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Сотрудник</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"{\'show-filter\': employeesCtrl.showFilter}\"><form class=\"search-entity col-xs-6\" role=search ng-submit=employeesCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=employeesCtrl.getPage() ng-model=employeesCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по имени, логину, доступу, e-mail, роли, телефону, компании, местоположению и временной зоне\"> <button class=\"btn slim-button search-btn\" ng-click=employeesCtrl.search()>Поиск</button></div></form><div class=\"filter-settings-block text-right pull-right\"><button ng-if=\"$root.hasRole(\'report.users\')\" class=\"btn button-print tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Печатать список сотрудников\" style=\"height: 36px;margin-right: 10px;\" ng-click=employeesCtrl.openPrintUserDialog()><span class=printer></span></button> <button ng-click=employeesCtrl.resetPassword() class=\"btn slim-button\" ng-if=\"$root.hasRole(\'user.set_need_change_password_flag\') && (employeesCtrl.employees | filter: {checked: true}).length > 0\">Сбросить пароль</button> <button type=button class=\"btn toggle-filter\" ng-click=employeesCtrl.turnShowFilter();>Фильтр</button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=employeesCtrl.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=employeesCtrl.gridFilter.getSavedFiltersNames().length><span class=ico></span>Сохраненные фильтры</div><div class=\"form-group input-group search search-entity\" ng-show=\"employeesCtrl.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"(employeesCtrl.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control ng-model=employeesCtrl.savedFilterListSearchText placeholder=Найти></div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=employeesCtrl.configScrollFilter><div class=content><div ng-repeat=\"filterName in employeesCtrl.gridFilter.getSavedFiltersNames() | filter:employeesCtrl.savedFilterListSearchText\" ng-click=employeesCtrl.chooseFilter(filterName)><span ng-bind-html=\"filterName | highlight: employeesCtrl.savedFilterListSearchText\"></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"employeesCtrl.removeFilter(filterName, $event)\"></span></div></div></div><div class=no-saved-filters ng-show=!employeesCtrl.gridFilter.getSavedFiltersNames().length>Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров<div class=no-saved-filters-ico></div></div><p class=\"info no-find-filters\" ng-show=\"employeesCtrl.gridFilter.getSavedFiltersNames().length && !(employeesCtrl.gridFilter.getSavedFiltersNames() | filter:employeesCtrl.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p></div></div></div><ul class=\"card-filter-wrap clearfix main-left-offset\" ng-show=\"employeesCtrl.display == \'card\' && employeesCtrl.showFilter\" ng-class=\"{\'show-card-filter\': employeesCtrl.display == \'card\' && employeesCtrl.showFilter}\"><li class=\"filter-item col-md-3\" style=\"padding-left: 0;\"><div class=filter-label>Доступ</div><div class=filter><ui-select ng-model=employeesCtrl.filter.enabled search-enabled=false on-select=\"employeesCtrl.updateFilter(employeesCtrl.filter); employeesCtrl.getPage();\" class=slim-control><ui-select-match allow-clear=true placeholder=Выберите><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"type.value as type in employeesCtrl.status\"><div ng-bind=type.label style=min-height:20px></div></ui-select-choices></ui-select></div></li><li class=\"filter-item col-md-3\"><div class=filter-label>Роль</div><div class=filter><ui-select ng-model=employeesCtrl.filter.role search-enabled=false on-select=\"employeesCtrl.updateFilter(employeesCtrl.filter); employeesCtrl.getPage();\" class=slim-control><ui-select-match allow-clear=true placeholder=Выберите><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"type.value as type in employeesCtrl.rolesArr\"><div ng-bind=type.label style=min-height:20px></div></ui-select-choices></ui-select></div></li><li class=\"filter-item col-md-3\"><div class=filter-label>Компания</div><div class=filter><ui-select ng-model=employeesCtrl.filter.company_id search-enabled=false on-select=\"employeesCtrl.updateFilter(employeesCtrl.filter); employeesCtrl.getPage();\" class=slim-control><ui-select-match allow-clear=true placeholder=Выберите><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"type.value as type in employeesCtrl.companiesArr\"><div ng-bind=type.label style=min-height:20px></div></ui-select-choices></ui-select></div></li><li class=\"filter-item col-md-3\"><div class=filter-label>Местоположение</div><div class=filter><input type=text clear-button class=\"filter-input slim-control\" ng-model=employeesCtrl.filter.location ng-keyup=\"employeesCtrl.updateFilter(employeesCtrl.filter); employeesCtrl.getPage();\" placeholder=Поиск></div></li></ul><div class=save-filter-star ng-class=\"employeesCtrl.filterSaved ? \'gold-star dropdown\' : \'white-star\'\"><span ng-if=!employeesCtrl.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" ng-click=employeesCtrl.showSaveFilterPopup(); tooltip-placement=bottom-left uib-tooltip=\"Сохранить фильтр\"></span> <span ng-if=employeesCtrl.filterSaved class=\"glyphicon glyphicon-star dropdown-toggle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"{{\'Фильтр «\' + employeesCtrl.savedFilterName + \'»\'}}\"></span></div><div class=\"dropdown all-filters-wrapper\"><button class=\"btn btn-default dropdown-toggle\" data-toggle=modal data-target=#filter-popup ng-click=employeesCtrl.showFilterPopup()>Все</button><div class=\"dropdown-menu pull-right\" ng-style=\"(!(employeesCtrl.filter.name || employeesCtrl.filter.fullName || employeesCtrl.filter.shortName)) && {display:none}\"><div><p class=dropdown-menu-header>Установленные фильтры</p></div><div class=content-wrapper><div class=content><div ng-if=employeesCtrl.filter.enabled><p style=\"margin-bottom: 0\">Доступ:</p><p ng-if=employeesCtrl.filter.enabled>Есть доступ</p><p ng-if=!employeesCtrl.filter.enabled>Доступа нет</p></div><div ng-if=employeesCtrl.filter.role><p style=\"margin-bottom: 0\">Роль:</p><user-role role=employeesCtrl.filter.role></div><div ng-if=employeesCtrl.filter.company_id><p style=\"margin-bottom: 0\">Компания:</p><p ng-repeat=\"item in employeesCtrl.companiesArr\" ng-bind=item.label ng-if=\"item.value == employeesCtrl.filter.company_id\"></p></div><div ng-if=employeesCtrl.filter.location><p style=\"margin-bottom: 0\">Местоположение:</p><p>{{employeesCtrl.filter.location}}</p></div><div class=\"dropdown-menu-header empty-filter-info\">Фильтры не установлены</div></div></div></div></div><div class=\"filter-not-found major-font\" ng-if=\"!employeesCtrl.employees.length && employeesCtrl.loadData\"><div class=big-danger-info-ico ng-if=!employeesCtrl.noData></div><div class=big-danger-info ng-if=!employeesCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=employeesCtrl.noData>Нет данных</div></div><grid-loader class=grid-loader-wrapper ng-class=\"{\'card-gird\': employeesCtrl.display == \'card\'}\" show=!employeesCtrl.loadData ng-show=!employeesCtrl.loadData></grid-loader><!-- Представление в виде карточек --><div class=\"card-wrapper main-left-offset main-right-offset\" ng-show=\"employeesCtrl.display == \'card\'\"><div class=row><div ng-repeat=\"employee in employeesCtrl.employees\" class=col-xs-4><employee-card employee=\"{{employee}}\" total=\"{{employeesCtrl.totalCompany}}\" roles=\"{{employeesCtrl.roles}}\"></employee-card></div></div></div><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=phoneTemplate.html><cell-with-tooltip text=\"(row.entity.phone)? (row.entity.phone | phoneFormat) : \'-\'\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=loginTemplate.html><cell-with-tooltip text=\"row.entity.login || ((row.entity.phone && row.entity.phone_confirmed)? (row.entity.phone | phoneFormat) : ((row.entity.email && row.entity.email_confirmed)? row.entity.email : \'-\'))\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=textTimezones.html><cell-with-tooltip text=\"grid.appScope.employeesCtrl.timezonesMap[COL_FIELD]\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=companyTemplate.html><div class=\"ui-grid-cell-contents tooltip-light\" tooltip-placement=\"bottom-right\" uib-tooltip=\"{{grid.appScope.employeesCtrl.getCompaniesTooltip(row.entity.companies)}}\" style=\"overflow: hidden;white-space: nowrap;text-overflow: ellipsis;\">\n    <span ng-repeat=\"company in row.entity.companies\" ng-bind=\"($index)? \', \' + company.short_name : company.short_name\"></span>\n  </div></script><script type=text/ng-template id=accessTemplate.html><div class=\"ui-grid-cell-contents\">\n    <span class=\"ban tooltip-light\" tooltip-placement=\"bottom-left\" uib-tooltip=\"Нет доступа к Системе\" ng-show=\"COL_FIELD == false\"></span>\n    <span class=\"load\" ng-show=\"COL_FIELD != false && row.entity.need_change_password\"></span>\n  </div></script><script type=text/ng-template id=locationTemplate.html><cell-with-tooltip text=\"row.entity.location.address_as_string\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><script type=text/ng-template id=recs/inputFilterTemplate.html><div class=\"select-wrap for-filter ui-grid-filter-container\">\n    <input clear-button type=\"text\" class=\"ui-grid-filter-input\" ng-model=\"col.filters[0].term\" placeholder=\"Поиск\" >\n  </div></script><script type=text/ng-template id=recs/rolesTemplate.html><div class=\"ui-grid-cell-contents tooltip-light\" tooltip-placement=\"bottom-right\" uib-tooltip=\"{{grid.appScope.employeesCtrl.getRoleTooltip(COL_FIELD)}}\">\n    <span ng-if=\"COL_FIELD.length\">\n      <user-role role=\"COL_FIELD[0]\"/>\n    </span>\n    <span ng-if=\"COL_FIELD.length > 1\">...</span>\n  </div></script><script type=text/ng-template id=recs/select-filter-template.html><div class=\"select-wrap for-filter ui-grid-filter-container\">\n    <ui-select ng-model=\"col.filters[0].term\" search-enabled=\"false\">\n      <ui-select-match allow-clear=\"true\" placeholder=\"Выберите\" title=\"{{$select.selected.label}}\">\n        <span ng-bind=\"$select.selected.label\"></span>\n      </ui-select-match>\n      <ui-select-choices\n        repeat=\"type.value as type in col.filters[0].selectOptions\">\n        <div ng-bind=\"type.label\" title=\"type.label\"></div>\n      </ui-select-choices>\n      <ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice>\n    </ui-select>\n  </div></script><!-- Представление в виде таблицы --><div ng-if=\"employeesCtrl.display == \'table\'\" class=grid ui-grid=employeesCtrl.gridOptions ui-grid-selection ui-grid-cellnav></div><div class=table-footer><paging page-info=employeesCtrl.paging callback=employeesCtrl.getPage></paging><div class=\"view-wrapper pull-right\"><a href=javascript:void(0) ng-click=\"employeesCtrl.display = \'table\'\" ng-disabled=\"employeesCtrl.display == \'table\'\" class=\"table-btn tooltip-light\" tooltip-placement=top-right uib-tooltip=\"Отображать в виде списка\"></a> <a href=javascript:void(0) ng-click=\"employeesCtrl.display = \'card\'\" ng-disabled=\"employeesCtrl.display == \'card\'\" class=\"card-btn tooltip-light\" tooltip-placement=top-right uib-tooltip=\"Отображать в виде карточек\"></a></div></div><all-filter filter-meta=employeesCtrl.filterMeta apply-filter=employeesCtrl.applyFilter filter-data=employeesCtrl.popupFilter clean-filter=employeesCtrl.cleanFilter></all-filter>");
$templateCache.put("app/settings/encashments/encashments.html","");
$templateCache.put("app/settings/expenseItems/expenseItem.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Деньги</a> <span class=divider></span></li><li><a ui-sref=\"expenseItems({parent: \'money\'})\">Статьи затрат</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/expenseItems/expenseItems.html","<div class=main-left-offset><ul class=breadcrumbs><li><a>Деньги</a></li></ul><h1>Статьи затрат</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'expense_item.write\')\"><a ui-sref=\"expenseItem.new({parent: \'money\'})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': expenseItemsCtrl.loadData && expenseItemsCtrl.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Статья затрат</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><form class=\"search-entity col-xs-6\" role=search ng-submit=expenseItemsCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=expenseItemsCtrl.getPage() ng-model=expenseItemsCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по наименованию, общехозяйсвенным расходам, статусу и комментариюю\"> <button class=\"btn slim-button search-btn\" ng-click=expenseItemsCtrl.search()>Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!expenseItemsCtrl.expenseItems.length && expenseItemsCtrl.loadData\"><div class=big-danger-info-ico ng-if=!expenseItemsCtrl.noData></div><div class=big-danger-info ng-if=!expenseItemsCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=expenseItemsCtrl.noData>Нет данных</div></div><grid-loader show=expenseItemsCtrl.crudState.loading></grid-loader><div class=clear></div><div class=grid ui-grid=expenseItemsCtrl.gridOptions ui-grid-edit></div><script type=text/ng-template id=statusTemplate.html><div class=\"ui-grid-cell-contents\">\n    <div ng-if=\"grid.getCellValue(row, col)\">\n      <span class=\"active-status tooltip-light\" tooltip-placement=\"bottom-left\" uib-tooltip=\"Действуюший\"></span>\n    </div>\n  </div></script><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><div class=table-footer><paging page-info=expenseItemsCtrl.paging callback=expenseItemsCtrl.getPage></div>");
$templateCache.put("app/settings/main-settings/main-settings.html","<div class=\"crud-entity main-settings-wrap\"><div class=\"main-left-offset main-right-offset\"><h1>Настройки</h1><form class=main-settings-form role=form name=mainSettingsForm autocomplete=off><div class=\"clearfix full-width flex-column\"><section class=col-xs-9 ng-repeat=\"option in vm.settingsOptions\" style=\"padding-bottom: 20px;\"><div class=pull-left ng-bind=option.label></div><a class=pull-right ui-sref=\"{{option.link}}\">Открыть</a></section></div></form></div></div>");
$templateCache.put("app/settings/marked-product-settings/marked-product-settings.html","<div class=\"main-left-offset main-right-offset crud-entity price-tags-settings\"><!-- content of settings --><ul class=breadcrumbs><li><a>РОЗНИЦА</a> <span class=divider></span></li><li><a>Настройка реализации маркированного товара</a></li></ul><div style=\"margin-top: 10px\"><h1>Настройка реализации маркированного товара</h1><form role=form name=markedProductSettingsForm class=row><div class=\"clearfix full-width\"><section class=col-xs-9><div class=row style=\"margin-bottom: 10px; font-size: 14px; color: #9c9c9c\" ng-if=vm.settings.length><div style=\"width: 96%;\"><div class=col-xs-4>Категория</div><div class=col-xs-4>Товарная группа</div><div class=col-xs-4>Сканировать марку на кассе</div></div></div><div ng-repeat=\"settings in vm.settings\" class=row><div style=\"width: 96%;\"><div class=\"form-group col-xs-4\"><input-category select-class=\"\'slim-control\'\" disable-clearence=true triggers=vm.triggersMap[settings.$$uiid] on-close=vm.onCategoryPopupClose ng-model=settings.category hidden-items=vm.hiddenItems field-name=$index required></input-category></div><div class=\"form-group col-xs-4\"><ui-select ng-model=settings.product_group required class=\"tooltip-light slim-control\" tooltip=\"{{$select.selected.name}}\"><ui-select-match allow-clear=false><span bind-html-compile=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=\"vm.refreshProductGroups($select.search, $select)\" repeat=\"item in (vm.productGroups | filter: $select.search) track by $index\"><span bind-html-compile=item.name title-ext=item.name></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req></span><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group col-xs-4\" style=\"margin-right: -20px;\" ng-if=settings.product_group><ui-select ng-model=settings.scan_mark_type required search-enabled=false class=slim-control><ui-select-match><span ng-bind-html=$select.selected.value></span></ui-select-match><ui-select-choices repeat=\"type.key as (key, type) in vm.scanMarkTypes\"><span ng-bind-html=type.value></span></ui-select-choices></ui-select><span class=req></span></div></div><div style=\"padding-top: 7px; width: 4%; float: right;\" ng-click=vm.deleteCategorySettings($index)><span class=\"btn-ico glyphicon glyphicon-trash\"></span></div></div><div class=add-item-wrap ng-click=vm.addNewSettings()><span class=add-item-icon></span> <span class=add-item-title>Категория</span></div></section><div class=\"col-xs-3 section-helper\"><div class=narrow-container style=\"margin: 7px 0 30px;\">Выберите одну или несколько категорий с товарами, подлежащими обязательной маркировке</div></div></div><div class=\"col-xs-9 section\"><strong class=text-danger>ВНИМАНИЕ!</strong><div>Для возможности продажи и учета маркированного товара необходимо зарегистрироваться в Национальной системе цифровой маркировки \"Честный знак\". Если вы не сделали это ранее, то пройдите по <a href=https://xn--80ajghhoc2aj1c8b.xn--p1ai/ target=_blank>ссылке</a>.</div></div><div class=\"col-xs-9 section bottom-buttons\"><form-buttons no-action-check=true view-type=\"{isEdit: true}\" on-button=vm.crud(status) hide-delete=true can-disabled=!markedProductSettingsForm.$valid></form-buttons></div></form></div></div>");
$templateCache.put("app/settings/paid-services/paid-services.html","<div class=\"main-left-offset main-right-offset\"><h1>Платные услуги</h1></div><div class=\"crud-entity main-left-offset main-right-offset paid-services-wrapper\"><uib-tabset class=tab-form-group active=paidServicesCtrl.activeStatus><uib-tab ng-repeat=\"(tabName, tabData) in paidServicesCtrl.tabs\" select=paidServicesCtrl.selectTab(tabName) index=tabName ng-if=tabData.paging.total><uib-tab-heading class=tab-heading><span class=tab-title><span ng-bind=tabData.title></span> <span class=count ng-if=tabData.showLength ng-bind=tabData.paging.total></span></span></uib-tab-heading><div class=\"main-control-block clearfix\" ng-include=tabData.include></div></uib-tab></uib-tabset><div class=\"form-group bottom-buttons\" ng-if=\"paidServicesCtrl.activeStatus == \'DRAFT\'\"><button class=\"btn btn-primary\" type=button ng-click=paidServicesCtrl.orderInvoice()>Оплатить по счету</button> <button class=\"btn btn-primary\" type=button ng-click=paidServicesCtrl.payOnline()>Оплатить онлайн</button></div></div><div ng-repeat=\"(tabName, tabData) in paidServicesCtrl.tabs\" class=table-footer ng-if=\"paidServicesCtrl.activeStatus == tabName\"><paging page-info=tabData.paging callback=tabData.pagingCallback></div>");
$templateCache.put("app/settings/paymentTypes/paymentType.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Деньги</a></li><li><a ui-sref=\"paymentTypes({parent: \'money\'})\">Способы оплаты</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/paymentTypes/paymentTypes.html","<div class=main-left-offset><ul class=breadcrumbs><li><a>Деньги</a></li></ul><h1>Способы оплаты</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'payment_type.write\')\"><a ui-sref=\"paymentType.new({parent: \'money\'})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': paymentTypesCtrl.loadData && paymentTypesCtrl.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Способ оплаты</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><form class=\"search-entity col-xs-6\" role=search ng-submit=paymentTypesCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=paymentTypesCtrl.getPage() ng-model=paymentTypesCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по наименованию, типу, статусу, договору, валюте и признаку по умолчанию\"> <button class=\"btn slim-button search-btn\" ng-click=paymentTypesCtrl.search()>Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!paymentTypesCtrl.paymentTypes.length && paymentTypesCtrl.loadData\"><div class=big-danger-info-ico ng-if=!paymentTypesCtrl.noData></div><div class=big-danger-info ng-if=!paymentTypesCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=paymentTypesCtrl.noData>Нет данных</div></div><grid-loader show=paymentTypesCtrl.crudState.loading></grid-loader><div class=clear></div><div class=grid ui-grid=paymentTypesCtrl.gridOptions ui-grid-edit></div><script type=text/ng-template id=statusTemplate.html><div class=\"ui-grid-cell-contents\">\n    <div ng-if=\"row.entity.active\">\n      <span class=\"active-status tooltip-light\" tooltip-placement=\"bottom-right\" uib-tooltip=\"Действующий\"></span>\n    </div>\n  </div></script><script type=text/ng-template id=defaultTemplate.html><div class=\"ui-grid-cell-contents\">\n    <span>{{grid.getCellValue(row, col)?\'Да\':\'Нет\'}}</span>\n  </div></script><script type=text/ng-template id=typeTemplate.html><div class=\"ui-grid-cell-contents\">\n    <span ng-bind=\"grid.getCellValue(row, col) | paymentTypes\"></span>\n  </div></script><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><div class=table-footer><paging page-info=paymentTypesCtrl.paging callback=paymentTypesCtrl.getPage></div>");
$templateCache.put("app/settings/priceTagsSettings/price-tags-settings.html","<div class=\"main-left-offset main-right-offset crud-entity price-tags-settings\"><!-- content of settings --><ul class=breadcrumbs><li><a>РОЗНИЦА</a> <span class=divider></span></li><li><a ui-sref=\"priceTagsSettings({parent: \'retail\'})\">Настройка печати ценников</a></li></ul><h1>Настройка печати ценников</h1><form role=form name=priceTagsSettings class=row><div class=\"clearfix full-width\"><section class=col-xs-9><h5 class=section-header>ОБЫЧНЫЕ ЦЕННИКИ</h5><div class=\"form-group clearfix\"><label class=\"col-xs-12 row\" style=\"margin-bottom: 15px\">Формат файла</label><div class=\"col-xs-3 row\" ng-repeat=\"format in vm.formats\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=vm.priceTagsSettings.output_format id=\"{{format}}\" name=format ng-value=format> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{format}}\"><span class=\"{{format.toLowerCase()}} label-icon\"></span></label></div></div><div class=row><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.priceTagsSettings.paper_size ng-required=true search-enabled=false on-select=\"vm.priceTagsSettings.price_tag_size = vm[\'priceTagSize\'+vm.priceTagsSettings.paper_size][0].value\"><ui-select-match><span ng-bind=\"$select.selected === \'TAGS_PRINTER\'? \'Принтер этикеток\' : $select.selected\"></span></ui-select-match><ui-select-choices repeat=\"size in vm.paperSizes track by $index\"><span ng-bind=\"size === \'TAGS_PRINTER\' ? \'Принтер этикеток\' : size\"></span></ui-select-choices></ui-select><label class=form-control-label>Размер бумаги</label></div><div class=\"form-group col-xs-6 text-muted price-tag-description\">Укажите размер бумаги, на которой будете печатать ценники</div></div><div class=row><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.priceTagsSettings.price_tag_size ng-required=true search-enabled=false ng-if=\"vm.priceTagsSettings.paper_size === \'A4\'\"><ui-select-match><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"tagSize.value as tagSize in vm.priceTagSizeA4 track by $index\"><span ng-bind-html=tagSize.label></span></ui-select-choices></ui-select><ui-select ng-model=vm.priceTagsSettings.price_tag_size ng-required=true search-enabled=false ng-if=\"vm.priceTagsSettings.paper_size === \'A5\'\"><ui-select-match><span ng-bind=$select.selected.label></span></ui-select-match>=<ui-select-choices repeat=\"tagSize.value as tagSize in vm.priceTagSizeA5 track by $index\"><span ng-bind-html=tagSize.label></span></ui-select-choices></ui-select><ui-select ng-model=vm.priceTagsSettings.price_tag_size ng-required=true search-enabled=false ng-if=\"vm.priceTagsSettings.paper_size === \'TAGS_PRINTER\'\"><ui-select-match><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"tagSize.value as tagSize in vm.priceTagSizeTAGS_PRINTER track by $index\"><span ng-bind-html=tagSize.label></span></ui-select-choices></ui-select><label class=form-control-label>Размер одного ценника</label></div><div class=\"form-group col-xs-7 text-muted price-tag-description\">Выберите один из предустановленных размеров для ценников. Такого размера должны быть разделители на бумаге</div></div><div class=\"row bool-settings\"><label class=col-xs-12>Что включаем в ценник:</label><div class=\"form-group col-xs-12\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=vm.is_gtin id=is_gtin> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=is_gtin>Штрих-код</label></div><div class=\"form-group col-xs-10 radio_wrapper\" ng-class=\"{\'disabled\':!vm.is_gtin}\"><div class=\"radio pull-left\"><label><input type=radio name=is_img ng-model=vm.is_img ng-value=false id=no_img ng-disabled=!vm.is_gtin> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=no_img>Только цифры</label><div class=clear></div><div class=\"radio pull-left\"><label><input type=radio name=is_img ng-model=vm.is_img ng-value=true id=is_img ng-disabled=!vm.is_gtin> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=is_img>Изображение + цифры</label></div><div class=\"form-group col-xs-12\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=vm.priceTagsSettings.vendor_code id=vendor_code> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=vendor_code>Артикул производителя</label></div><div class=\"form-group col-xs-12\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=vm.priceTagsSettings.catalog_item_code id=catalog_item_code> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=catalog_item_code>Код товара</label></div></div><!--<div class=\"row col-xs-12\">--><!--<h3 style=\"margin-top: 20px; margin-bottom: 10px\">Пример дизайна ценника</h3>--><!--<price-tag-view config=\"vm.priceTagsSettings\" show-size=\"true\"></price-tag-view>--><!--&lt;!&ndash; <price-tag-print config=\"vm.priceTagsSettings\"></price-tag-print> &ndash;&gt;--><!--</div>--></section></div><div class=\"col-xs-9 section bottom-buttons\"><form-buttons view-type=\"{isEdit: true}\" on-button=vm.crud(status) hide-delete=true can-disabled=false></form-buttons></div></form></div>");
$templateCache.put("app/settings/projects/project.html","<ul class=\"breadcrumbs main-left-offset\"><li><a>Деньги</a></li><li><a ui-sref=\"projects({parent: \'money\'})\">Проекты</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/projects/projects.html","<div class=\"main-left-offset main-right-offset\"><ui-view></ui-view><ul class=breadcrumbs><li><a>Деньги</a></li></ul><h1>Проекты</h1><div class=grid-buttons ng-if=\"$root.hasRole(\'project.write\')\"><a ui-sref=\"project.new({parent: \'money\'})\" class=\"btn add-entity\" ng-class=\"{\'btn-primary\': projectsCtrl.loadData && projectsCtrl.noData}\"><span class=\"btn-ico btn-plus btn-plus-dark\"></span>Проект</a></div></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><form class=\"search-entity col-xs-6\" role=search ng-submit=projectsCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=projectsCtrl.getPage() ng-model=projectsCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по наименованию, статусу и комментарию\"> <button class=\"btn slim-button search-btn\" ng-click=projectsCtrl.search()>Поиск</button></div></form></div><div class=clear></div><div class=\"filter-not-found major-font\" ng-if=\"!projectsCtrl.projects.length && projectsCtrl.loadData\"><div class=big-danger-info-ico ng-if=!projectsCtrl.noData></div><div class=big-danger-info ng-if=!projectsCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=projectsCtrl.noData>Нет данных</div></div><grid-loader show=projectsCtrl.crudState.loading></grid-loader><div class=grid ui-grid=projectsCtrl.gridOptions ui-grid-edit></div><script type=text/ng-template id=statusTemplate.html><div class=\"ui-grid-cell-contents\">\n    <div ng-if=\"row.entity.active\">\n      <span class=\"active-status tooltip-light\" tooltip-placement=\"bottom-left\" uib-tooltip=\"Действуюший\"></span>\n    </div>\n  </div></script><script type=text/ng-template id=textTemplate.html><cell-with-tooltip text=\"grid.getCellValue(row, col)\" cell-row=\"row\" cell-col=\"col\"></cell-with-tooltip></script><div class=table-footer><paging page-info=projectsCtrl.paging callback=projectsCtrl.getPage></div>");
$templateCache.put("app/settings/returns/return.html","<ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"$root.$state.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!$root.$state.params.parent><a>Деньги</a></li><li ng-if=!$root.$state.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li><li ng-if=!$root.$state.params.parent><a ui-sref=\"returns({parent: $root.$state.params.parent || \'retail\'})\">Возвраты</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/returns/returns.html","<div class=settings-entities><ul class=\"breadcrumbs main-left-offset\"><li ng-if=\"ctrl.params.parent == \'retail\'\"><a>Розница</a></li><li ng-if=!ctrl.params.parent><a>Деньги</a></li><li ng-if=!ctrl.params.parent><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></li></ul><grid-wide url=ctrl.url page=ctrl.page header=ctrl.header no-data-str=ctrl.noDataStr filters-required=true row-route-func=ctrl.rowRouteFunc base-columns-count=3 default-position=4 sort=ctrl.sort limit=ctrl.limit column-defs=ctrl.columnDefs using-service=ctrl.usingService filter-meta=ctrl.filterMeta currency=ctrl.currency last-sync=true></grid-wide></div>");
$templateCache.put("app/settings/support/support.html","<div class=\"crud-entity support_wrapper\"><div class=\"main-left-offset main-right-offset\"><h1>Поддержка</h1><div class=crud-entity><uib-tabset class=tab-form-group active=supportCtrl.activeTab><uib-tab select=supportCtrl.selectTab($index)><uib-tab-heading class=tab-heading><span class=tab-title>Мой партнер</span></uib-tab-heading><div class=clearfix ng-include=\"\'app/settings/support/includes/my_partner.html\'\"></div></uib-tab><uib-tab><uib-tab-heading class=tab-heading><span class=tab-title>Помощь</span></uib-tab-heading><div class=clearfix ng-include=\"\'app/settings/support/includes/help.html\'\"></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/settings/utmConnections/utmConnection.html","<ul class=\"breadcrumbs main-left-offset\"><li><a ui-sref=alco>Алкоголь</a></li><li><a ui-sref=\"utmConnections({parent: \'alcohol\'})\">Подключения к УТМ</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/utmConnections/utmConnections.html","<div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li><a ui-sref=alcohol>Алкоголь</a></li></ul><h1>Подключения к УТМ</h1></div><div class=\"main-control-block functional_block clearfix main-left-offset main-right-offset\"><form class=\"search-entity col-xs-6\" role=search ng-submit=utmConnectionsCtrl.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=utmConnectionsCtrl.getPage() ng-model=utmConnectionsCtrl.searchText class=\"form-control label-clear-button\" placeholder=\"Поиск по наименованию, ИНН, КПП, идентификатору ФС РАР\"> <button class=\"btn slim-button search-btn\" ng-click=utmConnectionsCtrl.search()>Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!utmConnectionsCtrl.connections.length && utmConnectionsCtrl.loadData\"><div class=big-danger-info-ico ng-if=!utmConnectionsCtrl.noData></div><div class=big-danger-info ng-if=!utmConnectionsCtrl.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=utmConnectionsCtrl.noData>Нет данных</div></div><grid-loader show=utmConnectionsCtrl.crudState.loading></grid-loader><div class=\"card-wrapper main-left-offset main-right-offset\"><div class=row><div class=col-xs-6 ng-repeat=\"connection in utmConnectionsCtrl.connections\"><utm-connection-card connection=connection></utm-connection-card></div></div></div><div class=table-footer><paging-customizable page-info=utmConnectionsCtrl.paging callback=utmConnectionsCtrl.getPage paging=utmConnectionsCtrl.gridPaging></paging-customizable></div>");
$templateCache.put("app/auth/register/includes/address.html","<section class=\"form-group col-xs-9\" style=\"padding-right: 0;\"><h5 class=section-header>Адрес магазина</h5><div class=form-group style=\"margin-bottom: 25px;\"><address address-data=userData.company.shop_address name=\"\'address\'\" ng-required=false parent-form=$ctrl.long address-controls=addressOptions field-label=\"\'Адрес\'\"></address></div></section>");
$templateCache.put("app/auth/register/includes/cashier.html","<section class=\"form-group col-xs-9\" style=\"padding-bottom: 0;\"><h5 class=section-header>Данные кассира</h5><div class=row><div class=\"form-group col-xs-12\"><div class=check-wrapper><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=userData.needCashier id=needCashier ng-change=\" checkNameUnique(); checkPhonesUnique(); checkInnUnique();\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=needCashier class=checkbox-label>Создать отдельную учетную запись для кассира</label></div></div><div ng-if=userData.needCashier><div class=\"form-group col-xs-6\"><input type=password style=display:none> <input hard-pruning type=text name=cashierLastname class=form-control maxlength=150 ng-model=userData.cashier.surname data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]*\" required ng-keyup=\"$ctrl.long.cashierLastname.$setValidity(\'unique\', true)\" ng-blur=checkNameUnique();><label for=name class=form-control-label>Фамилия</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message data-unique-mess text-origin\">ФИО кассира совпадает с ФИО администратора группы</div><div class=\"valid-message isset-name\">Сотрудник с таким ФИО уже существует</div><span class=req></span></div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': $ctrl.long.cashierName.$invalid && $ctrl.long.cashierName.$error.unique}\"><input type=password style=display:none> <input hard-pruning type=text name=cashierName class=form-control maxlength=150 ng-model=userData.cashier.name data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]*\" required ng-keyup=\"$ctrl.long.cashierName.$setValidity(\'unique\', true)\" ng-blur=checkNameUnique();><label for=name class=form-control-label>Имя</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Сотрудник с таким ФИО уже существует</div><div class=\"valid-message data-unique-mess text-origin\">ФИО кассира совпадает с ФИО администратора группы</div><span class=req></span></div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': $ctrl.long.cashierName.$invalid && $ctrl.long.cashierName.$error.unique}\"><input type=password style=display:none> <input hard-pruning type=text name=cashierPatronymic class=form-control maxlength=150 ng-model=userData.cashier.patronymic data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]*\" ng-keyup=\"$ctrl.long.cashierPatronymic.$setValidity(\'unique\', true)\" ng-blur=checkNameUnique();><label for=name class=form-control-label>Отчество</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Сотрудник с таким ФИО уже существует</div><div class=\"valid-message data-unique-mess text-origin\">ФИО кассира совпадает с ФИО администратора группы</div></div><div class=\"form-group col-xs-6\"><input empty-to-null hard-pruning data-check=([0-9_]) pattern=^(\\d{12})$ type=text inn-check required maxlength=12 class=form-control inn-type=fiz name=cashierInn ng-model=userData.cashier.inn ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-blur=checkInnUnique()><label for=cashierInn class=form-control-label>ИНН</label><span class=\"valid-message invalid-inn-mess text-origin\">ИНН должен содержать 12 цифр</span><div class=\"valid-message data-unique-mess text-origin\">ИНН кассира совпадает с ИНН администратора группы</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=$ctrl.long.cashierInn.$error.validInn>Такой номер не существует</span> <span class=req></span></div><div><div class=\"form-group col-xs-6 phone-input-wrapper\"><input name=cashierLogin style=\"padding-top: 15px\" class=\"form-control phone-input\" maxlength=15 ng-pattern=\"/^\\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/\" phone-input required ng-keyup=\"$ctrl.long.cashierLogin.$setValidity(\'confirmError\', true); checkPhonesUnique();\" ng-model=userData.cashier.phone><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message confirm-error-mess\">Необходимо подтвердить номер</div><div class=\"valid-message phone-unique-mess\">Телефон администратора группы совпадает с телефоном кассира</div><div class=\"valid-message phone-attempts-mess\">Номер телефона не подтвержден</div><span class=\"field-status tip-top\" ng-bind=\"(!$ctrl.long.cashierLogin.$dirty)? (isPhoneConfirmed(true))? \'Телефон подтвержден\' : \'Телефон не подтвержден\' : \'\'\"></span><div class=input-flag><div class=flag-ru></div><div class=phone-code><span class=phone-code-text>+7</span></div></div><label for=uni class=\"form-control-label always-top\">Телефон</label><span class=req></span><div class=status-control><span class=\"glyphicon glyphicon-ok confirm-field-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Телефон подтвержден\" ng-if=isPhoneConfirmed(true)></span> <span class=no-confirm-field-ico tooltip-placement=bottom-left uib-tooltip=\"Телефон не подтвержден\" ng-if=!isPhoneConfirmed(true)></span></div></div><div class=\"form-group col-xs-6\" style=\"height: 48px; padding: 0;\"><div class=\"form-group col-xs-6\" style=\"height: 48px;\" ng-if=\"userData.cashier.phone && !$ctrl.long.cashierLogin.$error.phoneAttempts && (!isPhoneConfirmed(true) || cashier_pending_phone_changes)\"><div ng-if=\"!cashierPhoneConfirmSended && !cashier_pending_phone_changes\"><a href=\"\" ng-click=sendPhoneConfirmRequest(true) style=\"padding-top: 13px; display: inline-block;\">Подтвердить номер</a></div><div ng-if=\"cashierPhoneConfirmSended || cashier_pending_phone_changes\"><input class=form-control required maxlength=4 name=cashierConfirmCode ng-model=userData.cashier.$$confirmCode ng-keypress=\"$event.keyCode == 13 && checkPhoneConfirmCode(true) && $event.stopPropagation()\" ng-keyup=\"$ctrl.long.cashierConfirmCode.$setValidity(\'confirmError\', true);\"><label for=confirm class=form-control-label>Код из СМС</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message confirm-error-mess\" style=\"min-width: 175px;\">Введен неверный код. Осталось попыток: {{phoneAttemptsCashier}}</div><span class=req></span></div></div><div class=\"col-xs-3 no-padding-right no-padding-left\" style=\"margin-left: -15px;\" ng-if=!$ctrl.long.cashierLogin.$error.phoneAttempts><label ng-if=\"cashierPhoneConfirmSended || cashier_pending_phone_changes\" style=\"padding-top: 12px;\"><a class=break-word href=\"\" ng-click=\"checkPhoneConfirmCode(true) && $event.stopPropagation()\">Подтвердить</a></label></div><div class=\"col-xs-3 no-padding-right resend-with-timer\" ng-if=\"!$ctrl.long.cashierLogin.$error.phoneAttempts && (cashierPhoneConfirmSended || cashier_pending_phone_changes)\" ng-class=\"{\'disabled-link\': !cashierEndTimer}\" style=\"display: inline-block;\"><label><a class=break-word href=\"\" ng-click=\"sendPhoneConfirmRequest(true, true)\">Отправить повторно</a></label><div class=timer-wrapper><timer start=cashierTimerStart duration=61 is-end=cashierEndTimer></timer></div></div></div></div><div class=\"form-group col-xs-6 hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=30 name=password ng-show=cashshowpassword required type=text ng-model=userData.cashier.password class=form-control ng-class=\"(cashPassNoMatch)? \'passNoMatch\' : \'\'\" autocomplete=new-password> <input maxlength=30 name=cashPassword ng-hide=cashshowpassword required type=password ng-model=userData.cashier.password ng-class=\"(cashPassNoMatch)? \'passNoMatch\' : \'\'\" ng-keyup=checkCashierPassword() class=form-control title=\"Заполните это поле\" autocomplete=new-password><label for=cashPassword1 class=\"form-control-label small-offset\">Пароль</label><div class=\"valid-message required-mess\">Поле является обязательным</div><label class=\"showpassword tooltip-light\" ng-class=\"(cashshowpassword)? \'open\' : \'\'\" tooltip-placement=bottom-left uib-tooltip=\"{{(cashshowpassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\" ng-click=\"cashshowpassword = !cashshowpassword;\"></label></div><span class=req></span></div><div class=\"form-group hidden-password-form-group col-xs-6\"><div class=hidden-password-wrapper><input maxlength=50 name=$$repeatedCashPassword ng-show=cashRepeatedShowPassword required ng-model=userData.$$repeatedCashPassword type=text class=form-control ng-class=\"{passNoMatch: cashPassNoMatch}\" ng-keyup=checkCashierPassword()> <input maxlength=50 name=$$repeatedCashPassword ng-hide=cashRepeatedShowPassword required type=password ng-model=userData.$$repeatedCashPassword class=form-control ng-class=\"{passNoMatch: cashPassNoMatch}\" ng-keyup=checkCashierPassword()><label class=\"form-control-label small-offset\">Повторите пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(cashRepeatedShowPassword)? \'open\' : \'\'\" ng-click=\"cashRepeatedShowPassword = !cashRepeatedShowPassword;\" tooltip-placement=bottom-left uib-tooltip=\"{{(cashRepeatedShowPassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\"></label><div class=\"valid-message wrong-format passNoMatch-mess\">Пароли не совпадают</div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><span class=req></span></div></div></div></section>");
$templateCache.put("app/auth/register/includes/mode-data.html","<section class=\"glyphicon-chevron-up-wrapper col-xs-9\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(registerCtrl.moreFields)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"registerCtrl.moreFields = !registerCtrl.moreFields\"></span></section><section class=\"form-group col-xs-9 same-padding toggle\" ng-click=\"registerCtrl.moreFields = true;\"><h5 class=section-header style=\"margin: 0\">РАСШИРЕННАЯ ИНФОРМАЦИЯ</h5></section><div class=\"clearfix full-width\" ng-show=registerCtrl.moreFields><section class=col-xs-9><h5 class=section-header>Информация о компании</h5><div class=row><div class=\"form-group col-xs-6\"><input empty-to-null hard-pruning data-check=([0-9_]) pattern=^(\\d{10}|\\d{12})$ type=text inn-check maxlength=12 class=form-control inn-type=fiz name=inn id=inn ng-model=userData.company.inn ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-blur=onInnFill(userData.company.inn);><label for=inn class=form-control-label>ИНН</label><span class=\"valid-message invalid-inn-mess text-lowercase\">ИНН должен содержать 10 или 12 цифр</span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=$ctrl.long.inn.$error.validInn>Такой номер не существует</span></div><div class=\"form-group col-xs-6\"><input hard-pruning maxlength=150 name=companyName ng-model=userData.company.short_name type=text class=form-control data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]{1,64}\"><label class=form-control-label>Наименование</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div></div></div></section></div><div class=\"clearfix full-width\" ng-show=registerCtrl.moreFields ng-include=\"\'app/auth/register/includes/address.html\'\"></div><div class=\"clearfix full-width\" ng-show=registerCtrl.moreFields><section class=col-xs-9 style=\"padding-bottom: 0;\"><h5 class=section-header>Оплата банковcкой картой</h5><div class=row><div class=\"form-group col-xs-12\"><div class=check-wrapper><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=userData.acquirerAgreement id=acquirerAgreement> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=acquirerAgreement class=checkbox-label>Есть договор эквайринга</label></div></div><div class=\"form-group col-xs-6\" ng-if=userData.acquirerAgreement><input hard-pruning maxlength=150 name=companyName ng-model=userData.acquiring_bank required type=text class=form-control data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]{1,64}\"><label class=form-control-label>Банк-эквайер</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div></section></div><div class=\"clearfix full-width\" ng-show=registerCtrl.moreFields ng-include=\"\'app/auth/register/includes/cashier.html\'\"></div>");
$templateCache.put("app/auth/register/modals/promo-popup.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title>Код партнера</h3></div><div ng-form=$ctrl.promoForm class=modal-body style=\"padding: 9px 40px 0;\"><div class=form-group><input type=text name=partner_code class=form-control maxlength=64 ng-model=$ctrl.codes.partner_code ng-keyup=$ctrl.checkCode(true)><label for=contract-number class=\"form-control-label small-offset\">Введите код партнера</label><div class=\"valid-message not-found-mess\">Неизвестный код</div></div><div class=form-group><input type=text name=promo_code class=form-control maxlength=64 ng-model=$ctrl.codes.promo_code ng-keyup=$ctrl.checkCode(false)><label for=contract-number class=\"form-control-label small-offset\">Введите промо-код</label><div class=\"valid-message not-found-mess\">Неизвестный код</div></div></div><div class=modal-footer><button class=btn type=button ng-click=$ctrl.close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=$ctrl.savePromo()>Сохранить</button></div>");
$templateCache.put("app/base/header/navbar/navbar.html","<!-- navbar of settings --><div class=\"navbar navbar-default main-navbar major-font\" role=navigation><div class=navbar-collapse id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li ui-sref-active-eq=active ng-if=\"$root.hasRole(\'report.sale_totals\')\"><a ui-sref=indicators>Показатели</a></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'business\' }\"><a ui-sref=business>Структура бизнеса</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/structure.html\'\" class=dropdown-menu></div></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'purchase\' || $root.$state.params.parent == \'PURCHASE\' }\"><a data-toggle=dropdown>Закупки</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/purchase.html\'\" class=dropdown-menu></div></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'sale\' || $root.$state.params.parent == \'WHOLE_SALE\' }\"><a data-toggle=dropdown>Продажи</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/sale.html\'\" class=dropdown-menu></div></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'retail\' || $root.$state.params.parent == \'RETAIL\' }\"><a data-toggle=dropdown>Розница</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/retail.html\'\" class=dropdown-menu></div></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'storehouse\'}\" ng-if=$root.accountingSettings.inventory_accounting_enabled><a data-toggle=dropdown>Склад</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/storehouse.html\'\" class=dropdown-menu></div></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'money\' }\"><a data-toggle=dropdown>Деньги</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/money.html\'\" class=dropdown-menu></div></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'alcohol\' }\"><a data-toggle=dropdown>Алкоголь</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/alco.html\'\" class=dropdown-menu></div></li><li class=dropdown ui-sref-active-eq=active ng-class=\"{ \'active-nav-item\' : $root.$state.params.parent == \'partnership\' }\" ng-if=$root.partner><a data-toggle=dropdown>Партнерство</a> <span class=\"caret dropdown-toggle\" data-toggle=dropdown></span><div ng-include=\"\'app/base/header/navbar/dropdownMenu/partnership.html\'\" class=dropdown-menu></div></li></ul></div></div><!-- end navbar of settings -->");
$templateCache.put("app/cart/modals/cartPopup/cart-popup.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title>Добавить товары из корзины в документ</h3></div><div class=ui-spinner ng-if=$ctrl.load style=\"margin: 150px auto;\"></div><div class=\"modal-body cart-popup-wrapper\" style=\"padding: 9px 40px 0;\" ng-if=\"$ctrl.values.length && !$ctrl.load\"><grid-custom class=row-bg columns=$ctrl.columns data=$ctrl.values page-callback=$ctrl.getCartItems is-show-settings=false show-checkbox=true options=$ctrl.gridOptions min-height=100 is-full-width=false allow-selected=false scroll-height=425></grid-custom><div class=table-footer><paging page-info=$ctrl.paging callback=$ctrl.getCartItems></paging></div></div><div class=modal-body ng-if=\"!$ctrl.values.length && !$ctrl.load\">В корзине нет позиций, удовлетворяющих требованиям документа</div><div class=modal-footer><button class=btn type=button ng-click=$ctrl.close() ng-bind=\"($ctrl.values.length)? \'Отменить\' : \'Закрыть\'\"></button> <button class=\"btn btn-primary\" type=button ng-click=$ctrl.save() ng-bind=\"($ctrl.gridOptions.hasCheckedRows())? \'Добавить\' : \'Добавить все\'\" ng-if=$ctrl.values.length></button></div><script type=text/ng-template id=cartHeaderCellTemplate.html><div class=\"default-header-cell\" ng-class=\"{\'word-break text-right\': gridCustomHeaderCtrl.column.field == \'price\'}\">\n    <span class=\"default-header-text\">\n      <span ng-bind=\"::gridCustomHeaderCtrl.column.name\"></span>\n    </span>\n  </div></script><script type=text/ng-template id=cartCatalogItemTemplate.html><div class=\"cell-data single-line\">\n    <div class=\"view-entity-control text-left catalog-item-cell\" style=\"height: 42px;\">\n      <span class=\"catalog-item-name\"\n            tooltip-placement=\"right\" uib-tooltip=\"{{::value[column.field].name}}\"\n            ng-bind=\"::value[column.field].name\"></span>\n      <span class=\"catalog-item-derivative\"\n            ng-if=\"value.derivative.name\"\n            tooltip-placement=\"right\" uib-tooltip=\"{{::value.derivative.name}}\"\n            ng-bind=\"::value.derivative.name\"></span>\n    </div>\n  </div></script><script type=text/ng-template id=cartQuantityTemplate.html><div class=\"cell-data single-line\">\n    <span ng-bind=\"value[column.field]\"></span>\n  </div></script><script type=text/ng-template id=cartNameTemplate.html><div class=\"cell-data single-line\" tooltip-placement=\"bottom-right\" uib-tooltip=\"{{value[column.field].name}}\">\n    <span ng-bind=\"value[column.field].name\"></span>\n  </div></script><script type=text/ng-template id=cartPriceTemplate.html><div class=\"cell-data single-line\">\n    <span ng-bind=\"(value[column.field] / 100) | priceFormatter:(value.currency.char_iso_code || $root.homeCurrency.currency.char_iso_code)\"></span>\n  </div></script><script type=text/ng-template id=cartTaxIncludedTemplate.html><div class=\"cell-data single-line\">\n    <span ng-bind=\"(value[column.field])? \'Да\' : \'Нет\'\"></span>\n  </div></script>");
$templateCache.put("app/catalog/alcoholSettings/sections/alcohol_accounting.html","<section class=\"panel panel-default col-xs-9\"><h5 class=section-header>Учет алкогольной продукции</h5><!-- <div class=\"form-group checkbox-group\" style=\"padding-top: 5px; margin-bottom: 0;\">\n    <div class=\"checkbox pull-left\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"vm.alcoholSettings.auto_account_consigmnent_note_in\">\n        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n      </label>\n    </div>\n    <label class=\"label-checkbox\">Автоматическое проведение товарно-транспортной накладной</label>\n  </div>\n\n  <div class=\"form-group checkbox-group\" style=\"padding-top: 5px; margin-bottom: 0;\">\n    <div class=\"checkbox pull-left\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"vm.alcoholSettings.auto_account_write_off\">\n        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n      </label>\n    </div>\n    <label class=\"label-checkbox\">Автоматическое проведение акта списания с баланса</label>\n  </div>\n\n  <div class=\"form-group checkbox-group\" style=\"padding-top: 5px; margin-bottom: 0;\">\n    <div class=\"checkbox pull-left\">\n      <label>\n        <input type=\"checkbox\" ng-model=\"vm.alcoholSettings.auto_create_transfer_register\">\n        <span class=\"cr\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n      </label>\n    </div>\n    <label class=\"label-checkbox\">Автоматическое создание документа перевода между регистрами</label>\n  </div> --><div><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.alcoholSettings.beer_accounting_type search-enabled=false><ui-select-match allow-clear=false><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"item.value as item in [\n            {value: \'REGISTER1\', label: \'Регистр №1\'},\n            {value: \'REGISTER2\', label: \'Регистр №2\'}]\"><span ng-bind-html=item.label></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Регистр учета пивной продукции</label></div><div class=\"form-group col-xs-7 text-muted attr-description\" style=\"margin-bottom: 0px;\">Регистр №1. Строгий учет - списывать в минус нельзя. Не требуется перемещение пивной продукции на регистр №2 после приемки ТТН. Система создает акты списания с регистра №1 ЕГАИС по итогам закрытия кассовой смены. При списании доступен автоматический поиск остатков по складской позиции.<br><br>Регистр №2. Гибкий учет - можно списывать в минус. Требуется перемещение пивной продукции с регистра №1 после приемки ТТН. Система создает акты списания с регистра №2 ЕГАИС по итогам закрытия кассовой смены.</div></div></section>");
$templateCache.put("app/catalog/alcoholSettings/sections/attributes.html","<section class=\"panel panel-default col-xs-9 alcohol-attr\" id=alcoholAttrs><h5 class=section-header>АТРИБУТЫ <span class=req></span></h5><div><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.alcoholSettings.attribute_for_alcohol_product_flag ng-required=true class=\"no-caret slim-control select-autocomlete\" ng-class=\"{ \'has-error\': !vm.attributes.attr0.length && $select.search.length > 2, \'has-error-unique\': vm.errorAttrInd.length && vm.errorAttrInd.indexOf(0) + 1}\" on-select=vm.checkAttribute();><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 minimum-input-length=2 refresh=\"vm.refreshAttr($select.search, \'BOOLEAN\', 0)\" repeat=\"attribute in vm.attributes.attr0 track by $index\"><span ng-bind-html=\"attribute.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{($select.search)? $root.controlSettings.NOT_FOUND_STRING : \'\'}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\">Значение уже существует</div></div><div class=\"form-group col-xs-7 text-muted attr-description\" style=\"margin-top: 8px;margin-bottom: 11px;\">Признак принадлежности товара к алкогольной продукции</div><div class=clear></div><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.alcoholSettings.attribute_for_alcohol_type ng-required=true class=\"no-caret slim-control select-autocomlete\" ng-class=\"{ \'has-error\': !vm.attributes.attr1.length && $select.search.length > 2, \'has-error-unique\': vm.errorAttrInd.length && vm.errorAttrInd.indexOf(1) + 1}\" on-select=vm.checkAttribute();><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 minimum-input-length=2 refresh=\"vm.refreshAttr($select.search, \'INTEGER\', 1)\" repeat=\"attribute in vm.attributes.attr1 track by $index\"><span ng-bind-html=\"attribute.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{($select.search)? $root.controlSettings.NOT_FOUND_STRING : \'\'}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\">Значение уже существует</div></div><div class=\"form-group col-xs-7 text-muted attr-description\">Цифровой код вида продукции по классификатору ФС по регулированию алкогольного рынка</div><div class=clear></div><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.alcoholSettings.attribute_for_alcohol_percentage ng-required=true class=\"no-caret slim-control select-autocomlete\" ng-class=\"{ \'has-error\': !vm.attributes.attr2.length && $select.search.length > 2, \'has-error-unique\': vm.errorAttrInd.length && vm.errorAttrInd.indexOf(2) + 1}\" on-select=vm.checkAttribute();><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 minimum-input-length=2 refresh=\"vm.refreshAttr($select.search, \'FLOAT\', 2)\" repeat=\"attribute in vm.attributes.attr2 track by $index\"><span ng-bind-html=\"attribute.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{($select.search)? $root.controlSettings.NOT_FOUND_STRING : \'\'}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\">Значение уже существует</div></div><div class=\"form-group col-xs-7 text-muted attr-description\">Объёмный процент этилового спирта в алкогольном напитке (крепость алкогольной продукции)</div><div class=clear></div><div class=\"form-group col-xs-5\"><ui-select ng-model=vm.alcoholSettings.attribute_for_alcohol_label ng-required=true class=\"no-caret slim-control select-autocomlete\" ng-class=\"{ \'has-error\': !vm.attributes.attr3.length && $select.search.length > 2, \'has-error-unique\': vm.errorAttrInd.length && vm.errorAttrInd.indexOf(3) + 1}\" on-select=vm.checkAttribute();><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 minimum-input-length=2 refresh=\"vm.refreshAttr($select.search, \'BOOLEAN\', 3)\" repeat=\"attribute in vm.attributes.attr3 track by $index\"><span ng-bind-html=\"attribute.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{($select.search)? $root.controlSettings.NOT_FOUND_STRING : \'\'}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\">Значение уже существует</div></div><div class=\"form-group col-xs-7 text-muted attr-description\">Признак сканирования акцизной марки на алкогольную продукцию</div></div></section><div class=\"col-xs-3 section-helper\">Для возможности продажи и учета алкогольной продукции необходимо указать свои атрибуты, подходящие под описание, либо добавить в соответствующие категории указанные здесь атрибуты</div>");
$templateCache.put("app/catalog/alcoholSettings/sections/divisions.html","<div class=calendar-company-wrap ng-if=vm.alcoholSettings.companies.length><h5 class=section-header>СООТВЕТСТВИЯ ПОДРАЗДЕЛЕНИЙ КАЛЕНДАРЯМ РЕАЛИЗАЦИИ</h5><div class=\"clearfix full-width\" ng-repeat=\"company in vm.alcoholSettings.companies\" ng-if=company.division_links.length><section class=col-xs-9><h5 class=section-header ng-bind=company.name></h5><div class=\"calendar-division-wrap clearfix\" ng-repeat=\"divisionItem in company.division_links\"><div class=\"form-group col-xs-4\" ng-bind=divisionItem.name></div><div class=\"form-group col-xs-5\"><ui-select ng-model=divisionItem.calendar_name search-enabled=\"vm.alcoholSettings.calendars.length > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-class=\"{ \'has-error\': !divisionItem.$$search.length, \'autocomplete-select\': divisionItem.$$search.length > $root.controlSettings.OPTION_DEFAULT_LENGTH+1}\" class=slim-control><ui-select-match allow-clear=true placeholder=Нет><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=\"vm.refreshCalendars($select.search, divisionItem)\" repeat=\"calendar.name as calendar in divisionItem.$$search | limitTo:$root.controlSettings.OPTION_DEFAULT_LENGTH+1 track by $index\" ui-disable-choice=\"!$index && divisionItem.$$search.length > $root.controlSettings.OPTION_DEFAULT_LENGTH\"><span ng-bind-html=\"calendar.name | highlight: $select.search\" ng-class=calendar.class></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div></div></section></div></div>");
$templateCache.put("app/catalog/catalogItem/sections/attributes.html","<div ng-hide=\"(vm.stateName.endsWith(\'view\') && (vm.catalogSkus ? !vm.catalogSkus.attribute_values.length : !vm.catalogItem.attribute_values.length)) || !vm.category.elements.length\"><section class=\"nestedDemo attribute_wrapper clearfix\" style=\"width: 100%; position: relative;\"><h5 class=section-header>Атрибуты категории</h5><div class=catalog-item-atttributes><div ng-repeat=\"list in vm.category.elements\" class=attribute ng-class=\"{attributeContainer: !list.attribute}\" ng-if=\"!vm.stateName.endsWith(\'view\') || \n      (list.block && !list.block.$$empty) || \n      (list.attribute && vm.attribValues[list.attribute.name].values && vm.attribValues[list.attribute.name].values[0])\"><div ng-if=!list.attribute class=\"container-element box clearfix\" ng-hide=\"vm.stateName.endsWith(\'view\') && list.block.$$empty\"><h3 class=container-name ng-bind=list.block.name></h3><div class=clear></div><div class=column ng-repeat=\"item in list.block.attributes\" ng-attr-id=\"{{item.id + \'Anchor\'}}\"><attr-element parent-form=\"vm.addCatalogSkus || addCatalogItem\" attribute=item data=vm.attribValues[item.name] callback=vm.buildDerivatives state-name=vm.stateName hide-determinate=vm.hideDeterminate unique=vm.hasError></attr-element></div></div><div ng-if=list.attribute><div class=\"column clearfix\" ng-attr-id=\"{{list.attribute.id + \'Anchor\'}}\"><attr-element parent-form=\"vm.addCatalogSkus || addCatalogItem\" attribute=list.attribute data=vm.attribValues[list.attribute.name] callback=vm.buildDerivatives state-name=vm.stateName hide-determinate=vm.hideDeterminate unique=vm.hasError></attr-element></div></div></div></div><div class=\"col-xs-5 section-helper attr-helper\" ng-if=\"!vm.stateName.endsWith(\'view\')\" style=\"top: 0;\">Добавьте еще одно значение в атрибуте, если у вас есть услуги с похожими свойствами</div><div class=\"col-xs-5 section-helper attr-helper\" ng-if=\"!vm.stateName.endsWith(\'view\')\"><div style=\"font-weight: bold;margin-top: 50px;\">ВНИМАНИЕ!</div> {{(vm.catalogItem)? \'Услуга\' : \'Товар\'}} может содержать не более трех атрибутов с несколькими значениями. Как только вы добавите два или более значений трем атрибутам, кнопка \"Добавить значение\" у всех остальных атрибутов исчезнет</div></section></div><div ng-show=\"vm.catalogSkus.old_attribute_values.length || vm.catalogItem.old_attribute_values.length\"><section class=\"nestedDemo attribute_wrapper clearfix\" style=\"width: 100%;\"><h5 class=section-header>Устаревшие атрибуты</h5><div class=catalog-item-atttributes><div ng-repeat=\"attr in (vm.catalogSkus.old_attribute_values || vm.catalogItem.old_attribute_values)\" class=attribute ng-if=\"!vm.stateName.endsWith(\'view\') || \n      (attr | attributeValue)\"><div class=\"attribute item clearfix\"><div class=col-xs-6><div class=attr-name>{{attr.attribute.name}}</div></div><div class=\"col-xs-6 row\"><span>{{attr | attributeValue}}</span><span ng-click=vm.deleteOldAttrValue($index) class=\"pull-right glyphicon glyphicon-trash\"></span></div></div></div></div></section></div>");
$templateCache.put("app/catalog/catalogItem/sections/buttons.html","<div ng-if=\"vm.stateName.endsWith(\'new\')\"><a ng-if=\"$root.hasRole(\'catalog_item.write\')\" class=\"btn btn-primary pull-right\" ng-click=\"(!vm.catalogItem.name || !vm.catalogItem.code || vm.hasError.length || (addCatalogItem.$error[\'wrong-date\'] && addCatalogItem.$error[\'wrong-date\'].length))? vm.setDirty() : vm.save()\" ng-disabled=\"vm.isSetDirty && (!vm.catalogItem.name || !vm.catalogItem.code || vm.hasError.length || addCatalogItem.$error[\'wrong-date\'].length)\">Создать</a> <a class=\"btn pull-right\" ng-click=vm.returnToPage()>Отменить</a></div><div ng-if=\"vm.stateName.endsWith(\'edit\')\"><span ng-if=\"$root.hasRole(\'catalog_item.write\')\" ng-disabled=\"vm.catalogItem.status !== \'ARCHIVED\'\" class=\"btn btn-ico-wrap tooltip-light\" ng-click=\"vm.catalogItem.status !== \'ARCHIVED\' ? \'\' :vm.delete()\" role=button tooltip-placement=bottom-left uib-tooltip=\"{{(vm.catalogItem.status !== \'ARCHIVED\')? \'Нельзя удалить не архивную услугу\' : \'\'}}\"><span class=\"btn-ico glyphicon glyphicon-trash\"></span>Удалить</span> <span ng-if=\"$root.hasRole(\'catalog_item.unarchive\') && vm.catalogItem.status == \'ARCHIVED\'\" class=btn ng-click=vm.archivePopup(true) style=\"margin-left: 8px;\">Восстановить</span> <span ng-if=\"$root.hasRole(\'catalog_item.archive\') && vm.catalogItem.status != \'ARCHIVED\'\" class=btn ng-click=vm.archivePopup() style=\"margin-left: 8px;\">В архив</span> <a ng-if=\"$root.hasRole(\'catalog_item.write\')\" class=\"btn btn-primary pull-right\" ng-click=\"(!vm.catalogItem.name || !vm.catalogItem.code || vm.hasError.length || addCatalogItem.$error[\'wrong-date\'].length)? vm.setDirty() : vm.save()\" ng-disabled=\"vm.isSetDirty && (!vm.catalogItem.name || !vm.catalogItem.code || vm.hasError.length || addCatalogItem.$error[\'wrong-date\'].length)\">Сохранить</a> <a class=\"btn pull-right\" ng-click=vm.returnToPage()>Отменить</a></div><div ng-if=\"vm.stateName.endsWith(\'view\')\"><a class=\"btn btn-ico-wrap\" ng-click=vm.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</a> <span ng-if=\"$root.hasRole(\'catalog_item.unarchive\') && vm.catalogItem.status == \'ARCHIVED\'\" class=btn ng-click=vm.archivePopup(true) style=\"margin-left: 8px;\">Восстановить</span> <span ng-if=\"$root.hasRole(\'catalog_item.archive\') && vm.catalogItem.status != \'ARCHIVED\'\" class=btn ng-click=vm.archivePopup() style=\"margin-left: 8px;\">В архив</span> <a ng-if=\"$root.hasRole(\'catalog_item.write\')\" ui-sref=\"catalogServices.edit({categoryId: vm.categoryId, elementId: vm.catalogItem.id, parent: $state.params.parent})\" class=\"btn btn-primary pull-right\">Редактировать</a></div><div class=clear></div>");
$templateCache.put("app/catalog/catalogItem/sections/main-info.html","<section class=\"form-group full-width\"><h5 class=section-header ng-hide=\"vm.stateName.endsWith(\'view\')\">Основная информация</h5><ul class=catalogItem-path ng-show=\"vm.stateName.endsWith(\'view\')\"><li><a ui-sref=\"catalog({categoryId: vm.categoryId, parent: $state.params.parent})\" ng-bind=vm.catalogItem.category.name></a></li></ul><div class=row><div id=nameAnchor class=\"form-group col-xs-12\" ng-class=\"{\'has-error-unique\': addCatalogItem.name.$invalid && addCatalogItem.name.$error.unique}\"><input empty-to-null required type=text class=form-control id=name maxlength=128 ng-model=vm.catalogItem.name ng-hide=\"vm.stateName.endsWith(\'view\')\" name=name ng-keyup=\"addCatalogItem.name.$setValidity(\'unique\', true)\" ng-blur=\"vm.uniqueCallback(vm.catalogItem.name, \'name\')\"><label for=name class=form-control-label ng-hide=\"vm.stateName.endsWith(\'view\')\">Наименование</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=addCatalogItem.name.$error><div ng-message=unique class=\"valid-message isset-name\">Услуга уже существует</div></div><span class=req></span><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=vm.catalogItem.name class=h4 style=\"font-weight: 600;\"></div></div><div class=\"form-group description-wrapper col-xs-12\" ng-hide=\"vm.stateName.endsWith(\'view\') && !vm.catalogItem.full_desc\"><textarea empty-to-null class=form-control id=description ng-model=vm.catalogItem.full_desc ng-hide=\"vm.stateName.endsWith(\'view\')\" maxlength=1000></textarea><label for=description class=form-control-label ng-hide=\"vm.stateName.endsWith(\'view\')\">Описание</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=vm.catalogItem.full_desc style=\"margin-top: -10px; letter-spacing: 0.1px; font-size: 14px; opacity: 0.9;\"></div></div><div class=\"form-group col-xs-6\" id=derivative_code_prefixAnchor ng-class=\"{\'has-error-unique\': addCatalogItem.derivative_code_prefix.$invalid && addCatalogItem.derivative_code_prefix.$error.unique}\"><input empty-to-null required type=text class=form-control id=code maxlength=30 ng-model=vm.catalogItem.code ng-hide=\"vm.stateName.endsWith(\'view\')\" name=derivative_code_prefix ng-keyup=\"addCatalogItem.derivative_code_prefix.$setValidity(\'unique\', true)\" ng-blur=\"vm.buildDerivatives(); vm.uniqueCallback(vm.catalogItem.code, \'derivative_code_prefix\')\"><label for=code class=form-control-label>Код услуги</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=addCatalogItem.derivative_code_prefix.$error><div ng-message=unique class=\"valid-message isset-name\">Код услуги уже существует</div></div><span class=req></span><div ng-show=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=vm.catalogItem.code></div></div><div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': vm.formError.uom}\"><ui-select ng-model=vm.catalogItem.uom search-enabled=true ng-hide=\"vm.stateName.endsWith(\'view\')\" ng-required=true ng-class=\"{\'autocomplete-select\': vm.uoms.length > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match><span ng-bind=\"$select.selected.name + \' (\' + $select.selected.symbols + \')\'\"></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=vm.refreshUoms($select.search) repeat=\"uom in (vm.uoms | limitTo:$root.controlSettings.OPTION_DEFAULT_LENGTH) track by $index\" group-by=vm.totalStr><!-- group-by - вывод подсказки о количестве option --> <span ng-bind-html=\"uom.name + \' (\' + uom.symbols + \')\' | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Единица измерения</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-show=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=\"(vm.catalogItem.uom.name)? vm.catalogItem.uom.name : \'-\'\"></div><span class=req></span></div><div class=\"form-group col-xs-6\"><ui-select ng-model=vm.catalogItem.expense_item search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\" ng-required=false><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"expense_item in vm.expenseItems track by $index\"><span ng-bind-html=expense_item.name></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>При приемке относить на статью затрат</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=\"(vm.catalogItem.expense_item.name)? vm.catalogItem.expense_item.name : \'-\'\"></div></div><div class=\"form-group col-xs-6\"><ui-select ng-model=vm.catalogItem.project ng-hide=\"vm.stateName.endsWith(\'view\')\" search-enabled=\"vm.projectsFullTotal > 5\" ng-class=\"{\'autocomplete-select\': vm.projectsFullTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.refreshProjects($select.search) repeat=\"item in ( vm.projects.items | filter: $select.search) track by $index\" group-by=vm.totalSelectStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Проект</label><div ng-if=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control>{{vm.catalogItem.project.name || \'-\'}}</div></div></div></section>");
$templateCache.put("app/catalog/crudCategory/sections/searchItem.html","<div class=\"clearfix full-width\"><section class=\"form-group col-xs-9\" id=searchCategory><!-- <div class=\"example-category\">Например: <span style=\"color: #43ad9c;\">молочная продукция, морепродукты</span></div> --><combobox ng-model=vm.searchName refresh=vm.refreshCategories is-required=false id-name=\"\" disabled maxlength=150 choose=vm.choseCategory param=\"\'name\'\" arr-items=vm.autoCategories total=vm.autoCategoriesTotal field-label=\"\'Название категории\'\" is-open=open></combobox></section><div class=\"col-xs-3 section-helper\">Введите название категорий для товаров из одной группы, которые нужны для группировки однотипных товаров по похожим свойствам</div></div><div class=\"clearfix full-width\"><div ng-form=checkAttr class=\"section col-xs-9 choose-attributes clearfix\" ng-show=vm.category.elements.length><h5 class=section-header>Атрибуты</h5><ul class=list-attributes><li class=attr ng-repeat=\"element in vm.category.elements\" ng-class=\"{\'container-attr\': !element.attribute}\"><div ng-if=\"element.attribute && !element.attribute.$$isset\"><input type=checkbox ng-model=element.attribute.$$enabled id=\"{{element.attribute.id}}\"><label for=\"{{element.attribute.id}}\">{{element.attribute.name}}<span class=req ng-if=element.attribute.required></span></label></div><div ng-if=\"!element.attribute && !element.block.$$isset\"><attr-block data=element.block index=$index></attr-block></div></li></ul></div><div class=\"load-search col-xs-9 section\" ng-if=vm.disableButton></div></div><div class=\"col-xs-9 section bottom-buttons no-padding\" ng-if=\"vm.state.current.name == \'category.new\'\"><button ng-click=vm.showDetails() class=\"btn btn-primary pull-right\" ng-disabled=\" vm.disableButton\" style=\"margin-left: 15px;\">Далее</button> <a ng-click=vm.returnToPage() class=\"btn pull-right\">Отменить</a></div>");
$templateCache.put("app/catalog/directives/attr-block/attr-block.html","<div class=clearfix><h4 ng-bind=data.name class=pull-left></h4><span class=\"all-attr-checkbox pull-right\"><input type=checkbox ng-model=isCheckAll ng-change=checkAll() id=\"{{index}}{{data.id}}\"><label for=\"{{index}}{{data.id}}\" ng-bind=\"(isCheckAll)? \'убрать\' : \'все\'\"></label></span></div><ul class=list-attributes><li class=attr ng-repeat=\"attr in data.attributes\" ng-if=!attr.$$isset><input type=checkbox ng-model=attr.$$enabled id=\"{{index}}{{$index}}\" ng-change=removeCheckAll(attr.$$enabled)><label for=\"{{index}}{{$index}}\">{{attr.name}}<span class=req ng-if=attr.required></span></label></li></ul>");
$templateCache.put("app/catalog/directives/attr-element/attr-element.html","<div class=\"attribute item clearfix\" ng-hide=\"stateName.endsWith(\'view\') && (data.values[0] === \'\' || data.values[0].value === \'\')\"><div class=col-xs-6><div class=attr-name> {{attribute.name}}&nbsp;<span class=\"attr-star req\" ng-if=attribute.required></span></div></div><div class=\"col-xs-6 row\" style=\"padding-right: 0;\"><div class=\"attr-value-wrapper clearfix\" ng-repeat=\"value in data.values track by $index\"><div ng-switch=attribute.data_type ng-hide=\"stateName.endsWith(\'view\')\" ng-class=\"{\'has-error-unique\': errorInd.length && errorInd.indexOf($index)+1}\"><div ng-switch-when=STRING class=\"input-wrapper-{{$index}}\"><input maxlength=150 type=text title=\"{{data.values[$index]}}\" ng-model=data.values[$index] class=\"catalog-attribute-control attr-value form-control slim-control\" ng-blur=checkVal() ng-required=\"{{attribute.required}}\"> <span class=\"valid-message isset-name\">Значение уже существует</span></div><div ng-switch-when=BOOLEAN><div><ui-select ng-model=data.values[$index] search-enabled=false ng-required=\"{{attribute.required}}\" class=slim-control><ui-select-match placeholder=\"Выберите значение\" allow-clear=true><span ng-bind-html=\"angular.isUndefined($select.selected)? \'\' : ($select.selected === \'true\'? \'Да\' : \'Нет\' )\"></span></ui-select-match><ui-select-choices repeat=\"item as item in [\'true\', \'false\']\"><span ng-bind-html=\"(item === \'true\')? \'Да\' : \'Нет\'\"></span></ui-select-choices></ui-select></div></div><div ng-switch-when=INTEGER class=\"input-wrapper-{{$index}}\"><input hard-pruning type=text data-check=([0-9])+ maxlength=17 title=\"{{data.values[$index]}}\" ng-model=data.values[$index] class=\"catalog-attribute-control attr-value form-control slim-control\" ng-blur=checkVal() ng-required=\"{{attribute.required}}\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message isset-name\">Значение уже существует</span></div><div ng-switch-when=FLOAT class=\"input-wrapper-{{$index}}\"><input type=text float-input float-step=0.01 title=\"{{data.values[$index]}}\" ng-model=data.values[$index] class=\"catalog-attribute-control attr-value form-control slim-control text-align-left\" ng-blur=checkVal() ng-required=\"{{attribute.required}}\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message isset-name\">Значение уже существует</span></div><div ng-switch-when=DICTIONARY class=\"input-wrapper-{{$index}}\"><div ng-class=\"{ \'has-error\': notFound}\"><ui-select ng-model=data.values[$index] search-enabled=\"dictValues.length > $root.controlSettings.OPTION_DEFAULT_LENGTH\" on-select=checkVal() ng-required=\"{{attribute.required}}\" class=slim-control><ui-select-match placeholder=\"Выберите значение\" allow-clear=\"{{!attribute.required}}\"><span ng-bind=$select.selected.value></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=refreshDictionary($select.search) repeat=\"item as item in dictValues | filter: $select.search track by $index\"><span ng-bind-html=\"item.value | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=\"valid-message isset-name\">Значение уже существует</span></div></div><div ng-switch-when=DATE><div date-range-picker ng-model=value.date opts=datePickerOpts state=dateState class=datepicker-wrap change=onDatePickerChange name=\"date_only_{{attribute.id}}\" on-close=\"onDatePickerClose(returnValue, name)\"></div></div><div ng-switch-when=DATE_TIME><div date-range-picker ng-model=value.date opts=dateTimePickerOpts state=dateTimeState change=onDatePickerChange class=datepicker-wrap name=\"date_time_{{attribute.id}}\" on-close=\"onDatePickerClose(returnValue, name)\"></div></div></div><span class=\"glyphicon glyphicon-trash\" ng-show=\"data.values.length > 1 && !stateName.endsWith(\'view\')\" ng-click=\"removeAttrValue(data.values, $index);\"></span> <span ng-show=\"stateName.endsWith(\'view\') && attribute.data_type != \'BOOLEAN\' && attribute.data_type != \'DATE\' && attribute.data_type != \'DATE_TIME\' && attribute.data_type != \'DICTIONARY\'\" ng-bind=\"($index == 0)? value : \', \' + value\"></span> <span ng-show=\"stateName.endsWith(\'view\') && attribute.data_type == \'BOOLEAN\'\" ng-bind=\"(value === \'true\')? \'Да\' : \'Нет\'\"></span> <span ng-show=\"stateName.endsWith(\'view\') && data.values[0].value && (attribute.data_type == \'DATE\' || attribute.data_type == \'DATE_TIME\')\">{{value.value}}</span><span ng-show=\"stateName.endsWith(\'view\') && attribute.data_type == \'DICTIONARY\'\"><span class=attr-view ng-repeat=\"item in dictValues\" ng-if=\"item.id == data.values[$parent.$index].id || data.values[0] == item.id\" ng-bind=\"($parent.$parent.$index == data.values.length-1)? item.value : item.value + \',\'\"></span></span></div><div class=add-item-wrap ng-click=\"addAttrValue($event, data.values);\" ng-hide=\"attribute.data_type == \'BOOLEAN\' || attribute.data_type == \'DATE\' || attribute.data_type == \'DATE_TIME\' || !multiple || (hideDeterminate && data.values.length < 2)\"><span class=add-item-icon></span></div></div><div class=\"help col-xs-1\"></div></div>");
$templateCache.put("app/catalog/directives/attributes/attributes.html","<div class=\"nestedDemo drop-zone-attr\"><!-- Main area with dropzones and source code --><div class=dropzone><ul dnd-list=data dnd-allowed-types=\"[\'root\']\" dnd-drop=\"dropCallback(index, item, external, type, data)\"><li ng-repeat=\"list in data track by $index\" class=dnd-element dnd-draggable=list dnd-type=\"\'root\'\" dnd-nodrag dnd-effect-allowed=move dnd-dragend=\"listMoved($index, list, data)\" dnd-selected=\"data.selected = list\" ng-if=\"(!list.attribute)? list.block.$$enabled : list.attribute.$$enabled\" ng-class=\"{\'has-error\': (list.attribute && list.attribute.uinqError)||(list.block && list.block.uinqError)}\" ng-attr-id=\"{{(list.attribute && list.attribute.uinqError)||(list.block && list.block.uinqError) ? \'errorAnchor\': \'\'}}\"><dnd-nodrag draggable=true class=\"clearfix attribute\" ng-class=\"{attributeContainer: !list.attribute}\"><div ng-hide=list.attribute class=container-element><div class=\"attr-block-head clearfix\"><h3 class=\"container-name pull-left\">{{list.block.name}}</h3><div class=\"container-buttons pull-right\"><div dnd-handle class=\"handle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Переместить draggable=true></div><span class=\"attr-pencil tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Редактировать ng-class=\"{minOpacity: list.block.inherited}\" ng-click=\"crudAttr($index, list.block, true);\"></span> <span class=\"attr-trash tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Удалить ng-if=!list.block.inherited ng-click=\"deleteAttr(list.block, category.name, false, $index)\"></span> <span class=\"glyphicon glyphicon-info-sign attr-info tooltip-light\" ng-if=list.block.inherited tooltip-placement=right uib-tooltip=\"Этот блок относится к категории верхнего уровня и он может быть отредактирован и удален только там\" style=\"font-size: 14px;\"></span></div></div><ul dnd-list=list.block.attributes dnd-allowed-types=\"[\'{{list.block.id || list.block.name}}\']\" dnd-drop=\"dropCallback(index, item, external, type, list.block.attributes)\"><li class=dnd-element ng-repeat=\"item in list.block.attributes track by $index\" dnd-draggable=item dnd-type=\"\'{{list.block.id || list.block.name}}\'\" dnd-effect-allowed=move dnd-moved=\"list.block.attributes.splice($index, 1)\" dnd-selected=\"data.selected = item\" ng-class=\"{selected: data.selected === item, \'has-error\': item.uinqError}\" ng-attr-id=\"{{(item.uinqError)? \'errorAnchor\': \'\'}}\" dnd-dragstart=\"hideParents(event, false)\" dnd-dragend=\"hideParents(event, true);listMoved($index, item, list.block.attributes)\" ng-if=item.$$enabled dnd-nodrag><dnd-nodrag draggable=true class=\"clearfix attribute\"><div class=item><div class=pull-left style=\"max-width: 84%;\"><div class=attr-name> {{item.name}} <span class=\"attr-star req\" ng-if=item.required></span> <span class=attr-parents ng-if=item.inherited>из <span ng-bind=item.inheritedFrom.name></span></span></div></div><div class=pull-right><div dnd-handle class=\"handle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Переместить draggable=true></div><span class=\"attr-pencil tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Редактировать ng-class=\"{minOpacity: item.inherited}\" ng-click=\"crudAttr($index, item, false, list.block);\"></span> <span class=\"attr-trash tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Удалить ng-if=!item.inherited ng-click=\"deleteAttr(item, category.name, list.block)\"></span> <span class=\"glyphicon glyphicon-info-sign attr-info tooltip-light\" tooltip-placement=right ng-if=item.inherited uib-tooltip=\"Этот атрибут относится к категории верхнего уровня и он может быть отредактирован и удален только там\" style=\"font-size: 14px;\"></span></div></div></dnd-nodrag><span class=\"valid-message isset-name\">{{item.errorText}}</span></li></ul><div class=clear></div></div><div ng-show=list.attribute class=item><div class=pull-left style=\"max-width: 84%;\"><div class=attr-name> {{list.attribute.name}} <span class=\"attr-star req\" ng-if=list.attribute.required></span> <span class=attr-parents ng-if=list.attribute.inherited>из <span ng-bind=list.attribute.inheritedFrom.name></span></span></div></div><!-- <div class=\"attr-type\" ng-if=\"list.attribute.data_type\" ng-bind=\"dataType[list.attribute.data_type]\"></div> --><div class=pull-right><div dnd-handle class=\"handle tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Переместить draggable=true></div><span class=\"attr-pencil tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Редактировать ng-class=\"{minOpacity: list.attribute.inherited}\" ng-click=\"crudAttr($index, list.attribute);\"></span> <span class=\"attr-trash tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Удалить ng-if=!list.attribute.inherited ng-click=\"deleteAttr(list.attribute, category.name, {})\"></span> <span class=\"glyphicon glyphicon-info-sign attr-info tooltip-light\" tooltip-placement=right ng-if=list.attribute.inherited uib-tooltip=\"Этот атрибут относится к категории верхнего уровня и он может быть отредактирован и удален только там\" style=\"font-size: 14px;\"></span></div></div></dnd-nodrag><span class=\"valid-message isset-name\" ng-bind=\"(!list.attribute)? list.block.errorText : list.attribute.errorText\"></span></li></ul></div><div class=add-item-wrap ng-click=crudAttr();><span class=add-item-icon></span> <span class=add-item-title>Атрибут</span></div><div view-source=nested></div></div>");
$templateCache.put("app/catalog/directives/grid-search/grid-search-row.html","<div class=clearfix><div class=\"checkbox pull-left\" style=\"margin-top: 11px\" ng-if=gridSearchRowCtrl.gridSearchCtrl.showCheckbox><label style=\"padding: 0; outline: none;\" ng-click=$event.stopPropagation()><input type=checkbox ng-change=gridSearchRowCtrl.checkChanged() ng-click=$event.stopPropagation() ng-model=gridSearchRowCtrl.item._checked> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><div><h4 ng-if=!gridSearchRowCtrl.withoutLinks class=search-label title=\"{{gridSearchRowCtrl.item.name}}\"><a ng-if=\"gridSearchRowCtrl.item.type === \'CATEGORY\'\"><span class=catalog-folder></span><span ng-click=gridSearchRowCtrl.expandTreePath(gridSearchRowCtrl.item.path) class=header-text>{{gridSearchRowCtrl.item.code}} {{gridSearchRowCtrl.item.name}}</span></a><a ng-if=\"gridSearchRowCtrl.item.type !== \'CATEGORY\'\" ng-click=gridSearchRowCtrl.catalogItemEvent() target=_blank style=\"cursor: pointer;\"><span class=header-text>{{gridSearchRowCtrl.item.code}} {{gridSearchRowCtrl.item.name}}</span></a></h4><h4 ng-if=gridSearchRowCtrl.withoutLinks class=search-label title=\"{{gridSearchRowCtrl.item.name}}\" style=\"margin-top: 6px;\"><span ng-if=\"gridSearchRowCtrl.item.type === \'CATEGORY\'\"><span class=catalog-folder></span><span class=header-text>{{gridSearchRowCtrl.item.code}} {{gridSearchRowCtrl.item.name}}</span></span><span ng-if=\"gridSearchRowCtrl.item.type !== \'CATEGORY\'\"><span class=header-text>{{gridSearchRowCtrl.item.code}} {{gridSearchRowCtrl.item.name}}</span></span></h4><p class=category-path><span class=category-path-item ng-show=pathItem.name ng-repeat=\"pathItem in gridSearchRowCtrl.item[gridSearchRowCtrl.gridSearchCtrl.parentProperty]\"><span ng-if=$index class=path-arrow></span> <span class=catalog-folder-muted title=\"{{pathItem.name}}\"></span> <a ng-click=gridSearchRowCtrl.expandTreePath(pathItem.path) href=\"\"><small class=\"text-muted path-text\">{{pathItem.name}}</small></a></span></p></div></div>");
$templateCache.put("app/catalog/directives/grid-search/grid-search.html","<div class=\"grid-search-container main-left-offset main-right-offset\" style=\"min-height: 400px\"><div grid-search-row without-links=gridSearchCtrl.withoutLinks class=grid-search-row item=item ng-repeat=\"item in gridSearchCtrl.results\"></div></div>");
$templateCache.put("app/catalog/directives/products-tab/products-tab.html","<ng-form name=\"{{formName}}\"><div class=\"grid grid-head-bg\" ui-grid=grid ui-grid-cellnav ui-grid-auto-resize ui-grid-pagination ng-class=\"{\'hide-pagination\': hidePagination}\"></div></ng-form><!-- <div class=\"pagination-wrapper\">\n	<div class=\"pagination-wrapper\">\n	  <paging page-info=\"paging\" callback=\"getPage\"/>\n	</div>\n</div> --><script type=text/ng-template id=articleTemplate.html><div class=\"ui-grid-cell-contents\">\n      <input class=\"article-edit\" type=\"text\"\n             required\n             name=\"code_{{row.entity.pos}}\"\n             maxlength=\"50\"\n             ng-model=\"row.entity.article\"\n             ng-keyup=\"grid.appScope.sendUniqueUpdateEvent(row.entity.article, row.entity.pos); \"\n             ng-class=\"{\'has-error\': formName[\'code_\' + row.entity.pos].$invalid}\"\n             ng-if=\"!grid.appScope.view\"\n             ng-blur=\"grid.appScope.uniqueCallback(row.entity)\">\n      <span ng-bind=\"row.entity.article\"  ng-if=\"grid.appScope.view\"></span>\n    </div></script><script type=text/ng-template id=goodsTemplate.html><div class=\"ui-grid-cell-contents\">\n    <span ng-bind=\"(row.entity.sku == \'com\')? \'Комитента\' : \'Собственный\'\"></span>\n  </div></script>");
$templateCache.put("app/catalog/directives/products-tab/products-tabs.html","<h3 class=modal-title>Перечень разных <span ng-bind=\"(productsTabsCtrl.isGoods)? \'складских позиций\' : \'видов услуги\'\"></span><br>{{name}}</h3><div class=description style=\"margin-bottom: 15px;\">На основании выбранных атрибутов сформирован следующий перечень видов <span ng-bind=\"(productsTabsCtrl.isGoods)? \'складских позиций\' : \'услуг\'\"></span> с разными характеристиками</div><div class=\"modal-main-text crud-entity\" ng-class=\"{\'no-tab\': !productsTabsCtrl.isGoods}\"><section class=\"form-group tab-form-group tabs-with-grid\" style=\"width: 100%;margin: 0;\"><scrollable-tabset api=productsTabsCtrl.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset active=productsTabsCtrl.activeTab><uib-tab ng-repeat=\"tab in productsTabsCtrl.packingTabs\" select=productsTabsCtrl.selectTab($index)><uib-tab-heading class=tab-heading><span ng-class=tab.className class=tab-icon></span> <span class=tab-title>{{tab.title}}</span></uib-tab-heading><div><products-tab active-form-name=_temp.activeFormName form-name=\"\'gridForm\' + $index\" grid-options=tab.grid valid=valid view=productsTabsCtrl.isView is-goods=productsTabsCtrl.isGoods></products-tab></div></uib-tab></uib-tabset></scrollable-tabset></section></div>");
$templateCache.put("app/catalog/import/modal/import-modal.html","<div class=import-wrap><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Импорт товаров и услуг</h3></div><div class=container><div class=\"gray-content statuses-wrapper\" style=\"min-height: 265px;\"><div class=\"warning text-left\" ng-if=showInfo><strong>ВНИМАНИЕ!</strong><br><br><br>Вы хотите начать импорт файла при наличии в нем ошибок. Если нажать кнопку \"Продолжить\", то в процессе импорта строки с ошибками будут игнорироваться и не загрузятся в систему.</div><label class=\"load-data-spinner pull-left\" ng-if=loadImport><div class=ui-spinner style=\"display: inline-block; vertical-align: middle; margin-right: 15px;\"></div>Подождите, проводится импорт данных</label><div class=\"success-check text-left\" ng-if=\"!loadImport && !showInfo && !loadError\">Импорт успешно завершен! <span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Успешно></span></div><div class=\"error-check text-center\" ng-if=\"!loadImport && !showInfo && !loadSuccess && loadError\"><div class=\"center-ico error-check-ico\"></div> {{errorMessage}} </div></div></div><div class=modal-footer><button class=\"btn pull-left\" ng-click=close() ng-if=\"showInfo || loadImport\">Отменить</button> <button class=\"btn btn-primary pull-right\" ng-click=import() ng-if=showInfo>Продолжить</button> <a ui-sref=\"catalog({parent: \'retail\'})\" class=\"btn btn-primary pull-right\" ng-if=\"!showInfo && loadSuccess\" ng-click=close();>В Каталог</a> <button class=\"btn pull-right\" ng-click=close() ng-if=\"!loadImport && !showInfo && !loadSuccess && loadError\">Закрыть</button></div></div>");
$templateCache.put("app/catalog/import/sections/1-load-file.html","<section class=\"form-group col-xs-12\" style=\"max-width: inherit;\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Успешно ng-if=vm.uploader.queue[0].isSuccess></span><h5 class=section-header ng-class=\"{\'no-margin\': vm.activeStep}\">1. ЗАГРУЗКА ФАЙЛА</h5><div class=load-data-wrap ng-if=!vm.activeStep nv-file-drop uploader=vm.uploader><input type=file id=load-data-field nv-file-select uploader=vm.uploader accept=.xml style=\"display: none\"><div class=start ng-if=\"(!vm.uploader.queue[0].progress || vm.uploader.queue[0].isCancel) && !vm.uploader.queue[0].isError && !vm.uploader.queue[0].isSuccess\"><label class=load-data-descr>Нажмите «Загрузить» или перетащите файл в эту область</label><label for=load-data-field class=\"btn pull-right btn-primary\">Загрузить</label></div><div class=load ng-if=\"vm.uploader.queue[0].progress && !vm.uploader.queue[0].isSuccess\"><label class=\"load-data-spinner pull-left\"><div class=\"ui-spinner pull-left\"></div>Загружаю</label><button class=\"btn pull-right\" ng-click=vm.uploader.queue[0].cancel()>Отмена</button></div><div class=success ng-if=vm.uploader.queue[0].isSuccess><label class=\"load-data-success text-success pull-left\">Файл «{{vm.uploader.queue[0].file.name}}» загружен</label><label for=load-data-field class=\"btn pull-right\">Загрузить</label></div><div class=error ng-if=vm.uploader.queue[0].isError><label class=\"load-data-error text-danger pull-left\">Ошибка при загрузке файла. <span ng-if=\"vm.fileError == \'format\'\">Неверный формат</span> <span ng-if=\"vm.fileError == \'size\'\">Размер файла превышает 5 МБ</span> <span ng-if=\"vm.fileError == \'empty\'\">Файл пуст</span></label><label for=load-data-field class=\"btn pull-right btn-primary\">Загрузить</label></div></div><div class=section-helper ng-show=!vm.activeStep style=\"margin-top: 16px\"><span class=text-danger>ВНИМАНИЕ!</span> Загружаемый файл должен быть не более 5 МБ в формате <strong>.xml</strong> <a href=https://trade365.online/schema/recs/catalog/domain-catalog.xsd target=_blank>(XSD)</a></div></section>");
$templateCache.put("app/catalog/import/sections/2-check-file.html","<section class=\"form-group col-xs-12\" style=\"max-width: inherit;\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Успешно ng-if=\"vm.activeStep > 1\"></span><h5 class=section-header ng-class=\"{\'no-margin\': vm.activeStep > 1}\">2. ПРОВЕРКА ФАЙЛА</h5><div ng-show=\"vm.activeStep == 1\" class=text-center><div class=load-check ng-show=!vm.fileErrors><div class=ui-spinner style=\"margin: 60px auto 15px;\"></div>Подождите, проводится анализ файла<br>на отсутствие ошибок</div><div class=success-check ng-show=\"vm.fileErrors && !vm.fileErrors.errors.length\"><span class=ok-check-ico></span> Ошибок не обнаружено</div><div class=\"error-check text-danger\" ng-show=\"vm.fileErrors && vm.fileErrors.errors.length\"><div class=error-check-ico style=\"margin: 60px auto 8px;\"></div><div ng-if=\"vm.fileErrors && vm.fileErrors.errors.length\">Внимание, в файле — {{vm.fileErrors.errors.length + \' \' + vm.errorCountStr}}.</div><div ng-if=\"vm.fileErrors.errors.length > 100\">Список первых 100:</div></div><table class=\"load-errors table text-left\" ng-show=\"vm.fileErrors && vm.fileErrors.errors.length\"><tr ng-repeat=\"error in vm.fileErrors.errors\"><td ng-bind=error.message></td></tr></table></div></section>");
$templateCache.put("app/catalog/import/sections/3-category-choice.html","<section class=\"form-group col-xs-12\" style=\"max-width: inherit;\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Успешно ng-show=\"vm.activeStep > 2\"></span><h5 class=section-header ng-class=\"{\'no-margin\': vm.activeStep > 2}\">3. Выбор категории</h5><div ng-if=\"vm.activeStep == 2\" class=choose-category>Укажите в какую категорию будет производиться загрузка данных из файла<div ng-scrollbars ng-scrollbars-config=vm.configScroll><catalog-tree min-height=270 root-visible=!vm.contains_without_categories expand-node=vm.expand root=vm.root selected-callback=vm.selectNode item-count=false load-callback=vm.onTreeLoaded></catalog-tree></div></div></section>");
$templateCache.put("app/catalog/modals/search-alco-item/search-alco-item.html","<div class=\"extended-search-popup extended-alco-search crud-entity\"><div class=modal-body style=\"padding-bottom: 32px;\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=searchCtrl.close()>×</button><div class=modal-main-text><h2 ng-bind=\"searchCtrl.viewMode? \'Детальная информация\' : \'Расширенный поиск\'\"></h2><span ng-if=\"searchCtrl.choseCatalogItem && searchCtrl.isShowForms2\"><strong>Наименование:</strong> {{searchCtrl.choseCatalogItem.full_name || searchCtrl.choseCatalogItem.name || \"-\"}}<br><strong ng-if=searchCtrl.choseCatalogItem.alc_code>Алкокод:</strong> {{searchCtrl.choseCatalogItem.alc_code || \"\"}} </span></div><form class=\"container row\" style=\"padding: 0; position: relative;\" name=searchCtrl.catalogItemSearchForm ng-submit=searchCtrl.search(true) controller=searchCtrl><div class=\"section control-box-wrapper col-xs-3\" ng-if=!searchCtrl.isShowForms2 ng-include=\"\'app/catalog/modals/search-alco-item/includes/control-box.html\'\" style=\"width: 340px;\"></div><div ng-class=\"(searchCtrl.isShowForms2)? \'col-xs-12\' : \'col-xs-7\'\" style=\"min-height: 446px;\"><div class=arrow-pointer ng-if=\"!searchCtrl.searchRes.length && !searchCtrl.notFound && !searchCtrl.onlyForm2\">Установите параметры и<br>нажмите кнопку \"Найти\"</div><div class=\"filter-not-found major-font\" ng-if=searchCtrl.notFound style=\"margin: 0px auto;\"><div class=big-danger-info-ico></div><div class=big-danger-info><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div></div><div class=search-items ng-if=\"searchCtrl.searchRes.length && !searchCtrl.isShowForms2\" style=\"position: relative;\"><div class=catalog-item-wrap ng-repeat=\"catalogItem in searchCtrl.searchRes\" ng-click=\"searchCtrl.choiceCatalogItem($event, catalogItem);\"><div class=catalog-item-names-wrap><span class=\"one-str tooltip-light hover-parent\">{{catalogItem.full_name}} {{(catalogItem.capacity)? catalogItem.capacity + \'л\' : \'\'}}</span><div class=\"hover-info tooltip\"><div class=tooltip-inner ng-bind-html=searchCtrl.getTip(catalogItem)></div></div><span class=catalog-item-code ng-if=catalogItem.alc_code>Алкокод: {{catalogItem.alc_code}}</span></div><div class=quontity ng-if=catalogItem.quantity> {{catalogItem.quantity}} {{(catalogItem.uom)? \' \' + catalogItem.uom.symbols + \'.\': \'\'}} </div><div class=\"arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Открыть список справок 2\" ng-if=!searchCtrl.withoutFn2></div></div><div class=table-footer><paging-customizable page-info=searchCtrl.paging callback=searchCtrl.search paging=searchCtrl.gridFooterPaging></paging-customizable></div></div><div class=derivatives-list ng-if=\"searchCtrl.isShowForms2 && !searchCtrl.notFound\" style=\"padding: 0\"><section class=\"form-group tab-form-group tabs-with-grid\" style=\"width: 100%;margin: 0;\"><grid-custom columns=searchCtrl.columns data=searchCtrl.forms2 page-callback=searchCtrl.getForms2 is-show-settings=false show-checkbox=false options=searchCtrl.gridOptions min-height=100 is-full-width=false allow-selected=true selected-callback=searchCtrl.selectDoc></grid-custom><div class=table-footer><paging-customizable page-info=searchCtrl.form2paging callback=searchCtrl.getForms2 paging=searchCtrl.gridForms2FooterPaging></paging-customizable></div></section></div><div class=loader-wrapper ng-if=searchCtrl.showLoader><div class=ui-spinner></div></div></div></form></div></div><script type=text/ng-template id=documentSearchHeaderCellTemplate.html><div class=\"default-header-cell\" ng-class=\"{\'word-break text-right\': gridCustomHeaderCtrl.column.field == \'home_amount\' || gridCustomHeaderCtrl.column.field == \'catalog_item_totals\'}\">\n    <span class=\"default-header-text\">\n      <span ng-bind=\"::gridCustomHeaderCtrl.column.name\"></span>\n    </span>\n  </div></script><script type=text/ng-template id=documentSearchNumberTemplate.html><div class=\"cell-data\" style=\"padding-top: 0px;\">\n    <span>{{searchCtrl.forms2.indexOf(value) + 1}}</span>\n  </div></script><script type=text/ng-template id=documentAlcoSearchTemplate.html><div class=\"cell-data single-line\" ng-class=\"{\'text-right\': column.field == \'alcohol_stock_quantity\'}\" style=\"padding: 0 0 0 24px;\">\n\n      <span ng-if=\"column.field == \'number\'\" ng-bind=\"searchCtrl.forms2.indexOf(value) + 1\"></span>\n\n      <div class=\"ellipsis\" ng-class=\"{\'link-style\': searchCtrl.needDocLink}\" ng-click=\"searchCtrl.goToDoc(value[column.field])\" target=\"_blank\" ng-if=\"column.field == \'document\'\" ng-bind=\"(value[column.field].document_egais_type | docEgaisType:\'short\') + \' №\' + value[column.field].doc_number + \' от \' + (value[column.field].doc_date | date:\'dd.MM.yyyy\')\" tooltip-placement=\"bottom-left\" uib-tooltip=\"{{(value[column.field].document_egais_type | docEgaisType) + \' №\' + value[column.field].doc_number + \' от \' + (value[column.field].doc_date | date:\'dd.MM.yyyy\')}}\"></div>\n\n      <div class=\"ellipsis\" ng-if=\"column.field == \'f2reg_id\'\" ng-bind=\"value[column.field]\" tooltip-placement=\"bottom-left\" uib-tooltip=\"{{value[column.field]}}\"></div>\n\n      <div class=\"ellipsis text-right custom-tooltip-wrap\" ng-if=\"column.field == \'alcohol_stock_quantity\'\" style=\"padding-right: 20px;\"> {{value.alcohol_stock_quantity || 0}} </div>\n      <div class=\"tooltip custom-tooltip\" style=\"top: 80%;\n        right: 0;\">\n        <div class=\"tooltip-inner\" ng-bind-html=\"searchCtrl.getTooltipStr(value);\"></div>\n      </div>\n\n  </div></script>");
$templateCache.put("app/catalog/modals/search-catalog-item/search-catalog-item.html","<div class=\"extended-search-popup crud-entity\"><div class=modal-body style=\"padding-bottom: 32px;\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=searchCtrl.close()>×</button><div class=modal-main-text ng-if=!searchCtrl.showCatalogTree><h2>Расширенный поиск</h2><a class=item-link ng-bind=searchCtrl.choseCatalogItem.name target=_blank ui-sref=\"catalogServices.view({elementId: searchCtrl.catalogItemId, parent: $state.params.parent})\" ng-if=\"searchCtrl.choseCatalogItem.type == \'SERVICE\'\"></a> <a class=item-link ng-bind=searchCtrl.choseCatalogItem.name target=_blank ui-sref=\"catalogSkus.view({elementId: searchCtrl.catalogItemId, parent: $state.params.parent})\" ng-if=\"searchCtrl.choseCatalogItem.type !== \'SERVICE\'\"></a></div><form class=\"container row\" style=\"padding: 0; position: relative;\" name=searchCtrl.catalogItemSearchForm ng-submit=searchCtrl.search(true) controller=searchCtrl ng-if=!searchCtrl.showCatalogTree><div class=\"col-xs-5 section control-box-wrapper\" ng-include=\"\'app/catalog/modals/search-catalog-item/includes/control-box.html\'\"></div><div class=\"col-xs-7 arrow-pointer\" ng-if=\"!searchCtrl.searchRes.length && !searchCtrl.notFound\">Установите параметры и<br>нажмите кнопку \"Найти\"</div><div class=\"col-xs-7 filter-not-found major-font\" ng-if=searchCtrl.notFound><div class=big-danger-info-ico></div><div class=big-danger-info><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div></div><div class=\"col-xs-7 search-items\" ng-if=\"searchCtrl.searchRes.length && !searchCtrl.isShowDerivatives\"><a class=catalog-item-wrap ng-repeat=\"catalogItem in searchCtrl.searchRes\" ng-click=\"searchCtrl.choiceCatalogItem($event, catalogItem);\" ui-sref=\"{{catalogItem.type === \'SERVICE\' ?\n           \'catalogServices.view({elementId: catalogItem.id, parent: $state.params.parent})\' :\n           \'catalogSkus.view({elementId: catalogItem.id, parent: $state.params.parent})\'}}\"><div class=catalog-item-names-wrap ng-class=\"{\'with-path\': searchCtrl.showPath}\"><span class=\"one-str tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"{{catalogItem.name}}\">{{catalogItem.name}}</span><span class=catalog-item-code ng-if=catalogItem.code>Код: {{catalogItem.code}}</span><div class=\"path-wrapper one-str tooltip-light\" tooltip-placement=bottom uib-tooltip=\"{{searchCtrl.getParentsStr(catalogItem.parentList)}}\" ng-if=searchCtrl.showPath><span class=parent-name ng-repeat=\"parent in catalogItem.parentList\"> {{parent.name}} <span class=arrow ng-if=\"$index < catalogItem.parentList.length - 1\"></span></span></div></div><div class=quontity ng-if=catalogItem.base_qty> {{catalogItem.base_qty}} {{(catalogItem.base_uom)? \' \' + catalogItem.base_uom.symbols + \'.\': \'\'}} <div class=\"divisions-qty-wrap text-left\"><div ng-repeat=\"qty in catalogItem.qty_views\" ng-if=qty.base_qty><span class=division-name ng-bind=qty.division.name ng-class=qty.division_type.toLowerCase()></span> <span class=division-qty ng-bind=\"qty.base_qty + ((catalogItem.base_uom)? \' \' + catalogItem.base_uom.symbols + \'.\': \'\')\"></span></div></div></div><div class=\"arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Открыть список складских позиций или видов услуг\" ng-if=searchCtrl.isDerivative></div></a><div class=table-footer><paging-customizable page-info=searchCtrl.paging callback=searchCtrl.search paging=searchCtrl.gridFooterPaging></paging-customizable><span class=\"path-button tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"{{(!searchCtrl.showPath)? \'Показать путь до позиции каталога\' : \'Скрыть путь до позиции каталога\'}}\" ng-class=\"{\'active\': searchCtrl.showPath}\" ng-click=\"searchCtrl.showPath = !searchCtrl.showPath\"></span></div></div><div class=\"col-xs-7 derivatives-list\" ng-if=\"searchCtrl.isShowDerivatives && !searchCtrl.notFound\" style=\"padding: 0\"><section class=\"form-group tab-form-group tabs-with-grid\" style=\"width: 100%;margin: 0;\"><scrollable-tabset api=searchCtrl.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset active=searchCtrl.activeTab><uib-tab ng-repeat=\"tab in searchCtrl.packingTabs\"><uib-tab-heading class=tab-heading><span ng-class=tab.className class=tab-icon></span> <span class=tab-title>{{tab.title}}</span></uib-tab-heading><div><derivatives-tab tab=tab list=searchCtrl.derivatives choise-callback=searchCtrl.choiceDerivative></derivatives-tab></div></uib-tab></uib-tabset></scrollable-tabset></section></div><div class=link-style ng-if=searchCtrl.createAlcoItem ng-click=\"searchCtrl.showCatalogTree = true;\" style=\"position: absolute;top: -26px;right: 0;\">Создать новый товар в каталоге</div><div class=\"col-xs-7 loader-wrapper\" ng-if=searchCtrl.showLoader><div class=ui-spinner></div></div></form><div ng-if=searchCtrl.showCatalogTree><div class=modal-main-text><h2>Выбрать категорию для нового товара</h2></div><div ng-scrollbars ng-scrollbars-config=searchCtrl.configScroll ng-if=!searchCtrl.noCategories><catalog-tree min-height=250 root-visible=false expand-node=searchCtrl.expand root=searchCtrl.root selected-callback=searchCtrl.selectNode item-count=false load-callback=searchCtrl.onTreeLoaded></catalog-tree></div><div ng-if=searchCtrl.noCategories class=text-center style=\"padding: 194px 0;\">В домене не создано ни одной категории,<br>вы можете <a ui-sref=\"category.new({parent: $state.params.parent})\">создать новую категорию</a></div><div class=modal-footer><button class=btn type=button ng-click=\"searchCtrl.showCatalogTree = false;\">Отменить</button></div><div class=\"col-xs-12 loader-wrapper\" style=\"margin-top: 120px;\" ng-if=searchCtrl.showTreeLoader><div class=ui-spinner></div></div></div></div></div>");
$templateCache.put("app/comparative/components/calendar/calendar.html","<div class=calendar-custom><div class=calendar-header></div><div class=calendar-all-body><div class=calendar-subbody></div><div class=calendar-body><div class=text-container><span class=date-text> {{calendarCtrl.day}} <span class=month ng-bind=calendarCtrl.month></span></span></div></div></div></div>");
$templateCache.put("app/comparative/components/compare/compare.html","<div class=\"compare-container clearfix\"><div class=col-xs-5 style=\"padding-top: 8px;\"><h4 ng-bind=compareCtrl.header></h4><span class=\"arrow up pull-right\" ng-if=\"compareCtrl.valueTo > compareCtrl.valueFrom\">&#8593;</span> <span class=\"arrow down pull-right\" ng-if=\"compareCtrl.valueTo < compareCtrl.valueFrom\">&#8595;</span><div ng-show=compareCtrl.procent class=\"badge pull-right\" ng-class=\"{\n        \'success\': compareCtrl.valueTo > compareCtrl.valueFrom,\n        \'default\': compareCtrl.valueTo == compareCtrl.valueFrom,\n        \'danger\': compareCtrl.valueTo < compareCtrl.valueFrom\n      }\"><span ng-bind=\"(compareCtrl.valueTo > compareCtrl.valueFrom)? \'+\' : \'\' \"></span><span ng-bind=\"compareCtrl.procent + \'%\'\"></span></div></div><div class=col-xs-7 style=\"padding-right: 0\"><div class=\"col-xs-6 text-right\"><div class=coin-wrap><span ng-if=compareCtrl.coin class=text-muted><span ng-bind=\"compareCtrl.valueFrom | currencySpacesShift\"></span> <span ng-bind=compareCtrl.symbol></span></span> <span ng-if=!compareCtrl.coin class=text-muted><span ng-bind=\"compareCtrl.valueFrom | currencySpaces\"></span> <span ng-bind=compareCtrl.symbol></span></span></div><div class=\"chart-container pull-right\"><div class=\"chart-from pull-right\" ng-style=\"{width: compareCtrl.widthFrom  + \'%\'}\"></div></div></div><div class=col-xs-6><div class=coin-wrap ng-class=\"{\'up\': compareCtrl.trendUp, \'down\': !compareCtrl.trendUp}\"><span ng-if=compareCtrl.coin ng-bind=\"compareCtrl.valueTo | currencySpacesShift\"></span> <span ng-if=!compareCtrl.coin ng-bind=\"compareCtrl.valueTo | currencySpaces\"></span> <small ng-bind=compareCtrl.symbol></small></div><div class=chart-container><div class=chart-to ng-style=\"{width: compareCtrl.widthTo  + \'%\'}\" ng-class=\"{\n          \'success\': compareCtrl.valueTo > compareCtrl.valueFrom,\n          \'danger\': compareCtrl.valueTo < compareCtrl.valueFrom\n        }\"></div></div></div></div></div>");
$templateCache.put("app/comparative/components/grid-custom/grid-custom-header-cell.html","<div class=header-cell-container header-template-with-tooltip></div>");
$templateCache.put("app/comparative/components/grid-custom/grid-custom-row-cell.html","<div class=row-cell-container></div>");
$templateCache.put("app/comparative/components/grid-custom/grid-custom-row.html","<div class=grid-custom-row tabindex=-1 ng-class=\"{\'selected\': gridCustomRowCtrl.row.$$selected}\" ng-click=gridCustomRowCtrl.setSelected($event)><div class=grid-row-flex-container><div style=\"min-width: 0;\" ng-style=\"::{\'flex\': (column.flex || 0) + \' \' + (column.flex || 0) + (column.width != undefined ? \' \' + column.width + \'px\': \'\'),\n                      \'width\': (column.width != undefined ? \' \' + column.width + \'px\': \'1%\')}\" ng-repeat=\"column in gridCustomRowCtrl.gridCustomCtrl.allColumns\" ng-show=\"::column.visible && column.column_visible\"><div><grid-custom-row-cell template-scope=::column.templateScope template-url=::column.templateUrl column=::column value=::gridCustomRowCtrl.row></grid-custom-row-cell></div></div></div></div>");
$templateCache.put("app/comparative/components/grid-custom/grid-custom-total-cell.html","<div class=total-cell-container header-template-with-tooltip></div>");
$templateCache.put("app/comparative/components/grid-custom/grid-custom.html","<script type=text/ng-template id=defaultCustomGridCellTemplate.html><div>\n    <span class=\"default-cell-text\" ng-bind=\"value.name\"></span>\n  </div></script><script type=text/ng-template id=checkboxGridCellTemplate.html><div class=\"checkbox pull-left\">\n    <label style=\"padding: 10px 0 0; outline: none;\" ng-click=\"$event.stopPropagation()\">\n      <input type=\"checkbox\"\n             ng-change=\"rowCtrl.gridCustomCtrl._checkRow(rowCtrl.row, \'{{rowCtrl.row.$$checked}}\')\"\n             ng-click=\"$event.stopPropagation()\"\n             ng-model=\"rowCtrl.row.$$checked\">\n      <span class=\"cr\" style=\"margin: 0 0 0 8px\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span>\n    </label>\n  </div></script><script type=text/ng-template id=trashGridCellTemplate.html><div>\n    <span class=\"glyphicon glyphicon-trash\" ng-click=\"gridCustomCtrl.removeCallback($index);\"></span>\n  </div></script><script type=text/ng-template id=defaultCustomGridHeaderCellTemplate.html><div class=\"default-header-cell\">\n    <span class=\"default-header-text\" ng-bind=\"gridCustomHeaderCtrl.column.name\"></span>\n  </div></script><script type=text/ng-template id=defaultGroupCustomGridHeaderCellTemplate.html><div class=\"group-default-header-cell\">\n    <span class=\"default-header-text\" ng-bind=\"gridCustomHeaderCtrl.column.name\"></span>\n  </div></script><div data-footer-absolute top-flag=headerButtonNotInTop class=header-absolute ng-class=\"{hide: !headerButtonNotInTop}\" ng-if=gridCustomCtrl.headerFixedTopOffset top-shift=\"{{gridCustomCtrl.headerFixedTopOffset}}\"><div class=grid-custom-container ng-class=\"{\'set-main-padding\': gridCustomCtrl.isFullWidth, \'with-checkboxes\': gridCustomCtrl.showCheckbox}\"><div class=grid-custom-header ng-hide=gridCustomCtrl.hideHeader><div ng-style=\"{\'flex\': (column.flex || 0) + \' \' + (column.flex || 0) + (column.width != undefined ? \' \' + column.width + \'px\': \'\'),\n                        \'width\': (column.width != undefined ? \' \' + column.width + \'px\': \'1%\')}\" ng-repeat=\"column in gridCustomCtrl.allColumns\" ng-show=\"column.visible && column.column_visible\"><div grid-custom-header-cell template-url=column.headerTemplateUrl template-header-scope=column.templateHeaderScope column=column></div><span class=caret ng-show=column.sortName ng-click=gridCustomCtrl.sortColumn(column) ng-class=column.sortDirection></span></div></div></div></div><div class=grid-custom-container ng-style=\"{\'min-height\': gridCustomCtrl.minHeight || 400}\" ng-class=\"{\'set-main-padding\': gridCustomCtrl.isFullWidth,\n                \'with-checkboxes\': gridCustomCtrl.showCheckbox,\n                \'two-level-header\': gridCustomCtrl.twoLevelHeader}\"><div class=grid-custom-header ng-hide=\"gridCustomCtrl.hideHeader || !gridCustomCtrl.twoLevelHeader\"><div ng-style=\"{\'flex\': (column.flex || 1) + \' \' + (column.flex || 1) + (column.width != undefined ? \' \' + column.width + \'px\': \'\'),\n                    \'width\': (column.width != undefined ? \' \' + column.width + \'px\': \'1%\'),\n                    \'max-width\': (column.width != undefined ? \' \' + column.width + \'px\': \'inherit\')}\" ng-repeat=\"column in gridCustomCtrl.topLevelHeaders\" ng-class=\"{\'with-bg\': column.name}\"><div grid-custom-header-cell class=full-width template-url=\"\'defaultGroupCustomGridHeaderCellTemplate.html\'\" template-header-scope=column.templateHeaderScope column=column></div></div></div><div class=grid-custom-header ng-hide=gridCustomCtrl.hideHeader><div ng-style=\"{\'flex\': (column.flex || 1) + \' \' + (column.flex || 1) + (column.width != undefined ? \' \' + column.width + \'px\': \'\'),\n                    \'width\': (column.width != undefined ? \' \' + column.width + \'px\': \'1%\'),\n                    \'max-width\': (column.width != undefined ? \' \' + column.width + \'px\': \'inherit\')}\" ng-repeat=\"column in gridCustomCtrl.allColumns\" ng-show=\"column.visible && column.column_visible\" ng-class=\"{\'no-parent\': !column.parent}\"><div grid-custom-header-cell template-url=column.headerTemplateUrl template-header-scope=column.templateHeaderScope column=column></div><span class=caret ng-show=column.sortName ng-click=gridCustomCtrl.sortColumn(column) ng-class=column.sortDirection></span></div></div><div class=grid-custom-body ng-scrollbars ng-scrollbars-config=gridCustomCtrl.configScroll ng-if=gridCustomCtrl.scrollHeight><div grid-custom-row class=grid-custom-row-container ng-form=\"rowForm{{$index}}\" row=row ng-repeat=\"row in (gridCustomCtrl.data\n          | groupCustom: gridCustomCtrl.groupFunction\n          | filter:gridCustomCtrl.discriminatorFn\n          | filter:gridCustomCtrl._externalFilterFn\n          | limitTo:(gridCustomCtrl.pagingOptions.enablePaging ? gridCustomCtrl.paging.limit : gridCustomCtrl.data.length):gridCustomCtrl.paging.offset)\n          \" ng-class=\"{\'grid-parent\': row.parent}\"></div></div><div class=grid-custom-body ng-if=!gridCustomCtrl.scrollHeight><div grid-custom-row class=grid-custom-row-container ng-form=\"rowForm{{$index}}\" row=row index=$index ng-repeat=\"row in (gridCustomCtrl.data\n          | groupCustom: gridCustomCtrl.groupFunction\n          | filter:gridCustomCtrl.discriminatorFn\n          | filter:gridCustomCtrl._externalFilterFn\n          | limitTo:(gridCustomCtrl.pagingOptions.enablePaging ? gridCustomCtrl.paging.limit : gridCustomCtrl.data.length):gridCustomCtrl.paging.offset)\n          \" ng-class=\"{\'grid-parent\': row.parent}\"></div></div><div class=total-wrapper ng-if=gridCustomCtrl.totalsData ng-class=\"{\'set-main-padding\': gridCustomCtrl.isFullWidth, \'with-checkboxes\': gridCustomCtrl.showCheckbox}\"><div ng-repeat=\"column in gridCustomCtrl.allColumns\" ng-style=\"{\'flex\': (column.flex || 0) + \' \' + (column.flex || 0) + (column.width != undefined ? \' \' + column.width + \'px\': \'\'), \'width\': (column.width != undefined ? \' \' + column.width + \'px\': \'1%\')}\"><div grid-custom-total-cell template-url=column.totalTemplateUrl template-header-scope=column.templateScope totals-data=gridCustomCtrl.totalsData column=column></div></div></div><div class=table-footer ng-if=gridCustomCtrl.pagingOptions.enablePaging><div class=pagination-wrapper><paging page-info=gridCustomCtrl.paging callback=gridCustomCtrl.recreatePaging></div></div></div>");
$templateCache.put("app/components/cellTemplates/cell-cash-register-transfer/cell-cash-register-transfer.html","<div class=\"ui-grid-cell-contents cell-with-popup crud-entity\"><div class=cash-machine ng-repeat=\"cashMash in (rowEntity.cash_registers) | limitTo: 3\"><span class=cash-machine-ico ng-class=\"(cashMash.enabled)? \'onCash\': \'offCash\'\" ng-click=showInfoDialog($event,$index)><div class=cash-machine-info ng-if=showInfo[$index]><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=closeInfo($event,$index)></button> <span class=cash-machine-info-name>{{cashMash.manufacturer}} {{cashMash.model}}</span><span class=cash-machine-info-serial>№ {{cashMash.serial_number}}</span><span class=cash-machine-info-status ng-class=\"{\'active\': cashMash.enabled}\" ng-bind=\"(cashMash.enabled)? \'активен\': \'не активен\'\"></span> <span class=cash-machine-info-place-label ng-if=cashMash.place>Кассовое место</span> <span class=cash-machine-info-place>{{cashMash.place.name}}</span><button ng-if=\"$root.hasRole(\'cash_register.change_company\')\" class=btn style=\"width: 100%;\" ng-click=showTransferDialog($event,$index)>Переместить</button></div><div class=transfer-cash ng-if=showTransfer[$index]><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=closeTransfer($event,$index)></button> <span class=title-transfer-cash>ПЕРЕМЕЩЕНИЕ</span> <span class=cash-machine-info-name>{{cashMash.manufacturer}} {{cashMash.model}}</span><span class=cash-machine-info-serial>№ {{cashMash.serial_number}}</span><span class=cash-machine-info-status ng-class=\"{\'active\': cashMash.enabled}\" ng-bind=\"(cashMash.enabled)? \'активен\': \'не активен\'\"></span><div class=form-group><ui-select on-select=resetPlaces() ng-model=divisions.value required search-enable=divisions.getSearchEnabled($select) ng-disabled=divisions.getDisabled($select)><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=divisions.refresh($select.search) repeat=\"division in (divisions.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"division.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Подразделение</label></div><div class=form-group><ui-select ng-model=places.value ng-disabled=\"!divisions.value.cash_register_places.length || divisions.value.cash_register_places.length === 0\"><ui-select-match allow-clear=true><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item in (divisions.value.cash_register_places | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Кассовое место</label></div><div class=form-group><button class=\"btn btn-primary\" style=\"width: 100%;\" ng-disabled=\"!isChanged(cashMash, places.value)\" ng-click=transferCash(cashMash,divisions.value,places.value)>ПОДТВЕРДИТЬ</button></div></div></span></div><div class=more-element ng-if=\"rowEntity.cash_registers.length > 3\" data-ng-click=$event.stopPropagation()><span ng-click=\"showInfoDialog($event, $index + 3)\">&nbsp;+&nbsp;{{rowEntity.cash_registers.length - 3}}&nbsp;{{show}}</span><div class=more-element-helper ng-repeat=\"cashMash in (rowEntity.cash_registers | limitTo: 1) track by $index \" ng-class=\"{\'big\': showTransfer[$index + 3]}\" ng-if=\"showInfo[$index + 3]\"><div class=helper-header ng-show=\"!showTransfer[$index + 3]\"><div class=counter><span class=kkm-prev ng-class=\"{\'muted\': !$index}\" ng-click=\"$index = changeIndexMinus($index)\"></span> <span class=kkm-num>{{$index + 1}}</span><span class=kkm-next ng-class=\"{\'muted\': $index + 1 === rowEntity.cash_registers.length - 3 }\" ng-click=\"$index = changeIndexPlus($index)\"></span></div><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=\"closeMore($index + 3)\"></button></div><div class=\"helper-content cash-machine-info\" ng-if=\"!showTransfer[$index + 3]\"><span class=cash-machine-info-name>{{rowEntity.cash_registers[$index + 3].manufacturer}} {{rowEntity.cash_registers[$index + 3].model}}</span><span class=cash-machine-info-serial>№ {{rowEntity.cash_registers[$index + 3].serial_number}}</span><span class=cash-machine-info-status ng-class=\"{\'active\': rowEntity.cash_registers[$index + 3].enabled}\" ng-bind=\"(rowEntity.cash_registers[$index + 3].enabled)? \'активен\': \'не активен\'\"></span> <span class=cash-machine-info-place-label ng-if=\"rowEntity.cash_registers[$index + 3].place\">Кассовое место</span> <span class=cash-machine-info-place>{{rowEntity.cash_registers[$index + 3].place.name}}</span><button class=btn style=\"width: 100%; margin-left: -5px\" ng-click=\"showTransferDialog($event, $index + 3);\" ng-if=\"$root.hasRole(\'cash_register.change_company\')\">Переместить</button></div><div class=transfer-cash ng-if=\"showTransfer[$index + 3]\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=closeTransfer($event,$index)></button> <span class=title-transfer-cash>ПЕРЕМЕЩЕНИЕ</span> <span class=cash-machine-info-name>{{rowEntity.cash_registers[$index + 3].manufacturer}} {{rowEntity.cash_registers[$index + 3].model}}</span><span class=cash-machine-info-serial>№ {{rowEntity.cash_registers[$index + 3].serial_number}}</span><span class=cash-machine-info-status ng-class=\"{\'active\': rowEntity.cash_registers[$index + 3].enabled}\" ng-bind=\"(rowEntity.cash_registers[$index + 3].enabled)? \'активен\': \'не активен\'\"></span><div class=form-group><ui-select on-select=resetPlaces() ng-model=divisions.value required search-enable=divisions.getSearchEnabled($select) ng-disabled=divisions.getDisabled($select)><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=divisions.refresh($select.search) repeat=\"division in (divisions.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"division.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Подразделение</label></div><div class=form-group><ui-select ng-model=places.value ng-disabled=\"!divisions.value.cash_register_places.length || divisions.value.cash_register_places.length === 0\"><ui-select-match allow-clear=true><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item in (divisions.value.cash_register_places | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Кассовое место</label></div><div class=form-group><button class=\"btn btn-primary\" style=\"width: 100%;\" ng-disabled=\"!isChanged(rowEntity.cash_registers[$index + 3], places.value)\" ng-click=\"$index = 0;transferCash(rowEntity.cash_registers[$index + 3],divisions.value,places.value)\">ПОДТВЕРДИТЬ</button></div></div></div></div></div>");
$templateCache.put("app/components/cellTemplates/cell-date-picker-filter/cell-date-picker-filter.html","<div class=\"datepicker-wrap for-filter ui-grid-filter-container\"><div ng-repeat=\"colFilter in col.filters\" ng-if=\"parentScope.ctrl.showFilter && model\"><div date-range-picker ng-model=model state=s class=datepicker-wrap opts=opts name=\"{{name}}\" on-close=\"callback(returnValue, name)\"></div></div></div>");
$templateCache.put("app/components/cellTemplates/cell-for-footer/cell-for-footer.html","<div class=grid-tooltip> {{  totalValue | moneyFilter }} </div>");
$templateCache.put("app/components/cellTemplates/cell-for-gtins/cell-for-gtins.html","<cell-with-tooltip text=text></cell-with-tooltip>");
$templateCache.put("app/components/cellTemplates/cell-multiple-select-filter/cell-multiple-select-filter.html","<div class=\"select-wrap for-filter ui-grid-filter-container\"><multiselect class=multiselect ng-model=col.filters[0].term options=col.filters[0].selectOptions show-search=false display-prop=label id-prop=value model-save-field=value search-limit=100 labels=\"{select: \'Выберите\', itemsSelected: (col.filters[0].term.length < 5)? \' значения\' : \' значений\'}\" ng-disabled=!col.filters[0].selectOptions show-tooltip=true></multiselect><span class=close-button ng-click=onCloseButtonClick() ng-show=col.filters[0].term.length><i class=\"glyphicon glyphicon-remove\"></i></span></div>");
$templateCache.put("app/components/cellTemplates/cell-select-filter/cell-select-filter.html","<div class=\"select-wrap for-filter ui-grid-filter-container\"><ui-select ng-model=col.filters[0].term search-enabled=false append-to-body=true class=filter-select name=\"{{col.colDef.filterName}}\"><ui-select-match allow-clear=true placeholder=Выберите title=\"{{$select.selected.label}}\"><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"type.value as type in col.filters[0].selectOptions\"><div ng-bind=type.label title=\"{{type.label}}\"></div></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div>");
$templateCache.put("app/components/cellTemplates/cell-with-requested-data/cell-with-requested-data.html","<div class=ui-grid-cell-contents ng-click=\"$event.stopPropagation(); onCellClick() \" ng-class=\"{\'request-cell\': config.row.stock_accounting_type !== \'SIMPLE\' && !reserve && getText()}\"><span class=pull-right ng-bind=\"getText() | formattedAmount\" ng-class=\"{\'link-style\': !!config.clickCallback}\" ng-click=\"config.clickCallback(config.row, config.currentFilters, config.stockType);\"></span><div class=info-box ng-style=\"{\'top\': ((config.index < 15)? height + \'px\' : \'inherit\'), \'bottom\': ((config.index < 15)? \'inherit\' : \'100%\')}\" ng-show=showPopup><button class=\"btn only-ico\" ng-click=\"$event.stopPropagation();showPopup = false\"><span class=\"btn-close-bold btn-ico\"></span></button><div class=\"no-data text-center\" ng-if=!paging.total style=\"padding: 1px 27px;\">Нет данных</div><div ng-if=\"mode === \'BY_LOTS\' && paging.total\"><div ng-repeat=\"lot in requestedData\"><span class=bold-text ng-bind=getLotStr(lot);></span> <span style=\"margin-bottom: 8px;\">{{lot.quantity}} {{uomSymbol}}.</span></div></div><div ng-if=\"mode === \'BY_SERIAL_NUMBERS\' && paging.total\"><span class=bold-text style=\"margin-bottom: 8px;\">Серийные номера</span> <span ng-repeat=\"number in requestedData\"> {{number.serial_number}}&nbsp;</span></div><div ng-if=\"mode === \'RESERVES\' && paging.total\"></div><span ng-if=\"paging.offset !== 0 && paging.total\" ng-click=backward()>←</span> <span ng-if=\"paging.total > paging.offset + paging.limit && paging.total\" ng-click=forward()>→</span></div><div class=bg-helper ng-show=showPopup ng-click=\"$event.stopPropagation();showPopup = false\"></div></div>");
$templateCache.put("app/components/cellTemplates/cell-with-tooltip/cell-with-tooltip.html","<div class=ui-grid-cell-contents><span ng-class=\"{\'pull-right\': pullRight}\" ng-bind-html=text></span></div>");
$templateCache.put("app/components/cellTemplates/cell-with-tooltip-money/cell-with-tooltip-money.html","<div class=ui-grid-cell-contents><span>{{(text !== null && text !== undefined) ? ((text/100 | currency : \'\' : 2)| toDotFilter) || text : \'\' }} {{(currencySymbol && (+text || text === 0)) ? currencySymbol : null}}</span></div>");
$templateCache.put("app/components/cellTemplates/grid-menu/grid-menu.html","<div class=\"modal modal-open ui-grid-menu simpleDemo\" ng-if=shown style=\"display: block; max-width: 100%\"><style ui-grid-style>{{dynamicStyles}}</style><div class=\"modal-dialog modal-small-width ui-grid-menu-mid\" ng-show=shownMid><div class=\"modal-content ui-grid-menu-inner\" ng-click=clickModal($event)><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=modal ng-click=hideMenu()>&times;</button><h3 class=modal-title>Отображение колонок</h3></div><div class=container><div class=modal-description>Вы можете настроить отображение любых колонок из списка и, перетаскивая их, задать порядок следования</div><div ng-scrollbars ng-scrollbars-config=configScroll class=columns-wrapper><ul class=ui-grid-menu-items dnd-list=columnDefs dnd-drop=\"dropCallback(index, item, external, type, columnDefs)\"><li ng-repeat=\"item in columnDefs track by $index\" class=\"ui-grid-menu-item ui-item-{{item.name}}\" dnd-draggable=item dnd-dragend=\"listMoved($index, item, columnDefs)\" dnd-effect-allowed=move dnd-selected=\"models.selected = item\" ng-class=\"{\'selected\': columnDefs.selected === item}\" ng-hide=!item.displayName><dnd-nodrag class=display-flex ng-if=!item.pinned><div class=checkbox><label><input type=checkbox ng-model=item.settedVisibility> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><div class=menu-item-name><span ng-bind-html=item.displayName></span><div dnd-handle=\"\" class=handle></div></div></dnd-nodrag></li></ul></div></div><div class=modal-footer><button class=btn ng-mousedown=default()>По умолчанию</button> <button class=\"btn btn-primary\" ng-mousedown=save()>Применить</button></div></div></div></div>");
$templateCache.put("app/components/gird-wide-addons/filter-block/filter-block.html","<form name=filtersForm role=search class=filters-static-form><div class=\"form-group search-entity col-xs-3\" ng-if=!config.hideSearch><label class=label ng-bind=\"config.searchLabel || \'Поиск\'\"></label><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text ng-model=searchText.search class=form-control placeholder=\"{{(config.searchPlaceholder)? config.searchPlaceholder : \'По названию, коду, атрибуту\'}}\"></div><div ng-repeat=\"field in fields\"><div ng-if=\"field.type === \'select\'\" class=form-group ng-class=\"field.class || \'col-xs-3\'\" style=\"min-height: 52px;\"><label class=label>{{field.name}}</label><ui-select ng-model=filterData[field.code] ng-disabled=field.disabled name=\"{{field.code}}\" search-enabled=!!field.refresh on-select=\"onSelect($select.selected, field.code, field)\" class=slim-control ng-required=field.required><ui-select-match allow-clear=\"{{!field.required}}\" placeholder=\"{{field.placeholder}}\"><span bind-html-compile=field.selectMatchPattern></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=field.refresh($select.search) repeat=\"item.id as item in (field.items | filter: $select.search) track by $index\"><span bind-html-compile=field.selectChoicesPattern title-ext=field.selectChoicesPattern></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req ng-if=field.required></span><div class=\"valid-message required-mess small-offset\">Поле является обязательным</div></div><div ng-if=\"field.type === \'multiselect\'\" class=form-group ng-init=\"filterData[field.code] = filterData[field.code] || []; multiselectCode = field\" ng-class=\"field.class || \'col-xs-3\'\"><label class=label>{{field.name}}</label><multiselect-wrapper ng-model=filterData[field.code] settings=field change=changeMultiselect></multiselect-wrapper></div><div ng-if=\"field.type === \'custom_multiselect\'\" class=form-group ng-class=\"field.class || \'col-xs-3\'\"><label class=label>{{field.name}}</label><custom-multi-choose selected-arr=filters[field.code] get-data=field.refresh view-patern=field.selectMatchPattern limit=field.limit selected-patern=field.selectedPattern sort-by=field.sortBy></custom-multi-choose></div><div ng-if=\"field.type === \'date\'\" class=form-group ng-class=\"field.class || \'col-xs-3\'\"><label class=label>{{field.name}}</label><div date-range-picker state=dateStates[field.code] ng-model=filterData[field.code] opts=\"field.opts || {singleDatePicker: true, correctTimeZone: false}\" class=\"datepicker-wrap range-picker\" name=\"{{field.code}}\" ng-required=field.required on-close=\"onDatePickerClose(returnValue, name);\"></div></div><div ng-if=\"field.type === \'dateRange\'\" class=form-group ng-class=\"field.class || \'col-xs-3\'\"><label class=label>{{field.name}}</label><div date-range-picker ng-model=filterData[field.code] state=dateStates[field.code] opts=\"{singleDatePicker: false, correctTimeZone: false, fullRangeRequired: true, allTimePlaceholder: \' \'}\" class=datepicker-wrap name=\"{{field.code}}\" ng-required=field.required on-close=\"onDatePickerClose(returnValue, name);\"></div></div><div ng-if=\"field.type === \'categorySearch\'\" class=form-group ng-class=\"field.class || \'col-xs-3\'\"><label class=label>{{field.name}}</label><input-category ng-model=filterData[field.code] field-name=::field.code on-close=::onCategoryPopupClose is-slim-control=true></input-category></div><div ng-if=\"field.type === \'checkbox\'\" class=form-group ng-class=\"field.class || \'col-xs-4\'\" style=\"margin: 22px 0 0;\"><div class=check-wrapper><div class=checkbox style=\"display: inline-block; vertical-align: top;\"><label><input type=checkbox ng-change=\"onCheckBoxChange(filterData[field.code], field.code)\" ng-model=filterData[field.code] id=\"{{field.code}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{field.code}}\" class=checkbox-label ng-bind=field.name style=\"font-size: 14px; margin-top: -4px; line-height: 1.2; max-width: calc(100% - 45px);\"></label></div></div><div class=form-group ng-if=\"field.type === \'integer\'\" ng-class=\"field.class || \'col-xs-6\'\" style=\"padding: 0px\"><label class=label>{{field.name}}</label><div class=\"form-group col-xs-{{field.inputSize}}\" style=\"margin-bottom: 0;\"><input type=text class=form-control min-val=::0 ng-model=filterData[field.code] ng-change=\"onInputChange(filterData[field.code], field.code)\" integer-input ng-disabled=field.disabled ng-required=field.required> <span class=req ng-if=field.required style=\"top: 4px;\"></span></div></div><div class=form-group ng-if=\"field.type === \'string\'\" ng-class=\"field.class || \'col-xs-6\'\" style=\"padding: 0px\"><label class=label>{{field.name}}</label><div class=\"form-group col-xs-{{field.inputSize}}\" style=\"margin-bottom: 0;\"><input type=text class=form-control ng-model=filterData[field.code] ng-change=\"onInputChange(filterData[field.code], field.code)\" ng-disabled=field.disabled ng-required=field.required> <span class=req ng-if=field.required></span></div></div></div><button class=\"btn slim-button pull-right\" ng-disabled=\"!isValidForm || filtersForm.$invalid\" ng-click=\"filtersForm.$valid && isValid() && searchTrigger(filters, true)\" style=\"margin-right: 15px;\">Поиск</button></form>");
$templateCache.put("app/components/inputs/activity-areas/activity-areas.html","<div class=choosen-items ng-class=\"{\'has-error\': activityAreasCtrl.hasError}\"><label class=form-control-label ng-bind=\"activityAreasCtrl.fieldName || \'Сфера деятельности\'\"></label><div ng-if=!activityAreasCtrl.areas.length style=\"padding: 7px 10px;\">Нет значений</div><div ng-repeat=\"area in activityAreasCtrl.areas\" class=catalog-item><span class=catalog-item-name ng-bind=area.name></span> <span class=\"glyphicon glyphicon-trash\" ng-click=activityAreasCtrl.removeItemData($index); style=\"float: right;\"></span></div></div><div class=\"valid-message required-mess\" ng-if=activityAreasCtrl.isRequired>Поле является обязательным</div><span class=req ng-if=activityAreasCtrl.isRequired style=\"right: -12px;\"></span><div class=add-item-wrap ng-click=activityAreasCtrl.activityAreasPopup()><span class=add-item-icon></span> <span class=add-item-title>Сфера деятельности</span></div>");
$templateCache.put("app/components/inputs/category-input/category-input.html","<div class=category-field style=\"position: relative;\"><ui-select ng-model=inputCategoryCtrl.model class=\"without-group-label no-caret {{inputCategoryCtrl.selectClass}}\" name=\"{{inputCategoryCtrl.fieldName}}\" search-enabled=true ng-required=inputCategoryCtrl.required title=\"{{inputCategoryCtrl.model.name}}\" on-select=inputCategoryCtrl.onChange($select.selected) ng-class=\"{\'slim-control\': inputCategoryCtrl.isSlimControl, \'autocomplete-select\': inputCategoryCtrl.itemsTotal > inputCategoryCtrl.optionLength, \'category-select\': inputCategoryCtrl.onlyAutocomplete, \'open-up\': inputCategoryCtrl.position == \'up\'}\"><ui-select-match allow-clear=\"{{!inputCategoryCtrl.disableClearance}}\" placeholder=\"{{(inputCategoryCtrl.hasPlaceholder)? \'Все товары и услуги\' : \'\'}}\"><span class=catalog-folder style=\"margin-right: 10px;\" ng-if=inputCategoryCtrl.onlyAutocomplete></span><span bind-html-compile=inputCategoryCtrl.selectMatchPattern></span></ui-select-match><ui-select-choices position=\"{{inputCategoryCtrl.position}}\" refresh-delay=100 refresh=inputCategoryCtrl.refresh($select.search) repeat=\"item in (inputCategoryCtrl.items | filter: $select.search) track by $index\" group-by=inputCategoryCtrl.totalStr><span bind-html-compile=inputCategoryCtrl.selectChoicesPattern title=\"{{item.name}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req style=\"right: -12px;\" ng-if=inputCategoryCtrl.required></span><label class=\"form-control-label small-offset\" ng-bind=inputCategoryCtrl.label></label><span ng-click=inputCategoryCtrl.openChooseCategoryDialog() class=\"btn btn-ico-wrap btn-on-field tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Выбрать категорию\" style=\"margin-bottom: -10px;\" ng-if=\"!inputCategoryCtrl.onlyAutocomplete && !inputCategoryCtrl.model\"><span class=\"btn-ico btn-outline-folder\" style=\"width: 22px; height: 20px; margin: 0;\"></span></span></div>");
$templateCache.put("app/components/inputs/checkbox/checkbox.html","<div><div class=\"checkbox pull-left\"><label><input type=checkbox ng-disabled=mode id=\"{{checkboxId}}\" ng-model=model> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{checkboxId}}\" class=checkbox-label>{{text}}</label></div>");
$templateCache.put("app/components/inputs/combobox/combobox.html","<div class=\"form-group combobox-wrapper\"><input class=form-control type=text ng-model=vm.name placeholder=\"{{placeholder}}\" empty-to-null clear-button ng-keyup=vm.keyUp(vm.name) ng-paste=vm.keyUp(vm.name) ng-required=isRequired title=\"{{title}}\" id=\"{{idName}}\" name=\"{{idName}}\" maxlength=\"{{maxlength}}\" ng-disabled=\"{{isDisabled}}\" ng-focus=vm.changeIsOpen(true) ng-blur=\"vm.changeIsOpen(false); blurEvent(vm.name);\"><div class=\"valid-message required-mess\">Поле является обязательным</div><label for=\"{{idName}}\" class=\"form-control-label small-offset\" ng-bind=fieldLabel></label><span class=req ng-if=isRequired></span><ul class=dropdown-menu ng-if=arrItems.length style=\"display: block;\"><li ng-repeat=\"item in (arrItems) | limitTo:5 track by $index\" ng-click=vm.choose(item) ng-bind-html=\"item[param] | highlight: vm.name\"></li><li class=dropdown-footer ng-if=\"arrItems.length < total\"><span class=pull-left ng-bind=\"\'Показано \' + arrItems.length + \' из \' + total\"></span> <span class=pull-right>уточните запрос</span></li></ul></div>");
$templateCache.put("app/components/inputs/custom-multiselect/custom-multiselect.html","<div class=custom-multiselect-wrapper><div ng-scrollbars ng-scrollbars-config=customMultiselect.configScroll ng-scrollbars-update=customMultiselect.callbacks.updateScrollbar><div ng-repeat=\"item in customMultiselect.list\" ng-class=\"{\'active\': item.$$selected}\" class=\"select-item ellipsis\"><span class=ellipsis bind-html-compile=customMultiselect.viewPatern ng-click=customMultiselect.clickItem(item);></span> <span class=cross ng-click=customMultiselect.removeItem(item); ng-if=item.$$canDelete></span></div></div></div><span class=pull-right ng-if=!customMultiselect.isOneSelected>Выбрано: {{customMultiselect.selected.length || 0}}</span>");
$templateCache.put("app/components/inputs/custom-ui-multiselect/custom-ui-multiselect.html","<div class=ui-multiselect-wrapper><div class=\"form-control dropdown dropdown-toggle ellipsis\" data-toggle=dropdown><span ng-repeat=\"item in customUiMultiselectCtrl.selectedItems\"><span ng-if=$index>, </span><span bind-html-compile=customUiMultiselectCtrl.viewPatern></span> </span><span class=caret></span></div><ul class=\"dropdown-menu dropdown-menu-form\" style=\"min-width: 96.5%;\"><li class=ellipsis ng-click=customUiMultiselectCtrl.resetAll($event)><span style=\"padding: 0 0 0 17px;\" class=link-style>Сбросить все</span></li><li class=\"select-item ellipsis\" ng-repeat=\"item in customUiMultiselectCtrl.selectedItems\"><span class=ellipsis bind-html-compile=customUiMultiselectCtrl.viewPatern title-ext=customUiMultiselectCtrl.viewPatern ng-click=\"customUiMultiselectCtrl.removeItem($event, $index);\"></span></li><li class=search-wrapper><input type=text class=form-control placeholdef=Поиск ng-model=customUiMultiselectCtrl.search_string ng-keyup=customUiMultiselectCtrl.searchItem()></li><li ng-repeat=\"item in customUiMultiselectCtrl.list\" class=ellipsis><span class=ellipsis bind-html-compile=customUiMultiselectCtrl.viewPatern title-ext=customUiMultiselectCtrl.viewPatern ng-click=\"customUiMultiselectCtrl.clickItem($event, $index, item);\"></span></li><li class=total-wrap ng-if=customUiMultiselectCtrl.total ng-bind=\"\'Показано \' + customUiMultiselectCtrl.list.length + \' из \' + customUiMultiselectCtrl.total\"></li></ul></div>");
$templateCache.put("app/components/inputs/multiselect-wrapper/multiselect-wrapper.html","<div class=\"multiselect slim-control\" ng-class=\"{\'text-muted\': !multiselectCtrl.model.length}\" ng-dropdown-multiselect=\"\" translation-texts=\"multiselectCtrl.settings.translationTexts || multiselectCtrl.translationTexts\" events=multiselectCtrl.multiselectEvents options=multiselectCtrl.settings.items selected-model=multiselectCtrl.model extra-settings=multiselectCtrl.settings.options></div>");
$templateCache.put("app/components/inputs/okpo-input/okpo-input.html","<div class=okpo-wrapper ng-form=vm.okpoForm><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=okpo id=okpo ng-model=vm.company.organization.legal_requisites.okpo ng-keyup=vm.keyupInput() ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.okpo\" ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=okpo class=form-control-label>ОКПО</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.okpo\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message wrong-okpo-mess\">Некорректный ОКПО</div></div>");
$templateCache.put("app/components/inputs/okved-input/okved-input.html","<div style=\"position: relative;height: 48px;\" ng-form=okvedContainer tooltip-placement=right uib-tooltip=\"{{(vm.mode)? vm.company.organization.legal_requisites.okved_name : \'\'}}\"><input empty-to-null type=text class=\"dropdown-toggle form-control input-address\" name=okved id=okved data-toggle=dropdown ng-model-options=\"{allowInvalid: true}\" ng-change=vm.refresh(vm.company.organization.legal_requisites.okved) ng-model=vm.company.organization.legal_requisites.okved ng-blur=\"vm.refresh(vm.company.organization.legal_requisites.okved, true)\" ng-hide=\"vm.mode && !vm.company.organization.legal_requisites.okved\" maxlength=10><label for=okved class=form-control-label>Код основного вида деятельности по ОКВЭД</label><div ng-if=\"vm.mode && !vm.company.organization.legal_requisites.okved\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message wrong-okved-code-mess\">Недопустимое значение для кода ОКВЭД</div><div ng-bind=vm.company.organization.legal_requisites.okved_name class=\"okved-tip tooltip-light\" tooltip-placement=right uib-tooltip=\"{{vm.company.organization.legal_requisites.okved_name}}\" ng-if=!vm.mode></div><ul class=dropdown-menu ng-show=vm.suggestions.length><li ng-repeat=\"suggestion in vm.suggestions\" ng-mousedown=vm.updateOkved(suggestion) tooltip-placement=right uib-tooltip=\"{{suggestion.data.code + \' \' + suggestion.data.name}}\" class=tooltip-light><a href=javascript:void(0) ng-bind-html=\"(suggestion.data.code + \' \' + suggestion.data.name) | highlight: vm.company.organization.legal_requisites.okved\"></a></li></ul></div>");
$templateCache.put("app/components/ux-elements/entity-history/entity-history.html","<span class=\"light-custom-tip-wrap persons-icon-wrap\" ng-if=$ctrl.showHistory><span class=persons-ico></span><div class=\"light-custom-tip persons-info\"><div class=created-by>Создано <span class=persons-info-date>{{$ctrl.entityData.created_at | date: \'dd.MM.yyyy HH:mm\'}}</span><span class=persons-info-name ng-bind=$ctrl.entityData.created_by.name></span></div><div class=updated-by ng-if=$ctrl.entityData.updated_by>Изменено <span class=persons-info-date>{{$ctrl.entityData.updated_at | date: \'dd.MM.yyyy HH:mm\'}}</span><span class=persons-info-name ng-bind=$ctrl.entityData.updated_by.name></span></div></div></span>");
$templateCache.put("app/components/widgets/widget-container/widget-container.html","<div class=widget-container><div ng-repeat=\"widget in widgetContainerCtrl.widgets\"><widget-wrapper widget=widget ng-if=widget.visible></widget-wrapper></div></div>");
$templateCache.put("app/components/widgets/widget-wrapper/widget-wrapper.html","<div class=widget-wrapper><div class=widget-header><span uib-dropdown on-toggle=toggled(open) class=pull-right><span id=simple-dropdown uib-dropdown-toggle>&#8226;&#8226;&#8226;</span><ul class=dropdown-menu uib-dropdown-menu aria-labelledby=simple-dropdown><li><a href=\"\" ng-click=widgetWrapperCtrl.widgetContainerCtrl.pullUp(widgetWrapperCtrl.widget)>Переместить вверх</a> <a href=\"\" ng-click=widgetWrapperCtrl.widgetContainerCtrl.pushDown(widgetWrapperCtrl.widget)>Переместить вниз</a> <a href ng-click=widgetWrapperCtrl.openSettings() ng-bind=\"(widgetWrapperCtrl.settingsmode)? \'Скрыть настройки\' : \'Настроить\'\" ng-class=\"{\'disabled\': !widgetWrapperCtrl.callbacks.save}\"></a> <a href ng-click=widgetWrapperCtrl.changeRollUp(); ng-bind=\"(widgetWrapperCtrl.rollUp)? \'Развернуть\' : \'Свернуть\'\"></a></li></ul></span><a href=\"\" ng-click=widgetWrapperCtrl.changeRedactMode() ng-show=\"widgetWrapperCtrl.widget.allowRedactMode && !widgetWrapperCtrl.rollUp\"><span class=\"img-edit tooltip-light widget-redact-icon pull-right\" ng-class=\"{\'img-edit-funny\': widgetWrapperCtrl.redactMode}\" uib-tooltip=\"{{(!widgetWrapperCtrl.redactMode)? \'Редактировать\' : \'\'}}\"></span></a><h4 class=widget-header-title ng-bind=widgetWrapperCtrl.widget.name ng-class=\"{\'less-width\': widgetWrapperCtrl.widget.allowRedactMode}\"></h4></div><div class=widget-body ng-class=\"{\'roll-up\': widgetWrapperCtrl.rollUp}\"></div><div class=\"widget-footer clearfix\" ng-if=\"widgetWrapperCtrl.settingsmode && !widgetWrapperCtrl.rollUp\"><button class=\"btn btn-primary pull-right\" ng-click=widgetWrapperCtrl.save()>Сохранить</button> <button class=\"btn pull-right\" ng-click=widgetWrapperCtrl.dismiss()>Отменить</button></div></div>");
$templateCache.put("app/documents/components/attribute/document-attribute.html","<div class=attribute-container ng-if=documentAttributeCtrl.checkVisibleExpression()><div ng-switch=documentAttributeCtrl.item.field_type.toUpperCase() class=document-attribute-item ng-class=\"documentAttributeCtrl.item.class + \' \' + documentAttributeCtrl.item.field_type.toLowerCase()\"><div ng-switch-when=FLD_STRING><div class=form-group><input class=form-control name=\"{{::documentAttributeCtrl.item.code}}\" ng-hide=\"!documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false\" ng-model=documentAttributeCtrl.universalSetterGetter ng-model-options=\"{getterSetter: true }\" ng-required=::documentAttributeCtrl.item.required ng-show=documentAttributeCtrl.redact ng-if=::!documentAttributeCtrl.item.only_numbers autocomplete=off maxlength=\"{{documentAttributeCtrl.item.code == \'id\'? 150 : 30}}\"> <input class=form-control type=number name=\"{{::documentAttributeCtrl.item.code}}\" ng-hide=\"!documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false\" ng-model=documentAttributeCtrl.universalSetterGetter ng-model-options=\"{getterSetter: true }\" ng-required=::documentAttributeCtrl.item.required ng-show=documentAttributeCtrl.redact ng-if=::documentAttributeCtrl.item.only_numbers autocomplete=off><label class=\"form-control-label small-offset\" ng-hide=documentAttributeCtrl.hideLabel ng-bind=::documentAttributeCtrl.item.name ng-class=\"{\'always-top\': !documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false}\"></label><div class=\"view-entity-control ellipsis\" ng-if=\"!documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false\" ng-bind=\"documentAttributeCtrl.universalSetterGetter() || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.universalSetterGetter() || \'\'}}\"></div><i class=req ng-if=\"::documentAttributeCtrl.item.required && !documentAttributeCtrl.hideLabel\"></i></div></div><div ng-switch-when=FLD_TEXT><div class=form-group><textarea class=form-control style=\"resize: none;\" name=\"{{::documentAttributeCtrl.item.code}}\" ng-disabled=\"!documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false\" ng-model=documentAttributeCtrl.universalSetterGetter ng-model-options=\"{getterSetter: true }\" ng-required=::documentAttributeCtrl.item.required ng-show=documentAttributeCtrl.redact autocomplete=off>\n        </textarea><label class=\"form-control-label small-offset\" ng-hide=documentAttributeCtrl.hideLabel ng-bind=::documentAttributeCtrl.item.name></label><div class=view-entity-control ng-if=!documentAttributeCtrl.redact ng-bind=\"documentAttributeCtrl.universalSetterGetter() || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.universalSetterGetter()}}\"></div><i class=req ng-if=\"::documentAttributeCtrl.item.required && !documentAttributeCtrl.hideLabel\"></i></div></div><div ng-switch-when=FLD_NUMBER><number-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" ng-if=documentAttributeCtrl.redact item=::documentAttributeCtrl.item values=documentAttributeCtrl.values></number-field><div style=\"position: relative\" ng-if=!documentAttributeCtrl.redact><label class=\"form-control-label small-offset always-top\" ng-bind=::documentAttributeCtrl.item.name></label><div class=\"view-entity-control ellipsis\" ng-if=!documentAttributeCtrl.redact ng-bind=documentAttributeCtrl.values[documentAttributeCtrl.item.code] uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}\"></div></div></div><div ng-switch-when=FLD_AMOUNT ng-switch-when-separator=|><div class=form-group ng-if=\"documentAttributeCtrl.item.class !== \'total-summs\'\"><input class=\"form-control currency-input\" input-price ng-if=\"::!documentAttributeCtrl.item.ref || documentAttributeCtrl.item.ref.length === 0\" name=\"{{::documentAttributeCtrl.item.code}}\" ng-disabled=\"!documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false\" currency-input=true currency-icon=\"{{(documentAttributeCtrl.item.without_currency)? \'\' : (documentAttributeCtrl.externalData.natural_currency.symbol || documentAttributeCtrl.externalData.natural_currency.char_iso_code)}}\" ng-model=documentAttributeCtrl.values[documentAttributeCtrl.item.code] ng-required=::documentAttributeCtrl.item.required><get-sum ng-if=\"documentAttributeCtrl.item.ref && documentAttributeCtrl.item.ref.length > 0\" external-data=documentAttributeCtrl.externalData item=::documentAttributeCtrl.item values=documentAttributeCtrl.values></get-sum><label class=\"form-control-label small-offset\" ng-hide=documentAttributeCtrl.hideLabel ng-bind=::documentAttributeCtrl.item.name></label><i class=req ng-if=\"::documentAttributeCtrl.item.required && !documentAttributeCtrl.hideLabel\"></i></div><div class=form-group ng-if=\"documentAttributeCtrl.item.class == \'total-summs\'\" style=\"margin: 0;\"><total-amount redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" external-data=documentAttributeCtrl.externalData item=::documentAttributeCtrl.item values=documentAttributeCtrl.values></total-amount></div></div><div ng-switch-when=FLD_MULTIPLE_TOTAL><multiple-total external-data=documentAttributeCtrl.externalData item=::documentAttributeCtrl.item values=documentAttributeCtrl.values></multiple-total></div><div ng-switch-when=FLD_LINE_TAX_AMOUNT ng-switch-when-separator=|><div class=form-group ng-if=\"documentAttributeCtrl.item.class !== \'total-summs\'\"><input class=\"form-control currency-input\" ng-if=\"!documentAttributeCtrl.item.ref || documentAttributeCtrl.item.ref.length === 0\" name=\"{{::documentAttributeCtrl.item.code}}\" ng-disabled=\"!documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false\" input-price no-empty=::true currency-input=true currency-icon=\"{{documentAttributeCtrl.externalData.natural_currency.symbol || documentAttributeCtrl.externalData.natural_currency.char_iso_code}}\" min-val=0 tooltip=on ng-model=documentAttributeCtrl.values[documentAttributeCtrl.item.code] ng-required=::documentAttributeCtrl.item.required> <input class=\"form-control currency-input\" no-empty=::true ng-if=\"documentAttributeCtrl.item.ref && documentAttributeCtrl.item.ref.length > 0\" input-price name=\"{{::documentAttributeCtrl.item.code}}\" ng-disabled=true currency-input=true show-zeroes=true tooltip=on currency-icon=\"{{documentAttributeCtrl.externalData.natural_currency.symbol || documentAttributeCtrl.externalData.natural_currency.char_iso_code}}\" ng-model=documentAttributeCtrl.values[documentAttributeCtrl.item.code] values=documentAttributeCtrl.values><label class=\"form-control-label small-offset\" ng-hide=documentAttributeCtrl.hideLabel ng-bind=::documentAttributeCtrl.item.name></label><i class=req ng-if=\"::documentAttributeCtrl.item.required && !documentAttributeCtrl.hideLabel\"></i></div><div class=form-group ng-if=\"documentAttributeCtrl.item.class == \'total-summs\'\" style=\"margin: 0;\"><total-amount redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" external-data=::documentAttributeCtrl.externalData item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></total-amount></div></div><div ng-switch-when=FLD_QUANTITY><quantity-field ng-if=\"documentAttributeCtrl.redact || documentAttributeCtrl.item.noZeroes\" redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=documentAttributeCtrl.values external-data=documentAttributeCtrl.externalData need-marks=\"documentAttributeCtrl.values.accounting_type == \'MARK_ACCOUNTING\' && documentAttributeCtrl.item.needMarks\"></quantity-field><div class=\"view-entity-control text-right\" ng-if=\"!documentAttributeCtrl.redact && !documentAttributeCtrl.item.noZeroes\" ng-bind=documentAttributeCtrl.universalSetterGetter() uib-tooltip=\"{{documentAttributeCtrl.universalSetterGetter()}}\"></div></div><div ng-switch-when=FLD_QUANTITY_WRITE_OFF><quantity-write-off redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=documentAttributeCtrl.values external-data=documentAttributeCtrl.externalData></quantity-write-off></div><div ng-switch-when=FLD_PRICE><div class=form-group style=\"height: 48px;\"><price-field item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values hide-label=documentAttributeCtrl.hideLabel index=::$index redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" default-currency=documentAttributeCtrl.externalData.natural_currency external-data=::documentAttributeCtrl.externalData></price-field></div></div><div ng-switch-when=FLD_COMPANY><div class=form-group><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=100 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.companyService.companiesSearch><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_COMPANY_EGAIS ng-if=documentAttributeCtrl.item.visible><div class=\"form-group company-egais-field-wrapper\" uib-tooltip=\"{{(documentAttributeCtrl.values[documentAttributeCtrl.item.code].fsrar_id && !documentAttributeCtrl.item.editable) ? documentAttributeCtrl.values[documentAttributeCtrl.item.code].fsrar_id + \' \' + documentAttributeCtrl.values[documentAttributeCtrl.item.code].company_name : \'\'}}\"><company-egais-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values amount=5 purpose=::documentAttributeCtrl.documentCtrl.purpose select-match-patern=::documentAttributeCtrl.companyEgaisMatchPatern select-choices-patern=::documentAttributeCtrl.companyEgaisChoicesPatern get-data=documentAttributeCtrl.utmConnectionsService.utmsAuto><span ng-bind=::documentAttributeCtrl.item.name></span></company-egais-field><div class=\"view-entity-control ng-hide ellipsis\" ng-bind=\"(documentAttributeCtrl.values[documentAttributeCtrl.item.code].fsrar_id) ? documentAttributeCtrl.values[documentAttributeCtrl.item.code].fsrar_id + \' \' + documentAttributeCtrl.values[documentAttributeCtrl.item.code].company_name : \'-\'\" uib-tooltip=\"{{(documentAttributeCtrl.values[documentAttributeCtrl.item.code].fsrar_id) ? documentAttributeCtrl.values[documentAttributeCtrl.item.code].fsrar_id + \' \' + documentAttributeCtrl.values[documentAttributeCtrl.item.code].company_name : \'-\'}}\"></div></div></div><div ng-switch-when=FLD_DIVISION><div class=form-group><divisions-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=::documentAttributeCtrl.externalData select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.companyService.companyDivisionsLight><span ng-bind=::documentAttributeCtrl.item.name></span></divisions-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_CONTRACT><div class=form-group><contracts-field ng-if=\"documentAttributeCtrl.item.editable && documentAttributeCtrl.redact\" redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=::documentAttributeCtrl.externalData amount=5 select-match-patern=::documentAttributeCtrl.contractMatchPatern select-choices-patern=::documentAttributeCtrl.contractChoicesPatern get-data=::documentAttributeCtrl.contractService.contractsForAutocomplete create-str=\"\'Создать договор\'\" create-link=\"\'contract.new\'\" create-data=\"{\n                           companyId: documentAttributeCtrl.externalData.company.id,\n                           counterpartyId: documentAttributeCtrl.externalData.values.counterparty.id || documentAttributeCtrl.externalData.counterparty.id,\n                           purpose: documentAttributeCtrl.documentCtrl.purpose,\n                           closeTab: true\n                         }\"><span ng-bind=::documentAttributeCtrl.item.name></span></contracts-field><label class=\"form-control-label small-offset always-top\" ng-if=\"!documentAttributeCtrl.item.editable || !documentAttributeCtrl.redact\" ng-bind=::documentAttributeCtrl.item.name></label><div class=view-entity-control ng-if=\"!documentAttributeCtrl.item.editable || !documentAttributeCtrl.redact\"><span ng-if=documentAttributeCtrl.values[documentAttributeCtrl.item.code] ng-bind=\"(documentAttributeCtrl.values[documentAttributeCtrl.item.code])? (\'№\' + documentAttributeCtrl.values[documentAttributeCtrl.item.code].number + \' от \' + (documentAttributeCtrl.values[documentAttributeCtrl.item.code].date | date:\'dd.MM.yyyy\')) : \'-\'\" uib-tooltip=\"{{(documentAttributeCtrl.values[documentAttributeCtrl.item.code])? (\'№\' + documentAttributeCtrl.values[documentAttributeCtrl.item.code].number + \' от \' + (documentAttributeCtrl.values[documentAttributeCtrl.item.code].date | date:\'dd.MM.yyyy\')) : \'-\'}}\"></span></div></div></div><div ng-switch-when=FLD_BASE_DOCUMENT><div class=form-group><base-document item=::documentAttributeCtrl.item external-data=::documentAttributeCtrl.externalData values=::documentAttributeCtrl.values></base-document></div></div><div ng-switch-when=FLD_PROJECT><div class=form-group><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=5 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern filters=\"{filter_active: true}\" get-data=::documentAttributeCtrl.projectsService.projectsSearch create-str=\"\'Создать проект\'\" create-link=\"\'project.new\'\" create-data=\"{closeTab: true}\"><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_COUNTERPARTY|FLD_SOD_COUNTERPARTY ng-switch-when-separator=|><div class=form-group><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=5 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.counterpartiesSearch create-str=\"\'Создать \' + ((documentAttributeCtrl.item.name == \'Покупатель\')? \'покупателя\' : (documentAttributeCtrl.item.name | lowercase) + \'а\')\" create-link=\"\'contragent.new\'\" create-data=\"{purpose: documentAttributeCtrl.documentCtrl.purpose,\n                      closeTab: true}\"><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_FILTER><div class=form-group><select-field redact=true item=::documentAttributeCtrl.item values=documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=5 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.filterData always-set=true reset-dirty=true><span ng-bind=::documentAttributeCtrl.item.name></span></select-field></div></div><div ng-switch-when=FLD_ALCOHOL_COUNTERPARTY><div class=form-group style=\"margin: 0 -5px; padding: 0px 5px 12px;\" ng-style=\"{\'background\': (documentAttributeCtrl.item.foreignOrganizations && documentAttributeCtrl.values[documentAttributeCtrl.item.code].counterparty_egais_type && (documentAttributeCtrl.values[documentAttributeCtrl.item.code].counterparty_egais_type == \'FO\' || documentAttributeCtrl.values[documentAttributeCtrl.item.code].counterparty_egais_type == \'TS\'))? \'#fff1f1\' : \'transparent\'}\"><span class=\"text-muted help-data\" ng-bind=\"(documentAttributeCtrl.values[documentAttributeCtrl.item.code].inn || \'-\') + \'/\' + (documentAttributeCtrl.values[documentAttributeCtrl.item.code].kpp || \'-\')\"></span><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=5 select-match-patern=::documentAttributeCtrl.alcoholCounterpartyPatern select-choices-patern=::documentAttributeCtrl.alcoholCounterpartyChoicesPatern get-data=::documentAttributeCtrl.getAlcoholCounterparties ng-if=documentAttributeCtrl.redact filters=\"{filter_egais_type: [\'UL\', \'FL\']}\"><span ng-bind=::documentAttributeCtrl.item.short_name></span></select-field><div class=\"view-entity-control ng-hide ellipsis\" ng-show=!documentAttributeCtrl.redact ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].short_name || documentAttributeCtrl.values[documentAttributeCtrl.item.code].full_name || documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || ((documentAttributeCtrl.values[documentAttributeCtrl.item.code].client_reg_id && !documentAttributeCtrl.values[documentAttributeCtrl.item.code].inn)? documentAttributeCtrl.values[documentAttributeCtrl.item.code].client_reg_id + \' информация о контрагенте отсутствует в справочнике\' : \'-\')\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].short_name || documentAttributeCtrl.values[documentAttributeCtrl.item.code].full_name || documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || ((documentAttributeCtrl.values[documentAttributeCtrl.item.code].client_reg_id && !documentAttributeCtrl.values[documentAttributeCtrl.item.code].inn)? documentAttributeCtrl.values[documentAttributeCtrl.item.code].client_reg_id + \' информация о контрагенте отсутствует в справочнике\' : \'\')}}\" style=\"padding-right: 0; padding-left: 0;\"></div></div></div><div ng-switch-when=FLD_COUNTERPARTY_EGAIS><div class=form-group><select-without-autocomplete redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=documentAttributeCtrl.documentCtrl.purpose amount=5 external-data=::documentAttributeCtrl.externalData select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.egaiszService.getCounterpartyBind param=documentAttributeCtrl.externalData[documentAttributeCtrl.item.ref[0]].id outside-refresh=documentAttributeCtrl.outsideRefresh><span ng-bind=::documentAttributeCtrl.item.name></span></select-without-autocomplete><div class=\"view-entity-control ng-hide ellipsis\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div><span class=\"link-style egais-counterparty\" ng-click=\"documentAttributeCtrl.openCounterpartiesMap(documentAttributeCtrl.item, documentAttributeCtrl.values);\" ng-bind=documentAttributeCtrl.externalData[documentAttributeCtrl.item.ref[0]].short_name ng-if=documentAttributeCtrl.externalData[documentAttributeCtrl.item.ref[0]].short_name style=\"font-size: 14px; display: block; margin-top: 3px; margin-bottom: -11px;\"></span></div></div><div ng-switch-when=FLD_EXPENSE_ITEM><div class=form-group title=\"{{::documentAttributeCtrl.item.name}}\"><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=5 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern filters=\"{filter_active: true}\" get-data=::documentAttributeCtrl.expenseItemsService.expenseItemsSearch><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_PAYMENT_TYPE><div class=form-group><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=100 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.paymentTypesService.paymentTypesAuto><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_EMPLOYEE|FLD_SOD_USER ng-switch-when-separator=|><div class=form-group><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=5 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.employeesService.usersAuto create-str=\"\'Создать \' + (documentAttributeCtrl.item.name | lowercase) + \'а\'\" create-link=\"\'employee.new\'\" create-data=\"{closeTab: true}\"><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide ellipsis\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'\'}}\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\"></div></div></div><div ng-switch-when=FLD_CURRENCY ng-if=documentAttributeCtrl.item.visible><div class=form-group><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values amount=100 purpose=::documentAttributeCtrl.documentCtrl.purpose select-match-patern=::documentAttributeCtrl.currencyMatchPatern select-choices-patern=::documentAttributeCtrl.currencyChoicesPatern get-data=::documentAttributeCtrl.currenciesService.getDomainCurrenciesSearch on-currency-change=documentAttributeCtrl.onCurrencyChange><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_YEAR><div class=form-group><year-select redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values meta=::documentAttributeCtrl.documentCtrl.commonMeta external-data=::documentAttributeCtrl.externalData><span ng-bind=::documentAttributeCtrl.item.name></span></year-select></div></div><div ng-switch-when=FLD_QUARTER_OR_MONTH><div class=form-group><quarter-or-month redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values meta=::documentAttributeCtrl.documentCtrl.commonMeta external-data=::documentAttributeCtrl.externalData><span ng-bind=::documentAttributeCtrl.item.name></span></quarter-or-month></div></div><div ng-switch-when=FLD_SOD_COUNTERPARTY_CONTACT><div class=form-group><counterparty-contact redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern><span ng-bind=::documentAttributeCtrl.item.name></span></counterparty-contact><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_CURRENCY_RATE><div class=form-group ng-hide=documentAttributeCtrl.item.$$hidden uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}\"><input class=form-control name=\"{{::documentAttributeCtrl.item.code}}\" ng-disabled=\"!documentAttributeCtrl.item.editable || documentAttributeCtrl.redact === false\" float-input float-fixed=2 float-step=0.01 max-after-comma=4 max-int-length=6 ng-model=documentAttributeCtrl.values[documentAttributeCtrl.item.code] ng-required=::documentAttributeCtrl.item.required> <span class=\"rate-info text-muted pull-right\" ng-if=documentAttributeCtrl.values.currency_rate style=\"font-size: 12px;\" ng-bind=\"(10 | mathPow:documentAttributeCtrl.values.denominator_log10) + \'&nbsp;\' + documentAttributeCtrl.values.natural_currency.char_iso_code + \' = \' + documentAttributeCtrl.values.currency_rate.toString().replace(\'.\', \',\') + \'&nbsp;\' + documentAttributeCtrl.currencyHome.currency.char_iso_code\"></span><label class=\"form-control-label small-offset\" ng-hide=documentAttributeCtrl.documentAttributeCtrl.hideLabel ng-bind=::documentAttributeCtrl.item.name></label><i class=req ng-if=\"::documentAttributeCtrl.item.required && !documentAttributeCtrl.documentAttributeCtrl.hideLabel\"></i></div></div><!-- без поиска --><div ng-switch-when=FLD_VAT|FLD_TAX_GROUP|FLD_TAX_MODE ng-switch-when-separator=|><div class=form-group><tax-group-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values amount=100 select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern get-data=::documentAttributeCtrl.catalogService.getTax external-data=::documentAttributeCtrl.externalData><span ng-bind=::documentAttributeCtrl.item.name></span></tax-group-field><div class=\"view-entity-control ng-hide\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\"></div></div></div><div ng-switch-when=FLD_DOCUMENT_TOTALS><div class=form-group><totals-field with-taxes=false external-data=::documentAttributeCtrl.externalData redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></totals-field></div></div><div ng-switch-when=FLD_DOCUMENT_TOTALS_WITH_TAXES><div class=form-group><totals-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" external-data=::documentAttributeCtrl.externalData item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></totals-field></div></div><div ng-switch-when=FLD_DOCUMENT_AMOUNTS_WITH_TAXES><!-- Итоги для вознаграждений, и для счетов(без грида) --><div class=form-group><totals-amounts with-taxes=true external-data=::documentAttributeCtrl.externalData redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></totals-amounts></div></div><div ng-switch-when=FLD_DOCUMENT_AMOUNTS><!-- Итоги для вознаграждений, и для счетов(без грида) --><div class=form-group><totals-amounts with-taxes=false external-data=::documentAttributeCtrl.externalData redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></totals-amounts></div></div><div ng-switch-when=FLD_ADVANCE_REPORT_TOTALS><div class=form-group><totals-advance-report external-data=::documentAttributeCtrl.externalData item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></totals-advance-report></div></div><div ng-switch-when=FLD_COMPANY_BANK_ACCOUNT|FLD_COUNTERPARTY_BANK_ACCOUNT|FLD_PERSON_BANK_ACCOUNT ng-switch-when-separator=|><div class=form-group><accounts-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=::documentAttributeCtrl.externalData select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern create-str=\"\'Добавить счет \' + ((documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_COMPANY_BANK_ACCOUNT\')? \'компании\' : ((documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_COUNTERPARTY_BANK_ACCOUNT\')? \'контрагента\' : \'сотрудника\'))\" create-link=\"(documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_COMPANY_BANK_ACCOUNT\')? \'company.edit\' : ((documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_COUNTERPARTY_BANK_ACCOUNT\')? \'contragent.edit\' : \'employee.edit\')\" create-data=\"(documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_COMPANY_BANK_ACCOUNT\')? documentAttributeCtrl.externalData.company.id : documentAttributeCtrl.externalData.values[documentAttributeCtrl.item.ref[0]].id\"><span ng-bind=::documentAttributeCtrl.item.name></span></accounts-field><div class=\"view-entity-control ellipsis\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'\'}}\" ng-show=\"!documentAttributeCtrl.item.editable || !documentAttributeCtrl.redact\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\"></div></div></div><div ng-switch-when=FLD_ENUM><div class=form-group><custom-select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern><span ng-bind=::documentAttributeCtrl.item.name></span></custom-select-field></div></div><div ng-switch-when=FLD_FN_REG><div class=form-group><fn-reg-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=documentAttributeCtrl.item values=::documentAttributeCtrl.values amount=5 external-data=::documentAttributeCtrl.externalData get-data=::documentAttributeCtrl.egaiszService.searchForm2 ng-hide=\"!documentAttributeCtrl.item.editable || !documentAttributeCtrl.redact\"></fn-reg-field><div class=\"view-entity-control ellipsis\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'\'}}\" ng-show=\"!documentAttributeCtrl.item.editable || !documentAttributeCtrl.redact\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || (!documentAttributeCtrl.item.required && documentAttributeCtrl.values[documentAttributeCtrl.item.ref[0]] && documentAttributeCtrl.item.editable)? (documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'Автоматически\') : \'\'\"></div></div></div><div ng-switch-when=FLD_F1_REG><div class=form-group><f1-reg-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=documentAttributeCtrl.item values=documentAttributeCtrl.values amount=5 external-data=documentAttributeCtrl.externalData get-data=documentAttributeCtrl.egaiszService.searchF1Reg ng-hide=\"!documentAttributeCtrl.item.editable || !documentAttributeCtrl.redact\"><span ng-bind=::documentAttributeCtrl.item.name></span></f1-reg-field><div class=\"view-entity-control ellipsis\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]? \'ТТН №\' + documentAttributeCtrl.values[documentAttributeCtrl.item.code].ttn_number + \' от \' + (documentAttributeCtrl.values[documentAttributeCtrl.item.code].ttn_date | date:\'dd.MM.yyyy\') : \'\'}}\" ng-show=\"!documentAttributeCtrl.item.editable || !documentAttributeCtrl.redact\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code]? \'ТТН №\' + documentAttributeCtrl.values[documentAttributeCtrl.item.code].ttn_number + \' от \' + (documentAttributeCtrl.values[documentAttributeCtrl.item.code].ttn_date | date:\'dd.MM.yyyy\') : \'-\'\"></div></div></div><div ng-switch-when=FLD_DATE_TIME|FLD_DATE ng-switch-when-separator=|><date-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" ng-if=documentAttributeCtrl.redact item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=documentAttributeCtrl.externalData reference-data=::documentAttributeCtrl.referenceData properties=\"documentAttributeCtrl.documentCtrl.document.properties[documentAttributeCtrl.item.code] || documentAttributeCtrl.documentCtrl.document.layout.properties[documentAttributeCtrl.item.code]\"></date-field><div style=\"position: relative\" ng-if=!documentAttributeCtrl.redact><label class=\"form-control-label small-offset always-top\" ng-bind=::documentAttributeCtrl.item.name></label><div class=\"view-entity-control ellipsis\" ng-if=\"documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_DATE\'\" ng-bind=\"documentAttributeCtrl.crudsService.getFormattedDate(documentAttributeCtrl.values[documentAttributeCtrl.item.code], false, \'DD.MM.YYYY\')\" uib-tooltip=\"{{(documentAttributeCtrl.values[documentAttributeCtrl.item.code])? (documentAttributeCtrl.crudsService.getFormattedDate(documentAttributeCtrl.values[documentAttributeCtrl.item.code], false, \'DD.MMMM.YYYY\')) : \'\'}}\"></div><div class=\"view-entity-control ellipsis\" ng-if=\"documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_DATE_TIME\'\" ng-bind=\"documentAttributeCtrl.crudsService.getFormattedDate(documentAttributeCtrl.values[documentAttributeCtrl.item.code], true, \'DD.MM.YYYY HH:mm\')\" uib-tooltip=\"{{(documentAttributeCtrl.values[documentAttributeCtrl.item.code])? (documentAttributeCtrl.crudsService.getFormattedDate(documentAttributeCtrl.values[documentAttributeCtrl.item.code], true, \'DD.MM.YYYY HH:mm\')) : \'\'}}\"></div></div></div><div ng-switch-when=FLD_SKU_SERVICE_DERIVATIVE|FLD_SKU_DERIVATIVE ng-switch-when-separator=|><div class=form-group><catalog-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values select-match-patern=::documentAttributeCtrl.matchPaternDerivative select-choices-patern=::documentAttributeCtrl.choicesPaternDerivative only-stock=\"documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_SKU_DERIVATIVE\'\" get-data=::documentAttributeCtrl.cachedDerivativeForFld external-data=::documentAttributeCtrl.externalData><span ng-bind=::documentAttributeCtrl.item.name></span></catalog-field></div></div><div ng-switch-when=FLD_ALCOHOL_DERIVATIVE><div class=form-group><alcohol-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values select-match-patern=::documentAttributeCtrl.matchPaternDerivative select-choices-patern=::documentAttributeCtrl.choicesPaternDerivative match-patern-tooltip=::documentAttributeCtrl.matchPaternDerivativeTooltip only-stock=false get-data=::documentAttributeCtrl.cachedDerivativeForFld external-data=::documentAttributeCtrl.externalData properties=\"::documentAttributeCtrl.documentCtrl.document.properties || documentAttributeCtrl.documentCtrl.document.layout.properties\"><span ng-bind=::documentAttributeCtrl.item.name></span></alcohol-field></div></div><div ng-switch-when=FLD_CATALOG_ITEM|FLD_STOCK_ITEM ng-switch-when-separator=|><div class=form-group><catalog-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values select-match-patern=::documentAttributeCtrl.matchPatern select-choices-patern=::documentAttributeCtrl.choicesPatern only-stock=\"::documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_STOCK_ITEM\'\" get-data=::documentAttributeCtrl.catalogService.getItemSkuAuto><span ng-bind=::documentAttributeCtrl.item.name></span></catalog-field></div></div><div ng-switch-when=FLD_LOT_SN|FLD_ADD_LOT_SN ng-switch-when-separator=|><div class=form-group><lot-sn redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values allow-add=\"::documentAttributeCtrl.item.field_type.toUpperCase() == \'FLD_ADD_LOT_SN\'\" amount=100 save-item=::documentAttributeCtrl.inventoryService.saveByType get-data=::documentAttributeCtrl.inventoryService.getByStockType external-data=::documentAttributeCtrl.externalData></lot-sn></div></div><div ng-switch-when=FLD_UOM><div class=form-group><uom-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values amount=100 select-match-patern=::documentAttributeCtrl.uomMatchPatern select-choices-patern=::documentAttributeCtrl.uomChoicesPatern></uom-field><div class=\"view-entity-control ng-hide ellipsis\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\" tooltip-placement=right style=\"padding-top: 16px; position: relative; z-index: 9;\" ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].name || \'-\'\"></div></div></div><div ng-switch-when=FLD_HTML><div class=form-group><html-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></html-field></div></div><div ng-switch-when=FLD_DIFFERENCE><div class=form-group><difference-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values></difference-field></div></div><div ng-switch-when=FLD_STOCK_QUANTITY><div class=form-group><stock-quantity-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=::documentAttributeCtrl.externalData></stock-quantity-field></div></div><div ng-switch-when=FLD_PRODUCT_CLASSIFIER><div class=form-group><select-field redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values purpose=::documentAttributeCtrl.documentCtrl.purpose amount=100 select-match-patern=::documentAttributeCtrl.productClassifierPatern select-choices-patern=::documentAttributeCtrl.productClassifierChoicesPatern filters=\"{filter_low_alcohol: true}\" get-data=::documentAttributeCtrl.getProductClassifier class=dropdown-more-weight ng-if=documentAttributeCtrl.redact><span ng-bind=::documentAttributeCtrl.item.name></span></select-field><div class=\"view-entity-control ng-hide ellipsis\" ng-show=!documentAttributeCtrl.redact ng-bind=\"documentAttributeCtrl.values[documentAttributeCtrl.item.code].code || \'-\'\" uib-tooltip=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code].name}}\" style=\"padding-right: 0;padding-left: 0;\"></div></div></div><div ng-switch-when=FLD_BOOLEAN ng-init=\"(documentAttributeCtrl.values[documentAttributeCtrl.item.code] === null || documentAttributeCtrl.values[documentAttributeCtrl.item.code] === undefined)? documentAttributeCtrl.values[documentAttributeCtrl.item.code] = false : []\"><div class=form-group><div class=radio-box style=\"padding-left: 15px;\"><div class=radio-box-title ng-bind=::documentAttributeCtrl.item.name></div><div style=\"display: inline-block; margin-right: 20px;\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}\" ng-model=documentAttributeCtrl.values[documentAttributeCtrl.item.code] ng-value=true id=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}Yes\" ng-disabled=!documentAttributeCtrl.redact> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}Yes\">Да</label></div><div style=\"display: inline-block\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}\" ng-model=documentAttributeCtrl.values[documentAttributeCtrl.item.code] ng-value=false id=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}No\" ng-disabled=!documentAttributeCtrl.redact> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{documentAttributeCtrl.values[documentAttributeCtrl.item.code]}}No\">Нет</label></div></div></div></div><div ng-switch-when=FLD_CHECKBOX ng-if=\"documentAttributeCtrl.redact || documentAttributeCtrl.values[documentAttributeCtrl.item.code]\" ng-init=\"(documentAttributeCtrl.values[documentAttributeCtrl.item.code] === null)? documentAttributeCtrl.values[documentAttributeCtrl.item.code] = false : []\"><div class=form-group style=\"padding: 13px 0 10px;\"><div class=check-wrapper><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=documentAttributeCtrl.values[documentAttributeCtrl.item.code] id=\"{{::documentAttributeCtrl.item.code}}\" ng-disabled=!documentAttributeCtrl.redact> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{::documentAttributeCtrl.item.code}}\" class=checkbox-label ng-bind=::documentAttributeCtrl.item.name></label></div></div></div><div ng-switch-when=FLD_LIST_CHECKBOXES><document-checkboxes-list item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=::documentAttributeCtrl.externalData reference-data=::documentAttributeCtrl.referenceData redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\"></document-checkboxes-list></div><div ng-switch-when=FLD_MESSAGE><div class=form-group ng-bind=::documentAttributeCtrl.item.name></div></div><div ng-switch-when=FLD_SIMPLIFIED_CONTENT><div class=form-group><simplified-content item=::documentAttributeCtrl.item purpose=::documentAttributeCtrl.documentCtrl.purpose redact=\"documentAttributeCtrl.redact && !documentAttributeCtrl.blockRedact\" values=documentAttributeCtrl.values></simplified-content></div></div><div ng-switch-when=FLD_EMPTY></div></div><!-- вспомогательные поля --><div ng-switch=documentAttributeCtrl.item.helper_type.toUpperCase()><div ng-switch-when=FLD_STOCK_QUANTITY_ALL><div class=form-group><stock-quantity-all item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=::documentAttributeCtrl.externalData reference-data=::documentAttributeCtrl.referenceData></stock-quantity-all></div></div><div ng-switch-when=FLD_ADD_DOCUMENTS><div class=form-group ng-show=documentAttributeCtrl.redact><add-documents item=::documentAttributeCtrl.item values=::documentAttributeCtrl.values external-data=::documentAttributeCtrl.externalData reference-data=::documentAttributeCtrl.referenceData></add-documents></div></div></div></div>");
$templateCache.put("app/documents/components/block/document-block.html","<div class=block-container ng-class=::documentBlockCtrl.item.class ng-if=documentBlockCtrl.isVisibleBlock() ng-style=\"::(!documentBlockCtrl.item.name &&\n     documentBlockCtrl.item.class &&\n     (documentBlockCtrl.item.class.indexOf(\'top-indent\') != -1))? {\'padding-top\': \'16px\'} : \'\'\"><label class=section-header ng-show=::documentBlockCtrl.item.name ng-bind=::documentBlockCtrl.item.name></label><div class=info-click ng-if=\"documentBlockCtrl.item.info && documentBlockCtrl.redact\"><button class=\"btn btn-ico btn-info dropdown-toggle\" type=button data-toggle=dropdown aria-haspopup=true aria-expanded=false></button><div class=dropdown-menu aria-labelledby=dropdownMenuButton ng-click=$event.stopPropagation(); style=\"width: 280px; left: inherit; right: 0;\"><span ng-bind-html=::documentBlockCtrl.item.info></span></div></div><div class=block-content ng-style=\"{\'flex-direction\': documentBlockCtrl.item.direction.toLowerCase() || \'row\'}\"><div ng-repeat=\"child in documentBlockCtrl.item.items\" style=\"flex: {{((child.flex === undefined || child.flex === null)? 1 : child.flex) + \' \' + ((child.flex === undefined || child.flex === null)? 1 : child.flex)}}; min-width: 0;\" ng-if=\"(!child.visible_purposes || !child.visible_purposes.length ||\n              (child.visible_purposes.indexOf(documentBlockCtrl.documentCtrl.purpose) != -1)) &&\n              (child.visible == undefined || child.visible)\n              && documentBlockCtrl.isVisibleField(child)\" ng-class=\"child.type + \'-doc\'\" class=flex-child ng-hide=\"child.type.toUpperCase() == \'HELPER\' && child.type.visible === false\"><div ng-if=\"child.type.toUpperCase() == \'TABS\'\" ng-class=child.class class=tab-form-group><uib-tabset active=$tabIndex><uib-tab ng-repeat=\"tab in child.items\"><uib-tab-heading class=tab-heading><span class=tab-title>{{tab.tabname}}</span></uib-tab-heading><div><div ng-show=\"$tabIndex === $index\"><document-block redact=documentBlockCtrl.redact item=tab values=documentBlockCtrl.values external-data=documentBlockCtrl.externalData></document-block></div></div></uib-tab></uib-tabset></div><div ng-if=\"::child.type.toUpperCase() == \'CONTAINER\'\"><document-block redact=::documentBlockCtrl.redact external-data=documentBlockCtrl.externalData item=::child values=documentBlockCtrl.values currency-home=::documentBlockCtrl.currencyHome get-currencies-rate=::documentBlockCtrl.getCurrenciesRate amount-calculate=::documentBlockCtrl.amountCalculate reference-data=::documentBlockCtrl.referenceData></document-block></div><div ng-if=\"::child.type.toUpperCase() == \'SEPARATOR\'\"><div ng-style=\"{\'width\': child.width, \'height\': child.height}\"></div></div><div ng-if=\"::child.type.toUpperCase() == \'FIELD\' || child.type.toUpperCase() == \'EMPTY\'\"><document-attribute redact=documentBlockCtrl.redact external-data=documentBlockCtrl.externalData item=::child values=documentBlockCtrl.values on-currency-change=::documentBlockCtrl.onCurrencyChange currency-home=::documentBlockCtrl.currencyHome reference-data=::documentBlockCtrl.referenceData></document-attribute></div><div ng-if=\"::child.type.toUpperCase() == \'HELPER\'\"><document-attribute redact=documentBlockCtrl.redact external-data=documentBlockCtrl.externalData item=child values=documentBlockCtrl.values reference-data=documentBlockCtrl.referenceData></document-attribute></div><div ng-if=\"::child.type.toUpperCase() == \'TABLE\'\"><document-grid redact=::documentBlockCtrl.redact item=::child values=documentBlockCtrl.values doc-type=::documentBlockCtrl.item.docType amount-calculate=::documentBlockCtrl.amountCalculate external-data=documentBlockCtrl.externalData reference-data=::documentBlockCtrl.referenceData check-valid=::documentBlockCtrl.checkValid need-add-to-cart=::documentBlockCtrl.needAddToCart></document-grid></div></div></div></div>");
$templateCache.put("app/documents/components/document/document.html","<div class=\"document-contaiter crud-entity\" ng-form=\"{{documentCtrl.formName}}\"><h3 class=text-muted ng-if=documentCtrl.showHeader><span ng-bind=::documentCtrl.document.metadata.document_type.name title=::documentCtrl.document.metadata.document_type.name></span><hr></h3><document-block ng-if=\"(!documentCtrl.root.visible_purposes ||\n           (documentCtrl.root.visible_purposes.indexOf(documentCtrl.purpose) != -1)) &&\n           (documentCtrl.root.visible == undefined || documentCtrl.root.visible)\" redact=documentCtrl.redact item=::documentCtrl.root external-data=documentCtrl.externalData values=documentCtrl.values currency-home=::documentCtrl.currencyHome get-currencies-rate=::documentCtrl.getCurrenciesRate amount-calculate=::documentCtrl.amountCalculate reference-data=::documentCtrl.referenceData check-valid=::documentCtrl.checkValid need-add-to-cart=::documentCtrl.needAddToCart></document-block></div>");
$templateCache.put("app/documents/components/document-grid/document-grid.html","<script type=text/ng-template id=documentGridCellTemplate.html><div class=\"cell-data text-right single-line\">\n    <document-grid-unique ng-if=\"column.field.unique\"\n                          values=\"value\"\n                          refs=\"documentGridCtrl.uniqueIndexes[column.field.unique]\"\n                          unique-index=\"column.field.unique\"\n                          unique-field=\"column.field.code\">\n    </document-grid-unique>\n    <document-attribute item=\"column.field\"\n                        redact=\"(documentGridCtrl.item.edit_row_singly)? value.$$editMode : !!documentGridCtrl.redact\"\n                        hide-label=\"true\"\n                        values=\"value\"\n                        currency-home=\"\"\n                        external-data=\"documentGridCtrl.externalData\"\n                        reference-data=\"documentGridCtrl.referenceData\">\n    </document-attribute>\n  </div></script><script type=text/ng-template id=documentGridPurposeTemplate.html><div class=\"cell-data single-line\">\n    <cell-with-tooltip text=\"value[column.field.code] | documentPurpose\"></cell-with-tooltip>\n  </div></script><script type=text/ng-template id=documentGridHeaderCellTemplate.html><div class=\"default-header-cell\">\n    <span class=\"default-header-text {{::gridCustomHeaderCtrl.column.headerCellClass}}\">\n      <span ng-bind=\"::gridCustomHeaderCtrl.column.name\"></span>\n      <!--i class=\"req\" style=\"margin: 0 2px\" ng-if=\"::gridCustomHeaderCtrl.column.field.required\"></i-->\n    </span>\n  </div></script><script type=text/ng-template id=documentGridNumberTemplate.html><div class=\"cell-data\" style=\"padding-top: 6px;\"> {{documentGridCtrl.values[documentGridCtrl.item.code].indexOf(value) + 1}} </div>\n  <span ng-if=\"value._manual\" scroll-on-create></span></script><script type=text/ng-template id=documentGridControlTemplate.html><div class=\"cell-data text-right lines-buttons\" style=\"margin-top: 9px;\">\n    <i class=\"btn tooltip-light cart-button\" tooltip-placement=\"bottom-right\" uib-tooltip=\"Добавить в корзину\"\n       ng-if=\"documentGridCtrl.needAddToCart && !!(value.catalog_item || value.derivative)\"\n       ng-click=\"documentGridCtrl.addToCart(value);\"><span class=\"btn-cart btn-ico\"></span></i>\n    \n    <i ng-click=\"documentGridCtrl.editRow(value, $event); $event.stopPropagation();\" \n       ng-if=\"documentGridCtrl.item.edit_row_singly && !value.$$editMode\"\n       tabindex=\"-1\"\n       class=\"img-edit\"\n       uib-tooltip=\"Редактировать\"></i>\n\n    <span tooltip-placement=\"bottom-right\" uib-tooltip=\"{{documentGridCtrl.showRemoveIcon(value)? \'\' : \'Сначала необходимо удалить все связанные сведения о закупках продукции\'}}\">\n      <i ng-click=\"documentGridCtrl.removeValue(value, $event); $event.stopPropagation();\" tabindex=\"-1\"\n         class=\"glyphicon glyphicon-trash text-danger tooltip-light\" \n         ng-style=\"(!documentGridCtrl.showRemoveIcon(value))? {\'opacity\': \'0.5\', \'pointer-events\': \'none\'} : \'\'\" tooltip-placement=\"bottom-right\"\n         uib-tooltip=\"Удалить\"></i>\n    </span>\n  </div></script><div ng-if=documentGridCtrl.checkVisibleExpression() ng-class=\"\'limit-\' + documentGridCtrl.pagingOptions.limit\"><div data-footer-absolute top-flag=headerButtonNotInTop class=\"header-absolute fixed-panel-grid-buttons code_{{documentGridCtrl.item.code}}_grid_buttons\" ng-class=\"{hide: !headerButtonNotInTop}\" top-shift=\"{{documentGridCtrl.topShift()}}\"><div class=document-grid-control-panel><button tabindex=-1 ng-click=documentGridCtrl.openSettings() class=\"btn gear-button only-ico tooltip-light\" tooltip-placement=left uib-tooltip=\"Настроить отображение колонок\" ng-if=!documentGridCtrl.item.disabled_settings><span class=\"btn-ico btn-gear\"></span></button> <span ng-click=documentGridCtrl.addRow() ng-if=documentGridCtrl.redact class=\"text-success glyphicon glyphicon-plus\"></span></div></div><div class=\"document-grid-container grid-style-wrap code_{{documentGridCtrl.item.code}} fixed-helper\" ng-keydown=documentGridCtrl.key($event) ng-show=\"documentGridCtrl.values[documentGridCtrl.item.code].length || documentGridCtrl.item.empty_table\" ng-class=\"{\'remove-trash\': documentGridCtrl.values[documentGridCtrl.item.code].length == 1 && !documentGridCtrl.item.empty_table}\"><div class=document-grid-control-panel><button tabindex=-1 ng-click=documentGridCtrl.openSettings() class=\"btn gear-button only-ico tooltip-light\" tooltip-placement=left uib-tooltip=\"Настроить отображение колонок\" ng-if=!documentGridCtrl.item.disabled_settings><span class=\"btn-ico btn-gear\"></span></button> <span ng-click=documentGridCtrl.addRow() ng-if=documentGridCtrl.redact class=\"text-success glyphicon glyphicon-plus\"></span></div><grid-custom columns=documentGridCtrl.columns data=documentGridCtrl.values[documentGridCtrl.item.code] is-show-settings=true show-checkbox=false allow-selected=!!documentGridCtrl.item.selection_event selected-callback=documentGridCtrl.rowSelectionHandler two-level-header=documentGridCtrl.item.two_level_header paging-options=documentGridCtrl.pagingOptions group-external-func=documentGridCtrl.groupFunc external-filter-func=documentGridCtrl.filterFunc discriminator-field=documentGridCtrl.item.discriminator_field discriminator-value=\"documentGridCtrl.attributeUtilService._getValueDeep(\n    documentGridCtrl.values,\n    documentGridCtrl.item.discriminator_value.split(\'.\'))\" page-callback=documentGridCtrl.onPageChanges options=documentGridCtrl.gridOptions min-height=100 is-full-width=!documentGridCtrl.item.small_width header-fixed-top-offset=documentGridCtrl.topShift()></grid-custom></div></div>");
$templateCache.put("app/documents/document-crud/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=documentCrudCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons><button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Удалить ng-show=\"documentCrudCtrl.documentCommonData.id && documentCrudCtrl.redact && $root.hasRole(documentCrudCtrl.roleType + \'.write\')\" ng-click=documentCrudCtrl.delete()><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button><document-print-button perform=documentCrudCtrl.printDocument(mode) perform-reports=documentCrudCtrl.openReport(mode) ng-if=\"$root.hasRole(\'report.\' + documentCrudCtrl.roleType) && (documentCrudCtrl.metadata.print_forms.length > 0 || documentCrudCtrl.filteredDocumentReports.length > 0) && documentCrudCtrl.documentCommonData.id\" actions=::documentCrudCtrl.metadata.print_forms reports=::documentCrudCtrl.filteredDocumentReports></document-print-button><a class=\"btn btn-ico-wrap\" target=_blank ng-click=documentCrudCtrl.copyHandler() ng-if=\"$root.hasRole(documentCrudCtrl.roleType + \'.write\') && documentCrudCtrl.documentCommonData.id\"><span class=\"btn-ico btn-copy tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Копировать></span>Копировать</a><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\" ng-if=\"$root.hasRole(documentCrudCtrl.roleType + \'.write\') && documentCrudCtrl.docPurpose.possible_recipients.length > 0\n         && documentCrudCtrl.documentCommonData.id\"><button type=button class=btn ng-click=\"\" data-toggle=dropdown>Создать <span class=caret style=\"display: inline-block;\"></span></button><ul class=\"dropdown-menu pull-right\" role=menu style=\"width: auto;\"><li ng-repeat=\"possiblePurpose in documentCrudCtrl.docPurpose.possible_recipients\"><a ui-sref=\"document.new({\n            donor: documentCrudCtrl.documentCommonData.id,\n            type: possiblePurpose.type_code,\n            purpose: possiblePurpose.code,\n            parent: $stateParams.parent\n          })\" target=_blank>{{possiblePurpose.purpose_name}}</a></li></ul></div><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\" ng-if=\"documentCrudCtrl.metadata.document_type.code == \'CONSIGNMENT_NOTE_IN\' && documentCrudCtrl.documentCommonData.status == \'PROCESSED\'\"><button type=button class=btn ng-click=\"\" data-toggle=dropdown>Добавить в <span class=caret style=\"display: inline-block;\"></span></button><ul class=\"dropdown-menu pull-right\" role=menu style=\"width: auto;\"><li><a href=\"\" ng-click=documentCrudCtrl.openToPriceListModal()>Закупочный прайс-лист</a></li></ul></div><div ng-if=\"documentCrudCtrl.documentCommonData.id && $root.hasRole(documentCrudCtrl.roleType + \'.write\') && documentCrudCtrl.documentCommonData.changeable_status\" style=\"display: inline-block;\"><span class=\"btn btn-ico-wrap tooltip-target\" ng-disabled=documentCrudCtrl.documentAllForm.$invalid ng-click=\"documentCrudCtrl.documentAllForm.$invalid ? \'\':documentCrudCtrl.process()\" ng-if=\"documentCrudCtrl.documentCommonData.status == \'DRAFT\' && documentCrudCtrl.redact\" tooltip-placement=bottom-right uib-tooltip=\"{{documentCrudCtrl.documentAllForm.$invalid? \'Не заполнены обязательные поля\' : \'\'}}\"><span class=\"btn-ico btn-done tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Провести></span>Провести</span> <span class=\"btn btn-ico-wrap\" ng-click=documentCrudCtrl.rollback() ng-if=\"documentCrudCtrl.documentCommonData.status == \'PROCESSED\'\"><span class=\"btn-ico btn-no-done tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Отмена проведения\"></span>Отмена проведения</span></div><button class=\"btn btn-ico-wrap tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Импорт из файла\" ng-if=\"(!documentCrudCtrl.documentCommonData.status || documentCrudCtrl.documentCommonData.status == \'DRAFT\')\n            && documentCrudCtrl.isDerivative !== undefined\" ng-click=documentCrudCtrl.importFromFile();><span class=\"btn-import btn-ico\"></span> Импорт</button> <button class=\"btn btn-ico-wrap tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Добавить товары из корзины в документ\" ng-if=\"(!documentCrudCtrl.documentCommonData.status || documentCrudCtrl.documentCommonData.status == \'DRAFT\')\n            && documentCrudCtrl.isDerivative !== undefined\" ng-click=documentCrudCtrl.cartPopup();><span class=\"btn-cart btn-ico\"></span> Из корзины</button></div><div ng-if=\"$root.hasRole(documentCrudCtrl.roleType + \'.write\')\"><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\" ng-if=\"documentCrudCtrl.commonFieldsMeta.properties.auto_price && (!documentCrudCtrl.documentCommonData.status || documentCrudCtrl.documentCommonData.status == \'DRAFT\')\"><button type=button class=btn ng-click=\"\" data-toggle=dropdown>Подставить цены из <span class=caret style=\"display: inline-block;\"></span></button><ul class=\"dropdown-menu pull-right\" role=menu style=\"width: 225px;\"><li ng-repeat=\"source in documentCrudCtrl.priceSource\" ng-bind=source.label ng-click=documentCrudCtrl.autoPrice(source.value) style=\"padding: 10px;\"></li></ul></div><button class=\"btn btn-primary pull-right\" ng-click=documentCrudCtrl.save(documentCrudCtrl.documentCommonData.id) ng-show=documentCrudCtrl.redact ng-class=\"{\'pseudo-disabled\': documentCrudCtrl.isSaved && documentCrudCtrl.documentAllForm.$invalid}\" ng-bind=\"(documentCrudCtrl.documentCommonData.id)? \'Сохранить\' : \'Создать\'\" tooltip-placement=bottom-right uib-tooltip=\"{{documentCrudCtrl.documentAllForm.$invalid? \'Не заполнены обязательные поля\' : ((!documentCrudCtrl.documentAllForm.$dirty && !documentCrudCtrl.state.params.source && !documentCrudCtrl.state.current.name.endsWith(\'new\'))? \'Нет новых данных для сохранения\' : \'\')}}\"></button> <a class=\"btn pull-right\" ng-click=documentCrudCtrl.resetData() ng-show=\"documentCrudCtrl.redact && documentCrudCtrl.documentCommonData.status == \'DRAFT\'\">Отменить</a></div></div>");
$templateCache.put("app/documents/document-settings/autoNumbersPopup/auto-numbers-popup.html","<div class=\"crud-entity auto-numbers-popup\" ng-form=autoNumbersForm><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=autoNumbersPopup.close()></button><h3 class=modal-title>Параметры настройки автозаполнения цен</h3></div><div class=container><div class=\"ui-spinner ui-spinner-center\"></div><div class=tab-form-group ng-scrollbars ng-scrollbars-config=autoNumbersPopup.configScroll><scrollable-tabset api=autoNumbersPopup.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset active=autoNumbersPopup.activeTab><uib-tab ng-repeat=\"company in autoNumbersPopup.companies\" select=autoNumbersPopup.selectTab><uib-tab-heading class=tab-heading><span class=tab-title ng-bind=company.name></span></uib-tab-heading><doc-settings-company tab=company settings=autoNumbersPopup.settings.document_number_sequences periods=autoNumbersPopup.periods></doc-settings-company></uib-tab></uib-tabset></scrollable-tabset></div></div><div class=modal-footer><button class=btn ng-click=autoNumbersPopup.close()>Отменить</button> <button class=\"btn btn-primary\" ng-click=autoNumbersPopup.close(true) ng-disabled=\"!autoNumbersForm.$pristine && autoNumbersForm.$invalid\">Сохранить</button></div></div>");
$templateCache.put("app/documents/document-settings/autoPricePopup/auto-price-popup.html","<div class=\"crud-entity auto-price-popup\" ng-form=autoPriceForm><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=autoPricePopup.close()></button><h3 class=modal-title>Параметры настройки автозаполнения цен</h3></div><div class=container ng-scrollbars ng-scrollbars-config=autoPricePopup.configScroll><div class=funny-box><div class=label-wrap><span class=label>&nbsp;</span> <span class=label>Цена</span></div><div class=\"ui-spinner ui-spinner-center\"></div><div class=auto-price-wrapper><div ng-repeat=\"doc in autoPricePopup.types\" class=document-wrapper ng-hide=\"doc == \'ADVANCE_REPORT\'\"><div class=doc-name><span>{{doc | getDocName}}&nbsp;</span></div><div class=pricing-type><ui-select ng-model=autoPricePopup.settings.document_price_source[$index].pricing_type class=slim-control search-enabled=false><ui-select-match allow-clear=true><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices position=\"{{$index > (autoPricePopup.types.length/2)? \'up\' : \'down\'}}\" repeat=\"item.value as item in autoPricePopup.priceTypes\"><span ng-bind=item.label></span></ui-select-choices></ui-select></div></div></div></div></div><div class=modal-footer><button class=btn ng-click=autoPricePopup.close()>Отменить</button> <button class=\"btn btn-primary\" ng-click=autoPricePopup.close(true)>Сохранить</button></div></div>");
$templateCache.put("app/documents/document-settings/companyTab/company-tab.html","<div class=tab-wrapper><div class=funny-box><div class=label-wrap><span class=label>&nbsp;</span> <span class=label title=\"Следующий номер\">Следующий номер</span> <span class=label title=\"Начинать нумерацию с 1\">Начинать нумерацию с 1</span></div><div ng-repeat=\"setting in tabSettings\" class=document-wrapper ng-hide=\"setting.document_type == \'ADVANCE_REPORT\'\"><div class=doc-name><span>{{setting.document_type | getDocName}}&nbsp;<span class=req></span></span></div><div class=next-number><input type=text class=\"form-control slim-control\" ng-model=setting.next_number max-val=::999999 min-val=::1 integer-input hide-format=true required><div class=\"valid-message max-mess small-offset\" style=\"min-width: max-content;\">Не более 999999</div><div class=\"valid-message min-mess small-offset\" style=\"min-width: max-content;\">Не менее 1</div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=reset-period><ui-select ng-model=setting.reset_period required class=slim-control search-enabled=false><ui-select-match><span ng-bind=\"$select.selected | resetPeriodFilter\"></span></ui-select-match><ui-select-choices position=\"{{$index > (tabSettings.length/2)? \'up\' : \'down\'}}\" repeat=\"item in periods track by $index\"><span ng-bind=\"item | resetPeriodFilter\"></span></ui-select-choices></ui-select></div></div></div></div>");
$templateCache.put("app/documents/modals/forms-popup/forms-popup.html","<div class=details-fn1><div class=modal-body style=\"padding-bottom: 40px;\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><div class=modal-main-text><h2>Детальная информация</h2><strong>Наименование:</strong> {{catalogItem.full_name || catalogItem.name || \"-\"}}<br><strong>Алкокод:</strong> {{catalogItem.alc_code || \"-\"}} </div><section class=\"form-group tab-form-group tabs-with-grid\" style=\"width: 100%;margin: 0;\"><grid-custom columns=columns data=data is-show-settings=false show-checkbox=false options=gridOptions min-height=100 is-full-width=false allow-selected=true scroll-height=420></grid-custom></section><div class=loader-wrapper ng-if=showLoader><div class=ui-spinner></div></div></div></div><script type=text/ng-template id=headerCellTemplate.html><div class=\"default-header-cell\">\n    <div class=\"default-header-text\" ng-style=\"(column.field == \'quantity\')? {\'width\':\'207px\', \'text-align\': \'right\'} : \'\'\">\n      <div ng-bind=\"::gridCustomHeaderCtrl.column.name\"></div>\n    </div>\n  </div></script><script type=text/ng-template id=numberTemplate.html><div class=\"cell-data\" style=\"padding-top: 0px;\">\n    <span>{{data.indexOf(value) + 1}}</span>\n  </div></script><script type=text/ng-template id=cellTemplate.html><div class=\"cell-data single-line\" ng-class=\"{\'text-right\': column.field == \'quantity\'}\" style=\"padding: 0 0 0 10px;\">\n\n      <span ng-if=\"column.field == \'number\'\" ng-bind=\"data.indexOf(value) + 1\"></span>\n\n      <div class=\"ellipsis\" ng-if=\"column.field == \'f1_reg_id\' || column.field == \'f2_reg_id\'\" ng-bind=\"value[column.field]\" tooltip-placement=\"bottom-left\" uib-tooltip=\"{{value[column.field]}}\"></div>\n\n      <div class=\"ellipsis text-right\" ng-if=\"column.field == \'quantity\'\" ng-bind=\"value.quantity || 0\" style=\"padding-right: 20px\"></div>\n\n  </div></script>");
$templateCache.put("app/documents/modals/import-from-file/import-from-file.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title>Импорт из файла</h3></div><div class=ui-spinner ng-if=$ctrl.load style=\"margin: 150px auto;\"></div><form name=$ctrl.importForm class=\"modal-body import-wrap modal-import-wrap\" style=\"padding: 9px 40px 0;\"><div ng-include=\"\'app/documents/modals/import-from-file/sections/\' + $ctrl.activeStep + \'-step.html\'\" class=modal-import-content></div></form><div class=modal-footer style=\"height: 104px;\"><button class=\"btn btn-primary\" type=button ng-click=$ctrl.next() ng-if=$ctrl.uploader.queue[0].isSuccess>Далее</button> <button class=\"btn btn-primary\" type=button ng-click=$ctrl.save() ng-if=\"\">Импорт</button></div>");
$templateCache.put("app/documents/modals/search-documents/search-documents.html","<div class=\"extended-search-popup crud-entity doc-search-popup\"><div class=modal-body style=\"padding-bottom: 32px;\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=searchCtrl.close()>×</button><div class=modal-main-text><h2 ng-bind=searchCtrl.title></h2></div><form class=\"container row\" style=\"padding: 0; position: relative;\" name=searchCtrl.searchForm ng-submit=searchCtrl.search(true) controller=searchCtrl><div class=\"col-xs-4 section control-box-wrapper\" ng-include=\"\'app/documents/modals/search-documents/includes/control-box.html\'\"></div><div class=\"col-xs-8 arrow-pointer\" ng-if=\"!searchCtrl.searchRes.length && !searchCtrl.notFound\">Установите параметры и<br>нажмите кнопку \"Найти\"</div><div class=\"col-xs-8 filter-not-found major-font\" ng-if=searchCtrl.notFound><div class=big-danger-info-ico></div><div class=big-danger-info><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div></div><div class=\"col-xs-8 search-items\" ng-show=searchCtrl.searchRes.length><grid-custom columns=searchCtrl.columns data=searchCtrl.searchRes is-show-settings=false show-checkbox=true options=searchCtrl.documentOptions min-height=100></grid-custom><div class=table-footer><paging-customizable page-info=searchCtrl.paging callback=searchCtrl.search paging=searchCtrl.gridFooterPaging></paging-customizable></div></div><div class=\"col-xs-8 loader-wrapper\" ng-if=searchCtrl.showLoader><div class=ui-spinner></div></div><button class=\"btn btn-primary pull-right\" type=button ng-click=searchCtrl.addDocuments(); style=\"position: absolute; bottom: 0; right: 0;\" ng-show=searchCtrl.documentOptions.hasCheckedRows()>Добавить</button></form></div></div><script type=text/ng-template id=documentSearchHeaderCellTemplate.html><div class=\"default-header-cell\" ng-class=\"{\'word-break text-right\': gridCustomHeaderCtrl.column.field == \'home_amount\' || gridCustomHeaderCtrl.column.field == \'catalog_item_totals\'}\">\n    <span class=\"default-header-text\">\n      <span ng-bind=\"::gridCustomHeaderCtrl.column.name\"></span>\n    </span>\n  </div></script><script type=text/ng-template id=documentSearchCellTemplate.html><div class=\"cell-data single-line\" ng-class=\"{\'text-right\': column.field == \'home_amount\' || column.field == \'catalog_item_totals\'}\" style=\"padding: 0 12px;\">\n    <a ui-sref=\'document.view({\n            type: value[\"document_type\"],\n            purpose: value[\"document_purpose\"],\n            id: value[\"id\"],\n            parent: $state.params.parent\n          })\' target=\"_blank\" class=\"not-link\">\n      <span ng-if=\"column.field == \'number\' || column.field == \'catalog_item_totals\'\" ng-bind=\"value[column.field]\"></span>\n\n      <cell-with-tooltip ng-if=\"column.field == \'document_purpose\'\" text=\"value[column.field] | documentPurpose\"></cell-with-tooltip>\n\n      <cell-with-tooltip ng-if=\"column.field == \'date\'\" text=\"value[column.field] | date:\'dd.MM.yyyy\'\"></cell-with-tooltip>\n\n      <cell-with-tooltip-money ng-if=\"column.field == \'home_amount\'\" text=\"value[column.field] || 0\" currency-symbol=\"$root.homeCurrency.currency.symbol\"></cell-with-tooltip-money>\n    </a>\n  </div></script>");
$templateCache.put("app/egaisz/beer-declaration/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=beerDeclarationCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons ng-if=!beerDeclarationCtrl.newDoc><button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Удалить ng-show=\"beerDeclarationCtrl.values.id && beerDeclarationCtrl.values.status == \'DRAFT\'\" ng-click=beerDeclarationCtrl.delete()><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button> <button ng-if=!beerDeclarationCtrl.newDoc type=button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Экспортировать в файл\" ng-click=beerDeclarationCtrl.exportPopup();><span class=\"btn-export btn-ico\"></span></button><!--ng-disabled=\"beerDeclarationCtrl.form.$dirty && beerDeclarationCtrl.values.status == \'DRAFT\'\"--> <button class=\"btn tooltip-light\" ng-if=\"beerDeclarationCtrl.values.status == \'DRAFT\' && beerDeclarationCtrl.redact\" ng-click=beerDeclarationCtrl.autoFill()>Автоматическое заполнение</button> <button class=\"btn btn-ico-wrap tooltip-target ng-scope\" ng-disabled=beerDeclarationCtrl.form.$invalid ng-click=\"beerDeclarationCtrl.form.$invalid ? \'\' : beerDeclarationCtrl.save(true);\" ng-if=\"beerDeclarationCtrl.values.status == \'DRAFT\' && beerDeclarationCtrl.redact\" role=button tabindex=0 aria-disabled=false style=\"min-width: 54px;\"><span class=\"btn-ico btn-done tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\'Перевести в статус \"Принята ФСРАР\"\'></span>ИЗМЕНИТЬ СТАТУС</button> <span class=\"btn btn-ico-wrap ng-scope\" ng-click=beerDeclarationCtrl.rollback() ng-if=\"beerDeclarationCtrl.values.status == \'CONFIRMED\'\" role=button tabindex=0 style=\"min-width: 54px;\"><span class=\"btn-ico btn-no-done tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\'Перевести в статус \"Черновик\"\'></span>ИЗМЕНИТЬ СТАТУС</span></div><div><button class=\"btn btn-primary pull-right\" ng-click=beerDeclarationCtrl.save() ng-show=beerDeclarationCtrl.redact ng-disabled=\"beerDeclarationCtrl.form.$invalid || !beerDeclarationCtrl.form.$dirty\" ng-bind=\"(!beerDeclarationCtrl.newDoc)? \'Сохранить\' : \'Создать\'\"></button> <button class=\"btn pull-right\" ng-if=!beerDeclarationCtrl.newDoc ng-click=beerDeclarationCtrl.resetData(); ng-disabled=beerDeclarationCtrl.form.$pristine ng-show=\"beerDeclarationCtrl.redact && beerDeclarationCtrl.values.status == \'DRAFT\'\">Отменить</button></div></div>");
$templateCache.put("app/egaisz/beer-declaration/includes/title_page.html","<div class=title-page-wrapper><h5 ng-bind=values.company.full_name></h5><div class=row><div class=col-xs-2>ИНН: <strong ng-bind=\"values.company.inn || \'-\'\"></strong><br>КПП: <strong ng-bind=\"values.company.kpp || \'-\'\"></strong></div><div class=col-xs-10>Адрес: <strong ng-bind=\"values.company.legal_address.address_as_string || \'-\'\"></strong></div></div><h5 style=\"margin-top: 40px;\">Адреса мест осуществления деятельности (подразделения, точки продаж):</h5><div class=title-page-divisions><div class=title-page-head><div>Наименование</div><div>КПП</div><div>Адрес</div></div><div class=title-page-body ng-repeat=\"division in values.divisions\"><div ng-bind=\"division.name || \'-\'\">Наименование</div><div ng-bind=\"division.kpp || \'-\'\">КПП</div><div ng-bind=\"division.address.address_as_string || \'-\'\">Адрес</div></div></div><!-- <div class=\"title-page-division clearfix\" ng-repeat=\"division in values.divisions\">\n		<div class=\"col-xs-4\">\n			Наименование: <strong ng-bind=\"division.name || \'-\'\"></strong><br>\n			КПП: <strong ng-bind=\"division.kpp || \'-\'\"></strong>\n		</div>\n		<div class=\"col-xs-8\">\n			Адрес: <strong ng-bind=\"division.address.address_as_string || \'-\'\"></strong>\n		</div>\n	</div> --></div>");
$templateCache.put("app/egaisz/beer-declaration/modals/declaration-auto-fill.html","<div class=declaration-auto-fill><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Автоматическое заполнение декларации</h3></div><div class=container ng-if=load><div class=ui-spinner style=\"margin: 80px auto;\"></div></div><div class=container ng-if=\"!load && correctData\" style=\"margin: 30px auto 50px;\">Декларация заполнена в автоматическом режиме, будьте внимательны при внесении ручных корректировок</div><form name=beerAutoFill class=container ng-if=\"!load && !correctData\"><h5>При необходимости укажите декларацию за прошлый период, для заполнения начальных остатков.</h5><div class=check-wrapper style=\"margin: 15px 0 5px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox id=setBB ng-model=setBB ng-change=\"data.declaration = undefined\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=setBB class=checkbox-label>Заполнить начальные остатки на основании:</label></div><div class=form-group ng-style=\"{\'cursor\': setBB ? \'pointer\' : \'not-allowed\'}\"><ui-select ng-model=data.declaration ng-required=setBB search-enabled=false ng-disabled=!setBB><ui-select-match><span ng-bind=\"\'Декларация №\' + $select.selected.doc_number + \' за \' + ($select.selected.period_reporting | periodReportings) + \' \' + $select.selected.year_reporting + \' года\'\"></span></ui-select-match><ui-select-choices refresh=\"refreshDeclarations($select.search, divisionItem)\" repeat=\"dec in declartions track by $index\"><span ng-bind-html=\"\'Декларация №\' + dec.doc_number + \' за \' + (dec.period_reporting | periodReportings) + \' \' + dec.year_reporting + \' года\'\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Декларация</label><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div ng-if=data.declaration style=\"margin-bottom: 30px;\"><h5>Сведения о декларации:</h5><div class=row><div class=col-xs-4><strong>Дата подачи:</strong> <span ng-bind=\"data.declaration.doc_date | date:\'dd.MM.yyyy\'\"></span></div><div class=col-xs-4><strong>Тип:</strong> <span ng-bind=\"(data.declaration.beer_declaration_type == \'PRIMARY\')? \'Первичная\' : ((data.declaration.beer_declaration_type == \'CORRECTIVE\')? \'Корректирующая\' : \'-\');\"></span></div><div class=col-xs-4><strong>Номер корректировки:</strong> <span ng-bind=\"data.declaration.number_corrective || \'-\'\"></span></div></div></div><div class=text-danger ng-if=dirty>Внимание! Декларация будет перезаполнена, внесенные изменения будут потеряны.</div></form><div class=modal-footer ng-if=!load><button class=btn ng-click=close() ng-class=\"{\'btn-primary\' : correctData}\" ng-bind=\"(correctData)? \'Закрыть\' : \'Отменить\'\"></button> <button class=\"btn btn-primary\" ng-click=fill() ng-disabled=beerAutoFill.$invalid ng-if=!correctData>Заполнить</button></div></div>");
$templateCache.put("app/egaisz/beginning-balance-egais/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=beginningBalanceEgaisCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\"><button type=button class=btn ng-if=\"beginningBalanceEgaisCtrl.values.document_status == \'DATA_RECEIVED\' && beginningBalanceEgaisCtrl.redact\" ng-disabled=beginningBalanceEgaisCtrl.beginningBalanceForm.$invalid ng-click=\"beginningBalanceEgaisCtrl.setStatus(\'NEED_TO_ACCOUNTED\');\">Провести</button></div></div><div><button class=\"btn btn-primary pull-right\" ng-click=beginningBalanceEgaisCtrl.save() ng-if=\"beginningBalanceEgaisCtrl.values.document_status == \'DATA_RECEIVED\' && beginningBalanceEgaisCtrl.redact\" ng-disabled=!beginningBalanceEgaisCtrl.beginningBalanceForm.$dirty ng-bind=\"(beginningBalanceEgaisCtrl.values.id)? \'Сохранить\' : \'Создать\'\"></button> <button class=\"btn pull-right\" ng-click=beginningBalanceEgaisCtrl.resetData(); ng-if=\"beginningBalanceEgaisCtrl.values.document_status == \'DATA_RECEIVED\' && beginningBalanceEgaisCtrl.redact\">Отменить</button></div></div>");
$templateCache.put("app/egaisz/beginning-balance-egais-list/fsrar-company/fsrar-company-modal.html","<div class=fsrar-company-modal><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=fsrarCompanyModalCtr.close()></button><h3 class=modal-title>Запрос остатков в ЕГАИС</h3></div><div ng-if=fsrarCompanyModalCtr.load><div class=ui-spinner style=\"margin: 30px auto;\"></div></div><div class=\"container crud-entity\" ng-if=!fsrarCompanyModalCtr.load style=\"padding-right: 6px;\"><div class=form-group>Выберите компанию, зарегистрированную в ЕГАИС, по которой необходимо отправить запрос:</div><div class=form-group ng-class=\"{\'has-error-unique\': fsrarCompanyModalCtr.invalid}\"><ui-select ng-model=fsrarCompanyModalCtr.company search-enabled=\"fsrarCompanyModalCtr.total > 5\" ng-required=true on-select=\"fsrarCompanyModalCtr.invalid = false;\"><ui-select-match><span ng-bind=\"$select.selected.fsrar_id + \' \' + $select.selected.company_name\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=fsrarCompanyModalCtr.refreshUtms($select.search) repeat=\"item as item in fsrarCompanyModalCtr.companies track by $index\"><span ng-bind-html=\"item.fsrar_id + \' \' + item.company_name | highlight: $select.search\" uib-tooltip=\"{{item.company_name}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Компания</label><span class=req></span><div class=\"valid-message required-mess\">Поле является обязательным</div></div><section class=company-info ng-if=fsrarCompanyModalCtr.company style=\"width: 670px; margin: 0;\"><div class=row><h4 class=col-xs-12 style=\"margin-top: 0;\">Сведения о компании</h4><div class=clearfix><div class=col-xs-6><span style=\"font-weight: 500;\">Наименование:</span> {{fsrarCompanyModalCtr.company.company_name}}</div><div class=col-xs-6><span style=\"font-weight: 500;\">ИНН:</span> {{fsrarCompanyModalCtr.company.inn}}</div></div><div class=clearfix><div class=col-xs-6><span style=\"font-weight: 500;\">ФСРАР ИД:</span> {{fsrarCompanyModalCtr.company.fsrar_id}}</div><div class=col-xs-6><span style=\"font-weight: 500;\">КПП:</span> {{fsrarCompanyModalCtr.company.kpp}}</div></div></div></section></div><div class=modal-footer><button class=btn ng-click=fsrarCompanyModalCtr.close()>Отменить</button> <button class=\"btn btn-primary\" ng-click=fsrarCompanyModalCtr.send() ng-disabled=!fsrarCompanyModalCtr.company>Отправить</button></div></div>");
$templateCache.put("app/egaisz/cancellation-act/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=cancellationActCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons><button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Удалить ng-show=\"cancellationActCtrl.values.register && cancellationActCtrl.values.id && (cancellationActCtrl.values.status == \'DRAFT\' || cancellationActCtrl.values.status == \'REJECTED\')\" ng-click=cancellationActCtrl.delete()><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\"><a class=\"btn btn-ico-wrap\" target=_blank ng-click=cancellationActCtrl.copyHandler() ng-if=\"$root.hasRole(\'write_off_statement_egais.write\') && cancellationActCtrl.values.id && cancellationActCtrl.values.register\"><span class=\"btn-ico btn-copy tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Копировать></span>Копировать </a><button type=button class=btn ng-if=\"cancellationActCtrl.values.status == \'DRAFT\'\" ng-click=\"cancellationActCtrl.setActStatus(\'NEED_TO_ACCOUNTED\')\" ng-disabled=\"cancellationActCtrl.cancellationActForm.$invalid || (!cancellationActCtrl.values.change_recs_stock && !cancellationActCtrl.values.change_alcohol_stock && !cancellationActCtrl.values.change_egais_stock)\">Провести</button></div><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\" ng-if=\"$root.hasRole(\'write_up_statement_egais.write\') && cancellationActCtrl.values.write_off_type == \'MIX\' && cancellationActCtrl.values.status == \'ACCOUNTED_TO\'\"><button type=button class=btn ng-click=\"\" data-toggle=dropdown>Создать <span class=caret style=\"display: inline-block;\"></span></button><ul class=\"dropdown-menu pull-right\" role=menu style=\"width: auto;\"><li><a ui-sref=\"writeUpStatement.new({\n            source: cancellationActCtrl.values.id,\n            sourceNumber: cancellationActCtrl.values.doc_number,\n            sourceDate: cancellationActCtrl.values.doc_date,\n            register: cancellationActCtrl.values.register,\n            parent: \'alcohol\'\n          })\" target=_blank>Акт постановки</a></li></ul></div></div><div><button class=\"btn btn-primary pull-right\" ng-click=cancellationActCtrl.save() ng-show=cancellationActCtrl.redact ng-disabled=\"cancellationActCtrl.cancellationActForm.$invalid || !cancellationActCtrl.cancellationActForm.$dirty || (!cancellationActCtrl.values.change_recs_stock && !cancellationActCtrl.values.change_alcohol_stock && !cancellationActCtrl.values.change_egais_stock)\" ng-bind=\"(cancellationActCtrl.values.id)? \'Сохранить\' : \'Создать\'\"></button> <button class=\"btn btn-primary pull-right\" ng-click=\"cancellationActCtrl.setActStatus(\'DRAFT\')\" ng-if=\"cancellationActCtrl.values.status == \'REJECTED\' || cancellationActCtrl.values.status == \'ACCOUNTED_ERROR\'\" ng-bind=\"\'Исправить\'\"></button> <button class=\"btn pull-right\" ng-click=cancellationActCtrl.resetData(); ng-disabled=cancellationActCtrl.cancellationActForm.$pristine ng-show=\"cancellationActCtrl.redact && cancellationActCtrl.values.status == \'DRAFT\'\">Отменить</button></div></div>");
$templateCache.put("app/egaisz/invoice-waybill/approve-waybill/approve-waybill.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=approveWaybillCtrl.close()>×</button><h3 class=modal-title ng-bind=approveWaybillCtrl.resolve.settings.title></h3></div><div ng-switch=approveWaybillCtrl.step class=\"container crud-entity\" ng-class=\"{\'view-entity\': approveWaybillCtrl.resolve.isViewAct}\"><div ng-switch-when=INFO><p ng-bind=approveWaybillCtrl.resolve.settings.info></p></div><div ng-switch-when=ACT><section class=block-section ng-form=approveWaybillCtrl.actForm style=\"padding: 18px 24px;\"><h5 class=section-header ng-bind=approveWaybillCtrl.resolve.settings.header></h5><div class=row><div class=col-xs-6><div class=form-group><div style=\"position: relative\"><input class=form-control name=number ng-model=approveWaybillCtrl.act.act_number ng-required=true><label for=number class=\"form-control-label small-offset\" ng-style=\"(approveWaybillCtrl.resolve.isViewAct)? {\'left\': \'0px\'} : \'\'\">Номер акта</label><i class=req style=\"right: -10px\"></i></div></div></div><div class=col-xs-6><div class=form-group><div date-range-picker name=\"Дата акта\" ng-model=approveWaybillCtrl.act.act_date opts=approveWaybillCtrl.datePickerOptions state=approveWaybillCtrl.state class=datepicker-wrap ng-required=true field-label=\"\'Дата акта\'\"></div></div></div></div><div class=row ng-if=approveWaybillCtrl.resolve.isViewAct><div class=col-xs-12><div class=form-group><label class=form-control-label ng-style=\"{\'left\': \'0px\'}\">Решение</label><div class=view-entity-control ng-bind=\"(approveWaybillCtrl.act.accept | acceptStatuses) || \'-\'\"></div></div></div></div><div class=row><div class=col-xs-12><div class=form-group><textarea class=form-control style=\"resize: none;\" name=note ng-model=approveWaybillCtrl.act.note ng-if=!approveWaybillCtrl.resolve.isViewAct>\n            </textarea><label class=\"form-control-label small-offset\" ng-style=\"(approveWaybillCtrl.resolve.isViewAct)? {\'left\': \'0px\'} : \'\'\">Комментарий</label><div ng-if=approveWaybillCtrl.resolve.isViewAct ng-bind=\"approveWaybillCtrl.act.note || \'-\'\" class=view-entity-control></div></div></div></div></section></div></div><div class=modal-footer><button class=btn ng-click=approveWaybillCtrl.close() ng-bind=\"approveWaybillCtrl.resolve.isViewAct? \'Закрыть\' : \'Отмена\'\"></button> <button class=\"btn btn-primary\" ng-if=!approveWaybillCtrl.resolve.isViewAct ng-disabled=approveWaybillCtrl.actForm.$invalid ng-click=\"approveWaybillCtrl.step == \'INFO\' ? approveWaybillCtrl.step = \'ACT\' : approveWaybillCtrl.approve()\"><span ng-bind=approveWaybillCtrl.resolve.settings.button></span></button></div>");
$templateCache.put("app/egaisz/invoice-waybill/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=invoiceWaybillCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\"><button type=button class=btn ng-click=invoiceWaybillCtrl.openScanMarks() ng-if=\"invoiceWaybillCtrl.values.document_status == \'NEED_TO_DECIDE\'\">Сканировать</button> <button type=button class=btn ng-click=\"invoiceWaybillCtrl.setActStatus(\'NEED_TO_ACCOUNTED\')\" ng-if=\"invoiceWaybillCtrl.values.document_status == \'TTN_CONFIRMED\' || invoiceWaybillCtrl.values.document_status == \'TTN_PART_CONFIRMED\'\">Провести</button> <button type=button class=btn ng-click=\"invoiceWaybillCtrl.openApproveModal(\'VIEW\', true)\" ng-if=\"invoiceWaybillCtrl.values.document_status !== \'NEED_TO_DECIDE\'\">АКТ НА ТТН</button> <button type=button class=btn ng-click=\"\" data-toggle=dropdown ng-if=\"invoiceWaybillCtrl.values.document_status == \'NEED_TO_DECIDE\'\">Принять решение <span class=caret style=\"display: inline-block;\"></span></button><ul class=\"dropdown-menu pull-right\" role=menu style=\"width: auto;\"><li><a href=\"\" ng-click=\"(invoiceWaybillCtrl.canAccept)? invoiceWaybillCtrl.openApproveModal(\'APPROVE\') : \'\'\" ng-disabled=!invoiceWaybillCtrl.canAccept tooltip-placement=bottom-right uib-tooltip=\"{{(invoiceWaybillCtrl.canAccept)? \'\' : \'Не возможно принять решение, сохранены не все данные\'}}\">Принять полностью</a></li><li><a href=\"\" ng-click=\"(invoiceWaybillCtrl.canAcceptWithDispute)? invoiceWaybillCtrl.openApproveModal(\'APPROVE_WITH_DISAGREEMENT\') : \'\'\" ng-disabled=!invoiceWaybillCtrl.canAcceptWithDispute tooltip-placement=bottom-right uib-tooltip=\"{{(invoiceWaybillCtrl.canAcceptWithDispute)? \'\' : \'Не возможно принять решение, сохранены не все данные\'}}\">Принять с разногласиями</a></li><li><a href=\"\" ng-click=\"invoiceWaybillCtrl.openApproveModal(\'DECLINE\')\">Отклонить</a></li></ul></div></div><div><button class=\"btn btn-primary pull-right\" ng-click=invoiceWaybillCtrl.save() ng-show=invoiceWaybillCtrl.redact ng-disabled=\"invoiceWaybillCtrl.invoiceWaybillForm.$invalid || !invoiceWaybillCtrl.invoiceWaybillForm.$dirty\" ng-bind=\"(invoiceWaybillCtrl.values.id)? \'Сохранить\' : \'Создать\'\"></button> <button class=\"btn pull-right\" ng-click=\"invoiceWaybillCtrl.redact = false; invoiceWaybillCtrl.returnToPage();\" ng-show=\"invoiceWaybillCtrl.redact && invoiceWaybillCtrl.values.status == \'DRAFT\'\">Отменить</button> <button class=\"btn btn-primary pull-right\" ng-click=\"invoiceWaybillCtrl.setActStatus(\'NEED_TO_DECIDE\')\" ng-if=\"invoiceWaybillCtrl.values.document_status == \'ACT_REJECTED\'\" ng-bind=\"\'Исправить\'\"></button></div></div>");
$templateCache.put("app/egaisz/modals/history-popup/history-popup.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()></button><h3 class=modal-title>Иcтория изменений</h3></div><div class=\"container history-popup-container\"><div class=gray-content><div class=\"history-head row\"><strong class=col-xs-2>Дата</strong> <strong class=col-xs-2>Статус</strong> <strong class=col-xs-2>Кто изменил</strong> <strong class=col-xs-6>Комментарий</strong></div><div class=clearfix ng-scrollbars ng-scrollbars-config=$ctrl.configScroll><div class=\"status-item clearfix row\" ng-repeat=\"statusData in $ctrl.data\"><div class=col-xs-2 ng-bind=\"::statusData.created_at | date:\'dd.MM.yyyy HH:mm\'\"></div><div class=col-xs-2 ng-bind=\"::$ctrl.getStatus(statusData.document_status || statusData.status)\"></div><div class=col-xs-2 ng-bind=\"::statusData.created_by.name || \'-\'\"></div><div class=col-xs-6 ng-bind=\"::statusData.comment || \'-\'\"></div></div></div></div></div><div class=modal-footer><button class=\"btn pull-right\" ng-click=$ctrl.close()>Закрыть</button></div>");
$templateCache.put("app/egaisz/stock-balance/alco-stock-info/alco-stock-info.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=alcoStockInfoCtrl.close()>×</button><h3 class=modal-title ng-bind-html=\"alcoStockInfoCtrl.fn2Mode? \'Детализация остатков на регистре №1\' : \'Детализация остатков в разрезе алкогольной продукции\'\"></h3></div><div class=ui-spinner ng-if=alcoStockInfoCtrl.load style=\"margin: 150px auto;\"></div><div class=\"modal-body alco-items-wrapper\" style=\"padding: 9px 40px 30px;\"><div class=clearfix style=\"padding-bottom: 5px;\"><div class=\"coll-xs-6 pull-left\"><strong>Складская позиция: </strong><span ng-class=\"{\'text-danger\': (!alcoStockInfoCtrl.resolve.data.sku_derivative)}\">{{alcoStockInfoCtrl.resolve.data.sku_derivative.name || \'для отображения складской позиции поставьте продукцию на баланс в разделе \"Остатки&nbsp;ЕГАИС\"\'}}</span></div></div><div class=clearfix style=\"padding-bottom: 10px;\" ng-if=alcoStockInfoCtrl.fn2Mode><div class=\"coll-xs-6 pull-left\"><strong>Алкогольная продукция: </strong>{{(alcoStockInfoCtrl.alcoItem.alcohol_catalog)? alcoStockInfoCtrl.alcoItem.alcohol_catalog.alc_code + \" \" + alcoStockInfoCtrl.alcoItem.alcohol_catalog.full_name : \'-\'}}</div></div><div ng-if=!alcoStockInfoCtrl.fn2Mode><grid-custom columns=alcoStockInfoCtrl.alcoItemsColumns data=alcoStockInfoCtrl.alco_items is-show-settings=false show-checkbox=false options=alcoStockInfoCtrl.gridOptions min-height=100 is-full-width=false allow-selected=true scroll-height=325 selected-callback=alcoStockInfoCtrl.rowSelectionHandler two-level-header=true totals-data={}></grid-custom></div><div ng-if=alcoStockInfoCtrl.fn2Mode class=fn-mode-wrapper><grid-custom ng-if=alcoStockInfoCtrl.fn2Data.length columns=alcoStockInfoCtrl.fn2Columns data=alcoStockInfoCtrl.fn2Data is-show-settings=false show-checkbox=false options=alcoStockInfoCtrl.gridOptions min-height=100 is-full-width=false allow-selected=false scroll-height=225></grid-custom><div class=table-footer ng-if=alcoStockInfoCtrl.fn2Data.length><paging page-info=alcoStockInfoCtrl.paging callback=alcoStockInfoCtrl.getFn1></paging></div><div ng-if=\"!alcoStockInfoCtrl.fn2Data.length && alcoStockInfoCtrl.resolve.data.sku_derivative\" style=\"text-align: center; padding: 150px 0;\">{{alcoStockInfoCtrl.fn2Mode? \'Остатки на регистре №1 не найдены\' : \'Нет данных\'}}</div><div ng-if=\"!alcoStockInfoCtrl.fn2Data.length && !alcoStockInfoCtrl.resolve.data.sku_derivative\" style=\"text-align: center; padding: 150px 0;\">Для отображения детализации остатков на регистре №1<br>поставьте продукцию на баланс в разделе \"Остатки ЕГАИС\"</div></div></div><div class=modal-footer ng-if=alcoStockInfoCtrl.fn2Mode style=\"padding-top: 0; text-align: left;\"><button class=btn type=button ng-click=\"alcoStockInfoCtrl.fn2Mode = false;alcoStockInfoCtrl.alcoItem = undefined;\"><span class=\"btn-ico btn-arrow\"></span> Вернуться</button></div><script type=text/ng-template id=numTemplateAlcoStockInfo.html><div class=\"cell-data\" style=\"padding-top: 0px;\">\n    <span>{{alcoStockInfoCtrl.alco_items.indexOf(value) + 1}}</span>\n  </div></script><script type=text/ng-template id=numTemplateFn2.html><div class=\"cell-data\" style=\"padding-top: 0px;\">\n    <span>{{alcoStockInfoCtrl.paging.offset + (alcoStockInfoCtrl.fn2Data.indexOf(value) + 1)}}</span>\n  </div></script><script type=text/ng-template id=defaultTemplate.html><div class=\"cell-data single-line text-right\" uib-tooltip=\"{{value[column.field]}}\">\n    <span ng-bind=\"value[column.field]\"></span>\n  </div></script><script type=text/ng-template id=catalogItemTemplateAlcoStock.html><div class=\"cell-data single-line\">\n    <div class=\"view-entity-control text-left catalog-item-cell\" style=\"height: 42px;\">\n      <span class=\"catalog-item-name\"\n            ng-bind=\"value[column.field].full_name\"></span>\n      <span class=\"catalog-item-derivative\"\n            ng-if=\"value[column.field].alc_code\"\n            ng-bind=\"\'Алкокод: \' + value[column.field].alc_code\"></span>\n    </div>\n    <div class=\"hover-info tooltip\">\n      <div class=\"tooltip-inner\"> {{value[column.field].full_name}}<br>\n        Алкокод: {{value[column.field].alc_code}}<br>\n        Объем: {{value[column.field].capacity}}<br>\n        Крепость: {{value[column.field].alc_volume}}<br>\n        Производитель: {{value[column.field].producer.client_reg_id + \" \" + value[column.field].producer.short_name}} </div>\n    </div>\n\n  </div></script><script type=text/ng-template id=totalTitleTemplate.html><span class=\"pull-left\">Итого</span></script><script type=text/ng-template id=totalTemplate.html><div style=\"padding-top: 0px;\">\n    <span ng-bind=\"alcoStockInfoCtrl.getTotal(column.field);\"></span>\n  </div></script><script type=text/ng-template id=documentTemplate.html><div class=\"cell-data single-line text-right\">\n      <span tooltip-placement=\"bottom\" uib-tooltip=\"{{(value[column.field].document_egais_type | docEgaisType) + \' №\' +\n      value[column.field].doc_number + \' от \' + (value[column.field].doc_date | date:\'dd.MM.yyyy\')}}\"\n            ng-bind=\"(value[column.field].document_egais_type | docEgaisType) + \' №\' +\n      value[column.field].doc_number + \' от \' + (value[column.field].doc_date | date:\'dd.MM.yyyy\')\">\n      </span>\n  </div></script><script type=text/ng-template id=fn2Template.html><div class=\"cell-data single-line text-right\">\n      <span uib-tooltip=\"{{value[column.field]}}\" tooltip-placement=\"bottom\" ng-bind=\"value[column.field]\">\n      </span>\n  </div></script>");
$templateCache.put("app/egaisz/transfer-between-register/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=transferBetweenRegisterCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons><button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Удалить ng-show=\"transferBetweenRegisterCtrl.values.id && (transferBetweenRegisterCtrl.values.document_status == \'DRAFT\' || transferBetweenRegisterCtrl.values.document_status == \'REJECTED\')\" ng-click=transferBetweenRegisterCtrl.delete()><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\"><a class=\"btn btn-ico-wrap\" target=_blank ng-click=transferBetweenRegisterCtrl.copyHandler() ng-if=\"$root.hasRole(\'transfer_between_register_egais.write\') && (transferBetweenRegisterCtrl.values.document_status == \'DRAFT\' || transferBetweenRegisterCtrl.values.document_status == \'REJECTED\' || transferBetweenRegisterCtrl.values.document_status == \'ACCOUNTED_TO\')\"><span class=\"btn-ico btn-copy tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Копировать></span>Копировать </a><button type=button class=btn ng-if=\"transferBetweenRegisterCtrl.values.document_status == \'DRAFT\' && $root.hasRole(\'transfer_between_register_egais.write\')\" ng-click=\"transferBetweenRegisterCtrl.setActStatus(\'NEED_TO_ACCOUNTED\')\" ng-disabled=transferBetweenRegisterCtrl.transferBetweenRegisterForm.$invalid>Провести</button></div></div><div><button class=\"btn btn-primary pull-right\" ng-click=transferBetweenRegisterCtrl.save() ng-show=transferBetweenRegisterCtrl.redact ng-disabled=\"transferBetweenRegisterCtrl.transferBetweenRegisterForm.$invalid || !transferBetweenRegisterCtrl.transferBetweenRegisterForm.$dirty\" ng-bind=\"(transferBetweenRegisterCtrl.values.id)? \'Сохранить\' : \'Создать\'\"></button> <button class=\"btn btn-primary pull-right\" ng-click=\"transferBetweenRegisterCtrl.setActStatus(\'DRAFT\', true)\" ng-if=\"transferBetweenRegisterCtrl.values.document_status == \'REJECTED\' && $root.hasRole(\'transfer_between_register_egais.write\')\" ng-bind=\"\'Исправить\'\"></button> <button class=\"btn pull-right\" ng-click=transferBetweenRegisterCtrl.resetData(); ng-show=\"transferBetweenRegisterCtrl.redact && transferBetweenRegisterCtrl.values.document_status == \'DRAFT\'\">Отменить</button></div></div>");
$templateCache.put("app/egaisz/write-return/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=writeReturnCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\"><button type=button class=btn ng-if=\"writeReturnCtrl.values.status == \'DRAFT\'\" ng-click=\"writeReturnCtrl.setActStatus(\'NEED_TO_ACCOUNTED\')\" ng-disabled=writeReturnCtrl.writeReturnForm.$invalid>Провести</button></div></div><div></div></div>");
$templateCache.put("app/egaisz/write-up-statement/includes/buttons.html","<div class=control-button-line-container><div><span class=\"btn back-link btn-ico-wrap\" ng-click=writeUpStatementCtrl.toGridPage()><span class=\"btn-ico btn-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"К списку\"></span>К списку</span></div><div class=center-buttons><button class=\"btn only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Удалить ng-show=\"writeUpStatementCtrl.values.id && writeUpStatementCtrl.values.status == \'DRAFT\'\" ng-click=writeUpStatementCtrl.delete()><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button><div class=\"form-group doc-settings-block\" style=\"display: inline-block; padding-right: 0\"><a class=\"btn btn-ico-wrap\" target=_blank ng-click=writeUpStatementCtrl.copyHandler() ng-if=\"$root.hasRole(\'write_up_statement_egais.write\') && writeUpStatementCtrl.values.id\"><span class=\"btn-ico btn-copy tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Копировать></span>Копировать </a><button type=button class=btn ng-if=\"writeUpStatementCtrl.values.status == \'DRAFT\'\" ng-click=\"writeUpStatementCtrl.setActStatus(\'NEED_TO_ACCOUNTED\')\" ng-disabled=\"writeUpStatementCtrl.writeUpStatementForm.$invalid || (!writeUpStatementCtrl.values.change_recs_stock && !writeUpStatementCtrl.values.change_alcohol_stock && !writeUpStatementCtrl.values.change_egais_stock)\">Провести</button></div></div><div><button class=\"btn btn-primary pull-right\" ng-click=writeUpStatementCtrl.save() ng-show=writeUpStatementCtrl.redact ng-disabled=\"writeUpStatementCtrl.writeUpStatementForm.$invalid || !writeUpStatementCtrl.writeUpStatementForm.$dirty || (!writeUpStatementCtrl.values.change_recs_stock && !writeUpStatementCtrl.values.change_alcohol_stock && !writeUpStatementCtrl.values.change_egais_stock)\" ng-bind=\"(writeUpStatementCtrl.values.id)? \'Сохранить\' : \'Создать\'\"></button> <button class=\"btn btn-primary pull-right\" ng-click=\"writeUpStatementCtrl.setActStatus(\'DRAFT\')\" ng-if=\"writeUpStatementCtrl.values.status == \'REJECTED\' || writeUpStatementCtrl.values.status == \'ACCOUNTED_ERROR\'\" ng-bind=\"\'Исправить\'\"></button> <button class=\"btn pull-right\" ng-click=writeUpStatementCtrl.resetData(); ng-disabled=writeUpStatementCtrl.writeUpStatementForm.$pristine ng-show=\"writeUpStatementCtrl.redact && writeUpStatementCtrl.values.status == \'DRAFT\'\">Отменить</button></div></div>");
$templateCache.put("app/guide/sections/address/address.html","<form action=\"\" role=form name=guide.address class=\"col-md-6 inputs-form\" novalidate><div class=col-xs-8><div class=form-group ng-class=\"{ \'has-error\': guide.address.firstAddr.$invalid && !guide.address.firstAddr.$pristine}\"><label>Aдрес номер рас <span class=req>*</span></label><address address-data=address.first name=\"\'firstAddr\'\" ng-required=true parent-form=guide.address></address></div></div><div class=col-xs-8><div class=form-group><label>Aдрес номер два</label><address address-data=address.second name=\"\'secondAddr\'\" parent-form=guide.address></address></div></div><div class=clear></div><button class=btn ng-disabled=guide.address.$invalid>Сохранить</button></form>");
$templateCache.put("app/guide/sections/barcodes/barcodes.html","<div class=barcodes><div class=barcode-wrapper><span>EAN8</span><barcode format=barcode1form value=barcode1 valid=bcValid></barcode><div class=form-group><label>Штрих-код {{bcValid}}</label><div class=\"input-group code-wraper\"><input hard-pruning data-check=[0-9] style=\"border-radius: 5px;\" ng-pattern=\"/^(?=[0-9]*$)(?:.{8}|.{12}|.{13}|.{14})$/\" code type=text class=\"form-control code-input\" maxlength=14 ng-model=barcode1><div class=\"valid-message wrong-simbol-mess\">Для ввода доступны только цифры</div><div class=\"valid-message wrong-format-mess\">Штрих-код должен содержать 8, 12, 13 или 14 цифр</div></div></div></div><div class=barcode-wrapper><span>EAN13</span><barcode format=barcode2form value=barcode2></barcode></div><div class=barcode-wrapper><span>UPС</span><barcode format=barcode3form value=barcode3></barcode></div><div class=barcode-wrapper><span>ITF-14</span><barcode format=barcode4form value=barcode4></barcode></div></div><span class=\"btn btn-primary\" ng-click=update()>update</span>");
$templateCache.put("app/guide/sections/documents/document-builder.html","<div class=guide-documents><button class=\"btn btn-primary\" ng-click=guide.buildDocument()>Генерировать</button><div class=row><div class=\"col-xs-6 result-container\"><button class=\"btn btn-success\" ng-click=\"guide.redact = !guide.redact\">Редактирование</button></div><div class=\"col-xs-6 source-container\"><h4>Разметка</h4><textarea class=form-control ng-model=guide.documentMeta style=\"font-size: 10px\"></textarea></div></div><div class=row><div class=\"col-xs-12 result-container\"><h4>Результат <i class=\"text-right glyphicon glyphicon-pencil\" ng-click=\"guide.redact = !guide.redact\"></i></h4><div><document redact=guide.redact document=guide.documentObj values=guide.values></document></div></div></div><div><h4>Данные документа</h4><pre ng-bind=\"guide.values | json\">\n    </pre></div></div>");
$templateCache.put("app/guide/sections/form-elements/datepicker.html","<div class=\"container row\"><br><button class=btn ng-click=vm.resetDatePickersData()>RESET DATEPICKERS</button><br><div class=col-xs-12></div><div class=col-xs-6><div date-range-picker ng-model=vm.datePickerWithDisabledDays state=vm.statedatePickerWithDisabledDays opts=vm.datePickerWithDisabledDaysOpts disabled-days=vm.disabledDays class=datepicker-wrap name=datePickerWithDisabledDays on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'date picker with disabled days\'\"></div><br></div><pre class=col-xs-6>\n      <span>UTC             :</span> {{vm.datePickerWithDisabledDays.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n      <span>Local           :</span> {{vm.datePickerWithDisabledDays.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' }}<br>\n      <span>timestamp       :</span> {{vm.datePickerWithDisabledDays.valueOf()}} </pre>\n  <br>\n  <button class=\"btn-default btn\" ng-click=\"vm.disabledDays.push(vm.disabledDays[vm.disabledDays.length - 1].clone().add(1, \'day\'))\">add disabled day</button>\n  <br>\n  <div class=col-xs-12></div>\n  <div class=col-xs-6>\n    <timezone auto-timezone=true timezone-data=vm.timezoneData></timezone>\n    <br>\n    <button class=\"btn btn-primary\" ng-click=vm.saveTimezone()>Save Timezone</button>\n  </div>\n  <div class=col-xs-6>\n    <div class=form-group>\n      <input type=text class=form-control ng-model=vm.timestampStart placeholder=\"start Date\">\n      <br>\n      <input type=text class=form-control ng-model=vm.timestampEnd placeholder=\"end Date\">\n      <br>\n      <button class=\"btn btn-primary\" ng-click=vm.applyTimestamp()>Apply</button>\n    </div>\n  </div>\n  <div class=col-xs-12></div>\n  <div class=col-xs-6>\n    <div date-range-picker ng-model=vm.UTCDatePicker state=vm.stateUTCDatePicker opts=vm.UTCDatePickerOpts class=datepicker-wrap on-close=\"vm.onDatePickerClose(returnValue, name)\" name=dateFrom field-label=\"\'UTC Date picker\'\">\n    </div>\n    <br>\n  </div>\n  <pre class=col-xs-6>\n      <span>UTC             :</span> {{vm.UTCDatePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n      <span>Local           :</span> {{vm.UTCDatePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' }}<br>\n      <span>timestamp       :</span> {{vm.UTCDatePicker.valueOf()}} </pre>\n  <br>\n\n  <div class=col-xs-6>\n    <div date-range-picker ng-model=vm.UTCDateTimePicker state=vm.stateUTCDateTimePicker opts=vm.UTCDateTimePickerOpts class=datepicker-wrap on-close=\"vm.onDatePickerClose(returnValue, name)\" name=dateFrom field-label=\"\'UTC DateTime picker\'\">\n    </div>\n    <br>\n  </div>\n  <pre class=col-xs-6>\n      <span>UTC             :</span> {{vm.UTCDateTimePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n      <span>Local           :</span> {{vm.UTCDateTimePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' }}<br>\n      <span>timestamp       :</span> {{vm.UTCDateTimePicker.valueOf()}} </pre>\n  <br>\n\n  <div class=col-xs-6>\n    <div date-range-picker ng-model=vm.datePicker state=vm.statedatePicker opts=vm.datePickerOpts class=datepicker-wrap on-close=\"vm.onDatePickerClose(returnValue, name)\" name=dateFrom field-label=\"\'Date picker\'\">\n    </div>\n    <br>\n  </div>\n  <pre class=col-xs-6>\n      <span>UTC             :</span> {{vm.datePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n      <span>User timezone    :</span> {{vm.datePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\': vm.timezoneData.offset }}<br>\n      <span>timestamp       :</span> {{vm.datePicker.valueOf()}} </pre>\n  <br>\n\n  <div class=col-xs-6>\n    <div date-range-picker ng-model=vm.dateTimePicker state=vm.statedateTimePicker opts=vm.dateTimePickerOpts class=datepicker-wrap name=dateFrom on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'DateTime picker\'\">\n    </div>\n    <br>\n  </div>\n  <pre class=col-xs-6>\n      <span>UTC             :</span> {{vm.dateTimePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n      <span>User timezone    :</span> {{vm.dateTimePicker.valueOf() | date : \'dd.MM.yyyy HH:mm Z\': vm.timezoneData.offset }}<br>\n      <span>timestamp       :</span> {{vm.dateTimePicker.valueOf()}} </pre>\n  <br>\n\n  <div class=col-xs-6>\n    <div date-range-picker ng-model=vm.dateRangePickerUTC state=vm.statedateRangePickerUTC opts=vm.dateRangePickerUTCOpts class=datepicker-wrap name=dateFrom on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'UTC Date range picker\'\">\n    </div>\n    <br>\n  </div>\n  <pre class=col-xs-6>\n      <span>UTC               start_date</span> {{vm.dateRangePickerUTC.startDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n                        end_date {{vm.dateRangePickerUTC.endDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n      <span>Local             start_date</span> {{vm.dateRangePickerUTC.startDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\'}}<br>\n                        end_date {{vm.dateRangePickerUTC.endDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' }}<br>\n      <span>timestamp         start_date</span> {{vm.dateRangePickerUTC.startDate.valueOf()}}<br>\n                        end_date {{vm.dateRangePickerUTC.endDate.valueOf()}}<br>\n  </pre>\n  <br>\n\n  <div class=col-xs-6>\n    <div date-range-picker ng-model=vm.dateRangePicker state=vm.statedateRangePicker opts=vm.dateRangePickerOpts class=datepicker-wrap name=dateFrom on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Date range picker\'\">\n    </div>\n    <br>\n  </div>\n  <pre class=col-xs-6>\n      <span>UTC               start_date</span> {{vm.dateRangePicker.startDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n                        end_date {{vm.dateRangePicker.endDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : \'UTC\' }}<br>\n      <span>User timezone   start_date</span> {{vm.dateRangePicker.startDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\': vm.timezoneData.offset }}<br>\n                        end_date {{vm.dateRangePicker.endDate.valueOf() | date : \'dd.MM.yyyy HH:mm Z\' : vm.timezoneData.offset }}<br>\n      <span>timestamp         start_date</span> {{vm.dateRangePicker.startDate.valueOf()}}<br>\n                        end_date {{vm.dateRangePicker.endDate.valueOf()}}<br>\n  </pre>\n  <br></div>");
$templateCache.put("app/guide/sections/form-elements/inputs.html","<form action=\"\" role=form name=guide.inputsForm class=\"col-md-6 inputs-form\" novalidate><div class=form-group><label>Тестирование поля для ввода цены. В нижней части чистое значение модели (то что уходит и приходит с бекенда)</label><input class=\"form-control text-right\" input-price currency-input ng-model=guide.priceInputValue currency-input=true currency-icon=&#8381> <input class=\"form-control text-right\" ng-model=guide.priceInputValue></div><div class=form-group><label>Ввод телефонного номера</label><div class=phone-input-wrapper><input id=tel class=form-control maxlength=15 ng-pattern=\"/^\\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/\" phone-input ng-model=guide.phone><label for=tel class=\"form-control-label phone-control-label\">Телефон</label></div><input class=form-control ng-model=guide.phone></div><div class=form-group><label>Ввод универсального логина</label><div class=phone-input-wrapper><input ng-class=\"{\'phone-input\': guide.isPhone}\" class=form-control universal-login-input is-phone=guide.isPhone ng-model=guide.uni><div class=input-flag ng-if=guide.isPhone><div class=flag-ru></div><div class=phone-code><span class=phone-code-text>+7</span></div></div><label class=\"form-control-label phone-control-label\">Логин, телефон или email</label></div><input class=form-control ng-class=\"{\'text-success\': guide.isPhone}\" ng-model=guide.uni></div><div class=form-group ng-class=\"{ \'has-error\': guide.inputsForm.reqInput.$invalid && !guide.inputsForm.reqInput.$pristine}\"><label>Обязательное поле <span class=req></span></label><input empty-to-null required type=text class=form-control maxlength=32 ng-model=guide.inputs.reqInput name=reqInput id=reqInput><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=form-group><label>Штрих-код {{guide.inputs.code}}</label><div class=\"input-group code-wraper\"><input hard-pruning data-check=[0-9] style=\"border-radius: 5px;\" ng-pattern=\"/^(?=[0-9]*$)(?:.{8}|.{12}|.{13}|.{14})$/\" code type=text class=\"form-control code-input\" maxlength=14 ng-model=guide.inputs.code><div class=\"valid-message wrong-simbol-mess\">Для ввода доступны только цифры</div><div class=\"valid-message wrong-format-mess\">Штрих-код должен содержать 8, 12, 13 или 14 цифр</div></div></div><div class=form-group><label>Не обязательное поле</label><input empty-to-null type=text class=form-control maxlength=32 ng-model=guide.inputs.noReqInput></div><div class=form-group><label>Поле с очисткой</label><input empty-to-null type=text clear-button class=\"form-control label-clear-button\" ng-model=guide.inputs.clearValue></div><div class=form-group><label>Поле с маской</label><input hard-pruning empty-to-null clear-button type=text class=\"form-control label-clear-button\" maxlength=32 ng-model=guide.inputs.maskInput data-check=\"([0-9 _])+\" ui-mask=\"999 999 999\" ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><div class=\"valid-message wrong-simbol-mess\">Необходимо ввести 9 цифр</div></div><div class=form-group><label class=control-label>Поле с валидацией \"телефон\"</label><input hard-pruning ng-model=guide.inputs.phone type=tel data-check=\"([0-9 _])+\" class=form-control maxlength=20><div class=\"valid-message wrong-simbol-mess\">Некорректные символы для телефона</div></div><div class=form-group><label class=control-label>Поле с валидацией \"E-mail\"</label><email mail=guide.inputs.email is-required=false></email></div><div class=form-group><label>Не активное поле</label><input empty-to-null disabled type=text class=form-control maxlength=32 ng-model=guide.inputs.disabledInput></div><div class=form-group><label for=realAddress>Описание</label><textarea empty-to-null class=form-control ng-model=guide.inputs.textarea></textarea></div><div class=form-group><label>Поле для ввода целых чисел</label><input integer-input type=text class=form-control maxlength=15 style=text-align:right ng-model=guide.inputs.integer><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div> {{guide.inputs.integer}} {{typeOf(guide.inputs.integer)}} <div class=form-group><label>Поле для ввода дробных чисел</label><input float-input type=text class=form-control maxlength=17 style=text-align:right ng-model=guide.inputs.float><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div> {{guide.inputs.float}} {{typeOf(guide.inputs.float)}} <div class=form-group><label>Поле для ввода целых чисел <span class=req></span></label><input integer-input required type=text class=form-control maxlength=15 style=text-align:right ng-model=guide.inputs.integerReq><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div><div class=form-group><label>Поле для ввода дробных чисел <span class=req></span></label><input float-input required type=text class=form-control maxlength=17 style=text-align:right ng-model=guide.inputs.floatReq><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div><div class=form-group><label>Поле для ввода валют</label><input float-input float-fixed=2 max-val=100 float-step=0.01 empty-values=true max-after-comma=2 currency-input=true currency-icon=$ type=text class=\"form-control currency-input\" maxlength=17 ng-model=guide.inputs.money><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div> {{guide.inputs.money}} {{typeOf(guide.inputs.money)}} <div class=form-group><label>Поле для ввода валют (цветное)</label><input float-input float-fixed=2 maxlength=15 float-step=0.01 max-after-comma=2 currency-input=true currency-icon=&#8381 type=text class=\"form-control currency-input currency-input-blue\" maxlength=17 ng-model=guide.inputs.moneyBlue><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div><br><div class=btn ng-click=guide.makeRequiest()>request</div> {{guide.requiest}} <div class=\"form-group footer-buttons\"><div class=req ng-if=guide.inputsForm.isWrongFormData>Поля, помеченные *, обязательные для заполнения</div><a href=javascript:void(0) class=\"btn btn-link-main right-button pull-right\" ng-click=\"guide.inputsForm.$valid ? guide.inputsForm.isWrongFormData = false : guide.setDirty(guide.inputsForm)\">Сохранить</a></div></form><div class=col-md-6><h4>Основные поля для ввода данных, которые используются в формах</h4>Про отображение подробнее прочитать <a href=\"http://srv-recs-inf01:8090/pages/viewpage.action?pageId=4654916\" target=_blank>тут</a><br><br>В данной форме для валидации применена дирректива <strong>hardPruning</strong>, которая обеспечивает жесткую обрезку лишних символов и проверку формата введенных данных.<br><br>Для того чтобы обозначить допустимые символы для ввода - необходимо использовать атрибут <strong>ng-pattern</strong> с регулярным выражением. Для того чтобы обеспечить еще и проверку формата введенных данных (например e-mail) - необходимо еще использовать два атрибута:<ul><li><strong>ng-pattern</strong> - для указания регулярного выражения проверки формата</li><li><strong>data-check</strong> - для указания допустимых символов для ввода.</li></ul>Пример<pre>&lt;input type=\"text\" hard-pruning ng-pattern=\'/^/\\S+@\\S+\\.\\S+/$/\' data-check=\"[A-Za-z\\d()@._-]\"&gt;</pre><br><br>Поле с маской тоже использует <strong>hardPruning</strong> для валидации.<br>Для того чтобы применить маску необходимо написать два атрибута<ul><li><strong>ui-mask</strong> - с типом маски, например \"999 999 999\"</li><li><strong>ui-options</strong> - для разных опций маски.</li></ul>Пример<pre>&lt;input hard-pruning type=\"text\" data-check=\"([0-9 _])+\" ui-mask=\"999 999 999\"  ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"&gt;</pre></div>");
$templateCache.put("app/guide/sections/form-elements/selection-lists.html","<form name=guide.selectsForm class=\"col-md-5 selects-form\"><div class=form-group ng-class=\"{ \'has-error\': !guide.contragents.length}\"><label>Список выбора c созданием новой сущности <span class=req>*</span></label><ui-select ng-model=guide.select.create search-enabled=\"guide.contragentsTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-required=true ng-disabled=!guide.contragents.length><ui-select-match placeholder=\"Выберите значение\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=guide.refreshContragents($select.search) repeat=\"contragent in (guide.contragents) track by $index\"><span ng-bind-html=\"contragent.name | highlight: $select.search\"></span> <span ng-if=\"$index == (guide.contragents.length - 1)\"><a ui-sref=\"contragent.new({parent: vm.parentPage})\">Создать контрагента</a></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=form-group ng-class=\"{ \'has-error\': !guide.contragents.length}\"><label>Список выбора c поиском <span class=req>*</span></label><ui-select ng-model=guide.select.search search-enabled=\"guide.contragentsTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-required=true ng-disabled=!guide.contragents.length><ui-select-match placeholder=\"Выберите значение\"><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=guide.refreshContragents($select.search) repeat=\"contragent in (guide.contragents) track by $index\"><span ng-bind-html=\"contragent.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=form-group><label>Список выбора без поиска</label><ui-select ng-model=guide.select.noSearch search-enabled=false ng-disabled=!guide.contragents.length><ui-select-match placeholder=\"Выберите значение\" allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=guide.refreshContragents($select.search) repeat=\"contragent in (guide.contragents) track by contragent.id\"><span ng-bind-html=\"contragent.name | highlight: $select.search\"></span></ui-select-choices></ui-select></div><div class=form-group><label>Список c множественным выбором</label><multiselect model-save-field=name class=multiselect ng-model=guide.select.multiple options=guide.contragentsAll show-search=false display-prop=name id-prop=id labels=\"{select: \'Выберите значение\', itemsSelected: (guide.select.multiple.length < 5)? \' значения\' : \' значений\'}\" data-toggle=dropdown ng-disabled=!guide.contragentsAll.length></multiselect><!-- <br><br>\n    <div ng-dropdown-multiselect=\"\" options=\"guide.contragentsAll\" events=\"guide.yourEvents\" selected-model=\"guide.select.multiple\" extra-settings=\"guide.multipleSettings\" translation-texts=\"guide.customTexts\"></div> --></div><pre>{{guide.select.multiple | json}}</pre><div class=form-group><label>Список c множественным выбором (обязательное поле) <span class=req>*</span></label><multiselect required class=multiselect ng-model=guide.select.multiple1 options=guide.contragentsAll show-search=false display-prop=name id-prop=id labels=\"{select: \'Выберите значение\', itemsSelected: (guide.select.multiple1.length < 5)? \' значения\' : \' значений\'}\" data-toggle=dropdown ng-disabled=!guide.contragentsAll.length></multiselect></div><div class=\"form-group row\"><div class=col-md-12><label>Подразделения</label><ui-select multiple class=multiple-select ng-model=guide.select.divisions theme=bootstrap close-on-select=false><ui-select-match placeholder=\"Выберите значение\">{{$item.name + \' - \' + $item.$$companyName}}</ui-select-match><ui-select-choices repeat=\"division in guide.divisionsData\"><span ng-bind=\"division.name + \' - \' + division.$$companyName\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-12><label>Контрагенты:</label><ui-select multiple class=multiple-select ng-model=guide.select.multiple2 theme=bootstrap close-on-select=false><ui-select-match placeholder=\"Выберите значение\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"contragent in guide.contragentsAll\"> {{contragent.name}} </ui-select-choices></ui-select></div></div><div class=\"form-group footer-buttons\"><div class=req ng-if=guide.selectsForm.isWrongFormData>Поля, помеченные *, обязательные для заполнения</div><button class=\"btn btn-link-main right-button pull-right\" ng-click=\"guide.selectsForm.$valid ? guide.selectsForm.isWrongFormData = false : guide.setDirty(guide.selectsForm)\">Сохранить</button></div></form><div class=col-md-7><h4>Основные виды выпадающих списков, которые используются в формах</h4>Про отображение подробнее прочитать <a href=\"http://srv-recs-inf01:8090/pages/viewpage.action?pageId=4654964\" target=_blank>тут</a><br><br><h4>Одиночный список выбора</h4>Для отображения одиночного списка выбора применяется библиотека <strong>ui select</strong>. Основной пример:<pre>&lt;ui-select ng-model=\"selected.value\" search-enabled=\"true\"&gt;\n    &lt;ui-select-match allow-clear=\"true\"&gt;\n        &lt;span ng-bind=\"$select.selected.name\"&gt;&lt;/span&gt;\n    &lt;/ui-select-match&gt;\n    &lt;ui-select-choices refresh=\"callback\" repeat=\"item in (itemArray | filter: $select.search) track by item.id\"&gt;\n        &lt;span ng-bind=\"item.name\"&gt;&lt;/span&gt;\n    &lt;/ui-select-choices&gt;\n&lt;/ui-select&gt;</pre>Используются такие нестандартные атрибуты:<ul><li><strong>search-enabled</strong> - для включения и отключения поиска</li><li><strong>refresh</strong> - для вызова функции подгрузки элементов при поиске</li><li><strong>allow-clear</strong> - для включения функции очистки поля</li></ul><br><br><h4>Множественный список выбора</h4>Для выпадающего списка с несколькими вариантами выбора использкется библиотека <strong>Angular Bootstrap Multiselect</strong> Основной пример:<pre>&lt;multiselect ng-model=\"multiple\" options=\"allOptions\" show-search=\"false\" display-prop=\"name\" id-prop=\"id\" labels=\"{select: \'Выберите значение\', itemsSelected: \' значений\'}\" data-toggle=\"dropdown\"&gt;</pre>Описание атрибутов:<ul><li><strong>options</strong> - массив с полным списком элементов в выпадающем блоке</li><li><strong>show-search</strong> - разрешает/запрещает поиск</li><li><strong>display-prop</strong> - свойство объекта, которое выводится в выпадающем списке</li><li><strong>id-prop</strong> - поле с id элемента(обязательный атрибут)</li><li><strong>labels</strong> - для перевода надписей библиотеки</li><li><strong>data-toggle=\"dropdown\"</strong> - для корректного открытия/закрытия выпадающего списка</li></ul><br><br><h4>Множественный список выбора с дополнителым полем отображения</h4>Реализован посредством взаимодействия двух <strong>ui select</strong> с атрибутом multiple.<br></div>");
$templateCache.put("app/guide/sections/messages/messages.html","<div class=guide-messages><button class=\"btn btn-primary\" ng-click=guide.buildSurvey()>Генерировать</button><div class=row><div class=\"col-xs-6 result-container\"><h4>Результат <i class=\"text-right glyphicon glyphicon-pencil\" ng-click=\"guide.redact = !guide.redact\"></i></h4><div><survey survey=guide.messageObj show-header=true values=guide.messageData></survey></div></div><div class=\"col-xs-6 source-container\"><h4>Разметка</h4><div><div ng-repeat=\"surveyItem in guide.userSurveys\"><a href=\"\" ng-bind=surveyItem.code ng-click=guide.setSurvey(surveyItem)></a></div></div><textarea class=form-control ng-model=guide.survey style=\"font-size: 10px\"></textarea></div></div><div><h4>Данные опроса</h4><pre ng-bind=\"guide.messageData | json\">\n    </pre></div></div>");
$templateCache.put("app/guide/sections/tree/catalog-tree.html","<div class=row><div class=col-xs-8><form class=form-inline name=guide.newCategory><div class=form-group><input id=new-category type=text style=\"min-width: 300px\" class=form-control placeholder=\"Наименование новой категории\" ng-model=guide.newCategoryName required></div><button class=\"btn btn-default\" style=\"margin-left: 10px\" ng-click=guide.addCatalog() ng-disabled=!guide.newCategory.$valid>Добавить</button></form><br><catalog-tree selected-callback=guide.selectCallback expand-node=guide.expand root=guide.root></catalog-tree></div><div class=col-xs-4><span class=text-muted>Компонент в разработке. В качестве примера использования взят единый класссификатор. Работа с ним на текущий момент реализована на бекенде.</span><h4>Компонент дерева предназначен для отображения иерархической информации.</h4>Компоненту необходимо передать несколько управляющих атрибутов:<ul><li><strong>root</strong> - корневой узел</li><li><strong>expand-node</strong> - метод, позволяющий получить потомков узла</li></ul>Пример<pre>&lt;catalog-tree expand-node=\"guide.expand\" root=\"guide.root\"&gt;&lt/catalog-tree&gt;</pre></div></div>");
$templateCache.put("app/guide/sections/tree/price-tree.html","<div class=row><div class=col-xs-8><catalog-tree selected-callback=guide.selectCallback expand-node=guide.expand columns=guide.treeColumns root=guide.root></catalog-tree></div><div class=col-xs-4><span class=text-muted>Компонент в разработке. В качестве примера использования взят единый класссификатор. Работа с ним на текущий момент реализована на бекенде.</span><h4>Компонент дерева предназначен для отображения иерархической информации.</h4>Компоненту необходимо передать несколько управляющих атрибутов:<ul><li><strong>root</strong> - корневой узел</li><li><strong>expand-node</strong> - метод, позволяющий получить потомков узла</li></ul>Пример<pre>&lt;catalog-tree expand-node=\"guide.expand\" root=\"guide.root\"&gt;&lt/catalog-tree&gt;</pre></div></div>");
$templateCache.put("app/guide/sections/tree/templates.html","<script type=text/ng-template id=statusTemplate.html><div style=\"padding: 0 6px; height: 50px\"> {{value._rowsVolume}} </div></script><script type=text/ng-template id=testTemplate.html><div style=\"padding: 0 6px\">\n    <small class=\"text-muted\">{{value._rowsPosition}} шт.</small><br>\n    <span>{{value._rowsPosition}}</span>\n  </div></script>");
$templateCache.put("app/guide/sections/widgets/widgets-simple.html","<div class=pull-right style=\"width: 300px\"><widget-container widgets=guide.widgets></widget-container></div>");
$templateCache.put("app/inventory/stock/stock-print/stock-print.html","<div class=modal-header><button type=button class=close ng-click=ctrl.close()>×</button><h3 class=modal-title>Отчет по складским остаткам</h3></div><div class=\"container row\"><div ng-show=!ctrl.longRequest.crudState.loading><div ng-if=!ctrl.longRequest.flags.finish><label class=col-xs-12 style=\"padding-left: 15px;padding-bottom: 20px;\">Формат файла</label><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio checked name=formatType value=PDF id=pdf ng-model=ctrl.format.type> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=\"pdf label-icon\"></span><label class=\"label-radio label-with-icon\" for=pdf>PDF</label></div><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=formatType value=XLS id=xls ng-model=ctrl.format.type> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=\"xls label-icon\"></span><label class=\"label-radio label-with-icon\" for=xls>XLS</label></div></div></div><inview-loader class=popup show=ctrl.longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center;\" ng-if=\"ctrl.longRequest.crudState.loading && !ctrl.longRequest.flags.finish\">Подготовка отчета</h4><h4 style=\"text-align: center;\" ng-if=\"!ctrl.longRequest.crudState.loading && ctrl.longRequest.flags.finish && !ctrl.longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center;\" ng-if=ctrl.longRequest.flags.error>При подготовке отчета произошла ошибка</h4></div><div class=modal-footer><button class=btn type=button ng-click=ctrl.close()>{{ctrl.longRequest.flags.finish ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-show=\"!ctrl.longRequest.crudState.loading && !ctrl.longRequest.flags.processStart && !ctrl.longRequest.flags.finish\" class=\"btn btn-primary\" type=button ng-click=\"ctrl.hide = true;ctrl.print()\">Печать</button></div>");
$templateCache.put("app/messages/components/survey/survey.html","<div class=\"survey-container crud-entity\" ng-form=surveyCtrl.surveyForm><h5 class=section-header><span ng-bind=surveyCtrl.survey.title title=surveyCtrl.survey.title></span></h5><div class=\"survey-step clearfix\" ng-repeat=\"step in surveyCtrl.survey.items\"><div class=\"survey-step-title text-muted\" ng-if=step.name ng-bind=step.name></div><p ng-bind-html=step.messageSafe data-ellipsis data-ellipsis-symbol=... ng-style=\"(surveyCtrl.callbackClose)? {\'height\': \'70px;\', \'overflow\': \'hidden;\'} : \'\'\"></p><div ng-switch=step.type.toUpperCase() class=survey-item-response><div ng-switch-when=STRING><div class=form-group><input class=\"form-control slim-control\" name=\"{{step.code}}\" placeholder=\"{{step.placeholder}}\" ng-disabled=!surveyCtrl.redact ng-model=surveyCtrl.values[step.code] ng-required=step.required></div></div><div ng-switch-when=TEXT><div class=form-group><textarea class=\"form-control slim-control\" style=\"resize: none;\" name=\"{{step.code}}\" placeholder=\"{{step.placeholder}}\" ng-disabled=!surveyCtrl.redact ng-model=surveyCtrl.values[step.code] ng-required=step.required>\n        </textarea></div></div><div ng-switch-when=BUTTONS><div class=\"form-group buttons-block\"><div style=\"margin-bottom: 10px;\" ng-repeat=\"item in step.values\"><button ng-click=\"surveyCtrl.setValue(step.code, item, $event)\" ng-class=\"{\'btn-primary\': !$index, \'btn-default\': $index}\" class=btn ng-disabled=!surveyCtrl.redact><span class=btn-ico ng-class=\"{\'btn-ok-light\': !$index, \'btn-ok\': $index}\" ng-if=\"surveyCtrl.values[step.code] == item\" uib-tooltip=\"Ваш вариант выбора\"></span> <span ng-bind=item></span></button></div></div></div><div ng-switch-when=COMBOBOX><div class=form-group><div class=radio-box style=\"padding-left: 15px;\"><div style=\"margin-bottom: 10px;\" ng-repeat=\"item in step.values\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{step.code}}{{$index}}\" ng-disabled=!surveyCtrl.redact ng-change=surveyCtrl.valueChange(step.code) ng-value=item id=\"{{step.code}}{{$index}}\" ng-model=surveyCtrl.values[step.code]> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{step.code}}{{$index}}\" ng-bind=item></label></div></div></div></div><div ng-switch-when=BOOLEAN><div class=form-group><div class=radio-box style=\"padding-left: 15px;\"><div style=\"display: inline-block; margin-right: 20px;\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{step.code}}\" ng-value=\"\'true\'\" ng-disabled=!surveyCtrl.redact ng-change=surveyCtrl.valueChange(step.code) id=\"{{step.code}}Yes\" ng-model=surveyCtrl.values[step.code]> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{step.code}}Yes\">Да</label></div><div style=\"display: inline-block\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{step.code}}\" ng-value=\"\'false\'\" ng-disabled=!surveyCtrl.redact ng-change=surveyCtrl.valueChange(step.code) id=\"{{step.code}}No\" ng-model=surveyCtrl.values[step.code]> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{step.code}}No\">Нет</label></div></div></div></div></div></div></div>");
$templateCache.put("app/mobile/catalog/attributes/attr.html","<header class=header><div class=container><div class=arrow ng-click=catalogItemAttrMobileCtrl.goBack();></div><div class=title>Атрибуты</div></div></header><div ng-if=catalogItemAttrMobileCtrl.loading ng-include=\"\'app/mobile/loader.html\'\"></div><form name=catalogItemAttrMobileCtrl.attrForm class=container-wrapper style=\"padding-top: 0;\"><div class=\"container mobile-attrs\" style=\"padding-top: 15px;\"><div ng-repeat=\"attribute in catalogItemAttrMobileCtrl.attributesFields\"><div class=\"column clearfix\" ng-attr-id=\"{{attribute.id + \'Anchor\'}}\"><attr-element-mobile parent-form=catalogItemAttrMobileCtrl.attrForm attribute=attribute data=catalogItemAttrMobileCtrl.attribValues[attribute.name] attr-index=$index></attr-element-mobile></div></div></div></form><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=catalogItemAttrMobileCtrl.save() ng-disabled=catalogItemAttrMobileCtrl.attrForm.$invalid>Далее</button></div>");
$templateCache.put("app/mobile/catalog/category/category.html","<div ng-if=\"categoryMobileCtrl.state.current.name == \'catalogMobile.category\'\"><header class=header><div class=container><div class=arrow ng-click=categoryMobileCtrl.goBack();></div><div class=title>Данные о категории</div></div></header><div ng-if=categoryMobileCtrl.loading ng-include=\"\'app/mobile/loader.html\'\"></div><div><form name=categoryMobileCtrl.categoryForm class=\"container steps\" ng-keydown=categoryMobileCtrl.keypress($event) style=\"padding-bottom: 14.4vw;\"><div class=form-group><textarea required class=form-control maxlength=150 name=name ng-model=categoryMobileCtrl.category.name ng-blur=categoryMobileCtrl.uniqueCheck(categoryMobileCtrl.category.name) ng-keyup=\"categoryMobileCtrl.categoryForm.name.$setValidity(\'unique\', true)\" id=name></textarea><label for=name class=form-control-label>Наименование</label></div><div class=form-control-error ng-if=\"categoryMobileCtrl.categoryForm.name.$dirty && categoryMobileCtrl.categoryForm.name.$error.required\">Поле обязательно для заполнения</div><div class=form-control-error ng-if=\"categoryMobileCtrl.categoryForm.name.$dirty && categoryMobileCtrl.categoryForm.name.$error.unique\">Категория уже существует</div><mobile-select config=categoryMobileCtrl.parentConfig ng-model=categoryMobileCtrl.category.parent></mobile-select><mobile-select config=categoryMobileCtrl.cashRegisterConfig ng-model=categoryMobileCtrl.category.cash_register_item_type></mobile-select><div class=\"form-group checkbox-group\"><label for=hasMarkedSKU class=checkbox-label style=\"width: 75%;\">Категория содержит товар, подлежащий обязательной маркировке</label><div class=\"checkbox pull-right\"><label><input type=checkbox ng-model=categoryMobileCtrl.hasMarkedSKU id=hasMarkedSKU ng-change=categoryMobileCtrl.hasMarkedChange()> <span class=cr><i class=cr-icon></i></span></label></div></div><div ng-if=categoryMobileCtrl.hasMarkedSKU><mobile-select config=categoryMobileCtrl.productGroupConfig ng-model=categoryMobileCtrl.category.product_group></mobile-select><mobile-select config=categoryMobileCtrl.scanMarkConfig ng-model=categoryMobileCtrl.category.scan_mark_type></mobile-select></div><div class=text-danger ng-if=categoryMobileCtrl.errorMessage ng-bind=categoryMobileCtrl.errorMessage></div></form><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=categoryMobileCtrl.save() ng-disabled=categoryMobileCtrl.categoryForm.$invalid ng-bind=\"(categoryMobileCtrl.isNew)? \'Создать категорию\' : \'Сохранить категорию\'\"></button></div></div></div><div ng-if=\"categoryMobileCtrl.state.current.name !== \'catalogMobile.category\'\" ng-class=categoryMobileCtrl.theme.toLowerCase()><div class=ui-view-wrapper><div ui-view></div></div></div>");
$templateCache.put("app/mobile/catalog/create-catalog-route/create-catalog-route.html","<div ng-class=createCatalogRouteCtrl.theme.toLowerCase()><header class=header><div class=container><div class=arrow ng-click=createCatalogRouteCtrl.goBack()></div><div class=title>Добавление</div></div></header><div class=container-wrapper style=\"padding-top: 0;\"><p class=\"container steps\">Добавить категорию, товар или услугу?</p><div class=buttons-wrapper><a ui-sref=\"catalogMobile.category({parent: createCatalogRouteCtrl.params.parent, parentname: createCatalogRouteCtrl.params.parentname, theme: createCatalogRouteCtrl.params.theme})\" class=btn>Категорию</a> <a ui-sref=\"catalogMobile.scangtin({parent: createCatalogRouteCtrl.params.parent, parentname: createCatalogRouteCtrl.params.parentname, isarchived: true, theme: createCatalogRouteCtrl.params.theme})\" class=\"btn btn-secondary\">Товар</a> <a ui-sref=\"catalogMobile.mservice({parent: createCatalogRouteCtrl.params.parent,  parentname: createCatalogRouteCtrl.params.parentname, isarchived: true, theme: createCatalogRouteCtrl.params.theme})\" class=\"btn btn-primary\">Услугу</a></div></div></div>");
$templateCache.put("app/mobile/catalog/delete/delete.html","<div ng-class=deleteCatalogItemCtrl.theme.toLowerCase()><header class=header><div class=container><div class=arrow ng-click=deleteCatalogItemCtrl.goBack()></div><div class=title>Удаление {{(deleteCatalogItemCtrl.params.type == \'CATEGORY\') ? \'категории\' : (deleteCatalogItemCtrl.params.type == \'SKU\'? \'товара\' : \'услуги\')}}</div></div></header><div ng-if=deleteCatalogItemCtrl.loading ng-include=\"\'app/mobile/loader.html\'\"></div><div class=container-wrapper style=\"padding-top: 0;\"><p class=\"container steps\">Вы действительно хотите удалить {{(deleteCatalogItemCtrl.params.type == \'CATEGORY\') ? \'категорию\' : (deleteCatalogItemCtrl.params.type == \'SKU\'? \'товар\' : \'услугу\')}} <strong ng-bind=deleteCatalogItemCtrl.params.parentname></strong>?</p><div class=buttons-wrapper><button ng-click=deleteCatalogItemCtrl.delete() class=btn>Да</button> <button ng-click=deleteCatalogItemCtrl.goBack() class=\"btn btn-primary\">Нет</button></div></div></div>");
$templateCache.put("app/mobile/catalog/price/price.html","<header class=header><div class=container><div class=arrow ng-click=catalogItemPriceMobileCtrl.goBack();></div><div class=title ng-bind=\"catalogItemPriceMobileCtrl.isSku? \'Цена товара\' : \'Цена услуги\'\"></div></div></header><div ng-if=catalogItemPriceMobileCtrl.loading ng-include=\"\'app/mobile/loader.html\'\"></div><form name=catalogItemPriceMobileCtrl.priceForm class=container-wrapper style=\"padding-top: 0;\"><div class=container style=\"padding-top: 15px;\"><mobile-select config=catalogItemPriceMobileCtrl.columnsConfig ng-model=catalogItemPriceMobileCtrl.catalogItem.price_detail.column ng-if=\"catalogItemPriceMobileCtrl.columnsLen !== 1\" callback=catalogItemPriceMobileCtrl.getPrice></mobile-select><mobile-select config=catalogItemPriceMobileCtrl.priceTypeConfig ng-model=catalogItemPriceMobileCtrl.catalogItem.price_detail.price_type></mobile-select><div class=form-group><input input-price required class=form-control ng-model=catalogItemPriceMobileCtrl.catalogItem.price_detail.price_for_one_uom currency-input currency-input=true currency-icon=\"{{catalogItemPriceMobileCtrl.catalogItem.price_detail.column.currency.symbol || catalogItemPriceMobileCtrl.currency.symbol}}\"><label class=form-control-label>Цена</label></div></div><div class=text-danger ng-if=catalogItemPriceMobileCtrl.errorMessage ng-bind=catalogItemPriceMobileCtrl.errorMessage></div></form><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=catalogItemPriceMobileCtrl.save() ng-disabled=catalogItemPriceMobileCtrl.priceForm.$invalid ng-bind=\"((catalogItemPriceMobileCtrl.catalogItem.id)? \'Сохранить \' : \'Создать \') + ((catalogItemPriceMobileCtrl.isSku)? \'товар\' : \'услугу\')\"></button></div>");
$templateCache.put("app/mobile/catalog/recover/recover.html","<div ng-class=mrecoverCtrl.theme.toLowerCase()><header class=header><div class=container><div class=arrow ng-click=mrecoverCtrl.goBack()></div><div class=title> {{(mrecoverCtrl.isArchived? \'Архивирование\' : \'Восстановление\')}} {{(mrecoverCtrl.choosenItem.type == \'SKU\'? \'товара\' : \'услуги\')}} </div></div></header><div ng-if=mrecoverCtrl.loading ng-include=\"\'app/mobile/loader.html\'\"></div><div class=container-wrapper style=\"padding-top: 0;\"><p class=\"container steps\" ng-if=!mrecoverCtrl.isArchived ng-bind=\"(mrecoverCtrl.choosenItem.type == \'SKU\')? \'После восстановления товар будет доступен для продажи на кассе\' : \'После восстановления услуга будет доступна для продажи на кассе\'\"></p><p class=\"container steps\" ng-if=mrecoverCtrl.isArchived ng-bind-html=\"\'Вы действительно хотите отправить <strong>\' + mrecoverCtrl.choosenItem.name + \'</strong> в архив?<br><br>\' + ((mrecoverCtrl.choosenItem.type == \'SKU\')? \'Продажа архивного товара невозможна\' : \'Предоставление архивной услуги невозвожно\')\"></p><p class=\"container steps text-danger\" ng-bind=mrecoverCtrl.errorMessage style=\"padding-top: 0;\"></p><div class=buttons-wrapper><button ng-click=mrecoverCtrl.action() class=btn ng-bind=\"(mrecoverCtrl.isArchived)? \'Да\' : \'Восстановить\'\"></button> <button ng-click=mrecoverCtrl.goBack() class=\"btn btn-primary\" ng-bind=\"(mrecoverCtrl.isArchived)? \'Нет\' : \'Отменить\'\"></button></div></div></div>");
$templateCache.put("app/mobile/catalog/scangtin/scangtin.html","<div ng-class=scangtinCtrl.theme.toLowerCase() focus-request=true tabindex=0 ng-keypress=scangtinCtrl.applyScannerKeys($event)><header class=header><div class=container><div class=arrow ng-click=scangtinCtrl.goBack()></div><div class=title>Сканирование штрих-кода</div></div></header><div class=container-wrapper style=\"padding-top: 0; height: 89vh;\"><p class=\"container steps text-muted\">Отсканировать штрих-код товара</p><div class=buttons-wrapper><a ui-sref=catalogMobile.msku(scangtinCtrl.params) class=\"btn btn-primary\">Пропустить</a></div></div></div>");
$templateCache.put("app/mobile/catalog/search-catalog/search-catalog.html","<div class=\"mobile-catalog-wrapper {{searchCatalogCtrl.theme.toLowerCase()}}\"><search-header catalog-items-length=searchCatalogCtrl.catalogItems.length choosen-item=searchCatalogCtrl.choosenItem type=\"searchCatalogCtrl.choosenItem.type || \'CATEGORY\'\" search-callback=searchCatalogCtrl.searchCallback search-active=true search-loading=searchCatalogCtrl.searchLoading></search-header><div class=main-container style=\"padding-top: 0;\"><div class=catalog ng-class=searchCatalogCtrl.class><div ng-if=searchCatalogCtrl.searchLoading ng-include=\"\'app/mobile/loader.html\'\"></div><div class=\"catalog-item-wrapper row-name {{item.type? item.type.toLowerCase() : \'category\'}}\" ng-class=\"{\'choosen\': searchCatalogCtrl.choosenItem.id == item.id, \'archived\': item.status == \'ARCHIVED\'}\" ng-repeat=\"item in searchCatalogCtrl.searchData\" ng-style=\"{\'transition-delay\': (($index + 2) * 50) + \'ms\'}\" ng-click=searchCatalogCtrl.chooseSearchData(item) ng-if=\"!searchCatalogCtrl.searchLoading && searchCatalogCtrl.searchData.length\"><span class=catalog-item><span ng-show=\"::!item.type || item.type == \'CATEGORY\'\" class=\"catalog-folder major-font\" ng-bind=::searchCatalogCtrl.getAbbreviation(item.name)></span> <span class=\"default-cell-text major-font\" ng-class=\"item.type? item.type.toLowerCase() : \'category\'\" ng-bind=::item.name></span> <span ng-show=::item.price class=price ng-bind=\"::((item.price.price_for_one_uom / 100) + \' ₽\')\"></span></span></div><div class=\"container-wrapper error-wrapper\" ng-if=\"!searchCatalogCtrl.searchLoading && !searchCatalogCtrl.searchData.length\"><div class=sad></div><p class=major-font>Поиск не дал результатов</p><p class=major-font>Попробуйте уточнить запрос и повторить попытку</p></div></div></div></div>");
$templateCache.put("app/mobile/catalog/service/service.html","<div ng-if=\"serviceMobileCtrl.state.current.name == \'catalogMobile.mservice\'\" ng-class=serviceMobileCtrl.theme.toLowerCase()><header class=header><div class=container><div class=arrow ng-click=serviceMobileCtrl.goBack();></div><div class=title>Данные об услуге</div></div></header><div class=container-wrapper style=\"padding-top: 0;\"><form name=serviceMobileCtrl.serviceForm class=\"container steps\"><div class=form-group><textarea required class=form-control maxlength=150 name=name ng-model=serviceMobileCtrl.service.name ng-keyup=\"serviceMobileCtrl.serviceForm.name.$setValidity(\'unique\', true); serviceMobileCtrl.uniqueCheck(serviceMobileCtrl.service.name, \'name\')\" id=name></textarea><label for=name class=form-control-label>Наименование</label></div><div class=form-control-error ng-if=\"serviceMobileCtrl.serviceForm.name.$dirty && serviceMobileCtrl.serviceForm.name.$error.required\">Поле обязательно для заполнения</div><div class=form-control-error ng-if=\"serviceMobileCtrl.serviceForm.name.$dirty && serviceMobileCtrl.serviceForm.name.$error.unique\">Услуга уже существует</div><mobile-select config=serviceMobileCtrl.parentConfig ng-model=serviceMobileCtrl.service.category></mobile-select><div class=form-group><input empty-to-null required type=text class=form-control ng-model=serviceMobileCtrl.service.code maxlength=30 name=derivative_code_prefix ng-blur=\"serviceMobileCtrl.uniqueCheck(serviceMobileCtrl.service.code, \'derivative_code_prefix\')\" ng-keyup=\"serviceMobileCtrl.serviceForm.derivative_code_prefix.$setValidity(\'unique\', true)\" id=code autocomplete=off><label for=code class=form-control-label>Код услуги</label></div><div class=form-control-error ng-if=\"serviceMobileCtrl.serviceForm.code.$dirty && serviceMobileCtrl.serviceForm.derivative_code_prefix.$error.required\">Поле обязательно для заполнения</div><div class=form-control-error ng-if=serviceMobileCtrl.serviceForm.derivative_code_prefix.$error.unique>Код услуги уже существует</div><mobile-select config=serviceMobileCtrl.taxGroupConfig ng-model=serviceMobileCtrl.service.tax_group></mobile-select><mobile-select config=serviceMobileCtrl.uomConfig ng-model=serviceMobileCtrl.service.uom></mobile-select><div class=text-danger ng-if=serviceMobileCtrl.errorMessage ng-bind=serviceMobileCtrl.errorMessage></div></form><div class=buttons-wrapper ng-init=serviceMobileCtrl.calculNexStep();><a class=\"btn btn-primary\" ng-if=\"serviceMobileCtrl.isAttr === true\" ui-sref=catalogMobile.mservice.attr(serviceMobileCtrl.params) ng-disabled=serviceMobileCtrl.serviceForm.$invalid ng-click=\"(serviceMobileCtrl.serviceForm.$invalid)? $event.preventDefault() : \'\'\">Далее</a> <a class=\"btn btn-primary\" ng-if=\"serviceMobileCtrl.isAttr === false\" ui-sref=catalogMobile.mservice.price(serviceMobileCtrl.params) ng-disabled=serviceMobileCtrl.serviceForm.$invalid ng-click=\"(serviceMobileCtrl.serviceForm.$invalid)? $event.preventDefault() : \'\'\">Далее</a></div></div></div><div ng-if=\"serviceMobileCtrl.state.current.name !== \'catalogMobile.mservice\'\" ng-class=serviceMobileCtrl.theme.toLowerCase()><div class=ui-view-wrapper><div ui-view></div></div></div>");
$templateCache.put("app/mobile/catalog/sku/sku.html","<div ng-if=\"skuMobileCtrl.state.current.name == \'catalogMobile.msku\'\" ng-class=skuMobileCtrl.theme.toLowerCase()><header class=header><div class=container><div class=arrow ng-click=skuMobileCtrl.goBack();></div><div class=title>Данные о товаре</div></div></header><div class=container-wrapper style=\"padding-top: 0;\"><form name=skuMobileCtrl.skuForm class=\"container steps\" ng-keydown=skuMobileCtrl.keypress($event)><div class=form-group ng-if=skuMobileCtrl.needWeightBarcode><input code gtin-type=skuMobileCtrl.weightBarcodeType type=text class=\"form-control code-input\" maxlength=20 ng-model=skuMobileCtrl.weightBarcode name=gtin disabled autocomplete=off style=\"padding-right: 22%;\"><label for=gtin class=form-control-label>Весовой штрих-код</label></div><div class=form-group ng-if=!skuMobileCtrl.needWeightBarcode><input hard-pruning data-check=[0-9] code gtin-type=skuMobileCtrl.sku.sku_list[0].gtin_list[0].type ng-pattern=\"/^(?=[0-9]*$)(?:.{4,})$/\" type=text class=\"form-control code-input\" maxlength=20 ng-model=skuMobileCtrl.sku.sku_list[0].gtin_list[0].gtin name=gtin autocomplete=off ng-blur=\"skuMobileCtrl.uniqueCheck(skuMobileCtrl.sku.sku_list[0].gtin_list[0].gtin, \'gtin\');skuMobileCtrl.getSkuByGtin(skuMobileCtrl.sku.sku_list[0].gtin_list[0].gtin);\" ng-keyup=\"skuMobileCtrl.skuForm.gtin.$setValidity(\'unique\', true)\" style=\"padding-right: 22%;\"><label for=gtin class=form-control-label>Штрих-код</label></div><div class=form-control-error ng-if=skuMobileCtrl.skuForm.gtin.$error.unique>Штрих-код уже существует</div><div class=form-group><textarea required class=form-control maxlength=150 name=name ng-model=skuMobileCtrl.sku.name ng-keyup=\"skuMobileCtrl.skuForm.name.$setValidity(\'unique\', true); skuMobileCtrl.uniqueCheck(skuMobileCtrl.sku.name, \'name\');\" id=name></textarea><label for=name class=form-control-label>Наименование</label></div><div class=form-control-error ng-if=\"skuMobileCtrl.skuForm.name.$dirty && skuMobileCtrl.skuForm.name.$error.required\">Поле обязательно для заполнения</div><div class=form-control-error ng-if=skuMobileCtrl.skuForm.name.$error.unique>Товар уже существует</div><mobile-select config=skuMobileCtrl.parentConfig ng-model=skuMobileCtrl.sku.category></mobile-select><div class=form-group><input empty-to-null required type=text class=form-control ng-model=skuMobileCtrl.sku.code maxlength=30 name=derivative_code_prefix ng-blur=\"skuMobileCtrl.uniqueCheck(skuMobileCtrl.sku.code, \'derivative_code_prefix\')\" ng-keyup=\"skuMobileCtrl.skuForm.derivative_code_prefix.$setValidity(\'unique\', true)\" id=code autocomplete=off><label for=code class=form-control-label>Код товара</label></div><div class=form-control-error ng-if=\"skuMobileCtrl.skuForm.derivative_code_prefix.$dirty && skuMobileCtrl.skuForm.derivative_code_prefix.$error.required\">Поле обязательно для заполнения</div><div class=form-control-error ng-if=skuMobileCtrl.skuForm.derivative_code_prefix.$error.unique>Код товара уже существует</div><div id=vendor_codeAnchor class=form-group><input empty-to-null type=text class=form-control id=vendorCode maxlength=30 ng-model=skuMobileCtrl.sku.vendor_code name=vendor_code ng-keyup=\"skuMobileCtrl.skuForm.vendor_code.$setValidity(\'unique\', true);\" ng-blur=\"skuMobileCtrl.settings.unique_vendor_code && skuMobileCtrl.uniqueCheck(skuMobileCtrl.sku.vendor_code, \'vendor_code\')\" autocomplete=off><label for=vendorCode class=form-control-label>Артикул производителя</label></div><div class=form-control-error ng-if=\"skuMobileCtrl.skuForm.vendor_code.$dirty && skuMobileCtrl.skuForm.vendor_code.$error.unique\">Артикул производителя уже существует</div><mobile-select config=skuMobileCtrl.taxGroupConfig ng-model=skuMobileCtrl.sku.tax_group></mobile-select><mobile-select config=skuMobileCtrl.uomConfig ng-model=skuMobileCtrl.sku.sku_list[0].uom></mobile-select><div class=form-group><div class=checkbox-group><label class=checkbox-label>Товар весовой/мерный</label><div class=\"checkbox pull-right\"><label><input type=checkbox ng-model=skuMobileCtrl.sku.sku_list[0].packaged ng-change=skuMobileCtrl.changePackaged()> <span class=cr><i class=cr-icon></i></span></label></div></div></div><div class=text-danger ng-if=skuMobileCtrl.errorMessage ng-bind=skuMobileCtrl.errorMessage></div></form><div class=buttons-wrapper ng-init=skuMobileCtrl.calculNexStep();><a class=\"btn btn-primary\" ng-if=\"skuMobileCtrl.isAttr === true\" ui-sref=catalogMobile.msku.attr(skuMobileCtrl.params) ng-disabled=skuMobileCtrl.skuForm.$invalid ng-click=\"(skuMobileCtrl.skuForm.$invalid)? $event.preventDefault() : \'\'\">Далее</a> <a class=\"btn btn-primary\" ng-if=\"skuMobileCtrl.isAttr === false\" ui-sref=catalogMobile.msku.price(skuMobileCtrl.params) ng-disabled=skuMobileCtrl.skuForm.$invalid ng-click=\"(skuMobileCtrl.skuForm.$invalid)? $event.preventDefault() : \'\'\">Далее</a></div></div></div><div ng-if=\"skuMobileCtrl.state.current.name !== \'catalogMobile.msku\'\" ng-class=skuMobileCtrl.theme.toLowerCase()><div class=ui-view-wrapper><div ui-view></div></div></div>");
$templateCache.put("app/mobile/components/attr-element/attr-element-mobile.html","<div class=clearfix><div class=\"attr-value-wrapper clearfix\" ng-repeat=\"value in data.values track by $index\"><div ng-switch=attribute.data_type ng-class=\"{\'has-error-unique\': errorInd.length && errorInd.indexOf($index)+1}\"><div ng-switch-when=STRING class=\"input-wrapper-{{$index}} form-group\"><input maxlength=150 type=text title=\"{{data.values[$index]}}\" ng-model=data.values[$index] class=\"catalog-attribute-control attr-value form-control\" ng-blur=checkVal() ng-required=\"{{attribute.required}}\" name=\"attr{{attrIndex}}\"><label class=form-control-label>{{attribute.name}}</label><span class=\"valid-message isset-name\">Значение уже существует</span></div><div ng-switch-when=STRING class=\"form-control-error ng-scope\" ng-if=\"attribute.required && parentForm[\'attr\' + attrIndex].$touched && parentForm[\'attr\' + attrIndex].$error.required\">Поле обязательно для заполнения</div><div ng-switch-when=BOOLEAN><div ng-class=\"{\'has-error\': notFound}\"><mobile-select config=selectConfig ng-model=data.values[$index]></mobile-select></div></div><div ng-switch-when=INTEGER class=\"input-wrapper-{{$index}} form-group\"><input hard-pruning type=text data-check=([0-9])+ maxlength=17 title=\"{{data.values[$index]}}\" ng-model=data.values[$index] class=\"catalog-attribute-control attr-value form-control\" ng-blur=checkVal() ng-required=\"{{attribute.required}}\" name=\"attr{{attrIndex}}\"><label class=form-control-label>{{attribute.name}}</label><div class=\"valid-message wrong-simbol-mess\" style=\"left: 0;\">Некорректный символ</div><span class=\"valid-message isset-name\">Значение уже существует</span></div><div ng-switch-when=INTEGER class=\"form-control-error ng-scope\" ng-if=\"attribute.required && parentForm[\'attr\' + attrIndex].$touched && parentForm[\'attr\' + attrIndex].$error.required\">Поле обязательно для заполнения</div><div ng-switch-when=FLOAT class=\"input-wrapper-{{$index}} form-group\"><input type=text float-input float-step=0.01 title=\"{{data.values[$index]}}\" ng-model=data.values[$index] class=\"catalog-attribute-control attr-value form-control text-align-left\" ng-blur=checkVal() ng-required=\"{{attribute.required}}\" name=\"attr{{attrIndex}}\" autocomplete=off hard-pruning data-check=([0-9.,])+><label class=form-control-label>{{attribute.name}}</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message isset-name\">Значение уже существует</span></div><div ng-switch-when=FLOAT class=\"form-control-error ng-scope\" ng-if=\"attribute.required && parentForm[\'attr\' + attrIndex].$touched && parentForm[\'attr\' + attrIndex].$error.required\">Поле обязательно для заполнения</div><div ng-switch-when=DICTIONARY class=\"input-wrapper-{{$index}}\"><div ng-class=\"{\'has-error\': notFound}\"><mobile-select config=selectConfig ng-model=data.values[$index]></mobile-select></div></div><div ng-switch-when=DATE class=form-group><input type=text ng-model=\"dateData[\'date\' + attrIndex]\" class=\"catalog-attribute-control attr-value form-control\" ng-required=\"{{attribute.required}}\" ui-mask=99.99.9999 ng-keyup=\"checkDate(dateData[\'date\' + attrIndex], \'date\' + attrIndex, $index);\" name=\"date{{attrIndex}}\"><label class=\"form-control-label always-top\">{{attribute.name}}</label><span class=\"valid-message wrong-date\">Некорректное значение</span><div class=\"form-control-error ng-scope\" ng-if=\"attribute.required && parentForm[\'date\' + attrIndex].$touched && parentForm[\'date\' + attrIndex].$error.required\" style=\"margin-top: 0;\">Поле обязательно для заполнения</div></div><div ng-switch-when=DATE_TIME class=form-group><input type=text ng-model=\"dateData[\'date_time\' + attrIndex]\" class=\"catalog-attribute-control attr-value form-control\" ng-required=\"{{attribute.required}}\" ui-mask=\"99.99.9999 99:99\" ng-keyup=\"checkDate(dateData[\'date_time\' + attrIndex], \'date_time\' + attrIndex, $index);\" name=\"date_time{{attrIndex}}\"><label class=\"form-control-label always-top\">{{attribute.name}}</label><span class=\"valid-message wrong-date\">Некорректное значение</span><div class=\"form-control-error ng-scope\" ng-if=\"attribute.required && parentForm[\'date_time\' + attrIndex].$touched && parentForm[\'date_time\' + attrIndex].$error.required\" style=\"margin-top: 0;\">Поле обязательно для заполнения</div></div></div></div></div>");
$templateCache.put("app/mobile/components/mobile-select/mobile-select.html","<div class=\"form-group multi-line-wrapper\" ng-mousedown=mobileSelectCtrl.getData($event); ng-class=\"{\'mobile-disabled-wrapper\': mobileSelectCtrl.config.disabled}\"><input ng-model=mobileSelectCtrl.model name=\"{{mobileSelectCtrl.config.name}}\" ng-disabled=mobileSelectCtrl.config.disabled class=form-control ng-class=\"mobileSelectCtrl.isTouched? \'touched\' : \'\'\" ng-required=mobileSelectCtrl.config.required type=hidden><ul class=\"form-control multi-line\"><li class=ellipsis ng-repeat=\"item in mobileSelectCtrl.chosenData\" ng-bind=\"item.name || item.label || item.value || mobileSelectCtrl.findData(item).name\"></li></ul><label for=\"{{mobileSelectCtrl.config.name}}\" class=\"form-control-label small-offset\" ng-bind=mobileSelectCtrl.config.label ng-class=\"{\'always-top\': mobileSelectCtrl.chosenData.length || mobileSelectCtrl.model}\"></label><div class=\"valid-message required-mess\">Поле обязательно для заполнения</div></div><div class=mobile-select-choises ng-if=mobileSelectCtrl.showData ng-init=\"mobileSelectCtrl.isTouched = true\"><header class=header><div class=container><div class=arrow ng-click=mobileSelectCtrl.closeSelect();></div><div class=title ng-bind=mobileSelectCtrl.title></div></div></header><div class=container-wrapper><ul class=mobile-select><li ng-repeat=\"item in mobileSelectCtrl.tempData\"><div class=list-item ng-class=\"{\'has-active-childs\': item.$$hasActiveChilds, \'active\': item.$$active}\"><span ng-bind=\"item.name || item.label || item.value\" ng-click=mobileSelectCtrl.choose($index);></span> <span class=select-arrow ng-if=\"mobileSelectCtrl.config.treeView && mobileSelectCtrl.config.hasChildren(item)\" ng-click=\"mobileSelectCtrl.getData($event, $index);\"></span></div></li></ul><div class=buttons-wrapper style=\"z-index: 1;\"><button class=\"btn btn-primary\" ng-click=mobileSelectCtrl.save(); ng-disabled=mobileSelectCtrl.noData>Выбрать</button></div></div></div>");
$templateCache.put("app/mobile/components/search-header/search-header.html","<header class=header><div class=container><div class=search-header><button class=\"back old-school\" ng-click=searchHeaderCtrl.goBack(); ng-if=\"!searchHeaderCtrl.searchHeaderActive && searchHeaderCtrl.params.parent\"></button><div style=\"display: flex; width: 100%;\"><div class=searh-wrapper><input type=text id=msearch ng-model=searchHeaderCtrl.searchStr ng-keyup=searchHeaderCtrl.keyUp() ng-focus=\"searchHeaderCtrl.searchHeaderActive = true;\"><label for=msearch class=\"search-label ellipsis\" ng-if=!searchHeaderCtrl.searchStr>Поиск</label><span class=search-icon></span><div class=clear ng-click=searchHeaderCtrl.clear(); ng-if=searchHeaderCtrl.searchHeaderActive></div></div><a ui-sref=\"catalogMobile.category({id: searchHeaderCtrl.params.parent, theme: searchHeaderCtrl.params.theme})\" class=\"btn-ico pencil\" ng-if=\"!searchHeaderCtrl.searchHeaderActive && searchHeaderCtrl.params.parent && !searchHeaderCtrl.choosenItem\" ng-click=\"searchHeaderCtrl.searchLoading = true;\"></a> <a ui-sref=\"catalogMobile.msku({id: searchHeaderCtrl.choosenItem.id})\" class=\"btn-ico pencil\" ng-if=\"!searchHeaderCtrl.searchHeaderActive && searchHeaderCtrl.choosenItem && searchHeaderCtrl.choosenItem.status !== \'ARCHIVED\' && searchHeaderCtrl.choosenItem.type == \'SKU\'\" ng-click=\"searchHeaderCtrl.checkRedact($event); searchHeaderCtrl.searchLoading = true;\"></a> <a ui-sref=\"catalogMobile.mservice({id: searchHeaderCtrl.choosenItem.id, parent: searchHeaderCtrl.params.parent, parentname: searchHeaderCtrl.params.parentname, theme: searchHeaderCtrl.params.theme})\" class=\"btn-ico pencil\" ng-if=\"!searchHeaderCtrl.searchHeaderActive && searchHeaderCtrl.choosenItem && searchHeaderCtrl.choosenItem.status !== \'ARCHIVED\' && searchHeaderCtrl.choosenItem.type == \'SERVICE\'\" ng-click=\"searchHeaderCtrl.checkRedact($event); searchHeaderCtrl.searchLoading = true;\"></a> <a ui-sref=\"catalogMobile.deleteCatalogItem({type: searchHeaderCtrl.type, parent: searchHeaderCtrl.params.parent, parentname: searchHeaderCtrl.params.parentname, theme: searchHeaderCtrl.params.theme })\" class=\"btn-ico trash\" ng-if=\"!searchHeaderCtrl.searchHeaderActive && searchHeaderCtrl.params.parent && !searchHeaderCtrl.catalogItemsLength\" ng-click=\"searchHeaderCtrl.searchLoading = true;\"></a> <a ng-click=\"searchHeaderCtrl.goMrecover(); searchHeaderCtrl.searchLoading = true;\" class=\"btn-ico trash\" ng-if=\"!searchHeaderCtrl.searchHeaderActive && searchHeaderCtrl.choosenItem && searchHeaderCtrl.choosenItem.status !== \'ARCHIVED\'\"></a> <a ng-if=\"!searchHeaderCtrl.searchHeaderActive && searchHeaderCtrl.params.parent && !searchHeaderCtrl.choosenItem\" ui-sref=catalogMobile.createCatalogRoute class=\"btn-ico add\" ng-click=\"searchHeaderCtrl.searchLoading = true;\"></a> <a ng-if=\"!searchHeaderCtrl.searchHeaderActive && !searchHeaderCtrl.params.parent && !searchHeaderCtrl.choosenItem\" ui-sref=\"catalogMobile.category({theme: searchHeaderCtrl.params.theme})\" class=\"btn-ico add\" ng-click=\"searchHeaderCtrl.searchLoading = true;\"></a></div></div></div></header>");
$templateCache.put("app/mobile/register/includes/0-step.html","<div class=container-wrapper><div class=\"container steps\">Перед активацией кассы необходимо зарегистрироваться</div><div class=buttons-wrapper><button class=btn ng-click=$ctrl.next();>Зарегистрироваться</button> <button class=\"btn btn-primary\" ng-click=\"\">Я уже зарегистрирован</button></div></div>");
$templateCache.put("app/mobile/register/includes/1-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.cancelRegister(); ng-if=!$ctrl.activeSelect></div><div class=arrow ng-click=$ctrl.prev(); ng-if=$ctrl.activeSelect></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber)? \'\' : {\'padding-left\': \'4%\'}\"></div></div></header><div class=container-wrapper ng-if=\"!$ctrl.showActivityAreas && !$ctrl.showChildAreas\"><form name=step1 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input inn-check ng-model=$ctrl.regData.company.inn hard-pruning data-check=([0-9_]) pattern=^(\\d{10}|\\d{12})$ name=inn type=tel id=focusInput inn-type=fiz maxlength=12 class=form-control ng-change=$ctrl.updateInn($ctrl.regData.company.inn); ui-options=\"{ clearOnBlur: false, addDefaultPlaceholder: false }\" required form-name=step1><label for=inn class=\"form-control-label small-offset\">ИНН</label></div><div class=form-control-error ng-if=\"step1.inn.$dirty && step1.inn.$error.validInn\">Такой номер не существует</div><div class=form-control-error ng-if=\"step1.inn.$dirty && step1.inn.$error.pattern\">ИНН должен содержать 10 или 12 цифр</div><div class=form-control-error ng-if=\"step1.inn.$dirty && step1.inn.$error.required\">Поле обязательно для заполнения</div><div class=form-group><input ng-model=$ctrl.regData.company.short_name name=company class=form-control maxlength=100 required><label for=company class=\"form-control-label small-offset\">Компания</label><div class=\"valid-message required-mess\">Поле обязательно для заполнения</div></div><div class=form-control-error ng-if=\"step1.company.$dirty && step1.company.$error.required\">Поле обязательно для заполнения</div><div class=form-group ng-mousedown=$ctrl.getActivityAreas($event);><ul class=\"form-control multi-line\" ng-class=\"{\'ng-invalid-required\': step1.activity_areas.$error.required}\"><li class=ellipsis ng-repeat=\"area in $ctrl.regData.company.activity_areas\" ng-bind=area.name></li></ul><input ng-model=$ctrl.ocupacion name=activity_areas id=activity_areas class=form-control required type=hidden><label for=activity_areas class=\"form-control-label small-offset\">Сфера деятельности</label><div class=\"valid-message required-mess\">Поле обязательно для заполнения</div></div><div class=form-control-error ng-if=\"step1.activity_areas.$dirty && step1.activity_areas.$error.required\">Поле обязательно для заполнения</div></form><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-disabled=\"step1.$invalid && step1.$dirty\" ng-click=$ctrl.checkForm(step1);>Далее</button></div></div><div class=container-wrapper ng-if=$ctrl.showActivityAreas><ul class=mobile-select><li ng-repeat=\"area in $ctrl.allActivityAreas\"><div class=list-item ng-if=!$ctrl.showChildAreas ng-click=$ctrl.getOcupacion($index); ng-class=\"{\'has-active-childs\': area.$$active}\"><span ng-bind=area.name></span> <span class=select-arrow></span></div><div class=list-item ng-repeat=\"childArea in area.child_areas\" ng-if=\"$ctrl.showChildAreas && $parent.$index == $ctrl.activeParent\" ng-click=\"$ctrl.chooseActivityAreas($parent.$parent.$index, $index);\" ng-class=\"{\'active\': childArea.$$active}\"><span ng-bind=childArea.name></span></div></li></ul><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=$ctrl.saveActivityAreas(); ng-disabled=$ctrl.noActiveArea>Выбрать</button></div></div>");
$templateCache.put("app/mobile/register/includes/10-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step10 class=\"container steps\"><div class=form-group ng-if=$ctrl.addresses.length><ul class=mobile-select style=\"margin: -7% -4%;\"><li class=list-item ng-repeat=\"addr in $ctrl.addresses\" ng-bind=addr ng-click=\"$ctrl.activeAddrIndex = $index;\" ng-class=\"{\'active\': $ctrl.activeAddrIndex === $index}\"></li></ul></div><div class=form-group ng-if=!$ctrl.addresses.length><strong class=funny-text style=\"display: block; font-size: 60%; line-height: 1.3;\">{{$ctrl.gatherAddrStr}}</strong><div style=\"margin-top: 20px;margin-bottom: 0; font-size: 50%;\">Введенный текст не распознается системой как адрес. Вы подтверждаете корректность ввода адреса?</div></div></form><div class=buttons-wrapper ng-if=$ctrl.addresses.length><button class=btn ng-click=\"$ctrl.addresses = []\">Нет нужного</button> <button class=\"btn btn-primary\" ng-click=\"($ctrl.activeAddrIndex === undefined)? \'\' : $ctrl.saveAddr();\">Подтвердить</button></div><div class=buttons-wrapper ng-if=!$ctrl.addresses.length><button class=\"btn btn-primary\" ng-click=$ctrl.saveAddr();>Да</button></div></div>");
$templateCache.put("app/mobile/register/includes/11-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><p class=\"container steps\">Есть договор эквайринга?</p><div class=buttons-wrapper><button class=btn ng-click=$ctrl.checkForm();$ctrl.checkForm();>Нет</button> <button class=\"btn btn-primary\" ng-click=$ctrl.checkForm();>Да</button></div></div>");
$templateCache.put("app/mobile/register/includes/12-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step12 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input type=text class=form-control name=bank required id=focusInput ng-model=$ctrl.regData.acquiring_bank maxlength=50><label for=bank class=\"form-control-label small-offset\">Наименование банка-эквайера</label></div><div class=form-control-error ng-if=\"step12.bank.$dirty && step12.bank.$error.required\">Поле обязательно для заполнения</div></form><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=\"btn btn-primary\" ng-disabled=\"step12.$invalid && step12.$dirty\" ng-click=$ctrl.checkForm(step12);>Далее</button></div></div>");
$templateCache.put("app/mobile/register/includes/13-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step13 class=\"container steps\"><label for=accept2 class=checkbox-label style=\"font-size: 60%;\">Принимаю условия <a target=_blank href=http://файлы.торговля.онлайн/offer.pdf>договора-оферты</a>, <a target=_blank href=http://файлы.торговля.онлайн/license-agreement.pdf>лицензионного соглашения</a> и даю <a target=_blank href=http://файлы.торговля.онлайн/pd_consent.pdf>согласие</a> на обработку персональных данных (<a target=_blank href=http://файлы.торговля.онлайн/pd_policy.pdf>политика</a>)</label></form><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=$ctrl.checkForm();>Подтвердить</button></div></div>");
$templateCache.put("app/mobile/register/includes/14-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16 &&  !$ctrl.saveStarted\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div ng-if=$ctrl.loading ng-include=\"\'app/mobile/loader.html\'\"></div><div class=container-wrapper ng-if=!$ctrl.saveStarted><form name=step14 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input type=text class=form-control name=promo_code id=promo_code ng-model=$ctrl.regData.promo_code maxlength=50 ng-keyup=\"$ctrl.checkCode(true, step14)\"><label for=promo_code class=\"form-control-label small-offset\">Промо-код</label><div class=\"valid-message no-found-mess\">Неизвестный код</div></div><div class=form-group><input type=text class=form-control name=partner_code id=partner_code ng-model=$ctrl.regData.partner_code maxlength=50 ng-keyup=\"$ctrl.checkCode(false, step14)\"><label for=partner_code class=\"form-control-label small-offset\">Код партнера</label><div class=\"valid-message no-found-mess\">Неизвестный код</div></div></form><div class=buttons-wrapper><button class=\"btn btn-primary\" ng-click=$ctrl.save(); ng-bind=\"\'Далее\'\"></button></div></div><div style=\"height: 100vh;\" ng-if=$ctrl.saveStarted><div class=\"loader-wrappper text-center\"><span class=mobile-loader></span> <span style=\"font-size: 70%;\">Ожидайте</span></div></div>");
$templateCache.put("app/mobile/register/includes/15-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form class=\"container steps\"><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><div ng-if=\"$ctrl.userMailPhoneFlags.isPhone && !$ctrl.errorMessage\">Поздравляем! Регистрация прошла успешно.</div><div ng-if=\"$ctrl.userMailPhoneFlags.isEmail && !$ctrl.errorMessage\"><div class=message-ico></div><div class=\"mail-info text-center\" style=\"font-size: 60%;\">Для завершения регистрации в системе перейдите по ссылке из письма, отправленного вам на адрес:</div><div class=text-center ng-bind=$ctrl.regData.owner.login></div></div></form><div class=buttons-wrapper ng-if=!$ctrl.errorMessage><button class=\"btn btn-primary\" ng-disabled=\"step13.$invalid && step13.$dirty\" ng-click=\"$ctrl.checkCodeForUser(); $ctrl.checkForm();\">Далее</button></div></div>");
$templateCache.put("app/mobile/register/includes/16-step.html","<div class=\"container-wrapper final-register-step\"><form name=step3 class=\"container steps\"><div class=logo></div><h2>Поздравляем</h2><div class=final-message>Регистрация в системе прошла успешно</div></form></div>");
$templateCache.put("app/mobile/register/includes/2-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.backStep(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step2 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input hard-pruning name=domain ng-model=$ctrl.regData.domain required type=text class=form-control data-check=[a-zA-Z0-9-]* maxlength=30 ng-blur=$ctrl.checkDomain(step2) ng-keyup=\"$ctrl.checkDomain(step2); $ctrl.errorMessage = \'\';\" ng-paste=$ctrl.checkDomain(step2) id=focusInput form-name=step2><label class=\"form-control-label small-offset\">Группа</label><div class=\"form-control-error wrong-simbol-mess custom-error\">Только латинские буквы, цифры и дефис</div></div><div class=form-control-error ng-if=\"step2.domain.$dirty && step2.domain.$error.required\">Поле обязательно для заполнения</div><div class=\"status text-danger\" ng-if=$ctrl.domainTip ng-class=$ctrl.domainStatus title=\"{{$ctrl.domainTip}}\" ng-bind=$ctrl.domainTip></div><p class=clearfix><strong class=text-danger>Внимание!</strong><br>Название группы должно быть понятно и известно всем вашим пользователям, они будут указывать его при входе в систему.<br><br>В качестве имени группы можно указать название вашей компании или группы компаний, название вашей сети магазинов, торговую марку, домен вашего сайта и т.п.</p></form><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=\"btn btn-primary\" ng-disabled=\"step2.$invalid && step2.$dirty\" ng-click=$ctrl.checkForm(step2);>Далее</button></div></div>");
$templateCache.put("app/mobile/register/includes/3-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.backStep(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step3 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><input name=login type=text class=login-hack><!-- Для того чтобы не заполнялись поля autofill --> <input name=pass type=password class=login-hack><!-- Для того чтобы не заполнялись поля autofill --><div class=\"form-group phone-input-wrapper\"><input ng-class=\"{\n            \'phone-input\': $ctrl.userMailPhoneFlags.isPhone,\n            \'email-input\': $ctrl.userMailPhoneFlags.isEmail\n            }\" hard-pruning data-check=[a-zA-Z0-9._@\\-+\\(\\)\\s]* class=form-control maxlength=50 name=ownerLogin id=focusInput required universal-login-input is-phone=$ctrl.userMailPhoneFlags.isPhone is-email=$ctrl.userMailPhoneFlags.isEmail only-phone-email=true ng-keypress=\"$event.key === \'Enter\' && onEnter($event)\" ng-keyup=\"$ctrl.errorMessage = \'\'; $ctrl.validateLoginDomain(step3);\" ng-model=$ctrl.regData.owner.login ng-blur=\"$ctrl.validateLoginDomain(step3); (!$ctrl.regData.owner.login)? $ctrl.userMailPhoneFlags = {} : \'\'\" form-name=step3><label class=\"form-control-label small-offset\">Телефон или E-mail</label><div class=input-flag ng-if=\"$ctrl.userMailPhoneFlags.isPhone && $ctrl.regData.owner.login\"><div class=flag-ru></div><div class=phone-code><span class=phone-code-text>+7</span></div></div></div><div class=form-control-error ng-if=\"step3.ownerLogin.$dirty && step3.ownerLogin.$error.required\">Поле обязательно для заполнения</div><div class=form-control-error ng-if=step3.ownerLogin.$error.forbiddenEmailDomain>Регистрация с почтовых ящиков данного домена запрещена</div><div class=\"form-group hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=50 name=password ng-show=showpassword required type=text ng-model=$ctrl.regData.owner.password class=form-control> <input maxlength=50 name=password ng-hide=showpassword required type=password ng-model=$ctrl.regData.owner.password class=form-control><label class=\"form-control-label small-offset\">Пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(showpassword)? \'open\' : \'\'\" ng-click=\"showpassword = !showpassword;\"></label></div></div><div class=form-control-error ng-if=\"step3.password.$dirty && step3.password.$error.required\">Поле обязательно для заполнения</div></form><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=\"btn btn-primary\" ng-disabled=\"step3.$invalid && step3.$dirty\" ng-click=\"$ctrl.resetUniversalLogin(); $ctrl.checkForm(step3);\">Далее</button></div></div>");
$templateCache.put("app/mobile/register/includes/4-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.backStep(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step4 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input class=form-control type=tel id=focusInput required name=confirmCode maxlength=4 hard-pruning data-check=([0-9]) ng-model=$ctrl.regData.owner.$$confirmCode ng-keypress=\"$event.keyCode == 13 && $ctrl.checkPhoneConfirmCode() && $event.stopPropagation()\" ng-keyup=\"step4.confirmCode.$setValidity(\'confirmError\', true); $ctrl.errorMessage = \'\';\"><label for=confirm class=form-control-label>Код из СМС</label></div><div class=form-control-error ng-if=\"step4.confirmCode.$dirty && step4.confirmCode.$error.required\">Поле обязательно для заполнения</div><p class=text-danger ng-if=\"$ctrl.phoneAttempts && $ctrl.phoneAttempts < 3\" style=\"min-width: 175px;\">Введен неверный код.<br>Осталось попыток: {{$ctrl.phoneAttempts}} </p><p class=text-danger ng-if=!$ctrl.phoneAttempts>Количество попыток ввода кода исчерпано. Необходимо отправить СМС повторно.</p><p ng-if=$ctrl.regData.owner.login>Код подтверждения отправлен на номер:<br> {{$ctrl.regData.owner.login | phoneFormat}}</p><br></form><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=btn ng-click=\"$ctrl.sendPhoneConfirmRequest(step4, false, true);\">Отправить повторно</button> <button class=\"btn btn-primary\" ng-disabled=\"(step4.$invalid && step4.$dirty) || !$ctrl.phoneAttempts\" ng-click=\"$ctrl.setDirty(step4); $ctrl.checkPhoneConfirmCode(step4);\">Подтвердить</button></div></div>");
$templateCache.put("app/mobile/register/includes/5-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step5 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input type=text class=form-control hard-pruning empty-or-null name=surname required id=focusInput maxlength=50 ng-model=$ctrl.regData.owner.surname data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-keyup=\"$ctrl.errorMessage = \'\';\" form-name=step5><label for=surname class=\"form-control-label small-offset\">Фамилия</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=form-control-error ng-if=\"step5.surname.$dirty && step5.surname.$error.required\">Поле обязательно для заполнения</div><div class=form-group><input type=text class=form-control name=firstName empty-or-null hard-pruning required id=first_name maxlength=50 ng-model=$ctrl.regData.owner.name data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-keyup=\"$ctrl.errorMessage = \'\';\" form-name=step5><label for=first_name class=\"form-control-label small-offset\">Имя</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=form-control-error ng-if=\"step5.firstName.$dirty && step5.firstName.$error.required\">Поле обязательно для заполнения</div><div class=form-group><input type=text hard-pruning empty-or-null class=form-control name=patronymic id=patronymic maxlength=50 ng-model=$ctrl.regData.owner.patronymic data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-keyup=\"$ctrl.errorMessage = \'\';\" form-name=step5><label for=patronymic class=\"form-control-label small-offset\">Отчество</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=form-group><input empty-to-null hard-pruning data-check=([0-9_]) pattern=^(\\d{12})$ inn-check type=tel maxlength=12 class=form-control inn-type=fiz name=ownerInn id=ownerInn ng-model=$ctrl.regData.owner.inn ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-keyup=\"$ctrl.errorMessage = \'\';\" form-name=step5><label for=ownerInn class=form-control-label>ИНН</label></div><div class=form-control-error ng-if=\"step5.ownerInn.$dirty && step5.ownerInn.$error.pattern\">ИНН должен содержать 12 цифр</div><div class=form-control-error ng-if=\"step5.ownerInn.$dirty && step5.ownerInn.$error.validInn\">Такой номер не существует</div><timezone-no-auth class=ng-hide timezone-data=$ctrl.regData.owner.time_zone field-label=\"\'Часовой пояс\'\"></timezone-no-auth><p class=clearfix>Укажите ИНН, если этот пользователь будет работать за кассой</p></form><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=\"btn btn-primary\" ng-disabled=\"step5.$invalid && step5.$dirty\" ng-click=$ctrl.checkForm(step5);>Далее</button></div></div>");
$templateCache.put("app/mobile/register/includes/6-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><p class=\"container steps\">Создать отдельную учетную запись для кассира?</p><div class=buttons-wrapper><button class=btn ng-click=\"$ctrl.needCashier = false;$ctrl.checkForm();\">Нет</button> <button class=\"btn btn-primary\" ng-click=\"$ctrl.needCashier = true; $ctrl.checkForm();\">Да</button></div></div>");
$templateCache.put("app/mobile/register/includes/7-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step7 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><input name=login type=text class=login-hack><!-- Для того чтобы не заполнялись поля autofill --> <input name=pass type=password class=login-hack><!-- Для того чтобы не заполнялись поля autofill --><div class=form-group><input type=text class=form-control hard-pruning empty-or-null name=cashierLastname required maxlength=50 id=focusInput ng-model=$ctrl.regData.cashier.surname data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-keyup=\"$ctrl.errorMessage = \'\';\n                       step7.cashierLastname.$setValidity(\'dataUnique\', true);\n                       step7.cashierName.$setValidity(\'dataUnique\', true);\n                       step7.cashierPatronymic.$setValidity(\'dataUnique\', true);\" ng-blur=$ctrl.checkNameUnique(step7); form-name=step7><label for=cashierLastname class=\"form-control-label small-offset\">Фамилия</label></div><div class=\"form-control-error text-danger\" ng-if=step7.cashierLastname.$error.dataUnique>ФИО администратора группы совпадает с ФИО кассира</div><div class=form-control-error ng-if=\"step7.cashierLastname.$dirty && step7.cashierLastname.$error.required\">Поле обязательно для заполнения</div><div class=form-group><input type=text class=form-control name=cashierName empty-or-null hard-pruning required maxlength=50 id=cashierName ng-model=$ctrl.regData.cashier.name data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-blur=$ctrl.checkNameUnique(step7); form-name=step7 ng-keyup=\"$ctrl.errorMessage = \'\';\n                       step7.cashierLastname.$setValidity(\'dataUnique\', true);\n                       step7.cashierName.$setValidity(\'dataUnique\', true);\n                       step7.cashierPatronymic.$setValidity(\'dataUnique\', true);\"><label for=cashierName class=\"form-control-label small-offset\">Имя</label></div><div class=\"form-control-error text-danger\" ng-if=step7.cashierName.$error.dataUnique>ФИО администратора группы совпадает с ФИО кассира</div><div class=form-control-error ng-if=\"step7.cashierName.$dirty && step7.cashierName.$error.required\">Поле обязательно для заполнения</div><div class=form-group><input type=text hard-pruning empty-or-null class=form-control name=cashierPatronymic id=cashierPatronymic maxlength=50 ng-model=$ctrl.regData.cashier.patronymic data-check=\"[A-Za-zА-Яа-яёЁ` -]{1,64}\" ng-blur=$ctrl.checkNameUnique(step7); form-name=step7 ng-keyup=\"$ctrl.errorMessage = \'\';\n                       step7.cashierLastname.$setValidity(\'dataUnique\', true);\n                       step7.cashierName.$setValidity(\'dataUnique\', true);\n                       step7.cashierPatronymic.$setValidity(\'dataUnique\', true);\"><label for=cashierPatronymic class=\"form-control-label small-offset\">Отчество</label></div><div class=\"form-control-error text-danger\" ng-if=step7.cashierPatronymic.$error.dataUnique>ФИО администратора группы совпадает с ФИО кассира</div><div class=form-control-error ng-if=\"step7.cashierPatronymic.$dirty && step7.cashierPatronymic.$error.required\">Поле обязательно для заполнения</div><div class=form-group><input inn-check type=tel ng-model=$ctrl.regData.cashier.inn hard-pruning data-check=([0-9_]) name=cashierInn id=cashierInn type=tel pattern=^(\\d{12})$ inn-type=fiz maxlength=12 class=form-control ng-keyup=\"$ctrl.errorMessage = \'\'; step7.cashierInn.$setValidity(\'dataUnique\', true);\" ng-blur=\"inn_blur = true; $ctrl.checkInnUnique(step7);\" ng-focus=\"inn_blur = false\" ui-options=\"{ clearOnBlur: false, addDefaultPlaceholder: false }\" required form-name=step7><label for=cashierInn class=\"form-control-label small-offset\">ИНН</label></div><div class=\"form-control-error text-danger\" ng-if=step7.cashierInn.$error.dataUnique>ИНН администратора группы совпадает с ИНН кассира</div><div class=form-control-error ng-if=\"step7.cashierInn.$dirty && step7.cashierInn.$error.validInn\">Такой номер не существует</div><div class=form-control-error ng-if=\"step7.cashierInn.$dirty && step7.cashierInn.$error.pattern\">ИНН должен содержать 12 цифр</div><div class=form-control-error ng-if=\"step7.cashierInn.$dirty && step7.cashierInn.$error.required\">Поле обязательно для заполнения</div><div class=form-group><input id=tel name=cashierLogin class=form-control maxlength=15 ng-pattern=\"/^\\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/\" phone-input required ng-keyup=\"$ctrl.errorMessage = \'\'; step7.cashierLogin.$setValidity(\'phoneUnique\', true); $ctrl.checkPhonesUnique(step7);\" ng-model=$ctrl.regData.cashier.phone ng-blur=$ctrl.checkPhonesUnique(step7);><label class=\"form-control-label always-top small-offset always-top\">Телефон</label></div><div class=\"form-control-error text-danger\" ng-if=\"step7.cashierLogin.$error && step7.cashierLogin.$error.phoneUnique\">Телефон администратора группы совпадает с телефоном кассира</div><div class=form-control-error ng-if=\"step7.cashierLogin.$dirty && step7.cashierLogin.$error.required\">Поле обязательно для заполнения</div><div class=\"form-group hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=50 name=password ng-show=showpassword required type=text ng-model=$ctrl.regData.cashier.password class=form-control> <input maxlength=50 name=password ng-hide=showpassword required type=password ng-model=$ctrl.regData.cashier.password class=form-control ng-keyup=\"$ctrl.errorMessage = \'\'; \"><label class=\"form-control-label small-offset\">Пароль</label><label class=\"showpassword tooltip-light\" ng-class=\"(showpassword)? \'open\' : \'\'\" ng-click=\"showpassword = !showpassword;\"></label></div></div><div class=form-control-error ng-if=\"step7.password.$dirty && step7.password.$error.required\">Поле обязательно для заполнения</div></form><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=\"btn btn-primary\" ng-disabled=\"step7.$invalid && step7.$dirty\" ng-click=\"$ctrl.resetUniversalLogin(step7, true); $ctrl.checkForm(step7);\">Подтвердить телефон</button></div></div>");
$templateCache.put("app/mobile/register/includes/8-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step8 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input class=form-control type=tel id=focusInput required maxlength=4 hard-pruning data-check=([0-9]) name=cashierConfirmCode ng-model=$ctrl.regData.cashier.$$confirmCode ng-keypress=\"$event.keyCode == 13 && $ctrl.checkPhoneConfirmCode(step8, true) && $event.stopPropagation()\" ng-keyup=\"step8.cashierConfirmCode.$setValidity(\'confirmError\', true); $ctrl.errorMessage = \'\';\"><label class=\"form-control-label always-top small-offset\">Код из CMC</label></div><div class=form-control-error ng-if=\"step8.cashierConfirmCode.$dirty && step8.cashierConfirmCode.$error.required\">Поле обязательно для заполнения</div><p class=text-danger ng-if=\"$ctrl.phoneAttemptsCashier && $ctrl.phoneAttemptsCashier < 3\" style=\"min-width: 175px;\">Введен неверный код.<br>Осталось попыток: {{$ctrl.phoneAttemptsCashier}} </p><p class=text-danger ng-if=!$ctrl.phoneAttemptsCashier>Количество попыток ввода кода исчерпано. Необходимо отправить СМС повторно.</p><p>Код подтверждения отправлен на номер:<br> {{$ctrl.regData.cashier.phone | phoneFormat}}</p><br><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p></form><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=btn ng-click=\"$ctrl.sendPhoneConfirmRequest(step8, true, true);\">Отправить повторно</button> <button class=\"btn btn-primary\" ng-disabled=\"(step8.$invalid && step8.$dirty) || !$ctrl.phoneAttemptsCashier\" ng-click=\"$ctrl.setDirty(step8); $ctrl.checkPhoneConfirmCode(step8, true)\">Подтвердить</button></div></div>");
$templateCache.put("app/mobile/register/includes/9-step.html","<header class=header ng-if=\"$ctrl.stepNumber < 16\"><div class=container ng-class=\"{\'active-select\': $ctrl.activeSelect}\"><div class=arrow ng-click=$ctrl.prev(); ng-show=\"$ctrl.activeSelect || $ctrl.stepNumber > 1\"></div><div class=title ng-bind=\"$ctrl.stepTitle || $ctrl.steps[$ctrl.stepNumber].title\" ng-style=\"($ctrl.activeSelect || $ctrl.stepNumber > 1)? \'\' : {\'padding-left\': \'4%\'}\"></div><div class=cross ng-if=$ctrl.activeSelect ng-click=$ctrl.closeSelect();></div></div></header><div class=container-wrapper><form name=step9 class=\"container steps\" ng-keydown=$ctrl.keypress($event)><div class=form-group><input name=region id=focusInput hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=$ctrl.address.region type=text class=\"form-control region\" maxlength=100 form-name=step9><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=region class=\"form-control-label small-offset\">Регион</label></div><div class=form-group><input name=area id=area ng-model=$ctrl.address.area type=text hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" class=\"form-control district\" maxlength=100 form-name=step9><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=area class=\"form-control-label small-offset\">Район</label></div><div class=form-group><input name=city id=city hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=$ctrl.address.city type=text class=\"form-control city\" maxlength=50 form-name=step9><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=city class=\"form-control-label small-offset\">Город или населенный пункт</label></div><div class=form-group><input name=street id=street ng-model=$ctrl.address.street type=text hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" class=\"form-control street\" maxlength=50 form-name=step9><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=street class=\"form-control-label small-offset\">Улица</label></div><div class=row><div class=\"form-group col-xs-6\"><input name=houseStr hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=$ctrl.address.house type=text class=\"form-control houseStr\" form-name=step9 style=\"padding-left: 9%; padding-top: 16%;\"><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div><label for=street class=form-control-label style=\"left: 15%\">Дом</label></div><div class=\"form-group col-xs-6\"><input name=case hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=$ctrl.address.housing type=text class=\"form-control case\" form-name=step9 style=\"padding-left: 9%; padding-top: 16%;\"><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div><label for=street class=form-control-label style=\"left: 15%\">Корпус</label></div></div><div class=row><div class=\"form-group col-xs-6\"><input name=constructionStr hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=$ctrl.address.building type=text class=\"form-control constructionStr\" form-name=step9 style=\"padding-left: 9%; padding-top: 16%;\"><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div><label for=street class=form-control-label style=\"left: 15%\">Строение</label></div><div class=\"form-group col-xs-6\"><input name=flat hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=$ctrl.address.flat type=text class=\"form-control flat\" form-name=step9 style=\"padding-left: 9%; padding-top: 16%;\"><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div><label for=street class=form-control-label style=\"left: 15%\">Офис</label></div></div></form></div><div class=buttons-wrapper><p class=text-danger ng-bind=$ctrl.errorMessage ng-if=$ctrl.errorMessage></p><button class=\"btn btn-primary\" ng-if=\"$ctrl.gatherAddrAsString() && !$ctrl.regData.company.shop_address\" ng-click=$ctrl.parseAddr(); style=\"position: absolute; bottom: 0;\">Подтвердить адрес</button> <button class=\"btn btn-primary\" ng-if=\"!$ctrl.gatherAddrAsString() || $ctrl.regData.company.shop_address\" ng-click=$ctrl.parseAddr(true);>Далее</button></div>");
$templateCache.put("app/partnership/partners/crud/partner.html","<div class=\"partner-wrapper crud-entity main-left-offset main-right-offset view-entity\"><ul class=breadcrumbs><li><a ui-sref=business>Структура бизнеса</a></li><li><a ui-sref=\"partners({parent: \'business\'})\">Привлеченные клиенты</a></li></ul><div class=\"col-xs-9 section\" style=\"padding: 0;\"><h1 class=\"main-title pull-left\" style=\"max-width: 65%\">Информация о клиенте {{partnerController.partner.name}}</h1><span class=pull-right style=\"margin-top: 13px;\" ng-if=partnerController.partner.last_document_date>Дата последней активности: {{partnerController.partner.last_document_date | date:\'dd.MM.yyyy\'}}</span></div><div class=\"col-xs-9 section top-buttons\"><form-buttons view-type=\"{isView: true}\" on-button=partnerController.crud(status)></form-buttons></div><div class=clear></div><div class=full-width><div ng-if=!partnerController.partner.companies.length>У клиента не настроена структура бизнеса</div><div class=\"crud-main-column col-xs-9\" ng-if=partnerController.partner.companies.length><section class=\"form-group full-width\" ng-repeat=\"company in partnerController.partner.companies\" ng-class=\"{\'slide-up\': partnerController[company.code]}\" ng-style=\"(partnerController.mode.isView)? {\'max-height\': \'305px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(partnerController[company.code])? \'Показать\' : \'Свернуть\'}}\" ng-click=\"partnerController[company.code] = !partnerController[company.code]\" ng-show=partnerController.mode.isView></span><h5 class=section-header ng-bind=company.name></h5><div class=\"header-wrapper clearfix body-flex\" class=row><div class=\"ellipsis header-cell\" uib-tooltip=\"Кассовый аппарат\">Кассовый аппарат</div><div class=\"ellipsis header-cell\" uib-tooltip=Адрес>Адрес</div><div class=\"ellipsis header-cell\" uib-tooltip=\"Дата активации\">Дата активации</div><div class=\"ellipsis header-cell\" uib-tooltip=\"Дата замены ФН\">Дата замены ФН</div><div class=\"ellipsis header-cell\" uib-tooltip=\"ПО на кассе\">Версия ПО на кассе</div><div class=\"ellipsis header-cell\" uib-tooltip=\"Последняя синхронизация\">Последняя синхронизация</div><div class=\"ellipsis header-cell\" uib-tooltip=Подписки>Подписки</div></div><div class=\"body-wrapper clearfix\" ng-repeat=\"division in company.divisions\"><div class=body-flex ng-repeat=\"cash_register in division.cash_registers\"><div class=\"ellipsis body-cell\" ng-bind=\"partnerController.cashRegisterStr(cash_register) || \'-\'\" uib-tooltip=\"{{partnerController.cashRegisterStr(cash_register)}}\" tooltip-placement=top-left></div><div class=\"col-xs-3 ellipsis body-cell\" ng-bind=\"division.address.address_as_string || \'-\'\" uib-tooltip=\"{{division.address.address_as_string}}\"></div><div class=\"ellipsis body-cell\" ng-bind=\"(cash_register.when_created  | date:\'dd.MM.yyyy\') || \'-\'\" uib-tooltip=\"{{cash_register.when_created  | date:\'dd.MM.yyyy\'}}\"></div><div class=\"ellipsis body-cell\" ng-bind=\"(cash_register.fd_expire_date | date:\'dd.MM.yyyy\') || \'-\'\" uib-tooltip=\"{{cash_register.fd_expire_date | date:\'dd.MM.yyyy\'}}\"></div><div class=\"col-xs-2 ellipsis body-cell\" ng-bind=\"partnerController.versionStr(cash_register) || \'-\'\" uib-tooltip=\"{{partnerController.versionStr(cash_register)}}\"></div><div class=\"ellipsis body-cell\" ng-bind=\"(cash_register.last_sync_date | date:\'dd.MM.yyyy\') || \'-\'\" uib-tooltip=\"{{cash_register.last_sync_date | date:\'dd.MM.yyyy\'}}\" tooltip-placement=top-right></div><div class=\"col-xs-2 body-cell\"><div class=subscriptions-indicator ng-class=partnerController.getSubscriptionsStatus(cash_register.subscriptions)><span ng-if=!cash_register.subscriptions.length>-</span></div><div class=\"subscriptions-wrap info-block-grid\" ng-if=cash_register.subscriptions.length><div class=\"subscription info-block-info\" ng-repeat=\"subscr in cash_register.subscriptions\"><span ng-bind=subscr.name></span><br><span ng-bind=\"(subscr.status == \'ACTIVE\'? \'Действует до \' : \'Истекла \') + (subscr.expire_date?(subscr.expire_date | date:\'dd.MM.yyyy\'): \'\')\"></span></div></div></div></div></div><div class=text-center ng-if=!company.cashRegisterlength style=\"margin-top: 15px;\">Кассы не зарегистрированы</div></section></div></div><div class=\"section bottom-buttons col-xs-9\" ng-if=\"partnerController.partner.companies.length > 1\"><form-buttons view-type=\"{isView: true}\" on-button=partnerController.crud(status)></form-buttons></div></div>");
$templateCache.put("app/partnership/partnership-settings/sections/address.html","<section class=\"col-xs-9 public-contact\"><h5 class=section-header>Регионы и адреса обслуживания</h5><div class=row><div class=\"form-group col-xs-12\" style=\"margin-bottom: 0px;\"><div ng-repeat=\"address in partnerSettingsCtrl.regions\" class=\"clearfix addresses-wrap row\" style=\"margin-bottom: 20px;\"><address address-data=address.address parent-form=partnerSettingsCtrl.settingsForm mode=\"\'input\'\" truncate=false postal-index=false ng-required=!$index class=col-xs-11 name=\"\'addr\' + $index\" field-label=\"\'Регион или адрес\'\" address-controls=address.addressOptions></address><span class=\"glyphicon glyphicon-trash\" ng-click=\"partnerSettingsCtrl.removeItemData(partnerSettingsCtrl.regions, $index);\" ng-if=\"partnerSettingsCtrl.regions.length > 1\"></span></div><div class=clear></div><div class=add-item-wrap ng-click=partnerSettingsCtrl.addAddressData(partnerSettingsCtrl.regions);><span class=add-item-icon></span> <span class=add-item-title>Поле</span></div></div></div></section>");
$templateCache.put("app/partnership/partnership-settings/sections/client-contacts.html","<section class=\"col-xs-9 public-contact\"><h5 class=section-header>Контактные данные для клиентов</h5><div class=row><div class=\"col-xs-6 row custom-dynamic-fields\"><div class=\"form-group dynamic-field col-xs-12 icon-form-group\" ng-repeat=\"contact in partnerSettingsCtrl.helper_public_contact\"><div ng-switch=contact.type><div ng-switch-when=PHONE><input hard-pruning empty-to-null ng-model=contact.value type=tel id=\"contactVal{{$index}}\" name=\"contactVal{{$index}}\" data-check=\"[0-9*+() -]\" class=form-control maxlength=20 ng-required=true><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><label for=\"contactVal{{$index}}\" class=form-control-label>{{contact.caption}}</label><span class=req></span></div><div ng-switch-when=EMAIL><email mail=contact.value mail-name=\"contactVal{{$index}}\" is-required=true></email><span class=req></span></div></div></div></div><div class=\"form-group col-xs-6 pull-right dropdown-multiline\"><ui-select ng-model=partnerSettingsCtrl.settings.actual_address name=actual_address search-enabled=false ng-disabled=\"!partnerSettingsCtrl.settings.bonus_recipient || !partnerSettingsCtrl.addreses.length\"><ui-select-match><span ng-bind=$select.selected.address_as_string></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"item in partnerSettingsCtrl.addreses track by $index\"><span ng-bind-html=item.address_as_string title=\"{{item.address_as_string}}\"></span></ui-select-choices></ui-select><label class=form-control-label>Фактический адрес</label></div><contact-info contact-info=partnerSettingsCtrl.settings.public_contact min-details-required=0 name-id=\"\'client\'\"></contact-info><br><div class=\"form-group col-xs-6\"><input maxlength=50 ng-model=partnerSettingsCtrl.settings.schedule type=text class=form-control><label class=form-control-label>График работы</label></div><div class=\"form-group col-xs-6 check-wrapper\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=partnerSettingsCtrl.settings.only_for_own_clients id=only_for_own_clients ng-change=\"\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=only_for_own_clients class=checkbox-label>Показывать контактную информацию только своим клиентам</label></div></div></section><div class=\"col-xs-3 section-helper\"><div style=\"font-weight: bold;\">ВНИМАНИЕ!</div>Информация в этом блоке будет публиковаться в свободном доступе для пользователей Торговля.Онлайн</div><div class=\"col-xs-3 section-helper\" style=\"margin-top: 220px;\">Контактная информация отобржается для всх пользователей Торговля.Онлайн, если настройка \"Показывать контактную информацию только своим клиентам\" отключена</div>");
$templateCache.put("app/partnership/partnership-settings/sections/edi-contacts.html","<section class=col-xs-9><h5 class=section-header>Контактное лицо по документообороту с Торговля.Онлайн</h5><div class=row><!-- <div class=\"form-group col-xs-6\" id=\"documentFlowPersonName\">\n	    <div id=\"employee-fio\" person-data-input fio=\"partnerSettingsCtrl.settings.document_flow_person_name\"\n	         form-model=\"partnerSettingsCtrl.settings.document_flow_person_name\" name-and-id=\"name\" is-required=\"false\" field-label=\"\'ФИО\'\"></div>\n	  </div> --><div class=\"form-group col-xs-6\"><input maxlength=50 ng-model=partnerSettingsCtrl.settings.document_flow_person_name type=text class=form-control><label class=form-control-label>ФИО</label></div><contact-info contact-info=partnerSettingsCtrl.settings.document_flow_contact min-details-required=0 name-id=\"\'edi\'\"></contact-info></div></section>");
$templateCache.put("app/partnership/partnership-settings/sections/edi.html","<section class=col-xs-9><h5 class=section-header>ЭДО</h5><div class=row><div class=\"form-group col-xs-6\"><input maxlength=50 ng-model=partnerSettingsCtrl.settings.edi_operator type=text class=form-control><label class=form-control-label>Оператор</label></div><div class=\"form-group col-xs-6\"><input maxlength=50 ng-model=partnerSettingsCtrl.settings.edi_id type=text class=form-control><label class=form-control-label>Идентификационный номер</label></div></div></section>");
$templateCache.put("app/partnership/partnership-settings/sections/main-info.html","<section class=col-xs-9><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group col-xs-6\"><ui-select ng-model=partnerSettingsCtrl.settings.bonus_recipient name=company ng-required=true on-select=partnerSettingsCtrl.loadDataByCompany()><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=partnerSettingsCtrl.refreshCompanies($select.search) repeat=\"item in partnerSettingsCtrl.companies track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div><label class=form-control-label>Компания</label><span class=req></span></div><div class=\"form-group col-xs-6\"><ui-select ng-model=partnerSettingsCtrl.settings.bonus_bank_account name=bank_account ng-required=true ng-disabled=\"!partnerSettingsCtrl.bankAccounts.length || !partnerSettingsCtrl.settings.bonus_recipient\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"item in partnerSettingsCtrl.bankAccounts track by $index\"><span ng-bind-html=item.name></span></ui-select-choices></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div><label class=form-control-label>Банковский счет для выплаты вознаграждений</label><span class=req></span></div></div></section>");
$templateCache.put("app/price-list/column/sections/main-info.html","<section class=col-xs-9><h5 class=section-header>Основная информация</h5><div class=row><div id=numberAnchor class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': priceColumnCrudCtrl.addPriceColumn.name.$invalid && !priceColumnCrudCtrl.addPriceColumn.name.$pristine}\"><input empty-to-null type=text name=name class=form-control id=price-column-name maxlength=50 ng-model=priceColumnCrudCtrl.priceColumn.name ng-required=true ng-keyup=\"priceColumnCrudCtrl.addPriceColumn.name.$setValidity(\'unique\', true)\" ng-blur=priceColumnCrudCtrl.uniqueCheck()><label for=price-column-name class=form-control-label>Название</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=priceColumnCrudCtrl.addPriceColumn.name.$error ng-if=!priceColumnCrudCtrl.mode.isView><div ng-message=unique class=\"valid-message isset-name\">Название колонки уже существует</div></div><span class=req></span></div><div class=\"form-group col-xs-6\"><ui-select ng-model=priceColumnCrudCtrl.priceColumn.currency search-enabled=\"priceColumnCrudCtrl.currencies > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-required=true><ui-select-match><span ng-bind=\"($select.selected.symbol || $select.selected.char_iso_code) + \' \' + $select.selected.name\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=priceColumnCrudCtrl.refreshCurrencies($select.search) repeat=\"currency in (priceColumnCrudCtrl.currencies) track by currency.id\"><span ng-bind=\"currency.symbol || currency.char_iso_code | highlight: $select.search\" class=currency-font></span> <span ng-bind=currency.name></span></ui-select-choices></ui-select><label class=form-control-label>Валюта</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div class=row><div class=\"col-xs-6 form-group\" style=\"margin-bottom: 0;\"><label style=\"margin-bottom: 15px\">Цена включает налоги</label><br><label style=\"margin-right: 10px\"><div class=\"radio pull-left\"><label><input type=radio name=taxes_included ng-model=priceColumnCrudCtrl.priceColumn.taxes_included ng-value=false id=no_taxes_included> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=no_taxes_included>Нет</label></label><label><div class=\"radio pull-left\"><label><input type=radio name=taxes_included ng-model=priceColumnCrudCtrl.priceColumn.taxes_included ng-value=true id=taxes_included> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=taxes_included>Да</label></label></div><div class=\"col-xs-6 form-group currency-summ\" style=\"margin-bottom: 0;\" ng-if=\"priceColumnCrudCtrl.type === \'WHOLE_SALE\'\"><input float-input float-fixed=2 maxlength=15 float-step=0.01 max-after-comma=2 currency-input=true currency-icon=\"{{priceColumnCrudCtrl.priceColumn.currency.symbol || priceColumnCrudCtrl.priceColumn.currency.char_iso_code}}\" type=text class=\"form-control currency-input\" maxlength=17 id=price-column-base ng-model=priceColumnCrudCtrl.priceColumn.effective_order_sum> <span class=currency-input-addon></span><label for=price-column-base class=form-control-label>Для суммы заказа больше</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div></div></section>");
$templateCache.put("app/price-list/column/sections/main-purchase-info.html","<section class=col-xs-9><h5 class=section-header>Основная информация</h5><div class=row><div id=numberAnchor class=\"form-group col-xs-6\" ng-class=\"{\'has-error\': priceColumnCrudCtrl.addPriceColumn.name.$invalid && !priceColumnCrudCtrl.addPriceColumn.name.$pristine}\"><input empty-to-null type=text name=name class=form-control id=price-column-name maxlength=50 ng-model=priceColumnCrudCtrl.priceColumn.name ng-required=true ng-keyup=\"priceColumnCrudCtrl.addPriceColumn.name.$setValidity(\'unique\', true)\" ng-blur=priceColumnCrudCtrl.uniqueCheck()><label for=price-column-name class=form-control-label>Название</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=priceColumnCrudCtrl.addPriceColumn.name.$error ng-if=!priceColumnCrudCtrl.mode.isView><div ng-message=unique class=\"valid-message isset-name\">Название колонки уже существует</div></div><span class=req></span></div><div class=\"form-group col-xs-6\"><ui-select ng-model=priceColumnCrudCtrl.priceColumn.supplier search-enabled=\"priceColumnCrudCtrl.counterpartiesTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH\" not-found><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=priceColumnCrudCtrl.refreshCounterparties($select.search) repeat=\"counterparty in (priceColumnCrudCtrl.counterparties.items) track by counterparty.id\"><span ng-bind-html=\"counterparty.name | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Поставщик</label></div></div><div class=row><div class=\"col-xs-6 form-group currency-summ\"><input float-input float-fixed=2 maxlength=15 float-step=0.01 max-after-comma=2 currency-input=true currency-icon=\"{{priceColumnCrudCtrl.priceColumn.currency.symbol || priceColumnCrudCtrl.priceColumn.currency.char_iso_code}}\" type=text class=\"form-control currency-input\" maxlength=17 id=price-column-base ng-model=priceColumnCrudCtrl.priceColumn.effective_order_sum> <span class=currency-input-addon></span><label for=price-column-base class=form-control-label>Для суммы заказа больше</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=\"form-group col-xs-6\" ng-if=\"priceColumnCrudCtrl.state.current.name != \'priceColumn.view\'\"><ui-select ng-model=priceColumnCrudCtrl.priceColumn.currency search-enabled=\"priceColumnCrudCtrl.currencies > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-disabled=\"priceColumnCrudCtrl.state.current.name == \'contract.view\'\" ng-required=true><ui-select-match><span ng-bind=\"($select.selected.symbol || $select.selected.char_iso_code) + \' \' + $select.selected.name\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=priceColumnCrudCtrl.refreshCurrencies($select.search) repeat=\"currency in (priceColumnCrudCtrl.currencies) track by currency.id\"><span ng-bind=\"currency.symbol || currency.char_iso_code | highlight: $select.search\" class=currency-font></span> <span ng-bind=currency.name></span></ui-select-choices></ui-select><label class=form-control-label>Валюта</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div class=row><div class=\"col-xs-6 form-group\" style=\"margin-bottom: 0;\"><label style=\"margin-bottom: 15px\">Цена включает налоги</label><br><label style=\"margin-right: 10px\"><div class=\"radio pull-left\"><label><input type=radio name=taxes_included ng-model=priceColumnCrudCtrl.priceColumn.taxes_included ng-value=false id=no_taxes_included> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=no_taxes_included>Нет</label></label><label><div class=\"radio pull-left\"><label><input type=radio name=taxes_included ng-model=priceColumnCrudCtrl.priceColumn.taxes_included ng-value=true id=taxes_included> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=taxes_included>Да</label></label></div><div class=\"form-group col-xs-6\"><ui-select ng-model=priceColumnCrudCtrl.priceColumn.supplier_tax_group search-enabled=false><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"tax in (priceColumnCrudCtrl.taxGroups) track by tax.id\"><span ng-bind-html=tax.name></span></ui-select-choices></ui-select><label class=form-control-label>Налог поставщика</label></div></div></section><div class=\"col-xs-3 section-helper\" style=\"margin-top: 200px;\">Данный налог будет указан в отгрузочных документах поставщика.</div>");
$templateCache.put("app/price-list/column/sections/price.html","<section class=col-xs-9><h5 class=section-header>Формирование цены</h5><div class=\"row form-group\"><label class=col-xs-4><div class=\"radio pull-left\"><label><input type=radio name=priceCreation ng-model=priceColumnCrudCtrl.priceCreation ng-change=\"priceColumnCrudCtrl.useRounding = false\" ng-value=false id=no_price_creation> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=no_price_creation>Вручную</label></label><label class=col-xs-8><div class=\"radio pull-left\"><label><input type=radio name=priceCreation ng-model=priceColumnCrudCtrl.priceCreation ng-value=true id=price_creation> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=price_creation><i>По формуле</i></label></label></div><div class=row ng-if=priceColumnCrudCtrl.priceCreation><div class=\"form-group col-xs-4\"><div class=multiplier-wrapper><div class=multiplier-symbol><ui-select ng-model=priceColumnCrudCtrl.priceColumn.$$operation required search-enabled=false class=slim-control><ui-select-match><span ng-bind-html=$select.selected></span></ui-select-match><ui-select-choices repeat=\"symbol in [\'-\', \'+\'] track by $index\"><span ng-bind=symbol></span></ui-select-choices></ui-select></div><div class=multiplier-percent><!-- <input class=\"form-control\" ng-model=\"priceColumnCrudCtrl.priceColumn.$$percent\"> --> <span><input float-input float-fixed=2 float-step=0.01 max-after-comma=2 required type=text class=\"form-control slim-control\" max-int-length=14 ng-model=priceColumnCrudCtrl.priceColumn.$$percent></span></div><div class=multiplier-descr><span>% от значений<br>колонки</span></div></div></div><div class=\"form-group col-xs-4\"><ui-select ng-model=priceColumnCrudCtrl.currentType name=currentType on-select=priceColumnCrudCtrl.onSelectType() class=slim-control><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"type.code as type in priceColumnCrudCtrl.priceListTypes\"><span ng-bind=type.name></span></ui-select-choices></ui-select></div><div class=\"form-group col-xs-4\" ng-if=\"priceColumnCrudCtrl.currentType && priceColumnCrudCtrl.currentType != \'PURCHASE\'\"><ui-select ng-model=priceColumnCrudCtrl.priceColumn.source_column name=sourceColumn on-select=\"priceColumnCrudCtrl.priceColumn.purchase_source_column = undefined;\" search-enabled=\"priceColumnCrudCtrl.columnsTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-required=true class=slim-control ng-class=\"{\'autocomplete-select\': priceColumnCrudCtrl.columnsTotalSearch > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=priceColumnCrudCtrl.refreshColumns($select.search) repeat=\"column in priceColumnCrudCtrl.columns\" group-by=priceColumnCrudCtrl.totalStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"column.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div><div class=\"form-group col-xs-4\" ng-if=\"priceColumnCrudCtrl.currentType == \'PURCHASE\'\"><ui-select ng-model=priceColumnCrudCtrl.priceColumn.purchase_source_column name=sourceColumn on-select=\"priceColumnCrudCtrl.priceColumn.source_column = undefined;\" search-enabled=\"priceColumnCrudCtrl.purchaseColumnsTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-required=true class=slim-control ng-class=\"{\'autocomplete-select\': priceColumnCrudCtrl.purchaseColumnsTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=priceColumnCrudCtrl.refreshPurchaseColumns($select.search) repeat=\"column in priceColumnCrudCtrl.purchaseColumns\" group-by=priceColumnCrudCtrl.totalPurchaseStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"column.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div class=\"row form-group col-xs-12\" ng-if=priceColumnCrudCtrl.priceCreation style=\"margin-bottom: 0;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=priceColumnCrudCtrl.useRounding id=useRounding> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=useRounding>Использовать округление</label></div></section>");
$templateCache.put("app/price-list/directives/price-cell-multiple/price-cell-multiple.html","<div class=price-cell-multiple ng-class=\"{\'selected\': priceCellMultipleCtrl.selected, \'reduced\': priceCellMultipleCtrl.column.column_type == \'PURCHASE\'}\"><div style=\"position: relative; outline: none; height: 100%;\"><price-cell currency=::priceCellMultipleCtrl.column.currency uom=::priceCellMultipleCtrl.uom column-type=::priceCellMultipleCtrl.column.column_type start-selected-callback=::priceCellMultipleCtrl.startSelectedCallback commit-value=::priceCellMultipleCtrl.commitValueMulti validate-price=::priceCellMultipleCtrl.validatePrice state=priceCellMultipleCtrl.selected selected cancel=::priceCellMultipleCtrl.cancelWithoutSave price=\"priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current || 0]\" add-new=::priceCellMultipleCtrl.addNewPrice></price-cell></div><div ng-if=\"!priceCellMultipleCtrl.selected && priceCellMultipleCtrl.prices.length > 1\"><div class=\"price-cell-controls cell-arrows ng-hide\"><span class=\"badge badge-arrow left tooltip-light\" tooltip-placement=top-right uib-tooltip=\"Предыдущая цена\" ng-click=\"priceCellMultipleCtrl.current = priceCellMultipleCtrl.current + (priceCellMultipleCtrl.current > 0 ? -1 : 0); $event.stopPropagation();\"></span> <span class=\"badge badge-arrow right tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Следующая цена\" ng-click=\"priceCellMultipleCtrl.current = priceCellMultipleCtrl.current + (priceCellMultipleCtrl.current < (priceCellMultipleCtrl.prices.length - 1) ? 1 : 0); $event.stopPropagation();\"></span></div></div><div class=\"cell-controlls selected\" ng-if=priceCellMultipleCtrl.selected><div class=close-button-container><button class=\"btn only-ico tooltip-light\" tooltip-placement=right uib-tooltip=Закрыть ng-click=::priceCellMultipleCtrl.cancelWithoutSave()><span class=\"btn-close btn-ico\"></span></button> <button class=\"btn only-ico tooltip-light\" tooltip-placement=left uib-tooltip=\"Показать все цены\" ng-click=::priceCellMultipleCtrl.openAllPrices()><span class=\"btn-maximizer btn-ico\"></span></button> <button class=\"btn cart-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Добавить в корзину\" ng-click=\"priceCellMultipleCtrl.addToCart(priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current || 0], priceCellMultipleCtrl.column);\"><span class=\"btn-cart btn-ico\"></span> В корзину</button></div><div class=\"price-cell-controls clearfix\"><button class=\"add-item-icon pull-right tooltip-light\" tooltip-placement=right uib-tooltip=\"Добавить цену\" ng-click=priceCellMultipleCtrl.addNewPrice($event)></button><br><br><button class=\"btn slim-button only-ico delete-badge pull-right\" ng-click=::priceCellMultipleCtrl.removePrice($event) ng-disabled=\"priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current || 0] && priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current || 0].price_for_one_uom == undefined && priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current || 0].calculated_automatically_price_for_one_uom !== undefined\"><span class=\"glyphicon glyphicon-trash btn-ico tooltip-light\" tooltip-placement=right uib-tooltip=\"Удалить цену\"></span></button><div ng-class=\"{\'show-badge-arrow\': priceCellMultipleCtrl.prices.length > 1 && !priceCellMultipleCtrl.selected}\"><div><span class=\"disabled-helper tooltip-light\" tooltip-placement=right uib-tooltip=\"{{(priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current || 0].price_for_one_uom == undefined && priceCellMultipleCtrl.prices[priceCellMultipleCtrl.current || 0].calculated_automatically_price_for_one_uom !== undefined)? \'Нельзя удалить цену\' : \'\'}}\"></span> <span class=\"badge badge-arrow left\" ng-hide=priceCellMultipleCtrl.selected ng-click=\"priceCellMultipleCtrl.current = priceCellMultipleCtrl.current + (priceCellMultipleCtrl.current > 0 ? -1 : 0); $event.stopPropagation();\"></span></div><div><span class=\"badge badge-arrow right\" ng-hide=priceCellMultipleCtrl.selected ng-click=\"priceCellMultipleCtrl.current = priceCellMultipleCtrl.current + (priceCellMultipleCtrl.current < (priceCellMultipleCtrl.prices.length - 1) ? 1 : 0); $event.stopPropagation();\"></span></div></div></div></div></div>");
$templateCache.put("app/price-list/directives/price-formula/formula.html","<section class=\"tab-form-group col-xs-9\"><span class=\"add-new-account tooltip-light\" ng-click=vm.addNewInterval() tooltip-placement=bottom-left uib-tooltip=\"Добавить интервал\"></span><scrollable-tabset api=vm.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset class=custom-tabs-inner active=vm.activeInterval><uib-tab ng-repeat=\"interval in column.rounding_details track by $index\" select=vm.selectTab($index)><uib-tab-heading class=tab-heading> {{interval.starting_price_for_rounding ? (interval.$$to > 0? \'от \' : \'свыше \') + (interval.starting_price_for_rounding / 100) : (!interval.$$to)? \'Все значения\' : \'\'}} <span class=currency-font ng-bind=\"column.currency.symbol || column.currency.char_iso_code\" ng-if=interval.starting_price_for_rounding></span> {{interval.$$to > 0 ? \'до \' + (interval.$$to / 100) : \'\'}} <span class=currency-font ng-bind=\"column.currency.symbol || column.currency.char_iso_code\" ng-if=\"interval.$$to > 0\"></span> <span class=\"close-tab danger-close tooltip-light\" tooltip-placement=right uib-tooltip=Удалить ng-click=\"interval.$$askRemove = true;\" ng-if=\"column.rounding_details.length > 1\"></span><div class=remove-tab ng-class=\"{\'ask-remove\': interval.$$askRemove}\"><span class=\"glyphicon glyphicon-trash\"></span><label class=tab-remove-label>Удалить?</label><span class=pull-right><span class=tab-remove-yes ng-click=\"vm.removeInterval($index, $event);\">Да</span>/ <span class=tab-remove-no ng-click=\"interval.$$askRemove = false;\">Нет</span></span></div></uib-tab-heading><div class=row><div class=\"form-group col-xs-5 currency-summ\" ng-class=\"{ \'has-error\': formCtrl.name.$invalid && !formCtrl.name.$pristine}\"><input input-price currency-input currency-icon=\"{{column.currency.symbol || column.currency.char_iso_code}}\" type=text class=\"form-control currency-input\" max-int-length=14 ng-model=interval.starting_price_for_rounding ng-blur=vm.changeTo();vm.updateRounding(); ng-class=\"{\'wrong-format\': interval.$$error}\" id=\"from{{$index}}\"><label for=\"from{{$index}}\" class=form-control-label>Интервал цен от</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-format\">Начало интервала меньше предыдущего</div><span class=req></span></div><div class=\"form-group col-xs-5\" ng-class=\"{ \'has-error\': formCtrl.name.$invalid && !contractCrudCtrl.addPriceColumn.name.$pristine}\" ng-if=interval.$$to><input input-price empty-values=true currency-input=true currency-icon=\"{{column.currency.symbol || column.currency.char_iso_code}}\" type=text class=\"form-control currency-input\" maxlength=17 ng-model=interval.$$to ng-disabled=true ng-class=\"{\'empty-placeholder\': interval.$$to == 0 || !interval.$$to}\" id=\"to{{$index}}\"><label for=\"to{{$index}}\" class=form-control-label>До</label></div></div><div class=\"row col-xs-9 rounding-factor-wrapper\"><label>округляем до:</label><ui-select ng-model=interval.rounding_factor search-enabled=false ng-required=true class=\"small-select exclude-items slim-control\" on-select=vm.resetPsychRounding(interval)><ui-select-match><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"factor.count as factor in vm.roundingFactors track by $index\"><span ng-bind=factor.name ng-if=\"!interval.$$to || interval.$$to == 0 || factor.count < interval.$$to * 100\"></span></ui-select-choices></ui-select></div><div class=\"row formula-wrapper\" ng-class=\"{\'psych-rounding\': interval.$$usePsychRounding}\"><div class=col-xs-12><div class=\"formula-container row col-xs-9\"><div class=devider ng-class=\"\'factor\' + interval.rounding_factor\"><span class=left ng-click=\"vm.changeFactor(\'left\', interval)\"></span> <span class=right ng-click=\"vm.changeFactor(\'right\', interval)\"></span></div><div class=formula-symbol ng-repeat=\"item in interval.$$factorsHelper\" ng-class=\"{\'symbol-disabled\': interval.rounding_factor > item.position+1 && item.last_digit != \',\', \'empty-symbol\' : interval.$$to > 0 && interval.$$to < item.position/100}\"><strong class=symbol ng-bind=\"(interval.rounding_factor > item.position+1 && item.last_digit != \',\')? \'0\' : item.last_digit\"></strong> <strong class=psych-symbol ng-bind=item.psych_digit></strong><ul class=change-digit-wrap ng-if=\"interval.rounding_factor > item.position+1 && item.last_digit != \',\'\"><li ng-click=\"vm.changeLastDigit(9, $index, interval)\" ng-class=\"{active: item.psych_digit == 9}\">9</li><li ng-click=\"vm.changeLastDigit(7, $index, interval)\" ng-class=\"{active: item.psych_digit == 7}\">7</li><li ng-click=\"vm.changeLastDigit(5, $index, interval)\" ng-class=\"{active: item.psych_digit == 5}\">5</li><li ng-click=\"vm.changeLastDigit(3, $index, interval)\" ng-class=\"{active: item.psych_digit == 3}\">3</li><li ng-click=\"vm.changeLastDigit(0, $index, interval)\" ng-class=\"{active: item.psych_digit == 0}\">0</li></ul></div></div><span class=arrow><span class=up ng-if=\"interval.rounding_method != \'DOWN\'\"></span> <span class=down ng-if=\"interval.rounding_method != \'UP\'\"></span></span><div class=\"row col-xs-4 rounding-type\"><div><div class=\"radio pull-left\"><label><input type=radio name=\"rounding_type{{$index}}\" ng-model=interval.rounding_method value=UP id=roundingUp ng-change=vm.updateRounding();> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=roundingUp>Вверх</label></div><div><div class=\"radio pull-left\"><label><input type=radio name=\"rounding_type{{$index}}\" ng-model=interval.rounding_method value=ARITHMETIC id=rounding ng-change=vm.updateRounding();> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=rounding>Арифметически</label></div><div><div class=\"radio pull-left\"><label><input type=radio name=\"rounding_type{{$index}}\" ng-model=interval.rounding_method value=DOWN id=roundingDown ng-change=vm.updateRounding();> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=roundingDown>Вниз</label></div></div></div></div><div class=\"row col-xs-9\" style=\"padding: 25px 14px 0;float: none;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=interval.$$usePsychRounding id=usePsychRounding ng-change=vm.turnPsychRounding(interval) ng-disabled=\"interval.rounding_factor == 1\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=usePsychRounding>Использовать <span ng-class=\"{\'green\': interval.$$usePsychRounding}\">психологическое</span> округление</label></div></uib-tab></uib-tabset></scrollable-tabset><div class=\"for-small-width rounding-example\"><div ng-include=\"\'app/price-list/directives/price-formula/price-example.html\'\"></div></div></section><div class=\"col-xs-3 rounding-example section-helper\"><div ng-include=\"\'app/price-list/directives/price-formula/price-example.html\'\"></div></div>");
$templateCache.put("app/price-list/directives/price-formula/price-example.html","<label>Пример для отображения правил обработки цен</label><div class=random-digit><button class=update-rounding ng-click=vm.updateRounding()></button> <span class=currency-font ng-bind=\"column.currency.symbol || column.currency.char_iso_code\"></span> <span ng-bind=vm.example></span></div><label class=text-right ng-if=vm.exampleRes>После округления:</label><div class=\"res text-right\" ng-if=vm.exampleRes>= <span ng-bind=vm.exampleRes></span><span class=currency-font ng-bind=\"column.currency.symbol || column.currency.char_iso_code\"></span></div><label class=text-right ng-if=vm.examplePsychRes>После психологического округления:</label><div class=\"res text-right\" ng-if=vm.examplePsychRes>= <span ng-bind=vm.examplePsychRes></span><span class=currency-font ng-bind=\"column.currency.symbol || column.currency.char_iso_code\"></span></div>");
$templateCache.put("app/price-list/directives/print-price-list/print-price-list-popup.html","<form name=$ctrl.printPriceList><div class=print-price-list-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>&times;</button><h3 class=modal-title>Печать {{!$ctrl.retailMode ? \'оптового\' : \'розничного\'}} прайс-листа</h3></div><div ng-show=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.finish\"><div class=\"container clearfix crud-entity\" ng-if=!$ctrl.showColumns style=\"margin-top: 9px;padding-right: 0;\"><div class=\"col-xs-6 row\" style=\"height: 115px;\"><label class=\"col-xs-12 row bottom-space\">Формат файла</label><div class=\"col-xs-6 row\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.format id=pdfFormat name=format value=PDF> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=pdfFormat><span class=pdf-ico></span>PDF</label></div><div class=col-xs-6><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.format id=xlsFormat name=format value=XLS> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=xlsFormat><span class=xls-ico></span>XLS</label></div></div><div class=\"form-group col-xs-6 row\" style=\"height: 115px\"><label class=\"col-xs-12 bottom-space\">Ориентация страницы</label><div class=\"form-group col-xs-7\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.page_orientation id=landscape_orientation name=page_orientation value=LANDSCAPE> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=landscape_orientation><span class=landscape-ico></span>альбомная</label></div><div class=\"form-group col-xs-5 row\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.page_orientation id=book_orientation name=page_orientation value=PORTRAIT> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=book_orientation><span class=book-ico></span>книжная</label></div></div><div class=\"form-group col-xs-12 row\"><ui-select ng-model=$ctrl.printData.division search-enabled=false on-select=$ctrl.divisionSelected($select.selected) ng-required=true ng-disabled=!$ctrl.divisions.length><ui-select-match><span ng-bind=\"$select.selected.name + \' - \' + $select.selected.company_name\"></span></ui-select-match><ui-select-choices repeat=\"item as item in $ctrl.divisions track by $index\"><span ng-bind-html=\"item.name + \' - \' + item.company_name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Подразделение</label><span class=req></span></div><div class=\"form-group col-xs-6 row\" style=\"margin-right: 0;\"><div date-range-picker ng-model=$ctrl.printData.effective_date state=effective_date opts=\"{singleDatePicker: true, correctTimeZone: false, drops: \'up\'}\" class=datepicker-wrap name=dateon ng-required=true field-label=\"\'На какую дату\'\"></div></div><div class=\"form-group col-xs-6 row\" style=\"float: right; margin-right: 28px;\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-change=\"$ctrl.printData.other_inform = $ctrl.printData.is_other_inform ? \'BAR_CODE\' : null\" ng-model=$ctrl.printData.is_other_inform id=is_other_inform> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=is_other_inform>Дополнительная информация</label><div class=\"radio-wrapper row\"><div class=\"col-xs-11 col-xs-offset-1\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.other_inform id=NOMENCLATURE_CODE name=other_inform value=OWN_CODE ng-disabled=!$ctrl.printData.is_other_inform> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=NOMENCLATURE_CODE>Код</label></div><div class=\"col-xs-11 col-xs-offset-1\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.other_inform id=ARTICLE name=other_inform value=VENDOR_CODE ng-disabled=!$ctrl.printData.is_other_inform> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=ARTICLE>Артикул производителя</label></div><div class=\"col-xs-11 col-xs-offset-1\"><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.other_inform id=GTIN name=other_inform value=BAR_CODE ng-disabled=!$ctrl.printData.is_other_inform> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=GTIN>Штрих-код</label></div></div><div class=form-group><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=$ctrl.printData.grouping id=category_group> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=category_group>Группировать по категориям</label></div></div><div class=\"form-group col-xs-6 row\" ng-if=$ctrl.showCurrencySelect><ui-select ng-model=$ctrl.currencies.value search-enabled=\"($ctrl.currencies.field.total > 100 && $ctrl.currencies.field.length <= 100)\" required><ui-select-match><span ng-bind-html=\"$select.selected.name + \' (\' +$select.selected.char_iso_code+\')\'\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=$ctrl.currencies.refresh($select.search) repeat=\"item in ($ctrl.currencies.field.items | filter: $select.search) track by $index\"><span class=currency-font ng-bind-html=\"(item.name + \' (\' +item.char_iso_code+\')\') | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Валюта</label><span class=req></span></div><!-- валюта --><div class=\"form-group col-xs-6 row\" ng-if=!$ctrl.retailMode><label>Печатать цены</label><div class=\"radio-wrapper clearfix\"><div class=col-xs-12><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.price_print id=print_one name=price_print value=ONE> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=print_one>За одну единицу</label></div><div class=col-xs-12><div class=\"radio pull-left\"><label style=\"padding: 0\"><input type=radio ng-model=$ctrl.printData.price_print id=print_many name=price_print value=MANY> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=print_many>Для разного количества</label></div></div></div></div><div class=\"modal-body clearfix\" ng-if=\"!$ctrl.retailMode && $ctrl.showColumns\"><h4>Выберите колонки для печати</h4><div ng-scrollbars ng-scrollbars-config=$ctrl.configScroll><ul class=colums-list><li ng-repeat=\"column in $ctrl.columns\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=column.selected id=\"{{column.id}}\" ng-change=$ctrl.selectColumn(column.selected)> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{column.id}}\" ng-bind=column.name></label></li></ul></div><div class=select-all><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=$ctrl.printData.$$selectAll id=select-all ng-change=$ctrl.changeAll()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=select-all>Выбрать все</label></div></div></div><inview-loader show=$ctrl.longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center;\" ng-if=\"$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.finish\">Подготовка отчета</h4><h4 style=\"text-align: center;\" ng-if=\"!$ctrl.longRequest.crudState.loading && $ctrl.longRequest.flags.finish && !$ctrl.longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center;\" ng-if=$ctrl.longRequest.flags.error>При подготовке отчета произошла ошибка</h4><div class=modal-footer><button class=\"btn btn-default\" type=button ng-click=$ctrl.close()>{{longRequest.flags.finish ? \'Закрыть\' : \'Отменить\' }}</button> <button class=\"btn btn-primary\" ng-click=$ctrl.next(); ng-if=\"!$ctrl.retailMode && !$ctrl.showColumns\" ng-disabled=!$ctrl.printPriceList.$valid>Далее</button> <button ng-if=\"!$ctrl.ongRequest.crudState.loading && !$ctrl.longRequest.flags.processStart && !$ctrl.longRequest.flags.finish && ($ctrl.retailMode || $ctrl.showColumns)\" class=\"btn btn-primary\" ng-click=$ctrl.print() ng-disabled=!$ctrl.printPriceList.$valid>Печать</button></div></div></form>");
$templateCache.put("app/price-list/directives/visibility-settings/visibility-settings.html","<div class=\"clearfix fill-width\"><section class=col-xs-9><h5 class=section-header>Видна ДЛЯ ПОДРАЗДЕЛЕНИЙ</h5><div class=\"row clearfix\"><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=divisions_assignment_type ng-model=column.divisions_assignment_type value=EVERYONE id=divisionEVERYONE> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=divisionEVERYONE>Все</label></div><div class=col-xs-5><div class=\"radio pull-left\"><label><input type=radio name=divisions_assignment_type ng-model=column.divisions_assignment_type value=SET id=divisionSET> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=divisionSET>Ограниченный список</label></div><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=divisions_assignment_type ng-model=column.divisions_assignment_type value=NONE id=divisionNONE> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=divisionNONE>Ни для кого</label></div></div><div class=limited-list ng-if=\"column.divisions_assignment_type == \'SET\'\" ng-class=\"{all: vm.divisionsData.length == column.divisions.length}\"><label>Подразделения <span class=req></span></label><ui-select multiple class=multiple-select ng-model=column.divisions theme=bootstrap close-on-select=false ng-required=true><ui-select-match placeholder=\"Выберите значение\">{{$item.name + \' - \' + $item.company_name}}</ui-select-match><ui-select-choices repeat=\"division in vm.divisionsData\"><span ng-bind=\"division.name + \' - \' + division.company_name\"></span></ui-select-choices></ui-select></div></section></div><div class=\"clearfix fill-width\"><section class=col-xs-9 ng-hide=\"column.column_type == \'RETAIL\'\"><h5 class=section-header>Видна ДЛЯ КОНТРАГЕНТОВ</h5><div class=\"row clearfix\"><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=\"counterparties_assignment_type \" ng-model=\"column.counterparties_assignment_type \" value=EVERYONE id=counterpartiesEVERYONE> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=counterpartiesEVERYONE>Все</label></div><div class=col-xs-5><div class=\"radio pull-left\"><label><input type=radio name=\"counterparties_assignment_type \" ng-model=\"column.counterparties_assignment_type \" value=SET id=counterpartiesSET> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=counterpartiesSET>Ограниченный список</label></div><div class=col-xs-3><div class=\"radio pull-left\"><label><input type=radio name=\"counterparties_assignment_type \" ng-model=\"column.counterparties_assignment_type \" value=NONE id=counterpartiesNONE> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=counterpartiesNONE>Ни для кого</label></div></div><div class=limited-list ng-if=\"column.counterparties_assignment_type == \'SET\'\" ng-class=\"{all: vm.contragentsAll.length == column.counterparties.length}\"><label>Контрагенты <span class=req></span></label><ui-select multiple class=multiple-select ng-model=column.counterparties theme=bootstrap close-on-select=false ng-required=true><ui-select-match placeholder=\"Выберите значение\">{{$item.name}}</ui-select-match><ui-select-choices repeat=\"contragent in vm.contragentsAll\"> {{contragent.name}} </ui-select-choices></ui-select></div></section></div>");
$templateCache.put("app/price-list/import/modal/import-modal.html","<div class=import-wrap><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Импорт прайс-листа</h3></div><div class=container><div class=statuses-wrapper><div class=\"warning text-left\" ng-if=showInfo style=\"margin-top: -65px;\"><strong>ВНИМАНИЕ!</strong><br><br><br>Файл содержит ошибки. Если нажать кнопку \"Продолжить\", то в процессе импорта строки с ошибками не загрузятся в систему.</div><div class=\"load-data-spinner text-center\" ng-if=loadImport><inview-loader show=loadImport></inview-loader>Подождите, проводится импорт данных</div><div class=\"success-check text-center\" ng-if=\"!loadImport && !showInfo && loadSuccess && !loadError\"><div class=\"center-ico ok-check-ico\" style=\"margin-top: 0;\"></div>Импорт успешно завершен!</div><div class=\"error-check text-center\" ng-if=\"!loadImport && !showInfo && !loadSuccess && loadError\"><div class=\"center-ico error-check-ico\"></div> {{errorMessage}} </div></div></div><div class=modal-footer><button class=\"btn pull-left\" ng-click=cancel() ng-if=\"showInfo || loadImport\">Отменить</button> <button class=\"btn btn-primary pull-right\" ng-click=import(); ng-if=showInfo>Продолжить</button> <button class=\"btn btn-primary pull-right\" ng-click=close(); ng-if=\"!loadImport && !showInfo && !loadSuccess && loadError\">Закрыть</button> <a ui-sref=\"priceList({parent: type})\" ng-click=close(); class=\"btn btn-primary pull-right\" ng-if=\"!showInfo && loadSuccess\">В прайс-лист</a> <button class=\"btn pull-right\" ng-click=close() ng-if=\"!loadImport && !showInfo && !loadSuccess && loadError\">Закрыть</button></div></div>");
$templateCache.put("app/price-list/import/sections/1-load-file.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-if=vm.uploader.queue[0].isSuccess></span><h5 class=section-header ng-class=\"{\'no-margin\': vm.activeStep}\">1. ЗАГРУЗКА ФАЙЛА</h5><div class=load-data-wrap ng-show=!vm.activeStep nv-file-drop uploader=vm.uploader><input type=file id=load-data-field nv-file-select uploader=vm.uploader accept=\".xls, .xlsx\" style=\"display: none\" multiple><div class=start ng-if=\"(!vm.uploader.queue[0].progress || vm.uploader.queue[0].isCancel) && !vm.uploader.queue[0].isError && !vm.uploader.queue[0].isSuccess\"><label class=load-data-descr>Нажмите «Загрузить» или перетащите файл в эту область</label><label for=load-data-field class=\"btn pull-right btn-primary\">Загрузить</label></div><div class=load ng-if=\"vm.uploader.queue[0].progress && !vm.uploader.queue[0].isSuccess\"><label class=\"load-data-spinner pull-left\"><div class=\"ui-spinner pull-left\"></div>Загружаю</label><button class=\"btn pull-right\" ng-click=vm.uploader.queue[0].cancel()>Отмена</button></div><div class=success ng-if=vm.uploader.queue[0].isSuccess><label class=\"load-data-success text-success pull-left\">Файл «{{vm.uploader.queue[0].file.name}}» загружен</label><label for=load-data-field class=\"btn pull-right\">Загрузить</label></div><div class=error ng-if=vm.uploader.queue[0].isError><label class=\"load-data-error text-danger pull-left\">Ошибка при загрузке файла. <span ng-if=\"vm.fileError == \'format\'\">Неверный формат</span> <span ng-if=\"vm.fileError == \'size\'\">Размер файла превышает 5 МБ</span> <span ng-if=\"vm.fileError == \'empty\'\">Файл пуст</span></label><label for=load-data-field class=\"btn pull-right btn-primary\">Загрузить</label></div></div><div class=section-helper ng-show=!vm.activeStep style=\"margin-top: 16px\"><span class=text-danger>ВНИМАНИЕ!</span> Загружаемый файл должен быть не более 5 МБ в формате <strong>.xls</strong> и <strong>.xlsx</strong></div></section>");
$templateCache.put("app/price-list/import/sections/2-data-processing.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-show=\"vm.activeStep > 1\"></span><h5 class=section-header ng-class=\"{\'no-margin\': vm.activeStep > 1}\">2. ОБРАБОТКА ДАННЫХ</h5><div ng-if=\"vm.activeStep == 1\">Укажите, где в файле «Категории», «Код позиции», «Наименование позиции», «Цена» и др.<div class=data-processing-wrap><div class=data-processing-table><div class=\"data-processing-table-body nestedDemo\" ng-class=\"{\'has-more-data\': vm.fileData.line_count > 20}\"><div class=arrow-wrap><span class=\"move-position-button prev tooltip-light\" tooltip-placement=right uib-tooltip=\"Показать еще колонки\" ng-click=vm.switchColumn() ng-if=vm.offsetColumn></span> <span class=\"move-position-button next tooltip-right tooltip-light\" tooltip-placement=left uib-tooltip=\"Показать еще колонки\" ng-click=vm.switchColumn(true) ng-if=\"(vm.offsetColumn + vm.countColumn) < vm.processing.column_mapping.length\"></span></div><div class=data-processing-table-head><div class=header-cell ng-repeat=\"row in vm.processing.column_mapping | limitTo:vm.countColumn:vm.offsetColumn track by ($index + vm.offsetColumn)\" style=\"width: {{100/vm.countColumn}}%; max-width: {{100/vm.countColumn}}%; min-width: {{100/vm.countColumn}}%;\"><div class=form-group ng-class=\"{\'has-error-unique\': vm.columnErrorInds.length && vm.columnErrorInds.indexOf($index + vm.offsetColumn) + 1}\"><ui-select class=slim-control ng-model=row search-enabled=false on-select=\"vm.changeColumnName(row, $index + vm.offsetColumn)\" ng-class=\"{\'ng-invalid-required ng-dirty\': vm.headersCheck === false && !row}\"><ui-select-match placeholder=Выберите allow-clear=true><span ng-bind-html=$select.selected.label title=\"{{$select.selected.label}}\"></span></ui-select-match><ui-select-choices repeat=\"type.id as type in vm.headerData track by $index\"><span ng-bind-html=type.label title=\"{{type.label}}\"></span></ui-select-choices></ui-select><div class=\"valid-message isset-name\">Колонка уже выбрана</div><div class=\"valid-message required-mess\">Выберите значение</div></div></div></div><div ng-scrollbars ng-scrollbars-config=vm.configScroll><ul class=\"line-helper dropzone\" dnd-list=vm.lineHelper dnd-drop=\"vm.dropCallback(index, item, external, type, vm.lineHelper)\"><li ng-repeat=\"item in vm.lineHelper track by $index\" dnd-draggable=item dnd-dragend=\"vm.listMoved($index, item, vm.lineHelper)\" dnd-effect-allowed=move dnd-selected=\"models.selected = item\" ng-class=\"{\'selected\': item.selected === item}\" dnd-dragstart=\"vm.onDragstart(vm.lineHelper, event)\"><div ng-if=\"item[0] === true\" class=devider-wrap ng-hide=\"vm.fileData.line_count == 1\"><div class=devider ng-class=\"{\'all-row\': !vm.processing.start_line, \'no-row\': vm.processing.start_line == vm.fileData.lines.length - 1}\"></div><ul><li class=move-up-row ng-click=vm.changeRowNum()></li><li class=move-row-descr>первая строка</li><li class=move-down-row ng-click=vm.changeRowNum(true)></li></ul></div><dnd-nodrag class=tr-helper ng-if=\"item[0] !== true\"></dnd-nodrag></li></ul><div class=file-data-table><div ng-repeat=\"row in vm.fileData.lines track by $index\" ng-class=\"{\'text-muted\': $index < vm.processing.start_line, \'tr-devider\': vm.processing.start_line == ($index + 1)}\" class=tr><span ng-repeat=\"cell in row | limitTo:vm.countColumn:vm.offsetColumn track by $index\" class=td style=\"width: {{100/vm.countColumn}}%; max-width: {{100/vm.countColumn}}%; min-width: {{100/vm.countColumn}}%;\"><cell-with-tooltip text=cell></span></div></div></div></div><i class=text-muted ng-if=\"vm.fileData.line_count > 20\">выведено первые 20 строк загруженного файла</i><br><span class=req-inform ng-show=\"vm.headersCheck === false\" aria-hidden=false>Необходимо указать в файле обязательные колонки: <span ng-if=!vm.reqColumn.category>«Категория»<span>,</span></span> <span ng-if=!vm.reqColumn.code>«Код позиции»<span>,</span></span> <span ng-if=!vm.reqColumn.name>«Наименование позиции»<span>,</span></span> <span ng-if=!vm.reqColumn.price>«Цена»<span>,</span></span></span></div></div></div></section>");
$templateCache.put("app/price-list/import/sections/3-other-data.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-show=\"vm.activeStep > 2\"></span><h5 class=section-header ng-class=\"{\'no-margin\': vm.activeStep > 2}\">3. ДОПОЛНИТЕЛЬНАЯ ИНФОРМАЦИЯ</h5><div ng-if=\"vm.activeStep == 2\"><div class=form-group>В какую колонку прайс-листа мы загружаем данные?<table class=\"table without-bg\"><tr><th style=\"width: 40px;\"></th><th>Наименование</th><th>Параметры</th></tr><tr ng-repeat=\"column in vm.priceColumns\"><td><div class=radio><label><input type=radio name=forColumn ng-model=vm.columnNumber ng-value=$index ng-change=vm.choseColumn($index); id=\"{{column.id}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></td><td ng-bind=column.name></td><td class=column-header-container><span class=\"glyphicon glyphicon-info-sign divisions-icon tooltip-light\" ng-if=column.divisions.length tooltip-placement=right uib-tooltip-html=\"\'{{vm.tipForDivisions(column)}}\'\"></span> <span class=\"glyphicon glyphicon-info-sign divisions-icon no-access\" ng-if=\"column.divisions_assignment_type == \'NONE\'\" tooltip-placement=right uib-tooltip=\"Ни для кого\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon tooltip-light\" ng-if=column.counterparties.length tooltip-placement=right uib-tooltip-html=\"\'{{vm.tipForCounterparties(column)}}\'\"></span> <span class=\"glyphicon glyphicon-info-sign counterparties-icon no-access\" ng-if=\"column.counterparties_assignment_type == \'NONE\' && vm.type !== \'RETAIL\'\" tooltip-placement=right uib-tooltip=\"Ни для кого\"></span> <small class=\"badge badge-primary\" ng-show=column.effective_order_sum>от {{column.effective_order_sum}} <span ng-bind=column.currency.symbol class=currency-font></span></small></td></tr><tr><td><div class=radio><label><input type=radio name=forColumn ng-model=vm.columnNumber ng-value=vm.priceColumns.length ng-change=vm.choseColumn(-1); id=new> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></td><td><div class=form-group ng-class=\"{\'has-error-unique\': vm.issetColumnName}\" style=\"margin-bottom: 0;\"><i style=\"margin-bottom: 8px;\">Создать новую колонку</i> <input type=text class=\"form-control slim-control\" ng-model=vm.newColumnName ng-required=!vm.processing.column.id maxlength=50 ng-keydown=\"vm.columnNumber = vm.priceColumns.length;\" ng-keyup=vm.checkUniqueColumnName(vm.newColumnName);><div class=\"valid-message required-mess small-offset\">Поле является обязательным</div><div class=\"valid-message isset-name small-offset\">Название колонки уже существует</div></div><div class=section-helper style=\"padding-left: 0;\">Не более 50 символов</div></td></tr></table></div><div class=form-group><label for=\"\">Создавать позицию, если ее нет в каталоге?</label><div class=radio><label><input type=radio name=createSku ng-model=vm.processing.create_position ng-value=true id=createSkuYes> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><label for=createSkuYes>Да</label><label><input type=radio name=createSku ng-model=vm.processing.create_position ng-value=false id=createSkuNo> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><label for=createSkuNo>Нет</label></div></div><div class=form-group><label for=\"\">Обновлять сведения о позиции из файла, если такая позиция уже есть в каталоге?</label><div class=radio><label><input type=radio name=updateSku ng-model=vm.processing.update_position ng-value=true id=updateSkuYes> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><label for=updateSkuYes>Да</label><label><input type=radio name=updateSku ng-model=vm.processing.update_position ng-value=false id=updateSkuNo> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><label for=updateSkuNo>Нет</label></div></div><div class=\"form-group col-xs-4 row\" style=\"margin-bottom: 0; margin-top: 20px;\"><div date-range-picker ng-model=vm.processing.actual_date opts=vm.datePickerOpts state=vm.datePickerState class=datepicker-wrap name=start_date ng-required=true on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Цены действуют с\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div></div></section>");
$templateCache.put("app/price-list/import/sections/4-check-file.html","<section class=\"form-group col-xs-12\"><h5 class=section-header>4. ПРОВЕРКА ФАЙЛА</h5><div ng-show=\"vm.activeStep == 3\" class=text-center><div class=load-check ng-show=!vm.fileErrors><div class=ui-spinner style=\"margin: 60px auto 15px;\"></div>Подождите, проводится анализ файла<br>на отсутствие ошибок</div><div class=success-check ng-show=\"vm.fileErrors && !vm.fileErrors.file_errors && vm.fileErrors.success_count\"><span class=ok-check-ico></span> Доступно для импорта: <span ng-bind=\"vm.fileErrors.success_count + \' \' + vm.successCountStr\"></span></div><div class=\"error-check text-danger\" ng-show=\"(vm.fileErrors && vm.fileErrors.file_errors) || vm.fileErrors.success_count === 0\"><div class=error-check-ico style=\"margin: 60px auto 8px;\"></div><div class=req-inform ng-show=\"vm.fileErrors.success_count === 0\" style=\"font-size: 16px;\">Внимание, нет строк, доступных для импорта</div><div ng-if=vm.fileErrors.success_count>Внимание, для импорта доступно: <span ng-bind=\"vm.fileErrors.success_count + \' \' + vm.successCountStr\"></span></div><div ng-if=\"vm.fileErrors && vm.fileErrors.file_errors\">В файле: {{vm.fileErrors.file_errors + \' \' + vm.errorCountStr}}.</div><div ng-if=\"vm.fileErrors.file_errors > 100\">Список первых 100 ошибок:</div></div><table class=\"load-errors table text-left\" ng-show=\"vm.fileErrors && vm.fileErrors.file_errors\"><tr><th style=\"width: 93px;\">Строка</th><th style=\"width: 93px;\">Столбец</th><th>Ошибка</th></tr><tr ng-repeat=\"error in vm.fileErrors.errors\"><td ng-bind=error.row></td><td ng-bind=\"error.columnName || error.column\"></td><td ng-bind=error.message></td></tr></table></div></section>");
$templateCache.put("app/print/sales-totals-print/includes/common-info.html","<section class=form-group style=\"padding: 12px 18px; display: block;\"><h5 class=section-header>Основная информация</h5><div class=\"row clearfix\"><div class=\"form-group col-xs-6\"><ui-select ng-model=salesTotalsPrintCtrl.data.filter_company_id on-select=salesTotalsPrintCtrl.refreshDivisions(); on-remove=salesTotalsPrintCtrl.refreshDivisions(); name=companyId><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=salesTotalsPrintCtrl.refreshCompanies($select.search) repeat=\"item.id as item in salesTotalsPrintCtrl.companies track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Компания</label></div><div class=\"form-group col-xs-6\"><ui-select ng-model=salesTotalsPrintCtrl.data.filter_division_id ng-disabled=!salesTotalsPrintCtrl.data.filter_company_id name=divsionId search-enabled=false><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in ( salesTotalsPrintCtrl.divisions | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Подразделение</label></div></div><div class=\"row clearfix\"><div class=\"form-group clearfix\" style=\"padding: 0;\"><div class=col-xs-6><h5 style=\"font-weight: bold;\">ПЕРИОД ОТЧЕТА</h5><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'yestarday\');\">Вчера</span><br><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'last month\');\">Прошлый месяц</span><br><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'last quarter\');\">Прошлый квартал</span><br><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'last year\');\">Прошлый год</span></div><div class=col-xs-6 style=\"padding-top: 29px;\"><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'today\');\">Сегодня</span><br><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'this month\');\">Текущий месяц</span><br><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'this quarter\');\">Текущий квартал</span><br><span class=link-style ng-click=\"salesTotalsPrintCtrl.setInterval(\'this year\');\">Текущий год</span></div></div><div class=\"form-group col-xs-6\"><div date-range-picker state=start_date ng-model=salesTotalsPrintCtrl.data.start_date opts=\"{singleDatePicker: true, correctTimeZone: false, maxDate: salesTotalsPrintCtrl.today}\" ng-required=true class=datepicker-wrap name=dateTo field-label=\"\'Начало периода\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group col-xs-6\"><div date-range-picker state=end_date ng-model=salesTotalsPrintCtrl.data.end_date opts=\"{singleDatePicker: true, correctTimeZone: false, maxDate: salesTotalsPrintCtrl.today}\" ng-required=true class=datepicker-wrap name=dateTo field-label=\"\'Конец периода\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div></div></section>");
$templateCache.put("app/print/sales-totals-print/includes/tabs.html","<section class=form-group style=\"padding: 12px 18px; display: block;\"><h5 class=section-header>Вид отчета</h5><div class=\"row radio-box clearfix\" style=\"margin-bottom: 15px;\"><div class=\"clearfix col-xs-6\"><div class=\"radio pull-left\"><label><input type=radio name=activeTab ng-model=salesTotalsPrintCtrl.activeTab ng-value=1 id=activeTab1 uib-tooltip=\"Выберите тип формируемого отчета\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=activeTab1>Типовой</label></div><div class=\"clearfix col-xs-6\"><div class=\"radio pull-left\"><label><input type=radio name=activeTab ng-model=salesTotalsPrintCtrl.activeTab ng-value=2 id=activeTab2 uib-tooltip=\"Выберите тип формируемого отчета\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=activeTab2>Настраиваемый</label></div></div><div style=\"border-top: 1px solid rgba(51, 51, 51, 0.6); padding-top: 25px;\"><div class=scan-tab ng-if=\"salesTotalsPrintCtrl.activeTab == 1\"><div class=radio-box><div class=clearfix ng-repeat=\"radioField in salesTotalsPrintCtrl.allDimensions\"><div class=\"radio pull-left\"><label><input type=radio name=allDim ng-model=salesTotalsPrintCtrl.data.dimensions ng-value=radioField.id id=\"{{radioField.id}}\" uib-tooltip=\"Выберите тип формируемого отчета\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{radioField.id}}\">{{radioField.label}}</label></div></div></div><div class=\"row scan-tab\" ng-if=\"salesTotalsPrintCtrl.activeTab == 2\"><div class=clearfix><p class=col-xs-10>Чтобы добавить колонки и строки в отчет, перетащите их из левого блока \"Доступные\" в правый \"Отображать в отчете\" или \"Группировать в отчете\".</p><div class=\"col-xs-2 filter-settings-block text-right pull-right\"><button type=button class=\"btn toggle-filter filter-star\" ng-click=salesTotalsPrintCtrl.saveFilterPopup(); uib-tooltip=\"{{salesTotalsPrintCtrl.filterApplied? \'\' : \'Сохранить настройки отчета\'}}\" ng-class=\"{\'funny-star\': salesTotalsPrintCtrl.filterApplied}\"></button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=salesTotalsPrintCtrl.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=salesTotalsPrintCtrl.filterObj.getSavedFiltersNames().length><span class=ico></span>Сохраненные настройки</div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=salesTotalsPrintCtrl.configScrollFilter ng-show=salesTotalsPrintCtrl.filterObj.getSavedFiltersNames().length><div class=content><div ng-repeat=\"filterName in salesTotalsPrintCtrl.filterObj.getSavedFiltersNames()\" ng-click=\"salesTotalsPrintCtrl.chooseFilter({filterName: filterName})\"><span ng-bind-html=filterName></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"salesTotalsPrintCtrl.removeFilter(filterName, $event)\"></span></div></div></div><div class=no-saved-filters ng-show=!salesTotalsPrintCtrl.filterObj.getSavedFiltersNames().length>Для сохранения настроек отчета нажмите на звездочку</div></div></div><div class=col-xs-6><h5 class=section-header>Колонки<span class=req style=\"position: relative; top: -10px; right: -5px;\"></span></h5></div><div class=col-xs-6><h5 class=section-header>Строки<span class=req style=\"position: relative; top: -10px; right: -5px;\"></span></h5></div></div><div class=col-xs-6><div class=\"row dnd-wrapper clearfix\" ng-class=\"{\'required-error\' : salesTotalsPrintCtrl.isSetDirty && !salesTotalsPrintCtrl.myTotals.dndColumns[1].items.length}\"><div class=col-xs-6 ng-repeat=\"list in salesTotalsPrintCtrl.myTotals.dndColumns\"><div class=dnd-header><div><span ng-bind=list.listName></span></div></div><ul dnd-list dnd-drop=\"salesTotalsPrintCtrl.onDrop(list, item, index)\" dnd-allowed-types=list.allowedTypes><li class=ellipsis ng-repeat=\"item in list.items\" dnd-draggable=\"salesTotalsPrintCtrl.getSelectedItemsIncluding(list, item)\" dnd-dragstart=\"salesTotalsPrintCtrl.onDragstart(list, event)\" dnd-moved=salesTotalsPrintCtrl.onMoved(list) dnd-dragend=\"list.dragging = false\" dnd-selected=\"item.selected = !item.selected\" ng-class=\"{\'selected\': item.selected}\" ng-hide=\"list.dragging && item.selected\" dnd-type=item.type uib-tooltip=\"{{item.label}}\" tooltip-placement=right ng-if=\"item.value != \'COST\' || (item.value == \'COST\' && $root.accountingSettings.calc_cost_enabled)\"> {{item.label}} <span class=\"handle tooltip-light\" uib-tooltip=Переместить tooltip-placement=left></span></li></ul></div></div><br><p>Группировать колонки по</p><div class=row><div class=\"col-xs-6 radio-box clearfix\"><div class=\"radio pull-left\"><label><input type=radio name=groupBy ng-model=salesTotalsPrintCtrl.myTotals.metric_grouping_period value=DAY id=DAY ng-change=\"salesTotalsPrintCtrl.filterApplied = false;\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=DAY>День</label></div><div class=\"col-xs-6 radio-box clearfix\"><div class=\"radio pull-left\"><label><input type=radio name=groupBy ng-model=salesTotalsPrintCtrl.myTotals.metric_grouping_period value=QUARTER id=QUARTER ng-change=\"salesTotalsPrintCtrl.filterApplied = false;\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=QUARTER>Квартал</label></div><div class=\"col-xs-6 radio-box clearfix\"><div class=\"radio pull-left\"><label><input type=radio name=groupBy ng-model=salesTotalsPrintCtrl.myTotals.metric_grouping_period value=MONTH id=MONTH ng-change=\"salesTotalsPrintCtrl.filterApplied = false;\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=MONTH>Месяц</label></div><div class=\"col-xs-6 radio-box clearfix\"><div class=\"radio pull-left\"><label><input type=radio name=groupBy ng-model=salesTotalsPrintCtrl.myTotals.metric_grouping_period value=YEAR id=YEAR ng-change=\"salesTotalsPrintCtrl.filterApplied = false;\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=YEAR>Год</label></div></div></div><div class=col-xs-6><div class=\"row dnd-wrapper clearfix\" ng-class=\"{\'required-error\' : salesTotalsPrintCtrl.isSetDirty && !salesTotalsPrintCtrl.myTotals.dndLines[1].items.length}\"><div class=col-xs-6 ng-repeat=\"list in salesTotalsPrintCtrl.myTotals.dndLines\"><div class=dnd-header><div><span ng-bind=list.listName></span></div></div><ul dnd-list dnd-drop=\"salesTotalsPrintCtrl.onDrop(list, item, index)\" dnd-allowed-types=list.allowedTypes style=\"min-height: 560px;\"><li class=ellipsis ng-repeat=\"item in list.items\" dnd-draggable=\"salesTotalsPrintCtrl.getSelectedItemsIncluding(list, item)\" dnd-dragstart=\"salesTotalsPrintCtrl.onDragstart(list, event)\" dnd-moved=salesTotalsPrintCtrl.onMoved(list) dnd-dragend=\"list.dragging = false\" dnd-selected=\"item.selected = !item.selected\" ng-class=\"{\'selected\': item.selected}\" ng-hide=\"list.dragging && item.selected\" dnd-type=item.type uib-tooltip=\"{{item.label}}\" tooltip-placement=left> {{item.label}} <span class=\"handle tooltip-light\" uib-tooltip=Переместить tooltip-placement=left></span></li></ul></div></div></div></div></div></section>");
$templateCache.put("app/settings/bank-product-request/components/consent.html","<div class=consent-wrapper><a class=\"pointer switch-btn\" ng-click=\"!ctrl.consentData.link.url ? ctrl.prepareReport() : ctrl.unlink()\">{{ctrl.consentData.link.url ? \'Удалить\': \'Скачать\'}}</a><div class=\"consent load-data-wrap\" style=\"{{ (ctrl.consentData.link.url ? \'background-image: url(\' + ctrl.consentData.link.url+ \') ;background-size: cover;\' : \'\')}}\" ng-class=\"{\'bg-isset\': ctrl.consentData.link.url}\"><div ng-if=!ctrl.longRequest.crudState.loading nv-file-drop uploader=ctrl.uploader><input type=file id=\"load-data-field{{ctrl.consentData.id}}\" nv-file-select uploader=ctrl.uploader accept=.pdf style=\"display: none\"><div ng-if=!ctrl.consentData.link.url class=full-height><div class=\"start load-data-container\" ng-if=\"(!ctrl.uploader.queue[0].progress || ctrl.uploader.queue[0].isCancel) && !ctrl.uploader.queue[0].isSuccess\"><label class=load-data-descr>Нажмите «Загрузить» или перетащите скан согласия в эту область</label><label class=\"link-like pointer\" for=\"load-data-field{{ctrl.consentData.id}}\" ng-mousedown=\"ctrl.uploader.queue[0].isError ? ctrl.uploader.clearQueue() : \'\'\">Загрузить</label></div><div class=\"load load-data-container\" ng-if=\"ctrl.uploader.queue[0].progress && !ctrl.uploader.queue[0].isSuccess\"><label class=\"load-data-spinner pull-left\"><div class=ui-spinner></div>Загружаю</label><label class=pointer ng-click=ctrl.uploader.queue[0].cancel()>Отмена</label></div></div></div><div class=load-data-container ng-if=ctrl.longRequest.crudState.loading><div class=ui-spinner></div></div></div><div class=\"consent-description row\" ng-bind=ctrl.consentData.output_name></div><div class=error ng-if=ctrl.uploader.queue[0].isError><label class=\"load-data-error text-danger pull-left text-center\">Ошибка при загрузке файла. <span ng-if=\"ctrl.fileError == \'format\'\">Неверный формат</span> <span ng-if=\"ctrl.fileError == \'size\'\">Размер файла превышает 5 МБ</span> <span ng-if=\"ctrl.fileError == \'empty\'\">Файл пуст</span></label></div></div>");
$templateCache.put("app/settings/bank-product-request/list/bank-product-requests.html","<div class=\"main-left-offset main-right-offset\"><ul class=breadcrumbs><li>Деньги</li></ul><div><h1>Заявки на банковские продукты</h1></div></div><div class=\"beneficiary main-control-block functional_block clearfix main-left-offset main-right-offset\" ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"><form class=\"search-entity col-xs-6\" role=search ng-submit=vm.search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=vm.getPage() class=\"form-control label-clear-button\" ng-model=vm.searchText placeholder=\"Поиск по продукту и компании\"> <button class=\"btn slim-button search-btn\" ng-click=vm.search()>Поиск</button></div></form><div class=btn-group style=\"display: none;\"><button type=button class=\"btn dropdown-toggle\" data-toggle=dropdown><span class=\"glyphicon glyphicon-share\"></span> Выгрузить <span class=caret></span></button><ul class=dropdown-menu role=menu><li><a href=#>Действие</a></li><li><a href=#>Другое действие</a></li><li><a href=#>Что-то иное</a></li><li class=divider></li><li><a href=#>Отдельная ссылка</a></li></ul></div><div class=\"filter-settings-block text-right pull-right\"><button type=button class=\"btn toggle-filter\" ng-click=vm.turnShowFilter();>Фильтр</button> <button type=button class=\"btn dropdown-toggle filter-dropdown tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Выбрать сохраненный фильтр\" data-toggle=dropdown tabindex=-1 ng-click=vm.prepareSavedFiltersList()><span class=caret></span> <span class=sr-only></span></button><div class=\"dropdown-menu pull-right\" role=menu><div class=\"filters-list-title major-font\" ng-show=vm.gridFilter.getSavedFiltersNames().length><span class=ico></span>Сохраненные фильтры</div><div class=\"form-group input-group search search-entity\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length > 5\" ng-class=\"(vm.gridFilter.getSavedFiltersNames().length > 5)? \'show-search\' : \'no-search\'\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text class=form-control ng-model=vm.savedFilterListSearchText placeholder=Найти></div><div class=content-wrapper ng-scrollbars ng-scrollbars-config=vm.configScrollFilter><div class=content><div ng-repeat=\"filterName in vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText\" ng-click=vm.chooseFilter(filterName)><span ng-bind-html=\"filterName | highlight: vm.savedFilterListSearchText\"></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"vm.removeFilter(filterName, $event)\"></span></div></div></div><div class=no-saved-filters ng-show=!vm.gridFilter.getSavedFiltersNames().length>Для сохранения фильтра<br>нажмите на звездочку<br>в поле фильтров<div class=no-saved-filters-ico></div></div><p class=\"info no-find-filters\" ng-show=\"vm.gridFilter.getSavedFiltersNames().length && !(vm.gridFilter.getSavedFiltersNames() | filter:vm.savedFilterListSearchText).length\">К сожалению, мы не смогли ничего найти. Пожалуйста, уточните запрос</p></div></div></div><div class=\"filter-not-found beneficiary major-font\" ng-if=\"!vm.bankProductRequests.length && vm.loadData\"><div class=big-danger-info-ico ng-if=!vm.noData></div><div class=big-danger-info ng-if=!vm.noData><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=vm.noData>Нет данных</div></div><grid-loader show=vm.crudState.loading ng-class=\"vm.showFilter ? \'show-filter\' : \'\';\"></grid-loader><div class=grid ui-grid=vm.gridOptions ui-grid-edit ui-grid-cellnav></div><div class=table-footer><paging page-info=vm.paging callback=vm.getPage></paging></div><all-filter filter-meta=vm.filterMeta apply-filter=vm.applyFilter filter-data=vm.popupFilter clean-filter=vm.cleanFilter></all-filter>");
$templateCache.put("app/settings/bank-product-request/steps/fifth-step.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-show=\"vm.activeStep == 5\"></span><h5 class=\"section-header text-uppercase\" ng-class=\"{\'no-margin\': vm.activeStep > 5}\">5. Результат</h5><div ng-if=\"vm.activeStep == 5\"><div ng-bind-html=\"vm.bankProductRequest.bank_product.successful_request_message\n        .replace(\'USER_EMAIL\', $root.user.email)\n        .replace(\'USER_PHONE\', $root.user.phone)\"></div></div></section>");
$templateCache.put("app/settings/bank-product-request/steps/first-step.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-show=\"vm.activeStep > 0\"></span><h5 class=\"section-header text-uppercase\" ng-class=\"{\'no-margin\': vm.activeStep > 1}\">1. Выбор продукта</h5><div ng-if=!vm.activeStep><div class=form-group ng-repeat=\"bankProduct in vm.bankProducts\"><div class=\"radio pull-left\"><label><input type=radio name=bank_product required ng-model=vm.choosenBankProduct ng-value=bankProduct ng-change=vm.onBankProductChange(vm.choosenBankProduct) id=\"bank_product{{$index}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"bank_product{{$index}}\" ng-bind=\"bankProduct.partner_bank.name + \': \' + bankProduct.name\"></label></div><div ng-if=\"!vm.bankProducts.length && !vm.bankProductRequest.bank_product\">В данный момент у нас нет ни одного предложения для вас</div><div class=bank-product-description ng-show=vm.bankProductRequest.bank_product ng-bind-html=vm.bankProductRequest.bank_product.product_description></div></div><div ng-show=\"vm.activeStep > 0\" ng-bind=\"vm.bankProductRequest.bank_product.partner_bank.name + \': \' + vm.bankProductRequest.bank_product.name\"></div></section>");
$templateCache.put("app/settings/bank-product-request/steps/forth-step.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-show=\"vm.activeStep > 3\"></span><h5 class=\"section-header text-uppercase\" ng-class=\"{\'no-margin\': vm.activeStep > 3}\">4. Подтверждение и отправка заявки</h5><div ng-if=\"vm.activeStep == 3\"><p ng-bind-html=\"vm.bankProductRequest.bank_product.partner_bank.ready_request_test\n        .replace(\'BANK\', vm.bankProductRequest.bank_product.partner_bank.name)\n        .replace(\'BANK_PRODUCT\', vm.bankProductRequest.bank_product.name)\n        .replace(\'COMPANY_NAME\', vm.company.organization.legal_requisites.full_name)\n        .replace(vm.regexp, \'\')\"></p><ul class=panel-body><li class=item ng-repeat=\"include in vm.listOfIncludes\">{{include}}</li><li class=item>Согласие на обработку персональных данных и запрос в бюро кредитных историй:</li><li><ul class=panel-body><li class=item ng-repeat=\"consent in vm.bankProductRequest.consents\">{{ vm.legalEntityConsents.indexOf(consent.type) != -1 ? \' юридического лица \' + vm.company.organization.legal_requisites.short_name + \' за подписью руководителя - \' + vm.company.organization.chief_name : \' физического лица \' + consent.output_name }}</li></ul></li></ul></div><style>.panel-body li.item:before{\n      content: \'•\';\n      text-decoration: none;\n      color: #333333;\n      font-size: 20px;\n      margin-right: 10px;\n    }</style></section>");
$templateCache.put("app/settings/bank-product-request/steps/second-step.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-show=\"vm.activeStep > 1\"></span><h5 class=\"section-header text-uppercase\" ng-class=\"{\'no-margin\': vm.activeStep > 1}\">2. Проверка возможности получения продукта</h5><div ng-if=\"vm.activeStep === 1\"><button class=\"btn btn-primary pull-right\" ng-show=vm.bankProductRequest.company ng-click=vm.refreshDiagnostics()>Проверить</button><div class=\"form-group col-xs-8\"><ui-select ng-model=vm.bankProductRequest.company name=company required tooltip=\"{{$select.selected.name}}\" on-select=vm.onCompanySelect(vm.bankProductRequest.company)><ui-select-match tooltip-placement=right uib-tooltip=\"{{$select.selected.name}}\"><span bind-html-compile=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item in vm.companies\"><span ng-bind=item.name></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Укажите компанию, для которой нужен банковский продукт</label><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=col-xs-12><div ng-repeat=\"examination in vm.examinations\"><div class=text-uppercase><span class=status ng-class=\"examination.status == \'SUCCESS\' ? \'success\': \'error\'\"></span> {{vm.examinationType[examination.examination_chapter]}} </div><div style=\"padding-left: 20px\"><div ng-repeat=\"detail in examination.details\"><div>- {{detail.name}} <a ng-if=detail.entity_name style=\"cursor: pointer\" ng-click=\"vm.fixError(detail.entity_name, detail.entity_id)\">исправить</a></div></div></div></div><div ng-if=\"!vm.examinations.length && vm.bankProductRequest.status != \'NEW\' && vm.bankProductRequest.company\">Вы подготовили онлайн заявку в банк \"{{vm.bankProductRequest.bank_product.partner_bank.name}}\" на банковский продукт \"{{vm.bankProductRequest.bank_product.name}}\" от имени компании \"{{vm.bankProductRequest.company.name}}\"</div></div></div><div ng-if=\"vm.activeStep > 1\" ng-bind=vm.bankProductRequest.company.name></div></section>");
$templateCache.put("app/settings/bank-product-request/steps/third-step.html","<section class=\"form-group col-xs-12\"><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-show=\"vm.activeStep > 2\"></span><h5 class=\"section-header text-uppercase\" ng-class=\"{\'no-margin\': vm.activeStep > 2}\">3. Оформление согласий</h5><div ng-if=\"vm.activeStep == 2\"><div style=\"margin-bottom: 10px\" ng-bind-html=vm.bankProductRequest.bank_product.partner_bank.bank_consent_description></div><div style=\"display: flex;margin-top: 10px;flex-direction: row;flex-flow: wrap;\"><div ng-repeat=\"consent in vm.bankProductRequest.consents track by $index\"><consent-component bank-product-request-id=vm.bankProductRequest.id on-update=vm.onConsentUpdate(consent) consent-data=consent></consent-component></div></div></div></section>");
$templateCache.put("app/settings/beneficiary/crud/beneficiary-crud.html","<div class=\"crud-entity main-left-offset main-right-offset\" ng-class=\"(vm.mode.isView)? \'view-entity\': \'\'\"><!-- content of settings --><form class=\"crud-main-column col-xs-9\" ng-submit=vm.submit() role=form name=vm.beneficiaryForm><div ng-if=vm.mode.isNew><h1>Добавление нового бенефициара</h1></div><div ng-if=vm.mode.isEdit><h1>Редактирование бенефициара<entity-history entity-data=vm.beneficiary></entity-history></h1></div><div ng-if=vm.mode.isView><h1>Информация о бенефициаре<entity-history entity-data=vm.beneficiary></entity-history></h1></div><div class=\"section top-buttons col-xs-12\" ng-if=!vm.mode.isNew><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"(vm.isSetDirty && !vm.beneficiaryForm.$valid) || vm.isHasValidErrors(vm.beneficiaryForm.$error)\"></form-buttons></div><div class=clear></div><fieldset ng-disabled=vm.mode.isView><section class=\"form-group col-xs-12\" ng-class=\"{\'slide-up\': vm.hideMainInfo}\" ng-style=\"(vm.mode.isView)? {\'max-height\': \'350px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideMainInfo = !vm.hideMainInfo\" ng-show=vm.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=row><div class=clearfix><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': vm.beneficiaryForm.person.$invalid && vm.beneficiaryForm.person.$error.unique}\"><div id=beneficiary-fio only-popup-edit=true person-data-input fio=vm.fio form-model=vm.beneficiary.person name-and-id=person is-required=true unique-callback=vm.uniqueCheck field-label=\"\'ФИО\'\"></div><div class=\"valid-message isset-name\">Бенефициар с таким именем у этой компании уже существует</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': vm.beneficiaryForm.name.$invalid && vm.beneficiaryForm.name.$error.unique}\"><ui-select ng-model=vm.beneficiary.company ng-required=true name=company search-enabled=\"vm.companies.length >= $root.controlSettings.OPTION_DEFAULT_LENGTH\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"company in (vm.companies | filter: $select.search )\"><span ng-bind-html=\"company.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\">Бенефициар с таким именем у этой компании уже существует</div><label class=form-control-label>Компания</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div class=clearfix style=\"margin-top: 5px\"><div class=\"form-group col-xs-6\"><input float-input float-fixed=1 float-step=0.1 max-after-comma=3 max-int-length=3 currency-input non-currency-uom=true currency-icon=% type=text id=share_in_perc max-val=100 class=\"form-control currency-input\" ng-if=!vm.mode.isView ng-model=vm.beneficiary.share_in_perc><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message max-mess\">Максмальное значение 100%</div><label for=share_in_perc class=form-control-label>Доля в процентах</label><div ng-if=vm.mode.isView class=view-entity-control style=\"height: 48px\"> {{vm.beneficiary.share_in_perc ? (vm.beneficiary.share_in_perc | parseNumber) : \'-\'}} <span>{{vm.beneficiary.share_in_perc ? \'%\' : \'\'}}</span></div></div><contact-info contact-info=vm.beneficiary.contact_info min-details-required=3></contact-info></div></div></section></fieldset><div class=\"section bottom-buttons col-xs-12\"><form-errors form-ctrl=vm.beneficiaryForm can-show=vm.isSetDirty></form-errors><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"(vm.isSetDirty && !vm.beneficiaryForm.$valid) || vm.isHasValidErrors(vm.beneficiaryForm.$error)\"></form-buttons></div></form></div>");
$templateCache.put("app/settings/beneficiary/crud/beneficiary.html","<ul class=\"breadcrumbs main-left-offset\" ng-switch=$state.params.parent><li><a ui-sref=business>Структура бизнеса</a></li><li><a ui-sref=\"beneficiaries({parent: \'business\'})\">Бенефициары</a></li></ul><div ui-view></div>");
$templateCache.put("app/settings/business/sections/addCashier.html","<div class=\"gray-bg clearfix\"><form novalidate name=vm.addCashier class=add-cashier-form><div class=row><div class=\"form-group col-xs-6 major-font\" style=\"font-size: 12px;line-height: 1.29;     padding-right: 0; margin-bottom: 0;\">Вы можете быстро добавить в компанию нового кассира.<br>ВНИМАНИЕ! По завершению регистрации вам необходимо лично сообщить пароль кассиру.</div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': vm.addCashier.name.$invalid && vm.addCashier.name.$error.unique}\"><input type=password style=display:none> <input hard-pruning type=text name=surname id=surname class=form-control maxlength=50 ng-model=vm.cashier.surname data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]*\" required ng-blur=\"vm.uniqueCheck(vm.cashier.surname, $event)\" ng-keyup=\"vm.addCashier.surname.$setValidity(\'unique\', true)\"><label for=name class=form-control-label>Фамилия</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Сотрудник с таким ФИО уже существует</div><span class=req></span></div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': vm.addCashier.name.$invalid && vm.addCashier.name.$error.unique}\"><input type=password style=display:none> <input hard-pruning type=text name=name id=name class=form-control maxlength=50 ng-model=vm.cashier.name data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]*\" required ng-blur=\"vm.uniqueCheck(vm.cashier.name, $event)\" ng-keyup=\"vm.addCashier.name.$setValidity(\'unique\', true)\"><label for=name class=form-control-label>Имя</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Сотрудник с таким ФИО уже существует</div><span class=req></span></div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': vm.addCashier.name.$invalid && vm.addCashier.name.$error.unique}\"><input type=password style=display:none> <input hard-pruning type=text name=patronymic id=patronymic class=form-control maxlength=50 ng-model=vm.cashier.patronymic data-check=\"[\\sA-Za-zА-Яа-яёЁ\'` -]*\" ng-blur=\"vm.uniqueCheck(vm.cashier.patronymic, $event)\" ng-keyup=\"vm.addCashier.patronymic.$setValidity(\'unique\', true)\"><label for=name class=form-control-label>Отчество</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Сотрудник с таким ФИО уже существует</div></div><div class=\"form-group col-xs-6\"><ui-select ng-model=vm.cashierCompany ng-required=true name=company search-enabled=\"vm.companiesListTotal >= $root.controlSettings.OPTION_DEFAULT_LENGTH\" on-select=vm.addDivision($item) ng-class=\"{\'autocomplete-select\': vm.searchTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.refreshCompanies($select.search) repeat=\"company in (vm.companiesList | filter: $select.search | limitTo:$root.controlSettings.OPTION_DEFAULT_LENGTH) track by company.id\" group-by=vm.totalStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"company.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Компания</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group form-group--color col-xs-6\"><ui-select ng-model=vm.cashierDivision ng-required=true name=division search-enabled=\"vm.divisionsListTotal >= $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-disabled=\"!vm.divisionsList || !vm.divisionsList.length\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.refreshDivisions(vm.cashierCompany.id) repeat=\"division.id as division in (vm.divisionsList | filter: $select.search) track by division.id\"><span ng-bind-html=\"division.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Подразделение</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input empty-to-null hard-pruning data-check=([0-9_]) pattern=^(\\d{12})$ type=text inn-check maxlength=12 class=form-control inn-type=fiz ui-mask=999999999999 name=inn id=inn ng-model=vm.cashier.inn ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=inn class=form-control-label>ИНН кассира</label><span class=\"valid-message wrong-format-mess text-lowercase\">ИНН должен содержать 12 цифр</span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=vm.addCashier.inn.$error.validInn>Такой номер не существует</span></div><div class=\"form-group col-xs-6 hidden-password-form-group\"><div class=hidden-password-wrapper><input maxlength=30 id=cashPassword1 name=password ng-show=showpassword required type=text ng-model=vm.cashier.password class=form-control ng-class=\"(vm.passNoMatch)? \'passNoMatch\' : \'\'\" autocomplete=new-password> <input maxlength=30 id=cashPassword2 name=cashPassword ng-hide=showpassword required type=password ng-model=vm.cashier.password ng-class=\"(vm.passNoMatch)? \'passNoMatch\' : \'\'\" ng-keyup=vm.checkPassword() class=form-control title=\"Заполните это поле\" autocomplete=new-password><label for=cashPassword1 class=\"form-control-label small-offset\">Пароль</label><div class=\"valid-message required-mess\" style=\"width: 100%;\">Поле является обязательным</div><label class=\"showpassword tooltip-light\" ng-class=\"(showpassword)? \'open\' : \'\'\" tooltip-placement=bottom-left uib-tooltip=\"{{(showpassword)? \'Скрыть пароль\' : \'Показать пароль\'}}\" ng-click=\"showpassword = !showpassword;\"></label><span class=req style=\"right: -12px;\"></span></div></div><div class=\"form-group col-xs-6\"><div class=phone-input-wrapper><input id=tel name=phone class=form-control maxlength=15 ng-pattern=\"/^\\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/\" phone-input required ng-change=\"vm.resetPhone();vm.uniqueCheck(vm.cashier.phone, null, \'phone\')\" ng-model=vm.cashier.phone><label for=tel class=\"form-control-label phone-control-label always-top\" style=\"padding-left: 0; left: 10px;\">Телефон</label><span class=\"field-status tip-top\" ng-bind=\"(!vm.addCashier.phone.$dirty)? (vm.isPhoneConfirmed())? \'Телефон подтвержден\' : \'Телефон не подтвержден\' : \'\'\"></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess small-offset\" style=\"width: 100%;\">Поле является обязательным</div><div class=\"valid-message confirm-error-mess small-offset\">Необходимо подтвердить номер</div><div class=\"valid-message invalid-unique-mess small-offset\">Сотрудник с таким телефоном уже существует</div><div class=\"valid-message phone-attempts-mess small-offset\">Номер телефона не подтвержден</div></div><div class=status-control><span class=\"glyphicon glyphicon-ok confirm-field-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Телефон подтвержден\" ng-if=vm.isPhoneConfirmed()></span> <span class=no-confirm-field-ico tooltip-placement=bottom-left uib-tooltip=\"Телефон не подтвержден\" ng-if=!vm.isPhoneConfirmed()></span></div><span class=req></span></div><div class=\"form-group col-xs-2\" style=\"padding-right: 0\" ng-if=\"vm.cashier.phone &&\n             !vm.addCashier.phone.$error.unique &&\n             !vm.pendingPhoneCheck &&\n             !vm.addCashier.phone.$error.unique &&\n             (!vm.isPhoneConfirmed() || vm.cashier.pending_phone_changes)\"><div ng-if=\"!vm.phoneConfirmSended && !vm.cashier.pending_phone_changes\"><a href=\"\" ng-click=vm.sendPhoneConfirmRequest()>Подтвердить номер</a></div><div ng-if=\"vm.phoneConfirmSended || vm.cashier.pending_phone_changes\"><input class=form-control name=confirmCode id=confirm required maxlength=4 ng-model=vm.confirmCode ng-keypress=\"$event.keyCode == 13 && vm.checkPhoneConfirmCode() && $event.stopPropagation()\"><label for=confirm class=form-control-label>Код из СМС</label><div class=\"valid-message required-mess\" style=\"min-width: 120px;\">Поле является обязательным</div><div class=\"valid-message confirm-error-mess\" style=\"min-width: 175px;\">Введен неверный код. Осталось попыток: {{vm.phoneAttempts}}</div><span class=req style=\"right: -12px;\"></span></div></div><div class=\"col-xs-2 no-padding-right\" ng-if=!vm.addCashier.phone.$error.unique><label ng-if=\"vm.phoneConfirmSended || vm.cashier.pending_phone_changes\" style=\"padding-top: 12px;\"><a class=break-word href=\"\" ng-click=\"vm.checkPhoneConfirmCode() && $event.stopPropagation()\">Подтвердить</a></label></div><div class=\"col-xs-2 no-padding-right resend-with-timer\" ng-class=\"{\'disabled-link\': !vm.isTimerEnd}\" ng-if=\"!vm.addCashier.phone.$error.unique && (vm.phoneConfirmSended || vm.cashier.pending_phone_changes)\"><label><a href=\"\" ng-click=vm.sendPhoneConfirmRequest(true) class=break-word>Отправить повторно</a></label><div class=timer-wrapper><timer start=vm.startTimer duration=61 is-end=vm.isTimerEnd></timer></div></div></div><button type=button class=\"btn btn-primary pull-right\" ng-click=\"(vm.addCashier.$valid && !vm.passNoMatch) ? vm.addEmployee() : vm.setDirty()\" ng-disabled=\"vm.isSetDirty && (!vm.addCashier.$valid || vm.passNoMatch)\" style=\"margin-right: 20px;\">Создать</button></form></div>");
$templateCache.put("app/settings/business/sections/bar.html","<div class=\"panel panel-default\" ng-class=\"{\'slide-up\': vm.hideComp}\" style=\"max-height: 138px\"><div class=panel-heading ng-if=\"$root.hasRole(\'company.read\')\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" ng-click=\"vm.hideComp = !vm.hideComp\" tooltip-placement=bottom-left uib-tooltip=\"{{(!vm.hideComp)? \'Свернуть список действий\' : \'Показать список действий\'}}\"></span> <a ui-sref=\"companies({parent:\'business\'})\" class=panel-title>Компании</a></div><ul class=panel-body ng-if=\"$root.hasRole(\'company.write\')\"><li><a ui-sref=\"company.new({type: \'LEGAL_ENTITY\', parent:\'business\'})\">Добавить компанию</a></li></ul></div><div ng-if=\"$root.hasRole(\'division.read\')\" class=\"panel panel-default\" ng-class=\"{\'slide-up\': vm.hideDiv}\" style=\"max-height: 138px\"><div class=panel-heading><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" ng-click=\"vm.hideDiv = !vm.hideDiv\" tooltip-placement=bottom-left uib-tooltip=\"{{(!vm.hideDiv)? \'Свернуть список действий\' : \'Показать список действий\'}}\"></span> <a ui-sref=\"divisions({parent:\'business\'})\" class=panel-title>Подразделения</a></div><ul class=panel-body ng-if=\"$root.hasRole(\'division.write\')\"><li><a ui-sref=\"division.new({type: \'SHOP\', parent:\'business\'})\">Добавить подразделение</a></li></ul></div>");
$templateCache.put("app/settings/business/sections/companyInfo.html","<div style=\"height: 267px;\" class=majorfont><ul uib-carousel active=0><li uib-slide ng-repeat=\"company in vm.companies track by $index\" index=$index><div class=company-info-wrap><a ng-if=\"$root.hasRole(\'company.read\')\" ui-sref=\"company.view({companyId: company.id, parent:\'business\'})\" class=company-name ng-bind=company.name></a> <span class=company-data ng-if=company.organization.legal_requisites.ogrn ng-bind=\"\'ОГРН: \' + company.organization.legal_requisites.ogrn\"></span> <span class=company-data ng-if=company.organization.legal_requisites.inn ng-bind=\"\'ИНН: \' + company.organization.legal_requisites.inn\"></span></div><div class=divisions-wrap><div class=\"divisions-type clearfix\" ng-if=company.divisions[0].length><span class=\"divisions-title office\">Офисы</span><div class=divisions-content><span ng-repeat=\"division in company.divisions[0]\" ng-hide=\"$index > 3\"><span ng-hide=\"$index == 0\" class=coma>,</span> <span class=division-name ng-class=\"(division.cash_registers.length)? \'has-cash\':\'\'\" title=\"{{division.address.address_as_string}}\"><a ui-sref=\"division.edit({divisionId: division.id, companyId: company.id, parent:\'business\'})\" ng-bind=division.name></a> </span></span><span class=inc ng-show=\"company.divisions[0].length > 3\">и др.</span></div></div><div class=\"divisions-type clearfix\" ng-if=company.divisions[1].length><span class=\"divisions-title shop\">Магазины</span><div class=divisions-content><span ng-repeat=\"division in company.divisions[1]\" ng-hide=\"$index > 3\"><span ng-hide=\"$index == 0\" class=coma>,</span> <span class=division-name ng-class=\"(division.cash_registers.length)? \'has-cash\':\'\'\" title=\"{{division.address.address_as_string}}\"><a ui-sref=\"division.edit({divisionId: division.id, companyId: company.id, parent:\'business\'})\" ng-bind=division.name></a> </span></span><span class=inc ng-show=\"company.divisions[1].length > 3\">и др.</span></div></div><div class=\"divisions-type clearfix\" ng-if=company.divisions[2].length><span class=\"divisions-title storehouse\">Склады</span><div class=divisions-content><span ng-repeat=\"division in company.divisions[2]\" ng-hide=\"$index > 3\"><span ng-hide=\"$index == 0\" class=coma>,</span> <span class=division-name ng-class=\"(division.cash_registers.length)? \'has-cash\':\'\'\" title=\"{{division.address.address_as_string}}\"><a ui-sref=\"division.edit({divisionId: division.id, companyId: company.id, parent:\'business\'})\" ng-bind=division.name></a> </span></span><span class=inc ng-show=\"company.divisions[2].length > 3\">и др.</span></div></div><div class=\"divisions-type col-md-12\" ng-if=!company.divisionTypeCount><span class=divisions-title></span><div class=divisions-content>Подразделений нет</div></div></div></li></ul></div><div class=table-footer ng-if=\"vm.paging.total > 15\"><paging-customizable page-info=vm.paging callback=vm.getCompanies paging=vm.gridPaging></paging-customizable></div>");
$templateCache.put("app/settings/business/sections/employeesInfo.html","<a ui-sref=\"employees({parent:\'business\'})\"><span class=\"employee-count major-font\"><span class=\"user-icon tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Открыть справочник сотрудников\"></span><!-- <div class=\"tooltip\">\n			<span class=\"tooltip-inner\">Открыть справочник сотрудников</span>\n		</div> --> {{vm.employeesTotal}} <span class=user-label ng-bind=\"(vm.declension)? \'человек\' : \'человека\'\"></span> </span></a><a ui-sref=\"employee.new({parent:\'business\'})\" ng-if=\"$root.hasRole(\'user.write\')\" class=\"btn btn-primary\" style=\"margin-right: 12px;\"><span class=\"btn-ico btn-plus\"></span>Сотрудник</a>");
$templateCache.put("app/settings/business/sections/reports.html","<div class=\"container report-wrapper\"><h3>Отчеты</h3><ul class=report-list><li class=col-md-3><a href=\"\">Сводная структура бизнеса</a></li><li class=col-md-3><a href=\"\">Полный спискок ККМ</a></li><li class=col-md-3><a href=\"\">Роли и доступы сотрудников</a></li><li class=col-md-3><a href=\"\" class=new-report>Создать собственный отчет</a></li></ul></div>");
$templateCache.put("app/settings/cashbox-encashments/crud/cashbox-encashment-crud.html","<div class=\"main-left-offset main-right-offset\"><modal-load show-main-modal=ctrl.loadedData status=ctrl.loadingData success=ctrl.success fail=ctrl.fail></modal-load></div><div class=\"settings-crud crud-entity main-left-offset main-right-offset view-entity clearfix full-width\" ng-if=ctrl.loadedData><h1><span class=\"light-custom-tip-wrap doc-status-icon\" ng-class=\"{\n    \'on-disabled\': ctrl.encashment.status == \'PROCESSED\',\n    \'wait\': ctrl.encashment.status == \'IN_PROCESS\' || ctrl.encashment.status == \'IN_ROLLBACK\',\n    \'off-disabled\': ctrl.encashment.status == \'DRAFT\'}\"><div class=light-custom-tip style=\"margin-top: 30px; margin-left: 20px;\">Статус: <span ng-if=\"ctrl.encashment.status == \'PROCESSED\'\">Проведен</span> <span ng-if=\"ctrl.encashment.status == \'DRAFT\'\">Черновик</span> <span ng-if=\"ctrl.encashment.status == \'IN_PROCESS\' || ctrl.encashment.status == \'IN_ROLLBACK\'\">В обработке</span></div></span>Выемка №{{ctrl.encashment.number}} от <span class=text-lowercase>{{ctrl.getFormattedDate(ctrl.encashment.date, false)}}</span></h1><div class=\"col-xs-9 section top-buttons no-padding\"><span class=\"btn back-link btn-ico-wrap\" ng-click=ctrl.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</span></div><div class=clear></div><entity-view-card fields=ctrl.fields></entity-view-card><entity-view-lower-table ng-if=ctrl.sumTable data=ctrl.sumTable></entity-view-lower-table></div>");
$templateCache.put("app/settings/cashbox-replenishments/crud/cashbox-replenishments-crud.html","<div class=\"main-left-offset main-right-offset\"><modal-load show-main-modal=ctrl.loadedData status=ctrl.loadingData success=ctrl.success fail=ctrl.fail></modal-load></div><div class=\"settings-crud crud-entity main-left-offset main-right-offset view-entity clearfix full-width\" ng-if=ctrl.loadedData><h1><span class=\"light-custom-tip-wrap doc-status-icon\" ng-class=\"{\n    \'on-disabled\': ctrl.replenishment.status == \'PROCESSED\',\n    \'wait\': ctrl.replenishment.status == \'IN_PROCESS\' || ctrl.replenishment.status == \'IN_ROLLBACK\',\n    \'off-disabled\': ctrl.replenishment.status == \'DRAFT\'}\"><div class=light-custom-tip style=\"margin-top: 30px; margin-left: 20px;\">Статус: <span ng-if=\"ctrl.replenishment.status == \'PROCESSED\'\">Проведен</span> <span ng-if=\"ctrl.replenishment.status == \'DRAFT\'\">Черновик</span> <span ng-if=\"ctrl.replenishment.status == \'IN_PROCESS\' || ctrl.replenishment.status == \'IN_ROLLBACK\'\">В обработке</span></div></span>Внесение №{{ctrl.replenishment.number}} от <span class=text-lowercase>{{ctrl.getFormattedDate(ctrl.replenishment.shift_date, false)}}</span></h1><div class=\"col-xs-9 section top-buttons no-padding\"><span class=\"btn back-link btn-ico-wrap\" ng-click=ctrl.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</span></div><div class=clear></div><entity-view-card fields=ctrl.fields></entity-view-card><entity-view-lower-table ng-if=ctrl.sumTable data=ctrl.sumTable></entity-view-lower-table></div>");
$templateCache.put("app/settings/cashregister-receipts/crud/cashregister-receipt-crud.html","<div class=\"main-left-offset main-right-offset\"><modal-load show-main-modal=ctrl.loadedData status=ctrl.loadingData success=ctrl.success fail=ctrl.fail></modal-load></div><div class=\"settings-crud crud-entity main-left-offset main-right-offset view-entity clearfix full-width\" ng-if=ctrl.loadedData><h1><span class=\"light-custom-tip-wrap doc-status-icon\" ng-class=\"{\n    \'on-disabled\': ctrl.cashRegisterReceipt.status == \'PROCESSED\',\n    \'wait\': ctrl.cashRegisterReceipt.status == \'IN_PROCESS\' || ctrl.cashRegisterReceipt.status == \'IN_ROLLBACK\',\n    \'off-disabled\': ctrl.cashRegisterReceipt.status == \'DRAFT\'}\"><div class=light-custom-tip style=\"margin-top: 30px; margin-left: 20px;\">Статус: <span ng-if=\"ctrl.cashRegisterReceipt.status == \'PROCESSED\'\">Проведен</span> <span ng-if=\"ctrl.cashRegisterReceipt.status == \'DRAFT\'\">Черновик</span> <span ng-if=\"ctrl.cashRegisterReceipt.status == \'IN_PROCESS\' || ctrl.cashRegisterReceipt.status == \'IN_ROLLBACK\'\">В обработке</span></div></span>Кассовый чек №{{ctrl.cashRegisterReceipt.number}} от <span class=text-lowercase>{{ctrl.getFormattedDate(ctrl.cashRegisterReceipt.shift_date, false)}}</span></h1><div class=\"col-xs-9 section top-buttons no-padding\"><span class=\"btn back-link btn-ico-wrap\" ng-click=ctrl.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</span></div><div class=clear></div><entity-view-card fields=ctrl.fields></entity-view-card><entity-view-lower-table ng-if=ctrl.sumTable data=ctrl.sumTable></entity-view-lower-table></div><grid-wide class=\"grid-wide no-selection-style\" ng-if=ctrl.loadedData url=ctrl.url page=ctrl.page header=ctrl.header filters-required=false row-route=null is-sku=true sort=ctrl.sort limit=ctrl.limit currency=ctrl.currency column-defs=ctrl.columnDefs using-service=ctrl.usingService config=::ctrl.gridConfig need-add-to-cart=true></grid-wide>");
$templateCache.put("app/settings/cashregistes-shifts/crud/cashregister-shift-crud.html","<div class=\"main-left-offset main-right-offset\"><modal-load show-main-modal=ctrl.loadedData status=ctrl.loadingData success=ctrl.success fail=ctrl.fail></modal-load></div><div class=\"settings-crud crud-entity main-left-offset main-right-offset view-entity clearfix full-width\" ng-if=ctrl.loadedData><h1>Смена №{{ctrl.cashRegisterShift.number}} от <span class=text-lowercase>{{ctrl.getFormattedDate(ctrl.cashRegisterShift.start_date)}}</span></h1><div class=\"col-xs-9 section top-buttons no-padding\"><span class=\"btn back-link btn-ico-wrap\" ng-click=ctrl.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</span><div class=\"doc-settings-block pull-right\"><button type=button class=btn data-toggle=dropdown>Отчет о продажах <span class=caret style=\"display: inherit;\"></span></button><ul class=\"dropdown-menu pull-right\" role=menu><li><a href ng-click=\"ctrl.salesTotalRepo(\'PDF\');\">В формате PDF</a></li><li><a href ng-click=\"ctrl.salesTotalRepo(\'XLS\');\">В формате XLS</a></li></ul></div></div><div class=clear></div><entity-view-card fields=ctrl.fields></entity-view-card><entity-view-lower-table ng-if=ctrl.sumTable header-items=ctrl.sumTable.headerItems data=ctrl.sumTable.data></entity-view-lower-table></div><grid-wide class=\"grid-wide no-selection-style\" ng-if=ctrl.loadedData url=ctrl.url page=ctrl.page header=ctrl.header filters-required=false row-route=ctrl.rowRoute is-sku=true sort=ctrl.sort limit=ctrl.limit currency=ctrl.currency column-defs=ctrl.columnDefs using-service=ctrl.usingService config=::ctrl.gridConfig need-add-to-cart=true></grid-wide>");
$templateCache.put("app/settings/companies/crudCompanies/companies-crud.html","<div class=\"crud-entity main-left-offset main-right-offset\" ng-class=\"(vm.mode.isView)? \'view-entity\': \'\'\"><div ng-if=vm.mode.isNew><h1>Добавление новой компании</h1></div><div ng-if=vm.mode.isEdit><h1>Редактирование компании<entity-history entity-data=vm.company></entity-history></h1></div><div ng-if=vm.mode.isView><h1>Информация о компании<entity-history entity-data=vm.company></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-if=!vm.mode.isNew><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"(vm.isSetDirty && !addOrg.$valid) || vm.isHasValidErrors(addOrg.$error)\"></form-buttons></div><div class=clear></div><form role=form name=addOrg novalidate ng-class=vm.company.requisite.legal_status class=\"crud-main-column col-xs-9\"><fieldset ng-disabled=vm.mode.isView><!-- Выбор типа компании --><div ng-include=\"\'app/settings/companies/crudCompanies/sections/type-company.html\'\" class=\"clearfix full-width\"></div><div class=for-small-width ng-if=vm.mode.isView><div class=\"radio-group edit-radio-group checked\" ng-class=\"{\'fade-out\': vm.hideMainInfo}\"><label class=\"radio-label legal_entity\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'LEGAL_ENTITY\'\"><span class=radio-label-name>Юридическое лицо</span> <span class=shad></span></label><label class=\"radio-label sole_trader\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'SOLE_TRADER\'\"><span class=radio-label-name>Индивидуальный предприниматель</span> <span class=shad></span></label><label class=\"radio-label person\" ng-if=\"vm.company.counterparty_type == \'PERSON\'\"><span class=radio-label-name>Физическое лицо</span> <span class=shad></span></label></div></div><div class=clear></div><!-- Основная информация о компании --><info-company address-controls=vm.addressOptions state-name=\"{{vm.state.current.name}}\" company=vm.company show-names=true unique-callback=vm.uniqueCheck class=\"clearfix full-width\"></info-company><!-- division box --><div ng-if=vm.mode.isView class=\"clearfix full-width\"><section class=\"form-group tab-form-group division-tabs mini-grid-wrapper col-xs-12\"><uib-tabset><uib-tab ng-repeat=\"tab in vm.divisionsTabs track by $index\"><uib-tab-heading class=tab-heading><span class=tab-title ng-class=tab.className>{{tab.title}}</span><div class=badge ng-if=\"error.items && (error.items.index == key)\">{{error.items.count}}</div></uib-tab-heading><div><division-tab-company tab=tab divisions=vm.company.divisions company-id=vm.company.id></division-tab-company></div></uib-tab></uib-tabset></section></div><!-- Информация о партнере --><section class=\"clearfix full-width\" ng-if=$root.partner ng-hide=\"vm.mode.isView && !vm.company.code\"><h5 class=section-header>Информация о партнере</h5><div class=\"form-group col-xs-6 row\"><input name=code ng-model=vm.company.code type=text class=form-control maxlength=32 ng-show=!vm.mode.isView ng-blur=vm.uniqueCheckCode(vm.company.code) ng-keyup=\"addOrg.code.$setValidity(\'unique\', true); addOrg.code.$setValidity(\'used\', true)\"><label class=form-control-label>Код партнера</label><div ng-show=vm.mode.isView ng-bind=\"vm.company.code || \'-\'\" class=view-entity-control></div><div class=\"valid-message isset-name\">Код партнера уже существует</div><div class=\"valid-message used\">Невозможно удалить код партнера, по котору были начисления бонусов</div></div></section><!-- Сисиема налогообложения --><div ng-include=\"\'app/settings/companies/crudCompanies/sections/tax-system.html\'\" class=\"clearfix full-width\"></div><!-- Юридические реквизиты --><requisites-company state-name=\"{{vm.state.current.name}}\" company=vm.company class=\"clearfix full-width\" mode=vm.mode ng-hide=\" vm.mode.isView && !vm.company.organization.legal_requisites.full_name && \n                                  !vm.company.organization.legal_requisites.inn && \n                                  !vm.company.organization.legal_requisites.kpp && \n                                  !vm.company.organization.legal_requisites.legal_address && \n                                  !vm.company.organization.legal_requisites.ogrn && \n                                  !vm.company.organization.legal_requisites.okpo && \n                                  !vm.company.organization.legal_requisites.okved && \n                                  !vm.company.organization.legal_requisites.okved_name && \n                                  !vm.company.organization.legal_requisites.registration_date && \n                                  !vm.company.organization.legal_requisites.registration_number && \n                                  !vm.company.organization.legal_requisites.short_name\"></requisites-company><!-- Основные лица --><persons-company state-name=\"{{vm.state.current.name}}\" company=vm.company class=\"clearfix full-width\" mode=vm.mode ng-hide=\"vm.mode.isView && !vm.company.organization.chief_name && !vm.company.organization.chief_person && !vm.company.organization.chief_accountant_person && !vm.company.organization.chief_accountant_name\"></persons-company><!-- расчетный счет --><account-company state-name=\"{{vm.state.current.name}}\" company=vm.company class=\"clearfix full-width\" mode=vm.mode></account-company></fieldset><div class=\"full-width clearfix\"><section class=\"form-group col-xs-12 hide-fields\" ng-if=\"vm.mode.isEdit || vm.mode.isNew || (vm.mode.isView && vm.company.comment)\" ng-init=\"(vm.company.comment)?vm.addComment=true:\'\'\" ng-class=\"{\'same-padding\': !vm.addComment}\"><div class=add-item-wrap ng-click=\"vm.addComment = !vm.addComment\" ng-if=!vm.mode.isView><span class=add-item-icon></span> <span class=add-item-title>Комментарий о компании</span></div><div ng-if=!vm.mode.isView class=added-item-wrap><div class=\"danger-close tooltip-light\" ng-click=\"vm.addComment = !vm.addComment; vm.company.comment = undefined;\" tooltip-placement=bottom-left uib-tooltip=Удалить></div><h5 class=section-header>Комментарий о компании</h5><div class=\"form-group row col-xs-12\" style=\"padding-right: 0; margin-bottom: 0;\"><textarea empty-to-null class=form-control rows=3 id=comment ng-model=vm.company.comment></textarea><label for=comment class=form-control-label>Комментарий о компании</label></div></div><div class=view-comment ng-if=\"vm.mode.isView && vm.company.comment\"><h5 class=section-header>Комментарий о договоре</h5> {{vm.company.comment}} </div></section></div><div class=\"col-xs-12 section bottom-buttons\"><form-errors form-ctrl=addOrg can-show=vm.isSetDirty></form-errors><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"(vm.isSetDirty && !addOrg.$valid) || vm.isHasValidErrors(addOrg.$error)\"></form-buttons></div></form><div class=\"col-xs-3 section-helper\" style=\"max-width: 450px;\"><div ng-if=vm.mode.isView><div class=\"radio-group edit-radio-group checked\" ng-class=\"{\'fade-out\': vm.hideMainInfo}\"><label class=\"radio-label legal_entity\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'LEGAL_ENTITY\'\">Юридическое лицо <span class=shad></span></label><label class=\"radio-label sole_trader\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'SOLE_TRADER\'\">Индивидуальный предприниматель <span class=shad></span></label><label class=\"radio-label person\" ng-if=\"vm.company.counterparty_type == \'PERSON\'\">Физическое лицо <span class=shad></span></label></div></div><div ng-if=vm.mode.isView><widget-container widgets=vm.widget></widget-container></div></div></div>");
$templateCache.put("app/settings/components/address/address.html","<div class=\"form-group address-field dropdown btn-group\" ng-class=\"[vm.statusClass, vm.mode]\"><textarea empty-to-null msd-elastic maxlength=255 autocomplete=off ng-if=\"!vm.mode || vm.mode == \'textarea\'\" id=\"{{vm.name}}\" name=\"{{vm.name}}\" ng-required=\"{{vm.ngRequired}}\" style=\"height: 74px;\" class=\"dropdown-toggle form-control\" data-toggle=dropdown ng-model=vm.addressData.address_as_string ng-blur=vm.checkAddr(vm.addressData.address_as_string) ng-class=\"(vm.statusClass == \'error\')? \'ng-invalid\' : \'\'\" ng-change=vm.getTip(vm.addressData.address_as_string); ng-keyup=\"vm.addressData.accepted = false; vm.keyEvent($event);\">\n    </textarea><input empty-to-null type=text maxlength=255 autocomplete=off ng-if=\"vm.mode == \'input\'\" id=\"{{vm.name}}\" name=\"{{vm.name}}\" ng-required=\"{{vm.ngRequired}}\" class=\"dropdown-toggle form-control input-address\" data-toggle=dropdown ng-model=vm.addressData.address_as_string ng-blur=vm.checkAddr(vm.addressData.address_as_string) ng-class=\"(vm.statusClass == \'error\')? \'ng-invalid\' : \'\'\" ng-change=vm.getTip(vm.addressData.address_as_string) ng-keyup=\"vm.addressData.accepted = false; vm.keyEvent($event);\"><label for=\"{{vm.name}}\" class=form-control-label ng-bind=vm.fieldLabel></label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=message-status>{{vm.statusMessage}}</div><a class=\"adress-btn tooltip-light\" ng-click=\"(vm.statusClass != \'success\')? vm.openPopupAddress() : \'\';\" tooltip-placement=bottom-left uib-tooltip=\"Расширенная информация об адресе\"></a><ul class=dropdown-menu ng-show=vm.areaTip.length><li ng-repeat=\"str in vm.areaTip track by $index\" ng-mousedown=vm.choiseTip(str)><a href=javascript:void(0) ng-bind-html=\"str | highlight: vm.addressData.address_as_string\"></a></li></ul><span class=req ng-if=vm.ngRequired></span></div>");
$templateCache.put("app/settings/components/formButtons/formButtons.html","<div class=\"clearfix edit-view-buttons row\"><div ng-if=$ctrl.viewType.isNew><button ng-if=\"$ctrl.noActionCheck || $root.hasAnyRoleEditButton()\" class=\"btn right-button btn-primary\" ng-click=\"$ctrl.actionDecorator({status:\'save\'})\" ng-disabled=$ctrl.canDisabled>Создать</button> <button ng-click=\"$ctrl.actionDecorator({status:\'return\'})\" class=\"btn right-button\">Отменить</button></div><div ng-if=$ctrl.viewType.isEdit><button ng-if=\"$ctrl.noActionCheck || $root.hasAnyRoleEditButton()\" class=\"btn btn-ico-wrap delete\" ng-disabled=$ctrl.crudState.loading ng-click=\"$ctrl.actionDecorator({status:\'delete\'})\" ng-hide=$ctrl.hideDelete><span class=\"btn-ico glyphicon glyphicon-trash\"></span> Удалить</button> <button ng-if=\"$ctrl.noActionCheck || $root.hasAnyRoleEditButton()\" ng-click=\"$ctrl.actionDecorator({status:\'save\'})\" class=\"btn btn-primary right-button\" ng-show=!$ctrl.formPristine ng-disabled=\"$ctrl.crudState.loading || $ctrl.canDisabled\">Сохранить</button> <button ng-click=\"$ctrl.actionDecorator({status:\'return\'})\" ng-show=!$ctrl.formPristine class=\"btn right-button\">Отменить</button></div><div ng-if=$ctrl.viewType.isView><button class=\"btn back-link btn-ico-wrap\" ng-disabled=$ctrl.crudState.loading ng-click=\"$ctrl.actionDecorator({status:\'return\'})\"><span class=\"btn-ico btn-arrow\"></span> Вернуться</button> <button ng-if=\"$ctrl.noActionCheck || $root.hasAnyRoleEditButton()\" ng-disabled=$ctrl.crudState.loading ng-click=\"$ctrl.actionDecorator({status:\'edit\'})\" class=\"btn btn-primary btn-edit right-button\">Редактировать</button> <button ng-if=$ctrl.isSmsButton class=\"btn right-button\" ng-disabled=$ctrl.crudState.loading uib-tooltip=\"Отправить пароль для предоставления временного доступа к ТОРГОВЛЯ.ОНЛАЙН под учетной записью данного пользователя\" ng-click=$ctrl.sendPassword($ctrl.userPhone)>Отправить пароль</button></div></div>");
$templateCache.put("app/settings/components/formErrors/formErrors.html","<div class=\"form-error row\" ng-class=\"{\'show-form-error\': canShow && insideCanShow}\"><span class=req-inform ng-show=reqError>Поля, помеченные *, обязательные для заполнения </span><span class=req-inform ng-hide=reqError>Некоторые поля заполнены некорректными данными</span></div>");
$templateCache.put("app/settings/components/longText/longText.html","<span class=long-text-wrapper ng-class=\"(vm.isFits)? \'add-button\':\'\'\"><a ng-if=vm.url href=\"{{vm.url}}\">{{vm.text}}</a><span ng-if=!vm.url>{{vm.text}}</span></span><button class=ellipsis-button ng-if=vm.isFits>...</button> <span class=ellipsis-tip>{{vm.text}} </span>");
$templateCache.put("app/settings/components/partnerInfoCard/partner_info_card.html","<div class=row><div class=\"form-group col-xs-12\"><div ng-bind=vm.info.name class=\"h4 ng-binding\" style=\"font-weight: 600;margin-top: 0;\"></div></div><div class=\"form-group col-xs-6\"><label class=form-control-label>Телефон</label><div class=\"view-entity-control ng-binding\" ng-bind=\"vm.info.phone || \'-\'\" ng-click=\"vm.copyText(vm.info.phone, \'Телефон сохранен\');\" title=\"скопировать в буфер обмена\"></div></div><div class=\"form-group col-xs-6\"><label class=form-control-label>Фактический адрес</label><div class=\"view-entity-control ng-binding\" ng-bind=\"vm.info.actual_address || \'-\'\"></div></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0;\"><label class=form-control-label>E-mail</label><div class=\"view-entity-control ng-binding\"><a href=\"mailto:{{vm.info.email}}\" ng-if=vm.info.email ng-bind=vm.info.email ng-click=\"vm.copyText(vm.info.email, \'E-mail сохранен\');\" title=\"скопировать в буфер обмена\"></a> <span ng-if=!vm.info.email>-</span></div></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0;\"><label class=form-control-label>График работы</label><div class=\"view-entity-control ng-binding\" ng-bind=\"vm.info.schedule || \'-\'\"></div></div></div>");
$templateCache.put("app/settings/contracts/crud/contract-crud.html","<div class=\"crud-entity main-left-offset main-right-offset\" ng-class=\"(contractCrudCtrl.mode.isView)? \'view-entity\': \'\'\"><div ng-if=contractCrudCtrl.mode.isEdit><h1 class=main-title>Редактирование договора</h1></div><div ng-if=contractCrudCtrl.mode.isNew><h1 class=main-title>Добавление нового договора<entity-history entity-data=contractCrudCtrl.contract></entity-history></h1></div><div ng-if=contractCrudCtrl.mode.isView><h1 class=main-title>Просмотр договора<entity-history entity-data=contractCrudCtrl.contract></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-if=!contractCrudCtrl.mode.isNew><form-buttons view-type=contractCrudCtrl.mode on-button=contractCrudCtrl.crud(status) can-disabled=\"(contractCrudCtrl.isSetDirty && !contractCrudCtrl.eForm.$valid) || contractCrudCtrl.isHasValidErrors(contractCrudCtrl.eForm.$error)\"></form-buttons></div><div class=clear></div><div class=full-width><form name=contractCrudCtrl.eForm class=\"crud-main-column col-xs-9\"><fieldset ng-disabled=contractCrudCtrl.mode.isView><div ng-include=\"\'app/settings/contracts/crud/sections/main-info.html\'\" class=\"clearfix full-width\"></div><div ng-include=\"\'app/settings/contracts/crud/sections/finance-info.html\'\" class=\"clearfix full-width\"></div><section class=\"form-group col-xs-12 hide-fields\" ng-if=\"contractCrudCtrl.mode.isEdit || contractCrudCtrl.mode.isNew || (contractCrudCtrl.mode.isView && contractCrudCtrl.contract.comment)\" ng-init=\"(contractCrudCtrl.contract.comment)?contractCrudCtrl.addComment=true:\'\'\" ng-class=\"{\'same-padding\': !contractCrudCtrl.addComment}\"><div class=add-item-wrap ng-click=\"contractCrudCtrl.addComment = !contractCrudCtrl.addComment\" ng-if=!contractCrudCtrl.mode.isView><span class=add-item-icon></span> <span class=add-item-title>Комментарий о договоре</span></div><div ng-if=!contractCrudCtrl.mode.isView class=added-item-wrap><div class=\"danger-close tooltip-light\" ng-click=\"contractCrudCtrl.addComment = !contractCrudCtrl.addComment; contractCrudCtrl.contract.comment = undefined;\" tooltip-placement=bottom-left uib-tooltip=Удалить></div><h5 class=section-header>Комментарий о договоре</h5><div class=\"form-group row col-xs-12\" style=\"padding-right: 0; margin-bottom: 0;\"><textarea empty-to-null class=form-control rows=3 id=comment ng-model=contractCrudCtrl.contract.comment></textarea><label for=comment class=form-control-label>Комментарий о договоре</label></div></div><div class=view-comment ng-if=\"contractCrudCtrl.mode.isView && contractCrudCtrl.contract.comment\"><h5 class=section-header>Комментарий о договоре</h5> {{contractCrudCtrl.contract.comment}} </div></section></fieldset></form><div class=\"row col-xs-3 section-helper\" style=\"max-width: 450px;\" ng-if=\"$root.hasRole(\'period_totals.read\')\"><div ng-if=contractCrudCtrl.mode.isView><widget-container widgets=contractCrudCtrl.widget></widget-container></div></div></div><div class=\"section bottom-buttons col-xs-9\"><form-errors form-ctrl=contractCrudCtrl.eForm can-show=contractCrudCtrl.isSetDirty></form-errors><form-buttons view-type=contractCrudCtrl.mode on-button=contractCrudCtrl.crud(status) can-disabled=\"(contractCrudCtrl.isSetDirty && !contractCrudCtrl.eForm.$valid) || contractCrudCtrl.isHasValidErrors(contractCrudCtrl.eForm.$error)\"></form-buttons></div></div>");
$templateCache.put("app/settings/contragents/crudContragent/crudContragent.html","<div class=\"crud-entity main-left-offset main-right-offset\" ng-class=\"(vm.mode.isView)? \'view-entity\': \'\'\"><!-- content of settings --><form class=\"crud-main-column col-xs-9\" ng-submit=vm.submit() role=form name=addContragent ng-class=\"vm.contragent.counterparty_type; { \'has-error\': vm.isSetDirty && !addContragent.$valid}\"><div ng-if=vm.mode.isNew><h1>Добавление нового {{vm.counterpartyName(true)}}</h1></div><div ng-if=vm.mode.isEdit><h1>Редактирование {{vm.counterpartyName(true)}} <entity-history entity-data=vm.contragent></entity-history></h1></div><div ng-if=vm.mode.isView><h1>Информация о {{vm.counterpartyName(true)}} <entity-history entity-data=vm.contragent></entity-history></h1></div><div class=\"section top-buttons col-xs-12\" ng-if=!vm.mode.isNew><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"(vm.isSetDirty && !addContragent.$valid) || vm.isHasValidErrors(addContragent.$error)\"></form-buttons></div><div class=clear></div><fieldset ng-disabled=vm.mode.isView><div ng-if=\"vm.mode.isNew && $root.permission.is_owner\" class=\"clearfix full-width\" ng-include=\"\'app/settings/contragents/crudContragent/sections/autocomplete.html\'\"></div><div ng-if=\"($root.permission.is_owner && vm.contragent.linked_company_organization) || !$root.permission.is_owner || vm.manually || !vm.mode.isNew\"><div class=\"clearfix full-width\"><section class=\"form-group radio-group col-xs-12\" ng-if=vm.mode.isNew><h5 class=section-header>Тип контрагента</h5><input type=radio ng-checked=true name=counterpartyType value=LEGAL_ENTITY id=legal_entity ng-model=vm.contragent.counterparty_type ng-change=\"vm.resetTypes(); vm.uniqueCheck();\"><label class=\"radio-label legal_entity\" for=legal_entity>Юридическое лицо<span class=shad></span></label><input type=radio name=counterpartyType value=SOLE_TRADER id=sole_trader ng-model=vm.contragent.counterparty_type ng-change=\"vm.resetTypes(); vm.uniqueCheck();\"><label class=\"radio-label sole_trader\" for=sole_trader>ИП<span class=shad></span></label><input type=radio name=counterpartyType value=PERSON id=person ng-model=vm.contragent.counterparty_type ng-change=\"vm.resetTypes(); vm.uniqueCheck();\"><label class=\"radio-label person\" for=person>Физическое лицо<span class=shad></span></label></section></div><div class=for-small-width ng-if=!vm.mode.isNew><div class=\"radio-group edit-radio-group checked\"><label class=\"radio-label legal_entity\" ng-if=\"vm.contragent.counterparty_type == \'LEGAL_ENTITY\'\"><span class=radio-label-name>Юридическое лицо</span> <span class=shad></span></label><label class=\"radio-label sole_trader\" ng-if=\"vm.contragent.counterparty_type == \'SOLE_TRADER\'\"><span class=radio-label-name>Индивидуальный предприниматель</span> <span class=shad></span></label><label class=\"radio-label person\" ng-if=\"vm.contragent.counterparty_type == \'PERSON\'\"><span class=radio-label-name>Физическое лицо</span> <span class=shad></span></label></div></div><!-- Основная информация о контрагенте --><info-company state-name=\"{{vm.state.current.name}}\" name=vm.contragent.name company=vm.contragent show-names=true unique-callback=vm.uniqueCheck class=\"clearfix full-width\" address-controls=vm.addressOptions></info-company><!-- <div class=\"radio-group edit-radio-group\" ng-if=\"!vm.mode.isNew\">\n            <label class=\"radio-label\" ng-if=\"vm.contragent.counterparty_type == \'LEGAL_ENTITY\'\">Юридическое лицо</label>\n            <label class=\"radio-label\" ng-if=\"vm.contragent.counterparty_type == \'SOLE_TRADER\'\">Индивидуальный предприниматель</label>\n            <label class=\"radio-label\" ng-if=\"vm.contragent.counterparty_type == \'PERSON\'\">Физическое лицо</label>\n          </div> --><div ng-include=\"\'app/settings/contragents/crudContragent/sections/counterparty-roles.html\'\" class=\"clearfix full-width\"></div><div ng-if=\"vm.contragent.counterparty_type != \'PERSON\'\"><!-- Юридические реквизиты --><div ng-include=\"\'app/settings/contragents/crudContragent/sections/legal-requisites.html\'\" class=\"clearfix full-width\" ng-hide=\" vm.mode.isView && !vm.contragent.organization.legal_requisites.full_name && \n                                    !vm.contragent.organization.legal_requisites.inn && \n                                    !vm.contragent.organization.legal_requisites.kpp && \n                                    !vm.contragent.organization.legal_requisites.legal_address && \n                                    !vm.contragent.organization.legal_requisites.ogrn && \n                                    !vm.contragent.organization.legal_requisites.okpo && \n                                    !vm.contragent.organization.legal_requisites.okved && \n                                    !vm.contragent.organization.legal_requisites.okved_name && \n                                    !vm.contragent.organization.legal_requisites.registration_date && \n                                    !vm.contragent.organization.legal_requisites.registration_number && \n                                    !vm.contragent.organization.legal_requisites.short_name\"></div><!-- Основные лица --><div ng-include=\"\'app/settings/contragents/crudContragent/sections/main-person.html\'\" class=\"clearfix full-width\" ng-hide=\" vm.mode.isView && !vm.contragent.organization.chief_person && !vm.contragent.organization.chief_accountant_person\"></div><!-- расчетный счет --><account-company state-name=\"{{vm.state.current.name}}\" company=vm.contragent class=\"clearfix full-width\"></account-company></div><section class=\"form-group hide-fields col-xs-12\" ng-if=\"vm.mode.isEdit || vm.mode.isNew || (vm.mode.isView && vm.contragent.comment)\" ng-init=\"(vm.contragent.comment)?vm.addComment = true : \'\'\" ng-class=\"{\'same-padding\': !vm.addComment}\"><div class=add-item-wrap ng-click=\"vm.addComment = !vm.addComment\" ng-if=!vm.mode.isView><span class=add-item-icon></span> <span class=add-item-title>Комментарий о {{vm.counterpartyName(true, true)}}</span></div><div ng-if=!vm.mode.isView class=added-item-wrap><div class=\"danger-close tooltip-light\" ng-click=\"vm.addComment = !vm.addComment; vm.contragent.comment = undefined;\" tooltip-placement=bottom-left uib-tooltip=Удалить></div><h5 class=section-header>Комментарий о {{vm.counterpartyName(true, true)}}</h5><div class=\"form-group row col-xs-12\" style=\"padding-right: 0; margin-bottom: 0;\"><textarea empty-to-null class=form-control rows=3 id=comment ng-model=vm.contragent.comment></textarea><label for=comment class=form-control-label>Комментарий о {{vm.counterpartyName(true, true)}}</label></div></div><div class=view-comment ng-if=\"vm.mode.isView && vm.contragent.comment\"><h5 class=section-header>Комментарий о {{vm.counterpartyName(true, true)}}</h5> {{vm.contragent.comment}} </div></section></div></fieldset><div class=\"section bottom-buttons col-xs-12\"><form-errors form-ctrl=addContragent can-show=vm.isSetDirty></form-errors><form-buttons view-type=vm.mode on-button=vm.crud(status) can-disabled=\"(vm.isSetDirty && !addContragent.$valid) || vm.isHasValidErrors(addContragent.$error)\"></form-buttons></div></form><div class=\"col-xs-3 section-helper\" style=\"max-width: 450px;\"><div ng-if=!vm.mode.isNew style=\"margin-top: 127px;\"><div class=\"radio-group edit-radio-group checked\"><label class=\"radio-label legal_entity\" ng-if=\"vm.contragent.counterparty_type == \'LEGAL_ENTITY\'\">Юридическое лицо <span class=shad></span></label><label class=\"radio-label sole_trader\" ng-if=\"vm.contragent.counterparty_type == \'SOLE_TRADER\'\">Индивидуальный предприниматель <span class=shad></span></label><label class=\"radio-label person\" ng-if=\"vm.contragent.counterparty_type == \'PERSON\'\">Физическое лицо <span class=shad></span></label></div></div><div ng-if=vm.mode.isView><widget-container widgets=vm.widget></widget-container></div></div></div>");
$templateCache.put("app/settings/discounts/crudDiscount/crudDiscount.html","<div class=\"crud-entity main-left-offset main-right-offset discounts\" ng-class=\"(vm.mode.isView)? \'view-entity\': \'\'\"><div ng-if=vm.mode.isNew><h1>Добавление скидочной акции</h1></div><div ng-if=vm.mode.isEdit><h1>Редактирование скидочной акции<entity-history entity-data=vm.discount></entity-history></h1></div><div ng-if=vm.mode.isView><h1>Просмотр скидочной акции<entity-history entity-data=vm.discount></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-if=!vm.mode.isNew><form-buttons view-type=vm.mode hide-delete=true on-button=vm.crud(status) can-disabled=\"(vm.isSetDirty && !addDiscount.$valid) || vm.isHasValidErrors(addDiscount.$error)\"></form-buttons></div><div class=clear></div><form ng-submit=vm.submit() role=form name=addDiscount><fieldset ng-disabled=vm.mode.isView><div class=\"clearfix full-width\"><section class=col-xs-9 ng-class=\"{\'slide-up\': vm.hideMainInfo}\" ng-style=\"(vm.mode.isView)? {\'max-height\': \'350px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideMainInfo = !vm.hideMainInfo\" ng-show=vm.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=\"form-group row\"><div id=nameAnchor class=\"form-group col-xs-6\"><input required type=text name=name class=form-control id=discountName maxlength=150 ng-model=vm.discount.name ng-keyup=\"addDiscount.name.$setValidity(\'unique\', true);addDiscount.effective_date.$setValidity(\'unique\', true);\" ng-blur=vm.uniqueCheck()><label for=discountName class=form-control-label>Наименование</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=addDiscount.name.$error ng-if=\"!vm.stateName.endsWith(\'view\')\"><div ng-message=unique class=\"valid-message isset-name\">Акция уже существует</div></div><span class=req></span></div><div class=\"clearfix col-xs-12\"></div><div class=\"radio-box col-xs-6\" style=\"margin-bottom: 15px;\" ng-if=!vm.mode.isView><div class=clearfix><div class=\"radio pull-left\" ng-hide=\"vm.stateName.endsWith(\'view\')\"><label><input type=radio name=is_regular ng-model=vm.discount.mode ng-value=\"\'ACTION\'\" ng-change=\"\" id=sell> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=sell>Акция</label></div></div><div class=\"radio-box col-xs-6\" ng-if=!vm.mode.isView><div class=clearfix><div class=\"radio pull-left\" ng-hide=\"vm.stateName.endsWith(\'view\')\"><label><input type=radio name=is_regular ng-model=vm.discount.mode ng-value=\"\'REGULAR\'\" ng-change=\"\" id=regular> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=regular>Регулярная скидка</label></div></div><div class=form-group ng-if=vm.mode.isView><div class=\"form-group col-xs-12\"><label class=\"form-control-label always-top\">Формат</label><div class=view-entity-control ng-bind=\"(vm.discount.mode === \'REGULAR\')? \'Регулярная скидка\' : ((vm.discount.mode === \'ACTION\')? \'Акция\' : \'-\') \"></div></div></div><div class=\"form-group col-xs-12\"><textarea empty-to-null class=form-control ng-model=vm.discount.description ng-if=!vm.mode.isView maxlength=1000 id=discountComment></textarea><label for=discountComment class=form-control-label>Описание</label><div class=view-entity-control ng-show=vm.mode.isView ng-bind=\"vm.discount.description || \'-\'\" style=\"height: auto;\"></div></div></div></section><div class=\"col-xs-3 section-helper\" ng-hide=vm.mode.isView><div style=\"font-weight: bold;margin-top: 10px;\">ВНИМАНИЕ!</div>Акции суммируются друг с другом и имеют приоритет в применении перед регулярными скидками.<br>Регулярные скидки суммируются друг с другом и применяются только к тем товарам, к которым не были применены акции</div></div><discount-calendar mode=vm.mode discount=vm.discount form-ctrl=addDiscount unique=vm.uniqueCheck class=\"clearfix full-width\"></discount-calendar><discount-parameters mode=vm.mode mode=vm.mode discount=vm.discount parameter=vm.parameter catalog-item-popup=vm.catalogItemPopup catalog-elements-error=vm.paramCatalogElementsError property-types=vm.propertyTypes no-param=vm.noParam class=\"clearfix full-width\"></discount-parameters><discount-belongs mode=vm.mode discount=vm.discount form-ctrl=addDiscount catalog-item-popup=vm.catalogItemPopup catalog-elements-error=vm.discountCatalogElementsError class=discount-belongs parameter-type=vm.parameter.type></discount-belongs></fieldset><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=addDiscount can-show=vm.isSetDirty></form-errors><form-buttons view-type=vm.mode hide-delete=true on-button=vm.crud(status) can-disabled=\"vm.isSetDirty && (!addDiscount.$valid  || vm.discountCatalogElementsError || vm.paramCatalogElementsError || vm.noParam)\"></form-buttons></div></form></div>");
$templateCache.put("app/settings/divisions/crudDivision/cash-register-places.html","<div class=\"modal-content cash-register-places-popup\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>&times;</button><h4 class=modal-title>Кассовые места</h4></div><div class=container><div class=places-wrapper><div class=empty-modal ng-if=\"places.length == 0\"><p>У вас пока не добавлено ни одно кассовое место. Вы можете это сделать, нажав кнопку \"Добавить\"</p><div class=arrow></div></div><span class=places-title ng-if=\"places.length > 0\">Название</span><div class=places-rows ng-scrollbars ng-scrollbars-config=scrollBarConfig ng-if=\"places.length > 0\"><div class=\"form-group places-row\" ng-repeat=\"place in places track by $index\" ng-class=\"{\'has-error-unique\': errorInd.length && errorInd.indexOf($index) + 1}\"><input type=text class=\"form-control slim-control\" name=\"place{{$index}}\" ng-model=place.name ng-keyup=checkName()> <span class=\"valid-message isset-name\">Кассовое место уже существует</span> <span class=\"glyphicon glyphicon-trash remove-post pull-right\" ng-click=delete($index)></span></div></div></div></div><div class=modal-footer><button class=\"btn btn-primary pull-left\" ng-click=add()>+ Добавить</button> <button class=\"btn right-button\" ng-click=close() ng-disabled=errorInd.length>Закрыть</button></div></div>");
$templateCache.put("app/settings/divisions/crudDivision/crudDivision.html","<div class=\"crud-entity main-left-offset main-right-offset\" ng-class=\"(divisionCrudCtrl.mode.isView)? \'view-entity\': \'\'\"><!-- content of settings --><div ng-if=divisionCrudCtrl.mode.isNew><h1>Добавление подразделения</h1></div><div ng-if=divisionCrudCtrl.mode.isEdit><h1>Редактирование подразделения<entity-history entity-data=divisionCrudCtrl.division></entity-history></h1></div><div ng-show=divisionCrudCtrl.mode.isView><h1>Информация о подразделении<entity-history entity-data=divisionCrudCtrl.division></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-if=!divisionCrudCtrl.mode.isNew><form-buttons view-type=divisionCrudCtrl.mode on-button=divisionCrudCtrl.crud(status) can-disabled=\"(divisionCrudCtrl.isSetDirty && !addDivision.$valid) || divisionCrudCtrl.isHasValidErrors(addDivision.$error)\"></form-buttons></div><div class=clear></div><form role=form novalidate name=addDivision ng-class=divisionCrudCtrl.division.type><fieldset ng-disabled=divisionCrudCtrl.mode.isView><!-- division type --><div class=\"clearfix full-width\"><section class=\"form-group radio-group col-xs-9\" ng-if=!divisionCrudCtrl.mode.isView><h5 class=section-header>Тип подразделения</h5><input type=radio ng-checked=true name=divisionType value=OFFICE id=office ng-model=divisionCrudCtrl.division.type><label class=\"radio-label office\" for=office>Офис</label><input type=radio name=divisionType value=SHOP id=shop ng-model=divisionCrudCtrl.division.type><label class=\"radio-label shop\" for=shop>Магазин</label><input type=radio name=divisionType value=STOREHOUSE id=warehouse ng-model=divisionCrudCtrl.division.type><label class=\"radio-label warehouse\" for=warehouse>Склад</label></section></div><div class=for-small-width ng-if=divisionCrudCtrl.mode.isView><div class=\"radio-group edit-radio-group checked\"><label class=\"radio-label office\" ng-if=\"divisionCrudCtrl.division.type == \'OFFICE\'\"><span class=radio-label-name>Офис</span></label><label class=\"radio-label shop\" ng-if=\"divisionCrudCtrl.division.type == \'SHOP\'\"><span class=radio-label-name>Магазин</span></label><label class=\"radio-label warehouse\" ng-if=\"divisionCrudCtrl.division.type == \'STOREHOUSE\'\"><span class=radio-label-name>Склад</span></label></div></div><!-- basic information --><div class=\"clearfix full-width\" ng-include=\"\'app/settings/divisions/crudDivision/sections/common-info.html\'\"></div><!-- Информация о партнере --><div class=\"clearfix full-width\"><section class=\"form-group col-xs-9\" ng-if=$root.partner ng-hide=\"divisionCrudCtrl.mode.isView && !divisionCrudCtrl.division.code\"><h5 class=section-header>Информация о партнере</h5><div class=\"form-group col-xs-6 row\"><input name=code ng-model=divisionCrudCtrl.division.code type=text class=form-control maxlength=32 ng-show=!divisionCrudCtrl.mode.isView ng-blur=divisionCrudCtrl.uniqueCheckCode(divisionCrudCtrl.division.code) ng-keyup=\"addDivision.code.$setValidity(\'unique\', true); addDivision.code.$setValidity(\'used\', true)\"><label class=form-control-label>Код партнера</label><div ng-show=divisionCrudCtrl.mode.isView ng-bind=\"divisionCrudCtrl.division.code || \'-\'\" class=view-entity-control></div><div class=\"valid-message isset-name\">Код партнера уже существует</div><div class=\"valid-message used\">Невозможно удалить код партнера, по котору были начисления бонусов</div></div></section></div><div class=\"clearfix full-width\" ng-include=\"\'app/settings/divisions/crudDivision/sections/special-tax.html\'\"></div><div class=\"clearfix full-width\" ng-hide=\"divisionCrudCtrl.mode.isView && !divisionCrudCtrl.division.total_area && !divisionCrudCtrl.division.sales_area\"><section class=\"form-group col-xs-9\" ng-class=\"{\'slide-up\': divisionCrudCtrl.hideCharacteristics}\" ng-style=\"(divisionCrudCtrl.mode.isView)? {\'max-height\': \'305px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(divisionCrudCtrl.hideCharacteristics)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"divisionCrudCtrl.hideCharacteristics = !divisionCrudCtrl.hideCharacteristics\" ng-show=divisionCrudCtrl.mode.isView></span><h5 class=section-header>Полезные характеристики</h5><div class=row><div class=\"form-group col-xs-6\"><input float-input float-fixed=1 float-step=0.1 max-after-comma=1 max-int-length=12 currency-input non-currency-uom=true currency-icon=кв.м. type=text id=totalArea class=\"form-control currency-input\" ng-if=!divisionCrudCtrl.mode.isView ng-model=divisionCrudCtrl.division.total_area><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><label for=totalArea class=form-control-label>Общая площадь</label><div ng-if=divisionCrudCtrl.mode.isView class=view-entity-control> {{divisionCrudCtrl.division.total_area ? (divisionCrudCtrl.division.total_area | parseNumber) : \'-\'}} <span>{{divisionCrudCtrl.division.total_area ? \'кв.м.\' : \'\'}}</span></div></div><div class=\"form-group col-xs-6 pull-right\" style=\"margin-bottom: 0;\" ng-if=\"divisionCrudCtrl.division.total_area || divisionCrudCtrl.division.total_area === 0\"><input float-input float-fixed=1 float-step=0.1 max-after-comma=1 max-int-length=12 currency-input non-currency-uom=true currency-icon=кв.м. max-val=divisionCrudCtrl.division.total_area type=text id=salesArea class=\"form-control currency-input\" ng-if=!divisionCrudCtrl.mode.isView ng-model=divisionCrudCtrl.division.sales_area><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><label for=salesArea class=form-control-label>Торговая площадь</label><div class=\"valid-message max-mess\">Торговая площадь превышает общую</div><div ng-if=divisionCrudCtrl.mode.isView class=view-entity-control> {{divisionCrudCtrl.division.sales_area ? (divisionCrudCtrl.division.sales_area | parseNumber) : \'-\'}} <span>{{divisionCrudCtrl.division.sales_area ? \'кв.м.\' : \'\'}}</span></div></div></div></section></div><!-- cash registers --><div ng-repeat=\"cash in divisionCrudCtrl.division.cash_registers\" ng-if=!divisionCrudCtrl.mode.isView class=\"clearfix full-width\"><section class=\"form-group cash-register col-xs-9\"><div class=\"danger-close tooltip-light\" ng-if=\"$root.hasRole(\'cash_register.write\')\" ng-click=\"divisionCrudCtrl.removeCash(cash, $index)\" tooltip-placement=bottom-left uib-tooltip=Удалить></div><h5 class=section-header><span class=\"cash-machine-ico onCash\" style=\"top: 6px;\"></span> Кассовый аппарат</h5><div class=row ng-class=\"{\'required-checkbox\' : cash.$$noPaymentType }\"><div class=\"form-group col-xs-6\"><input type=text class=form-control name=\"manufacturer{{$index}}\" id=\"manufacturer{{$index}}\" ng-model=cash.manufacturer required maxlength=128><label for=\"manufacturer{{$index}}\" class=form-control-label>Производитель</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input type=text class=form-control name=\"model{{$index}}\" id=\"model{{$index}}\" ng-model=cash.model required maxlength=45><label for=\"model{{$index}}\" class=form-control-label>Модель</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\" ng-init=\"serialNum_blur = true\"><input type=text add-zeroes hard-pruning data-check=([.\\S])+ class=form-control name=\"serialNum{{$index}}\" id=\"serialNum{{$index}}\" ng-model=cash.serial_number maxlength=20 required ng-focus=\"serialNum_blur = false\" ng-keyup=\"addDivision[\'serialNum\' + $index].$setValidity(\'unique\', true)\" ng-blur=\"serialNum_blur = true; divisionCrudCtrl.uniqueCheck(cash.serial_number, \'CASH_REGISTER\', \'serial_number\', $index)\"><label for=\"serialNum{{$index}}\" class=form-control-label>Заводской номер</label><div class=\"valid-message wrong-simbol-mess\">Недопустимые символы</div><div class=\"valid-message required-mess\" ng-if=serialNum_blur>Поле является обязательным</div><span class=\"valid-message wrong-format-mess\">Требуется 20 символов</span><div ng-messages=\"addDivision[\'serialNum\' + $index].$error\"><div ng-message=unique class=\"valid-message isset-name\" style=\"display: block;\">Заводской номер уже существует</div></div><span class=req></span></div><div class=\"form-group col-xs-6 form-group-flex\"><ui-select ng-model=cash.place search-enable=\"divisionCrudCtrl.division.cash_register_places.length > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-disabled=!divisionCrudCtrl.division.cash_register_places.length><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"item in (divisionCrudCtrl.division.cash_register_places | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Кассовое место</label><div ng-if=\"$root.hasRole(\'cash_register_place.write\')\" class=\"btn btn-default tooltip-light\" tooltip-placement=right uib-tooltip=\"Открыть список кассовых мест\" style=\"min-width: inherit; margin: 5px 0 0 16px;\" ng-click=divisionCrudCtrl.openCrudPlaces($index)>...</div></div><div class=\"form-group col-xs-6\"><ui-select ng-model=cash.currency ng-if=!divisionCrudCtrl.mode.isView search-enabled=\"(divisionCrudCtrl.currencies.field.total > 100 && divisionCrudCtrl.currencies.field.length <= 100)\" ng-disabled=divisionCrudCtrl.currencies.getDisabled($select) on-select=divisionCrudCtrl.currencySelected($index) required><ui-select-match><span ng-bind-html=\"$select.selected.name + \' (\' +$select.selected.char_iso_code+\')\'\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=divisionCrudCtrl.currencies.refresh($select.search) repeat=\"item in (divisionCrudCtrl.currencies.field.items | filter: $select.search) track by $index\"><span class=currency-font ng-bind-html=\"(item.name + \' (\' +item.char_iso_code+\')\') | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Валюта</label></div><div class=\"form-group col-xs-6 pull-right\"><div class=info-block><span class=no-info ng-if=\"!cash.fd_num && !cash.fd_expire_date && !cash.software_type && !cash.software_version\">Дополнительной информации пока нет</span><div class=info-block-info ng-if=cash.fd_num><span>Номер ФН:&nbsp;</span><tooltip-text-depend text=cash.fd_num placement=top classes=value></tooltip-text-depend></div><div class=info-block-info ng-if=cash.fd_inn><span>ИНН ФН:&nbsp;</span><tooltip-text-depend text=cash.fd_inn placement=top classes=value></tooltip-text-depend></div><div class=info-block-info ng-if=cash.fd_expire_date><span>Дата замены ФН:&nbsp;</span><tooltip-text-depend text=\"cash.fd_expire_date | date: \'dd.MM.yyyy\' : \'UTC\'\" placement=top classes=value></tooltip-text-depend></div><div class=info-block-info ng-if=cash.software_type><span>ПО на кассе:&nbsp;</span><tooltip-text-depend text=cash.software_type placement=top classes=value></tooltip-text-depend></div><div class=info-block-info ng-if=cash.software_version><span>ПО версия:&nbsp;</span><tooltip-text-depend text=cash.software_version placement=top classes=value></tooltip-text-depend></div><div class=info-block-info ng-if=cash.last_sync_date><span>Последняя синхронизация:&nbsp;</span><tooltip-text-depend text=\"cash.last_sync_date | date: \'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset\" placement=top classes=value></tooltip-text-depend></div></div></div><div class=\"form-group col-xs-6\"><label>Доступные способы оплаты</label><div class=tick><div class=\"checkbox pull-left\"><label><input type=checkbox name=nal id=\"payment-type--cash{{$index}}\" ng-model=cash.$$meta.cash ng-change=divisionCrudCtrl.resetPaymentError($index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--cash{{$index}}\">Наличные</label></div><div class=tick><div class=\"checkbox pull-left\"><label><input type=checkbox name=bank_transfer id=\"payment-type--bank_transfer{{$index}}\" ng-model=cash.$$meta.bank_transfer ng-change=divisionCrudCtrl.resetPaymentError($index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--bank_transfer{{$index}}\">Банковский перевод</label></div><div class=tick ng-class=\"{\'disabled\': divisionCrudCtrl.paymentTypes[$index].total === 0 || !divisionCrudCtrl.company}\"><div class=\"checkbox pull-left\"><label><input type=checkbox name=bank id=\"payment-type--bank{{$index}}\" ng-change=\"divisionCrudCtrl.onPaymentTypeChange(cash.$$meta.bank, $index); divisionCrudCtrl.resetPaymentError($index);\" ng-disabled=!divisionCrudCtrl.company ng-model=cash.$$meta.bank> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--bank{{$index}}\">Банковская карта</label></div><div class=\"payment-type form-group\" ng-show=cash.$$meta.bank style=\"padding: 0\"><ui-select ng-model=cash.bank_payment_type name=\"bank_payment_type{{$index}}\" search-enable=\"divisionCrudCtrl.paymentTypes[$index].total > $root.controlSettings.OPTION_DEFAULT_LENGTH || $select.search !== \'\'\" ng-required=!!cash.$$meta.bank ng-change=divisionCrudCtrl.resetPaymentError($index);><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=\"divisionCrudCtrl.refreshPaymentTypes($select.search, $index)\" repeat=\"item in (divisionCrudCtrl.paymentTypes[$index].items | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Название</label><span class=req style=\"right: -13px;\"></span></div><div class=col-xs-12 ng-if=\"cash.$$meta.bank && !divisionCrudCtrl.paymentTypes[$index].items.length\" style=\"padding: 0px; margin-top: -10px; margin-bottom: 10px;\"><div class=payment-type-info>Для установки способа оплаты банковской картой на кассе необходимо завести в системе:<ul class=\"default-ul-styles payment-type-info-steps\"><li>Банк-эквайер на странице <a target=_blank ui-sref=\"contragents({parent: \'money\'})\">Контрагенты</a></li><li>Договор эквайринга на странице <a target=_blank ui-sref=\"contracts({parent: \'money\'})\">Договоры</a></li><li>Соответствующий способ оплаты с типом \"Банковская карта\" на странице <a target=_blank ui-sref=\"paymentTypes({parent: \'money\'})\">Способы оплаты</a></li></ul></div></div><div class=tick ng-repeat=\"payment in divisionCrudCtrl.otherPaymentType\"><div class=\"checkbox pull-left\"><label><input type=checkbox name=\"other{{$index}}\" id=\"payment-type--other{{payment.id}}{{$parent.$index}}\" ng-model=\"cash.$$meta[\'other\' + payment.id]\" ng-change=divisionCrudCtrl.resetPaymentError($parent.$index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--other{{payment.id}}{{$parent.$index}}\" ng-bind=payment.name></label></div><div class=tick><div class=\"checkbox pull-left\"><label><input type=checkbox name=prepay id=\"payment-type--prepay{{$index}}\" ng-model=cash.$$meta.prepay ng-change=divisionCrudCtrl.resetPaymentError($index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--prepay{{$index}}\">Предоплата</label></div><div class=tick><div class=\"checkbox pull-left\"><label><input type=checkbox name=postpay id=\"payment-type--postpay{{$index}}\" ng-model=cash.$$meta.postpay ng-change=divisionCrudCtrl.resetPaymentError($index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--postpay{{$index}}\">Постоплата</label></div><div class=tick><div class=\"checkbox pull-left\"><label><input type=checkbox name=qrYandexPay id=\"payment-type--qrYandexPay{{$index}}\" ng-model=cash.$$meta.qr_yandex ng-change=divisionCrudCtrl.resetPaymentError($index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--qrYandexPay{{$index}}\">QR Яндекс</label><div class=tick><div class=\"checkbox pull-left\"><label><input type=checkbox name=consideration id=\"payment-type--consideration{{$index}}\" ng-model=cash.$$meta.consideration ng-change=divisionCrudCtrl.resetPaymentError($index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"payment-type--consideration{{$index}}\">Встречное предоставление</label></div></div><div class=\"section-footer col-xs-12\"><div class=form-group><div class=\"checkbox pull-left\"><label><input type=checkbox id=\"cash_active{{$index}}\" ng-model=cash.enabled ng-change=divisionCrudCtrl.resetPaymentError($index);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"cash_active{{$index}}\">Синхронизация работает</label></div></div></div></div></section><div class=\"helper col-xs-3 section-helper\" ng-class=\"{\'invisible\': !divisionCrudCtrl.mode.isNew || (divisionCrudCtrl.mode.isNew && divisionCrudCtrl.paymentTypes[$index].total !== 0)}\">Нет ни одного способа оплаты с такой валютой. <a ui-sref=\"paymentType.new({parent: \'money\'})\">Перейдите</a> что бы добавить</div><div class=\"helper col-xs-3 section-helper\" style=\"margin-top: 240px;\"><strong class=text-danger>ВНИМАНИЕ!</strong><div>Для того, чтобы изменения способов оплаты на кассе вступили в силу, надо закрыть и открыть кассовое приложение \"Торговля Онлайн\"</div></div></div><!-- <div class=\"helper\" ng-if=\"divisionCrudCtrl.mode.isEdit && divisionCrudCtrl.cash.length\">Текст для хелпа пользователю что такое перемещение и для чего оно нужно</div> --><div class=\"clearfix full-width\" ng-if=\"!divisionCrudCtrl.mode.isView || $root.hasRole(\'cash_register.write\')\"><section class=\"form-group col-xs-9 same-padding\" ng-if=!divisionCrudCtrl.mode.isView>Добавление кассового аппарата выполняется автоматически в момент его активации</section><div class=\"helper col-xs-3 section-helper\" ng-if=\"divisionCrudCtrl.mode.isNew && !divisionCrudCtrl.company\">Чтобы добавить кассовые аппараты сначала выберите компанию</div></div><!-- list of cash registers --><section class=\"col-xs-9 mini-grid-wrapper\" ng-if=\"divisionCrudCtrl.mode.isView && divisionCrudCtrl.division.cash_registers.length\" ng-class=\"{\'slide-up\': divisionCrudCtrl.hideCashInfo}\" style=\"overflow: visible;\"><h5 class=section-header>Кассовые аппараты</h5><div class=\"grid no-min-height\" ui-grid=gridOptions></div><script type=text/ng-template id=cashTemplate.html><div class=\"ui-grid-cell-contents no-overflow\" style=\"text-align: center\">\n              <span class=\"cash-machine-ico\" ng-class=\"(row.entity.enabled)? \'onCash\': \'offCash\'\">\n              </span>\n              <div class=\"info-block-grid cash-machine-info\">\n                <div class=\"info-block-info\" ng-if=\"::row.entity.currency\"><span>Валюта: </span><tooltip-text-depend text=\"row.entity.currency.name\" placement=\"top\" classes=\"value\"></tooltip-text-depend>\n                </div>\n                <div class=\"info-block-info\" ng-if=\"::row.entity.cash_payment_type || row.entity.bank_payment_type\"><span>Способ оплаты: </span><tooltip-text-depend text=\"grid.appScope.getPaymentTypeNames(row.entity)\" placement=\"top\" classes=\"value\"></tooltip-text-depend></div>\n                <div class=\"info-block-info\" ng-if=\"::row.entity.fd_num\"><span>Номер ФН: </span><tooltip-text-depend text=\"::row.entity.fd_num\" placement=\"top\" classes=\"value\"></tooltip-text-depend>\n                </div>\n                <div class=\"info-block-info\" ng-if=\"::row.entity.fd_inn\"><span>ИНН ФН: </span><tooltip-text-depend text=\"::row.entity.fd_inn\" placement=\"top\" classes=\"value\"></tooltip-text-depend></div>\n                <div class=\"info-block-info\" ng-if=\"::row.entity.fd_expire_date\"><span>Дата замены ФН: </span><tooltip-text-depend text=\"::row.entity.fd_expire_date | date: \'dd.MM.yyyy\'\" placement=\"top\" classes=\"value\"></tooltip-text-depend></div>\n                <div class=\"info-block-info\" ng-if=\"::row.entity.software_type\"><span>ПО на кассе: </span><tooltip-text-depend text=\"::row.entity.software_type\" placement=\"top\" classes=\"value\"></tooltip-text-depend></div>\n                <div class=\"info-block-info\" ng-if=\"::row.entity.software_version\"><span>ПО версия: </span><tooltip-text-depend text=\"::row.entity.software_version\" placement=\"top\" classes=\"value\"></tooltip-text-depend></div>\n                <span class=\"cash-machine-info-status\">{{(row.entity.enabled)? \'Активен\': \'Не активен\'}}</span>\n              </div>\n            </div></script><script type=text/ng-template id=subscriptionsTemplate.html><div class=\"ui-grid-cell-contents no-overflow\" style=\"text-align: center\">\n              <div class=\"subscriptions-indicator\" ng-class=\"grid.appScope.getSubscriptionsStatus(row.entity.subscriptions)\"><span ng-if=\"!row.entity.subscriptions.length\">-</span></div>\n              <div class=\"subscriptions-wrap info-block-grid\" ng-if=\"row.entity.subscriptions.length\">\n                <div class=\"subscription info-block-info\" ng-repeat=\"subscr in row.entity.subscriptions\">\n                  <span ng-bind=\"subscr.name\"></span><br>\n                  <span ng-bind=\"(subscr.status == \'ACTIVE\'? \'Действует до \' : \'Истекла \') + (subscr.expire_date?(subscr.expire_date | date:\'dd.MM.yyyy\'): \'\')\"></span>\n                </div>\n              </div>\n            </div></script></section></fieldset><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=addDivision can-show=divisionCrudCtrl.isSetDirty></form-errors><form-buttons view-type=divisionCrudCtrl.mode on-button=divisionCrudCtrl.crud(status) can-disabled=\"(divisionCrudCtrl.isSetDirty && !addDivision.$valid) || divisionCrudCtrl.isHasValidErrors(addDivision.$error)\"></form-buttons></div></form></div>");
$templateCache.put("app/settings/divisions/crudDivision/remove-cash.html","<div class=modal-content ng-if=divisionCrudCtrl.hasDoc><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>&times;</button><h4 class=modal-title>Невозможно удалить</h4></div><div class=container>Для удаления кассового аппарата <strong ng-bind=cash.model></strong> необходимо удалить все связанные документы <span class=doc-title>Документы:</span><ul class=doc-list><li><span class=\"glyphicon glyphicon-file\"></span> Комиссионный договор</li><li><span class=\"glyphicon glyphicon-file\"></span> Договор с поставщиком</li></ul></div><div class=modal-footer ng-hide=divisionCrudCtrl.hasDoc><button class=btn ng-click=close()>Закрыть</button></div></div><!-- can remove --><div class=modal-content ng-if=!divisionCrudCtrl.hasDoc><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>&times;</button><h3 class=modal-title>Подтверждение удаления</h3></div><div class=\"container can-remove\">Вы действительно хотите удалить <strong ng-bind=\"\'Кассовый аппарат \' + cash.model\"></strong> <span ng-if=cash.serial_number>Заводской номер: {{cash.serial_number}}</span></div><div class=modal-footer ng-hide=divisionCrudCtrl.hasDoc><button class=btn ng-click=close()>Нет</button> <button type=submit class=\"btn btn-primary\" ng-click=removeCash()>Да</button></div></div>");
$templateCache.put("app/settings/employees/crud/employees-crud.html","<div class=\"crud-entity main-left-offset main-right-offset employee\" ng-class=\"(employeesCrudCtrl.mode.isView)? \'view-entity\' : \'\'\"><div ng-if=employeesCrudCtrl.mode.isEdit><h1>Редактирование сотрудника</h1></div><div ng-if=employeesCrudCtrl.mode.isNew><h1>Добавление нового сотрудника<entity-history entity-data=employeesCrudCtrl.user></entity-history></h1></div><div ng-if=employeesCrudCtrl.mode.isView><h1>Просмотр сотрудника<entity-history entity-data=employeesCrudCtrl.user></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-if=!employeesCrudCtrl.mode.isNew><form-buttons is-sms-button=\"employeesCrudCtrl.mode.isView && employeesCrudCtrl.user.phone && $root.hasRole(\'user.write\') && employeesCrudCtrl.user.enabled\" user-phone=employeesCrudCtrl.user.phone view-type=employeesCrudCtrl.mode on-button=employeesCrudCtrl.crud(status) can-disabled=\"(employeesCrudCtrl.isSetDirty && !employeesCrudCtrl.eform.$valid) || employeesCrudCtrl.isHasValidErrors(employeesCrudCtrl.eform.$error)\"></form-buttons></div><div class=clear></div><ng-form name=employeesCrudCtrl.eform><fieldset ng-disabled=employeesCrudCtrl.mode.isView><div ng-include=\"\'app/settings/employees/crud/sections/main-info.html\'\"></div><div ng-include=\"\'app/settings/employees/crud/sections/roles.html\'\" class=\"clearfix full-width\"></div><div ng-include=\"\'app/settings/employees/crud/sections/companies-access.html\'\" ng-if=!employeesCrudCtrl.mode.isView ng-hide=employeesCrudCtrl.hideCompanies class=\"clearfix full-width\"></div><div class=\"clearfix full-width\" ng-show=\"employeesCrudCtrl.user.data_access_rules.has_access && employeesCrudCtrl.mode.isView\"><section class=col-xs-9><span class=active-status style=\"vertical-align: bottom;margin-right: 10px;\"></span> Доступ ко всем компаниям и подразделениям</section></div><div ng-repeat=\"company in employeesCrudCtrl.user.data_access_rules.company_access_rules\" ng-if=employeesCrudCtrl.user.enabled class=\"clearfix full-width\" ng-hide=\"(employeesCrudCtrl.user.data_access_rules.has_access && employeesCrudCtrl.mode.isView) || employeesCrudCtrl.hideCompanies || (!company.division_access_rules.length && !employeesCrudCtrl.mode.isView)\"><div ng-if=company.enabled class=mini-grid-wrapper ng-class=\"(!employeesCrudCtrl.showCashColumn)? \'hide-cash-column\': \'\'\"><division divisions=company.division_access_rules company=::company tabs=::employeesCrudCtrl.divisionsTabs state=::employeesCrudCtrl.state.current.name></division></div></div><section class=\"form-group col-xs-9 hide-fields\" ng-if=\"employeesCrudCtrl.mode.isEdit || employeesCrudCtrl.mode.isNew || (employeesCrudCtrl.mode.isView && employeesCrudCtrl.user.comment)\" ng-class=\"{\'same-padding\': !employeesCrudCtrl.showComment}\"><div class=add-item-wrap ng-click=\"employeesCrudCtrl.showComment = !employeesCrudCtrl.showComment\" ng-if=!employeesCrudCtrl.mode.isView><span class=add-item-icon></span> <span class=add-item-title>Комментарий о сотруднике</span></div><div ng-if=!employeesCrudCtrl.mode.isView class=added-item-wrap><div class=\"danger-close tooltip-light\" ng-click=\"employeesCrudCtrl.showComment = !employeesCrudCtrl.showComment; employeesCrudCtrl.user.comment = undefined;\" tooltip-placement=bottom-left uib-tooltip=Удалить></div><h5 class=section-header>Комментарий о сотруднике</h5><div class=\"form-group row col-xs-12\" style=\"padding-right: 0; margin-bottom: 0;\"><textarea empty-to-null class=form-control rows=3 id=comment ng-model=employeesCrudCtrl.user.comment></textarea><label for=comment class=form-control-label>Комментарий о сотруднике</label></div></div><div class=view-comment ng-if=\"employeesCrudCtrl.mode.isView && employeesCrudCtrl.user.comment\"><h5 class=section-header>Комментарий о сотруднике</h5> {{employeesCrudCtrl.user.comment}} </div></section></fieldset></ng-form><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=employeesCrudCtrl.eform can-show=employeesCrudCtrl.isSetDirty></form-errors><form-buttons is-sms-button=\"employeesCrudCtrl.mode.isView && employeesCrudCtrl.user.phone && $root.hasRole(\'user.write\') && employeesCrudCtrl.user.enabled\" user-phone=employeesCrudCtrl.user.phone view-type=employeesCrudCtrl.mode on-button=employeesCrudCtrl.crud(status) can-disabled=\"(employeesCrudCtrl.isSetDirty && !employeesCrudCtrl.eform.$valid) || employeesCrudCtrl.isHasValidErrors(employeesCrudCtrl.eform.$error)\"></form-buttons></div><br></div>");
$templateCache.put("app/settings/employees/print-component/print-users-popup.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title>Печать списка сотрудников</h3></div><div class=\"container row\"><div ng-show=!$ctrl.longRequest.crudState.loading><div ng-if=!$ctrl.longRequest.flags.finish><label class=col-xs-12 style=\"padding-left: 15px;padding-bottom: 20px;\">Формат файла</label><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio checked name=formatType value=PDF id=pdf ng-model=$ctrl.format.type> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=\"pdf label-icon\"></span><label class=\"label-radio label-with-icon\" for=pdf>PDF</label></div><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=formatType value=XLS id=xls ng-model=$ctrl.format.type> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=\"xls label-icon\"></span><label class=\"label-radio label-with-icon\" for=xls>XLS</label></div></div></div><inview-loader class=popup show=$ctrl.longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center;\" ng-if=\"l$ctrl.ongRequest.crudState.loading && !$ctrl.longRequest.flags.finish\">Подготовка отчета</h4><h4 style=\"text-align: center;\" ng-if=\"!$ctrl.longRequest.crudState.loading && $ctrl.longRequest.flags.finish && !$ctrl.longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center;\" ng-if=$ctrl.longRequest.flags.error>При подготовке отчета произошла ошибка</h4></div><div class=modal-footer><button class=btn type=button ng-click=$ctrl.close()>{{$ctrl.longRequest.flags.finish ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-show=\"!$ctrl.longRequest.crudState.loading && !$ctrl.longRequest.flags.processStart && !$ctrl.longRequest.flags.finish\" class=\"btn btn-primary\" type=button ng-click=\"$ctrl.hide = true;$ctrl.print()\">Печать</button></div>");
$templateCache.put("app/settings/expenseItems/crud/expenseItem-crud.html","<div class=\"crud-entity main-left-offset main-right-offset\" id=expenseItems ng-class=\"(expenseItemCrudCtrl.mode.isView)? \'view-entity\': \'\'\"><!-- content of settings --><div ng-if=expenseItemCrudCtrl.mode.isNew><h1>Добавление статьи затрат</h1></div><div ng-if=expenseItemCrudCtrl.mode.isEdit><h1>Редактирование статьи затрат<entity-history entity-data=expenseItemCrudCtrl.expenseItem></entity-history></h1></div><div ng-if=expenseItemCrudCtrl.mode.isView><h1>Информация о статье затрат<entity-history entity-data=expenseItemCrudCtrl.expenseItem></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-show=!expenseItemCrudCtrl.mode.isNew><form-buttons view-type=expenseItemCrudCtrl.mode on-button=expenseItemCrudCtrl.crud(status) can-disabled=\"(expenseItemCrudCtrl.isSetDirty && !addexpenseItem.$valid) || expenseItemCrudCtrl.isHasValidErrors(addexpenseItem.$error)\"></form-buttons></div><div class=clear></div><form role=form novalidate name=addexpenseItem ng-class=expenseItemCrudCtrl.expenseItem.type><fieldset ng-disabled=expenseItemCrudCtrl.mode.isView><!-- basic information --><section class=\"form-group col-xs-9\" ng-class=\"{\'slide-up\': expenseItemCrudCtrl.hideMainInfo}\" ng-style=\"(expenseItemCrudCtrl.mode.isView)? {\'max-height\': \'450px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(expenseItemCrudCtrl.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"expenseItemCrudCtrl.hideMainInfo = !expenseItemCrudCtrl.hideMainInfo\" ng-show=expenseItemCrudCtrl.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group col-xs-7\" ng-class=\"{\'has-error-unique\': addexpenseItem.name.$invalid && addexpenseItem.name.$error.unique}\"><input type=text class=form-control name=name maxlength=255 id=name ng-model=expenseItemCrudCtrl.expenseItem.name ng-keyup=\"addexpenseItem.name.$setValidity(\'unique\', true)\" ng-blur=expenseItemCrudCtrl.uniqueCheck(expenseItemCrudCtrl.expenseItem.name) required><div ng-show=addexpenseItem.name.$error.unique class=valid-message style=display:block>Статья затрат уже существует</div><div class=\"valid-message required-mess\">Поле является обязательным</div><label for=name class=form-control-label>Наименование</label><span class=req></span></div><div class=\"form-group col-xs-7\"><textarea class=form-control maxlength=255 name=expenseItem-comment id=expenseItem-comment ng-model=expenseItemCrudCtrl.expenseItem.comment ng-hide=\"expenseItemCrudCtrl.mode.isView && !expenseItemCrudCtrl.expenseItem.comment\"></textarea><div ng-if=\"expenseItemCrudCtrl.mode.isView && !expenseItemCrudCtrl.expenseItem.comment\" class=view-entity-control>-</div><label for=expenseItem-comment class=form-control-label>Комментарий</label></div><div class=\"form-group col-xs-7 checkbox-group\" style=\"margin-bottom: 0;\" ng-hide=expenseItemCrudCtrl.mode.isView><checkbox text=\"\'Действующая статья затрат\'\" checkbox-id=active-expenseItem ng-model=expenseItemCrudCtrl.expenseItem.active></checkbox></div><div class=\"form-group col-xs-6 active-status-wrapper\" ng-if=expenseItemCrudCtrl.mode.isView ng-class=\"(!expenseItemCrudCtrl.expenseItem.active)? \'no-active\' : \'\'\" style=\"margin-bottom: 20px;\"><span class=active-status></span> <span ng-if=expenseItemCrudCtrl.expenseItem.active>Действующая статья затрат</span> <span ng-if=!expenseItemCrudCtrl.expenseItem.active>Не действующая статья затрат</span></div></div></section><div class=\"col-xs-3 section-helper\" ng-if=!expenseItemCrudCtrl.mode.isView style=\"margin-top: 280px;\">Этот признак дает возможность указать статью затрат в связанных с ней документах</div></fieldset><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=addexpenseItem can-show=expenseItemCrudCtrl.isSetDirty></form-errors><form-buttons view-type=expenseItemCrudCtrl.mode on-button=expenseItemCrudCtrl.crud(status) can-disabled=\"(expenseItemCrudCtrl.isSetDirty && !addexpenseItem.$valid) || expenseItemCrudCtrl.isHasValidErrors(addexpenseItem.$error)\"></form-buttons></div></form></div>");
$templateCache.put("app/settings/paid-services/crud/paid-service.html","<div class=\"crud-entity main-left-offset main-right-offset paid-service\" ng-class=\"(paidServiceCtrl.mode.isView)? \'view-entity\': \'\'\"><h1 class=main-title>Информация об услуге</h1><div class=\"col-xs-9 section top-buttons\" style=\"padding: 0;\" ng-if=!paidServiceCtrl.mode.isNew><span class=\"btn btn-ico-wrap\" ng-click=paidServiceCtrl.returnToPage(paidServiceCtrl.serviceInfo.status)><span class=\"btn-ico btn-arrow\"></span>Вернуться</span> <button class=\"btn pull-right\" ng-click=paidServiceCtrl.extendAndPrint() ng-if=\"!paidServiceCtrl.isFree && (paidServiceCtrl.serviceInfo.status == \'ACTIVE\' || paidServiceCtrl.serviceInfo.status == \'EXPIRED\')\">Продлить подписку</button></div><div class=clear></div><div class=full-width style=\"max-width: 1500px;\"><form name=paidServiceCtrl.paidForm><section class=col-xs-9 ng-class=\"{\'slide-up\': paidServiceCtrl.hideMainInfo}\" ng-style=\"(paidServiceCtrl.mode.isView)? {\'max-height\': \'305px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.paidServiceCtrl.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"paidServiceCtrl.hideMainInfo = !paidServiceCtrl.hideMainInfo\" ng-show=paidServiceCtrl.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=row><h4 class=\"service-name col-xs-12\" ng-bind=paidServiceCtrl.serviceInfo.name></h4><div class=\"service-description col-xs-12\" ng-bind=paidServiceCtrl.serviceInfo.description></div><div class=\"service-duration col-xs-8\" ng-if=\"paidServiceCtrl.serviceInfo.status !== \'ACTIVE\'\"><label>Услуга предоставляется с</label><span ng-bind=\"(paidServiceCtrl.serviceInfo.effective_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div><div class=\"service-duration col-xs-4\" ng-if=\"paidServiceCtrl.serviceInfo.status !== \'ACTIVE\'\"><label>по</label><span ng-bind=\"(paidServiceCtrl.serviceInfo.expire_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div></div></section><div class=\"col-xs-3 section-helper ng-scope\" style=\"max-width: 450px;\"><div class=\"radio-group edit-radio-group checked\"><label class=\"radio-label edit\" ng-if=!paidServiceCtrl.serviceInfo.status><span class=radio-label-name>Выбрана</span> <span class=shad></span></label><label class=\"radio-label invoice\" ng-if=\"paidServiceCtrl.serviceInfo.status == \'INVOICE_SENT\' || paidServiceCtrl.serviceInfo.status == \'INVOICE_ORDERED\'\"><span class=radio-label-name ng-if=\"paidServiceCtrl.serviceInfo.status == \'INVOICE_ORDERED\'\">Счет заказан</span> <span class=radio-label-name ng-if=\"paidServiceCtrl.serviceInfo.status == \'INVOICE_SENT\'\">Счет выставлен</span> <span class=link-style ng-if=\"paidServiceCtrl.serviceInfo.status == \'INVOICE_SENT\' && paidServiceCtrl.serviceInfo.invoice_out\" ng-click=\"paidServiceCtrl.extendAndPrint(paidServiceCtrl.serviceInfo.invoice_out.id, true)\">Загрузить</span> <span class=shad></span></label><label class=\"radio-label active\" ng-if=\"paidServiceCtrl.serviceInfo.status == \'ACTIVE\' || paidServiceCtrl.serviceInfo.status == \'EXPIRED\'\"><span class=radio-label-name ng-bind=\"paidServiceCtrl.serviceInfo.status == \'ACTIVE\'? \'Активна\' : \'Подписка истекла\'\"></span> <span class=link-style ng-if=\"(paidServiceCtrl.serviceInfo.status == \'ACTIVE\' || paidServiceCtrl.serviceInfo.status == \'EXPIRED\') && paidServiceCtrl.serviceInfo.prices[0].price != 0 && paidServiceCtrl.serviceInfo.invoice_out != null\" ng-click=paidServiceCtrl.loadUTD() style=\"white-space: nowrap;\">Загрузить УПД</span> <span class=shad></span></label></div></div><section class=col-xs-9 ng-class=\"{\'slide-up\': paidServiceCtrl.hideInfo}\" ng-style=\"(paidServiceCtrl.mode.isView)? {\'max-height\': \'305px\'} : \'\'\" ng-if=\"paidServiceCtrl.serviceInfo.status == \'ACTIVE\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.paidServiceCtrl.hideInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"paidServiceCtrl.hideInfo = !paidServiceCtrl.hideInfo\" ng-show=paidServiceCtrl.mode.isView></span><h5 class=section-header>Информация о подписке</h5><div class=row><div class=\"service-duration col-xs-12\"><label>Ключ подписки</label><span>{{paidServiceCtrl.serviceInfo.key}} <span class=copy-icon ngclipboard data-clipboard-text=\"{{paidServiceCtrl.serviceInfo.key}}\" ngclipboard-success=paidServiceCtrl.copied(); tooltip-placement=bottom-left uib-tooltip=\"Копировать ключ подписки\"></span></span></div><br><br><br><div class=\"service-duration col-xs-6\"><label>Дата активации</label><span ng-bind=\"(paidServiceCtrl.serviceInfo.effective_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div><div class=\"service-duration col-xs-6\"><label>Действует до</label><span ng-bind=\"(paidServiceCtrl.serviceInfo.expire_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div></div></section><section class=col-xs-9 ng-class=\"{\'slide-up\': paidServiceCtrl.hideServiceCost, \'no-hover\': paidServiceCtrl.serviceInfo.status}\" ng-style=\"(paidServiceCtrl.mode.isView)? {\'max-height\': \'305px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.paidServiceCtrl.hideServiceCost)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"paidServiceCtrl.hideServiceCost = !paidServiceCtrl.hideServiceCost\" ng-show=paidServiceCtrl.mode.isView></span><h5 class=section-header>Стоимость услуги</h5><table class=service-cost-table><tr><th class=text-right style=\"padding-right: 100px; width: 200px;\">Цена</th><th>Период действия</th><th class=text-right ng-if=paidServiceCtrl.serviceInfo.applicable_to_company>Кол-во компаний</th><th class=text-right ng-if=paidServiceCtrl.serviceInfo.applicable_to_division>Кол-во подразделений</th><th class=text-right ng-if=paidServiceCtrl.serviceInfo.applicable_to_cashregister>Кол-во касс</th></tr><tr ng-click=paidServiceCtrl.chooseTarif(priceObj); ng-repeat=\"priceObj in paidServiceCtrl.serviceInfo.prices\" ng-class=\"{\'active\': paidServiceCtrl.choosenTarif.id == priceObj.id}\"><td class=text-right ng-if=paidServiceCtrl.serviceInfo.price_subscription ng-bind=\"(paidServiceCtrl.serviceInfo.price_subscription/100) | parseNumber\" style=\"padding-right: 100px; width: 200px;\"></td><td class=text-right ng-if=!paidServiceCtrl.serviceInfo.price_subscription ng-bind=\"priceObj.price | priceFormatter:priceObj.currency.char_iso_code:0\" style=\"padding-right: 100px; width: 200px;\"></td><td ng-bind=paidServiceCtrl.periodStr(priceObj.number_of_months);></td><td class=text-right ng-if=paidServiceCtrl.serviceInfo.applicable_to_company ng-bind=\"priceObj.number_of_companies || 0\"></td><td class=text-right ng-if=paidServiceCtrl.serviceInfo.applicable_to_division ng-bind=\"priceObj.number_of_divisions || 0\"></td><td class=text-right ng-if=paidServiceCtrl.serviceInfo.applicable_to_cashregister ng-bind=\"priceObj.number_of_cashregisters || 0\"></td></tr></table></section><div class=\"col-xs-3 section-helper ng-scope\" ng-if=!paidServiceCtrl.serviceInfo.status style=\"max-width: 450px; margin-top: 110px;\">Выберите подходящий тариф</div><section class=col-xs-9 ng-if=\"paidServiceCtrl.serviceApplicationMap.length && paidServiceCtrl.serviceInfo.applicable_to_company\"><h5 class=section-header>Применить услугу к компании</h5><div class=col-xs-6 ng-repeat=\"company in paidServiceCtrl.serviceApplicationMap\"><div class=\"checkbox pull-left\"><label><input type=checkbox name=companies ng-model=company.checked id=\"company{{$index}}\" ng-change=\"paidServiceCtrl.checkItem(company, true); paidServiceCtrl.calculateCountsItems();\" ng-checked=company.checked ng-disabled=\"!company.checked && paidServiceCtrl.companyCheckedCount >= paidServiceCtrl.choosenTarif.number_of_companies\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"company{{$index}}\" class=checkbox-label ng-bind=company.name></label></div></section><div class=\"col-xs-3 section-helper ng-scope\" style=\"max-width: 450px; margin-top: 22px;\" ng-if=\"paidServiceCtrl.serviceInfo.status != \'ACTIVE\'\"><div style=\"font-weight: bold;\" class=text-danger>ВНИМАНИЕ!</div>На данном этапе выбор компаний/подразделений/касс не обязателен. Вы можете сделать это после активации услуги.</div><div class=\"col-xs-3 section-helper ng-scope\" style=\"max-width: 450px; margin-top: 22px;\" ng-if=\"paidServiceCtrl.serviceInfo.status == \'ACTIVE\'\"><div style=\"font-weight: bold;\" class=text-danger>ВНИМАНИЕ!</div>Список объектов применения можно изменить на протяжении всего срока подписки <span ng-bind=paidServiceCtrl.choosenTarif.service.number_of_updates></span> раз{{[2, 3, 4].includes(+paidServiceCtrl.choosenTarif.service.number_of_updates) ? \'a\' : \'\'}}. Осталось попыток: <span ng-bind=paidServiceCtrl.serviceInfo.numberOfRemainingUpdates></span></div><section class=col-xs-9 ng-if=\"paidServiceCtrl.hasVisibleDivisions() && paidServiceCtrl.serviceInfo.applicable_to_division\"><h5 class=section-header>Применить услугу к подразделению</h5><div class=card-wrapper><div class=card ng-repeat=\"company in paidServiceCtrl.serviceApplicationMap\" ng-if=\"company.checked && company.items.length\"><div class=\"card-name major-font\" ng-bind=company.name></div><div ng-repeat=\"division in company.items\" class=\"division-wrapper card-item\"><div class=\"checkbox pull-left\"><label><input type=checkbox name=divisions ng-model=division.checked id=\"division{{$index}}\" ng-change=\"paidServiceCtrl.checkItem(division, false, company.items.length); paidServiceCtrl.calculateCountsItems();\" ng-checked=division.checked ng-disabled=\"!division.checked && paidServiceCtrl.divisionCheckedCount >= paidServiceCtrl.choosenTarif.number_of_divisions\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"division{{$index}}\" class=checkbox-label ng-bind=division.name></label></div></div></div></section><section class=\"col-xs-9 cash-register-wrapper\" ng-if=\"paidServiceCtrl.hasVisibleCashregisters() && paidServiceCtrl.serviceInfo.applicable_to_cashregister\"><h5 class=section-header>Применить услугу к кассам</h5><div class=card-wrapper ng-repeat=\"company in paidServiceCtrl.serviceApplicationMap\" ng-if=\"company.checked && paidServiceCtrl.hasCheckedItem(company)\"><div class=\"company-name major-font\" ng-bind=company.name></div><div ng-repeat=\"division in company.items\" ng-if=\"division.checked && division.items.length\" class=card><div class=\"card-name major-font\" ng-bind=division.name></div><div ng-repeat=\"cashRegister in division.items\" class=card-item><div class=\"checkbox pull-left\"><label><input type=checkbox name=cashRegisters ng-model=cashRegister.checked id=\"cashRegister{{$index}}\" ng-checked=cashRegister.checked ng-disabled=\"!cashRegister.checked && paidServiceCtrl.cashregCheckedCount >= paidServiceCtrl.choosenTarif.number_of_cashregisters\" ng-change=\" paidServiceCtrl.calculateCountsItems();\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"cashRegister{{$index}}\" class=checkbox-label ng-bind=\"cashRegister.manufacturer + \' \' + cashRegister.serial_number\"></label><div class=subscriptions-wrap ng-if=cashRegister.subscriptions.length><div class=subscriptions-indicator ng-class=paidServiceCtrl.getSubscriptionsStatus(cashRegister.subscriptions)></div><div class=subscriptions-description><div class=subscription ng-repeat=\"subscr in cashRegister.subscriptions\"><span ng-bind=subscr.name></span><br><span ng-bind=paidServiceCtrl.getSubscriptionDate(subscr)></span></div></div></div></div></div></div></section></form></div><div class=\"section bottom-buttons col-xs-9\" style=\"padding: 0;\"><button class=\"btn pull-left\" ng-click=paidServiceCtrl.delete() ng-if=\"paidServiceCtrl.serviceInfo.status == \'INVOICE_SENT\' || paidServiceCtrl.serviceInfo.status == \'INVOICE_ORDERED\'\"><span class=\"glyphicon glyphicon-trash btn-ico\"></span> Удалить</button> <button class=\"btn btn-primary pull-right\" type=button ng-click=paidServiceCtrl.choose() ng-if=\"!paidServiceCtrl.serviceInfo.status && paidServiceCtrl.serviceInfo.is_free_of_charge == false\" ng-disabled=!paidServiceCtrl.choosenTarif>Выбрать</button> <button class=\"btn btn-primary pull-right\" type=button ng-click=paidServiceCtrl.activate() ng-if=\"!paidServiceCtrl.serviceInfo.status && paidServiceCtrl.serviceInfo.is_free_of_charge == true\" ng-disabled=paidServiceCtrl.disabledActivate()>Активировать</button> <button class=\"btn btn-primary pull-right\" type=button ng-click=paidServiceCtrl.save() ng-if=paidServiceCtrl.serviceInfo.status>Сохранить</button> <button class=\"btn pull-right\" type=button ng-click=paidServiceCtrl.returnToPage(paidServiceCtrl.serviceInfo.status)>Отменить</button></div></div>");
$templateCache.put("app/settings/paid-services/includes/available.html","<div class=\"col-xs-12 row\"><form class=search-entity role=search ng-submit=\"paidServicesCtrl.search(\'EMPTY\')\"><div class=\"form-group col-xs-6\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=\"paidServicesCtrl.universalGetPaidServices(\'EMPTY\')\" ng-model=\"paidServicesCtrl.tabs[\'EMPTY\'].searchText\" class=\"form-control label-clear-button\" placeholder=Поиск maxlength=30> <button class=\"btn slim-button search-btn\" ng-click=\"paidServicesCtrl.search(\'EMPTY\')\">Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!paidServicesCtrl.tabs[\'EMPTY\'].paidServices.length\" style=\"background: transparent; position: relative; min-width: 100%;\"><div class=big-danger-info-ico ng-if=\"paidServicesCtrl.tabs[\'EMPTY\'].searchText\"></div><div class=big-danger-info ng-if=\"paidServicesCtrl.tabs[\'EMPTY\'].searchText\"><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=\"!paidServicesCtrl.tabs[\'EMPTY\'].searchText\">Нет данных</div></div><div class=spinner-wrapper ng-if=paidServicesCtrl.crudState.loading><div class=ui-spinner></div></div><div class=\"all-card-wrapper row\"><div class=\"col-xs-6 card-box\" ng-repeat=\"paidServ in paidServicesCtrl.tabs[\'EMPTY\'].paidServices\"><div class=card-container ng-click=\"paidServicesCtrl.goToCard(paidServ.id, undefined, paidServ.prices)\"><div class=service-name><span class=\"main-title ellipsis\" ng-bind=paidServ.name></span></div><div class=service-description ng-bind=paidServ.description data-ellipsis data-ellipsis-append=\"\"></div><div class=\"service-tarif-wrapper price-length-{{paidServ.prices.length}}\" ng-if=paidServicesCtrl.showCarousel ng-click=paidServicesCtrl.disabledlClick($event);><div class=service-subtitle>Варианты подключения:</div><ui-carousel slides=paidServ.prices slides-to-show=3 slides-to-scroll=1 autoplay autoplay-speed=2000 dots=false infinite=false><carousel-item><a ui-sref=\"paidService({id: item.parentId, tarif: item.id})\" class=carousel-link><div class=slide-title> {{ (!item.price)? \'БЕСПЛАТНО\' : (item.price | priceFormatter:currency.char_iso_code:0)}} </div><div class=slide-text ng-bind-html=item.description></div></a></carousel-item><carousel-prev><button class=arrow-prev></button></carousel-prev><carousel-next><button class=arrow-next></button></carousel-next></ui-carousel></div></div></div></div>");
$templateCache.put("app/settings/paid-services/includes/draft.html","<div class=\"col-xs-12 row\"><form class=search-entity role=search ng-submit=\"paidServicesCtrl.search(\'DRAFT\')\"><div class=\"form-group col-xs-6\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=\"paidServicesCtrl.universalGetPaidServices(\'DRAFT\')\" ng-model=\"paidServicesCtrl.tabs[\'DRAFT\'].searchText\" class=\"form-control label-clear-button\" placeholder=Поиск maxlength=30> <button class=\"btn slim-button search-btn\" ng-click=\"paidServicesCtrl.search(\'DRAFT\')\">Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!paidServicesCtrl.tabs[\'DRAFT\'].paidServices.length\"><div class=big-danger-info-ico ng-if=\"paidServicesCtrl.tabs[\'DRAFT\'].searchText\"></div><div class=big-danger-info ng-if=\"paidServicesCtrl.tabs[\'DRAFT\'].searchText\"><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=\"!paidServicesCtrl.tabs[\'DRAFT\'].searchText\">Нет данных</div></div><div class=spinner-wrapper ng-if=paidServicesCtrl.crudState.loading><div class=ui-spinner></div></div><div class=\"all-card-wrapper row existing-cards\"><div class=\"col-xs-6 card-box\" ng-repeat=\"paidServ in paidServicesCtrl.tabs[\'DRAFT\'].paidServices\"><div class=card-container ng-click=\"paidServicesCtrl.goToCard(paidServ.id, true)\"><div class=service-name><span class=\"main-title ellipsis\" ng-bind=paidServ.price.service.name></span> <span class=\"description tarif ellipsis\" ng-bind=\"paidServicesCtrl.getDescriptionTarif(paidServ.price, paidServ.price_subscription);\"></span></div><div class=service-description ng-bind=paidServ.price.service.description data-ellipsis data-ellipsis-append=\"\"></div><div class=row><div class=\"service-duration col-xs-7\"><label>Услуга предоставляется с</label><span ng-bind=\"(paidServ.effective_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div><div class=\"service-duration col-xs-5\" ng-click=paidServicesCtrl.disabledlClick($event);><label>по</label><span ng-bind=\"(paidServ.expire_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_company && paidServ.companies.length\"><span class=connections-title>КОМПАНИИ:</span> <span class=connections-item ng-repeat=\"company in paidServ.companies\"><span ng-if=$index>, </span><span ng-bind=company.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_division && paidServ.divisions.length\"><span class=connections-title>ПОДРАЗДЕЛЕНИЯ:</span> <span class=connections-item ng-repeat=\"division in paidServ.divisions\"><span ng-if=$index>, </span><span ng-bind=division.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_cashregister && paidServ.cash_registers.length\"><span class=connections-title>КАССЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.cash_registers\"><span ng-if=$index>, </span><span ng-bind=\"cashregister.manufacturer + \' \' + cashregister.serial_num\"></span></span></div><div class=connections ng-if=\"!paidServ.price.service.applicable_to_division && !paidServ.price.service.applicable_to_company && !paidServ.price.service.applicable_to_cashregister && paidServ.domains.length\"><span class=connections-title>ДОМЕНЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.domains\"><span ng-if=$index>, </span><span ng-bind=cashregister.name></span></span></div><div class=\"glyphicon glyphicon-trash\" ng-click=\"paidServicesCtrl.remove($event, paidServ.id);\" tooltip-placement=bottom-right uib-tooltip=Удалить></div></div></div></div>");
$templateCache.put("app/settings/paid-services/includes/existing.html","<div class=\"col-xs-12 row\"><form class=search-entity role=search ng-submit=\"paidServicesCtrl.search(\'ACTIVE\')\"><div class=\"form-group col-xs-6\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=\"paidServicesCtrl.universalGetPaidServices(\'ACTIVE\')\" ng-model=\"paidServicesCtrl.tabs[\'ACTIVE\'].searchText\" class=\"form-control label-clear-button\" placeholder=Поиск maxlength=30> <button class=\"btn slim-button search-btn\" ng-click=\"paidServicesCtrl.search(\'ACTIVE\')\">Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!paidServicesCtrl.tabs[\'ACTIVE\'].paidServices.length\"><div class=big-danger-info-ico ng-if=\"paidServicesCtrl.tabs[\'ACTIVE\'].searchText\"></div><div class=big-danger-info ng-if=\"paidServicesCtrl.tabs[\'ACTIVE\'].searchText\"><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=\"!paidServicesCtrl.tabs[\'ACTIVE\'].searchText\">Нет данных</div></div><div class=spinner-wrapper ng-if=paidServicesCtrl.crudState.loading><div class=ui-spinner></div></div><div class=\"all-card-wrapper row existing-cards\"><div class=\"col-xs-6 card-box\" ng-repeat=\"paidServ in paidServicesCtrl.tabs[\'ACTIVE\'].paidServices\"><div class=card-container ng-click=\"paidServicesCtrl.goToCard(paidServ.id, true)\"><div class=service-name><span class=\"main-title ellipsis\" ng-bind=paidServ.price.service.name></span> <span class=\"description tarif ellipsis\" ng-bind=\"paidServicesCtrl.getDescriptionTarif(paidServ.price, paidServ.price_subscription);\"></span></div><div class=service-description ng-bind=paidServ.price.service.description data-ellipsis data-ellipsis-append=\"\"></div><div class=row><div class=\"service-duration col-xs-7\"><label>Услуга предоставляется с</label><span ng-bind=\"(paidServ.effective_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div><div class=\"service-duration col-xs-5\" ng-click=paidServicesCtrl.disabledlClick($event);><label>по</label><span ng-bind=\"(paidServ.expire_date | date:\'dd.MM.yyyy\') || \'-\'\"></span> <span class=\"link-style extend-link\" ng-click=\"paidServicesCtrl.extend(paidServ.id, null, true);\" ng-if=\"paidServ.price.price && (paidServ.status == \'ACTIVE\' || paidServ.status == \'EXPIRED\')\"><span class=txt>Продлить</span> <span class=icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink width=23 height=22 viewBox=\"0 0 23 22\"><defs><path id=a d=\"M22.932 13.638a1 1 0 0 1 .068.364V20a1 1 0 0 1-2 0v-3.688l-2.933 2.755a10 10 0 0 1-16.5-3.733 1 1 0 1 1 1.886-.668A8 8 0 0 0 9.229 19.8a8.015 8.015 0 0 0 7.446-2.169l2.8-2.631H16a1 1 0 0 1 0-2h6a1 1 0 0 1 .927.625l.005.013zM.068 8.36A1 1 0 0 1 0 7.996V1.998a1 1 0 0 1 2 0v3.688l2.933-2.755a10 10 0 0 1 16.5 3.733 1 1 0 1 1-1.886.667 8 8 0 0 0-5.776-5.134 8.015 8.015 0 0 0-7.446 2.17l-2.8 2.63H7a1 1 0 1 1 0 2H1a1 1 0 0 1-.927-.625L.068 8.36z\"/></defs><use fill=#43ad9c fill-rule=evenodd xlink:href=#a /></svg></span></span></div></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_company && paidServ.companies.length\"><span class=connections-title>КОМПАНИИ:</span> <span class=connections-item ng-repeat=\"company in paidServ.companies\"><span ng-if=$index>, </span><span ng-bind=company.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_division && paidServ.divisions.length\"><span class=connections-title>ПОДРАЗДЕЛЕНИЯ:</span> <span class=connections-item ng-repeat=\"division in paidServ.divisions\"><span ng-if=$index>, </span><span ng-bind=division.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_cashregister && paidServ.cash_registers.length\"><span class=connections-title>КАССЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.cash_registers\"><span ng-if=$index>, </span><span ng-bind=\"cashregister.manufacturer + \' \' + cashregister.serial_num\"></span></span></div><div class=connections ng-if=\"!paidServ.price.service.applicable_to_division && !paidServ.price.service.applicable_to_company && !paidServ.price.service.applicable_to_cashregister && paidServ.domains.length\"><span class=connections-title>ДОМЕНЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.domains\"><span ng-if=$index>, </span><span ng-bind=cashregister.name></span></span></div><div class=service-status ng-class=\"{\'active\': paidServ.status == \'ACTIVE\', \'expired\': paidServ.status == \'EXPIRED\'}\" ng-bind=paidServicesCtrl.statusesMap[paidServ.status]></div></div></div></div>");
$templateCache.put("app/settings/paid-services/includes/expired.html","<div class=\"col-xs-12 row\"><form class=search-entity role=search ng-submit=\"paidServicesCtrl.search(\'EXPIRED\')\"><div class=\"form-group col-xs-6\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=\"paidServicesCtrl.universalGetPaidServices(\'EXPIRED\')\" ng-model=\"paidServicesCtrl.tabs[\'EXPIRED\'].searchText\" class=\"form-control label-clear-button\" placeholder=Поиск maxlength=30> <button class=\"btn slim-button search-btn\" ng-click=\"paidServicesCtrl.search(\'EXPIRED\')\">Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!paidServicesCtrl.tabs[\'EXPIRED\'].paidServices.length\"><div class=big-danger-info-ico ng-if=\"paidServicesCtrl.tabs[\'EXPIRED\'].searchText\"></div><div class=big-danger-info ng-if=\"paidServicesCtrl.tabs[\'EXPIRED\'].searchText\"><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=\"!paidServicesCtrl.tabs[\'EXPIRED\'].searchText\">Нет данных</div></div><div class=spinner-wrapper ng-if=paidServicesCtrl.crudState.loading><div class=ui-spinner></div></div><div class=\"all-card-wrapper row existing-cards\"><div class=\"col-xs-6 card-box\" ng-repeat=\"paidServ in paidServicesCtrl.tabs[\'EXPIRED\'].paidServices\"><div class=card-container ng-click=\"paidServicesCtrl.goToCard(paidServ.id, true)\"><div class=service-name><span class=\"main-title ellipsis\" ng-bind=paidServ.price.service.name></span> <span class=\"description tarif ellipsis\" ng-bind=\"paidServicesCtrl.getDescriptionTarif(paidServ.price, paidServ.price_subscription);\"></span></div><div class=service-description ng-bind=paidServ.price.service.description data-ellipsis data-ellipsis-append=\"\"></div><div class=row><div class=\"service-duration col-xs-7\"><label>Услуга предоставляется с</label><span ng-bind=\"(paidServ.effective_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div><div class=\"service-duration col-xs-5\" ng-click=paidServicesCtrl.disabledlClick($event);><label>по</label><span ng-bind=\"(paidServ.expire_date | date:\'dd.MM.yyyy\') || \'-\'\"></span> <span class=\"link-style extend-link\" ng-click=paidServicesCtrl.extend(paidServ.id); ng-if=\"paidServ.price.price && (paidServ.status == \'EXPIRED\' || paidServ.status == \'EXPIRED\')\"><span class=txt>Продлить</span> <span class=icon><svg xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink width=23 height=22 viewBox=\"0 0 23 22\"><defs><path id=a d=\"M22.932 13.638a1 1 0 0 1 .068.364V20a1 1 0 0 1-2 0v-3.688l-2.933 2.755a10 10 0 0 1-16.5-3.733 1 1 0 1 1 1.886-.668A8 8 0 0 0 9.229 19.8a8.015 8.015 0 0 0 7.446-2.169l2.8-2.631H16a1 1 0 0 1 0-2h6a1 1 0 0 1 .927.625l.005.013zM.068 8.36A1 1 0 0 1 0 7.996V1.998a1 1 0 0 1 2 0v3.688l2.933-2.755a10 10 0 0 1 16.5 3.733 1 1 0 1 1-1.886.667 8 8 0 0 0-5.776-5.134 8.015 8.015 0 0 0-7.446 2.17l-2.8 2.63H7a1 1 0 1 1 0 2H1a1 1 0 0 1-.927-.625L.068 8.36z\"/></defs><use fill=#43ad9c fill-rule=evenodd xlink:href=#a /></svg></span></span></div></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_company && paidServ.companies.length\"><span class=connections-title>КОМПАНИИ:</span> <span class=connections-item ng-repeat=\"company in paidServ.companies\"><span ng-if=$index>, </span><span ng-bind=company.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_division && paidServ.divisions.length\"><span class=connections-title>ПОДРАЗДЕЛЕНИЯ:</span> <span class=connections-item ng-repeat=\"division in paidServ.divisions\"><span ng-if=$index>, </span><span ng-bind=division.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_cashregister && paidServ.cash_registers.length\"><span class=connections-title>КАССЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.cash_registers\"><span ng-if=$index>, </span><span ng-bind=\"cashregister.manufacturer + \' \' + cashregister.serial_num\"></span></span></div><div class=connections ng-if=\"!paidServ.price.service.applicable_to_division && !paidServ.price.service.applicable_to_company && !paidServ.price.service.applicable_to_cashregister && paidServ.domains.length\"><span class=connections-title>ДОМЕНЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.domains\"><span ng-if=$index>, </span><span ng-bind=cashregister.name></span></span></div><div class=service-status ng-class=\"{\'EXPIRED\': paidServ.status == \'EXPIRED\', \'expired\': paidServ.status == \'EXPIRED\'}\" ng-bind=paidServicesCtrl.statusesMap[paidServ.status]></div></div></div></div>");
$templateCache.put("app/settings/paid-services/includes/invoice-sent.html","<div class=\"col-xs-12 row\"><form class=search-entity role=search ng-submit=\"paidServicesCtrl.search(\'INVOICE_SENT\')\"><div class=\"form-group col-xs-6\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=\"paidServicesCtrl.universalGetPaidServices(\'INVOICE_SENT\')\" ng-model=\"paidServicesCtrl.tabs[\'INVOICE_SENT\'].searchText\" class=\"form-control label-clear-button\" placeholder=Поиск maxlength=30> <button class=\"btn slim-button search-btn\" ng-click=\"paidServicesCtrl.search(\'INVOICE_SENT\')\">Поиск</button></div></form></div><div class=\"filter-not-found major-font\" ng-if=\"!paidServicesCtrl.tabs[\'INVOICE_SENT\'].paidServices.length\"><div class=big-danger-info-ico ng-if=\"paidServicesCtrl.tabs[\'INVOICE_SENT\'].searchText\"></div><div class=big-danger-info ng-if=\"paidServicesCtrl.tabs[\'INVOICE_SENT\'].searchText\"><h3>Поиск не дал результатов</h3>Попробуйте уточнить запрос<br>и повторить попытку</div><div ng-if=\"!paidServicesCtrl.tabs[\'INVOICE_SENT\'].searchText\">Нет данных</div></div><div class=spinner-wrapper ng-if=paidServicesCtrl.crudState.loading><div class=ui-spinner></div></div><div class=\"all-card-wrapper row existing-cards\"><div class=\"col-xs-6 card-box\" ng-repeat=\"paidServ in paidServicesCtrl.tabs[\'INVOICE_SENT\'].paidServices\"><div class=card-container ng-click=\"paidServicesCtrl.goToCard(paidServ.id, true)\"><div class=service-name><span class=\"main-title ellipsis\" ng-bind=paidServ.price.service.name></span> <span class=\"description tarif ellipsis\" ng-bind=\"paidServicesCtrl.getDescriptionTarif(paidServ.price, paidServ.price_subscription);\"></span></div><div class=service-description ng-bind=paidServ.price.service.description data-ellipsis data-ellipsis-append=\"\"></div><div class=row><div class=\"service-duration col-xs-7\"><label>Услуга предоставляется с</label><span ng-bind=\"(paidServ.effective_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div><div class=\"service-duration col-xs-5\" ng-click=paidServicesCtrl.disabledlClick($event);><label>по</label><span ng-bind=\"(paidServ.expire_date | date:\'dd.MM.yyyy\') || \'-\'\"></span></div></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_company && paidServ.companies.length\"><span class=connections-title>КОМПАНИИ:</span> <span class=connections-item ng-repeat=\"company in paidServ.companies\"><span ng-if=$index>, </span><span ng-bind=company.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_division && paidServ.divisions.length\"><span class=connections-title>ПОДРАЗДЕЛЕНИЯ:</span> <span class=connections-item ng-repeat=\"division in paidServ.divisions\"><span ng-if=$index>, </span><span ng-bind=division.name></span></span></div><div class=connections ng-if=\"paidServ.price.service.applicable_to_cashregister && paidServ.cash_registers.length\"><span class=connections-title>КАССЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.cash_registers\"><span ng-if=$index>, </span><span ng-bind=\"cashregister.manufacturer + \' \' + cashregister.serial_num\"></span></span></div><div class=connections ng-if=\"!paidServ.price.service.applicable_to_division && !paidServ.price.service.applicable_to_company && !paidServ.price.service.applicable_to_cashregister && paidServ.domains.length\"><span class=connections-title>ДОМЕНЫ:</span> <span class=connections-item ng-repeat=\"cashregister in paidServ.domains\"><span ng-if=$index>, </span><span ng-bind=cashregister.name></span></span></div><div class=service-status ng-class=\"{\'INVOICE_SENT\': paidServ.status == \'INVOICE_SENT\', \'INVOICE_SENT\': paidServ.status == \'INVOICE_SENT\'}\" ng-bind=paidServicesCtrl.statusesMap[paidServ.status]></div></div></div></div>");
$templateCache.put("app/settings/paymentTypes/crud/paymentTypeCrud.html","<div class=\"crud-entity main-left-offset main-right-offset\" id=paymentTypes ng-class=\"(paymentTypeCrudCtrl.mode.isView)? \'view-entity\': \'\'\"><!-- content of settings --><div ng-if=paymentTypeCrudCtrl.mode.isNew><h1>Добавление способа оплаты</h1></div><div ng-if=paymentTypeCrudCtrl.mode.isEdit><h1>Редактирование способа оплаты<entity-history entity-data=paymentTypeCrudCtrl.paymentType></entity-history></h1></div><div ng-if=paymentTypeCrudCtrl.mode.isView><h1>Информация о способе оплаты<entity-history entity-data=paymentTypeCrudCtrl.paymentType></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-show=!paymentTypeCrudCtrl.mode.isNew><form-buttons ng-class=\"{\'remove-delete\': paymentTypeCrudCtrl.paymentType.type === \'CASH\' || paymentTypeCrudCtrl.paymentType.type === \'BANK_TRANSFER\' || paymentTypeCrudCtrl.paymentType.type === \'PREPAY\' || paymentTypeCrudCtrl.paymentType.type === \'POSTPAY\' || paymentTypeCrudCtrl.paymentType.type === \'CONSIDERATION\', \'remove-edit\': paymentTypeCrudCtrl.paymentType.type === \'CASH\'}\" view-type=paymentTypeCrudCtrl.mode on-button=paymentTypeCrudCtrl.crud(status) can-disabled=\"paymentTypeCrudCtrl.isSetDirty && !addPaymentType.$valid\"></form-buttons></div><div class=clear></div><form role=form novalidate name=addPaymentType ng-class=paymentTypeCrudCtrl.paymentType.type><fieldset ng-disabled=paymentTypeCrudCtrl.mode.isView><!--types --><div class=\"clearfix full-width\"><section class=\"form-group radio-group col-xs-9\" ng-if=paymentTypeCrudCtrl.mode.isNew><h5 class=section-header>Основная информация</h5><!-- <input type=\"radio\" ng-checked=\"true\" name=\"paymentType\" value=\"CASH\" id=\"cash\"\n                 ng-model=\"paymentTypeCrudCtrl.paymentType.type\" ng-disabled=\"paymentTypeCrudCtrl.disabledCashType\">\n          <label class=\"radio-label cash\" for=\"cash\">Наличные<span class=\"shad\"></span></label> --> <input type=radio name=paymentType value=BANK_CARD id=card ng-model=paymentTypeCrudCtrl.paymentType.type ng-change=paymentTypeCrudCtrl.changeType();><label class=\"radio-label card\" for=card>Банковская карта<span class=shad></span></label><input type=radio name=paymentType value=OTHER id=other ng-model=paymentTypeCrudCtrl.paymentType.type ng-change=paymentTypeCrudCtrl.changeType();><label class=\"radio-label other\" for=other>Прочее<span class=shad></span></label></section></div><div class=\"clearfix full-width\"><!-- basic information --><section class=\"form-group col-xs-9\" ng-class=\"{\'slide-up\': paymentTypeCrudCtrl.hideMainInfo}\" ng-style=\"(paymentTypeCrudCtrl.mode.isView)? {\'max-height\': \'247px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(paymentTypeCrudCtrl.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"paymentTypeCrudCtrl.hideMainInfo = !paymentTypeCrudCtrl.hideMainInfo\" ng-show=paymentTypeCrudCtrl.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group col-xs-6\"><input type=text class=form-control name=name maxlength=255 id=name ng-model=paymentTypeCrudCtrl.paymentType.name ng-keyup=\"addPaymentType.name.$setValidity(\'unique\', true)\" ng-blur=paymentTypeCrudCtrl.uniqueCheck(paymentTypeCrudCtrl.paymentType.name) required><div ng-show=addPaymentType.name.$error.unique class=valid-message style=display:block>Способ оплаты уже существует</div><div class=\"valid-message required-mess\">Поле является обязательным</div><label for=contract-number class=form-control-label>Наименование</label><span class=req></span></div><div class=\"form-group col-xs-6 checkbox-group\" ng-if=!paymentTypeCrudCtrl.mode.isView><checkbox text=\"\'Действующий способ оплаты\'\" checkbox-id=active-paymentType ng-model=paymentTypeCrudCtrl.paymentType.active mode=\"paymentTypeCrudCtrl.paymentType.type === \'CASH\' || paymentTypeCrudCtrl.paymentType.type === \'BANK_TRANSFER\' || paymentTypeCrudCtrl.paymentType.type === \'PREPAY\' || paymentTypeCrudCtrl.paymentType.type === \'POSTPAY\' || paymentTypeCrudCtrl.paymentType.type === \'CONSIDERATION\' || paymentTypeCrudCtrl.mode.isView\"></checkbox></div><div class=\"form-group col-xs-6 active-status-wrapper\" ng-if=paymentTypeCrudCtrl.mode.isView ng-class=\"(!paymentTypeCrudCtrl.paymentType.active)? \'no-active\' : \'\'\" style=\"margin-bottom: 20px;\"><span class=active-status></span> <span ng-if=paymentTypeCrudCtrl.paymentType.active>Действующий способ оплаты</span> <span ng-if=!paymentTypeCrudCtrl.paymentType.active>Не действующий способ оплаты</span></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0;\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'BANK_CARD\' || paymentTypeCrudCtrl.paymentType.type === \'OTHER\'\"><ui-select ng-model=paymentTypeCrudCtrl.paymentType.contract search-enabled=false ng-if=!paymentTypeCrudCtrl.mode.isView required ng-disabled=!paymentTypeCrudCtrl.contracts.length><ui-select-match><span ng-bind=paymentTypeCrudCtrl.createContractString($select.selected) title=\"{{paymentTypeCrudCtrl.createContractString($select.selected)}}\"></span></ui-select-match><ui-select-choices repeat=\"contract in paymentTypeCrudCtrl.contracts track by $index\"><span ng-bind-html=paymentTypeCrudCtrl.createContractString(contract) title=\"{{paymentTypeCrudCtrl.createContractString(contract)}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label for=contract-number class=form-control-label>Договор</label><span class=req></span><div ng-if=paymentTypeCrudCtrl.mode.isView class=view-entity-control>{{paymentTypeCrudCtrl.createContractString(paymentTypeCrudCtrl.paymentType.contract)}}</div></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0;\"><div class=currency-info ng-show=paymentTypeCrudCtrl.paymentType.contract.currency><span class=\"currency-info--title text-muted\">Валюта договора</span><br><span class=text-muted ng-bind=\"paymentTypeCrudCtrl.paymentType.contract.currency.name + \' (\'+ paymentTypeCrudCtrl.paymentType.contract.currency.char_iso_code +\')\'\"></span></div></div></div></section><div class=\"col-xs-3 section-helper\" ng-if=!paymentTypeCrudCtrl.mode.isNew><div class=\"radio-group edit-radio-group checked\" ng-class=\"{\'fade-out\': paymentTypeCrudCtrl.hideMainInfo}\"><label class=\"radio-label cash\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'CASH\'\">Наличные<span class=shad></span></label><label class=\"radio-label card\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'BANK_CARD\'\">Банковская карта<span class=shad></span></label><label class=\"radio-label card\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'BANK_TRANSFER\'\">Банковский перевод<span class=shad></span></label><label class=\"radio-label cash\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'PREPAY\'\">Предоплата<span class=shad></span></label><label class=\"radio-label cash\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'POSTPAY\'\">Постоплата<span class=shad></span></label><label class=\"radio-label cash\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'CONSIDERATION\'\">Встречное предоставление<span class=shad></span></label><label class=\"radio-label other\" ng-if=\"paymentTypeCrudCtrl.paymentType.type == \'OTHER\'\">Прочий<span class=shad></span></label></div></div></div><div class=\"clearfix full-width\" ng-hide=\"paymentTypeCrudCtrl.mode.isView && !paymentTypeCrudCtrl.paymentType.default\"><section ng-if=paymentTypeCrudCtrl.paymentType.active class=\"col-xs-9 same-padding\"><div class=\"form-group checkbox-group\" style=\"margin-bottom: 0;\" ng-hide=paymentTypeCrudCtrl.mode.isView><checkbox text=\"\'Использовать по умолчанию\'\" checkbox-id=default-paymentType ng-model=paymentTypeCrudCtrl.paymentType.default mode=paymentTypeCrudCtrl.mode.isView></checkbox></div><span class=view-entity-control ng-if=paymentTypeCrudCtrl.mode.isView>Используется по умолчанию</span></section></div></fieldset><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=addPaymentType can-show=paymentTypeCrudCtrl.isSetDirty></form-errors><form-buttons ng-class=\"{\'remove-delete\': paymentTypeCrudCtrl.paymentType.type === \'CASH\' || paymentTypeCrudCtrl.paymentType.type === \'BANK_TRANSFER\' || paymentTypeCrudCtrl.paymentType.type === \'PREPAY\' || paymentTypeCrudCtrl.paymentType.type === \'POSTPAY\' || paymentTypeCrudCtrl.paymentType.type === \'CONSIDERATION\', \'remove-edit\': paymentTypeCrudCtrl.paymentType.type === \'CASH\'}\" view-type=paymentTypeCrudCtrl.mode on-button=paymentTypeCrudCtrl.crud(status) can-disabled=\"paymentTypeCrudCtrl.isSetDirty && !addPaymentType.$valid\"></form-buttons></div></form></div>");
$templateCache.put("app/price-list/directives/price-cell/price-cell.html","<div class=price-cell-container ng-class=\"{\n      \'price-new\': priceCellCtrl.price.$new,\n      \'price-deleted\': priceCellCtrl.price.$deleted || priceCellCtrl.price.$deleted_,\n      \'price-modify\': priceCellCtrl.price.$modify || priceCellCtrl.price.$$changed,\n      \'always-edit\': priceCellCtrl.alwaysEdit\n     }\" ng-click=$event.stopPropagation();><div class=\"price-backdrop show-price-backdrop\" ng-show=\"priceCellCtrl.selected && !priceCellCtrl.alwaysEdit\" ng-click=priceCellCtrl.cancel();></div><div class=\"price-cell-overlap price-cell-item selected\" ng-class=\"{\'has-error\': !priceCellCtrl.valid}\" ng-if=priceCellCtrl.selected><form name=priceCellCtrl.priceCellForm ng-class=\"{\'price-cell-error\': !priceCellCtrl.valid}\"><div class=\"cell-flex-container crud-entity\"><div class=\"form-group col-xs-6\" ng-if=\"priceCellCtrl.columnType !== \'PURCHASE\'\"><span class=disabled-helper ng-if=\"priceCellCtrl.today > priceCellCtrl.price.effective_date || priceCellCtrl.price.$deleted\"></span><div date-range-picker ng-model=priceCellCtrl.effective_date ng-disabled=false state=priceCellCtrl.effective_date_state opts=::priceCellCtrl.datePickerOpts class=\"datepicker-wrap tooltip-light\" tooltip-placement=left uib-tooltip=\"{{priceCellCtrl.message}}\" name=effective_date field-label=\"\'Начиная с\'\" on-close=\"priceCellCtrl.onDatePickerClose(returnValue, name)\" ng-click=::priceCellCtrl.onDatePickerClick($event) ng-required=true></div></div><div class=\"form-group count-wrap\" ng-class=\"(priceCellCtrl.columnType == \'PURCHASE\')? \'col-xs-12\' : \'col-xs-6\'\" title=\"{{::priceCellCtrl.columnType == \'RETAIL\' ? \'Для розничной цены недоступно редактирование\': \'\'}}\" tooltip-placement=bottom uib-tooltip=\"{{(priceCellCtrl.columnType == \'PURCHASE\')? priceCellCtrl.message : \'\'}}\"><input type=text class=\"form-control text-right count\" ng-click=$event.stopPropagation() ng-disabled=\"priceCellCtrl.columnType == \'RETAIL\' ||\n                 (priceCellCtrl.columnType != \'PURCHASE\' && (priceCellCtrl.today > priceCellCtrl.effective_date))\" ng-keypress=::priceCellCtrl.setModify() ng-model=priceCellCtrl.price.effective_qty currency-input=true currency-icon=\"{{priceCellCtrl.uom.symbols || \'ед.\'}}\" ng-blur=priceCellCtrl.onBlurHandler($event) ng-keydown=priceCellCtrl.keyEventHandler($event) required><label class=\"form-control-label small-offset\" ng-bind=\"priceCellCtrl.columnType != \'RETAIL\'? \'Кол-во от\' : \'За кол-во\'\"></label></div></div><div class=cell-flex-container style=\"margin-top: 5px;\"><div class=\"form-group col-xs-6\" ng-if=\"priceCellCtrl.columnType !== \'PURCHASE\'\"><ui-select ng-model=priceCellCtrl.price.free_of_control_price ng-disabled=\"(priceCellCtrl.today > priceCellCtrl.price.effective_date) || priceCellCtrl.price.$deleted\" on-select=priceCellCtrl.setModify() ng-required=true search-enabled=false><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"control.value as control in [{value: false, name: \'Указанная\'}, {value: true, name: \'Свободная\'}]\"><span ng-bind-html=control.name></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Тип цены</label></div><div class=form-group ng-class=\"(priceCellCtrl.columnType == \'PURCHASE\')? \'col-xs-12\' : \'col-xs-6\'\"><input input-price type=text focus-request=true focus-on-event=newPriceEvent class=\"form-control text-right price\" ng-click=$event.stopPropagation() ng-disabled=\"(priceCellCtrl.columnType != \'PURCHASE\' && (priceCellCtrl.today > priceCellCtrl.price.effective_date)) ||\n                 priceCellCtrl.price.$deleted\" ng-keyup=::priceCellCtrl.setModify() currency-input=true currency-icon=\"{{priceCellCtrl.currency.symbol}}\" ng-model=priceCellCtrl.price.price_for_one_uom ng-required=true ng-blur=priceCellCtrl.onBlurHandler($event) ng-keydown=priceCellCtrl.keyEventHandler($event)><label class=\"form-control-label small-offset\">Цена</label></div></div><button class=\"btn btn-primary pull-right\" ng-click=priceCellCtrl.onClick($event); style=\"margin: 12px -4px;\" ng-if=!priceCellCtrl.alwaysEdit ng-disabled=!priceCellCtrl.priceCellForm.$valid>Сохранить</button></form></div><div ng-click=\"!priceCellCtrl.selected && ((priceCellCtrl.columnType == \'PURCHASE\' && $root.hasRole(\'purchase_price_list.write\') && priceCellCtrl.priceCellMultiple.node.catalog_item.status !== \'ARCHIVED\') || (priceCellCtrl.columnType == \'RETAIL\' && $root.hasRole(\'price_list.write\')) || (priceCellCtrl.columnType == \'WHOLE_SALE\' && $root.hasRole(\'wholesale_price_list.write\'))) && priceCellCtrl.onClick($event);\" class=price-cell-item><div><div class=text-right><div class=cell-flex-container><div class=text-left style=\"flex: 1 1\" ng-if=\"priceCellCtrl.columnType !== \'PURCHASE\'\"><small ng-show=\"priceCellCtrl.price && priceCellCtrl.price.effective_date\">c <span ng-bind=\"priceCellCtrl.price.effective_date | date : \'dd.MM.yyyy\'\"></span></small></div><div style=\"flex: 1 1\"><small ng-show=priceCellCtrl.price.effective_qty style=\"opacity: 0.4;\"><small ng-bind=priceCellCtrl.price.effective_qty></small> <small ng-bind=\"::priceCellCtrl.uom.symbols || \'ед.\'\"></small></small></div></div><div class=cell-flex-container><div style=\"flex: 1 1\" ng-show=priceCellCtrl.price.free_of_control_price ng-if=\"priceCellCtrl.columnType !== \'PURCHASE\'\"><div class=\"free-price text-muted tooltip-light\" style=\"height: 100%;\" tooltip-placement=left uib-tooltip=\"Цена может быть изменена при продаже, но не может быть меньше указанного значения\"></div></div><div style=\"flex: 8 8\"><strong class=\"price-cell-str tooltip-light\" ng-class=\"{\'text-price-auto\': priceCellCtrl.price.$$withFormula, \'previous-price-wrap\': !priceCellCtrl.price.$$previos.withTip && (priceCellCtrl.price.$$previos.price_for_one_uom || priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom)}\" ng-hide=\"priceCellCtrl.price.price_for_one_uom == undefined && priceCellCtrl.price.calculated_automatically_price_for_one_uom == undefined\" tooltip-placement=left uib-tooltip=\"{{(priceCellCtrl.price.$$previos.withTip && (priceCellCtrl.price.$$previos.price_for_one_uom || priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom))? (((priceCellCtrl.price.$$previos.price_for_one_uom || priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom) / 100 | parseNumber) + priceCellCtrl.currency.symbol) + \' →\' : \'\'}}\"><span class=\"price-str previous-price-str\" ng-class=\"{\'text-price-auto\': (!priceCellCtrl.price.$$previos.price_for_one_uom && priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom) || (priceCellCtrl.price.$$previos.price_for_one_uom == priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom)}\" ng-if=\"!priceCellCtrl.price.$$previos.withTip && (priceCellCtrl.price.$$previos.price_for_one_uom || priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom)\" ng-bind=\"(priceCellCtrl.price.$$previos.price_for_one_uom || priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom)? (((priceCellCtrl.price.$$previos.price_for_one_uom || priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom) / 100 | parseNumber) + priceCellCtrl.currency.symbol) : \'\'\"></span><div class=gray-arrow ng-if=\"!priceCellCtrl.price.$$previos.withTip && (priceCellCtrl.price.$$previos.price_for_one_uom || priceCellCtrl.price.$$previos.calculated_automatically_price_for_one_uom)\"></div><span class=price-str><span ng-bind=\"(priceCellCtrl.price.price_for_one_uom || priceCellCtrl.price.calculated_automatically_price_for_one_uom || 0) / 100 | parseNumber\"></span> <span ng-bind=::priceCellCtrl.currency.symbol class=currency-font></span> </span></strong><small ng-show=\"priceCellCtrl.price.price_for_one_uom == undefined && priceCellCtrl.price.calculated_automatically_price_for_one_uom == undefined\" class=text-muted>цены нет</small></div></div></div></div></div></div>");
$templateCache.put("app/settings/projects/crud/project-crud.html","<div class=\"crud-entity main-left-offset main-right-offset\" id=projects ng-class=\"(projectCrudCtrl.mode.isView)? \'view-entity\': \'\'\"><!-- content of settings --><div ng-if=projectCrudCtrl.mode.isNew><h1 class=main-title>Добавление проекта</h1></div><div ng-if=projectCrudCtrl.mode.isEdit><h1 class=main-title>Редактирование проекта<entity-history entity-data=projectCrudCtrl.project></entity-history></h1></div><div ng-if=projectCrudCtrl.mode.isView><h1 class=main-title>Информация о проекте<entity-history entity-data=projectCrudCtrl.project></entity-history></h1></div><div class=\"col-xs-9 section top-buttons\" ng-if=!projectCrudCtrl.mode.isNew><form-buttons view-type=projectCrudCtrl.mode on-button=projectCrudCtrl.crud(status) can-disabled=\"projectCrudCtrl.isSetDirty && !addproject.$valid\"></form-buttons></div><div class=clear></div><form role=form novalidate name=addproject ng-class=projectCrudCtrl.project.type><fieldset ng-disabled=projectCrudCtrl.mode.isView><!-- basic information --><section class=\"form-group col-xs-9\" ng-class=\"{\'slide-up\': projectCrudCtrl.hideMainInfo}\" ng-style=\"(projectCrudCtrl.mode.isView)? {\'max-height\': \'300px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(projectCrudCtrl.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"projectCrudCtrl.hideMainInfo = !projectCrudCtrl.hideMainInfo\" ng-show=projectCrudCtrl.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group wide-form-group col-xs-6\" ng-class=\"{\'has-error-unique\': addproject.name.$invalid && addproject.name.$error.unique}\"><input type=text class=form-control name=name maxlength=255 id=name ng-model=projectCrudCtrl.project.name ng-keyup=\"addproject.name.$setValidity(\'unique\', true)\" ng-blur=projectCrudCtrl.uniqueCheck(projectCrudCtrl.project.name) required><label for=name class=form-control-label>Наименование</label><div ng-show=addproject.name.$error.unique class=valid-message style=display:block>Проект уже существует</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group wide-form-group col-xs-12\"><textarea class=form-control maxlength=255 name=project-comment id=project-comment ng-model=projectCrudCtrl.project.comment id=comment ng-hide=projectCrudCtrl.mode.isView></textarea><div ng-if=projectCrudCtrl.mode.isView class=view-entity-control ng-bind=\"(projectCrudCtrl.project.comment)? projectCrudCtrl.project.comment : \'-\'\"></div><label for=comment class=form-control-label>Комментарий</label></div><div class=\"form-group wide-form-group col-xs-12 checkbox-group\" ng-hide=projectCrudCtrl.mode.isView><checkbox text=\"\'Действующий проект\'\" checkbox-id=active-project ng-model=projectCrudCtrl.project.active></checkbox></div><div class=\"form-group col-xs-6 active-status-wrapper\" ng-if=projectCrudCtrl.mode.isView ng-class=\"(!projectCrudCtrl.project.active)? \'no-active\' : \'\'\" style=\"margin-bottom: 20px;\"><span class=active-status></span> <span ng-if=projectCrudCtrl.project.active>Действующий проект</span> <span ng-if=!projectCrudCtrl.project.active>Не действующий проект</span></div></div></section><div class=\"col-xs-3 section-helper\" ng-if=!projectCrudCtrl.mode.isView style=\"margin-top: 280px;\">Этот признак дает возможность указать проект в связанных с ним документах</div></fieldset><div class=\"col-xs-9 section bottom-buttons\"><form-errors form-ctrl=addproject can-show=projectCrudCtrl.isSetDirty></form-errors><form-buttons view-type=projectCrudCtrl.mode on-button=projectCrudCtrl.crud(status) can-disabled=\"projectCrudCtrl.isSetDirty && !addproject.$valid\"></form-buttons></div></form></div>");
$templateCache.put("app/settings/returns/crud/return-crud.html","<div class=\"main-left-offset main-right-offset\"><modal-load show-main-modal=ctrl.loadedData status=ctrl.loadingData success=ctrl.success fail=ctrl.fail></modal-load></div><div class=\"settings-crud crud-entity main-left-offset main-right-offset view-entity clearfix full-width\" ng-if=ctrl.loadedData><h1><span class=\"light-custom-tip-wrap doc-status-icon\" ng-class=\"{\n    \'on-disabled\': ctrl.return.status == \'PROCESSED\',\n    \'wait\': ctrl.return.status == \'IN_PROCESS\' || ctrl.return.status == \'IN_ROLLBACK\',\n    \'off-disabled\': ctrl.return.status == \'DRAFT\'}\"><div class=light-custom-tip style=\"margin-top: 30px; margin-left: 20px;\">Статус: <span ng-if=\"ctrl.return.status == \'PROCESSED\'\">Проведен</span> <span ng-if=\"ctrl.return.status == \'DRAFT\'\">Черновик</span> <span ng-if=\"ctrl.return.status == \'IN_PROCESS\' || ctrl.return.status == \'IN_ROLLBACK\'\">В обработке</span></div></span>Возврат №{{ctrl.return.number}} от <span class=text-lowercase>{{ctrl.getFormattedDate(ctrl.return.date, false)}}</span></h1><div class=\"col-xs-9 section top-buttons no-padding\"><span class=\"btn back-link btn-ico-wrap\" ng-click=ctrl.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</span></div><div class=clear></div><entity-view-card fields=ctrl.fields></entity-view-card><entity-view-lower-table ng-if=ctrl.sumTable data=ctrl.sumTable></entity-view-lower-table></div><grid-wide class=\"grid-wide no-selection-style\" ng-if=ctrl.loadedData url=ctrl.url page=ctrl.page header=ctrl.header filters-required=false row-route=null is-sku=true sort=ctrl.sort limit=ctrl.limit currency=ctrl.currency column-defs=ctrl.columnDefs using-service=ctrl.usingService config=::ctrl.gridConfig need-add-to-cart=true></grid-wide>");
$templateCache.put("app/settings/services/message/modal-message.html","<div class=modal-custom><div class=modal-body><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><div class=modal-main-text><h2>{{message.message}}</h2><h4 class=text-muted style=\"word-break: break-word;\" ng-bind-html=message.submessage.data.message></h4></div></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=close()>ОК</button></div></div>");
$templateCache.put("app/settings/support/includes/help.html","<div class=main-color-block>Ответ на свой вопрос вы скорее всего найдете в нашей <a href=http://доки.торговля.онлайн target=_blank>документации</a><br><br>Если вам все же нужна наша помощь или вы обнаружили ошибку в нашей программе, <span class=link-style ng-click=supportCtrl.openForm();>свяжитесь с нами</span></div><div ng-if=supportCtrl.showForm><form name=supportCtrl.supportForm ng-show=!supportCtrl.successMessage><section class=\"col-xs-9 support_wrapper\"><div class=row><div class=\"form-group col-xs-6\"><input type=text class=form-control name=name maxlength=255 id=name ng-model=supportCtrl.data.name ng-required=true><label for=name class=form-control-label>Отправитель</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\"><email mail=supportCtrl.data.reply_to[0] is-required=true></email><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div class=row><div class=\"form-group col-xs-12\"><input type=text class=form-control name=subject maxlength=255 ng-model=supportCtrl.data.subject ng-required=true><label class=form-control-label>Тема</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div class=row><div class=\"form-group col-xs-12\"><textarea class=form-control ng-model=supportCtrl.data.mail_body ng-required=true></textarea><label class=form-control-label>Сообщение</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div></section><div class=row><div class=\"section bottom-buttons\"><div class=req-inform ng-if=supportCtrl.errorMessage ng-bind=supportCtrl.errorMessage></div><form-errors class=col-xs-12 form-ctrl=supportCtrl.supportForm can-show=supportCtrl.isSetDirty style=\"padding-left: 30px;\"></form-errors><button class=\"btn btn-primary pull-right\" ng-click=supportCtrl.send(); ng-disabled=\"supportCtrl.supportForm.$invalid && supportCtrl.supportForm.$dirty\">Отправить</button><div class=pull-right><span ng-bind=\"!supportCtrl.type ? \'\': supportCtrl.fileName\"></span> <input type=file id=upload onchange=angular.element(this).scope().changeFile(this) class=ng-hide><label class=btn for=upload>Загрузить файл</label></div></div></div></form><div ng-if=supportCtrl.successMessage>Спасибо! Ваше обращение направлено в службу поддержки</div></div>");
$templateCache.put("app/settings/support/includes/my_partner.html","<div class=\"crud-entity view-entity\" ng-if=supportCtrl.myPartner style=\"max-width: 1000px;\"><div class=main-color-block><partner-info-card info=supportCtrl.myPartner></partner-info-card></div><button class=\"btn pull-right\" ng-click=supportCtrl.partnershipReject()>Отказаться от партнера</button></div><div class=\"crud-entity view-entity\" ng-if=!supportCtrl.myPartner><div class=\"no-partner-message main-color-block\">У Вас пока нет партнера.<br><br><div ng-if=supportCtrl.possiblePartners.length>Мы подобрали партнеров в вашем регионе. При необходимости обучения функционалу личного кабанета, кассового приложения или обслуживания кассовой техники Вы можете к ним обращаться</div></div><div class=\"possible-partners main-color-block\" ng-repeat=\"partnerInfo in supportCtrl.possiblePartners\"><partner-info-card info=partnerInfo></partner-info-card></div></div>");
$templateCache.put("app/settings/templates/modals/ask-delete.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title ng-if=\"canDelete || forceDelete\">Удаление</h3><h3 class=modal-title ng-if=\"!canDelete && !forceDelete\">Невозможно удалить</h3></div><div class=container ng-if=canDelete><div class=modal-main-text><span class=\"text-muted modal-description\">Вы действительно хотите удалить {{deleteEntityStr}}?</span><h2 style=\"word-wrap: break-word\">{{name}}</h2></div></div><div class=container ng-if=\"!canDelete || forceDelete\"><div class=modal-main-text style=\"padding: 20px 0px 20px; min-height: 100px;\"><span class=\"text-muted modal-description\" ng-bind-html=conflictDeleteText></span></div></div><div class=modal-footer><div ng-if=\"canDelete || forceDelete\"><button class=btn type=button ng-disabled=lock ng-click=close()>Отмена</button> <button class=\"btn btn-primary\" ng-disabled=lock type=button ng-click=delete()>Удалить</button></div><button class=\"btn btn-primary\" type=button ng-click=close() ng-if=\"!canDelete && !forceDelete\">Закрыть</button></div><div class=lock-bg ng-show=lock><div class=ui-spinner></div></div>");
$templateCache.put("app/settings/templates/modals/img-view.html","<button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button> <img src=\"{{img}}\" alt=\"\">");
$templateCache.put("app/settings/templates/modals/info.html","<div class=modal-header ng-if=title><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title ng-bind=title ng-style=\"(titleFontSize)? {\'font-size\': titleFontSize + \'px\'} : \'\'\"></h3></div><div class=modal-body ng-class=\"{\'one-question-modal\': !title}\"><button ng-if=!title type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><div class=\"question-text clearfix row\"><span class=\"info-icon col-xs-1\" ng-if=infoIcon style=\"height: 22px;background-size: contain;\"></span> <span class=col-xs-11 ng-bind-html=text></span></div></div><div class=modal-footer><button class=\"btn btn-primary\" type=button ng-click=close()>Закрыть</button></div>");
$templateCache.put("app/settings/templates/modals/one-question.html","<div class=modal-header ng-if=title><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title ng-bind-html=title></h3></div><div class=\"modal-body one-question-modal\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close() ng-if=!title>×</button><div class=question-text ng-bind-html=text ng-style=\"(title)? {\'padding-top\': \'0\'} : \'\'\" ng-if=!load></div><div class=ui-spinner ng-if=load style=\"margin: 62px auto 74px;\"></div></div><div class=modal-footer ng-if=!load><button class=btn type=button ng-click=close() ng-bind=\"buttonClose || \'Нет\'\">Нет</button> <button class=\"btn btn-primary\" type=button ng-click=action() ng-bind=\"buttonAction || \'Да\'\"></button></div>");
$templateCache.put("app/settings/templates/modals/reset-password.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title>Сброс пароля</h3></div><div class=\"container user-reset-password-popup\"><div class=modal-inner ng-if=!errorUserIds.length><span class=text-muted>Пользователям из списка ниже будет необходимо<br>изменить свой пароль на новый при следующем входе:</span><ul class=user-list><li class=user-name ng-repeat=\"name in data.names\" ng-bind=name></li></ul><span class=text-muted>Вы подтверждаете сброс пароля?</span></div><div class=modal-inner ng-if=errorUserIds.length><span class=text-muted>Не удалось сбросить пароль для следующих пользователей:</span><ul class=user-list><li class=user-name ng-repeat=\"name in data.names\" ng-bind=name ng-if=errorUserIds.indexOf($index)+1></li></ul></div></div><div class=modal-footer><button class=btn ng-click=close() ng-if=errorUserIds.length>Закрыть</button> <button class=btn ng-click=close() ng-if=!errorUserIds.length>Нет</button> <button class=\"btn btn-primary\" ng-click=resetPassword() ng-if=!errorUserIds.length>Да</button></div>");
$templateCache.put("app/settings/utmConnections/crudUtmConnection/utmConnection.html","<div class=\"utm-connection-wrapper crud-entity main-left-offset main-right-offset view-entity\"><h1>Подключение к УТМ<!-- <entity-history entity-data=\"utmConnectionCtrl.company\"></entity-history> --></h1><div class=\"col-xs-9 section top-buttons\"><form-buttons view-type=utmConnectionCtrl.mode on-button=utmConnectionCtrl.crud(status) can-disabled=\"utmConnectionCtrl.isSetDirty && !utmForm.$valid\" hide-delete=true></form-buttons></div><div class=clear></div><form role=form name=utmForm class=\"crud-main-column col-xs-9\"><fieldset ng-disabled=true><div ng-include=\"\'app/settings/utmConnections/crudUtmConnection/sections/main-info.html\'\"></div><div ng-include=\"\'app/settings/utmConnections/crudUtmConnection/sections/utm.html\'\"></div><div ng-include=\"\'app/settings/utmConnections/crudUtmConnection/sections/divisions.html\'\"></div></fieldset><div class=\"col-xs-12 section bottom-buttons\"><form-errors form-ctrl=utmForm can-show=utmConnectionCtrl.isSetDirty></form-errors><form-buttons view-type=utmConnectionCtrl.mode on-button=utmConnectionCtrl.crud(status) hide-delete=true can-disabled=\"utmConnectionCtrl.isSetDirty && !utmForm.$valid\"></form-buttons></div></form></div>");
$templateCache.put("app/settings/widgets/egaisCounterparties/egais-counterparties.html","<div class=ui-spinner ng-if=egaisCounterpartiesCtrl.loading></div><div ng-if=\"egaisCounterpartiesCtrl.noData || egaisCounterpartiesCtrl.counterparties.length == 0\">Нет связанных контрагентов</div><div class=egais-counterparties ng-if=\"!egaisCounterpartiesCtrl.loading && !egaisCounterpartiesCtrl.noData\"><div class=widget-row ng-repeat=\"counterparty in egaisCounterpartiesCtrl.counterparties\"><strong class=\"counterparty-name-wrap clearfix\"><span class=\"counterparty-name ellipsis\" ng-bind=counterparty.short_name uib-tooltip=\"{{counterparty.name}}\"></span> <span class=\"glyphicon cross\" ng-if=egaisCounterpartiesCtrl.redactMode ng-click=egaisCounterpartiesCtrl.deletePopup(counterparty); uib-tooltip=Удалить></span></strong><div class=counterparty-data-wrap><label>ИД ФСРАР:</label><div class=text-right ng-bind=\"counterparty.client_reg_id || \'-\'\"></div></div><div class=counterparty-data-wrap><label>ИНН / КПП:</label><div class=text-right ng-bind=\"(counterparty.inn || \'-\') + \' / \' + (counterparty.kpp || \'-\')\"></div></div><div class=counterparty-data-wrap><label>Адрес:</label><div class=text-right ng-bind=\"counterparty.address_description || \'-\'\"></div></div></div><div class=\"widget-footer clearfix\" ng-if=\"!egaisCounterpartiesCtrl.loading && egaisCounterpartiesCtrl.redactMode\"><button class=\"btn btn-primary pull-right\" ng-click=egaisCounterpartiesCtrl.save()>Сохранить</button> <button class=\"btn pull-right\" ng-click=egaisCounterpartiesCtrl.dismiss()>Отменить</button></div></div>");
$templateCache.put("app/settings/widgets/mutualSettlement/mutual-settlement.html","<div class=mutual-settlement><div ng-if=mutualSettlementCtrl.noPermissions>Не достаточно прав для просмотра данных</div><div ng-if=mutualSettlementCtrl.someError>Возникла ошибка</div><div class=row ng-if=\"!mutualSettlementCtrl.noPermissions && !mutualSettlementCtrl.someError\"><div class=col-xs-5></div><div class=\"col-xs-4 text-right amounth-total\"><div tooltip-placement=bottom-right uib-tooltip=\"Нам должны\">Нам должны</div><strong ng-bind=\"((mutualSettlementCtrl.isWeOwe)? 0 : mutualSettlementCtrl.owe) | parseNumber\" tooltip-placement=bottom-right uib-tooltip=\"{{((mutualSettlementCtrl.isWeOwe)? 0 : mutualSettlementCtrl.owe) | parseNumber}}\"></strong></div><div class=\"col-xs-3 text-right amounth-total\" style=\"padding: 0 6px 0 0px; position: relative; left: -8px;\"><div tooltip-placement=bottom-right uib-tooltip=\"Мы должны\">Мы должны</div><strong ng-bind=\"((mutualSettlementCtrl.isWeOwe)? mutualSettlementCtrl.owe : 0) | parseNumber\" tooltip-placement=bottom-right uib-tooltip=\"{{((mutualSettlementCtrl.isWeOwe)? mutualSettlementCtrl.owe : 0) | parseNumber}}\"></strong></div></div><div class=collapse-toggle data-toggle=collapse data-target=#contractsData aria-expanded=false aria-controls=contractsData ng-click=mutualSettlementCtrl.getData(true); ng-if=\"!mutualSettlementCtrl.noPermissions && !mutualSettlementCtrl.someError\" ng-class=\"{\'collapsed\': !mutualSettlementCtrl.showData}\">По договорам <span class=arrow></span></div><div class=collapse id=contractsData ng-class=\"{\'in\': mutualSettlementCtrl.showData}\"><div ng-if=\"!mutualSettlementCtrl.contractsData.length && !mutualSettlementCtrl.load\" style=\"margin: 25px 0 30px 0;\">Взаиморасчетов с контрагентом не найдено</div><div ng-show=mutualSettlementCtrl.load><div class=ui-spinner></div></div><div class=company-wrapper ng-show=\"mutualSettlementCtrl.contractsData.length && !mutualSettlementCtrl.load\"><div ng-repeat=\"company in mutualSettlementCtrl.contractsData\"><div class=company-name ng-bind=company.company_name></div><div class=row ng-repeat=\"contract in company.contracts\"><div class=col-xs-5><a ui-sref=\"contract.view({contractId: contract.id, parent: $state.params.parent})\" target=_blank ng-bind=\"\'№\' + contract.number + \' от \' + (contract.date | date:\'dd.MM.yyyy\')\"></a></div><div class=\"col-xs-4 text-right tooltip-label\" ng-bind=\"(contract.isWeOwe)? \'\' : (contract.owe | parseNumber)\" tooltip-placement=bottom-right uib-tooltip=\"{{(contract.isWeOwe)? \'\' : (contract.owe | parseNumber)}}\"></div><div class=\"col-xs-3 text-right tooltip-label\" ng-bind=\"(contract.isWeOwe)? (contract.owe | parseNumber) : \'\'\" style=\"padding: 0 15px 0 3px;\" tooltip-placement=bottom-right uib-tooltip=\"{{(contract.isWeOwe)? (contract.owe | parseNumber) : \'\'}}\"></div></div></div></div></div></div>");
$templateCache.put("app/settings/widgets/price-widget/price-widget.html","<div ng-if=priceWidgetCtrl.crudState.error>При получении данных произошла ошибка</div><div ng-form=priceWidgetForm class=\"price-widget crud-entity\" ng-class=\"{\'view-entity\': !priceWidgetCtrl.redactMode , \'redact-mode\': priceWidgetCtrl.redactMode}\" ng-if=!priceWidgetCtrl.crudState.error><div class=widget-content ng-if=!priceWidgetCtrl.settingsmode><div ng-show=!priceWidgetCtrl.crudState.loading><div class=\"widget-price-list crud-entity\" ng-if=priceWidgetCtrl.widgetSettings[priceList.type].visible ng-repeat=\"priceList in priceWidgetCtrl.pricesLists.price_lists\"><a class=\"text-uppercase major-font\" target=_blank ui-sref=\"priceList({ parent: priceList.type })\" ng-bind=\"(priceList.type | priceListName).substr(0, (priceList.type | priceListName).length-1) + \'е\'\"></a><div class=widget-price-column ng-repeat=\"column in priceList.columns track by $index\" ng-if=\"priceList.has_price_list_line &&\n                    (priceWidgetCtrl.redactMode || column.prices.length) &&\n                    priceWidgetCtrl.widgetSettings[priceList.type].columns[column.id].visible\"><price-widget-column uom-symbol=priceWidgetCtrl.pricesLists.uom.symbols column=column redact-mode=\"priceWidgetCtrl.redactMode && $root.hasRole(priceList.$$action_prefix + \'.write\')\" on-column-change=\"priceWidgetCtrl.onColumnChange(updatedColumn, priceList, $index)\" price-list-type=priceList.type></div><div class=widget-price-column ng-if=!priceList.has_price_list_line>{{($root.toState.name.indexOf(\"catalogSkus\") + 1)? \'Товар не добавлен\' : \'Услуга не добавлена\'}} в данный прайс-лист</div></div><div ng-if=\"priceWidgetCtrl.redactMode && !$root.hasRole(\'price_list.write\') && !$root.hasRole(\'wholesale_price_list.write\') && !$root.hasRole(\'purchase_price_list.write\')\">Не достаточно прав для редактирования цен.</div></div><div ng-show=priceWidgetCtrl.crudState.loading><div class=ui-spinner></div></div><div class=\"widget-footer clearfix\" ng-if=priceWidgetCtrl.redactMode><button class=\"btn btn-primary pull-right\" ng-disabled=priceWidgetForm.$invalid ng-click=priceWidgetCtrl.save()>Сохранить</button> <button class=\"btn pull-right\" ng-click=priceWidgetCtrl.dismiss()>Отменить</button></div></div><div class=widget-settings ng-if=priceWidgetCtrl.settingsmode><label class=\"widget-body-title text-muted\">Отображаем колонки цен:</label><div ng-repeat=\"(priceListKey, priceListValue) in priceWidgetCtrl.widgetSettings\"><div class=form-group><div class=check-wrapper><div class=\"checkbox pull-left\"><label><input type=checkbox ng-change=priceWidgetCtrl.priceListVisibilityChange(priceListKey) ng-model=priceListValue.visible id=\"{{priceListKey}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span data-toggle=collapse data-target=\"#{{priceListKey}}Collapse\"><label class=checkbox-label ng-bind=\"priceListKey | priceListName\"></label><span class=caret></span></span></div></div><div style=\"margin-left: 15px;\" class=\"collapse in\" id=\"{{priceListKey}}Collapse\"><div ng-repeat=\"(columnKey, columnValue) in priceListValue.columns\"><div class=form-group><div class=check-wrapper uib-tooltip=\"{{(columnValue.supplier.name)? \'Действует для поставщика \' + columnValue.supplier.name : (columnValue.name | priceListName)}}\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-change=\"priceWidgetCtrl.columnVisibilityChanged(priceListKey, columnValue.visible)\" ng-model=columnValue.visible id=\"{{columnKey}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{columnKey}}\" class=checkbox-label ng-bind=\"columnValue.name | priceListName\"></label></div></div></div></div></div></div></div>");
$templateCache.put("app/settings/widgets/specialTaxMode/special-tax-mode.html","<div ng-if=\"!specialTaxModeCtrl.settingsmode && !specialTaxModeCtrl.options.divisions.length\">В компании нет подразделений</div><div ng-if=\"!specialTaxModeCtrl.settingsmode && specialTaxModeCtrl.options.divisions.length && !specialTaxModeCtrl.divisions.length\">Для подразделений компании спецрежимы налогообложения не назначены</div><div ng-if=\"!specialTaxModeCtrl.settingsmode && specialTaxModeCtrl.onlyCurrent && !specialTaxModeCtrl.hasCurrentLength && specialTaxModeCtrl.divisions.length\">Нет действующих спецрежимов</div><div class=widget-row ng-repeat=\"division in specialTaxModeCtrl.divisions\" ng-if=!specialTaxModeCtrl.settingsmode ng-hide=\"specialTaxModeCtrl.onlyCurrent && !division.$$hasCurrent\"><div class=division-name-wrap><span class=division-type ng-class=\"(division.type | lowercase) + \'-ico\'\"></span> <a ui-sref=\"division.view({divisionId: division.id, companyId: specialTaxModeCtrl.companyId, parent: \'business\'})\" class=division-name ng-bind=division.name target=_blank></a></div><div class=special-tax-wrap><div class=\"special-tax clearfix\" ng-repeat=\"tax in division.special_tax_modes\" ng-class=\"{\'current\': tax.$$current}\" tooltip-placement=bottom-right uib-tooltip=\"{{(tax.$$current)? \'Действующий спецрежим\' : \'\'}}\"><span class=text-muted ng-bind=\"(tax.special_tax_mode == \'IMPUTED\')? \'ЕНВД\' : \'Патент\'\"></span> <span class=text-muted ng-bind=\"specialTaxModeCtrl.getDateStr(tax, $index, division)\"></span></div></div></div><div class=widget-settings ng-if=specialTaxModeCtrl.settingsmode><label class=widget-body-title>В истории показывать:</label><div><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=specialTaxModeCtrl.setOnlyCurrent id=setOnlyCurrent> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=status-name for=setOnlyCurrent style=\"margin-top: 3px;\">Только действующий спецрежим</label></div></div>");
$templateCache.put("app/settings/widgets/stockWidget/stock-widget.html","<div class=\"mutual-settlement stock-widget\" ng-if=!stockWidgetCtrl.settingsmode><div ng-if=stockWidgetCtrl.crudState.error>При получении данных произошла ошибка</div><div ng-if=\"!stockWidgetCtrl.settingsmode && !stockWidgetCtrl.stock.items.length\">Товар отсутствует во всех подразделениях</div><div class=\"row head-row\" ng-if=stockWidgetCtrl.stock.items.length><strong class=col-xs-6>Всего</strong> <strong class=\"col-xs-6 text-right\" ng-bind=\"stockWidgetCtrl.stock.totals.stock_qty + \' \' + stockWidgetCtrl.stock.items[0].uom.symbols\"></strong></div><div class=collapse-toggle data-toggle=collapse data-target=#stockData aria-expanded=false aria-controls=stockData ng-if=stockWidgetCtrl.stock.items.length ng-class=\"{\'collapsed\': !stockWidgetCtrl.showData}\" ng-click=stockWidgetCtrl.showHideData();>По подразделениям <span class=arrow></span></div><div class=collapse id=stockData ng-class=\"{\'in\': stockWidgetCtrl.showData}\" ng-show=stockWidgetCtrl.stock.items.length><div ng-repeat=\"item in stockWidgetCtrl.stock.items\"><div class=company-name ng-bind=item.company.name ng-if=\"stockWidgetCtrl.sortBy == \'company_id\' && stockWidgetCtrl.stock.items[$index - 1].company.name !== item.company.name\"></div><div class=division-type ng-if=\"stockWidgetCtrl.sortBy == \'division_type\' && stockWidgetCtrl.stock.items[$index - 1].division.type !== item.division.type\"><span class=divisions-title ng-class=\"(item.division.type | lowercase) + \'-ico\'\" ng-bind=\"item.division.type | divisionType:true\"></span></div><div class=row><div class=col-xs-8><a ui-sref=\"division.view({divisionId: item.division.id, companyId: item.company.id, parent: \'business\'})\" ng-bind=item.division.name uib-tooltip=\"{{item.division.name}}\"></a></div><div class=\"col-xs-4 text-right\" ng-bind=\"item.stock_qty | parseNumber\"></div></div></div></div></div><div class=widget-settings ng-if=stockWidgetCtrl.settingsmode><label class=widget-body-title>Группировать подразделения по:</label><div class=form-group><div class=\"radio-box clearfix\"><div class=\"radio pull-left\"><label><input type=radio name=settings ng-model=stockWidgetCtrl.tempSortBy ng-value=\"\'company_id\'\" id=company> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=company style=\"padding-top: 13px;\">Компании</label></div><div class=\"radio-box clearfix\"><div class=\"radio pull-left\"><label><input type=radio name=settings ng-model=stockWidgetCtrl.tempSortBy ng-value=\"\'division_type\'\" id=division> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=division style=\"padding-top: 13px;\">Типу (Магазин, Склад, Офис)</label></div></div></div>");
$templateCache.put("app/settings/widgets/verificationWidget/verification-widget.html","<div class=\"mutual-settlement verification-widget\" ng-if=!verificationWidgetCtrl.settingsmode><div ng-if=verificationWidgetCtrl.noPermissions>Не достаточно прав для просмотра данных</div><div ng-if=verificationWidgetCtrl.someError>Возникла ошибка</div><div class=row ng-if=\"!verificationWidgetCtrl.noPermissions && !verificationWidgetCtrl.someError\"><div class=col-xs-5></div><div class=\"col-xs-4 text-right amounth-total\"><div tooltip-placement=bottom-right uib-tooltip=\"Нам должны\">Нам должны</div><strong ng-bind=\"((!verificationWidgetCtrl.isWeOweMain)? verificationWidgetCtrl.owe : 0) | parseNumber\" tooltip-placement=bottom-right uib-tooltip=\"{{((!verificationWidgetCtrl.isWeOweMain)? verificationWidgetCtrl.owe : 0) | parseNumber}}\"></strong></div><div class=\"col-xs-3 text-right amounth-total\" style=\"padding: 0 6px 0 0px; position: relative; left: -8px;\"><div tooltip-placement=bottom-right uib-tooltip=\"Мы должны\">Мы должны</div><strong ng-bind=\"((verificationWidgetCtrl.isWeOweMain)? verificationWidgetCtrl.owe : 0) | parseNumber\" tooltip-placement=bottom-right uib-tooltip=\"{{((verificationWidgetCtrl.isWeOweMain)? verificationWidgetCtrl.owe : 0) | parseNumber}}\"></strong></div></div><div class=collapse-toggle data-toggle=collapse data-target=#documentsData aria-expanded=false aria-controls=documentsData ng-click=\"verificationWidgetCtrl.getData(false, true);\" ng-if=\"!verificationWidgetCtrl.noPermissions && !verificationWidgetCtrl.someError\" ng-class=\"{\'collapsed\': !verificationWidgetCtrl.showData}\">Последние операции <span class=arrow></span></div><div class=collapse id=documentsData ng-class=\"{\'in\': verificationWidgetCtrl.showData}\"><div ng-if=\"!verificationWidgetCtrl.documentsData.length && !verificationWidgetCtrl.load\" style=\"margin: 25px 0 30px 0;\">Операций по договору не найдено</div><div ng-show=verificationWidgetCtrl.load><div class=ui-spinner></div></div><div class=document-widget-wrapper ng-show=\"verificationWidgetCtrl.documentsData.length && !verificationWidgetCtrl.load\"><div ng-repeat=\"document in verificationWidgetCtrl.documentsData\" class=clearfix><div class=\"document-name-wrapper col-xs-5\" style=\"padding-left: 0;\"><a ui-sref=\"document.view({type: document.document.document_type,  purpose: document.document.document_purpose, id: document.document.id, parent: $state.params.parent })\" target=_blank class=document-name ng-bind=\"\'№\' + document.document.number + \' от \' + (document.document.date | date:\'dd.MM.yyyy HH:mm\' : $root.user.time_zone_ext.offset)\"></a><div class=document-purpose>{{document.document.document_purpose | documentPurpose}} {{(document.isSecondDoc || document.withoutCNI)? \'(без документа приёмки)\' : \'\'}} {{(document.percent)? \'(проценты)\' : \'\'}}</div></div><div class=\"col-xs-4 text-right tooltip-label\" ng-bind=\"(document.isYourOwe)? (document.owe | parseNumber) : \'\'\" style=\"padding: 0 3px 0 3px;\" tooltip-placement=bottom-right uib-tooltip=\"{{(document.isYourOwe)? (document.owe | parseNumber) : \'\'}}\"></div><div class=\"col-xs-3 text-right tooltip-label\" ng-bind=\"(document.isYourOwe)? \'\' : (document.owe | parseNumber)\" style=\"padding: 0 0 0 3px;\" tooltip-placement=bottom-right uib-tooltip=\"{{(document.isYourOwe)? \'\' : (document.owe | parseNumber)}}\"></div></div></div><div class=document-wrapper ng-show=\"verificationWidgetCtrl.documentsData.length && !verificationWidgetCtrl.load\"><div class=\"col-xs-5 text-right\">Остаток</div><strong class=\"col-xs-4 text-right tooltip-label\" ng-bind=\"(verificationWidgetCtrl.isWeOwe)? \'\' : (verificationWidgetCtrl.residue | parseNumber)\" style=\"padding: 0 3px 0 3px;\" tooltip-placement=bottom-right uib-tooltip=\"{{(verificationWidgetCtrl.isWeOwe)? \'\' : (verificationWidgetCtrl.residue | parseNumber)}}\"></strong> <strong class=\"col-xs-3 text-right tooltip-label\" ng-bind=\"(verificationWidgetCtrl.isWeOwe)? (verificationWidgetCtrl.residue | parseNumber) : \'\'\" style=\"padding: 0 0 0 3px;\" tooltip-placement=bottom-right uib-tooltip=\"{{(verificationWidgetCtrl.isWeOwe)? (verificationWidgetCtrl.residue | parseNumber) : \'\'}}\"></strong></div></div></div><div class=widget-settings ng-if=verificationWidgetCtrl.settingsmode><label class=widget-body-title>Показывать последние операции по:</label><div class=radio-group><div class=\"radio pull-left\"><label><input type=radio ng-model=verificationWidgetCtrl.showCount name=showCount id=five ng-value=5> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=status-name for=five>5</label></div><div class=radio-group><div class=\"radio pull-left\"><label><input type=radio ng-model=verificationWidgetCtrl.showCount name=showCount id=ten ng-value=10> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=status-name for=ten>10</label></div><div class=radio-group><div class=\"radio pull-left\"><label><input type=radio ng-model=verificationWidgetCtrl.showCount name=showCount id=twenty ng-value=20> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=status-name for=twenty>20</label></div></div>");
$templateCache.put("app/base/header/navbar/dropdownMenu/alco.html","<ul class=\"sub-menu center-sub-menu\"><li ng-if=\"($root.alcohol_products && ($root.hasRole(\'beginning_balance_egais.read\') || $root.hasRole(\'consignment_note_in_egais.read\') || $root.hasRole(\'alcohol_stock.read\') || $root.hasRole(\'beer_declaration.read\')))\"><span ng-if=\"$root.alcohol_products && $root.hasRole(\'consignment_note_in_egais.read\')\"><a ui-sref=\"invoiceWaybills({parent:\'alcohol\'})\">Приемки ТТН</a></span> <span ng-if=\"$root.alcohol_products && $root.hasRole(\'beginning_balance_egais.read\')\"><a ui-sref=\"beginningBalanceEgaisList({parent:\'alcohol\'})\">Остатки ЕГАИС</a></span> <span ng-if=\"$root.hasRole(\'alcohol_stock.read\')\"><a ui-sref=\"stockBalanceEgaisList({parent:\'alcohol\'})\">Складские остатки алкоголя</a></span> <span ng-if=\"$root.hasRole(\'beer_declaration.read\')\"><a ui-sref=\"beerDeclarations({parent:\'alcohol\'})\">Пивные декларации</a></span></li><li ng-if=\"$root.alcohol_products && ($root.hasRole(\'write_off_statement_egais.read\') || $root.hasRole(\'write_up_statement_egais.read\') || $root.hasRole(\'write_return_egais.read\') || $root.hasRole(\'transfer_between_register_egais.read\'))\"><span ng-if=\"$root.hasRole(\'write_off_statement_egais.read\')\"><a ui-sref=\"cancellationActsList({parent:\'alcohol\'})\">Списания</a></span> <span ng-if=\"$root.hasRole(\'write_up_statement_egais.read\')\"><a ui-sref=\"writeUpStatementsList({parent:\'alcohol\'})\">Оприходования</a></span> <span ng-if=\"$root.hasRole(\'write_return_egais.read\')\"><a ui-sref=\"writeReturnList({parent:\'alcohol\'})\">Розничные возвраты</a></span> <span ng-if=\"$root.hasRole(\'transfer_between_register_egais.read\')\"><a ui-sref=\"transferBetweenRegisterList({parent:\'alcohol\'})\">Переводы между регистрами</a></span></li><li ng-if=\"$root.hasRole(\'alcohol_settings.write\') || ($root.alcohol_products && $root.hasRole(\'egais_connection.read\'))\"><span ng-if=\"$root.hasRole(\'egais_connection.read\')\"><a ui-sref=\"utmConnections({parent:\'alcohol\'})\">Подключения к УТМ</a></span> <span ng-if=\"$root.hasRole(\'alcohol_settings.write\')\"><a ui-sref=\"alcoholSettings({parent:\'alcohol\'})\">Настройки реализации<br>алкогольной продукции</a></span></li></ul>");
$templateCache.put("app/base/header/navbar/dropdownMenu/money.html","<ul class=\"sub-menu center-sub-menu\"><li ng-if=\"($root.hasRole(\'cash_payment.read\') || $root.hasRole(\'cash_receipt.read\') || $root.hasRole(\'non_cash_payment.read\') || $root.hasRole(\'non_cash_receipt.read\') || $root.hasRole(\'advance_report.read\')) && $root.accountingSettings.financial_accounting_enabled\"><span ng-if=\"$root.hasRole(\'cash_payment.read\')\"><a ui-sref=\"documents({type:\'CASH_PAYMENT\', parent:\'money\'})\">Расходные кассовые ордера</a> </span><span ng-if=\"$root.hasRole(\'cash_receipt.read\')\"><a ui-sref=\"documents({type:\'CASH_RECEIPT\', parent:\'money\'})\">Приходные кассовые ордера</a> </span><span ng-if=\"$root.hasRole(\'non_cash_payment.read\')\"><a ui-sref=\"documents({type:\'NON_CASH_PAYMENT\', parent:\'money\'})\">Исходящие платежи</a> </span><span ng-if=\"$root.hasRole(\'non_cash_receipt.read\')\"><a ui-sref=\"documents({type:\'NON_CASH_RECEIPT\', parent:\'money\'})\">Входящие платежи</a> </span><span ng-if=\"$root.hasRole(\'advance_report.read\')\"><a ui-sref=\"documents({type:\'ADVANCE_REPORT\', parent:\'money\'})\">Авансовые отчеты</a></span></li><li ng-if=\"($root.hasRole(\'money_transfer.read\') || $root.hasRole(\'invoice_in.read\') || $root.hasRole(\'invoice_out.read\') || $root.hasRole(\'tax_charge.read\')) && $root.accountingSettings.financial_accounting_enabled\"><span ng-if=\"$root.hasRole(\'money_transfer.read\')\"><a ui-sref=\"documents({type:\'MONEY_TRANSFER\', parent:\'money\'})\">Перемещения денежных средств</a> </span><span ng-if=\"$root.hasRole(\'invoice_in.read\')\"><a ui-sref=\"documents({type:\'INVOICE_IN\', parent:\'money\'})\">Полученные счета-фактуры</a> </span><span ng-if=\"$root.hasRole(\'invoice_out.read\')\"><a ui-sref=\"documents({type:\'INVOICE_OUT\', parent:\'money\'})\">Выданные счета-фактуры</a> </span><span ng-if=\"$root.hasRole(\'tax_charge.read\')\"><a ui-sref=\"documents({type:\'TAX_CHARGE\', parent:\'money\'})\">Начисления налогов и сборов</a></span></li><li ng-if=\"$root.hasRole(\'counterparty.read\') || $root.hasRole(\'expense_item.read\') || $root.hasRole(\'contract.read\') || $root.hasRole(\'payment_type.read\') || $root.hasRole(\'all_documents.read\')\"><span ng-if=\"$root.hasRole(\'counterparty.read\')\"><a ui-sref=\"contragents({parent:\'money\'})\">Контрагенты</a> </span><span ng-if=\"$root.hasRole(\'contract.read\')\"><a ui-sref=\"contracts({parent:\'money\'})\">Договоры</a> </span><span ng-if=\"$root.hasRole(\'payment_type.read\')\"><a ui-sref=\"paymentTypes({parent:\'money\'})\">Способы оплаты</a> </span><span ng-if=\"$root.hasRole(\'expense_item.read\') && $root.accountingSettings.financial_accounting_enabled\"><a ui-sref=\"expenseItems({parent:\'money\'})\">Статьи затрат</a> </span><span ng-if=\"$root.hasRole(\'all_documents.read\') && $root.accountingSettings.financial_accounting_enabled\"><a ui-sref=\"allDocuments({parent: \'money\'})\">Все документы</a></span></li><li ng-if=\"$root.hasRole(\'project.read\') || $root.hasRole(\'currency.read\') || $root.hasRole(\'bank_product_request.write\') && $root.hasRole(\'report.profit_and_loss\') || $root.hasRole(\'report.cash_flow\')\"><span ng-if=\"$root.hasRole(\'project.read\')\"><a ui-sref=\"projects({parent:\'money\'})\">Проекты</a> </span><span ng-if=\"$root.hasRole(\'currency.read\')\"><a ui-sref=\"currencies({parent:\'money\'})\">Валюты</a> </span><span ng-if=\"$root.hasRole(\'report.profit_and_loss\') && $root.accountingSettings.financial_accounting_enabled\"><a ng-click=$ctrl.openReportProfitAndLoss()>Прибыль и убытки</a> </span><span ng-if=\"$root.hasRole(\'report.cash_flow\') && $root.accountingSettings.financial_accounting_enabled\"><a ng-click=$ctrl.openReportCashFlow()>Движение денежных средств</a> </span><span ng-if=\"$root.hasRole(\'bank_product_request.write\')\"><a ui-sref=\"bankProductRequest({parent:\'money\'})\">Получить кредит в банке <span ng-if=$ctrl.activeBankProductRequestCounter class=dot>{{$ctrl.activeBankProductRequestCounter}}</span></a></span></li></ul>");
$templateCache.put("app/base/header/navbar/dropdownMenu/partnership.html","<ul class=\"sub-menu center-sub-menu\"><li><span><a ui-sref=\"partnerSettings({parent:\'partnership\'})\">Настройки партнера</a></span> <span ng-if=\"$root.partner && $root.hasAnyRole([\'client.read\', \'client.write\'])\"><a ui-sref=\"partners({parent:\'partnership\'})\">Привлеченные клиенты</a></span></li><li><span ng-if=\"$root.partner && $root.hasAnyRole([\'client.read\', \'client.write\'])\"><a ui-sref=\"partnerBonuses({parent:\'partnership\'})\">Детализация бонусов</a></span> <span ng-if=\"$root.partner && $root.hasAnyRole([\'client.read\', \'client.write\'])\"><a ui-sref=\"closePeriod({parent:\'partnership\'})\">Закрытые периоды</a></span></li></ul>");
$templateCache.put("app/base/header/navbar/dropdownMenu/purchase.html","<ul class=\"sub-menu center-sub-menu\"><li ng-if=\"($root.hasRole(\'stock_period_totals.read\') && $root.hasRole(\'report.sale_totals\')) || $root.hasRole(\'purchase_order.read\') || $root.hasRole(\'payment_request_in.read\')\"><span ng-if=\"$root.hasRole(\'stock_period_totals.read\') && $root.hasRole(\'report.sale_totals\')\"><a ui-sref=\"stockAnalysis({parent:\'purchase\'})\">Товарные запасы</a></span> <span ng-if=\"$root.hasRole(\'purchase_order.read\')\"><a ui-sref=\"documents({type:\'PURCHASE_ORDER\', parent:\'purchase\'})\">Заказы на&nbsp;закупку</a></span> <span ng-if=\"$root.hasRole(\'payment_request_in.read\')\"><a ui-sref=\"documents({type:\'PAYMENT_REQUEST_IN\', parent:\'purchase\'})\">Счета на&nbsp;оплату от&nbsp;поставщиков</a></span></li><li ng-if=\"$root.hasRole(\'invoice_in.read\') || $root.hasRole(\'commissioners_report_out.read\')\"><span ng-if=\"$root.hasRole(\'invoice_in.read\')\"><a ui-sref=\"documents({type:\'INVOICE_IN\', parent:\'purchase\'})\">Полученные счет-фактуры</a></span> <span ng-if=\"$root.hasRole(\'commissioners_report_out.read\')\"><a ui-sref=\"documents({type:\'COMMISSIONERS_REPORT_OUT\', parent:\'purchase\'})\">Выданные отчеты комиссионера</a></span></li><li ng-if=\"$root.hasRole(\'purchase_price_list.read\') || $root.hasRole(\'catalog.read\') || $root.hasRole(\'counterparty.read\') || $root.hasRole(\'counterparty.read\')\"><span ng-if=\"$root.hasRole(\'purchase_price_list.read\')\"><a ui-sref=\"priceList({parent: \'PURCHASE\'})\" title=\"Закупочный прайс-лист\">Закупочный прайс-лист</a></span> <span ng-if=\"$root.hasRole(\'catalog.read\')\"><a ui-sref=\"catalog({parent:\'purchase\'})\">Каталог товаров&nbsp;и&nbsp;услуг</a></span> <span ng-if=\"$root.hasRole(\'counterparty.read\')\"><a ui-sref=\"contragents({parent:\'purchase\'})\">Поставщики</a></span></li></ul>");
$templateCache.put("app/base/header/navbar/dropdownMenu/retail.html","<ul class=\"sub-menu center-sub-menu\"><li ng-if=\"$root.hasRole(\'cash_register_docs.read\')\"><span ng-if=\"$root.hasRole(\'cash_register_docs.read\')\"><a ui-sref=\"cashregshifts({parent: \'retail\'})\">Смены</a></span> <span ng-if=\"$root.hasRole(\'cash_register_docs.read\')\"><a ui-sref=\"cashregreceipts({parent: \'retail\'})\">Кассовые чеки</a></span> <span ng-if=\"$root.hasRole(\'cash_register_docs.read\')\"><a ui-sref=\"returns({parent: \'retail\'})\">Возвраты</a></span></li><li ng-if=\"$root.hasRole(\'cash_register_docs.read\') || $root.hasRole(\'report.sale_totals\')\"><span ng-if=\"$root.hasRole(\'cash_register_docs.read\')\"><a ui-sref=\"cashboxreplenishments({parent: \'retail\'})\">Внесения</a></span> <span ng-if=\"$root.hasRole(\'cash_register_docs.read\')\"><a ui-sref=\"encashments({parent: \'retail\'})\">Выемки</a></span> <span ng-if=\"$root.hasRole(\'report.sale_totals\')\"><a ng-click=$ctrl.openPrintSalesTotalDialog()>Отчёт о розничных продажах</a></span></li><li ng-if=\"$root.hasRole(\'price_list.read\') || $root.hasRole(\'catalog.read\') || $root.hasRole(\'retail_discount.read\')\"><span ng-if=\"$root.hasRole(\'price_list.read\')\"><a ui-sref=\"priceList({parent: \'RETAIL\'})\">Розничный прайс-лист</a></span> <span ng-if=\"$root.hasRole(\'catalog.read\')\"><a ui-sref=\"catalog({parent: \'retail\'})\">Каталог товаров&nbsp;и&nbsp;услуг</a></span> <span ng-if=\"$root.hasRole(\'retail_discount.read\')\"><a ui-sref=\"discounts({parent: \'retail\'})\">Скидочные акции</a></span></li><li ng-if=\"$root.hasRole(\'price_tag_settings.write\') || $root.hasRole(\'catalog_category.write\') || ($root.hasRole(\'report.sale_totals\') && !$root.permission.hasNoDivisionsAccess)\"><span ng-if=\"$root.hasRole(\'price_tag_settings.write\')\"><a ui-sref=priceTagsSettings>Настройка печати ценников</a></span> <span ng-if=\"$root.hasRole(\'catalog_category.write\')\"><a ui-sref=markedProductSettings>Настройка реализации маркированного товара</a></span> <span ng-if=\"$root.hasRole(\'report.sale_totals\') && !$root.permission.hasNoDivisionsAccess\"><a ui-sref=\"salesTotalsPrint({parent: \'retail\'})\">Сводный отчет о продажах</a></span></li></ul>");
$templateCache.put("app/base/header/navbar/dropdownMenu/sale.html","<ul class=\"sub-menu center-sub-menu\"><li ng-if=\"$root.hasRole(\'sales_order.read\') || $root.hasRole(\'payment_request_out.read\')\"><span ng-if=\"$root.hasRole(\'sales_order.read\')\"><a ui-sref=\"documents({type:\'SALES_ORDER\', parent:\'sale\'})\">Заказы на&nbsp;продажу&nbsp;покупателям</a></span> <span ng-if=\"$root.hasRole(\'payment_request_out.read\')\"><a ui-sref=\"documents({type:\'PAYMENT_REQUEST_OUT\', parent:\'sale\'})\">Счета на&nbsp;оплату покупателям</a></span></li><li ng-if=\"$root.hasRole(\'invoice_out.read\') || $root.hasRole(\'commissioners_report_in.read\')\"><span ng-if=\"$root.hasRole(\'invoice_out.read\')\"><a ui-sref=\"documents({type:\'INVOICE_OUT\', parent:\'sale\'})\">Выданные счета-фактуры</a></span> <span ng-if=\"$root.hasRole(\'commissioners_report_in.read\')\"><a ui-sref=\"documents({type:\'COMMISSIONERS_REPORT_IN\', parent:\'sale\'})\">Полученные отчеты комиссионера</a></span></li><li ng-if=\"$root.hasRole(\'wholesale_price_list.read\') || $root.hasRole(\'catalog.read\') || $root.hasRole(\'counterparty.read\')\"><span ng-if=\"$root.hasRole(\'wholesale_price_list.read\')\"><a ui-sref=\"priceList({parent: \'WHOLE_SALE\'})\">Оптовый прайс-лист</a></span> <span ng-if=\"$root.hasRole(\'catalog.read\')\"><a ui-sref=\"catalog({parent: \'sale\'})\">Каталог товаров&nbsp;и&nbsp;услуг</a></span> <span ng-if=\"$root.hasRole(\'counterparty.read\')\"><a ui-sref=\"contragents({parent: \'sale\'})\">Покупатели</a></span></li></ul>");
$templateCache.put("app/base/header/navbar/dropdownMenu/storehouse.html","<ul class=\"sub-menu center-sub-menu\"><li ng-if=\"$root.hasRole(\'consignment_note_in.read\') || $root.hasRole(\'consignment_note_out.read\') || $root.hasRole(\'internal_consignment_note.read\')\"><span ng-if=\"$root.hasRole(\'consignment_note_in.read\')\"><a ui-sref=\"documents({type:\'CONSIGNMENT_NOTE_IN\', parent:\'storehouse\'})\">Приемки товара</a></span> <span ng-if=\"$root.hasRole(\'consignment_note_out.read\')\"><a ui-sref=\"documents({type:\'CONSIGNMENT_NOTE_OUT\', parent:\'storehouse\'})\">Отгрузки товара</a></span> <span ng-if=\"$root.hasRole(\'internal_consignment_note.read\')\"><a ui-sref=\"documents({type:\'INTERNAL_CONSIGNMENT_NOTE\', parent:\'storehouse\'})\">Перемещения</a></span></li><li ng-if=\"$root.hasRole(\'inventory.read\') || $root.hasRole(\'write_up_statement.read\') || $root.hasRole(\'beginning_balance_sku.read\')\"><span ng-if=\"$root.hasRole(\'inventory.read\')\"><a ui-sref=\"documents({type:\'INVENTORY\', parent:\'storehouse\'})\">Инвентаризации</a></span> <span ng-if=\"$root.hasRole(\'write_off_statement.read\')\"><a ui-sref=\"documents({type:\'WRITE_OFF_STATEMENT\', parent:\'storehouse\'})\">Списания</a></span> <span ng-if=\"$root.hasRole(\'write_up_statement.read\')\"><a ui-sref=\"documents({type:\'WRITE_UP_STATEMENT\', parent:\'storehouse\'})\">Оприходования</a></span> <span ng-if=\"$root.hasRole(\'beginning_balance_sku.read\')\"><a ui-sref=\"documents({type:\'BEGINNING_BALANCE_SKU\', parent:\'storehouse\'})\">Начальные остатки</a></span></li><li ng-if=\"$root.hasRole(\'stock_period_totals.read\') || $root.hasRole(\'catalog.read\')\"><span ng-if=\"$root.hasRole(\'catalog.read\')\"><a ui-sref=\"catalog({parent: \'storehouse\'})\">Каталог товаров и услуг</a></span> <span ng-if=\"$root.hasRole(\'stock_period_totals.read\')\"><a ui-sref=\"stock({parent: \'storehouse\'})\">Складские остатки</a></span> <span ng-if=\"$root.hasRole(\'stock_period_totals.read\')\"><a ui-sref=\"stockTotal({parent: \'storehouse\'})\">Складские обороты</a></span></li><li ng-if=\"$root.hasRole(\'stock_period_totals.read\') || $root.hasRole(\'report.sale_totals\') || $root.hasRole(\'inventory_tag_settings.write\')\"><span ng-if=\"$root.hasRole(\'stock_period_totals.read\')\"><a ui-sref=\"transactions({parent: \'storehouse\'})\">Складские операции</a></span> <span ng-if=\"$root.hasRole(\'stock_period_totals.read\') && $root.hasRole(\'report.sale_totals\')\"><a ui-sref=\"stockAnalysis({parent:\'storehouse\'})\">Товарные запасы</a></span> <span ng-if=\"$root.hasRole(\'inventory_tag_settings.write\')\"><a ui-sref=\"inventoryTagSettings({parent: \'storehouse\'})\">Настройки печати этикеток</a></span></li></ul>");
$templateCache.put("app/base/header/navbar/dropdownMenu/structure.html","<ul class=\"sub-menu center-sub-menu\" ng-if=\"$root.hasAnyRole([\'user.read\', \'company.read\', \'division.read\'])\"><li ng-if=\"$root.hasRole(\'company.read\') || $root.hasRole(\'division.read\') || $root.hasRole(\'user.read\')\"><span ng-if=\"$root.hasRole(\'company.read\')\"><a ui-sref=\"companies({parent:\'business\'})\">Компании</a></span> <span ng-if=\"$root.hasRole(\'division.read\')\"><a ui-sref=\"divisions({parent:\'business\'})\">Подразделения</a></span> <span ng-if=\"$root.hasRole(\'user.read\')\"><a ui-sref=\"employees({parent:\'business\'})\">Сотрудники</a></span></li><li ng-if=\"$root.hasRole(\'beneficiary.read\') || $root.hasAnyRole([\'client.read\', \'client.write\'])\"><span ng-if=\"$root.hasRole(\'beneficiary.read\')\"><a ui-sref=\"beneficiaries({parent:\'business\'})\">Бенефициары</a></span></li></ul>");
$templateCache.put("app/catalog/alcoholSettings/directives/calendar/calendar.html","<section class=\"tab-form-group col-xs-9 calendars\"><h5 class=section-header>КАЛЕНДАРЬ РЕАЛИЗАЦИИ</h5><span class=\"add-new-tab tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Добавить новый календарь\" ng-click=vm.addCalendar() style=\"top: 60px;\"></span><scrollable-tabset api=vm.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset active=vm.activeCalendar><uib-tab ng-repeat=\"calendar in vm.alcoholSettings.calendars track by $index\" index=\"$index + 1\" select=vm.selectTab($index)><uib-tab-heading class=tab-heading><span class=pull-left>{{calendar.name || \"Календарь \" + ($index+1)}}</span><span class=\"close-tab danger-close tooltip-light\" tooltip-placement=right uib-tooltip=Удалить ng-click=\"calendar.$$askRemove = true;\" ng-if=\"vm.alcoholSettings.calendars.length > 1\"></span><div class=remove-tab ng-class=\"{\'ask-remove\': calendar.$$askRemove}\"><span class=\"glyphicon glyphicon-trash\"></span><label class=tab-remove-label>Удалить?</label><span class=pull-right><span class=tab-remove-yes ng-click=\"vm.removeCalendar($index, $event);\">Да</span>/ <span class=tab-remove-no ng-click=\"calendar.$$askRemove = false;\">Нет</span></span></div></uib-tab-heading><div><div style=\"display: flex\"><div class=\"form-group no-fixed-width-group\" ng-class=\"{\'has-error-unique\': vm.errorInd.length && vm.errorInd.indexOf($index) + 1}\"><input empty-to-null type=text class=form-control value=calendar.name ng-model=calendar.name required maxlength=20 ng-focus=\"vm.oldName = calendar.name\" ng-blur=vm.checkCalendarName(); ng-keyup=\"vm.errorInd = [];vm.changeName(calendar)\" id=\"{{$index}}name\"><label for=\"{{$index}}name\" class=\"form-control-label small-offset\">Наименование календаря</label><div class=\"valid-message isset-name\">Наименование уже существует</div><span class=req></span></div><div class=\"form-group fixed-width-group\"><ui-select ng-model=calendar.$$type search-enabled=false on-select=vm.changeTimetable(calendar) ng-required=true><ui-select-match><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"type.id as type in vm.timetable track by $index\"><span ng-bind-html=type.name></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Дни продажи</label></div></div><div class=\"timetable-wrapper clearfix\"><div class=\"calendar-thead pull-right\"><span>Время продажи</span> <span>с</span> <span>до</span></div><div class=clear></div><div class=\"calendar-tbody clearfix\" ng-repeat=\"item in calendar.calendar_items\" ng-if=\"item.type != \'EXCEPTIONAL_DATE\'\"><div class=day-name ng-class=\"{\'weekend\': item.day_of_week == 5 || item.day_of_week == 6}\" ng-switch=item.type><span ng-switch-when=ANY_DAY>Ежедневно<span class=req></span></span> <span ng-switch-when=DAY_OF_WEEK ng-bind-html=\"vm.days[item.day_of_week] + \'<span class=\\\'req\\\'></span>\'\"></span> <span ng-switch-when=WORKING_DAY>По будням<span class=req></span></span> <span ng-switch-when=DAY_OFF>По выходным<span class=req></span></span></div><div class=\"day-options pull-right\"><div class=time-mode><ui-select ng-model=item.$$mode search-enabled=false ng-required=true on-select=vm.changeMode(item); class=slim-control><ui-select-match placeholder=Выберите><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"mode.id as mode in vm.calendarsMode\"><span ng-bind=mode.name></span></ui-select-choices></ui-select></div><div class=interval ng-if=\"item.$$mode == \'interval\'\"><span class=time-wrapper><input empty-to-null type=text class=\"form-control slim-control\" name=\"with{{item.$$uiid}}\" ng-model=item.from_time required ng-pattern=/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ ui-mask=99:99 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-change=vm.checkTime(item) model-view-value=\"{{true}}\"> </span><span class=time-wrapper><input empty-to-null type=text class=\"form-control slim-control\" name=\"to{{item.$$uiid}}\" ng-model=item.to_time required ng-pattern=/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ ui-mask=99:99 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-change=vm.checkTime(item) model-view-value=\"{{true}}\"></span></div></div></div></div><div class=\"exceptions-wrapper timetable-wrapper\"><h5>ИСКЛЮЧЕНИЯ ДЛЯ ДАТ:</h5><div class=\"calendar-thead pull-left\" ng-if=\"calendar.calendar_items.length > 1\"><span>Дата</span></div><div class=\"calendar-thead pull-right\" ng-if=\"calendar.calendar_items.length > 1\" style=\"margin-right: 24px;\"><span>Время продажи</span> <span>с</span> <span>до</span></div><div class=clear></div><div class=\"calendar-tbody clearfix\" ng-repeat=\"item in calendar.calendar_items\" ng-if=\"calendar.$$hasException && item.type == \'EXCEPTIONAL_DATE\'\"><div style=\"width: 100%;\"><div date-range-picker ng-model=item.exceptional_date_model opts=vm.datePickerOpts state=vm.dateState disabled-days=vm.disabledDays[calendar.$$uiid] class=datepicker-wrap ng-required=true name=\"exceptional_date{{item.$$uiid}}\" on-close=\"vm.onDatePickerClose(returnValue, name, item, calendar)\"></div><div class=\"valid-message wrong-format-mess\" style=display:block ng-show=\"personalDataForm.birth_date.$error.mask && date_blur\">Некорректный формат</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=\"day-options pull-right\" style=\"position: relative;\"><div class=time-mode><ui-select ng-model=item.$$mode search-enabled=false ng-required=true on-select=vm.changeMode(item); class=slim-control><ui-select-match placeholder=Выберите><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"mode.id as mode in vm.calendarsMode\"><span ng-bind=mode.name></span></ui-select-choices></ui-select></div><div class=interval ng-if=\"item.$$mode == \'interval\'\"><span class=time-wrapper><input empty-to-null type=text class=\"form-control slim-control\" name=\"with{{item.$$uiid}}\" ng-model=item.from_time required ng-pattern=/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ ui-mask=99:99 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-change=vm.checkTime(item) model-view-value=\"{{true}}\"> </span><span class=time-wrapper><input empty-to-null type=text class=\"form-control slim-control\" name=\"to{{item.$$uiid}}\" ng-model=item.to_time required ng-pattern=/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ ui-mask=99:99 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-change=vm.checkTime(item) model-view-value=\"{{true}}\"></span></div><span class=\"glyphicon glyphicon-trash tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Удалить ng-click=\"vm.removeException(calendar, $index);\"></span></div></div><div class=add-item-wrap ng-click=vm.addException(calendar) style=\"margin-top: 16px;\"><span class=add-item-icon></span> <span class=add-item-title>исключение</span></div></div></div></uib-tab></uib-tabset></scrollable-tabset></section><div class=\"col-xs-3 section-helper\" style=\"margin-bottom: 24px;\">Укажите конкретные даты, для которых продажа алкоголя производится по особому графику или запрещена</div>");
$templateCache.put("app/catalog/catalogItem/sections/services/catalogServicesMain.html","<div class=\"catalog catalogItem crud-entity\" ng-class=\"(vm.stateName.endsWith(\'view\'))? \'view-entity\': \'\'\"><div style=\"max-width: 1000px; position: relative;\"><div ng-if=\"vm.stateName.endsWith(\'new\')\"><h1>Добавить услугу</h1></div><div ng-if=\"vm.stateName.endsWith(\'edit\')\"><h1>Редактировать услугу<entity-history entity-data=vm.catalogItem></entity-history></h1></div><div ng-if=\"vm.stateName.endsWith(\'view\')\"><h1>Просмотр услуги<entity-history entity-data=vm.catalogItem></entity-history></h1></div><div class=\"for-small-width catalog-item-status\"><div class=\"status-button no-confirm\" ng-click=vm.statusPopup(); ng-if=\"vm.catalogItem.status == \'NOT_CONFIRMED\'\"><strong>не подтвержден</strong></div><div class=\"status-button archived\" ng-click=vm.archivePopup(true); ng-if=\"vm.catalogItem.status == \'ARCHIVED\'\"><strong>в архиве</strong></div><div class=\"status-button draft\" ng-click=vm.draftPopupInfo(); ng-if=\"vm.catalogItem.status == \'DRAFT\'\"><strong>черновик</strong></div></div></div><form action=\"\" name=addCatalogItem class=\"col-xs-9 crud-main-column\"><div class=\"full-width section top-buttons no-padding\" ng-if=\"!vm.stateName.endsWith(\'new\')\"><div ng-include=\"\'app/catalog/catalogItem/sections/buttons.html\'\"></div></div><div class=clear></div><div ng-include=\"\'app/catalog/catalogItem/sections/main-info.html\'\" class=\"clearfix full-width\"></div><div ng-include=\"\'app/catalog/catalogItem/sections/services/templates/taxInfoService.html\'\" class=\"clearfix full-width\"></div><div class=\"clearfix full-width\" ng-if=\"!vm.stateName.endsWith(\'view\')\"><section class=\"form-group mini-grid-wrapper full-width\"><h5 class=section-header>Расположение услуги</h5><div class=pull-right><button type=button style=\"margin-right: 9px\" class=\"btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Переместить ng-click=vm.showMoveDialog();><span class=\"btn-move btn-ico\"></span></button></div><div ng-show=!vm.treeCollapsed style=\"margin-right: 72px; position: relative;\" class=without-selected><div class=arrow-area ng-click=\"vm.treeCollapsed = true;\"></div><a href=\"\" ng-click=\"vm.treeCollapsed = true\" class=\"toggle-arrow up\"></a><catalog-tree class=background-simple root=vm.root item-count=none root-always-expand=true></catalog-tree></div><div ng-show=vm.treeCollapsed style=\"padding-left: 17px; padding-top: 8px; position: relative; display: inline-block\"><a href=\"\" ng-click=\"vm.treeCollapsed = false;\" class=\"toggle-arrow down\"></a> <span class=catalog-folder ng-click=\"vm.treeCollapsed = false;\"></span> <span style=\"margin-left: 10px; vertical-align: middle;\" ng-bind=vm.currentCategory.name></span></div></section></div><div class=\"clearfix full-width\"><div class=\"section full-width\" ng-include=\"\'app/catalog/catalogItem/sections/attributes.html\'\"></div></div><div class=\"clearfix full-width\" ng-hide=\"vm.nomenclature.length < 2\"><div class=section-description ng-if=\"!vm.stateName.endsWith(\'view\')\">На основании всех выбраных значений атрибутов будет создано:</div><section class=\"form-group title-out-group catalog-item-total full-width\" style=\"padding: 12px 12px 12px 24px;\"><span class=item-count ng-bind=vm.nomenclature.length></span> <span class=item-count-description>разных видов услуг</span> <a class=btn ng-click=vm.showGoodsLists()>Посмотреть</a></section></div></form><div class=\"col-xs-3 section-helper\"><button class=\"status-button no-confirm\" ng-click=vm.statusPopup(); ng-if=\"vm.catalogItem.status == \'NOT_CONFIRMED\'\"><strong>не подтвержден</strong></button> <button class=\"status-button archived\" ng-click=vm.archivePopup(true); ng-if=\"vm.catalogItem.status == \'ARCHIVED\'\"><strong>в архиве</strong></button> <button class=\"status-button draft\" ng-click=vm.draftPopupInfo(); ng-if=\"vm.catalogItem.status == \'DRAFT\'\"><strong>черновик</strong></button> <span ng-if=\"vm.catalogItem.status !== \'DRAFT\' && vm.catalogItem.status !== \'ARCHIVED\'\"><a href=\"\" ng-if=\"vm.stateName.endsWith(\'view\')\" ng-click=vm.showPricePopup(); style=\"padding-bottom: 8px;display: inline-block;line-height: 1;\"><span class=rub-ico></span>Посмотреть текущие<br>цены</a><br><price-tag-print catalog-items=[vm.catalogItem] ng-if=\"vm.stateName.endsWith(\'view\') && $root.hasRole(\'report.price_tags\')\" for-service=true></price-tag-print></span></div><!-- Виджет цен --><div class=\"row col-xs-3 catalog-item-widget section-helper\" style=\"max-width: 450px; margin-left: 0px; margin-top: 15px;\" ng-if=\"vm.catalogItem.status == \'CONFIRMED\'\"><widget-container widgets=vm.widget></widget-container></div><div class=clear></div><div class=\"col-xs-9 section bottom-buttons no-padding\" style=\"padding: 0;\"><div class=form-error ng-class=\"{\'show-form-error\': vm.isSetDirty}\"><span class=req-inform ng-show=\"vm.isSetDirty && (!vm.catalogItem.name || !vm.catalogItem.code)\">Поля, помеченные *, обязательные для заполнения </span><span class=req-inform ng-show=\"vm.isSetDirty && (vm.hasError.length || addCatalogItem.$error[\'wrong-date\'].length)\">Некоторые поля заполнены некорректными данными</span></div><div class=edit-view-buttons ng-include=\"\'app/catalog/catalogItem/sections/buttons.html\'\"></div></div></div>");
$templateCache.put("app/catalog/catalogItem/sections/services/catalogServicesSearch.html","<h1>Добавить услугу</h1><form ng-submit=vm.submit() role=form name=searchCatalogItem class=\"row search-catalog-wrapper\"><div class=\"clearfix full-width\"><div class=\"col-xs-9 section\"><section class=\"form-group tab-form-group col-xs-12\" style=\"margin-bottom: 0px\"><ul class=\"nav nav-tabs\"><li class=active><a href=.itemName data-toggle=tab>Наименование</a></li></ul><div class=tab-content><div class=\"tab-pane itemName active\"><div class=form-group><span class=\"glyphicon glyphicon-search\"></span> <input empty-to-null clear-button type=text class=\"form-control search-input slim-control\" ng-model=vm.searchItemName placeholder=\"Введите наименование услуги\"></div></div></div></section><div class=\"col-xs-12 section bottom-buttons no-padding\" style=\"margin-bottom: 48px\"><div class=edit-view-buttons><a ui-sref=\"catalogServices.new({searchName: vm.searchItemName, parent: $state.params.parent})\" class=\"btn btn-default\">Пропустить</a> <button class=\"btn btn-primary right-button\" ng-click=vm.search() ng-disabled=\"!vm.searchItemName || vm.showLoader\">Найти</button> <a class=\"btn btn-default right-button\" ng-click=vm.returnToPage()>Отменить</a></div></div></div><div class=\"col-xs-3 section-helper\">Возможно, услуга, которую Вы предоставляете, уже есть в нашей базе, тогда мы сами заполним всю информацию по ней. Вам останется только проверить и скорректировать данные при необходимости.</div></div><div class=\"clearfix full-width\"><div class=\"col-xs-9 section search-result-wrapper\"><inview-loader show=vm.showLoader style=\"position: absolute; left: 50%;margin-left: -2.5em;\"></inview-loader><h3 ng-show=vm.showSeach>Результаты поиска по наименованию</h3><div class=no-search-result ng-show=\"!vm.searchElements.length && vm.showSeach\">К сожалению, мы не смогли ничего найти. Попробуйте уточнить запрос, либо пропустите этот этап</div><ul class=search-result ng-show=\"vm.searchElements.length && vm.showSeach\"><li class=\"result-item clearfix row\" ng-repeat=\"item in vm.searchElements\"><div class=col-xs-3><div class=element-item></div></div><div class=col-xs-9><div class=element-title ng-bind=item.name></div><div class=element-description ng-bind=item.description></div><a ui-sref=\"catalogServices.new({searchElementId: item.id, parent: $state.params.parent})\" class=\"btn btn-primary pull-right\">Выбрать</a></div></li></ul></div><div class=\"col-xs-3 helper-search section-helper\" ng-show=\"vm.searchTotal > 9\"><div style=\"font-weight: bold;margin-top: 10px;\">ВНИМАНИЕ!</div>Мы вывели всего лишь 10 элементов из огромного числа тех, что есть в нашей базе. Если среди данных результатов Вы не нашли подходящий, пожалуйста, уточните наименование</div></div></form>");
$templateCache.put("app/catalog/catalogItem/sections/skus/catalogSkusMain.html","<div class=\"catalog catalogItem crud-entity\" ng-class=\"(vm.stateName.endsWith(\'view\'))? \'view-entity\': \'\'\"><div style=\"max-width: 1000px; position: relative;\"><div ng-if=\"vm.stateName.endsWith(\'new\')\"><h1>Добавить товар</h1></div><div ng-if=\"vm.stateName.endsWith(\'edit\')\"><h1>Редактировать товар<entity-history entity-data=vm.catalogSkus></entity-history></h1></div><div ng-if=\"vm.stateName.endsWith(\'view\')\"><h1>Просмотр товара<entity-history entity-data=vm.catalogSkus></entity-history></h1></div><div class=\"for-small-width catalog-item-status\"><div class=\"status-button no-confirm\" ng-click=vm.statusPopup(); ng-if=\"vm.catalogSkus.status == \'NOT_CONFIRMED\'\"><strong>не подтвержден</strong></div><div class=\"status-button archived\" ng-click=vm.archivePopup(true); ng-if=\"vm.catalogSkus.status == \'ARCHIVED\'\"><strong>в архиве</strong></div><div class=\"status-button draft\" ng-click=vm.draftPopupInfo(); ng-if=\"vm.catalogSkus.status == \'DRAFT\'\"><strong>черновик</strong></div><span ng-if=\"vm.catalogSkus.status !== \'DRAFT\' && vm.catalogSkus.status !== \'ARCHIVED\' && vm.stateName.endsWith(\'view\')\"></span></div></div><ng-form action=\"\" name=vm.addCatalogSkus class=\"col-xs-9 crud-main-column\"><div class=\"full-width section top-buttons no-padding\" ng-if=\"!vm.stateName.endsWith(\'new\')\"><div ng-include=\"\'app/catalog/catalogItem/sections/skus/templates/buttons.html\'\"></div></div><div class=clear></div><div ng-include=\"\'app/catalog/catalogItem/sections/skus/templates/mainInfoSkus.html\'\" class=\"clearfix full-width\"></div><div ng-include=\"\'app/catalog/catalogItem/sections/skus/templates/taxInfoSkus.html\'\" class=\"clearfix full-width\"></div><div class=\"clearfix full-width\" ng-if=\"!vm.stateName.endsWith(\'view\')\"><section class=\"form-group mini-grid-wrapper full-width\"><h5 class=section-header>Расположение товара</h5><div class=pull-right><button type=button style=\"margin-right: 9px\" class=\"btn slim-button only-ico tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Переместить ng-click=vm.showMoveDialog();><span class=\"btn-move btn-ico\"></span></button></div><div ng-show=!vm.treeCollapsed style=\"margin-right: 72px; position: relative;\" class=without-selected><div class=arrow-area ng-click=\"vm.treeCollapsed = true;\"></div><a href=\"\" ng-click=\"vm.treeCollapsed = true;\" class=\"toggle-arrow up\"></a><catalog-tree class=background-simple root=vm.root item-count=none root-always-expand=true></catalog-tree></div><div ng-show=vm.treeCollapsed style=\"padding-left: 17px; padding-top: 8px; position: relative; display: inline-block;\"><a href=\"\" ng-click=\"vm.treeCollapsed = false;\" class=\"toggle-arrow down\"></a> <span class=catalog-folder ng-click=\"vm.treeCollapsed = false;\"></span> <span style=\"margin-left: 10px; vertical-align: middle;\" ng-bind=vm.category.name></span></div></section></div><div class=\"clearfix full-width\" style=\"position: relative;\"><div class=\"section full-width\" ng-include=\"\'app/catalog/catalogItem/sections/attributes.html\'\"></div></div><div class=\"clearfix full-width\" style=\"position: relative;\"><section id=packingAnchor class=\"form-group full-width tab-form-group packing-wrapper\"><span class=\"add-new-tab tooltip-light\" ng-click=\"vm.addPack(vm.baseGroupPack); vm.buildDerivatives();\" ng-if=\"!vm.stateName.endsWith(\'view\')\" tooltip-placement=bottom-left uib-tooltip=\"Добавить новую упаковку\"></span><scrollable-tabset api=vm.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset class=custom-tabs-inner active=vm.activePack><uib-tab index=\"$index + 1\" ng-repeat=\"sku in vm.catalogSkus.sku_list track by $index\" select=vm.selectTab($index)><uib-tab-heading class=tab-heading><span class=\"tab-title {{sku.pack_type.ext_id}}-ico\" ng-class=\"{\'without-pack-ico\': sku.packaged}\"><span>{{sku.name || sku.pack_type.name}}</span><span class=\"close-tab danger-close tooltip-light\" tooltip-placement=right uib-tooltip=Удалить ng-click=\"sku.$$askRemove = true;\" ng-if=\"sku.pack_type.ext_id != \'PACK_BASE_UNIT\' || (vm.catalogSkus.sku_list | filter:{pack_type: {ext_id : \'PACK_BASE_UNIT\'}}).length > 1\"></span></span><div class=\"remove-tab major-font\" ng-class=\"{\'ask-remove\': sku.$$askRemove}\"><span class=\"glyphicon glyphicon-trash\"></span><label class=tab-remove-label>Удалить?</label><span class=pull-right><span class=tab-remove-yes ng-click=\"$event.preventDefault(); $event.stopPropagation(); vm.deleteSku(sku, $event, $index); vm.checkValidForm();vm.checkPackingName();\">Да</span>/ <span class=tab-remove-no ng-click=\"sku.$$askRemove = false;\">Нет</span></span></div></uib-tab-heading><div ng-form=\"{{\'sku\' + $index}}\" ng-include=\"\'app/catalog/catalogItem/sections/skus/templates/packing.html\'\" ng-class=\"{\'has-error-name\': vm.packNameError.length && vm.packNameError.indexOf($index)+1}\"></div></uib-tab></uib-tabset></scrollable-tabset></section><div class=\"col-xs-5 section-helper pack-helper\" ng-hide=\"vm.stateName.endsWith(\'view\')\">Вы можете добавить необходимые упаковки для данного товара</div></div><div class=\"clearfix full-width\" ng-hide=\"vm.allNomenclatureCounter < 2\"><div class=section-description ng-if=\"!vm.stateName.endsWith(\'view\')\">На основании всех выбраных значений атрибутов и упаковок будет создано:</div><section class=\"form-group title-out-group catalog-item-total full-width\" style=\"padding: 12px 12px 12px 24px;\"><span class=item-count ng-bind=vm.allNomenclatureCounter></span> <span class=item-count-description>разных складских<br>позиций</span> <a class=btn ng-click=vm.showGoodsLists()>Посмотреть</a></section></div><div class=clear></div></ng-form><div class=\"col-xs-3 section-helper\"><button class=\"status-button no-confirm\" ng-click=vm.statusPopup(); ng-if=\"vm.catalogSkus.status == \'NOT_CONFIRMED\'\"><strong>не подтвержден</strong></button> <button class=\"status-button archived\" ng-click=vm.archivePopup(true); ng-if=\"vm.catalogSkus.status == \'ARCHIVED\'\"><strong>в архиве</strong></button> <button class=\"status-button draft\" ng-click=vm.draftPopupInfo(); ng-if=\"vm.catalogSkus.status == \'DRAFT\'\"><strong>черновик</strong></button> <span ng-if=\"vm.catalogSkus.status !== \'DRAFT\' && vm.catalogSkus.status !== \'ARCHIVED\' && vm.stateName.endsWith(\'view\')\"><a href=\"\" ng-click=vm.showPricePopup(); style=\"padding-bottom: 8px;display: inline-block;line-height: 1;\"><span class=rub-ico></span>Посмотреть текущие<br>цены</a><br><price-tag-print catalog-items=[vm.catalogSkus] ng-if=\"$root.hasRole(\'report.price_tags\')\" for-service=false></price-tag-print><br><a ng-if=\"$root.hasRole(\'report.inventory_tags\') && vm.showInventoryTagButton\" href=\"\" ng-click=vm.openInventoryTagPrintModal() style=\"display: inline-block; line-height: 1\"><span class=price-tag-ico></span><span style=\"position: relative;top: 10px;\">Распечатать этикетки</span></a></span></div><!-- Виджет цен --><div class=\"row col-xs-3 catalog-item-widget section-helper\" style=\"max-width: 450px; margin-left: 0px; margin-top: 15px;\"><widget-container widgets=vm.widget></widget-container></div><div class=\"col-xs-9 section bottom-buttons\" style=\"padding: 0;\"><div class=form-error ng-class=\"{\'show-form-error\': vm.isSetDirty && (vm.isWrongValid || vm.hasError.length || vm.packNameError.length || vm.addCatalogSkus.$error[\'wrong-date\'].length)}\"><span class=req-inform ng-show=\"vm.isSetDirty && (!vm.catalogSkus.name || !vm.catalogSkus.code || !vm.packRequred)\">Поля, помеченные *, обязательные для заполнения </span><span class=req-inform ng-show=\"vm.isSetDirty && (vm.isWrongValid || vm.hasError.length || vm.packNameError.length || vm.addCatalogSkus.$error[\'wrong-date\'].length)\">Некоторые поля заполнены некорректными данными</span></div><div class=edit-view-buttons ng-include=\"\'app/catalog/catalogItem/sections/skus/templates/buttons.html\'\" class=row></div></div></div>");
$templateCache.put("app/catalog/catalogItem/sections/skus/catalogSkusSearch.html","<h1>Добавить товар</h1><form ng-submit=vm.submit() role=form name=searchCatalogSkus class=\"row search-catalog-wrapper\"><div class=\"clearfix full-width\"><div class=\"col-xs-9 section\"><section class=\"form-group tab-form-group col-xs-12\" style=\"margin-bottom: 0px\"><uib-tabset class=custom-tabs-inner active=vm.searchActive><uib-tab index=\"\'GTIN\'\"><uib-tab-heading>Штрих-код</uib-tab-heading><div class=tabContent><div class=form-group style=\"margin: 0;\"><span class=\"glyphicon glyphicon-search\"></span><div class=code-wraper><input hard-pruning data-check=[0-9] ng-pattern=\"/^(?=[0-9]*$)(?:.{8}|.{12}|.{13}|.{14})$/\" code type=text class=\"form-control code-input search-input slim-control\" maxlength=14 ng-model=vm.searchGtinName placeholder=\"Введите штрих-код\" name=searchGtin><div class=\"valid-message wrong-simbol-mess\">Для ввода доступны только цифры</div><div class=\"valid-message wrong-format-mess\">Штрих-код должен содержать 8, 12, 13 или 14 цифр</div></div></div></div></uib-tab><uib-tab index=\"\'NAME\'\"><uib-tab-heading>Наименование</uib-tab-heading><div class=tabContent><div class=form-group style=\"margin: 0;\"><span class=\"glyphicon glyphicon-search\"></span> <input empty-to-null clear-button type=text class=\"form-control search-input slim-control\" ng-model=vm.searchItemName placeholder=\"Введите наименование товара\"></div></div></uib-tab></uib-tabset></section><div class=\"col-xs-12 section bottom-buttons\" style=\"margin-bottom: 48px\"><div class=edit-view-buttons><a ui-sref=\"catalogSkus.new({searchName: vm.searchItemName, searchGtinName: searchCatalogSkus.searchGtin.$viewValue, parent: $state.params.parent})\" class=\"btn btn-default\">Пропустить</a> <button class=\"btn btn-primary right-button\" ng-click=vm.search() ng-disabled=\"vm.showLoader || ((vm.searchActive == \'GTIN\' && (searchCatalogSkus.searchGtin.$invalid || !vm.searchGtinName)) || vm.searchActive != \'GTIN\' && !vm.searchItemName)\">Найти</button> <a class=\"btn btn-default right-button\" ng-click=vm.returnToPage()>Отменить</a></div></div></div><div class=\"col-xs-3 section-helper\">Очень вероятно, товар, который Вы хотите добавить в свой каталог, уже есть в базе данных ассоциации GS1. Если так, мы сами заполним всю информацию по товару. Вам остаётся только ввести его штрих-код или наименование, потом проверить и скорректировать данные при необходимости.</div></div><div class=\"clearfix full-width\"><div class=\"col-xs-9 section search-result-wrapper\"><inview-loader show=vm.showLoader style=\"position: absolute; left: 50%;margin-left: -2.5em;\"></inview-loader><h3 ng-show=vm.showSeach>Результаты поиска по наименованию</h3><div class=no-search-result ng-show=\"!vm.searchElements.length && vm.showSeach\">К сожалению, мы не смогли ничего найти. Попробуйте воспользоваться поиском<br>по наименованию, либо пропустите этот этап</div><ul class=search-result ng-show=\"vm.searchElements.length && vm.showSeach\"><li class=\"result-item clearfix\" ng-repeat=\"item in vm.searchElements\"><div class=col-xs-3><div class=element-item></div></div><div class=col-xs-9><div class=element-title ng-bind=item.name></div><div class=element-description ng-bind=item.description></div><a ui-sref=\"catalogSkus.new({searchElementId: item.id, parent: $state.params.parent})\" class=\"btn btn-primary pull-right\">Выбрать</a></div></li></ul></div><div class=\"col-xs-3 helper-search section-helper\" ng-show=\"vm.searchTotal > 9\"><div style=\"font-weight: bold; margin-top: 10px;\">ВНИМАНИЕ!</div>Мы вывели всего лишь 10 элементов из огромного числа тех, что есть в нашей базе. Если среди данных результатов Вы не нашли подходящий, пожалуйста, уточните наименование</div></div></form>");
$templateCache.put("app/catalog/modals/search-alco-item/includes/control-box.html","<div><div class=control-box><h5 class=section-header>Поиск</h5><div ng-if=!searchCtrl.isShowForms2><div class=form-group><label>Наименование</label><input type=text calback=searchCtrl.search() class=\"form-control label-clear-button slim-control\" ng-model=searchCtrl.urlParams.catalog_search maxlength=30 ng-keydown=\"$event.stopPropagation(); $event.key === \'Enter\' && searchCtrl.search()\" ng-change=searchCtrl.checkIssetData() style=\"border-radius: 6px; width: 100%;\"></div><div class=form-group><label>Алкокод</label><input type=text calback=searchCtrl.search() class=\"form-control label-clear-button slim-control\" ng-model=searchCtrl.urlParams.alc_code_search maxlength=30 ng-keydown=\"$event.stopPropagation(); $event.key === \'Enter\' && searchCtrl.search()\" ng-change=searchCtrl.checkIssetData() style=\"border-radius: 6px; width: 100%;\"></div></div><div ng-if=searchCtrl.isShowForms2><div class=form-group><label>Документ поставки</label><ui-select ng-model=searchCtrl.form2_params.filter_document_id class=\"slim-control fsm-types\" search-enabled=\"searchCtrl.documentsTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-class=\"{\'autocomplete-select\': searchCtrl.documentsTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\" on-select=searchCtrl.getForms2();><ui-select-match><span title=\"{{\'№\' + $select.selected.doc_number + \' от \' + ($select.selected.doc_date | date:\'dd.MM.yyyy\') + \' \' + ($select.selected.document_egais_type | docEgaisType)}}\" ng-bind=\"\'№\' + $select.selected.doc_number + \' от \' + ($select.selected.doc_date | date:\'dd.MM.yyyy\') + \' \' + ($select.selected.document_egais_type | docEgaisType)\"></span></ui-select-match><ui-select-choices refresh-delay=500 width=800 refresh=searchCtrl.refreshDocuments($select.search) repeat=\"item.id as item in searchCtrl.documents\" group-by=searchCtrl.totalDocStr><span title=\"{{\'№\' + item.doc_number + \' от \' + (item.doc_date | date:\'dd.MM.yyyy\') + \' \' + (item.document_egais_type | docEgaisType)}}\" ng-bind=\"\'№\' + item.doc_number + \' от \' + (item.doc_date | date:\'dd.MM.yyyy\') + \' \' + (item.document_egais_type | docEgaisType)\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div></div></div></div><div class=modal-footer style=\"padding: 16px 0 0 0; width: 310px; display: flex;\" ng-if=!searchCtrl.isShowForms2><button class=\"btn col-xs-5\" type=button ng-click=searchCtrl.reset() ng-disabled=!searchCtrl.isIssetData>Сброс</button> <button class=\"btn btn-primary col-xs-7\" type=button ng-click=searchCtrl.search(true) style=\"margin-left: 8px;\" ng-disabled=\"searchCtrl.formInvalid || !searchCtrl.catalogItemSearchForm.$valid || !searchCtrl.isIssetData\">Найти</button></div><div class=modal-footer style=\"padding: 16px 0 0 0; width: 310px; display: flex;\" ng-if=searchCtrl.isShowForms2><a class=\"btn col-xs-6\" ng-click=searchCtrl.return() ng-if=!searchCtrl.onlyForm2><span class=\"btn-ico btn-arrow\"></span>Вернуться</a> <button class=\"btn btn-primary col-xs-6\" type=button ng-click=\"searchCtrl.showForm2SearchForm(searchCtrl.choseCatalogItem, $event);\" style=\"margin-left: 8px;\" ng-disabled=\"searchCtrl.formInvalid || !searchCtrl.catalogItemSearchForm.$valid || (!searchCtrl.form2_params.filter_document_id)\">Найти</button></div>");
$templateCache.put("app/catalog/modals/search-catalog-item/derivative-tab/derivative-tab.html","<div ng-scrollbars ng-scrollbars-config=configScroll ng-scrollbars-update=callbacks><a class=catalog-item-wrap ng-repeat=\"derivative in tabDerivatives\" ng-click=\"choiseCallback($event, derivative);\"><div class=catalog-item-name title=\"{{derivative.code}}\"> {{derivative.code}} <span class=catalog-item-code>{{derivative.name}}</span></div><div class=quontity ng-if=derivative.base_qty> {{derivative.base_qty}} {{(derivative.uom)? \' \' + derivative.uom.symbols + \'.\': \'\'}} <div class=\"divisions-qty-wrap text-left\" style=\"left: inherit; right: 0;\"><div ng-repeat=\"qty in derivative.qty_views\" ng-if=qty.base_qty><span class=division-name ng-bind=qty.division.name ng-class=qty.division_type.toLowerCase()></span> <span class=division-qty ng-bind=\"qty.base_qty + ((derivative.uom)? \' \' + derivative.uom.symbols + \'.\': \'\')\"></span></div></div></div></a></div>");
$templateCache.put("app/catalog/modals/search-catalog-item/includes/control-box.html","<div ng-scrollbars ng-scrollbars-config=searchCtrl.configScroll ng-scrollbars-update=searchCtrl.callbacks><div class=control-box><h5 class=section-header>Поиск</h5><div class=\"form-group small-bottom-offset\" ng-if=!searchCtrl.isShowDerivatives><ui-select class=slim-control ng-model=searchCtrl.urlParams.search_string_type search-enabled=false on-select=\"\" ng-required=true><ui-select-match><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"type.id as type in searchCtrl.searchStringTypes track by $index\"><span ng-bind=type.name></span></ui-select-choices></ui-select></div><div class=main-control-block style=\"padding: 0; background: none;\" ng-if=!searchCtrl.isShowDerivatives><div class=\"form-group search-entity\"><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button calback=searchCtrl.search() class=\"form-control label-clear-button slim-control\" ng-model=searchCtrl.urlParams.search_string maxlength=30 ng-keydown=\"$event.stopPropagation(); $event.key === \'Enter\' && searchCtrl.search()\" ng-change=searchCtrl.checkIssetData() required style=\"border-radius: 6px; width: 100%;\"><div class=\"valid-message required-mess small-offset\">Поле является обязательным</div></div></div><div class=form-group><label>Наличие в подразделении:</label><div class=\"multiselect slim-control\" ng-class=\"{\'text-muted\': !searchCtrl.divisions_ids.length}\" ng-dropdown-multiselect=\"\" options=searchCtrl.divisionsAll selected-model=searchCtrl.divisions_ids extra-settings=searchCtrl.options translation-texts=searchCtrl.translationTexts events=searchCtrl.multiselectEvents></div></div><div class=\"form-group category-form-group\" ng-if=!searchCtrl.isShowDerivatives><label>Категория:</label><input-category ng-model=searchCtrl.category on-close=::searchCtrl.getAttrs is-slim-control=true position=\"\'up\'\" only-autocomplete=true has-placeholder=true></input-category></div><div class=form-group ng-if=searchCtrl.isShowDerivatives><label>Тип реализации:</label><ui-select class=slim-control ng-model=searchCtrl.committent search-enabled=false ng-disabled=searchCtrl.disabledCommittent><ui-select-match allow-clear=true><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"type.value as type in searchCtrl.implementationTypes track by $index\"><span ng-bind=type.name></span></ui-select-choices></ui-select></div><div class=form-group ng-if=searchCtrl.attrs.length><label>Атрибуты:</label><div class=attribute-wrapper ng-repeat=\"attr in searchCtrl.attrs\"><div class=\"attr-name collapsed tooltip-light\" data-toggle=collapse data-target=\"#{{attr.id}}\" ng-bind=attr.name ng-class=\"{\'has-value\': attr.$$hasVal}\" tooltip-placement=bottom-right uib-tooltip=\"{{attr.name}}\"></div><span class=\"cross tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Очистить выбранные значения\" ng-click=\"searchCtrl.clearAttrData(attr, $index)\"></span><div ng-switch=attr.data_type class=data-type><div id=\"{{attr.id}}\" class=\"search-entity collapse\" ng-switch-when=STRING><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span> </span><input type=text class=\"form-control slim-control\" ng-model=searchCtrl.filterAttrs[$index].values.filter_string[0] placeholder=Поиск maxlength=150 ng-change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData();\"></div><div id=\"{{attr.id}}\" class=\"two-field row collapse clearfix\" ng-switch-when=FLOAT><span class=\"with-label col-xs-6\"><label>от</label><input class=\"form-control slim-control\" float-input float-fixed=4 max-int-length=15 float-step=0.01 max-after-comma=4 no-empty=::false empty-values=true ng-model=searchCtrl.filterAttrs[$index].values.filter_float_min ng-change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\" ng-class=\"{\'ng-invalid\': attr.$$invalid}\"><div class=\"valid-message wrong-format\">Неверный формат</div></span><span class=\"with-label col-xs-6\"><label>до</label><input class=\"form-control slim-control\" float-input float-fixed=4 max-int-length=15 float-step=0.01 max-after-comma=4 no-empty=::false empty-values=true ng-model=searchCtrl.filterAttrs[$index].values.filter_float_max ng-change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\" ng-class=\"{\'ng-invalid\': attr.$$invalid}\"><div class=\"valid-message wrong-format small-offset\">Неверный формат</div></span></div><div id=\"{{attr.id}}\" class=collapse ng-switch-when=DICTIONARY><div class=check-wrapper ng-repeat=\"value in attr.values\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=searchCtrl.filterAttrs[$parent.$index].values.filter_string[$index] id=\"{{value.id}}\" ng-change=\"searchCtrl.changeAttrData(attr, $parent.$index); searchCtrl.checkIssetData()\" ng-true-value=\"\'{{value.id}}\'\" ng-false-value=null> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{value.id}}\" class=checkbox-label ng-bind=value.value></label></div></div><div id=\"{{attr.id}}\" class=\"collapse clearfix\" ng-switch-when=BOOLEAN><div class=clearfix><div class=\"radio pull-left\"><label><input type=radio name=\"{{attr.id}}\" ng-model=searchCtrl.filterAttrs[$index].values.filter_string[0] value=true id=\"true{{attr.id}}\" ng-change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"true{{attr.id}}\">Да</label></div><div class=clearfix><div class=\"radio pull-left\"><label><input type=radio name=\"{{attr.id}}\" ng-model=searchCtrl.filterAttrs[$index].values.filter_string[0] value=false id=\"false{{attr.id}}\" ng-change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"false{{attr.id}}\">Нет</label></div></div><div id=\"{{attr.id}}\" class=\"two-field row collapse clearfix date-attr\" ng-switch-when=DATE|DATE_TIME ng-switch-when-separator=| ng-class=\"{\'time-attr\': attr.data_type == \'DATE_TIME\'}\"><span class=\"with-label col-xs-6\"><label>c</label><div date-range-picker state=searchCtrl.filterDateFromState[$index] ng-model=searchCtrl.filterAttrs[$index].values.filter_date_from opts=\"{singleDatePicker: true, correctTimeZone: false, timePicker: attr.data_type == \'DATE_TIME\', drops: \'up\'}\" class=datepicker-wrap name=dateFrom change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\" ng-class=\"{\'ng-invalid\': attr.$$invalid}\"></div><div class=\"valid-message wrong-format\">Неверный формат</div></span><span class=\"with-label col-xs-6\"><label>по</label><div date-range-picker state=searchCtrl.filterDateToState[$index] ng-model=searchCtrl.filterAttrs[$index].values.filter_date_to opts=\"{singleDatePicker: true, correctTimeZone: false, timePicker: attr.data_type == \'DATE_TIME\', drops: \'up\'}\" class=datepicker-wrap name=dateTo change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\" ng-class=\"{\'ng-invalid\': attr.$$invalid}\"></div><div class=\"valid-message wrong-format small-offset\">Неверный формат</div></span></div><div id=\"{{attr.id}}\" class=\"two-field row collapse clearfix\" ng-switch-when=INTEGER><span class=\"with-label col-xs-6\"><label>от</label><input class=\"form-control slim-control\" integer-input maxlength=20 no-empty=::true ng-model=searchCtrl.filterAttrs[$index].values.filter_int_min ng-change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\" ng-class=\"{\'ng-invalid\': attr.$$invalid}\"><div class=\"valid-message wrong-format\">Неверный формат</div></span><span class=\"with-label col-xs-6\"><label>до</label><input class=\"form-control slim-control\" integer-input maxlength=20 no-empty=::true ng-model=searchCtrl.filterAttrs[$index].values.filter_int_max ng-change=\"searchCtrl.changeAttrData(attr, $index); searchCtrl.checkIssetData()\" ng-class=\"{\'ng-invalid\': attr.$$invalid}\"><div class=\"valid-message wrong-format small-offset\">Неверный формат</div></span></div></div></div></div></div></div><div class=modal-footer style=\"padding: 16px 0 0 0; width: 310px; display: flex;\" ng-if=!searchCtrl.isShowDerivatives><button class=\"btn col-xs-5\" type=button ng-click=searchCtrl.reset() ng-disabled=!searchCtrl.isIssetData>Сброс</button> <button class=\"btn btn-primary col-xs-7\" type=button ng-click=searchCtrl.search(true) style=\"margin-left: 8px;\" ng-disabled=\"(searchCtrl.formInvalid || !searchCtrl.catalogItemSearchForm.$valid || !searchCtrl.isIssetData) && searchCtrl.isSaved\">Найти</button></div><div class=modal-footer style=\"padding: 16px 0 0 0; width: 310px; display: flex;\" ng-if=searchCtrl.isShowDerivatives><a class=\"btn col-xs-6\" ng-click=searchCtrl.return()><span class=\"btn-ico btn-arrow\"></span>Вернуться</a> <button class=\"btn btn-primary col-xs-6\" type=button ng-click=\"searchCtrl.showDerivatives(searchCtrl.choseCatalogItem, $event);\" style=\"margin-left: 8px;\" ng-disabled=\"(searchCtrl.formInvalid || !searchCtrl.catalogItemSearchForm.$valid || (!searchCtrl.isIssetData && !searchCtrl.derivatives.length)) && searchCtrl.isSaved\">Найти</button></div>");
$templateCache.put("app/components/inputs/activity-areas/modal/activity-areas-popup.html","<div class=\"modal-body catalog-items-popup activity-areas-popup\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h4 class=modal-title>Сферы деятельности</h4><div class=\"clearfix main-control-block\" style=\"background: none;\"><form class=\"search-entity col-xs-11\" role=search ng-submit=search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button class=\"form-control label-clear-button\" ng-model=searchText placeholder=Поиск> <button class=\"btn slim-button search-btn\" ng-disabled=!searchText ng-click=search()>Поиск</button></div></form></div><div ng-scrollbars ng-scrollbars-config=configScroll class=\"shares-types-wrapper without-selected\"><catalog-tree ng-show=!showSearch min-height=400 root-visible=false block-choice-hoisting=true load-callback=onTreeLoaded on-collapse-node=onCollapseNode on-expand-node=onExpandNode expand-node=expand root=root show-checkbox=true load-callback=onTreeLoaded allow-checkbox=allowCheckbox checkbox-only-for-leaf=::true selected-callback=selectNode></catalog-tree><grid-search ng-show=\"showSearch && searchResult.length\" results=searchResult show-checkbox=true external-selection-model=currentSelectionTree parent-property=parentList expand-callback=expandTreePath without-links=::true></grid-search><div class=\"no-content text-center\" ng-if=\"showSearch && !searchResult.length\"><p>К сожалению, поиск не дал результатов.<br>Попробуйте уточнить запрос<br>и повторить попытку</p><div class=arrow></div></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" ng-click=choose() ng-disabled=\"(!root.getSelectionModel().length && !showSearch) || (showSearch && !checkedLength())\">Выбрать</button></div></div>");
$templateCache.put("app/components/widgets/implementations/special-tax/special-tax.html","<div class=special-tax><h6 class=\"text-in-center text-center\">Спец настройки. Компонент</h6></div>");
$templateCache.put("app/components/widgets/implementations/special-tax-settings/special-tax-settings.html","<div class=special-tax-settings><h6 class=\"special-tax-settings-text text-center\">Настроечки</h6></div>");
$templateCache.put("app/documents/components/document-grid/settings/gridSettings.html","<div class=ui-grid-menu-wrapper><div class=\"price-settings ui-grid-menu simpleDemo\"><!-- content of settings --><div class=\"price-settings-container ui-grid-menu-inner\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=gridSettingsCtrl.cancel()>&times;</button><h3 class=modal-title>Отображение колонок</h3></div><div class=container><form class=clearfix><div class=row><section class=\"form-group col-xs-12\"><div class=modal-description>Вы можете настроить отображение любых колонок из списка и, перетаскивая их, задать порядок следования</div><div ng-scrollbars ng-scrollbars-config=gridSettingsCtrl.configScroll class=columns-wrapper ng-class=\"{\'without-scroll\': gridSettingsCtrl.simpleColumns.length < 10}\"><ul class=ui-grid-menu-items dnd-list=gridSettingsCtrl.simpleColumns><li ng-repeat=\"item in gridSettingsCtrl.simpleColumns\" class=\"ui-grid-menu-item ui-item-{{item.name}}\" dnd-draggable=item dnd-moved=\"gridSettingsCtrl.simpleColumns.splice($index, 1)\" ng-class=\"{\'selected\': gridSettingsCtrl.simpleColumns.selected === item}\"><dnd-nodrag class=display-flex><div class=checkbox><label><input type=checkbox ng-model=item.column_visible> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><div class=menu-item-name><span ng-bind-html=item.name></span><div dnd-handle=\"\" class=handle></div></div></dnd-nodrag></li></ul></div></section></div></form></div><div class=modal-footer><div class=pull-right><button class=\"btn btn-padding-lg\" ng-click=gridSettingsCtrl.default()>По умолчанию</button> <button class=\"btn btn-primary btn-padding-lg\" ng-click=gridSettingsCtrl.save()><span>Применить</span></button></div></div></div></div></div>");
$templateCache.put("app/documents/modals/import-from-file/sections/0-step.html","<section class=form-group><span class=\"status-check pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Успешно ng-if=$ctrl.uploader.queue[0].isSuccess></span><h5 class=section-header>ЗАГРУЗКА ФАЙЛА</h5><div class=load-data-wrap nv-file-drop uploader=$ctrl.uploader><input type=file id=load-data-field nv-file-select uploader=$ctrl.uploader accept=\".xls, .xlsx, .xml\" style=\"display: none\" multiple><div class=start ng-if=\"(!$ctrl.uploader.queue[0].progress || $ctrl.uploader.queue[0].isCancel) && !$ctrl.uploader.queue[0].isError && !$ctrl.uploader.queue[0].isSuccess\"><label class=load-data-descr>Нажмите «Загрузить» или перетащите файл в эту область</label><label for=load-data-field class=\"btn pull-right btn-primary\">Загрузить</label></div><div class=load ng-if=\"$ctrl.uploader.queue[0].progress && !$ctrl.uploader.queue[0].isSuccess\"><label class=\"load-data-spinner pull-left\"><div class=\"ui-spinner pull-left\"></div>Загружаю</label><button class=\"btn pull-right\" ng-click=$ctrl.uploader.queue[0].cancel()>Отмена</button></div><div class=success ng-if=$ctrl.uploader.queue[0].isSuccess><label class=\"load-data-success text-success pull-left\">Файл «{{$ctrl.uploader.queue[0].file.name}}» загружен</label><label for=load-data-field class=\"btn pull-right\">Загрузить</label></div><div class=error ng-if=$ctrl.uploader.queue[0].isError><label class=\"load-data-error text-danger pull-left\">Ошибка при загрузке файла. <span ng-if=\"$ctrl.fileError == \'format\'\">Неверный формат</span> <span ng-if=\"$ctrl.fileError == \'size\'\">Размер файла превышает 5 МБ</span> <span ng-if=\"$ctrl.fileError == \'empty\'\">Файл пуст</span></label><label for=load-data-field class=\"btn pull-right btn-primary\">Загрузить</label></div></div><div class=section-helper style=\"margin-top: 16px; display: block;\"><span class=text-danger>ВНИМАНИЕ!</span> Загружаемый файл должен быть не более 5 МБ в формате <strong>.xls</strong>, <strong>.xlsx</strong> и <strong>.xml</strong></div><div class=form-group style=\"margin-top: 50px; display: block;\"><label for=\"\">Создавать позицию, если ее нет в каталоге?</label><div class=radio><label><input type=radio name=createSku ng-model=$ctrl.processing.need_create_item ng-value=true id=createSkuYes ng-change=$ctrl.changeNeedCreateItem(true)> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><label for=createSkuYes>Да</label><label><input type=radio name=createSku ng-model=$ctrl.processing.need_create_item ng-value=false id=createSkuNo ng-change=$ctrl.changeNeedCreateItem(false)> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><label for=createSkuNo>Нет</label></div></div></section>");
$templateCache.put("app/documents/modals/import-from-file/sections/1-step.html","<section class=form-group style=\"margin-bottom: 0;\"><h5 class=section-header>ОБРАБОТКА ДАННЫХ</h5><div>Укажите, где в файле код позиции, наименование, количество, цена и др.<div class=data-processing-wrap style=\"margin-top: 10px;\"><div class=data-processing-table><div class=\"data-processing-table-body nestedDemo\" ng-class=\"{\'has-more-data\': $ctrl.fileData.line_count > 20}\"><div class=arrow-wrap><span class=\"move-position-button prev tooltip-light\" tooltip-placement=right uib-tooltip=\"Показать еще колонки\" ng-click=$ctrl.switchColumn() ng-if=$ctrl.offsetColumn></span> <span class=\"move-position-button next tooltip-right tooltip-light\" tooltip-placement=left uib-tooltip=\"Показать еще колонки\" ng-click=$ctrl.switchColumn(true) ng-if=\"($ctrl.offsetColumn + $ctrl.countColumn) < $ctrl.processing.column_mapping.length\"></span></div><div class=data-processing-table-head><div class=header-cell ng-repeat=\"row in $ctrl.processing.column_mapping | limitTo:$ctrl.countColumn:$ctrl.offsetColumn track by ($index + $ctrl.offsetColumn)\" style=\"width: {{100/$ctrl.countColumn}}%; max-width: {{100/$ctrl.countColumn}}%; min-width: {{100/$ctrl.countColumn}}%;\"><div class=form-group ng-class=\"{\'has-error-unique\': $ctrl.columnErrorInds.length && $ctrl.columnErrorInds.indexOf($index + $ctrl.offsetColumn) + 1}\"><ui-select class=slim-control ng-model=row search-enabled=false on-select=\"$ctrl.changeColumnName(row, $index + $ctrl.offsetColumn)\" ng-class=\"{\'ng-invalid-required ng-dirty\': $ctrl.headersCheck === false && !row}\"><ui-select-match placeholder=Выберите allow-clear=true><span ng-bind-html=$select.selected.label title=\"{{$select.selected.label}}\"></span></ui-select-match><ui-select-choices repeat=\"type.id as type in $ctrl.headerData track by $index\"><span ng-bind-html=type.label title=\"{{type.label}}\"></span></ui-select-choices></ui-select><div class=\"valid-message isset-name\">Колонка уже выбрана</div><div class=\"valid-message required-mess\">Выберите значение</div></div></div></div><div ng-scrollbars ng-scrollbars-config=$ctrl.configScroll><ul class=\"line-helper dropzone\" dnd-list=$ctrl.lineHelper dnd-drop=\"$ctrl.dropCallback(index, item, external, type, $ctrl.lineHelper)\"><li ng-repeat=\"item in $ctrl.lineHelper track by $index\" dnd-draggable=item dnd-dragend=\"$ctrl.listMoved($index, item, $ctrl.lineHelper)\" dnd-effect-allowed=move dnd-selected=\"models.selected = item\" ng-class=\"{\'selected\': item.selected === item}\" dnd-dragstart=\"$ctrl.onDragstart($ctrl.lineHelper, event)\"><div ng-if=\"item[0] === true\" class=devider-wrap ng-hide=\"$ctrl.fileData.line_count == 1\"><div class=devider ng-class=\"{\'all-row\': !$ctrl.processing.start_line, \'no-row\': $ctrl.processing.start_line == $ctrl.fileData.lines.length - 1}\"></div><ul><li class=move-up-row ng-click=$ctrl.changeRowNum()></li><li class=move-row-descr>первая строка</li><li class=move-down-row ng-click=$ctrl.changeRowNum(true)></li></ul></div><dnd-nodrag class=tr-helper ng-if=\"item[0] !== true\"></dnd-nodrag></li></ul><div class=file-data-table><div ng-repeat=\"row in $ctrl.fileData.lines track by $index\" ng-class=\"{\'text-muted\': $index < $ctrl.processing.start_line, \'tr-devider\': $ctrl.processing.start_line == ($index + 1)}\" class=tr><span ng-repeat=\"cell in row | limitTo:$ctrl.countColumn:$ctrl.offsetColumn track by $index\" class=td style=\"width: {{100/$ctrl.countColumn}}%; max-width: {{100/$ctrl.countColumn}}%; min-width: {{100/$ctrl.countColumn}}%;\"><cell-with-tooltip text=cell></span></div></div></div></div><i class=text-muted ng-if=\"$ctrl.fileData.line_count > 20\">выведено первые 20 строк загруженного файла</i><br><span class=req-inform ng-show=\"$ctrl.headersCheck === false\" aria-hidden=false>Необходимо указать в файле хотя бы одно значение из списка: «Наименование товара», «Количество товара», «Цена»</span></div></div></div></section>");
$templateCache.put("app/documents/modals/import-from-file/sections/2-step.html","<section class=form-group><h5 class=section-header>ПРОВЕРКА ФАЙЛА</h5><div class=text-center><div class=load-check ng-show=!$ctrl.fileErrors><div class=ui-spinner style=\"margin: 60px auto 15px;\"></div>Подождите, проводится анализ файла<br>на отсутствие ошибок</div><div class=success-check ng-show=\"$ctrl.fileErrors && !$ctrl.fileErrors.error_list.length && $ctrl.fileErrors.success_count\"><span class=ok-check-ico></span> Доступно для импорта: <span ng-bind=\"$ctrl.fileErrors.success_count + \' \' + $ctrl.successCountStr\"></span></div><div class=\"error-check text-danger\" ng-show=\"($ctrl.fileErrors && $ctrl.fileErrors.error_list.length) || $ctrl.fileErrors.success_count === 0\"><div class=error-check-ico style=\"margin: 60px auto 8px;\"></div><div class=req-inform ng-show=\"$ctrl.fileErrors.success_count === 0\" style=\"font-size: 16px;\">Внимание, нет строк, доступных для импорта</div><div ng-if=$ctrl.fileErrors.success_count>Внимание, для импорта доступно: <span ng-bind=\"$ctrl.fileErrors.success_count + \' \' + $ctrl.successCountStr\"></span></div><div ng-if=\"$ctrl.fileErrors && $ctrl.fileErrors.error_list.length\">В файле: {{$ctrl.fileErrors.error_list.length + \' \' + $ctrl.errorCountStr}}.</div><div ng-if=\"$ctrl.fileErrors.error_list.length > 100\">Список первых 100 ошибок:</div></div><div class=errors-wrapper><table class=\"load-errors table text-left\" ng-show=\"$ctrl.fileErrors && $ctrl.fileErrors.error_list.length\"><tr><th style=\"width: 93px;\">Строка</th><th style=\"width: 93px;\">Колонка</th><th style=\"width: 150px;\">Имя колонки</th><th>Ошибка</th></tr><tr ng-repeat=\"error in $ctrl.fileErrors.error_list\"><td ng-bind=\"error.row || \'-\'\"></td><td ng-bind=\"error.column || \'-\'\"></td><td ng-bind=\"error.column_name || \'-\'\"></td><td ng-bind=\"error.message || \'-\'\"></td></tr></table></div></div></section>");
$templateCache.put("app/documents/modals/search-documents/includes/control-box.html","<div ng-scrollbars ng-scrollbars-config=searchCtrl.configScroll><div class=control-box><h5 class=section-header>Поиск</h5><!-- Универсальное поле поиска RECS-6517 --><!-- <div class=\"form-group\">\n      <label>Универсальный поиск:</label>\n      <input type=\"text\"\n             clear-button\n             class=\"form-control slim-control\"\n             ng-model=\"searchCtrl.urlParams.multi_string\"\n             maxlength=\"30\"\n             ng-change=\"searchCtrl.checkIssetData()\">\n    </div> --><div class=form-group><label>Номер:</label><input type=text clear-button class=\"form-control slim-control\" ng-model=searchCtrl.urlParams.filter_number maxlength=30 ng-change=searchCtrl.checkIssetData()></div><div class=form-group><label>Дата:</label><div date-range-picker ng-model=searchCtrl.date state=searchCtrl.state opts=\"{singleDatePicker: false, correctTimeZone: false, opens: \'right\'}\" class=\"datepicker-wrap range-picker\" name=date on-close=searchCtrl.checkIssetData();></div></div><div class=form-group ng-if=!searchCtrl.isAdvanceReport><label>Подразделение:</label><ui-select class=slim-control ng-model=searchCtrl.urlParams.filter_division_id search-enabled=false on-select=searchCtrl.checkIssetData();><ui-select-match allow-clear=true><span ng-bind-html=$select.selected.name title=\"{{$select.selected.name}}\"></span></ui-select-match><ui-select-choices refresh-delay=500 repeat=\"item.id as item in searchCtrl.divisions track by $index\"><span ng-bind=item.name title=\"{{item.name}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div><div class=form-group ng-if=!searchCtrl.isAdvanceReport><label>Контрагент:</label><ui-select class=slim-control ng-model=searchCtrl.urlParams.filter_counterparty_id search-enabled=\"searchCtrl.counterpartiesFullTotal > searchCtrl.optionLength\" on-select=searchCtrl.checkIssetData(); ng-class=\"{\'autocomplete-select\': searchCtrl.counterparties.total > searchCtrl.optionLength}\"><ui-select-match allow-clear=true><span ng-bind-html=$select.selected.name title=\"{{$select.selected.name}}\"></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=searchCtrl.refreshCounterparties($select.search) group-by=searchCtrl.totalStr(searchCtrl.counterparties.total) repeat=\"item.id as item in searchCtrl.counterparties.items track by $index\"><span ng-bind=item.name title=\"{{item.name}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div><div class=form-group ng-if=!searchCtrl.isAdvanceReport><label>Договор:</label><ui-select class=slim-control ng-model=searchCtrl.urlParams.filter_contract_id search-enabled=\"searchCtrl.contractsFullTotal > searchCtrl.optionLength\" on-select=searchCtrl.checkIssetData(); ng-class=\"{\'autocomplete-select\': searchCtrl.contracts.total > searchCtrl.optionLength}\"><ui-select-match allow-clear=true><span ng-bind-html=\"\'№\' + $select.selected.number + \' от \' + ($select.selected.date | date:\'dd.MM.yyyy\')\" title=\"{{\'№\' + $select.selected.number + \' от \' + ($select.selected.date | date:\'dd.MM.yyyy\')}}\"></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=searchCtrl.refreshContracts($select.search) group-by=searchCtrl.totalStr(searchCtrl.contracts.total) repeat=\"item.id as item in searchCtrl.contracts.items track by $index\"><span ng-bind=\"\'№\' + item.number + \' от \' + (item.date | date:\'dd.MM.yyyy\')\" title=\"{{\'№\' + item.number + \' от \' + (item.date | date:\'dd.MM.yyyy\')}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div><div class=form-group><label>Проект:</label><ui-select class=slim-control ng-model=searchCtrl.urlParams.filter_project_id search-enabled=\"searchCtrl.projectsFullTotal > searchCtrl.optionLength\" on-select=searchCtrl.checkIssetData(); ng-class=\"{\'autocomplete-select\': searchCtrl.projects.total > searchCtrl.optionLength}\"><ui-select-match allow-clear=true title=\"{{$select.selected.name}}\"><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices position=up refresh-delay=500 refresh=searchCtrl.refreshProjects($select.search) group-by=searchCtrl.totalStr(searchCtrl.projects.total) repeat=\"item.id as item in searchCtrl.projects.items track by $index\"><span ng-bind=item.name title=\"{{item.name}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div><div class=form-group><label>Сумма в валюте учета, от:</label><input ng-change=searchCtrl.checkIssetData() class=\"form-control slim-control\" input-price hide-zero=true type=text maxlength=17 ng-model=searchCtrl.urlParams.filter_home_amount_from></div><div class=form-group><label>Сумма в валюте учета, до:</label><input ng-change=searchCtrl.checkIssetData() class=\"form-control slim-control\" input-price hide-zero=true type=text maxlength=17 ng-model=searchCtrl.urlParams.filter_home_amount_to></div><div class=form-group ng-if=!searchCtrl.isAdvanceReport><label>Содержит позицию</label><ui-select class=slim-control ng-model=searchCtrl.urlParams.filter_derivative_id name=catalogItem search-enabled=true tooltip=\"{{$select.selected.name}}\" ng-class=\"{\'autocomplete-select\': searchCtrl.catalogItemTotal > 5}\" on-select=searchCtrl.checkIssetData();><ui-select-match allow-clear=true><span bind-html-compile=$select.selected.name></span></ui-select-match><ui-select-choices position=up refresh-delay=100 refresh=searchCtrl.catalogItemRefresh($select.search) repeat=\"item.derivative.id as item in (searchCtrl.catalogItems.items | filter: $select.search) track by $index\" group-by=searchCtrl.catalogItemTotalStr><span bind-html-compile=item.name title=\"{{item.name}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div></div></div><div class=modal-footer style=\"padding: 16px 0 0 0; display: flex; width: 236px;\"><button class=\"btn col-xs-5\" type=button ng-click=searchCtrl.reset() ng-disabled=!searchCtrl.isIssetData>Сброс</button> <button class=\"btn col-xs-7\" type=button ng-click=searchCtrl.search(true) style=\"margin-left: 8px;\" ng-disabled=!searchCtrl.isIssetData>Найти</button></div>");
$templateCache.put("app/egaisz/scan-marks/components/group-box/approve-modal.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()></button><h3 class=modal-title>Подтверждение</h3></div><div class=container>При приеме упаковки целиком, будут учтены все позиции, входящие в данную упаковку по накладной.<br>Фактическое наличие бутылок в упаковке и их соответствие сведениям, указанным в накладной не проверяется. Принять упаковку целиком?<div style=\"margin-top: 20px;\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=scanAll id=scanAll name=scanAll> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=scanAll>Для всех групповых упаковок по накладной</label></div></div><div class=modal-footer><button class=btn ng-click=close()>Отмена</button> <button class=\"btn btn-primary\" ng-click=accept()>Принять</button></div>");
$templateCache.put("app/egaisz/scan-marks/components/group-box/group-box.html","<div class=group-box><div class=\"pull-left group-box-header-image-container\"><div class=\"group-box-header-image PACK_GROUP_UNIT\"></div></div><h4 class=group-box-header-text>Групповая упаковка</h4><h6 class=text-muted>ШК: <span ng-bind=groupBoxCtrl.mark.box_num></span></h6><div><div class=group-box-mark-list-wrapper><div ng-scrollbars ng-scrollbars-config=groupBoxCtrl.configScroll><div class=group-box-mark-list-container><div class=group-box-mark-item ng-class=\"{\'accepted\': item.accepted}\" ng-repeat=\"item in groupBoxCtrl.mark.amcs track by $index\"><div class=\"group-box-mark-item-text single-line\"><span title=\"{{item.full_name}}\" ng-bind=item.full_name></span></div><div class=\"group-box-mark-item-sub-text text-muted single-line\"><span title=\"{{item.amc}}\" ng-bind=\"item.amc | egaisBarcode\"></span></div></div><div ng-repeat=\"child in groupBoxCtrl.mark.children_box_num\"><div class=group-box-mark-item ng-class=\"{\'accepted\': child_item.accepted}\" ng-repeat=\"child_item in child.amcs track by $index\"><div class=\"group-box-mark-item-text single-line\"><span title=\"{{child_item.full_name}}\" ng-bind=child_item.full_name></span></div><div class=\"group-box-mark-item-sub-text text-muted single-line\"><span title=\"{{child_item.amc}}\" ng-bind=\"child_item.amc | egaisBarcode\"></span></div></div></div></div></div></div><div class=\"row pull-left col-xs-6\" ng-if=!groupBoxCtrl.isset><span style=\"padding-right: 30px;\"><small>Принято: </small><span ng-bind=groupBoxCtrl.totalAcceptedMarks></span> </span><span><small>Всего:</small> <span ng-bind=groupBoxCtrl.totalMarks></span></span></div><div class=\"row pull-right col-xs-6 text-right\" ng-if=!groupBoxCtrl.isset><label class=text-success ng-if=\"groupBoxCtrl.totalMarks == groupBoxCtrl.totalAcceptedMarks\">Упаковка принята</label><button class=\"btn btn-primary\" ng-if=\"!groupBoxCtrl.scanAll && groupBoxCtrl.totalMarks !== groupBoxCtrl.totalAcceptedMarks\" ng-click=groupBoxCtrl.approveAll()>Принять все</button></div></div><div ng-if=\"groupBoxCtrl.isset && !groupBoxCtrl.onlyView\" class=\"isset-mark-message text-danger\" style=\"position: absolute; bottom: 15px;\">Повторное сканирование упаковки!<br>Упаковка уже была сканирована ранее.</div></div>");
$templateCache.put("app/egaisz/scan-marks/components/info-block/info-block.html","<div class=scan-marks-info-block ng-class=\"infoBlockCtrl.level + \'-wrapper\'\"><div class=info-block-image ng-class=\"infoBlockCtrl.level + \'-ico\'\"></div><div class=info-block-text><p class=info-paragraph ng-bind=infoBlockCtrl.message></p></div></div>");
$templateCache.put("app/egaisz/scan-marks/components/simple-tree/simple-tree-row.html","<div class=simple-tree-row><div class=simple-tree-switcher ng-if=\"(simpleTreeRowCtrl.item.amcs.length || simpleTreeRowCtrl.item.children_box_num.length) && !simpleTreeRowCtrl.hideSelf\" ng-click=\"simpleTreeRowCtrl.expanded = !simpleTreeRowCtrl.expanded\"><span class=tree-arrow ng-class=\"{\'down\' : simpleTreeRowCtrl.expanded}\"></span></div><div class=simple-tree-row-text-block ng-hide=simpleTreeRowCtrl.hideSelf><div ng-if=simpleTreeRowCtrl.item.amc.full_name ng-click=simpleTreeRowCtrl.rowClickCallback(simpleTreeRowCtrl.item)><div class=\"simple-tree-row-main-text single-line\"><span title=\"{{simpleTreeRowCtrl.item.amc.full_name}}\" ng-bind=simpleTreeRowCtrl.item.amc.full_name></span></div><div class=\"simple-tree-row-sub-text text-muted single-line\"><span title=\"{{simpleTreeRowCtrl.item.amc}}\" ng-if=simpleTreeRowCtrl.item.amc ng-bind=\"simpleTreeRowCtrl.item.amc | egaisBarcode\" style=\"margin-bottom: 3px; display: inline-block;\"></span></div></div><div ng-if=simpleTreeRowCtrl.item.box_num ng-click=simpleTreeRowCtrl.rowClickCallback(simpleTreeRowCtrl.item)><div class=\"simple-tree-row-main-text single-line\"><span>Групповая упаковка</span></div><div class=\"simple-tree-row-sub-text text-muted single-line\">ШК: <span title=\"{{simpleTreeRowCtrl.item.box_num}}\" ng-bind=simpleTreeRowCtrl.item.box_num></span></div></div><!-- Возвращаемое дерево с бекенда неоднородно, внутренние марки коробки идут сразу, без amc --><div ng-if=\"!angular.isObject(simpleTreeRowCtrl.item.amc) && !simpleTreeRowCtrl.item.box_num\" ng-click=simpleTreeRowCtrl.rowClickCallback(simpleTreeRowCtrl.item)><div class=\"simple-tree-row-main-text single-line\"><span title=\"{{simpleTreeRowCtrl.item.full_name}}\" ng-bind=simpleTreeRowCtrl.item.full_name></span></div><div class=\"simple-tree-row-sub-text text-muted single-line\"><span title=\"{{simpleTreeRowCtrl.item.amc}}\" ng-if=simpleTreeRowCtrl.item.amc ng-bind=\"(simpleTreeRowCtrl.item.amc.amc || simpleTreeRowCtrl.item.amc) | egaisBarcode\"></span></div></div><div class=cross ng-click=simpleTreeRowCtrl.removeRow(simpleTreeRowCtrl.item);></div></div><div class=simple-tree-row-children-container ng-if=\"simpleTreeRowCtrl.expanded || simpleTreeRowCtrl.hideSelf\"><simple-tree-row item=item ng-repeat=\"item in simpleTreeRowCtrl.item.children_box_num track by $index\" remove-row=simpleTreeRowCtrl.removeRow level=\"simpleTreeRowCtrl.level + 1\" row-click-callback=simpleTreeRowCtrl.rowClickCallback></simple-tree-row><simple-tree-row item=item ng-repeat=\"item in simpleTreeRowCtrl.item.amcs track by $index\" remove-row=simpleTreeRowCtrl.removeRow level=\"simpleTreeRowCtrl.level + 1\" row-click-callback=simpleTreeRowCtrl.rowClickCallback></simple-tree-row></div></div>");
$templateCache.put("app/egaisz/scan-marks/components/simple-tree/simple-tree.html","<div class=simple-tree><simple-tree-row item=simpleTreeCtrl.root hide-self=!simpleTreeCtrl.rootVisible remove-row=simpleTreeCtrl.removeRow level=0 row-click-callback=simpleTreeCtrl.rowClickCallback></simple-tree-row></div>");
$templateCache.put("app/egaisz/scan-marks/components/single-mark/single-mark.html","<div class=single-mark-container><h4 class=mark-header><span ng-bind=\"singleMarkCtrl.mark.identity || 0\" uib-tooltip=\"Порядковый номер по ТТН\"></span>. <span ng-bind=singleMarkCtrl.mark.full_name></span><div class=\"mark-number-label pull-right\"><span ng-class=\"{\'text-danger\': singleMarkCtrl.mark.real_quantity < singleMarkCtrl.mark.quantity}\" ng-bind=\"singleMarkCtrl.mark.real_quantity || 0\" uib-tooltip=Принято></span> / <span ng-bind=\"singleMarkCtrl.mark.quantity || 0\" uib-tooltip=Всего></span></div></h4><div class=\"row mark-line\"><div class=\"col-xs-6 text-right\">Федеральная акцизная марка:</div><div class=\"col-xs-6 text-left single-line\"><span title=\"{{singleMarkCtrl.mark.amc}}\" ng-bind=\"singleMarkCtrl.mark.amc | egaisBarcode\"></span></div></div><div class=\"row mark-line\"><div class=\"col-xs-6 text-right\">Код вида продукции:</div><div class=\"col-xs-6 text-left\"><span title=\"{{singleMarkCtrl.mark.classifier_name}}\" ng-bind=singleMarkCtrl.mark.classifier_code></span></div></div><div class=\"row mark-line\"><div class=\"col-xs-6 text-right\">Алкокод:</div><div class=\"col-xs-6 text-left\"><span ng-bind=singleMarkCtrl.mark.alc_code></span></div></div><div class=\"row mark-line\"><div class=\"col-xs-6 text-right\">Объем:</div><div class=\"col-xs-6 text-left\"><span ng-bind=singleMarkCtrl.mark.capacity></span></div></div><div class=\"row mark-line\"><div class=\"col-xs-6 text-right\">Крепость:</div><div class=\"col-xs-6 text-left\"><span ng-bind=singleMarkCtrl.mark.alc_volume></span></div></div><div class=\"row mark-line\"><div class=\"col-xs-6 text-right\">Производитель:</div><div class=\"col-xs-6 text-left\"><span ng-bind=singleMarkCtrl.mark.producer.name></span></div></div><div ng-if=singleMarkCtrl.isset class=\"isset-mark-message text-danger\">Повторное сканирование марки!<br>Марка уже была сканирована и принята ранее.</div></div>");
$templateCache.put("app/settings/companies/crudCompanies/modals/tax-modal.html","<!-- tax popup --><div id=tax-popup><div class=modal-content ng-if=\"taxModalCtrl.viewType == \'history\'\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=taxModalCtrl.close();>×</button><h4 class=modal-title style=\"padding-bottom: 19px;\">История изменений</h4><p class=modal-description ng-if=\"!taxModalCtrl.mode.isView && taxModalCtrl.isCompany\">Если система налогообложения изменяется, вы можете добавить новую</p><p class=modal-description ng-if=\"!taxModalCtrl.mode.isView && !taxModalCtrl.isCompany\">Если спецрежим налогообложения изменяется, вы можете добавить новый</p></div><div class=\"container container-history\" ng-scrollbars ng-scrollbars-config=taxModalCtrl.configScroll><div class=history-item ng-repeat=\"tax in taxModalCtrl.tax_modes_modified track by $index\" ng-class=\"{\'current\': tax.$$current}\"><span class=item-date>с {{tax.start_date | date:\'dd.MM.yyyy\': \'UTC\'}} <span ng-show=tax.$$end_date>по {{tax.$$end_date | date:\'dd.MM.yyyy\': \'UTC\'}}</span><span ng-if=\"tax[taxModalCtrl.fieldName] == \'IMPUTED\' && !tax.$$end_date && $index\">по {{taxModalCtrl.getEndDateStr(taxModalCtrl.tax_modes_modified[$index-1].start_date) | date:\'dd.MM.yyyy\': \'UTC\'}}</span></span><span ng-class=\"{\'bold\': tax.$$current}\">{{tax[taxModalCtrl.fieldName] | tax}}</span><span class=\"glyphicon glyphicon-trash\" ng-click=\"taxModalCtrl.viewType = \'remove\'; taxModalCtrl.deleteTax = tax;\" ng-hide=\"taxModalCtrl.isCompany && taxModalCtrl.tax_modes_modified.length == 1\" ng-if=taxModalCtrl.mode.isEdit></span></div></div><div class=modal-footer><button class=btn ng-click=taxModalCtrl.close(); ng-if=taxModalCtrl.mode.isEdit>Закрыть</button><!-- <button class=\"btn btn-link-main\" ng-click=\"taxModalCtrl.viewType = \'add\'\" ng-if=\"taxModalCtrl.mode.isEdit\">Добавить</button> --></div></div><div class=modal-content ng-if=\"taxModalCtrl.viewType == \'change\'\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=taxModalCtrl.close();>×</button><h3 class=modal-title ng-bind=\"(taxModalCtrl.isCompany)? \'Изменение системы налогообложения\' : \'Изменение спецрежима налогообложения\'\"></h3></div><div class=\"container container-tax-change\"><form name=taxModalCtrl.editTaxForm ng-class=\"{\'check-date-error\': taxModalCtrl.checkDateError}\"><div class=form-group style=\"padding-right: 35px;\"><div class=select-tax><ui-select ng-model=taxModalCtrl.newTax[taxModalCtrl.fieldName] search-enabled=false name=tax ng-required=true><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"tax.type as tax in taxModalCtrl.taxs\"><div ng-bind=tax.name></div></ui-select-choices></ui-select><label class=\"form-control-label small-offset\" ng-bind=\"(taxModalCtrl.isCompany)? \'Новая система налогооблажения\' : \'Специальный режим налогообложения\'\"></label><span class=req></span></div></div><div class=\"form-group tax-date\" style=\"padding-right: 35px;\"><div date-range-picker ng-model=taxModalCtrl.startDate opts=\"{singleDatePicker: true, correctTimeZone: false}\" state=taxModalCtrl.dateStartState class=datepicker-wrap name=start_date_edit ng-required=true on-close=\"taxModalCtrl.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата начала действия\'\"></div></div><div class=\"form-group tax-date\" style=\"padding-right: 35px;\" ng-if=\"taxModalCtrl.fieldName == \'special_tax_mode\'\"><div date-range-picker ng-model=taxModalCtrl.endDate opts=\"{singleDatePicker: true, correctTimeZone: false, minDate: taxModalCtrl.startDate}\" state=taxModalCtrl.dateEndState class=datepicker-wrap name=end_date_edit ng-required=\"taxModalCtrl.newTax[taxModalCtrl.fieldName] == \'PATENT\'\" on-close=\"taxModalCtrl.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата конца действия\'\"></div></div><div class=\"danger-text ng-hide\" ng-if=!taxModalCtrl.isCompany ng-bind=\"taxModalCtrl.textError || \'В подразделении одновременно не могут действовать несколько специальных режимов налогообложения\'\"></div><div class=\"danger-text ng-hide\" ng-if=taxModalCtrl.isCompany ng-bind=\"taxModalCtrl.textError || \'В компании одновременно не могут действовать несколько режимов налогообложения\'\"></div></form></div><div class=modal-footer ng-hide=taxModalCtrl.hasDoc><button class=btn ng-if=\"taxModalCtrl.viewType === \'change\'\" ng-click=taxModalCtrl.close();>Отменить</button> <button class=btn ng-if=\"taxModalCtrl.viewType === \'add\'\" ng-click=\"taxModalCtrl.viewType = \'history\';\">Отменить</button> <span class=\"btn btn-primary\" ng-click=taxModalCtrl.addTaxMode(); ng-disabled=taxModalCtrl.editTaxForm.$invalid>Подтвердить</span></div></div><div class=modal-content ng-if=\"taxModalCtrl.viewType == \'remove\'\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=taxModalCtrl.close();>&times;</button><h4 class=modal-title>Удаление {{(taxModalCtrl.isCompany)? \'\' : \'спецрежима налогообложения\'}}</h4></div><div class=\"container container-remove-tax\">Вы действительно хотите удалить {{(taxModalCtrl.isCompany)? \'\' : \'спецрежим\'}} <span>{{taxModalCtrl.deleteTax[taxModalCtrl.fieldName] | tax}}</span> {{(taxModalCtrl.isCompany)? \'действующую\' : \'действующий\'}} с {{taxModalCtrl.deleteTax.start_date | date:\'dd.MM.yyyy\' : \'UTC\'}} </div><div class=modal-footer ng-hide=taxModalCtrl.hasDoc><button class=btn ng-click=\"taxModalCtrl.viewType = \'history\'\">Нет</button> <button class=\"btn btn-primary\" ng-click=\"taxModalCtrl.viewType = \'history\'; taxModalCtrl.removeTaxMode(taxModalCtrl.deleteTax);\">Да</button></div></div></div>");
$templateCache.put("app/settings/companies/crudCompanies/sections/tax-system.html","<!-- tax box --><section class=\"form-group tax-mode-group col-xs-12\" ng-class=\"{\'slide-up\': vm.hideTaxInfo}\" ng-style=\"(vm.mode.isView)? {\'max-height\': \'420px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideTaxInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideTaxInfo = !vm.hideTaxInfo\" ng-show=vm.mode.isView></span><h5 class=section-header>Система налогообложения</h5><div ng-if=vm.mode.isNew><ul class=form-group><li ng-repeat=\"tax in vm.taxs\"><label ng-mouseover=\"vm.taxHelper = true;\" ng-mouseleave=\"vm.taxHelper = false\" tooltip-placement=bottom-right uib-tooltip=\"{{tax.help}}\"><div class=\"radio pull-left\"><label><input type=radio name=tax ng-model=vm.currentTax.tax_mode ng-value=tax.type id=\"{{tax.type}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div>{{tax.name}} </label></li></ul><div class=row><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0\"><div date-range-picker ng-model=vm.date opts=\"{singleDatePicker: true, correctTimeZone: false}\" state=vm.datePickerState class=datepicker-wrap name=start_date ng-required=true on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата начала действия\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div></div></div><div ng-if=!vm.mode.isNew class=clearfix><span class=tax-selected ng-bind=\"vm.currentTax.tax_mode | tax\"></span><div style=\"margin-top: -20px; opacity:0.3; margin-bottom: 10px;\" ng-if=vm.currentTax.start_date>c {{vm.currentTax.start_date | date : \'dd.MM.yyyy\'}} <span ng-if=vm.currentTax.end_date>по {{vm.currentTax.end_date | date : \'dd.MM.yyyy\'}}</span></div><a class=\"btn tax-change\" ng-click=\"vm.showPopup(\'change\')\" ng-if=vm.mode.isEdit>Изменить</a> <a class=tax-history ng-click=\"vm.showPopup(\'history\')\"><span class=\"glyphicon glyphicon-file\"></span>История</a></div><div style=\"border-radius: 4px; background-color: #fefaf0; border: 1px solid #ead5a1; padding: 14px 20px 14px; margin-top: 15px; font-size: 14px;\"><strong>Патент</strong> и <strong>ЕНВД</strong> - это специальные режимы налогообложения для конкретного адреса и конкретного вида экономической деятельности. Они настраиваются на карточке подразделения.</div><!-- <div class=\"info-click\" ng-if=\"vm.mode.isEdit\">\n    <button class=\"btn btn-ico btn-info dropdown-toggle\" type=\"button\" id=\"companyTaxInfo\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"></button>\n    <div class=\"dropdown-menu\" aria-labelledby=\"dropdownMenuButton\" ng-click=\"$event.stopPropagation();\">\n      <span>Если с нового года ваша система налогообложения изменяется - вы можете добавить новую чтобы избежать штрафов</span>\n    </div>\n  </div> --></section>");
$templateCache.put("app/settings/companies/crudCompanies/sections/type-company.html","<section class=\"form-group radio-group col-xs-12\" ng-if=!vm.mode.isView><h5 class=section-header>Тип компании</h5><input type=radio ng-checked=true name=companiesType value=LEGAL_ENTITY id=ur ng-model=vm.company.organization.legal_requisites.legal_status ng-change=vm.changeType()><label class=\"radio-label legal_entity\" for=ur>Юридическое лицо<span class=shad></span></label><input type=radio name=companiesType value=SOLE_TRADER id=ip ng-model=vm.company.organization.legal_requisites.legal_status ng-change=vm.changeType()><label class=\"radio-label sole_trader\" for=ip>ИП<span class=shad></span></label></section>");
$templateCache.put("app/settings/companies/directives/company-card/company-card.html","<section class=card-box><div class=card-container ng-click=\"$state.go(\'company.view\', {companyId: company.id, parent: \'business\'})\"><div class=\"container-fluid card-body\"><div class=\"row clearfix\"><div class=\"col-xs-12 name-wrapper\"><div class=\"pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Редактировать ng-if=\"$root.hasRole(\'company.write\')\"><a ui-sref=\"company.edit({companyId: company.id, parent: \'business\'})\" class=\"status-ico redact-icon\"></a></div><span ng-switch=company.organization.legal_requisites.legal_status><span class=person-type ng-switch-when=LEGAL_ENTITY>Юридическое лицо</span> <span class=person-type ng-switch-when=SOLE_TRADER>Индивидуальный предприниматель</span></span><div class=card-name-wrapper><span class=\"card-name ellipsis\" uib-tooltip=\"{{company.name}}\" ng-bind=company.name></span> <span class=\"glyphicon info-icon comment-ico\" ng-if=company.comment><span class=info-message><span ng-bind=company.comment></span></span></span></div></div><div class=\"col-xs-12 info-block\"><ul class=\"card-data row\"><li class=col-xs-6><div>ИНН:</div><span ng-bind=\"company.organization.legal_requisites.inn || \'-\'\"></span></li><li class=col-xs-6><div>Телефон:</div><span ng-if=phones[0] ng-bind=phones[0]></span> <span ng-if=\"phones.length > 1\">и др.</span> <span ng-if=!phones.length>-</span></li><li class=col-xs-6><div>ОГРН:</div><span ng-bind=\"company.organization.legal_requisites.ogrn || \'-\'\"></span></li><li class=col-xs-6><div>Email:</div><a href=mailto:mails[0] ng-if=mails[0] ng-bind=mails[0] class=ellipsis uib-tooltip=\"{{mails[0]}}\"></a> <span ng-if=\"mails.length > 1\">и др.</span> <span ng-if=!mails.length>-</span></li><li class=col-xs-12><div>Фактический адрес:</div><span class=address-str tooltip-placement=bottom-right uib-tooltip=\"{{company.real_address.address_as_string || \'\'}}\" ng-bind=\"company.real_address.address_as_string || \'-\'\"></span></li></ul><a ui-sref=\"divisions({companyName: company.name, parent: \'business\'})\" class=\"card-doc has-division\" ng-if=company.has_division>Есть подразделения</a> <span class=card-doc ng-if=!company.has_division>Нет подразделений</span></div></div></div></div></section>");
$templateCache.put("app/settings/companies/directives/divisions-tab/divisions-tab.html","<div class=\"grid mini-grid-wrapper\" ui-grid=gridOptions ui-grid-cellnav ui-grid-auto-resize></div><a ng-if=\"$root.hasRole(\'division.write\')\" ui-sref=\"division.new({type: tab.type, companyId: companyId, parent: \'business\'})\"><span ng-switch=tab.type><span ng-switch-when=OFFICE>+ Офис</span> <span ng-switch-when=SHOP>+ Магазин</span> <span ng-switch-when=STOREHOUSE>+ Склад</span></span></a><script type=text/ng-template id=cashTemplate.html><div class=\"ui-grid-cell-contents\">\n     <div class=\"cash-machine\" ng-repeat=\"cash in row.entity.cash_registers\">\n      <span class=\"cash-machine-ico\" ng-class=\"(cash.enabled)? \'onCash\': \'offCash\'\"></span>\n    </div>\n  </div></script>");
$templateCache.put("app/settings/components/address/modals/address-detail.html","<div class=\"modal-content address-popup crud-entity\"><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close();>&times;</button><h4 class=modal-title ng-bind=\"(addrID)? \'Редактирование адреса\' : \'Добавление адреса\'\"></h4></div><form class=container name=addressFormModal autocomplete=off><div class=\"form-category col-xs-6\"><div class=form-group><input name=region id=region empty-to-null hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=addrData.granular_address.region type=text class=\"form-control region\" ng-keydown=keyEvent($event); ng-blur=gatherData($event); autocomplete=none ng-change=\"getTip(addrData.granular_address.region, \'REGION\')\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=region class=\"form-control-label small-offset\">Регион</label><ul class=dropdown-menu ng-show=granularListRegion.length><li ng-repeat=\"obj in granularListRegion\" ng-mousedown=\"choiseTip(obj, $event, \'region\')\"><a href=javascript:void(0)>{{obj.caption}}</a></li></ul></div><div class=form-group><input name=city id=city empty-to-null hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" ng-model=addrData.granular_address.city type=text class=\"form-control city\" ng-keydown=keyEvent($event); ng-blur=gatherData($event); autocomplete=none ng-change=\"getTip(addrData.granular_address.city, \'CITY\')\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=city class=\"form-control-label small-offset\">Город или населенный пункт</label><ul class=dropdown-menu ng-show=granularListCity.length><li ng-repeat=\"obj in granularListCity\" ng-mousedown=\"choiseTip(obj, $event, \'city\')\"><a href=javascript:void(0)>{{obj.caption}}</a></li></ul></div><div style=\"padding-right: 19px\"><div class=\"form-group col-xs-4\"><ui-select ng-model=addrData.granular_address.house_type search-enabled=false class=slim-control><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"type.id as type in houseTypes\"><span ng-bind=type.name></span></ui-select-choices></ui-select><input name=houseStr hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" empty-to-null ng-model=addrData.granular_address.house type=text class=\"form-control houseStr slim-control\" ng-blur=\"gatherData($event, true);\" ng-class=\"{wrongHouse: wrongHouse}\"><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=\"form-group col-xs-4\"><label class=control-label>Корп.</label><input name=case hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" empty-to-null ng-model=addrData.granular_address.housing type=text class=\"form-control case slim-control\" ng-blur=gatherData($event);><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=\"form-group col-xs-4\"><ui-select ng-model=addrData.granular_address.building_type search-enabled=false class=slim-control><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"type.id as type in buildingTypes\"><span ng-bind=type.name></span></ui-select-choices></ui-select><input name=constructionStr hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" empty-to-null ng-model=addrData.granular_address.building type=text class=\"form-control constructionStr slim-control\" ng-blur=gatherData($event);><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div></div></div></div><div class=\"form-category col-xs-6\"><div class=form-group><input name=area id=area empty-to-null ng-model=addrData.granular_address.area type=text hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" class=\"form-control district\" ng-keydown=keyEvent($event); ng-blur=gatherData($event); autocomplete=none ng-change=\"getTip(addrData.granular_address.area, \'AREA\')\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=area class=\"form-control-label small-offset\">Район</label><ul class=dropdown-menu ng-show=granularListArea.length><li ng-repeat=\"obj in granularListArea\" ng-mousedown=\"choiseTip(obj, $event, \'area\')\"><a href=javascript:void(0)>{{obj.caption}}</a></li></ul></div><div class=form-group><input name=street id=street empty-to-null ng-model=addrData.granular_address.street type=text hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" class=\"form-control street\" ng-keydown=keyEvent($event); ng-blur=gatherData($event); autocomplete=none ng-change=\"getTip(addrData.granular_address.street, \'STREET\')\"><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><label for=street class=\"form-control-label small-offset\">Улица</label><ul class=dropdown-menu ng-show=granularListStreet.length><li ng-repeat=\"obj in granularListStreet\" ng-mousedown=\"choiseTip(obj, $event, \'street\')\"><a href=javascript:void(0)>{{obj.caption}}</a></li></ul></div><div style=\"padding-right: 19px\"><div class=\"form-group col-xs-6\"><ui-select ng-model=addrData.granular_address.flat_type search-enabled=false class=slim-control><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"type.id as type in flatTypes\"><span ng-bind=type.name></span></ui-select-choices></ui-select><input name=roomStr hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" empty-to-null ng-model=addrData.granular_address.flat type=text class=\"form-control roomStr slim-control\" ng-blur=gatherData($event);><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=\"form-group col-xs-6\"><label class=control-label>Индекс</label><input name=postcode hard-pruning data-check=\"[A-Za-zА-ЯЁа-яё0-9\\.\\ \\-\\/,]\" empty-to-null ng-model=addrData.granular_address.postal_code type=text class=\"form-control postcode slim-control\" ng-blur=gatherData($event);><div class=\"small valid-message wrong-simbol-mess\">Некорректный символ</div></div></div></div><label class=checkbox-correct ng-if=\"statusClass == \'rewrite\'\"><div class=\"checkbox pull-left\"><label><input type=checkbox id=address-accepted class=check-correct-address ng-model=addrData.accepted ng-change=changeInput()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-checkbox for=address-accepted>Считаю, что адрес корректный</label></label></form><div class=modal-footer><span class=\"req-inform pull-left\" ng-show=\"isSaved && !addrData.address_as_string\">Необходимо заполнить форму </span><a href=javascript:void(0) class=btn ng-click=close();>Отменить</a> <a href=javascript:void(0) class=\"btn btn-primary\" ng-disabled=\"isSaved && !addrData.address_as_string\" role=button ng-click=\"(!wrongHouse || addrData.accepted)? gatherData($event, false, true) : \'\';\">Сохранить</a></div></div>");
$templateCache.put("app/settings/components/address/modals/confirm-popup.html","<div class=confirm-address><div class=modal-header><button type=\"button tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть class=close ng-click=close();>&times;</button><h3 class=modal-title>Подтверждение адреса</h3></div><div class=container><div class=incorrect-addr>{{addressStr}}</div>Введенный текст не распознается системой как адрес. Вы подтверждаете корректность ввода адреса?</div><div class=modal-footer><button class=btn role=button ng-click=\"save(); setStatus(\'success\');\">Да, адрес верный</button> <button type=submit class=\"btn btn-primary\" role=button ng-click=close();adressDetail();>Нет, редактировать</button></div></div>");
$templateCache.put("app/settings/contracts/crud/sections/finance-info.html","<section class=col-xs-12 ng-class=\"{\'slide-up\': contractCrudCtrl.hideFinInfo}\" ng-style=\"(contractCrudCtrl.mode.isView)? {\'max-height\': \'250px\'} : \'\'\" ng-hide=\" contractCrudCtrl.mode.isView && !contractCrudCtrl.contract.amount && !contractCrudCtrl.contract.currency && !contractCrudCtrl.contract.project && !contractCrudCtrl.contract.commission\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(contractCrudCtrl.hideFinInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"contractCrudCtrl.hideFinInfo = !contractCrudCtrl.hideFinInfo\" ng-show=contractCrudCtrl.mode.isView></span><h5 class=section-header>Финансовая информация</h5><div class=row><div class=\"form-group col-xs-6\"><input float-input float-fixed=2 float-step=0.01 max-after-comma=2 max-int-length=12 currency-input currency-icon=\"{{contractCrudCtrl.contract.currency.symbol}}\" type=text id=contract-amount class=\"form-control currency-input\" ng-if=!contractCrudCtrl.mode.isView ng-model=contractCrudCtrl.contract.amount> <span class=currency-input-addon ng-show=!contractCrudCtrl.mode.isView></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><label for=contract-amount class=form-control-label>Сумма договора</label><div ng-if=\"contractCrudCtrl.mode.isView && contractCrudCtrl.contract.amount\" class=view-entity-control> {{contractCrudCtrl.parseAmount(contractCrudCtrl.contract.amount)}} <span class=currency-font>{{contractCrudCtrl.contract.currency.symbol || contractCrudCtrl.contract.currency.char_iso_code}}</span></div><div ng-if=\"contractCrudCtrl.mode.isView && !contractCrudCtrl.contract.amount\" class=view-entity-control>-</div></div><div class=\"form-group col-xs-6\"><ui-select ng-model=contractCrudCtrl.contract.currency ng-if=!contractCrudCtrl.mode.isView search-enabled=\"(contractCrudCtrl.currencies.field.total > 100 && contractCrudCtrl.currencies.field.length <= 100)\" ng-required=\"contractCrudCtrl.contract_type.code === \'WE_USE_ACQUIRING\'\"><ui-select-match allow-clear=\"{{contractCrudCtrl.contract_type.code !== \'WE_USE_ACQUIRING\'}}\"><span ng-bind-html=\"$select.selected.name + \' (\' +$select.selected.char_iso_code+\')\'\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=contractCrudCtrl.currencies.refresh($select.search) repeat=\"item in (contractCrudCtrl.currencies.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"(item.name + \' (\' +item.char_iso_code+\')\') | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Валюта</label><span ng-if=\"contractCrudCtrl.contract_type.code == \'WE_USE_ACQUIRING\'\" class=req></span><div ng-if=\"contractCrudCtrl.mode.isView && contractCrudCtrl.contract.currency\" class=view-entity-control><span class=currency-font>{{contractCrudCtrl.contract.currency.name}} ({{contractCrudCtrl.contract.currency.char_iso_code}})</span></div><div ng-if=\"contractCrudCtrl.mode.isView && !contractCrudCtrl.contract.currency\" class=view-entity-control>-</div></div></div><div class=row><div class=\"form-group col-xs-6\"><ui-select ng-model=contractCrudCtrl.contract.project ng-if=!contractCrudCtrl.mode.isView search-enabled=contractCrudCtrl.projects.getSearchEnabled($select) ng-disabled=contractCrudCtrl.projects.getDisabled($select) ng-class=\"{\'autocomplete-select\': contractCrudCtrl.projects.getSearchEnabled($select) && contractCrudCtrl.projects.field.total > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=contractCrudCtrl.projects.refresh($select.search) repeat=\"item in ( contractCrudCtrl.projects.field.items | filter: $select.search) track by $index\" group-by=contractCrudCtrl.totalStr(contractCrudCtrl.projects.field.total)><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Проект</label><div ng-if=contractCrudCtrl.mode.isView class=view-entity-control>{{contractCrudCtrl.contract.project.name || \'-\'}}</div></div><div class=\"form-group col-xs-6\"><input float-input float-fixed=2 float-step=0.01 max-after-comma=2 max-int-length=5 currency-input currency-icon=% type=text class=\"form-control currency-input\" id=commision ng-model=contractCrudCtrl.contract.commission ng-if=!contractCrudCtrl.mode.isView><label for=commision class=form-control-label>Комиссия</label><div class=\"valid-message wrong-simbol-mess\" style=\"position: absolute; margin-top: 3px;\">Некорректный символ для числа</div><div ng-if=\"contractCrudCtrl.mode.isView && contractCrudCtrl.contract.commission\" class=view-entity-control> {{contractCrudCtrl.parseAmount(contractCrudCtrl.contract.commission)}} %</div><div ng-if=\"contractCrudCtrl.mode.isView && !contractCrudCtrl.contract.commission\" class=view-entity-control>-</div></div></div></section>");
$templateCache.put("app/settings/contracts/crud/sections/main-info.html","<section class=col-xs-12 ng-class=\"{\'slide-up\': contractCrudCtrl.hideMainInfo}\" ng-style=\"(contractCrudCtrl.mode.isView)? {\'max-height\': \'305px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.contractCrudCtrl.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"contractCrudCtrl.hideMainInfo = !contractCrudCtrl.hideMainInfo\" ng-show=contractCrudCtrl.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=row><div id=numberAnchor class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': contractCrudCtrl.eForm.number.$invalid && !contractCrudCtrl.eForm.number.$pristine, \'has-error-unique\': contractCrudCtrl.eForm.number.$invalid && contractCrudCtrl.eForm.number.$error.unique}\"><input empty-to-null type=text name=number class=form-control id=contract-number maxlength=20 ng-model=contractCrudCtrl.contract.number ng-required=true ng-readonly=contractCrudCtrl.mode.isView ng-keyup=contractCrudCtrl.resetUniqError();><label for=contract-number class=form-control-label>Номер договора</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Договор с таким номером между выбранными компанией и контрагентом уже существует</div><span class=req></span></div><div class=\"form-group col-xs-6 checkbox-group\" ng-if=!contractCrudCtrl.mode.isView><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=contractCrudCtrl.contract.active ng-disabled=contractCrudCtrl.mode.isView> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span class=checkbox-label>Действующий договор</span></div><div class=\"form-group col-xs-6 active-status-wrapper\" ng-if=contractCrudCtrl.mode.isView ng-class=\"(!contractCrudCtrl.contract.active)? \'no-active\' : \'\'\"><span class=\"active-status tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Действуюший></span> <span ng-if=contractCrudCtrl.contract.active>Действующий</span> <span ng-if=!contractCrudCtrl.contract.active>Не активный</span></div></div><div class=row><div class=\"form-group col-xs-6\"><div date-range-picker ng-model=contractCrudCtrl.date opts=contractCrudCtrl.datePickerOpts state=contractCrudCtrl.dateState class=datepicker-wrap name=agreement_date on-close=\"contractCrudCtrl.onDatePickerClose(returnValue, name)\" ng-required=true field-label=\"\'Дата договора\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': contractCrudCtrl.eForm.contract_type.$invalid && !contractCrudCtrl.eForm.contract_type.$pristine}\"><ui-select ng-model=contractCrudCtrl.contract_type search-enabled=false ng-if=!contractCrudCtrl.mode.isView on-select=contractCrudCtrl.onContractTypeSelect() required><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item in ( contractCrudCtrl.types| filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Тип договора</label><div ng-if=contractCrudCtrl.mode.isView class=view-entity-control>{{contractCrudCtrl.contract_type.name}}</div><span class=req></span></div></div><div class=row><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0\" ng-class=\"{ \'has-error\': contractCrudCtrl.eForm.company_id.$invalid && !contractCrudCtrl.eForm.company_id.$pristine, \'has-error-unique\': contractCrudCtrl.eForm.company_id.$invalid && contractCrudCtrl.eForm.company_id.$error.unique}\"><ui-select ng-model=contractCrudCtrl.contract.company ng-if=!contractCrudCtrl.mode.isView search-enabled=\"(contractCrudCtrl.companies.field.total > 100 && contractCrudCtrl.companies.field.length <= 100)\" required name=company_id><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=contractCrudCtrl.companies.refresh($select.search) repeat=\"item in ( contractCrudCtrl.companies.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Компания</label><div ng-if=contractCrudCtrl.mode.isView class=view-entity-control>{{contractCrudCtrl.contract.company.name}}</div><span class=req></span></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0\" ng-class=\"{ \'has-error\': contractCrudCtrl.eForm.counterparty_id.$invalid && !contractCrudCtrl.eForm.counterparty_id.$pristine, \'has-error-unique\': contractCrudCtrl.eForm.counterparty_id.$invalid && contractCrudCtrl.eForm.counterparty_id.$error.unique}\"><ui-select ng-model=contractCrudCtrl.contract.counterparty ng-if=!contractCrudCtrl.mode.isView search-enabled=contractCrudCtrl.counterparties.getSearchEnabled($select) ng-class=\"{\'autocomplete-select\': contractCrudCtrl.counterparties.getSearchEnabled($select) && contractCrudCtrl.counterparties.field.total > $root.controlSettings.OPTION_DEFAULT_LENGTH}\" ng-disabled=contractCrudCtrl.counterparties.getDisabled($select) required name=counterparty_id><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=contractCrudCtrl.counterparties.refresh($select.search) repeat=\"item in contractCrudCtrl.counterparties.field.items track by $index\" group-by=contractCrudCtrl.totalStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Контрагент</label><div ng-if=contractCrudCtrl.mode.isView class=view-entity-control>{{contractCrudCtrl.contract.counterparty.name}}</div><span class=req></span></div></div></section>");
$templateCache.put("app/settings/contragents/crudContragent/sections/autocomplete.html","<div class=\"clearfix full-width\"><section style=\"display: block;\"><h5 class=section-header>Заполнить на основании организации пользователя</h5><div class=row><div class=\"form-group col-xs-6\"><input hard-pruning maxlength=30 name=domain ng-model=vm.domain ng-required=!vm.manually type=text class=form-control data-check=[a-zA-Z0-9-]* ng-keyup=vm.checkDomain();><label class=form-control-label>Домен</label><span class=req ng-if=!vm.manually></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message data-unique-mess\">Домена с таким именем не существует</div></div><div class=\"form-group col-xs-6\"><ui-select ng-model=vm.company name=company ng-required=!vm.manually on-select=vm.loadCompany() search-enabled=false ng-disabled=!vm.domain><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item in vm.companies track by $index\"><span ng-bind-html=item.name></span></ui-select-choices></ui-select><span class=req ng-if=!vm.manually></span><div class=\"valid-message required-mess\">Поле является обязательным</div><label class=form-control-label>Компания</label></div><div class=\"form-group col-xs-12\" style=\"margin-bottom: 0;\"><div class=check-wrapper><div class=\"checkbox pull-left\"><label><input type=checkbox name=manually ng-model=vm.manually id=manually ng-change=\"vm.manually? vm.initData() : false\" ng-disabled=vm.contragent.linked_company_organization> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=manually class=checkbox-label>Заполнить вручную</label></div></div></div></section></div>");
$templateCache.put("app/settings/contragents/crudContragent/sections/counterparty-roles.html","<div ng-hide=\"vm.mode.isView && !vm.contragent.roles.length\"><section class=col-xs-12 ng-class=\"{\'slide-up\': vm.hideCounterpartyRoles}\" ng-style=\"(vm.mode.isView)? {\'max-height\': \'120px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideCounterpartyRoles)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideCounterpartyRoles = !vm.hideCounterpartyRoles\" ng-show=vm.mode.isView></span><h5 class=section-header>Роли</h5><div class=row><div class=form-group ng-if=!vm.mode.isView><div class=col-xs-6 ng-repeat=\"(key, val) in vm.counterpartyRoleMap\" style=\"margin-bottom: 10px\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=val.checked> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span> <span class=\"role-name tooltip-light\" ng-bind=val.name tooltip-placement=right uib-tooltip=\"{{val.name}}\"></span></label></div></div></div><div class=form-group ng-if=vm.mode.isView><div class=col-xs-12 style=\"margin-top: 5px;\"><span class=user-role ng-repeat=\"(key, val) in vm.counterpartyRoleMap\" ng-if=val.checked ng-bind=val.name></span></div></div></div></section></div>");
$templateCache.put("app/settings/contragents/crudContragent/sections/legal-requisites.html","<!-- legal box --><div ng-class=vm.contragent.counterparty_type><section class=\"legal-requisites col-xs-12\" ng-class=\"{\'slide-up\': vm.hideLegalInfo}\" ng-style=\"(vm.mode.isView)? {\'max-height\': \'450px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideLegalInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideLegalInfo = !vm.hideLegalInfo\" ng-show=vm.mode.isView></span><h5 class=section-header>Юридические реквизиты</h5><div class=row><!-- ИНН для компании --><div class=\"form-group col-xs-6\" ng-if=\"vm.contragent.counterparty_type == \'LEGAL_ENTITY\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text inn-check inn-type=ur class=form-control name=inn id=innCompany ng-focus=\"innCompany_blur = false\" ng-blur=\"innCompany_blur = true; vm.onInnFill()\" ng-model=vm.contragent.organization.legal_requisites.inn ui-mask=9999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-hide=\"vm.mode.isView && !vm.contragent.organization.legal_requisites.inn\"><label for=innCompany class=form-control-label>ИНН</label><div ng-if=\"vm.mode.isView && !vm.contragent.organization.legal_requisites.inn\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=\"addContragent.inn.$error.mask && innCompany_blur\">ИНН должен содержать 10 цифр</span> <span class=valid-message style=display:block ng-if=\"addContragent.inn.$error.validInn && innCompany_blur\">Такой номер не существует</span></div><!-- ИНН для ИП --><div class=\"form-group col-xs-6\" ng-if=\"vm.contragent.counterparty_type == \'SOLE_TRADER\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text inn-check inn-type=fiz class=form-control name=inn ng-focus=\"innIp_blur = false\" ng-blur=\"innIp_blur = true; vm.onInnFill()\" id=innIp ng-model=vm.contragent.organization.legal_requisites.inn ui-mask=999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-hide=\"vm.mode.isView && !vm.contragent.organization.legal_requisites.inn\"><label for=innIp class=form-control-label>ИНН</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=\"addContragent.inn.$error.mask && innIp_blur\">ИНН должен содержать 12 цифр</span> <span class=valid-message style=display:block ng-if=\"addContragent.inn.$error.validInn  && innIp_blur\">Такой номер не существует</span></div><div ng-if=\"vm.contragent.counterparty_type === \'SOLE_TRADER\'\"><div class=\"form-group col-xs-6\"><input empty-to-null hard-pruning data-check=([\\d\\s_]) type=text class=form-control name=registrationNumber id=registrationNumber ng-focus=\"registrationNumber_blur = false\" ng-blur=\"registrationNumber_blur = true\" ng-model=vm.contragent.organization.legal_requisites.registration_number ui-mask=\"99 999999999\" ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-hide=vm.mode.isView><div ng-show=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.registration_number)? vm.contragent.organization.legal_requisites.registration_number : \'-\'\"></div><label for=registrationNumber class=form-control-label>Серия и № свидетельства</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=\"addContragent.registrationNumber.$error.mask && registrationNumber_blur\">Серия и № должен содержать 15 цифр</span></div></div><div class=\"form-group col-xs-6\" ng-if=\"vm.contragent.counterparty_type == \'LEGAL_ENTITY\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=kpp id=kpp ng-focus=\"kpp_blur = false\" ng-blur=\"kpp_blur = true\" ng-model=vm.contragent.organization.legal_requisites.kpp ui-mask=999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-hide=vm.mode.isView><div ng-show=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.kpp)? vm.contragent.organization.legal_requisites.kpp : \'-\'\"></div><label for=kpp class=form-control-label>КПП</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=\"addContragent.kpp.$error.mask && kpp_blur\">КПП должен содержать 9 цифр</span></div><div class=clear></div><div class=\"form-group col-xs-6\"><textarea empty-to-null type=text class=form-control id=fullNomination maxlength=255 ng-model=vm.contragent.organization.legal_requisites.full_name ng-hide=vm.mode.isView></textarea><div ng-show=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.full_name)? vm.contragent.organization.legal_requisites.full_name : \'-\'\"></div><label for=fullNomination class=form-control-label>Полное наименование</label></div><div class=\"form-group col-xs-6 pull-right\" ng-if=\"vm.contragent.counterparty_type == \'SOLE_TRADER\'\"><address address-data=vm.contragent.organization.legal_requisites.legal_address name=\"\'legal_address\'\" parent-form=addContragent address-controls=vm.addressOptions field-label=\"\'Адрес регистрации\'\"></address><div ng-if=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.legal_address)? vm.contragent.organization.legal_requisites.legal_address.address_as_string : \'-\'\"></div></div><div class=\"form-group col-xs-6 pull-right\" ng-if=\"vm.contragent.counterparty_type == \'LEGAL_ENTITY\'\"><address address-data=vm.contragent.organization.legal_requisites.legal_address name=\"\'legal_address\'\" parent-form=addContragent address-controls=vm.addressOptions field-label=\"\'Юридический адрес\'\"></address><div ng-if=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.legal_address.address_as_string)? vm.contragent.organization.legal_requisites.legal_address.address_as_string : \'-\'\"></div></div><div class=clear></div><div class=\"form-group col-xs-6\"><input empty-to-null type=text class=form-control id=shortNomination maxlength=255 ng-model=vm.contragent.organization.legal_requisites.short_name ng-hide=vm.mode.isView><div ng-show=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.short_name)? vm.contragent.organization.legal_requisites.short_name : \'-\'\"></div><label for=shortNomination class=form-control-label>Сокращенное наименование</label></div><!-- ОГРН для компаний --><div class=\"form-group col-xs-6\" ng-if=\"vm.contragent.counterparty_type == \'LEGAL_ENTITY\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=ogrn id=ogrnUr ng-focus=\"ogrn_blur = false\" ng-blur=\"ogrn_blur = true\" ng-model=vm.contragent.organization.legal_requisites.ogrn ui-mask=9999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-hide=vm.mode.isView><label for=ogrnUr class=form-control-label>ОГРН</label><div ng-show=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.ogrn)? vm.contragent.organization.legal_requisites.ogrn : \'-\'\"></div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=\"addContragent.ogrn.$error.mask && ogrn_blur\">ОГРН должен содержать 13 цифр</span></div><!-- ОГРН для ИП --><div class=\"form-group col-xs-6\" ng-if=\"vm.contragent.counterparty_type == \'SOLE_TRADER\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=ogrn id=ogrnIp ng-focus=\"ogrnip_blur = false\" ng-blur=\"ogrnip_blur = true\" ng-model=vm.contragent.organization.legal_requisites.ogrn ui-mask=999999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-hide=vm.mode.isView><div ng-show=vm.mode.isView class=view-entity-control ng-bind=\"(vm.contragent.organization.legal_requisites.ogrn)? vm.contragent.organization.legal_requisites.ogrn : \'-\'\"></div><label for=ogrnIp class=form-control-label>ОГРНИП</label><div class=\"valid-message wrong-simbol-mess\" style=\"position: absolute\">Некорректный символ</div><span class=valid-message style=\"display:block;position: absolute\" ng-if=\"addContragent.ogrn.$error.mask && ogrnip_blur\">ОГРНИП должен содержать 15 цифр</span></div><div class=\"form-group col-xs-6\" ng-if=\"vm.contragent.counterparty_type == \'SOLE_TRADER\'\"><div date-range-picker ng-model=vm.registration_date opts=vm.datePickerOpts state=vm.dateState class=datepicker-wrap name=registration_date on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата регистрации\'\"></div><div class=\"valid-message wrong-simbol-mess\" style=position:absolute>Некорректный символ</div></div><!--/для юр. лиц  --><div class=\"col-xs-6 form-group checkbox-group\"><div class=\"checkbox pull-left vatPayer\" ng-hide=\"vm.mode.isView && !vm.contragent.organization.vat_payer\"><label><input type=checkbox id=vatPayer ng-model=vm.contragent.organization.vat_payer> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=vatPayer ng-hide=\"vm.mode.isView && !vm.contragent.organization.vat_payer\">Плательщик НДС</label></div></div></section></div>");
$templateCache.put("app/settings/contragents/crudContragent/sections/main-person.html","<div class=main-person><section class=\"form-group tab-form-group post-tabs col-xs-12\"><span class=\"add-new-post tooltip-light\" ng-click=vm.addRepresentatives() ng-if=!vm.mode.isView tooltip-placement=bottom-left uib-tooltip=\"Добавить нового представителя\"></span><scrollable-tabset api=vm.scrlTabsApi scroll-by=216 show-tooltips=false><uib-tabset active=vm.activeContact><uib-tab index=0 select=vm.selectTab(0)><uib-tab-heading class=tab-heading><span class=pull-left>Руководитель</span></uib-tab-heading><div class=clearfix><div class=\"form-group col-xs-6\"><!-- ФИО напрямую маппится на сущность, person опосредованно --><div id=chief-fio person-data-input fio=vm.contragent.organization.chief_name form-model=vm.contragent.organization.chief_person field-label=\"\'ФИО\'\"></div></div><div class=\"form-group col-xs-6\"><input empty-to-null type=text class=form-control id=companyChief maxlength=50 ng-model=vm.contragent.organization.chief_position ng-hide=\"vm.mode.isView && !vm.contragent.organization.chief_position\"><label for=companyChief class=form-control-label>Должность</label><div ng-if=\"vm.mode.isView && !vm.contragent.organization.chief_position\" class=view-entity-control>-</div></div></div></uib-tab><uib-tab index=1 ng-hide=\"vm.mode.isView && !vm.contragent.organization.chief_accountant_person && !vm.contragent.organization.chief_accountant_name\" select=vm.selectTab(1)><uib-tab-heading class=tab-heading><span class=pull-left>Бухгалтер</span></uib-tab-heading><div class=clearfix><div class=\"form-group col-xs-6\"><!-- ФИО напрямую маппится на сущность, person опосредованно --><div id=chief-fio person-data-input fio=vm.contragent.organization.chief_accountant_name form-model=vm.contragent.organization.chief_accountant_person field-label=\"\'ФИО\'\"></div></div></div></uib-tab><uib-tab ng-repeat=\"repres in vm.contragent.contacts\" index=\"$index + 2\" select=\"vm.selectTab($index + 2)\"><uib-tab-heading class=tab-heading><span class=pull-left>{{(repres.position)? repres.position : \'Представитель\'}}</span><span class=\"close-tab danger-close tooltip-light\" tooltip-placement=right uib-tooltip=Удалить ng-click=\"repres.$$askRemove = true;\"></span><div class=\"remove-tab major-font\" ng-class=\"{\'ask-remove\': repres.$$askRemove}\"><span class=\"glyphicon glyphicon-trash\"></span><label class=tab-remove-label>Удалить?</label><span class=pull-right><span class=tab-remove-yes ng-click=\"vm.removeRepresentatives($index, $event)\">Да</span>/ <span class=tab-remove-no ng-click=\"repres.$$askRemove = false;\">Нет</span></span></div></uib-tab-heading><div><div class=row><div class=\"form-group col-xs-6\"><input empty-to-null type=text class=form-control id=\"counterpartyContact{{$index}}\" ng-model=repres.position maxlength=50><label for=\"counterpartyContact{{$index}}\" class=form-control-label>Должность</label></div><div class=\"form-group col-xs-6\"><div id=user-fio person-data-input fio=repres.name form-model=repres.person field-label=\"\'ФИО\'\"></div></div><div class=\"form-group col-xs-6\"><input hard-pruning empty-to-null ng-model=repres.contact_info.details[0].value type=tel name=phone data-check=\"[0-9*+() -]\" class=form-control maxlength=20 id=\"counterpartyPhone{{$index}}\" ng-hide=vm.mode.isView><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div ng-if=vm.mode.isView class=view-entity-control ng-bind=\"(repres.contact_info.details[0].value)? repres.contact_info.details[0].value : \'-\'\"></div><label for=\"counterpartyPhone{{$index}}\" class=form-control-label>Телефон</label></div><div class=\"form-group col-xs-6\"><email mail=repres.contact_info.details[1].value is-view=vm.mode.isView></email></div></div></div></uib-tab></uib-tabset></scrollable-tabset></section></div>");
$templateCache.put("app/settings/discounts/crudDiscount/modals/catalogItemsPopup.html","<div class=\"modal-body catalog-items-popup\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3>Товары и услуги в продаже</h3><div class=\"row clearfix main-control-block\" style=\"background: none; margin: 25px -15px;\"><div class=\"description col-xs-6\">Выберите те товары и услуги, на которые будет распространяться действие скидочной акции</div><form class=\"search-entity col-xs-6\" role=search ng-submit=search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=search() class=\"form-control label-clear-button\" ng-model=searchText placeholder=Поиск> <button class=\"btn slim-button search-btn\" ng-click=search()>Поиск</button></div></form></div><div ng-scrollbars ng-scrollbars-config=configScroll class=shares-types-wrapper><catalog-tree ng-show=!showSearch min-height=400 root-visible=false block-choice-hoisting=true load-callback=onTreeLoaded on-collapse-node=onCollapseNode on-expand-node=onExpandNode expand-node=expand root=root show-checkbox=true load-callback=onTreeLoaded allow-checkbox=isBlockCheckbox></catalog-tree><grid-search ng-show=\"showSearch && searchResult.length\" results=searchResult show-checkbox=true external-selection-model=currentSelectionTree parent-property=parentList expand-callback=expandTreePath></grid-search><div class=\"no-content text-center\" ng-if=\"showSearch && !searchResult.length\"><p>К сожалению, поиск не дал результатов.<br>Попробуйте уточнить запрос<br>и повторить попытку</p><div class=arrow></div></div></div><div class=modal-footer><button class=\"btn btn-default\" ng-click=close()>Отменить</button> <button class=btn ng-click=choose()>Выбрать</button></div></div>");
$templateCache.put("app/settings/discounts/crudDiscount/modals/propertyPopup.html","<div class=\"modal-body property-popup\"><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3>Типы скидочных акций</h3><div class=\"row clearfix main-control-block\" style=\"background: none;\"><div class=\"description col-md-7\">Мы подготовили для вас набор типовых решений для организации системы скидок в компании. Выберите наиболее подходящий для вас</div><form class=\"search-entity col-xs-5\" role=search ng-submit=search()><div class=form-group><span class=input-group-addon><span class=\"glyphicon glyphicon-search\"></span></span> <input type=text clear-button callback=search() class=\"form-control label-clear-button\" ng-model=searchText placeholder=Поиск> <button class=\"btn slim-button search-btn\" ng-click=search()>Поиск</button></div></form></div><div ng-scrollbars ng-scrollbars-config=configScroll class=shares-types-wrapper><ul class=shares-types><li ng-repeat=\"type in propertyTypes\" class=\"row clearfix\" ng-hide=\"type.type == \'FIXED_AMOUNT\'\"><div class=\"col-xs-2 discount-img\"></div><div class=\"col-xs-7 discount-info\"><h5 class=discount-name ng-bind=type.name></h5><div class=discount-descr ng-bind=type.description></div><span class=\"discount-example tooltip-light\" tooltip-placement=right uib-tooltip=\"{{type.example}}\" ng-if=type.example>Подсказка</span></div><div class=col-xs-3><span class=\"btn btn-primary\" ng-click=\"choose(type, $index)\">Выбрать</span></div></li></ul></div></div>");
$templateCache.put("app/settings/divisions/crudDivision/sections/common-info.html","<section class=\"form-group col-xs-9\" ng-class=\"{\'slide-up\': divisionCrudCtrl.hideMainInfo}\" ng-style=\"(divisionCrudCtrl.mode.isView)? {\'max-height\': \'305px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(divisionCrudCtrl.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"divisionCrudCtrl.hideMainInfo = !divisionCrudCtrl.hideMainInfo\" ng-show=divisionCrudCtrl.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group col-xs-6\"><ui-select ng-model=divisionCrudCtrl.company ng-if=divisionCrudCtrl.mode.isNew search-enabled=\"(divisionCrudCtrl.companies.field.total > 100 && divisionCrudCtrl.companies.field.length === 100)|| $select.search\" on-select=divisionCrudCtrl.companySelected() required><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=divisionCrudCtrl.companies.refresh($select.search) repeat=\"item in ( divisionCrudCtrl.companies.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"item.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><input type=text ng-if=divisionCrudCtrl.mode.isEdit class=form-control ng-model=divisionCrudCtrl.company.name disabled><div ng-if=divisionCrudCtrl.mode.isView class=view-entity-control ng-bind=divisionCrudCtrl.company.name></div><label class=form-control-label>Относится к компании</label><span class=req></span></div><div class=\"form-group col-xs-6 pull-right\" style=\"margin-bottom: 25px;\"><address address-data=divisionCrudCtrl.division.address name=\"\'address\'\" ng-required=true parent-form=addDivision address-controls=divisionCrudCtrl.addressOptions field-label=\"\'Фактический адрес\'\"></address><div ng-show=divisionCrudCtrl.mode.isView class=view-entity-control ng-bind=\"(divisionCrudCtrl.division.address.address_as_string)? divisionCrudCtrl.division.address.address_as_string : \'-\'\"></div></div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': addDivision.name.$invalid && addDivision.name.$error.unique}\"><input type=text class=form-control maxlength=30 name=name id=name ng-model=divisionCrudCtrl.division.name required ng-keyup=\"addDivision.name.$setValidity(\'unique\', true)\" ng-blur=\"divisionCrudCtrl.uniqueCheck(divisionCrudCtrl.division.name, \'DIVISION\', \'name\')\" ng-hide=divisionCrudCtrl.mode.isView><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=addDivision.name.$error><div ng-message=unique class=\"valid-message isset-name\">Подразделение уже существует</div></div><label for=name class=form-control-label>Название</label><div ng-if=divisionCrudCtrl.mode.isView class=view-entity-control ng-bind=divisionCrudCtrl.division.name></div><span class=req></span></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0;\" ng-if=\"divisionCrudCtrl.company.legal_status === \'LEGAL_ENTITY\' || divisionCrudCtrl.company.organization.legal_requisites.legal_status === \'LEGAL_ENTITY\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=kpp id=kpp ng-focus=\"kpp_blur = false\" ng-blur=\"kpp_blur = true\" ng-model=divisionCrudCtrl.division.kpp ng-hide=divisionCrudCtrl.mode.isView ui-mask=999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=kpp class=form-control-label>КПП</label><div ng-if=divisionCrudCtrl.mode.isView class=view-entity-control>{{divisionCrudCtrl.division.kpp ? divisionCrudCtrl.division.kpp : \'-\'}}</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=\"parentForm.kpp.$error.mask && kpp_blur\">КПП должен содержать 9 цифр</span></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0;\"><ui-select ng-model=divisionCrudCtrl.division.project ng-hide=divisionCrudCtrl.mode.isView search-enabled=\"divisionCrudCtrl.projectsFullTotal > 5\" ng-class=\"{\'autocomplete-select\': divisionCrudCtrl.projectsFullTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=divisionCrudCtrl.refreshProjects($select.search) repeat=\"item in ( divisionCrudCtrl.projects.items | filter: $select.search) track by $index\" group-by=divisionCrudCtrl.totalSelectStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Проект</label><div ng-if=divisionCrudCtrl.mode.isView class=view-entity-control>{{divisionCrudCtrl.division.project.name || \'-\'}}</div></div></div></section><div class=\"col-xs-3 section-helper\" style=\"max-width: 450px;\"><div ng-if=divisionCrudCtrl.mode.isView><div class=\"radio-group edit-radio-group checked\"><label class=\"radio-label office\" ng-if=\"divisionCrudCtrl.division.type == \'OFFICE\'\">Офис</label><label class=\"radio-label shop\" ng-if=\"divisionCrudCtrl.division.type == \'SHOP\'\">Магазин</label><label class=\"radio-label warehouse\" ng-if=\"divisionCrudCtrl.division.type == \'STOREHOUSE\'\">Склад</label></div></div></div>");
$templateCache.put("app/settings/divisions/crudDivision/sections/special-tax.html","<section class=\"form-group col-xs-9 same-padding\" ng-if=!divisionCrudCtrl.mode.isView ng-click=divisionCrudCtrl.showSpecialTaxBlock(); ng-class=\"{\'ng-hide\': divisionCrudCtrl.specialTaxOn}\"><button class=add-item-wrap><span class=add-item-icon></span> <span class=add-item-title>СПЕЦИАЛЬНЫЙ РЕЖИМ НАЛОГООБЛОЖЕНИЯ</span></button></section><section class=\"form-group col-xs-9\" ng-if=divisionCrudCtrl.specialTaxOn ng-class=\"{\'slide-up\': divisionCrudCtrl.hideSpecialTax}\" ng-style=\"(divisionCrudCtrl.mode.isView)? {\'max-height\': \'305px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(divisionCrudCtrl.hideSpecialTax)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"divisionCrudCtrl.hideSpecialTax = !divisionCrudCtrl.hideSpecialTax\" ng-show=divisionCrudCtrl.mode.isView></span><h5 class=section-header>СПЕЦИАЛЬНЫЙ РЕЖИМ НАЛОГООБЛОЖЕНИЯ</h5><div class=row ng-if=\"!divisionCrudCtrl.division.special_tax_modes.length && divisionCrudCtrl.mode.isNew\"><div class=\"form-group col-xs-6\"><ui-select ng-model=divisionCrudCtrl.currentTax.special_tax_mode search-enabled=false required><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"tax.type as tax in divisionCrudCtrl.specialTaxes\"><span ng-bind-html=tax.name></span></ui-select-choices></ui-select><label class=form-control-label>Специальный режим налогообложения</label><span class=req></span></div><div class=\"form-group col-xs-6\" style=\"height: 48px;\"></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0\"><div date-range-picker ng-class=\"{\'ng-invalid-date-error\': addDivision.start_date.$error.dateError && divisionCrudCtrl.isSetDirty}\" ng-model=divisionCrudCtrl.currentTax.start_date opts=\"{singleDatePicker: true, correctTimeZone: false}\" state=divisionCrudCtrl.datePickerState class=datepicker-wrap name=start_date ng-required=true on-close=\"divisionCrudCtrl.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата начала действия\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message date-error\">Дата окончания действия спецрежима должна быть позднее даты начала</div></div><div class=\"form-group col-xs-6\" style=\"margin-bottom: 0\"><div date-range-picker ng-class=\"{\'ng-invalid-date-error\': addDivision.end_date.$error.dateError && divisionCrudCtrl.isSetDirty}\" ng-model=divisionCrudCtrl.currentTax.end_date opts=\"{singleDatePicker: true, correctTimeZone: false, minDate: divisionCrudCtrl.currentTax.start_date}\" state=divisionCrudCtrl.datePickerStateEnd class=datepicker-wrap name=end_date ng-required=\"divisionCrudCtrl.currentTax.special_tax_mode == \'PATENT\'\" on-close=\"divisionCrudCtrl.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата окончания действия\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message date-error\">Дата окончания действия спецрежима должна быть позднее даты начала</div></div></div><div ng-if=!divisionCrudCtrl.mode.isNew class=clearfix><span class=tax-selected ng-bind=\"divisionCrudCtrl.currentTax.special_tax_mode | tax\"></span><div style=\"margin-top: -20px; opacity:0.3; margin-bottom: 10px;\" ng-if=divisionCrudCtrl.currentTax.start_date>c {{divisionCrudCtrl.currentTax.start_date | date : \'dd.MM.yyyy\'}} <span ng-if=divisionCrudCtrl.currentTax.end_date>по {{divisionCrudCtrl.currentTax.end_date | date : \'dd.MM.yyyy\'}}</span></div><a class=\"btn tax-change\" ng-click=\"divisionCrudCtrl.showPopup(\'change\');\" ng-if=divisionCrudCtrl.mode.isEdit ng-bind=\"(divisionCrudCtrl.tax_modes_modified.length)? \'Изменить\' : \'Добавить\'\"></a> <a class=tax-history ng-click=\"divisionCrudCtrl.showPopup(\'history\');\" ng-if=divisionCrudCtrl.tax_modes_modified.length><span class=\"glyphicon glyphicon-file\"></span>История</a></div><div class=info-click ng-if=\"divisionCrudCtrl.mode.isEdit && divisionCrudCtrl.tax_modes_modified.length\"><button class=\"btn btn-ico btn-info dropdown-toggle\" type=button></button><div class=dropdown-menu ng-click=$event.stopPropagation(); style=\"width: 280px; right: 0; left: inherit;\"><span>Для добавления спецрежима налогообложения используйте кнопку \"Изменить\", при этом новый спецрежим с указанными параметрами будет выставлен для текущего подразделения. При необходимости редактирования спецрежима, добавленного ранее, необходимо удалить его из списка в окне \"История\" и добавить заново с корректными значениями.</span></div></div></section>");
$templateCache.put("app/settings/employees/crud/controls/button-block.html","<div class=clearfix><a href=\"\" ng-if=employeesCrudCtrl.mode.isEdit ng-click=employeesCrudCtrl.delete() class=\"btn btn-default btn-padding-lg\"><span class=\"glyphicon glyphicon-trash\" aria-hidden=true style=\"margin-right: 8px\">Удалить</a> <button class=\"btn btn-default btn-padding-lg\" ng-if=employeesCrudCtrl.mode.isView ng-click=employeesCrudCtrl.returnToPage()>&#60; Вернуться</button><div class=pull-right ng-if=\"employeesCrudCtrl.mode.isEdit || employeesCrudCtrl.mode.isNew\"><button class=\"btn btn-default btn-padding-lg\" ng-click=employeesCrudCtrl.resetData()>Отменить</button> <a href=\"\" class=\"btn btn-success btn-padding-lg\" ng-click=\"employeesCrudCtrl.eform.$valid ? employeesCrudCtrl.save() : employeesCrudCtrl.setDirty()\" ng-disabled=!employeesCrudCtrl.eform.$valid><span ng-show=!employeesCrudCtrl.mode.isNew>Сохранить</span> <span ng-show=employeesCrudCtrl.mode.isNew>Создать</span></a></div><div class=pull-right ng-if=employeesCrudCtrl.mode.isView><a ui-sref=\"employee.edit({userId: employeesCrudCtrl.user.id, parent: \'business\'})\" class=\"btn btn-success btn-padding-lg\">Редактирование</a></div></div>");
$templateCache.put("app/settings/employees/crud/sections/companies-access.html","<section class=col-xs-9 ng-hide=!employeesCrudCtrl.user.enabled><h5 class=section-header>Доступ к компаниям</h5><div class=row><div class=\"col-xs-12 company-access\" ng-repeat=\"company in employeesCrudCtrl.user.data_access_rules.company_access_rules\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=company.enabled ng-disabled=employeesCrudCtrl.mode.isView ng-change=employeesCrudCtrl.checkAllCompany(company);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span> <span class=role-name ng-bind=company.company_name></span></label></div></div></div><div class=section-footer><div class=\"checkbox pull-left\" style=\"margin-top: 4px\"><label style=\"font-size: 1.2em; padding: 0\"><input type=checkbox id=all-company-access ng-model=employeesCrudCtrl.user.data_access_rules.has_access ng-disabled=employeesCrudCtrl.mode.isView ng-change=employeesCrudCtrl.allCompanyAccess();> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=all-company-access style=\"font-weight: 100\">Доступ ко всем текущим и будущим компаниям и подразделениям</label></div></section>");
$templateCache.put("app/settings/employees/crud/sections/main-info.html","<div class=\"clearfix full-width\" style=\"max-width: 1333px\"><section class=col-xs-9 ng-hide=employeesCrudCtrl.mode.isView><div class=\"form-group checkbox-group\" style=\"margin-bottom: 0\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=employeesCrudCtrl.user.enabled id=enabled-check> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=enabled-check>Возможность входить в систему ТОРГОВЛЯ.ОНЛАЙН</label></div></section><div class=\"col-xs-3 section-helper pull-right\"><div class=narrow-container ng-show=employeesCrudCtrl.mode.isNew style=\"margin: 7px 0 30px;\">Вы можете добавлять в систему всех своих сотрудников, но получать возможность работать в ней будут только те, у кого установлен признак возможности доступа в систему</div><div class=narrow-container><div class=avatar-container><div class=\"avatar-overlay text-center user-change-pass\" ng-hide=!employeesCrudCtrl.user.need_change_password tooltip-placement=bottom-left uib-tooltip=\"Cмена пароля\"></div><div class=person-logo ng-click=employeesCrudCtrl.openImgView(); style=\"background-image: url({{employeesCrudCtrl.user.user_photo.url}});\" ng-class=\"{\'bg-isset\': employeesCrudCtrl.user.user_photo.url}\"><span class=photo></span> <span class=txt>Фото сотрудника</span></div><br><div class=link-style style=\"margin-bottom: 8px; margin-left: 22px;\" ng-click=employeesCrudCtrl.showImgLoadPopup() ng-show=\"!employeesCrudCtrl.mode.isView && $root.hasRole(\'upload.user_photo\')\">Загрузить фото</div><div class=\"link-style text-danger\" ng-click=\"employeesCrudCtrl.user.user_photo = undefined;\" style=\"margin-left: 22px;\" ng-show=\"!employeesCrudCtrl.mode.isView && $root.hasRole(\'upload.user_photo\') && employeesCrudCtrl.user.user_photo.url\">Удалить фото</div></div></div></div><section class=col-xs-9 ng-class=\"{\'slide-up\': employeesCrudCtrl.hideMainInfo}\" ng-style=\"(employeesCrudCtrl.mode.isView)? {\'max-height\': \'620px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(employeesCrudCtrl.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"employeesCrudCtrl.hideMainInfo = !employeesCrudCtrl.hideMainInfo\" ng-show=employeesCrudCtrl.mode.isView></span><h5 class=section-header>Основная информация</h5><div class=\"row clearfix\"><div class=\"form-group col-xs-6\" id=nameAnchor ng-class=\"{\'has-error\': employeesCrudCtrl.eform.name.$invalid && !employeesCrudCtrl.eform.name.$pristine, \'has-error-unique\': employeesCrudCtrl.eform.name.$invalid && employeesCrudCtrl.eform.name.$error.unique}\"><!-- ФИО напрямую маппится на сущность, person опосредованно --><div id=employee-fio person-data-input fio=employeesCrudCtrl.user.name form-model=employeesCrudCtrl.user.person name-and-id=name is-required=true unique-callback=employeesCrudCtrl.uniqueCheck field-label=\"\'ФИО\'\"></div><div class=\"valid-message isset-name\">Сотрудник с таким именем уже существует</div><span class=req></span></div><div id=loginAnchor class=\"form-group col-xs-6\" ng-hide=\"employeesCrudCtrl.mode.isNew || !employeesCrudCtrl.user.enabled\" ng-class=\"{\'has-error\': employeesCrudCtrl.eform.login.$invalid && !employeesCrudCtrl.eform.login.$pristine, \'has-error-unique\': employeesCrudCtrl.eform.login.$invalid && employeesCrudCtrl.eform.login.$error.unique}\"><input type=text name=login empty-to-null=true hard-pruning data-check=[0-9a-zA-z] maxlength=30 class=form-control ng-model=employeesCrudCtrl.user.login ng-readonly=employeesCrudCtrl.mode.isView ng-disabled=employeesCrudCtrl.disableLogin ng-keyup=\"employeesCrudCtrl.eform.login.$setValidity(\'unique\', true); employeesCrudCtrl.resetLoginError();\" id=employee-login ng-blur=\"employeesCrudCtrl.uniqueCheck(employeesCrudCtrl.user.login, $event)\" ng-if=!employeesCrudCtrl.mode.isView><label for=employee-login class=form-control-label>Логин</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\"><span ng-bind=\"(employeesCrudCtrl.mode.isNew || employeesCrudCtrl.disableLogin)? \'Телефон или Email\' : \'Телефон, email или логин\'\"></span> должны быть заполнены</div><div class=\"valid-message isset-name\">Сотрудник с таким логином уже существует</div><div ng-if=employeesCrudCtrl.mode.isView class=view-entity-control ng-bind=\"employeesCrudCtrl.user.login || ((employeesCrudCtrl.user.phone && employeesCrudCtrl.user.phone_confirmed)? (employeesCrudCtrl.user.phone | phoneFormat) : (employeesCrudCtrl.user.email && employeesCrudCtrl.user.email_confirmed)? employeesCrudCtrl.user.email : \'-\')\"></div></div></div><div class=row><div class=\"form-group col-xs-6\"><div class=phone-input-wrapper ng-class=\"{\'col-xs-6\': employeesCrudCtrl.mode.isView && employeesCrudCtrl.user.phone && $root.hasRole(\'user.write\')}\" style=\"padding-left: 0;\"><input id=tel name=phone class=form-control maxlength=15 ng-pattern=\"/^\\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/\" empty-to-null=true phone-input ng-keyup=\"employeesCrudCtrl.user.phone_confirmed = false; employeesCrudCtrl.resetLoginError(); employeesCrudCtrl.eform.phone.$setValidity(\'unique\', true); employeesCrudCtrl.resetLogin($event);\" ng-blur=\"employeesCrudCtrl.uniqueCheck(employeesCrudCtrl.user.phone, $event);\" ng-model=employeesCrudCtrl.user.phone ng-hide=\"employeesCrudCtrl.mode.isView && !employeesCrudCtrl.user.phone\"><label for=tel class=\"form-control-label phone-control-label always-top\" style=\"padding-left: 0;\" ng-style=\"{\'left\': employeesCrudCtrl.mode.isView ? \'0px\' : \'10px\'}\">Телефон</label><span class=\"field-status tip-top\" ng-bind=\"(!employeesCrudCtrl.eform.phone.$dirty)? (employeesCrudCtrl.user.phone_confirmed)? \'Телефон подтвержден\' : \'Телефон не подтвержден\' : \'\'\"></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess small-offset\"><span ng-bind=\"(employeesCrudCtrl.mode.isNew || employeesCrudCtrl.disableLogin)? \'Телефон или email\' : \'Телефон, email или логин\'\"></span> должны быть заполнены</div><div class=\"valid-message invalid-unique-mess small-offset\">Сотрудник с таким телефоном уже существует</div><div ng-if=\"employeesCrudCtrl.mode.isView && !employeesCrudCtrl.user.phone\" class=view-entity-control>-</div></div><div class=status-control ng-hide=employeesCrudCtrl.mode.isView><span class=\"glyphicon glyphicon-ok confirm-field-ico tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Телефон подтвержден\" ng-if=employeesCrudCtrl.user.phone_confirmed></span> <span class=no-confirm-field-ico tooltip-placement=bottom-left uib-tooltip=\"Телефон не подтвержден\" ng-if=!employeesCrudCtrl.user.phone_confirmed></span></div></div><div class=\"form-group col-xs-6\" ng-class=\"{\'ng-invalid-required\': employeesCrudCtrl.eform.email.$error.required}\"><email mail=employeesCrudCtrl.user.email confirmed=\"employeesCrudCtrl.user.email && employeesCrudCtrl.user.email_confirmed\" modify-confirmed=true is-view=employeesCrudCtrl.mode.isView mail-name=email blur-event=employeesCrudCtrl.uniqueCheck key-event=employeesCrudCtrl.resetEmailError></email><div class=\"valid-message required-mess\"><span ng-bind=\"(employeesCrudCtrl.mode.isNew || employeesCrudCtrl.disableLogin)? \'Телефон или email\' : \'Телефон, email или логин\'\"></span> должны быть заполнены</div><span class=\"field-status tip-top\" ng-bind=\"(!employeesCrudCtrl.eform.email.$dirty)? (employeesCrudCtrl.user.email_confirmed)? \'E-mail подтвержден\' : \'E-mail не подтвержден\' : \'\'\"></span></div><div class=\"pull-right col-xs-6 text-muted\" style=\"word-break: break-word; padding-right: 35px; margin: -19px 0 10px; font-size: 14px;\" ng-if=\"employeesCrudCtrl.user.pending_email_changes.length && employeesCrudCtrl.user.email != employeesCrudCtrl.user.pending_email_changes[employeesCrudCtrl.user.pending_email_changes.length-1].email\">Отправлен запрос подтверждения <strong>{{employeesCrudCtrl.user.pending_email_changes[employeesCrudCtrl.user.pending_email_changes.length-1].email}}</strong></div></div><div class=row><div class=\"form-group col-xs-6\" ng-hide=\"employeesCrudCtrl.mode.isView && !employeesCrudCtrl.user.location\"><address address-data=employeesCrudCtrl.user.location name=\"\'location\'\" parent-form=employeesCrudCtrl.eform mode=\"\'input\'\" truncate=true timezone=employeesCrudCtrl.timeZoneSelected field-label=\"\'Местоположение\'\"></address><div ng-if=employeesCrudCtrl.mode.isView class=view-entity-control ng-bind=\"(employeesCrudCtrl.user.location.address_as_string)? employeesCrudCtrl.user.location.address_as_string : \'-\'\" style=\"height: auto;\"></div></div><div class=\"form-group col-xs-6\" ng-hide=\"employeesCrudCtrl.mode.isView && !employeesCrudCtrl.timeZoneSelected\"><ui-select ng-model=employeesCrudCtrl.timeZoneSelected ng-disabled=employeesCrudCtrl.mode.isView ng-hide=employeesCrudCtrl.mode.isView><ui-select-match allow-clear=true><span ng-bind=\"\'(UTC\' + $select.selected.offset + \') \' + $select.selected.displayName\"></span></ui-select-match><ui-select-choices repeat=\"zone in (employeesCrudCtrl.timezones | filter: $select.search) track by zone.timezoneId\"><span ng-bind=\"\'(UTC\' + zone.offset + \') \' + zone.displayName\"></span></ui-select-choices></ui-select><label class=form-control-label>Часовой пояс</label><div class=view-entity-control ng-show=\"employeesCrudCtrl.mode.isView && employeesCrudCtrl.timeZoneSelected.displayName\"> {{employeesCrudCtrl.timeZoneSelected.displayName}} </div></div></div><!--div class=\"row\">\n      <div class=\"form-group col-xs-6 confirm-field-wrap\">\n        <email mail=\"employeesCrudCtrl.user.email\" confirmed=\"employeesCrudCtrl.user.email_confirmed && !employeesCrudCtrl.mailNotRequired\" is-required=\"employeesCrudCtrl.user.enabled && !employeesCrudCtrl.mailNotRequired\" is-view=\"employeesCrudCtrl.mode.isView\"></email>\n      </div>\n      <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': employeesCrudCtrl.eform.phone.$invalid && !employeesCrudCtrl.eform.phone.$pristine}\" ng-hide=\"employeesCrudCtrl.mode.isView && !employeesCrudCtrl.user.phone\">\n        <div class=\"phone-input-wrapper\" ng-if=\"!employeesCrudCtrl.mode.isView\">\n          <input id=\"tel\"\n                 name=\"employeePhone\"\n                 ng-readonly=\"employeesCrudCtrl.mode.isView\"\n                 class=\"form-control\"\n                 maxlength=\"15\"\n                 ng-pattern=\"/^\\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$/\"\n                 phone-input\n                 ng-model=\"employeesCrudCtrl.user.phone\">\n          <label for=\"tel\" class=\"form-control-label phone-control-label\">Телефон</label>\n          <span class=\"field-status tip-top\"\n                ng-bind=\"(!editProfileForm.phone.$dirty)? (vm.userData.phone_confirmed)? \'Телефон подтвержден\' : \'Телефон не подтвержден\' : \'\'\">\n                  </span>\n          <div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div>\n        </div>\n        <div ng-if=\"employeesCrudCtrl.mode.isView\" class=\"view-entity-control\" ng-bind=\"(employeesCrudCtrl.user.phone)? employeesCrudCtrl.user.phone : \'-\'\"></div>\n      </div>\n    </div--><div class=row><div class=\"form-group col-xs-6\"><ui-select ng-model=employeesCrudCtrl.user.project ng-hide=employeesCrudCtrl.mode.isView search-enabled=\"employeesCrudCtrl.projectsFullTotal > 5\" ng-class=\"{\'autocomplete-select\': employeesCrudCtrl.projectsFullTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=employeesCrudCtrl.refreshProjects($select.search) repeat=\"item in ( employeesCrudCtrl.projects.items | filter: $select.search) track by $index\" group-by=employeesCrudCtrl.totalSelectStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Проект</label><div ng-if=employeesCrudCtrl.mode.isView class=view-entity-control>{{employeesCrudCtrl.user.project.name || \'-\'}}</div></div><contact-info contact-info=employeesCrudCtrl.user.contact_info min-details-required=0></contact-info></div></section></div>");
$templateCache.put("app/settings/employees/crud/sections/roles.html","<section class=col-xs-9 ng-if=employeesCrudCtrl.user.enabled ng-init=employeesCrudCtrl.changeRole();><h5 class=section-header>Роли: <span class=req ng-if=!employeesCrudCtrl.mode.isView></span></h5><div class=\"row role_wrapper\" ng-if=!employeesCrudCtrl.mode.isView ng-class=\"{\'required-checkbox\':employeesCrudCtrl.redCheckbox}\"><div ng-if=\"role.toLowerCase() != \'admin\' && employeesCrudCtrl.isPublicRole(role);\" class=\"col-xs-6 role\" ng-repeat=\"(role, state) in employeesCrudCtrl.rolesMap\" ng-class=\"{\'ng-invalid\': employeesCrudCtrl.eform[role.toLowerCase()].$invalid}\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-init=\"employeesCrudCtrl.redCheckbox = false\" ng-required=employeesCrudCtrl.requiredCheckbox ng-model=state.enabled ng-change=employeesCrudCtrl.changeRole(); name=\"{{role.toLowerCase()}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span> <span class=\"role-name tooltip-light\" ng-bind=state.name tooltip-placement=right uib-tooltip=\"{{state.description}}\"></span></label></div></div></div><span class=view-roles ng-repeat=\"role in employeesCrudCtrl.user.roles\" ng-if=employeesCrudCtrl.mode.isView ng-if=employeesCrudCtrl.isPublicRole(role);><span user-role role=role></span></span><div class=section-footer ng-if=!employeesCrudCtrl.mode.isView ng-class=\"{\'required-checkbox\':employeesCrudCtrl.redCheckbox}\"><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=employeesCrudCtrl.rolesMap.admin.enabled ng-change=employeesCrudCtrl.changeRole(); ng-disabled=employeesCrudCtrl.mode.isView> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><span>Администратор (управление сотрудниками и справочниками)</span> <span class=\"glyphicon glyphicon-star admin-star pull-right\" aria-hidden=true></span></div></section>");
$templateCache.put("app/settings/employees/directives/division/divisions-access.html","<section class=\"tab-form-group col-xs-9 division-tab\"><h5 class=section-header>Доступ к подразделениям <span class=text-muted ng-bind=::company.company_name></span></h5><div ng-hide=\"company.has_access && allAccess && state === \'employee.view\'\"><uib-tabset active=activeTab><uib-tab ng-repeat=\"tab in tabs\" class=\"divCount{{(divisions | filter: tab.type).length}}\" index=$index+1><uib-tab-heading class=tab-heading><span class=\"tab-title {{tab.type | lowercase}}-tab\">{{tab.title}}</span><div class=badge ng-if=\"error.items && (error.items.index == key)\">{{error.items.count}}</div></uib-tab-heading><div ng-if=\"(divisions | filter: tab.type).length\"><division-tab tab=tab divisions=divisions access=company.has_access state=state style=\"min-height: {{::height * 30 + 40}}px;\"></division-tab></div></uib-tab></uib-tabset></div><section ng-show=\"company.has_access && allAccess && state === \'employee.view\'\" style=\"margin: 0; width: 100%;\">Доступ ко всем текущим и будущим подразделениям и ККМ компании</section></section>");
$templateCache.put("app/settings/employees/directives/division/divisions-tab.html","<table border=1 class=table-mini-grid><tr><th width=25><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=all ng-change=selectAll()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></th><th>Название</th><th width=200>Адрес</th><th width=200>Доступ к ККМ</th></tr><tr ng-repeat=\"division in (divisions | filter: tab.type)\" ng-if=\"state.indexOf(\'view\') == -1 || division.has_access\"><td><div class=\"checkbox pull-left\"><label><input type=checkbox ng-model=division.has_access ng-change=changeAccessToKKM(division);checkAllDivision();> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div></td><td><span>{{::division.division_name}}</span></td><td><span>{{::division.address.address}}</span></td><td><form class=has-acccess-kkm style=\"display: inline-block;margin-right: 16px\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{division.division_id}}\" ng-model=division.has_access_to_cash_register_places ng-value=true id=\"yes{{division.division_id}}\" ng-disabled=division.$$disable_access_to_places ng-change=changeAccessToPlaces(division)> <span class=cr style=\"margin-right: 8px\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"yes{{division.division_id}}\" ng-bind=\"(state.indexOf(\'view\') + 1)? ((division.has_access_to_cash_register_places)? \'Есть\' : \'Нет\') : \'Есть\'\">Есть</label></form><div class=no-acccess-kkm style=\"display: inline-block;\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{division.division_id}}\" ng-model=division.has_access_to_cash_register_places ng-value=false id=\"no{{division.division_id}}\" ng-disabled=division.$$disable_access_to_places ng-change=changeAccessToPlaces(division) class=тщ> <span class=cr style=\"margin-right: 8px\"><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"no{{division.division_id}}\">Нет</label></div></td></tr></table>");
$templateCache.put("app/settings/employees/directives/employee-card/employee-card.html","<div class=card-box><div class=card-container ng-click=\"$state.go(\'employee.view\', {userId: employee.id, parent: \'business\'})\"><div class=\"container-fluid card-body\"><div class=row><div class=\"col-xs-12 name-wrapper\"><div class=\"checkbox pull-left\"><label ng-click=$event.stopPropagation() ng-if=\"$root.hasRole(\'user.set_need_change_password_flag\')\"><input type=checkbox ng-click=$event.stopPropagation() ng-model=employee.checked> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><br><span class=\"glyphicon info-icon comment-ico\" ng-if=employee.comment><span class=info-message><span ng-bind=employee.comment></span></span></span></div><div class=name-block><strong class=user-name ng-bind=employee.name></strong></div><div class=\"user-status pull-right\"><div class=\"status-ico change-pass text-center user-change-pass\" ng-hide=!employee.need_change_password></div><div class=\"status-ico no-access text-center\" ng-class=\"{ \'user-denied\' : !employee.enabled}\" ng-show=!employee.enabled></div><a ng-if=\"$root.hasRole(\'user.write\')\" class=\"status-ico redact-icon tooltip-light\" ui-sref=\"employee.edit({userId: employee.id, parent: \'business\'})\" tooltip-placement=bottom-left uib-tooltip=\"Редактировать сотрудника\"></a></div></div><div class=\"col-xs-12 info-block\"><p class=row><i class=\"col-xs-12 card-mail\" ng-class=\"{\'text-muted\': !employee.email}\" ng-bind=\"(employee.email)? employee.email : \'E-mail не указан\'\"></i> <i class=\"col-xs-12 card-mail\" ng-class=\"{\'text-muted\': !employee.phone}\" ng-bind=\"(employee.phone | phoneFormat) || \'Телефон не указан\'\"></i><!-- <strong class=\"card-location col-xs-6 text-right\" ng-bind=\"employee.location.address_as_string\"></strong> --></p><p class=\"card-access major-font\" ng-if=employee.enabled><span ng-show=employee.companies.length class=text-uppercase>Доступ:</span> <span class=if-box ng-show=\"employee.companies.length < 2\"><span ng-repeat=\"company in employee.companies\"> {{company.short_name}} {{(employee.companies.length == $index + 1)? \'\':\',\'}} </span></span><span class=if-box ng-show=\"employee.companies.length >= 2\"><span class=total-more> {{txt}} <span class=total-more-popup ng-if=!isAllCompanies style=\"max-width: 350px; top: 30px; left: -9px;\"><span class=ellipsis ng-repeat=\"company in employee.companies | orderBy:\'short_name\'\"><span class=user-role>{{company.short_name}}</span></span></span></span></span></p></div></div><div class=\"row user-roles-block\" ng-if=employee.enabled><div class=col-xs-12><span ng-repeat=\"role in employee.roles\" ng-if=\"$index < 1 && employee.roles.length != roles.length\"><span user-role role=role></span></span><div class=\"more-roles total-more\" ng-if=\"employee.roles.length > 1\"><span class=user-role-more ng-if=\"employee.roles.length != roles.length\"></span> <span ng-if=\"employee.roles.length == roles.length\" class=\"user-role total-more\">Все роли</span> <span class=total-more-popup><span ng-repeat=\"role in employee.roles\" user-role role=role ng-if=$index></span></span></div></div></div></div></div></div>");
$templateCache.put("app/settings/employees/directives/user-role/user-role.html","<span class=user-role ng-if=rolesMap[role]><span class=\"glyphicon glyphicon-star admin-star\" ng-if=\"role == \'admin\'\" aria-hidden=true></span> {{rolesMap[role]}} </span>");
$templateCache.put("app/settings/paid-services/includes/extend-subscribe-popup/extend-subscribe-popup.html","<div class=order-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title ng-bind=\"($ctrl.load)? \'Подготовка счета\' : \'Продление подписки\'\">Продление подписки</h3></div><div class=spinner-wrapper ng-if=$ctrl.load><div class=ui-spinner></div></div><div class=\"modal-body crud-entity\" style=\"padding: 9px 40px 0;\"><div class=form-group><ui-select ng-model=$ctrl.number_of_months search-enabled=false ng-required=true name=number_of_months><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item.id as item in $ctrl.numberOfMonthsObj track by $index\"><span ng-bind=item.name uib-tooltip=\"{{item.name}}\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Период действия</label></div></div><div class=modal-footer><button class=btn type=button ng-click=$ctrl.close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=$ctrl.confirm()>Подтвердить</button></div></div>");
$templateCache.put("app/settings/paid-services/includes/order-popup/order-popup.html","<div class=order-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=$ctrl.close()>×</button><h3 class=modal-title ng-bind=\"$ctrl.isOnline? \'Оплатить онлайн\' : \'Заказать счет\'\"></h3></div><div class=spinner-wrapper ng-if=$ctrl.load><div class=ui-spinner></div></div><div class=\"modal-body crud-entity\" ng-form=$ctrl.orderForm ng-if=!$ctrl.isConfirmed style=\"padding: 9px 40px 0;\"><div class=form-group ng-if=$ctrl.companies.length><ui-select ng-model=$ctrl.orderObj.company search-enabled=false ng-required=true name=company on-select=\"$ctrl.formError = false; $ctrl.companyError = false;\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"item in $ctrl.companies track by $index\"><span ng-bind=item.name uib-tooltip=\"{{item.name}}\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Плательщик</label><span class=req></span><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group phone-input-wrapper\"><input ng-class=\"{\n				  \'phone-input\': $ctrl.userMailPhoneFlags.isPhone,\n				  \'email-input\': $ctrl.userMailPhoneFlags.isEmail\n				  }\" hard-pruning data-check=[a-zA-Z0-9._@\\-+\\(\\)\\s]* class=form-control maxlength=50 name=email id=focusInput required universal-login-input is-phone=$ctrl.userMailPhoneFlags.isPhone is-email=$ctrl.userMailPhoneFlags.isEmail only-phone-email=true ng-keyup=$ctrl.onChangeEmail() ng-model=$ctrl.orderObj.email ng-blur=\"(!$ctrl.orderObj.email)? $ctrl.userMailPhoneFlags = {} : \'\'\"><label class=\"form-control-label small-offset\">Телефон или E-mail</label><div class=input-flag ng-if=\"$ctrl.userMailPhoneFlags.isPhone && $ctrl.orderObj.email\"><div class=flag-ru></div><div class=phone-code><span class=phone-code-text>+7</span></div></div><span class=req></span></div><div class=form-group ng-if=!$ctrl.isOnline><span>ВНИМАНИЕ! Счёт на оплату будет сформирован автоматически через пару мгновений и сразу начнется загрузка файла.</span></div></div><div class=modal-footer ng-if=!$ctrl.isConfirmed><div class=modal-errors><div ng-if=$ctrl.formError>Поля, помеченные *, обязательные для заполнения</div><div ng-if=$ctrl.companyError>Не заполнены реквизиты компании:<div ng-if=!$ctrl.orderObj.company.organization.legal_requisites.full_name>- полное наименование</div><div ng-if=!$ctrl.orderObj.company.organization.legal_requisites.short_name>- сокращенное наименование</div><div ng-if=!$ctrl.orderObj.company.organization.legal_requisites.inn>- ИНН</div><div ng-if=\"$ctrl.orderObj.company.organization.legal_requisites.legal_status == \'LEGAL_ENTITY\' && !$ctrl.orderObj.company.organization.legal_requisites.kpp\">- КПП</div><div ng-if=\"$ctrl.orderObj.company.organization.legal_requisites.legal_status == \'SOLE_TRADER\' && !$ctrl.orderObj.company.organization.legal_requisites.okpo\">- ОКПО</div><div ng-if=!$ctrl.orderObj.company.organization.legal_requisites.legal_address>- юридический адрес</div><br><a target=_blank ui-sref=\"company.edit({companyId: $ctrl.orderObj.company.id, parent: \'business\'})\" ng-click=$ctrl.goToCompany();>Перейти к заполнению</a></div></div><button class=btn type=button ng-click=$ctrl.close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=$ctrl.confirm() ng-disabled=\"$ctrl.formError || $ctrl.companyError\">Подтвердить</button></div><div class=modal-footer ng-if=$ctrl.isConfirmed><button class=btn type=button ng-click=$ctrl.close()>Закрыть</button></div></div>");
$templateCache.put("app/settings/priceTagsSettings/directives/priceTagPopup/price-tag-button.html","<a ng-if=\"$root.hasRole(\'report.price_tags\') && !asButton\" href=\"\" ng-click=showPopup(); style=\"display: inline-block; line-height: 1\"><span class=price-tag-ico></span>Распечатать ценник<br>на {{forService ? \'услугу\' : \'товар\'}}</a><button ng-if=\"$root.hasRole(\'report.price_tags\') && asButton\" class=\"btn button-print btn-ico-wrap tooltip-light\" tooltip-placement=bottom-left uib-tooltip=\"Печатать ценники\" ng-click=showPopup(); ng-class=\"{\'slim-button\': asButton == \'slim\'}\"><span class=\"btn-ico btn-print\"></span><span ng-bind=\"(asButton == \'slim\')? \'Ценники\' : \'Ценник\'\"></span></button>");
$templateCache.put("app/settings/priceTagsSettings/directives/priceTagPopup/price-tag-popup.html","<div class=print-tag-popup><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close() style=\"top: 14px;\">&times;</button><h3 class=modal-title ng-if=catalogItems.length>Печать ценников для позиции<br><span ng-if=catalogItems[0]>«{{catalogItems[0].name}}»</span></h3><h3 class=modal-title ng-if=selectedItems.length>Печать ценников для выбранных позиций</h3></div><form name=printForm><div class=\"container clearfix crud-entity row\" ng-if=\"!longRequest.crudState.loading && !longRequest.flags.finish\"><div><div class=\"col-xs-12 form-wrapper\"><div class=form-group><ui-select ng-model=printData.division search-enabled=false ng-required=true on-select=divisionSelected($select.selected)><ui-select-match><span ng-bind=\"$select.selected.name + \' - \' + $select.selected.company_name\"></span></ui-select-match><ui-select-choices repeat=\"item as item in divisions track by $index\"><span ng-bind-html=\"item.name + \' - \' + item.company_name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Подразделение</label><span class=req></span></div></div><div class=col-xs-6><div class=form-group><input class=form-control empty-or-null hard-pruning required data-check=([0-9]) type=text ng-model=printData.number_of_copies><label class=\"form-control-label small-offset\">Копий для позиции</label><span class=req></span></div><div class=form-group><div date-range-picker ng-model=printData.date view-value=dateVeiwValue opts=datePickerOptions date-min=01.01.1900 date-max=31.12.2045 state=dateState field-label=\"\'На какую дату\'\" ng-required=true class=datepicker-wrap></div></div><div class=\"form-group invisible-content\" ng-class=\"{\'visible-content\': showCurrencySelect}\"><ui-select ng-model=currencies.value search-enabled=\"(currencies.field.total > 100 && currencies.field.length <= 100)\" ng-required=showCurrencySelect><ui-select-match><span ng-bind-html=\"$select.selected.name + \' (\' +$select.selected.char_iso_code+\')\'\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=currencies.refresh($select.search) repeat=\"item in (currencies.field.items | filter: $select.search) track by $index\"><span class=currency-font ng-bind-html=\"(item.name + \' (\' +item.char_iso_code+\')\') | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\">Валюта</label><span class=req></span></div></div><div class=\"col-xs-6 form-wrapper\"><div class=form-group><label>Печатать старую цену для:</label><div style=\"margin-top: 8px;\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=printData.print_discount_price id=retail_discount> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=retail_discount>Скидочных акций</label></div><div style=\"margin-top: 8px;\"><div class=\"checkbox pull-left\"><label style=\"padding: 0\"><input type=checkbox ng-model=printData.print_old_price id=price_reduction> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=price_reduction>Уменьшения цены</label><span class=\"text-muted description\">показывать разницу в цене в случае ее уменьшения на указанную дату</span></div></div></div></div><!--<div class=\"col-xs-12 print-tag-view\">--><!--<price-tag-view config=\"config\" show-size=\"true\"></price-tag-view>--><!--</div>--><div class=clear></div><a style=\"cursor: pointer; display: block; margin: 0 auto; width: 190px;\" class=link-gear ng-click=goToPriceTagsSettings()>Настройки печати</a></div><inview-loader class=popup show=longRequest.crudState.loading></inview-loader><h4 style=\"text-align: center;\" ng-if=\"longRequest.crudState.loading && !longRequest.flags.finish\">Подготовка отчета</h4><h4 style=\"text-align: center;\" ng-if=\"!longRequest.crudState.loading && longRequest.flags.finish && !longRequest.flags.error\">Отчет сформирован</h4><h4 style=\"text-align: center;\" ng-if=longRequest.flags.error>При подготовке отчета возникла ошибка</h4><div class=col-xs-12 style=\"text-align: center\" ng-show=\"!longRequest.crudState.loading && !longRequest.flags.finish\"><a ng-if=\"longRequest.flags.finish && format.type === \'PDF\'\" target=_blank id=downloadLink ng-href=\"{{download()}}\" class=\"btn btn-primary\">Скачать</a></div><div class=modal-footer><button class=btn type=button ng-click=close()>{{longRequest.flags.finish ? \'Закрыть\' : \'Отменить\' }}</button> <button ng-if=\"!longRequest.crudState.loading && !longRequest.flags.processStart && !longRequest.flags.finish\" class=\"btn btn-primary\" ng-disabled=printForm.$invalid ng-click=print()>Печать</button></div></form></div>");
$templateCache.put("app/settings/priceTagsSettings/directives/priceTagView/price-tag-view.html","<div class=price-tag-view-wrapper ng-class=\"{\'wide\': config.price_tag_size.indexOf(\'10 х 4\')+1}\"><div class=top-size ng-if=showSize> {{(config.price_tag_size.indexOf(\'10 х 4\') + 1)? \'10\' : \'5\'}} см <span class=arrow></span></div><div class=left-size ng-if=showSize><label class=size-label>4 см</label><span class=arrow></span></div><div class=price-tag-view ng-class=\"{\'with-inform\': config.is_gtin || config.vendor_code || config.catalog_item_code, \'wide\': config.price_tag_size.indexOf(\'10 х 4\')+1}\"><div class=gray-bg><span class=\"date major-font\">12.05.2017</span><div class=\"sku-name tall-font\" ng-class=\"{\'no-gtin\': !config.is_gtin}\">Молоко Parmalat ультрапастеризованное 3,5%</div></div><div class=gtin ng-if=\"config.is_gtin || config.vendor_code || config.catalog_item_code\" ng-class=\"{\'text-center\': config.is_gtin && !config.vendor_code && !config.catalog_item_code, \'barcode-left\': config.is_gtin, \'without-code\': !config.vendor_code && !config.catalog_item_code && !config.is_img}\"><div class=barcode ng-if=config.is_gtin ng-class=\"{\'only-numbers\': !config.is_img}\" ng-bind=\"(!config.is_img)? \'014100078463\' : \'\'\"></div><div class=\"articles tall-font\" ng-class=\"{\'no-gtin\': !config.is_gtin}\"><span class=article ng-if=config.vendor_code>Артикул: <strong>RTWIURTY-45645</strong></span> <span class=article ng-if=config.catalog_item_code>Код: <strong>12312353467</strong></span></div></div><div class=\"price_wrapper clearfix major-font\"><span class=count>100 г</span><div class=price>634 <span class=coin>,00<span class=currency-font>₽</span></span></div></div></div></div>");
$templateCache.put("app/settings/templates/companies/accounts/accounts.html","<section class=\"form-group tab-form-group accounts-tabs col-xs-12\" ng-class=\"{\'accounts-tabs-bg\': !vm.company.organization.accounts.length, \'same-padding\': !vm.company.organization.accounts.length}\" ng-hide=\"vm.stateName.endsWith(\'view\') && !vm.company.organization.accounts.length\" ng-class=\"{\'same-padding\': !contractCrudCtrl.addComment}\" ng-form=vm.accoutnsForm><div class=add-item-wrap ng-click=vm.addAccount() ng-show=!vm.company.organization.accounts.length ng-if=\"!vm.stateName.endsWith(\'view\')\"><span class=add-item-icon></span> <span class=add-item-title>банковский счет</span></div><div ng-if=vm.company.organization.accounts.length><span class=\"add-new-account tooltip-light\" ng-click=vm.addAccount() ng-if=\"!vm.state.endsWith(\'view\')\" tooltip-placement=bottom-left uib-tooltip=\"Добавить новый банковский счет\"></span><scrollable-tabset api=vm.scrlTabsApi show-tooltips=false tooltip-left-placement=top show-drop-down=false><uib-tabset active=vm.activeCount><uib-tab ng-repeat=\"account in vm.company.organization.accounts track by $index\" select=vm.selectTab($index)><uib-tab-heading class=tab-heading><span class=\"glyphicon glyphicon-star pull-left tooltip-light\" tooltip-placement=right uib-tooltip=\"Основной банковский счет\" ng-show=\"account.main && vm.company.organization.accounts.length > 1\"></span> <span class=pull-left>{{account.name}}</span><span class=\"close-tab danger-close tooltip-light\" ng-click=\"account.$$askRemove = true;\" ng-if=\"(vm.company.organization.accounts.length && !account.main) || vm.company.organization.accounts.length == 1\" tooltip-placement=right uib-tooltip=Удалить></span><div class=\"remove-tab major-font\" ng-class=\"{\'ask-remove\': account.$$askRemove}\"><span class=\"glyphicon glyphicon-trash\"></span><label class=tab-remove-label>Удалить?</label><span class=pull-right><span class=tab-remove-yes ng-click=\"vm.removeAccount($index, $event);\">Да</span>/ <span class=tab-remove-no ng-click=\"account.$$askRemove = false;\">Нет</span></span></div></uib-tab-heading><div><div class=\"form-group col-xs-6\"><input empty-to-null type=text class=form-control value=account.name ng-model=account.name required name=\"accName{{$index}}\" id=\"accName{{$index}}\" maxlength=50 ng-keyup=vm.checkUnique()><label for=\"accName{{$index}}\" class=form-control-label>Название счета</label><div class=\"valid-message isset-name\">Счет с таким именем уже существует</div><span class=req></span></div><div class=\"form-group col-xs-6 pull-right\"><textarea class=\"form-control bank-name\" name=\"bankName{{$index}}\" id=\"bankName{{$index}}\" maxlength=255 required ng-model=account.bank ng-disabled=\"!parentForm.bik{{$index}}.$dirty || !account.bik\" ng-hide=\"vm.stateName.endsWith(\'view\')\"></textarea><div class=\"valid-message required-mess\">Поле является обязательным</div><label for=\"bankName{{$index}}\" class=form-control-label>Наименование банка</label><div ng-if=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=\"(account.bank)? account.bank : \'-\'\"></div><span class=req></span></div><div class=\"form-group col-xs-6\"><input type=text hard-pruning data-check=([0-9_]) class=form-control required name=\"{{\'bik\' + $index}}\" id=\"{{\'bik\' + $index}}\" clean=true ng-model=account.bik ng-focus=\"bik_focus=true\" ng-blur=\"bik_focus=false;(!parentForm[\'bik\' + $index].$error.mask)? vm.getBankInfo($event, account.bik) : \'\'\" ng-enter=\"(!parentForm[\'bik\' + $index].$error.mask)? vm.getBankInfo($event) : \'\'\" ui-mask=999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><div class=\"valid-message required-mess\" ng-hide=bik_focus>Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-show=\"parentForm[\'bik\' + $index].$error.mask && !bik_focus\">БИК должен содержать 9 цифр</span><label for=\"{{\'bik\' + $index}}\" class=form-control-label>БИК</label><span class=req></span></div><div class=\"form-group col-xs-6\"><input type=text class=form-control hard-pruning data-check=([0-9_]) required name=\"{{\'account\' + $index}}\" id=\"{{\'account\' + $index}}\" ng-model=account.account ui-mask=99999999999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-focus=\"account_focus=true\" ng-blur=\"account_focus=false\"><div class=\"valid-message required-mess\" ng-hide=account_focus>Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-show=\"parentForm[\'account\' + $index].$error.mask && !account_focus\">Поле должно содержать 20 цифр</span><label for=\"{{\'account\' + $index}}\" class=form-control-label>Банковский счет</label><span class=req></span></div><div class=\"form-group col-xs-6\"><input type=text class=\"form-control corr-account\" hard-pruning data-check=([0-9_]) required name=\"{{\'corAcc\' + $index}}\" id=\"{{\'corAcc\' + $index}}\" ng-model=account.corr_account ng-disabled=\"!parentForm.bik{{$index}}.$dirty || !account.bik\" ui-mask=99999999999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-focus=\"corr_acc_focus = true\" ng-blur=\"corr_acc_focus = false\"><div class=\"valid-message required-mess\" ng-hide=corr_acc_focus>Поле является обязательным</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-show=\"parentForm[\'corAcc\' + $index].$error.mask && !corr_acc_focus && !parentForm[\'bik\' + $index].$error.wrongBik\">Поле должно содержать 20 цифр</span><label for=\"{{\'corAcc\' + $index}}\" class=form-control-label>Корр. счет</label><span class=req></span></div><div class=\"form-group col-xs-6\"><ui-select ng-model=account.currency search-enabled=\"(vm.currencies.field.total > 100 && vm.currencies.field.length <= 100)\" required><ui-select-match><span ng-bind-html=\"$select.selected.name + \' (\' +$select.selected.char_iso_code+\')\'\"></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.currencies.refresh($select.search) repeat=\"item in (vm.currencies.field.items | filter: $select.search) track by $index\"><span ng-bind-html=\"(item.name + \' (\' +item.char_iso_code+\')\') | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Валюта</label><span class=req></span></div><div class=\"form-group col-xs-6 checkbox-group\" ng-show=\"!vm.stateName.endsWith(\'view\') && vm.company.organization.accounts.length > 1\"><div class=\"checkbox pull-left\"><label><input ng-disabled=account.main type=checkbox ng-model=account.main ng-change=\"vm.changeMainAccount($index, account.main);\" id=\"{{\'mainAcc\' + $index}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label><label for=\"{{\'mainAcc\' + $index}}\" ng-if=\"!vm.stateName.endsWith(\'view\') || vm.stateName.endsWith(\'view\') && account.main\" style=\"vertical-align: top;\">Сделать этот счет основным</label></div></div><div class=clear></div></div></uib-tab></uib-tabset></scrollable-tabset></div></section>");
$templateCache.put("app/settings/templates/companies/legal-requisites/legal-requisites.html","<!-- legal box --><section class=\"form-group col-xs-12\" ng-class=\"{\'slide-up\': vm.hideLegalInfo}\" ng-style=\"(vm.mode.isView)? {\'max-height\': \'530px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideLegalInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideLegalInfo = !vm.hideLegalInfo\" ng-show=vm.mode.isView></span><h5 class=section-header>Юридические реквизиты</h5><div class=row><!-- ИНН для ЮЛ --><div class=\"form-group col-xs-6\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'LEGAL_ENTITY\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text inn-check inn-type=ur class=form-control name=inn id=innCompany ng-focus=\"innCompany_blur = false\" ng-blur=\"innCompany_blur = true;vm.onInnFill()\" ng-model=vm.company.organization.legal_requisites.inn ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.inn\" ui-mask=9999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=innCompany class=form-control-label>ИНН</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.inn\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message text-origin\" style=display:block ng-if=\"parentForm.inn.$error.mask && innCompany_blur\">ИНН должен содержать 10 цифр</span> <span class=valid-message style=display:block ng-if=parentForm.inn.$error.validInn>Такой номер не существует</span></div><!-- ИНН для ИП --><div class=\"form-group col-xs-6\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'SOLE_TRADER\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text inn-check inn-type=fiz class=form-control name=inn ng-focus=\"innip_blur = false\" ng-blur=\"innip_blur = true;vm.onInnFill()\" id=innIp ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.inn\" ng-model=vm.company.organization.legal_requisites.inn ui-mask=999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=innIp class=form-control-label>ИНН</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.inn\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message text-origin\" style=display:block ng-if=\"parentForm.inn.$error.mask && innip_blur\">ИНН должен содержать 12 цифр</span> <span class=valid-message style=display:block ng-if=parentForm.inn.$error.validInn>Такой номер не существует</span></div><div class=\"form-group col-xs-6\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'LEGAL_ENTITY\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=kpp id=kpp ng-focus=\"kpp_blur = false\" ng-blur=\"kpp_blur = true\" ng-model=vm.company.organization.legal_requisites.kpp ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.kpp\" ui-mask=999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=kpp class=form-control-label>КПП</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.kpp\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message text-origin\" style=display:block ng-if=\"parentForm.kpp.$error.mask && kpp_blur\">КПП должен содержать 9 цифр</span></div><div class=\"form-group col-xs-6\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'SOLE_TRADER\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=ogrn id=ogrnIp ng-focus=\"ogrnip_blur = false\" ng-blur=\"ogrnip_blur = true\" ng-model=vm.company.organization.legal_requisites.ogrn ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.ogrn\" ui-mask=999999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=ogrnIp class=form-control-label>ОГРНИП</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.ogrn\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message text-origin\" style=display:block ng-if=\"parentForm.ogrn.$error.mask && ogrnip_blur\">ОГРНИП должен содержать 15 цифр</span></div><div class=clear></div><div class=\"form-group col-xs-6\"><textarea empty-to-null type=text class=form-control id=fullNomination ng-model=vm.company.organization.legal_requisites.full_name ng-hide=vm.mode.isView maxlength=255></textarea><label for=fullNomination class=form-control-label>Полное наименование</label><div ng-if=vm.mode.isView class=view-entity-control ng-bind=\"(vm.company.organization.legal_requisites.full_name)? vm.company.organization.legal_requisites.full_name : \'-\'\"></div></div><div class=\"form-group col-xs-6 pull-right\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'SOLE_TRADER\'\"><address address-data=vm.company.organization.legal_requisites.legal_address name=\"\'legal_address\'\" parent-form=parentForm address-controls=vm.addressOptions field-label=\"\'Адрес регистрации\'\"></address><div ng-if=vm.mode.isView class=view-entity-control ng-bind=\"(vm.company.organization.legal_requisites.legal_address)? vm.company.organization.legal_requisites.legal_address.address_as_string : \'-\'\">-</div></div><div class=\"form-group col-xs-6 pull-right\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'LEGAL_ENTITY\'\"><address address-data=vm.company.organization.legal_requisites.legal_address name=\"\'legal_address\'\" parent-form=parentForm address-controls=vm.addressOptions field-label=\"\'Юридический адрес\'\"></address><div ng-if=vm.mode.isView class=view-entity-control ng-bind=\"(vm.company.organization.legal_requisites.legal_address)? vm.company.organization.legal_requisites.legal_address.address_as_string : \'-\'\">-</div></div><div class=clear></div><div class=\"form-group col-xs-6\"><input empty-to-null type=text class=form-control id=shortNomination ng-model=vm.company.organization.legal_requisites.short_name ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.short_name\" maxlength=255><label for=shortNomination class=form-control-label>Сокращенное наименование</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.short_name\" class=view-entity-control>-</div></div><!-- ОГРН для ЮЛ --><div class=\"form-group col-xs-6\" ng-if=\"vm.company.organization.legal_requisites.legal_status == \'LEGAL_ENTITY\'\"><input empty-to-null hard-pruning data-check=([0-9_]) type=text class=form-control name=ogrn id=ogrnUr ng-focus=\"ogrn_blur = false\" ng-blur=\"ogrn_blur = true\" ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.ogrn\" ng-model=vm.company.organization.legal_requisites.ogrn ui-mask=9999999999999 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\"><label for=ogrnUr class=form-control-label>ОГРН</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.ogrn\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=\"valid-message text-origin\" style=display:block ng-if=\"parentForm.ogrn.$error.mask && ogrn_blur\">ОГРН должен содержать 13 цифр</span></div><!-- Серия и номер свидетельства для ИП --><div ng-if=\"vm.company.organization.legal_requisites.legal_status === \'SOLE_TRADER\'\"><div class=\"form-group col-xs-6\"><input empty-to-null hard-pruning data-check=\"([0-9_ ])\" type=text class=form-control name=registrationNumber id=registrationNumber ng-focus=\"registrationNumber_blur = false\" ng-blur=\"registrationNumber_blur = true\" ng-model=vm.company.organization.legal_requisites.registration_number ui-mask=\"99 999999999\" ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-hide=\"vm.mode.isView && !vm.company.organization.legal_requisites.registration_number\"><label for=registrationNumber class=form-control-label>Серия и № свидетельства</label><div ng-if=\"vm.mode.isView && !vm.company.organization.legal_requisites.registration_number\" class=view-entity-control>-</div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><span class=valid-message style=display:block ng-if=\"parentForm.registrationNumber.$error.mask && registrationNumber_blur\">Серия и № свидетельства должен содержать 15 цифр</span></div></div><div class=\"form-group col-xs-6\"><okpo-input company=vm.company mode=vm.mode.isView></okpo-input></div><div class=\"form-group col-xs-6\" ng-if=!vm.mode.isView><div date-range-picker ng-model=vm.date opts=vm.datePickerOpts date-min=01.01.1900 date-max=31.12.2045 state=vm.dateState class=datepicker-wrap name=registration_date on-close=\"vm.onDatePickerClose2(returnValue, name)\" field-label=\"\'Дата регистрации\'\"></div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div class=\"form-group col-xs-6\" ng-if=vm.mode.isView><label for=shortNomination class=form-control-label>Дата регистрации</label><div class=view-entity-control ng-bind=\"vm.company.organization.legal_requisites.registration_date | date: \'dd.MM.yyyy\' : \'UTC\'\">-</div></div><div class=\"form-group col-xs-6\"><okved-input company=vm.company mode=vm.mode.isView trigger-update=vm.triggerOkvedUpdate></okved-input></div></div></section>");
$templateCache.put("app/settings/templates/companies/main-info/main-info.html","<section class=col-xs-12 ng-class=\"{\'slide-up\': vm.hideMainInfo, \'person-main-info\': vm.company.counterparty_type == \'PERSON\'}\" ng-style=\"(vm.stateName.endsWith(\'view\'))? {\'max-height\': \'400px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideMainInfo)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideMainInfo = !vm.hideMainInfo\" ng-show=\"vm.stateName.endsWith(\'view\')\"></span><h5 class=section-header>Основная информация</h5><div class=row><div id=nameAnchor class=\"form-group col-xs-6\" ng-if=\"vm.showNames && vm.company.counterparty_type != \'PERSON\'\" ng-class=\"{\'has-error-unique\': parentForm.name.$invalid && parentForm.name.$error.unique}\"><input required type=text name=name class=form-control id=nomination maxlength=127 ng-model=vm.company.name ng-keyup=\"parentForm.name.$setValidity(\'unique\', true)\" ng-blur=vm.uniqueCallback(vm.company.name)><label for=nomination class=form-control-label>Наименование</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=parentForm.name.$error ng-if=\"!vm.stateName.endsWith(\'view\')\"><div ng-message=unique class=\"valid-message isset-name\" ng-bind=\"(vm.stateName.indexOf(\'company\') + 1)? \'Компания уже существует\' : \'Контрагент уже существует\'\"></div></div><span class=req></span></div><!-- Имя для ФЛ --><div class=\"form-group col-xs-6\" ng-if=\"vm.company.counterparty_type == \'PERSON\'\" id=nameAnchor ng-class=\"{\'has-error-unique\': parentForm.name.$invalid && parentForm.name.$error.unique, \'has-person-group\': vm.company.person}\"><!-- ФИО напрямую маппится на сущность, person опосредованно --><div person-data-input fio=vm.company.name form-model=vm.company.person is-required=true name-and-id=name unique-callback=vm.uniqueCallback field-label=\"\'Имя\'\"></div><div class=\"valid-message isset-name\" ng-bind=\"(vm.stateName.indexOf(\'company\') + 1)? \'Компания уже существует\' : \'Контрагент уже существует\'\"></div></div><div class=\"form-group col-xs-6 pull-right\" ng-if=\"vm.company.counterparty_type != \'PERSON\' && vm.stateName.indexOf(\'company\') + 1\"><address address-data=vm.company.real_address name=\"\'real_address\'\" parent-form=parentForm field-label=\"\'Фактический адрес\'\" truncate=false address-controls=vm.addressControls timezone=vm.company.time_zone></address><div ng-if=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=\"(vm.company.real_address.address_as_string)? vm.company.real_address.address_as_string : \'-\'\">-</div></div><div class=\"form-group col-xs-6 pull-right\" ng-if=\"vm.company.counterparty_type != \'PERSON\' && vm.stateName.indexOf(\'company\') == -1\"><address address-data=vm.company.real_address name=\"\'real_address\'\" parent-form=parentForm field-label=\"\'Фактический адрес\'\" address-controls=vm.addressControls truncate=false></address><div ng-if=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=\"(vm.company.real_address.address_as_string)? vm.company.real_address.address_as_string : \'-\'\">-</div></div><div class=\"form-group col-xs-6\" ng-if=\"vm.stateName.indexOf(\'company\') + 1\"><timezone class=profile timezone-data=vm.company.time_zone field-label=\"\'Часовой пояс\'\" auto-timezone=\"vm.stateName.endsWith(\'new\')\" ng-required=true ng-disabled=\"vm.stateName.endsWith(\'view\')\"></timezone></div><div class=clear ng-if=\"vm.stateName.indexOf(\'company\') + 1\"></div><contact-info contact-info=vm.company.contact_info></contact-info></div></section>");
$templateCache.put("app/settings/templates/companies/main-person/main-person.html","<section class=\"form-group tab-form-group post-tabs col-xs-12\"><uib-tabset class=custom-tabs-inner active=vm.searchActive><uib-tab index=\"\'tab1\'\"><uib-tab-heading>Руководитель</uib-tab-heading><div class=tabContent><div class=row><div class=\"form-group col-xs-6\"><!-- ФИО напрямую маппится на сущность, person опосредованно --><div id=chief-fio person-data-input fio=vm.company.organization.chief_name form-model=vm.company.organization.chief_person field-label=\"\'ФИО\'\"></div></div><div class=\"form-group col-xs-6\"><input empty-to-null type=text class=form-control id=companyChief ng-model=vm.company.organization.chief_position ng-hide=\"vm.stateName == \'company.view\' && !vm.company.organization.chief_position\" maxlength=50><label for=companyChief class=form-control-label>Должность</label><div ng-if=\"vm.stateName == \'company.view\' && !vm.company.organization.chief_position\" class=view-entity-control>-</div></div></div></div></uib-tab><uib-tab index=\"\'tab2\'\" ng-hide=\"vm.stateName == \'company.view\' && !vm.company.organization.chief_accountant_person && !vm.company.organization.chief_accountant_name\"><uib-tab-heading>Бухгалтер</uib-tab-heading><div class=row><div class=\"form-group col-xs-6\"><!-- ФИО напрямую маппится на сущность, person опосредованно --><div id=chief-fio person-data-input fio=vm.company.organization.chief_accountant_name form-model=vm.company.organization.chief_accountant_person field-label=\"\'ФИО\'\"></div></div></div></uib-tab></uib-tabset></section>");
$templateCache.put("app/settings/templates/modals/img-editor/img-editor.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title ng-bind=title></h3></div><div class=container><div class=\"modal-main-text img-editor-wrapper\"><div class=gray-bg ng-class=\"{\'square-border\': imgType == \'square\'}\"><div class=prev-load-img ng-if=!temp.inputImage><input type=file id=upload accept=image/* onchange=angular.element(this).scope().changeFile(this)> <span class=prev-load-txt>Перетащите или<label for=upload>загрузите</label>фото</span></div><ng-croppie ng-if=temp.inputImage src=temp.inputImage ng-model=temp.outputImage boundry=\"{w: 474, h: 420}\" viewport=\"{w: imgWidth, h: imgHeight}\" zoomslider=true orientation=true rotation=rotate enableresize=true type=\"{{imgType}}\" enforceboundary=true></ng-croppie><!-- <img ng-src=\"{{temp.outputImage}}\" /> --></div><div class=img-editor-controls ng-if=temp.outputImage><button ng-if=temp.inputImage ng-click=removeImg() class=\"btn slim-button only-ico\"><span class=\"glyphicon glyphicon-trash btn-ico\"></span></button><div class=rotate-buttons ng-if=temp.inputImage><button ng-click=rotateAction(-90) class=\"btn slim-button only-ico\"><span class=\"btn-ico btn-arror-left\"></span></button> <button ng-click=rotateAction(90) class=\"btn slim-button only-ico\"><span class=\"btn-ico btn-arror-right\"></span></button></div><div class=\"pull-right range-icons\" ng-if=temp.inputImage><span class=range-minus></span> <span class=range-plus></span></div></div></div></div><div class=modal-footer><button class=btn type=button ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" type=button ng-click=save()>Сохранить</button></div>");
$templateCache.put("app/settings/templates/organizations/main-info/main-info.html","<div class=row><div class=col-xs-9><section class=form-group><h3>Основная информация</h3><div class=col-xs-6><div class=form-group ng-if=vm.showNames><label for=nomination>Наименование <span class=req></span></label><input required type=text class=form-control id=nomination maxlength=127 ng-model=vm.organization.name ng-hide=\"vm.stateName.endsWith(\'view\')\"><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=vm.organization.name></div></div><div class=form-group ng-hide=\"vm.stateName.endsWith(\'view\') && !vm.organization.phone\"><label for=organizationPhone>Телефон</label><input name=organizationPhone id=organizationPhone ng-model=vm.organization.phone type=tel maxlength=20 class=\"form-control input-xlarge\" pattern=\"^[\\d()+# -]{1,20}$\"> <span ng-hide=parentForm.organizationPhone.$valid||parentForm.organizationPhone.$pristine>Телефон содержит недопустимые символы</span></div><div class=form-group ng-hide=\"vm.stateName.endsWith(\'view\') && !vm.organization.email\"><label for=organizationEmail>E-mail</label><email mail=vm.organization.email></email></div></div><div class=col-xs-6><div class=form-group ng-hide=\"vm.stateName.endsWith(\'view\') && !vm.organization.real_address\"><label for=realAddress>Фактический адрес</label><textarea class=form-control rows=3 id=realAddress ng-model=vm.organization.real_address ng-hide=\"vm.stateName.endsWith(\'view\')\"></textarea><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=vm.organization.real_address></div></div><div class=\"form-group dynamic-field\" ng-repeat=\"contact in vm.contacts\"><select name=\"{{contact.id}}\" ng-model=\"vm.formData[\'title\' + contact.id]\" ng-change=\"pattern = vm.patterns[parentForm[contact.id].$viewValue]\"><option value=Телефон ng-selected=\"contact.name == \'Телефон\'\">Телефон</option><option value=E-mail ng-selected=\"contact.name == \'E-mail\'\">E-mail</option><option value=Факс ng-selected=\"contact.name == \'Факс\'\">Факс</option><option value=Skype ng-selected=\"contact.name == \'Skype\'\">Skype</option></select><input type=tel class=form-control name=\"contact{{$index}}\" id=\"contact{{$index}}\" ng-model=vm.formData[contact.id] pattern=\"{{pattern || vm.patterns[contact.name]}}\"> <span class=\"glyphicon glyphicon-trash remove-field\" ng-click=vm.removeContact($index) ng-if=\"!vm.stateName.endsWith(\'new\')\"></span> <span ng-hide=\"parentForm[\'contact\' + $index].$valid||parentForm[\'contact\' + $index].$pristine\">{{contact.name}} содержит недопустимые символы</span></div><!-- <div class=\"clear\"></div>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.addContact()\">+ Добавить поле</button> --></div></section></div></div>");
$templateCache.put("app/settings/utmConnections/crudUtmConnection/sections/divisions.html","<div class=company-wrap ng-if=utmConnectionCtrl.connection.divisions.length style=\"margin-top: 30px;\"><h5 class=section-header>Подразделения, подключенные к УТМ</h5><div class=\"clearfix full-width\" ng-repeat=\"company in utmConnectionCtrl.companies\"><section class=col-xs-12><h5 class=section-header ng-bind=company.name></h5><div class=\"division-wrap clearfix\" ng-repeat=\"division in utmConnectionCtrl.connection.divisions\" ng-if=\"division.company.id == company.id\"><div class=\"form-group col-xs-6\" ng-bind=division.division.name></div><div class=\"form-group col-xs-2\" ng-if=utmConnectionCtrl.mode.isEdit><span class=\"glyphicon glyphicon-trash\" ng-click=utmConnectionCtrl.deleteIssetDivision($index); style=\"display: block;\"></span></div></div></section></div></div><section class=\"form-group col-xs-12\" ng-if=utmConnectionCtrl.mode.isEdit style=\"overflow: visible;\"><div class=row><div class=clearfix ng-repeat=\"division in utmConnectionCtrl.newDivisionsList track by $index\" style=\"margin-bottom: 16px;\"><div class=col-xs-6 ng-class=\"{\'has-error-unique\': utmConnectionCtrl.errorInd.length && utmConnectionCtrl.errorInd.indexOf($index) + 1}\"><ui-select ng-model=division.data class=\"slim-control always-edit\" required on-select=utmConnectionCtrl.checkData();><ui-select-match allow-clear=true placeholder=\"Выберите подразделение\"><span ng-bind=$select.selected.division.name></span></ui-select-match><ui-select-choices repeat=\"item in ( utmConnectionCtrl.divisions | filter: $select.search) track by $index\"><span ng-bind-html=\"item.division.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-name\">Подразделение уже выбрано</div></div><div class=col-xs-2><span class=\"glyphicon glyphicon-trash\" ng-click=utmConnectionCtrl.deleteDivision($index); style=\"display: block; padding: 8px 9px; box-sizing: content-box;\"></span></div><br></div><div class=add-item-wrap ng-click=utmConnectionCtrl.addDivision() style=\"margin-left: 15px; display: block;\"><span class=add-item-icon></span> <span class=add-item-title>Добавить подразделение</span></div></div><div class=section-helper style=\"position: absolute; width: 30%; left: 100%; top: 0; margin-left: 15px;\">ИНН компании, к которой относится подразделение, и КПП подразделения должны совпадать с ИНН и КПП, указанные в ЕГАИС</div></section>");
$templateCache.put("app/settings/utmConnections/crudUtmConnection/sections/main-info.html","<section class=\"form-group col-xs-12\"><h5 class=section-header>Основная информация</h5><div class=row><div class=\"form-group col-xs-6\"><label class=form-control-label>Наименование компании</label><div class=view-entity-control ng-bind=utmConnectionCtrl.connection.company_name></div></div><div class=\"form-group col-xs-6\"><label class=form-control-label>ИД ФСРАР</label><div class=view-entity-control ng-bind=\"utmConnectionCtrl.connection.fsrar_id || \'-\'\"></div></div><div class=\"form-group col-xs-6\"><label class=form-control-label>ИНН</label><div class=view-entity-control ng-bind=\"utmConnectionCtrl.connection.inn || \'-\'\"></div></div><div class=\"form-group col-xs-6\"><label class=form-control-label>КПП</label><div class=view-entity-control ng-bind=\"utmConnectionCtrl.connection.kpp || \'-\'\"></div></div><div class=\"form-group col-xs-6\"><label class=form-control-label>Лицензия</label><div class=view-entity-control ng-bind=\"(utmConnectionCtrl.connection.licence)? \'Есть\' : \'Нет\'\"></div></div><div class=\"form-group col-xs-6 pull-right\" style=\"margin-bottom: 25px;\"><label class=form-control-label>Адрес</label><div class=view-entity-control ng-bind=\"(utmConnectionCtrl.connection.address)? utmConnectionCtrl.connection.address : \'-\'\" style=\"height: auto;\"></div></div></div></section>");
$templateCache.put("app/settings/utmConnections/crudUtmConnection/sections/utm.html","<section class=\"form-group col-xs-12\"><h5 class=section-header>Универсальный Транспортный модуль</h5><div class=row><div class=\"form-group col-xs-6\"><label for=name class=form-control-label>Срок действия сертификата ГОСТ</label><div class=view-entity-control>с <span ng-bind=\"utmConnectionCtrl.connection.gost_start_date | date:\'dd.MM.yyyy\'\"></span> по <span ng-bind=\"utmConnectionCtrl.connection.gost_end_date | date:\'dd.MM.yyyy\'\"></span> <span class=atantion-ico ng-class=\"{\'expired\': utmConnectionCtrl.connection.gost_end_date < utmConnectionCtrl.today}\" ng-hide=!utmConnectionCtrl.gostInfo tooltip-placement=bottom-left uib-tooltip=\"{{utmConnectionCtrl.gostInfo}}\"></span></div></div><div class=\"form-group col-xs-6\"><label for=name class=form-control-label>Версия УТМ</label><div class=view-entity-control ng-bind=\"utmConnectionCtrl.connection.utm_version || \'-\'\"></div></div><div class=\"form-group col-xs-6\"><label for=name class=form-control-label>Срок действия сертификата RSA</label><div class=view-entity-control>с <span ng-bind=\"utmConnectionCtrl.connection.rsa_start_date | date:\'dd.MM.yyyy\'\"></span> по <span ng-bind=\"utmConnectionCtrl.connection.rsa_end_date | date:\'dd.MM.yyyy\'\"></span> <span class=atantion-ico ng-class=\"{\'expired\': utmConnectionCtrl.connection.rsa_end_date < utmConnectionCtrl.today}\" ng-hide=!utmConnectionCtrl.rsaInfo tooltip-placement=bottom-left uib-tooltip=\"{{utmConnectionCtrl.rsaInfo}}\"></span></div></div><div class=\"form-group col-xs-6\"><label for=name class=form-control-label>Подключение</label><span ng-if=utmConnectionCtrl.connection.last_heart_beat uib-tooltip=\"Последний обмен с УТМ {{utmConnectionCtrl.connection.last_heart_beat | date: \'dd.MM.yyyy в HH:mm\'}}\" tooltip-placement=bottom-left class=\"info-icon tooltip-light\"></span><div class=view-entity-control ng-bind=\"(utmConnectionCtrl.connection.connection_status)? \'Активно\' : \'Не активно\'\"></div></div></div></section>");
$templateCache.put("app/settings/utmConnections/directives/utm-connection-card/utm-connection-card.html","<section class=card-box><div class=card-container ng-click=\"$state.go(\'utmConnection.view\', {id: connection.id, parent: \'alcohol\'})\"><div class=\"container-fluid card-body\"><div class=\"row clearfix\"><div class=\"col-xs-12 name-wrapper\"><div class=\"pull-right tooltip-light\" tooltip-placement=bottom-left uib-tooltip=Редактировать ng-if=\"$root.hasRole(\'egais_connection.write\')\"><a ui-sref=\"utmConnection.edit({id: connection.id, parent: \'alcohol\'})\" class=\"status-ico redact-icon\"></a></div><span class=person-type ng-bind=connection.fsrar_id></span><br><span class=card-name ng-bind=connection.company_name></span></div><div class=\"col-xs-12 info-block\"><ul class=\"card-data row\"><li class=col-xs-6><div>ИНН:</div><span ng-bind=\"connection.inn || \'-\'\"></span></li><li class=col-xs-6><div>КПП:</div><span ng-bind=\"connection.kpp || \'-\'\"></span></li><li class=col-xs-6><div>Лицензия:</div><span ng-bind=\"(connection.licence)? \'Есть\' : \'Нет\'\"></span></li><li class=col-xs-6><div>Подключение: <span ng-if=connection.last_heart_beat uib-tooltip=\"Последний обмен с УТМ {{connection.last_heart_beat | date: \'dd.MM.yyyy в HH:mm\'}}\" tooltip-placement=bottom-left class=\"info-icon tooltip-light\" style=\"margin: 0 0 -3px;\"></span></div><span ng-bind=\"(connection.connection_status)? \'Активно\' : \'Не активно\'\"></span></li><li class=col-xs-12><div>Адрес:</div><span class=ellipsis ng-bind=\"connection.address || \'-\'\" uib-tooltip=\"{{connection.address || \'\'}}\"></span></li></ul><div ng-if=connection.divisions.length><span>Подразделения, подключенные через УТМ ({{connection.divisions.length}}):</span> <span ng-repeat=\"division in connection.divisions\"><span ng-if=$index>, </span><a ui-sref=\"division.edit({divisionId: division.division.id, companyId: division.company.id, parent: \'business\'})\" ng-bind=division.division.name></a></span></div><span class=card-doc ng-if=!connection.divisions.length>Нет подразделений</span></div></div></div></div></section>");
$templateCache.put("app/catalog/catalogItem/sections/services/templates/taxInfoService.html","<section class=\"form-group tab-form-group full-width\" ng-class=\"{\'title-out-group\': vm.stateName.endsWith(\'view\')}\"><ul class=\"nav nav-tabs\"><li class=active><a href=.salesTaxes data-toggle=tab>Налоги при реализации</a></li><li><a href=.forCash data-toggle=tab>На кассе</a></li></ul><div class=tab-content><div class=\"tab-pane salesTaxes active\"><div class=row><div class=form-group style=\"margin: 0;\" ng-class=\"(vm.stateName.endsWith(\'view\'))? \'row col-xs-12\' : \'col-xs-6\'\"><ui-select ng-model=vm.catalogItem.tax_group search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=vm.getTaxGroups($select.search) repeat=\"tax_group in (vm.taxGroups) track by $index\"><span ng-bind-html=\"tax_group.name | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Налог при реализации</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=vm.catalogItem.tax_group.name></div></div></div></div><div class=\"tab-pane forCash\"><h5 class=section-header>Налогообложение чека</h5><div class=row><div class=\"form-group col-xs-6\"><div class=radio-box><div class=clearfix ng-repeat=\"radio in vm.radioTaxModeSource\" ng-hide=\"vm.stateName.endsWith(\'view\') && radio.value != vm.catalogItem.tax_mode_source\"><div class=\"radio pull-left\" ng-hide=\"vm.stateName.endsWith(\'view\')\"><label><input type=radio name=\"{{radio.value}}\" ng-model=vm.catalogItem.tax_mode_source ng-value=radio.value ng-change=vm.taxModeSourceChanged(radio.value) id=\"{{radio.value}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{radio.value}}\">{{radio.label}}</label></div></div></div><div class=\"form-group col-xs-6\" style=\"margin: 0\" ng-if=\"vm.catalogItem.tax_mode_source === \'FROM_CATALOG_ITEM\'\"><ui-select ng-model=vm.catalogItem.tax_mode search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\"><ui-select-match><span ng-bind=\"$select.selected | tax\"></span></ui-select-match><ui-select-choices repeat=\"tax_mode in (vm.taxModeList) track by $index\"><span ng-bind-html=\"tax_mode | tax | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Режим налогообложения чека</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=\"(vm.catalogItem.tax_mode ? vm.catalogItem.tax_mode: \'-\') | tax\" class=view-entity-control></div></div></div><h5 class=section-header>Предмет расчета</h5><div class=row><div class=\"form-group col-xs-6\" style=\"margin: 0\"><ui-select ng-model=vm.catalogItem.cash_register_item_type search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\"><ui-select-match><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"item.value as item in (vm.cashRegisterItemTypes) track by $index\"><span ng-bind=\"item.label | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Признак предмета расчета</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=\"(vm.catalogItem.cash_register_item_type ? vm.catalogItem.cash_register_item_type: \'-\') | cashRegisterItemTypes\" class=view-entity-control></div></div></div></div></div></section>");
$templateCache.put("app/catalog/catalogItem/sections/skus/templates/buttons.html","<div ng-if=\"$state.current.name.endsWith(\'new\')\"><a class=\"btn btn-primary pull-right\" ng-click=\"(vm.isWrongValid || vm.hasError.length || vm.packNameError.length || vm.addCatalogSkus.$error[\'wrong-date\'].length)? vm.setDirty() : vm.save()\" ng-disabled=\"vm.isSetDirty && (vm.isWrongValid || vm.hasError.length || vm.packNameError.length || vm.addCatalogSkus.$error[\'wrong-date\'].length)\">Создать</a> <a class=\"btn pull-right\" ng-click=vm.returnToPage()>Отменить</a></div><div ng-if=\"$state.current.name.endsWith(\'edit\')\"><span class=\"btn btn-ico-wrap tooltip-light\" ng-click=\"vm.catalogSkus.status !== \'ARCHIVED\' ? \'\' :vm.delete()\" ng-disabled=\"vm.catalogSkus.status !== \'ARCHIVED\'\" role=button tooltip-placement=bottom-left uib-tooltip=\"{{(vm.catalogSkus.status !== \'ARCHIVED\')? \'Нельзя удалить не архивный товар\' : \'\'}}\"><span class=\"btn-ico glyphicon glyphicon-trash\"></span>Удалить</span> <span class=btn ng-click=vm.archivePopup(true) ng-if=\"$root.hasRole(\'catalog_item.unarchive\') && vm.catalogSkus.status == \'ARCHIVED\'\" style=\"margin-left: 8px;\">Восстановить</span> <span class=btn ng-click=vm.archivePopup() ng-if=\"$root.hasRole(\'catalog_item.archive\') && vm.catalogSkus.status != \'ARCHIVED\'\" style=\"margin-left: 8px;\">В архив</span> <a ng-if=\"$root.hasRole(\'catalog_item.write\')\" class=\"btn btn-primary pull-right\" ng-click=\"(vm.isWrongValid || vm.hasError.length || vm.packNameError.length || vm.addCatalogSkus.$error[\'wrong-date\'].length)? vm.setDirty() : vm.save()\" ng-disabled=\"vm.isSetDirty && (vm.isWrongValid || vm.hasError.length || vm.packNameError.length || vm.addCatalogSkus.$error[\'wrong-date\'].length)\">Сохранить</a> <a class=\"btn pull-right\" ng-click=vm.returnToPage()>Отменить</a></div><div ng-if=\"$state.current.name.endsWith(\'view\')\"><span class=\"btn btn-ico-wrap\" ng-click=vm.returnToPage()><span class=\"btn-ico btn-arrow\"></span>Вернуться</span> <span class=btn ng-click=vm.archivePopup(true) ng-if=\"$root.hasRole(\'catalog_item.unarchive\') && vm.catalogSkus.status == \'ARCHIVED\'\" style=\"margin-left: 8px;\">Восстановить</span> <span class=btn ng-click=vm.archivePopup() ng-if=\"$root.hasRole(\'catalog_item.archive\') && vm.catalogSkus.status != \'ARCHIVED\'\" style=\"margin-left: 8px;\">В архив</span> <a ng-if=\"$root.hasRole(\'catalog_item.write\')\" ui-sref=\"catalogSkus.edit({categoryId: vm.categoryId, elementId: vm.catalogSkus.id, parent: $state.params.parent})\" class=\"btn btn-primary pull-right\">Редактировать</a></div><div class=clear></div>");
$templateCache.put("app/catalog/catalogItem/sections/skus/templates/mainInfoSkus.html","<section class=\"form-group full-width\"><h5 class=section-header ng-hide=\"vm.stateName.endsWith(\'view\')\">Основная информация</h5><ul class=catalogItem-path ng-show=\"vm.stateName.endsWith(\'view\')\"><li><a ui-sref=\"catalog({categoryId: vm.categoryId, parent: $state.params.parent})\" ng-bind=vm.catalogSkus.category.name></a></li></ul><div class=row><div id=nameAnchor class=\"form-group col-xs-12\" ng-class=\"{\'has-error-unique\': vm.addCatalogSkus.name.$invalid && vm.addCatalogSkus.name.$error.unique}\"><input empty-to-null required type=text class=form-control id=name maxlength=128 ng-model=vm.catalogSkus.name ng-hide=\"vm.stateName.endsWith(\'view\')\" name=name ng-keyup=\"vm.addCatalogSkus.name.$setValidity(\'unique\', true); vm.checkValidForm()\" ng-blur=\"vm.uniqueCheck(vm.catalogSkus.name, \'name\')\"><label for=name class=form-control-label ng-hide=\"vm.stateName.endsWith(\'view\')\">Наименование</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=vm.addCatalogSkus.name.$error><div ng-message=unique class=\"valid-message isset-name\">Товар уже существует</div></div><span class=req></span><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=vm.catalogSkus.name class=h4 style=\"font-weight: 600;\"></div></div><div class=\"form-group col-xs-12\" ng-hide=\"vm.stateName.endsWith(\'view\') && !vm.catalogSkus.full_desc\"><textarea empty-to-null class=form-control id=description ng-model=vm.catalogSkus.full_desc ng-hide=\"vm.stateName.endsWith(\'view\')\" maxlength=1000></textarea><label for=description class=form-control-label ng-hide=\"vm.stateName.endsWith(\'view\')\">Описание</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=vm.catalogSkus.full_desc style=\"margin-top: -10px; letter-spacing: 0.1px; font-size: 14px; opacity: 0.9;\"></div></div><div id=derivative_code_prefixAnchor class=\"form-group col-xs-6\" id=derivative_code_prefixAnchor ng-class=\"{\'has-error-unique\': vm.addCatalogSkus.derivative_code_prefix.$invalid && vm.addCatalogSkus.derivative_code_prefix.$error.unique}\"><input empty-to-null required type=text class=form-control id=code maxlength=30 ng-model=vm.catalogSkus.code ng-hide=\"vm.stateName.endsWith(\'view\')\" name=derivative_code_prefix ng-keyup=\"vm.addCatalogSkus.derivative_code_prefix.$setValidity(\'unique\', true); vm.checkValidForm(); vm.checkWeightBarcode();\" ng-blur=\"vm.buildDerivatives(); vm.uniqueCheck(vm.catalogSkus.code, \'derivative_code_prefix\')\"><label for=code class=form-control-label>Код товара</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-messages=vm.addCatalogSkus.derivative_code_prefix.$error><div ng-message=unique class=\"valid-message isset-name\">Код товара уже существует</div></div><span class=req></span><div ng-show=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=vm.catalogSkus.code></div></div><div id=vendor_codeAnchor class=\"form-group col-xs-6\" ng-class=\"{\'has-error-unique\': vm.addCatalogSkus.vendor_code.$invalid && vm.addCatalogSkus.vendor_code.$error.unique}\"><input empty-to-null type=text class=form-control id=vendorCode maxlength=30 ng-model=vm.catalogSkus.vendor_code ng-hide=\"vm.stateName.endsWith(\'view\')\" name=vendor_code ng-keyup=\"vm.addCatalogSkus.vendor_code.$setValidity(\'unique\', true); vm.settings.unique_vendor_code && vm.checkValidForm(); vm.checkWeightBarcode();\" ng-blur=\"vm.settings.unique_vendor_code && vm.uniqueCheck(vm.catalogSkus.vendor_code, \'vendor_code\')\"><label for=vendorCode class=form-control-label>Артикул производителя</label><div ng-messages=vm.addCatalogSkus.vendor_code.$error><div ng-message=unique class=\"valid-message isset-name\">Артикул производителя уже существует</div></div><div ng-show=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=\"(vm.catalogSkus.vendor_code)? vm.catalogSkus.vendor_code : \'-\'\"></div></div><div class=clear></div><div class=\"form-group col-xs-6\" ng-class=\"{\'has-error-stock-accounting-type\': vm.addCatalogSkus.stock_accounting_type.$invalid}\"><ui-select ng-model=vm.catalogSkus.stock_accounting_type search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\" name=stock_accounting_type><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=vm.getTaxGroups($select.search) repeat=\"type.val as type in (vm.accountingTypes) track by $index\"><span ng-bind-html=type.name></span></ui-select-choices></ui-select><label class=form-control-label>Складской учет</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-switch=vm.catalogSkus.stock_accounting_type class=view-entity-control><span ng-switch-when=SIMPLE>Обычный</span> <span ng-switch-when=BY_LOTS_FIFO>По партиям (FIFO)</span> <span ng-switch-when=BY_LOTS_LIFO>По партиям (LIFO)</span> <span ng-switch-when=BY_LOTS_FEFO>По партиям (FEFO)</span> <span ng-switch-when=BY_SERIAL_NUMBERS>По серийным номерам</span></div></div><div class=\"form-group col-xs-6\"><ui-select ng-model=vm.catalogSkus.project ng-hide=\"vm.stateName.endsWith(\'view\')\" search-enabled=\"vm.projectsFullTotal > 5\" ng-class=\"{\'autocomplete-select\': vm.projectsFullTotal > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.refreshProjects($select.search) repeat=\"item in ( vm.projects.items | filter: $select.search) track by $index\" group-by=vm.totalSelectStr><!-- group-by -вывод подсказки о количестве option --> <span ng-bind-html=\"item.name | highlight : $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=form-control-label>Проект</label><div ng-if=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control>{{vm.catalogSkus.project.name || \'-\'}}</div></div></div></section>");
$templateCache.put("app/catalog/catalogItem/sections/skus/templates/pack-attributes.html","<h5 class=section-header>Атрибуты упаковки</h5><div class=\"nestedDemo attribute_wrapper clearfix\" style=\"margin-bottom: 15px; padding: 0 7px;\"><div class=\"catalog-item-atttributes row\"><div ng-repeat=\"list in vm.settings.elements\" class=attribute ng-class=\"{attributeContainer: !list.attribute}\" ng-if=\"!vm.stateName.endsWith(\'view\') || \n      (list.block && !sku.$$blockFlags[list.block.id]) || \n      (list.attribute && sku.$$attribValues[list.attribute.name].values && sku.$$attribValues[list.attribute.name].values[0])\"><div ng-if=\"!list.attribute && !sku.$$blockFlags[list.block.id]\" class=\"container-element box clearfix\"><h3 class=container-name>{{list.block.name}}</h3><div class=clear></div><div class=container-attr><div class=column ng-repeat=\"item in list.block.attributes\" ng-hide=\"vm.stateName.endsWith(\'view\') && !sku.$$attribValues[item.name].values[0].value && (item.data_type == \'DATE\' || item.data_type == \'DATE_TIME\')\"><attr-element parent-form=\"vm.addCatalogSkus || addCatalogItem\" attribute=item data=sku.$$attribValues[item.name] data-multiple=false callback=vm.buildDerivatives state-name=vm.stateName unique=vm.hasError></attr-element></div></div></div><div ng-if=list.attribute><div class=\"column clearfix\" ng-hide=\"vm.stateName.endsWith(\'view\') && !sku.$$attribValues[list.attribute.name].values[0].value && (list.attribute.data_type == \'DATE\' || list.attribute.data_type == \'DATE_TIME\')\"><attr-element parent-form=\"vm.addCatalogSkus || addCatalogItem\" attribute=list.attribute data=sku.$$attribValues[list.attribute.name] data-multiple=false callback=vm.buildDerivatives state-name=vm.stateName unique=vm.hasError></attr-element></div></div></div></div></div>");
$templateCache.put("app/catalog/catalogItem/sections/skus/templates/packing.html","<div><div class=\"tab-pane active\"><div class=barcode-wrapper><div class=\"row clearfix gtin-wrapper\" ng-if=\"!vm.stateName.endsWith(\'view\')\"><!-- Весовой штрих-код --><div class=\"form-group col-xs-6\" ng-if=sku.$$weight_barcode><div class=\"code-wraper clearfix\"><input style=\"border-radius: 5px;\" code gtin-type=vm.weightBarcodeType type=text class=\"form-control code-input\" ng-model=vm.weightBarcode name=weightBarcode ng-disabled=true><label for=weightBarcode class=form-control-label>Весовой штрих-код</label></div></div><!-- Обычные штрих-коды --><div class=\"form-group col-xs-6\" ng-repeat=\"gtin in sku.$$gtin_list\" ng-class=\"{\'has-error-unique\': gtin.$$error || (sku.$$gtinErrors.length && sku.$$gtinErrors.indexOf($index)+1), \'wrong-format\': gtin.$$formatError}\"><div class=\"code-wraper clearfix\"><input hard-pruning data-check=[0-9] style=\"border-radius: 5px;\" code gtin-type=gtin.type generate-barcode=vm.settings.generate_barcode ng-pattern=\"/^(?=[0-9]*$)(?:.{4,})$/\" type=text class=\"form-control code-input\" maxlength=20 ng-model=gtin.gtin name=\"{{\'gtin_\' + $index}}\" ng-blur=\"vm.uniqueCheck(gtin, \'gtin\');vm.checkGtin(sku);vm.checkValidForm();\" ng-keyup=\"gtin.$$error = false;gtin.$$formatError = false;\"><label for=\"{{\'gtin_\' + $index}}\" class=form-control-label>Штрих-код</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message wrong-format-mess\">Неверный формат штрих-кода</div><div class=\"valid-message isset-mess\">Штрих-код уже существует</div></div></div><div class=\"form-group col-xs-6\" style=\"padding-top: 12px;\"><div class=add-item-wrap ng-click=vm.addGtin(sku)><span class=add-item-icon></span> <span class=add-item-title>Добавить штрих-код</span></div></div></div><div class=barcode-container ng-if=\"vm.stateName.endsWith(\'view\') && sku.$$weight_barcode\"><barcode background-color=#f6f6f6 value=vm.weightBarcode></barcode></div><div ng-if=\"vm.stateName.endsWith(\'view\')\" class=barcode-container ng-repeat=\"gtin in sku.$$gtin_list\"><barcode ng-if=gtin.gtin background-color=#f6f6f6 value=gtin.gtin></barcode></div></div><div class=clearfix style=\"padding-bottom: 32px\"><div class=\"col-xs-6 packing-property-block\"><div class=\"pack-mainInfo-wrap col-xs-12 clearfix\"><div class=pack-imge-wrap><div ng-show=\"sku.pack_type.ext_id == \'PACK_BASE_UNIT\' && sku.packaged\" class=\"pack-image triangle\"></div><div ng-class=sku.pack_type.ext_id ng-hide=\"sku.pack_type.ext_id == \'PACK_BASE_UNIT\' && sku.packaged\" class=\"pack-image pull-left\"></div></div><div class=pack-name-wrap><div class=form-group ng-hide=\"vm.stateName.endsWith(\'view\') && sku.packaged\"><input empty-to-null type=text class=\"form-control pack-name-input\" ng-model=sku.name required maxlength=255 ng-blur=vm.buildDerivatives();vm.checkValidForm(); ng-hide=\"vm.stateName.endsWith(\'view\')\" name=name ng-keyup=vm.checkPackingName();vm.reCalcScroll(); id=\"packName{{$index}}\"><label for=\"packName{{$index}}\" class=\"form-control-label small-offset\" ng-style=\"vm.stateName.endsWith(\'view\')? {\'left\':\'0\'} : \'\'\">Название</label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message isset-mess\">Название упаковки уже существует</div><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=sku.name class=view-entity-control></div><span class=req ng-hide=\"vm.stateName.endsWith(\'view\')\"></span></div><div class=form-group ng-hide=\"vm.stateName.endsWith(\'view\') && sku.packaged\"><ui-select ng-model=sku.pack_type search-enabled=false on-select=\"vm.loadMetaByPack($item.id, sku);vm.checkValidForm();\" ng-hide=\"vm.stateName.endsWith(\'view\')\" ng-disabled=\"sku.pack_type.ext_id == \'PACK_BASE_UNIT\'\"><ui-select-match allow-clear=false><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"type in vm.packTypes track by type.ext_id\"><span ng-bind-html=\"type.name | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><label class=\"form-control-label small-offset\" ng-style=\"vm.stateName.endsWith(\'view\')? {\'left\':\'0\'} : \'\'\">Тип</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=sku.pack_type.name class=view-entity-control></div></div></div><div class=\"form-group form-group-checkbox\" style=\"margin-bottom: 6px;\" ng-hide=\"(sku.pack_type.ext_id == \'PCK_GRP_TR_COVER\' || sku.pack_type.ext_id == \'PCK_BASE_TR_CVR\' || sku.pack_type.ext_id == \'PACK_GROUP_UNIT\') || (vm.stateName.endsWith(\'view\') && !sku.packaged)\"><div class=\"checkbox pull-left\" ng-hide=\"vm.stateName.endsWith(\'view\')\"><label><input type=checkbox ng-model=sku.packaged ng-disabled=\"vm.stateName.endsWith(\'view\')\" id=\"wihoutPack{{$index}}\" ng-change=vm.changePackaged(sku);> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"wihoutPack{{$index}}\" class=label-checkbox>Товар весовой/мерный</label></div></div><div class=clear></div><div ng-hide=\"vm.stateName.endsWith(\'view\')\"><div ng-show=\"sku.pack_type.ext_id == \'PACK_BASE_UNIT\'\"><label class=\"form-label col-xs-offset-5\">Единица измерения</label><div class=clean></div><div class=col-xs-5><input type=text value=1 disabled class=\"form-control slim-control\"></div><div class=\"form-group col-xs-7\" style=\"padding-left: 0; margin-bottom: 6px;\"><ui-select ng-model=sku.uom search-enabled=true ng-required=true on-select=vm.checkValidForm() name=uom class=slim-control ng-class=\"{\'autocomplete-select\': vm.uoms.length > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=500 refresh=vm.refreshUoms($select.search) repeat=\"uom in (vm.uoms | limitTo:$root.controlSettings.OPTION_DEFAULT_LENGTH) track by $index\" group-by=vm.totalUomStr><span ng-bind-html=\"uom.name + \' (\' + uom.symbols + \')\' | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req ng-hide=\"vm.stateName.endsWith(\'view\')\"></span></div></div><div class=\"form-group col-xs-12\" ng-show=\"sku.pack_type.ext_id != \'PACK_BASE_UNIT\'\"><label class=\"form-label small-offset\">Единица измерения</label><ui-select ng-model=sku.uom search-enabled=true ng-required=true on-select=vm.checkValidForm() class=slim-control ng-class=\"{\'autocomplete-select\': vm.uoms.length > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=vm.refreshUoms($select.search) repeat=\"uom in (vm.uoms | limitTo:$root.controlSettings.OPTION_DEFAULT_LENGTH) track by $index\" group-by=vm.totalUomStr><span ng-bind-html=\"uom.name + \' (\' + uom.symbols + \')\' | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><span class=req ng-hide=\"vm.stateName.endsWith(\'view\')\"></span></div></div><div class=form-group ng-show=\"vm.stateName.endsWith(\'view\') && sku.uom.name\" style=\"margin-left: 16px;\"><label class=form-control-label ng-style=\"vm.stateName.endsWith(\'view\')? {\'left\':\'0\'} : \'\'\">Единица измерения</label><div ng-bind=\"\'1 \' + sku.uom.symbols\" class=view-entity-control title=\"{{sku.uom.name}}\"></div></div><div ng-hide=\"sku.packaged || sku.pack_type.ext_id == \'PCK_GRP_TR_COVER\' || sku.pack_type.ext_id == \'PCK_BASE_TR_CVR\' || sku.pack_type.ext_id == \'PACK_GROUP_UNIT\' || vm.stateName.endsWith(\'view\')\"><label class=\"form-label col-xs-offset-5\">Кол-во/Мера нетто</label><div class=clean></div><div class=col-xs-5><input type=text float-input class=\"form-control slim-control text-align-left\" float-step=0.01 max-int-length=9 ng-model=sku.alt_count><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div></div><div class=\"form-group col-xs-7\" style=\"padding-left: 0;\"><ui-select ng-model=sku.alt_uom search-enabled=true class=slim-control ng-class=\"{\'autocomplete-select\': vm.uoms.length > $root.controlSettings.OPTION_DEFAULT_LENGTH}\"><ui-select-match allow-clear=true><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices refresh=vm.refreshUoms($select.search) repeat=\"uom in (vm.uoms | limitTo:$root.controlSettings.OPTION_DEFAULT_LENGTH) track by $index\" group-by=vm.totalUomStr><span ng-bind-html=\"uom.name + \' (\' + uom.symbols + \')\' | highlight: $select.search\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select></div></div><div class=form-group ng-show=\"vm.stateName.endsWith(\'view\') && sku.alt_uom.name\" style=\"margin-left: 16px;\"><label class=form-control-label>Кол-во/Мера нетто</label><div ng-bind=\"(sku.alt_count)? (sku.alt_count | parseNumber) + \' \' + sku.alt_uom.symbols : \'-\'\" class=view-entity-control title=\"{{sku.alt_uom.name}}\"></div></div></div><div class=\"col-xs-6 packing-property-block\" ng-if=\"sku.pack_type.ext_id == \'PCK_GRP_TR_COVER\' || sku.pack_type.ext_id == \'PCK_BASE_TR_CVR\' || sku.pack_type.ext_id == \'PACK_GROUP_UNIT\'\" style=\"padding-left: 20px;\"><div class=\"pack-mainInfo-wrap clearfix\" style=\"box-shadow: -8px 9px 0 -8px #681a1b;\"><div class=arrow-right style=\"height: 20px; width: 20px; left: -25px; top: 120px; position: absolute; transform: rotate(90deg);\"></div><div class=counts-wrap style=\"padding-right: 24px;\"><label for=\"count{{$index}}\" class=form-label>Содержит:</label><div class=input-wrap><input hard-pruning pattern=[0-9]* empty-to-null type=text class=\"form-control slim-control\" ng-model=sku.constituent_multiplier ng-hide=\"vm.stateName.endsWith(\'view\')\" ng-required=true ng-keyup=vm.checkValidForm(); ng-blur=vm.checkValidForm(); name=countPack id=\"count{{$index}}\"> <span class=req ng-hide=\"vm.stateName.endsWith(\'view\')\"></span></div><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=sku.constituent_multiplier class=view-entity-control style=\"padding-top: 6px;height: auto;margin-bottom: 9px;\"></div><span style=\"font-size: 16px; opacity: 0.5;margin: 0 10px;\">×</span><div ng-show=\"sku.$$constituent.pack_type.ext_id == \'PACK_BASE_UNIT\' && sku.$$constituent.packaged\" class=\"pack-image triangle\"></div><div ng-hide=\"sku.$$constituent.pack_type.ext_id == \'PACK_BASE_UNIT\' && sku.$$constituent.packaged\" ng-class=\"(sku.$$constituent.pack_type.ext_id)? sku.$$constituent.pack_type.ext_id : \'PACK_GROUP_UNIT\'\" class=pack-image></div></div><div class=clear></div><div class=form-group><ui-select ng-model=sku.$$constituent search-enabled=\"vm.searchPackLength > $root.controlSettings.OPTION_DEFAULT_LENGTH\" ng-hide=\"vm.stateName.endsWith(\'view\')\" ng-required=true on-select=vm.checkValidForm()><ui-select-match><span ng-bind=\"$select.selected.name || $select.selected.pack_type.name\"></span></ui-select-match><ui-select-choices repeat=\"sku_parent in (vm.catalogSkus.sku_list | filter: {pack_type: {id: sku.pack_type.parent.id}}) track by $index\"><span ng-bind-html=\"sku_parent.name || sku_parent.pack_type.name\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message required-mess small-offset\">Поле является обязательным</div><label class=\"form-control-label small-offset\">Наименование</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=sku.$$constituent.name class=view-entity-control></div><span class=req ng-hide=\"vm.stateName.endsWith(\'view\')\"></span></div><div class=form-group><input type=text ng-value=sku.$$constituent.pack_type.name disabled class=\"form-control ng-not-empty\" ng-disabled=true ng-hide=\"vm.stateName.endsWith(\'view\')\"><label class=\"form-control-label small-offset\">Тип</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=\"(sku.$$constituent.pack_type.name)? sku.$$constituent.pack_type.name : \'-\'\" class=view-entity-control></div></div></div><div class=clear></div><div ng-hide=\"vm.stateName.endsWith(\'view\')\"><div class=row ng-show=\"sku.$$constituent.pack_type.ext_id == \'PACK_BASE_UNIT\'\" style=\"margin-right: 0;\"><label class=\"form-label col-xs-offset-5\">Единица измерения</label><div class=col-xs-5><input type=text value=1 disabled class=\"form-control slim-control\" ng-disabled=true></div><div class=\"form-group col-xs-7\" style=\"padding-left: 0;\"><input type=text ng-value=sku.$$constituent.uom.name disabled class=\"form-control ng-not-empty slim-control\" ng-disabled=true></div></div><div class=form-group ng-show=\"sku.$$constituent.pack_type.ext_id != \'PACK_BASE_UNIT\'\"><label class=form-label>Единица измерения</label><input type=text ng-value=sku.$$constituent.uom.name disabled class=\"form-control ng-not-empty slim-control\" ng-disabled=true></div></div><div class=form-group ng-show=\"vm.stateName.endsWith(\'view\') && sku.$$constituent.uom.name\"><label class=form-control-label>Единица измерения</label><div ng-bind=\"(sku.$$constituent.uom.name)? \'1 \' + sku.$$constituent.uom.symbols : \'-\'\" class=view-entity-control title=\"{{sku.$$constituent.uom.name}}\"></div></div></div></div><div class=\"form-group checkbox-group\" ng-if=\"sku.pack_type.ext_id == \'PCK_GRP_TR_COVER\' || sku.pack_type.ext_id == \'PCK_BASE_TR_CVR\' || sku.pack_type.ext_id == \'PACK_GROUP_UNIT\'\" style=\"padding-top: 0;\"><div class=\"checkbox pull-left\" ng-hide=\"vm.stateName.endsWith(\'view\')\"><label><input type=checkbox ng-disabled=\"vm.stateName.endsWith(\'view\')\" ng-model=sku.auto_assemble id=autoAssemble> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=autoAssemble class=label-checkbox ng-bind=\"(vm.stateName.endsWith(\'view\') && sku.auto_assemble)? \'Комплектуется автоматически\' : \'Автоматически комплектовать\'\" ng-hide=\"vm.stateName.endsWith(\'view\') && !sku.auto_assemble\"></label></div></div><div class=\"col-xs-5 section-helper pack-helper weight-barcode-helper\" ng-if=sku.$$weight_barcode><strong>ВНИМАНИЕ!</strong> Весовой штрих-код построен в соответствии с параметрами, установленными на форме <a ui-sref=\"attrSettings({parent: $state.params.parent})\">Настройки</a> и является примером для товара с весом в 1 грамм (если единица измерения конвертируется в граммы)</div><div class=clearfix ng-if=\"vm.settings.use_pack_attributes && vm.settings.elements.length && (!vm.stateName.endsWith(\'view\') || !sku.$$noAttr)\"><div ng-include=\"\'app/catalog/catalogItem/sections/skus/templates/pack-attributes.html\'\"></div></div></div>");
$templateCache.put("app/catalog/catalogItem/sections/skus/templates/taxInfoSkus.html","<section class=\"form-group tab-form-group full-width\" ng-class=\"{\'title-out-group\': vm.stateName.endsWith(\'view\')}\"><ul class=\"nav nav-tabs\"><li class=active><a href=.salesTaxes data-toggle=tab>Налоги при реализации</a></li><li><a href=.forCash data-toggle=tab>На кассе</a></li></ul><div class=tab-content><div class=\"tab-pane salesTaxes active\"><div class=row><div class=\"form-group col-xs-6\" ng-hide=\"vm.stateName.endsWith(\'view\')\"><div class=radio-box><div class=radio-box-title>Принадлежность товара</div><div class=clearfix ng-repeat=\"radio in vm.radioTaxGroupSelectors\"><div class=\"radio pull-left\"><label><input type=radio name=\"{{radio.value}}\" ng-model=vm.catalogSkus.tax_group_selector ng-value=radio.value id=\"{{radio.value}}\" ng-change=vm.buildDerivatives()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{radio.value}}\">{{radio.label}}</label></div></div></div><div class=form-group ng-class=\"(vm.stateName.endsWith(\'view\'))? \'row col-xs-12\' : \'col-xs-6\'\"><div ng-hide=\"vm.catalogSkus.tax_group_selector == \'COMMITTENT\'\" ng-class=\"{\'col-xs-6\': vm.stateName.endsWith(\'view\')}\"><ui-select ng-model=vm.catalogSkus.tax_group search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\" style=\"position: relative;\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"tax_group in (vm.taxGroups) track by $index\"><span ng-bind-html=\"tax_group.name | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Налог собственный</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" class=view-entity-control ng-bind=vm.catalogSkus.tax_group.name></div><br></div><div ng-hide=\"vm.catalogSkus.tax_group_selector == \'OWN\'\" ng-class=\"{\'col-xs-6\': vm.stateName.endsWith(\'view\')}\" style=\"position: relative;\"><ui-select ng-model=vm.catalogSkus.committent_tax_group search-enabled=true ng-hide=\"vm.stateName.endsWith(\'view\')\"><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"tax_group in (vm.taxGroups) track by $index\"><span ng-bind-html=\"tax_group.name | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\">Налог комитента</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=vm.catalogSkus.committent_tax_group.name class=view-entity-control></div></div></div></div></div><div class=\"tab-pane forCash\"><h5 class=section-header>Налогообложение чека</h5><div class=row><div class=\"form-group col-xs-6\"><div class=radio-box><div class=clearfix ng-repeat=\"radio in vm.radioTaxModeSource\" ng-hide=\"vm.stateName.endsWith(\'view\') && radio.value != vm.catalogSkus.tax_mode_source\"><div class=\"radio pull-left\" ng-hide=\"vm.stateName.endsWith(\'view\')\"><label><input type=radio name=\"{{radio.value}}\" ng-model=vm.catalogSkus.tax_mode_source ng-value=radio.value ng-change=vm.taxModeSourceChanged(radio.value) id=\"{{radio.value}}\" ng-required=true> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=\"{{radio.value}}\">{{radio.label}}</label></div></div></div><div class=\"form-group col-xs-6\" style=\"margin: 0\" ng-if=\"vm.catalogSkus.tax_mode_source === \'FROM_CATALOG_ITEM\'\"><ui-select ng-model=vm.catalogSkus.tax_mode search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\" ng-required=\"vm.catalogSkus.tax_mode_source === \'FROM_CATALOG_ITEM\'\"><ui-select-match><span ng-bind=\"$select.selected | tax\"></span></ui-select-match><ui-select-choices repeat=\"tax_mode in (vm.taxModeList) track by $index\"><span ng-bind=\"tax_mode | tax | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Режим налогообложения чека</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=\"vm.catalogSkus.tax_mode ? vm.catalogSkus.tax_mode: \'-\' | tax\" class=view-entity-control></div></div></div><h5 class=section-header>Предмет расчета</h5><div class=row><div class=\"form-group col-xs-6\" style=\"margin: 0\"><ui-select ng-model=vm.catalogSkus.cash_register_item_type search-enabled=false ng-hide=\"vm.stateName.endsWith(\'view\')\"><ui-select-match><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices repeat=\"item.value as item in (vm.cashRegisterItemTypes) track by $index\"><span ng-bind=\"item.label | highlight: $select.search\"></span></ui-select-choices></ui-select><label class=form-control-label>Признак предмета расчета</label><div ng-show=\"vm.stateName.endsWith(\'view\')\" ng-bind=\"(vm.catalogSkus.cash_register_item_type ? vm.catalogSkus.cash_register_item_type: \'-\') | cashRegisterItemTypes\" class=view-entity-control></div></div></div></div></div></section>");
$templateCache.put("app/documents/components/attribute/fields/add-documents/add-documents.html","<a ng-click=addDocuments.showPopup(); ng-hide=addDocuments.hide style=cursor:pointer; class=tooltip-light tooltip-placement=right uib-tooltip=\"{{addDocuments.disableMessage}}\" ng-class=\"(!addDocuments.isDisableLink)? \'\' : \'text-muted\'\">Добавить связанный документ</a>");
$templateCache.put("app/documents/components/attribute/fields/base-document/base-document.html","<label class=\"form-control-label small-offset always-top\" ng-bind=::baseDocumentCtrl.item.name></label><div class=view-entity-control><!-- Нет документа --> <span ng-if=!baseDocumentCtrl.doc>-</span><!-- RECS документы --><div ng-if=\"baseDocumentCtrl.doc && baseDocumentCtrl.doc.base_document_type == \'DOCUMENT_RECS\'\"><div ng-switch=baseDocumentCtrl.doc.document.document_type><div ng-switch-when=CASHREGISTER_END_SHIFT><a class=ellipsis target=_blank ui-sref=\"cashregshift.view({id: baseDocumentCtrl.doc.document.id, end_shift: true, parent: \'retail\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=CASHREGISTER_START_SHIFT><a class=ellipsis target=_blank ui-sref=\"cashregshift.view({id: baseDocumentCtrl.doc.document.id, parent: \'retail\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=CASHBOX_REPLENISHMENT><a class=ellipsis target=_blank ui-sref=\"cashboxreplenishment.view({id: baseDocumentCtrl.doc.document.id, parent: \'retail\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=RETAIL_SALE><a class=ellipsis target=_blank ui-sref=\"cashregreceipt.view({id: baseDocumentCtrl.doc.document.id, parent: \'retail\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=RETAIL_RETURN><a class=ellipsis target=_blank ui-sref=\"return.view({id: baseDocumentCtrl.doc.document.id, parent: \'retail\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=CASHBOX_ENCASHMENT><a class=ellipsis target=_blank ui-sref=\"encashment.view({id: baseDocumentCtrl.doc.document.id, parent: \'retail\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-default><a class=ellipsis target=_blank ui-sref=\"document.new({type: baseDocumentCtrl.doc.document.document_type, purpose: baseDocumentCtrl.doc.document.document_purpose, parent: $state.params.parent, allDocument: true, id: baseDocumentCtrl.doc.document.id})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div></div></div><!-- ЕГАИС документы --><div ng-if=\"baseDocumentCtrl.doc && baseDocumentCtrl.doc.base_document_type == \'DOCUMENT_EGAIS\'\"><div ng-switch=baseDocumentCtrl.doc.document_egais.document_egais_type><div ng-switch-when=WRITE_OFF_STATEMENT_EGAIS_ONLY|WRITE_UP_STATEMENT_EGAIS|INVENTORY_EGAIS ng-switch-when-separator=|><span class=ellipsis ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></span></div><div ng-switch-when=CONSIGNMENT_NOTE_IN_EGAIS><a class=ellipsis target=_blank ui-sref=\"invoiceWaybill.view({id: baseDocumentCtrl.doc.document_egais.id, parent: \'alcohol\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=WRITE_OFF_STATEMENT_EGAIS><a class=ellipsis target=_blank ui-sref=\"cancellationAct.view({id: baseDocumentCtrl.doc.document_egais.id, register: baseDocumentCtrl.register, parent: \'alcohol\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=WRITE_RETURN_EGAIS><a class=ellipsis target=_blank ui-sref=\"writeReturn.view({id: baseDocumentCtrl.doc.document_egais.id, parent: \'alcohol\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=TRANSFER_BETWEEN_REGISTER_EGAIS><a class=ellipsis target=_blank ui-sref=\"transferBetweenRegister.view({id: baseDocumentCtrl.doc.document_egais.id, parent: \'alcohol\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div><div ng-switch-when=BEGINNING_BALANCE_EGAIS><a class=ellipsis target=_blank ui-sref=\"beginningBalanceEgais.view({id: baseDocumentCtrl.doc.document_egais.id, parent: \'alcohol\'})\" ng-bind=baseDocumentCtrl.viewStr uib-tooltip=\"{{baseDocumentCtrl.viewStr}}\"></a></div></div></div></div>");
$templateCache.put("app/documents/components/attribute/fields/catalogItem/catalog-field.html","<div ng-if=!vm.hideField><div style=\"display: flex\" ng-if=\"vm.redact && !vm.item.modalInfo\"><div style=\"flex: 1 1;\" ng-style=\"{\'max-width\': ((vm.item.hideSearchButton)? \'100%\' : \'calc(100% - 35px)\')}\"><ui-select ng-model=vm.values[vm.item.code] name=\"{{vm.item.code}}\" ng-disabled=\"!vm.item.editable || !vm.redact\" ng-required=vm.item.required search-enabled=\"!vm.item.hideSearchButton && !vm.item.searchDisabled\" class=\"catalog-field tooltip-light {{($select.search.length < 3 && !vm.item.hideSearchButton && !vm.item.searchDisabled)? \'hide-error\' : \'\'}}\" tooltip=\"{{vm.matchPaternTooltip}}\" ng-class=\"{\'autocomplete-select\': vm.searchTotal > 5, \'ng-invalid\': !vm.values[vm.item.code]}\" on-select=\"$ctrl.formName.$setDirty(); vm.onSelect($select.selected);\"><ui-select-match allow-clear=!vm.item.required tooltip-placement=right uib-tooltip=\"{{$select.selected.alc_code}} {{$select.selected.name || $select.selected.full_name}} {{$select.selected.derivative.name}}\"><span bind-html-compile=vm.selectMatchPatern></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=vm.refresh($select) repeat=\"item in vm.items track by $index\" group-by=vm.totalStr><span bind-html-compile=vm.selectChoicesPatern title-ext=vm.selectChoicesPatern></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\">{{vm.item.name}} уже существует</div><div class=disabled-helper ng-if=\"!vm.item.editable || vm.isDisabled\"></div><span class=req ng-if=\"vm.item.required && vm.total\"></span><label class=\"form-control-label small-offset\" ng-transclude></label><div class=\"valid-message wrong-supplier\">Не правильно указан поставщик</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message wrong-commitent\">Не принадлежит комитенту</div><div class=\"valid-message wrong-match\" ng-bind=vm.selectObj.ngModel.errorStr style=\"white-space: normal;\"></div><div class=\"valid-message uom-match\">Единица измерения не соответствует выбранному товару</div></div><button class=\"catalog-item-seach text-left\" ng-click=vm.showSearchCatalogItemPopup(); ng-if=\"vm.redact && !vm.item.hideSearchButton\" ng-disabled=vm.isDisabled><span class=\"glyphicon glyphicon-search tooltip-light\" tooltip-placement=right uib-tooltip=\"{{vm.tipForSearch}}\"></span></button></div><div class=\"view-entity-control ng-hide text-left catalog-item-cell\" ng-if=\"!vm.redact && !vm.item.modalInfo\" style=\"padding-top: 10px;\"><span class=catalog-item-name tooltip-placement=right uib-tooltip=\"{{vm.values[vm.item.code].alc_code? vm.values[vm.item.code].alc_code + \' \': \'\'}}{{::(vm.values[vm.item.code].name || vm.values[vm.item.code].full_name)}}\" ng-bind=\"::(vm.values[vm.item.code].name || vm.values[vm.item.code].full_name || \'-\')\"></span> <span class=catalog-item-derivative tooltip-placement=right uib-tooltip=\"{{::vm.values[vm.item.code].derivative.name}}\" ng-bind=\"::(vm.values[vm.item.code].derivative.name)? vm.values[vm.item.code].code + \', \' + vm.values[vm.item.code].derivative.name : (vm.values[vm.item.code].code || vm.values[vm.item.code].alc_code || \'-\') \"></span></div><span class=\"link-style ellipsis text-left\" style=\"padding-top: 5px;\" ng-if=::vm.item.modalInfo ng-click=vm.showSkuInfoModal() ng-bind=\"(vm.values[vm.item.code].name || vm.values[vm.item.code].full_name) + ((vm.values[vm.item.code].capacity)? \' \' + vm.values[vm.item.code].capacity + \'л.\' : \'\')\" tooltip-placement=bottom-left uib-tooltip=\"{{(vm.values[vm.item.code].name || vm.values[vm.item.code].full_name) + ((vm.values[vm.item.code].capacity)? \' \' + vm.values[vm.item.code].capacity + \'л.\' : \'\')}}\"></span></div>");
$templateCache.put("app/documents/components/attribute/fields/custom-select/custom-select.html","<div ng-if=!vm.needPopup><ui-select ng-model=vm.values[vm.item.code] name=\"{{::vm.item.code}}\" ng-disabled=\"::(vm.item.non_editable_purposes &&\n                vm.item.non_editable_purposes.indexOf(vm.purpose) != -1) ||\n                !vm.item.editable\" ng-required=::vm.item.required class=tooltip-light title=$select.selected.value ng-if=vm.redact search-enabled=false><ui-select-match allow-clear=\"{{!vm.item.required}}\"><span ng-bind-html=$select.selected.value></span></ui-select-match><ui-select-choices repeat=\"item.key as (key, item) in vm.items\"><span ng-bind-html=item.value title=\"{{item.value}}\"></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=disabled-helper ng-if=!vm.item.editable></div><span class=req ng-if=vm.item.required></span><label class=\"form-control-label small-offset\" ng-transclude ng-class=\"{\'always-top\': !vm.redact}\"></label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"view-entity-control ellipsis\" uib-tooltip=\"{{vm.getViewValue(vm.values[vm.item.code]) || \'\'}}\" ng-if=!vm.redact ng-bind=\"vm.getViewValue(vm.values[vm.item.code]) || \'-\'\"></div></div><div ng-if=vm.needPopup class=\"text-left ellipsis\" style=\"padding-top: 6px;\"><span class=link-style ng-bind=vm.getViewValue(vm.values[vm.item.code]) ng-click=vm.openFormsPopup();></span></div>");
$templateCache.put("app/documents/components/attribute/fields/date/date-field.html","<div class=form-group ng-class=\"{\'crud-entity view-entity\': !dateFieldCtrl.item.editable}\"><div date-range-picker ng-if=dateFieldCtrl.item.editable name=\"{{dateFieldCtrl.item.code + dateFieldCtrl.id}}\" ng-model=dateFieldCtrl.values[dateFieldCtrl.item.code] opts=dateFieldCtrl.datePickerOptions state=dateFieldCtrl.item.$$dateState class=datepicker-wrap ng-class=\"{\'hide-label\': dateFieldCtrl.hideLabel, \n                  \'view\': dateFieldCtrl.redact === false || !dateFieldCtrl.item.editable, \n                  \'disabled\': dateFieldCtrl.item.disabled}\" ng-required=dateFieldCtrl.item.required field-label=::dateFieldCtrl.item.name></div><div ng-if=!dateFieldCtrl.item.editable><label class=\"form-control-label small-offset\" ng-hide=dateFieldCtrl.hideLabel ng-bind=::dateFieldCtrl.item.name></label><div class=\"view-entity-control ellipsis\" ng-style=\"(dateFieldCtrl.redact)? {\'margin-left\': \'15px\'} : \'\'\" ng-if=\"dateFieldCtrl.item.field_type.toUpperCase() === \'FLD_DATE_TIME\'\" ng-bind=\"(dateFieldCtrl.values[dateFieldCtrl.item.code] | date:\'dd.MM.yyyy HH:mm\') || \'-\'\"></div><div class=\"view-entity-control ellipsis\" ng-style=\"(dateFieldCtrl.redact)? {\'margin-left\': \'15px\'} : \'\'\" ng-if=\"dateFieldCtrl.item.field_type.toUpperCase() === \'FLD_DATE\'\" ng-bind=\"(dateFieldCtrl.values[dateFieldCtrl.item.code] | date:\'dd.MM.yyyy\') || \'-\'\"></div></div><div class=disabled-helper></div><div class=\"valid-message isset-name\">Документ с такими данными уже существует</div></div>");
$templateCache.put("app/documents/components/attribute/fields/differenceField/difference-field.html","<div class=form-group><input class=form-control float-input float-fixed=2 max-int-length=9 empty-values=true float-step=0.01 max-after-comma=3 name=\"{{differenceFieldCtrl.item.code}}\" ng-disabled=\"!differenceFieldCtrl.item.editable || differenceFieldCtrl.redact === false\" ng-model=differenceFieldCtrl.values[differenceFieldCtrl.item.code] ng-required=differenceFieldCtrl.item.required><label class=\"form-control-label small-offset\" ng-hide=differenceFieldCtrl.hideLabel ng-bind=::differenceFieldCtrl.item.name></label><i class=req ng-if=\"::differenceFieldCtrl.item.required && !differenceFieldCtrl.hideLabel\"></i></div>");
$templateCache.put("app/documents/components/attribute/fields/documentCheckboxesList/document-checkboxes-list.html","<div style=\"padding: 0 0 0 15px; margin-right: -15px; margin-bottom: 10px;\"><label style=\"line-height: 1.3;margin-bottom: 10px;\"> {{documentCheckboxesList.item.name}} <span ng-if=\"!documentCheckboxesList.item.editable && documentCheckboxesList.redact && documentCheckboxesList.canRedact\">(<span class=link-style ng-click=documentCheckboxesList.changeInfo();>изменить</span>)</span></label><div ng-repeat=\"item in documentCheckboxesList.checkboxList\" style=\"min-height: 30px\"><div class=\"checkbox pull-left\" uib-tooltip=\"{{item.tooltip}}\"><label><input type=checkbox ng-model=documentCheckboxesList.externalData[item.code] ng-disabled=\"!documentCheckboxesList.item.editable || !item.editable || !documentCheckboxesList.redact || !documentCheckboxesList.canRedact\" id=\"{{item.code}}\"> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label for=\"{{item.code}}\" class=label-checkbox ng-bind=item.label uib-tooltip=\"{{item.tooltip}}\"></label></div></div>");
$templateCache.put("app/documents/components/attribute/fields/fn-reg-field/f1-popup.html","<div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title>Добавление информации по справке 1</h3></div><div class=\"container crud-entity\"><form class=row name=createF1><div class=\"form-group col-xs-6\"><input float-input float-fixed=2 float-step=0.01 max-after-comma=3 max-int-length=5 type=text class=form-control ng-required=true ng-model=data.quantity><label class=form-control-label>Количество</label><div class=\"valid-message wrong-simbol-mess\" style=\"position: absolute; margin-top: 3px;\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\"><div date-range-picker ng-required=true ng-model=data.bottling_date opts=datePickerOpts state=bottling_date class=datepicker-wrap field-label=\"\'Дата розлива\'\"></div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input maxlength=50 ng-model=data.ttn_number ng-required=true type=text class=form-control><label class=form-control-label>Номер ТТН</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\"><div date-range-picker ng-required=true ng-model=data.ttn_date opts=datePickerOpts state=ttn_date class=datepicker-wrap field-label=\"\'Дата ТТН\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div><div class=\"form-group col-xs-6\"><input maxlength=50 ng-model=data.egais_fix_number type=text class=form-control><label class=form-control-label>Номер фиксации в ЕГАИС</label><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"form-group col-xs-6\"><div date-range-picker name=egais_fix_date ng-model=data.egais_fix_date opts=datePickerOpts state=egais_fix_date class=datepicker-wrap field-label=\"\'Дата фиксации в ЕГАИС\'\"></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div></form></div><div class=modal-footer><button class=btn type=button ng-click=close()>Отмена</button> <button class=\"btn btn-primary\" type=button ng-click=create() ng-disabled=createF1.$invalid ng-bind=\"\'Добавить\'\"></button></div>");
$templateCache.put("app/documents/components/attribute/fields/fn-reg-field/f1-reg-field.html","<div class=f1-wrapper ng-show=vm.redact><div style=\"flex: 1 1;\" uib-tooltip=\"{{vm.viewValue}}\"><input class=form-control ng-if=\"vm.item.editable && vm.redact\" name=\"{{vm.item.code}}\" disabled ng-model=vm.viewValue ng-required=vm.item.required uib-tooltip=\"{{vm.viewValue}}\" tooltip-placement=bottom> <span class=req ng-if=vm.item.required></span><label class=\"form-control-label small-offset\" ng-transclude></label><div class=\"valid-message required-mess\">Поле является обязательным</div></div><span class=\"btn slim-button only-ico\" ng-click=vm.openF1Popup(); ng-if=vm.item.editable><span class=\"btn-ico btn-edit tooltip-light\" tooltip-placement=right uib-tooltip=\"Редактировать справку\"></span></span></div>");
$templateCache.put("app/documents/components/attribute/fields/fn-reg-field/fn-reg-field.html","<div style=\"display: flex\" ng-show=\"vm.redact && vm.showField\"><div style=\"flex: 1 1;\" ng-style=\"(vm.item.editable && vm.redact)? {\'max-width\': \'calc(100% - 35px)\'} : {\'max-width\': \'100%\'}\"><ui-select ng-model=vm.values[vm.item.code] name=\"{{vm.item.code}}\" ng-disabled=\"!vm.item.editable || !vm.redact\" ng-required=vm.item.required search-enabled=true class=tooltip-light tooltip=\"{{vm.selectMatchPatern}}\" ng-class=\"{\'autocomplete-select\': vm.total > 5}\" on-select=\"$ctrl.formName.$setDirty(); vm.setData($select.selected);\" on-remove=vm.removed()><ui-select-match allow-clear=\"{{!vm.item.required}}\" placeholder=\"{{(!vm.item.required)? \'Автоматически\' : \'\'}}\" tooltip-placement=right uib-tooltip=\"{{$select.selected[vm.selectCode]}}\"><span ng-bind=$select.selected[vm.selectCode]></span></ui-select-match><ui-select-choices refresh=vm.refresh($select) repeat=\"item in vm.items track by $index\" group-by=vm.totalStr><div ng-bind=item[vm.selectCode] tooltip-placement=\"{{($index)? \'top\' : \'bottom\'}}\" uib-tooltip=\"{{item[vm.selectCode]}}\"></div></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\" ng-if=vm.values[vm.item.code]>{{vm.item.name}} уже существует</div><div class=\"valid-message isset-name\" ng-if=!vm.values[vm.item.code]>Поле является обязательным</div><div class=disabled-helper ng-if=\"!vm.item.editable || !vm.total\" tooltip=\"{{vm.selectMatchPatern}}\"></div><span class=req ng-if=\"vm.item.required && vm.total\"></span><label class=\"form-control-label small-offset\" ng-transclude></label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message invalid-accounting-type\">Недоступно для перевода между регистрами</div></div><span class=\"catalog-item-seach text-left\" ng-click=vm.showSearchCatalogItemPopup(); ng-if=\"vm.item.editable && vm.redact\"><span class=\"glyphicon glyphicon-search tooltip-light\" tooltip-placement=right uib-tooltip=\"Расширенный поиск\"></span></span></div>");
$templateCache.put("app/documents/components/attribute/fields/getSum/get-sum.html","<input class=\"form-control currency-input\" input-price currency-input type=text name=\"{{$ctrl.item.code}}\" ng-model=$ctrl.values[$ctrl.item.code] currency-input=true currency-icon=\"{{($ctrl.item.without_currency)? \'\' : ($ctrl.externalData.natural_currency.symbol || $ctrl.externalData.natural_currency.char_iso_code || $root.homeCurrency.currency.symbol)}}\" ng-required=$ctrl.item.required ng-disabled=true><label class=\"form-control-label small-offset\" ng-hide=$ctrl.hideLabel ng-bind=::$ctrl.item.name></label><i class=req ng-if=\"::$ctrl.item.required && !$ctrl.hideLabel\"></i>");
$templateCache.put("app/documents/components/attribute/fields/html-field/html-field.html","<div>html</div>");
$templateCache.put("app/documents/components/attribute/fields/lot-sn/lot-sn.html","<div ng-if=\"!lotSnCtrl.stockAccountingType || lotSnCtrl.stockAccountingType == \'SIMPLE\'\"></div><div ng-if=\"lotSnCtrl.stockAccountingType && lotSnCtrl.stockAccountingType != \'SIMPLE\'\" class=text-left tooltip-placement=right uib-tooltip=\"{{(lotSnCtrl.stockAccountingType == \'BY_SERIAL_NUMBERS\')? lotSnCtrl.values[lotSnCtrl.item.code].serial_number : lotSnCtrl.values[lotSnCtrl.item.code].log_number}}\"><ui-select ng-model=lotSnCtrl.values[lotSnCtrl.item.code] name=\"{{lotSnCtrl.item.code}}\" ng-disabled=\"!lotSnCtrl.item.editable || !lotSnCtrl.redact\" ng-required=lotSnCtrl.item.required search-enabled=true tooltip=\"{{lotSnCtrl.selectMatchPatern}}\" style=\"width: calc(100% - 30px); display: inline-block;\" select-choices-paging items-total=\"{{lotSnCtrl.helpTotal}}\"><ui-select-match allow-clear=!lotSnCtrl.item.required><span ng-bind=lotSnCtrl.getStr($select.selected)></span></ui-select-match><ui-select-choices refresh=\"lotSnCtrl.refresh($select.search, $select.offset)\" repeat=\"item in (lotSnCtrl.items | filter: $select.search) track by $index\"><span title=\"{{lotSnCtrl.getStr(item)}}\" ng-bind=lotSnCtrl.getStr(item)></span></ui-select-choices><ui-select-no-choice> {{$root.controlSettings.NOT_FOUND_STRING}} </ui-select-no-choice></ui-select><div class=\"valid-message isset-name\">{{(lotSnCtrl.stockAccountingType == \"BY_SERIAL_NUMBERS\")? \'Серийный номер\' : \'Партия\'}} уже {{(lotSnCtrl.stockAccountingType == \"BY_SERIAL_NUMBERS\")? \'добавлен\' : \'добавлена\'}}</div><button type=button ng-if=\"lotSnCtrl.allowAdd && lotSnCtrl.redact\" class=\"btn slim-button only-ico add-lot-sn-btn\" ng-click=lotSnCtrl.addLotSn()><span class=\"btn-ico btn-plus btn-plus-dark\"></span></button><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=disabled-helper ng-if=!lotSnCtrl.item.editable></div><span class=req ng-if=lotSnCtrl.item.required></span><label class=\"form-control-label small-offset\" ng-transclude></label>");
$templateCache.put("app/documents/components/attribute/fields/number/number-field.html","<div class=form-group uib-tooltip=\"{{numberFieldCtrl.item.tooltip}}\"><input class=form-control name=\"{{::numberFieldCtrl.item.code}}\" ng-disabled=\"!numberFieldCtrl.item.editable || numberFieldCtrl.redact === false\" maxlength=30 type=\"{{::numberFieldCtrl.item.only_numbers? \'number\' : \'text\'}}\" focus-request=\"{{::numberFieldCtrl.item.focus}}\" ng-model=numberFieldCtrl.values[numberFieldCtrl.item.code] ng-required=::numberFieldCtrl.item.required ng-show=\"::numberFieldCtrl.item.editable || numberFieldCtrl.item.only_numbers\" ng-keydown=numberFieldCtrl.change(); autocomplete=off><label class=\"form-control-label small-offset\" ng-class=\"::{\'always-top\': !numberFieldCtrl.item.editable}\" ng-hide=::numberFieldCtrl.attributeCtrl.hideLabel ng-bind=::numberFieldCtrl.item.name></label><div class=\"view-entity-control ellipsis\" ng-if=\"::!numberFieldCtrl.item.editable && !numberFieldCtrl.item.only_numbers\" ng-bind=\"numberFieldCtrl.values[numberFieldCtrl.item.code] || \'-\'\" uib-tooltip=\"{{numberFieldCtrl.values[numberFieldCtrl.item.code] || \'\'}}\"></div><i class=req ng-if=\"::numberFieldCtrl.item.required && !numberFieldCtrl.attributeCtrl.hideLabel\"></i><div class=\"valid-message isset-name ng-hide\" style=\"width: 210px; white-space: normal;\">Документ с такими данными уже существует</div><div class=\"valid-message required-mess\" style=\"width: 210px; white-space: normal;\">Поле является обязательным</div></div>");
$templateCache.put("app/documents/components/attribute/fields/price/field-price.html","<div ng-if=\"($ctrl.item.ref[1] && $ctrl.values[$ctrl.item.ref[1]]) || !$ctrl.item.ref[1]\"><input class=\"form-control currency-input\" input-price currency-input type=text autocomplete=off name=\"{{$ctrl.item.code}}\" ng-model=$ctrl.values[$ctrl.item.code] currency-input=true currency-icon=\"{{$ctrl.currencyIcon || $ctrl.defaultCurrency.symbol || $root.homeCurrency.currency.symbol}}\" ng-required=$ctrl.item.required ng-disabled=\"($ctrl.item.ref[1] && !$ctrl.values[$ctrl.item.ref[1]]) || (!$ctrl.item.editable || $ctrl.redact === false)\" ng-class=\"{\'with-caret\' : !$ctrl.simpleField && $ctrl.pricesData.lines[0].prices.length && !$ctrl.close, \'font-italic\': $ctrl.edited}\" ng-change=$ctrl.closeDropDown(); ng-focus=\"$ctrl.getAllPrices(); maxlen = 10;\" ng-blur=\"$ctrl.getAllPrices(); maxlen = 16;\" maxlength=\"{{maxlen}}\"><label class=\"form-control-label small-offset\" ng-hide=$ctrl.hideLabel ng-bind=::$ctrl.item.name></label><div class=\"valid-message error-max-mess\">Значение превышает сумму платежа</div><i class=req ng-if=\"::$ctrl.item.required && !$ctrl.hideLabel\"></i> <span class=\"caret ng-hide\" ng-hide=\"$ctrl.simpleField || !$ctrl.pricesData.lines[0].prices.length || $ctrl.close\"></span><ul class=\"dropdown-menu custom-dropdown\" ng-hide=\"$ctrl.simpleField || !$ctrl.pricesData.lines[0].prices.length || $ctrl.close\"><li ng-repeat=\"priceObj in $ctrl.pricesData.lines[0].prices\" ng-mousedown=$ctrl.choosePrice(priceObj)><span class=ellipsis ng-bind=priceObj.name title=\"{{priceObj.name}}\"></span> <span> {{priceObj.price / 100}} <span ng-bind=$ctrl.externalData[$ctrl.item.ref[0]].symbol></span></span></li></ul></div>");
$templateCache.put("app/documents/components/attribute/fields/quantity/quantity-field.html","<div class=form-group uib-tooltip=\"{{((quantityFieldCtrl.hint)? quantityFieldCtrl.hint : (quantityFieldCtrl.needMarks && quantityFieldCtrl.amcsList)? quantityFieldCtrl.amcsList : \'\')}}\"><input class=form-control ng-hide=\"!quantityFieldCtrl.needMarks && !quantityFieldCtrl.redact && quantityFieldCtrl.item.noZeroes\" float-input float-fixed=2 max-int-length=9 empty-values=::true no-empty=::!quantityFieldCtrl.item.noZeroes float-step=0.01 max-after-comma=\"::quantityFieldCtrl.item.max_after_comma === undefined? 3 : quantityFieldCtrl.item.max_after_comma\" selection-on-focus=\"[\'1\', 1]\" name=\"{{::quantityFieldCtrl.item.code}}\" ng-disabled=\"!quantityFieldCtrl.item.editable ||\n          quantityFieldCtrl.redact === false ||\n          \'BY_SERIAL_NUMBERS\' == quantityFieldCtrl.stockAccountingType\" ng-model=quantityFieldCtrl.universalSetterGetter ng-model-options=\"::{getterSetter: true }\" ng-required=::quantityFieldCtrl.item.required ng-change=quantityFieldCtrl.checkError(); ng-hide=\"::quantityFieldCtrl.needMarks && !quantityFieldCtrl.item.editable\" ng-blur=quantityFieldCtrl.onblur() autocomplete=off><label class=\"form-control-label small-offset\" ng-bind=::quantityFieldCtrl.item.name></label><div class=\"valid-message required-mess\">Поле является обязательным</div><!--  Вызов марок, если ЕСТЬ первоисточник по этим маркам - ТТН (марки зашиты внутри) или акт списания (марки числящиеся на складе) --><div class=disabled-helper ng-if=\"quantityFieldCtrl.needMarks && !quantityFieldCtrl.item.noSource && quantityFieldCtrl.item.editable && quantityFieldCtrl.redact\" ng-click=quantityFieldCtrl.showMarkViewModal(); style=\"height: 100%; width: 100%; position: absolute; top: 0;\"></div><!--  Вызов марок, если НЕТ первоисточника по этим маркам, то есть мы изначально не знаем сколько их есть в наличии --><div class=disabled-helper ng-if=\"quantityFieldCtrl.item.noSource && quantityFieldCtrl.needMarks && quantityFieldCtrl.item.editable && quantityFieldCtrl.redact\" ng-click=quantityFieldCtrl.showMarksWithoutSourse(); style=\"height: 100%; width: 100%; position: absolute; top: 0;\"></div><div class=\"valid-message not-found-mark-mess\" ng-bind=quantityFieldCtrl.item.$errorObj.error></div><div class=\"view-entity-control ellipsis link-style text-right\" ng-if=\"::quantityFieldCtrl.needMarks && !quantityFieldCtrl.item.editable\" ng-bind=quantityFieldCtrl.universalSetterGetter() ng-click=quantityFieldCtrl.showMarkViewModal(); style=\"text-align: right\"></div><div class=\"view-entity-control ellipsis text-right\" ng-if=\"!quantityFieldCtrl.needMarks && !quantityFieldCtrl.redact && quantityFieldCtrl.item.noZeroes\" ng-bind=\"quantityFieldCtrl.universalSetterGetter() || \'-\'\"></div><i class=req ng-if=\"::quantityFieldCtrl.item.required && !quantityFieldCtrl.hideLabel\"></i></div>");
$templateCache.put("app/documents/components/attribute/fields/select/select-field.html","<div tooltip=\"{{::vm.selectMatchPatern}}\" ng-style=\"{\'background\': (vm.invalid)? \'#fff1f1\' : \'transparent\'}\" ng-if=\"!(vm.item.field_type == \'FLD_EXPENSE_ITEM\' && hide) && !vm.hideField\"><ui-select ng-model=vm.values[vm.item.code] name=\"{{::vm.item.code}}\" ng-disabled=\"(vm.item.non_editable_purposes &&\n                vm.item.non_editable_purposes.indexOf(vm.purpose) != -1) ||\n                (!vm.item.editable || !vm.redact)\" ng-required=::vm.item.required search-enabled=vm.searchEnabled class=tooltip-light tooltip=\"{{::vm.selectMatchPatern}}\" on-select=\"vm.change($select.selected, $select)\" on-remove=::vm.removed() ng-class=\"::{\'autocomplete-select\': vm.dynamicTotal > vm.amount && vm.searchEnabled, \'create-new-item\': vm.item.create_new_item}\" ignore-dirty=\"{{::vm.resetDirty}}\"><ui-select-match allow-clear=\"{{::!vm.item.required}}\"><span bind-html-compile=::vm.selectMatchPatern title-ext=::vm.selectMatchPatern></span></ui-select-match><ui-select-choices refresh-delay=100 refresh=\"vm.refresh($select.search, $select)\" repeat=\"item in (vm.items | filter: $select.search) track by $index\" group-by=vm.totalStr><span ng-hide=\"vm.item.create_new_item && $index == (vm.items.length - 1)\" bind-html-compile=::vm.selectChoicesPatern title-ext=::vm.selectChoicesPatern></span> <span ng-if=\"vm.item.create_new_item && $index == (vm.items.length - 1)\"><span class=\"link-style create-link text-italic ellipsis\" ng-click=\"vm.toCreateItem($event, $select);\" ng-bind=::vm.createStr></span></span></ui-select-choices><ui-select-no-choice> {{::$root.controlSettings.NOT_FOUND_STRING}} <div ng-if=::vm.item.create_new_item><span class=\"link-style create-link text-italic ellipsis\" ng-click=\"vm.toCreateItem($event, $select);\" ng-bind=::vm.createStr></span></div></ui-select-no-choice></ui-select><div class=disabled-helper ng-if=::!vm.item.editable></div><span class=req ng-if=::vm.item.required></span><label class=\"form-control-label small-offset\" ng-transclude></label><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message foreign-organizations\">Замените производителя (иностранную организацию) на импортера</div><div class=\"valid-message isset-name\" ng-bind=\"(vm.isDivisonUniq)? \'Отправитель и получатель не могут совпадать\' : \'Документ с такими данными уже существует\'\"></div></div>");
$templateCache.put("app/documents/components/attribute/fields/select/simple-select.html","<div ng-show=vm.show><ui-select ng-model=vm.values[vm.item.code] name=\"{{vm.item.code}}\" ng-disabled=\"!vm.item.editable || !vm.redact\" ng-required=\"vm.item.required && vm.show\" class=tooltip-light on-select=vm.change($select.selected) on-remove=vm.change()><ui-select-match allow-clear=\"{{!vm.item.required}}\"><span ng-bind=\"$select.selected.label || $select.selected.name || $select.selected\" title=\"{{$select.selected}}\"></span></ui-select-match><ui-select-choices repeat=\"item in vm.data\"><span ng-bind=\"item.label || item.name || item\" ng-style=\"(item.value == \'MONTH\')?{\'padding-left\': \'25px\'} : \'\'\"></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\" ng-transclude></label><span class=req ng-if=vm.item.required></span><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=\"view-entity-control ng-hide\" ng-if=vm.show ng-bind=\"vm.getViewStr() || vm.values[vm.item.code] || \'-\'\"></div>");
$templateCache.put("app/documents/components/attribute/fields/simplified-content/simplified-content.html","<div ng-hide=simplifiedContentCtrl.hideField><input class=form-control ng-model=simplifiedContentCtrl.values[simplifiedContentCtrl.item.code] ng-required=::simplifiedContentCtrl.item.required ng-show=simplifiedContentCtrl.redact autocomplete=off maxlength=150><div class=\"view-entity-control ng-hide\" ng-bind=\"simplifiedContentCtrl.values[simplifiedContentCtrl.item.code].name || \'-\'\" uib-tooltip=\"{{simplifiedContentCtrl.values[simplifiedContentCtrl.item.code].name}}\"></div><label class=\"form-control-label small-offset\" ng-hide=simplifiedContentCtrl.hideLabel ng-bind=::simplifiedContentCtrl.item.name ng-class=\"{\'always-top\': !simplifiedContentCtrl.item.editable || simplifiedContentCtrl.redact === false}\"></label><div class=\"view-entity-control ellipsis\" ng-if=\"!simplifiedContentCtrl.item.editable || simplifiedContentCtrl.redact === false\" ng-bind=\"simplifiedContentCtrl.values[simplifiedContentCtrl.item.code] || \'-\'\" uib-tooltip=\"{{simplifiedContentCtrl.values[simplifiedContentCtrl.item.code] || \'\'}}\"></div><i class=req ng-if=\"::simplifiedContentCtrl.item.required && !simplifiedContentCtrl.hideLabel\"></i></div>");
$templateCache.put("app/documents/components/attribute/fields/skuModalInfo/sku-modal-info-popup.html","<div class=catalog-item-modal-inform><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=skuModalInfoCtrl.close()></button><h3 class=modal-title>Сведения об алкоголе</h3></div><div class=container><div ng-if=skuModalInfoCtrl.load><div class=ui-spinner></div></div><div class=\"gray-content clearfix\" ng-if=!skuModalInfoCtrl.load ng-scrollbars ng-scrollbars-config=skuModalInfoCtrl.configScroll><div class=col-xs-6><h4>Алкогольная продукция</h4><div class=row><div class=\"col-xs-5 text-right\">Наименование:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.full_name || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Алкокод:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.alc_code || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Объем:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.capacity || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Крепость:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.alc_volume || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Упаковка:</div><div class=col-xs-7 ng-bind=\"(skuModalInfoCtrl.data.alco_packed_type == \'PACKED\')? \'В единичной упаковке\' : \'Без единичной упаковки\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Код продукции:</div><div class=col-xs-7 ng-bind=\"(skuModalInfoCtrl.data.alcohol_product_classifier)? skuModalInfoCtrl.data.alcohol_product_classifier.code + \' (\' + skuModalInfoCtrl.data.alcohol_product_classifier.name + \')\' : \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Штрих-код:</div><div class=col-xs-7><span ng-if=!skuModalInfoCtrl.data.ean13>-</span><barcode ng-if=skuModalInfoCtrl.data.ean13 background-color=#f6f6f6 value=skuModalInfoCtrl.data.ean13></barcode></div></div><!-- <div ng-if=\"!skuModalInfoCtrl.resolve.hide_form2\">\n          <h4 class=\"mt-3\">Сведения ЕГАИС</h4>\n          <div class=\"row\">\n            <div class=\"col-xs-5 text-right\">Справка 1:</div>\n            <div class=\"col-xs-7\" ng-bind=\"skuModalInfoCtrl.data.f1_reg_id || skuModalInfoCtrl.resolve.line.f1_reg_id || \'-\'\"></div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-xs-5 text-right\">Справка 2:</div>\n            <div class=\"col-xs-7\" ng-bind=\"skuModalInfoCtrl.data.f2_reg_id || skuModalInfoCtrl.resolve.line.f2_reg_id || \'-\'\"></div>\n          </div>\n        </div> --></div><div class=col-xs-6><h4>Производитель</h4><div class=row><div class=\"col-xs-5 text-right\">ФСРАР ИД:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.client_reg_id || skuModalInfoCtrl.data.producer.client_reg_id || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Наименование:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.producer_full_name || skuModalInfoCtrl.data.producer.full_name || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">ИНН:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.inn || skuModalInfoCtrl.data.producer.inn || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">КПП:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.kpp || skuModalInfoCtrl.data.producer.kpp || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Адрес:</div><div class=col-xs-7 ng-bind=\"skuModalInfoCtrl.data.address || skuModalInfoCtrl.data.producer.address || \'-\'\"></div></div></div><div class=col-xs-12><h4 ng-if=skuModalInfoCtrl.data.history_f2_reg_lines.length class=mt-3>История по справке 2</h4><div class=row><div class=\"step col-xs-6\" ng-repeat=\"line in skuModalInfoCtrl.data.history_f2_reg_lines\"><div class=row><div class=\"col-xs-5 text-right\">Шаг:</div><div class=col-xs-7 ng-bind=\"line.lev + 1 || \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Получатель:</div><div class=col-xs-7 ng-bind=\"line.consignee_id|| \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Отправитель:</div><div class=col-xs-7 ng-bind=\"line.shipper_id|| \'-\'\"></div></div><div class=row><div class=\"col-xs-5 text-right\">Количество:</div><div class=col-xs-7 ng-bind=\"line.amount|| \'-\'\"></div></div></div></div></div></div></div><div class=modal-footer><button class=btn ng-click=skuModalInfoCtrl.close()>Закрыть</button></div></div>");
$templateCache.put("app/settings/components/filters/modals/allFilters/all-filters.html","<div class=\"modal fade filter-popup\" id=filter-popup role=dialog style=\"overflow: hidden\"><div class=\"modal-dialog modal-middle-width\"><div class=modal-content><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть data-dismiss=modal>&times;</button><h3 class=modal-title>Все фильтры</h3></div><div class=container><form class=row role=form name=filterForm ng-scrollbars ng-scrollbars-config=configScroll><div ng-repeat=\"filter in filterMeta\" class=\"col-md-{{filter.size}}\" ng-class=\"{empty: filter.type == \'empty\'}\" ng-style=\"(filter.type == \'empty\')? {\'min-height\': \'71px\'} : \'\'\"><div ng-switch=filter.type class=form-group><div ng-switch-when=text><input type=text clear-button class=form-control id=\"{{filter.id}}\" name=\"{{filter.id}}\" ng-model=filterData[filter.id]><label for=\"{{filter.id}}\" class=\"form-control-label small-offset\" ng-bind=filter.name></label></div><div ng-switch-when=number><input type=text clear-button hard-pruning data-check=([0-9])+ ng-pattern=/\\d/ class=form-control name=\"{{filter.id}}\" ng-model=filterData[filter.id] id=\"{{filter.id}}\"><label for=\"{{filter.id}}\" class=\"form-control-label small-offset\" ng-bind=filter.name></label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ</div></div><div ng-switch-when=select><ui-select ng-model=filterData[filter.id] search-enabled=false on-select=\"onSelect($select.selected, filter.id)\"><ui-select-match allow-clear=true title=\"{{$select.selected.label}}\"><span ng-bind=$select.selected.label></span></ui-select-match><ui-select-choices position=\"{{(filter.position)? filter.position : \'down\'}}\" repeat=\"item.value as item in (filter.selectVal | filter: $select.search) track by $index\"><div ng-bind=item.label title=\"{{item.label}}\"></div></ui-select-choices></ui-select><label class=\"form-control-label small-offset\" ng-bind=filter.name></label></div><div ng-switch-when=multipleSelect><multiselect class=multiselect ng-model=filterData[filter.id] options=filter.selectVal show-search=false display-prop=label id-prop=value model-save-field=value labels=\"{select: filter.name, itemsSelected: (col.filters[0].term.length < 5)? \' значения\' : \' значений\'}\" data-toggle=dropdown ng-disabled=!filter.selectVal></multiselect><!--<label class=\"form-control-label small-offset always-top\" ng-bind=\"filter.name\"></label>--><!-- <ui-select multiple class=\"multiple-select\" ng-model=\"filterData[filter.id]\" theme=\"bootstrap\"\n                           close-on-select=\"false\"\n                           focus-on=\"{{filter.id}}\"\n                           name=\"{{filter.id}}\">\n                  <ui-select-match placeholder=\"Выберите значение\">\n                    <span ng-bind-html=\"$item.label\"></span></ui-select-match>\n                  <ui-select-choices\n                    repeat=\"item.value as item in filter.selectVal\">\n                    <div ng-bind-html=\"item.label\" title=\"{{item.label}}\"></div>\n                  </ui-select-choices>\n                </ui-select> --></div><div ng-switch-when=date><div date-range-picker ng-if=showDateFilters ng-model=filterData[filter.id] opts=\"{singleDatePicker: false, correctTimeZone: filter.correctTimezone || true}\" state=state[filter.id] class=datepicker-wrap name=\"{{filter.id}}\" on-close=\"onDatePickerClose(returnValue, name)\" field-label=filter.name></div></div></div></div></form></div><div class=modal-footer><button class=btn role=button data-toggle=modal data-target=#filter-popup ng-click=cleanFilter()>Очистить</button> <button type=submit class=\"btn btn-primary\" role=button ng-click=prepareApply();applyFilter(filterData) data-toggle=modal data-target=#filter-popup>Применить</button></div></div></div></div>");
$templateCache.put("app/settings/components/filters/modals/saveFilter/save-filter.html","<div class=save-filter-popup id=save-filter-popup><!-- Modal content--><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>&times;</button><h3 class=modal-title ng-bind=\"title || \'Сохранение фильтра\'\"></h3></div><form role=form name=saveFilterForm novalidate><div class=container><p class=text-muted ng-if=!description>Вы можете сохранить часто используемые фильтры для быстрого поиска информации в таблицах. Найти сохраненные фильтры можно нажав на <span class=caret></span> рядом с кнопкой фильтра</p><p class=text-muted ng-if=description ng-bind-html=description></p><div class=form-group><input type=text check-filter-name-existing target-filter=filterObj class=form-control name=filterName id=filterName required minlength=1 ng-model=filterName><label for=filterName class=\"form-control-label small-offset\">Название</label><div ng-show=\"(saveFilterForm.$submitted || saveFilterForm.filterName.$touched)\" ng-messages=saveFilterForm.filterName.$error><div class=valid-message ng-message=required>Поле является обязательным</div><div class=valid-message ng-message=filterExists>Такой фильтр уже существует</div></div></div></div><div class=modal-footer><button role=button class=btn ng-click=close() type=reset>Отменить</button> <button role=button class=\"btn btn-primary btn-link-main\" ng-click=save(saveFilterForm) type=submit ng-disabled=!saveFilterForm.$valid>Сохранить</button></div></form></div>");
$templateCache.put("app/settings/discounts/crudDiscount/discountDirectives/calendar/discountCalendar.html","<section class=\"col-xs-9 calendars\" ng-class=\"{\'slide-up\': vm.hideCalendar}\" ng-style=\"(mode.isView)? {\'max-height\': \'613px\'} : \'\'\" style=\"padding-right: 1px;\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideCalendar)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideCalendar = !vm.hideCalendar\" ng-show=mode.isView style=\"margin-right: 15px;\"></span><h5 class=section-header>КАЛЕНДАРЬ ДЕЙСТВИЯ</h5><div style=\"display: flex\"><div class=\"form-group no-fixed-width-group\" ng-if=!mode.isView><div class=datepicker-wrap><div date-range-picker ng-model=vm.effective_date opts=vm.dateOptsStart state=effective_date_state class=datepicker-wrap ng-required=true name=effective_date on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата начала\'\"></div><div ng-messages=formCtrl.effective_date.$error ng-if=\"!vm.stateName.endsWith(\'view\')\"><div ng-message=unique class=\"valid-message isset-name\">Скидочная акция уже существует</div></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div></div><div class=\"form-group col-xs-6\" ng-if=mode.isView><label class=form-control-label>Дата начала</label><div class=view-entity-control ng-bind=\"vm.effective_date.valueOf() | date: \'dd.MM.yyyy\' : \'UTC\'\">-</div></div><div class=\"form-group fixed-width-group\" ng-if=!mode.isView><div date-range-picker ng-model=vm.expire_date opts=vm.dateOptsEnd state=expire_dateState class=datepicker-wrap name=expire_date on-close=\"vm.onDatePickerClose(returnValue, name)\" field-label=\"\'Дата окончания\'\"></div></div><div class=\"form-group col-xs-6\" ng-if=mode.isView><label class=form-control-label>Дата окончания</label><div class=view-entity-control ng-bind=\"(vm.expire_date.isEmpty)? \'-\' : vm.expire_date.valueOf() | date: \'dd.MM.yyyy\' : \'UTC\'\"></div></div></div><div style=\"display: flex\"><div class=\"form-group no-fixed-width-group\"><ui-select ng-model=vm.calendarType search-enabled=false on-select=vm.changeTimetable(vm.calendarType) ng-required=true ng-hide=mode.isView><ui-select-match><span ng-bind-html=$select.selected.name></span></ui-select-match><ui-select-choices refresh-delay=100 repeat=\"type.id as type in vm.timetable track by $index\"><span ng-bind-html=type.name></span></ui-select-choices></ui-select><label class=\"form-control-label small-offset\" ng-hide=mode.isView>Дни действия</label><span class=req></span></div><div class=\"form-group fixed-width-group\"></div></div><div class=\"timetable-wrapper clearfix\"><div class=\"calendar-thead pull-right\"><span>Время продажи</span> <span ng-hide=mode.isView>C</span> <span ng-hide=mode.isView>До</span></div><div class=clear></div><div class=\"calendar-tbody clearfix\" ng-repeat=\"item in discount.times\" ng-if=\"item.day_type != \'EXCEPTIONAL_DATE\'\"><div class=day-name ng-class=\"{\'weekend\': item.day == 5 || item.day == 6}\" ng-switch=item.day_type><span ng-switch-when=ANY_DAY>Ежедневно</span> <span ng-switch-when=DAY_OF_WEEK ng-bind=vm.getDayStr(item.day);></span> <span ng-switch-when=WORKING_DAY>По будням</span> <span ng-switch-when=DAY_OFF>По выходным</span> <span class=req></span></div><div class=\"day-options pull-right\"><div class=time-mode ng-hide=\"mode.isView && item.$$mode == \'interval\'\"><ui-select ng-model=item.$$mode search-enabled=false ng-required=true on-change=vm.changeMode(item); ng-disabled=mode.isView class=slim-control><ui-select-match><span ng-bind=$select.selected.name></span></ui-select-match><ui-select-choices repeat=\"mode.id as mode in vm.calendarsMode\"><span ng-bind=mode.name></span></ui-select-choices></ui-select></div><div class=interval ng-if=\"item.$$mode == \'interval\'\"><span class=time-wrapper><input empty-to-null type=text class=\"form-control slim-control\" name=\"with{{item.id}}\" ng-model=item.from_hour required ng-pattern=/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ ui-mask=99:99 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-disabled=item.$$noSell ng-change=vm.checkTime(item) model-view-value=\"{{true}}\" ng-disabled=mode.isView> </span><span class=time-wrapper><input empty-to-null type=text class=\"form-control slim-control\" name=\"to{{item.id}}\" ng-model=item.upto_hour required ng-pattern=/^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/ ui-mask=99:99 ui-options=\"{clearOnBlur: false, addDefaultPlaceholder: false}\" ng-disabled=item.$$noSell ng-change=vm.checkTime(item) model-view-value=\"{{true}}\" ng-disabled=mode.isView></span></div></div></div></div></section>");
$templateCache.put("app/settings/discounts/crudDiscount/discountDirectives/parameters/discountParameters.html","<section ng-form=vm.discountParamentsForm class=\"col-xs-9 discount-parameters\" ng-class=\"{\'slide-up\': vm.hideParameter}\" ng-style=\"(mode.isView)? {\'max-height\': \'650px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideParameter)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideParameter = !vm.hideParameter\" ng-show=mode.isView></span><h5 class=section-header>ПАРАМЕТРЫ <span class=req></span></h5><div class=empty-param ng-if=!parameter ng-class=\"{\'has-error\': noParam}\"><span class=btn ng-click=vm.openPropertyPopup()>Выбрать тип скидочной акции</span></div><div class=shares-types ng-if=parameter><div class=\"col-xs-3 discount-img\"></div><div class=\"col-xs-8 discount-info\"><h5 class=discount-name ng-bind=parameter.name></h5><div class=discount-descr ng-bind=parameter.description></div><span class=\"discount-example tooltip-light\" tooltip-placement=right uib-tooltip=\"{{parameter.example}}\" ng-if=parameter.example>Подсказка</span></div><div class=col-xs-2 ng-hide=mode.isView><span class=\"btn pencil tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Изменить тип акции\" ng-click=vm.openPropertyPopup()></span></div><div class=clear></div><div ng-switch=vm.metaType class=property-data><div ng-switch-when=PROC_FOR_EACH_NTH_UNIT_IN_ONE_LINE|PROC_FOR_EACH_NTH_UNIT_IN_CASH_RECEIPT ng-switch-when-separator=| ng-if=\"(parameter.type == \'PROC_FOR_EACH_NTH_UNIT_IN_ONE_LINE\' && parameter.unitSeqNum != 1) || parameter.type == \'PROC_FOR_EACH_NTH_UNIT_IN_CASH_RECEIPT\'\"><table><tr><!-- <th>Порядковый номер товара <span class=\"req\"></span></th> --><th>Размер скидки <span class=req></span></th><th width=25></th></tr><tr ng-repeat=\"item in parameter.units\"><!-- <td valign=\"top\">\n              <input empty-to-null ng-change=\"vm.checkUniqueNumber(item.unit_seq_num, $index)\" name=\"{{\'unit_seq_num\' + $index}}\" required hard-pruning pattern=\"[0-9]*\" type=\"text\" class=\"form-control slim-control\" maxlength=\"128\" ng-model=\"item.unit_seq_num\" float-input max-val=\"100\" float-fixed=\"0\" float-step=\"1\" max-after-comma=\"0\">\n              <div class=\"valid-message required-mess\">Поле является обязательным</div>\n              <div ng-if=\"vm.discountParamentsForm[\'unit_seq_num\' + $index].$error.unique\" class=\"valid-message isset-name\">Номер уже существует</div>\n              <div class=\"valid-message max-mess\">Максмальное значение 100</div>\n            </td> --><td valign=top ng-if=!mode.isView><input required float-input float-fixed=2 float-step=1 max-after-comma=0 currency-input=true currency-icon=% type=text class=\"form-control currency-input slim-control\" maxlength=15 ng-model=item.proc_value max-val=100 no-empty=::true> <span class=currency-input-addon></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message max-mess\">Максмальное значение 100</div></td><td valign=top ng-show=mode.isView ng-bind=\"(item.proc_value | parseNumber) + \'%\'\"></td><td><span class=\"glyphicon glyphicon-trash tooltip-light\" tooltip-placement=right uib-tooltip=Удалить ng-click=vm.removeDiscount($index); ng-if=\"parameter.units.length > 1\"></span></td></tr></table><div class=add-item-wrap ng-click=vm.addDiscount(); ng-hide=\"mode.isView || vm.metaType == \'PROC_FOR_EACH_NTH_UNIT_IN_ONE_LINE\'\"><span class=add-item-icon></span> <span class=add-item-title>Добавить</span></div></div><div ng-switch-when=PROC_ON_ONE class=row><div class=\"form-group col-xs-6\"><input required float-input float-fixed=2 maxlength=15 float-step=1 max-after-comma=0 currency-input=true currency-icon=% type=text class=\"form-control currency-input\" ng-model=parameter.units[0].proc_value max-val=100 id=PROC_ON_ONE no-empty=::true><label for=PROC_ON_ONE class=form-control-label>Размер скидки</label><span class=currency-input-addon></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message max-mess\">Максмальное значение 100</div><span class=req></span></div></div><div ng-switch-when=PROC_FOR_UNIT_FROM_SET class=row><div class=col-xs-7><label for=nomination>Товары или услуги <span class=req></span></label><div class=choosen-goods ng-class=\"{\'has-error\': catalogElementsError}\"><div ng-if=!parameter.discount_set_items.length style=\"padding: 9px 13px;\">Нет значений</div><div ng-repeat=\"catalogItem in parameter.discount_set_items\" class=catalog-item><span class=folder ng-if=\"!catalogItem.catalog_item.type || catalogItem.catalog_item.type == \'CATEGORY\'\"></span> <span class=catalog-item-name ng-bind=catalogItem.catalog_item.name></span></div></div><div class=\"valid-message required-mess\">Поле является обязательным</div></div><div class=col-xs-4><label for=nomination ng-if=\"parameter.type != \'CASHIER_DECIDES_ON_PROC\'\">Размер скидки <span class=req></span></label><span ng-repeat=\"item in parameter.discount_set_items\" ng-if=!mode.isView class=choosen-goods-size><input required float-input float-fixed=2 maxlength=15 float-step=1 max-after-comma=0 currency-input=true currency-icon=% type=text class=\"form-control currency-input slim-control\" maxlength=17 ng-model=item.proc_value max-val=100 no-empty=::true> <span class=currency-input-addon></span><!-- <div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div>\n            <div class=\"valid-message required-mess\">Поле является обязательным</div>\n            <div class=\"valid-message max-mess\">Максмальное значение 100</div> --></span><div ng-if=mode.isView ng-repeat=\"item in parameter.discount_set_items\" ng-bind=\"(item.proc_value | parseNumber) + \'%\'\" class=choosen-goods-size-view></div></div><div class=\"col-xs-1 trachCans\"><div ng-repeat=\"item in parameter.discount_set_items\" class=\"choosen-goods-size trachCan\"><span ng-if=!mode.isView class=\"glyphicon glyphicon-trash tooltip-light\" tooltip-placement=right uib-tooltip=Удалить ng-click=vm.removeDiscountSetItem($index); ng-if=\"parameter.discount_set_items.length > 1\"></span><br></div></div><div class=clear></div><div class=\"add-item-wrap col-xs-12\" ng-click=\"catalogItemPopup(\'discount_set_items\')\" ng-hide=mode.isView><span class=add-item-icon></span> <span class=add-item-title>Добавить</span></div></div><div ng-switch-when=PROC_OF_CASH_RECEIPT_AMOUNT|FIXED_AMOUNT ng-switch-when-separator=| class=row><div class=\"form-group col-xs-6\"><input required input-price maxlength=15 currency-input=true currency-icon=\"{{vm.currency.currency.symbol}}\" type=text class=\"form-control currency-input\" ng-model=parameter.units[0].cash_receipt_amount id=min-summ ng-if=!mode.isView><label for=min-summ class=form-control-label>Минимальная сумма чека</label><span class=\"currency-input-addon currency-font\"></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div ng-if=mode.isView class=view-entity-control> {{parameter.units[0].cash_receipt_amount/100}}<span class=currency-font ng-bind=vm.currency.currency.symbol></span></div><span class=req></span></div><div class=\"form-group col-xs-6\"><div class=percent-currency-wrapper><div class=\"form-group percent-wrap\" ng-show=\"parameter.unit == \'percent\'\"><input required float-input float-fixed=2 maxlength=15 float-step=1 max-after-comma=0 currency-input=true currency-icon=% type=text class=\"form-control currency-input\" ng-model=parameter.units[0].proc_value max-val=100 ng-if=!mode.isView no-empty=::true> <span class=currency-input-addon></span><label for=discount-size class=\"form-control-label small-offset\">Размер скидки</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message max-mess\">Максмальное значение 100</div><div ng-if=mode.isView class=view-entity-control ng-bind=\"(parameter.units[0].proc_value | parseNumber ) + \'%\'\"></div><span class=req></span></div><div class=\"form-group currency-wrap col-xs-12\" ng-show=\"parameter.unit == \'summ\'\"><input required input-price maxlength=15 currency-input=true currency-icon=\"{{vm.currency.currency.symbol}}\" type=text class=\"form-control currency-input\" ng-model=parameter.units[0].fixed_amount no-empty=::true ng-if=!mode.isView> <span class=currency-input-addon></span><label for=discount-size class=\"form-control-label small-offset\">Размер скидки</label><div ng-if=mode.isView class=view-entity-control>{{parameter.units[0].fixed_amount/100}}<span class=currency-font ng-bind=vm.currency.currency.symbol></span></div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div><div style=\"margin-top: 16px;\"><div class=\"radio pull-left\" ng-hide=mode.isView><label><input type=radio name=unit ng-model=parameter.unit value=percent id=percent ng-change=vm.changeUnit()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=\"label-radio pull-left\" for=percent ng-hide=mode.isView>Процентами</label><div class=\"radio pull-left\" ng-hide=mode.isView><label><input type=radio name=unit ng-model=parameter.unit value=summ id=summ ng-change=vm.changeUnit()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=\"label-radio pull-left\" for=summ ng-hide=mode.isView>Суммой</label></div></div></div><div ng-switch-when=CASHIER_DECIDES_ON_PROC|CASHIER_DECIDES_AMOUNT_FOR_SEL_ITEMS ng-switch-when-separator=| class=row><div class=\"form-group col-xs-6\"><div class=percent-currency-wrapper><div class=\"form-group percent-wrap col-xs-12\" ng-show=\"parameter.unit == \'percent\'\"><input required float-input float-fixed=2 maxlength=15 float-step=1 max-after-comma=0 currency-input=true currency-icon=% type=text class=\"form-control currency-input\" ng-model=parameter.units[0].proc_value max-val=100 id=max-size no-empty=::true ng-if=!mode.isView> <span class=currency-input-addon></span><label for=max-size class=\"form-control-label small-offset\">Максимальный размер скидки</label><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message max-mess\">Максмальное значение 100</div><div ng-if=mode.isView class=view-entity-control ng-bind=\"(parameter.units[0].proc_value | parseNumber) + \'%\'\"></div><span class=req></span></div><div class=\"form-group currency-wrap col-xs-12\" ng-show=\"parameter.unit == \'summ\'\"><input required input-price maxlength=15 currency-input=true currency-icon=\"{{vm.currency.currency.symbol}}\" type=text class=\"form-control currency-input\" name=maxDiscountAmount ng-model=parameter.units[0].max_discount_amount ng-change=vm.validateMaxDiscountAmount() no-empty=::true ng-if=!mode.isView id=max-discount-amount> <span class=currency-input-addon></span><label for=max-discount-amount class=\"form-control-label small-offset\">Максимальный размер скидки</label><div ng-if=mode.isView class=view-entity-control>{{parameter.units[0].max_discount_amount/100}}<span class=currency-font ng-bind=vm.currency.currency.symbol></span></div><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess text-origin\">Укажите максимальную сумму скидки</div><div class=\"valid-message min-mess text-origin\">Сумма должна быть больше 0</div><span class=req></span></div></div><div style=\"margin-top: 16px;\"><div class=\"radio pull-left\" ng-hide=mode.isView><label><input type=radio name=cashierUnit ng-model=parameter.unit value=percent id=cashier-percent ng-change=vm.changeUnit()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=\"label-radio pull-left\" for=cashier-percent ng-hide=mode.isView>Процентами</label><div class=\"radio pull-left\" ng-hide=mode.isView><label><input type=radio name=cashierUnit ng-model=parameter.unit value=summ id=cashier-summ ng-change=vm.changeUnit()> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=\"label-radio pull-left\" for=cashier-summ ng-hide=mode.isView>Суммой</label></div></div></div><div ng-switch-when=CASHIER_DECIDES class=row><div class=\"form-group col-xs-6\"><input required float-input float-fixed=2 maxlength=15 float-step=1 max-after-comma=0 currency-input=true currency-icon=% type=text class=\"form-control currency-input\" ng-model=parameter.units[0].proc_value max-val=100 id=discount-size no-empty=::true ng-if=!mode.isView> <span class=\"currency-input-addon currency-font\"></span><div class=\"valid-message wrong-simbol-mess\">Некорректный символ для числа</div><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=\"valid-message max-mess\">Максмальное значение 100</div><label for=discount-size class=form-control-label>Размер скидки</label><div ng-if=mode.isView class=view-entity-control> {{(parameter.units[0].proc_value | parseNumber )}}<span class=currency-font>%</span></div><span class=req></span></div></div></div></div></section>");
$templateCache.put("app/settings/discounts/crudDiscount/discountDirectives/worksFor/discountBelongs.html","<div class=\"clearfix full-width\" ng-hide=\"mode.isView && discount.all_divisions\"><section class=col-xs-9 ng-class=\"{\'slide-up\': vm.hideDivisions}\" ng-style=\"(mode.isView)? {\'max-height\': \'400px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideDivisions)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideDivisions = !vm.hideDivisions\" ng-show=mode.isView></span><h5 class=section-header>действует для ПОДРАЗДЕЛЕНИй</h5><div class=\"row clearfix\" ng-hide=mode.isView><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=divisions ng-model=discount.all_divisions ng-value=true id=divisionAll> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=divisionAll>Все</label></div><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=divisions ng-model=discount.all_divisions ng-value=false id=divisionLimited> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=divisionLimited>Ограниченный список</label></div></div><div class=\"limited-list row\" ng-if=!discount.all_divisions><div class=\"form-group col-xs-12\"><ui-select multiple class=multiple-select ng-model=discount.divisions theme=bootstrap close-on-select=false ng-required=true><ui-select-match placeholder=\"Выберите значение\">{{$item.name + \' - \' + $item.company_name}}</ui-select-match><ui-select-choices repeat=\"division in vm.divisionsData\"><span ng-bind=\"division.name + \' - \' + division.company_name\"></span></ui-select-choices></ui-select><label class=form-control-label ng-hide=mode.isView>Подразделения</label><div class=\"valid-message required-mess\">Поле является обязательным</div><span class=req></span></div></div></section></div><div class=\"clearfix full-width\" ng-hide=\"mode.isView && discount.all_regions\"><section class=col-xs-9 ng-class=\"{\'slide-up\': vm.hideAddresses}\" ng-style=\"(mode.isView)? {\'max-height\': \'400px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideAddresses)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideAddresses = !vm.hideAddresses\" ng-show=mode.isView></span><h5 class=section-header>Действует для Регионов или адресов</h5><div class=\"row clearfix\" ng-hide=mode.isView><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=adresses ng-model=discount.all_regions ng-value=true id=adressesAll> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=adressesAll>Все</label></div><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=adresses ng-model=discount.all_regions ng-value=false id=adressesLimited ng-change=vm.addRegion();> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=adressesLimited>Ограниченный список</label></div></div><div class=\"limited-list row\" ng-if=!discount.all_regions><div class=\"form-group col-xs-12\"><div ng-repeat=\"address in discount.regions\" class=\"clearfix addresses-wrap row\"><address address-data=address.address parent-form=formCtrl mode=\"\'input\'\" truncate=false postal-index=false ng-required=true class=col-xs-11 name=\"\'addr\' + $index\" field-label=\"(mode.isView)? \'\' : \'Регион или адрес\'\" address-controls=address.addressOptions ng-hide=mode.isView></address><div ng-if=mode.isView class=view-entity-control ng-bind=address.address.address_as_string style=\"min-width: 100%;\"></div><span class=\"glyphicon glyphicon-trash\" ng-click=\"vm.removeItemData(discount.regions, $index);\" ng-if=\"discount.regions.length > 1\"></span></div><div class=clear></div><div class=add-item-wrap ng-click=vm.addAddressData(discount.regions); ng-if=!mode.isView><span class=add-item-icon></span> <span class=add-item-title>Поле</span></div></div></div></section></div><div class=\"clearfix full-width\" ng-hide=\"mode.isView && discount.all_catalog_elements\"><section class=col-xs-9 ng-if=\"parameterType != \'PROC_FOR_UNIT_FROM_SET\'\" ng-class=\"{\'slide-up\': vm.hideSkys}\" ng-style=\"(mode.isView)? {\'max-height\': \'400px\'} : \'\'\"><span class=\"glyphicon glyphicon-chevron-up pull-right tooltip-light\" tooltip-placement=left uib-tooltip=\"{{(vm.hideSkys)? \'Показать\' : \'Свернуть\'}}\" ng-click=\"vm.hideSkys = !vm.hideSkys\" ng-show=mode.isView></span><h5 class=section-header>Действует для Товаров и услуг</h5><div class=\"row clearfix\" ng-hide=mode.isView><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=catalogItems ng-model=discount.all_catalog_elements ng-value=true id=catalogItemsAll> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=catalogItemsAll>Все</label></div><div class=col-xs-6><div class=\"radio pull-left\"><label><input type=radio name=catalogItems ng-model=discount.all_catalog_elements ng-value=false id=catalogItemsLimited> <span class=cr><i class=\"cr-icon glyphicon glyphicon-ok\"></i></span></label></div><label class=label-radio for=catalogItemsLimited>Ограниченный список</label></div></div><div class=\"limited-list row\" ng-if=!discount.all_catalog_elements><div class=\"form-group col-xs-12\"><div class=choosen-goods ng-class=\"{\'has-error\': catalogElementsError}\"><label class=form-control-label ng-hide=mode.isView>Товары и услуги</label><div ng-if=!discount.catalog_elements.length style=\"padding: 7px 10px;\">Нет значений</div><div ng-repeat=\"catalogItem in discount.catalog_elements\" class=catalog-item><span class=folder ng-if=\"!catalogItem.type || catalogItem.type == \'CATEGORY\'\"></span> <span class=catalog-item-name ng-bind=catalogItem.name></span> <span class=\"glyphicon glyphicon-trash\" ng-click=\"vm.removeItemData(discount.catalog_elements, $index);\" ng-if=\"discount.catalog_elements.length > 1\"></span></div></div><span class=req></span><div class=\"valid-message required-mess\">Поле является обязательным</div><div class=add-item-wrap ng-click=\"catalogItemPopup(\'catalog_elements\')\" ng-if=!mode.isView><span class=add-item-icon></span> <span class=add-item-title>Товары и услуги</span></div></div></div></section></div>");
$templateCache.put("app/settings/widgets/price-widget/components/price-widget-column/price-widget-column.html","<div ng-form=\"priceWidgetColumn[\'form\' + priceWidgetColumn.column.id]\"><div class=row><span class=\"widget-column-name major-font ellipsis col-xs-10\" ng-bind=priceWidgetColumn.column.name uib-tooltip=\"{{(priceWidgetColumn.column.supplier.name)? \'Действует для поставщика \' + priceWidgetColumn.column.supplier.name : priceWidgetColumn.column.name}}\" tooltip-placement=bottom-left></span><div class=\"add-item-wrap col-xs-2\" ng-click=priceWidgetColumn.addNewPrice() ng-if=\"priceWidgetColumn.redactMode && (priceWidgetColumn.priceListType !== \'RETAIL\' || !priceWidgetColumn.column.prices.length)\" uib-tooltip=\"Добавить цену\" tooltip-placement=bottom-right><span class=add-item-icon></span></div></div><div ng-if=\"!priceWidgetColumn.column.prices.length && !priceWidgetColumn.redactMode\" class=\"widget-price text-right\" style=\"display: block;\">-</div><div class=widget-price ng-repeat=\"price in priceWidgetColumn.column.prices\n       | filter: { $$hide: false}\n       | filter: { $$deleted: false}\n       | limitTo : (priceWidgetColumn.priceListType === \'RETAIL\' ? 1 : priceWidgetColumn.column.prices.length)\"><div class=uom-input-wrapper ng-if=\"priceWidgetColumn.priceListType !== \'RETAIL\' && priceWidgetColumn.redactMode\" style=\"min-width: 28%;\" tooltip=\"{{price.effective_qty}}\"><input class=\"form-control slim-control\" name=\"effective_qty{{$index}}\" integer-input maxlength=15 ng-blur=\"priceWidgetColumn.onQtyChange(price, $index)\" ng-model=price.effective_qty><div class=\"valid-message ng-hide\">Цены с одинаковым параметром</div></div><div ng-style=\"(priceWidgetColumn.priceListType == \'RETAIL\')? {\'min-width\': \'30%\'} : {\'max-width\': \'63px\'}\"><div ng-if=\"!priceWidgetColumn.redactMode || priceWidgetColumn.priceListType == \'RETAIL\'\" ng-bind=\"(priceWidgetColumn.priceListType == \'RETAIL\')? 1 : price.effective_qty\"></div><div ng-bind=\"priceWidgetColumn.uomSymbol + \'.\'\" class=uom></div></div><div class=free-of-control-price style=\"max-width: 50px; min-width: 37px;\"><ui-select ng-model=price.free_of_control_price on-select=\"priceWidgetColumn.onTypeChange(price, $index)\" search-enabled=false class=slim-control ng-if=\"priceWidgetColumn.priceListType !== \'PURCHASE\' && priceWidgetColumn.redactMode\"><ui-select-match><span ng-bind=$select.selected.symbol></span></ui-select-match><ui-select-choices repeat=\"item.value as item in [{value: false, name: \'= Указанная\', symbol: \'=\'}, {value: true, name: \'≥ Свободная\', symbol: \'≥\'}]\"><span ng-bind=item.name></span></ui-select-choices></ui-select></div><div style=\"max-width: 40%; min-width: 40%;\" class=text-right><div class=price-input ng-if=priceWidgetColumn.redactMode><input class=\"form-control currency-input slim-control\" input-price currency-input=true currency-icon=\"{{priceWidgetColumn.column.currency.symbol}}\" min-val=1 name=\"price_for_one_uom{{$index}}\" required tooltip=on ng-blur=\"priceWidgetColumn.onPriceChange(price, $index)\" ng-model=price.price_for_one_uom><div class=\"valid-message ng-hide right-align\">Цены с одинаковым параметром</div></div><div ng-if=!priceWidgetColumn.redactMode><span ng-if=\"price.free_of_control_price && priceWidgetColumn.priceListType !== \'PURCHASE\'\" uib-tooltip=\"свободная цена\">≥</span> <span class=view-price>{{((price.price_for_one_uom / 100) | parseNumber)}}</span><span class=\"currency-font view-currency-font\" ng-bind=priceWidgetColumn.column.currency.symbol></span></div></div><span class=\"glyphicon glyphicon-trash\" ng-if=priceWidgetColumn.redactMode ng-click=\"priceWidgetColumn.removePrice(price, $index)\" uib-tooltip=\"Удалить цену\" tooltip-placement=bottom-right></span></div></div>");
$templateCache.put("app/documents/components/attribute/fields/lot-sn/popup/add-lot-sn.html","<form class=crud-entity name=addLotSn><div class=modal-header><button type=button class=\"close tooltip-light\" tooltip-placement=bottom-right uib-tooltip=Закрыть ng-click=close()>×</button><h3 class=modal-title ng-bind=\"\'Добавление \' + typeStr\"></h3></div><div class=container ng-if=\"type == \'BY_SERIAL_NUMBERS\'\"><div class=row><!-- для серии --><div class=\"form-group col-xs-12\"><input type=text class=form-control ng-model=createdValue.number required><label class=form-control-label>Серийный номер</label><span class=req></span></div></div></div><div class=container ng-if=\"type.startsWith(\'BY_LOTS\')\"><div class=row><!-- для партии --><div class=\"form-group col-xs-12\"><input type=text class=form-control ng-model=createdValue.lot_number required><label class=form-control-label>Номер партии</label><span class=req></span></div><div class=\"form-group col-xs-12\"><div date-range-picker state=state_manufacture_date ng-model=createdValue.$$manufacture_date opts=\"{singleDatePicker: true, correctTimeZone: false}\" class=datepicker-wrap name=manufacture_date field-label=\"\'Дата производства\'\"></div></div><div class=\"form-group col-xs-12\" ng-class=\"(addLotSn.manufacture_date.$modelValue && addLotSn.manufacture_date.$valid && createdValue.$$expiration_date.valueOf() < createdValue.$$manufacture_date.valueOf()) ? \'wrong-valid-date-wrap\' : \'\'\"><div ng-show=addLotSn.manufacture_date.$modelValue date-range-picker state=state_expiration_date ng-model=createdValue.$$expiration_date opts=\"{ singleDatePicker: true,\n                     correctTimeZone: false,\n                     minDate: createdValue.$$manufacture_date,\n                   }\" class=datepicker-wrap name=expiration_date on-close=\"\" ng-required=\"type === \'BY_LOTS_FEFO\'\" field-label=\"\'Срок годности\'\"></div><div ng-show=!addLotSn.manufacture_date.$modelValue date-range-picker state=state_expiration_date ng-model=createdValue.$$expiration_date opts=\"{\n                    singleDatePicker: true,\n                    correctTimeZone: false\n                  }\" class=datepicker-wrap name=expiration_date on-close=\"\" ng-required=\"type === \'BY_LOTS_FEFO\'\" field-label=\"\'Срок годности\'\"></div></div></div></div><div class=modal-footer><button class=btn type=button ng-click=close()>Отменить</button> <button class=\"btn btn-primary\" ng-disabled=addLotSn.$invalid type=button ng-click=save() style=\"width: auto;\">Создать</button></div></form>");
$templateCache.put("app/documents/components/attribute/fields/stockQuantity/field/stock-quantity-field.html","<div class=\"form-group text-left\" style=\"margin-top: 6px;\" ng-bind=\"stockQuantityField.values[stockQuantityField.item.code] || 0\"></div>");
$templateCache.put("app/documents/components/attribute/fields/totals/common-totals/totals-field.html","<div><!-- в поле ref содержится массив, в т.ч. ссылкана линейки (первая зависимость) и вторая ссылка на выбранную валюту --><div class=clearfix ng-if=\"totalsFieldCtrl.documentCtrl.currencyHome.currency_id\n       !== totalsFieldCtrl.externalData[totalsFieldCtrl.item.ref[1]].id\"><div class=col-xs-6>Итого, <span ng-bind=\"totalsFieldCtrl.externalData.natural_currency.symbol || $root.homeCurrency.currency.symbol\"></span></div><div class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.values[totalsFieldCtrl.item.code].natural_amount, totalsFieldCtrl.externalData.natural_currency.char_iso_code);}} </div></div><div class=clearfix><div class=col-xs-6>Итого, <span ng-bind=\"totalsFieldCtrl.documentCtrl.currencyHome.currency.symbol || $root.homeCurrency.currency.symbol\"></span></div><div class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.values[totalsFieldCtrl.item.code].home_amount, totalsFieldCtrl.documentCtrl.currencyHome.currency.char_iso_code);}} </div></div><div class=\"clearfix collapsed\" ng-if=\"totalsFieldCtrl.documentCtrl.currencyHome.currency_id !== totalsFieldCtrl.externalData[totalsFieldCtrl.item.ref[1]].id && totalsFieldCtrl.withTaxes\" data-toggle=collapse data-target=#natural_tax_amount><span class=\"collapse-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Показать/скрыть детализацию\"></span><div class=col-xs-6>Сумма налога, <span ng-bind=totalsFieldCtrl.externalData[totalsFieldCtrl.item.ref[1]].symbol></span></div><div class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.values[totalsFieldCtrl.item.code].natural_tax_amount, totalsFieldCtrl.externalData[totalsFieldCtrl.item.ref[1]].char_iso_code);}} </div></div><div id=natural_tax_amount class=\"collapse tax-summs\" ng-if=totalsFieldCtrl.withTaxes><span class=clearfix ng-repeat=\"(name, summ) in totalsFieldCtrl.values[totalsFieldCtrl.item.code].natural_tax_amounts\"><span class=col-xs-6 ng-bind=name></span> <span class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(summ, totalsFieldCtrl.externalData[totalsFieldCtrl.item.ref[1]].char_iso_code);}}</span></span></div><div class=\"clearfix collapsed\" data-toggle=collapse data-target=#home_tax_amount ng-if=totalsFieldCtrl.withTaxes><span class=\"collapse-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Показать/скрыть детализацию\"></span><div class=col-xs-6>Сумма налога, <span ng-bind=totalsFieldCtrl.documentCtrl.currencyHome.currency.symbol></span></div><div class=\"col-xs-6 text-right\"> {{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.values[totalsFieldCtrl.item.code].home_tax_amount, totalsFieldCtrl.documentCtrl.currencyHome.currency.char_iso_code);}} </div></div><div id=home_tax_amount class=\"collapse tax-summs\" ng-if=totalsFieldCtrl.withTaxes><span class=clearfix ng-repeat=\"(name, summ) in totalsFieldCtrl.values[totalsFieldCtrl.item.code].home_tax_amounts\"><span class=col-xs-6 ng-bind=name></span> <span class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(summ, totalsFieldCtrl.documentCtrl.currencyHome.currency.char_iso_code)}}</span></span></div></div>");
$templateCache.put("app/documents/components/attribute/fields/totals/multiple-total/multiple-total.html","<div class=ellipsis style=\"padding: 7px 5px 0; margin: 0px -5px;\" ng-bind=multipleTotalCtrl.universalSetterGetter(); uib-tooltip=\"{{multipleTotalCtrl.universalSetterGetter();}}\" ng-style=\"{\'background\': (multipleTotalCtrl.invalid)? \'#fff1f1\' : \'transparent\'}\"></div>");
$templateCache.put("app/documents/components/attribute/fields/totals/total-amount/total-amount.html","<div><!-- в поле ref содержится массив с полями, значение которых необходимо перемножить и вывести --><div class=clearfix><div class=col-xs-6>{{totalsAmountCtrl.item.name}}, <span class=currency-font ng-bind=totalsAmountCtrl.externalData.natural_currency.symbol></span></div><div class=\"col-xs-6 text-right\" ng-bind=\"(totalsAmountCtrl.values[totalsAmountCtrl.item.code])? (totalsAmountCtrl.values[totalsAmountCtrl.item.code]/100 | priceFormatter:totalsAmountCtrl.externalData.natural_currency.char_iso_code) : 0\"></div></div></div>");
$templateCache.put("app/documents/components/attribute/fields/totals/totals-advance-report/totals-advance-report.html","<div><div class=clearfix ng-if=totalsFieldCtrl.values[totalsFieldCtrl.item.ref[0]].length><div class=col-xs-6>Выдано, <span class=currency-font ng-bind=$root.homeCurrency.currency.symbol></span></div><div class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.values.totals[totalsFieldCtrl.advances], $root.homeCurrency.currency.char_iso_code);}} </div></div><div class=clearfix ng-if=totalsFieldCtrl.values[totalsFieldCtrl.item.ref[1]].length><div class=col-xs-6>Израсходовано, <span class=currency-font ng-bind=$root.homeCurrency.currency.symbol></span></div><div class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.values.totals[totalsFieldCtrl.costs], $root.homeCurrency.currency.char_iso_code);}} </div></div><div class=clearfix ng-if=\"totalsFieldCtrl.isPositive && totalsFieldCtrl.values[totalsFieldCtrl.item.ref[0]].length && totalsFieldCtrl.values[totalsFieldCtrl.item.ref[1]].length\"><div class=col-xs-6>Остаток, <span class=currency-font ng-bind=$root.homeCurrency.currency.symbol></span></div><div class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.difference, $root.homeCurrency.currency.char_iso_code);}} </div></div><div class=clearfix ng-if=\"!totalsFieldCtrl.isPositive && totalsFieldCtrl.values[totalsFieldCtrl.item.ref[0]].length && totalsFieldCtrl.values[totalsFieldCtrl.item.ref[1]].length\"><div class=col-xs-6>Перерасход, <span class=currency-font ng-bind=$root.homeCurrency.currency.symbol></span></div><div class=\"col-xs-6 text-right\">{{totalsFieldCtrl.getPriceStr(totalsFieldCtrl.difference, $root.homeCurrency.currency.char_iso_code);}} </div></div></div>");
$templateCache.put("app/documents/components/attribute/fields/totals/totals-amounts/totals-amounts.html","<div ng-if=totalsAmountsCtrl.withTaxes><div class=clearfix ng-if=\"totalsAmountsCtrl.documentCtrl.currencyHome.currency_id\n       !== totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[0]].id\"><div class=col-xs-6>{{totalsAmountsCtrl.item.name}}, <span ng-bind=totalsAmountsCtrl.documentCtrl.currencyHome.currency.symbol></span></div><div class=\"col-xs-6 text-right\">{{ (totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].home_amount || 0)/100 | priceFormatter:totalsAmountsCtrl.documentCtrl.currencyHome.currency.char_iso_code}} </div></div><div class=\"clearfix collapsed\" ng-if=\"totalsAmountsCtrl.documentCtrl.currencyHome.currency_id !== totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[0]].id\" data-toggle=collapse data-target=#natural_tax_amount_collapse><span class=\"collapse-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Показать/скрыть детализацию\"></span><div class=col-xs-6>Сумма налога, <span ng-bind=totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[0]].symbol></span></div><div class=\"col-xs-6 text-right\" ng-bind=\"(totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].natural_tax_amount)? (totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].natural_tax_amount/100 | priceFormatter:totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[0]].char_iso_code) : 0\"></div></div><div id=natural_tax_amount_collapse class=\"collapse tax-summs\"><span class=clearfix ng-repeat=\"(name, summ) in totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].home_tax_amounts\"><span class=col-xs-6 ng-bind=name></span> <span class=\"col-xs-6 text-right\">{{summ/100 | priceFormatter:totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[0]].char_iso_code}}</span></span></div><div class=\"clearfix collapsed\" data-toggle=collapse data-target=#home_tax_amount_collapse> {{totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].natural_tax_amounts.length}}<span class=\"collapse-arrow tooltip-light\" tooltip-placement=bottom-right uib-tooltip=\"Показать/скрыть детализацию\"></span><div class=col-xs-6>Сумма налога, <span ng-bind=totalsAmountsCtrl.documentCtrl.currencyHome.currency.symbol></span></div><div class=\"col-xs-6 text-right\" ng-bind=\"(totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].home_tax_amount)? (totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].home_tax_amount/100 | priceFormatter:totalsAmountsCtrl.documentCtrl.currencyHome.currency.char_iso_code) : 0\"></div></div><div id=home_tax_amount_collapse class=\"collapse tax-summs\"><span class=clearfix ng-repeat=\"(name, summ) in totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].natural_tax_amounts\"><span class=col-xs-6 ng-bind=name></span> <span class=\"col-xs-6 text-right\">{{summ/100 | priceFormatter:totalsAmountsCtrl.documentCtrl.currencyHome.currency.char_iso_code}}</span></span></div></div><div ng-if=!totalsAmountsCtrl.withTaxes><div class=\"clearfix fake-price-form-control\" ng-if=\"totalsAmountsCtrl.documentCtrl.currencyHome.currency_id\n    !== totalsAmountsCtrl.externalData[totalsAmountsCtrl.item.ref[0]].id\"><div class=form-control>{{ (totalsAmountsCtrl.values[totalsAmountsCtrl.item.code].home_amount || 0)/100 | priceFormatter:totalsAmountsCtrl.documentCtrl.currencyHome.currency.char_iso_code}} </div><label class=\"form-control-label small-offset\" ng-bind=::totalsAmountsCtrl.item.name></label></div></div>");}]);